import { ref as ge, h as At, inject as $t, reactive as Qi, computed as Te, getCurrentScope as Ox, onScopeDispose as Bx, unref as _, readonly as _l, toRef as xi, customRef as EL, watch as qe, isRef as In, watchEffect as Ex, shallowRef as ti, getCurrentInstance as ho, onMounted as it, onUnmounted as sn, isVNode as Dx, defineComponent as Be, openBlock as E, createElementBlock as X, createBlock as fe, resolveDynamicComponent as tt, createCommentVNode as te, compile as mr, resolveComponent as $e, resolveDirective as Ut, Fragment as Re, renderList as Ge, createElementVNode as oe, toDisplayString as Ie, createVNode as ue, withDirectives as rt, effectScope as um, markRaw as ri, toRaw as as, isReactive as wr, hasInjectionContext as DL, nextTick as mt, toRefs as Ep, withModifiers as It, normalizeClass as Pe, useSlots as Jt, renderSlot as je, createTextVNode as Ve, mergeProps as Ce, Transition as ia, withCtx as Se, vShow as xn, Teleport as Rx, createSlots as Qt, toHandlers as sd, normalizeProps as si, withKeys as Ze, guardReactiveProps as Ki, normalizeStyle as hn, createApp as cv, onBeforeUpdate as zc, useId as Nx, toValue as RL, onBeforeMount as ws, onBeforeUnmount as Fa, isReadonly as NL, provide as Bo, onErrorCaptured as $L, TransitionGroup as FL, Text as jL, vModelText as $x, onUpdated as hm, mergeModels as HL, useModel as zL, defineAsyncComponent as VL, Comment as Fx, useCssVars as GL } from "vue";
import Ia from "isomorphic-dompurify";
import * as eo from "highcharts";
import es from "highcharts";
const Vc = typeof window > "u", Ue = !Vc, Uh = ge(!1), pm = () => {
  if (Ue) {
    const t = document?.querySelector("html")?.getAttribute("data-color-coding");
    Uh.value = t === "true";
  }
  return {
    setColorcodingFlag: (t) => {
      Ue && document.querySelector("html")?.setAttribute("data-color-coding", t.toString()), Uh.value = t;
    },
    useColorCoding: Uh.value
  };
}, UL = ge(!1), WL = ge(""), YL = ge(""), jx = () => ({
  shouldShowLeavingDisclaimer: UL,
  url: WL,
  disclaimer: YL
}), cBe = (e, t, n) => {
  const { url: i, shouldShowLeavingDisclaimer: o, disclaimer: a } = jx();
  e.preventDefault(), i.value = t, a.value = n, o.value = !0;
}, Ml = (e) => {
  if (!e.text)
    return e.text;
  if (e.text.length > e.maxCharacters) {
    const t = e.clippedTextSuffix ? e.clippedTextSuffix : "...", n = e.clippedAfterLastWord ? new RegExp(`^(.{1,${e.maxCharacters}}(?!\\w))`, "s") : new RegExp(`^.{1,${e.maxCharacters}}`, "s");
    return e.text.match(n)?.at(0)?.toString().trim() + t;
  }
  return e.text;
};
function qL() {
  return {
    getCircleComponent: (n, i) => At(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1rem",
        height: "1rem",
        viewBox: "0 0 16 16",
        fill: "none"
      },
      [
        At("circle", {
          cx: "8",
          cy: "8",
          r: "6",
          fill: n,
          ...i ? { stroke: "#FCFCFD", "stroke-width": "0.09375rem" } : {}
        })
      ]
    ),
    getCircleString: (n, i) => `<svg xmlns="http://www.w3.org/2000/svg" width="1rem" height="1rem" viewBox="0 0 16 16" fill="none">
      <circle cx="8" cy="8" r="6" fill="${n}" ${i ? 'stroke="#FCFCFD" stroke-width="0.09375rem"' : ""} />
    </svg>`
  };
}
const Hx = Symbol("i18n"), dv = {
  ADD_TAGS: [
    // the tags have to be the exactly spelling as they are defined in the HTML
    "BaseImage",
    "BaseLinkV2",
    "GlossaryItem",
    "PageFootnoteList",
    "PageFootnoteReference",
    "vue-glossary-item"
  ],
  ADD_ATTR: [
    ":always-underline",
    ":component-id",
    ":font-size",
    ":font-type",
    ":footnote-reference-id",
    ":footnote-type",
    ":has-text",
    ":icon",
    ":icon-color",
    ":icon-position",
    ":icon-size",
    ":is-copy-link",
    ":item-overlay-text",
    ":item-text",
    ":link-model",
    ":model",
    ":responsive-options",
    ":rounded-corner",
    ":special-link",
    ":stop-propagation",
    ":title",
    ":type"
  ]
};
function Wh(e, t) {
  var n = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (!n) {
    if (Array.isArray(e) || (n = fm(e)) || t && e && typeof e.length == "number") {
      n && (e = n);
      var i = 0, o = function() {
      };
      return { s: o, n: function() {
        return i >= e.length ? { done: !0 } : { done: !1, value: e[i++] };
      }, e: function(d) {
        throw d;
      }, f: o };
    }
    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  var a = !0, r = !1, s;
  return { s: function() {
    n = n.call(e);
  }, n: function() {
    var d = n.next();
    return a = d.done, d;
  }, e: function(d) {
    r = !0, s = d;
  }, f: function() {
    try {
      !a && n.return != null && n.return();
    } finally {
      if (r)
        throw s;
    }
  } };
}
function KL(e) {
  return JL(e) || ZL(e) || fm(e) || XL();
}
function XL() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function ZL(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null)
    return Array.from(e);
}
function JL(e) {
  if (Array.isArray(e))
    return Dp(e);
}
function kl(e) {
  "@babel/helpers - typeof";
  return kl = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, kl(e);
}
function Yh(e, t) {
  return tI(e) || eI(e, t) || fm(e, t) || QL();
}
function QL() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function fm(e, t) {
  if (e) {
    if (typeof e == "string")
      return Dp(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set")
      return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return Dp(e, t);
  }
}
function Dp(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, i = new Array(t); n < t; n++)
    i[n] = e[n];
  return i;
}
function eI(e, t) {
  var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var i, o, a, r, s = [], l = !0, d = !1;
    try {
      if (a = (n = n.call(e)).next, t === 0) {
        if (Object(n) !== n)
          return;
        l = !1;
      } else
        for (; !(l = (i = a.call(n)).done) && (s.push(i.value), s.length !== t); l = !0)
          ;
    } catch (y) {
      d = !0, o = y;
    } finally {
      try {
        if (!l && n.return != null && (r = n.return(), Object(r) !== r))
          return;
      } finally {
        if (d)
          throw o;
      }
    }
    return s;
  }
}
function tI(e) {
  if (Array.isArray(e))
    return e;
}
var Oe = {
  innerWidth: function(t) {
    if (t) {
      var n = t.offsetWidth, i = getComputedStyle(t);
      return n += parseFloat(i.paddingLeft) + parseFloat(i.paddingRight), n;
    }
    return 0;
  },
  width: function(t) {
    if (t) {
      var n = t.offsetWidth, i = getComputedStyle(t);
      return n -= parseFloat(i.paddingLeft) + parseFloat(i.paddingRight), n;
    }
    return 0;
  },
  getWindowScrollTop: function() {
    var t = document.documentElement;
    return (window.pageYOffset || t.scrollTop) - (t.clientTop || 0);
  },
  getWindowScrollLeft: function() {
    var t = document.documentElement;
    return (window.pageXOffset || t.scrollLeft) - (t.clientLeft || 0);
  },
  getOuterWidth: function(t, n) {
    if (t) {
      var i = t.offsetWidth;
      if (n) {
        var o = getComputedStyle(t);
        i += parseFloat(o.marginLeft) + parseFloat(o.marginRight);
      }
      return i;
    }
    return 0;
  },
  getOuterHeight: function(t, n) {
    if (t) {
      var i = t.offsetHeight;
      if (n) {
        var o = getComputedStyle(t);
        i += parseFloat(o.marginTop) + parseFloat(o.marginBottom);
      }
      return i;
    }
    return 0;
  },
  getClientHeight: function(t, n) {
    if (t) {
      var i = t.clientHeight;
      if (n) {
        var o = getComputedStyle(t);
        i += parseFloat(o.marginTop) + parseFloat(o.marginBottom);
      }
      return i;
    }
    return 0;
  },
  getViewport: function() {
    var t = window, n = document, i = n.documentElement, o = n.getElementsByTagName("body")[0], a = t.innerWidth || i.clientWidth || o.clientWidth, r = t.innerHeight || i.clientHeight || o.clientHeight;
    return {
      width: a,
      height: r
    };
  },
  getOffset: function(t) {
    if (t) {
      var n = t.getBoundingClientRect();
      return {
        top: n.top + (window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0),
        left: n.left + (window.pageXOffset || document.documentElement.scrollLeft || document.body.scrollLeft || 0)
      };
    }
    return {
      top: "auto",
      left: "auto"
    };
  },
  index: function(t) {
    if (t)
      for (var n, i = (n = this.getParentNode(t)) === null || n === void 0 ? void 0 : n.childNodes, o = 0, a = 0; a < i.length; a++) {
        if (i[a] === t)
          return o;
        i[a].nodeType === 1 && o++;
      }
    return -1;
  },
  addMultipleClasses: function(t, n) {
    var i = this;
    t && n && [n].flat().filter(Boolean).forEach(function(o) {
      return o.split(" ").forEach(function(a) {
        return i.addClass(t, a);
      });
    });
  },
  removeMultipleClasses: function(t, n) {
    var i = this;
    t && n && [n].flat().filter(Boolean).forEach(function(o) {
      return o.split(" ").forEach(function(a) {
        return i.removeClass(t, a);
      });
    });
  },
  addClass: function(t, n) {
    t && n && !this.hasClass(t, n) && (t.classList ? t.classList.add(n) : t.className += " " + n);
  },
  removeClass: function(t, n) {
    t && n && (t.classList ? t.classList.remove(n) : t.className = t.className.replace(new RegExp("(^|\\b)" + n.split(" ").join("|") + "(\\b|$)", "gi"), " "));
  },
  hasClass: function(t, n) {
    return t ? t.classList ? t.classList.contains(n) : new RegExp("(^| )" + n + "( |$)", "gi").test(t.className) : !1;
  },
  addStyles: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    t && Object.entries(n).forEach(function(i) {
      var o = Yh(i, 2), a = o[0], r = o[1];
      return t.style[a] = r;
    });
  },
  find: function(t, n) {
    return this.isElement(t) ? t.querySelectorAll(n) : [];
  },
  findSingle: function(t, n) {
    return this.isElement(t) ? t.querySelector(n) : null;
  },
  createElement: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (t) {
      var i = document.createElement(t);
      this.setAttributes(i, n);
      for (var o = arguments.length, a = new Array(o > 2 ? o - 2 : 0), r = 2; r < o; r++)
        a[r - 2] = arguments[r];
      return i.append.apply(i, a), i;
    }
  },
  setAttribute: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", i = arguments.length > 2 ? arguments[2] : void 0;
    this.isElement(t) && i !== null && i !== void 0 && t.setAttribute(n, i);
  },
  setAttributes: function(t) {
    var n = this, i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (this.isElement(t)) {
      var o = function a(r, s) {
        var l, d, y = t != null && (l = t.$attrs) !== null && l !== void 0 && l[r] ? [t == null || (d = t.$attrs) === null || d === void 0 ? void 0 : d[r]] : [];
        return [s].flat().reduce(function(u, m) {
          if (m != null) {
            var h = kl(m);
            if (h === "string" || h === "number")
              u.push(m);
            else if (h === "object") {
              var c = Array.isArray(m) ? a(r, m) : Object.entries(m).map(function(g) {
                var v = Yh(g, 2), P = v[0], f = v[1];
                return r === "style" && (f || f === 0) ? "".concat(P.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase(), ":").concat(f) : f ? P : void 0;
              });
              u = c.length ? u.concat(c.filter(function(g) {
                return !!g;
              })) : u;
            }
          }
          return u;
        }, y);
      };
      Object.entries(i).forEach(function(a) {
        var r = Yh(a, 2), s = r[0], l = r[1];
        if (l != null) {
          var d = s.match(/^on(.+)/);
          d ? t.addEventListener(d[1].toLowerCase(), l) : s === "p-bind" ? n.setAttributes(t, l) : (l = s === "class" ? KL(new Set(o("class", l))).join(" ").trim() : s === "style" ? o("style", l).join(";").trim() : l, (t.$attrs = t.$attrs || {}) && (t.$attrs[s] = l), t.setAttribute(s, l));
        }
      });
    }
  },
  getAttribute: function(t, n) {
    if (this.isElement(t)) {
      var i = t.getAttribute(n);
      return isNaN(i) ? i === "true" || i === "false" ? i === "true" : i : +i;
    }
  },
  isAttributeEquals: function(t, n, i) {
    return this.isElement(t) ? this.getAttribute(t, n) === i : !1;
  },
  isAttributeNotEquals: function(t, n, i) {
    return !this.isAttributeEquals(t, n, i);
  },
  getHeight: function(t) {
    if (t) {
      var n = t.offsetHeight, i = getComputedStyle(t);
      return n -= parseFloat(i.paddingTop) + parseFloat(i.paddingBottom) + parseFloat(i.borderTopWidth) + parseFloat(i.borderBottomWidth), n;
    }
    return 0;
  },
  getWidth: function(t) {
    if (t) {
      var n = t.offsetWidth, i = getComputedStyle(t);
      return n -= parseFloat(i.paddingLeft) + parseFloat(i.paddingRight) + parseFloat(i.borderLeftWidth) + parseFloat(i.borderRightWidth), n;
    }
    return 0;
  },
  absolutePosition: function(t, n) {
    if (t) {
      var i = t.offsetParent ? {
        width: t.offsetWidth,
        height: t.offsetHeight
      } : this.getHiddenElementDimensions(t), o = i.height, a = i.width, r = n.offsetHeight, s = n.offsetWidth, l = n.getBoundingClientRect(), d = this.getWindowScrollTop(), y = this.getWindowScrollLeft(), u = this.getViewport(), m, h;
      l.top + r + o > u.height ? (m = l.top + d - o, t.style.transformOrigin = "bottom", m < 0 && (m = d)) : (m = r + l.top + d, t.style.transformOrigin = "top"), l.left + a > u.width ? h = Math.max(0, l.left + y + s - a) : h = l.left + y, t.style.top = m + "px", t.style.left = h + "px";
    }
  },
  relativePosition: function(t, n) {
    if (t) {
      var i = t.offsetParent ? {
        width: t.offsetWidth,
        height: t.offsetHeight
      } : this.getHiddenElementDimensions(t), o = n.offsetHeight, a = n.getBoundingClientRect(), r = this.getViewport(), s, l;
      a.top + o + i.height > r.height ? (s = -1 * i.height, t.style.transformOrigin = "bottom", a.top + s < 0 && (s = -1 * a.top)) : (s = o, t.style.transformOrigin = "top"), i.width > r.width ? l = a.left * -1 : a.left + i.width > r.width ? l = (a.left + i.width - r.width) * -1 : l = 0, t.style.top = s + "px", t.style.left = l + "px";
    }
  },
  nestedPosition: function(t, n) {
    if (t) {
      var i = t.parentElement, o = this.getOffset(i), a = this.getViewport(), r = t.offsetParent ? t.offsetWidth : this.getHiddenElementOuterWidth(t), s = this.getOuterWidth(i.children[0]), l;
      parseInt(o.left, 10) + s + r > a.width - this.calculateScrollbarWidth() ? parseInt(o.left, 10) < r ? n % 2 === 1 ? l = parseInt(o.left, 10) ? "-" + parseInt(o.left, 10) + "px" : "100%" : n % 2 === 0 && (l = a.width - r - this.calculateScrollbarWidth() + "px") : l = "-100%" : l = "100%", t.style.top = "0px", t.style.left = l;
    }
  },
  getParentNode: function(t) {
    var n = t?.parentNode;
    return n && n.host && (n = n.host), n;
  },
  getParents: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], i = this.getParentNode(t);
    return i === null ? n : this.getParents(i, n.concat([i]));
  },
  getScrollableParents: function(t) {
    var n = [];
    if (t) {
      var i = this.getParents(t), o = /(auto|scroll)/, a = function(v) {
        try {
          var P = window.getComputedStyle(v, null);
          return o.test(P.getPropertyValue("overflow")) || o.test(P.getPropertyValue("overflowX")) || o.test(P.getPropertyValue("overflowY"));
        } catch {
          return !1;
        }
      }, r = Wh(i), s;
      try {
        for (r.s(); !(s = r.n()).done; ) {
          var l = s.value, d = l.nodeType === 1 && l.dataset.scrollselectors;
          if (d) {
            var y = d.split(","), u = Wh(y), m;
            try {
              for (u.s(); !(m = u.n()).done; ) {
                var h = m.value, c = this.findSingle(l, h);
                c && a(c) && n.push(c);
              }
            } catch (g) {
              u.e(g);
            } finally {
              u.f();
            }
          }
          l.nodeType !== 9 && a(l) && n.push(l);
        }
      } catch (g) {
        r.e(g);
      } finally {
        r.f();
      }
    }
    return n;
  },
  getHiddenElementOuterHeight: function(t) {
    if (t) {
      t.style.visibility = "hidden", t.style.display = "block";
      var n = t.offsetHeight;
      return t.style.display = "none", t.style.visibility = "visible", n;
    }
    return 0;
  },
  getHiddenElementOuterWidth: function(t) {
    if (t) {
      t.style.visibility = "hidden", t.style.display = "block";
      var n = t.offsetWidth;
      return t.style.display = "none", t.style.visibility = "visible", n;
    }
    return 0;
  },
  getHiddenElementDimensions: function(t) {
    if (t) {
      var n = {};
      return t.style.visibility = "hidden", t.style.display = "block", n.width = t.offsetWidth, n.height = t.offsetHeight, t.style.display = "none", t.style.visibility = "visible", n;
    }
    return 0;
  },
  fadeIn: function(t, n) {
    if (t) {
      t.style.opacity = 0;
      var i = +/* @__PURE__ */ new Date(), o = 0, a = function r() {
        o = +t.style.opacity + ((/* @__PURE__ */ new Date()).getTime() - i) / n, t.style.opacity = o, i = +/* @__PURE__ */ new Date(), +o < 1 && (window.requestAnimationFrame && requestAnimationFrame(r) || setTimeout(r, 16));
      };
      a();
    }
  },
  fadeOut: function(t, n) {
    if (t)
      var i = 1, o = 50, a = n, r = o / a, s = setInterval(function() {
        i -= r, i <= 0 && (i = 0, clearInterval(s)), t.style.opacity = i;
      }, o);
  },
  getUserAgent: function() {
    return navigator.userAgent;
  },
  appendChild: function(t, n) {
    if (this.isElement(n))
      n.appendChild(t);
    else if (n.el && n.elElement)
      n.elElement.appendChild(t);
    else
      throw new Error("Cannot append " + n + " to " + t);
  },
  isElement: function(t) {
    return (typeof HTMLElement > "u" ? "undefined" : kl(HTMLElement)) === "object" ? t instanceof HTMLElement : t && kl(t) === "object" && t !== null && t.nodeType === 1 && typeof t.nodeName == "string";
  },
  scrollInView: function(t, n) {
    var i = getComputedStyle(t).getPropertyValue("borderTopWidth"), o = i ? parseFloat(i) : 0, a = getComputedStyle(t).getPropertyValue("paddingTop"), r = a ? parseFloat(a) : 0, s = t.getBoundingClientRect(), l = n.getBoundingClientRect(), d = l.top + document.body.scrollTop - (s.top + document.body.scrollTop) - o - r, y = t.scrollTop, u = t.clientHeight, m = this.getOuterHeight(n);
    d < 0 ? t.scrollTop = y + d : d + m > u && (t.scrollTop = y + d - u + m);
  },
  clearSelection: function() {
    if (window.getSelection)
      window.getSelection().empty ? window.getSelection().empty() : window.getSelection().removeAllRanges && window.getSelection().rangeCount > 0 && window.getSelection().getRangeAt(0).getClientRects().length > 0 && window.getSelection().removeAllRanges();
    else if (document.selection && document.selection.empty)
      try {
        document.selection.empty();
      } catch {
      }
  },
  getSelection: function() {
    return window.getSelection ? window.getSelection().toString() : document.getSelection ? document.getSelection().toString() : document.selection ? document.selection.createRange().text : null;
  },
  calculateScrollbarWidth: function() {
    if (this.calculatedScrollbarWidth != null)
      return this.calculatedScrollbarWidth;
    var t = document.createElement("div");
    this.addStyles(t, {
      width: "100px",
      height: "100px",
      overflow: "scroll",
      position: "absolute",
      top: "-9999px"
    }), document.body.appendChild(t);
    var n = t.offsetWidth - t.clientWidth;
    return document.body.removeChild(t), this.calculatedScrollbarWidth = n, n;
  },
  calculateBodyScrollbarWidth: function() {
    return window.innerWidth - document.documentElement.offsetWidth;
  },
  getBrowser: function() {
    if (!this.browser) {
      var t = this.resolveUserAgent();
      this.browser = {}, t.browser && (this.browser[t.browser] = !0, this.browser.version = t.version), this.browser.chrome ? this.browser.webkit = !0 : this.browser.webkit && (this.browser.safari = !0);
    }
    return this.browser;
  },
  resolveUserAgent: function() {
    var t = navigator.userAgent.toLowerCase(), n = /(chrome)[ ]([\w.]+)/.exec(t) || /(webkit)[ ]([\w.]+)/.exec(t) || /(opera)(?:.*version|)[ ]([\w.]+)/.exec(t) || /(msie) ([\w.]+)/.exec(t) || t.indexOf("compatible") < 0 && /(mozilla)(?:.*? rv:([\w.]+)|)/.exec(t) || [];
    return {
      browser: n[1] || "",
      version: n[2] || "0"
    };
  },
  isVisible: function(t) {
    return t && t.offsetParent != null;
  },
  invokeElementMethod: function(t, n, i) {
    t[n].apply(t, i);
  },
  isExist: function(t) {
    return !!(t !== null && typeof t < "u" && t.nodeName && this.getParentNode(t));
  },
  isClient: function() {
    return !!(typeof window < "u" && window.document && window.document.createElement);
  },
  focus: function(t, n) {
    t && document.activeElement !== t && t.focus(n);
  },
  isFocusableElement: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    return this.isElement(t) ? t.matches('button:not([tabindex = "-1"]):not([disabled]):not([style*="display:none"]):not([hidden])'.concat(n, `,
                [href][clientHeight][clientWidth]:not([tabindex = "-1"]):not([disabled]):not([style*="display:none"]):not([hidden])`).concat(n, `,
                input:not([tabindex = "-1"]):not([disabled]):not([style*="display:none"]):not([hidden])`).concat(n, `,
                select:not([tabindex = "-1"]):not([disabled]):not([style*="display:none"]):not([hidden])`).concat(n, `,
                textarea:not([tabindex = "-1"]):not([disabled]):not([style*="display:none"]):not([hidden])`).concat(n, `,
                [tabIndex]:not([tabIndex = "-1"]):not([disabled]):not([style*="display:none"]):not([hidden])`).concat(n, `,
                [contenteditable]:not([tabIndex = "-1"]):not([disabled]):not([style*="display:none"]):not([hidden])`).concat(n)) : !1;
  },
  getFocusableElements: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", i = this.find(t, 'button:not([tabindex = "-1"]):not([disabled]):not([style*="display:none"]):not([hidden])'.concat(n, `,
                [href][clientHeight][clientWidth]:not([tabindex = "-1"]):not([disabled]):not([style*="display:none"]):not([hidden])`).concat(n, `,
                input:not([tabindex = "-1"]):not([disabled]):not([style*="display:none"]):not([hidden])`).concat(n, `,
                select:not([tabindex = "-1"]):not([disabled]):not([style*="display:none"]):not([hidden])`).concat(n, `,
                textarea:not([tabindex = "-1"]):not([disabled]):not([style*="display:none"]):not([hidden])`).concat(n, `,
                [tabIndex]:not([tabIndex = "-1"]):not([disabled]):not([style*="display:none"]):not([hidden])`).concat(n, `,
                [contenteditable]:not([tabIndex = "-1"]):not([disabled]):not([style*="display:none"]):not([hidden])`).concat(n)), o = [], a = Wh(i), r;
    try {
      for (a.s(); !(r = a.n()).done; ) {
        var s = r.value;
        getComputedStyle(s).display != "none" && getComputedStyle(s).visibility != "hidden" && o.push(s);
      }
    } catch (l) {
      a.e(l);
    } finally {
      a.f();
    }
    return o;
  },
  getFirstFocusableElement: function(t, n) {
    var i = this.getFocusableElements(t, n);
    return i.length > 0 ? i[0] : null;
  },
  getLastFocusableElement: function(t, n) {
    var i = this.getFocusableElements(t, n);
    return i.length > 0 ? i[i.length - 1] : null;
  },
  getNextFocusableElement: function(t, n, i) {
    var o = this.getFocusableElements(t, i), a = o.length > 0 ? o.findIndex(function(s) {
      return s === n;
    }) : -1, r = a > -1 && o.length >= a + 1 ? a + 1 : -1;
    return r > -1 ? o[r] : null;
  },
  getPreviousElementSibling: function(t, n) {
    for (var i = t.previousElementSibling; i; ) {
      if (i.matches(n))
        return i;
      i = i.previousElementSibling;
    }
    return null;
  },
  getNextElementSibling: function(t, n) {
    for (var i = t.nextElementSibling; i; ) {
      if (i.matches(n))
        return i;
      i = i.nextElementSibling;
    }
    return null;
  },
  isClickable: function(t) {
    if (t) {
      var n = t.nodeName, i = t.parentElement && t.parentElement.nodeName;
      return n === "INPUT" || n === "TEXTAREA" || n === "BUTTON" || n === "A" || i === "INPUT" || i === "TEXTAREA" || i === "BUTTON" || i === "A" || !!t.closest(".p-button, .p-checkbox, .p-radiobutton");
    }
    return !1;
  },
  applyStyle: function(t, n) {
    if (typeof n == "string")
      t.style.cssText = n;
    else
      for (var i in n)
        t.style[i] = n[i];
  },
  isIOS: function() {
    return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
  },
  isAndroid: function() {
    return /(android)/i.test(navigator.userAgent);
  },
  isTouchDevice: function() {
    return "ontouchstart" in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
  },
  hasCSSAnimation: function(t) {
    if (t) {
      var n = getComputedStyle(t), i = parseFloat(n.getPropertyValue("animation-duration") || "0");
      return i > 0;
    }
    return !1;
  },
  hasCSSTransition: function(t) {
    if (t) {
      var n = getComputedStyle(t), i = parseFloat(n.getPropertyValue("transition-duration") || "0");
      return i > 0;
    }
    return !1;
  },
  exportCSV: function(t, n) {
    var i = new Blob([t], {
      type: "application/csv;charset=utf-8;"
    });
    if (window.navigator.msSaveOrOpenBlob)
      navigator.msSaveOrOpenBlob(i, n + ".csv");
    else {
      var o = document.createElement("a");
      o.download !== void 0 ? (o.setAttribute("href", URL.createObjectURL(i)), o.setAttribute("download", n + ".csv"), o.style.display = "none", document.body.appendChild(o), o.click(), document.body.removeChild(o)) : (t = "data:text/csv;charset=utf-8," + t, window.open(encodeURI(t)));
    }
  },
  blockBodyScroll: function() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "p-overflow-hidden";
    document.body.style.setProperty("--scrollbar-width", this.calculateBodyScrollbarWidth() + "px"), this.addClass(document.body, t);
  },
  unblockBodyScroll: function() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "p-overflow-hidden";
    document.body.style.removeProperty("--scrollbar-width"), this.removeClass(document.body, t);
  }
};
function Ol(e) {
  "@babel/helpers - typeof";
  return Ol = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Ol(e);
}
function nI(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function uv(e, t) {
  for (var n = 0; n < t.length; n++) {
    var i = t[n];
    i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, aI(i.key), i);
  }
}
function iI(e, t, n) {
  return t && uv(e.prototype, t), n && uv(e, n), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function aI(e) {
  var t = oI(e, "string");
  return Ol(t) == "symbol" ? t : String(t);
}
function oI(e, t) {
  if (Ol(e) != "object" || !e)
    return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var i = n.call(e, t || "default");
    if (Ol(i) != "object")
      return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var po = /* @__PURE__ */ function() {
  function e(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : function() {
    };
    nI(this, e), this.element = t, this.listener = n;
  }
  return iI(e, [{
    key: "bindScrollListener",
    value: function() {
      this.scrollableParents = Oe.getScrollableParents(this.element);
      for (var n = 0; n < this.scrollableParents.length; n++)
        this.scrollableParents[n].addEventListener("scroll", this.listener);
    }
  }, {
    key: "unbindScrollListener",
    value: function() {
      if (this.scrollableParents)
        for (var n = 0; n < this.scrollableParents.length; n++)
          this.scrollableParents[n].removeEventListener("scroll", this.listener);
    }
  }, {
    key: "destroy",
    value: function() {
      this.unbindScrollListener(), this.element = null, this.listener = null, this.scrollableParents = null;
    }
  }]), e;
}();
function zx() {
  var e = /* @__PURE__ */ new Map();
  return {
    on: function(n, i) {
      var o = e.get(n);
      o ? o.push(i) : o = [i], e.set(n, o);
    },
    off: function(n, i) {
      var o = e.get(n);
      o && o.splice(o.indexOf(i) >>> 0, 1);
    },
    emit: function(n, i) {
      var o = e.get(n);
      o && o.slice().map(function(a) {
        a(i);
      });
    }
  };
}
function hv(e, t) {
  return lI(e) || sI(e, t) || mm(e, t) || rI();
}
function rI() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function sI(e, t) {
  var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var i, o, a, r, s = [], l = !0, d = !1;
    try {
      if (a = (n = n.call(e)).next, t === 0) {
        if (Object(n) !== n)
          return;
        l = !1;
      } else
        for (; !(l = (i = a.call(n)).done) && (s.push(i.value), s.length !== t); l = !0)
          ;
    } catch (y) {
      d = !0, o = y;
    } finally {
      try {
        if (!l && n.return != null && (r = n.return(), Object(r) !== r))
          return;
      } finally {
        if (d)
          throw o;
      }
    }
    return s;
  }
}
function lI(e) {
  if (Array.isArray(e))
    return e;
}
function pv(e) {
  return uI(e) || dI(e) || mm(e) || cI();
}
function cI() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function dI(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null)
    return Array.from(e);
}
function uI(e) {
  if (Array.isArray(e))
    return Rp(e);
}
function qh(e, t) {
  var n = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (!n) {
    if (Array.isArray(e) || (n = mm(e)) || t && e && typeof e.length == "number") {
      n && (e = n);
      var i = 0, o = function() {
      };
      return { s: o, n: function() {
        return i >= e.length ? { done: !0 } : { done: !1, value: e[i++] };
      }, e: function(d) {
        throw d;
      }, f: o };
    }
    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  var a = !0, r = !1, s;
  return { s: function() {
    n = n.call(e);
  }, n: function() {
    var d = n.next();
    return a = d.done, d;
  }, e: function(d) {
    r = !0, s = d;
  }, f: function() {
    try {
      !a && n.return != null && n.return();
    } finally {
      if (r)
        throw s;
    }
  } };
}
function mm(e, t) {
  if (e) {
    if (typeof e == "string")
      return Rp(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set")
      return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return Rp(e, t);
  }
}
function Rp(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, i = new Array(t); n < t; n++)
    i[n] = e[n];
  return i;
}
function Sl(e) {
  "@babel/helpers - typeof";
  return Sl = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Sl(e);
}
var We = {
  equals: function(t, n, i) {
    return i ? this.resolveFieldData(t, i) === this.resolveFieldData(n, i) : this.deepEquals(t, n);
  },
  deepEquals: function(t, n) {
    if (t === n)
      return !0;
    if (t && n && Sl(t) == "object" && Sl(n) == "object") {
      var i = Array.isArray(t), o = Array.isArray(n), a, r, s;
      if (i && o) {
        if (r = t.length, r != n.length)
          return !1;
        for (a = r; a-- !== 0; )
          if (!this.deepEquals(t[a], n[a]))
            return !1;
        return !0;
      }
      if (i != o)
        return !1;
      var l = t instanceof Date, d = n instanceof Date;
      if (l != d)
        return !1;
      if (l && d)
        return t.getTime() == n.getTime();
      var y = t instanceof RegExp, u = n instanceof RegExp;
      if (y != u)
        return !1;
      if (y && u)
        return t.toString() == n.toString();
      var m = Object.keys(t);
      if (r = m.length, r !== Object.keys(n).length)
        return !1;
      for (a = r; a-- !== 0; )
        if (!Object.prototype.hasOwnProperty.call(n, m[a]))
          return !1;
      for (a = r; a-- !== 0; )
        if (s = m[a], !this.deepEquals(t[s], n[s]))
          return !1;
      return !0;
    }
    return t !== t && n !== n;
  },
  resolveFieldData: function(t, n) {
    if (!t || !n)
      return null;
    try {
      var i = t[n];
      if (this.isNotEmpty(i))
        return i;
    } catch {
    }
    if (Object.keys(t).length) {
      if (this.isFunction(n))
        return n(t);
      if (n.indexOf(".") === -1)
        return t[n];
      for (var o = n.split("."), a = t, r = 0, s = o.length; r < s; ++r) {
        if (a == null)
          return null;
        a = a[o[r]];
      }
      return a;
    }
    return null;
  },
  getItemValue: function(t) {
    for (var n = arguments.length, i = new Array(n > 1 ? n - 1 : 0), o = 1; o < n; o++)
      i[o - 1] = arguments[o];
    return this.isFunction(t) ? t.apply(void 0, i) : t;
  },
  filter: function(t, n, i) {
    var o = [];
    if (t) {
      var a = qh(t), r;
      try {
        for (a.s(); !(r = a.n()).done; ) {
          var s = r.value, l = qh(n), d;
          try {
            for (l.s(); !(d = l.n()).done; ) {
              var y = d.value;
              if (String(this.resolveFieldData(s, y)).toLowerCase().indexOf(i.toLowerCase()) > -1) {
                o.push(s);
                break;
              }
            }
          } catch (u) {
            l.e(u);
          } finally {
            l.f();
          }
        }
      } catch (u) {
        a.e(u);
      } finally {
        a.f();
      }
    }
    return o;
  },
  reorderArray: function(t, n, i) {
    t && n !== i && (i >= t.length && (i %= t.length, n %= t.length), t.splice(i, 0, t.splice(n, 1)[0]));
  },
  findIndexInList: function(t, n) {
    var i = -1;
    if (n) {
      for (var o = 0; o < n.length; o++)
        if (n[o] === t) {
          i = o;
          break;
        }
    }
    return i;
  },
  contains: function(t, n) {
    if (t != null && n && n.length) {
      var i = qh(n), o;
      try {
        for (i.s(); !(o = i.n()).done; ) {
          var a = o.value;
          if (this.equals(t, a))
            return !0;
        }
      } catch (r) {
        i.e(r);
      } finally {
        i.f();
      }
    }
    return !1;
  },
  insertIntoOrderedArray: function(t, n, i, o) {
    if (i.length > 0) {
      for (var a = !1, r = 0; r < i.length; r++) {
        var s = this.findIndexInList(i[r], o);
        if (s > n) {
          i.splice(r, 0, t), a = !0;
          break;
        }
      }
      a || i.push(t);
    } else
      i.push(t);
  },
  removeAccents: function(t) {
    return t && t.search(/[\xC0-\xFF]/g) > -1 && (t = t.replace(/[\xC0-\xC5]/g, "A").replace(/[\xC6]/g, "AE").replace(/[\xC7]/g, "C").replace(/[\xC8-\xCB]/g, "E").replace(/[\xCC-\xCF]/g, "I").replace(/[\xD0]/g, "D").replace(/[\xD1]/g, "N").replace(/[\xD2-\xD6\xD8]/g, "O").replace(/[\xD9-\xDC]/g, "U").replace(/[\xDD]/g, "Y").replace(/[\xDE]/g, "P").replace(/[\xE0-\xE5]/g, "a").replace(/[\xE6]/g, "ae").replace(/[\xE7]/g, "c").replace(/[\xE8-\xEB]/g, "e").replace(/[\xEC-\xEF]/g, "i").replace(/[\xF1]/g, "n").replace(/[\xF2-\xF6\xF8]/g, "o").replace(/[\xF9-\xFC]/g, "u").replace(/[\xFE]/g, "p").replace(/[\xFD\xFF]/g, "y")), t;
  },
  getVNodeProp: function(t, n) {
    if (t) {
      var i = t.props;
      if (i) {
        var o = n.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase(), a = Object.prototype.hasOwnProperty.call(i, o) ? o : n;
        return t.type.extends.props[n].type === Boolean && i[a] === "" ? !0 : i[a];
      }
    }
    return null;
  },
  toFlatCase: function(t) {
    return this.isString(t) ? t.replace(/(-|_)/g, "").toLowerCase() : t;
  },
  toKebabCase: function(t) {
    return this.isString(t) ? t.replace(/(_)/g, "-").replace(/[A-Z]/g, function(n, i) {
      return i === 0 ? n : "-" + n.toLowerCase();
    }).toLowerCase() : t;
  },
  toCapitalCase: function(t) {
    return this.isString(t, {
      empty: !1
    }) ? t[0].toUpperCase() + t.slice(1) : t;
  },
  isEmpty: function(t) {
    return t == null || t === "" || Array.isArray(t) && t.length === 0 || !(t instanceof Date) && Sl(t) === "object" && Object.keys(t).length === 0;
  },
  isNotEmpty: function(t) {
    return !this.isEmpty(t);
  },
  isFunction: function(t) {
    return !!(t && t.constructor && t.call && t.apply);
  },
  isObject: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0;
    return t instanceof Object && t.constructor === Object && (n || Object.keys(t).length !== 0);
  },
  isDate: function(t) {
    return t instanceof Date && t.constructor === Date;
  },
  isArray: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0;
    return Array.isArray(t) && (n || t.length !== 0);
  },
  isString: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0;
    return typeof t == "string" && (n || t !== "");
  },
  isPrintableCharacter: function() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    return this.isNotEmpty(t) && t.length === 1 && t.match(/\S| /);
  },
  /**
   * Firefox-v103 does not currently support the "findLast" method. It is stated that this method will be supported with Firefox-v104.
   * https://caniuse.com/mdn-javascript_builtins_array_findlast
   */
  findLast: function(t, n) {
    var i;
    if (this.isNotEmpty(t))
      try {
        i = t.findLast(n);
      } catch {
        i = pv(t).reverse().find(n);
      }
    return i;
  },
  /**
   * Firefox-v103 does not currently support the "findLastIndex" method. It is stated that this method will be supported with Firefox-v104.
   * https://caniuse.com/mdn-javascript_builtins_array_findlastindex
   */
  findLastIndex: function(t, n) {
    var i = -1;
    if (this.isNotEmpty(t))
      try {
        i = t.findLastIndex(n);
      } catch {
        i = t.lastIndexOf(pv(t).reverse().find(n));
      }
    return i;
  },
  sort: function(t, n) {
    var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1, o = arguments.length > 3 ? arguments[3] : void 0, a = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 1, r = this.compare(t, n, o, i), s = i;
    return (this.isEmpty(t) || this.isEmpty(n)) && (s = a === 1 ? i : a), s * r;
  },
  compare: function(t, n, i) {
    var o = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 1, a = -1, r = this.isEmpty(t), s = this.isEmpty(n);
    return r && s ? a = 0 : r ? a = o : s ? a = -o : typeof t == "string" && typeof n == "string" ? a = i(t, n) : a = t < n ? -1 : t > n ? 1 : 0, a;
  },
  localeComparator: function() {
    return new Intl.Collator(void 0, {
      numeric: !0
    }).compare;
  },
  nestedKeys: function() {
    var t = this, n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    return Object.entries(n).reduce(function(o, a) {
      var r = hv(a, 2), s = r[0], l = r[1], d = i ? "".concat(i, ".").concat(s) : s;
      return t.isObject(l) ? o = o.concat(t.nestedKeys(l, d)) : o.push(d), o;
    }, []);
  },
  stringify: function(t) {
    var n = this, i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2, o = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0, a = " ".repeat(o), r = " ".repeat(o + i);
    return this.isArray(t) ? "[" + t.map(function(s) {
      return n.stringify(s, i, o + i);
    }).join(", ") + "]" : this.isDate(t) ? t.toISOString() : this.isFunction(t) ? t.toString() : this.isObject(t) ? `{
` + Object.entries(t).map(function(s) {
      var l = hv(s, 2), d = l[0], y = l[1];
      return "".concat(r).concat(d, ": ").concat(n.stringify(y, i, o + i));
    }).join(`,
`) + `
`.concat(a) + "}" : JSON.stringify(t);
  }
};
function Bl(e) {
  "@babel/helpers - typeof";
  return Bl = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Bl(e);
}
function hI(e) {
  return gI(e) || mI(e) || fI(e) || pI();
}
function pI() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function fI(e, t) {
  if (e) {
    if (typeof e == "string")
      return Np(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set")
      return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return Np(e, t);
  }
}
function mI(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null)
    return Array.from(e);
}
function gI(e) {
  if (Array.isArray(e))
    return Np(e);
}
function Np(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, i = new Array(t); n < t; n++)
    i[n] = e[n];
  return i;
}
function vI(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function fv(e, t) {
  for (var n = 0; n < t.length; n++) {
    var i = t[n];
    i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, Vx(i.key), i);
  }
}
function yI(e, t, n) {
  return t && fv(e.prototype, t), n && fv(e, n), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function mv(e, t, n) {
  return t = Vx(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function Vx(e) {
  var t = bI(e, "string");
  return Bl(t) == "symbol" ? t : String(t);
}
function bI(e, t) {
  if (Bl(e) != "object" || !e)
    return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var i = n.call(e, t || "default");
    if (Bl(i) != "object")
      return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var os = /* @__PURE__ */ function() {
  function e(t) {
    var n = t.init, i = t.type;
    vI(this, e), mv(this, "helpers", void 0), mv(this, "type", void 0), this.helpers = new Set(n), this.type = i;
  }
  return yI(e, [{
    key: "add",
    value: function(n) {
      this.helpers.add(n);
    }
  }, {
    key: "update",
    value: function() {
    }
  }, {
    key: "delete",
    value: function(n) {
      this.helpers.delete(n);
    }
  }, {
    key: "clear",
    value: function() {
      this.helpers.clear();
    }
  }, {
    key: "get",
    value: function(n, i) {
      var o = this._get(n, i), a = o ? this._recursive(hI(this.helpers), o) : null;
      return We.isNotEmpty(a) ? a : null;
    }
  }, {
    key: "_isMatched",
    value: function(n, i) {
      var o, a = n?.parent;
      return (a == null || (o = a.vnode) === null || o === void 0 ? void 0 : o.key) === i || a && this._isMatched(a, i) || !1;
    }
  }, {
    key: "_get",
    value: function(n, i) {
      var o, a;
      return ((o = i || n?.$slots) === null || o === void 0 || (a = o.default) === null || a === void 0 ? void 0 : a.call(o)) || null;
    }
  }, {
    key: "_recursive",
    value: function() {
      var n = this, i = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], a = [];
      return o.forEach(function(r) {
        r.children instanceof Array ? a = a.concat(n._recursive(a, r.children)) : r.type.name === n.type ? a.push(r) : We.isNotEmpty(r.key) && (a = a.concat(i.filter(function(s) {
          return n._isMatched(s, r.key);
        }).map(function(s) {
          return s.vnode;
        })));
      }), a;
    }
  }]), e;
}(), gv = 0;
function Mt() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "pv_id_";
  return gv++, "".concat(e).concat(gv);
}
function xI(e) {
  return CI(e) || SI(e) || kI(e) || wI();
}
function wI() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function kI(e, t) {
  if (e) {
    if (typeof e == "string")
      return $p(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set")
      return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return $p(e, t);
  }
}
function SI(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null)
    return Array.from(e);
}
function CI(e) {
  if (Array.isArray(e))
    return $p(e);
}
function $p(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, i = new Array(t); n < t; n++)
    i[n] = e[n];
  return i;
}
function TI() {
  var e = [], t = function(s, l) {
    var d = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 999, y = o(s, l, d), u = y.value + (y.key === s ? 0 : d) + 1;
    return e.push({
      key: s,
      value: u
    }), u;
  }, n = function(s) {
    e = e.filter(function(l) {
      return l.value !== s;
    });
  }, i = function(s, l) {
    return o(s, l).value;
  }, o = function(s, l) {
    var d = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
    return xI(e).reverse().find(function(y) {
      return l ? !0 : y.key === s;
    }) || {
      key: s,
      value: d
    };
  }, a = function(s) {
    return s && parseInt(s.style.zIndex, 10) || 0;
  };
  return {
    get: a,
    set: function(s, l, d) {
      l && (l.style.zIndex = String(t(s, !0, d)));
    },
    clear: function(s) {
      s && (n(a(s)), s.style.zIndex = "");
    },
    getCurrent: function(s) {
      return i(s, !0);
    }
  };
}
var qt = TI(), Hn = {
  STARTS_WITH: "startsWith",
  CONTAINS: "contains",
  NOT_CONTAINS: "notContains",
  ENDS_WITH: "endsWith",
  EQUALS: "equals",
  NOT_EQUALS: "notEquals",
  IN: "in",
  LESS_THAN: "lt",
  LESS_THAN_OR_EQUAL_TO: "lte",
  GREATER_THAN: "gt",
  GREATER_THAN_OR_EQUAL_TO: "gte",
  BETWEEN: "between",
  DATE_IS: "dateIs",
  DATE_IS_NOT: "dateIsNot",
  DATE_BEFORE: "dateBefore",
  DATE_AFTER: "dateAfter"
}, du = {
  AND: "and",
  OR: "or"
};
function vv(e, t) {
  var n = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (!n) {
    if (Array.isArray(e) || (n = LI(e)) || t && e && typeof e.length == "number") {
      n && (e = n);
      var i = 0, o = function() {
      };
      return { s: o, n: function() {
        return i >= e.length ? { done: !0 } : { done: !1, value: e[i++] };
      }, e: function(d) {
        throw d;
      }, f: o };
    }
    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  var a = !0, r = !1, s;
  return { s: function() {
    n = n.call(e);
  }, n: function() {
    var d = n.next();
    return a = d.done, d;
  }, e: function(d) {
    r = !0, s = d;
  }, f: function() {
    try {
      !a && n.return != null && n.return();
    } finally {
      if (r)
        throw s;
    }
  } };
}
function LI(e, t) {
  if (e) {
    if (typeof e == "string")
      return yv(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set")
      return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return yv(e, t);
  }
}
function yv(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, i = new Array(t); n < t; n++)
    i[n] = e[n];
  return i;
}
var El = {
  filter: function(t, n, i, o, a) {
    var r = [];
    if (!t)
      return r;
    var s = vv(t), l;
    try {
      for (s.s(); !(l = s.n()).done; ) {
        var d = l.value;
        if (typeof d == "string") {
          if (this.filters[o](d, i, a)) {
            r.push(d);
            continue;
          }
        } else {
          var y = vv(n), u;
          try {
            for (y.s(); !(u = y.n()).done; ) {
              var m = u.value, h = We.resolveFieldData(d, m);
              if (this.filters[o](h, i, a)) {
                r.push(d);
                break;
              }
            }
          } catch (c) {
            y.e(c);
          } finally {
            y.f();
          }
        }
      }
    } catch (c) {
      s.e(c);
    } finally {
      s.f();
    }
    return r;
  },
  filters: {
    startsWith: function(t, n, i) {
      if (n == null || n.trim() === "")
        return !0;
      if (t == null)
        return !1;
      var o = We.removeAccents(n.toString()).toLocaleLowerCase(i), a = We.removeAccents(t.toString()).toLocaleLowerCase(i);
      return a.slice(0, o.length) === o;
    },
    contains: function(t, n, i) {
      if (n == null || typeof n == "string" && n.trim() === "")
        return !0;
      if (t == null)
        return !1;
      var o = We.removeAccents(n.toString()).toLocaleLowerCase(i), a = We.removeAccents(t.toString()).toLocaleLowerCase(i);
      return a.indexOf(o) !== -1;
    },
    notContains: function(t, n, i) {
      if (n == null || typeof n == "string" && n.trim() === "")
        return !0;
      if (t == null)
        return !1;
      var o = We.removeAccents(n.toString()).toLocaleLowerCase(i), a = We.removeAccents(t.toString()).toLocaleLowerCase(i);
      return a.indexOf(o) === -1;
    },
    endsWith: function(t, n, i) {
      if (n == null || n.trim() === "")
        return !0;
      if (t == null)
        return !1;
      var o = We.removeAccents(n.toString()).toLocaleLowerCase(i), a = We.removeAccents(t.toString()).toLocaleLowerCase(i);
      return a.indexOf(o, a.length - o.length) !== -1;
    },
    equals: function(t, n, i) {
      return n == null || typeof n == "string" && n.trim() === "" ? !0 : t == null ? !1 : t.getTime && n.getTime ? t.getTime() === n.getTime() : We.removeAccents(t.toString()).toLocaleLowerCase(i) == We.removeAccents(n.toString()).toLocaleLowerCase(i);
    },
    notEquals: function(t, n, i) {
      return n == null || typeof n == "string" && n.trim() === "" ? !1 : t == null ? !0 : t.getTime && n.getTime ? t.getTime() !== n.getTime() : We.removeAccents(t.toString()).toLocaleLowerCase(i) != We.removeAccents(n.toString()).toLocaleLowerCase(i);
    },
    in: function(t, n) {
      if (n == null || n.length === 0)
        return !0;
      for (var i = 0; i < n.length; i++)
        if (We.equals(t, n[i]))
          return !0;
      return !1;
    },
    between: function(t, n) {
      return n == null || n[0] == null || n[1] == null ? !0 : t == null ? !1 : t.getTime ? n[0].getTime() <= t.getTime() && t.getTime() <= n[1].getTime() : n[0] <= t && t <= n[1];
    },
    lt: function(t, n) {
      return n == null ? !0 : t == null ? !1 : t.getTime && n.getTime ? t.getTime() < n.getTime() : t < n;
    },
    lte: function(t, n) {
      return n == null ? !0 : t == null ? !1 : t.getTime && n.getTime ? t.getTime() <= n.getTime() : t <= n;
    },
    gt: function(t, n) {
      return n == null ? !0 : t == null ? !1 : t.getTime && n.getTime ? t.getTime() > n.getTime() : t > n;
    },
    gte: function(t, n) {
      return n == null ? !0 : t == null ? !1 : t.getTime && n.getTime ? t.getTime() >= n.getTime() : t >= n;
    },
    dateIs: function(t, n) {
      return n == null ? !0 : t == null ? !1 : t.toDateString() === n.toDateString();
    },
    dateIsNot: function(t, n) {
      return n == null ? !0 : t == null ? !1 : t.toDateString() !== n.toDateString();
    },
    dateBefore: function(t, n) {
      return n == null ? !0 : t == null ? !1 : t.getTime() < n.getTime();
    },
    dateAfter: function(t, n) {
      return n == null ? !0 : t == null ? !1 : t.getTime() > n.getTime();
    }
  },
  register: function(t, n) {
    this.filters[t] = n;
  }
};
function Dl(e) {
  "@babel/helpers - typeof";
  return Dl = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Dl(e);
}
function bv(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    t && (i = i.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), n.push.apply(n, i);
  }
  return n;
}
function Kh(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? bv(Object(n), !0).forEach(function(i) {
      II(e, i, n[i]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : bv(Object(n)).forEach(function(i) {
      Object.defineProperty(e, i, Object.getOwnPropertyDescriptor(n, i));
    });
  }
  return e;
}
function II(e, t, n) {
  return t = PI(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function PI(e) {
  var t = AI(e, "string");
  return Dl(t) == "symbol" ? t : String(t);
}
function AI(e, t) {
  if (Dl(e) != "object" || !e)
    return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var i = n.call(e, t || "default");
    if (Dl(i) != "object")
      return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var xv = {
  ripple: !1,
  inputStyle: "outlined",
  locale: {
    startsWith: "Starts with",
    contains: "Contains",
    notContains: "Not contains",
    endsWith: "Ends with",
    equals: "Equals",
    notEquals: "Not equals",
    noFilter: "No Filter",
    lt: "Less than",
    lte: "Less than or equal to",
    gt: "Greater than",
    gte: "Greater than or equal to",
    dateIs: "Date is",
    dateIsNot: "Date is not",
    dateBefore: "Date is before",
    dateAfter: "Date is after",
    clear: "Clear",
    apply: "Apply",
    matchAll: "Match All",
    matchAny: "Match Any",
    addRule: "Add Rule",
    removeRule: "Remove Rule",
    accept: "Yes",
    reject: "No",
    choose: "Choose",
    upload: "Upload",
    cancel: "Cancel",
    completed: "Completed",
    pending: "Pending",
    fileSizeTypes: ["B", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"],
    dayNames: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
    dayNamesShort: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
    dayNamesMin: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
    monthNames: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
    monthNamesShort: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
    chooseYear: "Choose Year",
    chooseMonth: "Choose Month",
    chooseDate: "Choose Date",
    prevDecade: "Previous Decade",
    nextDecade: "Next Decade",
    prevYear: "Previous Year",
    nextYear: "Next Year",
    prevMonth: "Previous Month",
    nextMonth: "Next Month",
    prevHour: "Previous Hour",
    nextHour: "Next Hour",
    prevMinute: "Previous Minute",
    nextMinute: "Next Minute",
    prevSecond: "Previous Second",
    nextSecond: "Next Second",
    am: "am",
    pm: "pm",
    today: "Today",
    weekHeader: "Wk",
    firstDayOfWeek: 0,
    showMonthAfterYear: !1,
    dateFormat: "mm/dd/yy",
    weak: "Weak",
    medium: "Medium",
    strong: "Strong",
    passwordPrompt: "Enter a password",
    emptyFilterMessage: "No results found",
    // @deprecated Use 'emptySearchMessage' option instead.
    searchMessage: "{0} results are available",
    selectionMessage: "{0} items selected",
    emptySelectionMessage: "No selected item",
    emptySearchMessage: "No results found",
    emptyMessage: "No available options",
    aria: {
      trueLabel: "True",
      falseLabel: "False",
      nullLabel: "Not Selected",
      star: "1 star",
      stars: "{star} stars",
      selectAll: "All items selected",
      unselectAll: "All items unselected",
      close: "Close",
      previous: "Previous",
      next: "Next",
      navigation: "Navigation",
      scrollTop: "Scroll Top",
      moveTop: "Move Top",
      moveUp: "Move Up",
      moveDown: "Move Down",
      moveBottom: "Move Bottom",
      moveToTarget: "Move to Target",
      moveToSource: "Move to Source",
      moveAllToTarget: "Move All to Target",
      moveAllToSource: "Move All to Source",
      pageLabel: "Page {page}",
      firstPageLabel: "First Page",
      lastPageLabel: "Last Page",
      nextPageLabel: "Next Page",
      prevPageLabel: "Previous Page",
      rowsPerPageLabel: "Rows per page",
      jumpToPageDropdownLabel: "Jump to Page Dropdown",
      jumpToPageInputLabel: "Jump to Page Input",
      selectRow: "Row Selected",
      unselectRow: "Row Unselected",
      expandRow: "Row Expanded",
      collapseRow: "Row Collapsed",
      showFilterMenu: "Show Filter Menu",
      hideFilterMenu: "Hide Filter Menu",
      filterOperator: "Filter Operator",
      filterConstraint: "Filter Constraint",
      editRow: "Row Edit",
      saveEdit: "Save Edit",
      cancelEdit: "Cancel Edit",
      listView: "List View",
      gridView: "Grid View",
      slide: "Slide",
      slideNumber: "{slideNumber}",
      zoomImage: "Zoom Image",
      zoomIn: "Zoom In",
      zoomOut: "Zoom Out",
      rotateRight: "Rotate Right",
      rotateLeft: "Rotate Left"
    }
  },
  filterMatchModeOptions: {
    text: [Hn.STARTS_WITH, Hn.CONTAINS, Hn.NOT_CONTAINS, Hn.ENDS_WITH, Hn.EQUALS, Hn.NOT_EQUALS],
    numeric: [Hn.EQUALS, Hn.NOT_EQUALS, Hn.LESS_THAN, Hn.LESS_THAN_OR_EQUAL_TO, Hn.GREATER_THAN, Hn.GREATER_THAN_OR_EQUAL_TO],
    date: [Hn.DATE_IS, Hn.DATE_IS_NOT, Hn.DATE_BEFORE, Hn.DATE_AFTER]
  },
  zIndex: {
    modal: 1100,
    overlay: 1e3,
    menu: 1e3,
    tooltip: 1100
  },
  pt: void 0,
  ptOptions: {
    mergeSections: !0,
    mergeProps: !1
  },
  unstyled: !1,
  csp: {
    nonce: void 0
  }
}, Gx = Symbol();
function gm() {
  var e = $t(Gx);
  if (!e)
    throw new Error("PrimeVue is not installed!");
  return e;
}
function _I(e, t, n, i) {
  if (e !== t) {
    var o = document.getElementById(n), a = o.cloneNode(!0), r = o.getAttribute("href").replace(e, t);
    a.setAttribute("id", n + "-clone"), a.setAttribute("href", r), a.addEventListener("load", function() {
      o.remove(), a.setAttribute("id", n), i && i();
    }), o.parentNode && o.parentNode.insertBefore(a, o.nextSibling);
  }
}
var MI = {
  install: function(t, n) {
    var i = n ? Kh(Kh({}, xv), n) : Kh({}, xv), o = {
      config: Qi(i),
      changeTheme: _I
    };
    t.config.globalProperties.$primevue = o, t.provide(Gx, o);
  }
};
const Je = () => {
  const e = $t(Hx), t = gm(), { localesPrimeVue: n, translationOptions: i } = Li();
  return {
    t: (s, l) => {
      if (!e)
        throw new Error("i18n is not defined");
      return l ? e.global.t(s, l) : e.global.t(s);
    },
    n: (s, l) => {
      if (!e)
        throw new Error("i18n is not defined");
      return e.global.n(s, l);
    },
    setLocale: (s) => {
      if (!e)
        throw new Error("i18n is not defined");
      let l;
      n && (l = n.find((d) => d.locale === s)), l || (l = n?.find(
        (d) => d.locale === i?.fallbackLocale
      )), l || (l = n?.find((d) => d.locale === "en")), t.config.locale = l, e.global.locale.value = s;
    },
    currentLocale: e.global.locale
  };
};
var rn = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function en(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function OI(e) {
  if (e.__esModule)
    return e;
  var t = e.default;
  if (typeof t == "function") {
    var n = function i() {
      return this instanceof i ? Reflect.construct(t, arguments, this.constructor) : t.apply(this, arguments);
    };
    n.prototype = t.prototype;
  } else
    n = {};
  return Object.defineProperty(n, "__esModule", { value: !0 }), Object.keys(e).forEach(function(i) {
    var o = Object.getOwnPropertyDescriptor(e, i);
    Object.defineProperty(n, i, o.get ? o : {
      enumerable: !0,
      get: function() {
        return e[i];
      }
    });
  }), n;
}
var Ux = { exports: {} };
(function(e, t) {
  (function(n, i) {
    e.exports = i();
  })(rn, function() {
    var n = 1e3, i = 6e4, o = 36e5, a = "millisecond", r = "second", s = "minute", l = "hour", d = "day", y = "week", u = "month", m = "quarter", h = "year", c = "date", g = "Invalid Date", v = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, P = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, f = { name: "en", weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), ordinal: function(b) {
      var p = ["th", "st", "nd", "rd"], L = b % 100;
      return "[" + b + (p[(L - 20) % 10] || p[L] || p[0]) + "]";
    } }, S = function(b, p, L) {
      var B = String(b);
      return !B || B.length >= p ? b : "" + Array(p + 1 - B.length).join(L) + b;
    }, w = { s: S, z: function(b) {
      var p = -b.utcOffset(), L = Math.abs(p), B = Math.floor(L / 60), T = L % 60;
      return (p <= 0 ? "+" : "-") + S(B, 2, "0") + ":" + S(T, 2, "0");
    }, m: function b(p, L) {
      if (p.date() < L.date())
        return -b(L, p);
      var B = 12 * (L.year() - p.year()) + (L.month() - p.month()), T = p.clone().add(B, u), O = L - T < 0, I = p.clone().add(B + (O ? -1 : 1), u);
      return +(-(B + (L - T) / (O ? T - I : I - T)) || 0);
    }, a: function(b) {
      return b < 0 ? Math.ceil(b) || 0 : Math.floor(b);
    }, p: function(b) {
      return { M: u, y: h, w: y, d, D: c, h: l, m: s, s: r, ms: a, Q: m }[b] || String(b || "").toLowerCase().replace(/s$/, "");
    }, u: function(b) {
      return b === void 0;
    } }, x = "en", k = {};
    k[x] = f;
    var A = "$isDayjsObject", $ = function(b) {
      return b instanceof D || !(!b || !b[A]);
    }, j = function b(p, L, B) {
      var T;
      if (!p)
        return x;
      if (typeof p == "string") {
        var O = p.toLowerCase();
        k[O] && (T = O), L && (k[O] = L, T = O);
        var I = p.split("-");
        if (!T && I.length > 1)
          return b(I[0]);
      } else {
        var R = p.name;
        k[R] = p, T = R;
      }
      return !B && T && (x = T), T || !B && x;
    }, N = function(b, p) {
      if ($(b))
        return b.clone();
      var L = typeof p == "object" ? p : {};
      return L.date = b, L.args = arguments, new D(L);
    }, M = w;
    M.l = j, M.i = $, M.w = function(b, p) {
      return N(b, { locale: p.$L, utc: p.$u, x: p.$x, $offset: p.$offset });
    };
    var D = function() {
      function b(L) {
        this.$L = j(L.locale, null, !0), this.parse(L), this.$x = this.$x || L.x || {}, this[A] = !0;
      }
      var p = b.prototype;
      return p.parse = function(L) {
        this.$d = function(B) {
          var T = B.date, O = B.utc;
          if (T === null)
            return /* @__PURE__ */ new Date(NaN);
          if (M.u(T))
            return /* @__PURE__ */ new Date();
          if (T instanceof Date)
            return new Date(T);
          if (typeof T == "string" && !/Z$/i.test(T)) {
            var I = T.match(v);
            if (I) {
              var R = I[2] - 1 || 0, Y = (I[7] || "0").substring(0, 3);
              return O ? new Date(Date.UTC(I[1], R, I[3] || 1, I[4] || 0, I[5] || 0, I[6] || 0, Y)) : new Date(I[1], R, I[3] || 1, I[4] || 0, I[5] || 0, I[6] || 0, Y);
            }
          }
          return new Date(T);
        }(L), this.init();
      }, p.init = function() {
        var L = this.$d;
        this.$y = L.getFullYear(), this.$M = L.getMonth(), this.$D = L.getDate(), this.$W = L.getDay(), this.$H = L.getHours(), this.$m = L.getMinutes(), this.$s = L.getSeconds(), this.$ms = L.getMilliseconds();
      }, p.$utils = function() {
        return M;
      }, p.isValid = function() {
        return this.$d.toString() !== g;
      }, p.isSame = function(L, B) {
        var T = N(L);
        return this.startOf(B) <= T && T <= this.endOf(B);
      }, p.isAfter = function(L, B) {
        return N(L) < this.startOf(B);
      }, p.isBefore = function(L, B) {
        return this.endOf(B) < N(L);
      }, p.$g = function(L, B, T) {
        return M.u(L) ? this[B] : this.set(T, L);
      }, p.unix = function() {
        return Math.floor(this.valueOf() / 1e3);
      }, p.valueOf = function() {
        return this.$d.getTime();
      }, p.startOf = function(L, B) {
        var T = this, O = !!M.u(B) || B, I = M.p(L), R = function(G, W) {
          var ae = M.w(T.$u ? Date.UTC(T.$y, W, G) : new Date(T.$y, W, G), T);
          return O ? ae : ae.endOf(d);
        }, Y = function(G, W) {
          return M.w(T.toDate()[G].apply(T.toDate("s"), (O ? [0, 0, 0, 0] : [23, 59, 59, 999]).slice(W)), T);
        }, F = this.$W, U = this.$M, Q = this.$D, J = "set" + (this.$u ? "UTC" : "");
        switch (I) {
          case h:
            return O ? R(1, 0) : R(31, 11);
          case u:
            return O ? R(1, U) : R(0, U + 1);
          case y:
            var ee = this.$locale().weekStart || 0, V = (F < ee ? F + 7 : F) - ee;
            return R(O ? Q - V : Q + (6 - V), U);
          case d:
          case c:
            return Y(J + "Hours", 0);
          case l:
            return Y(J + "Minutes", 1);
          case s:
            return Y(J + "Seconds", 2);
          case r:
            return Y(J + "Milliseconds", 3);
          default:
            return this.clone();
        }
      }, p.endOf = function(L) {
        return this.startOf(L, !1);
      }, p.$set = function(L, B) {
        var T, O = M.p(L), I = "set" + (this.$u ? "UTC" : ""), R = (T = {}, T[d] = I + "Date", T[c] = I + "Date", T[u] = I + "Month", T[h] = I + "FullYear", T[l] = I + "Hours", T[s] = I + "Minutes", T[r] = I + "Seconds", T[a] = I + "Milliseconds", T)[O], Y = O === d ? this.$D + (B - this.$W) : B;
        if (O === u || O === h) {
          var F = this.clone().set(c, 1);
          F.$d[R](Y), F.init(), this.$d = F.set(c, Math.min(this.$D, F.daysInMonth())).$d;
        } else
          R && this.$d[R](Y);
        return this.init(), this;
      }, p.set = function(L, B) {
        return this.clone().$set(L, B);
      }, p.get = function(L) {
        return this[M.p(L)]();
      }, p.add = function(L, B) {
        var T, O = this;
        L = Number(L);
        var I = M.p(B), R = function(U) {
          var Q = N(O);
          return M.w(Q.date(Q.date() + Math.round(U * L)), O);
        };
        if (I === u)
          return this.set(u, this.$M + L);
        if (I === h)
          return this.set(h, this.$y + L);
        if (I === d)
          return R(1);
        if (I === y)
          return R(7);
        var Y = (T = {}, T[s] = i, T[l] = o, T[r] = n, T)[I] || 1, F = this.$d.getTime() + L * Y;
        return M.w(F, this);
      }, p.subtract = function(L, B) {
        return this.add(-1 * L, B);
      }, p.format = function(L) {
        var B = this, T = this.$locale();
        if (!this.isValid())
          return T.invalidDate || g;
        var O = L || "YYYY-MM-DDTHH:mm:ssZ", I = M.z(this), R = this.$H, Y = this.$m, F = this.$M, U = T.weekdays, Q = T.months, J = T.meridiem, ee = function(W, ae, z, q) {
          return W && (W[ae] || W(B, O)) || z[ae].slice(0, q);
        }, V = function(W) {
          return M.s(R % 12 || 12, W, "0");
        }, G = J || function(W, ae, z) {
          var q = W < 12 ? "AM" : "PM";
          return z ? q.toLowerCase() : q;
        };
        return O.replace(P, function(W, ae) {
          return ae || function(z) {
            switch (z) {
              case "YY":
                return String(B.$y).slice(-2);
              case "YYYY":
                return M.s(B.$y, 4, "0");
              case "M":
                return F + 1;
              case "MM":
                return M.s(F + 1, 2, "0");
              case "MMM":
                return ee(T.monthsShort, F, Q, 3);
              case "MMMM":
                return ee(Q, F);
              case "D":
                return B.$D;
              case "DD":
                return M.s(B.$D, 2, "0");
              case "d":
                return String(B.$W);
              case "dd":
                return ee(T.weekdaysMin, B.$W, U, 2);
              case "ddd":
                return ee(T.weekdaysShort, B.$W, U, 3);
              case "dddd":
                return U[B.$W];
              case "H":
                return String(R);
              case "HH":
                return M.s(R, 2, "0");
              case "h":
                return V(1);
              case "hh":
                return V(2);
              case "a":
                return G(R, Y, !0);
              case "A":
                return G(R, Y, !1);
              case "m":
                return String(Y);
              case "mm":
                return M.s(Y, 2, "0");
              case "s":
                return String(B.$s);
              case "ss":
                return M.s(B.$s, 2, "0");
              case "SSS":
                return M.s(B.$ms, 3, "0");
              case "Z":
                return I;
            }
            return null;
          }(W) || I.replace(":", "");
        });
      }, p.utcOffset = function() {
        return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
      }, p.diff = function(L, B, T) {
        var O, I = this, R = M.p(B), Y = N(L), F = (Y.utcOffset() - this.utcOffset()) * i, U = this - Y, Q = function() {
          return M.m(I, Y);
        };
        switch (R) {
          case h:
            O = Q() / 12;
            break;
          case u:
            O = Q();
            break;
          case m:
            O = Q() / 3;
            break;
          case y:
            O = (U - F) / 6048e5;
            break;
          case d:
            O = (U - F) / 864e5;
            break;
          case l:
            O = U / o;
            break;
          case s:
            O = U / i;
            break;
          case r:
            O = U / n;
            break;
          default:
            O = U;
        }
        return T ? O : M.a(O);
      }, p.daysInMonth = function() {
        return this.endOf(u).$D;
      }, p.$locale = function() {
        return k[this.$L];
      }, p.locale = function(L, B) {
        if (!L)
          return this.$L;
        var T = this.clone(), O = j(L, B, !0);
        return O && (T.$L = O), T;
      }, p.clone = function() {
        return M.w(this.$d, this);
      }, p.toDate = function() {
        return new Date(this.valueOf());
      }, p.toJSON = function() {
        return this.isValid() ? this.toISOString() : null;
      }, p.toISOString = function() {
        return this.$d.toISOString();
      }, p.toString = function() {
        return this.$d.toUTCString();
      }, b;
    }(), C = D.prototype;
    return N.prototype = C, [["$ms", a], ["$s", r], ["$m", s], ["$H", l], ["$W", d], ["$M", u], ["$y", h], ["$D", c]].forEach(function(b) {
      C[b[1]] = function(p) {
        return this.$g(p, b[0], b[1]);
      };
    }), N.extend = function(b, p) {
      return b.$i || (b(p, D, N), b.$i = !0), N;
    }, N.locale = j, N.isDayjs = $, N.unix = function(b) {
      return N(1e3 * b);
    }, N.en = k[x], N.Ls = k, N.p = {}, N;
  });
})(Ux);
var fo = Ux.exports;
const Lt = /* @__PURE__ */ en(fo);
var BI = { exports: {} };
(function(e, t) {
  (function(n, i) {
    e.exports = i(fo);
  })(rn, function(n) {
    function i(l) {
      return l && typeof l == "object" && "default" in l ? l : { default: l };
    }
    var o = i(n), a = { s: "ein paar Sekunden", m: ["eine Minute", "einer Minute"], mm: "%d Minuten", h: ["eine Stunde", "einer Stunde"], hh: "%d Stunden", d: ["ein Tag", "einem Tag"], dd: ["%d Tage", "%d Tagen"], M: ["ein Monat", "einem Monat"], MM: ["%d Monate", "%d Monaten"], y: ["ein Jahr", "einem Jahr"], yy: ["%d Jahre", "%d Jahren"] };
    function r(l, d, y) {
      var u = a[y];
      return Array.isArray(u) && (u = u[d ? 0 : 1]), u.replace("%d", l);
    }
    var s = { name: "de", weekdays: "Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag".split("_"), weekdaysShort: "So._Mo._Di._Mi._Do._Fr._Sa.".split("_"), weekdaysMin: "So_Mo_Di_Mi_Do_Fr_Sa".split("_"), months: "Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember".split("_"), monthsShort: "Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sept._Okt._Nov._Dez.".split("_"), ordinal: function(l) {
      return l + ".";
    }, weekStart: 1, yearStart: 4, formats: { LTS: "HH:mm:ss", LT: "HH:mm", L: "DD.MM.YYYY", LL: "D. MMMM YYYY", LLL: "D. MMMM YYYY HH:mm", LLLL: "dddd, D. MMMM YYYY HH:mm" }, relativeTime: { future: "in %s", past: "vor %s", s: r, m: r, mm: r, h: r, hh: r, d: r, dd: r, M: r, MM: r, y: r, yy: r } };
    return o.default.locale(s, null, !0), s;
  });
})(BI);
var EI = { exports: {} };
(function(e, t) {
  (function(n, i) {
    e.exports = i();
  })(rn, function() {
    return { name: "en", weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), ordinal: function(n) {
      var i = ["th", "st", "nd", "rd"], o = n % 100;
      return "[" + n + (i[(o - 20) % 10] || i[o] || i[0]) + "]";
    } };
  });
})(EI);
var DI = { exports: {} };
(function(e, t) {
  (function(n, i) {
    e.exports = i(fo);
  })(rn, function(n) {
    function i(r) {
      return r && typeof r == "object" && "default" in r ? r : { default: r };
    }
    var o = i(n), a = { name: "es", monthsShort: "ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic".split("_"), weekdays: "domingo_lunes_martes_miércoles_jueves_viernes_sábado".split("_"), weekdaysShort: "dom._lun._mar._mié._jue._vie._sáb.".split("_"), weekdaysMin: "do_lu_ma_mi_ju_vi_sá".split("_"), months: "enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre".split("_"), weekStart: 1, formats: { LT: "H:mm", LTS: "H:mm:ss", L: "DD/MM/YYYY", LL: "D [de] MMMM [de] YYYY", LLL: "D [de] MMMM [de] YYYY H:mm", LLLL: "dddd, D [de] MMMM [de] YYYY H:mm" }, relativeTime: { future: "en %s", past: "hace %s", s: "unos segundos", m: "un minuto", mm: "%d minutos", h: "una hora", hh: "%d horas", d: "un día", dd: "%d días", M: "un mes", MM: "%d meses", y: "un año", yy: "%d años" }, ordinal: function(r) {
      return r + "º";
    } };
    return o.default.locale(a, null, !0), a;
  });
})(DI);
var RI = { exports: {} };
(function(e, t) {
  (function(n, i) {
    e.exports = i(fo);
  })(rn, function(n) {
    function i(r) {
      return r && typeof r == "object" && "default" in r ? r : { default: r };
    }
    var o = i(n), a = { name: "fr", weekdays: "dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi".split("_"), weekdaysShort: "dim._lun._mar._mer._jeu._ven._sam.".split("_"), weekdaysMin: "di_lu_ma_me_je_ve_sa".split("_"), months: "janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre".split("_"), monthsShort: "janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.".split("_"), weekStart: 1, yearStart: 4, formats: { LT: "HH:mm", LTS: "HH:mm:ss", L: "DD/MM/YYYY", LL: "D MMMM YYYY", LLL: "D MMMM YYYY HH:mm", LLLL: "dddd D MMMM YYYY HH:mm" }, relativeTime: { future: "dans %s", past: "il y a %s", s: "quelques secondes", m: "une minute", mm: "%d minutes", h: "une heure", hh: "%d heures", d: "un jour", dd: "%d jours", M: "un mois", MM: "%d mois", y: "un an", yy: "%d ans" }, ordinal: function(r) {
      return "" + r + (r === 1 ? "er" : "");
    } };
    return o.default.locale(a, null, !0), a;
  });
})(RI);
var NI = { exports: {} };
(function(e, t) {
  (function(n, i) {
    e.exports = i(fo);
  })(rn, function(n) {
    function i(r) {
      return r && typeof r == "object" && "default" in r ? r : { default: r };
    }
    var o = i(n), a = { name: "it", weekdays: "domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato".split("_"), weekdaysShort: "dom_lun_mar_mer_gio_ven_sab".split("_"), weekdaysMin: "do_lu_ma_me_gi_ve_sa".split("_"), months: "gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre".split("_"), weekStart: 1, monthsShort: "gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic".split("_"), formats: { LT: "HH:mm", LTS: "HH:mm:ss", L: "DD/MM/YYYY", LL: "D MMMM YYYY", LLL: "D MMMM YYYY HH:mm", LLLL: "dddd D MMMM YYYY HH:mm" }, relativeTime: { future: "tra %s", past: "%s fa", s: "qualche secondo", m: "un minuto", mm: "%d minuti", h: "un' ora", hh: "%d ore", d: "un giorno", dd: "%d giorni", M: "un mese", MM: "%d mesi", y: "un anno", yy: "%d anni" }, ordinal: function(r) {
      return r + "º";
    } };
    return o.default.locale(a, null, !0), a;
  });
})(NI);
var $I = { exports: {} };
(function(e, t) {
  (function(n, i) {
    e.exports = i(fo);
  })(rn, function(n) {
    function i(r) {
      return r && typeof r == "object" && "default" in r ? r : { default: r };
    }
    var o = i(n), a = { name: "ja", weekdays: "日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日".split("_"), weekdaysShort: "日_月_火_水_木_金_土".split("_"), weekdaysMin: "日_月_火_水_木_金_土".split("_"), months: "1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月".split("_"), monthsShort: "1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月".split("_"), ordinal: function(r) {
      return r + "日";
    }, formats: { LT: "HH:mm", LTS: "HH:mm:ss", L: "YYYY/MM/DD", LL: "YYYY年M月D日", LLL: "YYYY年M月D日 HH:mm", LLLL: "YYYY年M月D日 dddd HH:mm", l: "YYYY/MM/DD", ll: "YYYY年M月D日", lll: "YYYY年M月D日 HH:mm", llll: "YYYY年M月D日(ddd) HH:mm" }, meridiem: function(r) {
      return r < 12 ? "午前" : "午後";
    }, relativeTime: { future: "%s後", past: "%s前", s: "数秒", m: "1分", mm: "%d分", h: "1時間", hh: "%d時間", d: "1日", dd: "%d日", M: "1ヶ月", MM: "%dヶ月", y: "1年", yy: "%d年" } };
    return o.default.locale(a, null, !0), a;
  });
})($I);
var FI = { exports: {} };
(function(e, t) {
  (function(n, i) {
    e.exports = i(fo);
  })(rn, function(n) {
    function i(r) {
      return r && typeof r == "object" && "default" in r ? r : { default: r };
    }
    var o = i(n), a = { name: "nl", weekdays: "zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag".split("_"), weekdaysShort: "zo._ma._di._wo._do._vr._za.".split("_"), weekdaysMin: "zo_ma_di_wo_do_vr_za".split("_"), months: "januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december".split("_"), monthsShort: "jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec".split("_"), ordinal: function(r) {
      return "[" + r + (r === 1 || r === 8 || r >= 20 ? "ste" : "de") + "]";
    }, weekStart: 1, yearStart: 4, formats: { LT: "HH:mm", LTS: "HH:mm:ss", L: "DD-MM-YYYY", LL: "D MMMM YYYY", LLL: "D MMMM YYYY HH:mm", LLLL: "dddd D MMMM YYYY HH:mm" }, relativeTime: { future: "over %s", past: "%s geleden", s: "een paar seconden", m: "een minuut", mm: "%d minuten", h: "een uur", hh: "%d uur", d: "een dag", dd: "%d dagen", M: "een maand", MM: "%d maanden", y: "een jaar", yy: "%d jaar" } };
    return o.default.locale(a, null, !0), a;
  });
})(FI);
var jI = { exports: {} };
(function(e, t) {
  (function(n, i) {
    e.exports = i(fo);
  })(rn, function(n) {
    function i(r) {
      return r && typeof r == "object" && "default" in r ? r : { default: r };
    }
    var o = i(n), a = { name: "sv", weekdays: "söndag_måndag_tisdag_onsdag_torsdag_fredag_lördag".split("_"), weekdaysShort: "sön_mån_tis_ons_tor_fre_lör".split("_"), weekdaysMin: "sö_må_ti_on_to_fr_lö".split("_"), months: "januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december".split("_"), monthsShort: "jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec".split("_"), weekStart: 1, yearStart: 4, ordinal: function(r) {
      var s = r % 10;
      return "[" + r + (s === 1 || s === 2 ? "a" : "e") + "]";
    }, formats: { LT: "HH:mm", LTS: "HH:mm:ss", L: "YYYY-MM-DD", LL: "D MMMM YYYY", LLL: "D MMMM YYYY [kl.] HH:mm", LLLL: "dddd D MMMM YYYY [kl.] HH:mm", lll: "D MMM YYYY HH:mm", llll: "ddd D MMM YYYY HH:mm" }, relativeTime: { future: "om %s", past: "för %s sedan", s: "några sekunder", m: "en minut", mm: "%d minuter", h: "en timme", hh: "%d timmar", d: "en dag", dd: "%d dagar", M: "en månad", MM: "%d månader", y: "ett år", yy: "%d år" } };
    return o.default.locale(a, null, !0), a;
  });
})(jI);
var HI = { exports: {} };
(function(e, t) {
  (function(n, i) {
    e.exports = i(fo);
  })(rn, function(n) {
    function i(r) {
      return r && typeof r == "object" && "default" in r ? r : { default: r };
    }
    var o = i(n), a = { name: "zh", weekdays: "星期日_星期一_星期二_星期三_星期四_星期五_星期六".split("_"), weekdaysShort: "周日_周一_周二_周三_周四_周五_周六".split("_"), weekdaysMin: "日_一_二_三_四_五_六".split("_"), months: "一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月".split("_"), monthsShort: "1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月".split("_"), ordinal: function(r, s) {
      return s === "W" ? r + "周" : r + "日";
    }, weekStart: 1, yearStart: 4, formats: { LT: "HH:mm", LTS: "HH:mm:ss", L: "YYYY/MM/DD", LL: "YYYY年M月D日", LLL: "YYYY年M月D日Ah点mm分", LLLL: "YYYY年M月D日ddddAh点mm分", l: "YYYY/M/D", ll: "YYYY年M月D日", lll: "YYYY年M月D日 HH:mm", llll: "YYYY年M月D日dddd HH:mm" }, relativeTime: { future: "%s后", past: "%s前", s: "几秒", m: "1 分钟", mm: "%d 分钟", h: "1 小时", hh: "%d 小时", d: "1 天", dd: "%d 天", M: "1 个月", MM: "%d 个月", y: "1 年", yy: "%d 年" }, meridiem: function(r, s) {
      var l = 100 * r + s;
      return l < 600 ? "凌晨" : l < 900 ? "早上" : l < 1100 ? "上午" : l < 1300 ? "中午" : l < 1800 ? "下午" : "晚上";
    } };
    return o.default.locale(a, null, !0), a;
  });
})(HI);
var Wx = { exports: {} };
(function(e, t) {
  (function(n, i) {
    e.exports = i();
  })(rn, function() {
    var n = "minute", i = /[+-]\d\d(?::?\d\d)?/g, o = /([+-]|\d\d)/g;
    return function(a, r, s) {
      var l = r.prototype;
      s.utc = function(g) {
        var v = { date: g, utc: !0, args: arguments };
        return new r(v);
      }, l.utc = function(g) {
        var v = s(this.toDate(), { locale: this.$L, utc: !0 });
        return g ? v.add(this.utcOffset(), n) : v;
      }, l.local = function() {
        return s(this.toDate(), { locale: this.$L, utc: !1 });
      };
      var d = l.parse;
      l.parse = function(g) {
        g.utc && (this.$u = !0), this.$utils().u(g.$offset) || (this.$offset = g.$offset), d.call(this, g);
      };
      var y = l.init;
      l.init = function() {
        if (this.$u) {
          var g = this.$d;
          this.$y = g.getUTCFullYear(), this.$M = g.getUTCMonth(), this.$D = g.getUTCDate(), this.$W = g.getUTCDay(), this.$H = g.getUTCHours(), this.$m = g.getUTCMinutes(), this.$s = g.getUTCSeconds(), this.$ms = g.getUTCMilliseconds();
        } else
          y.call(this);
      };
      var u = l.utcOffset;
      l.utcOffset = function(g, v) {
        var P = this.$utils().u;
        if (P(g))
          return this.$u ? 0 : P(this.$offset) ? u.call(this) : this.$offset;
        if (typeof g == "string" && (g = function(x) {
          x === void 0 && (x = "");
          var k = x.match(i);
          if (!k)
            return null;
          var A = ("" + k[0]).match(o) || ["-", 0, 0], $ = A[0], j = 60 * +A[1] + +A[2];
          return j === 0 ? 0 : $ === "+" ? j : -j;
        }(g), g === null))
          return this;
        var f = Math.abs(g) <= 16 ? 60 * g : g, S = this;
        if (v)
          return S.$offset = f, S.$u = g === 0, S;
        if (g !== 0) {
          var w = this.$u ? this.toDate().getTimezoneOffset() : -1 * this.utcOffset();
          (S = this.local().add(f + w, n)).$offset = f, S.$x.$localOffset = w;
        } else
          S = this.utc();
        return S;
      };
      var m = l.format;
      l.format = function(g) {
        var v = g || (this.$u ? "YYYY-MM-DDTHH:mm:ss[Z]" : "");
        return m.call(this, v);
      }, l.valueOf = function() {
        var g = this.$utils().u(this.$offset) ? 0 : this.$offset + (this.$x.$localOffset || this.$d.getTimezoneOffset());
        return this.$d.valueOf() - 6e4 * g;
      }, l.isUTC = function() {
        return !!this.$u;
      }, l.toISOString = function() {
        return this.toDate().toISOString();
      }, l.toString = function() {
        return this.toDate().toUTCString();
      };
      var h = l.toDate;
      l.toDate = function(g) {
        return g === "s" && this.$offset ? s(this.format("YYYY-MM-DD HH:mm:ss:SSS")).toDate() : h.call(this);
      };
      var c = l.diff;
      l.diff = function(g, v, P) {
        if (g && this.$u === g.$u)
          return c.call(this, g, v, P);
        var f = this.local(), S = s(g).local();
        return c.call(f, S, v, P);
      };
    };
  });
})(Wx);
var zI = Wx.exports;
const ks = /* @__PURE__ */ en(zI);
var Yx = { exports: {} };
(function(e, t) {
  (function(n, i) {
    e.exports = i();
  })(rn, function() {
    var n = { year: 0, month: 1, day: 2, hour: 3, minute: 4, second: 5 }, i = {};
    return function(o, a, r) {
      var s, l = function(m, h, c) {
        c === void 0 && (c = {});
        var g = new Date(m), v = function(P, f) {
          f === void 0 && (f = {});
          var S = f.timeZoneName || "short", w = P + "|" + S, x = i[w];
          return x || (x = new Intl.DateTimeFormat("en-US", { hour12: !1, timeZone: P, year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit", second: "2-digit", timeZoneName: S }), i[w] = x), x;
        }(h, c);
        return v.formatToParts(g);
      }, d = function(m, h) {
        for (var c = l(m, h), g = [], v = 0; v < c.length; v += 1) {
          var P = c[v], f = P.type, S = P.value, w = n[f];
          w >= 0 && (g[w] = parseInt(S, 10));
        }
        var x = g[3], k = x === 24 ? 0 : x, A = g[0] + "-" + g[1] + "-" + g[2] + " " + k + ":" + g[4] + ":" + g[5] + ":000", $ = +m;
        return (r.utc(A).valueOf() - ($ -= $ % 1e3)) / 6e4;
      }, y = a.prototype;
      y.tz = function(m, h) {
        m === void 0 && (m = s);
        var c = this.utcOffset(), g = this.toDate(), v = g.toLocaleString("en-US", { timeZone: m }), P = Math.round((g - new Date(v)) / 1e3 / 60), f = r(v, { locale: this.$L }).$set("millisecond", this.$ms).utcOffset(15 * -Math.round(g.getTimezoneOffset() / 15) - P, !0);
        if (h) {
          var S = f.utcOffset();
          f = f.add(c - S, "minute");
        }
        return f.$x.$timezone = m, f;
      }, y.offsetName = function(m) {
        var h = this.$x.$timezone || r.tz.guess(), c = l(this.valueOf(), h, { timeZoneName: m }).find(function(g) {
          return g.type.toLowerCase() === "timezonename";
        });
        return c && c.value;
      };
      var u = y.startOf;
      y.startOf = function(m, h) {
        if (!this.$x || !this.$x.$timezone)
          return u.call(this, m, h);
        var c = r(this.format("YYYY-MM-DD HH:mm:ss:SSS"), { locale: this.$L });
        return u.call(c, m, h).tz(this.$x.$timezone, !0);
      }, r.tz = function(m, h, c) {
        var g = c && h, v = c || h || s, P = d(+r(), v);
        if (typeof m != "string")
          return r(m).tz(v);
        var f = function(k, A, $) {
          var j = k - 60 * A * 1e3, N = d(j, $);
          if (A === N)
            return [j, A];
          var M = d(j -= 60 * (N - A) * 1e3, $);
          return N === M ? [j, N] : [k - 60 * Math.min(N, M) * 1e3, Math.max(N, M)];
        }(r.utc(m, g).valueOf(), P, v), S = f[0], w = f[1], x = r(S).utcOffset(w);
        return x.$x.$timezone = v, x;
      }, r.tz.guess = function() {
        return Intl.DateTimeFormat().resolvedOptions().timeZone;
      }, r.tz.setDefault = function(m) {
        s = m;
      };
    };
  });
})(Yx);
var VI = Yx.exports;
const Ss = /* @__PURE__ */ en(VI);
Lt.extend(ks);
Lt.extend(Ss);
Lt.tz.setDefault("UTC");
const vm = () => {
  const { currentLocale: e } = Je(), t = gm(), n = (r) => Lt(r).isValid(), i = (r, s, l) => {
    if (!e.value)
      return;
    let d;
    switch (e.value.toString()) {
      case "de-de":
      case "de":
        d = "de";
        break;
      case "en":
        d = "en";
        break;
      default:
        d = e.value.toString();
    }
    let y = Lt(r).utc();
    l && (y = y.tz(l)), Lt.locale(d);
    const u = ge("");
    return u.value = y.locale(d).format(s), u;
  };
  return {
    isValid: n,
    formatDate: i,
    formatDateWithPrimeFormat: (r, s) => {
      let d = t.config.locale?.dateFormat ?? "";
      d = d.replace("yy", "YYYY"), d = d.replace("y", "YY"), d = d.replace("MM", "MMMM"), d = d.replace("M", "MMM"), d = d.replace("mm", "MM"), d = d.replace("m", "M"), d = d.replace("dd", "DD"), d = d.replace("d", "D");
      const y = i(r, d, s);
      return y === void 0 ? "" : y.value;
    },
    toUnixTimestamp: (r) => {
      const s = ge(0);
      return s.value = Lt(r).valueOf(), s;
    }
  };
}, ld = (e) => {
  "touches" in e && GI(e) || document.activeElement instanceof HTMLElement && document.activeElement.blur();
};
function GI(e) {
  const t = e.changedTouches ? e.changedTouches[0].pageX : 0, n = e.changedTouches ? e.changedTouches[0].pageY : 0, i = document.elementFromPoint(t, n), o = e.changedTouches.item(0);
  return i === null || o === null ? !1 : i.getBoundingClientRect().right > o.clientX && i.getBoundingClientRect().left < o.clientX && i.getBoundingClientRect().top < o.clientY && i.getBoundingClientRect().bottom > o.clientY;
}
function Hu() {
  return { rootFontSize: Te(() => Ue && parseFloat(getComputedStyle(document.documentElement).fontSize) || 16) };
}
const zu = (e, t) => {
  if (!t) {
    const n = Math.floor(e / 3600), i = Math.floor((e - n * 3600) / 60), o = Math.round((e - n * 3600 - i * 60) * 100) / 100, a = i + n * 60, r = ":" + (o < 10 ? "0" + o : o).toString();
    return a.toString() + r;
  }
  return e >= 3600 ? new Date(e * 1e3).toISOString().slice(11, 19) : new Date(e * 1e3).toISOString().slice(14, 19);
}, el = ge(void 0), cd = ge(void 0), dd = ge(void 0), ud = ge(void 0), wv = ge(void 0), kv = ge(void 0), Sv = ge(void 0), Cv = ge(!1), Fn = () => {
  const e = (S) => {
    el.value = S;
  }, t = (S, w = xm().productHeader.value) => {
    cd.value = S, wv.value = w;
  }, n = (S, w) => {
    dd.value = S, kv.value = w;
  }, i = (S, w) => {
    ud.value = S, Sv.value = w;
  };
  function o(S) {
    if (!S?.value)
      return 0;
    const { display: w, visibility: x } = S.value.style;
    S.value.style.visibility = "hidden", S.value.style.display = "block";
    const k = S.value.offsetHeight;
    return S.value.style.visibility = x, S.value.style.display = w, k || 0;
  }
  const a = () => o(el), r = () => o(cd), s = () => o(dd), l = () => o(ud), d = () => (Cv.value = el.value ? el.value.classList.value.includes("fixed-on-up") : !1, Cv.value), y = (S, w = 0) => Ue && window.scrollY > S - w, u = (S, w, x = 0) => Ue && !!w && S - x > w.getBoundingClientRect().bottom + window.scrollY, m = (S, w = "show-element") => !!S?.value?.classList.contains(w), h = () => m(cd), c = () => m(dd), g = () => m(ud), v = (S) => {
    if (!Ue)
      return 0;
    const w = [
      { trigger: wv.value, height: r() },
      { trigger: kv.value, height: s() },
      { trigger: Sv.value, height: l() }
    ];
    let x = 0;
    return x += y(S) ? a() : d() ? -a() : 0, w.forEach(({ trigger: k, height: A }) => {
      u(S, k, x) && (x += A);
    }), x;
  }, P = (S, w = 0) => {
    const x = S?.getBoundingClientRect().top || 0;
    if (!Ue)
      return x;
    let k = x + window.scrollY || 0;
    return k += w, k -= v(k), k;
  };
  return {
    headerRef: el,
    shrinkHeaderRef: cd,
    shrinkSearchRef: dd,
    shrinkPanelRef: ud,
    headerHeight: a,
    shrinkHeaderHeight: r,
    shrinkSearchHeight: s,
    shrinkPanelHeight: l,
    setHeader: e,
    setShrinkHeader: t,
    setShrinkSearch: n,
    setShrinkPanel: i,
    calculateScrollPosition: P,
    calculateOffset: v,
    isHeaderExpanded: d,
    isShrinkHeaderExpanded: h,
    isShrinkSearchExpanded: c,
    isShrinkPanelExpanded: g,
    scrollToTwice: (S, w, x = 0, k = 1e3, A = 1e3) => {
      let $ = x;
      const j = () => S({
        scrollTo: P(w, $),
        offset: x,
        duration: k,
        updateHistory: !1
      });
      j(), $ = 0, fi(j, A);
    },
    willHeaderExpand: y,
    willStickyElementExpand: u
  };
};
var qx = !1;
function hd(e, t, n) {
  return Array.isArray(e) ? (e.length = Math.max(e.length, t), e.splice(t, 1, n), n) : (e[t] = n, n);
}
function Xh(e, t) {
  if (Array.isArray(e)) {
    e.splice(t, 1);
    return;
  }
  delete e[t];
}
function Cs(e) {
  return Ox() ? (Bx(e), !0) : !1;
}
function Zh() {
  const e = /* @__PURE__ */ new Set(), t = (o) => {
    e.delete(o);
  };
  return {
    on: (o) => {
      e.add(o);
      const a = () => t(o);
      return Cs(a), {
        off: a
      };
    },
    off: t,
    trigger: (...o) => Promise.all(Array.from(e).map((a) => a(...o)))
  };
}
function Xn(e) {
  return typeof e == "function" ? e() : _(e);
}
const Vu = typeof window < "u" && typeof document < "u";
typeof WorkerGlobalScope < "u" && globalThis instanceof WorkerGlobalScope;
const UI = (e) => e != null, WI = Object.prototype.toString, YI = (e) => WI.call(e) === "[object Object]", Mi = () => {
}, qI = /* @__PURE__ */ KI();
function KI() {
  var e, t;
  return Vu && ((e = window?.navigator) == null ? void 0 : e.userAgent) && (/iP(?:ad|hone|od)/.test(window.navigator.userAgent) || ((t = window?.navigator) == null ? void 0 : t.maxTouchPoints) > 2 && /iPad|Macintosh/.test(window?.navigator.userAgent));
}
function XI(e, t) {
  function n(...i) {
    return new Promise((o, a) => {
      Promise.resolve(e(() => t.apply(this, i), { fn: t, thisArg: this, args: i })).then(o).catch(a);
    });
  }
  return n;
}
function ZI(e, t = {}) {
  let n, i, o = Mi;
  const a = (s) => {
    clearTimeout(s), o(), o = Mi;
  };
  return (s) => {
    const l = Xn(e), d = Xn(t.maxWait);
    return n && a(n), l <= 0 || d !== void 0 && d <= 0 ? (i && (a(i), i = null), Promise.resolve(s())) : new Promise((y, u) => {
      o = t.rejectOnCancel ? u : y, d && !i && (i = setTimeout(() => {
        n && a(n), i = null, y(s());
      }, d)), n = setTimeout(() => {
        i && a(i), i = null, y(s());
      }, l);
    });
  };
}
function Tv(e, t = !1, n = "Timeout") {
  return new Promise((i, o) => {
    setTimeout(t ? () => o(n) : i, e);
  });
}
function JI(e) {
  let t;
  function n() {
    return t || (t = e()), t;
  }
  return n.reset = async () => {
    const i = t;
    t = void 0, i && await i;
  }, n;
}
function QI(e, ...t) {
  return t.some((n) => n in e);
}
function eP(e, t) {
  var n;
  if (typeof e == "number")
    return e + t;
  const i = ((n = e.match(/^-?\d+\.?\d*/)) == null ? void 0 : n[0]) || "", o = e.slice(i.length), a = Number.parseFloat(i) + t;
  return Number.isNaN(a) ? e : a + o;
}
function Jh(...e) {
  if (e.length !== 1)
    return xi(...e);
  const t = e[0];
  return typeof t == "function" ? _l(EL(() => ({ get: t, set: Mi }))) : ge(t);
}
function Jn(e, t = 200, n = {}) {
  return XI(
    ZI(t, n),
    e
  );
}
function Fp(e, t = !1) {
  function n(u, { flush: m = "sync", deep: h = !1, timeout: c, throwOnTimeout: g } = {}) {
    let v = null;
    const f = [new Promise((S) => {
      v = qe(
        e,
        (w) => {
          u(w) !== t && (v?.(), S(w));
        },
        {
          flush: m,
          deep: h,
          immediate: !0
        }
      );
    })];
    return c != null && f.push(
      Tv(c, g).then(() => Xn(e)).finally(() => v?.())
    ), Promise.race(f);
  }
  function i(u, m) {
    if (!In(u))
      return n((w) => w === u, m);
    const { flush: h = "sync", deep: c = !1, timeout: g, throwOnTimeout: v } = m ?? {};
    let P = null;
    const S = [new Promise((w) => {
      P = qe(
        [e, u],
        ([x, k]) => {
          t !== (x === k) && (P?.(), w(x));
        },
        {
          flush: h,
          deep: c,
          immediate: !0
        }
      );
    })];
    return g != null && S.push(
      Tv(g, v).then(() => Xn(e)).finally(() => (P?.(), Xn(e)))
    ), Promise.race(S);
  }
  function o(u) {
    return n((m) => !!m, u);
  }
  function a(u) {
    return i(null, u);
  }
  function r(u) {
    return i(void 0, u);
  }
  function s(u) {
    return n(Number.isNaN, u);
  }
  function l(u, m) {
    return n((h) => {
      const c = Array.from(h);
      return c.includes(u) || c.includes(Xn(u));
    }, m);
  }
  function d(u) {
    return y(1, u);
  }
  function y(u = 1, m) {
    let h = -1;
    return n(() => (h += 1, h >= u), m);
  }
  return Array.isArray(Xn(e)) ? {
    toMatch: n,
    toContains: l,
    changed: d,
    changedTimes: y,
    get not() {
      return Fp(e, !t);
    }
  } : {
    toMatch: n,
    toBe: i,
    toBeTruthy: o,
    toBeNull: a,
    toBeNaN: s,
    toBeUndefined: r,
    changed: d,
    changedTimes: y,
    get not() {
      return Fp(e, !t);
    }
  };
}
function tP(e) {
  return Fp(e);
}
function Kx(e, t, n = {}) {
  const {
    immediate: i = !0
  } = n, o = ge(!1);
  let a = null;
  function r() {
    a && (clearTimeout(a), a = null);
  }
  function s() {
    o.value = !1, r();
  }
  function l(...d) {
    r(), o.value = !0, a = setTimeout(() => {
      o.value = !1, a = null, e(...d);
    }, Xn(t));
  }
  return i && (o.value = !0, Vu && l()), Cs(s), {
    isPending: _l(o),
    start: l,
    stop: s
  };
}
function Di(e, t, n) {
  let i;
  In(n) ? i = {
    evaluating: n
  } : i = n || {};
  const {
    lazy: o = !1,
    evaluating: a = void 0,
    shallow: r = !0,
    onError: s = Mi
  } = i, l = ge(!o), d = r ? ti(t) : ge(t);
  let y = 0;
  return Ex(async (u) => {
    if (!l.value)
      return;
    y++;
    const m = y;
    let h = !1;
    a && Promise.resolve().then(() => {
      a.value = !0;
    });
    try {
      const c = await e((g) => {
        u(() => {
          a && (a.value = !1), h || g();
        });
      });
      m === y && (d.value = c);
    } catch (c) {
      s(c);
    } finally {
      a && m === y && (a.value = !1), h = !0;
    }
  }), o ? Te(() => (l.value = !0, d.value)) : d;
}
function Ta(e) {
  var t;
  const n = Xn(e);
  return (t = n?.$el) != null ? t : n;
}
const mo = Vu ? window : void 0, Xx = Vu ? window.navigator : void 0;
function wi(...e) {
  let t, n, i, o;
  if (typeof e[0] == "string" || Array.isArray(e[0]) ? ([n, i, o] = e, t = mo) : [t, n, i, o] = e, !t)
    return Mi;
  Array.isArray(n) || (n = [n]), Array.isArray(i) || (i = [i]);
  const a = [], r = () => {
    a.forEach((y) => y()), a.length = 0;
  }, s = (y, u, m, h) => (y.addEventListener(u, m, h), () => y.removeEventListener(u, m, h)), l = qe(
    () => [Ta(t), Xn(o)],
    ([y, u]) => {
      if (r(), !y)
        return;
      const m = YI(u) ? { ...u } : u;
      a.push(
        ...n.flatMap((h) => i.map((c) => s(y, h, c, m)))
      );
    },
    { immediate: !0, flush: "post" }
  ), d = () => {
    l(), r();
  };
  return Cs(d), d;
}
let Lv = !1;
function ym(e, t, n = {}) {
  const { window: i = mo, ignore: o = [], capture: a = !0, detectIframe: r = !1 } = n;
  if (!i)
    return Mi;
  qI && !Lv && (Lv = !0, Array.from(i.document.body.children).forEach((m) => m.addEventListener("click", Mi)), i.document.documentElement.addEventListener("click", Mi));
  let s = !0;
  const l = (m) => o.some((h) => {
    if (typeof h == "string")
      return Array.from(i.document.querySelectorAll(h)).some((c) => c === m.target || m.composedPath().includes(c));
    {
      const c = Ta(h);
      return c && (m.target === c || m.composedPath().includes(c));
    }
  }), y = [
    wi(i, "click", (m) => {
      const h = Ta(e);
      if (!(!h || h === m.target || m.composedPath().includes(h))) {
        if (m.detail === 0 && (s = !l(m)), !s) {
          s = !0;
          return;
        }
        t(m);
      }
    }, { passive: !0, capture: a }),
    wi(i, "pointerdown", (m) => {
      const h = Ta(e);
      s = !l(m) && !!(h && !m.composedPath().includes(h));
    }, { passive: !0 }),
    r && wi(i, "blur", (m) => {
      setTimeout(() => {
        var h;
        const c = Ta(e);
        ((h = i.document.activeElement) == null ? void 0 : h.tagName) === "IFRAME" && !c?.contains(i.document.activeElement) && t(m);
      }, 0);
    })
  ].filter(Boolean);
  return () => y.forEach((m) => m());
}
function nP() {
  const e = ge(!1), t = ho();
  return t && it(() => {
    e.value = !0;
  }, t), e;
}
function Gc(e) {
  const t = nP();
  return Te(() => (t.value, !!e()));
}
function no(e, t = {}) {
  const { window: n = mo } = t, i = Gc(() => n && "matchMedia" in n && typeof n.matchMedia == "function");
  let o;
  const a = ge(!1), r = (d) => {
    a.value = d.matches;
  }, s = () => {
    o && ("removeEventListener" in o ? o.removeEventListener("change", r) : o.removeListener(r));
  }, l = Ex(() => {
    i.value && (s(), o = n.matchMedia(Xn(e)), "addEventListener" in o ? o.addEventListener("change", r) : o.addListener(r), a.value = o.matches);
  });
  return Cs(() => {
    l(), s(), o = void 0;
  }), a;
}
function iP(e, t = {}) {
  function n(y, u) {
    let m = Xn(e[Xn(y)]);
    return u != null && (m = eP(m, u)), typeof m == "number" && (m = `${m}px`), m;
  }
  const { window: i = mo, strategy: o = "min-width" } = t;
  function a(y) {
    return i ? i.matchMedia(y).matches : !1;
  }
  const r = (y) => no(() => `(min-width: ${n(y)})`, t), s = (y) => no(() => `(max-width: ${n(y)})`, t), l = Object.keys(e).reduce((y, u) => (Object.defineProperty(y, u, {
    get: () => o === "min-width" ? r(u) : s(u),
    enumerable: !0,
    configurable: !0
  }), y), {});
  function d() {
    const y = Object.keys(e).map((u) => [u, r(u)]);
    return Te(() => y.filter(([, u]) => u.value).map(([u]) => u));
  }
  return Object.assign(l, {
    greaterOrEqual: r,
    smallerOrEqual: s,
    greater(y) {
      return no(() => `(min-width: ${n(y, 0.1)})`, t);
    },
    smaller(y) {
      return no(() => `(max-width: ${n(y, -0.1)})`, t);
    },
    between(y, u) {
      return no(() => `(min-width: ${n(y)}) and (max-width: ${n(u, -0.1)})`, t);
    },
    isGreater(y) {
      return a(`(min-width: ${n(y, 0.1)})`);
    },
    isGreaterOrEqual(y) {
      return a(`(min-width: ${n(y)})`);
    },
    isSmaller(y) {
      return a(`(max-width: ${n(y, -0.1)})`);
    },
    isSmallerOrEqual(y) {
      return a(`(max-width: ${n(y)})`);
    },
    isInBetween(y, u) {
      return a(`(min-width: ${n(y)}) and (max-width: ${n(u, -0.1)})`);
    },
    current: d,
    active() {
      const y = d();
      return Te(() => y.value.length === 0 ? "" : y.value.at(-1));
    }
  });
}
function Iv(e, t = {}) {
  const {
    controls: n = !1,
    navigator: i = Xx
  } = t, o = Gc(() => i && "permissions" in i);
  let a;
  const r = typeof e == "string" ? { name: e } : e, s = ge(), l = () => {
    a && (s.value = a.state);
  }, d = JI(async () => {
    if (o.value) {
      if (!a)
        try {
          a = await i.permissions.query(r), wi(a, "change", l), l();
        } catch {
          s.value = "prompt";
        }
      return a;
    }
  });
  return d(), n ? {
    state: s,
    isSupported: o,
    query: d
  } : s;
}
function aP(e = {}) {
  const {
    navigator: t = Xx,
    read: n = !1,
    source: i,
    copiedDuring: o = 1500,
    legacy: a = !1
  } = e, r = Gc(() => t && "clipboard" in t), s = Iv("clipboard-read"), l = Iv("clipboard-write"), d = Te(() => r.value || a), y = ge(""), u = ge(!1), m = Kx(() => u.value = !1, o);
  function h() {
    r.value && P(s.value) ? t.clipboard.readText().then((f) => {
      y.value = f;
    }) : y.value = v();
  }
  d.value && n && wi(["copy", "cut"], h);
  async function c(f = Xn(i)) {
    d.value && f != null && (r.value && P(l.value) ? await t.clipboard.writeText(f) : g(f), y.value = f, u.value = !0, m.start());
  }
  function g(f) {
    const S = document.createElement("textarea");
    S.value = f ?? "", S.style.position = "absolute", S.style.opacity = "0", document.body.appendChild(S), S.select(), document.execCommand("copy"), S.remove();
  }
  function v() {
    var f, S, w;
    return (w = (S = (f = document?.getSelection) == null ? void 0 : f.call(document)) == null ? void 0 : S.toString()) != null ? w : "";
  }
  function P(f) {
    return f === "granted" || f === "prompt";
  }
  return {
    isSupported: d,
    text: y,
    copied: u,
    copy: c
  };
}
function oP(e, t, n = {}) {
  const { window: i = mo, ...o } = n;
  let a;
  const r = Gc(() => i && "ResizeObserver" in i), s = () => {
    a && (a.disconnect(), a = void 0);
  }, l = Te(() => Array.isArray(e) ? e.map((u) => Ta(u)) : [Ta(e)]), d = qe(
    l,
    (u) => {
      if (s(), r.value && i) {
        a = new ResizeObserver(t);
        for (const m of u)
          m && a.observe(m, o);
      }
    },
    { immediate: !0, flush: "post" }
  ), y = () => {
    s(), d();
  };
  return Cs(y), {
    isSupported: r,
    stop: y
  };
}
function rP(e, t, n = {}) {
  const {
    root: i,
    rootMargin: o = "0px",
    threshold: a = 0.1,
    window: r = mo,
    immediate: s = !0
  } = n, l = Gc(() => r && "IntersectionObserver" in r), d = Te(() => {
    const c = Xn(e);
    return (Array.isArray(c) ? c : [c]).map(Ta).filter(UI);
  });
  let y = Mi;
  const u = ge(s), m = l.value ? qe(
    () => [d.value, Ta(i), u.value],
    ([c, g]) => {
      if (y(), !u.value || !c.length)
        return;
      const v = new IntersectionObserver(
        t,
        {
          root: Ta(g),
          rootMargin: o,
          threshold: a
        }
      );
      c.forEach((P) => P && v.observe(P)), y = () => {
        v.disconnect(), y = Mi;
      };
    },
    { immediate: s, flush: "post" }
  ) : Mi, h = () => {
    y(), m(), u.value = !1;
  };
  return Cs(h), {
    isSupported: l,
    isActive: u,
    pause() {
      y(), u.value = !1;
    },
    resume() {
      u.value = !0;
    },
    stop: h
  };
}
function sP(e, t = {}) {
  const { window: n = mo, scrollTarget: i, threshold: o = 0 } = t, a = ge(!1);
  return rP(
    e,
    (r) => {
      let s = a.value, l = 0;
      for (const d of r)
        d.time >= l && (l = d.time, s = d.isIntersecting);
      a.value = s;
    },
    {
      root: i,
      window: n,
      threshold: o
    }
  ), a;
}
const lP = {
  json: "application/json",
  text: "text/plain"
};
function Pv(e) {
  return e && QI(e, "immediate", "refetch", "initialData", "timeout", "beforeFetch", "afterFetch", "onFetchError", "fetch", "updateDataOnError");
}
function Qh(e) {
  return typeof Headers < "u" && e instanceof Headers ? Object.fromEntries(e.entries()) : e;
}
function Av(e, ...t) {
  var n;
  const i = typeof AbortController == "function";
  let o = {}, a = {
    immediate: !0,
    refetch: !1,
    timeout: 0,
    updateDataOnError: !1
  };
  const r = {
    method: "GET",
    type: "text",
    payload: void 0
  };
  t.length > 0 && (Pv(t[0]) ? a = { ...a, ...t[0] } : o = t[0]), t.length > 1 && Pv(t[1]) && (a = { ...a, ...t[1] });
  const {
    fetch: s = (n = mo) == null ? void 0 : n.fetch,
    initialData: l,
    timeout: d
  } = a, y = Zh(), u = Zh(), m = Zh(), h = ge(!1), c = ge(!1), g = ge(!1), v = ge(null), P = ti(null), f = ti(null), S = ti(l || null), w = Te(() => i && c.value);
  let x, k;
  const A = () => {
    i && (x?.abort(), x = new AbortController(), x.signal.onabort = () => g.value = !0, o = {
      ...o,
      signal: x.signal
    });
  }, $ = (L) => {
    c.value = L, h.value = !L;
  };
  d && (k = Kx(A, d, { immediate: !1 }));
  let j = 0;
  const N = async (L = !1) => {
    var B, T;
    A(), $(!0), f.value = null, v.value = null, g.value = !1, j += 1;
    const O = j, I = {
      method: r.method,
      headers: {}
    };
    if (r.payload) {
      const U = Qh(I.headers), Q = Xn(r.payload);
      !r.payloadType && Q && Object.getPrototypeOf(Q) === Object.prototype && !(Q instanceof FormData) && (r.payloadType = "json"), r.payloadType && (U["Content-Type"] = (B = lP[r.payloadType]) != null ? B : r.payloadType), I.body = r.payloadType === "json" ? JSON.stringify(Q) : Q;
    }
    let R = !1;
    const Y = {
      url: Xn(e),
      options: {
        ...I,
        ...o
      },
      cancel: () => {
        R = !0;
      }
    };
    if (a.beforeFetch && Object.assign(Y, await a.beforeFetch(Y)), R || !s)
      return $(!1), Promise.resolve(null);
    let F = null;
    return k && k.start(), s(
      Y.url,
      {
        ...I,
        ...Y.options,
        headers: {
          ...Qh(I.headers),
          ...Qh((T = Y.options) == null ? void 0 : T.headers)
        }
      }
    ).then(async (U) => {
      if (P.value = U, v.value = U.status, F = await U.clone()[r.type](), !U.ok)
        throw S.value = l || null, new Error(U.statusText);
      return a.afterFetch && ({ data: F } = await a.afterFetch({
        data: F,
        response: U
      })), S.value = F, y.trigger(U), U;
    }).catch(async (U) => {
      let Q = U.message || U.name;
      if (a.onFetchError && ({ error: Q, data: F } = await a.onFetchError({
        data: F,
        error: U,
        response: P.value
      })), f.value = Q, a.updateDataOnError && (S.value = F), u.trigger(U), L)
        throw U;
      return null;
    }).finally(() => {
      O === j && $(!1), k && k.stop(), m.trigger(null);
    });
  }, M = Jh(a.refetch);
  qe(
    [
      M,
      Jh(e)
    ],
    ([L]) => L && N(),
    { deep: !0 }
  );
  const D = {
    isFinished: _l(h),
    isFetching: _l(c),
    statusCode: v,
    response: P,
    error: f,
    data: S,
    canAbort: w,
    aborted: g,
    abort: A,
    execute: N,
    onFetchResponse: y.on,
    onFetchError: u.on,
    onFetchFinally: m.on,
    // method
    get: C("GET"),
    put: C("PUT"),
    post: C("POST"),
    delete: C("DELETE"),
    patch: C("PATCH"),
    head: C("HEAD"),
    options: C("OPTIONS"),
    // type
    json: p("json"),
    text: p("text"),
    blob: p("blob"),
    arrayBuffer: p("arrayBuffer"),
    formData: p("formData")
  };
  function C(L) {
    return (B, T) => {
      if (!c.value)
        return r.method = L, r.payload = B, r.payloadType = T, In(r.payload) && qe(
          [
            M,
            Jh(r.payload)
          ],
          ([O]) => O && N(),
          { deep: !0 }
        ), {
          ...D,
          then(O, I) {
            return b().then(O, I);
          }
        };
    };
  }
  function b() {
    return new Promise((L, B) => {
      tP(h).toBe(!0).then(() => L(D)).catch((T) => B(T));
    });
  }
  function p(L) {
    return () => {
      if (!c.value)
        return r.type = L, {
          ...D,
          then(B, T) {
            return b().then(B, T);
          }
        };
    };
  }
  return a.immediate && Promise.resolve().then(() => N()), {
    ...D,
    then(L, B) {
      return b().then(L, B);
    }
  };
}
function Zx(e, t = {}) {
  const {
    threshold: n = 50,
    onSwipe: i,
    onSwipeEnd: o,
    onSwipeStart: a,
    passive: r = !0,
    window: s = mo
  } = t, l = Qi({ x: 0, y: 0 }), d = Qi({ x: 0, y: 0 }), y = Te(() => l.x - d.x), u = Te(() => l.y - d.y), { max: m, abs: h } = Math, c = Te(() => m(h(y.value), h(u.value)) >= n), g = ge(!1), v = Te(() => c.value ? h(y.value) > h(u.value) ? y.value > 0 ? "left" : "right" : u.value > 0 ? "up" : "down" : "none"), P = (j) => [j.touches[0].clientX, j.touches[0].clientY], f = (j, N) => {
    l.x = j, l.y = N;
  }, S = (j, N) => {
    d.x = j, d.y = N;
  };
  let w;
  const x = cP(s?.document);
  r ? w = x ? { passive: !0 } : { capture: !1 } : w = x ? { passive: !1, capture: !0 } : { capture: !0 };
  const k = (j) => {
    g.value && o?.(j, v.value), g.value = !1;
  }, A = [
    wi(e, "touchstart", (j) => {
      if (j.touches.length !== 1)
        return;
      w.capture && !w.passive && j.preventDefault();
      const [N, M] = P(j);
      f(N, M), S(N, M), a?.(j);
    }, w),
    wi(e, "touchmove", (j) => {
      if (j.touches.length !== 1)
        return;
      const [N, M] = P(j);
      S(N, M), !g.value && c.value && (g.value = !0), g.value && i?.(j);
    }, w),
    wi(e, ["touchend", "touchcancel"], k, w)
  ];
  return {
    isPassiveEventSupported: x,
    isSwiping: g,
    direction: v,
    coordsStart: l,
    coordsEnd: d,
    lengthX: y,
    lengthY: u,
    stop: () => A.forEach((j) => j())
  };
}
function cP(e) {
  if (!e)
    return !1;
  let t = !1;
  const n = {
    get passive() {
      return t = !0, !1;
    }
  };
  return e.addEventListener("x", Mi, n), e.removeEventListener("x", Mi), t;
}
const dP = () => {
  if (!Ue)
    return { isTouchDevice: ge(!1) };
  const e = ge(!1), t = () => {
    const n = (window.top || window).navigator;
    if ("maxTouchPoints" in n) {
      const o = Number.isFinite(n.maxTouchPoints) ? n.maxTouchPoints : n.msMaxTouchPoints;
      e.value = o > 0 && o !== 256;
      return;
    }
    const i = window.navigator.userAgent;
    e.value = /\b(BlackBerry|webOS|iPhone|IEMobile)\b/i.test(i) || /\b(Android|Windows Phone|iPad|iPod)\b/i.test(i);
  };
  return Ue && (wi(window, "resize", () => t(), {
    passive: !0
  }), wi(window, "DOMContentLoaded", () => t())), {
    isTouchDevice: e
  };
};
function Uc() {
  const { currentLocale: e } = Je();
  return {
    abbreviateNumber: (o, a = {
      useDefaultOptions: !0
    }) => {
      if (isNaN(o))
        return o;
      a?.useDefaultOptions && (a = {
        useDefaultOptions: !0,
        minimumAbbreviation: a.minimumAbbreviation || 1e6,
        checkForInteger: a.checkForInteger || !1,
        currency: a.currency || void 0,
        currencyDisplay: a.currencyDisplay || void 0,
        minimumFractionDigits: isNaN(a.minimumFractionDigits) ? 2 : a.minimumFractionDigits,
        maximumFractionDigits: isNaN(a.minimumFractionDigits) ? 2 : a.maximumFractionDigits
      });
      const r = o >= a?.minimumAbbreviation, s = a?.checkForInteger ? Number.isInteger(o) : !1;
      return new Intl.NumberFormat(e.value.toString(), {
        notation: r ? "compact" : void 0,
        compactDisplay: r ? "short" : void 0,
        style: a?.currency ? "currency" : void 0,
        currency: a?.currency,
        currencyDisplay: a?.currencyDisplay,
        minimumFractionDigits: s ? 0 : a?.minimumFractionDigits,
        maximumFractionDigits: a?.maximumFractionDigits
      }).format(o);
    },
    getCurrencyAffix: (o = "EUR") => {
      const a = (u) => new Intl.NumberFormat(e.value.toString(), {
        style: "currency",
        currency: u,
        maximumFractionDigits: 0,
        currencyDisplay: "symbol"
      }).formatToParts(1), r = (u) => {
        let m = -1, h = -1;
        for (let c = 0; c < u.length && (u[c].type === "currency" && m === -1 && (m = c), u[c].type === "integer" && h === -1 && (h = c), !(m !== -1 && h !== -1)); c++)
          ;
        return m !== -1 && h !== -1 && m < h;
      }, s = (u) => u.filter((m) => m.type !== "integer").map((m) => m.value).join(""), l = a(o), d = s(l), y = r(l);
      return {
        prefix: y ? d : null,
        suffix: y ? null : d
      };
    },
    checkNumberString: (o) => {
      const a = new Intl.NumberFormat(
        e.value.toString()
      ).formatToParts(10000001e-1), r = a.find((u) => u.type === "decimal")?.value ?? ".", s = a.find((u) => u.type === "group")?.value ?? ",";
      if (!new RegExp(
        `^-?\\d{1,3}((\\${s}?\\d{3})*)?(\\${r}\\d+)?$`
      ).test(o))
        return {
          value: void 0,
          isNumber: !1,
          isInteger: !1,
          isPositive: !1
        };
      let d = o.replace(
        new RegExp(`\\${s}`, "g"),
        ""
      );
      r !== "." && (d = d.replace(r, "."));
      const y = Number(d);
      return {
        value: y,
        isNumber: !isNaN(y),
        isInteger: Number.isInteger(y),
        isPositive: !o.startsWith("-") && y >= 0
      };
    }
  };
}
const dBe = (e, t) => {
  const { currentLocale: n } = Je(), i = Intl.DateTimeFormat(n.value, {
    timeZone: t,
    timeZoneName: "short",
    hour: "numeric",
    minute: "numeric"
  }), o = new Date(e);
  return i.format(o);
}, Jx = () => {
  const e = ge(0), t = ge(0), n = (a) => {
    Ue && a && oP(a, (r) => {
      r.forEach((s) => {
        t.value = s.contentRect.height, e.value = s.contentRect.width;
      });
    });
  }, i = Te(() => e.value), o = Te(() => t.value);
  return { elementWidth: i, elementHeight: o, registerObserver: n };
}, Qe = () => ({ pageName: (Ue && window.utag_data?.page_name) ?? "" });
function bm() {
  return {
    onRowsPerPageChanged: (t, n, i) => {
      const o = typeof t == "object" ? t.rows || t.value : t;
      typeof o == "number" && (n.value = 0, i.value = o);
    }
  };
}
const uP = ge(), xm = () => ({ productHeader: uP });
var jp = { exports: {} };
(function(e, t) {
  (function(n, i) {
    var o = "1.0.37", a = "", r = "?", s = "function", l = "undefined", d = "object", y = "string", u = "major", m = "model", h = "name", c = "type", g = "vendor", v = "version", P = "architecture", f = "console", S = "mobile", w = "tablet", x = "smarttv", k = "wearable", A = "embedded", $ = 500, j = "Amazon", N = "Apple", M = "ASUS", D = "BlackBerry", C = "Browser", b = "Chrome", p = "Edge", L = "Firefox", B = "Google", T = "Huawei", O = "LG", I = "Microsoft", R = "Motorola", Y = "Opera", F = "Samsung", U = "Sharp", Q = "Sony", J = "Xiaomi", ee = "Zebra", V = "Facebook", G = "Chromium OS", W = "Mac OS", ae = function(he, ve) {
      var ye = {};
      for (var be in he)
        ve[be] && ve[be].length % 2 === 0 ? ye[be] = ve[be].concat(he[be]) : ye[be] = he[be];
      return ye;
    }, z = function(he) {
      for (var ve = {}, ye = 0; ye < he.length; ye++)
        ve[he[ye].toUpperCase()] = he[ye];
      return ve;
    }, q = function(he, ve) {
      return typeof he === y ? Z(ve).indexOf(Z(he)) !== -1 : !1;
    }, Z = function(he) {
      return he.toLowerCase();
    }, ne = function(he) {
      return typeof he === y ? he.replace(/[^\d\.]/g, a).split(".")[0] : i;
    }, ie = function(he, ve) {
      if (typeof he === y)
        return he = he.replace(/^\s\s*/, a), typeof ve === l ? he : he.substring(0, $);
    }, re = function(he, ve) {
      for (var ye = 0, be, ke, we, Le, Me, De; ye < ve.length && !Me; ) {
        var Ae = ve[ye], _e = ve[ye + 1];
        for (be = ke = 0; be < Ae.length && !Me && Ae[be]; )
          if (Me = Ae[be++].exec(he), Me)
            for (we = 0; we < _e.length; we++)
              De = Me[++ke], Le = _e[we], typeof Le === d && Le.length > 0 ? Le.length === 2 ? typeof Le[1] == s ? this[Le[0]] = Le[1].call(this, De) : this[Le[0]] = Le[1] : Le.length === 3 ? typeof Le[1] === s && !(Le[1].exec && Le[1].test) ? this[Le[0]] = De ? Le[1].call(this, De, Le[2]) : i : this[Le[0]] = De ? De.replace(Le[1], Le[2]) : i : Le.length === 4 && (this[Le[0]] = De ? Le[3].call(this, De.replace(Le[1], Le[2])) : i) : this[Le] = De || i;
        ye += 2;
      }
    }, de = function(he, ve) {
      for (var ye in ve)
        if (typeof ve[ye] === d && ve[ye].length > 0) {
          for (var be = 0; be < ve[ye].length; be++)
            if (q(ve[ye][be], he))
              return ye === r ? i : ye;
        } else if (q(ve[ye], he))
          return ye === r ? i : ye;
      return he;
    }, me = {
      "1.0": "/8",
      "1.2": "/1",
      "1.3": "/3",
      "2.0": "/412",
      "2.0.2": "/416",
      "2.0.3": "/417",
      "2.0.4": "/419",
      "?": "/"
    }, ce = {
      ME: "4.90",
      "NT 3.11": "NT3.51",
      "NT 4.0": "NT4.0",
      2e3: "NT 5.0",
      XP: ["NT 5.1", "NT 5.2"],
      Vista: "NT 6.0",
      7: "NT 6.1",
      8: "NT 6.2",
      "8.1": "NT 6.3",
      10: ["NT 6.4", "NT 10.0"],
      RT: "ARM"
    }, pe = {
      browser: [
        [
          /\b(?:crmo|crios)\/([\w\.]+)/i
          // Chrome for Android/iOS
        ],
        [v, [h, "Chrome"]],
        [
          /edg(?:e|ios|a)?\/([\w\.]+)/i
          // Microsoft Edge
        ],
        [v, [h, "Edge"]],
        [
          // Presto based
          /(opera mini)\/([-\w\.]+)/i,
          // Opera Mini
          /(opera [mobiletab]{3,6})\b.+version\/([-\w\.]+)/i,
          // Opera Mobi/Tablet
          /(opera)(?:.+version\/|[\/ ]+)([\w\.]+)/i
          // Opera
        ],
        [h, v],
        [
          /opios[\/ ]+([\w\.]+)/i
          // Opera mini on iphone >= 8.0
        ],
        [v, [h, Y + " Mini"]],
        [
          /\bopr\/([\w\.]+)/i
          // Opera Webkit
        ],
        [v, [h, Y]],
        [
          // Mixed
          /\bb[ai]*d(?:uhd|[ub]*[aekoprswx]{5,6})[\/ ]?([\w\.]+)/i
          // Baidu
        ],
        [v, [h, "Baidu"]],
        [
          /(kindle)\/([\w\.]+)/i,
          // Kindle
          /(lunascape|maxthon|netfront|jasmine|blazer)[\/ ]?([\w\.]*)/i,
          // Lunascape/Maxthon/Netfront/Jasmine/Blazer
          // Trident based
          /(avant|iemobile|slim)\s?(?:browser)?[\/ ]?([\w\.]*)/i,
          // Avant/IEMobile/SlimBrowser
          /(?:ms|\()(ie) ([\w\.]+)/i,
          // Internet Explorer
          // Webkit/KHTML based                                               // Flock/RockMelt/Midori/Epiphany/Silk/Skyfire/Bolt/Iron/Iridium/PhantomJS/Bowser/QupZilla/Falkon
          /(flock|rockmelt|midori|epiphany|silk|skyfire|bolt|iron|vivaldi|iridium|phantomjs|bowser|quark|qupzilla|falkon|rekonq|puffin|brave|whale(?!.+naver)|qqbrowserlite|qq|duckduckgo)\/([-\w\.]+)/i,
          // Rekonq/Puffin/Brave/Whale/QQBrowserLite/QQ, aka ShouQ
          /(heytap|ovi)browser\/([\d\.]+)/i,
          // Heytap/Ovi
          /(weibo)__([\d\.]+)/i
          // Weibo
        ],
        [h, v],
        [
          /(?:\buc? ?browser|(?:juc.+)ucweb)[\/ ]?([\w\.]+)/i
          // UCBrowser
        ],
        [v, [h, "UC" + C]],
        [
          /microm.+\bqbcore\/([\w\.]+)/i,
          // WeChat Desktop for Windows Built-in Browser
          /\bqbcore\/([\w\.]+).+microm/i,
          /micromessenger\/([\w\.]+)/i
          // WeChat
        ],
        [v, [h, "WeChat"]],
        [
          /konqueror\/([\w\.]+)/i
          // Konqueror
        ],
        [v, [h, "Konqueror"]],
        [
          /trident.+rv[: ]([\w\.]{1,9})\b.+like gecko/i
          // IE11
        ],
        [v, [h, "IE"]],
        [
          /ya(?:search)?browser\/([\w\.]+)/i
          // Yandex
        ],
        [v, [h, "Yandex"]],
        [
          /slbrowser\/([\w\.]+)/i
          // Smart Lenovo Browser
        ],
        [v, [h, "Smart Lenovo " + C]],
        [
          /(avast|avg)\/([\w\.]+)/i
          // Avast/AVG Secure Browser
        ],
        [[h, /(.+)/, "$1 Secure " + C], v],
        [
          /\bfocus\/([\w\.]+)/i
          // Firefox Focus
        ],
        [v, [h, L + " Focus"]],
        [
          /\bopt\/([\w\.]+)/i
          // Opera Touch
        ],
        [v, [h, Y + " Touch"]],
        [
          /coc_coc\w+\/([\w\.]+)/i
          // Coc Coc Browser
        ],
        [v, [h, "Coc Coc"]],
        [
          /dolfin\/([\w\.]+)/i
          // Dolphin
        ],
        [v, [h, "Dolphin"]],
        [
          /coast\/([\w\.]+)/i
          // Opera Coast
        ],
        [v, [h, Y + " Coast"]],
        [
          /miuibrowser\/([\w\.]+)/i
          // MIUI Browser
        ],
        [v, [h, "MIUI " + C]],
        [
          /fxios\/([-\w\.]+)/i
          // Firefox for iOS
        ],
        [v, [h, L]],
        [
          /\bqihu|(qi?ho?o?|360)browser/i
          // 360
        ],
        [[h, "360 " + C]],
        [
          /(oculus|sailfish|huawei|vivo)browser\/([\w\.]+)/i
        ],
        [[h, /(.+)/, "$1 " + C], v],
        [
          // Oculus/Sailfish/HuaweiBrowser/VivoBrowser
          /samsungbrowser\/([\w\.]+)/i
          // Samsung Internet
        ],
        [v, [h, F + " Internet"]],
        [
          /(comodo_dragon)\/([\w\.]+)/i
          // Comodo Dragon
        ],
        [[h, /_/g, " "], v],
        [
          /metasr[\/ ]?([\d\.]+)/i
          // Sogou Explorer
        ],
        [v, [h, "Sogou Explorer"]],
        [
          /(sogou)mo\w+\/([\d\.]+)/i
          // Sogou Mobile
        ],
        [[h, "Sogou Mobile"], v],
        [
          /(electron)\/([\w\.]+) safari/i,
          // Electron-based App
          /(tesla)(?: qtcarbrowser|\/(20\d\d\.[-\w\.]+))/i,
          // Tesla
          /m?(qqbrowser|2345Explorer)[\/ ]?([\w\.]+)/i
          // QQBrowser/2345 Browser
        ],
        [h, v],
        [
          /(lbbrowser)/i,
          // LieBao Browser
          /\[(linkedin)app\]/i
          // LinkedIn App for iOS & Android
        ],
        [h],
        [
          // WebView
          /((?:fban\/fbios|fb_iab\/fb4a)(?!.+fbav)|;fbav\/([\w\.]+);)/i
          // Facebook App for iOS & Android
        ],
        [[h, V], v],
        [
          /(Klarna)\/([\w\.]+)/i,
          // Klarna Shopping Browser for iOS & Android
          /(kakao(?:talk|story))[\/ ]([\w\.]+)/i,
          // Kakao App
          /(naver)\(.*?(\d+\.[\w\.]+).*\)/i,
          // Naver InApp
          /safari (line)\/([\w\.]+)/i,
          // Line App for iOS
          /\b(line)\/([\w\.]+)\/iab/i,
          // Line App for Android
          /(alipay)client\/([\w\.]+)/i,
          // Alipay
          /(chromium|instagram|snapchat)[\/ ]([-\w\.]+)/i
          // Chromium/Instagram/Snapchat
        ],
        [h, v],
        [
          /\bgsa\/([\w\.]+) .*safari\//i
          // Google Search Appliance on iOS
        ],
        [v, [h, "GSA"]],
        [
          /musical_ly(?:.+app_?version\/|_)([\w\.]+)/i
          // TikTok
        ],
        [v, [h, "TikTok"]],
        [
          /headlesschrome(?:\/([\w\.]+)| )/i
          // Chrome Headless
        ],
        [v, [h, b + " Headless"]],
        [
          / wv\).+(chrome)\/([\w\.]+)/i
          // Chrome WebView
        ],
        [[h, b + " WebView"], v],
        [
          /droid.+ version\/([\w\.]+)\b.+(?:mobile safari|safari)/i
          // Android Browser
        ],
        [v, [h, "Android " + C]],
        [
          /(chrome|omniweb|arora|[tizenoka]{5} ?browser)\/v?([\w\.]+)/i
          // Chrome/OmniWeb/Arora/Tizen/Nokia
        ],
        [h, v],
        [
          /version\/([\w\.\,]+) .*mobile\/\w+ (safari)/i
          // Mobile Safari
        ],
        [v, [h, "Mobile Safari"]],
        [
          /version\/([\w(\.|\,)]+) .*(mobile ?safari|safari)/i
          // Safari & Safari Mobile
        ],
        [v, h],
        [
          /webkit.+?(mobile ?safari|safari)(\/[\w\.]+)/i
          // Safari < 3.0
        ],
        [h, [v, de, me]],
        [
          /(webkit|khtml)\/([\w\.]+)/i
        ],
        [h, v],
        [
          // Gecko based
          /(navigator|netscape\d?)\/([-\w\.]+)/i
          // Netscape
        ],
        [[h, "Netscape"], v],
        [
          /mobile vr; rv:([\w\.]+)\).+firefox/i
          // Firefox Reality
        ],
        [v, [h, L + " Reality"]],
        [
          /ekiohf.+(flow)\/([\w\.]+)/i,
          // Flow
          /(swiftfox)/i,
          // Swiftfox
          /(icedragon|iceweasel|camino|chimera|fennec|maemo browser|minimo|conkeror|klar)[\/ ]?([\w\.\+]+)/i,
          // IceDragon/Iceweasel/Camino/Chimera/Fennec/Maemo/Minimo/Conkeror/Klar
          /(seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([-\w\.]+)$/i,
          // Firefox/SeaMonkey/K-Meleon/IceCat/IceApe/Firebird/Phoenix
          /(firefox)\/([\w\.]+)/i,
          // Other Firefox-based
          /(mozilla)\/([\w\.]+) .+rv\:.+gecko\/\d+/i,
          // Mozilla
          // Other
          /(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir|obigo|mosaic|(?:go|ice|up)[\. ]?browser)[-\/ ]?v?([\w\.]+)/i,
          // Polaris/Lynx/Dillo/iCab/Doris/Amaya/w3m/NetSurf/Sleipnir/Obigo/Mosaic/Go/ICE/UP.Browser
          /(links) \(([\w\.]+)/i,
          // Links
          /panasonic;(viera)/i
          // Panasonic Viera
        ],
        [h, v],
        [
          /(cobalt)\/([\w\.]+)/i
          // Cobalt
        ],
        [h, [v, /master.|lts./, ""]]
      ],
      cpu: [
        [
          /(?:(amd|x(?:(?:86|64)[-_])?|wow|win)64)[;\)]/i
          // AMD64 (x64)
        ],
        [[P, "amd64"]],
        [
          /(ia32(?=;))/i
          // IA32 (quicktime)
        ],
        [[P, Z]],
        [
          /((?:i[346]|x)86)[;\)]/i
          // IA32 (x86)
        ],
        [[P, "ia32"]],
        [
          /\b(aarch64|arm(v?8e?l?|_?64))\b/i
          // ARM64
        ],
        [[P, "arm64"]],
        [
          /\b(arm(?:v[67])?ht?n?[fl]p?)\b/i
          // ARMHF
        ],
        [[P, "armhf"]],
        [
          // PocketPC mistakenly identified as PowerPC
          /windows (ce|mobile); ppc;/i
        ],
        [[P, "arm"]],
        [
          /((?:ppc|powerpc)(?:64)?)(?: mac|;|\))/i
          // PowerPC
        ],
        [[P, /ower/, a, Z]],
        [
          /(sun4\w)[;\)]/i
          // SPARC
        ],
        [[P, "sparc"]],
        [
          /((?:avr32|ia64(?=;))|68k(?=\))|\barm(?=v(?:[1-7]|[5-7]1)l?|;|eabi)|(?=atmel )avr|(?:irix|mips|sparc)(?:64)?\b|pa-risc)/i
          // IA64, 68K, ARM/64, AVR/32, IRIX/64, MIPS/64, SPARC/64, PA-RISC
        ],
        [[P, Z]]
      ],
      device: [
        [
          //////////////////////////
          // MOBILES & TABLETS
          /////////////////////////
          // Samsung
          /\b(sch-i[89]0\d|shw-m380s|sm-[ptx]\w{2,4}|gt-[pn]\d{2,4}|sgh-t8[56]9|nexus 10)/i
        ],
        [m, [g, F], [c, w]],
        [
          /\b((?:s[cgp]h|gt|sm)-\w+|sc[g-]?[\d]+a?|galaxy nexus)/i,
          /samsung[- ]([-\w]+)/i,
          /sec-(sgh\w+)/i
        ],
        [m, [g, F], [c, S]],
        [
          // Apple
          /(?:\/|\()(ip(?:hone|od)[\w, ]*)(?:\/|;)/i
          // iPod/iPhone
        ],
        [m, [g, N], [c, S]],
        [
          /\((ipad);[-\w\),; ]+apple/i,
          // iPad
          /applecoremedia\/[\w\.]+ \((ipad)/i,
          /\b(ipad)\d\d?,\d\d?[;\]].+ios/i
        ],
        [m, [g, N], [c, w]],
        [
          /(macintosh);/i
        ],
        [m, [g, N]],
        [
          // Sharp
          /\b(sh-?[altvz]?\d\d[a-ekm]?)/i
        ],
        [m, [g, U], [c, S]],
        [
          // Huawei
          /\b((?:ag[rs][23]?|bah2?|sht?|btv)-a?[lw]\d{2})\b(?!.+d\/s)/i
        ],
        [m, [g, T], [c, w]],
        [
          /(?:huawei|honor)([-\w ]+)[;\)]/i,
          /\b(nexus 6p|\w{2,4}e?-[atu]?[ln][\dx][012359c][adn]?)\b(?!.+d\/s)/i
        ],
        [m, [g, T], [c, S]],
        [
          // Xiaomi
          /\b(poco[\w ]+|m2\d{3}j\d\d[a-z]{2})(?: bui|\))/i,
          // Xiaomi POCO
          /\b; (\w+) build\/hm\1/i,
          // Xiaomi Hongmi 'numeric' models
          /\b(hm[-_ ]?note?[_ ]?(?:\d\w)?) bui/i,
          // Xiaomi Hongmi
          /\b(redmi[\-_ ]?(?:note|k)?[\w_ ]+)(?: bui|\))/i,
          // Xiaomi Redmi
          /oid[^\)]+; (m?[12][0-389][01]\w{3,6}[c-y])( bui|; wv|\))/i,
          // Xiaomi Redmi 'numeric' models
          /\b(mi[-_ ]?(?:a\d|one|one[_ ]plus|note lte|max|cc)?[_ ]?(?:\d?\w?)[_ ]?(?:plus|se|lite)?)(?: bui|\))/i
          // Xiaomi Mi
        ],
        [[m, /_/g, " "], [g, J], [c, S]],
        [
          /oid[^\)]+; (2\d{4}(283|rpbf)[cgl])( bui|\))/i,
          // Redmi Pad
          /\b(mi[-_ ]?(?:pad)(?:[\w_ ]+))(?: bui|\))/i
          // Mi Pad tablets
        ],
        [[m, /_/g, " "], [g, J], [c, w]],
        [
          // OPPO
          /; (\w+) bui.+ oppo/i,
          /\b(cph[12]\d{3}|p(?:af|c[al]|d\w|e[ar])[mt]\d0|x9007|a101op)\b/i
        ],
        [m, [g, "OPPO"], [c, S]],
        [
          // Vivo
          /vivo (\w+)(?: bui|\))/i,
          /\b(v[12]\d{3}\w?[at])(?: bui|;)/i
        ],
        [m, [g, "Vivo"], [c, S]],
        [
          // Realme
          /\b(rmx[1-3]\d{3})(?: bui|;|\))/i
        ],
        [m, [g, "Realme"], [c, S]],
        [
          // Motorola
          /\b(milestone|droid(?:[2-4x]| (?:bionic|x2|pro|razr))?:?( 4g)?)\b[\w ]+build\//i,
          /\bmot(?:orola)?[- ](\w*)/i,
          /((?:moto[\w\(\) ]+|xt\d{3,4}|nexus 6)(?= bui|\)))/i
        ],
        [m, [g, R], [c, S]],
        [
          /\b(mz60\d|xoom[2 ]{0,2}) build\//i
        ],
        [m, [g, R], [c, w]],
        [
          // LG
          /((?=lg)?[vl]k\-?\d{3}) bui| 3\.[-\w; ]{10}lg?-([06cv9]{3,4})/i
        ],
        [m, [g, O], [c, w]],
        [
          /(lm(?:-?f100[nv]?|-[\w\.]+)(?= bui|\))|nexus [45])/i,
          /\blg[-e;\/ ]+((?!browser|netcast|android tv)\w+)/i,
          /\blg-?([\d\w]+) bui/i
        ],
        [m, [g, O], [c, S]],
        [
          // Lenovo
          /(ideatab[-\w ]+)/i,
          /lenovo ?(s[56]000[-\w]+|tab(?:[\w ]+)|yt[-\d\w]{6}|tb[-\d\w]{6})/i
        ],
        [m, [g, "Lenovo"], [c, w]],
        [
          // Nokia
          /(?:maemo|nokia).*(n900|lumia \d+)/i,
          /nokia[-_ ]?([-\w\.]*)/i
        ],
        [[m, /_/g, " "], [g, "Nokia"], [c, S]],
        [
          // Google
          /(pixel c)\b/i
          // Google Pixel C
        ],
        [m, [g, B], [c, w]],
        [
          /droid.+; (pixel[\daxl ]{0,6})(?: bui|\))/i
          // Google Pixel
        ],
        [m, [g, B], [c, S]],
        [
          // Sony
          /droid.+ (a?\d[0-2]{2}so|[c-g]\d{4}|so[-gl]\w+|xq-a\w[4-7][12])(?= bui|\).+chrome\/(?![1-6]{0,1}\d\.))/i
        ],
        [m, [g, Q], [c, S]],
        [
          /sony tablet [ps]/i,
          /\b(?:sony)?sgp\w+(?: bui|\))/i
        ],
        [[m, "Xperia Tablet"], [g, Q], [c, w]],
        [
          // OnePlus
          / (kb2005|in20[12]5|be20[12][59])\b/i,
          /(?:one)?(?:plus)? (a\d0\d\d)(?: b|\))/i
        ],
        [m, [g, "OnePlus"], [c, S]],
        [
          // Amazon
          /(alexa)webm/i,
          /(kf[a-z]{2}wi|aeo[c-r]{2})( bui|\))/i,
          // Kindle Fire without Silk / Echo Show
          /(kf[a-z]+)( bui|\)).+silk\//i
          // Kindle Fire HD
        ],
        [m, [g, j], [c, w]],
        [
          /((?:sd|kf)[0349hijorstuw]+)( bui|\)).+silk\//i
          // Fire Phone
        ],
        [[m, /(.+)/g, "Fire Phone $1"], [g, j], [c, S]],
        [
          // BlackBerry
          /(playbook);[-\w\),; ]+(rim)/i
          // BlackBerry PlayBook
        ],
        [m, g, [c, w]],
        [
          /\b((?:bb[a-f]|st[hv])100-\d)/i,
          /\(bb10; (\w+)/i
          // BlackBerry 10
        ],
        [m, [g, D], [c, S]],
        [
          // Asus
          /(?:\b|asus_)(transfo[prime ]{4,10} \w+|eeepc|slider \w+|nexus 7|padfone|p00[cj])/i
        ],
        [m, [g, M], [c, w]],
        [
          / (z[bes]6[027][012][km][ls]|zenfone \d\w?)\b/i
        ],
        [m, [g, M], [c, S]],
        [
          // HTC
          /(nexus 9)/i
          // HTC Nexus 9
        ],
        [m, [g, "HTC"], [c, w]],
        [
          /(htc)[-;_ ]{1,2}([\w ]+(?=\)| bui)|\w+)/i,
          // HTC
          // ZTE
          /(zte)[- ]([\w ]+?)(?: bui|\/|\))/i,
          /(alcatel|geeksphone|nexian|panasonic(?!(?:;|\.))|sony(?!-bra))[-_ ]?([-\w]*)/i
          // Alcatel/GeeksPhone/Nexian/Panasonic/Sony
        ],
        [g, [m, /_/g, " "], [c, S]],
        [
          // Acer
          /droid.+; ([ab][1-7]-?[0178a]\d\d?)/i
        ],
        [m, [g, "Acer"], [c, w]],
        [
          // Meizu
          /droid.+; (m[1-5] note) bui/i,
          /\bmz-([-\w]{2,})/i
        ],
        [m, [g, "Meizu"], [c, S]],
        [
          // Ulefone
          /; ((?:power )?armor(?:[\w ]{0,8}))(?: bui|\))/i
        ],
        [m, [g, "Ulefone"], [c, S]],
        [
          // MIXED
          /(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron|infinix|tecno)[-_ ]?([-\w]*)/i,
          // BlackBerry/BenQ/Palm/Sony-Ericsson/Acer/Asus/Dell/Meizu/Motorola/Polytron
          /(hp) ([\w ]+\w)/i,
          // HP iPAQ
          /(asus)-?(\w+)/i,
          // Asus
          /(microsoft); (lumia[\w ]+)/i,
          // Microsoft Lumia
          /(lenovo)[-_ ]?([-\w]+)/i,
          // Lenovo
          /(jolla)/i,
          // Jolla
          /(oppo) ?([\w ]+) bui/i
          // OPPO
        ],
        [g, m, [c, S]],
        [
          /(kobo)\s(ereader|touch)/i,
          // Kobo
          /(archos) (gamepad2?)/i,
          // Archos
          /(hp).+(touchpad(?!.+tablet)|tablet)/i,
          // HP TouchPad
          /(kindle)\/([\w\.]+)/i,
          // Kindle
          /(nook)[\w ]+build\/(\w+)/i,
          // Nook
          /(dell) (strea[kpr\d ]*[\dko])/i,
          // Dell Streak
          /(le[- ]+pan)[- ]+(\w{1,9}) bui/i,
          // Le Pan Tablets
          /(trinity)[- ]*(t\d{3}) bui/i,
          // Trinity Tablets
          /(gigaset)[- ]+(q\w{1,9}) bui/i,
          // Gigaset Tablets
          /(vodafone) ([\w ]+)(?:\)| bui)/i
          // Vodafone
        ],
        [g, m, [c, w]],
        [
          /(surface duo)/i
          // Surface Duo
        ],
        [m, [g, I], [c, w]],
        [
          /droid [\d\.]+; (fp\du?)(?: b|\))/i
          // Fairphone
        ],
        [m, [g, "Fairphone"], [c, S]],
        [
          /(u304aa)/i
          // AT&T
        ],
        [m, [g, "AT&T"], [c, S]],
        [
          /\bsie-(\w*)/i
          // Siemens
        ],
        [m, [g, "Siemens"], [c, S]],
        [
          /\b(rct\w+) b/i
          // RCA Tablets
        ],
        [m, [g, "RCA"], [c, w]],
        [
          /\b(venue[\d ]{2,7}) b/i
          // Dell Venue Tablets
        ],
        [m, [g, "Dell"], [c, w]],
        [
          /\b(q(?:mv|ta)\w+) b/i
          // Verizon Tablet
        ],
        [m, [g, "Verizon"], [c, w]],
        [
          /\b(?:barnes[& ]+noble |bn[rt])([\w\+ ]*) b/i
          // Barnes & Noble Tablet
        ],
        [m, [g, "Barnes & Noble"], [c, w]],
        [
          /\b(tm\d{3}\w+) b/i
        ],
        [m, [g, "NuVision"], [c, w]],
        [
          /\b(k88) b/i
          // ZTE K Series Tablet
        ],
        [m, [g, "ZTE"], [c, w]],
        [
          /\b(nx\d{3}j) b/i
          // ZTE Nubia
        ],
        [m, [g, "ZTE"], [c, S]],
        [
          /\b(gen\d{3}) b.+49h/i
          // Swiss GEN Mobile
        ],
        [m, [g, "Swiss"], [c, S]],
        [
          /\b(zur\d{3}) b/i
          // Swiss ZUR Tablet
        ],
        [m, [g, "Swiss"], [c, w]],
        [
          /\b((zeki)?tb.*\b) b/i
          // Zeki Tablets
        ],
        [m, [g, "Zeki"], [c, w]],
        [
          /\b([yr]\d{2}) b/i,
          /\b(dragon[- ]+touch |dt)(\w{5}) b/i
          // Dragon Touch Tablet
        ],
        [[g, "Dragon Touch"], m, [c, w]],
        [
          /\b(ns-?\w{0,9}) b/i
          // Insignia Tablets
        ],
        [m, [g, "Insignia"], [c, w]],
        [
          /\b((nxa|next)-?\w{0,9}) b/i
          // NextBook Tablets
        ],
        [m, [g, "NextBook"], [c, w]],
        [
          /\b(xtreme\_)?(v(1[045]|2[015]|[3469]0|7[05])) b/i
          // Voice Xtreme Phones
        ],
        [[g, "Voice"], m, [c, S]],
        [
          /\b(lvtel\-)?(v1[12]) b/i
          // LvTel Phones
        ],
        [[g, "LvTel"], m, [c, S]],
        [
          /\b(ph-1) /i
          // Essential PH-1
        ],
        [m, [g, "Essential"], [c, S]],
        [
          /\b(v(100md|700na|7011|917g).*\b) b/i
          // Envizen Tablets
        ],
        [m, [g, "Envizen"], [c, w]],
        [
          /\b(trio[-\w\. ]+) b/i
          // MachSpeed Tablets
        ],
        [m, [g, "MachSpeed"], [c, w]],
        [
          /\btu_(1491) b/i
          // Rotor Tablets
        ],
        [m, [g, "Rotor"], [c, w]],
        [
          /(shield[\w ]+) b/i
          // Nvidia Shield Tablets
        ],
        [m, [g, "Nvidia"], [c, w]],
        [
          /(sprint) (\w+)/i
          // Sprint Phones
        ],
        [g, m, [c, S]],
        [
          /(kin\.[onetw]{3})/i
          // Microsoft Kin
        ],
        [[m, /\./g, " "], [g, I], [c, S]],
        [
          /droid.+; (cc6666?|et5[16]|mc[239][23]x?|vc8[03]x?)\)/i
          // Zebra
        ],
        [m, [g, ee], [c, w]],
        [
          /droid.+; (ec30|ps20|tc[2-8]\d[kx])\)/i
        ],
        [m, [g, ee], [c, S]],
        [
          ///////////////////
          // SMARTTVS
          ///////////////////
          /smart-tv.+(samsung)/i
          // Samsung
        ],
        [g, [c, x]],
        [
          /hbbtv.+maple;(\d+)/i
        ],
        [[m, /^/, "SmartTV"], [g, F], [c, x]],
        [
          /(nux; netcast.+smarttv|lg (netcast\.tv-201\d|android tv))/i
          // LG SmartTV
        ],
        [[g, O], [c, x]],
        [
          /(apple) ?tv/i
          // Apple TV
        ],
        [g, [m, N + " TV"], [c, x]],
        [
          /crkey/i
          // Google Chromecast
        ],
        [[m, b + "cast"], [g, B], [c, x]],
        [
          /droid.+aft(\w+)( bui|\))/i
          // Fire TV
        ],
        [m, [g, j], [c, x]],
        [
          /\(dtv[\);].+(aquos)/i,
          /(aquos-tv[\w ]+)\)/i
          // Sharp
        ],
        [m, [g, U], [c, x]],
        [
          /(bravia[\w ]+)( bui|\))/i
          // Sony
        ],
        [m, [g, Q], [c, x]],
        [
          /(mitv-\w{5}) bui/i
          // Xiaomi
        ],
        [m, [g, J], [c, x]],
        [
          /Hbbtv.*(technisat) (.*);/i
          // TechniSAT
        ],
        [g, m, [c, x]],
        [
          /\b(roku)[\dx]*[\)\/]((?:dvp-)?[\d\.]*)/i,
          // Roku
          /hbbtv\/\d+\.\d+\.\d+ +\([\w\+ ]*; *([\w\d][^;]*);([^;]*)/i
          // HbbTV devices
        ],
        [[g, ie], [m, ie], [c, x]],
        [
          /\b(android tv|smart[- ]?tv|opera tv|tv; rv:)\b/i
          // SmartTV from Unidentified Vendors
        ],
        [[c, x]],
        [
          ///////////////////
          // CONSOLES
          ///////////////////
          /(ouya)/i,
          // Ouya
          /(nintendo) ([wids3utch]+)/i
          // Nintendo
        ],
        [g, m, [c, f]],
        [
          /droid.+; (shield) bui/i
          // Nvidia
        ],
        [m, [g, "Nvidia"], [c, f]],
        [
          /(playstation [345portablevi]+)/i
          // Playstation
        ],
        [m, [g, Q], [c, f]],
        [
          /\b(xbox(?: one)?(?!; xbox))[\); ]/i
          // Microsoft Xbox
        ],
        [m, [g, I], [c, f]],
        [
          ///////////////////
          // WEARABLES
          ///////////////////
          /((pebble))app/i
          // Pebble
        ],
        [g, m, [c, k]],
        [
          /(watch)(?: ?os[,\/]|\d,\d\/)[\d\.]+/i
          // Apple Watch
        ],
        [m, [g, N], [c, k]],
        [
          /droid.+; (glass) \d/i
          // Google Glass
        ],
        [m, [g, B], [c, k]],
        [
          /droid.+; (wt63?0{2,3})\)/i
        ],
        [m, [g, ee], [c, k]],
        [
          /(quest( 2| pro)?)/i
          // Oculus Quest
        ],
        [m, [g, V], [c, k]],
        [
          ///////////////////
          // EMBEDDED
          ///////////////////
          /(tesla)(?: qtcarbrowser|\/[-\w\.]+)/i
          // Tesla
        ],
        [g, [c, A]],
        [
          /(aeobc)\b/i
          // Echo Dot
        ],
        [m, [g, j], [c, A]],
        [
          ////////////////////
          // MIXED (GENERIC)
          ///////////////////
          /droid .+?; ([^;]+?)(?: bui|; wv\)|\) applew).+? mobile safari/i
          // Android Phones from Unidentified Vendors
        ],
        [m, [c, S]],
        [
          /droid .+?; ([^;]+?)(?: bui|\) applew).+?(?! mobile) safari/i
          // Android Tablets from Unidentified Vendors
        ],
        [m, [c, w]],
        [
          /\b((tablet|tab)[;\/]|focus\/\d(?!.+mobile))/i
          // Unidentifiable Tablet
        ],
        [[c, w]],
        [
          /(phone|mobile(?:[;\/]| [ \w\/\.]*safari)|pda(?=.+windows ce))/i
          // Unidentifiable Mobile
        ],
        [[c, S]],
        [
          /(android[-\w\. ]{0,9});.+buil/i
          // Generic Android Device
        ],
        [m, [g, "Generic"]]
      ],
      engine: [
        [
          /windows.+ edge\/([\w\.]+)/i
          // EdgeHTML
        ],
        [v, [h, p + "HTML"]],
        [
          /webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i
          // Blink
        ],
        [v, [h, "Blink"]],
        [
          /(presto)\/([\w\.]+)/i,
          // Presto
          /(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna)\/([\w\.]+)/i,
          // WebKit/Trident/NetFront/NetSurf/Amaya/Lynx/w3m/Goanna
          /ekioh(flow)\/([\w\.]+)/i,
          // Flow
          /(khtml|tasman|links)[\/ ]\(?([\w\.]+)/i,
          // KHTML/Tasman/Links
          /(icab)[\/ ]([23]\.[\d\.]+)/i,
          // iCab
          /\b(libweb)/i
        ],
        [h, v],
        [
          /rv\:([\w\.]{1,9})\b.+(gecko)/i
          // Gecko
        ],
        [v, h]
      ],
      os: [
        [
          // Windows
          /microsoft (windows) (vista|xp)/i
          // Windows (iTunes)
        ],
        [h, v],
        [
          /(windows (?:phone(?: os)?|mobile))[\/ ]?([\d\.\w ]*)/i
          // Windows Phone
        ],
        [h, [v, de, ce]],
        [
          /windows nt 6\.2; (arm)/i,
          // Windows RT
          /windows[\/ ]?([ntce\d\. ]+\w)(?!.+xbox)/i,
          /(?:win(?=3|9|n)|win 9x )([nt\d\.]+)/i
        ],
        [[v, de, ce], [h, "Windows"]],
        [
          // iOS/macOS
          /ip[honead]{2,4}\b(?:.*os ([\w]+) like mac|; opera)/i,
          // iOS
          /(?:ios;fbsv\/|iphone.+ios[\/ ])([\d\.]+)/i,
          /cfnetwork\/.+darwin/i
        ],
        [[v, /_/g, "."], [h, "iOS"]],
        [
          /(mac os x) ?([\w\. ]*)/i,
          /(macintosh|mac_powerpc\b)(?!.+haiku)/i
          // Mac OS
        ],
        [[h, W], [v, /_/g, "."]],
        [
          // Mobile OSes
          /droid ([\w\.]+)\b.+(android[- ]x86|harmonyos)/i
          // Android-x86/HarmonyOS
        ],
        [v, h],
        [
          // Android/WebOS/QNX/Bada/RIM/Maemo/MeeGo/Sailfish OS
          /(android|webos|qnx|bada|rim tablet os|maemo|meego|sailfish)[-\/ ]?([\w\.]*)/i,
          /(blackberry)\w*\/([\w\.]*)/i,
          // Blackberry
          /(tizen|kaios)[\/ ]([\w\.]+)/i,
          // Tizen/KaiOS
          /\((series40);/i
          // Series 40
        ],
        [h, v],
        [
          /\(bb(10);/i
          // BlackBerry 10
        ],
        [v, [h, D]],
        [
          /(?:symbian ?os|symbos|s60(?=;)|series60)[-\/ ]?([\w\.]*)/i
          // Symbian
        ],
        [v, [h, "Symbian"]],
        [
          /mozilla\/[\d\.]+ \((?:mobile|tablet|tv|mobile; [\w ]+); rv:.+ gecko\/([\w\.]+)/i
          // Firefox OS
        ],
        [v, [h, L + " OS"]],
        [
          /web0s;.+rt(tv)/i,
          /\b(?:hp)?wos(?:browser)?\/([\w\.]+)/i
          // WebOS
        ],
        [v, [h, "webOS"]],
        [
          /watch(?: ?os[,\/]|\d,\d\/)([\d\.]+)/i
          // watchOS
        ],
        [v, [h, "watchOS"]],
        [
          // Google Chromecast
          /crkey\/([\d\.]+)/i
          // Google Chromecast
        ],
        [v, [h, b + "cast"]],
        [
          /(cros) [\w]+(?:\)| ([\w\.]+)\b)/i
          // Chromium OS
        ],
        [[h, G], v],
        [
          // Smart TVs
          /panasonic;(viera)/i,
          // Panasonic Viera
          /(netrange)mmh/i,
          // Netrange
          /(nettv)\/(\d+\.[\w\.]+)/i,
          // NetTV
          // Console
          /(nintendo|playstation) ([wids345portablevuch]+)/i,
          // Nintendo/Playstation
          /(xbox); +xbox ([^\);]+)/i,
          // Microsoft Xbox (360, One, X, S, Series X, Series S)
          // Other
          /\b(joli|palm)\b ?(?:os)?\/?([\w\.]*)/i,
          // Joli/Palm
          /(mint)[\/\(\) ]?(\w*)/i,
          // Mint
          /(mageia|vectorlinux)[; ]/i,
          // Mageia/VectorLinux
          /([kxln]?ubuntu|debian|suse|opensuse|gentoo|arch(?= linux)|slackware|fedora|mandriva|centos|pclinuxos|red ?hat|zenwalk|linpus|raspbian|plan 9|minix|risc os|contiki|deepin|manjaro|elementary os|sabayon|linspire)(?: gnu\/linux)?(?: enterprise)?(?:[- ]linux)?(?:-gnu)?[-\/ ]?(?!chrom|package)([-\w\.]*)/i,
          // Ubuntu/Debian/SUSE/Gentoo/Arch/Slackware/Fedora/Mandriva/CentOS/PCLinuxOS/RedHat/Zenwalk/Linpus/Raspbian/Plan9/Minix/RISCOS/Contiki/Deepin/Manjaro/elementary/Sabayon/Linspire
          /(hurd|linux) ?([\w\.]*)/i,
          // Hurd/Linux
          /(gnu) ?([\w\.]*)/i,
          // GNU
          /\b([-frentopcghs]{0,5}bsd|dragonfly)[\/ ]?(?!amd|[ix346]{1,2}86)([\w\.]*)/i,
          // FreeBSD/NetBSD/OpenBSD/PC-BSD/GhostBSD/DragonFly
          /(haiku) (\w+)/i
          // Haiku
        ],
        [h, v],
        [
          /(sunos) ?([\w\.\d]*)/i
          // Solaris
        ],
        [[h, "Solaris"], v],
        [
          /((?:open)?solaris)[-\/ ]?([\w\.]*)/i,
          // Solaris
          /(aix) ((\d)(?=\.|\)| )[\w\.])*/i,
          // AIX
          /\b(beos|os\/2|amigaos|morphos|openvms|fuchsia|hp-ux|serenityos)/i,
          // BeOS/OS2/AmigaOS/MorphOS/OpenVMS/Fuchsia/HP-UX/SerenityOS
          /(unix) ?([\w\.]*)/i
          // UNIX
        ],
        [h, v]
      ]
    }, xe = function(he, ve) {
      if (typeof he === d && (ve = he, he = i), !(this instanceof xe))
        return new xe(he, ve).getResult();
      var ye = typeof n !== l && n.navigator ? n.navigator : i, be = he || (ye && ye.userAgent ? ye.userAgent : a), ke = ye && ye.userAgentData ? ye.userAgentData : i, we = ve ? ae(pe, ve) : pe, Le = ye && ye.userAgent == be;
      return this.getBrowser = function() {
        var Me = {};
        return Me[h] = i, Me[v] = i, re.call(Me, be, we.browser), Me[u] = ne(Me[v]), Le && ye && ye.brave && typeof ye.brave.isBrave == s && (Me[h] = "Brave"), Me;
      }, this.getCPU = function() {
        var Me = {};
        return Me[P] = i, re.call(Me, be, we.cpu), Me;
      }, this.getDevice = function() {
        var Me = {};
        return Me[g] = i, Me[m] = i, Me[c] = i, re.call(Me, be, we.device), Le && !Me[c] && ke && ke.mobile && (Me[c] = S), Le && Me[m] == "Macintosh" && ye && typeof ye.standalone !== l && ye.maxTouchPoints && ye.maxTouchPoints > 2 && (Me[m] = "iPad", Me[c] = w), Me;
      }, this.getEngine = function() {
        var Me = {};
        return Me[h] = i, Me[v] = i, re.call(Me, be, we.engine), Me;
      }, this.getOS = function() {
        var Me = {};
        return Me[h] = i, Me[v] = i, re.call(Me, be, we.os), Le && !Me[h] && ke && ke.platform != "Unknown" && (Me[h] = ke.platform.replace(/chrome os/i, G).replace(/macos/i, W)), Me;
      }, this.getResult = function() {
        return {
          ua: this.getUA(),
          browser: this.getBrowser(),
          engine: this.getEngine(),
          os: this.getOS(),
          device: this.getDevice(),
          cpu: this.getCPU()
        };
      }, this.getUA = function() {
        return be;
      }, this.setUA = function(Me) {
        return be = typeof Me === y && Me.length > $ ? ie(Me, $) : Me, this;
      }, this.setUA(be), this;
    };
    xe.VERSION = o, xe.BROWSER = z([h, v, u]), xe.CPU = z([P]), xe.DEVICE = z([m, g, c, f, S, x, w, k, A]), xe.ENGINE = xe.OS = z([h, v]), e.exports && (t = e.exports = xe), t.UAParser = xe;
    var le = typeof n !== l && (n.jQuery || n.Zepto);
    if (le && !le.ua) {
      var se = new xe();
      le.ua = se.getResult(), le.ua.get = function() {
        return se.getUA();
      }, le.ua.set = function(he) {
        se.setUA(he);
        var ve = se.getResult();
        for (var ye in ve)
          le.ua[ye] = ve[ye];
      };
    }
  })(typeof window == "object" ? window : rn);
})(jp, jp.exports);
var hP = jp.exports;
const pP = /* @__PURE__ */ en(hP), Cl = () => {
  const e = new pP(), t = e.getOS(), n = ge("");
  n.value = t.name || "Unknown";
  const i = n.value.toLowerCase() == "Windows".toLowerCase(), o = n.value.toLowerCase() == "iOS".toLowerCase(), a = n.value.toLowerCase() == "Mac OS".toLowerCase(), r = ge(""), s = ge(""), l = e.getBrowser();
  r.value = l.name || "Unknown", s.value = l.version || "Unknown";
  const d = e.getDevice(), y = ge(!1);
  (d.type === "mobile" || d.type === "tablet") && (y.value = !0);
  const u = e.getEngine(), m = ge(""), h = ge("");
  return m.value = u.name || "Unknown", h.value = u.version || "Unknown", {
    osName: n,
    osIsWindows: i,
    osIsIos: o,
    osIsMacOs: a,
    browserName: r,
    browserVersion: s,
    isTouchDevice: y,
    engineName: m,
    engineVersion: h
  };
}, Qx = (e) => {
  if (e) {
    const n = [...e].sort((i, o) => i.label.localeCompare(o.label));
    return n && n.length > 3 ? n.splice(0, 3) : n;
  }
  return [];
}, Ts = () => {
  let e = ge("lg"), t = ge(1200);
  if (Ue) {
    const n = ge(window.innerWidth), i = () => n.value = window.innerWidth;
    it(
      () => window.addEventListener("resize", i, { passive: !0 })
    ), sn(() => window.removeEventListener("resize", i)), e = Te(() => n.value < 550 ? "xs" : n.value >= 550 && n.value < 1200 ? "md" : n.value >= 1200 ? "lg" : null), t = Te(() => n.value);
  }
  return { width: t, type: e };
};
var Zt = /* @__PURE__ */ ((e) => (e.White = "white", e.Black = "black", e.Grey = "grey", e.GreyBlue000 = "grey-blue-000", e.Transparent = "transparent", e))(Zt || {}), ew = /* @__PURE__ */ ((e) => (e.White = "white", e.LeafGreen = "leaf-green", e.SkyBlue = "sky-blue", e.OceanBlue = "ocean-blue", e.SustainedGreen = "sustained-green", e.ProgPurple = "prog-purple", e.Amber = "amber", e.Pink = "pink", e.Petrol45 = "petrol-45", e.Petrol55 = "petrol-55", e.GreyBlue000 = "grey-blue-000", e.GreyBlue001 = "grey-blue-001", e.GreyBlue008 = "grey-blue-008", e.GreyBlue009 = "grey-blue-009", e.Transparent = "transparent", e))(ew || {}), Et = /* @__PURE__ */ ((e) => (e.Figma = "figma", e.AdobeXd = "adobe", e.Zeplin = "zeplin", e.Abstract = "abstract", e.GeneralWebPage = "webpage", e.Image = "image", e))(Et || {});
const jn = "https://www.figma.com/file/88vdoSFiEE2TY03URtO9CQ/", Mn = "https://www.figma.com/file/GaZ7XtioQfpWsVy00j3CEZ/", fP = [
  {
    componentName: "HeaderAvatar",
    designName: "Avatar",
    type: Et.Figma,
    url: jn + "DWS--Styleguide-%2F-UI-Kit?m=dev"
  },
  {
    componentName: "BaseButtonV2",
    designName: "Buttons",
    type: Et.Figma,
    url: jn + "?node-id=34046%3A22361"
  },
  {
    componentName: "BaseCheckbox",
    designName: "Checkbox",
    type: Et.Figma,
    url: jn + "?node-id=34821%3A35292"
  },
  {
    componentName: "BaseDropDown",
    designName: "DropDown",
    type: Et.Figma,
    url: jn + "?node-id=34747%3A38407"
  },
  {
    componentName: "TeaserBoxesStack",
    designName: "TeaserBoxes (1-2-3)",
    type: Et.Figma,
    url: jn + "?node-id=34057%3A67982"
  },
  {
    componentName: "TeaserHero",
    designName: "Hero Teaser",
    type: Et.Figma,
    url: jn + "?node-id=34145-21504"
  },
  {
    componentName: "TeaserHeroItem",
    designName: "Hero Teaser",
    type: Et.Figma,
    url: jn + "?node-id=34145-21504"
  },
  {
    componentName: "ArchivePage",
    designName: "Archive Page",
    type: Et.Figma,
    url: Mn + "?node-id=47172-79261"
  },
  {
    componentName: "BaseDisclaimer",
    designName: "Footer",
    type: Et.Figma,
    url: jn + "?node-id=34047-22382"
  },
  {
    componentName: "FundFinder",
    designName: "Fund Finder",
    type: Et.Figma,
    url: Mn + "?node-id=36834-79487"
  },
  {
    componentName: "SearchResultPage",
    designName: "Search Result Page",
    type: Et.Figma,
    url: Mn + "?node-id=45194-33012"
  },
  {
    componentName: "PropertyGalleryPage",
    designName: "Property Gallery Page",
    type: Et.Figma,
    url: Mn + "?node-id=42063-45435"
  },
  {
    componentName: "FeaturedPropertyTeaser",
    designName: "Featured Property Teaser",
    type: Et.Figma,
    url: jn + "?node-id=42558-35177"
  },
  {
    componentName: "MaintenancePage",
    designName: "Maintenance Page",
    type: Et.Figma,
    url: Mn + "?node-id=46567-120415"
  },
  {
    componentName: "BaseSelectButtonSwitch",
    designName: "Switch",
    type: Et.Figma,
    url: jn + "?node-id=34732-33994"
  },
  {
    componentName: "BaseSelectButtonTab",
    designName: "Tab",
    type: Et.Figma,
    url: jn + "?node-id=34732-33915"
  },
  {
    componentName: "ErrorPage",
    designName: "Error Page",
    type: Et.Figma,
    url: Mn + "?node-id=46567-120415"
  },
  {
    componentName: "DocumentViewer",
    designName: "Document Viewer",
    type: Et.Figma,
    url: Mn + "?node-id=48766-155683"
  },
  {
    componentName: "MediaReleases",
    designName: "Media Releases",
    type: Et.Figma,
    url: Mn + "?node-id=47129%3A61433"
  },
  {
    componentName: "LiteratureLibrary",
    designName: "Literature Library",
    type: Et.Figma,
    url: Mn + "?node-id=46078-95830"
  },
  {
    componentName: "FaqPage",
    designName: "FAQ",
    type: Et.Figma,
    url: Mn + "?node-id=46842-91158"
  },
  {
    componentName: "FactsLists",
    designName: "Facts Lists",
    type: Et.Figma,
    url: jn + "?node-id=48112-81486"
  },
  {
    componentName: "Glossary",
    designName: "Glossary",
    type: Et.Figma,
    url: Mn + "?node-id=46591%3A9523"
  },
  {
    componentName: "MediaReleasesDetailsPage",
    designName: "Media Releases Details Page",
    type: Et.Figma,
    url: Mn + "?node-id=50318-209243"
  },
  {
    componentName: "Calendar",
    designName: "Calendar",
    type: Et.Figma,
    url: Mn + "?node-id=47878%3A61789"
  },
  {
    componentName: "PersonCardBlock",
    designName: "Person Card Block",
    type: Et.Figma,
    url: Mn + "?node-id=52198%3A146569"
  },
  {
    componentName: "ArticleHeader",
    designName: "Article Header",
    type: Et.Figma,
    url: Mn + "?node-id=52198%3A146569"
  },
  {
    componentName: "ProductTeaserWithImage",
    designName: "Product Teaser With Image",
    type: Et.Figma,
    url: Mn + "?node-id=52187%3A68588"
  },
  {
    componentName: "ContentBoxWithImage",
    designName: "Content Box with Image",
    type: Et.Figma,
    url: Mn + "?node-id=52187%3A60860"
  },
  {
    componentName: "ImageGalleryTeaser",
    designName: "Image Gallery Teaser",
    type: Et.Figma,
    url: Mn + "?node-id=52187%3A21588"
  },
  {
    componentName: "ContentSlider",
    designName: "Content Slider",
    type: Et.Figma,
    url: Mn + "?node-id=52273-2003"
  },
  {
    componentName: "Fonts",
    designName: "Typography",
    type: Et.Figma,
    url: jn + "?node-id=34047-22373"
  },
  {
    componentName: "Footer",
    designName: "Footer",
    type: Et.Figma,
    url: jn + "?node-id=34047-22382"
  },
  {
    componentName: "RiskDisclaimer",
    designName: "Fixed site notification",
    type: Et.Figma,
    url: jn + "?node-id=34631-32405"
  },
  {
    componentName: "CrociCompanyOverviewPage",
    designName: "CROCI",
    type: Et.Figma,
    url: Mn + "?node-id=55684-158156"
  },
  {
    componentName: "CrociCompanyDetailPage",
    designName: "CROCI",
    type: Et.Figma,
    url: Mn + "?node-id=56105-8172"
  },
  {
    componentName: "InputText",
    designName: "Input Text",
    type: Et.Figma,
    url: jn + "?node-id=52170-61863"
  },
  {
    componentName: "BaseRangeSlider",
    designName: "Base Range Slider",
    type: Et.Figma,
    url: jn + "?node-id=58258-18978"
  },
  {
    componentName: "InvestmentCalculator",
    designName: "Investment Calculator",
    type: Et.Figma,
    url: jn + "node-id=238-15624"
  }
], _v = [
  // these are just random examples for testing
  {
    componentName: "BaseButtonV2",
    designName: "Buttons",
    type: Et.GeneralWebPage,
    url: "https://primevue.org/button/"
  },
  {
    componentName: "BaseCheckBox",
    designName: "Checkbox",
    type: Et.Image,
    url: "https://s3-alpha.figma.com/hub/file/2473463666/2d3f4289-ae4b-4687-90c7-47f9bf4ff9a0-cover.png"
  }
], uBe = async (e, t) => {
  let n = { design: { type: "", url: "" } }, i = "";
  switch (t) {
    case Et.Figma:
      i = fP?.find(
        (o) => o.componentName === e
      )?.url, i && (n = {
        type: Et.Figma,
        url: i
      });
      break;
    case Et.AdobeXd:
    case Et.Abstract:
    case Et.Zeplin:
      console.error("designType not implemented!");
      break;
    case Et.GeneralWebPage:
      i = _v?.find(
        (o) => o.componentName === e
      )?.url, i && (n = {
        type: "www",
        url: i
      });
      break;
    case Et.Image:
      i = _v?.find(
        (o) => o.componentName === e
      )?.url, i && i.length > 10 && await mP(i) && (n = {
        type: "image",
        url: i
      });
      break;
    default:
      console.error("Non existent designType!");
  }
  return n;
};
async function mP(e) {
  return await fetch(e, { method: "HEAD" }).then((t) => t.ok ? t?.headers?.get("Content-Type")?.startsWith("image") : (console.error("couldnt get url response. No Image available."), !1));
}
const ep = ge(!1), Bi = () => {
  function e() {
    ep.value = !0;
  }
  function t() {
    ep.value = !1;
  }
  return {
    containerQueriesEnabled: ep,
    enableContainerQueries: e,
    disableContainerQueries: t
  };
};
var Ct = /* @__PURE__ */ ((e) => (e[e.Xs = 320] = "Xs", e[e.Sm = 360] = "Sm", e[e.Md = 576] = "Md", e[e.Lg = 768] = "Lg", e[e.Xl = 1024] = "Xl", e[e.XxlPageSection = 1199] = "XxlPageSection", e[e.Xxl = 1280] = "Xxl", e[e.Xxxl = 1920] = "Xxxl", e))(Ct || {});
const xt = () => {
  const e = iP({
    Xs: 320,
    Sm: 360,
    Md: 576,
    Lg: 768,
    Xl: 1024,
    XxlPageSection: 1199,
    Xxl: 1280,
    Xxxl: 1920
    /* Xxxl */
  }), t = ge(), n = ge(), i = ge(), o = ge(), a = ge(), r = ge(), s = ge(), l = ge(), d = ge(), y = ge();
  t.value = e.greaterOrEqual("Lg").value && e.smaller("XxlPageSection").value, n.value = e.between("Xl", "XxlPageSection").value, i.value = e.smaller("Lg").value, o.value = e.greaterOrEqual("Md").value && e.smaller("Lg").value, a.value = e.greaterOrEqual("Xxl").value, r.value = e.greaterOrEqual("XxlPageSection").value, d.value = e.smaller("Xl").value, s.value = e.greaterOrEqual("Xl").value, l.value = e.smallerOrEqual("Lg").value, y.value = e.smallerOrEqual("Md").value, qe(e.current(), () => {
    t.value = e.greaterOrEqual("Lg").value && e.smaller("XxlPageSection").value, n.value = e.between("Xl", "XxlPageSection").value, i.value = e.smaller("Lg").value, o.value = e.greaterOrEqual("Md").value && e.smaller("Lg").value, a.value = e.greaterOrEqual("Xxl").value, r.value = e.greaterOrEqual("XxlPageSection").value, d.value = e.smaller("Xl").value, s.value = e.greaterOrEqual("Xl").value, l.value = e.smallerOrEqual("Lg").value, y.value = e.smallerOrEqual("Md").value;
  });
  const u = Di(() => e.greaterOrEqual("Lg").value && e.smaller("XxlPageSection").value), m = Di(() => e.between("Xl", "XxlPageSection").value), h = Di(() => e.smaller("Lg").value), c = Di(() => e.greaterOrEqual("Xxl").value), g = Di(() => e.greaterOrEqual("XxlPageSection").value), v = Di(() => e.smallerOrEqual("Md").value), P = Di(() => e.greaterOrEqual("Xl").value), f = Di(() => e.smallerOrEqual("Lg").value), S = Di(() => e.smaller("Xl").value), w = Di(() => e.smallerOrEqual("Xxl").value), x = Di(() => e.current().value.pop()), k = Di(() => e.greaterOrEqual("Xxl").value && e.smaller("Xxxl").value), A = Te(() => e.current().value.pop());
  return {
    breakpoints: e,
    isMobile: i,
    isMobileLandscape: o,
    isMobileAsync: h,
    isTablet: t,
    isTabletAsync: u,
    isTabletLandscape: n,
    isTabletLandscapeAsync: m,
    isDesktop: a,
    isDesktopAsync: c,
    currentBreakpoint: A,
    currentBreakpointAsync: x,
    isXxlPageSection: r,
    isXxlPageSectionAsync: g,
    isGreaterOrEqualLg: s,
    isGreaterOrEqualLgAsync: P,
    isSmallOrEqualLg: l,
    isSmallOrEqualLgAsync: f,
    isSmallerXl: d,
    isSmallerXlAsync: S,
    isSmallOrEqualMd: y,
    isSmallOrEqualMdAsync: v,
    isSmallOrEqualXxlAsync: w,
    isXXLAsync: k
  };
}, Gu = (e) => {
  const t = ge(e), n = ge(0), i = ge(0), o = () => {
    n.value = t.value?.clientWidth, i.value = t.value?.clientHeight;
  };
  o();
  const a = Jn(() => {
    o();
  }, 100);
  Ue && wi(window, "resize", () => a(), {
    passive: !0
  });
  const r = Te(() => n.value), s = Te(() => i.value), l = Te(() => n.value >= Ct.Xxl), d = Te(
    () => n.value >= Ct.Lg && n.value < Ct.Xxl
  ), y = Te(
    () => n.value >= Ct.Xl && n.value < Ct.Xxl
  ), u = Te(() => n.value < Ct.Lg), m = Te(
    () => n.value >= Ct.Md && n.value < Ct.Lg
  ), h = Te(() => n.value >= Ct.Xxxl), c = Te(() => n.value < Ct.Xxxl), g = Te(() => n.value < Ct.Xxl), v = Te(() => n.value < Ct.Xl), P = Te(() => n.value < Ct.Lg), f = Te(() => n.value < Ct.Md), S = Te(() => n.value < Ct.Sm);
  return {
    width: r,
    height: s,
    isDesktop: l,
    isTablet: d,
    isTabletLandscape: y,
    isMobile: u,
    isMobileLandscape: m,
    xxxLarge: h,
    xxLarge: c,
    xlarge: g,
    large: v,
    medium: P,
    small: f,
    xsmall: S
  };
}, tw = Symbol("dxOptions"), Li = () => $t(tw), pd = ge(!1), Uu = () => ({
  initialize: () => {
    Ue && (window.onbeforeprint = function() {
      pd.value = !0;
    }, window.onafterprint = function() {
      pd.value = !1;
    });
  },
  showPrintDialog: () => {
    Ue && (pd.value = !0, setTimeout(() => window.print(), 500));
  },
  isPrint: pd
}), nw = (e, t) => {
  const n = ge(null);
  return (...i) => {
    n.value || (e.apply(void 0, i), n.value = setTimeout(() => {
      n.value = null;
    }, t));
  };
}, fi = (e, t) => {
  const n = ge(null);
  n.value = setTimeout(() => {
    e(), n.value = null;
  }, t);
}, gP = {
  ADD_TAGS: [
    // the tags have to be the exactly spelling as they are defined in the HTML
    "BaseImage",
    "BaseLinkV2",
    "GlossaryItem",
    "PageFootnoteList",
    "PageFootnoteReference",
    "vue-glossary-item"
  ],
  ADD_ATTR: [
    ":always-underline",
    ":component-id",
    ":font-size",
    ":font-type",
    ":footnote-reference-id",
    ":footnote-type",
    ":has-text",
    ":icon",
    ":icon-color",
    ":icon-position",
    ":icon-size",
    ":is-copy-link",
    ":item-overlay-text",
    ":item-text",
    ":link-model",
    ":model",
    ":responsive-options",
    ":rounded-corner",
    ":special-link",
    ":stop-propagation",
    ":title",
    ":type"
  ]
}, fd = "data-temp-href-target";
let iw = !1;
const vP = () => {
  iw = !0, Ia.removeAllHooks(), Ia.addHook("beforeSanitizeAttributes", function(e) {
    e.tagName === "A" && (!e.hasAttribute("target") && e.getAttribute("href")?.charAt(0) === "#" ? e.setAttribute("target", "_self") : e.setAttribute(
      fd,
      e.getAttribute("target") || "_blank"
    ));
  }), Ia.addHook("afterSanitizeAttributes", function(e) {
    if (e.tagName === "A" && e.hasAttribute(fd)) {
      const t = e.getAttribute(fd);
      if (!t)
        return;
      e.removeAttribute(fd), e.setAttribute("target", t), t === "_blank" && e.setAttribute("rel", "noopener noreferrer");
    }
  });
}, Ma = (e, t) => e ? (t || (t = gP), iw || vP(), Ia.isSupported ? t ? Ia.sanitize(e, t) : Ia.sanitize(e) : e) : "", Wu = () => ({
  get: async (n, i) => {
    const { error: o, data: a } = await Av(n, i).get().json();
    return {
      error: o,
      data: a
    };
  },
  post: async (n, i) => {
    const { error: o, data: a } = await Av(n, i).post().json();
    return {
      error: o,
      data: a
    };
  }
}), On = (e, t, n, i, o, a, r) => {
  const s = (Ue && window.utag_data?.page_name) ?? "";
  Ue && window.utag?.view({
    event_name_tealium: [
      n || s,
      e,
      r,
      t,
      i,
      o,
      a
    ].join("."),
    event_source: n || s,
    // PageName ck1
    event_component_name: e,
    // ComponentName ck2
    event_title: t,
    // EventTitle ck4
    event_linktype: i || "",
    event_target: o || "",
    event_engagement: a || "",
    event_component_headline: r || ""
  });
};
function yP() {
  function e(n) {
    if (!n || !Dx(n))
      return "";
    let i = "";
    typeof n.type == "string" ? i = n.type : n.type && typeof n.type == "object" && "__name" in n.type && typeof n.type.__name == "string" && (i = n.type.__name.toLowerCase() === "symbol(v-txt)" ? "span" : i);
    const o = n.props ? Object.entries(n.props).map(([s, l]) => `${s}="${l}"`).join(" ") : "", a = n.children ? Array.isArray(n.children) ? n.children.map(
      (s) => typeof s == "object" ? e(s) : s
    ).join("") : n.children : "", r = `<${i} ${o}>${a}</${i}>`;
    return i ? r : a.toString();
  }
  function t(n) {
    return n && !Array.isArray(n.children) ? typeof n.children == "string" : !1;
  }
  return { convertVNodeToHTML: e, hasOnlyTextChildren: t };
}
const bP = {
  key: 0,
  class: "d-html-content-block"
}, xP = { key: 1 }, ht = /* @__PURE__ */ Be({
  __name: "HTMLContentBlock",
  props: {
    htmlText: {
      type: String,
      required: !0
    },
    disableDefaultStyling: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const { htmlContentBlockWhitelist: t } = Li(), n = t, i = new RegExp(n?.ADD_TAGS.join(">|")), o = (r) => i.test(r), a = (r) => {
      const s = Ma(r, n);
      return o(s) ? mr(s) : { template: s };
    };
    return (r, s) => e.disableDefaultStyling ? (E(), X("span", xP, [
      e.htmlText?.length > 0 ? (E(), fe(tt(a(e.htmlText)), { key: 0 })) : te("", !0)
    ])) : (E(), X("div", bP, [
      e.htmlText?.length > 0 ? (E(), fe(tt(a(e.htmlText)), { key: 0 })) : te("", !0)
    ]));
  }
});
const Fe = (e, t) => {
  const n = e.__vccOpts || e;
  for (const [i, o] of t)
    n[i] = o;
  return n;
}, wP = Be({
  name: "FootNote",
  components: { HTMLContentBlock: ht },
  props: {
    values: {
      type: Object,
      required: !0
    },
    id: {
      type: String,
      required: !1,
      default: ""
    }
  },
  created() {
    const { t: e } = Je();
    this.translate = e;
  }
}), kP = { class: "footnote" }, SP = ["id"], CP = { class: "item-number" }, TP = ["aria-label", "href"];
function LP(e, t, n, i, o, a) {
  const r = $e("HTMLContentBlock"), s = Ut("smooth-scroll");
  return E(), X("div", kP, [
    (E(!0), X(Re, null, Ge(e.values?.footnotes, (l) => (E(), X("div", {
      id: "sec-" + l.index + "-" + (e.values.id ? e.values.id : e.id),
      key: l,
      class: "flex flex-row"
    }, [
      oe("span", CP, Ie(l.index), 1),
      oe("span", null, [
        oe("span", null, [
          ue(r, {
            "html-text": l.value.toString(),
            "disable-default-styling": ""
          }, null, 8, ["html-text"])
        ]),
        rt((E(), X("a", {
          "aria-label": `${e.translate("footNote.link")} ${l.index}`,
          href: "#first-" + l.index + "-" + (e.values.id ? e.values.id : e.id)
        }, t[0] || (t[0] = [
          oe("i", { class: "las la-arrow-up footnote-arrow" }, null, -1)
        ]), 8, TP)), [
          [s, { duration: 1e3, offset: -350 }]
        ])
      ])
    ], 8, SP))), 128))
  ]);
}
const ja = /* @__PURE__ */ Fe(wP, [["render", LP]]);
function IP() {
  return aw().__VUE_DEVTOOLS_GLOBAL_HOOK__;
}
function aw() {
  return typeof navigator < "u" && typeof window < "u" ? window : typeof globalThis < "u" ? globalThis : {};
}
const PP = typeof Proxy == "function", AP = "devtools-plugin:setup", _P = "plugin:settings:set";
let Nr, Hp;
function MP() {
  var e;
  return Nr !== void 0 || (typeof window < "u" && window.performance ? (Nr = !0, Hp = window.performance) : typeof globalThis < "u" && (!((e = globalThis.perf_hooks) === null || e === void 0) && e.performance) ? (Nr = !0, Hp = globalThis.perf_hooks.performance) : Nr = !1), Nr;
}
function OP() {
  return MP() ? Hp.now() : Date.now();
}
class BP {
  constructor(t, n) {
    this.target = null, this.targetQueue = [], this.onQueue = [], this.plugin = t, this.hook = n;
    const i = {};
    if (t.settings)
      for (const r in t.settings) {
        const s = t.settings[r];
        i[r] = s.defaultValue;
      }
    const o = `__vue-devtools-plugin-settings__${t.id}`;
    let a = Object.assign({}, i);
    try {
      const r = localStorage.getItem(o), s = JSON.parse(r);
      Object.assign(a, s);
    } catch {
    }
    this.fallbacks = {
      getSettings() {
        return a;
      },
      setSettings(r) {
        try {
          localStorage.setItem(o, JSON.stringify(r));
        } catch {
        }
        a = r;
      },
      now() {
        return OP();
      }
    }, n && n.on(_P, (r, s) => {
      r === this.plugin.id && this.fallbacks.setSettings(s);
    }), this.proxiedOn = new Proxy({}, {
      get: (r, s) => this.target ? this.target.on[s] : (...l) => {
        this.onQueue.push({
          method: s,
          args: l
        });
      }
    }), this.proxiedTarget = new Proxy({}, {
      get: (r, s) => this.target ? this.target[s] : s === "on" ? this.proxiedOn : Object.keys(this.fallbacks).includes(s) ? (...l) => (this.targetQueue.push({
        method: s,
        args: l,
        resolve: () => {
        }
      }), this.fallbacks[s](...l)) : (...l) => new Promise((d) => {
        this.targetQueue.push({
          method: s,
          args: l,
          resolve: d
        });
      })
    });
  }
  async setRealTarget(t) {
    this.target = t;
    for (const n of this.onQueue)
      this.target.on[n.method](...n.args);
    for (const n of this.targetQueue)
      n.resolve(await this.target[n.method](...n.args));
  }
}
function wm(e, t) {
  const n = e, i = aw(), o = IP(), a = PP && n.enableEarlyProxy;
  if (o && (i.__VUE_DEVTOOLS_PLUGIN_API_AVAILABLE__ || !a))
    o.emit(AP, e, t);
  else {
    const r = a ? new BP(n, o) : null;
    (i.__VUE_DEVTOOLS_PLUGINS__ = i.__VUE_DEVTOOLS_PLUGINS__ || []).push({
      pluginDescriptor: n,
      setupFn: t,
      proxy: r
    }), r && t(r.proxiedTarget);
  }
}
/*!
 * pinia v2.3.0
 * (c) 2024 Eduardo San Martin Morote
 * @license MIT
 */
let gl;
const rs = (e) => gl = e, ow = process.env.NODE_ENV !== "production" ? Symbol("pinia") : (
  /* istanbul ignore next */
  Symbol()
);
function kr(e) {
  return e && typeof e == "object" && Object.prototype.toString.call(e) === "[object Object]" && typeof e.toJSON != "function";
}
var Pa;
(function(e) {
  e.direct = "direct", e.patchObject = "patch object", e.patchFunction = "patch function";
})(Pa || (Pa = {}));
const _o = typeof window < "u", Mv = /* @__PURE__ */ (() => typeof window == "object" && window.window === window ? window : typeof self == "object" && self.self === self ? self : typeof global == "object" && global.global === global ? global : typeof globalThis == "object" ? globalThis : { HTMLElement: null })();
function EP(e, { autoBom: t = !1 } = {}) {
  return t && /^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(e.type) ? new Blob([String.fromCharCode(65279), e], { type: e.type }) : e;
}
function km(e, t, n) {
  const i = new XMLHttpRequest();
  i.open("GET", e), i.responseType = "blob", i.onload = function() {
    lw(i.response, t, n);
  }, i.onerror = function() {
    console.error("could not download file");
  }, i.send();
}
function rw(e) {
  const t = new XMLHttpRequest();
  t.open("HEAD", e, !1);
  try {
    t.send();
  } catch {
  }
  return t.status >= 200 && t.status <= 299;
}
function Ud(e) {
  try {
    e.dispatchEvent(new MouseEvent("click"));
  } catch {
    const n = document.createEvent("MouseEvents");
    n.initMouseEvent("click", !0, !0, window, 0, 0, 0, 80, 20, !1, !1, !1, !1, 0, null), e.dispatchEvent(n);
  }
}
const Wd = typeof navigator == "object" ? navigator : { userAgent: "" }, sw = /* @__PURE__ */ (() => /Macintosh/.test(Wd.userAgent) && /AppleWebKit/.test(Wd.userAgent) && !/Safari/.test(Wd.userAgent))(), lw = _o ? (
  // Use download attribute first if possible (#193 Lumia mobile) unless this is a macOS WebView or mini program
  typeof HTMLAnchorElement < "u" && "download" in HTMLAnchorElement.prototype && !sw ? DP : (
    // Use msSaveOrOpenBlob as a second approach
    "msSaveOrOpenBlob" in Wd ? RP : (
      // Fallback to using FileReader and a popup
      NP
    )
  )
) : () => {
};
function DP(e, t = "download", n) {
  const i = document.createElement("a");
  i.download = t, i.rel = "noopener", typeof e == "string" ? (i.href = e, i.origin !== location.origin ? rw(i.href) ? km(e, t, n) : (i.target = "_blank", Ud(i)) : Ud(i)) : (i.href = URL.createObjectURL(e), setTimeout(function() {
    URL.revokeObjectURL(i.href);
  }, 4e4), setTimeout(function() {
    Ud(i);
  }, 0));
}
function RP(e, t = "download", n) {
  if (typeof e == "string")
    if (rw(e))
      km(e, t, n);
    else {
      const i = document.createElement("a");
      i.href = e, i.target = "_blank", setTimeout(function() {
        Ud(i);
      });
    }
  else
    navigator.msSaveOrOpenBlob(EP(e, n), t);
}
function NP(e, t, n, i) {
  if (i = i || open("", "_blank"), i && (i.document.title = i.document.body.innerText = "downloading..."), typeof e == "string")
    return km(e, t, n);
  const o = e.type === "application/octet-stream", a = /constructor/i.test(String(Mv.HTMLElement)) || "safari" in Mv, r = /CriOS\/[\d]+/.test(navigator.userAgent);
  if ((r || o && a || sw) && typeof FileReader < "u") {
    const s = new FileReader();
    s.onloadend = function() {
      let l = s.result;
      if (typeof l != "string")
        throw i = null, new Error("Wrong reader.result type");
      l = r ? l : l.replace(/^data:[^;]*;/, "data:attachment/file;"), i ? i.location.href = l : location.assign(l), i = null;
    }, s.readAsDataURL(e);
  } else {
    const s = URL.createObjectURL(e);
    i ? i.location.assign(s) : location.href = s, i = null, setTimeout(function() {
      URL.revokeObjectURL(s);
    }, 4e4);
  }
}
function Gn(e, t) {
  const n = "🍍 " + e;
  typeof __VUE_DEVTOOLS_TOAST__ == "function" ? __VUE_DEVTOOLS_TOAST__(n, t) : t === "error" ? console.error(n) : t === "warn" ? console.warn(n) : console.log(n);
}
function Sm(e) {
  return "_a" in e && "install" in e;
}
function cw() {
  if (!("clipboard" in navigator))
    return Gn("Your browser doesn't support the Clipboard API", "error"), !0;
}
function dw(e) {
  return e instanceof Error && e.message.toLowerCase().includes("document is not focused") ? (Gn('You need to activate the "Emulate a focused page" setting in the "Rendering" panel of devtools.', "warn"), !0) : !1;
}
async function $P(e) {
  if (!cw())
    try {
      await navigator.clipboard.writeText(JSON.stringify(e.state.value)), Gn("Global state copied to clipboard.");
    } catch (t) {
      if (dw(t))
        return;
      Gn("Failed to serialize the state. Check the console for more details.", "error"), console.error(t);
    }
}
async function FP(e) {
  if (!cw())
    try {
      uw(e, JSON.parse(await navigator.clipboard.readText())), Gn("Global state pasted from clipboard.");
    } catch (t) {
      if (dw(t))
        return;
      Gn("Failed to deserialize the state from clipboard. Check the console for more details.", "error"), console.error(t);
    }
}
async function jP(e) {
  try {
    lw(new Blob([JSON.stringify(e.state.value)], {
      type: "text/plain;charset=utf-8"
    }), "pinia-state.json");
  } catch (t) {
    Gn("Failed to export the state as JSON. Check the console for more details.", "error"), console.error(t);
  }
}
let Xa;
function HP() {
  Xa || (Xa = document.createElement("input"), Xa.type = "file", Xa.accept = ".json");
  function e() {
    return new Promise((t, n) => {
      Xa.onchange = async () => {
        const i = Xa.files;
        if (!i)
          return t(null);
        const o = i.item(0);
        return t(o ? { text: await o.text(), file: o } : null);
      }, Xa.oncancel = () => t(null), Xa.onerror = n, Xa.click();
    });
  }
  return e;
}
async function zP(e) {
  try {
    const n = await HP()();
    if (!n)
      return;
    const { text: i, file: o } = n;
    uw(e, JSON.parse(i)), Gn(`Global state imported from "${o.name}".`);
  } catch (t) {
    Gn("Failed to import the state from JSON. Check the console for more details.", "error"), console.error(t);
  }
}
function uw(e, t) {
  for (const n in t) {
    const i = e.state.value[n];
    i ? Object.assign(i, t[n]) : e.state.value[n] = t[n];
  }
}
function ha(e) {
  return {
    _custom: {
      display: e
    }
  };
}
const hw = "🍍 Pinia (root)", Yd = "_root";
function VP(e) {
  return Sm(e) ? {
    id: Yd,
    label: hw
  } : {
    id: e.$id,
    label: e.$id
  };
}
function GP(e) {
  if (Sm(e)) {
    const n = Array.from(e._s.keys()), i = e._s;
    return {
      state: n.map((a) => ({
        editable: !0,
        key: a,
        value: e.state.value[a]
      })),
      getters: n.filter((a) => i.get(a)._getters).map((a) => {
        const r = i.get(a);
        return {
          editable: !1,
          key: a,
          value: r._getters.reduce((s, l) => (s[l] = r[l], s), {})
        };
      })
    };
  }
  const t = {
    state: Object.keys(e.$state).map((n) => ({
      editable: !0,
      key: n,
      value: e.$state[n]
    }))
  };
  return e._getters && e._getters.length && (t.getters = e._getters.map((n) => ({
    editable: !1,
    key: n,
    value: e[n]
  }))), e._customProperties.size && (t.customProperties = Array.from(e._customProperties).map((n) => ({
    editable: !0,
    key: n,
    value: e[n]
  }))), t;
}
function UP(e) {
  return e ? Array.isArray(e) ? e.reduce((t, n) => (t.keys.push(n.key), t.operations.push(n.type), t.oldValue[n.key] = n.oldValue, t.newValue[n.key] = n.newValue, t), {
    oldValue: {},
    keys: [],
    operations: [],
    newValue: {}
  }) : {
    operation: ha(e.type),
    key: ha(e.key),
    oldValue: e.oldValue,
    newValue: e.newValue
  } : {};
}
function WP(e) {
  switch (e) {
    case Pa.direct:
      return "mutation";
    case Pa.patchFunction:
      return "$patch";
    case Pa.patchObject:
      return "$patch";
    default:
      return "unknown";
  }
}
let Kr = !0;
const qd = [], ir = "pinia:mutations", ni = "pinia", { assign: YP } = Object, uu = (e) => "🍍 " + e;
function qP(e, t) {
  wm({
    id: "dev.esm.pinia",
    label: "Pinia 🍍",
    logo: "https://pinia.vuejs.org/logo.svg",
    packageName: "pinia",
    homepage: "https://pinia.vuejs.org",
    componentStateTypes: qd,
    app: e
  }, (n) => {
    typeof n.now != "function" && Gn("You seem to be using an outdated version of Vue Devtools. Are you still using the Beta release instead of the stable one? You can find the links at https://devtools.vuejs.org/guide/installation.html."), n.addTimelineLayer({
      id: ir,
      label: "Pinia 🍍",
      color: 15064968
    }), n.addInspector({
      id: ni,
      label: "Pinia 🍍",
      icon: "storage",
      treeFilterPlaceholder: "Search stores",
      actions: [
        {
          icon: "content_copy",
          action: () => {
            $P(t);
          },
          tooltip: "Serialize and copy the state"
        },
        {
          icon: "content_paste",
          action: async () => {
            await FP(t), n.sendInspectorTree(ni), n.sendInspectorState(ni);
          },
          tooltip: "Replace the state with the content of your clipboard"
        },
        {
          icon: "save",
          action: () => {
            jP(t);
          },
          tooltip: "Save the state as a JSON file"
        },
        {
          icon: "folder_open",
          action: async () => {
            await zP(t), n.sendInspectorTree(ni), n.sendInspectorState(ni);
          },
          tooltip: "Import the state from a JSON file"
        }
      ],
      nodeActions: [
        {
          icon: "restore",
          tooltip: 'Reset the state (with "$reset")',
          action: (i) => {
            const o = t._s.get(i);
            o ? typeof o.$reset != "function" ? Gn(`Cannot reset "${i}" store because it doesn't have a "$reset" method implemented.`, "warn") : (o.$reset(), Gn(`Store "${i}" reset.`)) : Gn(`Cannot reset "${i}" store because it wasn't found.`, "warn");
          }
        }
      ]
    }), n.on.inspectComponent((i, o) => {
      const a = i.componentInstance && i.componentInstance.proxy;
      if (a && a._pStores) {
        const r = i.componentInstance.proxy._pStores;
        Object.values(r).forEach((s) => {
          i.instanceData.state.push({
            type: uu(s.$id),
            key: "state",
            editable: !0,
            value: s._isOptionsAPI ? {
              _custom: {
                value: as(s.$state),
                actions: [
                  {
                    icon: "restore",
                    tooltip: "Reset the state of this store",
                    action: () => s.$reset()
                  }
                ]
              }
            } : (
              // NOTE: workaround to unwrap transferred refs
              Object.keys(s.$state).reduce((l, d) => (l[d] = s.$state[d], l), {})
            )
          }), s._getters && s._getters.length && i.instanceData.state.push({
            type: uu(s.$id),
            key: "getters",
            editable: !1,
            value: s._getters.reduce((l, d) => {
              try {
                l[d] = s[d];
              } catch (y) {
                l[d] = y;
              }
              return l;
            }, {})
          });
        });
      }
    }), n.on.getInspectorTree((i) => {
      if (i.app === e && i.inspectorId === ni) {
        let o = [t];
        o = o.concat(Array.from(t._s.values())), i.rootNodes = (i.filter ? o.filter((a) => "$id" in a ? a.$id.toLowerCase().includes(i.filter.toLowerCase()) : hw.toLowerCase().includes(i.filter.toLowerCase())) : o).map(VP);
      }
    }), globalThis.$pinia = t, n.on.getInspectorState((i) => {
      if (i.app === e && i.inspectorId === ni) {
        const o = i.nodeId === Yd ? t : t._s.get(i.nodeId);
        if (!o)
          return;
        o && (i.nodeId !== Yd && (globalThis.$store = as(o)), i.state = GP(o));
      }
    }), n.on.editInspectorState((i, o) => {
      if (i.app === e && i.inspectorId === ni) {
        const a = i.nodeId === Yd ? t : t._s.get(i.nodeId);
        if (!a)
          return Gn(`store "${i.nodeId}" not found`, "error");
        const { path: r } = i;
        Sm(a) ? r.unshift("state") : (r.length !== 1 || !a._customProperties.has(r[0]) || r[0] in a.$state) && r.unshift("$state"), Kr = !1, i.set(a, r, i.state.value), Kr = !0;
      }
    }), n.on.editComponentState((i) => {
      if (i.type.startsWith("🍍")) {
        const o = i.type.replace(/^🍍\s*/, ""), a = t._s.get(o);
        if (!a)
          return Gn(`store "${o}" not found`, "error");
        const { path: r } = i;
        if (r[0] !== "state")
          return Gn(`Invalid path for store "${o}":
${r}
Only state can be modified.`);
        r[0] = "$state", Kr = !1, i.set(a, r, i.state.value), Kr = !0;
      }
    });
  });
}
function KP(e, t) {
  qd.includes(uu(t.$id)) || qd.push(uu(t.$id)), wm({
    id: "dev.esm.pinia",
    label: "Pinia 🍍",
    logo: "https://pinia.vuejs.org/logo.svg",
    packageName: "pinia",
    homepage: "https://pinia.vuejs.org",
    componentStateTypes: qd,
    app: e,
    settings: {
      logStoreChanges: {
        label: "Notify about new/deleted stores",
        type: "boolean",
        defaultValue: !0
      }
      // useEmojis: {
      //   label: 'Use emojis in messages ⚡️',
      //   type: 'boolean',
      //   defaultValue: true,
      // },
    }
  }, (n) => {
    const i = typeof n.now == "function" ? n.now.bind(n) : Date.now;
    t.$onAction(({ after: r, onError: s, name: l, args: d }) => {
      const y = pw++;
      n.addTimelineEvent({
        layerId: ir,
        event: {
          time: i(),
          title: "🛫 " + l,
          subtitle: "start",
          data: {
            store: ha(t.$id),
            action: ha(l),
            args: d
          },
          groupId: y
        }
      }), r((u) => {
        Mo = void 0, n.addTimelineEvent({
          layerId: ir,
          event: {
            time: i(),
            title: "🛬 " + l,
            subtitle: "end",
            data: {
              store: ha(t.$id),
              action: ha(l),
              args: d,
              result: u
            },
            groupId: y
          }
        });
      }), s((u) => {
        Mo = void 0, n.addTimelineEvent({
          layerId: ir,
          event: {
            time: i(),
            logType: "error",
            title: "💥 " + l,
            subtitle: "end",
            data: {
              store: ha(t.$id),
              action: ha(l),
              args: d,
              error: u
            },
            groupId: y
          }
        });
      });
    }, !0), t._customProperties.forEach((r) => {
      qe(() => _(t[r]), (s, l) => {
        n.notifyComponentUpdate(), n.sendInspectorState(ni), Kr && n.addTimelineEvent({
          layerId: ir,
          event: {
            time: i(),
            title: "Change",
            subtitle: r,
            data: {
              newValue: s,
              oldValue: l
            },
            groupId: Mo
          }
        });
      }, { deep: !0 });
    }), t.$subscribe(({ events: r, type: s }, l) => {
      if (n.notifyComponentUpdate(), n.sendInspectorState(ni), !Kr)
        return;
      const d = {
        time: i(),
        title: WP(s),
        data: YP({ store: ha(t.$id) }, UP(r)),
        groupId: Mo
      };
      s === Pa.patchFunction ? d.subtitle = "⤵️" : s === Pa.patchObject ? d.subtitle = "🧩" : r && !Array.isArray(r) && (d.subtitle = r.type), r && (d.data["rawEvent(s)"] = {
        _custom: {
          display: "DebuggerEvent",
          type: "object",
          tooltip: "raw DebuggerEvent[]",
          value: r
        }
      }), n.addTimelineEvent({
        layerId: ir,
        event: d
      });
    }, { detached: !0, flush: "sync" });
    const o = t._hotUpdate;
    t._hotUpdate = ri((r) => {
      o(r), n.addTimelineEvent({
        layerId: ir,
        event: {
          time: i(),
          title: "🔥 " + t.$id,
          subtitle: "HMR update",
          data: {
            store: ha(t.$id),
            info: ha("HMR update")
          }
        }
      }), n.notifyComponentUpdate(), n.sendInspectorTree(ni), n.sendInspectorState(ni);
    });
    const { $dispose: a } = t;
    t.$dispose = () => {
      a(), n.notifyComponentUpdate(), n.sendInspectorTree(ni), n.sendInspectorState(ni), n.getSettings().logStoreChanges && Gn(`Disposed "${t.$id}" store 🗑`);
    }, n.notifyComponentUpdate(), n.sendInspectorTree(ni), n.sendInspectorState(ni), n.getSettings().logStoreChanges && Gn(`"${t.$id}" store installed 🆕`);
  });
}
let pw = 0, Mo;
function Ov(e, t, n) {
  const i = t.reduce((o, a) => (o[a] = as(e)[a], o), {});
  for (const o in i)
    e[o] = function() {
      const a = pw, r = n ? new Proxy(e, {
        get(...l) {
          return Mo = a, Reflect.get(...l);
        },
        set(...l) {
          return Mo = a, Reflect.set(...l);
        }
      }) : e;
      Mo = a;
      const s = i[o].apply(r, arguments);
      return Mo = void 0, s;
    };
}
function XP({ app: e, store: t, options: n }) {
  if (!t.$id.startsWith("__hot:")) {
    if (t._isOptionsAPI = !!n.state, !t._p._testing) {
      Ov(t, Object.keys(n.actions), t._isOptionsAPI);
      const i = t._hotUpdate;
      as(t)._hotUpdate = function(o) {
        i.apply(this, arguments), Ov(t, Object.keys(o._hmrPayload.actions), !!t._isOptionsAPI);
      };
    }
    KP(
      e,
      // FIXME: is there a way to allow the assignment from Store<Id, S, G, A> to StoreGeneric?
      t
    );
  }
}
function ZP() {
  const e = um(!0), t = e.run(() => ge({}));
  let n = [], i = [];
  const o = ri({
    install(a) {
      rs(o), o._a = a, a.provide(ow, o), a.config.globalProperties.$pinia = o, process.env.NODE_ENV !== "production" && process.env.NODE_ENV !== "test" && _o && qP(a, o), i.forEach((r) => n.push(r)), i = [];
    },
    use(a) {
      return !this._a && !qx ? i.push(a) : n.push(a), this;
    },
    _p: n,
    // it's actually undefined here
    // @ts-expect-error
    _a: null,
    _e: e,
    _s: /* @__PURE__ */ new Map(),
    state: t
  });
  return process.env.NODE_ENV !== "production" && process.env.NODE_ENV !== "test" && _o && typeof Proxy < "u" && o.use(XP), o;
}
function fw(e, t) {
  for (const n in t) {
    const i = t[n];
    if (!(n in e))
      continue;
    const o = e[n];
    kr(o) && kr(i) && !In(i) && !wr(i) ? e[n] = fw(o, i) : e[n] = i;
  }
  return e;
}
const mw = () => {
};
function Bv(e, t, n, i = mw) {
  e.push(t);
  const o = () => {
    const a = e.indexOf(t);
    a > -1 && (e.splice(a, 1), i());
  };
  return !n && Ox() && Bx(o), o;
}
function $r(e, ...t) {
  e.slice().forEach((n) => {
    n(...t);
  });
}
const JP = (e) => e(), Ev = Symbol(), tp = Symbol();
function zp(e, t) {
  e instanceof Map && t instanceof Map ? t.forEach((n, i) => e.set(i, n)) : e instanceof Set && t instanceof Set && t.forEach(e.add, e);
  for (const n in t) {
    if (!t.hasOwnProperty(n))
      continue;
    const i = t[n], o = e[n];
    kr(o) && kr(i) && e.hasOwnProperty(n) && !In(i) && !wr(i) ? e[n] = zp(o, i) : e[n] = i;
  }
  return e;
}
const QP = process.env.NODE_ENV !== "production" ? Symbol("pinia:skipHydration") : (
  /* istanbul ignore next */
  Symbol()
);
function eA(e) {
  return !kr(e) || !e.hasOwnProperty(QP);
}
const { assign: Fi } = Object;
function Dv(e) {
  return !!(In(e) && e.effect);
}
function Rv(e, t, n, i) {
  const { state: o, actions: a, getters: r } = t, s = n.state.value[e];
  let l;
  function d() {
    !s && (process.env.NODE_ENV === "production" || !i) && (n.state.value[e] = o ? o() : {});
    const y = process.env.NODE_ENV !== "production" && i ? (
      // use ref() to unwrap refs inside state TODO: check if this is still necessary
      Ep(ge(o ? o() : {}).value)
    ) : Ep(n.state.value[e]);
    return Fi(y, a, Object.keys(r || {}).reduce((u, m) => (process.env.NODE_ENV !== "production" && m in y && console.warn(`[🍍]: A getter cannot have the same name as another state property. Rename one of them. Found with "${m}" in store "${e}".`), u[m] = ri(Te(() => {
      rs(n);
      const h = n._s.get(e);
      return r[m].call(h, h);
    })), u), {}));
  }
  return l = Vp(e, d, t, n, i, !0), l;
}
function Vp(e, t, n = {}, i, o, a) {
  let r;
  const s = Fi({ actions: {} }, n);
  if (process.env.NODE_ENV !== "production" && !i._e.active)
    throw new Error("Pinia destroyed");
  const l = { deep: !0 };
  process.env.NODE_ENV !== "production" && !qx && (l.onTrigger = (N) => {
    d ? h = N : d == !1 && !A._hotUpdating && (Array.isArray(h) ? h.push(N) : console.error("🍍 debuggerEvents should be an array. This is most likely an internal Pinia bug."));
  });
  let d, y, u = [], m = [], h;
  const c = i.state.value[e];
  !a && !c && (process.env.NODE_ENV === "production" || !o) && (i.state.value[e] = {});
  const g = ge({});
  let v;
  function P(N) {
    let M;
    d = y = !1, process.env.NODE_ENV !== "production" && (h = []), typeof N == "function" ? (N(i.state.value[e]), M = {
      type: Pa.patchFunction,
      storeId: e,
      events: h
    }) : (zp(i.state.value[e], N), M = {
      type: Pa.patchObject,
      payload: N,
      storeId: e,
      events: h
    });
    const D = v = Symbol();
    mt().then(() => {
      v === D && (d = !0);
    }), y = !0, $r(u, M, i.state.value[e]);
  }
  const f = a ? function() {
    const { state: M } = n, D = M ? M() : {};
    this.$patch((C) => {
      Fi(C, D);
    });
  } : (
    /* istanbul ignore next */
    process.env.NODE_ENV !== "production" ? () => {
      throw new Error(`🍍: Store "${e}" is built using the setup syntax and does not implement $reset().`);
    } : mw
  );
  function S() {
    r.stop(), u = [], m = [], i._s.delete(e);
  }
  const w = (N, M = "") => {
    if (Ev in N)
      return N[tp] = M, N;
    const D = function() {
      rs(i);
      const C = Array.from(arguments), b = [], p = [];
      function L(O) {
        b.push(O);
      }
      function B(O) {
        p.push(O);
      }
      $r(m, {
        args: C,
        name: D[tp],
        store: A,
        after: L,
        onError: B
      });
      let T;
      try {
        T = N.apply(this && this.$id === e ? this : A, C);
      } catch (O) {
        throw $r(p, O), O;
      }
      return T instanceof Promise ? T.then((O) => ($r(b, O), O)).catch((O) => ($r(p, O), Promise.reject(O))) : ($r(b, T), T);
    };
    return D[Ev] = !0, D[tp] = M, D;
  }, x = /* @__PURE__ */ ri({
    actions: {},
    getters: {},
    state: [],
    hotState: g
  }), k = {
    _p: i,
    // _s: scope,
    $id: e,
    $onAction: Bv.bind(null, m),
    $patch: P,
    $reset: f,
    $subscribe(N, M = {}) {
      const D = Bv(u, N, M.detached, () => C()), C = r.run(() => qe(() => i.state.value[e], (b) => {
        (M.flush === "sync" ? y : d) && N({
          storeId: e,
          type: Pa.direct,
          events: h
        }, b);
      }, Fi({}, l, M)));
      return D;
    },
    $dispose: S
  }, A = Qi(process.env.NODE_ENV !== "production" || process.env.NODE_ENV !== "production" && process.env.NODE_ENV !== "test" && _o ? Fi(
    {
      _hmrPayload: x,
      _customProperties: ri(/* @__PURE__ */ new Set())
      // devtools custom properties
    },
    k
    // must be added later
    // setupStore
  ) : k);
  i._s.set(e, A);
  const j = (i._a && i._a.runWithContext || JP)(() => i._e.run(() => (r = um()).run(() => t({ action: w }))));
  for (const N in j) {
    const M = j[N];
    if (In(M) && !Dv(M) || wr(M))
      process.env.NODE_ENV !== "production" && o ? hd(g.value, N, xi(j, N)) : a || (c && eA(M) && (In(M) ? M.value = c[N] : zp(M, c[N])), i.state.value[e][N] = M), process.env.NODE_ENV !== "production" && x.state.push(N);
    else if (typeof M == "function") {
      const D = process.env.NODE_ENV !== "production" && o ? M : w(M, N);
      j[N] = D, process.env.NODE_ENV !== "production" && (x.actions[N] = M), s.actions[N] = M;
    } else
      process.env.NODE_ENV !== "production" && Dv(M) && (x.getters[N] = a ? (
        // @ts-expect-error
        n.getters[N]
      ) : M, _o && (j._getters || // @ts-expect-error: same
      (j._getters = ri([]))).push(N));
  }
  if (Fi(A, j), Fi(as(A), j), Object.defineProperty(A, "$state", {
    get: () => process.env.NODE_ENV !== "production" && o ? g.value : i.state.value[e],
    set: (N) => {
      if (process.env.NODE_ENV !== "production" && o)
        throw new Error("cannot set hotState");
      P((M) => {
        Fi(M, N);
      });
    }
  }), process.env.NODE_ENV !== "production" && (A._hotUpdate = ri((N) => {
    A._hotUpdating = !0, N._hmrPayload.state.forEach((M) => {
      if (M in A.$state) {
        const D = N.$state[M], C = A.$state[M];
        typeof D == "object" && kr(D) && kr(C) ? fw(D, C) : N.$state[M] = C;
      }
      hd(A, M, xi(N.$state, M));
    }), Object.keys(A.$state).forEach((M) => {
      M in N.$state || Xh(A, M);
    }), d = !1, y = !1, i.state.value[e] = xi(N._hmrPayload, "hotState"), y = !0, mt().then(() => {
      d = !0;
    });
    for (const M in N._hmrPayload.actions) {
      const D = N[M];
      hd(A, M, w(D, M));
    }
    for (const M in N._hmrPayload.getters) {
      const D = N._hmrPayload.getters[M], C = a ? (
        // special handling of options api
        Te(() => (rs(i), D.call(A, A)))
      ) : D;
      hd(A, M, C);
    }
    Object.keys(A._hmrPayload.getters).forEach((M) => {
      M in N._hmrPayload.getters || Xh(A, M);
    }), Object.keys(A._hmrPayload.actions).forEach((M) => {
      M in N._hmrPayload.actions || Xh(A, M);
    }), A._hmrPayload = N._hmrPayload, A._getters = N._getters, A._hotUpdating = !1;
  })), process.env.NODE_ENV !== "production" && process.env.NODE_ENV !== "test" && _o) {
    const N = {
      writable: !0,
      configurable: !0,
      // avoid warning on devtools trying to display this property
      enumerable: !1
    };
    ["_p", "_hmrPayload", "_getters", "_customProperties"].forEach((M) => {
      Object.defineProperty(A, M, Fi({ value: A[M] }, N));
    });
  }
  return i._p.forEach((N) => {
    if (process.env.NODE_ENV !== "production" && process.env.NODE_ENV !== "test" && _o) {
      const M = r.run(() => N({
        store: A,
        app: i._a,
        pinia: i,
        options: s
      }));
      Object.keys(M || {}).forEach((D) => A._customProperties.add(D)), Fi(A, M);
    } else
      Fi(A, r.run(() => N({
        store: A,
        app: i._a,
        pinia: i,
        options: s
      })));
  }), process.env.NODE_ENV !== "production" && A.$state && typeof A.$state == "object" && typeof A.$state.constructor == "function" && !A.$state.constructor.toString().includes("[native code]") && console.warn(`[🍍]: The "state" must be a plain object. It cannot be
	state: () => new MyClass()
Found in store "${A.$id}".`), c && a && n.hydrate && n.hydrate(A.$state, c), d = !0, y = !0, A;
}
/*! #__NO_SIDE_EFFECTS__ */
// @__NO_SIDE_EFFECTS__
function Ha(e, t, n) {
  let i, o;
  const a = typeof t == "function";
  if (typeof e == "string")
    i = e, o = a ? n : t;
  else if (o = e, i = e.id, process.env.NODE_ENV !== "production" && typeof i != "string")
    throw new Error('[🍍]: "defineStore()" must be passed a store id as its first argument.');
  function r(s, l) {
    const d = DL();
    if (s = // in test mode, ignore the argument provided as we can always retrieve a
    // pinia instance with getActivePinia()
    (process.env.NODE_ENV === "test" && gl && gl._testing ? null : s) || (d ? $t(ow, null) : null), s && rs(s), process.env.NODE_ENV !== "production" && !gl)
      throw new Error(`[🍍]: "getActivePinia()" was called but there was no active Pinia. Are you trying to use a store before calling "app.use(pinia)"?
See https://pinia.vuejs.org/core-concepts/outside-component-usage.html for help.
This will fail in production.`);
    s = gl, s._s.has(i) || (a ? Vp(i, t, o, s) : Rv(i, o, s), process.env.NODE_ENV !== "production" && (r._pinia = s));
    const y = s._s.get(i);
    if (process.env.NODE_ENV !== "production" && l) {
      const u = "__hot:" + i, m = a ? Vp(u, t, o, s, !0) : Rv(u, Fi({}, o), s, !0);
      l._hotUpdate(m), delete s.state.value[u], s._s.delete(u);
    }
    if (process.env.NODE_ENV !== "production" && _o) {
      const u = ho();
      if (u && u.proxy && // avoid adding stores that are just built for hot module replacement
      !l) {
        const m = u.proxy, h = "_pStores" in m ? m._pStores : m._pStores = {};
        h[i] = y;
      }
    }
    return y;
  }
  return r.$id = i, r;
}
function tA(e, t) {
  return Array.isArray(t) ? t.reduce((n, i) => (n[i] = function() {
    return e(this.$pinia)[i];
  }, n), {}) : Object.keys(t).reduce((n, i) => (n[i] = function() {
    const o = e(this.$pinia), a = t[i];
    return typeof a == "function" ? a.call(this, o) : (
      // @ts-expect-error: FIXME: should work?
      o[a]
    );
  }, n), {});
}
function Cm(e) {
  {
    const t = as(e), n = {};
    for (const i in t) {
      const o = t[i];
      o.effect ? n[i] = // ...
      Te({
        get: () => e[i],
        set(a) {
          e[i] = a;
        }
      }) : (In(o) || wr(o)) && (n[i] = // ---
      xi(e, i));
    }
    return n;
  }
}
const Xi = /* @__PURE__ */ Ha("references", {
  state: () => ({ referenceItems: {} }),
  getters: {
    orderedReferenceItems: (e) => Wc(e.referenceItems),
    referencesCount: (e) => e?.referenceItems ? Object.keys(e.referenceItems).length : 0
  },
  actions: {
    add(e, t, n) {
      const o = {
        referenceItems: this.referenceItems,
        text: e,
        reference: t,
        componentId: n
      };
      this.referenceItems = aA(o);
    },
    remove(e, t, n) {
      const o = {
        referenceItems: this.referenceItems,
        text: e,
        reference: t,
        componentId: n
      };
      this.referenceItems = rA(o);
    },
    activate(e, t, n) {
      const o = {
        referenceItems: this.referenceItems,
        text: e,
        reference: t,
        componentId: n
      };
      this.referenceItems = sA(o);
    },
    deactivate(e, t, n) {
      const o = {
        referenceItems: this.referenceItems,
        text: e,
        reference: t,
        componentId: n
      };
      this.referenceItems = lA(o);
    },
    getReferencesByComponentId(e) {
      return cA(
        this.referenceItems,
        e
      );
    },
    resetStore() {
      this.referenceItems = {};
    }
  }
}), Wc = (e) => Object.keys(e).sort((t, n) => e[t].order - e[n].order).reduce(
  (t, n, i) => ({
    ...t,
    // merge existing items
    [n]: {
      // edit current item
      ...e[n],
      index: i + 1
      // set new index starting from 1
    }
  }),
  {}
);
let nA = 0;
const iA = (e, t) => ({
  referencesIds: [],
  order: nA++,
  index: 0,
  isActive: !1,
  componentId: t,
  text: e
}), aA = ({
  referenceItems: e,
  text: t,
  reference: n,
  componentId: i
}) => {
  const o = i ? t + "-" + i : t, a = e[o] || iA(o), r = a.referencesIds || [], s = r.includes(n);
  return a.referencesIds = s ? r : [...r, n], a.text = t, i && (a.componentId = i), Wc({
    ...e,
    [o]: a
  });
}, oA = (e, t) => {
  const n = e.indexOf(t);
  return n > -1 && e.splice(n, 1), e;
}, rA = ({
  referenceItems: e,
  text: t,
  reference: n,
  componentId: i
}) => {
  const o = i ? t + "-" + i : t, a = e[o];
  if (!a)
    return e;
  const r = oA(a.referencesIds, n) || [];
  return (!r || !r.length) && delete e[o], Wc(e);
}, sA = ({
  referenceItems: e,
  text: t,
  componentId: n
}) => {
  for (const a in e)
    e[a].isActive = !1;
  const i = n ? t + "-" + n : t, o = e[i];
  return o ? (o.isActive = !0, Wc(e)) : e;
}, lA = ({
  referenceItems: e,
  text: t,
  componentId: n
}) => {
  const i = n ? t + "-" + n : t, o = e[i];
  return o ? (o.isActive = !1, Wc(e)) : e;
};
function cA(e, t) {
  if (t?.length > 0) {
    const n = {};
    for (const i in e)
      e[i].componentId === t && (n[i] = e[i]);
    return n;
  } else
    return e;
}
const dA = ["id", "href", "data-event_title", "aria-label"], uA = ["title"], hA = /* @__PURE__ */ Be({
  __name: "Reference",
  props: {
    id: {
      type: String,
      required: !0
    },
    title: {
      type: String,
      required: !0
    },
    counterValue: {
      type: Number,
      required: !0
    },
    componentId: {
      type: String,
      required: !1,
      default: ""
    }
  },
  setup(e) {
    const { t } = Je(), n = ge(null), i = e, { activate: o } = Xi(), a = () => {
      if (!Ue)
        return;
      let y = n?.value;
      for (; y; )
        y?.classList && y?.classList?.contains("p-accordion-header-action") && (y?.closest(".p-accordion-tab")?.classList?.contains(
          "p-accordion-tab-active"
        ) || y?.click()), y = y?.parentElement;
    }, r = (y, u) => {
      y.preventDefault(), a(), o(u, i.id, i.componentId), d(), y.stopPropagation();
    }, s = Te(() => i.counterValue + (i.componentId ? "-" + i.componentId : "")), l = $t("smoothScroll");
    async function d() {
      if (await mt(), Ue) {
        const y = document.getElementById("footnote-ref-" + s.value);
        y && l({
          scrollTo: y,
          duration: 1e3,
          offset: 250,
          updateHistory: !1
        });
      }
    }
    return (y, u) => (E(), X("a", {
      id: "footnote-link-" + s.value,
      ref_key: "linkRef",
      ref: n,
      href: "#footnote-ref-" + s.value,
      target: "_self",
      "data-event_source": "${dataEventSource}",
      "data-event_component_name": "Text Links (same page)",
      "data-event_title": "Sprungmarke | [" + e.counterValue + "]",
      "aria-label": `${_(t)("footNoteHeader.link")} ${e.counterValue}`,
      onClick: u[0] || (u[0] = It((m) => r(m, e.title), ["stop"]))
    }, [
      oe("sup", {
        class: "d-footnote",
        title: e.title
      }, "[" + Ie(e.counterValue) + "]", 9, uA)
    ], 8, dA));
  }
});
const pA = /* @__PURE__ */ Fe(hA, [["__scopeId", "data-v-ba68dec6"]]);
function Pn() {
  return Ue ? mA() : fA();
}
function fA() {
  return "xxxxxxxx-xxxx-4xxx-xxxx-xxxxxxxxxxxx".replace(
    /[xy]/g,
    (e) => {
      const t = Math.random() * 16 | 0;
      return (e == "x" ? t : t & 3 | 8).toString(16);
    }
  );
}
function mA() {
  return "10000000-1000-4000-8000-100000000000".replace(
    /[018]/g,
    (e) => (parseInt(e, 10) ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> parseInt(e, 10) / 4).toString(16)
  );
}
const gA = /* @__PURE__ */ Be({
  __name: "PageFootnoteReference",
  props: {
    title: {
      type: String,
      required: !0
    },
    specialLink: {
      type: String,
      required: !1,
      default: ""
    },
    componentId: {
      type: String,
      required: !1,
      default: void 0
    }
  },
  setup(e) {
    const t = e, n = Pn(), { add: i, remove: o } = Xi();
    i(t.title, n, t.componentId);
    const a = Xi(), r = t.componentId ? t.title + "-" + t.componentId : t.title, s = Te(() => (a?.referenceItems[r] || {}).index);
    return sn(() => {
      o(t.title, n, t.componentId);
    }), (l, d) => (E(), fe(pA, {
      id: _(n),
      key: _(n),
      title: e.title,
      "counter-value": s.value,
      "component-id": e.componentId,
      class: "d-page-footnote-reference"
    }, null, 8, ["id", "title", "counter-value", "component-id"]));
  }
});
const ma = /* @__PURE__ */ Fe(gA, [["__scopeId", "data-v-72b33b79"]]);
function vA(e) {
  const t = [];
  let n = 1;
  return e.replace(/{{(.*?)}}/g, (o, a, r) => (t.push({ id: n++, position: r, content: a }), "")), e.replace(
    /{{(.*?)}}/g,
    (o, a, r) => `<PageFootnoteReference :title="'${t.find((l) => l.position === r)?.content}'" :specialLink="null"></PageFootnoteReference>`
  );
}
const ss = Be({
  name: "DynamicFootnoteRenderer",
  props: {
    html: {
      type: String,
      default: ""
    },
    purify: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const t = vA(e.html);
    return e.purify ? Ia.isSupported ? () => At(mr(Ia.sanitize(t))) : () => At(mr(t)) : () => At(mr(t));
  }
});
var Oi = /* @__PURE__ */ ((e) => (e.None = "none", e.ComponentId = "component-id", e.All = "all", e))(Oi || {});
const yA = {
  key: 0,
  class: "d-page-footnotes-list"
}, bA = { class: "footnote" }, xA = { class: "d-page-footnotes-list__text" }, wA = ["id", "href", "aria-label", "onClick"], kA = /* @__PURE__ */ Be({
  __name: "PageFootnoteList",
  props: {
    componentId: {
      type: String,
      default: void 0
    },
    footnoteType: {
      type: String,
      default: Oi.None
    }
  },
  setup(e) {
    const { t } = Je(), n = Xi(), { referenceItems: i } = Cm(Xi()), { getReferencesByComponentId: o } = Xi(), a = (r, s) => {
      setTimeout(function() {
        n.deactivate(r, s);
      }, 1e3);
    };
    return sn(() => {
      n.$dispose();
    }), (r, s) => {
      const l = Ut("smooth-scroll");
      return e.footnoteType !== _(Oi).None ? (E(), X("div", yA, [
        (E(!0), X(Re, null, Ge(e.footnoteType === _(Oi).ComponentId ? _(o)(e.componentId) : _(i), (d, y) => (E(), X("div", {
          key: y,
          class: "d-page-footnotes-list__row"
        }, [
          oe("span", bA, Ie(d.index), 1),
          oe("span", null, [
            oe("p", xA, [
              ue(_(ht), {
                "html-text": d.text,
                "disable-default-styling": ""
              }, null, 8, ["html-text"])
            ]),
            d.isActive ? rt((E(), X("a", {
              key: 0,
              id: "footnote-ref-" + d.index + (d.componentId ? "-" + d.componentId : ""),
              target: "_self",
              href: "#footnote-link-" + d.index + (d.componentId ? "-" + d.componentId : ""),
              "aria-label": `${_(t)("footNote.link")} ${d.index}`,
              onClick: It((u) => a(y, d.referencesIds[0]), ["stop"])
            }, s[0] || (s[0] = [
              oe("i", { class: "las la-arrow-up footnote-arrow" }, null, -1)
            ]), 8, wA)), [
              [l, { duration: 1e3, offset: -350 }]
            ]) : te("", !0)
          ])
        ]))), 128))
      ])) : te("", !0);
    };
  }
});
const ro = /* @__PURE__ */ Fe(kA, [["__scopeId", "data-v-bb5cc3d2"]]);
var at = /* @__PURE__ */ ((e) => (e.L = "large", e.M = "medium", e.S = "small", e.XS = "x-small", e.XXS = "xx-small", e.Inherit = "inherit", e.NextToText = "icon-size-text", e))(at || {}), K = /* @__PURE__ */ ((e) => (e.Lab = "lab", e.Lar = "lar", e.Las = "las", e))(K || {}), H = /* @__PURE__ */ ((e) => (e.FiveHundredPx = "500px", e.AccessibleIcon = "accessible-icon", e.Accusoft = "accusoft", e.AcquisitionsIncorporated = "acquisitions-incorporated", e.Ad = "ad", e.AddressBook = "address-book", e.AddressCard = "address-card", e.Adjust = "adjust", e.Adn = "adn", e.Adobe = "adobe", e.Adversal = "adversal", e.Affiliatetheme = "affiliatetheme", e.AirFreshener = "air-freshener", e.Airbnb = "airbnb", e.Algolia = "algolia", e.AlignCenter = "align-center", e.AlignJustify = "align-justify", e.AlignLeft = "align-left", e.AlignRight = "align-right", e.Alipay = "alipay", e.Allergies = "allergies", e.Amazon = "amazon", e.AmazonPay = "amazon-pay", e.Ambulance = "ambulance", e.AmericanSignLanguageInterpreting = "american-sign-language-interpreting", e.Amilia = "amilia", e.Anchor = "anchor", e.Android = "android", e.Angellist = "angellist", e.AngleDoubleDown = "angle-double-down", e.AngleDoubleLeft = "angle-double-left", e.AngleDoubleRight = "angle-double-right", e.AngleDoubleUp = "angle-double-up", e.AngleDown = "angle-down", e.AngleLeft = "angle-left", e.AngleRight = "angle-right", e.AngleUp = "angle-up", e.Angry = "angry", e.Angrycreative = "angrycreative", e.Angular = "angular", e.Ankh = "ankh", e.AppStore = "app-store", e.AppStoreIos = "app-store-ios", e.Apper = "apper", e.Apple = "apple", e.AppleAlt = "apple-alt", e.ApplePay = "apple-pay", e.Archive = "archive", e.Archway = "archway", e.ArrowAltCircleDown = "arrow-alt-circle-down", e.ArrowAltCircleLeft = "arrow-alt-circle-left", e.ArrowAltCircleRight = "arrow-alt-circle-right", e.ArrowAltCircleUp = "arrow-alt-circle-up", e.ArrowCircleDown = "arrow-circle-down", e.ArrowCircleLeft = "arrow-circle-left", e.ArrowCircleRight = "arrow-circle-right", e.ArrowCircleUp = "arrow-circle-up", e.ArrowDown = "arrow-down", e.ArrowLeft = "arrow-left", e.ArrowRight = "arrow-right", e.ArrowUp = "arrow-up", e.ArrowsAlt = "arrows-alt", e.ArrowsAltH = "arrows-alt-h", e.ArrowsAltV = "arrows-alt-v", e.Artstation = "artstation", e.AssistiveListeningSystems = "assistive-listening-systems", e.Asterisk = "asterisk", e.Asymmetrik = "asymmetrik", e.At = "at", e.Atlas = "atlas", e.Atlassian = "atlassian", e.Atom = "atom", e.Audible = "audible", e.AudioDescription = "audio-description", e.Autoprefixer = "autoprefixer", e.Avianex = "avianex", e.Aviato = "aviato", e.Award = "award", e.Aws = "aws", e.Baby = "baby", e.BabyCarriage = "baby-carriage", e.Backspace = "backspace", e.Backward = "backward", e.Bacon = "bacon", e.BalanceScale = "balance-scale", e.BalanceScaleLeft = "balance-scale-left", e.BalanceScaleRight = "balance-scale-right", e.Ban = "ban", e.BandAid = "band-aid", e.Bandcamp = "bandcamp", e.Barcode = "barcode", e.Bars = "bars", e.BaseballBall = "baseball-ball", e.BasketballBall = "basketball-ball", e.Bath = "bath", e.BatteryEmpty = "battery-empty", e.BatteryFull = "battery-full", e.BatteryHalf = "battery-half", e.BatteryQuarter = "battery-quarter", e.BatteryThreeQuarters = "battery-three-quarters", e.BattleNet = "battle-net", e.Bed = "bed", e.Beer = "beer", e.Behance = "behance", e.BehanceSquare = "behance-square", e.Bell = "bell", e.BellSlash = "bell-slash", e.BezierCurve = "bezier-curve", e.Bible = "bible", e.Bicycle = "bicycle", e.Biking = "biking", e.Bimobject = "bimobject", e.Binoculars = "binoculars", e.Biohazard = "biohazard", e.BirthdayCake = "birthday-cake", e.Bitbucket = "bitbucket", e.Bitcoin = "bitcoin", e.Bity = "bity", e.BlackTie = "black-tie", e.Blackberry = "blackberry", e.Blender = "blender", e.BlenderPhone = "blender-phone", e.Blind = "blind", e.Blog = "blog", e.Blogger = "blogger", e.BloggerB = "blogger-b", e.Bluetooth = "bluetooth", e.BluetoothB = "bluetooth-b", e.Bold = "bold", e.Bolt = "bolt", e.Bomb = "bomb", e.Bone = "bone", e.Bong = "bong", e.Book = "book", e.BookDead = "book-dead", e.BookMedical = "book-medical", e.BookOpen = "book-open", e.BookReader = "book-reader", e.Bookmark = "bookmark", e.Bootstrap = "bootstrap", e.BorderAll = "border-all", e.BorderNone = "border-none", e.BorderStyle = "border-style", e.BowlingBall = "bowling-ball", e.Box = "box", e.BoxOpen = "box-open", e.Boxes = "boxes", e.Braille = "braille", e.Brain = "brain", e.BreadSlice = "bread-slice", e.Briefcase = "briefcase", e.BriefcaseMedical = "briefcase-medical", e.BroadcastTower = "broadcast-tower", e.Broom = "broom", e.Brush = "brush", e.Btc = "btc", e.Buffer = "buffer", e.Bug = "bug", e.Building = "building", e.Bullhorn = "bullhorn", e.Bullseye = "bullseye", e.Burn = "burn", e.Buromobelexperte = "buromobelexperte", e.Bus = "bus", e.BusAlt = "bus-alt", e.BusinessTime = "business-time", e.BuyNLarge = "buy-n-large", e.Buysellads = "buysellads", e.Calculator = "calculator", e.Calendar = "calendar", e.CalendarAlt = "calendar-alt", e.CalendarCheck = "calendar-check", e.CalendarDay = "calendar-day", e.CalendarMinus = "calendar-minus", e.CalendarPlus = "calendar-plus", e.CalendarTimes = "calendar-times", e.CalendarWeek = "calendar-week", e.Camera = "camera", e.CameraRetro = "camera-retro", e.Campground = "campground", e.CanadianMapleLeaf = "canadian-maple-leaf", e.CandyCane = "candy-cane", e.Cannabis = "cannabis", e.Capsules = "capsules", e.Car = "car", e.CarAlt = "car-alt", e.CarBattery = "car-battery", e.CarCrash = "car-crash", e.CarSide = "car-side", e.CaretDown = "caret-down", e.CaretLeft = "caret-left", e.CaretRight = "caret-right", e.CaretSquareDown = "caret-square-down", e.CaretSquareLeft = "caret-square-left", e.CaretSquareRight = "caret-square-right", e.CaretSquareUp = "caret-square-up", e.CaretUp = "caret-up", e.Carrot = "carrot", e.CartArrowDown = "cart-arrow-down", e.CartPlus = "cart-plus", e.CashRegister = "cash-register", e.Cat = "cat", e.CcAmazonPay = "cc-amazon-pay", e.CcAmex = "cc-amex", e.CcApplePay = "cc-apple-pay", e.CcDinersClub = "cc-diners-club", e.CcDiscover = "cc-discover", e.CcJcb = "cc-jcb", e.CcMastercard = "cc-mastercard", e.CcPaypal = "cc-paypal", e.CcStripe = "cc-stripe", e.CcVisa = "cc-visa", e.Centercode = "centercode", e.Centos = "centos", e.Certificate = "certificate", e.Chair = "chair", e.Chalkboard = "chalkboard", e.ChalkboardTeacher = "chalkboard-teacher", e.ChargingStation = "charging-station", e.ChartArea = "chart-area", e.ChartBar = "chart-bar", e.ChartLine = "chart-line", e.ChartPie = "chart-pie", e.Check = "check", e.CheckCircle = "check-circle", e.CheckDouble = "check-double", e.CheckSquare = "check-square", e.Cheese = "cheese", e.Chess = "chess", e.ChessBishop = "chess-bishop", e.ChessBoard = "chess-board", e.ChessKing = "chess-king", e.ChessKnight = "chess-knight", e.ChessPawn = "chess-pawn", e.ChessQueen = "chess-queen", e.ChessRook = "chess-rook", e.ChevronCircleDown = "chevron-circle-down", e.ChevronCircleLeft = "chevron-circle-left", e.ChevronCircleRight = "chevron-circle-right", e.ChevronCircleUp = "chevron-circle-up", e.ChevronDown = "chevron-down", e.ChevronLeft = "chevron-left", e.ChevronRight = "chevron-right", e.ChevronUp = "chevron-up", e.Child = "child", e.Chrome = "chrome", e.Chromecast = "chromecast", e.Church = "church", e.Circle = "circle", e.CircleNotch = "circle-notch", e.City = "city", e.ClinicMedical = "clinic-medical", e.Clipboard = "clipboard", e.ClipboardCheck = "clipboard-check", e.ClipboardList = "clipboard-list", e.Clock = "clock", e.Clone = "clone", e.ClosedCaptioning = "closed-captioning", e.Cloud = "cloud", e.CloudDownloadAlt = "cloud-download-alt", e.CloudMeatball = "cloud-meatball", e.CloudMoon = "cloud-moon", e.CloudMoonRain = "cloud-moon-rain", e.CloudRain = "cloud-rain", e.CloudShowersHeavy = "cloud-showers-heavy", e.CloudSun = "cloud-sun", e.CloudSunRain = "cloud-sun-rain", e.CloudUploadAlt = "cloud-upload-alt", e.Cloudscale = "cloudscale", e.Cloudsmith = "cloudsmith", e.Cloudversify = "cloudversify", e.Cocktail = "cocktail", e.Code = "code", e.CodeBranch = "code-branch", e.Codepen = "codepen", e.Codiepie = "codiepie", e.Coffee = "coffee", e.Cog = "cog", e.Cogs = "cogs", e.Coins = "coins", e.Columns = "columns", e.Comment = "comment", e.CommentAlt = "comment-alt", e.CommentDollar = "comment-dollar", e.CommentDots = "comment-dots", e.CommentMedical = "comment-medical", e.CommentSlash = "comment-slash", e.Comments = "comments", e.CommentsDollar = "comments-dollar", e.CompactDisc = "compact-disc", e.Compass = "compass", e.Compress = "compress", e.CompressArrowsAlt = "compress-arrows-alt", e.ConciergeBell = "concierge-bell", e.Confluence = "confluence", e.Connectdevelop = "connectdevelop", e.Contao = "contao", e.Cookie = "cookie", e.CookieBite = "cookie-bite", e.Copy = "copy", e.Copyright = "copyright", e.CottonBureau = "cotton-bureau", e.Couch = "couch", e.Cpanel = "cpanel", e.CreativeCommons = "creative-commons", e.CreativeCommonsBy = "creative-commons-by", e.CreativeCommonsNc = "creative-commons-nc", e.CreativeCommonsNcEu = "creative-commons-nc-eu", e.CreativeCommonsNcJp = "creative-commons-nc-jp", e.CreativeCommonsNd = "creative-commons-nd", e.CreativeCommonsPd = "creative-commons-pd", e.CreativeCommonsPdAlt = "creative-commons-pd-alt", e.CreativeCommonsRemix = "creative-commons-remix", e.CreativeCommonsSa = "creative-commons-sa", e.CreativeCommonsSampling = "creative-commons-sampling", e.CreativeCommonsSamplingPlus = "creative-commons-sampling-plus", e.CreativeCommonsShare = "creative-commons-share", e.CreativeCommonsZero = "creative-commons-zero", e.CreditCard = "credit-card", e.CriticalRole = "critical-role", e.Crop = "crop", e.CropAlt = "crop-alt", e.Cross = "cross", e.Crosshairs = "crosshairs", e.Crow = "crow", e.Crown = "crown", e.Crutch = "crutch", e.Css3 = "css3", e.Css3Alt = "css3-alt", e.Cube = "cube", e.Cubes = "cubes", e.Cut = "cut", e.Cuttlefish = "cuttlefish", e.DAndD = "d-and-d", e.DAndDBeyond = "d-and-d-beyond", e.Dashcube = "dashcube", e.Database = "database", e.Deaf = "deaf", e.Delicious = "delicious", e.Democrat = "democrat", e.Deploydog = "deploydog", e.Deskpro = "deskpro", e.Desktop = "desktop", e.Dev = "dev", e.Deviantart = "deviantart", e.Dharmachakra = "dharmachakra", e.Dhl = "dhl", e.Diagnoses = "diagnoses", e.Diaspora = "diaspora", e.Dice = "dice", e.DiceD20 = "dice-d20", e.DiceD6 = "dice-d6", e.DiceFive = "dice-five", e.DiceFour = "dice-four", e.DiceOne = "dice-one", e.DiceSix = "dice-six", e.DiceThree = "dice-three", e.DiceTwo = "dice-two", e.Digg = "digg", e.DigitalOcean = "digital-ocean", e.DigitalTachograph = "digital-tachograph", e.Directions = "directions", e.Discord = "discord", e.Discourse = "discourse", e.Divide = "divide", e.Dizzy = "dizzy", e.Dna = "dna", e.Dochub = "dochub", e.Docker = "docker", e.Dog = "dog", e.DollarSign = "dollar-sign", e.Dolly = "dolly", e.DollyFlatbed = "dolly-flatbed", e.Donate = "donate", e.DoorClosed = "door-closed", e.DoorOpen = "door-open", e.DotCircle = "dot-circle", e.Dove = "dove", e.Download = "download", e.Draft2digital = "draft2digital", e.DraftingCompass = "drafting-compass", e.Dragon = "dragon", e.DrawPolygon = "draw-polygon", e.Dribbble = "dribbble", e.DribbbleSquare = "dribbble-square", e.Dropbox = "dropbox", e.Drum = "drum", e.DrumSteelpan = "drum-steelpan", e.DrumstickBite = "drumstick-bite", e.Drupal = "drupal", e.Dumbbell = "dumbbell", e.Dumpster = "dumpster", e.DumpsterFire = "dumpster-fire", e.Dungeon = "dungeon", e.Dyalog = "dyalog", e.Earlybirds = "earlybirds", e.Ebay = "ebay", e.Edge = "edge", e.Edit = "edit", e.Egg = "egg", e.Eject = "eject", e.Elementor = "elementor", e.EllipsisH = "ellipsis-h", e.EllipsisV = "ellipsis-v", e.Ello = "ello", e.Ember = "ember", e.Empire = "empire", e.Envelope = "envelope", e.EnvelopeOpen = "envelope-open", e.EnvelopeOpenText = "envelope-open-text", e.EnvelopeSquare = "envelope-square", e.Envira = "envira", e.Equals = "equals", e.Eraser = "eraser", e.Erlang = "erlang", e.Ethereum = "ethereum", e.Ethernet = "ethernet", e.Etsy = "etsy", e.EuroSign = "euro-sign", e.Evernote = "evernote", e.Exchange = "exchange-alt", e.Exclamation = "exclamation", e.ExclamationCircle = "exclamation-circle", e.ExclamationTriangle = "exclamation-triangle", e.Expand = "expand", e.ExpandArrowsAlt = "expand-arrows-alt", e.Expeditedssl = "expeditedssl", e.ExternalLinkAlt = "external-link-alt", e.ExternalLinkSquareAlt = "external-link-square-alt", e.Eye = "eye", e.EyeDropper = "eye-dropper", e.EyeSlash = "eye-slash", e.Facebook = "facebook", e.FacebookF = "facebook-f", e.FacebookMessenger = "facebook-messenger", e.FacebookSquare = "facebook-square", e.Fan = "fan", e.FantasyFlightGames = "fantasy-flight-games", e.FastBackward = "fast-backward", e.FastForward = "fast-forward", e.Fax = "fax", e.Feather = "feather", e.FeatherAlt = "feather-alt", e.Fedex = "fedex", e.Fedora = "fedora", e.Female = "female", e.FighterJet = "fighter-jet", e.Figma = "figma", e.File = "file", e.FileAlt = "file-alt", e.FileArchive = "file-archive", e.FileAudio = "file-audio", e.FileCode = "file-code", e.FileContract = "file-contract", e.FileCsv = "file-csv", e.FileDownload = "file-download", e.FileExcel = "file-excel", e.FileExport = "file-export", e.FileImage = "file-image", e.FileImport = "file-import", e.FileInvoice = "file-invoice", e.FileInvoiceDollar = "file-invoice-dollar", e.FileMedical = "file-medical", e.FileMedicalAlt = "file-medical-alt", e.FilePdf = "file-pdf", e.FilePowerpoint = "file-powerpoint", e.FilePrescription = "file-prescription", e.FileSignature = "file-signature", e.FileUpload = "file-upload", e.FileVideo = "file-video", e.FileWord = "file-word", e.Fill = "fill", e.FillDrip = "fill-drip", e.Film = "film", e.Filter = "filter", e.Fingerprint = "fingerprint", e.Fire = "fire", e.FireAlt = "fire-alt", e.FireExtinguisher = "fire-extinguisher", e.Firefox = "firefox", e.FirstAid = "first-aid", e.FirstOrder = "first-order", e.FirstOrderAlt = "first-order-alt", e.Firstdraft = "firstdraft", e.Fish = "fish", e.FistRaised = "fist-raised", e.Flag = "flag", e.FlagCheckered = "flag-checkered", e.FlagUsa = "flag-usa", e.Flask = "flask", e.Flickr = "flickr", e.Flipboard = "flipboard", e.Flushed = "flushed", e.Fly = "fly", e.Folder = "folder", e.FolderMinus = "folder-minus", e.FolderOpen = "folder-open", e.FolderPlus = "folder-plus", e.Font = "font", e.FontAwesome = "font-awesome", e.FontAwesomeAlt = "font-awesome-alt", e.FontAwesomeFlag = "font-awesome-flag", e.Fonticons = "fonticons", e.FonticonsFi = "fonticons-fi", e.FootballBall = "football-ball", e.FortAwesome = "fort-awesome", e.FortAwesomeAlt = "fort-awesome-alt", e.Forumbee = "forumbee", e.Forward = "forward", e.Foursquare = "foursquare", e.FreeCodeCamp = "free-code-camp", e.Freebsd = "freebsd", e.Frog = "frog", e.Frown = "frown", e.FrownOpen = "frown-open", e.Fulcrum = "fulcrum", e.FunnelDollar = "funnel-dollar", e.Futbol = "futbol", e.GalacticRepublic = "galactic-republic", e.GalacticSenate = "galactic-senate", e.Gamepad = "gamepad", e.GasPump = "gas-pump", e.Gavel = "gavel", e.Gem = "gem", e.Genderless = "genderless", e.GetPocket = "get-pocket", e.Gg = "gg", e.GgCircle = "gg-circle", e.Ghost = "ghost", e.Gift = "gift", e.Gifts = "gifts", e.Git = "git", e.GitAlt = "git-alt", e.GitSquare = "git-square", e.Github = "github", e.GithubAlt = "github-alt", e.GithubSquare = "github-square", e.Gitkraken = "gitkraken", e.Gitlab = "gitlab", e.Gitter = "gitter", e.GlassCheers = "glass-cheers", e.GlassMartini = "glass-martini", e.GlassMartiniAlt = "glass-martini-alt", e.GlassWhiskey = "glass-whiskey", e.Glasses = "glasses", e.Glide = "glide", e.GlideG = "glide-g", e.Globe = "globe", e.GlobeAfrica = "globe-africa", e.GlobeAmericas = "globe-americas", e.GlobeAsia = "globe-asia", e.GlobeEurope = "globe-europe", e.Gofore = "gofore", e.GolfBall = "golf-ball", e.Goodreads = "goodreads", e.GoodreadsG = "goodreads-g", e.Google = "google", e.GoogleDrive = "google-drive", e.GooglePlay = "google-play", e.GooglePlus = "google-plus", e.GooglePlusG = "google-plus-g", e.GooglePlusSquare = "google-plus-square", e.GoogleWallet = "google-wallet", e.Gopuram = "gopuram", e.GraduationCap = "graduation-cap", e.Gratipay = "gratipay", e.Grav = "grav", e.GreaterThan = "greater-than", e.GreaterThanEqual = "greater-than-equal", e.Grimace = "grimace", e.Grin = "grin", e.GrinAlt = "grin-alt", e.GrinBeam = "grin-beam", e.GrinBeamSweat = "grin-beam-sweat", e.GrinHearts = "grin-hearts", e.GrinSquint = "grin-squint", e.GrinSquintTears = "grin-squint-tears", e.GrinStars = "grin-stars", e.GrinTears = "grin-tears", e.GrinTongue = "grin-tongue", e.GrinTongueSquint = "grin-tongue-squint", e.GrinTongueWink = "grin-tongue-wink", e.GrinWink = "grin-wink", e.GripHorizontal = "grip-horizontal", e.GripLines = "grip-lines", e.GripLinesVertical = "grip-lines-vertical", e.GripVertical = "grip-vertical", e.Gripfire = "gripfire", e.Grunt = "grunt", e.Guitar = "guitar", e.Gulp = "gulp", e.HSquare = "h-square", e.HackerNews = "hacker-news", e.HackerNewsSquare = "hacker-news-square", e.Hackerrank = "hackerrank", e.Hamburger = "hamburger", e.Hammer = "hammer", e.Hamsa = "hamsa", e.HandHolding = "hand-holding", e.HandHoldingHeart = "hand-holding-heart", e.HandHoldingUsd = "hand-holding-usd", e.HandLizard = "hand-lizard", e.HandMiddleFinger = "hand-middle-finger", e.HandPaper = "hand-paper", e.HandPeace = "hand-peace", e.HandPointDown = "hand-point-down", e.HandPointLeft = "hand-point-left", e.HandPointRight = "hand-point-right", e.HandPointUp = "hand-point-up", e.HandPointer = "hand-pointer", e.HandRock = "hand-rock", e.HandScissors = "hand-scissors", e.HandSpock = "hand-spock", e.Hands = "hands", e.HandsHelping = "hands-helping", e.Handshake = "handshake", e.Hanukiah = "hanukiah", e.HardHat = "hard-hat", e.Hashtag = "hashtag", e.HatCowboy = "hat-cowboy", e.HatCowboySide = "hat-cowboy-side", e.HatWizard = "hat-wizard", e.Haykal = "haykal", e.Hdd = "hdd", e.Heading = "heading", e.Headphones = "headphones", e.HeadphonesAlt = "headphones-alt", e.Headset = "headset", e.Heart = "heart", e.HeartBroken = "heart-broken", e.Heartbeat = "heartbeat", e.Helicopter = "helicopter", e.Highlighter = "highlighter", e.Hiking = "hiking", e.Hippo = "hippo", e.Hips = "hips", e.HireAHelper = "hire-a-helper", e.History = "history", e.HockeyPuck = "hockey-puck", e.HollyBerry = "holly-berry", e.Home = "home", e.Hooli = "hooli", e.Hornbill = "hornbill", e.Horse = "horse", e.HorseHead = "horse-head", e.Hospital = "hospital", e.HospitalAlt = "hospital-alt", e.HospitalSymbol = "hospital-symbol", e.HotTub = "hot-tub", e.Hotdog = "hotdog", e.Hotel = "hotel", e.Hotjar = "hotjar", e.Hourglass = "hourglass", e.HourglassEnd = "hourglass-end", e.HourglassHalf = "hourglass-half", e.HourglassStart = "hourglass-start", e.HouseDamage = "house-damage", e.Houzz = "houzz", e.Hryvnia = "hryvnia", e.Html5 = "html5", e.Hubspot = "hubspot", e.ICursor = "i-cursor", e.IceCream = "ice-cream", e.Icicles = "icicles", e.Icons = "icons", e.IdBadge = "id-badge", e.IdCard = "id-card", e.IdCardAlt = "id-card-alt", e.Igloo = "igloo", e.Image = "image", e.Images = "images", e.Imdb = "imdb", e.Inbox = "inbox", e.Indent = "indent", e.Industry = "industry", e.Info = "info", e.InfoCircle = "info-circle", e.Instagram = "instagram", e.Intercom = "intercom", e.InternetExplorer = "internet-explorer", e.Invision = "invision", e.Ioxhost = "ioxhost", e.Italic = "italic", e.ItchIo = "itch-io", e.Itunes = "itunes", e.ItunesNote = "itunes-note", e.Java = "java", e.Jedi = "jedi", e.JediOrder = "jedi-order", e.Jenkins = "jenkins", e.Jira = "jira", e.Joget = "joget", e.Joint = "joint", e.Joomla = "joomla", e.JournalWhills = "journal-whills", e.Js = "js", e.JsSquare = "js-square", e.Jsfiddle = "jsfiddle", e.Kaaba = "kaaba", e.Kaggle = "kaggle", e.Key = "key", e.Keybase = "keybase", e.Keyboard = "keyboard", e.Keycdn = "keycdn", e.Khanda = "khanda", e.Kickstarter = "kickstarter", e.KickstarterK = "kickstarter-k", e.Kiss = "kiss", e.KissBeam = "kiss-beam", e.KissWinkHeart = "kiss-wink-heart", e.KiwiBird = "kiwi-bird", e.Korvue = "korvue", e.Landmark = "landmark", e.Language = "language", e.Laptop = "laptop", e.LaptopCode = "laptop-code", e.LaptopMedical = "laptop-medical", e.Laravel = "laravel", e.Lastfm = "lastfm", e.LastfmSquare = "lastfm-square", e.Laugh = "laugh", e.LaughBeam = "laugh-beam", e.LaughSquint = "laugh-squint", e.LaughWink = "laugh-wink", e.LayerGroup = "layer-group", e.Leaf = "leaf", e.Leanpub = "leanpub", e.Lemon = "lemon", e.Less = "less", e.LessThan = "less-than", e.LessThanEqual = "less-than-equal", e.LevelDownAlt = "level-down-alt", e.LevelUpAlt = "level-up-alt", e.LifeRing = "life-ring", e.Lightbulb = "lightbulb", e.Line = "line", e.Link = "link", e.Linkedin = "linkedin", e.LinkedinIn = "linkedin-in", e.Linode = "linode", e.Linux = "linux", e.LiraSign = "lira-sign", e.List = "list", e.ListAlt = "list-alt", e.ListOl = "list-ol", e.ListUl = "list-ul", e.LocationArrow = "location-arrow", e.Lock = "lock", e.LockOpen = "lock-open", e.LongArrowAltDown = "long-arrow-alt-down", e.LongArrowAltLeft = "long-arrow-alt-left", e.LongArrowAltRight = "long-arrow-alt-right", e.LongArrowAltUp = "long-arrow-alt-up", e.LowVision = "low-vision", e.LuggageCart = "luggage-cart", e.Lyft = "lyft", e.Magento = "magento", e.Magic = "magic", e.Magnet = "magnet", e.MailBulk = "mail-bulk", e.Mailchimp = "mailchimp", e.Male = "male", e.Mandalorian = "mandalorian", e.Map = "map", e.MapMarked = "map-marked", e.MapMarkedAlt = "map-marked-alt", e.MapMarker = "map-marker", e.MapMarkerAlt = "map-marker-alt", e.MapPin = "map-pin", e.MapSigns = "map-signs", e.Markdown = "markdown", e.Marker = "marker", e.Mars = "mars", e.MarsDouble = "mars-double", e.MarsStroke = "mars-stroke", e.MarsStrokeH = "mars-stroke-h", e.MarsStrokeV = "mars-stroke-v", e.Mask = "mask", e.Mastodon = "mastodon", e.Maxcdn = "maxcdn", e.Mdb = "mdb", e.Medal = "medal", e.Medapps = "medapps", e.Medium = "medium", e.MediumM = "medium-m", e.Medkit = "medkit", e.Medrt = "medrt", e.Meetup = "meetup", e.Megaport = "megaport", e.Meh = "meh", e.MehBlank = "meh-blank", e.MehRollingEyes = "meh-rolling-eyes", e.Memory = "memory", e.Mendeley = "mendeley", e.Menorah = "menorah", e.Mercury = "mercury", e.Meteor = "meteor", e.Microchip = "microchip", e.Microphone = "microphone", e.MicrophoneAlt = "microphone-alt", e.MicrophoneAltSlash = "microphone-alt-slash", e.MicrophoneSlash = "microphone-slash", e.Microscope = "microscope", e.Microsoft = "microsoft", e.Minus = "minus", e.MinusCircle = "minus-circle", e.MinusSquare = "minus-square", e.Mitten = "mitten", e.Mix = "mix", e.Mixcloud = "mixcloud", e.Mizuni = "mizuni", e.Mobile = "mobile", e.MobileAlt = "mobile-alt", e.Modx = "modx", e.Monero = "monero", e.MoneyBill = "money-bill", e.MoneyBillAlt = "money-bill-alt", e.MoneyBillWave = "money-bill-wave", e.MoneyBillWaveAlt = "money-bill-wave-alt", e.MoneyCheck = "money-check", e.MoneyCheckAlt = "money-check-alt", e.Monument = "monument", e.Moon = "moon", e.MortarPestle = "mortar-pestle", e.Mosque = "mosque", e.Motorcycle = "motorcycle", e.Mountain = "mountain", e.Mouse = "mouse", e.MousePointer = "mouse-pointer", e.MugHot = "mug-hot", e.Music = "music", e.Napster = "napster", e.Neos = "neos", e.NetworkWired = "network-wired", e.Neuter = "neuter", e.Newspaper = "newspaper", e.Nimblr = "nimblr", e.Node = "node", e.NodeJs = "node-js", e.NotEqual = "not-equal", e.NotesMedical = "notes-medical", e.Npm = "npm", e.Ns8 = "ns8", e.Nutritionix = "nutritionix", e.ObjectGroup = "object-group", e.ObjectUngroup = "object-ungroup", e.Odnoklassniki = "odnoklassniki", e.OdnoklassnikiSquare = "odnoklassniki-square", e.OilCan = "oil-can", e.OldRepublic = "old-republic", e.Om = "om", e.Opencart = "opencart", e.Openid = "openid", e.Opera = "opera", e.OptinMonster = "optin-monster", e.Orcid = "orcid", e.Osi = "osi", e.Otter = "otter", e.Outdent = "outdent", e.Page4 = "page4", e.Pagelines = "pagelines", e.Pager = "pager", e.PaintBrush = "paint-brush", e.PaintRoller = "paint-roller", e.Palette = "palette", e.Palfed = "palfed", e.Pallet = "pallet", e.PaperPlane = "paper-plane", e.Paperclip = "paperclip", e.ParachuteBox = "parachute-box", e.Paragraph = "paragraph", e.Parking = "parking", e.Passport = "passport", e.Pastafarianism = "pastafarianism", e.Paste = "paste", e.Patreon = "patreon", e.Pause = "pause", e.PauseCircle = "pause-circle", e.Paw = "paw", e.Paypal = "paypal", e.Peace = "peace", e.Pen = "pen", e.PenAlt = "pen-alt", e.PenFancy = "pen-fancy", e.PenNib = "pen-nib", e.PenSquare = "pen-square", e.PencilAlt = "pencil-alt", e.PencilRuler = "pencil-ruler", e.PennyArcade = "penny-arcade", e.PeopleCarry = "people-carry", e.PepperHot = "pepper-hot", e.Percent = "percent", e.Percentage = "percentage", e.Periscope = "periscope", e.PersonBooth = "person-booth", e.Phabricator = "phabricator", e.PhoenixFramework = "phoenix-framework", e.PhoenixSquadron = "phoenix-squadron", e.Phone = "phone", e.PhoneAlt = "phone-alt", e.PhoneSlash = "phone-slash", e.PhoneSquare = "phone-square", e.PhoneSquareAlt = "phone-square-alt", e.PhoneVolume = "phone-volume", e.PhotoVideo = "photo-video", e.Php = "php", e.PiedPiper = "pied-piper", e.PiedPiperAlt = "pied-piper-alt", e.PiedPiperHat = "pied-piper-hat", e.PiedPiperPp = "pied-piper-pp", e.PiggyBank = "piggy-bank", e.Pills = "pills", e.Pinterest = "pinterest", e.PinterestP = "pinterest-p", e.PinterestSquare = "pinterest-square", e.PizzaSlice = "pizza-slice", e.PlaceOfWorship = "place-of-worship", e.Plane = "plane", e.PlaneArrival = "plane-arrival", e.PlaneDeparture = "plane-departure", e.Play = "play", e.PlayCircle = "play-circle", e.Playstation = "playstation", e.Plug = "plug", e.Plus = "plus", e.PlusCircle = "plus-circle", e.PlusSquare = "plus-square", e.Podcast = "podcast", e.Poll = "poll", e.PollH = "poll-h", e.Poo = "poo", e.PooStorm = "poo-storm", e.Poop = "poop", e.Portrait = "portrait", e.PoundSign = "pound-sign", e.PowerOff = "power-off", e.Pray = "pray", e.PrayingHands = "praying-hands", e.Prescription = "prescription", e.PrescriptionBottle = "prescription-bottle", e.PrescriptionBottleAlt = "prescription-bottle-alt", e.Print = "print", e.Procedures = "procedures", e.ProductHunt = "product-hunt", e.ProjectDiagram = "project-diagram", e.Pushed = "pushed", e.PuzzlePiece = "puzzle-piece", e.Python = "python", e.Qq = "qq", e.Qrcode = "qrcode", e.Question = "question", e.QuestionCircle = "question-circle", e.Quidditch = "quidditch", e.Quinscape = "quinscape", e.Quora = "quora", e.QuoteLeft = "quote-left", e.QuoteRight = "quote-right", e.Quran = "quran", e.RProject = "r-project", e.Radiation = "radiation", e.RadiationAlt = "radiation-alt", e.Rainbow = "rainbow", e.Random = "random", e.RaspberryPi = "raspberry-pi", e.Ravelry = "ravelry", e.React = "react", e.Reacteurope = "reacteurope", e.Readme = "readme", e.Rebel = "rebel", e.Receipt = "receipt", e.RecordVinyl = "record-vinyl", e.Recycle = "recycle", e.RedRiver = "red-river", e.Reddit = "reddit", e.RedditAlien = "reddit-alien", e.RedditSquare = "reddit-square", e.Redhat = "redhat", e.Redo = "redo", e.RedoAlt = "redo-alt", e.Registered = "registered", e.RemoveFormat = "remove-format", e.Renren = "renren", e.Reply = "reply", e.ReplyAll = "reply-all", e.Replyd = "replyd", e.Republican = "republican", e.Researchgate = "researchgate", e.Resolving = "resolving", e.Restroom = "restroom", e.Retweet = "retweet", e.Rev = "rev", e.Ribbon = "ribbon", e.Ring = "ring", e.Road = "road", e.Robot = "robot", e.Rocket = "rocket", e.Rocketchat = "rocketchat", e.Rockrms = "rockrms", e.Route = "route", e.Rss = "rss", e.RssSquare = "rss-square", e.RubleSign = "ruble-sign", e.Ruler = "ruler", e.RulerCombined = "ruler-combined", e.RulerHorizontal = "ruler-horizontal", e.RulerVertical = "ruler-vertical", e.Running = "running", e.RupeeSign = "rupee-sign", e.SadCry = "sad-cry", e.SadTear = "sad-tear", e.Safari = "safari", e.Salesforce = "salesforce", e.Sass = "sass", e.Satellite = "satellite", e.SatelliteDish = "satellite-dish", e.Save = "save", e.Schlix = "schlix", e.School = "school", e.Screwdriver = "screwdriver", e.Scribd = "scribd", e.Scroll = "scroll", e.SdCard = "sd-card", e.Search = "search", e.SearchDollar = "search-dollar", e.SearchLocation = "search-location", e.SearchMinus = "search-minus", e.SearchPlus = "search-plus", e.Searchengin = "searchengin", e.Seedling = "seedling", e.Sellcast = "sellcast", e.Sellsy = "sellsy", e.Server = "server", e.Servicestack = "servicestack", e.Shapes = "shapes", e.Share = "share", e.ShareAlt = "share-alt", e.ShareAltSquare = "share-alt-square", e.ShareSquare = "share-square", e.ShekelSign = "shekel-sign", e.ShieldAlt = "shield-alt", e.Ship = "ship", e.ShippingFast = "shipping-fast", e.Shirtsinbulk = "shirtsinbulk", e.ShoePrints = "shoe-prints", e.ShoppingBag = "shopping-bag", e.ShoppingBasket = "shopping-basket", e.ShoppingCart = "shopping-cart", e.Shopware = "shopware", e.Shower = "shower", e.ShuttleVan = "shuttle-van", e.Sign = "sign", e.SignInAlt = "sign-in-alt", e.SignLanguage = "sign-language", e.SignOutAlt = "sign-out-alt", e.Signal = "signal", e.Signature = "signature", e.SimCard = "sim-card", e.Simplybuilt = "simplybuilt", e.Sistrix = "sistrix", e.Sitemap = "sitemap", e.Sith = "sith", e.Skating = "skating", e.Sketch = "sketch", e.Skiing = "skiing", e.SkiingNordic = "skiing-nordic", e.Skull = "skull", e.SkullCrossbones = "skull-crossbones", e.Skyatlas = "skyatlas", e.Skype = "skype", e.Slack = "slack", e.SlackHash = "slack-hash", e.Slash = "slash", e.Sleigh = "sleigh", e.SlidersH = "sliders-h", e.Slideshare = "slideshare", e.Smile = "smile", e.SmileBeam = "smile-beam", e.SmileWink = "smile-wink", e.Smog = "smog", e.Smoking = "smoking", e.SmokingBan = "smoking-ban", e.Sms = "sms", e.Snapchat = "snapchat", e.SnapchatGhost = "snapchat-ghost", e.SnapchatSquare = "snapchat-square", e.Snowboarding = "snowboarding", e.Snowflake = "snowflake", e.Snowman = "snowman", e.Snowplow = "snowplow", e.Socks = "socks", e.SolarPanel = "solar-panel", e.Sort = "sort", e.SortAlphaDown = "sort-alpha-down", e.SortAlphaDownAlt = "sort-alpha-down-alt", e.SortAlphaUp = "sort-alpha-up", e.SortAlphaUpAlt = "sort-alpha-up-alt", e.SortAmountDown = "sort-amount-down", e.SortAmountDownAlt = "sort-amount-down-alt", e.SortAmountUp = "sort-amount-up", e.SortAmountUpAlt = "sort-amount-up-alt", e.SortDown = "sort-down", e.SortNumericDown = "sort-numeric-down", e.SortNumericDownAlt = "sort-numeric-down-alt", e.SortNumericUp = "sort-numeric-up", e.SortNumericUpAlt = "sort-numeric-up-alt", e.SortUp = "sort-up", e.Soundcloud = "soundcloud", e.Sourcetree = "sourcetree", e.Spa = "spa", e.SpaceShuttle = "space-shuttle", e.Speakap = "speakap", e.SpeakerDeck = "speaker-deck", e.SpellCheck = "spell-check", e.Spider = "spider", e.Spinner = "spinner", e.Splotch = "splotch", e.Spotify = "spotify", e.SprayCan = "spray-can", e.Square = "square", e.SquareFull = "square-full", e.SquareRootAlt = "square-root-alt", e.Squarespace = "squarespace", e.StackExchange = "stack-exchange", e.StackOverflow = "stack-overflow", e.Stackpath = "stackpath", e.Stamp = "stamp", e.Star = "star", e.StarAndCrescent = "star-and-crescent", e.StarHalf = "star-half", e.StarHalfAlt = "star-half-alt", e.StarOfDavid = "star-of-david", e.StarOfLife = "star-of-life", e.Staylinked = "staylinked", e.Steam = "steam", e.SteamSquare = "steam-square", e.SteamSymbol = "steam-symbol", e.StepBackward = "step-backward", e.StepForward = "step-forward", e.Stethoscope = "stethoscope", e.StickerMule = "sticker-mule", e.StickyNote = "sticky-note", e.Stop = "stop", e.StopCircle = "stop-circle", e.Stopwatch = "stopwatch", e.Store = "store", e.StoreAlt = "store-alt", e.Strava = "strava", e.Stream = "stream", e.StreetView = "street-view", e.Strikethrough = "strikethrough", e.Stripe = "stripe", e.StripeS = "stripe-s", e.Stroopwafel = "stroopwafel", e.Studiovinari = "studiovinari", e.Stumbleupon = "stumbleupon", e.StumbleuponCircle = "stumbleupon-circle", e.Subscript = "subscript", e.Subway = "subway", e.Suitcase = "suitcase", e.SuitcaseRolling = "suitcase-rolling", e.Sun = "sun", e.Superpowers = "superpowers", e.Superscript = "superscript", e.Supple = "supple", e.Surprise = "surprise", e.Suse = "suse", e.Swatchbook = "swatchbook", e.Swift = "swift", e.Swimmer = "swimmer", e.SwimmingPool = "swimming-pool", e.Symfony = "symfony", e.Synagogue = "synagogue", e.Sync = "sync", e.SyncAlt = "sync-alt", e.Syringe = "syringe", e.Table = "table", e.TableTennis = "table-tennis", e.Tablet = "tablet", e.TabletAlt = "tablet-alt", e.Tablets = "tablets", e.TachometerAlt = "tachometer-alt", e.Tag = "tag", e.Tags = "tags", e.Tape = "tape", e.Tasks = "tasks", e.Taxi = "taxi", e.Teamspeak = "teamspeak", e.Teeth = "teeth", e.TeethOpen = "teeth-open", e.Telegram = "telegram", e.TelegramPlane = "telegram-plane", e.TemperatureHigh = "temperature-high", e.TemperatureLow = "temperature-low", e.TencentWeibo = "tencent-weibo", e.Tenge = "tenge", e.Terminal = "terminal", e.TextHeight = "text-height", e.TextWidth = "text-width", e.Th = "th", e.ThLarge = "th-large", e.ThList = "th-list", e.TheRedYeti = "the-red-yeti", e.TheaterMasks = "theater-masks", e.Themeco = "themeco", e.Themeisle = "themeisle", e.Thermometer = "thermometer", e.ThermometerEmpty = "thermometer-empty", e.ThermometerFull = "thermometer-full", e.ThermometerHalf = "thermometer-half", e.ThermometerQuarter = "thermometer-quarter", e.ThermometerThreeQuarters = "thermometer-three-quarters", e.ThinkPeaks = "think-peaks", e.ThumbsDown = "thumbs-down", e.ThumbsUp = "thumbs-up", e.Thumbtack = "thumbtack", e.TicketAlt = "ticket-alt", e.Times = "times", e.TimesCircle = "times-circle", e.Tint = "tint", e.TintSlash = "tint-slash", e.Tired = "tired", e.ToggleOff = "toggle-off", e.ToggleOn = "toggle-on", e.Toilet = "toilet", e.ToiletPaper = "toilet-paper", e.Toolbox = "toolbox", e.Tools = "tools", e.Tooth = "tooth", e.Torah = "torah", e.ToriiGate = "torii-gate", e.Tractor = "tractor", e.TradeFederation = "trade-federation", e.Trademark = "trademark", e.TrafficLight = "traffic-light", e.Train = "train", e.Tram = "tram", e.Transgender = "transgender", e.TransgenderAlt = "transgender-alt", e.Trash = "trash", e.TrashAlt = "trash-alt", e.TrashRestore = "trash-restore", e.TrashRestoreAlt = "trash-restore-alt", e.Tree = "tree", e.Trello = "trello", e.Tripadvisor = "tripadvisor", e.Trophy = "trophy", e.Truck = "truck", e.TruckLoading = "truck-loading", e.TruckMonster = "truck-monster", e.TruckMoving = "truck-moving", e.TruckPickup = "truck-pickup", e.Tshirt = "tshirt", e.Tty = "tty", e.Tumblr = "tumblr", e.TumblrSquare = "tumblr-square", e.Tv = "tv", e.Twitch = "twitch", e.Twitter = "twitter", e.TwitterSquare = "twitter-square", e.Typo3 = "typo3", e.Uber = "uber", e.Ubuntu = "ubuntu", e.Uikit = "uikit", e.Umbraco = "umbraco", e.Umbrella = "umbrella", e.UmbrellaBeach = "umbrella-beach", e.Underline = "underline", e.Undo = "undo", e.UndoAlt = "undo-alt", e.Uniregistry = "uniregistry", e.UniversalAccess = "universal-access", e.University = "university", e.Unlink = "unlink", e.Unlock = "unlock", e.UnlockAlt = "unlock-alt", e.Untappd = "untappd", e.Upload = "upload", e.Ups = "ups", e.Usb = "usb", e.User = "user", e.UserAlt = "user-alt", e.UserAltSlash = "user-alt-slash", e.UserAstronaut = "user-astronaut", e.UserCheck = "user-check", e.UserCircle = "user-circle", e.UserClock = "user-clock", e.UserCog = "user-cog", e.UserEdit = "user-edit", e.UserFriends = "user-friends", e.UserGraduate = "user-graduate", e.UserInjured = "user-injured", e.UserLock = "user-lock", e.UserMd = "user-md", e.UserMinus = "user-minus", e.UserNinja = "user-ninja", e.UserNurse = "user-nurse", e.UserPlus = "user-plus", e.UserSecret = "user-secret", e.UserShield = "user-shield", e.UserSlash = "user-slash", e.UserTag = "user-tag", e.UserTie = "user-tie", e.UserTimes = "user-times", e.Users = "users", e.UsersCog = "users-cog", e.Usps = "usps", e.Ussunnah = "ussunnah", e.UtensilSpoon = "utensil-spoon", e.Utensils = "utensils", e.Vaadin = "vaadin", e.VectorSquare = "vector-square", e.Venus = "venus", e.VenusDouble = "venus-double", e.VenusMars = "venus-mars", e.Viacoin = "viacoin", e.Viadeo = "viadeo", e.ViadeoSquare = "viadeo-square", e.Vial = "vial", e.Vials = "vials", e.Viber = "viber", e.Video = "video", e.VideoSlash = "video-slash", e.Vihara = "vihara", e.Vimeo = "vimeo", e.VimeoSquare = "vimeo-square", e.VimeoV = "vimeo-v", e.Vine = "vine", e.Vk = "vk", e.Vnv = "vnv", e.Voicemail = "voicemail", e.VolleyballBall = "volleyball-ball", e.VolumeDown = "volume-down", e.VolumeMute = "volume-mute", e.VolumeOff = "volume-off", e.VolumeUp = "volume-up", e.VoteYea = "vote-yea", e.VrCardboard = "vr-cardboard", e.Vuejs = "vuejs", e.Walking = "walking", e.Wallet = "wallet", e.Warehouse = "warehouse", e.Water = "water", e.WaveSquare = "wave-square", e.Waze = "waze", e.Weebly = "weebly", e.Weibo = "weibo", e.Weight = "weight", e.WeightHanging = "weight-hanging", e.Weixin = "weixin", e.Whatsapp = "whatsapp", e.WhatsappSquare = "whatsapp-square", e.Wheelchair = "wheelchair", e.Whmcs = "whmcs", e.Wifi = "wifi", e.WikipediaW = "wikipedia-w", e.Wind = "wind", e.WindowClose = "window-close", e.WindowMaximize = "window-maximize", e.WindowMinimize = "window-minimize", e.WindowRestore = "window-restore", e.Windows = "windows", e.WineBottle = "wine-bottle", e.WineGlass = "wine-glass", e.WineGlassAlt = "wine-glass-alt", e.Wix = "wix", e.WizardsOfTheCoast = "wizards-of-the-coast", e.WolfPackBattalion = "wolf-pack-battalion", e.WonSign = "won-sign", e.Wordpress = "wordpress", e.WordpressSimple = "wordpress-simple", e.Wpbeginner = "wpbeginner", e.Wpexplorer = "wpexplorer", e.Wpforms = "wpforms", e.Wpressr = "wpressr", e.Wrench = "wrench", e.XRay = "x-ray", e.Xbox = "xbox", e.Xing = "xing", e.XingSquare = "xing-square", e.YCombinator = "y-combinator", e.Yahoo = "yahoo", e.Yammer = "yammer", e.Yandex = "yandex", e.YandexInternational = "yandex-international", e.Yarn = "yarn", e.Yelp = "yelp", e.YenSign = "yen-sign", e.YinYang = "yin-yang", e.Yoast = "yoast", e.Youtube = "youtube", e.YoutubeSquare = "youtube-square", e.Zhihu = "zhihu", e))(H || {}), gt = /* @__PURE__ */ ((e) => (e.Default = "default", e.White = "white", e.Negative = "negative", e.Inherit = "inherit", e.Positive = "positive", e.Success = "success", e.GreyBlue003 = "greyBlue003", e.GreyBlue005 = "greyBlue005", e.GreyBlue008 = "greyBlue008", e.GreyBlue009 = "greyBlue009", e.Petrol45 = "petrol45", e.Petrol55 = "petrol55", e.LeafGreen = "leaf-green", e.SkyBlue = "sky-blue", e.OceanBlue = "ocean-blue", e.SustainedGreen = "sustained-green", e.ProgPurple = "prog-purple", e.Amber = "amber", e.Pink = "pink", e))(gt || {}), et = /* @__PURE__ */ ((e) => (e.Large = "large", e.Medium = "medium", e.Small = "small", e.XSmall = "x-small", e.XXSmall = "xx-small", e.Inherit = "inherit", e))(et || {}), Ke = /* @__PURE__ */ ((e) => (e.Primary = "primary", e.Secondary = "secondary", e.Tertiary = "tertiary", e.Ghost = "ghost", e.RoundedPrimary = "rounded-primary", e.RoundedSecondary = "rounded-secondary", e.RoundedTertiary = "rounded-tertiary", e.RoundedGhost = "rounded-ghost", e.RoundedNonFilled = "rounded-non-filled", e.RoundedSocial = "rounded-social", e.Unstyled = "unstyled", e))(Ke || {}), zt = /* @__PURE__ */ ((e) => (e.Link = "link", e.Button = "button", e))(zt || {}), ct = /* @__PURE__ */ ((e) => (e.Left = "left", e.Right = "right", e))(ct || {});
const md = {
  "xx-small": at.NextToText,
  "x-small": at.NextToText,
  small: at.NextToText,
  medium: at.NextToText,
  large: at.NextToText,
  inherit: at.NextToText
}, SA = [
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.FiveHundredPx
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.AccessibleIcon
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Accusoft
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.AcquisitionsIncorporated
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Ad
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.AddressBook
  },
  {
    BaseIconStyle: K.Lar,
    BaseIconType: H.AddressBook
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.AddressCard
  },
  {
    BaseIconStyle: K.Lar,
    BaseIconType: H.AddressCard
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Adjust
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Adn
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Adobe
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Adversal
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Affiliatetheme
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.AirFreshener
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Airbnb
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Algolia
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.AlignCenter
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.AlignJustify
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.AlignLeft
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.AlignRight
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Alipay
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Allergies
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.AmazonPay
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Amazon
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Ambulance
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.AmericanSignLanguageInterpreting
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Amilia
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Anchor
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Android
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Angellist
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.AngleDoubleDown
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.AngleDoubleLeft
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.AngleDoubleRight
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.AngleDoubleUp
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.AngleDown
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.AngleLeft
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.AngleRight
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.AngleUp
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Angry
  },
  {
    BaseIconStyle: K.Lar,
    BaseIconType: H.Angry
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Angrycreative
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Angular
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Ankh
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.AppStoreIos
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.AppStore
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Apper
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.AppleAlt
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.ApplePay
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Apple
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Archive
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Archway
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.ArrowAltCircleDown
  },
  {
    BaseIconStyle: K.Lar,
    BaseIconType: H.ArrowAltCircleDown
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.ArrowAltCircleLeft
  },
  {
    BaseIconStyle: K.Lar,
    BaseIconType: H.ArrowAltCircleLeft
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.ArrowAltCircleRight
  },
  {
    BaseIconStyle: K.Lar,
    BaseIconType: H.ArrowAltCircleRight
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.ArrowAltCircleUp
  },
  {
    BaseIconStyle: K.Lar,
    BaseIconType: H.ArrowAltCircleUp
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.ArrowCircleDown
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.ArrowCircleLeft
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.ArrowCircleRight
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.ArrowCircleUp
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.ArrowDown
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.ArrowLeft
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.ArrowRight
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.ArrowUp
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.ArrowsAltH
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.ArrowsAlt
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.ArrowsAltV
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Artstation
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.AssistiveListeningSystems
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Asterisk
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Asymmetrik
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.At
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Atlas
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Atlassian
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Atom
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Audible
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.AudioDescription
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Autoprefixer
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Avianex
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Aviato
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Award
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Aws
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.BabyCarriage
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Baby
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Backspace
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Backward
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Bacon
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.BalanceScaleLeft
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.BalanceScaleRight
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.BalanceScale
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Ban
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.BandAid
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Bandcamp
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Barcode
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Bars
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.BaseballBall
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.BasketballBall
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Bath
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.BatteryEmpty
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.BatteryFull
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.BatteryHalf
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.BatteryQuarter
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.BatteryThreeQuarters
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.BattleNet
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Bed
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Beer
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.BehanceSquare
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Behance
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.BellSlash
  },
  {
    BaseIconStyle: K.Lar,
    BaseIconType: H.BellSlash
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Bell
  },
  {
    BaseIconStyle: K.Lar,
    BaseIconType: H.Bell
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.BezierCurve
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Bible
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Bicycle
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Biking
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Bimobject
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Binoculars
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Biohazard
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.BirthdayCake
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Bitbucket
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Bitcoin
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Bity
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.BlackTie
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Blackberry
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.BlenderPhone
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Blender
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Blind
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Blog
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.BloggerB
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Blogger
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.BluetoothB
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Bluetooth
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Bold
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Bolt
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Bomb
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Bone
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Bong
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.BookDead
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.BookMedical
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.BookOpen
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.BookReader
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Book
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Bookmark
  },
  {
    BaseIconStyle: K.Lar,
    BaseIconType: H.Bookmark
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Bootstrap
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.BorderAll
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.BorderNone
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.BorderStyle
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.BowlingBall
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.BoxOpen
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Box
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Boxes
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Braille
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Brain
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.BreadSlice
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.BriefcaseMedical
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Briefcase
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.BroadcastTower
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Broom
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Brush
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Btc
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Buffer
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Bug
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Building
  },
  {
    BaseIconStyle: K.Lar,
    BaseIconType: H.Building
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Bullhorn
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Bullseye
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Burn
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Buromobelexperte
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.BusAlt
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Bus
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.BusinessTime
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.BuyNLarge
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Buysellads
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Calculator
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.CalendarAlt
  },
  {
    BaseIconStyle: K.Lar,
    BaseIconType: H.CalendarAlt
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.CalendarCheck
  },
  {
    BaseIconStyle: K.Lar,
    BaseIconType: H.CalendarCheck
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.CalendarDay
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.CalendarMinus
  },
  {
    BaseIconStyle: K.Lar,
    BaseIconType: H.CalendarMinus
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.CalendarPlus
  },
  {
    BaseIconStyle: K.Lar,
    BaseIconType: H.CalendarPlus
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Calendar
  },
  {
    BaseIconStyle: K.Lar,
    BaseIconType: H.Calendar
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.CalendarTimes
  },
  {
    BaseIconStyle: K.Lar,
    BaseIconType: H.CalendarTimes
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.CalendarWeek
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.CameraRetro
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Camera
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Campground
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.CanadianMapleLeaf
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.CandyCane
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Cannabis
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Capsules
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.CarAlt
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.CarBattery
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.CarCrash
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.CarSide
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Car
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.CaretDown
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.CaretLeft
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.CaretRight
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.CaretSquareDown
  },
  {
    BaseIconStyle: K.Lar,
    BaseIconType: H.CaretSquareDown
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.CaretSquareLeft
  },
  {
    BaseIconStyle: K.Lar,
    BaseIconType: H.CaretSquareLeft
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.CaretSquareRight
  },
  {
    BaseIconStyle: K.Lar,
    BaseIconType: H.CaretSquareRight
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.CaretSquareUp
  },
  {
    BaseIconStyle: K.Lar,
    BaseIconType: H.CaretSquareUp
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.CaretUp
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Carrot
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.CartArrowDown
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.CartPlus
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.CashRegister
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Cat
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.CcAmazonPay
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.CcAmex
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.CcApplePay
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.CcDinersClub
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.CcDiscover
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.CcJcb
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.CcMastercard
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.CcPaypal
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.CcStripe
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.CcVisa
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Centercode
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Centos
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Certificate
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Chair
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Chalkboard
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.ChalkboardTeacher
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.ChargingStation
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.ChartArea
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.ChartBar
  },
  {
    BaseIconStyle: K.Lar,
    BaseIconType: H.ChartBar
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.ChartLine
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.ChartPie
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.CheckCircle
  },
  {
    BaseIconStyle: K.Lar,
    BaseIconType: H.CheckCircle
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.CheckDouble
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Check
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.CheckSquare
  },
  {
    BaseIconStyle: K.Lar,
    BaseIconType: H.CheckSquare
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Cheese
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.ChessBishop
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.ChessBoard
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.ChessKing
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.ChessKnight
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.ChessPawn
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.ChessQueen
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.ChessRook
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Chess
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.ChevronCircleDown
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.ChevronCircleLeft
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.ChevronCircleRight
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.ChevronCircleUp
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.ChevronDown
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.ChevronLeft
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.ChevronRight
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.ChevronUp
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Child
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Chrome
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Chromecast
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Church
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.CircleNotch
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Circle
  },
  {
    BaseIconStyle: K.Lar,
    BaseIconType: H.Circle
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.City
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.ClinicMedical
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.ClipboardCheck
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.ClipboardList
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Clipboard
  },
  {
    BaseIconStyle: K.Lar,
    BaseIconType: H.Clipboard
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Clock
  },
  {
    BaseIconStyle: K.Lar,
    BaseIconType: H.Clock
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Clone
  },
  {
    BaseIconStyle: K.Lar,
    BaseIconType: H.Clone
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.ClosedCaptioning
  },
  {
    BaseIconStyle: K.Lar,
    BaseIconType: H.ClosedCaptioning
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.CloudDownloadAlt
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.CloudMeatball
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.CloudMoonRain
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.CloudMoon
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.CloudRain
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.CloudShowersHeavy
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Cloud
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.CloudSunRain
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.CloudSun
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.CloudUploadAlt
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Cloudscale
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Cloudsmith
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Cloudversify
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Cocktail
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.CodeBranch
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Code
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Codepen
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Codiepie
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Coffee
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Cog
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Cogs
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Coins
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Columns
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.CommentAlt
  },
  {
    BaseIconStyle: K.Lar,
    BaseIconType: H.CommentAlt
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.CommentDollar
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.CommentDots
  },
  {
    BaseIconStyle: K.Lar,
    BaseIconType: H.CommentDots
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.CommentMedical
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.CommentSlash
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Comment
  },
  {
    BaseIconStyle: K.Lar,
    BaseIconType: H.Comment
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.CommentsDollar
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Comments
  },
  {
    BaseIconStyle: K.Lar,
    BaseIconType: H.Comments
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.CompactDisc
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Compass
  },
  {
    BaseIconStyle: K.Lar,
    BaseIconType: H.Compass
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.CompressArrowsAlt
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Compress
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.ConciergeBell
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Confluence
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Connectdevelop
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Contao
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.CookieBite
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Cookie
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Copy
  },
  {
    BaseIconStyle: K.Lar,
    BaseIconType: H.Copy
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Copyright
  },
  {
    BaseIconStyle: K.Lar,
    BaseIconType: H.Copyright
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.CottonBureau
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Couch
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Cpanel
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.CreativeCommonsBy
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.CreativeCommonsNcEu
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.CreativeCommonsNcJp
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.CreativeCommonsNc
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.CreativeCommonsNd
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.CreativeCommonsPdAlt
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.CreativeCommonsPd
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.CreativeCommonsRemix
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.CreativeCommonsSa
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.CreativeCommonsSamplingPlus
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.CreativeCommonsSampling
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.CreativeCommonsShare
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.CreativeCommonsZero
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.CreativeCommons
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.CreditCard
  },
  {
    BaseIconStyle: K.Lar,
    BaseIconType: H.CreditCard
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.CriticalRole
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.CropAlt
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Crop
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Cross
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Crosshairs
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Crow
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Crown
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Crutch
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Css3Alt
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Css3
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Cube
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Cubes
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Cut
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Cuttlefish
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.DAndDBeyond
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.DAndD
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Dashcube
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Database
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Deaf
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Delicious
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Democrat
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Deploydog
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Deskpro
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Desktop
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Dev
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Deviantart
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Dharmachakra
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Dhl
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Diagnoses
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Diaspora
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.DiceD20
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.DiceD6
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.DiceFive
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.DiceFour
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.DiceOne
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.DiceSix
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Dice
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.DiceThree
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.DiceTwo
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Digg
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.DigitalOcean
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.DigitalTachograph
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Directions
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Discord
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Discourse
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Divide
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Dizzy
  },
  {
    BaseIconStyle: K.Lar,
    BaseIconType: H.Dizzy
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Dna
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Dochub
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Docker
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Dog
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.DollarSign
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.DollyFlatbed
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Dolly
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Donate
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.DoorClosed
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.DoorOpen
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.DotCircle
  },
  {
    BaseIconStyle: K.Lar,
    BaseIconType: H.DotCircle
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Dove
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Download
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Draft2digital
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.DraftingCompass
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Dragon
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.DrawPolygon
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.DribbbleSquare
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Dribbble
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Dropbox
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Drum
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.DrumSteelpan
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.DrumstickBite
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Drupal
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Dumbbell
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.DumpsterFire
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Dumpster
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Dungeon
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Dyalog
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Earlybirds
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Ebay
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Edge
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Edit
  },
  {
    BaseIconStyle: K.Lar,
    BaseIconType: H.Edit
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Egg
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Eject
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Elementor
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.EllipsisH
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.EllipsisV
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Ello
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Ember
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Empire
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.EnvelopeOpen
  },
  {
    BaseIconStyle: K.Lar,
    BaseIconType: H.EnvelopeOpen
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.EnvelopeOpenText
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Envelope
  },
  {
    BaseIconStyle: K.Lar,
    BaseIconType: H.Envelope
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.EnvelopeSquare
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Envira
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Equals
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Eraser
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Erlang
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Ethereum
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Ethernet
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Etsy
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.EuroSign
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Evernote
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Exchange
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.ExclamationCircle
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Exclamation
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.ExclamationTriangle
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.ExpandArrowsAlt
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Expand
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Expeditedssl
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.ExternalLinkAlt
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.ExternalLinkSquareAlt
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.EyeDropper
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.EyeSlash
  },
  {
    BaseIconStyle: K.Lar,
    BaseIconType: H.EyeSlash
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Eye
  },
  {
    BaseIconStyle: K.Lar,
    BaseIconType: H.Eye
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.FacebookF
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.FacebookMessenger
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.FacebookSquare
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Facebook
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Fan
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.FantasyFlightGames
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.FastBackward
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.FastForward
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Fax
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.FeatherAlt
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Feather
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Fedex
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Fedora
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Female
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.FighterJet
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Figma
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.FileAlt
  },
  {
    BaseIconStyle: K.Lar,
    BaseIconType: H.FileAlt
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.FileArchive
  },
  {
    BaseIconStyle: K.Lar,
    BaseIconType: H.FileArchive
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.FileAudio
  },
  {
    BaseIconStyle: K.Lar,
    BaseIconType: H.FileAudio
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.FileCode
  },
  {
    BaseIconStyle: K.Lar,
    BaseIconType: H.FileCode
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.FileContract
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.FileCsv
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.FileDownload
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.FileExcel
  },
  {
    BaseIconStyle: K.Lar,
    BaseIconType: H.FileExcel
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.FileExport
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.FileImage
  },
  {
    BaseIconStyle: K.Lar,
    BaseIconType: H.FileImage
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.FileImport
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.FileInvoiceDollar
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.FileInvoice
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.FileMedicalAlt
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.FileMedical
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.FilePdf
  },
  {
    BaseIconStyle: K.Lar,
    BaseIconType: H.FilePdf
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.FilePowerpoint
  },
  {
    BaseIconStyle: K.Lar,
    BaseIconType: H.FilePowerpoint
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.FilePrescription
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.FileSignature
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.File
  },
  {
    BaseIconStyle: K.Lar,
    BaseIconType: H.File
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.FileUpload
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.FileVideo
  },
  {
    BaseIconStyle: K.Lar,
    BaseIconType: H.FileVideo
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.FileWord
  },
  {
    BaseIconStyle: K.Lar,
    BaseIconType: H.FileWord
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.FillDrip
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Fill
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Film
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Filter
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Fingerprint
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.FireAlt
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.FireExtinguisher
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Fire
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Firefox
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.FirstAid
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.FirstOrderAlt
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.FirstOrder
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Firstdraft
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Fish
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.FistRaised
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.FlagCheckered
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Flag
  },
  {
    BaseIconStyle: K.Lar,
    BaseIconType: H.Flag
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.FlagUsa
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Flask
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Flickr
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Flipboard
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Flushed
  },
  {
    BaseIconStyle: K.Lar,
    BaseIconType: H.Flushed
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Fly
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.FolderMinus
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.FolderOpen
  },
  {
    BaseIconStyle: K.Lar,
    BaseIconType: H.FolderOpen
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.FolderPlus
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Folder
  },
  {
    BaseIconStyle: K.Lar,
    BaseIconType: H.Folder
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.FontAwesomeAlt
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.FontAwesomeFlag
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.FontAwesome
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Font
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.FonticonsFi
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Fonticons
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.FootballBall
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.FortAwesomeAlt
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.FortAwesome
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Forumbee
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Forward
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Foursquare
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.FreeCodeCamp
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Freebsd
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Frog
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.FrownOpen
  },
  {
    BaseIconStyle: K.Lar,
    BaseIconType: H.FrownOpen
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Frown
  },
  {
    BaseIconStyle: K.Lar,
    BaseIconType: H.Frown
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Fulcrum
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.FunnelDollar
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Futbol
  },
  {
    BaseIconStyle: K.Lar,
    BaseIconType: H.Futbol
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.GalacticRepublic
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.GalacticSenate
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Gamepad
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.GasPump
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Gavel
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Gem
  },
  {
    BaseIconStyle: K.Lar,
    BaseIconType: H.Gem
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Genderless
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.GetPocket
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.GgCircle
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Gg
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Ghost
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Gift
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Gifts
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.GitAlt
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.GitSquare
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Git
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.GithubAlt
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.GithubSquare
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Github
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Gitkraken
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Gitlab
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Gitter
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.GlassCheers
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.GlassMartiniAlt
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.GlassMartini
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.GlassWhiskey
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Glasses
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.GlideG
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Glide
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.GlobeAfrica
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.GlobeAmericas
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.GlobeAsia
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.GlobeEurope
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Globe
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Gofore
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.GolfBall
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.GoodreadsG
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Goodreads
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.GoogleDrive
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.GooglePlay
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.GooglePlusG
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.GooglePlusSquare
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.GooglePlus
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.GoogleWallet
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Google
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Gopuram
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.GraduationCap
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Gratipay
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Grav
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.GreaterThanEqual
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.GreaterThan
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Grimace
  },
  {
    BaseIconStyle: K.Lar,
    BaseIconType: H.Grimace
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.GrinAlt
  },
  {
    BaseIconStyle: K.Lar,
    BaseIconType: H.GrinAlt
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.GrinBeam
  },
  {
    BaseIconStyle: K.Lar,
    BaseIconType: H.GrinBeam
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.GrinBeamSweat
  },
  {
    BaseIconStyle: K.Lar,
    BaseIconType: H.GrinBeamSweat
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.GrinHearts
  },
  {
    BaseIconStyle: K.Lar,
    BaseIconType: H.GrinHearts
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Grin
  },
  {
    BaseIconStyle: K.Lar,
    BaseIconType: H.Grin
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.GrinSquint
  },
  {
    BaseIconStyle: K.Lar,
    BaseIconType: H.GrinSquint
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.GrinSquintTears
  },
  {
    BaseIconStyle: K.Lar,
    BaseIconType: H.GrinSquintTears
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.GrinStars
  },
  {
    BaseIconStyle: K.Lar,
    BaseIconType: H.GrinStars
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.GrinTears
  },
  {
    BaseIconStyle: K.Lar,
    BaseIconType: H.GrinTears
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.GrinTongue
  },
  {
    BaseIconStyle: K.Lar,
    BaseIconType: H.GrinTongue
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.GrinTongueSquint
  },
  {
    BaseIconStyle: K.Lar,
    BaseIconType: H.GrinTongueSquint
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.GrinTongueWink
  },
  {
    BaseIconStyle: K.Lar,
    BaseIconType: H.GrinTongueWink
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.GrinWink
  },
  {
    BaseIconStyle: K.Lar,
    BaseIconType: H.GrinWink
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.GripHorizontal
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.GripLines
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.GripLinesVertical
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.GripVertical
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Gripfire
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Grunt
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Guitar
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Gulp
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.HSquare
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.HackerNewsSquare
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.HackerNews
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Hackerrank
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Hamburger
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Hammer
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Hamsa
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.HandHoldingHeart
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.HandHolding
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.HandHoldingUsd
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.HandLizard
  },
  {
    BaseIconStyle: K.Lar,
    BaseIconType: H.HandLizard
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.HandMiddleFinger
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.HandPaper
  },
  {
    BaseIconStyle: K.Lar,
    BaseIconType: H.HandPaper
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.HandPeace
  },
  {
    BaseIconStyle: K.Lar,
    BaseIconType: H.HandPeace
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.HandPointDown
  },
  {
    BaseIconStyle: K.Lar,
    BaseIconType: H.HandPointDown
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.HandPointLeft
  },
  {
    BaseIconStyle: K.Lar,
    BaseIconType: H.HandPointLeft
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.HandPointRight
  },
  {
    BaseIconStyle: K.Lar,
    BaseIconType: H.HandPointRight
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.HandPointUp
  },
  {
    BaseIconStyle: K.Lar,
    BaseIconType: H.HandPointUp
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.HandPointer
  },
  {
    BaseIconStyle: K.Lar,
    BaseIconType: H.HandPointer
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.HandRock
  },
  {
    BaseIconStyle: K.Lar,
    BaseIconType: H.HandRock
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.HandScissors
  },
  {
    BaseIconStyle: K.Lar,
    BaseIconType: H.HandScissors
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.HandSpock
  },
  {
    BaseIconStyle: K.Lar,
    BaseIconType: H.HandSpock
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.HandsHelping
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Hands
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Handshake
  },
  {
    BaseIconStyle: K.Lar,
    BaseIconType: H.Handshake
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Hanukiah
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.HardHat
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Hashtag
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.HatCowboySide
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.HatCowboy
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.HatWizard
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Haykal
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Hdd
  },
  {
    BaseIconStyle: K.Lar,
    BaseIconType: H.Hdd
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Heading
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.HeadphonesAlt
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Headphones
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Headset
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.HeartBroken
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Heart
  },
  {
    BaseIconStyle: K.Lar,
    BaseIconType: H.Heart
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Heartbeat
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Helicopter
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Highlighter
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Hiking
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Hippo
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Hips
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.HireAHelper
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.History
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.HockeyPuck
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.HollyBerry
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Home
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Hooli
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Hornbill
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.HorseHead
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Horse
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.HospitalAlt
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Hospital
  },
  {
    BaseIconStyle: K.Lar,
    BaseIconType: H.Hospital
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.HospitalSymbol
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.HotTub
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Hotdog
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Hotel
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Hotjar
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.HourglassEnd
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.HourglassHalf
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Hourglass
  },
  {
    BaseIconStyle: K.Lar,
    BaseIconType: H.Hourglass
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.HourglassStart
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.HouseDamage
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Houzz
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Hryvnia
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Html5
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Hubspot
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.ICursor
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.IceCream
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Icicles
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Icons
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.IdBadge
  },
  {
    BaseIconStyle: K.Lar,
    BaseIconType: H.IdBadge
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.IdCardAlt
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.IdCard
  },
  {
    BaseIconStyle: K.Lar,
    BaseIconType: H.IdCard
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Igloo
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Image
  },
  {
    BaseIconStyle: K.Lar,
    BaseIconType: H.Image
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Images
  },
  {
    BaseIconStyle: K.Lar,
    BaseIconType: H.Images
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Imdb
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Inbox
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Indent
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Industry
  },
  // commented out because ts recognizes infinity a number
  {
    /* tslint:disable-next-line */
    BaseIconStyle: K.Las
    /* tslint:disable-next-line */
    // BaseIconType: BaseIconType.Infinity,
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.InfoCircle
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Info
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Instagram
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Intercom
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.InternetExplorer
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Invision
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Ioxhost
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Italic
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.ItchIo
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.ItunesNote
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Itunes
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Java
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.JediOrder
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Jedi
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Jenkins
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Jira
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Joget
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Joint
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Joomla
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.JournalWhills
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.JsSquare
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Js
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Jsfiddle
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Kaaba
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Kaggle
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Key
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Keybase
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Keyboard
  },
  {
    BaseIconStyle: K.Lar,
    BaseIconType: H.Keyboard
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Keycdn
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Khanda
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.KickstarterK
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Kickstarter
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.KissBeam
  },
  {
    BaseIconStyle: K.Lar,
    BaseIconType: H.KissBeam
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Kiss
  },
  {
    BaseIconStyle: K.Lar,
    BaseIconType: H.Kiss
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.KissWinkHeart
  },
  {
    BaseIconStyle: K.Lar,
    BaseIconType: H.KissWinkHeart
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.KiwiBird
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Korvue
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Landmark
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Language
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.LaptopCode
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.LaptopMedical
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Laptop
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Laravel
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.LastfmSquare
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Lastfm
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.LaughBeam
  },
  {
    BaseIconStyle: K.Lar,
    BaseIconType: H.LaughBeam
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Laugh
  },
  {
    BaseIconStyle: K.Lar,
    BaseIconType: H.Laugh
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.LaughSquint
  },
  {
    BaseIconStyle: K.Lar,
    BaseIconType: H.LaughSquint
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.LaughWink
  },
  {
    BaseIconStyle: K.Lar,
    BaseIconType: H.LaughWink
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.LayerGroup
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Leaf
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Leanpub
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Lemon
  },
  {
    BaseIconStyle: K.Lar,
    BaseIconType: H.Lemon
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.LessThanEqual
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.LessThan
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Less
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.LevelDownAlt
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.LevelUpAlt
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.LifeRing
  },
  {
    BaseIconStyle: K.Lar,
    BaseIconType: H.LifeRing
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Lightbulb
  },
  {
    BaseIconStyle: K.Lar,
    BaseIconType: H.Lightbulb
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Line
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Link
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.LinkedinIn
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Linkedin
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Linode
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Linux
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.LiraSign
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.ListAlt
  },
  {
    BaseIconStyle: K.Lar,
    BaseIconType: H.ListAlt
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.ListOl
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.List
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.ListUl
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.LocationArrow
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.LockOpen
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Lock
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.LongArrowAltDown
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.LongArrowAltLeft
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.LongArrowAltRight
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.LongArrowAltUp
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.LowVision
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.LuggageCart
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Lyft
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Magento
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Magic
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Magnet
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.MailBulk
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Mailchimp
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Male
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Mandalorian
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.MapMarkedAlt
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.MapMarked
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.MapMarkerAlt
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.MapMarker
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.MapPin
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.MapSigns
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Map
  },
  {
    BaseIconStyle: K.Lar,
    BaseIconType: H.Map
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Markdown
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Marker
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.MarsDouble
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Mars
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.MarsStrokeH
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.MarsStroke
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.MarsStrokeV
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Mask
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Mastodon
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Maxcdn
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Mdb
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Medal
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Medapps
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.MediumM
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Medium
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Medkit
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Medrt
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Meetup
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Megaport
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.MehBlank
  },
  {
    BaseIconStyle: K.Lar,
    BaseIconType: H.MehBlank
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.MehRollingEyes
  },
  {
    BaseIconStyle: K.Lar,
    BaseIconType: H.MehRollingEyes
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Meh
  },
  {
    BaseIconStyle: K.Lar,
    BaseIconType: H.Meh
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Memory
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Mendeley
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Menorah
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Mercury
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Meteor
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Microchip
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.MicrophoneAltSlash
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.MicrophoneAlt
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.MicrophoneSlash
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Microphone
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Microscope
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Microsoft
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.MinusCircle
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Minus
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.MinusSquare
  },
  {
    BaseIconStyle: K.Lar,
    BaseIconType: H.MinusSquare
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Mitten
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Mix
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Mixcloud
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Mizuni
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.MobileAlt
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Mobile
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Modx
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Monero
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.MoneyBillAlt
  },
  {
    BaseIconStyle: K.Lar,
    BaseIconType: H.MoneyBillAlt
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.MoneyBill
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.MoneyBillWaveAlt
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.MoneyBillWave
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.MoneyCheckAlt
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.MoneyCheck
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Monument
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Moon
  },
  {
    BaseIconStyle: K.Lar,
    BaseIconType: H.Moon
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.MortarPestle
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Mosque
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Motorcycle
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Mountain
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.MousePointer
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Mouse
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.MugHot
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Music
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Napster
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Neos
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.NetworkWired
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Neuter
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Newspaper
  },
  {
    BaseIconStyle: K.Lar,
    BaseIconType: H.Newspaper
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Nimblr
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.NodeJs
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Node
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.NotEqual
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.NotesMedical
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Npm
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Ns8
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Nutritionix
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.ObjectGroup
  },
  {
    BaseIconStyle: K.Lar,
    BaseIconType: H.ObjectGroup
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.ObjectUngroup
  },
  {
    BaseIconStyle: K.Lar,
    BaseIconType: H.ObjectUngroup
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.OdnoklassnikiSquare
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Odnoklassniki
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.OilCan
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.OldRepublic
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Om
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Opencart
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Openid
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Opera
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.OptinMonster
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Orcid
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Osi
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Otter
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Outdent
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Page4
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Pagelines
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Pager
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.PaintBrush
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.PaintRoller
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Palette
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Palfed
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Pallet
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.PaperPlane
  },
  {
    BaseIconStyle: K.Lar,
    BaseIconType: H.PaperPlane
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Paperclip
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.ParachuteBox
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Paragraph
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Parking
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Passport
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Pastafarianism
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Paste
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Patreon
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.PauseCircle
  },
  {
    BaseIconStyle: K.Lar,
    BaseIconType: H.PauseCircle
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Pause
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Paw
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Paypal
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Peace
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.PenAlt
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.PenFancy
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.PenNib
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Pen
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.PenSquare
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.PencilAlt
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.PencilRuler
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.PennyArcade
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.PeopleCarry
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.PepperHot
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Percent
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Percentage
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Periscope
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.PersonBooth
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Phabricator
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.PhoenixFramework
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.PhoenixSquadron
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.PhoneAlt
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.PhoneSlash
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Phone
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.PhoneSquareAlt
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.PhoneSquare
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.PhoneVolume
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.PhotoVideo
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Php
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.PiedPiperAlt
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.PiedPiperHat
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.PiedPiperPp
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.PiedPiper
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.PiggyBank
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Pills
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.PinterestP
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.PinterestSquare
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Pinterest
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.PizzaSlice
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.PlaceOfWorship
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.PlaneArrival
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.PlaneDeparture
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Plane
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.PlayCircle
  },
  {
    BaseIconStyle: K.Lar,
    BaseIconType: H.PlayCircle
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Play
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Playstation
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Plug
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.PlusCircle
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Plus
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.PlusSquare
  },
  {
    BaseIconStyle: K.Lar,
    BaseIconType: H.PlusSquare
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Podcast
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.PollH
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Poll
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Poo
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.PooStorm
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Poop
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Portrait
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.PoundSign
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.PowerOff
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Pray
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.PrayingHands
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.PrescriptionBottleAlt
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.PrescriptionBottle
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Prescription
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Print
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Procedures
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.ProductHunt
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.ProjectDiagram
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Pushed
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.PuzzlePiece
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Python
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Qq
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Qrcode
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.QuestionCircle
  },
  {
    BaseIconStyle: K.Lar,
    BaseIconType: H.QuestionCircle
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Question
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Quidditch
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Quinscape
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Quora
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.QuoteLeft
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.QuoteRight
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Quran
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.RProject
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.RadiationAlt
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Radiation
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Rainbow
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Random
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.RaspberryPi
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Ravelry
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.React
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Reacteurope
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Readme
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Rebel
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Receipt
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.RecordVinyl
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Recycle
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.RedRiver
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.RedditAlien
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.RedditSquare
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Reddit
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Redhat
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.RedoAlt
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Redo
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Registered
  },
  {
    BaseIconStyle: K.Lar,
    BaseIconType: H.Registered
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.RemoveFormat
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Renren
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.ReplyAll
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Reply
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Replyd
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Republican
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Researchgate
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Resolving
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Restroom
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Retweet
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Rev
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Ribbon
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Ring
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Road
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Robot
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Rocket
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Rocketchat
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Rockrms
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Route
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Rss
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.RssSquare
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.RubleSign
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.RulerCombined
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.RulerHorizontal
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Ruler
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.RulerVertical
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Running
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.RupeeSign
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.SadCry
  },
  {
    BaseIconStyle: K.Lar,
    BaseIconType: H.SadCry
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.SadTear
  },
  {
    BaseIconStyle: K.Lar,
    BaseIconType: H.SadTear
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Safari
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Salesforce
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Sass
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.SatelliteDish
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Satellite
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Save
  },
  {
    BaseIconStyle: K.Lar,
    BaseIconType: H.Save
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Schlix
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.School
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Screwdriver
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Scribd
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Scroll
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.SdCard
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.SearchDollar
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.SearchLocation
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.SearchMinus
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.SearchPlus
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Search
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Searchengin
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Seedling
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Sellcast
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Sellsy
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Server
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Servicestack
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Shapes
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.ShareAlt
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.ShareAltSquare
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Share
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.ShareSquare
  },
  {
    BaseIconStyle: K.Lar,
    BaseIconType: H.ShareSquare
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.ShekelSign
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.ShieldAlt
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Ship
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.ShippingFast
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Shirtsinbulk
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.ShoePrints
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.ShoppingBag
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.ShoppingBasket
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.ShoppingCart
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Shopware
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Shower
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.ShuttleVan
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.SignInAlt
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.SignLanguage
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.SignOutAlt
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Sign
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Signal
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Signature
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.SimCard
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Simplybuilt
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Sistrix
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Sitemap
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Sith
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Skating
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Sketch
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.SkiingNordic
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Skiing
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.SkullCrossbones
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Skull
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Skyatlas
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Skype
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.SlackHash
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Slack
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Slash
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Sleigh
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.SlidersH
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Slideshare
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.SmileBeam
  },
  {
    BaseIconStyle: K.Lar,
    BaseIconType: H.SmileBeam
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Smile
  },
  {
    BaseIconStyle: K.Lar,
    BaseIconType: H.Smile
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.SmileWink
  },
  {
    BaseIconStyle: K.Lar,
    BaseIconType: H.SmileWink
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Smog
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.SmokingBan
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Smoking
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Sms
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.SnapchatGhost
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.SnapchatSquare
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Snapchat
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Snowboarding
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Snowflake
  },
  {
    BaseIconStyle: K.Lar,
    BaseIconType: H.Snowflake
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Snowman
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Snowplow
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Socks
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.SolarPanel
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.SortAlphaDownAlt
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.SortAlphaDown
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.SortAlphaUpAlt
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.SortAlphaUp
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.SortAmountDownAlt
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.SortAmountDown
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.SortAmountUpAlt
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.SortAmountUp
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.SortDown
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.SortNumericDownAlt
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.SortNumericDown
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.SortNumericUpAlt
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.SortNumericUp
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Sort
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.SortUp
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Soundcloud
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Sourcetree
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Spa
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.SpaceShuttle
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Speakap
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.SpeakerDeck
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.SpellCheck
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Spider
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Spinner
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Splotch
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Spotify
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.SprayCan
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.SquareFull
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.SquareRootAlt
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Square
  },
  {
    BaseIconStyle: K.Lar,
    BaseIconType: H.Square
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Squarespace
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.StackExchange
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.StackOverflow
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Stackpath
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Stamp
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.StarAndCrescent
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.StarHalfAlt
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.StarHalf
  },
  {
    BaseIconStyle: K.Lar,
    BaseIconType: H.StarHalf
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.StarOfDavid
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.StarOfLife
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Star
  },
  {
    BaseIconStyle: K.Lar,
    BaseIconType: H.Star
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Staylinked
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.SteamSquare
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.SteamSymbol
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Steam
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.StepBackward
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.StepForward
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Stethoscope
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.StickerMule
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.StickyNote
  },
  {
    BaseIconStyle: K.Lar,
    BaseIconType: H.StickyNote
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.StopCircle
  },
  {
    BaseIconStyle: K.Lar,
    BaseIconType: H.StopCircle
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Stop
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Stopwatch
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.StoreAlt
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Store
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Strava
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Stream
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.StreetView
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Strikethrough
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.StripeS
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Stripe
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Stroopwafel
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Studiovinari
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.StumbleuponCircle
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Stumbleupon
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Subscript
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Subway
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.SuitcaseRolling
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Suitcase
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Sun
  },
  {
    BaseIconStyle: K.Lar,
    BaseIconType: H.Sun
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Superpowers
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Superscript
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Supple
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Surprise
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Surprise
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Suse
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Swatchbook
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Swift
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Swimmer
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.SwimmingPool
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Symfony
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Synagogue
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.SyncAlt
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Sync
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Syringe
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Table
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.TableTennis
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.TabletAlt
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Tablet
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Tablets
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.TachometerAlt
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Tag
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Tags
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Tape
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Tasks
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Taxi
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Teamspeak
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.TeethOpen
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Teeth
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.TelegramPlane
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Telegram
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.TemperatureHigh
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.TemperatureLow
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.TencentWeibo
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Tenge
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Terminal
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.TextHeight
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.TextWidth
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.ThLarge
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.ThList
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Th
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.TheRedYeti
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.TheaterMasks
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Themeco
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Themeisle
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.ThermometerEmpty
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.ThermometerFull
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.ThermometerHalf
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.ThermometerQuarter
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Thermometer
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.ThermometerThreeQuarters
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.ThinkPeaks
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.ThumbsDown
  },
  {
    BaseIconStyle: K.Lar,
    BaseIconType: H.ThumbsDown
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.ThumbsUp
  },
  {
    BaseIconStyle: K.Lar,
    BaseIconType: H.ThumbsUp
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Thumbtack
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.TicketAlt
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.TimesCircle
  },
  {
    BaseIconStyle: K.Lar,
    BaseIconType: H.TimesCircle
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Times
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.TintSlash
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Tint
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Tired
  },
  {
    BaseIconStyle: K.Lar,
    BaseIconType: H.Tired
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.ToggleOff
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.ToggleOn
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.ToiletPaper
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Toilet
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Toolbox
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Tools
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Tooth
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Torah
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.ToriiGate
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Tractor
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.TradeFederation
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Trademark
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.TrafficLight
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Train
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Tram
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.TransgenderAlt
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Transgender
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.TrashAlt
  },
  {
    BaseIconStyle: K.Lar,
    BaseIconType: H.TrashAlt
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.TrashRestoreAlt
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.TrashRestore
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Trash
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Tree
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Trello
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Tripadvisor
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Trophy
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.TruckLoading
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.TruckMonster
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.TruckMoving
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.TruckPickup
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Truck
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Tshirt
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Tty
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.TumblrSquare
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Tumblr
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Tv
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Twitch
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.TwitterSquare
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Twitter
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Typo3
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Uber
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Ubuntu
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Uikit
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Umbraco
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.UmbrellaBeach
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Umbrella
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Underline
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.UndoAlt
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Undo
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Uniregistry
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.UniversalAccess
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.University
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Unlink
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.UnlockAlt
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Unlock
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Untappd
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Upload
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Ups
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Usb
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.UserAltSlash
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.UserAlt
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.UserAstronaut
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.UserCheck
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.UserCircle
  },
  {
    BaseIconStyle: K.Lar,
    BaseIconType: H.UserCircle
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.UserClock
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.UserCog
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.UserEdit
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.UserFriends
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.UserGraduate
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.UserInjured
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.UserLock
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.UserMd
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.UserMinus
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.UserNinja
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.UserNurse
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.UserPlus
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.UserSecret
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.UserShield
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.UserSlash
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.User
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.UserTag
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.UserTie
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.UserTimes
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.User
  },
  {
    BaseIconStyle: K.Lar,
    BaseIconType: H.User
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.UsersCog
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Users
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Usps
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Ussunnah
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.UtensilSpoon
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Utensils
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Vaadin
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.VectorSquare
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.VenusDouble
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.VenusMars
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Venus
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Viacoin
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.ViadeoSquare
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Viadeo
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Vial
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Vials
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Viber
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.VideoSlash
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Video
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Vihara
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.VimeoSquare
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.VimeoV
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Vimeo
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Vine
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Vk
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Vnv
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Voicemail
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.VolleyballBall
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.VolumeDown
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.VolumeMute
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.VolumeOff
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.VolumeUp
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.VoteYea
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.VrCardboard
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Vuejs
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Walking
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Wallet
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Warehouse
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Water
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.WaveSquare
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Waze
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Weebly
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Weibo
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.WeightHanging
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Weight
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Weixin
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.WhatsappSquare
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Whatsapp
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Wheelchair
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Whmcs
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Wifi
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.WikipediaW
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Wind
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.WindowClose
  },
  {
    BaseIconStyle: K.Lar,
    BaseIconType: H.WindowClose
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.WindowMaximize
  },
  {
    BaseIconStyle: K.Lar,
    BaseIconType: H.WindowMaximize
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.WindowMinimize
  },
  {
    BaseIconStyle: K.Lar,
    BaseIconType: H.WindowMinimize
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.WindowRestore
  },
  {
    BaseIconStyle: K.Lar,
    BaseIconType: H.WindowRestore
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Windows
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.WineBottle
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.WineGlassAlt
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.WineGlass
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Wix
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.WizardsOfTheCoast
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.WolfPackBattalion
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.WonSign
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.WordpressSimple
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Wordpress
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Wpbeginner
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Wpexplorer
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Wpforms
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Wpressr
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.Wrench
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.XRay
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Xbox
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.XingSquare
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Xing
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.YCombinator
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Yahoo
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Yammer
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.YandexInternational
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Yandex
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Yarn
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Yelp
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.YenSign
  },
  {
    BaseIconStyle: K.Las,
    BaseIconType: H.YinYang
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Yoast
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.YoutubeSquare
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Youtube
  },
  {
    BaseIconStyle: K.Lab,
    BaseIconType: H.Zhihu
  }
], CA = ["title", "aria-label"], TA = /* @__PURE__ */ Be({
  __name: "BaseIcon",
  props: {
    baseIcon: {
      type: String,
      default: H.ArrowRight
    },
    baseIconFilled: {
      type: Boolean,
      default: !1
    },
    baseIconSize: {
      type: String,
      default: at.Inherit
    },
    baseIconColor: {
      type: String,
      default: gt.Default
    },
    baseIconBgColor: {
      type: String,
      default: void 0
    },
    ariaLabel: {
      type: String,
      default: void 0
      //Not all icons need an aria-label
    }
  },
  emits: ["click"],
  setup(e, { emit: t }) {
    const n = e, i = Te(() => {
      switch (n.baseIconSize) {
        case at.L:
          return "size-l";
        case at.M:
          return "size-m";
        case at.S:
          return "size-s";
        case at.XS:
          return "size-xs";
        case at.XXS:
          return "size-xxs";
        case at.Inherit:
          return "size-inherit";
        case at.NextToText:
          return "next-to-text";
      }
    }), o = Te(() => n.baseIconColor === gt.Inherit ? "d-color-inherit" : `d-${n.baseIconColor}`), a = Te(() => {
      if (n.baseIconBgColor)
        return `d-bg-${n.baseIconBgColor}`;
    }), r = Te(() => {
      const l = SA?.find((d) => d.BaseIconType === n.baseIcon);
      return l ? l.BaseIconStyle : K.Las;
    }), s = t;
    return (l, d) => (E(), X("i", {
      class: Pe(["d-icon", [
        { filled: e.baseIconFilled },
        `${r.value} la-${e.baseIcon}`,
        i.value,
        o.value,
        a.value
      ]]),
      role: "img",
      title: e.baseIcon,
      "aria-label": n.ariaLabel,
      onClick: d[0] || (d[0] = (y) => s("click", y))
    }, null, 10, CA));
  }
});
const _t = /* @__PURE__ */ Fe(TA, [["__scopeId", "data-v-3f4f4121"]]);
var yt = /* @__PURE__ */ ((e) => (e.Default = "default", e.Javascript = "javascript", e.Anchor = "anchor", e.Mail = "mail", e.Tel = "tel", e))(yt || {}), yn = /* @__PURE__ */ ((e) => (e.TwelvePx = "12px", e.FourteenPx = "14px", e.SixteenPx = "16px", e.EighteenPx = "18px", e.TwentyPx = "20px", e.TwentyTwoPx = "22px", e.TwentyFourPx = "24px", e))(yn || {}), ya = /* @__PURE__ */ ((e) => (e.DwsRegular = "dws-slab", e.DwsBold = "dws-slab-bold", e.DwsSans = "dws-sans", e.DwsSansBold = "dws-sans-bold", e.DwsSansLight = "dws-sans-light", e.DwsSlabLight = "dws-slab-light", e))(ya || {});
const LA = ["href", "target", "rel", "data-event_linktype", "data-event_source", "data-event_target", "data-event_title", "data-event_engagement", "data-event_component_name", "data-event_component_headline"], IA = {
  key: 1,
  class: "d-base-link--left"
}, PA = {
  key: 3,
  class: "d-base-link--right"
}, AA = /* @__PURE__ */ Be({
  __name: "BaseLinkV2",
  props: {
    linkModel: {
      type: Object,
      required: !0
    },
    fontSize: {
      type: String,
      default: yn.SixteenPx
    },
    fontType: {
      type: String,
      default: ya.DwsBold
    },
    hasText: {
      type: Boolean,
      default: !0
    },
    icon: {
      type: String,
      default: null
    },
    iconPosition: {
      type: String,
      default: ct.Right
    },
    iconColor: {
      type: String,
      default: gt.Inherit
    },
    iconSize: {
      type: String,
      default: at.NextToText
    },
    isCopyLink: {
      type: Boolean,
      default: !1
    },
    alwaysUnderline: {
      type: Boolean,
      default: !1
    },
    stopPropagation: {
      type: Boolean,
      default: !1
    },
    iconAriaHidden: {
      type: Boolean,
      default: !0
    },
    iconAriaLabel: {
      type: String,
      default: null
    }
  },
  setup(e, { expose: t }) {
    const n = e, i = Jt(), o = (h) => !!i[h], a = (h) => {
      !Ue || !n?.stopPropagation || (h?.stopPropagation(), h?.preventDefault(), On(
        n?.linkModel?.tealiumTrackingModel?.eventComponentName,
        n?.linkModel?.tealiumTrackingModel?.eventTitle,
        n?.linkModel?.tealiumTrackingModel?.eventSource,
        n?.linkModel?.tealiumTrackingModel?.eventLinkType,
        n?.linkModel?.tealiumTrackingModel?.eventTarget,
        n?.linkModel?.tealiumTrackingModel?.eventEngagement,
        n?.linkModel?.tealiumTrackingModel?.eventComponentHeadline
      ), window?.open(n?.linkModel?.href, n?.linkModel?.target));
    }, r = Te(() => n.icon !== null ? "d-base-link--icon" : n.linkModel?.text != "" ? "d-base-link--hover" : "d-base-link--no-hover"), s = Te(() => {
      switch (n.fontSize) {
        case yn.TwelvePx:
          return "d-base-link--font-size-12";
        case yn.FourteenPx:
          return "d-base-link--font-size-14";
        case yn.SixteenPx:
          return "d-base-link--font-size-16";
        case yn.EighteenPx:
          return "d-base-link--font-size-18";
        case yn.TwentyPx:
          return "d-base-link--font-size-20";
        case yn.TwentyTwoPx:
          return "d-base-link--font-size-22";
        case yn.TwentyFourPx:
          return "d-base-link--font-size-24";
        default:
          return "";
      }
    }), l = Te(() => n.fontType ? `d-base-text--font-${n.fontType}` : ""), d = Te(() => n.isCopyLink ? "d-base-link--is-copy-link" : ""), y = Te(() => n.alwaysUnderline ? "d-base-link--always-underline" : ""), u = ge(), m = ge();
    return t({
      linkRef: u,
      iconRef: m
    }), (h, c) => (E(), X("a", {
      ref_key: "linkRef",
      ref: u,
      href: e.linkModel?.href,
      target: e.linkModel?.target,
      rel: e.linkModel?.target ? "noopener noreferrer" : "",
      tabindex: "0",
      class: Pe(["d-base-link", [
        s.value,
        l.value,
        r.value,
        d.value,
        y.value
      ]]),
      "data-event_linktype": e.linkModel?.tealiumTrackingModel?.eventLinkType,
      "data-event_source": e.linkModel?.tealiumTrackingModel?.eventSource,
      "data-event_target": e.linkModel?.tealiumTrackingModel?.eventTarget,
      "data-event_title": e.linkModel?.tealiumTrackingModel?.eventTitle,
      "data-event_engagement": e.linkModel?.tealiumTrackingModel?.eventEngagement,
      "data-event_component_name": e.linkModel?.tealiumTrackingModel?.eventComponentName,
      "data-event_component_headline": e.linkModel?.tealiumTrackingModel?.eventComponentHeadline,
      onClick: a
    }, [
      je(h.$slots, "content", {}, () => [
        o("container") ? je(h.$slots, "container", { key: 0 }, void 0, !0) : te("", !0),
        e.icon !== null && e.iconPosition === _(ct).Left ? (E(), X("div", IA, [
          ue(_t, {
            ref_key: "iconRef",
            ref: m,
            class: Pe(["d-base-link--left-icon d-base-link--icon", { "no-margin": !e.hasText }]),
            "base-icon": e.icon,
            "base-icon-size": e.iconSize,
            "base-icon-color": e.iconColor,
            "aria-hidden": e.iconAriaHidden,
            "aria-label": e.iconAriaLabel || e.icon
          }, null, 8, ["class", "base-icon", "base-icon-size", "base-icon-color", "aria-hidden", "aria-label"])
        ])) : te("", !0),
        e.linkModel?.text != "" && e.hasText ? (E(), X("span", {
          key: 2,
          class: Pe(["d-base-link--text inline-block", s.value])
        }, Ie(e.linkModel?.text), 3)) : te("", !0),
        e.icon !== null && e.iconPosition === _(ct).Right ? (E(), X("div", PA, [
          ue(_t, {
            class: Pe(["d-base-link--right-icon d-base-link--icon", { "no-margin": !e.hasText }]),
            "base-icon": e.icon,
            "base-icon-size": e.iconSize,
            "base-icon-color": e.iconColor,
            "aria-hidden": e.iconAriaHidden,
            "aria-label": e.iconAriaLabel || e.icon
          }, null, 8, ["class", "base-icon", "base-icon-size", "base-icon-color", "aria-hidden", "aria-label"])
        ])) : te("", !0)
      ], !0)
    ], 10, LA));
  }
});
const ot = /* @__PURE__ */ Fe(AA, [["__scopeId", "data-v-98e77744"]]), Yc = {
  eventSource: "eventSource (Placeholder)",
  eventComponentName: "eventComponentName (Placeholder)",
  eventComponentHeadline: "eventComponentHeadline123 (Placeholder)",
  eventTitle: "eventTitle (Placeholder)",
  eventLinkType: "eventLinkType (Placeholder)",
  eventTarget: "eventTarget (Placeholder)",
  eventEngagement: "eventEngagement (Placeholder)",
  customAttributes: {}
};
var za = /* @__PURE__ */ ((e) => (e.Default = "default", e.Javascript = "javascript", e.Anchor = "anchor", e.Mail = "mail", e.Tel = "tel", e))(za || {}), gw = /* @__PURE__ */ ((e) => (e.Sixteen = "16", e.TwentyFour = "24", e))(gw || {}), zi = /* @__PURE__ */ ((e) => (e.TwelvePx = "12px", e.FourteenPx = "14px", e.SixteenPx = "16px", e.TwentyPx = "20px", e.TwentyTwoPx = "22px", e.TwentyFourPx = "24px", e))(zi || {}), Kd = /* @__PURE__ */ ((e) => (e.DwsRegular = "dws-slab", e.DwsBold = "dws-slab-bold", e))(Kd || {});
za.Anchor;
const Tm = {
  href: "#",
  contentUrl: "#",
  title: "",
  text: "",
  target: "_blank",
  isLocked: !1,
  isExternal: !1,
  linkType: za.Anchor,
  tealiumTrackingModel: Yc
}, _A = {
  ...Tm,
  title: "Button title",
  text: "Button text",
  tealiumTrackingModel: Yc
};
za.Anchor;
Ke.Primary, Ke.RoundedPrimary, Ke.Primary, Ke.RoundedPrimary, Ke.Primary, Ke.RoundedPrimary, Ke.Secondary, Ke.RoundedSecondary, Ke.Secondary, Ke.RoundedSecondary, Ke.Secondary, Ke.RoundedSecondary, Ke.Tertiary, Ke.RoundedTertiary, Ke.Tertiary, Ke.RoundedTertiary, Ke.Tertiary, Ke.RoundedTertiary, Ke.Ghost, Ke.RoundedGhost, Ke.Ghost, Ke.RoundedGhost, Ke.Ghost, Ke.RoundedGhost, Ke.RoundedSocial, Ke.RoundedSocial, Ke.RoundedSocial;
H.Download;
const MA = { class: "container" }, OA = /* @__PURE__ */ Be({
  __name: "PageFootnoteReferenceExample",
  props: {
    htmlText: {
      type: String,
      required: !0
    }
  },
  setup(e) {
    const t = Pn();
    return (n, i) => (E(), X("div", MA, [
      i[3] || (i[3] = oe("h3", null, "Dynamischer Text vom Backend", -1)),
      oe("p", null, [
        ue(ss, {
          html: e.htmlText,
          purify: !1
        }, null, 8, ["html"])
      ]),
      i[4] || (i[4] = oe("h3", null, "Manueller Text im Frontend", -1)),
      oe("p", null, [
        i[0] || (i[0] = Ve(" Testtext mit manueller Fussnote")),
        ue(ma, {
          title: "Manuelle Fussnoten können jederzeit platziert werden.",
          "special-link": "",
          "component-id": _(t)
        }, null, 8, ["component-id"]),
        i[1] || (i[1] = Ve(" Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr")),
        ue(ma, {
          title: "manuel footnote 2.",
          "special-link": "",
          "component-id": _(t)
        }, null, 8, ["component-id"]),
        i[2] || (i[2] = Ve(", sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. "))
      ]),
      i[5] || (i[5] = oe("h3", null, 'Manueller text im frontend "component" footnote', -1)),
      ue(ro, {
        "component-id": _(t),
        "footnote-type": _(Oi).ComponentId
      }, null, 8, ["component-id", "footnote-type"]),
      ue(ot, { "link-model": _(_A) }, null, 8, ["link-model"]),
      ue(ma, {
        title: "Link footnote",
        "special-link": ""
      }),
      i[6] || (i[6] = oe("h3", null, "Footnote List All", -1)),
      oe("p", null, [
        ue(ro, {
          "component-id": void 0,
          "footnote-type": _(Oi).ComponentId
        }, null, 8, ["footnote-type"])
      ])
    ]));
  }
});
const hBe = /* @__PURE__ */ Fe(OA, [["__scopeId", "data-v-8eb4a31e"]]), BA = Be({
  name: "FootnoteHeader",
  components: { PageFootnoteReference: ma, HTMLContentBlock: ht },
  props: {
    text: {
      type: String,
      default: ""
    },
    footNoteId: {
      type: String,
      default: ""
    },
    shouldStopPropagation: {
      type: Boolean,
      default: !1
    },
    onClick: {
      type: Function,
      default: function() {
        return !0;
      }
    },
    newPageFootnoteListVisible: {
      type: Boolean,
      default: !1
    },
    cssClass: {
      type: String,
      default: ""
    }
  },
  data() {
    return {};
  },
  created() {
    const { t: e } = Je();
    this.translate = e;
  },
  computed: {
    footNotes() {
      if (!this.text)
        return [];
      const e = this.text.split("{{");
      if (e.length === 1)
        return { label: e[0] };
      const t = [];
      return e.forEach((n) => {
        const i = n.indexOf("}}");
        if (i > -1) {
          const o = n.substring(0, i);
          t.push(o);
        }
      }), { label: e[0], items: t };
    }
  },
  methods: {
    footNotesLabel(e) {
      const { htmlContentBlockWhitelist: t } = Li();
      return Ma(e, t).toString();
    },
    handleClick(e, t) {
      if (this.shouldStopPropagation && e.stopPropagation(), !Ue)
        return;
      const n = document.getElementById(t);
      if (n) {
        const { calculateScrollPosition: i } = Fn();
        window.scrollTo({
          top: i(n) || 0,
          behavior: "smooth"
        }), n?.focus();
      }
    }
  }
}), EA = ["id", "data-event_title", "aria-label", "onClick"];
function DA(e, t, n, i, o, a) {
  const r = $e("HTMLContentBlock"), s = $e("PageFootnoteReference");
  return E(), X(Re, null, [
    oe("span", {
      class: Pe(["contents", e.cssClass])
    }, [
      ue(r, {
        "html-text": e.footNotesLabel(e.footNotes.label),
        "disable-default-styling": ""
      }, null, 8, ["html-text"])
    ], 2),
    (E(!0), X(Re, null, Ge(e.footNotes.items, (l) => (E(), X(Re, { key: l }, [
      e.newPageFootnoteListVisible ? te("", !0) : (E(), X("a", {
        key: 0,
        id: `first-${l}-${e.footNoteId}`,
        class: "footnote",
        href: "javascript:void(0)",
        "data-event_component_name": "Text Links (same page)",
        "data-event_title": "Sprungmarke | [" + l + "]",
        "aria-label": `${e.translate("footNoteHeader.link")} ${l}`,
        "data-event_source": "${dataEventSource}",
        onClick: (d) => e.handleClick(d, `sec-${l}-${e.footNoteId}`)
      }, [
        oe("sup", null, "[" + Ie(l) + "]", 1)
      ], 8, EA)),
      e.newPageFootnoteListVisible ? (E(), fe(s, {
        key: 1,
        title: e.footNotes.label,
        "special-link": ""
      }, null, 8, ["title"])) : te("", !0)
    ], 64))), 128))
  ], 64);
}
const li = /* @__PURE__ */ Fe(BA, [["render", DA]]), RA = /* @__PURE__ */ Be({
  __name: "TextBlock",
  props: {
    values: {
      type: String,
      default: ""
    },
    numberColumn: {
      type: Number,
      required: !1,
      default: 1
    },
    isDisclaimer: {
      type: Boolean,
      required: !1,
      default: !0
    }
  },
  setup(e) {
    const t = e, n = Te(() => {
      let i = "";
      if (t.isDisclaimer === !0)
        i += " d-text-block__disclaimer-style ";
      else
        return "";
      return i;
    });
    return (i, o) => e.values?.length > 0 ? (E(), X("div", {
      key: 0,
      class: Pe(["d-text-block", n.value])
    }, [
      ue(_(ht), {
        "html-text": e.values,
        "disable-default-styling": ""
      }, null, 8, ["html-text"])
    ], 2)) : te("", !0);
  }
});
const Mr = /* @__PURE__ */ Fe(RA, [["__scopeId", "data-v-dc905184"]]);
function Rl(e) {
  "@babel/helpers - typeof";
  return Rl = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Rl(e);
}
function Nv(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    t && (i = i.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), n.push.apply(n, i);
  }
  return n;
}
function $v(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Nv(Object(n), !0).forEach(function(i) {
      NA(e, i, n[i]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Nv(Object(n)).forEach(function(i) {
      Object.defineProperty(e, i, Object.getOwnPropertyDescriptor(n, i));
    });
  }
  return e;
}
function NA(e, t, n) {
  return t = $A(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function $A(e) {
  var t = FA(e, "string");
  return Rl(t) == "symbol" ? t : String(t);
}
function FA(e, t) {
  if (Rl(e) != "object" || !e)
    return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var i = n.call(e, t || "default");
    if (Rl(i) != "object")
      return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function jA(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0;
  ho() ? it(e) : t ? e() : mt(e);
}
var HA = 0;
function vw(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = ge(!1), i = ge(e), o = ge(null), a = Oe.isClient() ? window.document : void 0, r = t.document, s = r === void 0 ? a : r, l = t.immediate, d = l === void 0 ? !0 : l, y = t.manual, u = y === void 0 ? !1 : y, m = t.name, h = m === void 0 ? "style_".concat(++HA) : m, c = t.id, g = c === void 0 ? void 0 : c, v = t.media, P = v === void 0 ? void 0 : v, f = t.nonce, S = f === void 0 ? void 0 : f, w = t.props, x = w === void 0 ? {} : w, k = function() {
  }, A = function(N) {
    var M = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (s) {
      var D = $v($v({}, x), M), C = D.name || h, b = D.id || g, p = D.nonce || S;
      o.value = s.querySelector('style[data-primevue-style-id="'.concat(C, '"]')) || s.getElementById(b) || s.createElement("style"), o.value.isConnected || (i.value = N || e, Oe.setAttributes(o.value, {
        type: "text/css",
        id: b,
        media: P,
        nonce: p
      }), s.head.appendChild(o.value), Oe.setAttribute(o.value, "data-primevue-style-id", h), Oe.setAttributes(o.value, D)), !n.value && (k = qe(i, function(L) {
        o.value.textContent = L;
      }, {
        immediate: !0
      }), n.value = !0);
    }
  }, $ = function() {
    !s || !n.value || (k(), Oe.isExist(o.value) && s.head.removeChild(o.value), n.value = !1);
  };
  return d && !u && jA(A), {
    id: g,
    name: h,
    css: i,
    unload: $,
    load: A,
    isLoaded: _l(n)
  };
}
function Nl(e) {
  "@babel/helpers - typeof";
  return Nl = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Nl(e);
}
function zA(e, t) {
  return WA(e) || UA(e, t) || GA(e, t) || VA();
}
function VA() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function GA(e, t) {
  if (e) {
    if (typeof e == "string")
      return Fv(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set")
      return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return Fv(e, t);
  }
}
function Fv(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, i = new Array(t); n < t; n++)
    i[n] = e[n];
  return i;
}
function UA(e, t) {
  var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var i, o, a, r, s = [], l = !0, d = !1;
    try {
      if (a = (n = n.call(e)).next, t === 0) {
        if (Object(n) !== n)
          return;
        l = !1;
      } else
        for (; !(l = (i = a.call(n)).done) && (s.push(i.value), s.length !== t); l = !0)
          ;
    } catch (y) {
      d = !0, o = y;
    } finally {
      try {
        if (!l && n.return != null && (r = n.return(), Object(r) !== r))
          return;
      } finally {
        if (d)
          throw o;
      }
    }
    return s;
  }
}
function WA(e) {
  if (Array.isArray(e))
    return e;
}
function jv(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    t && (i = i.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), n.push.apply(n, i);
  }
  return n;
}
function np(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? jv(Object(n), !0).forEach(function(i) {
      YA(e, i, n[i]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : jv(Object(n)).forEach(function(i) {
      Object.defineProperty(e, i, Object.getOwnPropertyDescriptor(n, i));
    });
  }
  return e;
}
function YA(e, t, n) {
  return t = qA(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function qA(e) {
  var t = KA(e, "string");
  return Nl(t) == "symbol" ? t : String(t);
}
function KA(e, t) {
  if (Nl(e) != "object" || !e)
    return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var i = n.call(e, t || "default");
    if (Nl(i) != "object")
      return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var XA = `
.p-hidden-accessible {
    border: 0;
    clip: rect(0 0 0 0);
    height: 1px;
    margin: -1px;
    overflow: hidden;
    padding: 0;
    position: absolute;
    width: 1px;
}

.p-hidden-accessible input,
.p-hidden-accessible select {
    transform: scale(0);
}

.p-overflow-hidden {
    overflow: hidden;
    padding-right: var(--scrollbar-width);
}
`, ZA = {}, JA = {}, Wt = {
  name: "base",
  css: XA,
  classes: ZA,
  inlineStyles: JA,
  loadStyle: function() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return this.css ? vw(this.css, np({
      name: this.name
    }, t)) : {};
  },
  getStyleSheet: function() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (this.css) {
      var i = Object.entries(n).reduce(function(o, a) {
        var r = zA(a, 2), s = r[0], l = r[1];
        return o.push("".concat(s, '="').concat(l, '"')) && o;
      }, []).join(" ");
      return '<style type="text/css" data-primevue-style-id="'.concat(this.name, '" ').concat(i, ">").concat(this.css).concat(t, "</style>");
    }
    return "";
  },
  extend: function(t) {
    return np(np({}, this), {}, {
      css: void 0
    }, t);
  }
};
function $l(e) {
  "@babel/helpers - typeof";
  return $l = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, $l(e);
}
function Hv(e, t) {
  return n_(e) || t_(e, t) || e_(e, t) || QA();
}
function QA() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function e_(e, t) {
  if (e) {
    if (typeof e == "string")
      return zv(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set")
      return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return zv(e, t);
  }
}
function zv(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, i = new Array(t); n < t; n++)
    i[n] = e[n];
  return i;
}
function t_(e, t) {
  var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var i, o, a, r, s = [], l = !0, d = !1;
    try {
      if (a = (n = n.call(e)).next, t === 0) {
        if (Object(n) !== n)
          return;
        l = !1;
      } else
        for (; !(l = (i = a.call(n)).done) && (s.push(i.value), s.length !== t); l = !0)
          ;
    } catch (y) {
      d = !0, o = y;
    } finally {
      try {
        if (!l && n.return != null && (r = n.return(), Object(r) !== r))
          return;
      } finally {
        if (d)
          throw o;
      }
    }
    return s;
  }
}
function n_(e) {
  if (Array.isArray(e))
    return e;
}
function Vv(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    t && (i = i.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), n.push.apply(n, i);
  }
  return n;
}
function Tn(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Vv(Object(n), !0).forEach(function(i) {
      Gp(e, i, n[i]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Vv(Object(n)).forEach(function(i) {
      Object.defineProperty(e, i, Object.getOwnPropertyDescriptor(n, i));
    });
  }
  return e;
}
function Gp(e, t, n) {
  return t = i_(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function i_(e) {
  var t = a_(e, "string");
  return $l(t) == "symbol" ? t : String(t);
}
function a_(e, t) {
  if ($l(e) != "object" || !e)
    return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var i = n.call(e, t || "default");
    if ($l(i) != "object")
      return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var tn = {
  _getMeta: function() {
    return [We.isObject(arguments.length <= 0 ? void 0 : arguments[0]) || arguments.length <= 0 ? void 0 : arguments[0], We.getItemValue(We.isObject(arguments.length <= 0 ? void 0 : arguments[0]) ? arguments.length <= 0 ? void 0 : arguments[0] : arguments.length <= 1 ? void 0 : arguments[1])];
  },
  _getConfig: function(t, n) {
    var i, o, a;
    return (i = (t == null || (o = t.instance) === null || o === void 0 ? void 0 : o.$primevue) || (n == null || (a = n.ctx) === null || a === void 0 || (a = a.appContext) === null || a === void 0 || (a = a.config) === null || a === void 0 || (a = a.globalProperties) === null || a === void 0 ? void 0 : a.$primevue)) === null || i === void 0 ? void 0 : i.config;
  },
  _getOptionValue: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, o = We.toFlatCase(n).split("."), a = o.shift();
    return a ? We.isObject(t) ? tn._getOptionValue(We.getItemValue(t[Object.keys(t).find(function(r) {
      return We.toFlatCase(r) === a;
    }) || ""], i), o.join("."), i) : void 0 : We.getItemValue(t, i);
  },
  _getPTValue: function() {
    var t, n, i = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, a = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "", r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {}, s = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : !0, l = function() {
      var S = tn._getOptionValue.apply(tn, arguments);
      return We.isString(S) || We.isArray(S) ? {
        class: S
      } : S;
    }, d = "data-pc-", y = ((t = i.binding) === null || t === void 0 || (t = t.value) === null || t === void 0 ? void 0 : t.ptOptions) || ((n = i.$config) === null || n === void 0 ? void 0 : n.ptOptions) || {}, u = y.mergeSections, m = u === void 0 ? !0 : u, h = y.mergeProps, c = h === void 0 ? !1 : h, g = s ? tn._useDefaultPT(i, i.defaultPT(), l, a, r) : void 0, v = tn._usePT(i, tn._getPT(o, i.$name), l, a, Tn(Tn({}, r), {}, {
      global: g || {}
    })), P = Tn(Tn({}, a === "root" && Gp({}, "".concat(d, "name"), We.toFlatCase(i.$name))), {}, Gp({}, "".concat(d, "section"), We.toFlatCase(a)));
    return m || !m && v ? c ? Ce(g, v, P) : Tn(Tn(Tn({}, g), v), P) : Tn(Tn({}, v), P);
  },
  _getPT: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", i = arguments.length > 2 ? arguments[2] : void 0, o = function(r) {
      var s, l = i ? i(r) : r, d = We.toFlatCase(n);
      return (s = l?.[d]) !== null && s !== void 0 ? s : l;
    };
    return t != null && t.hasOwnProperty("_usept") ? {
      _usept: t._usept,
      originalValue: o(t.originalValue),
      value: o(t.value)
    } : o(t);
  },
  _usePT: function() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = arguments.length > 1 ? arguments[1] : void 0, i = arguments.length > 2 ? arguments[2] : void 0, o = arguments.length > 3 ? arguments[3] : void 0, a = arguments.length > 4 ? arguments[4] : void 0, r = function(v) {
      return i(v, o, a);
    };
    if (n != null && n.hasOwnProperty("_usept")) {
      var s, l = n._usept || ((s = t.$config) === null || s === void 0 ? void 0 : s.ptOptions) || {}, d = l.mergeSections, y = d === void 0 ? !0 : d, u = l.mergeProps, m = u === void 0 ? !1 : u, h = r(n.originalValue), c = r(n.value);
      return h === void 0 && c === void 0 ? void 0 : We.isString(c) ? c : We.isString(h) ? h : y || !y && c ? m ? Ce(h, c) : Tn(Tn({}, h), c) : c;
    }
    return r(n);
  },
  _useDefaultPT: function() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, i = arguments.length > 2 ? arguments[2] : void 0, o = arguments.length > 3 ? arguments[3] : void 0, a = arguments.length > 4 ? arguments[4] : void 0;
    return tn._usePT(t, n, i, o, a);
  },
  _hook: function(t, n, i, o, a, r) {
    var s, l, d = "on".concat(We.toCapitalCase(n)), y = tn._getConfig(o, a), u = i?.$instance, m = tn._usePT(u, tn._getPT(o == null || (s = o.value) === null || s === void 0 ? void 0 : s.pt, t), tn._getOptionValue, "hooks.".concat(d)), h = tn._useDefaultPT(u, y == null || (l = y.pt) === null || l === void 0 || (l = l.directives) === null || l === void 0 ? void 0 : l[t], tn._getOptionValue, "hooks.".concat(d)), c = {
      el: i,
      binding: o,
      vnode: a,
      prevVnode: r
    };
    m?.(u, c), h?.(u, c);
  },
  _extend: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, i = function(a, r, s, l, d) {
      var y, u;
      r._$instances = r._$instances || {};
      var m = tn._getConfig(s, l), h = r._$instances[t] || {}, c = We.isEmpty(h) ? Tn(Tn({}, n), n?.methods) : {};
      r._$instances[t] = Tn(Tn({}, h), {}, {
        /* new instance variables to pass in directive methods */
        $name: t,
        $host: r,
        $binding: s,
        $modifiers: s?.modifiers,
        $value: s?.value,
        $el: h.$el || r || void 0,
        $style: Tn({
          classes: void 0,
          inlineStyles: void 0,
          loadStyle: function() {
          }
        }, n?.style),
        $config: m,
        /* computed instance variables */
        defaultPT: function() {
          return tn._getPT(m?.pt, void 0, function(v) {
            var P;
            return v == null || (P = v.directives) === null || P === void 0 ? void 0 : P[t];
          });
        },
        isUnstyled: function() {
          var v, P;
          return ((v = r.$instance) === null || v === void 0 || (v = v.$binding) === null || v === void 0 || (v = v.value) === null || v === void 0 ? void 0 : v.unstyled) !== void 0 ? (P = r.$instance) === null || P === void 0 || (P = P.$binding) === null || P === void 0 || (P = P.value) === null || P === void 0 ? void 0 : P.unstyled : m?.unstyled;
        },
        /* instance's methods */
        ptm: function() {
          var v, P = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", f = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
          return tn._getPTValue(r.$instance, (v = r.$instance) === null || v === void 0 || (v = v.$binding) === null || v === void 0 || (v = v.value) === null || v === void 0 ? void 0 : v.pt, P, Tn({}, f));
        },
        ptmo: function() {
          var v = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, P = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", f = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
          return tn._getPTValue(r.$instance, v, P, f, !1);
        },
        cx: function() {
          var v, P, f = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", S = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
          return (v = r.$instance) !== null && v !== void 0 && v.isUnstyled() ? void 0 : tn._getOptionValue((P = r.$instance) === null || P === void 0 || (P = P.$style) === null || P === void 0 ? void 0 : P.classes, f, Tn({}, S));
        },
        sx: function() {
          var v, P = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", f = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0, S = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
          return f ? tn._getOptionValue((v = r.$instance) === null || v === void 0 || (v = v.$style) === null || v === void 0 ? void 0 : v.inlineStyles, P, Tn({}, S)) : void 0;
        }
      }, c), r.$instance = r._$instances[t], (y = (u = r.$instance)[a]) === null || y === void 0 || y.call(u, r, s, l, d), tn._hook(t, a, r, s, l, d);
    };
    return {
      created: function(a, r, s, l) {
        i("created", a, r, s, l);
      },
      beforeMount: function(a, r, s, l) {
        var d, y, u, m, h = tn._getConfig(r, s);
        Wt.loadStyle(void 0, {
          nonce: h == null || (d = h.csp) === null || d === void 0 ? void 0 : d.nonce
        }), !((y = a.$instance) !== null && y !== void 0 && y.isUnstyled()) && ((u = a.$instance) === null || u === void 0 || (u = u.$style) === null || u === void 0 || u.loadStyle(void 0, {
          nonce: h == null || (m = h.csp) === null || m === void 0 ? void 0 : m.nonce
        })), i("beforeMount", a, r, s, l);
      },
      mounted: function(a, r, s, l) {
        i("mounted", a, r, s, l);
      },
      beforeUpdate: function(a, r, s, l) {
        i("beforeUpdate", a, r, s, l);
      },
      updated: function(a, r, s, l) {
        i("updated", a, r, s, l);
      },
      beforeUnmount: function(a, r, s, l) {
        i("beforeUnmount", a, r, s, l);
      },
      unmounted: function(a, r, s, l) {
        i("unmounted", a, r, s, l);
      }
    };
  },
  extend: function() {
    var t = tn._getMeta.apply(tn, arguments), n = Hv(t, 2), i = n[0], o = n[1];
    return Tn({
      extend: function() {
        var r = tn._getMeta.apply(tn, arguments), s = Hv(r, 2), l = s[0], d = s[1];
        return tn.extend(l, Tn(Tn(Tn({}, o), o?.methods), d));
      }
    }, tn._extend(i, o));
  }
}, o_ = `
@layer primevue {
    .p-tooltip {
        position:absolute;
        display:none;
        padding: .25em .5rem;
        max-width: 12.5rem;
    }

    .p-tooltip.p-tooltip-right,
    .p-tooltip.p-tooltip-left {
        padding: 0 .25rem;
    }

    .p-tooltip.p-tooltip-top,
    .p-tooltip.p-tooltip-bottom {
        padding:.25em 0;
    }

    .p-tooltip .p-tooltip-text {
        white-space: pre-line;
        word-break: break-word;
    }

    .p-tooltip-arrow {
        position: absolute;
        width: 0;
        height: 0;
        border-color: transparent;
        border-style: solid;
        scale: 2;
    }

    .p-tooltip-right .p-tooltip-arrow {
        margin-top: -.25rem;
        border-width: .25em .25em .25em 0;
    }

    .p-tooltip-left .p-tooltip-arrow {
        margin-top: -.25rem;
        border-width: .25em 0 .25em .25rem;
    }

    .p-tooltip.p-tooltip-top {
        padding: .25em 0;
    }

    .p-tooltip-top .p-tooltip-arrow {
        margin-left: -.25rem;
        border-width: .25em .25em 0;
    }

    .p-tooltip-bottom .p-tooltip-arrow {
        margin-left: -.25rem;
        border-width: 0 .25em .25rem;
    }
}
`, r_ = {
  root: "p-tooltip p-component",
  arrow: "p-tooltip-arrow",
  text: "p-tooltip-text"
}, s_ = Wt.extend({
  name: "tooltip",
  css: o_,
  classes: r_
}), l_ = tn.extend({
  style: s_
});
function c_(e, t) {
  return p_(e) || h_(e, t) || u_(e, t) || d_();
}
function d_() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function u_(e, t) {
  if (e) {
    if (typeof e == "string")
      return Gv(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set")
      return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return Gv(e, t);
  }
}
function Gv(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, i = new Array(t); n < t; n++)
    i[n] = e[n];
  return i;
}
function h_(e, t) {
  var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var i, o, a, r, s = [], l = !0, d = !1;
    try {
      if (a = (n = n.call(e)).next, t === 0) {
        if (Object(n) !== n)
          return;
        l = !1;
      } else
        for (; !(l = (i = a.call(n)).done) && (s.push(i.value), s.length !== t); l = !0)
          ;
    } catch (y) {
      d = !0, o = y;
    } finally {
      try {
        if (!l && n.return != null && (r = n.return(), Object(r) !== r))
          return;
      } finally {
        if (d)
          throw o;
      }
    }
    return s;
  }
}
function p_(e) {
  if (Array.isArray(e))
    return e;
}
function Tl(e) {
  "@babel/helpers - typeof";
  return Tl = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Tl(e);
}
var Yu = l_.extend("tooltip", {
  beforeMount: function(t, n) {
    var i, o = this.getTarget(t);
    if (o.$_ptooltipModifiers = this.getModifiers(n), n.value) {
      if (typeof n.value == "string")
        o.$_ptooltipValue = n.value, o.$_ptooltipDisabled = !1, o.$_ptooltipEscape = !0, o.$_ptooltipClass = null, o.$_ptooltipFitContent = !0, o.$_ptooltipIdAttr = Mt() + "_tooltip", o.$_ptooltipShowDelay = 0, o.$_ptooltipHideDelay = 0, o.$_ptooltipAutoHide = !0;
      else if (Tl(n.value) === "object" && n.value) {
        if (We.isEmpty(n.value.value) || n.value.value.trim() === "")
          return;
        o.$_ptooltipValue = n.value.value, o.$_ptooltipDisabled = !!n.value.disabled === n.value.disabled ? n.value.disabled : !1, o.$_ptooltipEscape = !!n.value.escape === n.value.escape ? n.value.escape : !0, o.$_ptooltipClass = n.value.class || "", o.$_ptooltipFitContent = !!n.value.fitContent === n.value.fitContent ? n.value.fitContent : !0, o.$_ptooltipIdAttr = n.value.id || Mt() + "_tooltip", o.$_ptooltipShowDelay = n.value.showDelay || 0, o.$_ptooltipHideDelay = n.value.hideDelay || 0, o.$_ptooltipAutoHide = !!n.value.autoHide === n.value.autoHide ? n.value.autoHide : !0;
      }
    } else
      return;
    o.$_ptooltipZIndex = (i = n.instance.$primevue) === null || i === void 0 || (i = i.config) === null || i === void 0 || (i = i.zIndex) === null || i === void 0 ? void 0 : i.tooltip, this.bindEvents(o, n), t.setAttribute("data-pd-tooltip", !0);
  },
  updated: function(t, n) {
    var i = this.getTarget(t);
    if (i.$_ptooltipModifiers = this.getModifiers(n), this.unbindEvents(i), !!n.value) {
      if (typeof n.value == "string")
        i.$_ptooltipValue = n.value, i.$_ptooltipDisabled = !1, i.$_ptooltipEscape = !0, i.$_ptooltipClass = null, i.$_ptooltipIdAttr = i.$_ptooltipIdAttr || Mt() + "_tooltip", i.$_ptooltipShowDelay = 0, i.$_ptooltipHideDelay = 0, i.$_ptooltipAutoHide = !0, this.bindEvents(i, n);
      else if (Tl(n.value) === "object" && n.value)
        if (We.isEmpty(n.value.value) || n.value.value.trim() === "") {
          this.unbindEvents(i, n);
          return;
        } else
          i.$_ptooltipValue = n.value.value, i.$_ptooltipDisabled = !!n.value.disabled === n.value.disabled ? n.value.disabled : !1, i.$_ptooltipEscape = !!n.value.escape === n.value.escape ? n.value.escape : !0, i.$_ptooltipClass = n.value.class || "", i.$_ptooltipFitContent = !!n.value.fitContent === n.value.fitContent ? n.value.fitContent : !0, i.$_ptooltipIdAttr = n.value.id || i.$_ptooltipIdAttr || Mt() + "_tooltip", i.$_ptooltipShowDelay = n.value.showDelay || 0, i.$_ptooltipHideDelay = n.value.hideDelay || 0, i.$_ptooltipAutoHide = !!n.value.autoHide === n.value.autoHide ? n.value.autoHide : !0, this.bindEvents(i, n);
    }
  },
  unmounted: function(t, n) {
    var i = this.getTarget(t);
    this.remove(i), this.unbindEvents(i, n), i.$_ptooltipScrollHandler && (i.$_ptooltipScrollHandler.destroy(), i.$_ptooltipScrollHandler = null);
  },
  timer: void 0,
  methods: {
    bindEvents: function(t, n) {
      var i = this, o = t.$_ptooltipModifiers;
      o.focus ? (t.$_focusevent = function(a) {
        return i.onFocus(a, n);
      }, t.addEventListener("focus", t.$_focusevent), t.addEventListener("blur", this.onBlur.bind(this))) : (t.$_mouseenterevent = function(a) {
        return i.onMouseEnter(a, n);
      }, t.addEventListener("mouseenter", t.$_mouseenterevent), t.addEventListener("mouseleave", this.onMouseLeave.bind(this)), t.addEventListener("click", this.onClick.bind(this))), t.addEventListener("keydown", this.onKeydown.bind(this));
    },
    unbindEvents: function(t) {
      var n = t.$_ptooltipModifiers;
      n.focus ? (t.removeEventListener("focus", t.$_focusevent), t.$_focusevent = null, t.removeEventListener("blur", this.onBlur.bind(this))) : (t.removeEventListener("mouseenter", t.$_mouseenterevent), t.$_mouseenterevent = null, t.removeEventListener("mouseleave", this.onMouseLeave.bind(this)), t.removeEventListener("click", this.onClick.bind(this))), t.removeEventListener("keydown", this.onKeydown.bind(this));
    },
    bindScrollListener: function(t) {
      var n = this;
      t.$_ptooltipScrollHandler || (t.$_ptooltipScrollHandler = new po(t, function() {
        n.hide(t);
      })), t.$_ptooltipScrollHandler.bindScrollListener();
    },
    unbindScrollListener: function(t) {
      t.$_ptooltipScrollHandler && t.$_ptooltipScrollHandler.unbindScrollListener();
    },
    onMouseEnter: function(t, n) {
      var i = t.currentTarget, o = i.$_ptooltipShowDelay;
      this.show(i, n, o);
    },
    onMouseLeave: function(t) {
      var n = t.currentTarget, i = n.$_ptooltipHideDelay, o = n.$_ptooltipAutoHide;
      if (o)
        this.hide(n, i);
      else {
        var a = Oe.getAttribute(t.target, "data-pc-name") === "tooltip" || Oe.getAttribute(t.target, "data-pc-section") === "arrow" || Oe.getAttribute(t.target, "data-pc-section") === "text" || Oe.getAttribute(t.relatedTarget, "data-pc-name") === "tooltip" || Oe.getAttribute(t.relatedTarget, "data-pc-section") === "arrow" || Oe.getAttribute(t.relatedTarget, "data-pc-section") === "text";
        !a && this.hide(n, i);
      }
    },
    onFocus: function(t, n) {
      var i = t.currentTarget, o = i.$_ptooltipShowDelay;
      this.show(i, n, o);
    },
    onBlur: function(t) {
      var n = t.currentTarget, i = n.$_ptooltipHideDelay;
      this.hide(n, i);
    },
    onClick: function(t) {
      var n = t.currentTarget, i = n.$_ptooltipHideDelay;
      this.hide(n, i);
    },
    onKeydown: function(t) {
      var n = t.currentTarget, i = n.$_ptooltipHideDelay;
      t.code === "Escape" && this.hide(t.currentTarget, i);
    },
    tooltipActions: function(t, n) {
      if (!(t.$_ptooltipDisabled || !Oe.isExist(t))) {
        var i = this.create(t, n);
        this.align(t), !this.isUnstyled() && Oe.fadeIn(i, 250);
        var o = this;
        window.addEventListener("resize", function a() {
          Oe.isTouchDevice() || o.hide(t), window.removeEventListener("resize", a);
        }), i.addEventListener("mouseleave", function a() {
          o.hide(t), i.removeEventListener("mouseleave", a);
        }), this.bindScrollListener(t), qt.set("tooltip", i, t.$_ptooltipZIndex);
      }
    },
    show: function(t, n, i) {
      var o = this;
      i !== void 0 ? this.timer = setTimeout(function() {
        return o.tooltipActions(t, n);
      }, i) : this.tooltipActions(t, n);
    },
    tooltipRemoval: function(t) {
      this.remove(t), this.unbindScrollListener(t);
    },
    hide: function(t, n) {
      var i = this;
      clearTimeout(this.timer), n !== void 0 ? setTimeout(function() {
        return i.tooltipRemoval(t);
      }, n) : this.tooltipRemoval(t);
    },
    getTooltipElement: function(t) {
      return document.getElementById(t.$_ptooltipId);
    },
    create: function(t, n) {
      var i = t.$_ptooltipModifiers, o = Oe.createElement("div", {
        class: !this.isUnstyled() && this.cx("arrow"),
        style: {
          top: i != null && i.bottom ? "0" : i != null && i.right || i != null && i.left || !(i != null && i.right) && !(i != null && i.left) && !(i != null && i.top) && !(i != null && i.bottom) ? "50%" : null,
          bottom: i != null && i.top ? "0" : null,
          left: i != null && i.right || !(i != null && i.right) && !(i != null && i.left) && !(i != null && i.top) && !(i != null && i.bottom) ? "0" : i != null && i.top || i != null && i.bottom ? "50%" : null,
          right: i != null && i.left ? "0" : null
        },
        "p-bind": this.ptm("arrow", {
          context: i
        })
      }), a = Oe.createElement("div", {
        class: !this.isUnstyled() && this.cx("text"),
        "p-bind": this.ptm("text", {
          context: i
        })
      });
      t.$_ptooltipEscape ? (a.innerHTML = "", a.appendChild(document.createTextNode(t.$_ptooltipValue))) : a.innerHTML = t.$_ptooltipValue;
      var r = Oe.createElement("div", {
        id: t.$_ptooltipIdAttr,
        role: "tooltip",
        style: {
          display: "inline-block",
          width: t.$_ptooltipFitContent ? "fit-content" : void 0,
          pointerEvents: !this.isUnstyled() && t.$_ptooltipAutoHide && "none"
        },
        class: [!this.isUnstyled() && this.cx("root"), t.$_ptooltipClass],
        "p-bind": this.ptm("root", {
          context: i
        })
      }, o, a);
      return document.body.appendChild(r), t.$_ptooltipId = r.id, this.$el = r, r;
    },
    remove: function(t) {
      if (t) {
        var n = this.getTooltipElement(t);
        n && n.parentElement && (qt.clear(n), document.body.removeChild(n)), t.$_ptooltipId = null;
      }
    },
    align: function(t) {
      var n = t.$_ptooltipModifiers;
      n.top ? (this.alignTop(t), this.isOutOfBounds(t) && (this.alignBottom(t), this.isOutOfBounds(t) && this.alignTop(t))) : n.left ? (this.alignLeft(t), this.isOutOfBounds(t) && (this.alignRight(t), this.isOutOfBounds(t) && (this.alignTop(t), this.isOutOfBounds(t) && (this.alignBottom(t), this.isOutOfBounds(t) && this.alignLeft(t))))) : n.bottom ? (this.alignBottom(t), this.isOutOfBounds(t) && (this.alignTop(t), this.isOutOfBounds(t) && this.alignBottom(t))) : (this.alignRight(t), this.isOutOfBounds(t) && (this.alignLeft(t), this.isOutOfBounds(t) && (this.alignTop(t), this.isOutOfBounds(t) && (this.alignBottom(t), this.isOutOfBounds(t) && this.alignRight(t)))));
    },
    getHostOffset: function(t) {
      var n = t.getBoundingClientRect(), i = n.left + Oe.getWindowScrollLeft(), o = n.top + Oe.getWindowScrollTop();
      return {
        left: i,
        top: o
      };
    },
    alignRight: function(t) {
      this.preAlign(t, "right");
      var n = this.getTooltipElement(t), i = this.getHostOffset(t), o = i.left + Oe.getOuterWidth(t), a = i.top + (Oe.getOuterHeight(t) - Oe.getOuterHeight(n)) / 2;
      n.style.left = o + "px", n.style.top = a + "px";
    },
    alignLeft: function(t) {
      this.preAlign(t, "left");
      var n = this.getTooltipElement(t), i = this.getHostOffset(t), o = i.left - Oe.getOuterWidth(n), a = i.top + (Oe.getOuterHeight(t) - Oe.getOuterHeight(n)) / 2;
      n.style.left = o + "px", n.style.top = a + "px";
    },
    alignTop: function(t) {
      this.preAlign(t, "top");
      var n = this.getTooltipElement(t), i = this.getHostOffset(t), o = i.left + (Oe.getOuterWidth(t) - Oe.getOuterWidth(n)) / 2, a = i.top - Oe.getOuterHeight(n);
      n.style.left = o + "px", n.style.top = a + "px";
    },
    alignBottom: function(t) {
      this.preAlign(t, "bottom");
      var n = this.getTooltipElement(t), i = this.getHostOffset(t), o = i.left + (Oe.getOuterWidth(t) - Oe.getOuterWidth(n)) / 2, a = i.top + Oe.getOuterHeight(t);
      n.style.left = o + "px", n.style.top = a + "px";
    },
    preAlign: function(t, n) {
      var i = this.getTooltipElement(t);
      i.style.left = "-999px", i.style.top = "-999px", Oe.removeClass(i, "p-tooltip-".concat(i.$_ptooltipPosition)), !this.isUnstyled() && Oe.addClass(i, "p-tooltip-".concat(n)), i.$_ptooltipPosition = n, i.setAttribute("data-p-position", n);
    },
    isOutOfBounds: function(t) {
      var n = this.getTooltipElement(t), i = n.getBoundingClientRect(), o = i.top, a = i.left, r = Oe.getOuterWidth(n), s = Oe.getOuterHeight(n), l = Oe.getViewport();
      return a + r > l.width || a < 0 || o < 0 || o + s > l.height;
    },
    getTarget: function(t) {
      return Oe.hasClass(t, "p-inputwrapper") ? Oe.findSingle(t, "input") : t;
    },
    getModifiers: function(t) {
      return t.modifiers && Object.keys(t.modifiers).length ? t.modifiers : t.arg && Tl(t.arg) === "object" ? Object.entries(t.arg).reduce(function(n, i) {
        var o = c_(i, 2), a = o[0], r = o[1];
        return (a === "event" || a === "position") && (n[r] = !0), n;
      }, {}) : {};
    }
  }
});
const f_ = Be({
  name: "SRRIndicator",
  directives: {
    tooltip: Yu
  },
  props: {
    rating: {
      type: Number,
      required: !0,
      default: 1,
      lastId: null
    }
  },
  data() {
    return {
      srri: [1, 2, 3, 4, 5, 6, 7],
      uuid: Pn()
    };
  },
  methods: {
    onTouch(e) {
      if (this.focusActive = !this.focusActive, Ue) {
        const t = document.getElementById(e);
        this.focusActive ? (t.setAttribute("tabindex", "0"), t.focus()) : (t.removeAttribute("tabindex"), t.blur()), this.lastId !== e && (t.setAttribute("tabindex", "0"), t.focus(), this.focusActive = !0), this.lastId = e;
      }
    },
    onBlur() {
      this.focusActive = !1;
    }
  }
}), m_ = { class: "srr-indicator" }, g_ = ["id"], v_ = ["id", "onTouchstartPassive"];
function y_(e, t, n, i, o, a) {
  const r = Ut("tooltip");
  return E(), X("div", m_, [
    (E(!0), X(Re, null, Ge(e.srri, (s, l) => rt((E(), X("span", {
      id: `rate-${l}-${e.uuid}`,
      key: l,
      class: Pe(["srr-element hidden xxl:inline-block", {
        "active-rating": s == e.rating
      }])
    }, [
      Ve(Ie(s), 1)
    ], 10, g_)), [
      [
        r,
        {
          value: "SRRI: " + s,
          class: "custom-wide-tooltip",
          disabled: s != e.rating,
          fitContent: !0
        },
        void 0,
        { top: !0 }
      ]
    ])), 128)),
    (E(!0), X(Re, null, Ge(e.srri, (s, l) => rt((E(), X("span", {
      id: `rate-${l}-${e.uuid}`,
      key: l,
      class: Pe(["srr-element inline-block xxl:hidden", {
        "active-rating": s == e.rating
      }]),
      tabindex: -1,
      onTouchstartPassive: (d) => e.onTouch(`rate-${l}-${e.uuid}`),
      onBlurPassive: t[0] || (t[0] = (...d) => e.onBlur && e.onBlur(...d))
    }, [
      Ve(Ie(s), 1)
    ], 42, v_)), [
      [
        r,
        {
          value: "SRRI: " + s,
          class: "custom-wide-tooltip",
          disabled: s != e.rating,
          fitContent: !0
        },
        void 0,
        {
          top: !0,
          focus: !0
        }
      ]
    ])), 128))
  ]);
}
const b_ = /* @__PURE__ */ Fe(f_, [["render", y_]]);
const x_ = Be({
  name: "LipperRating",
  directives: {
    tooltip: Yu
  },
  props: {
    values: {
      type: Array,
      required: !0,
      lastId: null
    }
  },
  data() {
    return {
      uuid: Pn()
    };
  },
  methods: {
    onTouch(e) {
      if (this.focusActive = !this.focusActive, Ue) {
        const t = document.getElementById(e);
        this.focusActive ? (t.setAttribute("tabindex", "0"), t.focus()) : (t.removeAttribute("tabindex"), t.blur()), this.lastId !== e && (t.setAttribute("tabindex", "0"), t.focus(), this.focusActive = !0), this.lastId = e;
      }
    },
    onBlur() {
      this.focusActive = !1;
    }
  }
}), w_ = { class: "lipper-rating" }, k_ = ["id"], S_ = ["id", "onTouchstartPassive"];
function C_(e, t, n, i, o, a) {
  const r = Ut("tooltip");
  return E(), X("div", w_, [
    (E(!0), X(Re, null, Ge(e.values, (s, l) => rt((E(), X("span", {
      id: `rate-${l}-${e.uuid}`,
      key: l,
      class: Pe([{
        "lipper-circle-inverted": s.rating === 5,
        "lipper-circle ": s.rating >= 1 && s.rating <= 4
      }, "xs:hidden xxl:inline-block"])
    }, [
      Ve(Ie(s.rating), 1)
    ], 10, k_)), [
      [
        r,
        s.text + ": " + s.rating,
        void 0,
        { top: !0 }
      ]
    ])), 128)),
    (E(!0), X(Re, null, Ge(e.values, (s, l) => rt((E(), X("span", {
      id: `mobilerate-${l}-${e.uuid}`,
      key: l,
      class: Pe([{
        "lipper-circle-inverted": s.rating === 5,
        "lipper-circle ": s.rating >= 1 && s.rating <= 4
      }, "xs:inline-block xxl:hidden"]),
      tabindex: -1,
      onTouchstartPassive: (d) => e.onTouch(`mobilerate-${l}-${e.uuid}`),
      onBlurPassive: t[0] || (t[0] = (...d) => e.onBlur && e.onBlur(...d))
    }, [
      Ve(Ie(s.rating), 1)
    ], 42, S_)), [
      [
        r,
        s.text + ": " + s.rating,
        void 0,
        {
          top: !0,
          focus: !0
        }
      ]
    ])), 128))
  ]);
}
const yw = /* @__PURE__ */ Fe(x_, [["render", C_]]);
const T_ = /* @__PURE__ */ Ha("jump", {
  state: () => ({
    shouldOpen: !1
  }),
  actions: {
    openSelectedAccordionItem() {
      this.shouldOpen = !this.shouldOpen;
    }
  }
});
function Fl(e) {
  "@babel/helpers - typeof";
  return Fl = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Fl(e);
}
function Uv(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    t && (i = i.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), n.push.apply(n, i);
  }
  return n;
}
function L_(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Uv(Object(n), !0).forEach(function(i) {
      I_(e, i, n[i]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Uv(Object(n)).forEach(function(i) {
      Object.defineProperty(e, i, Object.getOwnPropertyDescriptor(n, i));
    });
  }
  return e;
}
function I_(e, t, n) {
  return t = P_(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function P_(e) {
  var t = A_(e, "string");
  return Fl(t) == "symbol" ? t : String(t);
}
function A_(e, t) {
  if (Fl(e) != "object" || !e)
    return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var i = n.call(e, t || "default");
    if (Fl(i) != "object")
      return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var __ = `
.p-button {
    display: inline-flex;
    cursor: pointer;
    user-select: none;
    align-items: center;
    vertical-align: bottom;
    text-align: center;
    overflow: hidden;
    position: relative;
}

.p-button-label {
    flex: 1 1 auto;
}

.p-button-icon-right {
    order: 1;
}

.p-button:disabled {
    cursor: default;
}

.p-button-icon-only {
    justify-content: center;
}

.p-button-icon-only .p-button-label {
    visibility: hidden;
    width: 0;
    flex: 0 0 auto;
}

.p-button-vertical {
    flex-direction: column;
}

.p-button-icon-bottom {
    order: 2;
}

.p-buttonset .p-button {
    margin: 0;
}

.p-buttonset .p-button:not(:last-child), .p-buttonset .p-button:not(:last-child):hover {
    border-right: 0 none;
}

.p-buttonset .p-button:not(:first-of-type):not(:last-of-type) {
    border-radius: 0;
}

.p-buttonset .p-button:first-of-type:not(:only-of-type) {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
}

.p-buttonset .p-button:last-of-type:not(:only-of-type) {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
}

.p-buttonset .p-button:focus {
    position: relative;
    z-index: 1;
}
`, M_ = `
.p-checkbox {
    display: inline-flex;
    cursor: pointer;
    user-select: none;
    vertical-align: bottom;
    position: relative;
}

.p-checkbox.p-checkbox-disabled {
    cursor: default;
}

.p-checkbox-box {
    display: flex;
    justify-content: center;
    align-items: center;
}
`, O_ = `
.p-fluid .p-inputtext {
    width: 100%;
}

/* InputGroup */
.p-inputgroup {
    display: flex;
    align-items: stretch;
    width: 100%;
}

.p-inputgroup-addon {
    display: flex;
    align-items: center;
    justify-content: center;
}

.p-inputgroup .p-float-label {
    display: flex;
    align-items: stretch;
    width: 100%;
}

.p-inputgroup .p-inputtext,
.p-fluid .p-inputgroup .p-inputtext,
.p-inputgroup .p-inputwrapper,
.p-fluid .p-inputgroup .p-input {
    flex: 1 1 auto;
    width: 1%;
}

/* Floating Label */
.p-float-label {
    display: block;
    position: relative;
}

.p-float-label label {
    position: absolute;
    pointer-events: none;
    top: 50%;
    margin-top: -.5rem;
    transition-property: all;
    transition-timing-function: ease;
    line-height: 1;
}

.p-float-label textarea ~ label {
    top: 1rem;
}

.p-float-label input:focus ~ label,
.p-float-label input.p-filled ~ label,
.p-float-label input:-webkit-autofill ~ label,
.p-float-label textarea:focus ~ label,
.p-float-label textarea.p-filled ~ label,
.p-float-label .p-inputwrapper-focus ~ label,
.p-float-label .p-inputwrapper-filled ~ label {
    top: -.75rem;
    font-size: 12px;
}


.p-float-label .p-placeholder,
.p-float-label input::placeholder,
.p-float-label .p-inputtext::placeholder {
    opacity: 0;
    transition-property: all;
    transition-timing-function: ease;
}

.p-float-label .p-focus .p-placeholder,
.p-float-label input:focus::placeholder,
.p-float-label .p-inputtext:focus::placeholder {
    opacity: 1;
    transition-property: all;
    transition-timing-function: ease;
}

.p-input-icon-left,
.p-input-icon-right {
    position: relative;
    display: inline-block;
}

.p-input-icon-left > i,
.p-input-icon-left > svg,
.p-input-icon-right > i,
.p-input-icon-right > svg {
    position: absolute;
    top: 50%;
    margin-top: -.5rem;
}

.p-fluid .p-input-icon-left,
.p-fluid .p-input-icon-right {
    display: block;
    width: 100%;
}
`, B_ = `
.p-radiobutton {
    position: relative;
    display: inline-flex;
    cursor: pointer;
    user-select: none;
    vertical-align: bottom;
}

.p-radiobutton.p-radiobutton-disabled {
    cursor: default;
}

.p-radiobutton-box {
    display: flex;
    justify-content: center;
    align-items: center;
}

.p-radiobutton-icon {
    -webkit-backface-visibility: hidden;
    backface-visibility: hidden;
    transform: translateZ(0) scale(.1);
    border-radius: 50%;
    visibility: hidden;
}

.p-radiobutton-box.p-highlight .p-radiobutton-icon {
    transform: translateZ(0) scale(1.0, 1.0);
    visibility: visible;
}
`, E_ = `
@layer primevue {
.p-component, .p-component * {
    box-sizing: border-box;
}

.p-hidden-space {
    visibility: hidden;
}

.p-reset {
    margin: 0;
    padding: 0;
    border: 0;
    outline: 0;
    text-decoration: none;
    font-size: 100%;
    list-style: none;
}

.p-disabled, .p-disabled * {
    cursor: default;
    pointer-events: none;
    user-select: none;
}

.p-component-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
}

.p-unselectable-text {
    user-select: none;
}

.p-sr-only {
    border: 0;
    clip: rect(1px, 1px, 1px, 1px);
    clip-path: inset(50%);
    height: 1px;
    margin: -1px;
    overflow: hidden;
    padding: 0;
    position: absolute;
    width: 1px;
    word-wrap: normal;
}

.p-link {
	text-align: left;
	background-color: transparent;
	margin: 0;
	padding: 0;
	border: none;
    cursor: pointer;
    user-select: none;
}

.p-link:disabled {
	cursor: default;
}

/* Non vue overlay animations */
.p-connected-overlay {
    opacity: 0;
    transform: scaleY(0.8);
    transition: transform .12s cubic-bezier(0, 0, 0.2, 1), opacity .12s cubic-bezier(0, 0, 0.2, 1);
}

.p-connected-overlay-visible {
    opacity: 1;
    transform: scaleY(1);
}

.p-connected-overlay-hidden {
    opacity: 0;
    transform: scaleY(1);
    transition: opacity .1s linear;
}

/* Vue based overlay animations */
.p-connected-overlay-enter-from {
    opacity: 0;
    transform: scaleY(0.8);
}

.p-connected-overlay-leave-to {
    opacity: 0;
}

.p-connected-overlay-enter-active {
    transition: transform .12s cubic-bezier(0, 0, 0.2, 1), opacity .12s cubic-bezier(0, 0, 0.2, 1);
}

.p-connected-overlay-leave-active {
    transition: opacity .1s linear;
}

/* Toggleable Content */
.p-toggleable-content-enter-from,
.p-toggleable-content-leave-to {
    max-height: 0;
}

.p-toggleable-content-enter-to,
.p-toggleable-content-leave-from {
    max-height: 1000px;
}

.p-toggleable-content-leave-active {
    overflow: hidden;
    transition: max-height 0.45s cubic-bezier(0, 1, 0, 1);
}

.p-toggleable-content-enter-active {
    overflow: hidden;
    transition: max-height 1s ease-in-out;
}
`.concat(__, `
`).concat(M_, `
`).concat(O_, `
`).concat(B_, `
}
`), ip = Wt.extend({
  name: "common",
  css: E_,
  loadGlobalStyle: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return vw(t, L_({
      name: "global"
    }, n));
  }
});
function jl(e) {
  "@babel/helpers - typeof";
  return jl = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, jl(e);
}
function Wv(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    t && (i = i.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), n.push.apply(n, i);
  }
  return n;
}
function wn(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Wv(Object(n), !0).forEach(function(i) {
      Up(e, i, n[i]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Wv(Object(n)).forEach(function(i) {
      Object.defineProperty(e, i, Object.getOwnPropertyDescriptor(n, i));
    });
  }
  return e;
}
function Up(e, t, n) {
  return t = D_(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function D_(e) {
  var t = R_(e, "string");
  return jl(t) == "symbol" ? t : String(t);
}
function R_(e, t) {
  if (jl(e) != "object" || !e)
    return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var i = n.call(e, t || "default");
    if (jl(i) != "object")
      return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var wt = {
  name: "BaseComponent",
  props: {
    pt: {
      type: Object,
      default: void 0
    },
    ptOptions: {
      type: Object,
      default: void 0
    },
    unstyled: {
      type: Boolean,
      default: void 0
    }
  },
  inject: {
    $parentInstance: {
      default: void 0
    }
  },
  watch: {
    isUnstyled: {
      immediate: !0,
      handler: function(t) {
        if (!t) {
          var n, i;
          ip.loadStyle({
            nonce: (n = this.$config) === null || n === void 0 || (n = n.csp) === null || n === void 0 ? void 0 : n.nonce
          }), this.$options.style && this.$style.loadStyle({
            nonce: (i = this.$config) === null || i === void 0 || (i = i.csp) === null || i === void 0 ? void 0 : i.nonce
          });
        }
      }
    }
  },
  beforeCreate: function() {
    var t, n, i, o, a, r, s, l, d, y, u, m = (t = this.pt) === null || t === void 0 ? void 0 : t._usept, h = m ? (n = this.pt) === null || n === void 0 || (n = n.originalValue) === null || n === void 0 ? void 0 : n[this.$.type.name] : void 0, c = m ? (i = this.pt) === null || i === void 0 || (i = i.value) === null || i === void 0 ? void 0 : i[this.$.type.name] : this.pt;
    (o = c || h) === null || o === void 0 || (o = o.hooks) === null || o === void 0 || (a = o.onBeforeCreate) === null || a === void 0 || a.call(o);
    var g = (r = this.$config) === null || r === void 0 || (r = r.pt) === null || r === void 0 ? void 0 : r._usept, v = g ? (s = this.$primevue) === null || s === void 0 || (s = s.config) === null || s === void 0 || (s = s.pt) === null || s === void 0 ? void 0 : s.originalValue : void 0, P = g ? (l = this.$primevue) === null || l === void 0 || (l = l.config) === null || l === void 0 || (l = l.pt) === null || l === void 0 ? void 0 : l.value : (d = this.$primevue) === null || d === void 0 || (d = d.config) === null || d === void 0 ? void 0 : d.pt;
    (y = P || v) === null || y === void 0 || (y = y[this.$.type.name]) === null || y === void 0 || (y = y.hooks) === null || y === void 0 || (u = y.onBeforeCreate) === null || u === void 0 || u.call(y);
  },
  created: function() {
    this._hook("onCreated");
  },
  beforeMount: function() {
    var t;
    Wt.loadStyle({
      nonce: (t = this.$config) === null || t === void 0 || (t = t.csp) === null || t === void 0 ? void 0 : t.nonce
    }), this._loadGlobalStyles(), this._hook("onBeforeMount");
  },
  mounted: function() {
    this._hook("onMounted");
  },
  beforeUpdate: function() {
    this._hook("onBeforeUpdate");
  },
  updated: function() {
    this._hook("onUpdated");
  },
  beforeUnmount: function() {
    this._hook("onBeforeUnmount");
  },
  unmounted: function() {
    this._hook("onUnmounted");
  },
  methods: {
    _hook: function(t) {
      if (!this.$options.hostName) {
        var n = this._usePT(this._getPT(this.pt, this.$.type.name), this._getOptionValue, "hooks.".concat(t)), i = this._useDefaultPT(this._getOptionValue, "hooks.".concat(t));
        n?.(), i?.();
      }
    },
    _loadGlobalStyles: function() {
      var t, n = this._useGlobalPT(this._getOptionValue, "global.css", this.$params);
      We.isNotEmpty(n) && ip.loadGlobalStyle(n, {
        nonce: (t = this.$config) === null || t === void 0 || (t = t.csp) === null || t === void 0 ? void 0 : t.nonce
      });
    },
    _getHostInstance: function(t) {
      return t ? this.$options.hostName ? t.$.type.name === this.$options.hostName ? t : this._getHostInstance(t.$parentInstance) : t.$parentInstance : void 0;
    },
    _getPropValue: function(t) {
      var n;
      return this[t] || ((n = this._getHostInstance(this)) === null || n === void 0 ? void 0 : n[t]);
    },
    _getOptionValue: function(t) {
      var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, o = We.toFlatCase(n).split("."), a = o.shift();
      return a ? We.isObject(t) ? this._getOptionValue(We.getItemValue(t[Object.keys(t).find(function(r) {
        return We.toFlatCase(r) === a;
      }) || ""], i), o.join("."), i) : void 0 : We.getItemValue(t, i);
    },
    _getPTValue: function() {
      var t, n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", o = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, a = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !0, r = "data-pc-", s = /./g.test(i) && !!o[i.split(".")[0]], l = this._getPropValue("ptOptions") || ((t = this.$config) === null || t === void 0 ? void 0 : t.ptOptions) || {}, d = l.mergeSections, y = d === void 0 ? !0 : d, u = l.mergeProps, m = u === void 0 ? !1 : u, h = a ? s ? this._useGlobalPT(this._getPTClassValue, i, o) : this._useDefaultPT(this._getPTClassValue, i, o) : void 0, c = s ? void 0 : this._usePT(this._getPT(n, this.$name), this._getPTClassValue, i, wn(wn({}, o), {}, {
        global: h || {}
      })), g = i !== "transition" && wn(wn({}, i === "root" && Up({}, "".concat(r, "name"), We.toFlatCase(this.$.type.name))), {}, Up({}, "".concat(r, "section"), We.toFlatCase(i)));
      return y || !y && c ? m ? Ce(h, c, g) : wn(wn(wn({}, h), c), g) : wn(wn({}, c), g);
    },
    _getPTClassValue: function() {
      var t = this._getOptionValue.apply(this, arguments);
      return We.isString(t) || We.isArray(t) ? {
        class: t
      } : t;
    },
    _getPT: function(t) {
      var n = this, i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", o = arguments.length > 2 ? arguments[2] : void 0, a = function(s) {
        var l, d = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, y = o ? o(s) : s, u = We.toFlatCase(i), m = We.toFlatCase(n.$name);
        return (l = d ? u !== m ? y?.[u] : void 0 : y?.[u]) !== null && l !== void 0 ? l : y;
      };
      return t != null && t.hasOwnProperty("_usept") ? {
        _usept: t._usept,
        originalValue: a(t.originalValue),
        value: a(t.value)
      } : a(t, !0);
    },
    _usePT: function(t, n, i, o) {
      var a = function(g) {
        return n(g, i, o);
      };
      if (t != null && t.hasOwnProperty("_usept")) {
        var r, s = t._usept || ((r = this.$config) === null || r === void 0 ? void 0 : r.ptOptions) || {}, l = s.mergeSections, d = l === void 0 ? !0 : l, y = s.mergeProps, u = y === void 0 ? !1 : y, m = a(t.originalValue), h = a(t.value);
        return m === void 0 && h === void 0 ? void 0 : We.isString(h) ? h : We.isString(m) ? m : d || !d && h ? u ? Ce(m, h) : wn(wn({}, m), h) : h;
      }
      return a(t);
    },
    _useGlobalPT: function(t, n, i) {
      return this._usePT(this.globalPT, t, n, i);
    },
    _useDefaultPT: function(t, n, i) {
      return this._usePT(this.defaultPT, t, n, i);
    },
    ptm: function() {
      var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      return this._getPTValue(this.pt, t, wn(wn({}, this.$params), n));
    },
    ptmo: function() {
      var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
      return this._getPTValue(t, n, wn({
        instance: this
      }, i), !1);
    },
    cx: function() {
      var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      return this.isUnstyled ? void 0 : this._getOptionValue(this.$style.classes, t, wn(wn({}, this.$params), n));
    },
    sx: function() {
      var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0, i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
      if (n) {
        var o = this._getOptionValue(this.$style.inlineStyles, t, wn(wn({}, this.$params), i)), a = this._getOptionValue(ip.inlineStyles, t, wn(wn({}, this.$params), i));
        return [a, o];
      }
    }
  },
  computed: {
    globalPT: function() {
      var t, n = this;
      return this._getPT((t = this.$config) === null || t === void 0 ? void 0 : t.pt, void 0, function(i) {
        return We.getItemValue(i, {
          instance: n
        });
      });
    },
    defaultPT: function() {
      var t, n = this;
      return this._getPT((t = this.$config) === null || t === void 0 ? void 0 : t.pt, void 0, function(i) {
        return n._getOptionValue(i, n.$name, wn({}, n.$params)) || We.getItemValue(i, wn({}, n.$params));
      });
    },
    isUnstyled: function() {
      var t;
      return this.unstyled !== void 0 ? this.unstyled : (t = this.$config) === null || t === void 0 ? void 0 : t.unstyled;
    },
    $params: function() {
      var t = this._getHostInstance(this) || this.$parent;
      return {
        instance: this,
        props: this.$props,
        state: this.$data,
        attrs: this.$attrs,
        parent: {
          instance: t,
          props: t?.$props,
          state: t?.$data,
          attrs: t?.$attrs
        },
        /* @deprecated since v3.43.0. Use the `parent.instance` instead of the `parentInstance`.*/
        parentInstance: t
      };
    },
    $style: function() {
      return wn(wn({
        classes: void 0,
        inlineStyles: void 0,
        loadStyle: function() {
        },
        loadCustomStyle: function() {
        }
      }, (this._getHostInstance(this) || {}).$style), this.$options.style);
    },
    $config: function() {
      var t;
      return (t = this.$primevue) === null || t === void 0 ? void 0 : t.config;
    },
    $name: function() {
      return this.$options.hostName || this.$.type.name;
    }
  }
}, N_ = `
.p-icon {
    display: inline-block;
}

.p-icon-spin {
    -webkit-animation: p-icon-spin 2s infinite linear;
    animation: p-icon-spin 2s infinite linear;
}

@-webkit-keyframes p-icon-spin {
    0% {
        -webkit-transform: rotate(0deg);
        transform: rotate(0deg);
    }
    100% {
        -webkit-transform: rotate(359deg);
        transform: rotate(359deg);
    }
}

@keyframes p-icon-spin {
    0% {
        -webkit-transform: rotate(0deg);
        transform: rotate(0deg);
    }
    100% {
        -webkit-transform: rotate(359deg);
        transform: rotate(359deg);
    }
}
`, $_ = Wt.extend({
  name: "baseicon",
  css: N_
});
function Hl(e) {
  "@babel/helpers - typeof";
  return Hl = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Hl(e);
}
function Yv(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    t && (i = i.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), n.push.apply(n, i);
  }
  return n;
}
function qv(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Yv(Object(n), !0).forEach(function(i) {
      F_(e, i, n[i]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Yv(Object(n)).forEach(function(i) {
      Object.defineProperty(e, i, Object.getOwnPropertyDescriptor(n, i));
    });
  }
  return e;
}
function F_(e, t, n) {
  return t = j_(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function j_(e) {
  var t = H_(e, "string");
  return Hl(t) == "symbol" ? t : String(t);
}
function H_(e, t) {
  if (Hl(e) != "object" || !e)
    return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var i = n.call(e, t || "default");
    if (Hl(i) != "object")
      return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var Yt = {
  name: "BaseIcon",
  extends: wt,
  props: {
    label: {
      type: String,
      default: void 0
    },
    spin: {
      type: Boolean,
      default: !1
    }
  },
  style: $_,
  methods: {
    pti: function() {
      var t = We.isEmpty(this.label);
      return qv(qv({}, !this.isUnstyled && {
        class: ["p-icon", {
          "p-icon-spin": this.spin
        }]
      }), {}, {
        role: t ? void 0 : "img",
        "aria-label": t ? void 0 : this.label,
        "aria-hidden": t
      });
    }
  }
}, Va = {
  name: "ChevronDownIcon",
  extends: Yt
}, z_ = /* @__PURE__ */ oe("path", {
  d: "M7.01744 10.398C6.91269 10.3985 6.8089 10.378 6.71215 10.3379C6.61541 10.2977 6.52766 10.2386 6.45405 10.1641L1.13907 4.84913C1.03306 4.69404 0.985221 4.5065 1.00399 4.31958C1.02276 4.13266 1.10693 3.95838 1.24166 3.82747C1.37639 3.69655 1.55301 3.61742 1.74039 3.60402C1.92777 3.59062 2.11386 3.64382 2.26584 3.75424L7.01744 8.47394L11.769 3.75424C11.9189 3.65709 12.097 3.61306 12.2748 3.62921C12.4527 3.64535 12.6199 3.72073 12.7498 3.84328C12.8797 3.96582 12.9647 4.12842 12.9912 4.30502C13.0177 4.48162 12.9841 4.662 12.8958 4.81724L7.58083 10.1322C7.50996 10.2125 7.42344 10.2775 7.32656 10.3232C7.22968 10.3689 7.12449 10.3944 7.01744 10.398Z",
  fill: "currentColor"
}, null, -1), V_ = [z_];
function G_(e, t, n, i, o, a) {
  return E(), X("svg", Ce({
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.pti()), V_, 16);
}
Va.render = G_;
var Fo = {
  name: "ChevronRightIcon",
  extends: Yt
}, U_ = /* @__PURE__ */ oe("path", {
  d: "M4.38708 13C4.28408 13.0005 4.18203 12.9804 4.08691 12.9409C3.99178 12.9014 3.9055 12.8433 3.83313 12.7701C3.68634 12.6231 3.60388 12.4238 3.60388 12.2161C3.60388 12.0084 3.68634 11.8091 3.83313 11.6622L8.50507 6.99022L3.83313 2.31827C3.69467 2.16968 3.61928 1.97313 3.62287 1.77005C3.62645 1.56698 3.70872 1.37322 3.85234 1.22959C3.99596 1.08597 4.18972 1.00371 4.3928 1.00012C4.59588 0.996539 4.79242 1.07192 4.94102 1.21039L10.1669 6.43628C10.3137 6.58325 10.3962 6.78249 10.3962 6.99022C10.3962 7.19795 10.3137 7.39718 10.1669 7.54416L4.94102 12.7701C4.86865 12.8433 4.78237 12.9014 4.68724 12.9409C4.59212 12.9804 4.49007 13.0005 4.38708 13Z",
  fill: "currentColor"
}, null, -1), W_ = [U_];
function Y_(e, t, n, i, o, a) {
  return E(), X("svg", Ce({
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.pti()), W_, 16);
}
Fo.render = Y_;
var q_ = `
@keyframes ripple {
    100% {
        opacity: 0;
        transform: scale(2.5);
    }
}

@layer primevue {
    .p-ripple {
        overflow: hidden;
        position: relative;
    }

    .p-ink {
        display: block;
        position: absolute;
        background: rgba(255, 255, 255, 0.5);
        border-radius: 100%;
        transform: scale(0);
        pointer-events: none;
    }

    .p-ink-active {
        animation: ripple 0.4s linear;
    }

    .p-ripple-disabled .p-ink {
        display: none;
    }
}
`, K_ = {
  root: "p-ink"
}, X_ = Wt.extend({
  name: "ripple",
  css: q_,
  classes: K_
}), Z_ = tn.extend({
  style: X_
});
function J_(e) {
  return nM(e) || tM(e) || eM(e) || Q_();
}
function Q_() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function eM(e, t) {
  if (e) {
    if (typeof e == "string")
      return Wp(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set")
      return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return Wp(e, t);
  }
}
function tM(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null)
    return Array.from(e);
}
function nM(e) {
  if (Array.isArray(e))
    return Wp(e);
}
function Wp(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, i = new Array(t); n < t; n++)
    i[n] = e[n];
  return i;
}
var An = Z_.extend("ripple", {
  mounted: function(t) {
    var n, i = t == null || (n = t.$instance) === null || n === void 0 ? void 0 : n.$config;
    i && i.ripple && (this.create(t), this.bindEvents(t), t.setAttribute("data-pd-ripple", !0));
  },
  unmounted: function(t) {
    this.remove(t);
  },
  timeout: void 0,
  methods: {
    bindEvents: function(t) {
      t.addEventListener("mousedown", this.onMouseDown.bind(this));
    },
    unbindEvents: function(t) {
      t.removeEventListener("mousedown", this.onMouseDown.bind(this));
    },
    create: function(t) {
      var n = Oe.createElement("span", {
        role: "presentation",
        "aria-hidden": !0,
        "data-p-ink": !0,
        "data-p-ink-active": !1,
        class: !this.isUnstyled() && this.cx("root"),
        onAnimationEnd: this.onAnimationEnd.bind(this),
        "p-bind": this.ptm("root")
      });
      t.appendChild(n), this.$el = n;
    },
    remove: function(t) {
      var n = this.getInk(t);
      n && (this.unbindEvents(t), n.removeEventListener("animationend", this.onAnimationEnd), n.remove());
    },
    onMouseDown: function(t) {
      var n = this, i = t.currentTarget, o = this.getInk(i);
      if (!(!o || getComputedStyle(o, null).display === "none")) {
        if (!this.isUnstyled() && Oe.removeClass(o, "p-ink-active"), o.setAttribute("data-p-ink-active", "false"), !Oe.getHeight(o) && !Oe.getWidth(o)) {
          var a = Math.max(Oe.getOuterWidth(i), Oe.getOuterHeight(i));
          o.style.height = a + "px", o.style.width = a + "px";
        }
        var r = Oe.getOffset(i), s = t.pageX - r.left + document.body.scrollTop - Oe.getWidth(o) / 2, l = t.pageY - r.top + document.body.scrollLeft - Oe.getHeight(o) / 2;
        o.style.top = l + "px", o.style.left = s + "px", !this.isUnstyled() && Oe.addClass(o, "p-ink-active"), o.setAttribute("data-p-ink-active", "true"), this.timeout = setTimeout(function() {
          o && (!n.isUnstyled() && Oe.removeClass(o, "p-ink-active"), o.setAttribute("data-p-ink-active", "false"));
        }, 401);
      }
    },
    onAnimationEnd: function(t) {
      this.timeout && clearTimeout(this.timeout), !this.isUnstyled() && Oe.removeClass(t.currentTarget, "p-ink-active"), t.currentTarget.setAttribute("data-p-ink-active", "false");
    },
    getInk: function(t) {
      return t && t.children ? J_(t.children).find(function(n) {
        return Oe.getAttribute(n, "data-pc-name") === "ripple";
      }) : void 0;
    }
  }
}), iM = `
@layer primevue {
    .p-accordion-header-action {
        cursor: pointer;
        display: flex;
        align-items: center;
        user-select: none;
        position: relative;
        text-decoration: none;
    }
    
    .p-accordion-header-action:focus {
        z-index: 1;
    }
    
    .p-accordion-header-text {
        line-height: 1;
    }
}
`, aM = {
  root: "p-accordion p-component",
  tab: {
    root: function(t) {
      var n = t.instance, i = t.index;
      return ["p-accordion-tab", {
        "p-accordion-tab-active": n.isTabActive(i)
      }];
    },
    header: function(t) {
      var n = t.instance, i = t.tab, o = t.index;
      return ["p-accordion-header", {
        "p-highlight": n.isTabActive(o),
        "p-disabled": n.getTabProp(i, "disabled")
      }];
    },
    headerAction: "p-accordion-header-link p-accordion-header-action",
    headerIcon: "p-accordion-toggle-icon",
    headerTitle: "p-accordion-header-text",
    toggleableContent: "p-toggleable-content",
    content: "p-accordion-content"
  }
}, oM = Wt.extend({
  name: "accordion",
  css: iM,
  classes: aM
}), rM = {
  name: "BaseAccordion",
  extends: wt,
  props: {
    multiple: {
      type: Boolean,
      default: !1
    },
    activeIndex: {
      type: [Number, Array],
      default: null
    },
    lazy: {
      type: Boolean,
      default: !1
    },
    expandIcon: {
      type: String,
      default: void 0
    },
    collapseIcon: {
      type: String,
      default: void 0
    },
    tabindex: {
      type: Number,
      default: 0
    },
    selectOnFocus: {
      type: Boolean,
      default: !1
    }
  },
  style: oM,
  provide: function() {
    return {
      $parentInstance: this
    };
  }
}, Lm = {
  name: "Accordion",
  extends: rM,
  emits: ["update:activeIndex", "tab-open", "tab-close", "tab-click"],
  data: function() {
    return {
      id: this.$attrs.id,
      d_activeIndex: this.activeIndex
    };
  },
  watch: {
    "$attrs.id": function(t) {
      this.id = t || Mt();
    },
    activeIndex: function(t) {
      this.d_activeIndex = t;
    }
  },
  mounted: function() {
    this.id = this.id || Mt();
  },
  methods: {
    isAccordionTab: function(t) {
      return t.type.name === "AccordionTab";
    },
    isTabActive: function(t) {
      return this.multiple ? this.d_activeIndex && this.d_activeIndex.includes(t) : this.d_activeIndex === t;
    },
    getTabProp: function(t, n) {
      return t.props ? t.props[n] : void 0;
    },
    getKey: function(t, n) {
      return this.getTabProp(t, "header") || n;
    },
    getTabHeaderActionId: function(t) {
      return "".concat(this.id, "_").concat(t, "_header_action");
    },
    getTabContentId: function(t) {
      return "".concat(this.id, "_").concat(t, "_content");
    },
    getTabPT: function(t, n, i) {
      var o = this.tabs.length, a = {
        props: t.props || {},
        parent: {
          instance: this,
          props: this.$props,
          state: this.$data
        },
        context: {
          index: i,
          count: o,
          first: i === 0,
          last: i === o - 1,
          active: this.isTabActive(i)
        }
      };
      return Ce(this.ptm("tab.".concat(n), {
        tab: a
      }), this.ptm("accordiontab.".concat(n), {
        accordiontab: a
      }), this.ptm("accordiontab.".concat(n), a), this.ptmo(this.getTabProp(t, "pt"), n, a));
    },
    onTabClick: function(t, n, i) {
      this.changeActiveIndex(t, n, i), this.$emit("tab-click", {
        originalEvent: t,
        index: i
      });
    },
    onTabKeyDown: function(t, n, i) {
      switch (t.code) {
        case "ArrowDown":
          this.onTabArrowDownKey(t);
          break;
        case "ArrowUp":
          this.onTabArrowUpKey(t);
          break;
        case "Home":
          this.onTabHomeKey(t);
          break;
        case "End":
          this.onTabEndKey(t);
          break;
        case "Enter":
        case "NumpadEnter":
        case "Space":
          this.onTabEnterKey(t, n, i);
          break;
      }
    },
    onTabArrowDownKey: function(t) {
      var n = this.findNextHeaderAction(t.target.parentElement.parentElement);
      n ? this.changeFocusedTab(t, n) : this.onTabHomeKey(t), t.preventDefault();
    },
    onTabArrowUpKey: function(t) {
      var n = this.findPrevHeaderAction(t.target.parentElement.parentElement);
      n ? this.changeFocusedTab(t, n) : this.onTabEndKey(t), t.preventDefault();
    },
    onTabHomeKey: function(t) {
      var n = this.findFirstHeaderAction();
      this.changeFocusedTab(t, n), t.preventDefault();
    },
    onTabEndKey: function(t) {
      var n = this.findLastHeaderAction();
      this.changeFocusedTab(t, n), t.preventDefault();
    },
    onTabEnterKey: function(t, n, i) {
      this.changeActiveIndex(t, n, i), t.preventDefault();
    },
    findNextHeaderAction: function(t) {
      var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, i = n ? t : t.nextElementSibling, o = Oe.findSingle(i, '[data-pc-section="header"]');
      return o ? Oe.getAttribute(o, "data-p-disabled") ? this.findNextHeaderAction(o.parentElement) : Oe.findSingle(o, '[data-pc-section="headeraction"]') : null;
    },
    findPrevHeaderAction: function(t) {
      var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, i = n ? t : t.previousElementSibling, o = Oe.findSingle(i, '[data-pc-section="header"]');
      return o ? Oe.getAttribute(o, "data-p-disabled") ? this.findPrevHeaderAction(o.parentElement) : Oe.findSingle(o, '[data-pc-section="headeraction"]') : null;
    },
    findFirstHeaderAction: function() {
      return this.findNextHeaderAction(this.$el.firstElementChild, !0);
    },
    findLastHeaderAction: function() {
      return this.findPrevHeaderAction(this.$el.lastElementChild, !0);
    },
    changeActiveIndex: function(t, n, i) {
      if (!this.getTabProp(n, "disabled")) {
        var o = this.isTabActive(i), a = o ? "tab-close" : "tab-open";
        this.multiple ? o ? this.d_activeIndex = this.d_activeIndex.filter(function(r) {
          return r !== i;
        }) : this.d_activeIndex ? this.d_activeIndex.push(i) : this.d_activeIndex = [i] : this.d_activeIndex = this.d_activeIndex === i ? null : i, this.$emit("update:activeIndex", this.d_activeIndex), this.$emit(a, {
          originalEvent: t,
          index: i
        });
      }
    },
    changeFocusedTab: function(t, n) {
      if (n && (Oe.focus(n), this.selectOnFocus)) {
        var i = parseInt(n.parentElement.parentElement.dataset.pcIndex, 10), o = this.tabs[i];
        this.changeActiveIndex(t, o, i);
      }
    }
  },
  computed: {
    tabs: function() {
      var t = this;
      return this.$slots.default().reduce(function(n, i) {
        return t.isAccordionTab(i) ? n.push(i) : i.children && i.children instanceof Array && i.children.forEach(function(o) {
          t.isAccordionTab(o) && n.push(o);
        }), n;
      }, []);
    }
  },
  components: {
    ChevronDownIcon: Va,
    ChevronRightIcon: Fo
  },
  directives: {
    ripple: An
  }
};
function zl(e) {
  "@babel/helpers - typeof";
  return zl = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, zl(e);
}
function Kv(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    t && (i = i.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), n.push.apply(n, i);
  }
  return n;
}
function Fr(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Kv(Object(n), !0).forEach(function(i) {
      sM(e, i, n[i]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Kv(Object(n)).forEach(function(i) {
      Object.defineProperty(e, i, Object.getOwnPropertyDescriptor(n, i));
    });
  }
  return e;
}
function sM(e, t, n) {
  return t = lM(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function lM(e) {
  var t = cM(e, "string");
  return zl(t) == "symbol" ? t : String(t);
}
function cM(e, t) {
  if (zl(e) != "object" || !e)
    return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var i = n.call(e, t || "default");
    if (zl(i) != "object")
      return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var dM = ["data-pc-index", "data-p-active"], uM = ["data-p-highlight", "data-p-disabled"], hM = ["id", "tabindex", "aria-disabled", "aria-expanded", "aria-controls", "onClick", "onKeydown"], pM = ["id", "aria-labelledby"];
function fM(e, t, n, i, o, a) {
  return E(), X("div", Ce({
    class: e.cx("root")
  }, e.ptm("root")), [(E(!0), X(Re, null, Ge(a.tabs, function(r, s) {
    return E(), X("div", Ce({
      key: a.getKey(r, s),
      class: e.cx("tab.root", {
        tab: r,
        index: s
      })
    }, a.getTabPT(r, "root", s), {
      "data-pc-name": "accordiontab",
      "data-pc-index": s,
      "data-p-active": a.isTabActive(s)
    }), [oe("div", Ce({
      style: a.getTabProp(r, "headerStyle"),
      class: [e.cx("tab.header", {
        tab: r,
        index: s
      }), a.getTabProp(r, "headerClass")]
    }, Fr(Fr({}, a.getTabProp(r, "headerProps")), a.getTabPT(r, "header", s)), {
      "data-p-highlight": a.isTabActive(s),
      "data-p-disabled": a.getTabProp(r, "disabled")
    }), [oe("a", Ce({
      id: a.getTabHeaderActionId(s),
      class: e.cx("tab.headerAction"),
      tabindex: a.getTabProp(r, "disabled") ? -1 : e.tabindex,
      role: "button",
      "aria-disabled": a.getTabProp(r, "disabled"),
      "aria-expanded": a.isTabActive(s),
      "aria-controls": a.getTabContentId(s),
      onClick: function(d) {
        return a.onTabClick(d, r, s);
      },
      onKeydown: function(d) {
        return a.onTabKeyDown(d, r, s);
      }
    }, Fr(Fr({}, a.getTabProp(r, "headeractionprops")), a.getTabPT(r, "headeraction", s))), [r.children && r.children.headericon ? (E(), fe(tt(r.children.headericon), {
      key: 0,
      isTabActive: a.isTabActive(s),
      active: a.isTabActive(s),
      index: s
    }, null, 8, ["isTabActive", "active", "index"])) : a.isTabActive(s) ? (E(), fe(tt(e.$slots.collapseicon ? e.$slots.collapseicon : e.collapseIcon ? "span" : "ChevronDownIcon"), Ce({
      key: 1,
      class: [e.cx("tab.headerIcon"), e.collapseIcon],
      "aria-hidden": "true"
    }, a.getTabPT(r, "headericon", s)), null, 16, ["class"])) : (E(), fe(tt(e.$slots.expandicon ? e.$slots.expandicon : e.expandIcon ? "span" : "ChevronRightIcon"), Ce({
      key: 2,
      class: [e.cx("tab.headerIcon"), e.expandIcon],
      "aria-hidden": "true"
    }, a.getTabPT(r, "headericon", s)), null, 16, ["class"])), r.props && r.props.header ? (E(), X("span", Ce({
      key: 3,
      class: e.cx("tab.headerTitle")
    }, a.getTabPT(r, "headertitle", s)), Ie(r.props.header), 17)) : te("", !0), r.children && r.children.header ? (E(), fe(tt(r.children.header), {
      key: 4
    })) : te("", !0)], 16, hM)], 16, uM), ue(ia, Ce({
      name: "p-toggleable-content"
    }, a.getTabPT(r, "transition", s)), {
      default: Se(function() {
        return [!e.lazy || a.isTabActive(s) ? rt((E(), X("div", Ce({
          key: 0,
          id: a.getTabContentId(s),
          style: a.getTabProp(r, "contentStyle"),
          class: [e.cx("tab.toggleableContent"), a.getTabProp(r, "contentClass")],
          role: "region",
          "aria-labelledby": a.getTabHeaderActionId(s)
        }, Fr(Fr({}, a.getTabProp(r, "contentProps")), a.getTabPT(r, "toggleablecontent", s))), [oe("div", Ce({
          class: e.cx("tab.content")
        }, a.getTabPT(r, "content", s)), [(E(), fe(tt(r)))], 16)], 16, pM)), [[xn, e.lazy ? !0 : a.isTabActive(s)]]) : te("", !0)];
      }),
      _: 2
    }, 1040)], 16, dM);
  }), 128))], 16);
}
Lm.render = fM;
var mM = {}, gM = {
  name: "BaseAccordionTab",
  extends: wt,
  props: {
    header: null,
    headerStyle: null,
    headerClass: null,
    headerProps: null,
    headerActionProps: null,
    contentStyle: null,
    contentClass: null,
    contentProps: null,
    disabled: Boolean
  },
  style: mM,
  provide: function() {
    return {
      $parentInstance: this
    };
  }
}, Im = {
  name: "AccordionTab",
  extends: gM
};
function vM(e, t, n, i, o, a) {
  return je(e.$slots, "default");
}
Im.render = vM;
var yM = {}, bM = {
  name: "BaseColumn",
  extends: wt,
  props: {
    columnKey: {
      type: null,
      default: null
    },
    field: {
      type: [String, Function],
      default: null
    },
    sortField: {
      type: [String, Function],
      default: null
    },
    filterField: {
      type: [String, Function],
      default: null
    },
    dataType: {
      type: String,
      default: "text"
    },
    sortable: {
      type: Boolean,
      default: !1
    },
    header: {
      type: null,
      default: null
    },
    footer: {
      type: null,
      default: null
    },
    style: {
      type: null,
      default: null
    },
    class: {
      type: String,
      default: null
    },
    headerStyle: {
      type: null,
      default: null
    },
    headerClass: {
      type: String,
      default: null
    },
    bodyStyle: {
      type: null,
      default: null
    },
    bodyClass: {
      type: String,
      default: null
    },
    footerStyle: {
      type: null,
      default: null
    },
    footerClass: {
      type: String,
      default: null
    },
    showFilterMenu: {
      type: Boolean,
      default: !0
    },
    showFilterOperator: {
      type: Boolean,
      default: !0
    },
    showClearButton: {
      type: Boolean,
      default: !0
    },
    showApplyButton: {
      type: Boolean,
      default: !0
    },
    showFilterMatchModes: {
      type: Boolean,
      default: !0
    },
    showAddButton: {
      type: Boolean,
      default: !0
    },
    filterMatchModeOptions: {
      type: Array,
      default: null
    },
    maxConstraints: {
      type: Number,
      default: 2
    },
    excludeGlobalFilter: {
      type: Boolean,
      default: !1
    },
    filterHeaderClass: {
      type: String,
      default: null
    },
    filterHeaderStyle: {
      type: null,
      default: null
    },
    filterMenuClass: {
      type: String,
      default: null
    },
    filterMenuStyle: {
      type: null,
      default: null
    },
    selectionMode: {
      type: String,
      default: null
    },
    expander: {
      type: Boolean,
      default: !1
    },
    colspan: {
      type: Number,
      default: null
    },
    rowspan: {
      type: Number,
      default: null
    },
    rowReorder: {
      type: Boolean,
      default: !1
    },
    rowReorderIcon: {
      type: String,
      default: void 0
    },
    reorderableColumn: {
      type: Boolean,
      default: !0
    },
    rowEditor: {
      type: Boolean,
      default: !1
    },
    frozen: {
      type: Boolean,
      default: !1
    },
    alignFrozen: {
      type: String,
      default: "left"
    },
    exportable: {
      type: Boolean,
      default: !0
    },
    exportHeader: {
      type: String,
      default: null
    },
    exportFooter: {
      type: String,
      default: null
    },
    filterMatchMode: {
      type: String,
      default: null
    },
    hidden: {
      type: Boolean,
      default: !1
    }
  },
  style: yM,
  provide: function() {
    return {
      $parentInstance: this
    };
  }
}, Xr = {
  name: "Column",
  extends: bM,
  inject: ["$columns"],
  mounted: function() {
    var t;
    (t = this.$columns) === null || t === void 0 || t.add(this.$);
  },
  unmounted: function() {
    var t;
    (t = this.$columns) === null || t === void 0 || t.delete(this.$);
  },
  render: function() {
    return null;
  }
}, bw = {
  name: "ArrowDownIcon",
  extends: Yt,
  computed: {
    pathId: function() {
      return "pv_icon_clip_".concat(Mt());
    }
  }
}, xM = ["clip-path"], wM = /* @__PURE__ */ oe("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M6.99994 14C6.91097 14.0004 6.82281 13.983 6.74064 13.9489C6.65843 13.9148 6.58387 13.8646 6.52133 13.8013L1.10198 8.38193C0.982318 8.25351 0.917175 8.08367 0.920272 7.90817C0.923368 7.73267 0.994462 7.56523 1.11858 7.44111C1.24269 7.317 1.41014 7.2459 1.58563 7.2428C1.76113 7.23971 1.93098 7.30485 2.0594 7.42451L6.32263 11.6877V0.677419C6.32263 0.497756 6.394 0.325452 6.52104 0.198411C6.64808 0.0713706 6.82039 0 7.00005 0C7.17971 0 7.35202 0.0713706 7.47906 0.198411C7.6061 0.325452 7.67747 0.497756 7.67747 0.677419V11.6877L11.9407 7.42451C12.0691 7.30485 12.2389 7.23971 12.4144 7.2428C12.5899 7.2459 12.7574 7.317 12.8815 7.44111C13.0056 7.56523 13.0767 7.73267 13.0798 7.90817C13.0829 8.08367 13.0178 8.25351 12.8981 8.38193L7.47875 13.8013C7.41621 13.8646 7.34164 13.9148 7.25944 13.9489C7.17727 13.983 7.08912 14.0004 7.00015 14C7.00012 14 7.00009 14 7.00005 14C7.00001 14 6.99998 14 6.99994 14Z",
  fill: "currentColor"
}, null, -1), kM = [wM], SM = ["id"], CM = /* @__PURE__ */ oe("rect", {
  width: "14",
  height: "14",
  fill: "white"
}, null, -1), TM = [CM];
function LM(e, t, n, i, o, a) {
  return E(), X("svg", Ce({
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.pti()), [oe("g", {
    "clip-path": "url(#".concat(a.pathId, ")")
  }, kM, 8, xM), oe("defs", null, [oe("clipPath", {
    id: "".concat(a.pathId)
  }, TM, 8, SM)])], 16);
}
bw.render = LM;
var xw = {
  name: "ArrowUpIcon",
  extends: Yt,
  computed: {
    pathId: function() {
      return "pv_icon_clip_".concat(Mt());
    }
  }
}, IM = ["clip-path"], PM = /* @__PURE__ */ oe("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M6.51551 13.799C6.64205 13.9255 6.813 13.9977 6.99193 14C7.17087 13.9977 7.34182 13.9255 7.46835 13.799C7.59489 13.6725 7.66701 13.5015 7.66935 13.3226V2.31233L11.9326 6.57554C11.9951 6.63887 12.0697 6.68907 12.1519 6.72319C12.2341 6.75731 12.3223 6.77467 12.4113 6.77425C12.5003 6.77467 12.5885 6.75731 12.6707 6.72319C12.7529 6.68907 12.8274 6.63887 12.89 6.57554C13.0168 6.44853 13.0881 6.27635 13.0881 6.09683C13.0881 5.91732 13.0168 5.74514 12.89 5.61812L7.48846 0.216594C7.48274 0.210436 7.4769 0.204374 7.47094 0.198411C7.3439 0.0713707 7.1716 0 6.99193 0C6.81227 0 6.63997 0.0713707 6.51293 0.198411C6.50704 0.204296 6.50128 0.210278 6.49563 0.216354L1.09386 5.61812C0.974201 5.74654 0.909057 5.91639 0.912154 6.09189C0.91525 6.26738 0.986345 6.43483 1.11046 6.55894C1.23457 6.68306 1.40202 6.75415 1.57752 6.75725C1.75302 6.76035 1.92286 6.6952 2.05128 6.57554L6.31451 2.31231V13.3226C6.31685 13.5015 6.38898 13.6725 6.51551 13.799Z",
  fill: "currentColor"
}, null, -1), AM = [PM], _M = ["id"], MM = /* @__PURE__ */ oe("rect", {
  width: "14",
  height: "14",
  fill: "white"
}, null, -1), OM = [MM];
function BM(e, t, n, i, o, a) {
  return E(), X("svg", Ce({
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.pti()), [oe("g", {
    "clip-path": "url(#".concat(a.pathId, ")")
  }, AM, 8, IM), oe("defs", null, [oe("clipPath", {
    id: "".concat(a.pathId)
  }, OM, 8, _M)])], 16);
}
xw.render = BM;
var jo = {
  name: "SpinnerIcon",
  extends: Yt,
  computed: {
    pathId: function() {
      return "pv_icon_clip_".concat(Mt());
    }
  }
}, EM = ["clip-path"], DM = /* @__PURE__ */ oe("path", {
  d: "M6.99701 14C5.85441 13.999 4.72939 13.7186 3.72012 13.1832C2.71084 12.6478 1.84795 11.8737 1.20673 10.9284C0.565504 9.98305 0.165424 8.89526 0.041387 7.75989C-0.0826496 6.62453 0.073125 5.47607 0.495122 4.4147C0.917119 3.35333 1.59252 2.4113 2.46241 1.67077C3.33229 0.930247 4.37024 0.413729 5.4857 0.166275C6.60117 -0.0811796 7.76026 -0.0520535 8.86188 0.251112C9.9635 0.554278 10.9742 1.12227 11.8057 1.90555C11.915 2.01493 11.9764 2.16319 11.9764 2.31778C11.9764 2.47236 11.915 2.62062 11.8057 2.73C11.7521 2.78503 11.688 2.82877 11.6171 2.85864C11.5463 2.8885 11.4702 2.90389 11.3933 2.90389C11.3165 2.90389 11.2404 2.8885 11.1695 2.85864C11.0987 2.82877 11.0346 2.78503 10.9809 2.73C9.9998 1.81273 8.73246 1.26138 7.39226 1.16876C6.05206 1.07615 4.72086 1.44794 3.62279 2.22152C2.52471 2.99511 1.72683 4.12325 1.36345 5.41602C1.00008 6.70879 1.09342 8.08723 1.62775 9.31926C2.16209 10.5513 3.10478 11.5617 4.29713 12.1803C5.48947 12.7989 6.85865 12.988 8.17414 12.7157C9.48963 12.4435 10.6711 11.7264 11.5196 10.6854C12.3681 9.64432 12.8319 8.34282 12.8328 7C12.8328 6.84529 12.8943 6.69692 13.0038 6.58752C13.1132 6.47812 13.2616 6.41667 13.4164 6.41667C13.5712 6.41667 13.7196 6.47812 13.8291 6.58752C13.9385 6.69692 14 6.84529 14 7C14 8.85651 13.2622 10.637 11.9489 11.9497C10.6356 13.2625 8.85432 14 6.99701 14Z",
  fill: "currentColor"
}, null, -1), RM = [DM], NM = ["id"], $M = /* @__PURE__ */ oe("rect", {
  width: "14",
  height: "14",
  fill: "white"
}, null, -1), FM = [$M];
function jM(e, t, n, i, o, a) {
  return E(), X("svg", Ce({
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.pti()), [oe("g", {
    "clip-path": "url(#".concat(a.pathId, ")")
  }, RM, 8, EM), oe("defs", null, [oe("clipPath", {
    id: "".concat(a.pathId)
  }, FM, 8, NM)])], 16);
}
jo.render = jM;
function Vl(e) {
  "@babel/helpers - typeof";
  return Vl = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Vl(e);
}
function HM(e, t, n) {
  return t = zM(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function zM(e) {
  var t = VM(e, "string");
  return Vl(t) == "symbol" ? t : String(t);
}
function VM(e, t) {
  if (Vl(e) != "object" || !e)
    return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var i = n.call(e, t || "default");
    if (Vl(i) != "object")
      return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var GM = `
@layer primevue {
    .p-paginator-default {
        display: flex;
    }

    .p-paginator {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-wrap: wrap;
    }

    .p-paginator-left-content {
        margin-right: auto;
    }

    .p-paginator-right-content {
        margin-left: auto;
    }

    .p-paginator-page,
    .p-paginator-next,
    .p-paginator-last,
    .p-paginator-first,
    .p-paginator-prev,
    .p-paginator-current {
        cursor: pointer;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        line-height: 1;
        user-select: none;
        overflow: hidden;
        position: relative;
    }

    .p-paginator-element:focus {
        z-index: 1;
        position: relative;
    }
}
`, UM = {
  paginator: function(t) {
    var n = t.instance, i = t.key;
    return ["p-paginator p-component", HM({
      "p-paginator-default": !n.hasBreakpoints()
    }, "p-paginator-".concat(i), n.hasBreakpoints())];
  },
  start: "p-paginator-left-content",
  end: "p-paginator-right-content",
  firstPageButton: function(t) {
    var n = t.instance;
    return ["p-paginator-first p-paginator-element p-link", {
      "p-disabled": n.$attrs.disabled
    }];
  },
  firstPageIcon: "p-paginator-icon",
  previousPageButton: function(t) {
    var n = t.instance;
    return ["p-paginator-prev p-paginator-element p-link", {
      "p-disabled": n.$attrs.disabled
    }];
  },
  previousPageIcon: "p-paginator-icon",
  nextPageButton: function(t) {
    var n = t.instance;
    return ["p-paginator-next p-paginator-element p-link", {
      "p-disabled": n.$attrs.disabled
    }];
  },
  nextPageIcon: "p-paginator-icon",
  lastPageButton: function(t) {
    var n = t.instance;
    return ["p-paginator-last p-paginator-element p-link", {
      "p-disabled": n.$attrs.disabled
    }];
  },
  lastPageIcon: "p-paginator-icon",
  pages: "p-paginator-pages",
  pageButton: function(t) {
    var n = t.props, i = t.pageLink;
    return ["p-paginator-page p-paginator-element p-link", {
      "p-highlight": i - 1 === n.page
    }];
  },
  current: "p-paginator-current",
  rowPerPageDropdown: "p-paginator-rpp-options",
  jumpToPageDropdown: "p-paginator-page-options",
  jumpToPageInput: "p-paginator-page-input"
}, WM = Wt.extend({
  name: "paginator",
  css: GM,
  classes: UM
}), ww = {
  name: "AngleDoubleLeftIcon",
  extends: Yt
}, YM = /* @__PURE__ */ oe("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M5.71602 11.164C5.80782 11.2021 5.9063 11.2215 6.00569 11.221C6.20216 11.2301 6.39427 11.1612 6.54025 11.0294C6.68191 10.8875 6.76148 10.6953 6.76148 10.4948C6.76148 10.2943 6.68191 10.1021 6.54025 9.96024L3.51441 6.9344L6.54025 3.90855C6.624 3.76126 6.65587 3.59011 6.63076 3.42254C6.60564 3.25498 6.525 3.10069 6.40175 2.98442C6.2785 2.86815 6.11978 2.79662 5.95104 2.7813C5.78229 2.76598 5.61329 2.80776 5.47112 2.89994L1.97123 6.39983C1.82957 6.54167 1.75 6.73393 1.75 6.9344C1.75 7.13486 1.82957 7.32712 1.97123 7.46896L5.47112 10.9991C5.54096 11.0698 5.62422 11.1259 5.71602 11.164ZM11.0488 10.9689C11.1775 11.1156 11.3585 11.2061 11.5531 11.221C11.7477 11.2061 11.9288 11.1156 12.0574 10.9689C12.1815 10.8302 12.25 10.6506 12.25 10.4645C12.25 10.2785 12.1815 10.0989 12.0574 9.96024L9.03158 6.93439L12.0574 3.90855C12.1248 3.76739 12.1468 3.60881 12.1204 3.45463C12.0939 3.30045 12.0203 3.15826 11.9097 3.04765C11.7991 2.93703 11.6569 2.86343 11.5027 2.83698C11.3486 2.81053 11.19 2.83252 11.0488 2.89994L7.51865 6.36957C7.37699 6.51141 7.29742 6.70367 7.29742 6.90414C7.29742 7.1046 7.37699 7.29686 7.51865 7.4387L11.0488 10.9689Z",
  fill: "currentColor"
}, null, -1), qM = [YM];
function KM(e, t, n, i, o, a) {
  return E(), X("svg", Ce({
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.pti()), qM, 16);
}
ww.render = KM;
var Pm = {
  name: "FilterIcon",
  extends: Yt,
  computed: {
    pathId: function() {
      return "pv_icon_clip_".concat(Mt());
    }
  }
}, XM = ["clip-path"], ZM = /* @__PURE__ */ oe("path", {
  d: "M8.64708 14H5.35296C5.18981 13.9979 5.03395 13.9321 4.91858 13.8167C4.8032 13.7014 4.73745 13.5455 4.73531 13.3824V7L0.329431 0.98C0.259794 0.889466 0.217389 0.780968 0.20718 0.667208C0.19697 0.553448 0.219379 0.439133 0.271783 0.337647C0.324282 0.236453 0.403423 0.151519 0.500663 0.0920138C0.597903 0.0325088 0.709548 0.000692754 0.823548 0H13.1765C13.2905 0.000692754 13.4021 0.0325088 13.4994 0.0920138C13.5966 0.151519 13.6758 0.236453 13.7283 0.337647C13.7807 0.439133 13.8031 0.553448 13.7929 0.667208C13.7826 0.780968 13.7402 0.889466 13.6706 0.98L9.26472 7V13.3824C9.26259 13.5455 9.19683 13.7014 9.08146 13.8167C8.96609 13.9321 8.81022 13.9979 8.64708 14ZM5.97061 12.7647H8.02943V6.79412C8.02878 6.66289 8.07229 6.53527 8.15296 6.43177L11.9412 1.23529H2.05884L5.86355 6.43177C5.94422 6.53527 5.98773 6.66289 5.98708 6.79412L5.97061 12.7647Z",
  fill: "currentColor"
}, null, -1), JM = [ZM], QM = ["id"], eO = /* @__PURE__ */ oe("rect", {
  width: "14",
  height: "14",
  fill: "white"
}, null, -1), tO = [eO];
function nO(e, t, n, i, o, a) {
  return E(), X("svg", Ce({
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.pti()), [oe("g", {
    "clip-path": "url(#".concat(a.pathId, ")")
  }, JM, 8, XM), oe("defs", null, [oe("clipPath", {
    id: "".concat(a.pathId)
  }, tO, 8, QM)])], 16);
}
Pm.render = nO;
var Ho = {
  name: "TimesIcon",
  extends: Yt
}, iO = /* @__PURE__ */ oe("path", {
  d: "M8.01186 7.00933L12.27 2.75116C12.341 2.68501 12.398 2.60524 12.4375 2.51661C12.4769 2.42798 12.4982 2.3323 12.4999 2.23529C12.5016 2.13827 12.4838 2.0419 12.4474 1.95194C12.4111 1.86197 12.357 1.78024 12.2884 1.71163C12.2198 1.64302 12.138 1.58893 12.0481 1.55259C11.9581 1.51625 11.8617 1.4984 11.7647 1.50011C11.6677 1.50182 11.572 1.52306 11.4834 1.56255C11.3948 1.60204 11.315 1.65898 11.2488 1.72997L6.99067 5.98814L2.7325 1.72997C2.59553 1.60234 2.41437 1.53286 2.22718 1.53616C2.03999 1.53946 1.8614 1.61529 1.72901 1.74767C1.59663 1.88006 1.5208 2.05865 1.5175 2.24584C1.5142 2.43303 1.58368 2.61419 1.71131 2.75116L5.96948 7.00933L1.71131 11.2675C1.576 11.403 1.5 11.5866 1.5 11.7781C1.5 11.9696 1.576 12.1532 1.71131 12.2887C1.84679 12.424 2.03043 12.5 2.2219 12.5C2.41338 12.5 2.59702 12.424 2.7325 12.2887L6.99067 8.03052L11.2488 12.2887C11.3843 12.424 11.568 12.5 11.7594 12.5C11.9509 12.5 12.1346 12.424 12.27 12.2887C12.4053 12.1532 12.4813 11.9696 12.4813 11.7781C12.4813 11.5866 12.4053 11.403 12.27 11.2675L8.01186 7.00933Z",
  fill: "currentColor"
}, null, -1), aO = [iO];
function oO(e, t, n, i, o, a) {
  return E(), X("svg", Ce({
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.pti()), aO, 16);
}
Ho.render = oO;
var Zn = zx(), Yn = {
  name: "Portal",
  props: {
    appendTo: {
      type: [String, Object],
      default: "body"
    },
    disabled: {
      type: Boolean,
      default: !1
    }
  },
  data: function() {
    return {
      mounted: !1
    };
  },
  mounted: function() {
    this.mounted = Oe.isClient();
  },
  computed: {
    inline: function() {
      return this.disabled || this.appendTo === "self";
    }
  }
};
function rO(e, t, n, i, o, a) {
  return a.inline ? je(e.$slots, "default", {
    key: 0
  }) : o.mounted ? (E(), fe(Rx, {
    key: 1,
    to: n.appendTo
  }, [je(e.$slots, "default")], 8, ["to"])) : te("", !0);
}
Yn.render = rO;
var sO = `
@layer primevue {
    .p-virtualscroller {
        position: relative;
        overflow: auto;
        contain: strict;
        transform: translateZ(0);
        will-change: scroll-position;
        outline: 0 none;
    }

    .p-virtualscroller-content {
        position: absolute;
        top: 0;
        left: 0;
        /* contain: content; */
        min-height: 100%;
        min-width: 100%;
        will-change: transform;
    }

    .p-virtualscroller-spacer {
        position: absolute;
        top: 0;
        left: 0;
        height: 1px;
        width: 1px;
        transform-origin: 0 0;
        pointer-events: none;
    }

    .p-virtualscroller .p-virtualscroller-loader {
        position: sticky;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
    }

    .p-virtualscroller-loader.p-component-overlay {
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .p-virtualscroller-loading-icon {
        font-size: 2rem;
    }

    .p-virtualscroller-loading-icon.p-icon {
        width: 2rem;
        height: 2rem;
    }

    .p-virtualscroller-horizontal > .p-virtualscroller-content {
        display: flex;
    }

    /* Inline */
    .p-virtualscroller-inline .p-virtualscroller-content {
        position: static;
    }
}
`, Xv = Wt.extend({
  name: "virtualscroller",
  css: sO
}), lO = {
  name: "BaseVirtualScroller",
  extends: wt,
  props: {
    id: {
      type: String,
      default: null
    },
    style: null,
    class: null,
    items: {
      type: Array,
      default: null
    },
    itemSize: {
      type: [Number, Array],
      default: 0
    },
    scrollHeight: null,
    scrollWidth: null,
    orientation: {
      type: String,
      default: "vertical"
    },
    numToleratedItems: {
      type: Number,
      default: null
    },
    delay: {
      type: Number,
      default: 0
    },
    resizeDelay: {
      type: Number,
      default: 10
    },
    lazy: {
      type: Boolean,
      default: !1
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    loaderDisabled: {
      type: Boolean,
      default: !1
    },
    columns: {
      type: Array,
      default: null
    },
    loading: {
      type: Boolean,
      default: !1
    },
    showSpacer: {
      type: Boolean,
      default: !0
    },
    showLoader: {
      type: Boolean,
      default: !1
    },
    tabindex: {
      type: Number,
      default: 0
    },
    inline: {
      type: Boolean,
      default: !1
    },
    step: {
      type: Number,
      default: 0
    },
    appendOnly: {
      type: Boolean,
      default: !1
    },
    autoSize: {
      type: Boolean,
      default: !1
    }
  },
  style: Xv,
  provide: function() {
    return {
      $parentInstance: this
    };
  },
  beforeMount: function() {
    Xv.loadStyle();
  }
};
function Gl(e) {
  "@babel/helpers - typeof";
  return Gl = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Gl(e);
}
function Zv(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    t && (i = i.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), n.push.apply(n, i);
  }
  return n;
}
function tl(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Zv(Object(n), !0).forEach(function(i) {
      kw(e, i, n[i]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Zv(Object(n)).forEach(function(i) {
      Object.defineProperty(e, i, Object.getOwnPropertyDescriptor(n, i));
    });
  }
  return e;
}
function kw(e, t, n) {
  return t = cO(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function cO(e) {
  var t = dO(e, "string");
  return Gl(t) == "symbol" ? t : String(t);
}
function dO(e, t) {
  if (Gl(e) != "object" || !e)
    return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var i = n.call(e, t || "default");
    if (Gl(i) != "object")
      return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var Ls = {
  name: "VirtualScroller",
  extends: lO,
  emits: ["update:numToleratedItems", "scroll", "scroll-index-change", "lazy-load"],
  data: function() {
    return {
      first: this.isBoth() ? {
        rows: 0,
        cols: 0
      } : 0,
      last: this.isBoth() ? {
        rows: 0,
        cols: 0
      } : 0,
      page: this.isBoth() ? {
        rows: 0,
        cols: 0
      } : 0,
      numItemsInViewport: this.isBoth() ? {
        rows: 0,
        cols: 0
      } : 0,
      lastScrollPos: this.isBoth() ? {
        top: 0,
        left: 0
      } : 0,
      d_numToleratedItems: this.numToleratedItems,
      d_loading: this.loading,
      loaderArr: [],
      spacerStyle: {},
      contentStyle: {}
    };
  },
  element: null,
  content: null,
  lastScrollPos: null,
  scrollTimeout: null,
  resizeTimeout: null,
  defaultWidth: 0,
  defaultHeight: 0,
  defaultContentWidth: 0,
  defaultContentHeight: 0,
  isRangeChanged: !1,
  lazyLoadState: {},
  resizeListener: null,
  initialized: !1,
  watch: {
    numToleratedItems: function(t) {
      this.d_numToleratedItems = t;
    },
    loading: function(t, n) {
      this.lazy && t !== n && t !== this.d_loading && (this.d_loading = t);
    },
    items: function(t, n) {
      (!n || n.length !== (t || []).length) && (this.init(), this.calculateAutoSize());
    },
    itemSize: function() {
      this.init(), this.calculateAutoSize();
    },
    orientation: function() {
      this.lastScrollPos = this.isBoth() ? {
        top: 0,
        left: 0
      } : 0;
    },
    scrollHeight: function() {
      this.init(), this.calculateAutoSize();
    },
    scrollWidth: function() {
      this.init(), this.calculateAutoSize();
    }
  },
  mounted: function() {
    this.viewInit(), this.lastScrollPos = this.isBoth() ? {
      top: 0,
      left: 0
    } : 0, this.lazyLoadState = this.lazyLoadState || {};
  },
  updated: function() {
    !this.initialized && this.viewInit();
  },
  unmounted: function() {
    this.unbindResizeListener(), this.initialized = !1;
  },
  methods: {
    viewInit: function() {
      Oe.isVisible(this.element) && (this.setContentEl(this.content), this.init(), this.bindResizeListener(), this.defaultWidth = Oe.getWidth(this.element), this.defaultHeight = Oe.getHeight(this.element), this.defaultContentWidth = Oe.getWidth(this.content), this.defaultContentHeight = Oe.getHeight(this.content), this.initialized = !0);
    },
    init: function() {
      this.disabled || (this.setSize(), this.calculateOptions(), this.setSpacerSize());
    },
    isVertical: function() {
      return this.orientation === "vertical";
    },
    isHorizontal: function() {
      return this.orientation === "horizontal";
    },
    isBoth: function() {
      return this.orientation === "both";
    },
    scrollTo: function(t) {
      this.lastScrollPos = this.both ? {
        top: 0,
        left: 0
      } : 0, this.element && this.element.scrollTo(t);
    },
    scrollToIndex: function(t) {
      var n = this, i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "auto", o = this.isBoth(), a = this.isHorizontal(), r = this.first, s = this.calculateNumItems(), l = s.numToleratedItems, d = this.getContentPosition(), y = this.itemSize, u = function() {
        var P = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, f = arguments.length > 1 ? arguments[1] : void 0;
        return P <= f ? 0 : P;
      }, m = function(P, f, S) {
        return P * f + S;
      }, h = function() {
        var P = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, f = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
        return n.scrollTo({
          left: P,
          top: f,
          behavior: i
        });
      }, c = o ? {
        rows: 0,
        cols: 0
      } : 0, g = !1;
      o ? (c = {
        rows: u(t[0], l[0]),
        cols: u(t[1], l[1])
      }, h(m(c.cols, y[1], d.left), m(c.rows, y[0], d.top)), g = c.rows !== r.rows || c.cols !== r.cols) : (c = u(t, l), a ? h(m(c, y, d.left), 0) : h(0, m(c, y, d.top)), g = c !== r), this.isRangeChanged = g, this.first = c;
    },
    scrollInView: function(t, n) {
      var i = this, o = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "auto";
      if (n) {
        var a = this.isBoth(), r = this.isHorizontal(), s = this.getRenderedRange(), l = s.first, d = s.viewport, y = function() {
          var v = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, P = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
          return i.scrollTo({
            left: v,
            top: P,
            behavior: o
          });
        }, u = n === "to-start", m = n === "to-end";
        if (u) {
          if (a)
            d.first.rows - l.rows > t[0] ? y(d.first.cols * this.itemSize[1], (d.first.rows - 1) * this.itemSize[0]) : d.first.cols - l.cols > t[1] && y((d.first.cols - 1) * this.itemSize[1], d.first.rows * this.itemSize[0]);
          else if (d.first - l > t) {
            var h = (d.first - 1) * this.itemSize;
            r ? y(h, 0) : y(0, h);
          }
        } else if (m) {
          if (a)
            d.last.rows - l.rows <= t[0] + 1 ? y(d.first.cols * this.itemSize[1], (d.first.rows + 1) * this.itemSize[0]) : d.last.cols - l.cols <= t[1] + 1 && y((d.first.cols + 1) * this.itemSize[1], d.first.rows * this.itemSize[0]);
          else if (d.last - l <= t + 1) {
            var c = (d.first + 1) * this.itemSize;
            r ? y(c, 0) : y(0, c);
          }
        }
      } else
        this.scrollToIndex(t, o);
    },
    getRenderedRange: function() {
      var t = function(u, m) {
        return Math.floor(u / (m || u));
      }, n = this.first, i = 0;
      if (this.element) {
        var o = this.isBoth(), a = this.isHorizontal(), r = this.element, s = r.scrollTop, l = r.scrollLeft;
        if (o)
          n = {
            rows: t(s, this.itemSize[0]),
            cols: t(l, this.itemSize[1])
          }, i = {
            rows: n.rows + this.numItemsInViewport.rows,
            cols: n.cols + this.numItemsInViewport.cols
          };
        else {
          var d = a ? l : s;
          n = t(d, this.itemSize), i = n + this.numItemsInViewport;
        }
      }
      return {
        first: this.first,
        last: this.last,
        viewport: {
          first: n,
          last: i
        }
      };
    },
    calculateNumItems: function() {
      var t = this.isBoth(), n = this.isHorizontal(), i = this.itemSize, o = this.getContentPosition(), a = this.element ? this.element.offsetWidth - o.left : 0, r = this.element ? this.element.offsetHeight - o.top : 0, s = function(m, h) {
        return Math.ceil(m / (h || m));
      }, l = function(m) {
        return Math.ceil(m / 2);
      }, d = t ? {
        rows: s(r, i[0]),
        cols: s(a, i[1])
      } : s(n ? a : r, i), y = this.d_numToleratedItems || (t ? [l(d.rows), l(d.cols)] : l(d));
      return {
        numItemsInViewport: d,
        numToleratedItems: y
      };
    },
    calculateOptions: function() {
      var t = this, n = this.isBoth(), i = this.first, o = this.calculateNumItems(), a = o.numItemsInViewport, r = o.numToleratedItems, s = function(y, u, m) {
        var h = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !1;
        return t.getLast(y + u + (y < m ? 2 : 3) * m, h);
      }, l = n ? {
        rows: s(i.rows, a.rows, r[0]),
        cols: s(i.cols, a.cols, r[1], !0)
      } : s(i, a, r);
      this.last = l, this.numItemsInViewport = a, this.d_numToleratedItems = r, this.$emit("update:numToleratedItems", this.d_numToleratedItems), this.showLoader && (this.loaderArr = n ? Array.from({
        length: a.rows
      }).map(function() {
        return Array.from({
          length: a.cols
        });
      }) : Array.from({
        length: a
      })), this.lazy && Promise.resolve().then(function() {
        t.lazyLoadState = {
          first: t.step ? n ? {
            rows: 0,
            cols: i.cols
          } : 0 : i,
          last: Math.min(t.step ? t.step : l, t.items.length)
        }, t.$emit("lazy-load", t.lazyLoadState);
      });
    },
    calculateAutoSize: function() {
      var t = this;
      this.autoSize && !this.d_loading && Promise.resolve().then(function() {
        if (t.content) {
          var n = t.isBoth(), i = t.isHorizontal(), o = t.isVertical();
          t.content.style.minHeight = t.content.style.minWidth = "auto", t.content.style.position = "relative", t.element.style.contain = "none";
          var a = [Oe.getWidth(t.content), Oe.getHeight(t.content)], r = a[0], s = a[1];
          r !== t.defaultContentWidth && (t.element.style.width = ""), s !== t.defaultContentHeight && (t.element.style.height = "");
          var l = [Oe.getWidth(t.element), Oe.getHeight(t.element)], d = l[0], y = l[1];
          (n || i) && (t.element.style.width = d < t.defaultWidth ? d + "px" : t.scrollWidth || t.defaultWidth + "px"), (n || o) && (t.element.style.height = y < t.defaultHeight ? y + "px" : t.scrollHeight || t.defaultHeight + "px"), t.content.style.minHeight = t.content.style.minWidth = "", t.content.style.position = "", t.element.style.contain = "";
        }
      });
    },
    getLast: function() {
      var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, n = arguments.length > 1 ? arguments[1] : void 0;
      return this.items ? Math.min(n ? (this.columns || this.items[0]).length : this.items.length, t) : 0;
    },
    getContentPosition: function() {
      if (this.content) {
        var t = getComputedStyle(this.content), n = parseFloat(t.paddingLeft) + Math.max(parseFloat(t.left) || 0, 0), i = parseFloat(t.paddingRight) + Math.max(parseFloat(t.right) || 0, 0), o = parseFloat(t.paddingTop) + Math.max(parseFloat(t.top) || 0, 0), a = parseFloat(t.paddingBottom) + Math.max(parseFloat(t.bottom) || 0, 0);
        return {
          left: n,
          right: i,
          top: o,
          bottom: a,
          x: n + i,
          y: o + a
        };
      }
      return {
        left: 0,
        right: 0,
        top: 0,
        bottom: 0,
        x: 0,
        y: 0
      };
    },
    setSize: function() {
      var t = this;
      if (this.element) {
        var n = this.isBoth(), i = this.isHorizontal(), o = this.element.parentElement, a = this.scrollWidth || "".concat(this.element.offsetWidth || o.offsetWidth, "px"), r = this.scrollHeight || "".concat(this.element.offsetHeight || o.offsetHeight, "px"), s = function(d, y) {
          return t.element.style[d] = y;
        };
        n || i ? (s("height", r), s("width", a)) : s("height", r);
      }
    },
    setSpacerSize: function() {
      var t = this, n = this.items;
      if (n) {
        var i = this.isBoth(), o = this.isHorizontal(), a = this.getContentPosition(), r = function(l, d, y) {
          var u = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0;
          return t.spacerStyle = tl(tl({}, t.spacerStyle), kw({}, "".concat(l), (d || []).length * y + u + "px"));
        };
        i ? (r("height", n, this.itemSize[0], a.y), r("width", this.columns || n[1], this.itemSize[1], a.x)) : o ? r("width", this.columns || n, this.itemSize, a.x) : r("height", n, this.itemSize, a.y);
      }
    },
    setContentPosition: function(t) {
      var n = this;
      if (this.content && !this.appendOnly) {
        var i = this.isBoth(), o = this.isHorizontal(), a = t ? t.first : this.first, r = function(y, u) {
          return y * u;
        }, s = function() {
          var y = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, u = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
          return n.contentStyle = tl(tl({}, n.contentStyle), {
            transform: "translate3d(".concat(y, "px, ").concat(u, "px, 0)")
          });
        };
        if (i)
          s(r(a.cols, this.itemSize[1]), r(a.rows, this.itemSize[0]));
        else {
          var l = r(a, this.itemSize);
          o ? s(l, 0) : s(0, l);
        }
      }
    },
    onScrollPositionChange: function(t) {
      var n = this, i = t.target, o = this.isBoth(), a = this.isHorizontal(), r = this.getContentPosition(), s = function(M, D) {
        return M ? M > D ? M - D : M : 0;
      }, l = function(M, D) {
        return Math.floor(M / (D || M));
      }, d = function(M, D, C, b, p, L) {
        return M <= p ? p : L ? C - b - p : D + p - 1;
      }, y = function(M, D, C, b, p, L, B) {
        return M <= L ? 0 : Math.max(0, B ? M < D ? C : M - L : M > D ? C : M - 2 * L);
      }, u = function(M, D, C, b, p, L) {
        var B = D + b + 2 * p;
        return M >= p && (B += p + 1), n.getLast(B, L);
      }, m = s(i.scrollTop, r.top), h = s(i.scrollLeft, r.left), c = o ? {
        rows: 0,
        cols: 0
      } : 0, g = this.last, v = !1, P = this.lastScrollPos;
      if (o) {
        var f = this.lastScrollPos.top <= m, S = this.lastScrollPos.left <= h;
        if (!this.appendOnly || this.appendOnly && (f || S)) {
          var w = {
            rows: l(m, this.itemSize[0]),
            cols: l(h, this.itemSize[1])
          }, x = {
            rows: d(w.rows, this.first.rows, this.last.rows, this.numItemsInViewport.rows, this.d_numToleratedItems[0], f),
            cols: d(w.cols, this.first.cols, this.last.cols, this.numItemsInViewport.cols, this.d_numToleratedItems[1], S)
          };
          c = {
            rows: y(w.rows, x.rows, this.first.rows, this.last.rows, this.numItemsInViewport.rows, this.d_numToleratedItems[0], f),
            cols: y(w.cols, x.cols, this.first.cols, this.last.cols, this.numItemsInViewport.cols, this.d_numToleratedItems[1], S)
          }, g = {
            rows: u(w.rows, c.rows, this.last.rows, this.numItemsInViewport.rows, this.d_numToleratedItems[0]),
            cols: u(w.cols, c.cols, this.last.cols, this.numItemsInViewport.cols, this.d_numToleratedItems[1], !0)
          }, v = c.rows !== this.first.rows || g.rows !== this.last.rows || c.cols !== this.first.cols || g.cols !== this.last.cols || this.isRangeChanged, P = {
            top: m,
            left: h
          };
        }
      } else {
        var k = a ? h : m, A = this.lastScrollPos <= k;
        if (!this.appendOnly || this.appendOnly && A) {
          var $ = l(k, this.itemSize), j = d($, this.first, this.last, this.numItemsInViewport, this.d_numToleratedItems, A);
          c = y($, j, this.first, this.last, this.numItemsInViewport, this.d_numToleratedItems, A), g = u($, c, this.last, this.numItemsInViewport, this.d_numToleratedItems), v = c !== this.first || g !== this.last || this.isRangeChanged, P = k;
        }
      }
      return {
        first: c,
        last: g,
        isRangeChanged: v,
        scrollPos: P
      };
    },
    onScrollChange: function(t) {
      var n = this.onScrollPositionChange(t), i = n.first, o = n.last, a = n.isRangeChanged, r = n.scrollPos;
      if (a) {
        var s = {
          first: i,
          last: o
        };
        if (this.setContentPosition(s), this.first = i, this.last = o, this.lastScrollPos = r, this.$emit("scroll-index-change", s), this.lazy && this.isPageChanged(i)) {
          var l = {
            first: this.step ? Math.min(this.getPageByFirst(i) * this.step, this.items.length - this.step) : i,
            last: Math.min(this.step ? (this.getPageByFirst(i) + 1) * this.step : o, this.items.length)
          }, d = this.lazyLoadState.first !== l.first || this.lazyLoadState.last !== l.last;
          d && this.$emit("lazy-load", l), this.lazyLoadState = l;
        }
      }
    },
    onScroll: function(t) {
      var n = this;
      if (this.$emit("scroll", t), this.delay) {
        if (this.scrollTimeout && clearTimeout(this.scrollTimeout), this.isPageChanged()) {
          if (!this.d_loading && this.showLoader) {
            var i = this.onScrollPositionChange(t), o = i.isRangeChanged, a = o || (this.step ? this.isPageChanged() : !1);
            a && (this.d_loading = !0);
          }
          this.scrollTimeout = setTimeout(function() {
            n.onScrollChange(t), n.d_loading && n.showLoader && (!n.lazy || n.loading === void 0) && (n.d_loading = !1, n.page = n.getPageByFirst());
          }, this.delay);
        }
      } else
        this.onScrollChange(t);
    },
    onResize: function() {
      var t = this;
      this.resizeTimeout && clearTimeout(this.resizeTimeout), this.resizeTimeout = setTimeout(function() {
        if (Oe.isVisible(t.element)) {
          var n = t.isBoth(), i = t.isVertical(), o = t.isHorizontal(), a = [Oe.getWidth(t.element), Oe.getHeight(t.element)], r = a[0], s = a[1], l = r !== t.defaultWidth, d = s !== t.defaultHeight, y = n ? l || d : o ? l : i ? d : !1;
          y && (t.d_numToleratedItems = t.numToleratedItems, t.defaultWidth = r, t.defaultHeight = s, t.defaultContentWidth = Oe.getWidth(t.content), t.defaultContentHeight = Oe.getHeight(t.content), t.init());
        }
      }, this.resizeDelay);
    },
    bindResizeListener: function() {
      this.resizeListener || (this.resizeListener = this.onResize.bind(this), window.addEventListener("resize", this.resizeListener), window.addEventListener("orientationchange", this.resizeListener));
    },
    unbindResizeListener: function() {
      this.resizeListener && (window.removeEventListener("resize", this.resizeListener), window.removeEventListener("orientationchange", this.resizeListener), this.resizeListener = null);
    },
    getOptions: function(t) {
      var n = (this.items || []).length, i = this.isBoth() ? this.first.rows + t : this.first + t;
      return {
        index: i,
        count: n,
        first: i === 0,
        last: i === n - 1,
        even: i % 2 === 0,
        odd: i % 2 !== 0
      };
    },
    getLoaderOptions: function(t, n) {
      var i = this.loaderArr.length;
      return tl({
        index: t,
        count: i,
        first: t === 0,
        last: t === i - 1,
        even: t % 2 === 0,
        odd: t % 2 !== 0
      }, n);
    },
    getPageByFirst: function(t) {
      return Math.floor(((t ?? this.first) + this.d_numToleratedItems * 4) / (this.step || 1));
    },
    isPageChanged: function(t) {
      return this.step ? this.page !== this.getPageByFirst(t ?? this.first) : !0;
    },
    setContentEl: function(t) {
      this.content = t || this.content || Oe.findSingle(this.element, '[data-pc-section="content"]');
    },
    elementRef: function(t) {
      this.element = t;
    },
    contentRef: function(t) {
      this.content = t;
    }
  },
  computed: {
    containerClass: function() {
      return ["p-virtualscroller", this.class, {
        "p-virtualscroller-inline": this.inline,
        "p-virtualscroller-both p-both-scroll": this.isBoth(),
        "p-virtualscroller-horizontal p-horizontal-scroll": this.isHorizontal()
      }];
    },
    contentClass: function() {
      return ["p-virtualscroller-content", {
        "p-virtualscroller-loading": this.d_loading
      }];
    },
    loaderClass: function() {
      return ["p-virtualscroller-loader", {
        "p-component-overlay": !this.$slots.loader
      }];
    },
    loadedItems: function() {
      var t = this;
      return this.items && !this.d_loading ? this.isBoth() ? this.items.slice(this.appendOnly ? 0 : this.first.rows, this.last.rows).map(function(n) {
        return t.columns ? n : n.slice(t.appendOnly ? 0 : t.first.cols, t.last.cols);
      }) : this.isHorizontal() && this.columns ? this.items : this.items.slice(this.appendOnly ? 0 : this.first, this.last) : [];
    },
    loadedRows: function() {
      return this.d_loading ? this.loaderDisabled ? this.loaderArr : [] : this.loadedItems;
    },
    loadedColumns: function() {
      if (this.columns) {
        var t = this.isBoth(), n = this.isHorizontal();
        if (t || n)
          return this.d_loading && this.loaderDisabled ? t ? this.loaderArr[0] : this.loaderArr : this.columns.slice(t ? this.first.cols : this.first, t ? this.last.cols : this.last);
      }
      return this.columns;
    }
  },
  components: {
    SpinnerIcon: jo
  }
}, uO = ["tabindex"];
function hO(e, t, n, i, o, a) {
  var r = $e("SpinnerIcon");
  return e.disabled ? (E(), X(Re, {
    key: 1
  }, [je(e.$slots, "default"), je(e.$slots, "content", {
    items: e.items,
    rows: e.items,
    columns: a.loadedColumns
  })], 64)) : (E(), X("div", Ce({
    key: 0,
    ref: a.elementRef,
    class: a.containerClass,
    tabindex: e.tabindex,
    style: e.style,
    onScroll: t[0] || (t[0] = function() {
      return a.onScroll && a.onScroll.apply(a, arguments);
    })
  }, e.ptm("root"), {
    "data-pc-name": "virtualscroller"
  }), [je(e.$slots, "content", {
    styleClass: a.contentClass,
    items: a.loadedItems,
    getItemOptions: a.getOptions,
    loading: o.d_loading,
    getLoaderOptions: a.getLoaderOptions,
    itemSize: e.itemSize,
    rows: a.loadedRows,
    columns: a.loadedColumns,
    contentRef: a.contentRef,
    spacerStyle: o.spacerStyle,
    contentStyle: o.contentStyle,
    vertical: a.isVertical(),
    horizontal: a.isHorizontal(),
    both: a.isBoth()
  }, function() {
    return [oe("div", Ce({
      ref: a.contentRef,
      class: a.contentClass,
      style: o.contentStyle
    }, e.ptm("content")), [(E(!0), X(Re, null, Ge(a.loadedItems, function(s, l) {
      return je(e.$slots, "item", {
        key: l,
        item: s,
        options: a.getOptions(l)
      });
    }), 128))], 16)];
  }), e.showSpacer ? (E(), X("div", Ce({
    key: 0,
    class: "p-virtualscroller-spacer",
    style: o.spacerStyle
  }, e.ptm("spacer")), null, 16)) : te("", !0), !e.loaderDisabled && e.showLoader && o.d_loading ? (E(), X("div", Ce({
    key: 1,
    class: a.loaderClass
  }, e.ptm("loader")), [e.$slots && e.$slots.loader ? (E(!0), X(Re, {
    key: 0
  }, Ge(o.loaderArr, function(s, l) {
    return je(e.$slots, "loader", {
      key: l,
      options: a.getLoaderOptions(l, a.isBoth() && {
        numCols: e.d_numItemsInViewport.cols
      })
    });
  }), 128)) : te("", !0), je(e.$slots, "loadingicon", {}, function() {
    return [ue(r, Ce({
      spin: "",
      class: "p-virtualscroller-loading-icon"
    }, e.ptm("loadingIcon")), null, 16)];
  })], 16)) : te("", !0)], 16, uO));
}
Ls.render = hO;
var pO = `
@layer primevue {
    .p-dropdown {
        display: inline-flex;
        cursor: pointer;
        position: relative;
        user-select: none;
    }

    .p-dropdown-clear-icon {
        position: absolute;
        top: 50%;
        margin-top: -0.5rem;
    }

    .p-dropdown-trigger {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
    }

    .p-dropdown-label {
        display: block;
        white-space: nowrap;
        overflow: hidden;
        flex: 1 1 auto;
        width: 1%;
        text-overflow: ellipsis;
        cursor: pointer;
    }

    .p-dropdown-label-empty {
        overflow: hidden;
        opacity: 0;
    }

    input.p-dropdown-label {
        cursor: default;
    }

    .p-dropdown .p-dropdown-panel {
        min-width: 100%;
    }

    .p-dropdown-panel {
        position: absolute;
        top: 0;
        left: 0;
    }

    .p-dropdown-items-wrapper {
        overflow: auto;
    }

    .p-dropdown-item {
        cursor: pointer;
        font-weight: normal;
        white-space: nowrap;
        position: relative;
        overflow: hidden;
    }

    .p-dropdown-item-group {
        cursor: auto;
    }

    .p-dropdown-items {
        margin: 0;
        padding: 0;
        list-style-type: none;
    }

    .p-dropdown-filter {
        width: 100%;
    }

    .p-dropdown-filter-container {
        position: relative;
    }

    .p-dropdown-filter-icon {
        position: absolute;
        top: 50%;
        margin-top: -0.5rem;
    }

    .p-fluid .p-dropdown {
        display: flex;
    }

    .p-fluid .p-dropdown .p-dropdown-label {
        width: 1%;
    }
}
`, fO = {
  root: function(t) {
    var n = t.instance, i = t.props, o = t.state;
    return ["p-dropdown p-component p-inputwrapper", {
      "p-disabled": i.disabled,
      "p-dropdown-clearable": i.showClear,
      "p-focus": o.focused,
      "p-inputwrapper-filled": n.hasSelectedOption,
      "p-inputwrapper-focus": o.focused || o.overlayVisible,
      "p-overlay-open": o.overlayVisible
    }];
  },
  input: function(t) {
    var n = t.instance, i = t.props;
    return ["p-dropdown-label p-inputtext", {
      "p-placeholder": !i.editable && n.label === i.placeholder,
      "p-dropdown-label-empty": !i.editable && !n.$slots.value && (n.label === "p-emptylabel" || n.label.length === 0)
    }];
  },
  clearIcon: "p-dropdown-clear-icon",
  trigger: "p-dropdown-trigger",
  loadingicon: "p-dropdown-trigger-icon",
  dropdownIcon: "p-dropdown-trigger-icon",
  panel: function(t) {
    var n = t.instance;
    return ["p-dropdown-panel p-component", {
      "p-input-filled": n.$primevue.config.inputStyle === "filled",
      "p-ripple-disabled": n.$primevue.config.ripple === !1
    }];
  },
  header: "p-dropdown-header",
  filterContainer: "p-dropdown-filter-container",
  filterInput: "p-dropdown-filter p-inputtext p-component",
  filterIcon: "p-dropdown-filter-icon",
  wrapper: "p-dropdown-items-wrapper",
  list: "p-dropdown-items",
  itemGroup: "p-dropdown-item-group",
  item: function(t) {
    var n = t.instance, i = t.state, o = t.option, a = t.focusedOption;
    return ["p-dropdown-item", {
      "p-highlight": n.isSelected(o),
      "p-focus": i.focusedOptionIndex === a,
      "p-disabled": n.isOptionDisabled(o)
    }];
  },
  emptyMessage: "p-dropdown-empty-message"
}, mO = Wt.extend({
  name: "dropdown",
  css: pO,
  classes: fO
}), gO = {
  name: "BaseDropdown",
  extends: wt,
  props: {
    modelValue: null,
    options: Array,
    optionLabel: [String, Function],
    optionValue: [String, Function],
    optionDisabled: [String, Function],
    optionGroupLabel: [String, Function],
    optionGroupChildren: [String, Function],
    scrollHeight: {
      type: String,
      default: "200px"
    },
    filter: Boolean,
    filterPlaceholder: String,
    filterLocale: String,
    filterMatchMode: {
      type: String,
      default: "contains"
    },
    filterFields: {
      type: Array,
      default: null
    },
    editable: Boolean,
    placeholder: {
      type: String,
      default: null
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    dataKey: null,
    showClear: {
      type: Boolean,
      default: !1
    },
    inputId: {
      type: String,
      default: null
    },
    inputClass: {
      type: [String, Object],
      default: null
    },
    inputStyle: {
      type: Object,
      default: null
    },
    inputProps: {
      type: null,
      default: null
    },
    panelClass: {
      type: [String, Object],
      default: null
    },
    panelStyle: {
      type: Object,
      default: null
    },
    panelProps: {
      type: null,
      default: null
    },
    filterInputProps: {
      type: null,
      default: null
    },
    clearIconProps: {
      type: null,
      default: null
    },
    appendTo: {
      type: [String, Object],
      default: "body"
    },
    loading: {
      type: Boolean,
      default: !1
    },
    clearIcon: {
      type: String,
      default: void 0
    },
    dropdownIcon: {
      type: String,
      default: void 0
    },
    filterIcon: {
      type: String,
      default: void 0
    },
    loadingIcon: {
      type: String,
      default: void 0
    },
    resetFilterOnHide: {
      type: Boolean,
      default: !1
    },
    virtualScrollerOptions: {
      type: Object,
      default: null
    },
    autoOptionFocus: {
      type: Boolean,
      default: !0
    },
    autoFilterFocus: {
      type: Boolean,
      default: !1
    },
    selectOnFocus: {
      type: Boolean,
      default: !1
    },
    filterMessage: {
      type: String,
      default: null
    },
    selectionMessage: {
      type: String,
      default: null
    },
    emptySelectionMessage: {
      type: String,
      default: null
    },
    emptyFilterMessage: {
      type: String,
      default: null
    },
    emptyMessage: {
      type: String,
      default: null
    },
    tabindex: {
      type: Number,
      default: 0
    },
    ariaLabel: {
      type: String,
      default: null
    },
    ariaLabelledby: {
      type: String,
      default: null
    }
  },
  style: mO,
  provide: function() {
    return {
      $parentInstance: this
    };
  }
};
function Ul(e) {
  "@babel/helpers - typeof";
  return Ul = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Ul(e);
}
function vO(e) {
  return wO(e) || xO(e) || bO(e) || yO();
}
function yO() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function bO(e, t) {
  if (e) {
    if (typeof e == "string")
      return Yp(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set")
      return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return Yp(e, t);
  }
}
function xO(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null)
    return Array.from(e);
}
function wO(e) {
  if (Array.isArray(e))
    return Yp(e);
}
function Yp(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, i = new Array(t); n < t; n++)
    i[n] = e[n];
  return i;
}
function Jv(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    t && (i = i.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), n.push.apply(n, i);
  }
  return n;
}
function Qv(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Jv(Object(n), !0).forEach(function(i) {
      Sw(e, i, n[i]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Jv(Object(n)).forEach(function(i) {
      Object.defineProperty(e, i, Object.getOwnPropertyDescriptor(n, i));
    });
  }
  return e;
}
function Sw(e, t, n) {
  return t = kO(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function kO(e) {
  var t = SO(e, "string");
  return Ul(t) == "symbol" ? t : String(t);
}
function SO(e, t) {
  if (Ul(e) != "object" || !e)
    return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var i = n.call(e, t || "default");
    if (Ul(i) != "object")
      return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var Ga = {
  name: "Dropdown",
  extends: gO,
  emits: ["update:modelValue", "change", "focus", "blur", "before-show", "before-hide", "show", "hide", "filter"],
  outsideClickListener: null,
  scrollHandler: null,
  resizeListener: null,
  labelClickListener: null,
  overlay: null,
  list: null,
  virtualScroller: null,
  searchTimeout: null,
  searchValue: null,
  isModelValueChanged: !1,
  focusOnHover: !1,
  data: function() {
    return {
      id: this.$attrs.id,
      focused: !1,
      focusedOptionIndex: -1,
      filterValue: null,
      overlayVisible: !1
    };
  },
  watch: {
    "$attrs.id": function(t) {
      this.id = t || Mt();
    },
    modelValue: function() {
      this.isModelValueChanged = !0;
    },
    options: function() {
      this.autoUpdateModel();
    }
  },
  mounted: function() {
    this.id = this.id || Mt(), this.autoUpdateModel(), this.bindLabelClickListener();
  },
  updated: function() {
    this.overlayVisible && this.isModelValueChanged && this.scrollInView(this.findSelectedOptionIndex()), this.isModelValueChanged = !1;
  },
  beforeUnmount: function() {
    this.unbindOutsideClickListener(), this.unbindResizeListener(), this.unbindLabelClickListener(), this.scrollHandler && (this.scrollHandler.destroy(), this.scrollHandler = null), this.overlay && (qt.clear(this.overlay), this.overlay = null);
  },
  methods: {
    getOptionIndex: function(t, n) {
      return this.virtualScrollerDisabled ? t : n && n(t).index;
    },
    getOptionLabel: function(t) {
      return this.optionLabel ? We.resolveFieldData(t, this.optionLabel) : t;
    },
    getOptionValue: function(t) {
      return this.optionValue ? We.resolveFieldData(t, this.optionValue) : t;
    },
    getOptionRenderKey: function(t, n) {
      return (this.dataKey ? We.resolveFieldData(t, this.dataKey) : this.getOptionLabel(t)) + "_" + n;
    },
    getPTItemOptions: function(t, n, i, o) {
      return this.ptm(o, {
        context: {
          selected: this.isSelected(t),
          focused: this.focusedOptionIndex === this.getOptionIndex(i, n),
          disabled: this.isOptionDisabled(t)
        }
      });
    },
    isOptionDisabled: function(t) {
      return this.optionDisabled ? We.resolveFieldData(t, this.optionDisabled) : !1;
    },
    isOptionGroup: function(t) {
      return this.optionGroupLabel && t.optionGroup && t.group;
    },
    getOptionGroupLabel: function(t) {
      return We.resolveFieldData(t, this.optionGroupLabel);
    },
    getOptionGroupChildren: function(t) {
      return We.resolveFieldData(t, this.optionGroupChildren);
    },
    getAriaPosInset: function(t) {
      var n = this;
      return (this.optionGroupLabel ? t - this.visibleOptions.slice(0, t).filter(function(i) {
        return n.isOptionGroup(i);
      }).length : t) + 1;
    },
    show: function(t) {
      this.$emit("before-show"), this.overlayVisible = !0, this.focusedOptionIndex = this.focusedOptionIndex !== -1 ? this.focusedOptionIndex : this.autoOptionFocus ? this.findFirstFocusedOptionIndex() : -1, t && Oe.focus(this.$refs.focusInput);
    },
    hide: function(t) {
      var n = this, i = function() {
        n.$emit("before-hide"), n.overlayVisible = !1, n.focusedOptionIndex = -1, n.searchValue = "", n.resetFilterOnHide && (n.filterValue = null), t && Oe.focus(n.$refs.focusInput);
      };
      setTimeout(function() {
        i();
      }, 0);
    },
    onFocus: function(t) {
      this.disabled || (this.focused = !0, this.focusedOptionIndex = this.focusedOptionIndex !== -1 ? this.focusedOptionIndex : this.overlayVisible && this.autoOptionFocus ? this.findFirstFocusedOptionIndex() : -1, this.overlayVisible && this.scrollInView(this.focusedOptionIndex), this.$emit("focus", t));
    },
    onBlur: function(t) {
      this.focused = !1, this.focusedOptionIndex = -1, this.searchValue = "", this.$emit("blur", t);
    },
    onKeyDown: function(t) {
      if (this.disabled || Oe.isAndroid()) {
        t.preventDefault();
        return;
      }
      var n = t.metaKey || t.ctrlKey;
      switch (t.code) {
        case "ArrowDown":
          this.onArrowDownKey(t);
          break;
        case "ArrowUp":
          this.onArrowUpKey(t, this.editable);
          break;
        case "ArrowLeft":
        case "ArrowRight":
          this.onArrowLeftKey(t, this.editable);
          break;
        case "Delete":
          this.onDeleteKey(t);
        case "Home":
          this.onHomeKey(t, this.editable);
          break;
        case "End":
          this.onEndKey(t, this.editable);
          break;
        case "PageDown":
          this.onPageDownKey(t);
          break;
        case "PageUp":
          this.onPageUpKey(t);
          break;
        case "Space":
          this.onSpaceKey(t, this.editable);
          break;
        case "Enter":
        case "NumpadEnter":
          this.onEnterKey(t);
          break;
        case "Escape":
          this.onEscapeKey(t);
          break;
        case "Tab":
          this.onTabKey(t);
          break;
        case "Backspace":
          this.onBackspaceKey(t, this.editable);
          break;
        case "ShiftLeft":
        case "ShiftRight":
          break;
        default:
          !n && We.isPrintableCharacter(t.key) && (!this.overlayVisible && this.show(), !this.editable && this.searchOptions(t, t.key));
          break;
      }
    },
    onEditableInput: function(t) {
      var n = t.target.value;
      this.searchValue = "";
      var i = this.searchOptions(t, n);
      !i && (this.focusedOptionIndex = -1), this.updateModel(t, n), !this.overlayVisible && We.isNotEmpty(n) && this.show();
    },
    onContainerClick: function(t) {
      this.disabled || this.loading || t.target.tagName === "INPUT" || t.target.getAttribute("data-pc-section") === "clearicon" || t.target.closest('[data-pc-section="clearicon"]') || (!this.overlay || !this.overlay.contains(t.target)) && (this.overlayVisible ? this.hide(!0) : this.show(!0));
    },
    onClearClick: function(t) {
      this.updateModel(t, null);
    },
    onFirstHiddenFocus: function(t) {
      var n = t.relatedTarget === this.$refs.focusInput ? Oe.getFirstFocusableElement(this.overlay, ':not([data-p-hidden-focusable="true"])') : this.$refs.focusInput;
      Oe.focus(n);
    },
    onLastHiddenFocus: function(t) {
      var n = t.relatedTarget === this.$refs.focusInput ? Oe.getLastFocusableElement(this.overlay, ':not([data-p-hidden-focusable="true"])') : this.$refs.focusInput;
      Oe.focus(n);
    },
    onOptionSelect: function(t, n) {
      var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0, o = this.getOptionValue(n);
      this.updateModel(t, o), i && this.hide(!0);
    },
    onOptionMouseMove: function(t, n) {
      this.focusOnHover && this.changeFocusedOptionIndex(t, n);
    },
    onFilterChange: function(t) {
      var n = t.target.value;
      this.filterValue = n, this.focusedOptionIndex = -1, this.$emit("filter", {
        originalEvent: t,
        value: n
      }), !this.virtualScrollerDisabled && this.virtualScroller.scrollToIndex(0);
    },
    onFilterKeyDown: function(t) {
      switch (t.code) {
        case "ArrowDown":
          this.onArrowDownKey(t);
          break;
        case "ArrowUp":
          this.onArrowUpKey(t, !0);
          break;
        case "ArrowLeft":
        case "ArrowRight":
          this.onArrowLeftKey(t, !0);
          break;
        case "Home":
          this.onHomeKey(t, !0);
          break;
        case "End":
          this.onEndKey(t, !0);
          break;
        case "Enter":
        case "NumpadEnter":
          this.onEnterKey(t);
          break;
        case "Escape":
          this.onEscapeKey(t);
          break;
        case "Tab":
          this.onTabKey(t, !0);
          break;
      }
    },
    onFilterBlur: function() {
      this.focusedOptionIndex = -1;
    },
    onFilterUpdated: function() {
      this.overlayVisible && this.alignOverlay();
    },
    onOverlayClick: function(t) {
      Zn.emit("overlay-click", {
        originalEvent: t,
        target: this.$el
      });
    },
    onOverlayKeyDown: function(t) {
      switch (t.code) {
        case "Escape":
          this.onEscapeKey(t);
          break;
      }
    },
    onDeleteKey: function(t) {
      this.showClear && (this.updateModel(t, null), t.preventDefault());
    },
    onArrowDownKey: function(t) {
      var n = this.focusedOptionIndex !== -1 ? this.findNextOptionIndex(this.focusedOptionIndex) : this.findFirstFocusedOptionIndex();
      this.changeFocusedOptionIndex(t, n), !this.overlayVisible && this.show(), t.preventDefault();
    },
    onArrowUpKey: function(t) {
      var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
      if (t.altKey && !n)
        this.focusedOptionIndex !== -1 && this.onOptionSelect(t, this.visibleOptions[this.focusedOptionIndex]), this.overlayVisible && this.hide(), t.preventDefault();
      else {
        var i = this.focusedOptionIndex !== -1 ? this.findPrevOptionIndex(this.focusedOptionIndex) : this.findLastFocusedOptionIndex();
        this.changeFocusedOptionIndex(t, i), !this.overlayVisible && this.show(), t.preventDefault();
      }
    },
    onArrowLeftKey: function(t) {
      var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
      n && (this.focusedOptionIndex = -1);
    },
    onHomeKey: function(t) {
      var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
      n ? (t.currentTarget.setSelectionRange(0, 0), this.focusedOptionIndex = -1) : (this.changeFocusedOptionIndex(t, this.findFirstOptionIndex()), !this.overlayVisible && this.show()), t.preventDefault();
    },
    onEndKey: function(t) {
      var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
      if (n) {
        var i = t.currentTarget, o = i.value.length;
        i.setSelectionRange(o, o), this.focusedOptionIndex = -1;
      } else
        this.changeFocusedOptionIndex(t, this.findLastOptionIndex()), !this.overlayVisible && this.show();
      t.preventDefault();
    },
    onPageUpKey: function(t) {
      this.scrollInView(0), t.preventDefault();
    },
    onPageDownKey: function(t) {
      this.scrollInView(this.visibleOptions.length - 1), t.preventDefault();
    },
    onEnterKey: function(t) {
      this.overlayVisible ? (this.focusedOptionIndex !== -1 && this.onOptionSelect(t, this.visibleOptions[this.focusedOptionIndex]), this.hide()) : this.onArrowDownKey(t), t.preventDefault();
    },
    onSpaceKey: function(t) {
      var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
      !n && this.onEnterKey(t);
    },
    onEscapeKey: function(t) {
      this.overlayVisible && this.hide(!0), t.preventDefault();
    },
    onTabKey: function(t) {
      var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
      n || (this.overlayVisible && this.hasFocusableElements() ? (Oe.focus(this.$refs.firstHiddenFocusableElementOnOverlay), t.preventDefault()) : (this.focusedOptionIndex !== -1 && this.onOptionSelect(t, this.visibleOptions[this.focusedOptionIndex]), this.overlayVisible && this.hide(this.filter)));
    },
    onBackspaceKey: function(t) {
      var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
      n && !this.overlayVisible && this.show();
    },
    onOverlayEnter: function(t) {
      qt.set("overlay", t, this.$primevue.config.zIndex.overlay), Oe.addStyles(t, {
        position: "absolute",
        top: "0",
        left: "0"
      }), this.alignOverlay(), this.scrollInView(), this.autoFilterFocus && Oe.focus(this.$refs.filterInput);
    },
    onOverlayAfterEnter: function() {
      this.bindOutsideClickListener(), this.bindScrollListener(), this.bindResizeListener(), this.$emit("show");
    },
    onOverlayLeave: function() {
      this.unbindOutsideClickListener(), this.unbindScrollListener(), this.unbindResizeListener(), this.$emit("hide"), this.overlay = null;
    },
    onOverlayAfterLeave: function(t) {
      qt.clear(t);
    },
    alignOverlay: function() {
      this.appendTo === "self" ? Oe.relativePosition(this.overlay, this.$el) : (this.overlay.style.minWidth = Oe.getOuterWidth(this.$el) + "px", Oe.absolutePosition(this.overlay, this.$el));
    },
    bindOutsideClickListener: function() {
      var t = this;
      this.outsideClickListener || (this.outsideClickListener = function(n) {
        t.overlayVisible && t.overlay && !t.$el.contains(n.target) && !t.overlay.contains(n.target) && t.hide();
      }, document.addEventListener("click", this.outsideClickListener));
    },
    unbindOutsideClickListener: function() {
      this.outsideClickListener && (document.removeEventListener("click", this.outsideClickListener), this.outsideClickListener = null);
    },
    bindScrollListener: function() {
      var t = this;
      this.scrollHandler || (this.scrollHandler = new po(this.$refs.container, function() {
        t.overlayVisible && t.hide();
      })), this.scrollHandler.bindScrollListener();
    },
    unbindScrollListener: function() {
      this.scrollHandler && this.scrollHandler.unbindScrollListener();
    },
    bindResizeListener: function() {
      var t = this;
      this.resizeListener || (this.resizeListener = function() {
        t.overlayVisible && !Oe.isTouchDevice() && t.hide();
      }, window.addEventListener("resize", this.resizeListener));
    },
    unbindResizeListener: function() {
      this.resizeListener && (window.removeEventListener("resize", this.resizeListener), this.resizeListener = null);
    },
    bindLabelClickListener: function() {
      var t = this;
      if (!this.editable && !this.labelClickListener) {
        var n = document.querySelector('label[for="'.concat(this.inputId, '"]'));
        n && Oe.isVisible(n) && (this.labelClickListener = function() {
          Oe.focus(t.$refs.focusInput);
        }, n.addEventListener("click", this.labelClickListener));
      }
    },
    unbindLabelClickListener: function() {
      if (this.labelClickListener) {
        var t = document.querySelector('label[for="'.concat(this.inputId, '"]'));
        t && Oe.isVisible(t) && t.removeEventListener("click", this.labelClickListener);
      }
    },
    hasFocusableElements: function() {
      return Oe.getFocusableElements(this.overlay, ':not([data-p-hidden-focusable="true"])').length > 0;
    },
    isOptionMatched: function(t) {
      return this.isValidOption(t) && this.getOptionLabel(t).toLocaleLowerCase(this.filterLocale).startsWith(this.searchValue.toLocaleLowerCase(this.filterLocale));
    },
    isValidOption: function(t) {
      return We.isNotEmpty(t) && !(this.isOptionDisabled(t) || this.isOptionGroup(t));
    },
    isValidSelectedOption: function(t) {
      return this.isValidOption(t) && this.isSelected(t);
    },
    isSelected: function(t) {
      return this.isValidOption(t) && We.equals(this.modelValue, this.getOptionValue(t), this.equalityKey);
    },
    findFirstOptionIndex: function() {
      var t = this;
      return this.visibleOptions.findIndex(function(n) {
        return t.isValidOption(n);
      });
    },
    findLastOptionIndex: function() {
      var t = this;
      return We.findLastIndex(this.visibleOptions, function(n) {
        return t.isValidOption(n);
      });
    },
    findNextOptionIndex: function(t) {
      var n = this, i = t < this.visibleOptions.length - 1 ? this.visibleOptions.slice(t + 1).findIndex(function(o) {
        return n.isValidOption(o);
      }) : -1;
      return i > -1 ? i + t + 1 : t;
    },
    findPrevOptionIndex: function(t) {
      var n = this, i = t > 0 ? We.findLastIndex(this.visibleOptions.slice(0, t), function(o) {
        return n.isValidOption(o);
      }) : -1;
      return i > -1 ? i : t;
    },
    findSelectedOptionIndex: function() {
      var t = this;
      return this.hasSelectedOption ? this.visibleOptions.findIndex(function(n) {
        return t.isValidSelectedOption(n);
      }) : -1;
    },
    findFirstFocusedOptionIndex: function() {
      var t = this.findSelectedOptionIndex();
      return t < 0 ? this.findFirstOptionIndex() : t;
    },
    findLastFocusedOptionIndex: function() {
      var t = this.findSelectedOptionIndex();
      return t < 0 ? this.findLastOptionIndex() : t;
    },
    searchOptions: function(t, n) {
      var i = this;
      this.searchValue = (this.searchValue || "") + n;
      var o = -1, a = !1;
      return this.focusedOptionIndex !== -1 ? (o = this.visibleOptions.slice(this.focusedOptionIndex).findIndex(function(r) {
        return i.isOptionMatched(r);
      }), o = o === -1 ? this.visibleOptions.slice(0, this.focusedOptionIndex).findIndex(function(r) {
        return i.isOptionMatched(r);
      }) : o + this.focusedOptionIndex) : o = this.visibleOptions.findIndex(function(r) {
        return i.isOptionMatched(r);
      }), o !== -1 && (a = !0), o === -1 && this.focusedOptionIndex === -1 && (o = this.findFirstFocusedOptionIndex()), o !== -1 && this.changeFocusedOptionIndex(t, o), this.searchTimeout && clearTimeout(this.searchTimeout), this.searchTimeout = setTimeout(function() {
        i.searchValue = "", i.searchTimeout = null;
      }, 500), a;
    },
    changeFocusedOptionIndex: function(t, n) {
      this.focusedOptionIndex !== n && (this.focusedOptionIndex = n, this.scrollInView(), this.selectOnFocus && this.onOptionSelect(t, this.visibleOptions[n], !1));
    },
    scrollInView: function() {
      var t = this, n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : -1, i = n !== -1 ? "".concat(this.id, "_").concat(n) : this.focusedOptionId, o = Oe.findSingle(this.list, 'li[id="'.concat(i, '"]'));
      o ? o.scrollIntoView && o.scrollIntoView({
        block: "nearest",
        inline: "start"
      }) : this.virtualScrollerDisabled || setTimeout(function() {
        t.virtualScroller && t.virtualScroller.scrollToIndex(n !== -1 ? n : t.focusedOptionIndex);
      }, 0);
    },
    autoUpdateModel: function() {
      this.selectOnFocus && this.autoOptionFocus && !this.hasSelectedOption && (this.focusedOptionIndex = this.findFirstFocusedOptionIndex(), this.onOptionSelect(null, this.visibleOptions[this.focusedOptionIndex], !1));
    },
    updateModel: function(t, n) {
      this.$emit("update:modelValue", n), this.$emit("change", {
        originalEvent: t,
        value: n
      });
    },
    flatOptions: function(t) {
      var n = this;
      return (t || []).reduce(function(i, o, a) {
        i.push({
          optionGroup: o,
          group: !0,
          index: a
        });
        var r = n.getOptionGroupChildren(o);
        return r && r.forEach(function(s) {
          return i.push(s);
        }), i;
      }, []);
    },
    overlayRef: function(t) {
      this.overlay = t;
    },
    listRef: function(t, n) {
      this.list = t, n && n(t);
    },
    virtualScrollerRef: function(t) {
      this.virtualScroller = t;
    }
  },
  computed: {
    visibleOptions: function() {
      var t = this, n = this.optionGroupLabel ? this.flatOptions(this.options) : this.options || [];
      if (this.filterValue) {
        var i = El.filter(n, this.searchFields, this.filterValue, this.filterMatchMode, this.filterLocale);
        if (this.optionGroupLabel) {
          var o = this.options || [], a = [];
          return o.forEach(function(r) {
            var s = t.getOptionGroupChildren(r), l = s.filter(function(d) {
              return i.includes(d);
            });
            l.length > 0 && a.push(Qv(Qv({}, r), {}, Sw({}, typeof t.optionGroupChildren == "string" ? t.optionGroupChildren : "items", vO(l))));
          }), this.flatOptions(a);
        }
        return i;
      }
      return n;
    },
    hasSelectedOption: function() {
      return We.isNotEmpty(this.modelValue);
    },
    label: function() {
      var t = this.findSelectedOptionIndex();
      return t !== -1 ? this.getOptionLabel(this.visibleOptions[t]) : this.placeholder || "p-emptylabel";
    },
    editableInputValue: function() {
      var t = this.findSelectedOptionIndex();
      return t !== -1 ? this.getOptionLabel(this.visibleOptions[t]) : this.modelValue || "";
    },
    equalityKey: function() {
      return this.optionValue ? null : this.dataKey;
    },
    searchFields: function() {
      return this.filterFields || [this.optionLabel];
    },
    filterResultMessageText: function() {
      return We.isNotEmpty(this.visibleOptions) ? this.filterMessageText.replaceAll("{0}", this.visibleOptions.length) : this.emptyFilterMessageText;
    },
    filterMessageText: function() {
      return this.filterMessage || this.$primevue.config.locale.searchMessage || "";
    },
    emptyFilterMessageText: function() {
      return this.emptyFilterMessage || this.$primevue.config.locale.emptySearchMessage || this.$primevue.config.locale.emptyFilterMessage || "";
    },
    emptyMessageText: function() {
      return this.emptyMessage || this.$primevue.config.locale.emptyMessage || "";
    },
    selectionMessageText: function() {
      return this.selectionMessage || this.$primevue.config.locale.selectionMessage || "";
    },
    emptySelectionMessageText: function() {
      return this.emptySelectionMessage || this.$primevue.config.locale.emptySelectionMessage || "";
    },
    selectedMessageText: function() {
      return this.hasSelectedOption ? this.selectionMessageText.replaceAll("{0}", "1") : this.emptySelectionMessageText;
    },
    focusedOptionId: function() {
      return this.focusedOptionIndex !== -1 ? "".concat(this.id, "_").concat(this.focusedOptionIndex) : null;
    },
    ariaSetSize: function() {
      var t = this;
      return this.visibleOptions.filter(function(n) {
        return !t.isOptionGroup(n);
      }).length;
    },
    virtualScrollerDisabled: function() {
      return !this.virtualScrollerOptions;
    }
  },
  directives: {
    ripple: An
  },
  components: {
    VirtualScroller: Ls,
    Portal: Yn,
    TimesIcon: Ho,
    ChevronDownIcon: Va,
    SpinnerIcon: jo,
    FilterIcon: Pm
  }
};
function Wl(e) {
  "@babel/helpers - typeof";
  return Wl = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Wl(e);
}
function ey(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    t && (i = i.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), n.push.apply(n, i);
  }
  return n;
}
function ka(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? ey(Object(n), !0).forEach(function(i) {
      CO(e, i, n[i]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : ey(Object(n)).forEach(function(i) {
      Object.defineProperty(e, i, Object.getOwnPropertyDescriptor(n, i));
    });
  }
  return e;
}
function CO(e, t, n) {
  return t = TO(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function TO(e) {
  var t = LO(e, "string");
  return Wl(t) == "symbol" ? t : String(t);
}
function LO(e, t) {
  if (Wl(e) != "object" || !e)
    return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var i = n.call(e, t || "default");
    if (Wl(i) != "object")
      return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var IO = ["id"], PO = ["id", "value", "placeholder", "tabindex", "disabled", "aria-label", "aria-labelledby", "aria-expanded", "aria-controls", "aria-activedescendant"], AO = ["id", "tabindex", "aria-label", "aria-labelledby", "aria-expanded", "aria-controls", "aria-activedescendant", "aria-disabled"], _O = ["value", "placeholder", "aria-owns", "aria-activedescendant"], MO = ["id"], OO = ["id"], BO = ["id", "aria-label", "aria-selected", "aria-disabled", "aria-setsize", "aria-posinset", "onClick", "onMousemove", "data-p-highlight", "data-p-focused", "data-p-disabled"];
function EO(e, t, n, i, o, a) {
  var r = $e("SpinnerIcon"), s = $e("VirtualScroller"), l = $e("Portal"), d = Ut("ripple");
  return E(), X("div", Ce({
    ref: "container",
    id: o.id,
    class: e.cx("root"),
    onClick: t[15] || (t[15] = function() {
      return a.onContainerClick && a.onContainerClick.apply(a, arguments);
    })
  }, e.ptm("root"), {
    "data-pc-name": "dropdown"
  }), [e.editable ? (E(), X("input", Ce({
    key: 0,
    ref: "focusInput",
    id: e.inputId,
    type: "text",
    class: [e.cx("input"), e.inputClass],
    style: e.inputStyle,
    value: a.editableInputValue,
    placeholder: e.placeholder,
    tabindex: e.disabled ? -1 : e.tabindex,
    disabled: e.disabled,
    autocomplete: "off",
    role: "combobox",
    "aria-label": e.ariaLabel,
    "aria-labelledby": e.ariaLabelledby,
    "aria-haspopup": "listbox",
    "aria-expanded": o.overlayVisible,
    "aria-controls": o.id + "_list",
    "aria-activedescendant": o.focused ? a.focusedOptionId : void 0,
    onFocus: t[0] || (t[0] = function() {
      return a.onFocus && a.onFocus.apply(a, arguments);
    }),
    onBlur: t[1] || (t[1] = function() {
      return a.onBlur && a.onBlur.apply(a, arguments);
    }),
    onKeydown: t[2] || (t[2] = function() {
      return a.onKeyDown && a.onKeyDown.apply(a, arguments);
    }),
    onInput: t[3] || (t[3] = function() {
      return a.onEditableInput && a.onEditableInput.apply(a, arguments);
    })
  }, ka(ka({}, e.inputProps), e.ptm("input"))), null, 16, PO)) : (E(), X("span", Ce({
    key: 1,
    ref: "focusInput",
    id: e.inputId,
    class: [e.cx("input"), e.inputClass],
    style: e.inputStyle,
    tabindex: e.disabled ? -1 : e.tabindex,
    role: "combobox",
    "aria-label": e.ariaLabel || (a.label === "p-emptylabel" ? void 0 : a.label),
    "aria-labelledby": e.ariaLabelledby,
    "aria-haspopup": "listbox",
    "aria-expanded": o.overlayVisible,
    "aria-controls": o.id + "_list",
    "aria-activedescendant": o.focused ? a.focusedOptionId : void 0,
    "aria-disabled": e.disabled,
    onFocus: t[4] || (t[4] = function() {
      return a.onFocus && a.onFocus.apply(a, arguments);
    }),
    onBlur: t[5] || (t[5] = function() {
      return a.onBlur && a.onBlur.apply(a, arguments);
    }),
    onKeydown: t[6] || (t[6] = function() {
      return a.onKeyDown && a.onKeyDown.apply(a, arguments);
    })
  }, ka(ka({}, e.inputProps), e.ptm("input"))), [je(e.$slots, "value", {
    value: e.modelValue,
    placeholder: e.placeholder
  }, function() {
    return [Ve(Ie(a.label === "p-emptylabel" ? " " : a.label || "empty"), 1)];
  })], 16, AO)), e.showClear && e.modelValue != null ? je(e.$slots, "clearicon", {
    key: 2,
    class: Pe(e.cx("clearIcon")),
    onClick: a.onClearClick,
    clearCallback: a.onClearClick
  }, function() {
    return [(E(), fe(tt(e.clearIcon ? "i" : "TimesIcon"), Ce({
      ref: "clearIcon",
      class: [e.cx("clearIcon"), e.clearIcon],
      onClick: a.onClearClick
    }, ka(ka({}, e.clearIconProps), e.ptm("clearIcon")), {
      "data-pc-section": "clearicon"
    }), null, 16, ["class", "onClick"]))];
  }) : te("", !0), oe("div", Ce({
    class: e.cx("trigger")
  }, e.ptm("trigger")), [e.loading ? je(e.$slots, "loadingicon", {
    key: 0,
    class: Pe(e.cx("loadingIcon"))
  }, function() {
    return [e.loadingIcon ? (E(), X("span", Ce({
      key: 0,
      class: [e.cx("loadingIcon"), "pi-spin", e.loadingIcon],
      "aria-hidden": "true"
    }, e.ptm("loadingIcon")), null, 16)) : (E(), fe(r, Ce({
      key: 1,
      class: e.cx("loadingIcon"),
      spin: "",
      "aria-hidden": "true"
    }, e.ptm("loadingIcon")), null, 16, ["class"]))];
  }) : je(e.$slots, "dropdownicon", {
    key: 1,
    class: Pe(e.cx("dropdownIcon"))
  }, function() {
    return [(E(), fe(tt(e.dropdownIcon ? "span" : "ChevronDownIcon"), Ce({
      class: [e.cx("dropdownIcon"), e.dropdownIcon],
      "aria-hidden": "true"
    }, e.ptm("dropdownIcon")), null, 16, ["class"]))];
  })], 16), ue(l, {
    appendTo: e.appendTo
  }, {
    default: Se(function() {
      return [ue(ia, Ce({
        name: "p-connected-overlay",
        onEnter: a.onOverlayEnter,
        onAfterEnter: a.onOverlayAfterEnter,
        onLeave: a.onOverlayLeave,
        onAfterLeave: a.onOverlayAfterLeave
      }, e.ptm("transition")), {
        default: Se(function() {
          return [o.overlayVisible ? (E(), X("div", Ce({
            key: 0,
            ref: a.overlayRef,
            class: [e.cx("panel"), e.panelClass],
            style: e.panelStyle,
            onClick: t[13] || (t[13] = function() {
              return a.onOverlayClick && a.onOverlayClick.apply(a, arguments);
            }),
            onKeydown: t[14] || (t[14] = function() {
              return a.onOverlayKeyDown && a.onOverlayKeyDown.apply(a, arguments);
            })
          }, ka(ka({}, e.panelProps), e.ptm("panel"))), [oe("span", Ce({
            ref: "firstHiddenFocusableElementOnOverlay",
            role: "presentation",
            "aria-hidden": "true",
            class: "p-hidden-accessible p-hidden-focusable",
            tabindex: 0,
            onFocus: t[7] || (t[7] = function() {
              return a.onFirstHiddenFocus && a.onFirstHiddenFocus.apply(a, arguments);
            })
          }, e.ptm("hiddenFirstFocusableEl"), {
            "data-p-hidden-accessible": !0,
            "data-p-hidden-focusable": !0
          }), null, 16), je(e.$slots, "header", {
            value: e.modelValue,
            options: a.visibleOptions
          }), e.filter ? (E(), X("div", Ce({
            key: 0,
            class: e.cx("header")
          }, e.ptm("header")), [oe("div", Ce({
            class: e.cx("filterContainer")
          }, e.ptm("filterContainer")), [oe("input", Ce({
            ref: "filterInput",
            type: "text",
            value: o.filterValue,
            onVnodeMounted: t[8] || (t[8] = function() {
              return a.onFilterUpdated && a.onFilterUpdated.apply(a, arguments);
            }),
            class: e.cx("filterInput"),
            placeholder: e.filterPlaceholder,
            role: "searchbox",
            autocomplete: "off",
            "aria-owns": o.id + "_list",
            "aria-activedescendant": a.focusedOptionId,
            onKeydown: t[9] || (t[9] = function() {
              return a.onFilterKeyDown && a.onFilterKeyDown.apply(a, arguments);
            }),
            onBlur: t[10] || (t[10] = function() {
              return a.onFilterBlur && a.onFilterBlur.apply(a, arguments);
            }),
            onInput: t[11] || (t[11] = function() {
              return a.onFilterChange && a.onFilterChange.apply(a, arguments);
            })
          }, ka(ka({}, e.filterInputProps), e.ptm("filterInput"))), null, 16, _O), je(e.$slots, "filtericon", {
            class: Pe(e.cx("filterIcon"))
          }, function() {
            return [(E(), fe(tt(e.filterIcon ? "span" : "FilterIcon"), Ce({
              class: [e.cx("filterIcon"), e.filterIcon]
            }, e.ptm("filterIcon")), null, 16, ["class"]))];
          })], 16), oe("span", Ce({
            role: "status",
            "aria-live": "polite",
            class: "p-hidden-accessible"
          }, e.ptm("hiddenFilterResult"), {
            "data-p-hidden-accessible": !0
          }), Ie(a.filterResultMessageText), 17)], 16)) : te("", !0), oe("div", Ce({
            class: e.cx("wrapper"),
            style: {
              "max-height": a.virtualScrollerDisabled ? e.scrollHeight : ""
            }
          }, e.ptm("wrapper")), [ue(s, Ce({
            ref: a.virtualScrollerRef
          }, e.virtualScrollerOptions, {
            items: a.visibleOptions,
            style: {
              height: e.scrollHeight
            },
            tabindex: -1,
            disabled: a.virtualScrollerDisabled,
            pt: e.ptm("virtualScroller")
          }), Qt({
            content: Se(function(y) {
              var u = y.styleClass, m = y.contentRef, h = y.items, c = y.getItemOptions, g = y.contentStyle, v = y.itemSize;
              return [oe("ul", Ce({
                ref: function(f) {
                  return a.listRef(f, m);
                },
                id: o.id + "_list",
                class: [e.cx("list"), u],
                style: g,
                role: "listbox"
              }, e.ptm("list")), [(E(!0), X(Re, null, Ge(h, function(P, f) {
                return E(), X(Re, {
                  key: a.getOptionRenderKey(P, a.getOptionIndex(f, c))
                }, [a.isOptionGroup(P) ? (E(), X("li", Ce({
                  key: 0,
                  id: o.id + "_" + a.getOptionIndex(f, c),
                  style: {
                    height: v ? v + "px" : void 0
                  },
                  class: e.cx("itemGroup"),
                  role: "option"
                }, e.ptm("itemGroup")), [je(e.$slots, "optiongroup", {
                  option: P.optionGroup,
                  index: a.getOptionIndex(f, c)
                }, function() {
                  return [Ve(Ie(a.getOptionGroupLabel(P.optionGroup)), 1)];
                })], 16, OO)) : rt((E(), X("li", Ce({
                  key: 1,
                  id: o.id + "_" + a.getOptionIndex(f, c),
                  class: e.cx("item", {
                    option: P,
                    focusedOption: a.getOptionIndex(f, c)
                  }),
                  style: {
                    height: v ? v + "px" : void 0
                  },
                  role: "option",
                  "aria-label": a.getOptionLabel(P),
                  "aria-selected": a.isSelected(P),
                  "aria-disabled": a.isOptionDisabled(P),
                  "aria-setsize": a.ariaSetSize,
                  "aria-posinset": a.getAriaPosInset(a.getOptionIndex(f, c)),
                  onClick: function(w) {
                    return a.onOptionSelect(w, P);
                  },
                  onMousemove: function(w) {
                    return a.onOptionMouseMove(w, a.getOptionIndex(f, c));
                  },
                  "data-p-highlight": a.isSelected(P),
                  "data-p-focused": o.focusedOptionIndex === a.getOptionIndex(f, c),
                  "data-p-disabled": a.isOptionDisabled(P)
                }, a.getPTItemOptions(P, c, f, "item")), [je(e.$slots, "option", {
                  option: P,
                  index: a.getOptionIndex(f, c)
                }, function() {
                  return [Ve(Ie(a.getOptionLabel(P)), 1)];
                })], 16, BO)), [[d]])], 64);
              }), 128)), o.filterValue && (!h || h && h.length === 0) ? (E(), X("li", Ce({
                key: 0,
                class: e.cx("emptyMessage"),
                role: "option"
              }, e.ptm("emptyMessage"), {
                "data-p-hidden-accessible": !0
              }), [je(e.$slots, "emptyfilter", {}, function() {
                return [Ve(Ie(a.emptyFilterMessageText), 1)];
              })], 16)) : !e.options || e.options && e.options.length === 0 ? (E(), X("li", Ce({
                key: 1,
                class: e.cx("emptyMessage"),
                role: "option"
              }, e.ptm("emptyMessage"), {
                "data-p-hidden-accessible": !0
              }), [je(e.$slots, "empty", {}, function() {
                return [Ve(Ie(a.emptyMessageText), 1)];
              })], 16)) : te("", !0)], 16, MO)];
            }),
            _: 2
          }, [e.$slots.loader ? {
            name: "loader",
            fn: Se(function(y) {
              var u = y.options;
              return [je(e.$slots, "loader", {
                options: u
              })];
            }),
            key: "0"
          } : void 0]), 1040, ["items", "style", "disabled", "pt"])], 16), je(e.$slots, "footer", {
            value: e.modelValue,
            options: a.visibleOptions
          }), !e.options || e.options && e.options.length === 0 ? (E(), X("span", Ce({
            key: 1,
            role: "status",
            "aria-live": "polite",
            class: "p-hidden-accessible"
          }, e.ptm("hiddenEmptyMessage"), {
            "data-p-hidden-accessible": !0
          }), Ie(a.emptyMessageText), 17)) : te("", !0), oe("span", Ce({
            role: "status",
            "aria-live": "polite",
            class: "p-hidden-accessible"
          }, e.ptm("hiddenSelectedMessage"), {
            "data-p-hidden-accessible": !0
          }), Ie(a.selectedMessageText), 17), oe("span", Ce({
            ref: "lastHiddenFocusableElementOnOverlay",
            role: "presentation",
            "aria-hidden": "true",
            class: "p-hidden-accessible p-hidden-focusable",
            tabindex: 0,
            onFocus: t[12] || (t[12] = function() {
              return a.onLastHiddenFocus && a.onLastHiddenFocus.apply(a, arguments);
            })
          }, e.ptm("hiddenLastFocusableEl"), {
            "data-p-hidden-accessible": !0,
            "data-p-hidden-focusable": !0
          }), null, 16)], 16)) : te("", !0)];
        }),
        _: 3
      }, 16, ["onEnter", "onAfterEnter", "onLeave", "onAfterLeave"])];
    }),
    _: 3
  }, 8, ["appendTo"])], 16, IO);
}
Ga.render = EO;
var DO = `
@layer primevue {
    .p-badge {
        display: inline-block;
        border-radius: 10px;
        text-align: center;
        padding: 0 .5rem;
    }

    .p-overlay-badge {
        position: relative;
    }

    .p-overlay-badge .p-badge {
        position: absolute;
        top: 0;
        right: 0;
        transform: translate(50%,-50%);
        transform-origin: 100% 0;
        margin: 0;
    }

    .p-badge-dot {
        width: .5rem;
        min-width: .5rem;
        height: .5rem;
        border-radius: 50%;
        padding: 0;
    }

    .p-badge-no-gutter {
        padding: 0;
        border-radius: 50%;
    }
}
`, RO = {
  root: function(t) {
    var n = t.props, i = t.instance;
    return ["p-badge p-component", {
      "p-badge-no-gutter": We.isNotEmpty(n.value) && String(n.value).length === 1,
      "p-badge-dot": We.isEmpty(n.value) && !i.$slots.default,
      "p-badge-lg": n.size === "large",
      "p-badge-xl": n.size === "xlarge",
      "p-badge-info": n.severity === "info",
      "p-badge-success": n.severity === "success",
      "p-badge-warning": n.severity === "warning",
      "p-badge-danger": n.severity === "danger"
    }];
  }
}, NO = Wt.extend({
  name: "badge",
  css: DO,
  classes: RO
}), $O = {
  name: "BaseBadge",
  extends: wt,
  props: {
    value: {
      type: [String, Number],
      default: null
    },
    severity: {
      type: String,
      default: null
    },
    size: {
      type: String,
      default: null
    }
  },
  style: NO,
  provide: function() {
    return {
      $parentInstance: this
    };
  }
}, Cw = {
  name: "Badge",
  extends: $O
};
function FO(e, t, n, i, o, a) {
  return E(), X("span", Ce({
    class: e.cx("root")
  }, e.ptm("root"), {
    "data-pc-name": "badge"
  }), [je(e.$slots, "default", {}, function() {
    return [Ve(Ie(e.value), 1)];
  })], 16);
}
Cw.render = FO;
function Yl(e) {
  "@babel/helpers - typeof";
  return Yl = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Yl(e);
}
function vo(e, t, n) {
  return t = jO(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function jO(e) {
  var t = HO(e, "string");
  return Yl(t) == "symbol" ? t : String(t);
}
function HO(e, t) {
  if (Yl(e) != "object" || !e)
    return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var i = n.call(e, t || "default");
    if (Yl(i) != "object")
      return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var zO = {
  root: function(t) {
    var n = t.instance, i = t.props;
    return ["p-button p-component", vo(vo(vo(vo(vo(vo(vo(vo({
      "p-button-icon-only": n.hasIcon && !i.label && !i.badge,
      "p-button-vertical": (i.iconPos === "top" || i.iconPos === "bottom") && i.label,
      "p-disabled": n.$attrs.disabled || n.$attrs.disabled === "" || i.loading,
      "p-button-loading": i.loading,
      "p-button-loading-label-only": i.loading && !n.hasIcon && i.label,
      "p-button-link": i.link
    }, "p-button-".concat(i.severity), i.severity), "p-button-raised", i.raised), "p-button-rounded", i.rounded), "p-button-text", i.text), "p-button-outlined", i.outlined), "p-button-sm", i.size === "small"), "p-button-lg", i.size === "large"), "p-button-plain", i.plain)];
  },
  loadingIcon: "p-button-loading-icon pi-spin",
  icon: function(t) {
    var n = t.props;
    return ["p-button-icon", {
      "p-button-icon-left": n.iconPos === "left" && n.label,
      "p-button-icon-right": n.iconPos === "right" && n.label,
      "p-button-icon-top": n.iconPos === "top" && n.label,
      "p-button-icon-bottom": n.iconPos === "bottom" && n.label
    }];
  },
  label: "p-button-label"
}, VO = Wt.extend({
  name: "button",
  classes: zO
}), GO = {
  name: "BaseButton",
  extends: wt,
  props: {
    label: {
      type: String,
      default: null
    },
    icon: {
      type: String,
      default: null
    },
    iconPos: {
      type: String,
      default: "left"
    },
    iconClass: {
      type: String,
      default: null
    },
    badge: {
      type: String,
      default: null
    },
    badgeClass: {
      type: String,
      default: null
    },
    badgeSeverity: {
      type: String,
      default: null
    },
    loading: {
      type: Boolean,
      default: !1
    },
    loadingIcon: {
      type: String,
      default: void 0
    },
    link: {
      type: Boolean,
      default: !1
    },
    severity: {
      type: String,
      default: null
    },
    raised: {
      type: Boolean,
      default: !1
    },
    rounded: {
      type: Boolean,
      default: !1
    },
    text: {
      type: Boolean,
      default: !1
    },
    outlined: {
      type: Boolean,
      default: !1
    },
    size: {
      type: String,
      default: null
    },
    plain: {
      type: Boolean,
      default: !1
    }
  },
  style: VO,
  provide: function() {
    return {
      $parentInstance: this
    };
  }
}, ki = {
  name: "Button",
  extends: GO,
  methods: {
    getPTOptions: function(t) {
      return this.ptm(t, {
        context: {
          disabled: this.disabled
        }
      });
    }
  },
  computed: {
    disabled: function() {
      return this.$attrs.disabled || this.$attrs.disabled === "" || this.loading;
    },
    defaultAriaLabel: function() {
      return this.label ? this.label + (this.badge ? " " + this.badge : "") : this.$attrs.ariaLabel;
    },
    hasIcon: function() {
      return this.icon || this.$slots.icon;
    }
  },
  components: {
    SpinnerIcon: jo,
    Badge: Cw
  },
  directives: {
    ripple: An
  }
}, UO = ["aria-label", "disabled", "data-pc-severity"];
function WO(e, t, n, i, o, a) {
  var r = $e("SpinnerIcon"), s = $e("Badge"), l = Ut("ripple");
  return rt((E(), X("button", Ce({
    class: e.cx("root"),
    type: "button",
    "aria-label": a.defaultAriaLabel,
    disabled: a.disabled
  }, a.getPTOptions("root"), {
    "data-pc-name": "button",
    "data-pc-severity": e.severity
  }), [je(e.$slots, "default", {}, function() {
    return [e.loading ? je(e.$slots, "loadingicon", {
      key: 0,
      class: Pe([e.cx("loadingIcon"), e.cx("icon")])
    }, function() {
      return [e.loadingIcon ? (E(), X("span", Ce({
        key: 0,
        class: [e.cx("loadingIcon"), e.cx("icon"), e.loadingIcon]
      }, e.ptm("loadingIcon")), null, 16)) : (E(), fe(r, Ce({
        key: 1,
        class: [e.cx("loadingIcon"), e.cx("icon")],
        spin: ""
      }, e.ptm("loadingIcon")), null, 16, ["class"]))];
    }) : je(e.$slots, "icon", {
      key: 1,
      class: Pe([e.cx("icon")])
    }, function() {
      return [e.icon ? (E(), X("span", Ce({
        key: 0,
        class: [e.cx("icon"), e.icon, e.iconClass]
      }, e.ptm("icon")), null, 16)) : te("", !0)];
    }), oe("span", Ce({
      class: e.cx("label")
    }, e.ptm("label")), Ie(e.label || " "), 17), e.badge ? (E(), fe(s, Ce({
      key: 2,
      value: e.badge,
      class: e.badgeClass,
      severity: e.badgeSeverity,
      unstyled: e.unstyled
    }, e.ptm("badge")), null, 16, ["value", "class", "severity", "unstyled"])) : te("", !0)];
  })], 16, UO)), [[l]]);
}
ki.render = WO;
var Tw = {
  name: "AngleDownIcon",
  extends: Yt
}, YO = /* @__PURE__ */ oe("path", {
  d: "M3.58659 4.5007C3.68513 4.50023 3.78277 4.51945 3.87379 4.55723C3.9648 4.59501 4.04735 4.65058 4.11659 4.7207L7.11659 7.7207L10.1166 4.7207C10.2619 4.65055 10.4259 4.62911 10.5843 4.65956C10.7427 4.69002 10.8871 4.77074 10.996 4.88976C11.1049 5.00877 11.1726 5.15973 11.1889 5.32022C11.2052 5.48072 11.1693 5.6422 11.0866 5.7807L7.58659 9.2807C7.44597 9.42115 7.25534 9.50004 7.05659 9.50004C6.85784 9.50004 6.66722 9.42115 6.52659 9.2807L3.02659 5.7807C2.88614 5.64007 2.80725 5.44945 2.80725 5.2507C2.80725 5.05195 2.88614 4.86132 3.02659 4.7207C3.09932 4.64685 3.18675 4.58911 3.28322 4.55121C3.37969 4.51331 3.48305 4.4961 3.58659 4.5007Z",
  fill: "currentColor"
}, null, -1), qO = [YO];
function KO(e, t, n, i, o, a) {
  return E(), X("svg", Ce({
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.pti()), qO, 16);
}
Tw.render = KO;
var Lw = {
  name: "AngleUpIcon",
  extends: Yt
}, XO = /* @__PURE__ */ oe("path", {
  d: "M10.4134 9.49931C10.3148 9.49977 10.2172 9.48055 10.1262 9.44278C10.0352 9.405 9.95263 9.34942 9.88338 9.27931L6.88338 6.27931L3.88338 9.27931C3.73811 9.34946 3.57409 9.3709 3.41567 9.34044C3.25724 9.30999 3.11286 9.22926 3.00395 9.11025C2.89504 8.99124 2.82741 8.84028 2.8111 8.67978C2.79478 8.51928 2.83065 8.35781 2.91338 8.21931L6.41338 4.71931C6.55401 4.57886 6.74463 4.49997 6.94338 4.49997C7.14213 4.49997 7.33276 4.57886 7.47338 4.71931L10.9734 8.21931C11.1138 8.35994 11.1927 8.55056 11.1927 8.74931C11.1927 8.94806 11.1138 9.13868 10.9734 9.27931C10.9007 9.35315 10.8132 9.41089 10.7168 9.44879C10.6203 9.48669 10.5169 9.5039 10.4134 9.49931Z",
  fill: "currentColor"
}, null, -1), ZO = [XO];
function JO(e, t, n, i, o, a) {
  return E(), X("svg", Ce({
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.pti()), ZO, 16);
}
Lw.render = JO;
var QO = {
  root: function(t) {
    var n = t.instance, i = t.props;
    return ["p-inputtext p-component", {
      "p-filled": n.filled,
      "p-inputtext-sm": i.size === "small",
      "p-inputtext-lg": i.size === "large"
    }];
  }
}, eB = Wt.extend({
  name: "inputtext",
  classes: QO
}), tB = {
  name: "BaseInputText",
  extends: wt,
  props: {
    modelValue: null,
    size: {
      type: String,
      default: null
    }
  },
  style: eB,
  provide: function() {
    return {
      $parentInstance: this
    };
  }
}, ls = {
  name: "InputText",
  extends: tB,
  emits: ["update:modelValue"],
  methods: {
    getPTOptions: function(t) {
      return this.ptm(t, {
        context: {
          filled: this.filled,
          disabled: this.$attrs.disabled || this.$attrs.disabled === ""
        }
      });
    },
    onInput: function(t) {
      this.$emit("update:modelValue", t.target.value);
    }
  },
  computed: {
    filled: function() {
      return this.modelValue != null && this.modelValue.toString().length > 0;
    }
  }
}, nB = ["value"];
function iB(e, t, n, i, o, a) {
  return E(), X("input", Ce({
    class: e.cx("root"),
    value: e.modelValue,
    onInput: t[0] || (t[0] = function() {
      return a.onInput && a.onInput.apply(a, arguments);
    })
  }, a.getPTOptions("root"), {
    "data-pc-name": "inputtext"
  }), null, 16, nB);
}
ls.render = iB;
var aB = `
@layer primevue {
    .p-inputnumber {
        display: inline-flex;
    }

    .p-inputnumber-button {
        display: flex;
        align-items: center;
        justify-content: center;
        flex: 0 0 auto;
    }

    .p-inputnumber-buttons-stacked .p-button.p-inputnumber-button .p-button-label,
    .p-inputnumber-buttons-horizontal .p-button.p-inputnumber-button .p-button-label {
        display: none;
    }

    .p-inputnumber-buttons-stacked .p-button.p-inputnumber-button-up {
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
        border-bottom-right-radius: 0;
        padding: 0;
    }

    .p-inputnumber-buttons-stacked .p-inputnumber-input {
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
    }

    .p-inputnumber-buttons-stacked .p-button.p-inputnumber-button-down {
        border-top-left-radius: 0;
        border-top-right-radius: 0;
        border-bottom-left-radius: 0;
        padding: 0;
    }

    .p-inputnumber-buttons-stacked .p-inputnumber-button-group {
        display: flex;
        flex-direction: column;
    }

    .p-inputnumber-buttons-stacked .p-inputnumber-button-group .p-button.p-inputnumber-button {
        flex: 1 1 auto;
    }

    .p-inputnumber-buttons-horizontal .p-button.p-inputnumber-button-up {
        order: 3;
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
    }

    .p-inputnumber-buttons-horizontal .p-inputnumber-input {
        order: 2;
        border-radius: 0;
    }

    .p-inputnumber-buttons-horizontal .p-button.p-inputnumber-button-down {
        order: 1;
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
    }

    .p-inputnumber-buttons-vertical {
        flex-direction: column;
    }

    .p-inputnumber-buttons-vertical .p-button.p-inputnumber-button-up {
        order: 1;
        border-bottom-left-radius: 0;
        border-bottom-right-radius: 0;
        width: 100%;
    }

    .p-inputnumber-buttons-vertical .p-inputnumber-input {
        order: 2;
        border-radius: 0;
        text-align: center;
    }

    .p-inputnumber-buttons-vertical .p-button.p-inputnumber-button-down {
        order: 3;
        border-top-left-radius: 0;
        border-top-right-radius: 0;
        width: 100%;
    }

    .p-inputnumber-input {
        flex: 1 1 auto;
    }

    .p-fluid .p-inputnumber {
        width: 100%;
    }

    .p-fluid .p-inputnumber .p-inputnumber-input {
        width: 1%;
    }

    .p-fluid .p-inputnumber-buttons-vertical .p-inputnumber-input {
        width: 100%;
    }
}
`, oB = {
  root: function(t) {
    var n = t.instance, i = t.props;
    return ["p-inputnumber p-component p-inputwrapper", {
      "p-inputwrapper-filled": n.filled || i.allowEmpty === !1,
      "p-inputwrapper-focus": n.focused,
      "p-inputnumber-buttons-stacked": i.showButtons && i.buttonLayout === "stacked",
      "p-inputnumber-buttons-horizontal": i.showButtons && i.buttonLayout === "horizontal",
      "p-inputnumber-buttons-vertical": i.showButtons && i.buttonLayout === "vertical"
    }];
  },
  input: "p-inputnumber-input",
  buttonGroup: "p-inputnumber-button-group",
  incrementButton: function(t) {
    var n = t.instance, i = t.props;
    return ["p-inputnumber-button p-inputnumber-button-up", {
      "p-disabled": i.showButtons && i.max !== null && n.maxBoundry()
    }];
  },
  decrementButton: function(t) {
    var n = t.instance, i = t.props;
    return ["p-inputnumber-button p-inputnumber-button-down", {
      "p-disabled": i.showButtons && i.min !== null && n.minBoundry()
    }];
  }
}, rB = Wt.extend({
  name: "inputnumber",
  css: aB,
  classes: oB
}), sB = {
  name: "BaseInputNumber",
  extends: wt,
  props: {
    modelValue: {
      type: Number,
      default: null
    },
    format: {
      type: Boolean,
      default: !0
    },
    showButtons: {
      type: Boolean,
      default: !1
    },
    buttonLayout: {
      type: String,
      default: "stacked"
    },
    incrementButtonClass: {
      type: String,
      default: null
    },
    decrementButtonClass: {
      type: String,
      default: null
    },
    incrementButtonIcon: {
      type: String,
      default: void 0
    },
    decrementButtonIcon: {
      type: String,
      default: void 0
    },
    locale: {
      type: String,
      default: void 0
    },
    localeMatcher: {
      type: String,
      default: void 0
    },
    mode: {
      type: String,
      default: "decimal"
    },
    prefix: {
      type: String,
      default: null
    },
    suffix: {
      type: String,
      default: null
    },
    currency: {
      type: String,
      default: void 0
    },
    currencyDisplay: {
      type: String,
      default: void 0
    },
    useGrouping: {
      type: Boolean,
      default: !0
    },
    minFractionDigits: {
      type: Number,
      default: void 0
    },
    maxFractionDigits: {
      type: Number,
      default: void 0
    },
    roundingMode: {
      type: String,
      default: "halfExpand",
      validator: function(t) {
        return ["ceil", "floor", "expand", "trunc", "halfCeil", "halfFloor", "halfExpand", "halfTrunc", "halfEven"].includes(t);
      }
    },
    min: {
      type: Number,
      default: null
    },
    max: {
      type: Number,
      default: null
    },
    step: {
      type: Number,
      default: 1
    },
    allowEmpty: {
      type: Boolean,
      default: !0
    },
    highlightOnFocus: {
      type: Boolean,
      default: !1
    },
    readonly: {
      type: Boolean,
      default: !1
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    placeholder: {
      type: String,
      default: null
    },
    inputId: {
      type: String,
      default: null
    },
    inputClass: {
      type: [String, Object],
      default: null
    },
    inputStyle: {
      type: Object,
      default: null
    },
    inputProps: {
      type: null,
      default: null
    },
    incrementButtonProps: {
      type: null,
      default: null
    },
    decrementButtonProps: {
      type: null,
      default: null
    },
    ariaLabelledby: {
      type: String,
      default: null
    },
    ariaLabel: {
      type: String,
      default: null
    }
  },
  style: rB,
  provide: function() {
    return {
      $parentInstance: this
    };
  }
};
function ql(e) {
  "@babel/helpers - typeof";
  return ql = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, ql(e);
}
function ty(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    t && (i = i.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), n.push.apply(n, i);
  }
  return n;
}
function ny(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? ty(Object(n), !0).forEach(function(i) {
      lB(e, i, n[i]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : ty(Object(n)).forEach(function(i) {
      Object.defineProperty(e, i, Object.getOwnPropertyDescriptor(n, i));
    });
  }
  return e;
}
function lB(e, t, n) {
  return t = cB(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function cB(e) {
  var t = dB(e, "string");
  return ql(t) == "symbol" ? t : String(t);
}
function dB(e, t) {
  if (ql(e) != "object" || !e)
    return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var i = n.call(e, t || "default");
    if (ql(i) != "object")
      return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function uB(e) {
  return mB(e) || fB(e) || pB(e) || hB();
}
function hB() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function pB(e, t) {
  if (e) {
    if (typeof e == "string")
      return qp(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set")
      return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return qp(e, t);
  }
}
function fB(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null)
    return Array.from(e);
}
function mB(e) {
  if (Array.isArray(e))
    return qp(e);
}
function qp(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, i = new Array(t); n < t; n++)
    i[n] = e[n];
  return i;
}
var Am = {
  name: "InputNumber",
  extends: sB,
  emits: ["update:modelValue", "input", "focus", "blur"],
  numberFormat: null,
  _numeral: null,
  _decimal: null,
  _group: null,
  _minusSign: null,
  _currency: null,
  _suffix: null,
  _prefix: null,
  _index: null,
  groupChar: "",
  isSpecialChar: null,
  prefixChar: null,
  suffixChar: null,
  timer: null,
  data: function() {
    return {
      d_modelValue: this.modelValue,
      focused: !1
    };
  },
  watch: {
    modelValue: function(t) {
      this.d_modelValue = t;
    },
    locale: function(t, n) {
      this.updateConstructParser(t, n);
    },
    localeMatcher: function(t, n) {
      this.updateConstructParser(t, n);
    },
    mode: function(t, n) {
      this.updateConstructParser(t, n);
    },
    currency: function(t, n) {
      this.updateConstructParser(t, n);
    },
    currencyDisplay: function(t, n) {
      this.updateConstructParser(t, n);
    },
    useGrouping: function(t, n) {
      this.updateConstructParser(t, n);
    },
    minFractionDigits: function(t, n) {
      this.updateConstructParser(t, n);
    },
    maxFractionDigits: function(t, n) {
      this.updateConstructParser(t, n);
    },
    suffix: function(t, n) {
      this.updateConstructParser(t, n);
    },
    prefix: function(t, n) {
      this.updateConstructParser(t, n);
    }
  },
  created: function() {
    this.constructParser();
  },
  methods: {
    getOptions: function() {
      return {
        localeMatcher: this.localeMatcher,
        style: this.mode,
        currency: this.currency,
        currencyDisplay: this.currencyDisplay,
        useGrouping: this.useGrouping,
        minimumFractionDigits: this.minFractionDigits,
        maximumFractionDigits: this.maxFractionDigits,
        roundingMode: this.roundingMode
      };
    },
    constructParser: function() {
      this.numberFormat = new Intl.NumberFormat(this.locale, this.getOptions());
      var t = uB(new Intl.NumberFormat(this.locale, {
        useGrouping: !1
      }).format(9876543210)).reverse(), n = new Map(t.map(function(i, o) {
        return [i, o];
      }));
      this._numeral = new RegExp("[".concat(t.join(""), "]"), "g"), this._group = this.getGroupingExpression(), this._minusSign = this.getMinusSignExpression(), this._currency = this.getCurrencyExpression(), this._decimal = this.getDecimalExpression(), this._suffix = this.getSuffixExpression(), this._prefix = this.getPrefixExpression(), this._index = function(i) {
        return n.get(i);
      };
    },
    updateConstructParser: function(t, n) {
      t !== n && this.constructParser();
    },
    escapeRegExp: function(t) {
      return t.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&");
    },
    getDecimalExpression: function() {
      var t = new Intl.NumberFormat(this.locale, ny(ny({}, this.getOptions()), {}, {
        useGrouping: !1
      }));
      return new RegExp("[".concat(t.format(1.1).replace(this._currency, "").trim().replace(this._numeral, ""), "]"), "g");
    },
    getGroupingExpression: function() {
      var t = new Intl.NumberFormat(this.locale, {
        useGrouping: !0
      });
      return this.groupChar = t.format(1e6).trim().replace(this._numeral, "").charAt(0), new RegExp("[".concat(this.groupChar, "]"), "g");
    },
    getMinusSignExpression: function() {
      var t = new Intl.NumberFormat(this.locale, {
        useGrouping: !1
      });
      return new RegExp("[".concat(t.format(-1).trim().replace(this._numeral, ""), "]"), "g");
    },
    getCurrencyExpression: function() {
      if (this.currency) {
        var t = new Intl.NumberFormat(this.locale, {
          style: "currency",
          currency: this.currency,
          currencyDisplay: this.currencyDisplay,
          minimumFractionDigits: 0,
          maximumFractionDigits: 0,
          roundingMode: this.roundingMode
        });
        return new RegExp("[".concat(t.format(1).replace(/\s/g, "").replace(this._numeral, "").replace(this._group, ""), "]"), "g");
      }
      return new RegExp("[]", "g");
    },
    getPrefixExpression: function() {
      if (this.prefix)
        this.prefixChar = this.prefix;
      else {
        var t = new Intl.NumberFormat(this.locale, {
          style: this.mode,
          currency: this.currency,
          currencyDisplay: this.currencyDisplay
        });
        this.prefixChar = t.format(1).split("1")[0];
      }
      return new RegExp("".concat(this.escapeRegExp(this.prefixChar || "")), "g");
    },
    getSuffixExpression: function() {
      if (this.suffix)
        this.suffixChar = this.suffix;
      else {
        var t = new Intl.NumberFormat(this.locale, {
          style: this.mode,
          currency: this.currency,
          currencyDisplay: this.currencyDisplay,
          minimumFractionDigits: 0,
          maximumFractionDigits: 0,
          roundingMode: this.roundingMode
        });
        this.suffixChar = t.format(1).split("1")[1];
      }
      return new RegExp("".concat(this.escapeRegExp(this.suffixChar || "")), "g");
    },
    formatValue: function(t) {
      if (t != null) {
        if (t === "-")
          return t;
        if (this.format) {
          var n = new Intl.NumberFormat(this.locale, this.getOptions()), i = n.format(t);
          return this.prefix && (i = this.prefix + i), this.suffix && (i = i + this.suffix), i;
        }
        return t.toString();
      }
      return "";
    },
    parseValue: function(t) {
      var n = t.replace(this._suffix, "").replace(this._prefix, "").trim().replace(/\s/g, "").replace(this._currency, "").replace(this._group, "").replace(this._minusSign, "-").replace(this._decimal, ".").replace(this._numeral, this._index);
      if (n) {
        if (n === "-")
          return n;
        var i = +n;
        return isNaN(i) ? null : i;
      }
      return null;
    },
    repeat: function(t, n, i) {
      var o = this;
      if (!this.readonly) {
        var a = n || 500;
        this.clearTimer(), this.timer = setTimeout(function() {
          o.repeat(t, 40, i);
        }, a), this.spin(t, i);
      }
    },
    spin: function(t, n) {
      if (this.$refs.input) {
        var i = this.step * n, o = this.parseValue(this.$refs.input.$el.value) || 0, a = this.validateValue(o + i);
        this.updateInput(a, null, "spin"), this.updateModel(t, a), this.handleOnInput(t, o, a);
      }
    },
    onUpButtonMouseDown: function(t) {
      this.disabled || (this.$refs.input.$el.focus(), this.repeat(t, null, 1), t.preventDefault());
    },
    onUpButtonMouseUp: function() {
      this.disabled || this.clearTimer();
    },
    onUpButtonMouseLeave: function() {
      this.disabled || this.clearTimer();
    },
    onUpButtonKeyUp: function() {
      this.disabled || this.clearTimer();
    },
    onUpButtonKeyDown: function(t) {
      (t.keyCode === 32 || t.keyCode === 13) && this.repeat(t, null, 1);
    },
    onDownButtonMouseDown: function(t) {
      this.disabled || (this.$refs.input.$el.focus(), this.repeat(t, null, -1), t.preventDefault());
    },
    onDownButtonMouseUp: function() {
      this.disabled || this.clearTimer();
    },
    onDownButtonMouseLeave: function() {
      this.disabled || this.clearTimer();
    },
    onDownButtonKeyUp: function() {
      this.disabled || this.clearTimer();
    },
    onDownButtonKeyDown: function(t) {
      (t.keyCode === 32 || t.keyCode === 13) && this.repeat(t, null, -1);
    },
    onUserInput: function() {
      this.isSpecialChar && (this.$refs.input.$el.value = this.lastValue), this.isSpecialChar = !1;
    },
    onInputKeyDown: function(t) {
      if (!this.readonly) {
        if (this.lastValue = t.target.value, t.shiftKey || t.altKey) {
          this.isSpecialChar = !0;
          return;
        }
        var n = t.target.selectionStart, i = t.target.selectionEnd, o = t.target.value, a = null;
        switch (t.altKey && t.preventDefault(), t.code) {
          case "ArrowUp":
            this.spin(t, 1), t.preventDefault();
            break;
          case "ArrowDown":
            this.spin(t, -1), t.preventDefault();
            break;
          case "ArrowLeft":
            this.isNumeralChar(o.charAt(n - 1)) || t.preventDefault();
            break;
          case "ArrowRight":
            this.isNumeralChar(o.charAt(n)) || t.preventDefault();
            break;
          case "Tab":
          case "Enter":
          case "NumpadEnter":
            a = this.validateValue(this.parseValue(o)), this.$refs.input.$el.value = this.formatValue(a), this.$refs.input.$el.setAttribute("aria-valuenow", a), this.updateModel(t, a);
            break;
          case "Backspace": {
            if (t.preventDefault(), n === i) {
              var r = o.charAt(n - 1), s = this.getDecimalCharIndexes(o), l = s.decimalCharIndex, d = s.decimalCharIndexWithoutPrefix;
              if (this.isNumeralChar(r)) {
                var y = this.getDecimalLength(o);
                if (this._group.test(r))
                  this._group.lastIndex = 0, a = o.slice(0, n - 2) + o.slice(n - 1);
                else if (this._decimal.test(r))
                  this._decimal.lastIndex = 0, y ? this.$refs.input.$el.setSelectionRange(n - 1, n - 1) : a = o.slice(0, n - 1) + o.slice(n);
                else if (l > 0 && n > l) {
                  var u = this.isDecimalMode() && (this.minFractionDigits || 0) < y ? "" : "0";
                  a = o.slice(0, n - 1) + u + o.slice(n);
                } else
                  d === 1 ? (a = o.slice(0, n - 1) + "0" + o.slice(n), a = this.parseValue(a) > 0 ? a : "") : a = o.slice(0, n - 1) + o.slice(n);
              }
              this.updateValue(t, a, null, "delete-single");
            } else
              a = this.deleteRange(o, n, i), this.updateValue(t, a, null, "delete-range");
            break;
          }
          case "Delete":
            if (t.preventDefault(), n === i) {
              var m = o.charAt(n), h = this.getDecimalCharIndexes(o), c = h.decimalCharIndex, g = h.decimalCharIndexWithoutPrefix;
              if (this.isNumeralChar(m)) {
                var v = this.getDecimalLength(o);
                if (this._group.test(m))
                  this._group.lastIndex = 0, a = o.slice(0, n) + o.slice(n + 2);
                else if (this._decimal.test(m))
                  this._decimal.lastIndex = 0, v ? this.$refs.input.$el.setSelectionRange(n + 1, n + 1) : a = o.slice(0, n) + o.slice(n + 1);
                else if (c > 0 && n > c) {
                  var P = this.isDecimalMode() && (this.minFractionDigits || 0) < v ? "" : "0";
                  a = o.slice(0, n) + P + o.slice(n + 1);
                } else
                  g === 1 ? (a = o.slice(0, n) + "0" + o.slice(n + 1), a = this.parseValue(a) > 0 ? a : "") : a = o.slice(0, n) + o.slice(n + 1);
              }
              this.updateValue(t, a, null, "delete-back-single");
            } else
              a = this.deleteRange(o, n, i), this.updateValue(t, a, null, "delete-range");
            break;
          case "Home":
            this.min && (this.updateModel(t, this.min), t.preventDefault());
            break;
          case "End":
            this.max && (this.updateModel(t, this.max), t.preventDefault());
            break;
        }
      }
    },
    onInputKeyPress: function(t) {
      if (!this.readonly) {
        t.preventDefault();
        var n = t.which || t.keyCode, i = String.fromCharCode(n), o = this.isDecimalSign(i), a = this.isMinusSign(i);
        (48 <= n && n <= 57 || a || o) && this.insert(t, i, {
          isDecimalSign: o,
          isMinusSign: a
        });
      }
    },
    onPaste: function(t) {
      t.preventDefault();
      var n = (t.clipboardData || window.clipboardData).getData("Text");
      if (n) {
        var i = this.parseValue(n);
        i != null && this.insert(t, i.toString());
      }
    },
    allowMinusSign: function() {
      return this.min === null || this.min < 0;
    },
    isMinusSign: function(t) {
      return this._minusSign.test(t) || t === "-" ? (this._minusSign.lastIndex = 0, !0) : !1;
    },
    isDecimalSign: function(t) {
      return this._decimal.test(t) ? (this._decimal.lastIndex = 0, !0) : !1;
    },
    isDecimalMode: function() {
      return this.mode === "decimal";
    },
    getDecimalCharIndexes: function(t) {
      var n = t.search(this._decimal);
      this._decimal.lastIndex = 0;
      var i = t.replace(this._prefix, "").trim().replace(/\s/g, "").replace(this._currency, ""), o = i.search(this._decimal);
      return this._decimal.lastIndex = 0, {
        decimalCharIndex: n,
        decimalCharIndexWithoutPrefix: o
      };
    },
    getCharIndexes: function(t) {
      var n = t.search(this._decimal);
      this._decimal.lastIndex = 0;
      var i = t.search(this._minusSign);
      this._minusSign.lastIndex = 0;
      var o = t.search(this._suffix);
      this._suffix.lastIndex = 0;
      var a = t.search(this._currency);
      return this._currency.lastIndex = 0, {
        decimalCharIndex: n,
        minusCharIndex: i,
        suffixCharIndex: o,
        currencyCharIndex: a
      };
    },
    insert: function(t, n) {
      var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {
        isDecimalSign: !1,
        isMinusSign: !1
      }, o = n.search(this._minusSign);
      if (this._minusSign.lastIndex = 0, !(!this.allowMinusSign() && o !== -1)) {
        var a = this.$refs.input.$el.selectionStart, r = this.$refs.input.$el.selectionEnd, s = this.$refs.input.$el.value.trim(), l = this.getCharIndexes(s), d = l.decimalCharIndex, y = l.minusCharIndex, u = l.suffixCharIndex, m = l.currencyCharIndex, h;
        if (i.isMinusSign)
          a === 0 && (h = s, (y === -1 || r !== 0) && (h = this.insertText(s, n, 0, r)), this.updateValue(t, h, n, "insert"));
        else if (i.isDecimalSign)
          d > 0 && a === d ? this.updateValue(t, s, n, "insert") : d > a && d < r ? (h = this.insertText(s, n, a, r), this.updateValue(t, h, n, "insert")) : d === -1 && this.maxFractionDigits && (h = this.insertText(s, n, a, r), this.updateValue(t, h, n, "insert"));
        else {
          var c = this.numberFormat.resolvedOptions().maximumFractionDigits, g = a !== r ? "range-insert" : "insert";
          if (d > 0 && a > d) {
            if (a + n.length - (d + 1) <= c) {
              var v = m >= a ? m - 1 : u >= a ? u : s.length;
              h = s.slice(0, a) + n + s.slice(a + n.length, v) + s.slice(v), this.updateValue(t, h, n, g);
            }
          } else
            h = this.insertText(s, n, a, r), this.updateValue(t, h, n, g);
        }
      }
    },
    insertText: function(t, n, i, o) {
      var a = n === "." ? n : n.split(".");
      if (a.length === 2) {
        var r = t.slice(i, o).search(this._decimal);
        return this._decimal.lastIndex = 0, r > 0 ? t.slice(0, i) + this.formatValue(n) + t.slice(o) : t || this.formatValue(n);
      } else
        return o - i === t.length ? this.formatValue(n) : i === 0 ? n + t.slice(o) : o === t.length ? t.slice(0, i) + n : t.slice(0, i) + n + t.slice(o);
    },
    deleteRange: function(t, n, i) {
      var o;
      return i - n === t.length ? o = "" : n === 0 ? o = t.slice(i) : i === t.length ? o = t.slice(0, n) : o = t.slice(0, n) + t.slice(i), o;
    },
    initCursor: function() {
      var t = this.$refs.input.$el.selectionStart, n = this.$refs.input.$el.value, i = n.length, o = null, a = (this.prefixChar || "").length;
      n = n.replace(this._prefix, ""), t = t - a;
      var r = n.charAt(t);
      if (this.isNumeralChar(r))
        return t + a;
      for (var s = t - 1; s >= 0; )
        if (r = n.charAt(s), this.isNumeralChar(r)) {
          o = s + a;
          break;
        } else
          s--;
      if (o !== null)
        this.$refs.input.$el.setSelectionRange(o + 1, o + 1);
      else {
        for (s = t; s < i; )
          if (r = n.charAt(s), this.isNumeralChar(r)) {
            o = s + a;
            break;
          } else
            s++;
        o !== null && this.$refs.input.$el.setSelectionRange(o, o);
      }
      return o || 0;
    },
    onInputClick: function() {
      var t = this.$refs.input.$el.value;
      !this.readonly && t !== Oe.getSelection() && this.initCursor();
    },
    isNumeralChar: function(t) {
      return t.length === 1 && (this._numeral.test(t) || this._decimal.test(t) || this._group.test(t) || this._minusSign.test(t)) ? (this.resetRegex(), !0) : !1;
    },
    resetRegex: function() {
      this._numeral.lastIndex = 0, this._decimal.lastIndex = 0, this._group.lastIndex = 0, this._minusSign.lastIndex = 0;
    },
    updateValue: function(t, n, i, o) {
      var a = this.$refs.input.$el.value, r = null;
      n != null && (r = this.parseValue(n), r = !r && !this.allowEmpty ? 0 : r, this.updateInput(r, i, o, n), this.handleOnInput(t, a, r));
    },
    handleOnInput: function(t, n, i) {
      this.isValueChanged(n, i) && this.$emit("input", {
        originalEvent: t,
        value: i,
        formattedValue: n
      });
    },
    isValueChanged: function(t, n) {
      if (n === null && t !== null)
        return !0;
      if (n != null) {
        var i = typeof t == "string" ? this.parseValue(t) : t;
        return n !== i;
      }
      return !1;
    },
    validateValue: function(t) {
      return t === "-" || t == null ? null : this.min != null && t < this.min ? this.min : this.max != null && t > this.max ? this.max : t;
    },
    updateInput: function(t, n, i, o) {
      n = n || "";
      var a = this.$refs.input.$el.value, r = this.formatValue(t), s = a.length;
      if (r !== o && (r = this.concatValues(r, o)), s === 0) {
        this.$refs.input.$el.value = r, this.$refs.input.$el.setSelectionRange(0, 0);
        var l = this.initCursor(), d = l + n.length;
        this.$refs.input.$el.setSelectionRange(d, d);
      } else {
        var y = this.$refs.input.$el.selectionStart, u = this.$refs.input.$el.selectionEnd;
        this.$refs.input.$el.value = r;
        var m = r.length;
        if (i === "range-insert") {
          var h = this.parseValue((a || "").slice(0, y)), c = h !== null ? h.toString() : "", g = c.split("").join("(".concat(this.groupChar, ")?")), v = new RegExp(g, "g");
          v.test(r);
          var P = n.split("").join("(".concat(this.groupChar, ")?")), f = new RegExp(P, "g");
          f.test(r.slice(v.lastIndex)), u = v.lastIndex + f.lastIndex, this.$refs.input.$el.setSelectionRange(u, u);
        } else if (m === s)
          i === "insert" || i === "delete-back-single" ? this.$refs.input.$el.setSelectionRange(u + 1, u + 1) : i === "delete-single" ? this.$refs.input.$el.setSelectionRange(u - 1, u - 1) : (i === "delete-range" || i === "spin") && this.$refs.input.$el.setSelectionRange(u, u);
        else if (i === "delete-back-single") {
          var S = a.charAt(u - 1), w = a.charAt(u), x = s - m, k = this._group.test(w);
          k && x === 1 ? u += 1 : !k && this.isNumeralChar(S) && (u += -1 * x + 1), this._group.lastIndex = 0, this.$refs.input.$el.setSelectionRange(u, u);
        } else if (a === "-" && i === "insert") {
          this.$refs.input.$el.setSelectionRange(0, 0);
          var A = this.initCursor(), $ = A + n.length + 1;
          this.$refs.input.$el.setSelectionRange($, $);
        } else
          u = u + (m - s), this.$refs.input.$el.setSelectionRange(u, u);
      }
      this.$refs.input.$el.setAttribute("aria-valuenow", t);
    },
    concatValues: function(t, n) {
      if (t && n) {
        var i = n.search(this._decimal);
        return this._decimal.lastIndex = 0, this.suffixChar ? i !== -1 ? t.replace(this.suffixChar, "").split(this._decimal)[0] + n.replace(this.suffixChar, "").slice(i) + this.suffixChar : t : i !== -1 ? t.split(this._decimal)[0] + n.slice(i) : t;
      }
      return t;
    },
    getDecimalLength: function(t) {
      if (t) {
        var n = t.split(this._decimal);
        if (n.length === 2)
          return n[1].replace(this._suffix, "").trim().replace(/\s/g, "").replace(this._currency, "").length;
      }
      return 0;
    },
    updateModel: function(t, n) {
      this.d_modelValue = n, this.$emit("update:modelValue", n);
    },
    onInputFocus: function(t) {
      this.focused = !0, !this.disabled && !this.readonly && this.$refs.input.$el.value !== Oe.getSelection() && this.highlightOnFocus && t.target.select(), this.$emit("focus", t);
    },
    onInputBlur: function(t) {
      this.focused = !1;
      var n = t.target, i = this.validateValue(this.parseValue(n.value));
      this.$emit("blur", {
        originalEvent: t,
        value: n.value
      }), n.value = this.formatValue(i), n.setAttribute("aria-valuenow", i), this.updateModel(t, i), !this.disabled && !this.readonly && this.highlightOnFocus && Oe.clearSelection();
    },
    clearTimer: function() {
      this.timer && clearInterval(this.timer);
    },
    maxBoundry: function() {
      return this.d_modelValue >= this.max;
    },
    minBoundry: function() {
      return this.d_modelValue <= this.min;
    }
  },
  computed: {
    filled: function() {
      return this.modelValue != null && this.modelValue.toString().length > 0;
    },
    upButtonListeners: function() {
      var t = this;
      return {
        mousedown: function(i) {
          return t.onUpButtonMouseDown(i);
        },
        mouseup: function(i) {
          return t.onUpButtonMouseUp(i);
        },
        mouseleave: function(i) {
          return t.onUpButtonMouseLeave(i);
        },
        keydown: function(i) {
          return t.onUpButtonKeyDown(i);
        },
        keyup: function(i) {
          return t.onUpButtonKeyUp(i);
        }
      };
    },
    downButtonListeners: function() {
      var t = this;
      return {
        mousedown: function(i) {
          return t.onDownButtonMouseDown(i);
        },
        mouseup: function(i) {
          return t.onDownButtonMouseUp(i);
        },
        mouseleave: function(i) {
          return t.onDownButtonMouseLeave(i);
        },
        keydown: function(i) {
          return t.onDownButtonKeyDown(i);
        },
        keyup: function(i) {
          return t.onDownButtonKeyUp(i);
        }
      };
    },
    formattedValue: function() {
      var t = !this.modelValue && !this.allowEmpty ? 0 : this.modelValue;
      return this.formatValue(t);
    },
    getFormatter: function() {
      return this.numberFormat;
    }
  },
  components: {
    INInputText: ls,
    INButton: ki,
    AngleUpIcon: Lw,
    AngleDownIcon: Tw
  }
};
function gB(e, t, n, i, o, a) {
  var r = $e("INInputText"), s = $e("INButton");
  return E(), X("span", Ce({
    class: e.cx("root")
  }, e.ptm("root"), {
    "data-pc-name": "inputnumber"
  }), [ue(r, Ce({
    ref: "input",
    id: e.inputId,
    role: "spinbutton",
    class: [e.cx("input"), e.inputClass],
    style: e.inputStyle,
    value: a.formattedValue,
    "aria-valuemin": e.min,
    "aria-valuemax": e.max,
    "aria-valuenow": e.modelValue,
    disabled: e.disabled,
    readonly: e.readonly,
    placeholder: e.placeholder,
    "aria-labelledby": e.ariaLabelledby,
    "aria-label": e.ariaLabel,
    onInput: a.onUserInput,
    onKeydown: a.onInputKeyDown,
    onKeypress: a.onInputKeyPress,
    onPaste: a.onPaste,
    onClick: a.onInputClick,
    onFocus: a.onInputFocus,
    onBlur: a.onInputBlur
  }, e.inputProps, {
    pt: e.ptm("input"),
    unstyled: e.unstyled,
    "data-pc-section": "input"
  }), null, 16, ["id", "class", "style", "value", "aria-valuemin", "aria-valuemax", "aria-valuenow", "disabled", "readonly", "placeholder", "aria-labelledby", "aria-label", "onInput", "onKeydown", "onKeypress", "onPaste", "onClick", "onFocus", "onBlur", "pt", "unstyled"]), e.showButtons && e.buttonLayout === "stacked" ? (E(), X("span", Ce({
    key: 0,
    class: e.cx("buttonGroup")
  }, e.ptm("buttonGroup")), [ue(s, Ce({
    class: [e.cx("incrementButton"), e.incrementButtonClass]
  }, sd(a.upButtonListeners), {
    disabled: e.disabled,
    tabindex: -1,
    "aria-hidden": "true"
  }, e.incrementButtonProps, {
    pt: e.ptm("incrementButton"),
    unstyled: e.unstyled,
    "data-pc-section": "incrementbutton"
  }), {
    icon: Se(function() {
      return [je(e.$slots, "incrementbuttonicon", {}, function() {
        return [(E(), fe(tt(e.incrementButtonIcon ? "span" : "AngleUpIcon"), Ce({
          class: e.incrementButtonIcon
        }, e.ptm("incrementButton").icon, {
          "data-pc-section": "incrementbuttonicon"
        }), null, 16, ["class"]))];
      })];
    }),
    _: 3
  }, 16, ["class", "disabled", "pt", "unstyled"]), ue(s, Ce({
    class: [e.cx("decrementButton"), e.decrementButtonClass]
  }, sd(a.downButtonListeners), {
    disabled: e.disabled,
    tabindex: -1,
    "aria-hidden": "true"
  }, e.decrementButtonProps, {
    pt: e.ptm("decrementButton"),
    unstyled: e.unstyled,
    "data-pc-section": "decrementbutton"
  }), {
    icon: Se(function() {
      return [je(e.$slots, "decrementbuttonicon", {}, function() {
        return [(E(), fe(tt(e.decrementButtonIcon ? "span" : "AngleDownIcon"), Ce({
          class: e.decrementButtonIcon
        }, e.ptm("decrementButton").icon, {
          "data-pc-section": "decrementbuttonicon"
        }), null, 16, ["class"]))];
      })];
    }),
    _: 3
  }, 16, ["class", "disabled", "pt", "unstyled"])], 16)) : te("", !0), e.showButtons && e.buttonLayout !== "stacked" ? (E(), fe(s, Ce({
    key: 1,
    class: [e.cx("incrementButton"), e.incrementButtonClass]
  }, sd(a.upButtonListeners), {
    disabled: e.disabled,
    tabindex: -1,
    "aria-hidden": "true"
  }, e.incrementButtonProps, {
    pt: e.ptm("incrementButton"),
    unstyled: e.unstyled,
    "data-pc-section": "incrementbutton"
  }), {
    icon: Se(function() {
      return [je(e.$slots, "incrementbuttonicon", {}, function() {
        return [(E(), fe(tt(e.incrementButtonIcon ? "span" : "AngleUpIcon"), Ce({
          class: e.incrementButtonIcon
        }, e.ptm("incrementButton").icon, {
          "data-pc-section": "incrementbuttonicon"
        }), null, 16, ["class"]))];
      })];
    }),
    _: 3
  }, 16, ["class", "disabled", "pt", "unstyled"])) : te("", !0), e.showButtons && e.buttonLayout !== "stacked" ? (E(), fe(s, Ce({
    key: 2,
    class: [e.cx("decrementButton"), e.decrementButtonClass]
  }, sd(a.downButtonListeners), {
    disabled: e.disabled,
    tabindex: -1,
    "aria-hidden": "true"
  }, e.decrementButtonProps, {
    pt: e.ptm("decrementButton"),
    unstyled: e.unstyled,
    "data-pc-section": "decrementbutton"
  }), {
    icon: Se(function() {
      return [je(e.$slots, "decrementbuttonicon", {}, function() {
        return [(E(), fe(tt(e.decrementButtonIcon ? "span" : "AngleDownIcon"), Ce({
          class: e.decrementButtonIcon
        }, e.ptm("decrementButton").icon, {
          "data-pc-section": "decrementbuttonicon"
        }), null, 16, ["class"]))];
      })];
    }),
    _: 3
  }, 16, ["class", "disabled", "pt", "unstyled"])) : te("", !0)], 16);
}
Am.render = gB;
var Iw = {
  name: "AngleDoubleRightIcon",
  extends: Yt
}, vB = /* @__PURE__ */ oe("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M7.68757 11.1451C7.7791 11.1831 7.8773 11.2024 7.9764 11.2019C8.07769 11.1985 8.17721 11.1745 8.26886 11.1312C8.36052 11.088 8.44238 11.0265 8.50943 10.9505L12.0294 7.49085C12.1707 7.34942 12.25 7.15771 12.25 6.95782C12.25 6.75794 12.1707 6.56622 12.0294 6.42479L8.50943 2.90479C8.37014 2.82159 8.20774 2.78551 8.04633 2.80192C7.88491 2.81833 7.73309 2.88635 7.6134 2.99588C7.4937 3.10541 7.41252 3.25061 7.38189 3.40994C7.35126 3.56927 7.37282 3.73423 7.44337 3.88033L10.4605 6.89748L7.44337 9.91463C7.30212 10.0561 7.22278 10.2478 7.22278 10.4477C7.22278 10.6475 7.30212 10.8393 7.44337 10.9807C7.51301 11.0512 7.59603 11.1071 7.68757 11.1451ZM1.94207 10.9505C2.07037 11.0968 2.25089 11.1871 2.44493 11.2019C2.63898 11.1871 2.81949 11.0968 2.94779 10.9505L6.46779 7.49085C6.60905 7.34942 6.68839 7.15771 6.68839 6.95782C6.68839 6.75793 6.60905 6.56622 6.46779 6.42479L2.94779 2.90479C2.80704 2.83757 2.6489 2.81563 2.49517 2.84201C2.34143 2.86839 2.19965 2.94178 2.08936 3.05207C1.97906 3.16237 1.90567 3.30415 1.8793 3.45788C1.85292 3.61162 1.87485 3.76975 1.94207 3.9105L4.95922 6.92765L1.94207 9.9448C1.81838 10.0831 1.75 10.2621 1.75 10.4477C1.75 10.6332 1.81838 10.8122 1.94207 10.9505Z",
  fill: "currentColor"
}, null, -1), yB = [vB];
function bB(e, t, n, i, o, a) {
  return E(), X("svg", Ce({
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.pti()), yB, 16);
}
Iw.render = bB;
var Pw = {
  name: "AngleRightIcon",
  extends: Yt
}, xB = /* @__PURE__ */ oe("path", {
  d: "M5.25 11.1728C5.14929 11.1694 5.05033 11.1455 4.9592 11.1025C4.86806 11.0595 4.78666 10.9984 4.72 10.9228C4.57955 10.7822 4.50066 10.5916 4.50066 10.3928C4.50066 10.1941 4.57955 10.0035 4.72 9.86283L7.72 6.86283L4.72 3.86283C4.66067 3.71882 4.64765 3.55991 4.68275 3.40816C4.71785 3.25642 4.79932 3.11936 4.91585 3.01602C5.03238 2.91268 5.17819 2.84819 5.33305 2.83149C5.4879 2.81479 5.64411 2.84671 5.78 2.92283L9.28 6.42283C9.42045 6.56346 9.49934 6.75408 9.49934 6.95283C9.49934 7.15158 9.42045 7.34221 9.28 7.48283L5.78 10.9228C5.71333 10.9984 5.63193 11.0595 5.5408 11.1025C5.44966 11.1455 5.35071 11.1694 5.25 11.1728Z",
  fill: "currentColor"
}, null, -1), wB = [xB];
function kB(e, t, n, i, o, a) {
  return E(), X("svg", Ce({
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.pti()), wB, 16);
}
Pw.render = kB;
var Aw = {
  name: "AngleLeftIcon",
  extends: Yt
}, SB = /* @__PURE__ */ oe("path", {
  d: "M8.75 11.185C8.65146 11.1854 8.55381 11.1662 8.4628 11.1284C8.37179 11.0906 8.28924 11.0351 8.22 10.965L4.72 7.46496C4.57955 7.32433 4.50066 7.13371 4.50066 6.93496C4.50066 6.73621 4.57955 6.54558 4.72 6.40496L8.22 2.93496C8.36095 2.84357 8.52851 2.80215 8.69582 2.81733C8.86312 2.83252 9.02048 2.90344 9.14268 3.01872C9.26487 3.134 9.34483 3.28696 9.36973 3.4531C9.39463 3.61924 9.36303 3.78892 9.28 3.93496L6.28 6.93496L9.28 9.93496C9.42045 10.0756 9.49934 10.2662 9.49934 10.465C9.49934 10.6637 9.42045 10.8543 9.28 10.995C9.13526 11.1257 8.9448 11.1939 8.75 11.185Z",
  fill: "currentColor"
}, null, -1), CB = [SB];
function TB(e, t, n, i, o, a) {
  return E(), X("svg", Ce({
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.pti()), CB, 16);
}
Aw.render = TB;
var LB = {
  name: "BasePaginator",
  extends: wt,
  props: {
    totalRecords: {
      type: Number,
      default: 0
    },
    rows: {
      type: Number,
      default: 0
    },
    first: {
      type: Number,
      default: 0
    },
    pageLinkSize: {
      type: Number,
      default: 5
    },
    rowsPerPageOptions: {
      type: Array,
      default: null
    },
    template: {
      type: [Object, String],
      default: "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
    },
    currentPageReportTemplate: {
      type: null,
      default: "({currentPage} of {totalPages})"
    },
    alwaysShow: {
      type: Boolean,
      default: !0
    }
  },
  style: WM,
  provide: function() {
    return {
      $parentInstance: this
    };
  }
}, _w = {
  name: "CurrentPageReport",
  hostName: "Paginator",
  extends: wt,
  props: {
    pageCount: {
      type: Number,
      default: 0
    },
    currentPage: {
      type: Number,
      default: 0
    },
    page: {
      type: Number,
      default: 0
    },
    first: {
      type: Number,
      default: 0
    },
    rows: {
      type: Number,
      default: 0
    },
    totalRecords: {
      type: Number,
      default: 0
    },
    template: {
      type: String,
      default: "({currentPage} of {totalPages})"
    }
  },
  computed: {
    text: function() {
      var t = this.template.replace("{currentPage}", this.currentPage).replace("{totalPages}", this.pageCount).replace("{first}", this.pageCount > 0 ? this.first + 1 : 0).replace("{last}", Math.min(this.first + this.rows, this.totalRecords)).replace("{rows}", this.rows).replace("{totalRecords}", this.totalRecords);
      return t;
    }
  }
};
function IB(e, t, n, i, o, a) {
  return E(), X("span", Ce({
    class: e.cx("current")
  }, e.ptm("current")), Ie(a.text), 17);
}
_w.render = IB;
var Mw = {
  name: "FirstPageLink",
  hostName: "Paginator",
  extends: wt,
  props: {
    template: {
      type: Function,
      default: null
    }
  },
  methods: {
    getPTOptions: function(t) {
      return this.ptm(t, {
        context: {
          disabled: this.$attrs.disabled
        }
      });
    }
  },
  components: {
    AngleDoubleLeftIcon: ww
  },
  directives: {
    ripple: An
  }
};
function PB(e, t, n, i, o, a) {
  var r = Ut("ripple");
  return rt((E(), X("button", Ce({
    class: e.cx("firstPageButton"),
    type: "button"
  }, a.getPTOptions("firstPageButton"), {
    "data-pc-group-section": "pagebutton"
  }), [(E(), fe(tt(n.template || "AngleDoubleLeftIcon"), Ce({
    class: e.cx("firstPageIcon")
  }, a.getPTOptions("firstPageIcon")), null, 16, ["class"]))], 16)), [[r]]);
}
Mw.render = PB;
var Ow = {
  name: "JumpToPageDropdown",
  hostName: "Paginator",
  extends: wt,
  emits: ["page-change"],
  props: {
    page: Number,
    pageCount: Number,
    disabled: Boolean,
    templates: null
  },
  methods: {
    onChange: function(t) {
      this.$emit("page-change", t);
    }
  },
  computed: {
    pageOptions: function() {
      for (var t = [], n = 0; n < this.pageCount; n++)
        t.push({
          label: String(n + 1),
          value: n
        });
      return t;
    }
  },
  components: {
    JTPDropdown: Ga
  }
};
function AB(e, t, n, i, o, a) {
  var r = $e("JTPDropdown");
  return E(), fe(r, {
    modelValue: n.page,
    options: a.pageOptions,
    optionLabel: "label",
    optionValue: "value",
    "onUpdate:modelValue": t[0] || (t[0] = function(s) {
      return a.onChange(s);
    }),
    class: Pe(e.cx("jumpToPageDropdown")),
    disabled: n.disabled,
    unstyled: e.unstyled,
    pt: e.ptm("jumpToPageDropdown"),
    "data-pc-section": "jumptopagedropdown",
    "data-pc-group-section": "pagedropdown"
  }, Qt({
    _: 2
  }, [n.templates.jumptopagedropdownicon ? {
    name: "dropdownicon",
    fn: Se(function(s) {
      return [(E(), fe(tt(n.templates.jumptopagedropdownicon), {
        class: Pe(s.class)
      }, null, 8, ["class"]))];
    }),
    key: "0"
  } : void 0]), 1032, ["modelValue", "options", "class", "disabled", "unstyled", "pt"]);
}
Ow.render = AB;
var Bw = {
  name: "JumpToPageInput",
  hostName: "Paginator",
  extends: wt,
  inheritAttrs: !1,
  emits: ["page-change"],
  props: {
    page: Number,
    pageCount: Number,
    disabled: Boolean
  },
  data: function() {
    return {
      d_page: this.page
    };
  },
  watch: {
    page: function(t) {
      this.d_page = t;
    }
  },
  methods: {
    onChange: function(t) {
      t !== this.page && (this.d_page = t, this.$emit("page-change", t - 1));
    }
  },
  computed: {
    inputArialabel: function() {
      return this.$primevue.config.locale.aria ? this.$primevue.config.locale.aria.jumpToPageInputLabel : void 0;
    }
  },
  components: {
    JTPInput: Am
  }
};
function _B(e, t, n, i, o, a) {
  var r = $e("JTPInput");
  return E(), fe(r, {
    ref: "jtpInput",
    modelValue: o.d_page,
    class: Pe(e.cx("jumpToPageInput")),
    "aria-label": a.inputArialabel,
    disabled: n.disabled,
    "onUpdate:modelValue": a.onChange,
    unstyled: e.unstyled,
    pt: e.ptm("jumpToPageInput"),
    "data-pc-section": "jumptopageinput"
  }, null, 8, ["modelValue", "class", "aria-label", "disabled", "onUpdate:modelValue", "unstyled", "pt"]);
}
Bw.render = _B;
var Ew = {
  name: "LastPageLink",
  hostName: "Paginator",
  extends: wt,
  props: {
    template: {
      type: Function,
      default: null
    }
  },
  methods: {
    getPTOptions: function(t) {
      return this.ptm(t, {
        context: {
          disabled: this.$attrs.disabled
        }
      });
    }
  },
  components: {
    AngleDoubleRightIcon: Iw
  },
  directives: {
    ripple: An
  }
};
function MB(e, t, n, i, o, a) {
  var r = Ut("ripple");
  return rt((E(), X("button", Ce({
    class: e.cx("lastPageButton"),
    type: "button"
  }, a.getPTOptions("lastPageButton"), {
    "data-pc-group-section": "pagebutton"
  }), [(E(), fe(tt(n.template || "AngleDoubleRightIcon"), Ce({
    class: e.cx("lastPageIcon")
  }, a.getPTOptions("lastPageIcon")), null, 16, ["class"]))], 16)), [[r]]);
}
Ew.render = MB;
var Dw = {
  name: "NextPageLink",
  hostName: "Paginator",
  extends: wt,
  props: {
    template: {
      type: Function,
      default: null
    }
  },
  methods: {
    getPTOptions: function(t) {
      return this.ptm(t, {
        context: {
          disabled: this.$attrs.disabled
        }
      });
    }
  },
  components: {
    AngleRightIcon: Pw
  },
  directives: {
    ripple: An
  }
};
function OB(e, t, n, i, o, a) {
  var r = Ut("ripple");
  return rt((E(), X("button", Ce({
    class: e.cx("nextPageButton"),
    type: "button"
  }, a.getPTOptions("nextPageButton"), {
    "data-pc-group-section": "pagebutton"
  }), [(E(), fe(tt(n.template || "AngleRightIcon"), Ce({
    class: e.cx("nextPageIcon")
  }, a.getPTOptions("nextPageIcon")), null, 16, ["class"]))], 16)), [[r]]);
}
Dw.render = OB;
var Rw = {
  name: "PageLinks",
  hostName: "Paginator",
  extends: wt,
  inheritAttrs: !1,
  emits: ["click"],
  props: {
    value: Array,
    page: Number
  },
  methods: {
    getPTOptions: function(t, n) {
      return this.ptm(n, {
        context: {
          active: t === this.page
        }
      });
    },
    onPageLinkClick: function(t, n) {
      this.$emit("click", {
        originalEvent: t,
        value: n
      });
    },
    ariaPageLabel: function(t) {
      return this.$primevue.config.locale.aria ? this.$primevue.config.locale.aria.pageLabel.replace(/{page}/g, t) : void 0;
    }
  },
  directives: {
    ripple: An
  }
}, BB = ["aria-label", "aria-current", "onClick", "data-p-highlight"];
function EB(e, t, n, i, o, a) {
  var r = Ut("ripple");
  return E(), X("span", Ce({
    class: e.cx("pages")
  }, e.ptm("pages")), [(E(!0), X(Re, null, Ge(n.value, function(s) {
    return rt((E(), X("button", Ce({
      key: s,
      class: e.cx("pageButton", {
        pageLink: s
      }),
      type: "button",
      "aria-label": a.ariaPageLabel(s),
      "aria-current": s - 1 === n.page ? "page" : void 0,
      onClick: function(d) {
        return a.onPageLinkClick(d, s);
      }
    }, a.getPTOptions(s - 1, "pageButton"), {
      "data-p-highlight": s - 1 === n.page
    }), [Ve(Ie(s), 1)], 16, BB)), [[r]]);
  }), 128))], 16);
}
Rw.render = EB;
var Nw = {
  name: "PrevPageLink",
  hostName: "Paginator",
  extends: wt,
  props: {
    template: {
      type: Function,
      default: null
    }
  },
  methods: {
    getPTOptions: function(t) {
      return this.ptm(t, {
        context: {
          disabled: this.$attrs.disabled
        }
      });
    }
  },
  components: {
    AngleLeftIcon: Aw
  },
  directives: {
    ripple: An
  }
};
function DB(e, t, n, i, o, a) {
  var r = Ut("ripple");
  return rt((E(), X("button", Ce({
    class: e.cx("previousPageButton"),
    type: "button"
  }, a.getPTOptions("previousPageButton"), {
    "data-pc-group-section": "pagebutton"
  }), [(E(), fe(tt(n.template || "AngleLeftIcon"), Ce({
    class: e.cx("previousPageIcon")
  }, a.getPTOptions("previousPageIcon")), null, 16, ["class"]))], 16)), [[r]]);
}
Nw.render = DB;
var $w = {
  name: "RowsPerPageDropdown",
  hostName: "Paginator",
  extends: wt,
  emits: ["rows-change"],
  props: {
    options: Array,
    rows: Number,
    disabled: Boolean,
    templates: null
  },
  methods: {
    onChange: function(t) {
      this.$emit("rows-change", t);
    }
  },
  computed: {
    rowsOptions: function() {
      var t = [];
      if (this.options)
        for (var n = 0; n < this.options.length; n++)
          t.push({
            label: String(this.options[n]),
            value: this.options[n]
          });
      return t;
    }
  },
  components: {
    RPPDropdown: Ga
  }
};
function RB(e, t, n, i, o, a) {
  var r = $e("RPPDropdown");
  return E(), fe(r, {
    modelValue: n.rows,
    options: a.rowsOptions,
    optionLabel: "label",
    optionValue: "value",
    "onUpdate:modelValue": t[0] || (t[0] = function(s) {
      return a.onChange(s);
    }),
    class: Pe(e.cx("rowPerPageDropdown")),
    disabled: n.disabled,
    unstyled: e.unstyled,
    pt: e.ptm("rowPerPageDropdown"),
    "data-pc-section": "rowperpagedropdown",
    "data-pc-group-section": "pagedropdown"
  }, Qt({
    _: 2
  }, [n.templates.rowsperpagedropdownicon ? {
    name: "dropdownicon",
    fn: Se(function(s) {
      return [(E(), fe(tt(n.templates.rowsperpagedropdownicon), {
        class: Pe(s.class)
      }, null, 8, ["class"]))];
    }),
    key: "0"
  } : void 0]), 1032, ["modelValue", "options", "class", "disabled", "unstyled", "pt"]);
}
$w.render = RB;
function NB(e) {
  return jB(e) || FB(e) || Fw(e) || $B();
}
function $B() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function FB(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null)
    return Array.from(e);
}
function jB(e) {
  if (Array.isArray(e))
    return Xp(e);
}
function Kp(e) {
  "@babel/helpers - typeof";
  return Kp = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Kp(e);
}
function iy(e, t) {
  return VB(e) || zB(e, t) || Fw(e, t) || HB();
}
function HB() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Fw(e, t) {
  if (e) {
    if (typeof e == "string")
      return Xp(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set")
      return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return Xp(e, t);
  }
}
function Xp(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, i = new Array(t); n < t; n++)
    i[n] = e[n];
  return i;
}
function zB(e, t) {
  var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var i, o, a, r, s = [], l = !0, d = !1;
    try {
      if (a = (n = n.call(e)).next, t === 0) {
        if (Object(n) !== n)
          return;
        l = !1;
      } else
        for (; !(l = (i = a.call(n)).done) && (s.push(i.value), s.length !== t); l = !0)
          ;
    } catch (y) {
      d = !0, o = y;
    } finally {
      try {
        if (!l && n.return != null && (r = n.return(), Object(r) !== r))
          return;
      } finally {
        if (d)
          throw o;
      }
    }
    return s;
  }
}
function VB(e) {
  if (Array.isArray(e))
    return e;
}
var _m = {
  name: "Paginator",
  extends: LB,
  emits: ["update:first", "update:rows", "page"],
  data: function() {
    return {
      d_first: this.first,
      d_rows: this.rows
    };
  },
  watch: {
    first: function(t) {
      this.d_first = t;
    },
    rows: function(t) {
      this.d_rows = t;
    },
    totalRecords: function(t) {
      this.page > 0 && t && this.d_first >= t && this.changePage(this.pageCount - 1);
    }
  },
  mounted: function() {
    this.setPaginatorAttribute(), this.createStyle();
  },
  methods: {
    changePage: function(t) {
      var n = this.pageCount;
      if (t >= 0 && t < n) {
        this.d_first = this.d_rows * t;
        var i = {
          page: t,
          first: this.d_first,
          rows: this.d_rows,
          pageCount: n
        };
        this.$emit("update:first", this.d_first), this.$emit("update:rows", this.d_rows), this.$emit("page", i);
      }
    },
    changePageToFirst: function(t) {
      this.isFirstPage || this.changePage(0), t.preventDefault();
    },
    changePageToPrev: function(t) {
      this.changePage(this.page - 1), t.preventDefault();
    },
    changePageLink: function(t) {
      this.changePage(t.value - 1), t.originalEvent.preventDefault();
    },
    changePageToNext: function(t) {
      this.changePage(this.page + 1), t.preventDefault();
    },
    changePageToLast: function(t) {
      this.isLastPage || this.changePage(this.pageCount - 1), t.preventDefault();
    },
    onRowChange: function(t) {
      this.d_rows = t, this.changePage(this.page);
    },
    createStyle: function() {
      var t = this;
      if (this.hasBreakpoints() && !this.isUnstyled) {
        var n;
        this.styleElement = document.createElement("style"), this.styleElement.type = "text/css", Oe.setAttribute(this.styleElement, "nonce", (n = this.$primevue) === null || n === void 0 || (n = n.config) === null || n === void 0 || (n = n.csp) === null || n === void 0 ? void 0 : n.nonce), document.head.appendChild(this.styleElement);
        var i = "", o = Object.keys(this.template), a = {};
        o.sort(function(c, g) {
          return parseInt(c) - parseInt(g);
        }).forEach(function(c) {
          a[c] = t.template[c];
        });
        for (var r = 0, s = Object.entries(Object.entries(a)); r < s.length; r++) {
          var l = iy(s[r], 2), d = l[0], y = iy(l[1], 1), u = y[0], m = void 0, h = void 0;
          u !== "default" && typeof Object.keys(a)[d - 1] == "string" ? h = Number(Object.keys(a)[d - 1].slice(0, -2)) + 1 + "px" : h = Object.keys(a)[d - 1], m = Object.entries(a)[d - 1] ? "and (min-width:".concat(h, ")") : "", u === "default" ? i += `
                            @media screen `.concat(m, ` {
                                .paginator[`).concat(this.attributeSelector, `],
                                .p-paginator-default{
                                    display: flex;
                                }
                            }
                        `) : i += `
.paginator[`.concat(this.attributeSelector, "], .p-paginator-").concat(u, ` {
    display: none;
}
@media screen `).concat(m, " and (max-width: ").concat(u, `) {
    .paginator[`).concat(this.attributeSelector, "], .p-paginator-").concat(u, ` {
        display: flex;
    }
    .paginator[`).concat(this.attributeSelector, `],
    .p-paginator-default{
        display: none;
    }
}
                    `);
        }
        this.styleElement.innerHTML = i;
      }
    },
    hasBreakpoints: function() {
      return Kp(this.template) === "object";
    },
    setPaginatorAttribute: function() {
      var t = this;
      this.$refs.paginator && this.$refs.paginator.length >= 0 && NB(this.$refs.paginator).forEach(function(n) {
        n.setAttribute(t.attributeSelector, "");
      });
    },
    getAriaLabel: function(t) {
      return this.$primevue.config.locale.aria ? this.$primevue.config.locale.aria[t] : void 0;
    }
  },
  computed: {
    templateItems: function() {
      var t = {};
      if (this.hasBreakpoints()) {
        t = this.template, t.default || (t.default = "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown");
        for (var n in t)
          t[n] = this.template[n].split(" ").map(function(i) {
            return i.trim();
          });
        return t;
      }
      return t.default = this.template.split(" ").map(function(i) {
        return i.trim();
      }), t;
    },
    page: function() {
      return Math.floor(this.d_first / this.d_rows);
    },
    pageCount: function() {
      return Math.ceil(this.totalRecords / this.d_rows);
    },
    isFirstPage: function() {
      return this.page === 0;
    },
    isLastPage: function() {
      return this.page === this.pageCount - 1;
    },
    calculatePageLinkBoundaries: function() {
      var t = this.pageCount, n = Math.min(this.pageLinkSize, t), i = Math.max(0, Math.ceil(this.page - n / 2)), o = Math.min(t - 1, i + n - 1), a = this.pageLinkSize - (o - i + 1);
      return i = Math.max(0, i - a), [i, o];
    },
    pageLinks: function() {
      for (var t = [], n = this.calculatePageLinkBoundaries, i = n[0], o = n[1], a = i; a <= o; a++)
        t.push(a + 1);
      return t;
    },
    currentState: function() {
      return {
        page: this.page,
        first: this.d_first,
        rows: this.d_rows
      };
    },
    empty: function() {
      return this.pageCount === 0;
    },
    currentPage: function() {
      return this.pageCount > 0 ? this.page + 1 : 0;
    },
    attributeSelector: function() {
      return Mt();
    }
  },
  components: {
    CurrentPageReport: _w,
    FirstPageLink: Mw,
    LastPageLink: Ew,
    NextPageLink: Dw,
    PageLinks: Rw,
    PrevPageLink: Nw,
    RowsPerPageDropdown: $w,
    JumpToPageDropdown: Ow,
    JumpToPageInput: Bw
  }
};
function GB(e, t, n, i, o, a) {
  var r = $e("FirstPageLink"), s = $e("PrevPageLink"), l = $e("NextPageLink"), d = $e("LastPageLink"), y = $e("PageLinks"), u = $e("CurrentPageReport"), m = $e("RowsPerPageDropdown"), h = $e("JumpToPageDropdown"), c = $e("JumpToPageInput");
  return e.alwaysShow || a.pageLinks && a.pageLinks.length > 1 ? (E(), X("nav", si(Ce({
    key: 0
  }, e.ptm("paginatorWrapper"))), [(E(!0), X(Re, null, Ge(a.templateItems, function(g, v) {
    return E(), X("div", Ce({
      key: v,
      ref_for: !0,
      ref: "paginator",
      class: e.cx("paginator", {
        key: v
      })
    }, e.ptm("root"), {
      "data-pc-name": "paginator"
    }), [e.$slots.start ? (E(), X("div", Ce({
      key: 0,
      class: e.cx("start")
    }, e.ptm("start")), [je(e.$slots, "start", {
      state: a.currentState
    })], 16)) : te("", !0), (E(!0), X(Re, null, Ge(g, function(P) {
      return E(), X(Re, {
        key: P
      }, [P === "FirstPageLink" ? (E(), fe(r, {
        key: 0,
        "aria-label": a.getAriaLabel("firstPageLabel"),
        template: e.$slots.firstpagelinkicon,
        onClick: t[0] || (t[0] = function(f) {
          return a.changePageToFirst(f);
        }),
        disabled: a.isFirstPage || a.empty,
        unstyled: e.unstyled,
        pt: e.pt
      }, null, 8, ["aria-label", "template", "disabled", "unstyled", "pt"])) : P === "PrevPageLink" ? (E(), fe(s, {
        key: 1,
        "aria-label": a.getAriaLabel("prevPageLabel"),
        template: e.$slots.prevpagelinkicon,
        onClick: t[1] || (t[1] = function(f) {
          return a.changePageToPrev(f);
        }),
        disabled: a.isFirstPage || a.empty,
        unstyled: e.unstyled,
        pt: e.pt
      }, null, 8, ["aria-label", "template", "disabled", "unstyled", "pt"])) : P === "NextPageLink" ? (E(), fe(l, {
        key: 2,
        "aria-label": a.getAriaLabel("nextPageLabel"),
        template: e.$slots.nextpagelinkicon,
        onClick: t[2] || (t[2] = function(f) {
          return a.changePageToNext(f);
        }),
        disabled: a.isLastPage || a.empty,
        unstyled: e.unstyled,
        pt: e.pt
      }, null, 8, ["aria-label", "template", "disabled", "unstyled", "pt"])) : P === "LastPageLink" ? (E(), fe(d, {
        key: 3,
        "aria-label": a.getAriaLabel("lastPageLabel"),
        template: e.$slots.lastpagelinkicon,
        onClick: t[3] || (t[3] = function(f) {
          return a.changePageToLast(f);
        }),
        disabled: a.isLastPage || a.empty,
        unstyled: e.unstyled,
        pt: e.pt
      }, null, 8, ["aria-label", "template", "disabled", "unstyled", "pt"])) : P === "PageLinks" ? (E(), fe(y, {
        key: 4,
        "aria-label": a.getAriaLabel("pageLabel"),
        value: a.pageLinks,
        page: a.page,
        onClick: t[4] || (t[4] = function(f) {
          return a.changePageLink(f);
        }),
        pt: e.pt
      }, null, 8, ["aria-label", "value", "page", "pt"])) : P === "CurrentPageReport" ? (E(), fe(u, {
        key: 5,
        "aria-live": "polite",
        template: e.currentPageReportTemplate,
        currentPage: a.currentPage,
        page: a.page,
        pageCount: a.pageCount,
        first: o.d_first,
        rows: o.d_rows,
        totalRecords: e.totalRecords,
        unstyled: e.unstyled,
        pt: e.pt
      }, null, 8, ["template", "currentPage", "page", "pageCount", "first", "rows", "totalRecords", "unstyled", "pt"])) : P === "RowsPerPageDropdown" && e.rowsPerPageOptions ? (E(), fe(m, {
        key: 6,
        "aria-label": a.getAriaLabel("rowsPerPageLabel"),
        rows: o.d_rows,
        options: e.rowsPerPageOptions,
        onRowsChange: t[5] || (t[5] = function(f) {
          return a.onRowChange(f);
        }),
        disabled: a.empty,
        templates: e.$slots,
        unstyled: e.unstyled,
        pt: e.pt
      }, null, 8, ["aria-label", "rows", "options", "disabled", "templates", "unstyled", "pt"])) : P === "JumpToPageDropdown" ? (E(), fe(h, {
        key: 7,
        "aria-label": a.getAriaLabel("jumpToPageDropdownLabel"),
        page: a.page,
        pageCount: a.pageCount,
        onPageChange: t[6] || (t[6] = function(f) {
          return a.changePage(f);
        }),
        disabled: a.empty,
        templates: e.$slots,
        unstyled: e.unstyled,
        pt: e.pt
      }, null, 8, ["aria-label", "page", "pageCount", "disabled", "templates", "unstyled", "pt"])) : P === "JumpToPageInput" ? (E(), fe(c, {
        key: 8,
        page: a.currentPage,
        onPageChange: t[7] || (t[7] = function(f) {
          return a.changePage(f);
        }),
        disabled: a.empty,
        unstyled: e.unstyled,
        pt: e.pt
      }, null, 8, ["page", "disabled", "unstyled", "pt"])) : te("", !0)], 64);
    }), 128)), e.$slots.end ? (E(), X("div", Ce({
      key: 1,
      class: e.cx("end")
    }, e.ptm("end")), [je(e.$slots, "end", {
      state: a.currentState
    })], 16)) : te("", !0)], 16);
  }), 128))], 16)) : te("", !0);
}
_m.render = GB;
var UB = `
@layer primevue {
    .p-datatable {
        position: relative;
    }

    .p-datatable-table {
        border-spacing: 0px;
        width: 100%;
    }

    .p-datatable .p-sortable-column {
        cursor: pointer;
        user-select: none;
    }

    .p-datatable .p-sortable-column .p-column-title,
    .p-datatable .p-sortable-column .p-sortable-column-icon,
    .p-datatable .p-sortable-column .p-sortable-column-badge {
        vertical-align: middle;
    }

    .p-datatable .p-sortable-column .p-sortable-column-badge {
        display: inline-flex;
        align-items: center;
        justify-content: center;
    }

    .p-datatable-hoverable-rows .p-selectable-row {
        cursor: pointer;
    }

    /* Scrollable */
    .p-datatable-scrollable > .p-datatable-wrapper {
        position: relative;
    }

    .p-datatable-scrollable-table > .p-datatable-thead {
        top: 0;
        z-index: 1;
    }

    .p-datatable-scrollable-table > .p-datatable-frozen-tbody {
        position: sticky;
        z-index: 1;
    }

    .p-datatable-scrollable-table > .p-datatable-tfoot {
        bottom: 0;
        z-index: 1;
    }

    .p-datatable-scrollable .p-frozen-column {
        position: sticky;
        background: inherit;
    }

    .p-datatable-scrollable th.p-frozen-column {
        z-index: 1;
    }

    .p-datatable-flex-scrollable {
        display: flex;
        flex-direction: column;
        height: 100%;
    }

    .p-datatable-flex-scrollable > .p-datatable-wrapper {
        display: flex;
        flex-direction: column;
        flex: 1;
        height: 100%;
    }

    .p-datatable-scrollable-table > .p-datatable-tbody > .p-rowgroup-header {
        position: sticky;
        z-index: 1;
    }

    /* Resizable */
    .p-datatable-resizable-table > .p-datatable-thead > tr > th,
    .p-datatable-resizable-table > .p-datatable-tfoot > tr > td,
    .p-datatable-resizable-table > .p-datatable-tbody > tr > td {
        overflow: hidden;
        white-space: nowrap;
    }

    .p-datatable-resizable-table > .p-datatable-thead > tr > th.p-resizable-column:not(.p-frozen-column) {
        background-clip: padding-box;
        position: relative;
    }

    .p-datatable-resizable-table-fit > .p-datatable-thead > tr > th.p-resizable-column:last-child .p-column-resizer {
        display: none;
    }

    .p-datatable .p-column-resizer {
        display: block;
        position: absolute;
        top: 0;
        right: 0;
        margin: 0;
        width: 0.5rem;
        height: 100%;
        padding: 0px;
        cursor: col-resize;
        border: 1px solid transparent;
    }

    .p-datatable .p-column-header-content {
        display: flex;
        align-items: center;
    }

    .p-datatable .p-column-resizer-helper {
        width: 1px;
        position: absolute;
        z-index: 10;
        display: none;
    }

    .p-datatable .p-row-editor-init,
    .p-datatable .p-row-editor-save,
    .p-datatable .p-row-editor-cancel {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        overflow: hidden;
        position: relative;
    }

    /* Expand */
    .p-datatable .p-row-toggler {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        overflow: hidden;
        position: relative;
    }

    /* Reorder */
    .p-datatable-reorder-indicator-up,
    .p-datatable-reorder-indicator-down {
        position: absolute;
        display: none;
    }

    .p-reorderable-column,
    .p-datatable-reorderablerow-handle {
        cursor: move;
    }

    /* Loader */
    .p-datatable .p-datatable-loading-overlay {
        position: absolute;
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 2;
    }

    /* Filter */
    .p-column-filter-row {
        display: flex;
        align-items: center;
        width: 100%;
    }

    .p-column-filter-menu {
        display: inline-flex;
        margin-left: auto;
    }

    .p-column-filter-row .p-column-filter-element {
        flex: 1 1 auto;
        width: 1%;
    }

    .p-column-filter-menu-button,
    .p-column-filter-clear-button {
        display: inline-flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        text-decoration: none;
        overflow: hidden;
        position: relative;
    }

    .p-column-filter-row-items {
        margin: 0;
        padding: 0;
        list-style: none;
    }

    .p-column-filter-row-item {
        cursor: pointer;
    }

    .p-column-filter-add-button,
    .p-column-filter-remove-button {
        justify-content: center;
    }

    .p-column-filter-add-button .p-button-label,
    .p-column-filter-remove-button .p-button-label {
        flex-grow: 0;
    }

    .p-column-filter-buttonbar {
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    .p-column-filter-buttonbar .p-button:not(.p-button-icon-only) {
        width: auto;
    }

    /* Responsive */
    .p-datatable .p-datatable-tbody > tr > td > .p-column-title {
        display: none;
    }

    /* VirtualScroller */
    .p-datatable-virtualscroller-spacer {
        display: flex;
    }

    .p-datatable .p-virtualscroller .p-virtualscroller-loading {
        transform: none !important;
        min-height: 0;
        position: sticky;
        top: 0;
        left: 0;
    }
}
`, WB = {
  root: function(t) {
    var n = t.instance, i = t.props;
    return ["p-datatable p-component", {
      "p-datatable-hoverable-rows": i.rowHover || i.selectionMode,
      "p-datatable-resizable": i.resizableColumns,
      "p-datatable-resizable-fit": i.resizableColumns && i.columnResizeMode === "fit",
      "p-datatable-scrollable": i.scrollable,
      "p-datatable-flex-scrollable": i.scrollable && i.scrollHeight === "flex",
      "p-datatable-responsive-stack": i.responsiveLayout === "stack",
      "p-datatable-responsive-scroll": i.responsiveLayout === "scroll",
      "p-datatable-striped": i.stripedRows,
      "p-datatable-gridlines": i.showGridlines,
      "p-datatable-grouped-header": n.headerColumnGroup != null,
      "p-datatable-grouped-footer": n.footerColumnGroup != null,
      "p-datatable-sm": i.size === "small",
      "p-datatable-lg": i.size === "large"
    }];
  },
  loadingOverlay: "p-datatable-loading-overlay p-component-overlay",
  loadingIcon: "p-datatable-loading-icon",
  header: "p-datatable-header",
  paginator: function(t) {
    var n = t.instance;
    return n.paginatorTop ? "p-paginator-top" : n.paginatorBottom ? "p-paginator-bottom" : "";
  },
  wrapper: "p-datatable-wrapper",
  table: function(t) {
    var n = t.props;
    return ["p-datatable-table", {
      "p-datatable-scrollable-table": n.scrollable,
      "p-datatable-resizable-table": n.resizableColumns,
      "p-datatable-resizable-table-fit": n.resizableColumns && n.columnResizeMode === "fit"
    }];
  },
  //tablehead
  thead: "p-datatable-thead",
  // headercell
  headerCell: function(t) {
    var n = t.instance, i = t.props, o = t.column;
    return o && !n.columnProp(o, "hidden") && (i.rowGroupMode !== "subheader" || i.groupRowsBy !== n.columnProp(o, "field")) ? ["p-filter-column", {
      "p-frozen-column": n.columnProp(o, "frozen")
    }] : [{
      "p-sortable-column": n.columnProp("sortable"),
      "p-resizable-column": n.resizableColumns,
      "p-highlight": n.isColumnSorted(),
      "p-filter-column": i.filterColumn,
      "p-frozen-column": n.columnProp("frozen"),
      "p-reorderable-column": i.reorderableColumns
    }];
  },
  columnResizer: "p-column-resizer",
  headerContent: "p-column-header-content",
  headerTitle: "p-column-title",
  sortIcon: "p-sortable-column-icon",
  sortBadge: "p-sortable-column-badge",
  //headercheckbox
  headerCheckboxWrapper: function(t) {
    var n = t.instance;
    return ["p-checkbox p-component", {
      "p-checkbox-focused": n.focused,
      "p-disabled": n.disabled
    }];
  },
  headerCheckbox: function(t) {
    var n = t.instance;
    return ["p-checkbox-box p-component", {
      "p-highlight": n.checked,
      "p-disabled": n.disabled,
      "p-focus": n.focused
    }];
  },
  headerCheckboxIcon: "p-checkbox-icon",
  // columnfilter
  columnFilter: function(t) {
    var n = t.props;
    return ["p-column-filter p-fluid", {
      "p-column-filter-row": n.display === "row",
      "p-column-filter-menu": n.display === "menu"
    }];
  },
  filterInput: "p-fluid p-column-filter-element",
  filterMenuButton: function(t) {
    var n = t.instance;
    return ["p-column-filter-menu-button p-link", {
      "p-column-filter-menu-button-open": n.overlayVisible,
      "p-column-filter-menu-button-active": n.hasFilter()
    }];
  },
  headerFilterClearButton: function(t) {
    var n = t.instance;
    return ["p-column-filter-clear-button p-link", {
      "p-hidden-space": !n.hasRowFilter()
    }];
  },
  filterOverlay: function(t) {
    var n = t.instance, i = t.props;
    return [{
      "p-column-filter-overlay p-component p-fluid": !0,
      "p-column-filter-overlay-menu": i.display === "menu",
      "p-input-filled": n.$primevue.config.inputStyle === "filled",
      "p-ripple-disabled": n.$primevue.config.ripple === !1
    }];
  },
  filterRowItems: "p-column-filter-row-items",
  filterRowItem: function(t) {
    var n = t.instance, i = t.matchMode;
    return ["p-column-filter-row-item", {
      "p-highlight": i && n.isRowMatchModeSelected(i.value)
    }];
  },
  filterSeparator: "p-column-filter-separator",
  filterOperator: "p-column-filter-operator",
  filterOperatorDropdown: "p-column-filter-operator-dropdown",
  filterConstraints: "p-column-filter-constraints",
  filterConstraint: "p-column-filter-constraint",
  filterMatchModeDropdown: "p-column-filter-matchmode-dropdown",
  filterRemoveButton: "p-column-filter-remove-button p-button-text p-button-danger p-button-sm",
  filterAddRule: "p-column-filter-add-rule",
  filterAddRuleButton: "p-column-filter-add-button p-button-text p-button-sm",
  filterButtonbar: "p-column-filter-buttonbar",
  filterClearButton: "p-button-outlined p-button-sm",
  filterApplyButton: "p-button-sm",
  //tablebody
  tbody: function(t) {
    var n = t.props;
    return n.frozenRow ? "p-datatable-tbody p-datatable-frozen-tbody" : "p-datatable-tbody";
  },
  rowgroupHeader: "p-rowgroup-header",
  rowGroupToggler: "p-row-toggler p-link",
  rowGroupTogglerIcon: "p-row-toggler-icon",
  row: function(t) {
    var n = t.instance, i = t.props, o = t.index, a = [];
    return i.selectionMode && a.push("p-selectable-row"), i.selection && a.push({
      "p-highlight": n.isSelected
    }), i.contextMenuSelection && a.push({
      "p-highlight-contextmenu": n.isSelectedWithContextMenu
    }), a.push(o % 2 === 0 ? "p-row-even" : "p-row-odd"), a;
  },
  rowExpansion: "p-datatable-row-expansion",
  rowgroupFooter: "p-rowgroup-footer",
  emptyMessage: "p-datatable-emptymessage",
  //bodycell
  bodyCell: function(t) {
    var n = t.instance;
    return [{
      "p-selection-column": n.columnProp("selectionMode") != null,
      "p-editable-column": n.isEditable(),
      "p-cell-editing": n.d_editing,
      "p-frozen-column": n.columnProp("frozen")
    }];
  },
  columnTitle: "p-column-title",
  rowReorderIcon: "p-datatable-reorderablerow-handle",
  rowToggler: "p-row-toggler p-link",
  rowTogglerIcon: "p-row-toggler-icon",
  rowEditorInitButton: "p-row-editor-init p-link",
  rowEditorInitIcon: "p-row-editor-init-icon",
  rowEditorSaveButton: "p-row-editor-save p-link",
  rowEditorSaveIcon: "p-row-editor-save-icon",
  rowEditorCancelButton: "p-row-editor-cancel p-link",
  rowEditorCancelIcon: "p-row-editor-cancel-icon",
  //rowcheckbox
  checkboxWrapper: function(t) {
    var n = t.instance;
    return ["p-checkbox p-component", {
      "p-checkbox-focused": n.focused
    }];
  },
  checkbox: function(t) {
    var n = t.instance;
    return ["p-checkbox-box p-component", {
      "p-highlight": n.checked,
      "p-disabled": n.$attrs.disabled,
      "p-focus": n.focused
    }];
  },
  checkboxIcon: "p-checkbox-icon",
  //rowradiobutton
  radiobuttonWrapper: function(t) {
    var n = t.instance;
    return ["p-radiobutton p-component", {
      "p-radiobutton-focused": n.focused
    }];
  },
  radiobutton: function(t) {
    var n = t.instance;
    return ["p-radiobutton-box p-component", {
      "p-highlight": n.checked,
      "p-disabled": n.$attrs.disabled,
      "p-focus": n.focused
    }];
  },
  radiobuttonIcon: "p-radiobutton-icon",
  //tablefooter
  tfoot: "p-datatable-tfoot",
  //footercell
  footerCell: function(t) {
    var n = t.instance;
    return [{
      "p-frozen-column": n.columnProp("frozen")
    }];
  },
  //datatable
  virtualScrollerSpacer: "p-datatable-virtualscroller-spacer",
  footer: "p-datatable-footer",
  resizeHelper: "p-column-resizer-helper",
  reorderIndicatorUp: "p-datatable-reorder-indicator-up",
  reorderIndicatorDown: "p-datatable-reorder-indicator-down"
}, YB = {
  wrapper: {
    overflow: "auto"
  },
  thead: {
    position: "sticky"
  },
  tfoot: {
    position: "sticky"
  }
}, qB = Wt.extend({
  name: "datatable",
  css: UB,
  classes: WB,
  inlineStyles: YB
}), jw = {
  name: "BarsIcon",
  extends: Yt
}, KB = /* @__PURE__ */ oe("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M13.3226 3.6129H0.677419C0.497757 3.6129 0.325452 3.54152 0.198411 3.41448C0.0713707 3.28744 0 3.11514 0 2.93548C0 2.75581 0.0713707 2.58351 0.198411 2.45647C0.325452 2.32943 0.497757 2.25806 0.677419 2.25806H13.3226C13.5022 2.25806 13.6745 2.32943 13.8016 2.45647C13.9286 2.58351 14 2.75581 14 2.93548C14 3.11514 13.9286 3.28744 13.8016 3.41448C13.6745 3.54152 13.5022 3.6129 13.3226 3.6129ZM13.3226 7.67741H0.677419C0.497757 7.67741 0.325452 7.60604 0.198411 7.479C0.0713707 7.35196 0 7.17965 0 6.99999C0 6.82033 0.0713707 6.64802 0.198411 6.52098C0.325452 6.39394 0.497757 6.32257 0.677419 6.32257H13.3226C13.5022 6.32257 13.6745 6.39394 13.8016 6.52098C13.9286 6.64802 14 6.82033 14 6.99999C14 7.17965 13.9286 7.35196 13.8016 7.479C13.6745 7.60604 13.5022 7.67741 13.3226 7.67741ZM0.677419 11.7419H13.3226C13.5022 11.7419 13.6745 11.6706 13.8016 11.5435C13.9286 11.4165 14 11.2442 14 11.0645C14 10.8848 13.9286 10.7125 13.8016 10.5855C13.6745 10.4585 13.5022 10.3871 13.3226 10.3871H0.677419C0.497757 10.3871 0.325452 10.4585 0.198411 10.5855C0.0713707 10.7125 0 10.8848 0 11.0645C0 11.2442 0.0713707 11.4165 0.198411 11.5435C0.325452 11.6706 0.497757 11.7419 0.677419 11.7419Z",
  fill: "currentColor"
}, null, -1), XB = [KB];
function ZB(e, t, n, i, o, a) {
  return E(), X("svg", Ce({
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.pti()), XB, 16);
}
jw.render = ZB;
var Oa = {
  name: "CheckIcon",
  extends: Yt
}, JB = /* @__PURE__ */ oe("path", {
  d: "M4.86199 11.5948C4.78717 11.5923 4.71366 11.5745 4.64596 11.5426C4.57826 11.5107 4.51779 11.4652 4.46827 11.4091L0.753985 7.69483C0.683167 7.64891 0.623706 7.58751 0.580092 7.51525C0.536478 7.44299 0.509851 7.36177 0.502221 7.27771C0.49459 7.19366 0.506156 7.10897 0.536046 7.03004C0.565935 6.95111 0.613367 6.88 0.674759 6.82208C0.736151 6.76416 0.8099 6.72095 0.890436 6.69571C0.970973 6.67046 1.05619 6.66385 1.13966 6.67635C1.22313 6.68886 1.30266 6.72017 1.37226 6.76792C1.44186 6.81567 1.4997 6.8786 1.54141 6.95197L4.86199 10.2503L12.6397 2.49483C12.7444 2.42694 12.8689 2.39617 12.9932 2.40745C13.1174 2.41873 13.2343 2.47141 13.3251 2.55705C13.4159 2.64268 13.4753 2.75632 13.4938 2.87973C13.5123 3.00315 13.4888 3.1292 13.4271 3.23768L5.2557 11.4091C5.20618 11.4652 5.14571 11.5107 5.07801 11.5426C5.01031 11.5745 4.9368 11.5923 4.86199 11.5948Z",
  fill: "currentColor"
}, null, -1), QB = [JB];
function eE(e, t, n, i, o, a) {
  return E(), X("svg", Ce({
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.pti()), QB, 16);
}
Oa.render = eE;
var Hw = {
  name: "PencilIcon",
  extends: Yt,
  computed: {
    pathId: function() {
      return "pv_icon_clip_".concat(Mt());
    }
  }
}, tE = ["clip-path"], nE = /* @__PURE__ */ oe("path", {
  d: "M0.609628 13.959C0.530658 13.9599 0.452305 13.9451 0.379077 13.9156C0.305849 13.8861 0.239191 13.8424 0.18294 13.787C0.118447 13.7234 0.0688234 13.6464 0.0376166 13.5614C0.00640987 13.4765 -0.00560954 13.3857 0.00241768 13.2956L0.25679 10.1501C0.267698 10.0041 0.331934 9.86709 0.437312 9.76516L9.51265 0.705715C10.0183 0.233014 10.6911 -0.0203041 11.3835 0.00127367C12.0714 0.00660201 12.7315 0.27311 13.2298 0.746671C13.7076 1.23651 13.9824 1.88848 13.9992 2.57201C14.0159 3.25554 13.7733 3.92015 13.32 4.4327L4.23648 13.5331C4.13482 13.6342 4.0017 13.6978 3.85903 13.7133L0.667067 14L0.609628 13.959ZM1.43018 10.4696L1.25787 12.714L3.50619 12.5092L12.4502 3.56444C12.6246 3.35841 12.7361 3.10674 12.7714 2.83933C12.8067 2.57193 12.7644 2.30002 12.6495 2.05591C12.5346 1.8118 12.3519 1.60575 12.1231 1.46224C11.8943 1.31873 11.6291 1.2438 11.3589 1.24633C11.1813 1.23508 11.0033 1.25975 10.8355 1.31887C10.6677 1.37798 10.5136 1.47033 10.3824 1.59036L1.43018 10.4696Z",
  fill: "currentColor"
}, null, -1), iE = [nE], aE = ["id"], oE = /* @__PURE__ */ oe("rect", {
  width: "14",
  height: "14",
  fill: "white"
}, null, -1), rE = [oE];
function sE(e, t, n, i, o, a) {
  return E(), X("svg", Ce({
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.pti()), [oe("g", {
    "clip-path": "url(#".concat(a.pathId, ")")
  }, iE, 8, tE), oe("defs", null, [oe("clipPath", {
    id: "".concat(a.pathId)
  }, rE, 8, aE)])], 16);
}
Hw.render = sE;
var lE = {}, cE = tn.extend({
  style: lE
}), qu = cE.extend("focustrap", {
  mounted: function(t, n) {
    var i = n.value || {}, o = i.disabled;
    o || (this.createHiddenFocusableElements(t, n), this.bind(t, n), this.autoFocus(t, n)), t.setAttribute("data-pd-focustrap", !0), this.$el = t;
  },
  updated: function(t, n) {
    var i = n.value || {}, o = i.disabled;
    o && this.unbind(t);
  },
  unmounted: function(t) {
    this.unbind(t);
  },
  methods: {
    getComputedSelector: function(t) {
      return ':not(.p-hidden-focusable):not([data-p-hidden-focusable="true"])'.concat(t ?? "");
    },
    bind: function(t, n) {
      var i = this, o = n.value || {}, a = o.onFocusIn, r = o.onFocusOut;
      t.$_pfocustrap_mutationobserver = new MutationObserver(function(s) {
        s.forEach(function(l) {
          if (l.type === "childList" && !t.contains(document.activeElement)) {
            var d = function y(u) {
              var m = Oe.isFocusableElement(u) ? Oe.isFocusableElement(u, i.getComputedSelector(t.$_pfocustrap_focusableselector)) ? u : Oe.getFirstFocusableElement(t, i.getComputedSelector(t.$_pfocustrap_focusableselector)) : Oe.getFirstFocusableElement(u);
              return We.isNotEmpty(m) ? m : u.nextSibling && y(u.nextSibling);
            };
            Oe.focus(d(l.nextSibling));
          }
        });
      }), t.$_pfocustrap_mutationobserver.disconnect(), t.$_pfocustrap_mutationobserver.observe(t, {
        childList: !0
      }), t.$_pfocustrap_focusinlistener = function(s) {
        return a && a(s);
      }, t.$_pfocustrap_focusoutlistener = function(s) {
        return r && r(s);
      }, t.addEventListener("focusin", t.$_pfocustrap_focusinlistener), t.addEventListener("focusout", t.$_pfocustrap_focusoutlistener);
    },
    unbind: function(t) {
      t.$_pfocustrap_mutationobserver && t.$_pfocustrap_mutationobserver.disconnect(), t.$_pfocustrap_focusinlistener && t.removeEventListener("focusin", t.$_pfocustrap_focusinlistener) && (t.$_pfocustrap_focusinlistener = null), t.$_pfocustrap_focusoutlistener && t.removeEventListener("focusout", t.$_pfocustrap_focusoutlistener) && (t.$_pfocustrap_focusoutlistener = null);
    },
    autoFocus: function(t, n) {
      var i = n.value || {}, o = i.autoFocusSelector, a = o === void 0 ? "" : o, r = i.firstFocusableSelector, s = r === void 0 ? "" : r, l = i.autoFocus, d = l === void 0 ? !1 : l, y = Oe.getFirstFocusableElement(t, "[autofocus]".concat(this.getComputedSelector(a)));
      d && !y && (y = Oe.getFirstFocusableElement(t, this.getComputedSelector(s))), Oe.focus(y);
    },
    onFirstHiddenElementFocus: function(t) {
      var n, i = t.currentTarget, o = t.relatedTarget, a = o === i.$_pfocustrap_lasthiddenfocusableelement || !((n = this.$el) !== null && n !== void 0 && n.contains(o)) ? Oe.getFirstFocusableElement(i.parentElement, this.getComputedSelector(i.$_pfocustrap_focusableselector)) : i.$_pfocustrap_lasthiddenfocusableelement;
      Oe.focus(a);
    },
    onLastHiddenElementFocus: function(t) {
      var n, i = t.currentTarget, o = t.relatedTarget, a = o === i.$_pfocustrap_firsthiddenfocusableelement || !((n = this.$el) !== null && n !== void 0 && n.contains(o)) ? Oe.getLastFocusableElement(i.parentElement, this.getComputedSelector(i.$_pfocustrap_focusableselector)) : i.$_pfocustrap_firsthiddenfocusableelement;
      Oe.focus(a);
    },
    createHiddenFocusableElements: function(t, n) {
      var i = this, o = n.value || {}, a = o.tabIndex, r = a === void 0 ? 0 : a, s = o.firstFocusableSelector, l = s === void 0 ? "" : s, d = o.lastFocusableSelector, y = d === void 0 ? "" : d, u = function(g) {
        return Oe.createElement("span", {
          class: "p-hidden-accessible p-hidden-focusable",
          tabIndex: r,
          role: "presentation",
          "aria-hidden": !0,
          "data-p-hidden-accessible": !0,
          "data-p-hidden-focusable": !0,
          onFocus: g?.bind(i)
        });
      }, m = u(this.onFirstHiddenElementFocus), h = u(this.onLastHiddenElementFocus);
      m.$_pfocustrap_lasthiddenfocusableelement = h, m.$_pfocustrap_focusableselector = l, m.setAttribute("data-pc-section", "firstfocusableelement"), h.$_pfocustrap_firsthiddenfocusableelement = m, h.$_pfocustrap_focusableselector = y, h.setAttribute("data-pc-section", "lastfocusableelement"), t.prepend(m), t.append(h);
    }
  }
}), zw = {
  name: "FilterSlashIcon",
  extends: Yt,
  computed: {
    pathId: function() {
      return "pv_icon_clip_".concat(Mt());
    }
  }
}, dE = ["clip-path"], uE = /* @__PURE__ */ oe("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M13.4994 0.0920138C13.5967 0.151519 13.6758 0.236453 13.7283 0.337647C13.7807 0.439133 13.8031 0.553448 13.7929 0.667208C13.7827 0.780968 13.7403 0.889466 13.6707 0.98L11.406 4.06823C11.3099 4.19928 11.1656 4.28679 11.005 4.3115C10.8444 4.33621 10.6805 4.2961 10.5495 4.2C10.4184 4.1039 10.3309 3.95967 10.3062 3.79905C10.2815 3.63843 10.3216 3.47458 10.4177 3.34353L11.9412 1.23529H7.41184C7.24803 1.23529 7.09093 1.17022 6.97509 1.05439C6.85926 0.938558 6.79419 0.781457 6.79419 0.617647C6.79419 0.453837 6.85926 0.296736 6.97509 0.180905C7.09093 0.0650733 7.24803 0 7.41184 0H13.1765C13.2905 0.000692754 13.4022 0.0325088 13.4994 0.0920138ZM4.20008 0.181168H4.24126L13.2013 9.03411C13.3169 9.14992 13.3819 9.3069 13.3819 9.47058C13.3819 9.63426 13.3169 9.79124 13.2013 9.90705C13.1445 9.96517 13.0766 10.0112 13.0016 10.0423C12.9266 10.0735 12.846 10.0891 12.7648 10.0882C12.6836 10.0886 12.6032 10.0728 12.5283 10.0417C12.4533 10.0106 12.3853 9.96479 12.3283 9.90705L9.3142 6.92587L9.26479 6.99999V13.3823C9.26265 13.5455 9.19689 13.7014 9.08152 13.8167C8.96615 13.9321 8.81029 13.9979 8.64714 14H5.35302C5.18987 13.9979 5.03401 13.9321 4.91864 13.8167C4.80327 13.7014 4.73751 13.5455 4.73537 13.3823V6.99999L0.329492 1.02117C0.259855 0.930634 0.21745 0.822137 0.207241 0.708376C0.197031 0.594616 0.21944 0.480301 0.271844 0.378815C0.324343 0.277621 0.403484 0.192687 0.500724 0.133182C0.597964 0.073677 0.709609 0.041861 0.823609 0.0411682H3.86243C3.92448 0.0461551 3.9855 0.060022 4.04361 0.0823446C4.10037 0.10735 4.15311 0.140655 4.20008 0.181168ZM8.02949 6.79411C8.02884 6.66289 8.07235 6.53526 8.15302 6.43176L8.42478 6.05293L3.55773 1.23529H2.0589L5.84714 6.43176C5.92781 6.53526 5.97132 6.66289 5.97067 6.79411V12.7647H8.02949V6.79411Z",
  fill: "currentColor"
}, null, -1), hE = [uE], pE = ["id"], fE = /* @__PURE__ */ oe("rect", {
  width: "14",
  height: "14",
  fill: "white"
}, null, -1), mE = [fE];
function gE(e, t, n, i, o, a) {
  return E(), X("svg", Ce({
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.pti()), [oe("g", {
    "clip-path": "url(#".concat(a.pathId, ")")
  }, hE, 8, dE), oe("defs", null, [oe("clipPath", {
    id: "".concat(a.pathId)
  }, mE, 8, pE)])], 16);
}
zw.render = gE;
var Vw = {
  name: "PlusIcon",
  extends: Yt,
  computed: {
    pathId: function() {
      return "pv_icon_clip_".concat(Mt());
    }
  }
}, vE = ["clip-path"], yE = /* @__PURE__ */ oe("path", {
  d: "M7.67742 6.32258V0.677419C7.67742 0.497757 7.60605 0.325452 7.47901 0.198411C7.35197 0.0713707 7.17966 0 7 0C6.82034 0 6.64803 0.0713707 6.52099 0.198411C6.39395 0.325452 6.32258 0.497757 6.32258 0.677419V6.32258H0.677419C0.497757 6.32258 0.325452 6.39395 0.198411 6.52099C0.0713707 6.64803 0 6.82034 0 7C0 7.17966 0.0713707 7.35197 0.198411 7.47901C0.325452 7.60605 0.497757 7.67742 0.677419 7.67742H6.32258V13.3226C6.32492 13.5015 6.39704 13.6725 6.52358 13.799C6.65012 13.9255 6.82106 13.9977 7 14C7.17966 14 7.35197 13.9286 7.47901 13.8016C7.60605 13.6745 7.67742 13.5022 7.67742 13.3226V7.67742H13.3226C13.5022 7.67742 13.6745 7.60605 13.8016 7.47901C13.9286 7.35197 14 7.17966 14 7C13.9977 6.82106 13.9255 6.65012 13.799 6.52358C13.6725 6.39704 13.5015 6.32492 13.3226 6.32258H7.67742Z",
  fill: "currentColor"
}, null, -1), bE = [yE], xE = ["id"], wE = /* @__PURE__ */ oe("rect", {
  width: "14",
  height: "14",
  fill: "white"
}, null, -1), kE = [wE];
function SE(e, t, n, i, o, a) {
  return E(), X("svg", Ce({
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.pti()), [oe("g", {
    "clip-path": "url(#".concat(a.pathId, ")")
  }, bE, 8, vE), oe("defs", null, [oe("clipPath", {
    id: "".concat(a.pathId)
  }, kE, 8, xE)])], 16);
}
Vw.render = SE;
var Gw = {
  name: "TrashIcon",
  extends: Yt,
  computed: {
    pathId: function() {
      return "pv_icon_clip_".concat(Mt());
    }
  }
}, CE = ["clip-path"], TE = /* @__PURE__ */ oe("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M3.44802 13.9955H10.552C10.8056 14.0129 11.06 13.9797 11.3006 13.898C11.5412 13.8163 11.7632 13.6877 11.9537 13.5196C12.1442 13.3515 12.2995 13.1473 12.4104 12.9188C12.5213 12.6903 12.5858 12.442 12.6 12.1884V4.36041H13.4C13.5591 4.36041 13.7117 4.29722 13.8243 4.18476C13.9368 4.07229 14 3.91976 14 3.76071C14 3.60166 13.9368 3.44912 13.8243 3.33666C13.7117 3.22419 13.5591 3.16101 13.4 3.16101H12.0537C12.0203 3.1557 11.9863 3.15299 11.952 3.15299C11.9178 3.15299 11.8838 3.1557 11.8503 3.16101H11.2285C11.2421 3.10893 11.2487 3.05513 11.248 3.00106V1.80966C11.2171 1.30262 10.9871 0.828306 10.608 0.48989C10.229 0.151475 9.73159 -0.0236625 9.22402 0.00257442H4.77602C4.27251 -0.0171866 3.78126 0.160868 3.40746 0.498617C3.03365 0.836366 2.807 1.30697 2.77602 1.80966V3.00106C2.77602 3.0556 2.78346 3.10936 2.79776 3.16101H0.6C0.521207 3.16101 0.443185 3.17652 0.37039 3.20666C0.297595 3.2368 0.231451 3.28097 0.175736 3.33666C0.120021 3.39235 0.0758251 3.45846 0.0456722 3.53121C0.0155194 3.60397 0 3.68196 0 3.76071C0 3.83946 0.0155194 3.91744 0.0456722 3.9902C0.0758251 4.06296 0.120021 4.12907 0.175736 4.18476C0.231451 4.24045 0.297595 4.28462 0.37039 4.31476C0.443185 4.3449 0.521207 4.36041 0.6 4.36041H1.40002V12.1884C1.41426 12.442 1.47871 12.6903 1.58965 12.9188C1.7006 13.1473 1.85582 13.3515 2.04633 13.5196C2.23683 13.6877 2.45882 13.8163 2.69944 13.898C2.94005 13.9797 3.1945 14.0129 3.44802 13.9955ZM2.60002 4.36041H11.304V12.1884C11.304 12.5163 10.952 12.7961 10.504 12.7961H3.40002C2.97602 12.7961 2.60002 12.5163 2.60002 12.1884V4.36041ZM3.95429 3.16101C3.96859 3.10936 3.97602 3.0556 3.97602 3.00106V1.80966C3.97602 1.48183 4.33602 1.20197 4.77602 1.20197H9.24802C9.66403 1.20197 10.048 1.48183 10.048 1.80966V3.00106C10.0473 3.05515 10.054 3.10896 10.0678 3.16101H3.95429ZM5.57571 10.997C5.41731 10.995 5.26597 10.9311 5.15395 10.8191C5.04193 10.7071 4.97808 10.5558 4.97601 10.3973V6.77517C4.97601 6.61612 5.0392 6.46359 5.15166 6.35112C5.26413 6.23866 5.41666 6.17548 5.57571 6.17548C5.73476 6.17548 5.8873 6.23866 5.99976 6.35112C6.11223 6.46359 6.17541 6.61612 6.17541 6.77517V10.3894C6.17647 10.4688 6.16174 10.5476 6.13208 10.6213C6.10241 10.695 6.05841 10.762 6.00261 10.8186C5.94682 10.8751 5.88035 10.92 5.80707 10.9506C5.73378 10.9813 5.65514 10.9971 5.57571 10.997ZM7.99968 10.8214C8.11215 10.9339 8.26468 10.997 8.42373 10.997C8.58351 10.9949 8.73604 10.93 8.84828 10.8163C8.96052 10.7025 9.02345 10.5491 9.02343 10.3894V6.77517C9.02343 6.61612 8.96025 6.46359 8.84778 6.35112C8.73532 6.23866 8.58278 6.17548 8.42373 6.17548C8.26468 6.17548 8.11215 6.23866 7.99968 6.35112C7.88722 6.46359 7.82404 6.61612 7.82404 6.77517V10.3973C7.82404 10.5564 7.88722 10.7089 7.99968 10.8214Z",
  fill: "currentColor"
}, null, -1), LE = [TE], IE = ["id"], PE = /* @__PURE__ */ oe("rect", {
  width: "14",
  height: "14",
  fill: "white"
}, null, -1), AE = [PE];
function _E(e, t, n, i, o, a) {
  return E(), X("svg", Ce({
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.pti()), [oe("g", {
    "clip-path": "url(#".concat(a.pathId, ")")
  }, LE, 8, CE), oe("defs", null, [oe("clipPath", {
    id: "".concat(a.pathId)
  }, AE, 8, IE)])], 16);
}
Gw.render = _E;
var Zp = {
  name: "SortAltIcon",
  extends: Yt,
  computed: {
    pathId: function() {
      return "pv_icon_clip_".concat(Mt());
    }
  }
}, ME = ["clip-path"], OE = /* @__PURE__ */ oe("path", {
  d: "M5.64515 3.61291C5.47353 3.61291 5.30192 3.54968 5.16644 3.4142L3.38708 1.63484L1.60773 3.4142C1.34579 3.67613 0.912244 3.67613 0.650309 3.4142C0.388374 3.15226 0.388374 2.71871 0.650309 2.45678L2.90837 0.198712C3.17031 -0.0632236 3.60386 -0.0632236 3.86579 0.198712L6.12386 2.45678C6.38579 2.71871 6.38579 3.15226 6.12386 3.4142C5.98837 3.54968 5.81676 3.61291 5.64515 3.61291Z",
  fill: "currentColor"
}, null, -1), BE = /* @__PURE__ */ oe("path", {
  d: "M3.38714 14C3.01681 14 2.70972 13.6929 2.70972 13.3226V0.677419C2.70972 0.307097 3.01681 0 3.38714 0C3.75746 0 4.06456 0.307097 4.06456 0.677419V13.3226C4.06456 13.6929 3.75746 14 3.38714 14Z",
  fill: "currentColor"
}, null, -1), EE = /* @__PURE__ */ oe("path", {
  d: "M10.6129 14C10.4413 14 10.2697 13.9368 10.1342 13.8013L7.87611 11.5432C7.61418 11.2813 7.61418 10.8477 7.87611 10.5858C8.13805 10.3239 8.5716 10.3239 8.83353 10.5858L10.6129 12.3652L12.3922 10.5858C12.6542 10.3239 13.0877 10.3239 13.3497 10.5858C13.6116 10.8477 13.6116 11.2813 13.3497 11.5432L11.0916 13.8013C10.9561 13.9368 10.7845 14 10.6129 14Z",
  fill: "currentColor"
}, null, -1), DE = /* @__PURE__ */ oe("path", {
  d: "M10.6129 14C10.2426 14 9.93552 13.6929 9.93552 13.3226V0.677419C9.93552 0.307097 10.2426 0 10.6129 0C10.9833 0 11.2904 0.307097 11.2904 0.677419V13.3226C11.2904 13.6929 10.9832 14 10.6129 14Z",
  fill: "currentColor"
}, null, -1), RE = [OE, BE, EE, DE], NE = ["id"], $E = /* @__PURE__ */ oe("rect", {
  width: "14",
  height: "14",
  fill: "white"
}, null, -1), FE = [$E];
function jE(e, t, n, i, o, a) {
  return E(), X("svg", Ce({
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.pti()), [oe("g", {
    "clip-path": "url(#".concat(a.pathId, ")")
  }, RE, 8, ME), oe("defs", null, [oe("clipPath", {
    id: "".concat(a.pathId)
  }, FE, 8, NE)])], 16);
}
Zp.render = jE;
var Jp = {
  name: "SortAmountDownIcon",
  extends: Yt,
  computed: {
    pathId: function() {
      return "pv_icon_clip_".concat(Mt());
    }
  }
}, HE = ["clip-path"], zE = /* @__PURE__ */ oe("path", {
  d: "M4.93953 10.5858L3.83759 11.6877V0.677419C3.83759 0.307097 3.53049 0 3.16017 0C2.78985 0 2.48275 0.307097 2.48275 0.677419V11.6877L1.38082 10.5858C1.11888 10.3239 0.685331 10.3239 0.423396 10.5858C0.16146 10.8477 0.16146 11.2813 0.423396 11.5432L2.68146 13.8013C2.74469 13.8645 2.81694 13.9097 2.89823 13.9458C2.97952 13.9819 3.06985 14 3.16017 14C3.25049 14 3.33178 13.9819 3.42211 13.9458C3.5034 13.9097 3.57565 13.8645 3.63888 13.8013L5.89694 11.5432C6.15888 11.2813 6.15888 10.8477 5.89694 10.5858C5.63501 10.3239 5.20146 10.3239 4.93953 10.5858ZM13.0957 0H7.22468C6.85436 0 6.54726 0.307097 6.54726 0.677419C6.54726 1.04774 6.85436 1.35484 7.22468 1.35484H13.0957C13.466 1.35484 13.7731 1.04774 13.7731 0.677419C13.7731 0.307097 13.466 0 13.0957 0ZM7.22468 5.41935H9.48275C9.85307 5.41935 10.1602 5.72645 10.1602 6.09677C10.1602 6.4671 9.85307 6.77419 9.48275 6.77419H7.22468C6.85436 6.77419 6.54726 6.4671 6.54726 6.09677C6.54726 5.72645 6.85436 5.41935 7.22468 5.41935ZM7.6763 8.12903H7.22468C6.85436 8.12903 6.54726 8.43613 6.54726 8.80645C6.54726 9.17677 6.85436 9.48387 7.22468 9.48387H7.6763C8.04662 9.48387 8.35372 9.17677 8.35372 8.80645C8.35372 8.43613 8.04662 8.12903 7.6763 8.12903ZM7.22468 2.70968H11.2892C11.6595 2.70968 11.9666 3.01677 11.9666 3.3871C11.9666 3.75742 11.6595 4.06452 11.2892 4.06452H7.22468C6.85436 4.06452 6.54726 3.75742 6.54726 3.3871C6.54726 3.01677 6.85436 2.70968 7.22468 2.70968Z",
  fill: "currentColor"
}, null, -1), VE = [zE], GE = ["id"], UE = /* @__PURE__ */ oe("rect", {
  width: "14",
  height: "14",
  fill: "white"
}, null, -1), WE = [UE];
function YE(e, t, n, i, o, a) {
  return E(), X("svg", Ce({
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.pti()), [oe("g", {
    "clip-path": "url(#".concat(a.pathId, ")")
  }, VE, 8, HE), oe("defs", null, [oe("clipPath", {
    id: "".concat(a.pathId)
  }, WE, 8, GE)])], 16);
}
Jp.render = YE;
var Qp = {
  name: "SortAmountUpAltIcon",
  extends: Yt,
  computed: {
    pathId: function() {
      return "pv_icon_clip_".concat(Mt());
    }
  }
}, qE = ["clip-path"], KE = /* @__PURE__ */ oe("path", {
  d: "M3.63435 0.19871C3.57113 0.135484 3.49887 0.0903226 3.41758 0.0541935C3.255 -0.0180645 3.06532 -0.0180645 2.90274 0.0541935C2.82145 0.0903226 2.74919 0.135484 2.68597 0.19871L0.427901 2.45677C0.165965 2.71871 0.165965 3.15226 0.427901 3.41419C0.689836 3.67613 1.12338 3.67613 1.38532 3.41419L2.48726 2.31226V13.3226C2.48726 13.6929 2.79435 14 3.16467 14C3.535 14 3.84209 13.6929 3.84209 13.3226V2.31226L4.94403 3.41419C5.07951 3.54968 5.25113 3.6129 5.42274 3.6129C5.59435 3.6129 5.76597 3.54968 5.90145 3.41419C6.16338 3.15226 6.16338 2.71871 5.90145 2.45677L3.64338 0.19871H3.63435ZM13.7685 13.3226C13.7685 12.9523 13.4615 12.6452 13.0911 12.6452H7.22016C6.84984 12.6452 6.54274 12.9523 6.54274 13.3226C6.54274 13.6929 6.84984 14 7.22016 14H13.0911C13.4615 14 13.7685 13.6929 13.7685 13.3226ZM7.22016 8.58064C6.84984 8.58064 6.54274 8.27355 6.54274 7.90323C6.54274 7.5329 6.84984 7.22581 7.22016 7.22581H9.47823C9.84855 7.22581 10.1556 7.5329 10.1556 7.90323C10.1556 8.27355 9.84855 8.58064 9.47823 8.58064H7.22016ZM7.22016 5.87097H7.67177C8.0421 5.87097 8.34919 5.56387 8.34919 5.19355C8.34919 4.82323 8.0421 4.51613 7.67177 4.51613H7.22016C6.84984 4.51613 6.54274 4.82323 6.54274 5.19355C6.54274 5.56387 6.84984 5.87097 7.22016 5.87097ZM11.2847 11.2903H7.22016C6.84984 11.2903 6.54274 10.9832 6.54274 10.6129C6.54274 10.2426 6.84984 9.93548 7.22016 9.93548H11.2847C11.655 9.93548 11.9621 10.2426 11.9621 10.6129C11.9621 10.9832 11.655 11.2903 11.2847 11.2903Z",
  fill: "currentColor"
}, null, -1), XE = [KE], ZE = ["id"], JE = /* @__PURE__ */ oe("rect", {
  width: "14",
  height: "14",
  fill: "white"
}, null, -1), QE = [JE];
function eD(e, t, n, i, o, a) {
  return E(), X("svg", Ce({
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.pti()), [oe("g", {
    "clip-path": "url(#".concat(a.pathId, ")")
  }, XE, 8, qE), oe("defs", null, [oe("clipPath", {
    id: "".concat(a.pathId)
  }, QE, 8, ZE)])], 16);
}
Qp.render = eD;
var tD = {
  name: "BaseDataTable",
  extends: wt,
  props: {
    value: {
      type: Array,
      default: null
    },
    dataKey: {
      type: [String, Function],
      default: null
    },
    rows: {
      type: Number,
      default: 0
    },
    first: {
      type: Number,
      default: 0
    },
    totalRecords: {
      type: Number,
      default: 0
    },
    paginator: {
      type: Boolean,
      default: !1
    },
    paginatorPosition: {
      type: String,
      default: "bottom"
    },
    alwaysShowPaginator: {
      type: Boolean,
      default: !0
    },
    paginatorTemplate: {
      type: [Object, String],
      default: "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
    },
    pageLinkSize: {
      type: Number,
      default: 5
    },
    rowsPerPageOptions: {
      type: Array,
      default: null
    },
    currentPageReportTemplate: {
      type: String,
      default: "({currentPage} of {totalPages})"
    },
    lazy: {
      type: Boolean,
      default: !1
    },
    loading: {
      type: Boolean,
      default: !1
    },
    loadingIcon: {
      type: String,
      default: void 0
    },
    sortField: {
      type: [String, Function],
      default: null
    },
    sortOrder: {
      type: Number,
      default: null
    },
    defaultSortOrder: {
      type: Number,
      default: 1
    },
    nullSortOrder: {
      type: Number,
      default: 1
    },
    multiSortMeta: {
      type: Array,
      default: null
    },
    sortMode: {
      type: String,
      default: "single"
    },
    removableSort: {
      type: Boolean,
      default: !1
    },
    filters: {
      type: Object,
      default: null
    },
    filterDisplay: {
      type: String,
      default: null
    },
    globalFilterFields: {
      type: Array,
      default: null
    },
    filterLocale: {
      type: String,
      default: void 0
    },
    selection: {
      type: [Array, Object],
      default: null
    },
    selectionMode: {
      type: String,
      default: null
    },
    compareSelectionBy: {
      type: String,
      default: "deepEquals"
    },
    metaKeySelection: {
      type: Boolean,
      default: !1
    },
    contextMenu: {
      type: Boolean,
      default: !1
    },
    contextMenuSelection: {
      type: Object,
      default: null
    },
    selectAll: {
      type: Boolean,
      default: null
    },
    rowHover: {
      type: Boolean,
      default: !1
    },
    csvSeparator: {
      type: String,
      default: ","
    },
    exportFilename: {
      type: String,
      default: "download"
    },
    exportFunction: {
      type: Function,
      default: null
    },
    resizableColumns: {
      type: Boolean,
      default: !1
    },
    columnResizeMode: {
      type: String,
      default: "fit"
    },
    reorderableColumns: {
      type: Boolean,
      default: !1
    },
    expandedRows: {
      type: [Array, Object],
      default: null
    },
    expandedRowIcon: {
      type: String,
      default: void 0
    },
    collapsedRowIcon: {
      type: String,
      default: void 0
    },
    rowGroupMode: {
      type: String,
      default: null
    },
    groupRowsBy: {
      type: [Array, String, Function],
      default: null
    },
    expandableRowGroups: {
      type: Boolean,
      default: !1
    },
    expandedRowGroups: {
      type: Array,
      default: null
    },
    stateStorage: {
      type: String,
      default: "session"
    },
    stateKey: {
      type: String,
      default: null
    },
    editMode: {
      type: String,
      default: null
    },
    editingRows: {
      type: Array,
      default: null
    },
    rowClass: {
      type: null,
      default: null
    },
    rowStyle: {
      type: null,
      default: null
    },
    scrollable: {
      type: Boolean,
      default: !1
    },
    virtualScrollerOptions: {
      type: Object,
      default: null
    },
    scrollHeight: {
      type: String,
      default: null
    },
    frozenValue: {
      type: Array,
      default: null
    },
    responsiveLayout: {
      type: String,
      default: "scroll"
    },
    breakpoint: {
      type: String,
      default: "960px"
    },
    showGridlines: {
      type: Boolean,
      default: !1
    },
    stripedRows: {
      type: Boolean,
      default: !1
    },
    size: {
      type: String,
      default: null
    },
    tableStyle: {
      type: null,
      default: null
    },
    tableClass: {
      type: String,
      default: null
    },
    tableProps: {
      type: null,
      default: null
    },
    filterInputProps: {
      type: null,
      default: null
    }
  },
  style: qB,
  provide: function() {
    return {
      $parentInstance: this
    };
  }
}, Uw = {
  name: "RowCheckbox",
  hostName: "DataTable",
  extends: wt,
  emits: ["change"],
  props: {
    value: null,
    checked: null,
    column: null,
    rowCheckboxIconTemplate: {
      type: Function,
      default: null
    },
    index: {
      type: Number,
      default: null
    }
  },
  data: function() {
    return {
      focused: !1
    };
  },
  methods: {
    getColumnPT: function(t) {
      var n = {
        props: this.column.props,
        parent: {
          instance: this,
          props: this.$props,
          state: this.$data
        },
        context: {
          index: this.index,
          checked: this.checked,
          focused: this.focused,
          disabled: this.$attrs.disabled
        }
      };
      return Ce(this.ptm("column.".concat(t), {
        column: n
      }), this.ptm("column.".concat(t), n), this.ptmo(this.getColumnProp(), t, n));
    },
    getColumnProp: function() {
      return this.column.props && this.column.props.pt ? this.column.props.pt : void 0;
    },
    onClick: function(t) {
      this.$attrs.disabled || (this.$emit("change", {
        originalEvent: t,
        data: this.value
      }), Oe.focus(this.$refs.input)), t.preventDefault(), t.stopPropagation();
    },
    onFocus: function() {
      this.focused = !0;
    },
    onBlur: function() {
      this.focused = !1;
    },
    onKeydown: function(t) {
      switch (t.code) {
        case "Space": {
          this.onClick(t);
          break;
        }
      }
    }
  },
  computed: {
    checkboxAriaLabel: function() {
      return this.$primevue.config.locale.aria ? this.checked ? this.$primevue.config.locale.aria.selectRow : this.$primevue.config.locale.aria.unselectRow : void 0;
    }
  },
  components: {
    CheckIcon: Oa
  }
}, nD = ["checked", "disabled", "tabindex", "aria-label"];
function iD(e, t, n, i, o, a) {
  var r = $e("CheckIcon");
  return E(), X("div", Ce({
    class: e.cx("checkboxWrapper"),
    onClick: t[3] || (t[3] = function() {
      return a.onClick && a.onClick.apply(a, arguments);
    })
  }, a.getColumnPT("checkboxWrapper")), [oe("div", Ce({
    class: "p-hidden-accessible"
  }, a.getColumnPT("hiddenInputWrapper"), {
    "data-p-hidden-accessible": !0
  }), [oe("input", Ce({
    ref: "input",
    type: "checkbox",
    checked: n.checked,
    disabled: e.$attrs.disabled,
    tabindex: e.$attrs.disabled ? null : "0",
    "aria-label": a.checkboxAriaLabel,
    onFocus: t[0] || (t[0] = function(s) {
      return a.onFocus(s);
    }),
    onBlur: t[1] || (t[1] = function(s) {
      return a.onBlur(s);
    }),
    onKeydown: t[2] || (t[2] = function() {
      return a.onKeydown && a.onKeydown.apply(a, arguments);
    })
  }, a.getColumnPT("hiddenInput")), null, 16, nD)], 16), oe("div", Ce({
    ref: "box",
    class: e.cx("checkbox")
  }, a.getColumnPT("checkbox")), [n.rowCheckboxIconTemplate ? (E(), fe(tt(n.rowCheckboxIconTemplate), {
    key: 0,
    checked: n.checked,
    class: Pe(e.cx("checkboxIcon"))
  }, null, 8, ["checked", "class"])) : !n.rowCheckboxIconTemplate && n.checked ? (E(), fe(r, Ce({
    key: 1,
    class: e.cx("checkboxIcon")
  }, a.getColumnPT("checkboxIcon")), null, 16, ["class"])) : te("", !0)], 16)], 16);
}
Uw.render = iD;
var Ww = {
  name: "RowRadioButton",
  hostName: "DataTable",
  extends: wt,
  inheritAttrs: !1,
  emits: ["change"],
  props: {
    value: null,
    checked: null,
    name: null,
    column: null,
    index: {
      type: Number,
      default: null
    }
  },
  data: function() {
    return {
      focused: !1
    };
  },
  methods: {
    getColumnPT: function(t) {
      var n = {
        props: this.column.props,
        parent: {
          instance: this,
          props: this.$props,
          state: this.$data
        },
        context: {
          index: this.index,
          checked: this.checked,
          focused: this.focused,
          disabled: this.$attrs.disabled
        }
      };
      return Ce(this.ptm("column.".concat(t), {
        column: n
      }), this.ptm("column.".concat(t), n), this.ptmo(this.getColumnProp(), t, n));
    },
    getColumnProp: function() {
      return this.column.props && this.column.props.pt ? this.column.props.pt : void 0;
    },
    onClick: function(t) {
      this.disabled || this.checked || (this.$emit("change", {
        originalEvent: t,
        data: this.value
      }), Oe.focus(this.$refs.input));
    },
    onFocus: function() {
      this.focused = !0;
    },
    onBlur: function() {
      this.focused = !1;
    }
  }
}, aD = ["checked", "disabled", "name"];
function oD(e, t, n, i, o, a) {
  return E(), X("div", Ce({
    class: e.cx("radiobuttonWrapper"),
    onClick: t[3] || (t[3] = function() {
      return a.onClick && a.onClick.apply(a, arguments);
    })
  }, a.getColumnPT("radiobuttonWrapper")), [oe("div", Ce({
    class: "p-hidden-accessible"
  }, a.getColumnPT("hiddenInputWrapper"), {
    "data-p-hidden-accessible": !0
  }), [oe("input", Ce({
    ref: "input",
    type: "radio",
    checked: n.checked,
    disabled: e.$attrs.disabled,
    name: n.name,
    tabindex: "0",
    onFocus: t[0] || (t[0] = function(r) {
      return a.onFocus(r);
    }),
    onBlur: t[1] || (t[1] = function(r) {
      return a.onBlur(r);
    }),
    onKeydown: t[2] || (t[2] = Ze(It(function() {
      return a.onClick && a.onClick.apply(a, arguments);
    }, ["prevent"]), ["space"]))
  }, a.getColumnPT("hiddenInput")), null, 16, aD)], 16), oe("div", Ce({
    ref: "box",
    class: e.cx("radiobutton")
  }, a.getColumnPT("radiobutton")), [oe("div", Ce({
    class: e.cx("radiobuttonIcon")
  }, a.getColumnPT("radiobuttonIcon")), null, 16)], 16)], 16);
}
Ww.render = oD;
var Yw = {
  name: "BodyCell",
  hostName: "DataTable",
  extends: wt,
  emits: ["cell-edit-init", "cell-edit-complete", "cell-edit-cancel", "row-edit-init", "row-edit-save", "row-edit-cancel", "row-toggle", "radio-change", "checkbox-change", "editing-meta-change"],
  props: {
    rowData: {
      type: Object,
      default: null
    },
    column: {
      type: Object,
      default: null
    },
    frozenRow: {
      type: Boolean,
      default: !1
    },
    rowIndex: {
      type: Number,
      default: null
    },
    index: {
      type: Number,
      default: null
    },
    isRowExpanded: {
      type: Boolean,
      default: !1
    },
    selected: {
      type: Boolean,
      default: !1
    },
    editing: {
      type: Boolean,
      default: !1
    },
    editingMeta: {
      type: Object,
      default: null
    },
    editMode: {
      type: String,
      default: null
    },
    responsiveLayout: {
      type: String,
      default: "stack"
    },
    virtualScrollerContentProps: {
      type: Object,
      default: null
    },
    ariaControls: {
      type: String,
      default: null
    },
    name: {
      type: String,
      default: null
    },
    expandedRowIcon: {
      type: String,
      default: null
    },
    collapsedRowIcon: {
      type: String,
      default: null
    }
  },
  documentEditListener: null,
  selfClick: !1,
  overlayEventListener: null,
  data: function() {
    return {
      d_editing: this.editing,
      styleObject: {}
    };
  },
  watch: {
    editing: function(t) {
      this.d_editing = t;
    },
    "$data.d_editing": function(t) {
      this.$emit("editing-meta-change", {
        data: this.rowData,
        field: this.field || "field_".concat(this.index),
        index: this.rowIndex,
        editing: t
      });
    }
  },
  mounted: function() {
    this.columnProp("frozen") && this.updateStickyPosition();
  },
  updated: function() {
    var t = this;
    this.columnProp("frozen") && this.updateStickyPosition(), this.d_editing && (this.editMode === "cell" || this.editMode === "row" && this.columnProp("rowEditor")) && setTimeout(function() {
      var n = Oe.getFirstFocusableElement(t.$el);
      n && n.focus();
    }, 1);
  },
  beforeUnmount: function() {
    this.overlayEventListener && (Zn.off("overlay-click", this.overlayEventListener), this.overlayEventListener = null);
  },
  methods: {
    columnProp: function(t) {
      return We.getVNodeProp(this.column, t);
    },
    getColumnPT: function(t) {
      var n, i, o = {
        props: this.column.props,
        parent: {
          instance: this,
          props: this.$props,
          state: this.$data
        },
        context: {
          index: this.index,
          size: (n = this.$parentInstance) === null || n === void 0 || (n = n.$parentInstance) === null || n === void 0 ? void 0 : n.size,
          showGridlines: (i = this.$parentInstance) === null || i === void 0 || (i = i.$parentInstance) === null || i === void 0 ? void 0 : i.showGridlines
        }
      };
      return Ce(this.ptm("column.".concat(t), {
        column: o
      }), this.ptm("column.".concat(t), o), this.ptmo(this.getColumnProp(), t, o));
    },
    getColumnProp: function() {
      return this.column.props && this.column.props.pt ? this.column.props.pt : void 0;
    },
    resolveFieldData: function() {
      return We.resolveFieldData(this.rowData, this.field);
    },
    toggleRow: function(t) {
      this.$emit("row-toggle", {
        originalEvent: t,
        data: this.rowData
      });
    },
    toggleRowWithRadio: function(t, n) {
      this.$emit("radio-change", {
        originalEvent: t.originalEvent,
        index: n,
        data: t.data
      });
    },
    toggleRowWithCheckbox: function(t, n) {
      this.$emit("checkbox-change", {
        originalEvent: t.originalEvent,
        index: n,
        data: t.data
      });
    },
    isEditable: function() {
      return this.column.children && this.column.children.editor != null;
    },
    bindDocumentEditListener: function() {
      var t = this;
      this.documentEditListener || (this.documentEditListener = function(n) {
        t.selfClick || t.completeEdit(n, "outside"), t.selfClick = !1;
      }, document.addEventListener("click", this.documentEditListener));
    },
    unbindDocumentEditListener: function() {
      this.documentEditListener && (document.removeEventListener("click", this.documentEditListener), this.documentEditListener = null, this.selfClick = !1);
    },
    switchCellToViewMode: function() {
      this.d_editing = !1, this.unbindDocumentEditListener(), Zn.off("overlay-click", this.overlayEventListener), this.overlayEventListener = null;
    },
    onClick: function(t) {
      var n = this;
      this.editMode === "cell" && this.isEditable() && (this.selfClick = !0, this.d_editing || (this.d_editing = !0, this.bindDocumentEditListener(), this.$emit("cell-edit-init", {
        originalEvent: t,
        data: this.rowData,
        field: this.field,
        index: this.rowIndex
      }), this.overlayEventListener = function(i) {
        n.$el && n.$el.contains(i.target) && (n.selfClick = !0);
      }, Zn.on("overlay-click", this.overlayEventListener)));
    },
    completeEdit: function(t, n) {
      var i = {
        originalEvent: t,
        data: this.rowData,
        newData: this.editingRowData,
        value: this.rowData[this.field],
        newValue: this.editingRowData[this.field],
        field: this.field,
        index: this.rowIndex,
        type: n,
        defaultPrevented: !1,
        preventDefault: function() {
          this.defaultPrevented = !0;
        }
      };
      this.$emit("cell-edit-complete", i), i.defaultPrevented || this.switchCellToViewMode();
    },
    onKeyDown: function(t) {
      if (this.editMode === "cell")
        switch (t.code) {
          case "Enter":
          case "NumpadEnter":
            this.completeEdit(t, "enter");
            break;
          case "Escape":
            this.switchCellToViewMode(), this.$emit("cell-edit-cancel", {
              originalEvent: t,
              data: this.rowData,
              field: this.field,
              index: this.rowIndex
            });
            break;
          case "Tab":
            this.completeEdit(t, "tab"), t.shiftKey ? this.moveToPreviousCell(t) : this.moveToNextCell(t);
            break;
        }
    },
    moveToPreviousCell: function(t) {
      var n = this.findCell(t.target), i = this.findPreviousEditableColumn(n);
      i && (Oe.invokeElementMethod(i, "click"), t.preventDefault());
    },
    moveToNextCell: function(t) {
      var n = this.findCell(t.target), i = this.findNextEditableColumn(n);
      i && (Oe.invokeElementMethod(i, "click"), t.preventDefault());
    },
    findCell: function(t) {
      if (t) {
        for (var n = t; n && !Oe.getAttribute(n, "data-p-cell-editing"); )
          n = n.parentElement;
        return n;
      } else
        return null;
    },
    findPreviousEditableColumn: function(t) {
      var n = t.previousElementSibling;
      if (!n) {
        var i = t.parentElement.previousElementSibling;
        i && (n = i.lastElementChild);
      }
      return n ? Oe.getAttribute(n, "data-p-editable-column") ? n : this.findPreviousEditableColumn(n) : null;
    },
    findNextEditableColumn: function(t) {
      var n = t.nextElementSibling;
      if (!n) {
        var i = t.parentElement.nextElementSibling;
        i && (n = i.firstElementChild);
      }
      return n ? Oe.getAttribute(n, "data-p-editable-column") ? n : this.findNextEditableColumn(n) : null;
    },
    isEditingCellValid: function() {
      return Oe.find(this.$el, ".p-invalid").length === 0;
    },
    onRowEditInit: function(t) {
      this.$emit("row-edit-init", {
        originalEvent: t,
        data: this.rowData,
        newData: this.editingRowData,
        field: this.field,
        index: this.rowIndex
      });
    },
    onRowEditSave: function(t) {
      this.$emit("row-edit-save", {
        originalEvent: t,
        data: this.rowData,
        newData: this.editingRowData,
        field: this.field,
        index: this.rowIndex
      });
    },
    onRowEditCancel: function(t) {
      this.$emit("row-edit-cancel", {
        originalEvent: t,
        data: this.rowData,
        newData: this.editingRowData,
        field: this.field,
        index: this.rowIndex
      });
    },
    editorInitCallback: function(t) {
      this.$emit("row-edit-init", {
        originalEvent: t,
        data: this.rowData,
        newData: this.editingRowData,
        field: this.field,
        index: this.rowIndex
      });
    },
    editorSaveCallback: function(t) {
      this.editMode === "row" ? this.$emit("row-edit-save", {
        originalEvent: t,
        data: this.rowData,
        newData: this.editingRowData,
        field: this.field,
        index: this.rowIndex
      }) : this.completeEdit(t, "enter");
    },
    editorCancelCallback: function(t) {
      this.editMode === "row" ? this.$emit("row-edit-cancel", {
        originalEvent: t,
        data: this.rowData,
        newData: this.editingRowData,
        field: this.field,
        index: this.rowIndex
      }) : (this.switchCellToViewMode(), this.$emit("cell-edit-cancel", {
        originalEvent: t,
        data: this.rowData,
        field: this.field,
        index: this.rowIndex
      }));
    },
    updateStickyPosition: function() {
      if (this.columnProp("frozen")) {
        var t = this.columnProp("alignFrozen");
        if (t === "right") {
          var n = 0, i = Oe.getNextElementSibling(this.$el, '[data-p-frozen-column="true"]');
          i && (n = Oe.getOuterWidth(i) + parseFloat(i.style.right || 0)), this.styleObject.right = n + "px";
        } else {
          var o = 0, a = Oe.getPreviousElementSibling(this.$el, '[data-p-frozen-column="true"]');
          a && (o = Oe.getOuterWidth(a) + parseFloat(a.style.left || 0)), this.styleObject.left = o + "px";
        }
      }
    },
    getVirtualScrollerProp: function(t) {
      return this.virtualScrollerContentProps ? this.virtualScrollerContentProps[t] : null;
    }
  },
  computed: {
    editingRowData: function() {
      return this.editingMeta[this.rowIndex] ? this.editingMeta[this.rowIndex].data : this.rowData;
    },
    field: function() {
      return this.columnProp("field");
    },
    containerClass: function() {
      return [this.columnProp("bodyClass"), this.columnProp("class"), this.cx("bodyCell")];
    },
    containerStyle: function() {
      var t = this.columnProp("bodyStyle"), n = this.columnProp("style");
      return this.columnProp("frozen") ? [n, t, this.styleObject] : [n, t];
    },
    loading: function() {
      return this.getVirtualScrollerProp("loading");
    },
    loadingOptions: function() {
      var t = this.getVirtualScrollerProp("getLoaderOptions");
      return t && t(this.rowIndex, {
        cellIndex: this.index,
        cellFirst: this.index === 0,
        cellLast: this.index === this.getVirtualScrollerProp("columns").length - 1,
        cellEven: this.index % 2 === 0,
        cellOdd: this.index % 2 !== 0,
        column: this.column,
        field: this.field
      });
    },
    expandButtonAriaLabel: function() {
      return this.$primevue.config.locale.aria ? this.isRowExpanded ? this.$primevue.config.locale.aria.expandRow : this.$primevue.config.locale.aria.collapseRow : void 0;
    },
    initButtonAriaLabel: function() {
      return this.$primevue.config.locale.aria ? this.$primevue.config.locale.aria.editRow : void 0;
    },
    saveButtonAriaLabel: function() {
      return this.$primevue.config.locale.aria ? this.$primevue.config.locale.aria.saveEdit : void 0;
    },
    cancelButtonAriaLabel: function() {
      return this.$primevue.config.locale.aria ? this.$primevue.config.locale.aria.cancelEdit : void 0;
    }
  },
  components: {
    DTRadioButton: Ww,
    DTCheckbox: Uw,
    ChevronDownIcon: Va,
    ChevronRightIcon: Fo,
    BarsIcon: jw,
    PencilIcon: Hw,
    CheckIcon: Oa,
    TimesIcon: Ho
  },
  directives: {
    ripple: An
  }
};
function Kl(e) {
  "@babel/helpers - typeof";
  return Kl = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Kl(e);
}
function ay(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    t && (i = i.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), n.push.apply(n, i);
  }
  return n;
}
function gd(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? ay(Object(n), !0).forEach(function(i) {
      rD(e, i, n[i]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : ay(Object(n)).forEach(function(i) {
      Object.defineProperty(e, i, Object.getOwnPropertyDescriptor(n, i));
    });
  }
  return e;
}
function rD(e, t, n) {
  return t = sD(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function sD(e) {
  var t = lD(e, "string");
  return Kl(t) == "symbol" ? t : String(t);
}
function lD(e, t) {
  if (Kl(e) != "object" || !e)
    return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var i = n.call(e, t || "default");
    if (Kl(i) != "object")
      return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var cD = ["colspan", "rowspan", "data-p-selection-column", "data-p-editable-column", "data-p-cell-editing", "data-p-frozen-column"], dD = ["aria-expanded", "aria-controls", "aria-label"], uD = ["aria-label"], hD = ["aria-label"], pD = ["aria-label"];
function fD(e, t, n, i, o, a) {
  var r = $e("DTRadioButton"), s = $e("DTCheckbox"), l = $e("BarsIcon"), d = $e("ChevronDownIcon"), y = $e("ChevronRightIcon"), u = Ut("ripple");
  return a.loading ? (E(), X("td", Ce({
    key: 0,
    style: a.containerStyle,
    class: a.containerClass,
    role: "cell"
  }, gd(gd({}, a.getColumnPT("root")), a.getColumnPT("bodyCell"))), [(E(), fe(tt(n.column.children.loading), {
    data: n.rowData,
    column: n.column,
    field: a.field,
    index: n.rowIndex,
    frozenRow: n.frozenRow,
    loadingOptions: a.loadingOptions
  }, null, 8, ["data", "column", "field", "index", "frozenRow", "loadingOptions"]))], 16)) : (E(), X("td", Ce({
    key: 1,
    style: a.containerStyle,
    class: a.containerClass,
    colspan: a.columnProp("colspan"),
    rowspan: a.columnProp("rowspan"),
    onClick: t[6] || (t[6] = function() {
      return a.onClick && a.onClick.apply(a, arguments);
    }),
    onKeydown: t[7] || (t[7] = function() {
      return a.onKeyDown && a.onKeyDown.apply(a, arguments);
    }),
    role: "cell"
  }, gd(gd({}, a.getColumnPT("root")), a.getColumnPT("bodyCell")), {
    "data-p-selection-column": a.columnProp("selectionMode") != null,
    "data-p-editable-column": a.isEditable(),
    "data-p-cell-editing": o.d_editing,
    "data-p-frozen-column": a.columnProp("frozen")
  }), [n.responsiveLayout === "stack" ? (E(), X("span", Ce({
    key: 0,
    class: e.cx("columnTitle")
  }, a.getColumnPT("columnTitle")), Ie(a.columnProp("header")), 17)) : te("", !0), n.column.children && n.column.children.body && !o.d_editing ? (E(), fe(tt(n.column.children.body), {
    key: 1,
    data: n.rowData,
    column: n.column,
    field: a.field,
    index: n.rowIndex,
    frozenRow: n.frozenRow,
    editorInitCallback: a.editorInitCallback
  }, null, 8, ["data", "column", "field", "index", "frozenRow", "editorInitCallback"])) : n.column.children && n.column.children.editor && o.d_editing ? (E(), fe(tt(n.column.children.editor), {
    key: 2,
    data: a.editingRowData,
    column: n.column,
    field: a.field,
    index: n.rowIndex,
    frozenRow: n.frozenRow,
    editorSaveCallback: a.editorSaveCallback,
    editorCancelCallback: a.editorCancelCallback
  }, null, 8, ["data", "column", "field", "index", "frozenRow", "editorSaveCallback", "editorCancelCallback"])) : n.column.children && n.column.children.body && !n.column.children.editor && o.d_editing ? (E(), fe(tt(n.column.children.body), {
    key: 3,
    data: a.editingRowData,
    column: n.column,
    field: a.field,
    index: n.rowIndex,
    frozenRow: n.frozenRow
  }, null, 8, ["data", "column", "field", "index", "frozenRow"])) : a.columnProp("selectionMode") ? (E(), X(Re, {
    key: 4
  }, [a.columnProp("selectionMode") === "single" ? (E(), fe(r, {
    key: 0,
    value: n.rowData,
    name: n.name,
    checked: n.selected,
    onChange: t[0] || (t[0] = function(m) {
      return a.toggleRowWithRadio(m, n.rowIndex);
    }),
    column: n.column,
    index: n.index,
    unstyled: e.unstyled,
    pt: e.pt
  }, null, 8, ["value", "name", "checked", "column", "index", "unstyled", "pt"])) : a.columnProp("selectionMode") === "multiple" ? (E(), fe(s, {
    key: 1,
    value: n.rowData,
    checked: n.selected,
    rowCheckboxIconTemplate: n.column.children && n.column.children.rowcheckboxicon,
    "aria-selected": n.selected ? !0 : void 0,
    onChange: t[1] || (t[1] = function(m) {
      return a.toggleRowWithCheckbox(m, n.rowIndex);
    }),
    column: n.column,
    index: n.index,
    unstyled: e.unstyled,
    pt: e.pt
  }, null, 8, ["value", "checked", "rowCheckboxIconTemplate", "aria-selected", "column", "index", "unstyled", "pt"])) : te("", !0)], 64)) : a.columnProp("rowReorder") ? (E(), X(Re, {
    key: 5
  }, [n.column.children && n.column.children.rowreordericon ? (E(), fe(tt(n.column.children.rowreordericon), {
    key: 0,
    class: Pe(e.cx("rowReorderIcon"))
  }, null, 8, ["class"])) : a.columnProp("rowReorderIcon") ? (E(), X("i", Ce({
    key: 1,
    class: [e.cx("rowReorderIcon"), a.columnProp("rowReorderIcon")]
  }, a.getColumnPT("rowReorderIcon")), null, 16)) : (E(), fe(l, Ce({
    key: 2,
    class: e.cx("rowReorderIcon")
  }, a.getColumnPT("rowReorderIcon")), null, 16, ["class"]))], 64)) : a.columnProp("expander") ? rt((E(), X("button", Ce({
    key: 6,
    class: e.cx("rowToggler"),
    type: "button",
    "aria-expanded": n.isRowExpanded,
    "aria-controls": n.ariaControls,
    "aria-label": a.expandButtonAriaLabel,
    onClick: t[2] || (t[2] = function() {
      return a.toggleRow && a.toggleRow.apply(a, arguments);
    })
  }, a.getColumnPT("rowToggler"), {
    "data-pc-group-section": "rowactionbutton"
  }), [n.column.children && n.column.children.rowtogglericon ? (E(), fe(tt(n.column.children.rowtogglericon), {
    key: 0,
    class: Pe(e.cx("rowTogglerIcon")),
    rowExpanded: n.isRowExpanded
  }, null, 8, ["class", "rowExpanded"])) : (E(), X(Re, {
    key: 1
  }, [n.isRowExpanded && n.expandedRowIcon ? (E(), X("span", {
    key: 0,
    class: Pe([e.cx("rowTogglerIcon"), n.expandedRowIcon])
  }, null, 2)) : n.isRowExpanded && !n.expandedRowIcon ? (E(), fe(d, Ce({
    key: 1,
    class: e.cx("rowTogglerIcon")
  }, a.getColumnPT("rowTogglerIcon")), null, 16, ["class"])) : !n.isRowExpanded && n.collapsedRowIcon ? (E(), X("span", {
    key: 2,
    class: Pe([e.cx("rowTogglerIcon"), n.collapsedRowIcon])
  }, null, 2)) : !n.isRowExpanded && !n.collapsedRowIcon ? (E(), fe(y, Ce({
    key: 3,
    class: e.cx("rowTogglerIcon")
  }, a.getColumnPT("rowTogglerIcon")), null, 16, ["class"])) : te("", !0)], 64))], 16, dD)), [[u]]) : n.editMode === "row" && a.columnProp("rowEditor") ? (E(), X(Re, {
    key: 7
  }, [o.d_editing ? te("", !0) : rt((E(), X("button", Ce({
    key: 0,
    class: e.cx("rowEditorInitButton"),
    type: "button",
    "aria-label": a.initButtonAriaLabel,
    onClick: t[3] || (t[3] = function() {
      return a.onRowEditInit && a.onRowEditInit.apply(a, arguments);
    })
  }, a.getColumnPT("rowEditorInitButton"), {
    "data-pc-group-section": "rowactionbutton"
  }), [(E(), fe(tt(n.column.children && n.column.children.roweditoriniticon || "PencilIcon"), Ce({
    class: e.cx("rowEditorInitIcon")
  }, a.getColumnPT("rowEditorInitIcon")), null, 16, ["class"]))], 16, uD)), [[u]]), o.d_editing ? rt((E(), X("button", Ce({
    key: 1,
    class: e.cx("rowEditorSaveButton"),
    type: "button",
    "aria-label": a.saveButtonAriaLabel,
    onClick: t[4] || (t[4] = function() {
      return a.onRowEditSave && a.onRowEditSave.apply(a, arguments);
    })
  }, a.getColumnPT("rowEditorSaveButton"), {
    "data-pc-group-section": "rowactionbutton"
  }), [(E(), fe(tt(n.column.children && n.column.children.roweditorsaveicon || "CheckIcon"), Ce({
    class: e.cx("rowEditorSaveIcon")
  }, a.getColumnPT("rowEditorSaveIcon")), null, 16, ["class"]))], 16, hD)), [[u]]) : te("", !0), o.d_editing ? rt((E(), X("button", Ce({
    key: 2,
    class: e.cx("rowEditorCancelButton"),
    type: "button",
    "aria-label": a.cancelButtonAriaLabel,
    onClick: t[5] || (t[5] = function() {
      return a.onRowEditCancel && a.onRowEditCancel.apply(a, arguments);
    })
  }, a.getColumnPT("rowEditorCancelButton"), {
    "data-pc-group-section": "rowactionbutton"
  }), [(E(), fe(tt(n.column.children && n.column.children.roweditorcancelicon || "TimesIcon"), Ce({
    class: e.cx("rowEditorCancelIcon")
  }, a.getColumnPT("rowEditorCancelIcon")), null, 16, ["class"]))], 16, pD)), [[u]]) : te("", !0)], 64)) : (E(), X(Re, {
    key: 8
  }, [Ve(Ie(a.resolveFieldData()), 1)], 64))], 16, cD));
}
Yw.render = fD;
function Xl(e) {
  "@babel/helpers - typeof";
  return Xl = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Xl(e);
}
function oy(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    t && (i = i.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), n.push.apply(n, i);
  }
  return n;
}
function ry(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? oy(Object(n), !0).forEach(function(i) {
      mD(e, i, n[i]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : oy(Object(n)).forEach(function(i) {
      Object.defineProperty(e, i, Object.getOwnPropertyDescriptor(n, i));
    });
  }
  return e;
}
function mD(e, t, n) {
  return t = gD(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function gD(e) {
  var t = vD(e, "string");
  return Xl(t) == "symbol" ? t : String(t);
}
function vD(e, t) {
  if (Xl(e) != "object" || !e)
    return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var i = n.call(e, t || "default");
    if (Xl(i) != "object")
      return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var qw = {
  name: "BodyRow",
  hostName: "DataTable",
  extends: wt,
  emits: ["rowgroup-toggle", "row-click", "row-dblclick", "row-rightclick", "row-touchend", "row-keydown", "row-mousedown", "row-dragstart", "row-dragover", "row-dragleave", "row-dragend", "row-drop", "row-toggle", "radio-change", "checkbox-change", "cell-edit-init", "cell-edit-complete", "cell-edit-cancel", "row-edit-init", "row-edit-save", "row-edit-cancel", "editing-meta-change"],
  props: {
    rowData: {
      type: Object,
      default: null
    },
    index: {
      type: Number,
      default: 0
    },
    value: {
      type: Array,
      default: null
    },
    columns: {
      type: null,
      default: null
    },
    frozenRow: {
      type: Boolean,
      default: !1
    },
    empty: {
      type: Boolean,
      default: !1
    },
    rowGroupMode: {
      type: String,
      default: null
    },
    groupRowsBy: {
      type: [Array, String, Function],
      default: null
    },
    expandableRowGroups: {
      type: Boolean,
      default: !1
    },
    expandedRowGroups: {
      type: Array,
      default: null
    },
    first: {
      type: Number,
      default: 0
    },
    dataKey: {
      type: [String, Function],
      default: null
    },
    expandedRowIcon: {
      type: String,
      default: null
    },
    collapsedRowIcon: {
      type: String,
      default: null
    },
    expandedRows: {
      type: [Array, Object],
      default: null
    },
    selection: {
      type: [Array, Object],
      default: null
    },
    selectionKeys: {
      type: null,
      default: null
    },
    selectionMode: {
      type: String,
      default: null
    },
    contextMenu: {
      type: Boolean,
      default: !1
    },
    contextMenuSelection: {
      type: Object,
      default: null
    },
    rowClass: {
      type: null,
      default: null
    },
    rowStyle: {
      type: null,
      default: null
    },
    rowGroupHeaderStyle: {
      type: null,
      default: null
    },
    editMode: {
      type: String,
      default: null
    },
    compareSelectionBy: {
      type: String,
      default: "deepEquals"
    },
    editingRows: {
      type: Array,
      default: null
    },
    editingRowKeys: {
      type: null,
      default: null
    },
    editingMeta: {
      type: Object,
      default: null
    },
    templates: {
      type: null,
      default: null
    },
    scrollable: {
      type: Boolean,
      default: !1
    },
    responsiveLayout: {
      type: String,
      default: "stack"
    },
    virtualScrollerContentProps: {
      type: Object,
      default: null
    },
    isVirtualScrollerDisabled: {
      type: Boolean,
      default: !1
    },
    expandedRowId: {
      type: String,
      default: null
    },
    nameAttributeSelector: {
      type: String,
      default: null
    }
  },
  data: function() {
    return {
      d_rowExpanded: !1
    };
  },
  watch: {
    expandedRows: function(t) {
      var n = this;
      this.d_rowExpanded = this.dataKey ? t?.[We.resolveFieldData(this.rowData, this.dataKey)] !== void 0 : t?.some(function(i) {
        return n.equals(n.rowData, i);
      });
    }
  },
  methods: {
    columnProp: function(t, n) {
      return We.getVNodeProp(t, n);
    },
    //@todo - update this method
    getColumnPT: function(t) {
      var n = {
        parent: {
          instance: this,
          props: this.$props,
          state: this.$data
        }
      };
      return Ce(this.ptm("column.".concat(t), {
        column: n
      }), this.ptm("column.".concat(t), n), this.ptmo(this.columnProp({}, "pt"), t, n));
    },
    //@todo - update this method
    getBodyRowPTOptions: function(t) {
      var n, i = (n = this.$parentInstance) === null || n === void 0 ? void 0 : n.$parentInstance;
      return this.ptm(t, {
        context: {
          index: this.rowIndex,
          selectable: i?.rowHover || i?.selectionMode,
          selected: this.isSelected,
          stripedRows: i?.stripedRows || !1
        }
      });
    },
    shouldRenderBodyCell: function(t) {
      var n = this.columnProp(t, "hidden");
      if (this.rowGroupMode && !n) {
        var i = this.columnProp(t, "field");
        if (this.rowGroupMode === "subheader")
          return this.groupRowsBy !== i;
        if (this.rowGroupMode === "rowspan")
          if (this.isGrouped(t)) {
            var o = this.value[this.rowIndex - 1];
            if (o) {
              var a = We.resolveFieldData(this.value[this.rowIndex], i), r = We.resolveFieldData(o, i);
              return a !== r;
            } else
              return !0;
          } else
            return !0;
      } else
        return !n;
    },
    calculateRowGroupSize: function(t) {
      if (this.isGrouped(t)) {
        for (var n = this.rowIndex, i = this.columnProp(t, "field"), o = We.resolveFieldData(this.value[n], i), a = o, r = 0; o === a; ) {
          r++;
          var s = this.value[++n];
          if (s)
            a = We.resolveFieldData(s, i);
          else
            break;
        }
        return r === 1 ? null : r;
      } else
        return null;
    },
    isGrouped: function(t) {
      var n = this.columnProp(t, "field");
      return this.groupRowsBy && n ? Array.isArray(this.groupRowsBy) ? this.groupRowsBy.indexOf(n) > -1 : this.groupRowsBy === n : !1;
    },
    findIndexInSelection: function(t) {
      return this.findIndex(t, this.selection);
    },
    findIndex: function(t, n) {
      var i = -1;
      if (n && n.length) {
        for (var o = 0; o < n.length; o++)
          if (this.equals(t, n[o])) {
            i = o;
            break;
          }
      }
      return i;
    },
    equals: function(t, n) {
      return this.compareSelectionBy === "equals" ? t === n : We.equals(t, n, this.dataKey);
    },
    onRowGroupToggle: function(t) {
      this.$emit("rowgroup-toggle", {
        originalEvent: t,
        data: this.rowData
      });
    },
    onRowClick: function(t) {
      this.$emit("row-click", {
        originalEvent: t,
        data: this.rowData,
        index: this.rowIndex
      });
    },
    onRowDblClick: function(t) {
      this.$emit("row-dblclick", {
        originalEvent: t,
        data: this.rowData,
        index: this.rowIndex
      });
    },
    onRowRightClick: function(t) {
      this.$emit("row-rightclick", {
        originalEvent: t,
        data: this.rowData,
        index: this.rowIndex
      });
    },
    onRowTouchEnd: function(t) {
      this.$emit("row-touchend", t);
    },
    onRowKeyDown: function(t) {
      this.$emit("row-keydown", {
        originalEvent: t,
        data: this.rowData,
        index: this.rowIndex
      });
    },
    onRowMouseDown: function(t) {
      this.$emit("row-mousedown", t);
    },
    onRowDragStart: function(t) {
      this.$emit("row-dragstart", {
        originalEvent: t,
        index: this.rowIndex
      });
    },
    onRowDragOver: function(t) {
      this.$emit("row-dragover", {
        originalEvent: t,
        index: this.rowIndex
      });
    },
    onRowDragLeave: function(t) {
      this.$emit("row-dragleave", t);
    },
    onRowDragEnd: function(t) {
      this.$emit("row-dragend", t);
    },
    onRowDrop: function(t) {
      this.$emit("row-drop", t);
    },
    onRowToggle: function(t) {
      this.d_rowExpanded = !this.d_rowExpanded, this.$emit("row-toggle", ry(ry({}, t), {}, {
        expanded: this.d_rowExpanded
      }));
    },
    onRadioChange: function(t) {
      this.$emit("radio-change", t);
    },
    onCheckboxChange: function(t) {
      this.$emit("checkbox-change", t);
    },
    onCellEditInit: function(t) {
      this.$emit("cell-edit-init", t);
    },
    onCellEditComplete: function(t) {
      this.$emit("cell-edit-complete", t);
    },
    onCellEditCancel: function(t) {
      this.$emit("cell-edit-cancel", t);
    },
    onRowEditInit: function(t) {
      this.$emit("row-edit-init", t);
    },
    onRowEditSave: function(t) {
      this.$emit("row-edit-save", t);
    },
    onRowEditCancel: function(t) {
      this.$emit("row-edit-cancel", t);
    },
    onEditingMetaChange: function(t) {
      this.$emit("editing-meta-change", t);
    },
    getVirtualScrollerProp: function(t, n) {
      return n = n || this.virtualScrollerContentProps, n ? n[t] : null;
    }
  },
  computed: {
    rowIndex: function() {
      var t = this.getVirtualScrollerProp("getItemOptions");
      return t ? t(this.index).index : this.index;
    },
    rowStyles: function() {
      var t;
      return (t = this.rowStyle) === null || t === void 0 ? void 0 : t.call(this, this.rowData);
    },
    rowClasses: function() {
      var t = [];
      if (this.rowClass) {
        var n = this.rowClass(this.rowData);
        n && t.push(n);
      }
      return [this.cx("row", {
        rowData: this.rowData,
        index: this.rowIndex
      }), t];
    },
    rowTabindex: function() {
      return this.selection === null && (this.selectionMode === "single" || this.selectionMode === "multiple") && this.rowIndex === 0 ? 0 : -1;
    },
    isRowEditing: function() {
      return this.rowData && this.editingRows ? this.dataKey ? this.editingRowKeys ? this.editingRowKeys[We.resolveFieldData(this.rowData, this.dataKey)] !== void 0 : !1 : this.findIndex(this.rowData, this.editingRows) > -1 : !1;
    },
    isRowGroupExpanded: function() {
      if (this.expandableRowGroups && this.expandedRowGroups) {
        var t = We.resolveFieldData(this.rowData, this.groupRowsBy);
        return this.expandedRowGroups.indexOf(t) > -1;
      }
      return !1;
    },
    isSelected: function() {
      return this.rowData && this.selection ? this.dataKey ? this.selectionKeys ? this.selectionKeys[We.resolveFieldData(this.rowData, this.dataKey)] !== void 0 : !1 : this.selection instanceof Array ? this.findIndexInSelection(this.rowData) > -1 : this.equals(this.rowData, this.selection) : !1;
    },
    isSelectedWithContextMenu: function() {
      return this.rowData && this.contextMenuSelection ? this.equals(this.rowData, this.contextMenuSelection, this.dataKey) : !1;
    },
    shouldRenderRowGroupHeader: function() {
      var t = We.resolveFieldData(this.rowData, this.groupRowsBy), n = this.value[this.rowIndex - 1];
      if (n) {
        var i = We.resolveFieldData(n, this.groupRowsBy);
        return t !== i;
      } else
        return !0;
    },
    shouldRenderRowGroupFooter: function() {
      if (this.expandableRowGroups && !this.isRowGroupExpanded)
        return !1;
      var t = We.resolveFieldData(this.rowData, this.groupRowsBy), n = this.value[this.rowIndex + 1];
      if (n) {
        var i = We.resolveFieldData(n, this.groupRowsBy);
        return t !== i;
      } else
        return !0;
    },
    columnsLength: function() {
      var t = this;
      if (this.columns) {
        var n = 0;
        return this.columns.forEach(function(i) {
          t.columnProp(i, "selectionMode") === "single" && n--, t.columnProp(i, "hidden") && n++;
        }), this.columns.length - n;
      }
      return 0;
    }
  },
  components: {
    DTBodyCell: Yw,
    ChevronDownIcon: Va,
    ChevronRightIcon: Fo
  }
};
function Zl(e) {
  "@babel/helpers - typeof";
  return Zl = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Zl(e);
}
function sy(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    t && (i = i.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), n.push.apply(n, i);
  }
  return n;
}
function yo(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? sy(Object(n), !0).forEach(function(i) {
      yD(e, i, n[i]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : sy(Object(n)).forEach(function(i) {
      Object.defineProperty(e, i, Object.getOwnPropertyDescriptor(n, i));
    });
  }
  return e;
}
function yD(e, t, n) {
  return t = bD(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function bD(e) {
  var t = xD(e, "string");
  return Zl(t) == "symbol" ? t : String(t);
}
function xD(e, t) {
  if (Zl(e) != "object" || !e)
    return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var i = n.call(e, t || "default");
    if (Zl(i) != "object")
      return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var wD = ["colspan"], kD = ["tabindex", "aria-selected", "data-p-index", "data-p-selectable-row", "data-p-highlight", "data-p-highlight-contextmenu"], SD = ["id"], CD = ["colspan"], TD = ["colspan"], LD = ["colspan"];
function ID(e, t, n, i, o, a) {
  var r = $e("ChevronDownIcon"), s = $e("ChevronRightIcon"), l = $e("DTBodyCell");
  return n.empty ? (E(), X("tr", Ce({
    key: 1,
    class: e.cx("emptyMessage"),
    role: "row"
  }, e.ptm("emptyMessage")), [oe("td", Ce({
    colspan: a.columnsLength
  }, yo(yo({}, a.getColumnPT("bodycell")), e.ptm("emptyMessageCell"))), [n.templates.empty ? (E(), fe(tt(n.templates.empty), {
    key: 0
  })) : te("", !0)], 16, LD)], 16)) : (E(), X(Re, {
    key: 0
  }, [n.templates.groupheader && n.rowGroupMode === "subheader" && a.shouldRenderRowGroupHeader ? (E(), X("tr", Ce({
    key: 0,
    class: e.cx("rowGroupHeader"),
    style: n.rowGroupHeaderStyle,
    role: "row"
  }, e.ptm("rowGroupHeader")), [oe("td", Ce({
    colspan: a.columnsLength - 1
  }, yo(yo({}, a.getColumnPT("bodycell")), e.ptm("rowGroupHeaderCell"))), [n.expandableRowGroups ? (E(), X("button", Ce({
    key: 0,
    class: e.cx("rowGroupToggler"),
    onClick: t[0] || (t[0] = function() {
      return a.onRowGroupToggle && a.onRowGroupToggle.apply(a, arguments);
    }),
    type: "button"
  }, e.ptm("rowGroupToggler")), [n.templates.rowgrouptogglericon ? (E(), fe(tt(n.templates.rowgrouptogglericon), {
    key: 0,
    expanded: a.isRowGroupExpanded
  }, null, 8, ["expanded"])) : (E(), X(Re, {
    key: 1
  }, [a.isRowGroupExpanded && n.expandedRowIcon ? (E(), X("span", Ce({
    key: 0,
    class: [e.cx("rowGroupTogglerIcon"), n.expandedRowIcon]
  }, e.ptm("rowGroupTogglerIcon")), null, 16)) : a.isRowGroupExpanded && !n.expandedRowIcon ? (E(), fe(r, Ce({
    key: 1,
    class: e.cx("rowGroupTogglerIcon")
  }, e.ptm("rowGroupTogglerIcon")), null, 16, ["class"])) : !a.isRowGroupExpanded && n.collapsedRowIcon ? (E(), X("span", Ce({
    key: 2,
    class: [e.cx("rowGroupTogglerIcon"), n.collapsedRowIcon]
  }, e.ptm("rowGroupTogglerIcon")), null, 16)) : !a.isRowGroupExpanded && !n.collapsedRowIcon ? (E(), fe(s, Ce({
    key: 3,
    class: e.cx("rowGroupTogglerIcon")
  }, e.ptm("rowGroupTogglerIcon")), null, 16, ["class"])) : te("", !0)], 64))], 16)) : te("", !0), (E(), fe(tt(n.templates.groupheader), {
    data: n.rowData,
    index: a.rowIndex
  }, null, 8, ["data", "index"]))], 16, wD)], 16)) : te("", !0), !n.expandableRowGroups || a.isRowGroupExpanded ? (E(), X("tr", Ce({
    key: 1,
    class: a.rowClasses,
    style: a.rowStyles,
    tabindex: a.rowTabindex,
    role: "row",
    "aria-selected": n.selectionMode ? a.isSelected : null,
    onClick: t[1] || (t[1] = function() {
      return a.onRowClick && a.onRowClick.apply(a, arguments);
    }),
    onDblclick: t[2] || (t[2] = function() {
      return a.onRowDblClick && a.onRowDblClick.apply(a, arguments);
    }),
    onContextmenu: t[3] || (t[3] = function() {
      return a.onRowRightClick && a.onRowRightClick.apply(a, arguments);
    }),
    onTouchend: t[4] || (t[4] = function() {
      return a.onRowTouchEnd && a.onRowTouchEnd.apply(a, arguments);
    }),
    onKeydown: t[5] || (t[5] = It(function() {
      return a.onRowKeyDown && a.onRowKeyDown.apply(a, arguments);
    }, ["self"])),
    onMousedown: t[6] || (t[6] = function() {
      return a.onRowMouseDown && a.onRowMouseDown.apply(a, arguments);
    }),
    onDragstart: t[7] || (t[7] = function() {
      return a.onRowDragStart && a.onRowDragStart.apply(a, arguments);
    }),
    onDragover: t[8] || (t[8] = function() {
      return a.onRowDragOver && a.onRowDragOver.apply(a, arguments);
    }),
    onDragleave: t[9] || (t[9] = function() {
      return a.onRowDragLeave && a.onRowDragLeave.apply(a, arguments);
    }),
    onDragend: t[10] || (t[10] = function() {
      return a.onRowDragEnd && a.onRowDragEnd.apply(a, arguments);
    }),
    onDrop: t[11] || (t[11] = function() {
      return a.onRowDrop && a.onRowDrop.apply(a, arguments);
    })
  }, a.getBodyRowPTOptions("bodyRow"), {
    "data-p-index": a.rowIndex,
    "data-p-selectable-row": !!n.selectionMode,
    "data-p-highlight": n.selection && a.isSelected,
    "data-p-highlight-contextmenu": n.contextMenuSelection && a.isSelectedWithContextMenu
  }), [(E(!0), X(Re, null, Ge(n.columns, function(d, y) {
    return E(), X(Re, null, [a.shouldRenderBodyCell(d) ? (E(), fe(l, {
      key: a.columnProp(d, "columnKey") || a.columnProp(d, "field") || y,
      rowData: n.rowData,
      column: d,
      rowIndex: a.rowIndex,
      index: y,
      selected: a.isSelected,
      frozenRow: n.frozenRow,
      rowspan: n.rowGroupMode === "rowspan" ? a.calculateRowGroupSize(d) : null,
      editMode: n.editMode,
      editing: n.editMode === "row" && a.isRowEditing,
      editingMeta: n.editingMeta,
      responsiveLayout: n.responsiveLayout,
      virtualScrollerContentProps: n.virtualScrollerContentProps,
      ariaControls: n.expandedRowId + "_" + a.rowIndex + "_expansion",
      name: n.nameAttributeSelector,
      isRowExpanded: o.d_rowExpanded,
      expandedRowIcon: n.expandedRowIcon,
      collapsedRowIcon: n.collapsedRowIcon,
      onRadioChange: a.onRadioChange,
      onCheckboxChange: a.onCheckboxChange,
      onRowToggle: a.onRowToggle,
      onCellEditInit: a.onCellEditInit,
      onCellEditComplete: a.onCellEditComplete,
      onCellEditCancel: a.onCellEditCancel,
      onRowEditInit: a.onRowEditInit,
      onRowEditSave: a.onRowEditSave,
      onRowEditCancel: a.onRowEditCancel,
      onEditingMetaChange: a.onEditingMetaChange,
      unstyled: e.unstyled,
      pt: e.pt
    }, null, 8, ["rowData", "column", "rowIndex", "index", "selected", "frozenRow", "rowspan", "editMode", "editing", "editingMeta", "responsiveLayout", "virtualScrollerContentProps", "ariaControls", "name", "isRowExpanded", "expandedRowIcon", "collapsedRowIcon", "onRadioChange", "onCheckboxChange", "onRowToggle", "onCellEditInit", "onCellEditComplete", "onCellEditCancel", "onRowEditInit", "onRowEditSave", "onRowEditCancel", "onEditingMetaChange", "unstyled", "pt"])) : te("", !0)], 64);
  }), 256))], 16, kD)) : te("", !0), n.templates.expansion && n.expandedRows && o.d_rowExpanded ? (E(), X("tr", Ce({
    key: 2,
    id: n.expandedRowId + "_" + a.rowIndex + "_expansion",
    class: e.cx("rowExpansion"),
    role: "row"
  }, e.ptm("rowExpansion")), [oe("td", Ce({
    colspan: a.columnsLength
  }, yo(yo({}, a.getColumnPT("bodycell")), e.ptm("rowExpansionCell"))), [(E(), fe(tt(n.templates.expansion), {
    data: n.rowData,
    index: a.rowIndex
  }, null, 8, ["data", "index"]))], 16, CD)], 16, SD)) : te("", !0), n.templates.groupfooter && n.rowGroupMode === "subheader" && a.shouldRenderRowGroupFooter ? (E(), X("tr", Ce({
    key: 3,
    class: e.cx("rowGroupFooter"),
    role: "row"
  }, e.ptm("rowGroupFooter")), [oe("td", Ce({
    colspan: a.columnsLength - 1
  }, yo(yo({}, a.getColumnPT("bodycell")), e.ptm("rowGroupFooterCell"))), [(E(), fe(tt(n.templates.groupfooter), {
    data: n.rowData,
    index: a.rowIndex
  }, null, 8, ["data", "index"]))], 16, TD)], 16)) : te("", !0)], 64));
}
qw.render = ID;
var Kw = {
  name: "TableBody",
  hostName: "DataTable",
  extends: wt,
  emits: ["rowgroup-toggle", "row-click", "row-dblclick", "row-rightclick", "row-touchend", "row-keydown", "row-mousedown", "row-dragstart", "row-dragover", "row-dragleave", "row-dragend", "row-drop", "row-toggle", "radio-change", "checkbox-change", "cell-edit-init", "cell-edit-complete", "cell-edit-cancel", "row-edit-init", "row-edit-save", "row-edit-cancel", "editing-meta-change"],
  props: {
    value: {
      type: Array,
      default: null
    },
    columns: {
      type: null,
      default: null
    },
    frozenRow: {
      type: Boolean,
      default: !1
    },
    empty: {
      type: Boolean,
      default: !1
    },
    rowGroupMode: {
      type: String,
      default: null
    },
    groupRowsBy: {
      type: [Array, String, Function],
      default: null
    },
    expandableRowGroups: {
      type: Boolean,
      default: !1
    },
    expandedRowGroups: {
      type: Array,
      default: null
    },
    first: {
      type: Number,
      default: 0
    },
    dataKey: {
      type: [String, Function],
      default: null
    },
    expandedRowIcon: {
      type: String,
      default: null
    },
    collapsedRowIcon: {
      type: String,
      default: null
    },
    expandedRows: {
      type: [Array, Object],
      default: null
    },
    selection: {
      type: [Array, Object],
      default: null
    },
    selectionKeys: {
      type: null,
      default: null
    },
    selectionMode: {
      type: String,
      default: null
    },
    contextMenu: {
      type: Boolean,
      default: !1
    },
    contextMenuSelection: {
      type: Object,
      default: null
    },
    rowClass: {
      type: null,
      default: null
    },
    rowStyle: {
      type: null,
      default: null
    },
    editMode: {
      type: String,
      default: null
    },
    compareSelectionBy: {
      type: String,
      default: "deepEquals"
    },
    editingRows: {
      type: Array,
      default: null
    },
    editingRowKeys: {
      type: null,
      default: null
    },
    editingMeta: {
      type: Object,
      default: null
    },
    templates: {
      type: null,
      default: null
    },
    scrollable: {
      type: Boolean,
      default: !1
    },
    responsiveLayout: {
      type: String,
      default: "stack"
    },
    virtualScrollerContentProps: {
      type: Object,
      default: null
    },
    isVirtualScrollerDisabled: {
      type: Boolean,
      default: !1
    }
  },
  data: function() {
    return {
      rowGroupHeaderStyleObject: {}
    };
  },
  mounted: function() {
    this.frozenRow && this.updateFrozenRowStickyPosition(), this.scrollable && this.rowGroupMode === "subheader" && this.updateFrozenRowGroupHeaderStickyPosition();
  },
  updated: function() {
    this.frozenRow && this.updateFrozenRowStickyPosition(), this.scrollable && this.rowGroupMode === "subheader" && this.updateFrozenRowGroupHeaderStickyPosition();
  },
  methods: {
    updateFrozenRowStickyPosition: function() {
      this.$el.style.top = Oe.getOuterHeight(this.$el.previousElementSibling) + "px";
    },
    updateFrozenRowGroupHeaderStickyPosition: function() {
      var t = Oe.getOuterHeight(this.$el.previousElementSibling);
      this.rowGroupHeaderStyleObject.top = t + "px";
    },
    getVirtualScrollerProp: function(t, n) {
      return n = n || this.virtualScrollerContentProps, n ? n[t] : null;
    },
    bodyRef: function(t) {
      var n = this.getVirtualScrollerProp("contentRef");
      n && n(t);
    }
  },
  computed: {
    rowGroupHeaderStyle: function() {
      return this.scrollable ? {
        top: this.rowGroupHeaderStyleObject.top
      } : null;
    },
    bodyStyle: function() {
      return this.getVirtualScrollerProp("contentStyle");
    },
    ptmTBodyOptions: function() {
      var t;
      return {
        context: {
          scrollable: (t = this.$parentInstance) === null || t === void 0 || (t = t.$parentInstance) === null || t === void 0 ? void 0 : t.scrollable
        }
      };
    },
    expandedRowId: function() {
      return Mt();
    },
    nameAttributeSelector: function() {
      return Mt();
    }
  },
  components: {
    DTBodyRow: qw
  }
};
function PD(e, t, n, i, o, a) {
  var r = $e("DTBodyRow");
  return E(), X("tbody", Ce({
    ref: a.bodyRef,
    class: e.cx("tbody"),
    role: "rowgroup",
    style: a.bodyStyle
  }, e.ptm("tbody", a.ptmTBodyOptions)), [n.empty ? (E(), fe(r, {
    key: 1,
    empty: n.empty,
    columns: n.columns,
    templates: n.templates
  }, null, 8, ["empty", "columns", "templates"])) : (E(!0), X(Re, {
    key: 0
  }, Ge(n.value, function(s, l) {
    return E(), fe(r, {
      key: l,
      rowData: s,
      index: l,
      value: n.value,
      columns: n.columns,
      frozenRow: n.frozenRow,
      empty: n.empty,
      first: n.first,
      dataKey: n.dataKey,
      selection: n.selection,
      selectionKeys: n.selectionKeys,
      selectionMode: n.selectionMode,
      contextMenu: n.contextMenu,
      contextMenuSelection: n.contextMenuSelection,
      rowGroupMode: n.rowGroupMode,
      groupRowsBy: n.groupRowsBy,
      expandableRowGroups: n.expandableRowGroups,
      rowClass: n.rowClass,
      rowStyle: n.rowStyle,
      editMode: n.editMode,
      compareSelectionBy: n.compareSelectionBy,
      scrollable: n.scrollable,
      expandedRowIcon: n.expandedRowIcon,
      collapsedRowIcon: n.collapsedRowIcon,
      expandedRows: n.expandedRows,
      expandedRowGroups: n.expandedRowGroups,
      editingRows: n.editingRows,
      editingRowKeys: n.editingRowKeys,
      templates: n.templates,
      responsiveLayout: n.responsiveLayout,
      virtualScrollerContentProps: n.virtualScrollerContentProps,
      isVirtualScrollerDisabled: n.isVirtualScrollerDisabled,
      editingMeta: n.editingMeta,
      rowGroupHeaderStyle: a.rowGroupHeaderStyle,
      expandedRowId: a.expandedRowId,
      nameAttributeSelector: a.nameAttributeSelector,
      onRowgroupToggle: t[0] || (t[0] = function(d) {
        return e.$emit("rowgroup-toggle", d);
      }),
      onRowClick: t[1] || (t[1] = function(d) {
        return e.$emit("row-click", d);
      }),
      onRowDblclick: t[2] || (t[2] = function(d) {
        return e.$emit("row-dblclick", d);
      }),
      onRowRightclick: t[3] || (t[3] = function(d) {
        return e.$emit("row-rightclick", d);
      }),
      onRowTouchend: t[4] || (t[4] = function(d) {
        return e.$emit("row-touchend", d);
      }),
      onRowKeydown: t[5] || (t[5] = function(d) {
        return e.$emit("row-keydown", d);
      }),
      onRowMousedown: t[6] || (t[6] = function(d) {
        return e.$emit("row-mousedown", d);
      }),
      onRowDragstart: t[7] || (t[7] = function(d) {
        return e.$emit("row-dragstart", d);
      }),
      onRowDragover: t[8] || (t[8] = function(d) {
        return e.$emit("row-dragover", d);
      }),
      onRowDragleave: t[9] || (t[9] = function(d) {
        return e.$emit("row-dragleave", d);
      }),
      onRowDragend: t[10] || (t[10] = function(d) {
        return e.$emit("row-dragend", d);
      }),
      onRowDrop: t[11] || (t[11] = function(d) {
        return e.$emit("row-drop", d);
      }),
      onRowToggle: t[12] || (t[12] = function(d) {
        return e.$emit("row-toggle", d);
      }),
      onRadioChange: t[13] || (t[13] = function(d) {
        return e.$emit("radio-change", d);
      }),
      onCheckboxChange: t[14] || (t[14] = function(d) {
        return e.$emit("checkbox-change", d);
      }),
      onCellEditInit: t[15] || (t[15] = function(d) {
        return e.$emit("cell-edit-init", d);
      }),
      onCellEditComplete: t[16] || (t[16] = function(d) {
        return e.$emit("cell-edit-complete", d);
      }),
      onCellEditCancel: t[17] || (t[17] = function(d) {
        return e.$emit("cell-edit-cancel", d);
      }),
      onRowEditInit: t[18] || (t[18] = function(d) {
        return e.$emit("row-edit-init", d);
      }),
      onRowEditSave: t[19] || (t[19] = function(d) {
        return e.$emit("row-edit-save", d);
      }),
      onRowEditCancel: t[20] || (t[20] = function(d) {
        return e.$emit("row-edit-cancel", d);
      }),
      onEditingMetaChange: t[21] || (t[21] = function(d) {
        return e.$emit("editing-meta-change", d);
      }),
      unstyled: e.unstyled,
      pt: e.pt
    }, null, 8, ["rowData", "index", "value", "columns", "frozenRow", "empty", "first", "dataKey", "selection", "selectionKeys", "selectionMode", "contextMenu", "contextMenuSelection", "rowGroupMode", "groupRowsBy", "expandableRowGroups", "rowClass", "rowStyle", "editMode", "compareSelectionBy", "scrollable", "expandedRowIcon", "collapsedRowIcon", "expandedRows", "expandedRowGroups", "editingRows", "editingRowKeys", "templates", "responsiveLayout", "virtualScrollerContentProps", "isVirtualScrollerDisabled", "editingMeta", "rowGroupHeaderStyle", "expandedRowId", "nameAttributeSelector", "unstyled", "pt"]);
  }), 128))], 16);
}
Kw.render = PD;
var Xw = {
  name: "FooterCell",
  hostName: "DataTable",
  extends: wt,
  props: {
    column: {
      type: Object,
      default: null
    },
    index: {
      type: Number,
      default: null
    }
  },
  data: function() {
    return {
      styleObject: {}
    };
  },
  mounted: function() {
    this.columnProp("frozen") && this.updateStickyPosition();
  },
  updated: function() {
    this.columnProp("frozen") && this.updateStickyPosition();
  },
  methods: {
    columnProp: function(t) {
      return We.getVNodeProp(this.column, t);
    },
    getColumnPT: function(t) {
      var n, i, o = {
        props: this.column.props,
        parent: {
          instance: this,
          props: this.$props,
          state: this.$data
        },
        context: {
          index: this.index,
          size: (n = this.$parentInstance) === null || n === void 0 || (n = n.$parentInstance) === null || n === void 0 ? void 0 : n.size,
          showGridlines: ((i = this.$parentInstance) === null || i === void 0 || (i = i.$parentInstance) === null || i === void 0 ? void 0 : i.showGridlines) || !1
        }
      };
      return Ce(this.ptm("column.".concat(t), {
        column: o
      }), this.ptm("column.".concat(t), o), this.ptmo(this.getColumnProp(), t, o));
    },
    getColumnProp: function() {
      return this.column.props && this.column.props.pt ? this.column.props.pt : void 0;
    },
    updateStickyPosition: function() {
      if (this.columnProp("frozen")) {
        var t = this.columnProp("alignFrozen");
        if (t === "right") {
          var n = 0, i = Oe.getNextElementSibling(this.$el, '[data-p-frozen-column="true"]');
          i && (n = Oe.getOuterWidth(i) + parseFloat(i.style.right || 0)), this.styleObject.right = n + "px";
        } else {
          var o = 0, a = Oe.getPreviousElementSibling(this.$el, '[data-p-frozen-column="true"]');
          a && (o = Oe.getOuterWidth(a) + parseFloat(a.style.left || 0)), this.styleObject.left = o + "px";
        }
      }
    }
  },
  computed: {
    containerClass: function() {
      return [this.columnProp("footerClass"), this.columnProp("class"), this.cx("footerCell")];
    },
    containerStyle: function() {
      var t = this.columnProp("footerStyle"), n = this.columnProp("style");
      return this.columnProp("frozen") ? [n, t, this.styleObject] : [n, t];
    }
  }
};
function Jl(e) {
  "@babel/helpers - typeof";
  return Jl = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Jl(e);
}
function ly(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    t && (i = i.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), n.push.apply(n, i);
  }
  return n;
}
function cy(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? ly(Object(n), !0).forEach(function(i) {
      AD(e, i, n[i]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : ly(Object(n)).forEach(function(i) {
      Object.defineProperty(e, i, Object.getOwnPropertyDescriptor(n, i));
    });
  }
  return e;
}
function AD(e, t, n) {
  return t = _D(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function _D(e) {
  var t = MD(e, "string");
  return Jl(t) == "symbol" ? t : String(t);
}
function MD(e, t) {
  if (Jl(e) != "object" || !e)
    return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var i = n.call(e, t || "default");
    if (Jl(i) != "object")
      return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var OD = ["colspan", "rowspan", "data-p-frozen-column"];
function BD(e, t, n, i, o, a) {
  return E(), X("td", Ce({
    style: a.containerStyle,
    class: a.containerClass,
    role: "cell",
    colspan: a.columnProp("colspan"),
    rowspan: a.columnProp("rowspan")
  }, cy(cy({}, a.getColumnPT("root")), a.getColumnPT("footerCell")), {
    "data-p-frozen-column": a.columnProp("frozen")
  }), [n.column.children && n.column.children.footer ? (E(), fe(tt(n.column.children.footer), {
    key: 0,
    column: n.column
  }, null, 8, ["column"])) : te("", !0), Ve(" " + Ie(a.columnProp("footer")), 1)], 16, OD);
}
Xw.render = BD;
function ED(e, t) {
  var n = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (!n) {
    if (Array.isArray(e) || (n = DD(e)) || t && e && typeof e.length == "number") {
      n && (e = n);
      var i = 0, o = function() {
      };
      return { s: o, n: function() {
        return i >= e.length ? { done: !0 } : { done: !1, value: e[i++] };
      }, e: function(d) {
        throw d;
      }, f: o };
    }
    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  var a = !0, r = !1, s;
  return { s: function() {
    n = n.call(e);
  }, n: function() {
    var d = n.next();
    return a = d.done, d;
  }, e: function(d) {
    r = !0, s = d;
  }, f: function() {
    try {
      !a && n.return != null && n.return();
    } finally {
      if (r)
        throw s;
    }
  } };
}
function DD(e, t) {
  if (e) {
    if (typeof e == "string")
      return dy(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set")
      return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return dy(e, t);
  }
}
function dy(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, i = new Array(t); n < t; n++)
    i[n] = e[n];
  return i;
}
var Zw = {
  name: "TableFooter",
  hostName: "DataTable",
  extends: wt,
  props: {
    columnGroup: {
      type: null,
      default: null
    },
    columns: {
      type: Object,
      default: null
    }
  },
  provide: function() {
    return {
      $rows: this.d_footerRows,
      $columns: this.d_footerColumns
    };
  },
  data: function() {
    return {
      d_footerRows: new os({
        type: "Row"
      }),
      d_footerColumns: new os({
        type: "Column"
      })
    };
  },
  beforeUnmount: function() {
    this.d_footerRows.clear(), this.d_footerColumns.clear();
  },
  methods: {
    columnProp: function(t, n) {
      return We.getVNodeProp(t, n);
    },
    getColumnGroupPT: function(t) {
      var n = {
        props: this.getColumnGroupProps(),
        parent: {
          instance: this,
          props: this.$props,
          state: this.$data
        },
        context: {
          type: "footer",
          scrollable: this.ptmTFootOptions.context.scrollable
        }
      };
      return Ce(this.ptm("columnGroup.".concat(t), {
        columnGroup: n
      }), this.ptm("columnGroup.".concat(t), n), this.ptmo(this.getColumnGroupProps(), t, n));
    },
    getColumnGroupProps: function() {
      return this.columnGroup && this.columnGroup.props && this.columnGroup.props.pt ? this.columnGroup.props.pt : void 0;
    },
    getRowPT: function(t, n, i) {
      var o = {
        props: t.props,
        parent: {
          instance: this,
          props: this.$props,
          state: this.$data
        },
        context: {
          index: i
        }
      };
      return Ce(this.ptm("row.".concat(n), {
        row: o
      }), this.ptm("row.".concat(n), o), this.ptmo(this.getRowProp(t), n, o));
    },
    getRowProp: function(t) {
      return t.props && t.props.pt ? t.props.pt : void 0;
    },
    getFooterRows: function() {
      var t;
      return (t = this.d_footerRows) === null || t === void 0 ? void 0 : t.get(this.columnGroup, this.columnGroup.children);
    },
    getFooterColumns: function(t) {
      var n;
      return (n = this.d_footerColumns) === null || n === void 0 ? void 0 : n.get(t, t.children);
    }
  },
  computed: {
    hasFooter: function() {
      var t = !1;
      if (this.columnGroup)
        t = !0;
      else if (this.columns) {
        var n = ED(this.columns), i;
        try {
          for (n.s(); !(i = n.n()).done; ) {
            var o = i.value;
            if (this.columnProp(o, "footer") || o.children && o.children.footer) {
              t = !0;
              break;
            }
          }
        } catch (a) {
          n.e(a);
        } finally {
          n.f();
        }
      }
      return t;
    },
    ptmTFootOptions: function() {
      var t;
      return {
        context: {
          scrollable: (t = this.$parentInstance) === null || t === void 0 || (t = t.$parentInstance) === null || t === void 0 ? void 0 : t.scrollable
        }
      };
    }
  },
  components: {
    DTFooterCell: Xw
  }
};
function Ql(e) {
  "@babel/helpers - typeof";
  return Ql = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Ql(e);
}
function uy(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    t && (i = i.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), n.push.apply(n, i);
  }
  return n;
}
function vd(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? uy(Object(n), !0).forEach(function(i) {
      RD(e, i, n[i]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : uy(Object(n)).forEach(function(i) {
      Object.defineProperty(e, i, Object.getOwnPropertyDescriptor(n, i));
    });
  }
  return e;
}
function RD(e, t, n) {
  return t = ND(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function ND(e) {
  var t = $D(e, "string");
  return Ql(t) == "symbol" ? t : String(t);
}
function $D(e, t) {
  if (Ql(e) != "object" || !e)
    return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var i = n.call(e, t || "default");
    if (Ql(i) != "object")
      return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function FD(e, t, n, i, o, a) {
  var r = $e("DTFooterCell");
  return a.hasFooter ? (E(), X("tfoot", Ce({
    key: 0,
    class: e.cx("tfoot"),
    style: e.sx("tfoot"),
    role: "rowgroup"
  }, n.columnGroup ? vd(vd({}, e.ptm("tfoot", a.ptmTFootOptions)), a.getColumnGroupPT("root")) : e.ptm("tfoot", a.ptmTFootOptions), {
    "data-pc-section": "tfoot"
  }), [n.columnGroup ? (E(!0), X(Re, {
    key: 1
  }, Ge(a.getFooterRows(), function(s, l) {
    return E(), X("tr", Ce({
      key: l,
      role: "row"
    }, vd(vd({}, e.ptm("footerRow")), a.getRowPT(s, "root", l))), [(E(!0), X(Re, null, Ge(a.getFooterColumns(s), function(d, y) {
      return E(), X(Re, {
        key: a.columnProp(d, "columnKey") || a.columnProp(d, "field") || y
      }, [a.columnProp(d, "hidden") ? te("", !0) : (E(), fe(r, {
        key: 0,
        column: d,
        index: l,
        pt: e.pt
      }, null, 8, ["column", "index", "pt"]))], 64);
    }), 128))], 16);
  }), 128)) : (E(), X("tr", Ce({
    key: 0,
    role: "row"
  }, e.ptm("footerRow")), [(E(!0), X(Re, null, Ge(n.columns, function(s, l) {
    return E(), X(Re, {
      key: a.columnProp(s, "columnKey") || a.columnProp(s, "field") || l
    }, [a.columnProp(s, "hidden") ? te("", !0) : (E(), fe(r, {
      key: 0,
      column: s,
      pt: e.pt
    }, null, 8, ["column", "pt"]))], 64);
  }), 128))], 16))], 16)) : te("", !0);
}
Zw.render = FD;
function ec(e) {
  "@babel/helpers - typeof";
  return ec = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, ec(e);
}
function hy(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    t && (i = i.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), n.push.apply(n, i);
  }
  return n;
}
function Xo(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? hy(Object(n), !0).forEach(function(i) {
      jD(e, i, n[i]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : hy(Object(n)).forEach(function(i) {
      Object.defineProperty(e, i, Object.getOwnPropertyDescriptor(n, i));
    });
  }
  return e;
}
function jD(e, t, n) {
  return t = HD(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function HD(e) {
  var t = zD(e, "string");
  return ec(t) == "symbol" ? t : String(t);
}
function zD(e, t) {
  if (ec(e) != "object" || !e)
    return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var i = n.call(e, t || "default");
    if (ec(i) != "object")
      return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var Mm = {
  name: "ColumnFilter",
  hostName: "DataTable",
  extends: wt,
  emits: ["filter-change", "filter-apply", "operator-change", "matchmode-change", "constraint-add", "constraint-remove", "filter-clear", "apply-click"],
  props: {
    field: {
      type: String,
      default: null
    },
    type: {
      type: String,
      default: "text"
    },
    display: {
      type: String,
      default: null
    },
    showMenu: {
      type: Boolean,
      default: !0
    },
    matchMode: {
      type: String,
      default: null
    },
    showOperator: {
      type: Boolean,
      default: !0
    },
    showClearButton: {
      type: Boolean,
      default: !0
    },
    showApplyButton: {
      type: Boolean,
      default: !0
    },
    showMatchModes: {
      type: Boolean,
      default: !0
    },
    showAddButton: {
      type: Boolean,
      default: !0
    },
    matchModeOptions: {
      type: Array,
      default: null
    },
    maxConstraints: {
      type: Number,
      default: 2
    },
    filterElement: {
      type: Function,
      default: null
    },
    filterHeaderTemplate: {
      type: Function,
      default: null
    },
    filterFooterTemplate: {
      type: Function,
      default: null
    },
    filterClearTemplate: {
      type: Function,
      default: null
    },
    filterApplyTemplate: {
      type: Function,
      default: null
    },
    filterIconTemplate: {
      type: Function,
      default: null
    },
    filterAddIconTemplate: {
      type: Function,
      default: null
    },
    filterRemoveIconTemplate: {
      type: Function,
      default: null
    },
    filterClearIconTemplate: {
      type: Function,
      default: null
    },
    filters: {
      type: Object,
      default: null
    },
    filtersStore: {
      type: Object,
      default: null
    },
    filterMenuClass: {
      type: String,
      default: null
    },
    filterMenuStyle: {
      type: null,
      default: null
    },
    filterInputProps: {
      type: null,
      default: null
    },
    column: null
  },
  data: function() {
    return {
      overlayVisible: !1,
      defaultMatchMode: null,
      defaultOperator: null
    };
  },
  overlay: null,
  selfClick: !1,
  overlayEventListener: null,
  beforeUnmount: function() {
    this.overlayEventListener && (Zn.off("overlay-click", this.overlayEventListener), this.overlayEventListener = null), this.overlay && (qt.clear(this.overlay), this.onOverlayHide());
  },
  mounted: function() {
    if (this.filters && this.filters[this.field]) {
      var t = this.filters[this.field];
      t.operator ? (this.defaultMatchMode = t.constraints[0].matchMode, this.defaultOperator = t.operator) : this.defaultMatchMode = this.filters[this.field].matchMode;
    }
  },
  methods: {
    getColumnPT: function(t, n) {
      var i = Xo({
        props: this.column.props,
        parent: {
          instance: this,
          props: this.$props,
          state: this.$data
        }
      }, n);
      return Ce(this.ptm("column.".concat(t), {
        column: i
      }), this.ptm("column.".concat(t), i), this.ptmo(this.getColumnProp(), t, i));
    },
    getColumnProp: function() {
      return this.column.props && this.column.props.pt ? this.column.props.pt : void 0;
    },
    ptmFilterRowItemOptions: function(t) {
      return {
        context: {
          highlighted: t && this.isRowMatchModeSelected(t.value)
        }
      };
    },
    clearFilter: function() {
      var t = Xo({}, this.filters);
      t[this.field].operator ? (t[this.field].constraints.splice(1), t[this.field].operator = this.defaultOperator, t[this.field].constraints[0] = {
        value: null,
        matchMode: this.defaultMatchMode
      }) : (t[this.field].value = null, t[this.field].matchMode = this.defaultMatchMode), this.$emit("filter-clear"), this.$emit("filter-change", t), this.$emit("filter-apply"), this.hide();
    },
    applyFilter: function() {
      this.$emit("apply-click", {
        field: this.field,
        constraints: this.filters[this.field]
      }), this.$emit("filter-apply"), this.hide();
    },
    hasFilter: function() {
      if (this.filtersStore) {
        var t = this.filtersStore[this.field];
        if (t)
          return t.operator ? !this.isFilterBlank(t.constraints[0].value) : !this.isFilterBlank(t.value);
      }
      return !1;
    },
    hasRowFilter: function() {
      return this.filters[this.field] && !this.isFilterBlank(this.filters[this.field].value);
    },
    isFilterBlank: function(t) {
      return t != null ? typeof t == "string" && t.trim().length == 0 || t instanceof Array && t.length == 0 : !0;
    },
    toggleMenu: function(t) {
      this.overlayVisible = !this.overlayVisible, t.preventDefault();
    },
    onToggleButtonKeyDown: function(t) {
      switch (t.code) {
        case "Enter":
        case "NumpadEnter":
        case "Space":
          this.toggleMenu(t);
          break;
        case "Escape":
          this.overlayVisible = !1;
          break;
      }
    },
    onRowMatchModeChange: function(t) {
      var n = Xo({}, this.filters);
      n[this.field].matchMode = t, this.$emit("matchmode-change", {
        field: this.field,
        matchMode: t
      }), this.$emit("filter-change", n), this.$emit("filter-apply"), this.hide();
    },
    onRowMatchModeKeyDown: function(t) {
      var n = t.target;
      switch (t.code) {
        case "ArrowDown":
          var i = this.findNextItem(n);
          i && (n.removeAttribute("tabindex"), i.tabIndex = "0", i.focus()), t.preventDefault();
          break;
        case "ArrowUp":
          var o = this.findPrevItem(n);
          o && (n.removeAttribute("tabindex"), o.tabIndex = "0", o.focus()), t.preventDefault();
          break;
      }
    },
    isRowMatchModeSelected: function(t) {
      return this.filters[this.field].matchMode === t;
    },
    onOperatorChange: function(t) {
      var n = Xo({}, this.filters);
      n[this.field].operator = t, this.$emit("filter-change", n), this.$emit("operator-change", {
        field: this.field,
        operator: t
      }), this.showApplyButton || this.$emit("filter-apply");
    },
    onMenuMatchModeChange: function(t, n) {
      var i = Xo({}, this.filters);
      i[this.field].constraints[n].matchMode = t, this.$emit("matchmode-change", {
        field: this.field,
        matchMode: t,
        index: n
      }), this.showApplyButton || this.$emit("filter-apply");
    },
    addConstraint: function() {
      var t = Xo({}, this.filters), n = {
        value: null,
        matchMode: this.defaultMatchMode
      };
      t[this.field].constraints.push(n), this.$emit("constraint-add", {
        field: this.field,
        constraing: n
      }), this.$emit("filter-change", t), this.showApplyButton || this.$emit("filter-apply");
    },
    removeConstraint: function(t) {
      var n = Xo({}, this.filters), i = n[this.field].constraints.splice(t, 1);
      this.$emit("constraint-remove", {
        field: this.field,
        constraing: i
      }), this.$emit("filter-change", n), this.showApplyButton || this.$emit("filter-apply");
    },
    filterCallback: function() {
      this.$emit("filter-apply");
    },
    findNextItem: function(t) {
      var n = t.nextElementSibling;
      return n ? Oe.getAttribute(n, "data-pc-section") === "filterseparator" ? this.findNextItem(n) : n : t.parentElement.firstElementChild;
    },
    findPrevItem: function(t) {
      var n = t.previousElementSibling;
      return n ? Oe.getAttribute(n, "data-pc-section") === "filterseparator" ? this.findPrevItem(n) : n : t.parentElement.lastElementChild;
    },
    hide: function() {
      this.overlayVisible = !1, Oe.focus(this.$refs.icon);
    },
    onContentClick: function(t) {
      this.selfClick = !0, Zn.emit("overlay-click", {
        originalEvent: t,
        target: this.overlay
      });
    },
    onContentMouseDown: function() {
      this.selfClick = !0;
    },
    onOverlayEnter: function(t) {
      var n = this;
      this.filterMenuStyle && Oe.applyStyle(this.overlay, this.filterMenuStyle), qt.set("overlay", t, this.$primevue.config.zIndex.overlay), Oe.addStyles(t, {
        position: "absolute",
        top: "0",
        left: "0"
      }), Oe.absolutePosition(this.overlay, this.$refs.icon), this.bindOutsideClickListener(), this.bindScrollListener(), this.bindResizeListener(), this.overlayEventListener = function(i) {
        n.isOutsideClicked(i.target) || (n.selfClick = !0);
      }, Zn.on("overlay-click", this.overlayEventListener);
    },
    onOverlayLeave: function() {
      this.onOverlayHide();
    },
    onOverlayAfterLeave: function(t) {
      qt.clear(t);
    },
    onOverlayHide: function() {
      this.unbindOutsideClickListener(), this.unbindResizeListener(), this.unbindScrollListener(), this.overlay = null, Zn.off("overlay-click", this.overlayEventListener), this.overlayEventListener = null;
    },
    overlayRef: function(t) {
      this.overlay = t;
    },
    isOutsideClicked: function(t) {
      return !this.isTargetClicked(t) && this.overlay && !(this.overlay.isSameNode(t) || this.overlay.contains(t));
    },
    isTargetClicked: function(t) {
      return this.$refs.icon && (this.$refs.icon.isSameNode(t) || this.$refs.icon.contains(t));
    },
    bindOutsideClickListener: function() {
      var t = this;
      this.outsideClickListener || (this.outsideClickListener = function(n) {
        t.overlayVisible && !t.selfClick && t.isOutsideClicked(n.target) && (t.overlayVisible = !1), t.selfClick = !1;
      }, document.addEventListener("click", this.outsideClickListener));
    },
    unbindOutsideClickListener: function() {
      this.outsideClickListener && (document.removeEventListener("click", this.outsideClickListener), this.outsideClickListener = null, this.selfClick = !1);
    },
    bindScrollListener: function() {
      var t = this;
      this.scrollHandler || (this.scrollHandler = new po(this.$refs.icon, function() {
        t.overlayVisible && t.hide();
      })), this.scrollHandler.bindScrollListener();
    },
    unbindScrollListener: function() {
      this.scrollHandler && this.scrollHandler.unbindScrollListener();
    },
    bindResizeListener: function() {
      var t = this;
      this.resizeListener || (this.resizeListener = function() {
        t.overlayVisible && !Oe.isTouchDevice() && t.hide();
      }, window.addEventListener("resize", this.resizeListener));
    },
    unbindResizeListener: function() {
      this.resizeListener && (window.removeEventListener("resize", this.resizeListener), this.resizeListener = null);
    }
  },
  computed: {
    showMenuButton: function() {
      return this.showMenu && (this.display === "row" ? this.type !== "boolean" : !0);
    },
    overlayId: function() {
      return Mt();
    },
    matchModes: function() {
      var t = this;
      return this.matchModeOptions || this.$primevue.config.filterMatchModeOptions[this.type].map(function(n) {
        return {
          label: t.$primevue.config.locale[n],
          value: n
        };
      });
    },
    isShowMatchModes: function() {
      return this.type !== "boolean" && this.showMatchModes && this.matchModes;
    },
    operatorOptions: function() {
      return [{
        label: this.$primevue.config.locale.matchAll,
        value: du.AND
      }, {
        label: this.$primevue.config.locale.matchAny,
        value: du.OR
      }];
    },
    noFilterLabel: function() {
      return this.$primevue.config.locale ? this.$primevue.config.locale.noFilter : void 0;
    },
    isShowOperator: function() {
      return this.showOperator && this.filters[this.field].operator;
    },
    operator: function() {
      return this.filters[this.field].operator;
    },
    fieldConstraints: function() {
      return this.filters[this.field].constraints || [this.filters[this.field]];
    },
    showRemoveIcon: function() {
      return this.fieldConstraints.length > 1;
    },
    removeRuleButtonLabel: function() {
      return this.$primevue.config.locale ? this.$primevue.config.locale.removeRule : void 0;
    },
    addRuleButtonLabel: function() {
      return this.$primevue.config.locale ? this.$primevue.config.locale.addRule : void 0;
    },
    isShowAddConstraint: function() {
      return this.showAddButton && this.filters[this.field].operator && this.fieldConstraints && this.fieldConstraints.length < this.maxConstraints;
    },
    clearButtonLabel: function() {
      return this.$primevue.config.locale ? this.$primevue.config.locale.clear : void 0;
    },
    applyButtonLabel: function() {
      return this.$primevue.config.locale ? this.$primevue.config.locale.apply : void 0;
    },
    filterMenuButtonAriaLabel: function() {
      return this.$primevue.config.locale ? this.overlayVisible ? this.$primevue.config.locale.showFilterMenu : this.$primevue.config.locale.hideFilterMenu : void 0;
    },
    filterOperatorAriaLabel: function() {
      return this.$primevue.config.locale ? this.$primevue.config.locale.filterOperator : void 0;
    },
    filterConstraintAriaLabel: function() {
      return this.$primevue.config.locale ? this.$primevue.config.locale.filterConstraint : void 0;
    },
    ptmHeaderFilterClearParams: function() {
      return {
        context: {
          hidden: this.hasRowFilter()
        }
      };
    },
    ptmFilterMenuParams: function() {
      return {
        context: {
          overlayVisible: this.overlayVisible,
          active: this.hasFilter()
        }
      };
    }
  },
  components: {
    CFDropdown: Ga,
    CFButton: ki,
    Portal: Yn,
    FilterSlashIcon: zw,
    FilterIcon: Pm,
    TrashIcon: Gw,
    PlusIcon: Vw
  },
  directives: {
    focustrap: qu
  }
};
function tc(e) {
  "@babel/helpers - typeof";
  return tc = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, tc(e);
}
function py(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    t && (i = i.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), n.push.apply(n, i);
  }
  return n;
}
function fy(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? py(Object(n), !0).forEach(function(i) {
      VD(e, i, n[i]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : py(Object(n)).forEach(function(i) {
      Object.defineProperty(e, i, Object.getOwnPropertyDescriptor(n, i));
    });
  }
  return e;
}
function VD(e, t, n) {
  return t = GD(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function GD(e) {
  var t = UD(e, "string");
  return tc(t) == "symbol" ? t : String(t);
}
function UD(e, t) {
  if (tc(e) != "object" || !e)
    return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var i = n.call(e, t || "default");
    if (tc(i) != "object")
      return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var WD = ["aria-label", "aria-expanded", "aria-controls"], YD = ["id", "aria-modal"], qD = ["onClick", "onKeydown", "tabindex"];
function KD(e, t, n, i, o, a) {
  var r = $e("CFDropdown"), s = $e("CFButton"), l = $e("Portal"), d = Ut("focustrap");
  return E(), X("div", Ce({
    class: e.cx("columnFilter")
  }, a.getColumnPT("columnFilter")), [n.display === "row" ? (E(), X("div", Ce({
    key: 0,
    class: e.cx("filterInput")
  }, fy(fy({}, n.filterInputProps), a.getColumnPT("filterInput"))), [(E(), fe(tt(n.filterElement), {
    field: n.field,
    filterModel: n.filters[n.field],
    filterCallback: a.filterCallback
  }, null, 8, ["field", "filterModel", "filterCallback"]))], 16)) : te("", !0), a.showMenuButton ? (E(), X("button", Ce({
    key: 1,
    ref: "icon",
    type: "button",
    "aria-label": a.filterMenuButtonAriaLabel,
    "aria-haspopup": "true",
    "aria-expanded": o.overlayVisible,
    "aria-controls": a.overlayId,
    class: e.cx("filterMenuButton"),
    onClick: t[0] || (t[0] = function(y) {
      return a.toggleMenu(y);
    }),
    onKeydown: t[1] || (t[1] = function(y) {
      return a.onToggleButtonKeyDown(y);
    })
  }, a.getColumnPT("filterMenuButton", a.ptmFilterMenuParams)), [(E(), fe(tt(n.filterIconTemplate || "FilterIcon"), si(Ki(a.getColumnPT("filterMenuIcon"))), null, 16))], 16, WD)) : te("", !0), n.showClearButton && n.display === "row" ? (E(), X("button", Ce({
    key: 2,
    class: e.cx("headerFilterClearButton"),
    type: "button",
    onClick: t[2] || (t[2] = function(y) {
      return a.clearFilter();
    })
  }, a.getColumnPT("headerFilterClearButton", a.ptmHeaderFilterClearParams)), [(E(), fe(tt(n.filterClearIconTemplate || "FilterSlashIcon"), si(Ki(a.getColumnPT("filterClearIcon"))), null, 16))], 16)) : te("", !0), ue(l, null, {
    default: Se(function() {
      return [ue(ia, Ce({
        name: "p-connected-overlay",
        onEnter: a.onOverlayEnter,
        onLeave: a.onOverlayLeave,
        onAfterLeave: a.onOverlayAfterLeave
      }, a.getColumnPT("transition")), {
        default: Se(function() {
          return [o.overlayVisible ? rt((E(), X("div", Ce({
            key: 0,
            ref: a.overlayRef,
            id: a.overlayId,
            "aria-modal": o.overlayVisible,
            role: "dialog",
            class: [e.cx("filterOverlay"), n.filterMenuClass],
            onKeydown: t[10] || (t[10] = Ze(function() {
              return a.hide && a.hide.apply(a, arguments);
            }, ["escape"])),
            onClick: t[11] || (t[11] = function() {
              return a.onContentClick && a.onContentClick.apply(a, arguments);
            }),
            onMousedown: t[12] || (t[12] = function() {
              return a.onContentMouseDown && a.onContentMouseDown.apply(a, arguments);
            })
          }, a.getColumnPT("filterOverlay")), [(E(), fe(tt(n.filterHeaderTemplate), {
            field: n.field,
            filterModel: n.filters[n.field],
            filterCallback: a.filterCallback
          }, null, 8, ["field", "filterModel", "filterCallback"])), n.display === "row" ? (E(), X("ul", Ce({
            key: 0,
            class: e.cx("filterRowItems")
          }, a.getColumnPT("filterRowItems")), [(E(!0), X(Re, null, Ge(a.matchModes, function(y, u) {
            return E(), X("li", Ce({
              key: y.label,
              class: e.cx("filterRowItem", {
                matchMode: y
              }),
              onClick: function(h) {
                return a.onRowMatchModeChange(y.value);
              },
              onKeydown: [t[3] || (t[3] = function(m) {
                return a.onRowMatchModeKeyDown(m);
              }), Ze(It(function(m) {
                return a.onRowMatchModeChange(y.value);
              }, ["prevent"]), ["enter"])],
              tabindex: u === 0 ? "0" : null
            }, a.getColumnPT("filterRowItem", a.ptmFilterRowItemOptions(y))), Ie(y.label), 17, qD);
          }), 128)), oe("li", Ce({
            class: e.cx("filterSeparator")
          }, a.getColumnPT("filterSeparator")), null, 16), oe("li", Ce({
            class: e.cx("filterRowItem"),
            onClick: t[4] || (t[4] = function(y) {
              return a.clearFilter();
            }),
            onKeydown: [t[5] || (t[5] = function(y) {
              return a.onRowMatchModeKeyDown(y);
            }), t[6] || (t[6] = Ze(function(y) {
              return e.onRowClearItemClick();
            }, ["enter"]))]
          }, a.getColumnPT("filterRowItem")), Ie(a.noFilterLabel), 17)], 16)) : (E(), X(Re, {
            key: 1
          }, [a.isShowOperator ? (E(), X("div", Ce({
            key: 0,
            class: e.cx("filterOperator")
          }, a.getColumnPT("filterOperator")), [ue(r, {
            options: a.operatorOptions,
            modelValue: a.operator,
            "aria-label": a.filterOperatorAriaLabel,
            class: Pe(e.cx("filterOperatorDropdown")),
            optionLabel: "label",
            optionValue: "value",
            "onUpdate:modelValue": t[7] || (t[7] = function(y) {
              return a.onOperatorChange(y);
            }),
            unstyled: e.unstyled,
            pt: a.getColumnPT("filterOperatorDropdown"),
            "data-pc-section": "filteroperatordropdown"
          }, null, 8, ["options", "modelValue", "aria-label", "class", "unstyled", "pt"])], 16)) : te("", !0), oe("div", Ce({
            class: e.cx("filterConstraints")
          }, a.getColumnPT("filterConstraints")), [(E(!0), X(Re, null, Ge(a.fieldConstraints, function(y, u) {
            return E(), X("div", Ce({
              key: u,
              class: e.cx("filterConstraint")
            }, a.getColumnPT("filterConstraint")), [a.isShowMatchModes ? (E(), fe(r, {
              key: 0,
              options: a.matchModes,
              modelValue: y.matchMode,
              class: Pe(e.cx("filterMatchModeDropdown")),
              optionLabel: "label",
              optionValue: "value",
              "aria-label": a.filterConstraintAriaLabel,
              "onUpdate:modelValue": function(h) {
                return a.onMenuMatchModeChange(h, u);
              },
              unstyled: e.unstyled,
              pt: a.getColumnPT("filterMatchModeDropdown"),
              "data-pc-section": "filtermatchmodedropdown"
            }, null, 8, ["options", "modelValue", "class", "aria-label", "onUpdate:modelValue", "unstyled", "pt"])) : te("", !0), n.display === "menu" ? (E(), fe(tt(n.filterElement), {
              key: 1,
              field: n.field,
              filterModel: y,
              filterCallback: a.filterCallback,
              applyFilter: a.applyFilter
            }, null, 8, ["field", "filterModel", "filterCallback", "applyFilter"])) : te("", !0), oe("div", si(Ki(a.getColumnPT("filterRemove"))), [a.showRemoveIcon ? (E(), fe(s, {
              key: 0,
              type: "button",
              class: Pe(e.cx("filterRemoveButton")),
              onClick: function(h) {
                return a.removeConstraint(u);
              },
              label: a.removeRuleButtonLabel,
              unstyled: e.unstyled,
              text: "",
              severity: "danger",
              size: "small",
              pt: a.getColumnPT("filterRemoveButton"),
              "data-pc-section": "filterremovebutton"
            }, {
              icon: Se(function(m) {
                return [(E(), fe(tt(n.filterRemoveIconTemplate || "TrashIcon"), Ce({
                  class: m.class
                }, a.getColumnPT("filterRemoveButton").icon), null, 16, ["class"]))];
              }),
              _: 2
            }, 1032, ["class", "onClick", "label", "unstyled", "pt"])) : te("", !0)], 16)], 16);
          }), 128))], 16), a.isShowAddConstraint ? (E(), X("div", Ce({
            key: 1,
            class: e.cx("filterAddRule")
          }, a.getColumnPT("filterAddRule")), [ue(s, {
            type: "button",
            label: a.addRuleButtonLabel,
            iconPos: "left",
            class: Pe(e.cx("filterAddRuleButton")),
            onClick: t[8] || (t[8] = function(y) {
              return a.addConstraint();
            }),
            unstyled: e.unstyled,
            text: "",
            severity: "info",
            size: "small",
            pt: a.getColumnPT("filterAddRuleButton"),
            "data-pc-section": "filteraddrulebutton"
          }, {
            icon: Se(function(y) {
              return [(E(), fe(tt(n.filterAddIconTemplate || "PlusIcon"), Ce({
                class: y.class
              }, a.getColumnPT("filterAddRuleButton").icon), null, 16, ["class"]))];
            }),
            _: 1
          }, 8, ["label", "class", "unstyled", "pt"])], 16)) : te("", !0), oe("div", Ce({
            class: e.cx("filterButtonbar")
          }, a.getColumnPT("filterButtonbar")), [!n.filterClearTemplate && n.showClearButton ? (E(), fe(s, {
            key: 0,
            type: "button",
            class: Pe(e.cx("filterClearButton")),
            label: a.clearButtonLabel,
            onClick: a.clearFilter,
            unstyled: e.unstyled,
            size: "small",
            outlined: "",
            pt: a.getColumnPT("filterClearButton"),
            "data-pc-section": "filterclearbutton"
          }, null, 8, ["class", "label", "onClick", "unstyled", "pt"])) : (E(), fe(tt(n.filterClearTemplate), {
            key: 1,
            field: n.field,
            filterModel: n.filters[n.field],
            filterCallback: a.clearFilter
          }, null, 8, ["field", "filterModel", "filterCallback"])), n.showApplyButton ? (E(), X(Re, {
            key: 2
          }, [n.filterApplyTemplate ? (E(), fe(tt(n.filterApplyTemplate), {
            key: 1,
            field: n.field,
            filterModel: n.filters[n.field],
            filterCallback: a.applyFilter
          }, null, 8, ["field", "filterModel", "filterCallback"])) : (E(), fe(s, {
            key: 0,
            type: "button",
            class: Pe(e.cx("filterApplyButton")),
            label: a.applyButtonLabel,
            onClick: t[9] || (t[9] = function(y) {
              return a.applyFilter();
            }),
            unstyled: e.unstyled,
            size: "small",
            pt: a.getColumnPT("filterApplyButton"),
            "data-pc-section": "filterapplybutton"
          }, null, 8, ["class", "label", "unstyled", "pt"]))], 64)) : te("", !0)], 16)], 64)), (E(), fe(tt(n.filterFooterTemplate), {
            field: n.field,
            filterModel: n.filters[n.field],
            filterCallback: a.filterCallback
          }, null, 8, ["field", "filterModel", "filterCallback"]))], 16, YD)), [[d, {
            autoFocus: !0
          }]]) : te("", !0)];
        }),
        _: 1
      }, 16, ["onEnter", "onLeave", "onAfterLeave"])];
    }),
    _: 1
  })], 16);
}
Mm.render = KD;
var Om = {
  name: "HeaderCheckbox",
  hostName: "DataTable",
  extends: wt,
  emits: ["change"],
  props: {
    checked: null,
    disabled: null,
    column: null,
    headerCheckboxIconTemplate: {
      type: Function,
      default: null
    }
  },
  data: function() {
    return {
      focused: !1
    };
  },
  methods: {
    getColumnPT: function(t) {
      var n = {
        props: this.column.props,
        parent: {
          instance: this,
          props: this.$props,
          state: this.$data
        },
        context: {
          checked: this.checked,
          focused: this.focused,
          disabled: this.disabled
        }
      };
      return Ce(this.ptm("column.".concat(t), {
        column: n
      }), this.ptm("column.".concat(t), n), this.ptmo(this.getColumnProp(), t, n));
    },
    getColumnProp: function() {
      return this.column.props && this.column.props.pt ? this.column.props.pt : void 0;
    },
    onClick: function(t) {
      this.disabled || (this.$emit("change", {
        originalEvent: t,
        checked: !this.checked
      }), Oe.focus(this.$refs.input));
    },
    onFocus: function() {
      this.focused = !0;
    },
    onBlur: function() {
      this.focused = !1;
    }
  },
  computed: {
    headerCheckboxAriaLabel: function() {
      return this.$primevue.config.locale.aria ? this.checked ? this.$primevue.config.locale.aria.selectAll : this.$primevue.config.locale.aria.unselectAll : void 0;
    }
  },
  components: {
    CheckIcon: Oa
  }
}, XD = ["checked", "disabled", "tabindex", "aria-label"];
function ZD(e, t, n, i, o, a) {
  var r = $e("CheckIcon");
  return E(), X("div", Ce({
    class: e.cx("headerCheckboxWrapper"),
    onClick: t[2] || (t[2] = function() {
      return a.onClick && a.onClick.apply(a, arguments);
    }),
    onKeydown: t[3] || (t[3] = Ze(It(function() {
      return a.onClick && a.onClick.apply(a, arguments);
    }, ["prevent"]), ["space"]))
  }, a.getColumnPT("headerCheckboxWrapper")), [oe("div", Ce({
    class: "p-hidden-accessible"
  }, a.getColumnPT("hiddenHeaderInputWrapper"), {
    "data-p-hidden-accessible": !0
  }), [oe("input", Ce({
    ref: "input",
    type: "checkbox",
    checked: n.checked,
    disabled: n.disabled,
    tabindex: n.disabled ? null : "0",
    "aria-label": a.headerCheckboxAriaLabel,
    onFocus: t[0] || (t[0] = function(s) {
      return a.onFocus(s);
    }),
    onBlur: t[1] || (t[1] = function(s) {
      return a.onBlur(s);
    })
  }, a.getColumnPT("hiddenHeaderInput")), null, 16, XD)], 16), oe("div", Ce({
    ref: "box",
    class: e.cx("headerCheckbox")
  }, a.getColumnPT("headerCheckbox")), [n.headerCheckboxIconTemplate ? (E(), fe(tt(n.headerCheckboxIconTemplate), {
    key: 0,
    checked: n.checked,
    class: Pe(e.cx("headerCheckboxIcon"))
  }, null, 8, ["checked", "class"])) : !n.headerCheckboxIconTemplate && n.checked ? (E(), fe(r, Ce({
    key: 1,
    class: e.cx("headerCheckboxIcon")
  }, a.getColumnPT("headerCheckboxIcon")), null, 16, ["class"])) : te("", !0)], 16)], 16);
}
Om.render = ZD;
var Jw = {
  name: "HeaderCell",
  hostName: "DataTable",
  extends: wt,
  emits: ["column-click", "column-mousedown", "column-dragstart", "column-dragover", "column-dragleave", "column-drop", "column-resizestart", "checkbox-change", "filter-change", "filter-apply", "operator-change", "matchmode-change", "constraint-add", "constraint-remove", "filter-clear", "apply-click"],
  props: {
    column: {
      type: Object,
      default: null
    },
    index: {
      type: Number,
      default: null
    },
    resizableColumns: {
      type: Boolean,
      default: !1
    },
    groupRowsBy: {
      type: [Array, String, Function],
      default: null
    },
    sortMode: {
      type: String,
      default: "single"
    },
    groupRowSortField: {
      type: [String, Function],
      default: null
    },
    sortField: {
      type: [String, Function],
      default: null
    },
    sortOrder: {
      type: Number,
      default: null
    },
    multiSortMeta: {
      type: Array,
      default: null
    },
    allRowsSelected: {
      type: Boolean,
      default: !1
    },
    empty: {
      type: Boolean,
      default: !1
    },
    filterDisplay: {
      type: String,
      default: null
    },
    filters: {
      type: Object,
      default: null
    },
    filtersStore: {
      type: Object,
      default: null
    },
    filterColumn: {
      type: Boolean,
      default: !1
    },
    reorderableColumns: {
      type: Boolean,
      default: !1
    },
    filterInputProps: {
      type: null,
      default: null
    }
  },
  data: function() {
    return {
      styleObject: {}
    };
  },
  mounted: function() {
    this.columnProp("frozen") && this.updateStickyPosition();
  },
  updated: function() {
    this.columnProp("frozen") && this.updateStickyPosition();
  },
  methods: {
    columnProp: function(t) {
      return We.getVNodeProp(this.column, t);
    },
    getColumnPT: function(t) {
      var n, i, o = {
        props: this.column.props,
        parent: {
          instance: this,
          props: this.$props,
          state: this.$data
        },
        context: {
          index: this.index,
          sortable: this.column.props.sortable === "" || this.column.props.sortable,
          sorted: this.isColumnSorted(),
          resizable: this.resizableColumns,
          size: (n = this.$parentInstance) === null || n === void 0 || (n = n.$parentInstance) === null || n === void 0 ? void 0 : n.size,
          showGridlines: ((i = this.$parentInstance) === null || i === void 0 || (i = i.$parentInstance) === null || i === void 0 ? void 0 : i.showGridlines) || !1
        }
      };
      return Ce(this.ptm("column.".concat(t), {
        column: o
      }), this.ptm("column.".concat(t), o), this.ptmo(this.getColumnProp(), t, o));
    },
    getColumnProp: function() {
      return this.column.props && this.column.props.pt ? this.column.props.pt : void 0;
    },
    onClick: function(t) {
      this.$emit("column-click", {
        originalEvent: t,
        column: this.column
      });
    },
    onKeyDown: function(t) {
      (t.code === "Enter" || t.code === "NumpadEnter" || t.code === "Space") && t.currentTarget.nodeName === "TH" && Oe.getAttribute(t.currentTarget, "data-p-sortable-column") && (this.$emit("column-click", {
        originalEvent: t,
        column: this.column
      }), t.preventDefault());
    },
    onMouseDown: function(t) {
      this.$emit("column-mousedown", {
        originalEvent: t,
        column: this.column
      });
    },
    onDragStart: function(t) {
      this.$emit("column-dragstart", {
        originalEvent: t,
        column: this.column
      });
    },
    onDragOver: function(t) {
      this.$emit("column-dragover", {
        originalEvent: t,
        column: this.column
      });
    },
    onDragLeave: function(t) {
      this.$emit("column-dragleave", {
        originalEvent: t,
        column: this.column
      });
    },
    onDrop: function(t) {
      this.$emit("column-drop", {
        originalEvent: t,
        column: this.column
      });
    },
    onResizeStart: function(t) {
      this.$emit("column-resizestart", t);
    },
    getMultiSortMetaIndex: function() {
      var t = this;
      return this.multiSortMeta.findIndex(function(n) {
        return n.field === t.columnProp("field") || n.field === t.columnProp("sortField");
      });
    },
    getBadgeValue: function() {
      var t = this.getMultiSortMetaIndex();
      return this.groupRowsBy && this.groupRowsBy === this.groupRowSortField && t > -1 ? t : t + 1;
    },
    isMultiSorted: function() {
      return this.sortMode === "multiple" && this.columnProp("sortable") && this.getMultiSortMetaIndex() > -1;
    },
    isColumnSorted: function() {
      return this.sortMode === "single" ? this.sortField && (this.sortField === this.columnProp("field") || this.sortField === this.columnProp("sortField")) : this.isMultiSorted();
    },
    updateStickyPosition: function() {
      if (this.columnProp("frozen")) {
        var t = this.columnProp("alignFrozen");
        if (t === "right") {
          var n = 0, i = Oe.getNextElementSibling(this.$el, '[data-p-frozen-column="true"]');
          i && (n = Oe.getOuterWidth(i) + parseFloat(i.style.right || 0)), this.styleObject.right = n + "px";
        } else {
          var o = 0, a = Oe.getPreviousElementSibling(this.$el, '[data-p-frozen-column="true"]');
          a && (o = Oe.getOuterWidth(a) + parseFloat(a.style.left || 0)), this.styleObject.left = o + "px";
        }
        var r = this.$el.parentElement.nextElementSibling;
        if (r) {
          var s = Oe.index(this.$el);
          r.children[s] && (r.children[s].style.left = this.styleObject.left, r.children[s].style.right = this.styleObject.right);
        }
      }
    },
    onHeaderCheckboxChange: function(t) {
      this.$emit("checkbox-change", t);
    }
  },
  computed: {
    containerClass: function() {
      return [this.cx("headerCell"), this.filterColumn ? this.columnProp("filterHeaderClass") : this.columnProp("headerClass"), this.columnProp("class")];
    },
    containerStyle: function() {
      var t = this.filterColumn ? this.columnProp("filterHeaderStyle") : this.columnProp("headerStyle"), n = this.columnProp("style");
      return this.columnProp("frozen") ? [n, t, this.styleObject] : [n, t];
    },
    sortState: function() {
      var t = !1, n = null;
      if (this.sortMode === "single")
        t = this.sortField && (this.sortField === this.columnProp("field") || this.sortField === this.columnProp("sortField")), n = t ? this.sortOrder : 0;
      else if (this.sortMode === "multiple") {
        var i = this.getMultiSortMetaIndex();
        i > -1 && (t = !0, n = this.multiSortMeta[i].order);
      }
      return {
        sorted: t,
        sortOrder: n
      };
    },
    sortableColumnIcon: function() {
      var t = this.sortState, n = t.sorted, i = t.sortOrder;
      if (n) {
        if (n && i > 0)
          return Qp;
        if (n && i < 0)
          return Jp;
      } else
        return Zp;
      return null;
    },
    ariaSort: function() {
      if (this.columnProp("sortable")) {
        var t = this.sortState, n = t.sorted, i = t.sortOrder;
        return n && i < 0 ? "descending" : n && i > 0 ? "ascending" : "none";
      } else
        return null;
    }
  },
  components: {
    DTHeaderCheckbox: Om,
    DTColumnFilter: Mm,
    SortAltIcon: Zp,
    SortAmountUpAltIcon: Qp,
    SortAmountDownIcon: Jp
  }
};
function nc(e) {
  "@babel/helpers - typeof";
  return nc = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, nc(e);
}
function my(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    t && (i = i.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), n.push.apply(n, i);
  }
  return n;
}
function gy(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? my(Object(n), !0).forEach(function(i) {
      JD(e, i, n[i]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : my(Object(n)).forEach(function(i) {
      Object.defineProperty(e, i, Object.getOwnPropertyDescriptor(n, i));
    });
  }
  return e;
}
function JD(e, t, n) {
  return t = QD(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function QD(e) {
  var t = e2(e, "string");
  return nc(t) == "symbol" ? t : String(t);
}
function e2(e, t) {
  if (nc(e) != "object" || !e)
    return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var i = n.call(e, t || "default");
    if (nc(i) != "object")
      return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var t2 = ["tabindex", "colspan", "rowspan", "aria-sort", "data-p-sortable-column", "data-p-resizable-column", "data-p-highlight", "data-p-filter-column", "data-p-frozen-column", "data-p-reorderable-column"];
function n2(e, t, n, i, o, a) {
  var r = $e("DTHeaderCheckbox"), s = $e("DTColumnFilter");
  return E(), X("th", Ce({
    style: a.containerStyle,
    class: a.containerClass,
    tabindex: a.columnProp("sortable") ? "0" : null,
    role: "columnheader",
    colspan: a.columnProp("colspan"),
    rowspan: a.columnProp("rowspan"),
    "aria-sort": a.ariaSort,
    onClick: t[8] || (t[8] = function() {
      return a.onClick && a.onClick.apply(a, arguments);
    }),
    onKeydown: t[9] || (t[9] = function() {
      return a.onKeyDown && a.onKeyDown.apply(a, arguments);
    }),
    onMousedown: t[10] || (t[10] = function() {
      return a.onMouseDown && a.onMouseDown.apply(a, arguments);
    }),
    onDragstart: t[11] || (t[11] = function() {
      return a.onDragStart && a.onDragStart.apply(a, arguments);
    }),
    onDragover: t[12] || (t[12] = function() {
      return a.onDragOver && a.onDragOver.apply(a, arguments);
    }),
    onDragleave: t[13] || (t[13] = function() {
      return a.onDragLeave && a.onDragLeave.apply(a, arguments);
    }),
    onDrop: t[14] || (t[14] = function() {
      return a.onDrop && a.onDrop.apply(a, arguments);
    })
  }, gy(gy({}, a.getColumnPT("root")), a.getColumnPT("headerCell")), {
    "data-p-sortable-column": a.columnProp("sortable"),
    "data-p-resizable-column": n.resizableColumns,
    "data-p-highlight": a.isColumnSorted(),
    "data-p-filter-column": n.filterColumn,
    "data-p-frozen-column": a.columnProp("frozen"),
    "data-p-reorderable-column": n.reorderableColumns
  }), [n.resizableColumns && !a.columnProp("frozen") ? (E(), X("span", Ce({
    key: 0,
    class: e.cx("columnResizer"),
    onMousedown: t[0] || (t[0] = function() {
      return a.onResizeStart && a.onResizeStart.apply(a, arguments);
    })
  }, a.getColumnPT("columnResizer")), null, 16)) : te("", !0), oe("div", Ce({
    class: e.cx("headerContent")
  }, a.getColumnPT("headerContent")), [n.column.children && n.column.children.header ? (E(), fe(tt(n.column.children.header), {
    key: 0,
    column: n.column
  }, null, 8, ["column"])) : te("", !0), a.columnProp("header") ? (E(), X("span", Ce({
    key: 1,
    class: e.cx("headerTitle")
  }, a.getColumnPT("headerTitle")), Ie(a.columnProp("header")), 17)) : te("", !0), a.columnProp("sortable") ? (E(), X("span", si(Ce({
    key: 2
  }, a.getColumnPT("sort"))), [(E(), fe(tt(n.column.children && n.column.children.sorticon || a.sortableColumnIcon), Ce({
    sorted: a.sortState.sorted,
    sortOrder: a.sortState.sortOrder,
    class: e.cx("sortIcon")
  }, a.getColumnPT("sorticon"), {
    "data-pc-section": "sorticon"
  }), null, 16, ["sorted", "sortOrder", "class"]))], 16)) : te("", !0), a.isMultiSorted() ? (E(), X("span", Ce({
    key: 3,
    class: e.cx("sortBadge")
  }, a.getColumnPT("sortBadge")), Ie(a.getBadgeValue()), 17)) : te("", !0), a.columnProp("selectionMode") === "multiple" && n.filterDisplay !== "row" ? (E(), fe(r, {
    key: 4,
    checked: n.allRowsSelected,
    onChange: a.onHeaderCheckboxChange,
    disabled: n.empty,
    headerCheckboxIconTemplate: n.column.children && n.column.children.headercheckboxicon,
    column: n.column,
    pt: e.pt
  }, null, 8, ["checked", "onChange", "disabled", "headerCheckboxIconTemplate", "column", "pt"])) : te("", !0), n.filterDisplay === "menu" && n.column.children && n.column.children.filter ? (E(), fe(s, {
    key: 5,
    field: a.columnProp("filterField") || a.columnProp("field"),
    type: a.columnProp("dataType"),
    display: "menu",
    showMenu: a.columnProp("showFilterMenu"),
    filterElement: n.column.children && n.column.children.filter,
    filterHeaderTemplate: n.column.children && n.column.children.filterheader,
    filterFooterTemplate: n.column.children && n.column.children.filterfooter,
    filterClearTemplate: n.column.children && n.column.children.filterclear,
    filterApplyTemplate: n.column.children && n.column.children.filterapply,
    filterIconTemplate: n.column.children && n.column.children.filtericon,
    filterAddIconTemplate: n.column.children && n.column.children.filteraddicon,
    filterRemoveIconTemplate: n.column.children && n.column.children.filterremoveicon,
    filterClearIconTemplate: n.column.children && n.column.children.filterclearicon,
    filters: n.filters,
    filtersStore: n.filtersStore,
    filterInputProps: n.filterInputProps,
    onFilterChange: t[1] || (t[1] = function(l) {
      return e.$emit("filter-change", l);
    }),
    onFilterApply: t[2] || (t[2] = function(l) {
      return e.$emit("filter-apply");
    }),
    filterMenuStyle: a.columnProp("filterMenuStyle"),
    filterMenuClass: a.columnProp("filterMenuClass"),
    showOperator: a.columnProp("showFilterOperator"),
    showClearButton: a.columnProp("showClearButton"),
    showApplyButton: a.columnProp("showApplyButton"),
    showMatchModes: a.columnProp("showFilterMatchModes"),
    showAddButton: a.columnProp("showAddButton"),
    matchModeOptions: a.columnProp("filterMatchModeOptions"),
    maxConstraints: a.columnProp("maxConstraints"),
    onOperatorChange: t[3] || (t[3] = function(l) {
      return e.$emit("operator-change", l);
    }),
    onMatchmodeChange: t[4] || (t[4] = function(l) {
      return e.$emit("matchmode-change", l);
    }),
    onConstraintAdd: t[5] || (t[5] = function(l) {
      return e.$emit("constraint-add", l);
    }),
    onConstraintRemove: t[6] || (t[6] = function(l) {
      return e.$emit("constraint-remove", l);
    }),
    onApplyClick: t[7] || (t[7] = function(l) {
      return e.$emit("apply-click", l);
    }),
    column: n.column,
    unstyled: e.unstyled,
    pt: e.pt
  }, null, 8, ["field", "type", "showMenu", "filterElement", "filterHeaderTemplate", "filterFooterTemplate", "filterClearTemplate", "filterApplyTemplate", "filterIconTemplate", "filterAddIconTemplate", "filterRemoveIconTemplate", "filterClearIconTemplate", "filters", "filtersStore", "filterInputProps", "filterMenuStyle", "filterMenuClass", "showOperator", "showClearButton", "showApplyButton", "showMatchModes", "showAddButton", "matchModeOptions", "maxConstraints", "column", "unstyled", "pt"])) : te("", !0)], 16)], 16, t2);
}
Jw.render = n2;
var Qw = {
  name: "TableHeader",
  hostName: "DataTable",
  extends: wt,
  emits: ["column-click", "column-mousedown", "column-dragstart", "column-dragover", "column-dragleave", "column-drop", "column-resizestart", "checkbox-change", "filter-change", "filter-apply", "operator-change", "matchmode-change", "constraint-add", "constraint-remove", "filter-clear", "apply-click"],
  props: {
    columnGroup: {
      type: null,
      default: null
    },
    columns: {
      type: null,
      default: null
    },
    rowGroupMode: {
      type: String,
      default: null
    },
    groupRowsBy: {
      type: [Array, String, Function],
      default: null
    },
    resizableColumns: {
      type: Boolean,
      default: !1
    },
    allRowsSelected: {
      type: Boolean,
      default: !1
    },
    empty: {
      type: Boolean,
      default: !1
    },
    sortMode: {
      type: String,
      default: "single"
    },
    groupRowSortField: {
      type: [String, Function],
      default: null
    },
    sortField: {
      type: [String, Function],
      default: null
    },
    sortOrder: {
      type: Number,
      default: null
    },
    multiSortMeta: {
      type: Array,
      default: null
    },
    filterDisplay: {
      type: String,
      default: null
    },
    filters: {
      type: Object,
      default: null
    },
    filtersStore: {
      type: Object,
      default: null
    },
    reorderableColumns: {
      type: Boolean,
      default: !1
    },
    filterInputProps: {
      type: null,
      default: null
    }
  },
  provide: function() {
    return {
      $rows: this.d_headerRows,
      $columns: this.d_headerColumns
    };
  },
  data: function() {
    return {
      d_headerRows: new os({
        type: "Row"
      }),
      d_headerColumns: new os({
        type: "Column"
      })
    };
  },
  beforeUnmount: function() {
    this.d_headerRows.clear(), this.d_headerColumns.clear();
  },
  methods: {
    columnProp: function(t, n) {
      return We.getVNodeProp(t, n);
    },
    getColumnGroupPT: function(t) {
      var n, i = {
        props: this.getColumnGroupProps(),
        parent: {
          instance: this,
          props: this.$props,
          state: this.$data
        },
        context: {
          type: "header",
          scrollable: (n = this.$parentInstance) === null || n === void 0 || (n = n.$parentInstance) === null || n === void 0 ? void 0 : n.scrollable
        }
      };
      return Ce(this.ptm("columnGroup.".concat(t), {
        columnGroup: i
      }), this.ptm("columnGroup.".concat(t), i), this.ptmo(this.getColumnGroupProps(), t, i));
    },
    getColumnGroupProps: function() {
      return this.columnGroup && this.columnGroup.props && this.columnGroup.props.pt ? this.columnGroup.props.pt : void 0;
    },
    getRowPT: function(t, n, i) {
      var o = {
        props: t.props,
        parent: {
          instance: this,
          props: this.$props,
          state: this.$data
        },
        context: {
          index: i
        }
      };
      return Ce(this.ptm("row.".concat(n), {
        row: o
      }), this.ptm("row.".concat(n), o), this.ptmo(this.getRowProp(t), n, o));
    },
    getRowProp: function(t) {
      return t.props && t.props.pt ? t.props.pt : void 0;
    },
    getColumnPT: function(t, n, i) {
      var o = {
        props: t.props,
        parent: {
          instance: this,
          props: this.$props,
          state: this.$data
        },
        context: {
          index: i
        }
      };
      return Ce(this.ptm("column.".concat(n), {
        column: o
      }), this.ptm("column.".concat(n), o), this.ptmo(this.getColumnProp(t), n, o));
    },
    getColumnProp: function(t) {
      return t.props && t.props.pt ? t.props.pt : void 0;
    },
    getFilterColumnHeaderClass: function(t) {
      return [this.cx("headerCell", {
        column: t
      }), this.columnProp(t, "filterHeaderClass"), this.columnProp(t, "class")];
    },
    getFilterColumnHeaderStyle: function(t) {
      return [this.columnProp(t, "filterHeaderStyle"), this.columnProp(t, "style")];
    },
    getHeaderRows: function() {
      var t;
      return (t = this.d_headerRows) === null || t === void 0 ? void 0 : t.get(this.columnGroup, this.columnGroup.children);
    },
    getHeaderColumns: function(t) {
      var n;
      return (n = this.d_headerColumns) === null || n === void 0 ? void 0 : n.get(t, t.children);
    }
  },
  computed: {
    ptmTHeadOptions: function() {
      var t;
      return {
        context: {
          scrollable: (t = this.$parentInstance) === null || t === void 0 || (t = t.$parentInstance) === null || t === void 0 ? void 0 : t.scrollable
        }
      };
    }
  },
  components: {
    DTHeaderCell: Jw,
    DTHeaderCheckbox: Om,
    DTColumnFilter: Mm
  }
};
function ic(e) {
  "@babel/helpers - typeof";
  return ic = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, ic(e);
}
function vy(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    t && (i = i.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), n.push.apply(n, i);
  }
  return n;
}
function jr(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? vy(Object(n), !0).forEach(function(i) {
      i2(e, i, n[i]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : vy(Object(n)).forEach(function(i) {
      Object.defineProperty(e, i, Object.getOwnPropertyDescriptor(n, i));
    });
  }
  return e;
}
function i2(e, t, n) {
  return t = a2(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function a2(e) {
  var t = o2(e, "string");
  return ic(t) == "symbol" ? t : String(t);
}
function o2(e, t) {
  if (ic(e) != "object" || !e)
    return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var i = n.call(e, t || "default");
    if (ic(i) != "object")
      return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function r2(e, t, n, i, o, a) {
  var r = $e("DTHeaderCell"), s = $e("DTHeaderCheckbox"), l = $e("DTColumnFilter");
  return E(), X("thead", Ce({
    class: e.cx("thead"),
    style: e.sx("thead"),
    role: "rowgroup"
  }, n.columnGroup ? jr(jr({}, e.ptm("thead", a.ptmTHeadOptions)), a.getColumnGroupPT("root")) : e.ptm("thead", a.ptmTHeadOptions), {
    "data-pc-section": "thead"
  }), [n.columnGroup ? (E(!0), X(Re, {
    key: 1
  }, Ge(a.getHeaderRows(), function(d, y) {
    return E(), X("tr", Ce({
      key: y,
      role: "row"
    }, jr(jr({}, e.ptm("headerRow")), a.getRowPT(d, "root", y))), [(E(!0), X(Re, null, Ge(a.getHeaderColumns(d), function(u, m) {
      return E(), X(Re, {
        key: a.columnProp(u, "columnKey") || a.columnProp(u, "field") || m
      }, [!a.columnProp(u, "hidden") && (n.rowGroupMode !== "subheader" || n.groupRowsBy !== a.columnProp(u, "field")) && typeof u.children != "string" ? (E(), fe(r, {
        key: 0,
        column: u,
        onColumnClick: t[23] || (t[23] = function(h) {
          return e.$emit("column-click", h);
        }),
        onColumnMousedown: t[24] || (t[24] = function(h) {
          return e.$emit("column-mousedown", h);
        }),
        groupRowsBy: n.groupRowsBy,
        groupRowSortField: n.groupRowSortField,
        sortMode: n.sortMode,
        sortField: n.sortField,
        sortOrder: n.sortOrder,
        multiSortMeta: n.multiSortMeta,
        allRowsSelected: n.allRowsSelected,
        empty: n.empty,
        onCheckboxChange: t[25] || (t[25] = function(h) {
          return e.$emit("checkbox-change", h);
        }),
        filters: n.filters,
        filterDisplay: n.filterDisplay,
        filtersStore: n.filtersStore,
        onFilterChange: t[26] || (t[26] = function(h) {
          return e.$emit("filter-change", h);
        }),
        onFilterApply: t[27] || (t[27] = function(h) {
          return e.$emit("filter-apply");
        }),
        onOperatorChange: t[28] || (t[28] = function(h) {
          return e.$emit("operator-change", h);
        }),
        onMatchmodeChange: t[29] || (t[29] = function(h) {
          return e.$emit("matchmode-change", h);
        }),
        onConstraintAdd: t[30] || (t[30] = function(h) {
          return e.$emit("constraint-add", h);
        }),
        onConstraintRemove: t[31] || (t[31] = function(h) {
          return e.$emit("constraint-remove", h);
        }),
        onApplyClick: t[32] || (t[32] = function(h) {
          return e.$emit("apply-click", h);
        }),
        pt: e.pt
      }, null, 8, ["column", "groupRowsBy", "groupRowSortField", "sortMode", "sortField", "sortOrder", "multiSortMeta", "allRowsSelected", "empty", "filters", "filterDisplay", "filtersStore", "pt"])) : te("", !0)], 64);
    }), 128))], 16);
  }), 128)) : (E(), X(Re, {
    key: 0
  }, [oe("tr", Ce({
    role: "row"
  }, e.ptm("headerRow")), [(E(!0), X(Re, null, Ge(n.columns, function(d, y) {
    return E(), X(Re, {
      key: a.columnProp(d, "columnKey") || a.columnProp(d, "field") || y
    }, [!a.columnProp(d, "hidden") && (n.rowGroupMode !== "subheader" || n.groupRowsBy !== a.columnProp(d, "field")) ? (E(), fe(r, {
      key: 0,
      column: d,
      index: y,
      onColumnClick: t[0] || (t[0] = function(u) {
        return e.$emit("column-click", u);
      }),
      onColumnMousedown: t[1] || (t[1] = function(u) {
        return e.$emit("column-mousedown", u);
      }),
      onColumnDragstart: t[2] || (t[2] = function(u) {
        return e.$emit("column-dragstart", u);
      }),
      onColumnDragover: t[3] || (t[3] = function(u) {
        return e.$emit("column-dragover", u);
      }),
      onColumnDragleave: t[4] || (t[4] = function(u) {
        return e.$emit("column-dragleave", u);
      }),
      onColumnDrop: t[5] || (t[5] = function(u) {
        return e.$emit("column-drop", u);
      }),
      groupRowsBy: n.groupRowsBy,
      groupRowSortField: n.groupRowSortField,
      reorderableColumns: n.reorderableColumns,
      resizableColumns: n.resizableColumns,
      onColumnResizestart: t[6] || (t[6] = function(u) {
        return e.$emit("column-resizestart", u);
      }),
      sortMode: n.sortMode,
      sortField: n.sortField,
      sortOrder: n.sortOrder,
      multiSortMeta: n.multiSortMeta,
      allRowsSelected: n.allRowsSelected,
      empty: n.empty,
      onCheckboxChange: t[7] || (t[7] = function(u) {
        return e.$emit("checkbox-change", u);
      }),
      filters: n.filters,
      filterDisplay: n.filterDisplay,
      filtersStore: n.filtersStore,
      filterInputProps: n.filterInputProps,
      onFilterChange: t[8] || (t[8] = function(u) {
        return e.$emit("filter-change", u);
      }),
      onFilterApply: t[9] || (t[9] = function(u) {
        return e.$emit("filter-apply");
      }),
      onOperatorChange: t[10] || (t[10] = function(u) {
        return e.$emit("operator-change", u);
      }),
      onMatchmodeChange: t[11] || (t[11] = function(u) {
        return e.$emit("matchmode-change", u);
      }),
      onConstraintAdd: t[12] || (t[12] = function(u) {
        return e.$emit("constraint-add", u);
      }),
      onConstraintRemove: t[13] || (t[13] = function(u) {
        return e.$emit("constraint-remove", u);
      }),
      onApplyClick: t[14] || (t[14] = function(u) {
        return e.$emit("apply-click", u);
      }),
      pt: e.pt
    }, null, 8, ["column", "index", "groupRowsBy", "groupRowSortField", "reorderableColumns", "resizableColumns", "sortMode", "sortField", "sortOrder", "multiSortMeta", "allRowsSelected", "empty", "filters", "filterDisplay", "filtersStore", "filterInputProps", "pt"])) : te("", !0)], 64);
  }), 128))], 16), n.filterDisplay === "row" ? (E(), X("tr", Ce({
    key: 0,
    role: "row"
  }, e.ptm("headerRow")), [(E(!0), X(Re, null, Ge(n.columns, function(d, y) {
    return E(), X(Re, {
      key: a.columnProp(d, "columnKey") || a.columnProp(d, "field") || y
    }, [!a.columnProp(d, "hidden") && (n.rowGroupMode !== "subheader" || n.groupRowsBy !== a.columnProp(d, "field")) ? (E(), X("th", Ce({
      key: 0,
      style: a.getFilterColumnHeaderStyle(d),
      class: a.getFilterColumnHeaderClass(d)
    }, jr(jr({}, a.getColumnPT(d, "root", y)), a.getColumnPT(d, "headerCell", y))), [a.columnProp(d, "selectionMode") === "multiple" ? (E(), fe(s, {
      key: 0,
      checked: n.allRowsSelected,
      disabled: n.empty,
      onChange: t[15] || (t[15] = function(u) {
        return e.$emit("checkbox-change", u);
      }),
      column: d,
      pt: e.pt
    }, null, 8, ["checked", "disabled", "column", "pt"])) : te("", !0), d.children && d.children.filter ? (E(), fe(l, {
      key: 1,
      field: a.columnProp(d, "filterField") || a.columnProp(d, "field"),
      type: a.columnProp(d, "dataType"),
      display: "row",
      showMenu: a.columnProp(d, "showFilterMenu"),
      filterElement: d.children && d.children.filter,
      filterHeaderTemplate: d.children && d.children.filterheader,
      filterFooterTemplate: d.children && d.children.filterfooter,
      filterClearTemplate: d.children && d.children.filterclear,
      filterApplyTemplate: d.children && d.children.filterapply,
      filterIconTemplate: d.children && d.children.filtericon,
      filterAddIconTemplate: d.children && d.children.filteraddicon,
      filterRemoveIconTemplate: d.children && d.children.filterremoveicon,
      filterClearIconTemplate: d.children && d.children.filterclearicon,
      filters: n.filters,
      filtersStore: n.filtersStore,
      filterInputProps: n.filterInputProps,
      onFilterChange: t[16] || (t[16] = function(u) {
        return e.$emit("filter-change", u);
      }),
      onFilterApply: t[17] || (t[17] = function(u) {
        return e.$emit("filter-apply");
      }),
      filterMenuStyle: a.columnProp(d, "filterMenuStyle"),
      filterMenuClass: a.columnProp(d, "filterMenuClass"),
      showOperator: a.columnProp(d, "showFilterOperator"),
      showClearButton: a.columnProp(d, "showClearButton"),
      showApplyButton: a.columnProp(d, "showApplyButton"),
      showMatchModes: a.columnProp(d, "showFilterMatchModes"),
      showAddButton: a.columnProp(d, "showAddButton"),
      matchModeOptions: a.columnProp(d, "filterMatchModeOptions"),
      maxConstraints: a.columnProp(d, "maxConstraints"),
      onOperatorChange: t[18] || (t[18] = function(u) {
        return e.$emit("operator-change", u);
      }),
      onMatchmodeChange: t[19] || (t[19] = function(u) {
        return e.$emit("matchmode-change", u);
      }),
      onConstraintAdd: t[20] || (t[20] = function(u) {
        return e.$emit("constraint-add", u);
      }),
      onConstraintRemove: t[21] || (t[21] = function(u) {
        return e.$emit("constraint-remove", u);
      }),
      onApplyClick: t[22] || (t[22] = function(u) {
        return e.$emit("apply-click", u);
      }),
      column: d,
      unstyled: e.unstyled,
      pt: e.pt
    }, null, 8, ["field", "type", "showMenu", "filterElement", "filterHeaderTemplate", "filterFooterTemplate", "filterClearTemplate", "filterApplyTemplate", "filterIconTemplate", "filterAddIconTemplate", "filterRemoveIconTemplate", "filterClearIconTemplate", "filters", "filtersStore", "filterInputProps", "filterMenuStyle", "filterMenuClass", "showOperator", "showClearButton", "showApplyButton", "showMatchModes", "showAddButton", "matchModeOptions", "maxConstraints", "column", "unstyled", "pt"])) : te("", !0)], 16)) : te("", !0)], 64);
  }), 128))], 16)) : te("", !0)], 64))], 16);
}
Qw.render = r2;
function ac(e) {
  "@babel/helpers - typeof";
  return ac = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, ac(e);
}
var s2 = ["expanded"];
function l2(e, t) {
  if (e == null)
    return {};
  var n = c2(e, t), i, o;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (o = 0; o < a.length; o++)
      i = a[o], !(t.indexOf(i) >= 0) && Object.prototype.propertyIsEnumerable.call(e, i) && (n[i] = e[i]);
  }
  return n;
}
function c2(e, t) {
  if (e == null)
    return {};
  var n = {}, i = Object.keys(e), o, a;
  for (a = 0; a < i.length; a++)
    o = i[a], !(t.indexOf(o) >= 0) && (n[o] = e[o]);
  return n;
}
function yy(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    t && (i = i.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), n.push.apply(n, i);
  }
  return n;
}
function Zo(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? yy(Object(n), !0).forEach(function(i) {
      d2(e, i, n[i]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : yy(Object(n)).forEach(function(i) {
      Object.defineProperty(e, i, Object.getOwnPropertyDescriptor(n, i));
    });
  }
  return e;
}
function d2(e, t, n) {
  return t = u2(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function u2(e) {
  var t = h2(e, "string");
  return ac(t) == "symbol" ? t : String(t);
}
function h2(e, t) {
  if (ac(e) != "object" || !e)
    return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var i = n.call(e, t || "default");
    if (ac(i) != "object")
      return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function by(e, t) {
  return m2(e) || f2(e, t) || Bm(e, t) || p2();
}
function p2() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function f2(e, t) {
  var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var i, o, a, r, s = [], l = !0, d = !1;
    try {
      if (a = (n = n.call(e)).next, t === 0) {
        if (Object(n) !== n)
          return;
        l = !1;
      } else
        for (; !(l = (i = a.call(n)).done) && (s.push(i.value), s.length !== t); l = !0)
          ;
    } catch (y) {
      d = !0, o = y;
    } finally {
      try {
        if (!l && n.return != null && (r = n.return(), Object(r) !== r))
          return;
      } finally {
        if (d)
          throw o;
      }
    }
    return s;
  }
}
function m2(e) {
  if (Array.isArray(e))
    return e;
}
function nl(e, t) {
  var n = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (!n) {
    if (Array.isArray(e) || (n = Bm(e)) || t && e && typeof e.length == "number") {
      n && (e = n);
      var i = 0, o = function() {
      };
      return { s: o, n: function() {
        return i >= e.length ? { done: !0 } : { done: !1, value: e[i++] };
      }, e: function(d) {
        throw d;
      }, f: o };
    }
    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  var a = !0, r = !1, s;
  return { s: function() {
    n = n.call(e);
  }, n: function() {
    var d = n.next();
    return a = d.done, d;
  }, e: function(d) {
    r = !0, s = d;
  }, f: function() {
    try {
      !a && n.return != null && n.return();
    } finally {
      if (r)
        throw s;
    }
  } };
}
function kn(e) {
  return y2(e) || v2(e) || Bm(e) || g2();
}
function g2() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Bm(e, t) {
  if (e) {
    if (typeof e == "string")
      return ef(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set")
      return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return ef(e, t);
  }
}
function v2(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null)
    return Array.from(e);
}
function y2(e) {
  if (Array.isArray(e))
    return ef(e);
}
function ef(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, i = new Array(t); n < t; n++)
    i[n] = e[n];
  return i;
}
var Ku = {
  name: "DataTable",
  extends: tD,
  emits: ["value-change", "update:first", "update:rows", "page", "update:sortField", "update:sortOrder", "update:multiSortMeta", "sort", "filter", "row-click", "row-dblclick", "update:selection", "row-select", "row-unselect", "update:contextMenuSelection", "row-contextmenu", "row-unselect-all", "row-select-all", "select-all-change", "column-resize-end", "column-reorder", "row-reorder", "update:expandedRows", "row-collapse", "row-expand", "update:expandedRowGroups", "rowgroup-collapse", "rowgroup-expand", "update:filters", "state-restore", "state-save", "cell-edit-init", "cell-edit-complete", "cell-edit-cancel", "update:editingRows", "row-edit-init", "row-edit-save", "row-edit-cancel"],
  provide: function() {
    return {
      $columns: this.d_columns,
      $columnGroups: this.d_columnGroups
    };
  },
  data: function() {
    return {
      d_first: this.first,
      d_rows: this.rows,
      d_sortField: this.sortField,
      d_sortOrder: this.sortOrder,
      d_nullSortOrder: this.nullSortOrder,
      d_multiSortMeta: this.multiSortMeta ? kn(this.multiSortMeta) : [],
      d_groupRowsSortMeta: null,
      d_selectionKeys: null,
      d_columnOrder: null,
      d_editingRowKeys: null,
      d_editingMeta: {},
      d_filters: this.cloneFilters(this.filters),
      d_columns: new os({
        type: "Column"
      }),
      d_columnGroups: new os({
        type: "ColumnGroup"
      })
    };
  },
  rowTouched: !1,
  anchorRowIndex: null,
  rangeRowIndex: null,
  documentColumnResizeListener: null,
  documentColumnResizeEndListener: null,
  lastResizeHelperX: null,
  resizeColumnElement: null,
  columnResizing: !1,
  colReorderIconWidth: null,
  colReorderIconHeight: null,
  draggedColumn: null,
  draggedColumnElement: null,
  draggedRowIndex: null,
  droppedRowIndex: null,
  rowDragging: null,
  columnWidthsState: null,
  tableWidthState: null,
  columnWidthsRestored: !1,
  watch: {
    first: function(t) {
      this.d_first = t;
    },
    rows: function(t) {
      this.d_rows = t;
    },
    sortField: function(t) {
      this.d_sortField = t;
    },
    sortOrder: function(t) {
      this.d_sortOrder = t;
    },
    nullSortOrder: function(t) {
      this.d_nullSortOrder = t;
    },
    multiSortMeta: function(t) {
      this.d_multiSortMeta = t;
    },
    selection: {
      immediate: !0,
      handler: function(t) {
        this.dataKey && this.updateSelectionKeys(t);
      }
    },
    editingRows: {
      immediate: !0,
      handler: function(t) {
        this.dataKey && this.updateEditingRowKeys(t);
      }
    },
    filters: {
      deep: !0,
      handler: function(t) {
        this.d_filters = this.cloneFilters(t);
      }
    }
  },
  mounted: function() {
    this.$el.setAttribute(this.attributeSelector, ""), this.responsiveLayout === "stack" && !this.scrollable && !this.unstyled && this.createResponsiveStyle(), this.isStateful() && (this.restoreState(), this.resizableColumns && this.restoreColumnWidths()), this.editMode === "row" && this.dataKey && !this.d_editingRowKeys && this.updateEditingRowKeys(this.editingRows);
  },
  beforeUnmount: function() {
    this.unbindColumnResizeEvents(), this.destroyStyleElement(), this.destroyResponsiveStyle(), this.d_columns.clear(), this.d_columnGroups.clear();
  },
  updated: function() {
    this.isStateful() && this.saveState(), this.editMode === "row" && this.dataKey && !this.d_editingRowKeys && this.updateEditingRowKeys(this.editingRows);
  },
  methods: {
    columnProp: function(t, n) {
      return We.getVNodeProp(t, n);
    },
    onPage: function(t) {
      var n = this;
      this.clearEditingMetaData(), this.d_first = t.first, this.d_rows = t.rows;
      var i = this.createLazyLoadEvent(t);
      i.pageCount = t.pageCount, i.page = t.page, this.$emit("update:first", this.d_first), this.$emit("update:rows", this.d_rows), this.$emit("page", i), this.$nextTick(function() {
        n.$emit("value-change", n.processedData);
      });
    },
    onColumnHeaderClick: function(t) {
      var n = this, i = t.originalEvent, o = t.column;
      if (this.columnProp(o, "sortable")) {
        var a = i.target, r = this.columnProp(o, "sortField") || this.columnProp(o, "field");
        if (Oe.getAttribute(a, "data-p-sortable-column") === !0 || Oe.getAttribute(a, "data-pc-section") === "headertitle" || Oe.getAttribute(a, "data-pc-section") === "headercontent" || Oe.getAttribute(a, "data-pc-section") === "sorticon" || Oe.getAttribute(a.parentElement, "data-pc-section") === "sorticon" || Oe.getAttribute(a.parentElement.parentElement, "data-pc-section") === "sorticon" || a.closest('[data-p-sortable-column="true"]') && !a.closest('[data-pc-section="filtermenubutton"]') && !Oe.isClickable(i.target)) {
          if (Oe.clearSelection(), this.sortMode === "single")
            this.d_sortField === r ? this.removableSort && this.d_sortOrder * -1 === this.defaultSortOrder ? (this.d_sortOrder = null, this.d_sortField = null) : this.d_sortOrder = this.d_sortOrder * -1 : (this.d_sortOrder = this.defaultSortOrder, this.d_sortField = r), this.$emit("update:sortField", this.d_sortField), this.$emit("update:sortOrder", this.d_sortOrder), this.resetPage();
          else if (this.sortMode === "multiple") {
            var s = i.metaKey || i.ctrlKey;
            s || (this.d_multiSortMeta = this.d_multiSortMeta.filter(function(l) {
              return l.field === r;
            })), this.addMultiSortField(r), this.$emit("update:multiSortMeta", this.d_multiSortMeta);
          }
          this.$emit("sort", this.createLazyLoadEvent(i)), this.$nextTick(function() {
            n.$emit("value-change", n.processedData);
          });
        }
      }
    },
    sortSingle: function(t) {
      var n = this;
      if (this.clearEditingMetaData(), this.groupRowsBy && this.groupRowsBy === this.sortField)
        return this.d_multiSortMeta = [{
          field: this.sortField,
          order: this.sortOrder || this.defaultSortOrder
        }, {
          field: this.d_sortField,
          order: this.d_sortOrder
        }], this.sortMultiple(t);
      var i = kn(t), o = /* @__PURE__ */ new Map(), a = nl(i), r;
      try {
        for (a.s(); !(r = a.n()).done; ) {
          var s = r.value;
          o.set(s, We.resolveFieldData(s, this.d_sortField));
        }
      } catch (d) {
        a.e(d);
      } finally {
        a.f();
      }
      var l = We.localeComparator();
      return i.sort(function(d, y) {
        var u = o.get(d), m = o.get(y);
        return We.sort(u, m, n.d_sortOrder, l, n.d_nullSortOrder);
      }), i;
    },
    sortMultiple: function(t) {
      var n = this;
      if (this.clearEditingMetaData(), this.groupRowsBy && (this.d_groupRowsSortMeta || this.d_multiSortMeta.length && this.groupRowsBy === this.d_multiSortMeta[0].field)) {
        var i = this.d_multiSortMeta[0];
        !this.d_groupRowsSortMeta && (this.d_groupRowsSortMeta = i), i.field !== this.d_groupRowsSortMeta.field && (this.d_multiSortMeta = [this.d_groupRowsSortMeta].concat(kn(this.d_multiSortMeta)));
      }
      var o = kn(t);
      return o.sort(function(a, r) {
        return n.multisortField(a, r, 0);
      }), o;
    },
    multisortField: function(t, n, i) {
      var o = We.resolveFieldData(t, this.d_multiSortMeta[i].field), a = We.resolveFieldData(n, this.d_multiSortMeta[i].field), r = We.localeComparator();
      return o === a ? this.d_multiSortMeta.length - 1 > i ? this.multisortField(t, n, i + 1) : 0 : We.sort(o, a, this.d_multiSortMeta[i].order, r, this.d_nullSortOrder);
    },
    addMultiSortField: function(t) {
      var n = this.d_multiSortMeta.findIndex(function(i) {
        return i.field === t;
      });
      n >= 0 ? this.removableSort && this.d_multiSortMeta[n].order * -1 === this.defaultSortOrder ? this.d_multiSortMeta.splice(n, 1) : this.d_multiSortMeta[n] = {
        field: t,
        order: this.d_multiSortMeta[n].order * -1
      } : this.d_multiSortMeta.push({
        field: t,
        order: this.defaultSortOrder
      }), this.d_multiSortMeta = kn(this.d_multiSortMeta);
    },
    getActiveFilters: function(t) {
      var n = function(r) {
        var s = by(r, 2), l = s[0], d = s[1];
        if (d.constraints) {
          var y = d.constraints.filter(function(u) {
            return u.value !== null;
          });
          if (y.length > 0)
            return [l, Zo(Zo({}, d), {}, {
              constraints: y
            })];
        } else if (d.value !== null)
          return [l, d];
      }, i = function(r) {
        return r !== void 0;
      }, o = Object.entries(t).map(n).filter(i);
      return Object.fromEntries(o);
    },
    filter: function(t) {
      var n = this;
      if (t) {
        this.clearEditingMetaData();
        var i = this.getActiveFilters(this.filters), o;
        i.global && (o = this.globalFilterFields || this.columns.map(function(w) {
          return n.columnProp(w, "filterField") || n.columnProp(w, "field");
        }));
        for (var a = [], r = 0; r < t.length; r++) {
          var s = !0, l = !1, d = !1;
          for (var y in i)
            if (Object.prototype.hasOwnProperty.call(i, y) && y !== "global") {
              d = !0;
              var u = y, m = i[u];
              if (m.operator) {
                var h = nl(m.constraints), c;
                try {
                  for (h.s(); !(c = h.n()).done; ) {
                    var g = c.value;
                    if (s = this.executeLocalFilter(u, t[r], g), m.operator === du.OR && s || m.operator === du.AND && !s)
                      break;
                  }
                } catch (w) {
                  h.e(w);
                } finally {
                  h.f();
                }
              } else
                s = this.executeLocalFilter(u, t[r], m);
              if (!s)
                break;
            }
          if (s && i.global && !l && o)
            for (var v = 0; v < o.length; v++) {
              var P = o[v];
              if (l = El.filters[i.global.matchMode || Hn.CONTAINS](We.resolveFieldData(t[r], P), i.global.value, this.filterLocale), l)
                break;
            }
          var f = void 0;
          i.global ? f = d ? d && s && l : l : f = d && s, f && a.push(t[r]);
        }
        (a.length === this.value.length || Object.keys(i).length == 0) && (a = t);
        var S = this.createLazyLoadEvent();
        return S.filteredValue = a, this.$emit("filter", S), this.$nextTick(function() {
          n.$emit("value-change", n.processedData);
        }), a;
      }
    },
    executeLocalFilter: function(t, n, i) {
      var o = i.value, a = i.matchMode || Hn.STARTS_WITH, r = We.resolveFieldData(n, t), s = El.filters[a];
      return s(r, o, this.filterLocale);
    },
    onRowClick: function(t) {
      var n = t.originalEvent, i = this.$refs.bodyRef && this.$refs.bodyRef.$el, o = Oe.findSingle(i, 'tr[data-p-selectable-row="true"][tabindex="0"]');
      if (!Oe.isClickable(n.target)) {
        if (this.$emit("row-click", t), this.selectionMode) {
          var a = t.data, r = this.d_first + t.index;
          if (this.isMultipleSelectionMode() && n.shiftKey && this.anchorRowIndex != null)
            Oe.clearSelection(), this.rangeRowIndex = r, this.selectRange(n);
          else {
            var s = this.isSelected(a), l = this.rowTouched ? !1 : this.metaKeySelection;
            if (this.anchorRowIndex = r, this.rangeRowIndex = r, l) {
              var d = n.metaKey || n.ctrlKey;
              if (s && d) {
                if (this.isSingleSelectionMode())
                  this.$emit("update:selection", null);
                else {
                  var y = this.findIndexInSelection(a), u = this.selection.filter(function(P, f) {
                    return f != y;
                  });
                  this.$emit("update:selection", u);
                }
                this.$emit("row-unselect", {
                  originalEvent: n,
                  data: a,
                  index: r,
                  type: "row"
                });
              } else {
                if (this.isSingleSelectionMode())
                  this.$emit("update:selection", a);
                else if (this.isMultipleSelectionMode()) {
                  var m = d ? this.selection || [] : [];
                  m = [].concat(kn(m), [a]), this.$emit("update:selection", m);
                }
                this.$emit("row-select", {
                  originalEvent: n,
                  data: a,
                  index: r,
                  type: "row"
                });
              }
            } else if (this.selectionMode === "single")
              s ? (this.$emit("update:selection", null), this.$emit("row-unselect", {
                originalEvent: n,
                data: a,
                index: r,
                type: "row"
              })) : (this.$emit("update:selection", a), this.$emit("row-select", {
                originalEvent: n,
                data: a,
                index: r,
                type: "row"
              }));
            else if (this.selectionMode === "multiple")
              if (s) {
                var h = this.findIndexInSelection(a), c = this.selection.filter(function(P, f) {
                  return f != h;
                });
                this.$emit("update:selection", c), this.$emit("row-unselect", {
                  originalEvent: n,
                  data: a,
                  index: r,
                  type: "row"
                });
              } else {
                var g = this.selection ? [].concat(kn(this.selection), [a]) : [a];
                this.$emit("update:selection", g), this.$emit("row-select", {
                  originalEvent: n,
                  data: a,
                  index: r,
                  type: "row"
                });
              }
          }
        }
        if (this.rowTouched = !1, o) {
          if (t.originalEvent.target.getAttribute("data-pc-section") === "rowtogglericon" || t.originalEvent.target.parentElement.getAttribute("data-pc-section") === "rowtogglericon")
            return;
          var v = t.originalEvent.target.closest('tr[data-p-selectable-row="true"]');
          o.tabIndex = "-1", v.tabIndex = "0";
        }
      }
    },
    onRowDblClick: function(t) {
      var n = t.originalEvent;
      Oe.isClickable(n.target) || this.$emit("row-dblclick", t);
    },
    onRowRightClick: function(t) {
      this.contextMenu && (Oe.clearSelection(), t.originalEvent.target.focus()), this.$emit("update:contextMenuSelection", t.data), this.$emit("row-contextmenu", t);
    },
    onRowTouchEnd: function() {
      this.rowTouched = !0;
    },
    onRowKeyDown: function(t, n) {
      var i = t.originalEvent, o = t.data, a = t.index, r = i.metaKey || i.ctrlKey;
      if (this.selectionMode) {
        var s = i.target;
        switch (i.code) {
          case "ArrowDown":
            this.onArrowDownKey(i, s, a, n);
            break;
          case "ArrowUp":
            this.onArrowUpKey(i, s, a, n);
            break;
          case "Home":
            this.onHomeKey(i, s, a, n);
            break;
          case "End":
            this.onEndKey(i, s, a, n);
            break;
          case "Enter":
          case "NumpadEnter":
            this.onEnterKey(i, o, a);
            break;
          case "Space":
            this.onSpaceKey(i, o, a, n);
            break;
          case "Tab":
            this.onTabKey(i, a);
            break;
          default:
            if (i.code === "KeyA" && r) {
              var l = this.dataToRender(n.rows);
              this.$emit("update:selection", l), i.preventDefault();
            }
            break;
        }
      }
    },
    onArrowDownKey: function(t, n, i, o) {
      var a = this.findNextSelectableRow(n);
      if (a && this.focusRowChange(n, a), t.shiftKey) {
        var r = this.dataToRender(o.rows), s = i + 1 >= r.length ? r.length - 1 : i + 1;
        this.onRowClick({
          originalEvent: t,
          data: r[s],
          index: s
        });
      }
      t.preventDefault();
    },
    onArrowUpKey: function(t, n, i, o) {
      var a = this.findPrevSelectableRow(n);
      if (a && this.focusRowChange(n, a), t.shiftKey) {
        var r = this.dataToRender(o.rows), s = i - 1 <= 0 ? 0 : i - 1;
        this.onRowClick({
          originalEvent: t,
          data: r[s],
          index: s
        });
      }
      t.preventDefault();
    },
    onHomeKey: function(t, n, i, o) {
      var a = this.findFirstSelectableRow();
      if (a && this.focusRowChange(n, a), t.ctrlKey && t.shiftKey) {
        var r = this.dataToRender(o.rows);
        this.$emit("update:selection", r.slice(0, i + 1));
      }
      t.preventDefault();
    },
    onEndKey: function(t, n, i, o) {
      var a = this.findLastSelectableRow();
      if (a && this.focusRowChange(n, a), t.ctrlKey && t.shiftKey) {
        var r = this.dataToRender(o.rows);
        this.$emit("update:selection", r.slice(i, r.length));
      }
      t.preventDefault();
    },
    onEnterKey: function(t, n, i) {
      this.onRowClick({
        originalEvent: t,
        data: n,
        index: i
      }), t.preventDefault();
    },
    onSpaceKey: function(t, n, i, o) {
      if (this.onEnterKey(t, n, i), t.shiftKey && this.selection !== null) {
        var a = this.dataToRender(o.rows), r;
        if (this.selection.length > 0) {
          var s, l;
          s = We.findIndexInList(this.selection[0], a), l = We.findIndexInList(this.selection[this.selection.length - 1], a), r = i <= s ? l : s;
        } else
          r = We.findIndexInList(this.selection, a);
        var d = r !== i ? a.slice(Math.min(r, i), Math.max(r, i) + 1) : n;
        this.$emit("update:selection", d);
      }
    },
    onTabKey: function(t, n) {
      var i = this.$refs.bodyRef && this.$refs.bodyRef.$el, o = Oe.find(i, 'tr[data-p-selectable-row="true"]');
      if (t.code === "Tab" && o && o.length > 0) {
        var a = Oe.findSingle(i, 'tr[data-p-highlight="true"]'), r = Oe.findSingle(i, 'tr[data-p-selectable-row="true"][tabindex="0"]');
        a ? (a.tabIndex = "0", r && r !== a && (r.tabIndex = "-1")) : (o[0].tabIndex = "0", r !== o[0] && (o[n].tabIndex = "-1"));
      }
    },
    findNextSelectableRow: function(t) {
      var n = t.nextElementSibling;
      return n ? Oe.getAttribute(n, "data-p-selectable-row") === !0 ? n : this.findNextSelectableRow(n) : null;
    },
    findPrevSelectableRow: function(t) {
      var n = t.previousElementSibling;
      return n ? Oe.getAttribute(n, "data-p-selectable-row") === !0 ? n : this.findPrevSelectableRow(n) : null;
    },
    findFirstSelectableRow: function() {
      var t = Oe.findSingle(this.$refs.table, 'tr[data-p-selectable-row="true"]');
      return t;
    },
    findLastSelectableRow: function() {
      var t = Oe.find(this.$refs.table, 'tr[data-p-selectable-row="true"]');
      return t ? t[t.length - 1] : null;
    },
    focusRowChange: function(t, n) {
      t.tabIndex = "-1", n.tabIndex = "0", Oe.focus(n);
    },
    toggleRowWithRadio: function(t) {
      var n = t.data;
      this.isSelected(n) ? (this.$emit("update:selection", null), this.$emit("row-unselect", {
        originalEvent: t.originalEvent,
        data: n,
        index: t.index,
        type: "radiobutton"
      })) : (this.$emit("update:selection", n), this.$emit("row-select", {
        originalEvent: t.originalEvent,
        data: n,
        index: t.index,
        type: "radiobutton"
      }));
    },
    toggleRowWithCheckbox: function(t) {
      var n = t.data;
      if (this.isSelected(n)) {
        var i = this.findIndexInSelection(n), o = this.selection.filter(function(r, s) {
          return s != i;
        });
        this.$emit("update:selection", o), this.$emit("row-unselect", {
          originalEvent: t.originalEvent,
          data: n,
          index: t.index,
          type: "checkbox"
        });
      } else {
        var a = this.selection ? kn(this.selection) : [];
        a = [].concat(kn(a), [n]), this.$emit("update:selection", a), this.$emit("row-select", {
          originalEvent: t.originalEvent,
          data: n,
          index: t.index,
          type: "checkbox"
        });
      }
    },
    toggleRowsWithCheckbox: function(t) {
      if (this.selectAll !== null)
        this.$emit("select-all-change", t);
      else {
        var n = t.originalEvent, i = t.checked, o = [];
        i ? (o = this.frozenValue ? [].concat(kn(this.frozenValue), kn(this.processedData)) : this.processedData, this.$emit("row-select-all", {
          originalEvent: n,
          data: o
        })) : this.$emit("row-unselect-all", {
          originalEvent: n
        }), this.$emit("update:selection", o);
      }
    },
    isSingleSelectionMode: function() {
      return this.selectionMode === "single";
    },
    isMultipleSelectionMode: function() {
      return this.selectionMode === "multiple";
    },
    isSelected: function(t) {
      return t && this.selection ? this.dataKey ? this.d_selectionKeys ? this.d_selectionKeys[We.resolveFieldData(t, this.dataKey)] !== void 0 : !1 : this.selection instanceof Array ? this.findIndexInSelection(t) > -1 : this.equals(t, this.selection) : !1;
    },
    findIndexInSelection: function(t) {
      return this.findIndex(t, this.selection);
    },
    findIndex: function(t, n) {
      var i = -1;
      if (n && n.length) {
        for (var o = 0; o < n.length; o++)
          if (this.equals(t, n[o])) {
            i = o;
            break;
          }
      }
      return i;
    },
    updateSelectionKeys: function(t) {
      if (this.d_selectionKeys = {}, Array.isArray(t)) {
        var n = nl(t), i;
        try {
          for (n.s(); !(i = n.n()).done; ) {
            var o = i.value;
            this.d_selectionKeys[String(We.resolveFieldData(o, this.dataKey))] = 1;
          }
        } catch (a) {
          n.e(a);
        } finally {
          n.f();
        }
      } else
        this.d_selectionKeys[String(We.resolveFieldData(t, this.dataKey))] = 1;
    },
    updateEditingRowKeys: function(t) {
      if (t && t.length) {
        this.d_editingRowKeys = {};
        var n = nl(t), i;
        try {
          for (n.s(); !(i = n.n()).done; ) {
            var o = i.value;
            this.d_editingRowKeys[String(We.resolveFieldData(o, this.dataKey))] = 1;
          }
        } catch (a) {
          n.e(a);
        } finally {
          n.f();
        }
      } else
        this.d_editingRowKeys = null;
    },
    equals: function(t, n) {
      return this.compareSelectionBy === "equals" ? t === n : We.equals(t, n, this.dataKey);
    },
    selectRange: function(t) {
      var n, i;
      this.rangeRowIndex > this.anchorRowIndex ? (n = this.anchorRowIndex, i = this.rangeRowIndex) : this.rangeRowIndex < this.anchorRowIndex ? (n = this.rangeRowIndex, i = this.anchorRowIndex) : (n = this.rangeRowIndex, i = this.rangeRowIndex), this.lazy && this.paginator && (n -= this.first, i -= this.first);
      for (var o = this.processedData, a = [], r = n; r <= i; r++) {
        var s = o[r];
        a.push(s), this.$emit("row-select", {
          originalEvent: t,
          data: s,
          type: "row"
        });
      }
      this.$emit("update:selection", a);
    },
    exportCSV: function(t, n) {
      var i = this, o = "\uFEFF";
      n || (n = this.processedData, t && t.selectionOnly ? n = this.selection || [] : this.frozenValue && (n = n ? [].concat(kn(this.frozenValue), kn(n)) : this.frozenValue));
      for (var a = !1, r = 0; r < this.columns.length; r++) {
        var s = this.columns[r];
        this.columnProp(s, "exportable") !== !1 && this.columnProp(s, "field") && (a ? o += this.csvSeparator : a = !0, o += '"' + (this.columnProp(s, "exportHeader") || this.columnProp(s, "header") || this.columnProp(s, "field")) + '"');
      }
      n && n.forEach(function(u) {
        o += `
`;
        for (var m = !1, h = 0; h < i.columns.length; h++) {
          var c = i.columns[h];
          if (i.columnProp(c, "exportable") !== !1 && i.columnProp(c, "field")) {
            m ? o += i.csvSeparator : m = !0;
            var g = We.resolveFieldData(u, i.columnProp(c, "field"));
            g != null ? i.exportFunction ? g = i.exportFunction({
              data: g,
              field: i.columnProp(c, "field")
            }) : g = String(g).replace(/"/g, '""') : g = "", o += '"' + g + '"';
          }
        }
      });
      for (var l = !1, d = 0; d < this.columns.length; d++) {
        var y = this.columns[d];
        d === 0 && (o += `
`), this.columnProp(y, "exportable") !== !1 && this.columnProp(y, "exportFooter") && (l ? o += this.csvSeparator : l = !0, o += '"' + (this.columnProp(y, "exportFooter") || this.columnProp(y, "footer") || this.columnProp(y, "field")) + '"');
      }
      Oe.exportCSV(o, this.exportFilename);
    },
    resetPage: function() {
      this.d_first = 0, this.$emit("update:first", this.d_first);
    },
    onColumnResizeStart: function(t) {
      var n = Oe.getOffset(this.$el).left;
      this.resizeColumnElement = t.target.parentElement, this.columnResizing = !0, this.lastResizeHelperX = t.pageX - n + this.$el.scrollLeft, this.bindColumnResizeEvents();
    },
    onColumnResize: function(t) {
      var n = Oe.getOffset(this.$el).left;
      this.$el.setAttribute("data-p-unselectable-text", "true"), !this.isUnstyled && Oe.addClass(this.$el, "p-unselectable-text"), this.$refs.resizeHelper.style.height = this.$el.offsetHeight + "px", this.$refs.resizeHelper.style.top = "0px", this.$refs.resizeHelper.style.left = t.pageX - n + this.$el.scrollLeft + "px", this.$refs.resizeHelper.style.display = "block";
    },
    onColumnResizeEnd: function() {
      var t = this.$refs.resizeHelper.offsetLeft - this.lastResizeHelperX, n = this.resizeColumnElement.offsetWidth, i = n + t, o = this.resizeColumnElement.style.minWidth || 15;
      if (n + t > parseInt(o, 10)) {
        if (this.columnResizeMode === "fit") {
          var a = this.resizeColumnElement.nextElementSibling, r = a.offsetWidth - t;
          i > 15 && r > 15 && this.resizeTableCells(i, r);
        } else if (this.columnResizeMode === "expand") {
          var s = this.$refs.table.offsetWidth + t + "px", l = function(m) {
            m && (m.style.width = m.style.minWidth = s);
          };
          if (this.resizeTableCells(i), l(this.$refs.table), !this.virtualScrollerDisabled) {
            var d = this.$refs.bodyRef && this.$refs.bodyRef.$el, y = this.$refs.frozenBodyRef && this.$refs.frozenBodyRef.$el;
            l(d), l(y);
          }
        }
        this.$emit("column-resize-end", {
          element: this.resizeColumnElement,
          delta: t
        });
      }
      this.$refs.resizeHelper.style.display = "none", this.resizeColumn = null, this.$el.setAttribute("data-p-unselectable-text", "true"), !this.isUnstyled && Oe.removeClass(this.$el, "p-unselectable-text"), this.unbindColumnResizeEvents(), this.isStateful() && this.saveState();
    },
    resizeTableCells: function(t, n) {
      var i = Oe.index(this.resizeColumnElement), o = [], a = Oe.find(this.$refs.table, 'thead[data-pc-section="thead"] > tr > th');
      a.forEach(function(l) {
        return o.push(Oe.getOuterWidth(l));
      }), this.destroyStyleElement(), this.createStyleElement();
      var r = "", s = '[data-pc-name="datatable"]['.concat(this.attributeSelector, '] > [data-pc-section="wrapper"] ').concat(this.virtualScrollerDisabled ? "" : '> [data-pc-name="virtualscroller"]', ' > table[data-pc-section="table"]');
      o.forEach(function(l, d) {
        var y = d === i ? t : n && d === i + 1 ? n : l, u = "width: ".concat(y, "px !important; max-width: ").concat(y, "px !important");
        r += `
                    `.concat(s, ' > thead[data-pc-section="thead"] > tr > th:nth-child(').concat(d + 1, `),
                    `).concat(s, ' > tbody[data-pc-section="tbody"] > tr > td:nth-child(').concat(d + 1, `),
                    `).concat(s, ' > tfoot[data-pc-section="tfoot"] > tr > td:nth-child(').concat(d + 1, `) {
                        `).concat(u, `
                    }
                `);
      }), this.styleElement.innerHTML = r;
    },
    bindColumnResizeEvents: function() {
      var t = this;
      this.documentColumnResizeListener || (this.documentColumnResizeListener = document.addEventListener("mousemove", function() {
        t.columnResizing && t.onColumnResize(event);
      })), this.documentColumnResizeEndListener || (this.documentColumnResizeEndListener = document.addEventListener("mouseup", function() {
        t.columnResizing && (t.columnResizing = !1, t.onColumnResizeEnd());
      }));
    },
    unbindColumnResizeEvents: function() {
      this.documentColumnResizeListener && (document.removeEventListener("document", this.documentColumnResizeListener), this.documentColumnResizeListener = null), this.documentColumnResizeEndListener && (document.removeEventListener("document", this.documentColumnResizeEndListener), this.documentColumnResizeEndListener = null);
    },
    onColumnHeaderMouseDown: function(t) {
      var n = t.originalEvent, i = t.column;
      this.reorderableColumns && this.columnProp(i, "reorderableColumn") !== !1 && (n.target.nodeName === "INPUT" || n.target.nodeName === "TEXTAREA" || Oe.getAttribute(n.target, '[data-pc-section="columnresizer"]') ? n.currentTarget.draggable = !1 : n.currentTarget.draggable = !0);
    },
    onColumnHeaderDragStart: function(t) {
      var n = t.originalEvent, i = t.column;
      if (this.columnResizing) {
        n.preventDefault();
        return;
      }
      this.colReorderIconWidth = Oe.getHiddenElementOuterWidth(this.$refs.reorderIndicatorUp), this.colReorderIconHeight = Oe.getHiddenElementOuterHeight(this.$refs.reorderIndicatorUp), this.draggedColumn = i, this.draggedColumnElement = this.findParentHeader(n.target), n.dataTransfer.setData("text", "b");
    },
    onColumnHeaderDragOver: function(t) {
      var n = t.originalEvent, i = t.column, o = this.findParentHeader(n.target);
      if (this.reorderableColumns && this.draggedColumnElement && o && !this.columnProp(i, "frozen")) {
        n.preventDefault();
        var a = Oe.getOffset(this.$el), r = Oe.getOffset(o);
        if (this.draggedColumnElement !== o) {
          var s = r.left - a.left, l = r.left + o.offsetWidth / 2;
          this.$refs.reorderIndicatorUp.style.top = r.top - a.top - (this.colReorderIconHeight - 1) + "px", this.$refs.reorderIndicatorDown.style.top = r.top - a.top + o.offsetHeight + "px", n.pageX > l ? (this.$refs.reorderIndicatorUp.style.left = s + o.offsetWidth - Math.ceil(this.colReorderIconWidth / 2) + "px", this.$refs.reorderIndicatorDown.style.left = s + o.offsetWidth - Math.ceil(this.colReorderIconWidth / 2) + "px", this.dropPosition = 1) : (this.$refs.reorderIndicatorUp.style.left = s - Math.ceil(this.colReorderIconWidth / 2) + "px", this.$refs.reorderIndicatorDown.style.left = s - Math.ceil(this.colReorderIconWidth / 2) + "px", this.dropPosition = -1), this.$refs.reorderIndicatorUp.style.display = "block", this.$refs.reorderIndicatorDown.style.display = "block";
        }
      }
    },
    onColumnHeaderDragLeave: function(t) {
      var n = t.originalEvent;
      this.reorderableColumns && this.draggedColumnElement && (n.preventDefault(), this.$refs.reorderIndicatorUp.style.display = "none", this.$refs.reorderIndicatorDown.style.display = "none");
    },
    onColumnHeaderDrop: function(t) {
      var n = this, i = t.originalEvent, o = t.column;
      if (i.preventDefault(), this.draggedColumnElement) {
        var a = Oe.index(this.draggedColumnElement), r = Oe.index(this.findParentHeader(i.target)), s = a !== r;
        if (s && (r - a === 1 && this.dropPosition === -1 || r - a === -1 && this.dropPosition === 1) && (s = !1), s) {
          var l = function(P, f) {
            return n.columnProp(P, "columnKey") || n.columnProp(f, "columnKey") ? n.columnProp(P, "columnKey") === n.columnProp(f, "columnKey") : n.columnProp(P, "field") === n.columnProp(f, "field");
          }, d = this.columns.findIndex(function(v) {
            return l(v, n.draggedColumn);
          }), y = this.columns.findIndex(function(v) {
            return l(v, o);
          }), u = [], m = Oe.find(this.$el, 'thead[data-pc-section="thead"] > tr > th');
          m.forEach(function(v) {
            return u.push(Oe.getOuterWidth(v));
          });
          var h = u.find(function(v, P) {
            return P === d;
          }), c = u.filter(function(v, P) {
            return P !== d;
          }), g = [].concat(kn(c.slice(0, y)), [h], kn(c.slice(y)));
          this.addColumnWidthStyles(g), y < d && this.dropPosition === 1 && y++, y > d && this.dropPosition === -1 && y--, We.reorderArray(this.columns, d, y), this.updateReorderableColumns(), this.$emit("column-reorder", {
            originalEvent: i,
            dragIndex: d,
            dropIndex: y
          });
        }
        this.$refs.reorderIndicatorUp.style.display = "none", this.$refs.reorderIndicatorDown.style.display = "none", this.draggedColumnElement.draggable = !1, this.draggedColumnElement = null, this.draggedColumn = null, this.dropPosition = null;
      }
    },
    findParentHeader: function(t) {
      if (t.nodeName === "TH")
        return t;
      for (var n = t.parentElement; n.nodeName !== "TH" && (n = n.parentElement, !!n); )
        ;
      return n;
    },
    findColumnByKey: function(t, n) {
      if (t && t.length)
        for (var i = 0; i < t.length; i++) {
          var o = t[i];
          if (this.columnProp(o, "columnKey") === n || this.columnProp(o, "field") === n)
            return o;
        }
      return null;
    },
    onRowMouseDown: function(t) {
      Oe.getAttribute(t.target, "data-pc-section") === "rowreordericon" || Oe.getAttribute(t.target.parentElement, "data-pc-section") === "rowreordericon" ? t.currentTarget.draggable = !0 : t.currentTarget.draggable = !1;
    },
    onRowDragStart: function(t) {
      var n = t.originalEvent, i = t.index;
      this.rowDragging = !0, this.draggedRowIndex = i, n.dataTransfer.setData("text", "b");
    },
    onRowDragOver: function(t) {
      var n = t.originalEvent, i = t.index;
      if (this.rowDragging && this.draggedRowIndex !== i) {
        var o = n.currentTarget, a = Oe.getOffset(o).top + Oe.getWindowScrollTop(), r = n.pageY, s = a + Oe.getOuterHeight(o) / 2, l = o.previousElementSibling;
        r < s ? (o.setAttribute("data-p-datatable-dragpoint-bottom", "false"), !this.isUnstyled && Oe.removeClass(o, "p-datatable-dragpoint-bottom"), this.droppedRowIndex = i, l ? (l.setAttribute("data-p-datatable-dragpoint-bottom", "true"), !this.isUnstyled && Oe.addClass(l, "p-datatable-dragpoint-bottom")) : (o.setAttribute("data-p-datatable-dragpoint-top", "true"), !this.isUnstyled && Oe.addClass(o, "p-datatable-dragpoint-top"))) : (l ? (l.setAttribute("data-p-datatable-dragpoint-bottom", "false"), !this.isUnstyled && Oe.removeClass(l, "p-datatable-dragpoint-bottom")) : (o.setAttribute("data-p-datatable-dragpoint-top", "true"), !this.isUnstyled && Oe.addClass(o, "p-datatable-dragpoint-top")), this.droppedRowIndex = i + 1, o.setAttribute("data-p-datatable-dragpoint-bottom", "true"), !this.isUnstyled && Oe.addClass(o, "p-datatable-dragpoint-bottom")), n.preventDefault();
      }
    },
    onRowDragLeave: function(t) {
      var n = t.currentTarget, i = n.previousElementSibling;
      i && (i.setAttribute("data-p-datatable-dragpoint-bottom", "false"), !this.isUnstyled && Oe.removeClass(i, "p-datatable-dragpoint-bottom")), n.setAttribute("data-p-datatable-dragpoint-bottom", "false"), !this.isUnstyled && Oe.removeClass(n, "p-datatable-dragpoint-bottom"), n.setAttribute("data-p-datatable-dragpoint-top", "false"), !this.isUnstyled && Oe.removeClass(n, "p-datatable-dragpoint-top");
    },
    onRowDragEnd: function(t) {
      this.rowDragging = !1, this.draggedRowIndex = null, this.droppedRowIndex = null, t.currentTarget.draggable = !1;
    },
    onRowDrop: function(t) {
      if (this.droppedRowIndex != null) {
        var n = this.draggedRowIndex > this.droppedRowIndex ? this.droppedRowIndex : this.droppedRowIndex === 0 ? 0 : this.droppedRowIndex - 1, i = kn(this.processedData);
        We.reorderArray(i, this.draggedRowIndex + this.d_first, n + this.d_first), this.$emit("row-reorder", {
          originalEvent: t,
          dragIndex: this.draggedRowIndex,
          dropIndex: n,
          value: i
        });
      }
      this.onRowDragLeave(t), this.onRowDragEnd(t), t.preventDefault();
    },
    toggleRow: function(t) {
      var n = this, i = t.expanded, o = l2(t, s2), a = t.data, r;
      if (this.dataKey) {
        var s = We.resolveFieldData(a, this.dataKey);
        r = this.expandedRows ? Zo({}, this.expandedRows) : {}, i ? r[s] = !0 : delete r[s];
      } else
        r = this.expandedRows ? kn(this.expandedRows) : [], i ? r.push(a) : r = r.filter(function(l) {
          return !n.equals(a, l);
        });
      this.$emit("update:expandedRows", r), i ? this.$emit("row-expand", o) : this.$emit("row-collapse", o);
    },
    toggleRowGroup: function(t) {
      var n = t.originalEvent, i = t.data, o = We.resolveFieldData(i, this.groupRowsBy), a = this.expandedRowGroups ? kn(this.expandedRowGroups) : [];
      this.isRowGroupExpanded(i) ? (a = a.filter(function(r) {
        return r !== o;
      }), this.$emit("update:expandedRowGroups", a), this.$emit("rowgroup-collapse", {
        originalEvent: n,
        data: o
      })) : (a.push(o), this.$emit("update:expandedRowGroups", a), this.$emit("rowgroup-expand", {
        originalEvent: n,
        data: o
      }));
    },
    isRowGroupExpanded: function(t) {
      if (this.expandableRowGroups && this.expandedRowGroups) {
        var n = We.resolveFieldData(t, this.groupRowsBy);
        return this.expandedRowGroups.indexOf(n) > -1;
      }
      return !1;
    },
    isStateful: function() {
      return this.stateKey != null;
    },
    getStorage: function() {
      switch (this.stateStorage) {
        case "local":
          return window.localStorage;
        case "session":
          return window.sessionStorage;
        default:
          throw new Error(this.stateStorage + ' is not a valid value for the state storage, supported values are "local" and "session".');
      }
    },
    saveState: function() {
      var t = this.getStorage(), n = {};
      this.paginator && (n.first = this.d_first, n.rows = this.d_rows), this.d_sortField && (n.sortField = this.d_sortField, n.sortOrder = this.d_sortOrder), this.d_multiSortMeta && (n.multiSortMeta = this.d_multiSortMeta), this.hasFilters && (n.filters = this.filters), this.resizableColumns && this.saveColumnWidths(n), this.reorderableColumns && (n.columnOrder = this.d_columnOrder), this.expandedRows && (n.expandedRows = this.expandedRows), this.expandedRowGroups && (n.expandedRowGroups = this.expandedRowGroups), this.selection && (n.selection = this.selection, n.selectionKeys = this.d_selectionKeys), Object.keys(n).length && t.setItem(this.stateKey, JSON.stringify(n)), this.$emit("state-save", n);
    },
    restoreState: function() {
      var t = this.getStorage(), n = t.getItem(this.stateKey), i = /\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.\d{3}Z/, o = function(s, l) {
        return typeof l == "string" && i.test(l) ? new Date(l) : l;
      };
      if (n) {
        var a = JSON.parse(n, o);
        this.paginator && (this.d_first = a.first, this.d_rows = a.rows), a.sortField && (this.d_sortField = a.sortField, this.d_sortOrder = a.sortOrder), a.multiSortMeta && (this.d_multiSortMeta = a.multiSortMeta), a.filters && this.$emit("update:filters", a.filters), this.resizableColumns && (this.columnWidthsState = a.columnWidths, this.tableWidthState = a.tableWidth), this.reorderableColumns && (this.d_columnOrder = a.columnOrder), a.expandedRows && this.$emit("update:expandedRows", a.expandedRows), a.expandedRowGroups && this.$emit("update:expandedRowGroups", a.expandedRowGroups), a.selection && (this.d_selectionKeys = a.d_selectionKeys, this.$emit("update:selection", a.selection)), this.$emit("state-restore", a);
      }
    },
    saveColumnWidths: function(t) {
      var n = [], i = Oe.find(this.$el, 'thead[data-pc-section="thead"] > tr > th');
      i.forEach(function(o) {
        return n.push(Oe.getOuterWidth(o));
      }), t.columnWidths = n.join(","), this.columnResizeMode === "expand" && (t.tableWidth = Oe.getOuterWidth(this.$refs.table) + "px");
    },
    addColumnWidthStyles: function(t) {
      this.createStyleElement();
      var n = "", i = '[data-pc-name="datatable"]['.concat(this.attributeSelector, '] > [data-pc-section="wrapper"] ').concat(this.virtualScrollerDisabled ? "" : '> [data-pc-name="virtualscroller"]', ' > table[data-pc-section="table"]');
      t.forEach(function(o, a) {
        var r = "width: ".concat(o, "px !important; max-width: ").concat(o, "px !important");
        n += `
        `.concat(i, ' > thead[data-pc-section="thead"] > tr > th:nth-child(').concat(a + 1, `),
        `).concat(i, ' > tbody[data-pc-section="tbody"] > tr > td:nth-child(').concat(a + 1, `),
        `).concat(i, ' > tfoot[data-pc-section="tfoot"] > tr > td:nth-child(').concat(a + 1, `) {
            `).concat(r, `
        }
    `);
      }), this.styleElement.innerHTML = n;
    },
    restoreColumnWidths: function() {
      if (this.columnWidthsState) {
        var t = this.columnWidthsState.split(",");
        this.columnResizeMode === "expand" && this.tableWidthState && (this.$refs.table.style.width = this.tableWidthState, this.$refs.table.style.minWidth = this.tableWidthState), We.isNotEmpty(t) && this.addColumnWidthStyles(t);
      }
    },
    onCellEditInit: function(t) {
      this.$emit("cell-edit-init", t);
    },
    onCellEditComplete: function(t) {
      this.$emit("cell-edit-complete", t);
    },
    onCellEditCancel: function(t) {
      this.$emit("cell-edit-cancel", t);
    },
    onRowEditInit: function(t) {
      var n = this.editingRows ? kn(this.editingRows) : [];
      n.push(t.data), this.$emit("update:editingRows", n), this.$emit("row-edit-init", t);
    },
    onRowEditSave: function(t) {
      var n = kn(this.editingRows);
      n.splice(this.findIndex(t.data, n), 1), this.$emit("update:editingRows", n), this.$emit("row-edit-save", t);
    },
    onRowEditCancel: function(t) {
      var n = kn(this.editingRows);
      n.splice(this.findIndex(t.data, n), 1), this.$emit("update:editingRows", n), this.$emit("row-edit-cancel", t);
    },
    onEditingMetaChange: function(t) {
      var n = t.data, i = t.field, o = t.index, a = t.editing, r = Zo({}, this.d_editingMeta), s = r[o];
      if (a)
        !s && (s = r[o] = {
          data: Zo({}, n),
          fields: []
        }), s.fields.push(i);
      else if (s) {
        var l = s.fields.filter(function(d) {
          return d !== i;
        });
        l.length ? s.fields = l : delete r[o];
      }
      this.d_editingMeta = r;
    },
    clearEditingMetaData: function() {
      this.editMode && (this.d_editingMeta = {});
    },
    createLazyLoadEvent: function(t) {
      return {
        originalEvent: t,
        first: this.d_first,
        rows: this.d_rows,
        sortField: this.d_sortField,
        sortOrder: this.d_sortOrder,
        multiSortMeta: this.d_multiSortMeta,
        filters: this.d_filters
      };
    },
    hasGlobalFilter: function() {
      return this.filters && Object.prototype.hasOwnProperty.call(this.filters, "global");
    },
    onFilterChange: function(t) {
      this.d_filters = t;
    },
    onFilterApply: function() {
      this.d_first = 0, this.$emit("update:first", this.d_first), this.$emit("update:filters", this.d_filters), this.lazy && this.$emit("filter", this.createLazyLoadEvent());
    },
    cloneFilters: function() {
      var t = {};
      return this.filters && Object.entries(this.filters).forEach(function(n) {
        var i = by(n, 2), o = i[0], a = i[1];
        t[o] = a.operator ? {
          operator: a.operator,
          constraints: a.constraints.map(function(r) {
            return Zo({}, r);
          })
        } : Zo({}, a);
      }), t;
    },
    updateReorderableColumns: function() {
      var t = this, n = [];
      this.columns.forEach(function(i) {
        return n.push(t.columnProp(i, "columnKey") || t.columnProp(i, "field"));
      }), this.d_columnOrder = n;
    },
    createStyleElement: function() {
      var t;
      this.styleElement = document.createElement("style"), this.styleElement.type = "text/css", Oe.setAttribute(this.styleElement, "nonce", (t = this.$primevue) === null || t === void 0 || (t = t.config) === null || t === void 0 || (t = t.csp) === null || t === void 0 ? void 0 : t.nonce), document.head.appendChild(this.styleElement);
    },
    createResponsiveStyle: function() {
      if (!this.responsiveStyleElement) {
        var t;
        this.responsiveStyleElement = document.createElement("style"), this.responsiveStyleElement.type = "text/css", Oe.setAttribute(this.responsiveStyleElement, "nonce", (t = this.$primevue) === null || t === void 0 || (t = t.config) === null || t === void 0 || (t = t.csp) === null || t === void 0 ? void 0 : t.nonce), document.head.appendChild(this.responsiveStyleElement);
        var n = ".p-datatable-wrapper ".concat(this.virtualScrollerDisabled ? "" : "> .p-virtualscroller", " > .p-datatable-table"), i = ".p-datatable[".concat(this.attributeSelector, "] > ").concat(n), o = ".p-datatable[".concat(this.attributeSelector, "].p-datatable-gridlines > ").concat(n), a = `
@media screen and (max-width: `.concat(this.breakpoint, `) {
    `).concat(i, ` > .p-datatable-thead > tr > th,
    `).concat(i, ` > .p-datatable-tfoot > tr > td {
        display: none;
    }

    `).concat(i, ` > .p-datatable-tbody > tr > td {
        display: flex;
        width: 100%;
        align-items: center;
        justify-content: space-between;
    }

    `).concat(i, ` > .p-datatable-tbody > tr > td:not(:last-child) {
        border: 0 none;
    }

    `).concat(o, ` > .p-datatable-tbody > tr > td:last-child {
        border-top: 0;
        border-right: 0;
        border-left: 0;
    }

    `).concat(i, ` > .p-datatable-tbody > tr > td > .p-column-title {
        display: block;
    }
}
`);
        this.responsiveStyleElement.innerHTML = a;
      }
    },
    destroyResponsiveStyle: function() {
      this.responsiveStyleElement && (document.head.removeChild(this.responsiveStyleElement), this.responsiveStyleElement = null);
    },
    destroyStyleElement: function() {
      this.styleElement && (document.head.removeChild(this.styleElement), this.styleElement = null);
    },
    dataToRender: function(t) {
      var n = t || this.processedData;
      if (n && this.paginator) {
        var i = this.lazy ? 0 : this.d_first;
        return n.slice(i, i + this.d_rows);
      }
      return n;
    },
    getVirtualScrollerRef: function() {
      return this.$refs.virtualScroller;
    },
    hasSpacerStyle: function(t) {
      return We.isNotEmpty(t);
    }
  },
  computed: {
    columns: function() {
      var t = this.d_columns.get(this);
      if (this.reorderableColumns && this.d_columnOrder) {
        var n = [], i = nl(this.d_columnOrder), o;
        try {
          for (i.s(); !(o = i.n()).done; ) {
            var a = o.value, r = this.findColumnByKey(t, a);
            r && !this.columnProp(r, "hidden") && n.push(r);
          }
        } catch (s) {
          i.e(s);
        } finally {
          i.f();
        }
        return [].concat(n, kn(t.filter(function(s) {
          return n.indexOf(s) < 0;
        })));
      }
      return t;
    },
    columnGroups: function() {
      return this.d_columnGroups.get(this);
    },
    headerColumnGroup: function() {
      var t, n = this;
      return (t = this.columnGroups) === null || t === void 0 ? void 0 : t.find(function(i) {
        return n.columnProp(i, "type") === "header";
      });
    },
    footerColumnGroup: function() {
      var t, n = this;
      return (t = this.columnGroups) === null || t === void 0 ? void 0 : t.find(function(i) {
        return n.columnProp(i, "type") === "footer";
      });
    },
    hasFilters: function() {
      return this.filters && Object.keys(this.filters).length > 0 && this.filters.constructor === Object;
    },
    processedData: function() {
      var t, n = this.value || [];
      return !this.lazy && !((t = this.virtualScrollerOptions) !== null && t !== void 0 && t.lazy) && n && n.length && (this.hasFilters && (n = this.filter(n)), this.sorted && (this.sortMode === "single" ? n = this.sortSingle(n) : this.sortMode === "multiple" && (n = this.sortMultiple(n)))), n;
    },
    totalRecordsLength: function() {
      if (this.lazy)
        return this.totalRecords;
      var t = this.processedData;
      return t ? t.length : 0;
    },
    empty: function() {
      var t = this.processedData;
      return !t || t.length === 0;
    },
    paginatorTop: function() {
      return this.paginator && (this.paginatorPosition !== "bottom" || this.paginatorPosition === "both");
    },
    paginatorBottom: function() {
      return this.paginator && (this.paginatorPosition !== "top" || this.paginatorPosition === "both");
    },
    sorted: function() {
      return this.d_sortField || this.d_multiSortMeta && this.d_multiSortMeta.length > 0;
    },
    allRowsSelected: function() {
      var t = this;
      if (this.selectAll !== null)
        return this.selectAll;
      var n = this.frozenValue ? [].concat(kn(this.frozenValue), kn(this.processedData)) : this.processedData;
      return We.isNotEmpty(n) && this.selection && Array.isArray(this.selection) && n.every(function(i) {
        return t.selection.some(function(o) {
          return t.equals(o, i);
        });
      });
    },
    attributeSelector: function() {
      return Mt();
    },
    groupRowSortField: function() {
      return this.sortMode === "single" ? this.sortField : this.d_groupRowsSortMeta ? this.d_groupRowsSortMeta.field : null;
    },
    virtualScrollerDisabled: function() {
      return We.isEmpty(this.virtualScrollerOptions) || !this.scrollable;
    }
  },
  components: {
    DTPaginator: _m,
    DTTableHeader: Qw,
    DTTableBody: Kw,
    DTTableFooter: Zw,
    DTVirtualScroller: Ls,
    ArrowDownIcon: bw,
    ArrowUpIcon: xw,
    SpinnerIcon: jo
  }
};
function oc(e) {
  "@babel/helpers - typeof";
  return oc = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, oc(e);
}
function xy(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    t && (i = i.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), n.push.apply(n, i);
  }
  return n;
}
function wy(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? xy(Object(n), !0).forEach(function(i) {
      b2(e, i, n[i]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : xy(Object(n)).forEach(function(i) {
      Object.defineProperty(e, i, Object.getOwnPropertyDescriptor(n, i));
    });
  }
  return e;
}
function b2(e, t, n) {
  return t = x2(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function x2(e) {
  var t = w2(e, "string");
  return oc(t) == "symbol" ? t : String(t);
}
function w2(e, t) {
  if (oc(e) != "object" || !e)
    return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var i = n.call(e, t || "default");
    if (oc(i) != "object")
      return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function k2(e, t, n, i, o, a) {
  var r = $e("SpinnerIcon"), s = $e("DTPaginator"), l = $e("DTTableHeader"), d = $e("DTTableBody"), y = $e("DTTableFooter"), u = $e("DTVirtualScroller");
  return E(), X("div", Ce({
    class: e.cx("root"),
    "data-scrollselectors": ".p-datatable-wrapper"
  }, e.ptm("root"), {
    "data-pc-name": "datatable"
  }), [je(e.$slots, "default"), e.loading ? (E(), X("div", Ce({
    key: 0,
    class: e.cx("loadingOverlay")
  }, e.ptm("loadingOverlay")), [e.$slots.loading ? je(e.$slots, "loading", {
    key: 0
  }) : (E(), X(Re, {
    key: 1
  }, [e.$slots.loadingicon ? (E(), fe(tt(e.$slots.loadingicon), {
    key: 0,
    class: Pe(e.cx("loadingIcon"))
  }, null, 8, ["class"])) : e.loadingIcon ? (E(), X("i", Ce({
    key: 1,
    class: [e.cx("loadingIcon"), "pi-spin", e.loadingIcon]
  }, e.ptm("loadingIcon")), null, 16)) : (E(), fe(r, Ce({
    key: 2,
    spin: "",
    class: e.cx("loadingIcon")
  }, e.ptm("loadingIcon")), null, 16, ["class"]))], 64))], 16)) : te("", !0), e.$slots.header ? (E(), X("div", Ce({
    key: 1,
    class: e.cx("header")
  }, e.ptm("header")), [je(e.$slots, "header")], 16)) : te("", !0), a.paginatorTop ? (E(), fe(s, {
    key: 2,
    rows: o.d_rows,
    first: o.d_first,
    totalRecords: a.totalRecordsLength,
    pageLinkSize: e.pageLinkSize,
    template: e.paginatorTemplate,
    rowsPerPageOptions: e.rowsPerPageOptions,
    currentPageReportTemplate: e.currentPageReportTemplate,
    class: Pe(e.cx("paginator")),
    onPage: t[0] || (t[0] = function(m) {
      return a.onPage(m);
    }),
    alwaysShow: e.alwaysShowPaginator,
    unstyled: e.unstyled,
    pt: e.ptm("paginator")
  }, Qt({
    _: 2
  }, [e.$slots.paginatorstart ? {
    name: "start",
    fn: Se(function() {
      return [je(e.$slots, "paginatorstart")];
    }),
    key: "0"
  } : void 0, e.$slots.paginatorend ? {
    name: "end",
    fn: Se(function() {
      return [je(e.$slots, "paginatorend")];
    }),
    key: "1"
  } : void 0, e.$slots.paginatorfirstpagelinkicon ? {
    name: "firstpagelinkicon",
    fn: Se(function(m) {
      return [je(e.$slots, "paginatorfirstpagelinkicon", {
        class: Pe(m.class)
      })];
    }),
    key: "2"
  } : void 0, e.$slots.paginatorprevpagelinkicon ? {
    name: "prevpagelinkicon",
    fn: Se(function(m) {
      return [je(e.$slots, "paginatorprevpagelinkicon", {
        class: Pe(m.class)
      })];
    }),
    key: "3"
  } : void 0, e.$slots.paginatornextpagelinkicon ? {
    name: "nextpagelinkicon",
    fn: Se(function(m) {
      return [je(e.$slots, "paginatornextpagelinkicon", {
        class: Pe(m.class)
      })];
    }),
    key: "4"
  } : void 0, e.$slots.paginatorlastpagelinkicon ? {
    name: "lastpagelinkicon",
    fn: Se(function(m) {
      return [je(e.$slots, "paginatorlastpagelinkicon", {
        class: Pe(m.class)
      })];
    }),
    key: "5"
  } : void 0, e.$slots.paginatorjumptopagedropdownicon ? {
    name: "jumptopagedropdownicon",
    fn: Se(function(m) {
      return [je(e.$slots, "paginatorjumptopagedropdownicon", {
        class: Pe(m.class)
      })];
    }),
    key: "6"
  } : void 0, e.$slots.paginatorrowsperpagedropdownicon ? {
    name: "rowsperpagedropdownicon",
    fn: Se(function(m) {
      return [je(e.$slots, "paginatorrowsperpagedropdownicon", {
        class: Pe(m.class)
      })];
    }),
    key: "7"
  } : void 0]), 1032, ["rows", "first", "totalRecords", "pageLinkSize", "template", "rowsPerPageOptions", "currentPageReportTemplate", "class", "alwaysShow", "unstyled", "pt"])) : te("", !0), oe("div", Ce({
    class: e.cx("wrapper"),
    style: [e.sx("wrapper"), {
      maxHeight: a.virtualScrollerDisabled ? e.scrollHeight : ""
    }]
  }, e.ptm("wrapper")), [ue(u, Ce({
    ref: "virtualScroller"
  }, e.virtualScrollerOptions, {
    items: a.processedData,
    columns: a.columns,
    style: e.scrollHeight !== "flex" ? {
      height: e.scrollHeight
    } : void 0,
    scrollHeight: e.scrollHeight !== "flex" ? void 0 : "100%",
    disabled: a.virtualScrollerDisabled,
    loaderDisabled: "",
    inline: "",
    autoSize: "",
    showSpacer: !1,
    pt: e.ptm("virtualScroller")
  }), {
    content: Se(function(m) {
      return [oe("table", Ce({
        ref: "table",
        role: "table",
        class: [e.cx("table"), e.tableClass],
        style: [e.tableStyle, m.spacerStyle]
      }, wy(wy({}, e.tableProps), e.ptm("table"))), [ue(l, {
        columnGroup: a.headerColumnGroup,
        columns: m.columns,
        rowGroupMode: e.rowGroupMode,
        groupRowsBy: e.groupRowsBy,
        groupRowSortField: a.groupRowSortField,
        reorderableColumns: e.reorderableColumns,
        resizableColumns: e.resizableColumns,
        allRowsSelected: a.allRowsSelected,
        empty: a.empty,
        sortMode: e.sortMode,
        sortField: o.d_sortField,
        sortOrder: o.d_sortOrder,
        multiSortMeta: o.d_multiSortMeta,
        filters: o.d_filters,
        filtersStore: e.filters,
        filterDisplay: e.filterDisplay,
        filterInputProps: e.filterInputProps,
        onColumnClick: t[1] || (t[1] = function(h) {
          return a.onColumnHeaderClick(h);
        }),
        onColumnMousedown: t[2] || (t[2] = function(h) {
          return a.onColumnHeaderMouseDown(h);
        }),
        onFilterChange: a.onFilterChange,
        onFilterApply: a.onFilterApply,
        onColumnDragstart: t[3] || (t[3] = function(h) {
          return a.onColumnHeaderDragStart(h);
        }),
        onColumnDragover: t[4] || (t[4] = function(h) {
          return a.onColumnHeaderDragOver(h);
        }),
        onColumnDragleave: t[5] || (t[5] = function(h) {
          return a.onColumnHeaderDragLeave(h);
        }),
        onColumnDrop: t[6] || (t[6] = function(h) {
          return a.onColumnHeaderDrop(h);
        }),
        onColumnResizestart: t[7] || (t[7] = function(h) {
          return a.onColumnResizeStart(h);
        }),
        onCheckboxChange: t[8] || (t[8] = function(h) {
          return a.toggleRowsWithCheckbox(h);
        }),
        unstyled: e.unstyled,
        pt: e.pt
      }, null, 8, ["columnGroup", "columns", "rowGroupMode", "groupRowsBy", "groupRowSortField", "reorderableColumns", "resizableColumns", "allRowsSelected", "empty", "sortMode", "sortField", "sortOrder", "multiSortMeta", "filters", "filtersStore", "filterDisplay", "filterInputProps", "onFilterChange", "onFilterApply", "unstyled", "pt"]), e.frozenValue ? (E(), fe(d, {
        key: 0,
        ref: "frozenBodyRef",
        value: e.frozenValue,
        frozenRow: !0,
        columns: m.columns,
        first: o.d_first,
        dataKey: e.dataKey,
        selection: e.selection,
        selectionKeys: o.d_selectionKeys,
        selectionMode: e.selectionMode,
        contextMenu: e.contextMenu,
        contextMenuSelection: e.contextMenuSelection,
        rowGroupMode: e.rowGroupMode,
        groupRowsBy: e.groupRowsBy,
        expandableRowGroups: e.expandableRowGroups,
        rowClass: e.rowClass,
        rowStyle: e.rowStyle,
        editMode: e.editMode,
        compareSelectionBy: e.compareSelectionBy,
        scrollable: e.scrollable,
        expandedRowIcon: e.expandedRowIcon,
        collapsedRowIcon: e.collapsedRowIcon,
        expandedRows: e.expandedRows,
        expandedRowGroups: e.expandedRowGroups,
        editingRows: e.editingRows,
        editingRowKeys: o.d_editingRowKeys,
        templates: e.$slots,
        responsiveLayout: e.responsiveLayout,
        isVirtualScrollerDisabled: !0,
        onRowgroupToggle: a.toggleRowGroup,
        onRowClick: t[9] || (t[9] = function(h) {
          return a.onRowClick(h);
        }),
        onRowDblclick: t[10] || (t[10] = function(h) {
          return a.onRowDblClick(h);
        }),
        onRowRightclick: t[11] || (t[11] = function(h) {
          return a.onRowRightClick(h);
        }),
        onRowTouchend: a.onRowTouchEnd,
        onRowKeydown: a.onRowKeyDown,
        onRowMousedown: a.onRowMouseDown,
        onRowDragstart: t[12] || (t[12] = function(h) {
          return a.onRowDragStart(h);
        }),
        onRowDragover: t[13] || (t[13] = function(h) {
          return a.onRowDragOver(h);
        }),
        onRowDragleave: t[14] || (t[14] = function(h) {
          return a.onRowDragLeave(h);
        }),
        onRowDragend: t[15] || (t[15] = function(h) {
          return a.onRowDragEnd(h);
        }),
        onRowDrop: t[16] || (t[16] = function(h) {
          return a.onRowDrop(h);
        }),
        onRowToggle: t[17] || (t[17] = function(h) {
          return a.toggleRow(h);
        }),
        onRadioChange: t[18] || (t[18] = function(h) {
          return a.toggleRowWithRadio(h);
        }),
        onCheckboxChange: t[19] || (t[19] = function(h) {
          return a.toggleRowWithCheckbox(h);
        }),
        onCellEditInit: t[20] || (t[20] = function(h) {
          return a.onCellEditInit(h);
        }),
        onCellEditComplete: t[21] || (t[21] = function(h) {
          return a.onCellEditComplete(h);
        }),
        onCellEditCancel: t[22] || (t[22] = function(h) {
          return a.onCellEditCancel(h);
        }),
        onRowEditInit: t[23] || (t[23] = function(h) {
          return a.onRowEditInit(h);
        }),
        onRowEditSave: t[24] || (t[24] = function(h) {
          return a.onRowEditSave(h);
        }),
        onRowEditCancel: t[25] || (t[25] = function(h) {
          return a.onRowEditCancel(h);
        }),
        editingMeta: o.d_editingMeta,
        onEditingMetaChange: a.onEditingMetaChange,
        unstyled: e.unstyled,
        pt: e.pt
      }, null, 8, ["value", "columns", "first", "dataKey", "selection", "selectionKeys", "selectionMode", "contextMenu", "contextMenuSelection", "rowGroupMode", "groupRowsBy", "expandableRowGroups", "rowClass", "rowStyle", "editMode", "compareSelectionBy", "scrollable", "expandedRowIcon", "collapsedRowIcon", "expandedRows", "expandedRowGroups", "editingRows", "editingRowKeys", "templates", "responsiveLayout", "onRowgroupToggle", "onRowTouchend", "onRowKeydown", "onRowMousedown", "editingMeta", "onEditingMetaChange", "unstyled", "pt"])) : te("", !0), ue(d, {
        ref: "bodyRef",
        value: a.dataToRender(m.rows),
        class: Pe(m.styleClass),
        columns: m.columns,
        empty: a.empty,
        first: o.d_first,
        dataKey: e.dataKey,
        selection: e.selection,
        selectionKeys: o.d_selectionKeys,
        selectionMode: e.selectionMode,
        contextMenu: e.contextMenu,
        contextMenuSelection: e.contextMenuSelection,
        rowGroupMode: e.rowGroupMode,
        groupRowsBy: e.groupRowsBy,
        expandableRowGroups: e.expandableRowGroups,
        rowClass: e.rowClass,
        rowStyle: e.rowStyle,
        editMode: e.editMode,
        compareSelectionBy: e.compareSelectionBy,
        scrollable: e.scrollable,
        expandedRowIcon: e.expandedRowIcon,
        collapsedRowIcon: e.collapsedRowIcon,
        expandedRows: e.expandedRows,
        expandedRowGroups: e.expandedRowGroups,
        editingRows: e.editingRows,
        editingRowKeys: o.d_editingRowKeys,
        templates: e.$slots,
        responsiveLayout: e.responsiveLayout,
        virtualScrollerContentProps: m,
        isVirtualScrollerDisabled: a.virtualScrollerDisabled,
        onRowgroupToggle: a.toggleRowGroup,
        onRowClick: t[26] || (t[26] = function(h) {
          return a.onRowClick(h);
        }),
        onRowDblclick: t[27] || (t[27] = function(h) {
          return a.onRowDblClick(h);
        }),
        onRowRightclick: t[28] || (t[28] = function(h) {
          return a.onRowRightClick(h);
        }),
        onRowTouchend: a.onRowTouchEnd,
        onRowKeydown: function(c) {
          return a.onRowKeyDown(c, m);
        },
        onRowMousedown: a.onRowMouseDown,
        onRowDragstart: t[29] || (t[29] = function(h) {
          return a.onRowDragStart(h);
        }),
        onRowDragover: t[30] || (t[30] = function(h) {
          return a.onRowDragOver(h);
        }),
        onRowDragleave: t[31] || (t[31] = function(h) {
          return a.onRowDragLeave(h);
        }),
        onRowDragend: t[32] || (t[32] = function(h) {
          return a.onRowDragEnd(h);
        }),
        onRowDrop: t[33] || (t[33] = function(h) {
          return a.onRowDrop(h);
        }),
        onRowToggle: t[34] || (t[34] = function(h) {
          return a.toggleRow(h);
        }),
        onRadioChange: t[35] || (t[35] = function(h) {
          return a.toggleRowWithRadio(h);
        }),
        onCheckboxChange: t[36] || (t[36] = function(h) {
          return a.toggleRowWithCheckbox(h);
        }),
        onCellEditInit: t[37] || (t[37] = function(h) {
          return a.onCellEditInit(h);
        }),
        onCellEditComplete: t[38] || (t[38] = function(h) {
          return a.onCellEditComplete(h);
        }),
        onCellEditCancel: t[39] || (t[39] = function(h) {
          return a.onCellEditCancel(h);
        }),
        onRowEditInit: t[40] || (t[40] = function(h) {
          return a.onRowEditInit(h);
        }),
        onRowEditSave: t[41] || (t[41] = function(h) {
          return a.onRowEditSave(h);
        }),
        onRowEditCancel: t[42] || (t[42] = function(h) {
          return a.onRowEditCancel(h);
        }),
        editingMeta: o.d_editingMeta,
        onEditingMetaChange: a.onEditingMetaChange,
        unstyled: e.unstyled,
        pt: e.pt
      }, null, 8, ["value", "class", "columns", "empty", "first", "dataKey", "selection", "selectionKeys", "selectionMode", "contextMenu", "contextMenuSelection", "rowGroupMode", "groupRowsBy", "expandableRowGroups", "rowClass", "rowStyle", "editMode", "compareSelectionBy", "scrollable", "expandedRowIcon", "collapsedRowIcon", "expandedRows", "expandedRowGroups", "editingRows", "editingRowKeys", "templates", "responsiveLayout", "virtualScrollerContentProps", "isVirtualScrollerDisabled", "onRowgroupToggle", "onRowTouchend", "onRowKeydown", "onRowMousedown", "editingMeta", "onEditingMetaChange", "unstyled", "pt"]), a.hasSpacerStyle(m.spacerStyle) ? (E(), X("tbody", Ce({
        key: 1,
        class: e.cx("virtualScrollerSpacer"),
        style: {
          height: "calc(".concat(m.spacerStyle.height, " - ").concat(m.rows.length * m.itemSize, "px)")
        }
      }, e.ptm("virtualScrollerSpacer")), null, 16)) : te("", !0), ue(y, {
        columnGroup: a.footerColumnGroup,
        columns: m.columns,
        pt: e.pt
      }, null, 8, ["columnGroup", "columns", "pt"])], 16)];
    }),
    _: 1
  }, 16, ["items", "columns", "style", "scrollHeight", "disabled", "pt"])], 16), e.$slots.footer ? (E(), X("div", Ce({
    key: 3,
    class: e.cx("footer")
  }, e.ptm("footer")), [je(e.$slots, "footer")], 16)) : te("", !0), a.paginatorBottom ? (E(), fe(s, {
    key: 4,
    rows: o.d_rows,
    first: o.d_first,
    totalRecords: a.totalRecordsLength,
    pageLinkSize: e.pageLinkSize,
    template: e.paginatorTemplate,
    rowsPerPageOptions: e.rowsPerPageOptions,
    currentPageReportTemplate: e.currentPageReportTemplate,
    class: Pe(e.cx("paginator")),
    onPage: t[43] || (t[43] = function(m) {
      return a.onPage(m);
    }),
    alwaysShow: e.alwaysShowPaginator,
    unstyled: e.unstyled,
    pt: e.ptm("paginator")
  }, Qt({
    _: 2
  }, [e.$slots.paginatorstart ? {
    name: "start",
    fn: Se(function() {
      return [je(e.$slots, "paginatorstart")];
    }),
    key: "0"
  } : void 0, e.$slots.paginatorend ? {
    name: "end",
    fn: Se(function() {
      return [je(e.$slots, "paginatorend")];
    }),
    key: "1"
  } : void 0, e.$slots.paginatorfirstpagelinkicon ? {
    name: "firstpagelinkicon",
    fn: Se(function(m) {
      return [je(e.$slots, "paginatorfirstpagelinkicon", {
        class: Pe(m.class)
      })];
    }),
    key: "2"
  } : void 0, e.$slots.paginatorprevpagelinkicon ? {
    name: "prevpagelinkicon",
    fn: Se(function(m) {
      return [je(e.$slots, "paginatorprevpagelinkicon", {
        class: Pe(m.class)
      })];
    }),
    key: "3"
  } : void 0, e.$slots.paginatornextpagelinkicon ? {
    name: "nextpagelinkicon",
    fn: Se(function(m) {
      return [je(e.$slots, "paginatornextpagelinkicon", {
        class: Pe(m.class)
      })];
    }),
    key: "4"
  } : void 0, e.$slots.paginatorlastpagelinkicon ? {
    name: "lastpagelinkicon",
    fn: Se(function(m) {
      return [je(e.$slots, "paginatorlastpagelinkicon", {
        class: Pe(m.class)
      })];
    }),
    key: "5"
  } : void 0, e.$slots.paginatorjumptopagedropdownicon ? {
    name: "jumptopagedropdownicon",
    fn: Se(function(m) {
      return [je(e.$slots, "paginatorjumptopagedropdownicon", {
        class: Pe(m.class)
      })];
    }),
    key: "6"
  } : void 0, e.$slots.paginatorrowsperpagedropdownicon ? {
    name: "rowsperpagedropdownicon",
    fn: Se(function(m) {
      return [je(e.$slots, "paginatorrowsperpagedropdownicon", {
        class: Pe(m.class)
      })];
    }),
    key: "7"
  } : void 0]), 1032, ["rows", "first", "totalRecords", "pageLinkSize", "template", "rowsPerPageOptions", "currentPageReportTemplate", "class", "alwaysShow", "unstyled", "pt"])) : te("", !0), oe("div", Ce({
    ref: "resizeHelper",
    class: e.cx("resizeHelper"),
    style: {
      display: "none"
    }
  }, e.ptm("resizeHelper")), null, 16), e.reorderableColumns ? (E(), X("span", Ce({
    key: 5,
    ref: "reorderIndicatorUp",
    class: e.cx("reorderIndicatorUp"),
    style: {
      position: "absolute",
      display: "none"
    }
  }, e.ptm("reorderIndicatorUp")), [(E(), fe(tt(e.$slots.reorderindicatorupicon || "ArrowDownIcon")))], 16)) : te("", !0), e.reorderableColumns ? (E(), X("span", Ce({
    key: 6,
    ref: "reorderIndicatorDown",
    class: e.cx("reorderIndicatorDown"),
    style: {
      position: "absolute",
      display: "none"
    }
  }, e.ptm("reorderIndicatorDown")), [(E(), fe(tt(e.$slots.reorderindicatordownicon || "ArrowUpIcon")))], 16)) : te("", !0)], 16);
}
Ku.render = k2;
var ek = {
  name: "BanIcon",
  extends: Yt,
  computed: {
    pathId: function() {
      return "pv_icon_clip_".concat(Mt());
    }
  }
}, S2 = ["clip-path"], C2 = /* @__PURE__ */ oe("path", {
  d: "M7 0C5.61553 0 4.26215 0.410543 3.11101 1.17971C1.95987 1.94888 1.06266 3.04213 0.532846 4.32122C0.00303296 5.6003 -0.13559 7.00776 0.134506 8.36563C0.404603 9.7235 1.07129 10.9708 2.05026 11.9497C3.02922 12.9287 4.2765 13.5954 5.63437 13.8655C6.99224 14.1356 8.3997 13.997 9.67879 13.4672C10.9579 12.9373 12.0511 12.0401 12.8203 10.889C13.5895 9.73785 14 8.38447 14 7C14 5.14348 13.2625 3.36301 11.9497 2.05025C10.637 0.737498 8.85652 0 7 0ZM1.16667 7C1.16549 5.65478 1.63303 4.35118 2.48889 3.31333L10.6867 11.5111C9.83309 12.2112 8.79816 12.6544 7.70243 12.789C6.60669 12.9236 5.49527 12.744 4.49764 12.2713C3.50001 11.7986 2.65724 11.0521 2.06751 10.1188C1.47778 9.18558 1.16537 8.10397 1.16667 7ZM11.5111 10.6867L3.31334 2.48889C4.43144 1.57388 5.84966 1.10701 7.29265 1.1789C8.73565 1.2508 10.1004 1.85633 11.1221 2.87795C12.1437 3.89956 12.7492 5.26435 12.8211 6.70735C12.893 8.15034 12.4261 9.56856 11.5111 10.6867Z",
  fill: "currentColor"
}, null, -1), T2 = [C2], L2 = ["id"], I2 = /* @__PURE__ */ oe("rect", {
  width: "14",
  height: "14",
  fill: "white"
}, null, -1), P2 = [I2];
function A2(e, t, n, i, o, a) {
  return E(), X("svg", Ce({
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.pti()), [oe("g", {
    "clip-path": "url(#".concat(a.pathId, ")")
  }, T2, 8, S2), oe("defs", null, [oe("clipPath", {
    id: "".concat(a.pathId)
  }, P2, 8, L2)])], 16);
}
ek.render = A2;
var tk = {
  name: "StarIcon",
  extends: Yt,
  computed: {
    pathId: function() {
      return "pv_icon_clip_".concat(Mt());
    }
  }
}, _2 = ["clip-path"], M2 = /* @__PURE__ */ oe("path", {
  d: "M10.9741 13.6721C10.8806 13.6719 10.7886 13.6483 10.7066 13.6033L7.00002 11.6545L3.29345 13.6033C3.19926 13.6539 3.09281 13.6771 2.98612 13.6703C2.87943 13.6636 2.77676 13.6271 2.6897 13.5651C2.60277 13.5014 2.53529 13.4147 2.4948 13.3148C2.45431 13.215 2.44241 13.1058 2.46042 12.9995L3.17881 8.87264L0.167699 5.95324C0.0922333 5.8777 0.039368 5.78258 0.0150625 5.67861C-0.00924303 5.57463 -0.00402231 5.46594 0.030136 5.36477C0.0621323 5.26323 0.122141 5.17278 0.203259 5.10383C0.284377 5.03488 0.383311 4.99023 0.488681 4.97501L4.63087 4.37126L6.48797 0.618832C6.54083 0.530159 6.61581 0.456732 6.70556 0.405741C6.79532 0.35475 6.89678 0.327942 7.00002 0.327942C7.10325 0.327942 7.20471 0.35475 7.29447 0.405741C7.38422 0.456732 7.4592 0.530159 7.51206 0.618832L9.36916 4.37126L13.5114 4.97501C13.6167 4.99023 13.7157 5.03488 13.7968 5.10383C13.8779 5.17278 13.9379 5.26323 13.9699 5.36477C14.0041 5.46594 14.0093 5.57463 13.985 5.67861C13.9607 5.78258 13.9078 5.8777 13.8323 5.95324L10.8212 8.87264L11.532 12.9995C11.55 13.1058 11.5381 13.215 11.4976 13.3148C11.4571 13.4147 11.3896 13.5014 11.3027 13.5651C11.2059 13.632 11.0917 13.6692 10.9741 13.6721ZM7.00002 10.4393C7.09251 10.4404 7.18371 10.4613 7.2675 10.5005L10.2098 12.029L9.65193 8.75036C9.6368 8.6584 9.64343 8.56418 9.6713 8.47526C9.69918 8.38633 9.74751 8.30518 9.81242 8.23832L12.1969 5.94559L8.90298 5.45648C8.81188 5.44198 8.72555 5.406 8.65113 5.35152C8.57671 5.29703 8.51633 5.2256 8.475 5.14314L7.00002 2.1626L5.52503 5.15078C5.4837 5.23324 5.42332 5.30467 5.3489 5.35916C5.27448 5.41365 5.18815 5.44963 5.09705 5.46412L1.80318 5.94559L4.18761 8.23832C4.25252 8.30518 4.30085 8.38633 4.32873 8.47526C4.3566 8.56418 4.36323 8.6584 4.3481 8.75036L3.7902 12.0519L6.73253 10.5234C6.81451 10.4762 6.9058 10.4475 7.00002 10.4393Z",
  fill: "currentColor"
}, null, -1), O2 = [M2], B2 = ["id"], E2 = /* @__PURE__ */ oe("rect", {
  width: "14",
  height: "14",
  fill: "white"
}, null, -1), D2 = [E2];
function R2(e, t, n, i, o, a) {
  return E(), X("svg", Ce({
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.pti()), [oe("g", {
    "clip-path": "url(#".concat(a.pathId, ")")
  }, O2, 8, _2), oe("defs", null, [oe("clipPath", {
    id: "".concat(a.pathId)
  }, D2, 8, B2)])], 16);
}
tk.render = R2;
var nk = {
  name: "StarFillIcon",
  extends: Yt,
  computed: {
    pathId: function() {
      return "pv_icon_clip_".concat(Mt());
    }
  }
}, N2 = ["clip-path"], $2 = /* @__PURE__ */ oe("path", {
  d: "M13.9718 5.36453C13.9398 5.26298 13.8798 5.17252 13.7986 5.10356C13.7175 5.0346 13.6186 4.98994 13.5132 4.97472L9.37043 4.37088L7.51307 0.617955C7.46021 0.529271 7.38522 0.455834 7.29545 0.404836C7.20568 0.353838 7.1042 0.327026 7.00096 0.327026C6.89771 0.327026 6.79624 0.353838 6.70647 0.404836C6.6167 0.455834 6.54171 0.529271 6.48885 0.617955L4.63149 4.37088L0.488746 4.97472C0.383363 4.98994 0.284416 5.0346 0.203286 5.10356C0.122157 5.17252 0.0621407 5.26298 0.03014 5.36453C-0.00402286 5.46571 -0.00924428 5.57442 0.0150645 5.67841C0.0393733 5.7824 0.0922457 5.87753 0.167722 5.95308L3.17924 8.87287L2.4684 13.0003C2.45038 13.1066 2.46229 13.2158 2.50278 13.3157C2.54328 13.4156 2.61077 13.5022 2.6977 13.5659C2.78477 13.628 2.88746 13.6644 2.99416 13.6712C3.10087 13.678 3.20733 13.6547 3.30153 13.6042L7.00096 11.6551L10.708 13.6042C10.79 13.6491 10.882 13.6728 10.9755 13.673C11.0958 13.6716 11.2129 13.6343 11.3119 13.5659C11.3988 13.5022 11.4663 13.4156 11.5068 13.3157C11.5473 13.2158 11.5592 13.1066 11.5412 13.0003L10.8227 8.87287L13.8266 5.95308C13.9033 5.87835 13.9577 5.7836 13.9833 5.67957C14.009 5.57554 14.005 5.4664 13.9718 5.36453Z",
  fill: "currentColor"
}, null, -1), F2 = [$2], j2 = ["id"], H2 = /* @__PURE__ */ oe("rect", {
  width: "14",
  height: "14",
  fill: "white"
}, null, -1), z2 = [H2];
function V2(e, t, n, i, o, a) {
  return E(), X("svg", Ce({
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.pti()), [oe("g", {
    "clip-path": "url(#".concat(a.pathId, ")")
  }, F2, 8, N2), oe("defs", null, [oe("clipPath", {
    id: "".concat(a.pathId)
  }, z2, 8, j2)])], 16);
}
nk.render = V2;
var G2 = `
@layer primevue {
    .p-rating {
        position: relative;
        display: flex;
        align-items: center;
    }

    .p-rating-item {
        display: inline-flex;
        align-items: center;
        cursor: pointer;
    }

    .p-rating.p-readonly .p-rating-item {
        cursor: default;
    }
}
`, U2 = {
  root: function(t) {
    var n = t.props;
    return ["p-rating", {
      "p-readonly": n.readonly,
      "p-disabled": n.disabled
    }];
  },
  cancelItem: function(t) {
    var n = t.instance;
    return ["p-rating-item p-rating-cancel-item", {
      "p-focus": n.focusedOptionIndex === 0 && n.isFocusVisibleItem
    }];
  },
  cancelIcon: "p-rating-icon p-rating-cancel",
  item: function(t) {
    var n = t.instance, i = t.props, o = t.value;
    return ["p-rating-item", {
      "p-rating-item-active": o <= i.modelValue,
      "p-focus": o === n.focusedOptionIndex && n.isFocusVisibleItem
    }];
  },
  onIcon: "p-rating-icon",
  offIcon: "p-rating-icon"
}, W2 = Wt.extend({
  name: "rating",
  css: G2,
  classes: U2
}), Y2 = {
  name: "BaseRating",
  extends: wt,
  props: {
    modelValue: {
      type: Number,
      default: null
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    readonly: {
      type: Boolean,
      default: !1
    },
    stars: {
      type: Number,
      default: 5
    },
    cancel: {
      type: Boolean,
      default: !0
    },
    onIcon: {
      type: String,
      default: void 0
    },
    offIcon: {
      type: String,
      default: void 0
    },
    cancelIcon: {
      type: String,
      default: void 0
    }
  },
  style: W2,
  provide: function() {
    return {
      $parentInstance: this
    };
  }
}, Xu = {
  name: "Rating",
  extends: Y2,
  emits: ["update:modelValue", "change", "focus", "blur"],
  data: function() {
    return {
      name: this.$attrs.name,
      focusedOptionIndex: -1,
      isFocusVisibleItem: !0
    };
  },
  watch: {
    "$attrs.name": function(t) {
      this.name = t || Mt();
    }
  },
  mounted: function() {
    this.name = this.name || Mt();
  },
  methods: {
    getPTOptions: function(t, n) {
      return this.ptm(t, {
        context: {
          active: n <= this.modelValue,
          focused: n === this.focusedOptionIndex
        }
      });
    },
    onOptionClick: function(t, n) {
      if (!this.readonly && !this.disabled) {
        this.onOptionSelect(t, n), this.isFocusVisibleItem = !1;
        var i = Oe.getFirstFocusableElement(t.currentTarget);
        i && Oe.focus(i);
      }
    },
    onFocus: function(t, n) {
      this.focusedOptionIndex = n, this.$emit("focus", t);
    },
    onBlur: function(t) {
      this.focusedOptionIndex = -1, this.$emit("blur", t);
    },
    onChange: function(t, n) {
      this.onOptionSelect(t, n), this.isFocusVisibleItem = !0;
    },
    onOptionSelect: function(t, n) {
      this.focusedOptionIndex = n, this.updateModel(t, n || null);
    },
    updateModel: function(t, n) {
      this.$emit("update:modelValue", n), this.$emit("change", {
        originalEvent: t,
        value: n
      });
    },
    cancelAriaLabel: function() {
      return this.$primevue.config.locale.clear;
    },
    starAriaLabel: function(t) {
      return t === 1 ? this.$primevue.config.locale.aria.star : this.$primevue.config.locale.aria.stars.replace(/{star}/g, t);
    }
  },
  components: {
    StarFillIcon: nk,
    StarIcon: tk,
    BanIcon: ek
  }
}, q2 = ["data-p-focused"], K2 = ["name", "checked", "disabled", "readonly", "aria-label"], X2 = ["onClick", "data-p-active", "data-p-focused"], Z2 = ["value", "name", "checked", "disabled", "readonly", "aria-label", "onFocus", "onChange"];
function J2(e, t, n, i, o, a) {
  return E(), X("div", Ce({
    class: e.cx("root")
  }, e.ptm("root"), {
    "data-pc-name": "rating"
  }), [e.cancel ? (E(), X("div", Ce({
    key: 0,
    class: e.cx("cancelItem"),
    onClick: t[3] || (t[3] = function(r) {
      return a.onOptionClick(r, 0);
    })
  }, a.getPTOptions("cancelItem", 0), {
    "data-p-focused": o.focusedOptionIndex === 0
  }), [oe("span", Ce({
    class: "p-hidden-accessible"
  }, e.ptm("hiddenCancelInputWrapper"), {
    "data-p-hidden-accessible": !0
  }), [oe("input", Ce({
    type: "radio",
    value: "0",
    name: o.name,
    checked: e.modelValue === 0,
    disabled: e.disabled,
    readonly: e.readonly,
    "aria-label": a.cancelAriaLabel(),
    onFocus: t[0] || (t[0] = function(r) {
      return a.onFocus(r, 0);
    }),
    onBlur: t[1] || (t[1] = function() {
      return a.onBlur && a.onBlur.apply(a, arguments);
    }),
    onChange: t[2] || (t[2] = function(r) {
      return a.onChange(r, 0);
    })
  }, e.ptm("hiddenCancelInput")), null, 16, K2)], 16), je(e.$slots, "cancelicon", {
    class: Pe(e.cx("cancelIcon"))
  }, function() {
    return [(E(), fe(tt(e.cancelIcon ? "span" : "BanIcon"), Ce({
      class: [e.cx("cancelIcon"), e.cancelIcon]
    }, e.ptm("cancelIcon")), null, 16, ["class"]))];
  })], 16, q2)) : te("", !0), (E(!0), X(Re, null, Ge(e.stars, function(r) {
    return E(), X("div", Ce({
      key: r,
      class: e.cx("item", {
        value: r
      }),
      onClick: function(l) {
        return a.onOptionClick(l, r);
      }
    }, a.getPTOptions("item", r), {
      "data-p-active": r <= e.modelValue,
      "data-p-focused": r === o.focusedOptionIndex
    }), [oe("span", Ce({
      class: "p-hidden-accessible"
    }, e.ptm("hiddenItemInputWrapper"), {
      "data-p-hidden-accessible": !0
    }), [oe("input", Ce({
      type: "radio",
      value: r,
      name: o.name,
      checked: e.modelValue === r,
      disabled: e.disabled,
      readonly: e.readonly,
      "aria-label": a.starAriaLabel(r),
      onFocus: function(l) {
        return a.onFocus(l, r);
      },
      onBlur: t[4] || (t[4] = function() {
        return a.onBlur && a.onBlur.apply(a, arguments);
      }),
      onChange: function(l) {
        return a.onChange(l, r);
      }
    }, e.ptm("hiddenItemInput")), null, 16, Z2)], 16), r <= e.modelValue ? je(e.$slots, "onicon", {
      key: 0,
      value: r,
      class: Pe(e.cx("onIcon"))
    }, function() {
      return [(E(), fe(tt(e.onIcon ? "span" : "StarFillIcon"), Ce({
        class: [e.cx("onIcon"), e.onIcon]
      }, e.ptm("onIcon")), null, 16, ["class"]))];
    }) : je(e.$slots, "officon", {
      key: 1,
      value: r,
      class: Pe(e.cx("offIcon"))
    }, function() {
      return [(E(), fe(tt(e.offIcon ? "span" : "StarIcon"), Ce({
        class: [e.cx("offIcon"), e.offIcon]
      }, e.ptm("offIcon")), null, 16, ["class"]))];
    })], 16, X2);
  }), 128))], 16);
}
Xu.render = J2;
const Q2 = Be({
  name: "AccordionList",
  components: {
    HTMLContentBlock: ht,
    PrimeAccordion: Lm,
    PrimeAccordionTab: Im,
    PrimeDataTable: Ku,
    PrimeColumn: Xr,
    PrimeRating: Xu,
    FootNote: ja,
    FootnoteHeader: li,
    LipperRating: yw,
    SRRIndicator: b_
  },
  props: {
    valuesProductHeader: {
      type: Object,
      required: !0,
      default: null
    },
    values: {
      type: Object,
      required: !0,
      default: null
    },
    valuesMain: {
      type: Object,
      required: !0,
      default: null
    },
    activeItems: {
      type: Array,
      required: !0
    }
  },
  emits: ["activeItemsUpdate"],
  data() {
    return {
      active: [],
      activeSubItems: [],
      accordionItems: [],
      flag: !0
    };
  },
  watch: {
    activeItems: function() {
      this.active = [];
      for (let e = 0; e < this.activeItems.length; e++)
        this.active.push(this.activeItems[e]);
    },
    shouldOpen() {
      const e = [...this.active];
      for (let t = 0; t < this.values?.mainList?.length; t++)
        this.valuesProductHeader?.furtherInfoButton.href && (e[t] = t);
      this.active = e;
    }
  },
  created() {
    const { pageName: e } = Qe();
    this.dataEventSource = e, this.active = [];
    for (let t = 0; t < this.activeItems.length; t++)
      this.active.push(this.activeItems[t]);
    for (let t = 0; t < this.values?.mainList?.length; t++)
      for (let n = 0; n < this.values?.mainList[t].content?.length; n++)
        this.activeSubItems[[t, n]] = !1;
    this.values?.mainList && (this.accordionItems = this.values?.mainList.filter((t) => this.hasContent(t)));
  },
  mounted() {
    if (Vc)
      return;
    const e = document.getElementsByClassName("collapsible");
    for (let t = 0; t < e.length; t++)
      e[t].addEventListener("click", function() {
        this.classList.toggle("active");
        const n = this.nextElementSibling;
        n.style.display === "block" ? n.style.display = "none" : n.style.display = "block";
      });
  },
  computed: {
    ...tA(T_, ["shouldOpen"])
  },
  methods: {
    openTab(e) {
      this.updateActiveItem(e.index);
    },
    closeTab(e) {
      this.updateActiveItem(e.index);
    },
    hasContent(e) {
      return e.content && e.content.length > 0 ? e.content.findIndex((n) => {
        switch (n.type) {
          case "LIST":
          case "TEXT":
            return n.data.list && n.data.list.length > 0;
          case "STYLEBOX":
            return n.data.rowValues && n.data.rowValues.length > 0 && n.data.colValues && n.data.colValues.length > 0;
          case "TABLE":
            return n.detailsHistoryTable.header && n.detailsHistoryTable.header.length > 0;
          default:
            return !0;
        }
      }) > -1 : !1;
    },
    toggleSubElement(e, t) {
      this.activeSubItems[[e, t]] = !this.activeSubItems[[e, t]];
    },
    updateActiveItem(e) {
      this.$emit("activeItemsUpdate", e), this.active[e] = this.active[e] === null ? e : null;
    },
    sanitizeHtml(e) {
      const { htmlContentBlockWhitelist: t } = Li();
      return Ma(e, t);
    }
  }
}), eR = ["id", "data-event_title", "data-event_source"], tR = { key: 0 }, nR = { key: 0 }, iR = { key: 0 }, aR = { key: 1 }, oR = {
  key: 0,
  class: "disclaimer"
}, rR = ["onClick"], sR = { class: "expand-element collapsible mb-0 w-full text-right xs:pr-5 md:pr-3 pr-3" }, lR = { key: 0 }, cR = { key: 1 }, dR = { class: "content" }, uR = { key: 0 }, hR = { key: 1 }, pR = { key: 1 }, fR = { key: 0 }, mR = { class: "item-list-box" }, gR = {
  key: 0,
  class: "keyfacts-section__item-list"
}, vR = { class: "item-list-key" }, yR = {
  key: 0,
  class: "item-list-value"
}, bR = {
  key: 1,
  class: "item-list-value"
}, xR = {
  key: 2,
  class: "item-list-value"
}, wR = {
  key: 3,
  class: "item-list-value"
}, kR = {
  key: 4,
  class: "item-list-value"
}, SR = {
  key: 5,
  class: "item-list-value"
}, CR = ["onClick"], TR = { class: "expand-element collapsible mb-0 w-full text-right xs:pr-5 md:pr-3 pr-3" }, LR = { key: 0 }, IR = { key: 1 }, PR = { class: "content" }, AR = { class: "keyfacts-section__item-list" }, _R = { key: 0 }, MR = { class: "item-list-key" }, OR = { class: "item-list-value" }, BR = { key: 2 }, ER = { key: 0 }, DR = ["onClick"], RR = { class: "expand-element collapsible mb-0 w-full text-right xs:pr-5 md:pr-3 pr-3" }, NR = { key: 0 }, $R = { key: 1 }, FR = {
  key: 0,
  class: "content"
}, jR = {
  key: 3,
  class: "morningstar-box"
}, HR = {
  key: 0,
  class: "mb-4"
}, zR = {
  key: 1,
  class: "mb-4"
}, VR = { class: "flex flex-row flex-wrap w-full" }, GR = { class: "flex flex-wrap" }, UR = { class: "row-title" }, WR = { class: "row-headline" }, YR = { class: "col-title pt-4" }, qR = { class: "axis-label" }, KR = {
  key: 0,
  class: "disclaimer"
}, XR = { class: "mt-6 disclaimer" };
function ZR(e, t, n, i, o, a) {
  const r = $e("FootnoteHeader"), s = $e("FootNote"), l = $e("HTMLContentBlock"), d = $e("PrimeRating"), y = $e("LipperRating"), u = $e("SRRIndicator"), m = $e("PrimeColumn"), h = $e("PrimeDataTable"), c = $e("PrimeAccordionTab"), g = $e("PrimeAccordion"), v = Ut("tooltip");
  return E(), fe(g, {
    ref: "DWSAccordion",
    multiple: !0,
    "active-index": e.active,
    onTabOpen: e.openTab,
    onTabClose: e.closeTab
  }, {
    default: Se(() => [
      (E(!0), X(Re, null, Ge(e.accordionItems, (P, f) => (E(), fe(c, {
        key: f,
        "header-action-props": {
          "data-event_component_name": "Tabs",
          "data-event_title": P.headlineText,
          "data-event_source": e.dataEventSource
        }
      }, {
        header: Se(() => [
          oe("h3", null, [
            oe("a", {
              id: P.id,
              "data-event_component_name": "Tabs",
              "data-event_title": P.headlineText,
              "data-event_source": e.dataEventSource,
              tabindex: "-1"
            }, [
              ue(r, {
                text: P.headlineText,
                "foot-note-id": P.content[0].id ? P.content[0].id : P.id,
                "should-stop-propagation": e.active[f] === null,
                "on-click": () => {
                  e.updateActiveItem(f);
                }
              }, null, 8, ["text", "foot-note-id", "should-stop-propagation", "on-click"]),
              oe("i", {
                class: Pe([{
                  "las la-minus": e.active[f] !== null,
                  "las la-plus": e.active[f] === null
                }, "p-accordion-toggle-icon"])
              }, null, 2)
            ], 8, eR)
          ])
        ]),
        default: Se(() => [
          (E(!0), X(Re, null, Ge(P.content, (S, w) => (E(), X("div", { key: S }, [
            S.type === "TEXT" ? (E(), X("span", tR, [
              S.data?.headlineText && !S.expandable ? (E(), X("h4", nR, [
                ue(r, {
                  text: S.data?.headlineText,
                  "foot-note-id": S.id
                }, null, 8, ["text", "foot-note-id"])
              ])) : te("", !0),
              (E(!0), X(Re, null, Ge(S.data?.list, (x) => (E(), X("div", { key: x }, [
                x.headlineText && !S.expandable ? (E(), X("h4", iR, [
                  ue(r, {
                    text: x.headlineText,
                    "foot-note-id": S.id
                  }, null, 8, ["text", "foot-note-id"])
                ])) : te("", !0),
                x.value && !S.expandable ? (E(), X("p", aR, [
                  ue(r, {
                    text: x.value,
                    "foot-note-id": S.id
                  }, null, 8, ["text", "foot-note-id"])
                ])) : te("", !0)
              ]))), 128)),
              ue(s, {
                id: S.id,
                values: S
              }, null, 8, ["id", "values"]),
              (E(!0), X(Re, null, Ge(S.data.disclaimerHtml, (x) => (E(), X("div", {
                key: x,
                class: "mt-10"
              }, [
                S.expandable ? te("", !0) : (E(), X("p", oR, [
                  ue(l, {
                    "html-text": x.text,
                    "disable-default-styling": ""
                  }, null, 8, ["html-text"])
                ]))
              ]))), 128)),
              S.expandable ? (E(), X("div", {
                key: 1,
                onClick: (x) => e.activeSubItems[[f, w]] = !e.activeSubItems[[f, w]]
              }, [
                oe("p", sR, [
                  Ve(Ie(S.data?.headlineText) + " ", 1),
                  e.activeSubItems[[f, w]] ? (E(), X("span", lR, t[0] || (t[0] = [
                    oe("i", { class: "las la-minus" }, null, -1)
                  ]))) : (E(), X("span", cR, t[1] || (t[1] = [
                    oe("i", { class: "las la-plus" }, null, -1)
                  ])))
                ]),
                oe("div", dR, [
                  (E(!0), X(Re, null, Ge(S.data?.list, (x) => (E(), X("div", { key: x }, [
                    x.headlineText && S.expandable ? (E(), X("h4", uR, [
                      ue(r, {
                        text: x.headlineText,
                        "foot-note-id": S.id
                      }, null, 8, ["text", "foot-note-id"])
                    ])) : te("", !0),
                    x.value && S.expandable ? (E(), X("p", hR, [
                      ue(r, {
                        text: x.value,
                        "foot-note-id": S.id
                      }, null, 8, ["text", "foot-note-id"])
                    ])) : te("", !0)
                  ]))), 128))
                ])
              ], 8, rR)) : te("", !0)
            ])) : te("", !0),
            S.type === "LIST" ? (E(), X("span", pR, [
              S.data?.headlineText && !S.expandable ? (E(), X("h4", fR, [
                ue(r, {
                  text: S.data?.headlineText,
                  "foot-note-id": S.id
                }, null, 8, ["text", "foot-note-id"])
              ])) : te("", !0),
              oe("div", mR, [
                S.expandable ? te("", !0) : (E(), X("ul", gR, [
                  (E(!0), X(Re, null, Ge(S.data?.list, (x) => (E(), X("li", { key: x }, [
                    oe("span", vR, [
                      ue(r, {
                        text: x.key,
                        "foot-note-id": S.id
                      }, null, 8, ["text", "foot-note-id"])
                    ]),
                    x.type === "STRING" ? (E(), X("span", yR, [
                      ue(r, {
                        text: x.value,
                        "foot-note-id": S.id
                      }, null, 8, ["text", "foot-note-id"])
                    ])) : x.type === "BOOL" && x.value ? (E(), X("span", bR, t[2] || (t[2] = [
                      oe("i", { class: "info-icon las la-check-circle" }, null, -1)
                    ]))) : x.type === "BOOL" && !x.value ? (E(), X("span", xR, t[3] || (t[3] = [
                      oe("i", { class: "info-icon las la-ban" }, null, -1)
                    ]))) : x.type === "MORNINGSTAR" ? (E(), X("span", wR, [
                      rt(ue(d, {
                        "model-value": parseInt(x.value),
                        readonly: !0,
                        stars: 5,
                        cancel: !1,
                        "on-icon": "las la-star",
                        "off-icon": "lar la-star"
                      }, null, 8, ["model-value"]), [
                        [
                          v,
                          parseInt(x.value) + " " + (e.valuesMain.morningStarTooltipText ? e.valuesMain.morningStarTooltipText : "Stars"),
                          void 0,
                          { top: !0 }
                        ]
                      ])
                    ])) : x.type === "LIPPERRATNG" ? (E(), X("span", kR, [
                      ue(y, {
                        values: x.value
                      }, null, 8, ["values"])
                    ])) : x.type === "SRRI" ? (E(), X("span", SR, [
                      ue(u, {
                        rating: parseInt(x.value)
                      }, null, 8, ["rating"])
                    ])) : te("", !0)
                  ]))), 128))
                ]))
              ]),
              ue(s, {
                id: S.id,
                values: S.data
              }, null, 8, ["id", "values"]),
              S.expandable ? (E(), X("div", {
                key: 1,
                onClick: (x) => e.toggleSubElement(f, w)
              }, [
                oe("p", TR, [
                  Ve(Ie(S.data?.headlineText) + " ", 1),
                  e.activeSubItems[[f, w]] ? (E(), X("span", LR, t[4] || (t[4] = [
                    oe("i", { class: "las la-minus" }, null, -1)
                  ]))) : (E(), X("span", IR, t[5] || (t[5] = [
                    oe("i", { class: "las la-plus" }, null, -1)
                  ])))
                ]),
                oe("div", PR, [
                  (E(!0), X(Re, null, Ge(S.data?.list, (x) => (E(), X("div", { key: x }, [
                    oe("ul", AR, [
                      S.expandable ? (E(), X("li", _R, [
                        oe("span", MR, [
                          ue(r, {
                            text: x.key,
                            "foot-note-id": S.id
                          }, null, 8, ["text", "foot-note-id"])
                        ]),
                        oe("span", OR, [
                          ue(r, {
                            text: x.value,
                            "foot-note-id": S.id
                          }, null, 8, ["text", "foot-note-id"])
                        ])
                      ])) : te("", !0)
                    ])
                  ]))), 128))
                ])
              ], 8, CR)) : te("", !0)
            ])) : te("", !0),
            S.type === "TABLE" ? (E(), X("div", BR, [
              S.headlineText && !S.expandable ? (E(), X("h4", ER, [
                ue(r, {
                  text: S.headlineText,
                  "foot-note-id": S.id
                }, null, 8, ["text", "foot-note-id"])
              ])) : te("", !0),
              S.expandable ? te("", !0) : (E(), fe(h, {
                key: 1,
                class: "border shade",
                value: S.detailsHistoryTable.values,
                scrollable: !1,
                "responsive-layout": "scroll",
                "show-gridlines": ""
              }, {
                default: Se(() => [
                  (E(!0), X(Re, null, Ge(S.detailsHistoryTable.header, (x) => (E(), fe(m, {
                    key: x,
                    field: x.key,
                    header: x.value,
                    frozen: x.key == "header"
                  }, {
                    body: Se((k) => [
                      oe("span", null, [
                        ue(r, {
                          text: k.data[k.column.props.key.key],
                          "foot-note-id": S.id
                        }, null, 8, ["text", "foot-note-id"])
                      ])
                    ]),
                    _: 2
                  }, 1032, ["field", "header", "frozen"]))), 128))
                ]),
                _: 2
              }, 1032, ["value"])),
              ue(s, { values: S }, null, 8, ["values"]),
              S.expandable ? (E(), X("div", {
                key: 2,
                onClick: (x) => e.toggleSubElement(f, w)
              }, [
                oe("p", RR, [
                  Ve(Ie(S.headlineText) + " ", 1),
                  e.activeSubItems[[f, w]] ? (E(), X("span", NR, t[6] || (t[6] = [
                    oe("i", { class: "las la-minus" }, null, -1)
                  ]))) : (E(), X("span", $R, t[7] || (t[7] = [
                    oe("i", { class: "las la-plus" }, null, -1)
                  ])))
                ]),
                S.expandable ? (E(), X("div", FR, [
                  ue(h, {
                    class: "border shade",
                    value: S.detailsHistoryTable.values,
                    scrollable: !1,
                    "show-gridlines": "",
                    "responsive-layout": "scroll"
                  }, {
                    default: Se(() => [
                      (E(!0), X(Re, null, Ge(S.detailsHistoryTable.header, (x) => (E(), fe(m, {
                        key: x,
                        field: x.key,
                        header: x.value
                      }, {
                        body: Se((k) => [
                          oe("span", null, [
                            ue(r, {
                              text: k.data[k.column.props.key.key],
                              "foot-note-id": S.id
                            }, null, 8, ["text", "foot-note-id"])
                          ])
                        ]),
                        _: 2
                      }, 1032, ["field", "header"]))), 128))
                    ]),
                    _: 2
                  }, 1032, ["value"])
                ])) : te("", !0)
              ], 8, DR)) : te("", !0)
            ])) : te("", !0),
            S.type === "STYLEBOX" ? (E(), X("div", jR, [
              S.data?.headlineText ? (E(), X("h4", HR, [
                ue(r, {
                  text: S.data?.headlineText,
                  "foot-note-id": S.id
                }, null, 8, ["text", "foot-note-id"])
              ])) : te("", !0),
              S.data.topHeadlineText ? (E(), X("p", zR, [
                ue(r, {
                  text: S.data.topHeadlineText,
                  "foot-note-id": S.id
                }, null, 8, ["text", "foot-note-id"])
              ])) : te("", !0),
              oe("div", VR, [
                oe("table", null, [
                  oe("tbody", null, [
                    oe("tr", GR, [
                      (E(), X(Re, null, Ge(9, (x, k) => oe("td", {
                        key: k,
                        class: Pe(["w-1/3", {
                          "color-marker": x === S.data.value
                        }])
                      }, null, 2)), 64))
                    ])
                  ])
                ]),
                oe("div", UR, [
                  (E(!0), X(Re, null, Ge(S.data.colValues, (x) => (E(), X("span", {
                    key: x,
                    class: ""
                  }, Ie(x.value), 1))), 128))
                ]),
                oe("span", WR, [
                  ue(r, {
                    text: S.data?.rowHeadlineText,
                    "foot-note-id": S.id
                  }, null, 8, ["text", "foot-note-id"])
                ])
              ]),
              oe("div", YR, [
                (E(!0), X(Re, null, Ge(S.data.rowValues, (x) => (E(), X("span", {
                  key: x,
                  class: "text-center"
                }, Ie(x.value), 1))), 128)),
                t[8] || (t[8] = oe("br", null, null, -1)),
                oe("span", qR, Ie(S.data.colHeadlineText), 1)
              ]),
              (E(!0), X(Re, null, Ge(S.data.disclaimerHtml, (x) => (E(), X("div", {
                key: x,
                class: "mt-10"
              }, [
                S.expandable ? te("", !0) : (E(), X("p", KR, [
                  ue(l, {
                    "html-text": x.text,
                    "disable-default-styling": ""
                  }, null, 8, ["html-text"])
                ]))
              ]))), 128))
            ])) : te("", !0)
          ]))), 128)),
          (E(!0), X(Re, null, Ge(P.disclaimerHtml, (S) => (E(), X("div", { key: S }, [
            oe("p", XR, [
              ue(l, {
                "html-text": S.text,
                "disable-default-styling": ""
              }, null, 8, ["html-text"])
            ])
          ]))), 128))
        ]),
        _: 2
      }, 1032, ["header-action-props"]))), 128))
    ]),
    _: 1
  }, 8, ["active-index", "onTabOpen", "onTabClose"]);
}
const JR = /* @__PURE__ */ Fe(Q2, [["render", ZR]]), QR = Be({
  name: "Keyfacts",
  components: {
    AccordionList: JR,
    PrimeButton: ki,
    FootNote: ja,
    FootnoteHeader: li,
    TextBlock: Mr
  },
  props: {
    valuesProductHeader: {
      type: Object,
      required: !0,
      default: null
    },
    values: {
      type: Object,
      required: !0,
      default: null
    },
    valuesMain: {
      type: Object,
      required: !0,
      default: null
    }
  },
  data() {
    return {
      activeItems: [],
      numberColumn: 1
    };
  },
  created() {
    this.setActiveArray(!1);
    for (let t = 0; t < this.values?.mainList?.length; t++)
      this.values?.mainList[t].activeOnLoad && (this.activeItems[t] = t);
    const { pageName: e } = Qe();
    this.dataEventSource = e;
  },
  methods: {
    setActiveArray(e, t) {
      if (!Vc) {
        this.activeItems = [];
        for (let n = 0; n < this.values?.mainList?.length; n++)
          e ? this.activeItems.push(n) : this.activeItems.push(null);
        t && t.target.blur(), document.activeElement.toString() == "[object HTMLButtonElement]" && document.activeElement.blur();
      }
    },
    onActiveItemsUpdate(e) {
      this.activeItems[e] = this.activeItems[e] === null ? e : null;
    }
  }
}), e3 = { class: "keyfacts-section" }, t3 = { class: "grid xs:grid-cols-1 xl:grid-cols-6 container" }, n3 = { class: "md:col-span-1 xl:col-span-2" }, i3 = { class: "mb-8 md:m-0" }, a3 = {
  key: 0,
  class: "md:col-span-1 xl:col-span-4 xl:mt-6"
}, o3 = { class: "keyfacts-section__btn justify-end gap-x-4 print:hidden" };
function r3(e, t, n, i, o, a) {
  const r = $e("FootnoteHeader"), s = $e("PrimeButton"), l = $e("AccordionList"), d = $e("FootNote"), y = $e("TextBlock");
  return E(), X("div", e3, [
    oe("div", t3, [
      oe("div", n3, [
        oe("h2", i3, [
          ue(r, {
            text: e.values?.headlineText,
            "foot-note-id": e.values?.id
          }, null, 8, ["text", "foot-note-id"])
        ])
      ]),
      e.values?.mainList ? (E(), X("div", a3, [
        oe("div", o3, [
          ue(s, {
            ref: "allClose",
            "data-event_component_name": "Button",
            "data-event_title": e.valuesMain?.closeAllButtonText,
            "data-event_source": e.dataEventSource,
            label: e.valuesMain?.closeAllButtonText,
            class: "p-button-sm p-button-rounded p-button-outlined",
            onClick: t[0] || (t[0] = (u) => e.setActiveArray(!1, u))
          }, null, 8, ["data-event_title", "data-event_source", "label"]),
          ue(s, {
            ref: "allOpen",
            "data-event_component_name": "Button",
            "data-event_title": e.valuesMain?.openAllButtonText,
            "data-event_source": e.dataEventSource,
            label: e.valuesMain?.openAllButtonText,
            class: "p-button-sm p-button-rounded p-button-outlined",
            onClick: t[1] || (t[1] = (u) => e.setActiveArray(!0, u))
          }, null, 8, ["data-event_title", "data-event_source", "label"])
        ]),
        ue(l, {
          "values-product-header": e.valuesProductHeader,
          values: e.values,
          "values-main": e.valuesMain,
          "active-items": e.activeItems,
          class: "mb-20",
          onActiveItemsUpdate: e.onActiveItemsUpdate
        }, null, 8, ["values-product-header", "values", "values-main", "active-items", "onActiveItemsUpdate"])
      ])) : te("", !0),
      ue(d, {
        class: "xs:col-span-1 xl:col-span-6",
        values: e.values
      }, null, 8, ["values"]),
      (E(!0), X(Re, null, Ge(e.values?.disclaimerHtml, (u) => (E(), fe(y, {
        key: u,
        values: u.text,
        class: "xs:col-span-1 xl:col-span-6 mt-6",
        "number-column": e.numberColumn
      }, null, 8, ["values", "number-column"]))), 128))
    ])
  ]);
}
const pBe = /* @__PURE__ */ Fe(QR, [["render", r3]]);
const s3 = Be({
  name: "AnchorButton",
  props: {
    anchorSize: {
      type: String,
      default: ""
    },
    anchorTitle: {
      type: String,
      required: !0,
      default: "Anchor Title"
    },
    anchorUrl: {
      type: String,
      required: !0
    },
    urlTarget: {
      type: String,
      default: "_self"
    },
    iconIsEnabled: {
      type: Boolean,
      default: !1
    },
    anchorIcon: {
      type: String
    },
    dataComponentName: {
      type: String
    },
    dataEventTitle: {
      type: String
    },
    dataEventSource: {
      type: String
    }
  },
  data() {
    return {};
  },
  methods: {}
}), l3 = ["href", "data-event_component_name", "data-event_title", "data-event_source", "data-event_target", "target"];
function c3(e, t, n, i, o, a) {
  return E(), X("a", {
    href: e.anchorUrl,
    "data-event_component_name": e.dataComponentName,
    "data-event_title": e.dataEventTitle,
    "data-event_source": e.dataEventSource,
    "data-event_target": e.anchorUrl,
    class: Pe(["anchor-button p-button p-button-rounded", e.anchorSize]),
    "data-cy": "anchorTitle",
    target: e.urlTarget
  }, [
    e.iconIsEnabled ? (E(), X("i", {
      key: 0,
      class: Pe(e.anchorIcon)
    }, null, 2)) : te("", !0),
    Ve(Ie(e.anchorTitle), 1)
  ], 10, l3);
}
const Em = /* @__PURE__ */ Fe(s3, [["render", c3]]);
const d3 = Be({
  name: "DWSCarousel",
  directives: {
    ripple: An
  },
  props: {
    value: null,
    page: {
      type: Number,
      default: 0
    },
    numVisible: {
      type: Number,
      default: 1
    },
    numScroll: {
      type: Number,
      default: 1
    },
    responsiveOptions: Array,
    orientation: {
      type: String,
      default: "horizontal"
    },
    verticalViewPortHeight: {
      type: String,
      default: "300px"
    },
    contentClass: String,
    containerClass: String,
    indicatorsContentClass: String,
    circular: {
      type: Boolean,
      default: !1
    },
    autoplayInterval: {
      type: Number,
      default: 0
    }
  },
  emits: ["update:page"],
  data() {
    return {
      id: Mt(),
      remainingItems: 0,
      d_numVisible: this.numVisible,
      d_numScroll: this.numScroll,
      d_oldNumScroll: 0,
      d_oldNumVisible: 0,
      d_oldValue: null,
      d_page: this.page,
      totalShiftedItems: this.page * this.numScroll * -1,
      allowAutoplay: !!this.autoplayInterval,
      d_circular: this.circular || this.allowAutoplay,
      swipeThreshold: 20
    };
  },
  isRemainingItemsAdded: !1,
  created() {
    const { t: e } = Je();
    this.translate = e;
  },
  computed: {
    totalIndicators() {
      return this.value ? Math.max(
        Math.ceil(
          (this.value.length - this.d_numVisible) / this.d_numScroll
        ) + 1,
        0
      ) : 0;
    },
    backwardIsDisabled() {
      return this.value && (!this.circular || this.value.length < this.d_numVisible) && this.d_page === 0;
    },
    forwardIsDisabled() {
      return this.value && (!this.circular || this.value.length < this.d_numVisible) && (this.d_page === this.totalIndicators - 1 || this.totalIndicators === 0);
    },
    containerClasses() {
      return ["p-carousel-container", this.containerClass];
    },
    contentClasses() {
      return ["p-carousel-content ", this.contentClass];
    },
    indicatorsContentClasses() {
      return ["p-carousel-indicators p-reset", this.indicatorsContentClass];
    }
  },
  watch: {
    page(e) {
      this.d_page = e;
    },
    circular(e) {
      this.d_circular = e;
    },
    numVisible(e, t) {
      this.d_numVisible = e, this.d_oldNumVisible = t;
    },
    numScroll(e, t) {
      this.d_oldNumScroll = t, this.d_numScroll = e;
    },
    value(e) {
      this.d_oldValue = e;
    }
  },
  async mounted() {
    await mt();
    let e = !1;
    if (this.createStyle(), this.calculatePosition(), this.responsiveOptions && this.bindDocumentListeners(), this.isCircular()) {
      let t = this.totalShiftedItems;
      this.d_page === 0 ? t = -1 * this.d_numVisible : t === 0 && (t = -1 * this.value.length, this.remainingItems > 0 && (this.isRemainingItemsAdded = !0)), t !== this.totalShiftedItems && (this.totalShiftedItems = t, e = !0);
    }
    !e && this.isAutoplay() && this.startAutoplay();
  },
  async updated() {
    await mt();
    const e = this.isCircular();
    let t = !1, n = this.totalShiftedItems;
    if (this.autoplayInterval && this.stopAutoplay(), this.d_oldNumScroll !== this.d_numScroll || this.d_oldNumVisible !== this.d_numVisible || this.d_oldValue.length !== this.value.length) {
      this.remainingItems = (this.value.length - this.d_numVisible) % this.d_numScroll;
      let i = this.d_page;
      this.totalIndicators !== 0 && i >= this.totalIndicators && (i = this.totalIndicators - 1, this.$emit("update:page", i), this.d_page = i, t = !0), n = i * this.d_numScroll * -1, e && (n -= this.d_numVisible), i === this.totalIndicators - 1 && this.remainingItems > 0 ? (n += -1 * this.remainingItems + this.d_numScroll, this.isRemainingItemsAdded = !0) : this.isRemainingItemsAdded = !1, n !== this.totalShiftedItems && (this.totalShiftedItems = n, t = !0), this.d_oldNumScroll = this.d_numScroll, this.d_oldNumVisible = this.d_numVisible, this.d_oldValue = this.value, this.$refs.itemsContainer.style.transform = this.isVertical() ? `translate3d(0, ${n * (100 / this.d_numVisible)}%, 0)` : `translate3d(${n * (100 / this.d_numVisible)}%, 0, 0)`;
    }
    e && (this.d_page === 0 ? n = -1 * this.d_numVisible : n === 0 && (n = -1 * this.value.length, this.remainingItems > 0 && (this.isRemainingItemsAdded = !0)), n !== this.totalShiftedItems && (this.totalShiftedItems = n, t = !0)), !t && this.isAutoplay() && this.startAutoplay();
  },
  beforeUnmount() {
    this.responsiveOptions && this.unbindDocumentListeners(), this.autoplayInterval && this.stopAutoplay();
  },
  methods: {
    step(e, t) {
      let n = this.totalShiftedItems;
      const i = this.isCircular();
      if (t != null)
        n = this.d_numScroll * t * -1, i && (n -= this.d_numVisible), this.isRemainingItemsAdded = !1;
      else {
        n += this.d_numScroll * e, this.isRemainingItemsAdded && (n += this.remainingItems - this.d_numScroll * e, this.isRemainingItemsAdded = !1);
        const o = i ? n + this.d_numVisible : n;
        t = Math.abs(Math.floor(o / this.d_numScroll));
      }
      i && this.d_page === this.totalIndicators - 1 && e === -1 ? (n = -1 * (this.value.length + this.d_numVisible), t = 0) : i && this.d_page === 0 && e === 1 ? (n = 0, t = this.totalIndicators - 1) : t === this.totalIndicators - 1 && this.remainingItems > 0 && (n += this.remainingItems * -1 - this.d_numScroll * e, this.isRemainingItemsAdded = !0), this.$refs.itemsContainer && (Oe.removeClass(this.$refs.itemsContainer, "p-items-hidden"), this.$refs.itemsContainer.style.transform = this.isVertical() ? `translate3d(0, ${n * (100 / this.d_numVisible)}%, 0)` : `translate3d(${n * (100 / this.d_numVisible)}%, 0, 0)`, this.$refs.itemsContainer.style.transition = "transform 500ms ease 0s"), this.totalShiftedItems = n, this.$emit("update:page", t), this.d_page = t;
    },
    calculatePosition() {
      if (this.$refs.itemsContainer && this.responsiveOptions) {
        const e = Ue ? window.innerWidth : 0;
        let t = {
          numVisible: this.numVisible,
          numScroll: this.numScroll
        };
        for (let n = 0; n < this.responsiveOptions.length; n++) {
          const i = this.responsiveOptions[n];
          parseInt(i.breakpoint, 10) >= e && (t = i);
        }
        if (this.d_numScroll !== t.numScroll) {
          let n = this.d_page;
          n = parseInt(
            n * this.d_numScroll / t.numScroll
          ), this.totalShiftedItems = t.numScroll * n * -1, this.isCircular() && (this.totalShiftedItems -= t.numVisible), this.d_numScroll = t.numScroll, this.$emit("update:page", n), this.d_page = n;
        }
        this.d_numVisible !== t.numVisible && (this.d_numVisible = t.numVisible);
      }
    },
    navBackward(e, t) {
      (this.d_circular || this.d_page !== 0) && this.step(1, t), this.allowAutoplay = !1, e.cancelable && e.preventDefault();
    },
    navForward(e, t) {
      (this.d_circular || this.d_page < this.totalIndicators - 1) && this.step(-1, t), this.allowAutoplay = !1, e.cancelable && e.preventDefault();
    },
    onIndicatorClick(e, t) {
      const n = this.d_page;
      t > n ? this.navForward(e, t) : t < n && this.navBackward(e, t);
    },
    onTransitionEnd() {
      this.$refs.itemsContainer && (Oe.addClass(this.$refs.itemsContainer, "p-items-hidden"), this.$refs.itemsContainer.style.transition = "", (this.d_page === 0 || this.d_page === this.totalIndicators - 1) && this.isCircular() && (this.$refs.itemsContainer.style.transform = this.isVertical() ? `translate3d(0, ${this.totalShiftedItems * (100 / this.d_numVisible)}%, 0)` : `translate3d(${this.totalShiftedItems * (100 / this.d_numVisible)}%, 0, 0)`));
    },
    onTouchStart(e) {
      const t = e.changedTouches[0];
      this.startPos = {
        x: t.pageX,
        y: t.pageY
      };
    },
    onTouchMove(e) {
      e.cancelable && e.preventDefault();
    },
    onTouchEnd(e) {
      const t = e.changedTouches[0];
      this.isVertical() ? this.changePageOnTouch(e, t.pageY - this.startPos.y) : this.changePageOnTouch(e, t.pageX - this.startPos.x);
    },
    changePageOnTouch(e, t) {
      Math.abs(t) > this.swipeThreshold && (t < 0 ? this.navForward(e) : this.navBackward(e));
    },
    bindDocumentListeners() {
      Ue && (this.documentResizeListener || (this.documentResizeListener = (e) => {
        this.calculatePosition(e);
      }, window.addEventListener("resize", this.documentResizeListener)));
    },
    unbindDocumentListeners() {
      this.documentResizeListener && Ue && (window.removeEventListener("resize", this.documentResizeListener), this.documentResizeListener = null);
    },
    startAutoplay() {
      this.interval = setInterval(() => {
        this.d_page === this.totalIndicators - 1 ? this.step(-1, 0) : this.step(-1, this.d_page + 1);
      }, this.autoplayInterval);
    },
    stopAutoplay() {
      this.interval && clearInterval(this.interval);
    },
    createStyle() {
      if (Vc)
        return;
      this.carouselStyle || (this.carouselStyle = document.createElement("style"), this.carouselStyle.type = "text/css", document.body.appendChild(this.carouselStyle));
      let e = `
            #${this.id} .p-carousel-item {
                flex: 1 0 ${100 / this.d_numVisible}%
            }
        `;
      if (this.responsiveOptions) {
        const t = [...this.responsiveOptions];
        t.sort((n, i) => {
          const o = n.breakpoint, a = i.breakpoint;
          let r = null;
          return o == null && a != null ? r = -1 : o != null && a == null ? r = 1 : o == null && a == null ? r = 0 : typeof o == "string" && typeof a == "string" ? r = o.localeCompare(a, void 0, { numeric: !0 }) : r = o < a ? -1 : o > a ? 1 : 0, -1 * r;
        });
        for (let n = 0; n < t.length; n++) {
          const i = t[n];
          e += `
                    @media screen and (max-width: ${i.breakpoint}) {
                        #${this.id} .p-carousel-item {
                            flex: 1 0 ${100 / i.numVisible}%
                        }
                    }
                `;
        }
      }
      this.carouselStyle.innerHTML = e;
    },
    isVertical() {
      return this.orientation === "vertical";
    },
    isCircular() {
      return this.value && this.d_circular && this.value.length >= this.d_numVisible;
    },
    isAutoplay() {
      return this.autoplayInterval && this.allowAutoplay;
    },
    firstIndex() {
      return this.isCircular() ? -1 * (this.totalShiftedItems + this.d_numVisible) : this.totalShiftedItems * -1;
    },
    lastIndex() {
      return this.firstIndex() + this.d_numVisible - 1;
    }
  }
}), u3 = ["id"], h3 = {
  key: 0,
  class: "p-carousel-header"
}, p3 = ["disabled", "aria-label"], f3 = ["disabled", "aria-label"], m3 = { class: "p-carousel-indicator-left" }, g3 = ["disabled", "aria-label"], v3 = ["aria-label", "aria-current", "onClick"], y3 = { class: "p-carousel-indicator-right" }, b3 = ["disabled", "aria-label"], x3 = {
  key: 1,
  class: "p-carousel-footer"
};
function w3(e, t, n, i, o, a) {
  const r = Ut("ripple");
  return E(), X("div", {
    id: e.id,
    class: Pe([
      "p-carousel p-component",
      {
        "p-carousel-vertical": e.isVertical(),
        "p-carousel-horizontal": !e.isVertical()
      }
    ])
  }, [
    e.$slots.header ? (E(), X("div", h3, [
      je(e.$slots, "header", {}, void 0, !0)
    ])) : te("", !0),
    oe("div", {
      class: Pe(e.contentClasses)
    }, [
      oe("div", {
        class: Pe(e.containerClasses)
      }, [
        rt((E(), X("button", {
          class: Pe([
            "p-carousel-prev p-link",
            { "p-hidden": e.backwardIsDisabled }
          ]),
          disabled: e.backwardIsDisabled,
          type: "button",
          "aria-label": e.translate("dwsCarousel.backward"),
          onClick: t[0] || (t[0] = (...s) => e.navBackward && e.navBackward(...s))
        }, [
          oe("span", {
            class: Pe([
              "p-carousel-prev-icon pi",
              {
                "las la-angle-left": !e.isVertical(),
                "las la-angle-up": e.isVertical()
              }
            ])
          }, null, 2)
        ], 10, p3)), [
          [r]
        ]),
        oe("div", {
          class: "p-carousel-items-content",
          style: hn([{ height: e.isVertical() ? e.verticalViewPortHeight : "auto" }]),
          onTouchendPassive: t[2] || (t[2] = (...s) => e.onTouchEnd && e.onTouchEnd(...s)),
          onTouchstartPassive: t[3] || (t[3] = (...s) => e.onTouchStart && e.onTouchStart(...s)),
          onTouchmovePassive: t[4] || (t[4] = (...s) => e.onTouchMove && e.onTouchMove(...s))
        }, [
          oe("div", {
            ref: "itemsContainer",
            class: "p-carousel-items-container",
            onTransitionend: t[1] || (t[1] = (...s) => e.onTransitionEnd && e.onTransitionEnd(...s))
          }, [
            e.isCircular() ? (E(!0), X(Re, { key: 0 }, Ge(e.value.slice(-1 * e.d_numVisible), (s, l) => (E(), X("div", {
              key: l + "_scloned",
              class: Pe([
                "p-carousel-item p-carousel-item-cloned",
                {
                  "p-carousel-item-active": e.totalShiftedItems * -1 === e.value.length + e.d_numVisible,
                  "p-carousel-item-start": l === 0,
                  "p-carousel-item-end": e.value.slice(-1 * e.d_numVisible).length - 1 === l
                }
              ])
            }, [
              je(e.$slots, "item", {
                data: s,
                index: l
              }, void 0, !0)
            ], 2))), 128)) : te("", !0),
            (E(!0), X(Re, null, Ge(e.value, (s, l) => (E(), X("div", {
              key: l,
              class: Pe([
                "p-carousel-item",
                {
                  "p-carousel-item-active": e.firstIndex() <= l && e.lastIndex() >= l,
                  "p-carousel-item-start": e.firstIndex() === l,
                  "p-carousel-item-end": e.lastIndex() === l
                }
              ])
            }, [
              je(e.$slots, "item", {
                data: s,
                index: l
              }, void 0, !0)
            ], 2))), 128)),
            e.isCircular() ? (E(!0), X(Re, { key: 1 }, Ge(e.value.slice(0, e.d_numVisible), (s, l) => (E(), X("div", {
              key: l + "_fcloned",
              class: Pe([
                "p-carousel-item p-carousel-item-cloned",
                {
                  "p-carousel-item-active": e.totalShiftedItems === 0,
                  "p-carousel-item-start": l === 0,
                  "p-carousel-item-end": e.value.slice(0, e.d_numVisible).length - 1 === l
                }
              ])
            }, [
              je(e.$slots, "item", {
                data: s,
                index: l
              }, void 0, !0)
            ], 2))), 128)) : te("", !0)
          ], 544)
        ], 36),
        rt((E(), X("button", {
          class: Pe(["p-carousel-next p-link", { "p-hidden": e.forwardIsDisabled }]),
          disabled: e.forwardIsDisabled,
          type: "button",
          "aria-label": e.translate("dwsCarousel.forward"),
          onClick: t[5] || (t[5] = (...s) => e.navForward && e.navForward(...s))
        }, [
          oe("span", {
            class: Pe([
              "p-carousel-prev-icon pi",
              {
                "las la-angle-right": !e.isVertical(),
                "las la-angle-down": e.isVertical()
              }
            ])
          }, null, 2)
        ], 10, f3)), [
          [r]
        ])
      ], 2),
      e.totalIndicators > 1 ? (E(), X("ul", {
        key: 0,
        class: Pe(e.indicatorsContentClasses)
      }, [
        oe("li", m3, [
          rt((E(), X("button", {
            class: Pe(["p-link", { "p-disabled": e.backwardIsDisabled }]),
            disabled: e.backwardIsDisabled,
            type: "button",
            "aria-label": e.translate("dwsCarousel.backward"),
            onClick: t[6] || (t[6] = (...s) => e.navBackward && e.navBackward(...s))
          }, [
            oe("span", {
              class: Pe([
                "p-carousel-prev-icon pi",
                {
                  "las la-angle-left": !e.isVertical(),
                  "las la-angle-up": e.isVertical()
                }
              ])
            }, null, 2)
          ], 10, g3)), [
            [r]
          ])
        ]),
        (E(!0), X(Re, null, Ge(e.totalIndicators, (s, l) => (E(), X("li", {
          key: "p-carousel-indicator-" + l.toString(),
          class: Pe(["p-carousel-indicator", { "p-highlight": e.d_page === l }])
        }, [
          oe("button", {
            "aria-label": `${e.translate("dwsCarousel.page")} ${l + 1}`,
            class: "p-link",
            type: "button",
            "aria-current": e.d_page === l ? "page" : null,
            onClick: (d) => e.onIndicatorClick(d, l)
          }, null, 8, v3)
        ], 2))), 128)),
        oe("li", y3, [
          rt((E(), X("button", {
            class: Pe(["p-link", { "p-disabled": e.forwardIsDisabled }]),
            disabled: e.forwardIsDisabled,
            type: "button",
            "aria-label": e.translate("dwsCarousel.forward"),
            onClick: t[7] || (t[7] = (...s) => e.navForward && e.navForward(...s))
          }, [
            oe("span", {
              class: Pe([
                "p-carousel-prev-icon pi",
                {
                  "las la-angle-right": !e.isVertical(),
                  "las la-angle-down": e.isVertical()
                }
              ])
            }, null, 2)
          ], 10, b3)), [
            [r]
          ])
        ])
      ], 2)) : te("", !0)
    ], 2),
    e.$slots.footer ? (E(), X("div", x3, [
      je(e.$slots, "footer", {}, void 0, !0)
    ])) : te("", !0)
  ], 10, u3);
}
const ik = /* @__PURE__ */ Fe(d3, [["render", w3], ["__scopeId", "data-v-fb1e8a0b"]]);
/*!
  * vue-tippy v6.6.0
  * (c) 2024 
  * @license MIT
  */
var Si = "top", ea = "bottom", ta = "right", Ci = "left", Dm = "auto", qc = [Si, ea, ta, Ci], cs = "start", rc = "end", k3 = "clippingParents", ak = "viewport", il = "popper", S3 = "reference", ky = /* @__PURE__ */ qc.reduce(function(e, t) {
  return e.concat([t + "-" + cs, t + "-" + rc]);
}, []), ok = /* @__PURE__ */ [].concat(qc, [Dm]).reduce(function(e, t) {
  return e.concat([t, t + "-" + cs, t + "-" + rc]);
}, []), C3 = "beforeRead", T3 = "read", L3 = "afterRead", I3 = "beforeMain", P3 = "main", A3 = "afterMain", _3 = "beforeWrite", M3 = "write", O3 = "afterWrite", B3 = [C3, T3, L3, I3, P3, A3, _3, M3, O3];
function Ba(e) {
  return e ? (e.nodeName || "").toLowerCase() : null;
}
function ba(e) {
  if (e == null)
    return window;
  if (e.toString() !== "[object Window]") {
    var t = e.ownerDocument;
    return t && t.defaultView || window;
  }
  return e;
}
function ds(e) {
  var t = ba(e).Element;
  return e instanceof t || e instanceof Element;
}
function Zi(e) {
  var t = ba(e).HTMLElement;
  return e instanceof t || e instanceof HTMLElement;
}
function rk(e) {
  if (typeof ShadowRoot > "u")
    return !1;
  var t = ba(e).ShadowRoot;
  return e instanceof t || e instanceof ShadowRoot;
}
function E3(e) {
  var t = e.state;
  Object.keys(t.elements).forEach(function(n) {
    var i = t.styles[n] || {}, o = t.attributes[n] || {}, a = t.elements[n];
    !Zi(a) || !Ba(a) || (Object.assign(a.style, i), Object.keys(o).forEach(function(r) {
      var s = o[r];
      s === !1 ? a.removeAttribute(r) : a.setAttribute(r, s === !0 ? "" : s);
    }));
  });
}
function D3(e) {
  var t = e.state, n = {
    popper: {
      position: t.options.strategy,
      left: "0",
      top: "0",
      margin: "0"
    },
    arrow: {
      position: "absolute"
    },
    reference: {}
  };
  return Object.assign(t.elements.popper.style, n.popper), t.styles = n, t.elements.arrow && Object.assign(t.elements.arrow.style, n.arrow), function() {
    Object.keys(t.elements).forEach(function(i) {
      var o = t.elements[i], a = t.attributes[i] || {}, r = Object.keys(t.styles.hasOwnProperty(i) ? t.styles[i] : n[i]), s = r.reduce(function(l, d) {
        return l[d] = "", l;
      }, {});
      !Zi(o) || !Ba(o) || (Object.assign(o.style, s), Object.keys(a).forEach(function(l) {
        o.removeAttribute(l);
      }));
    });
  };
}
var sk = {
  name: "applyStyles",
  enabled: !0,
  phase: "write",
  fn: E3,
  effect: D3,
  requires: ["computeStyles"]
};
function Aa(e) {
  return e.split("-")[0];
}
var gr = Math.max, hu = Math.min, us = Math.round;
function hs(e, t) {
  t === void 0 && (t = !1);
  var n = e.getBoundingClientRect(), i = 1, o = 1;
  if (Zi(e) && t) {
    var a = e.offsetHeight, r = e.offsetWidth;
    r > 0 && (i = us(n.width) / r || 1), a > 0 && (o = us(n.height) / a || 1);
  }
  return {
    width: n.width / i,
    height: n.height / o,
    top: n.top / o,
    right: n.right / i,
    bottom: n.bottom / o,
    left: n.left / i,
    x: n.left / i,
    y: n.top / o
  };
}
function Rm(e) {
  var t = hs(e), n = e.offsetWidth, i = e.offsetHeight;
  return Math.abs(t.width - n) <= 1 && (n = t.width), Math.abs(t.height - i) <= 1 && (i = t.height), {
    x: e.offsetLeft,
    y: e.offsetTop,
    width: n,
    height: i
  };
}
function lk(e, t) {
  var n = t.getRootNode && t.getRootNode();
  if (e.contains(t))
    return !0;
  if (n && rk(n)) {
    var i = t;
    do {
      if (i && e.isSameNode(i))
        return !0;
      i = i.parentNode || i.host;
    } while (i);
  }
  return !1;
}
function Ea(e) {
  return ba(e).getComputedStyle(e);
}
function R3(e) {
  return ["table", "td", "th"].indexOf(Ba(e)) >= 0;
}
function zo(e) {
  return ((ds(e) ? e.ownerDocument : (
    // $FlowFixMe[prop-missing]
    e.document
  )) || window.document).documentElement;
}
function Zu(e) {
  return Ba(e) === "html" ? e : (
    // this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    e.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    e.parentNode || // DOM Element detected
    (rk(e) ? e.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    zo(e)
  );
}
function Sy(e) {
  return !Zi(e) || // https://github.com/popperjs/popper-core/issues/837
  Ea(e).position === "fixed" ? null : e.offsetParent;
}
function N3(e) {
  var t = navigator.userAgent.toLowerCase().indexOf("firefox") !== -1, n = navigator.userAgent.indexOf("Trident") !== -1;
  if (n && Zi(e)) {
    var i = Ea(e);
    if (i.position === "fixed")
      return null;
  }
  for (var o = Zu(e); Zi(o) && ["html", "body"].indexOf(Ba(o)) < 0; ) {
    var a = Ea(o);
    if (a.transform !== "none" || a.perspective !== "none" || a.contain === "paint" || ["transform", "perspective"].indexOf(a.willChange) !== -1 || t && a.willChange === "filter" || t && a.filter && a.filter !== "none")
      return o;
    o = o.parentNode;
  }
  return null;
}
function Kc(e) {
  for (var t = ba(e), n = Sy(e); n && R3(n) && Ea(n).position === "static"; )
    n = Sy(n);
  return n && (Ba(n) === "html" || Ba(n) === "body" && Ea(n).position === "static") ? t : n || N3(e) || t;
}
function Nm(e) {
  return ["top", "bottom"].indexOf(e) >= 0 ? "x" : "y";
}
function Ll(e, t, n) {
  return gr(e, hu(t, n));
}
function $3(e, t, n) {
  var i = Ll(e, t, n);
  return i > n ? n : i;
}
function ck() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
function dk(e) {
  return Object.assign({}, ck(), e);
}
function uk(e, t) {
  return t.reduce(function(n, i) {
    return n[i] = e, n;
  }, {});
}
var F3 = function(t, n) {
  return t = typeof t == "function" ? t(Object.assign({}, n.rects, {
    placement: n.placement
  })) : t, dk(typeof t != "number" ? t : uk(t, qc));
};
function j3(e) {
  var t, n = e.state, i = e.name, o = e.options, a = n.elements.arrow, r = n.modifiersData.popperOffsets, s = Aa(n.placement), l = Nm(s), d = [Ci, ta].indexOf(s) >= 0, y = d ? "height" : "width";
  if (!(!a || !r)) {
    var u = F3(o.padding, n), m = Rm(a), h = l === "y" ? Si : Ci, c = l === "y" ? ea : ta, g = n.rects.reference[y] + n.rects.reference[l] - r[l] - n.rects.popper[y], v = r[l] - n.rects.reference[l], P = Kc(a), f = P ? l === "y" ? P.clientHeight || 0 : P.clientWidth || 0 : 0, S = g / 2 - v / 2, w = u[h], x = f - m[y] - u[c], k = f / 2 - m[y] / 2 + S, A = Ll(w, k, x), $ = l;
    n.modifiersData[i] = (t = {}, t[$] = A, t.centerOffset = A - k, t);
  }
}
function H3(e) {
  var t = e.state, n = e.options, i = n.element, o = i === void 0 ? "[data-popper-arrow]" : i;
  o != null && (typeof o == "string" && (o = t.elements.popper.querySelector(o), !o) || lk(t.elements.popper, o) && (t.elements.arrow = o));
}
var z3 = {
  name: "arrow",
  enabled: !0,
  phase: "main",
  fn: j3,
  effect: H3,
  requires: ["popperOffsets"],
  requiresIfExists: ["preventOverflow"]
};
function ps(e) {
  return e.split("-")[1];
}
var V3 = {
  top: "auto",
  right: "auto",
  bottom: "auto",
  left: "auto"
};
function G3(e) {
  var t = e.x, n = e.y, i = window, o = i.devicePixelRatio || 1;
  return {
    x: us(t * o) / o || 0,
    y: us(n * o) / o || 0
  };
}
function Cy(e) {
  var t, n = e.popper, i = e.popperRect, o = e.placement, a = e.variation, r = e.offsets, s = e.position, l = e.gpuAcceleration, d = e.adaptive, y = e.roundOffsets, u = e.isFixed, m = y === !0 ? G3(r) : typeof y == "function" ? y(r) : r, h = m.x, c = h === void 0 ? 0 : h, g = m.y, v = g === void 0 ? 0 : g, P = r.hasOwnProperty("x"), f = r.hasOwnProperty("y"), S = Ci, w = Si, x = window;
  if (d) {
    var k = Kc(n), A = "clientHeight", $ = "clientWidth";
    if (k === ba(n) && (k = zo(n), Ea(k).position !== "static" && s === "absolute" && (A = "scrollHeight", $ = "scrollWidth")), k = k, o === Si || (o === Ci || o === ta) && a === rc) {
      w = ea;
      var j = u && x.visualViewport ? x.visualViewport.height : (
        // $FlowFixMe[prop-missing]
        k[A]
      );
      v -= j - i.height, v *= l ? 1 : -1;
    }
    if (o === Ci || (o === Si || o === ea) && a === rc) {
      S = ta;
      var N = u && x.visualViewport ? x.visualViewport.width : (
        // $FlowFixMe[prop-missing]
        k[$]
      );
      c -= N - i.width, c *= l ? 1 : -1;
    }
  }
  var M = Object.assign({
    position: s
  }, d && V3);
  if (l) {
    var D;
    return Object.assign({}, M, (D = {}, D[w] = f ? "0" : "", D[S] = P ? "0" : "", D.transform = (x.devicePixelRatio || 1) <= 1 ? "translate(" + c + "px, " + v + "px)" : "translate3d(" + c + "px, " + v + "px, 0)", D));
  }
  return Object.assign({}, M, (t = {}, t[w] = f ? v + "px" : "", t[S] = P ? c + "px" : "", t.transform = "", t));
}
function U3(e) {
  var t = e.state, n = e.options, i = n.gpuAcceleration, o = i === void 0 ? !0 : i, a = n.adaptive, r = a === void 0 ? !0 : a, s = n.roundOffsets, l = s === void 0 ? !0 : s, d = {
    placement: Aa(t.placement),
    variation: ps(t.placement),
    popper: t.elements.popper,
    popperRect: t.rects.popper,
    gpuAcceleration: o,
    isFixed: t.options.strategy === "fixed"
  };
  t.modifiersData.popperOffsets != null && (t.styles.popper = Object.assign({}, t.styles.popper, Cy(Object.assign({}, d, {
    offsets: t.modifiersData.popperOffsets,
    position: t.options.strategy,
    adaptive: r,
    roundOffsets: l
  })))), t.modifiersData.arrow != null && (t.styles.arrow = Object.assign({}, t.styles.arrow, Cy(Object.assign({}, d, {
    offsets: t.modifiersData.arrow,
    position: "absolute",
    adaptive: !1,
    roundOffsets: l
  })))), t.attributes.popper = Object.assign({}, t.attributes.popper, {
    "data-popper-placement": t.placement
  });
}
var W3 = {
  name: "computeStyles",
  enabled: !0,
  phase: "beforeWrite",
  fn: U3,
  data: {}
}, yd = {
  passive: !0
};
function Y3(e) {
  var t = e.state, n = e.instance, i = e.options, o = i.scroll, a = o === void 0 ? !0 : o, r = i.resize, s = r === void 0 ? !0 : r, l = ba(t.elements.popper), d = [].concat(t.scrollParents.reference, t.scrollParents.popper);
  return a && d.forEach(function(y) {
    y.addEventListener("scroll", n.update, yd);
  }), s && l.addEventListener("resize", n.update, yd), function() {
    a && d.forEach(function(y) {
      y.removeEventListener("scroll", n.update, yd);
    }), s && l.removeEventListener("resize", n.update, yd);
  };
}
var q3 = {
  name: "eventListeners",
  enabled: !0,
  phase: "write",
  fn: function() {
  },
  effect: Y3,
  data: {}
}, K3 = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function Xd(e) {
  return e.replace(/left|right|bottom|top/g, function(t) {
    return K3[t];
  });
}
var X3 = {
  start: "end",
  end: "start"
};
function Ty(e) {
  return e.replace(/start|end/g, function(t) {
    return X3[t];
  });
}
function $m(e) {
  var t = ba(e), n = t.pageXOffset, i = t.pageYOffset;
  return {
    scrollLeft: n,
    scrollTop: i
  };
}
function Fm(e) {
  return hs(zo(e)).left + $m(e).scrollLeft;
}
function Z3(e) {
  var t = ba(e), n = zo(e), i = t.visualViewport, o = n.clientWidth, a = n.clientHeight, r = 0, s = 0;
  return i && (o = i.width, a = i.height, /^((?!chrome|android).)*safari/i.test(navigator.userAgent) || (r = i.offsetLeft, s = i.offsetTop)), {
    width: o,
    height: a,
    x: r + Fm(e),
    y: s
  };
}
function J3(e) {
  var t, n = zo(e), i = $m(e), o = (t = e.ownerDocument) == null ? void 0 : t.body, a = gr(n.scrollWidth, n.clientWidth, o ? o.scrollWidth : 0, o ? o.clientWidth : 0), r = gr(n.scrollHeight, n.clientHeight, o ? o.scrollHeight : 0, o ? o.clientHeight : 0), s = -i.scrollLeft + Fm(e), l = -i.scrollTop;
  return Ea(o || n).direction === "rtl" && (s += gr(n.clientWidth, o ? o.clientWidth : 0) - a), {
    width: a,
    height: r,
    x: s,
    y: l
  };
}
function jm(e) {
  var t = Ea(e), n = t.overflow, i = t.overflowX, o = t.overflowY;
  return /auto|scroll|overlay|hidden/.test(n + o + i);
}
function hk(e) {
  return ["html", "body", "#document"].indexOf(Ba(e)) >= 0 ? e.ownerDocument.body : Zi(e) && jm(e) ? e : hk(Zu(e));
}
function Il(e, t) {
  var n;
  t === void 0 && (t = []);
  var i = hk(e), o = i === ((n = e.ownerDocument) == null ? void 0 : n.body), a = ba(i), r = o ? [a].concat(a.visualViewport || [], jm(i) ? i : []) : i, s = t.concat(r);
  return o ? s : (
    // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
    s.concat(Il(Zu(r)))
  );
}
function tf(e) {
  return Object.assign({}, e, {
    left: e.x,
    top: e.y,
    right: e.x + e.width,
    bottom: e.y + e.height
  });
}
function Q3(e) {
  var t = hs(e);
  return t.top = t.top + e.clientTop, t.left = t.left + e.clientLeft, t.bottom = t.top + e.clientHeight, t.right = t.left + e.clientWidth, t.width = e.clientWidth, t.height = e.clientHeight, t.x = t.left, t.y = t.top, t;
}
function Ly(e, t) {
  return t === ak ? tf(Z3(e)) : ds(t) ? Q3(t) : tf(J3(zo(e)));
}
function e8(e) {
  var t = Il(Zu(e)), n = ["absolute", "fixed"].indexOf(Ea(e).position) >= 0, i = n && Zi(e) ? Kc(e) : e;
  return ds(i) ? t.filter(function(o) {
    return ds(o) && lk(o, i) && Ba(o) !== "body" && (n ? Ea(o).position !== "static" : !0);
  }) : [];
}
function t8(e, t, n) {
  var i = t === "clippingParents" ? e8(e) : [].concat(t), o = [].concat(i, [n]), a = o[0], r = o.reduce(function(s, l) {
    var d = Ly(e, l);
    return s.top = gr(d.top, s.top), s.right = hu(d.right, s.right), s.bottom = hu(d.bottom, s.bottom), s.left = gr(d.left, s.left), s;
  }, Ly(e, a));
  return r.width = r.right - r.left, r.height = r.bottom - r.top, r.x = r.left, r.y = r.top, r;
}
function pk(e) {
  var t = e.reference, n = e.element, i = e.placement, o = i ? Aa(i) : null, a = i ? ps(i) : null, r = t.x + t.width / 2 - n.width / 2, s = t.y + t.height / 2 - n.height / 2, l;
  switch (o) {
    case Si:
      l = {
        x: r,
        y: t.y - n.height
      };
      break;
    case ea:
      l = {
        x: r,
        y: t.y + t.height
      };
      break;
    case ta:
      l = {
        x: t.x + t.width,
        y: s
      };
      break;
    case Ci:
      l = {
        x: t.x - n.width,
        y: s
      };
      break;
    default:
      l = {
        x: t.x,
        y: t.y
      };
  }
  var d = o ? Nm(o) : null;
  if (d != null) {
    var y = d === "y" ? "height" : "width";
    switch (a) {
      case cs:
        l[d] = l[d] - (t[y] / 2 - n[y] / 2);
        break;
      case rc:
        l[d] = l[d] + (t[y] / 2 - n[y] / 2);
        break;
    }
  }
  return l;
}
function sc(e, t) {
  t === void 0 && (t = {});
  var n = t, i = n.placement, o = i === void 0 ? e.placement : i, a = n.boundary, r = a === void 0 ? k3 : a, s = n.rootBoundary, l = s === void 0 ? ak : s, d = n.elementContext, y = d === void 0 ? il : d, u = n.altBoundary, m = u === void 0 ? !1 : u, h = n.padding, c = h === void 0 ? 0 : h, g = dk(typeof c != "number" ? c : uk(c, qc)), v = y === il ? S3 : il, P = e.rects.popper, f = e.elements[m ? v : y], S = t8(ds(f) ? f : f.contextElement || zo(e.elements.popper), r, l), w = hs(e.elements.reference), x = pk({
    reference: w,
    element: P,
    strategy: "absolute",
    placement: o
  }), k = tf(Object.assign({}, P, x)), A = y === il ? k : w, $ = {
    top: S.top - A.top + g.top,
    bottom: A.bottom - S.bottom + g.bottom,
    left: S.left - A.left + g.left,
    right: A.right - S.right + g.right
  }, j = e.modifiersData.offset;
  if (y === il && j) {
    var N = j[o];
    Object.keys($).forEach(function(M) {
      var D = [ta, ea].indexOf(M) >= 0 ? 1 : -1, C = [Si, ea].indexOf(M) >= 0 ? "y" : "x";
      $[M] += N[C] * D;
    });
  }
  return $;
}
function n8(e, t) {
  t === void 0 && (t = {});
  var n = t, i = n.placement, o = n.boundary, a = n.rootBoundary, r = n.padding, s = n.flipVariations, l = n.allowedAutoPlacements, d = l === void 0 ? ok : l, y = ps(i), u = y ? s ? ky : ky.filter(function(c) {
    return ps(c) === y;
  }) : qc, m = u.filter(function(c) {
    return d.indexOf(c) >= 0;
  });
  m.length === 0 && (m = u);
  var h = m.reduce(function(c, g) {
    return c[g] = sc(e, {
      placement: g,
      boundary: o,
      rootBoundary: a,
      padding: r
    })[Aa(g)], c;
  }, {});
  return Object.keys(h).sort(function(c, g) {
    return h[c] - h[g];
  });
}
function i8(e) {
  if (Aa(e) === Dm)
    return [];
  var t = Xd(e);
  return [Ty(e), t, Ty(t)];
}
function a8(e) {
  var t = e.state, n = e.options, i = e.name;
  if (!t.modifiersData[i]._skip) {
    for (var o = n.mainAxis, a = o === void 0 ? !0 : o, r = n.altAxis, s = r === void 0 ? !0 : r, l = n.fallbackPlacements, d = n.padding, y = n.boundary, u = n.rootBoundary, m = n.altBoundary, h = n.flipVariations, c = h === void 0 ? !0 : h, g = n.allowedAutoPlacements, v = t.options.placement, P = Aa(v), f = P === v, S = l || (f || !c ? [Xd(v)] : i8(v)), w = [v].concat(S).reduce(function(U, Q) {
      return U.concat(Aa(Q) === Dm ? n8(t, {
        placement: Q,
        boundary: y,
        rootBoundary: u,
        padding: d,
        flipVariations: c,
        allowedAutoPlacements: g
      }) : Q);
    }, []), x = t.rects.reference, k = t.rects.popper, A = /* @__PURE__ */ new Map(), $ = !0, j = w[0], N = 0; N < w.length; N++) {
      var M = w[N], D = Aa(M), C = ps(M) === cs, b = [Si, ea].indexOf(D) >= 0, p = b ? "width" : "height", L = sc(t, {
        placement: M,
        boundary: y,
        rootBoundary: u,
        altBoundary: m,
        padding: d
      }), B = b ? C ? ta : Ci : C ? ea : Si;
      x[p] > k[p] && (B = Xd(B));
      var T = Xd(B), O = [];
      if (a && O.push(L[D] <= 0), s && O.push(L[B] <= 0, L[T] <= 0), O.every(function(U) {
        return U;
      })) {
        j = M, $ = !1;
        break;
      }
      A.set(M, O);
    }
    if ($)
      for (var I = c ? 3 : 1, R = function(Q) {
        var J = w.find(function(ee) {
          var V = A.get(ee);
          if (V)
            return V.slice(0, Q).every(function(G) {
              return G;
            });
        });
        if (J)
          return j = J, "break";
      }, Y = I; Y > 0; Y--) {
        var F = R(Y);
        if (F === "break")
          break;
      }
    t.placement !== j && (t.modifiersData[i]._skip = !0, t.placement = j, t.reset = !0);
  }
}
var o8 = {
  name: "flip",
  enabled: !0,
  phase: "main",
  fn: a8,
  requiresIfExists: ["offset"],
  data: {
    _skip: !1
  }
};
function Iy(e, t, n) {
  return n === void 0 && (n = {
    x: 0,
    y: 0
  }), {
    top: e.top - t.height - n.y,
    right: e.right - t.width + n.x,
    bottom: e.bottom - t.height + n.y,
    left: e.left - t.width - n.x
  };
}
function Py(e) {
  return [Si, ta, ea, Ci].some(function(t) {
    return e[t] >= 0;
  });
}
function r8(e) {
  var t = e.state, n = e.name, i = t.rects.reference, o = t.rects.popper, a = t.modifiersData.preventOverflow, r = sc(t, {
    elementContext: "reference"
  }), s = sc(t, {
    altBoundary: !0
  }), l = Iy(r, i), d = Iy(s, o, a), y = Py(l), u = Py(d);
  t.modifiersData[n] = {
    referenceClippingOffsets: l,
    popperEscapeOffsets: d,
    isReferenceHidden: y,
    hasPopperEscaped: u
  }, t.attributes.popper = Object.assign({}, t.attributes.popper, {
    "data-popper-reference-hidden": y,
    "data-popper-escaped": u
  });
}
var s8 = {
  name: "hide",
  enabled: !0,
  phase: "main",
  requiresIfExists: ["preventOverflow"],
  fn: r8
};
function l8(e, t, n) {
  var i = Aa(e), o = [Ci, Si].indexOf(i) >= 0 ? -1 : 1, a = typeof n == "function" ? n(Object.assign({}, t, {
    placement: e
  })) : n, r = a[0], s = a[1];
  return r = r || 0, s = (s || 0) * o, [Ci, ta].indexOf(i) >= 0 ? {
    x: s,
    y: r
  } : {
    x: r,
    y: s
  };
}
function c8(e) {
  var t = e.state, n = e.options, i = e.name, o = n.offset, a = o === void 0 ? [0, 0] : o, r = ok.reduce(function(y, u) {
    return y[u] = l8(u, t.rects, a), y;
  }, {}), s = r[t.placement], l = s.x, d = s.y;
  t.modifiersData.popperOffsets != null && (t.modifiersData.popperOffsets.x += l, t.modifiersData.popperOffsets.y += d), t.modifiersData[i] = r;
}
var d8 = {
  name: "offset",
  enabled: !0,
  phase: "main",
  requires: ["popperOffsets"],
  fn: c8
};
function u8(e) {
  var t = e.state, n = e.name;
  t.modifiersData[n] = pk({
    reference: t.rects.reference,
    element: t.rects.popper,
    strategy: "absolute",
    placement: t.placement
  });
}
var h8 = {
  name: "popperOffsets",
  enabled: !0,
  phase: "read",
  fn: u8,
  data: {}
};
function p8(e) {
  return e === "x" ? "y" : "x";
}
function f8(e) {
  var t = e.state, n = e.options, i = e.name, o = n.mainAxis, a = o === void 0 ? !0 : o, r = n.altAxis, s = r === void 0 ? !1 : r, l = n.boundary, d = n.rootBoundary, y = n.altBoundary, u = n.padding, m = n.tether, h = m === void 0 ? !0 : m, c = n.tetherOffset, g = c === void 0 ? 0 : c, v = sc(t, {
    boundary: l,
    rootBoundary: d,
    padding: u,
    altBoundary: y
  }), P = Aa(t.placement), f = ps(t.placement), S = !f, w = Nm(P), x = p8(w), k = t.modifiersData.popperOffsets, A = t.rects.reference, $ = t.rects.popper, j = typeof g == "function" ? g(Object.assign({}, t.rects, {
    placement: t.placement
  })) : g, N = typeof j == "number" ? {
    mainAxis: j,
    altAxis: j
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, j), M = t.modifiersData.offset ? t.modifiersData.offset[t.placement] : null, D = {
    x: 0,
    y: 0
  };
  if (k) {
    if (a) {
      var C, b = w === "y" ? Si : Ci, p = w === "y" ? ea : ta, L = w === "y" ? "height" : "width", B = k[w], T = B + v[b], O = B - v[p], I = h ? -$[L] / 2 : 0, R = f === cs ? A[L] : $[L], Y = f === cs ? -$[L] : -A[L], F = t.elements.arrow, U = h && F ? Rm(F) : {
        width: 0,
        height: 0
      }, Q = t.modifiersData["arrow#persistent"] ? t.modifiersData["arrow#persistent"].padding : ck(), J = Q[b], ee = Q[p], V = Ll(0, A[L], U[L]), G = S ? A[L] / 2 - I - V - J - N.mainAxis : R - V - J - N.mainAxis, W = S ? -A[L] / 2 + I + V + ee + N.mainAxis : Y + V + ee + N.mainAxis, ae = t.elements.arrow && Kc(t.elements.arrow), z = ae ? w === "y" ? ae.clientTop || 0 : ae.clientLeft || 0 : 0, q = (C = M?.[w]) != null ? C : 0, Z = B + G - q - z, ne = B + W - q, ie = Ll(h ? hu(T, Z) : T, B, h ? gr(O, ne) : O);
      k[w] = ie, D[w] = ie - B;
    }
    if (s) {
      var re, de = w === "x" ? Si : Ci, me = w === "x" ? ea : ta, ce = k[x], pe = x === "y" ? "height" : "width", xe = ce + v[de], le = ce - v[me], se = [Si, Ci].indexOf(P) !== -1, he = (re = M?.[x]) != null ? re : 0, ve = se ? xe : ce - A[pe] - $[pe] - he + N.altAxis, ye = se ? ce + A[pe] + $[pe] - he - N.altAxis : le, be = h && se ? $3(ve, ce, ye) : Ll(h ? ve : xe, ce, h ? ye : le);
      k[x] = be, D[x] = be - ce;
    }
    t.modifiersData[i] = D;
  }
}
var m8 = {
  name: "preventOverflow",
  enabled: !0,
  phase: "main",
  fn: f8,
  requiresIfExists: ["offset"]
};
function g8(e) {
  return {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  };
}
function v8(e) {
  return e === ba(e) || !Zi(e) ? $m(e) : g8(e);
}
function y8(e) {
  var t = e.getBoundingClientRect(), n = us(t.width) / e.offsetWidth || 1, i = us(t.height) / e.offsetHeight || 1;
  return n !== 1 || i !== 1;
}
function b8(e, t, n) {
  n === void 0 && (n = !1);
  var i = Zi(t), o = Zi(t) && y8(t), a = zo(t), r = hs(e, o), s = {
    scrollLeft: 0,
    scrollTop: 0
  }, l = {
    x: 0,
    y: 0
  };
  return (i || !i && !n) && ((Ba(t) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
  jm(a)) && (s = v8(t)), Zi(t) ? (l = hs(t, !0), l.x += t.clientLeft, l.y += t.clientTop) : a && (l.x = Fm(a))), {
    x: r.left + s.scrollLeft - l.x,
    y: r.top + s.scrollTop - l.y,
    width: r.width,
    height: r.height
  };
}
function x8(e) {
  var t = /* @__PURE__ */ new Map(), n = /* @__PURE__ */ new Set(), i = [];
  e.forEach(function(a) {
    t.set(a.name, a);
  });
  function o(a) {
    n.add(a.name);
    var r = [].concat(a.requires || [], a.requiresIfExists || []);
    r.forEach(function(s) {
      if (!n.has(s)) {
        var l = t.get(s);
        l && o(l);
      }
    }), i.push(a);
  }
  return e.forEach(function(a) {
    n.has(a.name) || o(a);
  }), i;
}
function w8(e) {
  var t = x8(e);
  return B3.reduce(function(n, i) {
    return n.concat(t.filter(function(o) {
      return o.phase === i;
    }));
  }, []);
}
function k8(e) {
  var t;
  return function() {
    return t || (t = new Promise(function(n) {
      Promise.resolve().then(function() {
        t = void 0, n(e());
      });
    })), t;
  };
}
function S8(e) {
  var t = e.reduce(function(n, i) {
    var o = n[i.name];
    return n[i.name] = o ? Object.assign({}, o, i, {
      options: Object.assign({}, o.options, i.options),
      data: Object.assign({}, o.data, i.data)
    }) : i, n;
  }, {});
  return Object.keys(t).map(function(n) {
    return t[n];
  });
}
var Ay = {
  placement: "bottom",
  modifiers: [],
  strategy: "absolute"
};
function _y() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  return !t.some(function(i) {
    return !(i && typeof i.getBoundingClientRect == "function");
  });
}
function C8(e) {
  e === void 0 && (e = {});
  var t = e, n = t.defaultModifiers, i = n === void 0 ? [] : n, o = t.defaultOptions, a = o === void 0 ? Ay : o;
  return function(s, l, d) {
    d === void 0 && (d = a);
    var y = {
      placement: "bottom",
      orderedModifiers: [],
      options: Object.assign({}, Ay, a),
      modifiersData: {},
      elements: {
        reference: s,
        popper: l
      },
      attributes: {},
      styles: {}
    }, u = [], m = !1, h = {
      state: y,
      setOptions: function(P) {
        var f = typeof P == "function" ? P(y.options) : P;
        g(), y.options = Object.assign({}, a, y.options, f), y.scrollParents = {
          reference: ds(s) ? Il(s) : s.contextElement ? Il(s.contextElement) : [],
          popper: Il(l)
        };
        var S = w8(S8([].concat(i, y.options.modifiers)));
        return y.orderedModifiers = S.filter(function(w) {
          return w.enabled;
        }), c(), h.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function() {
        if (!m) {
          var P = y.elements, f = P.reference, S = P.popper;
          if (_y(f, S)) {
            y.rects = {
              reference: b8(f, Kc(S), y.options.strategy === "fixed"),
              popper: Rm(S)
            }, y.reset = !1, y.placement = y.options.placement, y.orderedModifiers.forEach(function(N) {
              return y.modifiersData[N.name] = Object.assign({}, N.data);
            });
            for (var w = 0; w < y.orderedModifiers.length; w++) {
              if (y.reset === !0) {
                y.reset = !1, w = -1;
                continue;
              }
              var x = y.orderedModifiers[w], k = x.fn, A = x.options, $ = A === void 0 ? {} : A, j = x.name;
              typeof k == "function" && (y = k({
                state: y,
                options: $,
                name: j,
                instance: h
              }) || y);
            }
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: k8(function() {
        return new Promise(function(v) {
          h.forceUpdate(), v(y);
        });
      }),
      destroy: function() {
        g(), m = !0;
      }
    };
    if (!_y(s, l))
      return h;
    h.setOptions(d).then(function(v) {
      !m && d.onFirstUpdate && d.onFirstUpdate(v);
    });
    function c() {
      y.orderedModifiers.forEach(function(v) {
        var P = v.name, f = v.options, S = f === void 0 ? {} : f, w = v.effect;
        if (typeof w == "function") {
          var x = w({
            state: y,
            name: P,
            instance: h,
            options: S
          }), k = function() {
          };
          u.push(x || k);
        }
      });
    }
    function g() {
      u.forEach(function(v) {
        return v();
      }), u = [];
    }
    return h;
  };
}
var T8 = [q3, h8, W3, sk, d8, o8, m8, z3, s8], L8 = /* @__PURE__ */ C8({
  defaultModifiers: T8
}), I8 = "tippy-box", fk = "tippy-content", mk = "tippy-backdrop", gk = "tippy-arrow", vk = "tippy-svg-arrow", ar = {
  passive: !0,
  capture: !0
}, yk = function() {
  return document.body;
};
function ap(e, t, n) {
  if (Array.isArray(e)) {
    var i = e[t];
    return i ?? (Array.isArray(n) ? n[t] : n);
  }
  return e;
}
function Hm(e, t) {
  var n = {}.toString.call(e);
  return n.indexOf("[object") === 0 && n.indexOf(t + "]") > -1;
}
function bk(e, t) {
  return typeof e == "function" ? e.apply(void 0, t) : e;
}
function My(e, t) {
  if (t === 0)
    return e;
  var n;
  return function(i) {
    clearTimeout(n), n = setTimeout(function() {
      e(i);
    }, t);
  };
}
function P8(e, t) {
  var n = Object.assign({}, e);
  return t.forEach(function(i) {
    delete n[i];
  }), n;
}
function A8(e) {
  return e.split(/\s+/).filter(Boolean);
}
function ur(e) {
  return [].concat(e);
}
function Oy(e, t) {
  e.indexOf(t) === -1 && e.push(t);
}
function _8(e) {
  return e.filter(function(t, n) {
    return e.indexOf(t) === n;
  });
}
function xk(e) {
  return e.split("-")[0];
}
function fs(e) {
  return [].slice.call(e);
}
function By(e) {
  return Object.keys(e).reduce(function(t, n) {
    return e[n] !== void 0 && (t[n] = e[n]), t;
  }, {});
}
function vr() {
  return document.createElement("div");
}
function Ju(e) {
  return ["Element", "Fragment"].some(function(t) {
    return Hm(e, t);
  });
}
function M8(e) {
  return Hm(e, "NodeList");
}
function zm(e) {
  return Hm(e, "MouseEvent");
}
function O8(e) {
  return !!(e && e._tippy && e._tippy.reference === e);
}
function B8(e) {
  return Ju(e) ? [e] : M8(e) ? fs(e) : Array.isArray(e) ? e : fs(document.querySelectorAll(e));
}
function op(e, t) {
  e.forEach(function(n) {
    n && (n.style.transitionDuration = t + "ms");
  });
}
function lc(e, t) {
  e.forEach(function(n) {
    n && n.setAttribute("data-state", t);
  });
}
function wk(e) {
  var t, n = ur(e), i = n[0];
  return i != null && (t = i.ownerDocument) != null && t.body ? i.ownerDocument : document;
}
function E8(e, t) {
  var n = t.clientX, i = t.clientY;
  return e.every(function(o) {
    var a = o.popperRect, r = o.popperState, s = o.props, l = s.interactiveBorder, d = xk(r.placement), y = r.modifiersData.offset;
    if (!y)
      return !0;
    var u = d === "bottom" ? y.top.y : 0, m = d === "top" ? y.bottom.y : 0, h = d === "right" ? y.left.x : 0, c = d === "left" ? y.right.x : 0, g = a.top - i + u > l, v = i - a.bottom - m > l, P = a.left - n + h > l, f = n - a.right - c > l;
    return g || v || P || f;
  });
}
function rp(e, t, n) {
  var i = t + "EventListener";
  ["transitionend", "webkitTransitionEnd"].forEach(function(o) {
    e[i](o, n);
  });
}
function Ey(e, t) {
  for (var n = t; n; ) {
    var i;
    if (e.contains(n))
      return !0;
    n = n.getRootNode == null || (i = n.getRootNode()) == null ? void 0 : i.host;
  }
  return !1;
}
var Ca = {
  isTouch: !1
}, Dy = 0;
function D8() {
  Ca.isTouch || (Ca.isTouch = !0, window.performance && document.addEventListener("mousemove", kk));
}
function kk() {
  var e = performance.now();
  e - Dy < 20 && (Ca.isTouch = !1, document.removeEventListener("mousemove", kk)), Dy = e;
}
function R8() {
  var e = document.activeElement;
  if (O8(e)) {
    var t = e._tippy;
    e.blur && !t.state.isVisible && e.blur();
  }
}
function N8() {
  document.addEventListener("touchstart", D8, ar), window.addEventListener("blur", R8);
}
var $8 = typeof window < "u" && typeof document < "u", F8 = $8 ? (
  // @ts-ignore
  !!window.msCrypto
) : !1, j8 = {
  animateFill: !1,
  followCursor: !1,
  inlinePositioning: !1,
  sticky: !1
}, H8 = {
  allowHTML: !1,
  animation: "fade",
  arrow: !0,
  content: "",
  inertia: !1,
  maxWidth: 350,
  role: "tooltip",
  theme: "",
  zIndex: 9999
}, fa = Object.assign({
  appendTo: yk,
  aria: {
    content: "auto",
    expanded: "auto"
  },
  delay: 0,
  duration: [300, 250],
  getReferenceClientRect: null,
  hideOnClick: !0,
  ignoreAttributes: !1,
  interactive: !1,
  interactiveBorder: 2,
  interactiveDebounce: 0,
  moveTransition: "",
  offset: [0, 10],
  onAfterUpdate: function() {
  },
  onBeforeUpdate: function() {
  },
  onCreate: function() {
  },
  onDestroy: function() {
  },
  onHidden: function() {
  },
  onHide: function() {
  },
  onMount: function() {
  },
  onShow: function() {
  },
  onShown: function() {
  },
  onTrigger: function() {
  },
  onUntrigger: function() {
  },
  onClickOutside: function() {
  },
  placement: "top",
  plugins: [],
  popperOptions: {},
  render: null,
  showOnCreate: !1,
  touch: !0,
  trigger: "mouseenter focus",
  triggerTarget: null
}, j8, H8), z8 = Object.keys(fa), V8 = function(t) {
  var n = Object.keys(t);
  n.forEach(function(i) {
    fa[i] = t[i];
  });
};
function Sk(e) {
  var t = e.plugins || [], n = t.reduce(function(i, o) {
    var a = o.name, r = o.defaultValue;
    if (a) {
      var s;
      i[a] = e[a] !== void 0 ? e[a] : (s = fa[a]) != null ? s : r;
    }
    return i;
  }, {});
  return Object.assign({}, e, n);
}
function G8(e, t) {
  var n = t ? Object.keys(Sk(Object.assign({}, fa, {
    plugins: t
  }))) : z8, i = n.reduce(function(o, a) {
    var r = (e.getAttribute("data-tippy-" + a) || "").trim();
    if (!r)
      return o;
    if (a === "content")
      o[a] = r;
    else
      try {
        o[a] = JSON.parse(r);
      } catch {
        o[a] = r;
      }
    return o;
  }, {});
  return i;
}
function Ry(e, t) {
  var n = Object.assign({}, t, {
    content: bk(t.content, [e])
  }, t.ignoreAttributes ? {} : G8(e, t.plugins));
  return n.aria = Object.assign({}, fa.aria, n.aria), n.aria = {
    expanded: n.aria.expanded === "auto" ? t.interactive : n.aria.expanded,
    content: n.aria.content === "auto" ? t.interactive ? null : "describedby" : n.aria.content
  }, n;
}
var U8 = function() {
  return "innerHTML";
};
function nf(e, t) {
  e[U8()] = t;
}
function Ny(e) {
  var t = vr();
  return e === !0 ? t.className = gk : (t.className = vk, Ju(e) ? t.appendChild(e) : nf(t, e)), t;
}
function $y(e, t) {
  Ju(t.content) ? (nf(e, ""), e.appendChild(t.content)) : typeof t.content != "function" && (t.allowHTML ? nf(e, t.content) : e.textContent = t.content);
}
function pu(e) {
  var t = e.firstElementChild, n = fs(t.children);
  return {
    box: t,
    content: n.find(function(i) {
      return i.classList.contains(fk);
    }),
    arrow: n.find(function(i) {
      return i.classList.contains(gk) || i.classList.contains(vk);
    }),
    backdrop: n.find(function(i) {
      return i.classList.contains(mk);
    })
  };
}
function Ck(e) {
  var t = vr(), n = vr();
  n.className = I8, n.setAttribute("data-state", "hidden"), n.setAttribute("tabindex", "-1");
  var i = vr();
  i.className = fk, i.setAttribute("data-state", "hidden"), $y(i, e.props), t.appendChild(n), n.appendChild(i), o(e.props, e.props);
  function o(a, r) {
    var s = pu(t), l = s.box, d = s.content, y = s.arrow;
    r.theme ? l.setAttribute("data-theme", r.theme) : l.removeAttribute("data-theme"), typeof r.animation == "string" ? l.setAttribute("data-animation", r.animation) : l.removeAttribute("data-animation"), r.inertia ? l.setAttribute("data-inertia", "") : l.removeAttribute("data-inertia"), l.style.maxWidth = typeof r.maxWidth == "number" ? r.maxWidth + "px" : r.maxWidth, r.role ? l.setAttribute("role", r.role) : l.removeAttribute("role"), (a.content !== r.content || a.allowHTML !== r.allowHTML) && $y(d, e.props), r.arrow ? y ? a.arrow !== r.arrow && (l.removeChild(y), l.appendChild(Ny(r.arrow))) : l.appendChild(Ny(r.arrow)) : y && l.removeChild(y);
  }
  return {
    popper: t,
    onUpdate: o
  };
}
Ck.$$tippy = !0;
var W8 = 1, bd = [], sp = [];
function Y8(e, t) {
  var n = Ry(e, Object.assign({}, fa, Sk(By(t)))), i, o, a, r = !1, s = !1, l = !1, d = !1, y, u, m, h = [], c = My(Z, n.interactiveDebounce), g, v = W8++, P = null, f = _8(n.plugins), S = {
    // Is the instance currently enabled?
    isEnabled: !0,
    // Is the tippy currently showing and not transitioning out?
    isVisible: !1,
    // Has the instance been destroyed?
    isDestroyed: !1,
    // Is the tippy currently mounted to the DOM?
    isMounted: !1,
    // Has the tippy finished transitioning in?
    isShown: !1
  }, w = {
    // properties
    id: v,
    reference: e,
    popper: vr(),
    popperInstance: P,
    props: n,
    state: S,
    plugins: f,
    // methods
    clearDelayTimeouts: ve,
    setProps: ye,
    setContent: be,
    show: ke,
    hide: we,
    hideWithInteractivity: Le,
    enable: se,
    disable: he,
    unmount: Me,
    destroy: De
  };
  if (!n.render)
    return w;
  var x = n.render(w), k = x.popper, A = x.onUpdate;
  k.setAttribute("data-tippy-root", ""), k.id = "tippy-" + w.id, w.popper = k, e._tippy = w, k._tippy = w;
  var $ = f.map(function(Ae) {
    return Ae.fn(w);
  }), j = e.hasAttribute("aria-expanded");
  return ae(), I(), B(), T("onCreate", [w]), n.showOnCreate && xe(), k.addEventListener("mouseenter", function() {
    w.props.interactive && w.state.isVisible && w.clearDelayTimeouts();
  }), k.addEventListener("mouseleave", function() {
    w.props.interactive && w.props.trigger.indexOf("mouseenter") >= 0 && b().addEventListener("mousemove", c);
  }), w;
  function N() {
    var Ae = w.props.touch;
    return Array.isArray(Ae) ? Ae : [Ae, 0];
  }
  function M() {
    return N()[0] === "hold";
  }
  function D() {
    var Ae;
    return !!((Ae = w.props.render) != null && Ae.$$tippy);
  }
  function C() {
    return g || e;
  }
  function b() {
    var Ae = C().parentNode;
    return Ae ? wk(Ae) : document;
  }
  function p() {
    return pu(k);
  }
  function L(Ae) {
    return w.state.isMounted && !w.state.isVisible || Ca.isTouch || y && y.type === "focus" ? 0 : ap(w.props.delay, Ae ? 0 : 1, fa.delay);
  }
  function B(Ae) {
    Ae === void 0 && (Ae = !1), k.style.pointerEvents = w.props.interactive && !Ae ? "" : "none", k.style.zIndex = "" + w.props.zIndex;
  }
  function T(Ae, _e, He) {
    if (He === void 0 && (He = !0), $.forEach(function(Ne) {
      Ne[Ae] && Ne[Ae].apply(Ne, _e);
    }), He) {
      var Ee;
      (Ee = w.props)[Ae].apply(Ee, _e);
    }
  }
  function O() {
    var Ae = w.props.aria;
    if (Ae.content) {
      var _e = "aria-" + Ae.content, He = k.id, Ee = ur(w.props.triggerTarget || e);
      Ee.forEach(function(Ne) {
        var Ye = Ne.getAttribute(_e);
        if (w.state.isVisible)
          Ne.setAttribute(_e, Ye ? Ye + " " + He : He);
        else {
          var Xe = Ye && Ye.replace(He, "").trim();
          Xe ? Ne.setAttribute(_e, Xe) : Ne.removeAttribute(_e);
        }
      });
    }
  }
  function I() {
    if (!(j || !w.props.aria.expanded)) {
      var Ae = ur(w.props.triggerTarget || e);
      Ae.forEach(function(_e) {
        w.props.interactive ? _e.setAttribute("aria-expanded", w.state.isVisible && _e === C() ? "true" : "false") : _e.removeAttribute("aria-expanded");
      });
    }
  }
  function R() {
    b().removeEventListener("mousemove", c), bd = bd.filter(function(Ae) {
      return Ae !== c;
    });
  }
  function Y(Ae) {
    if (!(Ca.isTouch && (l || Ae.type === "mousedown"))) {
      var _e = Ae.composedPath && Ae.composedPath()[0] || Ae.target;
      if (!(w.props.interactive && Ey(k, _e))) {
        if (ur(w.props.triggerTarget || e).some(function(He) {
          return Ey(He, _e);
        })) {
          if (Ca.isTouch || w.state.isVisible && w.props.trigger.indexOf("click") >= 0)
            return;
        } else
          T("onClickOutside", [w, Ae]);
        w.props.hideOnClick === !0 && (w.clearDelayTimeouts(), w.hide(), s = !0, setTimeout(function() {
          s = !1;
        }), w.state.isMounted || J());
      }
    }
  }
  function F() {
    l = !0;
  }
  function U() {
    l = !1;
  }
  function Q() {
    var Ae = b();
    Ae.addEventListener("mousedown", Y, !0), Ae.addEventListener("touchend", Y, ar), Ae.addEventListener("touchstart", U, ar), Ae.addEventListener("touchmove", F, ar);
  }
  function J() {
    var Ae = b();
    Ae.removeEventListener("mousedown", Y, !0), Ae.removeEventListener("touchend", Y, ar), Ae.removeEventListener("touchstart", U, ar), Ae.removeEventListener("touchmove", F, ar);
  }
  function ee(Ae, _e) {
    G(Ae, function() {
      !w.state.isVisible && k.parentNode && k.parentNode.contains(k) && _e();
    });
  }
  function V(Ae, _e) {
    G(Ae, _e);
  }
  function G(Ae, _e) {
    var He = p().box;
    function Ee(Ne) {
      Ne.target === He && (rp(He, "remove", Ee), _e());
    }
    if (Ae === 0)
      return _e();
    rp(He, "remove", u), rp(He, "add", Ee), u = Ee;
  }
  function W(Ae, _e, He) {
    He === void 0 && (He = !1);
    var Ee = ur(w.props.triggerTarget || e);
    Ee.forEach(function(Ne) {
      Ne.addEventListener(Ae, _e, He), h.push({
        node: Ne,
        eventType: Ae,
        handler: _e,
        options: He
      });
    });
  }
  function ae() {
    M() && (W("touchstart", q, {
      passive: !0
    }), W("touchend", ne, {
      passive: !0
    })), A8(w.props.trigger).forEach(function(Ae) {
      if (Ae !== "manual")
        switch (W(Ae, q), Ae) {
          case "mouseenter":
            W("mouseleave", ne);
            break;
          case "focus":
            W(F8 ? "focusout" : "blur", ie);
            break;
          case "focusin":
            W("focusout", ie);
            break;
        }
    });
  }
  function z() {
    h.forEach(function(Ae) {
      var _e = Ae.node, He = Ae.eventType, Ee = Ae.handler, Ne = Ae.options;
      _e.removeEventListener(He, Ee, Ne);
    }), h = [];
  }
  function q(Ae) {
    var _e, He = !1;
    if (!(!w.state.isEnabled || re(Ae) || s)) {
      var Ee = ((_e = y) == null ? void 0 : _e.type) === "focus";
      y = Ae, g = Ae.currentTarget, I(), !w.state.isVisible && zm(Ae) && bd.forEach(function(Ne) {
        return Ne(Ae);
      }), Ae.type === "click" && (w.props.trigger.indexOf("mouseenter") < 0 || r) && w.props.hideOnClick !== !1 && w.state.isVisible ? He = !0 : xe(Ae), Ae.type === "click" && (r = !He), He && !Ee && le(Ae);
    }
  }
  function Z(Ae) {
    var _e = Ae.target, He = C().contains(_e) || k.contains(_e);
    if (!(Ae.type === "mousemove" && He)) {
      var Ee = pe().concat(k).map(function(Ne) {
        var Ye, Xe = Ne._tippy, nt = (Ye = Xe.popperInstance) == null ? void 0 : Ye.state;
        return nt ? {
          popperRect: Ne.getBoundingClientRect(),
          popperState: nt,
          props: n
        } : null;
      }).filter(Boolean);
      E8(Ee, Ae) && (R(), le(Ae));
    }
  }
  function ne(Ae) {
    var _e = re(Ae) || w.props.trigger.indexOf("click") >= 0 && r;
    if (!_e) {
      if (w.props.interactive) {
        w.hideWithInteractivity(Ae);
        return;
      }
      le(Ae);
    }
  }
  function ie(Ae) {
    w.props.trigger.indexOf("focusin") < 0 && Ae.target !== C() || w.props.interactive && Ae.relatedTarget && k.contains(Ae.relatedTarget) || le(Ae);
  }
  function re(Ae) {
    return Ca.isTouch ? M() !== Ae.type.indexOf("touch") >= 0 : !1;
  }
  function de() {
    me();
    var Ae = w.props, _e = Ae.popperOptions, He = Ae.placement, Ee = Ae.offset, Ne = Ae.getReferenceClientRect, Ye = Ae.moveTransition, Xe = D() ? pu(k).arrow : null, nt = Ne ? {
      getBoundingClientRect: Ne,
      contextElement: Ne.contextElement || C()
    } : e, ut = {
      name: "$$tippy",
      enabled: !0,
      phase: "beforeWrite",
      requires: ["computeStyles"],
      fn: function(kt) {
        var nn = kt.state;
        if (D()) {
          var an = p(), Cn = an.box;
          ["placement", "reference-hidden", "escaped"].forEach(function(Ft) {
            Ft === "placement" ? Cn.setAttribute("data-placement", nn.placement) : nn.attributes.popper["data-popper-" + Ft] ? Cn.setAttribute("data-" + Ft, "") : Cn.removeAttribute("data-" + Ft);
          }), nn.attributes.popper = {};
        }
      }
    }, bt = [{
      name: "offset",
      options: {
        offset: Ee
      }
    }, {
      name: "preventOverflow",
      options: {
        padding: {
          top: 2,
          bottom: 2,
          left: 5,
          right: 5
        }
      }
    }, {
      name: "flip",
      options: {
        padding: 5
      }
    }, {
      name: "computeStyles",
      options: {
        adaptive: !Ye
      }
    }, ut];
    D() && Xe && bt.push({
      name: "arrow",
      options: {
        element: Xe,
        padding: 3
      }
    }), bt.push.apply(bt, _e?.modifiers || []), w.popperInstance = L8(nt, k, Object.assign({}, _e, {
      placement: He,
      onFirstUpdate: m,
      modifiers: bt
    }));
  }
  function me() {
    w.popperInstance && (w.popperInstance.destroy(), w.popperInstance = null);
  }
  function ce() {
    var Ae = w.props.appendTo, _e, He = C();
    w.props.interactive && Ae === yk || Ae === "parent" ? _e = He.parentNode : _e = bk(Ae, [He]), _e.contains(k) || _e.appendChild(k), w.state.isMounted = !0, de();
  }
  function pe() {
    return fs(k.querySelectorAll("[data-tippy-root]"));
  }
  function xe(Ae) {
    w.clearDelayTimeouts(), Ae && T("onTrigger", [w, Ae]), Q();
    var _e = L(!0), He = N(), Ee = He[0], Ne = He[1];
    Ca.isTouch && Ee === "hold" && Ne && (_e = Ne), _e ? i = setTimeout(function() {
      w.show();
    }, _e) : w.show();
  }
  function le(Ae) {
    if (w.clearDelayTimeouts(), T("onUntrigger", [w, Ae]), !w.state.isVisible) {
      J();
      return;
    }
    if (!(w.props.trigger.indexOf("mouseenter") >= 0 && w.props.trigger.indexOf("click") >= 0 && ["mouseleave", "mousemove"].indexOf(Ae.type) >= 0 && r)) {
      var _e = L(!1);
      _e ? o = setTimeout(function() {
        w.state.isVisible && w.hide();
      }, _e) : a = requestAnimationFrame(function() {
        w.hide();
      });
    }
  }
  function se() {
    w.state.isEnabled = !0;
  }
  function he() {
    w.hide(), w.state.isEnabled = !1;
  }
  function ve() {
    clearTimeout(i), clearTimeout(o), cancelAnimationFrame(a);
  }
  function ye(Ae) {
    if (!w.state.isDestroyed) {
      T("onBeforeUpdate", [w, Ae]), z();
      var _e = w.props, He = Ry(e, Object.assign({}, _e, By(Ae), {
        ignoreAttributes: !0
      }));
      w.props = He, ae(), _e.interactiveDebounce !== He.interactiveDebounce && (R(), c = My(Z, He.interactiveDebounce)), _e.triggerTarget && !He.triggerTarget ? ur(_e.triggerTarget).forEach(function(Ee) {
        Ee.removeAttribute("aria-expanded");
      }) : He.triggerTarget && e.removeAttribute("aria-expanded"), I(), B(), A && A(_e, He), w.popperInstance && (de(), pe().forEach(function(Ee) {
        requestAnimationFrame(Ee._tippy.popperInstance.forceUpdate);
      })), T("onAfterUpdate", [w, Ae]);
    }
  }
  function be(Ae) {
    w.setProps({
      content: Ae
    });
  }
  function ke() {
    var Ae = w.state.isVisible, _e = w.state.isDestroyed, He = !w.state.isEnabled, Ee = Ca.isTouch && !w.props.touch, Ne = ap(w.props.duration, 0, fa.duration);
    if (!(Ae || _e || He || Ee) && !C().hasAttribute("disabled") && (T("onShow", [w], !1), w.props.onShow(w) !== !1)) {
      if (w.state.isVisible = !0, D() && (k.style.visibility = "visible"), B(), Q(), w.state.isMounted || (k.style.transition = "none"), D()) {
        var Ye = p(), Xe = Ye.box, nt = Ye.content;
        op([Xe, nt], 0);
      }
      m = function() {
        var bt;
        if (!(!w.state.isVisible || d)) {
          if (d = !0, k.offsetHeight, k.style.transition = w.props.moveTransition, D() && w.props.animation) {
            var Bt = p(), kt = Bt.box, nn = Bt.content;
            op([kt, nn], Ne), lc([kt, nn], "visible");
          }
          O(), I(), Oy(sp, w), (bt = w.popperInstance) == null || bt.forceUpdate(), T("onMount", [w]), w.props.animation && D() && V(Ne, function() {
            w.state.isShown = !0, T("onShown", [w]);
          });
        }
      }, ce();
    }
  }
  function we() {
    var Ae = !w.state.isVisible, _e = w.state.isDestroyed, He = !w.state.isEnabled, Ee = ap(w.props.duration, 1, fa.duration);
    if (!(Ae || _e || He) && (T("onHide", [w], !1), w.props.onHide(w) !== !1)) {
      if (w.state.isVisible = !1, w.state.isShown = !1, d = !1, r = !1, D() && (k.style.visibility = "hidden"), R(), J(), B(!0), D()) {
        var Ne = p(), Ye = Ne.box, Xe = Ne.content;
        w.props.animation && (op([Ye, Xe], Ee), lc([Ye, Xe], "hidden"));
      }
      O(), I(), w.props.animation ? D() && ee(Ee, w.unmount) : w.unmount();
    }
  }
  function Le(Ae) {
    b().addEventListener("mousemove", c), Oy(bd, c), c(Ae);
  }
  function Me() {
    w.state.isVisible && w.hide(), w.state.isMounted && (me(), pe().forEach(function(Ae) {
      Ae._tippy.unmount();
    }), k.parentNode && k.parentNode.removeChild(k), sp = sp.filter(function(Ae) {
      return Ae !== w;
    }), w.state.isMounted = !1, T("onHidden", [w]));
  }
  function De() {
    w.state.isDestroyed || (w.clearDelayTimeouts(), w.unmount(), z(), delete e._tippy, w.state.isDestroyed = !0, T("onDestroy", [w]));
  }
}
function St(e, t) {
  t === void 0 && (t = {});
  var n = fa.plugins.concat(t.plugins || []);
  N8();
  var i = Object.assign({}, t, {
    plugins: n
  }), o = B8(e), a = o.reduce(function(r, s) {
    var l = s && Y8(s, i);
    return l && r.push(l), r;
  }, []);
  return Ju(e) ? a[0] : a;
}
St.defaultProps = fa;
St.setDefaultProps = V8;
St.currentInput = Ca;
var q8 = Object.assign({}, sk, {
  effect: function(t) {
    var n = t.state, i = {
      popper: {
        position: n.options.strategy,
        left: "0",
        top: "0",
        margin: "0"
      },
      arrow: {
        position: "absolute"
      },
      reference: {}
    };
    Object.assign(n.elements.popper.style, i.popper), n.styles = i, n.elements.arrow && Object.assign(n.elements.arrow.style, i.arrow);
  }
}), K8 = function(t, n) {
  var i;
  n === void 0 && (n = {});
  var o = t, a = [], r = [], s, l = n.overrides, d = [], y = !1;
  function u() {
    r = o.map(function(w) {
      return ur(w.props.triggerTarget || w.reference);
    }).reduce(function(w, x) {
      return w.concat(x);
    }, []);
  }
  function m() {
    a = o.map(function(w) {
      return w.reference;
    });
  }
  function h(w) {
    o.forEach(function(x) {
      w ? x.enable() : x.disable();
    });
  }
  function c(w) {
    return o.map(function(x) {
      var k = x.setProps;
      return x.setProps = function(A) {
        k(A), x.reference === s && w.setProps(A);
      }, function() {
        x.setProps = k;
      };
    });
  }
  function g(w, x) {
    var k = r.indexOf(x);
    if (x !== s) {
      s = x;
      var A = (l || []).concat("content").reduce(function($, j) {
        return $[j] = o[k].props[j], $;
      }, {});
      w.setProps(Object.assign({}, A, {
        getReferenceClientRect: typeof A.getReferenceClientRect == "function" ? A.getReferenceClientRect : function() {
          var $;
          return ($ = a[k]) == null ? void 0 : $.getBoundingClientRect();
        }
      }));
    }
  }
  h(!1), m(), u();
  var v = {
    fn: function() {
      return {
        onDestroy: function() {
          h(!0);
        },
        onHidden: function() {
          s = null;
        },
        onClickOutside: function(k) {
          k.props.showOnCreate && !y && (y = !0, s = null);
        },
        onShow: function(k) {
          k.props.showOnCreate && !y && (y = !0, g(k, a[0]));
        },
        onTrigger: function(k, A) {
          g(k, A.currentTarget);
        }
      };
    }
  }, P = St(vr(), Object.assign({}, P8(n, ["overrides"]), {
    plugins: [v].concat(n.plugins || []),
    triggerTarget: r,
    popperOptions: Object.assign({}, n.popperOptions, {
      modifiers: [].concat(((i = n.popperOptions) == null ? void 0 : i.modifiers) || [], [q8])
    })
  })), f = P.show;
  P.show = function(w) {
    if (f(), !s && w == null)
      return g(P, a[0]);
    if (!(s && w == null)) {
      if (typeof w == "number")
        return a[w] && g(P, a[w]);
      if (o.indexOf(w) >= 0) {
        var x = w.reference;
        return g(P, x);
      }
      if (a.indexOf(w) >= 0)
        return g(P, w);
    }
  }, P.showNext = function() {
    var w = a[0];
    if (!s)
      return P.show(0);
    var x = a.indexOf(s);
    P.show(a[x + 1] || w);
  }, P.showPrevious = function() {
    var w = a[a.length - 1];
    if (!s)
      return P.show(w);
    var x = a.indexOf(s), k = a[x - 1] || w;
    P.show(k);
  };
  var S = P.setProps;
  return P.setProps = function(w) {
    l = w.overrides || l, S(w);
  }, P.setInstances = function(w) {
    h(!0), d.forEach(function(x) {
      return x();
    }), o = w, h(!1), m(), u(), d = c(P), P.setProps({
      triggerTarget: r
    });
  }, d = c(P), P;
}, X8 = {
  name: "animateFill",
  defaultValue: !1,
  fn: function(t) {
    var n;
    if (!((n = t.props.render) != null && n.$$tippy))
      return {};
    var i = pu(t.popper), o = i.box, a = i.content, r = t.props.animateFill ? Z8() : null;
    return {
      onCreate: function() {
        r && (o.insertBefore(r, o.firstElementChild), o.setAttribute("data-animatefill", ""), o.style.overflow = "hidden", t.setProps({
          arrow: !1,
          animation: "shift-away"
        }));
      },
      onMount: function() {
        if (r) {
          var l = o.style.transitionDuration, d = Number(l.replace("ms", ""));
          a.style.transitionDelay = Math.round(d / 10) + "ms", r.style.transitionDuration = l, lc([r], "visible");
        }
      },
      onShow: function() {
        r && (r.style.transitionDuration = "0ms");
      },
      onHide: function() {
        r && lc([r], "hidden");
      }
    };
  }
};
function Z8() {
  var e = vr();
  return e.className = mk, lc([e], "hidden"), e;
}
var af = {
  clientX: 0,
  clientY: 0
}, xd = [];
function Tk(e) {
  var t = e.clientX, n = e.clientY;
  af = {
    clientX: t,
    clientY: n
  };
}
function J8(e) {
  e.addEventListener("mousemove", Tk);
}
function Q8(e) {
  e.removeEventListener("mousemove", Tk);
}
var eN = {
  name: "followCursor",
  defaultValue: !1,
  fn: function(t) {
    var n = t.reference, i = wk(t.props.triggerTarget || n), o = !1, a = !1, r = !0, s = t.props;
    function l() {
      return t.props.followCursor === "initial" && t.state.isVisible;
    }
    function d() {
      i.addEventListener("mousemove", m);
    }
    function y() {
      i.removeEventListener("mousemove", m);
    }
    function u() {
      o = !0, t.setProps({
        getReferenceClientRect: null
      }), o = !1;
    }
    function m(g) {
      var v = g.target ? n.contains(g.target) : !0, P = t.props.followCursor, f = g.clientX, S = g.clientY, w = n.getBoundingClientRect(), x = f - w.left, k = S - w.top;
      (v || !t.props.interactive) && t.setProps({
        // @ts-ignore - unneeded DOMRect properties
        getReferenceClientRect: function() {
          var $ = n.getBoundingClientRect(), j = f, N = S;
          P === "initial" && (j = $.left + x, N = $.top + k);
          var M = P === "horizontal" ? $.top : N, D = P === "vertical" ? $.right : j, C = P === "horizontal" ? $.bottom : N, b = P === "vertical" ? $.left : j;
          return {
            width: D - b,
            height: C - M,
            top: M,
            right: D,
            bottom: C,
            left: b
          };
        }
      });
    }
    function h() {
      t.props.followCursor && (xd.push({
        instance: t,
        doc: i
      }), J8(i));
    }
    function c() {
      xd = xd.filter(function(g) {
        return g.instance !== t;
      }), xd.filter(function(g) {
        return g.doc === i;
      }).length === 0 && Q8(i);
    }
    return {
      onCreate: h,
      onDestroy: c,
      onBeforeUpdate: function() {
        s = t.props;
      },
      onAfterUpdate: function(v, P) {
        var f = P.followCursor;
        o || f !== void 0 && s.followCursor !== f && (c(), f ? (h(), t.state.isMounted && !a && !l() && d()) : (y(), u()));
      },
      onMount: function() {
        t.props.followCursor && !a && (r && (m(af), r = !1), l() || d());
      },
      onTrigger: function(v, P) {
        zm(P) && (af = {
          clientX: P.clientX,
          clientY: P.clientY
        }), a = P.type === "focus";
      },
      onHidden: function() {
        t.props.followCursor && (u(), y(), r = !0);
      }
    };
  }
};
function tN(e, t) {
  var n;
  return {
    popperOptions: Object.assign({}, e.popperOptions, {
      modifiers: [].concat((((n = e.popperOptions) == null ? void 0 : n.modifiers) || []).filter(function(i) {
        var o = i.name;
        return o !== t.name;
      }), [t])
    })
  };
}
var nN = {
  name: "inlinePositioning",
  defaultValue: !1,
  fn: function(t) {
    var n = t.reference;
    function i() {
      return !!t.props.inlinePositioning;
    }
    var o, a = -1, r = !1, s = [], l = {
      name: "tippyInlinePositioning",
      enabled: !0,
      phase: "afterWrite",
      fn: function(h) {
        var c = h.state;
        i() && (s.indexOf(c.placement) !== -1 && (s = []), o !== c.placement && s.indexOf(c.placement) === -1 && (s.push(c.placement), t.setProps({
          // @ts-ignore - unneeded DOMRect properties
          getReferenceClientRect: function() {
            return d(c.placement);
          }
        })), o = c.placement);
      }
    };
    function d(m) {
      return iN(xk(m), n.getBoundingClientRect(), fs(n.getClientRects()), a);
    }
    function y(m) {
      r = !0, t.setProps(m), r = !1;
    }
    function u() {
      r || y(tN(t.props, l));
    }
    return {
      onCreate: u,
      onAfterUpdate: u,
      onTrigger: function(h, c) {
        if (zm(c)) {
          var g = fs(t.reference.getClientRects()), v = g.find(function(f) {
            return f.left - 2 <= c.clientX && f.right + 2 >= c.clientX && f.top - 2 <= c.clientY && f.bottom + 2 >= c.clientY;
          }), P = g.indexOf(v);
          a = P > -1 ? P : a;
        }
      },
      onHidden: function() {
        a = -1;
      }
    };
  }
};
function iN(e, t, n, i) {
  if (n.length < 2 || e === null)
    return t;
  if (n.length === 2 && i >= 0 && n[0].left > n[1].right)
    return n[i] || t;
  switch (e) {
    case "top":
    case "bottom": {
      var o = n[0], a = n[n.length - 1], r = e === "top", s = o.top, l = a.bottom, d = r ? o.left : a.left, y = r ? o.right : a.right, u = y - d, m = l - s;
      return {
        top: s,
        bottom: l,
        left: d,
        right: y,
        width: u,
        height: m
      };
    }
    case "left":
    case "right": {
      var h = Math.min.apply(Math, n.map(function(k) {
        return k.left;
      })), c = Math.max.apply(Math, n.map(function(k) {
        return k.right;
      })), g = n.filter(function(k) {
        return e === "left" ? k.left === h : k.right === c;
      }), v = g[0].top, P = g[g.length - 1].bottom, f = h, S = c, w = S - f, x = P - v;
      return {
        top: v,
        bottom: P,
        left: f,
        right: S,
        width: w,
        height: x
      };
    }
    default:
      return t;
  }
}
var aN = {
  name: "sticky",
  defaultValue: !1,
  fn: function(t) {
    var n = t.reference, i = t.popper;
    function o() {
      return t.popperInstance ? t.popperInstance.state.elements.reference : n;
    }
    function a(d) {
      return t.props.sticky === !0 || t.props.sticky === d;
    }
    var r = null, s = null;
    function l() {
      var d = a("reference") ? o().getBoundingClientRect() : null, y = a("popper") ? i.getBoundingClientRect() : null;
      (d && Fy(r, d) || y && Fy(s, y)) && t.popperInstance && t.popperInstance.update(), r = d, s = y, t.state.isMounted && requestAnimationFrame(l);
    }
    return {
      onMount: function() {
        t.props.sticky && l();
      }
    };
  }
};
function Fy(e, t) {
  return e && t ? e.top !== t.top || e.right !== t.right || e.bottom !== t.bottom || e.left !== t.left : !0;
}
St.setDefaultProps({
  render: Ck
});
St.setDefaultProps({
  //@ts-ignore
  onShow: (e) => {
    if (!e.props.content)
      return !1;
  }
});
function Vm(e, t = {}, n = { mount: !0, appName: "Tippy" }) {
  n = Object.assign({ mount: !0, appName: "Tippy" }, n);
  const i = ho(), o = ge(), a = ge({
    isEnabled: !1,
    isVisible: !1,
    isDestroyed: !1,
    isMounted: !1,
    isShown: !1
  }), r = ti();
  let s = null;
  const l = () => s || (s = document.createDocumentFragment(), s), d = (A) => {
    let $, j = In(A) ? A.value : A;
    return Dx(j) ? (r.value || (r.value = cv({
      name: n.appName,
      setup: () => () => In(A) ? A.value : A
    }), i && Object.assign(r.value._context, i.appContext), r.value.mount(l())), $ = () => l()) : typeof j == "object" ? (r.value || (r.value = cv({
      name: n.appName,
      setup: () => () => At(In(A) ? A.value : A)
    }), i && Object.assign(r.value._context, i.appContext), r.value.mount(l())), $ = () => l()) : $ = j, $;
  }, y = (A) => {
    let $ = {};
    return In(A) ? $ = A.value || {} : wr(A) ? $ = { ...A } : $ = { ...A }, $.content && ($.content = d($.content)), $.triggerTarget && ($.triggerTarget = In($.triggerTarget) ? $.triggerTarget.value : $.triggerTarget), (!$.plugins || !Array.isArray($.plugins)) && ($.plugins = []), $.plugins = $.plugins.filter((j) => j.name !== "vueTippyReactiveState"), $.plugins.push({
      name: "vueTippyReactiveState",
      fn: () => ({
        onCreate() {
          a.value.isEnabled = !0;
        },
        onMount() {
          a.value.isMounted = !0;
        },
        onShow() {
          a.value.isMounted = !0, a.value.isVisible = !0;
        },
        onShown() {
          a.value.isShown = !0;
        },
        onHide() {
          a.value.isMounted = !1, a.value.isVisible = !1;
        },
        onHidden() {
          a.value.isShown = !1;
        },
        onUnmounted() {
          a.value.isMounted = !1;
        },
        onDestroy() {
          a.value.isDestroyed = !0;
        }
      })
    }), $;
  }, u = () => {
    o.value && o.value.setProps(y(t));
  }, m = () => {
    !o.value || !t.content || o.value.setContent(d(t.content));
  }, h = (A) => {
    var $;
    ($ = o.value) === null || $ === void 0 || $.setContent(d(A));
  }, c = (A) => {
    var $;
    ($ = o.value) === null || $ === void 0 || $.setProps(y(A));
  }, g = () => {
    var A;
    o.value && (o.value.destroy(), o.value = void 0), s = null, (A = r.value) === null || A === void 0 || A.unmount(), r.value = void 0;
  }, v = () => {
    var A;
    (A = o.value) === null || A === void 0 || A.show();
  }, P = () => {
    var A;
    (A = o.value) === null || A === void 0 || A.hide();
  }, f = () => {
    var A;
    (A = o.value) === null || A === void 0 || A.disable(), a.value.isEnabled = !1;
  }, S = () => {
    var A;
    (A = o.value) === null || A === void 0 || A.enable(), a.value.isEnabled = !0;
  }, w = () => {
    var A;
    (A = o.value) === null || A === void 0 || A.unmount();
  }, x = () => {
    if (!e)
      return;
    let A = In(e) ? e.value : e;
    typeof A == "function" && (A = A()), A && (o.value = St(A, y(t)), A.$tippy = k);
  }, k = {
    tippy: o,
    refresh: u,
    refreshContent: m,
    setContent: h,
    setProps: c,
    destroy: g,
    hide: P,
    show: v,
    disable: f,
    enable: S,
    unmount: w,
    mount: x,
    state: a
  };
  return n.mount && (i ? i.isMounted ? x() : it(x) : x()), i && sn(() => {
    g();
  }), In(t) || wr(t) ? qe(t, u, { immediate: !1 }) : In(t.content) && qe(t.content, m, { immediate: !1 }), k;
}
function oN(e, t) {
  const n = ge();
  return it(() => {
    const o = (Array.isArray(e) ? e.map((a) => a.value) : typeof e == "function" ? e() : e.value).map((a) => a instanceof Element ? a._tippy : a).filter(Boolean);
    n.value = K8(o, t ? { allowHTML: !0, ...t } : { allowHTML: !0 });
  }), {
    singleton: n
  };
}
function rN(e) {
  return typeof e == "function" ? e() : _(e);
}
function sN(e) {
  var t, n;
  const i = rN(e);
  return (n = (t = i) === null || t === void 0 ? void 0 : t.$el) !== null && n !== void 0 ? n : i;
}
const lN = Be({
  props: {
    to: {
      type: [String, Function]
    },
    tag: {
      type: [String, Object],
      default: "span"
    },
    contentTag: {
      type: [String, Object],
      default: "span"
    },
    contentClass: {
      type: String,
      default: null
    },
    appendTo: { default: () => St.defaultProps.appendTo },
    aria: { default: () => St.defaultProps.aria },
    delay: { default: () => St.defaultProps.delay },
    duration: { default: () => St.defaultProps.duration },
    getReferenceClientRect: { default: () => St.defaultProps.getReferenceClientRect },
    hideOnClick: { type: [Boolean, String], default: () => St.defaultProps.hideOnClick },
    ignoreAttributes: { type: Boolean, default: () => St.defaultProps.ignoreAttributes },
    interactive: { type: Boolean, default: () => St.defaultProps.interactive },
    interactiveBorder: { default: () => St.defaultProps.interactiveBorder },
    interactiveDebounce: { default: () => St.defaultProps.interactiveDebounce },
    moveTransition: { default: () => St.defaultProps.moveTransition },
    offset: { default: () => St.defaultProps.offset },
    onAfterUpdate: { default: () => St.defaultProps.onAfterUpdate },
    onBeforeUpdate: { default: () => St.defaultProps.onBeforeUpdate },
    onCreate: { default: () => St.defaultProps.onCreate },
    onDestroy: { default: () => St.defaultProps.onDestroy },
    onHidden: { default: () => St.defaultProps.onHidden },
    onHide: { default: () => St.defaultProps.onHide },
    onMount: { default: () => St.defaultProps.onMount },
    onShow: { default: () => St.defaultProps.onShow },
    onShown: { default: () => St.defaultProps.onShown },
    onTrigger: { default: () => St.defaultProps.onTrigger },
    onUntrigger: { default: () => St.defaultProps.onUntrigger },
    onClickOutside: { default: () => St.defaultProps.onClickOutside },
    placement: { default: () => St.defaultProps.placement },
    plugins: { default: () => St.defaultProps.plugins },
    popperOptions: { default: () => St.defaultProps.popperOptions },
    render: { default: () => St.defaultProps.render },
    showOnCreate: { type: Boolean, default: () => St.defaultProps.showOnCreate },
    touch: { type: [Boolean, String, Array], default: () => St.defaultProps.touch },
    trigger: { default: () => St.defaultProps.trigger },
    triggerTarget: { default: () => St.defaultProps.triggerTarget },
    animateFill: { type: Boolean, default: () => St.defaultProps.animateFill },
    followCursor: { type: [Boolean, String], default: () => St.defaultProps.followCursor },
    inlinePositioning: { type: Boolean, default: () => St.defaultProps.inlinePositioning },
    sticky: { type: [Boolean, String], default: () => St.defaultProps.sticky },
    allowHTML: { type: Boolean, default: () => St.defaultProps.allowHTML },
    animation: { default: () => St.defaultProps.animation },
    arrow: { default: () => St.defaultProps.arrow },
    content: { default: () => St.defaultProps.content },
    inertia: { default: () => St.defaultProps.inertia },
    maxWidth: { default: () => St.defaultProps.maxWidth },
    role: { default: () => St.defaultProps.role },
    theme: { default: () => St.defaultProps.theme },
    zIndex: { default: () => St.defaultProps.zIndex }
  },
  emits: ["state"],
  setup(e, { slots: t, emit: n, expose: i }) {
    const o = ge(), a = ge(), r = ge(), s = ge(!1), l = () => {
      let h = { ...e };
      for (const c of ["to", "tag", "contentTag", "contentClass"])
        h.hasOwnProperty(c) && delete h[c];
      return h;
    };
    let d = () => sN(o);
    e.to && (typeof Element < "u" && e.to instanceof Element ? d = () => e.to : e.to === "parent" ? d = () => {
      let h = o.value;
      return h || (h = o.value = a.value.parentElement), h;
    } : (typeof e.to == "string" || e.to instanceof String) && (d = () => document.querySelector(e.to)));
    const y = Vm(d, l());
    let u = t.content;
    !u && e.to === "parent" && (u = t.default), it(() => {
      s.value = !0, mt(() => {
        u && y.setContent(() => r.value);
      });
    }), qe(y.state, () => {
      n("state", _(y.state));
    }, { immediate: !0, deep: !0 }), qe(() => e, () => {
      y.setProps(l()), u && y.setContent(() => r.value);
    }, { deep: !0 });
    let m = Qi({
      elem: o,
      contentElem: r,
      mounted: s,
      ...y
    });
    return i(m), () => {
      const h = (typeof e.contentTag == "string", e.contentTag), c = u ? At(h, {
        ref: r,
        style: { display: s.value ? "inherit" : "none" },
        class: e.contentClass
      }, u(m)) : null;
      if (e.to === "parent") {
        const P = [];
        if (!o.value) {
          const f = At("span", {
            ref: a,
            "data-v-tippy": "",
            style: { display: "none" }
          });
          P.push(f);
        }
        return c && P.push(c), P;
      }
      const g = t.default ? t.default(m) : [];
      if (!e.tag) {
        const P = At(g[0], {
          ref: o,
          "data-v-tippy": ""
        });
        return c ? [P, c] : P;
      }
      const v = (typeof e.tag == "string", e.tag);
      return At(v, { ref: o, "data-v-tippy": "" }, c ? [g, c] : g);
    };
  }
}), cN = [
  "a11y",
  "allowHTML",
  "arrow",
  "flip",
  "flipOnUpdate",
  "hideOnClick",
  "ignoreAttributes",
  "inertia",
  "interactive",
  "lazy",
  "multiple",
  "showOnInit",
  "touch",
  "touchHold"
];
let of = {};
Object.keys(St.defaultProps).forEach((e) => {
  cN.includes(e) ? of[e] = {
    type: Boolean,
    default: function() {
      return St.defaultProps[e];
    }
  } : of[e] = {
    default: function() {
      return St.defaultProps[e];
    }
  };
});
const dN = Be({
  props: of,
  setup(e) {
    const t = ge([]), { singleton: n } = oN(t, e);
    return { instances: t, singleton: n };
  },
  mounted() {
    var e;
    const n = this.$el.parentElement.querySelectorAll("[data-v-tippy]");
    this.instances = Array.from(n).map((i) => i._tippy).filter(Boolean), (e = this.singleton) === null || e === void 0 || e.setInstances(this.instances);
  },
  render() {
    let e = this.$slots.default ? this.$slots.default() : [];
    return At(() => e);
  }
}), uN = {
  mounted(e, t, n) {
    const i = typeof t.value == "string" ? { content: t.value } : t.value || {}, o = Object.keys(t.modifiers || {}), a = o.find((s) => s !== "arrow"), r = o.findIndex((s) => s === "arrow") !== -1;
    a && (i.placement = i.placement || a), r && (i.arrow = i.arrow !== void 0 ? i.arrow : !0), n.props && n.props.onTippyShow && (i.onShow = function(...s) {
      var l;
      return (l = n.props) === null || l === void 0 ? void 0 : l.onTippyShow(...s);
    }), n.props && n.props.onTippyShown && (i.onShown = function(...s) {
      var l;
      return (l = n.props) === null || l === void 0 ? void 0 : l.onTippyShown(...s);
    }), n.props && n.props.onTippyHidden && (i.onHidden = function(...s) {
      var l;
      return (l = n.props) === null || l === void 0 ? void 0 : l.onTippyHidden(...s);
    }), n.props && n.props.onTippyHide && (i.onHide = function(...s) {
      var l;
      return (l = n.props) === null || l === void 0 ? void 0 : l.onTippyHide(...s);
    }), n.props && n.props.onTippyMount && (i.onMount = function(...s) {
      var l;
      return (l = n.props) === null || l === void 0 ? void 0 : l.onTippyMount(...s);
    }), e.getAttribute("title") && !i.content && (i.content = e.getAttribute("title"), e.removeAttribute("title")), e.getAttribute("content") && !i.content && (i.content = e.getAttribute("content")), Vm(e, i);
  },
  unmounted(e) {
    e.$tippy ? e.$tippy.destroy() : e._tippy && e._tippy.destroy();
  },
  updated(e, t) {
    const n = typeof t.value == "string" ? { content: t.value } : t.value || {};
    e.getAttribute("title") && !n.content && (n.content = e.getAttribute("title"), e.removeAttribute("title")), e.getAttribute("content") && !n.content && (n.content = e.getAttribute("content")), e.$tippy ? e.$tippy.setProps(n || {}) : e._tippy && e._tippy.setProps(n || {});
  }
}, hN = {
  install(e, t = {}) {
    St.setDefaultProps(t.defaultProps || {}), e.directive(t.directive || "tippy", uN), e.component(t.component || "tippy", lN), e.component(t.componentSingleton || "tippy-singleton", dN);
  }
}, pN = St.setDefaultProps;
pN({
  ignoreAttributes: !0,
  plugins: [aN, nN, eN, X8]
});
const fN = hN;
var st = /* @__PURE__ */ ((e) => (e.TwelvePx = "12px", e.FourteenPx = "14px", e.SixteenPx = "16px", e.EighteenPx = "18px", e.TwentyFour = "24px", e.FourtyPx = "40px", e))(st || {}), dt = /* @__PURE__ */ ((e) => (e.GreyBlue004 = "grey-blue-004", e.GreyBlue006 = "grey-blue-006", e.GreyBlue008 = "grey-blue-008", e.GreyBlue009 = "grey-blue-009", e.Negative = "negativ", e.Success = "success", e.Primary = "primary", e.White = "white", e.NearWhite = "near-white", e))(dt || {}), lt = /* @__PURE__ */ ((e) => (e.DwsSans = "dws-sans", e.DwsSansBold = "dws-sans-bold", e.DwsSansLight = "dws-sans-light", e.DwsSlab = "dws-slab", e.DwsSlabBold = "dws-slab-bold", e.DwsSlabLight = "dws-slab-light", e))(lt || {});
const mN = ["innerHTML"], gN = /* @__PURE__ */ Be({
  __name: "BaseText",
  props: {
    text: {
      type: String,
      default: ""
    },
    fontSize: {
      type: String,
      default: st.SixteenPx
    },
    textColor: {
      type: String,
      default: dt.GreyBlue008
    },
    fontType: {
      type: String,
      default: lt.DwsSans
    },
    maxLength: {
      type: Number,
      default: Number.MAX_SAFE_INTEGER
    },
    clippedAfterLastWord: {
      type: Boolean,
      default: !1
    },
    clippedTextSuffix: {
      type: String,
      default: "..."
    },
    renderAsString: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const t = e, n = Te(() => Ml({
      text: t.text,
      maxCharacters: t.maxLength,
      clippedAfterLastWord: t.clippedAfterLastWord,
      clippedTextSuffix: t.clippedTextSuffix
    })), i = Te(() => {
      switch (t.fontSize) {
        case st.TwelvePx:
          return "d-base-text--font-size-12";
        case st.FourteenPx:
          return "d-base-text--font-size-14";
        case st.SixteenPx:
          return "d-base-text--font-size-16";
        case st.EighteenPx:
          return "d-base-text--font-size-18";
        case st.TwentyFour:
          return "d-base-text--font-size-24";
        case st.FourtyPx:
          return "d-base-text--font-size-40";
        default:
          return "";
      }
    }), o = Te(() => t.textColor ? `d-base-text--color-${t.textColor}` : ""), a = Te(() => t.fontType ? `d-base-text--font-${t.fontType}` : "");
    return (r, s) => (E(), X("p", {
      class: Pe(["d-base-text", [o.value, i.value, a.value]])
    }, [
      e.renderAsString ? (E(), X("span", {
        key: 0,
        innerHTML: n.value
      }, null, 8, mN)) : (E(), fe(_(ht), {
        key: 1,
        "html-text": n.value,
        "disable-default-styling": ""
      }, null, 8, ["html-text"]))
    ], 2));
  }
});
const Tt = /* @__PURE__ */ Fe(gN, [["__scopeId", "data-v-f8858b6a"]]), vN = { class: "d-info-overlay" }, yN = { class: "d-info-overlay__header" }, bN = /* @__PURE__ */ Be({
  __name: "InfoOverlay",
  props: {
    headline: {
      type: String,
      required: !0
    },
    infoText: {
      type: String,
      required: !0
    }
  },
  emits: ["closeInfoOverlay"],
  setup(e, { emit: t }) {
    const { isDesktop: n } = xt(), { t: i } = Je(), o = t;
    function a() {
      o("closeInfoOverlay");
    }
    return (r, s) => (E(), X("div", vN, [
      oe("div", yN, [
        ue(Tt, {
          class: "d-info-overlay__headline",
          text: e.headline,
          "font-type": _(lt).DwsSlabBold,
          "text-color": _(dt).GreyBlue009
        }, null, 8, ["text", "font-type", "text-color"]),
        _(n) ? te("", !0) : (E(), X("div", {
          key: 0,
          class: "d-info-overlay__close",
          tabindex: "0",
          role: "button",
          "data-id": "silktide-close",
          onKeypress: s[0] || (s[0] = Ze((l) => a(), ["enter"])),
          onClick: s[1] || (s[1] = (l) => a())
        }, [
          ue(_t, {
            class: "d-info-overlay__close__icon",
            "base-icon": _(H).Times,
            "base-icon-size": _(at).S,
            "aria-label": _(i)("globalTranslations.close")
          }, null, 8, ["base-icon", "base-icon-size", "aria-label"])
        ], 32))
      ]),
      ue(Tt, {
        class: "d-info-overlay__info-text",
        text: e.infoText,
        "font-type": _(lt).DwsSans,
        "font-size": _(st).FourteenPx,
        "text-color": _(dt).GreyBlue009
      }, null, 8, ["text", "font-type", "font-size", "text-color"])
    ]));
  }
});
const xN = /* @__PURE__ */ Fe(bN, [["__scopeId", "data-v-197f9bc7"]]), wN = {
  key: 0,
  class: "d-tooltip"
}, kN = /* @__PURE__ */ Be({
  __name: "Tooltip",
  props: {
    tooltipText: {
      type: String,
      required: !0
    }
  },
  setup(e) {
    return (t, n) => e.tooltipText ? (E(), X("div", wN, [
      ue(Tt, {
        text: e.tooltipText,
        "max-length": 150,
        class: "d-tooltip__text",
        "font-type": _(lt).DwsSansBold,
        "font-size": _(st).FourteenPx,
        "text-color": _(dt).GreyBlue009,
        "render-as-string": ""
      }, null, 8, ["text", "font-type", "font-size", "text-color"])
    ])) : te("", !0);
  }
});
const SN = /* @__PURE__ */ Fe(kN, [["__scopeId", "data-v-95c18205"]]), CN = { class: "d-base-overlay__info" }, Lk = /* @__PURE__ */ Be({
  __name: "BaseOverlay",
  props: {
    headline: {
      type: String,
      default: ""
    },
    content: {
      type: String,
      required: !0
    },
    overlayType: {
      type: String,
      default: void 0
    }
  },
  emits: ["closeOverlay"],
  setup(e, { emit: t }) {
    const n = e, i = () => n.overlayType === ms.InfoOverlay || n.content.length > 150 ? At(xN, {
      headline: n.headline,
      infoText: n.content
    }) : At(SN, {
      tooltipText: n.content
    }), o = t;
    function a() {
      o("closeOverlay");
    }
    return (r, s) => (E(), X("div", CN, [
      e.content ? (E(), fe(tt(i()), {
        key: 0,
        class: "d-base-overlay",
        onCloseInfoOverlay: a,
        onHide: a
      }, null, 32)) : te("", !0)
    ]));
  }
});
const { isDesktop: jy } = xt();
let So;
var ms = /* @__PURE__ */ ((e) => (e.Tooltip = "tooltip", e.InfoOverlay = "info-overlay", e))(ms || {});
const pn = (e) => {
  function t() {
    if (Ue && !jy.value && o()) {
      const y = document.body;
      y && (y.style.overflow === "hidden" ? y.style.overflow = "" : y.style.overflow = "hidden");
    }
  }
  const n = (y, u, m) => At(Lk, {
    headline: y,
    content: u,
    overlayType: m,
    onCloseOverlay: () => i()
  }), i = () => {
    So.hide();
  }, o = () => rf(e.content, e.manuallyOverlayType) === "info-overlay", a = () => {
    let y;
    return e.appendTo === "parent" ? y = d.value.parentElement.querySelector("[data-tippy-root]") : y = d.value.querySelector("[data-tippy-root]"), y;
  }, r = () => {
    if (Ue && !jy.value && o()) {
      const y = a();
      if (y) {
        y.querySelector(".tippy-box")?.setAttribute("style", "transition-duration: 300ms;");
        const m = document.documentElement.clientHeight, h = y.scrollHeight, c = 20, g = m - h - c;
        y.setAttribute(
          "style",
          `z-index: 9999; visibility: visible; position: fixed; margin: 0px; inset: 0px auto auto 0px; top: ${g}px;`
        );
      }
    }
  }, s = () => {
    if (Ue && e.useSetFixedPosition) {
      const y = d.value.querySelector(
        "[data-tippy-root]"
      );
      if (y) {
        const u = y.querySelector(".tippy-box"), m = y.querySelector(
          ".tippy-arrow"
        );
        u?.setAttribute("style", "transition-duration: 300ms;");
        const h = d.value, c = y?.offsetWidth, g = m?.offsetWidth, v = window.getComputedStyle(m, "::before").getPropertyValue("top"), P = Math.abs(parseInt(v, 10)), f = h.offsetTop + h.offsetHeight + P;
        y.setAttribute(
          "style",
          `z-index: 9999; visibility: visible; position: fixed; margin: 0px; top: ${f}px; left: ${e.positionLeft - c / 2}px;`
        ), m?.setAttribute(
          "style",
          `position: fixed; left: ${e.positionLeft - g / 2}px; top: ${f}px; `
        );
      }
    }
  }, l = () => {
    if (e.headline || e.content) {
      const y = (m, h) => {
        m.key === "Escape" && h && h.hide();
      };
      d.value?.setAttribute("tabindex", "0"), d.value?.classList.add("d-base-overlay-trigger");
      const { setContent: u } = Vm(_(e.field()), {
        appendTo: _(e.appendTo),
        hideOnClick: !0,
        interactive: !0,
        inertia: !0,
        inlinePositioning: !0,
        theme: rf(e.content, e.manuallyOverlayType),
        maxWidth: 440,
        placement: "bottom",
        touch: e.showOnTouchDevices,
        aria: {
          content: "describedby",
          expanded: !1
        },
        role: null,
        trigger: "mouseenter focus",
        triggerTarget: _(e.triggerTarget),
        onCreate(m) {
          So = m;
        },
        onMount: (m) => {
          if (m.popperInstance.update(), Ue) {
            const h = a();
            h && h.setAttribute("role", "tooltip"), window.requestAnimationFrame(() => {
              r(), s();
            });
          }
          So = m;
        },
        onShow: (m) => {
          So = m, _(e.trigger).classList.add("overlay-open"), t(), nw(() => {
            d.value?.setAttribute(
              "aria-describedby",
              So.popper.id
            );
          }, 500), Ue && document.addEventListener(
            "keydown",
            (h) => y(h, m)
          );
        },
        onHide: (m) => {
          Ue && document.removeEventListener(
            "keydown",
            (h) => y(h, m)
          ), So = m, _(e.trigger).classList.remove("overlay-open"), t(), d.value?.removeAttribute("aria-describedby");
        }
      });
      u(
        n(e.headline, e.content, e.manuallyOverlayType)
      );
    }
  }, d = xi(e?.trigger);
  return qe(
    d,
    () => {
      l();
    },
    { deep: !0, immediate: !0 }
  ), {
    tippyInstance: So
  };
}, Hy = () => {
  So.destroy();
}, rf = (e, t) => t || (e.length > 150 ? "info-overlay" : "tooltip"), TN = ["id"], LN = /* @__PURE__ */ Be({
  __name: "SrrIndicator",
  props: {
    tooltipLabel: {
      type: String,
      default: "SRRI"
    },
    rating: {
      type: Number,
      required: !0,
      default: 1
    }
  },
  setup(e) {
    const t = e, n = [1, 2, 3, 4, 5, 6, 7], i = Pn(), o = ge([]), a = ge();
    return zc(() => {
      o.value = [];
    }), it(() => {
      o.value.forEach((r, s) => {
        pn({
          trigger: r,
          content: t.tooltipLabel + " " + (s + 1),
          appendTo: "parent",
          showOnTouchDevices: !0,
          field: () => r,
          triggerTarget: a.value
        });
      });
    }), (r, s) => (E(), X("div", {
      ref_key: "srrIndicatorRef",
      ref: a,
      class: "srr-indicator"
    }, [
      (E(), X(Re, null, Ge(n, (l, d) => oe("span", {
        id: `rate-${d}-${_(i)}`,
        key: d,
        ref_for: !0,
        ref: (y) => {
          l === e.rating && (o.value[d] = y);
        },
        class: Pe(["srr-element", {
          "active-rating": l == e.rating
        }])
      }, Ie(l), 11, TN)), 64))
    ], 512));
  }
});
const Ik = /* @__PURE__ */ Fe(LN, [["__scopeId", "data-v-c0103a96"]]);
var aa = /* @__PURE__ */ ((e) => (e.Center = "center", e.Top = "top", e.Bottom = "bottom", e.Left = "left", e.Right = "right", e.Topleft = "topleft", e.Topright = "topright", e.Bottomleft = "bottomleft", e.Bottomright = "bottomright", e))(aa || {}), Pk = {
  name: "WindowMaximizeIcon",
  extends: Yt,
  computed: {
    pathId: function() {
      return "pv_icon_clip_".concat(Mt());
    }
  }
}, IN = ["clip-path"], PN = /* @__PURE__ */ oe("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M7 14H11.8C12.3835 14 12.9431 13.7682 13.3556 13.3556C13.7682 12.9431 14 12.3835 14 11.8V2.2C14 1.61652 13.7682 1.05694 13.3556 0.644365C12.9431 0.231785 12.3835 0 11.8 0H2.2C1.61652 0 1.05694 0.231785 0.644365 0.644365C0.231785 1.05694 0 1.61652 0 2.2V7C0 7.15913 0.063214 7.31174 0.175736 7.42426C0.288258 7.53679 0.44087 7.6 0.6 7.6C0.75913 7.6 0.911742 7.53679 1.02426 7.42426C1.13679 7.31174 1.2 7.15913 1.2 7V2.2C1.2 1.93478 1.30536 1.68043 1.49289 1.49289C1.68043 1.30536 1.93478 1.2 2.2 1.2H11.8C12.0652 1.2 12.3196 1.30536 12.5071 1.49289C12.6946 1.68043 12.8 1.93478 12.8 2.2V11.8C12.8 12.0652 12.6946 12.3196 12.5071 12.5071C12.3196 12.6946 12.0652 12.8 11.8 12.8H7C6.84087 12.8 6.68826 12.8632 6.57574 12.9757C6.46321 13.0883 6.4 13.2409 6.4 13.4C6.4 13.5591 6.46321 13.7117 6.57574 13.8243C6.68826 13.9368 6.84087 14 7 14ZM9.77805 7.42192C9.89013 7.534 10.0415 7.59788 10.2 7.59995C10.3585 7.59788 10.5099 7.534 10.622 7.42192C10.7341 7.30985 10.798 7.15844 10.8 6.99995V3.94242C10.8066 3.90505 10.8096 3.86689 10.8089 3.82843C10.8079 3.77159 10.7988 3.7157 10.7824 3.6623C10.756 3.55552 10.701 3.45698 10.622 3.37798C10.5099 3.2659 10.3585 3.20202 10.2 3.19995H7.00002C6.84089 3.19995 6.68828 3.26317 6.57576 3.37569C6.46324 3.48821 6.40002 3.64082 6.40002 3.79995C6.40002 3.95908 6.46324 4.11169 6.57576 4.22422C6.68828 4.33674 6.84089 4.39995 7.00002 4.39995H8.80006L6.19997 7.00005C6.10158 7.11005 6.04718 7.25246 6.04718 7.40005C6.04718 7.54763 6.10158 7.69004 6.19997 7.80005C6.30202 7.91645 6.44561 7.98824 6.59997 8.00005C6.75432 7.98824 6.89791 7.91645 6.99997 7.80005L9.60002 5.26841V6.99995C9.6021 7.15844 9.66598 7.30985 9.77805 7.42192ZM1.4 14H3.8C4.17066 13.9979 4.52553 13.8498 4.78763 13.5877C5.04973 13.3256 5.1979 12.9707 5.2 12.6V10.2C5.1979 9.82939 5.04973 9.47452 4.78763 9.21242C4.52553 8.95032 4.17066 8.80215 3.8 8.80005H1.4C1.02934 8.80215 0.674468 8.95032 0.412371 9.21242C0.150274 9.47452 0.00210008 9.82939 0 10.2V12.6C0.00210008 12.9707 0.150274 13.3256 0.412371 13.5877C0.674468 13.8498 1.02934 13.9979 1.4 14ZM1.25858 10.0586C1.29609 10.0211 1.34696 10 1.4 10H3.8C3.85304 10 3.90391 10.0211 3.94142 10.0586C3.97893 10.0961 4 10.147 4 10.2V12.6C4 12.6531 3.97893 12.704 3.94142 12.7415C3.90391 12.779 3.85304 12.8 3.8 12.8H1.4C1.34696 12.8 1.29609 12.779 1.25858 12.7415C1.22107 12.704 1.2 12.6531 1.2 12.6V10.2C1.2 10.147 1.22107 10.0961 1.25858 10.0586Z",
  fill: "currentColor"
}, null, -1), AN = [PN], _N = ["id"], MN = /* @__PURE__ */ oe("rect", {
  width: "14",
  height: "14",
  fill: "white"
}, null, -1), ON = [MN];
function BN(e, t, n, i, o, a) {
  return E(), X("svg", Ce({
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.pti()), [oe("g", {
    "clip-path": "url(#".concat(a.pathId, ")")
  }, AN, 8, IN), oe("defs", null, [oe("clipPath", {
    id: "".concat(a.pathId)
  }, ON, 8, _N)])], 16);
}
Pk.render = BN;
var Ak = {
  name: "WindowMinimizeIcon",
  extends: Yt,
  computed: {
    pathId: function() {
      return "pv_icon_clip_".concat(Mt());
    }
  }
}, EN = ["clip-path"], DN = /* @__PURE__ */ oe("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M11.8 0H2.2C1.61652 0 1.05694 0.231785 0.644365 0.644365C0.231785 1.05694 0 1.61652 0 2.2V7C0 7.15913 0.063214 7.31174 0.175736 7.42426C0.288258 7.53679 0.44087 7.6 0.6 7.6C0.75913 7.6 0.911742 7.53679 1.02426 7.42426C1.13679 7.31174 1.2 7.15913 1.2 7V2.2C1.2 1.93478 1.30536 1.68043 1.49289 1.49289C1.68043 1.30536 1.93478 1.2 2.2 1.2H11.8C12.0652 1.2 12.3196 1.30536 12.5071 1.49289C12.6946 1.68043 12.8 1.93478 12.8 2.2V11.8C12.8 12.0652 12.6946 12.3196 12.5071 12.5071C12.3196 12.6946 12.0652 12.8 11.8 12.8H7C6.84087 12.8 6.68826 12.8632 6.57574 12.9757C6.46321 13.0883 6.4 13.2409 6.4 13.4C6.4 13.5591 6.46321 13.7117 6.57574 13.8243C6.68826 13.9368 6.84087 14 7 14H11.8C12.3835 14 12.9431 13.7682 13.3556 13.3556C13.7682 12.9431 14 12.3835 14 11.8V2.2C14 1.61652 13.7682 1.05694 13.3556 0.644365C12.9431 0.231785 12.3835 0 11.8 0ZM6.368 7.952C6.44137 7.98326 6.52025 7.99958 6.6 8H9.8C9.95913 8 10.1117 7.93678 10.2243 7.82426C10.3368 7.71174 10.4 7.55913 10.4 7.4C10.4 7.24087 10.3368 7.08826 10.2243 6.97574C10.1117 6.86321 9.95913 6.8 9.8 6.8H8.048L10.624 4.224C10.73 4.11026 10.7877 3.95982 10.7849 3.80438C10.7822 3.64894 10.7192 3.50063 10.6093 3.3907C10.4994 3.28077 10.3511 3.2178 10.1956 3.21506C10.0402 3.21232 9.88974 3.27002 9.776 3.376L7.2 5.952V4.2C7.2 4.04087 7.13679 3.88826 7.02426 3.77574C6.91174 3.66321 6.75913 3.6 6.6 3.6C6.44087 3.6 6.28826 3.66321 6.17574 3.77574C6.06321 3.88826 6 4.04087 6 4.2V7.4C6.00042 7.47975 6.01674 7.55862 6.048 7.632C6.07656 7.70442 6.11971 7.7702 6.17475 7.82524C6.2298 7.88029 6.29558 7.92344 6.368 7.952ZM1.4 8.80005H3.8C4.17066 8.80215 4.52553 8.95032 4.78763 9.21242C5.04973 9.47452 5.1979 9.82939 5.2 10.2V12.6C5.1979 12.9707 5.04973 13.3256 4.78763 13.5877C4.52553 13.8498 4.17066 13.9979 3.8 14H1.4C1.02934 13.9979 0.674468 13.8498 0.412371 13.5877C0.150274 13.3256 0.00210008 12.9707 0 12.6V10.2C0.00210008 9.82939 0.150274 9.47452 0.412371 9.21242C0.674468 8.95032 1.02934 8.80215 1.4 8.80005ZM3.94142 12.7415C3.97893 12.704 4 12.6531 4 12.6V10.2C4 10.147 3.97893 10.0961 3.94142 10.0586C3.90391 10.0211 3.85304 10 3.8 10H1.4C1.34696 10 1.29609 10.0211 1.25858 10.0586C1.22107 10.0961 1.2 10.147 1.2 10.2V12.6C1.2 12.6531 1.22107 12.704 1.25858 12.7415C1.29609 12.779 1.34696 12.8 1.4 12.8H3.8C3.85304 12.8 3.90391 12.779 3.94142 12.7415Z",
  fill: "currentColor"
}, null, -1), RN = [DN], NN = ["id"], $N = /* @__PURE__ */ oe("rect", {
  width: "14",
  height: "14",
  fill: "white"
}, null, -1), FN = [$N];
function jN(e, t, n, i, o, a) {
  return E(), X("svg", Ce({
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.pti()), [oe("g", {
    "clip-path": "url(#".concat(a.pathId, ")")
  }, RN, 8, EN), oe("defs", null, [oe("clipPath", {
    id: "".concat(a.pathId)
  }, FN, 8, NN)])], 16);
}
Ak.render = jN;
var HN = `
@layer primevue {
    .p-dialog-mask.p-component-overlay {
        pointer-events: auto;
    }

    .p-dialog {
        max-height: 90%;
        transform: scale(1);
    }

    .p-dialog-content {
        overflow-y: auto;
    }

    .p-dialog-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        flex-shrink: 0;
    }

    .p-dialog-footer {
        flex-shrink: 0;
    }

    .p-dialog .p-dialog-header-icons {
        display: flex;
        align-items: center;
    }

    .p-dialog .p-dialog-header-icon {
        display: flex;
        align-items: center;
        justify-content: center;
        overflow: hidden;
        position: relative;
    }

    /* Fluid */
    .p-fluid .p-dialog-footer .p-button {
        width: auto;
    }

    /* Animation */
    /* Center */
    .p-dialog-enter-active {
        transition: all 150ms cubic-bezier(0, 0, 0.2, 1);
    }
    .p-dialog-leave-active {
        transition: all 150ms cubic-bezier(0.4, 0, 0.2, 1);
    }
    .p-dialog-enter-from,
    .p-dialog-leave-to {
        opacity: 0;
        transform: scale(0.7);
    }

    /* Top, Bottom, Left, Right, Top* and Bottom* */
    .p-dialog-top .p-dialog,
    .p-dialog-bottom .p-dialog,
    .p-dialog-left .p-dialog,
    .p-dialog-right .p-dialog,
    .p-dialog-topleft .p-dialog,
    .p-dialog-topright .p-dialog,
    .p-dialog-bottomleft .p-dialog,
    .p-dialog-bottomright .p-dialog {
        margin: 0.75rem;
        transform: translate3d(0px, 0px, 0px);
    }
    .p-dialog-top .p-dialog-enter-active,
    .p-dialog-top .p-dialog-leave-active,
    .p-dialog-bottom .p-dialog-enter-active,
    .p-dialog-bottom .p-dialog-leave-active,
    .p-dialog-left .p-dialog-enter-active,
    .p-dialog-left .p-dialog-leave-active,
    .p-dialog-right .p-dialog-enter-active,
    .p-dialog-right .p-dialog-leave-active,
    .p-dialog-topleft .p-dialog-enter-active,
    .p-dialog-topleft .p-dialog-leave-active,
    .p-dialog-topright .p-dialog-enter-active,
    .p-dialog-topright .p-dialog-leave-active,
    .p-dialog-bottomleft .p-dialog-enter-active,
    .p-dialog-bottomleft .p-dialog-leave-active,
    .p-dialog-bottomright .p-dialog-enter-active,
    .p-dialog-bottomright .p-dialog-leave-active {
        transition: all 0.3s ease-out;
    }
    .p-dialog-top .p-dialog-enter-from,
    .p-dialog-top .p-dialog-leave-to {
        transform: translate3d(0px, -100%, 0px);
    }
    .p-dialog-bottom .p-dialog-enter-from,
    .p-dialog-bottom .p-dialog-leave-to {
        transform: translate3d(0px, 100%, 0px);
    }
    .p-dialog-left .p-dialog-enter-from,
    .p-dialog-left .p-dialog-leave-to,
    .p-dialog-topleft .p-dialog-enter-from,
    .p-dialog-topleft .p-dialog-leave-to,
    .p-dialog-bottomleft .p-dialog-enter-from,
    .p-dialog-bottomleft .p-dialog-leave-to {
        transform: translate3d(-100%, 0px, 0px);
    }
    .p-dialog-right .p-dialog-enter-from,
    .p-dialog-right .p-dialog-leave-to,
    .p-dialog-topright .p-dialog-enter-from,
    .p-dialog-topright .p-dialog-leave-to,
    .p-dialog-bottomright .p-dialog-enter-from,
    .p-dialog-bottomright .p-dialog-leave-to {
        transform: translate3d(100%, 0px, 0px);
    }

    /* Maximize */
    .p-dialog-maximized {
        -webkit-transition: none;
        transition: none;
        transform: none;
        width: 100vw !important;
        height: 100vh !important;
        top: 0px;
        left: 0px;
        max-height: 100%;
        height: 100%;
    }
    .p-dialog-maximized .p-dialog-content {
        flex-grow: 1;
    }

    .p-confirm-dialog .p-dialog-content {
        display: flex;
        align-items: center;
    }
}
`, zN = {
  mask: function(t) {
    var n = t.position, i = t.modal;
    return {
      position: "fixed",
      height: "100%",
      width: "100%",
      left: 0,
      top: 0,
      display: "flex",
      justifyContent: n === "left" || n === "topleft" || n === "bottomleft" ? "flex-start" : n === "right" || n === "topright" || n === "bottomright" ? "flex-end" : "center",
      alignItems: n === "top" || n === "topleft" || n === "topright" ? "flex-start" : n === "bottom" || n === "bottomleft" || n === "bottomright" ? "flex-end" : "center",
      pointerEvents: i ? "auto" : "none"
    };
  },
  root: {
    display: "flex",
    flexDirection: "column",
    pointerEvents: "auto"
  }
}, VN = {
  mask: function(t) {
    var n = t.props, i = ["left", "right", "top", "topleft", "topright", "bottom", "bottomleft", "bottomright"], o = i.find(function(a) {
      return a === n.position;
    });
    return ["p-dialog-mask", {
      "p-component-overlay p-component-overlay-enter": n.modal
    }, o ? "p-dialog-".concat(o) : ""];
  },
  root: function(t) {
    var n = t.props, i = t.instance;
    return ["p-dialog p-component", {
      "p-dialog-rtl": n.rtl,
      "p-dialog-maximized": n.maximizable && i.maximized,
      "p-input-filled": i.$primevue.config.inputStyle === "filled",
      "p-ripple-disabled": i.$primevue.config.ripple === !1
    }];
  },
  header: "p-dialog-header",
  title: "p-dialog-title",
  icons: "p-dialog-header-icons",
  maximizableButton: "p-dialog-header-icon p-dialog-header-maximize p-link",
  maximizableIcon: "p-dialog-header-maximize-icon",
  closeButton: "p-dialog-header-icon p-dialog-header-close p-link",
  closeButtonIcon: "p-dialog-header-close-icon",
  content: "p-dialog-content",
  footer: "p-dialog-footer"
}, GN = Wt.extend({
  name: "dialog",
  css: HN,
  classes: VN,
  inlineStyles: zN
}), UN = {
  name: "BaseDialog",
  extends: wt,
  props: {
    header: {
      type: null,
      default: null
    },
    footer: {
      type: null,
      default: null
    },
    visible: {
      type: Boolean,
      default: !1
    },
    modal: {
      type: Boolean,
      default: null
    },
    contentStyle: {
      type: null,
      default: null
    },
    contentClass: {
      type: String,
      default: null
    },
    contentProps: {
      type: null,
      default: null
    },
    rtl: {
      type: Boolean,
      default: null
    },
    maximizable: {
      type: Boolean,
      default: !1
    },
    dismissableMask: {
      type: Boolean,
      default: !1
    },
    closable: {
      type: Boolean,
      default: !0
    },
    closeOnEscape: {
      type: Boolean,
      default: !0
    },
    showHeader: {
      type: Boolean,
      default: !0
    },
    blockScroll: {
      type: Boolean,
      default: !1
    },
    baseZIndex: {
      type: Number,
      default: 0
    },
    autoZIndex: {
      type: Boolean,
      default: !0
    },
    position: {
      type: String,
      default: "center"
    },
    breakpoints: {
      type: Object,
      default: null
    },
    draggable: {
      type: Boolean,
      default: !0
    },
    keepInViewport: {
      type: Boolean,
      default: !0
    },
    minX: {
      type: Number,
      default: 0
    },
    minY: {
      type: Number,
      default: 0
    },
    appendTo: {
      type: [String, Object],
      default: "body"
    },
    closeIcon: {
      type: String,
      default: void 0
    },
    maximizeIcon: {
      type: String,
      default: void 0
    },
    minimizeIcon: {
      type: String,
      default: void 0
    },
    closeButtonProps: {
      type: null,
      default: null
    },
    _instance: null
  },
  style: GN,
  provide: function() {
    return {
      $parentInstance: this
    };
  }
}, Gm = {
  name: "Dialog",
  extends: UN,
  inheritAttrs: !1,
  emits: ["update:visible", "show", "hide", "after-hide", "maximize", "unmaximize", "dragend"],
  provide: function() {
    var t = this;
    return {
      dialogRef: Te(function() {
        return t._instance;
      })
    };
  },
  data: function() {
    return {
      containerVisible: this.visible,
      maximized: !1,
      focusableMax: null,
      focusableClose: null
    };
  },
  documentKeydownListener: null,
  container: null,
  mask: null,
  content: null,
  headerContainer: null,
  footerContainer: null,
  maximizableButton: null,
  closeButton: null,
  styleElement: null,
  dragging: null,
  documentDragListener: null,
  documentDragEndListener: null,
  lastPageX: null,
  lastPageY: null,
  updated: function() {
    this.visible && (this.containerVisible = this.visible);
  },
  beforeUnmount: function() {
    this.unbindDocumentState(), this.unbindGlobalListeners(), this.destroyStyle(), this.mask && this.autoZIndex && qt.clear(this.mask), this.container = null, this.mask = null;
  },
  mounted: function() {
    this.breakpoints && this.createStyle();
  },
  methods: {
    close: function() {
      this.$emit("update:visible", !1);
    },
    onBeforeEnter: function(t) {
      t.setAttribute(this.attributeSelector, "");
    },
    onEnter: function() {
      this.$emit("show"), this.focus(), this.enableDocumentSettings(), this.bindGlobalListeners(), this.autoZIndex && qt.set("modal", this.mask, this.baseZIndex + this.$primevue.config.zIndex.modal);
    },
    onBeforeLeave: function() {
      this.modal && !this.isUnstyled && Oe.addClass(this.mask, "p-component-overlay-leave");
    },
    onLeave: function() {
      this.$emit("hide"), this.focusableClose = null, this.focusableMax = null;
    },
    onAfterLeave: function() {
      this.autoZIndex && qt.clear(this.mask), this.containerVisible = !1, this.unbindDocumentState(), this.unbindGlobalListeners(), this.$emit("after-hide");
    },
    onMaskClick: function(t) {
      this.dismissableMask && this.modal && this.mask === t.target && this.close();
    },
    focus: function() {
      var t = function(o) {
        return o && o.querySelector("[autofocus]");
      }, n = this.$slots.footer && t(this.footerContainer);
      n || (n = this.$slots.header && t(this.headerContainer), n || (n = this.$slots.default && t(this.content), n || (this.maximizable ? (this.focusableMax = !0, n = this.maximizableButton) : (this.focusableClose = !0, n = this.closeButton)))), n && Oe.focus(n, {
        focusVisible: !0
      });
    },
    maximize: function(t) {
      this.maximized ? (this.maximized = !1, this.$emit("unmaximize", t)) : (this.maximized = !0, this.$emit("maximize", t)), this.modal || (this.maximized ? Oe.blockBodyScroll() : Oe.unblockBodyScroll());
    },
    enableDocumentSettings: function() {
      (this.modal || !this.modal && this.blockScroll || this.maximizable && this.maximized) && Oe.blockBodyScroll();
    },
    unbindDocumentState: function() {
      (this.modal || !this.modal && this.blockScroll || this.maximizable && this.maximized) && Oe.unblockBodyScroll();
    },
    onKeyDown: function(t) {
      t.code === "Escape" && this.closeOnEscape && this.close();
    },
    bindDocumentKeyDownListener: function() {
      this.documentKeydownListener || (this.documentKeydownListener = this.onKeyDown.bind(this), window.document.addEventListener("keydown", this.documentKeydownListener));
    },
    unbindDocumentKeyDownListener: function() {
      this.documentKeydownListener && (window.document.removeEventListener("keydown", this.documentKeydownListener), this.documentKeydownListener = null);
    },
    containerRef: function(t) {
      this.container = t;
    },
    maskRef: function(t) {
      this.mask = t;
    },
    contentRef: function(t) {
      this.content = t;
    },
    headerContainerRef: function(t) {
      this.headerContainer = t;
    },
    footerContainerRef: function(t) {
      this.footerContainer = t;
    },
    maximizableRef: function(t) {
      this.maximizableButton = t;
    },
    closeButtonRef: function(t) {
      this.closeButton = t;
    },
    createStyle: function() {
      if (!this.styleElement && !this.isUnstyled) {
        var t;
        this.styleElement = document.createElement("style"), this.styleElement.type = "text/css", Oe.setAttribute(this.styleElement, "nonce", (t = this.$primevue) === null || t === void 0 || (t = t.config) === null || t === void 0 || (t = t.csp) === null || t === void 0 ? void 0 : t.nonce), document.head.appendChild(this.styleElement);
        var n = "";
        for (var i in this.breakpoints)
          n += `
                        @media screen and (max-width: `.concat(i, `) {
                            .p-dialog[`).concat(this.attributeSelector, `] {
                                width: `).concat(this.breakpoints[i], ` !important;
                            }
                        }
                    `);
        this.styleElement.innerHTML = n;
      }
    },
    destroyStyle: function() {
      this.styleElement && (document.head.removeChild(this.styleElement), this.styleElement = null);
    },
    initDrag: function(t) {
      t.target.closest("div").getAttribute("data-pc-section") !== "icons" && this.draggable && (this.dragging = !0, this.lastPageX = t.pageX, this.lastPageY = t.pageY, this.container.style.margin = "0", !this.isUnstyled && Oe.addClass(document.body, "p-unselectable-text"));
    },
    bindGlobalListeners: function() {
      this.draggable && (this.bindDocumentDragListener(), this.bindDocumentDragEndListener()), this.closeOnEscape && this.closable && this.bindDocumentKeyDownListener();
    },
    unbindGlobalListeners: function() {
      this.unbindDocumentDragListener(), this.unbindDocumentDragEndListener(), this.unbindDocumentKeyDownListener();
    },
    bindDocumentDragListener: function() {
      var t = this;
      this.documentDragListener = function(n) {
        if (t.dragging) {
          var i = Oe.getOuterWidth(t.container), o = Oe.getOuterHeight(t.container), a = n.pageX - t.lastPageX, r = n.pageY - t.lastPageY, s = t.container.getBoundingClientRect(), l = s.left + a, d = s.top + r, y = Oe.getViewport(), u = getComputedStyle(t.container), m = parseFloat(u.marginLeft), h = parseFloat(u.marginTop);
          t.container.style.position = "fixed", t.keepInViewport ? (l >= t.minX && l + i < y.width && (t.lastPageX = n.pageX, t.container.style.left = l - m + "px"), d >= t.minY && d + o < y.height && (t.lastPageY = n.pageY, t.container.style.top = d - h + "px")) : (t.lastPageX = n.pageX, t.container.style.left = l - m + "px", t.lastPageY = n.pageY, t.container.style.top = d - h + "px");
        }
      }, window.document.addEventListener("mousemove", this.documentDragListener);
    },
    unbindDocumentDragListener: function() {
      this.documentDragListener && (window.document.removeEventListener("mousemove", this.documentDragListener), this.documentDragListener = null);
    },
    bindDocumentDragEndListener: function() {
      var t = this;
      this.documentDragEndListener = function(n) {
        t.dragging && (t.dragging = !1, !t.isUnstyled && Oe.removeClass(document.body, "p-unselectable-text"), t.$emit("dragend", n));
      }, window.document.addEventListener("mouseup", this.documentDragEndListener);
    },
    unbindDocumentDragEndListener: function() {
      this.documentDragEndListener && (window.document.removeEventListener("mouseup", this.documentDragEndListener), this.documentDragEndListener = null);
    }
  },
  computed: {
    maximizeIconComponent: function() {
      return this.maximized ? this.minimizeIcon ? "span" : "WindowMinimizeIcon" : this.maximizeIcon ? "span" : "WindowMaximizeIcon";
    },
    ariaId: function() {
      return Mt();
    },
    ariaLabelledById: function() {
      return this.header != null || this.$attrs["aria-labelledby"] !== null ? this.ariaId + "_header" : null;
    },
    closeAriaLabel: function() {
      return this.$primevue.config.locale.aria ? this.$primevue.config.locale.aria.close : void 0;
    },
    attributeSelector: function() {
      return Mt();
    }
  },
  directives: {
    ripple: An,
    focustrap: qu
  },
  components: {
    Portal: Yn,
    WindowMinimizeIcon: Ak,
    WindowMaximizeIcon: Pk,
    TimesIcon: Ho
  }
};
function cc(e) {
  "@babel/helpers - typeof";
  return cc = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, cc(e);
}
function zy(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    t && (i = i.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), n.push.apply(n, i);
  }
  return n;
}
function Hr(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? zy(Object(n), !0).forEach(function(i) {
      WN(e, i, n[i]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : zy(Object(n)).forEach(function(i) {
      Object.defineProperty(e, i, Object.getOwnPropertyDescriptor(n, i));
    });
  }
  return e;
}
function WN(e, t, n) {
  return t = YN(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function YN(e) {
  var t = qN(e, "string");
  return cc(t) == "symbol" ? t : String(t);
}
function qN(e, t) {
  if (cc(e) != "object" || !e)
    return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var i = n.call(e, t || "default");
    if (cc(i) != "object")
      return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var KN = ["aria-labelledby", "aria-modal"], XN = ["id"], ZN = ["autofocus", "tabindex"], JN = ["autofocus", "aria-label"];
function QN(e, t, n, i, o, a) {
  var r = $e("Portal"), s = Ut("ripple"), l = Ut("focustrap");
  return E(), fe(r, {
    appendTo: e.appendTo
  }, {
    default: Se(function() {
      return [o.containerVisible ? (E(), X("div", Ce({
        key: 0,
        ref: a.maskRef,
        class: e.cx("mask"),
        style: e.sx("mask", !0, {
          position: e.position,
          modal: e.modal
        }),
        onClick: t[3] || (t[3] = function() {
          return a.onMaskClick && a.onMaskClick.apply(a, arguments);
        })
      }, e.ptm("mask")), [ue(ia, Ce({
        name: "p-dialog",
        onBeforeEnter: a.onBeforeEnter,
        onEnter: a.onEnter,
        onBeforeLeave: a.onBeforeLeave,
        onLeave: a.onLeave,
        onAfterLeave: a.onAfterLeave,
        appear: ""
      }, e.ptm("transition")), {
        default: Se(function() {
          return [e.visible ? rt((E(), X("div", Ce({
            key: 0,
            ref: a.containerRef,
            class: e.cx("root"),
            style: e.sx("root"),
            role: "dialog",
            "aria-labelledby": a.ariaLabelledById,
            "aria-modal": e.modal
          }, Hr(Hr({}, e.$attrs), e.ptm("root"))), [e.$slots.container ? je(e.$slots, "container", {
            key: 0,
            onClose: a.close,
            onMaximize: function(y) {
              return a.maximize(y);
            },
            closeCallback: a.close,
            maximizeCallback: function(y) {
              return a.maximize(y);
            }
          }) : (E(), X(Re, {
            key: 1
          }, [e.showHeader ? (E(), X("div", Ce({
            key: 0,
            ref: a.headerContainerRef,
            class: e.cx("header"),
            onMousedown: t[2] || (t[2] = function() {
              return a.initDrag && a.initDrag.apply(a, arguments);
            })
          }, e.ptm("header")), [je(e.$slots, "header", {
            class: Pe(e.cx("title"))
          }, function() {
            return [e.header ? (E(), X("span", Ce({
              key: 0,
              id: a.ariaLabelledById,
              class: e.cx("title")
            }, e.ptm("title")), Ie(e.header), 17, XN)) : te("", !0)];
          }), oe("div", Ce({
            class: e.cx("icons")
          }, e.ptm("icons")), [e.maximizable ? rt((E(), X("button", Ce({
            key: 0,
            ref: a.maximizableRef,
            autofocus: o.focusableMax,
            class: e.cx("maximizableButton"),
            onClick: t[0] || (t[0] = function() {
              return a.maximize && a.maximize.apply(a, arguments);
            }),
            type: "button",
            tabindex: e.maximizable ? "0" : "-1"
          }, e.ptm("maximizableButton"), {
            "data-pc-group-section": "headericon"
          }), [je(e.$slots, "maximizeicon", {
            maximized: o.maximized,
            class: Pe(e.cx("maximizableIcon"))
          }, function() {
            return [(E(), fe(tt(a.maximizeIconComponent), Ce({
              class: [e.cx("maximizableIcon"), o.maximized ? e.minimizeIcon : e.maximizeIcon]
            }, e.ptm("maximizableIcon")), null, 16, ["class"]))];
          })], 16, ZN)), [[s]]) : te("", !0), e.closable ? rt((E(), X("button", Ce({
            key: 1,
            ref: a.closeButtonRef,
            autofocus: o.focusableClose,
            class: e.cx("closeButton"),
            onClick: t[1] || (t[1] = function() {
              return a.close && a.close.apply(a, arguments);
            }),
            "aria-label": a.closeAriaLabel,
            type: "button"
          }, Hr(Hr({}, e.closeButtonProps), e.ptm("closeButton")), {
            "data-pc-group-section": "headericon"
          }), [je(e.$slots, "closeicon", {
            class: Pe(e.cx("closeButtonIcon"))
          }, function() {
            return [(E(), fe(tt(e.closeIcon ? "span" : "TimesIcon"), Ce({
              class: [e.cx("closeButtonIcon"), e.closeIcon]
            }, e.ptm("closeButtonIcon")), null, 16, ["class"]))];
          })], 16, JN)), [[s]]) : te("", !0)], 16)], 16)) : te("", !0), oe("div", Ce({
            ref: a.contentRef,
            class: [e.cx("content"), e.contentClass],
            style: e.contentStyle
          }, Hr(Hr({}, e.contentProps), e.ptm("content"))), [je(e.$slots, "default")], 16), e.footer || e.$slots.footer ? (E(), X("div", Ce({
            key: 1,
            ref: a.footerContainerRef,
            class: e.cx("footer")
          }, e.ptm("footer")), [je(e.$slots, "footer", {}, function() {
            return [Ve(Ie(e.footer), 1)];
          })], 16)) : te("", !0)], 64))], 16, KN)), [[l, {
            disabled: !e.modal
          }]]) : te("", !0)];
        }),
        _: 3
      }, 16, ["onBeforeEnter", "onEnter", "onBeforeLeave", "onLeave", "onAfterLeave"])], 16)) : te("", !0)];
    }),
    _: 3
  }, 8, ["appendTo"]);
}
Gm.render = QN;
const e6 = ["id"], t6 = /* @__PURE__ */ Be({
  __name: "ModalDialog",
  props: {
    appendTo: {
      type: String,
      default: "body"
    },
    display: {
      type: Boolean,
      default: !1
    },
    draggable: {
      type: Boolean,
      default: !1
    },
    closable: {
      type: Boolean,
      default: !0
    },
    baseZIndex: {
      type: Number,
      default: 1005
    },
    position: {
      type: String,
      default: aa.Top
    },
    breakpoints: {
      type: Object,
      default: () => ({
        "1280px": "75vw",
        "1024px": "85vw",
        "768px": "95vw",
        "576px": "100vw",
        "375px": "100vw"
      })
    },
    closeButtonWithBorder: {
      type: Boolean,
      default: !0
    }
  },
  emits: ["close-dialog", "after-hide"],
  setup(e, { emit: t }) {
    const n = e, i = Pn(), o = ge(!1), a = Jt(), r = (u) => !!a[u];
    qe(
      () => n.display,
      (u) => {
        o.value = u;
      },
      { immediate: !0 }
    );
    const s = t, l = () => {
      o.value = !1;
    }, d = () => {
      s("close-dialog");
    }, y = () => {
      s("after-hide");
    };
    return (u, m) => (E(), fe(_(Gm), {
      visible: o.value,
      "onUpdate:visible": m[0] || (m[0] = (h) => o.value = h),
      class: "d-modal-dialog w-5/6 lg:w-4/5",
      modal: !0,
      position: e.position,
      "append-to": e.appendTo,
      draggable: e.draggable,
      closable: e.closable,
      "base-z-index": e.baseZIndex,
      breakpoints: e.breakpoints,
      "aria-labelledby": _(i),
      pt: {
        closeButton: {
          class: e.closeButtonWithBorder ? "border" : "no-border",
          "data-id": "silktide-close"
        }
      },
      onHide: d,
      onAfterHide: y
    }, Qt({
      default: Se(() => [
        je(u.$slots, "content", { closed: l }, void 0, !0)
      ]),
      _: 2
    }, [
      r("header") ? {
        name: "header",
        fn: Se(() => [
          je(u.$slots, "header", {}, void 0, !0),
          oe("span", { id: _(i) }, null, 8, e6)
        ]),
        key: "0"
      } : void 0,
      r("closeicon") ? {
        name: "closeicon",
        fn: Se(() => [
          je(u.$slots, "closeicon", {}, void 0, !0)
        ]),
        key: "1"
      } : void 0,
      r("footer") ? {
        name: "footer",
        fn: Se(() => [
          je(u.$slots, "footer", { closed: l }, void 0, !0)
        ]),
        key: "2"
      } : void 0
    ]), 1032, ["visible", "position", "append-to", "draggable", "closable", "base-z-index", "breakpoints", "aria-labelledby", "pt"]));
  }
});
const Ei = /* @__PURE__ */ Fe(t6, [["__scopeId", "data-v-fed49883"]]), n6 = { class: "d-tooltip-dialog__content" }, i6 = /* @__PURE__ */ Be({
  __name: "TextWithTooltip",
  props: {
    tooltipText: {
      type: String,
      required: !1,
      default: null
    },
    additionalClass: {
      type: String,
      default: ""
    },
    tooltipClass: {
      type: String,
      default: ""
    },
    useDialog: {
      type: Boolean,
      default: !0
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    style: {
      type: String,
      required: !1
    },
    useRegularFont: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const t = e, n = ge(!1), i = Te(() => t.disabled ? "tooltip-disabled " + t.additionalClass : t.tooltipText ? "tooltip-underline " + t.additionalClass : t.additionalClass), o = Te(() => {
      if (!t.tooltipClass || t.tooltipClass.length === 0)
        return t.tooltipText;
      let l = '<div class="d-big-tooltip__div">';
      if (t.tooltipText && t.tooltipText.length > 0) {
        const d = Ma(t.tooltipText, {
          ALLOWED_TAGS: ["br", "span", "div", "b", "p"]
        });
        l += '<span class="d-big-tooltip__text">' + d + " </span>";
      }
      return l += "</div>", l;
    }), a = Te(() => ({
      "1280px": "95vw",
      "1024px": "95vw",
      "768px": "95vw",
      "576px": "100vw",
      "375px": "100vw"
    })), r = () => {
      !t.tooltipText || t.tooltipText.length < 1 || (n.value = !0);
    }, s = () => {
      n.value = !1;
    };
    return (l, d) => {
      const y = Ut("tooltip");
      return E(), X(Re, null, [
        _(Cl)()?.isTouchDevice?.value ? te("", !0) : rt((E(), X("span", {
          key: 0,
          class: Pe(i.value),
          style: hn(e.style)
        }, [
          je(l.$slots, "default")
        ], 6)), [
          [y, {
            value: o.value,
            class: [e.tooltipClass, e.useRegularFont ? "d-regular-tooltip" : ""],
            fitContent: !0,
            escape: !1,
            disabled: !e.tooltipText || e.tooltipText?.length < 1 || e.disabled
          }]
        ]),
        _(Cl)()?.isTouchDevice?.value && !e.disabled ? (E(), X("span", {
          key: 1,
          ref: "touchTooltipForMobile",
          class: Pe(i.value),
          onClick: r,
          style: hn(e.style)
        }, [
          je(l.$slots, "default")
        ], 6)) : te("", !0),
        _(Cl)()?.isTouchDevice?.value && e.disabled ? (E(), X("span", {
          key: 2,
          class: Pe(i.value),
          style: hn(e.style)
        }, [
          je(l.$slots, "default")
        ], 6)) : te("", !0),
        e.useDialog ? (E(), fe(Ei, {
          key: 3,
          class: "d-tooltip-dialog",
          display: n.value,
          closable: !0,
          position: _(aa).Center,
          breakpoints: a.value,
          onAfterHide: s
        }, {
          content: Se(() => [
            oe("div", n6, [
              ue(_(ht), {
                "html-text": e.tooltipText,
                "disable-default-styling": ""
              }, null, 8, ["html-text"])
            ])
          ]),
          _: 1
        }, 8, ["display", "position", "breakpoints"])) : te("", !0)
      ], 64);
    };
  }
});
const a6 = { key: 1 }, o6 = /* @__PURE__ */ Be({
  __name: "ProductCardItem",
  props: {
    triggerText: {
      type: String,
      required: !0
    },
    tooltipContent: {
      type: String,
      default: ""
    }
  },
  setup(e) {
    const t = e, n = ge();
    return it(() => {
      Ue && t.tooltipContent?.length > 0 && pn({
        trigger: n,
        headline: t.triggerText,
        content: t.tooltipContent,
        appendTo: document.body,
        showOnTouchDevices: !0,
        field: () => n
      });
    }), (i, o) => t.tooltipContent?.length > 0 ? (E(), X("span", {
      key: 0,
      ref_key: "triggerRef",
      ref: n,
      class: "glossary-styled"
    }, Ie(e.triggerText), 513)) : (E(), X("span", a6, Ie(e.triggerText), 1));
  }
}), r6 = Be({
  name: "ProductCard",
  components: {
    PrimeRating: Xu,
    PrimeDropdown: Ga,
    AnchorButton: Em,
    LipperRating: yw,
    TextWithTooltip: i6,
    SRRIndicator: Ik,
    ProductCardItem: o6
  },
  directives: {
    tooltip: Yu
  },
  props: {
    valuesMain: {
      type: Object,
      required: !0,
      default: null
    },
    values: {
      type: Object,
      required: !1,
      default: null
    }
  },
  data() {
    return {
      iconIsEnabled: !1,
      targetBlank: !0,
      uuid: Pn()
    };
  },
  created() {
    const { pageName: e } = Qe();
    this.dataEventSource = e;
  },
  methods: {
    showFundDetails(e) {
      Ue && window.location.replace(e);
    }
  }
}), s6 = { class: "product-card" }, l6 = {
  key: 0,
  class: "product-card__header"
}, c6 = ["id"], d6 = { class: "product-card__items" }, u6 = { key: 0 }, h6 = { class: "date-label" }, p6 = { key: 1 }, f6 = { class: "date-label" }, m6 = { class: "category-list gap-2" }, g6 = ["href", "data-event_source", "data-event_title", "data-event_target"], v6 = { key: 2 }, y6 = { class: "date-label" }, b6 = { key: 3 }, x6 = { class: "date-label" }, w6 = { key: 4 }, k6 = { class: "date-label" }, S6 = { key: 5 }, C6 = { class: "date-label" }, T6 = { key: 6 }, L6 = { class: "date-label" }, I6 = { class: "distinction" }, P6 = ["src", "alt"];
function A6(e, t, n, i, o, a) {
  const r = $e("ProductCardItem"), s = $e("PrimeDropdown"), l = $e("PrimeRating"), d = $e("LipperRating"), y = $e("SRRIndicator"), u = $e("AnchorButton"), m = Ut("tooltip");
  return E(), X("div", s6, [
    e.values?.title ? (E(), X("div", l6, [
      oe("h3", { id: e.uuid }, Ie(e.values.title), 9, c6)
    ])) : te("", !0),
    oe("div", d6, [
      (E(!0), X(Re, null, Ge(e.values.list, (h) => (E(), X("table", { key: h }, [
        h.type === "STRING" ? (E(), X("tr", u6, [
          oe("td", null, [
            ue(r, {
              "trigger-text": h.key,
              "tooltip-content": h.tooltip
            }, null, 8, ["trigger-text", "tooltip-content"]),
            oe("span", h6, Ie(h.date), 1)
          ]),
          oe("td", null, Ie(h.value), 1)
        ])) : h.type === "URLLIST" ? (E(), X("tr", p6, [
          oe("td", null, [
            ue(r, {
              "trigger-text": h.key,
              "tooltip-content": h.tooltip
            }, null, 8, ["trigger-text", "tooltip-content"]),
            oe("span", f6, Ie(h.date), 1)
          ]),
          oe("td", m6, [
            (E(!0), X(Re, null, Ge(h.value, (c) => (E(), X("div", { key: c }, [
              rt((E(), X("a", {
                href: c.url,
                class: Pe({
                  underline: c.url !== null,
                  "no-underline": c.url === null
                }),
                "data-event_source": e.dataEventSource,
                "data-event_component_name": "Text Links (next page)",
                "data-event_title": c.name,
                "data-event_target": c.url
              }, [
                Ve(Ie(c.name), 1)
              ], 10, g6)), [
                [
                  m,
                  c.tooltip,
                  void 0,
                  { top: !0 }
                ]
              ])
            ]))), 128))
          ])
        ])) : h.type === "DROPDOWN" ? (E(), X("tr", v6, [
          oe("td", null, [
            ue(r, {
              "trigger-text": h.key,
              "tooltip-content": h.tooltip
            }, null, 8, ["trigger-text", "tooltip-content"]),
            oe("span", y6, Ie(h.date), 1)
          ]),
          oe("td", null, [
            ue(s, {
              modelValue: e.selectedValue,
              "onUpdate:modelValue": t[0] || (t[0] = (c) => e.selectedValue = c),
              options: h.value,
              "option-label": "name",
              "option-value": "name",
              placeholder: "Select share class..."
            }, null, 8, ["modelValue", "options"])
          ])
        ])) : h.type === "MORNINGSTAR" ? (E(), X("tr", b6, [
          oe("td", null, [
            ue(r, {
              "trigger-text": h.key,
              "tooltip-content": h.tooltip
            }, null, 8, ["trigger-text", "tooltip-content"]),
            oe("span", x6, Ie(h.date), 1)
          ]),
          oe("td", null, [
            rt(ue(l, {
              "model-value": parseInt(h.value),
              stars: 5,
              readonly: !0,
              cancel: !1,
              "on-icon": "las la-star",
              "off-icon": "lar la-star"
            }, null, 8, ["model-value"]), [
              [
                m,
                parseInt(h.value) + " " + (e.valuesMain.morningStarTooltipText ? e.valuesMain.morningStarTooltipText : " stars"),
                void 0,
                { top: !0 }
              ]
            ])
          ])
        ])) : te("", !0),
        h.type === "LIPPERRATING" ? (E(), X("tr", w6, [
          oe("td", null, [
            ue(r, {
              "trigger-text": h.key,
              "tooltip-content": h.tooltip
            }, null, 8, ["trigger-text", "tooltip-content"]),
            oe("span", k6, Ie(h.date), 1)
          ]),
          oe("td", null, [
            ue(d, {
              values: e.listItem.value
            }, null, 8, ["values"])
          ])
        ])) : h.type === "SRRI" ? (E(), X("tr", S6, [
          oe("td", null, [
            ue(r, {
              "trigger-text": h.key,
              "tooltip-content": h.tooltip
            }, null, 8, ["trigger-text", "tooltip-content"]),
            oe("span", C6, Ie(h.date), 1)
          ]),
          oe("td", null, [
            ue(y, {
              rating: parseInt(h.value),
              "tooltip-label": h?.tooltipLabel || "SRRI"
            }, null, 8, ["rating", "tooltip-label"])
          ])
        ])) : h.type === "IMAGE" ? (E(), X("tr", T6, [
          oe("td", null, [
            ue(r, {
              "trigger-text": h.key,
              "tooltip-content": h.tooltip
            }, null, 8, ["trigger-text", "tooltip-content"]),
            oe("span", L6, Ie(h.date), 1)
          ]),
          oe("td", I6, [
            (E(!0), X(Re, null, Ge(h.value, (c) => (E(), X("div", { key: c }, [
              oe("img", {
                src: c.url,
                alt: c.name
              }, null, 8, P6)
            ]))), 128))
          ])
        ])) : te("", !0)
      ]))), 128))
    ]),
    ue(u, {
      "anchor-title": e.valuesMain?.showFundDetailsButtonText,
      "anchor-url": e.values.url,
      "data-event_source": e.dataEventSource,
      "data-event_component_name": "Button",
      "data-event_title": e.valuesMain?.showFundDetailsButtonText,
      "data-event_target": e.values.url,
      "aria-describedby": e.uuid,
      "icon-is-enabled": "",
      "url-target": "_self",
      class: "p-button-primary p-button-sm mt-2"
    }, null, 8, ["anchor-title", "anchor-url", "data-event_source", "data-event_title", "data-event_target", "aria-describedby"])
  ]);
}
const _6 = /* @__PURE__ */ Fe(r6, [["render", A6]]);
const M6 = Be({
  name: "TopProducts",
  components: {
    AnchorButton: Em,
    ProductCard: _6,
    Carousel: ik
  },
  props: {
    valuesMain: {
      type: Object,
      required: !0,
      default: null
    },
    values: {
      type: Object,
      required: !0,
      default: null
    }
  },
  data() {
    return {
      dataEventSource: null,
      responsiveOptions: [
        {
          breakpoint: "1699px",
          numVisible: 2,
          numScroll: 1
        },
        {
          breakpoint: "1280px",
          numVisible: 2,
          numScroll: 1
        },
        {
          breakpoint: "360px",
          numVisible: 1,
          numScroll: 1
        }
      ]
    };
  },
  created() {
    const { pageName: e } = Qe();
    this.dataEventSource = e;
  },
  methods: {
    clickShowAllResultsButton(e) {
      Ue && window.open(e);
    }
  }
}), O6 = {
  key: 0,
  class: "top-products"
}, B6 = { class: "xl:text-center mb-12" }, E6 = { class: "top-products__caption" }, D6 = { class: "top-products__row" }, R6 = { class: "flex" }, N6 = {
  key: 0,
  class: "flex flex-row flex-nowrap print:flex-wrap xs:gap-x-8 md:gap-x-10 m-auto"
}, $6 = { class: "further-fonds" };
function F6(e, t, n, i, o, a) {
  const r = $e("ProductCard"), s = $e("Carousel"), l = $e("AnchorButton");
  return e.values?.cards?.length >= 1 ? (E(), X("div", O6, [
    oe("h2", B6, Ie(e.values?.headlineText), 1),
    oe("ul", E6, [
      (E(!0), X(Re, null, Ge(e.values.topics, (d) => (E(), X("li", { key: d }, [
        t[0] || (t[0] = oe("i", { class: "las la-check" }, null, -1)),
        Ve(" " + Ie(d.title), 1)
      ]))), 128))
    ]),
    oe("div", {
      class: Pe(["top-products__touch-scroll", {
        "xs:block xxl:hidden": e.values.cards.length > 2,
        block: e.values.cards.length <= 2,
        hidden: e.values.cards.length > 2
      }])
    }, [
      oe("div", D6, [
        oe("div", R6, [
          e.values?.cards ? (E(), X("div", N6, [
            (E(!0), X(Re, null, Ge(e.values.cards, (d) => (E(), fe(r, {
              key: d,
              "values-main": e.valuesMain,
              values: d
            }, null, 8, ["values-main", "values"]))), 128))
          ])) : te("", !0)
        ])
      ])
    ], 2),
    e.values?.cards?.length > 0 ? (E(), X("div", {
      key: 0,
      class: Pe({
        "xs:hidden xxl:block print:hidden dws-carousel-container": e.values.cards.length > 2,
        hidden: e.values.cards.length <= 2
      })
    }, [
      e.values?.cards ? (E(), fe(s, {
        key: 0,
        value: e.values.cards,
        "num-scroll": 1,
        "num-visible": 3,
        circular: !1,
        "responsive-options": e.responsiveOptions
      }, {
        item: Se((d) => [
          ue(r, {
            "values-main": e.valuesMain,
            values: d.data
          }, null, 8, ["values-main", "values"])
        ]),
        _: 1
      }, 8, ["value", "responsive-options"])) : te("", !0)
    ], 2)) : te("", !0),
    oe("div", $6, [
      ue(l, {
        "anchor-title": e.valuesMain?.showAllResultsButtonText,
        "anchor-url": e.values.searchUrl,
        "data-event_source": e.dataEventSource,
        "data-event_component_name": "Button",
        "data-event_title": e.valuesMain?.showAllResultsButtonText,
        "data-event_target": e.values.searchUrl,
        "icon-is-enabled": "",
        "url-target": "_self",
        class: "p-button-secondary p-button-lg"
      }, null, 8, ["anchor-title", "anchor-url", "data-event_source", "data-event_title", "data-event_target"])
    ])
  ])) : te("", !0);
}
const fBe = /* @__PURE__ */ Fe(M6, [["render", F6]]), Ai = "#007d85", Sr = "#73A22A", Da = "#489CD2", Um = "#5A6D78", Wm = "#91887E", Ym = "#2B5192", qm = "#238B45", Qu = "#6A51A3", Km = "#e8c64d", Xm = "#50711D", fu = "#326D93", Zm = "#3F4C54", Jm = "#655F58", Qm = "#1E3966", eg = "#186130", tg = "#4A3972", ng = "#A28B36", j6 = "#ED6F2B", H6 = "#D34F8E", Wi = "#ebeef0", oi = "#d9dfe3", mu = "#AAB9C0", Yi = "#708894", so = "#5A6D78", _k = "#5A6D78", Mk = "#5A6D78", Ok = [
  Ai,
  Sr,
  Da,
  Um,
  Wm,
  Ym,
  qm,
  Qu,
  Km,
  Xm,
  fu,
  Zm,
  Jm,
  Qm,
  eg,
  tg,
  ng,
  j6,
  H6
], Is = "'DwsSlab', -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol", gu = "'DwsSlab', -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol", Ps = "14px", As = "400", ii = {
  color: so,
  fontWeight: As,
  fontSize: Ps,
  fontFamily: Is
}, _s = {
  title: {
    text: ""
  },
  legend: {
    enabled: !1
  },
  navigator: {
    show: !1
  },
  scrollbar: {
    enabled: !1
  },
  credits: {
    enabled: !1
  },
  rangeSelector: {
    enabled: !1
  },
  exporting: {
    enabled: !1
  },
  chart: {
    style: ii
  },
  yAxis: {
    lineColor: Wi,
    labels: {
      style: ii
    }
  },
  xAxis: {
    lineColor: Wi,
    labels: {
      style: ii,
      align: "right",
      reserveSpace: !0,
      overflow: "justify",
      step: 2
    }
  },
  colors: Ok,
  accessibility: {
    enabled: !0,
    keyboardNavigation: {
      enabled: !0,
      focusBorder: {
        style: {
          lineWidth: 2,
          color: Ai,
          borderRadius: 2
        },
        margin: 2
      }
    }
  }
}, Zd = "#007d85", Vy = "#6A51A3", sf = "#5A6D78", lf = "#489CD2", z6 = "#e8c64d", Sa = 0, lp = 1, cp = 2, dp = 4, V6 = {
  ..._s,
  title: {
    // text: 'Chart-Headline'
  },
  legend: {
    show: !0
  },
  series: [
    {
      type: "line",
      name: "No data",
      data: []
    },
    {
      type: "line",
      name: "No data",
      data: []
    },
    {
      type: "line",
      name: "No data",
      data: []
    },
    {
      type: "line",
      name: "No data",
      data: []
    },
    {
      type: "line",
      name: "No data",
      data: []
    }
  ],
  noData: {
    style: {
      fontFamily: gu,
      fontWeight: "300",
      fontSize: "16px",
      color: z6
    }
  },
  responsive: {
    rules: [
      {
        condition: {
          maxWidth: "350"
        },
        chartOptions: {
          legend: {
            enabled: !1
          },
          title: {
            text: ""
          },
          subtitle: {
            text: ""
          },
          navigator: {
            enabled: !1
          }
        }
      }
    ]
  },
  lang: {
    noData: "No Data available...",
    decimalPoint: ",",
    thousandsSep: ".",
    loading: "Loading Data from Server",
    months: [
      "Januar",
      "Februar",
      "März",
      "April",
      "Mai",
      "Juni",
      "Juli",
      "August",
      "September",
      "Oktober",
      "November",
      "Dezember"
    ],
    weekdays: [
      "Sonntag",
      "Montag",
      "Dienstag",
      "Mittwoch",
      "Donnerstag",
      "Freitag",
      "Samstag"
    ],
    shortMonths: [
      "Jan",
      "Feb",
      "Mär",
      "Apr",
      "Mai",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Okt",
      "Nov",
      "Dez"
    ]
  },
  chart: {
    zoomBySingleTouch: !1,
    panning: {
      enabled: !1
    },
    styledMode: !1,
    style: ii
  },
  xAxis: [
    {
      lineColor: Wi,
      tickWidth: 0,
      tickColor: "transparent",
      type: "datetime",
      // no hours in x-axis
      minTickInterval: 24 * 3600 * 1e3,
      dateTimeLabelFormats: {
        millisecond: "%e. %b",
        second: "%e. %b",
        minute: "%e. %b",
        hour: "%e. %b",
        day: "%e. %b",
        week: "%e. %b",
        month: "%b / %y",
        year: "%Y"
      },
      labels: {
        step: 2,
        style: ii,
        align: "right",
        //reserveSpace: true,
        overflow: "justify"
      }
    },
    {
      lineColor: Wi,
      tickWidth: 0,
      lineWidth: 0
    }
  ],
  yAxis: {
    lineColor: Wi,
    lineWidth: 1,
    tickWidth: 0,
    tickColor: "transparent",
    style: ii,
    labels: {
      step: 2,
      style: ii
    },
    title: {
      text: "Veränderung in %"
    },
    opposite: !1
  },
  accessibility: {
    keyboardNavigation: {
      focusBorder: {
        style: {
          lineWidth: 3,
          color: "#aa1111",
          borderRadius: 5
        },
        margin: 4
      }
    }
  },
  plotOptions: {
    series: {
      showCheckbox: !0,
      dataGrouping: {
        enabled: !1
      }
    },
    flags: {
      y: -248,
      lineColor: sf,
      // Highcharts.getOptions().colors[3].color,
      lineWidth: 1,
      fillColor: sf,
      height: 24,
      states: {
        hover: {
          fillColor: lf,
          lineColor: lf
        }
      },
      style: {
        fontFamily: gu,
        color: "#ffffff",
        fontWeight: "400",
        borderRadius: 12
      }
    }
  },
  animationDuration: 1e3,
  scrollbar: {
    enabled: !1
  },
  credits: {
    enabled: !1
  },
  colors: [Zd, Qu],
  stroke: {
    width: [2, 2],
    dashArray: [0, 4]
  },
  dataLabels: {
    enabled: !0
  },
  navigator: {
    show: !0,
    adaptToUpdatedData: !0,
    maskFill: "rgba(238, 247, 247, .5)",
    color: "white",
    maskInside: !0,
    outlineWidth: 0,
    borderRadius: 20,
    lineColor: null,
    marker: {
      enabled: !1
    },
    handles: {
      symbols: ["navigator-handle", "navigator-handle"],
      backgroundColor: "#007D85",
      borderColor: "#fff",
      color: "#fff",
      height: 24,
      width: 10
    },
    height: 64,
    margin: 32,
    xAxis: {
      lineColor: Wi,
      tickWidth: 0,
      gridLineWidth: 0,
      labels: {
        enabled: !1,
        step: 1,
        style: ii
      }
    },
    series: {
      type: "areaspline",
      // colors: ['#C1E1E1'],
      // fillOpacity: 1,
      fillColor: {
        linearGradient: {
          x1: 0,
          y1: 0,
          x2: 0,
          y2: 1
        },
        stops: [
          [0, "rgba(193,225,225, 1)"],
          [1, "rgba(193,225,225, 0.25)"]
        ]
      }
    }
  },
  rangeSelector: {
    enabled: !1,
    buttonTheme: {
      fill: "none",
      stroke: "none",
      "stroke-width": 0,
      r: 8,
      style: ii,
      states: {
        hover: {},
        select: {
          fill: "#016266",
          style: {
            color: "white"
          }
        }
      }
    },
    inputStyle: {
      color: "#016266",
      fontWeight: "bold"
    },
    labelStyle: {
      color: "#016266",
      fontWeight: "bold"
    },
    selected: 5,
    inputPosition: {
      align: "right",
      x: 0,
      y: 0
    },
    buttonPosition: {
      align: "left",
      x: 0,
      y: 0
    },
    buttons: [
      {
        type: "month",
        count: 1,
        text: "1M"
      },
      {
        type: "month",
        count: 3,
        text: "3M"
      },
      {
        type: "month",
        count: 6,
        text: "6M"
      },
      {
        type: "ytd",
        text: "YTD"
      },
      {
        type: "year",
        count: 1,
        text: "1Y"
      },
      {
        type: "all",
        text: "All"
      }
    ]
  },
  exporting: {
    enabled: !1,
    buttons: {
      contextButton: {
        menuItems: ["printChart", "separator", "downloadPNG", "downloadPDF"]
      }
    }
  }
}, G6 = {
  tooltip: {
    pointFormat: "{point.y:.2f}",
    xDateFormat: "%d.%m.%Y",
    backgroundColor: "rgba(255,255,255,0)",
    borderRadius: 12,
    shadow: !1,
    useHTML: !0,
    outside: !0,
    split: !1,
    shared: !0,
    percentageDecimals: 2,
    // eslint-disable-next-line
    formatter: function() {
      const e = new es.Time({
        timezone: "Europe/Berlin"
      }), t = e.dateFormat("%d/%m/%Y", Number(this.x));
      return '<table class="highchart-stock-chart-tooltip"><thead><tr><th>Start date</th><th>End date</th></tr>  <tr><td>' + e.dateFormat(
        "%d/%m/%Y",
        Number(this?.points[0].series?.xAxis?.min)
      ) + "</td><td>" + t + '</td></tr>  </thead>  <tbody>		  <tr><th>Nav %</th><th>Nav</th></tr>  <tr><td><span style="color: #73A22A"><i class="las la-arrow-circle-up la-rotate-45" style="--fa-rotate-angle: 45deg;"></i> ' + es.numberFormat(Number(this.points[0].y), 2) + "%</span> </td><td>" + es.numberFormat(Number(this.points[0].y), 2) + '</td></tr>  <tr><th>Index Level %</th><th></th></tr>  <tr><td><span style="color: #E84057"><i class="las la-arrow-circle-down la-rotate-45-minus" style="--fa-rotate-angle: -45deg;"></i> 17.50%</span> </td><td></td></tr> </tbody> </table>';
    }
  }
}, U6 = {
  tooltip: {
    pointFormat: "{point.y:.2f}",
    xDateFormat: "%d.%m.%Y",
    backgroundColor: "rgba(255,255,255,0)",
    borderRadius: 5,
    shadow: !1,
    useHTML: !0,
    outside: !0,
    split: !1,
    shared: !1,
    percentageDecimals: 2,
    // eslint-disable-next-line
    formatter: function() {
      return '<table class="highchart-stock-chart-tooltip"><thead><tr><th>Datum</th></tr>  <tr><td>' + new es.Time({
        timezone: "Europe/Berlin"
      }).dateFormat("%d.%m.%Y", Number(this.key)) + "</td></tr>  </thead>  <tbody>		  <tr><th>Nav</th></tr>  <tr><td> " + es.numberFormat(this.points[0].y, 2) + "</td></tr> </tbody> </table>";
    }
  }
};
var Ra = /* @__PURE__ */ ((e) => (e.Chart = "chart", e.StockChart = "stockChart", e))(Ra || {}), Vo = /* @__PURE__ */ ((e) => (e.Small = "25rem", e.Medium = "30rem", e.Large = "37.5rem", e.XLarge = "50rem", e))(Vo || {}), Bk = { exports: {} };
(function(e) {
  /**
  * Highcharts JS v11.4.8 (2024-08-29)
  *
  * (c) 2009-2024 Torstein Honsi
  *
  * License: www.highcharts.com/license
  */
  (function(t, n) {
    e.exports ? (n.default = n, e.exports = t && t.document ? n(t) : n) : (t.Highcharts && t.Highcharts.error(16, !0), t.Highcharts = n(t));
  })(typeof window < "u" ? window : rn, function(t) {
    var n = {};
    function i(o, a, r, s) {
      !o.hasOwnProperty(a) && (o[a] = s.apply(null, r), t && typeof CustomEvent == "function" && t.dispatchEvent(new CustomEvent("HighchartsModuleLoaded", { detail: { path: a, module: o[a] } })));
    }
    return i(n, "Core/Globals.js", [], function() {
      var o, a;
      return (a = o || (o = {})).SVG_NS = "http://www.w3.org/2000/svg", a.product = "Highcharts", a.version = "11.4.8", a.win = t !== void 0 ? t : {}, a.doc = a.win.document, a.svg = a.doc && a.doc.createElementNS && !!a.doc.createElementNS(a.SVG_NS, "svg").createSVGRect, a.userAgent = a.win.navigator && a.win.navigator.userAgent || "", a.isChrome = a.win.chrome, a.isFirefox = a.userAgent.indexOf("Firefox") !== -1, a.isMS = /(edge|msie|trident)/i.test(a.userAgent) && !a.win.opera, a.isSafari = !a.isChrome && a.userAgent.indexOf("Safari") !== -1, a.isTouchDevice = /(Mobile|Android|Windows Phone)/.test(a.userAgent), a.isWebKit = a.userAgent.indexOf("AppleWebKit") !== -1, a.deg2rad = 2 * Math.PI / 360, a.hasBidiBug = a.isFirefox && 4 > parseInt(a.userAgent.split("Firefox/")[1], 10), a.marginNames = ["plotTop", "marginRight", "marginBottom", "plotLeft"], a.noop = function() {
      }, a.supportsPassiveEvents = function() {
        let r = !1;
        if (!a.isMS) {
          let s = Object.defineProperty({}, "passive", { get: function() {
            r = !0;
          } });
          a.win.addEventListener && a.win.removeEventListener && (a.win.addEventListener("testPassive", a.noop, s), a.win.removeEventListener("testPassive", a.noop, s));
        }
        return r;
      }(), a.charts = [], a.composed = [], a.dateFormats = {}, a.seriesTypes = {}, a.symbolSizes = {}, a.chartCount = 0, o;
    }), i(n, "Core/Utilities.js", [n["Core/Globals.js"]], function(o) {
      let a, { charts: r, doc: s, win: l } = o;
      function d(b, p, L, B) {
        let T = p ? "Highcharts error" : "Highcharts warning";
        b === 32 && (b = `${T}: Deprecated member`);
        let O = v(b), I = O ? `${T} #${b}: www.highcharts.com/errors/${b}/` : b.toString();
        if (B !== void 0) {
          let R = "";
          O && (I += "?"), N(B, function(Y, F) {
            R += `
 - ${F}: ${Y}`, O && (I += encodeURI(F) + "=" + encodeURI(Y));
          }), I += R;
        }
        D(o, "displayError", { chart: L, code: b, message: I, params: B }, function() {
          if (p)
            throw Error(I);
          l.console && d.messages.indexOf(I) === -1 && console.warn(I);
        }), d.messages.push(I);
      }
      function y(b, p) {
        return parseInt(b, p || 10);
      }
      function u(b) {
        return typeof b == "string";
      }
      function m(b) {
        let p = Object.prototype.toString.call(b);
        return p === "[object Array]" || p === "[object Array Iterator]";
      }
      function h(b, p) {
        return !!b && typeof b == "object" && (!p || !m(b));
      }
      function c(b) {
        return h(b) && typeof b.nodeType == "number";
      }
      function g(b) {
        let p = b && b.constructor;
        return !!(h(b, !0) && !c(b) && p && p.name && p.name !== "Object");
      }
      function v(b) {
        return typeof b == "number" && !isNaN(b) && b < 1 / 0 && b > -1 / 0;
      }
      function P(b) {
        return b != null;
      }
      function f(b, p, L) {
        let B, T = u(p) && !P(L), O = (I, R) => {
          P(I) ? b.setAttribute(R, I) : T ? (B = b.getAttribute(R)) || R !== "class" || (B = b.getAttribute(R + "Name")) : b.removeAttribute(R);
        };
        return u(p) ? O(L, p) : N(p, O), B;
      }
      function S(b) {
        return m(b) ? b : [b];
      }
      function w(b, p) {
        let L;
        for (L in b || (b = {}), p)
          b[L] = p[L];
        return b;
      }
      function x() {
        let b = arguments, p = b.length;
        for (let L = 0; L < p; L++) {
          let B = b[L];
          if (B != null)
            return B;
        }
      }
      function k(b, p) {
        w(b.style, p);
      }
      function A(b) {
        return Math.pow(10, Math.floor(Math.log(b) / Math.LN10));
      }
      function $(b, p) {
        return b > 1e14 ? b : parseFloat(b.toPrecision(p || 14));
      }
      (d || (d = {})).messages = [], Math.easeInOutSine = function(b) {
        return -0.5 * (Math.cos(Math.PI * b) - 1);
      };
      let j = Array.prototype.find ? function(b, p) {
        return b.find(p);
      } : function(b, p) {
        let L, B = b.length;
        for (L = 0; L < B; L++)
          if (p(b[L], L))
            return b[L];
      };
      function N(b, p, L) {
        for (let B in b)
          Object.hasOwnProperty.call(b, B) && p.call(L || b[B], b[B], B, b);
      }
      function M(b, p, L) {
        function B(I, R) {
          let Y = b.removeEventListener;
          Y && Y.call(b, I, R, !1);
        }
        function T(I) {
          let R, Y;
          b.nodeName && (p ? (R = {})[p] = !0 : R = I, N(R, function(F, U) {
            if (I[U])
              for (Y = I[U].length; Y--; )
                B(U, I[U][Y].fn);
          }));
        }
        let O = typeof b == "function" && b.prototype || b;
        if (Object.hasOwnProperty.call(O, "hcEvents")) {
          let I = O.hcEvents;
          if (p) {
            let R = I[p] || [];
            L ? (I[p] = R.filter(function(Y) {
              return L !== Y.fn;
            }), B(p, L)) : (T(I), I[p] = []);
          } else
            T(I), delete O.hcEvents;
        }
      }
      function D(b, p, L, B) {
        if (L = L || {}, s.createEvent && (b.dispatchEvent || b.fireEvent && b !== o)) {
          let T = s.createEvent("Events");
          T.initEvent(p, !0, !0), L = w(T, L), b.dispatchEvent ? b.dispatchEvent(L) : b.fireEvent(p, L);
        } else if (b.hcEvents) {
          L.target || w(L, { preventDefault: function() {
            L.defaultPrevented = !0;
          }, target: b, type: p });
          let T = [], O = b, I = !1;
          for (; O.hcEvents; )
            Object.hasOwnProperty.call(O, "hcEvents") && O.hcEvents[p] && (T.length && (I = !0), T.unshift.apply(T, O.hcEvents[p])), O = Object.getPrototypeOf(O);
          I && T.sort((R, Y) => R.order - Y.order), T.forEach((R) => {
            R.fn.call(b, L) === !1 && L.preventDefault();
          });
        }
        B && !L.defaultPrevented && B.call(b, L);
      }
      N({ map: "map", each: "forEach", grep: "filter", reduce: "reduce", some: "some" }, function(b, p) {
        o[p] = function(L) {
          return d(32, !1, void 0, { [`Highcharts.${p}`]: `use Array.${b}` }), Array.prototype[b].apply(L, [].slice.call(arguments, 1));
        };
      });
      let C = function() {
        let b = Math.random().toString(36).substring(2, 9) + "-", p = 0;
        return function() {
          return "highcharts-" + (a ? "" : b) + p++;
        };
      }();
      return l.jQuery && (l.jQuery.fn.highcharts = function() {
        let b = [].slice.call(arguments);
        if (this[0])
          return b[0] ? (new o[u(b[0]) ? b.shift() : "Chart"](this[0], b[0], b[1]), this) : r[f(this[0], "data-highcharts-chart")];
      }), { addEvent: function(b, p, L, B = {}) {
        let T = typeof b == "function" && b.prototype || b;
        Object.hasOwnProperty.call(T, "hcEvents") || (T.hcEvents = {});
        let O = T.hcEvents;
        o.Point && b instanceof o.Point && b.series && b.series.chart && (b.series.chart.runTrackerClick = !0);
        let I = b.addEventListener;
        I && I.call(b, p, L, !!o.supportsPassiveEvents && { passive: B.passive === void 0 ? p.indexOf("touch") !== -1 : B.passive, capture: !1 }), O[p] || (O[p] = []);
        let R = { fn: L, order: typeof B.order == "number" ? B.order : 1 / 0 };
        return O[p].push(R), O[p].sort((Y, F) => Y.order - F.order), function() {
          M(b, p, L);
        };
      }, arrayMax: function(b) {
        let p = b.length, L = b[0];
        for (; p--; )
          b[p] > L && (L = b[p]);
        return L;
      }, arrayMin: function(b) {
        let p = b.length, L = b[0];
        for (; p--; )
          b[p] < L && (L = b[p]);
        return L;
      }, attr: f, clamp: function(b, p, L) {
        return b > p ? b < L ? b : L : p;
      }, clearTimeout: function(b) {
        P(b) && clearTimeout(b);
      }, correctFloat: $, createElement: function(b, p, L, B, T) {
        let O = s.createElement(b);
        return p && w(O, p), T && k(O, { padding: "0", border: "none", margin: "0" }), L && k(O, L), B && B.appendChild(O), O;
      }, crisp: (b, p = 0, L) => {
        let B = p % 2 / 2, T = L ? -1 : 1;
        return (Math.round(b * T - B) + B) * T;
      }, css: k, defined: P, destroyObjectProperties: function(b, p, L) {
        N(b, function(B, T) {
          B !== p && B?.destroy && B.destroy(), (B?.destroy || !L) && delete b[T];
        });
      }, diffObjects: function(b, p, L, B) {
        let T = {};
        return function O(I, R, Y, F) {
          let U = L ? R : I;
          N(I, function(Q, J) {
            if (!F && B && B.indexOf(J) > -1 && R[J]) {
              Q = S(Q), Y[J] = [];
              for (let ee = 0; ee < Math.max(Q.length, R[J].length); ee++)
                R[J][ee] && (Q[ee] === void 0 ? Y[J][ee] = R[J][ee] : (Y[J][ee] = {}, O(Q[ee], R[J][ee], Y[J][ee], F + 1)));
            } else
              h(Q, !0) && !Q.nodeType ? (Y[J] = m(Q) ? [] : {}, O(Q, R[J] || {}, Y[J], F + 1), Object.keys(Y[J]).length !== 0 || J === "colorAxis" && F === 0 || delete Y[J]) : (I[J] !== R[J] || J in I && !(J in R)) && J !== "__proto__" && J !== "constructor" && (Y[J] = U[J]);
          });
        }(b, p, T, 0), T;
      }, discardElement: function(b) {
        b && b.parentElement && b.parentElement.removeChild(b);
      }, erase: function(b, p) {
        let L = b.length;
        for (; L--; )
          if (b[L] === p) {
            b.splice(L, 1);
            break;
          }
      }, error: d, extend: w, extendClass: function(b, p) {
        let L = function() {
        };
        return L.prototype = new b(), w(L.prototype, p), L;
      }, find: j, fireEvent: D, getClosestDistance: function(b, p) {
        let L, B, T, O = !p;
        return b.forEach((I) => {
          if (I.length > 1)
            for (T = I.length - 1; T > 0; T--)
              (B = I[T] - I[T - 1]) < 0 && !O ? (p?.(), p = void 0) : B && (L === void 0 || B < L) && (L = B);
        }), L;
      }, getMagnitude: A, getNestedProperty: function(b, p) {
        let L = b.split(".");
        for (; L.length && P(p); ) {
          let B = L.shift();
          if (B === void 0 || B === "__proto__")
            return;
          if (B === "this") {
            let O;
            return h(p) && (O = p["@this"]), O ?? p;
          }
          let T = p[B];
          if (!P(T) || typeof T == "function" || typeof T.nodeType == "number" || T === l)
            return;
          p = T;
        }
        return p;
      }, getStyle: function b(p, L, B) {
        let T;
        if (L === "width") {
          let I = Math.min(p.offsetWidth, p.scrollWidth), R = p.getBoundingClientRect && p.getBoundingClientRect().width;
          return R < I && R >= I - 1 && (I = Math.floor(R)), Math.max(0, I - (b(p, "padding-left", !0) || 0) - (b(p, "padding-right", !0) || 0));
        }
        if (L === "height")
          return Math.max(0, Math.min(p.offsetHeight, p.scrollHeight) - (b(p, "padding-top", !0) || 0) - (b(p, "padding-bottom", !0) || 0));
        let O = l.getComputedStyle(p, void 0);
        return O && (T = O.getPropertyValue(L), x(B, L !== "opacity") && (T = y(T))), T;
      }, inArray: function(b, p, L) {
        return d(32, !1, void 0, { "Highcharts.inArray": "use Array.indexOf" }), p.indexOf(b, L);
      }, insertItem: function(b, p) {
        let L, B = b.options.index, T = p.length;
        for (L = b.options.isInternal ? T : 0; L < T + 1; L++)
          if (!p[L] || v(B) && B < x(p[L].options.index, p[L]._i) || p[L].options.isInternal) {
            p.splice(L, 0, b);
            break;
          }
        return L;
      }, isArray: m, isClass: g, isDOMElement: c, isFunction: function(b) {
        return typeof b == "function";
      }, isNumber: v, isObject: h, isString: u, keys: function(b) {
        return d(32, !1, void 0, { "Highcharts.keys": "use Object.keys" }), Object.keys(b);
      }, merge: function() {
        let b, p = arguments, L = {}, B = function(O, I) {
          return typeof O != "object" && (O = {}), N(I, function(R, Y) {
            Y !== "__proto__" && Y !== "constructor" && (!h(R, !0) || g(R) || c(R) ? O[Y] = I[Y] : O[Y] = B(O[Y] || {}, R));
          }), O;
        };
        p[0] === !0 && (L = p[1], p = Array.prototype.slice.call(p, 2));
        let T = p.length;
        for (b = 0; b < T; b++)
          L = B(L, p[b]);
        return L;
      }, normalizeTickInterval: function(b, p, L, B, T) {
        let O, I = b;
        L = x(L, A(b));
        let R = b / L;
        for (!p && (p = T ? [1, 1.2, 1.5, 2, 2.5, 3, 4, 5, 6, 8, 10] : [1, 2, 2.5, 5, 10], B === !1 && (L === 1 ? p = p.filter(function(Y) {
          return Y % 1 == 0;
        }) : L <= 0.1 && (p = [1 / L]))), O = 0; O < p.length && (I = p[O], (!T || !(I * L >= b)) && (T || !(R <= (p[O] + (p[O + 1] || p[O])) / 2))); O++)
          ;
        return $(I * L, -Math.round(Math.log(1e-3) / Math.LN10));
      }, objectEach: N, offset: function(b) {
        let p = s.documentElement, L = b.parentElement || b.parentNode ? b.getBoundingClientRect() : { top: 0, left: 0, width: 0, height: 0 };
        return { top: L.top + (l.pageYOffset || p.scrollTop) - (p.clientTop || 0), left: L.left + (l.pageXOffset || p.scrollLeft) - (p.clientLeft || 0), width: L.width, height: L.height };
      }, pad: function(b, p, L) {
        return Array((p || 2) + 1 - String(b).replace("-", "").length).join(L || "0") + b;
      }, pick: x, pInt: y, pushUnique: function(b, p) {
        return 0 > b.indexOf(p) && !!b.push(p);
      }, relativeLength: function(b, p, L) {
        return /%$/.test(b) ? p * parseFloat(b) / 100 + (L || 0) : parseFloat(b);
      }, removeEvent: M, replaceNested: function(b, ...p) {
        let L, B;
        do
          for (B of (L = b, p))
            b = b.replace(B[0], B[1]);
        while (b !== L);
        return b;
      }, splat: S, stableSort: function(b, p) {
        let L, B, T = b.length;
        for (B = 0; B < T; B++)
          b[B].safeI = B;
        for (b.sort(function(O, I) {
          return (L = p(O, I)) === 0 ? O.safeI - I.safeI : L;
        }), B = 0; B < T; B++)
          delete b[B].safeI;
      }, syncTimeout: function(b, p, L) {
        return p > 0 ? setTimeout(b, p, L) : (b.call(0, L), -1);
      }, timeUnits: { millisecond: 1, second: 1e3, minute: 6e4, hour: 36e5, day: 864e5, week: 6048e5, month: 24192e5, year: 314496e5 }, uniqueKey: C, useSerialIds: function(b) {
        return a = x(b, a);
      }, wrap: function(b, p, L) {
        let B = b[p];
        b[p] = function() {
          let T = arguments, O = this;
          return L.apply(this, [function() {
            return B.apply(O, arguments.length ? arguments : T);
          }].concat([].slice.call(arguments)));
        };
      } };
    }), i(n, "Core/Chart/ChartDefaults.js", [], function() {
      return { alignThresholds: !1, panning: { enabled: !1, type: "x" }, styledMode: !1, borderRadius: 0, colorCount: 10, allowMutatingData: !0, ignoreHiddenSeries: !0, spacing: [10, 10, 15, 10], resetZoomButton: { theme: {}, position: {} }, reflow: !0, type: "line", zooming: { singleTouch: !1, resetButton: { theme: { zIndex: 6 }, position: { align: "right", x: -10, y: 10 } } }, width: null, height: null, borderColor: "#334eff", backgroundColor: "#ffffff", plotBorderColor: "#cccccc" };
    }), i(n, "Core/Color/Palettes.js", [], function() {
      return { colors: ["#2caffe", "#544fc5", "#00e272", "#fe6a35", "#6b8abc", "#d568fb", "#2ee0ca", "#fa4b42", "#feb56a", "#91e8e1"] };
    }), i(n, "Core/Time.js", [n["Core/Globals.js"], n["Core/Utilities.js"]], function(o, a) {
      let { win: r } = o, { defined: s, error: l, extend: d, isNumber: y, isObject: u, merge: m, objectEach: h, pad: c, pick: g, splat: v, timeUnits: P } = a, f = o.isSafari && r.Intl && r.Intl.DateTimeFormat.prototype.formatRange, S = o.isSafari && r.Intl && !r.Intl.DateTimeFormat.prototype.formatRange;
      class w {
        constructor(k) {
          this.options = {}, this.useUTC = !1, this.variableTimezone = !1, this.Date = r.Date, this.getTimezoneOffset = this.timezoneOffsetFunction(), this.update(k);
        }
        get(k, A) {
          if (this.variableTimezone || this.timezoneOffset) {
            let $ = A.getTime(), j = $ - this.getTimezoneOffset(A);
            A.setTime(j);
            let N = A["getUTC" + k]();
            return A.setTime($), N;
          }
          return this.useUTC ? A["getUTC" + k]() : A["get" + k]();
        }
        set(k, A, $) {
          if (this.variableTimezone || this.timezoneOffset) {
            if (k === "Milliseconds" || k === "Seconds" || k === "Minutes" && this.getTimezoneOffset(A) % 36e5 == 0)
              return A["setUTC" + k]($);
            let j = this.getTimezoneOffset(A), N = A.getTime() - j;
            A.setTime(N), A["setUTC" + k]($);
            let M = this.getTimezoneOffset(A);
            return N = A.getTime() + M, A.setTime(N);
          }
          return this.useUTC || f && k === "FullYear" ? A["setUTC" + k]($) : A["set" + k]($);
        }
        update(k = {}) {
          let A = g(k.useUTC, !0);
          this.options = k = m(!0, this.options, k), this.Date = k.Date || r.Date || Date, this.useUTC = A, this.timezoneOffset = A && k.timezoneOffset || void 0, this.getTimezoneOffset = this.timezoneOffsetFunction(), this.variableTimezone = A && !!(k.getTimezoneOffset || k.timezone);
        }
        makeTime(k, A, $, j, N, M) {
          let D, C, b;
          return this.useUTC ? (D = this.Date.UTC.apply(0, arguments), C = this.getTimezoneOffset(D), D += C, C !== (b = this.getTimezoneOffset(D)) ? D += b - C : C - 36e5 !== this.getTimezoneOffset(D - 36e5) || S || (D -= 36e5)) : D = new this.Date(k, A, g($, 1), g(j, 0), g(N, 0), g(M, 0)).getTime(), D;
        }
        timezoneOffsetFunction() {
          let k = this, A = this.options, $ = A.getTimezoneOffset;
          return this.useUTC ? A.timezone ? (j) => {
            try {
              let N = `shortOffset,${A.timezone || ""}`, [M, D, C, b, p = 0] = (w.formatCache[N] = w.formatCache[N] || Intl.DateTimeFormat("en", { timeZone: A.timezone, timeZoneName: "shortOffset" })).format(j).split(/(GMT|:)/).map(Number), L = -(36e5 * (C + p / 60));
              if (y(L))
                return L;
            } catch {
              l(34);
            }
            return 0;
          } : this.useUTC && $ ? (j) => 6e4 * $(j.valueOf()) : () => 6e4 * (k.timezoneOffset || 0) : (j) => 6e4 * new Date(j.toString()).getTimezoneOffset();
        }
        dateFormat(k, A, $) {
          if (!s(A) || isNaN(A))
            return o.defaultOptions.lang && o.defaultOptions.lang.invalidDate || "";
          k = g(k, "%Y-%m-%d %H:%M:%S");
          let j = this, N = new this.Date(A), M = this.get("Hours", N), D = this.get("Day", N), C = this.get("Date", N), b = this.get("Month", N), p = this.get("FullYear", N), L = o.defaultOptions.lang, B = L && L.weekdays, T = L && L.shortWeekdays;
          return h(d({ a: T ? T[D] : B[D].substr(0, 3), A: B[D], d: c(C), e: c(C, 2, " "), w: D, b: L.shortMonths[b], B: L.months[b], m: c(b + 1), o: b + 1, y: p.toString().substr(2, 2), Y: p, H: c(M), k: M, I: c(M % 12 || 12), l: M % 12 || 12, M: c(this.get("Minutes", N)), p: M < 12 ? "AM" : "PM", P: M < 12 ? "am" : "pm", S: c(this.get("Seconds", N)), L: c(Math.floor(A % 1e3), 3) }, o.dateFormats), function(O, I) {
            for (; k.indexOf("%" + I) !== -1; )
              k = k.replace("%" + I, typeof O == "function" ? O.call(j, A) : O);
          }), $ ? k.substr(0, 1).toUpperCase() + k.substr(1) : k;
        }
        resolveDTLFormat(k) {
          return u(k, !0) ? k : { main: (k = v(k))[0], from: k[1], to: k[2] };
        }
        getTimeTicks(k, A, $, j) {
          let N, M, D, C, b = this, p = b.Date, L = [], B = {}, T = new p(A), O = k.unitRange, I = k.count || 1;
          if (j = g(j, 1), s(A)) {
            b.set("Milliseconds", T, O >= P.second ? 0 : I * Math.floor(b.get("Milliseconds", T) / I)), O >= P.second && b.set("Seconds", T, O >= P.minute ? 0 : I * Math.floor(b.get("Seconds", T) / I)), O >= P.minute && b.set("Minutes", T, O >= P.hour ? 0 : I * Math.floor(b.get("Minutes", T) / I)), O >= P.hour && b.set("Hours", T, O >= P.day ? 0 : I * Math.floor(b.get("Hours", T) / I)), O >= P.day && b.set("Date", T, O >= P.month ? 1 : Math.max(1, I * Math.floor(b.get("Date", T) / I))), O >= P.month && (b.set("Month", T, O >= P.year ? 0 : I * Math.floor(b.get("Month", T) / I)), M = b.get("FullYear", T)), O >= P.year && (M -= M % I, b.set("FullYear", T, M)), O === P.week && (C = b.get("Day", T), b.set("Date", T, b.get("Date", T) - C + j + (C < j ? -7 : 0))), M = b.get("FullYear", T);
            let R = b.get("Month", T), Y = b.get("Date", T), F = b.get("Hours", T);
            A = T.getTime(), (b.variableTimezone || !b.useUTC) && s($) && (D = $ - A > 4 * P.month || b.getTimezoneOffset(A) !== b.getTimezoneOffset($));
            let U = T.getTime();
            for (N = 1; U < $; )
              L.push(U), O === P.year ? U = b.makeTime(M + N * I, 0) : O === P.month ? U = b.makeTime(M, R + N * I) : D && (O === P.day || O === P.week) ? U = b.makeTime(M, R, Y + N * I * (O === P.day ? 1 : 7)) : D && O === P.hour && I > 1 ? U = b.makeTime(M, R, Y, F + N * I) : U += O * I, N++;
            L.push(U), O <= P.hour && L.length < 1e4 && L.forEach(function(Q) {
              Q % 18e5 == 0 && b.dateFormat("%H%M%S%L", Q) === "000000000" && (B[Q] = "day");
            });
          }
          return L.info = d(k, { higherRanks: B, totalRange: O * I }), L;
        }
        getDateFormat(k, A, $, j) {
          let N = this.dateFormat("%m-%d %H:%M:%S.%L", A), M = "01-01 00:00:00.000", D = { millisecond: 15, second: 12, minute: 9, hour: 6, day: 3 }, C = "millisecond", b = C;
          for (C in P) {
            if (k === P.week && +this.dateFormat("%w", A) === $ && N.substr(6) === M.substr(6)) {
              C = "week";
              break;
            }
            if (P[C] > k) {
              C = b;
              break;
            }
            if (D[C] && N.substr(D[C]) !== M.substr(D[C]))
              break;
            C !== "week" && (b = C);
          }
          return this.resolveDTLFormat(j[C]).main;
        }
      }
      return w.formatCache = {}, w;
    }), i(n, "Core/Defaults.js", [n["Core/Chart/ChartDefaults.js"], n["Core/Globals.js"], n["Core/Color/Palettes.js"], n["Core/Time.js"], n["Core/Utilities.js"]], function(o, a, r, s, l) {
      let { isTouchDevice: d } = a, { fireEvent: y, merge: u } = l, m = { colors: r.colors, symbols: ["circle", "diamond", "square", "triangle", "triangle-down"], lang: { loading: "Loading...", months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"], shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"], weekdays: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"], decimalPoint: ".", numericSymbols: ["k", "M", "G", "T", "P", "E"], resetZoom: "Reset zoom", resetZoomTitle: "Reset zoom level 1:1", thousandsSep: " " }, global: { buttonTheme: { fill: "#f7f7f7", padding: 8, r: 2, stroke: "#cccccc", "stroke-width": 1, style: { color: "#333333", cursor: "pointer", fontSize: "0.8em", fontWeight: "normal" }, states: { hover: { fill: "#e6e6e6" }, select: { fill: "#e6e9ff", style: { color: "#000000", fontWeight: "bold" } }, disabled: { style: { color: "#cccccc" } } } } }, time: { Date: void 0, getTimezoneOffset: void 0, timezone: void 0, timezoneOffset: 0, useUTC: !0 }, chart: o, title: { style: { color: "#333333", fontWeight: "bold" }, text: "Chart title", align: "center", margin: 15, widthAdjust: -44 }, subtitle: { style: { color: "#666666", fontSize: "0.8em" }, text: "", align: "center", widthAdjust: -44 }, caption: { margin: 15, style: { color: "#666666", fontSize: "0.8em" }, text: "", align: "left", verticalAlign: "bottom" }, plotOptions: {}, legend: { enabled: !0, align: "center", alignColumns: !0, className: "highcharts-no-tooltip", events: {}, layout: "horizontal", itemMarginBottom: 2, itemMarginTop: 2, labelFormatter: function() {
        return this.name;
      }, borderColor: "#999999", borderRadius: 0, navigation: { style: { fontSize: "0.8em" }, activeColor: "#0022ff", inactiveColor: "#cccccc" }, itemStyle: { color: "#333333", cursor: "pointer", fontSize: "0.8em", textDecoration: "none", textOverflow: "ellipsis" }, itemHoverStyle: { color: "#000000" }, itemHiddenStyle: { color: "#666666", textDecoration: "line-through" }, shadow: !1, itemCheckboxStyle: { position: "absolute", width: "13px", height: "13px" }, squareSymbol: !0, symbolPadding: 5, verticalAlign: "bottom", x: 0, y: 0, title: { style: { fontSize: "0.8em", fontWeight: "bold" } } }, loading: { labelStyle: { fontWeight: "bold", position: "relative", top: "45%" }, style: { position: "absolute", backgroundColor: "#ffffff", opacity: 0.5, textAlign: "center" } }, tooltip: { enabled: !0, animation: { duration: 300, easing: (c) => Math.sqrt(1 - Math.pow(c - 1, 2)) }, borderRadius: 3, dateTimeLabelFormats: { millisecond: "%A, %e %b, %H:%M:%S.%L", second: "%A, %e %b, %H:%M:%S", minute: "%A, %e %b, %H:%M", hour: "%A, %e %b, %H:%M", day: "%A, %e %b %Y", week: "Week from %A, %e %b %Y", month: "%B %Y", year: "%Y" }, footerFormat: "", headerShape: "callout", hideDelay: 500, padding: 8, shape: "callout", shared: !1, snap: d ? 25 : 10, headerFormat: '<span style="font-size: 0.8em">{point.key}</span><br/>', pointFormat: '<span style="color:{point.color}">●</span> {series.name}: <b>{point.y}</b><br/>', backgroundColor: "#ffffff", borderWidth: void 0, shadow: !0, stickOnContact: !1, style: { color: "#333333", cursor: "default", fontSize: "0.8em" }, useHTML: !1 }, credits: { enabled: !0, href: "https://www.highcharts.com?credits", position: { align: "right", x: -10, verticalAlign: "bottom", y: -5 }, style: { cursor: "pointer", color: "#999999", fontSize: "0.6em" }, text: "Highcharts.com" } };
      m.chart.styledMode = !1;
      let h = new s(m.time);
      return { defaultOptions: m, defaultTime: h, getOptions: function() {
        return m;
      }, setOptions: function(c) {
        return y(a, "setOptions", { options: c }), u(!0, m, c), (c.time || c.global) && (a.time ? a.time.update(u(m.global, m.time, c.global, c.time)) : a.time = h), m;
      } };
    }), i(n, "Core/Color/Color.js", [n["Core/Globals.js"], n["Core/Utilities.js"]], function(o, a) {
      let { isNumber: r, merge: s, pInt: l } = a;
      class d {
        static parse(u) {
          return u ? new d(u) : d.None;
        }
        constructor(u) {
          let m, h, c, g;
          this.rgba = [NaN, NaN, NaN, NaN], this.input = u;
          let v = o.Color;
          if (v && v !== d)
            return new v(u);
          if (typeof u == "object" && u.stops !== void 0)
            this.stops = u.stops.map((P) => new d(P[1]));
          else if (typeof u == "string") {
            if (this.input = u = d.names[u.toLowerCase()] || u, u.charAt(0) === "#") {
              let P = u.length, f = parseInt(u.substr(1), 16);
              P === 7 ? h = [(16711680 & f) >> 16, (65280 & f) >> 8, 255 & f, 1] : P === 4 && (h = [(3840 & f) >> 4 | (3840 & f) >> 8, (240 & f) >> 4 | 240 & f, (15 & f) << 4 | 15 & f, 1]);
            }
            if (!h)
              for (c = d.parsers.length; c-- && !h; )
                (m = (g = d.parsers[c]).regex.exec(u)) && (h = g.parse(m));
          }
          h && (this.rgba = h);
        }
        get(u) {
          let m = this.input, h = this.rgba;
          if (typeof m == "object" && this.stops !== void 0) {
            let c = s(m);
            return c.stops = [].slice.call(c.stops), this.stops.forEach((g, v) => {
              c.stops[v] = [c.stops[v][0], g.get(u)];
            }), c;
          }
          return h && r(h[0]) ? u !== "rgb" && (u || h[3] !== 1) ? u === "a" ? `${h[3]}` : "rgba(" + h.join(",") + ")" : "rgb(" + h[0] + "," + h[1] + "," + h[2] + ")" : m;
        }
        brighten(u) {
          let m = this.rgba;
          if (this.stops)
            this.stops.forEach(function(h) {
              h.brighten(u);
            });
          else if (r(u) && u !== 0)
            for (let h = 0; h < 3; h++)
              m[h] += l(255 * u), m[h] < 0 && (m[h] = 0), m[h] > 255 && (m[h] = 255);
          return this;
        }
        setOpacity(u) {
          return this.rgba[3] = u, this;
        }
        tweenTo(u, m) {
          let h = this.rgba, c = u.rgba;
          if (!r(h[0]) || !r(c[0]))
            return u.input || "none";
          let g = c[3] !== 1 || h[3] !== 1;
          return (g ? "rgba(" : "rgb(") + Math.round(c[0] + (h[0] - c[0]) * (1 - m)) + "," + Math.round(c[1] + (h[1] - c[1]) * (1 - m)) + "," + Math.round(c[2] + (h[2] - c[2]) * (1 - m)) + (g ? "," + (c[3] + (h[3] - c[3]) * (1 - m)) : "") + ")";
        }
      }
      return d.names = { white: "#ffffff", black: "#000000" }, d.parsers = [{ regex: /rgba\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d?(?:\.\d+)?)\s*\)/, parse: function(y) {
        return [l(y[1]), l(y[2]), l(y[3]), parseFloat(y[4], 10)];
      } }, { regex: /rgb\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*\)/, parse: function(y) {
        return [l(y[1]), l(y[2]), l(y[3]), 1];
      } }], d.None = new d(""), d;
    }), i(n, "Core/Animation/Fx.js", [n["Core/Color/Color.js"], n["Core/Globals.js"], n["Core/Utilities.js"]], function(o, a, r) {
      let { parse: s } = o, { win: l } = a, { isNumber: d, objectEach: y } = r;
      class u {
        constructor(h, c, g) {
          this.pos = NaN, this.options = c, this.elem = h, this.prop = g;
        }
        dSetter() {
          let h = this.paths, c = h && h[0], g = h && h[1], v = this.now || 0, P = [];
          if (v !== 1 && c && g)
            if (c.length === g.length && v < 1)
              for (let f = 0; f < g.length; f++) {
                let S = c[f], w = g[f], x = [];
                for (let k = 0; k < w.length; k++) {
                  let A = S[k], $ = w[k];
                  d(A) && d($) && !(w[0] === "A" && (k === 4 || k === 5)) ? x[k] = A + v * ($ - A) : x[k] = $;
                }
                P.push(x);
              }
            else
              P = g;
          else
            P = this.toD || [];
          this.elem.attr("d", P, void 0, !0);
        }
        update() {
          let h = this.elem, c = this.prop, g = this.now, v = this.options.step;
          this[c + "Setter"] ? this[c + "Setter"]() : h.attr ? h.element && h.attr(c, g, null, !0) : h.style[c] = g + this.unit, v && v.call(h, g, this);
        }
        run(h, c, g) {
          let v = this, P = v.options, f = function(x) {
            return !f.stopped && v.step(x);
          }, S = l.requestAnimationFrame || function(x) {
            setTimeout(x, 13);
          }, w = function() {
            for (let x = 0; x < u.timers.length; x++)
              u.timers[x]() || u.timers.splice(x--, 1);
            u.timers.length && S(w);
          };
          h !== c || this.elem["forceAnimate:" + this.prop] ? (this.startTime = +/* @__PURE__ */ new Date(), this.start = h, this.end = c, this.unit = g, this.now = this.start, this.pos = 0, f.elem = this.elem, f.prop = this.prop, f() && u.timers.push(f) === 1 && S(w)) : (delete P.curAnim[this.prop], P.complete && Object.keys(P.curAnim).length === 0 && P.complete.call(this.elem));
        }
        step(h) {
          let c, g, v = +/* @__PURE__ */ new Date(), P = this.options, f = this.elem, S = P.complete, w = P.duration, x = P.curAnim;
          return f.attr && !f.element ? c = !1 : h || v >= w + this.startTime ? (this.now = this.end, this.pos = 1, this.update(), x[this.prop] = !0, g = !0, y(x, function(k) {
            k !== !0 && (g = !1);
          }), g && S && S.call(f), c = !1) : (this.pos = P.easing((v - this.startTime) / w), this.now = this.start + (this.end - this.start) * this.pos, this.update(), c = !0), c;
        }
        initPath(h, c, g) {
          let v = h.startX, P = h.endX, f = g.slice(), S = h.isArea, w = S ? 2 : 1, x = c && g.length > c.length && g.hasStackedCliffs, k, A, $, j, N = c && c.slice();
          if (!N || x)
            return [f, f];
          function M(C, b) {
            for (; C.length < A; ) {
              let p = C[0], L = b[A - C.length];
              if (L && p[0] === "M" && (L[0] === "C" ? C[0] = ["C", p[1], p[2], p[1], p[2], p[1], p[2]] : C[0] = ["L", p[1], p[2]]), C.unshift(p), S) {
                let B = C.pop();
                C.push(C[C.length - 1], B);
              }
            }
          }
          function D(C) {
            for (; C.length < A; ) {
              let b = C[Math.floor(C.length / w) - 1].slice();
              if (b[0] === "C" && (b[1] = b[5], b[2] = b[6]), S) {
                let p = C[Math.floor(C.length / w)].slice();
                C.splice(C.length / 2, 0, b, p);
              } else
                C.push(b);
            }
          }
          if (v && P && P.length) {
            for ($ = 0; $ < v.length; $++) {
              if (v[$] === P[0]) {
                k = $;
                break;
              }
              if (v[0] === P[P.length - v.length + $]) {
                k = $, j = !0;
                break;
              }
              if (v[v.length - 1] === P[P.length - v.length + $]) {
                k = v.length - $;
                break;
              }
            }
            k === void 0 && (N = []);
          }
          return N.length && d(k) && (A = f.length + k * w, j ? (M(N, f), D(f)) : (M(f, N), D(N))), [N, f];
        }
        fillSetter() {
          u.prototype.strokeSetter.apply(this, arguments);
        }
        strokeSetter() {
          this.elem.attr(this.prop, s(this.start).tweenTo(s(this.end), this.pos), void 0, !0);
        }
      }
      return u.timers = [], u;
    }), i(n, "Core/Animation/AnimationUtilities.js", [n["Core/Animation/Fx.js"], n["Core/Utilities.js"]], function(o, a) {
      let { defined: r, getStyle: s, isArray: l, isNumber: d, isObject: y, merge: u, objectEach: m, pick: h } = a;
      function c(v) {
        return y(v) ? u({ duration: 500, defer: 0 }, v) : { duration: v ? 500 : 0, defer: 0 };
      }
      function g(v, P) {
        let f = o.timers.length;
        for (; f--; )
          o.timers[f].elem !== v || P && P !== o.timers[f].prop || (o.timers[f].stopped = !0);
      }
      return { animate: function(v, P, f) {
        let S, w = "", x, k, A;
        y(f) || (A = arguments, f = { duration: A[2], easing: A[3], complete: A[4] }), d(f.duration) || (f.duration = 400), f.easing = typeof f.easing == "function" ? f.easing : Math[f.easing] || Math.easeInOutSine, f.curAnim = u(P), m(P, function($, j) {
          g(v, j), k = new o(v, f, j), x = void 0, j === "d" && l(P.d) ? (k.paths = k.initPath(v, v.pathArray, P.d), k.toD = P.d, S = 0, x = 1) : v.attr ? S = v.attr(j) : (S = parseFloat(s(v, j)) || 0, j !== "opacity" && (w = "px")), x || (x = $), typeof x == "string" && x.match("px") && (x = x.replace(/px/g, "")), k.run(S, x, w);
        });
      }, animObject: c, getDeferredAnimation: function(v, P, f) {
        let S = c(P), w = f ? [f] : v.series, x = 0, k = 0;
        return w.forEach((A) => {
          let $ = c(A.options.animation);
          x = y(P) && r(P.defer) ? S.defer : Math.max(x, $.duration + $.defer), k = Math.min(S.duration, $.duration);
        }), v.renderer.forExport && (x = 0), { defer: Math.max(0, x - k), duration: Math.min(x, k) };
      }, setAnimation: function(v, P) {
        P.renderer.globalAnimation = h(v, P.options.chart.animation, !0);
      }, stop: g };
    }), i(n, "Core/Renderer/HTML/AST.js", [n["Core/Globals.js"], n["Core/Utilities.js"]], function(o, a) {
      let { SVG_NS: r, win: s } = o, { attr: l, createElement: d, css: y, error: u, isFunction: m, isString: h, objectEach: c, splat: g } = a, { trustedTypes: v } = s, P = v && m(v.createPolicy) && v.createPolicy("highcharts", { createHTML: (x) => x }), f = P ? P.createHTML("") : "", S = function() {
        try {
          return !!new DOMParser().parseFromString(f, "text/html");
        } catch {
          return !1;
        }
      }();
      class w {
        static filterUserAttributes(k) {
          return c(k, (A, $) => {
            let j = !0;
            w.allowedAttributes.indexOf($) === -1 && (j = !1), ["background", "dynsrc", "href", "lowsrc", "src"].indexOf($) !== -1 && (j = h(A) && w.allowedReferences.some((N) => A.indexOf(N) === 0)), j || (u(33, !1, void 0, { "Invalid attribute in config": `${$}` }), delete k[$]), h(A) && k[$] && (k[$] = A.replace(/</g, "&lt;"));
          }), k;
        }
        static parseStyle(k) {
          return k.split(";").reduce((A, $) => {
            let j = $.split(":").map((M) => M.trim()), N = j.shift();
            return N && j.length && (A[N.replace(/-([a-z])/g, (M) => M[1].toUpperCase())] = j.join(":")), A;
          }, {});
        }
        static setElementHTML(k, A) {
          k.innerHTML = w.emptyHTML, A && new w(A).addToDOM(k);
        }
        constructor(k) {
          this.nodes = typeof k == "string" ? this.parseMarkup(k) : k;
        }
        addToDOM(k) {
          return function A($, j) {
            let N;
            return g($).forEach(function(M) {
              let D, C = M.tagName, b = M.textContent ? o.doc.createTextNode(M.textContent) : void 0, p = w.bypassHTMLFiltering;
              if (C)
                if (C === "#text")
                  D = b;
                else if (w.allowedTags.indexOf(C) !== -1 || p) {
                  let L = C === "svg" ? r : j.namespaceURI || r, B = o.doc.createElementNS(L, C), T = M.attributes || {};
                  c(M, function(O, I) {
                    I !== "tagName" && I !== "attributes" && I !== "children" && I !== "style" && I !== "textContent" && (T[I] = O);
                  }), l(B, p ? T : w.filterUserAttributes(T)), M.style && y(B, M.style), b && B.appendChild(b), A(M.children || [], B), D = B;
                } else
                  u(33, !1, void 0, { "Invalid tagName in config": C });
              D && j.appendChild(D), N = D;
            }), N;
          }(this.nodes, k);
        }
        parseMarkup(k) {
          let A, $ = [];
          if (k = k.trim().replace(/ style=(["'])/g, " data-style=$1"), S)
            A = new DOMParser().parseFromString(P ? P.createHTML(k) : k, "text/html");
          else {
            let N = d("div");
            N.innerHTML = k, A = { body: N };
          }
          let j = (N, M) => {
            let D = N.nodeName.toLowerCase(), C = { tagName: D };
            D === "#text" && (C.textContent = N.textContent || "");
            let b = N.attributes;
            if (b) {
              let p = {};
              [].forEach.call(b, (L) => {
                L.name === "data-style" ? C.style = w.parseStyle(L.value) : p[L.name] = L.value;
              }), C.attributes = p;
            }
            if (N.childNodes.length) {
              let p = [];
              [].forEach.call(N.childNodes, (L) => {
                j(L, p);
              }), p.length && (C.children = p);
            }
            M.push(C);
          };
          return [].forEach.call(A.body.childNodes, (N) => j(N, $)), $;
        }
      }
      return w.allowedAttributes = ["alt", "aria-controls", "aria-describedby", "aria-expanded", "aria-haspopup", "aria-hidden", "aria-label", "aria-labelledby", "aria-live", "aria-pressed", "aria-readonly", "aria-roledescription", "aria-selected", "class", "clip-path", "color", "colspan", "cx", "cy", "d", "dx", "dy", "disabled", "fill", "filterUnits", "flood-color", "flood-opacity", "height", "href", "id", "in", "in2", "markerHeight", "markerWidth", "offset", "opacity", "operator", "orient", "padding", "paddingLeft", "paddingRight", "patternUnits", "r", "radius", "refX", "refY", "role", "scope", "slope", "src", "startOffset", "stdDeviation", "stroke", "stroke-linecap", "stroke-width", "style", "tableValues", "result", "rowspan", "summary", "target", "tabindex", "text-align", "text-anchor", "textAnchor", "textLength", "title", "type", "valign", "width", "x", "x1", "x2", "xlink:href", "y", "y1", "y2", "zIndex"], w.allowedReferences = ["https://", "http://", "mailto:", "/", "../", "./", "#"], w.allowedTags = ["a", "abbr", "b", "br", "button", "caption", "circle", "clipPath", "code", "dd", "defs", "div", "dl", "dt", "em", "feComponentTransfer", "feComposite", "feDropShadow", "feFlood", "feFuncA", "feFuncB", "feFuncG", "feFuncR", "feGaussianBlur", "feMorphology", "feOffset", "feMerge", "feMergeNode", "filter", "h1", "h2", "h3", "h4", "h5", "h6", "hr", "i", "img", "li", "linearGradient", "marker", "ol", "p", "path", "pattern", "pre", "rect", "small", "span", "stop", "strong", "style", "sub", "sup", "svg", "table", "text", "textPath", "thead", "title", "tbody", "tspan", "td", "th", "tr", "u", "ul", "#text"], w.emptyHTML = f, w.bypassHTMLFiltering = !1, w;
    }), i(n, "Core/Templating.js", [n["Core/Defaults.js"], n["Core/Utilities.js"]], function(o, a) {
      let { defaultOptions: r, defaultTime: s } = o, { extend: l, getNestedProperty: d, isArray: y, isNumber: u, isObject: m, pick: h, pInt: c } = a, g = { add: (f, S) => f + S, divide: (f, S) => S !== 0 ? f / S : "", eq: (f, S) => f == S, each: function(f) {
        let S = arguments[arguments.length - 1];
        return !!y(f) && f.map((w, x) => v(S.body, l(m(w) ? w : { "@this": w }, { "@index": x, "@first": x === 0, "@last": x === f.length - 1 }))).join("");
      }, ge: (f, S) => f >= S, gt: (f, S) => f > S, if: (f) => !!f, le: (f, S) => f <= S, lt: (f, S) => f < S, multiply: (f, S) => f * S, ne: (f, S) => f != S, subtract: (f, S) => f - S, unless: (f) => !f };
      function v(f = "", S, w) {
        let x = /\{([\w\:\.\,;\-\/<>%@"'’= #\(\)]+)\}/g, k = /\(([\w\:\.\,;\-\/<>%@"'= ]+)\)/g, A = [], $ = /f$/, j = /\.(\d)/, N = r.lang, M = w && w.time || s, D = w && w.numberFormatter || P, C = (T = "") => {
          let O;
          return T === "true" || T !== "false" && ((O = Number(T)).toString() === T ? O : d(T, S));
        }, b, p, L = 0, B;
        for (; (b = x.exec(f)) !== null; ) {
          let T = k.exec(b[1]);
          T && (b = T, B = !0), p && p.isBlock || (p = { ctx: S, expression: b[1], find: b[0], isBlock: b[1].charAt(0) === "#", start: b.index, startInner: b.index + b[0].length, length: b[0].length });
          let O = b[1].split(" ")[0].replace("#", "");
          g[O] && (p.isBlock && O === p.fn && L++, p.fn || (p.fn = O));
          let I = b[1] === "else";
          if (p.isBlock && p.fn && (b[1] === `/${p.fn}` || I))
            if (L)
              !I && L--;
            else {
              let R = p.startInner, Y = f.substr(R, b.index - R);
              p.body === void 0 ? (p.body = Y, p.startInner = b.index + b[0].length) : p.elseBody = Y, p.find += Y + b[0], I || (A.push(p), p = void 0);
            }
          else
            p.isBlock || A.push(p);
          if (T && !p?.isBlock)
            break;
        }
        return A.forEach((T) => {
          let O, I, { body: R, elseBody: Y, expression: F, fn: U } = T;
          if (U) {
            let Q = [T], J = F.split(" ");
            for (I = g[U].length; I--; )
              Q.unshift(C(J[I + 1]));
            O = g[U].apply(S, Q), T.isBlock && typeof O == "boolean" && (O = v(O ? R : Y, S, w));
          } else {
            let Q = F.split(":");
            if (O = C(Q.shift() || ""), Q.length && typeof O == "number") {
              let J = Q.join(":");
              if ($.test(J)) {
                let ee = parseInt((J.match(j) || ["", "-1"])[1], 10);
                O !== null && (O = D(O, ee, N.decimalPoint, J.indexOf(",") > -1 ? N.thousandsSep : ""));
              } else
                O = M.dateFormat(J, O);
            }
          }
          f = f.replace(T.find, h(O, ""));
        }), B ? v(f, S, w) : f;
      }
      function P(f, S, w, x) {
        let k, A;
        f = +f || 0, S = +S;
        let $ = r.lang, j = (f.toString().split(".")[1] || "").split("e")[0].length, N = f.toString().split("e"), M = S;
        S === -1 ? S = Math.min(j, 20) : u(S) ? S && N[1] && N[1] < 0 && ((A = S + +N[1]) >= 0 ? (N[0] = (+N[0]).toExponential(A).split("e")[0], S = A) : (N[0] = N[0].split(".")[0] || 0, f = S < 20 ? (N[0] * Math.pow(10, N[1])).toFixed(S) : 0, N[1] = 0)) : S = 2;
        let D = (Math.abs(N[1] ? N[0] : f) + Math.pow(10, -Math.max(S, j) - 1)).toFixed(S), C = String(c(D)), b = C.length > 3 ? C.length % 3 : 0;
        return w = h(w, $.decimalPoint), x = h(x, $.thousandsSep), k = (f < 0 ? "-" : "") + (b ? C.substr(0, b) + x : ""), 0 > +N[1] && !M ? k = "0" : k += C.substr(b).replace(/(\d{3})(?=\d)/g, "$1" + x), S ? k += w + D.slice(-S) : +k == 0 && (k = "0"), N[1] && +k != 0 && (k += "e" + N[1]), k;
      }
      return { dateFormat: function(f, S, w) {
        return s.dateFormat(f, S, w);
      }, format: v, helpers: g, numberFormat: P };
    }), i(n, "Core/Renderer/RendererRegistry.js", [n["Core/Globals.js"]], function(o) {
      var a, r;
      let s;
      return (r = a || (a = {})).rendererTypes = {}, r.getRendererType = function(l = s) {
        return r.rendererTypes[l] || r.rendererTypes[s];
      }, r.registerRendererType = function(l, d, y) {
        r.rendererTypes[l] = d, (!s || y) && (s = l, o.Renderer = d);
      }, a;
    }), i(n, "Core/Renderer/RendererUtilities.js", [n["Core/Utilities.js"]], function(o) {
      var a;
      let { clamp: r, pick: s, pushUnique: l, stableSort: d } = o;
      return (a || (a = {})).distribute = function y(u, m, h) {
        let c = u, g = c.reducedLen || m, v = (C, b) => C.target - b.target, P = [], f = u.length, S = [], w = P.push, x, k, A, $ = !0, j, N, M = 0, D;
        for (x = f; x--; )
          M += u[x].size;
        if (M > g) {
          for (d(u, (C, b) => (b.rank || 0) - (C.rank || 0)), A = (D = u[0].rank === u[u.length - 1].rank) ? f / 2 : -1, k = D ? A : f - 1; A && M > g; )
            j = u[x = Math.floor(k)], l(S, x) && (M -= j.size), k += A, D && k >= u.length && (A /= 2, k = A);
          S.sort((C, b) => b - C).forEach((C) => w.apply(P, u.splice(C, 1)));
        }
        for (d(u, v), u = u.map((C) => ({ size: C.size, targets: [C.target], align: s(C.align, 0.5) })); $; ) {
          for (x = u.length; x--; )
            j = u[x], N = (Math.min.apply(0, j.targets) + Math.max.apply(0, j.targets)) / 2, j.pos = r(N - j.size * j.align, 0, m - j.size);
          for (x = u.length, $ = !1; x--; )
            x > 0 && u[x - 1].pos + u[x - 1].size > u[x].pos && (u[x - 1].size += u[x].size, u[x - 1].targets = u[x - 1].targets.concat(u[x].targets), u[x - 1].align = 0.5, u[x - 1].pos + u[x - 1].size > m && (u[x - 1].pos = m - u[x - 1].size), u.splice(x, 1), $ = !0);
        }
        return w.apply(c, P), x = 0, u.some((C) => {
          let b = 0;
          return (C.targets || []).some(() => (c[x].pos = C.pos + b, h !== void 0 && Math.abs(c[x].pos - c[x].target) > h ? (c.slice(0, x + 1).forEach((p) => delete p.pos), c.reducedLen = (c.reducedLen || m) - 0.1 * m, c.reducedLen > 0.1 * m && y(c, m, h), !0) : (b += c[x].size, x++, !1)));
        }), d(c, v), c;
      }, a;
    }), i(n, "Core/Renderer/SVG/SVGElement.js", [n["Core/Animation/AnimationUtilities.js"], n["Core/Color/Color.js"], n["Core/Globals.js"], n["Core/Utilities.js"]], function(o, a, r, s) {
      let { animate: l, animObject: d, stop: y } = o, { deg2rad: u, doc: m, svg: h, SVG_NS: c, win: g } = r, { addEvent: v, attr: P, createElement: f, crisp: S, css: w, defined: x, erase: k, extend: A, fireEvent: $, isArray: j, isFunction: N, isObject: M, isString: D, merge: C, objectEach: b, pick: p, pInt: L, pushUnique: B, replaceNested: T, syncTimeout: O, uniqueKey: I } = s;
      class R {
        _defaultGetter(F) {
          let U = p(this[F + "Value"], this[F], this.element ? this.element.getAttribute(F) : null, 0);
          return /^-?[\d\.]+$/.test(U) && (U = parseFloat(U)), U;
        }
        _defaultSetter(F, U, Q) {
          Q.setAttribute(U, F);
        }
        add(F) {
          let U, Q = this.renderer, J = this.element;
          return F && (this.parentGroup = F), this.textStr !== void 0 && this.element.nodeName === "text" && Q.buildText(this), this.added = !0, (!F || F.handleZ || this.zIndex) && (U = this.zIndexSetter()), U || (F ? F.element : Q.box).appendChild(J), this.onAdd && this.onAdd(), this;
        }
        addClass(F, U) {
          let Q = U ? "" : this.attr("class") || "";
          return (F = (F || "").split(/ /g).reduce(function(J, ee) {
            return Q.indexOf(ee) === -1 && J.push(ee), J;
          }, Q ? [Q] : []).join(" ")) !== Q && this.attr("class", F), this;
        }
        afterSetters() {
          this.doTransform && (this.updateTransform(), this.doTransform = !1);
        }
        align(F, U, Q, J = !0) {
          let ee, V, G, W, ae = {}, z = this.renderer, q = z.alignedObjects, Z = !!F;
          F ? (this.alignOptions = F, this.alignByTranslate = U, this.alignTo = Q) : (F = this.alignOptions || {}, U = this.alignByTranslate, Q = this.alignTo);
          let ne = !Q || D(Q) ? Q || "renderer" : void 0;
          ne && (Z && B(q, this), Q = void 0);
          let ie = p(Q, z[ne], z), re = F.align, de = F.verticalAlign;
          return ee = (ie.x || 0) + (F.x || 0), V = (ie.y || 0) + (F.y || 0), re === "right" ? G = 1 : re === "center" && (G = 2), G && (ee += ((ie.width || 0) - (F.width || 0)) / G), ae[U ? "translateX" : "x"] = Math.round(ee), de === "bottom" ? W = 1 : de === "middle" && (W = 2), W && (V += ((ie.height || 0) - (F.height || 0)) / W), ae[U ? "translateY" : "y"] = Math.round(V), J && (this[this.placed ? "animate" : "attr"](ae), this.placed = !0), this.alignAttr = ae, this;
        }
        alignSetter(F) {
          let U = { left: "start", center: "middle", right: "end" };
          U[F] && (this.alignValue = F, this.element.setAttribute("text-anchor", U[F]));
        }
        animate(F, U, Q) {
          let J = d(p(U, this.renderer.globalAnimation, !0)), ee = J.defer;
          return m.hidden && (J.duration = 0), J.duration !== 0 ? (Q && (J.complete = Q), O(() => {
            this.element && l(this, F, J);
          }, ee)) : (this.attr(F, void 0, Q || J.complete), b(F, function(V, G) {
            J.step && J.step.call(this, V, { prop: G, pos: 1, elem: this });
          }, this)), this;
        }
        applyTextOutline(F) {
          let U = this.element;
          F.indexOf("contrast") !== -1 && (F = F.replace(/contrast/g, this.renderer.getContrast(U.style.fill)));
          let Q = F.split(" "), J = Q[Q.length - 1], ee = Q[0];
          if (ee && ee !== "none" && r.svg) {
            this.fakeTS = !0, ee = ee.replace(/(^[\d\.]+)(.*?)$/g, function(z, q, Z) {
              return 2 * Number(q) + Z;
            }), this.removeTextOutline();
            let V = m.createElementNS(c, "tspan");
            P(V, { class: "highcharts-text-outline", fill: J, stroke: J, "stroke-width": ee, "stroke-linejoin": "round" });
            let G = U.querySelector("textPath") || U;
            [].forEach.call(G.childNodes, (z) => {
              let q = z.cloneNode(!0);
              q.removeAttribute && ["fill", "stroke", "stroke-width", "stroke"].forEach((Z) => q.removeAttribute(Z)), V.appendChild(q);
            });
            let W = 0;
            [].forEach.call(G.querySelectorAll("text tspan"), (z) => {
              W += Number(z.getAttribute("dy"));
            });
            let ae = m.createElementNS(c, "tspan");
            ae.textContent = "​", P(ae, { x: Number(U.getAttribute("x")), dy: -W }), V.appendChild(ae), G.insertBefore(V, G.firstChild);
          }
        }
        attr(F, U, Q, J) {
          let { element: ee } = this, V = R.symbolCustomAttribs, G, W, ae = this, z;
          return typeof F == "string" && U !== void 0 && (G = F, (F = {})[G] = U), typeof F == "string" ? ae = (this[F + "Getter"] || this._defaultGetter).call(this, F, ee) : (b(F, function(q, Z) {
            z = !1, J || y(this, Z), this.symbolName && V.indexOf(Z) !== -1 && (W || (this.symbolAttr(F), W = !0), z = !0), this.rotation && (Z === "x" || Z === "y") && (this.doTransform = !0), z || (this[Z + "Setter"] || this._defaultSetter).call(this, q, Z, ee);
          }, this), this.afterSetters()), Q && Q.call(this), ae;
        }
        clip(F) {
          if (F && !F.clipPath) {
            let U = I() + "-", Q = this.renderer.createElement("clipPath").attr({ id: U }).add(this.renderer.defs);
            A(F, { clipPath: Q, id: U, count: 0 }), F.add(Q);
          }
          return this.attr("clip-path", F ? `url(${this.renderer.url}#${F.id})` : "none");
        }
        crisp(F, U) {
          U = Math.round(U || F.strokeWidth || 0);
          let Q = F.x || this.x || 0, J = F.y || this.y || 0, ee = (F.width || this.width || 0) + Q, V = (F.height || this.height || 0) + J, G = S(Q, U), W = S(J, U);
          return A(F, { x: G, y: W, width: S(ee, U) - G, height: S(V, U) - W }), x(F.strokeWidth) && (F.strokeWidth = U), F;
        }
        complexColor(F, U, Q) {
          let J = this.renderer, ee, V, G, W, ae, z, q, Z, ne, ie, re = [], de;
          $(this.renderer, "complexColor", { args: arguments }, function() {
            if (F.radialGradient ? V = "radialGradient" : F.linearGradient && (V = "linearGradient"), V) {
              if (G = F[V], ae = J.gradients, z = F.stops, ne = Q.radialReference, j(G) && (F[V] = G = { x1: G[0], y1: G[1], x2: G[2], y2: G[3], gradientUnits: "userSpaceOnUse" }), V === "radialGradient" && ne && !x(G.gradientUnits) && (W = G, G = C(G, J.getRadialAttr(ne, W), { gradientUnits: "userSpaceOnUse" })), b(G, function(me, ce) {
                ce !== "id" && re.push(ce, me);
              }), b(z, function(me) {
                re.push(me);
              }), ae[re = re.join(",")])
                ie = ae[re].attr("id");
              else {
                G.id = ie = I();
                let me = ae[re] = J.createElement(V).attr(G).add(J.defs);
                me.radAttr = W, me.stops = [], z.forEach(function(ce) {
                  ce[1].indexOf("rgba") === 0 ? (q = (ee = a.parse(ce[1])).get("rgb"), Z = ee.get("a")) : (q = ce[1], Z = 1);
                  let pe = J.createElement("stop").attr({ offset: ce[0], "stop-color": q, "stop-opacity": Z }).add(me);
                  me.stops.push(pe);
                });
              }
              de = "url(" + J.url + "#" + ie + ")", Q.setAttribute(U, de), Q.gradient = re, F.toString = function() {
                return de;
              };
            }
          });
        }
        css(F) {
          let U = this.styles, Q = {}, J = this.element, ee, V = !U;
          if (U && b(F, function(G, W) {
            U && U[W] !== G && (Q[W] = G, V = !0);
          }), V) {
            U && (F = A(U, Q)), F.width === null || F.width === "auto" ? delete this.textWidth : J.nodeName.toLowerCase() === "text" && F.width && (ee = this.textWidth = L(F.width)), A(this.styles, F), ee && !h && this.renderer.forExport && delete F.width;
            let G = C(F);
            J.namespaceURI === this.SVG_NS && (["textOutline", "textOverflow", "width"].forEach((W) => G && delete G[W]), G.color && (G.fill = G.color)), w(J, G);
          }
          return this.added && (this.element.nodeName === "text" && this.renderer.buildText(this), F.textOutline && this.applyTextOutline(F.textOutline)), this;
        }
        dashstyleSetter(F) {
          let U, Q = this["stroke-width"];
          if (Q === "inherit" && (Q = 1), F = F && F.toLowerCase()) {
            let J = F.replace("shortdashdotdot", "3,1,1,1,1,1,").replace("shortdashdot", "3,1,1,1").replace("shortdot", "1,1,").replace("shortdash", "3,1,").replace("longdash", "8,3,").replace(/dot/g, "1,3,").replace("dash", "4,3,").replace(/,$/, "").split(",");
            for (U = J.length; U--; )
              J[U] = "" + L(J[U]) * p(Q, NaN);
            F = J.join(",").replace(/NaN/g, "none"), this.element.setAttribute("stroke-dasharray", F);
          }
        }
        destroy() {
          let F = this, U = F.element || {}, Q = F.renderer, J = U.ownerSVGElement, ee = U.nodeName === "SPAN" && F.parentGroup || void 0, V, G;
          if (U.onclick = U.onmouseout = U.onmouseover = U.onmousemove = U.point = null, y(F), F.clipPath && J) {
            let W = F.clipPath;
            [].forEach.call(J.querySelectorAll("[clip-path],[CLIP-PATH]"), function(ae) {
              ae.getAttribute("clip-path").indexOf(W.element.id) > -1 && ae.removeAttribute("clip-path");
            }), F.clipPath = W.destroy();
          }
          if (F.connector = F.connector?.destroy(), F.stops) {
            for (G = 0; G < F.stops.length; G++)
              F.stops[G].destroy();
            F.stops.length = 0, F.stops = void 0;
          }
          for (F.safeRemoveChild(U); ee && ee.div && ee.div.childNodes.length === 0; )
            V = ee.parentGroup, F.safeRemoveChild(ee.div), delete ee.div, ee = V;
          F.alignOptions && k(Q.alignedObjects, F), b(F, function(W, ae) {
            F[ae] && F[ae].parentGroup === F && F[ae].destroy && F[ae].destroy(), delete F[ae];
          });
        }
        dSetter(F, U, Q) {
          j(F) && (typeof F[0] == "string" && (F = this.renderer.pathToSegments(F)), this.pathArray = F, F = F.reduce((J, ee, V) => ee && ee.join ? (V ? J + " " : "") + ee.join(" ") : (ee || "").toString(), "")), /(NaN| {2}|^$)/.test(F) && (F = "M 0 0"), this[U] !== F && (Q.setAttribute(U, F), this[U] = F);
        }
        fillSetter(F, U, Q) {
          typeof F == "string" ? Q.setAttribute(U, F) : F && this.complexColor(F, U, Q);
        }
        hrefSetter(F, U, Q) {
          Q.setAttributeNS("http://www.w3.org/1999/xlink", U, F);
        }
        getBBox(F, U) {
          let Q, J, ee, V, { alignValue: G, element: W, renderer: ae, styles: z, textStr: q } = this, { cache: Z, cacheKeys: ne } = ae, ie = W.namespaceURI === this.SVG_NS, re = p(U, this.rotation, 0), de = ae.styledMode ? W && R.prototype.getStyle.call(W, "font-size") : z.fontSize;
          if (x(q) && ((V = q.toString()).indexOf("<") === -1 && (V = V.replace(/\d/g, "0")), V += ["", ae.rootFontSize, de, re, this.textWidth, G, z.textOverflow, z.fontWeight].join(",")), V && !F && (Q = Z[V]), !Q || Q.polygon) {
            if (ie || ae.forExport) {
              try {
                ee = this.fakeTS && function(ce) {
                  let pe = W.querySelector(".highcharts-text-outline");
                  pe && w(pe, { display: ce });
                }, N(ee) && ee("none"), Q = W.getBBox ? A({}, W.getBBox()) : { width: W.offsetWidth, height: W.offsetHeight, x: 0, y: 0 }, N(ee) && ee("");
              } catch {
              }
              (!Q || Q.width < 0) && (Q = { x: 0, y: 0, width: 0, height: 0 });
            } else
              Q = this.htmlGetBBox();
            J = Q.height, ie && (Q.height = J = { "11px,17": 14, "13px,20": 16 }[`${de || ""},${Math.round(J)}`] || J), re && (Q = this.getRotatedBox(Q, re));
            let me = { bBox: Q };
            $(this, "afterGetBBox", me), Q = me.bBox;
          }
          if (V && (q === "" || Q.height > 0)) {
            for (; ne.length > 250; )
              delete Z[ne.shift()];
            Z[V] || ne.push(V), Z[V] = Q;
          }
          return Q;
        }
        getRotatedBox(F, U) {
          let { x: Q, y: J, width: ee, height: V } = F, { alignValue: G, translateY: W, rotationOriginX: ae = 0, rotationOriginY: z = 0 } = this, q = { right: 1, center: 0.5 }[G || 0] || 0, Z = Number(this.element.getAttribute("y") || 0) - (W ? 0 : J), ne = U * u, ie = (U - 90) * u, re = Math.cos(ne), de = Math.sin(ne), me = ee * re, ce = ee * de, pe = Math.cos(ie), xe = Math.sin(ie), [[le, se], [he, ve]] = [ae, z].map((Ye) => [Ye - Ye * re, Ye * de]), ye = Q + q * (ee - me) + le + ve + Z * pe, be = ye + me, ke = be - V * pe, we = ke - me, Le = J + Z - q * ce - se + he + Z * xe, Me = Le + ce, De = Me - V * xe, Ae = De - ce, _e = Math.min(ye, be, ke, we), He = Math.min(Le, Me, De, Ae), Ee = Math.max(ye, be, ke, we) - _e, Ne = Math.max(Le, Me, De, Ae) - He;
          return { x: _e, y: He, width: Ee, height: Ne, polygon: [[ye, Le], [be, Me], [ke, De], [we, Ae]] };
        }
        getStyle(F) {
          return g.getComputedStyle(this.element || this, "").getPropertyValue(F);
        }
        hasClass(F) {
          return ("" + this.attr("class")).split(" ").indexOf(F) !== -1;
        }
        hide() {
          return this.attr({ visibility: "hidden" });
        }
        htmlGetBBox() {
          return { height: 0, width: 0, x: 0, y: 0 };
        }
        constructor(F, U) {
          this.onEvents = {}, this.opacity = 1, this.SVG_NS = c, this.element = U === "span" || U === "body" ? f(U) : m.createElementNS(this.SVG_NS, U), this.renderer = F, this.styles = {}, $(this, "afterInit");
        }
        on(F, U) {
          let { onEvents: Q } = this;
          return Q[F] && Q[F](), Q[F] = v(this.element, F, U), this;
        }
        opacitySetter(F, U, Q) {
          let J = Number(Number(F).toFixed(3));
          this.opacity = J, Q.setAttribute(U, J);
        }
        reAlign() {
          this.alignOptions?.width && this.alignOptions.align !== "left" && (this.alignOptions.width = this.getBBox().width, this.placed = !1, this.align());
        }
        removeClass(F) {
          return this.attr("class", ("" + this.attr("class")).replace(D(F) ? RegExp(`(^| )${F}( |$)`) : F, " ").replace(/ +/g, " ").trim());
        }
        removeTextOutline() {
          let F = this.element.querySelector("tspan.highcharts-text-outline");
          F && this.safeRemoveChild(F);
        }
        safeRemoveChild(F) {
          let U = F.parentNode;
          U && U.removeChild(F);
        }
        setRadialReference(F) {
          let U = this.element.gradient && this.renderer.gradients[this.element.gradient];
          return this.element.radialReference = F, U && U.radAttr && U.animate(this.renderer.getRadialAttr(F, U.radAttr)), this;
        }
        shadow(F) {
          let { renderer: U } = this, Q = C(this.parentGroup?.rotation === 90 ? { offsetX: -1, offsetY: -1 } : {}, M(F) ? F : {}), J = U.shadowDefinition(Q);
          return this.attr({ filter: F ? `url(${U.url}#${J})` : "none" });
        }
        show(F = !0) {
          return this.attr({ visibility: F ? "inherit" : "visible" });
        }
        "stroke-widthSetter"(F, U, Q) {
          this[U] = F, Q.setAttribute(U, F);
        }
        strokeWidth() {
          if (!this.renderer.styledMode)
            return this["stroke-width"] || 0;
          let F = this.getStyle("stroke-width"), U = 0, Q;
          return /px$/.test(F) ? U = L(F) : F !== "" && (P(Q = m.createElementNS(c, "rect"), { width: F, "stroke-width": 0 }), this.element.parentNode.appendChild(Q), U = Q.getBBox().width, Q.parentNode.removeChild(Q)), U;
        }
        symbolAttr(F) {
          let U = this;
          R.symbolCustomAttribs.forEach(function(Q) {
            U[Q] = p(F[Q], U[Q]);
          }), U.attr({ d: U.renderer.symbols[U.symbolName](U.x, U.y, U.width, U.height, U) });
        }
        textSetter(F) {
          F !== this.textStr && (delete this.textPxLength, this.textStr = F, this.added && this.renderer.buildText(this), this.reAlign());
        }
        titleSetter(F) {
          let U = this.element, Q = U.getElementsByTagName("title")[0] || m.createElementNS(this.SVG_NS, "title");
          U.insertBefore ? U.insertBefore(Q, U.firstChild) : U.appendChild(Q), Q.textContent = T(p(F, ""), [/<[^>]*>/g, ""]).replace(/&lt;/g, "<").replace(/&gt;/g, ">");
        }
        toFront() {
          let F = this.element;
          return F.parentNode.appendChild(F), this;
        }
        translate(F, U) {
          return this.attr({ translateX: F, translateY: U });
        }
        updateTransform(F = "transform") {
          let { element: U, matrix: Q, rotation: J = 0, rotationOriginX: ee, rotationOriginY: V, scaleX: G, scaleY: W, translateX: ae = 0, translateY: z = 0 } = this, q = ["translate(" + ae + "," + z + ")"];
          x(Q) && q.push("matrix(" + Q.join(",") + ")"), J && (q.push("rotate(" + J + " " + p(ee, U.getAttribute("x"), 0) + " " + p(V, U.getAttribute("y") || 0) + ")"), this.text?.element.tagName === "SPAN" && this.text.attr({ rotation: J, rotationOriginX: (ee || 0) - this.padding, rotationOriginY: (V || 0) - this.padding })), (x(G) || x(W)) && q.push("scale(" + p(G, 1) + " " + p(W, 1) + ")"), q.length && !(this.text || this).textPath && U.setAttribute(F, q.join(" "));
        }
        visibilitySetter(F, U, Q) {
          F === "inherit" ? Q.removeAttribute(U) : this[U] !== F && Q.setAttribute(U, F), this[U] = F;
        }
        xGetter(F) {
          return this.element.nodeName === "circle" && (F === "x" ? F = "cx" : F === "y" && (F = "cy")), this._defaultGetter(F);
        }
        zIndexSetter(F, U) {
          let Q = this.renderer, J = this.parentGroup, ee = (J || Q).element || Q.box, V = this.element, G = ee === Q.box, W, ae, z, q = !1, Z, ne = this.added, ie;
          if (x(F) ? (V.setAttribute("data-z-index", F), F = +F, this[U] === F && (ne = !1)) : x(this[U]) && V.removeAttribute("data-z-index"), this[U] = F, ne) {
            for ((F = this.zIndex) && J && (J.handleZ = !0), ie = (W = ee.childNodes).length - 1; ie >= 0 && !q; ie--)
              Z = !x(z = (ae = W[ie]).getAttribute("data-z-index")), ae !== V && (F < 0 && Z && !G && !ie ? (ee.insertBefore(V, W[ie]), q = !0) : (L(z) <= F || Z && (!x(F) || F >= 0)) && (ee.insertBefore(V, W[ie + 1]), q = !0));
            q || (ee.insertBefore(V, W[G ? 3 : 0]), q = !0);
          }
          return q;
        }
      }
      return R.symbolCustomAttribs = ["anchorX", "anchorY", "clockwise", "end", "height", "innerR", "r", "start", "width", "x", "y"], R.prototype.strokeSetter = R.prototype.fillSetter, R.prototype.yGetter = R.prototype.xGetter, R.prototype.matrixSetter = R.prototype.rotationOriginXSetter = R.prototype.rotationOriginYSetter = R.prototype.rotationSetter = R.prototype.scaleXSetter = R.prototype.scaleYSetter = R.prototype.translateXSetter = R.prototype.translateYSetter = R.prototype.verticalAlignSetter = function(Y, F) {
        this[F] = Y, this.doTransform = !0;
      }, R;
    }), i(n, "Core/Renderer/SVG/SVGLabel.js", [n["Core/Renderer/SVG/SVGElement.js"], n["Core/Utilities.js"]], function(o, a) {
      let { defined: r, extend: s, isNumber: l, merge: d, pick: y, removeEvent: u } = a;
      class m extends o {
        constructor(c, g, v, P, f, S, w, x, k, A) {
          let $;
          super(c, "g"), this.paddingLeftSetter = this.paddingSetter, this.paddingRightSetter = this.paddingSetter, this.doUpdate = !1, this.textStr = g, this.x = v, this.y = P, this.anchorX = S, this.anchorY = w, this.baseline = k, this.className = A, this.addClass(A === "button" ? "highcharts-no-tooltip" : "highcharts-label"), A && this.addClass("highcharts-" + A), this.text = c.text(void 0, 0, 0, x).attr({ zIndex: 1 }), typeof f == "string" && (($ = /^url\((.*?)\)$/.test(f)) || this.renderer.symbols[f]) && (this.symbolKey = f), this.bBox = m.emptyBBox, this.padding = 3, this.baselineOffset = 0, this.needsBox = c.styledMode || $, this.deferredAttr = {}, this.alignFactor = 0;
        }
        alignSetter(c) {
          let g = { left: 0, center: 0.5, right: 1 }[c];
          g !== this.alignFactor && (this.alignFactor = g, this.bBox && l(this.xSetting) && this.attr({ x: this.xSetting }));
        }
        anchorXSetter(c, g) {
          this.anchorX = c, this.boxAttr(g, Math.round(c) - this.getCrispAdjust() - this.xSetting);
        }
        anchorYSetter(c, g) {
          this.anchorY = c, this.boxAttr(g, c - this.ySetting);
        }
        boxAttr(c, g) {
          this.box ? this.box.attr(c, g) : this.deferredAttr[c] = g;
        }
        css(c) {
          if (c) {
            let g = {};
            c = d(c), m.textProps.forEach((v) => {
              c[v] !== void 0 && (g[v] = c[v], delete c[v]);
            }), this.text.css(g), "fontSize" in g || "fontWeight" in g ? this.updateTextPadding() : ("width" in g || "textOverflow" in g) && this.updateBoxSize();
          }
          return o.prototype.css.call(this, c);
        }
        destroy() {
          u(this.element, "mouseenter"), u(this.element, "mouseleave"), this.text && this.text.destroy(), this.box && (this.box = this.box.destroy()), o.prototype.destroy.call(this);
        }
        fillSetter(c, g) {
          c && (this.needsBox = !0), this.fill = c, this.boxAttr(g, c);
        }
        getBBox(c, g) {
          this.textStr && this.bBox.width === 0 && this.bBox.height === 0 && this.updateBoxSize();
          let { padding: v, height: P = 0, translateX: f = 0, translateY: S = 0, width: w = 0 } = this, x = y(this.paddingLeft, v), k = g ?? (this.rotation || 0), A = { width: w, height: P, x: f + this.bBox.x - x, y: S + this.bBox.y - v + this.baselineOffset };
          return k && (A = this.getRotatedBox(A, k)), A;
        }
        getCrispAdjust() {
          return (this.renderer.styledMode && this.box ? this.box.strokeWidth() : this["stroke-width"] ? parseInt(this["stroke-width"], 10) : 0) % 2 / 2;
        }
        heightSetter(c) {
          this.heightSetting = c, this.doUpdate = !0;
        }
        afterSetters() {
          super.afterSetters(), this.doUpdate && (this.updateBoxSize(), this.doUpdate = !1);
        }
        onAdd() {
          this.text.add(this), this.attr({ text: y(this.textStr, ""), x: this.x || 0, y: this.y || 0 }), this.box && r(this.anchorX) && this.attr({ anchorX: this.anchorX, anchorY: this.anchorY });
        }
        paddingSetter(c, g) {
          l(c) ? c !== this[g] && (this[g] = c, this.updateTextPadding()) : this[g] = void 0;
        }
        rSetter(c, g) {
          this.boxAttr(g, c);
        }
        strokeSetter(c, g) {
          this.stroke = c, this.boxAttr(g, c);
        }
        "stroke-widthSetter"(c, g) {
          c && (this.needsBox = !0), this["stroke-width"] = c, this.boxAttr(g, c);
        }
        "text-alignSetter"(c) {
          this.textAlign = c;
        }
        textSetter(c) {
          c !== void 0 && this.text.attr({ text: c }), this.updateTextPadding(), this.reAlign();
        }
        updateBoxSize() {
          let c, g = this.text, v = {}, P = this.padding, f = this.bBox = (!l(this.widthSetting) || !l(this.heightSetting) || this.textAlign) && r(g.textStr) ? g.getBBox(void 0, 0) : m.emptyBBox;
          this.width = this.getPaddedWidth(), this.height = (this.heightSetting || f.height || 0) + 2 * P;
          let S = this.renderer.fontMetrics(g);
          if (this.baselineOffset = P + Math.min((this.text.firstLineMetrics || S).b, f.height || 1 / 0), this.heightSetting && (this.baselineOffset += (this.heightSetting - S.h) / 2), this.needsBox && !g.textPath) {
            if (!this.box) {
              let w = this.box = this.symbolKey ? this.renderer.symbol(this.symbolKey) : this.renderer.rect();
              w.addClass((this.className === "button" ? "" : "highcharts-label-box") + (this.className ? " highcharts-" + this.className + "-box" : "")), w.add(this);
            }
            c = this.getCrispAdjust(), v.x = c, v.y = (this.baseline ? -this.baselineOffset : 0) + c, v.width = Math.round(this.width), v.height = Math.round(this.height), this.box.attr(s(v, this.deferredAttr)), this.deferredAttr = {};
          }
        }
        updateTextPadding() {
          let c = this.text;
          if (!c.textPath) {
            this.updateBoxSize();
            let g = this.baseline ? 0 : this.baselineOffset, v = y(this.paddingLeft, this.padding);
            r(this.widthSetting) && this.bBox && (this.textAlign === "center" || this.textAlign === "right") && (v += { center: 0.5, right: 1 }[this.textAlign] * (this.widthSetting - this.bBox.width)), (v !== c.x || g !== c.y) && (c.attr("x", v), c.hasBoxWidthChanged && (this.bBox = c.getBBox(!0)), g !== void 0 && c.attr("y", g)), c.x = v, c.y = g;
          }
        }
        widthSetter(c) {
          this.widthSetting = l(c) ? c : void 0, this.doUpdate = !0;
        }
        getPaddedWidth() {
          let c = this.padding, g = y(this.paddingLeft, c), v = y(this.paddingRight, c);
          return (this.widthSetting || this.bBox.width || 0) + g + v;
        }
        xSetter(c) {
          this.x = c, this.alignFactor && (c -= this.alignFactor * this.getPaddedWidth(), this["forceAnimate:x"] = !0), this.xSetting = Math.round(c), this.attr("translateX", this.xSetting);
        }
        ySetter(c) {
          this.ySetting = this.y = Math.round(c), this.attr("translateY", this.ySetting);
        }
      }
      return m.emptyBBox = { width: 0, height: 0, x: 0, y: 0 }, m.textProps = ["color", "direction", "fontFamily", "fontSize", "fontStyle", "fontWeight", "lineHeight", "textAlign", "textDecoration", "textOutline", "textOverflow", "whiteSpace", "width"], m;
    }), i(n, "Core/Renderer/SVG/Symbols.js", [n["Core/Utilities.js"]], function(o) {
      let { defined: a, isNumber: r, pick: s } = o;
      function l(u, m, h, c, g) {
        let v = [];
        if (g) {
          let P = g.start || 0, f = s(g.r, h), S = s(g.r, c || h), w = 2e-4 / (g.borderRadius ? 1 : Math.max(f, 1)), x = Math.abs((g.end || 0) - P - 2 * Math.PI) < w, k = (g.end || 0) - (x ? w : 0), A = g.innerR, $ = s(g.open, x), j = Math.cos(P), N = Math.sin(P), M = Math.cos(k), D = Math.sin(k), C = s(g.longArc, k - P - Math.PI < w ? 0 : 1), b = ["A", f, S, 0, C, s(g.clockwise, 1), u + f * M, m + S * D];
          b.params = { start: P, end: k, cx: u, cy: m }, v.push(["M", u + f * j, m + S * N], b), a(A) && ((b = ["A", A, A, 0, C, a(g.clockwise) ? 1 - g.clockwise : 0, u + A * j, m + A * N]).params = { start: k, end: P, cx: u, cy: m }, v.push($ ? ["M", u + A * M, m + A * D] : ["L", u + A * M, m + A * D], b)), $ || v.push(["Z"]);
        }
        return v;
      }
      function d(u, m, h, c, g) {
        return g && g.r ? y(u, m, h, c, g) : [["M", u, m], ["L", u + h, m], ["L", u + h, m + c], ["L", u, m + c], ["Z"]];
      }
      function y(u, m, h, c, g) {
        let v = g?.r || 0;
        return [["M", u + v, m], ["L", u + h - v, m], ["A", v, v, 0, 0, 1, u + h, m + v], ["L", u + h, m + c - v], ["A", v, v, 0, 0, 1, u + h - v, m + c], ["L", u + v, m + c], ["A", v, v, 0, 0, 1, u, m + c - v], ["L", u, m + v], ["A", v, v, 0, 0, 1, u + v, m], ["Z"]];
      }
      return { arc: l, callout: function(u, m, h, c, g) {
        let v = Math.min(g && g.r || 0, h, c), P = v + 6, f = g && g.anchorX, S = g && g.anchorY || 0, w = y(u, m, h, c, { r: v });
        if (!r(f) || f < h && f > 0 && S < c && S > 0)
          return w;
        if (u + f > h - P)
          if (S > m + P && S < m + c - P)
            w.splice(3, 1, ["L", u + h, S - 6], ["L", u + h + 6, S], ["L", u + h, S + 6], ["L", u + h, m + c - v]);
          else if (f < h) {
            let x = S < m + P, k = x ? m : m + c;
            w.splice(x ? 2 : 5, 0, ["L", f, S], ["L", u + h - v, k]);
          } else
            w.splice(3, 1, ["L", u + h, c / 2], ["L", f, S], ["L", u + h, c / 2], ["L", u + h, m + c - v]);
        else if (u + f < P)
          if (S > m + P && S < m + c - P)
            w.splice(7, 1, ["L", u, S + 6], ["L", u - 6, S], ["L", u, S - 6], ["L", u, m + v]);
          else if (f > 0) {
            let x = S < m + P, k = x ? m : m + c;
            w.splice(x ? 1 : 6, 0, ["L", f, S], ["L", u + v, k]);
          } else
            w.splice(7, 1, ["L", u, c / 2], ["L", f, S], ["L", u, c / 2], ["L", u, m + v]);
        else
          S > c && f < h - P ? w.splice(5, 1, ["L", f + 6, m + c], ["L", f, m + c + 6], ["L", f - 6, m + c], ["L", u + v, m + c]) : S < 0 && f > P && w.splice(1, 1, ["L", f - 6, m], ["L", f, m - 6], ["L", f + 6, m], ["L", h - v, m]);
        return w;
      }, circle: function(u, m, h, c) {
        return l(u + h / 2, m + c / 2, h / 2, c / 2, { start: 0.5 * Math.PI, end: 2.5 * Math.PI, open: !1 });
      }, diamond: function(u, m, h, c) {
        return [["M", u + h / 2, m], ["L", u + h, m + c / 2], ["L", u + h / 2, m + c], ["L", u, m + c / 2], ["Z"]];
      }, rect: d, roundedRect: y, square: d, triangle: function(u, m, h, c) {
        return [["M", u + h / 2, m], ["L", u + h, m + c], ["L", u, m + c], ["Z"]];
      }, "triangle-down": function(u, m, h, c) {
        return [["M", u, m], ["L", u + h, m], ["L", u + h / 2, m + c], ["Z"]];
      } };
    }), i(n, "Core/Renderer/SVG/TextBuilder.js", [n["Core/Renderer/HTML/AST.js"], n["Core/Globals.js"], n["Core/Utilities.js"]], function(o, a, r) {
      let { doc: s, SVG_NS: l, win: d } = a, { attr: y, extend: u, fireEvent: m, isString: h, objectEach: c, pick: g } = r;
      return class {
        constructor(v) {
          let P = v.styles;
          this.renderer = v.renderer, this.svgElement = v, this.width = v.textWidth, this.textLineHeight = P && P.lineHeight, this.textOutline = P && P.textOutline, this.ellipsis = !!(P && P.textOverflow === "ellipsis"), this.noWrap = !!(P && P.whiteSpace === "nowrap");
        }
        buildSVG() {
          let v = this.svgElement, P = v.element, f = v.renderer, S = g(v.textStr, "").toString(), w = S.indexOf("<") !== -1, x = P.childNodes, k = !v.added && f.box, A = [S, this.ellipsis, this.noWrap, this.textLineHeight, this.textOutline, v.getStyle("font-size"), this.width].join(",");
          if (A !== v.textCache) {
            v.textCache = A, delete v.actualWidth;
            for (let $ = x.length; $--; )
              P.removeChild(x[$]);
            if (w || this.ellipsis || this.width || v.textPath || S.indexOf(" ") !== -1 && (!this.noWrap || /<br.*?>/g.test(S))) {
              if (S !== "") {
                k && k.appendChild(P);
                let $ = new o(S);
                this.modifyTree($.nodes), $.addToDOM(P), this.modifyDOM(), this.ellipsis && (P.textContent || "").indexOf("…") !== -1 && v.attr("title", this.unescapeEntities(v.textStr || "", ["&lt;", "&gt;"])), k && k.removeChild(P);
              }
            } else
              P.appendChild(s.createTextNode(this.unescapeEntities(S)));
            h(this.textOutline) && v.applyTextOutline && v.applyTextOutline(this.textOutline);
          }
        }
        modifyDOM() {
          let v, P = this.svgElement, f = y(P.element, "x");
          for (P.firstLineMetrics = void 0; (v = P.element.firstChild) && /^[\s\u200B]*$/.test(v.textContent || " "); )
            P.element.removeChild(v);
          [].forEach.call(P.element.querySelectorAll("tspan.highcharts-br"), (k, A) => {
            k.nextSibling && k.previousSibling && (A === 0 && k.previousSibling.nodeType === 1 && (P.firstLineMetrics = P.renderer.fontMetrics(k.previousSibling)), y(k, { dy: this.getLineHeight(k.nextSibling), x: f }));
          });
          let S = this.width || 0;
          if (!S)
            return;
          let w = (k, A) => {
            let $ = k.textContent || "", j = $.replace(/([^\^])-/g, "$1- ").split(" "), N = !this.noWrap && (j.length > 1 || P.element.childNodes.length > 1), M = this.getLineHeight(A), D = 0, C = P.actualWidth;
            if (this.ellipsis)
              $ && this.truncate(k, $, void 0, 0, Math.max(0, S - 0.8 * M), (b, p) => b.substring(0, p) + "…");
            else if (N) {
              let b = [], p = [];
              for (; A.firstChild && A.firstChild !== k; )
                p.push(A.firstChild), A.removeChild(A.firstChild);
              for (; j.length; )
                j.length && !this.noWrap && D > 0 && (b.push(k.textContent || ""), k.textContent = j.join(" ").replace(/- /g, "-")), this.truncate(k, void 0, j, D === 0 && C || 0, S, (L, B) => j.slice(0, B).join(" ").replace(/- /g, "-")), C = P.actualWidth, D++;
              p.forEach((L) => {
                A.insertBefore(L, k);
              }), b.forEach((L) => {
                A.insertBefore(s.createTextNode(L), k);
                let B = s.createElementNS(l, "tspan");
                B.textContent = "​", y(B, { dy: M, x: f }), A.insertBefore(B, k);
              });
            }
          }, x = (k) => {
            [].slice.call(k.childNodes).forEach((A) => {
              A.nodeType === d.Node.TEXT_NODE ? w(A, k) : (A.className.baseVal.indexOf("highcharts-br") !== -1 && (P.actualWidth = 0), x(A));
            });
          };
          x(P.element);
        }
        getLineHeight(v) {
          let P = v.nodeType === d.Node.TEXT_NODE ? v.parentElement : v;
          return this.textLineHeight ? parseInt(this.textLineHeight.toString(), 10) : this.renderer.fontMetrics(P || this.svgElement.element).h;
        }
        modifyTree(v) {
          let P = (f, S) => {
            let { attributes: w = {}, children: x, style: k = {}, tagName: A } = f, $ = this.renderer.styledMode;
            if (A === "b" || A === "strong" ? $ ? w.class = "highcharts-strong" : k.fontWeight = "bold" : (A === "i" || A === "em") && ($ ? w.class = "highcharts-emphasized" : k.fontStyle = "italic"), k && k.color && (k.fill = k.color), A === "br") {
              w.class = "highcharts-br", f.textContent = "​";
              let j = v[S + 1];
              j && j.textContent && (j.textContent = j.textContent.replace(/^ +/gm, ""));
            } else
              A === "a" && x && x.some((j) => j.tagName === "#text") && (f.children = [{ children: x, tagName: "tspan" }]);
            A !== "#text" && A !== "a" && (f.tagName = "tspan"), u(f, { attributes: w, style: k }), x && x.filter((j) => j.tagName !== "#text").forEach(P);
          };
          v.forEach(P), m(this.svgElement, "afterModifyTree", { nodes: v });
        }
        truncate(v, P, f, S, w, x) {
          let k, A, $ = this.svgElement, { rotation: j } = $, N = [], M = f ? 1 : 0, D = (P || f || "").length, C = D, b = function(p, L) {
            let B = L || p, T = v.parentNode;
            if (T && N[B] === void 0 && T.getSubStringLength)
              try {
                N[B] = S + T.getSubStringLength(0, f ? B + 1 : B);
              } catch {
              }
            return N[B];
          };
          if ($.rotation = 0, S + (A = b(v.textContent.length)) > w) {
            for (; M <= D; )
              C = Math.ceil((M + D) / 2), f && (k = x(f, C)), A = b(C, k && k.length - 1), M === D ? M = D + 1 : A > w ? D = C - 1 : M = C;
            D === 0 ? v.textContent = "" : P && D === P.length - 1 || (v.textContent = k || x(P || f, C));
          }
          f && f.splice(0, C), $.actualWidth = A, $.rotation = j;
        }
        unescapeEntities(v, P) {
          return c(this.renderer.escapes, function(f, S) {
            P && P.indexOf(f) !== -1 || (v = v.toString().replace(RegExp(f, "g"), S));
          }), v;
        }
      };
    }), i(n, "Core/Renderer/SVG/SVGRenderer.js", [n["Core/Renderer/HTML/AST.js"], n["Core/Defaults.js"], n["Core/Color/Color.js"], n["Core/Globals.js"], n["Core/Renderer/RendererRegistry.js"], n["Core/Renderer/SVG/SVGElement.js"], n["Core/Renderer/SVG/SVGLabel.js"], n["Core/Renderer/SVG/Symbols.js"], n["Core/Renderer/SVG/TextBuilder.js"], n["Core/Utilities.js"]], function(o, a, r, s, l, d, y, u, m, h) {
      let c, { defaultOptions: g } = a, { charts: v, deg2rad: P, doc: f, isFirefox: S, isMS: w, isWebKit: x, noop: k, SVG_NS: A, symbolSizes: $, win: j } = s, { addEvent: N, attr: M, createElement: D, crisp: C, css: b, defined: p, destroyObjectProperties: L, extend: B, isArray: T, isNumber: O, isObject: I, isString: R, merge: Y, pick: F, pInt: U, replaceNested: Q, uniqueKey: J } = h;
      class ee {
        constructor(G, W, ae, z, q, Z, ne) {
          let ie, re, de = this.createElement("svg").attr({ version: "1.1", class: "highcharts-root" }), me = de.element;
          ne || de.css(this.getStyle(z || {})), G.appendChild(me), M(G, "dir", "ltr"), G.innerHTML.indexOf("xmlns") === -1 && M(me, "xmlns", this.SVG_NS), this.box = me, this.boxWrapper = de, this.alignedObjects = [], this.url = this.getReferenceURL(), this.createElement("desc").add().element.appendChild(f.createTextNode("Created with Highcharts 11.4.8")), this.defs = this.createElement("defs").add(), this.allowHTML = Z, this.forExport = q, this.styledMode = ne, this.gradients = {}, this.cache = {}, this.cacheKeys = [], this.imgCount = 0, this.rootFontSize = de.getStyle("font-size"), this.setSize(W, ae, !1), S && G.getBoundingClientRect && ((ie = function() {
            b(G, { left: 0, top: 0 }), re = G.getBoundingClientRect(), b(G, { left: Math.ceil(re.left) - re.left + "px", top: Math.ceil(re.top) - re.top + "px" });
          })(), this.unSubPixelFix = N(j, "resize", ie));
        }
        definition(G) {
          return new o([G]).addToDOM(this.defs.element);
        }
        getReferenceURL() {
          if ((S || x) && f.getElementsByTagName("base").length) {
            if (!p(c)) {
              let G = J(), W = new o([{ tagName: "svg", attributes: { width: 8, height: 8 }, children: [{ tagName: "defs", children: [{ tagName: "clipPath", attributes: { id: G }, children: [{ tagName: "rect", attributes: { width: 4, height: 4 } }] }] }, { tagName: "rect", attributes: { id: "hitme", width: 8, height: 8, "clip-path": `url(#${G})`, fill: "rgba(0,0,0,0.001)" } }] }]).addToDOM(f.body);
              b(W, { position: "fixed", top: 0, left: 0, zIndex: 9e5 });
              let ae = f.elementFromPoint(6, 6);
              c = (ae && ae.id) === "hitme", f.body.removeChild(W);
            }
            if (c)
              return Q(j.location.href.split("#")[0], [/<[^>]*>/g, ""], [/([\('\)])/g, "\\$1"], [/ /g, "%20"]);
          }
          return "";
        }
        getStyle(G) {
          return this.style = B({ fontFamily: "Helvetica, Arial, sans-serif", fontSize: "1rem" }, G), this.style;
        }
        setStyle(G) {
          this.boxWrapper.css(this.getStyle(G));
        }
        isHidden() {
          return !this.boxWrapper.getBBox().width;
        }
        destroy() {
          let G = this.defs;
          return this.box = null, this.boxWrapper = this.boxWrapper.destroy(), L(this.gradients || {}), this.gradients = null, this.defs = G.destroy(), this.unSubPixelFix && this.unSubPixelFix(), this.alignedObjects = null, null;
        }
        createElement(G) {
          return new this.Element(this, G);
        }
        getRadialAttr(G, W) {
          return { cx: G[0] - G[2] / 2 + (W.cx || 0) * G[2], cy: G[1] - G[2] / 2 + (W.cy || 0) * G[2], r: (W.r || 0) * G[2] };
        }
        shadowDefinition(G) {
          let W = [`highcharts-drop-shadow-${this.chartIndex}`, ...Object.keys(G).map((z) => `${z}-${G[z]}`)].join("-").toLowerCase().replace(/[^a-z\d\-]/g, ""), ae = Y({ color: "#000000", offsetX: 1, offsetY: 1, opacity: 0.15, width: 5 }, G);
          return this.defs.element.querySelector(`#${W}`) || this.definition({ tagName: "filter", attributes: { id: W, filterUnits: ae.filterUnits }, children: this.getShadowFilterContent(ae) }), W;
        }
        getShadowFilterContent(G) {
          return [{ tagName: "feDropShadow", attributes: { dx: G.offsetX, dy: G.offsetY, "flood-color": G.color, "flood-opacity": Math.min(5 * G.opacity, 1), stdDeviation: G.width / 2 } }];
        }
        buildText(G) {
          new m(G).buildSVG();
        }
        getContrast(G) {
          let W = r.parse(G).rgba.map((z) => {
            let q = z / 255;
            return q <= 0.03928 ? q / 12.92 : Math.pow((q + 0.055) / 1.055, 2.4);
          }), ae = 0.2126 * W[0] + 0.7152 * W[1] + 0.0722 * W[2];
          return 1.05 / (ae + 0.05) > (ae + 0.05) / 0.05 ? "#FFFFFF" : "#000000";
        }
        button(G, W, ae, z, q = {}, Z, ne, ie, re, de) {
          let me = this.label(G, W, ae, re, void 0, void 0, de, void 0, "button"), ce = this.styledMode, pe = arguments, xe = 0;
          q = Y(g.global.buttonTheme, q), ce && (delete q.fill, delete q.stroke, delete q["stroke-width"]);
          let le = q.states || {}, se = q.style || {};
          delete q.states, delete q.style;
          let he = [o.filterUserAttributes(q)], ve = [se];
          return ce || ["hover", "select", "disabled"].forEach((ye, be) => {
            he.push(Y(he[0], o.filterUserAttributes(pe[be + 5] || le[ye] || {}))), ve.push(he[be + 1].style), delete he[be + 1].style;
          }), N(me.element, w ? "mouseover" : "mouseenter", function() {
            xe !== 3 && me.setState(1);
          }), N(me.element, w ? "mouseout" : "mouseleave", function() {
            xe !== 3 && me.setState(xe);
          }), me.setState = (ye = 0) => {
            if (ye !== 1 && (me.state = xe = ye), me.removeClass(/highcharts-button-(normal|hover|pressed|disabled)/).addClass("highcharts-button-" + ["normal", "hover", "pressed", "disabled"][ye]), !ce) {
              me.attr(he[ye]);
              let be = ve[ye];
              I(be) && me.css(be);
            }
          }, me.attr(he[0]), !ce && (me.css(B({ cursor: "default" }, se)), de && me.text.css({ pointerEvents: "none" })), me.on("touchstart", (ye) => ye.stopPropagation()).on("click", function(ye) {
            xe !== 3 && z.call(me, ye);
          });
        }
        crispLine(G, W) {
          let [ae, z] = G;
          return p(ae[1]) && ae[1] === z[1] && (ae[1] = z[1] = C(ae[1], W)), p(ae[2]) && ae[2] === z[2] && (ae[2] = z[2] = C(ae[2], W)), G;
        }
        path(G) {
          let W = this.styledMode ? {} : { fill: "none" };
          return T(G) ? W.d = G : I(G) && B(W, G), this.createElement("path").attr(W);
        }
        circle(G, W, ae) {
          let z = I(G) ? G : G === void 0 ? {} : { x: G, y: W, r: ae }, q = this.createElement("circle");
          return q.xSetter = q.ySetter = function(Z, ne, ie) {
            ie.setAttribute("c" + ne, Z);
          }, q.attr(z);
        }
        arc(G, W, ae, z, q, Z) {
          let ne;
          I(G) ? (W = (ne = G).y, ae = ne.r, z = ne.innerR, q = ne.start, Z = ne.end, G = ne.x) : ne = { innerR: z, start: q, end: Z };
          let ie = this.symbol("arc", G, W, ae, ae, ne);
          return ie.r = ae, ie;
        }
        rect(G, W, ae, z, q, Z) {
          let ne = I(G) ? G : G === void 0 ? {} : { x: G, y: W, r: q, width: Math.max(ae || 0, 0), height: Math.max(z || 0, 0) }, ie = this.createElement("rect");
          return this.styledMode || (Z !== void 0 && (ne["stroke-width"] = Z, B(ne, ie.crisp(ne))), ne.fill = "none"), ie.rSetter = function(re, de, me) {
            ie.r = re, M(me, { rx: re, ry: re });
          }, ie.rGetter = function() {
            return ie.r || 0;
          }, ie.attr(ne);
        }
        roundedRect(G) {
          return this.symbol("roundedRect").attr(G);
        }
        setSize(G, W, ae) {
          this.width = G, this.height = W, this.boxWrapper.animate({ width: G, height: W }, { step: function() {
            this.attr({ viewBox: "0 0 " + this.attr("width") + " " + this.attr("height") });
          }, duration: F(ae, !0) ? void 0 : 0 }), this.alignElements();
        }
        g(G) {
          let W = this.createElement("g");
          return G ? W.attr({ class: "highcharts-" + G }) : W;
        }
        image(G, W, ae, z, q, Z) {
          let ne = { preserveAspectRatio: "none" };
          O(W) && (ne.x = W), O(ae) && (ne.y = ae), O(z) && (ne.width = z), O(q) && (ne.height = q);
          let ie = this.createElement("image").attr(ne), re = function(de) {
            ie.attr({ href: G }), Z.call(ie, de);
          };
          if (Z) {
            ie.attr({ href: "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==" });
            let de = new j.Image();
            N(de, "load", re), de.src = G, de.complete && re({});
          } else
            ie.attr({ href: G });
          return ie;
        }
        symbol(G, W, ae, z, q, Z) {
          let ne, ie, re, de, me = this, ce = /^url\((.*?)\)$/, pe = ce.test(G), xe = !pe && (this.symbols[G] ? G : "circle"), le = xe && this.symbols[xe];
          if (le)
            typeof W == "number" && (ie = le.call(this.symbols, W || 0, ae || 0, z || 0, q || 0, Z)), ne = this.path(ie), me.styledMode || ne.attr("fill", "none"), B(ne, { symbolName: xe || void 0, x: W, y: ae, width: z, height: q }), Z && B(ne, Z);
          else if (pe) {
            re = G.match(ce)[1];
            let se = ne = this.image(re);
            se.imgwidth = F(Z && Z.width, $[re] && $[re].width), se.imgheight = F(Z && Z.height, $[re] && $[re].height), de = (he) => he.attr({ width: he.width, height: he.height }), ["width", "height"].forEach((he) => {
              se[`${he}Setter`] = function(ve, ye) {
                this[ye] = ve;
                let { alignByTranslate: be, element: ke, width: we, height: Le, imgwidth: Me, imgheight: De } = this, Ae = ye === "width" ? Me : De, _e = 1;
                Z && Z.backgroundSize === "within" && we && Le && Me && De ? (_e = Math.min(we / Me, Le / De), M(ke, { width: Math.round(Me * _e), height: Math.round(De * _e) })) : ke && Ae && ke.setAttribute(ye, Ae), !be && Me && De && this.translate(((we || 0) - Me * _e) / 2, ((Le || 0) - De * _e) / 2);
              };
            }), p(W) && se.attr({ x: W, y: ae }), se.isImg = !0, se.symbolUrl = G, p(se.imgwidth) && p(se.imgheight) ? de(se) : (se.attr({ width: 0, height: 0 }), D("img", { onload: function() {
              let he = v[me.chartIndex];
              this.width === 0 && (b(this, { position: "absolute", top: "-999em" }), f.body.appendChild(this)), $[re] = { width: this.width, height: this.height }, se.imgwidth = this.width, se.imgheight = this.height, se.element && de(se), this.parentNode && this.parentNode.removeChild(this), me.imgCount--, me.imgCount || !he || he.hasLoaded || he.onload();
            }, src: re }), this.imgCount++);
          }
          return ne;
        }
        clipRect(G, W, ae, z) {
          return this.rect(G, W, ae, z, 0);
        }
        text(G, W, ae, z) {
          let q = {};
          if (z && (this.allowHTML || !this.forExport))
            return this.html(G, W, ae);
          q.x = Math.round(W || 0), ae && (q.y = Math.round(ae)), p(G) && (q.text = G);
          let Z = this.createElement("text").attr(q);
          return z && (!this.forExport || this.allowHTML) || (Z.xSetter = function(ne, ie, re) {
            let de = re.getElementsByTagName("tspan"), me = re.getAttribute(ie);
            for (let ce = 0, pe; ce < de.length; ce++)
              (pe = de[ce]).getAttribute(ie) === me && pe.setAttribute(ie, ne);
            re.setAttribute(ie, ne);
          }), Z;
        }
        fontMetrics(G) {
          let W = U(d.prototype.getStyle.call(G, "font-size") || 0), ae = W < 24 ? W + 3 : Math.round(1.2 * W), z = Math.round(0.8 * ae);
          return { h: ae, b: z, f: W };
        }
        rotCorr(G, W, ae) {
          let z = G;
          return W && ae && (z = Math.max(z * Math.cos(W * P), 4)), { x: -G / 3 * Math.sin(W * P), y: z };
        }
        pathToSegments(G) {
          let W = [], ae = [], z = { A: 8, C: 7, H: 2, L: 3, M: 3, Q: 5, S: 5, T: 3, V: 2 };
          for (let q = 0; q < G.length; q++)
            R(ae[0]) && O(G[q]) && ae.length === z[ae[0].toUpperCase()] && G.splice(q, 0, ae[0].replace("M", "L").replace("m", "l")), typeof G[q] == "string" && (ae.length && W.push(ae.slice(0)), ae.length = 0), ae.push(G[q]);
          return W.push(ae.slice(0)), W;
        }
        label(G, W, ae, z, q, Z, ne, ie, re) {
          return new y(this, G, W, ae, z, q, Z, ne, ie, re);
        }
        alignElements() {
          this.alignedObjects.forEach((G) => G.align());
        }
      }
      return B(ee.prototype, { Element: d, SVG_NS: A, escapes: { "&": "&amp;", "<": "&lt;", ">": "&gt;", "'": "&#39;", '"': "&quot;" }, symbols: u, draw: k }), l.registerRendererType("svg", ee, !0), ee;
    }), i(n, "Core/Renderer/HTML/HTMLElement.js", [n["Core/Renderer/HTML/AST.js"], n["Core/Globals.js"], n["Core/Renderer/SVG/SVGElement.js"], n["Core/Utilities.js"]], function(o, a, r, s) {
      let { composed: l } = a, { attr: d, css: y, createElement: u, defined: m, extend: h, pInt: c, pushUnique: g } = s;
      function v(w, x, k) {
        let A = this.div?.style || k.style;
        r.prototype[`${x}Setter`].call(this, w, x, k), A && (A[x] = w);
      }
      let P = (w, x) => {
        if (!w.div) {
          let k = d(w.element, "class"), A = w.css, $ = u("div", k ? { className: k } : void 0, { position: "absolute", left: `${w.translateX || 0}px`, top: `${w.translateY || 0}px`, ...w.styles, display: w.display, opacity: w.opacity, visibility: w.visibility }, w.parentGroup?.div || x);
          w.classSetter = (j, N, M) => {
            M.setAttribute("class", j), $.className = j;
          }, w.translateXSetter = w.translateYSetter = (j, N) => {
            w[N] = j, $.style[N === "translateX" ? "left" : "top"] = `${j}px`, w.doTransform = !0;
          }, w.opacitySetter = w.visibilitySetter = v, w.css = (j) => (A.call(w, j), j.cursor && ($.style.cursor = j.cursor), j.pointerEvents && ($.style.pointerEvents = j.pointerEvents), w), w.on = function() {
            return r.prototype.on.apply({ element: $, onEvents: w.onEvents }, arguments), w;
          }, w.div = $;
        }
        return w.div;
      };
      class f extends r {
        static compose(x) {
          g(l, this.compose) && (x.prototype.html = function(k, A, $) {
            return new f(this, "span").attr({ text: k, x: Math.round(A), y: Math.round($) });
          });
        }
        constructor(x, k) {
          super(x, k), this.css({ position: "absolute", ...x.styledMode ? {} : { fontFamily: x.style.fontFamily, fontSize: x.style.fontSize } }), this.element.style.whiteSpace = "nowrap";
        }
        getSpanCorrection(x, k, A) {
          this.xCorr = -x * A, this.yCorr = -k;
        }
        css(x) {
          let k, { element: A } = this, $ = A.tagName === "SPAN" && x && "width" in x, j = $ && x.width;
          return $ && (delete x.width, this.textWidth = c(j) || void 0, k = !0), x?.textOverflow === "ellipsis" && (x.whiteSpace = "nowrap", x.overflow = "hidden"), h(this.styles, x), y(A, x), k && this.updateTransform(), this;
        }
        htmlGetBBox() {
          let { element: x } = this;
          return { x: x.offsetLeft, y: x.offsetTop, width: x.offsetWidth, height: x.offsetHeight };
        }
        updateTransform() {
          if (!this.added) {
            this.alignOnAdd = !0;
            return;
          }
          let { element: x, renderer: k, rotation: A, rotationOriginX: $, rotationOriginY: j, styles: N, textAlign: M = "left", textWidth: D, translateX: C = 0, translateY: b = 0, x: p = 0, y: L = 0 } = this, B = { left: 0, center: 0.5, right: 1 }[M], T = N.whiteSpace;
          if (y(x, { marginLeft: `${C}px`, marginTop: `${b}px` }), x.tagName === "SPAN") {
            let O = [A, M, x.innerHTML, D, this.textAlign].join(","), I = -(this.parentGroup?.padding * 1) || 0, R, Y = !1;
            if (D !== this.oldTextWidth) {
              let ee = this.textPxLength ? this.textPxLength : (y(x, { width: "", whiteSpace: T || "nowrap" }), x.offsetWidth), V = D || 0;
              (V > this.oldTextWidth || ee > V) && (/[ \-]/.test(x.textContent || x.innerText) || x.style.textOverflow === "ellipsis") && (y(x, { width: ee > V || A ? D + "px" : "auto", display: "block", whiteSpace: T || "normal" }), this.oldTextWidth = D, Y = !0);
            }
            this.hasBoxWidthChanged = Y, O !== this.cTT && (R = k.fontMetrics(x).b, m(A) && (A !== (this.oldRotation || 0) || M !== this.oldAlign) && this.setSpanRotation(A, I, I), this.getSpanCorrection(!m(A) && this.textPxLength || x.offsetWidth, R, B));
            let { xCorr: F = 0, yCorr: U = 0 } = this, Q = ($ ?? p) - F - p - I, J = (j ?? L) - U - L - I;
            y(x, { left: `${p + F}px`, top: `${L + U}px`, transformOrigin: `${Q}px ${J}px` }), this.cTT = O, this.oldRotation = A, this.oldAlign = M;
          }
        }
        setSpanRotation(x, k, A) {
          y(this.element, { transform: `rotate(${x}deg)`, transformOrigin: `${k}% ${A}px` });
        }
        add(x) {
          let k, A = this.renderer.box.parentNode, $ = [];
          if (this.parentGroup = x, x && !(k = x.div)) {
            let j = x;
            for (; j; )
              $.push(j), j = j.parentGroup;
            for (let N of $.reverse())
              k = P(N, A);
          }
          return (k || A).appendChild(this.element), this.added = !0, this.alignOnAdd && this.updateTransform(), this;
        }
        textSetter(x) {
          x !== this.textStr && (delete this.bBox, delete this.oldTextWidth, o.setElementHTML(this.element, x ?? ""), this.textStr = x, this.doTransform = !0);
        }
        alignSetter(x) {
          this.alignValue = this.textAlign = x, this.doTransform = !0;
        }
        xSetter(x, k) {
          this[k] = x, this.doTransform = !0;
        }
      }
      let S = f.prototype;
      return S.visibilitySetter = S.opacitySetter = v, S.ySetter = S.rotationSetter = S.rotationOriginXSetter = S.rotationOriginYSetter = S.xSetter, f;
    }), i(n, "Core/Axis/AxisDefaults.js", [], function() {
      var o, a;
      return (a = o || (o = {})).xAxis = { alignTicks: !0, allowDecimals: void 0, panningEnabled: !0, zIndex: 2, zoomEnabled: !0, dateTimeLabelFormats: { millisecond: { main: "%H:%M:%S.%L", range: !1 }, second: { main: "%H:%M:%S", range: !1 }, minute: { main: "%H:%M", range: !1 }, hour: { main: "%H:%M", range: !1 }, day: { main: "%e %b" }, week: { main: "%e %b" }, month: { main: "%b '%y" }, year: { main: "%Y" } }, endOnTick: !1, gridLineDashStyle: "Solid", gridZIndex: 1, labels: { autoRotationLimit: 80, distance: 15, enabled: !0, indentation: 10, overflow: "justify", reserveSpace: void 0, rotation: void 0, staggerLines: 0, step: 0, useHTML: !1, zIndex: 7, style: { color: "#333333", cursor: "default", fontSize: "0.8em" } }, maxPadding: 0.01, minorGridLineDashStyle: "Solid", minorTickLength: 2, minorTickPosition: "outside", minorTicksPerMajor: 5, minPadding: 0.01, offset: void 0, reversed: void 0, reversedStacks: !1, showEmpty: !0, showFirstLabel: !0, showLastLabel: !0, startOfWeek: 1, startOnTick: !1, tickLength: 10, tickPixelInterval: 100, tickmarkPlacement: "between", tickPosition: "outside", title: { align: "middle", useHTML: !1, x: 0, y: 0, style: { color: "#666666", fontSize: "0.8em" } }, visible: !0, minorGridLineColor: "#f2f2f2", minorGridLineWidth: 1, minorTickColor: "#999999", lineColor: "#333333", lineWidth: 1, gridLineColor: "#e6e6e6", gridLineWidth: void 0, tickColor: "#333333" }, a.yAxis = { reversedStacks: !0, endOnTick: !0, maxPadding: 0.05, minPadding: 0.05, tickPixelInterval: 72, showLastLabel: !0, labels: { x: void 0 }, startOnTick: !0, title: { text: "Values" }, stackLabels: { animation: {}, allowOverlap: !1, enabled: !1, crop: !0, overflow: "justify", formatter: function() {
        let { numberFormatter: r } = this.axis.chart;
        return r(this.total || 0, -1);
      }, style: { color: "#000000", fontSize: "0.7em", fontWeight: "bold", textOutline: "1px contrast" } }, gridLineWidth: 1, lineWidth: 0 }, o;
    }), i(n, "Core/Foundation.js", [n["Core/Utilities.js"]], function(o) {
      var a;
      let { addEvent: r, isFunction: s, objectEach: l, removeEvent: d } = o;
      return (a || (a = {})).registerEventOptions = function(y, u) {
        y.eventOptions = y.eventOptions || {}, l(u.events, function(m, h) {
          y.eventOptions[h] !== m && (y.eventOptions[h] && (d(y, h, y.eventOptions[h]), delete y.eventOptions[h]), s(m) && (y.eventOptions[h] = m, r(y, h, m, { order: 0 })));
        });
      }, a;
    }), i(n, "Core/Axis/Tick.js", [n["Core/Templating.js"], n["Core/Globals.js"], n["Core/Utilities.js"]], function(o, a, r) {
      let { deg2rad: s } = a, { clamp: l, correctFloat: d, defined: y, destroyObjectProperties: u, extend: m, fireEvent: h, isNumber: c, merge: g, objectEach: v, pick: P } = r;
      return class {
        constructor(f, S, w, x, k) {
          this.isNew = !0, this.isNewLabel = !0, this.axis = f, this.pos = S, this.type = w || "", this.parameters = k || {}, this.tickmarkOffset = this.parameters.tickmarkOffset, this.options = this.parameters.options, h(this, "init"), w || x || this.addLabel();
        }
        addLabel() {
          let f = this, S = f.axis, w = S.options, x = S.chart, k = S.categories, A = S.logarithmic, $ = S.names, j = f.pos, N = P(f.options && f.options.labels, w.labels), M = S.tickPositions, D = j === M[0], C = j === M[M.length - 1], b = (!N.step || N.step === 1) && S.tickInterval === 1, p = M.info, L = f.label, B, T, O, I = this.parameters.category || (k ? P(k[j], $[j], j) : j);
          A && c(I) && (I = d(A.lin2log(I))), S.dateTime && (p ? B = (T = x.time.resolveDTLFormat(w.dateTimeLabelFormats[!w.grid && p.higherRanks[j] || p.unitName])).main : c(I) && (B = S.dateTime.getXDateFormat(I, w.dateTimeLabelFormats || {}))), f.isFirst = D, f.isLast = C;
          let R = { axis: S, chart: x, dateTimeLabelFormat: B, isFirst: D, isLast: C, pos: j, tick: f, tickPositionInfo: p, value: I };
          h(this, "labelFormat", R);
          let Y = (Q) => N.formatter ? N.formatter.call(Q, Q) : N.format ? (Q.text = S.defaultLabelFormatter.call(Q), o.format(N.format, Q, x)) : S.defaultLabelFormatter.call(Q), F = Y.call(R, R), U = T && T.list;
          U ? f.shortenLabel = function() {
            for (O = 0; O < U.length; O++)
              if (m(R, { dateTimeLabelFormat: U[O] }), L.attr({ text: Y.call(R, R) }), L.getBBox().width < S.getSlotWidth(f) - 2 * (N.padding || 0))
                return;
            L.attr({ text: "" });
          } : f.shortenLabel = void 0, b && S._addedPlotLB && f.moveLabel(F, N), y(L) || f.movedLabel ? L && L.textStr !== F && !b && (!L.textWidth || N.style.width || L.styles.width || L.css({ width: null }), L.attr({ text: F }), L.textPxLength = L.getBBox().width) : (f.label = L = f.createLabel(F, N), f.rotation = 0);
        }
        createLabel(f, S, w) {
          let x = this.axis, k = x.chart, A = y(f) && S.enabled ? k.renderer.text(f, w?.x, w?.y, S.useHTML).add(x.labelGroup) : void 0;
          return A && (k.styledMode || A.css(g(S.style)), A.textPxLength = A.getBBox().width), A;
        }
        destroy() {
          u(this, this.axis);
        }
        getPosition(f, S, w, x) {
          let k = this.axis, A = k.chart, $ = x && A.oldChartHeight || A.chartHeight, j = { x: f ? d(k.translate(S + w, void 0, void 0, x) + k.transB) : k.left + k.offset + (k.opposite ? (x && A.oldChartWidth || A.chartWidth) - k.right - k.left : 0), y: f ? $ - k.bottom + k.offset - (k.opposite ? k.height : 0) : d($ - k.translate(S + w, void 0, void 0, x) - k.transB) };
          return j.y = l(j.y, -1e9, 1e9), h(this, "afterGetPosition", { pos: j }), j;
        }
        getLabelPosition(f, S, w, x, k, A, $, j) {
          let N, M, D = this.axis, C = D.transA, b = D.isLinked && D.linkedParent ? D.linkedParent.reversed : D.reversed, p = D.staggerLines, L = D.tickRotCorr || { x: 0, y: 0 }, B = x || D.reserveSpaceDefault ? 0 : -D.labelOffset * (D.labelAlign === "center" ? 0.5 : 1), T = k.distance, O = {};
          return N = D.side === 0 ? w.rotation ? -T : -w.getBBox().height : D.side === 2 ? L.y + T : Math.cos(w.rotation * s) * (L.y - w.getBBox(!1, 0).height / 2), y(k.y) && (N = D.side === 0 && D.horiz ? k.y + N : k.y), f = f + P(k.x, [0, 1, 0, -1][D.side] * T) + B + L.x - (A && x ? A * C * (b ? -1 : 1) : 0), S = S + N - (A && !x ? A * C * (b ? 1 : -1) : 0), p && (M = $ / (j || 1) % p, D.opposite && (M = p - M - 1), S += M * (D.labelOffset / p)), O.x = f, O.y = Math.round(S), h(this, "afterGetLabelPosition", { pos: O, tickmarkOffset: A, index: $ }), O;
        }
        getLabelSize() {
          return this.label ? this.label.getBBox()[this.axis.horiz ? "height" : "width"] : 0;
        }
        getMarkPath(f, S, w, x, k = !1, A) {
          return A.crispLine([["M", f, S], ["L", f + (k ? 0 : -w), S + (k ? w : 0)]], x);
        }
        handleOverflow(f) {
          let S = this.axis, w = S.options.labels, x = f.x, k = S.chart.chartWidth, A = S.chart.spacing, $ = P(S.labelLeft, Math.min(S.pos, A[3])), j = P(S.labelRight, Math.max(S.isRadial ? 0 : S.pos + S.len, k - A[1])), N = this.label, M = this.rotation, D = { left: 0, center: 0.5, right: 1 }[S.labelAlign || N.attr("align")], C = N.getBBox().width, b = S.getSlotWidth(this), p = {}, L = b, B = 1, T, O, I;
          M || w.overflow !== "justify" ? M < 0 && x - D * C < $ ? I = Math.round(x / Math.cos(M * s) - $) : M > 0 && x + D * C > j && (I = Math.round((k - x) / Math.cos(M * s))) : (T = x - D * C, O = x + (1 - D) * C, T < $ ? L = f.x + L * (1 - D) - $ : O > j && (L = j - f.x + L * D, B = -1), (L = Math.min(b, L)) < b && S.labelAlign === "center" && (f.x += B * (b - L - D * (b - Math.min(C, L)))), (C > L || S.autoRotation && (N.styles || {}).width) && (I = L)), I && (this.shortenLabel ? this.shortenLabel() : (p.width = Math.floor(I) + "px", (w.style || {}).textOverflow || (p.textOverflow = "ellipsis"), N.css(p)));
        }
        moveLabel(f, S) {
          let w = this, x = w.label, k = w.axis, A = !1, $;
          x && x.textStr === f ? (w.movedLabel = x, A = !0, delete w.label) : v(k.ticks, function(j) {
            A || j.isNew || j === w || !j.label || j.label.textStr !== f || (w.movedLabel = j.label, A = !0, j.labelPos = w.movedLabel.xy, delete j.label);
          }), !A && (w.labelPos || x) && ($ = w.labelPos || x.xy, w.movedLabel = w.createLabel(f, S, $), w.movedLabel && w.movedLabel.attr({ opacity: 0 }));
        }
        render(f, S, w) {
          let x = this.axis, k = x.horiz, A = this.pos, $ = P(this.tickmarkOffset, x.tickmarkOffset), j = this.getPosition(k, A, $, S), N = j.x, M = j.y, D = x.pos, C = D + x.len, b = k ? N : M;
          !x.chart.polar && this.isNew && (d(b) < D || b > C) && (w = 0);
          let p = P(w, this.label && this.label.newOpacity, 1);
          w = P(w, 1), this.isActive = !0, this.renderGridLine(S, w), this.renderMark(j, w), this.renderLabel(j, S, p, f), this.isNew = !1, h(this, "afterRender");
        }
        renderGridLine(f, S) {
          let w = this.axis, x = w.options, k = {}, A = this.pos, $ = this.type, j = P(this.tickmarkOffset, w.tickmarkOffset), N = w.chart.renderer, M = this.gridLine, D, C = x.gridLineWidth, b = x.gridLineColor, p = x.gridLineDashStyle;
          this.type === "minor" && (C = x.minorGridLineWidth, b = x.minorGridLineColor, p = x.minorGridLineDashStyle), M || (w.chart.styledMode || (k.stroke = b, k["stroke-width"] = C || 0, k.dashstyle = p), $ || (k.zIndex = 1), f && (S = 0), this.gridLine = M = N.path().attr(k).addClass("highcharts-" + ($ ? $ + "-" : "") + "grid-line").add(w.gridGroup)), M && (D = w.getPlotLinePath({ value: A + j, lineWidth: M.strokeWidth(), force: "pass", old: f, acrossPanes: !1 })) && M[f || this.isNew ? "attr" : "animate"]({ d: D, opacity: S });
        }
        renderMark(f, S) {
          let w = this.axis, x = w.options, k = w.chart.renderer, A = this.type, $ = w.tickSize(A ? A + "Tick" : "tick"), j = f.x, N = f.y, M = P(x[A !== "minor" ? "tickWidth" : "minorTickWidth"], !A && w.isXAxis ? 1 : 0), D = x[A !== "minor" ? "tickColor" : "minorTickColor"], C = this.mark, b = !C;
          $ && (w.opposite && ($[0] = -$[0]), C || (this.mark = C = k.path().addClass("highcharts-" + (A ? A + "-" : "") + "tick").add(w.axisGroup), w.chart.styledMode || C.attr({ stroke: D, "stroke-width": M })), C[b ? "attr" : "animate"]({ d: this.getMarkPath(j, N, $[0], C.strokeWidth(), w.horiz, k), opacity: S }));
        }
        renderLabel(f, S, w, x) {
          let k = this.axis, A = k.horiz, $ = k.options, j = this.label, N = $.labels, M = N.step, D = P(this.tickmarkOffset, k.tickmarkOffset), C = f.x, b = f.y, p = !0;
          j && c(C) && (j.xy = f = this.getLabelPosition(C, b, j, A, N, D, x, M), (!this.isFirst || this.isLast || $.showFirstLabel) && (!this.isLast || this.isFirst || $.showLastLabel) ? !A || N.step || N.rotation || S || w === 0 || this.handleOverflow(f) : p = !1, M && x % M && (p = !1), p && c(f.y) ? (f.opacity = w, j[this.isNewLabel ? "attr" : "animate"](f).show(!0), this.isNewLabel = !1) : (j.hide(), this.isNewLabel = !0));
        }
        replaceMovedLabel() {
          let f = this.label, S = this.axis;
          f && !this.isNew && (f.animate({ opacity: 0 }, void 0, f.destroy), delete this.label), S.isDirty = !0, this.label = this.movedLabel, delete this.movedLabel;
        }
      };
    }), i(n, "Core/Axis/Axis.js", [n["Core/Animation/AnimationUtilities.js"], n["Core/Axis/AxisDefaults.js"], n["Core/Color/Color.js"], n["Core/Defaults.js"], n["Core/Foundation.js"], n["Core/Globals.js"], n["Core/Axis/Tick.js"], n["Core/Utilities.js"]], function(o, a, r, s, l, d, y, u) {
      let { animObject: m } = o, { xAxis: h, yAxis: c } = a, { defaultOptions: g } = s, { registerEventOptions: v } = l, { deg2rad: P } = d, { arrayMax: f, arrayMin: S, clamp: w, correctFloat: x, defined: k, destroyObjectProperties: A, erase: $, error: j, extend: N, fireEvent: M, getClosestDistance: D, insertItem: C, isArray: b, isNumber: p, isString: L, merge: B, normalizeTickInterval: T, objectEach: O, pick: I, relativeLength: R, removeEvent: Y, splat: F, syncTimeout: U } = u, Q = (ee, V) => T(V, void 0, void 0, I(ee.options.allowDecimals, V < 0.5 || ee.tickAmount !== void 0), !!ee.tickAmount);
      N(g, { xAxis: h, yAxis: B(h, c) });
      class J {
        constructor(V, G, W) {
          this.init(V, G, W);
        }
        init(V, G, W = this.coll) {
          let ae = W === "xAxis", z = this.isZAxis || (V.inverted ? !ae : ae);
          this.chart = V, this.horiz = z, this.isXAxis = ae, this.coll = W, M(this, "init", { userOptions: G }), this.opposite = I(G.opposite, this.opposite), this.side = I(G.side, this.side, z ? this.opposite ? 0 : 2 : this.opposite ? 1 : 3), this.setOptions(G);
          let q = this.options, Z = q.labels;
          this.type ?? (this.type = q.type || "linear"), this.uniqueNames ?? (this.uniqueNames = q.uniqueNames ?? !0), M(this, "afterSetType"), this.userOptions = G, this.minPixelPadding = 0, this.reversed = I(q.reversed, this.reversed), this.visible = q.visible, this.zoomEnabled = q.zoomEnabled, this.hasNames = this.type === "category" || q.categories === !0, this.categories = b(q.categories) && q.categories || (this.hasNames ? [] : void 0), this.names || (this.names = [], this.names.keys = {}), this.plotLinesAndBandsGroups = {}, this.positiveValuesOnly = !!this.logarithmic, this.isLinked = k(q.linkedTo), this.ticks = {}, this.labelEdge = [], this.minorTicks = {}, this.plotLinesAndBands = [], this.alternateBands = {}, this.len ?? (this.len = 0), this.minRange = this.userMinRange = q.minRange || q.maxZoom, this.range = q.range, this.offset = q.offset || 0, this.max = void 0, this.min = void 0;
          let ne = I(q.crosshair, F(V.options.tooltip.crosshairs)[ae ? 0 : 1]);
          this.crosshair = ne === !0 ? {} : ne, V.axes.indexOf(this) === -1 && (ae ? V.axes.splice(V.xAxis.length, 0, this) : V.axes.push(this), C(this, V[this.coll])), V.orderItems(this.coll), this.series = this.series || [], V.inverted && !this.isZAxis && ae && !k(this.reversed) && (this.reversed = !0), this.labelRotation = p(Z.rotation) ? Z.rotation : void 0, v(this, q), M(this, "afterInit");
        }
        setOptions(V) {
          let G = this.horiz ? { labels: { autoRotation: [-45], padding: 4 }, margin: 15 } : { labels: { padding: 1 }, title: { rotation: 90 * this.side } };
          this.options = B(G, g[this.coll], V), M(this, "afterSetOptions", { userOptions: V });
        }
        defaultLabelFormatter() {
          let V = this.axis, { numberFormatter: G } = this.chart, W = p(this.value) ? this.value : NaN, ae = V.chart.time, z = V.categories, q = this.dateTimeLabelFormat, Z = g.lang, ne = Z.numericSymbols, ie = Z.numericSymbolMagnitude || 1e3, re = V.logarithmic ? Math.abs(W) : V.tickInterval, de = ne && ne.length, me, ce;
          if (z)
            ce = `${this.value}`;
          else if (q)
            ce = ae.dateFormat(q, W);
          else if (de && ne && re >= 1e3)
            for (; de-- && ce === void 0; )
              re >= (me = Math.pow(ie, de + 1)) && 10 * W % me == 0 && ne[de] !== null && W !== 0 && (ce = G(W / me, -1) + ne[de]);
          return ce === void 0 && (ce = Math.abs(W) >= 1e4 ? G(W, -1) : G(W, -1, void 0, "")), ce;
        }
        getSeriesExtremes() {
          let V, G = this;
          M(this, "getSeriesExtremes", null, function() {
            G.hasVisibleSeries = !1, G.dataMin = G.dataMax = G.threshold = void 0, G.softThreshold = !G.isXAxis, G.series.forEach((W) => {
              if (W.reserveSpace()) {
                let ae = W.options, z, q = ae.threshold, Z, ne;
                if (G.hasVisibleSeries = !0, G.positiveValuesOnly && 0 >= (q || 0) && (q = void 0), G.isXAxis)
                  (z = W.xData) && z.length && (z = G.logarithmic ? z.filter((ie) => ie > 0) : z, Z = (V = W.getXExtremes(z)).min, ne = V.max, p(Z) || Z instanceof Date || (z = z.filter(p), Z = (V = W.getXExtremes(z)).min, ne = V.max), z.length && (G.dataMin = Math.min(I(G.dataMin, Z), Z), G.dataMax = Math.max(I(G.dataMax, ne), ne)));
                else {
                  let ie = W.applyExtremes();
                  p(ie.dataMin) && (Z = ie.dataMin, G.dataMin = Math.min(I(G.dataMin, Z), Z)), p(ie.dataMax) && (ne = ie.dataMax, G.dataMax = Math.max(I(G.dataMax, ne), ne)), k(q) && (G.threshold = q), (!ae.softThreshold || G.positiveValuesOnly) && (G.softThreshold = !1);
                }
              }
            });
          }), M(this, "afterGetSeriesExtremes");
        }
        translate(V, G, W, ae, z, q) {
          let Z = this.linkedParent || this, ne = ae && Z.old ? Z.old.min : Z.min;
          if (!p(ne))
            return NaN;
          let ie = Z.minPixelPadding, re = (Z.isOrdinal || Z.brokenAxis?.hasBreaks || Z.logarithmic && z) && Z.lin2val, de = 1, me = 0, ce = ae && Z.old ? Z.old.transA : Z.transA, pe = 0;
          return ce || (ce = Z.transA), W && (de *= -1, me = Z.len), Z.reversed && (de *= -1, me -= de * (Z.sector || Z.len)), G ? (pe = (V = V * de + me - ie) / ce + ne, re && (pe = Z.lin2val(pe))) : (re && (V = Z.val2lin(V)), pe = de * (V - ne) * ce + me + de * ie + (p(q) ? ce * q : 0), Z.isRadial || (pe = x(pe))), pe;
        }
        toPixels(V, G) {
          return this.translate(V, !1, !this.horiz, void 0, !0) + (G ? 0 : this.pos);
        }
        toValue(V, G) {
          return this.translate(V - (G ? 0 : this.pos), !0, !this.horiz, void 0, !0);
        }
        getPlotLinePath(V) {
          let G = this, W = G.chart, ae = G.left, z = G.top, q = V.old, Z = V.value, ne = V.lineWidth, ie = q && W.oldChartHeight || W.chartHeight, re = q && W.oldChartWidth || W.chartWidth, de = G.transB, me = V.translatedValue, ce = V.force, pe, xe, le, se, he;
          function ve(be, ke, we) {
            return ce !== "pass" && (be < ke || be > we) && (ce ? be = w(be, ke, we) : he = !0), be;
          }
          let ye = { value: Z, lineWidth: ne, old: q, force: ce, acrossPanes: V.acrossPanes, translatedValue: me };
          return M(this, "getPlotLinePath", ye, function(be) {
            pe = le = (me = w(me = I(me, G.translate(Z, void 0, void 0, q)), -1e9, 1e9)) + de, xe = se = ie - me - de, p(me) ? G.horiz ? (xe = z, se = ie - G.bottom + (G.options.isInternal ? 0 : W.scrollablePixelsY || 0), pe = le = ve(pe, ae, ae + G.width)) : (pe = ae, le = re - G.right + (W.scrollablePixelsX || 0), xe = se = ve(xe, z, z + G.height)) : (he = !0, ce = !1), be.path = he && !ce ? void 0 : W.renderer.crispLine([["M", pe, xe], ["L", le, se]], ne || 1);
          }), ye.path;
        }
        getLinearTickPositions(V, G, W) {
          let ae, z, q, Z = x(Math.floor(G / V) * V), ne = x(Math.ceil(W / V) * V), ie = [];
          if (x(Z + V) === Z && (q = 20), this.single)
            return [G];
          for (ae = Z; ae <= ne && (ie.push(ae), (ae = x(ae + V, q)) !== z); )
            z = ae;
          return ie;
        }
        getMinorTickInterval() {
          let { minorTicks: V, minorTickInterval: G } = this.options;
          return V === !0 ? I(G, "auto") : V !== !1 ? G : void 0;
        }
        getMinorTickPositions() {
          let V = this.options, G = this.tickPositions, W = this.minorTickInterval, ae = this.pointRangePadding || 0, z = (this.min || 0) - ae, q = (this.max || 0) + ae, Z = q - z, ne = [], ie;
          if (Z && Z / W < this.len / 3) {
            let re = this.logarithmic;
            if (re)
              this.paddedTicks.forEach(function(de, me, ce) {
                me && ne.push.apply(ne, re.getLogTickPositions(W, ce[me - 1], ce[me], !0));
              });
            else if (this.dateTime && this.getMinorTickInterval() === "auto")
              ne = ne.concat(this.getTimeTicks(this.dateTime.normalizeTimeTickInterval(W), z, q, V.startOfWeek));
            else
              for (ie = z + (G[0] - z) % W; ie <= q && ie !== ne[0]; ie += W)
                ne.push(ie);
          }
          return ne.length !== 0 && this.trimTicks(ne), ne;
        }
        adjustForMinRange() {
          let V = this.options, G = this.logarithmic, { max: W, min: ae, minRange: z } = this, q, Z, ne, ie;
          this.isXAxis && z === void 0 && !G && (z = k(V.min) || k(V.max) || k(V.floor) || k(V.ceiling) ? null : Math.min(5 * (D(this.series.map((re) => (re.xIncrement ? re.xData?.slice(0, 2) : re.xData) || [])) || 0), this.dataMax - this.dataMin)), p(W) && p(ae) && p(z) && W - ae < z && (Z = this.dataMax - this.dataMin >= z, q = (z - W + ae) / 2, ne = [ae - q, I(V.min, ae - q)], Z && (ne[2] = G ? G.log2lin(this.dataMin) : this.dataMin), ie = [(ae = f(ne)) + z, I(V.max, ae + z)], Z && (ie[2] = G ? G.log2lin(this.dataMax) : this.dataMax), (W = S(ie)) - ae < z && (ne[0] = W - z, ne[1] = I(V.min, W - z), ae = f(ne))), this.minRange = z, this.min = ae, this.max = W;
        }
        getClosest() {
          let V, G;
          if (this.categories)
            G = 1;
          else {
            let W = [];
            this.series.forEach(function(ae) {
              let z = ae.closestPointRange;
              ae.xData?.length === 1 ? W.push(ae.xData[0]) : !ae.noSharedTooltip && k(z) && ae.reserveSpace() && (G = k(G) ? Math.min(G, z) : z);
            }), W.length && (W.sort((ae, z) => ae - z), V = D([W]));
          }
          return V && G ? Math.min(V, G) : V || G;
        }
        nameToX(V) {
          let G = b(this.options.categories), W = G ? this.categories : this.names, ae = V.options.x, z;
          return V.series.requireSorting = !1, k(ae) || (ae = this.uniqueNames && W ? G ? W.indexOf(V.name) : I(W.keys[V.name], -1) : V.series.autoIncrement()), ae === -1 ? !G && W && (z = W.length) : z = ae, z !== void 0 ? (this.names[z] = V.name, this.names.keys[V.name] = z) : V.x && (z = V.x), z;
        }
        updateNames() {
          let V = this, G = this.names;
          G.length > 0 && (Object.keys(G.keys).forEach(function(W) {
            delete G.keys[W];
          }), G.length = 0, this.minRange = this.userMinRange, (this.series || []).forEach((W) => {
            W.xIncrement = null, (!W.points || W.isDirtyData) && (V.max = Math.max(V.max, W.xData.length - 1), W.processData(), W.generatePoints()), W.data.forEach(function(ae, z) {
              let q;
              ae?.options && ae.name !== void 0 && (q = V.nameToX(ae)) !== void 0 && q !== ae.x && (ae.x = q, W.xData[z] = q);
            });
          }));
        }
        setAxisTranslation() {
          let V = this, G = V.max - V.min, W = V.linkedParent, ae = !!V.categories, z = V.isXAxis, q = V.axisPointRange || 0, Z, ne = 0, ie = 0, re, de = V.transA;
          (z || ae || q) && (Z = V.getClosest(), W ? (ne = W.minPointOffset, ie = W.pointRangePadding) : V.series.forEach(function(me) {
            let ce = ae ? 1 : z ? I(me.options.pointRange, Z, 0) : V.axisPointRange || 0, pe = me.options.pointPlacement;
            if (q = Math.max(q, ce), !V.single || ae) {
              let xe = me.is("xrange") ? !z : z;
              ne = Math.max(ne, xe && L(pe) ? 0 : ce / 2), ie = Math.max(ie, xe && pe === "on" ? 0 : ce);
            }
          }), re = V.ordinal && V.ordinal.slope && Z ? V.ordinal.slope / Z : 1, V.minPointOffset = ne *= re, V.pointRangePadding = ie *= re, V.pointRange = Math.min(q, V.single && ae ? 1 : G), z && Z && (V.closestPointRange = Z)), V.translationSlope = V.transA = de = V.staticScale || V.len / (G + ie || 1), V.transB = V.horiz ? V.left : V.bottom, V.minPixelPadding = de * ne, M(this, "afterSetAxisTranslation");
        }
        minFromRange() {
          let { max: V, min: G } = this;
          return p(V) && p(G) && V - G || void 0;
        }
        setTickInterval(V) {
          let { categories: G, chart: W, dataMax: ae, dataMin: z, dateTime: q, isXAxis: Z, logarithmic: ne, options: ie, softThreshold: re } = this, de = p(this.threshold) ? this.threshold : void 0, me = this.minRange || 0, { ceiling: ce, floor: pe, linkedTo: xe, softMax: le, softMin: se } = ie, he = p(xe) && W[this.coll]?.[xe], ve = ie.tickPixelInterval, ye = ie.maxPadding, be = ie.minPadding, ke = 0, we, Le = p(ie.tickInterval) && ie.tickInterval >= 0 ? ie.tickInterval : void 0, Me, De, Ae, _e;
          if (q || G || he || this.getTickAmount(), Ae = I(this.userMin, ie.min), _e = I(this.userMax, ie.max), he ? (this.linkedParent = he, we = he.getExtremes(), this.min = I(we.min, we.dataMin), this.max = I(we.max, we.dataMax), this.type !== he.type && j(11, !0, W)) : (re && k(de) && p(ae) && p(z) && (z >= de ? (Me = de, be = 0) : ae <= de && (De = de, ye = 0)), this.min = I(Ae, Me, z), this.max = I(_e, De, ae)), p(this.max) && p(this.min) && (ne && (this.positiveValuesOnly && !V && 0 >= Math.min(this.min, I(z, this.min)) && j(10, !0, W), this.min = x(ne.log2lin(this.min), 16), this.max = x(ne.log2lin(this.max), 16)), this.range && p(z) && (this.userMin = this.min = Ae = Math.max(z, this.minFromRange() || 0), this.userMax = _e = this.max, this.range = void 0)), M(this, "foundExtremes"), this.adjustForMinRange(), p(this.min) && p(this.max)) {
            if (!p(this.userMin) && p(se) && se < this.min && (this.min = Ae = se), !p(this.userMax) && p(le) && le > this.max && (this.max = _e = le), G || this.axisPointRange || this.stacking?.usePercentage || he || !(ke = this.max - this.min) || (!k(Ae) && be && (this.min -= ke * be), k(_e) || !ye || (this.max += ke * ye)), !p(this.userMin) && p(pe) && (this.min = Math.max(this.min, pe)), !p(this.userMax) && p(ce) && (this.max = Math.min(this.max, ce)), re && p(z) && p(ae)) {
              let Ee = de || 0;
              !k(Ae) && this.min < Ee && z >= Ee ? this.min = ie.minRange ? Math.min(Ee, this.max - me) : Ee : !k(_e) && this.max > Ee && ae <= Ee && (this.max = ie.minRange ? Math.max(Ee, this.min + me) : Ee);
            }
            !W.polar && this.min > this.max && (k(ie.min) ? this.max = this.min : k(ie.max) && (this.min = this.max)), ke = this.max - this.min;
          }
          if (this.min !== this.max && p(this.min) && p(this.max) ? he && !Le && ve === he.options.tickPixelInterval ? this.tickInterval = Le = he.tickInterval : this.tickInterval = I(Le, this.tickAmount ? ke / Math.max(this.tickAmount - 1, 1) : void 0, G ? 1 : ke * ve / Math.max(this.len, ve)) : this.tickInterval = 1, Z && !V) {
            let Ee = this.min !== this.old?.min || this.max !== this.old?.max;
            this.series.forEach(function(Ne) {
              Ne.forceCrop = Ne.forceCropping?.(), Ne.processData(Ee);
            }), M(this, "postProcessData", { hasExtremesChanged: Ee });
          }
          this.setAxisTranslation(), M(this, "initialAxisTranslation"), this.pointRange && !Le && (this.tickInterval = Math.max(this.pointRange, this.tickInterval));
          let He = I(ie.minTickInterval, q && !this.series.some((Ee) => Ee.noSharedTooltip) ? this.closestPointRange : 0);
          !Le && this.tickInterval < He && (this.tickInterval = He), q || ne || Le || (this.tickInterval = Q(this, this.tickInterval)), this.tickAmount || (this.tickInterval = this.unsquish()), this.setTickPositions();
        }
        setTickPositions() {
          let V = this.options, G = V.tickPositions, W = V.tickPositioner, ae = this.getMinorTickInterval(), z = !this.isPanning, q = z && V.startOnTick, Z = z && V.endOnTick, ne = [], ie;
          if (this.tickmarkOffset = this.categories && V.tickmarkPlacement === "between" && this.tickInterval === 1 ? 0.5 : 0, this.single = this.min === this.max && k(this.min) && !this.tickAmount && (this.min % 1 == 0 || V.allowDecimals !== !1), G)
            ne = G.slice();
          else if (p(this.min) && p(this.max)) {
            if (!this.ordinal?.positions && (this.max - this.min) / this.tickInterval > Math.max(2 * this.len, 200))
              ne = [this.min, this.max], j(19, !1, this.chart);
            else if (this.dateTime)
              ne = this.getTimeTicks(this.dateTime.normalizeTimeTickInterval(this.tickInterval, V.units), this.min, this.max, V.startOfWeek, this.ordinal?.positions, this.closestPointRange, !0);
            else if (this.logarithmic)
              ne = this.logarithmic.getLogTickPositions(this.tickInterval, this.min, this.max);
            else {
              let re = this.tickInterval, de = re;
              for (; de <= 2 * re && (ne = this.getLinearTickPositions(this.tickInterval, this.min, this.max), this.tickAmount && ne.length > this.tickAmount); )
                this.tickInterval = Q(this, de *= 1.1);
            }
            ne.length > this.len && (ne = [ne[0], ne[ne.length - 1]])[0] === ne[1] && (ne.length = 1), W && (this.tickPositions = ne, (ie = W.apply(this, [this.min, this.max])) && (ne = ie));
          }
          this.tickPositions = ne, this.minorTickInterval = ae === "auto" && this.tickInterval ? this.tickInterval / V.minorTicksPerMajor : ae, this.paddedTicks = ne.slice(0), this.trimTicks(ne, q, Z), !this.isLinked && p(this.min) && p(this.max) && (this.single && ne.length < 2 && !this.categories && !this.series.some((re) => re.is("heatmap") && re.options.pointPlacement === "between") && (this.min -= 0.5, this.max += 0.5), G || ie || this.adjustTickAmount()), M(this, "afterSetTickPositions");
        }
        trimTicks(V, G, W) {
          let ae = V[0], z = V[V.length - 1], q = !this.isOrdinal && this.minPointOffset || 0;
          if (M(this, "trimTicks"), !this.isLinked) {
            if (G && ae !== -1 / 0)
              this.min = ae;
            else
              for (; this.min - q > V[0]; )
                V.shift();
            if (W)
              this.max = z;
            else
              for (; this.max + q < V[V.length - 1]; )
                V.pop();
            V.length === 0 && k(ae) && !this.options.tickPositions && V.push((z + ae) / 2);
          }
        }
        alignToOthers() {
          let V, G = this, W = G.chart, ae = [this], z = G.options, q = W.options.chart, Z = this.coll === "yAxis" && q.alignThresholds, ne = [];
          if (G.thresholdAlignment = void 0, (q.alignTicks !== !1 && z.alignTicks || Z) && z.startOnTick !== !1 && z.endOnTick !== !1 && !G.logarithmic) {
            let ie = (de) => {
              let { horiz: me, options: ce } = de;
              return [me ? ce.left : ce.top, ce.width, ce.height, ce.pane].join(",");
            }, re = ie(this);
            W[this.coll].forEach(function(de) {
              let { series: me } = de;
              me.length && me.some((ce) => ce.visible) && de !== G && ie(de) === re && (V = !0, ae.push(de));
            });
          }
          if (V && Z) {
            ae.forEach((re) => {
              let de = re.getThresholdAlignment(G);
              p(de) && ne.push(de);
            });
            let ie = ne.length > 1 ? ne.reduce((re, de) => re += de, 0) / ne.length : void 0;
            ae.forEach((re) => {
              re.thresholdAlignment = ie;
            });
          }
          return V;
        }
        getThresholdAlignment(V) {
          if ((!p(this.dataMin) || this !== V && this.series.some((G) => G.isDirty || G.isDirtyData)) && this.getSeriesExtremes(), p(this.threshold)) {
            let G = w((this.threshold - (this.dataMin || 0)) / ((this.dataMax || 0) - (this.dataMin || 0)), 0, 1);
            return this.options.reversed && (G = 1 - G), G;
          }
        }
        getTickAmount() {
          let V = this.options, G = V.tickPixelInterval, W = V.tickAmount;
          k(V.tickInterval) || W || !(this.len < G) || this.isRadial || this.logarithmic || !V.startOnTick || !V.endOnTick || (W = 2), !W && this.alignToOthers() && (W = Math.ceil(this.len / G) + 1), W < 4 && (this.finalTickAmt = W, W = 5), this.tickAmount = W;
        }
        adjustTickAmount() {
          let V = this, { finalTickAmt: G, max: W, min: ae, options: z, tickPositions: q, tickAmount: Z, thresholdAlignment: ne } = V, ie = q?.length, re = I(V.threshold, V.softThreshold ? 0 : null), de, me, ce = V.tickInterval, pe, xe = () => q.push(x(q[q.length - 1] + ce)), le = () => q.unshift(x(q[0] - ce));
          if (p(ne) && (pe = ne < 0.5 ? Math.ceil(ne * (Z - 1)) : Math.floor(ne * (Z - 1)), z.reversed && (pe = Z - 1 - pe)), V.hasData() && p(ae) && p(W)) {
            let se = () => {
              V.transA *= (ie - 1) / (Z - 1), V.min = z.startOnTick ? q[0] : Math.min(ae, q[0]), V.max = z.endOnTick ? q[q.length - 1] : Math.max(W, q[q.length - 1]);
            };
            if (p(pe) && p(V.threshold)) {
              for (; q[pe] !== re || q.length !== Z || q[0] > ae || q[q.length - 1] < W; ) {
                for (q.length = 0, q.push(V.threshold); q.length < Z; )
                  q[pe] === void 0 || q[pe] > V.threshold ? le() : xe();
                if (ce > 8 * V.tickInterval)
                  break;
                ce *= 2;
              }
              se();
            } else if (ie < Z) {
              for (; q.length < Z; )
                q.length % 2 || ae === re ? xe() : le();
              se();
            }
            if (k(G)) {
              for (me = de = q.length; me--; )
                (G === 3 && me % 2 == 1 || G <= 2 && me > 0 && me < de - 1) && q.splice(me, 1);
              V.finalTickAmt = void 0;
            }
          }
        }
        setScale() {
          let { coll: V, stacking: G } = this, W = !1, ae = !1;
          this.series.forEach((q) => {
            W = W || q.isDirtyData || q.isDirty, ae = ae || q.xAxis && q.xAxis.isDirty || !1;
          }), this.setAxisSize();
          let z = this.len !== (this.old && this.old.len);
          z || W || ae || this.isLinked || this.forceRedraw || this.userMin !== (this.old && this.old.userMin) || this.userMax !== (this.old && this.old.userMax) || this.alignToOthers() ? (G && V === "yAxis" && G.buildStacks(), this.forceRedraw = !1, this.userMinRange || (this.minRange = void 0), this.getSeriesExtremes(), this.setTickInterval(), G && V === "xAxis" && G.buildStacks(), this.isDirty || (this.isDirty = z || this.min !== this.old?.min || this.max !== this.old?.max)) : G && G.cleanStacks(), W && delete this.allExtremes, M(this, "afterSetScale");
        }
        setExtremes(V, G, W = !0, ae, z) {
          this.series.forEach((q) => {
            delete q.kdTree;
          }), M(this, "setExtremes", z = N(z, { min: V, max: G }), (q) => {
            this.userMin = q.min, this.userMax = q.max, this.eventArgs = q, W && this.chart.redraw(ae);
          });
        }
        setAxisSize() {
          let V = this.chart, G = this.options, W = G.offsets || [0, 0, 0, 0], ae = this.horiz, z = this.width = Math.round(R(I(G.width, V.plotWidth - W[3] + W[1]), V.plotWidth)), q = this.height = Math.round(R(I(G.height, V.plotHeight - W[0] + W[2]), V.plotHeight)), Z = this.top = Math.round(R(I(G.top, V.plotTop + W[0]), V.plotHeight, V.plotTop)), ne = this.left = Math.round(R(I(G.left, V.plotLeft + W[3]), V.plotWidth, V.plotLeft));
          this.bottom = V.chartHeight - q - Z, this.right = V.chartWidth - z - ne, this.len = Math.max(ae ? z : q, 0), this.pos = ae ? ne : Z;
        }
        getExtremes() {
          let V = this.logarithmic;
          return { min: V ? x(V.lin2log(this.min)) : this.min, max: V ? x(V.lin2log(this.max)) : this.max, dataMin: this.dataMin, dataMax: this.dataMax, userMin: this.userMin, userMax: this.userMax };
        }
        getThreshold(V) {
          let G = this.logarithmic, W = G ? G.lin2log(this.min) : this.min, ae = G ? G.lin2log(this.max) : this.max;
          return V === null || V === -1 / 0 ? V = W : V === 1 / 0 ? V = ae : W > V ? V = W : ae < V && (V = ae), this.translate(V, 0, 1, 0, 1);
        }
        autoLabelAlign(V) {
          let G = (I(V, 0) - 90 * this.side + 720) % 360, W = { align: "center" };
          return M(this, "autoLabelAlign", W, function(ae) {
            G > 15 && G < 165 ? ae.align = "right" : G > 195 && G < 345 && (ae.align = "left");
          }), W.align;
        }
        tickSize(V) {
          let G = this.options, W = I(G[V === "tick" ? "tickWidth" : "minorTickWidth"], V === "tick" && this.isXAxis && !this.categories ? 1 : 0), ae = G[V === "tick" ? "tickLength" : "minorTickLength"], z;
          W && ae && (G[V + "Position"] === "inside" && (ae = -ae), z = [ae, W]);
          let q = { tickSize: z };
          return M(this, "afterTickSize", q), q.tickSize;
        }
        labelMetrics() {
          let V = this.chart.renderer, G = this.ticks, W = G[Object.keys(G)[0]] || {};
          return this.chart.renderer.fontMetrics(W.label || W.movedLabel || V.box);
        }
        unsquish() {
          let V = this.options.labels, G = V.padding || 0, W = this.horiz, ae = this.tickInterval, z = this.len / (((this.categories ? 1 : 0) + this.max - this.min) / ae), q = V.rotation, Z = x(0.8 * this.labelMetrics().h), ne = Math.max(this.max - this.min, 0), ie = function(pe) {
            let xe = (pe + 2 * G) / (z || 1);
            return (xe = xe > 1 ? Math.ceil(xe) : 1) * ae > ne && pe !== 1 / 0 && z !== 1 / 0 && ne && (xe = Math.ceil(ne / ae)), x(xe * ae);
          }, re = ae, de, me = Number.MAX_VALUE, ce;
          if (W) {
            if (!V.staggerLines && (p(q) ? ce = [q] : z < V.autoRotationLimit && (ce = V.autoRotation)), ce) {
              let pe, xe;
              for (let le of ce)
                (le === q || le && le >= -90 && le <= 90) && (xe = (pe = ie(Math.abs(Z / Math.sin(P * le)))) + Math.abs(le / 360)) < me && (me = xe, de = le, re = pe);
            }
          } else
            re = ie(0.75 * Z);
          return this.autoRotation = ce, this.labelRotation = I(de, p(q) ? q : 0), V.step ? ae : re;
        }
        getSlotWidth(V) {
          let G = this.chart, W = this.horiz, ae = this.options.labels, z = Math.max(this.tickPositions.length - (this.categories ? 0 : 1), 1), q = G.margin[3];
          if (V && p(V.slotWidth))
            return V.slotWidth;
          if (W && ae.step < 2)
            return ae.rotation ? 0 : (this.staggerLines || 1) * this.len / z;
          if (!W) {
            let Z = ae.style.width;
            if (Z !== void 0)
              return parseInt(String(Z), 10);
            if (q)
              return q - G.spacing[3];
          }
          return 0.33 * G.chartWidth;
        }
        renderUnsquish() {
          let V = this.chart, G = V.renderer, W = this.tickPositions, ae = this.ticks, z = this.options.labels, q = z.style, Z = this.horiz, ne = this.getSlotWidth(), ie = Math.max(1, Math.round(ne - (Z ? 2 * (z.padding || 0) : z.distance || 0))), re = {}, de = this.labelMetrics(), me = q.textOverflow, ce, pe, xe = 0, le, se;
          if (L(z.rotation) || (re.rotation = z.rotation || 0), W.forEach(function(he) {
            let ve = ae[he];
            ve.movedLabel && ve.replaceMovedLabel(), ve && ve.label && ve.label.textPxLength > xe && (xe = ve.label.textPxLength);
          }), this.maxLabelLength = xe, this.autoRotation)
            xe > ie && xe > de.h ? re.rotation = this.labelRotation : this.labelRotation = 0;
          else if (ne && (ce = ie, !me))
            for (pe = "clip", se = W.length; !Z && se--; )
              (le = ae[W[se]].label) && (le.styles.textOverflow === "ellipsis" ? le.css({ textOverflow: "clip" }) : le.textPxLength > ne && le.css({ width: ne + "px" }), le.getBBox().height > this.len / W.length - (de.h - de.f) && (le.specificTextOverflow = "ellipsis"));
          re.rotation && (ce = xe > 0.5 * V.chartHeight ? 0.33 * V.chartHeight : xe, me || (pe = "ellipsis")), this.labelAlign = z.align || this.autoLabelAlign(this.labelRotation), this.labelAlign && (re.align = this.labelAlign), W.forEach(function(he) {
            let ve = ae[he], ye = ve && ve.label, be = q.width, ke = {};
            ye && (ye.attr(re), ve.shortenLabel ? ve.shortenLabel() : ce && !be && q.whiteSpace !== "nowrap" && (ce < ye.textPxLength || ye.element.tagName === "SPAN") ? (ke.width = ce + "px", me || (ke.textOverflow = ye.specificTextOverflow || pe), ye.css(ke)) : !ye.styles.width || ke.width || be || ye.css({ width: null }), delete ye.specificTextOverflow, ve.rotation = re.rotation);
          }, this), this.tickRotCorr = G.rotCorr(de.b, this.labelRotation || 0, this.side !== 0);
        }
        hasData() {
          return this.series.some(function(V) {
            return V.hasData();
          }) || this.options.showEmpty && k(this.min) && k(this.max);
        }
        addTitle(V) {
          let G, W = this.chart.renderer, ae = this.horiz, z = this.opposite, q = this.options.title, Z = this.chart.styledMode;
          this.axisTitle || ((G = q.textAlign) || (G = (ae ? { low: "left", middle: "center", high: "right" } : { low: z ? "right" : "left", middle: "center", high: z ? "left" : "right" })[q.align]), this.axisTitle = W.text(q.text || "", 0, 0, q.useHTML).attr({ zIndex: 7, rotation: q.rotation || 0, align: G }).addClass("highcharts-axis-title"), Z || this.axisTitle.css(B(q.style)), this.axisTitle.add(this.axisGroup), this.axisTitle.isNew = !0), Z || q.style.width || this.isRadial || this.axisTitle.css({ width: this.len + "px" }), this.axisTitle[V ? "show" : "hide"](V);
        }
        generateTick(V) {
          let G = this.ticks;
          G[V] ? G[V].addLabel() : G[V] = new y(this, V);
        }
        createGroups() {
          let { axisParent: V, chart: G, coll: W, options: ae } = this, z = G.renderer, q = (Z, ne, ie) => z.g(Z).attr({ zIndex: ie }).addClass(`highcharts-${W.toLowerCase()}${ne} ` + (this.isRadial ? `highcharts-radial-axis${ne} ` : "") + (ae.className || "")).add(V);
          this.axisGroup || (this.gridGroup = q("grid", "-grid", ae.gridZIndex), this.axisGroup = q("axis", "", ae.zIndex), this.labelGroup = q("axis-labels", "-labels", ae.labels.zIndex));
        }
        getOffset() {
          let V = this, { chart: G, horiz: W, options: ae, side: z, ticks: q, tickPositions: Z, coll: ne } = V, ie = G.inverted && !V.isZAxis ? [1, 0, 3, 2][z] : z, re = V.hasData(), de = ae.title, me = ae.labels, ce = p(ae.crossing), pe = G.axisOffset, xe = G.clipOffset, le = [-1, 1, 1, -1][z], se, he = 0, ve, ye = 0, be = 0, ke, we;
          if (V.showAxis = se = re || ae.showEmpty, V.staggerLines = V.horiz && me.staggerLines || void 0, V.createGroups(), re || V.isLinked ? (Z.forEach(function(Le) {
            V.generateTick(Le);
          }), V.renderUnsquish(), V.reserveSpaceDefault = z === 0 || z === 2 || { 1: "left", 3: "right" }[z] === V.labelAlign, I(me.reserveSpace, !ce && null, V.labelAlign === "center" || null, V.reserveSpaceDefault) && Z.forEach(function(Le) {
            be = Math.max(q[Le].getLabelSize(), be);
          }), V.staggerLines && (be *= V.staggerLines), V.labelOffset = be * (V.opposite ? -1 : 1)) : O(q, function(Le, Me) {
            Le.destroy(), delete q[Me];
          }), de?.text && de.enabled !== !1 && (V.addTitle(se), se && !ce && de.reserveSpace !== !1 && (V.titleOffset = he = V.axisTitle.getBBox()[W ? "height" : "width"], ye = k(ve = de.offset) ? 0 : I(de.margin, W ? 5 : 10))), V.renderLine(), V.offset = le * I(ae.offset, pe[z] ? pe[z] + (ae.margin || 0) : 0), V.tickRotCorr = V.tickRotCorr || { x: 0, y: 0 }, we = z === 0 ? -V.labelMetrics().h : z === 2 ? V.tickRotCorr.y : 0, ke = Math.abs(be) + ye, be && (ke -= we, ke += le * (W ? I(me.y, V.tickRotCorr.y + le * me.distance) : I(me.x, le * me.distance))), V.axisTitleMargin = I(ve, ke), V.getMaxLabelDimensions && (V.maxLabelDimensions = V.getMaxLabelDimensions(q, Z)), ne !== "colorAxis" && xe) {
            let Le = this.tickSize("tick");
            pe[z] = Math.max(pe[z], (V.axisTitleMargin || 0) + he + le * V.offset, ke, Z && Z.length && Le ? Le[0] + le * V.offset : 0);
            let Me = !V.axisLine || ae.offset ? 0 : V.axisLine.strokeWidth() / 2;
            xe[ie] = Math.max(xe[ie], Me);
          }
          M(this, "afterGetOffset");
        }
        getLinePath(V) {
          let G = this.chart, W = this.opposite, ae = this.offset, z = this.horiz, q = this.left + (W ? this.width : 0) + ae, Z = G.chartHeight - this.bottom - (W ? this.height : 0) + ae;
          return W && (V *= -1), G.renderer.crispLine([["M", z ? this.left : q, z ? Z : this.top], ["L", z ? G.chartWidth - this.right : q, z ? Z : G.chartHeight - this.bottom]], V);
        }
        renderLine() {
          this.axisLine || (this.axisLine = this.chart.renderer.path().addClass("highcharts-axis-line").add(this.axisGroup), this.chart.styledMode || this.axisLine.attr({ stroke: this.options.lineColor, "stroke-width": this.options.lineWidth, zIndex: 7 }));
        }
        getTitlePosition(V) {
          let G = this.horiz, W = this.left, ae = this.top, z = this.len, q = this.options.title, Z = G ? W : ae, ne = this.opposite, ie = this.offset, re = q.x, de = q.y, me = this.chart.renderer.fontMetrics(V), ce = V ? Math.max(V.getBBox(!1, 0).height - me.h - 1, 0) : 0, pe = { low: Z + (G ? 0 : z), middle: Z + z / 2, high: Z + (G ? z : 0) }[q.align], xe = (G ? ae + this.height : W) + (G ? 1 : -1) * (ne ? -1 : 1) * (this.axisTitleMargin || 0) + [-ce, ce, me.f, -ce][this.side], le = { x: G ? pe + re : xe + (ne ? this.width : 0) + ie + re, y: G ? xe + de - (ne ? this.height : 0) + ie : pe + de };
          return M(this, "afterGetTitlePosition", { titlePosition: le }), le;
        }
        renderMinorTick(V, G) {
          let W = this.minorTicks;
          W[V] || (W[V] = new y(this, V, "minor")), G && W[V].isNew && W[V].render(null, !0), W[V].render(null, !1, 1);
        }
        renderTick(V, G, W) {
          let ae = this.isLinked, z = this.ticks;
          (!ae || V >= this.min && V <= this.max || this.grid && this.grid.isColumn) && (z[V] || (z[V] = new y(this, V)), W && z[V].isNew && z[V].render(G, !0, -1), z[V].render(G));
        }
        render() {
          let V, G, W = this, ae = W.chart, z = W.logarithmic, q = ae.renderer, Z = W.options, ne = W.isLinked, ie = W.tickPositions, re = W.axisTitle, de = W.ticks, me = W.minorTicks, ce = W.alternateBands, pe = Z.stackLabels, xe = Z.alternateGridColor, le = Z.crossing, se = W.tickmarkOffset, he = W.axisLine, ve = W.showAxis, ye = m(q.globalAnimation);
          if (W.labelEdge.length = 0, W.overlap = !1, [de, me, ce].forEach(function(be) {
            O(be, function(ke) {
              ke.isActive = !1;
            });
          }), p(le)) {
            let be = this.isXAxis ? ae.yAxis[0] : ae.xAxis[0], ke = [1, -1, -1, 1][this.side];
            if (be) {
              let we = be.toPixels(le, !0);
              W.horiz && (we = be.len - we), W.offset = ke * we;
            }
          }
          if (W.hasData() || ne) {
            let be = W.chart.hasRendered && W.old && p(W.old.min);
            W.minorTickInterval && !W.categories && W.getMinorTickPositions().forEach(function(ke) {
              W.renderMinorTick(ke, be);
            }), ie.length && (ie.forEach(function(ke, we) {
              W.renderTick(ke, we, be);
            }), se && (W.min === 0 || W.single) && (de[-1] || (de[-1] = new y(W, -1, null, !0)), de[-1].render(-1))), xe && ie.forEach(function(ke, we) {
              G = ie[we + 1] !== void 0 ? ie[we + 1] + se : W.max - se, we % 2 == 0 && ke < W.max && G <= W.max + (ae.polar ? -se : se) && (ce[ke] || (ce[ke] = new d.PlotLineOrBand(W, {})), V = ke + se, ce[ke].options = { from: z ? z.lin2log(V) : V, to: z ? z.lin2log(G) : G, color: xe, className: "highcharts-alternate-grid" }, ce[ke].render(), ce[ke].isActive = !0);
            }), W._addedPlotLB || (W._addedPlotLB = !0, (Z.plotLines || []).concat(Z.plotBands || []).forEach(function(ke) {
              W.addPlotBandOrLine(ke);
            }));
          }
          [de, me, ce].forEach(function(be) {
            let ke = [], we = ye.duration;
            O(be, function(Le, Me) {
              Le.isActive || (Le.render(Me, !1, 0), Le.isActive = !1, ke.push(Me));
            }), U(function() {
              let Le = ke.length;
              for (; Le--; )
                be[ke[Le]] && !be[ke[Le]].isActive && (be[ke[Le]].destroy(), delete be[ke[Le]]);
            }, be !== ce && ae.hasRendered && we ? we : 0);
          }), he && (he[he.isPlaced ? "animate" : "attr"]({ d: this.getLinePath(he.strokeWidth()) }), he.isPlaced = !0, he[ve ? "show" : "hide"](ve)), re && ve && (re[re.isNew ? "attr" : "animate"](W.getTitlePosition(re)), re.isNew = !1), pe && pe.enabled && W.stacking && W.stacking.renderStackTotals(), W.old = { len: W.len, max: W.max, min: W.min, transA: W.transA, userMax: W.userMax, userMin: W.userMin }, W.isDirty = !1, M(this, "afterRender");
        }
        redraw() {
          this.visible && (this.render(), this.plotLinesAndBands.forEach(function(V) {
            V.render();
          })), this.series.forEach(function(V) {
            V.isDirty = !0;
          });
        }
        getKeepProps() {
          return this.keepProps || J.keepProps;
        }
        destroy(V) {
          let G = this, W = G.plotLinesAndBands, ae = this.eventOptions;
          if (M(this, "destroy", { keepEvents: V }), V || Y(G), [G.ticks, G.minorTicks, G.alternateBands].forEach(function(z) {
            A(z);
          }), W) {
            let z = W.length;
            for (; z--; )
              W[z].destroy();
          }
          for (let z in ["axisLine", "axisTitle", "axisGroup", "gridGroup", "labelGroup", "cross", "scrollbar"].forEach(function(q) {
            G[q] && (G[q] = G[q].destroy());
          }), G.plotLinesAndBandsGroups)
            G.plotLinesAndBandsGroups[z] = G.plotLinesAndBandsGroups[z].destroy();
          O(G, function(z, q) {
            G.getKeepProps().indexOf(q) === -1 && delete G[q];
          }), this.eventOptions = ae;
        }
        drawCrosshair(V, G) {
          let W = this.crosshair, ae = I(W && W.snap, !0), z = this.chart, q, Z, ne, ie = this.cross, re;
          if (M(this, "drawCrosshair", { e: V, point: G }), V || (V = this.cross && this.cross.e), W && (k(G) || !ae) !== !1) {
            if (ae ? k(G) && (Z = I(this.coll !== "colorAxis" ? G.crosshairPos : null, this.isXAxis ? G.plotX : this.len - G.plotY)) : Z = V && (this.horiz ? V.chartX - this.pos : this.len - V.chartY + this.pos), k(Z) && (re = { value: G && (this.isXAxis ? G.x : I(G.stackY, G.y)), translatedValue: Z }, z.polar && N(re, { isCrosshair: !0, chartX: V && V.chartX, chartY: V && V.chartY, point: G }), q = this.getPlotLinePath(re) || null), !k(q)) {
              this.hideCrosshair();
              return;
            }
            ne = this.categories && !this.isRadial, ie || (this.cross = ie = z.renderer.path().addClass("highcharts-crosshair highcharts-crosshair-" + (ne ? "category " : "thin ") + (W.className || "")).attr({ zIndex: I(W.zIndex, 2) }).add(), !z.styledMode && (ie.attr({ stroke: W.color || (ne ? r.parse("#ccd3ff").setOpacity(0.25).get() : "#cccccc"), "stroke-width": I(W.width, 1) }).css({ "pointer-events": "none" }), W.dashStyle && ie.attr({ dashstyle: W.dashStyle }))), ie.show().attr({ d: q }), ne && !W.width && ie.attr({ "stroke-width": this.transA }), this.cross.e = V;
          } else
            this.hideCrosshair();
          M(this, "afterDrawCrosshair", { e: V, point: G });
        }
        hideCrosshair() {
          this.cross && this.cross.hide(), M(this, "afterHideCrosshair");
        }
        update(V, G) {
          let W = this.chart;
          V = B(this.userOptions, V), this.destroy(!0), this.init(W, V), W.isDirtyBox = !0, I(G, !0) && W.redraw();
        }
        remove(V) {
          let G = this.chart, W = this.coll, ae = this.series, z = ae.length;
          for (; z--; )
            ae[z] && ae[z].remove(!1);
          $(G.axes, this), $(G[W] || [], this), G.orderItems(W), this.destroy(), G.isDirtyBox = !0, I(V, !0) && G.redraw();
        }
        setTitle(V, G) {
          this.update({ title: V }, G);
        }
        setCategories(V, G) {
          this.update({ categories: V }, G);
        }
      }
      return J.keepProps = ["coll", "extKey", "hcEvents", "len", "names", "series", "userMax", "userMin"], J;
    }), i(n, "Core/Axis/DateTimeAxis.js", [n["Core/Utilities.js"]], function(o) {
      var a;
      let { addEvent: r, getMagnitude: s, normalizeTickInterval: l, timeUnits: d } = o;
      return function(y) {
        function u() {
          return this.chart.time.getTimeTicks.apply(this.chart.time, arguments);
        }
        function m() {
          if (this.type !== "datetime") {
            this.dateTime = void 0;
            return;
          }
          this.dateTime || (this.dateTime = new h(this));
        }
        y.compose = function(c) {
          return c.keepProps.includes("dateTime") || (c.keepProps.push("dateTime"), c.prototype.getTimeTicks = u, r(c, "afterSetType", m)), c;
        };
        class h {
          constructor(g) {
            this.axis = g;
          }
          normalizeTimeTickInterval(g, v) {
            let P = v || [["millisecond", [1, 2, 5, 10, 20, 25, 50, 100, 200, 500]], ["second", [1, 2, 5, 10, 15, 30]], ["minute", [1, 2, 5, 10, 15, 30]], ["hour", [1, 2, 3, 4, 6, 8, 12]], ["day", [1, 2]], ["week", [1, 2]], ["month", [1, 2, 3, 4, 6]], ["year", null]], f = P[P.length - 1], S = d[f[0]], w = f[1], x;
            for (x = 0; x < P.length && (S = d[(f = P[x])[0]], w = f[1], !P[x + 1] || !(g <= (S * w[w.length - 1] + d[P[x + 1][0]]) / 2)); x++)
              ;
            S === d.year && g < 5 * S && (w = [1, 2, 5]);
            let k = l(g / S, w, f[0] === "year" ? Math.max(s(g / S), 1) : 1);
            return { unitRange: S, count: k, unitName: f[0] };
          }
          getXDateFormat(g, v) {
            let { axis: P } = this, f = P.chart.time;
            return P.closestPointRange ? f.getDateFormat(P.closestPointRange, g, P.options.startOfWeek, v) || f.resolveDTLFormat(v.year).main : f.resolveDTLFormat(v.day).main;
          }
        }
        y.Additions = h;
      }(a || (a = {})), a;
    }), i(n, "Core/Axis/LogarithmicAxis.js", [n["Core/Utilities.js"]], function(o) {
      var a;
      let { addEvent: r, normalizeTickInterval: s, pick: l } = o;
      return function(d) {
        function y() {
          this.type !== "logarithmic" ? this.logarithmic = void 0 : this.logarithmic ?? (this.logarithmic = new m(this));
        }
        function u() {
          let h = this.logarithmic;
          h && (this.lin2val = function(c) {
            return h.lin2log(c);
          }, this.val2lin = function(c) {
            return h.log2lin(c);
          });
        }
        d.compose = function(h) {
          return h.keepProps.includes("logarithmic") || (h.keepProps.push("logarithmic"), r(h, "afterSetType", y), r(h, "afterInit", u)), h;
        };
        class m {
          constructor(c) {
            this.axis = c;
          }
          getLogTickPositions(c, g, v, P) {
            let f = this.axis, S = f.len, w = f.options, x = [];
            if (P || (this.minorAutoInterval = void 0), c >= 0.5)
              c = Math.round(c), x = f.getLinearTickPositions(c, g, v);
            else if (c >= 0.08) {
              let k, A, $, j, N, M, D, C = Math.floor(g);
              for (k = c > 0.3 ? [1, 2, 4] : c > 0.15 ? [1, 2, 4, 6, 8] : [1, 2, 3, 4, 5, 6, 7, 8, 9], A = C; A < v + 1 && !D; A++)
                for ($ = 0, j = k.length; $ < j && !D; $++)
                  (N = this.log2lin(this.lin2log(A) * k[$])) > g && (!P || M <= v) && M !== void 0 && x.push(M), M > v && (D = !0), M = N;
            } else {
              let k = this.lin2log(g), A = this.lin2log(v), $ = P ? f.getMinorTickInterval() : w.tickInterval, j = w.tickPixelInterval / (P ? 5 : 1), N = P ? S / f.tickPositions.length : S;
              c = s(c = l($ === "auto" ? null : $, this.minorAutoInterval, (A - k) * j / (N || 1))), x = f.getLinearTickPositions(c, k, A).map(this.log2lin), P || (this.minorAutoInterval = c / 5);
            }
            return P || (f.tickInterval = c), x;
          }
          lin2log(c) {
            return Math.pow(10, c);
          }
          log2lin(c) {
            return Math.log(c) / Math.LN10;
          }
        }
        d.Additions = m;
      }(a || (a = {})), a;
    }), i(n, "Core/Axis/PlotLineOrBand/PlotLineOrBandAxis.js", [n["Core/Utilities.js"]], function(o) {
      var a;
      let { erase: r, extend: s, isNumber: l } = o;
      return function(d) {
        let y;
        function u(f) {
          return this.addPlotBandOrLine(f, "plotBands");
        }
        function m(f, S) {
          let w = this.userOptions, x = new y(this, f);
          if (this.visible && (x = x.render()), x) {
            if (this._addedPlotLB || (this._addedPlotLB = !0, (w.plotLines || []).concat(w.plotBands || []).forEach((k) => {
              this.addPlotBandOrLine(k);
            })), S) {
              let k = w[S] || [];
              k.push(f), w[S] = k;
            }
            this.plotLinesAndBands.push(x);
          }
          return x;
        }
        function h(f) {
          return this.addPlotBandOrLine(f, "plotLines");
        }
        function c(f, S, w) {
          w = w || this.options;
          let x = this.getPlotLinePath({ value: S, force: !0, acrossPanes: w.acrossPanes }), k = [], A = this.horiz, $ = !l(this.min) || !l(this.max) || f < this.min && S < this.min || f > this.max && S > this.max, j = this.getPlotLinePath({ value: f, force: !0, acrossPanes: w.acrossPanes }), N, M = 1, D;
          if (j && x)
            for ($ && (D = j.toString() === x.toString(), M = 0), N = 0; N < j.length; N += 2) {
              let C = j[N], b = j[N + 1], p = x[N], L = x[N + 1];
              (C[0] === "M" || C[0] === "L") && (b[0] === "M" || b[0] === "L") && (p[0] === "M" || p[0] === "L") && (L[0] === "M" || L[0] === "L") && (A && p[1] === C[1] ? (p[1] += M, L[1] += M) : A || p[2] !== C[2] || (p[2] += M, L[2] += M), k.push(["M", C[1], C[2]], ["L", b[1], b[2]], ["L", L[1], L[2]], ["L", p[1], p[2]], ["Z"])), k.isFlat = D;
            }
          return k;
        }
        function g(f) {
          this.removePlotBandOrLine(f);
        }
        function v(f) {
          let S = this.plotLinesAndBands, w = this.options, x = this.userOptions;
          if (S) {
            let k = S.length;
            for (; k--; )
              S[k].id === f && S[k].destroy();
            [w.plotLines || [], x.plotLines || [], w.plotBands || [], x.plotBands || []].forEach(function(A) {
              for (k = A.length; k--; )
                (A[k] || {}).id === f && r(A, A[k]);
            });
          }
        }
        function P(f) {
          this.removePlotBandOrLine(f);
        }
        d.compose = function(f, S) {
          let w = S.prototype;
          return w.addPlotBand || (y = f, s(w, { addPlotBand: u, addPlotLine: h, addPlotBandOrLine: m, getPlotBandPath: c, removePlotBand: g, removePlotLine: P, removePlotBandOrLine: v })), S;
        };
      }(a || (a = {})), a;
    }), i(n, "Core/Axis/PlotLineOrBand/PlotLineOrBand.js", [n["Core/Axis/PlotLineOrBand/PlotLineOrBandAxis.js"], n["Core/Utilities.js"]], function(o, a) {
      let { addEvent: r, arrayMax: s, arrayMin: l, defined: d, destroyObjectProperties: y, erase: u, fireEvent: m, merge: h, objectEach: c, pick: g } = a;
      class v {
        static compose(f, S) {
          return r(f, "afterInit", function() {
            this.labelCollectors.push(() => {
              let w = [];
              for (let x of this.axes)
                for (let { label: k, options: A } of x.plotLinesAndBands)
                  k && !A?.label?.allowOverlap && w.push(k);
              return w;
            });
          }), o.compose(v, S);
        }
        constructor(f, S) {
          this.axis = f, this.options = S, this.id = S.id;
        }
        render() {
          m(this, "render");
          let { axis: f, options: S } = this, { horiz: w, logarithmic: x } = f, { color: k, events: A, zIndex: $ = 0 } = S, j = {}, N = f.chart.renderer, M = S.to, D = S.from, C = S.value, b = S.borderWidth, p = S.label, { label: L, svgElem: B } = this, T = [], O, I = d(D) && d(M), R = d(C), Y = !B, F = { class: "highcharts-plot-" + (I ? "band " : "line ") + (S.className || "") }, U = I ? "bands" : "lines";
          if (!f.chart.styledMode && (R ? (F.stroke = k || "#999999", F["stroke-width"] = g(S.width, 1), S.dashStyle && (F.dashstyle = S.dashStyle)) : I && (F.fill = k || "#e6e9ff", b && (F.stroke = S.borderColor, F["stroke-width"] = b))), j.zIndex = $, U += "-" + $, (O = f.plotLinesAndBandsGroups[U]) || (f.plotLinesAndBandsGroups[U] = O = N.g("plot-" + U).attr(j).add()), B || (this.svgElem = B = N.path().attr(F).add(O)), d(C))
            T = f.getPlotLinePath({ value: x?.log2lin(C) ?? C, lineWidth: B.strokeWidth(), acrossPanes: S.acrossPanes });
          else {
            if (!(d(D) && d(M)))
              return;
            T = f.getPlotBandPath(x?.log2lin(D) ?? D, x?.log2lin(M) ?? M, S);
          }
          return !this.eventsAdded && A && (c(A, (Q, J) => {
            B?.on(J, (ee) => {
              A[J].apply(this, [ee]);
            });
          }), this.eventsAdded = !0), (Y || !B.d) && T?.length ? B.attr({ d: T }) : B && (T ? (B.show(), B.animate({ d: T })) : B.d && (B.hide(), L && (this.label = L = L.destroy()))), p && (d(p.text) || d(p.formatter)) && T?.length && f.width > 0 && f.height > 0 && !T.isFlat ? (p = h({ align: w && I ? "center" : void 0, x: w ? !I && 4 : 10, verticalAlign: !w && I ? "middle" : void 0, y: w ? I ? 16 : 10 : I ? 6 : -4, rotation: w && !I ? 90 : 0, ...I ? { inside: !0 } : {} }, p), this.renderLabel(p, T, I, $)) : L && L.hide(), this;
        }
        renderLabel(f, S, w, x) {
          let k = this.axis, A = k.chart.renderer, $ = f.inside, j = this.label;
          j || (this.label = j = A.text(this.getLabelText(f), 0, 0, f.useHTML).attr({ align: f.textAlign || f.align, rotation: f.rotation, class: "highcharts-plot-" + (w ? "band" : "line") + "-label " + (f.className || ""), zIndex: x }), k.chart.styledMode || j.css(h({ fontSize: "0.8em", textOverflow: w && !$ ? "" : "ellipsis" }, f.style)), j.add());
          let N = S.xBounds || [S[0][1], S[1][1], w ? S[2][1] : S[0][1]], M = S.yBounds || [S[0][2], S[1][2], w ? S[2][2] : S[0][2]], D = l(N), C = l(M), b = s(N) - D;
          j.align(f, !1, { x: D, y: C, width: b, height: s(M) - C }), (!j.alignValue || j.alignValue === "left" || d($)) && j.css({ width: (f.style?.width || (w && $ ? b : j.rotation === 90 ? k.height - (j.alignAttr.y - k.top) : (f.clip ? k.width : k.chart.chartWidth) - (j.alignAttr.x - k.left))) + "px" }), j.show(!0);
        }
        getLabelText(f) {
          return d(f.formatter) ? f.formatter.call(this) : f.text;
        }
        destroy() {
          u(this.axis.plotLinesAndBands, this), delete this.axis, y(this);
        }
      }
      return v;
    }), i(n, "Core/Tooltip.js", [n["Core/Animation/AnimationUtilities.js"], n["Core/Templating.js"], n["Core/Globals.js"], n["Core/Renderer/RendererUtilities.js"], n["Core/Renderer/RendererRegistry.js"], n["Core/Utilities.js"]], function(o, a, r, s, l, d) {
      var y;
      let { animObject: u } = o, { format: m } = a, { composed: h, doc: c, isSafari: g } = r, { distribute: v } = s, { addEvent: P, clamp: f, css: S, discardElement: w, extend: x, fireEvent: k, isArray: A, isNumber: $, isString: j, merge: N, pick: M, pushUnique: D, splat: C, syncTimeout: b } = d;
      class p {
        constructor(B, T, O) {
          this.allowShared = !0, this.crosshairs = [], this.distance = 0, this.isHidden = !0, this.isSticky = !1, this.options = {}, this.outside = !1, this.chart = B, this.init(B, T), this.pointer = O;
        }
        bodyFormatter(B) {
          return B.map(function(T) {
            let O = T.series.tooltipOptions;
            return (O[(T.point.formatPrefix || "point") + "Formatter"] || T.point.tooltipFormatter).call(T.point, O[(T.point.formatPrefix || "point") + "Format"] || "");
          });
        }
        cleanSplit(B) {
          this.chart.series.forEach(function(T) {
            let O = T && T.tt;
            O && (!O.isActive || B ? T.tt = O.destroy() : O.isActive = !1);
          });
        }
        defaultFormatter(B) {
          let T, O = this.points || C(this);
          return (T = (T = [B.tooltipFooterHeaderFormatter(O[0])]).concat(B.bodyFormatter(O))).push(B.tooltipFooterHeaderFormatter(O[0], !0)), T;
        }
        destroy() {
          this.label && (this.label = this.label.destroy()), this.split && (this.cleanSplit(!0), this.tt && (this.tt = this.tt.destroy())), this.renderer && (this.renderer = this.renderer.destroy(), w(this.container)), d.clearTimeout(this.hideTimer);
        }
        getAnchor(B, T) {
          let O, { chart: I, pointer: R } = this, Y = I.inverted, F = I.plotTop, U = I.plotLeft;
          if ((B = C(B))[0].series && B[0].series.yAxis && !B[0].series.yAxis.options.reversedStacks && (B = B.slice().reverse()), this.followPointer && T)
            T.chartX === void 0 && (T = R.normalize(T)), O = [T.chartX - U, T.chartY - F];
          else if (B[0].tooltipPos)
            O = B[0].tooltipPos;
          else {
            let Q = 0, J = 0;
            B.forEach(function(ee) {
              let V = ee.pos(!0);
              V && (Q += V[0], J += V[1]);
            }), Q /= B.length, J /= B.length, this.shared && B.length > 1 && T && (Y ? Q = T.chartX : J = T.chartY), O = [Q - U, J - F];
          }
          return O.map(Math.round);
        }
        getClassName(B, T, O) {
          let I = this.options, R = B.series, Y = R.options;
          return [I.className, "highcharts-label", O && "highcharts-tooltip-header", T ? "highcharts-tooltip-box" : "highcharts-tooltip", !O && "highcharts-color-" + M(B.colorIndex, R.colorIndex), Y && Y.className].filter(j).join(" ");
        }
        getLabel({ anchorX: B, anchorY: T } = { anchorX: 0, anchorY: 0 }) {
          let O = this, I = this.chart.styledMode, R = this.options, Y = this.split && this.allowShared, F = this.container, U = this.chart.renderer;
          if (this.label) {
            let Q = !this.label.hasClass("highcharts-label");
            (!Y && Q || Y && !Q) && this.destroy();
          }
          if (!this.label) {
            if (this.outside) {
              let Q = this.chart.options.chart.style, J = l.getRendererType();
              this.container = F = r.doc.createElement("div"), F.className = "highcharts-tooltip-container", S(F, { position: "absolute", top: "1px", pointerEvents: "none", zIndex: Math.max(this.options.style.zIndex || 0, (Q && Q.zIndex || 0) + 3) }), this.renderer = U = new J(F, 0, 0, Q, void 0, void 0, U.styledMode);
            }
            if (Y ? this.label = U.g("tooltip") : (this.label = U.label("", B, T, R.shape, void 0, void 0, R.useHTML, void 0, "tooltip").attr({ padding: R.padding, r: R.borderRadius }), I || this.label.attr({ fill: R.backgroundColor, "stroke-width": R.borderWidth || 0 }).css(R.style).css({ pointerEvents: R.style.pointerEvents || (this.shouldStickOnContact() ? "auto" : "none") })), O.outside) {
              let Q = this.label;
              [Q.xSetter, Q.ySetter].forEach((J, ee) => {
                Q[ee ? "ySetter" : "xSetter"] = (V) => {
                  J.call(Q, O.distance), Q[ee ? "y" : "x"] = V, F && (F.style[ee ? "top" : "left"] = `${V}px`);
                };
              });
            }
            this.label.attr({ zIndex: 8 }).shadow(R.shadow).add();
          }
          return F && !F.parentElement && r.doc.body.appendChild(F), this.label;
        }
        getPlayingField() {
          let { body: B, documentElement: T } = c, { chart: O, distance: I, outside: R } = this;
          return { width: R ? Math.max(B.scrollWidth, T.scrollWidth, B.offsetWidth, T.offsetWidth, T.clientWidth) - 2 * I : O.chartWidth, height: R ? Math.max(B.scrollHeight, T.scrollHeight, B.offsetHeight, T.offsetHeight, T.clientHeight) : O.chartHeight };
        }
        getPosition(B, T, O) {
          let { distance: I, chart: R, outside: Y, pointer: F } = this, { inverted: U, plotLeft: Q, plotTop: J, polar: ee } = R, { plotX: V = 0, plotY: G = 0 } = O, W = {}, ae = U && O.h || 0, { height: z, width: q } = this.getPlayingField(), Z = F.getChartPosition(), ne = (ye) => ye * Z.scaleX, ie = (ye) => ye * Z.scaleY, re = (ye) => {
            let be = ye === "x";
            return [ye, be ? q : z, be ? B : T].concat(Y ? [be ? ne(B) : ie(T), be ? Z.left - I + ne(V + Q) : Z.top - I + ie(G + J), 0, be ? q : z] : [be ? B : T, be ? V + Q : G + J, be ? Q : J, be ? Q + R.plotWidth : J + R.plotHeight]);
          }, de = re("y"), me = re("x"), ce, pe = !!O.negative;
          !ee && R.hoverSeries?.yAxis?.reversed && (pe = !pe);
          let xe = !this.followPointer && M(O.ttBelow, !ee && !U === pe), le = function(ye, be, ke, we, Le, Me, De) {
            let Ae = Y ? ye === "y" ? ie(I) : ne(I) : I, _e = (ke - we) / 2, He = we < Le - I, Ee = Le + I + we < be, Ne = Le - Ae - ke + _e, Ye = Le + Ae - _e;
            if (xe && Ee)
              W[ye] = Ye;
            else if (!xe && He)
              W[ye] = Ne;
            else if (He)
              W[ye] = Math.min(De - we, Ne - ae < 0 ? Ne : Ne - ae);
            else {
              if (!Ee)
                return !1;
              W[ye] = Math.max(Me, Ye + ae + ke > be ? Ye : Ye + ae);
            }
          }, se = function(ye, be, ke, we, Le) {
            if (Le < I || Le > be - I)
              return !1;
            Le < ke / 2 ? W[ye] = 1 : Le > be - we / 2 ? W[ye] = be - we - 2 : W[ye] = Le - ke / 2;
          }, he = function(ye) {
            [de, me] = [me, de], ce = ye;
          }, ve = () => {
            le.apply(0, de) !== !1 ? se.apply(0, me) !== !1 || ce || (he(!0), ve()) : ce ? W.x = W.y = 0 : (he(!0), ve());
          };
          return (U && !ee || this.len > 1) && he(), ve(), W;
        }
        hide(B) {
          let T = this;
          d.clearTimeout(this.hideTimer), B = M(B, this.options.hideDelay), this.isHidden || (this.hideTimer = b(function() {
            let O = T.getLabel();
            T.getLabel().animate({ opacity: 0 }, { duration: B && 150, complete: () => {
              O.hide(), T.container && T.container.remove();
            } }), T.isHidden = !0;
          }, B));
        }
        init(B, T) {
          this.chart = B, this.options = T, this.crosshairs = [], this.isHidden = !0, this.split = T.split && !B.inverted && !B.polar, this.shared = T.shared || this.split, this.outside = M(T.outside, !!(B.scrollablePixelsX || B.scrollablePixelsY));
        }
        shouldStickOnContact(B) {
          return !!(!this.followPointer && this.options.stickOnContact && (!B || this.pointer.inClass(B.target, "highcharts-tooltip")));
        }
        move(B, T, O, I) {
          let R = this, Y = u(!R.isHidden && R.options.animation), F = R.followPointer || (R.len || 0) > 1, U = { x: B, y: T };
          F || (U.anchorX = O, U.anchorY = I), Y.step = () => R.drawTracker(), R.getLabel().animate(U, Y);
        }
        refresh(B, T) {
          let { chart: O, options: I, pointer: R, shared: Y } = this, F = C(B), U = F[0], Q = [], J = I.format, ee = I.formatter || this.defaultFormatter, V = O.styledMode, G = {}, W = this.allowShared;
          if (!I.enabled || !U.series)
            return;
          d.clearTimeout(this.hideTimer), this.allowShared = !(!A(B) && B.series && B.series.noSharedTooltip), W = W && !this.allowShared, this.followPointer = !this.split && U.series.tooltipOptions.followPointer;
          let ae = this.getAnchor(B, T), z = ae[0], q = ae[1];
          Y && this.allowShared ? (R.applyInactiveState(F), F.forEach(function(ie) {
            ie.setState("hover"), Q.push(ie.getLabelConfig());
          }), (G = U.getLabelConfig()).points = Q) : G = U.getLabelConfig(), this.len = Q.length;
          let Z = j(J) ? m(J, G, O) : ee.call(G, this), ne = U.series;
          if (this.distance = M(ne.tooltipOptions.distance, 16), Z === !1)
            this.hide();
          else {
            if (this.split && this.allowShared)
              this.renderSplit(Z, F);
            else {
              let ie = z, re = q;
              if (T && R.isDirectTouch && (ie = T.chartX - O.plotLeft, re = T.chartY - O.plotTop), O.polar || ne.options.clip === !1 || F.some((de) => R.isDirectTouch || de.series.shouldShowTooltip(ie, re))) {
                let de = this.getLabel(W && this.tt || {});
                (!I.style.width || V) && de.css({ width: (this.outside ? this.getPlayingField() : O.spacingBox).width + "px" }), de.attr({ class: this.getClassName(U), text: Z && Z.join ? Z.join("") : Z }), this.outside && de.attr({ x: f(de.x || 0, 0, this.getPlayingField().width - (de.width || 0)) }), V || de.attr({ stroke: I.borderColor || U.color || ne.color || "#666666" }), this.updatePosition({ plotX: z, plotY: q, negative: U.negative, ttBelow: U.ttBelow, h: ae[2] || 0 });
              } else {
                this.hide();
                return;
              }
            }
            this.isHidden && this.label && this.label.attr({ opacity: 1 }).show(), this.isHidden = !1;
          }
          k(this, "refresh");
        }
        renderSplit(B, T) {
          let O = this, { chart: I, chart: { chartWidth: R, chartHeight: Y, plotHeight: F, plotLeft: U, plotTop: Q, scrollablePixelsY: J = 0, scrollablePixelsX: ee, styledMode: V }, distance: G, options: W, options: { positioner: ae }, pointer: z } = O, { scrollLeft: q = 0, scrollTop: Z = 0 } = I.scrollablePlotArea?.scrollingContainer || {}, ne = O.outside && typeof ee != "number" ? c.documentElement.getBoundingClientRect() : { left: q, right: q + R, top: Z, bottom: Z + Y }, ie = O.getLabel(), re = this.renderer || I.renderer, de = !!(I.xAxis[0] && I.xAxis[0].opposite), { left: me, top: ce } = z.getChartPosition(), pe = Q + Z, xe = 0, le = F - J;
          function se(we, Le, Me, De, Ae = !0) {
            let _e, He;
            return Me ? (_e = de ? 0 : le, He = f(we - De / 2, ne.left, ne.right - De - (O.outside ? me : 0))) : (_e = Le - pe, He = f(He = Ae ? we - De - G : we + G, Ae ? He : ne.left, ne.right)), { x: He, y: _e };
          }
          j(B) && (B = [!1, B]);
          let he = B.slice(0, T.length + 1).reduce(function(we, Le, Me) {
            if (Le !== !1 && Le !== "") {
              let De = T[Me - 1] || { isHeader: !0, plotX: T[0].plotX, plotY: F, series: {} }, Ae = De.isHeader, _e = Ae ? O : De.series, He = _e.tt = function(nt, ut, bt) {
                let Bt = nt, { isHeader: kt, series: nn } = ut;
                if (!Bt) {
                  let an = { padding: W.padding, r: W.borderRadius };
                  V || (an.fill = W.backgroundColor, an["stroke-width"] = W.borderWidth ?? 1), Bt = re.label("", 0, 0, W[kt ? "headerShape" : "shape"], void 0, void 0, W.useHTML).addClass(O.getClassName(ut, !0, kt)).attr(an).add(ie);
                }
                return Bt.isActive = !0, Bt.attr({ text: bt }), V || Bt.css(W.style).attr({ stroke: W.borderColor || ut.color || nn.color || "#333333" }), Bt;
              }(_e.tt, De, Le.toString()), Ee = He.getBBox(), Ne = Ee.width + He.strokeWidth();
              Ae && (xe = Ee.height, le += xe, de && (pe -= xe));
              let { anchorX: Ye, anchorY: Xe } = function(nt) {
                let ut, bt, { isHeader: Bt, plotX: kt = 0, plotY: nn = 0, series: an } = nt;
                if (Bt)
                  ut = Math.max(U + kt, U), bt = Q + F / 2;
                else {
                  let { xAxis: Cn, yAxis: Ft } = an;
                  ut = Cn.pos + f(kt, -G, Cn.len + G), an.shouldShowTooltip(0, Ft.pos - Q + nn, { ignoreX: !0 }) && (bt = Ft.pos + nn);
                }
                return { anchorX: ut = f(ut, ne.left - G, ne.right + G), anchorY: bt };
              }(De);
              if (typeof Xe == "number") {
                let nt = Ee.height + 1, ut = ae ? ae.call(O, Ne, nt, De) : se(Ye, Xe, Ae, Ne);
                we.push({ align: ae ? 0 : void 0, anchorX: Ye, anchorY: Xe, boxWidth: Ne, point: De, rank: M(ut.rank, Ae ? 1 : 0), size: nt, target: ut.y, tt: He, x: ut.x });
              } else
                He.isActive = !1;
            }
            return we;
          }, []);
          !ae && he.some((we) => {
            let { outside: Le } = O, Me = (Le ? me : 0) + we.anchorX;
            return Me < ne.left && Me + we.boxWidth < ne.right || Me < me - ne.left + we.boxWidth && ne.right - Me > Me;
          }) && (he = he.map((we) => {
            let { x: Le, y: Me } = se(we.anchorX, we.anchorY, we.point.isHeader, we.boxWidth, !1);
            return x(we, { target: Me, x: Le });
          })), O.cleanSplit(), v(he, le);
          let ve = { left: me, right: me };
          he.forEach(function(we) {
            let { x: Le, boxWidth: Me, isHeader: De } = we;
            !De && (O.outside && me + Le < ve.left && (ve.left = me + Le), !De && O.outside && ve.left + Me > ve.right && (ve.right = me + Le));
          }), he.forEach(function(we) {
            let { x: Le, anchorX: Me, anchorY: De, pos: Ae, point: { isHeader: _e } } = we, He = { visibility: Ae === void 0 ? "hidden" : "inherit", x: Le, y: (Ae || 0) + pe, anchorX: Me, anchorY: De };
            if (O.outside && Le < Me) {
              let Ee = me - ve.left;
              Ee > 0 && (_e || (He.x = Le + Ee, He.anchorX = Me + Ee), _e && (He.x = (ve.right - ve.left) / 2, He.anchorX = Me + Ee));
            }
            we.tt.attr(He);
          });
          let { container: ye, outside: be, renderer: ke } = O;
          if (be && ye && ke) {
            let { width: we, height: Le, x: Me, y: De } = ie.getBBox();
            ke.setSize(we + Me, Le + De, !1), ye.style.left = ve.left + "px", ye.style.top = ce + "px";
          }
          g && ie.attr({ opacity: ie.opacity === 1 ? 0.999 : 1 });
        }
        drawTracker() {
          if (!this.shouldStickOnContact()) {
            this.tracker && (this.tracker = this.tracker.destroy());
            return;
          }
          let B = this.chart, T = this.label, O = this.shared ? B.hoverPoints : B.hoverPoint;
          if (!T || !O)
            return;
          let I = { x: 0, y: 0, width: 0, height: 0 }, R = this.getAnchor(O), Y = T.getBBox();
          R[0] += B.plotLeft - (T.translateX || 0), R[1] += B.plotTop - (T.translateY || 0), I.x = Math.min(0, R[0]), I.y = Math.min(0, R[1]), I.width = R[0] < 0 ? Math.max(Math.abs(R[0]), Y.width - R[0]) : Math.max(Math.abs(R[0]), Y.width), I.height = R[1] < 0 ? Math.max(Math.abs(R[1]), Y.height - Math.abs(R[1])) : Math.max(Math.abs(R[1]), Y.height), this.tracker ? this.tracker.attr(I) : (this.tracker = T.renderer.rect(I).addClass("highcharts-tracker").add(T), B.styledMode || this.tracker.attr({ fill: "rgba(0,0,0,0)" }));
        }
        styledModeFormat(B) {
          return B.replace('style="font-size: 0.8em"', 'class="highcharts-header"').replace(/style="color:{(point|series)\.color}"/g, 'class="highcharts-color-{$1.colorIndex} {series.options.className} {point.options.className}"');
        }
        tooltipFooterHeaderFormatter(B, T) {
          let O = B.series, I = O.tooltipOptions, R = O.xAxis, Y = R && R.dateTime, F = { isFooter: T, labelConfig: B }, U = I.xDateFormat, Q = I[T ? "footerFormat" : "headerFormat"];
          return k(this, "headerFormatter", F, function(J) {
            Y && !U && $(B.key) && (U = Y.getXDateFormat(B.key, I.dateTimeLabelFormats)), Y && U && (B.point && B.point.tooltipDateKeys || ["key"]).forEach(function(ee) {
              Q = Q.replace("{point." + ee + "}", "{point." + ee + ":" + U + "}");
            }), O.chart.styledMode && (Q = this.styledModeFormat(Q)), J.text = m(Q, { point: B, series: O }, this.chart);
          }), F.text;
        }
        update(B) {
          this.destroy(), this.init(this.chart, N(!0, this.options, B));
        }
        updatePosition(B) {
          let { chart: T, container: O, distance: I, options: R, pointer: Y, renderer: F } = this, { height: U = 0, width: Q = 0 } = this.getLabel(), { left: J, top: ee, scaleX: V, scaleY: G } = Y.getChartPosition(), W = (R.positioner || this.getPosition).call(this, Q, U, B), ae = (B.plotX || 0) + T.plotLeft, z = (B.plotY || 0) + T.plotTop, q;
          F && O && (R.positioner && (W.x += J - I, W.y += ee - I), q = (R.borderWidth || 0) + 2 * I + 2, F.setSize(Q + q, U + q, !1), (V !== 1 || G !== 1) && (S(O, { transform: `scale(${V}, ${G})` }), ae *= V, z *= G), ae += J - W.x, z += ee - W.y), this.move(Math.round(W.x), Math.round(W.y || 0), ae, z);
        }
      }
      return (y = p || (p = {})).compose = function(L) {
        D(h, "Core.Tooltip") && P(L, "afterInit", function() {
          let B = this.chart;
          B.options.tooltip && (B.tooltip = new y(B, B.options.tooltip, this));
        });
      }, p;
    }), i(n, "Core/Series/Point.js", [n["Core/Renderer/HTML/AST.js"], n["Core/Animation/AnimationUtilities.js"], n["Core/Defaults.js"], n["Core/Templating.js"], n["Core/Utilities.js"]], function(o, a, r, s, l) {
      let { animObject: d } = a, { defaultOptions: y } = r, { format: u } = s, { addEvent: m, crisp: h, erase: c, extend: g, fireEvent: v, getNestedProperty: P, isArray: f, isFunction: S, isNumber: w, isObject: x, merge: k, pick: A, syncTimeout: $, removeEvent: j, uniqueKey: N } = l;
      class M {
        animateBeforeDestroy() {
          let C = this, b = { x: C.startXPos, opacity: 0 }, p = C.getGraphicalProps();
          p.singular.forEach(function(L) {
            C[L] = C[L].animate(L === "dataLabel" ? { x: C[L].startXPos, y: C[L].startYPos, opacity: 0 } : b);
          }), p.plural.forEach(function(L) {
            C[L].forEach(function(B) {
              B.element && B.animate(g({ x: C.startXPos }, B.startYPos ? { x: B.startXPos, y: B.startYPos } : {}));
            });
          });
        }
        applyOptions(C, b) {
          let p = this.series, L = p.options.pointValKey || p.pointValKey;
          return g(this, C = M.prototype.optionsToObject.call(this, C)), this.options = this.options ? g(this.options, C) : C, C.group && delete this.group, C.dataLabels && delete this.dataLabels, L && (this.y = M.prototype.getNestedProperty.call(this, L)), this.selected && (this.state = "select"), "name" in this && b === void 0 && p.xAxis && p.xAxis.hasNames && (this.x = p.xAxis.nameToX(this)), this.x === void 0 && p ? this.x = b ?? p.autoIncrement() : w(C.x) && p.options.relativeXValue && (this.x = p.autoIncrement(C.x)), this.isNull = this.isValid && !this.isValid(), this.formatPrefix = this.isNull ? "null" : "point", this;
        }
        destroy() {
          if (!this.destroyed) {
            let C = this, b = C.series, p = b.chart, L = b.options.dataSorting, B = p.hoverPoints, T = d(C.series.chart.renderer.globalAnimation), O = () => {
              for (let I in (C.graphic || C.graphics || C.dataLabel || C.dataLabels) && (j(C), C.destroyElements()), C)
                delete C[I];
            };
            C.legendItem && p.legend.destroyItem(C), B && (C.setState(), c(B, C), B.length || (p.hoverPoints = null)), C === p.hoverPoint && C.onMouseOut(), L && L.enabled ? (this.animateBeforeDestroy(), $(O, T.duration)) : O(), p.pointCount--;
          }
          this.destroyed = !0;
        }
        destroyElements(C) {
          let b = this, p = b.getGraphicalProps(C);
          p.singular.forEach(function(L) {
            b[L] = b[L].destroy();
          }), p.plural.forEach(function(L) {
            b[L].forEach(function(B) {
              B && B.element && B.destroy();
            }), delete b[L];
          });
        }
        firePointEvent(C, b, p) {
          let L = this, B = this.series.options;
          L.manageEvent(C), C === "click" && B.allowPointSelect && (p = function(T) {
            !L.destroyed && L.select && L.select(null, T.ctrlKey || T.metaKey || T.shiftKey);
          }), v(L, C, b, p);
        }
        getClassName() {
          return "highcharts-point" + (this.selected ? " highcharts-point-select" : "") + (this.negative ? " highcharts-negative" : "") + (this.isNull ? " highcharts-null-point" : "") + (this.colorIndex !== void 0 ? " highcharts-color-" + this.colorIndex : "") + (this.options.className ? " " + this.options.className : "") + (this.zone && this.zone.className ? " " + this.zone.className.replace("highcharts-negative", "") : "");
        }
        getGraphicalProps(C) {
          let b, p, L = this, B = [], T = { singular: [], plural: [] };
          for ((C = C || { graphic: 1, dataLabel: 1 }).graphic && B.push("graphic", "connector"), C.dataLabel && B.push("dataLabel", "dataLabelPath", "dataLabelUpper"), p = B.length; p--; )
            L[b = B[p]] && T.singular.push(b);
          return ["graphic", "dataLabel"].forEach(function(O) {
            let I = O + "s";
            C[O] && L[I] && T.plural.push(I);
          }), T;
        }
        getLabelConfig() {
          return { x: this.category, y: this.y, color: this.color, colorIndex: this.colorIndex, key: this.name || this.category, series: this.series, point: this, percentage: this.percentage, total: this.total || this.stackTotal };
        }
        getNestedProperty(C) {
          return C ? C.indexOf("custom.") === 0 ? P(C, this.options) : this[C] : void 0;
        }
        getZone() {
          let C = this.series, b = C.zones, p = C.zoneAxis || "y", L, B = 0;
          for (L = b[0]; this[p] >= L.value; )
            L = b[++B];
          return this.nonZonedColor || (this.nonZonedColor = this.color), L && L.color && !this.options.color ? this.color = L.color : this.color = this.nonZonedColor, L;
        }
        hasNewShapeType() {
          return (this.graphic && (this.graphic.symbolName || this.graphic.element.nodeName)) !== this.shapeType;
        }
        constructor(C, b, p) {
          this.formatPrefix = "point", this.visible = !0, this.series = C, this.applyOptions(b, p), this.id ?? (this.id = N()), this.resolveColor(), C.chart.pointCount++, v(this, "afterInit");
        }
        isValid() {
          return (w(this.x) || this.x instanceof Date) && w(this.y);
        }
        optionsToObject(C) {
          let b = this.series, p = b.options.keys, L = p || b.pointArrayMap || ["y"], B = L.length, T = {}, O, I = 0, R = 0;
          if (w(C) || C === null)
            T[L[0]] = C;
          else if (f(C))
            for (!p && C.length > B && ((O = typeof C[0]) == "string" ? T.name = C[0] : O === "number" && (T.x = C[0]), I++); R < B; )
              p && C[I] === void 0 || (L[R].indexOf(".") > 0 ? M.prototype.setNestedProperty(T, C[I], L[R]) : T[L[R]] = C[I]), I++, R++;
          else
            typeof C == "object" && (T = C, C.dataLabels && (b.hasDataLabels = () => !0), C.marker && (b._hasPointMarkers = !0));
          return T;
        }
        pos(C, b = this.plotY) {
          if (!this.destroyed) {
            let { plotX: p, series: L } = this, { chart: B, xAxis: T, yAxis: O } = L, I = 0, R = 0;
            if (w(p) && w(b))
              return C && (I = T ? T.pos : B.plotLeft, R = O ? O.pos : B.plotTop), B.inverted && T && O ? [O.len - b + R, T.len - p + I] : [p + I, b + R];
          }
        }
        resolveColor() {
          let C = this.series, b = C.chart.options.chart, p = C.chart.styledMode, L, B, T = b.colorCount, O;
          delete this.nonZonedColor, C.options.colorByPoint ? (p || (L = (B = C.options.colors || C.chart.options.colors)[C.colorCounter], T = B.length), O = C.colorCounter, C.colorCounter++, C.colorCounter === T && (C.colorCounter = 0)) : (p || (L = C.color), O = C.colorIndex), this.colorIndex = A(this.options.colorIndex, O), this.color = A(this.options.color, L);
        }
        setNestedProperty(C, b, p) {
          return p.split(".").reduce(function(L, B, T, O) {
            let I = O.length - 1 === T;
            return L[B] = I ? b : x(L[B], !0) ? L[B] : {}, L[B];
          }, C), C;
        }
        shouldDraw() {
          return !this.isNull;
        }
        tooltipFormatter(C) {
          let b = this.series, p = b.tooltipOptions, L = A(p.valueDecimals, ""), B = p.valuePrefix || "", T = p.valueSuffix || "";
          return b.chart.styledMode && (C = b.chart.tooltip.styledModeFormat(C)), (b.pointArrayMap || ["y"]).forEach(function(O) {
            O = "{point." + O, (B || T) && (C = C.replace(RegExp(O + "}", "g"), B + O + "}" + T)), C = C.replace(RegExp(O + "}", "g"), O + ":,." + L + "f}");
          }), u(C, { point: this, series: this.series }, b.chart);
        }
        update(C, b, p, L) {
          let B, T = this, O = T.series, I = T.graphic, R = O.chart, Y = O.options;
          function F() {
            T.applyOptions(C);
            let U = I && T.hasMockGraphic, Q = T.y === null ? !U : U;
            I && Q && (T.graphic = I.destroy(), delete T.hasMockGraphic), x(C, !0) && (I && I.element && C && C.marker && C.marker.symbol !== void 0 && (T.graphic = I.destroy()), C?.dataLabels && T.dataLabel && (T.dataLabel = T.dataLabel.destroy())), B = T.index, O.updateParallelArrays(T, B), Y.data[B] = x(Y.data[B], !0) || x(C, !0) ? T.options : A(C, Y.data[B]), O.isDirty = O.isDirtyData = !0, !O.fixedBox && O.hasCartesianSeries && (R.isDirtyBox = !0), Y.legendType === "point" && (R.isDirtyLegend = !0), b && R.redraw(p);
          }
          b = A(b, !0), L === !1 ? F() : T.firePointEvent("update", { options: C }, F);
        }
        remove(C, b) {
          this.series.removePoint(this.series.data.indexOf(this), C, b);
        }
        select(C, b) {
          let p = this, L = p.series, B = L.chart;
          C = A(C, !p.selected), this.selectedStaging = C, p.firePointEvent(C ? "select" : "unselect", { accumulate: b }, function() {
            p.selected = p.options.selected = C, L.options.data[L.data.indexOf(p)] = p.options, p.setState(C && "select"), b || B.getSelectedPoints().forEach(function(T) {
              let O = T.series;
              T.selected && T !== p && (T.selected = T.options.selected = !1, O.options.data[O.data.indexOf(T)] = T.options, T.setState(B.hoverPoints && O.options.inactiveOtherPoints ? "inactive" : ""), T.firePointEvent("unselect"));
            });
          }), delete this.selectedStaging;
        }
        onMouseOver(C) {
          let { inverted: b, pointer: p } = this.series.chart;
          p && (C = C ? p.normalize(C) : p.getChartCoordinatesFromPoint(this, b), p.runPointActions(C, this));
        }
        onMouseOut() {
          let C = this.series.chart;
          this.firePointEvent("mouseOut"), this.series.options.inactiveOtherPoints || (C.hoverPoints || []).forEach(function(b) {
            b.setState();
          }), C.hoverPoints = C.hoverPoint = null;
        }
        manageEvent(C) {
          let b = k(this.series.options.point, this.options), p = b.events?.[C];
          S(p) && (!this.hcEvents?.[C] || this.hcEvents?.[C]?.map((L) => L.fn).indexOf(p) === -1) ? (this.importedUserEvent?.(), this.importedUserEvent = m(this, C, p)) : this.importedUserEvent && !p && this.hcEvents?.[C] && (j(this, C), delete this.hcEvents[C], Object.keys(this.hcEvents) || delete this.importedUserEvent);
        }
        setState(C, b) {
          let p = this.series, L = this.state, B = p.options.states[C || "normal"] || {}, T = y.plotOptions[p.type].marker && p.options.marker, O = T && T.enabled === !1, I = T && T.states && T.states[C || "normal"] || {}, R = I.enabled === !1, Y = this.marker || {}, F = p.chart, U = T && p.markerAttribs, Q = p.halo, J, ee, V, G = p.stateMarkerGraphic, W;
          if ((C = C || "") === this.state && !b || this.selected && C !== "select" || B.enabled === !1 || C && (R || O && I.enabled === !1) || C && Y.states && Y.states[C] && Y.states[C].enabled === !1)
            return;
          if (this.state = C, U && (J = p.markerAttribs(this, C)), this.graphic && !this.hasMockGraphic) {
            if (L && this.graphic.removeClass("highcharts-point-" + L), C && this.graphic.addClass("highcharts-point-" + C), !F.styledMode) {
              ee = p.pointAttribs(this, C), V = A(F.options.chart.animation, B.animation);
              let Z = ee.opacity;
              p.options.inactiveOtherPoints && w(Z) && (this.dataLabels || []).forEach(function(ne) {
                ne && !ne.hasClass("highcharts-data-label-hidden") && (ne.animate({ opacity: Z }, V), ne.connector && ne.connector.animate({ opacity: Z }, V));
              }), this.graphic.animate(ee, V);
            }
            J && this.graphic.animate(J, A(F.options.chart.animation, I.animation, T.animation)), G && G.hide();
          } else
            C && I && (W = Y.symbol || p.symbol, G && G.currentSymbol !== W && (G = G.destroy()), J && (G ? G[b ? "animate" : "attr"]({ x: J.x, y: J.y }) : W && (p.stateMarkerGraphic = G = F.renderer.symbol(W, J.x, J.y, J.width, J.height).add(p.markerGroup), G.currentSymbol = W)), !F.styledMode && G && this.state !== "inactive" && G.attr(p.pointAttribs(this, C))), G && (G[C && this.isInside ? "show" : "hide"](), G.element.point = this, G.addClass(this.getClassName(), !0));
          let ae = B.halo, z = this.graphic || G, q = z && z.visibility || "inherit";
          ae && ae.size && z && q !== "hidden" && !this.isCluster ? (Q || (p.halo = Q = F.renderer.path().add(z.parentGroup)), Q.show()[b ? "animate" : "attr"]({ d: this.haloPath(ae.size) }), Q.attr({ class: "highcharts-halo highcharts-color-" + A(this.colorIndex, p.colorIndex) + (this.className ? " " + this.className : ""), visibility: q, zIndex: -1 }), Q.point = this, F.styledMode || Q.attr(g({ fill: this.color || p.color, "fill-opacity": ae.opacity }, o.filterUserAttributes(ae.attributes || {})))) : Q?.point?.haloPath && !Q.point.destroyed && Q.animate({ d: Q.point.haloPath(0) }, null, Q.hide), v(this, "afterSetState", { state: C });
        }
        haloPath(C) {
          let b = this.pos();
          return b ? this.series.chart.renderer.symbols.circle(h(b[0], 1) - C, b[1] - C, 2 * C, 2 * C) : [];
        }
      }
      return M;
    }), i(n, "Core/Pointer.js", [n["Core/Color/Color.js"], n["Core/Globals.js"], n["Core/Utilities.js"]], function(o, a, r) {
      var s;
      let { parse: l } = o, { charts: d, composed: y, isTouchDevice: u } = a, { addEvent: m, attr: h, css: c, extend: g, find: v, fireEvent: P, isNumber: f, isObject: S, objectEach: w, offset: x, pick: k, pushUnique: A, splat: $ } = r;
      class j {
        applyInactiveState(M) {
          let D = [], C;
          (M || []).forEach(function(b) {
            C = b.series, D.push(C), C.linkedParent && D.push(C.linkedParent), C.linkedSeries && (D = D.concat(C.linkedSeries)), C.navigatorSeries && D.push(C.navigatorSeries);
          }), this.chart.series.forEach(function(b) {
            D.indexOf(b) === -1 ? b.setState("inactive", !0) : b.options.inactiveOtherPoints && b.setAllPointsToState("inactive");
          });
        }
        destroy() {
          let M = this;
          this.eventsToUnbind.forEach((D) => D()), this.eventsToUnbind = [], !a.chartCount && (j.unbindDocumentMouseUp && j.unbindDocumentMouseUp.forEach((D) => D()), j.unbindDocumentTouchEnd && (j.unbindDocumentTouchEnd = j.unbindDocumentTouchEnd())), clearInterval(M.tooltipTimeout), w(M, function(D, C) {
            M[C] = void 0;
          });
        }
        getSelectionMarkerAttrs(M, D) {
          let C = { args: { chartX: M, chartY: D }, attrs: {}, shapeType: "rect" };
          return P(this, "getSelectionMarkerAttrs", C, (b) => {
            let p, { chart: L, zoomHor: B, zoomVert: T } = this, { mouseDownX: O = 0, mouseDownY: I = 0 } = L, R = b.attrs;
            R.x = L.plotLeft, R.y = L.plotTop, R.width = B ? 1 : L.plotWidth, R.height = T ? 1 : L.plotHeight, B && (p = M - O, R.width = Math.max(1, Math.abs(p)), R.x = (p > 0 ? 0 : p) + O), T && (p = D - I, R.height = Math.max(1, Math.abs(p)), R.y = (p > 0 ? 0 : p) + I);
          }), C;
        }
        drag(M) {
          let { chart: D } = this, { mouseDownX: C = 0, mouseDownY: b = 0 } = D, { panning: p, panKey: L, selectionMarkerFill: B } = D.options.chart, T = D.plotLeft, O = D.plotTop, I = D.plotWidth, R = D.plotHeight, Y = S(p) ? p.enabled : p, F = L && M[`${L}Key`], U = M.chartX, Q = M.chartY, J, ee = this.selectionMarker;
          if ((!ee || !ee.touch) && (U < T ? U = T : U > T + I && (U = T + I), Q < O ? Q = O : Q > O + R && (Q = O + R), this.hasDragged = Math.sqrt(Math.pow(C - U, 2) + Math.pow(b - Q, 2)), this.hasDragged > 10)) {
            J = D.isInsidePlot(C - T, b - O, { visiblePlotOnly: !0 });
            let { shapeType: V, attrs: G } = this.getSelectionMarkerAttrs(U, Q);
            (D.hasCartesianSeries || D.mapView) && this.hasZoom && J && !F && !ee && (this.selectionMarker = ee = D.renderer[V](), ee.attr({ class: "highcharts-selection-marker", zIndex: 7 }).add(), D.styledMode || ee.attr({ fill: B || l("#334eff").setOpacity(0.25).get() })), ee && ee.attr(G), J && !ee && Y && D.pan(M, p);
          }
        }
        dragStart(M) {
          let D = this.chart;
          D.mouseIsDown = M.type, D.cancelClick = !1, D.mouseDownX = M.chartX, D.mouseDownY = M.chartY;
        }
        getSelectionBox(M) {
          let D = { args: { marker: M }, result: M.getBBox() };
          return P(this, "getSelectionBox", D), D.result;
        }
        drop(M) {
          let D, { chart: C, selectionMarker: b } = this;
          for (let p of C.axes)
            p.isPanning && (p.isPanning = !1, (p.options.startOnTick || p.options.endOnTick || p.series.some((L) => L.boosted)) && (p.forceRedraw = !0, p.setExtremes(p.userMin, p.userMax, !1), D = !0));
          if (D && C.redraw(), b && M) {
            if (this.hasDragged) {
              let p = this.getSelectionBox(b);
              C.transform({ axes: C.axes.filter((L) => L.zoomEnabled && (L.coll === "xAxis" && this.zoomX || L.coll === "yAxis" && this.zoomY)), selection: { originalEvent: M, xAxis: [], yAxis: [], ...p }, from: p });
            }
            f(C.index) && (this.selectionMarker = b.destroy());
          }
          C && f(C.index) && (c(C.container, { cursor: C._cursor }), C.cancelClick = this.hasDragged > 10, C.mouseIsDown = !1, this.hasDragged = 0, this.pinchDown = []);
        }
        findNearestKDPoint(M, D, C) {
          let b;
          return M.forEach(function(p) {
            let L = !(p.noSharedTooltip && D) && 0 > p.options.findNearestPointBy.indexOf("y"), B = p.searchPoint(C, L);
            S(B, !0) && B.series && (!S(b, !0) || function(T, O) {
              let I = T.distX - O.distX, R = T.dist - O.dist, Y = O.series.group?.zIndex - T.series.group?.zIndex;
              return I !== 0 && D ? I : R !== 0 ? R : Y !== 0 ? Y : T.series.index > O.series.index ? -1 : 1;
            }(b, B) > 0) && (b = B);
          }), b;
        }
        getChartCoordinatesFromPoint(M, D) {
          let { xAxis: C, yAxis: b } = M.series, p = M.shapeArgs;
          if (C && b) {
            let L = M.clientX ?? M.plotX ?? 0, B = M.plotY || 0;
            return M.isNode && p && f(p.x) && f(p.y) && (L = p.x, B = p.y), D ? { chartX: b.len + b.pos - B, chartY: C.len + C.pos - L } : { chartX: L + C.pos, chartY: B + b.pos };
          }
          if (p && p.x && p.y)
            return { chartX: p.x, chartY: p.y };
        }
        getChartPosition() {
          if (this.chartPosition)
            return this.chartPosition;
          let { container: M } = this.chart, D = x(M);
          this.chartPosition = { left: D.left, top: D.top, scaleX: 1, scaleY: 1 };
          let { offsetHeight: C, offsetWidth: b } = M;
          return b > 2 && C > 2 && (this.chartPosition.scaleX = D.width / b, this.chartPosition.scaleY = D.height / C), this.chartPosition;
        }
        getCoordinates(M) {
          let D = { xAxis: [], yAxis: [] };
          for (let C of this.chart.axes)
            D[C.isXAxis ? "xAxis" : "yAxis"].push({ axis: C, value: C.toValue(M[C.horiz ? "chartX" : "chartY"]) });
          return D;
        }
        getHoverData(M, D, C, b, p, L) {
          let B = [], T = function(F) {
            return F.visible && !(!p && F.directTouch) && k(F.options.enableMouseTracking, !0);
          }, O = D, I, R = { chartX: L ? L.chartX : void 0, chartY: L ? L.chartY : void 0, shared: p };
          P(this, "beforeGetHoverData", R), I = O && !O.stickyTracking ? [O] : C.filter((F) => F.stickyTracking && (R.filter || T)(F));
          let Y = b && M || !L ? M : this.findNearestKDPoint(I, p, L);
          return O = Y && Y.series, Y && (p && !O.noSharedTooltip ? (I = C.filter(function(F) {
            return R.filter ? R.filter(F) : T(F) && !F.noSharedTooltip;
          })).forEach(function(F) {
            let U = v(F.points, function(Q) {
              return Q.x === Y.x && !Q.isNull;
            });
            S(U) && (F.boosted && F.boost && (U = F.boost.getPoint(U)), B.push(U));
          }) : B.push(Y)), P(this, "afterGetHoverData", R = { hoverPoint: Y }), { hoverPoint: R.hoverPoint, hoverSeries: O, hoverPoints: B };
        }
        getPointFromEvent(M) {
          let D = M.target, C;
          for (; D && !C; )
            C = D.point, D = D.parentNode;
          return C;
        }
        onTrackerMouseOut(M) {
          let D = this.chart, C = M.relatedTarget, b = D.hoverSeries;
          this.isDirectTouch = !1, !b || !C || b.stickyTracking || this.inClass(C, "highcharts-tooltip") || this.inClass(C, "highcharts-series-" + b.index) && this.inClass(C, "highcharts-tracker") || b.onMouseOut();
        }
        inClass(M, D) {
          let C = M, b;
          for (; C; ) {
            if (b = h(C, "class")) {
              if (b.indexOf(D) !== -1)
                return !0;
              if (b.indexOf("highcharts-container") !== -1)
                return !1;
            }
            C = C.parentElement;
          }
        }
        constructor(M, D) {
          this.hasDragged = 0, this.pointerCaptureEventsToUnbind = [], this.eventsToUnbind = [], this.options = D, this.chart = M, this.runChartClick = !!D.chart.events?.click, this.pinchDown = [], this.setDOMEvents(), P(this, "afterInit");
        }
        normalize(M, D) {
          let C = M.touches, b = C ? C.length ? C.item(0) : k(C.changedTouches, M.changedTouches)[0] : M;
          D || (D = this.getChartPosition());
          let p = b.pageX - D.left, L = b.pageY - D.top;
          return g(M, { chartX: Math.round(p /= D.scaleX), chartY: Math.round(L /= D.scaleY) });
        }
        onContainerClick(M) {
          let D = this.chart, C = D.hoverPoint, b = this.normalize(M), p = D.plotLeft, L = D.plotTop;
          !D.cancelClick && (C && this.inClass(b.target, "highcharts-tracker") ? (P(C.series, "click", g(b, { point: C })), D.hoverPoint && C.firePointEvent("click", b)) : (g(b, this.getCoordinates(b)), D.isInsidePlot(b.chartX - p, b.chartY - L, { visiblePlotOnly: !0 }) && P(D, "click", b)));
        }
        onContainerMouseDown(M) {
          let D = (1 & (M.buttons || M.button)) == 1;
          M = this.normalize(M), a.isFirefox && M.button !== 0 && this.onContainerMouseMove(M), (M.button === void 0 || D) && (this.zoomOption(M), D && M.preventDefault?.(), this.dragStart(M));
        }
        onContainerMouseLeave(M) {
          let { pointer: D } = d[k(j.hoverChartIndex, -1)] || {};
          M = this.normalize(M), this.onContainerMouseMove(M), D && !this.inClass(M.relatedTarget, "highcharts-tooltip") && (D.reset(), D.chartPosition = void 0);
        }
        onContainerMouseEnter() {
          delete this.chartPosition;
        }
        onContainerMouseMove(M) {
          let D = this.chart, C = D.tooltip, b = this.normalize(M);
          this.setHoverChartIndex(M), (D.mouseIsDown === "mousedown" || this.touchSelect(b)) && this.drag(b), !D.openMenu && (this.inClass(b.target, "highcharts-tracker") || D.isInsidePlot(b.chartX - D.plotLeft, b.chartY - D.plotTop, { visiblePlotOnly: !0 })) && !(C && C.shouldStickOnContact(b)) && (this.inClass(b.target, "highcharts-no-tooltip") ? this.reset(!1, 0) : this.runPointActions(b));
        }
        onDocumentTouchEnd(M) {
          this.onDocumentMouseUp(M);
        }
        onContainerTouchMove(M) {
          this.touchSelect(M) ? this.onContainerMouseMove(M) : this.touch(M);
        }
        onContainerTouchStart(M) {
          this.touchSelect(M) ? this.onContainerMouseDown(M) : (this.zoomOption(M), this.touch(M, !0));
        }
        onDocumentMouseMove(M) {
          let D = this.chart, C = D.tooltip, b = this.chartPosition, p = this.normalize(M, b);
          !b || D.isInsidePlot(p.chartX - D.plotLeft, p.chartY - D.plotTop, { visiblePlotOnly: !0 }) || C && C.shouldStickOnContact(p) || p.target !== D.container.ownerDocument && this.inClass(p.target, "highcharts-tracker") || this.reset();
        }
        onDocumentMouseUp(M) {
          d[k(j.hoverChartIndex, -1)]?.pointer?.drop(M);
        }
        pinch(M) {
          let D = this, { chart: C, hasZoom: b, lastTouches: p } = D, L = [].map.call(M.touches || [], (R) => D.normalize(R)), B = L.length, T = B === 1 && (D.inClass(M.target, "highcharts-tracker") && C.runTrackerClick || D.runChartClick), O = C.tooltip, I = B === 1 && k(O?.options.followTouchMove, !0);
          B > 1 ? D.initiated = !0 : I && (D.initiated = !1), b && D.initiated && !T && M.cancelable !== !1 && M.preventDefault(), M.type === "touchstart" ? (D.pinchDown = L, D.res = !0, C.mouseDownX = M.chartX) : I ? this.runPointActions(D.normalize(M)) : p && (P(C, "touchpan", { originalEvent: M, touches: L }, () => {
            let R = (Y) => {
              let F = Y[0], U = Y[1] || F;
              return { x: F.chartX, y: F.chartY, width: U.chartX - F.chartX, height: U.chartY - F.chartY };
            };
            C.transform({ axes: C.axes.filter((Y) => Y.zoomEnabled && (this.zoomHor && Y.horiz || this.zoomVert && !Y.horiz)), to: R(L), from: R(p), trigger: M.type });
          }), D.res && (D.res = !1, this.reset(!1, 0))), D.lastTouches = L;
        }
        reset(M, D) {
          let C = this.chart, b = C.hoverSeries, p = C.hoverPoint, L = C.hoverPoints, B = C.tooltip, T = B && B.shared ? L : p;
          M && T && $(T).forEach(function(O) {
            O.series.isCartesian && O.plotX === void 0 && (M = !1);
          }), M ? B && T && $(T).length && (B.refresh(T), B.shared && L ? L.forEach(function(O) {
            O.setState(O.state, !0), O.series.isCartesian && (O.series.xAxis.crosshair && O.series.xAxis.drawCrosshair(null, O), O.series.yAxis.crosshair && O.series.yAxis.drawCrosshair(null, O));
          }) : p && (p.setState(p.state, !0), C.axes.forEach(function(O) {
            O.crosshair && p.series[O.coll] === O && O.drawCrosshair(null, p);
          }))) : (p && p.onMouseOut(), L && L.forEach(function(O) {
            O.setState();
          }), b && b.onMouseOut(), B && B.hide(D), this.unDocMouseMove && (this.unDocMouseMove = this.unDocMouseMove()), C.axes.forEach(function(O) {
            O.hideCrosshair();
          }), C.hoverPoints = C.hoverPoint = void 0);
        }
        runPointActions(M, D, C) {
          let b = this.chart, p = b.series, L = b.tooltip && b.tooltip.options.enabled ? b.tooltip : void 0, B = !!L && L.shared, T = D || b.hoverPoint, O = T && T.series || b.hoverSeries, I = (!M || M.type !== "touchmove") && (!!D || O && O.directTouch && this.isDirectTouch), R = this.getHoverData(T, O, p, I, B, M);
          T = R.hoverPoint, O = R.hoverSeries;
          let Y = R.hoverPoints, F = O && O.tooltipOptions.followPointer && !O.tooltipOptions.split, U = B && O && !O.noSharedTooltip;
          if (T && (C || T !== b.hoverPoint || L && L.isHidden)) {
            if ((b.hoverPoints || []).forEach(function(Q) {
              Y.indexOf(Q) === -1 && Q.setState();
            }), b.hoverSeries !== O && O.onMouseOver(), this.applyInactiveState(Y), (Y || []).forEach(function(Q) {
              Q.setState("hover");
            }), b.hoverPoint && b.hoverPoint.firePointEvent("mouseOut"), !T.series)
              return;
            b.hoverPoints = Y, b.hoverPoint = T, T.firePointEvent("mouseOver", void 0, () => {
              L && T && L.refresh(U ? Y : T, M);
            });
          } else if (F && L && !L.isHidden) {
            let Q = L.getAnchor([{}], M);
            b.isInsidePlot(Q[0], Q[1], { visiblePlotOnly: !0 }) && L.updatePosition({ plotX: Q[0], plotY: Q[1] });
          }
          this.unDocMouseMove || (this.unDocMouseMove = m(b.container.ownerDocument, "mousemove", (Q) => d[j.hoverChartIndex ?? -1]?.pointer?.onDocumentMouseMove(Q)), this.eventsToUnbind.push(this.unDocMouseMove)), b.axes.forEach(function(Q) {
            let J, ee = k((Q.crosshair || {}).snap, !0);
            !ee || (J = b.hoverPoint) && J.series[Q.coll] === Q || (J = v(Y, (V) => V.series && V.series[Q.coll] === Q)), J || !ee ? Q.drawCrosshair(M, J) : Q.hideCrosshair();
          });
        }
        setDOMEvents() {
          let M = this.chart.container, D = M.ownerDocument;
          M.onmousedown = this.onContainerMouseDown.bind(this), M.onmousemove = this.onContainerMouseMove.bind(this), M.onclick = this.onContainerClick.bind(this), this.eventsToUnbind.push(m(M, "mouseenter", this.onContainerMouseEnter.bind(this)), m(M, "mouseleave", this.onContainerMouseLeave.bind(this))), j.unbindDocumentMouseUp || (j.unbindDocumentMouseUp = []), j.unbindDocumentMouseUp.push(m(D, "mouseup", this.onDocumentMouseUp.bind(this)));
          let C = this.chart.renderTo.parentElement;
          for (; C && C.tagName !== "BODY"; )
            this.eventsToUnbind.push(m(C, "scroll", () => {
              delete this.chartPosition;
            })), C = C.parentElement;
          this.eventsToUnbind.push(m(M, "touchstart", this.onContainerTouchStart.bind(this), { passive: !1 }), m(M, "touchmove", this.onContainerTouchMove.bind(this), { passive: !1 })), j.unbindDocumentTouchEnd || (j.unbindDocumentTouchEnd = m(D, "touchend", this.onDocumentTouchEnd.bind(this), { passive: !1 })), this.setPointerCapture(), m(this.chart, "redraw", this.setPointerCapture.bind(this));
        }
        setPointerCapture() {
          if (!u)
            return;
          let M = this.pointerCaptureEventsToUnbind, D = this.chart, C = D.container, b = k(D.options.tooltip?.followTouchMove, !0) && D.series.some((p) => p.options.findNearestPointBy.indexOf("y") > -1);
          !this.hasPointerCapture && b ? (M.push(m(C, "pointerdown", (p) => {
            p.target?.hasPointerCapture(p.pointerId) && p.target?.releasePointerCapture(p.pointerId);
          }), m(C, "pointermove", (p) => {
            D.pointer?.getPointFromEvent(p)?.onMouseOver(p);
          })), D.styledMode || c(C, { "touch-action": "none" }), C.className += " highcharts-no-touch-action", this.hasPointerCapture = !0) : this.hasPointerCapture && !b && (M.forEach((p) => p()), M.length = 0, D.styledMode || c(C, { "touch-action": k(D.options.chart.style?.["touch-action"], "manipulation") }), C.className = C.className.replace(" highcharts-no-touch-action", ""), this.hasPointerCapture = !1);
        }
        setHoverChartIndex(M) {
          let D = this.chart, C = a.charts[k(j.hoverChartIndex, -1)];
          if (C && C !== D) {
            let b = { relatedTarget: D.container };
            M && !M?.relatedTarget && (M = { ...b, ...M }), C.pointer?.onContainerMouseLeave(M || b);
          }
          C && C.mouseIsDown || (j.hoverChartIndex = D.index);
        }
        touch(M, D) {
          let C, { chart: b, pinchDown: p = [] } = this;
          this.setHoverChartIndex(), (M = this.normalize(M)).touches.length === 1 ? b.isInsidePlot(M.chartX - b.plotLeft, M.chartY - b.plotTop, { visiblePlotOnly: !0 }) && !b.openMenu ? (D && this.runPointActions(M), M.type === "touchmove" && (C = !!p[0] && Math.pow(p[0].chartX - M.chartX, 2) + Math.pow(p[0].chartY - M.chartY, 2) >= 16), k(C, !0) && this.pinch(M)) : D && this.reset() : M.touches.length === 2 && this.pinch(M);
        }
        touchSelect(M) {
          return !!(this.chart.zooming.singleTouch && M.touches && M.touches.length === 1);
        }
        zoomOption(M) {
          let D = this.chart, C = D.inverted, b = D.zooming.type || "", p, L;
          /touch/.test(M.type) && (b = k(D.zooming.pinchType, b)), this.zoomX = p = /x/.test(b), this.zoomY = L = /y/.test(b), this.zoomHor = p && !C || L && C, this.zoomVert = L && !C || p && C, this.hasZoom = p || L;
        }
      }
      return (s = j || (j = {})).compose = function(N) {
        A(y, "Core.Pointer") && m(N, "beforeRender", function() {
          this.pointer = new s(this, this.options);
        });
      }, j;
    }), i(n, "Core/Legend/LegendSymbol.js", [n["Core/Utilities.js"]], function(o) {
      var a;
      let { extend: r, merge: s, pick: l } = o;
      return function(d) {
        function y(u, m, h) {
          let c = this.legendItem = this.legendItem || {}, { chart: g, options: v } = this, { baseline: P = 0, symbolWidth: f, symbolHeight: S } = u, w = this.symbol || "circle", x = S / 2, k = g.renderer, A = c.group, $ = P - Math.round((u.fontMetrics?.b || S) * (h ? 0.4 : 0.3)), j = {}, N, M = v.marker, D = 0;
          if (g.styledMode || (j["stroke-width"] = Math.min(v.lineWidth || 0, 24), v.dashStyle ? j.dashstyle = v.dashStyle : v.linecap === "square" || (j["stroke-linecap"] = "round")), c.line = k.path().addClass("highcharts-graph").attr(j).add(A), h && (c.area = k.path().addClass("highcharts-area").add(A)), j["stroke-linecap"] && (D = Math.min(c.line.strokeWidth(), f) / 2), f) {
            let C = [["M", D, $], ["L", f - D, $]];
            c.line.attr({ d: C }), c.area?.attr({ d: [...C, ["L", f - D, P], ["L", D, P]] });
          }
          if (M && M.enabled !== !1 && f) {
            let C = Math.min(l(M.radius, x), x);
            w.indexOf("url") === 0 && (M = s(M, { width: S, height: S }), C = 0), c.symbol = N = k.symbol(w, f / 2 - C, $ - C, 2 * C, 2 * C, r({ context: "legend" }, M)).addClass("highcharts-point").add(A), N.isMarker = !0;
          }
        }
        d.areaMarker = function(u, m) {
          y.call(this, u, m, !0);
        }, d.lineMarker = y, d.rectangle = function(u, m) {
          let h = m.legendItem || {}, c = u.options, g = u.symbolHeight, v = c.squareSymbol, P = v ? g : u.symbolWidth;
          h.symbol = this.chart.renderer.rect(v ? (u.symbolWidth - g) / 2 : 0, u.baseline - g + 1, P, g, l(u.options.symbolRadius, g / 2)).addClass("highcharts-point").attr({ zIndex: 3 }).add(h.group);
        };
      }(a || (a = {})), a;
    }), i(n, "Core/Series/SeriesDefaults.js", [], function() {
      return { lineWidth: 2, allowPointSelect: !1, crisp: !0, showCheckbox: !1, animation: { duration: 1e3 }, enableMouseTracking: !0, events: {}, marker: { enabledThreshold: 2, lineColor: "#ffffff", lineWidth: 0, radius: 4, states: { normal: { animation: !0 }, hover: { animation: { duration: 150 }, enabled: !0, radiusPlus: 2, lineWidthPlus: 1 }, select: { fillColor: "#cccccc", lineColor: "#000000", lineWidth: 2 } } }, point: { events: {} }, dataLabels: { animation: {}, align: "center", borderWidth: 0, defer: !0, formatter: function() {
        let { numberFormatter: o } = this.series.chart;
        return typeof this.y != "number" ? "" : o(this.y, -1);
      }, padding: 5, style: { fontSize: "0.7em", fontWeight: "bold", color: "contrast", textOutline: "1px contrast" }, verticalAlign: "bottom", x: 0, y: 0 }, cropThreshold: 300, opacity: 1, pointRange: 0, softThreshold: !0, states: { normal: { animation: !0 }, hover: { animation: { duration: 150 }, lineWidthPlus: 1, marker: {}, halo: { size: 10, opacity: 0.25 } }, select: { animation: { duration: 0 } }, inactive: { animation: { duration: 150 }, opacity: 0.2 } }, stickyTracking: !0, turboThreshold: 1e3, findNearestPointBy: "x" };
    }), i(n, "Core/Series/SeriesRegistry.js", [n["Core/Globals.js"], n["Core/Defaults.js"], n["Core/Series/Point.js"], n["Core/Utilities.js"]], function(o, a, r, s) {
      var l;
      let { defaultOptions: d } = a, { extend: y, extendClass: u, merge: m } = s;
      return function(h) {
        function c(g, v) {
          let P = d.plotOptions || {}, f = v.defaultOptions, S = v.prototype;
          return S.type = g, S.pointClass || (S.pointClass = r), !h.seriesTypes[g] && (f && (P[g] = f), h.seriesTypes[g] = v, !0);
        }
        h.seriesTypes = o.seriesTypes, h.registerSeriesType = c, h.seriesType = function(g, v, P, f, S) {
          let w = d.plotOptions || {};
          if (v = v || "", w[g] = m(w[v], P), delete h.seriesTypes[g], c(g, u(h.seriesTypes[v] || function() {
          }, f)), h.seriesTypes[g].prototype.type = g, S) {
            class x extends r {
            }
            y(x.prototype, S), h.seriesTypes[g].prototype.pointClass = x;
          }
          return h.seriesTypes[g];
        };
      }(l || (l = {})), l;
    }), i(n, "Core/Series/Series.js", [n["Core/Animation/AnimationUtilities.js"], n["Core/Defaults.js"], n["Core/Foundation.js"], n["Core/Globals.js"], n["Core/Legend/LegendSymbol.js"], n["Core/Series/Point.js"], n["Core/Series/SeriesDefaults.js"], n["Core/Series/SeriesRegistry.js"], n["Core/Renderer/SVG/SVGElement.js"], n["Core/Utilities.js"]], function(o, a, r, s, l, d, y, u, m, h) {
      let { animObject: c, setAnimation: g } = o, { defaultOptions: v } = a, { registerEventOptions: P } = r, { svg: f, win: S } = s, { seriesTypes: w } = u, { arrayMax: x, arrayMin: k, clamp: A, correctFloat: $, crisp: j, defined: N, destroyObjectProperties: M, diffObjects: D, erase: C, error: b, extend: p, find: L, fireEvent: B, getClosestDistance: T, getNestedProperty: O, insertItem: I, isArray: R, isNumber: Y, isString: F, merge: U, objectEach: Q, pick: J, removeEvent: ee, splat: V, syncTimeout: G } = h;
      class W {
        constructor() {
          this.zoneAxis = "y";
        }
        init(z, q) {
          let Z;
          B(this, "init", { options: q });
          let ne = this, ie = z.series;
          this.eventsToUnbind = [], ne.chart = z, ne.options = ne.setOptions(q);
          let re = ne.options, de = re.visible !== !1;
          ne.linkedSeries = [], ne.bindAxes(), p(ne, { name: re.name, state: "", visible: de, selected: re.selected === !0 }), P(this, re);
          let me = re.events;
          (me && me.click || re.point && re.point.events && re.point.events.click || re.allowPointSelect) && (z.runTrackerClick = !0), ne.getColor(), ne.getSymbol(), ne.parallelArrays.forEach(function(ce) {
            ne[ce + "Data"] || (ne[ce + "Data"] = []);
          }), ne.isCartesian && (z.hasCartesianSeries = !0), ie.length && (Z = ie[ie.length - 1]), ne._i = J(Z && Z._i, -1) + 1, ne.opacity = ne.options.opacity, z.orderItems("series", I(this, ie)), re.dataSorting && re.dataSorting.enabled ? ne.setDataSortingOptions() : ne.points || ne.data || ne.setData(re.data, !1), B(this, "afterInit");
        }
        is(z) {
          return w[z] && this instanceof w[z];
        }
        bindAxes() {
          let z, q = this, Z = q.options, ne = q.chart;
          B(this, "bindAxes", null, function() {
            (q.axisTypes || []).forEach(function(ie) {
              (ne[ie] || []).forEach(function(re) {
                z = re.options, (J(Z[ie], 0) === re.index || Z[ie] !== void 0 && Z[ie] === z.id) && (I(q, re.series), q[ie] = re, re.isDirty = !0);
              }), q[ie] || q.optionalAxis === ie || b(18, !0, ne);
            });
          }), B(this, "afterBindAxes");
        }
        updateParallelArrays(z, q, Z) {
          let ne = z.series, ie = Y(q) ? function(re) {
            let de = re === "y" && ne.toYData ? ne.toYData(z) : z[re];
            ne[re + "Data"][q] = de;
          } : function(re) {
            Array.prototype[q].apply(ne[re + "Data"], Z);
          };
          ne.parallelArrays.forEach(ie);
        }
        hasData() {
          return this.visible && this.dataMax !== void 0 && this.dataMin !== void 0 || this.visible && this.yData && this.yData.length > 0;
        }
        hasMarkerChanged(z, q) {
          let Z = z.marker, ne = q.marker || {};
          return Z && (ne.enabled && !Z.enabled || ne.symbol !== Z.symbol || ne.height !== Z.height || ne.width !== Z.width);
        }
        autoIncrement(z) {
          let q = this.options, Z = q.pointIntervalUnit, ne = q.relativeXValue, ie = this.chart.time, re = this.xIncrement, de, me;
          return re = J(re, q.pointStart, 0), this.pointInterval = me = J(this.pointInterval, q.pointInterval, 1), ne && Y(z) && (me *= z), Z && (de = new ie.Date(re), Z === "day" ? ie.set("Date", de, ie.get("Date", de) + me) : Z === "month" ? ie.set("Month", de, ie.get("Month", de) + me) : Z === "year" && ie.set("FullYear", de, ie.get("FullYear", de) + me), me = de.getTime() - re), ne && Y(z) ? re + me : (this.xIncrement = re + me, re);
        }
        setDataSortingOptions() {
          let z = this.options;
          p(this, { requireSorting: !1, sorted: !1, enabledDataSorting: !0, allowDG: !1 }), N(z.pointRange) || (z.pointRange = 1);
        }
        setOptions(z) {
          let q, Z = this.chart, ne = Z.options.plotOptions, ie = Z.userOptions || {}, re = U(z), de = Z.styledMode, me = { plotOptions: ne, userOptions: re };
          B(this, "setOptions", me);
          let ce = me.plotOptions[this.type], pe = ie.plotOptions || {}, xe = pe.series || {}, le = v.plotOptions[this.type] || {}, se = pe[this.type] || {};
          this.userOptions = me.userOptions;
          let he = U(ce, ne.series, se, re);
          this.tooltipOptions = U(v.tooltip, v.plotOptions.series?.tooltip, le?.tooltip, Z.userOptions.tooltip, pe.series?.tooltip, se.tooltip, re.tooltip), this.stickyTracking = J(re.stickyTracking, se.stickyTracking, xe.stickyTracking, !!this.tooltipOptions.shared && !this.noSharedTooltip || he.stickyTracking), ce.marker === null && delete he.marker, this.zoneAxis = he.zoneAxis || "y";
          let ve = this.zones = (he.zones || []).map((ye) => ({ ...ye }));
          return (he.negativeColor || he.negativeFillColor) && !he.zones && (q = { value: he[this.zoneAxis + "Threshold"] || he.threshold || 0, className: "highcharts-negative" }, de || (q.color = he.negativeColor, q.fillColor = he.negativeFillColor), ve.push(q)), ve.length && N(ve[ve.length - 1].value) && ve.push(de ? {} : { color: this.color, fillColor: this.fillColor }), B(this, "afterSetOptions", { options: he }), he;
        }
        getName() {
          return J(this.options.name, "Series " + (this.index + 1));
        }
        getCyclic(z, q, Z) {
          let ne, ie, re = this.chart, de = `${z}Index`, me = `${z}Counter`, ce = Z?.length || re.options.chart.colorCount;
          !q && (N(ie = J(z === "color" ? this.options.colorIndex : void 0, this[de])) ? ne = ie : (re.series.length || (re[me] = 0), ne = re[me] % ce, re[me] += 1), Z && (q = Z[ne])), ne !== void 0 && (this[de] = ne), this[z] = q;
        }
        getColor() {
          this.chart.styledMode ? this.getCyclic("color") : this.options.colorByPoint ? this.color = "#cccccc" : this.getCyclic("color", this.options.color || v.plotOptions[this.type].color, this.chart.options.colors);
        }
        getPointsCollection() {
          return (this.hasGroupedData ? this.points : this.data) || [];
        }
        getSymbol() {
          let z = this.options.marker;
          this.getCyclic("symbol", z.symbol, this.chart.options.symbols);
        }
        findPointIndex(z, q) {
          let Z, ne, ie, re = z.id, de = z.x, me = this.points, ce = this.options.dataSorting;
          if (re) {
            let pe = this.chart.get(re);
            pe instanceof d && (Z = pe);
          } else if (this.linkedParent || this.enabledDataSorting || this.options.relativeXValue) {
            let pe = (xe) => !xe.touched && xe.index === z.index;
            if (ce && ce.matchByName ? pe = (xe) => !xe.touched && xe.name === z.name : this.options.relativeXValue && (pe = (xe) => !xe.touched && xe.options.x === z.x), !(Z = L(me, pe)))
              return;
          }
          return Z && (ie = Z && Z.index) !== void 0 && (ne = !0), ie === void 0 && Y(de) && (ie = this.xData.indexOf(de, q)), ie !== -1 && ie !== void 0 && this.cropped && (ie = ie >= this.cropStart ? ie - this.cropStart : ie), !ne && Y(ie) && me[ie] && me[ie].touched && (ie = void 0), ie;
        }
        updateData(z, q) {
          let Z = this.options, ne = Z.dataSorting, ie = this.points, re = [], de = this.requireSorting, me = z.length === ie.length, ce, pe, xe, le, se = !0;
          if (this.xIncrement = null, z.forEach(function(he, ve) {
            let ye, be = N(he) && this.pointClass.prototype.optionsToObject.call({ series: this }, he) || {}, ke = be.x;
            be.id || Y(ke) ? ((ye = this.findPointIndex(be, le)) === -1 || ye === void 0 ? re.push(he) : ie[ye] && he !== Z.data[ye] ? (ie[ye].update(he, !1, null, !1), ie[ye].touched = !0, de && (le = ye + 1)) : ie[ye] && (ie[ye].touched = !0), (!me || ve !== ye || ne && ne.enabled || this.hasDerivedData) && (ce = !0)) : re.push(he);
          }, this), ce)
            for (pe = ie.length; pe--; )
              (xe = ie[pe]) && !xe.touched && xe.remove && xe.remove(!1, q);
          else
            !me || ne && ne.enabled ? se = !1 : (z.forEach(function(he, ve) {
              he === ie[ve].y || ie[ve].destroyed || ie[ve].update(he, !1, null, !1);
            }), re.length = 0);
          return ie.forEach(function(he) {
            he && (he.touched = !1);
          }), !!se && (re.forEach(function(he) {
            this.addPoint(he, !1, null, null, !1);
          }, this), this.xIncrement === null && this.xData && this.xData.length && (this.xIncrement = x(this.xData), this.autoIncrement()), !0);
        }
        setData(z, q = !0, Z, ne) {
          let ie = this, re = ie.points, de = re && re.length || 0, me = ie.options, ce = ie.chart, pe = me.dataSorting, xe = ie.xAxis, le = me.turboThreshold, se = this.xData, he = this.yData, ve = ie.pointArrayMap, ye = ve && ve.length, be = me.keys, ke, we, Le, Me = 0, De = 1, Ae;
          ce.options.chart.allowMutatingData || (me.data && delete ie.options.data, ie.userOptions.data && delete ie.userOptions.data, Ae = U(!0, z));
          let _e = (z = Ae || z || []).length;
          if (pe && pe.enabled && (z = this.sortData(z)), ce.options.chart.allowMutatingData && ne !== !1 && _e && de && !ie.cropped && !ie.hasGroupedData && ie.visible && !ie.boosted && (Le = this.updateData(z, Z)), !Le) {
            ie.xIncrement = null, ie.colorCounter = 0, this.parallelArrays.forEach(function(Ee) {
              ie[Ee + "Data"].length = 0;
            });
            let He = le && _e > le;
            if (He) {
              let Ee = ie.getFirstValidPoint(z), Ne = ie.getFirstValidPoint(z, _e - 1, -1), Ye = (Xe) => !!(R(Xe) && (be || Y(Xe[0])));
              if (Y(Ee) && Y(Ne))
                for (ke = 0; ke < _e; ke++)
                  se[ke] = this.autoIncrement(), he[ke] = z[ke];
              else if (Ye(Ee) && Ye(Ne))
                if (ye)
                  if (Ee.length === ye)
                    for (ke = 0; ke < _e; ke++)
                      se[ke] = this.autoIncrement(), he[ke] = z[ke];
                  else
                    for (ke = 0; ke < _e; ke++)
                      we = z[ke], se[ke] = we[0], he[ke] = we.slice(1, ye + 1);
                else if (be && (Me = be.indexOf("x"), De = be.indexOf("y"), Me = Me >= 0 ? Me : 0, De = De >= 0 ? De : 1), Ee.length === 1 && (De = 0), Me === De)
                  for (ke = 0; ke < _e; ke++)
                    se[ke] = this.autoIncrement(), he[ke] = z[ke][De];
                else
                  for (ke = 0; ke < _e; ke++)
                    we = z[ke], se[ke] = we[Me], he[ke] = we[De];
              else
                He = !1;
            }
            if (!He)
              for (ke = 0; ke < _e; ke++)
                we = { series: ie }, ie.pointClass.prototype.applyOptions.apply(we, [z[ke]]), ie.updateParallelArrays(we, ke);
            for (he && F(he[0]) && b(14, !0, ce), ie.data = [], ie.options.data = ie.userOptions.data = z, ke = de; ke--; )
              re[ke]?.destroy();
            xe && (xe.minRange = xe.userMinRange), ie.isDirty = ce.isDirtyBox = !0, ie.isDirtyData = !!re, Z = !1;
          }
          me.legendType === "point" && (this.processData(), this.generatePoints()), q && ce.redraw(Z);
        }
        sortData(z) {
          let q = this, Z = q.options.dataSorting.sortKey || "y", ne = function(ie, re) {
            return N(re) && ie.pointClass.prototype.optionsToObject.call({ series: ie }, re) || {};
          };
          return z.forEach(function(ie, re) {
            z[re] = ne(q, ie), z[re].index = re;
          }, this), z.concat().sort((ie, re) => {
            let de = O(Z, ie), me = O(Z, re);
            return me < de ? -1 : me > de ? 1 : 0;
          }).forEach(function(ie, re) {
            ie.x = re;
          }, this), q.linkedSeries && q.linkedSeries.forEach(function(ie) {
            let re = ie.options, de = re.data;
            re.dataSorting && re.dataSorting.enabled || !de || (de.forEach(function(me, ce) {
              de[ce] = ne(ie, me), z[ce] && (de[ce].x = z[ce].x, de[ce].index = ce);
            }), ie.setData(de, !1));
          }), z;
        }
        getProcessedData(z) {
          let q = this, Z = q.xAxis, ne = q.options.cropThreshold, ie = Z?.logarithmic, re = q.isCartesian, de, me, ce = 0, pe, xe, le, se = q.xData, he = q.yData, ve = !1, ye = se.length;
          Z && (xe = (pe = Z.getExtremes()).min, le = pe.max, ve = !!(Z.categories && !Z.names.length)), re && q.sorted && !z && (!ne || ye > ne || q.forceCrop) && (se[ye - 1] < xe || se[0] > le ? (se = [], he = []) : q.yData && (se[0] < xe || se[ye - 1] > le) && (se = (de = this.cropData(q.xData, q.yData, xe, le)).xData, he = de.yData, ce = de.start, me = !0));
          let be = T([ie ? se.map(ie.log2lin) : se], () => q.requireSorting && !ve && b(15, !1, q.chart));
          return { xData: se, yData: he, cropped: me, cropStart: ce, closestPointRange: be };
        }
        processData(z) {
          let q = this.xAxis;
          if (this.isCartesian && !this.isDirty && !q.isDirty && !this.yAxis.isDirty && !z)
            return !1;
          let Z = this.getProcessedData();
          this.cropped = Z.cropped, this.cropStart = Z.cropStart, this.processedXData = Z.xData, this.processedYData = Z.yData, this.closestPointRange = this.basePointRange = Z.closestPointRange, B(this, "afterProcessData");
        }
        cropData(z, q, Z, ne) {
          let ie = z.length, re, de, me = 0, ce = ie;
          for (re = 0; re < ie; re++)
            if (z[re] >= Z) {
              me = Math.max(0, re - 1);
              break;
            }
          for (de = re; de < ie; de++)
            if (z[de] > ne) {
              ce = de + 1;
              break;
            }
          return { xData: z.slice(me, ce), yData: q.slice(me, ce), start: me, end: ce };
        }
        generatePoints() {
          let z = this.options, q = this.processedData || z.data, Z = this.processedXData, ne = this.processedYData, ie = this.pointClass, re = Z.length, de = this.cropStart || 0, me = this.hasGroupedData, ce = z.keys, pe = [], xe = z.dataGrouping && z.dataGrouping.groupAll ? de : 0, le, se, he, ve, ye = this.data;
          if (!ye && !me) {
            let be = [];
            be.length = q.length, ye = this.data = be;
          }
          for (ce && me && (this.options.keys = !1), ve = 0; ve < re; ve++)
            se = de + ve, me ? ((he = new ie(this, [Z[ve]].concat(V(ne[ve])))).dataGroup = this.groupMap[xe + ve], he.dataGroup.options && (he.options = he.dataGroup.options, p(he, he.dataGroup.options), delete he.dataLabels)) : (he = ye[se]) || q[se] === void 0 || (ye[se] = he = new ie(this, q[se], Z[ve])), he && (he.index = me ? xe + ve : se, pe[ve] = he);
          if (this.options.keys = ce, ye && (re !== (le = ye.length) || me))
            for (ve = 0; ve < le; ve++)
              ve !== de || me || (ve += re), ye[ve] && (ye[ve].destroyElements(), ye[ve].plotX = void 0);
          this.data = ye, this.points = pe, B(this, "afterGeneratePoints");
        }
        getXExtremes(z) {
          return { min: k(z), max: x(z) };
        }
        getExtremes(z, q) {
          let Z = this.xAxis, ne = this.yAxis, ie = [], re = this.requireSorting && !this.is("column") ? 1 : 0, de = !!ne && ne.positiveValuesOnly, me = q || this.getExtremesFromAll || this.options.getExtremesFromAll, { processedXData: ce, processedYData: pe } = this, xe, le, se, he, ve, ye, be, ke = 0, we = 0, Le = 0;
          if (this.cropped && me) {
            let _e = this.getProcessedData(!0);
            ce = _e.xData, pe = _e.yData;
          }
          let Me = (z = z || this.stackedYData || pe || []).length, De = ce || this.xData;
          for (Z && (ke = (xe = Z.getExtremes()).min, we = xe.max), ye = 0; ye < Me; ye++)
            if (he = De[ye], le = (Y(ve = z[ye]) || R(ve)) && ((Y(ve) ? ve > 0 : ve.length) || !de), se = q || this.getExtremesFromAll || this.options.getExtremesFromAll || this.cropped || !Z || (De[ye + re] || he) >= ke && (De[ye - re] || he) <= we, le && se)
              if (be = ve.length)
                for (; be--; )
                  Y(ve[be]) && (ie[Le++] = ve[be]);
              else
                ie[Le++] = ve;
          let Ae = { activeYData: ie, dataMin: k(ie), dataMax: x(ie) };
          return B(this, "afterGetExtremes", { dataExtremes: Ae }), Ae;
        }
        applyExtremes() {
          let z = this.getExtremes();
          return this.dataMin = z.dataMin, this.dataMax = z.dataMax, z;
        }
        getFirstValidPoint(z, q = 0, Z = 1) {
          let ne = z.length, ie = q;
          for (; ie >= 0 && ie < ne; ) {
            if (N(z[ie]))
              return z[ie];
            ie += Z;
          }
        }
        translate() {
          this.processedXData || this.processData(), this.generatePoints();
          let z = this.options, q = z.stacking, Z = this.xAxis, ne = Z.categories, ie = this.enabledDataSorting, re = this.yAxis, de = this.points, me = de.length, ce = this.pointPlacementToXValue(), pe = !!ce, xe = z.threshold, le = z.startFromThreshold ? xe : 0, se, he, ve, ye, be = Number.MAX_VALUE;
          function ke(we) {
            return A(we, -1e9, 1e9);
          }
          for (se = 0; se < me; se++) {
            let we, Le = de[se], Me = Le.x, De, Ae, _e = Le.y, He = Le.low, Ee = q && re.stacking?.stacks[(this.negStacks && _e < (le ? 0 : xe) ? "-" : "") + this.stackKey];
            he = Z.translate(Me, !1, !1, !1, !0, ce), Le.plotX = Y(he) ? $(ke(he)) : void 0, q && this.visible && Ee && Ee[Me] && (ye = this.getStackIndicator(ye, Me, this.index), !Le.isNull && ye.key && (Ae = (De = Ee[Me]).points[ye.key]), De && R(Ae) && (He = Ae[0], _e = Ae[1], He === le && ye.key === Ee[Me].base && (He = J(Y(xe) ? xe : re.min)), re.positiveValuesOnly && N(He) && He <= 0 && (He = void 0), Le.total = Le.stackTotal = J(De.total), Le.percentage = N(Le.y) && De.total ? Le.y / De.total * 100 : void 0, Le.stackY = _e, this.irregularWidths || De.setOffset(this.pointXOffset || 0, this.barW || 0, void 0, void 0, void 0, this.xAxis))), Le.yBottom = N(He) ? ke(re.translate(He, !1, !0, !1, !0)) : void 0, this.dataModify && (_e = this.dataModify.modifyValue(_e, se)), Y(_e) && Le.plotX !== void 0 && (we = Y(we = re.translate(_e, !1, !0, !1, !0)) ? ke(we) : void 0), Le.plotY = we, Le.isInside = this.isPointInside(Le), Le.clientX = pe ? $(Z.translate(Me, !1, !1, !1, !0, ce)) : he, Le.negative = (Le.y || 0) < (xe || 0), Le.category = J(ne && ne[Le.x], Le.x), Le.isNull || Le.visible === !1 || (ve !== void 0 && (be = Math.min(be, Math.abs(he - ve))), ve = he), Le.zone = this.zones.length ? Le.getZone() : void 0, !Le.graphic && this.group && ie && (Le.isNew = !0);
          }
          this.closestPointRangePx = be, B(this, "afterTranslate");
        }
        getValidPoints(z, q, Z) {
          let ne = this.chart;
          return (z || this.points || []).filter(function(ie) {
            let { plotX: re, plotY: de } = ie;
            return !!((Z || !ie.isNull && Y(de)) && (!q || ne.isInsidePlot(re, de, { inverted: ne.inverted }))) && ie.visible !== !1;
          });
        }
        getClipBox() {
          let { chart: z, xAxis: q, yAxis: Z } = this, { x: ne, y: ie, width: re, height: de } = U(z.clipBox);
          return q && q.len !== z.plotSizeX && (re = q.len), Z && Z.len !== z.plotSizeY && (de = Z.len), z.inverted && !this.invertible && ([re, de] = [de, re]), { x: ne, y: ie, width: re, height: de };
        }
        getSharedClipKey() {
          return this.sharedClipKey = (this.options.xAxis || 0) + "," + (this.options.yAxis || 0), this.sharedClipKey;
        }
        setClip() {
          let { chart: z, group: q, markerGroup: Z } = this, ne = z.sharedClips, ie = z.renderer, re = this.getClipBox(), de = this.getSharedClipKey(), me = ne[de];
          me ? me.animate(re) : ne[de] = me = ie.clipRect(re), q && q.clip(this.options.clip === !1 ? void 0 : me), Z && Z.clip();
        }
        animate(z) {
          let { chart: q, group: Z, markerGroup: ne } = this, ie = q.inverted, re = c(this.options.animation), de = [this.getSharedClipKey(), re.duration, re.easing, re.defer].join(","), me = q.sharedClips[de], ce = q.sharedClips[de + "m"];
          if (z && Z) {
            let pe = this.getClipBox();
            if (me)
              me.attr("height", pe.height);
            else {
              pe.width = 0, ie && (pe.x = q.plotHeight), me = q.renderer.clipRect(pe), q.sharedClips[de] = me;
              let xe = { x: -99, y: -99, width: ie ? q.plotWidth + 199 : 99, height: ie ? 99 : q.plotHeight + 199 };
              ce = q.renderer.clipRect(xe), q.sharedClips[de + "m"] = ce;
            }
            Z.clip(me), ne?.clip(ce);
          } else if (me && !me.hasClass("highcharts-animating")) {
            let pe = this.getClipBox(), xe = re.step;
            (ne?.element.childNodes.length || q.series.length > 1) && (re.step = function(le, se) {
              xe && xe.apply(se, arguments), se.prop === "width" && ce?.element && ce.attr(ie ? "height" : "width", le + 99);
            }), me.addClass("highcharts-animating").animate(pe, re);
          }
        }
        afterAnimate() {
          this.setClip(), Q(this.chart.sharedClips, (z, q, Z) => {
            z && !this.chart.container.querySelector(`[clip-path="url(#${z.id})"]`) && (z.destroy(), delete Z[q]);
          }), this.finishedAnimating = !0, B(this, "afterAnimate");
        }
        drawPoints(z = this.points) {
          let q, Z, ne, ie, re, de, me, ce = this.chart, pe = ce.styledMode, { colorAxis: xe, options: le } = this, se = le.marker, he = this[this.specialGroup || "markerGroup"], ve = this.xAxis, ye = J(se.enabled, !ve || !!ve.isRadial || null, this.closestPointRangePx >= se.enabledThreshold * se.radius);
          if (se.enabled !== !1 || this._hasPointMarkers)
            for (q = 0; q < z.length; q++)
              if (ie = (ne = (Z = z[q]).graphic) ? "animate" : "attr", re = Z.marker || {}, de = !!Z.marker, (ye && re.enabled === void 0 || re.enabled) && !Z.isNull && Z.visible !== !1) {
                let be = J(re.symbol, this.symbol, "rect");
                me = this.markerAttribs(Z, Z.selected && "select"), this.enabledDataSorting && (Z.startXPos = ve.reversed ? -(me.width || 0) : ve.width);
                let ke = Z.isInside !== !1;
                if (!ne && ke && ((me.width || 0) > 0 || Z.hasImage) && (Z.graphic = ne = ce.renderer.symbol(be, me.x, me.y, me.width, me.height, de ? re : se).add(he), this.enabledDataSorting && ce.hasRendered && (ne.attr({ x: Z.startXPos }), ie = "animate")), ne && ie === "animate" && ne[ke ? "show" : "hide"](ke).animate(me), ne) {
                  let we = this.pointAttribs(Z, pe || !Z.selected ? void 0 : "select");
                  pe ? xe && ne.css({ fill: we.fill }) : ne[ie](we);
                }
                ne && ne.addClass(Z.getClassName(), !0);
              } else
                ne && (Z.graphic = ne.destroy());
        }
        markerAttribs(z, q) {
          let Z = this.options, ne = Z.marker, ie = z.marker || {}, re = ie.symbol || ne.symbol, de = {}, me, ce, pe = J(ie.radius, ne && ne.radius);
          q && (me = ne.states[q], pe = J((ce = ie.states && ie.states[q]) && ce.radius, me && me.radius, pe && pe + (me && me.radiusPlus || 0))), z.hasImage = re && re.indexOf("url") === 0, z.hasImage && (pe = 0);
          let xe = z.pos();
          return Y(pe) && xe && (Z.crisp && (xe[0] = j(xe[0], z.hasImage ? 0 : re === "rect" ? ne?.lineWidth || 0 : 1)), de.x = xe[0] - pe, de.y = xe[1] - pe), pe && (de.width = de.height = 2 * pe), de;
        }
        pointAttribs(z, q) {
          let Z = this.options.marker, ne = z && z.options, ie = ne && ne.marker || {}, re = ne && ne.color, de = z && z.color, me = z && z.zone && z.zone.color, ce, pe, xe = this.color, le, se, he = J(ie.lineWidth, Z.lineWidth), ve = 1;
          return xe = re || me || de || xe, le = ie.fillColor || Z.fillColor || xe, se = ie.lineColor || Z.lineColor || xe, q = q || "normal", ce = Z.states[q] || {}, he = J((pe = ie.states && ie.states[q] || {}).lineWidth, ce.lineWidth, he + J(pe.lineWidthPlus, ce.lineWidthPlus, 0)), le = pe.fillColor || ce.fillColor || le, { stroke: se = pe.lineColor || ce.lineColor || se, "stroke-width": he, fill: le, opacity: ve = J(pe.opacity, ce.opacity, ve) };
        }
        destroy(z) {
          let q, Z, ne, ie = this, re = ie.chart, de = /AppleWebKit\/533/.test(S.navigator.userAgent), me = ie.data || [];
          for (B(ie, "destroy", { keepEventsForUpdate: z }), this.removeEvents(z), (ie.axisTypes || []).forEach(function(ce) {
            (ne = ie[ce]) && ne.series && (C(ne.series, ie), ne.isDirty = ne.forceRedraw = !0);
          }), ie.legendItem && ie.chart.legend.destroyItem(ie), q = me.length; q--; )
            (Z = me[q]) && Z.destroy && Z.destroy();
          for (let ce of ie.zones)
            M(ce, void 0, !0);
          h.clearTimeout(ie.animationTimeout), Q(ie, function(ce, pe) {
            ce instanceof m && !ce.survive && ce[de && pe === "group" ? "hide" : "destroy"]();
          }), re.hoverSeries === ie && (re.hoverSeries = void 0), C(re.series, ie), re.orderItems("series"), Q(ie, function(ce, pe) {
            z && pe === "hcEvents" || delete ie[pe];
          });
        }
        applyZones() {
          let { area: z, chart: q, graph: Z, zones: ne, points: ie, xAxis: re, yAxis: de, zoneAxis: me } = this, { inverted: ce, renderer: pe } = q, xe = this[`${me}Axis`], { isXAxis: le, len: se = 0 } = xe || {}, he = (Z?.strokeWidth() || 0) / 2 + 1, ve = (ye, be = 0, ke = 0) => {
            ce && (ke = se - ke);
            let { translated: we = 0, lineClip: Le } = ye, Me = ke - we;
            Le?.push(["L", be, Math.abs(Me) < he ? ke - he * (Me <= 0 ? -1 : 1) : we]);
          };
          if (ne.length && (Z || z) && xe && Y(xe.min)) {
            let ye = xe.getExtremes().max, be = (Le) => {
              Le.forEach((Me, De) => {
                (Me[0] === "M" || Me[0] === "L") && (Le[De] = [Me[0], le ? se - Me[1] : Me[1], le ? Me[2] : se - Me[2]]);
              });
            };
            if (ne.forEach((Le) => {
              Le.lineClip = [], Le.translated = A(xe.toPixels(J(Le.value, ye), !0) || 0, 0, se);
            }), Z && !this.showLine && Z.hide(), z && z.hide(), me === "y" && ie.length < re.len)
              for (let Le of ie) {
                let { plotX: Me, plotY: De, zone: Ae } = Le, _e = Ae && ne[ne.indexOf(Ae) - 1];
                Ae && ve(Ae, Me, De), _e && ve(_e, Me, De);
              }
            let ke = [], we = xe.toPixels(xe.getExtremes().min, !0);
            ne.forEach((Le) => {
              let Me = Le.lineClip || [], De = Math.round(Le.translated || 0);
              re.reversed && Me.reverse();
              let { clip: Ae, simpleClip: _e } = Le, He = 0, Ee = 0, Ne = re.len, Ye = de.len;
              le ? (He = De, Ne = we) : (Ee = De, Ye = we);
              let Xe = [["M", He, Ee], ["L", Ne, Ee], ["L", Ne, Ye], ["L", He, Ye], ["Z"]], nt = [Xe[0], ...Me, Xe[1], Xe[2], ...ke, Xe[3], Xe[4]];
              ke = Me.reverse(), we = De, ce && (be(nt), z && be(Xe)), Ae ? (Ae.animate({ d: nt }), _e?.animate({ d: Xe })) : (Ae = Le.clip = pe.path(nt), z && (_e = Le.simpleClip = pe.path(Xe))), Z && Le.graph?.clip(Ae), z && Le.area?.clip(_e);
            });
          } else
            this.visible && (Z && Z.show(), z && z.show());
        }
        plotGroup(z, q, Z, ne, ie) {
          let re = this[z], de = !re, me = { visibility: Z, zIndex: ne || 0.1 };
          return N(this.opacity) && !this.chart.styledMode && this.state !== "inactive" && (me.opacity = this.opacity), re || (this[z] = re = this.chart.renderer.g().add(ie)), re.addClass("highcharts-" + q + " highcharts-series-" + this.index + " highcharts-" + this.type + "-series " + (N(this.colorIndex) ? "highcharts-color-" + this.colorIndex + " " : "") + (this.options.className || "") + (re.hasClass("highcharts-tracker") ? " highcharts-tracker" : ""), !0), re.attr(me)[de ? "attr" : "animate"](this.getPlotBox(q)), re;
        }
        getPlotBox(z) {
          let q = this.xAxis, Z = this.yAxis, ne = this.chart, ie = ne.inverted && !ne.polar && q && this.invertible && z === "series";
          return ne.inverted && (q = Z, Z = this.xAxis), { translateX: q ? q.left : ne.plotLeft, translateY: Z ? Z.top : ne.plotTop, rotation: ie ? 90 : 0, rotationOriginX: ie ? (q.len - Z.len) / 2 : 0, rotationOriginY: ie ? (q.len + Z.len) / 2 : 0, scaleX: ie ? -1 : 1, scaleY: 1 };
        }
        removeEvents(z) {
          let { eventsToUnbind: q } = this;
          z || ee(this), q.length && (q.forEach((Z) => {
            Z();
          }), q.length = 0);
        }
        render() {
          let z = this, { chart: q, options: Z, hasRendered: ne } = z, ie = c(Z.animation), re = z.visible ? "inherit" : "hidden", de = Z.zIndex, me = q.seriesGroup, ce = z.finishedAnimating ? 0 : ie.duration;
          B(this, "render"), z.plotGroup("group", "series", re, de, me), z.markerGroup = z.plotGroup("markerGroup", "markers", re, de, me), Z.clip !== !1 && z.setClip(), ce && z.animate?.(!0), z.drawGraph && (z.drawGraph(), z.applyZones()), z.visible && z.drawPoints(), z.drawDataLabels?.(), z.redrawPoints?.(), Z.enableMouseTracking && z.drawTracker?.(), ce && z.animate?.(), ne || (ce && ie.defer && (ce += ie.defer), z.animationTimeout = G(() => {
            z.afterAnimate();
          }, ce || 0)), z.isDirty = !1, z.hasRendered = !0, B(z, "afterRender");
        }
        redraw() {
          let z = this.isDirty || this.isDirtyData;
          this.translate(), this.render(), z && delete this.kdTree;
        }
        reserveSpace() {
          return this.visible || !this.chart.options.chart.ignoreHiddenSeries;
        }
        searchPoint(z, q) {
          let { xAxis: Z, yAxis: ne } = this, ie = this.chart.inverted;
          return this.searchKDTree({ clientX: ie ? Z.len - z.chartY + Z.pos : z.chartX - Z.pos, plotY: ie ? ne.len - z.chartX + ne.pos : z.chartY - ne.pos }, q, z);
        }
        buildKDTree(z) {
          this.buildingKdTree = !0;
          let q = this, Z = q.options.findNearestPointBy.indexOf("y") > -1 ? 2 : 1;
          delete q.kdTree, G(function() {
            q.kdTree = function ne(ie, re, de) {
              let me, ce, pe = ie?.length;
              if (pe)
                return me = q.kdAxisArray[re % de], ie.sort((xe, le) => (xe[me] || 0) - (le[me] || 0)), { point: ie[ce = Math.floor(pe / 2)], left: ne(ie.slice(0, ce), re + 1, de), right: ne(ie.slice(ce + 1), re + 1, de) };
            }(q.getValidPoints(void 0, !q.directTouch), Z, Z), q.buildingKdTree = !1;
          }, q.options.kdNow || z?.type === "touchstart" ? 0 : 1);
        }
        searchKDTree(z, q, Z) {
          let ne = this, [ie, re] = this.kdAxisArray, de = q ? "distX" : "dist", me = (ne.options.findNearestPointBy || "").indexOf("y") > -1 ? 2 : 1, ce = !!ne.isBubble;
          if (this.kdTree || this.buildingKdTree || this.buildKDTree(Z), this.kdTree)
            return function pe(xe, le, se, he) {
              let ve = le.point, ye = ne.kdAxisArray[se % he], be, ke, we = ve;
              (function(Ae, _e) {
                let He = Ae[ie], Ee = _e[ie], Ne = N(He) && N(Ee) ? He - Ee : null, Ye = Ae[re], Xe = _e[re], nt = N(Ye) && N(Xe) ? Ye - Xe : 0, ut = ce && _e.marker?.radius || 0;
                _e.dist = Math.sqrt((Ne && Ne * Ne || 0) + nt * nt) - ut, _e.distX = N(Ne) ? Math.abs(Ne) - ut : Number.MAX_VALUE;
              })(xe, ve);
              let Le = (xe[ye] || 0) - (ve[ye] || 0) + (ce && ve.marker?.radius || 0), Me = Le < 0 ? "left" : "right", De = Le < 0 ? "right" : "left";
              return le[Me] && (we = (be = pe(xe, le[Me], se + 1, he))[de] < we[de] ? be : ve), le[De] && Math.sqrt(Le * Le) < we[de] && (we = (ke = pe(xe, le[De], se + 1, he))[de] < we[de] ? ke : we), we;
            }(z, this.kdTree, me, me);
        }
        pointPlacementToXValue() {
          let { options: z, xAxis: q } = this, Z = z.pointPlacement;
          return Z === "between" && (Z = q.reversed ? -0.5 : 0.5), Y(Z) ? Z * (z.pointRange || q.pointRange) : 0;
        }
        isPointInside(z) {
          let { chart: q, xAxis: Z, yAxis: ne } = this, { plotX: ie = -1, plotY: re = -1 } = z;
          return re >= 0 && re <= (ne ? ne.len : q.plotHeight) && ie >= 0 && ie <= (Z ? Z.len : q.plotWidth);
        }
        drawTracker() {
          let z = this, q = z.options, Z = q.trackByArea, ne = [].concat((Z ? z.areaPath : z.graphPath) || []), ie = z.chart, re = ie.pointer, de = ie.renderer, me = ie.options.tooltip?.snap || 0, ce = () => {
            q.enableMouseTracking && ie.hoverSeries !== z && z.onMouseOver();
          }, pe = "rgba(192,192,192," + (f ? 1e-4 : 2e-3) + ")", xe = z.tracker;
          xe ? xe.attr({ d: ne }) : z.graph && (z.tracker = xe = de.path(ne).attr({ visibility: z.visible ? "inherit" : "hidden", zIndex: 2 }).addClass(Z ? "highcharts-tracker-area" : "highcharts-tracker-line").add(z.group), ie.styledMode || xe.attr({ "stroke-linecap": "round", "stroke-linejoin": "round", stroke: pe, fill: Z ? pe : "none", "stroke-width": z.graph.strokeWidth() + (Z ? 0 : 2 * me) }), [z.tracker, z.markerGroup, z.dataLabelsGroup].forEach((le) => {
            le && (le.addClass("highcharts-tracker").on("mouseover", ce).on("mouseout", (se) => {
              re?.onTrackerMouseOut(se);
            }), q.cursor && !ie.styledMode && le.css({ cursor: q.cursor }), le.on("touchstart", ce));
          })), B(this, "afterDrawTracker");
        }
        addPoint(z, q, Z, ne, ie) {
          let re, de, me = this.options, ce = this.data, pe = this.chart, xe = this.xAxis, le = xe && xe.hasNames && xe.names, se = me.data, he = this.xData;
          q = J(q, !0);
          let ve = { series: this };
          this.pointClass.prototype.applyOptions.apply(ve, [z]);
          let ye = ve.x;
          if (de = he.length, this.requireSorting && ye < he[de - 1])
            for (re = !0; de && he[de - 1] > ye; )
              de--;
          this.updateParallelArrays(ve, "splice", [de, 0, 0]), this.updateParallelArrays(ve, de), le && ve.name && (le[ye] = ve.name), se.splice(de, 0, z), (re || this.processedData) && (this.data.splice(de, 0, null), this.processData()), me.legendType === "point" && this.generatePoints(), Z && (ce[0] && ce[0].remove ? ce[0].remove(!1) : (ce.shift(), this.updateParallelArrays(ve, "shift"), se.shift())), ie !== !1 && B(this, "addPoint", { point: ve }), this.isDirty = !0, this.isDirtyData = !0, q && pe.redraw(ne);
        }
        removePoint(z, q, Z) {
          let ne = this, ie = ne.data, re = ie[z], de = ne.points, me = ne.chart, ce = function() {
            de && de.length === ie.length && de.splice(z, 1), ie.splice(z, 1), ne.options.data.splice(z, 1), ne.updateParallelArrays(re || { series: ne }, "splice", [z, 1]), re && re.destroy(), ne.isDirty = !0, ne.isDirtyData = !0, q && me.redraw();
          };
          g(Z, me), q = J(q, !0), re ? re.firePointEvent("remove", null, ce) : ce();
        }
        remove(z, q, Z, ne) {
          let ie = this, re = ie.chart;
          function de() {
            ie.destroy(ne), re.isDirtyLegend = re.isDirtyBox = !0, re.linkSeries(ne), J(z, !0) && re.redraw(q);
          }
          Z !== !1 ? B(ie, "remove", null, de) : de();
        }
        update(z, q) {
          B(this, "update", { options: z = D(z, this.userOptions) });
          let Z = this, ne = Z.chart, ie = Z.userOptions, re = Z.initialType || Z.type, de = ne.options.plotOptions, me = w[re].prototype, ce = Z.finishedAnimating && { animation: !1 }, pe = {}, xe, le, se = ["colorIndex", "eventOptions", "navigatorSeries", "symbolIndex", "baseSeries"], he = z.type || ie.type || ne.options.chart.type, ve = !(this.hasDerivedData || he && he !== this.type || z.pointStart !== void 0 || z.pointInterval !== void 0 || z.relativeXValue !== void 0 || z.joinBy || z.mapData || ["dataGrouping", "pointStart", "pointInterval", "pointIntervalUnit", "keys"].some((be) => Z.hasOptionChanged(be)));
          he = he || re, ve && (se.push("data", "isDirtyData", "isDirtyCanvas", "points", "processedData", "processedXData", "processedYData", "xIncrement", "cropped", "_hasPointMarkers", "hasDataLabels", "nodes", "layout", "level", "mapMap", "mapData", "minY", "maxY", "minX", "maxX", "transformGroups"), z.visible !== !1 && se.push("area", "graph"), Z.parallelArrays.forEach(function(be) {
            se.push(be + "Data");
          }), z.data && (z.dataSorting && p(Z.options.dataSorting, z.dataSorting), this.setData(z.data, !1))), z = U(ie, { index: ie.index === void 0 ? Z.index : ie.index, pointStart: de?.series?.pointStart ?? ie.pointStart ?? Z.xData?.[0] }, !ve && { data: Z.options.data }, z, ce), ve && z.data && (z.data = Z.options.data), (se = ["group", "markerGroup", "dataLabelsGroup", "transformGroup"].concat(se)).forEach(function(be) {
            se[be] = Z[be], delete Z[be];
          });
          let ye = !1;
          if (w[he]) {
            if (ye = he !== Z.type, Z.remove(!1, !1, !1, !0), ye)
              if (ne.propFromSeries(), Object.setPrototypeOf)
                Object.setPrototypeOf(Z, w[he].prototype);
              else {
                let be = Object.hasOwnProperty.call(Z, "hcEvents") && Z.hcEvents;
                for (le in me)
                  Z[le] = void 0;
                p(Z, w[he].prototype), be ? Z.hcEvents = be : delete Z.hcEvents;
              }
          } else
            b(17, !0, ne, { missingModuleFor: he });
          if (se.forEach(function(be) {
            Z[be] = se[be];
          }), Z.init(ne, z), ve && this.points)
            for (let be of ((xe = Z.options).visible === !1 ? (pe.graphic = 1, pe.dataLabel = 1) : (this.hasMarkerChanged(xe, ie) && (pe.graphic = 1), Z.hasDataLabels?.() || (pe.dataLabel = 1)), this.points))
              be && be.series && (be.resolveColor(), Object.keys(pe).length && be.destroyElements(pe), xe.showInLegend === !1 && be.legendItem && ne.legend.destroyItem(be));
          Z.initialType = re, ne.linkSeries(), ne.setSortedData(), ye && Z.linkedSeries.length && (Z.isDirtyData = !0), B(this, "afterUpdate"), J(q, !0) && ne.redraw(!!ve && void 0);
        }
        setName(z) {
          this.name = this.options.name = this.userOptions.name = z, this.chart.isDirtyLegend = !0;
        }
        hasOptionChanged(z) {
          let q = this.chart, Z = this.options[z], ne = q.options.plotOptions, ie = this.userOptions[z], re = J(ne?.[this.type]?.[z], ne?.series?.[z]);
          return ie && !N(re) ? Z !== ie : Z !== J(re, Z);
        }
        onMouseOver() {
          let z = this.chart, q = z.hoverSeries;
          z.pointer?.setHoverChartIndex(), q && q !== this && q.onMouseOut(), this.options.events.mouseOver && B(this, "mouseOver"), this.setState("hover"), z.hoverSeries = this;
        }
        onMouseOut() {
          let z = this.options, q = this.chart, Z = q.tooltip, ne = q.hoverPoint;
          q.hoverSeries = null, ne && ne.onMouseOut(), this && z.events.mouseOut && B(this, "mouseOut"), Z && !this.stickyTracking && (!Z.shared || this.noSharedTooltip) && Z.hide(), q.series.forEach(function(ie) {
            ie.setState("", !0);
          });
        }
        setState(z, q) {
          let Z = this, ne = Z.options, ie = Z.graph, re = ne.inactiveOtherPoints, de = ne.states, me = J(de[z || "normal"] && de[z || "normal"].animation, Z.chart.options.chart.animation), ce = ne.lineWidth, pe = ne.opacity;
          if (z = z || "", Z.state !== z && ([Z.group, Z.markerGroup, Z.dataLabelsGroup].forEach(function(xe) {
            xe && (Z.state && xe.removeClass("highcharts-series-" + Z.state), z && xe.addClass("highcharts-series-" + z));
          }), Z.state = z, !Z.chart.styledMode)) {
            if (de[z] && de[z].enabled === !1)
              return;
            if (z && (ce = de[z].lineWidth || ce + (de[z].lineWidthPlus || 0), pe = J(de[z].opacity, pe)), ie && !ie.dashstyle && Y(ce))
              for (let xe of [ie, ...this.zones.map((le) => le.graph)])
                xe?.animate({ "stroke-width": ce }, me);
            re || [Z.group, Z.markerGroup, Z.dataLabelsGroup, Z.labelBySeries].forEach(function(xe) {
              xe && xe.animate({ opacity: pe }, me);
            });
          }
          q && re && Z.points && Z.setAllPointsToState(z || void 0);
        }
        setAllPointsToState(z) {
          this.points.forEach(function(q) {
            q.setState && q.setState(z);
          });
        }
        setVisible(z, q) {
          let Z = this, ne = Z.chart, ie = ne.options.chart.ignoreHiddenSeries, re = Z.visible;
          Z.visible = z = Z.options.visible = Z.userOptions.visible = z === void 0 ? !re : z;
          let de = z ? "show" : "hide";
          ["group", "dataLabelsGroup", "markerGroup", "tracker", "tt"].forEach((me) => {
            Z[me]?.[de]();
          }), (ne.hoverSeries === Z || ne.hoverPoint?.series === Z) && Z.onMouseOut(), Z.legendItem && ne.legend.colorizeItem(Z, z), Z.isDirty = !0, Z.options.stacking && ne.series.forEach((me) => {
            me.options.stacking && me.visible && (me.isDirty = !0);
          }), Z.linkedSeries.forEach((me) => {
            me.setVisible(z, !1);
          }), ie && (ne.isDirtyBox = !0), B(Z, de), q !== !1 && ne.redraw();
        }
        show() {
          this.setVisible(!0);
        }
        hide() {
          this.setVisible(!1);
        }
        select(z) {
          this.selected = z = this.options.selected = z === void 0 ? !this.selected : z, this.checkbox && (this.checkbox.checked = z), B(this, z ? "select" : "unselect");
        }
        shouldShowTooltip(z, q, Z = {}) {
          return Z.series = this, Z.visiblePlotOnly = !0, this.chart.isInsidePlot(z, q, Z);
        }
        drawLegendSymbol(z, q) {
          l[this.options.legendSymbol || "rectangle"]?.call(this, z, q);
        }
      }
      return W.defaultOptions = y, W.types = u.seriesTypes, W.registerType = u.registerSeriesType, p(W.prototype, { axisTypes: ["xAxis", "yAxis"], coll: "series", colorCounter: 0, directTouch: !1, invertible: !0, isCartesian: !0, kdAxisArray: ["clientX", "plotY"], parallelArrays: ["x", "y"], pointClass: d, requireSorting: !0, sorted: !0 }), u.series = W, W;
    }), i(n, "Core/Legend/Legend.js", [n["Core/Animation/AnimationUtilities.js"], n["Core/Foundation.js"], n["Core/Globals.js"], n["Core/Series/Series.js"], n["Core/Series/Point.js"], n["Core/Renderer/RendererUtilities.js"], n["Core/Templating.js"], n["Core/Utilities.js"]], function(o, a, r, s, l, d, y, u) {
      var m;
      let { animObject: h, setAnimation: c } = o, { registerEventOptions: g } = a, { composed: v, marginNames: P } = r, { distribute: f } = d, { format: S } = y, { addEvent: w, createElement: x, css: k, defined: A, discardElement: $, find: j, fireEvent: N, isNumber: M, merge: D, pick: C, pushUnique: b, relativeLength: p, stableSort: L, syncTimeout: B } = u;
      class T {
        constructor(I, R) {
          this.allItems = [], this.initialItemY = 0, this.itemHeight = 0, this.itemMarginBottom = 0, this.itemMarginTop = 0, this.itemX = 0, this.itemY = 0, this.lastItemY = 0, this.lastLineHeight = 0, this.legendHeight = 0, this.legendWidth = 0, this.maxItemWidth = 0, this.maxLegendWidth = 0, this.offsetWidth = 0, this.padding = 0, this.pages = [], this.symbolHeight = 0, this.symbolWidth = 0, this.titleHeight = 0, this.totalItemWidth = 0, this.widthOption = 0, this.chart = I, this.setOptions(R), R.enabled && (this.render(), g(this, R), w(this.chart, "endResize", function() {
            this.legend.positionCheckboxes();
          })), w(this.chart, "render", () => {
            this.options.enabled && this.proximate && (this.proximatePositions(), this.positionItems());
          });
        }
        setOptions(I) {
          let R = C(I.padding, 8);
          this.options = I, this.chart.styledMode || (this.itemStyle = I.itemStyle, this.itemHiddenStyle = D(this.itemStyle, I.itemHiddenStyle)), this.itemMarginTop = I.itemMarginTop, this.itemMarginBottom = I.itemMarginBottom, this.padding = R, this.initialItemY = R - 5, this.symbolWidth = C(I.symbolWidth, 16), this.pages = [], this.proximate = I.layout === "proximate" && !this.chart.inverted, this.baseline = void 0;
        }
        update(I, R) {
          let Y = this.chart;
          this.setOptions(D(!0, this.options, I)), "events" in this.options && g(this, this.options), this.destroy(), Y.isDirtyLegend = Y.isDirtyBox = !0, C(R, !0) && Y.redraw(), N(this, "afterUpdate", { redraw: R });
        }
        colorizeItem(I, R) {
          let { area: Y, group: F, label: U, line: Q, symbol: J } = I.legendItem || {};
          if (F?.[R ? "removeClass" : "addClass"]("highcharts-legend-item-hidden"), !this.chart.styledMode) {
            let { itemHiddenStyle: ee = {} } = this, V = ee.color, { fillColor: G, fillOpacity: W, lineColor: ae, marker: z } = I.options, q = (Z) => (!R && (Z.fill && (Z.fill = V), Z.stroke && (Z.stroke = V)), Z);
            U?.css(D(R ? this.itemStyle : ee)), Q?.attr(q({ stroke: ae || I.color })), J && J.attr(q(z && J.isMarker ? I.pointAttribs() : { fill: I.color })), Y?.attr(q({ fill: G || I.color, "fill-opacity": G ? 1 : W ?? 0.75 }));
          }
          N(this, "afterColorizeItem", { item: I, visible: R });
        }
        positionItems() {
          this.allItems.forEach(this.positionItem, this), this.chart.isResizing || this.positionCheckboxes();
        }
        positionItem(I) {
          let { group: R, x: Y = 0, y: F = 0 } = I.legendItem || {}, U = this.options, Q = U.symbolPadding, J = !U.rtl, ee = I.checkbox;
          if (R && R.element) {
            let V = { translateX: J ? Y : this.legendWidth - Y - 2 * Q - 4, translateY: F };
            R[A(R.translateY) ? "animate" : "attr"](V, void 0, () => {
              N(this, "afterPositionItem", { item: I });
            });
          }
          ee && (ee.x = Y, ee.y = F);
        }
        destroyItem(I) {
          let R = I.checkbox, Y = I.legendItem || {};
          for (let F of ["group", "label", "line", "symbol"])
            Y[F] && (Y[F] = Y[F].destroy());
          R && $(R), I.legendItem = void 0;
        }
        destroy() {
          for (let I of this.getAllItems())
            this.destroyItem(I);
          for (let I of ["clipRect", "up", "down", "pager", "nav", "box", "title", "group"])
            this[I] && (this[I] = this[I].destroy());
          this.display = null;
        }
        positionCheckboxes() {
          let I, R = this.group && this.group.alignAttr, Y = this.clipHeight || this.legendHeight, F = this.titleHeight;
          R && (I = R.translateY, this.allItems.forEach(function(U) {
            let Q, J = U.checkbox;
            J && (Q = I + F + J.y + (this.scrollOffset || 0) + 3, k(J, { left: R.translateX + U.checkboxOffset + J.x - 20 + "px", top: Q + "px", display: this.proximate || Q > I - 6 && Q < I + Y - 6 ? "" : "none" }));
          }, this));
        }
        renderTitle() {
          let I = this.options, R = this.padding, Y = I.title, F, U = 0;
          Y.text && (this.title || (this.title = this.chart.renderer.label(Y.text, R - 3, R - 4, void 0, void 0, void 0, I.useHTML, void 0, "legend-title").attr({ zIndex: 1 }), this.chart.styledMode || this.title.css(Y.style), this.title.add(this.group)), Y.width || this.title.css({ width: this.maxLegendWidth + "px" }), U = (F = this.title.getBBox()).height, this.offsetWidth = F.width, this.contentGroup.attr({ translateY: U })), this.titleHeight = U;
        }
        setText(I) {
          let R = this.options;
          I.legendItem.label.attr({ text: R.labelFormat ? S(R.labelFormat, I, this.chart) : R.labelFormatter.call(I) });
        }
        renderItem(I) {
          let R = I.legendItem = I.legendItem || {}, Y = this.chart, F = Y.renderer, U = this.options, Q = U.layout === "horizontal", J = this.symbolWidth, ee = U.symbolPadding || 0, V = this.itemStyle, G = this.itemHiddenStyle, W = Q ? C(U.itemDistance, 20) : 0, ae = !U.rtl, z = !I.series, q = !z && I.series.drawLegendSymbol ? I.series : I, Z = q.options, ne = !!this.createCheckboxForItem && Z && Z.showCheckbox, ie = U.useHTML, re = I.options.className, de = R.label, me = J + ee + W + (ne ? 20 : 0);
          !de && (R.group = F.g("legend-item").addClass("highcharts-" + q.type + "-series highcharts-color-" + I.colorIndex + (re ? " " + re : "") + (z ? " highcharts-series-" + I.index : "")).attr({ zIndex: 1 }).add(this.scrollGroup), R.label = de = F.text("", ae ? J + ee : -ee, this.baseline || 0, ie), Y.styledMode || de.css(D(I.visible ? V : G)), de.attr({ align: ae ? "left" : "right", zIndex: 2 }).add(R.group), !this.baseline && (this.fontMetrics = F.fontMetrics(de), this.baseline = this.fontMetrics.f + 3 + this.itemMarginTop, de.attr("y", this.baseline), this.symbolHeight = C(U.symbolHeight, this.fontMetrics.f), U.squareSymbol && (this.symbolWidth = C(U.symbolWidth, Math.max(this.symbolHeight, 16)), me = this.symbolWidth + ee + W + (ne ? 20 : 0), ae && de.attr("x", this.symbolWidth + ee))), q.drawLegendSymbol(this, I), this.setItemEvents && this.setItemEvents(I, de, ie)), ne && !I.checkbox && this.createCheckboxForItem && this.createCheckboxForItem(I), this.colorizeItem(I, I.visible), (Y.styledMode || !V.width) && de.css({ width: (U.itemWidth || this.widthOption || Y.spacingBox.width) - me + "px" }), this.setText(I);
          let ce = de.getBBox(), pe = this.fontMetrics && this.fontMetrics.h || 0;
          I.itemWidth = I.checkboxOffset = U.itemWidth || R.labelWidth || ce.width + me, this.maxItemWidth = Math.max(this.maxItemWidth, I.itemWidth), this.totalItemWidth += I.itemWidth, this.itemHeight = I.itemHeight = Math.round(R.labelHeight || (ce.height > 1.5 * pe ? ce.height : pe));
        }
        layoutItem(I) {
          let R = this.options, Y = this.padding, F = R.layout === "horizontal", U = I.itemHeight, Q = this.itemMarginBottom, J = this.itemMarginTop, ee = F ? C(R.itemDistance, 20) : 0, V = this.maxLegendWidth, G = R.alignColumns && this.totalItemWidth > V ? this.maxItemWidth : I.itemWidth, W = I.legendItem || {};
          F && this.itemX - Y + G > V && (this.itemX = Y, this.lastLineHeight && (this.itemY += J + this.lastLineHeight + Q), this.lastLineHeight = 0), this.lastItemY = J + this.itemY + Q, this.lastLineHeight = Math.max(U, this.lastLineHeight), W.x = this.itemX, W.y = this.itemY, F ? this.itemX += G : (this.itemY += J + U + Q, this.lastLineHeight = U), this.offsetWidth = this.widthOption || Math.max((F ? this.itemX - Y - (I.checkbox ? 0 : ee) : G) + Y, this.offsetWidth);
        }
        getAllItems() {
          let I = [];
          return this.chart.series.forEach(function(R) {
            let Y = R && R.options;
            R && C(Y.showInLegend, !A(Y.linkedTo) && void 0, !0) && (I = I.concat((R.legendItem || {}).labels || (Y.legendType === "point" ? R.data : R)));
          }), N(this, "afterGetAllItems", { allItems: I }), I;
        }
        getAlignment() {
          let I = this.options;
          return this.proximate ? I.align.charAt(0) + "tv" : I.floating ? "" : I.align.charAt(0) + I.verticalAlign.charAt(0) + I.layout.charAt(0);
        }
        adjustMargins(I, R) {
          let Y = this.chart, F = this.options, U = this.getAlignment();
          U && [/(lth|ct|rth)/, /(rtv|rm|rbv)/, /(rbh|cb|lbh)/, /(lbv|lm|ltv)/].forEach(function(Q, J) {
            Q.test(U) && !A(I[J]) && (Y[P[J]] = Math.max(Y[P[J]], Y.legend[(J + 1) % 2 ? "legendHeight" : "legendWidth"] + [1, -1, -1, 1][J] * F[J % 2 ? "x" : "y"] + C(F.margin, 12) + R[J] + (Y.titleOffset[J] || 0)));
          });
        }
        proximatePositions() {
          let I, R = this.chart, Y = [], F = this.options.align === "left";
          for (let U of (this.allItems.forEach(function(Q) {
            let J, ee, V = F, G, W;
            Q.yAxis && (Q.xAxis.options.reversed && (V = !V), Q.points && (J = j(V ? Q.points : Q.points.slice(0).reverse(), function(ae) {
              return M(ae.plotY);
            })), ee = this.itemMarginTop + Q.legendItem.label.getBBox().height + this.itemMarginBottom, W = Q.yAxis.top - R.plotTop, G = Q.visible ? (J ? J.plotY : Q.yAxis.height) + (W - 0.3 * ee) : W + Q.yAxis.height, Y.push({ target: G, size: ee, item: Q }));
          }, this), f(Y, R.plotHeight)))
            I = U.item.legendItem || {}, M(U.pos) && (I.y = R.plotTop - R.spacing[0] + U.pos);
        }
        render() {
          let I = this.chart, R = I.renderer, Y = this.options, F = this.padding, U = this.getAllItems(), Q, J, ee, V = this.group, G, W = this.box;
          this.itemX = F, this.itemY = this.initialItemY, this.offsetWidth = 0, this.lastItemY = 0, this.widthOption = p(Y.width, I.spacingBox.width - F), G = I.spacingBox.width - 2 * F - Y.x, ["rm", "lm"].indexOf(this.getAlignment().substring(0, 2)) > -1 && (G /= 2), this.maxLegendWidth = this.widthOption || G, V || (this.group = V = R.g("legend").addClass(Y.className || "").attr({ zIndex: 7 }).add(), this.contentGroup = R.g().attr({ zIndex: 1 }).add(V), this.scrollGroup = R.g().add(this.contentGroup)), this.renderTitle(), L(U, (ae, z) => (ae.options && ae.options.legendIndex || 0) - (z.options && z.options.legendIndex || 0)), Y.reversed && U.reverse(), this.allItems = U, this.display = Q = !!U.length, this.lastLineHeight = 0, this.maxItemWidth = 0, this.totalItemWidth = 0, this.itemHeight = 0, U.forEach(this.renderItem, this), U.forEach(this.layoutItem, this), J = (this.widthOption || this.offsetWidth) + F, ee = this.lastItemY + this.lastLineHeight + this.titleHeight, ee = this.handleOverflow(ee) + F, W || (this.box = W = R.rect().addClass("highcharts-legend-box").attr({ r: Y.borderRadius }).add(V)), I.styledMode || W.attr({ stroke: Y.borderColor, "stroke-width": Y.borderWidth || 0, fill: Y.backgroundColor || "none" }).shadow(Y.shadow), J > 0 && ee > 0 && W[W.placed ? "animate" : "attr"](W.crisp.call({}, { x: 0, y: 0, width: J, height: ee }, W.strokeWidth())), V[Q ? "show" : "hide"](), I.styledMode && V.getStyle("display") === "none" && (J = ee = 0), this.legendWidth = J, this.legendHeight = ee, Q && this.align(), this.proximate || this.positionItems(), N(this, "afterRender");
        }
        align(I = this.chart.spacingBox) {
          let R = this.chart, Y = this.options, F = I.y;
          /(lth|ct|rth)/.test(this.getAlignment()) && R.titleOffset[0] > 0 ? F += R.titleOffset[0] : /(lbh|cb|rbh)/.test(this.getAlignment()) && R.titleOffset[2] > 0 && (F -= R.titleOffset[2]), F !== I.y && (I = D(I, { y: F })), R.hasRendered || (this.group.placed = !1), this.group.align(D(Y, { width: this.legendWidth, height: this.legendHeight, verticalAlign: this.proximate ? "top" : Y.verticalAlign }), !0, I);
        }
        handleOverflow(I) {
          let R = this, Y = this.chart, F = Y.renderer, U = this.options, Q = U.y, J = U.verticalAlign === "top", ee = this.padding, V = U.maxHeight, G = U.navigation, W = C(G.animation, !0), ae = G.arrowSize || 12, z = this.pages, q = this.allItems, Z = function(xe) {
            typeof xe == "number" ? pe.attr({ height: xe }) : pe && (R.clipRect = pe.destroy(), R.contentGroup.clip()), R.contentGroup.div && (R.contentGroup.div.style.clip = xe ? "rect(" + ee + "px,9999px," + (ee + xe) + "px,0)" : "auto");
          }, ne = function(xe) {
            return R[xe] = F.circle(0, 0, 1.3 * ae).translate(ae / 2, ae / 2).add(ce), Y.styledMode || R[xe].attr("fill", "rgba(0,0,0,0.0001)"), R[xe];
          }, ie, re, de, me = Y.spacingBox.height + (J ? -Q : Q) - ee, ce = this.nav, pe = this.clipRect;
          return U.layout !== "horizontal" || U.verticalAlign === "middle" || U.floating || (me /= 2), V && (me = Math.min(me, V)), z.length = 0, I && me > 0 && I > me && G.enabled !== !1 ? (this.clipHeight = ie = Math.max(me - 20 - this.titleHeight - ee, 0), this.currentPage = C(this.currentPage, 1), this.fullHeight = I, q.forEach((xe, le) => {
            let se = (de = xe.legendItem || {}).y || 0, he = Math.round(de.label.getBBox().height), ve = z.length;
            (!ve || se - z[ve - 1] > ie && (re || se) !== z[ve - 1]) && (z.push(re || se), ve++), de.pageIx = ve - 1, re && ((q[le - 1].legendItem || {}).pageIx = ve - 1), le === q.length - 1 && se + he - z[ve - 1] > ie && se > z[ve - 1] && (z.push(se), de.pageIx = ve), se !== re && (re = se);
          }), pe || (pe = R.clipRect = F.clipRect(0, ee - 2, 9999, 0), R.contentGroup.clip(pe)), Z(ie), ce || (this.nav = ce = F.g().attr({ zIndex: 1 }).add(this.group), this.up = F.symbol("triangle", 0, 0, ae, ae).add(ce), ne("upTracker").on("click", function() {
            R.scroll(-1, W);
          }), this.pager = F.text("", 15, 10).addClass("highcharts-legend-navigation"), !Y.styledMode && G.style && this.pager.css(G.style), this.pager.add(ce), this.down = F.symbol("triangle-down", 0, 0, ae, ae).add(ce), ne("downTracker").on("click", function() {
            R.scroll(1, W);
          })), R.scroll(0), I = me) : ce && (Z(), this.nav = ce.destroy(), this.scrollGroup.attr({ translateY: 1 }), this.clipHeight = 0), I;
        }
        scroll(I, R) {
          let Y = this.chart, F = this.pages, U = F.length, Q = this.clipHeight, J = this.options.navigation, ee = this.pager, V = this.padding, G = this.currentPage + I;
          G > U && (G = U), G > 0 && (R !== void 0 && c(R, Y), this.nav.attr({ translateX: V, translateY: Q + this.padding + 7 + this.titleHeight, visibility: "inherit" }), [this.up, this.upTracker].forEach(function(W) {
            W.attr({ class: G === 1 ? "highcharts-legend-nav-inactive" : "highcharts-legend-nav-active" });
          }), ee.attr({ text: G + "/" + U }), [this.down, this.downTracker].forEach(function(W) {
            W.attr({ x: 18 + this.pager.getBBox().width, class: G === U ? "highcharts-legend-nav-inactive" : "highcharts-legend-nav-active" });
          }, this), Y.styledMode || (this.up.attr({ fill: G === 1 ? J.inactiveColor : J.activeColor }), this.upTracker.css({ cursor: G === 1 ? "default" : "pointer" }), this.down.attr({ fill: G === U ? J.inactiveColor : J.activeColor }), this.downTracker.css({ cursor: G === U ? "default" : "pointer" })), this.scrollOffset = -F[G - 1] + this.initialItemY, this.scrollGroup.animate({ translateY: this.scrollOffset }), this.currentPage = G, this.positionCheckboxes(), B(() => {
            N(this, "afterScroll", { currentPage: G });
          }, h(C(R, Y.renderer.globalAnimation, !0)).duration));
        }
        setItemEvents(I, R, Y) {
          let F = this, U = I.legendItem || {}, Q = F.chart.renderer.boxWrapper, J = I instanceof l, ee = I instanceof s, V = "highcharts-legend-" + (J ? "point" : "series") + "-active", G = F.chart.styledMode, W = Y ? [R, U.symbol] : [U.group], ae = (z) => {
            F.allItems.forEach((q) => {
              I !== q && [q].concat(q.linkedSeries || []).forEach((Z) => {
                Z.setState(z, !J);
              });
            });
          };
          for (let z of W)
            z && z.on("mouseover", function() {
              I.visible && ae("inactive"), I.setState("hover"), I.visible && Q.addClass(V), G || R.css(F.options.itemHoverStyle);
            }).on("mouseout", function() {
              F.chart.styledMode || R.css(D(I.visible ? F.itemStyle : F.itemHiddenStyle)), ae(""), Q.removeClass(V), I.setState();
            }).on("click", function(q) {
              let Z = function() {
                I.setVisible && I.setVisible(), ae(I.visible ? "inactive" : "");
              };
              Q.removeClass(V), N(F, "itemClick", { browserEvent: q, legendItem: I }, Z), J ? I.firePointEvent("legendItemClick", { browserEvent: q }) : ee && N(I, "legendItemClick", { browserEvent: q });
            });
        }
        createCheckboxForItem(I) {
          I.checkbox = x("input", { type: "checkbox", className: "highcharts-legend-checkbox", checked: I.selected, defaultChecked: I.selected }, this.options.itemCheckboxStyle, this.chart.container), w(I.checkbox, "click", function(R) {
            let Y = R.target;
            N(I.series || I, "checkboxClick", { checked: Y.checked, item: I }, function() {
              I.select();
            });
          });
        }
      }
      return (m = T || (T = {})).compose = function(O) {
        b(v, "Core.Legend") && w(O, "beforeMargins", function() {
          this.legend = new m(this, this.options.legend);
        });
      }, T;
    }), i(n, "Core/Chart/Chart.js", [n["Core/Animation/AnimationUtilities.js"], n["Core/Axis/Axis.js"], n["Core/Defaults.js"], n["Core/Templating.js"], n["Core/Foundation.js"], n["Core/Globals.js"], n["Core/Renderer/RendererRegistry.js"], n["Core/Series/Series.js"], n["Core/Series/SeriesRegistry.js"], n["Core/Renderer/SVG/SVGRenderer.js"], n["Core/Time.js"], n["Core/Utilities.js"], n["Core/Renderer/HTML/AST.js"], n["Core/Axis/Tick.js"]], function(o, a, r, s, l, d, y, u, m, h, c, g, v, P) {
      let { animate: f, animObject: S, setAnimation: w } = o, { defaultOptions: x, defaultTime: k } = r, { numberFormat: A } = s, { registerEventOptions: $ } = l, { charts: j, doc: N, marginNames: M, svg: D, win: C } = d, { seriesTypes: b } = m, { addEvent: p, attr: L, createElement: B, css: T, defined: O, diffObjects: I, discardElement: R, erase: Y, error: F, extend: U, find: Q, fireEvent: J, getStyle: ee, isArray: V, isNumber: G, isObject: W, isString: ae, merge: z, objectEach: q, pick: Z, pInt: ne, relativeLength: ie, removeEvent: re, splat: de, syncTimeout: me, uniqueKey: ce } = g;
      class pe {
        static chart(le, se, he) {
          return new pe(le, se, he);
        }
        constructor(le, se, he) {
          this.sharedClips = {};
          let ve = [...arguments];
          (ae(le) || le.nodeName) && (this.renderTo = ve.shift()), this.init(ve[0], ve[1]);
        }
        setZoomOptions() {
          let le = this.options.chart, se = le.zooming;
          this.zooming = { ...se, type: Z(le.zoomType, se.type), key: Z(le.zoomKey, se.key), pinchType: Z(le.pinchType, se.pinchType), singleTouch: Z(le.zoomBySingleTouch, se.singleTouch, !1), resetButton: z(se.resetButton, le.resetZoomButton) };
        }
        init(le, se) {
          J(this, "init", { args: arguments }, function() {
            let he = z(x, le), ve = he.chart;
            this.userOptions = U({}, le), this.margin = [], this.spacing = [], this.labelCollectors = [], this.callback = se, this.isResizing = 0, this.options = he, this.axes = [], this.series = [], this.time = le.time && Object.keys(le.time).length ? new c(le.time) : d.time, this.numberFormatter = ve.numberFormatter || A, this.styledMode = ve.styledMode, this.hasCartesianSeries = ve.showAxes, this.index = j.length, j.push(this), d.chartCount++, $(this, ve), this.xAxis = [], this.yAxis = [], this.pointCount = this.colorCounter = this.symbolCounter = 0, this.setZoomOptions(), J(this, "afterInit"), this.firstRender();
          });
        }
        initSeries(le) {
          let se = this.options.chart, he = le.type || se.type, ve = b[he];
          ve || F(17, !0, this, { missingModuleFor: he });
          let ye = new ve();
          return typeof ye.init == "function" && ye.init(this, le), ye;
        }
        setSortedData() {
          this.getSeriesOrderByLinks().forEach(function(le) {
            le.points || le.data || !le.enabledDataSorting || le.setData(le.options.data, !1);
          });
        }
        getSeriesOrderByLinks() {
          return this.series.concat().sort(function(le, se) {
            return le.linkedSeries.length || se.linkedSeries.length ? se.linkedSeries.length - le.linkedSeries.length : 0;
          });
        }
        orderItems(le, se = 0) {
          let he = this[le], ve = this.options[le] = de(this.options[le]).slice(), ye = this.userOptions[le] = this.userOptions[le] ? de(this.userOptions[le]).slice() : [];
          if (this.hasRendered && (ve.splice(se), ye.splice(se)), he)
            for (let be = se, ke = he.length; be < ke; ++be) {
              let we = he[be];
              we && (we.index = be, we instanceof u && (we.name = we.getName()), we.options.isInternal || (ve[be] = we.options, ye[be] = we.userOptions));
            }
        }
        isInsidePlot(le, se, he = {}) {
          let { inverted: ve, plotBox: ye, plotLeft: be, plotTop: ke, scrollablePlotBox: we } = this, { scrollLeft: Le = 0, scrollTop: Me = 0 } = he.visiblePlotOnly && this.scrollablePlotArea?.scrollingContainer || {}, De = he.series, Ae = he.visiblePlotOnly && we || ye, _e = he.inverted ? se : le, He = he.inverted ? le : se, Ee = { x: _e, y: He, isInsidePlot: !0, options: he };
          if (!he.ignoreX) {
            let Ne = De && (ve && !this.polar ? De.yAxis : De.xAxis) || { pos: be, len: 1 / 0 }, Ye = he.paneCoordinates ? Ne.pos + _e : be + _e;
            Ye >= Math.max(Le + be, Ne.pos) && Ye <= Math.min(Le + be + Ae.width, Ne.pos + Ne.len) || (Ee.isInsidePlot = !1);
          }
          if (!he.ignoreY && Ee.isInsidePlot) {
            let Ne = !ve && he.axis && !he.axis.isXAxis && he.axis || De && (ve ? De.xAxis : De.yAxis) || { pos: ke, len: 1 / 0 }, Ye = he.paneCoordinates ? Ne.pos + He : ke + He;
            Ye >= Math.max(Me + ke, Ne.pos) && Ye <= Math.min(Me + ke + Ae.height, Ne.pos + Ne.len) || (Ee.isInsidePlot = !1);
          }
          return J(this, "afterIsInsidePlot", Ee), Ee.isInsidePlot;
        }
        redraw(le) {
          J(this, "beforeRedraw");
          let se = this.hasCartesianSeries ? this.axes : this.colorAxis || [], he = this.series, ve = this.pointer, ye = this.legend, be = this.userOptions.legend, ke = this.renderer, we = ke.isHidden(), Le = [], Me, De, Ae, _e = this.isDirtyBox, He = this.isDirtyLegend, Ee;
          for (ke.rootFontSize = ke.boxWrapper.getStyle("font-size"), this.setResponsive && this.setResponsive(!1), w(!!this.hasRendered && le, this), we && this.temporaryDisplay(), this.layOutTitles(!1), Ae = he.length; Ae--; )
            if (((Ee = he[Ae]).options.stacking || Ee.options.centerInCategory) && (De = !0, Ee.isDirty)) {
              Me = !0;
              break;
            }
          if (Me)
            for (Ae = he.length; Ae--; )
              (Ee = he[Ae]).options.stacking && (Ee.isDirty = !0);
          he.forEach(function(Ne) {
            Ne.isDirty && (Ne.options.legendType === "point" ? (typeof Ne.updateTotals == "function" && Ne.updateTotals(), He = !0) : be && (be.labelFormatter || be.labelFormat) && (He = !0)), Ne.isDirtyData && J(Ne, "updatedData");
          }), He && ye && ye.options.enabled && (ye.render(), this.isDirtyLegend = !1), De && this.getStacks(), se.forEach(function(Ne) {
            Ne.updateNames(), Ne.setScale();
          }), this.getMargins(), se.forEach(function(Ne) {
            Ne.isDirty && (_e = !0);
          }), se.forEach(function(Ne) {
            let Ye = Ne.min + "," + Ne.max;
            Ne.extKey !== Ye && (Ne.extKey = Ye, Le.push(function() {
              J(Ne, "afterSetExtremes", U(Ne.eventArgs, Ne.getExtremes())), delete Ne.eventArgs;
            })), (_e || De) && Ne.redraw();
          }), _e && this.drawChartBox(), J(this, "predraw"), he.forEach(function(Ne) {
            (_e || Ne.isDirty) && Ne.visible && Ne.redraw(), Ne.isDirtyData = !1;
          }), ve && ve.reset(!0), ke.draw(), J(this, "redraw"), J(this, "render"), we && this.temporaryDisplay(!0), Le.forEach(function(Ne) {
            Ne.call();
          });
        }
        get(le) {
          let se = this.series;
          function he(ye) {
            return ye.id === le || ye.options && ye.options.id === le;
          }
          let ve = Q(this.axes, he) || Q(this.series, he);
          for (let ye = 0; !ve && ye < se.length; ye++)
            ve = Q(se[ye].points || [], he);
          return ve;
        }
        getAxes() {
          let le = this.userOptions;
          for (let se of (J(this, "getAxes"), ["xAxis", "yAxis"]))
            for (let he of le[se] = de(le[se] || {}))
              new a(this, he, se);
          J(this, "afterGetAxes");
        }
        getSelectedPoints() {
          return this.series.reduce((le, se) => (se.getPointsCollection().forEach((he) => {
            Z(he.selectedStaging, he.selected) && le.push(he);
          }), le), []);
        }
        getSelectedSeries() {
          return this.series.filter(function(le) {
            return le.selected;
          });
        }
        setTitle(le, se, he) {
          this.applyDescription("title", le), this.applyDescription("subtitle", se), this.applyDescription("caption", void 0), this.layOutTitles(he);
        }
        applyDescription(le, se) {
          let he = this, ve = this.options[le] = z(this.options[le], se), ye = this[le];
          ye && se && (this[le] = ye = ye.destroy()), ve && !ye && ((ye = this.renderer.text(ve.text, 0, 0, ve.useHTML).attr({ align: ve.align, class: "highcharts-" + le, zIndex: ve.zIndex || 4 }).add()).update = function(be, ke) {
            he.applyDescription(le, be), he.layOutTitles(ke);
          }, this.styledMode || ye.css(U(le === "title" ? { fontSize: this.options.isStock ? "1em" : "1.2em" } : {}, ve.style)), this[le] = ye);
        }
        layOutTitles(le = !0) {
          let se = [0, 0, 0], he = this.renderer, ve = this.spacingBox;
          ["title", "subtitle", "caption"].forEach(function(be) {
            let ke = this[be], we = this.options[be], Le = we.verticalAlign || "top", Me = be === "title" ? Le === "top" ? -3 : 0 : Le === "top" ? se[0] + 2 : 0;
            if (ke) {
              ke.css({ width: (we.width || ve.width + (we.widthAdjust || 0)) + "px" });
              let De = he.fontMetrics(ke).b, Ae = Math.round(ke.getBBox(we.useHTML).height);
              ke.align(U({ y: Le === "bottom" ? De : Me + De, height: Ae }, we), !1, "spacingBox"), we.floating || (Le === "top" ? se[0] = Math.ceil(se[0] + Ae) : Le === "bottom" && (se[2] = Math.ceil(se[2] + Ae)));
            }
          }, this), se[0] && (this.options.title.verticalAlign || "top") === "top" && (se[0] += this.options.title.margin), se[2] && this.options.caption.verticalAlign === "bottom" && (se[2] += this.options.caption.margin);
          let ye = !this.titleOffset || this.titleOffset.join(",") !== se.join(",");
          this.titleOffset = se, J(this, "afterLayOutTitles"), !this.isDirtyBox && ye && (this.isDirtyBox = this.isDirtyLegend = ye, this.hasRendered && le && this.isDirtyBox && this.redraw());
        }
        getContainerBox() {
          let le = [].map.call(this.renderTo.children, (he) => {
            if (he !== this.container) {
              let ve = he.style.display;
              return he.style.display = "none", [he, ve];
            }
          }), se = { width: ee(this.renderTo, "width", !0) || 0, height: ee(this.renderTo, "height", !0) || 0 };
          return le.filter(Boolean).forEach(([he, ve]) => {
            he.style.display = ve;
          }), se;
        }
        getChartSize() {
          let le = this.options.chart, se = le.width, he = le.height, ve = this.getContainerBox(), ye = ve.height > 1 && !(!this.renderTo.parentElement?.style.height && this.renderTo.style.height === "100%");
          this.chartWidth = Math.max(0, se || ve.width || 600), this.chartHeight = Math.max(0, ie(he, this.chartWidth) || (ye ? ve.height : 400)), this.containerBox = ve;
        }
        temporaryDisplay(le) {
          let se = this.renderTo, he;
          if (le)
            for (; se && se.style; )
              se.hcOrigStyle && (T(se, se.hcOrigStyle), delete se.hcOrigStyle), se.hcOrigDetached && (N.body.removeChild(se), se.hcOrigDetached = !1), se = se.parentNode;
          else
            for (; se && se.style && (N.body.contains(se) || se.parentNode || (se.hcOrigDetached = !0, N.body.appendChild(se)), (ee(se, "display", !1) === "none" || se.hcOricDetached) && (se.hcOrigStyle = { display: se.style.display, height: se.style.height, overflow: se.style.overflow }, he = { display: "block", overflow: "hidden" }, se !== this.renderTo && (he.height = 0), T(se, he), se.offsetWidth || se.style.setProperty("display", "block", "important")), (se = se.parentNode) !== N.body); )
              ;
        }
        setClassName(le) {
          this.container.className = "highcharts-container " + (le || "");
        }
        getContainer() {
          let le = this.options, se = le.chart, he = "data-highcharts-chart", ve = ce(), ye, be = this.renderTo;
          be || (this.renderTo = be = se.renderTo), ae(be) && (this.renderTo = be = N.getElementById(be)), be || F(13, !0, this);
          let ke = ne(L(be, he));
          G(ke) && j[ke] && j[ke].hasRendered && j[ke].destroy(), L(be, he, this.index), be.innerHTML = v.emptyHTML, se.skipClone || be.offsetWidth || this.temporaryDisplay(), this.getChartSize();
          let we = this.chartHeight, Le = this.chartWidth;
          T(be, { overflow: "hidden" }), this.styledMode || (ye = U({ position: "relative", overflow: "hidden", width: Le + "px", height: we + "px", textAlign: "left", lineHeight: "normal", zIndex: 0, "-webkit-tap-highlight-color": "rgba(0,0,0,0)", userSelect: "none", "touch-action": "manipulation", outline: "none", padding: "0px" }, se.style || {}));
          let Me = B("div", { id: ve }, ye, be);
          this.container = Me, this.getChartSize(), Le === this.chartWidth || (Le = this.chartWidth, this.styledMode || T(Me, { width: Z(se.style?.width, Le + "px") })), this.containerBox = this.getContainerBox(), this._cursor = Me.style.cursor;
          let De = se.renderer || !D ? y.getRendererType(se.renderer) : h;
          if (this.renderer = new De(Me, Le, we, void 0, se.forExport, le.exporting && le.exporting.allowHTML, this.styledMode), w(void 0, this), this.setClassName(se.className), this.styledMode)
            for (let Ae in le.defs)
              this.renderer.definition(le.defs[Ae]);
          else
            this.renderer.setStyle(se.style);
          this.renderer.chartIndex = this.index, J(this, "afterGetContainer");
        }
        getMargins(le) {
          let { spacing: se, margin: he, titleOffset: ve } = this;
          this.resetMargins(), ve[0] && !O(he[0]) && (this.plotTop = Math.max(this.plotTop, ve[0] + se[0])), ve[2] && !O(he[2]) && (this.marginBottom = Math.max(this.marginBottom, ve[2] + se[2])), this.legend && this.legend.display && this.legend.adjustMargins(he, se), J(this, "getMargins"), le || this.getAxisMargins();
        }
        getAxisMargins() {
          let le = this, se = le.axisOffset = [0, 0, 0, 0], he = le.colorAxis, ve = le.margin, ye = function(be) {
            be.forEach(function(ke) {
              ke.visible && ke.getOffset();
            });
          };
          le.hasCartesianSeries ? ye(le.axes) : he && he.length && ye(he), M.forEach(function(be, ke) {
            O(ve[ke]) || (le[be] += se[ke]);
          }), le.setChartSize();
        }
        getOptions() {
          return I(this.userOptions, x);
        }
        reflow(le) {
          let se = this, he = se.containerBox, ve = se.getContainerBox();
          delete se.pointer?.chartPosition, !se.isPrinting && !se.isResizing && he && ve.width && ((ve.width !== he.width || ve.height !== he.height) && (g.clearTimeout(se.reflowTimeout), se.reflowTimeout = me(function() {
            se.container && se.setSize(void 0, void 0, !1);
          }, le ? 100 : 0)), se.containerBox = ve);
        }
        setReflow() {
          let le = this, se = (he) => {
            le.options?.chart.reflow && le.hasLoaded && le.reflow(he);
          };
          if (typeof ResizeObserver == "function")
            new ResizeObserver(se).observe(le.renderTo);
          else {
            let he = p(C, "resize", se);
            p(this, "destroy", he);
          }
        }
        setSize(le, se, he) {
          let ve = this, ye = ve.renderer;
          ve.isResizing += 1, w(he, ve);
          let be = ye.globalAnimation;
          ve.oldChartHeight = ve.chartHeight, ve.oldChartWidth = ve.chartWidth, le !== void 0 && (ve.options.chart.width = le), se !== void 0 && (ve.options.chart.height = se), ve.getChartSize();
          let { chartWidth: ke, chartHeight: we, scrollablePixelsX: Le = 0, scrollablePixelsY: Me = 0 } = ve;
          (ve.isDirtyBox || ke !== ve.oldChartWidth || we !== ve.oldChartHeight) && (ve.styledMode || (be ? f : T)(ve.container, { width: `${ke + Le}px`, height: `${we + Me}px` }, be), ve.setChartSize(!0), ye.setSize(ke, we, be), ve.axes.forEach(function(De) {
            De.isDirty = !0, De.setScale();
          }), ve.isDirtyLegend = !0, ve.isDirtyBox = !0, ve.layOutTitles(), ve.getMargins(), ve.redraw(be), ve.oldChartHeight = void 0, J(ve, "resize"), setTimeout(() => {
            ve && J(ve, "endResize");
          }, S(be).duration)), ve.isResizing -= 1;
        }
        setChartSize(le) {
          let se, he, ve, ye, { chartHeight: be, chartWidth: ke, inverted: we, spacing: Le, renderer: Me } = this, De = this.clipOffset, Ae = Math[we ? "floor" : "round"];
          this.plotLeft = se = Math.round(this.plotLeft), this.plotTop = he = Math.round(this.plotTop), this.plotWidth = ve = Math.max(0, Math.round(ke - se - this.marginRight)), this.plotHeight = ye = Math.max(0, Math.round(be - he - this.marginBottom)), this.plotSizeX = we ? ye : ve, this.plotSizeY = we ? ve : ye, this.spacingBox = Me.spacingBox = { x: Le[3], y: Le[0], width: ke - Le[3] - Le[1], height: be - Le[0] - Le[2] }, this.plotBox = Me.plotBox = { x: se, y: he, width: ve, height: ye }, De && (this.clipBox = { x: Ae(De[3]), y: Ae(De[0]), width: Ae(this.plotSizeX - De[1] - De[3]), height: Ae(this.plotSizeY - De[0] - De[2]) }), le || (this.axes.forEach(function(_e) {
            _e.setAxisSize(), _e.setAxisTranslation();
          }), Me.alignElements()), J(this, "afterSetChartSize", { skipAxes: le });
        }
        resetMargins() {
          J(this, "resetMargins");
          let le = this, se = le.options.chart, he = se.plotBorderWidth || 0, ve = he / 2;
          ["margin", "spacing"].forEach(function(ye) {
            let be = se[ye], ke = W(be) ? be : [be, be, be, be];
            ["Top", "Right", "Bottom", "Left"].forEach(function(we, Le) {
              le[ye][Le] = Z(se[ye + we], ke[Le]);
            });
          }), M.forEach(function(ye, be) {
            le[ye] = Z(le.margin[be], le.spacing[be]);
          }), le.axisOffset = [0, 0, 0, 0], le.clipOffset = [ve, ve, ve, ve], le.plotBorderWidth = he;
        }
        drawChartBox() {
          let le = this.options.chart, se = this.renderer, he = this.chartWidth, ve = this.chartHeight, ye = this.styledMode, be = this.plotBGImage, ke = le.backgroundColor, we = le.plotBackgroundColor, Le = le.plotBackgroundImage, Me = this.plotLeft, De = this.plotTop, Ae = this.plotWidth, _e = this.plotHeight, He = this.plotBox, Ee = this.clipRect, Ne = this.clipBox, Ye = this.chartBackground, Xe = this.plotBackground, nt = this.plotBorder, ut, bt, Bt, kt = "animate";
          Ye || (this.chartBackground = Ye = se.rect().addClass("highcharts-background").add(), kt = "attr"), ye ? ut = bt = Ye.strokeWidth() : (bt = (ut = le.borderWidth || 0) + (le.shadow ? 8 : 0), Bt = { fill: ke || "none" }, (ut || Ye["stroke-width"]) && (Bt.stroke = le.borderColor, Bt["stroke-width"] = ut), Ye.attr(Bt).shadow(le.shadow)), Ye[kt]({ x: bt / 2, y: bt / 2, width: he - bt - ut % 2, height: ve - bt - ut % 2, r: le.borderRadius }), kt = "animate", Xe || (kt = "attr", this.plotBackground = Xe = se.rect().addClass("highcharts-plot-background").add()), Xe[kt](He), !ye && (Xe.attr({ fill: we || "none" }).shadow(le.plotShadow), Le && (be ? (Le !== be.attr("href") && be.attr("href", Le), be.animate(He)) : this.plotBGImage = se.image(Le, Me, De, Ae, _e).add())), Ee ? Ee.animate({ width: Ne.width, height: Ne.height }) : this.clipRect = se.clipRect(Ne), kt = "animate", nt || (kt = "attr", this.plotBorder = nt = se.rect().addClass("highcharts-plot-border").attr({ zIndex: 1 }).add()), ye || nt.attr({ stroke: le.plotBorderColor, "stroke-width": le.plotBorderWidth || 0, fill: "none" }), nt[kt](nt.crisp({ x: Me, y: De, width: Ae, height: _e }, -nt.strokeWidth())), this.isDirtyBox = !1, J(this, "afterDrawChartBox");
        }
        propFromSeries() {
          let le, se, he, ve = this, ye = ve.options.chart, be = ve.options.series;
          ["inverted", "angular", "polar"].forEach(function(ke) {
            for (se = b[ye.type], he = ye[ke] || se && se.prototype[ke], le = be && be.length; !he && le--; )
              (se = b[be[le].type]) && se.prototype[ke] && (he = !0);
            ve[ke] = he;
          });
        }
        linkSeries(le) {
          let se = this, he = se.series;
          he.forEach(function(ve) {
            ve.linkedSeries.length = 0;
          }), he.forEach(function(ve) {
            let { linkedTo: ye } = ve.options;
            if (ae(ye)) {
              let be;
              (be = ye === ":previous" ? se.series[ve.index - 1] : se.get(ye)) && be.linkedParent !== ve && (be.linkedSeries.push(ve), ve.linkedParent = be, be.enabledDataSorting && ve.setDataSortingOptions(), ve.visible = Z(ve.options.visible, be.options.visible, ve.visible));
            }
          }), J(this, "afterLinkSeries", { isUpdating: le });
        }
        renderSeries() {
          this.series.forEach(function(le) {
            le.translate(), le.render();
          });
        }
        render() {
          let le = this.axes, se = this.colorAxis, he = this.renderer, ve = this.options.chart.axisLayoutRuns || 2, ye = (Me) => {
            Me.forEach((De) => {
              De.visible && De.render();
            });
          }, be = 0, ke = !0, we, Le = 0;
          for (let Me of (this.setTitle(), J(this, "beforeMargins"), this.getStacks?.(), this.getMargins(!0), this.setChartSize(), le)) {
            let { options: De } = Me, { labels: Ae } = De;
            if (this.hasCartesianSeries && Me.horiz && Me.visible && Ae.enabled && Me.series.length && Me.coll !== "colorAxis" && !this.polar) {
              be = De.tickLength, Me.createGroups();
              let _e = new P(Me, 0, "", !0), He = _e.createLabel("x", Ae);
              if (_e.destroy(), He && Z(Ae.reserveSpace, !G(De.crossing)) && (be = He.getBBox().height + Ae.distance + Math.max(De.offset || 0, 0)), be) {
                He?.destroy();
                break;
              }
            }
          }
          for (this.plotHeight = Math.max(this.plotHeight - be, 0); (ke || we || ve > 1) && Le < ve; ) {
            let Me = this.plotWidth, De = this.plotHeight;
            for (let Ae of le)
              Le === 0 ? Ae.setScale() : (Ae.horiz && ke || !Ae.horiz && we) && Ae.setTickInterval(!0);
            Le === 0 ? this.getAxisMargins() : this.getMargins(), ke = Me / this.plotWidth > (Le ? 1 : 1.1), we = De / this.plotHeight > (Le ? 1 : 1.05), Le++;
          }
          this.drawChartBox(), this.hasCartesianSeries ? ye(le) : se && se.length && ye(se), this.seriesGroup || (this.seriesGroup = he.g("series-group").attr({ zIndex: 3 }).shadow(this.options.chart.seriesGroupShadow).add()), this.renderSeries(), this.addCredits(), this.setResponsive && this.setResponsive(), this.hasRendered = !0;
        }
        addCredits(le) {
          let se = this, he = z(!0, this.options.credits, le);
          he.enabled && !this.credits && (this.credits = this.renderer.text(he.text + (this.mapCredits || ""), 0, 0).addClass("highcharts-credits").on("click", function() {
            he.href && (C.location.href = he.href);
          }).attr({ align: he.position.align, zIndex: 8 }), se.styledMode || this.credits.css(he.style), this.credits.add().align(he.position), this.credits.update = function(ve) {
            se.credits = se.credits.destroy(), se.addCredits(ve);
          });
        }
        destroy() {
          let le, se = this, he = se.axes, ve = se.series, ye = se.container, be = ye && ye.parentNode;
          for (J(se, "destroy"), se.renderer.forExport ? Y(j, se) : j[se.index] = void 0, d.chartCount--, se.renderTo.removeAttribute("data-highcharts-chart"), re(se), le = he.length; le--; )
            he[le] = he[le].destroy();
          for (this.scroller && this.scroller.destroy && this.scroller.destroy(), le = ve.length; le--; )
            ve[le] = ve[le].destroy();
          ["title", "subtitle", "chartBackground", "plotBackground", "plotBGImage", "plotBorder", "seriesGroup", "clipRect", "credits", "pointer", "rangeSelector", "legend", "resetZoomButton", "tooltip", "renderer"].forEach(function(ke) {
            let we = se[ke];
            we && we.destroy && (se[ke] = we.destroy());
          }), ye && (ye.innerHTML = v.emptyHTML, re(ye), be && R(ye)), q(se, function(ke, we) {
            delete se[we];
          });
        }
        firstRender() {
          let le = this, se = le.options;
          le.getContainer(), le.resetMargins(), le.setChartSize(), le.propFromSeries(), le.getAxes();
          let he = V(se.series) ? se.series : [];
          se.series = [], he.forEach(function(ve) {
            le.initSeries(ve);
          }), le.linkSeries(), le.setSortedData(), J(le, "beforeRender"), le.render(), le.pointer?.getChartPosition(), le.renderer.imgCount || le.hasLoaded || le.onload(), le.temporaryDisplay(!0);
        }
        onload() {
          this.callbacks.concat([this.callback]).forEach(function(le) {
            le && this.index !== void 0 && le.apply(this, [this]);
          }, this), J(this, "load"), J(this, "render"), O(this.index) && this.setReflow(), this.warnIfA11yModuleNotLoaded(), this.hasLoaded = !0;
        }
        warnIfA11yModuleNotLoaded() {
          let { options: le, title: se } = this;
          !le || this.accessibility || (this.renderer.boxWrapper.attr({ role: "img", "aria-label": (se && se.element.textContent || "").replace(/</g, "&lt;") }), le.accessibility && le.accessibility.enabled === !1 || F('Highcharts warning: Consider including the "accessibility.js" module to make your chart more usable for people with disabilities. Set the "accessibility.enabled" option to false to remove this warning. See https://www.highcharts.com/docs/accessibility/accessibility-module.', !1, this));
        }
        addSeries(le, se, he) {
          let ve, ye = this;
          return le && (se = Z(se, !0), J(ye, "addSeries", { options: le }, function() {
            ve = ye.initSeries(le), ye.isDirtyLegend = !0, ye.linkSeries(), ve.enabledDataSorting && ve.setData(le.data, !1), J(ye, "afterAddSeries", { series: ve }), se && ye.redraw(he);
          })), ve;
        }
        addAxis(le, se, he, ve) {
          return this.createAxis(se ? "xAxis" : "yAxis", { axis: le, redraw: he, animation: ve });
        }
        addColorAxis(le, se, he) {
          return this.createAxis("colorAxis", { axis: le, redraw: se, animation: he });
        }
        createAxis(le, se) {
          let he = new a(this, se.axis, le);
          return Z(se.redraw, !0) && this.redraw(se.animation), he;
        }
        showLoading(le) {
          let se = this, he = se.options, ve = he.loading, ye = function() {
            be && T(be, { left: se.plotLeft + "px", top: se.plotTop + "px", width: se.plotWidth + "px", height: se.plotHeight + "px" });
          }, be = se.loadingDiv, ke = se.loadingSpan;
          be || (se.loadingDiv = be = B("div", { className: "highcharts-loading highcharts-loading-hidden" }, null, se.container)), ke || (se.loadingSpan = ke = B("span", { className: "highcharts-loading-inner" }, null, be), p(se, "redraw", ye)), be.className = "highcharts-loading", v.setElementHTML(ke, Z(le, he.lang.loading, "")), se.styledMode || (T(be, U(ve.style, { zIndex: 10 })), T(ke, ve.labelStyle), se.loadingShown || (T(be, { opacity: 0, display: "" }), f(be, { opacity: ve.style.opacity || 0.5 }, { duration: ve.showDuration || 0 }))), se.loadingShown = !0, ye();
        }
        hideLoading() {
          let le = this.options, se = this.loadingDiv;
          se && (se.className = "highcharts-loading highcharts-loading-hidden", this.styledMode || f(se, { opacity: 0 }, { duration: le.loading.hideDuration || 100, complete: function() {
            T(se, { display: "none" });
          } })), this.loadingShown = !1;
        }
        update(le, se, he, ve) {
          let ye, be, ke, we = this, Le = { credits: "addCredits", title: "setTitle", subtitle: "setSubtitle", caption: "setCaption" }, Me = le.isResponsiveOptions, De = [];
          J(we, "update", { options: le }), Me || we.setResponsive(!1, !0), le = I(le, we.options), we.userOptions = z(we.userOptions, le);
          let Ae = le.chart;
          Ae && (z(!0, we.options.chart, Ae), this.setZoomOptions(), "className" in Ae && we.setClassName(Ae.className), ("inverted" in Ae || "polar" in Ae || "type" in Ae) && (we.propFromSeries(), ye = !0), "alignTicks" in Ae && (ye = !0), "events" in Ae && $(this, Ae), q(Ae, function(Ee, Ne) {
            we.propsRequireUpdateSeries.indexOf("chart." + Ne) !== -1 && (be = !0), we.propsRequireDirtyBox.indexOf(Ne) !== -1 && (we.isDirtyBox = !0), we.propsRequireReflow.indexOf(Ne) === -1 || (we.isDirtyBox = !0, Me || (ke = !0));
          }), !we.styledMode && Ae.style && we.renderer.setStyle(we.options.chart.style || {})), !we.styledMode && le.colors && (this.options.colors = le.colors), le.time && (this.time === k && (this.time = new c(le.time)), z(!0, we.options.time, le.time)), q(le, function(Ee, Ne) {
            we[Ne] && typeof we[Ne].update == "function" ? we[Ne].update(Ee, !1) : typeof we[Le[Ne]] == "function" ? we[Le[Ne]](Ee) : Ne !== "colors" && we.collectionsWithUpdate.indexOf(Ne) === -1 && z(!0, we.options[Ne], le[Ne]), Ne !== "chart" && we.propsRequireUpdateSeries.indexOf(Ne) !== -1 && (be = !0);
          }), this.collectionsWithUpdate.forEach(function(Ee) {
            le[Ee] && (de(le[Ee]).forEach(function(Ne, Ye) {
              let Xe, nt = O(Ne.id);
              nt && (Xe = we.get(Ne.id)), !Xe && we[Ee] && (Xe = we[Ee][Z(Ne.index, Ye)]) && (nt && O(Xe.options.id) || Xe.options.isInternal) && (Xe = void 0), Xe && Xe.coll === Ee && (Xe.update(Ne, !1), he && (Xe.touched = !0)), !Xe && he && we.collectionsWithInit[Ee] && (we.collectionsWithInit[Ee][0].apply(we, [Ne].concat(we.collectionsWithInit[Ee][1] || []).concat([!1])).touched = !0);
            }), he && we[Ee].forEach(function(Ne) {
              Ne.touched || Ne.options.isInternal ? delete Ne.touched : De.push(Ne);
            }));
          }), De.forEach(function(Ee) {
            Ee.chart && Ee.remove && Ee.remove(!1);
          }), ye && we.axes.forEach(function(Ee) {
            Ee.update({}, !1);
          }), be && we.getSeriesOrderByLinks().forEach(function(Ee) {
            Ee.chart && Ee.update({}, !1);
          }, this);
          let _e = Ae && Ae.width, He = Ae && (ae(Ae.height) ? ie(Ae.height, _e || we.chartWidth) : Ae.height);
          ke || G(_e) && _e !== we.chartWidth || G(He) && He !== we.chartHeight ? we.setSize(_e, He, ve) : Z(se, !0) && we.redraw(ve), J(we, "afterUpdate", { options: le, redraw: se, animation: ve });
        }
        setSubtitle(le, se) {
          this.applyDescription("subtitle", le), this.layOutTitles(se);
        }
        setCaption(le, se) {
          this.applyDescription("caption", le), this.layOutTitles(se);
        }
        showResetZoom() {
          let le = this, se = x.lang, he = le.zooming.resetButton, ve = he.theme, ye = he.relativeTo === "chart" || he.relativeTo === "spacingBox" ? null : "plotBox";
          function be() {
            le.zoomOut();
          }
          J(this, "beforeShowResetZoom", null, function() {
            le.resetZoomButton = le.renderer.button(se.resetZoom, null, null, be, ve).attr({ align: he.position.align, title: se.resetZoomTitle }).addClass("highcharts-reset-zoom").add().align(he.position, !1, ye);
          }), J(this, "afterShowResetZoom");
        }
        zoomOut() {
          J(this, "selection", { resetSelection: !0 }, () => this.transform({ reset: !0, trigger: "zoom" }));
        }
        pan(le, se) {
          let he = this, ve = typeof se == "object" ? se : { enabled: se, type: "x" }, ye = ve.type, be = ye && he[{ x: "xAxis", xy: "axes", y: "yAxis" }[ye]].filter((we) => we.options.panningEnabled && !we.options.isInternal), ke = he.options.chart;
          ke?.panning && (ke.panning = ve), J(this, "pan", { originalEvent: le }, () => {
            he.transform({ axes: be, event: le, to: { x: le.chartX - (he.mouseDownX || 0), y: le.chartY - (he.mouseDownY || 0) }, trigger: "pan" }), T(he.container, { cursor: "move" });
          });
        }
        transform(le) {
          let { axes: se = this.axes, event: he, from: ve = {}, reset: ye, selection: be, to: ke = {}, trigger: we } = le, { inverted: Le } = this, Me = !1, De, Ae;
          for (let _e of (this.hoverPoints?.forEach((He) => He.setState()), se)) {
            let { horiz: He, len: Ee, minPointOffset: Ne = 0, options: Ye, reversed: Xe } = _e, nt = He ? "width" : "height", ut = He ? "x" : "y", bt = Z(ke[nt], _e.len), Bt = Z(ve[nt], _e.len), kt = 10 > Math.abs(bt) ? 1 : bt / Bt, nn = (ve[ut] || 0) + Bt / 2 - _e.pos, an = nn - ((ke[ut] ?? _e.pos) + bt / 2 - _e.pos) / kt, Cn = Xe && !Le || !Xe && Le ? -1 : 1;
            if (!ye && (nn < 0 || nn > _e.len))
              continue;
            let Ft = _e.toValue(an, !0) + (be || _e.isOrdinal ? 0 : Ne * Cn), dn = _e.toValue(an + Ee / kt, !0) - (be || _e.isOrdinal ? 0 : Ne * Cn || 0), Rn = _e.allExtremes;
            if (Ft > dn && ([Ft, dn] = [dn, Ft]), kt === 1 && !ye && _e.coll === "yAxis" && !Rn) {
              for (let Qs of _e.series) {
                let Ka = Qs.getExtremes(Qs.getProcessedData(!0).yData, !0);
                Rn ?? (Rn = { dataMin: Number.MAX_VALUE, dataMax: -Number.MAX_VALUE }), G(Ka.dataMin) && G(Ka.dataMax) && (Rn.dataMin = Math.min(Ka.dataMin, Rn.dataMin), Rn.dataMax = Math.max(Ka.dataMax, Rn.dataMax));
              }
              _e.allExtremes = Rn;
            }
            let { dataMin: Vh, dataMax: Gh, min: Ys, max: qs } = U(_e.getExtremes(), Rn || {}), Ks = Vh ?? Ye.min, Xs = Gh ?? Ye.max, Yo = dn - Ft, Zs = _e.categories ? 0 : Math.min(Yo, Xs - Ks), qo = Ks - Zs * (O(Ye.min) ? 0 : Ye.minPadding), Ko = Xs + Zs * (O(Ye.max) ? 0 : Ye.maxPadding), Js = _e.allowZoomOutside || kt === 1 || we !== "zoom" && kt > 1, Ya = Math.min(Ye.min ?? qo, qo, Js ? Ys : qo), qa = Math.max(Ye.max ?? Ko, Ko, Js ? qs : Ko);
            (!_e.isOrdinal || _e.options.overscroll || kt !== 1 || ye) && (Ft < Ya && (Ft = Ya, kt >= 1 && (dn = Ft + Yo)), dn > qa && (dn = qa, kt >= 1 && (Ft = dn - Yo)), (ye || _e.series.length && (Ft !== Ys || dn !== qs) && Ft >= Ya && dn <= qa) && (be ? be[_e.coll].push({ axis: _e, min: Ft, max: dn }) : (_e.isPanning = we !== "zoom", _e.isPanning && (Ae = !0), _e.setExtremes(ye ? void 0 : Ft, ye ? void 0 : dn, !1, !1, { move: an, trigger: we, scale: kt }), !ye && (Ft > Ya || dn < qa) && we !== "mousewheel" && (De = !0)), Me = !0), he && (this[He ? "mouseDownX" : "mouseDownY"] = he[He ? "chartX" : "chartY"]));
          }
          return Me && (be ? J(this, "selection", be, () => {
            delete le.selection, le.trigger = "zoom", this.transform(le);
          }) : (!De || Ae || this.resetZoomButton ? !De && this.resetZoomButton && (this.resetZoomButton = this.resetZoomButton.destroy()) : this.showResetZoom(), this.redraw(we === "zoom" && (this.options.chart.animation ?? this.pointCount < 100)))), Me;
        }
      }
      return U(pe.prototype, { callbacks: [], collectionsWithInit: { xAxis: [pe.prototype.addAxis, [!0]], yAxis: [pe.prototype.addAxis, [!1]], series: [pe.prototype.addSeries] }, collectionsWithUpdate: ["xAxis", "yAxis", "series"], propsRequireDirtyBox: ["backgroundColor", "borderColor", "borderWidth", "borderRadius", "plotBackgroundColor", "plotBackgroundImage", "plotBorderColor", "plotBorderWidth", "plotShadow", "shadow"], propsRequireReflow: ["margin", "marginTop", "marginRight", "marginBottom", "marginLeft", "spacing", "spacingTop", "spacingRight", "spacingBottom", "spacingLeft"], propsRequireUpdateSeries: ["chart.inverted", "chart.polar", "chart.ignoreHiddenSeries", "chart.type", "colors", "plotOptions", "time", "tooltip"] }), pe;
    }), i(n, "Extensions/ScrollablePlotArea.js", [n["Core/Animation/AnimationUtilities.js"], n["Core/Globals.js"], n["Core/Renderer/RendererRegistry.js"], n["Core/Utilities.js"]], function(o, a, r, s) {
      let { stop: l } = o, { composed: d } = a, { addEvent: y, createElement: u, css: m, defined: h, merge: c, pushUnique: g } = s;
      function v() {
        let S = this.scrollablePlotArea;
        (this.scrollablePixelsX || this.scrollablePixelsY) && !S && (this.scrollablePlotArea = S = new f(this)), S?.applyFixed();
      }
      function P() {
        this.chart.scrollablePlotArea && (this.chart.scrollablePlotArea.isDirty = !0);
      }
      class f {
        static compose(w, x, k) {
          g(d, this.compose) && (y(w, "afterInit", P), y(x, "afterSetChartSize", (A) => this.afterSetSize(A.target, A)), y(x, "render", v), y(k, "show", P));
        }
        static afterSetSize(w, x) {
          let k, A, $, { minWidth: j, minHeight: N } = w.options.chart.scrollablePlotArea || {}, { clipBox: M, plotBox: D, inverted: C, renderer: b } = w;
          if (!b.forExport && (j ? (w.scrollablePixelsX = k = Math.max(0, j - w.chartWidth), k && (w.scrollablePlotBox = c(w.plotBox), D.width = w.plotWidth += k, M[C ? "height" : "width"] += k, $ = !0)) : N && (w.scrollablePixelsY = A = Math.max(0, N - w.chartHeight), h(A) && (w.scrollablePlotBox = c(w.plotBox), D.height = w.plotHeight += A, M[C ? "width" : "height"] += A, $ = !1)), h($) && !x.skipAxes))
            for (let p of w.axes)
              p.horiz === $ && (p.setAxisSize(), p.setAxisTranslation());
        }
        constructor(w) {
          let x, k = w.options.chart, A = r.getRendererType(), $ = k.scrollablePlotArea || {}, j = this.moveFixedElements.bind(this), N = { WebkitOverflowScrolling: "touch", overflowX: "hidden", overflowY: "hidden" };
          w.scrollablePixelsX && (N.overflowX = "auto"), w.scrollablePixelsY && (N.overflowY = "auto"), this.chart = w;
          let M = this.parentDiv = u("div", { className: "highcharts-scrolling-parent" }, { position: "relative" }, w.renderTo), D = this.scrollingContainer = u("div", { className: "highcharts-scrolling" }, N, M), C = this.innerContainer = u("div", { className: "highcharts-inner-container" }, void 0, D), b = this.fixedDiv = u("div", { className: "highcharts-fixed" }, { position: "absolute", overflow: "hidden", pointerEvents: "none", zIndex: (k.style?.zIndex || 0) + 2, top: 0 }, void 0, !0), p = this.fixedRenderer = new A(b, w.chartWidth, w.chartHeight, k.style);
          this.mask = p.path().attr({ fill: k.backgroundColor || "#fff", "fill-opacity": $.opacity ?? 0.85, zIndex: -1 }).addClass("highcharts-scrollable-mask").add(), D.parentNode.insertBefore(b, D), m(w.renderTo, { overflow: "visible" }), y(w, "afterShowResetZoom", j), y(w, "afterApplyDrilldown", j), y(w, "afterLayOutTitles", j), y(D, "scroll", () => {
            let { pointer: L, hoverPoint: B } = w;
            L && (delete L.chartPosition, B && (x = B), L.runPointActions(void 0, x, !0));
          }), C.appendChild(w.container);
        }
        applyFixed() {
          let { chart: w, fixedRenderer: x, isDirty: k, scrollingContainer: A } = this, { axisOffset: $, chartWidth: j, chartHeight: N, container: M, plotHeight: D, plotLeft: C, plotTop: b, plotWidth: p, scrollablePixelsX: L = 0, scrollablePixelsY: B = 0 } = w, { scrollPositionX: T = 0, scrollPositionY: O = 0 } = w.options.chart.scrollablePlotArea || {}, I = j + L, R = N + B;
          x.setSize(j, N), (k ?? !0) && (this.isDirty = !1, this.moveFixedElements()), l(w.container), m(M, { width: `${I}px`, height: `${R}px` }), w.renderer.boxWrapper.attr({ width: I, height: R, viewBox: [0, 0, I, R].join(" ") }), w.chartBackground?.attr({ width: I, height: R }), m(A, { width: `${j}px`, height: `${N}px` }), h(k) || (A.scrollLeft = L * T, A.scrollTop = B * O);
          let Y = b - $[0] - 1, F = C - $[3] - 1, U = b + D + $[2] + 1, Q = C + p + $[1] + 1, J = C + p - L, ee = b + D - B, V = [["M", 0, 0]];
          L ? V = [["M", 0, Y], ["L", C - 1, Y], ["L", C - 1, U], ["L", 0, U], ["Z"], ["M", J, Y], ["L", j, Y], ["L", j, U], ["L", J, U], ["Z"]] : B && (V = [["M", F, 0], ["L", F, b - 1], ["L", Q, b - 1], ["L", Q, 0], ["Z"], ["M", F, ee], ["L", F, N], ["L", Q, N], ["L", Q, ee], ["Z"]]), w.redrawTrigger !== "adjustHeight" && this.mask.attr({ d: V });
        }
        moveFixedElements() {
          let w, { container: x, inverted: k, scrollablePixelsX: A, scrollablePixelsY: $ } = this.chart, j = this.fixedRenderer, N = f.fixedSelectors;
          for (let M of (A && !k ? w = ".highcharts-yaxis" : A && k || $ && !k ? w = ".highcharts-xaxis" : $ && k && (w = ".highcharts-yaxis"), w && N.push(`${w}:not(.highcharts-radial-axis)`, `${w}-labels:not(.highcharts-radial-axis-labels)`), N))
            [].forEach.call(x.querySelectorAll(M), (D) => {
              (D.namespaceURI === j.SVG_NS ? j.box : j.box.parentNode).appendChild(D), D.style.pointerEvents = "auto";
            });
        }
      }
      return f.fixedSelectors = [".highcharts-breadcrumbs-group", ".highcharts-contextbutton", ".highcharts-caption", ".highcharts-credits", ".highcharts-drillup-button", ".highcharts-legend", ".highcharts-legend-checkbox", ".highcharts-navigator-series", ".highcharts-navigator-xaxis", ".highcharts-navigator-yaxis", ".highcharts-navigator", ".highcharts-range-selector-group", ".highcharts-reset-zoom", ".highcharts-scrollbar", ".highcharts-subtitle", ".highcharts-title"], f;
    }), i(n, "Core/Axis/Stacking/StackItem.js", [n["Core/Templating.js"], n["Core/Series/SeriesRegistry.js"], n["Core/Utilities.js"]], function(o, a, r) {
      let { format: s } = o, { series: l } = a, { destroyObjectProperties: d, fireEvent: y, isNumber: u, pick: m } = r;
      return class {
        constructor(h, c, g, v, P) {
          let f = h.chart.inverted, S = h.reversed;
          this.axis = h;
          let w = this.isNegative = !!g != !!S;
          this.options = c = c || {}, this.x = v, this.total = null, this.cumulative = null, this.points = {}, this.hasValidPoints = !1, this.stack = P, this.leftCliff = 0, this.rightCliff = 0, this.alignOptions = { align: c.align || (f ? w ? "left" : "right" : "center"), verticalAlign: c.verticalAlign || (f ? "middle" : w ? "bottom" : "top"), y: c.y, x: c.x }, this.textAlign = c.textAlign || (f ? w ? "right" : "left" : "center");
        }
        destroy() {
          d(this, this.axis);
        }
        render(h) {
          let c = this.axis.chart, g = this.options, v = g.format, P = v ? s(v, this, c) : g.formatter.call(this);
          if (this.label)
            this.label.attr({ text: P, visibility: "hidden" });
          else {
            this.label = c.renderer.label(P, null, void 0, g.shape, void 0, void 0, g.useHTML, !1, "stack-labels");
            let f = { r: g.borderRadius || 0, text: P, padding: m(g.padding, 5), visibility: "hidden" };
            c.styledMode || (f.fill = g.backgroundColor, f.stroke = g.borderColor, f["stroke-width"] = g.borderWidth, this.label.css(g.style || {})), this.label.attr(f), this.label.added || this.label.add(h);
          }
          this.label.labelrank = c.plotSizeY, y(this, "afterRender");
        }
        setOffset(h, c, g, v, P, f) {
          let { alignOptions: S, axis: w, label: x, options: k, textAlign: A } = this, $ = w.chart, j = this.getStackBox({ xOffset: h, width: c, boxBottom: g, boxTop: v, defaultX: P, xAxis: f }), { verticalAlign: N } = S;
          if (x && j) {
            let M = x.getBBox(void 0, 0), D = x.padding, C = m(k.overflow, "justify") === "justify", b;
            S.x = k.x || 0, S.y = k.y || 0;
            let { x: p, y: L } = this.adjustStackPosition({ labelBox: M, verticalAlign: N, textAlign: A });
            j.x -= p, j.y -= L, x.align(S, !1, j), (b = $.isInsidePlot(x.alignAttr.x + S.x + p, x.alignAttr.y + S.y + L)) || (C = !1), C && l.prototype.justifyDataLabel.call(w, x, S, x.alignAttr, M, j), x.attr({ x: x.alignAttr.x, y: x.alignAttr.y, rotation: k.rotation, rotationOriginX: M.width * { left: 0, center: 0.5, right: 1 }[k.textAlign || "center"], rotationOriginY: M.height / 2 }), m(!C && k.crop, !0) && (b = u(x.x) && u(x.y) && $.isInsidePlot(x.x - D + (x.width || 0), x.y) && $.isInsidePlot(x.x + D, x.y)), x[b ? "show" : "hide"]();
          }
          y(this, "afterSetOffset", { xOffset: h, width: c });
        }
        adjustStackPosition({ labelBox: h, verticalAlign: c, textAlign: g }) {
          let v = { bottom: 0, middle: 1, top: 2, right: 1, center: 0, left: -1 }, P = v[c], f = v[g];
          return { x: h.width / 2 + h.width / 2 * f, y: h.height / 2 * P };
        }
        getStackBox(h) {
          let c = this.axis, g = c.chart, { boxTop: v, defaultX: P, xOffset: f, width: S, boxBottom: w } = h, x = c.stacking.usePercentage ? 100 : m(v, this.total, 0), k = c.toPixels(x), A = h.xAxis || g.xAxis[0], $ = m(P, A.translate(this.x)) + f, j = Math.abs(k - c.toPixels(w || u(c.min) && c.logarithmic && c.logarithmic.lin2log(c.min) || 0)), N = g.inverted, M = this.isNegative;
          return N ? { x: (M ? k : k - j) - g.plotLeft, y: A.height - $ - S + A.top - g.plotTop, width: j, height: S } : { x: $ + A.transB - g.plotLeft, y: (M ? k - j : k) - g.plotTop, width: S, height: j };
        }
      };
    }), i(n, "Core/Axis/Stacking/StackingAxis.js", [n["Core/Animation/AnimationUtilities.js"], n["Core/Axis/Axis.js"], n["Core/Series/SeriesRegistry.js"], n["Core/Axis/Stacking/StackItem.js"], n["Core/Utilities.js"]], function(o, a, r, s, l) {
      var d;
      let { getDeferredAnimation: y } = o, { series: { prototype: u } } = r, { addEvent: m, correctFloat: h, defined: c, destroyObjectProperties: g, fireEvent: v, isArray: P, isNumber: f, objectEach: S, pick: w } = l;
      function x() {
        let b = this.inverted;
        this.axes.forEach((p) => {
          p.stacking && p.stacking.stacks && p.hasVisibleSeries && (p.stacking.oldStacks = p.stacking.stacks);
        }), this.series.forEach((p) => {
          let L = p.xAxis && p.xAxis.options || {};
          p.options.stacking && p.reserveSpace() && (p.stackKey = [p.type, w(p.options.stack, ""), b ? L.top : L.left, b ? L.height : L.width].join(","));
        });
      }
      function k() {
        let b = this.stacking;
        if (b) {
          let p = b.stacks;
          S(p, (L, B) => {
            g(L), delete p[B];
          }), b.stackTotalGroup?.destroy();
        }
      }
      function A() {
        this.stacking || (this.stacking = new C(this));
      }
      function $(b, p, L, B) {
        return !c(b) || b.x !== p || B && b.stackKey !== B ? b = { x: p, index: 0, key: B, stackKey: B } : b.index++, b.key = [L, p, b.index].join(","), b;
      }
      function j() {
        let b, p = this, L = p.yAxis, B = p.stackKey || "", T = L.stacking.stacks, O = p.processedXData, I = p.options.stacking, R = p[I + "Stacker"];
        R && [B, "-" + B].forEach((Y) => {
          let F = O.length, U, Q, J;
          for (; F--; )
            U = O[F], b = p.getStackIndicator(b, U, p.index, Y), Q = T[Y]?.[U], (J = Q?.points[b.key || ""]) && R.call(p, J, Q, F);
        });
      }
      function N(b, p, L) {
        let B = p.total ? 100 / p.total : 0;
        b[0] = h(b[0] * B), b[1] = h(b[1] * B), this.stackedYData[L] = b[1];
      }
      function M(b) {
        (this.is("column") || this.is("columnrange")) && (this.options.centerInCategory && !this.options.stacking && this.chart.series.length > 1 ? u.setStackedPoints.call(this, b, "group") : b.stacking.resetStacks());
      }
      function D(b, p) {
        let L, B, T, O, I, R, Y, F, U, Q = p || this.options.stacking;
        if (!Q || !this.reserveSpace() || ({ group: "xAxis" }[Q] || "yAxis") !== b.coll)
          return;
        let J = this.processedXData, ee = this.processedYData, V = [], G = ee.length, W = this.options, ae = W.threshold || 0, z = W.startFromThreshold ? ae : 0, q = W.stack, Z = p ? `${this.type},${Q}` : this.stackKey || "", ne = "-" + Z, ie = this.negStacks, re = b.stacking, de = re.stacks, me = re.oldStacks;
        for (re.stacksTouched += 1, Y = 0; Y < G; Y++) {
          F = J[Y], U = ee[Y], R = (L = this.getStackIndicator(L, F, this.index)).key || "", de[I = (B = ie && U < (z ? 0 : ae)) ? ne : Z] || (de[I] = {}), de[I][F] || (me[I]?.[F] ? (de[I][F] = me[I][F], de[I][F].total = null) : de[I][F] = new s(b, b.options.stackLabels, !!B, F, q)), T = de[I][F], U !== null ? (T.points[R] = T.points[this.index] = [w(T.cumulative, z)], c(T.cumulative) || (T.base = R), T.touched = re.stacksTouched, L.index > 0 && this.singleStacks === !1 && (T.points[R][0] = T.points[this.index + "," + F + ",0"][0])) : (delete T.points[R], delete T.points[this.index]);
          let ce = T.total || 0;
          Q === "percent" ? (O = B ? Z : ne, ce = ie && de[O]?.[F] ? (O = de[O][F]).total = Math.max(O.total || 0, ce) + Math.abs(U) || 0 : h(ce + (Math.abs(U) || 0))) : Q === "group" ? (P(U) && (U = U[0]), U !== null && ce++) : ce = h(ce + (U || 0)), Q === "group" ? T.cumulative = (ce || 1) - 1 : T.cumulative = h(w(T.cumulative, z) + (U || 0)), T.total = ce, U !== null && (T.points[R].push(T.cumulative), V[Y] = T.cumulative, T.hasValidPoints = !0);
        }
        Q === "percent" && (re.usePercentage = !0), Q !== "group" && (this.stackedYData = V), re.oldStacks = {};
      }
      class C {
        constructor(p) {
          this.oldStacks = {}, this.stacks = {}, this.stacksTouched = 0, this.axis = p;
        }
        buildStacks() {
          let p, L, B = this.axis, T = B.series, O = B.coll === "xAxis", I = B.options.reversedStacks, R = T.length;
          for (this.resetStacks(), this.usePercentage = !1, L = R; L--; )
            p = T[I ? L : R - L - 1], O && p.setGroupedPoints(B), p.setStackedPoints(B);
          if (!O)
            for (L = 0; L < R; L++)
              T[L].modifyStacks();
          v(B, "afterBuildStacks");
        }
        cleanStacks() {
          this.oldStacks && (this.stacks = this.oldStacks, S(this.stacks, (p) => {
            S(p, (L) => {
              L.cumulative = L.total;
            });
          }));
        }
        resetStacks() {
          S(this.stacks, (p) => {
            S(p, (L, B) => {
              f(L.touched) && L.touched < this.stacksTouched ? (L.destroy(), delete p[B]) : (L.total = null, L.cumulative = null);
            });
          });
        }
        renderStackTotals() {
          let p = this.axis, L = p.chart, B = L.renderer, T = this.stacks, O = y(L, p.options.stackLabels?.animation || !1), I = this.stackTotalGroup = this.stackTotalGroup || B.g("stack-labels").attr({ zIndex: 6, opacity: 0 }).add();
          I.translate(L.plotLeft, L.plotTop), S(T, (R) => {
            S(R, (Y) => {
              Y.render(I);
            });
          }), I.animate({ opacity: 1 }, O);
        }
      }
      return (d || (d = {})).compose = function(b, p, L) {
        let B = p.prototype, T = L.prototype;
        B.getStacks || (m(b, "init", A), m(b, "destroy", k), B.getStacks = x, T.getStackIndicator = $, T.modifyStacks = j, T.percentStacker = N, T.setGroupedPoints = M, T.setStackedPoints = D);
      }, d;
    }), i(n, "Series/Line/LineSeries.js", [n["Core/Series/Series.js"], n["Core/Series/SeriesRegistry.js"], n["Core/Utilities.js"]], function(o, a, r) {
      let { defined: s, merge: l, isObject: d } = r;
      class y extends o {
        drawGraph() {
          let m = this.options, h = (this.gappedPath || this.getGraphPath).call(this), c = this.chart.styledMode;
          [this, ...this.zones].forEach((g, v) => {
            let P, f = g.graph, S = f ? "animate" : "attr", w = g.dashStyle || m.dashStyle;
            f ? (f.endX = this.preventGraphAnimation ? null : h.xMap, f.animate({ d: h })) : h.length && (g.graph = f = this.chart.renderer.path(h).addClass("highcharts-graph" + (v ? ` highcharts-zone-graph-${v - 1} ` : " ") + (v && g.className || "")).attr({ zIndex: 1 }).add(this.group)), f && !c && (P = { stroke: !v && m.lineColor || g.color || this.color || "#cccccc", "stroke-width": m.lineWidth || 0, fill: this.fillGraph && this.color || "none" }, w ? P.dashstyle = w : m.linecap !== "square" && (P["stroke-linecap"] = P["stroke-linejoin"] = "round"), f[S](P).shadow(v < 2 && m.shadow && l({ filterUnits: "userSpaceOnUse" }, d(m.shadow) ? m.shadow : {}))), f && (f.startX = h.xMap, f.isArea = h.isArea);
          });
        }
        getGraphPath(m, h, c) {
          let g = this, v = g.options, P = [], f = [], S, w = v.step, x = (m = m || g.points).reversed;
          return x && m.reverse(), (w = { right: 1, center: 2 }[w] || w && 3) && x && (w = 4 - w), (m = this.getValidPoints(m, !1, !(v.connectNulls && !h && !c))).forEach(function(k, A) {
            let $, j = k.plotX, N = k.plotY, M = m[A - 1], D = k.isNull || typeof N != "number";
            (k.leftCliff || M && M.rightCliff) && !c && (S = !0), D && !s(h) && A > 0 ? S = !v.connectNulls : D && !h ? S = !0 : (A === 0 || S ? $ = [["M", k.plotX, k.plotY]] : g.getPointSpline ? $ = [g.getPointSpline(m, k, A)] : w ? ($ = w === 1 ? [["L", M.plotX, N]] : w === 2 ? [["L", (M.plotX + j) / 2, M.plotY], ["L", (M.plotX + j) / 2, N]] : [["L", j, M.plotY]]).push(["L", j, N]) : $ = [["L", j, N]], f.push(k.x), w && (f.push(k.x), w === 2 && f.push(k.x)), P.push.apply(P, $), S = !1);
          }), P.xMap = f, g.graphPath = P, P;
        }
      }
      return y.defaultOptions = l(o.defaultOptions, { legendSymbol: "lineMarker" }), a.registerSeriesType("line", y), y;
    }), i(n, "Series/Area/AreaSeriesDefaults.js", [], function() {
      return { threshold: 0, legendSymbol: "areaMarker" };
    }), i(n, "Series/Area/AreaSeries.js", [n["Series/Area/AreaSeriesDefaults.js"], n["Core/Series/SeriesRegistry.js"], n["Core/Utilities.js"]], function(o, a, r) {
      let { seriesTypes: { line: s } } = a, { extend: l, merge: d, objectEach: y, pick: u } = r;
      class m extends s {
        drawGraph() {
          this.areaPath = [], super.drawGraph.apply(this);
          let { areaPath: c, options: g } = this;
          [this, ...this.zones].forEach((v, P) => {
            let f = {}, S = v.fillColor || g.fillColor, w = v.area, x = w ? "animate" : "attr";
            w ? (w.endX = this.preventGraphAnimation ? null : c.xMap, w.animate({ d: c })) : (f.zIndex = 0, (w = v.area = this.chart.renderer.path(c).addClass("highcharts-area" + (P ? ` highcharts-zone-area-${P - 1} ` : " ") + (P && v.className || "")).add(this.group)).isArea = !0), this.chart.styledMode || (f.fill = S || v.color || this.color, f["fill-opacity"] = S ? 1 : g.fillOpacity ?? 0.75, w.css({ pointerEvents: this.stickyTracking ? "none" : "auto" })), w[x](f), w.startX = c.xMap, w.shiftUnit = g.step ? 2 : 1;
          });
        }
        getGraphPath(c) {
          let g, v, P, f = s.prototype.getGraphPath, S = this.options, w = S.stacking, x = this.yAxis, k = [], A = [], $ = this.index, j = x.stacking.stacks[this.stackKey], N = S.threshold, M = Math.round(x.getThreshold(S.threshold)), D = u(S.connectNulls, w === "percent"), C = function(O, I, R) {
            let Y = c[O], F = w && j[Y.x].points[$], U = Y[R + "Null"] || 0, Q = Y[R + "Cliff"] || 0, J, ee, V = !0;
            Q || U ? (J = (U ? F[0] : F[1]) + Q, ee = F[0] + Q, V = !!U) : !w && c[I] && c[I].isNull && (J = ee = N), J !== void 0 && (A.push({ plotX: g, plotY: J === null ? M : x.getThreshold(J), isNull: V, isCliff: !0 }), k.push({ plotX: g, plotY: ee === null ? M : x.getThreshold(ee), doCurve: !1 }));
          };
          c = c || this.points, w && (c = this.getStackPoints(c));
          for (let O = 0, I = c.length; O < I; ++O)
            w || (c[O].leftCliff = c[O].rightCliff = c[O].leftNull = c[O].rightNull = void 0), v = c[O].isNull, g = u(c[O].rectPlotX, c[O].plotX), P = w ? u(c[O].yBottom, M) : M, v && !D || (D || C(O, O - 1, "left"), v && !w && D || (A.push(c[O]), k.push({ x: O, plotX: g, plotY: P })), D || C(O, O + 1, "right"));
          let b = f.call(this, A, !0, !0);
          k.reversed = !0;
          let p = f.call(this, k, !0, !0), L = p[0];
          L && L[0] === "M" && (p[0] = ["L", L[1], L[2]]);
          let B = b.concat(p);
          B.length && B.push(["Z"]);
          let T = f.call(this, A, !1, D);
          return this.chart.series.length > 1 && w && A.some((O) => O.isCliff) && (B.hasStackedCliffs = T.hasStackedCliffs = !0), B.xMap = b.xMap, this.areaPath = B, T;
        }
        getStackPoints(c) {
          let g = this, v = [], P = [], f = this.xAxis, S = this.yAxis, w = S.stacking.stacks[this.stackKey], x = {}, k = S.series, A = k.length, $ = S.options.reversedStacks ? 1 : -1, j = k.indexOf(g);
          if (c = c || this.points, this.options.stacking) {
            for (let M = 0; M < c.length; M++)
              c[M].leftNull = c[M].rightNull = void 0, x[c[M].x] = c[M];
            y(w, function(M, D) {
              M.total !== null && P.push(D);
            }), P.sort(function(M, D) {
              return M - D;
            });
            let N = k.map((M) => M.visible);
            P.forEach(function(M, D) {
              let C = 0, b, p;
              if (x[M] && !x[M].isNull)
                v.push(x[M]), [-1, 1].forEach(function(L) {
                  let B = L === 1 ? "rightNull" : "leftNull", T = w[P[D + L]], O = 0;
                  if (T) {
                    let I = j;
                    for (; I >= 0 && I < A; ) {
                      let R = k[I].index;
                      !(b = T.points[R]) && (R === g.index ? x[M][B] = !0 : N[I] && (p = w[M].points[R]) && (O -= p[1] - p[0])), I += $;
                    }
                  }
                  x[M][L === 1 ? "rightCliff" : "leftCliff"] = O;
                });
              else {
                let L = j;
                for (; L >= 0 && L < A; ) {
                  let B = k[L].index;
                  if (b = w[M].points[B]) {
                    C = b[1];
                    break;
                  }
                  L += $;
                }
                C = u(C, 0), C = S.translate(C, 0, 1, 0, 1), v.push({ isNull: !0, plotX: f.translate(M, 0, 0, 0, 1), x: M, plotY: C, yBottom: C });
              }
            });
          }
          return v;
        }
      }
      return m.defaultOptions = d(s.defaultOptions, o), l(m.prototype, { singleStacks: !1 }), a.registerSeriesType("area", m), m;
    }), i(n, "Series/Spline/SplineSeries.js", [n["Core/Series/SeriesRegistry.js"], n["Core/Utilities.js"]], function(o, a) {
      let { line: r } = o.seriesTypes, { merge: s, pick: l } = a;
      class d extends r {
        getPointSpline(u, m, h) {
          let c, g, v, P, f = m.plotX || 0, S = m.plotY || 0, w = u[h - 1], x = u[h + 1];
          function k($) {
            return $ && !$.isNull && $.doCurve !== !1 && !m.isCliff;
          }
          if (k(w) && k(x)) {
            let $ = w.plotX || 0, j = w.plotY || 0, N = x.plotX || 0, M = x.plotY || 0, D = 0;
            c = (1.5 * f + $) / 2.5, g = (1.5 * S + j) / 2.5, v = (1.5 * f + N) / 2.5, P = (1.5 * S + M) / 2.5, v !== c && (D = (P - g) * (v - f) / (v - c) + S - P), g += D, P += D, g > j && g > S ? (g = Math.max(j, S), P = 2 * S - g) : g < j && g < S && (g = Math.min(j, S), P = 2 * S - g), P > M && P > S ? (P = Math.max(M, S), g = 2 * S - P) : P < M && P < S && (P = Math.min(M, S), g = 2 * S - P), m.rightContX = v, m.rightContY = P, m.controlPoints = { low: [c, g], high: [v, P] };
          }
          let A = ["C", l(w.rightContX, w.plotX, 0), l(w.rightContY, w.plotY, 0), l(c, f, 0), l(g, S, 0), f, S];
          return w.rightContX = w.rightContY = void 0, A;
        }
      }
      return d.defaultOptions = s(r.defaultOptions), o.registerSeriesType("spline", d), d;
    }), i(n, "Series/AreaSpline/AreaSplineSeries.js", [n["Series/Spline/SplineSeries.js"], n["Core/Series/SeriesRegistry.js"], n["Core/Utilities.js"]], function(o, a, r) {
      let { area: s, area: { prototype: l } } = a.seriesTypes, { extend: d, merge: y } = r;
      class u extends o {
      }
      return u.defaultOptions = y(o.defaultOptions, s.defaultOptions), d(u.prototype, { getGraphPath: l.getGraphPath, getStackPoints: l.getStackPoints, drawGraph: l.drawGraph }), a.registerSeriesType("areaspline", u), u;
    }), i(n, "Series/Column/ColumnSeriesDefaults.js", [], function() {
      return { borderRadius: 3, centerInCategory: !1, groupPadding: 0.2, marker: null, pointPadding: 0.1, minPointLength: 0, cropThreshold: 50, pointRange: null, states: { hover: { halo: !1, brightness: 0.1 }, select: { color: "#cccccc", borderColor: "#000000" } }, dataLabels: { align: void 0, verticalAlign: void 0, y: void 0 }, startFromThreshold: !0, stickyTracking: !1, tooltip: { distance: 6 }, threshold: 0, borderColor: "#ffffff" };
    }), i(n, "Series/Column/ColumnSeries.js", [n["Core/Animation/AnimationUtilities.js"], n["Core/Color/Color.js"], n["Series/Column/ColumnSeriesDefaults.js"], n["Core/Globals.js"], n["Core/Series/Series.js"], n["Core/Series/SeriesRegistry.js"], n["Core/Utilities.js"]], function(o, a, r, s, l, d, y) {
      let { animObject: u } = o, { parse: m } = a, { noop: h } = s, { clamp: c, crisp: g, defined: v, extend: P, fireEvent: f, isArray: S, isNumber: w, merge: x, pick: k, objectEach: A } = y;
      class $ extends l {
        animate(N) {
          let M, D, C = this, b = this.yAxis, p = b.pos, L = b.reversed, B = C.options, { clipOffset: T, inverted: O } = this.chart, I = {}, R = O ? "translateX" : "translateY";
          N && T ? (I.scaleY = 1e-3, D = c(b.toPixels(B.threshold), p, p + b.len), O ? (D += L ? -Math.floor(T[0]) : Math.ceil(T[2]), I.translateX = D - b.len) : (D += L ? Math.ceil(T[0]) : -Math.floor(T[2]), I.translateY = D), C.clipBox && C.setClip(), C.group.attr(I)) : (M = Number(C.group.attr(R)), C.group.animate({ scaleY: 1 }, P(u(C.options.animation), { step: function(Y, F) {
            C.group && (I[R] = M + F.pos * (p - M), C.group.attr(I));
          } })));
        }
        init(N, M) {
          super.init.apply(this, arguments);
          let D = this;
          (N = D.chart).hasRendered && N.series.forEach(function(C) {
            C.type === D.type && (C.isDirty = !0);
          });
        }
        getColumnMetrics() {
          let N = this, M = N.options, D = N.xAxis, C = N.yAxis, b = D.options.reversedStacks, p = D.reversed && !b || !D.reversed && b, L = {}, B, T = 0;
          M.grouping === !1 ? T = 1 : N.chart.series.forEach(function(U) {
            let Q, J = U.yAxis, ee = U.options;
            U.type === N.type && U.reserveSpace() && C.len === J.len && C.pos === J.pos && (ee.stacking && ee.stacking !== "group" ? (L[B = U.stackKey] === void 0 && (L[B] = T++), Q = L[B]) : ee.grouping !== !1 && (Q = T++), U.columnIndex = Q);
          });
          let O = Math.min(Math.abs(D.transA) * (!D.brokenAxis?.hasBreaks && D.ordinal?.slope || M.pointRange || D.closestPointRange || D.tickInterval || 1), D.len), I = O * M.groupPadding, R = (O - 2 * I) / (T || 1), Y = Math.min(M.maxPointWidth || D.len, k(M.pointWidth, R * (1 - 2 * M.pointPadding))), F = (N.columnIndex || 0) + (p ? 1 : 0);
          return N.columnMetrics = { width: Y, offset: (R - Y) / 2 + (I + F * R - O / 2) * (p ? -1 : 1), paddedWidth: R, columnCount: T }, N.columnMetrics;
        }
        crispCol(N, M, D, C) {
          let b = this.borderWidth, p = this.chart.inverted;
          return C = g(M + C, b, p) - (M = g(M, b, p)), this.options.crisp && (D = g(N + D, b) - (N = g(N, b))), { x: N, y: M, width: D, height: C };
        }
        adjustForMissingColumns(N, M, D, C) {
          if (!D.isNull && C.columnCount > 1) {
            let b = this.xAxis.series.filter((T) => T.visible).map((T) => T.index), p = 0, L = 0;
            A(this.xAxis.stacking?.stacks, (T) => {
              if (typeof D.x == "number") {
                let O = T[D.x.toString()];
                if (O && S(O.points[this.index])) {
                  let I = Object.keys(O.points).filter((R) => !R.match(",") && O.points[R] && O.points[R].length > 1).map(parseFloat).filter((R) => b.indexOf(R) !== -1).sort((R, Y) => Y - R);
                  p = I.indexOf(this.index), L = I.length;
                }
              }
            }), p = this.xAxis.reversed ? L - 1 - p : p;
            let B = (L - 1) * C.paddedWidth + M;
            N = (D.plotX || 0) + B / 2 - M - p * C.paddedWidth;
          }
          return N;
        }
        translate() {
          let N = this, M = N.chart, D = N.options, C = N.dense = N.closestPointRange * N.xAxis.transA < 2, b = N.borderWidth = k(D.borderWidth, C ? 0 : 1), p = N.xAxis, L = N.yAxis, B = D.threshold, T = k(D.minPointLength, 5), O = N.getColumnMetrics(), I = O.width, R = N.pointXOffset = O.offset, Y = N.dataMin, F = N.dataMax, U = N.translatedThreshold = L.getThreshold(B), Q = N.barW = Math.max(I, 1 + 2 * b);
          D.pointPadding && (Q = Math.ceil(Q)), l.prototype.translate.apply(N), N.points.forEach(function(J) {
            let ee = k(J.yBottom, U), V = 999 + Math.abs(ee), G = J.plotX || 0, W = c(J.plotY, -V, L.len + V), ae, z = Math.min(W, ee), q = Math.max(W, ee) - z, Z = I, ne = G + R, ie = Q;
            T && Math.abs(q) < T && (q = T, ae = !L.reversed && !J.negative || L.reversed && J.negative, w(B) && w(F) && J.y === B && F <= B && (L.min || 0) < B && (Y !== F || (L.max || 0) <= B) && (ae = !ae, J.negative = !J.negative), z = Math.abs(z - U) > T ? ee - T : U - (ae ? T : 0)), v(J.options.pointWidth) && (ne -= Math.round(((Z = ie = Math.ceil(J.options.pointWidth)) - I) / 2)), D.centerInCategory && !D.stacking && (ne = N.adjustForMissingColumns(ne, Z, J, O)), J.barX = ne, J.pointWidth = Z, J.tooltipPos = M.inverted ? [c(L.len + L.pos - M.plotLeft - W, L.pos - M.plotLeft, L.len + L.pos - M.plotLeft), p.len + p.pos - M.plotTop - ne - ie / 2, q] : [p.left - M.plotLeft + ne + ie / 2, c(W + L.pos - M.plotTop, L.pos - M.plotTop, L.len + L.pos - M.plotTop), q], J.shapeType = N.pointClass.prototype.shapeType || "roundedRect", J.shapeArgs = N.crispCol(ne, J.isNull ? U : z, ie, J.isNull ? 0 : q);
          }), f(this, "afterColumnTranslate");
        }
        drawGraph() {
          this.group[this.dense ? "addClass" : "removeClass"]("highcharts-dense-data");
        }
        pointAttribs(N, M) {
          let D = this.options, C = this.pointAttrToOptions || {}, b = C.stroke || "borderColor", p = C["stroke-width"] || "borderWidth", L, B, T, O = N && N.color || this.color, I = N && N[b] || D[b] || O, R = N && N.options.dashStyle || D.dashStyle, Y = N && N[p] || D[p] || this[p] || 0, F = k(N && N.opacity, D.opacity, 1);
          N && this.zones.length && (B = N.getZone(), O = N.options.color || B && (B.color || N.nonZonedColor) || this.color, B && (I = B.borderColor || I, R = B.dashStyle || R, Y = B.borderWidth || Y)), M && N && (T = (L = x(D.states[M], N.options.states && N.options.states[M] || {})).brightness, O = L.color || T !== void 0 && m(O).brighten(L.brightness).get() || O, I = L[b] || I, Y = L[p] || Y, R = L.dashStyle || R, F = k(L.opacity, F));
          let U = { fill: O, stroke: I, "stroke-width": Y, opacity: F };
          return R && (U.dashstyle = R), U;
        }
        drawPoints(N = this.points) {
          let M, D = this, C = this.chart, b = D.options, p = C.renderer, L = b.animationLimit || 250;
          N.forEach(function(B) {
            let T = B.plotY, O = B.graphic, I = !!O, R = O && C.pointCount < L ? "animate" : "attr";
            w(T) && B.y !== null ? (M = B.shapeArgs, O && B.hasNewShapeType() && (O = O.destroy()), D.enabledDataSorting && (B.startXPos = D.xAxis.reversed ? -(M && M.width || 0) : D.xAxis.width), !O && (B.graphic = O = p[B.shapeType](M).add(B.group || D.group), O && D.enabledDataSorting && C.hasRendered && C.pointCount < L && (O.attr({ x: B.startXPos }), I = !0, R = "animate")), O && I && O[R](x(M)), C.styledMode || O[R](D.pointAttribs(B, B.selected && "select")).shadow(B.allowShadow !== !1 && b.shadow), O && (O.addClass(B.getClassName(), !0), O.attr({ visibility: B.visible ? "inherit" : "hidden" }))) : O && (B.graphic = O.destroy());
          });
        }
        drawTracker(N = this.points) {
          let M, D = this, C = D.chart, b = C.pointer, p = function(L) {
            let B = b?.getPointFromEvent(L);
            b && B && D.options.enableMouseTracking && (b.isDirectTouch = !0, B.onMouseOver(L));
          };
          N.forEach(function(L) {
            M = S(L.dataLabels) ? L.dataLabels : L.dataLabel ? [L.dataLabel] : [], L.graphic && (L.graphic.element.point = L), M.forEach(function(B) {
              (B.div || B.element).point = L;
            });
          }), D._hasTracking || (D.trackerGroups.forEach(function(L) {
            D[L] && (D[L].addClass("highcharts-tracker").on("mouseover", p).on("mouseout", function(B) {
              b?.onTrackerMouseOut(B);
            }).on("touchstart", p), !C.styledMode && D.options.cursor && D[L].css({ cursor: D.options.cursor }));
          }), D._hasTracking = !0), f(this, "afterDrawTracker");
        }
        remove() {
          let N = this, M = N.chart;
          M.hasRendered && M.series.forEach(function(D) {
            D.type === N.type && (D.isDirty = !0);
          }), l.prototype.remove.apply(N, arguments);
        }
      }
      return $.defaultOptions = x(l.defaultOptions, r), P($.prototype, { directTouch: !0, getSymbol: h, negStacks: !0, trackerGroups: ["group", "dataLabelsGroup"] }), d.registerSeriesType("column", $), $;
    }), i(n, "Core/Series/DataLabel.js", [n["Core/Animation/AnimationUtilities.js"], n["Core/Templating.js"], n["Core/Utilities.js"]], function(o, a, r) {
      var s;
      let { getDeferredAnimation: l } = o, { format: d } = a, { defined: y, extend: u, fireEvent: m, isArray: h, isString: c, merge: g, objectEach: v, pick: P, pInt: f, splat: S } = r;
      return function(w) {
        function x() {
          return D(this).some((b) => b?.enabled);
        }
        function k(b, p, L, B, T) {
          let { chart: O, enabledDataSorting: I } = this, R = this.isCartesian && O.inverted, Y = b.plotX, F = b.plotY, U = L.rotation || 0, Q = y(Y) && y(F) && O.isInsidePlot(Y, Math.round(F), { inverted: R, paneCoordinates: !0, series: this }), J = U === 0 && P(L.overflow, I ? "none" : "justify") === "justify", ee = this.visible && b.visible !== !1 && y(Y) && (b.series.forceDL || I && !J || Q || P(L.inside, !!this.options.stacking) && B && O.isInsidePlot(Y, R ? B.x + 1 : B.y + B.height - 1, { inverted: R, paneCoordinates: !0, series: this })), V = b.pos();
          if (ee && V) {
            var G;
            let W = p.getBBox(), ae = p.getBBox(void 0, 0), z = { right: 1, center: 0.5 }[L.align || 0] || 0, q = { bottom: 1, middle: 0.5 }[L.verticalAlign || 0] || 0;
            if (B = u({ x: V[0], y: Math.round(V[1]), width: 0, height: 0 }, B || {}), L.alignTo === "plotEdges" && this.isCartesian && (B[R ? "x" : "y"] = 0, B[R ? "width" : "height"] = this.yAxis?.len || 0), u(L, { width: W.width, height: W.height }), G = B, I && this.xAxis && !J && this.setDataLabelStartPos(b, p, T, Q, G), p.align(g(L, { width: ae.width, height: ae.height }), !1, B, !1), p.alignAttr.x += z * (ae.width - W.width), p.alignAttr.y += q * (ae.height - W.height), p[p.placed ? "animate" : "attr"]({ x: p.alignAttr.x + (W.width - ae.width) / 2, y: p.alignAttr.y + (W.height - ae.height) / 2, rotationOriginX: (p.width || 0) / 2, rotationOriginY: (p.height || 0) / 2 }), J && B.height >= 0)
              this.justifyDataLabel(p, L, p.alignAttr, W, B, T);
            else if (P(L.crop, !0)) {
              let { x: Z, y: ne } = p.alignAttr;
              ee = O.isInsidePlot(Z, ne, { paneCoordinates: !0, series: this }) && O.isInsidePlot(Z + W.width - 1, ne + W.height - 1, { paneCoordinates: !0, series: this });
            }
            L.shape && !U && p[T ? "attr" : "animate"]({ anchorX: V[0], anchorY: V[1] });
          }
          T && I && (p.placed = !1), ee || I && !J ? (p.show(), p.placed = !0) : (p.hide(), p.placed = !1);
        }
        function A() {
          return this.plotGroup("dataLabelsGroup", "data-labels", this.hasRendered ? "inherit" : "hidden", this.options.dataLabels.zIndex || 6);
        }
        function $(b) {
          let p = this.hasRendered || 0, L = this.initDataLabelsGroup().attr({ opacity: +p });
          return !p && L && (this.visible && L.show(), this.options.animation ? L.animate({ opacity: 1 }, b) : L.attr({ opacity: 1 })), L;
        }
        function j(b) {
          let p;
          b = b || this.points;
          let L = this, B = L.chart, T = L.options, O = B.renderer, { backgroundColor: I, plotBackgroundColor: R } = B.options.chart, Y = O.getContrast(c(R) && R || c(I) && I || "#000000"), F = D(L), { animation: U, defer: Q } = F[0], J = Q ? l(B, U, L) : { defer: 0, duration: 0 };
          m(this, "drawDataLabels"), L.hasDataLabels?.() && (p = this.initDataLabels(J), b.forEach((ee) => {
            let V = ee.dataLabels || [];
            S(M(F, ee.dlOptions || ee.options?.dataLabels)).forEach((W, ae) => {
              let z = W.enabled && (ee.visible || ee.dataLabelOnHidden) && (!ee.isNull || ee.dataLabelOnNull) && function(he, ve) {
                let ye = ve.filter;
                if (ye) {
                  let be = ye.operator, ke = he[ye.property], we = ye.value;
                  return be === ">" && ke > we || be === "<" && ke < we || be === ">=" && ke >= we || be === "<=" && ke <= we || be === "==" && ke == we || be === "===" && ke === we || be === "!=" && ke != we || be === "!==" && ke !== we;
                }
                return !0;
              }(ee, W), { backgroundColor: q, borderColor: Z, distance: ne, style: ie = {} } = W, re, de, me, ce, pe = {}, xe = V[ae], le = !xe, se;
              z && (de = P(W[ee.formatPrefix + "Format"], W.format), re = ee.getLabelConfig(), me = y(de) ? d(de, re, B) : (W[ee.formatPrefix + "Formatter"] || W.formatter).call(re, W), ce = W.rotation, !B.styledMode && (ie.color = P(W.color, ie.color, c(L.color) ? L.color : void 0, "#000000"), ie.color === "contrast" ? (q !== "none" && (se = q), ee.contrastColor = O.getContrast(se !== "auto" && se || ee.color || L.color), ie.color = se || !y(ne) && W.inside || 0 > f(ne || 0) || T.stacking ? ee.contrastColor : Y) : delete ee.contrastColor, T.cursor && (ie.cursor = T.cursor)), pe = { r: W.borderRadius || 0, rotation: ce, padding: W.padding, zIndex: 1 }, B.styledMode || (pe.fill = q === "auto" ? ee.color : q, pe.stroke = Z === "auto" ? ee.color : Z, pe["stroke-width"] = W.borderWidth), v(pe, (he, ve) => {
                he === void 0 && delete pe[ve];
              })), !xe || z && y(me) && !!xe.div == !!W.useHTML && (xe.rotation && W.rotation || xe.rotation === W.rotation) || (xe = void 0, le = !0), z && y(me) && (xe ? pe.text = me : (xe = O.label(me, 0, 0, W.shape, void 0, void 0, W.useHTML, void 0, "data-label")).addClass(" highcharts-data-label-color-" + ee.colorIndex + " " + (W.className || "") + (W.useHTML ? " highcharts-tracker" : "")), xe && (xe.options = W, xe.attr(pe), B.styledMode ? ie.width && xe.css({ width: ie.width, textOverflow: ie.textOverflow }) : xe.css(ie).shadow(W.shadow), m(xe, "beforeAddingDataLabel", { labelOptions: W, point: ee }), xe.added || xe.add(p), L.alignDataLabel(ee, xe, W, void 0, le), xe.isActive = !0, V[ae] && V[ae] !== xe && V[ae].destroy(), V[ae] = xe));
            });
            let G = V.length;
            for (; G--; )
              V[G] && V[G].isActive ? V[G].isActive = !1 : (V[G]?.destroy(), V.splice(G, 1));
            ee.dataLabel = V[0], ee.dataLabels = V;
          })), m(this, "afterDrawDataLabels");
        }
        function N(b, p, L, B, T, O) {
          let I = this.chart, R = p.align, Y = p.verticalAlign, F = b.box ? 0 : b.padding || 0, U = I.inverted ? this.yAxis : this.xAxis, Q = U ? U.left - I.plotLeft : 0, J = I.inverted ? this.xAxis : this.yAxis, ee = J ? J.top - I.plotTop : 0, { x: V = 0, y: G = 0 } = p, W, ae;
          return (W = (L.x || 0) + F + Q) < 0 && (R === "right" && V >= 0 ? (p.align = "left", p.inside = !0) : V -= W, ae = !0), (W = (L.x || 0) + B.width - F + Q) > I.plotWidth && (R === "left" && V <= 0 ? (p.align = "right", p.inside = !0) : V += I.plotWidth - W, ae = !0), (W = L.y + F + ee) < 0 && (Y === "bottom" && G >= 0 ? (p.verticalAlign = "top", p.inside = !0) : G -= W, ae = !0), (W = (L.y || 0) + B.height - F + ee) > I.plotHeight && (Y === "top" && G <= 0 ? (p.verticalAlign = "bottom", p.inside = !0) : G += I.plotHeight - W, ae = !0), ae && (p.x = V, p.y = G, b.placed = !O, b.align(p, void 0, T)), ae;
        }
        function M(b, p) {
          let L = [], B;
          if (h(b) && !h(p))
            L = b.map(function(T) {
              return g(T, p);
            });
          else if (h(p) && !h(b))
            L = p.map(function(T) {
              return g(b, T);
            });
          else if (h(b) || h(p)) {
            if (h(b) && h(p))
              for (B = Math.max(b.length, p.length); B--; )
                L[B] = g(b[B], p[B]);
          } else
            L = g(b, p);
          return L;
        }
        function D(b) {
          let p = b.chart.options.plotOptions;
          return S(M(M(p?.series?.dataLabels, p?.[b.type]?.dataLabels), b.options.dataLabels));
        }
        function C(b, p, L, B, T) {
          let O = this.chart, I = O.inverted, R = this.xAxis, Y = R.reversed, F = ((I ? p.height : p.width) || 0) / 2, U = b.pointWidth, Q = U ? U / 2 : 0;
          p.startXPos = I ? T.x : Y ? -F - Q : R.width - F + Q, p.startYPos = I ? Y ? this.yAxis.height - F + Q : -F - Q : T.y, B ? p.visibility === "hidden" && (p.show(), p.attr({ opacity: 0 }).animate({ opacity: 1 })) : p.attr({ opacity: 1 }).animate({ opacity: 0 }, void 0, p.hide), O.hasRendered && (L && p.attr({ x: p.startXPos, y: p.startYPos }), p.placed = !0);
        }
        w.compose = function(b) {
          let p = b.prototype;
          p.initDataLabels || (p.initDataLabels = $, p.initDataLabelsGroup = A, p.alignDataLabel = k, p.drawDataLabels = j, p.justifyDataLabel = N, p.setDataLabelStartPos = C, p.hasDataLabels = x);
        };
      }(s || (s = {})), s;
    }), i(n, "Series/Column/ColumnDataLabel.js", [n["Core/Series/DataLabel.js"], n["Core/Globals.js"], n["Core/Series/SeriesRegistry.js"], n["Core/Utilities.js"]], function(o, a, r, s) {
      var l;
      let { composed: d } = a, { series: y } = r, { merge: u, pick: m, pushUnique: h } = s;
      return function(c) {
        function g(v, P, f, S, w) {
          let x = this.chart.inverted, k = v.series, A = (k.xAxis ? k.xAxis.len : this.chart.plotSizeX) || 0, $ = (k.yAxis ? k.yAxis.len : this.chart.plotSizeY) || 0, j = v.dlBox || v.shapeArgs, N = m(v.below, v.plotY > m(this.translatedThreshold, $)), M = m(f.inside, !!this.options.stacking);
          if (j) {
            if (S = u(j), !(f.overflow === "allow" && f.crop === !1)) {
              S.y < 0 && (S.height += S.y, S.y = 0);
              let D = S.y + S.height - $;
              D > 0 && D < S.height - 1 && (S.height -= D);
            }
            x && (S = { x: $ - S.y - S.height, y: A - S.x - S.width, width: S.height, height: S.width }), M || (x ? (S.x += N ? 0 : S.width, S.width = 0) : (S.y += N ? S.height : 0, S.height = 0));
          }
          f.align = m(f.align, !x || M ? "center" : N ? "right" : "left"), f.verticalAlign = m(f.verticalAlign, x || M ? "middle" : N ? "top" : "bottom"), y.prototype.alignDataLabel.call(this, v, P, f, S, w), f.inside && v.contrastColor && P.css({ color: v.contrastColor });
        }
        c.compose = function(v) {
          o.compose(y), h(d, "ColumnDataLabel") && (v.prototype.alignDataLabel = g);
        };
      }(l || (l = {})), l;
    }), i(n, "Series/Bar/BarSeries.js", [n["Series/Column/ColumnSeries.js"], n["Core/Series/SeriesRegistry.js"], n["Core/Utilities.js"]], function(o, a, r) {
      let { extend: s, merge: l } = r;
      class d extends o {
      }
      return d.defaultOptions = l(o.defaultOptions, {}), s(d.prototype, { inverted: !0 }), a.registerSeriesType("bar", d), d;
    }), i(n, "Series/Scatter/ScatterSeriesDefaults.js", [], function() {
      return { lineWidth: 0, findNearestPointBy: "xy", jitter: { x: 0, y: 0 }, marker: { enabled: !0 }, tooltip: { headerFormat: '<span style="color:{point.color}">●</span> <span style="font-size: 0.8em"> {series.name}</span><br/>', pointFormat: "x: <b>{point.x}</b><br/>y: <b>{point.y}</b><br/>" } };
    }), i(n, "Series/Scatter/ScatterSeries.js", [n["Series/Scatter/ScatterSeriesDefaults.js"], n["Core/Series/SeriesRegistry.js"], n["Core/Utilities.js"]], function(o, a, r) {
      let { column: s, line: l } = a.seriesTypes, { addEvent: d, extend: y, merge: u } = r;
      class m extends l {
        applyJitter() {
          let c = this, g = this.options.jitter, v = this.points.length;
          g && this.points.forEach(function(P, f) {
            ["x", "y"].forEach(function(S, w) {
              if (g[S] && !P.isNull) {
                let x = `plot${S.toUpperCase()}`, k = c[`${S}Axis`], A = g[S] * k.transA;
                if (k && !k.logarithmic) {
                  let $ = Math.max(0, (P[x] || 0) - A), j = Math.min(k.len, (P[x] || 0) + A);
                  P[x] = $ + (j - $) * function(N) {
                    let M = 1e4 * Math.sin(N);
                    return M - Math.floor(M);
                  }(f + w * v), S === "x" && (P.clientX = P.plotX);
                }
              }
            });
          });
        }
        drawGraph() {
          this.options.lineWidth ? super.drawGraph() : this.graph && (this.graph = this.graph.destroy());
        }
      }
      return m.defaultOptions = u(l.defaultOptions, o), y(m.prototype, { drawTracker: s.prototype.drawTracker, sorted: !1, requireSorting: !1, noSharedTooltip: !0, trackerGroups: ["group", "markerGroup", "dataLabelsGroup"] }), d(m, "afterTranslate", function() {
        this.applyJitter();
      }), a.registerSeriesType("scatter", m), m;
    }), i(n, "Series/CenteredUtilities.js", [n["Core/Globals.js"], n["Core/Series/Series.js"], n["Core/Utilities.js"]], function(o, a, r) {
      var s, l;
      let { deg2rad: d } = o, { fireEvent: y, isNumber: u, pick: m, relativeLength: h } = r;
      return (l = s || (s = {})).getCenter = function() {
        let c = this.options, g = this.chart, v = 2 * (c.slicedOffset || 0), P = g.plotWidth - 2 * v, f = g.plotHeight - 2 * v, S = c.center, w = Math.min(P, f), x = c.thickness, k, A = c.size, $ = c.innerSize || 0, j, N;
        typeof A == "string" && (A = parseFloat(A)), typeof $ == "string" && ($ = parseFloat($));
        let M = [m(S[0], "50%"), m(S[1], "50%"), m(A && A < 0 ? void 0 : c.size, "100%"), m($ && $ < 0 ? void 0 : c.innerSize || 0, "0%")];
        for (!g.angular || this instanceof a || (M[3] = 0), j = 0; j < 4; ++j)
          N = M[j], k = j < 2 || j === 2 && /%$/.test(N), M[j] = h(N, [P, f, w, M[2]][j]) + (k ? v : 0);
        return M[3] > M[2] && (M[3] = M[2]), u(x) && 2 * x < M[2] && x > 0 && (M[3] = M[2] - 2 * x), y(this, "afterGetCenter", { positions: M }), M;
      }, l.getStartAndEndRadians = function(c, g) {
        let v = u(c) ? c : 0, P = u(g) && g > v && g - v < 360 ? g : v + 360;
        return { start: d * (v + -90), end: d * (P + -90) };
      }, s;
    }), i(n, "Series/Pie/PiePoint.js", [n["Core/Animation/AnimationUtilities.js"], n["Core/Series/Point.js"], n["Core/Utilities.js"]], function(o, a, r) {
      let { setAnimation: s } = o, { addEvent: l, defined: d, extend: y, isNumber: u, pick: m, relativeLength: h } = r;
      class c extends a {
        getConnectorPath(v) {
          let P = v.dataLabelPosition, f = v.options || {}, S = f.connectorShape, w = this.connectorShapes[S] || S;
          return P && w.call(this, { ...P.computed, alignment: P.alignment }, P.connectorPosition, f) || [];
        }
        getTranslate() {
          return this.sliced && this.slicedTranslation || { translateX: 0, translateY: 0 };
        }
        haloPath(v) {
          let P = this.shapeArgs;
          return this.sliced || !this.visible ? [] : this.series.chart.renderer.symbols.arc(P.x, P.y, P.r + v, P.r + v, { innerR: P.r - 1, start: P.start, end: P.end, borderRadius: P.borderRadius });
        }
        constructor(v, P, f) {
          super(v, P, f), this.half = 0, this.name ?? (this.name = "Slice");
          let S = (w) => {
            this.slice(w.type === "select");
          };
          l(this, "select", S), l(this, "unselect", S);
        }
        isValid() {
          return u(this.y) && this.y >= 0;
        }
        setVisible(v, P = !0) {
          v !== this.visible && this.update({ visible: v ?? !this.visible }, P, void 0, !1);
        }
        slice(v, P, f) {
          let S = this.series;
          s(f, S.chart), P = m(P, !0), this.sliced = this.options.sliced = v = d(v) ? v : !this.sliced, S.options.data[S.data.indexOf(this)] = this.options, this.graphic && this.graphic.animate(this.getTranslate());
        }
      }
      return y(c.prototype, { connectorShapes: { fixedOffset: function(g, v, P) {
        let f = v.breakAt, S = v.touchingSliceAt, w = P.softConnector ? ["C", g.x + (g.alignment === "left" ? -5 : 5), g.y, 2 * f.x - S.x, 2 * f.y - S.y, f.x, f.y] : ["L", f.x, f.y];
        return [["M", g.x, g.y], w, ["L", S.x, S.y]];
      }, straight: function(g, v) {
        let P = v.touchingSliceAt;
        return [["M", g.x, g.y], ["L", P.x, P.y]];
      }, crookedLine: function(g, v, P) {
        let { breakAt: f, touchingSliceAt: S } = v, { series: w } = this, [x, k, A] = w.center, $ = A / 2, { plotLeft: j, plotWidth: N } = w.chart, M = g.alignment === "left", { x: D, y: C } = g, b = f.x;
        if (P.crookDistance) {
          let L = h(P.crookDistance, 1);
          b = M ? x + $ + (N + j - x - $) * (1 - L) : j + (x - $) * L;
        } else
          b = x + (k - C) * Math.tan((this.angle || 0) - Math.PI / 2);
        let p = [["M", D, C]];
        return (M ? b <= D && b >= f.x : b >= D && b <= f.x) && p.push(["L", b, C]), p.push(["L", f.x, f.y], ["L", S.x, S.y]), p;
      } } }), c;
    }), i(n, "Series/Pie/PieSeriesDefaults.js", [], function() {
      return { borderRadius: 3, center: [null, null], clip: !1, colorByPoint: !0, dataLabels: { connectorPadding: 5, connectorShape: "crookedLine", crookDistance: void 0, distance: 30, enabled: !0, formatter: function() {
        return this.point.isNull ? void 0 : this.point.name;
      }, softConnector: !0, x: 0 }, fillColor: void 0, ignoreHiddenPoint: !0, inactiveOtherPoints: !0, legendType: "point", marker: null, size: null, showInLegend: !1, slicedOffset: 10, stickyTracking: !1, tooltip: { followPointer: !0 }, borderColor: "#ffffff", borderWidth: 1, lineWidth: void 0, states: { hover: { brightness: 0.1 } } };
    }), i(n, "Series/Pie/PieSeries.js", [n["Series/CenteredUtilities.js"], n["Series/Column/ColumnSeries.js"], n["Core/Globals.js"], n["Series/Pie/PiePoint.js"], n["Series/Pie/PieSeriesDefaults.js"], n["Core/Series/Series.js"], n["Core/Series/SeriesRegistry.js"], n["Core/Renderer/SVG/Symbols.js"], n["Core/Utilities.js"]], function(o, a, r, s, l, d, y, u, m) {
      let { getStartAndEndRadians: h } = o, { noop: c } = r, { clamp: g, extend: v, fireEvent: P, merge: f, pick: S } = m;
      class w extends d {
        animate(k) {
          let A = this, $ = A.points, j = A.startAngleRad;
          k || $.forEach(function(N) {
            let M = N.graphic, D = N.shapeArgs;
            M && D && (M.attr({ r: S(N.startR, A.center && A.center[3] / 2), start: j, end: j }), M.animate({ r: D.r, start: D.start, end: D.end }, A.options.animation));
          });
        }
        drawEmpty() {
          let k, A, $ = this.startAngleRad, j = this.endAngleRad, N = this.options;
          this.total === 0 && this.center ? (k = this.center[0], A = this.center[1], this.graph || (this.graph = this.chart.renderer.arc(k, A, this.center[1] / 2, 0, $, j).addClass("highcharts-empty-series").add(this.group)), this.graph.attr({ d: u.arc(k, A, this.center[2] / 2, 0, { start: $, end: j, innerR: this.center[3] / 2 }) }), this.chart.styledMode || this.graph.attr({ "stroke-width": N.borderWidth, fill: N.fillColor || "none", stroke: N.color || "#cccccc" })) : this.graph && (this.graph = this.graph.destroy());
        }
        drawPoints() {
          let k = this.chart.renderer;
          this.points.forEach(function(A) {
            A.graphic && A.hasNewShapeType() && (A.graphic = A.graphic.destroy()), A.graphic || (A.graphic = k[A.shapeType](A.shapeArgs).add(A.series.group), A.delayedRendering = !0);
          });
        }
        generatePoints() {
          super.generatePoints(), this.updateTotals();
        }
        getX(k, A, $, j) {
          let N = this.center, M = this.radii ? this.radii[$.index] || 0 : N[2] / 2, D = j.dataLabelPosition, C = D?.distance || 0, b = Math.asin(g((k - N[1]) / (M + C), -1, 1));
          return N[0] + Math.cos(b) * (M + C) * (A ? -1 : 1) + (C > 0 ? (A ? -1 : 1) * (j.padding || 0) : 0);
        }
        hasData() {
          return !!this.processedXData.length;
        }
        redrawPoints() {
          let k, A, $, j, N = this, M = N.chart;
          this.drawEmpty(), N.group && !M.styledMode && N.group.shadow(N.options.shadow), N.points.forEach(function(D) {
            let C = {};
            A = D.graphic, !D.isNull && A ? (j = D.shapeArgs, k = D.getTranslate(), M.styledMode || ($ = N.pointAttribs(D, D.selected && "select")), D.delayedRendering ? (A.setRadialReference(N.center).attr(j).attr(k), M.styledMode || A.attr($).attr({ "stroke-linejoin": "round" }), D.delayedRendering = !1) : (A.setRadialReference(N.center), M.styledMode || f(!0, C, $), f(!0, C, j, k), A.animate(C)), A.attr({ visibility: D.visible ? "inherit" : "hidden" }), A.addClass(D.getClassName(), !0)) : A && (D.graphic = A.destroy());
          });
        }
        sortByAngle(k, A) {
          k.sort(function($, j) {
            return $.angle !== void 0 && (j.angle - $.angle) * A;
          });
        }
        translate(k) {
          P(this, "translate"), this.generatePoints();
          let A = this.options, $ = A.slicedOffset, j = h(A.startAngle, A.endAngle), N = this.startAngleRad = j.start, M = (this.endAngleRad = j.end) - N, D = this.points, C = A.ignoreHiddenPoint, b = D.length, p, L, B, T, O, I, R, Y = 0;
          for (k || (this.center = k = this.getCenter()), I = 0; I < b; I++) {
            R = D[I], p = N + Y * M, R.isValid() && (!C || R.visible) && (Y += R.percentage / 100), L = N + Y * M;
            let F = { x: k[0], y: k[1], r: k[2] / 2, innerR: k[3] / 2, start: Math.round(1e3 * p) / 1e3, end: Math.round(1e3 * L) / 1e3 };
            R.shapeType = "arc", R.shapeArgs = F, (B = (L + p) / 2) > 1.5 * Math.PI ? B -= 2 * Math.PI : B < -Math.PI / 2 && (B += 2 * Math.PI), R.slicedTranslation = { translateX: Math.round(Math.cos(B) * $), translateY: Math.round(Math.sin(B) * $) }, T = Math.cos(B) * k[2] / 2, O = Math.sin(B) * k[2] / 2, R.tooltipPos = [k[0] + 0.7 * T, k[1] + 0.7 * O], R.half = B < -Math.PI / 2 || B > Math.PI / 2 ? 1 : 0, R.angle = B;
          }
          P(this, "afterTranslate");
        }
        updateTotals() {
          let k = this.points, A = k.length, $ = this.options.ignoreHiddenPoint, j, N, M = 0;
          for (j = 0; j < A; j++)
            (N = k[j]).isValid() && (!$ || N.visible) && (M += N.y);
          for (j = 0, this.total = M; j < A; j++)
            (N = k[j]).percentage = M > 0 && (N.visible || !$) ? N.y / M * 100 : 0, N.total = M;
        }
      }
      return w.defaultOptions = f(d.defaultOptions, l), v(w.prototype, { axisTypes: [], directTouch: !0, drawGraph: void 0, drawTracker: a.prototype.drawTracker, getCenter: o.getCenter, getSymbol: c, invertible: !1, isCartesian: !1, noSharedTooltip: !0, pointAttribs: a.prototype.pointAttribs, pointClass: s, requireSorting: !1, searchPoint: c, trackerGroups: ["group", "dataLabelsGroup"] }), y.registerSeriesType("pie", w), w;
    }), i(n, "Series/Pie/PieDataLabel.js", [n["Core/Series/DataLabel.js"], n["Core/Globals.js"], n["Core/Renderer/RendererUtilities.js"], n["Core/Series/SeriesRegistry.js"], n["Core/Utilities.js"]], function(o, a, r, s, l) {
      var d;
      let { composed: y, noop: u } = a, { distribute: m } = r, { series: h } = s, { arrayMax: c, clamp: g, defined: v, pick: P, pushUnique: f, relativeLength: S } = l;
      return function(w) {
        let x = { radialDistributionY: function(N, M) {
          return (M.dataLabelPosition?.top || 0) + N.distributeBox.pos;
        }, radialDistributionX: function(N, M, D, C, b) {
          let p = b.dataLabelPosition;
          return N.getX(D < (p?.top || 0) + 2 || D > (p?.bottom || 0) - 2 ? C : D, M.half, M, b);
        }, justify: function(N, M, D, C) {
          return C[0] + (N.half ? -1 : 1) * (D + (M.dataLabelPosition?.distance || 0));
        }, alignToPlotEdges: function(N, M, D, C) {
          let b = N.getBBox().width;
          return M ? b + C : D - b - C;
        }, alignToConnectors: function(N, M, D, C) {
          let b = 0, p;
          return N.forEach(function(L) {
            (p = L.dataLabel.getBBox().width) > b && (b = p);
          }), M ? b + C : D - b - C;
        } };
        function k(N, M) {
          let { center: D, options: C } = this, b = D[2] / 2, p = N.angle || 0, L = Math.cos(p), B = Math.sin(p), T = D[0] + L * b, O = D[1] + B * b, I = Math.min((C.slicedOffset || 0) + (C.borderWidth || 0), M / 5);
          return { natural: { x: T + L * M, y: O + B * M }, computed: {}, alignment: M < 0 ? "center" : N.half ? "right" : "left", connectorPosition: { breakAt: { x: T + L * I, y: O + B * I }, touchingSliceAt: { x: T, y: O } }, distance: M };
        }
        function A() {
          let N = this, M = N.points, D = N.chart, C = D.plotWidth, b = D.plotHeight, p = D.plotLeft, L = Math.round(D.chartWidth / 3), B = N.center, T = B[2] / 2, O = B[1], I = [[], []], R = [0, 0, 0, 0], Y = N.dataLabelPositioners, F, U, Q, J = 0;
          N.visible && N.hasDataLabels?.() && (M.forEach((ee) => {
            (ee.dataLabels || []).forEach((V) => {
              V.shortened && (V.attr({ width: "auto" }).css({ width: "auto", textOverflow: "clip" }), V.shortened = !1);
            });
          }), h.prototype.drawDataLabels.apply(N), M.forEach((ee) => {
            (ee.dataLabels || []).forEach((V, G) => {
              let W = B[2] / 2, ae = V.options, z = S(ae?.distance || 0, W);
              G === 0 && I[ee.half].push(ee), !v(ae?.style?.width) && V.getBBox().width > L && (V.css({ width: Math.round(0.7 * L) + "px" }), V.shortened = !0), V.dataLabelPosition = this.getDataLabelPosition(ee, z), J = Math.max(J, z);
            });
          }), I.forEach((ee, V) => {
            let G = ee.length, W = [], ae, z, q = 0, Z;
            G && (N.sortByAngle(ee, V - 0.5), J > 0 && (ae = Math.max(0, O - T - J), z = Math.min(O + T + J, D.plotHeight), ee.forEach((ne) => {
              (ne.dataLabels || []).forEach((ie) => {
                let re = ie.dataLabelPosition;
                re && re.distance > 0 && (re.top = Math.max(0, O - T - re.distance), re.bottom = Math.min(O + T + re.distance, D.plotHeight), q = ie.getBBox().height || 21, ie.lineHeight = D.renderer.fontMetrics(ie.text || ie).h + 2 * ie.padding, ne.distributeBox = { target: (ie.dataLabelPosition?.natural.y || 0) - re.top + ie.lineHeight / 2, size: q, rank: ne.y }, W.push(ne.distributeBox));
              });
            }), m(W, Z = z + q - ae, Z / 5)), ee.forEach((ne) => {
              (ne.dataLabels || []).forEach((ie) => {
                let re = ie.options || {}, de = ne.distributeBox, me = ie.dataLabelPosition, ce = me?.natural.y || 0, pe = re.connectorPadding || 0, xe = ie.lineHeight || 21, le = (xe - ie.getBBox().height) / 2, se = 0, he = ce, ve = "inherit";
                if (me) {
                  if (W && v(de) && me.distance > 0 && (de.pos === void 0 ? ve = "hidden" : (Q = de.size, he = Y.radialDistributionY(ne, ie))), re.justify)
                    se = Y.justify(ne, ie, T, B);
                  else
                    switch (re.alignTo) {
                      case "connectors":
                        se = Y.alignToConnectors(ee, V, C, p);
                        break;
                      case "plotEdges":
                        se = Y.alignToPlotEdges(ie, V, C, p);
                        break;
                      default:
                        se = Y.radialDistributionX(N, ne, he - le, ce, ie);
                    }
                  if (me.attribs = { visibility: ve, align: me.alignment }, me.posAttribs = { x: se + (re.x || 0) + ({ left: pe, right: -pe }[me.alignment] || 0), y: he + (re.y || 0) - xe / 2 }, me.computed.x = se, me.computed.y = he - le, P(re.crop, !0)) {
                    let ye;
                    se - (U = ie.getBBox().width) < pe && V === 1 ? (ye = Math.round(U - se + pe), R[3] = Math.max(ye, R[3])) : se + U > C - pe && V === 0 && (ye = Math.round(se + U - C + pe), R[1] = Math.max(ye, R[1])), he - Q / 2 < 0 ? R[0] = Math.max(Math.round(-he + Q / 2), R[0]) : he + Q / 2 > b && (R[2] = Math.max(Math.round(he + Q / 2 - b), R[2])), me.sideOverflow = ye;
                  }
                }
              });
            }));
          }), (c(R) === 0 || this.verifyDataLabelOverflow(R)) && (this.placeDataLabels(), this.points.forEach((ee) => {
            (ee.dataLabels || []).forEach((V) => {
              let { connectorColor: G, connectorWidth: W = 1 } = V.options || {}, ae = V.dataLabelPosition;
              if (W) {
                let z;
                F = V.connector, ae && ae.distance > 0 ? (z = !F, F || (V.connector = F = D.renderer.path().addClass("highcharts-data-label-connector  highcharts-color-" + ee.colorIndex + (ee.className ? " " + ee.className : "")).add(N.dataLabelsGroup)), D.styledMode || F.attr({ "stroke-width": W, stroke: G || ee.color || "#666666" }), F[z ? "attr" : "animate"]({ d: ee.getConnectorPath(V) }), F.attr({ visibility: ae.attribs?.visibility })) : F && (V.connector = F.destroy());
              }
            });
          })));
        }
        function $() {
          this.points.forEach((N) => {
            (N.dataLabels || []).forEach((M) => {
              let D = M.dataLabelPosition;
              D ? (D.sideOverflow && (M.css({ width: Math.max(M.getBBox().width - D.sideOverflow, 0) + "px", textOverflow: (M.options?.style || {}).textOverflow || "ellipsis" }), M.shortened = !0), M.attr(D.attribs), M[M.moved ? "animate" : "attr"](D.posAttribs), M.moved = !0) : M && M.attr({ y: -9999 });
            }), delete N.distributeBox;
          }, this);
        }
        function j(N) {
          let M = this.center, D = this.options, C = D.center, b = D.minSize || 80, p = b, L = D.size !== null;
          return !L && (C[0] !== null ? p = Math.max(M[2] - Math.max(N[1], N[3]), b) : (p = Math.max(M[2] - N[1] - N[3], b), M[0] += (N[3] - N[1]) / 2), C[1] !== null ? p = g(p, b, M[2] - Math.max(N[0], N[2])) : (p = g(p, b, M[2] - N[0] - N[2]), M[1] += (N[0] - N[2]) / 2), p < M[2] ? (M[2] = p, M[3] = Math.min(D.thickness ? Math.max(0, p - 2 * D.thickness) : Math.max(0, S(D.innerSize || 0, p)), p), this.translate(M), this.drawDataLabels && this.drawDataLabels()) : L = !0), L;
        }
        w.compose = function(N) {
          if (o.compose(h), f(y, "PieDataLabel")) {
            let M = N.prototype;
            M.dataLabelPositioners = x, M.alignDataLabel = u, M.drawDataLabels = A, M.getDataLabelPosition = k, M.placeDataLabels = $, M.verifyDataLabelOverflow = j;
          }
        };
      }(d || (d = {})), d;
    }), i(n, "Core/Geometry/GeometryUtilities.js", [], function() {
      var o, a;
      return (a = o || (o = {})).getCenterOfPoints = function(r) {
        let s = r.reduce((l, d) => (l.x += d.x, l.y += d.y, l), { x: 0, y: 0 });
        return { x: s.x / r.length, y: s.y / r.length };
      }, a.getDistanceBetweenPoints = function(r, s) {
        return Math.sqrt(Math.pow(s.x - r.x, 2) + Math.pow(s.y - r.y, 2));
      }, a.getAngleBetweenPoints = function(r, s) {
        return Math.atan2(s.x - r.x, s.y - r.y);
      }, a.pointInPolygon = function({ x: r, y: s }, l) {
        let d = l.length, y, u, m = !1;
        for (y = 0, u = d - 1; y < d; u = y++) {
          let [h, c] = l[y], [g, v] = l[u];
          c > s != v > s && r < (g - h) * (s - c) / (v - c) + h && (m = !m);
        }
        return m;
      }, o;
    }), i(n, "Extensions/OverlappingDataLabels.js", [n["Core/Geometry/GeometryUtilities.js"], n["Core/Utilities.js"]], function(o, a) {
      let { pointInPolygon: r } = o, { addEvent: s, fireEvent: l, objectEach: d, pick: y } = a;
      function u(c) {
        let g = c.length, v = ($, j) => !(j.x >= $.x + $.width || j.x + j.width <= $.x || j.y >= $.y + $.height || j.y + j.height <= $.y), P = ($, j) => {
          for (let N of $)
            if (r({ x: N[0], y: N[1] }, j))
              return !0;
          return !1;
        }, f, S, w, x, k, A = !1;
        for (let $ = 0; $ < g; $++)
          (f = c[$]) && (f.oldOpacity = f.opacity, f.newOpacity = 1, f.absoluteBox = function(j) {
            if (j && (!j.alignAttr || j.placed)) {
              let N = j.box ? 0 : j.padding || 0, M = j.alignAttr || { x: j.attr("x"), y: j.attr("y") }, D = j.getBBox();
              return j.width = D.width, j.height = D.height, { x: M.x + (j.parentGroup?.translateX || 0) + N, y: M.y + (j.parentGroup?.translateY || 0) + N, width: (j.width || 0) - 2 * N, height: (j.height || 0) - 2 * N, polygon: D?.polygon };
            }
          }(f));
        c.sort(($, j) => (j.labelrank || 0) - ($.labelrank || 0));
        for (let $ = 0; $ < g; ++$) {
          x = (S = c[$]) && S.absoluteBox;
          let j = x?.polygon;
          for (let N = $ + 1; N < g; ++N) {
            k = (w = c[N]) && w.absoluteBox;
            let M = !1;
            if (x && k && S !== w && S.newOpacity !== 0 && w.newOpacity !== 0 && S.visibility !== "hidden" && w.visibility !== "hidden") {
              let D = k.polygon;
              if (j && D && j !== D ? P(j, D) && (M = !0) : v(x, k) && (M = !0), M) {
                let C = S.labelrank < w.labelrank ? S : w, b = C.text;
                C.newOpacity = 0, b?.element.querySelector("textPath") && b.hide();
              }
            }
          }
        }
        for (let $ of c)
          m($, this) && (A = !0);
        A && l(this, "afterHideAllOverlappingLabels");
      }
      function m(c, g) {
        let v, P, f = !1;
        return c && (P = c.newOpacity, c.oldOpacity !== P && (c.hasClass("highcharts-data-label") ? (c[P ? "removeClass" : "addClass"]("highcharts-data-label-hidden"), v = function() {
          g.styledMode || c.css({ pointerEvents: P ? "auto" : "none" });
        }, f = !0, c[c.isOld ? "animate" : "attr"]({ opacity: P }, void 0, v), l(g, "afterHideOverlappingLabel")) : c.attr({ opacity: P })), c.isOld = !0), f;
      }
      function h() {
        let c = this, g = [];
        for (let v of c.labelCollectors || [])
          g = g.concat(v());
        for (let v of c.yAxis || [])
          v.stacking && v.options.stackLabels && !v.options.stackLabels.allowOverlap && d(v.stacking.stacks, (P) => {
            d(P, (f) => {
              f.label && g.push(f.label);
            });
          });
        for (let v of c.series || [])
          if (v.visible && v.hasDataLabels?.()) {
            let P = (f) => {
              for (let S of f)
                S.visible && (S.dataLabels || []).forEach((w) => {
                  let x = w.options || {};
                  w.labelrank = y(x.labelrank, S.labelrank, S.shapeArgs?.height), x.allowOverlap ?? Number(x.distance) > 0 ? (w.oldOpacity = w.opacity, w.newOpacity = 1, m(w, c)) : g.push(w);
                });
            };
            P(v.nodes || []), P(v.points);
          }
        this.hideOverlappingLabels(g);
      }
      return { compose: function(c) {
        let g = c.prototype;
        g.hideOverlappingLabels || (g.hideOverlappingLabels = u, s(c, "render", h));
      } };
    }), i(n, "Extensions/BorderRadius.js", [n["Core/Defaults.js"], n["Core/Globals.js"], n["Core/Utilities.js"]], function(o, a, r) {
      let { defaultOptions: s } = o, { noop: l } = a, { addEvent: d, extend: y, isObject: u, merge: m, relativeLength: h } = r, c = { radius: 0, scope: "stack", where: void 0 }, g = l, v = l;
      function P(k, A, $, j, N = {}) {
        let M = g(k, A, $, j, N), { innerR: D = 0, r: C = $, start: b = 0, end: p = 0 } = N;
        if (N.open || !N.borderRadius)
          return M;
        let L = p - b, B = Math.sin(L / 2), T = Math.max(Math.min(h(N.borderRadius || 0, C - D), (C - D) / 2, C * B / (1 + B)), 0), O = Math.min(T, L / Math.PI * 2 * D), I = M.length - 1;
        for (; I--; )
          (function(R, Y, F) {
            let U, Q, J, ee = R[Y], V = R[Y + 1];
            if (V[0] === "Z" && (V = R[0]), (ee[0] === "M" || ee[0] === "L") && V[0] === "A" ? (U = ee, Q = V, J = !0) : ee[0] === "A" && (V[0] === "M" || V[0] === "L") && (U = V, Q = ee), U && Q && Q.params) {
              let G = Q[1], W = Q[5], ae = Q.params, { start: z, end: q, cx: Z, cy: ne } = ae, ie = W ? G - F : G + F, re = ie ? Math.asin(F / ie) : 0, de = W ? re : -re, me = Math.cos(re) * ie;
              J ? (ae.start = z + de, U[1] = Z + me * Math.cos(z), U[2] = ne + me * Math.sin(z), R.splice(Y + 1, 0, ["A", F, F, 0, 0, 1, Z + G * Math.cos(ae.start), ne + G * Math.sin(ae.start)])) : (ae.end = q - de, Q[6] = Z + G * Math.cos(ae.end), Q[7] = ne + G * Math.sin(ae.end), R.splice(Y + 1, 0, ["A", F, F, 0, 0, 1, Z + me * Math.cos(q), ne + me * Math.sin(q)])), Q[4] = Math.abs(ae.end - ae.start) < Math.PI ? 0 : 1;
            }
          })(M, I, I > 1 ? O : T);
        return M;
      }
      function f() {
        if (this.options.borderRadius && !(this.chart.is3d && this.chart.is3d())) {
          let { options: k, yAxis: A } = this, $ = k.stacking === "percent", j = s.plotOptions?.[this.type]?.borderRadius, N = S(k.borderRadius, u(j) ? j : {}), M = A.options.reversed;
          for (let D of this.points) {
            let { shapeArgs: C } = D;
            if (D.shapeType === "roundedRect" && C) {
              let { width: b = 0, height: p = 0, y: L = 0 } = C, B = L, T = p;
              if (N.scope === "stack" && D.stackTotal) {
                let Y = A.translate($ ? 100 : D.stackTotal, !1, !0, !1, !0), F = A.translate(k.threshold || 0, !1, !0, !1, !0), U = this.crispCol(0, Math.min(Y, F), 0, Math.abs(Y - F));
                B = U.y, T = U.height;
              }
              let O = (D.negative ? -1 : 1) * (M ? -1 : 1) == -1, I = N.where;
              !I && this.is("waterfall") && Math.abs((D.yBottom || 0) - (this.translatedThreshold || 0)) > this.borderWidth && (I = "all"), I || (I = "end");
              let R = Math.min(h(N.radius, b), b / 2, I === "all" ? p / 2 : 1 / 0) || 0;
              I === "end" && (O && (B -= R), T += R), y(C, { brBoxHeight: T, brBoxY: B, r: R });
            }
          }
        }
      }
      function S(k, A) {
        return u(k) || (k = { radius: k || 0 }), m(c, A, k);
      }
      function w() {
        let k = S(this.options.borderRadius);
        for (let A of this.points) {
          let $ = A.shapeArgs;
          $ && ($.borderRadius = h(k.radius, ($.r || 0) - ($.innerR || 0)));
        }
      }
      function x(k, A, $, j, N = {}) {
        let M = v(k, A, $, j, N), { r: D = 0, brBoxHeight: C = j, brBoxY: b = A } = N, p = A - b, L = b + C - (A + j), B = p - D > -0.1 ? 0 : D, T = L - D > -0.1 ? 0 : D, O = Math.max(B && p, 0), I = Math.max(T && L, 0), R = [k + B, A], Y = [k + $ - B, A], F = [k + $, A + B], U = [k + $, A + j - T], Q = [k + $ - T, A + j], J = [k + T, A + j], ee = [k, A + j - T], V = [k, A + B], G = (W, ae) => Math.sqrt(Math.pow(W, 2) - Math.pow(ae, 2));
        if (O) {
          let W = G(B, B - O);
          R[0] -= W, Y[0] += W, F[1] = V[1] = A + B - O;
        }
        if (j < B - O) {
          let W = G(B, B - O - j);
          F[0] = U[0] = k + $ - B + W, Q[0] = Math.min(F[0], Q[0]), J[0] = Math.max(U[0], J[0]), ee[0] = V[0] = k + B - W, F[1] = V[1] = A + j;
        }
        if (I) {
          let W = G(T, T - I);
          Q[0] += W, J[0] -= W, U[1] = ee[1] = A + j - T + I;
        }
        if (j < T - I) {
          let W = G(T, T - I - j);
          F[0] = U[0] = k + $ - T + W, Y[0] = Math.min(F[0], Y[0]), R[0] = Math.max(U[0], R[0]), ee[0] = V[0] = k + T - W, U[1] = ee[1] = A;
        }
        return M.length = 0, M.push(["M", ...R], ["L", ...Y], ["A", B, B, 0, 0, 1, ...F], ["L", ...U], ["A", T, T, 0, 0, 1, ...Q], ["L", ...J], ["A", T, T, 0, 0, 1, ...ee], ["L", ...V], ["A", B, B, 0, 0, 1, ...R], ["Z"]), M;
      }
      return { compose: function(k, A, $) {
        let j = k.types.pie;
        if (!A.symbolCustomAttribs.includes("borderRadius")) {
          let N = $.prototype.symbols;
          d(k, "afterColumnTranslate", f, { order: 9 }), d(j, "afterTranslate", w), A.symbolCustomAttribs.push("borderRadius", "brBoxHeight", "brBoxY"), g = N.arc, v = N.roundedRect, N.arc = P, N.roundedRect = x;
        }
      }, optionsToObject: S };
    }), i(n, "Core/Responsive.js", [n["Core/Utilities.js"]], function(o) {
      var a;
      let { diffObjects: r, extend: s, find: l, merge: d, pick: y, uniqueKey: u } = o;
      return function(m) {
        function h(g, v) {
          let P = g.condition;
          (P.callback || function() {
            return this.chartWidth <= y(P.maxWidth, Number.MAX_VALUE) && this.chartHeight <= y(P.maxHeight, Number.MAX_VALUE) && this.chartWidth >= y(P.minWidth, 0) && this.chartHeight >= y(P.minHeight, 0);
          }).call(this) && v.push(g._id);
        }
        function c(g, v) {
          let P = this.options.responsive, f = this.currentResponsive, S = [], w;
          !v && P && P.rules && P.rules.forEach((A) => {
            A._id === void 0 && (A._id = u()), this.matchResponsiveRule(A, S);
          }, this);
          let x = d(...S.map((A) => l((P || {}).rules || [], ($) => $._id === A)).map((A) => A && A.chartOptions));
          x.isResponsiveOptions = !0, S = S.toString() || void 0;
          let k = f && f.ruleIds;
          S === k || (f && (this.currentResponsive = void 0, this.updatingResponsive = !0, this.update(f.undoOptions, g, !0), this.updatingResponsive = !1), S ? ((w = r(x, this.options, !0, this.collectionsWithUpdate)).isResponsiveOptions = !0, this.currentResponsive = { ruleIds: S, mergedOptions: x, undoOptions: w }, this.updatingResponsive || this.update(x, g, !0)) : this.currentResponsive = void 0);
        }
        m.compose = function(g) {
          let v = g.prototype;
          return v.matchResponsiveRule || s(v, { matchResponsiveRule: h, setResponsive: c }), g;
        };
      }(a || (a = {})), a;
    }), i(n, "masters/highcharts.src.js", [n["Core/Globals.js"], n["Core/Utilities.js"], n["Core/Defaults.js"], n["Core/Animation/Fx.js"], n["Core/Animation/AnimationUtilities.js"], n["Core/Renderer/HTML/AST.js"], n["Core/Templating.js"], n["Core/Renderer/RendererRegistry.js"], n["Core/Renderer/RendererUtilities.js"], n["Core/Renderer/SVG/SVGElement.js"], n["Core/Renderer/SVG/SVGRenderer.js"], n["Core/Renderer/HTML/HTMLElement.js"], n["Core/Axis/Axis.js"], n["Core/Axis/DateTimeAxis.js"], n["Core/Axis/LogarithmicAxis.js"], n["Core/Axis/PlotLineOrBand/PlotLineOrBand.js"], n["Core/Axis/Tick.js"], n["Core/Tooltip.js"], n["Core/Series/Point.js"], n["Core/Pointer.js"], n["Core/Legend/Legend.js"], n["Core/Legend/LegendSymbol.js"], n["Core/Chart/Chart.js"], n["Extensions/ScrollablePlotArea.js"], n["Core/Axis/Stacking/StackingAxis.js"], n["Core/Axis/Stacking/StackItem.js"], n["Core/Series/Series.js"], n["Core/Series/SeriesRegistry.js"], n["Series/Column/ColumnDataLabel.js"], n["Series/Pie/PieDataLabel.js"], n["Core/Series/DataLabel.js"], n["Extensions/OverlappingDataLabels.js"], n["Extensions/BorderRadius.js"], n["Core/Responsive.js"], n["Core/Color/Color.js"], n["Core/Time.js"]], function(o, a, r, s, l, d, y, u, m, h, c, g, v, P, f, S, w, x, k, A, $, j, N, M, D, C, b, p, L, B, T, O, I, R, Y, F) {
      return o.AST = d, o.Axis = v, o.Chart = N, o.Color = Y, o.DataLabel = T, o.Fx = s, o.HTMLElement = g, o.Legend = $, o.LegendSymbol = j, o.OverlappingDataLabels = o.OverlappingDataLabels || O, o.PlotLineOrBand = S, o.Point = k, o.Pointer = A, o.RendererRegistry = u, o.Series = b, o.SeriesRegistry = p, o.StackItem = C, o.SVGElement = h, o.SVGRenderer = c, o.Templating = y, o.Tick = w, o.Time = F, o.Tooltip = x, o.animate = l.animate, o.animObject = l.animObject, o.chart = N.chart, o.color = Y.parse, o.dateFormat = y.dateFormat, o.defaultOptions = r.defaultOptions, o.distribute = m.distribute, o.format = y.format, o.getDeferredAnimation = l.getDeferredAnimation, o.getOptions = r.getOptions, o.numberFormat = y.numberFormat, o.seriesType = p.seriesType, o.setAnimation = l.setAnimation, o.setOptions = r.setOptions, o.stop = l.stop, o.time = r.defaultTime, o.timers = s.timers, I.compose(o.Series, o.SVGElement, o.SVGRenderer), L.compose(o.Series.types.column), T.compose(o.Series), P.compose(o.Axis), g.compose(o.SVGRenderer), $.compose(o.Chart), f.compose(o.Axis), O.compose(o.Chart), B.compose(o.Series.types.pie), S.compose(o.Chart, o.Axis), A.compose(o.Chart), R.compose(o.Chart), M.compose(o.Axis, o.Chart, o.Series), D.compose(o.Axis, o.Chart, o.Series), x.compose(o.Pointer), a.extend(o, a), o;
    }), n["masters/highcharts.src.js"]._modules = n, n["masters/highcharts.src.js"];
  });
})(Bk);
var W6 = Bk.exports;
const Nn = /* @__PURE__ */ en(W6);
var Ek = { exports: {} };
(function(e) {
  /**
  * Highstock JS v11.4.8 (2024-08-29)
  *
  * Highcharts Stock as a plugin for Highcharts
  *
  * (c) 2010-2024 Torstein Honsi
  *
  * License: www.highcharts.com/license
  */
  (function(t) {
    e.exports ? (t.default = t, e.exports = t) : t(typeof Highcharts < "u" ? Highcharts : void 0);
  })(function(t) {
    var n = t ? t._modules : {};
    function i(o, a, r, s) {
      o.hasOwnProperty(a) || (o[a] = s.apply(null, r), typeof CustomEvent == "function" && t.win.dispatchEvent(new CustomEvent("HighchartsModuleLoaded", { detail: { path: a, module: o[a] } })));
    }
    i(n, "Series/DataModifyComposition.js", [n["Core/Axis/Axis.js"], n["Core/Series/Point.js"], n["Core/Series/Series.js"], n["Core/Utilities.js"]], function(o, a, r, s) {
      var l;
      let { tooltipFormatter: d } = a.prototype, { addEvent: y, arrayMax: u, arrayMin: m, correctFloat: h, defined: c, isArray: g, isNumber: v, isString: P, pick: f } = s;
      return function(S) {
        function w(b, p, L) {
          !this.isXAxis && (this.series.forEach(function(B) {
            b === "compare" && typeof p != "boolean" ? B.setCompare(p, !1) : b !== "cumulative" || P(p) || B.setCumulative(p, !1);
          }), f(L, !0) && this.chart.redraw());
        }
        function x(b) {
          let p = this, { numberFormatter: L } = p.series.chart, B = function(T) {
            b = b.replace("{point." + T + "}", (p[T] > 0 && T === "change" ? "+" : "") + L(p[T], f(p.series.tooltipOptions.changeDecimals, 2)));
          };
          return c(p.change) && B("change"), c(p.cumulativeSum) && B("cumulativeSum"), d.apply(this, [b]);
        }
        function k() {
          let b, p = this.options.compare;
          (p === "percent" || p === "value" || this.options.cumulative) && (b = new C(this), p === "percent" || p === "value" ? b.initCompare(p) : b.initCumulative()), this.dataModify = b;
        }
        function A(b) {
          let p = b.dataExtremes, L = p.activeYData;
          if (this.dataModify && p) {
            let B;
            this.options.compare ? B = [this.dataModify.modifyValue(p.dataMin), this.dataModify.modifyValue(p.dataMax)] : this.options.cumulative && g(L) && L.length >= 2 && (B = C.getCumulativeExtremes(L)), B && (p.dataMin = m(B), p.dataMax = u(B));
          }
        }
        function $(b, p) {
          this.options.compare = this.userOptions.compare = b, this.update({}, f(p, !0)), this.dataModify && (b === "value" || b === "percent") ? this.dataModify.initCompare(b) : this.points.forEach((L) => {
            delete L.change;
          });
        }
        function j() {
          if (this.xAxis && this.processedYData && this.dataModify) {
            let b = this.processedXData, p = this.processedYData, L = p.length, B = this.options.compareStart === !0 ? 0 : 1, T = -1, O;
            for (this.pointArrayMap && (T = this.pointArrayMap.indexOf(this.options.pointValKey || this.pointValKey || "y")), O = 0; O < L - B; O++) {
              let I = p[O] && T > -1 ? p[O][T] : p[O];
              if (v(I) && I !== 0 && b[O + B] >= (this.xAxis.min || 0)) {
                this.dataModify.compareValue = I;
                break;
              }
            }
          }
        }
        function N(b, p) {
          this.setModifier("compare", b, p);
        }
        function M(b, p) {
          b = f(b, !1), this.options.cumulative = this.userOptions.cumulative = b, this.update({}, f(p, !0)), this.dataModify ? this.dataModify.initCumulative() : this.points.forEach((L) => {
            delete L.cumulativeSum;
          });
        }
        function D(b, p) {
          this.setModifier("cumulative", b, p);
        }
        S.compose = function(b, p, L) {
          let B = p.prototype, T = L.prototype, O = b.prototype;
          return O.setCompare || (O.setCompare = $, O.setCumulative = M, y(b, "afterInit", k), y(b, "afterGetExtremes", A), y(b, "afterProcessData", j)), B.setCompare || (B.setCompare = N, B.setModifier = w, B.setCumulative = D, T.tooltipFormatter = x), b;
        };
        class C {
          constructor(p) {
            this.series = p;
          }
          modifyValue() {
            return 0;
          }
          static getCumulativeExtremes(p) {
            let L = 1 / 0, B = -1 / 0;
            return p.reduce((T, O) => {
              let I = T + O;
              return L = Math.min(L, I, T), B = Math.max(B, I, T), I;
            }), [L, B];
          }
          initCompare(p) {
            this.modifyValue = function(L, B) {
              L === null && (L = 0);
              let T = this.compareValue;
              if (L !== void 0 && T !== void 0) {
                if (p === "value" ? L -= T : L = L / T * 100 - (this.series.options.compareBase === 100 ? 0 : 100), B !== void 0) {
                  let O = this.series.points[B];
                  O && (O.change = L);
                }
                return L;
              }
              return 0;
            };
          }
          initCumulative() {
            this.modifyValue = function(p, L) {
              if (p === null && (p = 0), p !== void 0 && L !== void 0) {
                let B = L > 0 ? this.series.points[L - 1] : null;
                B && B.cumulativeSum && (p = h(B.cumulativeSum + p));
                let T = this.series.points[L], O = T.series.options.cumulativeStart, I = T.x <= this.series.xAxis.max && T.x >= this.series.xAxis.min;
                return T && (!O || I ? T.cumulativeSum = p : T.cumulativeSum = void 0), p;
              }
              return 0;
            };
          }
        }
        S.Additions = C;
      }(l || (l = {})), l;
    }), i(n, "Stock/Navigator/ChartNavigatorComposition.js", [n["Core/Globals.js"], n["Core/Utilities.js"]], function(o, a) {
      let r, { isTouchDevice: s } = o, { addEvent: l, merge: d, pick: y } = a, u = [];
      function m() {
        this.navigator && this.navigator.setBaseSeries(null, !1);
      }
      function h() {
        let S, w, x, k = this.legend, A = this.navigator;
        if (A) {
          S = k && k.options, w = A.xAxis, x = A.yAxis;
          let { scrollbarHeight: $, scrollButtonSize: j } = A;
          this.inverted ? (A.left = A.opposite ? this.chartWidth - $ - A.height : this.spacing[3] + $, A.top = this.plotTop + j) : (A.left = y(w.left, this.plotLeft + j), A.top = A.navigatorOptions.top || this.chartHeight - A.height - $ - (this.scrollbar?.options.margin || 0) - this.spacing[2] - (this.rangeSelector && this.extraBottomMargin ? this.rangeSelector.getHeight() : 0) - (S && S.verticalAlign === "bottom" && S.layout !== "proximate" && S.enabled && !S.floating ? k.legendHeight + y(S.margin, 10) : 0) - (this.titleOffset ? this.titleOffset[2] : 0)), w && x && (this.inverted ? w.options.left = x.options.left = A.left : w.options.top = x.options.top = A.top, w.setAxisSize(), x.setAxisSize());
        }
      }
      function c(S) {
        !this.navigator && !this.scroller && (this.options.navigator.enabled || this.options.scrollbar.enabled) && (this.scroller = this.navigator = new r(this), y(S.redraw, !0) && this.redraw(S.animation));
      }
      function g() {
        let S = this.options;
        (S.navigator.enabled || S.scrollbar.enabled) && (this.scroller = this.navigator = new r(this));
      }
      function v() {
        let S = this.options, w = S.navigator, x = S.rangeSelector;
        if ((w && w.enabled || x && x.enabled) && (!s && this.zooming.type === "x" || s && this.zooming.pinchType === "x"))
          return !1;
      }
      function P(S) {
        let w = S.navigator;
        if (w && S.xAxis[0]) {
          let x = S.xAxis[0].getExtremes();
          w.render(x.min, x.max);
        }
      }
      function f(S) {
        let w = S.options.navigator || {}, x = S.options.scrollbar || {};
        !this.navigator && !this.scroller && (w.enabled || x.enabled) && (d(!0, this.options.navigator, w), d(!0, this.options.scrollbar, x), delete S.options.navigator, delete S.options.scrollbar);
      }
      return { compose: function(S, w) {
        if (a.pushUnique(u, S)) {
          let x = S.prototype;
          r = w, x.callbacks.push(P), l(S, "afterAddSeries", m), l(S, "afterSetChartSize", h), l(S, "afterUpdate", c), l(S, "beforeRender", g), l(S, "beforeShowResetZoom", v), l(S, "update", f);
        }
      } };
    }), i(n, "Core/Axis/NavigatorAxisComposition.js", [n["Core/Globals.js"], n["Core/Utilities.js"]], function(o, a) {
      let { isTouchDevice: r } = o, { addEvent: s, correctFloat: l, defined: d, isNumber: y, pick: u } = a;
      function m() {
        this.navigatorAxis || (this.navigatorAxis = new c(this));
      }
      function h(g) {
        let v, P = this.chart, f = P.options, S = f.navigator, w = this.navigatorAxis, x = P.zooming.pinchType, k = f.rangeSelector, A = P.zooming.type;
        if (this.isXAxis && (S?.enabled || k?.enabled)) {
          if (A === "y" && g.trigger === "zoom")
            v = !1;
          else if ((g.trigger === "zoom" && A === "xy" || r && x === "xy") && this.options.range) {
            let $ = w.previousZoom;
            d(g.min) ? w.previousZoom = [this.min, this.max] : $ && (g.min = $[0], g.max = $[1], w.previousZoom = void 0);
          }
        }
        v !== void 0 && g.preventDefault();
      }
      class c {
        static compose(v) {
          v.keepProps.includes("navigatorAxis") || (v.keepProps.push("navigatorAxis"), s(v, "init", m), s(v, "setExtremes", h));
        }
        constructor(v) {
          this.axis = v;
        }
        destroy() {
          this.axis = void 0;
        }
        toFixedRange(v, P, f, S) {
          let w = this.axis, x = (w.pointRange || 0) / 2, k = u(f, w.translate(v, !0, !w.horiz)), A = u(S, w.translate(P, !0, !w.horiz));
          return d(f) || (k = l(k + x)), d(S) || (A = l(A - x)), y(k) && y(A) || (k = A = void 0), { min: k, max: A };
        }
      }
      return c;
    }), i(n, "Stock/Navigator/NavigatorDefaults.js", [n["Core/Color/Color.js"], n["Core/Series/SeriesRegistry.js"]], function(o, a) {
      let { parse: r } = o, { seriesTypes: s } = a;
      return { height: 40, margin: 25, maskInside: !0, handles: { width: 7, borderRadius: 0, height: 15, symbols: ["navigator-handle", "navigator-handle"], enabled: !0, lineWidth: 1, backgroundColor: "#f2f2f2", borderColor: "#999999" }, maskFill: r("#667aff").setOpacity(0.3).get(), outlineColor: "#999999", outlineWidth: 1, series: { type: s.areaspline === void 0 ? "line" : "areaspline", fillOpacity: 0.05, lineWidth: 1, compare: null, sonification: { enabled: !1 }, dataGrouping: { approximation: "average", enabled: !0, groupPixelWidth: 2, firstAnchor: "firstPoint", anchor: "middle", lastAnchor: "lastPoint", units: [["millisecond", [1, 2, 5, 10, 20, 25, 50, 100, 200, 500]], ["second", [1, 2, 5, 10, 15, 30]], ["minute", [1, 2, 5, 10, 15, 30]], ["hour", [1, 2, 3, 4, 6, 8, 12]], ["day", [1, 2, 3, 4]], ["week", [1, 2, 3]], ["month", [1, 3, 6]], ["year", null]] }, dataLabels: { enabled: !1, zIndex: 2 }, id: "highcharts-navigator-series", className: "highcharts-navigator-series", lineColor: null, marker: { enabled: !1 }, threshold: null }, xAxis: { className: "highcharts-navigator-xaxis", tickLength: 0, lineWidth: 0, gridLineColor: "#e6e6e6", id: "navigator-x-axis", gridLineWidth: 1, tickPixelInterval: 200, labels: { align: "left", style: { color: "#000000", fontSize: "0.7em", opacity: 0.6, textOutline: "2px contrast" }, x: 3, y: -4 }, crosshair: !1 }, yAxis: { className: "highcharts-navigator-yaxis", gridLineWidth: 0, startOnTick: !1, endOnTick: !1, minPadding: 0.1, id: "navigator-y-axis", maxPadding: 0.1, labels: { enabled: !1 }, crosshair: !1, title: { text: null }, tickLength: 0, tickWidth: 0 } };
    }), i(n, "Stock/Navigator/NavigatorSymbols.js", [n["Core/Renderer/SVG/Symbols.js"], n["Core/Utilities.js"]], function(o, a) {
      let { relativeLength: r } = a;
      return { "navigator-handle": function(s, l, d, y, u = {}) {
        let m = u.width ? u.width / 2 : d, h = r(u.borderRadius || 0, Math.min(2 * m, y));
        return [["M", -1.5, (y = u.height || y) / 2 - 3.5], ["L", -1.5, y / 2 + 4.5], ["M", 0.5, y / 2 - 3.5], ["L", 0.5, y / 2 + 4.5], ...o.rect(-m - 1, 0.5, 2 * m + 1, y, { r: h })];
      } };
    }), i(n, "Stock/Utilities/StockUtilities.js", [n["Core/Utilities.js"]], function(o) {
      let { defined: a } = o;
      return { setFixedRange: function(r) {
        let s = this.xAxis[0];
        a(s.dataMax) && a(s.dataMin) && r ? this.fixedRange = Math.min(r, s.dataMax - s.dataMin) : this.fixedRange = r;
      } };
    }), i(n, "Stock/Navigator/NavigatorComposition.js", [n["Core/Defaults.js"], n["Core/Globals.js"], n["Core/Axis/NavigatorAxisComposition.js"], n["Stock/Navigator/NavigatorDefaults.js"], n["Stock/Navigator/NavigatorSymbols.js"], n["Core/Renderer/RendererRegistry.js"], n["Stock/Utilities/StockUtilities.js"], n["Core/Utilities.js"]], function(o, a, r, s, l, d, y, u) {
      let { setOptions: m } = o, { composed: h } = a, { getRendererType: c } = d, { setFixedRange: g } = y, { addEvent: v, extend: P, pushUnique: f } = u;
      function S() {
        this.chart.navigator && !this.options.isInternal && this.chart.navigator.setBaseSeries(null, !1);
      }
      return { compose: function(w, x, k) {
        r.compose(x), f(h, "Navigator") && (w.prototype.setFixedRange = g, P(c().prototype.symbols, l), v(k, "afterUpdate", S), m({ navigator: s }));
      } };
    }), i(n, "Core/Axis/ScrollbarAxis.js", [n["Core/Globals.js"], n["Core/Utilities.js"]], function(o, a) {
      var r;
      let { composed: s } = o, { addEvent: l, defined: d, pick: y, pushUnique: u } = a;
      return function(m) {
        let h;
        function c(f) {
          let S = y(f.options && f.options.min, f.min), w = y(f.options && f.options.max, f.max);
          return { axisMin: S, axisMax: w, scrollMin: d(f.dataMin) ? Math.min(S, f.min, f.dataMin, y(f.threshold, 1 / 0)) : S, scrollMax: d(f.dataMax) ? Math.max(w, f.max, f.dataMax, y(f.threshold, -1 / 0)) : w };
        }
        function g() {
          let f = this.scrollbar, S = f && !f.options.opposite, w = this.horiz ? 2 : S ? 3 : 1;
          f && (this.chart.scrollbarsOffsets = [0, 0], this.chart.axisOffset[w] += f.size + (f.options.margin || 0));
        }
        function v() {
          let f = this;
          f.options && f.options.scrollbar && f.options.scrollbar.enabled && (f.options.scrollbar.vertical = !f.horiz, f.options.startOnTick = f.options.endOnTick = !1, f.scrollbar = new h(f.chart.renderer, f.options.scrollbar, f.chart), l(f.scrollbar, "changed", function(S) {
            let w, x, { axisMin: k, axisMax: A, scrollMin: $, scrollMax: j } = c(f), N = j - $;
            if (d(k) && d(A))
              if (f.horiz && !f.reversed || !f.horiz && f.reversed ? (w = $ + N * this.to, x = $ + N * this.from) : (w = $ + N * (1 - this.from), x = $ + N * (1 - this.to)), this.shouldUpdateExtremes(S.DOMType)) {
                let M = S.DOMType !== "mousemove" && S.DOMType !== "touchmove" && void 0;
                f.setExtremes(x, w, !0, M, S);
              } else
                this.setRange(this.from, this.to);
          }));
        }
        function P() {
          let f, S, w, { scrollMin: x, scrollMax: k } = c(this), A = this.scrollbar, $ = this.axisTitleMargin + (this.titleOffset || 0), j = this.chart.scrollbarsOffsets, N = this.options.margin || 0;
          if (A && j) {
            if (this.horiz)
              this.opposite || (j[1] += $), A.position(this.left, this.top + this.height + 2 + j[1] - (this.opposite ? N : 0), this.width, this.height), this.opposite || (j[1] += N), f = 1;
            else {
              let M;
              this.opposite && (j[0] += $), M = A.options.opposite ? this.left + this.width + 2 + j[0] - (this.opposite ? 0 : N) : this.opposite ? 0 : N, A.position(M, this.top, this.width, this.height), this.opposite && (j[0] += N), f = 0;
            }
            if (j[f] += A.size + (A.options.margin || 0), isNaN(x) || isNaN(k) || !d(this.min) || !d(this.max) || this.dataMin === this.dataMax)
              A.setRange(0, 1);
            else if (this.min === this.max) {
              let M = this.pointRange / (this.dataMax + 1);
              S = M * this.min, w = M * (this.max + 1), A.setRange(S, w);
            } else
              S = (this.min - x) / (k - x), w = (this.max - x) / (k - x), this.horiz && !this.reversed || !this.horiz && this.reversed ? A.setRange(S, w) : A.setRange(1 - w, 1 - S);
          }
        }
        m.compose = function(f, S) {
          u(s, "Axis.Scrollbar") && (h = S, l(f, "afterGetOffset", g), l(f, "afterInit", v), l(f, "afterRender", P));
        };
      }(r || (r = {})), r;
    }), i(n, "Stock/Scrollbar/ScrollbarDefaults.js", [], function() {
      return { height: 10, barBorderRadius: 5, buttonBorderRadius: 0, buttonsEnabled: !1, liveRedraw: void 0, margin: void 0, minWidth: 6, opposite: !0, step: 0.2, zIndex: 3, barBackgroundColor: "#cccccc", barBorderWidth: 0, barBorderColor: "#cccccc", buttonArrowColor: "#333333", buttonBackgroundColor: "#e6e6e6", buttonBorderColor: "#cccccc", buttonBorderWidth: 1, rifleColor: "none", trackBackgroundColor: "rgba(255, 255, 255, 0.001)", trackBorderColor: "#cccccc", trackBorderRadius: 5, trackBorderWidth: 1 };
    }), i(n, "Stock/Scrollbar/Scrollbar.js", [n["Core/Defaults.js"], n["Core/Globals.js"], n["Core/Axis/ScrollbarAxis.js"], n["Stock/Scrollbar/ScrollbarDefaults.js"], n["Core/Utilities.js"]], function(o, a, r, s, l) {
      let { defaultOptions: d } = o, { addEvent: y, correctFloat: u, crisp: m, defined: h, destroyObjectProperties: c, fireEvent: g, merge: v, pick: P, removeEvent: f } = l;
      class S {
        static compose(x) {
          r.compose(x, S);
        }
        static swapXY(x, k) {
          return k && x.forEach((A) => {
            let $, j = A.length;
            for (let N = 0; N < j; N += 2)
              typeof ($ = A[N + 1]) == "number" && (A[N + 1] = A[N + 2], A[N + 2] = $);
          }), x;
        }
        constructor(x, k, A) {
          this._events = [], this.chartX = 0, this.chartY = 0, this.from = 0, this.scrollbarButtons = [], this.scrollbarLeft = 0, this.scrollbarStrokeWidth = 1, this.scrollbarTop = 0, this.size = 0, this.to = 0, this.trackBorderWidth = 1, this.x = 0, this.y = 0, this.init(x, k, A);
        }
        addEvents() {
          let x = this.options.inverted ? [1, 0] : [0, 1], k = this.scrollbarButtons, A = this.scrollbarGroup.element, $ = this.track.element, j = this.mouseDownHandler.bind(this), N = this.mouseMoveHandler.bind(this), M = this.mouseUpHandler.bind(this), D = [[k[x[0]].element, "click", this.buttonToMinClick.bind(this)], [k[x[1]].element, "click", this.buttonToMaxClick.bind(this)], [$, "click", this.trackClick.bind(this)], [A, "mousedown", j], [A.ownerDocument, "mousemove", N], [A.ownerDocument, "mouseup", M], [A, "touchstart", j], [A.ownerDocument, "touchmove", N], [A.ownerDocument, "touchend", M]];
          D.forEach(function(C) {
            y.apply(null, C);
          }), this._events = D;
        }
        buttonToMaxClick(x) {
          let k = (this.to - this.from) * P(this.options.step, 0.2);
          this.updatePosition(this.from + k, this.to + k), g(this, "changed", { from: this.from, to: this.to, trigger: "scrollbar", DOMEvent: x });
        }
        buttonToMinClick(x) {
          let k = u(this.to - this.from) * P(this.options.step, 0.2);
          this.updatePosition(u(this.from - k), u(this.to - k)), g(this, "changed", { from: this.from, to: this.to, trigger: "scrollbar", DOMEvent: x });
        }
        cursorToScrollbarPosition(x) {
          let k = this.options, A = k.minWidth > this.calculatedWidth ? k.minWidth : 0;
          return { chartX: (x.chartX - this.x - this.xOffset) / (this.barWidth - A), chartY: (x.chartY - this.y - this.yOffset) / (this.barWidth - A) };
        }
        destroy() {
          let x = this, k = x.chart.scroller;
          x.removeEvents(), ["track", "scrollbarRifles", "scrollbar", "scrollbarGroup", "group"].forEach(function(A) {
            x[A] && x[A].destroy && (x[A] = x[A].destroy());
          }), k && x === k.scrollbar && (k.scrollbar = null, c(k.scrollbarButtons));
        }
        drawScrollbarButton(x) {
          let k = this.renderer, A = this.scrollbarButtons, $ = this.options, j = this.size, N = k.g().add(this.group);
          if (A.push(N), $.buttonsEnabled) {
            let M = k.rect().addClass("highcharts-scrollbar-button").add(N);
            this.chart.styledMode || M.attr({ stroke: $.buttonBorderColor, "stroke-width": $.buttonBorderWidth, fill: $.buttonBackgroundColor }), M.attr(M.crisp({ x: -0.5, y: -0.5, width: j, height: j, r: $.buttonBorderRadius }, M.strokeWidth()));
            let D = k.path(S.swapXY([["M", j / 2 + (x ? -1 : 1), j / 2 - 3], ["L", j / 2 + (x ? -1 : 1), j / 2 + 3], ["L", j / 2 + (x ? 2 : -2), j / 2]], $.vertical)).addClass("highcharts-scrollbar-arrow").add(A[x]);
            this.chart.styledMode || D.attr({ fill: $.buttonArrowColor });
          }
        }
        init(x, k, A) {
          this.scrollbarButtons = [], this.renderer = x, this.userOptions = k, this.options = v(s, d.scrollbar, k), this.options.margin = P(this.options.margin, 10), this.chart = A, this.size = P(this.options.size, this.options.height), k.enabled && (this.render(), this.addEvents());
        }
        mouseDownHandler(x) {
          let k = this.chart.pointer?.normalize(x) || x, A = this.cursorToScrollbarPosition(k);
          this.chartX = A.chartX, this.chartY = A.chartY, this.initPositions = [this.from, this.to], this.grabbedCenter = !0;
        }
        mouseMoveHandler(x) {
          let k, A = this.chart.pointer?.normalize(x) || x, $ = this.options.vertical ? "chartY" : "chartX", j = this.initPositions || [];
          this.grabbedCenter && (!x.touches || x.touches[0][$] !== 0) && (k = this.cursorToScrollbarPosition(A)[$] - this[$], this.hasDragged = !0, this.updatePosition(j[0] + k, j[1] + k), this.hasDragged && g(this, "changed", { from: this.from, to: this.to, trigger: "scrollbar", DOMType: x.type, DOMEvent: x }));
        }
        mouseUpHandler(x) {
          this.hasDragged && g(this, "changed", { from: this.from, to: this.to, trigger: "scrollbar", DOMType: x.type, DOMEvent: x }), this.grabbedCenter = this.hasDragged = this.chartX = this.chartY = null;
        }
        position(x, k, A, $) {
          let { buttonsEnabled: j, margin: N = 0, vertical: M } = this.options, D = this.rendered ? "animate" : "attr", C = $, b = 0;
          this.group.show(), this.x = x, this.y = k + this.trackBorderWidth, this.width = A, this.height = $, this.xOffset = C, this.yOffset = b, M ? (this.width = this.yOffset = A = b = this.size, this.xOffset = C = 0, this.yOffset = b = j ? this.size : 0, this.barWidth = $ - (j ? 2 * A : 0), this.x = x += N) : (this.height = $ = this.size, this.xOffset = C = j ? this.size : 0, this.barWidth = A - (j ? 2 * $ : 0), this.y = this.y + N), this.group[D]({ translateX: x, translateY: this.y }), this.track[D]({ width: A, height: $ }), this.scrollbarButtons[1][D]({ translateX: M ? 0 : A - C, translateY: M ? $ - b : 0 });
        }
        removeEvents() {
          this._events.forEach(function(x) {
            f.apply(null, x);
          }), this._events.length = 0;
        }
        render() {
          let x = this.renderer, k = this.options, A = this.size, $ = this.chart.styledMode, j = x.g("scrollbar").attr({ zIndex: k.zIndex }).hide().add();
          this.group = j, this.track = x.rect().addClass("highcharts-scrollbar-track").attr({ r: k.trackBorderRadius || 0, height: A, width: A }).add(j), $ || this.track.attr({ fill: k.trackBackgroundColor, stroke: k.trackBorderColor, "stroke-width": k.trackBorderWidth });
          let N = this.trackBorderWidth = this.track.strokeWidth();
          this.track.attr({ x: -m(0, N), y: -m(0, N) }), this.scrollbarGroup = x.g().add(j), this.scrollbar = x.rect().addClass("highcharts-scrollbar-thumb").attr({ height: A - N, width: A - N, r: k.barBorderRadius || 0 }).add(this.scrollbarGroup), this.scrollbarRifles = x.path(S.swapXY([["M", -3, A / 4], ["L", -3, 2 * A / 3], ["M", 0, A / 4], ["L", 0, 2 * A / 3], ["M", 3, A / 4], ["L", 3, 2 * A / 3]], k.vertical)).addClass("highcharts-scrollbar-rifles").add(this.scrollbarGroup), $ || (this.scrollbar.attr({ fill: k.barBackgroundColor, stroke: k.barBorderColor, "stroke-width": k.barBorderWidth }), this.scrollbarRifles.attr({ stroke: k.rifleColor, "stroke-width": 1 })), this.scrollbarStrokeWidth = this.scrollbar.strokeWidth(), this.scrollbarGroup.translate(-m(0, this.scrollbarStrokeWidth), -m(0, this.scrollbarStrokeWidth)), this.drawScrollbarButton(0), this.drawScrollbarButton(1);
        }
        setRange(x, k) {
          let A, $, j = this.options, N = j.vertical, M = j.minWidth, D = this.barWidth, C = !this.rendered || this.hasDragged || this.chart.navigator && this.chart.navigator.hasDragged ? "attr" : "animate";
          if (!h(D))
            return;
          let b = D * Math.min(k, 1);
          A = Math.ceil(D * (x = Math.max(x, 0))), this.calculatedWidth = $ = u(b - A), $ < M && (A = (D - M + $) * x, $ = M);
          let p = Math.floor(A + this.xOffset + this.yOffset), L = $ / 2 - 0.5;
          this.from = x, this.to = k, N ? (this.scrollbarGroup[C]({ translateY: p }), this.scrollbar[C]({ height: $ }), this.scrollbarRifles[C]({ translateY: L }), this.scrollbarTop = p, this.scrollbarLeft = 0) : (this.scrollbarGroup[C]({ translateX: p }), this.scrollbar[C]({ width: $ }), this.scrollbarRifles[C]({ translateX: L }), this.scrollbarLeft = p, this.scrollbarTop = 0), $ <= 12 ? this.scrollbarRifles.hide() : this.scrollbarRifles.show(), j.showFull === !1 && (x <= 0 && k >= 1 ? this.group.hide() : this.group.show()), this.rendered = !0;
        }
        shouldUpdateExtremes(x) {
          return P(this.options.liveRedraw, a.svg && !a.isTouchDevice && !this.chart.boosted) || x === "mouseup" || x === "touchend" || !h(x);
        }
        trackClick(x) {
          let k = this.chart.pointer?.normalize(x) || x, A = this.to - this.from, $ = this.y + this.scrollbarTop, j = this.x + this.scrollbarLeft;
          this.options.vertical && k.chartY > $ || !this.options.vertical && k.chartX > j ? this.updatePosition(this.from + A, this.to + A) : this.updatePosition(this.from - A, this.to - A), g(this, "changed", { from: this.from, to: this.to, trigger: "scrollbar", DOMEvent: x });
        }
        update(x) {
          this.destroy(), this.init(this.chart.renderer, v(!0, this.options, x), this.chart);
        }
        updatePosition(x, k) {
          k > 1 && (x = u(1 - u(k - x)), k = 1), x < 0 && (k = u(k - x), x = 0), this.from = x, this.to = k;
        }
      }
      return S.defaultOptions = s, d.scrollbar = v(!0, S.defaultOptions, d.scrollbar), S;
    }), i(n, "Stock/Navigator/Navigator.js", [n["Core/Axis/Axis.js"], n["Stock/Navigator/ChartNavigatorComposition.js"], n["Core/Defaults.js"], n["Core/Globals.js"], n["Core/Axis/NavigatorAxisComposition.js"], n["Stock/Navigator/NavigatorComposition.js"], n["Stock/Scrollbar/Scrollbar.js"], n["Core/Renderer/SVG/SVGRenderer.js"], n["Core/Utilities.js"]], function(o, a, r, s, l, d, y, u, m) {
      let { defaultOptions: h } = r, { isTouchDevice: c } = s, { prototype: { symbols: g } } = u, { addEvent: v, clamp: P, correctFloat: f, defined: S, destroyObjectProperties: w, erase: x, extend: k, find: A, fireEvent: $, isArray: j, isNumber: N, merge: M, pick: D, removeEvent: C, splat: b } = m;
      function p(B, ...T) {
        let O = [].filter.call(T, N);
        if (O.length)
          return Math[B].apply(0, O);
      }
      class L {
        static compose(T, O, I) {
          a.compose(T, L), d.compose(T, O, I);
        }
        constructor(T) {
          this.isDirty = !1, this.scrollbarHeight = 0, this.init(T);
        }
        drawHandle(T, O, I, R) {
          let Y = this.navigatorOptions.handles.height;
          this.handles[O][R](I ? { translateX: Math.round(this.left + this.height / 2), translateY: Math.round(this.top + parseInt(T, 10) + 0.5 - Y) } : { translateX: Math.round(this.left + parseInt(T, 10)), translateY: Math.round(this.top + this.height / 2 - Y / 2 - 1) });
        }
        drawOutline(T, O, I, R) {
          let Y = this.navigatorOptions.maskInside, F = this.outline.strokeWidth(), U = F / 2, Q = F % 2 / 2, J = this.scrollButtonSize, ee = this.size, V = this.top, G = this.height, W = V - U, ae = V + G, z = this.left, q, Z;
          I ? (q = V + O + Q, O = V + T + Q, Z = [["M", z + G, V - J - Q], ["L", z + G, q], ["L", z, q], ["M", z, O], ["L", z + G, O], ["L", z + G, V + ee + J]], Y && Z.push(["M", z + G, q - U], ["L", z + G, O + U])) : (z -= J, T += z + J - Q, O += z + J - Q, Z = [["M", z, W], ["L", T, W], ["L", T, ae], ["M", O, ae], ["L", O, W], ["L", z + ee + 2 * J, W]], Y && Z.push(["M", T - U, W], ["L", O + U, W])), this.outline[R]({ d: Z });
        }
        drawMasks(T, O, I, R) {
          let Y, F, U, Q, J = this.left, ee = this.top, V = this.height;
          I ? (U = [J, J, J], Q = [ee, ee + T, ee + O], F = [V, V, V], Y = [T, O - T, this.size - O]) : (U = [J, J + T, J + O], Q = [ee, ee, ee], F = [T, O - T, this.size - O], Y = [V, V, V]), this.shades.forEach((G, W) => {
            G[R]({ x: U[W], y: Q[W], width: F[W], height: Y[W] });
          });
        }
        renderElements() {
          let T = this, O = T.navigatorOptions, I = O.maskInside, R = T.chart, Y = R.inverted, F = R.renderer, U = { cursor: Y ? "ns-resize" : "ew-resize" }, Q = T.navigatorGroup ?? (T.navigatorGroup = F.g("navigator").attr({ zIndex: 8, visibility: "hidden" }).add());
          if ([!I, I, !I].forEach((J, ee) => {
            let V = T.shades[ee] ?? (T.shades[ee] = F.rect().addClass("highcharts-navigator-mask" + (ee === 1 ? "-inside" : "-outside")).add(Q));
            R.styledMode || (V.attr({ fill: J ? O.maskFill : "rgba(0,0,0,0)" }), ee === 1 && V.css(U));
          }), T.outline || (T.outline = F.path().addClass("highcharts-navigator-outline").add(Q)), R.styledMode || T.outline.attr({ "stroke-width": O.outlineWidth, stroke: O.outlineColor }), O.handles?.enabled) {
            let J = O.handles, { height: ee, width: V } = J;
            [0, 1].forEach((G) => {
              let W = J.symbols[G];
              if (T.handles[G] && T.handles[G].symbolUrl === W) {
                if (!T.handles[G].isImg && T.handles[G].symbolName !== W) {
                  let ae = g[W].call(g, -V / 2 - 1, 0, V, ee);
                  T.handles[G].attr({ d: ae }), T.handles[G].symbolName = W;
                }
              } else
                T.handles[G]?.destroy(), T.handles[G] = F.symbol(W, -V / 2 - 1, 0, V, ee, J), T.handles[G].attr({ zIndex: 7 - G }).addClass("highcharts-navigator-handle highcharts-navigator-handle-" + ["left", "right"][G]).add(Q), T.addMouseEvents();
              R.inverted && T.handles[G].attr({ rotation: 90, rotationOriginX: Math.floor(-V / 2), rotationOriginY: (ee + V) / 2 }), R.styledMode || T.handles[G].attr({ fill: J.backgroundColor, stroke: J.borderColor, "stroke-width": J.lineWidth, width: J.width, height: J.height, x: -V / 2 - 1, y: 0 }).css(U);
            });
          }
        }
        update(T, O = !1) {
          let I = this.chart, R = I.options.chart.inverted !== I.scrollbar?.options.vertical;
          if (M(!0, I.options.navigator, T), this.navigatorOptions = I.options.navigator || {}, this.setOpposite(), S(T.enabled) || R)
            return this.destroy(), this.navigatorEnabled = T.enabled || this.navigatorEnabled, this.init(I);
          if (this.navigatorEnabled && (this.isDirty = !0, T.adaptToUpdatedData === !1 && this.baseSeries.forEach((Y) => {
            C(Y, "updatedData", this.updatedDataHandler);
          }, this), T.adaptToUpdatedData && this.baseSeries.forEach((Y) => {
            Y.eventsToUnbind.push(v(Y, "updatedData", this.updatedDataHandler));
          }, this), (T.series || T.baseSeries) && this.setBaseSeries(void 0, !1), T.height || T.xAxis || T.yAxis)) {
            this.height = T.height ?? this.height;
            let Y = this.getXAxisOffsets();
            this.xAxis.update({ ...T.xAxis, offsets: Y, [I.inverted ? "width" : "height"]: this.height, [I.inverted ? "height" : "width"]: void 0 }, !1), this.yAxis.update({ ...T.yAxis, [I.inverted ? "width" : "height"]: this.height }, !1);
          }
          O && I.redraw();
        }
        render(T, O, I, R) {
          let Y = this.chart, F = this.xAxis, U = F.pointRange || 0, Q = F.navigatorAxis.fake ? Y.xAxis[0] : F, J = this.navigatorEnabled, ee = this.rendered, V = Y.inverted, G = Y.xAxis[0].minRange, W = Y.xAxis[0].options.maxRange, ae = this.scrollButtonSize, z, q, Z, ne = this.scrollbarHeight, ie, re;
          if (this.hasDragged && !S(I))
            return;
          if (this.isDirty && this.renderElements(), T = f(T - U / 2), O = f(O + U / 2), !N(T) || !N(O)) {
            if (!ee)
              return;
            I = 0, R = D(F.width, Q.width);
          }
          this.left = D(F.left, Y.plotLeft + ae + (V ? Y.plotWidth : 0));
          let de = this.size = ie = D(F.len, (V ? Y.plotHeight : Y.plotWidth) - 2 * ae);
          z = V ? ne : ie + 2 * ae, I = D(I, F.toPixels(T, !0)), R = D(R, F.toPixels(O, !0)), N(I) && Math.abs(I) !== 1 / 0 || (I = 0, R = z);
          let me = F.toValue(I, !0), ce = F.toValue(R, !0), pe = Math.abs(f(ce - me));
          pe < G ? this.grabbedLeft ? I = F.toPixels(ce - G - U, !0) : this.grabbedRight && (R = F.toPixels(me + G + U, !0)) : S(W) && f(pe - U) > W && (this.grabbedLeft ? I = F.toPixels(ce - W - U, !0) : this.grabbedRight && (R = F.toPixels(me + W + U, !0))), this.zoomedMax = P(Math.max(I, R), 0, de), this.zoomedMin = P(this.fixedWidth ? this.zoomedMax - this.fixedWidth : Math.min(I, R), 0, de), this.range = this.zoomedMax - this.zoomedMin, de = Math.round(this.zoomedMax);
          let xe = Math.round(this.zoomedMin);
          J && (this.navigatorGroup.attr({ visibility: "inherit" }), re = ee && !this.hasDragged ? "animate" : "attr", this.drawMasks(xe, de, V, re), this.drawOutline(xe, de, V, re), this.navigatorOptions.handles.enabled && (this.drawHandle(xe, 0, V, re), this.drawHandle(de, 1, V, re))), this.scrollbar && (V ? (Z = this.top - ae, q = this.left - ne + (J || !Q.opposite ? 0 : (Q.titleOffset || 0) + Q.axisTitleMargin), ne = ie + 2 * ae) : (Z = this.top + (J ? this.height : -ne), q = this.left - ae), this.scrollbar.position(q, Z, z, ne), this.scrollbar.setRange(this.zoomedMin / (ie || 1), this.zoomedMax / (ie || 1))), this.rendered = !0, this.isDirty = !1, $(this, "afterRender");
        }
        addMouseEvents() {
          let T = this, O = T.chart, I = O.container, R = [], Y, F;
          T.mouseMoveHandler = Y = function(U) {
            T.onMouseMove(U);
          }, T.mouseUpHandler = F = function(U) {
            T.onMouseUp(U);
          }, (R = T.getPartsEvents("mousedown")).push(v(O.renderTo, "mousemove", Y), v(I.ownerDocument, "mouseup", F), v(O.renderTo, "touchmove", Y), v(I.ownerDocument, "touchend", F)), R.concat(T.getPartsEvents("touchstart")), T.eventsToUnbind = R, T.series && T.series[0] && R.push(v(T.series[0].xAxis, "foundExtremes", function() {
            O.navigator.modifyNavigatorAxisExtremes();
          }));
        }
        getPartsEvents(T) {
          let O = this, I = [];
          return ["shades", "handles"].forEach(function(R) {
            O[R].forEach(function(Y, F) {
              I.push(v(Y.element, T, function(U) {
                O[R + "Mousedown"](U, F);
              }));
            });
          }), I;
        }
        shadesMousedown(T, O) {
          T = this.chart.pointer?.normalize(T) || T;
          let I = this.chart, R = this.xAxis, Y = this.zoomedMin, F = this.size, U = this.range, Q = this.left, J = T.chartX, ee, V, G, W;
          I.inverted && (J = T.chartY, Q = this.top), O === 1 ? (this.grabbedCenter = J, this.fixedWidth = U, this.dragOffset = J - Y) : (W = J - Q - U / 2, O === 0 ? W = Math.max(0, W) : O === 2 && W + U >= F && (W = F - U, this.reversedExtremes ? (W -= U, V = this.getUnionExtremes().dataMin) : ee = this.getUnionExtremes().dataMax), W !== Y && (this.fixedWidth = U, S((G = R.navigatorAxis.toFixedRange(W, W + U, V, ee)).min) && $(this, "setRange", { min: Math.min(G.min, G.max), max: Math.max(G.min, G.max), redraw: !0, eventArguments: { trigger: "navigator" } })));
        }
        handlesMousedown(T, O) {
          T = this.chart.pointer?.normalize(T) || T;
          let I = this.chart, R = I.xAxis[0], Y = this.reversedExtremes;
          O === 0 ? (this.grabbedLeft = !0, this.otherHandlePos = this.zoomedMax, this.fixedExtreme = Y ? R.min : R.max) : (this.grabbedRight = !0, this.otherHandlePos = this.zoomedMin, this.fixedExtreme = Y ? R.max : R.min), I.setFixedRange(void 0);
        }
        onMouseMove(T) {
          let O = this, I = O.chart, R = O.navigatorSize, Y = O.range, F = O.dragOffset, U = I.inverted, Q = O.left, J;
          (!T.touches || T.touches[0].pageX !== 0) && (J = (T = I.pointer?.normalize(T) || T).chartX, U && (Q = O.top, J = T.chartY), O.grabbedLeft ? (O.hasDragged = !0, O.render(0, 0, J - Q, O.otherHandlePos)) : O.grabbedRight ? (O.hasDragged = !0, O.render(0, 0, O.otherHandlePos, J - Q)) : O.grabbedCenter && (O.hasDragged = !0, J < F ? J = F : J > R + F - Y && (J = R + F - Y), O.render(0, 0, J - F, J - F + Y)), O.hasDragged && O.scrollbar && D(O.scrollbar.options.liveRedraw, !c && !this.chart.boosted) && (T.DOMType = T.type, setTimeout(function() {
            O.onMouseUp(T);
          }, 0)));
        }
        onMouseUp(T) {
          let O, I, R, Y, F, U, Q = this.chart, J = this.xAxis, ee = this.scrollbar, V = T.DOMEvent || T, G = Q.inverted, W = this.rendered && !this.hasDragged ? "animate" : "attr";
          (this.hasDragged && (!ee || !ee.hasDragged) || T.trigger === "scrollbar") && (R = this.getUnionExtremes(), this.zoomedMin === this.otherHandlePos ? Y = this.fixedExtreme : this.zoomedMax === this.otherHandlePos && (F = this.fixedExtreme), this.zoomedMax === this.size && (F = this.reversedExtremes ? R.dataMin : R.dataMax), this.zoomedMin === 0 && (Y = this.reversedExtremes ? R.dataMax : R.dataMin), S((U = J.navigatorAxis.toFixedRange(this.zoomedMin, this.zoomedMax, Y, F)).min) && $(this, "setRange", { min: Math.min(U.min, U.max), max: Math.max(U.min, U.max), redraw: !0, animation: !this.hasDragged && null, eventArguments: { trigger: "navigator", triggerOp: "navigator-drag", DOMEvent: V } })), T.DOMType !== "mousemove" && T.DOMType !== "touchmove" && (this.grabbedLeft = this.grabbedRight = this.grabbedCenter = this.fixedWidth = this.fixedExtreme = this.otherHandlePos = this.hasDragged = this.dragOffset = null), this.navigatorEnabled && N(this.zoomedMin) && N(this.zoomedMax) && (I = Math.round(this.zoomedMin), O = Math.round(this.zoomedMax), this.shades && this.drawMasks(I, O, G, W), this.outline && this.drawOutline(I, O, G, W), this.navigatorOptions.handles.enabled && Object.keys(this.handles).length === this.handles.length && (this.drawHandle(I, 0, G, W), this.drawHandle(O, 1, G, W)));
        }
        removeEvents() {
          this.eventsToUnbind && (this.eventsToUnbind.forEach(function(T) {
            T();
          }), this.eventsToUnbind = void 0), this.removeBaseSeriesEvents();
        }
        removeBaseSeriesEvents() {
          let T = this.baseSeries || [];
          this.navigatorEnabled && T[0] && (this.navigatorOptions.adaptToUpdatedData !== !1 && T.forEach(function(O) {
            C(O, "updatedData", this.updatedDataHandler);
          }, this), T[0].xAxis && C(T[0].xAxis, "foundExtremes", this.modifyBaseAxisExtremes));
        }
        getXAxisOffsets() {
          return this.chart.inverted ? [this.scrollButtonSize, 0, -this.scrollButtonSize, 0] : [0, -this.scrollButtonSize, 0, this.scrollButtonSize];
        }
        init(T) {
          let O = T.options, I = O.navigator || {}, R = I.enabled, Y = O.scrollbar || {}, F = Y.enabled, U = R && I.height || 0, Q = F && Y.height || 0, J = Y.buttonsEnabled && Q || 0;
          this.handles = [], this.shades = [], this.chart = T, this.setBaseSeries(), this.height = U, this.scrollbarHeight = Q, this.scrollButtonSize = J, this.scrollbarEnabled = F, this.navigatorEnabled = R, this.navigatorOptions = I, this.scrollbarOptions = Y, this.setOpposite();
          let ee = this, V = ee.baseSeries, G = T.xAxis.length, W = T.yAxis.length, ae = V && V[0] && V[0].xAxis || T.xAxis[0] || { options: {} };
          if (T.isDirtyBox = !0, ee.navigatorEnabled) {
            let z = this.getXAxisOffsets();
            ee.xAxis = new o(T, M({ breaks: ae.options.breaks, ordinal: ae.options.ordinal, overscroll: ae.options.overscroll }, I.xAxis, { type: "datetime", yAxis: I.yAxis?.id, index: G, isInternal: !0, offset: 0, keepOrdinalPadding: !0, startOnTick: !1, endOnTick: !1, minPadding: ae.options.ordinal ? 0 : ae.options.minPadding, maxPadding: ae.options.ordinal ? 0 : ae.options.maxPadding, zoomEnabled: !1 }, T.inverted ? { offsets: z, width: U } : { offsets: z, height: U }), "xAxis"), ee.yAxis = new o(T, M(I.yAxis, { alignTicks: !1, offset: 0, index: W, isInternal: !0, reversed: D(I.yAxis && I.yAxis.reversed, T.yAxis[0] && T.yAxis[0].reversed, !1), zoomEnabled: !1 }, T.inverted ? { width: U } : { height: U }), "yAxis"), V || I.series.data ? ee.updateNavigatorSeries(!1) : T.series.length === 0 && (ee.unbindRedraw = v(T, "beforeRedraw", function() {
              T.series.length > 0 && !ee.series && (ee.setBaseSeries(), ee.unbindRedraw());
            })), ee.reversedExtremes = T.inverted && !ee.xAxis.reversed || !T.inverted && ee.xAxis.reversed, ee.renderElements(), ee.addMouseEvents();
          } else
            ee.xAxis = { chart: T, navigatorAxis: { fake: !0 }, translate: function(z, q) {
              let Z = T.xAxis[0], ne = Z.getExtremes(), ie = Z.len - 2 * J, re = p("min", Z.options.min, ne.dataMin), de = p("max", Z.options.max, ne.dataMax) - re;
              return q ? z * de / ie + re : ie * (z - re) / de;
            }, toPixels: function(z) {
              return this.translate(z);
            }, toValue: function(z) {
              return this.translate(z, !0);
            } }, ee.xAxis.navigatorAxis.axis = ee.xAxis, ee.xAxis.navigatorAxis.toFixedRange = l.prototype.toFixedRange.bind(ee.xAxis.navigatorAxis);
          if (T.options.scrollbar.enabled) {
            let z = M(T.options.scrollbar, { vertical: T.inverted });
            !N(z.margin) && ee.navigatorEnabled && (z.margin = T.inverted ? -3 : 3), T.scrollbar = ee.scrollbar = new y(T.renderer, z, T), v(ee.scrollbar, "changed", function(q) {
              let Z = ee.size, ne = Z * this.to, ie = Z * this.from;
              ee.hasDragged = ee.scrollbar.hasDragged, ee.render(0, 0, ie, ne), this.shouldUpdateExtremes(q.DOMType) && setTimeout(function() {
                ee.onMouseUp(q);
              });
            });
          }
          ee.addBaseSeriesEvents(), ee.addChartEvents();
        }
        setOpposite() {
          let T = this.navigatorOptions, O = this.navigatorEnabled, I = this.chart;
          this.opposite = D(T.opposite, !!(!O && I.inverted));
        }
        getUnionExtremes(T) {
          let O, I = this.chart.xAxis[0], R = this.xAxis, Y = R.options, F = I.options;
          return T && I.dataMin === null || (O = { dataMin: D(Y && Y.min, p("min", F.min, I.dataMin, R.dataMin, R.min)), dataMax: D(Y && Y.max, p("max", F.max, I.dataMax, R.dataMax, R.max)) }), O;
        }
        setBaseSeries(T, O) {
          let I = this.chart, R = this.baseSeries = [];
          T = T || I.options && I.options.navigator.baseSeries || (I.series.length ? A(I.series, (Y) => !Y.options.isInternal).index : 0), (I.series || []).forEach((Y, F) => {
            !Y.options.isInternal && (Y.options.showInNavigator || (F === T || Y.options.id === T) && Y.options.showInNavigator !== !1) && R.push(Y);
          }), this.xAxis && !this.xAxis.navigatorAxis.fake && this.updateNavigatorSeries(!0, O);
        }
        updateNavigatorSeries(T, O) {
          let I = this, R = I.chart, Y = I.baseSeries, F = { enableMouseTracking: !1, index: null, linkedTo: null, group: "nav", padXAxis: !1, xAxis: this.navigatorOptions.xAxis?.id, yAxis: this.navigatorOptions.yAxis?.id, showInLegend: !1, stacking: void 0, isInternal: !0, states: { inactive: { opacity: 1 } } }, U = I.series = (I.series || []).filter((G) => {
            let W = G.baseSeries;
            return !(0 > Y.indexOf(W)) || (W && (C(W, "updatedData", I.updatedDataHandler), delete W.navigatorSeries), G.chart && G.destroy(), !1);
          }), Q, J, ee = I.navigatorOptions.series, V;
          Y && Y.length && Y.forEach((G) => {
            let W = G.navigatorSeries, ae = k({ color: G.color, visible: G.visible }, j(ee) ? h.navigator.series : ee);
            if (W && I.navigatorOptions.adaptToUpdatedData === !1)
              return;
            F.name = "Navigator " + Y.length, V = (Q = G.options || {}).navigatorOptions || {}, ae.dataLabels = b(ae.dataLabels), (J = M(Q, F, ae, V)).pointRange = D(ae.pointRange, V.pointRange, h.plotOptions[J.type || "line"].pointRange);
            let z = V.data || ae.data;
            I.hasNavigatorData = I.hasNavigatorData || !!z, J.data = z || Q.data && Q.data.slice(0), W && W.options ? W.update(J, O) : (G.navigatorSeries = R.initSeries(J), R.setSortedData(), G.navigatorSeries.baseSeries = G, U.push(G.navigatorSeries));
          }), (ee.data && !(Y && Y.length) || j(ee)) && (I.hasNavigatorData = !1, (ee = b(ee)).forEach((G, W) => {
            F.name = "Navigator " + (U.length + 1), (J = M(h.navigator.series, { color: R.series[W] && !R.series[W].options.isInternal && R.series[W].color || R.options.colors[W] || R.options.colors[0] }, F, G)).data = G.data, J.data && (I.hasNavigatorData = !0, U.push(R.initSeries(J)));
          })), T && this.addBaseSeriesEvents();
        }
        addBaseSeriesEvents() {
          let T = this, O = T.baseSeries || [];
          O[0] && O[0].xAxis && O[0].eventsToUnbind.push(v(O[0].xAxis, "foundExtremes", this.modifyBaseAxisExtremes)), O.forEach((I) => {
            I.eventsToUnbind.push(v(I, "show", function() {
              this.navigatorSeries && this.navigatorSeries.setVisible(!0, !1);
            })), I.eventsToUnbind.push(v(I, "hide", function() {
              this.navigatorSeries && this.navigatorSeries.setVisible(!1, !1);
            })), this.navigatorOptions.adaptToUpdatedData !== !1 && I.xAxis && I.eventsToUnbind.push(v(I, "updatedData", this.updatedDataHandler)), I.eventsToUnbind.push(v(I, "remove", function() {
              O && x(O, I), this.navigatorSeries && (x(T.series, this.navigatorSeries), S(this.navigatorSeries.options) && this.navigatorSeries.remove(!1), delete this.navigatorSeries);
            }));
          });
        }
        getBaseSeriesMin(T) {
          return this.baseSeries.reduce(function(O, I) {
            return Math.min(O, I.xData && I.xData.length ? I.xData[0] : O);
          }, T);
        }
        modifyNavigatorAxisExtremes() {
          let T = this.xAxis;
          if (T.getExtremes !== void 0) {
            let O = this.getUnionExtremes(!0);
            O && (O.dataMin !== T.min || O.dataMax !== T.max) && (T.min = O.dataMin, T.max = O.dataMax);
          }
        }
        modifyBaseAxisExtremes() {
          let T, O, I = this.chart.navigator, R = this.getExtremes(), Y = R.min, F = R.max, U = R.dataMin, Q = R.dataMax, J = F - Y, ee = I.stickToMin, V = I.stickToMax, G = D(this.ordinal?.convertOverscroll(this.options.overscroll), 0), W = I.series && I.series[0], ae = !!this.setExtremes;
          !(this.eventArgs && this.eventArgs.trigger === "rangeSelectorButton") && (ee && (T = (O = U) + J), V && (T = Q + G, ee || (O = Math.max(U, T - J, I.getBaseSeriesMin(W && W.xData ? W.xData[0] : -Number.MAX_VALUE)))), ae && (ee || V) && N(O) && (this.min = this.userMin = O, this.max = this.userMax = T)), I.stickToMin = I.stickToMax = null;
        }
        updatedDataHandler() {
          let T = this.chart.navigator, O = this.navigatorSeries, I = T.reversedExtremes ? Math.round(T.zoomedMin) === 0 : Math.round(T.zoomedMax) >= Math.round(T.size);
          T.stickToMax = D(this.chart.options.navigator && this.chart.options.navigator.stickToMax, I), T.stickToMin = T.shouldStickToMin(this, T), O && !T.hasNavigatorData && (O.options.pointStart = this.xData[0], O.setData(this.options.data, !1, null, !1));
        }
        shouldStickToMin(T, O) {
          let I = O.getBaseSeriesMin(T.xData[0]), R = T.xAxis, Y = R.max, F = R.min, U = R.options.range;
          return !!(N(Y) && N(F)) && (U && Y - I > 0 ? Y - I < U : F <= I);
        }
        addChartEvents() {
          this.eventsToUnbind || (this.eventsToUnbind = []), this.eventsToUnbind.push(v(this.chart, "redraw", function() {
            let T = this.navigator, O = T && (T.baseSeries && T.baseSeries[0] && T.baseSeries[0].xAxis || this.xAxis[0]);
            O && T.render(O.min, O.max);
          }), v(this.chart, "getMargins", function() {
            let T = this.navigator, O = T.opposite ? "plotTop" : "marginBottom";
            this.inverted && (O = T.opposite ? "marginRight" : "plotLeft"), this[O] = (this[O] || 0) + (T.navigatorEnabled || !this.inverted ? T.height + T.scrollbarHeight : 0) + T.navigatorOptions.margin;
          }), v(L, "setRange", function(T) {
            this.chart.xAxis[0].setExtremes(T.min, T.max, T.redraw, T.animation, T.eventArguments);
          }));
        }
        destroy() {
          this.removeEvents(), this.xAxis && (x(this.chart.xAxis, this.xAxis), x(this.chart.axes, this.xAxis)), this.yAxis && (x(this.chart.yAxis, this.yAxis), x(this.chart.axes, this.yAxis)), (this.series || []).forEach((T) => {
            T.destroy && T.destroy();
          }), ["series", "xAxis", "yAxis", "shades", "outline", "scrollbarTrack", "scrollbarRifles", "scrollbarGroup", "scrollbar", "navigatorGroup", "rendered"].forEach((T) => {
            this[T] && this[T].destroy && this[T].destroy(), this[T] = null;
          }), [this.handles].forEach((T) => {
            w(T);
          }), this.navigatorEnabled = !1;
        }
      }
      return L;
    }), i(n, "Core/Axis/OrdinalAxis.js", [n["Core/Axis/Axis.js"], n["Core/Globals.js"], n["Core/Series/Series.js"], n["Core/Utilities.js"]], function(o, a, r, s) {
      var l;
      let { addEvent: d, correctFloat: y, css: u, defined: m, error: h, isNumber: c, pick: g, timeUnits: v, isString: P } = s;
      return function(f) {
        function S(p, L, B, T, O = [], I = 0, R) {
          let Y = {}, F = this.options.tickPixelInterval, U = this.chart.time, Q = [], J, ee, V, G, W, ae = 0, z = [], q = -Number.MAX_VALUE;
          if (!this.options.ordinal && !this.options.breaks || !O || O.length < 3 || L === void 0)
            return U.getTimeTicks.apply(U, arguments);
          let Z = O.length;
          for (J = 0; J < Z; J++) {
            if (W = J && O[J - 1] > B, O[J] < L && (ae = J), J === Z - 1 || O[J + 1] - O[J] > 5 * I || W) {
              if (O[J] > q) {
                for (ee = U.getTimeTicks(p, O[ae], O[J], T); ee.length && ee[0] <= q; )
                  ee.shift();
                ee.length && (q = ee[ee.length - 1]), Q.push(z.length), z = z.concat(ee);
              }
              ae = J + 1;
            }
            if (W)
              break;
          }
          if (ee) {
            if (G = ee.info, R && G.unitRange <= v.hour) {
              for (ae = 1, J = z.length - 1; ae < J; ae++)
                U.dateFormat("%d", z[ae]) !== U.dateFormat("%d", z[ae - 1]) && (Y[z[ae]] = "day", V = !0);
              V && (Y[z[0]] = "day"), G.higherRanks = Y;
            }
            G.segmentStarts = Q, z.info = G;
          } else
            h(12, !1, this.chart);
          if (R && m(F)) {
            let ne = z.length, ie = [], re = [], de, me, ce, pe, xe, le = ne;
            for (; le--; )
              me = this.translate(z[le]), ce && (re[le] = ce - me), ie[le] = ce = me;
            for (re.sort((se, he) => se - he), (pe = re[Math.floor(re.length / 2)]) < 0.6 * F && (pe = null), le = z[ne - 1] > B ? ne - 1 : ne, ce = void 0; le--; )
              xe = Math.abs(ce - (me = ie[le])), ce && xe < 0.8 * F && (pe === null || xe < 0.8 * pe) ? (Y[z[le]] && !Y[z[le + 1]] ? (de = le + 1, ce = me) : de = le, z.splice(de, 1)) : ce = me;
          }
          return z;
        }
        function w(p) {
          let L = this.ordinal.positions;
          if (!L)
            return p;
          let B = L.length - 1, T;
          return p < 0 ? p = L[0] : p > B ? p = L[B] : (B = Math.floor(p), T = p - B), T !== void 0 && L[B] !== void 0 ? L[B] + (T ? T * (L[B + 1] - L[B]) : 0) : p;
        }
        function x(p) {
          let L = this.ordinal, B = this.old ? this.old.min : this.min, T = this.old ? this.old.transA : this.transA, O = L.getExtendedPositions();
          if (O && O.length) {
            let I = y((p - B) * T + this.minPixelPadding), R = y(L.getIndexOfPoint(I, O)), Y = y(R % 1);
            if (R >= 0 && R <= O.length - 1) {
              let F = O[Math.floor(R)], U = O[Math.ceil(R)];
              return O[Math.floor(R)] + Y * (U - F);
            }
          }
          return p;
        }
        function k(p, L) {
          let B = f.Additions.findIndexOf(p, L, !0);
          if (p[B] === L)
            return B;
          let T = (L - p[B]) / (p[B + 1] - p[B]);
          return B + T;
        }
        function A() {
          this.ordinal || (this.ordinal = new f.Additions(this));
        }
        function $() {
          let { eventArgs: p, options: L } = this;
          if (this.isXAxis && m(L.overscroll) && L.overscroll !== 0 && c(this.max) && c(this.min) && (this.options.ordinal && !this.ordinal.originalOrdinalRange && this.ordinal.getExtendedPositions(!1), this.max === this.dataMax && (p?.trigger !== "pan" || this.isInternal) && p?.trigger !== "navigator")) {
            let B = this.ordinal.convertOverscroll(L.overscroll);
            this.max += B, !this.isInternal && m(this.userMin) && p?.trigger !== "mousewheel" && (this.min += B);
          }
        }
        function j() {
          this.horiz && !this.isDirty && (this.isDirty = this.isOrdinal && this.chart.navigator && !this.chart.navigator.adaptToUpdatedData);
        }
        function N() {
          this.ordinal && (this.ordinal.beforeSetTickPositions(), this.tickInterval = this.ordinal.postProcessTickInterval(this.tickInterval));
        }
        function M(p) {
          let L = this.xAxis[0], B = L.ordinal.convertOverscroll(L.options.overscroll), T = p.originalEvent.chartX, O = this.options.chart.panning, I = !1;
          if (O && O.type !== "y" && L.options.ordinal && L.series.length && (!p.touches || p.touches.length <= 1)) {
            let R, Y, F = this.mouseDownX, U = L.getExtremes(), Q = U.dataMin, J = U.dataMax, ee = U.min, V = U.max, G = this.hoverPoints, W = L.closestPointRange || L.ordinal && L.ordinal.overscrollPointsRange, ae = Math.round((F - T) / (L.translationSlope * (L.ordinal.slope || W))), z = L.ordinal.getExtendedPositions(), q = { ordinal: { positions: z, extendedOrdinalPositions: z } }, Z = L.index2val, ne = L.val2lin;
            if (ee <= Q && ae < 0 || V + B >= J && ae > 0)
              return;
            q.ordinal.positions ? Math.abs(ae) > 1 && (G && G.forEach(function(ie) {
              ie.setState();
            }), J > (Y = q.ordinal.positions)[Y.length - 1] && Y.push(J), this.setFixedRange(V - ee), (R = L.navigatorAxis.toFixedRange(void 0, void 0, Z.apply(q, [ne.apply(q, [ee, !0]) + ae]), Z.apply(q, [ne.apply(q, [V, !0]) + ae]))).min >= Math.min(U.dataMin, ee) && R.max <= Math.max(J, V) + B && L.setExtremes(R.min, R.max, !0, !1, { trigger: "pan" }), this.mouseDownX = T, u(this.container, { cursor: "move" })) : I = !0;
          } else
            I = !0;
          I || O && /y/.test(O.type) ? B && (L.max = L.dataMax + B) : p.preventDefault();
        }
        function D() {
          let p = this.xAxis;
          p && p.options.ordinal && (delete p.ordinal.index, delete p.ordinal.originalOrdinalRange);
        }
        function C(p, L) {
          let B, T = this.ordinal, O = T.positions, I = T.slope, R;
          if (!O)
            return p;
          let Y = O.length;
          if (O[0] <= p && O[Y - 1] >= p)
            B = k(O, p);
          else {
            if (!((R = T.getExtendedPositions && T.getExtendedPositions()) && R.length))
              return p;
            let F = R.length;
            I || (I = (R[F - 1] - R[0]) / F);
            let U = k(R, O[0]);
            if (p >= R[0] && p <= R[F - 1])
              B = k(R, p) - U;
            else {
              if (!L)
                return p;
              B = p < R[0] ? -U - (R[0] - p) / I : (p - R[F - 1]) / I + F - U;
            }
          }
          return L ? B : I * (B || 0) + T.offset;
        }
        f.compose = function(p, L, B) {
          let T = p.prototype;
          return T.ordinal2lin || (T.getTimeTicks = S, T.index2val = w, T.lin2val = x, T.val2lin = C, T.ordinal2lin = T.val2lin, d(p, "afterInit", A), d(p, "foundExtremes", $), d(p, "afterSetScale", j), d(p, "initialAxisTranslation", N), d(B, "pan", M), d(B, "touchpan", M), d(L, "updatedData", D)), p;
        };
        class b {
          constructor(L) {
            this.index = {}, this.axis = L;
          }
          beforeSetTickPositions() {
            let L = this.axis, B = L.ordinal, T = L.getExtremes(), O = T.min, I = T.max, R = L.brokenAxis?.hasBreaks, Y = L.options.ordinal, F, U, Q, J, ee, V, G, W = [], ae = Number.MAX_VALUE, z = !1, q = !1, Z = !1;
            if (Y || R) {
              let ne = 0;
              if (L.series.forEach(function(ie, re) {
                if (U = [], re > 0 && ie.options.id !== "highcharts-navigator-series" && ie.processedXData.length > 1 && (q = ne !== ie.processedXData[1] - ie.processedXData[0]), ne = ie.processedXData[1] - ie.processedXData[0], ie.boosted && (Z = ie.boosted), ie.reserveSpace() && (ie.takeOrdinalPosition !== !1 || R) && (F = (W = W.concat(ie.processedXData)).length, W.sort(function(de, me) {
                  return de - me;
                }), ae = Math.min(ae, g(ie.closestPointRange, ae)), F)) {
                  for (re = 0; re < F - 1; )
                    W[re] !== W[re + 1] && U.push(W[re + 1]), re++;
                  U[0] !== W[0] && U.unshift(W[0]), W = U;
                }
              }), L.ordinal.originalOrdinalRange || (L.ordinal.originalOrdinalRange = (W.length - 1) * ae), q && Z && (W.pop(), W.shift()), (F = W.length) > 2) {
                for (Q = W[1] - W[0], G = F - 1; G-- && !z; )
                  W[G + 1] - W[G] !== Q && (z = !0);
                !L.options.keepOrdinalPadding && (W[0] - O > Q || I - W[W.length - 1] > Q) && (z = !0);
              } else
                L.options.overscroll && (F === 2 ? ae = W[1] - W[0] : F === 1 ? (ae = L.ordinal.convertOverscroll(L.options.overscroll), W = [W[0], W[0] + ae]) : ae = B.overscrollPointsRange);
              z || L.forceOrdinal ? (L.options.overscroll && (B.overscrollPointsRange = ae, W = W.concat(B.getOverscrollPositions())), B.positions = W, J = L.ordinal2lin(Math.max(O, W[0]), !0), ee = Math.max(L.ordinal2lin(Math.min(I, W[W.length - 1]), !0), 1), B.slope = V = (I - O) / (ee - J), B.offset = O - J * V) : (B.overscrollPointsRange = g(L.closestPointRange, B.overscrollPointsRange), B.positions = L.ordinal.slope = B.offset = void 0);
            }
            L.isOrdinal = Y && z, B.groupIntervalFactor = null;
          }
          static findIndexOf(L, B, T) {
            let O = 0, I = L.length - 1, R;
            for (; O < I; )
              L[R = Math.ceil((O + I) / 2)] <= B ? O = R : I = R - 1;
            return L[O] === B || T ? O : -1;
          }
          getExtendedPositions(L = !0) {
            let B = this, T = B.axis, O = T.constructor.prototype, I = T.chart, R = T.series[0]?.currentDataGrouping, Y = R ? R.count + R.unitName : "raw", F = L ? T.ordinal.convertOverscroll(T.options.overscroll) : 0, U = T.getExtremes(), Q, J, ee = B.index;
            return ee || (ee = B.index = {}), ee[Y] || ((Q = { series: [], chart: I, forceOrdinal: !1, getExtremes: function() {
              return { min: U.dataMin, max: U.dataMax + F };
            }, applyGrouping: O.applyGrouping, getGroupPixelWidth: O.getGroupPixelWidth, getTimeTicks: O.getTimeTicks, options: { ordinal: !0 }, ordinal: { getGroupIntervalFactor: this.getGroupIntervalFactor }, ordinal2lin: O.ordinal2lin, getIndexOfPoint: O.getIndexOfPoint, val2lin: O.val2lin }).ordinal.axis = Q, T.series.forEach(function(V) {
              J = { xAxis: Q, xData: V.xData.slice(), chart: I, groupPixelWidth: V.groupPixelWidth, destroyGroupedData: a.noop, getProcessedData: r.prototype.getProcessedData, applyGrouping: r.prototype.applyGrouping, reserveSpace: r.prototype.reserveSpace, visible: V.visible }, L && (J.xData = J.xData.concat(B.getOverscrollPositions())), J.options = { dataGrouping: R ? { firstAnchor: V.options.dataGrouping?.firstAnchor, anchor: V.options.dataGrouping?.anchor, lastAnchor: V.options.dataGrouping?.firstAnchor, enabled: !0, forced: !0, approximation: "open", units: [[R.unitName, [R.count]]] } : { enabled: !1 } }, Q.series.push(J), V.processData.apply(J);
            }), Q.applyGrouping({ hasExtremesChanged: !0 }), J?.closestPointRange !== J?.basePointRange && J.currentDataGrouping && (Q.forceOrdinal = !0), T.ordinal.beforeSetTickPositions.apply({ axis: Q }), !T.ordinal.originalOrdinalRange && Q.ordinal.originalOrdinalRange && (T.ordinal.originalOrdinalRange = Q.ordinal.originalOrdinalRange), ee[Y] = Q.ordinal.positions), ee[Y];
          }
          getGroupIntervalFactor(L, B, T) {
            let O = T.processedXData, I = O.length, R = [], Y, F, U = this.groupIntervalFactor;
            if (!U) {
              for (F = 0; F < I - 1; F++)
                R[F] = O[F + 1] - O[F];
              R.sort(function(Q, J) {
                return Q - J;
              }), Y = R[Math.floor(I / 2)], L = Math.max(L, O[0]), B = Math.min(B, O[I - 1]), this.groupIntervalFactor = U = I * Y / (B - L);
            }
            return U;
          }
          getIndexOfPoint(L, B) {
            let T, O = this.axis, I = 0, R = function(U) {
              let { min: Q, max: J } = O;
              return !!(m(Q) && m(J)) && U.points.some((ee) => ee.x >= Q && ee.x <= J);
            };
            O.series.forEach((U) => {
              let Q = U.points?.[0];
              m(Q?.plotX) && (Q.plotX < T || !m(T)) && R(U) && (T = Q.plotX, I = Q.x);
            }), T ?? (T = O.minPixelPadding);
            let Y = O.translationSlope * (this.slope || O.closestPointRange || this.overscrollPointsRange), F = y((L - T) / Y);
            return b.findIndexOf(B, I, !0) + F;
          }
          getOverscrollPositions() {
            let L = this.axis, B = this.convertOverscroll(L.options.overscroll), T = this.overscrollPointsRange, O = [], I = L.dataMax;
            if (m(T))
              for (; I <= L.dataMax + B; )
                O.push(I += T);
            return O;
          }
          postProcessTickInterval(L) {
            let B = this.axis, T = this.slope;
            return T ? B.options.breaks ? B.closestPointRange || L : L / (T / B.closestPointRange) : L;
          }
          convertOverscroll(L = 0) {
            let B = this, T = B.axis, O = function(I) {
              return g(B.originalOrdinalRange, m(T.dataMax) && m(T.dataMin) ? T.dataMax - T.dataMin : 0) * I;
            };
            if (P(L)) {
              let I = parseInt(L, 10);
              if (/%$/.test(L))
                return O(I / 100);
              if (/px/.test(L)) {
                let R = Math.min(I, 0.9 * T.len) / T.len;
                return O(R / (1 - R));
              }
              return 0;
            }
            return L;
          }
        }
        f.Additions = b;
      }(l || (l = {})), l;
    }), i(n, "Stock/RangeSelector/RangeSelectorDefaults.js", [], function() {
      return { lang: { rangeSelectorZoom: "Zoom", rangeSelectorFrom: "", rangeSelectorTo: "→" }, rangeSelector: { allButtonsEnabled: !1, buttons: void 0, buttonSpacing: 5, dropdown: "responsive", enabled: void 0, verticalAlign: "top", buttonTheme: { width: 28, height: 18, padding: 2, zIndex: 7 }, floating: !1, x: 0, y: 0, height: void 0, inputBoxBorderColor: "none", inputBoxHeight: 17, inputBoxWidth: void 0, inputDateFormat: "%e %b %Y", inputDateParser: void 0, inputEditDateFormat: "%Y-%m-%d", inputEnabled: !0, inputPosition: { align: "right", x: 0, y: 0 }, inputSpacing: 5, selected: void 0, buttonPosition: { align: "left", x: 0, y: 0 }, inputStyle: { color: "#334eff", cursor: "pointer", fontSize: "0.8em" }, labelStyle: { color: "#666666", fontSize: "0.8em" } } };
    }), i(n, "Stock/RangeSelector/RangeSelectorComposition.js", [n["Core/Defaults.js"], n["Core/Globals.js"], n["Stock/RangeSelector/RangeSelectorDefaults.js"], n["Core/Utilities.js"]], function(o, a, r, s) {
      let l, { defaultOptions: d } = o, { composed: y } = a, { addEvent: u, defined: m, extend: h, isNumber: c, merge: g, pick: v, pushUnique: P } = s, f = [];
      function S() {
        let N, M, D = this.range, C = D.type, b = this.max, p = this.chart.time, L = function(T, O) {
          let I = C === "year" ? "FullYear" : "Month", R = new p.Date(T), Y = p.get(I, R);
          return p.set(I, R, Y + O), Y === p.get(I, R) && p.set("Date", R, 0), R.getTime() - T;
        };
        c(D) ? (N = b - D, M = D) : D && (N = b + L(b, -(D.count || 1)), this.chart && this.chart.setFixedRange(b - N));
        let B = v(this.dataMin, Number.MIN_VALUE);
        return c(N) || (N = B), N <= B && (N = B, M === void 0 && (M = L(N, D.count)), this.newMax = Math.min(N + M, v(this.dataMax, Number.MAX_VALUE))), c(b) ? !c(D) && D && D._offsetMin && (N += D._offsetMin) : N = void 0, N;
      }
      function w() {
        this.options.rangeSelector && this.options.rangeSelector.enabled && (this.rangeSelector = new l(this));
      }
      function x() {
        let N = this.rangeSelector;
        if (N) {
          c(N.deferredYTDClick) && (N.clickButton(N.deferredYTDClick), delete N.deferredYTDClick);
          let M = N.options.verticalAlign;
          N.options.floating || (M === "bottom" ? this.extraBottomMargin = !0 : M === "middle" || (this.extraTopMargin = !0));
        }
      }
      function k() {
        let N, M = this.rangeSelector;
        if (!M)
          return;
        let D = this.xAxis[0].getExtremes(), C = this.legend, b = M && M.options.verticalAlign;
        c(D.min) && M.render(D.min, D.max), C.display && b === "top" && b === C.options.verticalAlign && (N = g(this.spacingBox), C.options.layout === "vertical" ? N.y = this.plotTop : N.y += M.getHeight(), C.group.placed = !1, C.align(N));
      }
      function A() {
        for (let N = 0, M = f.length; N < M; ++N) {
          let D = f[N];
          if (D[0] === this) {
            D[1].forEach((C) => C()), f.splice(N, 1);
            return;
          }
        }
      }
      function $() {
        let N = this.rangeSelector;
        if (N) {
          let M = N.getHeight();
          this.extraTopMargin && (this.plotTop += M), this.extraBottomMargin && (this.marginBottom += M);
        }
      }
      function j(N) {
        let M = N.options.rangeSelector, D = this.extraBottomMargin, C = this.extraTopMargin, b = this.rangeSelector;
        if (M && M.enabled && !m(b) && this.options.rangeSelector && (this.options.rangeSelector.enabled = !0, this.rangeSelector = b = new l(this)), this.extraBottomMargin = !1, this.extraTopMargin = !1, b) {
          let p = M && M.verticalAlign || b.options && b.options.verticalAlign;
          b.options.floating || (p === "bottom" ? this.extraBottomMargin = !0 : p === "middle" || (this.extraTopMargin = !0)), (this.extraBottomMargin !== D || this.extraTopMargin !== C) && (this.isDirtyBox = !0);
        }
      }
      return { compose: function(N, M, D) {
        if (l = D, P(y, "RangeSelector")) {
          let C = M.prototype;
          N.prototype.minFromRange = S, u(M, "afterGetContainer", w), u(M, "beforeRender", x), u(M, "destroy", A), u(M, "getMargins", $), u(M, "redraw", k), u(M, "update", j), C.callbacks.push(k), h(d, { rangeSelector: r.rangeSelector }), h(d.lang, r.lang);
        }
      } };
    }), i(n, "Stock/RangeSelector/RangeSelector.js", [n["Core/Axis/Axis.js"], n["Core/Defaults.js"], n["Core/Globals.js"], n["Stock/RangeSelector/RangeSelectorComposition.js"], n["Core/Renderer/SVG/SVGElement.js"], n["Core/Utilities.js"], n["Core/Axis/OrdinalAxis.js"]], function(o, a, r, s, l, d, y) {
      let { defaultOptions: u } = a, { addEvent: m, createElement: h, css: c, defined: g, destroyObjectProperties: v, discardElement: P, extend: f, fireEvent: S, isNumber: w, merge: x, objectEach: k, pad: A, pick: $, pInt: j, splat: N } = d;
      class M {
        static compose(C, b) {
          s.compose(C, b, M);
        }
        constructor(C) {
          this.buttonOptions = M.prototype.defaultButtons, this.initialButtonGroupWidth = 0, this.init(C);
        }
        clickButton(C, b) {
          let p = this.chart, L = this.buttonOptions[C], B = p.xAxis[0], T = p.scroller && p.scroller.getUnionExtremes() || B || {}, O = L.type, I = L.dataGrouping, R = T.dataMin, Y = T.dataMax, F, U = B && Math.round(Math.min(B.max, $(Y, B.max))), Q, J = L._range, ee, V, G, W = !0;
          if (R !== null && Y !== null) {
            if (this.setSelected(C), I && (this.forcedDataGrouping = !0, o.prototype.setDataGrouping.call(B || { chart: this.chart }, I, !1), this.frozenStates = L.preserveDataGrouping), O === "month" || O === "year")
              B ? (V = { range: L, max: U, chart: p, dataMin: R, dataMax: Y }, F = B.minFromRange.call(V), w(V.newMax) && (U = V.newMax), W = !1) : J = L;
            else if (J)
              U = Math.min((F = Math.max(U - J, R)) + J, Y), W = !1;
            else if (O === "ytd")
              if (B)
                (Y === void 0 || R === void 0) && (R = Number.MAX_VALUE, Y = Number.MIN_VALUE, p.series.forEach((ae) => {
                  let z = ae.xData;
                  z && (R = Math.min(z[0], R), Y = Math.max(z[z.length - 1], Y));
                }), b = !1), F = ee = (G = this.getYTDExtremes(Y, R, p.time.useUTC)).min, U = G.max;
              else {
                this.deferredYTDClick = C;
                return;
              }
            else
              O === "all" && B && (p.navigator && p.navigator.baseSeries[0] && (p.navigator.baseSeries[0].xAxis.options.range = void 0), F = R, U = Y);
            if (W && L._offsetMin && g(F) && (F += L._offsetMin), L._offsetMax && g(U) && (U += L._offsetMax), this.dropdown && (this.dropdown.selectedIndex = C + 1), B)
              B.setExtremes(F, U, $(b, !0), void 0, { trigger: "rangeSelectorButton", rangeSelectorButton: L }), p.setFixedRange(L._range);
            else {
              Q = N(p.options.xAxis)[0];
              let ae = m(p, "afterGetAxes", function() {
                let z = p.xAxis[0];
                z.range = z.options.range = J, z.min = z.options.min = ee;
              });
              m(p, "load", function() {
                let z = p.xAxis[0];
                p.setFixedRange(L._range), z.options.range = Q.range, z.options.min = Q.min, ae();
              });
            }
            S(this, "afterBtnClick");
          }
        }
        setSelected(C) {
          this.selected = this.options.selected = C;
        }
        init(C) {
          let b = this, p = C.options.rangeSelector, L = p.buttons || b.defaultButtons.slice(), B = p.selected, T = function() {
            let O = b.minInput, I = b.maxInput;
            O && O.blur && S(O, "blur"), I && I.blur && S(I, "blur");
          };
          b.chart = C, b.options = p, b.buttons = [], b.buttonOptions = L, this.eventsToUnbind = [], this.eventsToUnbind.push(m(C.container, "mousedown", T)), this.eventsToUnbind.push(m(C, "resize", T)), L.forEach(b.computeButtonRange), B !== void 0 && L[B] && this.clickButton(B, !1), this.eventsToUnbind.push(m(C, "load", function() {
            C.xAxis && C.xAxis[0] && m(C.xAxis[0], "setExtremes", function(O) {
              w(this.max) && w(this.min) && this.max - this.min !== C.fixedRange && O.trigger !== "rangeSelectorButton" && O.trigger !== "updatedData" && b.forcedDataGrouping && !b.frozenStates && this.setDataGrouping(!1, !1);
            });
          })), this.createElements();
        }
        updateButtonStates() {
          let C = this, b = this.chart, p = this.dropdown, L = this.dropdownLabel, B = b.xAxis[0], T = Math.round(B.max - B.min), O = !B.hasVisibleSeries, I = 24 * 36e5, R = b.scroller && b.scroller.getUnionExtremes() || B, Y = R.dataMin, F = R.dataMax, U = C.getYTDExtremes(F, Y, b.time.useUTC), Q = U.min, J = U.max, ee = C.selected, V = C.options.allButtonsEnabled, G = Array(C.buttonOptions.length).fill(0), W = w(ee), ae = C.buttons, z = !1, q = null;
          C.buttonOptions.forEach((Z, ne) => {
            let ie = Z._range, re = Z.type, de = Z.count || 1, me = Z._offsetMax - Z._offsetMin, ce = ne === ee, pe = ie > F - Y, xe = ie < B.minRange, le = !1, se = ie === T;
            if (ce && pe && (z = !0), B.isOrdinal && B.ordinal?.positions && ie && T < ie) {
              let ye = B.ordinal.positions, be = y.Additions.findIndexOf(ye, B.min, !0), ke = Math.min(y.Additions.findIndexOf(ye, B.max, !0) + 1, ye.length - 1);
              ye[ke] - ye[be] > ie && (se = !0);
            } else
              (re === "month" || re === "year") && T + 36e5 >= { month: 28, year: 365 }[re] * I * de - me && T - 36e5 <= { month: 31, year: 366 }[re] * I * de + me ? se = !0 : re === "ytd" ? (se = J - Q + me === T, le = !ce) : re === "all" && (se = B.max - B.min >= F - Y);
            let he = !V && !(z && re === "all") && (pe || xe || O), ve = z && re === "all" || !le && se || ce && C.frozenStates;
            he ? G[ne] = 3 : ve && (!W || ne === ee) && (q = ne);
          }), q !== null ? (G[q] = 2, C.setSelected(q)) : (C.setSelected(), L && (L.setState(0), L.attr({ text: (u.lang.rangeSelectorZoom || "") + " ▾" })));
          for (let Z = 0; Z < G.length; Z++) {
            let ne = G[Z], ie = ae[Z];
            if (ie.state !== ne && (ie.setState(ne), p)) {
              p.options[Z + 1].disabled = ne === 3, ne === 2 && (L && (L.setState(2), L.attr({ text: C.buttonOptions[Z].text + " ▾" })), p.selectedIndex = Z + 1);
              let re = L.getBBox();
              c(p, { width: `${re.width}px`, height: `${re.height}px` });
            }
          }
        }
        computeButtonRange(C) {
          let b = C.type, p = C.count || 1, L = { millisecond: 1, second: 1e3, minute: 6e4, hour: 36e5, day: 864e5, week: 6048e5 };
          L[b] ? C._range = L[b] * p : (b === "month" || b === "year") && (C._range = 24 * { month: 30, year: 365 }[b] * 36e5 * p), C._offsetMin = $(C.offsetMin, 0), C._offsetMax = $(C.offsetMax, 0), C._range += C._offsetMax - C._offsetMin;
        }
        getInputValue(C) {
          let b = C === "min" ? this.minInput : this.maxInput, p = this.chart.options.rangeSelector, L = this.chart.time;
          return b ? (b.type === "text" && p.inputDateParser || this.defaultInputDateParser)(b.value, L.useUTC, L) : 0;
        }
        setInputValue(C, b) {
          let p = this.options, L = this.chart.time, B = C === "min" ? this.minInput : this.maxInput, T = C === "min" ? this.minDateBox : this.maxDateBox;
          if (B) {
            let O = B.getAttribute("data-hc-time"), I = g(O) ? Number(O) : void 0;
            if (g(b)) {
              let R = I;
              g(R) && B.setAttribute("data-hc-time-previous", R), B.setAttribute("data-hc-time", b), I = b;
            }
            B.value = L.dateFormat(this.inputTypeFormats[B.type] || p.inputEditDateFormat, I), T && T.attr({ text: L.dateFormat(p.inputDateFormat, I) });
          }
        }
        setInputExtremes(C, b, p) {
          let L = C === "min" ? this.minInput : this.maxInput;
          if (L) {
            let B = this.inputTypeFormats[L.type], T = this.chart.time;
            if (B) {
              let O = T.dateFormat(B, b);
              L.min !== O && (L.min = O);
              let I = T.dateFormat(B, p);
              L.max !== I && (L.max = I);
            }
          }
        }
        showInput(C) {
          let b = C === "min" ? this.minDateBox : this.maxDateBox, p = C === "min" ? this.minInput : this.maxInput;
          if (p && b && this.inputGroup) {
            let L = p.type === "text", { translateX: B = 0, translateY: T = 0 } = this.inputGroup, { x: O = 0, width: I = 0, height: R = 0 } = b, { inputBoxWidth: Y } = this.options;
            c(p, { width: L ? I + (Y ? -2 : 20) + "px" : "auto", height: R - 2 + "px", border: "2px solid silver" }), L && Y ? c(p, { left: B + O + "px", top: T + "px" }) : c(p, { left: Math.min(Math.round(O + B - (p.offsetWidth - I) / 2), this.chart.chartWidth - p.offsetWidth) + "px", top: T - (p.offsetHeight - R) / 2 + "px" });
          }
        }
        hideInput(C) {
          let b = C === "min" ? this.minInput : this.maxInput;
          b && c(b, { top: "-9999em", border: 0, width: "1px", height: "1px" });
        }
        defaultInputDateParser(C, b, p) {
          let L = C.split("/").join("-").split(" ").join("T");
          if (L.indexOf("T") === -1 && (L += "T00:00"), b)
            L += "Z";
          else {
            let T;
            if (r.isSafari && !((T = L).length > 6 && (T.lastIndexOf("-") === T.length - 6 || T.lastIndexOf("+") === T.length - 6))) {
              let O = new Date(L).getTimezoneOffset() / 60;
              L += O <= 0 ? `+${A(-O)}:00` : `-${A(O)}:00`;
            }
          }
          let B = Date.parse(L);
          if (!w(B)) {
            let T = C.split("-");
            B = Date.UTC(j(T[0]), j(T[1]) - 1, j(T[2]));
          }
          return p && b && w(B) && (B += p.getTimezoneOffset(B)), B;
        }
        drawInput(C) {
          let { chart: b, div: p, inputGroup: L } = this, B = this, T = b.renderer.style || {}, O = b.renderer, I = b.options.rangeSelector, R = u.lang, Y = C === "min";
          function F(G) {
            let { maxInput: W, minInput: ae } = B, z = b.xAxis[0], q = b.scroller?.getUnionExtremes() || z, Z = q.dataMin, ne = q.dataMax, ie = b.xAxis[0].getExtremes()[G], re = B.getInputValue(G);
            w(re) && re !== ie && (Y && W && w(Z) ? re > Number(W.getAttribute("data-hc-time")) ? re = void 0 : re < Z && (re = Z) : ae && w(ne) && (re < Number(ae.getAttribute("data-hc-time")) ? re = void 0 : re > ne && (re = ne)), re !== void 0 && z.setExtremes(Y ? re : z.min, Y ? z.max : re, void 0, void 0, { trigger: "rangeSelectorInput" }));
          }
          let U = R[Y ? "rangeSelectorFrom" : "rangeSelectorTo"] || "", Q = O.label(U, 0).addClass("highcharts-range-label").attr({ padding: U ? 2 : 0, height: U ? I.inputBoxHeight : 0 }).add(L), J = O.label("", 0).addClass("highcharts-range-input").attr({ padding: 2, width: I.inputBoxWidth, height: I.inputBoxHeight, "text-align": "center" }).on("click", function() {
            B.showInput(C), B[C + "Input"].focus();
          });
          b.styledMode || J.attr({ stroke: I.inputBoxBorderColor, "stroke-width": 1 }), J.add(L);
          let ee = h("input", { name: C, className: "highcharts-range-selector" }, void 0, p);
          ee.setAttribute("type", function(G) {
            if (G.indexOf("%L") !== -1)
              return "text";
            let W = ["a", "A", "d", "e", "w", "b", "B", "m", "o", "y", "Y"].some((z) => G.indexOf("%" + z) !== -1), ae = ["H", "k", "I", "l", "M", "S"].some((z) => G.indexOf("%" + z) !== -1);
            return W && ae ? "datetime-local" : W ? "date" : ae ? "time" : "text";
          }(I.inputDateFormat || "%e %b %Y")), b.styledMode || (Q.css(x(T, I.labelStyle)), J.css(x({ color: "#333333" }, T, I.inputStyle)), c(ee, f({ position: "absolute", border: 0, boxShadow: "0 0 15px rgba(0,0,0,0.3)", width: "1px", height: "1px", padding: 0, textAlign: "center", fontSize: T.fontSize, fontFamily: T.fontFamily, top: "-9999em" }, I.inputStyle))), ee.onfocus = () => {
            B.showInput(C);
          }, ee.onblur = () => {
            ee === r.doc.activeElement && F(C), B.hideInput(C), B.setInputValue(C), ee.blur();
          };
          let V = !1;
          return ee.onchange = () => {
            V || (F(C), B.hideInput(C), ee.blur());
          }, ee.onkeypress = (G) => {
            G.keyCode === 13 && F(C);
          }, ee.onkeydown = (G) => {
            V = !0, (G.key === "ArrowUp" || G.key === "ArrowDown" || G.key === "Tab") && F(C);
          }, ee.onkeyup = () => {
            V = !1;
          }, { dateBox: J, input: ee, label: Q };
        }
        getPosition() {
          let C = this.chart, b = C.options.rangeSelector, p = b.verticalAlign === "top" ? C.plotTop - C.axisOffset[0] : 0;
          return { buttonTop: p + b.buttonPosition.y, inputTop: p + b.inputPosition.y - 10 };
        }
        getYTDExtremes(C, b, p) {
          let L = this.chart.time, B = new L.Date(C), T = L.get("FullYear", B), O = Math.max(b, p ? L.Date.UTC(T, 0, 1) : +new L.Date(T, 0, 1)), I = B.getTime();
          return { max: Math.min(C || I, I), min: O };
        }
        createElements() {
          let C = this.chart, b = C.renderer, p = C.container, L = C.options, B = L.rangeSelector, T = B.inputEnabled, O = $(L.chart.style?.zIndex, 0) + 1;
          if (B.enabled !== !1 && (this.group = b.g("range-selector-group").attr({ zIndex: 7 }).add(), this.div = h("div", void 0, { position: "relative", height: 0, zIndex: O }), this.buttonOptions.length && this.renderButtons(), p.parentNode && p.parentNode.insertBefore(this.div, p), T)) {
            this.inputGroup = b.g("input-group").add(this.group);
            let I = this.drawInput("min");
            this.minDateBox = I.dateBox, this.minLabel = I.label, this.minInput = I.input;
            let R = this.drawInput("max");
            this.maxDateBox = R.dateBox, this.maxLabel = R.label, this.maxInput = R.input;
          }
        }
        render(C, b) {
          let p = this.chart, L = p.options.rangeSelector, B = L.inputEnabled;
          if (L.enabled !== !1) {
            if (B) {
              this.setInputValue("min", C), this.setInputValue("max", b);
              let T = p.scroller && p.scroller.getUnionExtremes() || p.xAxis[0] || {};
              if (g(T.dataMin) && g(T.dataMax)) {
                let O = p.xAxis[0].minRange || 0;
                this.setInputExtremes("min", T.dataMin, Math.min(T.dataMax, this.getInputValue("max")) - O), this.setInputExtremes("max", Math.max(T.dataMin, this.getInputValue("min")) + O, T.dataMax);
              }
              if (this.inputGroup) {
                let O = 0;
                [this.minLabel, this.minDateBox, this.maxLabel, this.maxDateBox].forEach((I) => {
                  if (I) {
                    let { width: R } = I.getBBox();
                    R && (I.attr({ x: O }), O += R + L.inputSpacing);
                  }
                });
              }
            }
            this.alignElements(), this.updateButtonStates();
          }
        }
        renderButtons() {
          let { buttons: C, chart: b, options: p } = this, L = u.lang, B = b.renderer, T = x(p.buttonTheme), O = T && T.states, I = T.width || 28;
          delete T.width, delete T.states, this.buttonGroup = B.g("range-selector-buttons").add(this.group);
          let R = this.dropdown = h("select", void 0, { position: "absolute", padding: 0, border: 0, cursor: "pointer", opacity: 1e-4 }, this.div), Y = b.userOptions.rangeSelector?.buttonTheme;
          this.dropdownLabel = B.button("", 0, 0, () => {
          }, x(T, { "stroke-width": $(T["stroke-width"], 0), width: "auto", paddingLeft: $(p.buttonTheme.paddingLeft, Y?.padding, 8), paddingRight: $(p.buttonTheme.paddingRight, Y?.padding, 8) }), O && O.hover, O && O.select, O && O.disabled).hide().add(this.group), m(R, "touchstart", () => {
            R.style.fontSize = "16px";
          });
          let F = r.isMS ? "mouseover" : "mouseenter", U = r.isMS ? "mouseout" : "mouseleave";
          m(R, F, () => {
            S(this.dropdownLabel.element, F);
          }), m(R, U, () => {
            S(this.dropdownLabel.element, U);
          }), m(R, "change", () => {
            S(this.buttons[R.selectedIndex - 1].element, "click");
          }), this.zoomText = B.label(L.rangeSelectorZoom || "", 0).attr({ padding: p.buttonTheme.padding, height: p.buttonTheme.height, paddingLeft: 0, paddingRight: 0 }).add(this.buttonGroup), this.chart.styledMode || (this.zoomText.css(p.labelStyle), T["stroke-width"] = $(T["stroke-width"], 0)), h("option", { textContent: this.zoomText.textStr, disabled: !0 }, void 0, R), this.buttonOptions.forEach((Q, J) => {
            h("option", { textContent: Q.title || Q.text }, void 0, R), C[J] = B.button(Q.text, 0, 0, (ee) => {
              let V, G = Q.events && Q.events.click;
              G && (V = G.call(Q, ee)), V !== !1 && this.clickButton(J), this.isActive = !0;
            }, T, O && O.hover, O && O.select, O && O.disabled).attr({ "text-align": "center", width: I }).add(this.buttonGroup), Q.title && C[J].attr("title", Q.title);
          });
        }
        alignElements() {
          let { buttonGroup: C, buttons: b, chart: p, group: L, inputGroup: B, options: T, zoomText: O } = this, I = p.options, R = I.exporting && I.exporting.enabled !== !1 && I.navigation && I.navigation.buttonOptions, { buttonPosition: Y, inputPosition: F, verticalAlign: U } = T, Q = (ee, V) => R && this.titleCollision(p) && U === "top" && V.align === "right" && V.y - ee.getBBox().height - 12 < (R.y || 0) + (R.height || 0) + p.spacing[0] ? -40 : 0, J = p.plotLeft;
          if (L && Y && F) {
            let ee = Y.x - p.spacing[3];
            if (C) {
              if (this.positionButtons(), !this.initialButtonGroupWidth) {
                let ie = 0;
                O && (ie += O.getBBox().width + 5), b.forEach((re, de) => {
                  ie += re.width || 0, de !== b.length - 1 && (ie += T.buttonSpacing);
                }), this.initialButtonGroupWidth = ie;
              }
              J -= p.spacing[3];
              let ne = Q(C, Y);
              this.alignButtonGroup(ne), this.buttonGroup?.translateY && this.dropdownLabel.attr({ y: this.buttonGroup.translateY }), L.placed = C.placed = p.hasLoaded;
            }
            let V = 0;
            B && (V = Q(B, F), F.align === "left" ? ee = J : F.align === "right" && (ee = -Math.max(p.axisOffset[1], -V)), B.align({ y: F.y, width: B.getBBox().width, align: F.align, x: F.x + ee - 2 }, !0, p.spacingBox), B.placed = p.hasLoaded), this.handleCollision(V), L.align({ verticalAlign: U }, !0, p.spacingBox);
            let G = L.alignAttr.translateY, W = L.getBBox().height + 20, ae = 0;
            if (U === "bottom") {
              let ne = p.legend && p.legend.options;
              ae = G - (W = W + (ne && ne.verticalAlign === "bottom" && ne.enabled && !ne.floating ? p.legend.legendHeight + $(ne.margin, 10) : 0) - 20) - (T.floating ? 0 : T.y) - (p.titleOffset ? p.titleOffset[2] : 0) - 10;
            }
            U === "top" ? (T.floating && (ae = 0), p.titleOffset && p.titleOffset[0] && (ae = p.titleOffset[0]), ae += p.margin[0] - p.spacing[0] || 0) : U === "middle" && (F.y === Y.y ? ae = G : (F.y || Y.y) && (F.y < 0 || Y.y < 0 ? ae -= Math.min(F.y, Y.y) : ae = G - W)), L.translate(T.x, T.y + Math.floor(ae));
            let { minInput: z, maxInput: q, dropdown: Z } = this;
            T.inputEnabled && z && q && (z.style.marginTop = L.translateY + "px", q.style.marginTop = L.translateY + "px"), Z && (Z.style.marginTop = L.translateY + "px");
          }
        }
        alignButtonGroup(C, b) {
          let { chart: p, options: L, buttonGroup: B } = this, { buttonPosition: T } = L, O = p.plotLeft - p.spacing[3], I = T.x - p.spacing[3];
          T.align === "right" ? I += C - O : T.align === "center" && (I -= O / 2), B && B.align({ y: T.y, width: $(b, this.initialButtonGroupWidth), align: T.align, x: I }, !0, p.spacingBox);
        }
        positionButtons() {
          let { buttons: C, chart: b, options: p, zoomText: L } = this, B = b.hasLoaded ? "animate" : "attr", { buttonPosition: T } = p, O = b.plotLeft, I = O;
          L && L.visibility !== "hidden" && (L[B]({ x: $(O + T.x, O) }), I += T.x + L.getBBox().width + 5);
          for (let R = 0, Y = this.buttonOptions.length; R < Y; ++R)
            C[R].visibility !== "hidden" ? (C[R][B]({ x: I }), I += (C[R].width || 0) + p.buttonSpacing) : C[R][B]({ x: O });
        }
        handleCollision(C) {
          let { chart: b, buttonGroup: p, inputGroup: L } = this, { buttonPosition: B, dropdown: T, inputPosition: O } = this.options, I = () => {
            let F = 0;
            return this.buttons.forEach((U) => {
              let Q = U.getBBox();
              Q.width > F && (F = Q.width);
            }), F;
          }, R = (F) => {
            if (L?.alignOptions && p) {
              let U = L.alignAttr.translateX + L.alignOptions.x - C + L.getBBox().x + 2, Q = L.alignOptions.width || 0, J = p.alignAttr.translateX + p.getBBox().x;
              return J + F > U && U + Q > J && B.y < O.y + L.getBBox().height;
            }
            return !1;
          }, Y = () => {
            L && p && L.attr({ translateX: L.alignAttr.translateX + (b.axisOffset[1] >= -C ? 0 : -C), translateY: L.alignAttr.translateY + p.getBBox().height + 10 });
          };
          if (p) {
            if (T === "always") {
              this.collapseButtons(), R(I()) && Y();
              return;
            }
            T === "never" && this.expandButtons();
          }
          L && p ? O.align === B.align || R(this.initialButtonGroupWidth + 20) ? T === "responsive" ? (this.collapseButtons(), R(I()) && Y()) : Y() : T === "responsive" && this.expandButtons() : p && T === "responsive" && (this.initialButtonGroupWidth > b.plotWidth ? this.collapseButtons() : this.expandButtons());
        }
        collapseButtons() {
          let { buttons: C, zoomText: b } = this;
          this.isCollapsed !== !0 && (this.isCollapsed = !0, b.hide(), C.forEach((p) => void p.hide()), this.showDropdown());
        }
        expandButtons() {
          let { buttons: C, zoomText: b } = this;
          this.isCollapsed !== !1 && (this.isCollapsed = !1, this.hideDropdown(), b.show(), C.forEach((p) => void p.show()), this.positionButtons());
        }
        showDropdown() {
          let { buttonGroup: C, chart: b, dropdownLabel: p, dropdown: L } = this;
          if (C && L) {
            let { translateX: B = 0, translateY: T = 0 } = C, O = b.plotLeft + B;
            p.attr({ x: O, y: T }).show(), c(L, { left: O + "px", top: T + "px", visibility: "inherit" }), this.hasVisibleDropdown = !0;
          }
        }
        hideDropdown() {
          let { dropdown: C } = this;
          C && (this.dropdownLabel.hide(), c(C, { visibility: "hidden", width: "1px", height: "1px" }), this.hasVisibleDropdown = !1);
        }
        getHeight() {
          let C = this.options, b = this.group, p = C.inputPosition, L = C.buttonPosition, B = C.y, T = L.y, O = p.y, I = 0;
          if (C.height)
            return C.height;
          this.alignElements(), I = b ? b.getBBox(!0).height + 13 + B : 0;
          let R = Math.min(O, T);
          return (O < 0 && T < 0 || O > 0 && T > 0) && (I += Math.abs(R)), I;
        }
        titleCollision(C) {
          return !(C.options.title.text || C.options.subtitle.text);
        }
        update(C, b = !0) {
          let p = this.chart;
          x(!0, p.options.rangeSelector, C), this.destroy(), this.init(p), b && this.render();
        }
        destroy() {
          let C = this, b = C.minInput, p = C.maxInput;
          C.eventsToUnbind && (C.eventsToUnbind.forEach((L) => L()), C.eventsToUnbind = void 0), v(C.buttons), b && (b.onfocus = b.onblur = b.onchange = null), p && (p.onfocus = p.onblur = p.onchange = null), k(C, function(L, B) {
            L && B !== "chart" && (L instanceof l ? L.destroy() : L instanceof window.HTMLElement && P(L)), L !== M.prototype[B] && (C[B] = null);
          }, this);
        }
      }
      return f(M.prototype, { defaultButtons: [{ type: "month", count: 1, text: "1m", title: "View 1 month" }, { type: "month", count: 3, text: "3m", title: "View 3 months" }, { type: "month", count: 6, text: "6m", title: "View 6 months" }, { type: "ytd", text: "YTD", title: "View year to date" }, { type: "year", count: 1, text: "1y", title: "View 1 year" }, { type: "all", text: "All", title: "View all" }], inputTypeFormats: { "datetime-local": "%Y-%m-%dT%H:%M:%S", date: "%Y-%m-%d", time: "%H:%M:%S" } }), M;
    }), i(n, "Core/Chart/StockChart.js", [n["Core/Chart/Chart.js"], n["Core/Templating.js"], n["Core/Defaults.js"], n["Stock/Navigator/NavigatorDefaults.js"], n["Stock/RangeSelector/RangeSelectorDefaults.js"], n["Stock/Scrollbar/ScrollbarDefaults.js"], n["Stock/Utilities/StockUtilities.js"], n["Core/Utilities.js"]], function(o, a, r, s, l, d, y, u) {
      let { format: m } = a, { getOptions: h } = r, { setFixedRange: c } = y, { addEvent: g, clamp: v, crisp: P, defined: f, extend: S, find: w, isNumber: x, isString: k, merge: A, pick: $, splat: j } = u;
      function N(C, b, p) {
        return C === "xAxis" ? { minPadding: 0, maxPadding: 0, overscroll: 0, ordinal: !0 } : C === "yAxis" ? { labels: { y: -2 }, opposite: p.opposite ?? b.opposite ?? !0, showLastLabel: !!(b.categories || b.type === "category"), title: { text: p.title?.text !== "Values" ? p.title?.text : null } } : {};
      }
      function M(C, b) {
        if (C === "xAxis") {
          let p = $(b.navigator && b.navigator.enabled, s.enabled, !0), L = { type: "datetime", categories: void 0 };
          return p && (L.startOnTick = !1, L.endOnTick = !1), L;
        }
        return {};
      }
      class D extends o {
        init(b, p) {
          let L = h(), B = b.xAxis, T = b.yAxis, O = $(b.navigator && b.navigator.enabled, s.enabled, !0);
          b.xAxis = b.yAxis = void 0;
          let I = A({ chart: { panning: { enabled: !0, type: "x" }, zooming: { pinchType: "x", mouseWheel: { type: "x" } } }, navigator: { enabled: O }, scrollbar: { enabled: $(d.enabled, !0) }, rangeSelector: { enabled: $(l.rangeSelector.enabled, !0) }, title: { text: null }, tooltip: { split: $(L.tooltip && L.tooltip.split, !0), crosshairs: !0 }, legend: { enabled: !1 } }, b, { isStock: !0 });
          b.xAxis = B, b.yAxis = T, I.xAxis = j(b.xAxis || {}).map((R) => A(N("xAxis", R, L.xAxis), R, M("xAxis", b))), I.yAxis = j(b.yAxis || {}).map((R) => A(N("yAxis", R, L.yAxis), R)), super.init(I, p);
        }
        createAxis(b, p) {
          return p.axis = A(N(b, p.axis, h()[b]), p.axis, M(b, this.userOptions)), super.createAxis(b, p);
        }
      }
      return g(o, "update", function(C) {
        let b = C.options;
        "scrollbar" in b && this.navigator && (A(!0, this.options.scrollbar, b.scrollbar), this.navigator.update({ enabled: !!this.navigator.navigatorEnabled }), delete b.scrollbar);
      }), function(C) {
        function b(Y) {
          if (!this.crosshair || !this.crosshair.label || !this.crosshair.label.enabled || !this.cross || !x(this.min) || !x(this.max))
            return;
          let F = this.chart, U = this.logarithmic, Q = this.crosshair.label, J = this.horiz, ee = this.opposite, V = this.left, G = this.top, W = this.width, ae = this.options.tickPosition === "inside", z = this.crosshair.snap !== !1, q = Y.e || this.cross && this.cross.e, Z = Y.point, ne = this.crossLabel, ie, re, de = Q.format, me = "", ce, pe = 0, xe = this.min, le = this.max;
          U && (xe = U.lin2log(this.min), le = U.lin2log(this.max));
          let se = J ? "center" : ee ? this.labelAlign === "right" ? "right" : "left" : this.labelAlign === "left" ? "left" : "center";
          ne || (ne = this.crossLabel = F.renderer.label("", 0, void 0, Q.shape || "callout").addClass("highcharts-crosshair-label highcharts-color-" + (Z && Z.series ? Z.series.colorIndex : this.series[0] && this.series[0].colorIndex)).attr({ align: Q.align || se, padding: $(Q.padding, 8), r: $(Q.borderRadius, 3), zIndex: 2 }).add(this.labelGroup), F.styledMode || ne.attr({ fill: Q.backgroundColor || Z && Z.series && Z.series.color || "#666666", stroke: Q.borderColor || "", "stroke-width": Q.borderWidth || 0 }).css(S({ color: "#ffffff", fontWeight: "normal", fontSize: "0.7em", textAlign: "center" }, Q.style || {}))), J ? (ie = z ? (Z.plotX || 0) + V : q.chartX, re = G + (ee ? 0 : this.height)) : (ie = V + this.offset + (ee ? W : 0), re = z ? (Z.plotY || 0) + G : q.chartY), de || Q.formatter || (this.dateTime && (me = "%b %d, %Y"), de = "{value" + (me ? ":" + me : "") + "}");
          let he = z ? this.isXAxis ? Z.x : Z.y : this.toValue(J ? q.chartX : q.chartY), ve = Z && Z.series ? Z.series.isPointInside(Z) : x(he) && he > xe && he < le, ye = "";
          de ? ye = m(de, { value: he }, F) : Q.formatter && x(he) && (ye = Q.formatter.call(this, he)), ne.attr({ text: ye, x: ie, y: re, visibility: ve ? "inherit" : "hidden" });
          let be = ne.getBBox();
          !x(ne.x) || J || ee || (ie = ne.x - be.width / 2), x(ne.y) && (J ? (ae && !ee || !ae && ee) && (re = ne.y - be.height) : re = ne.y - be.height / 2), ce = J ? { left: V, right: V + this.width } : { left: this.labelAlign === "left" ? V : 0, right: this.labelAlign === "right" ? V + this.width : F.chartWidth };
          let ke = ne.translateX || 0;
          ke < ce.left && (pe = ce.left - ke), ke + be.width >= ce.right && (pe = -(ke + be.width - ce.right)), ne.attr({ x: ie + pe, y: re, anchorX: J ? ie : this.opposite ? 0 : F.chartWidth, anchorY: J ? this.opposite ? F.chartHeight : 0 : re + be.height / 2 });
        }
        function p() {
          this.crossLabel && (this.crossLabel = this.crossLabel.hide());
        }
        function L(Y) {
          let F = this.chart, U = this.options, Q = F._labelPanes = F._labelPanes || {}, J = U.labels;
          if (F.options.isStock && this.coll === "yAxis") {
            let ee = U.top + "," + U.height;
            !Q[ee] && J.enabled && (J.distance === 15 && this.side === 1 && (J.distance = 0), J.align === void 0 && (J.align = "right"), Q[ee] = this, Y.align = "right", Y.preventDefault());
          }
        }
        function B() {
          let Y = this.chart, F = this.options && this.options.top + "," + this.options.height;
          F && Y._labelPanes && Y._labelPanes[F] === this && delete Y._labelPanes[F];
        }
        function T(Y) {
          let F = this, U = F.isLinked && !F.series && F.linkedParent ? F.linkedParent.series : F.series, Q = F.chart, J = Q.renderer, ee = F.left, V = F.top, G = [], W = Y.translatedValue, ae = Y.value, z = Y.force, q, Z, ne, ie, re = [], de, me;
          if (Q.options.isStock && Y.acrossPanes !== !1 && F.coll === "xAxis" || F.coll === "yAxis") {
            for (let ce of (Y.preventDefault(), re = ((pe) => {
              let xe = pe === "xAxis" ? "yAxis" : "xAxis", le = F.options[xe];
              return x(le) ? [Q[xe][le]] : k(le) ? [Q.get(le)] : U.map((se) => se[xe]);
            })(F.coll), F.isXAxis ? Q.yAxis : Q.xAxis))
              if (!ce.options.isInternal) {
                let pe = ce.isXAxis ? "yAxis" : "xAxis";
                F === (f(ce.options[pe]) ? Q[pe][ce.options[pe]] : Q[pe][0]) && re.push(ce);
              }
            for (let ce of (de = re.length ? [] : [F.isXAxis ? Q.yAxis[0] : Q.xAxis[0]], re))
              de.indexOf(ce) !== -1 || w(de, (pe) => pe.pos === ce.pos && pe.len === ce.len) || de.push(ce);
            if (x(me = $(W, F.translate(ae || 0, void 0, void 0, Y.old))))
              if (F.horiz)
                for (let ce of de) {
                  let pe;
                  ie = (Z = ce.pos) + ce.len, q = ne = Math.round(me + F.transB), z !== "pass" && (q < ee || q > ee + F.width) && (z ? q = ne = v(q, ee, ee + F.width) : pe = !0), pe || G.push(["M", q, Z], ["L", ne, ie]);
                }
              else
                for (let ce of de) {
                  let pe;
                  ne = (q = ce.pos) + ce.len, Z = ie = Math.round(V + F.height - me), z !== "pass" && (Z < V || Z > V + F.height) && (z ? Z = ie = v(Z, V, V + F.height) : pe = !0), pe || G.push(["M", q, Z], ["L", ne, ie]);
                }
            Y.path = G.length > 0 ? J.crispPolyLine(G, Y.lineWidth || 1) : void 0;
          }
        }
        function O(Y) {
          if (this.chart.options.isStock) {
            let F;
            this.is("column") || this.is("columnrange") ? F = { borderWidth: 0, shadow: !1 } : this.is("scatter") || this.is("sma") || (F = { marker: { enabled: !1, radius: 2 } }), F && (Y.plotOptions[this.type] = A(Y.plotOptions[this.type], F));
          }
        }
        function I() {
          let Y = this.chart, F = this.options.dataGrouping;
          return this.allowDG !== !1 && F && $(F.enabled, Y.options.isStock);
        }
        function R(Y, F) {
          for (let U = 0; U < Y.length; U += 2) {
            let Q = Y[U], J = Y[U + 1];
            f(Q[1]) && Q[1] === J[1] && (Q[1] = J[1] = P(Q[1], F)), f(Q[2]) && Q[2] === J[2] && (Q[2] = J[2] = P(Q[2], F));
          }
          return Y;
        }
        C.compose = function(Y, F, U, Q) {
          let J = U.prototype;
          J.forceCropping || (g(F, "afterDrawCrosshair", b), g(F, "afterHideCrosshair", p), g(F, "autoLabelAlign", L), g(F, "destroy", B), g(F, "getPlotLinePath", T), Y.prototype.setFixedRange = c, J.forceCropping = I, g(U, "setOptions", O), Q.prototype.crispPolyLine = R);
        }, C.stockChart = function(Y, F, U) {
          return new C(Y, F, U);
        };
      }(D || (D = {})), D;
    }), i(n, "Series/HLC/HLCPoint.js", [n["Core/Series/SeriesRegistry.js"]], function(o) {
      let { column: { prototype: { pointClass: a } } } = o.seriesTypes;
      return class extends a {
      };
    }), i(n, "Series/HLC/HLCSeriesDefaults.js", [], function() {
      return { lineWidth: 1, tooltip: { pointFormat: '<span style="color:{point.color}">●</span> <b> {series.name}</b><br/>High: {point.high}<br/>Low: {point.low}<br/>Close: {point.close}<br/>' }, threshold: null, states: { hover: { lineWidth: 3 } }, stickyTracking: !0 };
    }), i(n, "Series/HLC/HLCSeries.js", [n["Series/HLC/HLCPoint.js"], n["Series/HLC/HLCSeriesDefaults.js"], n["Core/Series/SeriesRegistry.js"], n["Core/Utilities.js"]], function(o, a, r, s) {
      let { column: l } = r.seriesTypes, { crisp: d, extend: y, merge: u } = s;
      class m extends l {
        extendStem(c, g, v) {
          let P = c[0], f = c[1];
          typeof P[2] == "number" && (P[2] = Math.max(v + g, P[2])), typeof f[2] == "number" && (f[2] = Math.min(v - g, f[2]));
        }
        getPointPath(c, g) {
          let v = g.strokeWidth(), P = c.series, f = d(c.plotX || 0, v), S = Math.round(c.shapeArgs.width / 2), w = [["M", f, Math.round(c.yBottom)], ["L", f, Math.round(c.plotHigh)]];
          if (c.close !== null) {
            let x = d(c.plotClose, v);
            w.push(["M", f, x], ["L", f + S, x]), P.extendStem(w, v / 2, x);
          }
          return w;
        }
        drawSinglePoint(c) {
          let g = c.series, v = g.chart, P, f = c.graphic;
          c.plotY !== void 0 && (f || (c.graphic = f = v.renderer.path().add(g.group)), v.styledMode || f.attr(g.pointAttribs(c, c.selected && "select")), P = g.getPointPath(c, f), f[f ? "animate" : "attr"]({ d: P }).addClass(c.getClassName(), !0));
        }
        drawPoints() {
          this.points.forEach(this.drawSinglePoint);
        }
        init() {
          super.init.apply(this, arguments), this.options.stacking = void 0;
        }
        pointAttribs(c, g) {
          let v = super.pointAttribs.call(this, c, g);
          return delete v.fill, v;
        }
        toYData(c) {
          return [c.high, c.low, c.close];
        }
        translate() {
          let c = this, g = c.yAxis, v = this.pointArrayMap && this.pointArrayMap.slice() || [], P = v.map((f) => `plot${f.charAt(0).toUpperCase() + f.slice(1)}`);
          P.push("yBottom"), v.push("low"), super.translate.apply(c), c.points.forEach(function(f) {
            v.forEach(function(S, w) {
              let x = f[S];
              x !== null && (c.dataModify && (x = c.dataModify.modifyValue(x)), f[P[w]] = g.toPixels(x, !0));
            }), f.tooltipPos[1] = f.plotHigh + g.pos - c.chart.plotTop;
          });
        }
      }
      return m.defaultOptions = u(l.defaultOptions, a), y(m.prototype, { pointClass: o, animate: null, directTouch: !1, pointArrayMap: ["high", "low", "close"], pointAttrToOptions: { stroke: "color", "stroke-width": "lineWidth" }, pointValKey: "close" }), r.registerSeriesType("hlc", m), m;
    }), i(n, "Series/OHLC/OHLCPoint.js", [n["Core/Series/SeriesRegistry.js"]], function(o) {
      let { seriesTypes: { hlc: a } } = o;
      class r extends a.prototype.pointClass {
        getClassName() {
          return super.getClassName.call(this) + (this.open < this.close ? " highcharts-point-up" : " highcharts-point-down");
        }
        resolveUpColor() {
          this.open < this.close && !this.options.color && this.series.options.upColor && (this.color = this.series.options.upColor);
        }
        resolveColor() {
          super.resolveColor(), this.series.is("heikinashi") || this.resolveUpColor();
        }
        getZone() {
          let l = super.getZone();
          return this.resolveUpColor(), l;
        }
        applyOptions() {
          return super.applyOptions.apply(this, arguments), this.resolveColor && this.resolveColor(), this;
        }
      }
      return r;
    }), i(n, "Series/OHLC/OHLCSeriesDefaults.js", [], function() {
      return { tooltip: { pointFormat: '<span style="color:{point.color}">●</span> <b> {series.name}</b><br/>Open: {point.open}<br/>High: {point.high}<br/>Low: {point.low}<br/>Close: {point.close}<br/>' } };
    }), i(n, "Series/OHLC/OHLCSeries.js", [n["Core/Globals.js"], n["Series/OHLC/OHLCPoint.js"], n["Series/OHLC/OHLCSeriesDefaults.js"], n["Core/Series/SeriesRegistry.js"], n["Core/Utilities.js"]], function(o, a, r, s, l) {
      let { composed: d } = o, { hlc: y } = s.seriesTypes, { addEvent: u, crisp: m, extend: h, merge: c, pushUnique: g } = l;
      function v(S) {
        let w = S.options, x = w.dataGrouping;
        x && w.useOhlcData && w.id !== "highcharts-navigator-series" && (x.approximation = "ohlc");
      }
      function P(S) {
        let w = S.options;
        w.useOhlcData && w.id !== "highcharts-navigator-series" && h(this, { pointValKey: f.prototype.pointValKey, pointArrayMap: f.prototype.pointArrayMap, toYData: f.prototype.toYData });
      }
      class f extends y {
        static compose(w, ...x) {
          g(d, "OHLCSeries") && (u(w, "afterSetOptions", v), u(w, "init", P));
        }
        getPointPath(w, x) {
          let k = super.getPointPath(w, x), A = x.strokeWidth(), $ = m(w.plotX || 0, A), j = Math.round(w.shapeArgs.width / 2);
          if (w.open !== null) {
            let N = m(w.plotOpen, A);
            k.push(["M", $, N], ["L", $ - j, N]), super.extendStem(k, A / 2, N);
          }
          return k;
        }
        pointAttribs(w, x) {
          let k = super.pointAttribs.call(this, w, x), A = this.options;
          return delete k.fill, !w.options.color && A.upColor && w.open < w.close && (k.stroke = A.upColor), k;
        }
        toYData(w) {
          return [w.open, w.high, w.low, w.close];
        }
      }
      return f.defaultOptions = c(y.defaultOptions, r), h(f.prototype, { pointClass: a, pointArrayMap: ["open", "high", "low", "close"] }), s.registerSeriesType("ohlc", f), f;
    }), i(n, "Series/Candlestick/CandlestickSeriesDefaults.js", [], function() {
      return { states: { hover: { lineWidth: 2 } }, threshold: null, lineColor: "#000000", lineWidth: 1, upColor: "#ffffff", stickyTracking: !0 };
    }), i(n, "Series/Candlestick/CandlestickSeries.js", [n["Series/Candlestick/CandlestickSeriesDefaults.js"], n["Core/Series/SeriesRegistry.js"], n["Core/Utilities.js"]], function(o, a, r) {
      let { column: s, ohlc: l } = a.seriesTypes, { crisp: d, merge: y } = r;
      class u extends l {
        pointAttribs(h, c) {
          let g = s.prototype.pointAttribs.call(this, h, c), v = this.options, P = h.open < h.close, f = v.lineColor || this.color, S = h.color || this.color;
          if (g["stroke-width"] = v.lineWidth, g.fill = h.options.color || P && v.upColor || S, g.stroke = h.options.lineColor || P && v.upLineColor || f, c) {
            let w = v.states[c];
            g.fill = w.color || g.fill, g.stroke = w.lineColor || g.stroke, g["stroke-width"] = w.lineWidth || g["stroke-width"];
          }
          return g;
        }
        drawPoints() {
          let h = this.points, c = this.chart, g = this.yAxis.reversed;
          for (let v of h) {
            let P = v.graphic, f, S, w, x, k, A, $, j, N, M = !P;
            if (v.plotY !== void 0) {
              P || (v.graphic = P = c.renderer.path().add(this.group)), this.chart.styledMode || P.attr(this.pointAttribs(v, v.selected && "select")).shadow(this.options.shadow);
              let D = P.strokeWidth();
              $ = d(v.plotX || 0, D), w = Math.min(f = v.plotOpen, S = v.plotClose), x = Math.max(f, S), N = Math.round(v.shapeArgs.width / 2), k = g ? x !== v.yBottom : Math.round(w) !== Math.round(v.plotHigh || 0), A = g ? Math.round(w) !== Math.round(v.plotHigh || 0) : x !== v.yBottom, w = d(w, D), x = d(x, D), (j = []).push(["M", $ - N, x], ["L", $ - N, w], ["L", $ + N, w], ["L", $ + N, x], ["Z"], ["M", $, w], ["L", $, k ? Math.round(g ? v.yBottom : v.plotHigh) : w], ["M", $, x], ["L", $, A ? Math.round(g ? v.plotHigh : v.yBottom) : x]), P[M ? "attr" : "animate"]({ d: j }).addClass(v.getClassName(), !0);
            }
          }
        }
      }
      return u.defaultOptions = y(l.defaultOptions, { tooltip: l.defaultOptions.tooltip }, o), a.registerSeriesType("candlestick", u), u;
    }), i(n, "Series/Flags/FlagsPoint.js", [n["Core/Series/SeriesRegistry.js"], n["Core/Utilities.js"]], function(o, a) {
      let { column: { prototype: { pointClass: r } } } = o.seriesTypes, { isNumber: s } = a;
      return class extends r {
        constructor() {
          super(...arguments), this.ttBelow = !1;
        }
        isValid() {
          return s(this.y) || this.y === void 0;
        }
        hasNewShapeType() {
          let l = this.options.shape || this.series.options.shape;
          return this.graphic && l && l !== this.graphic.symbolKey;
        }
      };
    }), i(n, "Series/Flags/FlagsSeriesDefaults.js", [], function() {
      return { borderRadius: 0, pointRange: 0, allowOverlapX: !1, shape: "flag", stackDistance: 12, textAlign: "center", tooltip: { pointFormat: "{point.text}" }, threshold: null, y: -30, fillColor: "#ffffff", lineWidth: 1, states: { hover: { lineColor: "#000000", fillColor: "#ccd3ff" } }, style: { fontSize: "0.7em", fontWeight: "bold" } };
    }), i(n, "Series/Flags/FlagsSymbols.js", [n["Core/Renderer/RendererRegistry.js"]], function(o) {
      var a;
      return function(r) {
        let s = [];
        function l(y, u, m, h, c) {
          let g = c && c.anchorX || y, v = c && c.anchorY || u, P = this.circle(g - 1, v - 1, 2, 2);
          return P.push(["M", g, v], ["L", y, u + h], ["L", y, u], ["L", y + m, u], ["L", y + m, u + h], ["L", y, u + h], ["Z"]), P;
        }
        function d(y, u) {
          y[u + "pin"] = function(m, h, c, g, v) {
            let P, f = v && v.anchorX, S = v && v.anchorY;
            if (u === "circle" && g > c && (m -= Math.round((g - c) / 2), c = g), P = y[u](m, h, c, g, v), f && S) {
              let w = f;
              if (u === "circle")
                w = m + c / 2;
              else {
                let k = P[0], A = P[1];
                k[0] === "M" && A[0] === "L" && (w = (k[1] + A[1]) / 2);
              }
              let x = h > S ? h : h + g;
              P.push(["M", w, x], ["L", f, S]), P = P.concat(y.circle(f - 1, S - 1, 2, 2));
            }
            return P;
          };
        }
        r.compose = function(y) {
          if (s.indexOf(y) === -1) {
            s.push(y);
            let m = y.prototype.symbols;
            m.flag = l, d(m, "circle"), d(m, "square");
          }
          let u = o.getRendererType();
          s.indexOf(u) && s.push(u);
        };
      }(a || (a = {})), a;
    }), i(n, "Series/OnSeriesComposition.js", [n["Series/Column/ColumnSeries.js"], n["Core/Globals.js"], n["Core/Series/Series.js"], n["Core/Utilities.js"]], function(o, a, r, s) {
      var l;
      let { composed: d } = a, { prototype: y } = o, { prototype: u } = r, { defined: m, pushUnique: h, stableSort: c } = s;
      return function(g) {
        function v(f) {
          return u.getPlotBox.call(this.options.onSeries && this.chart.get(this.options.onSeries) || this, f);
        }
        function P() {
          y.translate.apply(this);
          let f = this, S = f.options, w = f.chart, x = f.points, k = S.onSeries, A = k && w.get(k), $ = A && A.options.step, j = A && A.points, N = w.inverted, M = f.xAxis, D = f.yAxis, C = x.length - 1, b, p, L = S.onKey || "y", B = j && j.length, T = 0, O, I, R, Y, F;
          if (A && A.visible && B) {
            for (T = (A.pointXOffset || 0) + (A.barW || 0) / 2, Y = A.currentDataGrouping, I = j[B - 1].x + (Y ? Y.totalRange : 0), c(x, (U, Q) => U.x - Q.x), L = "plot" + L[0].toUpperCase() + L.substr(1); B-- && x[C]; )
              if (O = j[B], (b = x[C]).y = O.y, O.x <= b.x && O[L] !== void 0) {
                if (b.x <= I && (b.plotY = O[L], O.x < b.x && !$ && (R = j[B + 1]) && R[L] !== void 0))
                  if (m(b.plotX) && A.is("spline")) {
                    let U = [O.plotX || 0, O.plotY || 0], Q = [R.plotX || 0, R.plotY || 0], J = O.controlPoints?.high || U, ee = R.controlPoints?.low || Q, V = (z, q) => Math.pow(1 - z, 3) * U[q] + 3 * (1 - z) * (1 - z) * z * J[q] + 3 * (1 - z) * z * z * ee[q] + z * z * z * Q[q], G = 0, W = 1, ae;
                    for (let z = 0; z < 100; z++) {
                      let q = (G + W) / 2, Z = V(q, 0);
                      if (Z === null)
                        break;
                      if (0.25 > Math.abs(Z - b.plotX)) {
                        ae = q;
                        break;
                      }
                      Z < b.plotX ? G = q : W = q;
                    }
                    m(ae) && (b.plotY = V(ae, 1), b.y = D.toValue(b.plotY, !0));
                  } else
                    F = (b.x - O.x) / (R.x - O.x), b.plotY += F * (R[L] - O[L]), b.y += F * (R.y - O.y);
                if (C--, B++, C < 0)
                  break;
              }
          }
          x.forEach((U, Q) => {
            let J;
            U.plotX += T, (U.plotY === void 0 || N) && (U.plotX >= 0 && U.plotX <= M.len ? N ? (U.plotY = M.translate(U.x, 0, 1, 0, 1), U.plotX = m(U.y) ? D.translate(U.y, 0, 0, 0, 1) : 0) : U.plotY = (M.opposite ? 0 : f.yAxis.len) + M.offset : U.shapeArgs = {}), (p = x[Q - 1]) && p.plotX === U.plotX && (p.stackIndex === void 0 && (p.stackIndex = 0), J = p.stackIndex + 1), U.stackIndex = J;
          }), this.onSeries = A;
        }
        g.compose = function(f) {
          if (h(d, "OnSeries")) {
            let S = f.prototype;
            S.getPlotBox = v, S.translate = P;
          }
          return f;
        }, g.getPlotBox = v, g.translate = P;
      }(l || (l = {})), l;
    }), i(n, "Series/Flags/FlagsSeries.js", [n["Series/Flags/FlagsPoint.js"], n["Series/Flags/FlagsSeriesDefaults.js"], n["Series/Flags/FlagsSymbols.js"], n["Core/Globals.js"], n["Series/OnSeriesComposition.js"], n["Core/Renderer/RendererUtilities.js"], n["Core/Series/SeriesRegistry.js"], n["Core/Renderer/SVG/SVGElement.js"], n["Core/Utilities.js"]], function(o, a, r, s, l, d, y, u, m) {
      let { noop: h } = s, { distribute: c } = d, { series: g, seriesTypes: { column: v } } = y, { addEvent: P, defined: f, extend: S, isNumber: w, merge: x, objectEach: k, wrap: A } = m;
      class $ extends v {
        animate(N) {
          N && this.setClip();
        }
        drawPoints() {
          let N, M, D, C, b, p, L, B, T, O, I, R = this.points, Y = this.chart, F = Y.renderer, U = Y.inverted, Q = this.options, J = Q.y, ee = this.yAxis, V = {}, G = [], W = w(Q.borderRadius) ? Q.borderRadius : 0;
          for (C = R.length; C--; )
            b = R[C], O = (U ? b.plotY : b.plotX) > this.xAxis.len, N = b.plotX, L = b.stackIndex, D = b.options.shape || Q.shape, (M = b.plotY) !== void 0 && (M = b.plotY + J - (L !== void 0 && L * Q.stackDistance)), b.anchorX = L ? void 0 : b.plotX, B = L ? void 0 : b.plotY, I = D !== "flag", p = b.graphic, M !== void 0 && N >= 0 && !O ? (p && b.hasNewShapeType() && (p = p.destroy()), p || (p = b.graphic = F.label("", 0, void 0, D, void 0, void 0, Q.useHTML).addClass("highcharts-point").add(this.markerGroup), b.graphic.div && (b.graphic.div.point = b), p.isNew = !0), p.attr({ align: I ? "center" : "left", width: Q.width, height: Q.height, "text-align": Q.textAlign, r: W }), Y.styledMode || p.attr(this.pointAttribs(b)).css(x(Q.style, b.style)).shadow(Q.shadow), N > 0 && (N -= p.strokeWidth() % 2), T = { y: M, anchorY: B }, Q.allowOverlapX && (T.x = N, T.anchorX = b.anchorX), p.attr({ text: b.options.title ?? Q.title ?? "A" })[p.isNew ? "attr" : "animate"](T), Q.allowOverlapX || (V[b.plotX] ? V[b.plotX].size = Math.max(V[b.plotX].size, p.width || 0) : V[b.plotX] = { align: I ? 0.5 : 0, size: p.width || 0, target: N, anchorX: N }), b.tooltipPos = [N, M + ee.pos - Y.plotTop]) : p && (b.graphic = p.destroy());
          if (!Q.allowOverlapX) {
            let ae = 100;
            for (let z of (k(V, function(q) {
              q.plotX = q.anchorX, G.push(q), ae = Math.max(q.size, ae);
            }), c(G, U ? ee.len : this.xAxis.len, ae), R)) {
              let q = z.plotX, Z = z.graphic, ne = Z && V[q];
              ne && Z && (f(ne.pos) ? Z[Z.isNew ? "attr" : "animate"]({ x: ne.pos + (ne.align || 0) * ne.size, anchorX: z.anchorX }).show().isNew = !1 : Z.hide().isNew = !0);
            }
          }
          Q.useHTML && this.markerGroup && A(this.markerGroup, "on", function(ae) {
            return u.prototype.on.apply(ae.apply(this, [].slice.call(arguments, 1)), [].slice.call(arguments, 1));
          });
        }
        drawTracker() {
          let N = this.points;
          for (let M of (super.drawTracker(), N)) {
            let D = M.graphic;
            D && (M.unbindMouseOver && M.unbindMouseOver(), M.unbindMouseOver = P(D.element, "mouseover", function() {
              for (let C of (M.stackIndex > 0 && !M.raised && (M._y = D.y, D.attr({ y: M._y - 8 }), M.raised = !0), N))
                C !== M && C.raised && C.graphic && (C.graphic.attr({ y: C._y }), C.raised = !1);
            }));
          }
        }
        pointAttribs(N, M) {
          let D = this.options, C = N && N.color || this.color, b = D.lineColor, p = N && N.lineWidth, L = N && N.fillColor || D.fillColor;
          return M && (L = D.states[M].fillColor, b = D.states[M].lineColor, p = D.states[M].lineWidth), { fill: L || C, stroke: b || C, "stroke-width": p || D.lineWidth || 0 };
        }
        setClip() {
          g.prototype.setClip.apply(this, arguments), this.options.clip !== !1 && this.sharedClipKey && this.markerGroup && this.markerGroup.clip(this.chart.sharedClips[this.sharedClipKey]);
        }
      }
      return $.compose = r.compose, $.defaultOptions = x(v.defaultOptions, a), l.compose($), S($.prototype, { allowDG: !1, forceCrop: !0, invertible: !1, noSharedTooltip: !0, pointClass: o, sorted: !1, takeOrdinalPosition: !1, trackerGroups: ["markerGroup"], buildKDTree: h, init: g.prototype.init }), y.registerSeriesType("flags", $), $;
    }), i(n, "Core/Axis/BrokenAxis.js", [n["Core/Axis/Stacking/StackItem.js"], n["Core/Utilities.js"]], function(o, a) {
      var r;
      let { addEvent: s, find: l, fireEvent: d, isArray: y, isNumber: u, pick: m } = a;
      return function(h) {
        function c() {
          this.brokenAxis !== void 0 && this.brokenAxis.setBreaks(this.options.breaks, !1);
        }
        function g() {
          this.brokenAxis?.hasBreaks && (this.options.ordinal = !1);
        }
        function v() {
          let A = this.brokenAxis;
          if (A?.hasBreaks) {
            let $ = this.tickPositions, j = this.tickPositions.info, N = [];
            for (let M = 0; M < $.length; M++)
              A.isInAnyBreak($[M]) || N.push($[M]);
            this.tickPositions = N, this.tickPositions.info = j;
          }
        }
        function P() {
          this.brokenAxis || (this.brokenAxis = new k(this));
        }
        function f() {
          let { isDirty: A, options: { connectNulls: $ }, points: j, xAxis: N, yAxis: M } = this;
          if (A) {
            let D = j.length;
            for (; D--; ) {
              let C = j[D], b = !(C.y === null && $ === !1) && (N?.brokenAxis?.isInAnyBreak(C.x, !0) || M?.brokenAxis?.isInAnyBreak(C.y, !0));
              C.visible = !b && C.options.visible !== !1;
            }
          }
        }
        function S() {
          this.drawBreaks(this.xAxis, ["x"]), this.drawBreaks(this.yAxis, m(this.pointArrayMap, ["y"]));
        }
        function w(A, $) {
          let j, N, M, D = this, C = D.points;
          if (A?.brokenAxis?.hasBreaks) {
            let b = A.brokenAxis;
            $.forEach(function(p) {
              j = b?.breakArray || [], N = A.isXAxis ? A.min : m(D.options.threshold, A.min);
              let L = A?.options?.breaks?.filter(function(B) {
                let T = !0;
                for (let O = 0; O < j.length; O++) {
                  let I = j[O];
                  if (I.from === B.from && I.to === B.to) {
                    T = !1;
                    break;
                  }
                }
                return T;
              });
              C.forEach(function(B) {
                M = m(B["stack" + p.toUpperCase()], B[p]), j.forEach(function(T) {
                  if (u(N) && u(M)) {
                    let O = "";
                    N < T.from && M > T.to || N > T.from && M < T.from ? O = "pointBreak" : (N < T.from && M > T.from && M < T.to || N > T.from && M > T.to && M < T.from) && (O = "pointInBreak"), O && d(A, O, { point: B, brk: T });
                  }
                }), L?.forEach(function(T) {
                  d(A, "pointOutsideOfBreak", { point: B, brk: T });
                });
              });
            });
          }
        }
        function x() {
          let A = this.currentDataGrouping, $ = A?.gapSize, j = this.points.slice(), N = this.yAxis, M = this.options.gapSize, D = j.length - 1;
          if (M && D > 0) {
            let C, b;
            for (this.options.gapUnit !== "value" && (M *= this.basePointRange), $ && $ > M && $ >= this.basePointRange && (M = $); D--; )
              if (b && b.visible !== !1 || (b = j[D + 1]), C = j[D], b.visible !== !1 && C.visible !== !1) {
                if (b.x - C.x > M) {
                  let p = (C.x + b.x) / 2;
                  j.splice(D + 1, 0, { isNull: !0, x: p }), N.stacking && this.options.stacking && ((N.stacking.stacks[this.stackKey][p] = new o(N, N.options.stackLabels, !1, p, this.stack)).total = 0);
                }
                b = C;
              }
          }
          return this.getGraphPath(j);
        }
        h.compose = function(A, $) {
          if (!A.keepProps.includes("brokenAxis")) {
            A.keepProps.push("brokenAxis"), s(A, "init", P), s(A, "afterInit", c), s(A, "afterSetTickPositions", v), s(A, "afterSetOptions", g);
            let j = $.prototype;
            j.drawBreaks = w, j.gappedPath = x, s($, "afterGeneratePoints", f), s($, "afterRender", S);
          }
          return A;
        };
        class k {
          static isInBreak($, j) {
            let N = $.repeat || 1 / 0, M = $.from, D = $.to - $.from, C = j >= M ? (j - M) % N : N - (M - j) % N;
            return $.inclusive ? C <= D : C < D && C !== 0;
          }
          static lin2Val($) {
            let j = this.brokenAxis, N = j && j.breakArray;
            if (!N || !u($))
              return $;
            let M = $, D, C;
            for (C = 0; C < N.length && !((D = N[C]).from >= M); C++)
              (D.to < M || k.isInBreak(D, M)) && (M += D.len);
            return M;
          }
          static val2Lin($) {
            let j = this.brokenAxis, N = j && j.breakArray;
            if (!N || !u($))
              return $;
            let M = $, D, C;
            for (C = 0; C < N.length; C++)
              if ((D = N[C]).to <= $)
                M -= D.len;
              else {
                if (D.from >= $)
                  break;
                if (k.isInBreak(D, $)) {
                  M -= $ - D.from;
                  break;
                }
              }
            return M;
          }
          constructor($) {
            this.hasBreaks = !1, this.axis = $;
          }
          findBreakAt($, j) {
            return l(j, function(N) {
              return N.from < $ && $ < N.to;
            });
          }
          isInAnyBreak($, j) {
            let N = this.axis, M = N.options.breaks || [], D = M.length, C, b, p;
            if (D && u($)) {
              for (; D--; )
                k.isInBreak(M[D], $) && (C = !0, b || (b = m(M[D].showPoints, !N.isXAxis)));
              p = C && j ? C && !b : C;
            }
            return p;
          }
          setBreaks($, j) {
            let N = this, M = N.axis, D = y($) && !!$.length && !!Object.keys($[0]).length;
            M.isDirty = N.hasBreaks !== D, N.hasBreaks = D, $ !== M.options.breaks && (M.options.breaks = M.userOptions.breaks = $), M.forceRedraw = !0, M.series.forEach(function(C) {
              C.isDirty = !0;
            }), D || M.val2lin !== k.val2Lin || (delete M.val2lin, delete M.lin2val), D && (M.userOptions.ordinal = !1, M.lin2val = k.lin2Val, M.val2lin = k.val2Lin, M.setExtremes = function(C, b, p, L, B) {
              if (N.hasBreaks) {
                let T, O = this.options.breaks || [];
                for (; T = N.findBreakAt(C, O); )
                  C = T.to;
                for (; T = N.findBreakAt(b, O); )
                  b = T.from;
                b < C && (b = C);
              }
              M.constructor.prototype.setExtremes.call(this, C, b, p, L, B);
            }, M.setAxisTranslation = function() {
              if (M.constructor.prototype.setAxisTranslation.call(this), N.unitLength = void 0, N.hasBreaks) {
                let C = M.options.breaks || [], b = [], p = [], L = m(M.pointRangePadding, 0), B = 0, T, O, I = M.userMin || M.min, R = M.userMax || M.max, Y, F;
                C.forEach(function(U) {
                  O = U.repeat || 1 / 0, u(I) && u(R) && (k.isInBreak(U, I) && (I += U.to % O - I % O), k.isInBreak(U, R) && (R -= R % O - U.from % O));
                }), C.forEach(function(U) {
                  if (Y = U.from, O = U.repeat || 1 / 0, u(I) && u(R)) {
                    for (; Y - O > I; )
                      Y -= O;
                    for (; Y < I; )
                      Y += O;
                    for (F = Y; F < R; F += O)
                      b.push({ value: F, move: "in" }), b.push({ value: F + U.to - U.from, move: "out", size: U.breakSize });
                  }
                }), b.sort(function(U, Q) {
                  return U.value === Q.value ? (U.move === "in" ? 0 : 1) - (Q.move === "in" ? 0 : 1) : U.value - Q.value;
                }), T = 0, Y = I, b.forEach(function(U) {
                  (T += U.move === "in" ? 1 : -1) === 1 && U.move === "in" && (Y = U.value), T === 0 && u(Y) && (p.push({ from: Y, to: U.value, len: U.value - Y - (U.size || 0) }), B += U.value - Y - (U.size || 0));
                }), N.breakArray = p, u(I) && u(R) && u(M.min) && (N.unitLength = R - I - B + L, d(M, "afterBreaks"), M.staticScale ? M.transA = M.staticScale : N.unitLength && (M.transA *= (R - M.min + L) / N.unitLength), L && (M.minPixelPadding = M.transA * (M.minPointOffset || 0)), M.min = I, M.max = R);
              }
            }), m(j, !0) && M.chart.redraw();
          }
        }
        h.Additions = k;
      }(r || (r = {})), r;
    }), i(n, "masters/modules/broken-axis.src.js", [n["Core/Globals.js"], n["Core/Axis/BrokenAxis.js"]], function(o, a) {
      return o.BrokenAxis = o.BrokenAxis || a, o.BrokenAxis.compose(o.Axis, o.Series), o;
    }), i(n, "Extensions/DataGrouping/ApproximationRegistry.js", [], function() {
      return {};
    }), i(n, "Extensions/DataGrouping/ApproximationDefaults.js", [n["Extensions/DataGrouping/ApproximationRegistry.js"], n["Core/Utilities.js"]], function(o, a) {
      let { arrayMax: r, arrayMin: s, correctFloat: l, extend: d, isNumber: y } = a;
      function u(c) {
        let g = c.length, v = m(c);
        return y(v) && g && (v = l(v / g)), v;
      }
      function m(c) {
        let g = c.length, v;
        if (!g && c.hasNulls)
          v = null;
        else if (g)
          for (v = 0; g--; )
            v += c[g];
        return v;
      }
      let h = { average: u, averages: function() {
        let c = [];
        return [].forEach.call(arguments, function(g) {
          c.push(u(g));
        }), c[0] === void 0 ? void 0 : c;
      }, close: function(c) {
        return c.length ? c[c.length - 1] : c.hasNulls ? null : void 0;
      }, high: function(c) {
        return c.length ? r(c) : c.hasNulls ? null : void 0;
      }, hlc: function(c, g, v) {
        if (c = o.high(c), g = o.low(g), v = o.close(v), y(c) || y(g) || y(v))
          return [c, g, v];
      }, low: function(c) {
        return c.length ? s(c) : c.hasNulls ? null : void 0;
      }, ohlc: function(c, g, v, P) {
        if (c = o.open(c), g = o.high(g), v = o.low(v), P = o.close(P), y(c) || y(g) || y(v) || y(P))
          return [c, g, v, P];
      }, open: function(c) {
        return c.length ? c[0] : c.hasNulls ? null : void 0;
      }, range: function(c, g) {
        return c = o.low(c), g = o.high(g), y(c) || y(g) ? [c, g] : c === null && g === null ? null : void 0;
      }, sum: m };
      return d(o, h), h;
    }), i(n, "Extensions/DataGrouping/DataGroupingDefaults.js", [], function() {
      return { common: { groupPixelWidth: 2, dateTimeLabelFormats: { millisecond: ["%A, %e %b, %H:%M:%S.%L", "%A, %e %b, %H:%M:%S.%L", "-%H:%M:%S.%L"], second: ["%A, %e %b, %H:%M:%S", "%A, %e %b, %H:%M:%S", "-%H:%M:%S"], minute: ["%A, %e %b, %H:%M", "%A, %e %b, %H:%M", "-%H:%M"], hour: ["%A, %e %b, %H:%M", "%A, %e %b, %H:%M", "-%H:%M"], day: ["%A, %e %b %Y", "%A, %e %b", "-%A, %e %b %Y"], week: ["Week from %A, %e %b %Y", "%A, %e %b", "-%A, %e %b %Y"], month: ["%B %Y", "%B", "-%B %Y"], year: ["%Y", "%Y", "-%Y"] } }, seriesSpecific: { line: {}, spline: {}, area: {}, areaspline: {}, arearange: {}, column: { groupPixelWidth: 10 }, columnrange: { groupPixelWidth: 10 }, candlestick: { groupPixelWidth: 10 }, ohlc: { groupPixelWidth: 5 }, hlc: { groupPixelWidth: 5 }, heikinashi: { groupPixelWidth: 10 } }, units: [["millisecond", [1, 2, 5, 10, 20, 25, 50, 100, 200, 500]], ["second", [1, 2, 5, 10, 15, 30]], ["minute", [1, 2, 5, 10, 15, 30]], ["hour", [1, 2, 3, 4, 6, 8, 12]], ["day", [1]], ["week", [1]], ["month", [1, 3, 6]], ["year", null]] };
    }), i(n, "Extensions/DataGrouping/DataGroupingAxisComposition.js", [n["Extensions/DataGrouping/DataGroupingDefaults.js"], n["Core/Utilities.js"]], function(o, a) {
      let r, { addEvent: s, extend: l, merge: d, pick: y } = a;
      function u(g) {
        let v = this, P = v.series;
        P.forEach(function(f) {
          f.groupPixelWidth = void 0;
        }), P.forEach(function(f) {
          f.groupPixelWidth = v.getGroupPixelWidth && v.getGroupPixelWidth(), f.groupPixelWidth && (f.hasProcessed = !0), f.applyGrouping(!!g.hasExtremesChanged);
        });
      }
      function m() {
        let g = this.series, v = g.length, P = 0, f = !1, S, w;
        for (; v--; )
          (w = g[v].options.dataGrouping) && (P = Math.max(P, y(w.groupPixelWidth, o.common.groupPixelWidth)), S = (g[v].processedXData || g[v].data).length, (g[v].groupPixelWidth || S > this.chart.plotSizeX / P || S && w.forced) && (f = !0));
        return f ? P : 0;
      }
      function h() {
        this.series.forEach(function(g) {
          g.hasProcessed = !1;
        });
      }
      function c(g, v) {
        let P;
        if (v = y(v, !0), g || (g = { forced: !1, units: null }), this instanceof r)
          for (P = this.series.length; P--; )
            this.series[P].update({ dataGrouping: g }, !1);
        else
          this.chart.options.series.forEach(function(f) {
            f.dataGrouping = typeof g == "boolean" ? g : d(g, f.dataGrouping);
          });
        this.ordinal && (this.ordinal.slope = void 0), v && this.chart.redraw();
      }
      return { compose: function(g) {
        r = g;
        let v = g.prototype;
        v.applyGrouping || (s(g, "afterSetScale", h), s(g, "postProcessData", u), l(v, { applyGrouping: u, getGroupPixelWidth: m, setDataGrouping: c }));
      } };
    }), i(n, "Extensions/DataGrouping/DataGroupingSeriesComposition.js", [n["Extensions/DataGrouping/ApproximationRegistry.js"], n["Extensions/DataGrouping/DataGroupingDefaults.js"], n["Core/Axis/DateTimeAxis.js"], n["Core/Defaults.js"], n["Core/Series/SeriesRegistry.js"], n["Core/Utilities.js"]], function(o, a, r, s, l, d) {
      let { series: { prototype: y } } = l, { addEvent: u, defined: m, error: h, extend: c, isNumber: g, merge: v, pick: P } = d, f = y.generatePoints;
      function S(j) {
        var N;
        let M, D, C = this.chart, b = this.options.dataGrouping, p = this.allowDG !== !1 && b && P(b.enabled, C.options.isStock), L = this.reserveSpace(), B = this.currentDataGrouping, T, O, I = !1;
        p && !this.requireSorting && (this.requireSorting = I = !0);
        let R = !!(this.isCartesian && !this.isDirty && !this.xAxis.isDirty && !this.yAxis.isDirty && !j) || !p;
        if (I && (this.requireSorting = !1), R)
          return;
        this.destroyGroupedData();
        let Y = b.groupAll ? this.xData : this.processedXData, F = b.groupAll ? this.yData : this.processedYData, U = C.plotSizeX, Q = this.xAxis, J = Q.options.ordinal, ee = this.groupPixelWidth;
        if (ee && Y && Y.length && U) {
          D = !0, this.isDirty = !0, this.points = null;
          let V = Q.getExtremes(), G = V.min, W = V.max, ae = J && Q.ordinal && Q.ordinal.getGroupIntervalFactor(G, W, this) || 1, z = ee * (W - G) / U * ae, q = Q.getTimeTicks(r.Additions.prototype.normalizeTimeTickInterval(z, b.units || a.units), Math.min(G, Y[0]), Math.max(W, Y[Y.length - 1]), Q.options.startOfWeek, Y, this.closestPointRange), Z = y.groupData.apply(this, [Y, F, q, b.approximation]), ne = Z.groupedXData, ie = Z.groupedYData, re = 0;
          for (b && b.smoothed && ne.length && (b.firstAnchor = "firstPoint", b.anchor = "middle", b.lastAnchor = "lastPoint", h(32, !1, C, { "dataGrouping.smoothed": "use dataGrouping.anchor" })), M = 1; M < q.length; M++)
            q.info.segmentStarts && q.info.segmentStarts.indexOf(M) !== -1 || (re = Math.max(q[M] - q[M - 1], re));
          (T = q.info).gapSize = re, this.closestPointRange = q.info.totalRange, this.groupMap = Z.groupMap, this.currentDataGrouping = T, function(de, me, ce) {
            let pe = de.options.dataGrouping, xe = de.currentDataGrouping && de.currentDataGrouping.gapSize;
            if (!(pe && de.xData && xe && de.groupMap))
              return;
            let le = me.length - 1, se = pe.anchor, he = pe.firstAnchor, ve = pe.lastAnchor, ye = me.length - 1, be = 0;
            if (he && de.xData[0] >= me[0]) {
              let ke;
              be++;
              let we = de.groupMap[0].start, Le = de.groupMap[0].length;
              g(we) && g(Le) && (ke = we + (Le - 1)), me[0] = { start: me[0], middle: me[0] + 0.5 * xe, end: me[0] + xe, firstPoint: de.xData[0], lastPoint: ke && de.xData[ke] }[he];
            }
            if (le > 0 && ve && xe && me[le] >= ce - xe) {
              ye--;
              let ke = de.groupMap[de.groupMap.length - 1].start;
              me[le] = { start: me[le], middle: me[le] + 0.5 * xe, end: me[le] + xe, firstPoint: ke && de.xData[ke], lastPoint: de.xData[de.xData.length - 1] }[ve];
            }
            if (se && se !== "start") {
              let ke = xe * { middle: 0.5, end: 1 }[se];
              for (; ye >= be; )
                me[ye] += ke, ye--;
            }
          }(this, ne, W), L && (m((N = ne)[0]) && g(Q.min) && g(Q.dataMin) && N[0] < Q.min && ((!m(Q.options.min) && Q.min <= Q.dataMin || Q.min === Q.dataMin) && (Q.min = Math.min(N[0], Q.min)), Q.dataMin = Math.min(N[0], Q.dataMin)), m(N[N.length - 1]) && g(Q.max) && g(Q.dataMax) && N[N.length - 1] > Q.max && ((!m(Q.options.max) && g(Q.dataMax) && Q.max >= Q.dataMax || Q.max === Q.dataMax) && (Q.max = Math.max(N[N.length - 1], Q.max)), Q.dataMax = Math.max(N[N.length - 1], Q.dataMax))), b.groupAll && (this.allGroupedData = ie, ne = (O = this.cropData(ne, ie, Q.min, Q.max)).xData, ie = O.yData, this.cropStart = O.start), this.processedXData = ne, this.processedYData = ie;
        } else
          this.groupMap = null, this.currentDataGrouping = void 0;
        this.hasGroupedData = D, this.preventGraphAnimation = (B && B.totalRange) !== (T && T.totalRange);
      }
      function w() {
        this.groupedData && (this.groupedData.forEach(function(j, N) {
          j && (this.groupedData[N] = j.destroy ? j.destroy() : null);
        }, this), this.groupedData.length = 0, delete this.allGroupedData);
      }
      function x() {
        f.apply(this), this.destroyGroupedData(), this.groupedData = this.hasGroupedData ? this.points : null;
      }
      function k() {
        return this.is("arearange") ? "range" : this.is("ohlc") ? "ohlc" : this.is("hlc") ? "hlc" : this.is("column") || this.options.cumulative ? "sum" : "average";
      }
      function A(j, N, M, D) {
        let C = this, b = C.data, p = C.options && C.options.data, L = [], B = [], T = [], O = j.length, I = !!N, R = [], Y = C.pointArrayMap, F = Y && Y.length, U = ["x"].concat(Y || ["y"]), Q = this.options.dataGrouping && this.options.dataGrouping.groupAll, J, ee, V, G = 0, W = 0, ae = typeof D == "function" ? D : D && o[D] ? o[D] : o[C.getDGApproximation && C.getDGApproximation() || "average"];
        if (F) {
          let q = Y.length;
          for (; q--; )
            R.push([]);
        } else
          R.push([]);
        let z = F || 1;
        for (let q = 0; q <= O; q++)
          if (!(j[q] < M[0])) {
            for (; M[G + 1] !== void 0 && j[q] >= M[G + 1] || q === O; ) {
              J = M[G], C.dataGroupInfo = { start: Q ? W : C.cropStart + W, length: R[0].length, groupStart: J }, V = ae.apply(C, R), C.pointClass && !m(C.dataGroupInfo.options) && (C.dataGroupInfo.options = v(C.pointClass.prototype.optionsToObject.call({ series: C }, C.options.data[C.cropStart + W])), U.forEach(function(Z) {
                delete C.dataGroupInfo.options[Z];
              })), V !== void 0 && (L.push(J), B.push(V), T.push(C.dataGroupInfo)), W = q;
              for (let Z = 0; Z < z; Z++)
                R[Z].length = 0, R[Z].hasNulls = !1;
              if (G += 1, q === O)
                break;
            }
            if (q === O)
              break;
            if (Y) {
              let Z, ne = C.options.dataGrouping && C.options.dataGrouping.groupAll ? q : C.cropStart + q, ie = b && b[ne] || C.pointClass.prototype.applyOptions.apply({ series: C }, [p[ne]]);
              for (let re = 0; re < F; re++)
                g(Z = ie[Y[re]]) ? R[re].push(Z) : Z === null && (R[re].hasNulls = !0);
            } else
              g(ee = I ? N[q] : null) ? R[0].push(ee) : ee === null && (R[0].hasNulls = !0);
          }
        return { groupedXData: L, groupedYData: B, groupMap: T };
      }
      function $(j) {
        let N = j.options, M = this.type, D = this.chart.options.plotOptions, C = this.useCommonDataGrouping && a.common, b = a.seriesSpecific, p = s.defaultOptions.plotOptions[M].dataGrouping;
        if (D && (b[M] || C)) {
          let L = this.chart.rangeSelector;
          p || (p = v(a.common, b[M])), N.dataGrouping = v(C, p, D.series && D.series.dataGrouping, D[M].dataGrouping, this.userOptions.dataGrouping, !N.isInternal && L && g(L.selected) && L.buttonOptions[L.selected].dataGrouping);
        }
      }
      return { compose: function(j) {
        let N = j.prototype;
        N.applyGrouping || (u(j.prototype.pointClass, "update", function() {
          if (this.dataGroup)
            return h(24, !1, this.series.chart), !1;
        }), u(j, "afterSetOptions", $), u(j, "destroy", w), c(N, { applyGrouping: S, destroyGroupedData: w, generatePoints: x, getDGApproximation: k, groupData: A }));
      }, groupData: A };
    }), i(n, "Extensions/DataGrouping/DataGrouping.js", [n["Extensions/DataGrouping/DataGroupingAxisComposition.js"], n["Extensions/DataGrouping/DataGroupingDefaults.js"], n["Extensions/DataGrouping/DataGroupingSeriesComposition.js"], n["Core/Templating.js"], n["Core/Globals.js"], n["Core/Utilities.js"]], function(o, a, r, s, l, d) {
      let { format: y } = s, { composed: u } = l, { addEvent: m, extend: h, isNumber: c, pick: g, pushUnique: v } = d;
      function P(f) {
        let S = this.chart, w = S.time, x = f.labelConfig, k = x.series, A = x.point, $ = k.options, j = k.tooltipOptions, N = $.dataGrouping, M = k.xAxis, D = j.xDateFormat, C, b, p, L, B, T = j[f.isFooter ? "footerFormat" : "headerFormat"];
        if (M && M.options.type === "datetime" && N && c(x.key)) {
          b = k.currentDataGrouping, p = N.dateTimeLabelFormats || a.common.dateTimeLabelFormats, b ? (L = p[b.unitName], b.count === 1 ? D = L[0] : (D = L[1], C = L[2])) : !D && p && M.dateTime && (D = M.dateTime.getXDateFormat(x.x, j.dateTimeLabelFormats));
          let O = g(k.groupMap?.[A.index].groupStart, x.key), I = O + b?.totalRange - 1;
          B = w.dateFormat(D, O), C && (B += w.dateFormat(C, I)), k.chart.styledMode && (T = this.styledModeFormat(T)), f.text = y(T, { point: h(x.point, { key: B }), series: k }, S), f.preventDefault();
        }
      }
      return { compose: function(f, S, w) {
        o.compose(f), r.compose(S), w && v(u, "DataGrouping") && m(w, "headerFormatter", P);
      }, groupData: r.groupData };
    }), i(n, "masters/modules/datagrouping.src.js", [n["Core/Globals.js"], n["Extensions/DataGrouping/ApproximationDefaults.js"], n["Extensions/DataGrouping/ApproximationRegistry.js"], n["Extensions/DataGrouping/DataGrouping.js"]], function(o, a, r, s) {
      return o.dataGrouping = o.dataGrouping || {}, o.dataGrouping.approximationDefaults = o.dataGrouping.approximationDefaults || a, o.dataGrouping.approximations = o.dataGrouping.approximations || r, s.compose(o.Axis, o.Series, o.Tooltip), o;
    }), i(n, "Extensions/Annotations/NavigationBindingsUtilities.js", [n["Core/Utilities.js"]], function(o) {
      let { defined: a, isNumber: r, pick: s } = o, l = { backgroundColor: "string", borderColor: "string", borderRadius: "string", color: "string", fill: "string", fontSize: "string", labels: "string", name: "string", stroke: "string", title: "string" };
      return { annotationsFieldsTypes: l, getAssignedAxis: function(d) {
        return d.filter((y) => {
          let u = y.axis.getExtremes(), m = u.min, h = u.max, c = s(y.axis.minPointOffset, 0);
          return r(m) && r(h) && y.value >= m - c && y.value <= h + c && !y.axis.options.isInternal;
        })[0];
      }, getFieldType: function(d, y) {
        let u = l[d], m = typeof y;
        return a(u) && (m = u), { string: "text", number: "number", boolean: "checkbox" }[m];
      } };
    }), i(n, "Extensions/MouseWheelZoom/MouseWheelZoom.js", [n["Core/Utilities.js"], n["Extensions/Annotations/NavigationBindingsUtilities.js"]], function(o, a) {
      let r, { addEvent: s, isObject: l, pick: d, defined: y, merge: u } = o, { getAssignedAxis: m } = a, h = [], c = { enabled: !0, sensitivity: 1.1 }, g = (f) => (l(f) || (f = { enabled: f ?? !0 }), u(c, f)), v = function(f, S, w, x, k, A, $) {
        let j = d($.type, f.zooming.type, ""), N = [];
        j === "x" ? N = w : j === "y" ? N = x : j === "xy" && (N = f.axes);
        let M = f.transform({ axes: N, to: { x: k - 5, y: A - 5, width: 10, height: 10 }, from: { x: k - 5 * S, y: A - 5 * S, width: 10 * S, height: 10 * S }, trigger: "mousewheel" });
        return M && (y(r) && clearTimeout(r), r = setTimeout(() => {
          f.pointer?.drop();
        }, 400)), M;
      };
      function P() {
        let f = g(this.zooming.mouseWheel);
        f.enabled && s(this.container, "wheel", (S) => {
          S = this.pointer?.normalize(S) || S;
          let { pointer: w } = this, x = w && !w.inClass(S.target, "highcharts-no-mousewheel");
          if (this.isInsidePlot(S.chartX - this.plotLeft, S.chartY - this.plotTop) && x) {
            let k = f.sensitivity || 1.1, A = S.detail || (S.deltaY || 0) / 120, $ = m(w.getCoordinates(S).xAxis), j = m(w.getCoordinates(S).yAxis);
            v(this, Math.pow(k, A), $ ? [$.axis] : this.xAxis, j ? [j.axis] : this.yAxis, S.chartX, S.chartY, f) && S.preventDefault?.();
          }
        });
      }
      return { compose: function(f) {
        h.indexOf(f) === -1 && (h.push(f), s(f, "afterGetContainer", P));
      } };
    }), i(n, "masters/modules/mouse-wheel-zoom.src.js", [n["Core/Globals.js"], n["Extensions/MouseWheelZoom/MouseWheelZoom.js"]], function(o, a) {
      return o.MouseWheelZoom = o.MouseWheelZoom || a, o.MouseWheelZoom.compose(o.Chart), o;
    }), i(n, "masters/modules/stock.src.js", [n["Core/Globals.js"], n["Series/DataModifyComposition.js"], n["Stock/Navigator/Navigator.js"], n["Core/Axis/OrdinalAxis.js"], n["Stock/RangeSelector/RangeSelector.js"], n["Stock/Scrollbar/Scrollbar.js"], n["Core/Chart/StockChart.js"], n["Series/OHLC/OHLCSeries.js"], n["Series/Flags/FlagsSeries.js"]], function(o, a, r, s, l, d, y, u, m) {
      return o.Navigator = o.Navigator || r, o.OrdinalAxis = o.OrdinalAxis || s, o.RangeSelector = o.RangeSelector || l, o.Scrollbar = o.Scrollbar || d, o.stockChart = o.stockChart || y.stockChart, o.StockChart = o.StockChart || o.stockChart, o.extend(o.StockChart, y), a.compose(o.Series, o.Axis, o.Point), m.compose(o.Renderer), u.compose(o.Series), o.Navigator.compose(o.Chart, o.Axis, o.Series), o.OrdinalAxis.compose(o.Axis, o.Series, o.Chart), o.RangeSelector.compose(o.Axis, o.Chart), o.Scrollbar.compose(o.Axis), o.StockChart.compose(o.Chart, o.Axis, o.Series, o.SVGRenderer), o;
    });
  });
})(Ek);
var Y6 = Ek.exports;
const q6 = /* @__PURE__ */ en(Y6);
var Dk = { exports: {} };
(function(e) {
  /**
  * Highcharts JS v11.4.8 (2024-08-29)
  *
  * Accessibility module
  *
  * (c) 2010-2024 Highsoft AS
  * Author: Oystein Moseng
  *
  * License: www.highcharts.com/license
  */
  (function(t) {
    e.exports ? (t.default = t, e.exports = t) : t(typeof Highcharts < "u" ? Highcharts : void 0);
  })(function(t) {
    var n = t ? t._modules : {};
    function i(o, a, r, s) {
      o.hasOwnProperty(a) || (o[a] = s.apply(null, r), typeof CustomEvent == "function" && t.win.dispatchEvent(new CustomEvent("HighchartsModuleLoaded", { detail: { path: a, module: o[a] } })));
    }
    i(n, "Accessibility/Utils/HTMLUtilities.js", [n["Core/Globals.js"], n["Core/Utilities.js"]], function(o, a) {
      let { doc: r, win: s } = o, { css: l } = a, d = s.EventTarget && new s.EventTarget() || "none";
      function y(m) {
        if (typeof s.MouseEvent == "function")
          return new s.MouseEvent(m.type, m);
        if (r.createEvent) {
          let h = r.createEvent("MouseEvent");
          if (h.initMouseEvent)
            return h.initMouseEvent(m.type, m.bubbles, m.cancelable, m.view || s, m.detail, m.screenX, m.screenY, m.clientX, m.clientY, m.ctrlKey, m.altKey, m.shiftKey, m.metaKey, m.button, m.relatedTarget), h;
        }
        return u(m.type);
      }
      function u(m, h, c) {
        let g = h || { x: 0, y: 0 };
        if (typeof s.MouseEvent == "function")
          return new s.MouseEvent(m, { bubbles: !0, cancelable: !0, composed: !0, button: 0, buttons: 1, relatedTarget: c || d, view: s, detail: m === "click" ? 1 : 0, screenX: g.x, screenY: g.y, clientX: g.x, clientY: g.y });
        if (r.createEvent) {
          let v = r.createEvent("MouseEvent");
          if (v.initMouseEvent)
            return v.initMouseEvent(m, !0, !0, s, m === "click" ? 1 : 0, g.x, g.y, g.x, g.y, !1, !1, !1, !1, 0, null), v;
        }
        return { type: m };
      }
      return { addClass: function(m, h) {
        m.classList ? m.classList.add(h) : 0 > m.className.indexOf(h) && (m.className += " " + h);
      }, cloneMouseEvent: y, cloneTouchEvent: function(m) {
        let h = (g) => {
          let v = [];
          for (let P = 0; P < g.length; ++P) {
            let f = g.item(P);
            f && v.push(f);
          }
          return v;
        };
        if (typeof s.TouchEvent == "function") {
          let g = new s.TouchEvent(m.type, { touches: h(m.touches), targetTouches: h(m.targetTouches), changedTouches: h(m.changedTouches), ctrlKey: m.ctrlKey, shiftKey: m.shiftKey, altKey: m.altKey, metaKey: m.metaKey, bubbles: m.bubbles, cancelable: m.cancelable, composed: m.composed, detail: m.detail, view: m.view });
          return m.defaultPrevented && g.preventDefault(), g;
        }
        let c = y(m);
        return c.touches = m.touches, c.changedTouches = m.changedTouches, c.targetTouches = m.targetTouches, c;
      }, escapeStringForHTML: function(m) {
        return m.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;").replace(/\//g, "&#x2F;");
      }, getElement: function(m) {
        return r.getElementById(m);
      }, getFakeMouseEvent: u, getHeadingTagNameForElement: function(m) {
        let h = (P) => "h" + Math.min(6, parseInt(P.slice(1), 10) + 1), c = (P) => /^H[1-6]$/i.test(P), g = (P) => {
          let f = P;
          for (; f = f.previousSibling; ) {
            let S = f.tagName || "";
            if (c(S))
              return S;
          }
          return "";
        }, v = (P) => {
          let f = g(P);
          if (f)
            return h(f);
          let S = P.parentElement;
          if (!S)
            return "p";
          let w = S.tagName;
          return c(w) ? h(w) : v(S);
        };
        return v(m);
      }, removeChildNodes: function(m) {
        for (; m.lastChild; )
          m.removeChild(m.lastChild);
      }, removeClass: function(m, h) {
        m.classList ? m.classList.remove(h) : m.className = m.className.replace(RegExp(h, "g"), "");
      }, removeElement: function(m) {
        m && m.parentNode && m.parentNode.removeChild(m);
      }, reverseChildNodes: function(m) {
        let h = m.childNodes.length;
        for (; h--; )
          m.appendChild(m.childNodes[h]);
      }, simulatedEventTarget: d, stripHTMLTagsFromString: function(m, h = !1) {
        return typeof m == "string" ? h ? m.replace(/<\/?[^>]+(>|$)/g, "") : m.replace(/<\/?(?!\s)[^>]+(>|$)/g, "") : m;
      }, visuallyHideElement: function(m) {
        l(m, { position: "absolute", width: "1px", height: "1px", overflow: "hidden", whiteSpace: "nowrap", clip: "rect(1px, 1px, 1px, 1px)", marginTop: "-3px", "-ms-filter": "progid:DXImageTransform.Microsoft.Alpha(Opacity=1)", filter: "alpha(opacity=1)", opacity: 0.01 });
      } };
    }), i(n, "Accessibility/A11yI18n.js", [n["Core/Templating.js"], n["Core/Utilities.js"]], function(o, a) {
      var r;
      let { format: s } = o, { getNestedProperty: l, pick: d } = a;
      return function(y) {
        function u(h, c, g) {
          let v = (x, k) => {
            let A = x.slice(k || 0), $ = A.indexOf("{"), j = A.indexOf("}");
            if ($ > -1 && j > $)
              return { statement: A.substring($ + 1, j), begin: k + $ + 1, end: k + j };
          }, P = [], f, S, w = 0;
          do
            f = v(h, w), (S = h.substring(w, f && f.begin - 1)).length && P.push({ value: S, type: "constant" }), f && P.push({ value: f.statement, type: "statement" }), w = f ? f.end + 1 : w + 1;
          while (f);
          return P.forEach((x) => {
            x.type === "statement" && (x.value = function(k, A) {
              let $, j, N = k.indexOf("#each("), M = k.indexOf("#plural("), D = k.indexOf("["), C = k.indexOf("]");
              if (N > -1) {
                let p = k.slice(N).indexOf(")") + N, L = k.substring(0, N), B = k.substring(p + 1), T = k.substring(N + 6, p).split(","), O = Number(T[1]), I;
                if (j = "", $ = l(T[0], A)) {
                  I = (O = isNaN(O) ? $.length : O) < 0 ? $.length + O : Math.min(O, $.length);
                  for (let R = 0; R < I; ++R)
                    j += L + $[R] + B;
                }
                return j.length ? j : "";
              }
              if (M > -1) {
                var b;
                let p = k.slice(M).indexOf(")") + M, L = k.substring(M + 8, p).split(",");
                switch (Number(l(L[0], A))) {
                  case 0:
                    j = d(L[4], L[1]);
                    break;
                  case 1:
                    j = d(L[2], L[1]);
                    break;
                  case 2:
                    j = d(L[3], L[1]);
                    break;
                  default:
                    j = L[1];
                }
                return j ? (b = j).trim && b.trim() || b.replace(/^\s+|\s+$/g, "") : "";
              }
              if (D > -1) {
                let p, L = k.substring(0, D), B = Number(k.substring(D + 1, C));
                return $ = l(L, A), !isNaN(B) && $ && (B < 0 ? (p = $[$.length + B]) === void 0 && (p = $[0]) : (p = $[B]) === void 0 && (p = $[$.length - 1])), p !== void 0 ? p : "";
              }
              return "{" + k + "}";
            }(x.value, c));
          }), s(P.reduce((x, k) => x + k.value, ""), c, g);
        }
        function m(h, c) {
          let g = h.split("."), v = this.options.lang, P = 0;
          for (; P < g.length; ++P)
            v = v && v[g[P]];
          return typeof v == "string" ? u(v, c, this) : "";
        }
        y.compose = function(h) {
          let c = h.prototype;
          c.langFormat || (c.langFormat = m);
        }, y.i18nFormat = u;
      }(r || (r = {})), r;
    }), i(n, "Accessibility/Utils/ChartUtilities.js", [n["Core/Globals.js"], n["Accessibility/Utils/HTMLUtilities.js"], n["Core/Utilities.js"]], function(o, a, r) {
      let { doc: s } = o, { stripHTMLTagsFromString: l } = a, { defined: d, find: y, fireEvent: u } = r;
      function m(c) {
        if (c.points && c.points.length) {
          let g = y(c.points, (v) => !!v.graphic);
          return g && g.graphic && g.graphic.element;
        }
      }
      function h(c) {
        let g = m(c);
        return g && g.parentNode || c.graph && c.graph.element || c.group && c.group.element;
      }
      return { fireEventOnWrappedOrUnwrappedElement: function c(g, v) {
        let P = v.type, f = g.hcEvents;
        s.createEvent && (g.dispatchEvent || g.fireEvent) ? g.dispatchEvent ? g.dispatchEvent(v) : g.fireEvent(P, v) : f && f[P] ? u(g, P, v) : g.element && c(g.element, v);
      }, getChartTitle: function(c) {
        return l(c.options.title.text || c.langFormat("accessibility.defaultChartTitle", { chart: c }), c.renderer.forExport);
      }, getAxisDescription: function(c) {
        return c && (c.options.accessibility?.description || c.axisTitle?.textStr || c.options.id || c.categories && "categories" || c.dateTime && "Time" || "values");
      }, getAxisRangeDescription: function(c) {
        let g = c.options || {};
        return g.accessibility && g.accessibility.rangeDescription !== void 0 ? g.accessibility.rangeDescription : c.categories ? function(v) {
          let P = v.chart;
          return v.dataMax && v.dataMin ? P.langFormat("accessibility.axis.rangeCategories", { chart: P, axis: v, numCategories: v.dataMax - v.dataMin + 1 }) : "";
        }(c) : c.dateTime && (c.min === 0 || c.dataMin === 0) ? function(v) {
          let P = v.chart, f = {}, S = v.dataMin || v.min || 0, w = v.dataMax || v.max || 0, x = "Seconds";
          f.Seconds = (w - S) / 1e3, f.Minutes = f.Seconds / 60, f.Hours = f.Minutes / 60, f.Days = f.Hours / 24, ["Minutes", "Hours", "Days"].forEach(function(A) {
            f[A] > 2 && (x = A);
          });
          let k = f[x].toFixed(x !== "Seconds" && x !== "Minutes" ? 1 : 0);
          return P.langFormat("accessibility.axis.timeRange" + x, { chart: P, axis: v, range: k.replace(".0", "") });
        }(c) : function(v) {
          let P = v.chart, f = P.options, S = f && f.accessibility && f.accessibility.screenReaderSection.axisRangeDateFormat || "", w = { min: v.dataMin || v.min || 0, max: v.dataMax || v.max || 0 }, x = function(k) {
            return v.dateTime ? P.time.dateFormat(S, w[k]) : w[k].toString();
          };
          return P.langFormat("accessibility.axis.rangeFromTo", { chart: P, axis: v, rangeFrom: x("min"), rangeTo: x("max") });
        }(c);
      }, getPointFromXY: function(c, g, v) {
        let P = c.length, f;
        for (; P--; )
          if (f = y(c[P].points || [], function(S) {
            return S.x === g && S.y === v;
          }))
            return f;
      }, getSeriesFirstPointElement: m, getSeriesFromName: function(c, g) {
        return g ? (c.series || []).filter(function(v) {
          return v.name === g;
        }) : c.series;
      }, getSeriesA11yElement: h, unhideChartElementFromAT: function c(g, v) {
        v.setAttribute("aria-hidden", !1), v !== g.renderTo && v.parentNode && v.parentNode !== s.body && (Array.prototype.forEach.call(v.parentNode.childNodes, function(P) {
          P.hasAttribute("aria-hidden") || P.setAttribute("aria-hidden", !0);
        }), c(g, v.parentNode));
      }, hideSeriesFromAT: function(c) {
        let g = h(c);
        g && g.setAttribute("aria-hidden", !0);
      }, scrollAxisToPoint: function(c) {
        let g = c.series.xAxis, v = c.series.yAxis, P = g && g.scrollbar ? g : v, f = P && P.scrollbar;
        if (f && d(f.to) && d(f.from)) {
          let S = f.to - f.from, w = function(x, k) {
            if (!d(x.dataMin) || !d(x.dataMax))
              return 0;
            let A = x.toPixels(x.dataMin), $ = x.toPixels(x.dataMax), j = x.coll === "xAxis" ? "x" : "y";
            return (x.toPixels(k[j] || 0) - A) / ($ - A);
          }(P, c);
          f.updatePosition(w - S / 2, w + S / 2), u(f, "changed", { from: f.from, to: f.to, trigger: "scrollbar", DOMEvent: null });
        }
      } };
    }), i(n, "Accessibility/Utils/DOMElementProvider.js", [n["Core/Globals.js"], n["Accessibility/Utils/HTMLUtilities.js"]], function(o, a) {
      let { doc: r } = o, { removeElement: s } = a;
      return class {
        constructor() {
          this.elements = [];
        }
        createElement() {
          let l = r.createElement.apply(r, arguments);
          return this.elements.push(l), l;
        }
        removeElement(l) {
          s(l), this.elements.splice(this.elements.indexOf(l), 1);
        }
        destroyCreatedElements() {
          this.elements.forEach(function(l) {
            s(l);
          }), this.elements = [];
        }
      };
    }), i(n, "Accessibility/Utils/EventProvider.js", [n["Core/Globals.js"], n["Core/Utilities.js"]], function(o, a) {
      let { addEvent: r } = a;
      return class {
        constructor() {
          this.eventRemovers = [];
        }
        addEvent() {
          let s = r.apply(o, arguments);
          return this.eventRemovers.push({ element: arguments[0], remover: s }), s;
        }
        removeEvent(s) {
          let l = this.eventRemovers.map((d) => d.remover).indexOf(s);
          this.eventRemovers[l].remover(), this.eventRemovers.splice(l, 1);
        }
        removeAddedEvents() {
          this.eventRemovers.map((s) => s.remover).forEach((s) => s()), this.eventRemovers = [];
        }
      };
    }), i(n, "Accessibility/AccessibilityComponent.js", [n["Accessibility/Utils/ChartUtilities.js"], n["Accessibility/Utils/DOMElementProvider.js"], n["Accessibility/Utils/EventProvider.js"], n["Accessibility/Utils/HTMLUtilities.js"]], function(o, a, r, s) {
      let { fireEventOnWrappedOrUnwrappedElement: l } = o, { getFakeMouseEvent: d } = s;
      return class {
        destroy() {
        }
        getKeyboardNavigation() {
          return [];
        }
        init() {
        }
        onChartRender() {
        }
        onChartUpdate() {
        }
        initBase(y, u) {
          this.chart = y, this.eventProvider = new r(), this.domElementProvider = new a(), this.proxyProvider = u, this.keyCodes = { left: 37, right: 39, up: 38, down: 40, enter: 13, space: 32, esc: 27, tab: 9, pageUp: 33, pageDown: 34, end: 35, home: 36 };
        }
        addEvent(y, u, m, h) {
          return this.eventProvider.addEvent(y, u, m, h);
        }
        createElement(y, u) {
          return this.domElementProvider.createElement(y, u);
        }
        fakeClickEvent(y) {
          l(y, d("click"));
        }
        destroyBase() {
          this.domElementProvider.destroyCreatedElements(), this.eventProvider.removeAddedEvents();
        }
      };
    }), i(n, "Accessibility/KeyboardNavigationHandler.js", [n["Core/Utilities.js"]], function(o) {
      let { find: a } = o;
      return class {
        constructor(r, s) {
          this.chart = r, this.keyCodeMap = s.keyCodeMap || [], this.validate = s.validate, this.init = s.init, this.terminate = s.terminate, this.response = { success: 1, prev: 2, next: 3, noHandler: 4, fail: 5 };
        }
        run(r) {
          let s = r.which || r.keyCode, l = this.response.noHandler, d = a(this.keyCodeMap, function(y) {
            return y[0].indexOf(s) > -1;
          });
          return d ? l = d[1].call(this, s, r) : s === 9 && (l = this.response[r.shiftKey ? "prev" : "next"]), l;
        }
      };
    }), i(n, "Accessibility/Components/ContainerComponent.js", [n["Accessibility/AccessibilityComponent.js"], n["Accessibility/KeyboardNavigationHandler.js"], n["Accessibility/Utils/ChartUtilities.js"], n["Core/Globals.js"], n["Accessibility/Utils/HTMLUtilities.js"]], function(o, a, r, s, l) {
      let { unhideChartElementFromAT: d, getChartTitle: y } = r, { doc: u } = s, { stripHTMLTagsFromString: m } = l;
      return class extends o {
        onChartUpdate() {
          this.handleSVGTitleElement(), this.setSVGContainerLabel(), this.setGraphicContainerAttrs(), this.setRenderToAttrs(), this.makeCreditsAccessible();
        }
        handleSVGTitleElement() {
          let h = this.chart, c = "highcharts-title-" + h.index, g = m(h.langFormat("accessibility.svgContainerTitle", { chartTitle: y(h) }));
          if (g.length) {
            let v = this.svgTitleElement = this.svgTitleElement || u.createElementNS("http://www.w3.org/2000/svg", "title");
            v.textContent = g, v.id = c, h.renderTo.insertBefore(v, h.renderTo.firstChild);
          }
        }
        setSVGContainerLabel() {
          let h = this.chart, c = h.langFormat("accessibility.svgContainerLabel", { chartTitle: y(h) });
          h.renderer.box && c.length && h.renderer.box.setAttribute("aria-label", c);
        }
        setGraphicContainerAttrs() {
          let h = this.chart, c = h.langFormat("accessibility.graphicContainerLabel", { chartTitle: y(h) });
          c.length && h.container.setAttribute("aria-label", c);
        }
        setRenderToAttrs() {
          let h = this.chart, c = h.options.accessibility.landmarkVerbosity !== "disabled", g = h.langFormat("accessibility.chartContainerLabel", { title: y(h), chart: h });
          g && (h.renderTo.setAttribute("role", c ? "region" : "group"), h.renderTo.setAttribute("aria-label", g));
        }
        makeCreditsAccessible() {
          let h = this.chart, c = h.credits;
          c && (c.textStr && c.element.setAttribute("aria-label", h.langFormat("accessibility.credits", { creditsStr: m(c.textStr, h.renderer.forExport) })), d(h, c.element));
        }
        getKeyboardNavigation() {
          let h = this.chart;
          return new a(h, { keyCodeMap: [], validate: function() {
            return !0;
          }, init: function() {
            let c = h.accessibility;
            c && c.keyboardNavigation.tabindexContainer.focus();
          } });
        }
        destroy() {
          this.chart.renderTo.setAttribute("aria-hidden", !0);
        }
      };
    }), i(n, "Accessibility/FocusBorder.js", [n["Core/Utilities.js"]], function(o) {
      var a;
      let { addEvent: r, pick: s } = o;
      return function(l) {
        let d = ["x", "y", "transform", "width", "height", "r", "d", "stroke-width"];
        function y() {
          let c = this.focusElement, g = this.options.accessibility.keyboardNavigation.focusBorder;
          c && (c.removeFocusBorder(), g.enabled && c.addFocusBorder(g.margin, { stroke: g.style.color, strokeWidth: g.style.lineWidth, r: g.style.borderRadius }));
        }
        function u(c, g) {
          let v = this.options.accessibility.keyboardNavigation.focusBorder, P = g || c.element;
          P && P.focus && (P.hcEvents && P.hcEvents.focusin || r(P, "focusin", function() {
          }), P.focus(), v.hideBrowserFocusOutline && (P.style.outline = "none")), this.focusElement && this.focusElement.removeFocusBorder(), this.focusElement = c, this.renderFocusBorder();
        }
        function m(c, g) {
          this.focusBorder && this.removeFocusBorder();
          let v = this.getBBox(), P = s(c, 3), f = this.parentGroup, S = this.scaleX || f && f.scaleX, w = this.scaleY || f && f.scaleY, x = (S ? !w : w) ? Math.abs(S || w || 1) : (Math.abs(S || 1) + Math.abs(w || 1)) / 2;
          v.x += this.translateX ? this.translateX : 0, v.y += this.translateY ? this.translateY : 0;
          let k = v.x - P, A = v.y - P, $ = v.width + 2 * P, j = v.height + 2 * P, N = !!this.text;
          if (this.element.nodeName === "text" || N) {
            let M, D, C = !!this.rotation, b = N ? { x: C ? 1 : 0, y: 0 } : (M = 0, D = 0, this.attr("text-anchor") === "middle" ? M = D = 0.5 : this.rotation ? M = 0.25 : D = 0.75, { x: M, y: D }), p = +this.attr("x"), L = +this.attr("y");
            if (isNaN(p) || (k = p - v.width * b.x - P), isNaN(L) || (A = L - v.height * b.y - P), N && C) {
              let B = $;
              $ = j, j = B, isNaN(p) || (k = p - v.height * b.x - P), isNaN(L) || (A = L - v.width * b.y - P);
            }
          }
          this.focusBorder = this.renderer.rect(k, A, $, j, parseInt((g && g.r || 0).toString(), 10) / x).addClass("highcharts-focus-border").attr({ zIndex: 99 }).add(f), this.renderer.styledMode || this.focusBorder.attr({ stroke: g && g.stroke, "stroke-width": (g && g.strokeWidth || 0) / x }), function(M, ...D) {
            M.focusBorderUpdateHooks || (M.focusBorderUpdateHooks = {}, d.forEach((C) => {
              let b = C + "Setter", p = M[b] || M._defaultSetter;
              M.focusBorderUpdateHooks[b] = p, M[b] = function() {
                let L = p.apply(M, arguments);
                return M.addFocusBorder.apply(M, D), L;
              };
            }));
          }(this, c, g), function(M) {
            if (M.focusBorderDestroyHook)
              return;
            let D = M.destroy;
            M.destroy = function() {
              return M.focusBorder && M.focusBorder.destroy && M.focusBorder.destroy(), D.apply(M, arguments);
            }, M.focusBorderDestroyHook = D;
          }(this);
        }
        function h() {
          var c;
          c = this, c.focusBorderUpdateHooks && (Object.keys(c.focusBorderUpdateHooks).forEach((g) => {
            let v = c.focusBorderUpdateHooks[g];
            v === c._defaultSetter ? delete c[g] : c[g] = v;
          }), delete c.focusBorderUpdateHooks), this.focusBorderDestroyHook && (this.destroy = this.focusBorderDestroyHook, delete this.focusBorderDestroyHook), this.focusBorder && (this.focusBorder.destroy(), delete this.focusBorder);
        }
        l.compose = function(c, g) {
          let v = c.prototype, P = g.prototype;
          v.renderFocusBorder || (v.renderFocusBorder = y, v.setFocusToElement = u), P.addFocusBorder || (P.addFocusBorder = m, P.removeFocusBorder = h);
        };
      }(a || (a = {})), a;
    }), i(n, "Accessibility/Utils/Announcer.js", [n["Core/Renderer/HTML/AST.js"], n["Accessibility/Utils/DOMElementProvider.js"], n["Core/Globals.js"], n["Accessibility/Utils/HTMLUtilities.js"], n["Core/Utilities.js"]], function(o, a, r, s, l) {
      let { doc: d } = r, { addClass: y, visuallyHideElement: u } = s, { attr: m } = l;
      return class {
        constructor(h, c) {
          this.chart = h, this.domElementProvider = new a(), this.announceRegion = this.addAnnounceRegion(c);
        }
        destroy() {
          this.domElementProvider.destroyCreatedElements();
        }
        announce(h) {
          o.setElementHTML(this.announceRegion, h), this.clearAnnouncementRegionTimer && clearTimeout(this.clearAnnouncementRegionTimer), this.clearAnnouncementRegionTimer = setTimeout(() => {
            this.announceRegion.innerHTML = o.emptyHTML, delete this.clearAnnouncementRegionTimer;
          }, 3e3);
        }
        addAnnounceRegion(h) {
          let c = this.chart.announcerContainer || this.createAnnouncerContainer(), g = this.domElementProvider.createElement("div");
          return m(g, { "aria-hidden": !1, "aria-live": h, "aria-atomic": !0 }), this.chart.styledMode ? y(g, "highcharts-visually-hidden") : u(g), c.appendChild(g), g;
        }
        createAnnouncerContainer() {
          let h = this.chart, c = d.createElement("div");
          return m(c, { "aria-hidden": !1, class: "highcharts-announcer-container" }), c.style.position = "relative", h.renderTo.insertBefore(c, h.renderTo.firstChild), h.announcerContainer = c, c;
        }
      };
    }), i(n, "Accessibility/Components/AnnotationsA11y.js", [n["Accessibility/Utils/HTMLUtilities.js"]], function(o) {
      let { escapeStringForHTML: a, stripHTMLTagsFromString: r } = o;
      function s(u) {
        return (u.annotations || []).reduce((m, h) => (h.options && h.options.visible !== !1 && (m = m.concat(h.labels)), m), []);
      }
      function l(u) {
        return u.options && u.options.accessibility && u.options.accessibility.description || u.graphic && u.graphic.text && u.graphic.text.textStr || "";
      }
      function d(u) {
        let m = u.options && u.options.accessibility && u.options.accessibility.description;
        if (m)
          return m;
        let h = u.chart, c = l(u), g = u.points, v = (x) => x.graphic && x.graphic.element && x.graphic.element.getAttribute("aria-label") || "", P = g.filter((x) => !!x.graphic).map((x) => {
          let k = x.accessibility && x.accessibility.valueDescription || v(x), A = x && x.series.name || "";
          return (A ? A + ", " : "") + "data point " + k;
        }).filter((x) => !!x), f = P.length, S = f > 1 ? "MultiplePoints" : f ? "SinglePoint" : "NoPoints", w = { annotationText: c, annotation: u, numPoints: f, annotationPoint: P[0], additionalAnnotationPoints: P.slice(1) };
        return h.langFormat("accessibility.screenReaderSection.annotations.description" + S, w);
      }
      function y(u) {
        return s(u).map((m) => {
          let h = a(r(d(m), u.renderer.forExport));
          return h ? `<li>${h}</li>` : "";
        });
      }
      return { getAnnotationsInfoHTML: function(u) {
        let m = u.annotations;
        return m && m.length ? `<ul style="list-style-type: none">${y(u).join(" ")}</ul>` : "";
      }, getAnnotationLabelDescription: d, getAnnotationListItems: y, getPointAnnotationTexts: function(u) {
        let m = s(u.series.chart).filter((h) => h.points.indexOf(u) > -1);
        return m.length ? m.map((h) => `${l(h)}`) : [];
      } };
    }), i(n, "Accessibility/Components/InfoRegionsComponent.js", [n["Accessibility/A11yI18n.js"], n["Accessibility/AccessibilityComponent.js"], n["Accessibility/Utils/Announcer.js"], n["Accessibility/Components/AnnotationsA11y.js"], n["Core/Renderer/HTML/AST.js"], n["Accessibility/Utils/ChartUtilities.js"], n["Core/Templating.js"], n["Core/Globals.js"], n["Accessibility/Utils/HTMLUtilities.js"], n["Core/Utilities.js"]], function(o, a, r, s, l, d, y, u, m, h) {
      let { getAnnotationsInfoHTML: c } = s, { getAxisDescription: g, getAxisRangeDescription: v, getChartTitle: P, unhideChartElementFromAT: f } = d, { format: S } = y, { doc: w } = u, { addClass: x, getElement: k, getHeadingTagNameForElement: A, stripHTMLTagsFromString: $, visuallyHideElement: j } = m, { attr: N, pick: M, replaceNested: D } = h;
      function C(b) {
        return D(b, [/<([\w\-.:!]+)\b[^<>]*>\s*<\/\1>/g, ""]);
      }
      return class extends a {
        constructor() {
          super(...arguments), this.screenReaderSections = {};
        }
        init() {
          let b = this.chart, p = this;
          this.initRegionsDefinitions(), this.addEvent(b, "aftergetTableAST", function(L) {
            p.onDataTableCreated(L);
          }), this.addEvent(b, "afterViewData", function(L) {
            L.wasHidden && (p.dataTableDiv = L.element, setTimeout(function() {
              p.focusDataTable();
            }, 300));
          }), this.addEvent(b, "afterHideData", function() {
            p.viewDataTableButton && p.viewDataTableButton.setAttribute("aria-expanded", "false");
          }), b.exporting && this.addEvent(b, "afterPrint", function() {
            p.updateAllScreenReaderSections();
          }), this.announcer = new r(b, "assertive");
        }
        initRegionsDefinitions() {
          let b = this, p = this.chart.options.accessibility;
          this.screenReaderSections = { before: { element: null, buildContent: function(L) {
            let B = p.screenReaderSection.beforeChartFormatter;
            return B ? B(L) : b.defaultBeforeChartFormatter(L);
          }, insertIntoDOM: function(L, B) {
            B.renderTo.insertBefore(L, B.renderTo.firstChild);
          }, afterInserted: function() {
            b.sonifyButtonId !== void 0 && b.initSonifyButton(b.sonifyButtonId), b.dataTableButtonId !== void 0 && b.initDataTableButton(b.dataTableButtonId);
          } }, after: { element: null, buildContent: function(L) {
            let B = p.screenReaderSection.afterChartFormatter;
            return B ? B(L) : b.defaultAfterChartFormatter();
          }, insertIntoDOM: function(L, B) {
            B.renderTo.insertBefore(L, B.container.nextSibling);
          }, afterInserted: function() {
            b.chart.accessibility && p.keyboardNavigation.enabled && b.chart.accessibility.keyboardNavigation.updateExitAnchor();
          } } };
        }
        onChartRender() {
          this.linkedDescriptionElement = this.getLinkedDescriptionElement(), this.setLinkedDescriptionAttrs(), this.updateAllScreenReaderSections();
        }
        updateAllScreenReaderSections() {
          let b = this;
          Object.keys(this.screenReaderSections).forEach(function(p) {
            b.updateScreenReaderSection(p);
          });
        }
        getLinkedDescriptionElement() {
          let b = this.chart.options.accessibility.linkedDescription;
          if (!b)
            return;
          if (typeof b != "string")
            return b;
          let p = S(b, this.chart), L = w.querySelectorAll(p);
          if (L.length === 1)
            return L[0];
        }
        setLinkedDescriptionAttrs() {
          let b = this.linkedDescriptionElement;
          b && (b.setAttribute("aria-hidden", "true"), x(b, "highcharts-linked-description"));
        }
        updateScreenReaderSection(b) {
          let p = this.chart, L = this.screenReaderSections[b], B = L.buildContent(p), T = L.element = L.element || this.createElement("div"), O = T.firstChild || this.createElement("div");
          B ? (this.setScreenReaderSectionAttribs(T, b), l.setElementHTML(O, B), T.appendChild(O), L.insertIntoDOM(T, p), p.styledMode ? x(O, "highcharts-visually-hidden") : j(O), f(p, O), L.afterInserted && L.afterInserted()) : (T.parentNode && T.parentNode.removeChild(T), L.element = null);
        }
        setScreenReaderSectionAttribs(b, p) {
          let L = this.chart, B = L.langFormat("accessibility.screenReaderSection." + p + "RegionLabel", { chart: L, chartTitle: P(L) });
          N(b, { id: `highcharts-screen-reader-region-${p}-${L.index}`, "aria-label": B || void 0 }), b.style.position = "relative", B && b.setAttribute("role", L.options.accessibility.landmarkVerbosity === "all" ? "region" : "group");
        }
        defaultBeforeChartFormatter() {
          let b = this.chart, p = b.options.accessibility.screenReaderSection.beforeChartFormat;
          if (!p)
            return "";
          let L = this.getAxesDescription(), B = b.sonify && b.options.sonification && b.options.sonification.enabled, T = "highcharts-a11y-sonify-data-btn-" + b.index, O = "hc-linkto-highcharts-data-table-" + b.index, I = c(b), R = b.langFormat("accessibility.screenReaderSection.annotations.heading", { chart: b }), Y = { headingTagName: A(b.renderTo), chartTitle: P(b), typeDescription: this.getTypeDescriptionText(), chartSubtitle: this.getSubtitleText(), chartLongdesc: this.getLongdescText(), xAxisDescription: L.xAxis, yAxisDescription: L.yAxis, playAsSoundButton: B ? this.getSonifyButtonText(T) : "", viewTableButton: b.getCSV ? this.getDataTableButtonText(O) : "", annotationsTitle: I ? R : "", annotationsList: I }, F = o.i18nFormat(p, Y, b);
          return this.dataTableButtonId = O, this.sonifyButtonId = T, C(F);
        }
        defaultAfterChartFormatter() {
          let b = this.chart, p = b.options.accessibility.screenReaderSection.afterChartFormat;
          if (!p)
            return "";
          let L = { endOfChartMarker: this.getEndOfChartMarkerText() };
          return C(o.i18nFormat(p, L, b));
        }
        getLinkedDescription() {
          let b = this.linkedDescriptionElement;
          return $(b && b.innerHTML || "", this.chart.renderer.forExport);
        }
        getLongdescText() {
          let b = this.chart.options, p = b.caption, L = p && p.text, B = this.getLinkedDescription();
          return b.accessibility.description || B || L || "";
        }
        getTypeDescriptionText() {
          let b = this.chart;
          return b.types ? b.options.accessibility.typeDescription || function(p, L) {
            let B = L[0], T = p.series && p.series[0] || {}, O = p.mapView && p.mapView.geoMap && p.mapView.geoMap.title, I = { numSeries: p.series.length, numPoints: T.points && T.points.length, chart: p, mapTitle: O };
            return B ? B === "map" || B === "tiledwebmap" ? I.mapTitle ? p.langFormat("accessibility.chartTypes.mapTypeDescription", I) : p.langFormat("accessibility.chartTypes.unknownMap", I) : p.types.length > 1 ? p.langFormat("accessibility.chartTypes.combinationChart", I) : function(R, Y, F) {
              let U = Y[0], Q = R.langFormat("accessibility.seriesTypeDescriptions." + U, F), J = R.series && R.series.length < 2 ? "Single" : "Multiple";
              return (R.langFormat("accessibility.chartTypes." + U + J, F) || R.langFormat("accessibility.chartTypes.default" + J, F)) + (Q ? " " + Q : "");
            }(p, L, I) : p.langFormat("accessibility.chartTypes.emptyChart", I);
          }(b, b.types) : "";
        }
        getDataTableButtonText(b) {
          let p = this.chart;
          return '<button id="' + b + '">' + p.langFormat("accessibility.table.viewAsDataTableButtonText", { chart: p, chartTitle: P(p) }) + "</button>";
        }
        getSonifyButtonText(b) {
          let p = this.chart;
          return p.options.sonification && p.options.sonification.enabled === !1 ? "" : '<button id="' + b + '">' + p.langFormat("accessibility.sonification.playAsSoundButtonText", { chart: p, chartTitle: P(p) }) + "</button>";
        }
        getSubtitleText() {
          let b = this.chart.options.subtitle;
          return $(b && b.text || "", this.chart.renderer.forExport);
        }
        getEndOfChartMarkerText() {
          let b = k(`highcharts-end-of-chart-marker-${this.chart.index}`);
          if (b)
            return b.outerHTML;
          let p = this.chart, L = p.langFormat("accessibility.screenReaderSection.endOfChartMarker", { chart: p });
          return '<div id="highcharts-end-of-chart-marker-' + p.index + '">' + L + "</div>";
        }
        onDataTableCreated(b) {
          let p = this.chart;
          if (p.options.accessibility.enabled) {
            this.viewDataTableButton && this.viewDataTableButton.setAttribute("aria-expanded", "true");
            let L = b.tree.attributes || {};
            L.tabindex = -1, L.summary = p.langFormat("accessibility.table.tableSummary", { chart: p }), b.tree.attributes = L;
          }
        }
        focusDataTable() {
          let b = this.dataTableDiv, p = b && b.getElementsByTagName("table")[0];
          p && p.focus && p.focus();
        }
        initSonifyButton(b) {
          let p = this.sonifyButton = k(b), L = this.chart, B = (T) => {
            p && (p.setAttribute("aria-hidden", "true"), p.setAttribute("aria-label", "")), T.preventDefault(), T.stopPropagation();
            let O = L.langFormat("accessibility.sonification.playAsSoundClickAnnouncement", { chart: L });
            this.announcer.announce(O), setTimeout(() => {
              p && (p.removeAttribute("aria-hidden"), p.removeAttribute("aria-label")), L.sonify && L.sonify();
            }, 1e3);
          };
          p && L && (p.setAttribute("tabindex", -1), p.onclick = function(T) {
            (L.options.accessibility && L.options.accessibility.screenReaderSection.onPlayAsSoundClick || B).call(this, T, L);
          });
        }
        initDataTableButton(b) {
          let p = this.viewDataTableButton = k(b), L = this.chart, B = b.replace("hc-linkto-", "");
          p && (N(p, { tabindex: -1, "aria-expanded": !!k(B) }), p.onclick = L.options.accessibility.screenReaderSection.onViewDataTableClick || function() {
            L.viewData();
          });
        }
        getAxesDescription() {
          let b = this.chart, p = function(R, Y) {
            let F = b[R];
            return F.length > 1 || F[0] && M(F[0].options.accessibility && F[0].options.accessibility.enabled, Y);
          }, L = !!b.types && 0 > b.types.indexOf("map") && 0 > b.types.indexOf("treemap") && 0 > b.types.indexOf("tilemap"), B = !!b.hasCartesianSeries, T = p("xAxis", !b.angular && B && L), O = p("yAxis", B && L), I = {};
          return T && (I.xAxis = this.getAxisDescriptionText("xAxis")), O && (I.yAxis = this.getAxisDescriptionText("yAxis")), I;
        }
        getAxisDescriptionText(b) {
          let p = this.chart, L = p[b];
          return p.langFormat("accessibility.axis." + b + "Description" + (L.length > 1 ? "Plural" : "Singular"), { chart: p, names: L.map(function(B) {
            return g(B);
          }), ranges: L.map(function(B) {
            return v(B);
          }), numAxes: L.length });
        }
        destroy() {
          this.announcer && this.announcer.destroy();
        }
      };
    }), i(n, "Accessibility/Components/MenuComponent.js", [n["Core/Utilities.js"], n["Accessibility/AccessibilityComponent.js"], n["Accessibility/KeyboardNavigationHandler.js"], n["Accessibility/Utils/ChartUtilities.js"], n["Accessibility/Utils/HTMLUtilities.js"]], function(o, a, r, s, l) {
      let { attr: d } = o, { getChartTitle: y, unhideChartElementFromAT: u } = s, { getFakeMouseEvent: m } = l;
      function h(g) {
        return g.exportSVGElements && g.exportSVGElements[0];
      }
      class c extends a {
        init() {
          let v = this.chart, P = this;
          this.addEvent(v, "exportMenuShown", function() {
            P.onMenuShown();
          }), this.addEvent(v, "exportMenuHidden", function() {
            P.onMenuHidden();
          }), this.createProxyGroup();
        }
        onMenuHidden() {
          let v = this.chart.exportContextMenu;
          v && v.setAttribute("aria-hidden", "true"), this.setExportButtonExpandedState("false");
        }
        onMenuShown() {
          let v = this.chart, P = v.exportContextMenu;
          P && (this.addAccessibleContextMenuAttribs(), u(v, P)), this.setExportButtonExpandedState("true");
        }
        setExportButtonExpandedState(v) {
          this.exportButtonProxy && this.exportButtonProxy.innerElement.setAttribute("aria-expanded", v);
        }
        onChartRender() {
          let v = this.chart, P = v.focusElement, f = v.accessibility;
          this.proxyProvider.clearGroup("chartMenu"), this.proxyMenuButton(), this.exportButtonProxy && P && P === v.exportingGroup && (P.focusBorder ? v.setFocusToElement(P, this.exportButtonProxy.innerElement) : f && f.keyboardNavigation.tabindexContainer.focus());
        }
        proxyMenuButton() {
          let v = this.chart, P = this.proxyProvider, f = h(v);
          (function(S) {
            let w = S.options.exporting, x = h(S);
            return !!(w && w.enabled !== !1 && w.accessibility && w.accessibility.enabled && x && x.element);
          })(v) && f && (this.exportButtonProxy = P.addProxyElement("chartMenu", { click: f }, "button", { "aria-label": v.langFormat("accessibility.exporting.menuButtonLabel", { chart: v, chartTitle: y(v) }), "aria-expanded": !1, title: v.options.lang.contextButtonTitle || null }));
        }
        createProxyGroup() {
          this.chart && this.proxyProvider && this.proxyProvider.addGroup("chartMenu");
        }
        addAccessibleContextMenuAttribs() {
          let v = this.chart, P = v.exportDivElements;
          if (P && P.length) {
            P.forEach((S) => {
              S && (S.tagName !== "LI" || S.children && S.children.length ? S.setAttribute("aria-hidden", "true") : S.setAttribute("tabindex", -1));
            });
            let f = P[0] && P[0].parentNode;
            f && d(f, { "aria-hidden": void 0, "aria-label": v.langFormat("accessibility.exporting.chartMenuLabel", { chart: v }), role: "list" });
          }
        }
        getKeyboardNavigation() {
          let v = this.keyCodes, P = this.chart, f = this;
          return new r(P, { keyCodeMap: [[[v.left, v.up], function() {
            return f.onKbdPrevious(this);
          }], [[v.right, v.down], function() {
            return f.onKbdNext(this);
          }], [[v.enter, v.space], function() {
            return f.onKbdClick(this);
          }]], validate: function() {
            return !!P.exporting && P.options.exporting.enabled !== !1 && P.options.exporting.accessibility.enabled !== !1;
          }, init: function() {
            let S = f.exportButtonProxy, w = f.chart.exportingGroup;
            S && w && P.setFocusToElement(w, S.innerElement);
          }, terminate: function() {
            P.hideExportMenu();
          } });
        }
        onKbdPrevious(v) {
          let P = this.chart, f = P.options.accessibility, S = v.response, w = P.highlightedExportItemIx || 0;
          for (; w--; )
            if (P.highlightExportItem(w))
              return S.success;
          return f.keyboardNavigation.wrapAround ? (P.highlightLastExportItem(), S.success) : S.prev;
        }
        onKbdNext(v) {
          let P = this.chart, f = P.options.accessibility, S = v.response;
          for (let w = (P.highlightedExportItemIx || 0) + 1; w < P.exportDivElements.length; ++w)
            if (P.highlightExportItem(w))
              return S.success;
          return f.keyboardNavigation.wrapAround ? (P.highlightExportItem(0), S.success) : S.next;
        }
        onKbdClick(v) {
          let P = this.chart, f = P.exportDivElements[P.highlightedExportItemIx], S = h(P).element;
          return P.openMenu ? this.fakeClickEvent(f) : (this.fakeClickEvent(S), P.highlightExportItem(0)), v.response.success;
        }
      }
      return function(g) {
        function v() {
          let w = h(this);
          if (w) {
            let x = w.element;
            x.onclick && x.onclick(m("click"));
          }
        }
        function P() {
          let w = this.exportDivElements;
          w && this.exportContextMenu && this.openMenu && (w.forEach((x) => {
            x && x.className === "highcharts-menu-item" && x.onmouseout && x.onmouseout(m("mouseout"));
          }), this.highlightedExportItemIx = 0, this.exportContextMenu.hideMenu(), this.container.focus());
        }
        function f(w) {
          let x = this.exportDivElements && this.exportDivElements[w], k = this.exportDivElements && this.exportDivElements[this.highlightedExportItemIx];
          if (x && x.tagName === "LI" && !(x.children && x.children.length)) {
            let A = !!(this.renderTo.getElementsByTagName("g")[0] || {}).focus;
            return x.focus && A && x.focus(), k && k.onmouseout && k.onmouseout(m("mouseout")), x.onmouseover && x.onmouseover(m("mouseover")), this.highlightedExportItemIx = w, !0;
          }
          return !1;
        }
        function S() {
          if (this.exportDivElements) {
            let w = this.exportDivElements.length;
            for (; w--; )
              if (this.highlightExportItem(w))
                return !0;
          }
          return !1;
        }
        g.compose = function(w) {
          let x = w.prototype;
          x.hideExportMenu || (x.hideExportMenu = P, x.highlightExportItem = f, x.highlightLastExportItem = S, x.showExportMenu = v);
        };
      }(c || (c = {})), c;
    }), i(n, "Accessibility/KeyboardNavigation.js", [n["Core/Globals.js"], n["Accessibility/Components/MenuComponent.js"], n["Core/Utilities.js"], n["Accessibility/Utils/EventProvider.js"], n["Accessibility/Utils/HTMLUtilities.js"]], function(o, a, r, s, l) {
      let { doc: d, win: y } = o, { addEvent: u, defined: m, fireEvent: h } = r, { getElement: c, simulatedEventTarget: g } = l;
      class v {
        constructor(f, S) {
          this.currentModuleIx = NaN, this.modules = [], this.init(f, S);
        }
        init(f, S) {
          let w = this.eventProvider = new s();
          this.chart = f, this.components = S, this.modules = [], this.currentModuleIx = 0, this.update(), w.addEvent(this.tabindexContainer, "keydown", (x) => this.onKeydown(x)), w.addEvent(this.tabindexContainer, "focus", (x) => this.onFocus(x)), ["mouseup", "touchend"].forEach((x) => w.addEvent(d, x, (k) => this.onMouseUp(k))), ["mousedown", "touchstart"].forEach((x) => w.addEvent(f.renderTo, x, () => {
            this.isClickingChart = !0;
          }));
        }
        update(f) {
          let S = this.chart.options.accessibility, w = S && S.keyboardNavigation, x = this.components;
          this.updateContainerTabindex(), w && w.enabled && f && f.length ? (this.modules = f.reduce(function(k, A) {
            let $ = x[A].getKeyboardNavigation();
            return k.concat($);
          }, []), this.updateExitAnchor()) : (this.modules = [], this.currentModuleIx = 0, this.removeExitAnchor());
        }
        updateExitAnchor() {
          let f = c(`highcharts-end-of-chart-marker-${this.chart.index}`);
          this.removeExitAnchor(), f ? (this.makeElementAnExitAnchor(f), this.exitAnchor = f) : this.createExitAnchor();
        }
        move(f) {
          let S = this.modules && this.modules[this.currentModuleIx];
          S && S.terminate && S.terminate(f), this.chart.focusElement && this.chart.focusElement.removeFocusBorder(), this.currentModuleIx += f;
          let w = this.modules && this.modules[this.currentModuleIx];
          if (w) {
            if (w.validate && !w.validate())
              return this.move(f);
            if (w.init)
              return w.init(f), !0;
          }
          return this.currentModuleIx = 0, this.exiting = !0, f > 0 ? this.exitAnchor && this.exitAnchor.focus() : this.tabindexContainer.focus(), !1;
        }
        onFocus(f) {
          let S = this.chart, w = f.relatedTarget && S.container.contains(f.relatedTarget), x = S.options.accessibility, k = x && x.keyboardNavigation;
          if (k && k.enabled && !this.exiting && !this.tabbingInBackwards && !this.isClickingChart && !w) {
            let A = this.getFirstValidModuleIx();
            A !== null && (this.currentModuleIx = A, this.modules[A].init(1));
          }
          this.keyboardReset = !1, this.exiting = !1;
        }
        onMouseUp(f) {
          if (delete this.isClickingChart, !this.keyboardReset && f.relatedTarget !== g) {
            let S = this.chart;
            if (!f.target || !S.container.contains(f.target)) {
              let w = this.modules && this.modules[this.currentModuleIx || 0];
              w && w.terminate && w.terminate(), this.currentModuleIx = 0;
            }
            S.focusElement && (S.focusElement.removeFocusBorder(), delete S.focusElement), this.keyboardReset = !0;
          }
        }
        onKeydown(f) {
          let S, w = f || y.event, x = this.modules && this.modules.length && this.modules[this.currentModuleIx], k = w.target;
          if ((!k || k.nodeName !== "INPUT" || k.classList.contains("highcharts-a11y-proxy-element")) && (this.keyboardReset = !1, this.exiting = !1, x)) {
            let A = x.run(w);
            A === x.response.success ? S = !0 : A === x.response.prev ? S = this.move(-1) : A === x.response.next && (S = this.move(1)), S && (w.preventDefault(), w.stopPropagation());
          }
        }
        updateContainerTabindex() {
          let f, S = this.chart.options.accessibility, w = S && S.keyboardNavigation, x = !(w && w.enabled === !1), k = this.chart, A = k.container;
          k.renderTo.hasAttribute("tabindex") ? (A.removeAttribute("tabindex"), f = k.renderTo) : f = A, this.tabindexContainer = f;
          let $ = f.getAttribute("tabindex");
          x && !$ ? f.setAttribute("tabindex", "0") : x || k.container.removeAttribute("tabindex");
        }
        createExitAnchor() {
          let f = this.chart, S = this.exitAnchor = d.createElement("div");
          f.renderTo.appendChild(S), this.makeElementAnExitAnchor(S);
        }
        makeElementAnExitAnchor(f) {
          let S = this.tabindexContainer.getAttribute("tabindex") || 0;
          f.setAttribute("class", "highcharts-exit-anchor"), f.setAttribute("tabindex", S), f.setAttribute("aria-hidden", !1), this.addExitAnchorEventsToEl(f);
        }
        removeExitAnchor() {
          if (this.exitAnchor) {
            let f = this.eventProvider.eventRemovers.find((S) => S.element === this.exitAnchor);
            f && m(f.remover) && this.eventProvider.removeEvent(f.remover), this.exitAnchor.parentNode && this.exitAnchor.parentNode.removeChild(this.exitAnchor), delete this.exitAnchor;
          }
        }
        addExitAnchorEventsToEl(f) {
          let S = this.chart, w = this;
          this.eventProvider.addEvent(f, "focus", function(x) {
            let k = x || y.event, A = !(k.relatedTarget && S.container.contains(k.relatedTarget) || w.exiting);
            if (S.focusElement && delete S.focusElement, A) {
              if (w.tabbingInBackwards = !0, w.tabindexContainer.focus(), delete w.tabbingInBackwards, k.preventDefault(), w.modules && w.modules.length) {
                w.currentModuleIx = w.modules.length - 1;
                let $ = w.modules[w.currentModuleIx];
                $ && $.validate && !$.validate() ? w.move(-1) : $ && $.init(-1);
              }
            } else
              w.exiting = !1;
          });
        }
        getFirstValidModuleIx() {
          let f = this.modules.length;
          for (let S = 0; S < f; ++S) {
            let w = this.modules[S];
            if (!w.validate || w.validate())
              return S;
          }
          return null;
        }
        destroy() {
          this.removeExitAnchor(), this.eventProvider.removeAddedEvents(), this.chart.container.removeAttribute("tabindex");
        }
      }
      return function(P) {
        function f() {
          let w = this;
          h(this, "dismissPopupContent", {}, function() {
            w.tooltip && w.tooltip.hide(0), w.hideExportMenu();
          });
        }
        function S(w) {
          (w.which || w.keyCode) === 27 && o.charts && o.charts.forEach((x) => {
            x && x.dismissPopupContent && x.dismissPopupContent();
          });
        }
        P.compose = function(w) {
          a.compose(w);
          let x = w.prototype;
          return x.dismissPopupContent || (x.dismissPopupContent = f, u(d, "keydown", S)), w;
        };
      }(v || (v = {})), v;
    }), i(n, "Accessibility/Components/LegendComponent.js", [n["Core/Animation/AnimationUtilities.js"], n["Core/Globals.js"], n["Core/Legend/Legend.js"], n["Core/Utilities.js"], n["Accessibility/AccessibilityComponent.js"], n["Accessibility/KeyboardNavigationHandler.js"], n["Accessibility/Utils/ChartUtilities.js"], n["Accessibility/Utils/HTMLUtilities.js"]], function(o, a, r, s, l, d, y, u) {
      let { animObject: m } = o, { doc: h } = a, { addEvent: c, fireEvent: g, isNumber: v, pick: P, syncTimeout: f } = s, { getChartTitle: S } = y, { stripHTMLTagsFromString: w, addClass: x, removeClass: k } = u;
      function A(N) {
        let M = N.legend && N.legend.allItems, D = N.options.legend.accessibility || {}, C = N.colorAxis && N.colorAxis.some((b) => !b.dataClasses || !b.dataClasses.length);
        return !!(M && M.length && !C && D.enabled !== !1);
      }
      function $(N, M) {
        let D = M.legendItem || {};
        for (let C of (M.setState(N ? "hover" : "", !0), ["group", "label", "symbol"])) {
          let b = D[C], p = b && b.element || b;
          p && g(p, N ? "mouseover" : "mouseout");
        }
      }
      class j extends l {
        constructor() {
          super(...arguments), this.highlightedLegendItemIx = NaN, this.proxyGroup = null;
        }
        init() {
          let M = this;
          this.recreateProxies(), this.addEvent(r, "afterScroll", function() {
            this.chart === M.chart && (M.proxyProvider.updateGroupProxyElementPositions("legend"), M.updateLegendItemProxyVisibility(), M.highlightedLegendItemIx > -1 && this.chart.highlightLegendItem(M.highlightedLegendItemIx));
          }), this.addEvent(r, "afterPositionItem", function(D) {
            this.chart === M.chart && this.chart.renderer && M.updateProxyPositionForItem(D.item);
          }), this.addEvent(r, "afterRender", function() {
            this.chart === M.chart && this.chart.renderer && M.recreateProxies() && f(() => M.proxyProvider.updateGroupProxyElementPositions("legend"), m(P(this.chart.renderer.globalAnimation, !0)).duration);
          });
        }
        updateLegendItemProxyVisibility() {
          let M, D = this.chart, C = D.legend, b = C.allItems || [], p = C.currentPage || 1, L = C.clipHeight || 0;
          b.forEach((B) => {
            if (B.a11yProxyElement) {
              let T = C.pages && C.pages.length, O = B.a11yProxyElement.element, I = !1;
              if (M = B.legendItem || {}, T) {
                let R = M.pageIx || 0;
                I = (M.y || 0) + (M.label ? Math.round(M.label.getBBox().height) : 0) - C.pages[R] > L || R !== p - 1;
              }
              I ? D.styledMode ? x(O, "highcharts-a11y-invisible") : O.style.visibility = "hidden" : (k(O, "highcharts-a11y-invisible"), O.style.visibility = "");
            }
          });
        }
        onChartRender() {
          A(this.chart) || this.removeProxies();
        }
        highlightAdjacentLegendPage(M) {
          let D = this.chart, C = D.legend, b = (C.currentPage || 1) + M, p = C.pages || [];
          if (b > 0 && b <= p.length) {
            let L = 0;
            for (let B of C.allItems)
              ((B.legendItem || {}).pageIx || 0) + 1 === b && D.highlightLegendItem(L) && (this.highlightedLegendItemIx = L), ++L;
          }
        }
        updateProxyPositionForItem(M) {
          M.a11yProxyElement && M.a11yProxyElement.refreshPosition();
        }
        recreateProxies() {
          let M = h.activeElement, D = this.proxyGroup, C = M && D && D.contains(M);
          return this.removeProxies(), !!A(this.chart) && (this.addLegendProxyGroup(), this.proxyLegendItems(), this.updateLegendItemProxyVisibility(), this.updateLegendTitle(), C && this.chart.highlightLegendItem(this.highlightedLegendItemIx), !0);
        }
        removeProxies() {
          this.proxyProvider.removeGroup("legend");
        }
        updateLegendTitle() {
          let M = this.chart, D = w((M.legend && M.legend.options.title && M.legend.options.title.text || "").replace(/<br ?\/?>/g, " "), M.renderer.forExport), C = M.langFormat("accessibility.legend.legendLabel" + (D ? "" : "NoTitle"), { chart: M, legendTitle: D, chartTitle: S(M) });
          this.proxyProvider.updateGroupAttrs("legend", { "aria-label": C });
        }
        addLegendProxyGroup() {
          let M = this.chart.options.accessibility.landmarkVerbosity === "all" ? "region" : null;
          this.proxyGroup = this.proxyProvider.addGroup("legend", "ul", { "aria-label": "_placeholder_", role: M });
        }
        proxyLegendItems() {
          let M, D = this;
          ((this.chart.legend || {}).allItems || []).forEach((C) => {
            (M = C.legendItem || {}).label && M.label.element && D.proxyLegendItem(C);
          });
        }
        proxyLegendItem(M) {
          let D = M.legendItem || {};
          if (!D.label || !D.group)
            return;
          let C = this.chart.langFormat("accessibility.legend.legendItem", { chart: this.chart, itemName: w(M.name, this.chart.renderer.forExport), item: M }), b = { tabindex: -1, "aria-pressed": M.visible, "aria-label": C }, p = D.group.div ? D.label : D.group;
          M.a11yProxyElement = this.proxyProvider.addProxyElement("legend", { click: D.label, visual: p.element }, "button", b);
        }
        getKeyboardNavigation() {
          let M = this.keyCodes, D = this, C = this.chart;
          return new d(C, { keyCodeMap: [[[M.left, M.right, M.up, M.down], function(b) {
            return D.onKbdArrowKey(this, b);
          }], [[M.enter, M.space], function() {
            return D.onKbdClick(this);
          }], [[M.pageDown, M.pageUp], function(b) {
            let p = b === M.pageDown ? 1 : -1;
            return D.highlightAdjacentLegendPage(p), this.response.success;
          }]], validate: function() {
            return D.shouldHaveLegendNavigation();
          }, init: function() {
            C.highlightLegendItem(0), D.highlightedLegendItemIx = 0;
          }, terminate: function() {
            D.highlightedLegendItemIx = -1, C.legend.allItems.forEach((b) => $(!1, b));
          } });
        }
        onKbdArrowKey(M, D) {
          let { keyCodes: { left: C, up: b }, highlightedLegendItemIx: p, chart: L } = this, B = L.legend.allItems.length, T = L.options.accessibility.keyboardNavigation.wrapAround, O = D === C || D === b ? -1 : 1;
          return L.highlightLegendItem(p + O) ? this.highlightedLegendItemIx += O : T && B > 1 && (this.highlightedLegendItemIx = O > 0 ? 0 : B - 1, L.highlightLegendItem(this.highlightedLegendItemIx)), M.response.success;
        }
        onKbdClick(M) {
          let D = this.chart.legend.allItems[this.highlightedLegendItemIx];
          return D && D.a11yProxyElement && D.a11yProxyElement.click(), M.response.success;
        }
        shouldHaveLegendNavigation() {
          if (!A(this.chart))
            return !1;
          let M = this.chart, D = (M.options.legend || {}).accessibility || {};
          return !!(M.legend.display && D.keyboardNavigation && D.keyboardNavigation.enabled);
        }
        destroy() {
          this.removeProxies();
        }
      }
      return function(N) {
        function M(C) {
          let b = this.legend.allItems, p = this.accessibility && this.accessibility.components.legend.highlightedLegendItemIx, L = b[C], B = L?.legendItem || {};
          if (L) {
            v(p) && b[p] && $(!1, b[p]), function(I, R) {
              let Y = (I.allItems[R].legendItem || {}).pageIx, F = I.currentPage;
              Y !== void 0 && Y + 1 !== F && I.scroll(1 + Y - F);
            }(this.legend, C);
            let T = B.label, O = L.a11yProxyElement && L.a11yProxyElement.innerElement;
            return T && T.element && O && this.setFocusToElement(T, O), $(!0, L), !0;
          }
          return !1;
        }
        function D(C) {
          let b = this.chart.options.accessibility, p = C.item;
          b.enabled && p && p.a11yProxyElement && p.a11yProxyElement.innerElement.setAttribute("aria-pressed", C.visible ? "true" : "false");
        }
        N.compose = function(C, b) {
          let p = C.prototype;
          p.highlightLegendItem || (p.highlightLegendItem = M, c(b, "afterColorizeItem", D));
        };
      }(j || (j = {})), j;
    }), i(n, "Stock/Navigator/ChartNavigatorComposition.js", [n["Core/Globals.js"], n["Core/Utilities.js"]], function(o, a) {
      let r, { isTouchDevice: s } = o, { addEvent: l, merge: d, pick: y } = a, u = [];
      function m() {
        this.navigator && this.navigator.setBaseSeries(null, !1);
      }
      function h() {
        let S, w, x, k = this.legend, A = this.navigator;
        if (A) {
          S = k && k.options, w = A.xAxis, x = A.yAxis;
          let { scrollbarHeight: $, scrollButtonSize: j } = A;
          this.inverted ? (A.left = A.opposite ? this.chartWidth - $ - A.height : this.spacing[3] + $, A.top = this.plotTop + j) : (A.left = y(w.left, this.plotLeft + j), A.top = A.navigatorOptions.top || this.chartHeight - A.height - $ - (this.scrollbar?.options.margin || 0) - this.spacing[2] - (this.rangeSelector && this.extraBottomMargin ? this.rangeSelector.getHeight() : 0) - (S && S.verticalAlign === "bottom" && S.layout !== "proximate" && S.enabled && !S.floating ? k.legendHeight + y(S.margin, 10) : 0) - (this.titleOffset ? this.titleOffset[2] : 0)), w && x && (this.inverted ? w.options.left = x.options.left = A.left : w.options.top = x.options.top = A.top, w.setAxisSize(), x.setAxisSize());
        }
      }
      function c(S) {
        !this.navigator && !this.scroller && (this.options.navigator.enabled || this.options.scrollbar.enabled) && (this.scroller = this.navigator = new r(this), y(S.redraw, !0) && this.redraw(S.animation));
      }
      function g() {
        let S = this.options;
        (S.navigator.enabled || S.scrollbar.enabled) && (this.scroller = this.navigator = new r(this));
      }
      function v() {
        let S = this.options, w = S.navigator, x = S.rangeSelector;
        if ((w && w.enabled || x && x.enabled) && (!s && this.zooming.type === "x" || s && this.zooming.pinchType === "x"))
          return !1;
      }
      function P(S) {
        let w = S.navigator;
        if (w && S.xAxis[0]) {
          let x = S.xAxis[0].getExtremes();
          w.render(x.min, x.max);
        }
      }
      function f(S) {
        let w = S.options.navigator || {}, x = S.options.scrollbar || {};
        !this.navigator && !this.scroller && (w.enabled || x.enabled) && (d(!0, this.options.navigator, w), d(!0, this.options.scrollbar, x), delete S.options.navigator, delete S.options.scrollbar);
      }
      return { compose: function(S, w) {
        if (a.pushUnique(u, S)) {
          let x = S.prototype;
          r = w, x.callbacks.push(P), l(S, "afterAddSeries", m), l(S, "afterSetChartSize", h), l(S, "afterUpdate", c), l(S, "beforeRender", g), l(S, "beforeShowResetZoom", v), l(S, "update", f);
        }
      } };
    }), i(n, "Core/Axis/NavigatorAxisComposition.js", [n["Core/Globals.js"], n["Core/Utilities.js"]], function(o, a) {
      let { isTouchDevice: r } = o, { addEvent: s, correctFloat: l, defined: d, isNumber: y, pick: u } = a;
      function m() {
        this.navigatorAxis || (this.navigatorAxis = new c(this));
      }
      function h(g) {
        let v, P = this.chart, f = P.options, S = f.navigator, w = this.navigatorAxis, x = P.zooming.pinchType, k = f.rangeSelector, A = P.zooming.type;
        if (this.isXAxis && (S?.enabled || k?.enabled)) {
          if (A === "y" && g.trigger === "zoom")
            v = !1;
          else if ((g.trigger === "zoom" && A === "xy" || r && x === "xy") && this.options.range) {
            let $ = w.previousZoom;
            d(g.min) ? w.previousZoom = [this.min, this.max] : $ && (g.min = $[0], g.max = $[1], w.previousZoom = void 0);
          }
        }
        v !== void 0 && g.preventDefault();
      }
      class c {
        static compose(v) {
          v.keepProps.includes("navigatorAxis") || (v.keepProps.push("navigatorAxis"), s(v, "init", m), s(v, "setExtremes", h));
        }
        constructor(v) {
          this.axis = v;
        }
        destroy() {
          this.axis = void 0;
        }
        toFixedRange(v, P, f, S) {
          let w = this.axis, x = (w.pointRange || 0) / 2, k = u(f, w.translate(v, !0, !w.horiz)), A = u(S, w.translate(P, !0, !w.horiz));
          return d(f) || (k = l(k + x)), d(S) || (A = l(A - x)), y(k) && y(A) || (k = A = void 0), { min: k, max: A };
        }
      }
      return c;
    }), i(n, "Stock/Navigator/NavigatorDefaults.js", [n["Core/Color/Color.js"], n["Core/Series/SeriesRegistry.js"]], function(o, a) {
      let { parse: r } = o, { seriesTypes: s } = a;
      return { height: 40, margin: 25, maskInside: !0, handles: { width: 7, borderRadius: 0, height: 15, symbols: ["navigator-handle", "navigator-handle"], enabled: !0, lineWidth: 1, backgroundColor: "#f2f2f2", borderColor: "#999999" }, maskFill: r("#667aff").setOpacity(0.3).get(), outlineColor: "#999999", outlineWidth: 1, series: { type: s.areaspline === void 0 ? "line" : "areaspline", fillOpacity: 0.05, lineWidth: 1, compare: null, sonification: { enabled: !1 }, dataGrouping: { approximation: "average", enabled: !0, groupPixelWidth: 2, firstAnchor: "firstPoint", anchor: "middle", lastAnchor: "lastPoint", units: [["millisecond", [1, 2, 5, 10, 20, 25, 50, 100, 200, 500]], ["second", [1, 2, 5, 10, 15, 30]], ["minute", [1, 2, 5, 10, 15, 30]], ["hour", [1, 2, 3, 4, 6, 8, 12]], ["day", [1, 2, 3, 4]], ["week", [1, 2, 3]], ["month", [1, 3, 6]], ["year", null]] }, dataLabels: { enabled: !1, zIndex: 2 }, id: "highcharts-navigator-series", className: "highcharts-navigator-series", lineColor: null, marker: { enabled: !1 }, threshold: null }, xAxis: { className: "highcharts-navigator-xaxis", tickLength: 0, lineWidth: 0, gridLineColor: "#e6e6e6", id: "navigator-x-axis", gridLineWidth: 1, tickPixelInterval: 200, labels: { align: "left", style: { color: "#000000", fontSize: "0.7em", opacity: 0.6, textOutline: "2px contrast" }, x: 3, y: -4 }, crosshair: !1 }, yAxis: { className: "highcharts-navigator-yaxis", gridLineWidth: 0, startOnTick: !1, endOnTick: !1, minPadding: 0.1, id: "navigator-y-axis", maxPadding: 0.1, labels: { enabled: !1 }, crosshair: !1, title: { text: null }, tickLength: 0, tickWidth: 0 } };
    }), i(n, "Stock/Navigator/NavigatorSymbols.js", [n["Core/Renderer/SVG/Symbols.js"], n["Core/Utilities.js"]], function(o, a) {
      let { relativeLength: r } = a;
      return { "navigator-handle": function(s, l, d, y, u = {}) {
        let m = u.width ? u.width / 2 : d, h = r(u.borderRadius || 0, Math.min(2 * m, y));
        return [["M", -1.5, (y = u.height || y) / 2 - 3.5], ["L", -1.5, y / 2 + 4.5], ["M", 0.5, y / 2 - 3.5], ["L", 0.5, y / 2 + 4.5], ...o.rect(-m - 1, 0.5, 2 * m + 1, y, { r: h })];
      } };
    }), i(n, "Stock/Utilities/StockUtilities.js", [n["Core/Utilities.js"]], function(o) {
      let { defined: a } = o;
      return { setFixedRange: function(r) {
        let s = this.xAxis[0];
        a(s.dataMax) && a(s.dataMin) && r ? this.fixedRange = Math.min(r, s.dataMax - s.dataMin) : this.fixedRange = r;
      } };
    }), i(n, "Stock/Navigator/NavigatorComposition.js", [n["Core/Defaults.js"], n["Core/Globals.js"], n["Core/Axis/NavigatorAxisComposition.js"], n["Stock/Navigator/NavigatorDefaults.js"], n["Stock/Navigator/NavigatorSymbols.js"], n["Core/Renderer/RendererRegistry.js"], n["Stock/Utilities/StockUtilities.js"], n["Core/Utilities.js"]], function(o, a, r, s, l, d, y, u) {
      let { setOptions: m } = o, { composed: h } = a, { getRendererType: c } = d, { setFixedRange: g } = y, { addEvent: v, extend: P, pushUnique: f } = u;
      function S() {
        this.chart.navigator && !this.options.isInternal && this.chart.navigator.setBaseSeries(null, !1);
      }
      return { compose: function(w, x, k) {
        r.compose(x), f(h, "Navigator") && (w.prototype.setFixedRange = g, P(c().prototype.symbols, l), v(k, "afterUpdate", S), m({ navigator: s }));
      } };
    }), i(n, "Core/Axis/ScrollbarAxis.js", [n["Core/Globals.js"], n["Core/Utilities.js"]], function(o, a) {
      var r;
      let { composed: s } = o, { addEvent: l, defined: d, pick: y, pushUnique: u } = a;
      return function(m) {
        let h;
        function c(f) {
          let S = y(f.options && f.options.min, f.min), w = y(f.options && f.options.max, f.max);
          return { axisMin: S, axisMax: w, scrollMin: d(f.dataMin) ? Math.min(S, f.min, f.dataMin, y(f.threshold, 1 / 0)) : S, scrollMax: d(f.dataMax) ? Math.max(w, f.max, f.dataMax, y(f.threshold, -1 / 0)) : w };
        }
        function g() {
          let f = this.scrollbar, S = f && !f.options.opposite, w = this.horiz ? 2 : S ? 3 : 1;
          f && (this.chart.scrollbarsOffsets = [0, 0], this.chart.axisOffset[w] += f.size + (f.options.margin || 0));
        }
        function v() {
          let f = this;
          f.options && f.options.scrollbar && f.options.scrollbar.enabled && (f.options.scrollbar.vertical = !f.horiz, f.options.startOnTick = f.options.endOnTick = !1, f.scrollbar = new h(f.chart.renderer, f.options.scrollbar, f.chart), l(f.scrollbar, "changed", function(S) {
            let w, x, { axisMin: k, axisMax: A, scrollMin: $, scrollMax: j } = c(f), N = j - $;
            if (d(k) && d(A))
              if (f.horiz && !f.reversed || !f.horiz && f.reversed ? (w = $ + N * this.to, x = $ + N * this.from) : (w = $ + N * (1 - this.from), x = $ + N * (1 - this.to)), this.shouldUpdateExtremes(S.DOMType)) {
                let M = S.DOMType !== "mousemove" && S.DOMType !== "touchmove" && void 0;
                f.setExtremes(x, w, !0, M, S);
              } else
                this.setRange(this.from, this.to);
          }));
        }
        function P() {
          let f, S, w, { scrollMin: x, scrollMax: k } = c(this), A = this.scrollbar, $ = this.axisTitleMargin + (this.titleOffset || 0), j = this.chart.scrollbarsOffsets, N = this.options.margin || 0;
          if (A && j) {
            if (this.horiz)
              this.opposite || (j[1] += $), A.position(this.left, this.top + this.height + 2 + j[1] - (this.opposite ? N : 0), this.width, this.height), this.opposite || (j[1] += N), f = 1;
            else {
              let M;
              this.opposite && (j[0] += $), M = A.options.opposite ? this.left + this.width + 2 + j[0] - (this.opposite ? 0 : N) : this.opposite ? 0 : N, A.position(M, this.top, this.width, this.height), this.opposite && (j[0] += N), f = 0;
            }
            if (j[f] += A.size + (A.options.margin || 0), isNaN(x) || isNaN(k) || !d(this.min) || !d(this.max) || this.dataMin === this.dataMax)
              A.setRange(0, 1);
            else if (this.min === this.max) {
              let M = this.pointRange / (this.dataMax + 1);
              S = M * this.min, w = M * (this.max + 1), A.setRange(S, w);
            } else
              S = (this.min - x) / (k - x), w = (this.max - x) / (k - x), this.horiz && !this.reversed || !this.horiz && this.reversed ? A.setRange(S, w) : A.setRange(1 - w, 1 - S);
          }
        }
        m.compose = function(f, S) {
          u(s, "Axis.Scrollbar") && (h = S, l(f, "afterGetOffset", g), l(f, "afterInit", v), l(f, "afterRender", P));
        };
      }(r || (r = {})), r;
    }), i(n, "Stock/Scrollbar/ScrollbarDefaults.js", [], function() {
      return { height: 10, barBorderRadius: 5, buttonBorderRadius: 0, buttonsEnabled: !1, liveRedraw: void 0, margin: void 0, minWidth: 6, opposite: !0, step: 0.2, zIndex: 3, barBackgroundColor: "#cccccc", barBorderWidth: 0, barBorderColor: "#cccccc", buttonArrowColor: "#333333", buttonBackgroundColor: "#e6e6e6", buttonBorderColor: "#cccccc", buttonBorderWidth: 1, rifleColor: "none", trackBackgroundColor: "rgba(255, 255, 255, 0.001)", trackBorderColor: "#cccccc", trackBorderRadius: 5, trackBorderWidth: 1 };
    }), i(n, "Stock/Scrollbar/Scrollbar.js", [n["Core/Defaults.js"], n["Core/Globals.js"], n["Core/Axis/ScrollbarAxis.js"], n["Stock/Scrollbar/ScrollbarDefaults.js"], n["Core/Utilities.js"]], function(o, a, r, s, l) {
      let { defaultOptions: d } = o, { addEvent: y, correctFloat: u, crisp: m, defined: h, destroyObjectProperties: c, fireEvent: g, merge: v, pick: P, removeEvent: f } = l;
      class S {
        static compose(x) {
          r.compose(x, S);
        }
        static swapXY(x, k) {
          return k && x.forEach((A) => {
            let $, j = A.length;
            for (let N = 0; N < j; N += 2)
              typeof ($ = A[N + 1]) == "number" && (A[N + 1] = A[N + 2], A[N + 2] = $);
          }), x;
        }
        constructor(x, k, A) {
          this._events = [], this.chartX = 0, this.chartY = 0, this.from = 0, this.scrollbarButtons = [], this.scrollbarLeft = 0, this.scrollbarStrokeWidth = 1, this.scrollbarTop = 0, this.size = 0, this.to = 0, this.trackBorderWidth = 1, this.x = 0, this.y = 0, this.init(x, k, A);
        }
        addEvents() {
          let x = this.options.inverted ? [1, 0] : [0, 1], k = this.scrollbarButtons, A = this.scrollbarGroup.element, $ = this.track.element, j = this.mouseDownHandler.bind(this), N = this.mouseMoveHandler.bind(this), M = this.mouseUpHandler.bind(this), D = [[k[x[0]].element, "click", this.buttonToMinClick.bind(this)], [k[x[1]].element, "click", this.buttonToMaxClick.bind(this)], [$, "click", this.trackClick.bind(this)], [A, "mousedown", j], [A.ownerDocument, "mousemove", N], [A.ownerDocument, "mouseup", M], [A, "touchstart", j], [A.ownerDocument, "touchmove", N], [A.ownerDocument, "touchend", M]];
          D.forEach(function(C) {
            y.apply(null, C);
          }), this._events = D;
        }
        buttonToMaxClick(x) {
          let k = (this.to - this.from) * P(this.options.step, 0.2);
          this.updatePosition(this.from + k, this.to + k), g(this, "changed", { from: this.from, to: this.to, trigger: "scrollbar", DOMEvent: x });
        }
        buttonToMinClick(x) {
          let k = u(this.to - this.from) * P(this.options.step, 0.2);
          this.updatePosition(u(this.from - k), u(this.to - k)), g(this, "changed", { from: this.from, to: this.to, trigger: "scrollbar", DOMEvent: x });
        }
        cursorToScrollbarPosition(x) {
          let k = this.options, A = k.minWidth > this.calculatedWidth ? k.minWidth : 0;
          return { chartX: (x.chartX - this.x - this.xOffset) / (this.barWidth - A), chartY: (x.chartY - this.y - this.yOffset) / (this.barWidth - A) };
        }
        destroy() {
          let x = this, k = x.chart.scroller;
          x.removeEvents(), ["track", "scrollbarRifles", "scrollbar", "scrollbarGroup", "group"].forEach(function(A) {
            x[A] && x[A].destroy && (x[A] = x[A].destroy());
          }), k && x === k.scrollbar && (k.scrollbar = null, c(k.scrollbarButtons));
        }
        drawScrollbarButton(x) {
          let k = this.renderer, A = this.scrollbarButtons, $ = this.options, j = this.size, N = k.g().add(this.group);
          if (A.push(N), $.buttonsEnabled) {
            let M = k.rect().addClass("highcharts-scrollbar-button").add(N);
            this.chart.styledMode || M.attr({ stroke: $.buttonBorderColor, "stroke-width": $.buttonBorderWidth, fill: $.buttonBackgroundColor }), M.attr(M.crisp({ x: -0.5, y: -0.5, width: j, height: j, r: $.buttonBorderRadius }, M.strokeWidth()));
            let D = k.path(S.swapXY([["M", j / 2 + (x ? -1 : 1), j / 2 - 3], ["L", j / 2 + (x ? -1 : 1), j / 2 + 3], ["L", j / 2 + (x ? 2 : -2), j / 2]], $.vertical)).addClass("highcharts-scrollbar-arrow").add(A[x]);
            this.chart.styledMode || D.attr({ fill: $.buttonArrowColor });
          }
        }
        init(x, k, A) {
          this.scrollbarButtons = [], this.renderer = x, this.userOptions = k, this.options = v(s, d.scrollbar, k), this.options.margin = P(this.options.margin, 10), this.chart = A, this.size = P(this.options.size, this.options.height), k.enabled && (this.render(), this.addEvents());
        }
        mouseDownHandler(x) {
          let k = this.chart.pointer?.normalize(x) || x, A = this.cursorToScrollbarPosition(k);
          this.chartX = A.chartX, this.chartY = A.chartY, this.initPositions = [this.from, this.to], this.grabbedCenter = !0;
        }
        mouseMoveHandler(x) {
          let k, A = this.chart.pointer?.normalize(x) || x, $ = this.options.vertical ? "chartY" : "chartX", j = this.initPositions || [];
          this.grabbedCenter && (!x.touches || x.touches[0][$] !== 0) && (k = this.cursorToScrollbarPosition(A)[$] - this[$], this.hasDragged = !0, this.updatePosition(j[0] + k, j[1] + k), this.hasDragged && g(this, "changed", { from: this.from, to: this.to, trigger: "scrollbar", DOMType: x.type, DOMEvent: x }));
        }
        mouseUpHandler(x) {
          this.hasDragged && g(this, "changed", { from: this.from, to: this.to, trigger: "scrollbar", DOMType: x.type, DOMEvent: x }), this.grabbedCenter = this.hasDragged = this.chartX = this.chartY = null;
        }
        position(x, k, A, $) {
          let { buttonsEnabled: j, margin: N = 0, vertical: M } = this.options, D = this.rendered ? "animate" : "attr", C = $, b = 0;
          this.group.show(), this.x = x, this.y = k + this.trackBorderWidth, this.width = A, this.height = $, this.xOffset = C, this.yOffset = b, M ? (this.width = this.yOffset = A = b = this.size, this.xOffset = C = 0, this.yOffset = b = j ? this.size : 0, this.barWidth = $ - (j ? 2 * A : 0), this.x = x += N) : (this.height = $ = this.size, this.xOffset = C = j ? this.size : 0, this.barWidth = A - (j ? 2 * $ : 0), this.y = this.y + N), this.group[D]({ translateX: x, translateY: this.y }), this.track[D]({ width: A, height: $ }), this.scrollbarButtons[1][D]({ translateX: M ? 0 : A - C, translateY: M ? $ - b : 0 });
        }
        removeEvents() {
          this._events.forEach(function(x) {
            f.apply(null, x);
          }), this._events.length = 0;
        }
        render() {
          let x = this.renderer, k = this.options, A = this.size, $ = this.chart.styledMode, j = x.g("scrollbar").attr({ zIndex: k.zIndex }).hide().add();
          this.group = j, this.track = x.rect().addClass("highcharts-scrollbar-track").attr({ r: k.trackBorderRadius || 0, height: A, width: A }).add(j), $ || this.track.attr({ fill: k.trackBackgroundColor, stroke: k.trackBorderColor, "stroke-width": k.trackBorderWidth });
          let N = this.trackBorderWidth = this.track.strokeWidth();
          this.track.attr({ x: -m(0, N), y: -m(0, N) }), this.scrollbarGroup = x.g().add(j), this.scrollbar = x.rect().addClass("highcharts-scrollbar-thumb").attr({ height: A - N, width: A - N, r: k.barBorderRadius || 0 }).add(this.scrollbarGroup), this.scrollbarRifles = x.path(S.swapXY([["M", -3, A / 4], ["L", -3, 2 * A / 3], ["M", 0, A / 4], ["L", 0, 2 * A / 3], ["M", 3, A / 4], ["L", 3, 2 * A / 3]], k.vertical)).addClass("highcharts-scrollbar-rifles").add(this.scrollbarGroup), $ || (this.scrollbar.attr({ fill: k.barBackgroundColor, stroke: k.barBorderColor, "stroke-width": k.barBorderWidth }), this.scrollbarRifles.attr({ stroke: k.rifleColor, "stroke-width": 1 })), this.scrollbarStrokeWidth = this.scrollbar.strokeWidth(), this.scrollbarGroup.translate(-m(0, this.scrollbarStrokeWidth), -m(0, this.scrollbarStrokeWidth)), this.drawScrollbarButton(0), this.drawScrollbarButton(1);
        }
        setRange(x, k) {
          let A, $, j = this.options, N = j.vertical, M = j.minWidth, D = this.barWidth, C = !this.rendered || this.hasDragged || this.chart.navigator && this.chart.navigator.hasDragged ? "attr" : "animate";
          if (!h(D))
            return;
          let b = D * Math.min(k, 1);
          A = Math.ceil(D * (x = Math.max(x, 0))), this.calculatedWidth = $ = u(b - A), $ < M && (A = (D - M + $) * x, $ = M);
          let p = Math.floor(A + this.xOffset + this.yOffset), L = $ / 2 - 0.5;
          this.from = x, this.to = k, N ? (this.scrollbarGroup[C]({ translateY: p }), this.scrollbar[C]({ height: $ }), this.scrollbarRifles[C]({ translateY: L }), this.scrollbarTop = p, this.scrollbarLeft = 0) : (this.scrollbarGroup[C]({ translateX: p }), this.scrollbar[C]({ width: $ }), this.scrollbarRifles[C]({ translateX: L }), this.scrollbarLeft = p, this.scrollbarTop = 0), $ <= 12 ? this.scrollbarRifles.hide() : this.scrollbarRifles.show(), j.showFull === !1 && (x <= 0 && k >= 1 ? this.group.hide() : this.group.show()), this.rendered = !0;
        }
        shouldUpdateExtremes(x) {
          return P(this.options.liveRedraw, a.svg && !a.isTouchDevice && !this.chart.boosted) || x === "mouseup" || x === "touchend" || !h(x);
        }
        trackClick(x) {
          let k = this.chart.pointer?.normalize(x) || x, A = this.to - this.from, $ = this.y + this.scrollbarTop, j = this.x + this.scrollbarLeft;
          this.options.vertical && k.chartY > $ || !this.options.vertical && k.chartX > j ? this.updatePosition(this.from + A, this.to + A) : this.updatePosition(this.from - A, this.to - A), g(this, "changed", { from: this.from, to: this.to, trigger: "scrollbar", DOMEvent: x });
        }
        update(x) {
          this.destroy(), this.init(this.chart.renderer, v(!0, this.options, x), this.chart);
        }
        updatePosition(x, k) {
          k > 1 && (x = u(1 - u(k - x)), k = 1), x < 0 && (k = u(k - x), x = 0), this.from = x, this.to = k;
        }
      }
      return S.defaultOptions = s, d.scrollbar = v(!0, S.defaultOptions, d.scrollbar), S;
    }), i(n, "Stock/Navigator/Navigator.js", [n["Core/Axis/Axis.js"], n["Stock/Navigator/ChartNavigatorComposition.js"], n["Core/Defaults.js"], n["Core/Globals.js"], n["Core/Axis/NavigatorAxisComposition.js"], n["Stock/Navigator/NavigatorComposition.js"], n["Stock/Scrollbar/Scrollbar.js"], n["Core/Renderer/SVG/SVGRenderer.js"], n["Core/Utilities.js"]], function(o, a, r, s, l, d, y, u, m) {
      let { defaultOptions: h } = r, { isTouchDevice: c } = s, { prototype: { symbols: g } } = u, { addEvent: v, clamp: P, correctFloat: f, defined: S, destroyObjectProperties: w, erase: x, extend: k, find: A, fireEvent: $, isArray: j, isNumber: N, merge: M, pick: D, removeEvent: C, splat: b } = m;
      function p(B, ...T) {
        let O = [].filter.call(T, N);
        if (O.length)
          return Math[B].apply(0, O);
      }
      class L {
        static compose(T, O, I) {
          a.compose(T, L), d.compose(T, O, I);
        }
        constructor(T) {
          this.isDirty = !1, this.scrollbarHeight = 0, this.init(T);
        }
        drawHandle(T, O, I, R) {
          let Y = this.navigatorOptions.handles.height;
          this.handles[O][R](I ? { translateX: Math.round(this.left + this.height / 2), translateY: Math.round(this.top + parseInt(T, 10) + 0.5 - Y) } : { translateX: Math.round(this.left + parseInt(T, 10)), translateY: Math.round(this.top + this.height / 2 - Y / 2 - 1) });
        }
        drawOutline(T, O, I, R) {
          let Y = this.navigatorOptions.maskInside, F = this.outline.strokeWidth(), U = F / 2, Q = F % 2 / 2, J = this.scrollButtonSize, ee = this.size, V = this.top, G = this.height, W = V - U, ae = V + G, z = this.left, q, Z;
          I ? (q = V + O + Q, O = V + T + Q, Z = [["M", z + G, V - J - Q], ["L", z + G, q], ["L", z, q], ["M", z, O], ["L", z + G, O], ["L", z + G, V + ee + J]], Y && Z.push(["M", z + G, q - U], ["L", z + G, O + U])) : (z -= J, T += z + J - Q, O += z + J - Q, Z = [["M", z, W], ["L", T, W], ["L", T, ae], ["M", O, ae], ["L", O, W], ["L", z + ee + 2 * J, W]], Y && Z.push(["M", T - U, W], ["L", O + U, W])), this.outline[R]({ d: Z });
        }
        drawMasks(T, O, I, R) {
          let Y, F, U, Q, J = this.left, ee = this.top, V = this.height;
          I ? (U = [J, J, J], Q = [ee, ee + T, ee + O], F = [V, V, V], Y = [T, O - T, this.size - O]) : (U = [J, J + T, J + O], Q = [ee, ee, ee], F = [T, O - T, this.size - O], Y = [V, V, V]), this.shades.forEach((G, W) => {
            G[R]({ x: U[W], y: Q[W], width: F[W], height: Y[W] });
          });
        }
        renderElements() {
          let T = this, O = T.navigatorOptions, I = O.maskInside, R = T.chart, Y = R.inverted, F = R.renderer, U = { cursor: Y ? "ns-resize" : "ew-resize" }, Q = T.navigatorGroup ?? (T.navigatorGroup = F.g("navigator").attr({ zIndex: 8, visibility: "hidden" }).add());
          if ([!I, I, !I].forEach((J, ee) => {
            let V = T.shades[ee] ?? (T.shades[ee] = F.rect().addClass("highcharts-navigator-mask" + (ee === 1 ? "-inside" : "-outside")).add(Q));
            R.styledMode || (V.attr({ fill: J ? O.maskFill : "rgba(0,0,0,0)" }), ee === 1 && V.css(U));
          }), T.outline || (T.outline = F.path().addClass("highcharts-navigator-outline").add(Q)), R.styledMode || T.outline.attr({ "stroke-width": O.outlineWidth, stroke: O.outlineColor }), O.handles?.enabled) {
            let J = O.handles, { height: ee, width: V } = J;
            [0, 1].forEach((G) => {
              let W = J.symbols[G];
              if (T.handles[G] && T.handles[G].symbolUrl === W) {
                if (!T.handles[G].isImg && T.handles[G].symbolName !== W) {
                  let ae = g[W].call(g, -V / 2 - 1, 0, V, ee);
                  T.handles[G].attr({ d: ae }), T.handles[G].symbolName = W;
                }
              } else
                T.handles[G]?.destroy(), T.handles[G] = F.symbol(W, -V / 2 - 1, 0, V, ee, J), T.handles[G].attr({ zIndex: 7 - G }).addClass("highcharts-navigator-handle highcharts-navigator-handle-" + ["left", "right"][G]).add(Q), T.addMouseEvents();
              R.inverted && T.handles[G].attr({ rotation: 90, rotationOriginX: Math.floor(-V / 2), rotationOriginY: (ee + V) / 2 }), R.styledMode || T.handles[G].attr({ fill: J.backgroundColor, stroke: J.borderColor, "stroke-width": J.lineWidth, width: J.width, height: J.height, x: -V / 2 - 1, y: 0 }).css(U);
            });
          }
        }
        update(T, O = !1) {
          let I = this.chart, R = I.options.chart.inverted !== I.scrollbar?.options.vertical;
          if (M(!0, I.options.navigator, T), this.navigatorOptions = I.options.navigator || {}, this.setOpposite(), S(T.enabled) || R)
            return this.destroy(), this.navigatorEnabled = T.enabled || this.navigatorEnabled, this.init(I);
          if (this.navigatorEnabled && (this.isDirty = !0, T.adaptToUpdatedData === !1 && this.baseSeries.forEach((Y) => {
            C(Y, "updatedData", this.updatedDataHandler);
          }, this), T.adaptToUpdatedData && this.baseSeries.forEach((Y) => {
            Y.eventsToUnbind.push(v(Y, "updatedData", this.updatedDataHandler));
          }, this), (T.series || T.baseSeries) && this.setBaseSeries(void 0, !1), T.height || T.xAxis || T.yAxis)) {
            this.height = T.height ?? this.height;
            let Y = this.getXAxisOffsets();
            this.xAxis.update({ ...T.xAxis, offsets: Y, [I.inverted ? "width" : "height"]: this.height, [I.inverted ? "height" : "width"]: void 0 }, !1), this.yAxis.update({ ...T.yAxis, [I.inverted ? "width" : "height"]: this.height }, !1);
          }
          O && I.redraw();
        }
        render(T, O, I, R) {
          let Y = this.chart, F = this.xAxis, U = F.pointRange || 0, Q = F.navigatorAxis.fake ? Y.xAxis[0] : F, J = this.navigatorEnabled, ee = this.rendered, V = Y.inverted, G = Y.xAxis[0].minRange, W = Y.xAxis[0].options.maxRange, ae = this.scrollButtonSize, z, q, Z, ne = this.scrollbarHeight, ie, re;
          if (this.hasDragged && !S(I))
            return;
          if (this.isDirty && this.renderElements(), T = f(T - U / 2), O = f(O + U / 2), !N(T) || !N(O)) {
            if (!ee)
              return;
            I = 0, R = D(F.width, Q.width);
          }
          this.left = D(F.left, Y.plotLeft + ae + (V ? Y.plotWidth : 0));
          let de = this.size = ie = D(F.len, (V ? Y.plotHeight : Y.plotWidth) - 2 * ae);
          z = V ? ne : ie + 2 * ae, I = D(I, F.toPixels(T, !0)), R = D(R, F.toPixels(O, !0)), N(I) && Math.abs(I) !== 1 / 0 || (I = 0, R = z);
          let me = F.toValue(I, !0), ce = F.toValue(R, !0), pe = Math.abs(f(ce - me));
          pe < G ? this.grabbedLeft ? I = F.toPixels(ce - G - U, !0) : this.grabbedRight && (R = F.toPixels(me + G + U, !0)) : S(W) && f(pe - U) > W && (this.grabbedLeft ? I = F.toPixels(ce - W - U, !0) : this.grabbedRight && (R = F.toPixels(me + W + U, !0))), this.zoomedMax = P(Math.max(I, R), 0, de), this.zoomedMin = P(this.fixedWidth ? this.zoomedMax - this.fixedWidth : Math.min(I, R), 0, de), this.range = this.zoomedMax - this.zoomedMin, de = Math.round(this.zoomedMax);
          let xe = Math.round(this.zoomedMin);
          J && (this.navigatorGroup.attr({ visibility: "inherit" }), re = ee && !this.hasDragged ? "animate" : "attr", this.drawMasks(xe, de, V, re), this.drawOutline(xe, de, V, re), this.navigatorOptions.handles.enabled && (this.drawHandle(xe, 0, V, re), this.drawHandle(de, 1, V, re))), this.scrollbar && (V ? (Z = this.top - ae, q = this.left - ne + (J || !Q.opposite ? 0 : (Q.titleOffset || 0) + Q.axisTitleMargin), ne = ie + 2 * ae) : (Z = this.top + (J ? this.height : -ne), q = this.left - ae), this.scrollbar.position(q, Z, z, ne), this.scrollbar.setRange(this.zoomedMin / (ie || 1), this.zoomedMax / (ie || 1))), this.rendered = !0, this.isDirty = !1, $(this, "afterRender");
        }
        addMouseEvents() {
          let T = this, O = T.chart, I = O.container, R = [], Y, F;
          T.mouseMoveHandler = Y = function(U) {
            T.onMouseMove(U);
          }, T.mouseUpHandler = F = function(U) {
            T.onMouseUp(U);
          }, (R = T.getPartsEvents("mousedown")).push(v(O.renderTo, "mousemove", Y), v(I.ownerDocument, "mouseup", F), v(O.renderTo, "touchmove", Y), v(I.ownerDocument, "touchend", F)), R.concat(T.getPartsEvents("touchstart")), T.eventsToUnbind = R, T.series && T.series[0] && R.push(v(T.series[0].xAxis, "foundExtremes", function() {
            O.navigator.modifyNavigatorAxisExtremes();
          }));
        }
        getPartsEvents(T) {
          let O = this, I = [];
          return ["shades", "handles"].forEach(function(R) {
            O[R].forEach(function(Y, F) {
              I.push(v(Y.element, T, function(U) {
                O[R + "Mousedown"](U, F);
              }));
            });
          }), I;
        }
        shadesMousedown(T, O) {
          T = this.chart.pointer?.normalize(T) || T;
          let I = this.chart, R = this.xAxis, Y = this.zoomedMin, F = this.size, U = this.range, Q = this.left, J = T.chartX, ee, V, G, W;
          I.inverted && (J = T.chartY, Q = this.top), O === 1 ? (this.grabbedCenter = J, this.fixedWidth = U, this.dragOffset = J - Y) : (W = J - Q - U / 2, O === 0 ? W = Math.max(0, W) : O === 2 && W + U >= F && (W = F - U, this.reversedExtremes ? (W -= U, V = this.getUnionExtremes().dataMin) : ee = this.getUnionExtremes().dataMax), W !== Y && (this.fixedWidth = U, S((G = R.navigatorAxis.toFixedRange(W, W + U, V, ee)).min) && $(this, "setRange", { min: Math.min(G.min, G.max), max: Math.max(G.min, G.max), redraw: !0, eventArguments: { trigger: "navigator" } })));
        }
        handlesMousedown(T, O) {
          T = this.chart.pointer?.normalize(T) || T;
          let I = this.chart, R = I.xAxis[0], Y = this.reversedExtremes;
          O === 0 ? (this.grabbedLeft = !0, this.otherHandlePos = this.zoomedMax, this.fixedExtreme = Y ? R.min : R.max) : (this.grabbedRight = !0, this.otherHandlePos = this.zoomedMin, this.fixedExtreme = Y ? R.max : R.min), I.setFixedRange(void 0);
        }
        onMouseMove(T) {
          let O = this, I = O.chart, R = O.navigatorSize, Y = O.range, F = O.dragOffset, U = I.inverted, Q = O.left, J;
          (!T.touches || T.touches[0].pageX !== 0) && (J = (T = I.pointer?.normalize(T) || T).chartX, U && (Q = O.top, J = T.chartY), O.grabbedLeft ? (O.hasDragged = !0, O.render(0, 0, J - Q, O.otherHandlePos)) : O.grabbedRight ? (O.hasDragged = !0, O.render(0, 0, O.otherHandlePos, J - Q)) : O.grabbedCenter && (O.hasDragged = !0, J < F ? J = F : J > R + F - Y && (J = R + F - Y), O.render(0, 0, J - F, J - F + Y)), O.hasDragged && O.scrollbar && D(O.scrollbar.options.liveRedraw, !c && !this.chart.boosted) && (T.DOMType = T.type, setTimeout(function() {
            O.onMouseUp(T);
          }, 0)));
        }
        onMouseUp(T) {
          let O, I, R, Y, F, U, Q = this.chart, J = this.xAxis, ee = this.scrollbar, V = T.DOMEvent || T, G = Q.inverted, W = this.rendered && !this.hasDragged ? "animate" : "attr";
          (this.hasDragged && (!ee || !ee.hasDragged) || T.trigger === "scrollbar") && (R = this.getUnionExtremes(), this.zoomedMin === this.otherHandlePos ? Y = this.fixedExtreme : this.zoomedMax === this.otherHandlePos && (F = this.fixedExtreme), this.zoomedMax === this.size && (F = this.reversedExtremes ? R.dataMin : R.dataMax), this.zoomedMin === 0 && (Y = this.reversedExtremes ? R.dataMax : R.dataMin), S((U = J.navigatorAxis.toFixedRange(this.zoomedMin, this.zoomedMax, Y, F)).min) && $(this, "setRange", { min: Math.min(U.min, U.max), max: Math.max(U.min, U.max), redraw: !0, animation: !this.hasDragged && null, eventArguments: { trigger: "navigator", triggerOp: "navigator-drag", DOMEvent: V } })), T.DOMType !== "mousemove" && T.DOMType !== "touchmove" && (this.grabbedLeft = this.grabbedRight = this.grabbedCenter = this.fixedWidth = this.fixedExtreme = this.otherHandlePos = this.hasDragged = this.dragOffset = null), this.navigatorEnabled && N(this.zoomedMin) && N(this.zoomedMax) && (I = Math.round(this.zoomedMin), O = Math.round(this.zoomedMax), this.shades && this.drawMasks(I, O, G, W), this.outline && this.drawOutline(I, O, G, W), this.navigatorOptions.handles.enabled && Object.keys(this.handles).length === this.handles.length && (this.drawHandle(I, 0, G, W), this.drawHandle(O, 1, G, W)));
        }
        removeEvents() {
          this.eventsToUnbind && (this.eventsToUnbind.forEach(function(T) {
            T();
          }), this.eventsToUnbind = void 0), this.removeBaseSeriesEvents();
        }
        removeBaseSeriesEvents() {
          let T = this.baseSeries || [];
          this.navigatorEnabled && T[0] && (this.navigatorOptions.adaptToUpdatedData !== !1 && T.forEach(function(O) {
            C(O, "updatedData", this.updatedDataHandler);
          }, this), T[0].xAxis && C(T[0].xAxis, "foundExtremes", this.modifyBaseAxisExtremes));
        }
        getXAxisOffsets() {
          return this.chart.inverted ? [this.scrollButtonSize, 0, -this.scrollButtonSize, 0] : [0, -this.scrollButtonSize, 0, this.scrollButtonSize];
        }
        init(T) {
          let O = T.options, I = O.navigator || {}, R = I.enabled, Y = O.scrollbar || {}, F = Y.enabled, U = R && I.height || 0, Q = F && Y.height || 0, J = Y.buttonsEnabled && Q || 0;
          this.handles = [], this.shades = [], this.chart = T, this.setBaseSeries(), this.height = U, this.scrollbarHeight = Q, this.scrollButtonSize = J, this.scrollbarEnabled = F, this.navigatorEnabled = R, this.navigatorOptions = I, this.scrollbarOptions = Y, this.setOpposite();
          let ee = this, V = ee.baseSeries, G = T.xAxis.length, W = T.yAxis.length, ae = V && V[0] && V[0].xAxis || T.xAxis[0] || { options: {} };
          if (T.isDirtyBox = !0, ee.navigatorEnabled) {
            let z = this.getXAxisOffsets();
            ee.xAxis = new o(T, M({ breaks: ae.options.breaks, ordinal: ae.options.ordinal, overscroll: ae.options.overscroll }, I.xAxis, { type: "datetime", yAxis: I.yAxis?.id, index: G, isInternal: !0, offset: 0, keepOrdinalPadding: !0, startOnTick: !1, endOnTick: !1, minPadding: ae.options.ordinal ? 0 : ae.options.minPadding, maxPadding: ae.options.ordinal ? 0 : ae.options.maxPadding, zoomEnabled: !1 }, T.inverted ? { offsets: z, width: U } : { offsets: z, height: U }), "xAxis"), ee.yAxis = new o(T, M(I.yAxis, { alignTicks: !1, offset: 0, index: W, isInternal: !0, reversed: D(I.yAxis && I.yAxis.reversed, T.yAxis[0] && T.yAxis[0].reversed, !1), zoomEnabled: !1 }, T.inverted ? { width: U } : { height: U }), "yAxis"), V || I.series.data ? ee.updateNavigatorSeries(!1) : T.series.length === 0 && (ee.unbindRedraw = v(T, "beforeRedraw", function() {
              T.series.length > 0 && !ee.series && (ee.setBaseSeries(), ee.unbindRedraw());
            })), ee.reversedExtremes = T.inverted && !ee.xAxis.reversed || !T.inverted && ee.xAxis.reversed, ee.renderElements(), ee.addMouseEvents();
          } else
            ee.xAxis = { chart: T, navigatorAxis: { fake: !0 }, translate: function(z, q) {
              let Z = T.xAxis[0], ne = Z.getExtremes(), ie = Z.len - 2 * J, re = p("min", Z.options.min, ne.dataMin), de = p("max", Z.options.max, ne.dataMax) - re;
              return q ? z * de / ie + re : ie * (z - re) / de;
            }, toPixels: function(z) {
              return this.translate(z);
            }, toValue: function(z) {
              return this.translate(z, !0);
            } }, ee.xAxis.navigatorAxis.axis = ee.xAxis, ee.xAxis.navigatorAxis.toFixedRange = l.prototype.toFixedRange.bind(ee.xAxis.navigatorAxis);
          if (T.options.scrollbar.enabled) {
            let z = M(T.options.scrollbar, { vertical: T.inverted });
            !N(z.margin) && ee.navigatorEnabled && (z.margin = T.inverted ? -3 : 3), T.scrollbar = ee.scrollbar = new y(T.renderer, z, T), v(ee.scrollbar, "changed", function(q) {
              let Z = ee.size, ne = Z * this.to, ie = Z * this.from;
              ee.hasDragged = ee.scrollbar.hasDragged, ee.render(0, 0, ie, ne), this.shouldUpdateExtremes(q.DOMType) && setTimeout(function() {
                ee.onMouseUp(q);
              });
            });
          }
          ee.addBaseSeriesEvents(), ee.addChartEvents();
        }
        setOpposite() {
          let T = this.navigatorOptions, O = this.navigatorEnabled, I = this.chart;
          this.opposite = D(T.opposite, !!(!O && I.inverted));
        }
        getUnionExtremes(T) {
          let O, I = this.chart.xAxis[0], R = this.xAxis, Y = R.options, F = I.options;
          return T && I.dataMin === null || (O = { dataMin: D(Y && Y.min, p("min", F.min, I.dataMin, R.dataMin, R.min)), dataMax: D(Y && Y.max, p("max", F.max, I.dataMax, R.dataMax, R.max)) }), O;
        }
        setBaseSeries(T, O) {
          let I = this.chart, R = this.baseSeries = [];
          T = T || I.options && I.options.navigator.baseSeries || (I.series.length ? A(I.series, (Y) => !Y.options.isInternal).index : 0), (I.series || []).forEach((Y, F) => {
            !Y.options.isInternal && (Y.options.showInNavigator || (F === T || Y.options.id === T) && Y.options.showInNavigator !== !1) && R.push(Y);
          }), this.xAxis && !this.xAxis.navigatorAxis.fake && this.updateNavigatorSeries(!0, O);
        }
        updateNavigatorSeries(T, O) {
          let I = this, R = I.chart, Y = I.baseSeries, F = { enableMouseTracking: !1, index: null, linkedTo: null, group: "nav", padXAxis: !1, xAxis: this.navigatorOptions.xAxis?.id, yAxis: this.navigatorOptions.yAxis?.id, showInLegend: !1, stacking: void 0, isInternal: !0, states: { inactive: { opacity: 1 } } }, U = I.series = (I.series || []).filter((G) => {
            let W = G.baseSeries;
            return !(0 > Y.indexOf(W)) || (W && (C(W, "updatedData", I.updatedDataHandler), delete W.navigatorSeries), G.chart && G.destroy(), !1);
          }), Q, J, ee = I.navigatorOptions.series, V;
          Y && Y.length && Y.forEach((G) => {
            let W = G.navigatorSeries, ae = k({ color: G.color, visible: G.visible }, j(ee) ? h.navigator.series : ee);
            if (W && I.navigatorOptions.adaptToUpdatedData === !1)
              return;
            F.name = "Navigator " + Y.length, V = (Q = G.options || {}).navigatorOptions || {}, ae.dataLabels = b(ae.dataLabels), (J = M(Q, F, ae, V)).pointRange = D(ae.pointRange, V.pointRange, h.plotOptions[J.type || "line"].pointRange);
            let z = V.data || ae.data;
            I.hasNavigatorData = I.hasNavigatorData || !!z, J.data = z || Q.data && Q.data.slice(0), W && W.options ? W.update(J, O) : (G.navigatorSeries = R.initSeries(J), R.setSortedData(), G.navigatorSeries.baseSeries = G, U.push(G.navigatorSeries));
          }), (ee.data && !(Y && Y.length) || j(ee)) && (I.hasNavigatorData = !1, (ee = b(ee)).forEach((G, W) => {
            F.name = "Navigator " + (U.length + 1), (J = M(h.navigator.series, { color: R.series[W] && !R.series[W].options.isInternal && R.series[W].color || R.options.colors[W] || R.options.colors[0] }, F, G)).data = G.data, J.data && (I.hasNavigatorData = !0, U.push(R.initSeries(J)));
          })), T && this.addBaseSeriesEvents();
        }
        addBaseSeriesEvents() {
          let T = this, O = T.baseSeries || [];
          O[0] && O[0].xAxis && O[0].eventsToUnbind.push(v(O[0].xAxis, "foundExtremes", this.modifyBaseAxisExtremes)), O.forEach((I) => {
            I.eventsToUnbind.push(v(I, "show", function() {
              this.navigatorSeries && this.navigatorSeries.setVisible(!0, !1);
            })), I.eventsToUnbind.push(v(I, "hide", function() {
              this.navigatorSeries && this.navigatorSeries.setVisible(!1, !1);
            })), this.navigatorOptions.adaptToUpdatedData !== !1 && I.xAxis && I.eventsToUnbind.push(v(I, "updatedData", this.updatedDataHandler)), I.eventsToUnbind.push(v(I, "remove", function() {
              O && x(O, I), this.navigatorSeries && (x(T.series, this.navigatorSeries), S(this.navigatorSeries.options) && this.navigatorSeries.remove(!1), delete this.navigatorSeries);
            }));
          });
        }
        getBaseSeriesMin(T) {
          return this.baseSeries.reduce(function(O, I) {
            return Math.min(O, I.xData && I.xData.length ? I.xData[0] : O);
          }, T);
        }
        modifyNavigatorAxisExtremes() {
          let T = this.xAxis;
          if (T.getExtremes !== void 0) {
            let O = this.getUnionExtremes(!0);
            O && (O.dataMin !== T.min || O.dataMax !== T.max) && (T.min = O.dataMin, T.max = O.dataMax);
          }
        }
        modifyBaseAxisExtremes() {
          let T, O, I = this.chart.navigator, R = this.getExtremes(), Y = R.min, F = R.max, U = R.dataMin, Q = R.dataMax, J = F - Y, ee = I.stickToMin, V = I.stickToMax, G = D(this.ordinal?.convertOverscroll(this.options.overscroll), 0), W = I.series && I.series[0], ae = !!this.setExtremes;
          !(this.eventArgs && this.eventArgs.trigger === "rangeSelectorButton") && (ee && (T = (O = U) + J), V && (T = Q + G, ee || (O = Math.max(U, T - J, I.getBaseSeriesMin(W && W.xData ? W.xData[0] : -Number.MAX_VALUE)))), ae && (ee || V) && N(O) && (this.min = this.userMin = O, this.max = this.userMax = T)), I.stickToMin = I.stickToMax = null;
        }
        updatedDataHandler() {
          let T = this.chart.navigator, O = this.navigatorSeries, I = T.reversedExtremes ? Math.round(T.zoomedMin) === 0 : Math.round(T.zoomedMax) >= Math.round(T.size);
          T.stickToMax = D(this.chart.options.navigator && this.chart.options.navigator.stickToMax, I), T.stickToMin = T.shouldStickToMin(this, T), O && !T.hasNavigatorData && (O.options.pointStart = this.xData[0], O.setData(this.options.data, !1, null, !1));
        }
        shouldStickToMin(T, O) {
          let I = O.getBaseSeriesMin(T.xData[0]), R = T.xAxis, Y = R.max, F = R.min, U = R.options.range;
          return !!(N(Y) && N(F)) && (U && Y - I > 0 ? Y - I < U : F <= I);
        }
        addChartEvents() {
          this.eventsToUnbind || (this.eventsToUnbind = []), this.eventsToUnbind.push(v(this.chart, "redraw", function() {
            let T = this.navigator, O = T && (T.baseSeries && T.baseSeries[0] && T.baseSeries[0].xAxis || this.xAxis[0]);
            O && T.render(O.min, O.max);
          }), v(this.chart, "getMargins", function() {
            let T = this.navigator, O = T.opposite ? "plotTop" : "marginBottom";
            this.inverted && (O = T.opposite ? "marginRight" : "plotLeft"), this[O] = (this[O] || 0) + (T.navigatorEnabled || !this.inverted ? T.height + T.scrollbarHeight : 0) + T.navigatorOptions.margin;
          }), v(L, "setRange", function(T) {
            this.chart.xAxis[0].setExtremes(T.min, T.max, T.redraw, T.animation, T.eventArguments);
          }));
        }
        destroy() {
          this.removeEvents(), this.xAxis && (x(this.chart.xAxis, this.xAxis), x(this.chart.axes, this.xAxis)), this.yAxis && (x(this.chart.yAxis, this.yAxis), x(this.chart.axes, this.yAxis)), (this.series || []).forEach((T) => {
            T.destroy && T.destroy();
          }), ["series", "xAxis", "yAxis", "shades", "outline", "scrollbarTrack", "scrollbarRifles", "scrollbarGroup", "scrollbar", "navigatorGroup", "rendered"].forEach((T) => {
            this[T] && this[T].destroy && this[T].destroy(), this[T] = null;
          }), [this.handles].forEach((T) => {
            w(T);
          }), this.navigatorEnabled = !1;
        }
      }
      return L;
    }), i(n, "Accessibility/Components/NavigatorComponent.js", [n["Accessibility/AccessibilityComponent.js"], n["Accessibility/Utils/Announcer.js"], n["Accessibility/KeyboardNavigationHandler.js"], n["Stock/Navigator/Navigator.js"], n["Core/Animation/AnimationUtilities.js"], n["Core/Templating.js"], n["Core/Utilities.js"], n["Accessibility/Utils/HTMLUtilities.js"], n["Accessibility/Utils/ChartUtilities.js"]], function(o, a, r, s, l, d, y, u, m) {
      let { animObject: h } = l, { format: c } = d, { clamp: g, pick: v, syncTimeout: P } = y, { getFakeMouseEvent: f } = u, { getAxisRangeDescription: S, fireEventOnWrappedOrUnwrappedElement: w } = m;
      return class extends o {
        init() {
          let x = this.chart, k = this;
          this.announcer = new a(x, "polite"), this.addEvent(s, "afterRender", function() {
            this.chart === k.chart && this.chart.renderer && P(() => {
              k.proxyProvider.updateGroupProxyElementPositions("navigator"), k.updateHandleValues();
            }, h(v(this.chart.renderer.globalAnimation, !0)).duration);
          });
        }
        onChartUpdate() {
          let x = this.chart, k = x.options, A = k.navigator;
          if (A.enabled && A.accessibility?.enabled) {
            let $ = k.accessibility.landmarkVerbosity, j = k.lang.accessibility?.navigator.groupLabel;
            this.proxyProvider.removeGroup("navigator"), this.proxyProvider.addGroup("navigator", "div", { role: $ === "all" ? "region" : "group", "aria-label": c(j, { chart: x }, x) });
            let N = k.lang.accessibility?.navigator.handleLabel;
            [0, 1].forEach((M) => {
              let D = this.getHandleByIx(M);
              if (D) {
                let C = this.proxyProvider.addProxyElement("navigator", { click: D }, "input", { type: "range", "aria-label": c(N, { handleIx: M, chart: x }, x) });
                this[M ? "maxHandleProxy" : "minHandleProxy"] = C.innerElement, C.innerElement.style.pointerEvents = "none", C.innerElement.oninput = () => this.updateNavigator();
              }
            }), this.updateHandleValues();
          } else
            this.proxyProvider.removeGroup("navigator");
        }
        getNavigatorHandleNavigation(x) {
          let k = this, A = this.chart, $ = x ? this.maxHandleProxy : this.minHandleProxy, j = this.keyCodes;
          return new r(A, { keyCodeMap: [[[j.left, j.right, j.up, j.down], function(N) {
            if ($) {
              let M = N === j.left || N === j.up ? -1 : 1;
              $.value = "" + g(parseFloat($.value) + M, 0, 100), k.updateNavigator(() => {
                let D = k.getHandleByIx(x);
                D && A.setFocusToElement(D, $);
              });
            }
            return this.response.success;
          }]], init: () => {
            A.setFocusToElement(this.getHandleByIx(x), $);
          }, validate: () => !!(this.getHandleByIx(x) && $ && A.options.navigator.accessibility?.enabled) });
        }
        getKeyboardNavigation() {
          return [this.getNavigatorHandleNavigation(0), this.getNavigatorHandleNavigation(1)];
        }
        destroy() {
          this.updateNavigatorThrottleTimer && clearTimeout(this.updateNavigatorThrottleTimer), this.proxyProvider.removeGroup("navigator"), this.announcer && this.announcer.destroy();
        }
        updateHandleValues() {
          let x = this.chart.navigator;
          if (x && this.minHandleProxy && this.maxHandleProxy) {
            let k = x.size;
            this.minHandleProxy.value = "" + Math.round(x.zoomedMin / k * 100), this.maxHandleProxy.value = "" + Math.round(x.zoomedMax / k * 100);
          }
        }
        getHandleByIx(x) {
          let k = this.chart.navigator;
          return k && k.handles && k.handles[x];
        }
        updateNavigator(x) {
          this.updateNavigatorThrottleTimer && clearTimeout(this.updateNavigatorThrottleTimer), this.updateNavigatorThrottleTimer = setTimeout(((k) => {
            let A = this.chart, { navigator: $, pointer: j } = A;
            if ($ && j && this.minHandleProxy && this.maxHandleProxy) {
              let N = j.getChartPosition(), M = parseFloat(this.minHandleProxy.value) / 100 * $.size, D = parseFloat(this.maxHandleProxy.value) / 100 * $.size;
              [[0, "mousedown", $.zoomedMin], [0, "mousemove", M], [0, "mouseup", M], [1, "mousedown", $.zoomedMax], [1, "mousemove", D], [1, "mouseup", D]].forEach(([p, L, B]) => {
                let T = this.getHandleByIx(p)?.element;
                T && w(T, f(L, { x: N.left + $.left + B, y: N.top + $.top }, T));
              }), k && k();
              let C = A.options.lang.accessibility?.navigator.changeAnnouncement, b = S(A.xAxis[0]);
              this.announcer.announce(c(C, { axisRangeDescription: b, chart: A }, A));
            }
          }).bind(this, x), 20);
        }
      };
    }), i(n, "Accessibility/Components/SeriesComponent/SeriesDescriber.js", [n["Accessibility/Components/AnnotationsA11y.js"], n["Accessibility/Utils/ChartUtilities.js"], n["Core/Templating.js"], n["Accessibility/Utils/HTMLUtilities.js"], n["Core/Utilities.js"]], function(o, a, r, s, l) {
      let { getPointAnnotationTexts: d } = o, { getAxisDescription: y, getSeriesFirstPointElement: u, getSeriesA11yElement: m, unhideChartElementFromAT: h } = a, { format: c, numberFormat: g } = r, { reverseChildNodes: v, stripHTMLTagsFromString: P } = s, { find: f, isNumber: S, isString: w, pick: x, defined: k } = l;
      function A(D) {
        let C = D.chart.options.accessibility.series.pointDescriptionEnabledThreshold;
        return !!(C !== !1 && D.points && D.points.length >= +C);
      }
      function $(D, C) {
        let b = D.series, p = b.chart, L = p.options.accessibility.point || {}, B = b.options.accessibility && b.options.accessibility.point || {}, T = b.tooltipOptions || {}, O = p.options.lang;
        return S(C) ? g(C, B.valueDecimals || L.valueDecimals || T.valueDecimals || -1, O.decimalPoint, O.accessibility.thousandsSep || O.thousandsSep) : C;
      }
      function j(D, C) {
        let b = D[C];
        return D.chart.langFormat("accessibility.series." + C + "Description", { name: y(b), series: D });
      }
      function N(D) {
        let C = D.series, b = C.chart.series.length > 1 || C.options.name, p = function(O) {
          let I = O.series, R = I.chart, Y = I.options.accessibility, F = Y && Y.point && Y.point.valueDescriptionFormat || R.options.accessibility.point.valueDescriptionFormat, U = x(I.xAxis && I.xAxis.options.accessibility && I.xAxis.options.accessibility.enabled, !R.angular && I.type !== "flowmap"), Q = U ? function(J) {
            let ee = function(ae) {
              let z = ae.series, q = z.chart, Z = z.options.accessibility && z.options.accessibility.point || {}, ne = q.options.accessibility.point || {}, ie = z.xAxis && z.xAxis.dateTime;
              if (ie) {
                let re = ie.getXDateFormat(ae.x || 0, q.options.tooltip.dateTimeLabelFormats), de = Z.dateFormatter && Z.dateFormatter(ae) || ne.dateFormatter && ne.dateFormatter(ae) || Z.dateFormat || ne.dateFormat || re;
                return q.time.dateFormat(de, ae.x || 0, void 0);
              }
            }(J), V = (J.series.xAxis || {}).categories && k(J.category) && ("" + J.category).replace("<br/>", " "), G = k(J.id) && 0 > ("" + J.id).indexOf("highcharts-"), W = "x, " + J.x;
            return J.name || ee || V || (G ? J.id : W);
          }(O) : "";
          return c(F, { point: O, index: k(O.index) ? O.index + 1 : "", xDescription: Q, value: function(J) {
            let ee = J.series, V = ee.chart.options.accessibility.point || {}, G = ee.chart.options.accessibility && ee.chart.options.accessibility.point || {}, W = ee.tooltipOptions || {}, ae = G.valuePrefix || V.valuePrefix || W.valuePrefix || "", z = G.valueSuffix || V.valueSuffix || W.valueSuffix || "", q = J.value !== void 0 ? "value" : "y", Z = $(J, J[q]);
            return J.isNull ? ee.chart.langFormat("accessibility.series.nullPointValue", { point: J }) : ee.pointArrayMap ? function(ne, ie, re) {
              let de = ie || "", me = re || "", ce = function(pe) {
                let xe = $(ne, x(ne[pe], ne.options[pe]));
                return xe !== void 0 ? pe + ": " + de + xe + me : xe;
              };
              return ne.series.pointArrayMap.reduce(function(pe, xe) {
                let le = ce(xe);
                return le ? pe + (pe.length ? ", " : "") + le : pe;
              }, "");
            }(J, ae, z) : ae + Z + z;
          }(O), separator: U ? ", " : "" }, R);
        }(D), L = D.options && D.options.accessibility && D.options.accessibility.description, B = b ? " " + C.name + "." : "", T = function(O) {
          let I = O.series.chart, R = d(O);
          return R.length ? I.langFormat("accessibility.series.pointAnnotationsDescription", { point: O, annotations: R }) : "";
        }(D);
        return D.accessibility = D.accessibility || {}, D.accessibility.valueDescription = p, p + (L ? " " + L : "") + B + (T ? " " + T : "");
      }
      function M(D) {
        let C = D.chart, b = C.types || [], p = function(U) {
          let Q = (U.options.accessibility || {}).description;
          return Q && U.chart.langFormat("accessibility.series.description", { description: Q, series: U }) || "";
        }(D), L = function(U) {
          return C[U] && C[U].length > 1 && D[U];
        }, B = D.index + 1, T = j(D, "xAxis"), O = j(D, "yAxis"), I = { seriesNumber: B, series: D, chart: C }, R = b.length > 1 ? "Combination" : "", Y = C.langFormat("accessibility.series.summary." + D.type + R, I) || C.langFormat("accessibility.series.summary.default" + R, I), F = (L("yAxis") ? " " + O + "." : "") + (L("xAxis") ? " " + T + "." : "");
        return c(x(D.options.accessibility && D.options.accessibility.descriptionFormat, C.options.accessibility.series.descriptionFormat, ""), { seriesDescription: Y, authorDescription: p ? " " + p : "", axisDescription: F, series: D, chart: C, seriesNumber: B }, void 0);
      }
      return { defaultPointDescriptionFormatter: N, defaultSeriesDescriptionFormatter: M, describeSeries: function(D) {
        let C = D.chart, b = u(D), p = m(D), L = C.is3d && C.is3d();
        p && (p.lastChild !== b || L || v(p), function(B) {
          let T = function(R) {
            let Y = R.options.accessibility || {};
            return !A(R) && !Y.exposeAsGroupOnly;
          }(B), O = function(R) {
            let Y = R.chart.options.accessibility.keyboardNavigation.seriesNavigation;
            return !!(R.points && (R.points.length < +Y.pointNavigationEnabledThreshold || Y.pointNavigationEnabledThreshold === !1));
          }(B), I = B.chart.options.accessibility.point.describeNull;
          (T || O) && B.points.forEach((R) => {
            let Y = R.graphic && R.graphic.element || function(U) {
              let Q = U.series, J = Q && Q.chart, ee = Q && Q.is("sunburst"), V = U.isNull, G = J && J.options.accessibility.point.describeNull;
              return V && !ee && G;
            }(R) && function(U) {
              let Q = U.series, J = function(ae) {
                let z = ae.index;
                return ae.series && ae.series.data && k(z) && f(ae.series.data, function(q) {
                  return !!(q && q.index !== void 0 && q.index > z && q.graphic && q.graphic.element);
                }) || null;
              }(U), ee = J && J.graphic, V = ee ? ee.parentGroup : Q.graph || Q.group, G = J ? { x: x(U.plotX, J.plotX, 0), y: x(U.plotY, J.plotY, 0) } : { x: x(U.plotX, 0), y: x(U.plotY, 0) }, W = function(ae, z) {
                let q = ae.series.chart.renderer.rect(z.x, z.y, 1, 1);
                return q.attr({ class: "highcharts-a11y-mock-point", fill: "none", opacity: 0, "fill-opacity": 0, "stroke-opacity": 0 }), q;
              }(U, G);
              if (V && V.element)
                return U.graphic = W, U.hasMockGraphic = !0, W.add(V), V.element.insertBefore(W.element, ee ? ee.element : null), W.element;
            }(R), F = R.options && R.options.accessibility && R.options.accessibility.enabled === !1;
            if (Y) {
              if (R.isNull && !I) {
                Y.setAttribute("aria-hidden", !0);
                return;
              }
              Y.setAttribute("tabindex", "-1"), B.chart.styledMode || (Y.style.outline = "none"), T && !F ? function(U, Q) {
                let J = U.series, ee = J.options.accessibility?.point || {}, V = J.chart.options.accessibility.point || {}, G = P(w(ee.descriptionFormat) && c(ee.descriptionFormat, U, J.chart) || ee.descriptionFormatter?.(U) || w(V.descriptionFormat) && c(V.descriptionFormat, U, J.chart) || V.descriptionFormatter?.(U) || N(U), J.chart.renderer.forExport);
                Q.setAttribute("role", "img"), Q.setAttribute("aria-label", G);
              }(R, Y) : Y.setAttribute("aria-hidden", !0);
            }
          });
        }(D), h(C, p), function(B) {
          let T = B.chart, O = T.options.chart, I = O.options3d && O.options3d.enabled, R = T.series.length > 1, Y = T.options.accessibility.series.describeSingleSeries, F = (B.options.accessibility || {}).exposeAsGroupOnly;
          return !(I && R) && (R || Y || F || A(B));
        }(D) ? function(B, T) {
          let O = B.options.accessibility || {}, I = B.chart.options.accessibility, R = I.landmarkVerbosity;
          O.exposeAsGroupOnly ? T.setAttribute("role", "img") : R === "all" ? T.setAttribute("role", "region") : T.setAttribute("role", "group"), T.setAttribute("tabindex", "-1"), B.chart.styledMode || (T.style.outline = "none"), T.setAttribute("aria-label", P(I.series.descriptionFormatter && I.series.descriptionFormatter(B) || M(B), B.chart.renderer.forExport));
        }(D, p) : p.removeAttribute("aria-label"));
      } };
    }), i(n, "Accessibility/Components/SeriesComponent/NewDataAnnouncer.js", [n["Core/Globals.js"], n["Core/Utilities.js"], n["Accessibility/Utils/Announcer.js"], n["Accessibility/Utils/ChartUtilities.js"], n["Accessibility/Utils/EventProvider.js"], n["Accessibility/Components/SeriesComponent/SeriesDescriber.js"]], function(o, a, r, s, l, d) {
      let { composed: y } = o, { addEvent: u, defined: m, pushUnique: h } = a, { getChartTitle: c } = s, { defaultPointDescriptionFormatter: g, defaultSeriesDescriptionFormatter: v } = d;
      function P(S) {
        return !!S.options.accessibility.announceNewData.enabled;
      }
      class f {
        constructor(w) {
          this.dirty = { allSeries: {} }, this.lastAnnouncementTime = 0, this.chart = w;
        }
        init() {
          let w = this.chart, x = w.options.accessibility.announceNewData.interruptUser ? "assertive" : "polite";
          this.lastAnnouncementTime = 0, this.dirty = { allSeries: {} }, this.eventProvider = new l(), this.announcer = new r(w, x), this.addEventListeners();
        }
        destroy() {
          this.eventProvider.removeAddedEvents(), this.announcer.destroy();
        }
        addEventListeners() {
          let w = this, x = this.chart, k = this.eventProvider;
          k.addEvent(x, "afterApplyDrilldown", function() {
            w.lastAnnouncementTime = 0;
          }), k.addEvent(x, "afterAddSeries", function(A) {
            w.onSeriesAdded(A.series);
          }), k.addEvent(x, "redraw", function() {
            w.announceDirtyData();
          });
        }
        onSeriesAdded(w) {
          P(this.chart) && (this.dirty.hasDirty = !0, this.dirty.allSeries[w.name + w.index] = w, this.dirty.newSeries = m(this.dirty.newSeries) ? void 0 : w);
        }
        announceDirtyData() {
          let w = this.chart, x = this;
          if (w.options.accessibility.announceNewData && this.dirty.hasDirty) {
            let k = this.dirty.newPoint;
            k && (k = function(A) {
              let $ = A.series.data.filter((j) => A.x === j.x && A.y === j.y);
              return $.length === 1 ? $[0] : A;
            }(k)), this.queueAnnouncement(Object.keys(this.dirty.allSeries).map((A) => x.dirty.allSeries[A]), this.dirty.newSeries, k), this.dirty = { allSeries: {} };
          }
        }
        queueAnnouncement(w, x, k) {
          let A = this.chart.options.accessibility.announceNewData;
          if (A.enabled) {
            let $ = +/* @__PURE__ */ new Date(), j = $ - this.lastAnnouncementTime, N = Math.max(0, A.minAnnounceInterval - j), M = function(C, b) {
              let p = (C || []).concat(b || []).reduce((L, B) => (L[B.name + B.index] = B, L), {});
              return Object.keys(p).map((L) => p[L]);
            }(this.queuedAnnouncement && this.queuedAnnouncement.series, w), D = this.buildAnnouncementMessage(M, x, k);
            D && (this.queuedAnnouncement && clearTimeout(this.queuedAnnouncementTimer), this.queuedAnnouncement = { time: $, message: D, series: M }, this.queuedAnnouncementTimer = setTimeout(() => {
              this && this.announcer && (this.lastAnnouncementTime = +/* @__PURE__ */ new Date(), this.announcer.announce(this.queuedAnnouncement.message), delete this.queuedAnnouncement, delete this.queuedAnnouncementTimer);
            }, N));
          }
        }
        buildAnnouncementMessage(w, x, k) {
          let A = this.chart, $ = A.options.accessibility.announceNewData;
          if ($.announcementFormatter) {
            let D = $.announcementFormatter(w, x, k);
            if (D !== !1)
              return D.length ? D : null;
          }
          let j = o.charts && o.charts.length > 1 ? "Multiple" : "Single", N = x ? "newSeriesAnnounce" + j : k ? "newPointAnnounce" + j : "newDataAnnounce", M = c(A);
          return A.langFormat("accessibility.announceNewData." + N, { chartTitle: M, seriesDesc: x ? v(x) : null, pointDesc: k ? g(k) : null, point: k, series: x });
        }
      }
      return function(S) {
        function w(k) {
          let A = this.chart, $ = A.accessibility?.components.series.newDataAnnouncer;
          $ && $.chart === A && P(A) && ($.dirty.newPoint = m($.dirty.newPoint) ? void 0 : k.point);
        }
        function x() {
          let k = this.chart, A = k.accessibility?.components.series.newDataAnnouncer;
          A && A.chart === k && P(k) && (A.dirty.hasDirty = !0, A.dirty.allSeries[this.name + this.index] = this);
        }
        S.compose = function(k) {
          h(y, "A11y.NDA") && (u(k, "addPoint", w), u(k, "updatedData", x));
        };
      }(f || (f = {})), f;
    }), i(n, "Accessibility/ProxyElement.js", [n["Core/Globals.js"], n["Core/Utilities.js"], n["Accessibility/Utils/EventProvider.js"], n["Accessibility/Utils/ChartUtilities.js"], n["Accessibility/Utils/HTMLUtilities.js"]], function(o, a, r, s, l) {
      let { doc: d } = o, { attr: y, css: u, merge: m } = a, { fireEventOnWrappedOrUnwrappedElement: h } = s, { cloneMouseEvent: c, cloneTouchEvent: g, getFakeMouseEvent: v, removeElement: P } = l;
      return class {
        constructor(f, S, w = "button", x, k) {
          this.chart = f, this.target = S, this.eventProvider = new r();
          let A = this.innerElement = d.createElement(w), $ = this.element = x ? d.createElement(x) : A;
          f.styledMode || this.hideElementVisually(A), x && (x !== "li" || f.styledMode || ($.style.listStyle = "none"), $.appendChild(A), this.element = $), this.updateTarget(S, k);
        }
        click() {
          let f = this.getTargetPosition();
          f.x += f.width / 2, f.y += f.height / 2;
          let S = v("click", f);
          h(this.target.click, S);
        }
        updateTarget(f, S) {
          this.target = f, this.updateCSSClassName();
          let w = S || {};
          Object.keys(w).forEach((k) => {
            w[k] === null && delete w[k];
          });
          let x = this.getTargetAttr(f.click, "aria-label");
          y(this.innerElement, m(x ? { "aria-label": x } : {}, w)), this.eventProvider.removeAddedEvents(), this.addProxyEventsToElement(this.innerElement, f.click), this.refreshPosition();
        }
        refreshPosition() {
          let f = this.getTargetPosition();
          u(this.innerElement, { width: (f.width || 1) + "px", height: (f.height || 1) + "px", left: (Math.round(f.x) || 0) + "px", top: (Math.round(f.y) || 0) + "px" });
        }
        remove() {
          this.eventProvider.removeAddedEvents(), P(this.element);
        }
        updateCSSClassName() {
          let f = (A) => A.indexOf("highcharts-no-tooltip") > -1, S = this.chart.legend, w = S.group && S.group.div, x = f(w && w.className || ""), k = f(this.getTargetAttr(this.target.click, "class") || "");
          this.innerElement.className = x || k ? "highcharts-a11y-proxy-element highcharts-no-tooltip" : "highcharts-a11y-proxy-element";
        }
        addProxyEventsToElement(f, S) {
          ["click", "touchstart", "touchend", "touchcancel", "touchmove", "mouseover", "mouseenter", "mouseleave", "mouseout"].forEach((w) => {
            let x = w.indexOf("touch") === 0;
            this.eventProvider.addEvent(f, w, (k) => {
              let A = x ? g(k) : c(k);
              S && h(S, A), k.stopPropagation(), x || k.preventDefault();
            }, { passive: !1 });
          });
        }
        hideElementVisually(f) {
          u(f, { borderWidth: 0, backgroundColor: "transparent", cursor: "pointer", outline: "none", opacity: 1e-3, filter: "alpha(opacity=1)", zIndex: 999, overflow: "hidden", padding: 0, margin: 0, display: "block", position: "absolute", "-ms-filter": "progid:DXImageTransform.Microsoft.Alpha(Opacity=1)" });
        }
        getTargetPosition() {
          let f = this.target.click, S = f.element ? f.element : f, w = this.target.visual || S, x = this.chart.renderTo, k = this.chart.pointer;
          if (x && w?.getBoundingClientRect && k) {
            let A = w.getBoundingClientRect(), $ = k.getChartPosition();
            return { x: (A.left - $.left) / $.scaleX, y: (A.top - $.top) / $.scaleY, width: A.right / $.scaleX - A.left / $.scaleX, height: A.bottom / $.scaleY - A.top / $.scaleY };
          }
          return { x: 0, y: 0, width: 1, height: 1 };
        }
        getTargetAttr(f, S) {
          return f.element ? f.element.getAttribute(S) : f.getAttribute(S);
        }
      };
    }), i(n, "Accessibility/ProxyProvider.js", [n["Core/Globals.js"], n["Core/Utilities.js"], n["Accessibility/Utils/ChartUtilities.js"], n["Accessibility/Utils/DOMElementProvider.js"], n["Accessibility/Utils/HTMLUtilities.js"], n["Accessibility/ProxyElement.js"]], function(o, a, r, s, l, d) {
      let { doc: y } = o, { attr: u, css: m } = a, { unhideChartElementFromAT: h } = r, { removeChildNodes: c } = l;
      return class {
        constructor(g) {
          this.chart = g, this.domElementProvider = new s(), this.groups = {}, this.groupOrder = [], this.beforeChartProxyPosContainer = this.createProxyPosContainer("before"), this.afterChartProxyPosContainer = this.createProxyPosContainer("after"), this.update();
        }
        addProxyElement(g, v, P = "button", f) {
          let S = this.groups[g];
          if (!S)
            throw Error("ProxyProvider.addProxyElement: Invalid group key " + g);
          let w = S.type === "ul" || S.type === "ol" ? "li" : void 0, x = new d(this.chart, v, P, w, f);
          return S.proxyContainerElement.appendChild(x.element), S.proxyElements.push(x), x;
        }
        addGroup(g, v = "div", P) {
          let f, S = this.groups[g];
          if (S)
            return S.groupElement;
          let w = this.domElementProvider.createElement(v);
          return P && P.role && v !== "div" ? (f = this.domElementProvider.createElement("div")).appendChild(w) : f = w, f.className = "highcharts-a11y-proxy-group highcharts-a11y-proxy-group-" + g.replace(/\W/g, "-"), this.groups[g] = { proxyContainerElement: w, groupElement: f, type: v, proxyElements: [] }, u(f, P || {}), v === "ul" && w.setAttribute("role", "list"), this.afterChartProxyPosContainer.appendChild(f), this.updateGroupOrder(this.groupOrder), f;
        }
        updateGroupAttrs(g, v) {
          let P = this.groups[g];
          if (!P)
            throw Error("ProxyProvider.updateGroupAttrs: Invalid group key " + g);
          u(P.groupElement, v);
        }
        updateGroupOrder(g) {
          if (this.groupOrder = g.slice(), this.isDOMOrderGroupOrder())
            return;
          let v = g.indexOf("series"), P = v > -1 ? g.slice(0, v) : g, f = v > -1 ? g.slice(v + 1) : [], S = y.activeElement;
          ["before", "after"].forEach((w) => {
            let x = this[w === "before" ? "beforeChartProxyPosContainer" : "afterChartProxyPosContainer"];
            c(x), (w === "before" ? P : f).forEach((k) => {
              let A = this.groups[k];
              A && x.appendChild(A.groupElement);
            });
          }), (this.beforeChartProxyPosContainer.contains(S) || this.afterChartProxyPosContainer.contains(S)) && S && S.focus && S.focus();
        }
        clearGroup(g) {
          let v = this.groups[g];
          if (!v)
            throw Error("ProxyProvider.clearGroup: Invalid group key " + g);
          c(v.proxyContainerElement);
        }
        removeGroup(g) {
          let v = this.groups[g];
          v && (this.domElementProvider.removeElement(v.groupElement), v.groupElement !== v.proxyContainerElement && this.domElementProvider.removeElement(v.proxyContainerElement), delete this.groups[g]);
        }
        update() {
          this.updatePosContainerPositions(), this.updateGroupOrder(this.groupOrder), this.updateProxyElementPositions();
        }
        updateProxyElementPositions() {
          Object.keys(this.groups).forEach(this.updateGroupProxyElementPositions.bind(this));
        }
        updateGroupProxyElementPositions(g) {
          let v = this.groups[g];
          v && v.proxyElements.forEach((P) => P.refreshPosition());
        }
        destroy() {
          this.domElementProvider.destroyCreatedElements();
        }
        createProxyPosContainer(g) {
          let v = this.domElementProvider.createElement("div");
          return v.setAttribute("aria-hidden", "false"), v.className = "highcharts-a11y-proxy-container" + (g ? "-" + g : ""), m(v, { top: "0", left: "0" }), this.chart.styledMode || (v.style.whiteSpace = "nowrap", v.style.position = "absolute"), v;
        }
        getCurrentGroupOrderInDOM() {
          let g = (S) => {
            let w = Object.keys(this.groups), x = w.length;
            for (; x--; ) {
              let k = w[x], A = this.groups[k];
              if (A && S === A.groupElement)
                return k;
            }
          }, v = (S) => {
            let w = [], x = S.children;
            for (let k = 0; k < x.length; ++k) {
              let A = g(x[k]);
              A && w.push(A);
            }
            return w;
          }, P = v(this.beforeChartProxyPosContainer), f = v(this.afterChartProxyPosContainer);
          return P.push("series"), P.concat(f);
        }
        isDOMOrderGroupOrder() {
          let g = this.getCurrentGroupOrderInDOM(), v = this.groupOrder.filter((f) => f === "series" || !!this.groups[f]), P = g.length;
          if (P !== v.length)
            return !1;
          for (; P--; )
            if (g[P] !== v[P])
              return !1;
          return !0;
        }
        updatePosContainerPositions() {
          let g = this.chart;
          if (g.renderer.forExport)
            return;
          let v = g.renderer.box;
          g.container.insertBefore(this.afterChartProxyPosContainer, v.nextSibling), g.container.insertBefore(this.beforeChartProxyPosContainer, v), h(this.chart, this.afterChartProxyPosContainer), h(this.chart, this.beforeChartProxyPosContainer);
        }
      };
    }), i(n, "Accessibility/Components/RangeSelectorComponent.js", [n["Accessibility/AccessibilityComponent.js"], n["Accessibility/Utils/Announcer.js"], n["Accessibility/Utils/ChartUtilities.js"], n["Accessibility/KeyboardNavigationHandler.js"], n["Core/Utilities.js"]], function(o, a, r, s, l) {
      let { unhideChartElementFromAT: d, getAxisRangeDescription: y } = r, { addEvent: u, attr: m } = l;
      class h extends o {
        init() {
          let g = this.chart;
          this.announcer = new a(g, "polite");
        }
        onChartUpdate() {
          let g = this.chart, v = this, P = g.rangeSelector;
          P && (this.updateSelectorVisibility(), this.setDropdownAttrs(), P.buttons && P.buttons.length && P.buttons.forEach((f) => {
            v.setRangeButtonAttrs(f);
          }), P.maxInput && P.minInput && ["minInput", "maxInput"].forEach(function(f, S) {
            let w = P[f];
            w && (d(g, w), v.setRangeInputAttrs(w, "accessibility.rangeSelector." + (S ? "max" : "min") + "InputLabel"));
          }));
        }
        updateSelectorVisibility() {
          let g = this.chart, v = g.rangeSelector, P = v && v.dropdown, f = v && v.buttons || [], S = (w) => w.setAttribute("aria-hidden", !0);
          v && v.hasVisibleDropdown && P ? (d(g, P), f.forEach((w) => S(w.element))) : (P && S(P), f.forEach((w) => d(g, w.element)));
        }
        setDropdownAttrs() {
          let g = this.chart, v = g.rangeSelector && g.rangeSelector.dropdown;
          if (v) {
            let P = g.langFormat("accessibility.rangeSelector.dropdownLabel", { rangeTitle: g.options.lang.rangeSelectorZoom });
            v.setAttribute("aria-label", P), v.setAttribute("tabindex", -1);
          }
        }
        setRangeButtonAttrs(g) {
          m(g.element, { tabindex: -1, role: "button" });
        }
        setRangeInputAttrs(g, v) {
          let P = this.chart;
          m(g, { tabindex: -1, "aria-label": P.langFormat(v, { chart: P }) });
        }
        onButtonNavKbdArrowKey(g, v) {
          let P = g.response, f = this.keyCodes, S = this.chart, w = S.options.accessibility.keyboardNavigation.wrapAround, x = v === f.left || v === f.up ? -1 : 1;
          return S.highlightRangeSelectorButton(S.highlightedRangeSelectorItemIx + x) ? P.success : w ? (g.init(x), P.success) : P[x > 0 ? "next" : "prev"];
        }
        onButtonNavKbdClick(g) {
          let v = g.response, P = this.chart;
          return P.oldRangeSelectorItemState !== 3 && this.fakeClickEvent(P.rangeSelector.buttons[P.highlightedRangeSelectorItemIx].element), v.success;
        }
        onAfterBtnClick() {
          let g = this.chart, v = y(g.xAxis[0]), P = g.langFormat("accessibility.rangeSelector.clickButtonAnnouncement", { chart: g, axisRangeDescription: v });
          P && this.announcer.announce(P);
        }
        onInputKbdMove(g) {
          let v = this.chart, P = v.rangeSelector, f = v.highlightedInputRangeIx = (v.highlightedInputRangeIx || 0) + g;
          if (f > 1 || f < 0) {
            if (v.accessibility)
              return v.accessibility.keyboardNavigation.exiting = !0, v.accessibility.keyboardNavigation.tabindexContainer.focus(), v.accessibility.keyboardNavigation.move(g);
          } else if (P) {
            let S = P[f ? "maxDateBox" : "minDateBox"], w = P[f ? "maxInput" : "minInput"];
            S && w && v.setFocusToElement(S, w);
          }
          return !0;
        }
        onInputNavInit(g) {
          let v = this, P = this.chart, f = g > 0 ? 0 : 1, S = P.rangeSelector, w = S && S[f ? "maxDateBox" : "minDateBox"], x = S && S.minInput, k = S && S.maxInput;
          if (P.highlightedInputRangeIx = f, w && x && k) {
            P.setFocusToElement(w, f ? k : x), this.removeInputKeydownHandler && this.removeInputKeydownHandler();
            let A = (N) => {
              (N.which || N.keyCode) === this.keyCodes.tab && v.onInputKbdMove(N.shiftKey ? -1 : 1) && (N.preventDefault(), N.stopPropagation());
            }, $ = u(x, "keydown", A), j = u(k, "keydown", A);
            this.removeInputKeydownHandler = () => {
              $(), j();
            };
          }
        }
        onInputNavTerminate() {
          let g = this.chart.rangeSelector || {};
          g.maxInput && g.hideInput("max"), g.minInput && g.hideInput("min"), this.removeInputKeydownHandler && (this.removeInputKeydownHandler(), delete this.removeInputKeydownHandler);
        }
        initDropdownNav() {
          let g = this.chart, v = g.rangeSelector, P = v && v.dropdown;
          v && P && (g.setFocusToElement(v.buttonGroup, P), this.removeDropdownKeydownHandler && this.removeDropdownKeydownHandler(), this.removeDropdownKeydownHandler = u(P, "keydown", (f) => {
            let S = (f.which || f.keyCode) === this.keyCodes.tab, w = g.accessibility;
            S && (f.preventDefault(), f.stopPropagation(), w && (w.keyboardNavigation.tabindexContainer.focus(), w.keyboardNavigation.move(f.shiftKey ? -1 : 1)));
          }));
        }
        getRangeSelectorButtonNavigation() {
          let g = this.chart, v = this.keyCodes, P = this;
          return new s(g, { keyCodeMap: [[[v.left, v.right, v.up, v.down], function(f) {
            return P.onButtonNavKbdArrowKey(this, f);
          }], [[v.enter, v.space], function() {
            return P.onButtonNavKbdClick(this);
          }]], validate: function() {
            return !!(g.rangeSelector && g.rangeSelector.buttons && g.rangeSelector.buttons.length);
          }, init: function(f) {
            let S = g.rangeSelector;
            if (S && S.hasVisibleDropdown)
              P.initDropdownNav();
            else if (S) {
              let w = S.buttons.length - 1;
              g.highlightRangeSelectorButton(f > 0 ? 0 : w);
            }
          }, terminate: function() {
            P.removeDropdownKeydownHandler && (P.removeDropdownKeydownHandler(), delete P.removeDropdownKeydownHandler);
          } });
        }
        getRangeSelectorInputNavigation() {
          let g = this.chart, v = this;
          return new s(g, { keyCodeMap: [], validate: function() {
            return !!(g.rangeSelector && g.rangeSelector.inputGroup && g.rangeSelector.inputGroup.element.style.visibility !== "hidden" && g.options.rangeSelector.inputEnabled !== !1 && g.rangeSelector.minInput && g.rangeSelector.maxInput);
          }, init: function(P) {
            v.onInputNavInit(P);
          }, terminate: function() {
            v.onInputNavTerminate();
          } });
        }
        getKeyboardNavigation() {
          return [this.getRangeSelectorButtonNavigation(), this.getRangeSelectorInputNavigation()];
        }
        destroy() {
          this.removeDropdownKeydownHandler && this.removeDropdownKeydownHandler(), this.removeInputKeydownHandler && this.removeInputKeydownHandler(), this.announcer && this.announcer.destroy();
        }
      }
      return function(c) {
        function g(P) {
          let f = this.rangeSelector && this.rangeSelector.buttons || [], S = this.highlightedRangeSelectorItemIx, w = this.rangeSelector && this.rangeSelector.selected;
          return S !== void 0 && f[S] && S !== w && f[S].setState(this.oldRangeSelectorItemState || 0), this.highlightedRangeSelectorItemIx = P, !!f[P] && (this.setFocusToElement(f[P].box, f[P].element), P !== w && (this.oldRangeSelectorItemState = f[P].state, f[P].setState(1)), !0);
        }
        function v() {
          let P = this.chart.accessibility;
          if (P && P.components.rangeSelector)
            return P.components.rangeSelector.onAfterBtnClick();
        }
        c.compose = function(P, f) {
          let S = P.prototype;
          S.highlightRangeSelectorButton || (S.highlightRangeSelectorButton = g, u(f, "afterBtnClick", v));
        };
      }(h || (h = {})), h;
    }), i(n, "Accessibility/Components/SeriesComponent/ForcedMarkers.js", [n["Core/Globals.js"], n["Core/Utilities.js"]], function(o, a) {
      var r;
      let { composed: s } = o, { addEvent: l, merge: d, pushUnique: y } = a;
      return function(u) {
        function m(S) {
          d(!0, S, { marker: { enabled: !0, states: { normal: { opacity: 0 } } } });
        }
        function h(S) {
          return S.marker.states && S.marker.states.normal && S.marker.states.normal.opacity;
        }
        function c(S) {
          return !!(S._hasPointMarkers && S.points && S.points.length);
        }
        function g() {
          this.chart.styledMode && (this.markerGroup && this.markerGroup[this.a11yMarkersForced ? "addClass" : "removeClass"]("highcharts-a11y-markers-hidden"), c(this) && this.points.forEach((S) => {
            S.graphic && (S.graphic[S.hasForcedA11yMarker ? "addClass" : "removeClass"]("highcharts-a11y-marker-hidden"), S.graphic[S.hasForcedA11yMarker === !1 ? "addClass" : "removeClass"]("highcharts-a11y-marker-visible"));
          }));
        }
        function v(S) {
          this.resetA11yMarkerOptions = d(S.options.marker || {}, this.userOptions.marker || {});
        }
        function P() {
          let S = this.options;
          (function(w) {
            let x = w.chart.options.accessibility.enabled, k = (w.options.accessibility && w.options.accessibility.enabled) !== !1;
            return x && k && function(A) {
              let $ = A.chart.options.accessibility;
              return A.points.length < $.series.pointDescriptionEnabledThreshold || $.series.pointDescriptionEnabledThreshold === !1;
            }(w);
          })(this) ? (S.marker && S.marker.enabled === !1 && (this.a11yMarkersForced = !0, m(this.options)), c(this) && function(w) {
            let x = w.points.length;
            for (; x--; ) {
              let k = w.points[x], A = k.options, $ = k.hasForcedA11yMarker;
              if (delete k.hasForcedA11yMarker, A.marker) {
                let j = $ && h(A) === 0;
                A.marker.enabled && !j ? (d(!0, A.marker, { states: { normal: { opacity: h(A) || 1 } } }), k.hasForcedA11yMarker = !1) : A.marker.enabled === !1 && (m(A), k.hasForcedA11yMarker = !0);
              }
            }
          }(this)) : this.a11yMarkersForced && (delete this.a11yMarkersForced, function(w) {
            let x = w.resetA11yMarkerOptions;
            if (x) {
              let k = x.states && x.states.normal && x.states.normal.opacity;
              w.userOptions && w.userOptions.marker && (w.userOptions.marker.enabled = !0), w.update({ marker: { enabled: x.enabled, states: { normal: { opacity: k } } } });
            }
          }(this), delete this.resetA11yMarkerOptions);
        }
        function f() {
          this.boosted && this.a11yMarkersForced && (d(!0, this.options, { marker: { enabled: !1 } }), delete this.a11yMarkersForced);
        }
        u.compose = function(S) {
          y(s, "A11y.FM") && (l(S, "afterSetOptions", v), l(S, "render", P), l(S, "afterRender", g), l(S, "renderCanvas", f));
        };
      }(r || (r = {})), r;
    }), i(n, "Accessibility/Components/SeriesComponent/SeriesKeyboardNavigation.js", [n["Core/Series/Point.js"], n["Core/Series/Series.js"], n["Core/Series/SeriesRegistry.js"], n["Core/Globals.js"], n["Core/Utilities.js"], n["Accessibility/KeyboardNavigationHandler.js"], n["Accessibility/Utils/EventProvider.js"], n["Accessibility/Utils/ChartUtilities.js"]], function(o, a, r, s, l, d, y, u) {
      let { seriesTypes: m } = r, { doc: h } = s, { defined: c, fireEvent: g } = l, { getPointFromXY: v, getSeriesFromName: P, scrollAxisToPoint: f } = u;
      function S(N) {
        let M = N.index, D = N.series.points, C = D.length;
        if (D[M] === N)
          return M;
        for (; C--; )
          if (D[C] === N)
            return C;
      }
      function w(N) {
        let M = N.chart.options.accessibility.keyboardNavigation.seriesNavigation, D = N.options.accessibility || {}, C = D.keyboardNavigation;
        return C && C.enabled === !1 || D.enabled === !1 || N.options.enableMouseTracking === !1 || !N.visible || M.pointNavigationEnabledThreshold && +M.pointNavigationEnabledThreshold <= N.points.length;
      }
      function x(N) {
        let M = N.series.chart.options.accessibility, D = N.options.accessibility && N.options.accessibility.enabled === !1;
        return N.isNull && M.keyboardNavigation.seriesNavigation.skipNullPoints || N.visible === !1 || N.isInside === !1 || D || w(N.series);
      }
      function k(N) {
        let M = N.series || [], D = M.length;
        for (let C = 0; C < D; ++C)
          if (!w(M[C])) {
            let b = function(p) {
              let L = p.points || [], B = L.length;
              for (let T = 0; T < B; ++T)
                if (!x(L[T]))
                  return L[T];
              return null;
            }(M[C]);
            if (b)
              return b;
          }
        return null;
      }
      function A(N) {
        let M = N.series.length, D = !1;
        for (; M-- && (N.highlightedPoint = N.series[M].points[N.series[M].points.length - 1], !(D = N.series[M].highlightNextValidPoint())); )
          ;
        return D;
      }
      function $(N) {
        delete N.highlightedPoint;
        let M = k(N);
        return !!M && M.highlight();
      }
      class j {
        constructor(M, D) {
          this.keyCodes = D, this.chart = M;
        }
        init() {
          let M = this, D = this.chart, C = this.eventProvider = new y();
          C.addEvent(a, "destroy", function() {
            return M.onSeriesDestroy(this);
          }), C.addEvent(D, "afterApplyDrilldown", function() {
            (function(b) {
              let p = k(b);
              p && p.highlight(!1);
            })(this);
          }), C.addEvent(D, "drilldown", function(b) {
            let p = b.point, L = p.series;
            M.lastDrilledDownPoint = { x: p.x, y: p.y, seriesName: L ? L.name : "" };
          }), C.addEvent(D, "drillupall", function() {
            setTimeout(function() {
              M.onDrillupAll();
            }, 10);
          }), C.addEvent(o, "afterSetState", function() {
            let b = this.graphic && this.graphic.element, p = h.activeElement, L = p && p.getAttribute("class"), B = L && L.indexOf("highcharts-a11y-proxy-element") > -1;
            D.highlightedPoint === this && p !== b && !B && b && b.focus && b.focus();
          });
        }
        onDrillupAll() {
          let M, D = this.lastDrilledDownPoint, C = this.chart, b = D && P(C, D.seriesName);
          D && b && c(D.x) && c(D.y) && (M = v(b, D.x, D.y)), M = M || k(C), C.container && C.container.focus(), M && M.highlight && M.highlight(!1);
        }
        getKeyboardNavigationHandler() {
          let M = this, D = this.keyCodes, C = this.chart, b = C.inverted;
          return new d(C, { keyCodeMap: [[b ? [D.up, D.down] : [D.left, D.right], function(p) {
            return M.onKbdSideways(this, p);
          }], [b ? [D.left, D.right] : [D.up, D.down], function(p) {
            return M.onKbdVertical(this, p);
          }], [[D.enter, D.space], function(p, L) {
            let B = C.highlightedPoint;
            if (B) {
              let { plotLeft: T, plotTop: O } = this.chart, { plotX: I = 0, plotY: R = 0 } = B;
              L = { ...L, chartX: T + I, chartY: O + R, point: B, target: B.graphic?.element || L.target }, g(B.series, "click", L), B.firePointEvent("click", L);
            }
            return this.response.success;
          }], [[D.home], function() {
            return $(C), this.response.success;
          }], [[D.end], function() {
            return A(C), this.response.success;
          }], [[D.pageDown, D.pageUp], function(p) {
            return C.highlightAdjacentSeries(p === D.pageDown), this.response.success;
          }]], init: function() {
            return M.onHandlerInit(this);
          }, validate: function() {
            return !!k(C);
          }, terminate: function() {
            return M.onHandlerTerminate();
          } });
        }
        onKbdSideways(M, D) {
          let C = this.keyCodes, b = D === C.right || D === C.down;
          return this.attemptHighlightAdjacentPoint(M, b);
        }
        onHandlerInit(M) {
          let D = this.chart;
          return D.options.accessibility.keyboardNavigation.seriesNavigation.rememberPointFocus && D.highlightedPoint ? D.highlightedPoint.highlight() : $(D), M.response.success;
        }
        onKbdVertical(M, D) {
          let C = this.chart, b = this.keyCodes, p = D === b.down || D === b.right, L = C.options.accessibility.keyboardNavigation.seriesNavigation;
          if (L.mode && L.mode === "serialize")
            return this.attemptHighlightAdjacentPoint(M, p);
          let B = C.highlightedPoint && C.highlightedPoint.series.keyboardMoveVertical ? "highlightAdjacentPointVertical" : "highlightAdjacentSeries";
          return C[B](p), M.response.success;
        }
        onHandlerTerminate() {
          let M = this.chart, D = M.options.accessibility.keyboardNavigation;
          M.tooltip && M.tooltip.hide(0);
          let C = M.highlightedPoint && M.highlightedPoint.series;
          C && C.onMouseOut && C.onMouseOut(), M.highlightedPoint && M.highlightedPoint.onMouseOut && M.highlightedPoint.onMouseOut(), D.seriesNavigation.rememberPointFocus || delete M.highlightedPoint;
        }
        attemptHighlightAdjacentPoint(M, D) {
          let C = this.chart, b = C.options.accessibility.keyboardNavigation.wrapAround;
          return C.highlightAdjacentPoint(D) || b && (D ? $(C) : A(C)) ? M.response.success : M.response[D ? "next" : "prev"];
        }
        onSeriesDestroy(M) {
          let D = this.chart;
          D.highlightedPoint && D.highlightedPoint.series === M && (delete D.highlightedPoint, D.focusElement && D.focusElement.removeFocusBorder());
        }
        destroy() {
          this.eventProvider.removeAddedEvents();
        }
      }
      return function(N) {
        function M(L) {
          let B, T, O = this.series, I = this.highlightedPoint, R = I && S(I) || 0, Y = I && I.series.points || [], F = this.series && this.series[this.series.length - 1], U = F && F.points && F.points[F.points.length - 1];
          if (!O[0] || !O[0].points)
            return !1;
          if (I) {
            if (B = O[I.series.index + (L ? 1 : -1)], (T = Y[R + (L ? 1 : -1)]) || !B || (T = B.points[L ? 0 : B.points.length - 1]), !T)
              return !1;
          } else
            T = L ? O[0].points[0] : U;
          return x(T) ? (w(B = T.series) ? this.highlightedPoint = L ? B.points[B.points.length - 1] : B.points[0] : this.highlightedPoint = T, this.highlightAdjacentPoint(L)) : T.highlight();
        }
        function D(L) {
          let B = this.highlightedPoint, T = 1 / 0, O;
          return !!(c(B.plotX) && c(B.plotY)) && (this.series.forEach((I) => {
            w(I) || I.points.forEach((R) => {
              if (!c(R.plotY) || !c(R.plotX) || R === B)
                return;
              let Y = R.plotY - B.plotY, F = Math.abs(R.plotX - B.plotX), U = Math.abs(Y) * Math.abs(Y) + F * F * 4;
              I.yAxis && I.yAxis.reversed && (Y *= -1), !(Y <= 0 && L || Y >= 0 && !L || U < 5 || x(R)) && U < T && (T = U, O = R);
            });
          }), !!O && O.highlight());
        }
        function C(L) {
          let B, T, O, I = this.highlightedPoint, R = this.series && this.series[this.series.length - 1], Y = R && R.points && R.points[R.points.length - 1];
          return this.highlightedPoint ? !!((B = this.series[I.series.index + (L ? -1 : 1)]) && (T = function(F, U, Q, J) {
            let ee = 1 / 0, V, G, W, ae = U.points.length, z = (q) => !(c(q.plotX) && c(q.plotY));
            if (!z(F)) {
              for (; ae--; )
                !z(V = U.points[ae]) && (W = (F.plotX - V.plotX) * (F.plotX - V.plotX) * 4 + (F.plotY - V.plotY) * (F.plotY - V.plotY) * 1) < ee && (ee = W, G = ae);
              return c(G) ? U.points[G] : void 0;
            }
          }(I, B))) && (w(B) ? (T.highlight(), (O = this.highlightAdjacentSeries(L)) ? O : (I.highlight(), !1)) : (T.highlight(), T.series.highlightNextValidPoint())) : (B = L ? this.series && this.series[0] : R, !!(T = L ? B && B.points && B.points[0] : Y) && T.highlight());
        }
        function b(L = !0) {
          let B = this.series.chart, T = B.tooltip?.label?.element;
          !this.isNull && L ? this.onMouseOver() : B.tooltip && B.tooltip.hide(0), f(this), this.graphic && (B.setFocusToElement(this.graphic), !L && B.focusElement && B.focusElement.removeFocusBorder()), B.highlightedPoint = this;
          let O = T?.getBoundingClientRect().top;
          if (T && O && O < 0) {
            let I = window.scrollY;
            window.scrollTo({ behavior: "smooth", top: I + O });
          }
          return this;
        }
        function p() {
          let L = this.chart.highlightedPoint, B = (L && L.series) === this ? S(L) : 0, T = this.points, O = T.length;
          if (T && O) {
            for (let I = B; I < O; ++I)
              if (!x(T[I]))
                return T[I].highlight();
            for (let I = B; I >= 0; --I)
              if (!x(T[I]))
                return T[I].highlight();
          }
          return !1;
        }
        N.compose = function(L, B, T) {
          let O = L.prototype, I = B.prototype, R = T.prototype;
          O.highlightAdjacentPoint || (O.highlightAdjacentPoint = M, O.highlightAdjacentPointVertical = D, O.highlightAdjacentSeries = C, I.highlight = b, R.keyboardMoveVertical = !0, ["column", "gantt", "pie"].forEach((Y) => {
            m[Y] && (m[Y].prototype.keyboardMoveVertical = !1);
          }), R.highlightNextValidPoint = p);
        };
      }(j || (j = {})), j;
    }), i(n, "Accessibility/Components/SeriesComponent/SeriesComponent.js", [n["Accessibility/AccessibilityComponent.js"], n["Accessibility/Utils/ChartUtilities.js"], n["Accessibility/Components/SeriesComponent/ForcedMarkers.js"], n["Accessibility/Components/SeriesComponent/NewDataAnnouncer.js"], n["Accessibility/Components/SeriesComponent/SeriesDescriber.js"], n["Accessibility/Components/SeriesComponent/SeriesKeyboardNavigation.js"]], function(o, a, r, s, l, d) {
      let { hideSeriesFromAT: y } = a, { describeSeries: u } = l;
      return class extends o {
        static compose(m, h, c) {
          s.compose(c), r.compose(c), d.compose(m, h, c);
        }
        init() {
          this.newDataAnnouncer = new s(this.chart), this.newDataAnnouncer.init(), this.keyboardNavigation = new d(this.chart, this.keyCodes), this.keyboardNavigation.init(), this.hideTooltipFromATWhenShown(), this.hideSeriesLabelsFromATWhenShown();
        }
        hideTooltipFromATWhenShown() {
          let m = this;
          this.chart.tooltip && this.addEvent(this.chart.tooltip.constructor, "refresh", function() {
            this.chart === m.chart && this.label && this.label.element && this.label.element.setAttribute("aria-hidden", !0);
          });
        }
        hideSeriesLabelsFromATWhenShown() {
          this.addEvent(this.chart, "afterDrawSeriesLabels", function() {
            this.series.forEach(function(m) {
              m.labelBySeries && m.labelBySeries.attr("aria-hidden", !0);
            });
          });
        }
        onChartRender() {
          this.chart.series.forEach(function(m) {
            (m.options.accessibility && m.options.accessibility.enabled) !== !1 && m.visible && m.getPointsCollection().length !== 0 ? u(m) : y(m);
          });
        }
        getKeyboardNavigation() {
          return this.keyboardNavigation.getKeyboardNavigationHandler();
        }
        destroy() {
          this.newDataAnnouncer.destroy(), this.keyboardNavigation.destroy();
        }
      };
    }), i(n, "Accessibility/Components/ZoomComponent.js", [n["Accessibility/AccessibilityComponent.js"], n["Accessibility/Utils/ChartUtilities.js"], n["Accessibility/Utils/HTMLUtilities.js"], n["Accessibility/KeyboardNavigationHandler.js"], n["Core/Utilities.js"]], function(o, a, r, s, l) {
      let { unhideChartElementFromAT: d } = a, { getFakeMouseEvent: y } = r, { attr: u, pick: m } = l;
      return class extends o {
        constructor() {
          super(...arguments), this.focusedMapNavButtonIx = -1;
        }
        init() {
          let h = this, c = this.chart;
          this.proxyProvider.addGroup("zoom", "div"), ["afterShowResetZoom", "afterApplyDrilldown", "drillupall"].forEach((g) => {
            h.addEvent(c, g, function() {
              h.updateProxyOverlays();
            });
          });
        }
        onChartUpdate() {
          let h = this.chart, c = this;
          h.mapNavigation && h.mapNavigation.navButtons.forEach((g, v) => {
            d(h, g.element), c.setMapNavButtonAttrs(g.element, "accessibility.zoom.mapZoom" + (v ? "Out" : "In"));
          });
        }
        setMapNavButtonAttrs(h, c) {
          let g = this.chart;
          u(h, { tabindex: -1, role: "button", "aria-label": g.langFormat(c, { chart: g }) });
        }
        onChartRender() {
          this.updateProxyOverlays();
        }
        updateProxyOverlays() {
          let h = this.chart;
          if (this.proxyProvider.clearGroup("zoom"), h.resetZoomButton && this.createZoomProxyButton(h.resetZoomButton, "resetZoomProxyButton", h.langFormat("accessibility.zoom.resetZoomButton", { chart: h })), h.drillUpButton && h.breadcrumbs && h.breadcrumbs.list) {
            let c = h.breadcrumbs.list[h.breadcrumbs.list.length - 1];
            this.createZoomProxyButton(h.drillUpButton, "drillUpProxyButton", h.langFormat("accessibility.drillUpButton", { chart: h, buttonText: h.breadcrumbs.getButtonText(c) }));
          }
        }
        createZoomProxyButton(h, c, g) {
          this[c] = this.proxyProvider.addProxyElement("zoom", { click: h }, "button", { "aria-label": g, tabindex: -1 });
        }
        getMapZoomNavigation() {
          let h = this.keyCodes, c = this.chart, g = this;
          return new s(c, { keyCodeMap: [[[h.up, h.down, h.left, h.right], function(v) {
            return g.onMapKbdArrow(this, v);
          }], [[h.tab], function(v, P) {
            return g.onMapKbdTab(this, P);
          }], [[h.space, h.enter], function() {
            return g.onMapKbdClick(this);
          }]], validate: function() {
            return !!(c.mapView && c.mapNavigation && c.mapNavigation.navButtons.length);
          }, init: function(v) {
            return g.onMapNavInit(v);
          } });
        }
        onMapKbdArrow(h, c) {
          let g = this.chart, v = this.keyCodes, P = g.container, f = c === v.up || c === v.down, S = c === v.left || c === v.up ? 1 : -1, w = (f ? g.plotHeight : g.plotWidth) / 10 * S, x = 10 * Math.random(), k = { x: P.offsetLeft + g.plotLeft + g.plotWidth / 2 + x, y: P.offsetTop + g.plotTop + g.plotHeight / 2 + x }, A = f ? { x: k.x, y: k.y + w } : { x: k.x + w, y: k.y };
          return [y("mousedown", k), y("mousemove", A), y("mouseup", A)].forEach(($) => P.dispatchEvent($)), h.response.success;
        }
        onMapKbdTab(h, c) {
          let g = this.chart, v = h.response, P = c.shiftKey, f = P && !this.focusedMapNavButtonIx || !P && this.focusedMapNavButtonIx;
          if (g.mapNavigation.navButtons[this.focusedMapNavButtonIx].setState(0), f)
            return g.mapView && g.mapView.zoomBy(), v[P ? "prev" : "next"];
          this.focusedMapNavButtonIx += P ? -1 : 1;
          let S = g.mapNavigation.navButtons[this.focusedMapNavButtonIx];
          return g.setFocusToElement(S.box, S.element), S.setState(2), v.success;
        }
        onMapKbdClick(h) {
          let c = this.chart.mapNavigation.navButtons[this.focusedMapNavButtonIx].element;
          return this.fakeClickEvent(c), h.response.success;
        }
        onMapNavInit(h) {
          let c = this.chart, g = c.mapNavigation.navButtons[0], v = c.mapNavigation.navButtons[1], P = h > 0 ? g : v;
          c.setFocusToElement(P.box, P.element), P.setState(2), this.focusedMapNavButtonIx = h > 0 ? 0 : 1;
        }
        simpleButtonNavigation(h, c, g) {
          let v = this.keyCodes, P = this, f = this.chart;
          return new s(f, { keyCodeMap: [[[v.tab, v.up, v.down, v.left, v.right], function(S, w) {
            let x = S === v.tab && w.shiftKey || S === v.left || S === v.up;
            return this.response[x ? "prev" : "next"];
          }], [[v.space, v.enter], function() {
            return m(g(this, f), this.response.success);
          }]], validate: function() {
            return f[h] && f[h].box && P[c].innerElement;
          }, init: function() {
            f.setFocusToElement(f[h].box, P[c].innerElement);
          } });
        }
        getKeyboardNavigation() {
          return [this.simpleButtonNavigation("resetZoomButton", "resetZoomProxyButton", function(h, c) {
            c.zoomOut();
          }), this.simpleButtonNavigation("drillUpButton", "drillUpProxyButton", function(h, c) {
            return c.drillUp(), h.response.prev;
          }), this.getMapZoomNavigation()];
        }
      };
    }), i(n, "Accessibility/HighContrastMode.js", [n["Core/Globals.js"]], function(o) {
      let { doc: a, isMS: r, win: s } = o;
      return { isHighContrastModeActive: function() {
        let l = /(Edg)/.test(s.navigator.userAgent);
        if (s.matchMedia && l)
          return s.matchMedia("(-ms-high-contrast: active)").matches;
        if (r && s.getComputedStyle) {
          let d = a.createElement("div");
          d.style.backgroundImage = "url(data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==)", a.body.appendChild(d);
          let y = (d.currentStyle || s.getComputedStyle(d)).backgroundImage;
          return a.body.removeChild(d), y === "none";
        }
        return s.matchMedia && s.matchMedia("(forced-colors: active)").matches;
      }, setHighContrastTheme: function(l) {
        l.highContrastModeActive = !0;
        let d = l.options.accessibility.highContrastTheme;
        l.update(d, !1);
        let y = d.colors?.length > 1;
        l.series.forEach(function(u) {
          let m = d.plotOptions[u.type] || {}, h = y && u.colorIndex !== void 0 ? d.colors[u.colorIndex] : m.color || "window", c = { color: m.color || "windowText", colors: y ? d.colors : [m.color || "windowText"], borderColor: m.borderColor || "window", fillColor: h };
          u.update(c, !1), u.points && u.points.forEach(function(g) {
            g.options && g.options.color && g.update({ color: m.color || "windowText", borderColor: m.borderColor || "window" }, !1);
          });
        }), l.redraw();
      } };
    }), i(n, "Accessibility/HighContrastTheme.js", [], function() {
      return { chart: { backgroundColor: "window" }, title: { style: { color: "windowText" } }, subtitle: { style: { color: "windowText" } }, colorAxis: { minColor: "windowText", maxColor: "windowText", stops: [], dataClasses: [] }, colors: ["windowText"], xAxis: { gridLineColor: "windowText", labels: { style: { color: "windowText" } }, lineColor: "windowText", minorGridLineColor: "windowText", tickColor: "windowText", title: { style: { color: "windowText" } } }, yAxis: { gridLineColor: "windowText", labels: { style: { color: "windowText" } }, lineColor: "windowText", minorGridLineColor: "windowText", tickColor: "windowText", title: { style: { color: "windowText" } } }, tooltip: { backgroundColor: "window", borderColor: "windowText", style: { color: "windowText" } }, plotOptions: { series: { lineColor: "windowText", fillColor: "window", borderColor: "windowText", edgeColor: "windowText", borderWidth: 1, dataLabels: { connectorColor: "windowText", color: "windowText", style: { color: "windowText", textOutline: "none" } }, marker: { lineColor: "windowText", fillColor: "windowText" } }, pie: { color: "window", colors: ["window"], borderColor: "windowText", borderWidth: 1 }, boxplot: { fillColor: "window" }, candlestick: { lineColor: "windowText", fillColor: "window" }, errorbar: { fillColor: "window" } }, legend: { backgroundColor: "window", itemStyle: { color: "windowText" }, itemHoverStyle: { color: "windowText" }, itemHiddenStyle: { color: "#555" }, title: { style: { color: "windowText" } } }, credits: { style: { color: "windowText" } }, drilldown: { activeAxisLabelStyle: { color: "windowText" }, activeDataLabelStyle: { color: "windowText" } }, navigation: { buttonOptions: { symbolStroke: "windowText", theme: { fill: "window" } } }, rangeSelector: { buttonTheme: { fill: "window", stroke: "windowText", style: { color: "windowText" }, states: { hover: { fill: "window", stroke: "windowText", style: { color: "windowText" } }, select: { fill: "#444", stroke: "windowText", style: { color: "windowText" } } } }, inputBoxBorderColor: "windowText", inputStyle: { backgroundColor: "window", color: "windowText" }, labelStyle: { color: "windowText" } }, navigator: { handles: { backgroundColor: "window", borderColor: "windowText" }, outlineColor: "windowText", maskFill: "transparent", series: { color: "windowText", lineColor: "windowText" }, xAxis: { gridLineColor: "windowText" } }, scrollbar: { barBackgroundColor: "#444", barBorderColor: "windowText", buttonArrowColor: "windowText", buttonBackgroundColor: "window", buttonBorderColor: "windowText", rifleColor: "windowText", trackBackgroundColor: "window", trackBorderColor: "windowText" } };
    }), i(n, "Accessibility/Options/A11yDefaults.js", [], function() {
      return { accessibility: { enabled: !0, screenReaderSection: { beforeChartFormat: "<{headingTagName}>{chartTitle}</{headingTagName}><div>{typeDescription}</div><div>{chartSubtitle}</div><div>{chartLongdesc}</div><div>{playAsSoundButton}</div><div>{viewTableButton}</div><div>{xAxisDescription}</div><div>{yAxisDescription}</div><div>{annotationsTitle}{annotationsList}</div>", afterChartFormat: "{endOfChartMarker}", axisRangeDateFormat: "%Y-%m-%d %H:%M:%S" }, series: { descriptionFormat: "{seriesDescription}{authorDescription}{axisDescription}", describeSingleSeries: !1, pointDescriptionEnabledThreshold: 200 }, point: { valueDescriptionFormat: "{xDescription}{separator}{value}.", describeNull: !0 }, landmarkVerbosity: "all", linkedDescription: '*[data-highcharts-chart="{index}"] + .highcharts-description', highContrastMode: "auto", keyboardNavigation: { enabled: !0, focusBorder: { enabled: !0, hideBrowserFocusOutline: !0, style: { color: "#334eff", lineWidth: 2, borderRadius: 3 }, margin: 2 }, order: ["series", "zoom", "rangeSelector", "navigator", "legend", "chartMenu"], wrapAround: !0, seriesNavigation: { skipNullPoints: !0, pointNavigationEnabledThreshold: !1, rememberPointFocus: !1 } }, announceNewData: { enabled: !1, minAnnounceInterval: 5e3, interruptUser: !1 } }, legend: { accessibility: { enabled: !0, keyboardNavigation: { enabled: !0 } } }, exporting: { accessibility: { enabled: !0 } }, navigator: { accessibility: { enabled: !0 } } };
    }), i(n, "Accessibility/Options/LangDefaults.js", [], function() {
      return { accessibility: { defaultChartTitle: "Chart", chartContainerLabel: "{title}. Highcharts interactive chart.", svgContainerLabel: "Interactive chart", drillUpButton: "{buttonText}", credits: "Chart credits: {creditsStr}", thousandsSep: ",", svgContainerTitle: "", graphicContainerLabel: "", screenReaderSection: { beforeRegionLabel: "", afterRegionLabel: "", annotations: { heading: "Chart annotations summary", descriptionSinglePoint: "{annotationText}. Related to {annotationPoint}", descriptionMultiplePoints: "{annotationText}. Related to {annotationPoint}{#each additionalAnnotationPoints}, also related to {this}{/each}", descriptionNoPoints: "{annotationText}" }, endOfChartMarker: "End of interactive chart." }, sonification: { playAsSoundButtonText: "Play as sound, {chartTitle}", playAsSoundClickAnnouncement: "Play" }, legend: { legendLabelNoTitle: "Toggle series visibility, {chartTitle}", legendLabel: "Chart legend: {legendTitle}", legendItem: "Show {itemName}" }, zoom: { mapZoomIn: "Zoom chart", mapZoomOut: "Zoom out chart", resetZoomButton: "Reset zoom" }, rangeSelector: { dropdownLabel: "{rangeTitle}", minInputLabel: "Select start date.", maxInputLabel: "Select end date.", clickButtonAnnouncement: "Viewing {axisRangeDescription}" }, navigator: { handleLabel: "{#eq handleIx 0}Start, percent{else}End, percent{/eq}", groupLabel: "Axis zoom", changeAnnouncement: "{axisRangeDescription}" }, table: { viewAsDataTableButtonText: "View as data table, {chartTitle}", tableSummary: "Table representation of chart." }, announceNewData: { newDataAnnounce: "Updated data for chart {chartTitle}", newSeriesAnnounceSingle: "New data series: {seriesDesc}", newPointAnnounceSingle: "New data point: {pointDesc}", newSeriesAnnounceMultiple: "New data series in chart {chartTitle}: {seriesDesc}", newPointAnnounceMultiple: "New data point in chart {chartTitle}: {pointDesc}" }, seriesTypeDescriptions: { boxplot: "Box plot charts are typically used to display groups of statistical data. Each data point in the chart can have up to 5 values: minimum, lower quartile, median, upper quartile, and maximum.", arearange: "Arearange charts are line charts displaying a range between a lower and higher value for each point.", areasplinerange: "These charts are line charts displaying a range between a lower and higher value for each point.", bubble: "Bubble charts are scatter charts where each data point also has a size value.", columnrange: "Columnrange charts are column charts displaying a range between a lower and higher value for each point.", errorbar: "Errorbar series are used to display the variability of the data.", funnel: "Funnel charts are used to display reduction of data in stages.", pyramid: "Pyramid charts consist of a single pyramid with item heights corresponding to each point value.", waterfall: "A waterfall chart is a column chart where each column contributes towards a total end value." }, chartTypes: { emptyChart: "Empty chart", mapTypeDescription: "Map of {mapTitle} with {numSeries} data series.", unknownMap: "Map of unspecified region with {numSeries} data series.", combinationChart: "Combination chart with {numSeries} data series.", defaultSingle: "Chart with {numPoints} data {#eq numPoints 1}point{else}points{/eq}.", defaultMultiple: "Chart with {numSeries} data series.", splineSingle: "Line chart with {numPoints} data {#eq numPoints 1}point{else}points{/eq}.", splineMultiple: "Line chart with {numSeries} lines.", lineSingle: "Line chart with {numPoints} data {#eq numPoints 1}point{else}points{/eq}.", lineMultiple: "Line chart with {numSeries} lines.", columnSingle: "Bar chart with {numPoints} {#eq numPoints 1}bar{else}bars{/eq}.", columnMultiple: "Bar chart with {numSeries} data series.", barSingle: "Bar chart with {numPoints} {#eq numPoints 1}bar{else}bars{/eq}.", barMultiple: "Bar chart with {numSeries} data series.", pieSingle: "Pie chart with {numPoints} {#eq numPoints 1}slice{else}slices{/eq}.", pieMultiple: "Pie chart with {numSeries} pies.", scatterSingle: "Scatter chart with {numPoints} {#eq numPoints 1}point{else}points{/eq}.", scatterMultiple: "Scatter chart with {numSeries} data series.", boxplotSingle: "Boxplot with {numPoints} {#eq numPoints 1}box{else}boxes{/eq}.", boxplotMultiple: "Boxplot with {numSeries} data series.", bubbleSingle: "Bubble chart with {numPoints} {#eq numPoints 1}bubbles{else}bubble{/eq}.", bubbleMultiple: "Bubble chart with {numSeries} data series." }, axis: { xAxisDescriptionSingular: "The chart has 1 X axis displaying {names[0]}. {ranges[0]}", xAxisDescriptionPlural: "The chart has {numAxes} X axes displaying {#each names}{#unless @first},{/unless}{#if @last} and{/if} {this}{/each}.", yAxisDescriptionSingular: "The chart has 1 Y axis displaying {names[0]}. {ranges[0]}", yAxisDescriptionPlural: "The chart has {numAxes} Y axes displaying {#each names}{#unless @first},{/unless}{#if @last} and{/if} {this}{/each}.", timeRangeDays: "Data range: {range} days.", timeRangeHours: "Data range: {range} hours.", timeRangeMinutes: "Data range: {range} minutes.", timeRangeSeconds: "Data range: {range} seconds.", rangeFromTo: "Data ranges from {rangeFrom} to {rangeTo}.", rangeCategories: "Data range: {numCategories} categories." }, exporting: { chartMenuLabel: "Chart menu", menuButtonLabel: "View chart menu, {chartTitle}" }, series: { summary: { default: "{series.name}, series {seriesNumber} of {chart.series.length} with {series.points.length} data {#eq series.points.length 1}point{else}points{/eq}.", defaultCombination: "{series.name}, series {seriesNumber} of {chart.series.length} with {series.points.length} data {#eq series.points.length 1}point{else}points{/eq}.", line: "{series.name}, line {seriesNumber} of {chart.series.length} with {series.points.length} data {#eq series.points.length 1}point{else}points{/eq}.", lineCombination: "{series.name}, series {seriesNumber} of {chart.series.length}. Line with {series.points.length} data {#eq series.points.length 1}point{else}points{/eq}.", spline: "{series.name}, line {seriesNumber} of {chart.series.length} with {series.points.length} data {#eq series.points.length 1}point{else}points{/eq}.", splineCombination: "{series.name}, series {seriesNumber} of {chart.series.length}. Line with {series.points.length} data {#eq series.points.length 1}point{else}points{/eq}.", column: "{series.name}, bar series {seriesNumber} of {chart.series.length} with {series.points.length} {#eq series.points.length 1}bar{else}bars{/eq}.", columnCombination: "{series.name}, series {seriesNumber} of {chart.series.length}. Bar series with {series.points.length} {#eq series.points.length 1}bar{else}bars{/eq}.", bar: "{series.name}, bar series {seriesNumber} of {chart.series.length} with {series.points.length} {#eq series.points.length 1}bar{else}bars{/eq}.", barCombination: "{series.name}, series {seriesNumber} of {chart.series.length}. Bar series with {series.points.length} {#eq series.points.length 1}bar{else}bars{/eq}.", pie: "{series.name}, pie {seriesNumber} of {chart.series.length} with {series.points.length} {#eq series.points.length 1}slice{else}slices{/eq}.", pieCombination: "{series.name}, series {seriesNumber} of {chart.series.length}. Pie with {series.points.length} {#eq series.points.length 1}slice{else}slices{/eq}.", scatter: "{series.name}, scatter plot {seriesNumber} of {chart.series.length} with {series.points.length} {#eq series.points.length 1}point{else}points{/eq}.", scatterCombination: "{series.name}, series {seriesNumber} of {chart.series.length}, scatter plot with {series.points.length} {#eq series.points.length 1}point{else}points{/eq}.", boxplot: "{series.name}, boxplot {seriesNumber} of {chart.series.length} with {series.points.length} {#eq series.points.length 1}box{else}boxes{/eq}.", boxplotCombination: "{series.name}, series {seriesNumber} of {chart.series.length}. Boxplot with {series.points.length} {#eq series.points.length 1}box{else}boxes{/eq}.", bubble: "{series.name}, bubble series {seriesNumber} of {chart.series.length} with {series.points.length} {#eq series.points.length 1}bubble{else}bubbles{/eq}.", bubbleCombination: "{series.name}, series {seriesNumber} of {chart.series.length}. Bubble series with {series.points.length} {#eq series.points.length 1}bubble{else}bubbles{/eq}.", map: "{series.name}, map {seriesNumber} of {chart.series.length} with {series.points.length} {#eq series.points.length 1}area{else}areas{/eq}.", mapCombination: "{series.name}, series {seriesNumber} of {chart.series.length}. Map with {series.points.length} {#eq series.points.length 1}area{else}areas{/eq}.", mapline: "{series.name}, line {seriesNumber} of {chart.series.length} with {series.points.length} data {#eq series.points.length 1}point{else}points{/eq}.", maplineCombination: "{series.name}, series {seriesNumber} of {chart.series.length}. Line with {series.points.length} data {#eq series.points.length 1}point{else}points{/eq}.", mapbubble: "{series.name}, bubble series {seriesNumber} of {chart.series.length} with {series.points.length} {#eq series.points.length 1}bubble{else}bubbles{/eq}.", mapbubbleCombination: "{series.name}, series {seriesNumber} of {chart.series.length}. Bubble series with {series.points.length} {#eq series.points.length 1}bubble{else}bubbles{/eq}." }, description: "{description}", xAxisDescription: "X axis, {name}", yAxisDescription: "Y axis, {name}", nullPointValue: "No value", pointAnnotationsDescription: "{#each annotations}Annotation: {this}{/each}" } } };
    }), i(n, "Accessibility/Options/DeprecatedOptions.js", [n["Core/Utilities.js"]], function(o) {
      let { error: a, pick: r } = o;
      function s(d, y, u) {
        let m = d, h, c = 0;
        for (; c < y.length - 1; ++c)
          m = m[h = y[c]] = r(m[h], {});
        m[y[y.length - 1]] = u;
      }
      function l(d, y, u, m) {
        function h(v, P) {
          return P.reduce(function(f, S) {
            return f[S];
          }, v);
        }
        let c = h(d.options, y), g = h(d.options, u);
        Object.keys(m).forEach(function(v) {
          let P = c[v];
          P !== void 0 && (s(g, m[v], P), a(32, !1, d, { [y.join(".") + "." + v]: u.join(".") + "." + m[v].join(".") }));
        });
      }
      return function(d) {
        (function(y) {
          let u = y.options.chart, m = y.options.accessibility || {};
          ["description", "typeDescription"].forEach(function(h) {
            u[h] && (m[h] = u[h], a(32, !1, y, { [`chart.${h}`]: `use accessibility.${h}` }));
          });
        })(d), function(y) {
          y.axes.forEach(function(u) {
            let m = u.options;
            m && m.description && (m.accessibility = m.accessibility || {}, m.accessibility.description = m.description, a(32, !1, y, { "axis.description": "use axis.accessibility.description" }));
          });
        }(d), d.series && function(y) {
          let u = { description: ["accessibility", "description"], exposeElementToA11y: ["accessibility", "exposeAsGroupOnly"], pointDescriptionFormatter: ["accessibility", "point", "descriptionFormatter"], skipKeyboardNavigation: ["accessibility", "keyboardNavigation", "enabled"], "accessibility.pointDescriptionFormatter": ["accessibility", "point", "descriptionFormatter"] };
          y.series.forEach(function(m) {
            Object.keys(u).forEach(function(h) {
              let c = m.options[h];
              h === "accessibility.pointDescriptionFormatter" && (c = m.options.accessibility && m.options.accessibility.pointDescriptionFormatter), c !== void 0 && (s(m.options, u[h], h === "skipKeyboardNavigation" ? !c : c), a(32, !1, y, { [`series.${h}`]: "series." + u[h].join(".") }));
            });
          });
        }(d), l(d, ["accessibility"], ["accessibility"], { pointDateFormat: ["point", "dateFormat"], pointDateFormatter: ["point", "dateFormatter"], pointDescriptionFormatter: ["point", "descriptionFormatter"], pointDescriptionThreshold: ["series", "pointDescriptionEnabledThreshold"], pointNavigationThreshold: ["keyboardNavigation", "seriesNavigation", "pointNavigationEnabledThreshold"], pointValueDecimals: ["point", "valueDecimals"], pointValuePrefix: ["point", "valuePrefix"], pointValueSuffix: ["point", "valueSuffix"], screenReaderSectionFormatter: ["screenReaderSection", "beforeChartFormatter"], describeSingleSeries: ["series", "describeSingleSeries"], seriesDescriptionFormatter: ["series", "descriptionFormatter"], onTableAnchorClick: ["screenReaderSection", "onViewDataTableClick"], axisRangeDateFormat: ["screenReaderSection", "axisRangeDateFormat"] }), l(d, ["accessibility", "keyboardNavigation"], ["accessibility", "keyboardNavigation", "seriesNavigation"], { skipNullPoints: ["skipNullPoints"], mode: ["mode"] }), l(d, ["lang", "accessibility"], ["lang", "accessibility"], { legendItem: ["legend", "legendItem"], legendLabel: ["legend", "legendLabel"], mapZoomIn: ["zoom", "mapZoomIn"], mapZoomOut: ["zoom", "mapZoomOut"], resetZoomButton: ["zoom", "resetZoomButton"], screenReaderRegionLabel: ["screenReaderSection", "beforeRegionLabel"], rangeSelectorButton: ["rangeSelector", "buttonText"], rangeSelectorMaxInput: ["rangeSelector", "maxInputLabel"], rangeSelectorMinInput: ["rangeSelector", "minInputLabel"], svgContainerEnd: ["screenReaderSection", "endOfChartMarker"], viewAsDataTable: ["table", "viewAsDataTableButtonText"], tableSummary: ["table", "tableSummary"] });
      };
    }), i(n, "Accessibility/Accessibility.js", [n["Core/Defaults.js"], n["Core/Globals.js"], n["Core/Utilities.js"], n["Accessibility/Utils/HTMLUtilities.js"], n["Accessibility/A11yI18n.js"], n["Accessibility/Components/ContainerComponent.js"], n["Accessibility/FocusBorder.js"], n["Accessibility/Components/InfoRegionsComponent.js"], n["Accessibility/KeyboardNavigation.js"], n["Accessibility/Components/LegendComponent.js"], n["Accessibility/Components/MenuComponent.js"], n["Accessibility/Components/NavigatorComponent.js"], n["Accessibility/Components/SeriesComponent/NewDataAnnouncer.js"], n["Accessibility/ProxyProvider.js"], n["Accessibility/Components/RangeSelectorComponent.js"], n["Accessibility/Components/SeriesComponent/SeriesComponent.js"], n["Accessibility/Components/ZoomComponent.js"], n["Accessibility/HighContrastMode.js"], n["Accessibility/HighContrastTheme.js"], n["Accessibility/Options/A11yDefaults.js"], n["Accessibility/Options/LangDefaults.js"], n["Accessibility/Options/DeprecatedOptions.js"]], function(o, a, r, s, l, d, y, u, m, h, c, g, v, P, f, S, w, x, k, A, $, j) {
      let { defaultOptions: N } = o, { doc: M } = a, { addEvent: D, extend: C, fireEvent: b, merge: p } = r, { removeElement: L } = s;
      class B {
        constructor(O) {
          this.init(O);
        }
        init(O) {
          if (this.chart = O, !M.addEventListener) {
            this.zombie = !0, this.components = {}, O.renderTo.setAttribute("aria-hidden", !0);
            return;
          }
          j(O), this.proxyProvider = new P(this.chart), this.initComponents(), this.keyboardNavigation = new m(O, this.components);
        }
        initComponents() {
          let O = this.chart, I = this.proxyProvider, R = O.options.accessibility;
          this.components = { container: new d(), infoRegions: new u(), legend: new h(), chartMenu: new c(), rangeSelector: new f(), series: new S(), zoom: new w(), navigator: new g() }, R.customComponents && C(this.components, R.customComponents);
          let Y = this.components;
          this.getComponentOrder().forEach(function(F) {
            Y[F].initBase(O, I), Y[F].init();
          });
        }
        getComponentOrder() {
          return this.components ? this.components.series ? ["series"].concat(Object.keys(this.components).filter((O) => O !== "series")) : Object.keys(this.components) : [];
        }
        update() {
          let O = this.components, I = this.chart, R = I.options.accessibility;
          b(I, "beforeA11yUpdate"), I.types = this.getChartTypes();
          let Y = R.keyboardNavigation.order;
          this.proxyProvider.updateGroupOrder(Y), this.getComponentOrder().forEach(function(F) {
            O[F].onChartUpdate(), b(I, "afterA11yComponentUpdate", { name: F, component: O[F] });
          }), this.keyboardNavigation.update(Y), !I.highContrastModeActive && R.highContrastMode !== !1 && (x.isHighContrastModeActive() || R.highContrastMode === !0) && x.setHighContrastTheme(I), b(I, "afterA11yUpdate", { accessibility: this });
        }
        destroy() {
          let O = this.chart || {}, I = this.components;
          Object.keys(I).forEach(function(R) {
            I[R].destroy(), I[R].destroyBase();
          }), this.proxyProvider && this.proxyProvider.destroy(), O.announcerContainer && L(O.announcerContainer), this.keyboardNavigation && this.keyboardNavigation.destroy(), O.renderTo && O.renderTo.setAttribute("aria-hidden", !0), O.focusElement && O.focusElement.removeFocusBorder();
        }
        getChartTypes() {
          let O = {};
          return this.chart.series.forEach(function(I) {
            O[I.type] = 1;
          }), Object.keys(O);
        }
      }
      return function(T) {
        function O() {
          this.accessibility && this.accessibility.destroy();
        }
        function I() {
          this.a11yDirty && this.renderTo && (delete this.a11yDirty, this.updateA11yEnabled());
          let U = this.accessibility;
          U && !U.zombie && (U.proxyProvider.updateProxyElementPositions(), U.getComponentOrder().forEach(function(Q) {
            U.components[Q].onChartRender();
          }));
        }
        function R(U) {
          let Q = U.options.accessibility;
          Q && (Q.customComponents && (this.options.accessibility.customComponents = Q.customComponents, delete Q.customComponents), p(!0, this.options.accessibility, Q), this.accessibility && this.accessibility.destroy && (this.accessibility.destroy(), delete this.accessibility)), this.a11yDirty = !0;
        }
        function Y() {
          let U = this.accessibility, Q = this.options.accessibility, J = this.renderer.boxWrapper.element, ee = this.title;
          if (Q && Q.enabled)
            U && !U.zombie ? U.update() : (this.accessibility = U = new T(this), U && !U.zombie && U.update(), J.getAttribute("role") === "img" && J.removeAttribute("role"));
          else if (U)
            U.destroy && U.destroy(), delete this.accessibility;
          else {
            this.renderTo.setAttribute("role", "img"), this.renderTo.setAttribute("aria-hidden", !1), this.renderTo.setAttribute("aria-label", (ee && ee.element.textContent || "").replace(/</g, "&lt;")), J.setAttribute("aria-hidden", !0);
            let V = document.getElementsByClassName("highcharts-description")[0];
            V && (V.setAttribute("aria-hidden", !1), V.classList.remove("highcharts-linked-description"));
          }
        }
        function F() {
          this.series.chart.accessibility && (this.series.chart.a11yDirty = !0);
        }
        T.i18nFormat = l.i18nFormat, T.compose = function(U, Q, J, ee, V, G) {
          m.compose(U), v.compose(ee), h.compose(U, Q), c.compose(U), S.compose(U, J, ee), l.compose(U), y.compose(U, V), G && f.compose(U, G);
          let W = U.prototype;
          W.updateA11yEnabled || (W.updateA11yEnabled = Y, D(U, "destroy", O), D(U, "render", I), D(U, "update", R), ["addSeries", "init"].forEach((ae) => {
            D(U, ae, function() {
              this.a11yDirty = !0;
            });
          }), ["afterApplyDrilldown", "drillupall"].forEach((ae) => {
            D(U, ae, function() {
              let z = this.accessibility;
              z && !z.zombie && z.update();
            });
          }), D(J, "update", F), ["update", "updatedData", "remove"].forEach((ae) => {
            D(ee, ae, function() {
              this.chart.accessibility && (this.chart.a11yDirty = !0);
            });
          }));
        };
      }(B || (B = {})), p(!0, N, A, { accessibility: { highContrastTheme: k }, lang: $ }), B;
    }), i(n, "masters/modules/accessibility.src.js", [n["Core/Globals.js"], n["Accessibility/Accessibility.js"], n["Accessibility/AccessibilityComponent.js"], n["Accessibility/Utils/ChartUtilities.js"], n["Accessibility/Utils/HTMLUtilities.js"], n["Accessibility/KeyboardNavigationHandler.js"], n["Accessibility/Components/SeriesComponent/SeriesDescriber.js"]], function(o, a, r, s, l, d, y) {
      return o.i18nFormat = a.i18nFormat, o.A11yChartUtilities = s, o.A11yHTMLUtilities = l, o.AccessibilityComponent = r, o.KeyboardNavigationHandler = d, o.SeriesAccessibilityDescriber = y, a.compose(o.Chart, o.Legend, o.Point, o.Series, o.SVGElement, o.RangeSelector), o;
    });
  });
})(Dk);
var K6 = Dk.exports;
const X6 = /* @__PURE__ */ en(K6);
var Rk = { exports: {} };
(function(e) {
  /**
  * Highcharts JS v11.4.8 (2024-08-29)
  *
  * Plugin for displaying a message when there is no data visible in chart.
  *
  * (c) 2010-2024 Highsoft AS
  * Author: Oystein Moseng
  *
  * License: www.highcharts.com/license
  */
  (function(t) {
    e.exports ? (t.default = t, e.exports = t) : t(typeof Highcharts < "u" ? Highcharts : void 0);
  })(function(t) {
    var n = t ? t._modules : {};
    function i(o, a, r, s) {
      o.hasOwnProperty(a) || (o[a] = s.apply(null, r), typeof CustomEvent == "function" && t.win.dispatchEvent(new CustomEvent("HighchartsModuleLoaded", { detail: { path: a, module: o[a] } })));
    }
    i(n, "Extensions/NoDataToDisplay/NoDataDefaults.js", [], function() {
      return { lang: { noData: "No data to display" }, noData: { attr: { zIndex: 1 }, position: { x: 0, y: 0, align: "center", verticalAlign: "middle" }, style: { fontWeight: "bold", fontSize: "0.8em", color: "#666666" } } };
    }), i(n, "Extensions/NoDataToDisplay/NoDataToDisplay.js", [n["Core/Renderer/HTML/AST.js"], n["Extensions/NoDataToDisplay/NoDataDefaults.js"], n["Core/Utilities.js"]], function(o, a, r) {
      let { addEvent: s, extend: l, merge: d } = r;
      function y() {
        let c = this.series || [], g = c.length;
        for (; g--; )
          if (c[g].hasData() && !c[g].options.isInternal)
            return !0;
        return this.loadingShown;
      }
      function u() {
        this.noDataLabel && (this.noDataLabel = this.noDataLabel.destroy());
      }
      function m(c) {
        let g = this.options, v = c || g && g.lang.noData || "", P = g && (g.noData || {});
        this.renderer && (this.noDataLabel || (this.noDataLabel = this.renderer.label(v, 0, 0, void 0, void 0, void 0, P.useHTML, void 0, "no-data").add()), this.styledMode || this.noDataLabel.attr(o.filterUserAttributes(P.attr || {})).css(P.style || {}), this.noDataLabel.align(l(this.noDataLabel.getBBox(), P.position || {}), !1, "plotBox"));
      }
      function h() {
        this.hasData() ? this.hideNoData() : this.showNoData();
      }
      return { compose: function(c, g) {
        let v = c.prototype;
        v.showNoData || (v.hasData = y, v.hideNoData = u, v.showNoData = m, s(c, "render", h), d(!0, g, a));
      } };
    }), i(n, "masters/modules/no-data-to-display.src.js", [n["Core/Globals.js"], n["Extensions/NoDataToDisplay/NoDataToDisplay.js"]], function(o, a) {
      return a.compose(o.Chart, o.defaultOptions), o;
    });
  });
})(Rk);
var Z6 = Rk.exports;
const J6 = /* @__PURE__ */ en(Z6);
var Nk = { exports: {} };
(function(e) {
  /**
  * Highcharts JS v11.4.8 (2024-08-29)
  *
  * (c) 2009-2024 Torstein Honsi
  *
  * License: www.highcharts.com/license
  */
  (function(t) {
    e.exports ? (t.default = t, e.exports = t) : t(typeof Highcharts < "u" ? Highcharts : void 0);
  })(function(t) {
    var n = t ? t._modules : {};
    function i(o, a, r, s) {
      o.hasOwnProperty(a) || (o[a] = s.apply(null, r), typeof CustomEvent == "function" && t.win.dispatchEvent(new CustomEvent("HighchartsModuleLoaded", { detail: { path: a, module: o[a] } })));
    }
    i(n, "Extensions/Pane/PaneComposition.js", [n["Core/Utilities.js"]], function(o) {
      let { addEvent: a, correctFloat: r, defined: s, pick: l } = o;
      function d(c) {
        let g, v = this;
        return c && v.pane.forEach((P) => {
          y(c.chartX - v.plotLeft, c.chartY - v.plotTop, P.center) && (g = P);
        }), g;
      }
      function y(c, g, v, P, f) {
        let S = !0, w = v[0], x = v[1], k = Math.sqrt(Math.pow(c - w, 2) + Math.pow(g - x, 2));
        if (s(P) && s(f)) {
          let A = Math.atan2(r(g - x, 8), r(c - w, 8));
          f !== P && (S = P > f ? A >= P && A <= Math.PI || A <= f && A >= -Math.PI : A >= P && A <= r(f, 8));
        }
        return k <= Math.ceil(v[2] / 2) && S;
      }
      function u(c) {
        this.polar && (c.options.inverted && ([c.x, c.y] = [c.y, c.x]), c.isInsidePlot = this.pane.some((g) => y(c.x, c.y, g.center, g.axis && g.axis.normalizedStartAngleRad, g.axis && g.axis.normalizedEndAngleRad)));
      }
      function m(c) {
        let g = this.chart;
        c.hoverPoint && c.hoverPoint.plotX && c.hoverPoint.plotY && g.hoverPane && !y(c.hoverPoint.plotX, c.hoverPoint.plotY, g.hoverPane.center) && (c.hoverPoint = void 0);
      }
      function h(c) {
        let g = this.chart;
        g.polar ? (g.hoverPane = g.getHoverPane(c), c.filter = function(v) {
          return v.visible && !(!c.shared && v.directTouch) && l(v.options.enableMouseTracking, !0) && (!g.hoverPane || v.xAxis.pane === g.hoverPane);
        }) : g.hoverPane = void 0;
      }
      return { compose: function(c, g) {
        let v = c.prototype;
        v.getHoverPane || (v.collectionsWithUpdate.push("pane"), v.getHoverPane = d, a(c, "afterIsInsidePlot", u), a(g, "afterGetHoverData", m), a(g, "beforeGetHoverData", h));
      } };
    }), i(n, "Extensions/Pane/PaneDefaults.js", [], function() {
      return { pane: { center: ["50%", "50%"], size: "85%", innerSize: "0%", startAngle: 0 }, background: { shape: "circle", borderRadius: 0, borderWidth: 1, borderColor: "#cccccc", backgroundColor: { linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 }, stops: [[0, "#ffffff"], [1, "#e6e6e6"]] }, from: -Number.MAX_VALUE, innerRadius: 0, to: Number.MAX_VALUE, outerRadius: "105%" } };
    }), i(n, "Extensions/Pane/Pane.js", [n["Series/CenteredUtilities.js"], n["Extensions/Pane/PaneComposition.js"], n["Extensions/Pane/PaneDefaults.js"], n["Core/Utilities.js"]], function(o, a, r, s) {
      let { extend: l, merge: d, splat: y } = s;
      class u {
        constructor(h, c) {
          this.coll = "pane", this.init(h, c);
        }
        init(h, c) {
          this.chart = c, this.background = [], c.pane.push(this), this.setOptions(h);
        }
        setOptions(h) {
          this.options = h = d(r.pane, this.chart.angular ? { background: {} } : void 0, h);
        }
        render() {
          let h = this.options, c = this.chart.renderer;
          this.group || (this.group = c.g("pane-group").attr({ zIndex: h.zIndex || 0 }).add()), this.updateCenter();
          let g = this.options.background;
          if (g) {
            let v = Math.max((g = y(g)).length, this.background.length || 0);
            for (let P = 0; P < v; P++)
              g[P] && this.axis ? this.renderBackground(d(r.background, g[P]), P) : this.background[P] && (this.background[P] = this.background[P].destroy(), this.background.splice(P, 1));
          }
        }
        renderBackground(h, c) {
          let g = { class: "highcharts-pane " + (h.className || "") }, v = "animate";
          this.chart.styledMode || l(g, { fill: h.backgroundColor, stroke: h.borderColor, "stroke-width": h.borderWidth }), this.background[c] || (this.background[c] = this.chart.renderer.path().add(this.group), v = "attr"), this.background[c][v]({ d: this.axis.getPlotBandPath(h.from, h.to, h) }).attr(g);
        }
        updateCenter(h) {
          this.center = (h || this.axis || {}).center = o.getCenter.call(this);
        }
        update(h, c) {
          d(!0, this.options, h), this.setOptions(this.options), this.render(), this.chart.axes.forEach(function(g) {
            g.pane === this && (g.pane = null, g.update({}, c));
          }, this);
        }
      }
      return u.compose = a.compose, u;
    }), i(n, "Series/AreaRange/AreaRangePoint.js", [n["Core/Series/SeriesRegistry.js"], n["Core/Utilities.js"]], function(o, a) {
      let { area: { prototype: { pointClass: r, pointClass: { prototype: s } } } } = o.seriesTypes, { defined: l, isNumber: d } = a;
      return class extends r {
        setState() {
          let y = this.state, u = this.series, m = u.chart.polar;
          l(this.plotHigh) || (this.plotHigh = u.yAxis.toPixels(this.high, !0)), l(this.plotLow) || (this.plotLow = this.plotY = u.yAxis.toPixels(this.low, !0)), u.lowerStateMarkerGraphic = u.stateMarkerGraphic, u.stateMarkerGraphic = u.upperStateMarkerGraphic, this.graphic = this.graphics && this.graphics[1], this.plotY = this.plotHigh, m && d(this.plotHighX) && (this.plotX = this.plotHighX), s.setState.apply(this, arguments), this.state = y, this.plotY = this.plotLow, this.graphic = this.graphics && this.graphics[0], m && d(this.plotLowX) && (this.plotX = this.plotLowX), u.upperStateMarkerGraphic = u.stateMarkerGraphic, u.stateMarkerGraphic = u.lowerStateMarkerGraphic, u.lowerStateMarkerGraphic = void 0;
          let h = u.modifyMarkerSettings();
          s.setState.apply(this, arguments), u.restoreMarkerSettings(h);
        }
        haloPath() {
          let y = this.series.chart.polar, u = [];
          return this.plotY = this.plotLow, y && d(this.plotLowX) && (this.plotX = this.plotLowX), this.isInside && (u = s.haloPath.apply(this, arguments)), this.plotY = this.plotHigh, y && d(this.plotHighX) && (this.plotX = this.plotHighX), this.isTopInside && (u = u.concat(s.haloPath.apply(this, arguments))), u;
        }
        isValid() {
          return d(this.low) && d(this.high);
        }
      };
    }), i(n, "Series/AreaRange/AreaRangeSeries.js", [n["Series/AreaRange/AreaRangePoint.js"], n["Core/Globals.js"], n["Core/Series/SeriesRegistry.js"], n["Core/Utilities.js"]], function(o, a, r, s) {
      let { noop: l } = a, { area: d, area: { prototype: y }, column: { prototype: u } } = r.seriesTypes, { addEvent: m, defined: h, extend: c, isArray: g, isNumber: v, pick: P, merge: f } = s;
      class S extends d {
        toYData(x) {
          return [x.low, x.high];
        }
        highToXY(x) {
          let k = this.chart, A = this.xAxis.postTranslate(x.rectPlotX || 0, this.yAxis.len - (x.plotHigh || 0));
          x.plotHighX = A.x - k.plotLeft, x.plotHigh = A.y - k.plotTop, x.plotLowX = x.plotX;
        }
        getGraphPath(x) {
          let k = [], A = [], $ = y.getGraphPath, j = this.options, N = this.chart.polar, M = N && j.connectEnds !== !1, D = j.connectNulls, C, b, p, L = j.step;
          for (C = (x = x || this.points).length; C--; ) {
            b = x[C];
            let R = N ? { plotX: b.rectPlotX, plotY: b.yBottom, doCurve: !1 } : { plotX: b.plotX, plotY: b.plotY, doCurve: !1 };
            b.isNull || M || D || x[C + 1] && !x[C + 1].isNull || A.push(R), p = { polarPlotY: b.polarPlotY, rectPlotX: b.rectPlotX, yBottom: b.yBottom, plotX: P(b.plotHighX, b.plotX), plotY: b.plotHigh, isNull: b.isNull }, A.push(p), k.push(p), b.isNull || M || D || x[C - 1] && !x[C - 1].isNull || A.push(R);
          }
          let B = $.call(this, x);
          L && (L === !0 && (L = "left"), j.step = { left: "right", center: "center", right: "left" }[L]);
          let T = $.call(this, k), O = $.call(this, A);
          j.step = L;
          let I = [].concat(B, T);
          return !this.chart.polar && O[0] && O[0][0] === "M" && (O[0] = ["L", O[0][1], O[0][2]]), this.graphPath = I, this.areaPath = B.concat(O), I.isArea = !0, I.xMap = B.xMap, this.areaPath.xMap = B.xMap, I;
        }
        drawDataLabels() {
          let x, k, A, $, j, N = this.points, M = N.length, D = [], C = this.options.dataLabels, b = this.chart.inverted;
          if (C) {
            if (g(C) ? ($ = C[0] || { enabled: !1 }, j = C[1] || { enabled: !1 }) : (($ = c({}, C)).x = C.xHigh, $.y = C.yHigh, (j = c({}, C)).x = C.xLow, j.y = C.yLow), $.enabled || this.hasDataLabels?.()) {
              for (x = M; x--; )
                if (k = N[x]) {
                  let { plotHigh: p = 0, plotLow: L = 0 } = k;
                  A = $.inside ? p < L : p > L, k.y = k.high, k._plotY = k.plotY, k.plotY = p, D[x] = k.dataLabel, k.dataLabel = k.dataLabelUpper, k.below = A, b ? $.align || ($.align = A ? "right" : "left") : $.verticalAlign || ($.verticalAlign = A ? "top" : "bottom");
                }
              for (this.options.dataLabels = $, y.drawDataLabels && y.drawDataLabels.apply(this, arguments), x = M; x--; )
                (k = N[x]) && (k.dataLabelUpper = k.dataLabel, k.dataLabel = D[x], delete k.dataLabels, k.y = k.low, k.plotY = k._plotY);
            }
            if (j.enabled || this.hasDataLabels?.()) {
              for (x = M; x--; )
                if (k = N[x]) {
                  let { plotHigh: p = 0, plotLow: L = 0 } = k;
                  A = j.inside ? p < L : p > L, k.below = !A, b ? j.align || (j.align = A ? "left" : "right") : j.verticalAlign || (j.verticalAlign = A ? "bottom" : "top");
                }
              this.options.dataLabels = j, y.drawDataLabels && y.drawDataLabels.apply(this, arguments);
            }
            if ($.enabled)
              for (x = M; x--; )
                (k = N[x]) && (k.dataLabels = [k.dataLabelUpper, k.dataLabel].filter(function(p) {
                  return !!p;
                }));
            this.options.dataLabels = C;
          }
        }
        alignDataLabel() {
          u.alignDataLabel.apply(this, arguments);
        }
        modifyMarkerSettings() {
          let x = { marker: this.options.marker, symbol: this.symbol };
          if (this.options.lowMarker) {
            let { options: { marker: k, lowMarker: A } } = this;
            this.options.marker = f(k, A), A.symbol && (this.symbol = A.symbol);
          }
          return x;
        }
        restoreMarkerSettings(x) {
          this.options.marker = x.marker, this.symbol = x.symbol;
        }
        drawPoints() {
          let x, k, A = this.points.length, $ = this.modifyMarkerSettings();
          for (y.drawPoints.apply(this, arguments), this.restoreMarkerSettings($), x = 0; x < A; )
            (k = this.points[x]).graphics = k.graphics || [], k.origProps = { plotY: k.plotY, plotX: k.plotX, isInside: k.isInside, negative: k.negative, zone: k.zone, y: k.y }, (k.graphic || k.graphics[0]) && (k.graphics[0] = k.graphic), k.graphic = k.graphics[1], k.plotY = k.plotHigh, h(k.plotHighX) && (k.plotX = k.plotHighX), k.y = P(k.high, k.origProps.y), k.negative = k.y < (this.options.threshold || 0), this.zones.length && (k.zone = k.getZone()), this.chart.polar || (k.isInside = k.isTopInside = k.plotY !== void 0 && k.plotY >= 0 && k.plotY <= this.yAxis.len && k.plotX >= 0 && k.plotX <= this.xAxis.len), x++;
          for (y.drawPoints.apply(this, arguments), x = 0; x < A; )
            (k = this.points[x]).graphics = k.graphics || [], (k.graphic || k.graphics[1]) && (k.graphics[1] = k.graphic), k.graphic = k.graphics[0], k.origProps && (c(k, k.origProps), delete k.origProps), x++;
        }
        hasMarkerChanged(x, k) {
          let A = x.lowMarker, $ = k.lowMarker || {};
          return A && (A.enabled === !1 || $.symbol !== A.symbol || $.height !== A.height || $.width !== A.width) || super.hasMarkerChanged(x, k);
        }
      }
      return S.defaultOptions = f(d.defaultOptions, { lineWidth: 1, threshold: null, tooltip: { pointFormat: '<span style="color:{series.color}">●</span> {series.name}: <b>{point.low}</b> - <b>{point.high}</b><br/>' }, trackByArea: !0, dataLabels: { align: void 0, verticalAlign: void 0, xLow: 0, xHigh: 0, yLow: 0, yHigh: 0 } }), m(S, "afterTranslate", function() {
        this.pointArrayMap.join(",") === "low,high" && this.points.forEach((w) => {
          let x = w.high, k = w.plotY;
          w.isNull ? w.plotY = void 0 : (w.plotLow = k, w.plotHigh = v(x) ? this.yAxis.translate(this.dataModify ? this.dataModify.modifyValue(x) : x, !1, !0, void 0, !0) : void 0, this.dataModify && (w.yBottom = w.plotHigh));
        });
      }, { order: 0 }), m(S, "afterTranslate", function() {
        this.points.forEach((w) => {
          if (this.chart.polar)
            this.highToXY(w), w.plotLow = w.plotY, w.tooltipPos = [((w.plotHighX || 0) + (w.plotLowX || 0)) / 2, ((w.plotHigh || 0) + (w.plotLow || 0)) / 2];
          else {
            let x = w.pos(!1, w.plotLow), k = w.pos(!1, w.plotHigh);
            x && k && (x[0] = (x[0] + k[0]) / 2, x[1] = (x[1] + k[1]) / 2), w.tooltipPos = x;
          }
        });
      }, { order: 3 }), c(S.prototype, { deferTranslatePolar: !0, pointArrayMap: ["low", "high"], pointClass: o, pointValKey: "low", setStackedPoints: l }), r.registerSeriesType("arearange", S), S;
    }), i(n, "Series/AreaSplineRange/AreaSplineRangeSeries.js", [n["Series/AreaRange/AreaRangeSeries.js"], n["Core/Series/SeriesRegistry.js"], n["Core/Utilities.js"]], function(o, a, r) {
      let { spline: { prototype: s } } = a.seriesTypes, { merge: l, extend: d } = r;
      class y extends o {
      }
      return y.defaultOptions = l(o.defaultOptions), d(y.prototype, { getPointSpline: s.getPointSpline }), a.registerSeriesType("areasplinerange", y), y;
    }), i(n, "Series/BoxPlot/BoxPlotSeriesDefaults.js", [], function() {
      return { threshold: null, tooltip: { pointFormat: '<span style="color:{point.color}">●</span> <b>{series.name}</b><br/>Maximum: {point.high}<br/>Upper quartile: {point.q3}<br/>Median: {point.median}<br/>Lower quartile: {point.q1}<br/>Minimum: {point.low}<br/>' }, whiskerLength: "50%", fillColor: "#ffffff", lineWidth: 1, medianWidth: 2, whiskerWidth: 2 };
    }), i(n, "Series/BoxPlot/BoxPlotSeries.js", [n["Series/BoxPlot/BoxPlotSeriesDefaults.js"], n["Series/Column/ColumnSeries.js"], n["Core/Globals.js"], n["Core/Series/SeriesRegistry.js"], n["Core/Utilities.js"]], function(o, a, r, s, l) {
      let { noop: d } = r, { crisp: y, extend: u, merge: m, pick: h } = l;
      class c extends a {
        pointAttribs() {
          return {};
        }
        translate() {
          let v = this.yAxis, P = this.pointArrayMap;
          super.translate.apply(this), this.points.forEach(function(f) {
            P.forEach(function(S) {
              f[S] !== null && (f[S + "Plot"] = v.translate(f[S], 0, 1, 0, 1));
            }), f.plotHigh = f.highPlot;
          });
        }
        drawPoints() {
          let v, P, f, S, w, x, k, A, $, j, N, M, D, C = this.points, b = this.options, p = this.chart, L = p.renderer, B = this.doQuartiles !== !1, T = this.options.whiskerLength;
          for (let O of C) {
            let I = (A = O.graphic) ? "animate" : "attr", R = O.shapeArgs, Y = {}, F = {}, U = {}, Q = {}, J = O.color || this.color;
            if (O.plotY !== void 0) {
              let ee;
              $ = R.width, N = (j = R.x) + $, M = $ / 2, v = B ? O.q1Plot : O.lowPlot, P = B ? O.q3Plot : O.lowPlot, f = O.highPlot, S = O.lowPlot, A || (O.graphic = A = L.g("point").add(this.group), O.stem = L.path().addClass("highcharts-boxplot-stem").add(A), T && (O.whiskers = L.path().addClass("highcharts-boxplot-whisker").add(A)), B && (O.box = L.path(k).addClass("highcharts-boxplot-box").add(A)), O.medianShape = L.path(x).addClass("highcharts-boxplot-median").add(A)), p.styledMode || (F.stroke = O.stemColor || b.stemColor || J, F["stroke-width"] = h(O.stemWidth, b.stemWidth, b.lineWidth), F.dashstyle = O.stemDashStyle || b.stemDashStyle || b.dashStyle, O.stem.attr(F), T && (U.stroke = O.whiskerColor || b.whiskerColor || J, U["stroke-width"] = h(O.whiskerWidth, b.whiskerWidth, b.lineWidth), U.dashstyle = O.whiskerDashStyle || b.whiskerDashStyle || b.dashStyle, O.whiskers.attr(U)), B && (Y.fill = O.fillColor || b.fillColor || J, Y.stroke = b.lineColor || J, Y["stroke-width"] = b.lineWidth || 0, Y.dashstyle = O.boxDashStyle || b.boxDashStyle || b.dashStyle, O.box.attr(Y)), Q.stroke = O.medianColor || b.medianColor || J, Q["stroke-width"] = h(O.medianWidth, b.medianWidth, b.lineWidth), Q.dashstyle = O.medianDashStyle || b.medianDashStyle || b.dashStyle, O.medianShape.attr(Q));
              let V = y((O.plotX || 0) + (this.pointXOffset || 0) + (this.barW || 0) / 2, O.stem.strokeWidth());
              if (ee = [["M", V, P], ["L", V, f], ["M", V, v], ["L", V, S]], O.stem[I]({ d: ee }), B) {
                let G = O.box.strokeWidth();
                v = y(v, G), P = y(P, G), ee = [["M", j = y(j, G), P], ["L", j, v], ["L", N = y(N, G), v], ["L", N, P], ["L", j, P], ["Z"]], O.box[I]({ d: ee });
              }
              if (T) {
                let G = O.whiskers.strokeWidth();
                f = y(O.highPlot, G), S = y(O.lowPlot, G), ee = [["M", y(V - (D = typeof T == "string" && /%$/.test(T) ? M * parseFloat(T) / 100 : Number(T) / 2)), f], ["L", y(V + D), f], ["M", y(V - D), S], ["L", y(V + D), S]], O.whiskers[I]({ d: ee });
              }
              ee = [["M", j, w = y(O.medianPlot, O.medianShape.strokeWidth())], ["L", N, w]], O.medianShape[I]({ d: ee });
            }
          }
        }
        toYData(v) {
          return [v.low, v.q1, v.median, v.q3, v.high];
        }
      }
      return c.defaultOptions = m(a.defaultOptions, o), u(c.prototype, { pointArrayMap: ["low", "q1", "median", "q3", "high"], pointValKey: "high", drawDataLabels: d, setStackedPoints: d }), s.registerSeriesType("boxplot", c), c;
    }), i(n, "Series/Bubble/BubbleLegendDefaults.js", [], function() {
      return { borderColor: void 0, borderWidth: 2, className: void 0, color: void 0, connectorClassName: void 0, connectorColor: void 0, connectorDistance: 60, connectorWidth: 1, enabled: !1, labels: { className: void 0, allowOverlap: !1, format: "", formatter: void 0, align: "right", style: { fontSize: "0.9em", color: "#000000" }, x: 0, y: 0 }, maxSize: 60, minSize: 10, legendIndex: 0, ranges: { value: void 0, borderColor: void 0, color: void 0, connectorColor: void 0 }, sizeBy: "area", sizeByAbsoluteValue: !1, zIndex: 1, zThreshold: 0 };
    }), i(n, "Series/Bubble/BubbleLegendItem.js", [n["Core/Color/Color.js"], n["Core/Templating.js"], n["Core/Globals.js"], n["Core/Utilities.js"]], function(o, a, r, s) {
      let { parse: l } = o, { noop: d } = r, { arrayMax: y, arrayMin: u, isNumber: m, merge: h, pick: c, stableSort: g } = s;
      return class {
        constructor(v, P) {
          this.setState = d, this.init(v, P);
        }
        init(v, P) {
          this.options = v, this.visible = !0, this.chart = P.chart, this.legend = P;
        }
        addToLegend(v) {
          v.splice(this.options.legendIndex, 0, this);
        }
        drawLegendSymbol(v) {
          let P, f = c(v.options.itemDistance, 20), S = this.legendItem || {}, w = this.options, x = w.ranges, k = w.connectorDistance;
          if (!x || !x.length || !m(x[0].value)) {
            v.options.bubbleLegend.autoRanges = !0;
            return;
          }
          g(x, function(N, M) {
            return M.value - N.value;
          }), this.ranges = x, this.setOptions(), this.render();
          let A = this.getMaxLabelSize(), $ = this.ranges[0].radius, j = 2 * $;
          P = (P = k - $ + A.width) > 0 ? P : 0, this.maxLabel = A, this.movementX = w.labels.align === "left" ? P : 0, S.labelWidth = j + P + f, S.labelHeight = j + A.height / 2;
        }
        setOptions() {
          let v = this.ranges, P = this.options, f = this.chart.series[P.seriesIndex], S = this.legend.baseline, w = { zIndex: P.zIndex, "stroke-width": P.borderWidth }, x = { zIndex: P.zIndex, "stroke-width": P.connectorWidth }, k = { align: this.legend.options.rtl || P.labels.align === "left" ? "right" : "left", zIndex: P.zIndex }, A = f.options.marker.fillOpacity, $ = this.chart.styledMode;
          v.forEach(function(j, N) {
            $ || (w.stroke = c(j.borderColor, P.borderColor, f.color), w.fill = c(j.color, P.color, A !== 1 ? l(f.color).setOpacity(A).get("rgba") : f.color), x.stroke = c(j.connectorColor, P.connectorColor, f.color)), v[N].radius = this.getRangeRadius(j.value), v[N] = h(v[N], { center: v[0].radius - v[N].radius + S }), $ || h(!0, v[N], { bubbleAttribs: h(w), connectorAttribs: h(x), labelAttribs: k });
          }, this);
        }
        getRangeRadius(v) {
          let P = this.options, f = this.options.seriesIndex, S = this.chart.series[f], w = P.ranges[0].value, x = P.ranges[P.ranges.length - 1].value, k = P.minSize, A = P.maxSize;
          return S.getRadius.call(this, x, w, k, A, v);
        }
        render() {
          let v = this.legendItem || {}, P = this.chart.renderer, f = this.options.zThreshold;
          for (let S of (this.symbols || (this.symbols = { connectors: [], bubbleItems: [], labels: [] }), v.symbol = P.g("bubble-legend"), v.label = P.g("bubble-legend-item").css(this.legend.itemStyle || {}), v.symbol.translateX = 0, v.symbol.translateY = 0, v.symbol.add(v.label), v.label.add(v.group), this.ranges))
            S.value >= f && this.renderRange(S);
          this.hideOverlappingLabels();
        }
        renderRange(v) {
          let P = this.ranges[0], f = this.legend, S = this.options, w = S.labels, x = this.chart, k = x.series[S.seriesIndex], A = x.renderer, $ = this.symbols, j = $.labels, N = v.center, M = Math.abs(v.radius), D = S.connectorDistance || 0, C = w.align, b = f.options.rtl, p = S.borderWidth, L = S.connectorWidth, B = P.radius || 0, T = N - M - p / 2 + L / 2, O = (T % 1 ? 1 : 0.5) - (L % 2 ? 0 : 0.5), I = A.styledMode, R = b || C === "left" ? -D : D;
          C === "center" && (R = 0, S.connectorDistance = 0, v.labelAttribs.align = "center"), $.bubbleItems.push(A.circle(B, N + O, M).attr(I ? {} : v.bubbleAttribs).addClass((I ? "highcharts-color-" + k.colorIndex + " " : "") + "highcharts-bubble-legend-symbol " + (S.className || "")).add(this.legendItem.symbol)), $.connectors.push(A.path(A.crispLine([["M", B, T], ["L", B + R, T]], S.connectorWidth)).attr(I ? {} : v.connectorAttribs).addClass((I ? "highcharts-color-" + this.options.seriesIndex + " " : "") + "highcharts-bubble-legend-connectors " + (S.connectorClassName || "")).add(this.legendItem.symbol));
          let Y = A.text(this.formatLabel(v)).attr(I ? {} : v.labelAttribs).css(I ? {} : w.style).addClass("highcharts-bubble-legend-labels " + (S.labels.className || "")).add(this.legendItem.symbol), F = { x: B + R + S.labels.x, y: T + S.labels.y + 0.4 * Y.getBBox().height };
          Y.attr(F), j.push(Y), Y.placed = !0, Y.alignAttr = F;
        }
        getMaxLabelSize() {
          let v, P;
          return this.symbols.labels.forEach(function(f) {
            P = f.getBBox(!0), v = v ? P.width > v.width ? P : v : P;
          }), v || {};
        }
        formatLabel(v) {
          let P = this.options, f = P.labels.formatter, S = P.labels.format, { numberFormatter: w } = this.chart;
          return S ? a.format(S, v) : f ? f.call(v) : w(v.value, 1);
        }
        hideOverlappingLabels() {
          let v = this.chart, P = this.options.labels.allowOverlap, f = this.symbols;
          !P && f && (v.hideOverlappingLabels(f.labels), f.labels.forEach(function(S, w) {
            S.newOpacity ? S.newOpacity !== S.oldOpacity && f.connectors[w].show() : f.connectors[w].hide();
          }));
        }
        getRanges() {
          let v = this.legend.bubbleLegend, P = v.chart.series, f = v.options.ranges, S, w, x = Number.MAX_VALUE, k = -Number.MAX_VALUE;
          return P.forEach(function(A) {
            A.isBubble && !A.ignoreSeries && (w = A.zData.filter(m)).length && (x = c(A.options.zMin, Math.min(x, Math.max(u(w), A.options.displayNegative === !1 ? A.options.zThreshold : -Number.MAX_VALUE))), k = c(A.options.zMax, Math.max(k, y(w))));
          }), S = x === k ? [{ value: k }] : [{ value: x }, { value: (x + k) / 2 }, { value: k, autoRanges: !0 }], f.length && f[0].radius && S.reverse(), S.forEach(function(A, $) {
            f && f[$] && (S[$] = h(f[$], A));
          }), S;
        }
        predictBubbleSizes() {
          let v = this.chart, P = v.legend.options, f = P.floating, S = P.layout === "horizontal", w = S ? v.legend.lastLineHeight : 0, x = v.plotSizeX, k = v.plotSizeY, A = v.series[this.options.seriesIndex], $ = A.getPxExtremes(), j = Math.ceil($.minPxSize), N = Math.ceil($.maxPxSize), M = Math.min(k, x), D, C = A.options.maxSize;
          return f || !/%$/.test(C) ? D = N : (D = (M + w) * (C = parseFloat(C)) / 100 / (C / 100 + 1), (S && k - D >= x || !S && x - D >= k) && (D = N)), [j, Math.ceil(D)];
        }
        updateRanges(v, P) {
          let f = this.legend.options.bubbleLegend;
          f.minSize = v, f.maxSize = P, f.ranges = this.getRanges();
        }
        correctSizes() {
          let v = this.legend, P = this.chart.series[this.options.seriesIndex].getPxExtremes();
          Math.abs(Math.ceil(P.maxPxSize) - this.options.maxSize) > 1 && (this.updateRanges(this.options.minSize, P.maxPxSize), v.render());
        }
      };
    }), i(n, "Series/Bubble/BubbleLegendComposition.js", [n["Series/Bubble/BubbleLegendDefaults.js"], n["Series/Bubble/BubbleLegendItem.js"], n["Core/Defaults.js"], n["Core/Globals.js"], n["Core/Utilities.js"]], function(o, a, r, s, l) {
      let { setOptions: d } = r, { composed: y } = s, { addEvent: u, objectEach: m, pushUnique: h, wrap: c } = l;
      function g(x, k, A) {
        let $, j, N, M = this.legend, D = v(this) >= 0;
        M && M.options.enabled && M.bubbleLegend && M.options.bubbleLegend.autoRanges && D ? ($ = M.bubbleLegend.options, j = M.bubbleLegend.predictBubbleSizes(), M.bubbleLegend.updateRanges(j[0], j[1]), $.placed || (M.group.placed = !1, M.allItems.forEach((C) => {
          (N = C.legendItem || {}).group && (N.group.translateY = void 0);
        })), M.render(), $.placed || (this.getMargins(), this.axes.forEach(function(C) {
          C.visible && C.render(), $.placed || (C.setScale(), C.updateNames(), m(C.ticks, function(b) {
            b.isNew = !0, b.isNewLabel = !0;
          }));
        }), this.getMargins()), $.placed = !0, x.call(this, k, A), M.bubbleLegend.correctSizes(), w(M, P(M))) : (x.call(this, k, A), M && M.options.enabled && M.bubbleLegend && (M.render(), w(M, P(M))));
      }
      function v(x) {
        let k = x.series, A = 0;
        for (; A < k.length; ) {
          if (k[A] && k[A].isBubble && k[A].visible && k[A].zData.length)
            return A;
          A++;
        }
        return -1;
      }
      function P(x) {
        let k = x.allItems, A = [], $ = k.length, j, N, M, D = 0, C = 0;
        for (D = 0; D < $; D++)
          if (N = k[D].legendItem || {}, M = (k[D + 1] || {}).legendItem || {}, N.labelHeight && (k[D].itemHeight = N.labelHeight), k[D] === k[$ - 1] || N.y !== M.y) {
            for (A.push({ height: 0 }), j = A[A.length - 1]; C <= D; C++)
              k[C].itemHeight > j.height && (j.height = k[C].itemHeight);
            j.step = D;
          }
        return A;
      }
      function f(x) {
        let k = this.bubbleLegend, A = this.options, $ = A.bubbleLegend, j = v(this.chart);
        k && k.ranges && k.ranges.length && ($.ranges.length && ($.autoRanges = !!$.ranges[0].autoRanges), this.destroyItem(k)), j >= 0 && A.enabled && $.enabled && ($.seriesIndex = j, this.bubbleLegend = new a($, this), this.bubbleLegend.addToLegend(x.allItems));
      }
      function S(x) {
        let k;
        if (x.defaultPrevented)
          return !1;
        let A = x.legendItem, $ = this.chart, j = A.visible;
        this && this.bubbleLegend && (A.visible = !j, A.ignoreSeries = j, k = v($) >= 0, this.bubbleLegend.visible !== k && (this.update({ bubbleLegend: { enabled: k } }), this.bubbleLegend.visible = k), A.visible = j);
      }
      function w(x, k) {
        let A = x.allItems, $ = x.options.rtl, j, N, M, D, C = 0;
        A.forEach((b, p) => {
          (D = b.legendItem || {}).group && (j = D.group.translateX || 0, N = D.y || 0, ((M = b.movementX) || $ && b.ranges) && (M = $ ? j - b.options.maxSize / 2 : j + M, D.group.attr({ translateX: M })), p > k[C].step && C++, D.group.attr({ translateY: Math.round(N + k[C].height / 2) }), D.y = N + k[C].height / 2);
        });
      }
      return { compose: function(x, k) {
        h(y, "Series.BubbleLegend") && (d({ legend: { bubbleLegend: o } }), c(x.prototype, "drawChartBox", g), u(k, "afterGetAllItems", f), u(k, "itemClick", S));
      } };
    }), i(n, "Series/Bubble/BubblePoint.js", [n["Core/Series/Point.js"], n["Core/Series/SeriesRegistry.js"], n["Core/Utilities.js"]], function(o, a, r) {
      let { seriesTypes: { scatter: { prototype: { pointClass: s } } } } = a, { extend: l } = r;
      class d extends s {
        haloPath(u) {
          let m = (u && this.marker && this.marker.radius || 0) + u;
          if (this.series.chart.inverted) {
            let h = this.pos() || [0, 0], { xAxis: c, yAxis: g, chart: v } = this.series;
            return v.renderer.symbols.circle(c.len - h[1] - m, g.len - h[0] - m, 2 * m, 2 * m);
          }
          return o.prototype.haloPath.call(this, m);
        }
      }
      return l(d.prototype, { ttBelow: !1 }), d;
    }), i(n, "Series/Bubble/BubbleSeries.js", [n["Series/Bubble/BubbleLegendComposition.js"], n["Series/Bubble/BubblePoint.js"], n["Core/Color/Color.js"], n["Core/Globals.js"], n["Core/Series/SeriesRegistry.js"], n["Core/Utilities.js"]], function(o, a, r, s, l, d) {
      let { parse: y } = r, { composed: u, noop: m } = s, { series: h, seriesTypes: { column: { prototype: c }, scatter: g } } = l, { addEvent: v, arrayMax: P, arrayMin: f, clamp: S, extend: w, isNumber: x, merge: k, pick: A, pushUnique: $ } = d;
      function j() {
        let M = this.len, { coll: D, isXAxis: C, min: b } = this, p = C ? "xData" : "yData", L = (this.max || 0) - (b || 0), B = 0, T = M, O = M / L, I;
        (D === "xAxis" || D === "yAxis") && (this.series.forEach((R) => {
          if (R.bubblePadding && R.reserveSpace()) {
            this.allowZoomOutside = !0, I = !0;
            let Y = R[p];
            if (C && ((R.onPoint || R).getRadii(0, 0, R), R.onPoint && (R.radii = R.onPoint.radii)), L > 0) {
              let F = Y.length;
              for (; F--; )
                if (x(Y[F]) && this.dataMin <= Y[F] && Y[F] <= this.max) {
                  let U = R.radii && R.radii[F] || 0;
                  B = Math.min((Y[F] - b) * O - U, B), T = Math.max((Y[F] - b) * O + U, T);
                }
            }
          }
        }), I && L > 0 && !this.logarithmic && (T -= M, O *= (M + Math.max(0, B) - Math.min(T, M)) / M, [["min", "userMin", B], ["max", "userMax", T]].forEach((R) => {
          A(this.options[R[0]], this[R[1]]) === void 0 && (this[R[0]] += R[2] / O);
        })));
      }
      class N extends g {
        static compose(D, C, b) {
          o.compose(C, b), $(u, "Series.Bubble") && v(D, "foundExtremes", j);
        }
        animate(D) {
          !D && this.points.length < this.options.animationLimit && this.points.forEach(function(C) {
            let { graphic: b, plotX: p = 0, plotY: L = 0 } = C;
            b && b.width && (this.hasRendered || b.attr({ x: p, y: L, width: 1, height: 1 }), b.animate(this.markerAttribs(C), this.options.animation));
          }, this);
        }
        getRadii() {
          let D = this.zData, C = this.yData, b = [], p, L, B, T = this.chart.bubbleZExtremes, { minPxSize: O, maxPxSize: I } = this.getPxExtremes();
          if (!T) {
            let R, Y = Number.MAX_VALUE, F = -Number.MAX_VALUE;
            this.chart.series.forEach((U) => {
              if (U.bubblePadding && U.reserveSpace()) {
                let Q = (U.onPoint || U).getZExtremes();
                Q && (Y = Math.min(A(Y, Q.zMin), Q.zMin), F = Math.max(A(F, Q.zMax), Q.zMax), R = !0);
              }
            }), R ? (T = { zMin: Y, zMax: F }, this.chart.bubbleZExtremes = T) : T = { zMin: 0, zMax: 0 };
          }
          for (L = 0, p = D.length; L < p; L++)
            B = D[L], b.push(this.getRadius(T.zMin, T.zMax, O, I, B, C && C[L]));
          this.radii = b;
        }
        getRadius(D, C, b, p, L, B) {
          let T = this.options, O = T.sizeBy !== "width", I = T.zThreshold, R = C - D, Y = 0.5;
          if (B === null || L === null)
            return null;
          if (x(L)) {
            if (T.sizeByAbsoluteValue && (L = Math.abs(L - I), C = R = Math.max(C - I, Math.abs(D - I)), D = 0), L < D)
              return b / 2 - 1;
            R > 0 && (Y = (L - D) / R);
          }
          return O && Y >= 0 && (Y = Math.sqrt(Y)), Math.ceil(b + Y * (p - b)) / 2;
        }
        hasData() {
          return !!this.processedXData.length;
        }
        markerAttribs(D, C) {
          let b = super.markerAttribs(D, C), { height: p = 0, width: L = 0 } = b;
          return this.chart.inverted ? w(b, { x: (D.plotX || 0) - L / 2, y: (D.plotY || 0) - p / 2 }) : b;
        }
        pointAttribs(D, C) {
          let b = this.options.marker.fillOpacity, p = h.prototype.pointAttribs.call(this, D, C);
          return b !== 1 && (p.fill = y(p.fill).setOpacity(b).get("rgba")), p;
        }
        translate() {
          super.translate.call(this), this.getRadii(), this.translateBubble();
        }
        translateBubble() {
          let { data: D, options: C, radii: b } = this, { minPxSize: p } = this.getPxExtremes(), L = D.length;
          for (; L--; ) {
            let B = D[L], T = b ? b[L] : 0;
            this.zoneAxis === "z" && (B.negative = (B.z || 0) < (C.zThreshold || 0)), x(T) && T >= p / 2 ? (B.marker = w(B.marker, { radius: T, width: 2 * T, height: 2 * T }), B.dlBox = { x: B.plotX - T, y: B.plotY - T, width: 2 * T, height: 2 * T }) : (B.shapeArgs = B.plotY = B.dlBox = void 0, B.isInside = !1);
          }
        }
        getPxExtremes() {
          let D = Math.min(this.chart.plotWidth, this.chart.plotHeight), C = (L) => {
            let B;
            return typeof L == "string" && (B = /%$/.test(L), L = parseInt(L, 10)), B ? D * L / 100 : L;
          }, b = C(A(this.options.minSize, 8)), p = Math.max(C(A(this.options.maxSize, "20%")), b);
          return { minPxSize: b, maxPxSize: p };
        }
        getZExtremes() {
          let D = this.options, C = (this.zData || []).filter(x);
          if (C.length) {
            let b = A(D.zMin, S(f(C), D.displayNegative === !1 ? D.zThreshold || 0 : -Number.MAX_VALUE, Number.MAX_VALUE)), p = A(D.zMax, P(C));
            if (x(b) && x(p))
              return { zMin: b, zMax: p };
          }
        }
      }
      return N.defaultOptions = k(g.defaultOptions, { dataLabels: { formatter: function() {
        let { numberFormatter: M } = this.series.chart, { z: D } = this.point;
        return x(D) ? M(D, -1) : "";
      }, inside: !0, verticalAlign: "middle" }, animationLimit: 250, marker: { lineColor: null, lineWidth: 1, fillOpacity: 0.5, radius: null, states: { hover: { radiusPlus: 0 } }, symbol: "circle" }, minSize: 8, maxSize: "20%", softThreshold: !1, states: { hover: { halo: { size: 5 } } }, tooltip: { pointFormat: "({point.x}, {point.y}), Size: {point.z}" }, turboThreshold: 0, zThreshold: 0, zoneAxis: "z" }), w(N.prototype, { alignDataLabel: c.alignDataLabel, applyZones: m, bubblePadding: !0, isBubble: !0, pointArrayMap: ["y", "z"], pointClass: a, parallelArrays: ["x", "y", "z"], trackerGroups: ["group", "dataLabelsGroup"], specialGroup: "group", zoneAxis: "z" }), v(N, "updatedData", (M) => {
        delete M.target.chart.bubbleZExtremes;
      }), v(N, "remove", (M) => {
        delete M.target.chart.bubbleZExtremes;
      }), l.registerSeriesType("bubble", N), N;
    }), i(n, "Series/ColumnRange/ColumnRangePoint.js", [n["Core/Series/SeriesRegistry.js"], n["Core/Utilities.js"]], function(o, a) {
      let { seriesTypes: { column: { prototype: { pointClass: { prototype: r } } }, arearange: { prototype: { pointClass: s } } } } = o, { extend: l, isNumber: d } = a;
      class y extends s {
        isValid() {
          return d(this.low);
        }
      }
      return l(y.prototype, { setState: r.setState }), y;
    }), i(n, "Series/ColumnRange/ColumnRangeSeries.js", [n["Series/ColumnRange/ColumnRangePoint.js"], n["Core/Globals.js"], n["Core/Series/SeriesRegistry.js"], n["Core/Utilities.js"]], function(o, a, r, s) {
      let { noop: l } = a, { seriesTypes: { arearange: d, column: y, column: { prototype: u } } } = r, { addEvent: m, clamp: h, extend: c, isNumber: g, merge: v, pick: P } = s;
      class f extends d {
        setOptions() {
          return v(!0, arguments[0], { stacking: void 0 }), d.prototype.setOptions.apply(this, arguments);
        }
        translate() {
          return u.translate.apply(this);
        }
        pointAttribs() {
          return u.pointAttribs.apply(this, arguments);
        }
        translate3dPoints() {
          return u.translate3dPoints.apply(this, arguments);
        }
        translate3dShapes() {
          return u.translate3dShapes.apply(this, arguments);
        }
        afterColumnTranslate() {
          let w, x, k, A, $ = this.yAxis, j = this.xAxis, N = j.startAngleRad, M = this.chart, D = this.xAxis.isRadial, C = Math.max(M.chartWidth, M.chartHeight) + 999;
          this.points.forEach((b) => {
            let p = b.shapeArgs || {}, L = this.options.minPointLength, B = b.plotY, T = $.translate(b.high, 0, 1, 0, 1);
            if (g(T) && g(B))
              if (b.plotHigh = h(T, -C, C), b.plotLow = h(B, -C, C), A = b.plotHigh, Math.abs(w = P(b.rectPlotY, b.plotY) - b.plotHigh) < L ? (x = L - w, w += x, A -= x / 2) : w < 0 && (w *= -1, A -= w), D && this.polar)
                k = b.barX + N, b.shapeType = "arc", b.shapeArgs = this.polar.arc(A + w, A, k, k + b.pointWidth);
              else {
                p.height = w, p.y = A;
                let { x: O = 0, width: I = 0 } = p;
                b.shapeArgs = v(b.shapeArgs, this.crispCol(O, A, I, w)), b.tooltipPos = M.inverted ? [$.len + $.pos - M.plotLeft - A - w / 2, j.len + j.pos - M.plotTop - O - I / 2, w] : [j.left - M.plotLeft + O + I / 2, $.pos - M.plotTop + A + w / 2, w];
              }
          });
        }
      }
      return f.defaultOptions = v(y.defaultOptions, d.defaultOptions, { borderRadius: { where: "all" }, pointRange: null, legendSymbol: "rectangle", marker: null, states: { hover: { halo: !1 } } }), m(f, "afterColumnTranslate", function() {
        f.prototype.afterColumnTranslate.apply(this);
      }, { order: 5 }), c(f.prototype, { directTouch: !0, pointClass: o, trackerGroups: ["group", "dataLabelsGroup"], adjustForMissingColumns: u.adjustForMissingColumns, animate: u.animate, crispCol: u.crispCol, drawGraph: l, drawPoints: u.drawPoints, getSymbol: l, drawTracker: u.drawTracker, getColumnMetrics: u.getColumnMetrics }), r.registerSeriesType("columnrange", f), f;
    }), i(n, "Series/ColumnPyramid/ColumnPyramidSeriesDefaults.js", [], function() {
      return {};
    }), i(n, "Series/ColumnPyramid/ColumnPyramidSeries.js", [n["Series/ColumnPyramid/ColumnPyramidSeriesDefaults.js"], n["Core/Series/SeriesRegistry.js"], n["Core/Utilities.js"]], function(o, a, r) {
      let { column: s } = a.seriesTypes, { clamp: l, merge: d, pick: y } = r;
      class u extends s {
        translate() {
          let h = this.chart, c = this.options, g = this.dense = this.closestPointRange * this.xAxis.transA < 2, v = this.borderWidth = y(c.borderWidth, g ? 0 : 1), P = this.yAxis, f = c.threshold, S = y(c.minPointLength, 5), w = this.getColumnMetrics(), x = w.width, k = this.pointXOffset = w.offset, A = this.translatedThreshold = P.getThreshold(f), $ = this.barW = Math.max(x, 1 + 2 * v);
          for (let j of (h.inverted && (A -= 0.5), c.pointPadding && ($ = Math.ceil($)), super.translate(), this.points)) {
            let N = y(j.yBottom, A), M = 999 + Math.abs(N), D = l(j.plotY, -M, P.len + M), C = $ / 2, b = Math.min(D, N), p = Math.max(D, N) - b, L = j.plotX + k, B, T, O, I, R, Y, F, U, Q, J, ee;
            c.centerInCategory && (L = this.adjustForMissingColumns(L, x, j, w)), j.barX = L, j.pointWidth = x, j.tooltipPos = h.inverted ? [P.len + P.pos - h.plotLeft - D, this.xAxis.len - L - C, p] : [L + C, D + P.pos - h.plotTop, p], B = f + (j.total || j.y), c.stacking === "percent" && (B = f + (j.y < 0) ? -100 : 100);
            let V = P.toPixels(B, !0);
            O = (T = h.plotHeight - V - (h.plotHeight - A)) ? C * (b - V) / T : 0, I = T ? C * (b + p - V) / T : 0, Y = L - O + C, F = L + O + C, U = L + I + C, Q = L - I + C, J = b - S, ee = b + p, j.y < 0 && (J = b, ee = b + p + S), h.inverted && (R = P.width - b, T = V - (P.width - A), O = C * (V - R) / T, I = C * (V - (R - p)) / T, F = (Y = L + C + O) - 2 * O, U = L - I + C, Q = L + I + C, J = b, ee = b + p - S, j.y < 0 && (ee = b + p + S)), j.shapeType = "path", j.shapeArgs = { x: Y, y: J, width: F - Y, height: p, d: [["M", Y, J], ["L", F, J], ["L", U, ee], ["L", Q, ee], ["Z"]] };
          }
        }
      }
      return u.defaultOptions = d(s.defaultOptions, o), a.registerSeriesType("columnpyramid", u), u;
    }), i(n, "Series/ErrorBar/ErrorBarSeriesDefaults.js", [], function() {
      return { color: "#000000", grouping: !1, linkedTo: ":previous", tooltip: { pointFormat: '<span style="color:{point.color}">●</span> {series.name}: <b>{point.low}</b> - <b>{point.high}</b><br/>' }, whiskerWidth: null };
    }), i(n, "Series/ErrorBar/ErrorBarSeries.js", [n["Series/BoxPlot/BoxPlotSeries.js"], n["Series/Column/ColumnSeries.js"], n["Series/ErrorBar/ErrorBarSeriesDefaults.js"], n["Core/Series/SeriesRegistry.js"], n["Core/Utilities.js"]], function(o, a, r, s, l) {
      let { arearange: d } = s.seriesTypes, { addEvent: y, merge: u, extend: m } = l;
      class h extends o {
        getColumnMetrics() {
          return this.linkedParent && this.linkedParent.columnMetrics || a.prototype.getColumnMetrics.call(this);
        }
        drawDataLabels() {
          let g = this.pointValKey;
          if (d)
            for (let v of (d.prototype.drawDataLabels.call(this), this.points))
              v.y = v[g];
        }
        toYData(g) {
          return [g.low, g.high];
        }
      }
      return h.defaultOptions = u(o.defaultOptions, r), y(h, "afterTranslate", function() {
        for (let c of this.points)
          c.plotLow = c.plotY;
      }, { order: 0 }), m(h.prototype, { pointArrayMap: ["low", "high"], pointValKey: "high", doQuartiles: !1 }), s.registerSeriesType("errorbar", h), h;
    }), i(n, "Series/Gauge/GaugePoint.js", [n["Core/Series/SeriesRegistry.js"]], function(o) {
      let { series: { prototype: { pointClass: a } } } = o;
      return class extends a {
        setState(r) {
          this.state = r;
        }
      };
    }), i(n, "Series/Gauge/GaugeSeries.js", [n["Series/Gauge/GaugePoint.js"], n["Core/Globals.js"], n["Core/Series/SeriesRegistry.js"], n["Core/Utilities.js"]], function(o, a, r, s) {
      let { noop: l } = a, { series: d, seriesTypes: { column: y } } = r, { clamp: u, isNumber: m, extend: h, merge: c, pick: g, pInt: v, defined: P } = s;
      class f extends d {
        translate() {
          let w = this.yAxis, x = this.options, k = w.center;
          this.generatePoints(), this.points.forEach((A) => {
            let $ = c(x.dial, A.dial), j = v($.radius) * k[2] / 200, N = v($.baseLength) * j / 100, M = v($.rearLength) * j / 100, D = $.baseWidth, C = $.topWidth, b = x.overshoot, p = w.startAngleRad + w.translate(A.y, void 0, void 0, void 0, !0);
            (m(b) || x.wrap === !1) && (b = m(b) ? b / 180 * Math.PI : 0, p = u(p, w.startAngleRad - b, w.endAngleRad + b)), p = 180 * p / Math.PI, A.shapeType = "path";
            let L = $.path || [["M", -M, -D / 2], ["L", N, -D / 2], ["L", j, -C / 2], ["L", j, C / 2], ["L", N, D / 2], ["L", -M, D / 2], ["Z"]];
            A.shapeArgs = { d: L, translateX: k[0], translateY: k[1], rotation: p }, A.plotX = k[0], A.plotY = k[1], P(A.y) && w.max - w.min && (A.percentage = (A.y - w.min) / (w.max - w.min) * 100);
          });
        }
        drawPoints() {
          let w = this, x = w.chart, k = w.yAxis.center, A = w.pivot, $ = w.options, j = $.pivot, N = x.renderer;
          w.points.forEach((M) => {
            let D = M.graphic, C = M.shapeArgs, b = C.d, p = c($.dial, M.dial);
            D ? (D.animate(C), C.d = b) : M.graphic = N[M.shapeType](C).addClass("highcharts-dial").add(w.group), x.styledMode || M.graphic[D ? "animate" : "attr"]({ stroke: p.borderColor, "stroke-width": p.borderWidth, fill: p.backgroundColor });
          }), A ? A.animate({ translateX: k[0], translateY: k[1] }) : j && (w.pivot = N.circle(0, 0, j.radius).attr({ zIndex: 2 }).addClass("highcharts-pivot").translate(k[0], k[1]).add(w.group), x.styledMode || w.pivot.attr({ fill: j.backgroundColor, stroke: j.borderColor, "stroke-width": j.borderWidth }));
        }
        animate(w) {
          let x = this;
          w || x.points.forEach((k) => {
            let A = k.graphic;
            A && (A.attr({ rotation: 180 * x.yAxis.startAngleRad / Math.PI }), A.animate({ rotation: k.shapeArgs.rotation }, x.options.animation));
          });
        }
        render() {
          this.group = this.plotGroup("group", "series", this.visible ? "inherit" : "hidden", this.options.zIndex, this.chart.seriesGroup), d.prototype.render.call(this), this.group.clip(this.chart.clipRect);
        }
        setData(w, x) {
          d.prototype.setData.call(this, w, !1), this.processData(), this.generatePoints(), g(x, !0) && this.chart.redraw();
        }
        hasData() {
          return !!this.points.length;
        }
      }
      return f.defaultOptions = c(d.defaultOptions, { dataLabels: { borderColor: "#cccccc", borderRadius: 3, borderWidth: 1, crop: !1, defer: !1, enabled: !0, verticalAlign: "top", y: 15, zIndex: 2 }, dial: { backgroundColor: "#000000", baseLength: "70%", baseWidth: 3, borderColor: "#cccccc", borderWidth: 0, radius: "80%", rearLength: "10%", topWidth: 1 }, pivot: { radius: 5, borderWidth: 0, borderColor: "#cccccc", backgroundColor: "#000000" }, tooltip: { headerFormat: "" }, showInLegend: !1 }), h(f.prototype, { angular: !0, directTouch: !0, drawGraph: l, drawTracker: y.prototype.drawTracker, fixedBox: !0, forceDL: !0, noSharedTooltip: !0, pointClass: o, trackerGroups: ["group", "dataLabelsGroup"] }), r.registerSeriesType("gauge", f), f;
    }), i(n, "Series/DragNodesComposition.js", [n["Core/Globals.js"], n["Core/Utilities.js"]], function(o, a) {
      let { composed: r } = o, { addEvent: s, pushUnique: l } = a;
      function d() {
        let y, u, m, h = this;
        h.container && (y = s(h.container, "mousedown", (c) => {
          let g = h.hoverPoint;
          g && g.series && g.series.hasDraggableNodes && g.series.options.draggable && (g.series.onMouseDown(g, c), u = s(h.container, "mousemove", (v) => g && g.series && g.series.onMouseMove(g, v)), m = s(h.container.ownerDocument, "mouseup", (v) => (u(), m(), g && g.series && g.series.onMouseUp(g, v))));
        })), s(h, "destroy", function() {
          y();
        });
      }
      return { compose: function(y) {
        l(r, "DragNodes") && s(y, "load", d);
      }, onMouseDown: function(y, u) {
        let m = this.chart.pointer?.normalize(u) || u;
        y.fixedPosition = { chartX: m.chartX, chartY: m.chartY, plotX: y.plotX, plotY: y.plotY }, y.inDragMode = !0;
      }, onMouseMove: function(y, u) {
        if (y.fixedPosition && y.inDragMode) {
          let m, h, c = this.chart, g = c.pointer?.normalize(u) || u, v = y.fixedPosition.chartX - g.chartX, P = y.fixedPosition.chartY - g.chartY, f = c.graphLayoutsLookup;
          (Math.abs(v) > 5 || Math.abs(P) > 5) && (m = y.fixedPosition.plotX - v, h = y.fixedPosition.plotY - P, c.isInsidePlot(m, h) && (y.plotX = m, y.plotY = h, y.hasDragged = !0, this.redrawHalo(y), f.forEach((S) => {
            S.restartSimulation();
          })));
        }
      }, onMouseUp: function(y) {
        y.fixedPosition && (y.hasDragged && (this.layout.enableSimulation ? this.layout.start() : this.chart.redraw()), y.inDragMode = y.hasDragged = !1, this.options.fixedDraggable || delete y.fixedPosition);
      }, redrawHalo: function(y) {
        y && this.halo && this.halo.attr({ d: y.haloPath(this.options.states.hover.halo.size) });
      } };
    }), i(n, "Series/GraphLayoutComposition.js", [n["Core/Animation/AnimationUtilities.js"], n["Core/Globals.js"], n["Core/Utilities.js"]], function(o, a, r) {
      let { setAnimation: s } = o, { composed: l } = a, { addEvent: d, pushUnique: y } = r;
      function u() {
        this.graphLayoutsLookup && (this.graphLayoutsLookup.forEach((g) => {
          g.updateSimulation();
        }), this.redraw());
      }
      function m() {
        this.graphLayoutsLookup && (this.graphLayoutsLookup.forEach((g) => {
          g.updateSimulation(!1);
        }), this.redraw());
      }
      function h() {
        this.graphLayoutsLookup && this.graphLayoutsLookup.forEach((g) => {
          g.stop();
        });
      }
      function c() {
        let g, v = !1, P = (f) => {
          f.maxIterations-- && isFinite(f.temperature) && !f.isStable() && !f.enableSimulation && (f.beforeStep && f.beforeStep(), f.step(), g = !1, v = !0);
        };
        if (this.graphLayoutsLookup) {
          for (s(!1, this), this.graphLayoutsLookup.forEach((f) => f.start()); !g; )
            g = !0, this.graphLayoutsLookup.forEach(P);
          v && this.series.forEach((f) => {
            f && f.layout && f.render();
          });
        }
      }
      return { compose: function(g) {
        y(l, "GraphLayout") && (d(g, "afterPrint", u), d(g, "beforePrint", m), d(g, "predraw", h), d(g, "render", c));
      }, integrations: {}, layouts: {} };
    }), i(n, "Series/PackedBubble/PackedBubblePoint.js", [n["Core/Chart/Chart.js"], n["Core/Series/Point.js"], n["Core/Series/SeriesRegistry.js"]], function(o, a, r) {
      let { seriesTypes: { bubble: { prototype: { pointClass: s } } } } = r;
      return class extends s {
        destroy() {
          return this.series?.layout && this.series.layout.removeElementFromCollection(this, this.series.layout.nodes), a.prototype.destroy.apply(this, arguments);
        }
        firePointEvent() {
          let l = this.series.options;
          if (this.isParentNode && l.parentNode) {
            let d = l.allowPointSelect;
            l.allowPointSelect = l.parentNode.allowPointSelect, a.prototype.firePointEvent.apply(this, arguments), l.allowPointSelect = d;
          } else
            a.prototype.firePointEvent.apply(this, arguments);
        }
        select() {
          let l = this.series.chart;
          this.isParentNode ? (l.getSelectedPoints = l.getSelectedParentNodes, a.prototype.select.apply(this, arguments), l.getSelectedPoints = o.prototype.getSelectedPoints) : a.prototype.select.apply(this, arguments);
        }
      };
    }), i(n, "Series/PackedBubble/PackedBubbleSeriesDefaults.js", [n["Core/Utilities.js"]], function(o) {
      let { isNumber: a } = o;
      return { minSize: "10%", maxSize: "50%", sizeBy: "area", zoneAxis: "y", crisp: !1, tooltip: { pointFormat: "Value: {point.value}" }, draggable: !0, useSimulation: !0, parentNode: { allowPointSelect: !1 }, dataLabels: { formatter: function() {
        let { numberFormatter: r } = this.series.chart, { value: s } = this.point;
        return a(s) ? r(s, -1) : "";
      }, parentNodeFormatter: function() {
        return this.name;
      }, parentNodeTextPath: { enabled: !0 }, padding: 0, style: { transition: "opacity 2000ms" } }, layoutAlgorithm: { initialPositions: "circle", initialPositionRadius: 20, bubblePadding: 5, parentNodeLimit: !1, seriesInteraction: !0, dragBetweenSeries: !1, parentNodeOptions: { maxIterations: 400, gravitationalConstant: 0.03, maxSpeed: 50, initialPositionRadius: 100, seriesInteraction: !0, marker: { fillColor: null, fillOpacity: 1, lineWidth: null, lineColor: null, symbol: "circle" } }, enableSimulation: !0, type: "packedbubble", integration: "packedbubble", maxIterations: 1e3, splitSeries: !1, maxSpeed: 5, gravitationalConstant: 0.01, friction: -0.981 } };
    }), i(n, "Series/Networkgraph/VerletIntegration.js", [], function() {
      return { attractive: function(o, a, r) {
        let s = o.getMass(), l = -r.x * a * this.diffTemperature, d = -r.y * a * this.diffTemperature;
        o.fromNode.fixedPosition || (o.fromNode.plotX -= l * s.fromNode / o.fromNode.degree, o.fromNode.plotY -= d * s.fromNode / o.fromNode.degree), o.toNode.fixedPosition || (o.toNode.plotX += l * s.toNode / o.toNode.degree, o.toNode.plotY += d * s.toNode / o.toNode.degree);
      }, attractiveForceFunction: function(o, a) {
        return (a - o) / o;
      }, barycenter: function() {
        let o = this.options.gravitationalConstant || 0, a = (this.barycenter.xFactor - (this.box.left + this.box.width) / 2) * o, r = (this.barycenter.yFactor - (this.box.top + this.box.height) / 2) * o;
        this.nodes.forEach(function(s) {
          s.fixedPosition || (s.plotX -= a / s.mass / s.degree, s.plotY -= r / s.mass / s.degree);
        });
      }, getK: function(o) {
        return Math.pow(o.box.width * o.box.height / o.nodes.length, 0.5);
      }, integrate: function(o, a) {
        let r = -o.options.friction, s = o.options.maxSpeed, l = a.prevX, d = a.prevY, y = (a.plotX + a.dispX - l) * r, u = (a.plotY + a.dispY - d) * r, m = Math.abs, h = m(y) / (y || 1), c = m(u) / (u || 1), g = h * Math.min(s, Math.abs(y)), v = c * Math.min(s, Math.abs(u));
        a.prevX = a.plotX + a.dispX, a.prevY = a.plotY + a.dispY, a.plotX += g, a.plotY += v, a.temperature = o.vectorLength({ x: g, y: v });
      }, repulsive: function(o, a, r) {
        let s = a * this.diffTemperature / o.mass / o.degree;
        o.fixedPosition || (o.plotX += r.x * s, o.plotY += r.y * s);
      }, repulsiveForceFunction: function(o, a) {
        return (a - o) / o * (a > o ? 1 : 0);
      } };
    }), i(n, "Series/PackedBubble/PackedBubbleIntegration.js", [n["Core/Globals.js"], n["Series/Networkgraph/VerletIntegration.js"]], function(o, a) {
      let { noop: r } = o;
      return { barycenter: function() {
        let s, l, d = this.options.gravitationalConstant, y = this.box, u = this.nodes;
        for (let m of u)
          this.options.splitSeries && !m.isParentNode ? (s = m.series.parentNode.plotX, l = m.series.parentNode.plotY) : (s = y.width / 2, l = y.height / 2), m.fixedPosition || (m.plotX -= (m.plotX - s) * d / (m.mass * Math.sqrt(u.length)), m.plotY -= (m.plotY - l) * d / (m.mass * Math.sqrt(u.length)));
      }, getK: r, integrate: a.integrate, repulsive: function(s, l, d, y) {
        let u = l * this.diffTemperature / s.mass / s.degree, m = d.x * u, h = d.y * u;
        s.fixedPosition || (s.plotX += m, s.plotY += h), y.fixedPosition || (y.plotX -= m, y.plotY -= h);
      }, repulsiveForceFunction: function(s, l, d, y) {
        return Math.min(s, (d.marker.radius + y.marker.radius) / 2);
      } };
    }), i(n, "Series/Networkgraph/EulerIntegration.js", [], function() {
      return { attractive: function(o, a, r, s) {
        let l = o.getMass(), d = r.x / s * a, y = r.y / s * a;
        o.fromNode.fixedPosition || (o.fromNode.dispX -= d * l.fromNode / o.fromNode.degree, o.fromNode.dispY -= y * l.fromNode / o.fromNode.degree), o.toNode.fixedPosition || (o.toNode.dispX += d * l.toNode / o.toNode.degree, o.toNode.dispY += y * l.toNode / o.toNode.degree);
      }, attractiveForceFunction: function(o, a) {
        return o * o / a;
      }, barycenter: function() {
        let o = this.options.gravitationalConstant, a = this.barycenter.xFactor, r = this.barycenter.yFactor;
        this.nodes.forEach(function(s) {
          if (!s.fixedPosition) {
            let l = s.getDegree(), d = l * (1 + l / 2);
            s.dispX += (a - s.plotX) * o * d / s.degree, s.dispY += (r - s.plotY) * o * d / s.degree;
          }
        });
      }, getK: function(o) {
        return Math.pow(o.box.width * o.box.height / o.nodes.length, 0.3);
      }, integrate: function(o, a) {
        a.dispX += a.dispX * o.options.friction, a.dispY += a.dispY * o.options.friction;
        let r = a.temperature = o.vectorLength({ x: a.dispX, y: a.dispY });
        r !== 0 && (a.plotX += a.dispX / r * Math.min(Math.abs(a.dispX), o.temperature), a.plotY += a.dispY / r * Math.min(Math.abs(a.dispY), o.temperature));
      }, repulsive: function(o, a, r, s) {
        o.dispX += r.x / s * a / o.degree, o.dispY += r.y / s * a / o.degree;
      }, repulsiveForceFunction: function(o, a) {
        return a * a / o;
      } };
    }), i(n, "Series/Networkgraph/QuadTreeNode.js", [], function() {
      class o {
        constructor(r) {
          this.body = !1, this.isEmpty = !1, this.isInternal = !1, this.nodes = [], this.box = r, this.boxSize = Math.min(r.width, r.height);
        }
        divideBox() {
          let r = this.box.width / 2, s = this.box.height / 2;
          this.nodes[0] = new o({ left: this.box.left, top: this.box.top, width: r, height: s }), this.nodes[1] = new o({ left: this.box.left + r, top: this.box.top, width: r, height: s }), this.nodes[2] = new o({ left: this.box.left + r, top: this.box.top + s, width: r, height: s }), this.nodes[3] = new o({ left: this.box.left, top: this.box.top + s, width: r, height: s });
        }
        getBoxPosition(r) {
          let s = r.plotX < this.box.left + this.box.width / 2, l = r.plotY < this.box.top + this.box.height / 2;
          return s ? l ? 0 : 3 : l ? 1 : 2;
        }
        insert(r, s) {
          let l;
          this.isInternal ? this.nodes[this.getBoxPosition(r)].insert(r, s - 1) : (this.isEmpty = !1, this.body ? s ? (this.isInternal = !0, this.divideBox(), this.body !== !0 && (this.nodes[this.getBoxPosition(this.body)].insert(this.body, s - 1), this.body = !0), this.nodes[this.getBoxPosition(r)].insert(r, s - 1)) : ((l = new o({ top: r.plotX || NaN, left: r.plotY || NaN, width: 0.1, height: 0.1 })).body = r, l.isInternal = !1, this.nodes.push(l)) : (this.isInternal = !1, this.body = r));
        }
        updateMassAndCenter() {
          let r = 0, s = 0, l = 0;
          if (this.isInternal) {
            for (let d of this.nodes)
              d.isEmpty || (r += d.mass, s += d.plotX * d.mass, l += d.plotY * d.mass);
            s /= r, l /= r;
          } else
            this.body && (r = this.body.mass, s = this.body.plotX, l = this.body.plotY);
          this.mass = r, this.plotX = s, this.plotY = l;
        }
      }
      return o;
    }), i(n, "Series/Networkgraph/QuadTree.js", [n["Series/Networkgraph/QuadTreeNode.js"]], function(o) {
      return class {
        constructor(a, r, s, l) {
          this.box = { left: a, top: r, width: s, height: l }, this.maxDepth = 25, this.root = new o(this.box), this.root.isInternal = !0, this.root.isRoot = !0, this.root.divideBox();
        }
        calculateMassAndCenter() {
          this.visitNodeRecursive(null, null, function(a) {
            a.updateMassAndCenter();
          });
        }
        insertNodes(a) {
          for (let r of a)
            this.root.insert(r, this.maxDepth);
        }
        visitNodeRecursive(a, r, s) {
          let l;
          if (a || (a = this.root), a === this.root && r && (l = r(a)), l !== !1) {
            for (let d of a.nodes) {
              if (d.isInternal) {
                if (r && (l = r(d)), l === !1)
                  continue;
                this.visitNodeRecursive(d, r, s);
              } else
                d.body && r && r(d.body);
              s && s(d);
            }
            a === this.root && s && s(a);
          }
        }
      };
    }), i(n, "Series/Networkgraph/ReingoldFruchtermanLayout.js", [n["Series/Networkgraph/EulerIntegration.js"], n["Core/Globals.js"], n["Series/GraphLayoutComposition.js"], n["Series/Networkgraph/QuadTree.js"], n["Core/Utilities.js"], n["Series/Networkgraph/VerletIntegration.js"]], function(o, a, r, s, l, d) {
      let { win: y } = a, { clamp: u, defined: m, isFunction: h, fireEvent: c, pick: g } = l;
      class v {
        constructor() {
          this.box = {}, this.currentStep = 0, this.initialRendering = !0, this.links = [], this.nodes = [], this.series = [], this.simulation = !1;
        }
        static compose(f) {
          r.compose(f), r.integrations.euler = o, r.integrations.verlet = d, r.layouts["reingold-fruchterman"] = v;
        }
        init(f) {
          this.options = f, this.nodes = [], this.links = [], this.series = [], this.box = { x: 0, y: 0, width: 0, height: 0 }, this.setInitialRendering(!0), this.integration = r.integrations[f.integration], this.enableSimulation = f.enableSimulation, this.attractiveForce = g(f.attractiveForce, this.integration.attractiveForceFunction), this.repulsiveForce = g(f.repulsiveForce, this.integration.repulsiveForceFunction), this.approximation = f.approximation;
        }
        updateSimulation(f) {
          this.enableSimulation = g(f, this.options.enableSimulation);
        }
        start() {
          let f = this.series, S = this.options;
          this.currentStep = 0, this.forces = f[0] && f[0].forces || [], this.chart = f[0] && f[0].chart, this.initialRendering && (this.initPositions(), f.forEach(function(w) {
            w.finishedAnimating = !0, w.render();
          })), this.setK(), this.resetSimulation(S), this.enableSimulation && this.step();
        }
        step() {
          let f = this.series;
          for (let S of (this.currentStep++, this.approximation === "barnes-hut" && (this.createQuadTree(), this.quadTree.calculateMassAndCenter()), this.forces || []))
            this[S + "Forces"](this.temperature);
          if (this.applyLimits(), this.temperature = this.coolDown(this.startTemperature, this.diffTemperature, this.currentStep), this.prevSystemTemperature = this.systemTemperature, this.systemTemperature = this.getSystemTemperature(), this.enableSimulation) {
            for (let S of f)
              S.chart && S.render();
            this.maxIterations-- && isFinite(this.temperature) && !this.isStable() ? (this.simulation && y.cancelAnimationFrame(this.simulation), this.simulation = y.requestAnimationFrame(() => this.step())) : (this.simulation = !1, this.series.forEach((S) => {
              c(S, "afterSimulation");
            }));
          }
        }
        stop() {
          this.simulation && y.cancelAnimationFrame(this.simulation);
        }
        setArea(f, S, w, x) {
          this.box = { left: f, top: S, width: w, height: x };
        }
        setK() {
          this.k = this.options.linkLength || this.integration.getK(this);
        }
        addElementsToCollection(f, S) {
          for (let w of f)
            S.indexOf(w) === -1 && S.push(w);
        }
        removeElementFromCollection(f, S) {
          let w = S.indexOf(f);
          w !== -1 && S.splice(w, 1);
        }
        clear() {
          this.nodes.length = 0, this.links.length = 0, this.series.length = 0, this.resetSimulation();
        }
        resetSimulation() {
          this.forcedStop = !1, this.systemTemperature = 0, this.setMaxIterations(), this.setTemperature(), this.setDiffTemperature();
        }
        restartSimulation() {
          this.simulation ? this.resetSimulation() : (this.setInitialRendering(!1), this.enableSimulation ? this.start() : this.setMaxIterations(1), this.chart && this.chart.redraw(), this.setInitialRendering(!0));
        }
        setMaxIterations(f) {
          this.maxIterations = g(f, this.options.maxIterations);
        }
        setTemperature() {
          this.temperature = this.startTemperature = Math.sqrt(this.nodes.length);
        }
        setDiffTemperature() {
          this.diffTemperature = this.startTemperature / (this.options.maxIterations + 1);
        }
        setInitialRendering(f) {
          this.initialRendering = f;
        }
        createQuadTree() {
          this.quadTree = new s(this.box.left, this.box.top, this.box.width, this.box.height), this.quadTree.insertNodes(this.nodes);
        }
        initPositions() {
          let f = this.options.initialPositions;
          if (h(f))
            for (let S of (f.call(this), this.nodes))
              m(S.prevX) || (S.prevX = S.plotX), m(S.prevY) || (S.prevY = S.plotY), S.dispX = 0, S.dispY = 0;
          else
            f === "circle" ? this.setCircularPositions() : this.setRandomPositions();
        }
        setCircularPositions() {
          let f, S = this.box, w = this.nodes, x = 2 * Math.PI / (w.length + 1), k = w.filter(function(M) {
            return M.linksTo.length === 0;
          }), A = {}, $ = this.options.initialPositionRadius, j = (M) => {
            for (let D of M.linksFrom || [])
              A[D.toNode.id] || (A[D.toNode.id] = !0, N.push(D.toNode), j(D.toNode));
          }, N = [];
          for (let M of k)
            N.push(M), j(M);
          if (N.length)
            for (let M of w)
              N.indexOf(M) === -1 && N.push(M);
          else
            N = w;
          for (let M = 0, D = N.length; M < D; ++M)
            (f = N[M]).plotX = f.prevX = g(f.plotX, S.width / 2 + $ * Math.cos(M * x)), f.plotY = f.prevY = g(f.plotY, S.height / 2 + $ * Math.sin(M * x)), f.dispX = 0, f.dispY = 0;
        }
        setRandomPositions() {
          let f, S = this.box, w = this.nodes, x = w.length + 1, k = (A) => {
            let $ = A * A / Math.PI;
            return $ - Math.floor($);
          };
          for (let A = 0, $ = w.length; A < $; ++A)
            (f = w[A]).plotX = f.prevX = g(f.plotX, S.width * k(A)), f.plotY = f.prevY = g(f.plotY, S.height * k(x + A)), f.dispX = 0, f.dispY = 0;
        }
        force(f, ...S) {
          this.integration[f].apply(this, S);
        }
        barycenterForces() {
          this.getBarycenter(), this.force("barycenter");
        }
        getBarycenter() {
          let f = 0, S = 0, w = 0;
          for (let x of this.nodes)
            S += x.plotX * x.mass, w += x.plotY * x.mass, f += x.mass;
          return this.barycenter = { x: S, y: w, xFactor: S / f, yFactor: w / f }, this.barycenter;
        }
        barnesHutApproximation(f, S) {
          let w, x, k = this.getDistXY(f, S), A = this.vectorLength(k);
          return f !== S && A !== 0 && (S.isInternal ? S.boxSize / A < this.options.theta && A !== 0 ? (x = this.repulsiveForce(A, this.k), this.force("repulsive", f, x * S.mass, k, A), w = !1) : w = !0 : (x = this.repulsiveForce(A, this.k), this.force("repulsive", f, x * S.mass, k, A))), w;
        }
        repulsiveForces() {
          if (this.approximation === "barnes-hut")
            for (let f of this.nodes)
              this.quadTree.visitNodeRecursive(null, (S) => this.barnesHutApproximation(f, S));
          else {
            let f, S, w;
            for (let x of this.nodes)
              for (let k of this.nodes)
                x === k || x.fixedPosition || (w = this.getDistXY(x, k), (S = this.vectorLength(w)) !== 0 && (f = this.repulsiveForce(S, this.k), this.force("repulsive", x, f * k.mass, w, S)));
          }
        }
        attractiveForces() {
          let f, S, w;
          for (let x of this.links)
            x.fromNode && x.toNode && (f = this.getDistXY(x.fromNode, x.toNode), (S = this.vectorLength(f)) !== 0 && (w = this.attractiveForce(S, this.k), this.force("attractive", x, w, f, S)));
        }
        applyLimits() {
          for (let f of this.nodes)
            f.fixedPosition || (this.integration.integrate(this, f), this.applyLimitBox(f, this.box), f.dispX = 0, f.dispY = 0);
        }
        applyLimitBox(f, S) {
          let w = f.radius;
          f.plotX = u(f.plotX, S.left + w, S.width - w), f.plotY = u(f.plotY, S.top + w, S.height - w);
        }
        coolDown(f, S, w) {
          return f - S * w;
        }
        isStable() {
          return 1e-5 > Math.abs(this.systemTemperature - this.prevSystemTemperature) || this.temperature <= 0;
        }
        getSystemTemperature() {
          let f = 0;
          for (let S of this.nodes)
            f += S.temperature;
          return f;
        }
        vectorLength(f) {
          return Math.sqrt(f.x * f.x + f.y * f.y);
        }
        getDistR(f, S) {
          let w = this.getDistXY(f, S);
          return this.vectorLength(w);
        }
        getDistXY(f, S) {
          let w = f.plotX - S.plotX, x = f.plotY - S.plotY;
          return { x: w, y: x, absX: Math.abs(w), absY: Math.abs(x) };
        }
      }
      return v;
    }), i(n, "Series/PackedBubble/PackedBubbleLayout.js", [n["Series/GraphLayoutComposition.js"], n["Series/PackedBubble/PackedBubbleIntegration.js"], n["Series/Networkgraph/ReingoldFruchtermanLayout.js"], n["Core/Utilities.js"]], function(o, a, r, s) {
      let { addEvent: l, pick: d } = s;
      function y() {
        let h = this.series, c = [];
        return h.forEach((g) => {
          g.parentNode && g.parentNode.selected && c.push(g.parentNode);
        }), c;
      }
      function u() {
        this.allDataPoints && delete this.allDataPoints;
      }
      class m extends r {
        constructor() {
          super(...arguments), this.index = NaN, this.nodes = [], this.series = [];
        }
        static compose(c) {
          r.compose(c), o.integrations.packedbubble = a, o.layouts.packedbubble = m;
          let g = c.prototype;
          g.getSelectedParentNodes || (l(c, "beforeRedraw", u), g.getSelectedParentNodes = y);
        }
        beforeStep() {
          this.options.marker && this.series.forEach((c) => {
            c && c.calculateParentRadius();
          });
        }
        isStable() {
          let c = Math.abs(this.prevSystemTemperature - this.systemTemperature);
          return 1 > Math.abs(10 * this.systemTemperature / Math.sqrt(this.nodes.length)) && c < 1e-5 || this.temperature <= 0;
        }
        setCircularPositions() {
          let c = this.box, g = this.nodes, v = 2 * Math.PI / (g.length + 1), P = this.options.initialPositionRadius, f, S, w = 0;
          for (let x of g)
            this.options.splitSeries && !x.isParentNode ? (f = x.series.parentNode.plotX, S = x.series.parentNode.plotY) : (f = c.width / 2, S = c.height / 2), x.plotX = x.prevX = d(x.plotX, f + P * Math.cos(x.index || w * v)), x.plotY = x.prevY = d(x.plotY, S + P * Math.sin(x.index || w * v)), x.dispX = 0, x.dispY = 0, w++;
        }
        repulsiveForces() {
          let c, g, v, P = this, f = P.options.bubblePadding, S = P.nodes;
          S.forEach((w) => {
            w.degree = w.mass, w.neighbours = 0, S.forEach((x) => {
              c = 0, w !== x && !w.fixedPosition && (P.options.seriesInteraction || w.series === x.series) && (v = P.getDistXY(w, x), (g = P.vectorLength(v) - (w.marker.radius + x.marker.radius + f)) < 0 && (w.degree += 0.01, w.neighbours++, c = P.repulsiveForce(-g / Math.sqrt(w.neighbours), P.k, w, x)), P.force("repulsive", w, c * x.mass, v, x, g));
            });
          });
        }
        applyLimitBox(c, g) {
          let v, P;
          this.options.splitSeries && !c.isParentNode && this.options.parentNodeLimit && (v = this.getDistXY(c, c.series.parentNode), (P = c.series.parentNodeRadius - c.marker.radius - this.vectorLength(v)) < 0 && P > -2 * c.marker.radius && (c.plotX -= 0.01 * v.x, c.plotY -= 0.01 * v.y)), super.applyLimitBox(c, g);
        }
      }
      return o.layouts.packedbubble = m, m;
    }), i(n, "Series/SimulationSeriesUtilities.js", [n["Core/Utilities.js"], n["Core/Animation/AnimationUtilities.js"]], function(o, a) {
      let { merge: r, syncTimeout: s } = o, { animObject: l } = a;
      return { initDataLabels: function() {
        let d = this.options.dataLabels;
        if (!this.dataLabelsGroup) {
          let y = this.initDataLabelsGroup();
          return !this.chart.styledMode && d?.style && y.css(d.style), y.attr({ opacity: 0 }), this.visible && y.show(), y;
        }
        return this.dataLabelsGroup.attr(r({ opacity: 1 }, this.getPlotBox("data-labels"))), this.dataLabelsGroup;
      }, initDataLabelsDefer: function() {
        let d = this.options.dataLabels;
        d?.defer && this.options.layoutAlgorithm?.enableSimulation ? s(() => {
          this.deferDataLabels = !1;
        }, d ? l(d.animation).defer : 0) : this.deferDataLabels = !1;
      } };
    }), i(n, "Extensions/TextPath.js", [n["Core/Globals.js"], n["Core/Utilities.js"]], function(o, a) {
      let { deg2rad: r } = o, { addEvent: s, merge: l, uniqueKey: d, defined: y, extend: u } = a;
      function m(g, v) {
        v = l(!0, { enabled: !0, attributes: { dy: -5, startOffset: "50%", textAnchor: "middle" } }, v);
        let P = this.renderer.url, f = this.text || this, S = f.textPath, { attributes: w, enabled: x } = v;
        if (g = g || S && S.path, S && S.undo(), g && x) {
          let k = s(f, "afterModifyTree", (A) => {
            if (g && x) {
              let $ = g.attr("id");
              $ || g.attr("id", $ = d());
              let j = { x: 0, y: 0 };
              y(w.dx) && (j.dx = w.dx, delete w.dx), y(w.dy) && (j.dy = w.dy, delete w.dy), f.attr(j), this.attr({ transform: "" }), this.box && (this.box = this.box.destroy());
              let N = A.nodes.slice(0);
              A.nodes.length = 0, A.nodes[0] = { tagName: "textPath", attributes: u(w, { "text-anchor": w.textAnchor, href: `${P}#${$}` }), children: N };
            }
          });
          f.textPath = { path: g, undo: k };
        } else
          f.attr({ dx: 0, dy: 0 }), delete f.textPath;
        return this.added && (f.textCache = "", this.renderer.buildText(f)), this;
      }
      function h(g) {
        let v = g.bBox, P = this.element?.querySelector("textPath");
        if (P) {
          let f = [], { b: S, h: w } = this.renderer.fontMetrics(this.element), x = w - S, k = RegExp('(<tspan>|<tspan(?!\\sclass="highcharts-br")[^>]*>|<\\/tspan>)', "g"), A = P.innerHTML.replace(k, "").split(/<tspan class="highcharts-br"[^>]*>/), $ = A.length, j = (N, M) => {
            let { x: D, y: C } = M, b = (P.getRotationOfChar(N) - 90) * r, p = Math.cos(b), L = Math.sin(b);
            return [[D - x * p, C - x * L], [D + S * p, C + S * L]];
          };
          for (let N = 0, M = 0; M < $; M++) {
            let D = A[M].length;
            for (let C = 0; C < D; C += 5)
              try {
                let b = N + C + M, [p, L] = j(b, P.getStartPositionOfChar(b));
                C === 0 ? (f.push(L), f.push(p)) : (M === 0 && f.unshift(L), M === $ - 1 && f.push(p));
              } catch {
                break;
              }
            N += D - 1;
            try {
              let C = N + M, b = P.getEndPositionOfChar(C), [p, L] = j(C, b);
              f.unshift(L), f.unshift(p);
            } catch {
              break;
            }
          }
          f.length && f.push(f[0].slice()), v.polygon = f;
        }
        return v;
      }
      function c(g) {
        let v = g.labelOptions, P = g.point, f = v[P.formatPrefix + "TextPath"] || v.textPath;
        f && !v.useHTML && (this.setTextPath(P.getDataLabelPath?.(this) || P.graphic, f), P.dataLabelPath && !f.enabled && (P.dataLabelPath = P.dataLabelPath.destroy()));
      }
      return { compose: function(g) {
        s(g, "afterGetBBox", h), s(g, "beforeAddingDataLabel", c);
        let v = g.prototype;
        v.setTextPath || (v.setTextPath = m);
      } };
    }), i(n, "Series/PackedBubble/PackedBubbleSeries.js", [n["Core/Color/Color.js"], n["Series/DragNodesComposition.js"], n["Series/GraphLayoutComposition.js"], n["Core/Globals.js"], n["Series/PackedBubble/PackedBubblePoint.js"], n["Series/PackedBubble/PackedBubbleSeriesDefaults.js"], n["Series/PackedBubble/PackedBubbleLayout.js"], n["Core/Series/SeriesRegistry.js"], n["Series/SimulationSeriesUtilities.js"], n["Core/Utilities.js"], n["Core/Renderer/SVG/SVGElement.js"], n["Extensions/TextPath.js"]], function(o, a, r, s, l, d, y, u, m, h, c, g) {
      let { parse: v } = o, { noop: P } = s, { series: { prototype: f }, seriesTypes: { bubble: S } } = u, { initDataLabels: w, initDataLabelsDefer: x } = m, { addEvent: k, clamp: A, defined: $, extend: j, fireEvent: N, isArray: M, isNumber: D, merge: C, pick: b } = h;
      g.compose(c);
      class p extends S {
        constructor() {
          super(...arguments), this.parentNodeMass = 0, this.deferDataLabels = !0;
        }
        static compose(B, T, O) {
          S.compose(B, T, O), a.compose(T), y.compose(T);
        }
        accumulateAllPoints() {
          let B, T = this.chart, O = [];
          for (let I of T.series)
            if (I.is("packedbubble") && I.reserveSpace()) {
              B = I.yData || [];
              for (let R = 0; R < B.length; R++)
                O.push([null, null, B[R], I.index, R, { id: R, marker: { radius: 0 } }]);
            }
          return O;
        }
        addLayout() {
          let B = this.options.layoutAlgorithm = this.options.layoutAlgorithm || {}, T = B.type || "packedbubble", O = this.chart.options.chart, I = this.chart.graphLayoutsStorage, R = this.chart.graphLayoutsLookup, Y;
          I || (this.chart.graphLayoutsStorage = I = {}, this.chart.graphLayoutsLookup = R = []), (Y = I[T]) || (B.enableSimulation = $(O.forExport) ? !O.forExport : B.enableSimulation, I[T] = Y = new r.layouts[T](), Y.init(B), R.splice(Y.index, 0, Y)), this.layout = Y, this.points.forEach((F) => {
            F.mass = 2, F.degree = 1, F.collisionNmb = 1;
          }), Y.setArea(0, 0, this.chart.plotWidth, this.chart.plotHeight), Y.addElementsToCollection([this], Y.series), Y.addElementsToCollection(this.points, Y.nodes);
        }
        addSeriesLayout() {
          let B = this.options.layoutAlgorithm = this.options.layoutAlgorithm || {}, T = B.type || "packedbubble", O = this.chart.graphLayoutsStorage, I = this.chart.graphLayoutsLookup, R = C(B, B.parentNodeOptions, { enableSimulation: this.layout.options.enableSimulation }), Y = O[T + "-series"];
          Y || (O[T + "-series"] = Y = new r.layouts[T](), Y.init(R), I.splice(Y.index, 0, Y)), this.parentNodeLayout = Y, this.createParentNodes();
        }
        calculateParentRadius() {
          let B = this.seriesBox();
          this.parentNodeRadius = A(Math.sqrt(2 * this.parentNodeMass / Math.PI) + 20, 20, B ? Math.max(Math.sqrt(Math.pow(B.width, 2) + Math.pow(B.height, 2)) / 2 + 20, 20) : Math.sqrt(2 * this.parentNodeMass / Math.PI) + 20), this.parentNode && (this.parentNode.marker.radius = this.parentNode.radius = this.parentNodeRadius);
        }
        calculateZExtremes() {
          let B = this.chart.series, T = this.options.zMin, O = this.options.zMax, I = 1 / 0, R = -1 / 0;
          return T && O ? [T, O] : (B.forEach((Y) => {
            Y.yData.forEach((F) => {
              $(F) && (F > R && (R = F), F < I && (I = F));
            });
          }), [T = b(T, I), O = b(O, R)]);
        }
        checkOverlap(B, T) {
          let O = B[0] - T[0], I = B[1] - T[1];
          return Math.sqrt(O * O + I * I) - Math.abs(B[2] + T[2]) < -1e-3;
        }
        createParentNodes() {
          let B = this.pointClass, T = this.chart, O = this.parentNodeLayout, I = this.layout.options, R, Y = this.parentNode, F = { radius: this.parentNodeRadius, lineColor: this.color, fillColor: v(this.color).brighten(0.4).get() };
          I.parentNodeOptions && (F = C(I.parentNodeOptions.marker || {}, F)), this.parentNodeMass = 0, this.points.forEach((U) => {
            this.parentNodeMass += Math.PI * Math.pow(U.marker.radius, 2);
          }), this.calculateParentRadius(), O.nodes.forEach((U) => {
            U.seriesIndex === this.index && (R = !0);
          }), O.setArea(0, 0, T.plotWidth, T.plotHeight), R || (Y || (Y = new B(this, { mass: this.parentNodeRadius / 2, marker: F, dataLabels: { inside: !1 }, states: { normal: { marker: F }, hover: { marker: F } }, dataLabelOnNull: !0, degree: this.parentNodeRadius, isParentNode: !0, seriesIndex: this.index })), this.parentNode && (Y.plotX = this.parentNode.plotX, Y.plotY = this.parentNode.plotY), this.parentNode = Y, O.addElementsToCollection([this], O.series), O.addElementsToCollection([Y], O.nodes));
        }
        deferLayout() {
          let B = this.options.layoutAlgorithm;
          this.visible && (this.addLayout(), B.splitSeries && this.addSeriesLayout());
        }
        destroy() {
          this.chart.graphLayoutsLookup && this.chart.graphLayoutsLookup.forEach((B) => {
            B.removeElementFromCollection(this, B.series);
          }, this), this.parentNode && this.parentNodeLayout && (this.parentNodeLayout.removeElementFromCollection(this.parentNode, this.parentNodeLayout.nodes), this.parentNode.dataLabel && (this.parentNode.dataLabel = this.parentNode.dataLabel.destroy())), f.destroy.apply(this, arguments);
        }
        drawDataLabels() {
          !this.deferDataLabels && (f.drawDataLabels.call(this, this.points), this.parentNode && (this.parentNode.formatPrefix = "parentNode", f.drawDataLabels.call(this, [this.parentNode])));
        }
        drawGraph() {
          if (!this.layout || !this.layout.options.splitSeries)
            return;
          let B = this.chart, T = this.layout.options.parentNodeOptions.marker, O = { fill: T.fillColor || v(this.color).brighten(0.4).get(), opacity: T.fillOpacity, stroke: T.lineColor || this.color, "stroke-width": b(T.lineWidth, this.options.lineWidth) }, I = {};
          this.parentNodesGroup = this.plotGroup("parentNodesGroup", "parentNode", this.visible ? "inherit" : "hidden", 0.1, B.seriesGroup), this.group?.attr({ zIndex: 2 }), this.calculateParentRadius(), this.parentNode && $(this.parentNode.plotX) && $(this.parentNode.plotY) && $(this.parentNodeRadius) && (I = C({ x: this.parentNode.plotX - this.parentNodeRadius, y: this.parentNode.plotY - this.parentNodeRadius, width: 2 * this.parentNodeRadius, height: 2 * this.parentNodeRadius }, O), this.parentNode.graphic || (this.graph = this.parentNode.graphic = B.renderer.symbol(O.symbol).add(this.parentNodesGroup)), this.parentNode.graphic.attr(I));
        }
        drawTracker() {
          let B, T = this.parentNode;
          super.drawTracker(), T && (B = M(T.dataLabels) ? T.dataLabels : T.dataLabel ? [T.dataLabel] : [], T.graphic && (T.graphic.element.point = T), B.forEach((O) => {
            (O.div || O.element).point = T;
          }));
        }
        getPointRadius() {
          let B, T, O, I, R = this.chart, Y = R.plotWidth, F = R.plotHeight, U = this.options, Q = U.useSimulation, J = Math.min(Y, F), ee = {}, V = [], G = R.allDataPoints || [], W = G.length;
          ["minSize", "maxSize"].forEach((z) => {
            let q = parseInt(U[z], 10), Z = /%$/.test(U[z]);
            ee[z] = Z ? J * q / 100 : q * Math.sqrt(W);
          }), R.minRadius = B = ee.minSize / Math.sqrt(W), R.maxRadius = T = ee.maxSize / Math.sqrt(W);
          let ae = Q ? this.calculateZExtremes() : [B, T];
          G.forEach((z, q) => {
            O = Q ? A(z[2], ae[0], ae[1]) : z[2], (I = this.getRadius(ae[0], ae[1], B, T, O)) === 0 && (I = null), G[q][2] = I, V.push(I);
          }), this.radii = V;
        }
        init() {
          return f.init.apply(this, arguments), x.call(this), this.eventsToUnbind.push(k(this, "updatedData", function() {
            this.chart.series.forEach((B) => {
              B.type === this.type && (B.isDirty = !0);
            }, this);
          })), this;
        }
        onMouseUp(B) {
          if (B.fixedPosition && !B.removed) {
            let T, O = this.layout, I = this.parentNodeLayout;
            I && O.options.dragBetweenSeries && I.nodes.forEach((R) => {
              B && B.marker && R !== B.series.parentNode && (T = O.getDistXY(B, R), O.vectorLength(T) - R.marker.radius - B.marker.radius < 0 && (R.series.addPoint(C(B.options, { plotX: B.plotX, plotY: B.plotY }), !1), O.removeElementFromCollection(B, O.nodes), B.remove()));
            }), a.onMouseUp.apply(this, arguments);
          }
        }
        placeBubbles(B) {
          let T = this.checkOverlap, O = this.positionBubble, I = [], R = 1, Y = 0, F = 0, U, Q = [], J, ee = B.sort((V, G) => G[2] - V[2]);
          if (ee.length) {
            if (I.push([[0, 0, ee[0][2], ee[0][3], ee[0][4]]]), ee.length > 1)
              for (I.push([[0, 0 - ee[1][2] - ee[0][2], ee[1][2], ee[1][3], ee[1][4]]]), J = 2; J < ee.length; J++)
                ee[J][2] = ee[J][2] || 1, T(U = O(I[R][Y], I[R - 1][F], ee[J]), I[R][0]) ? (I.push([]), F = 0, I[R + 1].push(O(I[R][Y], I[R][0], ee[J])), R++, Y = 0) : R > 1 && I[R - 1][F + 1] && T(U, I[R - 1][F + 1]) ? (F++, I[R].push(O(I[R][Y], I[R - 1][F], ee[J])), Y++) : (Y++, I[R].push(U));
            this.chart.stages = I, this.chart.rawPositions = [].concat.apply([], I), this.resizeRadius(), Q = this.chart.rawPositions;
          }
          return Q;
        }
        pointAttribs(B, T) {
          let O = this.options, I = B && B.isParentNode, R = O.marker;
          I && O.layoutAlgorithm && O.layoutAlgorithm.parentNodeOptions && (R = O.layoutAlgorithm.parentNodeOptions.marker);
          let Y = R.fillOpacity, F = f.pointAttribs.call(this, B, T);
          return Y !== 1 && (F["fill-opacity"] = Y), F;
        }
        positionBubble(B, T, O) {
          let I = Math.asin, R = Math.acos, Y = Math.pow, F = Math.abs, U = (0, Math.sqrt)(Y(B[0] - T[0], 2) + Y(B[1] - T[1], 2)), Q = R((Y(U, 2) + Y(O[2] + T[2], 2) - Y(O[2] + B[2], 2)) / (2 * (O[2] + T[2]) * U)), J = I(F(B[0] - T[0]) / U), ee = (B[1] - T[1] < 0 ? 0 : Math.PI) + Q + J * ((B[0] - T[0]) * (B[1] - T[1]) < 0 ? 1 : -1), V = Math.cos(ee), G = Math.sin(ee);
          return [T[0] + (T[2] + O[2]) * G, T[1] - (T[2] + O[2]) * V, O[2], O[3], O[4]];
        }
        render() {
          let B = [];
          f.render.apply(this, arguments), !this.options.dataLabels.allowOverlap && (this.data.forEach((T) => {
            M(T.dataLabels) && T.dataLabels.forEach((O) => {
              B.push(O);
            });
          }), this.options.useSimulation && this.chart.hideOverlappingLabels(B));
        }
        resizeRadius() {
          let B, T, O, I, R, Y = this.chart, F = Y.rawPositions, U = Math.min, Q = Math.max, J = Y.plotLeft, ee = Y.plotTop, V = Y.plotHeight, G = Y.plotWidth;
          for (let q of (B = O = Number.POSITIVE_INFINITY, T = I = Number.NEGATIVE_INFINITY, F))
            R = q[2], B = U(B, q[0] - R), T = Q(T, q[0] + R), O = U(O, q[1] - R), I = Q(I, q[1] + R);
          let W = [T - B, I - O], ae = [(G - J) / W[0], (V - ee) / W[1]], z = U.apply([], ae);
          if (Math.abs(z - 1) > 1e-10) {
            for (let q of F)
              q[2] *= z;
            this.placeBubbles(F);
          } else
            Y.diffY = V / 2 + ee - O - (I - O) / 2, Y.diffX = G / 2 + J - B - (T - B) / 2;
        }
        seriesBox() {
          let B, T = this.chart, O = this.data, I = Math.max, R = Math.min, Y = [T.plotLeft, T.plotLeft + T.plotWidth, T.plotTop, T.plotTop + T.plotHeight];
          return O.forEach((F) => {
            $(F.plotX) && $(F.plotY) && F.marker.radius && (B = F.marker.radius, Y[0] = R(Y[0], F.plotX - B), Y[1] = I(Y[1], F.plotX + B), Y[2] = R(Y[2], F.plotY - B), Y[3] = I(Y[3], F.plotY + B));
          }), D(Y.width / Y.height) ? Y : null;
        }
        setVisible() {
          let B = this;
          f.setVisible.apply(B, arguments), B.parentNodeLayout && B.graph ? B.visible ? (B.graph.show(), B.parentNode.dataLabel && B.parentNode.dataLabel.show()) : (B.graph.hide(), B.parentNodeLayout.removeElementFromCollection(B.parentNode, B.parentNodeLayout.nodes), B.parentNode.dataLabel && B.parentNode.dataLabel.hide()) : B.layout && (B.visible ? B.layout.addElementsToCollection(B.points, B.layout.nodes) : B.points.forEach((T) => {
            B.layout.removeElementFromCollection(T, B.layout.nodes);
          }));
        }
        translate() {
          let B, T, O, I = this.chart, R = this.data, Y = this.index, F = this.options.useSimulation;
          for (let U of (this.processedXData = this.xData, this.generatePoints(), $(I.allDataPoints) || (I.allDataPoints = this.accumulateAllPoints(), this.getPointRadius()), F ? O = I.allDataPoints : (O = this.placeBubbles(I.allDataPoints), this.options.draggable = !1), O))
            U[3] === Y && (B = R[U[4]], T = b(U[2], void 0), F || (B.plotX = U[0] - I.plotLeft + I.diffX, B.plotY = U[1] - I.plotTop + I.diffY), D(T) && (B.marker = j(B.marker, { radius: T, width: 2 * T, height: 2 * T }), B.radius = T));
          F && this.deferLayout(), N(this, "afterTranslate");
        }
      }
      return p.defaultOptions = C(S.defaultOptions, d), j(p.prototype, { pointClass: l, axisTypes: [], directTouch: !0, forces: ["barycenter", "repulsive"], hasDraggableNodes: !0, invertible: !1, isCartesian: !1, noSharedTooltip: !0, pointArrayMap: ["value"], pointValKey: "value", requireSorting: !1, trackerGroups: ["group", "dataLabelsGroup", "parentNodesGroup"], initDataLabels: w, alignDataLabel: f.alignDataLabel, indexateNodes: P, onMouseDown: a.onMouseDown, onMouseMove: a.onMouseMove, redrawHalo: a.redrawHalo, searchPoint: P }), u.registerSeriesType("packedbubble", p), p;
    }), i(n, "Series/Polygon/PolygonSeriesDefaults.js", [], function() {
      return { marker: { enabled: !1, states: { hover: { enabled: !1 } } }, stickyTracking: !1, tooltip: { followPointer: !0, pointFormat: "" }, trackByArea: !0, legendSymbol: "rectangle" };
    }), i(n, "Series/Polygon/PolygonSeries.js", [n["Core/Globals.js"], n["Series/Polygon/PolygonSeriesDefaults.js"], n["Core/Series/SeriesRegistry.js"], n["Core/Utilities.js"]], function(o, a, r, s) {
      let { noop: l } = o, { area: d, line: y, scatter: u } = r.seriesTypes, { extend: m, merge: h } = s;
      class c extends u {
        getGraphPath() {
          let v = y.prototype.getGraphPath.call(this), P = v.length + 1;
          for (; P--; )
            (P === v.length || v[P][0] === "M") && P > 0 && v.splice(P, 0, ["Z"]);
          return this.areaPath = v, v;
        }
        drawGraph() {
          this.options.fillColor = this.color, d.prototype.drawGraph.call(this);
        }
      }
      return c.defaultOptions = h(u.defaultOptions, a), m(c.prototype, { type: "polygon", drawTracker: y.prototype.drawTracker, setStackedPoints: l }), r.registerSeriesType("polygon", c), c;
    }), i(n, "Core/Axis/RadialAxisDefaults.js", [], function() {
      return { circular: { gridLineWidth: 1, labels: { align: void 0, x: 0, y: void 0, style: { textOverflow: "none" } }, maxPadding: 0, minPadding: 0, showLastLabel: !1, tickLength: 0 }, radial: { gridLineInterpolation: "circle", gridLineWidth: 1, labels: { align: "right", padding: 5, x: -3, y: -2 }, showLastLabel: !1, title: { x: 4, text: null, rotation: 90 } }, radialGauge: { endOnTick: !1, gridLineWidth: 0, labels: { align: "center", distance: -25, x: 0, y: void 0 }, lineWidth: 1, minorGridLineWidth: 0, minorTickInterval: "auto", minorTickLength: 10, minorTickPosition: "inside", minorTickWidth: 1, startOnTick: !1, tickLength: 10, tickPixelInterval: 100, tickPosition: "inside", tickWidth: 2, title: { rotation: 0, text: "" }, zIndex: 2 } };
    }), i(n, "Core/Axis/RadialAxis.js", [n["Core/Axis/RadialAxisDefaults.js"], n["Core/Defaults.js"], n["Core/Globals.js"], n["Core/Utilities.js"]], function(o, a, r, s) {
      var l;
      let { defaultOptions: d } = a, { composed: y, noop: u } = r, { addEvent: m, correctFloat: h, defined: c, extend: g, fireEvent: v, isObject: P, merge: f, pick: S, pushUnique: w, relativeLength: x, wrap: k } = s;
      return function(A) {
        function $() {
          this.autoConnect = this.isCircular && S(this.userMax, this.options.max) === void 0 && h(this.endAngleRad - this.startAngleRad) === h(2 * Math.PI), !this.isCircular && this.chart.inverted && this.max++, this.autoConnect && (this.max += this.categories && 1 || this.pointRange || this.closestPointRange || 0);
        }
        function j() {
          return () => {
            if (this.isRadial && this.tickPositions && this.options.labels && this.options.labels.allowOverlap !== !0)
              return this.tickPositions.map((q) => this.ticks[q] && this.ticks[q].label).filter((q) => !!q);
          };
        }
        function N() {
          return u;
        }
        function M(q, Z, ne) {
          let ie = this.pane.center, re = q.value, de, me, ce;
          return this.isCircular ? (c(re) ? q.point && (q.point.shapeArgs || {}).start && (re = this.chart.inverted ? this.translate(q.point.rectPlotY, !0) : q.point.x) : (me = q.chartX || 0, ce = q.chartY || 0, re = this.translate(Math.atan2(ce - ne, me - Z) - this.startAngleRad, !0)), me = (de = this.getPosition(re)).x, ce = de.y) : (c(re) || (me = q.chartX, ce = q.chartY), c(me) && c(ce) && (ne = ie[1] + this.chart.plotTop, re = this.translate(Math.min(Math.sqrt(Math.pow(me - Z, 2) + Math.pow(ce - ne, 2)), ie[2] / 2) - ie[3] / 2, !0))), [re, me || 0, ce || 0];
        }
        function D(q, Z, ne) {
          let ie = this.pane.center, re = this.chart, de = this.left || 0, me = this.top || 0, ce, pe = S(Z, ie[2] / 2 - this.offset), xe;
          return ne === void 0 && (ne = this.horiz ? 0 : this.center && -this.center[3] / 2), ne && (pe += ne), this.isCircular || Z !== void 0 ? ((xe = this.chart.renderer.symbols.arc(de + ie[0], me + ie[1], pe, pe, { start: this.startAngleRad, end: this.endAngleRad, open: !0, innerR: 0 })).xBounds = [de + ie[0]], xe.yBounds = [me + ie[1] - pe]) : (ce = this.postTranslate(this.angleRad, pe), xe = [["M", this.center[0] + re.plotLeft, this.center[1] + re.plotTop], ["L", ce.x, ce.y]]), xe;
        }
        function C() {
          this.constructor.prototype.getOffset.call(this), this.chart.axisOffset[this.side] = 0;
        }
        function b(q, Z, ne) {
          let ie = this.chart, re = (_e) => {
            if (typeof _e == "string") {
              let He = parseInt(_e, 10);
              return se.test(_e) && (He = He * ce / 100), He;
            }
            return _e;
          }, de = this.center, me = this.startAngleRad, ce = de[2] / 2, pe = Math.min(this.offset, 0), xe = this.left || 0, le = this.top || 0, se = /%$/, he = this.isCircular, ve, ye, be, ke, we, Le, Me = S(re(ne.outerRadius), ce), De = re(ne.innerRadius), Ae = S(re(ne.thickness), 10);
          if (this.options.gridLineInterpolation === "polygon")
            Le = this.getPlotLinePath({ value: q }).concat(this.getPlotLinePath({ value: Z, reverse: !0 }));
          else {
            q = Math.max(q, this.min), Z = Math.min(Z, this.max);
            let _e = this.translate(q), He = this.translate(Z);
            he || (Me = _e || 0, De = He || 0), ne.shape !== "circle" && he ? (ve = me + (_e || 0), ye = me + (He || 0)) : (ve = -Math.PI / 2, ye = 1.5 * Math.PI, we = !0), Me -= pe, Ae -= pe, Le = ie.renderer.symbols.arc(xe + de[0], le + de[1], Me, Me, { start: Math.min(ve, ye), end: Math.max(ve, ye), innerR: S(De, Me - Ae), open: we, borderRadius: ne.borderRadius }), he && (be = (ye + ve) / 2, ke = xe + de[0] + de[2] / 2 * Math.cos(be), Le.xBounds = be > -Math.PI / 2 && be < Math.PI / 2 ? [ke, ie.plotWidth] : [0, ke], Le.yBounds = [le + de[1] + de[2] / 2 * Math.sin(be)], Le.yBounds[0] += be > -Math.PI && be < 0 || be > Math.PI ? -10 : 10);
          }
          return Le;
        }
        function p(q) {
          let Z = this.pane.center, ne = this.chart, ie = ne.inverted, re = q.reverse, de = this.pane.options.background ? this.pane.options.background[0] || this.pane.options.background : {}, me = de.innerRadius || "0%", ce = de.outerRadius || "100%", pe = Z[0] + ne.plotLeft, xe = Z[1] + ne.plotTop, le = this.height, se = q.isCrosshair, he = Z[3] / 2, ve = q.value, ye, be, ke, we, Le, Me, De, Ae, _e, He = this.getPosition(ve), Ee = He.x, Ne = He.y;
          if (se && (ve = (Ae = this.getCrosshairPosition(q, pe, xe))[0], Ee = Ae[1], Ne = Ae[2]), this.isCircular)
            be = Math.sqrt(Math.pow(Ee - pe, 2) + Math.pow(Ne - xe, 2)), ke = typeof me == "string" ? x(me, 1) : me / be, we = typeof ce == "string" ? x(ce, 1) : ce / be, Z && he && (ke < (ye = he / be) && (ke = ye), we < ye && (we = ye)), _e = [["M", pe + ke * (Ee - pe), xe - ke * (xe - Ne)], ["L", Ee - (1 - we) * (Ee - pe), Ne + (1 - we) * (xe - Ne)]];
          else if ((ve = this.translate(ve)) && (ve < 0 || ve > le) && (ve = 0), this.options.gridLineInterpolation === "circle")
            _e = this.getLinePath(0, ve, he);
          else if (_e = [], ne[ie ? "yAxis" : "xAxis"].forEach((Ye) => {
            Ye.pane === this.pane && (Le = Ye);
          }), Le) {
            De = Le.tickPositions, Le.autoConnect && (De = De.concat([De[0]])), re && (De = De.slice().reverse()), ve && (ve += he);
            for (let Ye = 0; Ye < De.length; Ye++)
              Me = Le.getPosition(De[Ye], ve), _e.push(Ye ? ["L", Me.x, Me.y] : ["M", Me.x, Me.y]);
          }
          return _e;
        }
        function L(q, Z) {
          let ne = this.translate(q);
          return this.postTranslate(this.isCircular ? ne : this.angleRad, S(this.isCircular ? Z : ne < 0 ? 0 : ne, this.center[2] / 2) - this.offset);
        }
        function B() {
          let q = this.center, Z = this.chart, ne = this.options.title;
          return { x: Z.plotLeft + q[0] + (ne.x || 0), y: Z.plotTop + q[1] - { high: 0.5, middle: 0.25, low: 0 }[ne.align] * q[2] + (ne.y || 0) };
        }
        function T(q) {
          q.beforeSetTickPositions = $, q.createLabelCollector = j, q.getCrosshairPosition = M, q.getLinePath = D, q.getOffset = C, q.getPlotBandPath = b, q.getPlotLinePath = p, q.getPosition = L, q.getTitlePosition = B, q.postTranslate = ee, q.setAxisSize = G, q.setAxisTranslation = W, q.setOptions = ae;
        }
        function O() {
          let q = this.chart, Z = this.options, ne = q.angular && this.isXAxis, ie = this.pane, re = ie && ie.options;
          if (!ne && ie && (q.angular || q.polar)) {
            let de = 2 * Math.PI, me = (S(re.startAngle, 0) - 90) * Math.PI / 180, ce = (S(re.endAngle, S(re.startAngle, 0) + 360) - 90) * Math.PI / 180;
            this.angleRad = (Z.angle || 0) * Math.PI / 180, this.startAngleRad = me, this.endAngleRad = ce, this.offset = Z.offset || 0;
            let pe = (me % de + de) % de, xe = (ce % de + de) % de;
            pe > Math.PI && (pe -= de), xe > Math.PI && (xe -= de), this.normalizedStartAngleRad = pe, this.normalizedEndAngleRad = xe;
          }
        }
        function I(q) {
          this.isRadial && (q.align = void 0, q.preventDefault());
        }
        function R() {
          if (this.chart && this.chart.labelCollectors) {
            let q = this.labelCollector ? this.chart.labelCollectors.indexOf(this.labelCollector) : -1;
            q >= 0 && this.chart.labelCollectors.splice(q, 1);
          }
        }
        function Y(q) {
          let Z, ne = this.chart, ie = ne.angular, re = ne.polar, de = this.isXAxis, me = this.coll, ce = q.userOptions.pane || 0, pe = this.pane = ne.pane && ne.pane[ce];
          if (me === "colorAxis") {
            this.isRadial = !1;
            return;
          }
          ie ? (ie && de ? (this.isHidden = !0, this.createLabelCollector = N, this.getOffset = u, this.redraw = V, this.render = V, this.setScale = u, this.setCategories = u, this.setTitle = u) : T(this), Z = !de) : re && (T(this), Z = this.horiz), ie || re ? (this.isRadial = !0, this.labelCollector || (this.labelCollector = this.createLabelCollector()), this.labelCollector && ne.labelCollectors.push(this.labelCollector)) : this.isRadial = !1, pe && Z && (pe.axis = this), this.isCircular = Z;
        }
        function F() {
          this.isRadial && this.beforeSetTickPositions();
        }
        function U(q) {
          let Z = this.label;
          if (!Z)
            return;
          let ne = this.axis, ie = Z.getBBox(), re = ne.options.labels, de = (ne.translate(this.pos) + ne.startAngleRad + Math.PI / 2) / Math.PI * 180 % 360, me = Math.round(de), ce = c(re.y) ? 0 : -(0.3 * ie.height), pe = re.y, xe, le = 20, se = re.align, he = "end", ve = me < 0 ? me + 360 : me, ye = ve, be = 0, ke = 0;
          ne.isRadial && (xe = ne.getPosition(this.pos, ne.center[2] / 2 + x(S(re.distance, -25), ne.center[2] / 2, -ne.center[2] / 2)), re.rotation === "auto" ? Z.attr({ rotation: de }) : c(pe) || (pe = ne.chart.renderer.fontMetrics(Z).b - ie.height / 2), c(se) || (ne.isCircular ? (ie.width > ne.len * ne.tickInterval / (ne.max - ne.min) && (le = 0), se = de > le && de < 180 - le ? "left" : de > 180 + le && de < 360 - le ? "right" : "center") : se = "center", Z.attr({ align: se })), se === "auto" && ne.tickPositions.length === 2 && ne.isCircular && (ve > 90 && ve < 180 ? ve = 180 - ve : ve > 270 && ve <= 360 && (ve = 540 - ve), ye > 180 && ye <= 360 && (ye = 360 - ye), (ne.pane.options.startAngle === me || ne.pane.options.startAngle === me + 360 || ne.pane.options.startAngle === me - 360) && (he = "start"), se = me >= -90 && me <= 90 || me >= -360 && me <= -270 || me >= 270 && me <= 360 ? he === "start" ? "right" : "left" : he === "start" ? "left" : "right", ye > 70 && ye < 110 && (se = "center"), ve < 15 || ve >= 180 && ve < 195 ? be = 0.3 * ie.height : ve >= 15 && ve <= 35 ? be = he === "start" ? 0 : 0.75 * ie.height : ve >= 195 && ve <= 215 ? be = he === "start" ? 0.75 * ie.height : 0 : ve > 35 && ve <= 90 ? be = he === "start" ? -(0.25 * ie.height) : ie.height : ve > 215 && ve <= 270 && (be = he === "start" ? ie.height : -(0.25 * ie.height)), ye < 15 ? ke = he === "start" ? -(0.15 * ie.height) : 0.15 * ie.height : ye > 165 && ye <= 180 && (ke = he === "start" ? 0.15 * ie.height : -(0.15 * ie.height)), Z.attr({ align: se }), Z.translate(ke, be + ce)), q.pos.x = xe.x + (re.x || 0), q.pos.y = xe.y + (pe || 0));
        }
        function Q(q) {
          this.axis.getPosition && g(q.pos, this.axis.getPosition(this.pos));
        }
        function J({ options: q }) {
          q.xAxis && f(!0, A.radialDefaultOptions.circular, q.xAxis), q.yAxis && f(!0, A.radialDefaultOptions.radialGauge, q.yAxis);
        }
        function ee(q, Z) {
          let ne = this.chart, ie = this.center;
          return q = this.startAngleRad + q, { x: ne.plotLeft + ie[0] + Math.cos(q) * Z, y: ne.plotTop + ie[1] + Math.sin(q) * Z };
        }
        function V() {
          this.isDirty = !1;
        }
        function G() {
          let q, Z;
          this.constructor.prototype.setAxisSize.call(this), this.isRadial && (this.pane.updateCenter(this), q = this.center = this.pane.center.slice(), this.isCircular ? this.sector = this.endAngleRad - this.startAngleRad : (Z = this.postTranslate(this.angleRad, q[3] / 2), q[0] = Z.x - this.chart.plotLeft, q[1] = Z.y - this.chart.plotTop), this.len = this.width = this.height = (q[2] - q[3]) * S(this.sector, 1) / 2);
        }
        function W() {
          this.constructor.prototype.setAxisTranslation.call(this), this.center && (this.isCircular ? this.transA = (this.endAngleRad - this.startAngleRad) / (this.max - this.min || 1) : this.transA = (this.center[2] - this.center[3]) / 2 / (this.max - this.min || 1), this.isXAxis ? this.minPixelPadding = this.transA * this.minPointOffset : this.minPixelPadding = 0);
        }
        function ae(q) {
          let { coll: Z } = this, { angular: ne, inverted: ie, polar: re } = this.chart, de = {};
          ne ? this.isXAxis || (de = f(d.yAxis, A.radialDefaultOptions.radialGauge)) : re && (de = this.horiz ? f(d.xAxis, A.radialDefaultOptions.circular) : f(Z === "xAxis" ? d.xAxis : d.yAxis, A.radialDefaultOptions.radial)), ie && Z === "yAxis" && (de.stackLabels = P(d.yAxis, !0) ? d.yAxis.stackLabels : {}, de.reversedStacks = !0);
          let me = this.options = f(de, q);
          me.plotBands || (me.plotBands = []), v(this, "afterSetOptions");
        }
        function z(q, Z, ne, ie, re, de, me) {
          let ce, pe = this.axis;
          return pe.isRadial ? ["M", Z, ne, "L", (ce = pe.getPosition(this.pos, pe.center[2] / 2 + ie)).x, ce.y] : q.call(this, Z, ne, ie, re, de, me);
        }
        A.radialDefaultOptions = f(o), A.compose = function(q, Z) {
          return w(y, "Axis.Radial") && (m(q, "afterInit", O), m(q, "autoLabelAlign", I), m(q, "destroy", R), m(q, "init", Y), m(q, "initialAxisTranslation", F), m(Z, "afterGetLabelPosition", U), m(Z, "afterGetPosition", Q), m(r, "setOptions", J), k(Z.prototype, "getMarkPath", z)), q;
        };
      }(l || (l = {})), l;
    }), i(n, "Series/PolarComposition.js", [n["Core/Animation/AnimationUtilities.js"], n["Core/Globals.js"], n["Core/Series/Series.js"], n["Extensions/Pane/Pane.js"], n["Core/Axis/RadialAxis.js"], n["Core/Utilities.js"]], function(o, a, r, s, l, d) {
      let { animObject: y } = o, { composed: u } = a, { addEvent: m, defined: h, find: c, isNumber: g, merge: v, pick: P, pushUnique: f, relativeLength: S, splat: w, uniqueKey: x, wrap: k } = d;
      function A() {
        (this.pane || []).forEach((J) => {
          J.render();
        });
      }
      function $(J) {
        let ee = J.args[0].xAxis, V = J.args[0].yAxis, G = J.args[0].chart;
        ee && V && (V.gridLineInterpolation === "polygon" ? (ee.startOnTick = !0, ee.endOnTick = !0) : ee.gridLineInterpolation === "polygon" && G.inverted && (V.startOnTick = !0, V.endOnTick = !0));
      }
      function j() {
        this.pane || (this.pane = []), this.options.pane = w(this.options.pane), this.options.pane.forEach((J) => {
          new s(J, this);
        }, this);
      }
      function N(J) {
        let ee = J.args.marker, V = this.chart.xAxis[0], G = this.chart.yAxis[0], W = this.chart.inverted, ae = W ? G : V, z = W ? V : G;
        if (this.chart.polar) {
          J.preventDefault();
          let q = (ee.attr ? ee.attr("start") : ee.start) - ae.startAngleRad, Z = ee.attr ? ee.attr("r") : ee.r, ne = (ee.attr ? ee.attr("end") : ee.end) - ae.startAngleRad, ie = ee.attr ? ee.attr("innerR") : ee.innerR;
          J.result.x = q + ae.pos, J.result.width = ne - q, J.result.y = z.len + z.pos - Z, J.result.height = Z - ie;
        }
      }
      function M(J) {
        let ee = this.chart;
        if (ee.polar && ee.hoverPane && ee.hoverPane.axis) {
          J.preventDefault();
          let V = ee.hoverPane.center, G = ee.mouseDownX || 0, W = ee.mouseDownY || 0, ae = J.args.chartY, z = J.args.chartX, q = 2 * Math.PI, Z = ee.hoverPane.axis.startAngleRad, ne = ee.hoverPane.axis.endAngleRad, ie = ee.inverted ? ee.xAxis[0] : ee.yAxis[0], re = {}, de = "arc";
          if (re.x = V[0] + ee.plotLeft, re.y = V[1] + ee.plotTop, this.zoomHor) {
            let me = Z > 0 ? ne - Z : Math.abs(Z) + Math.abs(ne), ce = Math.atan2(W - ee.plotTop - V[1], G - ee.plotLeft - V[0]) - Z, pe = Math.atan2(ae - ee.plotTop - V[1], z - ee.plotLeft - V[0]) - Z;
            re.r = V[2] / 2, re.innerR = V[3] / 2, ce <= 0 && (ce += q), pe <= 0 && (pe += q), pe < ce && (pe = [ce, ce = pe][0]), me < q && Z + pe > ne + (q - me) / 2 && (pe = ce, ce = Z <= 0 ? Z : 0);
            let xe = re.start = Math.max(ce + Z, Z), le = re.end = Math.min(pe + Z, ne);
            if (ie.options.gridLineInterpolation === "polygon") {
              let se = ee.hoverPane.axis, he = xe - se.startAngleRad + se.pos, ve = ie.getPlotLinePath({ value: ie.max }), ye = se.toValue(he), be = se.toValue(he + (le - xe));
              if (ye < se.getExtremes().min) {
                let { min: ke, max: we } = se.getExtremes();
                ye = we - (ke - ye);
              }
              if (be < se.getExtremes().min) {
                let { min: ke, max: we } = se.getExtremes();
                be = we - (ke - be);
              }
              be < ye && (be = [ye, ye = be][0]), (ve = p(ve, ye, be, se)).push(["L", V[0] + ee.plotLeft, ee.plotTop + V[1]]), re.d = ve, de = "path";
            }
          }
          if (this.zoomVert) {
            let me = ee.inverted ? ee.xAxis[0] : ee.yAxis[0], ce = Math.sqrt(Math.pow(G - ee.plotLeft - V[0], 2) + Math.pow(W - ee.plotTop - V[1], 2)), pe = Math.sqrt(Math.pow(z - ee.plotLeft - V[0], 2) + Math.pow(ae - ee.plotTop - V[1], 2));
            if (pe < ce && (ce = [pe, pe = ce][0]), pe > V[2] / 2 && (pe = V[2] / 2), ce < V[3] / 2 && (ce = V[3] / 2), this.zoomHor || (re.start = Z, re.end = ne), re.r = pe, re.innerR = ce, me.options.gridLineInterpolation === "polygon") {
              let xe = me.toValue(me.len + me.pos - ce), le = me.toValue(me.len + me.pos - pe), se = me.getPlotLinePath({ value: le }).concat(me.getPlotLinePath({ value: xe, reverse: !0 }));
              re.d = se, de = "path";
            }
          }
          if (this.zoomHor && this.zoomVert && ie.options.gridLineInterpolation === "polygon") {
            let me = ee.hoverPane.axis, ce = re.start || 0, pe = re.end || 0, xe = ce - me.startAngleRad + me.pos, le = me.toValue(xe), se = me.toValue(xe + (pe - ce));
            if (re.d instanceof Array) {
              let he = re.d.slice(0, re.d.length / 2), ve = re.d.slice(re.d.length / 2, re.d.length);
              ve = [...ve].reverse();
              let ye = ee.hoverPane.axis;
              he = p(he, le, se, ye), (ve = p(ve, le, se, ye)) && (ve[0][0] = "L"), ve = [...ve].reverse(), re.d = he.concat(ve), de = "path";
            }
          }
          J.attrs = re, J.shapeType = de;
        }
      }
      function D() {
        let J = this.chart;
        J.polar && (this.polar = new Q(this), J.inverted && (this.isRadialSeries = !0, this.is("column") && (this.isRadialBar = !0)));
      }
      function C() {
        if (this.chart.polar && this.xAxis) {
          let { xAxis: J, yAxis: ee } = this, V = this.chart;
          this.kdByAngle = V.tooltip && V.tooltip.shared, this.kdByAngle || V.inverted ? this.searchPoint = b : this.options.findNearestPointBy = "xy";
          let G = this.points, W = G.length;
          for (; W--; )
            this.is("column") || this.is("columnrange") || this.polar.toXY(G[W]), V.hasParallelCoordinates || this.yAxis.reversed || (P(G[W].y, Number.MIN_VALUE) < ee.min || G[W].x < J.min || G[W].x > J.max ? (G[W].isNull = !0, G[W].plotY = NaN) : G[W].isNull = G[W].isValid && !G[W].isValid());
          this.hasClipCircleSetter || (this.hasClipCircleSetter = !!this.eventsToUnbind.push(m(this, "afterRender", function() {
            let ae;
            V.polar && this.options.clip !== !1 && (ae = this.yAxis.pane.center, this.clipCircle ? this.clipCircle.animate({ x: ae[0], y: ae[1], r: ae[2] / 2, innerR: ae[3] / 2 }) : this.clipCircle = function(z, q, Z, ne, ie) {
              let re = x(), de = z.createElement("clipPath").attr({ id: re }).add(z.defs), me = ie ? z.arc(q, Z, ne, ie, 0, 2 * Math.PI).add(de) : z.circle(q, Z, ne).add(de);
              return me.id = re, me.clipPath = de, me;
            }(V.renderer, ae[0], ae[1], ae[2] / 2, ae[3] / 2), this.group.clip(this.clipCircle), this.setClip = a.noop);
          })));
        }
      }
      function b(J) {
        let ee = this.chart, V = this.xAxis, G = this.yAxis, W = V.pane && V.pane.center, ae = J.chartX - (W && W[0] || 0) - ee.plotLeft, z = J.chartY - (W && W[1] || 0) - ee.plotTop, q = ee.inverted ? { clientX: J.chartX - G.pos, plotY: J.chartY - V.pos } : { clientX: 180 + -180 / Math.PI * Math.atan2(ae, z) };
        return this.searchKDTree(q);
      }
      function p(J, ee, V, G) {
        let W = G.tickInterval, ae = G.tickPositions, z = c(ae, (Z) => Z >= V), q = c([...ae].reverse(), (Z) => Z <= ee);
        return h(z) || (z = ae[ae.length - 1]), h(q) || (q = ae[0], z += W, J[0][0] = "L", J.unshift(J[J.length - 3])), (J = J.slice(ae.indexOf(q), ae.indexOf(z) + 1))[0][0] = "M", J;
      }
      function L(J, ee) {
        return c(this.pane || [], (V) => V.options.id === ee) || J.call(this, ee);
      }
      function B(J, ee, V, G, W, ae) {
        let z, q, Z, ne = this.chart, ie = P(G.inside, !!this.options.stacking);
        if (ne.polar) {
          if (z = ee.rectPlotX / Math.PI * 180, ne.inverted)
            this.forceDL = ne.isInsidePlot(ee.plotX, ee.plotY), ie && ee.shapeArgs ? (q = ee.shapeArgs, W = v(W, { x: (Z = this.yAxis.postTranslate(((q.start || 0) + (q.end || 0)) / 2 - this.xAxis.startAngleRad, ee.barX + ee.pointWidth / 2)).x - ne.plotLeft, y: Z.y - ne.plotTop })) : ee.tooltipPos && (W = v(W, { x: ee.tooltipPos[0], y: ee.tooltipPos[1] })), G.align = P(G.align, "center"), G.verticalAlign = P(G.verticalAlign, "middle");
          else {
            var re;
            let de, me;
            (re = G).align === null && (de = z > 20 && z < 160 ? "left" : z > 200 && z < 340 ? "right" : "center", re.align = de), re.verticalAlign === null && (me = z < 45 || z > 315 ? "bottom" : z > 135 && z < 225 ? "top" : "middle", re.verticalAlign = me), G = re;
          }
          r.prototype.alignDataLabel.call(this, ee, V, G, W, ae), this.isRadialBar && ee.shapeArgs && ee.shapeArgs.start === ee.shapeArgs.end ? V.hide() : V.show();
        } else
          J.call(this, ee, V, G, W, ae);
      }
      function T() {
        let J = this.options, ee = J.stacking, V = this.chart, G = this.xAxis, W = this.yAxis, ae = W.reversed, z = W.center, q = G.startAngleRad, Z = G.endAngleRad - q, ne = J.threshold, ie = 0, re, de, me, ce, pe, xe = 0, le = 0, se, he, ve, ye, be, ke, we, Le;
        if (G.isRadial)
          for (me = (re = this.points).length, ce = W.translate(W.min), pe = W.translate(W.max), ne = J.threshold || 0, V.inverted && g(ne) && h(ie = W.translate(ne)) && (ie < 0 ? ie = 0 : ie > Z && (ie = Z), this.translatedThreshold = ie + q); me--; ) {
            if (ke = (de = re[me]).barX, he = de.x, ve = de.y, de.shapeType = "arc", V.inverted) {
              de.plotY = W.translate(ve), ee && W.stacking ? (be = W.stacking.stacks[(ve < 0 ? "-" : "") + this.stackKey], this.visible && be && be[he] && !de.isNull && (ye = be[he].points[this.getStackIndicator(void 0, he, this.index).key], xe = W.translate(ye[0]), le = W.translate(ye[1]), h(xe) && (xe = d.clamp(xe, 0, Z)))) : (xe = ie, le = de.plotY), xe > le && (le = [xe, xe = le][0]), ae ? le > ce ? le = ce : xe < pe ? xe = pe : (xe > ce || le < pe) && (xe = le = Z) : xe < ce ? xe = ce : le > pe ? le = pe : (le < ce || xe > pe) && (xe = le = 0), W.min > W.max && (xe = le = ae ? Z : 0), xe += q, le += q, z && (de.barX = ke += z[3] / 2), we = Math.max(ke, 0), Le = Math.max(ke + de.pointWidth, 0);
              let Me = J.borderRadius, De = S((typeof Me == "object" ? Me.radius : Me) || 0, Le - we);
              de.shapeArgs = { x: z[0], y: z[1], r: Le, innerR: we, start: xe, end: le, borderRadius: De }, de.opacity = xe === le ? 0 : void 0, de.plotY = (h(this.translatedThreshold) && (xe < this.translatedThreshold ? xe : le)) - q;
            } else
              xe = ke + q, de.shapeArgs = this.polar.arc(de.yBottom, de.plotY, xe, xe + de.pointWidth), de.shapeArgs.borderRadius = 0;
            this.polar.toXY(de), V.inverted ? (se = W.postTranslate(de.rectPlotY, ke + de.pointWidth / 2), de.tooltipPos = [se.x - V.plotLeft, se.y - V.plotTop]) : de.tooltipPos = [de.plotX, de.plotY], z && (de.ttBelow = de.plotY > z[1]);
          }
      }
      function O(J, ee) {
        let V, G, W = this;
        if (this.chart.polar) {
          ee = ee || this.points;
          for (let z = 0; z < ee.length; z++)
            if (!ee[z].isNull) {
              V = z;
              break;
            }
          this.options.connectEnds !== !1 && V !== void 0 && (this.connectEnds = !0, ee.splice(ee.length, 0, ee[V]), G = !0), ee.forEach((z) => {
            z.polarPlotY === void 0 && W.polar.toXY(z);
          });
        }
        let ae = J.apply(this, [].slice.call(arguments, 1));
        return G && ee.pop(), ae;
      }
      function I(J, ee) {
        let V = this.chart, G = { xAxis: [], yAxis: [] };
        return V.polar ? V.axes.forEach((W) => {
          if (W.coll === "colorAxis")
            return;
          let ae = W.isXAxis, z = W.center, q = ee.chartX - z[0] - V.plotLeft, Z = ee.chartY - z[1] - V.plotTop;
          G[ae ? "xAxis" : "yAxis"].push({ axis: W, value: W.translate(ae ? Math.PI - Math.atan2(q, Z) : Math.sqrt(Math.pow(q, 2) + Math.pow(Z, 2)), !0) });
        }) : G = J.call(this, ee), G;
      }
      function R(J, ee) {
        this.chart.polar || J.call(this, ee);
      }
      function Y(J, ee) {
        let V = this, G = this.chart, W = this.group, ae = this.markerGroup, z = this.xAxis && this.xAxis.center, q = G.plotLeft, Z = G.plotTop, ne = this.options.animation, ie, re, de, me, ce, pe;
        G.polar ? V.isRadialBar ? ee || (V.startAngleRad = P(V.translatedThreshold, V.xAxis.startAngleRad), a.seriesTypes.pie.prototype.animate.call(V, ee)) : (ne = y(ne), V.is("column") ? ee || (re = z[3] / 2, V.points.forEach((xe) => {
          de = xe.graphic, ce = (me = xe.shapeArgs) && me.r, pe = me && me.innerR, de && me && (de.attr({ r: re, innerR: re }), de.animate({ r: ce, innerR: pe }, V.options.animation));
        })) : ee ? (ie = { translateX: z[0] + q, translateY: z[1] + Z, scaleX: 1e-3, scaleY: 1e-3 }, W.attr(ie), ae && ae.attr(ie)) : (ie = { translateX: q, translateY: Z, scaleX: 1, scaleY: 1 }, W.animate(ie, ne), ae && ae.animate(ie, ne))) : J.call(this, ee);
      }
      function F(J, ee, V, G) {
        let W, ae;
        if (this.chart.polar)
          if (G) {
            let z = (ae = function Z(ne, ie, re, de) {
              let me, ce, pe, xe, le, se, he = de ? 1 : 0, ve = (me = ie >= 0 && ie <= ne.length - 1 ? ie : ie < 0 ? ne.length - 1 + ie : 0) - 1 < 0 ? ne.length - (1 + he) : me - 1, ye = me + 1 > ne.length - 1 ? he : me + 1, be = ne[ve], ke = ne[ye], we = be.plotX, Le = be.plotY, Me = ke.plotX, De = ke.plotY, Ae = ne[me].plotX, _e = ne[me].plotY;
              ce = (1.5 * Ae + we) / 2.5, pe = (1.5 * _e + Le) / 2.5, xe = (1.5 * Ae + Me) / 2.5, le = (1.5 * _e + De) / 2.5;
              let He = Math.sqrt(Math.pow(ce - Ae, 2) + Math.pow(pe - _e, 2)), Ee = Math.sqrt(Math.pow(xe - Ae, 2) + Math.pow(le - _e, 2)), Ne = Math.atan2(pe - _e, ce - Ae);
              se = Math.PI / 2 + (Ne + Math.atan2(le - _e, xe - Ae)) / 2, Math.abs(Ne - se) > Math.PI / 2 && (se -= Math.PI), ce = Ae + Math.cos(se) * He, pe = _e + Math.sin(se) * He;
              let Ye = { rightContX: xe = Ae + Math.cos(Math.PI + se) * Ee, rightContY: le = _e + Math.sin(Math.PI + se) * Ee, leftContX: ce, leftContY: pe, plotX: Ae, plotY: _e };
              return re && (Ye.prevPointCont = Z(ne, ve, !1, de)), Ye;
            }(ee, G, !0, this.connectEnds)).prevPointCont && ae.prevPointCont.rightContX, q = ae.prevPointCont && ae.prevPointCont.rightContY;
            W = ["C", g(z) ? z : ae.plotX, g(q) ? q : ae.plotY, g(ae.leftContX) ? ae.leftContX : ae.plotX, g(ae.leftContY) ? ae.leftContY : ae.plotY, ae.plotX, ae.plotY];
          } else
            W = ["M", V.plotX, V.plotY];
        else
          W = J.call(this, ee, V, G);
        return W;
      }
      function U(J, ee, V = this.plotY) {
        if (!this.destroyed) {
          let { plotX: G, series: W } = this, { chart: ae } = W;
          return ae.polar && g(G) && g(V) ? [G + (ee ? ae.plotLeft : 0), V + (ee ? ae.plotTop : 0)] : J.call(this, ee, V);
        }
      }
      class Q {
        static compose(ee, V, G, W, ae, z, q, Z, ne, ie) {
          if (s.compose(V, G), l.compose(ee, ae), f(u, "Polar")) {
            let re = V.prototype, de = z.prototype, me = G.prototype, ce = W.prototype;
            if (m(V, "afterDrawChartBox", A), m(V, "getAxes", j), m(V, "init", $), k(re, "get", L), k(me, "getCoordinates", I), k(me, "pinch", R), m(G, "getSelectionMarkerAttrs", M), m(G, "getSelectionBox", N), m(W, "afterInit", D), m(W, "afterTranslate", C, { order: 2 }), m(W, "afterColumnTranslate", T, { order: 4 }), k(ce, "animate", Y), k(de, "pos", U), Z) {
              let pe = Z.prototype;
              k(pe, "alignDataLabel", B), k(pe, "animate", Y);
            }
            if (ne && k(ne.prototype, "getGraphPath", O), ie) {
              let pe = ie.prototype;
              k(pe, "getPointSpline", F), q && (q.prototype.getPointSpline = pe.getPointSpline);
            }
          }
        }
        constructor(ee) {
          this.series = ee;
        }
        arc(ee, V, G, W) {
          let ae = this.series, z = ae.xAxis.center, q = ae.yAxis.len, Z = z[3] / 2, ne = q - V + Z, ie = q - P(ee, q) + Z;
          return ae.yAxis.reversed && (ne < 0 && (ne = Z), ie < 0 && (ie = Z)), { x: z[0], y: z[1], r: ne, innerR: ie, start: G, end: W };
        }
        toXY(ee) {
          let V = this.series, G = V.chart, W = V.xAxis, ae = V.yAxis, z = ee.plotX, q = G.inverted, Z = ee.y, ne = ee.plotY, ie = q ? z : ae.len - ne, re;
          if (q && V && !V.isRadialBar && (ee.plotY = ne = g(Z) ? ae.translate(Z) : 0), ee.rectPlotX = z, ee.rectPlotY = ne, ae.center && (ie += ae.center[3] / 2), g(ne)) {
            let de = q ? ae.postTranslate(ne, ie) : W.postTranslate(z, ie);
            ee.plotX = ee.polarPlotX = de.x - G.plotLeft, ee.plotY = ee.polarPlotY = de.y - G.plotTop;
          }
          V.kdByAngle ? ((re = (z / Math.PI * 180 + W.pane.options.startAngle) % 360) < 0 && (re += 360), ee.clientX = re) : ee.clientX = ee.plotX;
        }
      }
      return Q;
    }), i(n, "Core/Axis/WaterfallAxis.js", [n["Core/Globals.js"], n["Core/Axis/Stacking/StackItem.js"], n["Core/Utilities.js"]], function(o, a, r) {
      var s;
      let { composed: l } = o, { addEvent: d, objectEach: y, pushUnique: u } = r;
      return function(m) {
        function h() {
          let f = this.waterfall.stacks;
          f && (f.changed = !1, delete f.alreadyChanged);
        }
        function c() {
          let f = this.options.stackLabels;
          f && f.enabled && this.waterfall.stacks && this.waterfall.renderStackTotals();
        }
        function g() {
          this.waterfall || (this.waterfall = new P(this));
        }
        function v() {
          let f = this.axes;
          for (let S of this.series)
            if (S.options.stacking) {
              for (let w of f)
                w.isXAxis || (w.waterfall.stacks.changed = !0);
              break;
            }
        }
        m.compose = function(f, S) {
          u(l, "Axis.Waterfall") && (d(f, "init", g), d(f, "afterBuildStacks", h), d(f, "afterRender", c), d(S, "beforeRedraw", v));
        };
        class P {
          constructor(S) {
            this.axis = S, this.stacks = { changed: !1 };
          }
          renderStackTotals() {
            let S = this.axis, w = S.waterfall.stacks, x = S.stacking && S.stacking.stackTotalGroup, k = new a(S, S.options.stackLabels || {}, !1, 0, void 0);
            this.dummyStackItem = k, x && y(w, (A) => {
              y(A, ($, j) => {
                k.total = $.stackTotal, k.x = +j, $.label && (k.label = $.label), a.prototype.render.call(k, x), $.label = k.label, delete k.label;
              });
            }), k.total = null;
          }
        }
        m.Composition = P;
      }(s || (s = {})), s;
    }), i(n, "Series/Waterfall/WaterfallPoint.js", [n["Series/Column/ColumnSeries.js"], n["Core/Series/Point.js"], n["Core/Utilities.js"]], function(o, a, r) {
      let { isNumber: s } = r;
      class l extends o.prototype.pointClass {
        getClassName() {
          let y = a.prototype.getClassName.call(this);
          return this.isSum ? y += " highcharts-sum" : this.isIntermediateSum && (y += " highcharts-intermediate-sum"), y;
        }
        isValid() {
          return s(this.y) || this.isSum || !!this.isIntermediateSum;
        }
      }
      return l;
    }), i(n, "Series/Waterfall/WaterfallSeriesDefaults.js", [], function() {
      return { dataLabels: { inside: !0 }, lineWidth: 1, lineColor: "#333333", dashStyle: "Dot", borderColor: "#333333", states: { hover: { lineWidthPlus: 0 } } };
    }), i(n, "Series/Waterfall/WaterfallSeries.js", [n["Core/Series/SeriesRegistry.js"], n["Core/Utilities.js"], n["Core/Axis/WaterfallAxis.js"], n["Series/Waterfall/WaterfallPoint.js"], n["Series/Waterfall/WaterfallSeriesDefaults.js"]], function(o, a, r, s, l) {
      let { column: d, line: y } = o.seriesTypes, { addEvent: u, arrayMax: m, arrayMin: h, correctFloat: c, crisp: g, extend: v, isNumber: P, merge: f, objectEach: S, pick: w } = a;
      function x(A, $) {
        return Object.hasOwnProperty.call(A, $);
      }
      class k extends d {
        generatePoints() {
          d.prototype.generatePoints.apply(this);
          for (let $ = 0, j = this.points.length; $ < j; $++) {
            let N = this.points[$], M = this.processedYData[$];
            P(M) && (N.isIntermediateSum || N.isSum) && (N.y = c(M));
          }
        }
        processData($) {
          let j, N, M, D, C, b, p = this.options, L = this.yData, B = p.data, T = L.length, O = p.threshold || 0;
          M = N = D = C = 0;
          for (let I = 0; I < T; I++)
            b = L[I], j = B && B[I] ? B[I] : {}, b === "sum" || j.isSum ? L[I] = c(M) : b === "intermediateSum" || j.isIntermediateSum ? (L[I] = c(N), N = 0) : (M += b, N += b), D = Math.min(M, D), C = Math.max(M, C);
          super.processData.call(this, $), p.stacking || (this.dataMin = D + O, this.dataMax = C);
        }
        toYData($) {
          return $.isSum ? "sum" : $.isIntermediateSum ? "intermediateSum" : $.y;
        }
        updateParallelArrays($, j) {
          super.updateParallelArrays.call(this, $, j), (this.yData[0] === "sum" || this.yData[0] === "intermediateSum") && (this.yData[0] = null);
        }
        pointAttribs($, j) {
          let N = this.options.upColor;
          N && !$.options.color && P($.y) && ($.color = $.y > 0 ? N : void 0);
          let M = d.prototype.pointAttribs.call(this, $, j);
          return delete M.dashstyle, M;
        }
        getGraphPath() {
          return [["M", 0, 0]];
        }
        getCrispPath() {
          let $ = this.data.filter((L) => P(L.y)), j = this.yAxis, N = $.length, M = this.graph?.strokeWidth() || 0, D = this.xAxis.reversed, C = this.yAxis.reversed, b = this.options.stacking, p = [];
          for (let L = 1; L < N; L++) {
            if (!(this.options.connectNulls || P(this.data[$[L].index - 1].y)))
              continue;
            let B = $[L].box, T = $[L - 1], O = T.y || 0, I = $[L - 1].box;
            if (!B || !I)
              continue;
            let R = j.waterfall.stacks[this.stackKey], Y = O > 0 ? -I.height : 0;
            if (R && I && B) {
              let F, U = R[L - 1];
              if (b) {
                let Q = U.connectorThreshold;
                F = g(j.translate(Q, !1, !0, !1, !0) + (C ? Y : 0), M);
              } else
                F = g(I.y + (T.minPointLengthOffset || 0), M);
              p.push(["M", (I.x || 0) + (D ? 0 : I.width || 0), F], ["L", (B.x || 0) + (D && B.width || 0), F]);
            }
            if (I && p.length && (!b && O < 0 && !C || O > 0 && C)) {
              let F = p[p.length - 2];
              F && typeof F[2] == "number" && (F[2] += I.height || 0);
              let U = p[p.length - 1];
              U && typeof U[2] == "number" && (U[2] += I.height || 0);
            }
          }
          return p;
        }
        drawGraph() {
          y.prototype.drawGraph.call(this), this.graph && this.graph.attr({ d: this.getCrispPath() });
        }
        setStackedPoints($) {
          let j = this.options, N = $.waterfall?.stacks, M = j.threshold || 0, D = this.stackKey, C = this.xData, b = C.length, p = M, L = p, B, T = 0, O = 0, I = 0, R, Y, F, U, Q, J, ee, V, G = (W, ae, z, q) => {
            if (B) {
              if (R)
                for (; z < R; z++)
                  B.stackState[z] += q;
              else
                B.stackState[0] = W, R = B.stackState.length;
              B.stackState.push(B.stackState[R - 1] + ae);
            }
          };
          if ($.stacking && N && this.reserveSpace()) {
            V = N.changed, (ee = N.alreadyChanged) && 0 > ee.indexOf(D) && (V = !0), N[D] || (N[D] = {});
            let W = N[D];
            if (W)
              for (let ae = 0; ae < b; ae++)
                (!W[J = C[ae]] || V) && (W[J] = { negTotal: 0, posTotal: 0, stackTotal: 0, threshold: 0, stateIndex: 0, stackState: [], label: V && W[J] ? W[J].label : void 0 }), B = W[J], (Q = this.yData[ae]) >= 0 ? B.posTotal += Q : B.negTotal += Q, U = j.data[ae], Y = B.absolutePos = B.posTotal, F = B.absoluteNeg = B.negTotal, B.stackTotal = Y + F, R = B.stackState.length, U && U.isIntermediateSum ? (G(I, O, 0, I), I = O, O = M, p ^= L, L ^= p, p ^= L) : U && U.isSum ? (G(M, T, R, 0), p = M) : (G(p, Q, 0, T), U && (T += Q, O += Q)), B.stateIndex++, B.threshold = p, p += B.stackTotal;
            N.changed = !1, N.alreadyChanged || (N.alreadyChanged = []), N.alreadyChanged.push(D);
          }
        }
        getExtremes() {
          let $, j, N, M = this.options.stacking;
          return M ? ($ = this.yAxis.waterfall.stacks, j = this.stackedYNeg = [], N = this.stackedYPos = [], M === "overlap" ? S($[this.stackKey], function(D) {
            j.push(h(D.stackState)), N.push(m(D.stackState));
          }) : S($[this.stackKey], function(D) {
            j.push(D.negTotal + D.threshold), N.push(D.posTotal + D.threshold);
          }), { dataMin: h(j), dataMax: m(N) }) : { dataMin: this.dataMin, dataMax: this.dataMax };
        }
      }
      return k.defaultOptions = f(d.defaultOptions, l), k.compose = r.compose, v(k.prototype, { pointValKey: "y", showLine: !0, pointClass: s }), u(k, "afterColumnTranslate", function() {
        let { options: A, points: $, yAxis: j } = this, N = w(A.minPointLength, 5), M = N / 2, D = A.threshold || 0, C = A.stacking, b = j.waterfall.stacks[this.stackKey], p = D, L = D, B, T, O, I;
        for (let R = 0; R < $.length; R++) {
          let Y = $[R], F = this.processedYData[R], U = v({ x: 0, y: 0, width: 0, height: 0 }, Y.shapeArgs || {});
          Y.box = U;
          let Q = [0, F], J = Y.y || 0;
          if (C) {
            if (b) {
              let G = b[R];
              C === "overlap" ? (T = G.stackState[G.stateIndex--], B = J >= 0 ? T : T - J, x(G, "absolutePos") && delete G.absolutePos, x(G, "absoluteNeg") && delete G.absoluteNeg) : (J >= 0 ? (T = G.threshold + G.posTotal, G.posTotal -= J, B = T) : (T = G.threshold + G.negTotal, G.negTotal -= J, B = T - J), !G.posTotal && P(G.absolutePos) && x(G, "absolutePos") && (G.posTotal = G.absolutePos, delete G.absolutePos), !G.negTotal && P(G.absoluteNeg) && x(G, "absoluteNeg") && (G.negTotal = G.absoluteNeg, delete G.absoluteNeg)), Y.isSum || (G.connectorThreshold = G.threshold + G.stackTotal), j.reversed ? (O = J >= 0 ? B - J : B + J, I = B) : (O = B, I = B - J), Y.below = O <= D, U.y = j.translate(O, !1, !0, !1, !0), U.height = Math.abs(U.y - j.translate(I, !1, !0, !1, !0));
              let W = j.waterfall.dummyStackItem;
              W && (W.x = R, W.label = b[R].label, W.setOffset(this.pointXOffset || 0, this.barW || 0, this.stackedYNeg[R], this.stackedYPos[R], void 0, this.xAxis));
            }
          } else
            B = Math.max(L, L + J) + Q[0], U.y = j.translate(B, !1, !0, !1, !0), Y.isSum ? (U.y = j.translate(Q[1], !1, !0, !1, !0), U.height = Math.min(j.translate(Q[0], !1, !0, !1, !0), j.len) - U.y, Y.below = Q[1] <= D) : Y.isIntermediateSum ? (J >= 0 ? (O = Q[1] + p, I = p) : (O = p, I = Q[1] + p), j.reversed && (O ^= I, I ^= O, O ^= I), U.y = j.translate(O, !1, !0, !1, !0), U.height = Math.abs(U.y - Math.min(j.translate(I, !1, !0, !1, !0), j.len)), p += Q[1], Y.below = O <= D) : (U.height = F > 0 ? j.translate(L, !1, !0, !1, !0) - U.y : j.translate(L, !1, !0, !1, !0) - j.translate(L - F, !1, !0, !1, !0), L += F, Y.below = L < D), U.height < 0 && (U.y += U.height, U.height *= -1);
          Y.plotY = U.y, Y.yBottom = U.y + U.height, U.height <= N && !Y.isNull ? (U.height = N, U.y -= M, Y.yBottom = U.y + U.height, Y.plotY = U.y, J < 0 ? Y.minPointLengthOffset = -M : Y.minPointLengthOffset = M) : (Y.isNull && (U.width = 0), Y.minPointLengthOffset = 0);
          let ee = Y.plotY + (Y.negative ? U.height : 0);
          Y.below && (Y.plotY += U.height), Y.tooltipPos && (this.chart.inverted ? Y.tooltipPos[0] = j.len - ee : Y.tooltipPos[1] = ee), Y.isInside = this.isPointInside(Y);
          let V = g(Y.yBottom, this.borderWidth);
          U.y = g(U.y, this.borderWidth), U.height = V - U.y, f(!0, Y.shapeArgs, U);
        }
      }, { order: 2 }), o.registerSeriesType("waterfall", k), k;
    }), i(n, "masters/highcharts-more.src.js", [n["Core/Globals.js"], n["Core/Series/SeriesRegistry.js"], n["Extensions/Pane/Pane.js"], n["Series/Bubble/BubbleSeries.js"], n["Series/PackedBubble/PackedBubbleSeries.js"], n["Series/PolarComposition.js"], n["Core/Axis/RadialAxis.js"], n["Series/Waterfall/WaterfallSeries.js"]], function(o, a, r, s, l, d, y, u) {
      return o.RadialAxis = y, s.compose(o.Axis, o.Chart, o.Legend), l.compose(o.Axis, o.Chart, o.Legend), r.compose(o.Chart, o.Pointer), d.compose(o.Axis, o.Chart, o.Pointer, o.Series, o.Tick, o.Point, a.seriesTypes.areasplinerange, a.seriesTypes.column, a.seriesTypes.line, a.seriesTypes.spline), u.compose(o.Axis, o.Chart), o;
    });
  });
})(Nk);
var Q6 = Nk.exports;
const e$ = /* @__PURE__ */ en(Q6);
var $k = { exports: {} };
(function(e) {
  /**
  * Highstock JS v11.4.8 (2024-08-29)
  *
  * Indicator series type for Highcharts Stock
  *
  * (c) 2010-2024 Pawel Fus, Sebastian Bochan
  *
  * License: www.highcharts.com/license
  */
  (function(t) {
    e.exports ? (t.default = t, e.exports = t) : t(typeof Highcharts < "u" ? Highcharts : void 0);
  })(function(t) {
    var n = t ? t._modules : {};
    function i(o, a, r, s) {
      o.hasOwnProperty(a) || (o[a] = s.apply(null, r), typeof CustomEvent == "function" && t.win.dispatchEvent(new CustomEvent("HighchartsModuleLoaded", { detail: { path: a, module: o[a] } })));
    }
    i(n, "Stock/Indicators/SMA/SMAIndicator.js", [n["Core/Chart/Chart.js"], n["Core/Series/SeriesRegistry.js"], n["Core/Utilities.js"]], function(o, a, r) {
      let { line: s } = a.seriesTypes, { addEvent: l, fireEvent: d, error: y, extend: u, isArray: m, merge: h, pick: c, splat: g } = r;
      class v extends s {
        destroy() {
          this.dataEventsToUnbind.forEach(function(f) {
            f();
          }), super.destroy.apply(this, arguments);
        }
        getName() {
          let f = [], S = this.name;
          return S || ((this.nameComponents || []).forEach(function(w, x) {
            f.push(this.options.params[w] + c(this.nameSuffixes[x], ""));
          }, this), S = (this.nameBase || this.type.toUpperCase()) + (this.nameComponents ? " (" + f.join(", ") + ")" : "")), S;
        }
        getValues(f, S) {
          let w = S.period, x = f.xData, k = f.yData, A = k.length, $ = [], j = [], N = [], M, D = -1, C = 0, b, p = 0;
          if (!(x.length < w)) {
            for (m(k[0]) && (D = S.index ? S.index : 0); C < w - 1; )
              p += D < 0 ? k[C] : k[C][D], C++;
            for (M = C; M < A; M++)
              p += D < 0 ? k[M] : k[M][D], b = [x[M], p / w], $.push(b), j.push(b[0]), N.push(b[1]), p -= D < 0 ? k[M - C] : k[M - C][D];
            return { values: $, xData: j, yData: N };
          }
        }
        init(f, S) {
          let w = this;
          super.init.call(w, f, S);
          let x = l(o, "afterLinkSeries", function({ isUpdating: k }) {
            if (k)
              return;
            let A = !!w.dataEventsToUnbind.length;
            if (!w.linkedParent)
              return y("Series " + w.options.linkedTo + " not found! Check `linkedTo`.", !1, f);
            if (!A && (w.dataEventsToUnbind.push(l(w.linkedParent, "updatedData", function() {
              w.recalculateValues();
            })), w.calculateOn.xAxis && w.dataEventsToUnbind.push(l(w.linkedParent.xAxis, w.calculateOn.xAxis, function() {
              w.recalculateValues();
            }))), w.calculateOn.chart === "init")
              w.processedYData || w.recalculateValues();
            else if (!A) {
              let $ = l(w.chart, w.calculateOn.chart, function() {
                w.recalculateValues(), $();
              });
            }
          }, { order: 0 });
          w.dataEventsToUnbind = [], w.eventsToUnbind.push(x);
        }
        recalculateValues() {
          let f = [], S = this.points || [], w = (this.xData || []).length, x = !0, k, A, $, j, N, M, D = this.linkedParent.options && this.linkedParent.yData && this.linkedParent.yData.length && this.getValues(this.linkedParent, this.options.params) || { values: [], xData: [], yData: [] };
          if (w && !this.hasGroupedData && this.visible && this.points)
            if (this.cropped) {
              for (this.xAxis && (j = this.xAxis.min, N = this.xAxis.max), $ = this.cropData(D.xData, D.yData, j, N), M = 0; M < $.xData.length; M++)
                f.push([$.xData[M]].concat(g($.yData[M])));
              k = D.xData.indexOf(this.xData[0]), A = D.xData.indexOf(this.xData[this.xData.length - 1]), k === -1 && A === D.xData.length - 2 && f[0][0] === S[0].x && f.shift(), this.updateData(f);
            } else
              (this.updateAllPoints || D.xData.length !== w - 1 && D.xData.length !== w + 1) && (x = !1, this.updateData(D.values));
          x && (this.xData = D.xData, this.yData = D.yData, this.options.data = D.values), this.calculateOn.xAxis && this.processedXData && (delete this.processedXData, this.isDirty = !0, this.redraw()), this.isDirtyData = !!this.linkedSeries.length, d(this, "updatedData");
        }
        processData() {
          let f = this.options.compareToMain, S = this.linkedParent;
          super.processData.apply(this, arguments), this.dataModify && S && S.dataModify && S.dataModify.compareValue && f && (this.dataModify.compareValue = S.dataModify.compareValue);
        }
      }
      return v.defaultOptions = h(s.defaultOptions, { name: void 0, tooltip: { valueDecimals: 4 }, linkedTo: void 0, compareToMain: !1, params: { index: 3, period: 14 } }), u(v.prototype, { calculateOn: { chart: "init" }, hasDerivedData: !0, nameComponents: ["period"], nameSuffixes: [], useCommonDataGrouping: !0 }), a.registerSeriesType("sma", v), v;
    }), i(n, "Stock/Indicators/EMA/EMAIndicator.js", [n["Core/Series/SeriesRegistry.js"], n["Core/Utilities.js"]], function(o, a) {
      let { sma: r } = o.seriesTypes, { correctFloat: s, isArray: l, merge: d } = a;
      class y extends r {
        accumulatePeriodPoints(m, h, c) {
          let g = 0, v = 0;
          for (; v < m; )
            g += h < 0 ? c[v] : c[v][h], v++;
          return g;
        }
        calculateEma(m, h, c, g, v, P, f) {
          let S = m[c - 1], w = P < 0 ? h[c - 1] : h[c - 1][P];
          return [S, v === void 0 ? f : s(w * g + v * (1 - g))];
        }
        getValues(m, h) {
          let c = h.period, g = m.xData, v = m.yData, P = v ? v.length : 0, f = 2 / (c + 1), S = [], w = [], x = [], k, A, $, j = -1, N = 0;
          if (!(P < c)) {
            for (l(v[0]) && (j = h.index ? h.index : 0), N = this.accumulatePeriodPoints(c, j, v) / c, $ = c; $ < P + 1; $++)
              A = this.calculateEma(g, v, $, f, k, j, N), S.push(A), w.push(A[0]), x.push(A[1]), k = A[1];
            return { values: S, xData: w, yData: x };
          }
        }
      }
      return y.defaultOptions = d(r.defaultOptions, { params: { index: 3, period: 9 } }), o.registerSeriesType("ema", y), y;
    }), i(n, "Stock/Indicators/MultipleLinesComposition.js", [n["Core/Series/SeriesRegistry.js"], n["Core/Utilities.js"]], function(o, a) {
      var r;
      let { sma: { prototype: s } } = o.seriesTypes, { defined: l, error: d, merge: y } = a;
      return function(u) {
        let m = ["bottomLine"], h = ["top", "bottom"], c = ["top"];
        function g(x) {
          return "plot" + x.charAt(0).toUpperCase() + x.slice(1);
        }
        function v(x, k) {
          let A = [];
          return (x.pointArrayMap || []).forEach(($) => {
            $ !== k && A.push(g($));
          }), A;
        }
        function P() {
          let x = this, k = x.pointValKey, A = x.linesApiNames, $ = x.areaLinesNames, j = x.points, N = x.options, M = x.graph, D = { options: { gapSize: N.gapSize } }, C = [], b = v(x, k), p = j.length, L;
          if (b.forEach((B, T) => {
            for (C[T] = []; p--; )
              L = j[p], C[T].push({ x: L.x, plotX: L.plotX, plotY: L[B], isNull: !l(L[B]) });
            p = j.length;
          }), x.userOptions.fillColor && $.length) {
            let B = C[b.indexOf(g($[0]))], T = $.length === 1 ? j : C[b.indexOf(g($[1]))], O = x.color;
            x.points = T, x.nextPoints = B, x.color = x.userOptions.fillColor, x.options = y(j, D), x.graph = x.area, x.fillGraph = !0, s.drawGraph.call(x), x.area = x.graph, delete x.nextPoints, delete x.fillGraph, x.color = O;
          }
          A.forEach((B, T) => {
            C[T] ? (x.points = C[T], N[B] ? x.options = y(N[B].styles, D) : d('Error: "There is no ' + B + ' in DOCS options declared. Check if linesApiNames are consistent with your DOCS line names."'), x.graph = x["graph" + B], s.drawGraph.call(x), x["graph" + B] = x.graph) : d('Error: "' + B + ` doesn't have equivalent in pointArrayMap. To many elements in linesApiNames relative to pointArrayMap."`);
          }), x.points = j, x.options = N, x.graph = M, s.drawGraph.call(x);
        }
        function f(x) {
          let k, A = [], $ = [];
          if (x = x || this.points, this.fillGraph && this.nextPoints) {
            if ((k = s.getGraphPath.call(this, this.nextPoints)) && k.length) {
              k[0][0] = "L", A = s.getGraphPath.call(this, x), $ = k.slice(0, A.length);
              for (let j = $.length - 1; j >= 0; j--)
                A.push($[j]);
            }
          } else
            A = s.getGraphPath.apply(this, arguments);
          return A;
        }
        function S(x) {
          let k = [];
          return (this.pointArrayMap || []).forEach((A) => {
            k.push(x[A]);
          }), k;
        }
        function w() {
          let x = this.pointArrayMap, k = [], A;
          k = v(this), s.translate.apply(this, arguments), this.points.forEach(($) => {
            x.forEach((j, N) => {
              A = $[j], this.dataModify && (A = this.dataModify.modifyValue(A)), A !== null && ($[k[N]] = this.yAxis.toPixels(A, !0));
            });
          });
        }
        u.compose = function(x) {
          let k = x.prototype;
          return k.linesApiNames = k.linesApiNames || m.slice(), k.pointArrayMap = k.pointArrayMap || h.slice(), k.pointValKey = k.pointValKey || "top", k.areaLinesNames = k.areaLinesNames || c.slice(), k.drawGraph = P, k.getGraphPath = f, k.toYData = S, k.translate = w, x;
        };
      }(r || (r = {})), r;
    }), i(n, "masters/indicators/indicators.src.js", [n["Core/Globals.js"], n["Stock/Indicators/MultipleLinesComposition.js"]], function(o, a) {
      return o.MultipleLinesComposition = o.MultipleLinesComposition || a, o;
    });
  });
})($k);
var t$ = $k.exports;
const n$ = /* @__PURE__ */ en(t$);
var Fk = { exports: {} };
(function(e) {
  /**
  * Highcharts JS v11.4.8 (2024-08-29)
  *
  * Exporting module
  *
  * (c) 2010-2024 Torstein Honsi
  *
  * License: www.highcharts.com/license
  */
  (function(t) {
    e.exports ? (t.default = t, e.exports = t) : t(typeof Highcharts < "u" ? Highcharts : void 0);
  })(function(t) {
    var n = t ? t._modules : {};
    function i(o, a, r, s) {
      o.hasOwnProperty(a) || (o[a] = s.apply(null, r), typeof CustomEvent == "function" && t.win.dispatchEvent(new CustomEvent("HighchartsModuleLoaded", { detail: { path: a, module: o[a] } })));
    }
    i(n, "Core/Chart/ChartNavigationComposition.js", [], function() {
      var o;
      return function(a) {
        a.compose = function(s) {
          return s.navigation || (s.navigation = new r(s)), s;
        };
        class r {
          constructor(l) {
            this.updates = [], this.chart = l;
          }
          addUpdate(l) {
            this.chart.navigation.updates.push(l);
          }
          update(l, d) {
            this.updates.forEach((y) => {
              y.call(this.chart, l, d);
            });
          }
        }
        a.Additions = r;
      }(o || (o = {})), o;
    }), i(n, "Extensions/Exporting/ExportingDefaults.js", [n["Core/Globals.js"]], function(o) {
      let { isTouchDevice: a } = o;
      return { exporting: { allowTableSorting: !0, type: "image/png", url: "https://export.highcharts.com/", pdfFont: { normal: void 0, bold: void 0, bolditalic: void 0, italic: void 0 }, printMaxWidth: 780, scale: 2, buttons: { contextButton: { className: "highcharts-contextbutton", menuClassName: "highcharts-contextmenu", symbol: "menu", titleKey: "contextButtonTitle", menuItems: ["viewFullscreen", "printChart", "separator", "downloadPNG", "downloadJPEG", "downloadPDF", "downloadSVG"] } }, menuItemDefinitions: { viewFullscreen: { textKey: "viewFullscreen", onclick: function() {
        this.fullscreen && this.fullscreen.toggle();
      } }, printChart: { textKey: "printChart", onclick: function() {
        this.print();
      } }, separator: { separator: !0 }, downloadPNG: { textKey: "downloadPNG", onclick: function() {
        this.exportChart();
      } }, downloadJPEG: { textKey: "downloadJPEG", onclick: function() {
        this.exportChart({ type: "image/jpeg" });
      } }, downloadPDF: { textKey: "downloadPDF", onclick: function() {
        this.exportChart({ type: "application/pdf" });
      } }, downloadSVG: { textKey: "downloadSVG", onclick: function() {
        this.exportChart({ type: "image/svg+xml" });
      } } } }, lang: { viewFullscreen: "View in full screen", exitFullscreen: "Exit from full screen", printChart: "Print chart", downloadPNG: "Download PNG image", downloadJPEG: "Download JPEG image", downloadPDF: "Download PDF document", downloadSVG: "Download SVG vector image", contextButtonTitle: "Chart context menu" }, navigation: { buttonOptions: { symbolSize: 14, symbolX: 14.5, symbolY: 13.5, align: "right", buttonSpacing: 3, height: 28, verticalAlign: "top", width: 28, symbolFill: "#666666", symbolStroke: "#666666", symbolStrokeWidth: 3, theme: { fill: "#ffffff", padding: 5, stroke: "none", "stroke-linecap": "round" } }, menuStyle: { border: "none", borderRadius: "3px", background: "#ffffff", padding: "0.5em" }, menuItemStyle: { background: "none", borderRadius: "3px", color: "#333333", padding: "0.5em", fontSize: a ? "0.9em" : "0.8em", transition: "background 250ms, color 250ms" }, menuItemHoverStyle: { background: "#f2f2f2" } } };
    }), i(n, "Extensions/Exporting/ExportingSymbols.js", [], function() {
      var o;
      return function(a) {
        let r = [];
        function s(d, y, u, m) {
          return [["M", d, y + 2.5], ["L", d + u, y + 2.5], ["M", d, y + m / 2 + 0.5], ["L", d + u, y + m / 2 + 0.5], ["M", d, y + m - 1.5], ["L", d + u, y + m - 1.5]];
        }
        function l(d, y, u, m) {
          let h = m / 3 - 2;
          return [].concat(this.circle(u - h, y, h, h), this.circle(u - h, y + h + 4, h, h), this.circle(u - h, y + 2 * (h + 4), h, h));
        }
        a.compose = function(d) {
          if (r.indexOf(d) === -1) {
            r.push(d);
            let y = d.prototype.symbols;
            y.menu = s, y.menuball = l.bind(y);
          }
        };
      }(o || (o = {})), o;
    }), i(n, "Extensions/Exporting/Fullscreen.js", [n["Core/Renderer/HTML/AST.js"], n["Core/Globals.js"], n["Core/Utilities.js"]], function(o, a, r) {
      let { composed: s } = a, { addEvent: l, fireEvent: d, pushUnique: y } = r;
      function u() {
        this.fullscreen = new m(this);
      }
      class m {
        static compose(c) {
          y(s, "Fullscreen") && l(c, "beforeRender", u);
        }
        constructor(c) {
          this.chart = c, this.isOpen = !1;
          let g = c.renderTo;
          !this.browserProps && (typeof g.requestFullscreen == "function" ? this.browserProps = { fullscreenChange: "fullscreenchange", requestFullscreen: "requestFullscreen", exitFullscreen: "exitFullscreen" } : g.mozRequestFullScreen ? this.browserProps = { fullscreenChange: "mozfullscreenchange", requestFullscreen: "mozRequestFullScreen", exitFullscreen: "mozCancelFullScreen" } : g.webkitRequestFullScreen ? this.browserProps = { fullscreenChange: "webkitfullscreenchange", requestFullscreen: "webkitRequestFullScreen", exitFullscreen: "webkitExitFullscreen" } : g.msRequestFullscreen && (this.browserProps = { fullscreenChange: "MSFullscreenChange", requestFullscreen: "msRequestFullscreen", exitFullscreen: "msExitFullscreen" }));
        }
        close() {
          let c = this, g = c.chart, v = g.options.chart;
          d(g, "fullscreenClose", null, function() {
            c.isOpen && c.browserProps && g.container.ownerDocument instanceof Document && g.container.ownerDocument[c.browserProps.exitFullscreen](), c.unbindFullscreenEvent && (c.unbindFullscreenEvent = c.unbindFullscreenEvent()), g.setSize(c.origWidth, c.origHeight, !1), c.origWidth = void 0, c.origHeight = void 0, v.width = c.origWidthOption, v.height = c.origHeightOption, c.origWidthOption = void 0, c.origHeightOption = void 0, c.isOpen = !1, c.setButtonText();
          });
        }
        open() {
          let c = this, g = c.chart, v = g.options.chart;
          d(g, "fullscreenOpen", null, function() {
            if (v && (c.origWidthOption = v.width, c.origHeightOption = v.height), c.origWidth = g.chartWidth, c.origHeight = g.chartHeight, c.browserProps) {
              let P = l(g.container.ownerDocument, c.browserProps.fullscreenChange, function() {
                c.isOpen ? (c.isOpen = !1, c.close()) : (g.setSize(null, null, !1), c.isOpen = !0, c.setButtonText());
              }), f = l(g, "destroy", P);
              c.unbindFullscreenEvent = () => {
                P(), f();
              };
              let S = g.renderTo[c.browserProps.requestFullscreen]();
              S && S.catch(function() {
                alert("Full screen is not supported inside a frame.");
              });
            }
          });
        }
        setButtonText() {
          let c = this.chart, g = c.exportDivElements, v = c.options.exporting, P = v && v.buttons && v.buttons.contextButton.menuItems, f = c.options.lang;
          if (v && v.menuItemDefinitions && f && f.exitFullscreen && f.viewFullscreen && P && g) {
            let S = g[P.indexOf("viewFullscreen")];
            S && o.setElementHTML(S, this.isOpen ? f.exitFullscreen : v.menuItemDefinitions.viewFullscreen.text || f.viewFullscreen);
          }
        }
        toggle() {
          this.isOpen ? this.close() : this.open();
        }
      }
      return m;
    }), i(n, "Core/HttpUtilities.js", [n["Core/Globals.js"], n["Core/Utilities.js"]], function(o, a) {
      let { win: r } = o, { discardElement: s, objectEach: l } = a, d = { ajax: function(y) {
        let u = { json: "application/json", xml: "application/xml", text: "text/plain", octet: "application/octet-stream" }, m = new XMLHttpRequest();
        function h(c, g) {
          y.error && y.error(c, g);
        }
        if (!y.url)
          return !1;
        m.open((y.type || "get").toUpperCase(), y.url, !0), y.headers && y.headers["Content-Type"] || m.setRequestHeader("Content-Type", u[y.dataType || "json"] || u.text), l(y.headers, function(c, g) {
          m.setRequestHeader(g, c);
        }), y.responseType && (m.responseType = y.responseType), m.onreadystatechange = function() {
          let c;
          if (m.readyState === 4) {
            if (m.status === 200) {
              if (y.responseType !== "blob" && (c = m.responseText, y.dataType === "json"))
                try {
                  c = JSON.parse(c);
                } catch (g) {
                  if (g instanceof Error)
                    return h(m, g);
                }
              return y.success && y.success(c, m);
            }
            h(m, m.responseText);
          }
        }, y.data && typeof y.data != "string" && (y.data = JSON.stringify(y.data)), m.send(y.data);
      }, getJSON: function(y, u) {
        d.ajax({ url: y, success: u, dataType: "json", headers: { "Content-Type": "text/plain" } });
      }, post: function(y, u, m) {
        let h = new r.FormData();
        l(u, function(v, P) {
          h.append(P, v);
        }), h.append("b64", "true");
        let { filename: c, type: g } = u;
        return r.fetch(y, { method: "POST", body: h, ...m }).then((v) => {
          v.ok && v.text().then((P) => {
            let f = document.createElement("a");
            f.href = `data:${g};base64,${P}`, f.download = c, f.click(), s(f);
          });
        });
      } };
      return d;
    }), i(n, "Extensions/Exporting/Exporting.js", [n["Core/Renderer/HTML/AST.js"], n["Core/Chart/Chart.js"], n["Core/Chart/ChartNavigationComposition.js"], n["Core/Defaults.js"], n["Extensions/Exporting/ExportingDefaults.js"], n["Extensions/Exporting/ExportingSymbols.js"], n["Extensions/Exporting/Fullscreen.js"], n["Core/Globals.js"], n["Core/HttpUtilities.js"], n["Core/Utilities.js"]], function(o, a, r, s, l, d, y, u, m, h) {
      var c;
      let { defaultOptions: g } = s, { doc: v, SVG_NS: P, win: f } = u, { addEvent: S, css: w, createElement: x, discardElement: k, extend: A, find: $, fireEvent: j, isObject: N, merge: M, objectEach: D, pick: C, removeEvent: b, uniqueKey: p } = h;
      return function(L) {
        let B, T = [/-/, /^(clipPath|cssText|d|height|width)$/, /^font$/, /[lL]ogical(Width|Height)$/, /^parentRule$/, /^(cssRules|ownerRules)$/, /perspective/, /TapHighlightColor/, /^transition/, /^length$/, /^\d+$/], O = ["fill", "stroke", "strokeLinecap", "strokeLinejoin", "strokeWidth", "textAnchor", "x", "y"];
        L.inlineAllowlist = [];
        let I = ["clipPath", "defs", "desc"];
        function R(de) {
          let me, ce, pe = this, xe = pe.renderer, le = M(pe.options.navigation.buttonOptions, de), se = le.onclick, he = le.menuItems, ve = le.symbolSize || 12;
          if (pe.btnCount || (pe.btnCount = 0), pe.exportDivElements || (pe.exportDivElements = [], pe.exportSVGElements = []), le.enabled === !1 || !le.theme)
            return;
          let ye = pe.styledMode ? {} : le.theme;
          se ? ce = function(ke) {
            ke && ke.stopPropagation(), se.call(pe, ke);
          } : he && (ce = function(ke) {
            ke && ke.stopPropagation(), pe.contextMenu(be.menuClassName, he, be.translateX || 0, be.translateY || 0, be.width || 0, be.height || 0, be), be.setState(2);
          }), le.text && le.symbol ? ye.paddingLeft = C(ye.paddingLeft, 30) : le.text || A(ye, { width: le.width, height: le.height, padding: 0 });
          let be = xe.button(le.text, 0, 0, ce, ye, void 0, void 0, void 0, void 0, le.useHTML).addClass(de.className).attr({ title: C(pe.options.lang[le._titleKey || le.titleKey], "") });
          be.menuClassName = de.menuClassName || "highcharts-menu-" + pe.btnCount++, le.symbol && (me = xe.symbol(le.symbol, Math.round((le.symbolX || 0) - ve / 2), Math.round((le.symbolY || 0) - ve / 2), ve, ve, { width: ve, height: ve }).addClass("highcharts-button-symbol").attr({ zIndex: 1 }).add(be), pe.styledMode || me.attr({ stroke: le.symbolStroke, fill: le.symbolFill, "stroke-width": le.symbolStrokeWidth || 1 })), be.add(pe.exportingGroup).align(A(le, { width: be.width, x: C(le.x, pe.buttonOffset) }), !0, "spacingBox"), pe.buttonOffset += ((be.width || 0) + le.buttonSpacing) * (le.align === "right" ? -1 : 1), pe.exportSVGElements.push(be, me);
        }
        function Y() {
          if (!this.printReverseInfo)
            return;
          let { childNodes: de, origDisplay: me, resetParams: ce } = this.printReverseInfo;
          this.moveContainers(this.renderTo), [].forEach.call(de, function(pe, xe) {
            pe.nodeType === 1 && (pe.style.display = me[xe] || "");
          }), this.isPrinting = !1, ce && this.setSize.apply(this, ce), delete this.printReverseInfo, B = void 0, j(this, "afterPrint");
        }
        function F() {
          let de = v.body, me = this.options.exporting.printMaxWidth, ce = { childNodes: de.childNodes, origDisplay: [], resetParams: void 0 };
          this.isPrinting = !0, this.pointer?.reset(void 0, 0), j(this, "beforePrint"), me && this.chartWidth > me && (ce.resetParams = [this.options.chart.width, void 0, !1], this.setSize(me, void 0, !1)), [].forEach.call(ce.childNodes, function(pe, xe) {
            pe.nodeType === 1 && (ce.origDisplay[xe] = pe.style.display, pe.style.display = "none");
          }), this.moveContainers(de), this.printReverseInfo = ce;
        }
        function U(de) {
          de.renderExporting(), S(de, "redraw", de.renderExporting), S(de, "destroy", de.destroyExport);
        }
        function Q(de, me, ce, pe, xe, le, se) {
          let he = this, ve = he.options.navigation, ye = he.chartWidth, be = he.chartHeight, ke = "cache-" + de, we = Math.max(xe, le), Le, Me = he[ke];
          Me || (he.exportContextMenu = he[ke] = Me = x("div", { className: de }, { position: "absolute", zIndex: 1e3, padding: we + "px", pointerEvents: "auto", ...he.renderer.style }, he.scrollablePlotArea?.fixedDiv || he.container), Le = x("ul", { className: "highcharts-menu" }, he.styledMode ? {} : { listStyle: "none", margin: 0, padding: 0 }, Me), he.styledMode || w(Le, A({ MozBoxShadow: "3px 3px 10px #888", WebkitBoxShadow: "3px 3px 10px #888", boxShadow: "3px 3px 10px #888" }, ve.menuStyle)), Me.hideMenu = function() {
            w(Me, { display: "none" }), se && se.setState(0), he.openMenu = !1, w(he.renderTo, { overflow: "hidden" }), w(he.container, { overflow: "hidden" }), h.clearTimeout(Me.hideTimer), j(he, "exportMenuHidden");
          }, he.exportEvents.push(S(Me, "mouseleave", function() {
            Me.hideTimer = f.setTimeout(Me.hideMenu, 500);
          }), S(Me, "mouseenter", function() {
            h.clearTimeout(Me.hideTimer);
          }), S(v, "mouseup", function(Ae) {
            he.pointer?.inClass(Ae.target, de) || Me.hideMenu();
          }), S(Me, "click", function() {
            he.openMenu && Me.hideMenu();
          })), me.forEach(function(Ae) {
            if (typeof Ae == "string" && (Ae = he.options.exporting.menuItemDefinitions[Ae]), N(Ae, !0)) {
              let _e;
              Ae.separator ? _e = x("hr", void 0, void 0, Le) : (Ae.textKey === "viewData" && he.isDataTableVisible && (Ae.textKey = "hideData"), _e = x("li", { className: "highcharts-menu-item", onclick: function(He) {
                He && He.stopPropagation(), Me.hideMenu(), typeof Ae != "string" && Ae.onclick && Ae.onclick.apply(he, arguments);
              } }, void 0, Le), o.setElementHTML(_e, Ae.text || he.options.lang[Ae.textKey]), he.styledMode || (_e.onmouseover = function() {
                w(this, ve.menuItemHoverStyle);
              }, _e.onmouseout = function() {
                w(this, ve.menuItemStyle);
              }, w(_e, A({ cursor: "pointer" }, ve.menuItemStyle || {})))), he.exportDivElements.push(_e);
            }
          }), he.exportDivElements.push(Le, Me), he.exportMenuWidth = Me.offsetWidth, he.exportMenuHeight = Me.offsetHeight);
          let De = { display: "block" };
          ce + (he.exportMenuWidth || 0) > ye ? De.right = ye - ce - xe - we + "px" : De.left = ce - we + "px", pe + le + (he.exportMenuHeight || 0) > be && se.alignOptions?.verticalAlign !== "top" ? De.bottom = be - pe - we + "px" : De.top = pe + le - we + "px", w(Me, De), w(he.renderTo, { overflow: "" }), w(he.container, { overflow: "" }), he.openMenu = !0, j(he, "exportMenuShown");
        }
        function J(de) {
          let me, ce = de ? de.target : this, pe = ce.exportSVGElements, xe = ce.exportDivElements, le = ce.exportEvents;
          pe && (pe.forEach((se, he) => {
            se && (se.onclick = se.ontouchstart = null, ce[me = "cache-" + se.menuClassName] && delete ce[me], pe[he] = se.destroy());
          }), pe.length = 0), ce.exportingGroup && (ce.exportingGroup.destroy(), delete ce.exportingGroup), xe && (xe.forEach(function(se, he) {
            se && (h.clearTimeout(se.hideTimer), b(se, "mouseleave"), xe[he] = se.onmouseout = se.onmouseover = se.ontouchstart = se.onclick = null, k(se));
          }), xe.length = 0), le && (le.forEach(function(se) {
            se();
          }), le.length = 0);
        }
        function ee(de, me) {
          let ce = this.getSVGForExport(de, me);
          de = M(this.options.exporting, de), m.post(de.url, { filename: de.filename ? de.filename.replace(/\//g, "-") : this.getFilename(), type: de.type, width: de.width, scale: de.scale, svg: ce }, de.fetchOptions);
        }
        function V() {
          return this.styledMode && this.inlineStyles(), this.container.innerHTML;
        }
        function G() {
          let de = this.userOptions.title && this.userOptions.title.text, me = this.options.exporting.filename;
          return me ? me.replace(/\//g, "-") : (typeof de == "string" && (me = de.toLowerCase().replace(/<\/?[^>]+(>|$)/g, "").replace(/[\s_]+/g, "-").replace(/[^a-z\d\-]/g, "").replace(/^[\-]+/g, "").replace(/[\-]+/g, "-").substr(0, 24).replace(/[\-]+$/g, "")), (!me || me.length < 5) && (me = "chart"), me);
        }
        function W(de) {
          let me, ce, pe = M(this.options, de);
          pe.plotOptions = M(this.userOptions.plotOptions, de && de.plotOptions), pe.time = M(this.userOptions.time, de && de.time);
          let xe = x("div", null, { position: "absolute", top: "-9999em", width: this.chartWidth + "px", height: this.chartHeight + "px" }, v.body), le = this.renderTo.style.width, se = this.renderTo.style.height, he = pe.exporting.sourceWidth || pe.chart.width || /px$/.test(le) && parseInt(le, 10) || (pe.isGantt ? 800 : 600), ve = pe.exporting.sourceHeight || pe.chart.height || /px$/.test(se) && parseInt(se, 10) || 400;
          A(pe.chart, { animation: !1, renderTo: xe, forExport: !0, renderer: "SVGRenderer", width: he, height: ve }), pe.exporting.enabled = !1, delete pe.data, pe.series = [], this.series.forEach(function(ke) {
            (ce = M(ke.userOptions, { animation: !1, enableMouseTracking: !1, showCheckbox: !1, visible: ke.visible })).isInternal || pe.series.push(ce);
          });
          let ye = {};
          this.axes.forEach(function(ke) {
            ke.userOptions.internalKey || (ke.userOptions.internalKey = p()), ke.options.isInternal || (ye[ke.coll] || (ye[ke.coll] = !0, pe[ke.coll] = []), pe[ke.coll].push(M(ke.userOptions, { visible: ke.visible, type: ke.type, uniqueNames: ke.uniqueNames })));
          }), pe.colorAxis = this.userOptions.colorAxis;
          let be = new this.constructor(pe, this.callback);
          return de && ["xAxis", "yAxis", "series"].forEach(function(ke) {
            let we = {};
            de[ke] && (we[ke] = de[ke], be.update(we));
          }), this.axes.forEach(function(ke) {
            let we = $(be.axes, function(Ae) {
              return Ae.options.internalKey === ke.userOptions.internalKey;
            }), Le = ke.getExtremes(), Me = Le.userMin, De = Le.userMax;
            we && (Me !== void 0 && Me !== we.min || De !== void 0 && De !== we.max) && we.setExtremes(Me, De, !0, !1);
          }), me = be.getChartHTML(), j(this, "getSVG", { chartCopy: be }), me = this.sanitizeSVG(me, pe), pe = null, be.destroy(), k(xe), me;
        }
        function ae(de, me) {
          let ce = this.options.exporting;
          return this.getSVG(M({ chart: { borderRadius: 0 } }, ce.chartOptions, me, { exporting: { sourceWidth: de && de.sourceWidth || ce.sourceWidth, sourceHeight: de && de.sourceHeight || ce.sourceHeight } }));
        }
        function z() {
          let de, me = L.inlineAllowlist, ce = {}, pe = v.createElement("iframe");
          w(pe, { width: "1px", height: "1px", visibility: "hidden" }), v.body.appendChild(pe);
          let xe = pe.contentWindow && pe.contentWindow.document;
          xe && xe.body.appendChild(xe.createElementNS(P, "svg")), function le(se) {
            let he, ve, ye, be, ke, we, Le = {};
            if (xe && se.nodeType === 1 && I.indexOf(se.nodeName) === -1) {
              if (he = f.getComputedStyle(se, null), ve = se.nodeName === "svg" ? {} : f.getComputedStyle(se.parentNode, null), !ce[se.nodeName]) {
                de = xe.getElementsByTagName("svg")[0], ye = xe.createElementNS(se.namespaceURI, se.nodeName), de.appendChild(ye);
                let Me = f.getComputedStyle(ye, null), De = {};
                for (let Ae in Me)
                  Ae.length < 1e3 && typeof Me[Ae] == "string" && !/^\d+$/.test(Ae) && (De[Ae] = Me[Ae]);
                ce[se.nodeName] = De, se.nodeName === "text" && delete ce.text.fill, de.removeChild(ye);
              }
              for (let Me in he)
                (u.isFirefox || u.isMS || u.isSafari || Object.hasOwnProperty.call(he, Me)) && function(De, Ae) {
                  if (be = ke = !1, me.length) {
                    for (we = me.length; we-- && !ke; )
                      ke = me[we].test(Ae);
                    be = !ke;
                  }
                  for (Ae === "transform" && De === "none" && (be = !0), we = T.length; we-- && !be; ) {
                    if (Ae.length > 1e3)
                      throw Error("Input too long");
                    be = T[we].test(Ae) || typeof De == "function";
                  }
                  !be && (ve[Ae] !== De || se.nodeName === "svg") && ce[se.nodeName][Ae] !== De && (O && O.indexOf(Ae) === -1 ? Le[Ae] = De : De && se.setAttribute(Ae.replace(/[A-Z]/g, function(_e) {
                    return "-" + _e.toLowerCase();
                  }), De));
                }(he[Me], Me);
              if (w(se, Le), se.nodeName === "svg" && se.setAttribute("stroke-width", "1px"), se.nodeName === "text")
                return;
              [].forEach.call(se.children || se.childNodes, le);
            }
          }(this.container.querySelector("svg")), de.parentNode.removeChild(de), pe.parentNode.removeChild(pe);
        }
        function q(de) {
          let { scrollablePlotArea: me } = this;
          (me ? [me.fixedDiv, me.scrollingContainer] : [this.container]).forEach(function(ce) {
            de.appendChild(ce);
          });
        }
        function Z() {
          let de = this, me = (ce, pe, xe) => {
            de.isDirtyExporting = !0, M(!0, de.options[ce], pe), C(xe, !0) && de.redraw();
          };
          de.exporting = { update: function(ce, pe) {
            me("exporting", ce, pe);
          } }, r.compose(de).navigation.addUpdate((ce, pe) => {
            me("navigation", ce, pe);
          });
        }
        function ne() {
          let de = this;
          de.isPrinting || (B = de, u.isSafari || de.beforePrint(), setTimeout(() => {
            f.focus(), f.print(), u.isSafari || setTimeout(() => {
              de.afterPrint();
            }, 1e3);
          }, 1));
        }
        function ie() {
          let de = this, me = de.options.exporting, ce = me.buttons, pe = de.isDirtyExporting || !de.exportSVGElements;
          de.buttonOffset = 0, de.isDirtyExporting && de.destroyExport(), pe && me.enabled !== !1 && (de.exportEvents = [], de.exportingGroup = de.exportingGroup || de.renderer.g("exporting-group").attr({ zIndex: 3 }).add(), D(ce, function(xe) {
            de.addButton(xe);
          }), de.isDirtyExporting = !1);
        }
        function re(de, me) {
          let ce = de.indexOf("</svg>") + 6, pe = de.substr(ce);
          return de = de.substr(0, ce), me && me.exporting && me.exporting.allowHTML && pe && (pe = '<foreignObject x="0" y="0" width="' + me.chart.width + '" height="' + me.chart.height + '"><body xmlns="http://www.w3.org/1999/xhtml">' + pe.replace(/(<(?:img|br).*?(?=\>))>/g, "$1 />") + "</body></foreignObject>", de = de.replace("</svg>", pe + "</svg>")), de = de.replace(/zIndex="[^"]+"/g, "").replace(/symbolName="[^"]+"/g, "").replace(/jQuery\d+="[^"]+"/g, "").replace(/url\(("|&quot;)(.*?)("|&quot;)\;?\)/g, "url($2)").replace(/url\([^#]+#/g, "url(#").replace(/<svg /, '<svg xmlns:xlink="http://www.w3.org/1999/xlink" ').replace(/ (NS\d+\:)?href=/g, " xlink:href=").replace(/\n+/g, " ").replace(/(fill|stroke)="rgba\(([ \d]+,[ \d]+,[ \d]+),([ \d\.]+)\)"/g, '$1="rgb($2)" $1-opacity="$3"').replace(/&nbsp;/g, " ").replace(/&shy;/g, "­");
        }
        L.compose = function(de, me) {
          d.compose(me), y.compose(de);
          let ce = de.prototype;
          ce.exportChart || (ce.afterPrint = Y, ce.exportChart = ee, ce.inlineStyles = z, ce.print = ne, ce.sanitizeSVG = re, ce.getChartHTML = V, ce.getSVG = W, ce.getSVGForExport = ae, ce.getFilename = G, ce.moveContainers = q, ce.beforePrint = F, ce.contextMenu = Q, ce.addButton = R, ce.destroyExport = J, ce.renderExporting = ie, ce.callbacks.push(U), S(de, "init", Z), u.isSafari && f.matchMedia("print").addListener(function(pe) {
            B && (pe.matches ? B.beforePrint() : B.afterPrint());
          }), g.exporting = M(l.exporting, g.exporting), g.lang = M(l.lang, g.lang), g.navigation = M(l.navigation, g.navigation));
        };
      }(c || (c = {})), c;
    }), i(n, "masters/modules/exporting.src.js", [n["Core/Globals.js"], n["Extensions/Exporting/Exporting.js"], n["Core/HttpUtilities.js"]], function(o, a, r) {
      return o.HttpUtilities = o.HttpUtilities || r, o.ajax = o.HttpUtilities.ajax, o.getJSON = o.HttpUtilities.getJSON, o.post = o.HttpUtilities.post, a.compose(o.Chart, o.Renderer), o;
    });
  });
})(Fk);
var i$ = Fk.exports;
const a$ = /* @__PURE__ */ en(i$);
var jk = { exports: {} };
(function(e) {
  /**
  * Highcharts JS v11.4.8 (2024-08-29)
  *
  * Exporting module
  *
  * (c) 2010-2024 Torstein Honsi
  *
  * License: www.highcharts.com/license
  */
  (function(t) {
    e.exports ? (t.default = t, e.exports = t) : t(typeof Highcharts < "u" ? Highcharts : void 0);
  })(function(t) {
    var n = t ? t._modules : {};
    function i(o, a, r, s) {
      o.hasOwnProperty(a) || (o[a] = s.apply(null, r), typeof CustomEvent == "function" && t.win.dispatchEvent(new CustomEvent("HighchartsModuleLoaded", { detail: { path: a, module: o[a] } })));
    }
    i(n, "Extensions/DownloadURL.js", [n["Core/Globals.js"]], function(o) {
      let { isSafari: a, win: r, win: { document: s } } = o, l = r.URL || r.webkitURL || r;
      function d(y) {
        let u = y.replace(/filename=.*;/, "").match(/data:([^;]*)(;base64)?,([A-Z+\d\/]+)/i);
        if (u && u.length > 3 && r.atob && r.ArrayBuffer && r.Uint8Array && r.Blob && l.createObjectURL) {
          let m = r.atob(u[3]), h = new r.ArrayBuffer(m.length), c = new r.Uint8Array(h);
          for (let g = 0; g < c.length; ++g)
            c[g] = m.charCodeAt(g);
          return l.createObjectURL(new r.Blob([c], { type: u[1] }));
        }
      }
      return { dataURLtoBlob: d, downloadURL: function(y, u) {
        let m = r.navigator, h = s.createElement("a");
        if (typeof y != "string" && !(y instanceof String) && m.msSaveOrOpenBlob) {
          m.msSaveOrOpenBlob(y, u);
          return;
        }
        if (y = "" + y, m.userAgent.length > 1e3)
          throw Error("Input too long");
        let c = /Edge\/\d+/.test(m.userAgent);
        if ((a && typeof y == "string" && y.indexOf("data:application/pdf") === 0 || c || y.length > 2e6) && !(y = d(y) || ""))
          throw Error("Failed to convert to blob");
        if (h.download !== void 0)
          h.href = y, h.download = u, s.body.appendChild(h), h.click(), s.body.removeChild(h);
        else
          try {
            if (!r.open(y, "chart"))
              throw Error("Failed to open window");
          } catch {
            r.location.href = y;
          }
      } };
    }), i(n, "Extensions/ExportData/ExportDataDefaults.js", [], function() {
      return { exporting: { csv: { annotations: { itemDelimiter: "; ", join: !1 }, columnHeaderFormatter: null, dateFormat: "%Y-%m-%d %H:%M:%S", decimalPoint: null, itemDelimiter: null, lineDelimiter: `
` }, showTable: !1, useMultiLevelHeaders: !0, useRowspanHeaders: !0, showExportInProgress: !0 }, lang: { downloadCSV: "Download CSV", downloadXLS: "Download XLS", exportData: { annotationHeader: "Annotations", categoryHeader: "Category", categoryDatetimeHeader: "DateTime" }, viewData: "View data table", hideData: "Hide data table", exportInProgress: "Exporting..." } };
    }), i(n, "Extensions/ExportData/ExportData.js", [n["Core/Renderer/HTML/AST.js"], n["Core/Defaults.js"], n["Extensions/DownloadURL.js"], n["Extensions/ExportData/ExportDataDefaults.js"], n["Core/Globals.js"], n["Core/Utilities.js"]], function(o, a, r, s, l, d) {
      let { getOptions: y, setOptions: u } = a, { downloadURL: m } = r, { doc: h, win: c } = l, { addEvent: g, defined: v, extend: P, find: f, fireEvent: S, isNumber: w, pick: x } = d;
      function k(I) {
        let R = !!this.options.exporting?.showExportInProgress, Y = c.requestAnimationFrame || setTimeout;
        Y(() => {
          R && this.showLoading(this.options.lang.exportInProgress), Y(() => {
            try {
              I.call(this);
            } finally {
              R && this.hideLoading();
            }
          });
        });
      }
      function A() {
        k.call(this, () => {
          let I = this.getCSV(!0);
          m(L(I, "text/csv") || "data:text/csv,\uFEFF" + encodeURIComponent(I), this.getFilename() + ".csv");
        });
      }
      function $() {
        k.call(this, () => {
          let I = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>Ark1</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--><style>td{border:none;font-family: Calibri, sans-serif;} .number{mso-number-format:"0.00";} .text{ mso-number-format:"@";}</style><meta name=ProgId content=Excel.Sheet><meta charset=UTF-8></head><body>' + this.getTable(!0) + "</body></html>";
          m(L(I, "application/vnd.ms-excel") || "data:application/vnd.ms-excel;base64," + c.btoa(unescape(encodeURIComponent(I))), this.getFilename() + ".xls");
        });
      }
      function j(I) {
        let R = "", Y = this.getDataRows(), F = this.options.exporting.csv, U = x(F.decimalPoint, F.itemDelimiter !== "," && I ? 1.1.toLocaleString()[1] : "."), Q = x(F.itemDelimiter, U === "," ? ";" : ","), J = F.lineDelimiter;
        return Y.forEach((ee, V) => {
          let G = "", W = ee.length;
          for (; W--; )
            typeof (G = ee[W]) == "string" && (G = `"${G}"`), typeof G == "number" && U !== "." && (G = G.toString().replace(".", U)), ee[W] = G;
          ee.length = Y.length ? Y[0].length : 0, R += ee.join(Q), V < Y.length - 1 && (R += J);
        }), R;
      }
      function N(I) {
        let R, Y, F = this.hasParallelCoordinates, U = this.time, Q = this.options.exporting && this.options.exporting.csv || {}, J = this.xAxis, ee = {}, V = [], G = [], W = [], ae = this.options.lang.exportData, z = ae.categoryHeader, q = ae.categoryDatetimeHeader, Z = function(se, he, ve) {
          if (Q.columnHeaderFormatter) {
            let ye = Q.columnHeaderFormatter(se, he, ve);
            if (ye !== !1)
              return ye;
          }
          return se ? se.bindAxes ? I ? { columnTitle: ve > 1 ? he : se.name, topLevelColumnTitle: se.name } : se.name + (ve > 1 ? " (" + he + ")" : "") : se.options.title && se.options.title.text || (se.dateTime ? q : z) : z;
        }, ne = function(se, he, ve) {
          let ye = {}, be = {};
          return he.forEach(function(ke) {
            let we = (se.keyToAxis && se.keyToAxis[ke] || ke) + "Axis", Le = w(ve) ? se.chart[we][ve] : se[we];
            ye[ke] = Le && Le.categories || [], be[ke] = Le && Le.dateTime;
          }), { categoryMap: ye, dateTimeValueAxisMap: be };
        }, ie = function(se, he) {
          let ve = se.pointArrayMap || ["y"];
          return se.data.some((ye) => ye.y !== void 0 && ye.name) && he && !he.categories && se.exportKey !== "name" ? ["x", ...ve] : ve;
        }, re = [], de, me, ce, pe = 0, xe, le;
        for (xe in this.series.forEach(function(se) {
          let he = se.options.keys, ve = se.xAxis, ye = he || ie(se, ve), be = ye.length, ke = !se.requireSorting && {}, we = J.indexOf(ve), Le = ne(se, ye), Me, De;
          if (se.options.includeInDataExport !== !1 && !se.options.isInternal && se.visible !== !1) {
            for (f(re, function(Ae) {
              return Ae[0] === we;
            }) || re.push([we, pe]), De = 0; De < be; )
              ce = Z(se, ye[De], ye.length), W.push(ce.columnTitle || ce), I && G.push(ce.topLevelColumnTitle || ce), De++;
            Me = { chart: se.chart, autoIncrement: se.autoIncrement, options: se.options, pointArrayMap: se.pointArrayMap, index: se.index }, se.options.data.forEach(function(Ae, _e) {
              let He, Ee, Ne, Ye = { series: Me };
              F && (Le = ne(se, ye, _e)), se.pointClass.prototype.applyOptions.apply(Ye, [Ae]);
              let Xe = se.data[_e] && se.data[_e].name;
              if (He = (Ye.x ?? "") + "," + Xe, De = 0, (!ve || se.exportKey === "name" || !F && ve && ve.hasNames && Xe) && (He = Xe), ke && (ke[He] && (He += "|" + _e), ke[He] = !0), ee[He]) {
                let nt = `${He},${ee[He].pointers[se.index]}`, ut = He;
                ee[He].pointers[se.index] && (ee[nt] || (ee[nt] = [], ee[nt].xValues = [], ee[nt].pointers = []), He = nt), ee[ut].pointers[se.index] += 1;
              } else {
                ee[He] = [], ee[He].xValues = [];
                let nt = [];
                for (let ut = 0; ut < se.chart.series.length; ut++)
                  nt[ut] = 0;
                ee[He].pointers = nt, ee[He].pointers[se.index] = 1;
              }
              for (ee[He].x = Ye.x, ee[He].name = Xe, ee[He].xValues[we] = Ye.x; De < be; )
                Ne = Ye[Ee = ye[De]], ee[He][pe + De] = x(Le.categoryMap[Ee][Ne], Le.dateTimeValueAxisMap[Ee] ? U.dateFormat(Q.dateFormat, Ne) : null, Ne), De++;
            }), pe += De;
          }
        }), ee)
          Object.hasOwnProperty.call(ee, xe) && V.push(ee[xe]);
        for (me = I ? [G, W] : [W], pe = re.length; pe--; )
          R = re[pe][0], Y = re[pe][1], de = J[R], V.sort(function(se, he) {
            return se.xValues[R] - he.xValues[R];
          }), le = Z(de), me[0].splice(Y, 0, le), I && me[1] && me[1].splice(Y, 0, le), V.forEach(function(se) {
            let he = se.name;
            de && !v(he) && (de.dateTime ? (se.x instanceof Date && (se.x = se.x.getTime()), he = U.dateFormat(Q.dateFormat, se.x)) : he = de.categories ? x(de.names[se.x], de.categories[se.x], se.x) : se.x), se.splice(Y, 0, he);
          });
        return S(this, "exportData", { dataRows: me = me.concat(V) }), me;
      }
      function M(I) {
        let R = (Y) => {
          if (!Y.tagName || Y.tagName === "#text")
            return Y.textContent || "";
          let F = Y.attributes, U = `<${Y.tagName}`;
          return F && Object.keys(F).forEach((Q) => {
            let J = F[Q];
            U += ` ${Q}="${J}"`;
          }), U += ">" + (Y.textContent || ""), (Y.children || []).forEach((Q) => {
            U += R(Q);
          }), U += `</${Y.tagName}>`;
        };
        return R(this.getTableAST(I));
      }
      function D(I) {
        let R = 0, Y = [], F = this.options, U = I ? 1.1.toLocaleString()[1] : ".", Q = x(F.exporting.useMultiLevelHeaders, !0), J = this.getDataRows(Q), ee = Q ? J.shift() : null, V = J.shift(), G = function(q, Z) {
          let ne = q.length;
          if (Z.length !== ne)
            return !1;
          for (; ne--; )
            if (q[ne] !== Z[ne])
              return !1;
          return !0;
        }, W = function(q, Z, ne, ie) {
          let re = x(ie, ""), de = "highcharts-text" + (Z ? " " + Z : "");
          return typeof re == "number" ? (re = re.toString(), U === "," && (re = re.replace(".", U)), de = "highcharts-number") : ie || (de = "highcharts-empty"), { tagName: q, attributes: ne = P({ class: de }, ne), textContent: re };
        };
        F.exporting.tableCaption !== !1 && Y.push({ tagName: "caption", attributes: { class: "highcharts-table-caption" }, textContent: x(F.exporting.tableCaption, F.title.text ? F.title.text : "Chart") });
        for (let q = 0, Z = J.length; q < Z; ++q)
          J[q].length > R && (R = J[q].length);
        Y.push(function(q, Z, ne) {
          let ie = [], re = 0, de = ne || Z && Z.length, me, ce = 0, pe;
          if (Q && q && Z && !G(q, Z)) {
            let xe = [];
            for (; re < de; ++re)
              if ((me = q[re]) === q[re + 1])
                ++ce;
              else if (ce)
                xe.push(W("th", "highcharts-table-topheading", { scope: "col", colspan: ce + 1 }, me)), ce = 0;
              else {
                me === Z[re] ? F.exporting.useRowspanHeaders ? (pe = 2, delete Z[re]) : (pe = 1, Z[re] = "") : pe = 1;
                let le = W("th", "highcharts-table-topheading", { scope: "col" }, me);
                pe > 1 && le.attributes && (le.attributes.valign = "top", le.attributes.rowspan = pe), xe.push(le);
              }
            ie.push({ tagName: "tr", children: xe });
          }
          if (Z) {
            let xe = [];
            for (re = 0, de = Z.length; re < de; ++re)
              Z[re] !== void 0 && xe.push(W("th", null, { scope: "col" }, Z[re]));
            ie.push({ tagName: "tr", children: xe });
          }
          return { tagName: "thead", children: ie };
        }(ee, V, Math.max(R, V.length)));
        let ae = [];
        J.forEach(function(q) {
          let Z = [];
          for (let ne = 0; ne < R; ne++)
            Z.push(W(ne ? "td" : "th", null, ne ? {} : { scope: "row" }, q[ne]));
          ae.push({ tagName: "tr", children: Z });
        }), Y.push({ tagName: "tbody", children: ae });
        let z = { tree: { tagName: "table", id: `highcharts-data-table-${this.index}`, children: Y } };
        return S(this, "aftergetTableAST", z), z.tree;
      }
      function C() {
        this.toggleDataTable(!1);
      }
      function b(I) {
        let R = (I = x(I, !this.isDataTableVisible)) && !this.dataTableDiv;
        if (R && (this.dataTableDiv = h.createElement("div"), this.dataTableDiv.className = "highcharts-data-table", this.renderTo.parentNode.insertBefore(this.dataTableDiv, this.renderTo.nextSibling)), this.dataTableDiv) {
          let J = this.dataTableDiv.style, ee = J.display;
          J.display = I ? "block" : "none", I ? (this.dataTableDiv.innerHTML = o.emptyHTML, new o([this.getTableAST()]).addToDOM(this.dataTableDiv), S(this, "afterViewData", { element: this.dataTableDiv, wasHidden: R || ee !== J.display })) : S(this, "afterHideData");
        }
        this.isDataTableVisible = I;
        let Y = this.exportDivElements, F = this.options.exporting, U = F && F.buttons && F.buttons.contextButton.menuItems, Q = this.options.lang;
        if (F && F.menuItemDefinitions && Q && Q.viewData && Q.hideData && U && Y) {
          let J = Y[U.indexOf("viewData")];
          J && o.setElementHTML(J, this.isDataTableVisible ? Q.hideData : Q.viewData);
        }
      }
      function p() {
        this.toggleDataTable(!0);
      }
      function L(I, R) {
        let Y = c.navigator, F = c.URL || c.webkitURL || c;
        try {
          if (Y.msSaveOrOpenBlob && c.MSBlobBuilder) {
            let U = new c.MSBlobBuilder();
            return U.append(I), U.getBlob("image/svg+xml");
          }
          return F.createObjectURL(new c.Blob(["\uFEFF" + I], { type: R }));
        } catch {
        }
      }
      function B() {
        let I = this, R = I.dataTableDiv, Y = (U, Q) => U.children[Q].textContent, F = (U, Q) => (J, ee) => {
          let V, G;
          return V = Y(Q ? J : ee, U), G = Y(Q ? ee : J, U), V === "" || G === "" || isNaN(V) || isNaN(G) ? V.toString().localeCompare(G) : V - G;
        };
        if (R && I.options.exporting && I.options.exporting.allowTableSorting) {
          let U = R.querySelector("thead tr");
          U && U.childNodes.forEach((Q) => {
            let J = Q.closest("table");
            Q.addEventListener("click", function() {
              let ee = [...R.querySelectorAll("tr:not(thead tr)")], V = [...Q.parentNode.children];
              ee.sort(F(V.indexOf(Q), I.ascendingOrderInTable = !I.ascendingOrderInTable)).forEach((G) => {
                J.appendChild(G);
              }), V.forEach((G) => {
                ["highcharts-sort-ascending", "highcharts-sort-descending"].forEach((W) => {
                  G.classList.contains(W) && G.classList.remove(W);
                });
              }), Q.classList.add(I.ascendingOrderInTable ? "highcharts-sort-ascending" : "highcharts-sort-descending");
            });
          });
        }
      }
      function T() {
        this.options && this.options.exporting && this.options.exporting.showTable && !this.options.chart.forExport && this.viewData();
      }
      function O() {
        this.dataTableDiv?.remove();
      }
      return { compose: function(I, R) {
        let Y = I.prototype;
        if (!Y.getCSV) {
          let F = y().exporting;
          g(I, "afterViewData", B), g(I, "render", T), g(I, "destroy", O), Y.downloadCSV = A, Y.downloadXLS = $, Y.getCSV = j, Y.getDataRows = N, Y.getTable = M, Y.getTableAST = D, Y.hideData = C, Y.toggleDataTable = b, Y.viewData = p, F && (P(F.menuItemDefinitions, { downloadCSV: { textKey: "downloadCSV", onclick: function() {
            this.downloadCSV();
          } }, downloadXLS: { textKey: "downloadXLS", onclick: function() {
            this.downloadXLS();
          } }, viewData: { textKey: "viewData", onclick: function() {
            k.call(this, this.toggleDataTable);
          } } }), F.buttons && F.buttons.contextButton.menuItems && F.buttons.contextButton.menuItems.push("separator", "downloadCSV", "downloadXLS", "viewData")), u(s);
          let { arearange: U, gantt: Q, map: J, mapbubble: ee, treemap: V, xrange: G } = R.types;
          U && (U.prototype.keyToAxis = { low: "y", high: "y" }), Q && (Q.prototype.exportKey = "name", Q.prototype.keyToAxis = { start: "x", end: "x" }), J && (J.prototype.exportKey = "name"), ee && (ee.prototype.exportKey = "name"), V && (V.prototype.exportKey = "name"), G && (G.prototype.keyToAxis = { x2: "x" });
        }
      } };
    }), i(n, "masters/modules/export-data.src.js", [n["Core/Globals.js"], n["Extensions/DownloadURL.js"], n["Extensions/ExportData/ExportData.js"]], function(o, a, r) {
      return o.dataURLtoBlob = o.dataURLtoBlob || a.dataURLtoBlob, o.downloadURL = o.downloadURL || a.downloadURL, r.compose(o.Chart, o.Series), o;
    });
  });
})(jk);
var o$ = jk.exports;
const r$ = /* @__PURE__ */ en(o$);
var Hk = { exports: {} };
(function(e) {
  /**
  * Highcharts JS v11.4.8 (2024-08-29)
  *
  * Annotations module
  *
  * (c) 2009-2024 Torstein Honsi
  *
  * License: www.highcharts.com/license
  */
  (function(t) {
    e.exports ? (t.default = t, e.exports = t) : t(typeof Highcharts < "u" ? Highcharts : void 0);
  })(function(t) {
    var n = t ? t._modules : {};
    function i(o, a, r, s) {
      o.hasOwnProperty(a) || (o[a] = s.apply(null, r), typeof CustomEvent == "function" && t.win.dispatchEvent(new CustomEvent("HighchartsModuleLoaded", { detail: { path: a, module: o[a] } })));
    }
    i(n, "Extensions/Annotations/AnnotationChart.js", [n["Core/Utilities.js"]], function(o) {
      var a;
      let { addEvent: r, erase: s, find: l, fireEvent: d, pick: y, wrap: u } = o;
      function m(f, S) {
        let w = this.initAnnotation(f);
        return this.options.annotations.push(w.options), y(S, !0) && (w.redraw(), w.graphic.attr({ opacity: 1 })), w;
      }
      function h() {
        let f = this;
        f.plotBoxClip = this.renderer.clipRect(this.plotBox), f.controlPointsGroup = f.renderer.g("control-points").attr({ zIndex: 99 }).clip(f.plotBoxClip).add(), f.options.annotations.forEach((S, w) => {
          if (!f.annotations.some((x) => x.options === S)) {
            let x = f.initAnnotation(S);
            f.options.annotations[w] = x.options;
          }
        }), f.drawAnnotations(), r(f, "redraw", f.drawAnnotations), r(f, "destroy", function() {
          f.plotBoxClip.destroy(), f.controlPointsGroup.destroy();
        }), r(f, "exportData", function(S) {
          let w = f.annotations, x = (this.options.exporting && this.options.exporting.csv || {}).columnHeaderFormatter, k = !S.dataRows[1].xValues, A = f.options.lang && f.options.lang.exportData && f.options.lang.exportData.annotationHeader, $ = S.dataRows[0].length, j = f.options.exporting && f.options.exporting.csv && f.options.exporting.csv.annotations && f.options.exporting.csv.annotations.itemDelimiter, N = f.options.exporting && f.options.exporting.csv && f.options.exporting.csv.annotations && f.options.exporting.csv.annotations.join;
          w.forEach((C) => {
            C.options.labelOptions && C.options.labelOptions.includeInDataExport && C.labels.forEach((b) => {
              if (b.options.text) {
                let p = b.options.text;
                b.points.forEach((L) => {
                  let B = L.x, T = L.series.xAxis ? L.series.xAxis.index : -1, O = !1;
                  if (T === -1) {
                    let I = S.dataRows[0].length, R = Array(I);
                    for (let Y = 0; Y < I; ++Y)
                      R[Y] = "";
                    R.push(p), R.xValues = [], R.xValues[T] = B, S.dataRows.push(R), O = !0;
                  }
                  if (O || S.dataRows.forEach((I) => {
                    !O && I.xValues && T !== void 0 && B === I.xValues[T] && (N && I.length > $ ? I[I.length - 1] += j + p : I.push(p), O = !0);
                  }), !O) {
                    let I = S.dataRows[0].length, R = Array(I);
                    for (let Y = 0; Y < I; ++Y)
                      R[Y] = "";
                    R[0] = B, R.push(p), R.xValues = [], T !== void 0 && (R.xValues[T] = B), S.dataRows.push(R);
                  }
                });
              }
            });
          });
          let M = 0;
          S.dataRows.forEach((C) => {
            M = Math.max(M, C.length);
          });
          let D = M - S.dataRows[0].length;
          for (let C = 0; C < D; C++) {
            let b = function(p) {
              let L;
              return x && (L = x(p)) !== !1 ? L : (L = A + " " + p, k ? { columnTitle: L, topLevelColumnTitle: L } : L);
            }(C + 1);
            k ? (S.dataRows[0].push(b.topLevelColumnTitle), S.dataRows[1].push(b.columnTitle)) : S.dataRows[0].push(b);
          }
        });
      }
      function c() {
        this.plotBoxClip.attr(this.plotBox), this.annotations.forEach((f) => {
          f.redraw(), f.graphic.animate({ opacity: 1 }, f.animationConfig);
        });
      }
      function g(f) {
        let S = this.annotations, w = f.coll === "annotations" ? f : l(S, function(x) {
          return x.options.id === f;
        });
        w && (d(w, "remove"), s(this.options.annotations, w.options), s(S, w), w.destroy());
      }
      function v() {
        this.annotations = [], this.options.annotations || (this.options.annotations = []);
      }
      function P(f) {
        this.chart.hasDraggedAnnotation || f.apply(this, Array.prototype.slice.call(arguments, 1));
      }
      return (a || (a = {})).compose = function(f, S, w) {
        let x = S.prototype;
        if (!x.addAnnotation) {
          let k = w.prototype;
          r(S, "afterInit", v), x.addAnnotation = m, x.callbacks.push(h), x.collectionsWithInit.annotations = [m], x.collectionsWithUpdate.push("annotations"), x.drawAnnotations = c, x.removeAnnotation = g, x.initAnnotation = function(A) {
            let $ = new (f.types[A.type] || f)(this, A);
            return this.annotations.push($), $;
          }, u(k, "onContainerMouseDown", P);
        }
      }, a;
    }), i(n, "Extensions/Annotations/AnnotationDefaults.js", [n["Core/Utilities.js"]], function(o) {
      let { defined: a } = o;
      return { visible: !0, animation: {}, crop: !0, draggable: "xy", labelOptions: { align: "center", allowOverlap: !1, backgroundColor: "rgba(0, 0, 0, 0.75)", borderColor: "#000000", borderRadius: 3, borderWidth: 1, className: "highcharts-no-tooltip", crop: !1, formatter: function() {
        return a(this.y) ? "" + this.y : "Annotation label";
      }, includeInDataExport: !0, overflow: "justify", padding: 5, shadow: !1, shape: "callout", style: { fontSize: "0.7em", fontWeight: "normal", color: "contrast" }, useHTML: !1, verticalAlign: "bottom", x: 0, y: -16 }, shapeOptions: { stroke: "rgba(0, 0, 0, 0.75)", strokeWidth: 1, fill: "rgba(0, 0, 0, 0.75)", r: 0, snap: 2 }, controlPointOptions: { events: {}, style: { cursor: "pointer", fill: "#ffffff", stroke: "#000000", "stroke-width": 2 }, height: 10, symbol: "circle", visible: !1, width: 10 }, events: {}, zIndex: 6 };
    }), i(n, "Extensions/Annotations/EventEmitter.js", [n["Core/Globals.js"], n["Core/Utilities.js"]], function(o, a) {
      let { doc: r, isTouchDevice: s } = o, { addEvent: l, fireEvent: d, objectEach: y, pick: u, removeEvent: m } = a;
      return class {
        addEvents() {
          let h = this, c = function(g) {
            l(g, s ? "touchstart" : "mousedown", (v) => {
              h.onMouseDown(v);
            }, { passive: !1 });
          };
          if (c(this.graphic.element), (h.labels || []).forEach((g) => {
            g.options.useHTML && g.graphic.text && c(g.graphic.text.element);
          }), y(h.options.events, (g, v) => {
            let P = function(f) {
              v === "click" && h.cancelClick || g.call(h, h.chart.pointer?.normalize(f), h.target);
            };
            (h.nonDOMEvents || []).indexOf(v) === -1 ? (l(h.graphic.element, v, P, { passive: !1 }), h.graphic.div && l(h.graphic.div, v, P, { passive: !1 })) : l(h, v, P, { passive: !1 });
          }), h.options.draggable && (l(h, "drag", h.onDrag), !h.graphic.renderer.styledMode)) {
            let g = { cursor: { x: "ew-resize", y: "ns-resize", xy: "move" }[h.options.draggable] };
            h.graphic.css(g), (h.labels || []).forEach((v) => {
              v.options.useHTML && v.graphic.text && v.graphic.text.css(g);
            });
          }
          h.isUpdating || d(h, "add");
        }
        destroy() {
          this.removeDocEvents(), m(this), this.hcEvents = null;
        }
        mouseMoveToRadians(h, c, g) {
          let v = h.prevChartY - g, P = h.prevChartX - c, f = h.chartY - g, S = h.chartX - c, w;
          return this.chart.inverted && (w = P, P = v, v = w, w = S, S = f, f = w), Math.atan2(f, S) - Math.atan2(v, P);
        }
        mouseMoveToScale(h, c, g) {
          let v = h.prevChartX - c, P = h.prevChartY - g, f = h.chartX - c, S = h.chartY - g, w = (f || 1) / (v || 1), x = (S || 1) / (P || 1);
          if (this.chart.inverted) {
            let k = x;
            x = w, w = k;
          }
          return { x: w, y: x };
        }
        mouseMoveToTranslation(h) {
          let c = h.chartX - h.prevChartX, g = h.chartY - h.prevChartY, v;
          return this.chart.inverted && (v = g, g = c, c = v), { x: c, y: g };
        }
        onDrag(h) {
          if (this.chart.isInsidePlot(h.chartX - this.chart.plotLeft, h.chartY - this.chart.plotTop, { visiblePlotOnly: !0 })) {
            let c = this.mouseMoveToTranslation(h);
            this.options.draggable === "x" && (c.y = 0), this.options.draggable === "y" && (c.x = 0), this.points.length ? this.translate(c.x, c.y) : (this.shapes.forEach((g) => g.translate(c.x, c.y)), this.labels.forEach((g) => g.translate(c.x, c.y))), this.redraw(!1);
          }
        }
        onMouseDown(h) {
          if (h.preventDefault && h.preventDefault(), h.button === 2)
            return;
          let c = this, g = c.chart.pointer, v = h?.sourceCapabilities?.firesTouchEvents || !1, P = (h = g?.normalize(h) || h).chartX, f = h.chartY;
          c.cancelClick = !1, c.chart.hasDraggedAnnotation = !0, c.removeDrag = l(r, s || v ? "touchmove" : "mousemove", function(S) {
            c.hasDragged = !0, (S = g?.normalize(S) || S).prevChartX = P, S.prevChartY = f, d(c, "drag", S), P = S.chartX, f = S.chartY;
          }, s || v ? { passive: !1 } : void 0), c.removeMouseUp = l(r, s || v ? "touchend" : "mouseup", function() {
            let S = u(c.target && c.target.annotation, c.target);
            S && (S.cancelClick = c.hasDragged), c.cancelClick = c.hasDragged, c.chart.hasDraggedAnnotation = !1, c.hasDragged && d(u(S, c), "afterUpdate"), c.hasDragged = !1, c.onMouseUp();
          }, s || v ? { passive: !1 } : void 0);
        }
        onMouseUp() {
          this.removeDocEvents();
        }
        removeDocEvents() {
          this.removeDrag && (this.removeDrag = this.removeDrag()), this.removeMouseUp && (this.removeMouseUp = this.removeMouseUp());
        }
      };
    }), i(n, "Extensions/Annotations/ControlPoint.js", [n["Extensions/Annotations/EventEmitter.js"], n["Core/Utilities.js"]], function(o, a) {
      let { merge: r, pick: s } = a;
      return class extends o {
        constructor(l, d, y, u) {
          super(), this.nonDOMEvents = ["drag"], this.chart = l, this.target = d, this.options = y, this.index = s(y.index, u);
        }
        destroy() {
          super.destroy(), this.graphic && (this.graphic = this.graphic.destroy()), this.chart = null, this.target = null, this.options = null;
        }
        redraw(l) {
          this.graphic[l ? "animate" : "attr"](this.options.positioner.call(this, this.target));
        }
        render() {
          let l = this.chart, d = this.options;
          this.graphic = l.renderer.symbol(d.symbol, 0, 0, d.width, d.height).add(l.controlPointsGroup).css(d.style), this.setVisibility(d.visible), this.addEvents();
        }
        setVisibility(l) {
          this.graphic[l ? "show" : "hide"](), this.options.visible = l;
        }
        update(l) {
          let d = this.chart, y = this.target, u = this.index, m = r(!0, this.options, l);
          this.destroy(), this.constructor(d, y, m, u), this.render(d.controlPointsGroup), this.redraw();
        }
      };
    }), i(n, "Extensions/Annotations/MockPoint.js", [n["Core/Series/SeriesRegistry.js"], n["Core/Utilities.js"]], function(o, a) {
      let { series: { prototype: r } } = o, { defined: s, fireEvent: l } = a;
      class d {
        static fromPoint(u) {
          return new d(u.series.chart, null, { x: u.x, y: u.y, xAxis: u.series.xAxis, yAxis: u.series.yAxis });
        }
        static pointToPixels(u, m) {
          let h = u.series, c = h.chart, g = u.plotX || 0, v = u.plotY || 0, P;
          return c.inverted && (u.mock ? (g = u.plotY, v = u.plotX) : (g = c.plotWidth - (u.plotY || 0), v = c.plotHeight - (u.plotX || 0))), h && !m && (g += (P = h.getPlotBox()).translateX, v += P.translateY), { x: g, y: v };
        }
        static pointToOptions(u) {
          return { x: u.x, y: u.y, xAxis: u.series.xAxis, yAxis: u.series.yAxis };
        }
        constructor(u, m, h) {
          this.mock = !0, this.series = { visible: !0, chart: u, getPlotBox: r.getPlotBox }, this.target = m || null, this.options = h, this.applyOptions(this.getOptions());
        }
        applyOptions(u) {
          this.command = u.command, this.setAxis(u, "x"), this.setAxis(u, "y"), this.refresh();
        }
        getLabelConfig() {
          return { x: this.x, y: this.y, point: this };
        }
        getOptions() {
          return this.hasDynamicOptions() ? this.options(this.target) : this.options;
        }
        hasDynamicOptions() {
          return typeof this.options == "function";
        }
        isInsidePlot() {
          let u = this.plotX, m = this.plotY, h = this.series.xAxis, c = this.series.yAxis, g = { x: u, y: m, isInsidePlot: !0, options: {} };
          return h && (g.isInsidePlot = s(u) && u >= 0 && u <= h.len), c && (g.isInsidePlot = g.isInsidePlot && s(m) && m >= 0 && m <= c.len), l(this.series.chart, "afterIsInsidePlot", g), g.isInsidePlot;
        }
        refresh() {
          let u = this.series, m = u.xAxis, h = u.yAxis, c = this.getOptions();
          m ? (this.x = c.x, this.plotX = m.toPixels(c.x, !0)) : (this.x = void 0, this.plotX = c.x), h ? (this.y = c.y, this.plotY = h.toPixels(c.y, !0)) : (this.y = null, this.plotY = c.y), this.isInside = this.isInsidePlot();
        }
        refreshOptions() {
          let u = this.series, m = u.xAxis, h = u.yAxis;
          this.x = this.options.x = m ? this.options.x = m.toValue(this.plotX, !0) : this.plotX, this.y = this.options.y = h ? h.toValue(this.plotY, !0) : this.plotY;
        }
        rotate(u, m, h) {
          if (!this.hasDynamicOptions()) {
            let c = Math.cos(h), g = Math.sin(h), v = this.plotX - u, P = this.plotY - m;
            this.plotX = v * c - P * g + u, this.plotY = v * g + P * c + m, this.refreshOptions();
          }
        }
        scale(u, m, h, c) {
          if (!this.hasDynamicOptions()) {
            let g = this.plotX * h, v = this.plotY * c;
            this.plotX = (1 - h) * u + g, this.plotY = (1 - c) * m + v, this.refreshOptions();
          }
        }
        setAxis(u, m) {
          let h = m + "Axis", c = u[h], g = this.series.chart;
          this.series[h] = typeof c == "object" ? c : s(c) ? g[h][c] || g.get(c) : null;
        }
        toAnchor() {
          let u = [this.plotX, this.plotY, 0, 0];
          return this.series.chart.inverted && (u[0] = this.plotY, u[1] = this.plotX), u;
        }
        translate(u, m, h, c) {
          this.hasDynamicOptions() || (this.plotX += h, this.plotY += c, this.refreshOptions());
        }
      }
      return d;
    }), i(n, "Extensions/Annotations/ControlTarget.js", [n["Extensions/Annotations/ControlPoint.js"], n["Extensions/Annotations/MockPoint.js"], n["Core/Utilities.js"]], function(o, a, r) {
      var s;
      return function(l) {
        function d() {
          let x = this.controlPoints, k = this.options.controlPoints || [];
          k.forEach((A, $) => {
            let j = r.merge(this.options.controlPointOptions, A);
            j.index || (j.index = $), k[$] = j, x.push(new o(this.chart, this, j));
          });
        }
        function y(x) {
          let k = x.series.getPlotBox(), A = x.series.chart, $ = x.mock ? x.toAnchor() : A.tooltip && A.tooltip.getAnchor.call({ chart: x.series.chart }, x) || [0, 0, 0, 0], j = { x: $[0] + (this.options.x || 0), y: $[1] + (this.options.y || 0), height: $[2] || 0, width: $[3] || 0 };
          return { relativePosition: j, absolutePosition: r.merge(j, { x: j.x + (x.mock ? k.translateX : A.plotLeft), y: j.y + (x.mock ? k.translateY : A.plotTop) }) };
        }
        function u() {
          this.controlPoints.forEach((x) => x.destroy()), this.chart = null, this.controlPoints = null, this.points = null, this.options = null, this.annotation && (this.annotation = null);
        }
        function m() {
          let x = this.options;
          return x.points || x.point && r.splat(x.point);
        }
        function h() {
          let x, k, A = this.getPointsOptions(), $ = this.points, j = A && A.length || 0;
          for (x = 0; x < j; x++) {
            if (!(k = this.point(A[x], $[x]))) {
              $.length = 0;
              return;
            }
            k.mock && k.refresh(), $[x] = k;
          }
          return $;
        }
        function c(x, k) {
          if (x && x.series)
            return x;
          if (!k || k.series === null) {
            if (r.isObject(x))
              k = new a(this.chart, this, x);
            else if (r.isString(x))
              k = this.chart.get(x) || null;
            else if (typeof x == "function") {
              let A = x.call(k, this);
              k = A.series ? A : new a(this.chart, this, x);
            }
          }
          return k;
        }
        function g(x) {
          this.controlPoints.forEach((k) => k.redraw(x));
        }
        function v() {
          this.controlPoints.forEach((x) => x.render());
        }
        function P(x, k, A, $, j) {
          if (this.chart.inverted) {
            let N = k;
            k = A, A = N;
          }
          this.points.forEach((N, M) => this.transformPoint(x, k, A, $, j, M), this);
        }
        function f(x, k, A, $, j, N) {
          let M = this.points[N];
          M.mock || (M = this.points[N] = a.fromPoint(M)), M[x](k, A, $, j);
        }
        function S(x, k) {
          this.transform("translate", null, null, x, k);
        }
        function w(x, k, A) {
          this.transformPoint("translate", null, null, x, k, A);
        }
        l.compose = function(x) {
          let k = x.prototype;
          k.addControlPoints || r.merge(!0, k, { addControlPoints: d, anchor: y, destroyControlTarget: u, getPointsOptions: m, linkPoints: h, point: c, redrawControlPoints: g, renderControlPoints: v, transform: P, transformPoint: f, translate: S, translatePoint: w });
        };
      }(s || (s = {})), s;
    }), i(n, "Extensions/Annotations/Controllables/Controllable.js", [n["Extensions/Annotations/ControlTarget.js"], n["Core/Utilities.js"]], function(o, a) {
      let { merge: r } = a;
      class s {
        constructor(d, y, u, m) {
          this.annotation = d, this.chart = d.chart, this.collection = m === "label" ? "labels" : "shapes", this.controlPoints = [], this.options = y, this.points = [], this.index = u, this.itemType = m, this.init(d, y, u);
        }
        attr(...d) {
          this.graphic.attr.apply(this.graphic, arguments);
        }
        attrsFromOptions(d) {
          let y, u, m = this.constructor.attrsMap, h = {}, c = this.chart.styledMode;
          for (y in d)
            u = m[y], m[y] === void 0 || c && ["fill", "stroke", "stroke-width"].indexOf(u) !== -1 || (h[u] = d[y]);
          return h;
        }
        destroy() {
          this.graphic && (this.graphic = this.graphic.destroy()), this.tracker && (this.tracker = this.tracker.destroy()), this.destroyControlTarget();
        }
        init(d, y, u) {
          this.annotation = d, this.chart = d.chart, this.options = y, this.points = [], this.controlPoints = [], this.index = u, this.linkPoints(), this.addControlPoints();
        }
        redraw(d) {
          this.redrawControlPoints(d);
        }
        render(d) {
          this.options.className && this.graphic && this.graphic.addClass(this.options.className), this.renderControlPoints();
        }
        rotate(d, y, u) {
          this.transform("rotate", d, y, u);
        }
        scale(d, y, u, m) {
          this.transform("scale", d, y, u, m);
        }
        setControlPointsVisibility(d) {
          this.controlPoints.forEach((y) => {
            y.setVisibility(d);
          });
        }
        shouldBeDrawn() {
          return !!this.points.length;
        }
        translateShape(d, y, u) {
          let m = this.annotation.chart, h = this.annotation.userOptions, c = m.annotations.indexOf(this.annotation), g = m.options.annotations[c];
          this.translatePoint(d, y, 0), u && this.translatePoint(d, y, 1), g[this.collection][this.index].point = this.options.point, h[this.collection][this.index].point = this.options.point;
        }
        update(d) {
          let y = this.annotation, u = r(!0, this.options, d), m = this.graphic.parentGroup, h = this.constructor;
          this.destroy(), r(!0, this, new h(y, u, this.index, this.itemType)), this.render(m), this.redraw();
        }
      }
      return o.compose(s), s;
    }), i(n, "Extensions/Annotations/Controllables/ControllableDefaults.js", [], function() {
      return { defaultMarkers: { arrow: { tagName: "marker", attributes: { id: "arrow", refY: 5, refX: 9, markerWidth: 10, markerHeight: 10 }, children: [{ tagName: "path", attributes: { d: "M 0 0 L 10 5 L 0 10 Z", "stroke-width": 0 } }] }, "reverse-arrow": { tagName: "marker", attributes: { id: "reverse-arrow", refY: 5, refX: 1, markerWidth: 10, markerHeight: 10 }, children: [{ tagName: "path", attributes: { d: "M 0 5 L 10 0 L 10 10 Z", "stroke-width": 0 } }] } } };
    }), i(n, "Extensions/Annotations/Controllables/ControllablePath.js", [n["Extensions/Annotations/Controllables/Controllable.js"], n["Extensions/Annotations/Controllables/ControllableDefaults.js"], n["Core/Globals.js"], n["Core/Utilities.js"]], function(o, a, r, s) {
      let { defaultMarkers: l } = a, { addEvent: d, defined: y, extend: u, merge: m, uniqueKey: h } = s, c = P("marker-end"), g = P("marker-start"), v = "rgba(192,192,192," + (r.svg ? 1e-4 : 2e-3) + ")";
      function P(x) {
        return function(k) {
          this.attr(x, "url(#" + k + ")");
        };
      }
      function f() {
        this.options.defs = m(l, this.options.defs || {});
      }
      function S(x, k) {
        let A = { attributes: { id: x } }, $ = { stroke: k.color || "none", fill: k.color || "rgba(0, 0, 0, 0.75)" };
        A.children = k.children && k.children.map(function(M) {
          return m($, M);
        });
        let j = m(!0, { attributes: { markerWidth: 20, markerHeight: 20, refX: 0, refY: 0, orient: "auto" } }, k, A), N = this.definition(j);
        return N.id = x, N;
      }
      class w extends o {
        static compose(k, A) {
          let $ = A.prototype;
          $.addMarker || (d(k, "afterGetContainer", f), $.addMarker = S);
        }
        constructor(k, A, $) {
          super(k, A, $, "shape"), this.type = "path";
        }
        toD() {
          let k = this.options.d;
          if (k)
            return typeof k == "function" ? k.call(this) : k;
          let A = this.points, $ = A.length, j = [], N = $, M = A[0], D = N && this.anchor(M).absolutePosition, C = 0, b;
          if (D)
            for (j.push(["M", D.x, D.y]); ++C < $ && N; )
              b = (M = A[C]).command || "L", D = this.anchor(M).absolutePosition, b === "M" ? j.push([b, D.x, D.y]) : b === "L" ? j.push([b, D.x, D.y]) : b === "Z" && j.push([b]), N = M.series.visible;
          return N && this.graphic ? this.chart.renderer.crispLine(j, this.graphic.strokeWidth()) : null;
        }
        shouldBeDrawn() {
          return super.shouldBeDrawn() || !!this.options.d;
        }
        render(k) {
          let A = this.options, $ = this.attrsFromOptions(A);
          this.graphic = this.annotation.chart.renderer.path([["M", 0, 0]]).attr($).add(k), this.tracker = this.annotation.chart.renderer.path([["M", 0, 0]]).addClass("highcharts-tracker-line").attr({ zIndex: 2 }).add(k), this.annotation.chart.styledMode || this.tracker.attr({ "stroke-linejoin": "round", stroke: v, fill: v, "stroke-width": this.graphic.strokeWidth() + 2 * A.snap }), super.render(), u(this.graphic, { markerStartSetter: g, markerEndSetter: c }), this.setMarkers(this);
        }
        redraw(k) {
          if (this.graphic) {
            let A = this.toD(), $ = k ? "animate" : "attr";
            A ? (this.graphic[$]({ d: A }), this.tracker[$]({ d: A })) : (this.graphic.attr({ d: "M 0 -9000000000" }), this.tracker.attr({ d: "M 0 -9000000000" })), this.graphic.placed = this.tracker.placed = !!A;
          }
          super.redraw(k);
        }
        setMarkers(k) {
          let A = k.options, $ = k.chart, j = $.options.defs, N = A.fill, M = y(N) && N !== "none" ? N : A.stroke;
          ["markerStart", "markerEnd"].forEach(function(D) {
            let C, b, p, L, B = A[D];
            if (B) {
              for (p in j)
                if ((B === ((C = j[p]).attributes && C.attributes.id) || B === C.id) && C.tagName === "marker") {
                  b = C;
                  break;
                }
              b && (L = k[D] = $.renderer.addMarker((A.id || h()) + "-" + B, m(b, { color: M })), k.attr(D, L.getAttribute("id")));
            }
          });
        }
      }
      return w.attrsMap = { dashStyle: "dashstyle", strokeWidth: "stroke-width", stroke: "stroke", fill: "fill", zIndex: "zIndex" }, w;
    }), i(n, "Extensions/Annotations/Controllables/ControllableRect.js", [n["Extensions/Annotations/Controllables/Controllable.js"], n["Extensions/Annotations/Controllables/ControllablePath.js"], n["Core/Utilities.js"]], function(o, a, r) {
      let { merge: s } = r;
      class l extends o {
        constructor(y, u, m) {
          super(y, u, m, "shape"), this.type = "rect", this.translate = super.translateShape;
        }
        render(y) {
          let u = this.attrsFromOptions(this.options);
          this.graphic = this.annotation.chart.renderer.rect(0, -9e9, 0, 0).attr(u).add(y), super.render();
        }
        redraw(y) {
          if (this.graphic) {
            let u = this.anchor(this.points[0]).absolutePosition;
            u ? this.graphic[y ? "animate" : "attr"]({ x: u.x, y: u.y, width: this.options.width, height: this.options.height }) : this.attr({ x: 0, y: -9e9 }), this.graphic.placed = !!u;
          }
          super.redraw(y);
        }
      }
      return l.attrsMap = s(a.attrsMap, { width: "width", height: "height" }), l;
    }), i(n, "Extensions/Annotations/Controllables/ControllableCircle.js", [n["Extensions/Annotations/Controllables/Controllable.js"], n["Extensions/Annotations/Controllables/ControllablePath.js"], n["Core/Utilities.js"]], function(o, a, r) {
      let { merge: s } = r;
      class l extends o {
        constructor(y, u, m) {
          super(y, u, m, "shape"), this.type = "circle", this.translate = super.translateShape;
        }
        redraw(y) {
          if (this.graphic) {
            let u = this.anchor(this.points[0]).absolutePosition;
            u ? this.graphic[y ? "animate" : "attr"]({ x: u.x, y: u.y, r: this.options.r }) : this.graphic.attr({ x: 0, y: -9e9 }), this.graphic.placed = !!u;
          }
          super.redraw.call(this, y);
        }
        render(y) {
          let u = this.attrsFromOptions(this.options);
          this.graphic = this.annotation.chart.renderer.circle(0, -9e9, 0).attr(u).add(y), super.render();
        }
        setRadius(y) {
          this.options.r = y;
        }
      }
      return l.attrsMap = s(a.attrsMap, { r: "r" }), l;
    }), i(n, "Extensions/Annotations/Controllables/ControllableEllipse.js", [n["Extensions/Annotations/Controllables/Controllable.js"], n["Extensions/Annotations/Controllables/ControllablePath.js"], n["Core/Utilities.js"]], function(o, a, r) {
      let { merge: s, defined: l } = r;
      class d extends o {
        constructor(u, m, h) {
          super(u, m, h, "shape"), this.type = "ellipse";
        }
        init(u, m, h) {
          l(m.yAxis) && m.points.forEach((c) => {
            c.yAxis = m.yAxis;
          }), l(m.xAxis) && m.points.forEach((c) => {
            c.xAxis = m.xAxis;
          }), super.init(u, m, h);
        }
        render(u) {
          this.graphic = this.annotation.chart.renderer.createElement("ellipse").attr(this.attrsFromOptions(this.options)).add(u), super.render();
        }
        translate(u, m) {
          super.translateShape(u, m, !0);
        }
        getDistanceFromLine(u, m, h, c) {
          return Math.abs((m.y - u.y) * h - (m.x - u.x) * c + m.x * u.y - m.y * u.x) / Math.sqrt((m.y - u.y) * (m.y - u.y) + (m.x - u.x) * (m.x - u.x));
        }
        getAttrs(u, m) {
          let h = u.x, c = u.y, g = m.x, v = m.y, P = (h + g) / 2, f = Math.sqrt((h - g) * (h - g) / 4 + (c - v) * (c - v) / 4), S = 180 * Math.atan((v - c) / (g - h)) / Math.PI;
          return P < h && (S += 180), { cx: P, cy: (c + v) / 2, rx: f, ry: this.getRY(), angle: S };
        }
        getRY() {
          let u = this.getYAxis();
          return l(u) ? Math.abs(u.toPixels(this.options.ry) - u.toPixels(0)) : this.options.ry;
        }
        getYAxis() {
          let u = this.options.yAxis;
          return this.chart.yAxis[u];
        }
        getAbsolutePosition(u) {
          return this.anchor(u).absolutePosition;
        }
        redraw(u) {
          if (this.graphic) {
            let m = this.getAbsolutePosition(this.points[0]), h = this.getAbsolutePosition(this.points[1]), c = this.getAttrs(m, h);
            m ? this.graphic[u ? "animate" : "attr"]({ cx: c.cx, cy: c.cy, rx: c.rx, ry: c.ry, rotation: c.angle, rotationOriginX: c.cx, rotationOriginY: c.cy }) : this.graphic.attr({ x: 0, y: -9e9 }), this.graphic.placed = !!m;
          }
          super.redraw(u);
        }
        setYRadius(u) {
          let m = this.annotation.userOptions.shapes;
          this.options.ry = u, m && m[0] && (m[0].ry = u, m[0].ry = u);
        }
      }
      return d.attrsMap = s(a.attrsMap, { ry: "ry" }), d;
    }), i(n, "Extensions/Annotations/Controllables/ControllableLabel.js", [n["Extensions/Annotations/Controllables/Controllable.js"], n["Core/Templating.js"], n["Extensions/Annotations/MockPoint.js"], n["Core/Utilities.js"]], function(o, a, r, s) {
      let { format: l } = a, { extend: d, isNumber: y, pick: u } = s;
      function m(c, g, v, P, f) {
        let S = f && f.anchorX, w = f && f.anchorY, x, k, A = v / 2;
        return y(S) && y(w) && (x = [["M", S, w]], (k = g - w) < 0 && (k = -P - k), k < v && (A = S < c + v / 2 ? k : v - k), w > g + P ? x.push(["L", c + A, g + P]) : w < g ? x.push(["L", c + A, g]) : S < c ? x.push(["L", c, g + P / 2]) : S > c + v && x.push(["L", c + v, g + P / 2])), x || [];
      }
      class h extends o {
        static alignedPosition(g, v) {
          let P = g.align, f = g.verticalAlign, S = (v.x || 0) + (g.x || 0), w = (v.y || 0) + (g.y || 0), x, k;
          return P === "right" ? x = 1 : P === "center" && (x = 2), x && (S += (v.width - (g.width || 0)) / x), f === "bottom" ? k = 1 : f === "middle" && (k = 2), k && (w += (v.height - (g.height || 0)) / k), { x: Math.round(S), y: Math.round(w) };
        }
        static compose(g) {
          g.prototype.symbols.connector = m;
        }
        static justifiedOptions(g, v, P, f) {
          let S, w = P.align, x = P.verticalAlign, k = v.box ? 0 : v.padding || 0, A = v.getBBox(), $ = { align: w, verticalAlign: x, x: P.x, y: P.y, width: v.width, height: v.height }, j = (f.x || 0) - g.plotLeft, N = (f.y || 0) - g.plotTop;
          return (S = j + k) < 0 && (w === "right" ? $.align = "left" : $.x = ($.x || 0) - S), (S = j + A.width - k) > g.plotWidth && (w === "left" ? $.align = "right" : $.x = ($.x || 0) + g.plotWidth - S), (S = N + k) < 0 && (x === "bottom" ? $.verticalAlign = "top" : $.y = ($.y || 0) - S), (S = N + A.height - k) > g.plotHeight && (x === "top" ? $.verticalAlign = "bottom" : $.y = ($.y || 0) + g.plotHeight - S), $;
        }
        constructor(g, v, P) {
          super(g, v, P, "label");
        }
        translatePoint(g, v) {
          super.translatePoint(g, v, 0);
        }
        translate(g, v) {
          let P = this.annotation.chart, f = this.annotation.userOptions, S = P.annotations.indexOf(this.annotation), w = P.options.annotations[S];
          if (P.inverted) {
            let x = g;
            g = v, v = x;
          }
          this.options.x += g, this.options.y += v, w[this.collection][this.index].x = this.options.x, w[this.collection][this.index].y = this.options.y, f[this.collection][this.index].x = this.options.x, f[this.collection][this.index].y = this.options.y;
        }
        render(g) {
          let v = this.options, P = this.attrsFromOptions(v), f = v.style;
          this.graphic = this.annotation.chart.renderer.label("", 0, -9999, v.shape, null, null, v.useHTML, null, "annotation-label").attr(P).add(g), this.annotation.chart.styledMode || (f.color === "contrast" && (f.color = this.annotation.chart.renderer.getContrast(h.shapesWithoutBackground.indexOf(v.shape) > -1 ? "#FFFFFF" : v.backgroundColor)), this.graphic.css(v.style).shadow(v.shadow)), this.graphic.labelrank = v.labelrank, super.render();
        }
        redraw(g) {
          let v = this.options, P = this.text || v.format || v.text, f = this.graphic, S = this.points[0];
          if (!f) {
            this.redraw(g);
            return;
          }
          f.attr({ text: P ? l(String(P), S.getLabelConfig(), this.annotation.chart) : v.formatter.call(S, this) });
          let w = this.anchor(S), x = this.position(w);
          x ? (f.alignAttr = x, x.anchorX = w.absolutePosition.x, x.anchorY = w.absolutePosition.y, f[g ? "animate" : "attr"](x)) : f.attr({ x: 0, y: -9999 }), f.placed = !!x, super.redraw(g);
        }
        anchor(g) {
          let v = super.anchor.apply(this, arguments), P = this.options.x || 0, f = this.options.y || 0;
          return v.absolutePosition.x -= P, v.absolutePosition.y -= f, v.relativePosition.x -= P, v.relativePosition.y -= f, v;
        }
        position(g) {
          let v = this.graphic, P = this.annotation.chart, f = P.tooltip, S = this.points[0], w = this.options, x = g.absolutePosition, k = g.relativePosition, A, $, j, N, M = S.series.visible && r.prototype.isInsidePlot.call(S);
          if (v && M) {
            let { width: D = 0, height: C = 0 } = v;
            w.distance && f ? A = f.getPosition.call({ chart: P, distance: u(w.distance, 16), getPlayingField: f.getPlayingField, pointer: f.pointer }, D, C, { plotX: k.x, plotY: k.y, negative: S.negative, ttBelow: S.ttBelow, h: k.height || k.width }) : w.positioner ? A = w.positioner.call(this) : ($ = { x: x.x, y: x.y, width: 0, height: 0 }, A = h.alignedPosition(d(w, { width: D, height: C }), $), this.options.overflow === "justify" && (A = h.alignedPosition(h.justifiedOptions(P, v, w, A), $))), w.crop && (j = A.x - P.plotLeft, N = A.y - P.plotTop, M = P.isInsidePlot(j, N) && P.isInsidePlot(j + D, N + C));
          }
          return M ? A : null;
        }
      }
      return h.attrsMap = { backgroundColor: "fill", borderColor: "stroke", borderWidth: "stroke-width", zIndex: "zIndex", borderRadius: "r", padding: "padding" }, h.shapesWithoutBackground = ["connector"], h;
    }), i(n, "Extensions/Annotations/Controllables/ControllableImage.js", [n["Extensions/Annotations/Controllables/Controllable.js"], n["Extensions/Annotations/Controllables/ControllableLabel.js"]], function(o, a) {
      class r extends o {
        constructor(l, d, y) {
          super(l, d, y, "shape"), this.type = "image", this.translate = super.translateShape;
        }
        render(l) {
          let d = this.attrsFromOptions(this.options), y = this.options;
          this.graphic = this.annotation.chart.renderer.image(y.src, 0, -9e9, y.width, y.height).attr(d).add(l), this.graphic.width = y.width, this.graphic.height = y.height, super.render();
        }
        redraw(l) {
          if (this.graphic) {
            let d = this.anchor(this.points[0]), y = a.prototype.position.call(this, d);
            y ? this.graphic[l ? "animate" : "attr"]({ x: y.x, y: y.y }) : this.graphic.attr({ x: 0, y: -9e9 }), this.graphic.placed = !!y;
          }
          super.redraw(l);
        }
      }
      return r.attrsMap = { width: "width", height: "height", zIndex: "zIndex" }, r;
    }), i(n, "Shared/BaseForm.js", [n["Core/Renderer/HTML/AST.js"], n["Core/Utilities.js"]], function(o, a) {
      let { addEvent: r, createElement: s } = a;
      return class {
        constructor(l, d) {
          this.iconsURL = d, this.container = this.createPopupContainer(l), this.closeButton = this.addCloseButton();
        }
        createPopupContainer(l, d = "highcharts-popup highcharts-no-tooltip") {
          return s("div", { className: d }, void 0, l);
        }
        addCloseButton(l = "highcharts-popup-close") {
          let d = this, y = this.iconsURL, u = s("button", { className: l }, void 0, this.container);
          return u.style["background-image"] = "url(" + (y.match(/png|svg|jpeg|jpg|gif/ig) ? y : y + "close.svg") + ")", ["click", "touchstart"].forEach((m) => {
            r(u, m, d.closeButtonEvents.bind(d));
          }), r(document, "keydown", function(m) {
            m.code === "Escape" && d.closeButtonEvents();
          }), u;
        }
        closeButtonEvents() {
          this.closePopup();
        }
        showPopup(l = "highcharts-annotation-toolbar") {
          let d = this.container, y = this.closeButton;
          this.type = void 0, d.innerHTML = o.emptyHTML, d.className.indexOf(l) >= 0 && (d.classList.remove(l), d.removeAttribute("style")), d.appendChild(y), d.style.display = "block", d.style.height = "";
        }
        closePopup() {
          this.container.style.display = "none";
        }
      };
    }), i(n, "Extensions/Annotations/Popup/PopupAnnotations.js", [n["Core/Globals.js"], n["Core/Utilities.js"]], function(o, a) {
      let { doc: r, isFirefox: s } = o, { createElement: l, isArray: d, isObject: y, objectEach: u, pick: m, stableSort: h } = a;
      function c(g, v, P, f, S, w) {
        let x, k;
        if (!v)
          return;
        let A = this.addInput, $ = this.lang;
        u(f, (j, N) => {
          x = P !== "" ? P + "." + N : N, y(j) && (!d(j) || d(j) && y(j[0]) ? ((k = $[N] || N).match(/\d/g) || S.push([!0, k, g]), c.call(this, g, v, x, j, S, !1)) : S.push([this, x, "annotation", g, j]));
        }), w && (h(S, (j) => j[1].match(/format/g) ? -1 : 1), s && S.reverse(), S.forEach((j) => {
          j[0] === !0 ? l("span", { className: "highcharts-annotation-title" }, void 0, j[2]).appendChild(r.createTextNode(j[1])) : (j[4] = { value: j[4][0], type: j[4][1] }, A.apply(j[0], j.splice(1)));
        }));
      }
      return { addForm: function(g, v, P, f) {
        if (!g)
          return;
        let S = this.container, w = this.lang, x = l("h2", { className: "highcharts-popup-main-title" }, void 0, S);
        x.appendChild(r.createTextNode(w[v.langKey] || v.langKey || "")), x = l("div", { className: "highcharts-popup-lhs-col highcharts-popup-lhs-full" }, void 0, S);
        let k = l("div", { className: "highcharts-popup-bottom-row" }, void 0, S);
        c.call(this, x, g, "", v, [], !0), this.addButton(k, f ? w.addButton || "Add" : w.saveButton || "Save", f ? "add" : "save", S, P);
      }, addToolbar: function(g, v, P) {
        let f = this.lang, S = this.container, w = this.showForm, x = "highcharts-annotation-toolbar";
        S.className.indexOf(x) === -1 && (S.className += " " + x + " highcharts-no-mousewheel"), g && (S.style.top = g.plotTop + 10 + "px");
        let k = l("p", { className: "highcharts-annotation-label" }, void 0, S);
        k.setAttribute("aria-label", "Annotation type"), k.appendChild(r.createTextNode(m(f[v.langKey] || v.langKey, v.shapes && v.shapes[0].type, "")));
        let A = this.addButton(S, f.editButton || "Edit", "edit", S, () => {
          w.call(this, "annotation-edit", g, v, P);
        });
        A.className += " highcharts-annotation-edit-button", A.style["background-image"] = "url(" + this.iconsURL + "edit.svg)", A = this.addButton(S, f.removeButton || "Remove", "remove", S, P), A.className += " highcharts-annotation-remove-button", A.style["background-image"] = "url(" + this.iconsURL + "destroy.svg)";
      } };
    }), i(n, "Extensions/Annotations/Popup/PopupIndicators.js", [n["Core/Renderer/HTML/AST.js"], n["Core/Globals.js"], n["Core/Series/SeriesRegistry.js"], n["Core/Utilities.js"]], function(o, a, r, s) {
      var l, d;
      let { doc: y } = a, { seriesTypes: u } = r, { addEvent: m, createElement: h, defined: c, isArray: g, isObject: v, objectEach: P, stableSort: f } = s;
      (d = l || (l = {}))[d["params.algorithm"] = 0] = "params.algorithm", d[d["params.average"] = 1] = "params.average";
      let S = { "algorithm-pivotpoints": ["standard", "fibonacci", "camarilla"], "average-disparityindex": ["sma", "ema", "dema", "tema", "wma"] };
      function w(p) {
        let L = h("div", { className: "highcharts-popup-lhs-col" }, void 0, p), B = h("div", { className: "highcharts-popup-rhs-col" }, void 0, p);
        return h("div", { className: "highcharts-popup-rhs-col-wrapper" }, void 0, B), { lhsCol: L, rhsCol: B };
      }
      function x(p, L, B, T) {
        let O = L.params || L.options.params;
        T.innerHTML = o.emptyHTML, h("h3", { className: "highcharts-indicator-title" }, void 0, T).appendChild(y.createTextNode(C(L, B).indicatorFullName)), h("input", { type: "hidden", name: "highcharts-type-" + B, value: B }, void 0, T), b.call(this, B, "series", p, T, L, L.linkedParent && L.linkedParent.options.id), O.volumeSeriesID && b.call(this, B, "volume", p, T, L, L.linkedParent && O.volumeSeriesID), A.call(this, p, "params", O, B, T);
      }
      function k(p, L, B, T) {
        function O(W, ae) {
          let z = G.parentNode.children[1];
          x.call(I, p, W, ae, G), z && (z.style.display = "block"), U && W.options && h("input", { type: "hidden", name: "highcharts-id-" + ae, value: W.options.id }, void 0, G).setAttribute("highcharts-data-series-id", W.options.id);
        }
        let I = this, R = I.lang, Y = L.querySelectorAll(".highcharts-popup-lhs-col")[0], F = L.querySelectorAll(".highcharts-popup-rhs-col")[0], U = B === "edit", Q = U ? p.series : p.options.plotOptions || {};
        if (!p && Q)
          return;
        let J, ee = [];
        U || g(Q) ? g(Q) && (ee = D.call(this, Q)) : ee = M.call(this, Q, T), f(ee, (W, ae) => {
          let z = W.indicatorFullName.toLowerCase(), q = ae.indicatorFullName.toLowerCase();
          return z < q ? -1 : z > q ? 1 : 0;
        }), Y.children[1] && Y.children[1].remove();
        let V = h("ul", { className: "highcharts-indicator-list" }, void 0, Y), G = F.querySelectorAll(".highcharts-popup-rhs-col-wrapper")[0];
        if (ee.forEach((W) => {
          let { indicatorFullName: ae, indicatorType: z, series: q } = W;
          J = h("li", { className: "highcharts-indicator-list" }, void 0, V);
          let Z = h("button", { className: "highcharts-indicator-list-item", textContent: ae }, void 0, J);
          ["click", "touchstart"].forEach((ne) => {
            m(Z, ne, function() {
              O(q, z);
            });
          });
        }), ee.length > 0) {
          let { series: W, indicatorType: ae } = ee[0];
          O(W, ae);
        } else
          U || (o.setElementHTML(G.parentNode.children[0], R.noFilterMatch || ""), G.parentNode.children[1].style.display = "none");
      }
      function A(p, L, B, T, O) {
        if (!p)
          return;
        let I = this.addInput;
        P(B, (R, Y) => {
          let F = L + "." + Y;
          if (c(R) && F)
            if (v(R) && (I.call(this, F, T, O, {}), A.call(this, p, F, R, T, O)), F in l) {
              let U = j.call(this, T, F, O);
              N.call(this, p, L, U, T, Y, R);
            } else
              F === "params.volumeSeriesID" || g(R) || I.call(this, F, T, O, { value: R, type: "number" });
        });
      }
      function $(p, L) {
        let B = this, T = L.querySelectorAll(".highcharts-popup-lhs-col")[0], O = this.lang.clearFilter, I = h("div", { className: "highcharts-input-wrapper" }, void 0, T), R = function(U) {
          k.call(B, p, B.container, "add", U);
        }, Y = this.addInput("searchIndicators", "input", I, { value: "", type: "text", htmlFor: "search-indicators", labelClassName: "highcharts-input-search-indicators-label" }), F = h("a", { textContent: O }, void 0, I);
        Y.classList.add("highcharts-input-search-indicators"), F.classList.add("clear-filter-button"), m(Y, "input", function() {
          R(this.value), this.value.length ? F.style.display = "inline-block" : F.style.display = "none";
        }), ["click", "touchstart"].forEach((U) => {
          m(F, U, function() {
            Y.value = "", R(""), F.style.display = "none";
          });
        });
      }
      function j(p, L, B) {
        let T = L.split("."), O = T[T.length - 1], I = "highcharts-" + L + "-type-" + p, R = this.lang;
        h("label", { htmlFor: I }, null, B).appendChild(y.createTextNode(R[O] || L));
        let Y = h("select", { name: I, className: "highcharts-popup-field", id: "highcharts-select-" + L }, null, B);
        return Y.setAttribute("id", "highcharts-select-" + L), Y;
      }
      function N(p, L, B, T, O, I, R) {
        L === "series" || L === "volume" ? p.series.forEach((Y) => {
          let F = Y.options, U = F.name || F.params ? Y.name : F.id || "";
          F.id !== "highcharts-navigator-series" && F.id !== (R && R.options && R.options.id) && (c(I) || L !== "volume" || Y.type !== "column" || (I = F.id), h("option", { value: F.id }, void 0, B).appendChild(y.createTextNode(U)));
        }) : T && O && S[O + "-" + T].forEach((Y) => {
          h("option", { value: Y }, void 0, B).appendChild(y.createTextNode(Y));
        }), c(I) && (B.value = I);
      }
      function M(p, L) {
        let B, T = this.chart && this.chart.options.lang, O = T && T.navigation && T.navigation.popup && T.navigation.popup.indicatorAliases, I = [];
        return P(p, (R, Y) => {
          let F = R && R.options;
          if (R.params || F && F.params) {
            let { indicatorFullName: U, indicatorType: Q } = C(R, Y);
            if (L) {
              let J = RegExp(L.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"), "i"), ee = O && O[Q] && O[Q].join(" ") || "";
              (U.match(J) || ee.match(J)) && (B = { indicatorFullName: U, indicatorType: Q, series: R }, I.push(B));
            } else
              B = { indicatorFullName: U, indicatorType: Q, series: R }, I.push(B);
          }
        }), I;
      }
      function D(p) {
        let L = [];
        return p.forEach((B) => {
          B.is("sma") && L.push({ indicatorFullName: B.name, indicatorType: B.type, series: B });
        }), L;
      }
      function C(p, L) {
        let B = p.options, T = u[L] && u[L].prototype.nameBase || L.toUpperCase(), O = L;
        return B && B.type && (O = p.options.type, T = p.name), { indicatorFullName: T, indicatorType: O };
      }
      function b(p, L, B, T, O, I) {
        if (!B)
          return;
        let R = j.call(this, p, L, T);
        N.call(this, B, L, R, void 0, void 0, void 0, O), c(I) && (R.value = I);
      }
      return { addForm: function(p, L, B) {
        let T, O = this.lang;
        if (!p)
          return;
        this.tabs.init.call(this, p);
        let I = this.container.querySelectorAll(".highcharts-tab-item-content");
        w(I[0]), $.call(this, p, I[0]), k.call(this, p, I[0], "add"), T = I[0].querySelectorAll(".highcharts-popup-rhs-col")[0], this.addButton(T, O.addButton || "add", "add", T, B), w(I[1]), k.call(this, p, I[1], "edit"), T = I[1].querySelectorAll(".highcharts-popup-rhs-col")[0], this.addButton(T, O.saveButton || "save", "edit", T, B), this.addButton(T, O.removeButton || "remove", "remove", T, B);
      }, getAmount: function() {
        let p = 0;
        return this.series.forEach((L) => {
          (L.params || L.options.params) && p++;
        }), p;
      } };
    }), i(n, "Extensions/Annotations/Popup/PopupTabs.js", [n["Core/Globals.js"], n["Core/Utilities.js"]], function(o, a) {
      let { doc: r } = o, { addEvent: s, createElement: l } = a;
      function d() {
        return l("div", { className: "highcharts-tab-item-content highcharts-no-mousewheel" }, void 0, this.container);
      }
      function y(c, g) {
        let v = this.container, P = this.lang, f = "highcharts-tab-item";
        g === 0 && (f += " highcharts-tab-disabled");
        let S = l("button", { className: f }, void 0, v);
        return S.appendChild(r.createTextNode(P[c + "Button"] || c)), S.setAttribute("highcharts-data-tab-type", c), S;
      }
      function u() {
        let c = this.container, g = c.querySelectorAll(".highcharts-tab-item"), v = c.querySelectorAll(".highcharts-tab-item-content");
        for (let P = 0; P < g.length; P++)
          g[P].classList.remove("highcharts-tab-item-active"), v[P].classList.remove("highcharts-tab-item-show");
      }
      function m(c, g) {
        let v = this.container.querySelectorAll(".highcharts-tab-item-content");
        c.className += " highcharts-tab-item-active", v[g].className += " highcharts-tab-item-show";
      }
      function h(c) {
        let g = this;
        this.container.querySelectorAll(".highcharts-tab-item").forEach((v, P) => {
          (c !== 0 || v.getAttribute("highcharts-data-tab-type") !== "edit") && ["click", "touchstart"].forEach((f) => {
            s(v, f, function() {
              u.call(g), m.call(g, this, P);
            });
          });
        });
      }
      return { init: function(c) {
        if (!c)
          return;
        let g = this.indicators.getAmount.call(c), v = y.call(this, "add");
        y.call(this, "edit", g), d.call(this), d.call(this), h.call(this, g), m.call(this, v, 0);
      } };
    }), i(n, "Extensions/Annotations/Popup/Popup.js", [n["Shared/BaseForm.js"], n["Core/Globals.js"], n["Core/Defaults.js"], n["Extensions/Annotations/Popup/PopupAnnotations.js"], n["Extensions/Annotations/Popup/PopupIndicators.js"], n["Extensions/Annotations/Popup/PopupTabs.js"], n["Core/Utilities.js"]], function(o, a, r, s, l, d, y) {
      let { doc: u } = a, { getOptions: m } = r, { addEvent: h, createElement: c, extend: g, fireEvent: v, pick: P } = y;
      class f extends o {
        constructor(w, x, k) {
          super(w, x), this.chart = k, this.lang = (m().lang.navigation || {}).popup || {}, h(this.container, "mousedown", () => {
            let A = k && k.navigationBindings && k.navigationBindings.activeAnnotation;
            if (A) {
              A.cancelClick = !0;
              let $ = h(u, "click", () => {
                setTimeout(() => {
                  A.cancelClick = !1;
                }, 0), $();
              });
            }
          });
        }
        addInput(w, x, k, A) {
          let $ = w.split("."), j = $[$.length - 1], N = this.lang, M = "highcharts-" + x + "-" + P(A.htmlFor, j);
          j.match(/^\d+$/) || c("label", { htmlFor: M, className: A.labelClassName }, void 0, k).appendChild(u.createTextNode(N[j] || j));
          let D = c("input", { name: M, value: A.value, type: A.type, className: "highcharts-popup-field" }, void 0, k);
          return D.setAttribute("highcharts-data-name", w), D;
        }
        closeButtonEvents() {
          if (this.chart) {
            let w = this.chart.navigationBindings;
            v(w, "closePopup"), w && w.selectedButtonElement && v(w, "deselectButton", { button: w.selectedButtonElement });
          } else
            super.closeButtonEvents();
        }
        addButton(w, x, k, A, $) {
          let j = c("button", void 0, void 0, w);
          return j.appendChild(u.createTextNode(x)), $ && ["click", "touchstart"].forEach((N) => {
            h(j, N, () => (this.closePopup(), $(function(M, D) {
              let C = Array.prototype.slice.call(M.querySelectorAll("input")), b = Array.prototype.slice.call(M.querySelectorAll("select")), p = M.querySelectorAll("#highcharts-select-series > option:checked")[0], L = M.querySelectorAll("#highcharts-select-volume > option:checked")[0], B = { actionType: D, linkedTo: p && p.getAttribute("value") || "", fields: {} };
              return C.forEach((T) => {
                let O = T.getAttribute("highcharts-data-name");
                T.getAttribute("highcharts-data-series-id") ? B.seriesId = T.value : O ? B.fields[O] = T.value : B.type = T.value;
              }), b.forEach((T) => {
                let O = T.id;
                if (O !== "highcharts-select-series" && O !== "highcharts-select-volume") {
                  let I = O.split("highcharts-select-")[1];
                  B.fields[I] = T.value;
                }
              }), L && (B.fields["params.volumeSeriesID"] = L.getAttribute("value") || ""), B;
            }(A, k))));
          }), j;
        }
        showForm(w, x, k, A) {
          x && (this.showPopup(), w === "indicators" && this.indicators.addForm.call(this, x, k, A), w === "annotation-toolbar" && this.annotations.addToolbar.call(this, x, k, A), w === "annotation-edit" && this.annotations.addForm.call(this, x, k, A), w === "flag" && this.annotations.addForm.call(this, x, k, A, !0), this.type = w, this.container.style.height = this.container.offsetHeight + "px");
        }
      }
      return g(f.prototype, { annotations: s, indicators: l, tabs: d }), f;
    }), i(n, "Extensions/Annotations/Popup/PopupComposition.js", [n["Core/Globals.js"], n["Extensions/Annotations/Popup/Popup.js"], n["Core/Utilities.js"]], function(o, a, r) {
      let { composed: s } = o, { addEvent: l, pushUnique: d, wrap: y } = r;
      function u() {
        this.popup && this.popup.closePopup();
      }
      function m(c) {
        this.popup || (this.popup = new a(this.chart.container, this.chart.options.navigation.iconsURL || this.chart.options.stockTools && this.chart.options.stockTools.gui.iconsURL || "https://code.highcharts.com/11.4.8/gfx/stock-icons/", this.chart)), this.popup.showForm(c.formType, this.chart, c.options, c.onSubmit);
      }
      function h(c, g) {
        this.inClass(g.target, "highcharts-popup") || c.apply(this, Array.prototype.slice.call(arguments, 1));
      }
      return { compose: function(c, g) {
        d(s, "Popup") && (l(c, "closePopup", u), l(c, "showPopup", m), y(g.prototype, "onContainerMouseDown", h));
      } };
    }), i(n, "Extensions/Annotations/Annotation.js", [n["Core/Animation/AnimationUtilities.js"], n["Extensions/Annotations/AnnotationChart.js"], n["Extensions/Annotations/AnnotationDefaults.js"], n["Extensions/Annotations/Controllables/ControllableRect.js"], n["Extensions/Annotations/Controllables/ControllableCircle.js"], n["Extensions/Annotations/Controllables/ControllableEllipse.js"], n["Extensions/Annotations/Controllables/ControllablePath.js"], n["Extensions/Annotations/Controllables/ControllableImage.js"], n["Extensions/Annotations/Controllables/ControllableLabel.js"], n["Extensions/Annotations/ControlPoint.js"], n["Extensions/Annotations/ControlTarget.js"], n["Extensions/Annotations/EventEmitter.js"], n["Extensions/Annotations/MockPoint.js"], n["Extensions/Annotations/Popup/PopupComposition.js"], n["Core/Utilities.js"]], function(o, a, r, s, l, d, y, u, m, h, c, g, v, P, f) {
      let { getDeferredAnimation: S } = o, { destroyObjectProperties: w, erase: x, fireEvent: k, merge: A, pick: $, splat: j } = f;
      function N(D, C) {
        let b = {};
        return ["labels", "shapes"].forEach((p) => {
          let L = D[p];
          L && (C[p] ? b[p] = j(C[p]).map(function(B, T) {
            return A(L[T], B);
          }) : b[p] = D[p]);
        }), b;
      }
      class M extends g {
        static compose(C, b, p, L) {
          a.compose(M, C, p), m.compose(L), y.compose(C, L), b.compose(M, C), P.compose(b, p);
        }
        constructor(C, b) {
          super(), this.coll = "annotations", this.chart = C, this.points = [], this.controlPoints = [], this.coll = "annotations", this.index = -1, this.labels = [], this.shapes = [], this.options = A(this.defaultOptions, b), this.userOptions = b;
          let p = N(this.options, b);
          this.options.labels = p.labels, this.options.shapes = p.shapes, this.init(C, this.options);
        }
        addClipPaths() {
          this.setClipAxes(), this.clipXAxis && this.clipYAxis && this.options.crop && (this.clipRect = this.chart.renderer.clipRect(this.getClipBox()));
        }
        addLabels() {
          let C = this.options.labels || [];
          C.forEach((b, p) => {
            let L = this.initLabel(b, p);
            A(!0, C[p], L.options);
          });
        }
        addShapes() {
          let C = this.options.shapes || [];
          C.forEach((b, p) => {
            let L = this.initShape(b, p);
            A(!0, C[p], L.options);
          });
        }
        destroy() {
          let C = this.chart, b = function(p) {
            p.destroy();
          };
          this.labels.forEach(b), this.shapes.forEach(b), this.clipXAxis = null, this.clipYAxis = null, x(C.labelCollectors, this.labelCollector), super.destroy(), this.destroyControlTarget(), w(this, C);
        }
        destroyItem(C) {
          x(this[C.itemType + "s"], C), C.destroy();
        }
        getClipBox() {
          if (this.clipXAxis && this.clipYAxis)
            return { x: this.clipXAxis.left, y: this.clipYAxis.top, width: this.clipXAxis.width, height: this.clipYAxis.height };
        }
        initProperties(C, b) {
          this.setOptions(b);
          let p = N(this.options, b);
          this.options.labels = p.labels, this.options.shapes = p.shapes, this.chart = C, this.points = [], this.controlPoints = [], this.coll = "annotations", this.userOptions = b, this.labels = [], this.shapes = [];
        }
        init(C, b, p = this.index) {
          let L = this.chart, B = this.options.animation;
          this.index = p, this.linkPoints(), this.addControlPoints(), this.addShapes(), this.addLabels(), this.setLabelCollector(), this.animationConfig = S(L, B);
        }
        initLabel(C, b) {
          let p = new m(this, A(this.options.labelOptions, { controlPointOptions: this.options.controlPointOptions }, C), b);
          return p.itemType = "label", this.labels.push(p), p;
        }
        initShape(C, b) {
          let p = A(this.options.shapeOptions, { controlPointOptions: this.options.controlPointOptions }, C), L = new M.shapesMap[p.type](this, p, b);
          return L.itemType = "shape", this.shapes.push(L), L;
        }
        redraw(C) {
          this.linkPoints(), this.graphic || this.render(), this.clipRect && this.clipRect.animate(this.getClipBox()), this.redrawItems(this.shapes, C), this.redrawItems(this.labels, C), this.redrawControlPoints(C);
        }
        redrawItem(C, b) {
          C.linkPoints(), C.shouldBeDrawn() ? (C.graphic || this.renderItem(C), C.redraw($(b, !0) && C.graphic.placed), C.points.length && function(p) {
            let L = p.graphic, B = p.points.some((T) => T.series.visible !== !1 && T.visible !== !1);
            L && (B ? L.visibility === "hidden" && L.show() : L.hide());
          }(C)) : this.destroyItem(C);
        }
        redrawItems(C, b) {
          let p = C.length;
          for (; p--; )
            this.redrawItem(C[p], b);
        }
        remove() {
          return this.chart.removeAnnotation(this);
        }
        render() {
          let C = this.chart.renderer;
          this.graphic = C.g("annotation").attr({ opacity: 0, zIndex: this.options.zIndex, visibility: this.options.visible ? "inherit" : "hidden" }).add(), this.shapesGroup = C.g("annotation-shapes").add(this.graphic), this.options.crop && this.shapesGroup.clip(this.chart.plotBoxClip), this.labelsGroup = C.g("annotation-labels").attr({ translateX: 0, translateY: 0 }).add(this.graphic), this.addClipPaths(), this.clipRect && this.graphic.clip(this.clipRect), this.renderItems(this.shapes), this.renderItems(this.labels), this.addEvents(), this.renderControlPoints();
        }
        renderItem(C) {
          C.render(C.itemType === "label" ? this.labelsGroup : this.shapesGroup);
        }
        renderItems(C) {
          let b = C.length;
          for (; b--; )
            this.renderItem(C[b]);
        }
        setClipAxes() {
          let C = this.chart.xAxis, b = this.chart.yAxis, p = (this.options.labels || []).concat(this.options.shapes || []).reduce((L, B) => {
            let T = B && (B.point || B.points && B.points[0]);
            return [C[T && T.xAxis] || L[0], b[T && T.yAxis] || L[1]];
          }, []);
          this.clipXAxis = p[0], this.clipYAxis = p[1];
        }
        setControlPointsVisibility(C) {
          let b = function(p) {
            p.setControlPointsVisibility(C);
          };
          this.controlPoints.forEach((p) => {
            p.setVisibility(C);
          }), this.shapes.forEach(b), this.labels.forEach(b);
        }
        setLabelCollector() {
          let C = this;
          C.labelCollector = function() {
            return C.labels.reduce(function(b, p) {
              return p.options.allowOverlap || b.push(p.graphic), b;
            }, []);
          }, C.chart.labelCollectors.push(C.labelCollector);
        }
        setOptions(C) {
          this.options = A(this.defaultOptions, C);
        }
        setVisibility(C) {
          let b = this.options, p = this.chart.navigationBindings, L = $(C, !b.visible);
          if (this.graphic.attr("visibility", L ? "inherit" : "hidden"), !L) {
            let B = function(T) {
              T.setControlPointsVisibility(L);
            };
            this.shapes.forEach(B), this.labels.forEach(B), p.activeAnnotation === this && p.popup && p.popup.type === "annotation-toolbar" && k(p, "closePopup");
          }
          b.visible = L;
        }
        update(C, b) {
          let p = this.chart, L = N(this.userOptions, C), B = p.annotations.indexOf(this), T = A(!0, this.userOptions, C);
          T.labels = L.labels, T.shapes = L.shapes, this.destroy(), this.initProperties(p, T), this.init(p, T), p.options.annotations[B] = this.options, this.isUpdating = !0, $(b, !0) && p.drawAnnotations(), k(this, "afterUpdate"), this.isUpdating = !1;
        }
      }
      return M.ControlPoint = h, M.MockPoint = v, M.shapesMap = { rect: s, circle: l, ellipse: d, path: y, image: u }, M.types = {}, M.prototype.defaultOptions = r, M.prototype.nonDOMEvents = ["add", "afterUpdate", "drag", "remove"], c.compose(M), M;
    }), i(n, "Core/Chart/ChartNavigationComposition.js", [], function() {
      var o;
      return function(a) {
        a.compose = function(s) {
          return s.navigation || (s.navigation = new r(s)), s;
        };
        class r {
          constructor(l) {
            this.updates = [], this.chart = l;
          }
          addUpdate(l) {
            this.chart.navigation.updates.push(l);
          }
          update(l, d) {
            this.updates.forEach((y) => {
              y.call(this.chart, l, d);
            });
          }
        }
        a.Additions = r;
      }(o || (o = {})), o;
    }), i(n, "Extensions/Annotations/NavigationBindingsUtilities.js", [n["Core/Utilities.js"]], function(o) {
      let { defined: a, isNumber: r, pick: s } = o, l = { backgroundColor: "string", borderColor: "string", borderRadius: "string", color: "string", fill: "string", fontSize: "string", labels: "string", name: "string", stroke: "string", title: "string" };
      return { annotationsFieldsTypes: l, getAssignedAxis: function(d) {
        return d.filter((y) => {
          let u = y.axis.getExtremes(), m = u.min, h = u.max, c = s(y.axis.minPointOffset, 0);
          return r(m) && r(h) && y.value >= m - c && y.value <= h + c && !y.axis.options.isInternal;
        })[0];
      }, getFieldType: function(d, y) {
        let u = l[d], m = typeof y;
        return a(u) && (m = u), { string: "text", number: "number", boolean: "checkbox" }[m];
      } };
    }), i(n, "Extensions/Annotations/NavigationBindingsDefaults.js", [n["Extensions/Annotations/NavigationBindingsUtilities.js"], n["Core/Utilities.js"]], function(o, a) {
      let { getAssignedAxis: r } = o, { isNumber: s, merge: l } = a;
      return { lang: { navigation: { popup: { simpleShapes: "Simple shapes", lines: "Lines", circle: "Circle", ellipse: "Ellipse", rectangle: "Rectangle", label: "Label", shapeOptions: "Shape options", typeOptions: "Details", fill: "Fill", format: "Text", strokeWidth: "Line width", stroke: "Line color", title: "Title", name: "Name", labelOptions: "Label options", labels: "Labels", backgroundColor: "Background color", backgroundColors: "Background colors", borderColor: "Border color", borderRadius: "Border radius", borderWidth: "Border width", style: "Style", padding: "Padding", fontSize: "Font size", color: "Color", height: "Height", shapes: "Shape options" } } }, navigation: { bindingsClassName: "highcharts-bindings-container", bindings: { circleAnnotation: { className: "highcharts-circle-annotation", start: function(d) {
        let y = this.chart.pointer?.getCoordinates(d), u = y && r(y.xAxis), m = y && r(y.yAxis), h = this.chart.options.navigation;
        if (u && m)
          return this.chart.addAnnotation(l({ langKey: "circle", type: "basicAnnotation", shapes: [{ type: "circle", point: { x: u.value, y: m.value, xAxis: u.axis.index, yAxis: m.axis.index }, r: 5 }] }, h.annotationsOptions, h.bindings.circleAnnotation.annotationsOptions));
      }, steps: [function(d, y) {
        let u, m = y.options.shapes, h = m && m[0] && m[0].point || {};
        if (s(h.xAxis) && s(h.yAxis)) {
          let c = this.chart.inverted, g = this.chart.xAxis[h.xAxis].toPixels(h.x), v = this.chart.yAxis[h.yAxis].toPixels(h.y);
          u = Math.max(Math.sqrt(Math.pow(c ? v - d.chartX : g - d.chartX, 2) + Math.pow(c ? g - d.chartY : v - d.chartY, 2)), 5);
        }
        y.update({ shapes: [{ r: u }] });
      }] }, ellipseAnnotation: { className: "highcharts-ellipse-annotation", start: function(d) {
        let y = this.chart.pointer?.getCoordinates(d), u = y && r(y.xAxis), m = y && r(y.yAxis), h = this.chart.options.navigation;
        if (u && m)
          return this.chart.addAnnotation(l({ langKey: "ellipse", type: "basicAnnotation", shapes: [{ type: "ellipse", xAxis: u.axis.index, yAxis: m.axis.index, points: [{ x: u.value, y: m.value }, { x: u.value, y: m.value }], ry: 1 }] }, h.annotationsOptions, h.bindings.ellipseAnnotation.annotationOptions));
      }, steps: [function(d, y) {
        let u = y.shapes[0], m = u.getAbsolutePosition(u.points[1]);
        u.translatePoint(d.chartX - m.x, d.chartY - m.y, 1), u.redraw(!1);
      }, function(d, y) {
        let u = y.shapes[0], m = u.getAbsolutePosition(u.points[0]), h = u.getAbsolutePosition(u.points[1]), c = u.getDistanceFromLine(m, h, d.chartX, d.chartY), g = u.getYAxis(), v = Math.abs(g.toValue(0) - g.toValue(c));
        u.setYRadius(v), u.redraw(!1);
      }] }, rectangleAnnotation: { className: "highcharts-rectangle-annotation", start: function(d) {
        let y = this.chart.pointer?.getCoordinates(d), u = y && r(y.xAxis), m = y && r(y.yAxis);
        if (!u || !m)
          return;
        let h = u.value, c = m.value, g = u.axis.index, v = m.axis.index, P = this.chart.options.navigation;
        return this.chart.addAnnotation(l({ langKey: "rectangle", type: "basicAnnotation", shapes: [{ type: "path", points: [{ xAxis: g, yAxis: v, x: h, y: c }, { xAxis: g, yAxis: v, x: h, y: c }, { xAxis: g, yAxis: v, x: h, y: c }, { xAxis: g, yAxis: v, x: h, y: c }, { command: "Z" }] }] }, P.annotationsOptions, P.bindings.rectangleAnnotation.annotationsOptions));
      }, steps: [function(d, y) {
        let u = y.options.shapes, m = u && u[0] && u[0].points || [], h = this.chart.pointer?.getCoordinates(d), c = h && r(h.xAxis), g = h && r(h.yAxis);
        if (c && g) {
          let v = c.value, P = g.value;
          m[1].x = v, m[2].x = v, m[2].y = P, m[3].y = P, y.update({ shapes: [{ points: m }] });
        }
      }] }, labelAnnotation: { className: "highcharts-label-annotation", start: function(d) {
        let y = this.chart.pointer?.getCoordinates(d), u = y && r(y.xAxis), m = y && r(y.yAxis), h = this.chart.options.navigation;
        if (u && m)
          return this.chart.addAnnotation(l({ langKey: "label", type: "basicAnnotation", labelOptions: { format: "{y:.2f}", overflow: "none", crop: !0 }, labels: [{ point: { xAxis: u.axis.index, yAxis: m.axis.index, x: u.value, y: m.value } }] }, h.annotationsOptions, h.bindings.labelAnnotation.annotationsOptions));
      } } }, events: {}, annotationsOptions: { animation: { defer: 0 } } } };
    }), i(n, "Extensions/Annotations/NavigationBindings.js", [n["Core/Chart/ChartNavigationComposition.js"], n["Core/Defaults.js"], n["Core/Templating.js"], n["Core/Globals.js"], n["Extensions/Annotations/NavigationBindingsDefaults.js"], n["Extensions/Annotations/NavigationBindingsUtilities.js"], n["Core/Utilities.js"]], function(o, a, r, s, l, d, y) {
      let { setOptions: u } = a, { format: m } = r, { composed: h, doc: c, win: g } = s, { getAssignedAxis: v, getFieldType: P } = d, { addEvent: f, attr: S, defined: w, fireEvent: x, isArray: k, isFunction: A, isNumber: $, isObject: j, merge: N, objectEach: M, pick: D, pushUnique: C } = y;
      function b() {
        this.chart.navigationBindings && this.chart.navigationBindings.deselectAnnotation();
      }
      function p() {
        this.navigationBindings && this.navigationBindings.destroy();
      }
      function L() {
        let Y = this.options;
        Y && Y.navigation && Y.navigation.bindings && (this.navigationBindings = new R(this, Y.navigation), this.navigationBindings.initEvents(), this.navigationBindings.initUpdate());
      }
      function B() {
        let Y = this.navigationBindings, F = "highcharts-disabled-btn";
        if (this && Y) {
          let U = !1;
          if (this.series.forEach((Q) => {
            !Q.options.isInternal && Q.visible && (U = !0);
          }), this.navigationBindings && this.navigationBindings.container && this.navigationBindings.container[0]) {
            let Q = this.navigationBindings.container[0];
            M(Y.boundClassNames, (J, ee) => {
              let V = Q.querySelectorAll("." + ee);
              if (V)
                for (let G = 0; G < V.length; G++) {
                  let W = V[G], ae = W.className;
                  J.noDataState === "normal" || U ? ae.indexOf(F) !== -1 && W.classList.remove(F) : ae.indexOf(F) === -1 && (W.className += " " + F);
                }
            });
          }
        }
      }
      function T() {
        this.deselectAnnotation();
      }
      function O() {
        this.selectedButtonElement = null;
      }
      function I(Y) {
        let F, U, Q = Y.prototype.defaultOptions.events && Y.prototype.defaultOptions.events.click;
        function J(ee) {
          let V = this, G = V.chart.navigationBindings, W = G.activeAnnotation;
          Q && Q.call(V, ee), W !== V ? (G.deselectAnnotation(), G.activeAnnotation = V, V.setControlPointsVisibility(!0), x(G, "showPopup", { annotation: V, formType: "annotation-toolbar", options: G.annotationToFields(V), onSubmit: function(ae) {
            if (ae.actionType === "remove")
              G.activeAnnotation = !1, G.chart.removeAnnotation(V);
            else {
              let z = {};
              G.fieldsToOptions(ae.fields, z), G.deselectAnnotation();
              let q = z.typeOptions;
              V.options.type === "measure" && (q.crosshairY.enabled = q.crosshairY.strokeWidth !== 0, q.crosshairX.enabled = q.crosshairX.strokeWidth !== 0), V.update(z);
            }
          } })) : x(G, "closePopup"), ee.activeAnnotation = !0;
        }
        N(!0, Y.prototype.defaultOptions.events, { click: J, touchstart: function(ee) {
          F = ee.touches[0].clientX, U = ee.touches[0].clientY;
        }, touchend: function(ee) {
          F && Math.sqrt(Math.pow(F - ee.changedTouches[0].clientX, 2) + Math.pow(U - ee.changedTouches[0].clientY, 2)) >= 4 || J.call(this, ee);
        } });
      }
      class R {
        static compose(F, U) {
          C(h, "NavigationBindings") && (f(F, "remove", b), I(F), M(F.types, (Q) => {
            I(Q);
          }), f(U, "destroy", p), f(U, "load", L), f(U, "render", B), f(R, "closePopup", T), f(R, "deselectButton", O), u(l));
        }
        constructor(F, U) {
          this.boundClassNames = void 0, this.chart = F, this.options = U, this.eventsToUnbind = [], this.container = this.chart.container.getElementsByClassName(this.options.bindingsClassName || ""), this.container.length || (this.container = c.getElementsByClassName(this.options.bindingsClassName || ""));
        }
        getCoords(F) {
          let U = this.chart.pointer?.getCoordinates(F);
          return [U && v(U.xAxis), U && v(U.yAxis)];
        }
        initEvents() {
          let F = this, U = F.chart, Q = F.container, J = F.options;
          F.boundClassNames = {}, M(J.bindings || {}, (ee) => {
            F.boundClassNames[ee.className] = ee;
          }), [].forEach.call(Q, (ee) => {
            F.eventsToUnbind.push(f(ee, "click", (V) => {
              let G = F.getButtonEvents(ee, V);
              G && !G.button.classList.contains("highcharts-disabled-btn") && F.bindingsButtonClick(G.button, G.events, V);
            }));
          }), M(J.events || {}, (ee, V) => {
            A(ee) && F.eventsToUnbind.push(f(F, V, ee, { passive: !1 }));
          }), F.eventsToUnbind.push(f(U.container, "click", function(ee) {
            !U.cancelClick && U.isInsidePlot(ee.chartX - U.plotLeft, ee.chartY - U.plotTop, { visiblePlotOnly: !0 }) && F.bindingsChartClick(this, ee);
          })), F.eventsToUnbind.push(f(U.container, s.isTouchDevice ? "touchmove" : "mousemove", function(ee) {
            F.bindingsContainerMouseMove(this, ee);
          }, s.isTouchDevice ? { passive: !1 } : void 0));
        }
        initUpdate() {
          let F = this;
          o.compose(this.chart).navigation.addUpdate((U) => {
            F.update(U);
          });
        }
        bindingsButtonClick(F, U, Q) {
          let J = this.chart, ee = J.renderer.boxWrapper, V = !0;
          this.selectedButtonElement && (this.selectedButtonElement.classList === F.classList && (V = !1), x(this, "deselectButton", { button: this.selectedButtonElement }), this.nextEvent && (this.currentUserDetails && this.currentUserDetails.coll === "annotations" && J.removeAnnotation(this.currentUserDetails), this.mouseMoveEvent = this.nextEvent = !1)), V ? (this.selectedButton = U, this.selectedButtonElement = F, x(this, "selectButton", { button: F }), U.init && U.init.call(this, F, Q), (U.start || U.steps) && J.renderer.boxWrapper.addClass("highcharts-draw-mode")) : (J.stockTools && F.classList.remove("highcharts-active"), ee.removeClass("highcharts-draw-mode"), this.nextEvent = !1, this.mouseMoveEvent = !1, this.selectedButton = null);
        }
        bindingsChartClick(F, U) {
          F = this.chart;
          let Q = this.activeAnnotation, J = this.selectedButton, ee = F.renderer.boxWrapper;
          Q && (Q.cancelClick || U.activeAnnotation || !U.target.parentNode || function(V, G) {
            let W = g.Element.prototype, ae = W.matches || W.msMatchesSelector || W.webkitMatchesSelector, z = null;
            if (W.closest)
              z = W.closest.call(V, G);
            else
              do {
                if (ae.call(V, G))
                  return V;
                V = V.parentElement || V.parentNode;
              } while (V !== null && V.nodeType === 1);
            return z;
          }(U.target, ".highcharts-popup") ? Q.cancelClick && setTimeout(() => {
            Q.cancelClick = !1;
          }, 0) : x(this, "closePopup")), J && J.start && (this.nextEvent ? (this.nextEvent(U, this.currentUserDetails), this.steps && (this.stepIndex++, J.steps[this.stepIndex] ? this.mouseMoveEvent = this.nextEvent = J.steps[this.stepIndex] : (x(this, "deselectButton", { button: this.selectedButtonElement }), ee.removeClass("highcharts-draw-mode"), J.end && J.end.call(this, U, this.currentUserDetails), this.nextEvent = !1, this.mouseMoveEvent = !1, this.selectedButton = null))) : (this.currentUserDetails = J.start.call(this, U), this.currentUserDetails && J.steps ? (this.stepIndex = 0, this.steps = !0, this.mouseMoveEvent = this.nextEvent = J.steps[this.stepIndex]) : (x(this, "deselectButton", { button: this.selectedButtonElement }), ee.removeClass("highcharts-draw-mode"), this.steps = !1, this.selectedButton = null, J.end && J.end.call(this, U, this.currentUserDetails))));
        }
        bindingsContainerMouseMove(F, U) {
          this.mouseMoveEvent && this.mouseMoveEvent(U, this.currentUserDetails);
        }
        fieldsToOptions(F, U) {
          return M(F, (Q, J) => {
            let ee = parseFloat(Q), V = J.split("."), G = V.length - 1;
            if (!$(ee) || Q.match(/px|em/g) || J.match(/format/g) || (Q = ee), Q !== "undefined") {
              let W = U;
              V.forEach((ae, z) => {
                if (ae !== "__proto__" && ae !== "constructor") {
                  let q = D(V[z + 1], "");
                  G === z ? W[ae] = Q : (W[ae] || (W[ae] = q.match(/\d/g) ? [] : {}), W = W[ae]);
                }
              });
            }
          }), U;
        }
        deselectAnnotation() {
          this.activeAnnotation && (this.activeAnnotation.setControlPointsVisibility(!1), this.activeAnnotation = !1);
        }
        annotationToFields(F) {
          let U = F.options, Q = R.annotationsEditable, J = Q.nestedOptions, ee = D(U.type, U.shapes && U.shapes[0] && U.shapes[0].type, U.labels && U.labels[0] && U.labels[0].type, "label"), V = R.annotationsNonEditable[U.langKey] || [], G = { langKey: U.langKey, type: ee };
          function W(ae, z, q, Z, ne) {
            let ie;
            q && w(ae) && V.indexOf(z) === -1 && ((q.indexOf && q.indexOf(z)) >= 0 || q[z] || q === !0) && (k(ae) ? (Z[z] = [], ae.forEach((re, de) => {
              j(re) ? (Z[z][de] = {}, M(re, (me, ce) => {
                W(me, ce, J[z], Z[z][de], z);
              })) : W(re, 0, J[z], Z[z], z);
            })) : j(ae) ? (ie = {}, k(Z) ? (Z.push(ie), ie[z] = {}, ie = ie[z]) : Z[z] = ie, M(ae, (re, de) => {
              W(re, de, z === 0 ? q : J[z], ie, z);
            })) : z === "format" ? Z[z] = [m(ae, F.labels[0].points[0]).toString(), "text"] : k(Z) ? Z.push([ae, P(ne, ae)]) : Z[z] = [ae, P(z, ae)]);
          }
          return M(U, (ae, z) => {
            z === "typeOptions" ? (G[z] = {}, M(U[z], (q, Z) => {
              W(q, Z, J, G[z], Z);
            })) : W(ae, z, Q[ee], G, z);
          }), G;
        }
        getClickedClassNames(F, U) {
          let Q = U.target, J = [], ee;
          for (; Q && Q.tagName && ((ee = S(Q, "class")) && (J = J.concat(ee.split(" ").map((V) => [V, Q]))), (Q = Q.parentNode) !== F); )
            ;
          return J;
        }
        getButtonEvents(F, U) {
          let Q, J = this;
          return this.getClickedClassNames(F, U).forEach((ee) => {
            J.boundClassNames[ee[0]] && !Q && (Q = { events: J.boundClassNames[ee[0]], button: ee[1] });
          }), Q;
        }
        update(F) {
          this.options = N(!0, this.options, F), this.removeEvents(), this.initEvents();
        }
        removeEvents() {
          this.eventsToUnbind.forEach((F) => F());
        }
        destroy() {
          this.removeEvents();
        }
      }
      return R.annotationsEditable = { nestedOptions: { labelOptions: ["style", "format", "backgroundColor"], labels: ["style"], label: ["style"], style: ["fontSize", "color"], background: ["fill", "strokeWidth", "stroke"], innerBackground: ["fill", "strokeWidth", "stroke"], outerBackground: ["fill", "strokeWidth", "stroke"], shapeOptions: ["fill", "strokeWidth", "stroke"], shapes: ["fill", "strokeWidth", "stroke"], line: ["strokeWidth", "stroke"], backgroundColors: [!0], connector: ["fill", "strokeWidth", "stroke"], crosshairX: ["strokeWidth", "stroke"], crosshairY: ["strokeWidth", "stroke"] }, circle: ["shapes"], ellipse: ["shapes"], verticalLine: [], label: ["labelOptions"], measure: ["background", "crosshairY", "crosshairX"], fibonacci: [], tunnel: ["background", "line", "height"], pitchfork: ["innerBackground", "outerBackground"], rect: ["shapes"], crookedLine: [], basicAnnotation: ["shapes", "labelOptions"] }, R.annotationsNonEditable = { rectangle: ["crosshairX", "crosshairY", "labelOptions"], ellipse: ["labelOptions"], circle: ["labelOptions"] }, R;
    }), i(n, "masters/modules/annotations.src.js", [n["Core/Globals.js"], n["Extensions/Annotations/Annotation.js"], n["Extensions/Annotations/NavigationBindings.js"]], function(o, a, r) {
      return o.Annotation = o.Annotation || a, o.NavigationBindings = o.NavigationBindings || r, o.Annotation.compose(o.Chart, o.NavigationBindings, o.Pointer, o.SVGRenderer), o;
    });
  });
})(Hk);
var s$ = Hk.exports;
const l$ = /* @__PURE__ */ en(s$), c$ = ["id"], eh = /* @__PURE__ */ Be({
  __name: "Chart",
  props: {
    constructorType: {
      type: String,
      default: "chart"
    },
    options: {
      type: Object,
      required: !0
    },
    redrawOnUpdate: {
      type: Boolean,
      default: !0
    },
    oneToOneUpdate: {
      type: Boolean,
      default: !0
    },
    animateOnUpdate: {
      type: Boolean,
      default: !0
    },
    deepCopyOnUpdate: {
      type: Boolean,
      default: !0
    }
  },
  emits: ["updated", "rendered", "destroyed"],
  setup(e, { expose: t, emit: n }) {
    typeof Nn == "object" && (q6(Nn), X6(Nn), J6(Nn), e$(Nn), n$(Nn), a$(Nn), r$(Nn), l$(Nn));
    function i(h, c, g) {
      function v(P, f) {
        Nn.isObject(P, !g) && !Nn.isClass(P) && !Nn.isDOMElement(P) ? h[f] = i(
          h[f] || Nn.isArray(P) ? [] : {},
          P,
          g
        ) : h[f] = c[f];
      }
      return Nn.isArray(c) ? c.forEach(v) : Nn.objectEach(c, v), h;
    }
    const o = function(h, c) {
      return i({}, h, c);
    }, a = e, r = n, s = Nx(), l = typeof window < "u" && typeof window.document < "u", d = ge(), y = ge(), { options: u } = Ep(a);
    return y.value && qe(
      u,
      (h) => {
        y.value && (y.value.update(
          o(h, a.deepCopyOnUpdate),
          a.redrawOnUpdate,
          a.oneToOneUpdate,
          a.animateOnUpdate
        ), r("updated"));
      },
      { deep: !0 }
    ), it(() => {
      const h = o(u.value, !0);
      d.value && (a.constructorType === Ra.Chart ? y.value = Nn.chart(d.value, h, () => {
        r("rendered");
      }) : a.constructorType === Ra.StockChart && (y.value = Nn.stockChart(d.value, h, () => {
        r("rendered");
      })));
    }), sn(() => {
      y.value ? (y.value.destroy(), r("destroyed")) : a.options ? l && console.warn(
        `${a.constructorType} is not a valid highcharts type or has not been imported`
      ) : console.warn('The "options" parameter is required.');
    }), t({
      chartRef: d,
      chartInstance: y,
      rerender: (h) => {
        y.value && (y.value.update(
          o(h, a.deepCopyOnUpdate),
          a.redrawOnUpdate,
          a.oneToOneUpdate,
          a.animateOnUpdate
        ), r("updated"));
      }
    }), (h, c) => (E(), X("div", {
      id: _(s),
      ref_key: "chartRef",
      ref: d
    }, null, 8, c$));
  }
}), d$ = ["id"], u$ = /* @__PURE__ */ Be({
  __name: "BaseChart",
  props: {
    options: {
      type: Object,
      required: !0
    },
    chartType: {
      type: String,
      required: !1,
      default: Ra.StockChart
    },
    height: {
      type: String,
      required: !1,
      default: Vo.Small
    }
  },
  emits: ["chartRendered", "chartUpdated", "chartDestroyed"],
  setup(e, { expose: t, emit: n }) {
    Ue && (es.SVGRenderer.prototype.symbols.flag = function(m, h, c, g, v) {
      const P = v && v.anchorX || m, f = v && v.anchorY || h, S = 6, w = [];
      return w.push(
        // flag-line
        ["M", P, f],
        ["L", m, h + g],
        ["L", m, h + g],
        ["Z"]
      ), w.push(
        // flag with rounded corners
        ["M", m + S, h],
        ["L", m + c - S, h],
        ["C", m + c, h, m + c, h, m + c, h + S],
        ["L", m + c, h + g - S],
        ["C", m + c, h + g, m + c, h + g, m + c - S, h + g],
        ["L", m + S, h + g],
        ["C", m, h + g, m, h + g, m, h + g],
        ["L", m, h],
        ["C", m, h, m, h, m + S, h],
        ["Z"]
      ), w;
    });
    const i = e, o = ge(), a = Nx();
    t({
      baseChart: o
    });
    const r = n, s = Te(() => "".concat(
      "height: ",
      i.height
    )), l = () => {
      r("chartRendered");
    }, d = () => {
      r("chartUpdated");
    }, y = () => {
      r("chartDestroyed");
    };
    return (u, m) => (E(), X("div", { id: _(a) }, [
      ue(eh, {
        ref_key: "baseChart",
        ref: o,
        "constructor-type": i.chartType,
        options: i.options,
        "redraw-on-update": !0,
        "one-to-one-update": !1,
        "animate-on-update": !0,
        style: hn(s.value),
        onRendered: l,
        onUpdated: d,
        onDestroyed: y,
        onChartRendered: l,
        onChartUpdated: d,
        onChartDestroyed: y
      }, null, 8, ["constructor-type", "options", "style"])
    ], 8, d$));
  }
});
const Xc = /* @__PURE__ */ Fe(u$, [["__scopeId", "data-v-45b30812"]]);
const h$ = Be({
  name: "ColoredNumber",
  props: {
    number: {
      type: String || Number,
      required: !1,
      default: null
    },
    addPercent: {
      type: Boolean,
      default: !1
    },
    percentSign: {
      type: String,
      required: !1,
      default: ""
    }
  },
  computed: {
    getClass() {
      return this.isZero() || !this.needColorCoding() ? null : this.isPositive() ? "positive" : "negative";
    }
  },
  created() {
    if (this.number) {
      const e = typeof this.number == "string" ? this.number.replace(",", ".") : this.number;
      this.valueAsFloat = parseFloat(e);
    }
  },
  methods: {
    isPositive() {
      return Math.sign(this.valueAsFloat) !== -1;
    },
    isZero() {
      return this.number === "0" || this.number === 0;
    },
    needColorCoding() {
      if (Ue) {
        const e = document.querySelector("html").getAttribute("data-color-coding");
        if (e)
          return e === "true";
      }
      return !1;
    }
  }
});
function p$(e, t, n, i, o, a) {
  return (e.number || e.number === 0) && !isNaN(e.valueAsFloat) ? (E(), X("span", {
    key: 0,
    class: Pe(e.getClass)
  }, Ie(e.number) + Ie(e.addPercent ? e.percentSign : ""), 3)) : te("", !0);
}
const zk = /* @__PURE__ */ Fe(h$, [["render", p$]]);
const f$ = Be({
  name: "DropDocuments",
  directives: {
    ripple: An
  },
  components: {
    VirtualScroller: Ls,
    BaseLinkV2: ot
  },
  props: {
    emptyLabel: {
      type: Boolean,
      default: !1
    },
    modelValue: null,
    options: Array,
    optionLabel: null,
    optionValue: null,
    optionDisabled: null,
    optionGroupLabel: null,
    optionGroupChildren: null,
    scrollHeight: {
      type: String,
      default: "200px"
    },
    editable: Boolean,
    placeholder: String,
    disabled: Boolean,
    dataKey: null,
    showClear: Boolean,
    inputId: String,
    tabindex: String,
    ariaLabelledBy: null,
    appendTo: {
      type: String,
      default: "self"
    },
    emptyMessage: {
      type: String,
      default: null
    },
    panelClass: null,
    loading: {
      type: Boolean,
      default: !1
    },
    loadingIcon: {
      type: String,
      default: "las la-angle-down"
    },
    virtualScrollerOptions: {
      type: Object,
      default: null
    },
    resetOptionLabel: {
      type: Boolean,
      default: !1
    },
    downloadAnchor: {
      type: Boolean,
      default: !1
    },
    anchorLink: {
      type: Object,
      default: void 0
    },
    dataEventSource: {
      type: String,
      default: ""
    },
    eventComponentName: {
      type: String,
      default: "Product-Header"
    }
  },
  emits: [
    "update:modelValue",
    "before-show",
    "before-hide",
    "show",
    "hide",
    "change",
    "focus",
    "blur"
  ],
  data() {
    return {
      focused: !1,
      overlayVisible: !1,
      uuid: Pn(),
      outsideClickListener: null,
      scrollHandler: null,
      resizeListener: null,
      searchTimeout: null,
      currentSearchChar: null,
      previousSearchChar: null,
      searchValue: null,
      overlay: null,
      itemsWrapper: null,
      virtualScroller: null,
      isModelValueChanged: !1
    };
  },
  created() {
    const { t: e } = Je();
    this.translate = e;
  },
  computed: {
    dropDocumentLabel() {
      return "dropDocumentLabel-" + this.uuid;
    },
    iconType() {
      return H.ArrowDown;
    },
    iconPosition() {
      return ct.Left;
    },
    linkType() {
      return yt.Anchor;
    },
    visibleOptions() {
      return this.options;
    },
    containerClass() {
      return [
        "p-dropdown-docs p-component p-inputwrapper",
        {
          "p-disabled": this.disabled,
          "p-dropdown-clearable": this.showClear && !this.disabled,
          "p-focus": this.focused,
          "p-inputwrapper-filled": this.modelValue,
          "p-inputwrapper-focus": this.focused || this.overlayVisible
        }
      ];
    },
    labelClass() {
      return [
        "p-dropdown-label p-inputtext",
        {
          "p-placeholder": this.label === this.placeholder,
          "p-dropdown-label-empty": !this.$slots.value && (this.label === "p-emptylabel" || this.label.length === 0) || this.emptyLabel
        }
      ];
    },
    panelStyleClass() {
      return [
        "p-dropdown-panel-docs p-component",
        this.panelClass,
        {
          "p-input-filled": this.$primevue.config.inputStyle === "filled",
          "p-ripple-disabled": this.$primevue.config.ripple === !1
        }
      ];
    },
    label() {
      const e = this.getSelectedOption();
      return e && !this.resetOptionLabel ? this.getOptionLabel(e) : this.placeholder || "";
    },
    editableInputValue() {
      const e = this.getSelectedOption();
      return e ? this.getOptionLabel(e) : this.modelValue;
    },
    equalityKey() {
      return this.optionValue ? null : this.dataKey;
    },
    emptyMessageText() {
      return this.emptyMessage || this.$primevue.config.locale.emptyMessage;
    },
    appendDisabled() {
      return this.appendTo === "self";
    },
    virtualScrollerDisabled() {
      return !this.virtualScrollerOptions;
    },
    appendTarget() {
      return this.appendDisabled ? null : this.appendTo;
    },
    dropdownIconClass() {
      return ["p-dropdown-trigger-icon", this.loadingIcon];
    },
    anchorLinkComputed() {
      return this.anchorLink ? this.anchorLink : {
        text: this.translate("productHeader.allDocuments"),
        href: "#documents",
        target: "_self",
        contentUrl: "",
        title: "",
        isLocked: !1,
        isExternal: !1,
        linkType: this.linkType,
        tealiumTrackingModel: {
          eventComponentName: this.eventComponentName,
          eventTitle: "Downloads | regular | all",
          eventSource: this.dataEventSource,
          eventTarget: "Alle Dokumente"
        }
      };
    }
  },
  watch: {
    modelValue() {
      this.isModelValueChanged = !0;
    }
  },
  updated() {
    this.overlayVisible && this.isModelValueChanged && this.scrollValueInView(), this.isModelValueChanged = !1;
  },
  beforeUnmount() {
    this.unbindOutsideClickListener(), this.unbindResizeListener(), this.scrollHandler && (this.scrollHandler.destroy(), this.scrollHandler = null), this.itemsWrapper = null, this.overlay && (qt.clear(this.overlay), this.overlay = null);
  },
  methods: {
    goToAnchor(e) {
      if (Ue) {
        const t = document.getElementById(e.replace("#", ""));
        t && this.$smoothScroll({
          scrollTo: t || 0,
          duration: 1e3,
          offset: 0,
          updateHistory: !1
        });
      }
    },
    getOptionIndex(e, t) {
      return this.virtualScrollerDisabled ? e : t && t(e).index;
    },
    getOptionLabel(e) {
      return this.optionLabel ? We.resolveFieldData(e, this.optionLabel) : e;
    },
    getOptionValue(e) {
      return this.optionValue ? We.resolveFieldData(e, this.optionValue) : e;
    },
    getOptionRenderKey(e) {
      return this.dataKey ? We.resolveFieldData(e, this.dataKey) : this.getOptionLabel(e);
    },
    isOptionDisabled(e) {
      return this.optionDisabled ? We.resolveFieldData(e, this.optionDisabled) : !1;
    },
    getOptionGroupRenderKey(e) {
      return We.resolveFieldData(e, this.optionGroupLabel);
    },
    getOptionGroupLabel(e) {
      return We.resolveFieldData(e, this.optionGroupLabel);
    },
    getOptionGroupChildren(e) {
      return We.resolveFieldData(
        e,
        this.optionGroupChildren
      );
    },
    getSelectedOption() {
      const e = this.getSelectedOptionIndex();
      return e !== -1 ? this.optionGroupLabel ? this.getOptionGroupChildren(this.visibleOptions[e.group])[e.option] : this.visibleOptions[e] : null;
    },
    getSelectedOptionIndex() {
      if (this.modelValue != null && this.visibleOptions)
        if (this.optionGroupLabel)
          for (let e = 0; e < this.visibleOptions.length; e++) {
            const t = this.findOptionIndexInList(
              this.modelValue,
              this.getOptionGroupChildren(this.visibleOptions[e])
            );
            if (t !== -1)
              return { group: e, option: t };
          }
        else
          return this.findOptionIndexInList(
            this.modelValue,
            this.visibleOptions
          );
      return -1;
    },
    findOptionIndexInList(e, t) {
      for (let n = 0; n < t.length; n++)
        if (We.equals(
          e,
          this.getOptionValue(t[n]),
          this.equalityKey
        ))
          return n;
      return -1;
    },
    isSelected(e) {
      return We.equals(
        this.modelValue,
        this.getOptionValue(e),
        this.equalityKey
      );
    },
    show() {
      this.$emit("before-show"), this.overlayVisible = !0;
    },
    hide() {
      this.$emit("before-hide"), this.overlayVisible = !1;
    },
    onFocus(e) {
      this.focused = !0, this.$emit("focus", e);
    },
    onBlur(e) {
      this.focused = !1, this.$emit("blur", e);
    },
    onKeyDown(e) {
      switch (e.which) {
        case 40:
          this.onDownKey(e);
          break;
        case 38:
          this.onUpKey(e);
          break;
        case 32:
          this.overlayVisible || (this.show(), e.preventDefault());
          break;
        case 13:
        case 27:
          this.overlayVisible && (this.$refs.container.focus(), this.hide(), e.preventDefault());
          break;
        default:
          this.search(e);
          break;
      }
    },
    onDownKey(e) {
      if (this.visibleOptions)
        if (!this.overlayVisible && e.altKey)
          this.show();
        else {
          const t = this.visibleOptions && this.visibleOptions.length > 0 ? this.findNextOption(this.getSelectedOptionIndex()) : null;
          t && this.updateModel(e, this.getOptionValue(t));
        }
      e.preventDefault();
    },
    onUpKey(e) {
      if (this.visibleOptions) {
        const t = this.findPrevOption(this.getSelectedOptionIndex());
        t && this.updateModel(e, this.getOptionValue(t));
      }
      e.preventDefault();
    },
    findNextOption(e) {
      if (this.optionGroupLabel) {
        const t = e === -1 ? 0 : e.group, n = e === -1 ? -1 : e.option, i = this.findNextOptionInList(
          this.getOptionGroupChildren(this.visibleOptions[t]),
          n
        );
        return i || (t + 1 !== this.visibleOptions.length ? this.findNextOption({
          group: t + 1,
          option: -1
        }) : null);
      } else
        return this.findNextOptionInList(this.visibleOptions, e);
    },
    findNextOptionInList(e, t) {
      const n = t + 1;
      if (n === e.length)
        return null;
      const i = e[n];
      return this.isOptionDisabled(i) ? this.findNextOptionInList(n) : i;
    },
    findPrevOption(e) {
      if (e === -1)
        return null;
      if (this.optionGroupLabel) {
        const t = e.group, n = e.option, i = this.findPrevOptionInList(
          this.getOptionGroupChildren(this.visibleOptions[t]),
          n
        );
        return i || (t > 0 ? this.findPrevOption({
          group: t - 1,
          option: this.getOptionGroupChildren(
            this.visibleOptions[t - 1]
          ).length
        }) : null);
      } else
        return this.findPrevOptionInList(this.visibleOptions, e);
    },
    findPrevOptionInList(e, t) {
      const n = t - 1;
      if (n < 0)
        return null;
      const i = e[n];
      return this.isOptionDisabled(i) ? this.findPrevOption(n) : i;
    },
    onClearClick(e) {
      this.updateModel(e, null);
    },
    onClick(e) {
      this.disabled || this.loading || Oe.hasClass(e.target, "p-dropdown-clear-icon") || e.target.tagName === "INPUT" || (!this.overlay || !this.overlay.contains(e.target)) && (this.overlayVisible ? this.hide() : this.show(), this.$refs.focusInput.focus());
    },
    onOptionSelect(e, t) {
      const n = this.getOptionValue(t);
      this.updateModel(e, n), this.$refs.focusInput.focus(), setTimeout(() => {
        this.hide();
      }, 200);
    },
    onEditableInput(e) {
      this.$emit("update:modelValue", e.target.value);
    },
    onOverlayEnter(e) {
      if (qt.set("overlay", e, this.$primevue.config.zIndex.overlay), this.alignOverlay(), this.bindOutsideClickListener(), this.bindScrollListener(), this.bindResizeListener(), this.scrollValueInView(), !this.virtualScrollerDisabled) {
        const t = this.getSelectedOptionIndex();
        t !== -1 && this.virtualScroller.scrollToIndex(t);
      }
      this.$emit("show");
    },
    onOverlayLeave() {
      this.unbindOutsideClickListener(), this.unbindScrollListener(), this.unbindResizeListener(), this.$emit("hide"), this.itemsWrapper = null, this.overlay = null;
    },
    onOverlayAfterLeave(e) {
      qt.clear(e);
    },
    alignOverlay() {
      this.appendDisabled ? Oe.relativePosition(this.overlay, this.$el) : (this.overlay.style.minWidth = Oe.getOuterWidth(this.$el) + "px", Oe.absolutePosition(this.overlay, this.$el));
    },
    updateModel(e, t) {
      this.$emit("update:modelValue", t), this.$emit("change", { originalEvent: e, value: t });
    },
    bindOutsideClickListener() {
      this.outsideClickListener || (this.outsideClickListener = (e) => {
        this.overlayVisible && this.overlay && !this.$el.contains(e.target) && !this.overlay.contains(e.target) && this.hide();
      }, Ue && document.addEventListener("click", this.outsideClickListener));
    },
    unbindOutsideClickListener() {
      this.outsideClickListener && Ue && (document.removeEventListener("click", this.outsideClickListener), this.outsideClickListener = null);
    },
    bindScrollListener() {
      this.scrollHandler || (this.scrollHandler = new po(
        this.$refs.container,
        () => {
          this.overlayVisible && this.hide();
        }
      )), this.scrollHandler.bindScrollListener();
    },
    unbindScrollListener() {
      this.scrollHandler && this.scrollHandler.unbindScrollListener();
    },
    bindResizeListener() {
      this.resizeListener || (this.resizeListener = () => {
        this.overlayVisible && !Oe.isTouchDevice() && this.hide();
      }, Ue && window.addEventListener("resize", this.resizeListener));
    },
    unbindResizeListener() {
      this.resizeListener && Ue && (window.removeEventListener("resize", this.resizeListener), this.resizeListener = null);
    },
    search(e) {
      if (!this.visibleOptions)
        return;
      this.searchTimeout && clearTimeout(this.searchTimeout);
      const t = e.key;
      if (this.previousSearchChar = this.currentSearchChar, this.currentSearchChar = t, this.previousSearchChar === this.currentSearchChar ? this.searchValue = this.currentSearchChar : this.searchValue = this.searchValue ? this.searchValue + t : t, this.searchValue) {
        let n = this.getSelectedOptionIndex();
        const i = this.optionGroupLabel ? this.searchOptionInGroup(n) : this.searchOption(++n);
        i && this.updateModel(e, this.getOptionValue(i));
      }
      this.searchTimeout = setTimeout(() => {
        this.searchValue = null;
      }, 250);
    },
    searchOption(e) {
      let t;
      return this.searchValue && (t = this.searchOptionInRange(e, this.visibleOptions.length), t || (t = this.searchOptionInRange(0, e))), t;
    },
    searchOptionInRange(e, t) {
      for (let n = e; n < t; n++) {
        const i = this.visibleOptions[n];
        if (this.matchesSearchValue(i))
          return i;
      }
      return null;
    },
    searchOptionInGroup(e) {
      const t = e === -1 ? { group: 0, option: -1 } : e;
      for (let n = t.group; n < this.visibleOptions.length; n++) {
        const i = this.getOptionGroupChildren(
          this.visibleOptions[n]
        );
        for (let o = t.group === n ? t.option + 1 : 0; o < i.length; o++)
          if (this.matchesSearchValue(i[o]))
            return i[o];
      }
      for (let n = 0; n <= t.group; n++) {
        const i = this.getOptionGroupChildren(
          this.visibleOptions[n]
        );
        for (let o = 0; o < (t.group === n ? t.option : i.length); o++)
          if (this.matchesSearchValue(i[o]))
            return i[o];
      }
      return null;
    },
    matchesSearchValue(e) {
      return this.getOptionLabel(e).toLocaleLowerCase(
        this.filterLocale
      ).startsWith(
        this.searchValue.toLocaleLowerCase(this.filterLocale)
      );
    },
    overlayRef(e) {
      this.overlay = e;
    },
    itemsWrapperRef(e) {
      this.itemsWrapper = e;
    },
    virtualScrollerRef(e) {
      this.virtualScroller = e;
    },
    scrollValueInView() {
      if (this.overlay) {
        const e = Oe.findSingle(
          this.overlay,
          "li.p-highlight"
        );
        e && e.scrollIntoView({
          block: "nearest",
          inline: "start"
        });
      }
    },
    onOverlayClick(e) {
      Zn.emit("overlay-click", {
        originalEvent: e,
        target: this.$el
      });
    }
  }
}), m$ = ["aria-labelledby"], g$ = { class: "p-hidden-accessible" }, v$ = ["id", "disabled", "aria-labelledby"], y$ = ["disabled", "placeholder", "value"], b$ = ["id"], x$ = ["aria-expanded", "aria-label"], w$ = ["id", "aria-label", "aria-selected", "onClick"], k$ = ["aria-label", "aria-selected"], S$ = { class: "p-dropdown-item-group" }, C$ = ["aria-label"];
function T$(e, t, n, i, o, a) {
  const r = $e("BaseLinkV2"), s = $e("VirtualScroller"), l = Ut("ripple");
  return E(), X("div", {
    ref: "container",
    class: Pe(e.containerClass),
    tabindex: "0",
    "aria-labelledby": e.dropDocumentLabel,
    onClick: t[13] || (t[13] = (d) => e.onClick(d)),
    onKeydown: t[14] || (t[14] = Ze((d) => e.onClick(d), ["enter"]))
  }, [
    oe("div", g$, [
      oe("input", {
        id: e.inputId,
        ref: "focusInput",
        type: "text",
        readonly: "",
        tabindex: "-1",
        disabled: e.disabled,
        "aria-haspopup": "true",
        "aria-labelledby": e.dropDocumentLabel,
        onFocus: t[0] || (t[0] = (...d) => e.onFocus && e.onFocus(...d)),
        onBlur: t[1] || (t[1] = (...d) => e.onBlur && e.onBlur(...d)),
        onKeydown: [
          t[2] || (t[2] = It((...d) => e.onKeyDown && e.onKeyDown(...d), ["exact"])),
          t[3] || (t[3] = Ze(It((...d) => e.onUpKey && e.onUpKey(...d), ["shift"]), ["tab"])),
          t[4] || (t[4] = Ze(It((...d) => e.onDownKey && e.onDownKey(...d), ["exact"]), ["tab"]))
        ]
      }, null, 40, v$)
    ]),
    e.editable ? (E(), X("input", {
      key: 0,
      type: "text",
      class: "p-dropdown-label p-inputtext",
      disabled: e.disabled,
      placeholder: e.placeholder,
      value: e.editableInputValue,
      "aria-haspopup": "listbox",
      onFocus: t[5] || (t[5] = (...d) => e.onFocus && e.onFocus(...d)),
      onBlur: t[6] || (t[6] = (...d) => e.onBlur && e.onBlur(...d)),
      onInput: t[7] || (t[7] = (...d) => e.onEditableInput && e.onEditableInput(...d))
    }, null, 40, y$)) : te("", !0),
    e.editable ? te("", !0) : (E(), X("span", {
      key: 1,
      id: e.dropDocumentLabel,
      class: Pe(e.labelClass)
    }, [
      je(e.$slots, "value", {
        value: e.modelValue,
        placeholder: e.placeholder
      }, () => [
        Ve(Ie(e.label || ""), 1)
      ])
    ], 10, b$)),
    e.showClear && e.modelValue != null ? (E(), X("i", {
      key: 2,
      class: "p-dropdown-clear-icon las la-times",
      onClick: t[8] || (t[8] = (d) => e.onClearClick(d))
    })) : te("", !0),
    oe("div", {
      class: "p-dropdown-trigger",
      role: "button",
      "aria-haspopup": "listbox",
      "aria-expanded": e.overlayVisible,
      "aria-label": e.translate("dropDocuments.button")
    }, [
      je(e.$slots, "indicator", {}, () => [
        oe("span", {
          class: Pe(e.dropdownIconClass)
        }, null, 2)
      ])
    ], 8, x$),
    (E(), fe(Rx, {
      to: e.appendTarget,
      disabled: e.appendDisabled
    }, [
      ue(ia, {
        name: "p-connected-overlay",
        onEnter: e.onOverlayEnter,
        onLeave: e.onOverlayLeave,
        onAfterLeave: e.onOverlayAfterLeave
      }, {
        default: Se(() => [
          e.overlayVisible ? (E(), X("div", {
            key: 0,
            ref: e.overlayRef,
            class: Pe(e.panelStyleClass),
            role: "dialog",
            onClick: t[12] || (t[12] = (...d) => e.onOverlayClick && e.onOverlayClick(...d))
          }, [
            je(e.$slots, "header", {
              value: e.modelValue,
              options: e.visibleOptions
            }),
            oe("div", {
              ref: e.itemsWrapperRef,
              class: "p-dropdown-items-wrapper",
              style: hn({
                "max-height": e.virtualScrollerDisabled ? e.scrollHeight : ""
              })
            }, [
              ue(s, Ce({ ref: e.virtualScrollerRef }, e.virtualScrollerOptions, {
                items: e.visibleOptions,
                style: { height: e.scrollHeight },
                disabled: e.virtualScrollerDisabled
              }), Qt({
                content: Se(({ styleClass: d, contentRef: y, items: u, getItemOptions: m }) => [
                  oe("ul", {
                    ref: y,
                    class: Pe(["p-dropdown-items", d]),
                    role: "listbox"
                  }, [
                    e.optionGroupLabel ? (E(!0), X(Re, { key: 1 }, Ge(u, (h, c) => (E(), X(Re, {
                      key: e.getOptionGroupRenderKey(h)
                    }, [
                      oe("li", S$, [
                        je(e.$slots, "optiongroup", {
                          option: h,
                          index: e.getOptionIndex(c, m)
                        }, () => [
                          Ve(Ie(e.getOptionGroupLabel(h)), 1)
                        ])
                      ]),
                      (E(!0), X(Re, null, Ge(e.getOptionGroupChildren(
                        h
                      ), (g, v) => rt((E(), X("li", {
                        key: e.getOptionRenderKey(g),
                        class: Pe([
                          "p-dropdown-item",
                          {
                            "p-highlight": e.isSelected(g),
                            "p-disabled": e.isOptionDisabled(g)
                          }
                        ]),
                        role: "option",
                        "aria-label": e.getOptionLabel(g),
                        onClick: t[11] || (t[11] = (...P) => e.hide && e.hide(...P))
                      }, [
                        je(e.$slots, "option", {
                          option: g,
                          index: e.getOptionIndex(v, m)
                        }, () => [
                          Ve(Ie(e.getOptionLabel(g)), 1)
                        ])
                      ], 10, C$)), [
                        [l]
                      ])), 128))
                    ], 64))), 128)) : (E(), X(Re, { key: 0 }, [
                      (E(!0), X(Re, null, Ge(u, (h, c) => rt((E(), X("li", {
                        id: `dropdoc-${c}`,
                        key: e.getOptionRenderKey(h),
                        class: Pe([
                          "p-dropdown-item",
                          {
                            "p-highlight": e.isSelected(h),
                            "p-disabled": e.isOptionDisabled(h)
                          }
                        ]),
                        role: "option",
                        "aria-label": e.getOptionLabel(h),
                        "aria-selected": e.isSelected(h),
                        onClick: (g) => e.onOptionSelect(g, h)
                      }, [
                        je(e.$slots, "option", {
                          option: h,
                          index: e.getOptionIndex(c, m)
                        }, () => [
                          Ve(Ie(e.getOptionLabel(h)), 1)
                        ])
                      ], 10, w$)), [
                        [l]
                      ])), 128)),
                      e.downloadAnchor ? (E(), X("li", {
                        key: 0,
                        id: "dropdoc-all",
                        class: "p-dropdown-item",
                        role: "option",
                        "aria-label": e.translate("dropDocuments.allDocuments"),
                        "aria-selected": e.isSelected(e.option),
                        onClick: t[10] || (t[10] = (h) => e.onOptionSelect(h, e.option))
                      }, [
                        ue(r, {
                          class: "product-header__description__btn-group__documents__item shrink-header__description__btn-group__documents__item all no-border",
                          "link-model": e.anchorLinkComputed,
                          icon: e.iconType,
                          "icon-position": e.iconPosition,
                          onClick: t[9] || (t[9] = (h) => e.goToAnchor(e.anchorLinkComputed.href))
                        }, null, 8, ["link-model", "icon", "icon-position"])
                      ], 8, k$)) : te("", !0)
                    ], 64))
                  ], 2)
                ]),
                _: 2
              }, [
                e.$slots.loader ? {
                  name: "loader",
                  fn: Se(({ options: d }) => [
                    je(e.$slots, "loader", { options: d })
                  ]),
                  key: "0"
                } : void 0
              ]), 1040, ["items", "style", "disabled"])
            ], 4),
            je(e.$slots, "footer", {
              value: e.modelValue,
              options: e.visibleOptions
            })
          ], 2)) : te("", !0)
        ]),
        _: 3
      }, 8, ["onEnter", "onLeave", "onAfterLeave"])
    ], 8, ["to", "disabled"]))
  ], 42, m$);
}
const Zc = /* @__PURE__ */ Fe(f$, [["render", T$]]);
var Vk = {
  name: "CalendarIcon",
  extends: Yt
}, L$ = /* @__PURE__ */ oe("path", {
  d: "M10.7838 1.51351H9.83783V0.567568C9.83783 0.417039 9.77804 0.272676 9.6716 0.166237C9.56516 0.0597971 9.42079 0 9.27027 0C9.11974 0 8.97538 0.0597971 8.86894 0.166237C8.7625 0.272676 8.7027 0.417039 8.7027 0.567568V1.51351H5.29729V0.567568C5.29729 0.417039 5.2375 0.272676 5.13106 0.166237C5.02462 0.0597971 4.88025 0 4.72973 0C4.5792 0 4.43484 0.0597971 4.3284 0.166237C4.22196 0.272676 4.16216 0.417039 4.16216 0.567568V1.51351H3.21621C2.66428 1.51351 2.13494 1.73277 1.74467 2.12305C1.35439 2.51333 1.13513 3.04266 1.13513 3.59459V11.9189C1.13513 12.4709 1.35439 13.0002 1.74467 13.3905C2.13494 13.7807 2.66428 14 3.21621 14H10.7838C11.3357 14 11.865 13.7807 12.2553 13.3905C12.6456 13.0002 12.8649 12.4709 12.8649 11.9189V3.59459C12.8649 3.04266 12.6456 2.51333 12.2553 2.12305C11.865 1.73277 11.3357 1.51351 10.7838 1.51351ZM3.21621 2.64865H4.16216V3.59459C4.16216 3.74512 4.22196 3.88949 4.3284 3.99593C4.43484 4.10237 4.5792 4.16216 4.72973 4.16216C4.88025 4.16216 5.02462 4.10237 5.13106 3.99593C5.2375 3.88949 5.29729 3.74512 5.29729 3.59459V2.64865H8.7027V3.59459C8.7027 3.74512 8.7625 3.88949 8.86894 3.99593C8.97538 4.10237 9.11974 4.16216 9.27027 4.16216C9.42079 4.16216 9.56516 4.10237 9.6716 3.99593C9.77804 3.88949 9.83783 3.74512 9.83783 3.59459V2.64865H10.7838C11.0347 2.64865 11.2753 2.74831 11.4527 2.92571C11.6301 3.10311 11.7297 3.34371 11.7297 3.59459V5.67568H2.27027V3.59459C2.27027 3.34371 2.36993 3.10311 2.54733 2.92571C2.72473 2.74831 2.96533 2.64865 3.21621 2.64865ZM10.7838 12.8649H3.21621C2.96533 12.8649 2.72473 12.7652 2.54733 12.5878C2.36993 12.4104 2.27027 12.1698 2.27027 11.9189V6.81081H11.7297V11.9189C11.7297 12.1698 11.6301 12.4104 11.4527 12.5878C11.2753 12.7652 11.0347 12.8649 10.7838 12.8649Z",
  fill: "currentColor"
}, null, -1), I$ = [L$];
function P$(e, t, n, i, o, a) {
  return E(), X("svg", Ce({
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.pti()), I$, 16);
}
Vk.render = P$;
var th = {
  name: "ChevronLeftIcon",
  extends: Yt
}, A$ = /* @__PURE__ */ oe("path", {
  d: "M9.61296 13C9.50997 13.0005 9.40792 12.9804 9.3128 12.9409C9.21767 12.9014 9.13139 12.8433 9.05902 12.7701L3.83313 7.54416C3.68634 7.39718 3.60388 7.19795 3.60388 6.99022C3.60388 6.78249 3.68634 6.58325 3.83313 6.43628L9.05902 1.21039C9.20762 1.07192 9.40416 0.996539 9.60724 1.00012C9.81032 1.00371 10.0041 1.08597 10.1477 1.22959C10.2913 1.37322 10.3736 1.56698 10.3772 1.77005C10.3808 1.97313 10.3054 2.16968 10.1669 2.31827L5.49496 6.99022L10.1669 11.6622C10.3137 11.8091 10.3962 12.0084 10.3962 12.2161C10.3962 12.4238 10.3137 12.6231 10.1669 12.7701C10.0945 12.8433 10.0083 12.9014 9.91313 12.9409C9.81801 12.9804 9.71596 13.0005 9.61296 13Z",
  fill: "currentColor"
}, null, -1), _$ = [A$];
function M$(e, t, n, i, o, a) {
  return E(), X("svg", Ce({
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.pti()), _$, 16);
}
th.render = M$;
var ig = {
  name: "ChevronUpIcon",
  extends: Yt
}, O$ = /* @__PURE__ */ oe("path", {
  d: "M12.2097 10.4113C12.1057 10.4118 12.0027 10.3915 11.9067 10.3516C11.8107 10.3118 11.7237 10.2532 11.6506 10.1792L6.93602 5.46461L2.22139 10.1476C2.07272 10.244 1.89599 10.2877 1.71953 10.2717C1.54307 10.2556 1.3771 10.1808 1.24822 10.0593C1.11933 9.93766 1.035 9.77633 1.00874 9.6011C0.982477 9.42587 1.0158 9.2469 1.10338 9.09287L6.37701 3.81923C6.52533 3.6711 6.72639 3.58789 6.93602 3.58789C7.14565 3.58789 7.3467 3.6711 7.49502 3.81923L12.7687 9.09287C12.9168 9.24119 13 9.44225 13 9.65187C13 9.8615 12.9168 10.0626 12.7687 10.2109C12.616 10.3487 12.4151 10.4207 12.2097 10.4113Z",
  fill: "currentColor"
}, null, -1), B$ = [O$];
function E$(e, t, n, i, o, a) {
  return E(), X("svg", Ce({
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.pti()), B$, 16);
}
ig.render = E$;
var D$ = `
@layer primevue {
    .p-calendar {
        display: inline-flex;
        max-width: 100%;
    }

    .p-calendar .p-inputtext {
        flex: 1 1 auto;
        width: 1%;
    }

    .p-calendar-w-btn .p-inputtext {
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
    }

    .p-calendar-w-btn .p-datepicker-trigger {
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
    }

    .p-calendar .p-datepicker-trigger-icon {
        cursor: pointer;
    }

    /* Fluid */
    .p-fluid .p-calendar {
        display: flex;
    }

    .p-fluid .p-calendar .p-inputtext {
        width: 1%;
    }

    /* Datepicker */
    .p-calendar .p-datepicker {
        min-width: 100%;
    }

    .p-datepicker {
        width: auto;
    }

    .p-datepicker-inline {
        display: inline-block;
        overflow-x: auto;
    }

    /* Header */
    .p-datepicker-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    .p-datepicker-header .p-datepicker-title {
        margin: 0 auto;
    }

    .p-datepicker-prev,
    .p-datepicker-next {
        cursor: pointer;
        display: inline-flex;
        justify-content: center;
        align-items: center;
        overflow: hidden;
        position: relative;
    }

    /* Multiple Month DatePicker */
    .p-datepicker-multiple-month .p-datepicker-group-container {
        display: flex;
    }

    .p-datepicker-multiple-month .p-datepicker-group-container .p-datepicker-group {
        flex: 1 1 auto;
    }

    /* DatePicker Table */
    .p-datepicker table {
        width: 100%;
        border-collapse: collapse;
    }

    .p-datepicker td > span {
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        margin: 0 auto;
        overflow: hidden;
        position: relative;
    }

    /* Month Picker */
    .p-monthpicker-month {
        width: 33.3%;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        overflow: hidden;
        position: relative;
    }

    /* Year Picker */
    .p-yearpicker-year {
        width: 50%;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        overflow: hidden;
        position: relative;
    }

    /*  Button Bar */
    .p-datepicker-buttonbar {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    /* Time Picker */
    .p-timepicker {
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .p-timepicker button {
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        overflow: hidden;
        position: relative;
    }

    .p-timepicker > div {
        display: flex;
        align-items: center;
        flex-direction: column;
    }

    /* Touch UI */
    .p-datepicker-touch-ui,
    .p-calendar .p-datepicker-touch-ui {
        min-width: 80vw;
    }
}
`, R$ = {
  root: function(t) {
    var n = t.props;
    return {
      position: n.appendTo === "self" ? "relative" : void 0
    };
  }
}, N$ = {
  root: function(t) {
    var n = t.props, i = t.state;
    return ["p-calendar p-component p-inputwrapper", {
      "p-calendar-w-btn": n.showIcon && n.iconDisplay === "button",
      "p-input-icon-right": n.showIcon && n.iconDisplay === "input",
      "p-calendar-timeonly": n.timeOnly,
      "p-calendar-disabled": n.disabled,
      "p-inputwrapper-filled": n.modelValue,
      "p-inputwrapper-focus": i.focused,
      "p-focus": i.focused || i.overlayVisible
    }];
  },
  input: "p-inputtext p-component",
  dropdownButton: "p-datepicker-trigger",
  inputIcon: "p-datepicker-trigger-icon",
  panel: function(t) {
    var n = t.instance, i = t.props, o = t.state;
    return ["p-datepicker p-component", {
      "p-datepicker-mobile": n.queryMatches,
      "p-datepicker-inline": i.inline,
      "p-disabled": i.disabled,
      "p-datepicker-timeonly": i.timeOnly,
      "p-datepicker-multiple-month": i.numberOfMonths > 1,
      "p-datepicker-monthpicker": o.currentView === "month",
      "p-datepicker-yearpicker": o.currentView === "year",
      "p-datepicker-touch-ui": i.touchUI,
      "p-input-filled": n.$primevue.config.inputStyle === "filled",
      "p-ripple-disabled": n.$primevue.config.ripple === !1
    }];
  },
  groupContainer: "p-datepicker-group-container",
  group: "p-datepicker-group",
  header: "p-datepicker-header",
  previousButton: "p-datepicker-prev p-link",
  previousIcon: "p-datepicker-prev-icon",
  title: "p-datepicker-title",
  monthTitle: "p-datepicker-month p-link",
  yearTitle: "p-datepicker-year p-link",
  decadeTitle: "p-datepicker-decade",
  nextButton: "p-datepicker-next p-link",
  nextIcon: "p-datepicker-next-icon",
  container: "p-datepicker-calendar-container",
  table: "p-datepicker-calendar",
  weekHeader: "p-datepicker-weekheader p-disabled",
  weekNumber: "p-datepicker-weeknumber",
  weekLabelContainer: "p-disabled",
  day: function(t) {
    var n = t.date;
    return [{
      "p-datepicker-other-month": n.otherMonth,
      "p-datepicker-today": n.today
    }];
  },
  dayLabel: function(t) {
    var n = t.instance, i = t.date;
    return [{
      "p-highlight": n.isSelected(i) && i.selectable,
      "p-disabled": !i.selectable
    }];
  },
  monthPicker: "p-monthpicker",
  month: function(t) {
    var n = t.instance, i = t.month, o = t.index;
    return ["p-monthpicker-month", {
      "p-highlight": n.isMonthSelected(o),
      "p-disabled": !i.selectable
    }];
  },
  yearPicker: "p-yearpicker",
  year: function(t) {
    var n = t.instance, i = t.year;
    return ["p-yearpicker-year", {
      "p-highlight": n.isYearSelected(i.value),
      "p-disabled": !i.selectable
    }];
  },
  timePicker: "p-timepicker",
  hourPicker: "p-hour-picker",
  incrementButton: "p-link",
  decrementButton: "p-link",
  separatorContainer: "p-separator",
  minutePicker: "p-minute-picker",
  secondPicker: "p-second-picker",
  ampmPicker: "p-ampm-picker",
  buttonbar: "p-datepicker-buttonbar",
  todayButton: "p-button-text",
  clearButton: "p-button-text"
}, $$ = Wt.extend({
  name: "calendar",
  css: D$,
  classes: N$,
  inlineStyles: R$
}), F$ = {
  name: "BaseCalendar",
  extends: wt,
  props: {
    modelValue: null,
    selectionMode: {
      type: String,
      default: "single"
    },
    dateFormat: {
      type: String,
      default: null
    },
    inline: {
      type: Boolean,
      default: !1
    },
    showOtherMonths: {
      type: Boolean,
      default: !0
    },
    selectOtherMonths: {
      type: Boolean,
      default: !1
    },
    showIcon: {
      type: Boolean,
      default: !1
    },
    iconDisplay: {
      type: String,
      default: "button"
    },
    icon: {
      type: String,
      default: void 0
    },
    previousIcon: {
      type: String,
      default: void 0
    },
    nextIcon: {
      type: String,
      default: void 0
    },
    incrementIcon: {
      type: String,
      default: void 0
    },
    decrementIcon: {
      type: String,
      default: void 0
    },
    numberOfMonths: {
      type: Number,
      default: 1
    },
    responsiveOptions: Array,
    breakpoint: {
      type: String,
      default: "769px"
    },
    view: {
      type: String,
      default: "date"
    },
    touchUI: {
      type: Boolean,
      default: !1
    },
    monthNavigator: {
      type: Boolean,
      default: !1
    },
    yearNavigator: {
      type: Boolean,
      default: !1
    },
    yearRange: {
      type: String,
      default: null
    },
    minDate: {
      type: Date,
      value: null
    },
    maxDate: {
      type: Date,
      value: null
    },
    disabledDates: {
      type: Array,
      value: null
    },
    disabledDays: {
      type: Array,
      value: null
    },
    maxDateCount: {
      type: Number,
      value: null
    },
    showOnFocus: {
      type: Boolean,
      default: !0
    },
    autoZIndex: {
      type: Boolean,
      default: !0
    },
    baseZIndex: {
      type: Number,
      default: 0
    },
    showButtonBar: {
      type: Boolean,
      default: !1
    },
    shortYearCutoff: {
      type: String,
      default: "+10"
    },
    showTime: {
      type: Boolean,
      default: !1
    },
    timeOnly: {
      type: Boolean,
      default: !1
    },
    hourFormat: {
      type: String,
      default: "24"
    },
    stepHour: {
      type: Number,
      default: 1
    },
    stepMinute: {
      type: Number,
      default: 1
    },
    stepSecond: {
      type: Number,
      default: 1
    },
    showSeconds: {
      type: Boolean,
      default: !1
    },
    hideOnDateTimeSelect: {
      type: Boolean,
      default: !1
    },
    hideOnRangeSelection: {
      type: Boolean,
      default: !1
    },
    timeSeparator: {
      type: String,
      default: ":"
    },
    showWeek: {
      type: Boolean,
      default: !1
    },
    manualInput: {
      type: Boolean,
      default: !0
    },
    appendTo: {
      type: [String, Object],
      default: "body"
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    readonly: {
      type: Boolean,
      default: !1
    },
    placeholder: {
      type: String,
      default: null
    },
    id: {
      type: String,
      default: null
    },
    inputId: {
      type: String,
      default: null
    },
    inputClass: {
      type: [String, Object],
      default: null
    },
    inputStyle: {
      type: Object,
      default: null
    },
    inputProps: {
      type: null,
      default: null
    },
    panelClass: {
      type: [String, Object],
      default: null
    },
    panelStyle: {
      type: Object,
      default: null
    },
    panelProps: {
      type: null,
      default: null
    },
    ariaLabelledby: {
      type: String,
      default: null
    },
    ariaLabel: {
      type: String,
      default: null
    }
  },
  style: $$,
  provide: function() {
    return {
      $parentInstance: this
    };
  }
};
function cf(e) {
  "@babel/helpers - typeof";
  return cf = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, cf(e);
}
function up(e) {
  return z$(e) || H$(e) || Gk(e) || j$();
}
function j$() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function H$(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null)
    return Array.from(e);
}
function z$(e) {
  if (Array.isArray(e))
    return df(e);
}
function hp(e, t) {
  var n = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (!n) {
    if (Array.isArray(e) || (n = Gk(e)) || t && e && typeof e.length == "number") {
      n && (e = n);
      var i = 0, o = function() {
      };
      return { s: o, n: function() {
        return i >= e.length ? { done: !0 } : { done: !1, value: e[i++] };
      }, e: function(d) {
        throw d;
      }, f: o };
    }
    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  var a = !0, r = !1, s;
  return { s: function() {
    n = n.call(e);
  }, n: function() {
    var d = n.next();
    return a = d.done, d;
  }, e: function(d) {
    r = !0, s = d;
  }, f: function() {
    try {
      !a && n.return != null && n.return();
    } finally {
      if (r)
        throw s;
    }
  } };
}
function Gk(e, t) {
  if (e) {
    if (typeof e == "string")
      return df(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set")
      return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return df(e, t);
  }
}
function df(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, i = new Array(t); n < t; n++)
    i[n] = e[n];
  return i;
}
var ag = {
  name: "Calendar",
  extends: F$,
  emits: ["show", "hide", "input", "month-change", "year-change", "date-select", "update:modelValue", "today-click", "clear-click", "focus", "blur", "keydown"],
  navigationState: null,
  timePickerChange: !1,
  scrollHandler: null,
  outsideClickListener: null,
  maskClickListener: null,
  resizeListener: null,
  matchMediaListener: null,
  overlay: null,
  input: null,
  mask: null,
  previousButton: null,
  nextButton: null,
  timePickerTimer: null,
  preventFocus: !1,
  typeUpdate: !1,
  data: function() {
    return {
      currentMonth: null,
      currentYear: null,
      currentHour: null,
      currentMinute: null,
      currentSecond: null,
      pm: null,
      focused: !1,
      overlayVisible: !1,
      currentView: this.view,
      query: null,
      queryMatches: !1
    };
  },
  watch: {
    modelValue: function(t) {
      this.updateCurrentMetaData(), !this.typeUpdate && !this.inline && this.input && (this.input.value = this.formatValue(t)), this.typeUpdate = !1;
    },
    showTime: function() {
      this.updateCurrentMetaData();
    },
    minDate: function() {
      this.updateCurrentMetaData();
    },
    maxDate: function() {
      this.updateCurrentMetaData();
    },
    months: function() {
      this.overlay && (this.focused || (this.inline && (this.preventFocus = !0), setTimeout(this.updateFocus, 0)));
    },
    numberOfMonths: function() {
      this.destroyResponsiveStyleElement(), this.createResponsiveStyle();
    },
    responsiveOptions: function() {
      this.destroyResponsiveStyleElement(), this.createResponsiveStyle();
    },
    currentView: function() {
      var t = this;
      Promise.resolve(null).then(function() {
        return t.alignOverlay();
      });
    }
  },
  created: function() {
    this.updateCurrentMetaData();
  },
  mounted: function() {
    this.createResponsiveStyle(), this.bindMatchMediaListener(), this.inline ? (this.overlay && this.overlay.setAttribute(this.attributeSelector, ""), this.disabled || (this.preventFocus = !0, this.initFocusableCell(), this.numberOfMonths === 1 && (this.overlay.style.width = Oe.getOuterWidth(this.$el) + "px"))) : this.input.value = this.formatValue(this.modelValue);
  },
  updated: function() {
    this.overlay && (this.preventFocus = !0, setTimeout(this.updateFocus, 0)), this.input && this.selectionStart != null && this.selectionEnd != null && (this.input.selectionStart = this.selectionStart, this.input.selectionEnd = this.selectionEnd, this.selectionStart = null, this.selectionEnd = null);
  },
  beforeUnmount: function() {
    this.timePickerTimer && clearTimeout(this.timePickerTimer), this.mask && this.destroyMask(), this.destroyResponsiveStyleElement(), this.unbindOutsideClickListener(), this.unbindResizeListener(), this.unbindMatchMediaListener(), this.scrollHandler && (this.scrollHandler.destroy(), this.scrollHandler = null), this.overlay && this.autoZIndex && qt.clear(this.overlay), this.overlay = null;
  },
  methods: {
    isComparable: function() {
      return this.modelValue != null && typeof this.modelValue != "string";
    },
    isSelected: function(t) {
      if (!this.isComparable())
        return !1;
      if (this.modelValue) {
        if (this.isSingleSelection())
          return this.isDateEquals(this.modelValue, t);
        if (this.isMultipleSelection()) {
          var n = !1, i = hp(this.modelValue), o;
          try {
            for (i.s(); !(o = i.n()).done; ) {
              var a = o.value;
              if (n = this.isDateEquals(a, t), n)
                break;
            }
          } catch (r) {
            i.e(r);
          } finally {
            i.f();
          }
          return n;
        } else if (this.isRangeSelection())
          return this.modelValue[1] ? this.isDateEquals(this.modelValue[0], t) || this.isDateEquals(this.modelValue[1], t) || this.isDateBetween(this.modelValue[0], this.modelValue[1], t) : this.isDateEquals(this.modelValue[0], t);
      }
      return !1;
    },
    isMonthSelected: function(t) {
      var n = this;
      if (this.isComparable()) {
        var i = this.isRangeSelection() ? this.modelValue[0] : this.modelValue;
        return this.isMultipleSelection() ? i.some(function(o) {
          return o.getMonth() === t && o.getFullYear() === n.currentYear;
        }) : i.getMonth() === t && i.getFullYear() === this.currentYear;
      }
      return !1;
    },
    isYearSelected: function(t) {
      if (this.isComparable()) {
        var n = this.isRangeSelection() ? this.modelValue[0] : this.modelValue;
        return this.isMultipleSelection() ? n.some(function(i) {
          return i.getFullYear() === t;
        }) : n.getFullYear() === t;
      }
      return !1;
    },
    isDateEquals: function(t, n) {
      return t ? t.getDate() === n.day && t.getMonth() === n.month && t.getFullYear() === n.year : !1;
    },
    isDateBetween: function(t, n, i) {
      var o = !1;
      if (t && n) {
        var a = new Date(i.year, i.month, i.day);
        return t.getTime() <= a.getTime() && n.getTime() >= a.getTime();
      }
      return o;
    },
    getFirstDayOfMonthIndex: function(t, n) {
      var i = /* @__PURE__ */ new Date();
      i.setDate(1), i.setMonth(t), i.setFullYear(n);
      var o = i.getDay() + this.sundayIndex;
      return o >= 7 ? o - 7 : o;
    },
    getDaysCountInMonth: function(t, n) {
      return 32 - this.daylightSavingAdjust(new Date(n, t, 32)).getDate();
    },
    getDaysCountInPrevMonth: function(t, n) {
      var i = this.getPreviousMonthAndYear(t, n);
      return this.getDaysCountInMonth(i.month, i.year);
    },
    getPreviousMonthAndYear: function(t, n) {
      var i, o;
      return t === 0 ? (i = 11, o = n - 1) : (i = t - 1, o = n), {
        month: i,
        year: o
      };
    },
    getNextMonthAndYear: function(t, n) {
      var i, o;
      return t === 11 ? (i = 0, o = n + 1) : (i = t + 1, o = n), {
        month: i,
        year: o
      };
    },
    daylightSavingAdjust: function(t) {
      return t ? (t.setHours(t.getHours() > 12 ? t.getHours() + 2 : 0), t) : null;
    },
    isToday: function(t, n, i, o) {
      return t.getDate() === n && t.getMonth() === i && t.getFullYear() === o;
    },
    isSelectable: function(t, n, i, o) {
      var a = !0, r = !0, s = !0, l = !0;
      return o && !this.selectOtherMonths ? !1 : (this.minDate && (this.minDate.getFullYear() > i || this.minDate.getFullYear() === i && (this.minDate.getMonth() > n || this.minDate.getMonth() === n && this.minDate.getDate() > t)) && (a = !1), this.maxDate && (this.maxDate.getFullYear() < i || this.maxDate.getFullYear() === i && (this.maxDate.getMonth() < n || this.maxDate.getMonth() === n && this.maxDate.getDate() < t)) && (r = !1), this.disabledDates && (s = !this.isDateDisabled(t, n, i)), this.disabledDays && (l = !this.isDayDisabled(t, n, i)), a && r && s && l);
    },
    onOverlayEnter: function(t) {
      t.setAttribute(this.attributeSelector, "");
      var n = this.touchUI ? {
        position: "fixed",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)"
      } : this.inline ? void 0 : {
        position: "absolute",
        top: "0",
        left: "0"
      };
      Oe.addStyles(t, n), this.autoZIndex && (this.touchUI ? qt.set("modal", t, this.baseZIndex || this.$primevue.config.zIndex.modal) : qt.set("overlay", t, this.baseZIndex || this.$primevue.config.zIndex.overlay)), this.alignOverlay(), this.$emit("show");
    },
    onOverlayEnterComplete: function() {
      this.bindOutsideClickListener(), this.bindScrollListener(), this.bindResizeListener();
    },
    onOverlayAfterLeave: function(t) {
      this.autoZIndex && qt.clear(t);
    },
    onOverlayLeave: function() {
      this.currentView = this.view, this.unbindOutsideClickListener(), this.unbindScrollListener(), this.unbindResizeListener(), this.$emit("hide"), this.mask && this.disableModality(), this.overlay = null;
    },
    onPrevButtonClick: function(t) {
      this.showOtherMonths && (this.navigationState = {
        backward: !0,
        button: !0
      }, this.navBackward(t));
    },
    onNextButtonClick: function(t) {
      this.showOtherMonths && (this.navigationState = {
        backward: !1,
        button: !0
      }, this.navForward(t));
    },
    navBackward: function(t) {
      t.preventDefault(), this.isEnabled() && (this.currentView === "month" ? (this.decrementYear(), this.$emit("year-change", {
        month: this.currentMonth,
        year: this.currentYear
      })) : this.currentView === "year" ? this.decrementDecade() : t.shiftKey ? this.decrementYear() : (this.currentMonth === 0 ? (this.currentMonth = 11, this.decrementYear()) : this.currentMonth--, this.$emit("month-change", {
        month: this.currentMonth + 1,
        year: this.currentYear
      })));
    },
    navForward: function(t) {
      t.preventDefault(), this.isEnabled() && (this.currentView === "month" ? (this.incrementYear(), this.$emit("year-change", {
        month: this.currentMonth,
        year: this.currentYear
      })) : this.currentView === "year" ? this.incrementDecade() : t.shiftKey ? this.incrementYear() : (this.currentMonth === 11 ? (this.currentMonth = 0, this.incrementYear()) : this.currentMonth++, this.$emit("month-change", {
        month: this.currentMonth + 1,
        year: this.currentYear
      })));
    },
    decrementYear: function() {
      this.currentYear--;
    },
    decrementDecade: function() {
      this.currentYear = this.currentYear - 10;
    },
    incrementYear: function() {
      this.currentYear++;
    },
    incrementDecade: function() {
      this.currentYear = this.currentYear + 10;
    },
    switchToMonthView: function(t) {
      this.currentView = "month", setTimeout(this.updateFocus, 0), t.preventDefault();
    },
    switchToYearView: function(t) {
      this.currentView = "year", setTimeout(this.updateFocus, 0), t.preventDefault();
    },
    isEnabled: function() {
      return !this.disabled && !this.readonly;
    },
    updateCurrentTimeMeta: function(t) {
      var n = t.getHours();
      this.hourFormat === "12" && (this.pm = n > 11, n >= 12 ? n = n == 12 ? 12 : n - 12 : n = n == 0 ? 12 : n), this.currentHour = Math.floor(n / this.stepHour) * this.stepHour, this.currentMinute = Math.floor(t.getMinutes() / this.stepMinute) * this.stepMinute, this.currentSecond = Math.floor(t.getSeconds() / this.stepSecond) * this.stepSecond;
    },
    bindOutsideClickListener: function() {
      var t = this;
      this.outsideClickListener || (this.outsideClickListener = function(n) {
        t.overlayVisible && t.isOutsideClicked(n) && (t.overlayVisible = !1);
      }, document.addEventListener("mousedown", this.outsideClickListener));
    },
    unbindOutsideClickListener: function() {
      this.outsideClickListener && (document.removeEventListener("mousedown", this.outsideClickListener), this.outsideClickListener = null);
    },
    bindScrollListener: function() {
      var t = this;
      this.scrollHandler || (this.scrollHandler = new po(this.$refs.container, function() {
        t.overlayVisible && (t.overlayVisible = !1);
      })), this.scrollHandler.bindScrollListener();
    },
    unbindScrollListener: function() {
      this.scrollHandler && this.scrollHandler.unbindScrollListener();
    },
    bindResizeListener: function() {
      var t = this;
      this.resizeListener || (this.resizeListener = function() {
        t.overlayVisible && !Oe.isTouchDevice() && (t.overlayVisible = !1);
      }, window.addEventListener("resize", this.resizeListener));
    },
    unbindResizeListener: function() {
      this.resizeListener && (window.removeEventListener("resize", this.resizeListener), this.resizeListener = null);
    },
    bindMatchMediaListener: function() {
      var t = this;
      if (!this.matchMediaListener) {
        var n = matchMedia("(max-width: ".concat(this.breakpoint, ")"));
        this.query = n, this.queryMatches = n.matches, this.matchMediaListener = function() {
          t.queryMatches = n.matches, t.mobileActive = !1;
        }, this.query.addEventListener("change", this.matchMediaListener);
      }
    },
    unbindMatchMediaListener: function() {
      this.matchMediaListener && (this.query.removeEventListener("change", this.matchMediaListener), this.matchMediaListener = null);
    },
    isOutsideClicked: function(t) {
      return !(this.$el.isSameNode(t.target) || this.isNavIconClicked(t) || this.$el.contains(t.target) || this.overlay && this.overlay.contains(t.target));
    },
    isNavIconClicked: function(t) {
      return this.previousButton && (this.previousButton.isSameNode(t.target) || this.previousButton.contains(t.target)) || this.nextButton && (this.nextButton.isSameNode(t.target) || this.nextButton.contains(t.target));
    },
    alignOverlay: function() {
      this.touchUI ? this.enableModality() : this.overlay && (this.appendTo === "self" || this.inline ? Oe.relativePosition(this.overlay, this.$el) : (this.view === "date" ? (this.overlay.style.width = Oe.getOuterWidth(this.overlay) + "px", this.overlay.style.minWidth = Oe.getOuterWidth(this.$el) + "px") : this.overlay.style.width = Oe.getOuterWidth(this.$el) + "px", Oe.absolutePosition(this.overlay, this.$el)));
    },
    onButtonClick: function() {
      this.isEnabled() && (this.overlayVisible ? this.overlayVisible = !1 : (this.input.focus(), this.overlayVisible = !0));
    },
    isDateDisabled: function(t, n, i) {
      if (this.disabledDates) {
        var o = hp(this.disabledDates), a;
        try {
          for (o.s(); !(a = o.n()).done; ) {
            var r = a.value;
            if (r.getFullYear() === i && r.getMonth() === n && r.getDate() === t)
              return !0;
          }
        } catch (s) {
          o.e(s);
        } finally {
          o.f();
        }
      }
      return !1;
    },
    isDayDisabled: function(t, n, i) {
      if (this.disabledDays) {
        var o = new Date(i, n, t), a = o.getDay();
        return this.disabledDays.indexOf(a) !== -1;
      }
      return !1;
    },
    onMonthDropdownChange: function(t) {
      this.currentMonth = parseInt(t), this.$emit("month-change", {
        month: this.currentMonth + 1,
        year: this.currentYear
      });
    },
    onYearDropdownChange: function(t) {
      this.currentYear = parseInt(t), this.$emit("year-change", {
        month: this.currentMonth + 1,
        year: this.currentYear
      });
    },
    onDateSelect: function(t, n) {
      var i = this;
      if (!(this.disabled || !n.selectable)) {
        if (Oe.find(this.overlay, 'table td span:not([data-p-disabled="true"])').forEach(function(a) {
          return a.tabIndex = -1;
        }), t && t.currentTarget.focus(), this.isMultipleSelection() && this.isSelected(n)) {
          var o = this.modelValue.filter(function(a) {
            return !i.isDateEquals(a, n);
          });
          this.updateModel(o);
        } else
          this.shouldSelectDate(n) && (n.otherMonth ? (this.currentMonth = n.month, this.currentYear = n.year, this.selectDate(n)) : this.selectDate(n));
        this.isSingleSelection() && (!this.showTime || this.hideOnDateTimeSelect) && setTimeout(function() {
          i.input && i.input.focus(), i.overlayVisible = !1;
        }, 150);
      }
    },
    selectDate: function(t) {
      var n = this, i = new Date(t.year, t.month, t.day);
      this.showTime && (this.hourFormat === "12" && this.pm && this.currentHour != 12 ? i.setHours(this.currentHour + 12) : i.setHours(this.currentHour), i.setMinutes(this.currentMinute), i.setSeconds(this.currentSecond)), this.minDate && this.minDate > i && (i = this.minDate, this.currentHour = i.getHours(), this.currentMinute = i.getMinutes(), this.currentSecond = i.getSeconds()), this.maxDate && this.maxDate < i && (i = this.maxDate, this.currentHour = i.getHours(), this.currentMinute = i.getMinutes(), this.currentSecond = i.getSeconds());
      var o = null;
      if (this.isSingleSelection())
        o = i;
      else if (this.isMultipleSelection())
        o = this.modelValue ? [].concat(up(this.modelValue), [i]) : [i];
      else if (this.isRangeSelection())
        if (this.modelValue && this.modelValue.length) {
          var a = this.modelValue[0], r = this.modelValue[1];
          !r && i.getTime() >= a.getTime() ? r = i : (a = i, r = null), o = [a, r];
        } else
          o = [i, null];
      o !== null && this.updateModel(o), this.isRangeSelection() && this.hideOnRangeSelection && o[1] !== null && setTimeout(function() {
        n.overlayVisible = !1;
      }, 150), this.$emit("date-select", i);
    },
    updateModel: function(t) {
      this.$emit("update:modelValue", t);
    },
    shouldSelectDate: function() {
      return this.isMultipleSelection() && this.maxDateCount != null ? this.maxDateCount > (this.modelValue ? this.modelValue.length : 0) : !0;
    },
    isSingleSelection: function() {
      return this.selectionMode === "single";
    },
    isRangeSelection: function() {
      return this.selectionMode === "range";
    },
    isMultipleSelection: function() {
      return this.selectionMode === "multiple";
    },
    formatValue: function(t) {
      if (typeof t == "string")
        return t;
      var n = "";
      if (t)
        try {
          if (this.isSingleSelection())
            n = this.formatDateTime(t);
          else if (this.isMultipleSelection())
            for (var i = 0; i < t.length; i++) {
              var o = this.formatDateTime(t[i]);
              n += o, i !== t.length - 1 && (n += ", ");
            }
          else if (this.isRangeSelection() && t && t.length) {
            var a = t[0], r = t[1];
            n = this.formatDateTime(a), r && (n += " - " + this.formatDateTime(r));
          }
        } catch {
          n = t;
        }
      return n;
    },
    formatDateTime: function(t) {
      var n = null;
      return t && (this.timeOnly ? n = this.formatTime(t) : (n = this.formatDate(t, this.datePattern), this.showTime && (n += " " + this.formatTime(t)))), n;
    },
    formatDate: function(t, n) {
      if (!t)
        return "";
      var i, o = function(y) {
        var u = i + 1 < n.length && n.charAt(i + 1) === y;
        return u && i++, u;
      }, a = function(y, u, m) {
        var h = "" + u;
        if (o(y))
          for (; h.length < m; )
            h = "0" + h;
        return h;
      }, r = function(y, u, m, h) {
        return o(y) ? h[u] : m[u];
      }, s = "", l = !1;
      if (t)
        for (i = 0; i < n.length; i++)
          if (l)
            n.charAt(i) === "'" && !o("'") ? l = !1 : s += n.charAt(i);
          else
            switch (n.charAt(i)) {
              case "d":
                s += a("d", t.getDate(), 2);
                break;
              case "D":
                s += r("D", t.getDay(), this.$primevue.config.locale.dayNamesShort, this.$primevue.config.locale.dayNames);
                break;
              case "o":
                s += a("o", Math.round((new Date(t.getFullYear(), t.getMonth(), t.getDate()).getTime() - new Date(t.getFullYear(), 0, 0).getTime()) / 864e5), 3);
                break;
              case "m":
                s += a("m", t.getMonth() + 1, 2);
                break;
              case "M":
                s += r("M", t.getMonth(), this.$primevue.config.locale.monthNamesShort, this.$primevue.config.locale.monthNames);
                break;
              case "y":
                s += o("y") ? t.getFullYear() : (t.getFullYear() % 100 < 10 ? "0" : "") + t.getFullYear() % 100;
                break;
              case "@":
                s += t.getTime();
                break;
              case "!":
                s += t.getTime() * 1e4 + this.ticksTo1970;
                break;
              case "'":
                o("'") ? s += "'" : l = !0;
                break;
              default:
                s += n.charAt(i);
            }
      return s;
    },
    formatTime: function(t) {
      if (!t)
        return "";
      var n = "", i = t.getHours(), o = t.getMinutes(), a = t.getSeconds();
      return this.hourFormat === "12" && i > 11 && i !== 12 && (i -= 12), this.hourFormat === "12" ? n += i === 0 ? 12 : i < 10 ? "0" + i : i : n += i < 10 ? "0" + i : i, n += ":", n += o < 10 ? "0" + o : o, this.showSeconds && (n += ":", n += a < 10 ? "0" + a : a), this.hourFormat === "12" && (n += t.getHours() > 11 ? " ".concat(this.$primevue.config.locale.pm) : " ".concat(this.$primevue.config.locale.am)), n;
    },
    onTodayButtonClick: function(t) {
      var n = /* @__PURE__ */ new Date(), i = {
        day: n.getDate(),
        month: n.getMonth(),
        year: n.getFullYear(),
        otherMonth: n.getMonth() !== this.currentMonth || n.getFullYear() !== this.currentYear,
        today: !0,
        selectable: !0
      };
      this.onDateSelect(null, i), this.$emit("today-click", n), t.preventDefault();
    },
    onClearButtonClick: function(t) {
      this.updateModel(null), this.overlayVisible = !1, this.$emit("clear-click", t), t.preventDefault();
    },
    onTimePickerElementMouseDown: function(t, n, i) {
      this.isEnabled() && (this.repeat(t, null, n, i), t.preventDefault());
    },
    onTimePickerElementMouseUp: function(t) {
      this.isEnabled() && (this.clearTimePickerTimer(), this.updateModelTime(), t.preventDefault());
    },
    onTimePickerElementMouseLeave: function() {
      this.clearTimePickerTimer();
    },
    repeat: function(t, n, i, o) {
      var a = this, r = n || 500;
      switch (this.clearTimePickerTimer(), this.timePickerTimer = setTimeout(function() {
        a.repeat(t, 100, i, o);
      }, r), i) {
        case 0:
          o === 1 ? this.incrementHour(t) : this.decrementHour(t);
          break;
        case 1:
          o === 1 ? this.incrementMinute(t) : this.decrementMinute(t);
          break;
        case 2:
          o === 1 ? this.incrementSecond(t) : this.decrementSecond(t);
          break;
      }
    },
    convertTo24Hour: function(t, n) {
      return this.hourFormat == "12" ? t === 12 ? n ? 12 : 0 : n ? t + 12 : t : t;
    },
    validateTime: function(t, n, i, o) {
      var a = this.isComparable() ? this.modelValue : this.viewDate, r = this.convertTo24Hour(t, o);
      this.isRangeSelection() && (a = this.modelValue[1] || this.modelValue[0]), this.isMultipleSelection() && (a = this.modelValue[this.modelValue.length - 1]);
      var s = a ? a.toDateString() : null;
      return !(this.minDate && s && this.minDate.toDateString() === s && (this.minDate.getHours() > r || this.minDate.getHours() === r && (this.minDate.getMinutes() > n || this.minDate.getMinutes() === n && this.minDate.getSeconds() > i)) || this.maxDate && s && this.maxDate.toDateString() === s && (this.maxDate.getHours() < r || this.maxDate.getHours() === r && (this.maxDate.getMinutes() < n || this.maxDate.getMinutes() === n && this.maxDate.getSeconds() < i)));
    },
    incrementHour: function(t) {
      var n = this.currentHour, i = this.currentHour + Number(this.stepHour), o = this.pm;
      this.hourFormat == "24" ? i = i >= 24 ? i - 24 : i : this.hourFormat == "12" && (n < 12 && i > 11 && (o = !this.pm), i = i >= 13 ? i - 12 : i), this.validateTime(i, this.currentMinute, this.currentSecond, o) && (this.currentHour = i, this.pm = o), t.preventDefault();
    },
    decrementHour: function(t) {
      var n = this.currentHour - this.stepHour, i = this.pm;
      this.hourFormat == "24" ? n = n < 0 ? 24 + n : n : this.hourFormat == "12" && (this.currentHour === 12 && (i = !this.pm), n = n <= 0 ? 12 + n : n), this.validateTime(n, this.currentMinute, this.currentSecond, i) && (this.currentHour = n, this.pm = i), t.preventDefault();
    },
    incrementMinute: function(t) {
      var n = this.currentMinute + Number(this.stepMinute);
      this.validateTime(this.currentHour, n, this.currentSecond, this.pm) && (this.currentMinute = n > 59 ? n - 60 : n), t.preventDefault();
    },
    decrementMinute: function(t) {
      var n = this.currentMinute - this.stepMinute;
      n = n < 0 ? 60 + n : n, this.validateTime(this.currentHour, n, this.currentSecond, this.pm) && (this.currentMinute = n), t.preventDefault();
    },
    incrementSecond: function(t) {
      var n = this.currentSecond + Number(this.stepSecond);
      this.validateTime(this.currentHour, this.currentMinute, n, this.pm) && (this.currentSecond = n > 59 ? n - 60 : n), t.preventDefault();
    },
    decrementSecond: function(t) {
      var n = this.currentSecond - this.stepSecond;
      n = n < 0 ? 60 + n : n, this.validateTime(this.currentHour, this.currentMinute, n, this.pm) && (this.currentSecond = n), t.preventDefault();
    },
    updateModelTime: function() {
      var t = this;
      this.timePickerChange = !0;
      var n = this.isComparable() ? this.modelValue : this.viewDate;
      this.isRangeSelection() && (n = this.modelValue[1] || this.modelValue[0]), this.isMultipleSelection() && (n = this.modelValue[this.modelValue.length - 1]), n = n ? new Date(n.getTime()) : /* @__PURE__ */ new Date(), this.hourFormat == "12" ? this.currentHour === 12 ? n.setHours(this.pm ? 12 : 0) : n.setHours(this.pm ? this.currentHour + 12 : this.currentHour) : n.setHours(this.currentHour), n.setMinutes(this.currentMinute), n.setSeconds(this.currentSecond), this.isRangeSelection() && (this.modelValue[1] ? n = [this.modelValue[0], n] : n = [n, null]), this.isMultipleSelection() && (n = [].concat(up(this.modelValue.slice(0, -1)), [n])), this.updateModel(n), this.$emit("date-select", n), setTimeout(function() {
        return t.timePickerChange = !1;
      }, 0);
    },
    toggleAMPM: function(t) {
      var n = this.validateTime(this.currentHour, this.currentMinute, this.currentSecond, !this.pm);
      !n && (this.maxDate || this.minDate) || (this.pm = !this.pm, this.updateModelTime(), t.preventDefault());
    },
    clearTimePickerTimer: function() {
      this.timePickerTimer && clearInterval(this.timePickerTimer);
    },
    onMonthSelect: function(t, n) {
      n.month;
      var i = n.index;
      this.view === "month" ? this.onDateSelect(t, {
        year: this.currentYear,
        month: i,
        day: 1,
        selectable: !0
      }) : (this.currentMonth = i, this.currentView = "date", this.$emit("month-change", {
        month: this.currentMonth + 1,
        year: this.currentYear
      })), setTimeout(this.updateFocus, 0);
    },
    onYearSelect: function(t, n) {
      this.view === "year" ? this.onDateSelect(t, {
        year: n.value,
        month: 0,
        day: 1,
        selectable: !0
      }) : (this.currentYear = n.value, this.currentView = "month", this.$emit("year-change", {
        month: this.currentMonth + 1,
        year: this.currentYear
      })), setTimeout(this.updateFocus, 0);
    },
    enableModality: function() {
      var t = this;
      if (!this.mask) {
        var n = "p-datepicker-mask p-datepicker-mask-scrollblocker p-component-overlay p-component-overlay-enter";
        this.mask = Oe.createElement("div", {
          "data-pc-section": "datepickermask",
          class: !this.isUnstyled && n,
          "p-bind": this.ptm("datepickermask")
        }), this.mask.style.zIndex = String(parseInt(this.overlay.style.zIndex, 10) - 1), this.maskClickListener = function() {
          t.overlayVisible = !1;
        }, this.mask.addEventListener("click", this.maskClickListener), document.body.appendChild(this.mask), Oe.blockBodyScroll();
      }
    },
    disableModality: function() {
      var t = this;
      this.mask && (this.isUnstyled ? this.destroyMask() : (Oe.addClass(this.mask, "p-component-overlay-leave"), this.mask.addEventListener("animationend", function() {
        t.destroyMask();
      })));
    },
    destroyMask: function() {
      this.mask.removeEventListener("click", this.maskClickListener), this.maskClickListener = null, document.body.removeChild(this.mask), this.mask = null;
      for (var t = document.body.children, n, i = 0; i < t.length; i++) {
        var o = t[i];
        if (Oe.isAttributeEquals(o, "data-pc-section", "datepickermask")) {
          n = !0;
          break;
        }
      }
      n || Oe.unblockBodyScroll();
    },
    updateCurrentMetaData: function() {
      var t = this.viewDate;
      this.currentMonth = t.getMonth(), this.currentYear = t.getFullYear(), (this.showTime || this.timeOnly) && this.updateCurrentTimeMeta(t);
    },
    isValidSelection: function(t) {
      var n = this;
      if (t == null)
        return !0;
      var i = !0;
      return this.isSingleSelection() ? this.isSelectable(t.getDate(), t.getMonth(), t.getFullYear(), !1) || (i = !1) : t.every(function(o) {
        return n.isSelectable(o.getDate(), o.getMonth(), o.getFullYear(), !1);
      }) && this.isRangeSelection() && (i = t.length > 1 && t[1] > t[0]), i;
    },
    parseValue: function(t) {
      if (!t || t.trim().length === 0)
        return null;
      var n;
      if (this.isSingleSelection())
        n = this.parseDateTime(t);
      else if (this.isMultipleSelection()) {
        var i = t.split(",");
        n = [];
        var o = hp(i), a;
        try {
          for (o.s(); !(a = o.n()).done; ) {
            var r = a.value;
            n.push(this.parseDateTime(r.trim()));
          }
        } catch (d) {
          o.e(d);
        } finally {
          o.f();
        }
      } else if (this.isRangeSelection()) {
        var s = t.split(" - ");
        n = [];
        for (var l = 0; l < s.length; l++)
          n[l] = this.parseDateTime(s[l].trim());
      }
      return n;
    },
    parseDateTime: function(t) {
      var n, i = t.split(" ");
      if (this.timeOnly)
        n = new Date(this.modelValue), this.populateTime(n, i[0], i[1]);
      else {
        var o = this.datePattern;
        this.showTime ? (n = this.parseDate(i[0], o), this.populateTime(n, i[1], i[2])) : n = this.parseDate(t, o);
      }
      return n;
    },
    populateTime: function(t, n, i) {
      if (this.hourFormat == "12" && !i)
        throw "Invalid Time";
      this.pm = i === this.$primevue.config.locale.pm || i === this.$primevue.config.locale.pm.toLowerCase();
      var o = this.parseTime(n);
      t.setHours(o.hour), t.setMinutes(o.minute), t.setSeconds(o.second);
    },
    parseTime: function(t) {
      var n = t.split(":"), i = this.showSeconds ? 3 : 2, o = /^[0-9][0-9]$/;
      if (n.length !== i || !n[0].match(o) || !n[1].match(o) || this.showSeconds && !n[2].match(o))
        throw "Invalid time";
      var a = parseInt(n[0]), r = parseInt(n[1]), s = this.showSeconds ? parseInt(n[2]) : null;
      if (isNaN(a) || isNaN(r) || a > 23 || r > 59 || this.hourFormat == "12" && a > 12 || this.showSeconds && (isNaN(s) || s > 59))
        throw "Invalid time";
      return this.hourFormat == "12" && a !== 12 && this.pm ? a += 12 : this.hourFormat == "12" && a == 12 && !this.pm && (a = 0), {
        hour: a,
        minute: r,
        second: s
      };
    },
    parseDate: function(t, n) {
      if (n == null || t == null)
        throw "Invalid arguments";
      if (t = cf(t) === "object" ? t.toString() : t + "", t === "")
        return null;
      var i, o, a, r = 0, s = typeof this.shortYearCutoff != "string" ? this.shortYearCutoff : (/* @__PURE__ */ new Date()).getFullYear() % 100 + parseInt(this.shortYearCutoff, 10), l = -1, d = -1, y = -1, u = -1, m = !1, h, c = function(S) {
        var w = i + 1 < n.length && n.charAt(i + 1) === S;
        return w && i++, w;
      }, g = function(S) {
        var w = c(S), x = S === "@" ? 14 : S === "!" ? 20 : S === "y" && w ? 4 : S === "o" ? 3 : 2, k = S === "y" ? x : 1, A = new RegExp("^\\d{" + k + "," + x + "}"), $ = t.substring(r).match(A);
        if (!$)
          throw "Missing number at position " + r;
        return r += $[0].length, parseInt($[0], 10);
      }, v = function(S, w, x) {
        for (var k = -1, A = c(S) ? x : w, $ = [], j = 0; j < A.length; j++)
          $.push([j, A[j]]);
        $.sort(function(D, C) {
          return -(D[1].length - C[1].length);
        });
        for (var N = 0; N < $.length; N++) {
          var M = $[N][1];
          if (t.substr(r, M.length).toLowerCase() === M.toLowerCase()) {
            k = $[N][0], r += M.length;
            break;
          }
        }
        if (k !== -1)
          return k + 1;
        throw "Unknown name at position " + r;
      }, P = function() {
        if (t.charAt(r) !== n.charAt(i))
          throw "Unexpected literal at position " + r;
        r++;
      };
      for (this.currentView === "month" && (y = 1), i = 0; i < n.length; i++)
        if (m)
          n.charAt(i) === "'" && !c("'") ? m = !1 : P();
        else
          switch (n.charAt(i)) {
            case "d":
              y = g("d");
              break;
            case "D":
              v("D", this.$primevue.config.locale.dayNamesShort, this.$primevue.config.locale.dayNames);
              break;
            case "o":
              u = g("o");
              break;
            case "m":
              d = g("m");
              break;
            case "M":
              d = v("M", this.$primevue.config.locale.monthNamesShort, this.$primevue.config.locale.monthNames);
              break;
            case "y":
              l = g("y");
              break;
            case "@":
              h = new Date(g("@")), l = h.getFullYear(), d = h.getMonth() + 1, y = h.getDate();
              break;
            case "!":
              h = new Date((g("!") - this.ticksTo1970) / 1e4), l = h.getFullYear(), d = h.getMonth() + 1, y = h.getDate();
              break;
            case "'":
              c("'") ? P() : m = !0;
              break;
            default:
              P();
          }
      if (r < t.length && (a = t.substr(r), !/^\s+/.test(a)))
        throw "Extra/unparsed characters found in date: " + a;
      if (l === -1 ? l = (/* @__PURE__ */ new Date()).getFullYear() : l < 100 && (l += (/* @__PURE__ */ new Date()).getFullYear() - (/* @__PURE__ */ new Date()).getFullYear() % 100 + (l <= s ? 0 : -100)), u > -1) {
        d = 1, y = u;
        do {
          if (o = this.getDaysCountInMonth(l, d - 1), y <= o)
            break;
          d++, y -= o;
        } while (!0);
      }
      if (h = this.daylightSavingAdjust(new Date(l, d - 1, y)), h.getFullYear() !== l || h.getMonth() + 1 !== d || h.getDate() !== y)
        throw "Invalid date";
      return h;
    },
    getWeekNumber: function(t) {
      var n = new Date(t.getTime());
      n.setDate(n.getDate() + 4 - (n.getDay() || 7));
      var i = n.getTime();
      return n.setMonth(0), n.setDate(1), Math.floor(Math.round((i - n.getTime()) / 864e5) / 7) + 1;
    },
    onDateCellKeydown: function(t, n, i) {
      var o = t.currentTarget, a = o.parentElement, r = Oe.index(a);
      switch (t.code) {
        case "ArrowDown": {
          o.tabIndex = "-1";
          var s = a.parentElement.nextElementSibling;
          if (s) {
            var l = Oe.index(a.parentElement), d = Array.from(a.parentElement.parentElement.children), y = d.slice(l + 1), u = y.find(function(B) {
              var T = B.children[r].children[0];
              return !Oe.getAttribute(T, "data-p-disabled");
            });
            if (u) {
              var m = u.children[r].children[0];
              m.tabIndex = "0", m.focus();
            } else
              this.navigationState = {
                backward: !1
              }, this.navForward(t);
          } else
            this.navigationState = {
              backward: !1
            }, this.navForward(t);
          t.preventDefault();
          break;
        }
        case "ArrowUp": {
          if (o.tabIndex = "-1", t.altKey)
            this.overlayVisible = !1, this.focused = !0;
          else {
            var h = a.parentElement.previousElementSibling;
            if (h) {
              var c = Oe.index(a.parentElement), g = Array.from(a.parentElement.parentElement.children), v = g.slice(0, c).reverse(), P = v.find(function(B) {
                var T = B.children[r].children[0];
                return !Oe.getAttribute(T, "data-p-disabled");
              });
              if (P) {
                var f = P.children[r].children[0];
                f.tabIndex = "0", f.focus();
              } else
                this.navigationState = {
                  backward: !0
                }, this.navBackward(t);
            } else
              this.navigationState = {
                backward: !0
              }, this.navBackward(t);
          }
          t.preventDefault();
          break;
        }
        case "ArrowLeft": {
          o.tabIndex = "-1";
          var S = a.previousElementSibling;
          if (S) {
            var w = Array.from(a.parentElement.children), x = w.slice(0, r).reverse(), k = x.find(function(B) {
              var T = B.children[0];
              return !Oe.getAttribute(T, "data-p-disabled");
            });
            if (k) {
              var A = k.children[0];
              A.tabIndex = "0", A.focus();
            } else
              this.navigateToMonth(t, !0, i);
          } else
            this.navigateToMonth(t, !0, i);
          t.preventDefault();
          break;
        }
        case "ArrowRight": {
          o.tabIndex = "-1";
          var $ = a.nextElementSibling;
          if ($) {
            var j = Array.from(a.parentElement.children), N = j.slice(r + 1), M = N.find(function(B) {
              var T = B.children[0];
              return !Oe.getAttribute(T, "data-p-disabled");
            });
            if (M) {
              var D = M.children[0];
              D.tabIndex = "0", D.focus();
            } else
              this.navigateToMonth(t, !1, i);
          } else
            this.navigateToMonth(t, !1, i);
          t.preventDefault();
          break;
        }
        case "Enter":
        case "NumpadEnter":
        case "Space": {
          this.onDateSelect(t, n), t.preventDefault();
          break;
        }
        case "Escape": {
          this.overlayVisible = !1, t.preventDefault();
          break;
        }
        case "Tab": {
          this.inline || this.trapFocus(t);
          break;
        }
        case "Home": {
          o.tabIndex = "-1";
          var C = a.parentElement, b = C.children[0].children[0];
          Oe.getAttribute(b, "data-p-disabled") ? this.navigateToMonth(t, !0, i) : (b.tabIndex = "0", b.focus()), t.preventDefault();
          break;
        }
        case "End": {
          o.tabIndex = "-1";
          var p = a.parentElement, L = p.children[p.children.length - 1].children[0];
          Oe.getAttribute(L, "data-p-disabled") ? this.navigateToMonth(t, !1, i) : (L.tabIndex = "0", L.focus()), t.preventDefault();
          break;
        }
        case "PageUp": {
          o.tabIndex = "-1", t.shiftKey ? (this.navigationState = {
            backward: !0
          }, this.navBackward(t)) : this.navigateToMonth(t, !0, i), t.preventDefault();
          break;
        }
        case "PageDown": {
          o.tabIndex = "-1", t.shiftKey ? (this.navigationState = {
            backward: !1
          }, this.navForward(t)) : this.navigateToMonth(t, !1, i), t.preventDefault();
          break;
        }
      }
    },
    navigateToMonth: function(t, n, i) {
      if (n)
        if (this.numberOfMonths === 1 || i === 0)
          this.navigationState = {
            backward: !0
          }, this.navBackward(t);
        else {
          var o = this.overlay.children[i - 1], a = Oe.find(o, 'table td span:not([data-p-disabled="true"]):not([data-p-ink="true"])'), r = a[a.length - 1];
          r.tabIndex = "0", r.focus();
        }
      else if (this.numberOfMonths === 1 || i === this.numberOfMonths - 1)
        this.navigationState = {
          backward: !1
        }, this.navForward(t);
      else {
        var s = this.overlay.children[i + 1], l = Oe.findSingle(s, 'table td span:not([data-p-disabled="true"]):not([data-p-ink="true"])');
        l.tabIndex = "0", l.focus();
      }
    },
    onMonthCellKeydown: function(t, n) {
      var i = t.currentTarget;
      switch (t.code) {
        case "ArrowUp":
        case "ArrowDown": {
          i.tabIndex = "-1";
          var o = i.parentElement.children, a = Oe.index(i), r = o[t.code === "ArrowDown" ? a + 3 : a - 3];
          r && (r.tabIndex = "0", r.focus()), t.preventDefault();
          break;
        }
        case "ArrowLeft": {
          i.tabIndex = "-1";
          var s = i.previousElementSibling;
          s ? (s.tabIndex = "0", s.focus()) : (this.navigationState = {
            backward: !0
          }, this.navBackward(t)), t.preventDefault();
          break;
        }
        case "ArrowRight": {
          i.tabIndex = "-1";
          var l = i.nextElementSibling;
          l ? (l.tabIndex = "0", l.focus()) : (this.navigationState = {
            backward: !1
          }, this.navForward(t)), t.preventDefault();
          break;
        }
        case "PageUp": {
          if (t.shiftKey)
            return;
          this.navigationState = {
            backward: !0
          }, this.navBackward(t);
          break;
        }
        case "PageDown": {
          if (t.shiftKey)
            return;
          this.navigationState = {
            backward: !1
          }, this.navForward(t);
          break;
        }
        case "Enter":
        case "NumpadEnter":
        case "Space": {
          this.onMonthSelect(t, n), t.preventDefault();
          break;
        }
        case "Escape": {
          this.overlayVisible = !1, t.preventDefault();
          break;
        }
        case "Tab": {
          this.trapFocus(t);
          break;
        }
      }
    },
    onYearCellKeydown: function(t, n) {
      var i = t.currentTarget;
      switch (t.code) {
        case "ArrowUp":
        case "ArrowDown": {
          i.tabIndex = "-1";
          var o = i.parentElement.children, a = Oe.index(i), r = o[t.code === "ArrowDown" ? a + 2 : a - 2];
          r && (r.tabIndex = "0", r.focus()), t.preventDefault();
          break;
        }
        case "ArrowLeft": {
          i.tabIndex = "-1";
          var s = i.previousElementSibling;
          s ? (s.tabIndex = "0", s.focus()) : (this.navigationState = {
            backward: !0
          }, this.navBackward(t)), t.preventDefault();
          break;
        }
        case "ArrowRight": {
          i.tabIndex = "-1";
          var l = i.nextElementSibling;
          l ? (l.tabIndex = "0", l.focus()) : (this.navigationState = {
            backward: !1
          }, this.navForward(t)), t.preventDefault();
          break;
        }
        case "PageUp": {
          if (t.shiftKey)
            return;
          this.navigationState = {
            backward: !0
          }, this.navBackward(t);
          break;
        }
        case "PageDown": {
          if (t.shiftKey)
            return;
          this.navigationState = {
            backward: !1
          }, this.navForward(t);
          break;
        }
        case "Enter":
        case "NumpadEnter":
        case "Space": {
          this.onYearSelect(t, n), t.preventDefault();
          break;
        }
        case "Escape": {
          this.overlayVisible = !1, t.preventDefault();
          break;
        }
        case "Tab": {
          this.trapFocus(t);
          break;
        }
      }
    },
    updateFocus: function() {
      var t;
      if (this.navigationState) {
        if (this.navigationState.button)
          this.initFocusableCell(), this.navigationState.backward ? this.previousButton.focus() : this.nextButton.focus();
        else {
          if (this.navigationState.backward) {
            var n;
            this.currentView === "month" ? n = Oe.find(this.overlay, '[data-pc-section="monthpicker"] [data-pc-section="month"]:not([data-p-disabled="true"])') : this.currentView === "year" ? n = Oe.find(this.overlay, '[data-pc-section="yearpicker"] [data-pc-section="year"]:not([data-p-disabled="true"])') : n = Oe.find(this.overlay, 'table td span:not([data-p-disabled="true"]):not([data-p-ink="true"])'), n && n.length > 0 && (t = n[n.length - 1]);
          } else
            this.currentView === "month" ? t = Oe.findSingle(this.overlay, '[data-pc-section="monthpicker"] [data-pc-section="month"]:not([data-p-disabled="true"])') : this.currentView === "year" ? t = Oe.findSingle(this.overlay, '[data-pc-section="yearpicker"] [data-pc-section="year"]:not([data-p-disabled="true"])') : t = Oe.findSingle(this.overlay, 'table td span:not([data-p-disabled="true"]):not([data-p-ink="true"])');
          t && (t.tabIndex = "0", t.focus());
        }
        this.navigationState = null;
      } else
        this.initFocusableCell();
    },
    initFocusableCell: function() {
      var t;
      if (this.currentView === "month") {
        var n = Oe.find(this.overlay, '[data-pc-section="monthpicker"] [data-pc-section="month"]'), i = Oe.findSingle(this.overlay, '[data-pc-section="monthpicker"] [data-pc-section="month"][data-p-highlight="true"]');
        n.forEach(function(s) {
          return s.tabIndex = -1;
        }), t = i || n[0];
      } else if (this.currentView === "year") {
        var o = Oe.find(this.overlay, '[data-pc-section="yearpicker"] [data-pc-section="year"]'), a = Oe.findSingle(this.overlay, '[data-pc-section="yearpicker"] [data-pc-section="year"][data-p-highlight="true"]');
        o.forEach(function(s) {
          return s.tabIndex = -1;
        }), t = a || o[0];
      } else if (t = Oe.findSingle(this.overlay, 'span[data-p-highlight="true"]'), !t) {
        var r = Oe.findSingle(this.overlay, 'td.p-datepicker-today span:not([data-p-disabled="true"]):not([data-p-ink="true"])');
        r ? t = r : t = Oe.findSingle(this.overlay, '.p-datepicker-calendar td span:not([data-p-disabled="true"]):not([data-p-ink="true"])');
      }
      t && (t.tabIndex = "0", !this.inline && (!this.navigationState || !this.navigationState.button) && !this.timePickerChange && (this.manualInput || t.focus()), this.preventFocus = !1);
    },
    trapFocus: function(t) {
      t.preventDefault();
      var n = Oe.getFocusableElements(this.overlay);
      if (n && n.length > 0)
        if (!document.activeElement)
          n[0].focus();
        else {
          var i = n.indexOf(document.activeElement);
          if (t.shiftKey)
            i === -1 || i === 0 ? n[n.length - 1].focus() : n[i - 1].focus();
          else if (i === -1)
            if (this.timeOnly)
              n[0].focus();
            else {
              for (var o = null, a = 0; a < n.length; a++)
                n[a].tagName === "SPAN" && (o = a);
              n[o].focus();
            }
          else
            i === n.length - 1 ? n[0].focus() : n[i + 1].focus();
        }
    },
    onContainerButtonKeydown: function(t) {
      switch (t.code) {
        case "Tab":
          this.trapFocus(t);
          break;
        case "Escape":
          this.overlayVisible = !1, t.preventDefault();
          break;
      }
      this.$emit("keydown", t);
    },
    onInput: function(t) {
      try {
        this.selectionStart = this.input.selectionStart, this.selectionEnd = this.input.selectionEnd;
        var n = this.parseValue(t.target.value);
        this.isValidSelection(n) && (this.typeUpdate = !0, this.updateModel(n));
      } catch {
      }
      this.$emit("input", t);
    },
    onInputClick: function() {
      this.showOnFocus && this.isEnabled() && !this.overlayVisible && (this.overlayVisible = !0);
    },
    onFocus: function(t) {
      this.showOnFocus && this.isEnabled() && (this.overlayVisible = !0), this.focused = !0, this.$emit("focus", t);
    },
    onBlur: function(t) {
      this.$emit("blur", {
        originalEvent: t,
        value: t.target.value
      }), this.focused = !1, t.target.value = this.formatValue(this.modelValue);
    },
    onKeyDown: function(t) {
      t.code === "ArrowDown" && this.overlay ? this.trapFocus(t) : t.code === "ArrowDown" && !this.overlay ? this.overlayVisible = !0 : t.code === "Escape" ? this.overlayVisible && (this.overlayVisible = !1, t.preventDefault()) : t.code === "Tab" && (this.overlay && Oe.getFocusableElements(this.overlay).forEach(function(n) {
        return n.tabIndex = "-1";
      }), this.overlayVisible && (this.overlayVisible = !1));
    },
    overlayRef: function(t) {
      this.overlay = t;
    },
    inputRef: function(t) {
      this.input = t;
    },
    previousButtonRef: function(t) {
      this.previousButton = t;
    },
    nextButtonRef: function(t) {
      this.nextButton = t;
    },
    getMonthName: function(t) {
      return this.$primevue.config.locale.monthNames[t];
    },
    getYear: function(t) {
      return this.currentView === "month" ? this.currentYear : t.year;
    },
    onOverlayClick: function(t) {
      this.inline || Zn.emit("overlay-click", {
        originalEvent: t,
        target: this.$el
      });
    },
    onOverlayKeyDown: function(t) {
      switch (t.code) {
        case "Escape":
          this.inline || (this.input.focus(), this.overlayVisible = !1);
          break;
      }
    },
    onOverlayMouseUp: function(t) {
      this.onOverlayClick(t);
    },
    createResponsiveStyle: function() {
      if (this.numberOfMonths > 1 && this.responsiveOptions && !this.isUnstyled) {
        if (!this.responsiveStyleElement) {
          var t;
          this.responsiveStyleElement = document.createElement("style"), this.responsiveStyleElement.type = "text/css", Oe.setAttribute(this.responsiveStyleElement, "nonce", (t = this.$primevue) === null || t === void 0 || (t = t.config) === null || t === void 0 || (t = t.csp) === null || t === void 0 ? void 0 : t.nonce), document.body.appendChild(this.responsiveStyleElement);
        }
        var n = "";
        if (this.responsiveOptions)
          for (var i = ObjectUtils.localeComparator(), o = up(this.responsiveOptions).filter(function(u) {
            return !!(u.breakpoint && u.numMonths);
          }).sort(function(u, m) {
            return -1 * i(u.breakpoint, m.breakpoint);
          }), a = 0; a < o.length; a++) {
            for (var r = o[a], s = r.breakpoint, l = r.numMonths, d = `
                            .p-datepicker[`.concat(this.attributeSelector, "] .p-datepicker-group:nth-child(").concat(l, `) .p-datepicker-next {
                                display: inline-flex;
                            }
                        `), y = l; y < this.numberOfMonths; y++)
              d += `
                                .p-datepicker[`.concat(this.attributeSelector, "] .p-datepicker-group:nth-child(").concat(y + 1, `) {
                                    display: none;
                                }
                            `);
            n += `
                            @media screen and (max-width: `.concat(s, `) {
                                `).concat(d, `
                            }
                        `);
          }
        this.responsiveStyleElement.innerHTML = n;
      }
    },
    destroyResponsiveStyleElement: function() {
      this.responsiveStyleElement && (this.responsiveStyleElement.remove(), this.responsiveStyleElement = null);
    }
  },
  computed: {
    viewDate: function() {
      var t = this.modelValue;
      if (t && Array.isArray(t) && (this.isRangeSelection() ? t = this.inline ? t[0] : t[1] || t[0] : this.isMultipleSelection() && (t = t[t.length - 1])), t && typeof t != "string")
        return t;
      var n = /* @__PURE__ */ new Date();
      return this.maxDate && this.maxDate < n ? this.maxDate : this.minDate && this.minDate > n ? this.minDate : n;
    },
    inputFieldValue: function() {
      return this.formatValue(this.modelValue);
    },
    months: function() {
      for (var t = [], n = 0; n < this.numberOfMonths; n++) {
        var i = this.currentMonth + n, o = this.currentYear;
        i > 11 && (i = i % 11 - 1, o = o + 1);
        for (var a = [], r = this.getFirstDayOfMonthIndex(i, o), s = this.getDaysCountInMonth(i, o), l = this.getDaysCountInPrevMonth(i, o), d = 1, y = /* @__PURE__ */ new Date(), u = [], m = Math.ceil((s + r) / 7), h = 0; h < m; h++) {
          var c = [];
          if (h == 0) {
            for (var g = l - r + 1; g <= l; g++) {
              var v = this.getPreviousMonthAndYear(i, o);
              c.push({
                day: g,
                month: v.month,
                year: v.year,
                otherMonth: !0,
                today: this.isToday(y, g, v.month, v.year),
                selectable: this.isSelectable(g, v.month, v.year, !0)
              });
            }
            for (var P = 7 - c.length, f = 0; f < P; f++)
              c.push({
                day: d,
                month: i,
                year: o,
                today: this.isToday(y, d, i, o),
                selectable: this.isSelectable(d, i, o, !1)
              }), d++;
          } else
            for (var S = 0; S < 7; S++) {
              if (d > s) {
                var w = this.getNextMonthAndYear(i, o);
                c.push({
                  day: d - s,
                  month: w.month,
                  year: w.year,
                  otherMonth: !0,
                  today: this.isToday(y, d - s, w.month, w.year),
                  selectable: this.isSelectable(d - s, w.month, w.year, !0)
                });
              } else
                c.push({
                  day: d,
                  month: i,
                  year: o,
                  today: this.isToday(y, d, i, o),
                  selectable: this.isSelectable(d, i, o, !1)
                });
              d++;
            }
          this.showWeek && u.push(this.getWeekNumber(new Date(c[0].year, c[0].month, c[0].day))), a.push(c);
        }
        t.push({
          month: i,
          year: o,
          dates: a,
          weekNumbers: u
        });
      }
      return t;
    },
    weekDays: function() {
      for (var t = [], n = this.$primevue.config.locale.firstDayOfWeek, i = 0; i < 7; i++)
        t.push(this.$primevue.config.locale.dayNamesMin[n]), n = n == 6 ? 0 : ++n;
      return t;
    },
    ticksTo1970: function() {
      return ((1970 - 1) * 365 + Math.floor(1970 / 4) - Math.floor(1970 / 100) + Math.floor(1970 / 400)) * 24 * 60 * 60 * 1e7;
    },
    sundayIndex: function() {
      return this.$primevue.config.locale.firstDayOfWeek > 0 ? 7 - this.$primevue.config.locale.firstDayOfWeek : 0;
    },
    datePattern: function() {
      return this.dateFormat || this.$primevue.config.locale.dateFormat;
    },
    yearOptions: function() {
      if (this.yearRange) {
        var t = this, n = this.yearRange.split(":"), i = parseInt(n[0]), o = parseInt(n[1]), a = [];
        this.currentYear < i ? t.currentYear = o : this.currentYear > o && (t.currentYear = i);
        for (var r = i; r <= o; r++)
          a.push(r);
        return a;
      } else
        return null;
    },
    monthPickerValues: function() {
      for (var t = this, n = [], i = function(r) {
        if (t.minDate) {
          var s = t.minDate.getMonth(), l = t.minDate.getFullYear();
          if (t.currentYear < l || t.currentYear === l && r < s)
            return !1;
        }
        if (t.maxDate) {
          var d = t.maxDate.getMonth(), y = t.maxDate.getFullYear();
          if (t.currentYear > y || t.currentYear === y && r > d)
            return !1;
        }
        return !0;
      }, o = 0; o <= 11; o++)
        n.push({
          value: this.$primevue.config.locale.monthNamesShort[o],
          selectable: i(o)
        });
      return n;
    },
    yearPickerValues: function() {
      for (var t = this, n = [], i = this.currentYear - this.currentYear % 10, o = function(s) {
        return !(t.minDate && t.minDate.getFullYear() > s || t.maxDate && t.maxDate.getFullYear() < s);
      }, a = 0; a < 10; a++)
        n.push({
          value: i + a,
          selectable: o(i + a)
        });
      return n;
    },
    formattedCurrentHour: function() {
      return this.currentHour < 10 ? "0" + this.currentHour : this.currentHour;
    },
    formattedCurrentMinute: function() {
      return this.currentMinute < 10 ? "0" + this.currentMinute : this.currentMinute;
    },
    formattedCurrentSecond: function() {
      return this.currentSecond < 10 ? "0" + this.currentSecond : this.currentSecond;
    },
    todayLabel: function() {
      return this.$primevue.config.locale.today;
    },
    clearLabel: function() {
      return this.$primevue.config.locale.clear;
    },
    weekHeaderLabel: function() {
      return this.$primevue.config.locale.weekHeader;
    },
    monthNames: function() {
      return this.$primevue.config.locale.monthNames;
    },
    attributeSelector: function() {
      return Mt();
    },
    switchViewButtonDisabled: function() {
      return this.numberOfMonths > 1 || this.disabled;
    },
    panelId: function() {
      return Mt() + "_panel";
    }
  },
  components: {
    CalendarButton: ki,
    Portal: Yn,
    CalendarIcon: Vk,
    ChevronLeftIcon: th,
    ChevronRightIcon: Fo,
    ChevronUpIcon: ig,
    ChevronDownIcon: Va
  },
  directives: {
    ripple: An
  }
};
function dc(e) {
  "@babel/helpers - typeof";
  return dc = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, dc(e);
}
function Gy(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    t && (i = i.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), n.push.apply(n, i);
  }
  return n;
}
function wd(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Gy(Object(n), !0).forEach(function(i) {
      V$(e, i, n[i]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Gy(Object(n)).forEach(function(i) {
      Object.defineProperty(e, i, Object.getOwnPropertyDescriptor(n, i));
    });
  }
  return e;
}
function V$(e, t, n) {
  return t = G$(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function G$(e) {
  var t = U$(e, "string");
  return dc(t) == "symbol" ? t : String(t);
}
function U$(e, t) {
  if (dc(e) != "object" || !e)
    return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var i = n.call(e, t || "default");
    if (dc(i) != "object")
      return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var W$ = ["id"], Y$ = ["id", "placeholder", "aria-expanded", "aria-controls", "aria-labelledby", "aria-label", "disabled", "readonly"], q$ = ["id", "role", "aria-modal", "aria-label"], K$ = ["disabled", "aria-label"], X$ = ["disabled", "aria-label"], Z$ = ["disabled", "aria-label"], J$ = ["disabled", "aria-label"], Q$ = ["disabled", "aria-label"], e4 = ["disabled", "aria-label"], t4 = ["data-p-disabled"], n4 = ["abbr"], i4 = ["data-p-disabled"], a4 = ["aria-label", "data-p-today", "data-p-other-month"], o4 = ["onClick", "onKeydown", "aria-selected", "aria-disabled", "data-p-disabled", "data-p-highlight"], r4 = ["onClick", "onKeydown", "data-p-disabled", "data-p-highlight"], s4 = ["onClick", "onKeydown", "data-p-disabled", "data-p-highlight"], l4 = ["aria-label"], c4 = ["aria-label"], d4 = ["aria-label", "disabled"], u4 = ["aria-label", "disabled"], h4 = ["aria-label", "disabled"], p4 = ["aria-label", "disabled"], f4 = ["aria-label", "disabled"], m4 = ["aria-label", "disabled"];
function g4(e, t, n, i, o, a) {
  var r = $e("CalendarButton"), s = $e("Portal"), l = Ut("ripple");
  return E(), X("span", Ce({
    ref: "container",
    id: e.id,
    class: e.cx("root"),
    style: e.sx("root")
  }, e.ptm("root"), {
    "data-pc-name": "calendar"
  }), [e.inline ? te("", !0) : (E(), X("input", Ce({
    key: 0,
    ref: a.inputRef,
    id: e.inputId,
    type: "text",
    role: "combobox",
    class: [e.cx("input"), e.inputClass],
    style: e.inputStyle,
    placeholder: e.placeholder,
    autocomplete: "off",
    "aria-autocomplete": "none",
    "aria-haspopup": "dialog",
    "aria-expanded": o.overlayVisible,
    "aria-controls": a.panelId,
    "aria-labelledby": e.ariaLabelledby,
    "aria-label": e.ariaLabel,
    inputmode: "none",
    disabled: e.disabled,
    readonly: !e.manualInput || e.readonly,
    tabindex: 0,
    onInput: t[0] || (t[0] = function() {
      return a.onInput && a.onInput.apply(a, arguments);
    }),
    onClick: t[1] || (t[1] = function() {
      return a.onInputClick && a.onInputClick.apply(a, arguments);
    }),
    onFocus: t[2] || (t[2] = function() {
      return a.onFocus && a.onFocus.apply(a, arguments);
    }),
    onBlur: t[3] || (t[3] = function() {
      return a.onBlur && a.onBlur.apply(a, arguments);
    }),
    onKeydown: t[4] || (t[4] = function() {
      return a.onKeyDown && a.onKeyDown.apply(a, arguments);
    })
  }, wd(wd({}, e.inputProps), e.ptm("input"))), null, 16, Y$)), e.showIcon && e.iconDisplay === "button" ? (E(), fe(r, {
    key: 1,
    class: Pe(e.cx("dropdownButton")),
    disabled: e.disabled,
    onClick: a.onButtonClick,
    type: "button",
    "aria-label": e.$primevue.config.locale.chooseDate,
    "aria-haspopup": "dialog",
    "aria-expanded": o.overlayVisible,
    "aria-controls": a.panelId,
    unstyled: e.unstyled,
    pt: e.ptm("dropdownButton"),
    "data-pc-section": "dropdownbutton"
  }, {
    icon: Se(function() {
      return [je(e.$slots, "dropdownicon", {
        class: Pe(e.icon)
      }, function() {
        return [(E(), fe(tt(e.icon ? "span" : "CalendarIcon"), Ce({
          class: e.icon
        }, e.ptm("dropdownButton").icon, {
          "data-pc-section": "dropdownicon"
        }), null, 16, ["class"]))];
      })];
    }),
    _: 3
  }, 8, ["class", "disabled", "onClick", "aria-label", "aria-expanded", "aria-controls", "unstyled", "pt"])) : e.showIcon && e.iconDisplay === "input" ? je(e.$slots, "inputicon", {
    key: 2,
    class: Pe(e.cx("inputIcon")),
    clickCallback: a.onButtonClick
  }, function() {
    return [(E(), fe(tt(e.icon ? "i" : "CalendarIcon"), Ce({
      class: [e.icon, e.cx("inputIcon")],
      onClick: a.onButtonClick
    }, e.ptm("inputicon")), null, 16, ["class", "onClick"]))];
  }) : te("", !0), ue(s, {
    appendTo: e.appendTo,
    disabled: e.inline
  }, {
    default: Se(function() {
      return [ue(ia, Ce({
        name: "p-connected-overlay",
        onEnter: t[74] || (t[74] = function(d) {
          return a.onOverlayEnter(d);
        }),
        onAfterEnter: a.onOverlayEnterComplete,
        onAfterLeave: a.onOverlayAfterLeave,
        onLeave: a.onOverlayLeave
      }, e.ptm("transition")), {
        default: Se(function() {
          return [e.inline || o.overlayVisible ? (E(), X("div", Ce({
            key: 0,
            ref: a.overlayRef,
            id: a.panelId,
            class: [e.cx("panel"), e.panelClass],
            style: e.panelStyle,
            role: e.inline ? null : "dialog",
            "aria-modal": e.inline ? null : "true",
            "aria-label": e.$primevue.config.locale.chooseDate,
            onClick: t[71] || (t[71] = function() {
              return a.onOverlayClick && a.onOverlayClick.apply(a, arguments);
            }),
            onKeydown: t[72] || (t[72] = function() {
              return a.onOverlayKeyDown && a.onOverlayKeyDown.apply(a, arguments);
            }),
            onMouseup: t[73] || (t[73] = function() {
              return a.onOverlayMouseUp && a.onOverlayMouseUp.apply(a, arguments);
            })
          }, wd(wd({}, e.panelProps), e.ptm("panel"))), [e.timeOnly ? te("", !0) : (E(), X(Re, {
            key: 0
          }, [oe("div", Ce({
            class: e.cx("groupContainer")
          }, e.ptm("groupContainer")), [(E(!0), X(Re, null, Ge(a.months, function(d, y) {
            return E(), X("div", Ce({
              key: d.month + d.year,
              class: e.cx("group")
            }, e.ptm("group")), [oe("div", Ce({
              class: e.cx("header")
            }, e.ptm("header")), [je(e.$slots, "header"), rt((E(), X("button", Ce({
              ref_for: !0,
              ref: a.previousButtonRef,
              class: e.cx("previousButton"),
              onClick: t[5] || (t[5] = function() {
                return a.onPrevButtonClick && a.onPrevButtonClick.apply(a, arguments);
              }),
              type: "button",
              onKeydown: t[6] || (t[6] = function() {
                return a.onContainerButtonKeydown && a.onContainerButtonKeydown.apply(a, arguments);
              }),
              disabled: e.disabled,
              "aria-label": o.currentView === "year" ? e.$primevue.config.locale.prevDecade : o.currentView === "month" ? e.$primevue.config.locale.prevYear : e.$primevue.config.locale.prevMonth
            }, e.ptm("previousButton"), {
              "data-pc-group-section": "navigator"
            }), [je(e.$slots, "previousicon", {
              class: Pe(e.cx("previousIcon"))
            }, function() {
              return [(E(), fe(tt(e.previousIcon ? "span" : "ChevronLeftIcon"), Ce({
                class: [e.cx("previousIcon"), e.previousIcon]
              }, e.ptm("previousIcon")), null, 16, ["class"]))];
            })], 16, K$)), [[xn, e.showOtherMonths ? y === 0 : !1], [l]]), oe("div", Ce({
              class: e.cx("title")
            }, e.ptm("title")), [e.$primevue.config.locale.showMonthAfterYear ? (E(), X(Re, {
              key: 0
            }, [o.currentView !== "year" ? (E(), X("button", Ce({
              key: 0,
              type: "button",
              onClick: t[7] || (t[7] = function() {
                return a.switchToYearView && a.switchToYearView.apply(a, arguments);
              }),
              onKeydown: t[8] || (t[8] = function() {
                return a.onContainerButtonKeydown && a.onContainerButtonKeydown.apply(a, arguments);
              }),
              class: e.cx("yearTitle"),
              disabled: a.switchViewButtonDisabled,
              "aria-label": e.$primevue.config.locale.chooseYear
            }, e.ptm("yearTitle"), {
              "data-pc-group-section": "view"
            }), Ie(a.getYear(d)), 17, X$)) : te("", !0), o.currentView === "date" ? (E(), X("button", Ce({
              key: 1,
              type: "button",
              onClick: t[9] || (t[9] = function() {
                return a.switchToMonthView && a.switchToMonthView.apply(a, arguments);
              }),
              onKeydown: t[10] || (t[10] = function() {
                return a.onContainerButtonKeydown && a.onContainerButtonKeydown.apply(a, arguments);
              }),
              class: e.cx("monthTitle"),
              disabled: a.switchViewButtonDisabled,
              "aria-label": e.$primevue.config.locale.chooseMonth
            }, e.ptm("monthTitle"), {
              "data-pc-group-section": "view"
            }), Ie(a.getMonthName(d.month)), 17, Z$)) : te("", !0)], 64)) : (E(), X(Re, {
              key: 1
            }, [o.currentView === "date" ? (E(), X("button", Ce({
              key: 0,
              type: "button",
              onClick: t[11] || (t[11] = function() {
                return a.switchToMonthView && a.switchToMonthView.apply(a, arguments);
              }),
              onKeydown: t[12] || (t[12] = function() {
                return a.onContainerButtonKeydown && a.onContainerButtonKeydown.apply(a, arguments);
              }),
              class: e.cx("monthTitle"),
              disabled: a.switchViewButtonDisabled,
              "aria-label": e.$primevue.config.locale.chooseMonth
            }, e.ptm("monthTitle"), {
              "data-pc-group-section": "view"
            }), Ie(a.getMonthName(d.month)), 17, J$)) : te("", !0), o.currentView !== "year" ? (E(), X("button", Ce({
              key: 1,
              type: "button",
              onClick: t[13] || (t[13] = function() {
                return a.switchToYearView && a.switchToYearView.apply(a, arguments);
              }),
              onKeydown: t[14] || (t[14] = function() {
                return a.onContainerButtonKeydown && a.onContainerButtonKeydown.apply(a, arguments);
              }),
              class: e.cx("yearTitle"),
              disabled: a.switchViewButtonDisabled,
              "aria-label": e.$primevue.config.locale.chooseYear
            }, e.ptm("yearTitle"), {
              "data-pc-group-section": "view"
            }), Ie(a.getYear(d)), 17, Q$)) : te("", !0)], 64)), o.currentView === "year" ? (E(), X("span", Ce({
              key: 2,
              class: e.cx("decadeTitle")
            }, e.ptm("decadeTitle")), [je(e.$slots, "decade", {
              years: a.yearPickerValues
            }, function() {
              return [Ve(Ie(a.yearPickerValues[0].value) + " - " + Ie(a.yearPickerValues[a.yearPickerValues.length - 1].value), 1)];
            })], 16)) : te("", !0)], 16), rt((E(), X("button", Ce({
              ref_for: !0,
              ref: a.nextButtonRef,
              class: e.cx("nextButton"),
              onClick: t[15] || (t[15] = function() {
                return a.onNextButtonClick && a.onNextButtonClick.apply(a, arguments);
              }),
              type: "button",
              onKeydown: t[16] || (t[16] = function() {
                return a.onContainerButtonKeydown && a.onContainerButtonKeydown.apply(a, arguments);
              }),
              disabled: e.disabled,
              "aria-label": o.currentView === "year" ? e.$primevue.config.locale.nextDecade : o.currentView === "month" ? e.$primevue.config.locale.nextYear : e.$primevue.config.locale.nextMonth
            }, e.ptm("nextButton"), {
              "data-pc-group-section": "navigator"
            }), [je(e.$slots, "nexticon", {
              class: Pe(e.cx("nextIcon"))
            }, function() {
              return [(E(), fe(tt(e.nextIcon ? "span" : "ChevronRightIcon"), Ce({
                class: [e.cx("nextIcon"), e.nextIcon]
              }, e.ptm("nextIcon")), null, 16, ["class"]))];
            })], 16, e4)), [[xn, e.showOtherMonths ? e.numberOfMonths === 1 ? !0 : y === e.numberOfMonths - 1 : !1], [l]])], 16), o.currentView === "date" ? (E(), X("div", Ce({
              key: 0,
              class: e.cx("container")
            }, e.ptm("container")), [oe("table", Ce({
              class: e.cx("table"),
              role: "grid"
            }, e.ptm("table")), [oe("thead", si(Ki(e.ptm("tableHeader"))), [oe("tr", si(Ki(e.ptm("tableHeaderRow"))), [e.showWeek ? (E(), X("th", Ce({
              key: 0,
              scope: "col",
              class: e.cx("weekHeader")
            }, e.ptm("weekHeader", {
              context: {
                disabled: e.showWeek
              }
            }), {
              "data-p-disabled": e.showWeek,
              "data-pc-group-section": "tableheadercell"
            }), [je(e.$slots, "weekheaderlabel", {}, function() {
              return [oe("span", Ce(e.ptm("weekHeaderLabel", {
                context: {
                  disabled: e.showWeek
                }
              }), {
                "data-pc-group-section": "tableheadercelllabel"
              }), Ie(a.weekHeaderLabel), 17)];
            })], 16, t4)) : te("", !0), (E(!0), X(Re, null, Ge(a.weekDays, function(u) {
              return E(), X("th", Ce({
                key: u,
                scope: "col",
                abbr: u
              }, e.ptm("tableHeaderCell"), {
                "data-pc-group-section": "tableheadercell"
              }), [oe("span", Ce(e.ptm("weekDay"), {
                "data-pc-group-section": "tableheadercelllabel"
              }), Ie(u), 17)], 16, n4);
            }), 128))], 16)], 16), oe("tbody", si(Ki(e.ptm("tableBody"))), [(E(!0), X(Re, null, Ge(d.dates, function(u, m) {
              return E(), X("tr", Ce({
                key: u[0].day + "" + u[0].month
              }, e.ptm("tableBodyRow")), [e.showWeek ? (E(), X("td", Ce({
                key: 0,
                class: e.cx("weekNumber")
              }, e.ptm("weekNumber"), {
                "data-pc-group-section": "tablebodycell"
              }), [oe("span", Ce({
                class: e.cx("weekLabelContainer")
              }, e.ptm("weekLabelContainer", {
                context: {
                  disabled: e.showWeek
                }
              }), {
                "data-p-disabled": e.showWeek,
                "data-pc-group-section": "tablebodycelllabel"
              }), [je(e.$slots, "weeklabel", {
                weekNumber: d.weekNumbers[m]
              }, function() {
                return [d.weekNumbers[m] < 10 ? (E(), X("span", Ce({
                  key: 0,
                  style: {
                    visibility: "hidden"
                  }
                }, e.ptm("weekLabel")), "0", 16)) : te("", !0), Ve(" " + Ie(d.weekNumbers[m]), 1)];
              })], 16, i4)], 16)) : te("", !0), (E(!0), X(Re, null, Ge(u, function(h) {
                return E(), X("td", Ce({
                  key: h.day + "" + h.month,
                  "aria-label": h.day,
                  class: e.cx("day", {
                    date: h
                  })
                }, e.ptm("day", {
                  context: {
                    date: h,
                    today: h.today,
                    otherMonth: h.otherMonth
                  }
                }), {
                  "data-p-today": h.today,
                  "data-p-other-month": h.otherMonth,
                  "data-pc-group-section": "tablebodycell"
                }), [rt((E(), X("span", Ce({
                  class: e.cx("dayLabel", {
                    date: h
                  }),
                  onClick: function(g) {
                    return a.onDateSelect(g, h);
                  },
                  draggable: "false",
                  onKeydown: function(g) {
                    return a.onDateCellKeydown(g, h, y);
                  },
                  "aria-selected": a.isSelected(h),
                  "aria-disabled": !h.selectable
                }, e.ptm("dayLabel", {
                  context: {
                    date: h,
                    selected: a.isSelected(h),
                    disabled: !h.selectable
                  }
                }), {
                  "data-p-disabled": !h.selectable,
                  "data-p-highlight": a.isSelected(h),
                  "data-pc-group-section": "tablebodycelllabel"
                }), [je(e.$slots, "date", {
                  date: h
                }, function() {
                  return [Ve(Ie(h.day), 1)];
                })], 16, o4)), [[l]]), a.isSelected(h) ? (E(), X("div", Ce({
                  key: 0,
                  class: "p-hidden-accessible",
                  "aria-live": "polite"
                }, e.ptm("hiddenSelectedDay"), {
                  "data-p-hidden-accessible": !0
                }), Ie(h.day), 17)) : te("", !0)], 16, a4);
              }), 128))], 16);
            }), 128))], 16)], 16)], 16)) : te("", !0)], 16);
          }), 128))], 16), o.currentView === "month" ? (E(), X("div", Ce({
            key: 0,
            class: e.cx("monthPicker")
          }, e.ptm("monthPicker")), [(E(!0), X(Re, null, Ge(a.monthPickerValues, function(d, y) {
            return rt((E(), X("span", Ce({
              key: d,
              onClick: function(m) {
                return a.onMonthSelect(m, {
                  month: d,
                  index: y
                });
              },
              onKeydown: function(m) {
                return a.onMonthCellKeydown(m, {
                  month: d,
                  index: y
                });
              },
              class: e.cx("month", {
                month: d,
                index: y
              })
            }, e.ptm("month", {
              context: {
                month: d,
                monthIndex: y,
                selected: a.isMonthSelected(y),
                disabled: !d.selectable
              }
            }), {
              "data-p-disabled": !d.selectable,
              "data-p-highlight": a.isMonthSelected(y)
            }), [Ve(Ie(d.value) + " ", 1), a.isMonthSelected(y) ? (E(), X("div", Ce({
              key: 0,
              class: "p-hidden-accessible",
              "aria-live": "polite"
            }, e.ptm("hiddenMonth"), {
              "data-p-hidden-accessible": !0
            }), Ie(d.value), 17)) : te("", !0)], 16, r4)), [[l]]);
          }), 128))], 16)) : te("", !0), o.currentView === "year" ? (E(), X("div", Ce({
            key: 1,
            class: e.cx("yearPicker")
          }, e.ptm("yearPicker")), [(E(!0), X(Re, null, Ge(a.yearPickerValues, function(d) {
            return rt((E(), X("span", Ce({
              key: d.value,
              onClick: function(u) {
                return a.onYearSelect(u, d);
              },
              onKeydown: function(u) {
                return a.onYearCellKeydown(u, d);
              },
              class: e.cx("year", {
                year: d
              })
            }, e.ptm("year", {
              context: {
                year: d,
                selected: a.isYearSelected(d.value),
                disabled: !d.selectable
              }
            }), {
              "data-p-disabled": !d.selectable,
              "data-p-highlight": a.isYearSelected(d.value)
            }), [Ve(Ie(d.value) + " ", 1), a.isYearSelected(d.value) ? (E(), X("div", Ce({
              key: 0,
              class: "p-hidden-accessible",
              "aria-live": "polite"
            }, e.ptm("hiddenYear"), {
              "data-p-hidden-accessible": !0
            }), Ie(d.value), 17)) : te("", !0)], 16, s4)), [[l]]);
          }), 128))], 16)) : te("", !0)], 64)), (e.showTime || e.timeOnly) && o.currentView === "date" ? (E(), X("div", Ce({
            key: 1,
            class: e.cx("timePicker")
          }, e.ptm("timePicker")), [oe("div", Ce({
            class: e.cx("hourPicker")
          }, e.ptm("hourPicker"), {
            "data-pc-group-section": "timepickerContainer"
          }), [rt((E(), X("button", Ce({
            class: e.cx("incrementButton"),
            "aria-label": e.$primevue.config.locale.nextHour,
            onMousedown: t[17] || (t[17] = function(d) {
              return a.onTimePickerElementMouseDown(d, 0, 1);
            }),
            onMouseup: t[18] || (t[18] = function(d) {
              return a.onTimePickerElementMouseUp(d);
            }),
            onKeydown: [t[19] || (t[19] = function() {
              return a.onContainerButtonKeydown && a.onContainerButtonKeydown.apply(a, arguments);
            }), t[21] || (t[21] = Ze(function(d) {
              return a.onTimePickerElementMouseDown(d, 0, 1);
            }, ["enter"])), t[22] || (t[22] = Ze(function(d) {
              return a.onTimePickerElementMouseDown(d, 0, 1);
            }, ["space"]))],
            onMouseleave: t[20] || (t[20] = function(d) {
              return a.onTimePickerElementMouseLeave();
            }),
            onKeyup: [t[23] || (t[23] = Ze(function(d) {
              return a.onTimePickerElementMouseUp(d);
            }, ["enter"])), t[24] || (t[24] = Ze(function(d) {
              return a.onTimePickerElementMouseUp(d);
            }, ["space"]))],
            type: "button"
          }, e.ptm("incrementButton"), {
            "data-pc-group-section": "timepickerbutton"
          }), [je(e.$slots, "incrementicon", {}, function() {
            return [(E(), fe(tt(e.incrementIcon ? "span" : "ChevronUpIcon"), Ce({
              class: e.incrementIcon
            }, e.ptm("incrementIcon"), {
              "data-pc-group-section": "timepickerlabel"
            }), null, 16, ["class"]))];
          })], 16, l4)), [[l]]), oe("span", Ce(e.ptm("hour"), {
            "data-pc-group-section": "timepickerlabel"
          }), Ie(a.formattedCurrentHour), 17), rt((E(), X("button", Ce({
            class: e.cx("decrementButton"),
            "aria-label": e.$primevue.config.locale.prevHour,
            onMousedown: t[25] || (t[25] = function(d) {
              return a.onTimePickerElementMouseDown(d, 0, -1);
            }),
            onMouseup: t[26] || (t[26] = function(d) {
              return a.onTimePickerElementMouseUp(d);
            }),
            onKeydown: [t[27] || (t[27] = function() {
              return a.onContainerButtonKeydown && a.onContainerButtonKeydown.apply(a, arguments);
            }), t[29] || (t[29] = Ze(function(d) {
              return a.onTimePickerElementMouseDown(d, 0, -1);
            }, ["enter"])), t[30] || (t[30] = Ze(function(d) {
              return a.onTimePickerElementMouseDown(d, 0, -1);
            }, ["space"]))],
            onMouseleave: t[28] || (t[28] = function(d) {
              return a.onTimePickerElementMouseLeave();
            }),
            onKeyup: [t[31] || (t[31] = Ze(function(d) {
              return a.onTimePickerElementMouseUp(d);
            }, ["enter"])), t[32] || (t[32] = Ze(function(d) {
              return a.onTimePickerElementMouseUp(d);
            }, ["space"]))],
            type: "button"
          }, e.ptm("decrementButton"), {
            "data-pc-group-section": "timepickerbutton"
          }), [je(e.$slots, "decrementicon", {}, function() {
            return [(E(), fe(tt(e.decrementIcon ? "span" : "ChevronDownIcon"), Ce({
              class: e.decrementIcon
            }, e.ptm("decrementIcon"), {
              "data-pc-group-section": "timepickerlabel"
            }), null, 16, ["class"]))];
          })], 16, c4)), [[l]])], 16), oe("div", Ce({
            class: e.cx("separatorContainer")
          }, e.ptm("separatorContainer"), {
            "data-pc-group-section": "timepickerContainer"
          }), [oe("span", Ce(e.ptm("separator"), {
            "data-pc-group-section": "timepickerlabel"
          }), Ie(e.timeSeparator), 17)], 16), oe("div", Ce({
            class: e.cx("minutePicker")
          }, e.ptm("minutePicker"), {
            "data-pc-group-section": "timepickerContainer"
          }), [rt((E(), X("button", Ce({
            class: e.cx("incrementButton"),
            "aria-label": e.$primevue.config.locale.nextMinute,
            onMousedown: t[33] || (t[33] = function(d) {
              return a.onTimePickerElementMouseDown(d, 1, 1);
            }),
            onMouseup: t[34] || (t[34] = function(d) {
              return a.onTimePickerElementMouseUp(d);
            }),
            onKeydown: [t[35] || (t[35] = function() {
              return a.onContainerButtonKeydown && a.onContainerButtonKeydown.apply(a, arguments);
            }), t[37] || (t[37] = Ze(function(d) {
              return a.onTimePickerElementMouseDown(d, 1, 1);
            }, ["enter"])), t[38] || (t[38] = Ze(function(d) {
              return a.onTimePickerElementMouseDown(d, 1, 1);
            }, ["space"]))],
            disabled: e.disabled,
            onMouseleave: t[36] || (t[36] = function(d) {
              return a.onTimePickerElementMouseLeave();
            }),
            onKeyup: [t[39] || (t[39] = Ze(function(d) {
              return a.onTimePickerElementMouseUp(d);
            }, ["enter"])), t[40] || (t[40] = Ze(function(d) {
              return a.onTimePickerElementMouseUp(d);
            }, ["space"]))],
            type: "button"
          }, e.ptm("incrementButton"), {
            "data-pc-group-section": "timepickerbutton"
          }), [je(e.$slots, "incrementicon", {}, function() {
            return [(E(), fe(tt(e.incrementIcon ? "span" : "ChevronUpIcon"), Ce({
              class: e.incrementIcon
            }, e.ptm("incrementIcon"), {
              "data-pc-group-section": "timepickerlabel"
            }), null, 16, ["class"]))];
          })], 16, d4)), [[l]]), oe("span", Ce(e.ptm("minute"), {
            "data-pc-group-section": "timepickerlabel"
          }), Ie(a.formattedCurrentMinute), 17), rt((E(), X("button", Ce({
            class: e.cx("decrementButton"),
            "aria-label": e.$primevue.config.locale.prevMinute,
            onMousedown: t[41] || (t[41] = function(d) {
              return a.onTimePickerElementMouseDown(d, 1, -1);
            }),
            onMouseup: t[42] || (t[42] = function(d) {
              return a.onTimePickerElementMouseUp(d);
            }),
            onKeydown: [t[43] || (t[43] = function() {
              return a.onContainerButtonKeydown && a.onContainerButtonKeydown.apply(a, arguments);
            }), t[45] || (t[45] = Ze(function(d) {
              return a.onTimePickerElementMouseDown(d, 1, -1);
            }, ["enter"])), t[46] || (t[46] = Ze(function(d) {
              return a.onTimePickerElementMouseDown(d, 1, -1);
            }, ["space"]))],
            disabled: e.disabled,
            onMouseleave: t[44] || (t[44] = function(d) {
              return a.onTimePickerElementMouseLeave();
            }),
            onKeyup: [t[47] || (t[47] = Ze(function(d) {
              return a.onTimePickerElementMouseUp(d);
            }, ["enter"])), t[48] || (t[48] = Ze(function(d) {
              return a.onTimePickerElementMouseUp(d);
            }, ["space"]))],
            type: "button"
          }, e.ptm("decrementButton"), {
            "data-pc-group-section": "timepickerbutton"
          }), [je(e.$slots, "decrementicon", {}, function() {
            return [(E(), fe(tt(e.decrementIcon ? "span" : "ChevronDownIcon"), Ce({
              class: e.decrementIcon
            }, e.ptm("decrementIcon"), {
              "data-pc-group-section": "timepickerlabel"
            }), null, 16, ["class"]))];
          })], 16, u4)), [[l]])], 16), e.showSeconds ? (E(), X("div", Ce({
            key: 0,
            class: e.cx("separatorContainer")
          }, e.ptm("separatorContainer"), {
            "data-pc-group-section": "timepickerContainer"
          }), [oe("span", Ce(e.ptm("separator"), {
            "data-pc-group-section": "timepickerlabel"
          }), Ie(e.timeSeparator), 17)], 16)) : te("", !0), e.showSeconds ? (E(), X("div", Ce({
            key: 1,
            class: e.cx("secondPicker")
          }, e.ptm("secondPicker"), {
            "data-pc-group-section": "timepickerContainer"
          }), [rt((E(), X("button", Ce({
            class: e.cx("incrementButton"),
            "aria-label": e.$primevue.config.locale.nextSecond,
            onMousedown: t[49] || (t[49] = function(d) {
              return a.onTimePickerElementMouseDown(d, 2, 1);
            }),
            onMouseup: t[50] || (t[50] = function(d) {
              return a.onTimePickerElementMouseUp(d);
            }),
            onKeydown: [t[51] || (t[51] = function() {
              return a.onContainerButtonKeydown && a.onContainerButtonKeydown.apply(a, arguments);
            }), t[53] || (t[53] = Ze(function(d) {
              return a.onTimePickerElementMouseDown(d, 2, 1);
            }, ["enter"])), t[54] || (t[54] = Ze(function(d) {
              return a.onTimePickerElementMouseDown(d, 2, 1);
            }, ["space"]))],
            disabled: e.disabled,
            onMouseleave: t[52] || (t[52] = function(d) {
              return a.onTimePickerElementMouseLeave();
            }),
            onKeyup: [t[55] || (t[55] = Ze(function(d) {
              return a.onTimePickerElementMouseUp(d);
            }, ["enter"])), t[56] || (t[56] = Ze(function(d) {
              return a.onTimePickerElementMouseUp(d);
            }, ["space"]))],
            type: "button"
          }, e.ptm("incrementButton"), {
            "data-pc-group-section": "timepickerbutton"
          }), [je(e.$slots, "incrementicon", {}, function() {
            return [(E(), fe(tt(e.incrementIcon ? "span" : "ChevronUpIcon"), Ce({
              class: e.incrementIcon
            }, e.ptm("incrementIcon"), {
              "data-pc-group-section": "timepickerlabel"
            }), null, 16, ["class"]))];
          })], 16, h4)), [[l]]), oe("span", Ce(e.ptm("second"), {
            "data-pc-group-section": "timepickerlabel"
          }), Ie(a.formattedCurrentSecond), 17), rt((E(), X("button", Ce({
            class: e.cx("decrementButton"),
            "aria-label": e.$primevue.config.locale.prevSecond,
            onMousedown: t[57] || (t[57] = function(d) {
              return a.onTimePickerElementMouseDown(d, 2, -1);
            }),
            onMouseup: t[58] || (t[58] = function(d) {
              return a.onTimePickerElementMouseUp(d);
            }),
            onKeydown: [t[59] || (t[59] = function() {
              return a.onContainerButtonKeydown && a.onContainerButtonKeydown.apply(a, arguments);
            }), t[61] || (t[61] = Ze(function(d) {
              return a.onTimePickerElementMouseDown(d, 2, -1);
            }, ["enter"])), t[62] || (t[62] = Ze(function(d) {
              return a.onTimePickerElementMouseDown(d, 2, -1);
            }, ["space"]))],
            disabled: e.disabled,
            onMouseleave: t[60] || (t[60] = function(d) {
              return a.onTimePickerElementMouseLeave();
            }),
            onKeyup: [t[63] || (t[63] = Ze(function(d) {
              return a.onTimePickerElementMouseUp(d);
            }, ["enter"])), t[64] || (t[64] = Ze(function(d) {
              return a.onTimePickerElementMouseUp(d);
            }, ["space"]))],
            type: "button"
          }, e.ptm("decrementButton"), {
            "data-pc-group-section": "timepickerbutton"
          }), [je(e.$slots, "decrementicon", {}, function() {
            return [(E(), fe(tt(e.decrementIcon ? "span" : "ChevronDownIcon"), Ce({
              class: e.decrementIcon
            }, e.ptm("decrementIcon"), {
              "data-pc-group-section": "timepickerlabel"
            }), null, 16, ["class"]))];
          })], 16, p4)), [[l]])], 16)) : te("", !0), e.hourFormat == "12" ? (E(), X("div", Ce({
            key: 2,
            class: e.cx("separatorContainer")
          }, e.ptm("separatorContainer"), {
            "data-pc-group-section": "timepickerContainer"
          }), [oe("span", Ce(e.ptm("separator"), {
            "data-pc-group-section": "timepickerlabel"
          }), Ie(e.timeSeparator), 17)], 16)) : te("", !0), e.hourFormat == "12" ? (E(), X("div", Ce({
            key: 3,
            class: e.cx("ampmPicker")
          }, e.ptm("ampmPicker")), [rt((E(), X("button", Ce({
            class: e.cx("incrementButton"),
            "aria-label": e.$primevue.config.locale.am,
            onClick: t[65] || (t[65] = function(d) {
              return a.toggleAMPM(d);
            }),
            onKeydown: t[66] || (t[66] = function() {
              return a.onContainerButtonKeydown && a.onContainerButtonKeydown.apply(a, arguments);
            }),
            type: "button",
            disabled: e.disabled
          }, e.ptm("incrementButton"), {
            "data-pc-group-section": "timepickerbutton"
          }), [je(e.$slots, "incrementicon", {
            class: Pe(e.cx("incrementIcon"))
          }, function() {
            return [(E(), fe(tt(e.incrementIcon ? "span" : "ChevronUpIcon"), Ce({
              class: e.cx("incrementIcon")
            }, e.ptm("incrementIcon"), {
              "data-pc-group-section": "timepickerlabel"
            }), null, 16, ["class"]))];
          })], 16, f4)), [[l]]), oe("span", Ce(e.ptm("ampm"), {
            "data-pc-group-section": "timepickerlabel"
          }), Ie(o.pm ? e.$primevue.config.locale.pm : e.$primevue.config.locale.am), 17), rt((E(), X("button", Ce({
            class: e.cx("decrementButton"),
            "aria-label": e.$primevue.config.locale.pm,
            onClick: t[67] || (t[67] = function(d) {
              return a.toggleAMPM(d);
            }),
            onKeydown: t[68] || (t[68] = function() {
              return a.onContainerButtonKeydown && a.onContainerButtonKeydown.apply(a, arguments);
            }),
            type: "button",
            disabled: e.disabled
          }, e.ptm("decrementButton"), {
            "data-pc-group-section": "timepickerbutton"
          }), [je(e.$slots, "decrementicon", {
            class: Pe(e.cx("decrementIcon"))
          }, function() {
            return [(E(), fe(tt(e.decrementIcon ? "span" : "ChevronDownIcon"), Ce({
              class: e.cx("decrementIcon")
            }, e.ptm("decrementIcon"), {
              "data-pc-group-section": "timepickerlabel"
            }), null, 16, ["class"]))];
          })], 16, m4)), [[l]])], 16)) : te("", !0)], 16)) : te("", !0), e.showButtonBar ? (E(), X("div", Ce({
            key: 2,
            class: e.cx("buttonbar")
          }, e.ptm("buttonbar")), [ue(r, {
            type: "button",
            label: a.todayLabel,
            onClick: t[69] || (t[69] = function(d) {
              return a.onTodayButtonClick(d);
            }),
            class: Pe(e.cx("todayButton")),
            onKeydown: a.onContainerButtonKeydown,
            unstyled: e.unstyled,
            pt: e.ptm("todayButton"),
            "data-pc-section": "todaybutton",
            "data-pc-group-section": "button"
          }, null, 8, ["label", "class", "onKeydown", "unstyled", "pt"]), ue(r, {
            type: "button",
            label: a.clearLabel,
            onClick: t[70] || (t[70] = function(d) {
              return a.onClearButtonClick(d);
            }),
            class: Pe(e.cx("clearButton")),
            onKeydown: a.onContainerButtonKeydown,
            unstyled: e.unstyled,
            pt: e.ptm("clearButton"),
            "data-pc-section": "clearbutton",
            "data-pc-group-section": "button"
          }, null, 8, ["label", "class", "onKeydown", "unstyled", "pt"])], 16)) : te("", !0), je(e.$slots, "footer")], 16, q$)) : te("", !0)];
        }),
        _: 3
      }, 16, ["onAfterEnter", "onAfterLeave", "onLeave"])];
    }),
    _: 3
  }, 8, ["appendTo", "disabled"])], 16, W$);
}
ag.render = g4;
const al = function(e, t) {
  return new Intl.NumberFormat(t, {
    style: "decimal",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(e);
}, v4 = Be({
  name: "PerformanceChart",
  components: {
    HTMLContentBlock: ht,
    DropDocuments: Zc,
    PrimeButton: ki,
    PrimeCalendar: ag,
    FootNote: ja,
    FootnoteHeader: li,
    ColoredNumber: zk,
    TextBlock: Mr,
    BaseChart: Xc
  },
  props: {
    performanceDataPeriods: {
      type: Object,
      required: !0
    },
    performanceData: {
      type: Object,
      required: !0
    },
    values: {
      type: Object,
      required: !0
    },
    culture: {
      type: String,
      required: !0,
      default: "de-DE"
    }
  },
  emits: ["onPeriod"],
  setup() {
    const e = Ue ? window.innerWidth : 0, t = Ue ? window.innerHeight : 0, n = ge(e), i = ge(t);
    return Ue && (it(() => {
      window.addEventListener("resize", () => {
        n.value = window.innerWidth, i.value = window.innerHeight;
      });
    }), sn(() => {
      window.removeEventListener("resize", () => {
        windowSize.value = window.innerWidth, i.value = window.innerHeigh;
      });
    })), {
      windowWidth: n,
      windowHeight: i
    };
  },
  data() {
    return {
      graphDataAvailable: !1,
      graphDataPeriodsAvailable: !1,
      selectedPerformanceToggle: 0,
      performanceToggleList: [
        { name: this.values?.performanceButtonText, value: 0 },
        { name: this.values?.priceButtonText, value: 1 }
      ],
      selectedDocument: null,
      documents: [],
      loadTimer: null,
      isLoading: !1,
      calendarIsActive: !1,
      calendarInputFrom: null,
      calendarInputTo: null,
      minDateFrom: /* @__PURE__ */ new Date("1900-01-01"),
      maxDateFrom: /* @__PURE__ */ new Date("2050-01-01"),
      minDateTo: /* @__PURE__ */ new Date("1900-01-01"),
      maxDateTo: /* @__PURE__ */ new Date("2050-01-01"),
      selectedPeriodStartDate: /* @__PURE__ */ new Date("1900-01-01"),
      selectedPeriodEndDate: /* @__PURE__ */ new Date("2050-01-01"),
      invalidDates: [],
      activeToggleButton: 0,
      numberColumn: 1,
      lastBrushValues: { min: null, max: null },
      currentBenchmark: { fund: null, bench: null },
      activePeriodButton: null,
      dataFirst: null,
      dataFirstUTC: null,
      dataLast: null,
      dataLastUTC: null,
      onCloseCalender: null,
      chartOptions: {
        series: [],
        yAxis: {},
        chart: {
          panning: !1
        }
      },
      chartResolution: "1000",
      dataEventSource: null,
      dateTimeFormat: "%d.%m.%y",
      dateTimeFormatYearOnly: this.values?.calendar.dateFormatYearOnly,
      dateTimeFormatMonthOnly: this.values?.calendar.dateFormatMonthOnly,
      dateTimeFormatDayOnly: this.values?.calendar.dateFormatDayOnly,
      dateTimeFormatMonthYear: this.values?.calendar.dateFormatMonthYear,
      calenderFromOpen: !1,
      calenderToOpen: !1,
      colorPetrol45: Zd,
      colorPurple40: Vy,
      colorGreyBlue006: sf,
      colorSkyBlue: lf
    };
  },
  computed: {
    chartContainer() {
      const e = this.$refs.highChart.$refs.baseChart.chart.id;
      return eo.find(eo.charts, function(t) {
        return t?.renderTo?.id === e;
      });
    },
    navigatorSeries() {
      const e = [];
      let t = [{ data: [] }];
      return this.graphDataAvailable && (t = [
        {
          data: [],
          name: this.performanceData.ticker,
          dashStyle: "solid",
          id: this.performanceData.ticker,
          color: {
            linearGradient: { x1: 0, x2: 0, y1: 0, y2: 1 },
            stops: [
              [0, "rgba(193,225,225, 1)"],
              [1, "rgba(193,225,225, 0.25)"]
            ]
          }
        }
      ], this.performanceData.values.forEach((n) => {
        this.activeToggleButton === 0 ? e.push([
          n[Sa],
          n[cp]
        ]) : e.push([
          n[Sa],
          n[lp]
        ]);
      })), t[0].data = e, t;
    },
    highChartOptionsArea() {
      const e = V6;
      e.lang.noData = this.values.noDataText, e.lang.loading = this.values.isLoadingText;
      const t = this;
      return e.xAxis = {
        events: {
          afterSetExtremes(n) {
            n.trigger === "navigator" && (t.calendarIsActive = !0, t.setDefaultDateRange(n.min, n.max), t.setBrushSelectionUtc(
              new Date(n.min).getTime(),
              new Date(n.max).getTime()
            ), t.navigatorEvent());
          }
        },
        labels: {
          step: 2,
          type: "datetime",
          style: {
            color: this.colorGreyBlue006,
            fontWeight: "400",
            fontSize: "14px",
            fontFamily: '"SlabLight", Helvetica, Arial, sans-serif'
          }
        },
        minTickInterval: 24 * 3600 * 1e3,
        dateTimeLabelFormats: {
          millisecond: this.dateTimeFormat,
          //"%e. %b",
          second: this.dateTimeFormat,
          //"%e. %b",
          minute: this.dateTimeFormat,
          //"%e. %b",
          hour: this.dateTimeFormat,
          //"%e. %b",
          day: this.dateTimeFormat,
          //"%e. %b",
          week: this.dateTimeFormat,
          //"%e. %b",
          month: this.dateTimeFormatMonthYear,
          //"%b / %y",
          year: this.dateTimeFormatYearOnly
          //"%Y",
        }
      }, e.yAxis = {
        title: {
          text: this.values.yAxisLabelPercent
        },
        opposite: !1,
        labels: {
          step: 1,
          style: {
            color: this.colorGreyBlue006,
            fontWeight: "400",
            fontSize: "14px",
            fontFamily: '"SlabLight", Helvetica, Arial, sans-serif'
          },
          formatter: function() {
            return this.value * 100;
          }
        }
      }, e;
    },
    calcMinDate() {
      return this.graphDataAvailable ? new Date(
        this.performanceData.values[0][Sa]
      ) : /* @__PURE__ */ new Date();
    },
    calcMaxDate() {
      return this.graphDataAvailable ? new Date(
        this.performanceData.values[this.performanceData.values.length - 1][Sa]
      ) : /* @__PURE__ */ new Date();
    },
    isToggleLong() {
      return this.values?.performanceButtonText.length > 11;
    },
    breakDateButtons() {
      return this.windowHeight >= 1024 && this.windowHeight <= 1366 || this.windowWidth <= 1080;
    }
  },
  watch: {
    performanceDataPeriods() {
      if (this.graphDataPeriodsAvailable = !(this.performanceDataPeriods && Object.keys(this.performanceDataPeriods).length === 0 && Object.getPrototypeOf(this.performanceDataPeriods) === Object.prototype), this.graphDataPeriodsAvailable) {
        this.currentBenchmark.fund = this.performanceDataPeriods.values[this.performanceDataPeriods.values.length - 1][cp] * 100, this.currentBenchmark.bench = this.performanceDataPeriods.values[this.performanceDataPeriods.values.length - 1][dp] ? this.performanceDataPeriods.values[this.performanceDataPeriods.values.length - 1][dp] * 100 : null;
        const e = this.performanceDataPeriods.values[0][0], t = this.performanceDataPeriods.values[this.performanceDataPeriods.values.length - 1][0];
        this.selectedPeriodStartDate = this.getFormattedUtcToIso(
          new Date(e)
        ), this.selectedPeriodEndDate = this.getFormattedUtcToIso(
          new Date(t)
        ), this.setDefaultDateRange(e, t), this.switchGraph(), this.chartOptions.navigator.series = this.navigatorSeries, this.updateChartGraph(e, t);
      }
    },
    selectedPeriodStartDate() {
      this.calcDocuments();
    },
    selectedPeriodEndDate() {
      this.calcDocuments();
    }
  },
  created() {
    this.actualLanguage = this.culture;
    const { pageName: e } = Qe();
    this.dataEventSource = e, this.setCalendarLanguage(), this.setDefaultButton(), this.calcDocuments(), this.chartOptions = Object.assign(
      this.chartOptions,
      this.highChartOptionsArea
    ), this.graphDataAvailable = !!this.performanceData && !(this.performanceData && Object.keys(this.performanceData).length === 0 && Object.getPrototypeOf(this.performanceData) === Object.prototype), this.graphDataAvailable && (this.chartOptions.navigator.series = this.navigatorSeries);
  },
  async mounted() {
    this.dateTimeFormat = this.values?.calendar.dateFormatDayMonthYear, this.dateTimeFormatYearOnly = this.values?.calendar.dateFormatYearOnly, this.dateTimeFormatMonthOnly = this.values?.calendar.dateFormatMonthOnly, this.dateTimeFormatDayOnly = this.values?.calendar.dateFormatDayOnly, this.dateTimeFormatMonthYear = this.values?.calendar.dateFormatMonthYear, this.loadPerformanceData(this.activePeriodButton), this.minDateFrom = this.minDateTo = this.calcMinDate, this.maxDateFrom = this.maxDateTo = this.calcMaxDate, await mt(), Ue && this.graphDataAvailable && (document.getElementById("draggedNavigatorButton").setAttribute("hidden", "hidden"), document.getElementById("calendarEventButton").setAttribute("hidden", "hidden"));
  },
  methods: {
    onCloseCalendar(e) {
      e === "rangeFrom" ? this.calenderFromOpen ? (this.hideCalendar(), this.$refs.rangeFrom.overlayVisible = !1, this.$refs.rangeFrom.focused = !1, this.calenderFromOpen = !1) : (this.showCalendar("FROM"), this.$refs.rangeFrom.overlayVisible = !0, this.$refs.rangeFrom.focused = !0, this.calenderFromOpen = !0) : this.calenderToOpen ? (this.hideCalendar(), this.$refs.rangeTo.overlayVisible = !1, this.$refs.rangeTo.focused = !1, this.calenderToOpen = !1) : (this.showCalendar("TO"), this.$refs.rangeTo.overlayVisible = !0, this.$refs.rangeTo.focused = !0, this.calenderToOpen = !0);
    },
    loadPerformanceData(e) {
      const t = this.activePeriodButton;
      let n = 0, i = 0;
      if (this.graphDataAvailable && (n = this.performanceData.values[this.performanceData.values.length - 1][Sa], i = this.performanceData.values[0][Sa]), this.activePeriodButton = e, e.type === "YTD")
        i = new Date(
          (/* @__PURE__ */ new Date()).getUTCFullYear(),
          0,
          1,
          6,
          0,
          0
        ).getTime();
      else if (e.type !== "MAX") {
        let o = 0;
        const a = parseInt(e.type.substr(-3, 2)), s = e.type.substr(-1) === "M" ? 1 : 12;
        o = a * s, i = this.subtractMonths(n, o);
      }
      i && n && (this.setBrushSelectionUtc(i, n), this.updateChartGraph(i, n)), this.graphDataAvailable || (this.activePeriodButton = t);
    },
    updateChartGraph(e, t) {
      this.chartOptions.navigator.series = this.navigatorSeries, this.chartContainer.xAxis[0].setExtremes(e, t, !0);
    },
    getFormattedUtcToIso(e) {
      const t = new Date(e), n = t.getFullYear(), i = (1 + t.getMonth()).toString().padStart(2, "0"), o = t.getDate().toString().padStart(2, "0");
      return `${n}-${i}-${o}`;
    },
    showCalendar(e) {
      if (e === "FROM" ? (this.maxDateFrom = this.calendarInputTo, this.calenderFromOpen = !0) : (this.minDateTo = this.calendarInputFrom, this.calenderToOpen = !0), Ue) {
        const t = document.getElementById("calendarEventButton");
        t.removeAttribute("hidden"), t.setAttribute(
          "data-event_title",
          "Calendar | closed | " + e
        ), t.click(), t.setAttribute("hidden", "hidden");
      }
    },
    hideCalendar() {
      this.setBrushSelectionUtc(this.calendarInputFrom, this.calendarInputTo);
    },
    setBrushSelectionUtc(e, t) {
      this.graphDataAvailable && (this.setSelectedPeriodStartEndDates(e, t), this.updateChartData(e, t));
    },
    setSelectedPeriodStartEndDates(e, t) {
      this.selectedPeriodStartDate = this.getFormattedUtcToIso(e), this.selectedPeriodEndDate = this.getFormattedUtcToIso(t);
    },
    onClickPerformanceButton(e) {
      this.activeToggleButton = e, this.selectedPerformanceToggle = e, this.switchGraph();
    },
    switchGraph() {
      const e = [], t = [], n = [];
      this.graphDataAvailable && this.performanceDataPeriods.values.forEach((o) => {
        this.activeToggleButton === 0 ? (e.push([
          o[Sa],
          o[cp]
        ]), t.push([
          o[Sa],
          o[dp]
        ]), n.push([
          o[Sa],
          o[lp]
        ])) : e.push([
          o[Sa],
          o[lp]
        ]);
      });
      const i = [];
      if (this.graphDataAvailable)
        if (this.activeToggleButton === 0) {
          i.push({
            data: e,
            name: this.performanceDataPeriods.ticker,
            color: Zd,
            dashStyle: "solid",
            visible: !0,
            showInNavigator: !1
          }), i.push({
            data: t,
            name: this.performanceDataPeriods.indexNames[0],
            color: Vy,
            dashStyle: "shortdot",
            visible: !0,
            showInNavigator: !1
          }), i.push({
            data: n,
            name: "FundsPrice",
            visible: !1,
            showInNavigator: !1
          });
          const o = this.performanceDataPeriods.flags.map((a) => ({
            color: a.lineColor,
            title: "&nbsp; &nbsp; " + a.title + "&nbsp; &nbsp; ",
            text: a.text,
            x: a.x
          }));
          i.push({
            data: o,
            name: "Flags",
            shape: "flag",
            type: "flags",
            dashStyle: "shortdot",
            lineColor: this.colorGreyBlue006,
            // Highcharts.getOptions().colors[3].color,
            lineWidth: 1,
            fillColor: this.colorGreyBlue006,
            states: {
              hover: {
                fillColor: this.colorSkyBlue,
                lineColor: this.colorSkyBlue
              }
            },
            style: {
              fontFamily: "SlabBold",
              color: "#ffffff",
              fontWeight: "400",
              borderRadius: 12
            }
            //onSeries:  this.performanceDataPeriods.ticker,
            //showInNavigator: false
          });
        } else
          i.push({
            data: e,
            color: Zd,
            name: "FundsPrice",
            dashStyle: "solid",
            visible: !0,
            showInNavigator: !1
          });
      this.setAdditionalLabel(), this.chartOptions.series = i, this.chartOptions.navigator.series = this.navigatorSeries;
    },
    setAdditionalLabel() {
      if (this.graphDataAvailable) {
        const e = this.activeToggleButton === 0 ? this.values.percent : this.values.currency;
        if (e === this.values.currency) {
          this.chartOptions.tooltip = U6.tooltip;
          const t = this;
          this.chartOptions.tooltip.formatter = function() {
            const i = new eo.Time().dateFormat("%d.%m.%Y", this.key);
            return `<table class="highchart-stock-chart-tooltip"><thead><tr class='norightborder'><th>` + t.values.dateText + "</th></tr>  <tr class='noborder'><td>" + i + "</td></tr>  </thead>  <tbody>  <tr><th>" + t.values.navText + "</th></tr>  <tr><td>" + eo.numberFormat(this.point.y, 2) + "</td></tr> </tbody> </table>";
          };
        } else {
          this.chartOptions.tooltip = G6.tooltip;
          const t = this, n = this.dateTimeFormat;
          this.chartOptions.tooltip.formatter = function() {
            if (this.series !== void 0 && this.series.type === "flags")
              return '<div class="highchart-stock-chart-flags-tooltip">' + new eo.Time().dateFormat(n, this.x) + " | " + this.series.data[0].text + "</div>";
            const i = this.points[0].x;
            let o = 0;
            t.chartOptions.series[1].data.forEach(function(h) {
              h.indexOf(i) !== -1 && (o = h[1] * 100);
            });
            let r = 0;
            t.chartOptions.series[2].data.forEach(function(h) {
              h.indexOf(i) !== -1 && (r = h[1]);
            });
            const l = al(
              this.points[0].y * 100,
              t.culture
            ), d = new eo.Time(), y = d.dateFormat(n, this.x), u = d.dateFormat(
              n,
              this.points[0].series.xAxis.min
            );
            return '<table class="highchart-stock-chart-tooltip"><thead> <tr><th>' + t.values.startDateText + "</th><th class='ttright'>" + t.values.endDateText + "</th></tr>  <tr><td>" + u + "</td><td class='ttright'>" + y + "</td></tr> <tr class='noborder'><td></td><td></td></tr> </thead>  <tbody>		  <tr><th>" + t.values.navPercentText + "</th><th class='ttright'>" + t.values.navText + '</th></tr>  <tr><td><span style="color:' + t.setPerformanceTooltipColor(l) + '"><i class= "' + t.setPerformanceTooltipIcon(l) + '" style="--fa-rotate-angle: 45deg;"></i> ' + l + t.values.percent + "</span> </td><td class='ttright'>" + al(r, t.culture) + "</td></tr>" + (o !== 0 ? "  <tr><th>" + t.values.indexLevelText + '</th><th></th></tr>  <tr><td><span style="color:' + t.setPerformanceTooltipColor(
              al(o, t.culture)
            ) + '"><i class="' + t.setPerformanceTooltipIcon(
              al(o, t.culture)
            ) + '" style="--fa-rotate-angle: -45deg;"></i> ' + al(o, t.culture) + t.values.percent + "</span> </td><td class='ttright'></td></tr>" : "") + " </tbody> </table>";
          };
        }
        this.chartOptions.yAxis = {
          title: {
            text: e === this.values.currency ? this.values.yAxisLabelCurrency : this.values.yAxisLabelPercent
          },
          labels: {
            formatter: function() {
              return Math.round(this.value);
            }
          }
        }, e === this.values.percent && (this.chartOptions.yAxis = {
          title: {
            text: e === this.values.currency ? this.values.yAxisLabelCurrency : this.values.yAxisLabelPercent
          },
          labels: {
            formatter: function() {
              return Math.round(this.value * 100);
            }
          }
        });
      }
    },
    setPerformanceTooltipIcon(e) {
      return this.isPositive(e) ? "las la-arrow-circle-up la-rotate-45" : "las la-arrow-circle-down la-rotate-45-minus";
    },
    setPerformanceTooltipColor(e) {
      return this.needColorCoding() ? this.isPositive(e) ? "#60A540" : "#e84057" : "#2e393d";
    },
    needColorCoding() {
      if (Ue) {
        const e = document.querySelector("html").getAttribute("data-color-coding");
        if (e)
          return e === "true";
      }
      return !1;
    },
    isPositive(e) {
      if (e == 0)
        return !0;
      const t = parseFloat(e.replace(",", "."));
      return Math.sign(t) !== -1;
    },
    checkNumberMonths(e) {
      let t = null, n = null;
      if (!this.graphDataAvailable)
        return -1;
      if (e !== "MAX" && e !== "YTD") {
        const a = parseInt(e.substr(-3, 2)), s = e.substr(-1) === "M" ? 1 : 12;
        n = a * s;
      }
      const i = new Date(this.performanceData.values[0][0]), o = new Date(
        this.performanceData.values[this.performanceData.values.length - 1][0]
      );
      return t = this.differenceInMonths(o, i), n >= t;
    },
    toggleCalendar() {
      this.calendarIsActive = !this.calendarIsActive, this.calendarIsActive || this.loadPerformanceData(this.activePeriodButton);
    },
    updateChartData(e, t) {
      this.graphDataAvailable && (this.loadTimer && (clearTimeout(this.loadTimer), this.loadTimer = null), this.chartContainer.showLoading(), this.loadTimer = setTimeout(() => {
        const n = {
          startDate: this.getFormattedUtcToIso(e),
          endDate: this.getFormattedUtcToIso(t),
          resolution: this.chartResolution
        };
        this.loadPeriod(n), this.chartContainer.hideLoading();
      }, 500));
    },
    loadPeriod(e) {
      this.$emit("onPeriod", e);
    },
    setDefaultButton() {
      let e = null;
      this.values?.periodButtons.forEach((t) => {
        t.default && (e = t);
      }), this.activePeriodButton = e;
    },
    // Set default range in the Date Pickers based on a Period button selection.
    setDefaultDateRange(e, t) {
      this.calendarInputFrom = new Date(e), this.calendarInputTo = new Date(t);
    },
    // Set calendar language from JSON
    setCalendarLanguage() {
      this.$primevue.config.locale.monthNamesShort = this.values?.shortMonths, this.$primevue.config.locale.monthNames = this.values?.calendar.monthNames, this.$primevue.config.locale.dayNamesMin = this.values?.calendar.dayNamesMin, this.$primevue.config.locale.dateFormat = this.values?.calendar.dateFormat;
    },
    showOrHideLegend(e) {
      this.chartOptions.series[e].visible = !this.chartOptions.series[e].visible;
    },
    calcDocuments() {
      this.selectedPeriodStartDate !== null && this.selectedPeriodEndDate !== null && (this.documents = [], this.values?.documents?.forEach((e) => {
        if (e.type === "PERIOD") {
          const t = `${e.url}&startDate=${this.selectedPeriodStartDate}&endDate=${this.selectedPeriodEndDate}`;
          this.documents.push({ url: t, name: e.name, type: e.type });
        } else
          this.documents.push(e);
      }));
    },
    downloadItem(e) {
      Ue && window.open(e);
    },
    navigatorEvent() {
      if (Ue) {
        const e = document.getElementById(
          "draggedNavigatorButton"
        );
        e.removeAttribute("hidden"), e.setAttribute("data-event_title", "Navigator"), e.click(), e.setAttribute("hidden", "hidden");
      }
    },
    // Parser footnote
    footNoteParser(e) {
      let t = "";
      return e.split("{{").forEach((i) => {
        const o = i.indexOf("}}");
        if (o > -1) {
          const a = i.substring(0, o + 2), r = i.substring(0, o), s = this.values?.id;
          t += i.replace(
            a,
            `<a class="footnote" id="first-${r}${s}" href="#sec-${r}${s}" v-smooth-scroll="{ duration: 1000, offset: -250}"><sup>[${r}]</sup></a>`
          );
        } else
          t += i;
      }), t;
    },
    useDeselectButton(e) {
      e instanceof TouchEvent && this.isTouchEventWithElement(e) || document.activeElement instanceof HTMLElement && document.activeElement.blur();
    },
    isTouchEventWithElement(e) {
      const t = e.changedTouches ? e.changedTouches[0].pageX : 0, n = e.changedTouches ? e.changedTouches[0].pageY : 0, i = document.elementFromPoint(t, n), o = e.changedTouches.item(0);
      return i === null || o === null ? !1 : i.getBoundingClientRect().right > o.clientX && i.getBoundingClientRect().left < o.clientX && i.getBoundingClientRect().top < o.clientY && i.getBoundingClientRect().bottom > o.clientY;
    },
    subtractMonths(e, t) {
      const n = new Date(e);
      return n.setMonth(n.getMonth() - t), n;
    },
    differenceInMonths(e, t) {
      const n = e.getMonth() - t.getMonth(), i = e.getFullYear() - t.getFullYear();
      return n + i * 12;
    },
    sanitizeHtml(e) {
      const { htmlContentBlockWhitelist: t } = Li();
      return Ma(e, t);
    }
  }
}), y4 = { class: "grid xs:grid-cols-1 lg:grid-cols-3 performance-chart container" }, b4 = { class: "xs:col-span-1 lg:col-span-3 mb-24" }, x4 = { class: "performance-chart-header text-right" }, w4 = { key: 0 }, k4 = {
  key: 0,
  class: "xs:col-span-1 lg:col-span-3 pt-8 text-end"
}, S4 = { key: 1 }, C4 = { class: "xs:col-span-1 lg:col-span-3 pt-8 performance-buttons" }, T4 = { class: "bordered" }, L4 = ["data-event_title", "data-event_source", "onClick"], I4 = { class: "performance-group-toggle" }, P4 = { class: "performance-buttons flex flex-col mb-4 lg:flex-row lg:justify-end" }, A4 = {
  key: 0,
  class: "period-buttons-group flex flex-wrap gap-x-2 justify-end"
}, _4 = ["hidden", "disabled", "data-event_title", "data-event_source", "onClick"], M4 = {
  key: 1,
  class: "calendar-input-group flex gap-2"
}, O4 = { class: "calendar-input-date" }, B4 = { class: "calendar-input-date" }, E4 = ["data-event_source"], D4 = {
  key: 0,
  class: "las la-calendar p-button-icon"
}, R4 = ["data-event_source"], N4 = { class: "chart-download-link bordered" }, $4 = ["data-event_title", "data-event_source", "onClick"], F4 = { class: "grid xs:grid-cols-1 lg:grid-cols-2" }, j4 = { class: "xs:col-span-1 md:col-span-1 ml-16 mt-4 text-left" }, H4 = {
  key: 0,
  class: "funds-bench-values flex"
}, z4 = { class: "performance-percent-text" }, V4 = { key: 0 }, G4 = { class: "performance-percent-text" }, U4 = { class: "xs:col-span-1 mx-2 mt-4 text-right performance-fonds" }, W4 = { key: 2 }, Y4 = { id: "highcharts" }, q4 = ["data-event_source"];
function K4(e, t, n, i, o, a) {
  const r = $e("FootnoteHeader"), s = $e("DropDocuments"), l = $e("PrimeButton"), d = $e("PrimeCalendar"), y = $e("HTMLContentBlock"), u = $e("ColoredNumber"), m = $e("BaseChart"), h = $e("FootNote"), c = $e("TextBlock"), g = Ut("tooltip");
  return E(), X("div", y4, [
    oe("div", b4, [
      oe("div", x4, [
        oe("h2", null, [
          ue(r, {
            text: e.values?.headlineText,
            "foot-note-id": e.values?.id
          }, null, 8, ["text", "foot-note-id"])
        ]),
        e.graphDataAvailable ? (E(), X("h2", w4, Ie(e.values?.headlineDateText), 1)) : te("", !0)
      ]),
      e.graphDataAvailable ? te("", !0) : (E(), X("div", k4, [
        oe("p", null, Ie(e.values.noDataText), 1)
      ])),
      e.graphDataAvailable ? (E(), X("div", S4, [
        oe("div", C4, [
          ue(s, {
            modelValue: e.selectedPerformanceToggle,
            "onUpdate:modelValue": t[0] || (t[0] = (v) => e.selectedPerformanceToggle = v),
            options: e.performanceToggleList,
            class: "w-full mb-4 lg:hidden switch-value",
            "option-label": "name",
            "option-value": "value",
            placeholder: "",
            downloadAnchorName: "",
            downloadAnchorHref: "",
            dataEventSource: e.dataEventSource,
            eventComponentName: "Performance-Chart"
          }, {
            option: Se((v) => [
              oe("div", T4, [
                oe("a", {
                  "data-event_component_name": "Chart",
                  "data-event_title": "Toggle | " + v.option.name,
                  "data-event_source": e.dataEventSource,
                  onClick: (P) => e.onClickPerformanceButton(v.option.value)
                }, Ie(v.option.name), 9, L4)
              ])
            ]),
            _: 1
          }, 8, ["modelValue", "options", "dataEventSource"]),
          oe("div", I4, [
            ue(l, {
              label: `${e.values?.performanceButtonText}`,
              class: Pe(["p-button-rounded performance-buttons-left", {
                "performance-buttons-left__active": e.activeToggleButton === 0
              }]),
              "data-event_component_name": "Chart",
              "data-event_title": `Toggle | ${e.values?.performanceButtonText}`,
              "data-event_source": e.dataEventSource,
              role: "tab",
              value: `${e.values?.performanceButtonText}`,
              onClick: t[1] || (t[1] = (v) => e.onClickPerformanceButton(0))
            }, null, 8, ["label", "class", "data-event_title", "data-event_source", "value"]),
            ue(l, {
              label: `${e.values?.priceButtonText}`,
              class: Pe(["p-button-rounded performance-buttons-right", {
                "performance-buttons-right__active": e.activeToggleButton === 1
              }]),
              "data-event_component_name": "Chart",
              "data-event_title": `Toggle | ${e.values?.priceButtonText}`,
              "data-event_source": e.dataEventSource,
              role: "tab",
              value: `${e.values?.priceButtonText}`,
              onClick: t[2] || (t[2] = (v) => e.onClickPerformanceButton(1))
            }, null, 8, ["label", "class", "data-event_title", "data-event_source", "value"])
          ])
        ]),
        oe("div", P4, [
          e.calendarIsActive ? te("", !0) : (E(), X("span", A4, [
            (E(!0), X(Re, null, Ge(e.values.periodButtons, (v) => (E(), X("button", {
              key: "per-but-" + v.type,
              hidden: e.checkNumberMonths(v.type),
              disabled: e.calendarIsActive,
              class: Pe(["performance-buttons-period", {
                "performance-buttons-period__active": v.type === e.activePeriodButton.type
              }]),
              "data-event_component_name": "Chart",
              "data-event_title": `Year Buttons | ${v.text}`,
              "data-event_source": e.dataEventSource,
              onClick: (P) => e.loadPerformanceData(v, !0)
            }, Ie(v.text), 11, _4))), 128))
          ])),
          e.calendarIsActive ? (E(), X("div", M4, [
            oe("span", O4, [
              ue(d, {
                id: "rangeFrom",
                ref: "rangeFrom",
                modelValue: e.calendarInputFrom,
                "onUpdate:modelValue": t[3] || (t[3] = (v) => e.calendarInputFrom = v),
                class: "calendar-input",
                "manual-input": !1,
                "min-date": e.minDateFrom,
                "max-date": e.maxDateFrom,
                "disabled-dates": e.invalidDates,
                "disabled-days": [0, 6],
                onShow: t[4] || (t[4] = (v) => e.showCalendar("FROM")),
                onHide: t[5] || (t[5] = (v) => e.hideCalendar("FROM"))
              }, null, 8, ["modelValue", "min-date", "max-date", "disabled-dates"]),
              ue(l, {
                class: "p-button-icon-only p-button-rounded",
                "data-event_component_name": "Chart",
                "data-event_title": "Calendar | closed | FROM",
                "data-event_source": e.dataEventSource,
                onClick: t[6] || (t[6] = It((v) => e.onCloseCalendar("rangeFrom"), ["stop"]))
              }, {
                default: Se(() => t[13] || (t[13] = [
                  oe("i", { class: "las la-calendar p-button-icon" }, null, -1)
                ])),
                _: 1
              }, 8, ["data-event_source"])
            ]),
            oe("span", B4, [
              ue(d, {
                id: "rangeTo",
                ref: "rangeTo",
                modelValue: e.calendarInputTo,
                "onUpdate:modelValue": t[7] || (t[7] = (v) => e.calendarInputTo = v),
                class: "calendar-input",
                "manual-input": !1,
                "min-date": e.minDateTo,
                "max-date": e.maxDateTo,
                "disabled-dates": e.invalidDates,
                "disabled-days": [0, 6],
                onShow: t[8] || (t[8] = (v) => e.showCalendar("TO")),
                onHide: t[9] || (t[9] = (v) => e.hideCalendar("TO"))
              }, null, 8, ["modelValue", "min-date", "max-date", "disabled-dates"]),
              ue(l, {
                class: "p-button-icon-only p-button-rounded",
                "data-event_component_name": "Chart",
                "data-event_title": "Calendar | closed | TO",
                "data-event_source": e.dataEventSource,
                onClick: t[10] || (t[10] = It((v) => e.onCloseCalendar("rangeTo"), ["stop"]))
              }, {
                default: Se(() => t[14] || (t[14] = [
                  oe("i", { class: "las la-calendar p-button-icon" }, null, -1)
                ])),
                _: 1
              }, 8, ["data-event_source"])
            ])
          ])) : te("", !0),
          oe("button", {
            id: "calendarEventButton",
            "data-event_component_name": "Chart",
            "data-event_title": "Calendar opened",
            "data-event_source": e.dataEventSource
          }, " . ", 8, E4),
          oe("span", null, [
            rt((E(), fe(l, {
              "aria-label": e.calendarIsActive ? e.values?.calendarTooltipCloseText ? e.values?.calendarTooltipCloseText : e.$t("performanceChart.close") : e.values?.calendarTooltipText,
              class: "p-button-icon-only p-button-rounded performance-buttons-add p-cal-dl-buttons",
              "data-event_component_name": "Chart",
              "data-event_title": "Calendar opened",
              "data-event_source": e.dataEventSource,
              onClick: e.toggleCalendar,
              onMouseout: e.useDeselectButton,
              onTouchend: e.useDeselectButton
            }, {
              default: Se(() => [
                e.calendarIsActive ? (E(), X("span", {
                  key: 1,
                  class: "las la-calendar-times p-button-icon",
                  "data-event_component_name": "Chart",
                  "data-event_title": "Calendar opened",
                  "data-event_source": e.dataEventSource
                }, null, 8, R4)) : (E(), X("span", D4))
              ]),
              _: 1
            }, 8, ["aria-label", "data-event_source", "onClick", "onMouseout", "onTouchend"])), [
              [
                g,
                {
                  value: e.calendarIsActive ? e.values?.calendarTooltipCloseText ? e.values?.calendarTooltipCloseText : e.$t("performanceChart.close") : e.values?.calendarTooltipText
                },
                void 0,
                { top: !0 }
              ]
            ]),
            e.values.documents?.length ? rt((E(), fe(l, {
              key: 0,
              class: "p-button-icon-only p-button-rounded performance-buttons-add p-cal-dl-buttons dd-small",
              "aria-label": e.values.downloadTooltipText,
              onMouseout: e.useDeselectButton,
              onTouchend: e.useDeselectButton
            }, {
              default: Se(() => [
                ue(s, {
                  options: e.documents,
                  "option-label": "name",
                  "option-value": "name",
                  "empty-label": !0,
                  "loading-icon": "las la-download",
                  class: "documents-button p-button-icon",
                  downloadAnchorName: "",
                  downloadAnchorHref: "",
                  dataEventSource: e.dataEventSource,
                  eventComponentName: "Performance-Chart"
                }, {
                  option: Se((v) => [
                    oe("div", N4, [
                      oe("a", {
                        "data-event_component_name": "Chart",
                        "data-event_title": "Download | " + v.option.name,
                        "data-event_source": e.dataEventSource,
                        onClick: (P) => e.downloadItem(v.option.url)
                      }, Ie(v.option.name), 9, $4)
                    ])
                  ]),
                  _: 1
                }, 8, ["options", "dataEventSource"])
              ]),
              _: 1
            }, 8, ["aria-label", "onMouseout", "onTouchend"])), [
              [
                g,
                { value: e.values.downloadTooltipText },
                void 0,
                { top: !0 }
              ]
            ]) : te("", !0)
          ])
        ]),
        oe("div", F4, [
          oe("div", j4, [
            e.activeToggleButton === 0 ? (E(), X("div", H4, [
              oe("div", null, [
                oe("span", z4, [
                  ue(y, {
                    "html-text": e.footNoteParser(e.values.fundLabelText),
                    "disable-default-styling": ""
                  }, null, 8, ["html-text"])
                ]),
                t[15] || (t[15] = oe("br", null, null, -1)),
                ue(u, {
                  class: "performance-percent-number",
                  number: new Intl.NumberFormat(e.actualLanguage, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                  }).format(e.currentBenchmark.fund),
                  "add-percent": !0,
                  "percent-sign": e.values.percent
                }, null, 8, ["number", "percent-sign"])
              ]),
              e.currentBenchmark.bench !== null ? (E(), X("div", V4, [
                oe("span", G4, [
                  ue(y, {
                    "html-text": e.footNoteParser(e.values.benchmarkLabelText),
                    "disable-default-styling": ""
                  }, null, 8, ["html-text"])
                ]),
                t[16] || (t[16] = oe("br", null, null, -1)),
                ue(u, {
                  class: "performance-percent-number",
                  number: new Intl.NumberFormat(e.actualLanguage, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                  }).format(e.currentBenchmark.bench),
                  "add-percent": !0,
                  "percent-sign": e.values.percent
                }, null, 8, ["number", "percent-sign"])
              ])) : te("", !0)
            ])) : te("", !0)
          ]),
          oe("div", U4, [
            !(e.performanceDataPeriods && Object.keys(e.performanceDataPeriods).length === 0 && Object.getPrototypeOf(e.performanceDataPeriods) === Object.prototype) && e.performanceDataPeriods.ticker ? (E(), X("span", {
              key: 0,
              onClick: t[11] || (t[11] = (v) => e.showOrHideLegend(0))
            }, [
              oe("i", {
                class: "las la-minus text-xl",
                style: hn("color: " + e.colorPetrol45)
              }, null, 4),
              Ve(" " + Ie(e.performanceDataPeriods && Object.keys(e.performanceDataPeriods).length === 0 && Object.getPrototypeOf(e.performanceDataPeriods) === Object.prototype ? "" : e.performanceDataPeriods.ticker), 1)
            ])) : te("", !0),
            t[17] || (t[17] = oe("br", null, null, -1)),
            !(e.performanceDataPeriods && Object.keys(e.performanceDataPeriods).length === 0 && Object.getPrototypeOf(e.performanceDataPeriods) === Object.prototype) && e.performanceDataPeriods.indexNames[0] && e.activeToggleButton === 0 ? (E(), X("span", {
              key: 1,
              onClick: t[12] || (t[12] = (v) => e.showOrHideLegend(1))
            }, [
              oe("i", {
                class: "las la-ellipsis-h",
                style: hn("color: " + e.colorPurple40)
              }, null, 4),
              Ve(" " + Ie(e.performanceDataPeriods && Object.keys(e.performanceDataPeriods).length === 0 && Object.getPrototypeOf(e.performanceDataPeriods) === Object.prototype ? "" : e.performanceDataPeriods.indexNames[0]), 1)
            ])) : (E(), X("span", W4, " "))
          ])
        ]),
        oe("div", Y4, [
          ue(m, {
            ref: "highChart",
            options: e.chartOptions,
            "chart-type": "stockChart",
            height: "25rem"
          }, null, 8, ["options"])
        ]),
        oe("button", {
          id: "draggedNavigatorButton",
          "data-event_component_name": "Chart",
          "data-event_title": "Navigator",
          "data-event_source": e.dataEventSource
        }, " . ", 8, q4)
      ])) : te("", !0),
      ue(h, { values: e.values }, null, 8, ["values"]),
      (E(!0), X(Re, null, Ge(e.values?.disclaimerHtml, (v) => (E(), fe(c, {
        key: v,
        values: v.text,
        class: "xs:col-span-1 lg:col-span-2 mt-8",
        "number-column": e.numberColumn
      }, null, 8, ["values", "number-column"]))), 128))
    ])
  ]);
}
const mBe = /* @__PURE__ */ Fe(v4, [["render", K4]]);
const X4 = {
  baidu: "http://cang.baidu.com/do/add?iu=@u&it=@t",
  buffer: "https://bufferapp.com/add?text=@t&url=@u",
  email: "mailto:?subject=@t&body=@u%0D%0A@d",
  evernote: "https://www.evernote.com/clip.action?url=@u&title=@t",
  facebook: "https://www.facebook.com/sharer/sharer.php?u=@u&title=@t&description=@d&quote=@q&hashtag=@h",
  flipboard: "https://share.flipboard.com/bookmarklet/popout?v=2&url=@u&title=@t",
  hackernews: "https://news.ycombinator.com/submitlink?u=@u&t=@t",
  instapaper: "http://www.instapaper.com/edit?url=@u&title=@t&description=@d",
  line: "http://line.me/R/msg/text/?@t%0D%0A@u%0D%0A@d",
  linkedin: "https://www.linkedin.com/sharing/share-offsite/?url=@u",
  messenger: "fb-messenger://share/?link=@u",
  odnoklassniki: "https://connect.ok.ru/dk?st.cmd=WidgetSharePreview&st.shareUrl=@u&st.comments=@t",
  pinterest: "https://pinterest.com/pin/create/button/?url=@u&media=@m&description=@t",
  pocket: "https://getpocket.com/save?url=@u&title=@t",
  quora: "https://www.quora.com/share?url=@u&title=@t",
  reddit: "https://www.reddit.com/submit?url=@u&title=@t",
  skype: "https://web.skype.com/share?url=@t%0D%0A@u%0D%0A@d",
  sms: "sms:?body=@t%0D%0A@u%0D%0A@d",
  stumbleupon: "https://www.stumbleupon.com/submit?url=@u&title=@t",
  telegram: "https://t.me/share/url?url=@u&text=@t%0D%0A@d",
  tumblr: "https://www.tumblr.com/share/link?url=@u&name=@t&description=@d",
  twitter: "https://twitter.com/intent/tweet?text=@t&url=@u&hashtags=@h&via=@tu",
  x: "https://x.com/intent/post?text=@t&url=@u&hashtags=@h&via=@tu",
  viber: "viber://forward?text=@t%0D%0A@u%0D%0A@d",
  vk: "https://vk.com/share.php?url=@u&title=@t&image=@m&noparse=true",
  weibo: "http://service.weibo.com/share/share.php?url=@u&title=@t&pic=@m",
  whatsapp: "https://api.whatsapp.com/send?text=@t%0D%0A@u%0D%0A@d",
  wordpress: "https://wordpress.com/press-this.php?u=@u&t=@t&s=@d&i=@m",
  xing: "https://www.xing.com/social/share/spi?op=share&url=@u&title=@t",
  yammer: "https://www.yammer.com/messages/new?login=true&status=@t%0D%0A@u%0D%0A@d"
}, Uk = () => typeof window < "u", Z4 = (e, t) => {
  if (!Uk())
    return null;
  const n = window.innerWidth || document.documentElement.clientWidth || window.screenX, i = window.innerHeight || document.documentElement.clientHeight || window.screenY, o = n / window.screen.availWidth, a = (n - e) / 2 / o + (window.screenLeft !== void 0 ? window.screenLeft : window.screenX);
  return {
    top: (i - t) / 2 / o + (window.screenTop !== void 0 ? window.screenTop : window.screenY),
    left: a,
    width: e,
    height: t
  };
}, J4 = (e) => Object.entries(e).map(([t, n]) => n ? `${t}=${n}` : "").filter((t) => t).join(","), Q4 = (e) => {
  if (!Uk())
    return null;
  if (e.substring(0, 4) !== "http")
    return window.open(e, "_blank");
  const t = Z4(500, 500);
  return t ? window.open(e, "sharer", J4(t)) : null;
}, e5 = (e, t) => {
  const n = window.navigator.userAgent.toLowerCase();
  return e === "sms" && (n.includes("iphone") || n.includes("ipad")) ? t[e].replace(":?", ":&") : t[e];
}, t5 = (e, t) => t === "facebook" && e && e.length > 0 ? `%23${e.split(",")[0]}` : e, n5 = () => ({
  network: "",
  url: "",
  title: "",
  description: "",
  quote: "",
  hashtags: "",
  twitterUser: "",
  media: ""
}), i5 = (e) => {
  const t = n5();
  return Object.fromEntries(Object.keys(t).map((n) => {
    let i = RL(e[n]) || t[n];
    return i = n === "hashtags" ? t5(i, n) : encodeURIComponent(i), [n, i];
  }));
}, a5 = (e, t) => e.replace(/@tu/g, t.twitterUser).replace(/@u/g, t.url).replace(/@t/g, t.title).replace(/@d/g, t.description).replace(/@q/g, t.quote).replace(/@h/g, t.hashtags).replace(/@m/g, t.media), o5 = () => {
  const e = Object.assign({}, X4, $t("share-networks", {})), t = (n) => {
    const i = i5(n);
    if (!i.network || !e[i.network])
      throw new Error(`Network ${i.network} does not exist`);
    let o = e5(i.network, e);
    return i.network === "twitter" && (i.hashtags.length || (o = o.replace("&hashtags=@h", "")), i.twitterUser.length || (o = o.replace("&via=@tu", ""))), a5(o, i);
  };
  return { getSharingLink: t, shareLink: (n) => {
    const i = t(n);
    return Q4(i);
  } };
}, Wk = Be({
  props: {
    network: {
      type: String,
      required: !0
    },
    url: {
      type: String,
      default: ""
    },
    title: {
      type: String,
      default: ""
    },
    description: {
      type: String,
      default: ""
    },
    quote: {
      type: String,
      default: ""
    },
    hashtags: {
      type: String,
      default: ""
    },
    twitterUser: {
      type: String,
      default: ""
    },
    media: {
      type: String,
      default: ""
    }
  },
  setup(e, t) {
    const { shareLink: n } = o5();
    return () => t.slots.default ? t.slots.default({ share: () => n(e) }) : At("div", { onClick: () => n(e) }, "Share");
  }
}), r5 = {
  install(e, t = {}) {
    e.provide("share-networks", t.shareNetworks || {}), e.component("share-network", Wk);
  }
}, s5 = Be({
  name: "BreadcrumbMain",
  components: {
    PrimeButton: ki,
    PrimeDropdown: Ga
  },
  props: {
    breadcrumbs: {
      type: Object,
      required: !0
    },
    shareClassItems: {
      type: Object,
      default: null
    },
    currentShareClassLabel: {
      type: String,
      required: !0
    },
    shareClassSelectLabel: {
      type: String,
      required: !0
    },
    valuesMain: {
      type: Object,
      required: !0,
      default: null
    },
    metaTags: {
      type: Object,
      required: !0
    }
  },
  emits: ["print"],
  data() {
    return {
      dataComponentName: "Breadcrumb",
      selectedValue: null,
      hideShareButtons: !0,
      selectedShareClass: this.currentShareClassLabel,
      truncateLimit: 25
    };
  },
  computed: {
    shareClassItemsWithoutSelected() {
      return this.shareClassItems.filter(
        (e) => e.name !== this.currentShareClassLabel
      );
    },
    shareClassLast() {
      return typeof InstallTrigger < "u" ? "" : "shareClassLast";
    }
  },
  watch: {
    selectedShareClass: function() {
      Ue && window.open(this.selectedShareClass.url, "_self");
    }
  },
  async mounted() {
    await mt(), this.breadCrumbScrollRight();
    const e = this.$refs.shareClassDropdownButton;
    e && e.setAttribute("hidden", "hidden");
  },
  created() {
    const { pageName: e } = Qe();
    this.dataEventSource = e;
  },
  methods: {
    truncate(e, t) {
      return e.length > t ? e.substring(0, t) + "..." : e;
    },
    async breadCrumbScrollRight() {
      await mt();
      const e = this.$refs.breadcrumbItems, t = e?.scrollWidth;
      e?.scrollLeft !== t && e?.scrollTo({
        left: t,
        behavior: "smooth"
      });
    },
    showPrintDialog() {
      this.$emit("print");
    },
    onEsc(e) {
      e.preventDefault(), this.$refs.shareClassesRef.toggle(e), Ue && document.querySelector(".share-class-btn").focus();
    },
    getShareUrl() {
      return Ue ? window.location.href : "";
    },
    showDropDown() {
      const e = this.$refs.shareClassDropdownButton;
      return e && (e.removeAttribute("hidden"), e.click(), e.setAttribute("hidden", "hidden")), !0;
    },
    isRedirectedToChildPage(e, t) {
      return this.breadcrumbs.length <= t + 1 ? !1 : e.link === this.breadcrumbs[t + 1].link;
    }
  }
}), l5 = { class: "breadcrumb" }, c5 = {
  ref: "breadcrumbItems",
  class: "breadcrumb__items"
}, d5 = {
  key: 0,
  class: "not-link"
}, u5 = ["href", "data-event_source", "data-event_component_name", "data-event_title", "data-event_target"], h5 = {
  key: 2,
  class: "not-link"
}, p5 = {
  key: 3,
  class: "las la-angle-right"
}, f5 = ["aria-label", "data-event_source"], m5 = { class: "flex flex-row share-buttons" };
function g5(e, t, n, i, o, a) {
  const r = $e("PrimeDropdown"), s = $e("PrimeButton"), l = $e("ShareNetwork"), d = Ut("tooltip");
  return E(), X("div", l5, [
    t[4] || (t[4] = oe("div", { class: "left-gradient" }, null, -1)),
    t[5] || (t[5] = oe("div", { class: "right-gradient" }, null, -1)),
    oe("ul", c5, [
      (E(!0), X(Re, null, Ge(e.breadcrumbs, (y, u) => (E(), X("li", { key: u }, [
        y.link.length < 1 ? (E(), X("span", d5, Ie(y.name), 1)) : te("", !0),
        y.link.length >= 1 && !e.isRedirectedToChildPage(y, u) ? (E(), X("a", {
          key: 1,
          class: Pe({ "item-bold": u == e.breadcrumbs.length - 1 }),
          href: y.link,
          "data-event_source": e.dataEventSource,
          "data-event_component_name": e.dataComponentName,
          "data-event_title": y.name,
          "data-event_target": y.link
        }, [
          u == e.breadcrumbs.length - 1 ? (E(), X(Re, { key: 0 }, [
            Ve(Ie(e.truncate(y.name, e.truncateLimit)), 1)
          ], 64)) : (E(), X(Re, { key: 1 }, [
            Ve(Ie(y.name), 1)
          ], 64))
        ], 10, u5)) : te("", !0),
        e.isRedirectedToChildPage(y, u) ? (E(), X("span", h5, Ie(y.name), 1)) : te("", !0),
        u !== e.breadcrumbs.length - 1 ? (E(), X("i", p5)) : te("", !0)
      ]))), 128)),
      e.shareClassItems?.length > 0 ? (E(), X(Re, { key: 0 }, [
        t[3] || (t[3] = oe("li", null, [
          oe("span", { class: "border-right" })
        ], -1)),
        oe("li", {
          class: Pe(e.shareClassLast)
        }, [
          ue(r, {
            modelValue: e.selectedShareClass,
            "onUpdate:modelValue": t[0] || (t[0] = (y) => e.selectedShareClass = y),
            options: e.shareClassItemsWithoutSelected,
            "option-label": "name",
            "panel-class": "d-dws-dropdown-simple",
            placeholder: e.shareClassSelectLabel ? e.shareClassSelectLabel : "Anteilsklasse",
            class: "share-class-dropdown",
            onBeforeShow: e.showDropDown
          }, null, 8, ["modelValue", "options", "placeholder", "onBeforeShow"]),
          oe("button", {
            ref: "shareClassDropdownButton",
            "aria-label": e.$t("breadcrumb.shareButton"),
            "data-event_component_name": "Breadcrumb",
            "data-event_title": "Share class",
            "data-event_source": e.dataEventSource
          }, null, 8, f5)
        ], 2)
      ], 64)) : (E(), X(Re, { key: 1 }, [], 64))
    ], 512),
    e.metaTags ? (E(), X("div", {
      key: 0,
      class: Pe(["breadcrumb__buttons gap-x-2", e.hideShareButtons ? "" : "over-items"])
    }, [
      oe("ul", null, [
        oe("li", null, [
          oe("div", {
            class: Pe(["social-bar__wrapper", e.hideShareButtons ? "" : "active"])
          }, [
            oe("div", m5, [
              ue(l, {
                network: "linkedin",
                url: e.metaTags.ogUrl,
                title: e.metaTags.metaTitleWithFallbackAndSuffix,
                tabindex: -1
              }, {
                default: Se(() => [
                  ue(s, {
                    "data-event_source": e.dataEventSource,
                    "data-event_component_name": "Exit Links",
                    "data-event_title": "linkedin",
                    "aria-label": "linkedin",
                    icon: "lab la-linkedin",
                    class: "p-button-rounded p-button-secondary"
                  }, null, 8, ["data-event_source"])
                ]),
                _: 1
              }, 8, ["url", "title"]),
              ue(l, {
                network: "twitter",
                url: e.metaTags.twitterUrl,
                title: e.metaTags.metaTitleWithFallbackAndSuffix,
                description: e.metaTags.twitterDescription,
                hashtags: e.metaTags.metaKeywords,
                tabindex: -1
              }, {
                default: Se(() => [
                  ue(s, {
                    "data-event_source": e.dataEventSource,
                    "data-event_component_name": "Exit Links",
                    "data-event_title": "twitter",
                    "aria-label": "twitter",
                    icon: "lab la-twitter",
                    class: "p-button-rounded p-button-secondary"
                  }, null, 8, ["data-event_source"])
                ]),
                _: 1
              }, 8, ["url", "title", "description", "hashtags"]),
              ue(l, {
                network: "facebook",
                url: e.metaTags.ogUrl,
                title: e.metaTags.metaTitleWithFallbackAndSuffix,
                description: e.metaTags.ogDescription,
                hashtags: e.metaTags.metaKeywords,
                quote: e.metaTags.ogDescription,
                tabindex: -1
              }, {
                default: Se(() => [
                  ue(s, {
                    "data-event_source": e.dataEventSource,
                    "data-event_component_name": "Exit Links",
                    "data-event_title": "facebook",
                    "aria-label": "facebook",
                    icon: "lab la-facebook-f",
                    class: "p-button-rounded p-button-secondary"
                  }, null, 8, ["data-event_source"])
                ]),
                _: 1
              }, 8, ["url", "title", "description", "hashtags", "quote"]),
              ue(l, {
                network: "xing",
                url: e.metaTags.ogUrl,
                title: e.metaTags.metaTitleWithFallbackAndSuffix,
                tabindex: -1
              }, {
                default: Se(() => [
                  ue(s, {
                    "data-event_source": e.dataEventSource,
                    "data-event_component_name": "Exit Links",
                    "data-event_title": "xing",
                    "aria-label": "xing",
                    icon: "lab la-xing",
                    class: "p-button-rounded p-button-secondary"
                  }, null, 8, ["data-event_source"])
                ]),
                _: 1
              }, 8, ["url", "title"]),
              ue(l, {
                network: "email",
                url: e.getShareUrl(),
                title: e.metaTags.metaTitleWithFallbackAndSuffix,
                description: e.metaTags.ogDescription,
                tabindex: -1
              }, {
                default: Se(() => [
                  ue(s, {
                    "data-event_source": e.dataEventSource,
                    "data-event_component_name": "Exit Links",
                    "data-event_title": "email",
                    "aria-label": e.$t("breadcrumb.email"),
                    icon: "lar la-envelope",
                    class: "p-button-rounded p-button-secondary"
                  }, null, 8, ["data-event_source", "aria-label"])
                ]),
                _: 1
              }, 8, ["url", "title", "description"])
            ])
          ], 2)
        ]),
        oe("li", null, [
          e.metaTags ? rt((E(), fe(s, {
            key: 0,
            "data-event_source": e.dataEventSource,
            "data-event_component_name": "Text Links (same page)",
            "data-event_title": "Share",
            icon: "la la-lg la-share",
            class: Pe([{ "button-active": !e.hideShareButtons }, "p-button-rounded p-button-secondary"]),
            "aria-label": e.valuesMain?.tooltipTextShare,
            onClick: t[1] || (t[1] = (y) => e.hideShareButtons = !e.hideShareButtons)
          }, null, 8, ["data-event_source", "class", "aria-label"])), [
            [
              d,
              e.valuesMain?.tooltipTextShare,
              void 0,
              { top: !0 }
            ]
          ]) : te("", !0),
          rt(ue(s, {
            "data-event_source": e.dataEventSource,
            "data-event_component_name": "Text Links (same page)",
            "data-event_title": "Print",
            icon: "la la-lg la-print",
            class: "p-button-rounded p-button-secondary",
            "aria-label": e.valuesMain?.tooltipTextPrint,
            onClick: t[2] || (t[2] = (y) => e.showPrintDialog())
          }, null, 8, ["data-event_source", "aria-label"]), [
            [
              d,
              e.valuesMain?.tooltipTextPrint,
              void 0,
              { top: !0 }
            ]
          ])
        ])
      ])
    ], 2)) : te("", !0)
  ]);
}
const gBe = /* @__PURE__ */ Fe(s5, [["render", g5]]);
function Uy(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    t && (i = i.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), n.push.apply(n, i);
  }
  return n;
}
function uc(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Uy(Object(n), !0).forEach(function(i) {
      v5(e, i, n[i]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Uy(Object(n)).forEach(function(i) {
      Object.defineProperty(e, i, Object.getOwnPropertyDescriptor(n, i));
    });
  }
  return e;
}
function v5(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function vu(e) {
  return typeof e == "function";
}
function uf(e) {
  return e !== null && typeof e == "object" && !Array.isArray(e);
}
function nh(e) {
  return vu(e.$validator) ? uc({}, e) : {
    $validator: e
  };
}
function Yk(e) {
  return typeof e == "object" ? e.$valid : e;
}
function qk(e) {
  return e.$validator || e;
}
function y5(e, t) {
  if (!uf(e))
    throw new Error(`[@vuelidate/validators]: First parameter to "withParams" should be an object, provided ${typeof e}`);
  if (!uf(t) && !vu(t))
    throw new Error("[@vuelidate/validators]: Validator must be a function or object with $validator parameter");
  const n = nh(t);
  return n.$params = uc(uc({}, n.$params || {}), e), n;
}
function b5(e, t) {
  if (!vu(e) && typeof _(e) != "string")
    throw new Error(`[@vuelidate/validators]: First parameter to "withMessage" should be string or a function returning a string, provided ${typeof e}`);
  if (!uf(t) && !vu(t))
    throw new Error("[@vuelidate/validators]: Validator must be a function or object with $validator parameter");
  const n = nh(t);
  return n.$message = e, n;
}
function x5(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
  const n = nh(e);
  return uc(uc({}, n), {}, {
    $async: !0,
    $watchTargets: t
  });
}
function w5(e) {
  return {
    $validator(t) {
      for (var n = arguments.length, i = new Array(n > 1 ? n - 1 : 0), o = 1; o < n; o++)
        i[o - 1] = arguments[o];
      return _(t).reduce((a, r, s) => {
        const l = Object.entries(r).reduce((d, y) => {
          let [u, m] = y;
          const h = e[u] || {}, c = Object.entries(h).reduce((g, v) => {
            let [P, f] = v;
            const w = qk(f).call(this, m, r, s, ...i), x = Yk(w);
            if (g.$data[P] = w, g.$data.$invalid = !x || !!g.$data.$invalid, g.$data.$error = g.$data.$invalid, !x) {
              let k = f.$message || "";
              const A = f.$params || {};
              typeof k == "function" && (k = k({
                $pending: !1,
                $invalid: !x,
                $params: A,
                $model: m,
                $response: w
              })), g.$errors.push({
                $property: u,
                $message: k,
                $params: A,
                $response: w,
                $model: m,
                $pending: !1,
                $validator: P
              });
            }
            return {
              $valid: g.$valid && x,
              $data: g.$data,
              $errors: g.$errors
            };
          }, {
            $valid: !0,
            $data: {},
            $errors: []
          });
          return d.$data[u] = c.$data, d.$errors[u] = c.$errors, {
            $valid: d.$valid && c.$valid,
            $data: d.$data,
            $errors: d.$errors
          };
        }, {
          $valid: !0,
          $data: {},
          $errors: {}
        });
        return {
          $valid: a.$valid && l.$valid,
          $data: a.$data.concat(l.$data),
          $errors: a.$errors.concat(l.$errors)
        };
      }, {
        $valid: !0,
        $data: [],
        $errors: []
      });
    },
    $message: (t) => {
      let {
        $response: n
      } = t;
      return n ? n.$errors.map((i) => Object.values(i).map((o) => o.map((a) => a.$message)).reduce((o, a) => o.concat(a), [])) : [];
    }
  };
}
const ih = (e) => {
  if (e = _(e), Array.isArray(e))
    return !!e.length;
  if (e == null)
    return !1;
  if (e === !1)
    return !0;
  if (e instanceof Date)
    return !isNaN(e.getTime());
  if (typeof e == "object") {
    for (let t in e)
      return !0;
    return !1;
  }
  return !!String(e).length;
}, Kk = (e) => (e = _(e), Array.isArray(e) ? e.length : typeof e == "object" ? Object.keys(e).length : String(e).length);
function Go() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  return (i) => (i = _(i), !ih(i) || t.every((o) => (o.lastIndex = 0, o.test(i))));
}
var Ri = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  forEach: w5,
  len: Kk,
  normalizeValidatorObject: nh,
  regex: Go,
  req: ih,
  unwrap: _,
  unwrapNormalizedValidator: qk,
  unwrapValidatorResponse: Yk,
  withAsync: x5,
  withMessage: b5,
  withParams: y5
});
Go(/^[a-zA-Z]*$/);
Go(/^[a-zA-Z0-9]*$/);
var k5 = Go(/^\d*(\.\d+)?$/), S5 = {
  $validator: k5,
  $message: "Value must be numeric",
  $params: {
    type: "numeric"
  }
};
const C5 = /^(?:[A-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[A-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9]{2,}(?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/i;
Go(C5);
function T5(e) {
  return (t) => !ih(t) || Kk(t) >= _(e);
}
function kd(e) {
  return {
    $validator: T5(e),
    $message: (t) => {
      let {
        $params: n
      } = t;
      return `This field should be at least ${n.min} characters long`;
    },
    $params: {
      min: e,
      type: "minLength"
    }
  };
}
function L5(e) {
  return typeof e == "string" && (e = e.trim()), ih(e);
}
var yi = {
  $validator: L5,
  $message: "Value is required",
  $params: {
    type: "required"
  }
};
function I5(e) {
  return (t) => _(t) === _(e);
}
function P5(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "other";
  return {
    $validator: I5(e),
    $message: (n) => `The value must be equal to the ${t} value`,
    $params: {
      equalTo: e,
      otherName: t,
      type: "sameAs"
    }
  };
}
const A5 = /^(?:(?:(?:https?|ftp):)?\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z0-9\u00a1-\uffff][a-z0-9\u00a1-\uffff_-]{0,62})?[a-z0-9\u00a1-\uffff]\.)+(?:[a-z\u00a1-\uffff]{2,}\.?))(?::\d{2,5})?(?:[/?#]\S*)?$/i;
Go(A5);
Go(/(^[0-9]*$)|(^-[0-9]+$)/);
Go(/^[-]?\d*(\.\d+)?$/);
var yu = {
  name: "ExclamationTriangleIcon",
  extends: Yt,
  computed: {
    pathId: function() {
      return "pv_icon_clip_".concat(Mt());
    }
  }
}, _5 = ["clip-path"], M5 = /* @__PURE__ */ oe("path", {
  d: "M13.4018 13.1893H0.598161C0.49329 13.189 0.390283 13.1615 0.299143 13.1097C0.208003 13.0578 0.131826 12.9832 0.0780112 12.8932C0.0268539 12.8015 0 12.6982 0 12.5931C0 12.4881 0.0268539 12.3848 0.0780112 12.293L6.47985 1.08982C6.53679 1.00399 6.61408 0.933574 6.70484 0.884867C6.7956 0.836159 6.897 0.810669 7 0.810669C7.103 0.810669 7.2044 0.836159 7.29516 0.884867C7.38592 0.933574 7.46321 1.00399 7.52015 1.08982L13.922 12.293C13.9731 12.3848 14 12.4881 14 12.5931C14 12.6982 13.9731 12.8015 13.922 12.8932C13.8682 12.9832 13.792 13.0578 13.7009 13.1097C13.6097 13.1615 13.5067 13.189 13.4018 13.1893ZM1.63046 11.989H12.3695L7 2.59425L1.63046 11.989Z",
  fill: "currentColor"
}, null, -1), O5 = /* @__PURE__ */ oe("path", {
  d: "M6.99996 8.78801C6.84143 8.78594 6.68997 8.72204 6.57787 8.60993C6.46576 8.49782 6.40186 8.34637 6.39979 8.18784V5.38703C6.39979 5.22786 6.46302 5.0752 6.57557 4.96265C6.68813 4.85009 6.84078 4.78686 6.99996 4.78686C7.15914 4.78686 7.31179 4.85009 7.42435 4.96265C7.5369 5.0752 7.60013 5.22786 7.60013 5.38703V8.18784C7.59806 8.34637 7.53416 8.49782 7.42205 8.60993C7.30995 8.72204 7.15849 8.78594 6.99996 8.78801Z",
  fill: "currentColor"
}, null, -1), B5 = /* @__PURE__ */ oe("path", {
  d: "M6.99996 11.1887C6.84143 11.1866 6.68997 11.1227 6.57787 11.0106C6.46576 10.8985 6.40186 10.7471 6.39979 10.5885V10.1884C6.39979 10.0292 6.46302 9.87658 6.57557 9.76403C6.68813 9.65147 6.84078 9.58824 6.99996 9.58824C7.15914 9.58824 7.31179 9.65147 7.42435 9.76403C7.5369 9.87658 7.60013 10.0292 7.60013 10.1884V10.5885C7.59806 10.7471 7.53416 10.8985 7.42205 11.0106C7.30995 11.1227 7.15849 11.1866 6.99996 11.1887Z",
  fill: "currentColor"
}, null, -1), E5 = [M5, O5, B5], D5 = ["id"], R5 = /* @__PURE__ */ oe("rect", {
  width: "14",
  height: "14",
  fill: "white"
}, null, -1), N5 = [R5];
function $5(e, t, n, i, o, a) {
  return E(), X("svg", Ce({
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.pti()), [oe("g", {
    "clip-path": "url(#".concat(a.pathId, ")")
  }, E5, 8, _5), oe("defs", null, [oe("clipPath", {
    id: "".concat(a.pathId)
  }, N5, 8, D5)])], 16);
}
yu.render = $5;
var bu = {
  name: "InfoCircleIcon",
  extends: Yt,
  computed: {
    pathId: function() {
      return "pv_icon_clip_".concat(Mt());
    }
  }
}, F5 = ["clip-path"], j5 = /* @__PURE__ */ oe("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M3.11101 12.8203C4.26215 13.5895 5.61553 14 7 14C8.85652 14 10.637 13.2625 11.9497 11.9497C13.2625 10.637 14 8.85652 14 7C14 5.61553 13.5895 4.26215 12.8203 3.11101C12.0511 1.95987 10.9579 1.06266 9.67879 0.532846C8.3997 0.00303296 6.99224 -0.13559 5.63437 0.134506C4.2765 0.404603 3.02922 1.07129 2.05026 2.05026C1.07129 3.02922 0.404603 4.2765 0.134506 5.63437C-0.13559 6.99224 0.00303296 8.3997 0.532846 9.67879C1.06266 10.9579 1.95987 12.0511 3.11101 12.8203ZM3.75918 2.14976C4.71846 1.50879 5.84628 1.16667 7 1.16667C8.5471 1.16667 10.0308 1.78125 11.1248 2.87521C12.2188 3.96918 12.8333 5.45291 12.8333 7C12.8333 8.15373 12.4912 9.28154 11.8502 10.2408C11.2093 11.2001 10.2982 11.9478 9.23232 12.3893C8.16642 12.8308 6.99353 12.9463 5.86198 12.7212C4.73042 12.4962 3.69102 11.9406 2.87521 11.1248C2.05941 10.309 1.50384 9.26958 1.27876 8.13803C1.05367 7.00647 1.16919 5.83358 1.61071 4.76768C2.05222 3.70178 2.79989 2.79074 3.75918 2.14976ZM7.00002 4.8611C6.84594 4.85908 6.69873 4.79698 6.58977 4.68801C6.48081 4.57905 6.4187 4.43185 6.41669 4.27776V3.88888C6.41669 3.73417 6.47815 3.58579 6.58754 3.4764C6.69694 3.367 6.84531 3.30554 7.00002 3.30554C7.15473 3.30554 7.3031 3.367 7.4125 3.4764C7.52189 3.58579 7.58335 3.73417 7.58335 3.88888V4.27776C7.58134 4.43185 7.51923 4.57905 7.41027 4.68801C7.30131 4.79698 7.1541 4.85908 7.00002 4.8611ZM7.00002 10.6945C6.84594 10.6925 6.69873 10.6304 6.58977 10.5214C6.48081 10.4124 6.4187 10.2652 6.41669 10.1111V6.22225C6.41669 6.06754 6.47815 5.91917 6.58754 5.80977C6.69694 5.70037 6.84531 5.63892 7.00002 5.63892C7.15473 5.63892 7.3031 5.70037 7.4125 5.80977C7.52189 5.91917 7.58335 6.06754 7.58335 6.22225V10.1111C7.58134 10.2652 7.51923 10.4124 7.41027 10.5214C7.30131 10.6304 7.1541 10.6925 7.00002 10.6945Z",
  fill: "currentColor"
}, null, -1), H5 = [j5], z5 = ["id"], V5 = /* @__PURE__ */ oe("rect", {
  width: "14",
  height: "14",
  fill: "white"
}, null, -1), G5 = [V5];
function U5(e, t, n, i, o, a) {
  return E(), X("svg", Ce({
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.pti()), [oe("g", {
    "clip-path": "url(#".concat(a.pathId, ")")
  }, H5, 8, F5), oe("defs", null, [oe("clipPath", {
    id: "".concat(a.pathId)
  }, G5, 8, z5)])], 16);
}
bu.render = U5;
var hc = {
  name: "TimesCircleIcon",
  extends: Yt,
  computed: {
    pathId: function() {
      return "pv_icon_clip_".concat(Mt());
    }
  }
}, W5 = ["clip-path"], Y5 = /* @__PURE__ */ oe("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M7 14C5.61553 14 4.26215 13.5895 3.11101 12.8203C1.95987 12.0511 1.06266 10.9579 0.532846 9.67879C0.00303296 8.3997 -0.13559 6.99224 0.134506 5.63437C0.404603 4.2765 1.07129 3.02922 2.05026 2.05026C3.02922 1.07129 4.2765 0.404603 5.63437 0.134506C6.99224 -0.13559 8.3997 0.00303296 9.67879 0.532846C10.9579 1.06266 12.0511 1.95987 12.8203 3.11101C13.5895 4.26215 14 5.61553 14 7C14 8.85652 13.2625 10.637 11.9497 11.9497C10.637 13.2625 8.85652 14 7 14ZM7 1.16667C5.84628 1.16667 4.71846 1.50879 3.75918 2.14976C2.79989 2.79074 2.05222 3.70178 1.61071 4.76768C1.16919 5.83358 1.05367 7.00647 1.27876 8.13803C1.50384 9.26958 2.05941 10.309 2.87521 11.1248C3.69102 11.9406 4.73042 12.4962 5.86198 12.7212C6.99353 12.9463 8.16642 12.8308 9.23232 12.3893C10.2982 11.9478 11.2093 11.2001 11.8502 10.2408C12.4912 9.28154 12.8333 8.15373 12.8333 7C12.8333 5.45291 12.2188 3.96918 11.1248 2.87521C10.0308 1.78125 8.5471 1.16667 7 1.16667ZM4.66662 9.91668C4.58998 9.91704 4.51404 9.90209 4.44325 9.87271C4.37246 9.84333 4.30826 9.8001 4.2544 9.74557C4.14516 9.6362 4.0838 9.48793 4.0838 9.33335C4.0838 9.17876 4.14516 9.0305 4.2544 8.92113L6.17553 7L4.25443 5.07891C4.15139 4.96832 4.09529 4.82207 4.09796 4.67094C4.10063 4.51982 4.16185 4.37563 4.26872 4.26876C4.3756 4.16188 4.51979 4.10066 4.67091 4.09799C4.82204 4.09532 4.96829 4.15142 5.07887 4.25446L6.99997 6.17556L8.92106 4.25446C9.03164 4.15142 9.1779 4.09532 9.32903 4.09799C9.48015 4.10066 9.62434 4.16188 9.73121 4.26876C9.83809 4.37563 9.89931 4.51982 9.90198 4.67094C9.90464 4.82207 9.84855 4.96832 9.74551 5.07891L7.82441 7L9.74554 8.92113C9.85478 9.0305 9.91614 9.17876 9.91614 9.33335C9.91614 9.48793 9.85478 9.6362 9.74554 9.74557C9.69168 9.8001 9.62748 9.84333 9.55669 9.87271C9.4859 9.90209 9.40996 9.91704 9.33332 9.91668C9.25668 9.91704 9.18073 9.90209 9.10995 9.87271C9.03916 9.84333 8.97495 9.8001 8.9211 9.74557L6.99997 7.82444L5.07884 9.74557C5.02499 9.8001 4.96078 9.84333 4.88999 9.87271C4.81921 9.90209 4.74326 9.91704 4.66662 9.91668Z",
  fill: "currentColor"
}, null, -1), q5 = [Y5], K5 = ["id"], X5 = /* @__PURE__ */ oe("rect", {
  width: "14",
  height: "14",
  fill: "white"
}, null, -1), Z5 = [X5];
function J5(e, t, n, i, o, a) {
  return E(), X("svg", Ce({
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.pti()), [oe("g", {
    "clip-path": "url(#".concat(a.pathId, ")")
  }, q5, 8, W5), oe("defs", null, [oe("clipPath", {
    id: "".concat(a.pathId)
  }, Z5, 8, K5)])], 16);
}
hc.render = J5;
var Q5 = `
@layer primevue {
    .p-inline-message {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        vertical-align: top;
    }
    
    .p-inline-message-icon {
        flex-shrink: 0;
    }

    .p-inline-message-icon-only .p-inline-message-text {
        visibility: hidden;
        width: 0;
    }

    .p-fluid .p-inline-message {
        display: flex;
    }
}
`, eF = {
  root: function(t) {
    var n = t.props, i = t.instance;
    return ["p-inline-message p-component p-inline-message-" + n.severity, {
      "p-inline-message-icon-only": !i.$slots.default
    }];
  },
  icon: function(t) {
    var n = t.props;
    return ["p-inline-message-icon", n.icon];
  },
  text: "p-inline-message-text"
}, tF = Wt.extend({
  name: "inlinemessage",
  css: Q5,
  classes: eF
}), nF = {
  name: "BaseInlineMessage",
  extends: wt,
  props: {
    severity: {
      type: String,
      default: "error"
    },
    icon: {
      type: String,
      default: void 0
    }
  },
  style: tF,
  provide: function() {
    return {
      $parentInstance: this
    };
  }
}, Xk = {
  name: "InlineMessage",
  extends: nF,
  timeout: null,
  data: function() {
    return {
      visible: !0
    };
  },
  mounted: function() {
    var t = this;
    this.sticky || setTimeout(function() {
      t.visible = !1;
    }, this.life);
  },
  computed: {
    iconComponent: function() {
      return {
        info: bu,
        success: Oa,
        warn: yu,
        error: hc
      }[this.severity];
    }
  }
};
function iF(e, t, n, i, o, a) {
  return E(), X("div", Ce({
    role: "alert",
    "aria-live": "assertive",
    "aria-atomic": "true",
    class: e.cx("root")
  }, e.ptm("root")), [je(e.$slots, "icon", {}, function() {
    return [(E(), fe(tt(e.icon ? "span" : a.iconComponent), Ce({
      class: e.cx("icon")
    }, e.ptm("icon")), null, 16, ["class"]))];
  }), oe("span", Ce({
    class: e.cx("text")
  }, e.ptm("text")), [je(e.$slots, "default", {}, function() {
    return [Ve(" ")];
  })], 16)], 16);
}
Xk.render = iF;
var aF = {
  root: function(t) {
    var n = t.instance, i = t.props;
    return ["p-radiobutton p-component", {
      "p-radiobutton-checked": n.checked,
      "p-radiobutton-disabled": i.disabled,
      "p-radiobutton-focused": n.focused
    }];
  },
  input: function(t) {
    var n = t.instance, i = t.props;
    return ["p-radiobutton-box", {
      "p-highlight": n.checked,
      "p-disabled": i.disabled,
      "p-focus": n.focused
    }];
  },
  icon: "p-radiobutton-icon"
}, oF = Wt.extend({
  name: "radiobutton",
  classes: aF
}), rF = {
  name: "BaseRadioButton",
  extends: wt,
  props: {
    value: null,
    modelValue: null,
    name: {
      type: String,
      default: null
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    inputId: {
      type: String,
      default: null
    },
    inputClass: {
      type: [String, Object],
      default: null
    },
    inputStyle: {
      type: Object,
      default: null
    },
    inputProps: {
      type: null,
      default: null
    },
    ariaLabelledby: {
      type: String,
      default: null
    },
    ariaLabel: {
      type: String,
      default: null
    }
  },
  style: oF,
  provide: function() {
    return {
      $parentInstance: this
    };
  }
}, Or = {
  name: "RadioButton",
  extends: rF,
  emits: ["click", "update:modelValue", "change", "focus", "blur"],
  data: function() {
    return {
      focused: !1
    };
  },
  methods: {
    onClick: function(t) {
      this.disabled || (this.$emit("click", t), this.$emit("update:modelValue", this.value), this.$refs.input.focus(), this.checked || this.$emit("change", t));
    },
    onFocus: function(t) {
      this.focused = !0, this.$emit("focus", t);
    },
    onBlur: function(t) {
      this.focused = !1, this.$emit("blur", t);
    }
  },
  computed: {
    checked: function() {
      return this.modelValue != null && We.equals(this.modelValue, this.value);
    }
  }
};
function pc(e) {
  "@babel/helpers - typeof";
  return pc = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, pc(e);
}
function Wy(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    t && (i = i.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), n.push.apply(n, i);
  }
  return n;
}
function Yy(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Wy(Object(n), !0).forEach(function(i) {
      sF(e, i, n[i]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Wy(Object(n)).forEach(function(i) {
      Object.defineProperty(e, i, Object.getOwnPropertyDescriptor(n, i));
    });
  }
  return e;
}
function sF(e, t, n) {
  return t = lF(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function lF(e) {
  var t = cF(e, "string");
  return pc(t) == "symbol" ? t : String(t);
}
function cF(e, t) {
  if (pc(e) != "object" || !e)
    return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var i = n.call(e, t || "default");
    if (pc(i) != "object")
      return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var dF = ["id", "name", "checked", "disabled", "value", "aria-labelledby", "aria-label"], uF = ["data-p-highlight", "data-p-disabled", "data-p-focused"];
function hF(e, t, n, i, o, a) {
  return E(), X("div", Ce({
    class: e.cx("root"),
    onClick: t[2] || (t[2] = function(r) {
      return a.onClick(r);
    })
  }, e.ptm("root"), {
    "data-pc-name": "radiobutton"
  }), [oe("div", Ce({
    class: "p-hidden-accessible"
  }, e.ptm("hiddenInputWrapper"), {
    "data-p-hidden-accessible": !0
  }), [oe("input", Ce({
    ref: "input",
    id: e.inputId,
    type: "radio",
    name: e.name,
    checked: a.checked,
    disabled: e.disabled,
    value: e.value,
    "aria-labelledby": e.ariaLabelledby,
    "aria-label": e.ariaLabel,
    onFocus: t[0] || (t[0] = function() {
      return a.onFocus && a.onFocus.apply(a, arguments);
    }),
    onBlur: t[1] || (t[1] = function() {
      return a.onBlur && a.onBlur.apply(a, arguments);
    })
  }, e.ptm("hiddenInput")), null, 16, dF)], 16), oe("div", Ce({
    ref: "box",
    class: [e.cx("input"), e.inputClass],
    style: e.inputStyle
  }, Yy(Yy({}, e.inputProps), e.ptm("input")), {
    "data-p-highlight": a.checked,
    "data-p-disabled": e.disabled,
    "data-p-focused": o.focused
  }), [oe("div", Ce({
    class: e.cx("icon")
  }, e.ptm("icon")), null, 16)], 16, uF)], 16);
}
Or.render = hF;
function qy(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    t && (i = i.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), n.push.apply(n, i);
  }
  return n;
}
function To(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? qy(Object(n), !0).forEach(function(i) {
      pF(e, i, n[i]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : qy(Object(n)).forEach(function(i) {
      Object.defineProperty(e, i, Object.getOwnPropertyDescriptor(n, i));
    });
  }
  return e;
}
function pF(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function Ky(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
  return Object.keys(e).reduce((n, i) => (t.includes(i) || (n[i] = _(e[i])), n), {});
}
function xu(e) {
  return typeof e == "function";
}
function fF(e) {
  return wr(e) || NL(e);
}
function Zk(e, t, n) {
  let i = e;
  const o = t.split(".");
  for (let a = 0; a < o.length; a++) {
    if (!i[o[a]])
      return n;
    i = i[o[a]];
  }
  return i;
}
function pp(e, t, n) {
  return Te(() => e.some((i) => Zk(t, i, {
    [n]: !1
  })[n]));
}
function Xy(e, t, n) {
  return Te(() => e.reduce((i, o) => {
    const a = Zk(t, o, {
      [n]: !1
    })[n] || [];
    return i.concat(a);
  }, []));
}
function Jk(e, t, n, i) {
  return e.call(i, _(t), _(n), i);
}
function Qk(e) {
  return e.$valid !== void 0 ? !e.$valid : !e;
}
function mF(e, t, n, i, o, a, r) {
  let {
    $lazy: s,
    $rewardEarly: l
  } = o, d = arguments.length > 7 && arguments[7] !== void 0 ? arguments[7] : [], y = arguments.length > 8 ? arguments[8] : void 0, u = arguments.length > 9 ? arguments[9] : void 0, m = arguments.length > 10 ? arguments[10] : void 0;
  const h = ge(!!i.value), c = ge(0);
  n.value = !1;
  const g = qe([t, i].concat(d, m), () => {
    if (s && !i.value || l && !u.value && !n.value)
      return;
    let v;
    try {
      v = Jk(e, t, y, r);
    } catch (P) {
      v = Promise.reject(P);
    }
    c.value++, n.value = !!c.value, h.value = !1, Promise.resolve(v).then((P) => {
      c.value--, n.value = !!c.value, a.value = P, h.value = Qk(P);
    }).catch((P) => {
      c.value--, n.value = !!c.value, a.value = P, h.value = !0;
    });
  }, {
    immediate: !0,
    deep: typeof t == "object"
  });
  return {
    $invalid: h,
    $unwatch: g
  };
}
function gF(e, t, n, i, o, a, r, s) {
  let {
    $lazy: l,
    $rewardEarly: d
  } = i;
  const y = () => ({}), u = Te(() => {
    if (l && !n.value || d && !s.value)
      return !1;
    let m = !0;
    try {
      const h = Jk(e, t, r, a);
      o.value = h, m = Qk(h);
    } catch (h) {
      o.value = h;
    }
    return m;
  });
  return {
    $unwatch: y,
    $invalid: u
  };
}
function vF(e, t, n, i, o, a, r, s, l, d, y) {
  const u = ge(!1), m = e.$params || {}, h = ge(null);
  let c, g;
  e.$async ? {
    $invalid: c,
    $unwatch: g
  } = mF(e.$validator, t, u, n, i, h, o, e.$watchTargets, l, d, y) : {
    $invalid: c,
    $unwatch: g
  } = gF(e.$validator, t, n, i, h, o, l, d);
  const v = e.$message;
  return {
    $message: xu(v) ? Te(() => v(Ky({
      $pending: u,
      $invalid: c,
      $params: Ky(m),
      $model: t,
      $response: h,
      $validator: a,
      $propertyPath: s,
      $property: r
    }))) : v || "",
    $params: m,
    $pending: u,
    $invalid: c,
    $response: h,
    $unwatch: g
  };
}
function yF() {
  let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  const t = _(e), n = Object.keys(t), i = {}, o = {}, a = {};
  let r = null;
  return n.forEach((s) => {
    const l = t[s];
    switch (!0) {
      case xu(l.$validator):
        i[s] = l;
        break;
      case xu(l):
        i[s] = {
          $validator: l
        };
        break;
      case s === "$validationGroups":
        r = l;
        break;
      case s.startsWith("$"):
        a[s] = l;
        break;
      default:
        o[s] = l;
    }
  }), {
    rules: i,
    nestedValidators: o,
    config: a,
    validationGroups: r
  };
}
const bF = "__root";
function xF(e, t, n, i, o, a, r, s, l) {
  const d = Object.keys(e), y = i.get(o, e), u = ge(!1), m = ge(!1), h = ge(0);
  if (y) {
    if (!y.$partial)
      return y;
    y.$unwatch(), u.value = y.$dirty.value;
  }
  const c = {
    $dirty: u,
    $path: o,
    $touch: () => {
      u.value || (u.value = !0);
    },
    $reset: () => {
      u.value && (u.value = !1);
    },
    $commit: () => {
    }
  };
  return d.length ? (d.forEach((g) => {
    c[g] = vF(e[g], t, c.$dirty, a, r, g, n, o, l, m, h);
  }), c.$externalResults = Te(() => s.value ? [].concat(s.value).map((g, v) => ({
    $propertyPath: o,
    $property: n,
    $validator: "$externalResults",
    $uid: `${o}-externalResult-${v}`,
    $message: g,
    $params: {},
    $response: null,
    $pending: !1
  })) : []), c.$invalid = Te(() => {
    const g = d.some((v) => _(c[v].$invalid));
    return m.value = g, !!c.$externalResults.value.length || g;
  }), c.$pending = Te(() => d.some((g) => _(c[g].$pending))), c.$error = Te(() => c.$dirty.value ? c.$pending.value || c.$invalid.value : !1), c.$silentErrors = Te(() => d.filter((g) => _(c[g].$invalid)).map((g) => {
    const v = c[g];
    return Qi({
      $propertyPath: o,
      $property: n,
      $validator: g,
      $uid: `${o}-${g}`,
      $message: v.$message,
      $params: v.$params,
      $response: v.$response,
      $pending: v.$pending
    });
  }).concat(c.$externalResults.value)), c.$errors = Te(() => c.$dirty.value ? c.$silentErrors.value : []), c.$unwatch = () => d.forEach((g) => {
    c[g].$unwatch();
  }), c.$commit = () => {
    m.value = !0, h.value = Date.now();
  }, i.set(o, e, c), c) : (y && i.set(o, e, c), c);
}
function wF(e, t, n, i, o, a, r) {
  const s = Object.keys(e);
  return s.length ? s.reduce((l, d) => (l[d] = hf({
    validations: e[d],
    state: t,
    key: d,
    parentKey: n,
    resultsCache: i,
    globalConfig: o,
    instance: a,
    externalResults: r
  }), l), {}) : {};
}
function kF(e, t, n) {
  const i = Te(() => [t, n].filter((c) => c).reduce((c, g) => c.concat(Object.values(_(g))), [])), o = Te({
    get() {
      return e.$dirty.value || (i.value.length ? i.value.every((c) => c.$dirty) : !1);
    },
    set(c) {
      e.$dirty.value = c;
    }
  }), a = Te(() => {
    const c = _(e.$silentErrors) || [], g = i.value.filter((v) => (_(v).$silentErrors || []).length).reduce((v, P) => v.concat(...P.$silentErrors), []);
    return c.concat(g);
  }), r = Te(() => {
    const c = _(e.$errors) || [], g = i.value.filter((v) => (_(v).$errors || []).length).reduce((v, P) => v.concat(...P.$errors), []);
    return c.concat(g);
  }), s = Te(() => i.value.some((c) => c.$invalid) || _(e.$invalid) || !1), l = Te(() => i.value.some((c) => _(c.$pending)) || _(e.$pending) || !1), d = Te(() => i.value.some((c) => c.$dirty) || i.value.some((c) => c.$anyDirty) || o.value), y = Te(() => o.value ? l.value || s.value : !1), u = () => {
    e.$touch(), i.value.forEach((c) => {
      c.$touch();
    });
  }, m = () => {
    e.$commit(), i.value.forEach((c) => {
      c.$commit();
    });
  }, h = () => {
    e.$reset(), i.value.forEach((c) => {
      c.$reset();
    });
  };
  return i.value.length && i.value.every((c) => c.$dirty) && u(), {
    $dirty: o,
    $errors: r,
    $invalid: s,
    $anyDirty: d,
    $error: y,
    $pending: l,
    $touch: u,
    $reset: h,
    $silentErrors: a,
    $commit: m
  };
}
function hf(e) {
  let {
    validations: t,
    state: n,
    key: i,
    parentKey: o,
    childResults: a,
    resultsCache: r,
    globalConfig: s = {},
    instance: l,
    externalResults: d
  } = e;
  const y = o ? `${o}.${i}` : i, {
    rules: u,
    nestedValidators: m,
    config: h,
    validationGroups: c
  } = yF(t), g = To(To({}, s), h), v = i ? Te(() => {
    const I = _(n);
    return I ? _(I[i]) : void 0;
  }) : n, P = To({}, _(d) || {}), f = Te(() => {
    const I = _(d);
    return i ? I ? _(I[i]) : void 0 : I;
  }), S = xF(u, v, i, r, y, g, l, f, n), w = wF(m, v, y, r, g, l, f), x = {};
  c && Object.entries(c).forEach((I) => {
    let [R, Y] = I;
    x[R] = {
      $invalid: pp(Y, w, "$invalid"),
      $error: pp(Y, w, "$error"),
      $pending: pp(Y, w, "$pending"),
      $errors: Xy(Y, w, "$errors"),
      $silentErrors: Xy(Y, w, "$silentErrors")
    };
  });
  const {
    $dirty: k,
    $errors: A,
    $invalid: $,
    $anyDirty: j,
    $error: N,
    $pending: M,
    $touch: D,
    $reset: C,
    $silentErrors: b,
    $commit: p
  } = kF(S, w, a), L = i ? Te({
    get: () => _(v),
    set: (I) => {
      k.value = !0;
      const R = _(n), Y = _(d);
      Y && (Y[i] = P[i]), In(R[i]) ? R[i].value = I : R[i] = I;
    }
  }) : null;
  i && g.$autoDirty && qe(v, () => {
    k.value || D();
    const I = _(d);
    I && (I[i] = P[i]);
  }, {
    flush: "sync"
  });
  async function B() {
    return D(), g.$rewardEarly && (p(), await mt()), await mt(), new Promise((I) => {
      if (!M.value)
        return I(!$.value);
      const R = qe(M, () => {
        I(!$.value), R();
      });
    });
  }
  function T(I) {
    return (a.value || {})[I];
  }
  function O() {
    In(d) ? d.value = P : Object.keys(P).length === 0 ? Object.keys(d).forEach((I) => {
      delete d[I];
    }) : Object.assign(d, P);
  }
  return Qi(To(To(To({}, S), {}, {
    $model: L,
    $dirty: k,
    $error: N,
    $errors: A,
    $invalid: $,
    $anyDirty: j,
    $pending: M,
    $touch: D,
    $reset: C,
    $path: y || bF,
    $silentErrors: b,
    $validate: B,
    $commit: p
  }, a && {
    $getResultsForChild: T,
    $clearExternalResults: O,
    $validationGroups: x
  }), w));
}
class SF {
  constructor() {
    this.storage = /* @__PURE__ */ new Map();
  }
  set(t, n, i) {
    this.storage.set(t, {
      rules: n,
      result: i
    });
  }
  checkRulesValidity(t, n, i) {
    const o = Object.keys(i), a = Object.keys(n);
    return a.length !== o.length || !a.every((s) => o.includes(s)) ? !1 : a.every((s) => n[s].$params ? Object.keys(n[s].$params).every((l) => _(i[s].$params[l]) === _(n[s].$params[l])) : !0);
  }
  get(t, n) {
    const i = this.storage.get(t);
    if (!i)
      return;
    const {
      rules: o,
      result: a
    } = i, r = this.checkRulesValidity(t, n, o), s = a.$unwatch ? a.$unwatch : () => ({});
    return r ? a : {
      $dirty: a.$dirty,
      $partial: !0,
      $unwatch: s
    };
  }
}
const Jd = {
  COLLECT_ALL: !0,
  COLLECT_NONE: !1
}, Zy = Symbol("vuelidate#injectChildResults"), Jy = Symbol("vuelidate#removeChildResults");
function CF(e) {
  let {
    $scope: t,
    instance: n
  } = e;
  const i = {}, o = ge([]), a = Te(() => o.value.reduce((y, u) => (y[u] = _(i[u]), y), {}));
  function r(y, u) {
    let {
      $registerAs: m,
      $scope: h,
      $stopPropagation: c
    } = u;
    c || t === Jd.COLLECT_NONE || h === Jd.COLLECT_NONE || t !== Jd.COLLECT_ALL && t !== h || (i[m] = y, o.value.push(m));
  }
  n.__vuelidateInjectInstances = [].concat(n.__vuelidateInjectInstances || [], r);
  function s(y) {
    o.value = o.value.filter((u) => u !== y), delete i[y];
  }
  n.__vuelidateRemoveInstances = [].concat(n.__vuelidateRemoveInstances || [], s);
  const l = $t(Zy, []);
  Bo(Zy, n.__vuelidateInjectInstances);
  const d = $t(Jy, []);
  return Bo(Jy, n.__vuelidateRemoveInstances), {
    childResults: a,
    sendValidationResultsToParent: l,
    removeValidationResultsFromParent: d
  };
}
function eS(e) {
  return new Proxy(e, {
    get(t, n) {
      return typeof t[n] == "object" ? eS(t[n]) : Te(() => t[n]);
    }
  });
}
let Qy = 0;
function TF(e, t) {
  var n;
  let i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  arguments.length === 1 && (i = e, e = void 0, t = void 0);
  let {
    $registerAs: o,
    $scope: a = Jd.COLLECT_ALL,
    $stopPropagation: r,
    $externalResults: s,
    currentVueInstance: l
  } = i;
  const d = l || ((n = ho()) === null || n === void 0 ? void 0 : n.proxy), y = d ? d.$options : {};
  o || (Qy += 1, o = `_vuelidate_${Qy}`);
  const u = ge({}), m = new SF(), {
    childResults: h,
    sendValidationResultsToParent: c,
    removeValidationResultsFromParent: g
  } = d ? CF({
    $scope: a,
    instance: d
  }) : {
    childResults: ge({})
  };
  if (!e && y.validations) {
    const v = y.validations;
    t = ge({}), ws(() => {
      t.value = d, qe(() => xu(v) ? v.call(t.value, new eS(t.value)) : v, (P) => {
        u.value = hf({
          validations: P,
          state: t,
          childResults: h,
          resultsCache: m,
          globalConfig: i,
          instance: d,
          externalResults: s || d.vuelidateExternalResults
        });
      }, {
        immediate: !0
      });
    }), i = y.validationsConfig || i;
  } else {
    const v = In(e) || fF(e) ? e : Qi(e || {});
    qe(v, (P) => {
      u.value = hf({
        validations: P,
        state: t,
        childResults: h,
        resultsCache: m,
        globalConfig: i,
        instance: d ?? {},
        externalResults: s
      });
    }, {
      immediate: !0
    });
  }
  return d && (c.forEach((v) => v(u, {
    $registerAs: o,
    $scope: a,
    $stopPropagation: r
  })), Fa(() => g.forEach((v) => v(o)))), Te(() => To(To({}, _(u.value)), h.value));
}
const LF = "", IF = Be({
  name: "RequestForm",
  components: {
    PrimeInputText: ls,
    PrimeButton: ki,
    PrimeRadioButton: Or,
    PrimeInlineMessage: Xk
  },
  props: {
    values: {
      type: Object,
      required: !0
    },
    dataEventSource: {
      type: String,
      required: !0
    }
  },
  emits: ["input", "close-dialog"],
  setup(e) {
    const t = Qi({
      isin: e.values.depotInfo.form.isin.value,
      fundName: e.values.depotInfo.form.fundName.value,
      depotInstitute: ge(""),
      depotNumber: ge(""),
      desiredInfo: e.values.desiredInfo && e.values.desiredInfo.list?.length ? e.values.desiredInfo.list[0]?.key : null,
      salutation: e.values.personalInfo && e.values.personalInfo.form.salutation?.length ? e.values.personalInfo.form.salutation[0]?.key : null,
      firstName: ge(""),
      lastName: ge(""),
      email: ge(""),
      confirmEmail: ge(""),
      secureEmail: ge(""),
      address: ge(""),
      postcode: ge(""),
      city: ge(""),
      country: ge("")
    }), n = (f, S) => (S = f.match(/^([\/~@;%#'])(.*?)\1([gimsuy]*)$/)) ? new RegExp(
      S[2],
      S[3].split("").filter((w, x, k) => k.indexOf(w) === x).join("")
    ) : new RegExp(f), i = e.values.depotInfo.form.isin.regEx ? Ri.regex(n(e.values.depotInfo.form.isin.regEx)) : !0, o = e.values.depotInfo.form.fundName.regEx ? Ri.regex(n(e.values.depotInfo.form.fundName.regEx)) : !0, a = e.values.depotInfo.form.depotInstitute.regEx ? Ri.regex(
      n(e.values.depotInfo.form.depotInstitute.regEx)
    ) : !0, r = e.values.depotInfo.form.depotNumber.regEx ? Ri.regex(
      n(e.values.depotInfo.form.depotNumber.regEx)
    ) : !0, s = e.values.personalInfo.form.firstName.regEx ? Ri.regex(
      n(e.values.personalInfo.form.firstName.regEx)
    ) : !0, l = e.values.personalInfo.form.lastName.regEx ? Ri.regex(
      n(e.values.personalInfo.form.lastName.regEx)
    ) : !0, d = e.values.personalInfo.form.email.regEx ? Ri.regex(n(e.values.personalInfo.form.email.regEx)) : !0, y = e.values.personalInfo.form.confirmEmail.regEx ? Ri.regex(
      n(e.values.personalInfo.form.confirmEmail.regEx)
    ) : !0, u = e.values.personalInfo.form.street.regEx ? Ri.regex(
      n(e.values.personalInfo.form.street.regEx)
    ) : !0, m = e.values.personalInfo.form.postcode.regEx ? Ri.regex(
      n(e.values.personalInfo.form.postcode.regEx)
    ) : !0, h = e.values.personalInfo.form.city.regEx ? Ri.regex(n(e.values.personalInfo.form.city.regEx)) : !0, c = e.values.personalInfo.form.country.regEx ? Ri.regex(
      n(e.values.personalInfo.form.country.regEx)
    ) : !0, g = ge(3), v = Te(() => ({
      isin: {
        required: yi,
        valIsin: i
      },
      fundName: {
        required: yi,
        valFundName: o
      },
      depotInstitute: {
        minLength: kd(g.value),
        required: yi,
        valDepotInstitute: a
      },
      depotNumber: {
        minLength: kd(g.value),
        required: yi,
        valDepotNumber: r
      },
      desiredInfo: {
        required: yi
      },
      salutation: {
        required: yi
      },
      firstName: {
        required: yi,
        minLength: kd(g.value),
        valFirstName: s
      },
      lastName: {
        required: yi,
        minLength: kd(g.value),
        valLastName: l
      },
      email: {
        required: yi,
        valEmail: d
      },
      confirmEmail: {
        required: yi,
        valConfirmEmail: y,
        sameAs: P5(t.email)
      },
      secureEmail: {},
      address: {
        required: yi,
        valAddress: u
      },
      postcode: {
        required: yi,
        numeric: S5,
        valPostCode: m
      },
      city: {
        required: yi,
        valCity: h
      },
      country: {
        required: yi,
        valCountry: c
      }
    })), P = TF(v, t);
    return it(async () => {
      if (await mt(), Ue) {
        const f = document.getElementById("opened");
        f.click(), f.setAttribute("hidden", "hidden"), document.getElementById("start").setAttribute("hidden", "hidden"), document.getElementById("submitOk").setAttribute("hidden", "hidden");
        const x = document.getElementById("form");
        let k = 0;
        x.addEventListener(
          "focus",
          () => {
            if (k == 0) {
              const A = document.getElementById("start");
              A.removeAttribute("hidden"), A.click(), A.setAttribute("hidden", "hidden");
            }
            k = 1;
          },
          !0
        );
      }
    }), { state: t, v$: P, requiredNameLength: g };
  },
  data() {
    return {
      submitted: !1,
      sentSuccessful: !1,
      errorSubmit: !1,
      formSuccess: !1
    };
  },
  methods: {
    async submitRequestForm() {
      if (this.submitted = !0, !await this.v$.$validate())
        return;
      const t = this.values.technicalFields.reduce(
        (d, y) => (d[y.key] = y.value, d),
        {}
      ), n = Object.assign(this.state, t), i = document.getElementsByName("__RequestVerificationToken")[0], o = {
        "Content-Type": "application/json;charset=UTF-8",
        "Access-Control-Allow-Origin": "*",
        Accept: "application/json",
        RequestVerificationToken: Ue && i.value ? i.value : ""
      }, a = {
        body: JSON.stringify(n),
        headers: o
      }, r = LF + this.values.submitUrl, { error: s, data: l } = await Wu().post(r, a);
      if (l.value !== void 0) {
        if (this.sentSuccessful = !0, Ue) {
          const d = document.getElementById("submitOk");
          d.removeAttribute("hidden"), d.click(), d.setAttribute("hidden", "hidden");
        }
        location.href = "#submitMessage", this.formSuccess = !0, setTimeout(() => {
          this.resetForm();
        }, 5e3);
      } else
        this.errorSubmit = !0, location.href = "#submitMessage", this.errorMessage = s.message;
    },
    resetForm() {
      this.state.depotInstitute = "", this.state.depotNumber = "", this.state.salutation = null, this.state.firstName = "", this.state.lastName = "", this.state.email = "", this.state.confirmEmail = "", this.state.address = "", this.state.postcode = "", this.state.city = "", this.state.country = null, this.v$.$reset(), this.$emit("close-dialog");
    }
  }
}), PF = { key: 0 }, AF = { class: "request-form" }, _F = { class: "bold mb-8" }, MF = { class: "small" }, OF = { class: "bold mb-12" }, BF = { class: "grid p-fluid xs:grid-cols-1 xl:grid-cols-6 gap-x-10 gap-y-8 mb-20" }, EF = { class: "field xs:col-span-1 md:col-span-3" }, DF = {
  key: 0,
  class: "p-helptext p-error-text"
}, RF = { class: "field xs:col-span-1 md:col-span-3" }, NF = {
  key: 0,
  class: "p-helptext p-error-text"
}, $F = { class: "field xs:col-span-1 md:col-span-3" }, FF = {
  key: 0,
  class: "p-helptext p-error-text"
}, jF = { class: "field xs:col-span-1 md:col-span-3" }, HF = {
  key: 0,
  class: "p-helptext p-error-text"
}, zF = { class: "bold mb-12" }, VF = { class: "grid xs:grid-cols-1 xl:grid-cols-2 mb-20" }, GF = ["for"], UF = { class: "bold mb-12" }, WF = { class: "grid p-fluid xs:grid-cols-2 xl:grid-cols-4" }, YF = ["for"], qF = { class: "grid p-fluid xs:grid-cols-1 xl:grid-cols-4 gap-x-10 gap-y-8" }, KF = { class: "xs:col-span-1 xl:col-span-2" }, XF = {
  key: 0,
  class: "p-helptext p-error-text"
}, ZF = { class: "field xs:col-span-1 xl:col-span-2" }, JF = {
  key: 0,
  class: "p-helptext p-error-text"
}, QF = { class: "field xs:col-span-1 xl:col-span-2" }, e9 = {
  key: 0,
  class: "p-helptext p-error-text"
}, t9 = {
  key: 1,
  class: "p-error"
}, n9 = { class: "field xs:col-span-1 xl:col-span-2" }, i9 = {
  key: 0,
  class: "p-helptext p-error-text"
}, a9 = {
  key: 1,
  class: "p-error"
}, o9 = { class: "field xs:col-span-1 xl:col-span-2" }, r9 = { class: "field xs:col-span-1 xl:col-span-3" }, s9 = {
  key: 0,
  class: "p-helptext p-error-text"
}, l9 = { class: "field xs:col-span-1 xl:col-span-1" }, c9 = {
  key: 0,
  class: "p-helptext p-error-text"
}, d9 = { class: "field xs:col-span-1 xl:col-span-2" }, u9 = {
  key: 0,
  class: "p-helptext p-error-text"
}, h9 = { class: "field xs:col-span-1 xl:col-span-2" }, p9 = {
  key: 0,
  class: "p-helptext p-error-text"
}, f9 = { class: "button-group p-button-group" }, m9 = { key: 1 }, g9 = { class: "request-form" }, v9 = {
  id: "submitMessage",
  class: "mt-8"
}, y9 = ["data-event_source"], b9 = ["data-event_source"], x9 = ["data-event_source", "data-event_title"];
function w9(e, t, n, i, o, a) {
  const r = $e("PrimeInputText"), s = $e("PrimeRadioButton"), l = $e("PrimeButton"), d = $e("PrimeInlineMessage");
  return E(), X(Re, null, [
    e.formSuccess ? (E(), X("div", m9, [
      oe("div", g9, [
        ue(l, {
          class: "p-button-sm p-button-rounded float-right",
          onClick: e.resetForm
        }, {
          default: Se(() => [
            Ve(Ie(e.values.closeButtonText ? e.values.closeButtonText : "Close"), 1)
          ]),
          _: 1
        }, 8, ["onClick"])
      ])
    ])) : (E(), X("div", PF, [
      oe("div", AF, [
        oe("h3", _F, Ie(e.values.generalInfo.headlineText), 1),
        oe("p", MF, Ie(e.values.generalInfo.headlineSubText), 1),
        oe("h3", OF, Ie(e.values.depotInfo.headlineText), 1),
        oe("form", {
          id: "form",
          class: "",
          novalidate: "",
          onSubmit: t[15] || (t[15] = It((y) => e.submitRequestForm(), ["prevent"]))
        }, [
          oe("div", BF, [
            oe("div", EF, [
              oe("label", {
                for: "isin",
                class: Pe({ "p-error": e.v$.isin.$invalid && e.submitted })
              }, [
                Ve(Ie(e.values.depotInfo.form.isin.title) + " ", 1),
                t[16] || (t[16] = oe("sup", { class: "p-label__mandantory" }, "*", -1))
              ], 2),
              ue(r, {
                id: "isin",
                modelValue: e.v$.isin.$model,
                "onUpdate:modelValue": t[0] || (t[0] = (y) => e.v$.isin.$model = y),
                class: Pe({ "p-invalid": e.v$.isin.$invalid && e.submitted }),
                disabled: !e.values.depotInfo.form.isin.isEditable
              }, null, 8, ["modelValue", "class", "disabled"]),
              e.v$.isin.$invalid && e.submitted ? (E(), X("span", DF, Ie(e.values.depotInfo.form.isin.errorText), 1)) : te("", !0)
            ]),
            oe("div", RF, [
              oe("label", {
                for: "fundName",
                class: Pe({
                  "p-error": e.v$.fundName.$invalid && e.submitted
                })
              }, [
                Ve(Ie(e.values.depotInfo.form.fundName.title) + " ", 1),
                t[17] || (t[17] = oe("sup", { class: "p-label__mandantory" }, "*", -1))
              ], 2),
              ue(r, {
                id: "fundName",
                modelValue: e.v$.fundName.$model,
                "onUpdate:modelValue": t[1] || (t[1] = (y) => e.v$.fundName.$model = y),
                class: Pe({
                  "p-invalid": e.v$.fundName.$invalid && e.submitted
                }),
                disabled: !e.values.depotInfo.form.fundName.isEditable
              }, null, 8, ["modelValue", "class", "disabled"]),
              e.v$.fundName.$invalid && e.submitted ? (E(), X("span", NF, Ie(e.values.depotInfo.form.fundName.errorText), 1)) : te("", !0)
            ]),
            oe("div", $F, [
              oe("label", {
                for: "depotInstitute",
                class: Pe({
                  "p-error": e.v$.depotInstitute.$invalid && e.submitted
                })
              }, [
                Ve(Ie(e.values.depotInfo.form.depotInstitute.title) + " ", 1),
                t[18] || (t[18] = oe("sup", { class: "p-label__mandantory" }, "*", -1))
              ], 2),
              ue(r, {
                id: "depotInstitute",
                modelValue: e.v$.depotInstitute.$model,
                "onUpdate:modelValue": t[2] || (t[2] = (y) => e.v$.depotInstitute.$model = y),
                class: Pe({
                  "p-invalid": e.v$.depotInstitute.$invalid && e.submitted
                }),
                disabled: !e.values.depotInfo.form.depotInstitute.isEditable
              }, null, 8, ["modelValue", "class", "disabled"]),
              e.v$.depotInstitute.$invalid && e.submitted ? (E(), X("span", FF, Ie(e.values.depotInfo.form.depotInstitute.errorText), 1)) : te("", !0)
            ]),
            oe("div", jF, [
              oe("label", {
                for: "depotNumber",
                class: Pe({
                  "p-error": e.v$.depotNumber.$invalid && e.submitted
                })
              }, [
                Ve(Ie(e.values.depotInfo.form.depotNumber.title) + " ", 1),
                t[19] || (t[19] = oe("sup", { class: "p-label__mandantory" }, "*", -1))
              ], 2),
              ue(r, {
                id: "depotNumber",
                modelValue: e.v$.depotNumber.$model,
                "onUpdate:modelValue": t[3] || (t[3] = (y) => e.v$.depotNumber.$model = y),
                class: Pe({
                  "p-invalid": e.v$.depotNumber.$invalid && e.submitted
                }),
                disabled: !e.values.depotInfo.form.depotNumber.isEditable
              }, null, 8, ["modelValue", "class", "disabled"]),
              e.v$.depotNumber.$invalid && e.submitted ? (E(), X("span", HF, Ie(e.values.depotInfo.form.depotNumber.errorText), 1)) : te("", !0)
            ])
          ]),
          oe("h3", zF, Ie(e.values.desiredInfo.headlineText), 1),
          oe("div", VF, [
            (E(!0), X(Re, null, Ge(e.values.desiredInfo.list, (y) => (E(), X("div", {
              key: y.key,
              class: "field-radiobutton flex xs:mb-4 xl:mb-10"
            }, [
              ue(s, {
                id: y.key,
                modelValue: e.v$.desiredInfo.$model,
                "onUpdate:modelValue": t[4] || (t[4] = (u) => e.v$.desiredInfo.$model = u),
                class: "field",
                value: y.key
              }, null, 8, ["id", "modelValue", "value"]),
              oe("label", {
                class: "field xs:col-span-10 md:col-span-10 pt-1 p-radiobutton__label",
                for: y.key
              }, Ie(y.value), 9, GF)
            ]))), 128))
          ]),
          oe("h3", UF, Ie(e.values.personalInfo.headlineText), 1),
          oe("div", WF, [
            (E(!0), X(Re, null, Ge(e.values.personalInfo.form.salutation, (y) => (E(), X("div", {
              key: y.key,
              class: "field-radiobutton flex xs:mb-4 xl:mb-10"
            }, [
              ue(s, {
                id: y.key,
                modelValue: e.v$.salutation.$model,
                "onUpdate:modelValue": t[5] || (t[5] = (u) => e.v$.salutation.$model = u),
                class: "field",
                value: y.key,
                onChange: t[6] || (t[6] = (u) => e.$emit("input", u.target.value))
              }, null, 8, ["id", "modelValue", "value"]),
              oe("label", {
                class: Pe(["field xs:col-span-10 md:col-span-10 pt-1 p-radiobutton__label", { "p-error": e.v$.salutation.$invalid && e.submitted }]),
                for: y.key
              }, Ie(y.value), 11, YF)
            ]))), 128))
          ]),
          oe("div", qF, [
            oe("div", KF, [
              oe("label", {
                for: "firstName",
                class: Pe({
                  "p-error": e.v$.firstName.$invalid && e.submitted
                })
              }, [
                Ve(Ie(e.values.personalInfo.form.firstName.title) + " ", 1),
                t[20] || (t[20] = oe("sup", { class: "p-label__mandantory" }, "*", -1))
              ], 2),
              ue(r, {
                id: "firstName",
                modelValue: e.v$.firstName.$model,
                "onUpdate:modelValue": t[7] || (t[7] = (y) => e.v$.firstName.$model = y),
                class: Pe({
                  "p-invalid": e.v$.firstName.$invalid && e.submitted
                }),
                disabled: !e.values.personalInfo.form.firstName.isEditable
              }, null, 8, ["modelValue", "class", "disabled"]),
              e.v$.firstName.$invalid && e.submitted ? (E(), X("span", XF, Ie(e.values.personalInfo.form.firstName.errorText), 1)) : te("", !0)
            ]),
            oe("div", ZF, [
              oe("label", {
                for: "lastName",
                class: Pe({
                  "p-error": e.v$.lastName.$invalid && e.submitted
                })
              }, [
                Ve(Ie(e.values.personalInfo.form.lastName.title) + " ", 1),
                t[21] || (t[21] = oe("sup", { class: "p-label__mandantory" }, "*", -1))
              ], 2),
              ue(r, {
                id: "lastName",
                modelValue: e.v$.lastName.$model,
                "onUpdate:modelValue": t[8] || (t[8] = (y) => e.v$.lastName.$model = y),
                class: Pe({
                  "p-invalid": e.v$.lastName.$invalid && e.submitted
                }),
                disabled: !e.values.personalInfo.form.lastName.isEditable
              }, null, 8, ["modelValue", "class", "disabled"]),
              e.v$.lastName.$invalid && e.submitted ? (E(), X("span", JF, Ie(e.values.personalInfo.form.lastName.errorText), 1)) : te("", !0)
            ]),
            oe("div", QF, [
              oe("label", {
                for: "email",
                class: Pe({ "p-error": e.v$.email.$invalid && e.submitted })
              }, [
                Ve(Ie(e.values.personalInfo.form.email.title) + " ", 1),
                t[22] || (t[22] = oe("sup", { class: "p-label__mandantory" }, "*", -1))
              ], 2),
              ue(r, {
                id: "email",
                modelValue: e.v$.email.$model,
                "onUpdate:modelValue": t[9] || (t[9] = (y) => e.v$.email.$model = y),
                class: Pe({ "p-invalid": e.v$.email.$invalid && e.submitted }),
                "aria-describedby": "email-error",
                disabled: !e.values.personalInfo.form.email.isEditable
              }, null, 8, ["modelValue", "class", "disabled"]),
              e.v$.email.$invalid && e.submitted ? (E(), X("span", e9, Ie(e.values.personalInfo.form.email.errorText), 1)) : e.v$.email.$invalid && e.submitted || e.v$.email.$pending.$response ? (E(), X("span", t9, Ie(e.v$.email.required.$message.replace("Value", "Email")), 1)) : te("", !0)
            ]),
            oe("div", n9, [
              oe("label", {
                for: "confirmEmail",
                class: Pe({
                  "p-error": e.v$.confirmEmail.$invalid && e.submitted
                })
              }, [
                Ve(Ie(e.values.personalInfo.form.confirmEmail.title) + " ", 1),
                t[23] || (t[23] = oe("sup", { class: "p-label__mandantory" }, "*", -1))
              ], 2),
              ue(r, {
                id: "confirmEmail",
                modelValue: e.v$.confirmEmail.$model,
                "onUpdate:modelValue": t[10] || (t[10] = (y) => e.v$.confirmEmail.$model = y),
                class: Pe({
                  "p-invalid": e.v$.confirmEmail.$invalid && e.submitted
                }),
                "aria-describedby": "email-error",
                disabled: !e.values.personalInfo.form.confirmEmail.isEditable
              }, null, 8, ["modelValue", "class", "disabled"]),
              e.v$.confirmEmail.$invalid && e.submitted ? (E(), X("span", i9, Ie(e.values.personalInfo.form.confirmEmail.errorText), 1)) : e.v$.confirmEmail.$invalid && e.submitted || e.v$.confirmEmail.$pending.$response ? (E(), X("span", a9, Ie(e.v$.confirmEmail.required.$message.replace("Value", "Email")), 1)) : te("", !0)
            ]),
            oe("div", o9, [
              ue(r, {
                id: "secureEmail",
                class: "hidden",
                value: e.v$.secureEmail.$model
              }, null, 8, ["value"])
            ]),
            oe("div", r9, [
              oe("label", {
                for: "address",
                class: Pe({ "p-error": e.v$.address.$invalid && e.submitted })
              }, [
                Ve(Ie(e.values.personalInfo.form.street.title) + " ", 1),
                t[24] || (t[24] = oe("sup", { class: "p-label__mandantory" }, "*", -1))
              ], 2),
              ue(r, {
                id: "address",
                modelValue: e.v$.address.$model,
                "onUpdate:modelValue": t[11] || (t[11] = (y) => e.v$.address.$model = y),
                class: Pe({
                  "p-invalid": e.v$.address.$invalid && e.submitted
                }),
                disabled: !e.values.personalInfo.form.street.isEditable
              }, null, 8, ["modelValue", "class", "disabled"]),
              e.v$.address.$invalid && e.submitted ? (E(), X("span", s9, Ie(e.values.personalInfo.form.street.errorText), 1)) : te("", !0)
            ]),
            oe("div", l9, [
              oe("label", {
                for: "postcode",
                class: Pe({
                  "p-error": e.v$.postcode.$invalid && e.submitted
                })
              }, [
                Ve(Ie(e.values.personalInfo.form.postcode.title) + " ", 1),
                t[25] || (t[25] = oe("sup", { class: "p-label__mandantory" }, "*", -1))
              ], 2),
              ue(r, {
                id: "postcode",
                modelValue: e.v$.postcode.$model,
                "onUpdate:modelValue": t[12] || (t[12] = (y) => e.v$.postcode.$model = y),
                class: Pe({
                  "p-invalid": e.v$.postcode.$invalid && e.submitted
                }),
                disabled: !e.values.personalInfo.form.postcode.isEditable
              }, null, 8, ["modelValue", "class", "disabled"]),
              e.v$.postcode.$invalid && e.submitted ? (E(), X("span", c9, Ie(e.values.personalInfo.form.postcode.errorText), 1)) : te("", !0)
            ]),
            oe("div", d9, [
              oe("label", {
                for: "city",
                class: Pe({ "p-error": e.v$.city.$invalid && e.submitted })
              }, [
                Ve(Ie(e.values.personalInfo.form.city.title) + " ", 1),
                t[26] || (t[26] = oe("sup", { class: "p-label__mandantory" }, "*", -1))
              ], 2),
              ue(r, {
                id: "city",
                modelValue: e.v$.city.$model,
                "onUpdate:modelValue": t[13] || (t[13] = (y) => e.v$.city.$model = y),
                class: Pe({ "p-invalid": e.v$.city.$invalid && e.submitted }),
                disabled: !e.values.personalInfo.form.city.isEditable
              }, null, 8, ["modelValue", "class", "disabled"]),
              e.v$.city.$invalid && e.submitted ? (E(), X("span", u9, Ie(e.values.personalInfo.form.city.errorText), 1)) : te("", !0)
            ]),
            oe("div", h9, [
              oe("label", {
                for: "country",
                class: Pe({ "p-error": e.v$.country.$invalid && e.submitted })
              }, [
                Ve(Ie(e.values.personalInfo.form.country.title) + " ", 1),
                t[27] || (t[27] = oe("sup", { class: "p-label__mandantory" }, "*", -1))
              ], 2),
              ue(r, {
                id: "country",
                modelValue: e.v$.country.$model,
                "onUpdate:modelValue": t[14] || (t[14] = (y) => e.v$.country.$model = y),
                class: Pe({
                  "p-invalid": e.v$.country.$invalid && e.submitted
                }),
                disabled: !e.values.personalInfo.form.country.isEditable
              }, null, 8, ["modelValue", "class", "disabled"]),
              e.v$.country.$invalid && e.submitted ? (E(), X("span", p9, Ie(e.values.personalInfo.form.country.errorText), 1)) : te("", !0)
            ])
          ]),
          oe("div", f9, [
            ue(l, {
              class: "p-button-sm p-button-rounded p-button-outlined",
              "data-event_source": e.dataEventSource,
              "data-event_component_name": "Formular",
              "data-event_title": e.values.cancelButtonText,
              onClick: e.resetForm
            }, {
              default: Se(() => [
                Ve(Ie(e.values.cancelButtonText), 1)
              ]),
              _: 1
            }, 8, ["data-event_source", "data-event_title", "onClick"]),
            ue(l, {
              class: "p-button-sm p-button-rounded",
              type: "submit"
            }, {
              default: Se(() => [
                Ve(Ie(e.values.submitButtonText), 1)
              ]),
              _: 1
            })
          ])
        ], 32)
      ])
    ])),
    oe("div", v9, [
      e.sentSuccessful ? (E(), fe(d, {
        key: 0,
        severity: "success"
      }, {
        default: Se(() => [
          Ve(Ie(e.values.sentSuccessfullyText), 1)
        ]),
        _: 1
      })) : te("", !0),
      e.errorSubmit ? (E(), fe(d, {
        key: 1,
        severity: "error"
      }, {
        default: Se(() => [
          Ve(Ie(e.values.sentWithErrorText), 1)
        ]),
        _: 1
      })) : te("", !0)
    ]),
    oe("button", {
      id: "opened",
      "data-event_source": e.dataEventSource,
      "data-event_component_name": "Formular",
      "data-event_title": "Opened"
    }, null, 8, y9),
    oe("button", {
      id: "start",
      "data-event_source": e.dataEventSource,
      "data-event_component_name": "Formular",
      "data-event_title": "Start"
    }, null, 8, b9),
    oe("button", {
      id: "submitOk",
      "data-event_source": e.dataEventSource,
      "data-event_component_name": "Formular",
      "data-event_title": e.values.submitButtonText
    }, null, 8, x9)
  ], 64);
}
const vBe = /* @__PURE__ */ Fe(IF, [["render", w9]]), k9 = Be({
  name: "LinkItem",
  props: {
    anchorTitle: {
      type: String
    },
    anchorUrl: {
      type: String
    },
    iconEnabled: {
      type: Boolean
    },
    anchorIconLeft: {
      type: String
    },
    anchorIconRight: {
      type: String
    },
    linkType: {
      // valid values: 'internal', 'external'
      type: String
    },
    linkTitle: {
      // valid values: 'internal', 'external'
      type: String
    },
    text_before: {
      type: Boolean,
      default: !0
    },
    anchorTarget: {
      type: String
    },
    tabindex: {
      type: String,
      default: "0"
    },
    isFalafel: {
      type: Boolean,
      default: !1
    },
    expanded: {
      type: Boolean,
      default: null
    },
    ariaPressed: {
      type: Boolean,
      default: null
    },
    ariaCurrent: {
      type: String,
      default: null
    }
  },
  emits: ["click"],
  data() {
    return {};
  },
  created() {
    const { pageName: e } = Qe();
    this.dataEventSource = e;
  },
  methods: {
    getLinkType() {
      if (!this.linkType)
        return "@@@NOT_SET@@@";
      if (this.isFalafel)
        return "Falafel";
      switch (this.linkType) {
        case "internal":
          return "Text Links (next page)";
        case "Falafel":
          return "Falafel";
        case "DropDown":
          return "DropDown";
        case "Header":
          return "Header";
        case "Breadcrumb":
          return "Breadcrumb";
        case "Product-Header":
          return "Product-Header";
        case "Culture":
          return "Culture";
        case "Country Picker":
          return "Country Picker";
        case "Audience Selector":
          return "Country Picker";
        default:
          return "Exit Links";
      }
    },
    getEventTitle() {
      switch (this.linkType) {
        case "Country Picker":
          return "Country";
        case "Audience Selector":
          return "Audience Selector";
        default:
          return this.anchorTitle;
      }
    },
    getEventTarget() {
      switch (this.linkType) {
        case "Audience Selector":
          return this.linkTitle;
        default:
          return this.anchorUrl;
      }
    },
    getTarget() {
      return this.linkType === "external" ? "_blank" : null;
    },
    getRole() {
      return this.anchorUrl ? null : "button";
    },
    isExpanded() {
      return this.expanded === null || this.getRole() !== "button" ? null : this.expanded;
    }
  }
}), S9 = ["href", "data-event_source", "data-event_component_name", "data-event_title", "data-event_target", "target", "tabindex", "role", "aria-expanded", "aria-pressed", "aria-current"], C9 = ["href", "data-event_source", "data-event_component_name", "data-event_title", "data-event_target", "target", "tabindex", "role", "aria-expanded", "aria-pressed", "aria-current"];
function T9(e, t, n, i, o, a) {
  return E(), X("div", null, [
    e.text_before ? (E(), X("a", {
      key: 0,
      href: e.anchorUrl,
      "data-event_source": e.dataEventSource,
      "data-event_component_name": e.getLinkType(),
      "data-event_title": e.getEventTitle(),
      "data-event_target": e.getEventTarget(),
      target: e.getTarget(),
      tabindex: parseInt(e.tabindex),
      role: e.getRole(),
      "aria-expanded": e.isExpanded(),
      "aria-pressed": e.ariaPressed,
      "aria-current": e.ariaCurrent,
      onClick: t[0] || (t[0] = (r) => e.$emit("click"))
    }, [
      e.iconEnabled ? (E(), X("i", {
        key: 0,
        class: Pe(e.anchorIconLeft)
      }, null, 2)) : te("", !0),
      Ve(" " + Ie(e.anchorTitle) + " ", 1),
      e.iconEnabled ? (E(), X("i", {
        key: 1,
        class: Pe(e.anchorIconRight)
      }, null, 2)) : te("", !0),
      je(e.$slots, "default")
    ], 8, S9)) : te("", !0),
    e.text_before ? te("", !0) : (E(), X("a", {
      key: 1,
      href: e.anchorUrl,
      "data-event_source": e.dataEventSource,
      "data-event_component_name": e.getLinkType(),
      "data-event_title": e.getEventTitle(),
      "data-event_target": e.getEventTarget(),
      target: e.getTarget(),
      tabindex: parseInt(e.tabindex),
      role: e.getRole(),
      "aria-expanded": e.isExpanded(),
      "aria-pressed": e.ariaPressed,
      "aria-current": e.ariaCurrent,
      onClick: t[1] || (t[1] = (r) => e.$emit("click"))
    }, [
      je(e.$slots, "default"),
      e.iconEnabled ? (E(), X("i", {
        key: 0,
        class: Pe(e.anchorIconLeft)
      }, null, 2)) : te("", !0),
      Ve(" " + Ie(e.anchorTitle) + " ", 1),
      e.iconEnabled ? (E(), X("i", {
        key: 1,
        class: Pe(e.anchorIconRight)
      }, null, 2)) : te("", !0)
    ], 8, C9))
  ]);
}
const L9 = /* @__PURE__ */ Fe(k9, [["render", T9]]);
const I9 = Be({
  name: "ManagerCard",
  components: { HTMLContentBlock: ht },
  props: {
    values: {
      type: Object,
      required: !0
    }
  },
  setup(e) {
    const t = ge(!1);
    return {
      isLoaded: t,
      loadImage: () => {
        t.value = !0;
      },
      sanitize: (o) => {
        const { htmlContentBlockWhitelist: a } = Li();
        return Ma(o, a);
      }
    };
  }
}), P9 = { class: "author-card flex flex-nowrap" }, A9 = ["src", "alt"], _9 = { class: "author-card__description" }, M9 = { class: "title" }, O9 = {
  key: 0,
  class: "position"
}, B9 = {
  key: 1,
  class: "location"
};
function E9(e, t, n, i, o, a) {
  const r = $e("HTMLContentBlock");
  return E(), X("div", P9, [
    rt(oe("img", {
      class: "author-card__avatar",
      src: e.values.image,
      alt: e.values.name,
      onLoad: t[0] || (t[0] = (...s) => e.loadImage && e.loadImage(...s))
    }, null, 40, A9), [
      [xn, e.values.image !== null && e.isLoaded]
    ]),
    oe("div", _9, [
      oe("p", M9, Ie(e.values.name), 1),
      e.values.positionHtml !== null ? (E(), X("p", O9, [
        ue(r, {
          "disable-default-styling": "",
          "html-text": e.values.positionHtml
        }, null, 8, ["html-text"])
      ])) : te("", !0),
      e.values.country !== null ? (E(), X("p", B9, [
        Ve(Ie(e.values.country) + " ", 1),
        t[1] || (t[1] = oe("i", { class: "las la-map-marker" }, null, -1))
      ])) : te("", !0)
    ])
  ]);
}
const D9 = /* @__PURE__ */ Fe(I9, [["render", E9]]);
var tS = { exports: {} };
(function(e, t) {
  (function(n, i) {
    e.exports = i();
  })(typeof self < "u" ? self : rn, function() {
    return function(n) {
      var i = {};
      function o(a) {
        if (i[a])
          return i[a].exports;
        var r = i[a] = { i: a, l: !1, exports: {} };
        return n[a].call(r.exports, r, r.exports, o), r.l = !0, r.exports;
      }
      return o.m = n, o.c = i, o.d = function(a, r, s) {
        o.o(a, r) || Object.defineProperty(a, r, { enumerable: !0, get: s });
      }, o.r = function(a) {
        typeof Symbol < "u" && Symbol.toStringTag && Object.defineProperty(a, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(a, "__esModule", { value: !0 });
      }, o.t = function(a, r) {
        if (1 & r && (a = o(a)), 8 & r || 4 & r && typeof a == "object" && a && a.__esModule)
          return a;
        var s = /* @__PURE__ */ Object.create(null);
        if (o.r(s), Object.defineProperty(s, "default", { enumerable: !0, value: a }), 2 & r && typeof a != "string")
          for (var l in a)
            o.d(s, l, function(d) {
              return a[d];
            }.bind(null, l));
        return s;
      }, o.n = function(a) {
        var r = a && a.__esModule ? function() {
          return a.default;
        } : function() {
          return a;
        };
        return o.d(r, "a", r), r;
      }, o.o = function(a, r) {
        return Object.prototype.hasOwnProperty.call(a, r);
      }, o.p = "", o(o.s = 44);
    }([function(n, i, o) {
      var a = o(28)("wks"), r = o(14), s = o(1).Symbol, l = typeof s == "function";
      (n.exports = function(d) {
        return a[d] || (a[d] = l && s[d] || (l ? s : r)("Symbol." + d));
      }).store = a;
    }, function(n, i) {
      var o = n.exports = typeof window < "u" && window.Math == Math ? window : typeof self < "u" && self.Math == Math ? self : Function("return this")();
      typeof __g == "number" && (__g = o);
    }, function(n, i, o) {
      var a = o(1), r = o(7), s = o(3), l = o(19), d = o(24), y = function(u, m, h) {
        var c, g, v, P, f = u & y.F, S = u & y.G, w = u & y.S, x = u & y.P, k = u & y.B, A = S ? a : w ? a[m] || (a[m] = {}) : (a[m] || {}).prototype, $ = S ? r : r[m] || (r[m] = {}), j = $.prototype || ($.prototype = {});
        for (c in S && (h = m), h)
          v = ((g = !f && A && A[c] !== void 0) ? A : h)[c], P = k && g ? d(v, a) : x && typeof v == "function" ? d(Function.call, v) : v, A && l(A, c, v, u & y.U), $[c] != v && s($, c, P), x && j[c] != v && (j[c] = v);
      };
      a.core = r, y.F = 1, y.G = 2, y.S = 4, y.P = 8, y.B = 16, y.W = 32, y.U = 64, y.R = 128, n.exports = y;
    }, function(n, i, o) {
      var a = o(4), r = o(13);
      n.exports = o(8) ? function(s, l, d) {
        return a.f(s, l, r(1, d));
      } : function(s, l, d) {
        return s[l] = d, s;
      };
    }, function(n, i, o) {
      var a = o(12), r = o(34), s = o(23), l = Object.defineProperty;
      i.f = o(8) ? Object.defineProperty : function(d, y, u) {
        if (a(d), y = s(y, !0), a(u), r)
          try {
            return l(d, y, u);
          } catch {
          }
        if ("get" in u || "set" in u)
          throw TypeError("Accessors not supported!");
        return "value" in u && (d[y] = u.value), d;
      };
    }, function(n, i) {
      n.exports = function(o) {
        return typeof o == "object" ? o !== null : typeof o == "function";
      };
    }, function(n, i) {
      var o = {}.hasOwnProperty;
      n.exports = function(a, r) {
        return o.call(a, r);
      };
    }, function(n, i) {
      var o = n.exports = { version: "2.5.7" };
      typeof __e == "number" && (__e = o);
    }, function(n, i, o) {
      n.exports = !o(9)(function() {
        return Object.defineProperty({}, "a", { get: function() {
          return 7;
        } }).a != 7;
      });
    }, function(n, i) {
      n.exports = function(o) {
        try {
          return !!o();
        } catch {
          return !0;
        }
      };
    }, function(n, i, o) {
      var a = o(37), r = o(29);
      n.exports = Object.keys || function(s) {
        return a(s, r);
      };
    }, function(n, i, o) {
      var a = o(25), r = o(17);
      n.exports = function(s) {
        return a(r(s));
      };
    }, function(n, i, o) {
      var a = o(5);
      n.exports = function(r) {
        if (!a(r))
          throw TypeError(r + " is not an object!");
        return r;
      };
    }, function(n, i) {
      n.exports = function(o, a) {
        return { enumerable: !(1 & o), configurable: !(2 & o), writable: !(4 & o), value: a };
      };
    }, function(n, i) {
      var o = 0, a = Math.random();
      n.exports = function(r) {
        return "Symbol(".concat(r === void 0 ? "" : r, ")_", (++o + a).toString(36));
      };
    }, function(n, i) {
      n.exports = {};
    }, function(n, i, o) {
      var a = o(17);
      n.exports = function(r) {
        return Object(a(r));
      };
    }, function(n, i) {
      n.exports = function(o) {
        if (o == null)
          throw TypeError("Can't call method on  " + o);
        return o;
      };
    }, function(n, i) {
      n.exports = !1;
    }, function(n, i, o) {
      var a = o(1), r = o(3), s = o(6), l = o(14)("src"), d = Function.toString, y = ("" + d).split("toString");
      o(7).inspectSource = function(u) {
        return d.call(u);
      }, (n.exports = function(u, m, h, c) {
        var g = typeof h == "function";
        g && (s(h, "name") || r(h, "name", m)), u[m] !== h && (g && (s(h, l) || r(h, l, u[m] ? "" + u[m] : y.join(String(m)))), u === a ? u[m] = h : c ? u[m] ? u[m] = h : r(u, m, h) : (delete u[m], r(u, m, h)));
      })(Function.prototype, "toString", function() {
        return typeof this == "function" && this[l] || d.call(this);
      });
    }, function(n, i) {
      var o = {}.toString;
      n.exports = function(a) {
        return o.call(a).slice(8, -1);
      };
    }, function(n, i) {
      i.f = {}.propertyIsEnumerable;
    }, function(n, i) {
      var o = Math.ceil, a = Math.floor;
      n.exports = function(r) {
        return isNaN(r = +r) ? 0 : (r > 0 ? a : o)(r);
      };
    }, function(n, i, o) {
      var a = o(5);
      n.exports = function(r, s) {
        if (!a(r))
          return r;
        var l, d;
        if (s && typeof (l = r.toString) == "function" && !a(d = l.call(r)) || typeof (l = r.valueOf) == "function" && !a(d = l.call(r)) || !s && typeof (l = r.toString) == "function" && !a(d = l.call(r)))
          return d;
        throw TypeError("Can't convert object to primitive value");
      };
    }, function(n, i, o) {
      var a = o(47);
      n.exports = function(r, s, l) {
        if (a(r), s === void 0)
          return r;
        switch (l) {
          case 1:
            return function(d) {
              return r.call(s, d);
            };
          case 2:
            return function(d, y) {
              return r.call(s, d, y);
            };
          case 3:
            return function(d, y, u) {
              return r.call(s, d, y, u);
            };
        }
        return function() {
          return r.apply(s, arguments);
        };
      };
    }, function(n, i, o) {
      var a = o(20);
      n.exports = Object("z").propertyIsEnumerable(0) ? Object : function(r) {
        return a(r) == "String" ? r.split("") : Object(r);
      };
    }, function(n, i, o) {
      var a = o(22), r = Math.min;
      n.exports = function(s) {
        return s > 0 ? r(a(s), 9007199254740991) : 0;
      };
    }, function(n, i, o) {
      var a = o(28)("keys"), r = o(14);
      n.exports = function(s) {
        return a[s] || (a[s] = r(s));
      };
    }, function(n, i, o) {
      var a = o(7), r = o(1), s = r["__core-js_shared__"] || (r["__core-js_shared__"] = {});
      (n.exports = function(l, d) {
        return s[l] || (s[l] = d !== void 0 ? d : {});
      })("versions", []).push({ version: a.version, mode: o(18) ? "pure" : "global", copyright: "© 2018 Denis Pushkarev (zloirock.ru)" });
    }, function(n, i) {
      n.exports = "constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf".split(",");
    }, function(n, i, o) {
      var a = o(4).f, r = o(6), s = o(0)("toStringTag");
      n.exports = function(l, d, y) {
        l && !r(l = y ? l : l.prototype, s) && a(l, s, { configurable: !0, value: d });
      };
    }, function(n, i, o) {
      var a = o(0)("unscopables"), r = Array.prototype;
      r[a] == null && o(3)(r, a, {}), n.exports = function(s) {
        r[a][s] = !0;
      };
    }, function(n, i) {
      i.f = Object.getOwnPropertySymbols;
    }, function(n, i, o) {
      var a = o(18), r = o(2), s = o(19), l = o(3), d = o(15), y = o(48), u = o(30), m = o(52), h = o(0)("iterator"), c = !([].keys && "next" in [].keys()), g = function() {
        return this;
      };
      n.exports = function(v, P, f, S, w, x, k) {
        y(f, P, S);
        var A, $, j, N = function(O) {
          if (!c && O in b)
            return b[O];
          switch (O) {
            case "keys":
            case "values":
              return function() {
                return new f(this, O);
              };
          }
          return function() {
            return new f(this, O);
          };
        }, M = P + " Iterator", D = w == "values", C = !1, b = v.prototype, p = b[h] || b["@@iterator"] || w && b[w], L = p || N(w), B = w ? D ? N("entries") : L : void 0, T = P == "Array" && b.entries || p;
        if (T && (j = m(T.call(new v()))) !== Object.prototype && j.next && (u(j, M, !0), a || typeof j[h] == "function" || l(j, h, g)), D && p && p.name !== "values" && (C = !0, L = function() {
          return p.call(this);
        }), a && !k || !c && !C && b[h] || l(b, h, L), d[P] = L, d[M] = g, w)
          if (A = { values: D ? L : N("values"), keys: x ? L : N("keys"), entries: B }, k)
            for ($ in A)
              $ in b || s(b, $, A[$]);
          else
            r(r.P + r.F * (c || C), P, A);
        return A;
      };
    }, function(n, i, o) {
      n.exports = !o(8) && !o(9)(function() {
        return Object.defineProperty(o(35)("div"), "a", { get: function() {
          return 7;
        } }).a != 7;
      });
    }, function(n, i, o) {
      var a = o(5), r = o(1).document, s = a(r) && a(r.createElement);
      n.exports = function(l) {
        return s ? r.createElement(l) : {};
      };
    }, function(n, i, o) {
      var a = o(12), r = o(49), s = o(29), l = o(27)("IE_PROTO"), d = function() {
      }, y = function() {
        var u, m = o(35)("iframe"), h = s.length;
        for (m.style.display = "none", o(51).appendChild(m), m.src = "javascript:", (u = m.contentWindow.document).open(), u.write("<script>document.F=Object<\/script>"), u.close(), y = u.F; h--; )
          delete y.prototype[s[h]];
        return y();
      };
      n.exports = Object.create || function(u, m) {
        var h;
        return u !== null ? (d.prototype = a(u), h = new d(), d.prototype = null, h[l] = u) : h = y(), m === void 0 ? h : r(h, m);
      };
    }, function(n, i, o) {
      var a = o(6), r = o(11), s = o(38)(!1), l = o(27)("IE_PROTO");
      n.exports = function(d, y) {
        var u, m = r(d), h = 0, c = [];
        for (u in m)
          u != l && a(m, u) && c.push(u);
        for (; y.length > h; )
          a(m, u = y[h++]) && (~s(c, u) || c.push(u));
        return c;
      };
    }, function(n, i, o) {
      var a = o(11), r = o(26), s = o(50);
      n.exports = function(l) {
        return function(d, y, u) {
          var m, h = a(d), c = r(h.length), g = s(u, c);
          if (l && y != y) {
            for (; c > g; )
              if ((m = h[g++]) != m)
                return !0;
          } else
            for (; c > g; g++)
              if ((l || g in h) && h[g] === y)
                return l || g || 0;
          return !l && -1;
        };
      };
    }, function(n, i, o) {
      var a = o(31), r = o(65), s = o(15), l = o(11);
      n.exports = o(33)(Array, "Array", function(d, y) {
        this._t = l(d), this._i = 0, this._k = y;
      }, function() {
        var d = this._t, y = this._k, u = this._i++;
        return !d || u >= d.length ? (this._t = void 0, r(1)) : r(0, y == "keys" ? u : y == "values" ? d[u] : [u, d[u]]);
      }, "values"), s.Arguments = s.Array, a("keys"), a("values"), a("entries");
    }, function(n, i, o) {
      var a = o(20);
      n.exports = Array.isArray || function(r) {
        return a(r) == "Array";
      };
    }, function(n, i, o) {
      var a = o(1), r = o(7), s = o(18), l = o(42), d = o(4).f;
      n.exports = function(y) {
        var u = r.Symbol || (r.Symbol = s ? {} : a.Symbol || {});
        y.charAt(0) == "_" || y in u || d(u, y, { value: l.f(y) });
      };
    }, function(n, i, o) {
      i.f = o(0);
    }, function(n, i, o) {
      var a = o(37), r = o(29).concat("length", "prototype");
      i.f = Object.getOwnPropertyNames || function(s) {
        return a(s, r);
      };
    }, function(n, i, o) {
      o.r(i), o(45), o(53), o(60), o(61), o(39), o(66), o(68), o(70), o(74), o(75), o(80);
      function a(h, c) {
        for (var g = 0; g < c.length; g++) {
          var v = c[g];
          v.enumerable = v.enumerable || !1, v.configurable = !0, "value" in v && (v.writable = !0), Object.defineProperty(h, v.key, v);
        }
      }
      var r = { methods: { $smoothReflow: function(h) {
        var c = function() {
          var g = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
          this._smoothElements.push(new u(g));
        }.bind(this);
        Array.isArray(h) ? h.forEach(c) : c(h);
      }, $unsmoothReflow: function(h) {
        var c = function() {
          var g = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : y(), v = this.$el, P = this._smoothElements.findIndex(function(f) {
            return l(v, f.options.el) === l(v, g.el);
          });
          if (P === -1)
            return void console.error("VSR_ERROR: $unsmoothReflow failed due to invalid el option");
          this._smoothElements[P].scheduleRemoval();
        }.bind(this);
        Array.isArray(h) ? h.forEach(c) : c(h);
      } }, beforeMount: function() {
        var h = this;
        this._smoothElements = [], this._endListener = function(c) {
          var g = !0, v = !1, P = void 0;
          try {
            for (var f, S = h._smoothElements[Symbol.iterator](); !(g = (f = S.next()).done); g = !0)
              f.value.endListener(c);
          } catch (w) {
            v = !0, P = w;
          } finally {
            try {
              g || S.return == null || S.return();
            } finally {
              if (v)
                throw P;
            }
          }
        };
      }, mounted: function() {
        this.$el.addEventListener("transitionend", this._endListener, { passive: !0 });
      }, destroyed: function() {
        this.$el.removeEventListener("transitionend", this._endListener, { passive: !0 });
      }, beforeUpdate: function() {
        this.$el.addEventListener("transitionend", this._endListener, { passive: !0 }), s(this);
        var h = !0, c = !1, g = void 0;
        try {
          for (var v, P = this._smoothElements[Symbol.iterator](); !(h = (v = P.next()).done); h = !0) {
            var f = v.value, S = l(this.$el, f.options.el);
            f.setSmoothElement(S), f.setBeforeValues();
          }
        } catch (w) {
          c = !0, g = w;
        } finally {
          try {
            h || P.return == null || P.return();
          } finally {
            if (c)
              throw g;
          }
        }
      }, updated: function() {
        var h = this;
        this.$nextTick(function() {
          var c = !0, g = !1, v = void 0;
          try {
            for (var P, f = h._smoothElements[Symbol.iterator](); !(c = (P = f.next()).done); c = !0) {
              var S = P.value, w = l(h.$el, S.options.el);
              S.setSmoothElement(w), S.doSmoothReflow();
            }
          } catch (x) {
            g = !0, v = x;
          } finally {
            try {
              c || f.return == null || f.return();
            } finally {
              if (g)
                throw v;
            }
          }
          s(h);
        });
      } };
      function s(h) {
        for (var c = h._smoothElements.length; c--; ) {
          var g = h._smoothElements[c];
          g.isRemoved && (g.stopTransition(), h._smoothElements.splice(c, 1));
        }
      }
      function l(h, c) {
        return !h || h instanceof Node && h.nodeType === Node.COMMENT_NODE ? null : c === null ? h : function(g, v) {
          return typeof v == "string" ? g.matches(v) ? g : g.querySelector(v) : v;
        }(h, c);
      }
      var d = { INACTIVE: "INACTIVE", ACTIVE: "ACTIVE" }, y = function() {
        return { el: null, property: "height", transitionEvent: null, hideOverflow: !0, debug: !1 };
      }, u = function() {
        function h(c) {
          (function(f, S) {
            if (!(f instanceof S))
              throw new TypeError("Cannot call a class as a function");
          })(this, h);
          var g = y();
          Object.assign(g, c);
          var v = this.parsePropertyOption(g.property);
          g.transition || (g.transition = v.map(function(f) {
            return "".concat(f, " .5s");
          }).join(","));
          var P = { $smoothEl: null, properties: v, beforeRect: {}, state: d.INACTIVE, isRemoved: !1 };
          Object.assign(this, { options: g }, P), this.endListener = this.endListener.bind(this), this.debug = this.debug.bind(this);
        }
        return function(c, g, v) {
          g && a(c.prototype, g), v && a(c, v);
        }(h, [{ key: "setSmoothElement", value: function(c) {
          this.$smoothEl = c;
        } }, { key: "transitionTo", value: function(c) {
          this.state = c;
        } }, { key: "parsePropertyOption", value: function(c) {
          return typeof c == "string" ? [c] : Array.isArray(c) ? c : [];
        } }, { key: "setBeforeValues", value: function() {
          var c = this.$smoothEl;
          if (this.beforeRect = {}, c) {
            var g = window.getComputedStyle(c) || {}, v = g.transition, P = g.overflowX, f = g.overflowY;
            this.computedTransition = v, this.overflowX = P, this.overflowY = f, this.beforeRect = m(c), this.state === d.ACTIVE && (this.stopTransition(), this.debug("Transition was interrupted."));
          }
        } }, { key: "didValuesChange", value: function(c, g) {
          var v = c, P = g;
          if (Object.keys(c).length === 0)
            return !1;
          var f = !0, S = !1, w = void 0;
          try {
            for (var x, k = this.properties[Symbol.iterator](); !(f = (x = k.next()).done); f = !0) {
              var A = x.value;
              if (A === "transform" && (v.top !== P.top || v.left !== P.left) || v[A] !== P[A])
                return !0;
            }
          } catch ($) {
            S = !0, w = $;
          } finally {
            try {
              f || k.return == null || k.return();
            } finally {
              if (S)
                throw w;
            }
          }
          return !1;
        } }, { key: "doSmoothReflow", value: function() {
          var c = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "data update", g = this.$smoothEl;
          if (!g)
            return this.debug("Could not find registered el to perform doSmoothReflow."), void this.transitionTo(d.INACTIVE);
          if (this.state !== d.ACTIVE) {
            var v = this.beforeRect, P = this.properties, f = this.options, S = this.overflowX, w = this.overflowY, x = this.debug;
            this.transitionTo(d.ACTIVE), x("doSmoothReflow triggered by:", typeof c == "string" ? c : c.target);
            var k = m(g);
            if (!this.didValuesChange(v, k))
              return x("Property values did not change."), void this.transitionTo(d.INACTIVE);
            x("beforeRect", v), x("afterRect", k), this.saveOverflowValues(g, S, w);
            var A = !0, $ = !1, j = void 0;
            try {
              for (var N, M = P[Symbol.iterator](); !(A = (N = M.next()).done); A = !0) {
                var D = N.value;
                if (D === "transform") {
                  var C = v.left - k.left, b = v.top - k.top;
                  g.style.transform = "translate(".concat(C, "px, ").concat(b, "px)");
                } else
                  g.style[D] = v[D] + "px";
              }
            } catch (R) {
              $ = !0, j = R;
            } finally {
              try {
                A || M.return == null || M.return();
              } finally {
                if ($)
                  throw j;
              }
            }
            g.offsetHeight, g.style.transition = [this.computedTransition, f.transition].filter(function(R) {
              return R;
            }).join(",");
            var p = !0, L = !1, B = void 0;
            try {
              for (var T, O = P[Symbol.iterator](); !(p = (T = O.next()).done); p = !0) {
                var I = T.value;
                I === "transform" ? g.style.transform = "" : g.style[I] = k[I] + "px";
              }
            } catch (R) {
              L = !0, B = R;
            } finally {
              try {
                p || O.return == null || O.return();
              } finally {
                if (L)
                  throw B;
              }
            }
          }
        } }, { key: "endListener", value: function(c) {
          var g = this.$smoothEl, v = this.properties;
          g === c.target ? v.includes(c.propertyName) && (this.stopTransition(), this.hasRegisteredEventEmitter() && this.setBeforeValues()) : this.isRegisteredEventEmitter(g, c) && this.doSmoothReflow(c);
        } }, { key: "hasRegisteredEventEmitter", value: function() {
          var c = this.options.transitionEvent;
          return c !== null && Object.keys(c).length > 0;
        } }, { key: "isRegisteredEventEmitter", value: function(c, g) {
          if (!this.hasRegisteredEventEmitter())
            return !1;
          var v = g.target, P = this.options.transitionEvent, f = P.selector, S = P.propertyName;
          if (S != null && S !== g.propertyName || f != null && !v.matches(f))
            return !1;
          if (this.properties.indexOf("transform") === -1) {
            var w = !1, x = g.composedPath ? g.composedPath() : [], k = !0, A = !1, $ = void 0;
            try {
              for (var j, N = x[Symbol.iterator](); !(k = (j = N.next()).done); k = !0)
                if (c === j.value) {
                  w = !0;
                  break;
                }
            } catch (M) {
              A = !0, $ = M;
            } finally {
              try {
                k || N.return == null || N.return();
              } finally {
                if (A)
                  throw $;
              }
            }
            if (!w)
              return !1;
          }
          return !0;
        } }, { key: "saveOverflowValues", value: function(c, g, v) {
          this.options.hideOverflow && (this.overflowX = g, this.overflowY = v, c.style.overflowX = "hidden", c.style.overflowY = "hidden");
        } }, { key: "restoreOverflowValues", value: function(c) {
          var g = this.options, v = this.overflowX, P = this.overflowY;
          g.hideOverflow && (c.style.overflowX = v, c.style.overflowY = P);
        } }, { key: "stopTransition", value: function() {
          var c = this.$smoothEl, g = this.properties, v = !0, P = !1, f = void 0;
          try {
            for (var S, w = g[Symbol.iterator](); !(v = (S = w.next()).done); v = !0) {
              var x = S.value;
              c.style[x] = null;
            }
          } catch (k) {
            P = !0, f = k;
          } finally {
            try {
              v || w.return == null || w.return();
            } finally {
              if (P)
                throw f;
            }
          }
          this.restoreOverflowValues(c), c.style.transition = null, this.transitionTo(d.INACTIVE);
        } }, { key: "scheduleRemoval", value: function() {
          this.isRemoved = !0;
        } }, { key: "debug", value: function() {
          if (this.options.debug) {
            var c = ["VSR_DEBUG:"].concat(Array.from(arguments));
            console.log.apply(null, c);
          }
        } }]), h;
      }(), m = function(h) {
        h.style.overflow = "hidden";
        var c = h.getBoundingClientRect(), g = c.top, v = c.right, P = c.bottom, f = c.left, S = c.width, w = c.height, x = c.x, k = c.y;
        return h.style.overflow = null, { top: g, right: v, bottom: P, left: f, width: S, height: w, x, y: k };
      };
      typeof Element < "u" && Element.prototype && !Element.prototype.matches && (Element.prototype.matches = Element.prototype.matchesSelector || Element.prototype.mozMatchesSelector || Element.prototype.msMatchesSelector || Element.prototype.oMatchesSelector || Element.prototype.webkitMatchesSelector || function(h) {
        for (var c = (this.document || this.ownerDocument).querySelectorAll(h), g = c.length; --g >= 0 && c.item(g) !== this; )
          ;
        return g > -1;
      }), i.default = r;
    }, function(n, i, o) {
      var a = o(46)(!0);
      o(33)(String, "String", function(r) {
        this._t = String(r), this._i = 0;
      }, function() {
        var r, s = this._t, l = this._i;
        return l >= s.length ? { value: void 0, done: !0 } : (r = a(s, l), this._i += r.length, { value: r, done: !1 });
      });
    }, function(n, i, o) {
      var a = o(22), r = o(17);
      n.exports = function(s) {
        return function(l, d) {
          var y, u, m = String(r(l)), h = a(d), c = m.length;
          return h < 0 || h >= c ? s ? "" : void 0 : (y = m.charCodeAt(h)) < 55296 || y > 56319 || h + 1 === c || (u = m.charCodeAt(h + 1)) < 56320 || u > 57343 ? s ? m.charAt(h) : y : s ? m.slice(h, h + 2) : u - 56320 + (y - 55296 << 10) + 65536;
        };
      };
    }, function(n, i) {
      n.exports = function(o) {
        if (typeof o != "function")
          throw TypeError(o + " is not a function!");
        return o;
      };
    }, function(n, i, o) {
      var a = o(36), r = o(13), s = o(30), l = {};
      o(3)(l, o(0)("iterator"), function() {
        return this;
      }), n.exports = function(d, y, u) {
        d.prototype = a(l, { next: r(1, u) }), s(d, y + " Iterator");
      };
    }, function(n, i, o) {
      var a = o(4), r = o(12), s = o(10);
      n.exports = o(8) ? Object.defineProperties : function(l, d) {
        r(l);
        for (var y, u = s(d), m = u.length, h = 0; m > h; )
          a.f(l, y = u[h++], d[y]);
        return l;
      };
    }, function(n, i, o) {
      var a = o(22), r = Math.max, s = Math.min;
      n.exports = function(l, d) {
        return (l = a(l)) < 0 ? r(l + d, 0) : s(l, d);
      };
    }, function(n, i, o) {
      var a = o(1).document;
      n.exports = a && a.documentElement;
    }, function(n, i, o) {
      var a = o(6), r = o(16), s = o(27)("IE_PROTO"), l = Object.prototype;
      n.exports = Object.getPrototypeOf || function(d) {
        return d = r(d), a(d, s) ? d[s] : typeof d.constructor == "function" && d instanceof d.constructor ? d.constructor.prototype : d instanceof Object ? l : null;
      };
    }, function(n, i, o) {
      var a = o(24), r = o(2), s = o(16), l = o(54), d = o(55), y = o(26), u = o(56), m = o(57);
      r(r.S + r.F * !o(59)(function(h) {
        Array.from(h);
      }), "Array", { from: function(h) {
        var c, g, v, P, f = s(h), S = typeof this == "function" ? this : Array, w = arguments.length, x = w > 1 ? arguments[1] : void 0, k = x !== void 0, A = 0, $ = m(f);
        if (k && (x = a(x, w > 2 ? arguments[2] : void 0, 2)), $ == null || S == Array && d($))
          for (g = new S(c = y(f.length)); c > A; A++)
            u(g, A, k ? x(f[A], A) : f[A]);
        else
          for (P = $.call(f), g = new S(); !(v = P.next()).done; A++)
            u(g, A, k ? l(P, x, [v.value, A], !0) : v.value);
        return g.length = A, g;
      } });
    }, function(n, i, o) {
      var a = o(12);
      n.exports = function(r, s, l, d) {
        try {
          return d ? s(a(l)[0], l[1]) : s(l);
        } catch (u) {
          var y = r.return;
          throw y !== void 0 && a(y.call(r)), u;
        }
      };
    }, function(n, i, o) {
      var a = o(15), r = o(0)("iterator"), s = Array.prototype;
      n.exports = function(l) {
        return l !== void 0 && (a.Array === l || s[r] === l);
      };
    }, function(n, i, o) {
      var a = o(4), r = o(13);
      n.exports = function(s, l, d) {
        l in s ? a.f(s, l, r(0, d)) : s[l] = d;
      };
    }, function(n, i, o) {
      var a = o(58), r = o(0)("iterator"), s = o(15);
      n.exports = o(7).getIteratorMethod = function(l) {
        if (l != null)
          return l[r] || l["@@iterator"] || s[a(l)];
      };
    }, function(n, i, o) {
      var a = o(20), r = o(0)("toStringTag"), s = a(function() {
        return arguments;
      }()) == "Arguments";
      n.exports = function(l) {
        var d, y, u;
        return l === void 0 ? "Undefined" : l === null ? "Null" : typeof (y = function(m, h) {
          try {
            return m[h];
          } catch {
          }
        }(d = Object(l), r)) == "string" ? y : s ? a(d) : (u = a(d)) == "Object" && typeof d.callee == "function" ? "Arguments" : u;
      };
    }, function(n, i, o) {
      var a = o(0)("iterator"), r = !1;
      try {
        var s = [7][a]();
        s.return = function() {
          r = !0;
        }, Array.from(s, function() {
          throw 2;
        });
      } catch {
      }
      n.exports = function(l, d) {
        if (!d && !r)
          return !1;
        var y = !1;
        try {
          var u = [7], m = u[a]();
          m.next = function() {
            return { done: y = !0 };
          }, u[a] = function() {
            return m;
          }, l(u);
        } catch {
        }
        return y;
      };
    }, function(n, i, o) {
      var a = o(2), r = o(38)(!0);
      a(a.P, "Array", { includes: function(s) {
        return r(this, s, arguments.length > 1 ? arguments[1] : void 0);
      } }), o(31)("includes");
    }, function(n, i, o) {
      var a = o(2), r = o(62);
      a(a.P + a.F * o(64)("includes"), "String", { includes: function(s) {
        return !!~r(this, s, "includes").indexOf(s, arguments.length > 1 ? arguments[1] : void 0);
      } });
    }, function(n, i, o) {
      var a = o(63), r = o(17);
      n.exports = function(s, l, d) {
        if (a(l))
          throw TypeError("String#" + d + " doesn't accept regex!");
        return String(r(s));
      };
    }, function(n, i, o) {
      var a = o(5), r = o(20), s = o(0)("match");
      n.exports = function(l) {
        var d;
        return a(l) && ((d = l[s]) !== void 0 ? !!d : r(l) == "RegExp");
      };
    }, function(n, i, o) {
      var a = o(0)("match");
      n.exports = function(r) {
        var s = /./;
        try {
          "/./"[r](s);
        } catch {
          try {
            return s[a] = !1, !"/./"[r](s);
          } catch {
          }
        }
        return !0;
      };
    }, function(n, i) {
      n.exports = function(o, a) {
        return { value: a, done: !!o };
      };
    }, function(n, i, o) {
      var a = o(16), r = o(10);
      o(67)("keys", function() {
        return function(s) {
          return r(a(s));
        };
      });
    }, function(n, i, o) {
      var a = o(2), r = o(7), s = o(9);
      n.exports = function(l, d) {
        var y = (r.Object || {})[l] || Object[l], u = {};
        u[l] = d(y), a(a.S + a.F * s(function() {
          y(1);
        }), "Object", u);
      };
    }, function(n, i, o) {
      var a = o(2);
      a(a.S + a.F, "Object", { assign: o(69) });
    }, function(n, i, o) {
      var a = o(10), r = o(32), s = o(21), l = o(16), d = o(25), y = Object.assign;
      n.exports = !y || o(9)(function() {
        var u = {}, m = {}, h = Symbol(), c = "abcdefghijklmnopqrst";
        return u[h] = 7, c.split("").forEach(function(g) {
          m[g] = g;
        }), y({}, u)[h] != 7 || Object.keys(y({}, m)).join("") != c;
      }) ? function(u, m) {
        for (var h = l(u), c = arguments.length, g = 1, v = r.f, P = s.f; c > g; )
          for (var f, S = d(arguments[g++]), w = v ? a(S).concat(v(S)) : a(S), x = w.length, k = 0; x > k; )
            P.call(S, f = w[k++]) && (h[f] = S[f]);
        return h;
      } : y;
    }, function(n, i, o) {
      var a = o(2), r = o(71)(6), s = "findIndex", l = !0;
      s in [] && Array(1)[s](function() {
        l = !1;
      }), a(a.P + a.F * l, "Array", { findIndex: function(d) {
        return r(this, d, arguments.length > 1 ? arguments[1] : void 0);
      } }), o(31)(s);
    }, function(n, i, o) {
      var a = o(24), r = o(25), s = o(16), l = o(26), d = o(72);
      n.exports = function(y, u) {
        var m = y == 1, h = y == 2, c = y == 3, g = y == 4, v = y == 6, P = y == 5 || v, f = u || d;
        return function(S, w, x) {
          for (var k, A, $ = s(S), j = r($), N = a(w, x, 3), M = l(j.length), D = 0, C = m ? f(S, M) : h ? f(S, 0) : void 0; M > D; D++)
            if ((P || D in j) && (A = N(k = j[D], D, $), y)) {
              if (m)
                C[D] = A;
              else if (A)
                switch (y) {
                  case 3:
                    return !0;
                  case 5:
                    return k;
                  case 6:
                    return D;
                  case 2:
                    C.push(k);
                }
              else if (g)
                return !1;
            }
          return v ? -1 : c || g ? g : C;
        };
      };
    }, function(n, i, o) {
      var a = o(73);
      n.exports = function(r, s) {
        return new (a(r))(s);
      };
    }, function(n, i, o) {
      var a = o(5), r = o(40), s = o(0)("species");
      n.exports = function(l) {
        var d;
        return r(l) && (typeof (d = l.constructor) != "function" || d !== Array && !r(d.prototype) || (d = void 0), a(d) && (d = d[s]) === null && (d = void 0)), d === void 0 ? Array : d;
      };
    }, function(n, i, o) {
      o(41)("asyncIterator");
    }, function(n, i, o) {
      var a = o(1), r = o(6), s = o(8), l = o(2), d = o(19), y = o(76).KEY, u = o(9), m = o(28), h = o(30), c = o(14), g = o(0), v = o(42), P = o(41), f = o(77), S = o(40), w = o(12), x = o(5), k = o(11), A = o(23), $ = o(13), j = o(36), N = o(78), M = o(79), D = o(4), C = o(10), b = M.f, p = D.f, L = N.f, B = a.Symbol, T = a.JSON, O = T && T.stringify, I = g("_hidden"), R = g("toPrimitive"), Y = {}.propertyIsEnumerable, F = m("symbol-registry"), U = m("symbols"), Q = m("op-symbols"), J = Object.prototype, ee = typeof B == "function", V = a.QObject, G = !V || !V.prototype || !V.prototype.findChild, W = s && u(function() {
        return j(p({}, "a", { get: function() {
          return p(this, "a", { value: 7 }).a;
        } })).a != 7;
      }) ? function(le, se, he) {
        var ve = b(J, se);
        ve && delete J[se], p(le, se, he), ve && le !== J && p(J, se, ve);
      } : p, ae = function(le) {
        var se = U[le] = j(B.prototype);
        return se._k = le, se;
      }, z = ee && typeof B.iterator == "symbol" ? function(le) {
        return typeof le == "symbol";
      } : function(le) {
        return le instanceof B;
      }, q = function(le, se, he) {
        return le === J && q(Q, se, he), w(le), se = A(se, !0), w(he), r(U, se) ? (he.enumerable ? (r(le, I) && le[I][se] && (le[I][se] = !1), he = j(he, { enumerable: $(0, !1) })) : (r(le, I) || p(le, I, $(1, {})), le[I][se] = !0), W(le, se, he)) : p(le, se, he);
      }, Z = function(le, se) {
        w(le);
        for (var he, ve = f(se = k(se)), ye = 0, be = ve.length; be > ye; )
          q(le, he = ve[ye++], se[he]);
        return le;
      }, ne = function(le) {
        var se = Y.call(this, le = A(le, !0));
        return !(this === J && r(U, le) && !r(Q, le)) && (!(se || !r(this, le) || !r(U, le) || r(this, I) && this[I][le]) || se);
      }, ie = function(le, se) {
        if (le = k(le), se = A(se, !0), le !== J || !r(U, se) || r(Q, se)) {
          var he = b(le, se);
          return !he || !r(U, se) || r(le, I) && le[I][se] || (he.enumerable = !0), he;
        }
      }, re = function(le) {
        for (var se, he = L(k(le)), ve = [], ye = 0; he.length > ye; )
          r(U, se = he[ye++]) || se == I || se == y || ve.push(se);
        return ve;
      }, de = function(le) {
        for (var se, he = le === J, ve = L(he ? Q : k(le)), ye = [], be = 0; ve.length > be; )
          !r(U, se = ve[be++]) || he && !r(J, se) || ye.push(U[se]);
        return ye;
      };
      ee || (d((B = function() {
        if (this instanceof B)
          throw TypeError("Symbol is not a constructor!");
        var le = c(arguments.length > 0 ? arguments[0] : void 0), se = function(he) {
          this === J && se.call(Q, he), r(this, I) && r(this[I], le) && (this[I][le] = !1), W(this, le, $(1, he));
        };
        return s && G && W(J, le, { configurable: !0, set: se }), ae(le);
      }).prototype, "toString", function() {
        return this._k;
      }), M.f = ie, D.f = q, o(43).f = N.f = re, o(21).f = ne, o(32).f = de, s && !o(18) && d(J, "propertyIsEnumerable", ne, !0), v.f = function(le) {
        return ae(g(le));
      }), l(l.G + l.W + l.F * !ee, { Symbol: B });
      for (var me = "hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables".split(","), ce = 0; me.length > ce; )
        g(me[ce++]);
      for (var pe = C(g.store), xe = 0; pe.length > xe; )
        P(pe[xe++]);
      l(l.S + l.F * !ee, "Symbol", { for: function(le) {
        return r(F, le += "") ? F[le] : F[le] = B(le);
      }, keyFor: function(le) {
        if (!z(le))
          throw TypeError(le + " is not a symbol!");
        for (var se in F)
          if (F[se] === le)
            return se;
      }, useSetter: function() {
        G = !0;
      }, useSimple: function() {
        G = !1;
      } }), l(l.S + l.F * !ee, "Object", { create: function(le, se) {
        return se === void 0 ? j(le) : Z(j(le), se);
      }, defineProperty: q, defineProperties: Z, getOwnPropertyDescriptor: ie, getOwnPropertyNames: re, getOwnPropertySymbols: de }), T && l(l.S + l.F * (!ee || u(function() {
        var le = B();
        return O([le]) != "[null]" || O({ a: le }) != "{}" || O(Object(le)) != "{}";
      })), "JSON", { stringify: function(le) {
        for (var se, he, ve = [le], ye = 1; arguments.length > ye; )
          ve.push(arguments[ye++]);
        if (he = se = ve[1], (x(se) || le !== void 0) && !z(le))
          return S(se) || (se = function(be, ke) {
            if (typeof he == "function" && (ke = he.call(this, be, ke)), !z(ke))
              return ke;
          }), ve[1] = se, O.apply(T, ve);
      } }), B.prototype[R] || o(3)(B.prototype, R, B.prototype.valueOf), h(B, "Symbol"), h(Math, "Math", !0), h(a.JSON, "JSON", !0);
    }, function(n, i, o) {
      var a = o(14)("meta"), r = o(5), s = o(6), l = o(4).f, d = 0, y = Object.isExtensible || function() {
        return !0;
      }, u = !o(9)(function() {
        return y(Object.preventExtensions({}));
      }), m = function(c) {
        l(c, a, { value: { i: "O" + ++d, w: {} } });
      }, h = n.exports = { KEY: a, NEED: !1, fastKey: function(c, g) {
        if (!r(c))
          return typeof c == "symbol" ? c : (typeof c == "string" ? "S" : "P") + c;
        if (!s(c, a)) {
          if (!y(c))
            return "F";
          if (!g)
            return "E";
          m(c);
        }
        return c[a].i;
      }, getWeak: function(c, g) {
        if (!s(c, a)) {
          if (!y(c))
            return !0;
          if (!g)
            return !1;
          m(c);
        }
        return c[a].w;
      }, onFreeze: function(c) {
        return u && h.NEED && y(c) && !s(c, a) && m(c), c;
      } };
    }, function(n, i, o) {
      var a = o(10), r = o(32), s = o(21);
      n.exports = function(l) {
        var d = a(l), y = r.f;
        if (y)
          for (var u, m = y(l), h = s.f, c = 0; m.length > c; )
            h.call(l, u = m[c++]) && d.push(u);
        return d;
      };
    }, function(n, i, o) {
      var a = o(11), r = o(43).f, s = {}.toString, l = typeof window == "object" && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [];
      n.exports.f = function(d) {
        return l && s.call(d) == "[object Window]" ? function(y) {
          try {
            return r(y);
          } catch {
            return l.slice();
          }
        }(d) : r(a(d));
      };
    }, function(n, i, o) {
      var a = o(21), r = o(13), s = o(11), l = o(23), d = o(6), y = o(34), u = Object.getOwnPropertyDescriptor;
      i.f = o(8) ? u : function(m, h) {
        if (m = s(m), h = l(h, !0), y)
          try {
            return u(m, h);
          } catch {
          }
        if (d(m, h))
          return r(!a.f.call(m, h), m[h]);
      };
    }, function(n, i, o) {
      for (var a = o(39), r = o(10), s = o(19), l = o(1), d = o(3), y = o(15), u = o(0), m = u("iterator"), h = u("toStringTag"), c = y.Array, g = { CSSRuleList: !0, CSSStyleDeclaration: !1, CSSValueList: !1, ClientRectList: !1, DOMRectList: !1, DOMStringList: !1, DOMTokenList: !0, DataTransferItemList: !1, FileList: !1, HTMLAllCollection: !1, HTMLCollection: !1, HTMLFormElement: !1, HTMLSelectElement: !1, MediaList: !0, MimeTypeArray: !1, NamedNodeMap: !1, NodeList: !0, PaintRequestList: !1, Plugin: !1, PluginArray: !1, SVGLengthList: !1, SVGNumberList: !1, SVGPathSegList: !1, SVGPointList: !1, SVGStringList: !1, SVGTransformList: !1, SourceBufferList: !1, StyleSheetList: !0, TextTrackCueList: !1, TextTrackList: !1, TouchList: !1 }, v = r(g), P = 0; P < v.length; P++) {
        var f, S = v[P], w = g[S], x = l[S], k = x && x.prototype;
        if (k && (k[m] || d(k, m, c), k[h] || d(k, h, S), y[S] = c, w))
          for (f in a)
            k[f] || s(k, f, a[f], !0);
      }
    }]).default;
  });
})(tS);
var R9 = tS.exports;
const N9 = /* @__PURE__ */ en(R9), $9 = Be({
  name: "SmoothReflow",
  mixins: [N9],
  props: {
    tag: {
      type: String,
      default: "div"
    }
  },
  mounted() {
    this.$smoothReflow(this.options);
  }
});
function F9(e, t, n, i, o, a) {
  return E(), fe(tt(e.tag), null, {
    default: Se(() => [
      je(e.$slots, "default")
    ]),
    _: 3
  });
}
const Br = /* @__PURE__ */ Fe($9, [["render", F9]]), j9 = Be({
  props: ["id"]
});
function H9(e, t, n, i, o, a) {
  return E(), X("div", null, [
    oe("span", null, " Could not render - " + Ie(e.id), 1)
  ]);
}
const z9 = /* @__PURE__ */ Fe(j9, [["render", H9]]);
var V9 = (e, t) => {
  for (const [n, i] of t)
    e[n] = i;
  return e;
};
const G9 = {}, U9 = /* @__PURE__ */ oe("h1", null, "Something went wrong!", -1), W9 = /* @__PURE__ */ oe("p", null, "Please try again.", -1), Y9 = [
  U9,
  W9
];
function q9(e, t) {
  return E(), X("div", null, Y9);
}
var K9 = /* @__PURE__ */ V9(G9, [["render", q9]]);
const nS = /* @__PURE__ */ Be({
  props: {
    fallBack: { type: null, required: !1, default: K9 },
    onError: { type: Function, required: !1, default: () => {
    } },
    params: { type: Object, required: !1, default: () => ({}) },
    stopPropagation: { type: Boolean, required: !1, default: !1 }
  },
  emits: ["error-captured"],
  setup(e, { emit: t }) {
    const n = e, i = ge(!1), o = ge(null), a = ge(""), r = Jt();
    return !r.default && !r.boundary && console.warn("ErrorBoundary component must have child components."), $L((s, l, d) => {
      if (i.value = !0, o.value = s, a.value = d, n?.onError(s, l, d), t("error-captured", { error: s, vm: l, info: d }), n.stopPropagation)
        return !1;
    }), (s, l) => _(r).boundary ? je(s.$slots, "boundary", Ce({
      key: 1,
      hasError: i.value,
      error: o.value,
      info: a.value
    }, e.params)) : (E(), X(Re, { key: 0 }, [
      i.value ? (E(), fe(tt(n.fallBack), si(Ce({ key: 1 }, e.params)), null, 16)) : je(s.$slots, "default", { key: 0 })
    ], 64));
  }
}), X9 = {
  class: "d-table-of-contents",
  role: "tablist"
}, Z9 = ["data-event_component_name", "data-event_title", "data-event_source", "aria-selected", "onClick", "onKeydown"], J9 = /* @__PURE__ */ Be({
  __name: "TableOfContents",
  props: {
    itemList: {
      type: Array,
      default: () => [],
      required: !0
    },
    initialItemSelected: {
      type: Number,
      default: 0
    },
    showActiveElement: {
      type: Boolean,
      default: !0
    },
    dataEventSource: {
      type: String,
      default: ""
    },
    dataEventComponent: {
      type: String,
      default: ""
    },
    activeIcon: {
      type: String,
      default: void 0
    }
  },
  emits: ["click"],
  setup(e, { emit: t }) {
    const n = e, i = ge(n.itemList), o = ge(n.initialItemSelected), a = t;
    function r(s) {
      o.value = s, a("click", s);
    }
    return (s, l) => (E(), X("div", X9, [
      (E(!0), X(Re, null, Ge(i.value, (d, y) => (E(), X("a", {
        key: d + y,
        class: Pe(["d-table-of-contents__item-link", {
          "d-table-of-contents__item-link--active": e.showActiveElement && o.value === y,
          "d-table-of-contents__item-link--has-icon": e.activeIcon && o.value !== y,
          "d-table-of-contents__item-link--has-icon--active": e.activeIcon && o.value === y && e.showActiveElement
        }]),
        tabindex: "0",
        role: "tab",
        "data-event_component_name": e.dataEventComponent,
        "data-event_title": d,
        "data-event_source": e.dataEventSource,
        "aria-selected": o.value === y,
        onClick: (u) => r(y),
        onKeydown: Ze((u) => r(y), ["enter"])
      }, [
        e.activeIcon && o.value === y ? (E(), fe(_(_t), {
          key: 0,
          class: "d-table-of-contents__item-link--icon",
          "base-icon": e.activeIcon,
          "base-icon-color": _(gt).White
        }, null, 8, ["base-icon", "base-icon-color"])) : te("", !0),
        Ve(" " + Ie(d), 1)
      ], 42, Z9))), 128))
    ]));
  }
});
const iS = /* @__PURE__ */ Fe(J9, [["__scopeId", "data-v-d2a17c06"]]), Q9 = ["href", "target", "tabindex", "title", "aria-disabled", "data-event_linktype", "data-event_source", "data-event_target", "data-event_title", "data-event_engagement", "data-event_component_name", "data-event_component_headline"], e7 = { key: 0 }, t7 = ["target", "tabindex", "title", "aria-disabled", "data-event_linktype", "data-event_source", "data-event_target", "data-event_title", "data-event_engagement", "data-event_component_name", "data-event_component_headline"], n7 = { key: 0 }, i7 = /* @__PURE__ */ Be({
  __name: "BaseButtonV2",
  props: {
    linkModel: {
      type: Object,
      required: !0
    },
    type: {
      type: String,
      default: Ke.Primary
    },
    buttonType: {
      type: String,
      default: zt.Button
    },
    size: {
      type: String,
      default: et.Large
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    icon: {
      type: String,
      default: null
    },
    iconPosition: {
      type: String,
      default: ct.Right
    },
    active: {
      type: Boolean,
      default: !1
    },
    tabindex: {
      type: Number,
      default: void 0
    }
  },
  emits: ["click"],
  setup(e, { emit: t }) {
    const n = t;
    return (i, o) => {
      const a = $e("BaseIcon");
      return e.buttonType === _(zt).Link ? (E(), X("a", {
        key: 0,
        href: e.linkModel?.href ?? "javascript:void(0)",
        target: e.linkModel?.target,
        class: Pe(["d-base-button", {
          "d-base-button--primary": e.type === _(Ke).Primary,
          "d-base-button--secondary": e.type === _(Ke).Secondary,
          "d-base-button--tertiary": e.type === _(Ke).Tertiary,
          "d-base-button--ghost": e.type === _(Ke).Ghost,
          "d-base-button--large": e.size === _(et).Large,
          "d-base-button--medium": e.size === _(et).Medium,
          "d-base-button--small": e.size === _(et).Small,
          "d-disabled": e.disabled,
          "d-base-button--active": e.active,
          "d-base-button--icon": e.icon !== null && e.iconPosition
        }]),
        tabindex: e.tabindex ? e.tabindex : e.disabled ? -1 : 0,
        title: e.linkModel?.title,
        "aria-disabled": e.disabled,
        "data-event_linktype": e.linkModel?.tealiumTrackingModel?.eventLinkType,
        "data-event_source": e.linkModel?.tealiumTrackingModel?.eventSource,
        "data-event_target": e.linkModel?.tealiumTrackingModel?.eventTarget,
        "data-event_title": e.linkModel?.tealiumTrackingModel?.eventTitle,
        "data-event_engagement": e.linkModel?.tealiumTrackingModel?.eventEngagement,
        "data-event_component_name": e.linkModel?.tealiumTrackingModel?.eventComponentName,
        "data-event_component_headline": e.linkModel?.tealiumTrackingModel?.eventComponentHeadline,
        onClick: o[0] || (o[0] = (r) => n("click", r))
      }, [
        je(i.$slots, "custom-icon", {}, () => [
          e.icon !== null && e.iconPosition === _(ct).Left ? (E(), fe(a, {
            key: 0,
            class: "mr-1.5",
            "base-icon": e.icon,
            "base-icon-size": _(md)[e.size]
          }, null, 8, ["base-icon", "base-icon-size"])) : te("", !0)
        ], !0),
        e.linkModel?.text != "" ? (E(), X("span", e7, Ie(e.linkModel?.text), 1)) : te("", !0),
        e.icon !== null && e.iconPosition === _(ct).Right ? (E(), fe(a, {
          key: 1,
          class: "ml-1.5",
          "base-icon": e.icon,
          "base-icon-size": _(md)[e.size]
        }, null, 8, ["base-icon", "base-icon-size"])) : te("", !0)
      ], 10, Q9)) : (E(), X("button", {
        key: 1,
        type: "submit",
        target: e.linkModel?.target,
        class: Pe(["d-base-button", {
          "d-base-button--primary": e.type === _(Ke).Primary,
          "d-base-button--secondary": e.type === _(Ke).Secondary,
          "d-base-button--tertiary": e.type === _(Ke).Tertiary,
          "d-base-button--ghost": e.type === _(Ke).Ghost,
          "d-base-button--large": e.size === _(et).Large,
          "d-base-button--medium": e.size === _(et).Medium,
          "d-base-button--small": e.size === _(et).Small,
          "d-disabled": e.disabled,
          "d-base-button--icon-left": e.icon !== null && e.iconPosition === _(ct).Left,
          "d-base-button--icon-right": e.icon !== null && e.iconPosition === _(ct).Right,
          "d-base-button--active": e.active
        }]),
        tabindex: e.tabindex ? e.tabindex : e.disabled ? -1 : 0,
        title: e.linkModel?.title,
        "aria-disabled": e.disabled,
        "data-event_linktype": e.linkModel?.tealiumTrackingModel?.eventLinkType,
        "data-event_source": e.linkModel?.tealiumTrackingModel?.eventSource,
        "data-event_target": e.linkModel?.tealiumTrackingModel?.eventTarget,
        "data-event_title": e.linkModel?.tealiumTrackingModel?.eventTitle,
        "data-event_engagement": e.linkModel?.tealiumTrackingModel?.eventEngagement,
        "data-event_component_name": e.linkModel?.tealiumTrackingModel?.eventComponentName,
        "data-event_component_headline": e.linkModel?.tealiumTrackingModel?.eventComponentHeadline,
        onClick: o[1] || (o[1] = (r) => n("click", r))
      }, [
        je(i.$slots, "custom-icon", {}, () => [
          e.icon !== null && e.iconPosition === _(ct).Left ? (E(), fe(a, {
            key: 0,
            "base-icon": e.icon,
            "base-icon-size": _(md)[e.size]
          }, null, 8, ["base-icon", "base-icon-size"])) : te("", !0)
        ], !0),
        e.linkModel?.text != "" ? (E(), X("span", n7, Ie(e.linkModel?.text), 1)) : te("", !0),
        e.icon !== null && e.iconPosition === _(ct).Right ? (E(), fe(a, {
          key: 1,
          "base-icon": e.icon,
          "base-icon-size": _(md)[e.size]
        }, null, 8, ["base-icon", "base-icon-size"])) : te("", !0)
      ], 10, t7));
    };
  }
});
const vt = /* @__PURE__ */ Fe(i7, [["__scopeId", "data-v-50c29b4a"]]), a7 = Be({
  name: "ManagementBlock",
  components: {
    BaseLinkV2: ot,
    HTMLContentBlock: ht,
    TableOfContents: iS,
    ManagerCard: D9,
    PrimeButton: ki,
    DropDocuments: Zc,
    LinkItem: L9,
    SmoothReflow: Br,
    ErrorBoundary: nS
  },
  props: {
    valuesMain: {
      type: Object,
      required: !0
    },
    values: {
      type: Object,
      required: !0
    },
    navItems: {
      type: Object,
      required: !0
    },
    watch: {
      isPrint: function() {
        this.showShortList = !this.isPrint;
      }
    }
  },
  data() {
    return {
      showShortList: !0,
      selectedArticle: null,
      showFlag: !1,
      articleTextLimitLength: 300,
      expandFlagArticle: [],
      activeItem: 0,
      isInCopy: [],
      fallBack: z9
    };
  },
  computed: {
    IconPosition() {
      return ct;
    },
    LinkType() {
      return yt;
    },
    BaseIconType() {
      return H;
    },
    limitedList() {
      return this.showShortList ? this.values?.otherFundsByManager.list.slice(0, 5) : this.values.otherFundsByManager.list;
    },
    limitedMonthList() {
      return this.showShortList ? this.values?.months?.slice(0, 6) : this.values?.months;
    }
  },
  mounted() {
    this.isInCopy.fill(
      !1,
      0,
      this.values?.otherFundsByManager?.list?.length
    );
  },
  created() {
    const { pageName: e } = Qe();
    if (this.dataEventSource = e, Array.isArray(this.values?.months) && this.values?.months?.length > 0)
      for (let t = 0; t < this.values?.months[0]?.article.length; t++)
        this.expandFlagArticle.push(!1);
  },
  methods: {
    usePageName: Qe,
    sanitize(e) {
      const { htmlContentBlockWhitelist: t } = Li();
      return Ma(e, t);
    },
    checkAvailableManagerInfo() {
      for (let e = 0; e < this.values.managers?.length; e++)
        if (this.values.managers[e].generalInformationHtml !== null)
          return !0;
      return !1;
    },
    setTextLength(e, t) {
      return e.length > this.articleTextLimitLength && (t || (e = this.parseText(e, this.articleTextLimitLength))), e;
    },
    parseText(e, t) {
      if (e.length > t) {
        for (let n = t; n > 0; n--)
          if (e.charAt(n) === " " && (e.charAt(n - 1) != "," || e.charAt(n - 1) != "." || e.charAt(n - 1) != ";"))
            return e.substring(0, n) + "...";
        return e.substring(0, t) + "...";
      } else
        return e;
    },
    selectItemByElementName(e) {
      const t = this.values?.months.findIndex((n) => n.elementName === e);
      this.selectItem(t);
    },
    selectItem(e) {
      this.activeItem = e, this.expandFlagArticle = [];
      for (let t = 0; t < this.values?.months[e].article.length; t++)
        this.expandFlagArticle.push(!1);
    },
    copyIsin(e, t) {
      const n = navigator.clipboard, i = document.querySelector("#" + e);
      n.writeText(i.innerText), this.isInCopy[t] = !0, setTimeout(() => {
        this.isInCopy[t] = !1;
      }, 5e3);
    },
    moreAndLess() {
      this.showShortList = !this.showShortList;
    },
    getFundDetail(e) {
      Ue && window.open(e);
    }
  }
}), o7 = {
  key: 0,
  class: "management"
}, r7 = { class: "container" }, s7 = { class: "grid xs:grid-cols-1 lg:grid-cols-2 gap-5 lg:gap-10 mb-12 lg:mb-24 manager-cards" }, l7 = { key: 0 }, c7 = {
  key: 1,
  class: "manager-articles grid xs:grid-cols-1 lg:grid-cols-6 gap-x-8"
}, d7 = { class: "article-content xs:col-span-1 lg:col-span-4" }, u7 = { class: "commentary-head" }, h7 = { class: "bold" }, p7 = { class: "bordered" }, f7 = { key: 0 }, m7 = {
  key: 0,
  class: "bold"
}, g7 = { class: "articles__current-article" }, v7 = ["data-event_title", "data-event_source", "onClick"], y7 = {
  key: 0,
  class: "expand-element"
}, b7 = {
  key: 1,
  class: "expand-element"
}, x7 = { key: 0 }, w7 = { class: "bold" }, k7 = { class: "articles__current-article" }, S7 = { key: 0 }, C7 = { class: "articles__current-article" }, T7 = {
  key: 1,
  class: "pb-8"
}, L7 = { class: "bold" }, I7 = { class: "funds__item-list w-full" }, P7 = ["id"], A7 = { class: "isin-copy" }, _7 = ["value", "id", "aria-labelledby", "onClick"], M7 = ["data-event_title", "data-event_source"], O7 = {
  key: 0,
  class: "expand-element pt-4"
}, B7 = {
  key: 1,
  class: "expand-element pt-4"
}, E7 = {
  key: 0,
  class: "article-list"
};
function D7(e, t, n, i, o, a) {
  const r = $e("ManagerCard"), s = $e("LinkItem"), l = $e("DropDocuments"), d = $e("SmoothReflow"), y = $e("ErrorBoundary"), u = $e("HTMLContentBlock"), m = $e("PrimeButton"), h = $e("BaseLinkV2"), c = $e("TableOfContents"), g = Ut("tooltip");
  return e.values ? (E(), X("div", o7, [
    t[11] || (t[11] = oe("div", { class: "triangle-top" }, null, -1)),
    t[12] || (t[12] = oe("div", { class: "triangle-bottom" }, null, -1)),
    oe("div", r7, [
      oe("h2", null, Ie(e.values?.headlineText), 1),
      oe("div", s7, [
        (E(!0), X(Re, null, Ge(e.values?.managers, (v) => (E(), X("div", {
          key: v.name,
          class: "xs:col-span-1"
        }, [
          ue(r, { values: v }, null, 8, ["values"])
        ]))), 128))
      ]),
      e.values?.months === null || e.values?.months.length === 0 ? (E(), X("p", l7, Ie(e.values?.fallbackText), 1)) : te("", !0),
      e.values?.months && e.values?.months?.length ? (E(), X("div", c7, [
        oe("div", d7, [
          oe("div", u7, [
            oe("h2", h7, Ie(e.values?.currentCommentaryText), 1),
            t[2] || (t[2] = oe("hr", null, null, -1)),
            ue(l, {
              modelValue: e.selectedArticle,
              "onUpdate:modelValue": t[0] || (t[0] = (v) => e.selectedArticle = v),
              options: e.limitedMonthList,
              class: "w-full mb-8",
              "option-label": "elementName",
              "option-value": "elementName",
              placeholder: Array.isArray(e.limitedMonthList) && e.limitedMonthList.length > 0 ? e.limitedMonthList[0].elementName : ""
            }, {
              option: Se((v) => [
                oe("div", p7, [
                  ue(s, {
                    "anchor-url": v.option.url ? v.option.url : "javascript:void(0)",
                    "anchor-title": v.option.elementName,
                    "link-type": "internal",
                    tabindex: 0,
                    onClick: (P) => e.selectItemByElementName(v.option.elementName),
                    onKeydown: Ze((P) => e.selectItemByElementName(v.option.elementName), ["enter"])
                  }, null, 8, ["anchor-url", "anchor-title", "onClick", "onKeydown"])
                ])
              ]),
              _: 1
            }, 8, ["modelValue", "options", "placeholder"])
          ]),
          (E(!0), X(Re, null, Ge(e.values?.months, (v, P) => (E(), X("div", {
            key: v,
            class: "articles"
          }, [
            P === e.activeItem ? (E(), X("div", f7, [
              (E(!0), X(Re, null, Ge(v.article, (f, S) => (E(), X("div", { key: f }, [
                (E(), fe(y, {
                  key: f,
                  params: { id: f },
                  "fall-back": e.fallBack
                }, {
                  default: Se(() => [
                    f.text?.length !== 0 ? (E(), X(Re, { key: 0 }, [
                      f?.headlineText ? (E(), X("h3", m7, Ie(f.headlineText), 1)) : te("", !0),
                      ue(d, null, {
                        default: Se(() => [
                          oe("p", g7, Ie(e.setTextLength(f.text, e.expandFlagArticle[S])), 1)
                        ]),
                        _: 2
                      }, 1024),
                      f.text.length > e.articleTextLimitLength ? (E(), X("div", {
                        key: 1,
                        "data-event_component_name": "Accordion",
                        "data-event_title": e.valuesMain?.globalReadMore,
                        "data-event_source": e.dataEventSource,
                        onClick: (w) => e.expandFlagArticle[S] = !e.expandFlagArticle[S]
                      }, [
                        e.expandFlagArticle[S] ? (E(), X("p", b7, [
                          t[4] || (t[4] = oe("i", { class: "las la-minus" }, null, -1)),
                          Ve(" " + Ie(e.valuesMain?.globalReadLess), 1)
                        ])) : (E(), X("p", y7, [
                          t[3] || (t[3] = oe("i", { class: "las la-plus" }, null, -1)),
                          Ve(" " + Ie(e.valuesMain?.globalReadMore), 1)
                        ]))
                      ], 8, v7)) : te("", !0),
                      t[5] || (t[5] = oe("div", { class: "paragraph-line" }, null, -1))
                    ], 64)) : te("", !0)
                  ]),
                  _: 2
                }, 1032, ["params", "fall-back"]))
              ]))), 128)),
              e.checkAvailableManagerInfo() ? (E(), X("div", x7, [
                oe("h2", w7, Ie(e.values.managerInformationHeaderText), 1),
                t[6] || (t[6] = oe("hr", null, null, -1)),
                (E(!0), X(Re, null, Ge(e.values.managers, (f) => (E(), X("div", { key: f }, [
                  oe("p", null, [
                    oe("span", k7, [
                      ue(u, {
                        "html-text": f.generalInformationHtml,
                        "disable-default-styling": ""
                      }, null, 8, ["html-text"])
                    ])
                  ]),
                  f.educationHtml ? (E(), X("p", S7, [
                    oe("span", C7, [
                      ue(u, {
                        "html-text": f.educationHtml,
                        "disable-default-styling": ""
                      }, null, 8, ["html-text"])
                    ])
                  ])) : te("", !0)
                ]))), 128)),
                t[7] || (t[7] = oe("div", { class: "paragraph-line" }, null, -1))
              ])) : te("", !0),
              e.values.otherFundsByManager.list !== null && e.values.otherFundsByManager.list.length !== 0 ? (E(), X("div", T7, [
                oe("h2", L7, Ie(e.values.otherFundsByManager.headlineText), 1),
                t[10] || (t[10] = oe("hr", null, null, -1)),
                ue(d, null, {
                  default: Se(() => [
                    oe("ul", I7, [
                      (E(!0), X(Re, null, Ge(e.limitedList, (f, S) => (E(), X("li", { key: f }, [
                        oe("span", {
                          id: "indexFund-label-" + S
                        }, Ie(f.key), 9, P7),
                        oe("div", A7, [
                          oe("a", {
                            target: "blank",
                            class: "pr-2 input cursor-pointer",
                            value: f.value,
                            id: "indexFund-" + S,
                            "aria-labelledby": "indexFund-label-" + S,
                            tabindex: "-1",
                            onClick: (w) => e.getFundDetail(f.url)
                          }, Ie(f.value), 9, _7),
                          rt(ue(m, {
                            class: "p-button-text icon-isin",
                            icon: e.isInCopy[S] ? "las la-check" : "las la-copy",
                            "data-event_component_name": "Text Links (same page)",
                            "data-event_title": `Copy | ${f.value}`,
                            "data-event_source": e.dataEventSource,
                            "aria-label": e.valuesMain?.globalCopyButtonTextFalse,
                            onClick: (w) => e.copyIsin("indexFund-" + S, S)
                          }, null, 8, ["icon", "data-event_title", "data-event_source", "aria-label", "onClick"]), [
                            [
                              g,
                              e.valuesMain?.globalCopyButtonTextFalse,
                              void 0,
                              { top: !0 }
                            ]
                          ])
                        ])
                      ]))), 128))
                    ])
                  ]),
                  _: 2
                }, 1024),
                e.values.otherFundsByManager.list.length > 5 ? (E(), X("div", {
                  key: 0,
                  "data-event_component_name": "Accordion",
                  "data-event_title": e.valuesMain?.globalReadMore,
                  "data-event_source": e.dataEventSource,
                  onClick: t[1] || (t[1] = (...f) => e.moreAndLess && e.moreAndLess(...f))
                }, [
                  e.showShortList ? (E(), X("p", O7, [
                    t[8] || (t[8] = oe("i", { class: "las la-plus" }, null, -1)),
                    Ve(" " + Ie(e.valuesMain?.globalReadMore), 1)
                  ])) : (E(), X("p", B7, [
                    t[9] || (t[9] = oe("i", { class: "las la-minus" }, null, -1)),
                    Ve(" " + Ie(e.valuesMain?.globalReadLess), 1)
                  ]))
                ], 8, M7)) : te("", !0)
              ])) : te("", !0),
              e.values?.otherFundsByManager?.buttonTarget ? (E(), fe(h, {
                key: 2,
                class: "expand-link",
                "data-cy": "anchorTitle",
                "link-model": {
                  text: e.values.otherFundsByManager.buttonTarget.label,
                  title: e.values.otherFundsByManager.buttonTarget.label,
                  href: e.values.otherFundsByManager.buttonTarget.href,
                  target: e.values.otherFundsByManager.buttonTarget.target,
                  linkType: e.LinkType.Anchor,
                  tealiumTrackingModel: {
                    eventComponentName: "Text Links (next page)",
                    eventTitle: e.values.otherFundsByManager.buttonTarget.label,
                    eventSource: e.dataEventSource,
                    eventTarget: "_self"
                  }
                },
                icon: e.BaseIconType.ArrowDown,
                "icon-position": e.IconPosition.Left
              }, null, 8, ["link-model", "icon", "icon-position"])) : te("", !0)
            ])) : te("", !0)
          ]))), 128))
        ]),
        e.limitedMonthList.some((v) => v.elementName) ? (E(), X("div", E7, [
          ue(c, {
            class: "article-list__table-of-contents",
            "item-list": e.limitedMonthList.map((v) => v.elementName),
            "active-icon": e.BaseIconType.AngleLeft,
            "data-event-source": e.dataEventSource,
            "data-event-component": "Tab",
            onClick: e.selectItem
          }, null, 8, ["item-list", "active-icon", "data-event-source", "onClick"])
        ])) : te("", !0)
      ])) : te("", !0)
    ])
  ])) : te("", !0);
}
const yBe = /* @__PURE__ */ Fe(a7, [["render", D7]]);
var R7 = {
  root: function(t) {
    var n = t.instance, i = t.props;
    return ["p-checkbox p-component", {
      "p-checkbox-checked": n.checked,
      "p-checkbox-disabled": i.disabled,
      "p-checkbox-focused": n.focused
    }];
  },
  input: function(t) {
    var n = t.instance, i = t.props;
    return ["p-checkbox-box", {
      "p-highlight": n.checked,
      "p-disabled": i.disabled,
      "p-focus": n.focused
    }];
  },
  icon: "p-checkbox-icon"
}, N7 = Wt.extend({
  name: "checkbox",
  classes: R7
}), $7 = {
  name: "BaseCheckbox",
  extends: wt,
  props: {
    value: null,
    modelValue: null,
    binary: Boolean,
    name: {
      type: String,
      default: null
    },
    trueValue: {
      type: null,
      default: !0
    },
    falseValue: {
      type: null,
      default: !1
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    readonly: {
      type: Boolean,
      default: !1
    },
    required: {
      type: Boolean,
      default: !1
    },
    tabindex: {
      type: Number,
      default: null
    },
    inputId: {
      type: String,
      default: null
    },
    inputClass: {
      type: [String, Object],
      default: null
    },
    inputStyle: {
      type: Object,
      default: null
    },
    inputProps: {
      type: null,
      default: null
    },
    ariaLabelledby: {
      type: String,
      default: null
    },
    ariaLabel: {
      type: String,
      default: null
    }
  },
  style: N7,
  provide: function() {
    return {
      $parentInstance: this
    };
  }
};
function F7(e) {
  return V7(e) || z7(e) || H7(e) || j7();
}
function j7() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function H7(e, t) {
  if (e) {
    if (typeof e == "string")
      return pf(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set")
      return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return pf(e, t);
  }
}
function z7(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null)
    return Array.from(e);
}
function V7(e) {
  if (Array.isArray(e))
    return pf(e);
}
function pf(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, i = new Array(t); n < t; n++)
    i[n] = e[n];
  return i;
}
var ah = {
  name: "Checkbox",
  extends: $7,
  emits: ["click", "update:modelValue", "change", "input", "focus", "blur"],
  data: function() {
    return {
      focused: !1
    };
  },
  methods: {
    getPTOptions: function(t) {
      return this.ptm(t, {
        context: {
          checked: this.checked,
          focused: this.focused,
          disabled: this.disabled
        }
      });
    },
    onClick: function(t) {
      var n = this;
      if (!this.disabled && !this.readonly) {
        var i;
        this.binary ? i = this.checked ? this.falseValue : this.trueValue : this.checked ? i = this.modelValue.filter(function(o) {
          return !We.equals(o, n.value);
        }) : i = this.modelValue ? [].concat(F7(this.modelValue), [this.value]) : [this.value], this.$emit("click", t), this.$emit("update:modelValue", i), this.$emit("change", t), this.$emit("input", i), this.$refs.input.focus();
      }
    },
    onFocus: function(t) {
      this.focused = !0, this.$emit("focus", t);
    },
    onBlur: function(t) {
      this.focused = !1, this.$emit("blur", t);
    }
  },
  computed: {
    checked: function() {
      return this.binary ? this.modelValue === this.trueValue : We.contains(this.value, this.modelValue);
    }
  },
  components: {
    CheckIcon: Oa
  }
};
function fc(e) {
  "@babel/helpers - typeof";
  return fc = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, fc(e);
}
function eb(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    t && (i = i.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), n.push.apply(n, i);
  }
  return n;
}
function tb(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? eb(Object(n), !0).forEach(function(i) {
      G7(e, i, n[i]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : eb(Object(n)).forEach(function(i) {
      Object.defineProperty(e, i, Object.getOwnPropertyDescriptor(n, i));
    });
  }
  return e;
}
function G7(e, t, n) {
  return t = U7(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function U7(e) {
  var t = W7(e, "string");
  return fc(t) == "symbol" ? t : String(t);
}
function W7(e, t) {
  if (fc(e) != "object" || !e)
    return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var i = n.call(e, t || "default");
    if (fc(i) != "object")
      return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var Y7 = ["id", "value", "name", "checked", "tabindex", "disabled", "readonly", "required", "aria-labelledby", "aria-label"], q7 = ["data-p-highlight", "data-p-disabled", "data-p-focused"];
function K7(e, t, n, i, o, a) {
  var r = $e("CheckIcon");
  return E(), X("div", Ce({
    class: e.cx("root"),
    onClick: t[2] || (t[2] = function(s) {
      return a.onClick(s);
    })
  }, a.getPTOptions("root"), {
    "data-pc-name": "checkbox"
  }), [oe("div", Ce({
    class: "p-hidden-accessible"
  }, e.ptm("hiddenInputWrapper"), {
    "data-p-hidden-accessible": !0
  }), [oe("input", Ce({
    ref: "input",
    id: e.inputId,
    type: "checkbox",
    value: e.value,
    name: e.name,
    checked: a.checked,
    tabindex: e.tabindex,
    disabled: e.disabled,
    readonly: e.readonly,
    required: e.required,
    "aria-labelledby": e.ariaLabelledby,
    "aria-label": e.ariaLabel,
    onFocus: t[0] || (t[0] = function(s) {
      return a.onFocus(s);
    }),
    onBlur: t[1] || (t[1] = function(s) {
      return a.onBlur(s);
    })
  }, e.ptm("hiddenInput")), null, 16, Y7)], 16), oe("div", Ce({
    ref: "box",
    class: [e.cx("input"), e.inputClass],
    style: e.inputStyle
  }, tb(tb({}, e.inputProps), a.getPTOptions("input")), {
    "data-p-highlight": a.checked,
    "data-p-disabled": e.disabled,
    "data-p-focused": o.focused
  }), [je(e.$slots, "icon", {
    checked: a.checked,
    class: Pe(e.cx("icon"))
  }, function() {
    return [a.checked ? (E(), fe(r, Ce({
      key: 0,
      class: e.cx("icon")
    }, a.getPTOptions("icon")), null, 16, ["class"])) : te("", !0)];
  })], 16, q7)], 16);
}
ah.render = K7;
const X7 = Be({
  name: "NotificationBox",
  components: {
    AnchorButton: Em,
    Checkbox: ah
  },
  props: {
    valuesMain: {
      type: Object,
      required: !0,
      default: null
    },
    values: {
      type: Object,
      required: !0,
      default: null
    }
  },
  data() {
    return {
      checked: []
    };
  },
  mounted() {
    this.createNotifications();
  },
  updated() {
    this.createNotifications();
  },
  created() {
    const { pageName: e } = Qe();
    this.dataEventSource = e;
  },
  methods: {
    createNotifications() {
      for (let e = 0; e < this.values?.length; e++)
        this.$cookies.get(`NotificationCookie${this.values[e].id}`) !== "true" && this.$toast.add({
          severity: this.values[e].type,
          summary: this.values[e].title,
          detail: this.values[e].text,
          closable: this.values[e].closable
        });
    },
    strippedText(e) {
      const t = /(<([^>]+)>)/gi;
      return e.replace(t, "");
    },
    setCookie(e, t) {
      this.$cookies.set(`NotificationCookie${e}`, t);
    }
  }
}), Z7 = { class: "p-toast-message-text" }, J7 = { class: "p-toast-summary" }, Q7 = { class: "p-toast-detail pb-6" }, ej = {
  key: 0,
  class: "anchor-button-div"
}, tj = { class: "field-checkbox flex flex-row-reverse" };
function nj(e, t, n, i, o, a) {
  const r = $e("AnchorButton"), s = $e("Checkbox"), l = $e("PrimeToast");
  return E(), fe(l, {
    class: "notification-box print:hidden",
    position: "bottom-center"
  }, {
    message: Se((d) => [
      t[0] || (t[0] = oe("i", { class: "p-toast-message-icon las la-exclamation" }, null, -1)),
      oe("div", Z7, [
        oe("span", J7, Ie(e.strippedText(d.message.summary)), 1),
        oe("div", Q7, Ie(e.strippedText(d.message.detail)), 1),
        e.values[d.message.id]?.buttonText && e.values[d.message.id]?.buttonUrl ? (E(), X("div", ej, [
          ue(r, {
            "anchor-title": e.strippedText(e.values[d.message.id].buttonText),
            "anchor-url": e.values[d.message.id].buttonUrl,
            "data-event_component_name": "Button",
            "data-event_title": e.strippedText(e.values[d.message.id].buttonText),
            "data-event_source": e.dataEventSource,
            "data-event_target": e.strippedText(e.values[d.message.id].buttonUrl),
            "url-target": "_blank",
            class: "p-button-primary p-button-sm"
          }, null, 8, ["anchor-title", "anchor-url", "data-event_title", "data-event_source", "data-event_target"])
        ])) : te("", !0),
        oe("div", tj, [
          ue(s, {
            "input-id": "check",
            modelValue: e.checked[d.message.id],
            "onUpdate:modelValue": (y) => e.checked[d.message.id] = y,
            binary: !0,
            onChange: (y) => e.setCookie(
              e.values[d.message.id].id,
              e.checked[d.message.id]
            )
          }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"]),
          oe("label", {
            class: Pe(["p-checkbox__label", {
              "p-checkbox__label--selected": e.checked[d.message.id]
            }]),
            for: "check"
          }, Ie(e.valuesMain?.doNotShowAgainText), 3)
        ])
      ])
    ]),
    _: 1
  });
}
const bBe = /* @__PURE__ */ Fe(X7, [["render", nj]]);
const ij = Be({
  name: "PerformanceBlock",
  components: {
    PrimeDataTable: Ku,
    PrimeColumn: Xr,
    TextBlock: Mr,
    ColoredNumber: zk,
    FootNote: ja,
    FootnoteHeader: li
  },
  props: {
    values: {
      type: Object,
      required: !0,
      default: null
    }
  },
  setup() {
    const e = Ue ? window.innerWidth : 0, t = ge(e);
    return Ue && (it(() => {
      window.addEventListener("resize", () => {
        t.value = window.innerWidth;
      });
    }), sn(() => {
      window.removeEventListener("resize", () => {
        t.value = window.innerWidth;
      });
    })), {
      windowWidth: t
    };
  },
  data() {
    return {
      numberColumn: 2,
      leftColStyles: {}
    };
  },
  watch: {
    windowWidth(e, t) {
      e !== t && this.matchHeight();
    }
  },
  mounted() {
    this.matchHeight();
  },
  methods: {
    isPositive(e) {
      const t = parseFloat(e.replace(",", ".")), n = Math.sign(t);
      return !(n === -1 || n === -0);
    },
    matchHeight() {
      if (this.windowWidth >= 768) {
        if (this.$refs.perfRight) {
          const e = this.$refs.perfRight.clientHeight + "px";
          this.leftColStyles = { height: e };
        }
      } else
        this.leftColStyles = {};
    }
  }
}), aj = { class: "performance-block" }, oj = { class: "grid xs:grid-cols-1 lg:grid-cols-2 gap-8 container" }, rj = {
  key: 0,
  class: "xs:col-span-1"
}, sj = { class: "bold" }, lj = {
  key: 0,
  class: "bold"
}, cj = { class: "performance-block__body" }, dj = { key: 0 }, uj = {
  key: 1,
  class: "performance-block__omitted"
}, hj = {
  key: 1,
  class: "xs:col-span-1 print:mt-8"
}, pj = {
  ref: "perfRight",
  class: "performance-block__head"
}, fj = { class: "bold" }, mj = {
  key: 0,
  class: "bold"
}, gj = { class: "performance-block__body" }, vj = { key: 0 };
function yj(e, t, n, i, o, a) {
  const r = $e("FootnoteHeader"), s = $e("ColoredNumber"), l = $e("PrimeColumn"), d = $e("PrimeDataTable"), y = $e("FootNote"), u = $e("TextBlock");
  return E(), X("div", aj, [
    oe("div", oj, [
      e.values.performanceTable !== null ? (E(), X("div", rj, [
        oe("div", {
          ref: "perfLeft",
          class: "performance-block__head",
          style: hn(e.leftColStyles)
        }, [
          oe("h2", sj, [
            ue(r, {
              text: e.values.performanceTable.headlineText,
              "foot-note-id": e.values.id
            }, null, 8, ["text", "foot-note-id"])
          ]),
          e.values?.performanceTable?.headlineDateText ? (E(), X("h2", lj, Ie(e.values.performanceTable.headlineDateText), 1)) : te("", !0)
        ], 4),
        oe("div", cj, [
          ue(d, {
            class: "border",
            value: e.values?.performanceTable?.values,
            scrollable: !1,
            "responsive-layout": "scroll"
          }, {
            default: Se(() => [
              (E(!0), X(Re, null, Ge(e.values?.performanceTable?.header, (m) => (E(), fe(l, {
                key: m,
                field: m.key,
                header: m.value,
                class: Pe({ "cell-right": m.key !== "column_0" })
              }, {
                body: Se((h) => [
                  m.key === "column_0" ? (E(), X("span", dj, Ie(h.data[h.column.props.key.key]), 1)) : te("", !0),
                  h.data[h.column.props.key.key] === "-" ? (E(), X("span", uj, " - ")) : te("", !0),
                  m.key !== "column_0" ? (E(), fe(s, {
                    key: 2,
                    number: h.data[h.column.props.key.key]
                  }, null, 8, ["number"])) : te("", !0)
                ]),
                _: 2
              }, 1032, ["field", "header", "class"]))), 128))
            ]),
            _: 1
          }, 8, ["value"])
        ])
      ])) : te("", !0),
      e.values.performance12MonthsTable !== null ? (E(), X("div", hj, [
        oe("div", pj, [
          oe("h2", fj, [
            ue(r, {
              text: e.values?.performance12MonthsTable?.headlineText,
              "foot-note-id": e.values.id
            }, null, 8, ["text", "foot-note-id"])
          ]),
          e.values?.performance12MonthsTable?.headlineDateText ? (E(), X("h2", mj, Ie(e.values?.performance12MonthsTable?.headlineDateText), 1)) : te("", !0)
        ], 512),
        oe("div", gj, [
          ue(d, {
            class: "border",
            value: e.values?.performance12MonthsTable?.values,
            "responsive-layout": "scroll"
          }, {
            default: Se(() => [
              (E(!0), X(Re, null, Ge(e.values?.performance12MonthsTable?.header, (m) => (E(), fe(l, {
                key: m,
                field: m.key,
                header: m.value,
                class: Pe({ "cell-right-small": m.key !== "column_0" })
              }, {
                body: Se((h) => [
                  m.key === "column_0" ? (E(), X("span", vj, Ie(h.data[h.column.props.key.key]), 1)) : te("", !0),
                  m.key !== "column_0" ? (E(), fe(s, {
                    key: 1,
                    number: h.data[h.column.props.key.key]
                  }, null, 8, ["number"])) : te("", !0)
                ]),
                _: 2
              }, 1032, ["field", "header", "class"]))), 128))
            ]),
            _: 1
          }, 8, ["value"])
        ])
      ])) : te("", !0),
      ue(y, {
        class: "grid gap-10 grid-cols-1 lg:grid-cols-2 xs:col-span-1 lg:col-span-2 mb-8",
        values: e.values
      }, null, 8, ["values"]),
      (E(!0), X(Re, null, Ge(e.values.disclaimerHtml, (m) => (E(), fe(u, {
        key: m,
        values: m.text,
        class: "xs:col-span-1 lg:col-span-2",
        "number-column": e.numberColumn
      }, null, 8, ["values", "number-column"]))), 128))
    ])
  ]);
}
const xBe = /* @__PURE__ */ Fe(ij, [["render", yj]]);
var bj = {
  root: "p-card p-component",
  header: "p-card-header",
  body: "p-card-body",
  caption: "p-card-caption",
  title: "p-card-title",
  subtitle: "p-card-subtitle",
  content: "p-card-content",
  footer: "p-card-footer"
}, xj = Wt.extend({
  name: "card",
  classes: bj
}), wj = {
  name: "BaseCard",
  extends: wt,
  style: xj
}, Ms = {
  name: "Card",
  extends: wj
};
function kj(e, t, n, i, o, a) {
  return E(), X("div", Ce({
    class: e.cx("root")
  }, e.ptm("root"), {
    "data-pc-name": "card"
  }), [e.$slots.header ? (E(), X("div", Ce({
    key: 0,
    class: e.cx("header")
  }, e.ptm("header")), [je(e.$slots, "header")], 16)) : te("", !0), oe("div", Ce({
    class: e.cx("body")
  }, e.ptm("body")), [e.$slots.title || e.$slots.subtitle ? (E(), X("div", Ce({
    key: 0,
    class: e.cx("caption")
  }, e.ptm("caption")), [e.$slots.title ? (E(), X("div", Ce({
    key: 0,
    class: e.cx("title")
  }, e.ptm("title")), [je(e.$slots, "title")], 16)) : te("", !0), e.$slots.subtitle ? (E(), X("div", Ce({
    key: 1,
    class: e.cx("subtitle")
  }, e.ptm("subtitle")), [je(e.$slots, "subtitle")], 16)) : te("", !0)], 16)) : te("", !0), oe("div", Ce({
    class: e.cx("content")
  }, e.ptm("content")), [je(e.$slots, "content")], 16), e.$slots.footer ? (E(), X("div", Ce({
    key: 1,
    class: e.cx("footer")
  }, e.ptm("footer")), [je(e.$slots, "footer")], 16)) : te("", !0)], 16)], 16);
}
Ms.render = kj;
const Sj = Be({
  name: "TeaserHeader",
  components: {
    PrimeCard: Ms
  },
  props: {
    teaserTitel: {
      type: String,
      required: !0
    },
    teaserUrl: {
      type: String,
      required: !0
    },
    teaserAlt: {
      type: String,
      required: !0
    },
    teaserImageUrl: {
      type: String,
      required: !0
    },
    teaserWidthSize: {
      type: Number,
      required: !0
    },
    teaserHeightSize: {
      type: Number,
      required: !0
    }
  }
}), Cj = ["href"], Tj = ["alt", "src"];
function Lj(e, t, n, i, o, a) {
  const r = $e("PrimeCard");
  return E(), X("a", { href: e.teaserUrl }, [
    ue(r, { class: "teaser" }, {
      header: Se(() => [
        oe("img", {
          alt: e.teaserAlt,
          src: e.teaserImageUrl + "&width=" + e.teaserWidthSize + "&height=" + e.teaserHeightSize
        }, null, 8, Tj)
      ]),
      title: Se(() => [
        Ve(Ie(e.teaserTitel), 1)
      ]),
      footer: Se(() => t[0] || (t[0] = [
        oe("button", { class: "triangle-button" }, [
          oe("i", { class: "las la-angle-right" })
        ], -1)
      ])),
      _: 1
    })
  ], 8, Cj);
}
const wBe = /* @__PURE__ */ Fe(Sj, [["render", Lj]]);
const Ij = Be({
  name: "ModalDialog",
  components: {
    PrimeDialog: Gm
  },
  props: {
    values: {
      type: Object,
      required: !0
    },
    displayDialog: {
      type: Boolean,
      required: !0
    },
    draggable: {
      type: Boolean,
      default: !1
    },
    closable: {
      type: Boolean,
      default: !0
    },
    position: {
      type: String,
      default: "bottom"
    },
    header: {
      type: String,
      default: ""
    },
    footer: {
      type: String,
      default: ""
    }
  },
  emits: ["close-dialog", "after-hide"],
  data() {
    return {
      displayModal: this.displayDialog,
      baseZIndex: 1005
    };
  },
  created() {
    const { pageName: e } = Qe();
    this.dataEventSource = e;
  },
  methods: {
    openModal() {
      this.displayModal = !0;
    },
    hide() {
      this.displayModal = !1;
    },
    close() {
      this.$emit("close-dialog");
    }
  }
}), Pj = { class: "small" }, Aj = { class: "small" };
function _j(e, t, n, i, o, a) {
  const r = $e("PrimeDialog");
  return E(), fe(r, {
    visible: e.displayModal,
    "onUpdate:visible": t[0] || (t[0] = (s) => e.displayModal = s),
    class: "mobile-modal-dialog",
    modal: !0,
    draggable: e.draggable,
    closable: e.closable,
    position: e.position,
    "base-z-index": e.baseZIndex,
    "append-to": "#mobile-overlay",
    breakpoints: {
      "1280px": "75vw",
      "1024px": "85vw",
      "768px": "95vw",
      "576px": "100vw",
      "360px": "100vw",
      "320px": "100vw"
    },
    header: e.header,
    footer: e.footer,
    onHide: e.hide,
    onAfterHide: e.close
  }, {
    header: Se(() => [
      oe("div", Pj, Ie(e.header), 1)
    ]),
    footer: Se(() => [
      oe("div", Aj, Ie(e.footer), 1)
    ]),
    default: Se(() => [
      je(e.$slots, "default")
    ]),
    _: 3
  }, 8, ["visible", "draggable", "closable", "position", "base-z-index", "header", "footer", "onHide", "onAfterHide"]);
}
const kBe = /* @__PURE__ */ Fe(Ij, [["render", _j]]);
const Mj = {};
function Oj(e, t) {
  return E(), fe(ia, { name: "fade" }, {
    default: Se(() => [
      je(e.$slots, "default", {}, void 0, !0)
    ]),
    _: 3
  });
}
const oo = /* @__PURE__ */ Fe(Mj, [["render", Oj], ["__scopeId", "data-v-9606f6c5"]]), Bj = {
  en: {
    Accept: "Accept",
    Cancel: "Cancel",
    baseSearchBox: {
      resultEventComponentName: "Text Links (same page)"
    },
    audioModule: {
      play: "Play"
    },
    allocationChart: {
      card: {
        othersText: "Others"
      }
    },
    teaserWww: {
      countrySelectorTitle: "Select a location",
      countryDropdownPlaceholder: "Select a location",
      countryDropdownFilterPlaceholder: "Type text here..."
    },
    shareButton: {
      label: "Share on"
    },
    productHeader: {
      allDocuments: "All documents"
    },
    entryGate: {
      productSearchLabel: "Enter your product",
      countryLabel: "Select your location",
      audienceLabel: "Select your role",
      inputPlaceholder: "ISIN",
      inputInvalidText: "Invalid ISIN",
      productLabel: "Your product",
      relationshipLabel: "Select your business relationship",
      existingInvestorLabel: "I am an existing investor",
      nonExistingInvestorLabel: "I am not an existing investor",
      countryDropdownFilterPlaceholder: "Type text here...",
      countryDropdownPlaceholder: "Select a country"
    },
    dataTable: {
      pageReportTemplate: "Showing {first} to {last} of {totalRecords} entries",
      sortedAscending: "Sorted ascending",
      sortedDescending: "Sorted descending"
    },
    dataCards: {
      showMoreValues: "Show more values",
      showLessValues: "Show less values",
      loadMore: "Load more:",
      sortBy: "Sort by",
      apply: "Apply",
      ascending: "Ascending",
      descending: "Descending"
    },
    paginator: {
      pageReportTemplate: "{first} - {last} of {totalRecords}",
      rowsPerPageLabel: "Entries"
    },
    downloads: {
      fallbackText: "Currently there are no downloads available"
    },
    baseSlider: {
      navBackward: "navigate backward",
      navForward: "navigate forward",
      navToPage: "navigate to page"
    },
    historicalData: {
      waitMessage: "Preparing download",
      failedMessage: "Download failed"
    },
    showMoreShowLess: {
      showMoreText: "Show more",
      showLessText: "Show less"
    },
    globalTranslations: {
      yes: "Yes",
      no: "No",
      submit: "Submit",
      copyButton: "Copy",
      copiedButton: "Copied!",
      clear: "Delete",
      disclaimerDisagreeButtonLabel: "Disagree",
      disclaimerAgreeButtonLabel: "Agree",
      disclaimerCancelButtonLabel: "Cancel",
      disclaimerConfirmButtonLabel: "Accept",
      disclaimerTitle: "Disclaimer",
      lockedContentLabel: "Only available for registered users",
      loginOrRegisterLabel: "Login or register now",
      isNewLabel: "New",
      addToWatchlist: "Add to watchlist",
      addedToWatchlist: "Added to watchlist",
      tooltipTextShare: "Share",
      tooltipTextPrint: "Print",
      backLinkText: "Back",
      backToTopButtonText: "Back to top",
      closeAllButtonText: "Close all",
      openAllButtonText: "Open all",
      shareClassSelectLabel: "Share Class",
      emailInputLabelText: "E-Mail address",
      emailInputHelperText: "Please enter correct e-mail address",
      date: "Date",
      startDate: "Start Date",
      endDate: "End Date",
      doNotShowAgain: "Do not show again",
      star: "Star",
      stars: "Stars",
      outOfStars: "out of 5 stars",
      noContent: "No content",
      results: "Results",
      result: "Result",
      search: "Search",
      phone: "Phone",
      email: "Email",
      open: "Open",
      close: "Close",
      monthly: "Monthly",
      quarterly: "Quarterly",
      yearly: "Yearly",
      million: "M",
      billion: "B",
      years: "years",
      year: "year"
    },
    mediaReleases: {
      searchBoxPlaceholder: "Search in media releases",
      noResults: "No results found"
    },
    alertButton: {
      label: "Subscribe"
    },
    periodCalendar: {
      fromLabel: "From:",
      toLabel: "To:"
    },
    accordionContainer: {
      closeAll: "Close all",
      openAll: "Open all"
    },
    premiumDiscountLineChart: {
      yAxisLabel: "Premium or discounts (bps)"
    },
    premiumDiscountHistoricChart: {
      yAxisLabel: "Number of Days",
      discount: "Discount",
      premium: "Premium",
      nav: "NAV"
    },
    stickyNavigation: {
      backToTopLinkText: "Back to top",
      dataEventComponentName: "Side Navigation",
      dataEventTitle: "Jumpmark | Back to top",
      mobileNavigation: "Mobile Navigation"
    },
    contactCard: {
      mailto: "mailto"
    },
    footNote: {
      link: "jump back to footnote"
    },
    footNoteHeader: {
      link: "jump to footnote"
    },
    breadcrumb: {
      shareButton: "choose share class",
      email: "send mail",
      scrollLeft: "scroll left",
      scrollRight: "scroll right"
    },
    dropDocuments: {
      button: "open selection list",
      allDocuments: "All documents"
    },
    dwsCarousel: {
      backward: "previous page",
      forward: "next page",
      page: "jump to page"
    },
    megaMenu: {
      close: "close"
    },
    header: {
      search: "Search",
      user: "User",
      moreLinks: "Show more",
      main: "Main Navigation",
      toggleMenu: "Toggle Menu",
      audienceAndCultureText: "Select your role & location",
      cultureText: "Your Location"
    },
    allocationChartCard: {
      showLess: "show less",
      showMore: "show more"
    },
    performanceChart: {
      close: "close",
      //remove after old component is eliminated
      calendarCloseTooltipText: "Close",
      calendarTooltipText: "Set period",
      downloadTooltipText: "Downloads",
      performanceToggleText: "Performance in %",
      priceToggleText: "NAV history",
      date: "Date",
      startDate: "Start date",
      endDate: "End date",
      nav: "Nav",
      navPercent: "Nav %",
      indexLevel: "Index level",
      indexLevelPercent: "Index level %",
      performanceYaxisLabel: "Performance in %",
      navYaxisLabel: "Nav",
      chartAriaLabel: "Interactive performance chart",
      chartSeriesLabel: "Chart series labels",
      chartNavigatorGroupLabel: "Navigator handles for selecting date range.",
      chartNavigatorHandlesLabelLeft: "Left",
      chartNavigatorHandlesLabelRight: "Right",
      chartNavigatorHandlesLabelEnd: "handle for zooming."
    },
    fundsInFocus: {
      categoryLabel: "Category / Investor Profile"
    },
    videoModule: {
      isRunningText: "now running",
      minutesShort: "min.",
      playButton: "Play video"
    },
    personDetailBlock: {
      biography: "Biography",
      education: "Education",
      professionalCareer: "Professional career",
      publications: "Publications"
    },
    publications: {
      loadMore: "Load more"
    },
    newsletterTeaser: {
      invalidErrorTextHeading: "An error has occurred",
      invalidErrorText: "An error occurred while processing your request. Please try again."
    },
    baseActionMenu: {
      label: "Action menu",
      itemSelected: "For comparison, the product was moved to the top of the list.",
      itemRemoved: "For comparison, the product was removed to the top of the list",
      markForComparison: "Mark for comparison",
      bookmark: "Bookmark",
      bookmarked: "Bookmarked",
      removeCompare: "Remove from comparison",
      openActionMenu: "open action menu"
    },
    fundFinder: {
      periodLabel: "Period",
      periodHeadline: "Change period",
      periodHint: "Changes here are also applied to other time-dependent settings.",
      otherFilters: "Other filters",
      deselectAll: "Deselect all",
      fundSearchHeadline: "",
      fundSearchPlaceholder: "Search",
      resetFilters: "Reset all filters",
      products: "products",
      product: "product",
      showProducts: "Showing",
      downloadDocuments: "Download documents",
      addedCompareMessage: "For comparison, the product was moved to the top of the list",
      removedCompareMessage: "The product was removed from the top of the list",
      addedBookmarkMessage: "The product was added to your watchlist",
      removedBookmarkMessage: "The product was removed from your watchlist",
      changeColumnView: "Change column view"
    },
    productChartTeaser: {
      performance: "Performance"
    },
    archivePage: {
      searchBoxPlaceholder: "Search in the archives",
      loadMore: "Load more",
      filters: "Filters",
      resetFilters: "Reset all filters",
      otherFilters: "Other filters"
    },
    teaser: {
      new: "New"
    },
    baseResultView: {
      listViewTitle: "List View",
      gridViewTitle: "Grid View"
    },
    showMoreLessToggle: {
      showMoreText: "Show more",
      showLessText: "Show less"
    },
    searchResultPage: {
      searchResultPagePlaceholder: "Search",
      resultsFor: "Results for",
      filterBy: "Filter by",
      sortBy: "Sort by"
    },
    baseNonRemovableFilters: {
      edit: "Edit"
    },
    baseRemovableFilters: {
      removeFilter: "remove filter"
    },
    tabContainer: {
      requiresLogin: "Requires Login"
    },
    propertyTeaser: {
      gallery: "Gallery",
      images: "images"
    },
    propertyGallery: {
      map: "Map",
      filters: "Filters",
      marketValue: "Market value",
      acquisitionYear: "Acquisition year",
      location: "Location",
      resultText: "Property",
      resultsText: "Properties",
      loadMore: "Load More"
    },
    sortOptions: {
      sortByLabel: "Sort by",
      nameAsc: "Name A-Z",
      nameDesc: "Name Z-A",
      priceAsc: "Price low-high",
      priceDesc: "Price high-low",
      acquisitionYearAsc: "Year past-recent",
      acquisitionYearDesc: "Year recent-past"
    },
    propertyKeyValues: {
      type: "Type",
      purchasePrice: "Purchase price",
      acquisitionYear: "Acquisition year",
      location: "Location"
    },
    baseGoogleMap: {
      mapType: "Map type",
      streetView: "Street view",
      zoomIn: "Zoom in",
      zoomOut: "Zoom out",
      locationMarker: "Select"
    },
    documentList: {
      numberOfResultLabel: "documents"
    },
    literatureLibrary: {
      searchBoxPlaceholder: "Search for product"
    },
    baseTreeSelect: {
      placeholder: "Search",
      emptyMessage: "No prospectuses or reports found",
      triggerAriaLabel: "Toggle selection list"
    },
    faqPage: {
      expandAll: "Show all answers",
      closeAll: "Close all answers",
      searchPlaceholder: "Search in FAQ",
      result: "Result",
      results: "Results",
      noResults: "No results found",
      searchResults: "Search results"
    },
    glossary: {
      expandAll: "Show all answers",
      closeAll: "Close all answers",
      searchPlaceholder: "Search in glossary",
      result: "Result",
      results: "Results",
      noResults: "We couldn't find any results for",
      showAllResults: "Show all results",
      chooseOption: "Choose option"
    },
    eventList: {
      date: "Date",
      event: "Event",
      time: "Time",
      download: "Download"
    },
    quizAndPoll: {
      explanationHeadlineCorrect: "Great, your answer is correct.",
      explanationHeadlineInCorrect: "Sorry, your answer wasn't quite right.",
      socialLabel: "Share:"
    },
    marketDataBlock: {
      intraday: "Intraday"
    },
    search: {
      showAllResults: "Show all results"
    },
    imageGalleryTeaser: {
      gallery: "Open in gallery"
    },
    documentViewer: {
      documentView: "PDF document view",
      loading: "Loading document"
    },
    productBuyingProcess: {
      searchBoxPlaceholder: "Search your provider",
      continueToPartner: "Continue to partner"
    },
    typography: {
      disclaimer: `Disclaimer: Bond investments are subject to interest-rate, credit,
      liquidity and market risks to varying degrees. When interest rates rise, bond prices 
      generally fall. Credit risk refers to the ability of an issuer to make timely 
      payments of principal and interest. Investments in lower-quality (junk bonds) 
      and non-rated securities present greater risk of loss than investments in
       higher-quality securities. Municipal securities are subject to the risk that 
       litigation, legislation or other political events, local business or economic
        conditions or the bankruptcy of the issuer could have a significant effect on 
        an issuer's ability to make payments of principal and/or interest. The market 
        for municipal bonds may be less liquid than for taxable bonds and there may be 
        less information available on the financial condition of issuers of municipal
        securities than for public corporations. Investing in derivatives entails 
        special risks relating to liquidity, leverage and credit that may reduce 
        returns and/or increase volatility. Although the fund seeks income that
         is exempt from California and federal income taxes, a portion of the 
         fund’s distributions may be subject to federal, state and local taxes,
          including the alternative minimum tax. Please read the
           prospectus for details.`,
      pageHeadline: "Page headline h1",
      h2Headline: "Headline h2",
      sectionH2Headline: "Section Headline h2",
      h3Headline: "Headline h3",
      h4Headline: "Headline h4",
      copyHeadline: "Copy headline",
      copyText: "Copy text normal",
      copyTextBold: "Copy text bold",
      labelGerman: "German",
      labelEnglish: "English",
      labelChinese: "Chinese",
      labelJapanese: "Japanese"
    },
    hyphenation: {
      pageHeadline: "Hyphenation Testpage with Translation",
      labelGerman: "German",
      labelEnglish: "English",
      labelFrench: "French",
      labelItalian: "Italian",
      labelSpanish: "Spanish",
      labelDutch: "Dutch",
      labelSwedish: "Swedish",
      labelPortugaise: "Portugaise",
      labelKorean: "Korean",
      labelTaiwan: "Taiwan",
      labelChinese: "Chinese",
      labelJapanese: "Japanese",
      htmlText: `
      .d-table<br>
      <table class="d-table d-hyphenation__table" cellspacing="0" cellpadding="0">\r
		
      <thead>
      <tr>
          <th>Currency</th>
          <th>currency</th>
          <th>Share&shy;weight Shareweight</th>
          <th>Marketvalue</th>
      </tr>
      </thead>
      <tbody>
      <tr>
          <td>Division 1</td>
          <td>Division 2</td>
          <td>Division 3</td>
          <td>Division 4</td>
      </tr>
      <tr class="even">
          <td>Division 1</td>
          <td>Division 2</td>
          <td>Division 3</td>
          <td>Division 4</td>
      </tr>
      <tr>
          <td>Division 1</td>
          <td>Division 2</td>
          <td>Division 3</td>
          <td>Division 4</td>
      </tr>
      </tbody>
      </table>`
    },
    coloredNumber: {
      default: "Neutral",
      positive: "Positive",
      negative: "Negative"
    },
    footer: {
      contact: "Contact",
      showContactInformation: "Show contact information",
      changeAudienceAndCulture: "Change audience and culture",
      changeCulture: "Change culture",
      legalAndPolicyLinks: "Legal and Policy Links"
    },
    calendarPage: {
      icalDownload: "Download iCal file for {eventTitle} event"
    },
    riskDisclaimer: {
      showDisclaimer: "Show disclaimer",
      hideDisclaimer: "Hide disclaimer"
    },
    crociCompanyOverviewPage: {
      searchBoxPlaceholder: "Search for company name or ticker"
    },
    crociCompanyDetailPage: {
      showAll: "Show all columns",
      showLess: "Show less columns",
      ticker: {
        ticker: "Ticker:",
        category: "Category:",
        sharePrice: "Share price:"
      },
      zoomChart: "Open chart detail",
      noData: "No data to display"
    },
    calculatorOutputCard: {
      inflationInfoText: "In <b>{years} years, {value}</b> of capital will only have a purchasing power of:",
      investmentInfoText: "Your saved credit",
      valueDevelopment: "Increase in value",
      regularInvestment: "Total regular payment",
      initialInvestment: "One-off amount",
      purchasingPower: "Purchasing power",
      investmentChartTitle: "Investment Chart Data",
      inflationChartTitle: "Inflation Chart Data"
    },
    calculationArea: {
      calculationButtonLabel: "Calculate",
      optionButtonLabel: "More options",
      optionButtonLabelLess: "Less options",
      restartButtonLabel: "Restart",
      currentInflationRateLabel: "Use the current inflation rate"
    }
  },
  de: {
    Accept: "Akzeptieren",
    Cancel: "Abbrechen",
    baseSearchBox: {
      resultEventComponentName: "Text Links (same page)"
    },
    audioModule: {
      play: "Abspielen"
    },
    allocationChart: {
      card: {
        othersText: "Sonstiges"
      }
    },
    teaserWww: {
      countrySelectorTitle: "Land auswählen",
      countryDropdownPlaceholder: "Land auswählen",
      countryDropdownFilterPlaceholder: "Hier Text eingeben..."
    },
    shareButton: {
      label: "Teilen auf"
    },
    productHeader: {
      allDocuments: "Alle Dokumente"
    },
    entryGate: {
      productSearchLabel: "Produkt eingeben",
      countryLabel: "Wählen Sie Ihr Land",
      audienceLabel: "Wählen Sie Ihre Rolle",
      inputPlaceholder: "ISIN",
      inputInvalidText: "Ungültige ISIN",
      productLabel: "Ihr Produkt",
      relationshipLabel: "Wählen Sie ihre Geschäftsrolle",
      existingInvestorLabel: "Ich bin bereits Investor",
      nonExistingInvestorLabel: "Ich bin noch kein Investor",
      countryDropdownFilterPlaceholder: "Hier Text eingeben...",
      countryDropdownPlaceholder: "Land wählen"
    },
    dataTable: {
      pageReportTemplate: "Zeige {first} bis {last} von {totalRecords} Einträgen",
      sortedAscending: "Aufsteigend sortiert",
      sortedDescending: "Absteigend sortiert"
    },
    dataCards: {
      showMoreValues: "Mehr Werte anzeigen",
      showLessValues: "Weniger Werte anzeigen",
      loadMore: "Mehr anzeigen",
      sortBy: "Sortieren nach:",
      apply: "Übernehmen",
      ascending: "Aufsteigend",
      descending: "Absteigend"
    },
    paginator: {
      pageReportTemplate: "{first} - {last} von {totalRecords}",
      rowsPerPageLabel: "Einträge"
    },
    downloads: {
      fallbackText: "Zurzeit sind keine Downloads vorhanden"
    },
    baseSlider: {
      navBackward: "Zurück blättern",
      navForward: "Vorwärts blättern",
      navToPage: "Navigiere zu Seite"
    },
    historicalData: {
      waitMessage: "Wird heruntergeladen",
      failedMessage: "Herunterladen fehlgeschlagen"
    },
    showMoreShowLess: {
      showMoreText: "Mehr anzeigen",
      showLessText: "Weniger anzeigen"
    },
    globalTranslations: {
      yes: "Ja",
      no: "Nein",
      submit: "Absenden",
      copyButton: "Kopieren",
      copiedButton: "Kopiert!",
      clear: "Löschen",
      disclaimerDisagreeButtonLabel: "Ablehnen",
      disclaimerAgreeButtonLabel: "Akzeptieren",
      disclaimerCancelButtonLabel: "Abbrechen",
      disclaimerConfirmButtonLabel: "Einverstanden",
      disclaimerTitle: "Disclaimer",
      lockedContentLabel: "Nur für registrierte Nutzer verfügbar",
      loginOrRegisterLabel: "Einloggen oder registrieren",
      isNewLabel: "Neu",
      addToWatchlist: "Zur Watchlist hinzufügen",
      addedToWatchlist: "Zur Watchlist hinzugefügt",
      tooltipTextShare: "Inhalt teilen",
      tooltipTextPrint: "Inhalt drucken",
      backLinkText: "Zurück",
      backToTopButtonText: "Zurück zum Anfang",
      closeAllButtonText: "Alle schließen",
      openAllButtonText: "Alle öffnen",
      shareClassSelectLabel: "Anteilsklasse",
      emailInputLabelText: "E-Mail Adresse",
      emailInputHelperText: "Bitte geben Sie die korrekte E-Mail Adresse ein",
      date: "Datum",
      startDate: "Startdatum",
      endDate: "Enddatum",
      doNotShowAgain: "Nicht mehr anzeigen",
      star: "Stern",
      stars: "Sterne",
      outOfStars: "von 5 Sternen",
      noContent: "Keine Ergebnisse",
      results: "Ergebnisse",
      result: "Ergebnis",
      search: "Suche",
      phone: "Telefon",
      email: "E-Mail",
      open: "Öffne",
      close: "Schließe",
      monthly: "Monatlich",
      quarterly: "Vierteljährlich",
      yearly: "Jährlich",
      million: "Mio.",
      billion: "Mrd.",
      years: "Jahre",
      year: "Jahr"
    },
    mediaReleases: {
      searchBoxPlaceholder: "Suche in Medienberichten",
      noResults: "Keine Ergebnisse gefunden"
    },
    alertButton: {
      label: "Alarmieren"
    },
    periodCalendar: {
      fromLabel: "Von:",
      toLabel: "Bis:"
    },
    accordionContainer: {
      closeAll: "Alle schließen",
      openAll: "Alle öffnen"
    },
    premiumDiscountLineChart: {
      yAxisLabel: "Premium oder Discount (bps)"
    },
    premiumDiscountHistoricChart: {
      yAxisLabel: "Anzahl der Tage",
      discount: "Discount",
      premium: "Premium",
      nav: "NAV"
    },
    stickyNavigation: {
      backToTopLinkText: "Zurück zum Anfang",
      dataEventComponentName: "Seitennavigation Translation",
      dataEventTitle: "Sprungmarke Zurück an den Anfang Translation",
      mobileNavigation: "Mobile Navigation"
    },
    contactCard: {
      mailto: "Email versenden"
    },
    footNote: {
      link: "Zurück springen zur Fußnote"
    },
    footNoteHeader: {
      link: "Zur Fußnote springen"
    },
    breadcrumb: {
      shareButton: "Anteilsklasse auswählen",
      email: "Email versenden",
      scrollLeft: "Nach links scrollen",
      scrollRight: "Nach rechts scrollen"
    },
    dropDocuments: {
      button: "Öffne Auswahlliste",
      allDocuments: "Alle Dokumente"
    },
    dwsCarousel: {
      backward: "Vorherige Seite",
      forward: "Nächste Seite",
      page: "Springe zu Seite"
    },
    megaMenu: {
      close: "Schließen"
    },
    header: {
      search: "Suche",
      user: "Benutzer",
      moreLinks: "mehr anzeigen",
      main: "Hauptmenü",
      toggleMenu: "Menü umschalten",
      audienceAndCultureText: "Wählen Sie Ihre Rolle & Ihren Standort",
      cultureText: "Ihr Standort"
    },
    allocationChartCard: {
      showLess: "weniger anzeigen",
      showMore: "mehr anzeigen"
    },
    performanceChart: {
      close: "Schließen",
      //remove after old component is eliminated
      calendarCloseTooltipText: "schließen",
      calendarTooltipText: "Periode setzen",
      downloadTooltipText: "Downloads",
      performanceToggleText: "Performance in %",
      priceToggleText: "NAV Historie",
      date: "Datum",
      startDate: "Start Datum",
      endDate: "End Datum",
      nav: "Nav",
      navPercent: "Nav %",
      indexLevel: "Index level",
      indexLevelPercent: "Index level %",
      performanceYaxisLabel: "Performance in %",
      navYaxisLabel: "Nav",
      chartAriaLabel: "Interaktive Performance Grafik",
      chartSeriesLabel: "Chart Serien Labels",
      chartNavigatorGroupLabel: "Navigator Knöpfe zur Auswahl des Datumsbereichs.",
      chartNavigatorHandlesLabelLeft: "Linker",
      chartNavigatorHandlesLabelRight: "Rechter",
      chartNavigatorHandlesLabelEnd: "Knopf für Bereichs-Zoom."
    },
    fundsInFocus: {
      categoryLabel: "Kategorie / Anlegerprofil"
    },
    videoModule: {
      isRunningText: "Läuft gerade",
      minutesShort: "Min.",
      playButton: "Video abspielen"
    },
    personDetailBlock: {
      biography: "Biografie",
      education: "Ausbildung",
      professionalCareer: "Berufliche Laufbahn",
      publications: "Publikationen"
    },
    publications: {
      loadMore: "Mehr anzeigen"
    },
    newsletterTeaser: {
      invalidErrorTextHeading: "Ein Fehler ist aufgetreten",
      invalidErrorText: "Bei der Bearbeitung Ihrer Anfrage ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut."
    },
    baseActionMenu: {
      label: "Aktionsmenü",
      itemSelected: "Das Produkt wurde zum Vergleichen an den Anfang geschoben.",
      itemRemoved: "Das Produkt wurde vom Anfang entfernt.",
      markForComparison: "Zum Vergleich markieren",
      bookmark: "Lesezeichen",
      bookmarked: "Mit Lesezeichen versehen",
      removeCompare: "Vergleich entfernen",
      openActionMenu: "öffne Action Menu"
    },
    fundFinder: {
      periodLabel: "Zeitperiode",
      periodHeadline: "Zeitperiode ändern",
      periodHint: "Änderungen werden auch auf andere zeitabhängige Einstellungen angewendet.",
      otherFilters: "Andere Filter",
      deselectAll: "Alle abwählen",
      fundSearchHeadline: "",
      resetFilters: "Alle Filter zurücksetzen",
      fundSearchPlaceholder: "Suche",
      products: "Produkte",
      product: "Produkt",
      showProducts: "Zeige",
      downloadDocuments: "Dokumente herunterladen",
      addedCompareMessage: "Das Produkt wurde zum Vergleich an den Anfang der Liste gesetzt",
      removedCompareMessage: "Das Produkt wurde vom Anfang der Liste entfernt",
      addedBookmarkMessage: "Das Produkt wurde zur Watchlist hinzugefügt",
      removedBookmarkMessage: "Das Produkt wurde von der Watchlist entfernt",
      changeColumnView: "Spaltenansicht ändern"
    },
    productChartTeaser: {
      performance: "Wertentwicklung"
    },
    archivePage: {
      searchBoxPlaceholder: "Suche im Archiv",
      loadMore: "Mehr anzeigen",
      filters: "Filter",
      resetFilters: "Alle Filter zurücksetzen",
      otherFilters: "Andere Filter"
    },
    teaser: {
      new: "Neu"
    },
    baseResultView: {
      listViewTitle: "Listenansicht",
      gridViewTitle: "Spaltenansicht"
    },
    showMoreLessToggle: {
      showMoreText: "Mehr anzeigen",
      showLessText: "Weniger anzeigen"
    },
    searchResultPage: {
      searchResultPagePlaceholder: "Suche",
      resultsFor: "Ergebnisse für",
      filterBy: "Filtern nach",
      sortBy: "Sortiere nach"
    },
    baseNonRemovableFilters: {
      edit: "Bearbeiten"
    },
    baseRemovableFilters: {
      removeFilter: "Filter entfernen"
    },
    tabContainer: {
      requiresLogin: "Benötigt Login"
    },
    propertyTeaser: {
      gallery: "Galerie",
      images: "Bilder"
    },
    propertyGallery: {
      map: "Karte",
      filters: "Filter",
      marketValue: "Marktwert",
      acquisitionYear: "Ankaufsjahr",
      location: "Standort",
      resultText: "Immobilie",
      resultsText: "Immobilien",
      loadMore: "Mehr anzeigen"
    },
    sortOptions: {
      sortByLabel: "Sortieren nach",
      nameAsc: "Name A-Z",
      nameDesc: "Name Z-A",
      priceAsc: "Wert niedrig-hoch",
      priceDesc: "Wert hoch-niedrig",
      acquisitionYearAsc: "Ankaufsjahr ältestes-letztes",
      acquisitionYearDesc: "Ankaufsjahr letztes-ältestes"
    },
    propertyKeyValues: {
      type: "Typ",
      purchasePrice: "Kaufpreis",
      acquisitionYear: "Erwerbsjahr",
      location: "Standort"
    },
    baseGoogleMap: {
      mapType: "Kartentyp",
      streetView: "Street View",
      zoomIn: "Reinzoomen",
      zoomOut: "Rauszoomen",
      locationMarker: "Auswählen"
    },
    documentList: {
      numberOfResultLabel: "Dokumente"
    },
    literatureLibrary: {
      searchBoxPlaceholder: "Suche nach Produkt"
    },
    baseTreeSelect: {
      placeholder: "Suche",
      emptyMessage: "Keine Prospekte oder Berichte gefunden",
      triggerAriaLabel: "Auswahlliste öffnen"
    },
    faqPage: {
      expandAll: "Alle Antworten anzeigen",
      closeAll: "Alle Antworten schließen",
      searchPlaceholder: "In FAQ suchen",
      result: "Ergebnis",
      results: "Ergebnisse",
      noResults: "Keine Ergebnisse gefunden",
      searchResults: "Suchergebnisse"
    },
    glossary: {
      expandAll: "Alle Antworten anzeigen",
      closeAll: "Alle Antworten schließen",
      searchPlaceholder: "In Glossar suchen",
      result: "Ergebnis",
      results: "Ergebnisse",
      noResults: "Keine Ergebnisse gefunden für",
      showAllResults: "Alle Ergebnisse anzeigen",
      chooseOption: "Option auswählen"
    },
    eventList: {
      date: "Datum",
      event: "Event",
      time: "Uhrzeit",
      download: "Download"
    },
    quizAndPoll: {
      explanationHeadlineCorrect: "Toll, deine Antwort ist richtig.",
      explanationHeadlineInCorrect: "Sorry, deine Antwort war nicht ganz richtig.",
      socialLabel: "Teilen:"
    },
    marketDataBlock: {
      intraday: "Intraday"
    },
    search: {
      showAllResults: "Alle Ergebnisse anzeigen"
    },
    imageGalleryTeaser: {
      gallery: "In Galerie öffnen"
    },
    documentViewer: {
      documentView: "PDF Dokumentenansicht",
      loading: "Dokument wird geladen"
    },
    productBuyingProcess: {
      searchBoxPlaceholder: "Suche deinen Anbieter",
      continueToPartner: "Weiter zum Partner"
    },
    typography: {
      disclaimer: `Haftungsausschluss: Anleihenanlagen unterliegen Zins-, Bonitäts-,
      Liquiditäts- und Marktrisiken in unterschiedlichem Ausmaß. Wenn die Zinsen steigen, steigen die Anleihepreise 
      im Allgemeinen fallen. Unter Kreditrisiko versteht man die Fähigkeit eines Emittenten, rechtzeitig zu leisten 
      Tilgungs- und Zinszahlungen. Investitionen in minderwertigere Anleihen (Junk Bonds) 
      und Wertpapiere ohne Rating bergen ein höheres Verlustrisiko als Anlagen in
       höherwertige Wertpapiere. Kommunale Wertpapiere unterliegen dem Risiko, dass 
       Rechtsstreitigkeiten, Gesetzgebung oder andere politische Ereignisse, lokale Geschäfts- oder Wirtschaftsereignisse
        Bedingungen oder der Konkurs des Emittenten könnten erhebliche Auswirkungen haben 
        die Fähigkeit eines Emittenten, Kapital- und/oder Zinszahlungen zu leisten. Der Markt 
        Bei Kommunalanleihen ist die Liquidität möglicherweise weniger liquide als bei steuerpflichtigen Anleihen, und das ist möglicherweise der Fall 
        Es liegen weniger Informationen über die Finanzlage der Emittenten kommunaler Anleihen vor
        Wertpapiere als bei Körperschaften des öffentlichen Rechts. Die Investition in Derivate bringt Folgendes mit sich: 
        besondere Risiken in Bezug auf Liquidität, Verschuldung und Kreditwürdigkeit, die sich verringern können 
        Renditen steigern und/oder die Volatilität erhöhen. Obwohl der Fonds Erträge anstrebt
         ist von der kalifornischen und bundesstaatlichen Einkommenssteuer befreit, ein Teil davon 
         Die Ausschüttungen des Fonds können Bundes-, Landes- und Kommunalsteuern unterliegen.
          inklusive der alternativen Mindeststeuer. Bitte lesen Sie die
           Einzelheiten finden Sie im Prospekt.`,
      pageHeadline: "Seiten Überschrift h1",
      h2Headline: "Überschrift h2",
      sectionH2Headline: "Sektions Überschrift h2",
      h3Headline: "Überschrift h3",
      h4Headline: "Überschrift h4",
      copyHeadline: "Copytext Überschrift",
      copyText: "Copytext normal",
      copyTextBold: "Copytext fett",
      labelGerman: "Deutsch",
      labelEnglish: "Englisch",
      labelChinese: "Chinesisch",
      labelJapanese: "Japanisch"
    },
    hyphenation: {
      pageHeadline: "Hyphenation Testseite mit Übersetzungen",
      labelGerman: "Deutsch",
      labelEnglish: "Englisch",
      labelFrench: "Französisch",
      labelItalian: "Italienisch",
      labelSpanish: "Spanisch",
      labelDutch: "Niederländisch",
      labelSwedish: "Schwedisch",
      labelPortugaise: "Portugiesisch",
      labelKorean: "Koreanisch",
      labelTaiwan: "Taiwanesisch",
      labelChinese: "Chinesisch",
      labelJapanese: "Japanisch",
      htmlText: `
      .d-table<br>
      <table class="d-table d-hyphenation__table" cellspacing="0" cellpadding="0">\r
		
      <thead>
      <tr>
          <th>Donaudampfschifffahrt</th>
          <th>Berufsbildungszentrum</th>
          <th>Fondsausgabeland</th>
          <th>Test</th>
      </tr>
      </thead>
      <tbody>
      <tr>
          <td>Division 1</td>
          <td>Division 2</td>
          <td>Division 3</td>
          <td>Division 4</td>
      </tr>
      <tr class="even">
          <td>Division 1</td>
          <td>Division 2</td>
          <td>Division 3</td>
          <td>Division 4</td>
      </tr>
      <tr>
          <td>Division 1</td>
          <td>Division 2</td>
          <td>Division 3</td>
          <td>Division 4</td>
      </tr>
      </tbody>
      </table>`
    },
    coloredNumber: {
      default: "Neutral",
      positive: "Positiv",
      negative: "Negativ"
    },
    footer: {
      contact: "Kontakt",
      showContactInformation: "Kontaktdaten anzeigen",
      changeAudienceAndCulture: "Role und Sprache ändern",
      changeCulture: "Sprache ändern",
      legalAndPolicyLinks: "Rechtliche und politische Links"
    },
    calendarPage: {
      icalDownload: "iCal Datei herunterladen für {eventTitle} Event"
    },
    riskDisclaimer: {
      showDisclaimer: "Haftungsausschluss anzeigen",
      hideDisclaimer: "Haftungsausschluss ausblenden"
    },
    crociCompanyOverviewPage: {
      searchBoxPlaceholder: "Suche nach Firmenname oder Ticker"
    },
    crociCompanyDetailPage: {
      showAll: "Zeige alle Daten",
      showLess: "Zeige weniger Daten",
      ticker: {
        ticker: "Ticker:",
        category: "Kategorie:",
        sharePrice: "Aktienkurs:"
      },
      zoomChart: "Öffne Chart Detailansicht",
      noData: "Keine Daten zum Anzeigen"
    },
    calculatorOutputCard: {
      inflationInfoText: "In <b>{years} Jahren</b> haben <b>{value}</b> Kapital nur noch eine Kaufkraft von:",
      investmentInfoText: "Ihr angespartes Guthaben",
      valueDevelopment: "Wertzuwachs",
      regularInvestment: "Gesamte regelmäßige Einzahlung",
      initialInvestment: "Einzahlung",
      purchasingPower: "Einmalbetrag",
      investmentChartTitle: "Investment Chart Daten",
      inflationChartTitle: "Inflations Chart Daten"
    },
    calculationArea: {
      calculationButtonLabel: "Berechnen",
      optionButtonLabel: "Mehr Optionen",
      optionButtonLabelLess: "Weniger Optionen",
      restartButtonLabel: "Neustart",
      currentInflationRateLabel: "Aktuelle Inflationsrate nutzen"
    }
  },
  es: {
    Accept: "Aceptar",
    Cancel: "Cancelar",
    baseSearchBox: {
      resultEventComponentName: "Enlaces de texto (misma página)"
    },
    audioModule: {
      play: "Reproducir"
    },
    allocationChart: {
      card: {
        othersText: "Misceláneas"
      }
    },
    teaserWww: {
      countrySelectorTitle: "Selecciona una ubicación",
      countryDropdownPlaceholder: "Selecciona una ubicación",
      countryDropdownFilterPlaceholder: "Escriba el texto aquí..."
    },
    shareButton: {
      label: "Compartir en"
    },
    productHeader: {
      allDocuments: "Todos los documentos"
    },
    entryGate: {
      productSearchLabel: "Introduce tu producto",
      countryLabel: "Selecciona tu ubicación",
      audienceLabel: "Selecciona tu rol",
      inputPlaceholder: "ISIN",
      inputInvalidText: "ISIN no válido",
      productLabel: "Tu producto",
      relationshipLabel: "Seleccione su relación comercial",
      existingInvestorLabel: "ya soy inversor",
      nonExistingInvestorLabel: "No soy un inversor existente",
      countryDropdownFilterPlaceholder: "Escriba el texto aquí...",
      countryDropdownPlaceholder: "Seleccione un país"
    },
    dataTable: {
      pageReportTemplate: "Mostrando {first} a {last} de {totalRecords} entradas",
      sortedAscending: "Orden ascendente",
      sortedDescending: "Orden descendente"
    },
    dataCards: {
      showMoreValues: "Mostrar más valores",
      showLessValues: "Mostrar menos valores",
      loadMore: "Cargar más:",
      sortBy: "Ordenar por",
      apply: "Solicitar",
      ascending: "Ascendente",
      descending: "Descendente"
    },
    paginator: {
      pageReportTemplate: "{first} - {last} de {totalRecords}",
      rowsPerPageLabel: "Entradas"
    },
    downloads: {
      fallbackText: "Actualmente no hay descargas disponibles"
    },
    baseSlider: {
      navBackward: "navegar hacia atrás",
      navForward: "navegar hacia adelante",
      navToPage: "navegar a la página"
    },
    historicalData: {
      waitMessage: "Preparando descarga",
      failedMessage: "Descarga fracasó"
    },
    showMoreShowLess: {
      showMoreText: "Mostrar más",
      showLessText: "Muestra menos"
    },
    globalTranslations: {
      yes: "Sí",
      no: "No",
      submit: "Enviar",
      copyButton: "Copiar",
      copiedButton: "copiado!",
      clear: "Delete",
      disclaimerDisagreeButtonLabel: "No Aceptar",
      disclaimerAgreeButtonLabel: "De acuerdo",
      disclaimerCancelButtonLabel: "Cancelar",
      disclaimerConfirmButtonLabel: "Aceptar",
      disclaimerTitle: "Descargo de responsabilidad",
      lockedContentLabel: "Solo disponible para usuarios registrados",
      loginOrRegisterLabel: "Inicie sesión o regístrese ahora",
      isNewLabel: "Nuevo",
      addToWatchlist: "Añadir a lista de seguimiento",
      addedToWatchlist: "Añadido a la lista de observación",
      tooltipTextShare: "Compartir",
      tooltipTextPrint: "Imprimir",
      backLinkText: "Back",
      backToTopButtonText: "Volver arriba",
      closeAllButtonText: "Cierra todo",
      openAllButtonText: "Abrir todo",
      shareClassSelectLabel: "Clase de acciones",
      emailInputLabelText: "Dirección de correo electrónico",
      emailInputHelperText: "Introduzca la dirección de correo electrónico correcta",
      date: "Fecha",
      startDate: "Fecha de inicio",
      endDate: "Fecha final",
      doNotShowAgain: "No volver a mostrar",
      star: "Estrella",
      stars: "Estrellas",
      outOfStars: "de 5 estrellas",
      noContent: "Sin contenido",
      results: "Resultados",
      result: "Resultado",
      search: "Buscar",
      phone: "Teléfono",
      email: "Correo electrónico",
      open: "Abierto",
      close: "Cerrar",
      monthly: "Mensual",
      quarterly: "Trimestral",
      yearly: "Anual",
      million: "mill.",
      billion: "bill",
      years: "años",
      year: "año"
    },
    mediaReleases: {
      searchBoxPlaceholder: "Buscar en comunicados de prensa",
      noResults: "No se encontraron resultados"
    },
    alertButton: {
      label: "Suscribir"
    },
    periodCalendar: {
      fromLabel: "De:",
      toLabel: "A:"
    },
    accordionContainer: {
      closeAll: "Cierra todo",
      openAll: "Abrir todo"
    },
    premiumDiscountLineChart: {
      yAxisLabel: "Prima o descuentos (bps)"
    },
    premiumDiscountHistoricChart: {
      yAxisLabel: "Número de días",
      discount: "Descuento",
      premium: "Prima",
      nav: "NAV"
    },
    stickyNavigation: {
      backToTopLinkText: "Volver arriba",
      dataEventComponentName: "Navegación lateral",
      dataEventTitle: "Marca de salto | Volver arriba",
      mobileNavigation: "Navegación móvil"
    },
    contactCard: {
      mailto: "correo a"
    },
    footNote: {
      link: "volver a la nota al pie"
    },
    footNoteHeader: {
      link: "saltar a la nota al pie"
    },
    breadcrumb: {
      shareButton: "elegir clase de acciones",
      email: "enviar correo",
      scrollLeft: "Desplazarse a la izquierda",
      scrollRight: "Desplazarse a la derecha"
    },
    dropDocuments: {
      button: "abrir lista de selección",
      allDocuments: "Todos los documentos"
    },
    dwsCarousel: {
      backward: "pagina anterior",
      forward: "siguiente página",
      page: "saltar a la página"
    },
    megaMenu: {
      close: "cerca"
    },
    header: {
      search: "Buscar",
      user: "usuario",
      moreLinks: "Mostrar más",
      main: "Navegación principal",
      toggleMenu: "Alternar menú",
      audienceAndCultureText: "Seleccione su rol y ubicación",
      cultureText: "Su ubicación"
    },
    allocationChartCard: {
      showLess: "Muestra menos",
      showMore: "mostrar más"
    },
    performanceChart: {
      close: "cerca",
      //remove after old component is eliminated
      calendarCloseTooltipText: "Cerca",
      calendarTooltipText: "Establecer período",
      downloadTooltipText: "Descargas",
      performanceToggleText: "Rendimiento en %",
      priceToggleText: "Historial NAV",
      date: "Fecha",
      startDate: "Fecha de inicio",
      endDate: "Fecha final",
      nav: "Nav",
      navPercent: "Nav %",
      indexLevel: "Index level",
      indexLevelPercent: "Index level %",
      performanceYaxisLabel: "Rendimiento en %",
      navYaxisLabel: "Nav",
      chartAriaLabel: "Gráfico de rendimiento interactivo",
      chartSeriesLabel: "Etiquetas de series de gráficos",
      chartNavigatorGroupLabel: "Controladores del navegador para seleccionar el rango de fechas.",
      chartNavigatorHandlesLabelLeft: "Izquierda",
      chartNavigatorHandlesLabelRight: "Derecha",
      chartNavigatorHandlesLabelEnd: "manija para hacer zoom."
    },
    fundsInFocus: {
      categoryLabel: "Categoría / Perfil del inversor"
    },
    videoModule: {
      isRunningText: "ahora corriendo",
      minutesShort: "min.",
      playButton: "Reproduce el video"
    },
    personDetailBlock: {
      biography: "Biografía",
      education: "Formación",
      professionalCareer: "Carrera profesional",
      publications: "Publicaciones"
    },
    publications: {
      loadMore: "Carga más"
    },
    newsletterTeaser: {
      invalidErrorTextHeading: "Se ha producido un error",
      invalidErrorText: "Se ha producido un error al procesar su solicitud. Por favor, inténtelo de nuevo."
    },
    baseActionMenu: {
      label: "Menú de acción",
      itemSelected: "A modo de comparación, el producto se movió a la parte superior de la lista.",
      itemRemoved: "A modo de comparación, el producto se eliminó a la parte superior de la lista.",
      markForComparison: "Marcar para comparación",
      bookmark: "Marcador",
      bookmarked: "Marcado",
      removeCompare: "Eliminar de la comparación",
      openActionMenu: "abrir menú de acción"
    },
    fundFinder: {
      periodLabel: "Periodo",
      periodHeadline: "Período de cambio",
      periodHint: "Los cambios realizados aquí también se aplican a otros ajustes que dependen del tiempo.",
      otherFilters: "Otros filtros",
      deselectAll: "Deseleccionar todo",
      fundSearchHeadline: "",
      resetFilters: "Restablecer todos los filtros",
      fundSearchPlaceholder: "Búsqueda",
      products: "productos",
      product: "producto",
      showProducts: "Mostrar",
      downloadDocuments: "Descargar documentos",
      addedCompareMessage: "Para comparar, el producto se movió al principio de la lista",
      removedCompareMessage: "El producto fue retirado de la parte superior de la lista",
      addedBookmarkMessage: "El producto se agregó a su lista de seguimiento",
      removedBookmarkMessage: "El producto fue eliminado de su lista de seguimiento",
      changeColumnView: "Cambiar la vista de columna"
    },
    productChartTeaser: {
      performance: "Rentabilidad"
    },
    archivePage: {
      searchBoxPlaceholder: "Buscar en los archivos",
      loadMore: "Carga más",
      filters: "Filtros",
      resetFilters: "Restablecer todos los filtros",
      otherFilters: "Otros filtros"
    },
    teaser: {
      new: "Nuevo"
    },
    baseResultView: {
      listViewTitle: "Ver lista",
      gridViewTitle: "Vista en cuadrícula"
    },
    showMoreLessToggle: {
      showMoreText: "Mostrar más",
      showLessText: "Mostrar menos"
    },
    searchResultPage: {
      searchResultPagePlaceholder: "Buscar",
      resultsFor: "Resultados para",
      filterBy: "Filtrado por",
      sortBy: "Ordenar por"
    },
    baseNonRemovableFilters: {
      edit: "Editar"
    },
    baseRemovableFilters: {
      removeFilter: "eliminar filtro"
    },
    tabContainer: {
      requiresLogin: "Requiere inicio de sesión"
    },
    propertyTeaser: {
      gallery: "Galería",
      images: "Imágenes"
    },
    propertyGallery: {
      map: "Mapa",
      filters: "Filtros",
      marketValue: "Valor de mercado",
      acquisitionYear: "Año de adquisición",
      location: "Localización",
      resultText: "Propiedad",
      resultsText: "Propiedades",
      loadMore: "Cargar más"
    },
    sortOptions: {
      sortByLabel: "Ordenar por",
      nameAsc: "Nombre A-Z",
      nameDesc: "Nombre Z-A",
      priceAsc: "Precio bajo-alto",
      priceDesc: "Precio alto-bajo",
      acquisitionYearAsc: "Año antiguo-reciente",
      acquisitionYearDesc: "Año reciente-antiguo"
    },
    propertyKeyValues: {
      type: "Tipo",
      purchasePrice: "Precio de compra",
      acquisitionYear: "Año de adquisición",
      location: "Ubicación"
    },
    baseGoogleMap: {
      mapType: "Tipo de mapa",
      streetView: "Vista de la calle",
      zoomIn: "Ampliar",
      zoomOut: "Alejar",
      locationMarker: "Elegir"
    },
    documentList: {
      numberOfResultLabel: "documentos"
    },
    literatureLibrary: {
      searchBoxPlaceholder: "Buscar producto"
    },
    baseTreeSelect: {
      placeholder: "Buscar",
      emptyMessage: "No se han encontrado prospectos ni informes",
      triggerAriaLabel: "Abrir lista de selección"
    },
    faqPage: {
      expandAll: "Mostrar todas las respuestas",
      closeAll: "Cerrar todas las respuestas",
      searchPlaceholder: "Buscar en FAQ",
      result: "Resultado",
      results: "Resultados",
      noResults: "No se encontraron resultados",
      searchResults: "Resultados de búsqueda"
    },
    glossary: {
      expandAll: "Mostrar todas las respuestas",
      closeAll: "Cerrar todas las respuestas",
      searchPlaceholder: "Buscar en glosario",
      result: "Resultado",
      results: "Resultados",
      noResults: "No se encontraron resultados para",
      showAllResults: "Mostrar todos los resultados",
      chooseOption: "Elegir opción"
    },
    eventList: {
      date: "Fecha",
      event: "Evento",
      time: "Hora",
      download: "Descargar"
    },
    quizAndPoll: {
      explanationHeadlineCorrect: "Genial, tu respuesta es correcta.",
      explanationHeadlineInCorrect: "Lo siento, tu respuesta no fue del todo correcta.",
      socialLabel: "Compartir:"
    },
    marketDataBlock: {
      intraday: "Intradía"
    },
    search: {
      showAllResults: "Mostrar todos los resultados"
    },
    imageGalleryTeaser: {
      gallery: "Abrir en galería"
    },
    documentViewer: {
      documentView: "Vista de documento PDF",
      loading: "Cargando documento"
    },
    productBuyingProcess: {
      searchBoxPlaceholder: "Buscar tu proveedor",
      continueToPartner: "Continuar con el socio"
    },
    coloredNumber: {
      default: "Neutral",
      positive: "Positivo",
      negative: "Negativo"
    },
    footer: {
      contact: "Contacto",
      showContactInformation: "Mostrar información de contacto",
      changeAudienceAndCulture: "Cambiar rol y idioma",
      changeCulture: "Cambiar idioma",
      legalAndPolicyLinks: "Enlaces legales y políticos"
    },
    calendarPage: {
      icalDownload: "Descargar archivo iCal para {eventTitle} Evento"
    },
    riskDisclaimer: {
      showDisclaimer: "Mostrar descargo de responsabilidad",
      hideDisclaimer: "Ocultar descargo de responsabilidad"
    },
    crociCompanyOverviewPage: {
      searchBoxPlaceholder: "Busque el nombre de la empresa o el teletipo"
    },
    crociCompanyDetailPage: {
      showAll: "Mostrar todos los datos",
      showLess: "Mostrar menos datos",
      ticker: {
        ticker: "Teletipo:",
        category: "Categoría:",
        sharePrice: "Precio de la acción:"
      },
      zoomChart: "Abrir vista detallada del gráfico"
    },
    calculatorOutputCard: {
      inflationInfoText: "En <b>{years} años, {value}</b> de capital solo tendrán un poder adquisitivo de:",
      investmentInfoText: "Su saldo acumulado",
      valueDevelopment: "Desarrollo de valor",
      regularInvestment: "Inversión regular total",
      initialInvestment: "Inversión inicial",
      purchasingPower: "Monto único",
      investmentChartTitle: "Datos del gráfico de inversión",
      inflationChartTitle: "Datos del gráfico de inflación"
    },
    calculationArea: {
      calculationButtonLabel: "Calcular",
      optionButtonLabel: "Más opciones",
      optionButtonLabelLess: "Menos opciones",
      restartButtonLabel: "Reiniciar",
      currentInflationRateLabel: "Utilizar la tasa de inflación actual"
    }
  },
  fr: {
    Accept: "Accepter",
    Cancel: "Annuler",
    baseSearchBox: {
      resultEventComponentName: "Liens texte (même page)"
    },
    audioModule: {
      play: "Jouer"
    },
    allocationChart: {
      card: {
        othersText: "Autres"
      }
    },
    teaserWww: {
      countrySelectorTitle: "Sélectionnez un emplacement",
      countryDropdownPlaceholder: "Sélectionnez un emplacement",
      countryDropdownFilterPlaceholder: "Tapez le texte ici.."
    },
    shareButton: {
      label: "Partager sur"
    },
    productHeader: {
      allDocuments: "Tous les documents"
    },
    entryGate: {
      productSearchLabel: "Entrez votre produit",
      countryLabel: "Sélectionnez votre emplacement",
      audienceLabel: "Sélectionnez votre rôle",
      inputPlaceholder: "ISIN",
      inputInvalidText: "ISIN invalide",
      productLabel: "Ton produit",
      relationshipLabel: "Sélectionnez votre relation d'affaires",
      existingInvestorLabel: "Je suis un investisseur existant",
      nonExistingInvestorLabel: "Je ne suis pas un investisseur existant",
      countryDropdownFilterPlaceholder: "Tapez le texte ici...",
      countryDropdownPlaceholder: "Choisissez un pays"
    },
    dataTable: {
      pageReportTemplate: "Affichage de la {first} à la {last} entrées sur {totalRecords}",
      sortedAscending: "Tri croissant",
      sortedDescending: "Tri décroissant"
    },
    dataCards: {
      showMoreValues: "Afficher plus de valeurs",
      showLessValues: "Afficher moins de valeurs",
      loadMore: "Charger plus:",
      sortBy: "Trier par",
      apply: "Appliquer",
      ascending: "Ascendante",
      descending: "Descente"
    },
    paginator: {
      pageReportTemplate: "{first} - {last} à la {totalRecords}",
      rowsPerPageLabel: "Entrées"
    },
    downloads: {
      fallbackText: "Actuellement, aucun téléchargement n'est disponible"
    },
    baseSlider: {
      navBackward: "naviguer en arrière",
      navForward: "naviguer vers l'avant",
      navToPage: "naviguer vers la page"
    },
    historicalData: {
      waitMessage: "Préparation du téléchargement",
      failedMessage: "Échec du téléchargement"
    },
    showMoreShowLess: {
      showMoreText: "Montre plus",
      showLessText: "Montrer moins"
    },
    globalTranslations: {
      yes: "Oui",
      no: "Non",
      submit: "Soumettre",
      copyButton: "Copie",
      copiedButton: "Copié !",
      clear: "Delete",
      disclaimerDisagreeButtonLabel: "Pas d'accord",
      disclaimerAgreeButtonLabel: "Accorder",
      disclaimerCancelButtonLabel: "Annuler",
      disclaimerConfirmButtonLabel: "Accepter",
      disclaimerTitle: "Clause de non-responsabilité",
      lockedContentLabel: "Uniquement disponible pour les utilisateurs enregistrés",
      loginOrRegisterLabel: "Connectez-vous ou inscrivez-vous dès maintenant",
      isNewLabel: "Nouveau",
      addToWatchlist: "Ajouter à la liste de surveillance",
      addedToWatchlist: "Ajouté à la liste de surveillance",
      tooltipTextShare: "Partager",
      tooltipTextPrint: "Print",
      backLinkText: "Back",
      backToTopButtonText: "Imprimer",
      closeAllButtonText: "Ferme tout",
      openAllButtonText: "Ouvre tout",
      shareClassSelectLabel: "Catégorie d'actions",
      emailInputLabelText: "Adresse e-mail",
      emailInputHelperText: "Veuillez saisir ladresse électronique correcte",
      date: "Données",
      startDate: "Date de début",
      endDate: "Date de fin",
      doNotShowAgain: "Ne plus montrer",
      star: "Étoile",
      stars: "Étoiles",
      outOfStars: "sur 5 étoiles",
      noContent: "Pas de contenu",
      results: "Résultats",
      result: "Résultat",
      search: "Recherche",
      phone: "Téléphone",
      email: "Email",
      open: "Ouvert",
      close: "Fermer",
      monthly: "Mensuel",
      quarterly: "Trimestriel",
      yearly: "Annuel",
      million: "M",
      billion: "Mrd",
      years: "ans",
      year: "an"
    },
    mediaReleases: {
      searchBoxPlaceholder: "Recherche dans les communiqués de presse",
      noResults: "Aucun résultat trouvé"
    },
    alertButton: {
      label: "S'abonner"
    },
    periodCalendar: {
      fromLabel: "Depuis:",
      toLabel: "Pour:"
    },
    accordionContainer: {
      closeAll: "Ferme tout",
      openAll: "Ouvre tout"
    },
    premiumDiscountLineChart: {
      yAxisLabel: "Prime ou rabais (bps)"
    },
    premiumDiscountHistoricChart: {
      yAxisLabel: "Nombre de jours",
      discount: "Remise",
      premium: "Prime",
      nav: "NAV"
    },
    stickyNavigation: {
      backToTopLinkText: "Retour au sommet",
      dataEventComponentName: "Navigation latérale",
      dataEventTitle: "Marque de saut | Retour au sommet",
      mobileNavigation: "Navigation mobile"
    },
    contactCard: {
      mailto: "mailto"
    },
    footNote: {
      link: "revenir à la note de bas de page"
    },
    footNoteHeader: {
      link: "aller à la note de bas de page"
    },
    breadcrumb: {
      shareButton: "choisir la classe d'actions",
      email: "envoyer un mail",
      scrollLeft: "Faites défiler vers la gauche",
      scrollRight: "Faites défiler vers la droite"
    },
    dropDocuments: {
      button: "ouvrir la liste de sélection",
      allDocuments: "Tous les documents"
    },
    dwsCarousel: {
      backward: "page précédente",
      forward: "page suivante",
      page: "sauter à la page"
    },
    megaMenu: {
      close: "fermer"
    },
    header: {
      search: "Recherche",
      user: "utilisateur",
      moreLinks: "Montre plus",
      main: "Navigation principale",
      toggleMenu: "Basculer le menu",
      audienceAndCultureText: "Sélectionnez votre rôle et votre emplacement",
      cultureText: "Votre emplacement"
    },
    allocationChartCard: {
      showLess: "Montrer moins",
      showMore: "montre plus"
    },
    performanceChart: {
      close: "fermer",
      //remove after old component is eliminated
      calendarCloseTooltipText: "Fermer",
      calendarTooltipText: "Définir la période",
      downloadTooltipText: "Téléchargements",
      performanceToggleText: "Performances en %",
      priceToggleText: "Historique de la NAV",
      date: "Date",
      startDate: "Date de début",
      endDate: "Date de fin",
      nav: "Nav",
      navPercent: "Nav %",
      indexLevel: "Index level",
      indexLevelPercent: "Index level %",
      performanceYaxisLabel: "Performances en %",
      navYaxisLabel: "Nav",
      chartAriaLabel: "Graphique de performance interactif",
      chartSeriesLabel: "Étiquettes de séries de graphiques",
      chartNavigatorGroupLabel: "Poignées de navigateur pour sélectionner la plage de dates.",
      chartNavigatorHandlesLabelLeft: "Gauche",
      chartNavigatorHandlesLabelRight: "Droite",
      chartNavigatorHandlesLabelEnd: "poignée pour zoomer."
    },
    fundsInFocus: {
      categoryLabel: "Catégorie / Profil d'investisseur"
    },
    videoModule: {
      isRunningText: "maintenant en cours d'exécution",
      minutesShort: "min.",
      playButton: "Lire la vidéo"
    },
    personDetailBlock: {
      biography: "Biographie",
      education: "Formation",
      professionalCareer: "Carrière professionnelle",
      publications: "Éditions"
    },
    publications: {
      loadMore: "Charger plus"
    },
    newsletterTeaser: {
      invalidErrorTextHeading: "Une erreur est survenue",
      invalidErrorText: "Une erreur est survenue lors du traitement de votre demande. Veuillez réessayer."
    },
    baseActionMenu: {
      label: "Menu d'action",
      itemSelected: "À titre de comparaison, le produit a été déplacé en haut de la liste.",
      itemRemoved: "A titre de comparaison, le produit a été retiré en haut de la liste.",
      markForComparison: "Marquer pour comparaison",
      bookmark: "Signet",
      bookmarked: "marquer avec des signets",
      removeCompare: "Supprimer de la comparaison",
      openActionMenu: "ouvrir le menu daction"
    },
    fundFinder: {
      periodLabel: "Période",
      periodHeadline: "Période de changement",
      periodHint: "Les modifications apportées ici sont également appliquées à d'autres paramètres dépendant du temps.",
      otherFilters: "Autres filtres",
      deselectAll: "Tout désélectionner",
      fundSearchHeadline: "",
      resetFilters: "Réinitialiser tous les filtres",
      fundSearchPlaceholder: "Recherche",
      products: "produits",
      product: "produit",
      showProducts: "Afficher",
      downloadDocuments: "Télécharger des documents",
      addedCompareMessage: "Pour comparaison, le produit a été déplacé vers le haut de la liste",
      removedCompareMessage: "Le produit a été retiré du haut de la liste",
      addedBookmarkMessage: "Le produit a été ajouté à votre liste de surveillance",
      removedBookmarkMessage: "Le produit a été retiré de votre liste de surveillance",
      changeColumnView: "Modifier laffichage des colonnes"
    },
    productChartTeaser: {
      performance: "Performance"
    },
    archivePage: {
      searchBoxPlaceholder: "Recherche dans les archives",
      loadMore: "Charger plus",
      filters: "Filtres",
      resetFilters: "Réinitialiser tous les filtres",
      otherFilters: "Autres filtres"
    },
    teaser: {
      new: "Nouveau"
    },
    baseResultView: {
      listViewTitle: "Vue de la liste",
      gridViewTitle: "Vue en grille"
    },
    showMoreLessToggle: {
      showMoreText: "Montre plus",
      showLessText: "Montre moins"
    },
    searchResultPage: {
      searchResultPagePlaceholder: "Recherche",
      resultsFor: "Résultats pour",
      filterBy: "Filtrer par",
      sortBy: "Trier par"
    },
    baseNonRemovableFilters: {
      edit: "Modifier"
    },
    baseRemovableFilters: {
      removeFilter: "supprimer le filtre"
    },
    tabContainer: {
      requiresLogin: "Nécessite une connexion"
    },
    propertyTeaser: {
      gallery: "Galerie",
      images: "Images"
    },
    propertyGallery: {
      map: "Carte",
      filters: "Filtres",
      marketValue: "Valeur de marché",
      acquisitionYear: "Année d'acquisition",
      location: "Localisation",
      resultText: "Propriété",
      resultsText: "Propriétés",
      loadMore: "Plus d'informations"
    },
    sortOptions: {
      sortByLabel: "Trier par",
      nameAsc: "Nom A-Z",
      nameDesc: "Nom Z-A",
      priceAsc: "Prix bas-élevé",
      priceDesc: "Prix élevé-bas",
      acquisitionYearAsc: "Année dachat ancien-récent",
      acquisitionYearDesc: "Année dachat récent-ancien"
    },
    propertyKeyValues: {
      type: "Type",
      purchasePrice: "Prix dachat",
      acquisitionYear: "Année dacquisition",
      location: "Emplacement"
    },
    baseGoogleMap: {
      mapType: "Type de carte",
      streetView: "Vue de la rue",
      zoomIn: "Zoom avant",
      zoomOut: "Zoom arrière",
      locationMarker: "Choisir"
    },
    documentList: {
      numberOfResultLabel: "documents"
    },
    literatureLibrary: {
      searchBoxPlaceholder: "Rechercher un produit"
    },
    baseTreeSelect: {
      placeholder: "Rechercher",
      emptyMessage: "Aucun prospectus ou rapport trouvé",
      triggerAriaLabel: "Ouvrir la liste de sélection"
    },
    faqPage: {
      expandAll: "Afficher toutes les réponses",
      closeAll: "Fermer toutes les réponses",
      searchPlaceholder: "Rechercher dans les FAQ",
      result: "Résultat",
      results: "Résultats",
      noResults: "Aucun résultat trouvé",
      searchResults: "Résultats de recherche"
    },
    glossary: {
      expandAll: "Afficher toutes les réponses",
      closeAll: "Fermer toutes les réponses",
      searchPlaceholder: "Rechercher dans le glossaire",
      result: "Résultat",
      results: "Résultats",
      noResults: "Aucun résultat trouvé pour",
      showAllResults: "Afficher tous les résultats",
      chooseOption: "Choisir une option"
    },
    eventList: {
      date: "Date",
      event: "Événement",
      time: "Heure",
      download: "Télécharger"
    },
    quizAndPoll: {
      explanationHeadlineCorrect: "Génial, votre réponse est correcte.",
      explanationHeadlineInCorrect: "Désolé, votre réponse nétait pas tout à fait correcte.",
      socialLabel: "Partager:"
    },
    marketDataBlock: {
      intraday: "Intraday"
    },
    search: {
      showAllResults: "Afficher tous les résultats"
    },
    imageGalleryTeaser: {
      gallery: "Ouvrir dans la galerie"
    },
    documentViewer: {
      documentView: "Vue du document PDF",
      loading: "Document en cours de chargement"
    },
    productBuyingProcess: {
      searchBoxPlaceholder: "Rechercher votre fournisseur",
      continueToPartner: "Continuer avec le partenaire"
    },
    coloredNumber: {
      default: "Neutre",
      positive: "Positif",
      negative: "Négatif"
    },
    footer: {
      contact: "Contact",
      showContactInformation: "Afficher les informations de contact",
      changeAudienceAndCulture: "Changer de rôle et de langue",
      changeCulture: "Changer de langue",
      legalAndPolicyLinks: "Liens juridiques et politiques"
    },
    calendarPage: {
      icalDownload: "Télécharger le fichier iCal pour {eventTitle} Événement"
    },
    riskDisclaimer: {
      showDisclaimer: "Afficher la clause de non-responsabilité",
      hideDisclaimer: "Masquer la clause de non-responsabilité"
    },
    crociCompanyOverviewPage: {
      searchBoxPlaceholder: "Rechercher le nom de l'entreprise ou le téléscripteur"
    },
    crociCompanyDetailPage: {
      showAll: "Afficher toutes les données",
      showLess: "Afficher moins de données",
      ticker: {
        ticker: "Téléscripteur:",
        category: "Catégorie:",
        sharePrice: "Prix de laction:"
      },
      zoomChart: "Ouvrir la vue détaillée du graphique"
    },
    calculatorOutputCard: {
      inflationInfoText: "Dans <b>{years} ans, {value}</b> de capital nauront plus un pouvoir dachat de:",
      investmentInfoText: "Votre solde accumulé",
      valueDevelopment: "Développement de la valeur",
      regularInvestment: "Investissement régulier total",
      initialInvestment: "Investissement initial",
      purchasingPower: "Montant unique",
      investmentChartTitle: "Données du graphique d'investissement",
      inflationChartTitle: "Données du graphique d'inflation"
    },
    calculationArea: {
      calculationButtonLabel: "Calculer",
      optionButtonLabel: "Plus doptions",
      optionButtonLabelLess: "Moins doptions",
      restartButtonLabel: "Redémarrer",
      currentInflationRateLabel: "Utiliser le taux dinflation actuel"
    }
  },
  it: {
    Accept: "Accettare",
    Cancel: "Annulla",
    baseSearchBox: {
      resultEventComponentName: "Link testuali (stessa pagina)"
    },
    audioModule: {
      play: "Giocare"
    },
    allocationChart: {
      card: {
        othersText: "Varie"
      }
    },
    teaserWww: {
      countrySelectorTitle: "Seleziona una posizione",
      countryDropdownPlaceholder: "Seleziona una posizione",
      countryDropdownFilterPlaceholder: "Digita il testo qui..."
    },
    shareButton: {
      label: "Condividi su"
    },
    productHeader: {
      allDocuments: "Tutti i documenti"
    },
    entryGate: {
      productSearchLabel: "Inserisci il tuo prodotto",
      countryLabel: "Seleziona la tua posizione",
      audienceLabel: "Seleziona il tuo ruolo",
      inputPlaceholder: "ISIN",
      inputInvalidText: "ISIN non valido",
      productLabel: "Il tuo prodotto",
      relationshipLabel: "Seleziona la tua relazione d'affari",
      existingInvestorLabel: "Sono un investitore esistente",
      nonExistingInvestorLabel: "Non sono un investitore esistente",
      countryDropdownFilterPlaceholder: "Digita il testo qui...",
      countryDropdownPlaceholder: "Seleziona un Paese"
    },
    dataTable: {
      pageReportTemplate: "Visualizzazione dal {first} al {last} di {totalRecords} voci",
      sortedAscending: "Ordinamento crescente",
      sortedDescending: "Ordinamento decrescente"
    },
    dataCards: {
      showMoreValues: "Mostra più valori",
      showLessValues: "Mostra meno valori",
      loadMore: "Carica di più:",
      sortBy: "Ordina per",
      apply: "Applicare",
      ascending: "In salita",
      descending: "In discesa"
    },
    paginator: {
      pageReportTemplate: "{first} - {last} di {totalRecords}",
      rowsPerPageLabel: "Inserimenti"
    },
    downloads: {
      fallbackText: "Al momento non sono disponibili download"
    },
    baseSlider: {
      navBackward: "navigare all'indietro",
      navForward: "navigare in avanti",
      navToPage: "vai alla pagina"
    },
    historicalData: {
      waitMessage: "Preparazione del download",
      failedMessage: "Scaricamento fallito"
    },
    showMoreShowLess: {
      showMoreText: "Mostra di più",
      showLessText: "Mostra meno"
    },
    globalTranslations: {
      yes: "Sì",
      no: "No",
      submit: "Invia",
      copyButton: "copia",
      copiedButton: "Copiato!",
      clear: "Delete",
      disclaimerDisagreeButtonLabel: "Non sono d'accordo",
      disclaimerAgreeButtonLabel: "Concordo",
      disclaimerCancelButtonLabel: "Annulla",
      disclaimerConfirmButtonLabel: "Accettare",
      disclaimerTitle: "Disclaimer",
      lockedContentLabel: "Disponibile solo per gli utenti registrati",
      loginOrRegisterLabel: "Accedi o registrati ora",
      isNewLabel: "Nuovo",
      addToWatchlist: "Aggiungere alla lista delle cose da vedere",
      addedToWatchlist: "Aggiunto alla lista di controllo",
      tooltipTextShare: "Condividere",
      tooltipTextPrint: "Stampa",
      backLinkText: "Back",
      backToTopButtonText: "Torna in cima",
      closeAllButtonText: "Chiudi tutto",
      openAllButtonText: "Apri tutto",
      shareClassSelectLabel: "Classe di azioni",
      emailInputLabelText: "Indirizzo e-mail",
      emailInputHelperText: "Inserire lindirizzo e-mail corretto",
      date: "Dato",
      startDate: "Dato iniziale",
      endDate: "Dato finale",
      doNotShowAgain: "Non mostrare di nuovo",
      star: "Stella",
      stars: "Stelle",
      outOfStars: "di 5 stelle",
      noContent: "Nessun contenuto",
      results: "Risultati",
      result: "Risultato",
      search: "Ricerca",
      phone: "Telefono",
      email: "Email",
      open: "Aperto",
      close: "Vicino",
      monthly: "Mensile",
      quarterly: "Trimestrale",
      yearly: "Annuale",
      million: "Mil.",
      billion: "Mld.",
      years: "anni",
      year: "anno"
    },
    mediaReleases: {
      searchBoxPlaceholder: "Ricerca nei comunicati stampa",
      noResults: "Nessun risultato trovato"
    },
    alertButton: {
      label: "sottoscrivi"
    },
    periodCalendar: {
      fromLabel: "Da:",
      toLabel: "A:"
    },
    accordionContainer: {
      closeAll: "Chiudi tutto",
      openAll: "Apri tutto"
    },
    premiumDiscountLineChart: {
      yAxisLabel: "Premio o sconti (bps)"
    },
    premiumDiscountHistoricChart: {
      yAxisLabel: "Number of Days",
      discount: "Sconto",
      premium: "Premio",
      nav: "NAV"
    },
    stickyNavigation: {
      backToTopLinkText: "Torna in cima",
      dataEventComponentName: "Navigazione laterale",
      dataEventTitle: "Salto | Torna in cima",
      mobileNavigation: "Navigazione mobile"
    },
    contactCard: {
      mailto: "mailto"
    },
    footNote: {
      link: "torna alla nota a piè di pagina"
    },
    footNoteHeader: {
      link: "vai alla nota a piè di pagina"
    },
    breadcrumb: {
      shareButton: "scegli la classe di azioni",
      email: "inviare una mail",
      scrollLeft: "Scorrere a sinistra",
      scrollRight: "Scorrere a destra"
    },
    dropDocuments: {
      button: "aprire l'elenco di selezione",
      allDocuments: "Tutti i documenti"
    },
    dwsCarousel: {
      backward: "pagina precedente",
      forward: "pagina successiva",
      page: "salta alla pagina"
    },
    megaMenu: {
      close: "vicino"
    },
    header: {
      search: "Ricerca",
      user: "Utente",
      moreLinks: "Mostra di più",
      main: "Navigazione principale",
      toggleMenu: "Attiva/disattiva il menu",
      audienceAndCultureText: "Seleziona il tuo ruolo e la tua posizione",
      cultureText: "La tua posizione"
    },
    allocationChartCard: {
      showLess: "mostra meno",
      showMore: "mostra di più"
    },
    performanceChart: {
      close: "vicino",
      //remove after old component is eliminated
      calendarCloseTooltipText: "Vicino",
      calendarTooltipText: "Periodo stabilito",
      downloadTooltipText: "Download",
      performanceToggleText: "Rendimento in %",
      priceToggleText: "Storia del NAV",
      date: "Data",
      startDate: "Data iniziale",
      endDate: "Data finale",
      nav: "Nav",
      navPercent: "Nav %",
      indexLevel: "Index level",
      indexLevelPercent: "Index level %",
      performanceYaxisLabel: "Rendimento in %",
      navYaxisLabel: "Nav",
      chartAriaLabel: "Grafico di performance interattivo",
      chartSeriesLabel: "Etichette delle serie di grafici",
      chartNavigatorGroupLabel: "Maniglie di navigazione per la selezione dell'intervallo di date.",
      chartNavigatorHandlesLabelLeft: "Sinistra",
      chartNavigatorHandlesLabelRight: "Destra",
      chartNavigatorHandlesLabelEnd: "maniglia per lo zoom."
    },
    fundsInFocus: {
      categoryLabel: "Categoria/Profilo dell'investitore"
    },
    videoModule: {
      isRunningText: "ora in esecuzione",
      minutesShort: "min.",
      playButton: "Riprodurre video"
    },
    personDetailBlock: {
      biography: "Biografia",
      education: "La formazione",
      professionalCareer: "Carriera professionale",
      publications: "Publications"
    },
    publications: {
      loadMore: "carica di più"
    },
    newsletterTeaser: {
      invalidErrorTextHeading: "Si è verificato un errore",
      invalidErrorText: "Si è verificato un errore durante l`elaborazione della richiesta. Si prega di riprovare."
    },
    baseActionMenu: {
      label: "Menu d'azione",
      itemSelected: "Per confronto, il prodotto è stato spostato in cima all'elenco.",
      itemRemoved: "Per confronto, il prodotto è stato rimosso in cima all'elenco.",
      markForComparison: "Contrassegnare per il confronto",
      bookmark: "Segnalibro",
      bookmarked: "Segnalibro",
      removeCompare: "Rimuovi dalla comparazione",
      openActionMenu: "apri il menu azioni"
    },
    fundFinder: {
      periodLabel: "Periodo",
      periodHeadline: "Cambiamento di periodo",
      periodHint: "Le modifiche apportate in questo punto vengono applicate anche ad altre impostazioni dipendenti dal tempo.",
      otherFilters: "Altri filtri",
      deselectAll: "Deseleziona tutto",
      fundSearchHeadline: "",
      resetFilters: "Reimposta tutti i filtri",
      fundSearchPlaceholder: "Ricerca",
      products: "prodotti",
      product: "prodotto",
      showProducts: "Mostra",
      downloadDocuments: "Scarica i documenti",
      addedCompareMessage: "Per confronto, il prodotto è stato spostato in cima all elenco",
      removedCompareMessage: "Il prodotto è stato rimosso dall inizio dell elenco",
      addedBookmarkMessage: "Il prodotto è stato aggiunto alla tua lista di controllo",
      removedBookmarkMessage: "Il prodotto è stato rimosso dalla tua lista di controllo",
      changeColumnView: "Cambiare la visualizzazione delle colonne"
    },
    productChartTeaser: {
      performance: "Performance"
    },
    archivePage: {
      searchBoxPlaceholder: "Ricerca negli archivi",
      loadMore: "carica di più",
      filters: "Filtri",
      resetFilters: "Reimposta tutti i filtri",
      otherFilters: "Altri filtri"
    },
    teaser: {
      new: "Nuovo"
    },
    baseResultView: {
      listViewTitle: "Vista elenco",
      gridViewTitle: "Vista griglia"
    },
    showMoreLessToggle: {
      showMoreText: "Mostra di più",
      showLessText: "Mostra meno"
    },
    searchResultPage: {
      searchResultPagePlaceholder: "Ricerca",
      resultsFor: "Risultati per",
      filterBy: "Filtra per",
      sortBy: "Ordina per"
    },
    baseNonRemovableFilters: {
      edit: "Modifica"
    },
    baseRemovableFilters: {
      removeFilter: "rimuovi filtro"
    },
    tabContainer: {
      requiresLogin: "Richiede laccesso"
    },
    propertyTeaser: {
      gallery: "Galleria",
      images: "Immagini"
    },
    propertyGallery: {
      map: "Mappa",
      filters: "Filtri",
      marketValue: "Valore di mercato",
      acquisitionYear: "Anno di acquisizione",
      location: "Posizione",
      resultText: "Proprietà",
      resultsText: "Proprietà",
      loadMore: "Carica di più"
    },
    sortOptions: {
      sortByLabel: "Ordina per",
      nameAsc: "Nome A-Z",
      nameDesc: "Nome Z-A",
      priceAsc: "Prezzo basso-alto",
      priceDesc: "Prezzo alto-basso",
      acquisitionYearAsc: "Anno di acquisizione vecchio-recente",
      acquisitionYearDesc: "Anno di acquisizione recente-vecchio"
    },
    propertyKeyValues: {
      type: "Tipo",
      purchasePrice: "Prezzo di acquisto",
      acquisitionYear: "Anno di acquisizione",
      location: "Posizione"
    },
    baseGoogleMap: {
      mapType: "Tipo di mappa",
      streetView: "Vista della strada",
      zoomIn: "Ingrandisci",
      zoomOut: "Ingrandire",
      locationMarker: "Scegliere"
    },
    documentList: {
      numberOfResultLabel: "documenti"
    },
    literatureLibrary: {
      searchBoxPlaceholder: "Cerca prodotto"
    },
    baseTreeSelect: {
      placeholder: "Cerca",
      emptyMessage: "Nessun prospetto o rapporto trovato",
      triggerAriaLabel: "Apri elenco di selezione"
    },
    faqPage: {
      expandAll: "Mostra tutte le risposte",
      closeAll: "Chiudi tutte le risposte",
      searchPlaceholder: "Cerca in FAQ",
      result: "Risultato",
      results: "Risultati",
      noResults: "Nessun risultato trovato",
      searchResults: "Risultati della ricerca"
    },
    glossary: {
      expandAll: "Mostra tutte le risposte",
      closeAll: "Chiudi tutte le risposte",
      searchPlaceholder: "Cerca nel glossario",
      result: "Risultato",
      results: "Risultati",
      noResults: "Nessun risultato trovato per",
      showAllResults: "Mostra tutti i risultati",
      chooseOption: "Scegliere unopzione"
    },
    eventList: {
      date: "Data",
      event: "Evento",
      time: "Ora",
      download: "Scarica"
    },
    quizAndPoll: {
      explanationHeadlineCorrect: "Grande, la tua risposta è corretta.",
      explanationHeadlineInCorrect: "Spiacente, la tua risposta non era del tutto corretta.",
      socialLabel: "Condividi:"
    },
    marketDataBlock: {
      intraday: "Intraday"
    },
    search: {
      showAllResults: "Mostra tutti i risultati"
    },
    imageGalleryTeaser: {
      gallery: "Apri nella galleria"
    },
    documentViewer: {
      documentView: "Vista del documento PDF",
      loading: "Documento in caricamento"
    },
    productBuyingProcess: {
      searchBoxPlaceholder: "Cerca il tuo fornitore",
      continueToPartner: "Continua con il partner"
    },
    coloredNumber: {
      default: "Neutro",
      positive: "Positivo",
      negative: "Negativo"
    },
    footer: {
      contact: "Contatto",
      showContactInformation: "Mostra informazioni di contatto",
      changeAudienceAndCulture: "Cambia ruolo e lingua",
      changeCulture: "Cambia lingua",
      legalAndPolicyLinks: "Link legali e politici"
    },
    calendarPage: {
      icalDownload: "Scarica file iCal per {eventTitle} Evento"
    },
    riskDisclaimer: {
      showDisclaimer: "Mostra la clausola di non responsabilità",
      hideDisclaimer: "Nascondi la clausola di non responsabilità"
    },
    crociCompanyOverviewPage: {
      searchBoxPlaceholder: "Cerca il nome o il titolo dell'azienda"
    },
    crociCompanyDetailPage: {
      showAll: "Mostra tutti i dati",
      showLess: "Mostra meno dati",
      ticker: {
        ticker: "Ticker:",
        category: "Categoria:",
        sharePrice: "Prezzo delle azioni:"
      },
      zoomChart: "Apri vista dettagliata del grafico"
    },
    calculatorOutputCard: {
      inflationInfoText: "In <b>{years} anni, {value}</b> di capitale non avrà più potere dacquisto di:",
      investmentInfoText: "Il tuo saldo accumulato",
      valueDevelopment: "Sviluppo del valore",
      regularInvestment: "Investimento regolare totale",
      initialInvestment: "Investimento iniziale",
      purchasingPower: "Importo singolo",
      investmentChartTitle: "Dati grafico investimenti",
      inflationChartTitle: "Dati grafico inflazione"
    },
    calculationArea: {
      calculationButtonLabel: "Calcolare",
      optionButtonLabel: "Più opzioni",
      optionButtonLabelLess: "Meno opzioni",
      restartButtonLabel: "Ricomincia",
      currentInflationRateLabel: "Usa il tasso dinflazione attuale"
    }
  },
  ja: {
    Accept: "受け入れる",
    Cancel: "キャンセル",
    baseSearchBox: {
      resultEventComponentName: "テキストリンク（同一ページ）"
    },
    audioModule: {
      play: "再生"
    },
    allocationChart: {
      card: {
        othersText: "その他"
      }
    },
    teaserWww: {
      countrySelectorTitle: "場所を選択",
      countryDropdownPlaceholder: "場所を選択",
      countryDropdownFilterPlaceholder: "ここにテキストを入力..."
    },
    shareButton: {
      label: "共有する"
    },
    productHeader: {
      allDocuments: "すべての書類"
    },
    entryGate: {
      productSearchLabel: "製品を入力してください",
      countryLabel: "あなたの場所を選択してください",
      audienceLabel: "役割を選択してください",
      inputPlaceholder: "ISIN",
      inputInvalidText: "無効な ISIN",
      productLabel: "あなたの製品",
      relationshipLabel: "ビジネス関係を選択してください",
      existingInvestorLabel: "私は既存の投資家です",
      nonExistingInvestorLabel: "私は既存の投資家ではありません",
      countryDropdownFilterPlaceholder: "ここにテキストを入力...",
      countryDropdownPlaceholder: "国を選択"
    },
    dataTable: {
      pageReportTemplate: "{totalRecords} エントリの {first} から {last} を表示しています",
      sortedAscending: "昇順で並べ替え",
      sortedDescending: "降順で並べ替え"
    },
    dataCards: {
      showMoreValues: "さらに表示",
      showLessValues: "表示を減らす",
      loadMore: "もっと読み込む:",
      sortBy: "並び替え",
      apply: "応募する",
      ascending: "上昇",
      descending: "下降"
    },
    paginator: {
      pageReportTemplate: "{first} - {last}/{totalRecords}",
      rowsPerPageLabel: "表示件数"
    },
    downloads: {
      fallbackText: "現在、利用可能なダウンロードはありません"
    },
    baseSlider: {
      navBackward: "後方に移動",
      navForward: "先に進む",
      navToPage: "ページに移動"
    },
    historicalData: {
      waitMessage: "ダウンロードの準備",
      failedMessage: "ダウンロードに失敗しました"
    },
    showMoreShowLess: {
      showMoreText: "もっと見せる",
      showLessText: "表示を減らす"
    },
    globalTranslations: {
      yes: "はい",
      no: "いいえ",
      submit: "提出する",
      copyButton: "コピー",
      copiedButton: "コピーしました！",
      clear: "Delete",
      disclaimerDisagreeButtonLabel: "同意しない",
      disclaimerAgreeButtonLabel: "同意する",
      disclaimerCancelButtonLabel: "キャンセル",
      disclaimerConfirmButtonLabel: "受け入れる",
      disclaimerTitle: "免責事項",
      lockedContentLabel: "登録ユーザーのみ利用可能",
      loginOrRegisterLabel: "ログインまたは今すぐ登録",
      isNewLabel: "新着",
      addToWatchlist: "気に入ったリストに追加する",
      addedToWatchlist: "ウォッチリストに追加",
      tooltipTextShare: "共有",
      tooltipTextPrint: "印刷する",
      backLinkText: "Back",
      backToTopButtonText: "トップに戻る",
      closeAllButtonText: "すべて閉じる",
      openAllButtonText: "すべて開く",
      shareClassSelectLabel: "Share Class",
      emailInputLabelText: "E-Mail address",
      emailInputHelperText: "正しいEメールアドレスを入力してください。",
      date: "データム",
      startDate: "開始日",
      endDate: "基準日",
      doNotShowAgain: "二度と表示しない",
      star: "星",
      stars: "出演者",
      outOfStars: "5つ星中",
      noContent: "内容なし",
      results: "結果",
      result: "結果",
      search: "検索",
      phone: "電話",
      email: "電子メール",
      open: "開いた",
      close: "閉じる",
      monthly: "毎月",
      quarterly: "四半期",
      yearly: "年次",
      million: "百万",
      billion: "十億",
      years: "年",
      year: "年"
    },
    mediaReleases: {
      searchBoxPlaceholder: "メディアリリースで検索",
      noResults: "結果が見つかりませんでした"
    },
    alertButton: {
      label: "購読"
    },
    periodCalendar: {
      fromLabel: "から:",
      toLabel: "に:"
    },
    accordionContainer: {
      closeAll: "すべて閉じる",
      openAll: "すべて開く"
    },
    premiumDiscountLineChart: {
      yAxisLabel: "プレミアムまたはディスカウント (bps)"
    },
    premiumDiscountHistoricChart: {
      yAxisLabel: "日数",
      discount: "割引",
      premium: "プレミアム",
      nav: "NAV"
    },
    stickyNavigation: {
      backToTopLinkText: "トップに戻る",
      dataEventComponentName: "サイドナビゲーション",
      dataEventTitle: "ジャンプマーク |トップに戻る",
      mobileNavigation: "モバイルナビゲーション"
    },
    contactCard: {
      mailto: "メールト"
    },
    footNote: {
      link: "脚注に戻る"
    },
    footNoteHeader: {
      link: "脚注にジャンプ"
    },
    breadcrumb: {
      shareButton: "シェアクラスを選ぶ",
      email: "メールを送る",
      scrollLeft: "左にスクロール",
      scrollRight: "右にスクロール"
    },
    dropDocuments: {
      button: "選択リストを開く",
      allDocuments: "すべての書類"
    },
    dwsCarousel: {
      backward: "前のページ",
      forward: "次のページ",
      page: "ページにジャンプ"
    },
    megaMenu: {
      close: "近い"
    },
    header: {
      search: "検索",
      user: "ユーザー",
      moreLinks: "もっと見せる",
      main: "メインナビゲーション",
      toggleMenu: "メニューを切り替える",
      audienceAndCultureText: "役割と場所を選択",
      cultureText: "あなたの場所"
    },
    allocationChartCard: {
      showLess: "表示を減らす",
      showMore: "もっと見せる"
    },
    performanceChart: {
      close: "近い",
      //remove after old component is eliminated
      calendarCloseTooltipText: "近い",
      calendarTooltipText: "日付を選択",
      downloadTooltipText: "ダウンロード",
      performanceToggleText: "パフォーマンス (%)",
      priceToggleText: "NAV履歴",
      date: "データム",
      startDate: "開始日",
      endDate: "基準日",
      nav: "Nav",
      navPercent: "Nav %",
      indexLevel: "Index level",
      indexLevelPercent: "Index level %",
      performanceYaxisLabel: "パフォーマンス (%)",
      navYaxisLabel: "基準価額(円)",
      chartAriaLabel: "対話型パフォーマンスチャ",
      chartSeriesLabel: "チャート シリーズ ラベル",
      chartNavigatorGroupLabel: "日付範囲を選択するためのナビゲータ ハンドル。",
      chartNavigatorHandlesLabelLeft: "左",
      chartNavigatorHandlesLabelRight: "右",
      chartNavigatorHandlesLabelEnd: "ズーム用のハンドル。"
    },
    fundsInFocus: {
      categoryLabel: "カテゴリー / 投資家プロフィール"
    },
    videoModule: {
      isRunningText: "現在実行中",
      minutesShort: "分",
      playButton: "播放視頻"
    },
    personDetailBlock: {
      biography: "バイオグラフィー",
      education: "教育",
      professionalCareer: "プロフェッショナルなキャリア",
      publications: "出版物"
    },
    publications: {
      loadMore: "もっと読み込む"
    },
    newsletterTeaser: {
      invalidErrorTextHeading: "エラーが発生しました",
      invalidErrorText: "リクエストの処理中にエラーが発生しました。もう一度やり直してください。"
    },
    baseActionMenu: {
      label: "アクションメニュー",
      itemSelected: "比較のために、この製品はリストの一番上に移動されました。",
      itemRemoved: "比較のため、この製品はリストの先頭から削除されました。",
      markForComparison: "比較のためにマークする",
      bookmark: "ブックマーク",
      bookmarked: "ブックマーク",
      removeCompare: "比較から削除",
      openActionMenu: "アクションメニューを開く"
    },
    fundFinder: {
      periodLabel: "期間",
      periodHeadline: "期間を選択",
      periodHint: "選択した期間は騰落率算出に使用されます。",
      otherFilters: "その他のフィルター",
      deselectAll: "すべて選択解除",
      fundSearchHeadline: "",
      resetFilters: "すべてのフィルターをリセット",
      fundSearchPlaceholder: "検索",
      products: "件の該当",
      product: "件の該当",
      showProducts: "",
      downloadDocuments: "ドキュメントをダウンロード",
      addedCompareMessage: "ファンド比較のため、選択したファンドはリスト上部に移動しました。",
      removedCompareMessage: "選択を解除したファンドはリスト上部から外れました。",
      addedBookmarkMessage: "製品がウォッチリストに追加されました",
      removedBookmarkMessage: "製品がウォッチリストから削除されました",
      changeColumnView: "カラム表示の変更"
    },
    productChartTeaser: {
      performance: "パフォーマンス"
    },
    archivePage: {
      searchBoxPlaceholder: "アーカイブで検索",
      loadMore: "もっと読み込む",
      filters: "フィルター",
      resetFilters: "すべてのフィルターをリセット",
      otherFilters: "その他のフィルター"
    },
    teaser: {
      new: "新しい"
    },
    baseResultView: {
      listViewTitle: "リスト表示",
      gridViewTitle: "グリッドビュー"
    },
    showMoreLessToggle: {
      showMoreText: "もっと見せる",
      showLessText: "表示を減らす"
    },
    searchResultPage: {
      searchResultPagePlaceholder: "検索",
      resultsFor: "の結果",
      filterBy: "フィルター条件",
      sortBy: " 並べ替え"
    },
    baseNonRemovableFilters: {
      edit: "編集"
    },
    baseRemovableFilters: {
      removeFilter: "フィルターを削除"
    },
    tabContainer: {
      requiresLogin: "ログインが必要です"
    },
    propertyTeaser: {
      gallery: "ギャラリー",
      images: "画像"
    },
    propertyGallery: {
      map: "地図",
      filters: "フィルター",
      marketValue: "市場価値",
      acquisitionYear: "取得年",
      location: "場所",
      resultText: "プロパティ",
      resultsText: "プロパティ",
      loadMore: "もっと読み込む"
    },
    sortOptions: {
      sortByLabel: "並び替え",
      nameAsc: "名前 A-Z",
      nameDesc: "名前 Z-A",
      priceAsc: "価格の安い順",
      priceDesc: "価格の高い順",
      acquisitionYearAsc: "取得年 古い順",
      acquisitionYearDesc: "取得年 新しい順"
    },
    propertyKeyValues: {
      type: "タイプ",
      purchasePrice: "購入価格",
      acquisitionYear: "取得年",
      location: "場所"
    },
    baseGoogleMap: {
      mapType: "地図の種類",
      streetView: "ストリートビュー",
      zoomIn: "ズームイン",
      zoomOut: "ズームアウト",
      locationMarker: "選ぶ"
    },
    documentList: {
      numberOfResultLabel: "ドキュメント"
    },
    literatureLibrary: {
      searchBoxPlaceholder: "製品を検索"
    },
    baseTreeSelect: {
      placeholder: "検索",
      emptyMessage: "目論見書・報告書が見つかりません",
      triggerAriaLabel: "選択リストを開く"
    },
    faqPage: {
      expandAll: "すべての回答を表示",
      closeAll: "すべての回答を閉じる",
      searchPlaceholder: "よくある質問で検索",
      result: "結果",
      results: "結果",
      noResults: "結果が見つかりませんでした",
      searchResults: "検索結果"
    },
    glossary: {
      expandAll: "すべての回答を表示",
      closeAll: "すべての回答を閉じる",
      searchPlaceholder: "用語集で検索",
      result: "結果",
      results: "結果",
      noResults: "次の用語に一致する結果が見つかりませんでした",
      showAllResults: "すべての結果を表示",
      chooseOption: "オプションを選択"
    },
    eventList: {
      date: "日付",
      event: "イベント",
      time: "時間",
      download: "ダウンロード"
    },
    quizAndPoll: {
      explanationHeadlineCorrect: "素晴らしい、あなたの回答は正解です。",
      explanationHeadlineInCorrect: "申し訳ありませんが、あなたの回答は完全に正しくありませんでした。",
      socialLabel: "共有:"
    },
    marketDataBlock: {
      intraday: "イントラデイ"
    },
    search: {
      showAllResults: "すべての結果を表示"
    },
    imageGalleryTeaser: {
      gallery: "ギャラリーで開く"
    },
    documentViewer: {
      documentView: "PDFドキュメントビュー",
      loading: "ドキュメントの読み込み中"
    },
    productBuyingProcess: {
      searchBoxPlaceholder: "お探しの製品を検索",
      continueToPartner: "パートナーと続行"
    },
    typography: {
      disclaimer: `DWS 免責事項: 債券投資は金利、信用、
      流動性と市場リスクはさまざまな程度に影響します。金利が上昇すると債券価格が上昇する 
      一般的には落ちます。信用リスクとは、発行者が適時に利益を得る能力を指します。 
      元金と利息の支払い。低品質（ジャンク債）への投資 
      格付けされていない証券は、投資に比べて損失のリスクが大きくなります。
       より質の高い証券。地方証券は次のようなリスクにさらされています。 
       訴訟、法律、その他の政治的出来事、地元のビジネスまたは経済
        条件や発行者の破産は、当社に重大な影響を与える可能性があります。 
        発行者の元本および/または利息の支払い能力。市場 
        地方債は課税債に比べて流動性が低い可能性があり、 
        地方自治体の発行体の財務状況に関して入手可能な情報が少ない
        公共企業体よりも有価証券。デリバティブへの投資には以下のことが伴います 
        流動性、レバレッジ、信用に関する特別なリスクにより、リスクが減少する可能性があります。 
        リターンやボラティリティの増加。ファンドは収入を求めていますが、
         カリフォルニア州および連邦所得税の一部が免除されます。 
         ファンドの分配金には連邦税、州税、地方税が課税される場合があります。
          代替最低税を含む。を読んでください。
           詳細については目論見書をご覧ください。 2022年09月08日時点`,
      pageHeadline: "ページの見出し h1 DWS 2022年09月08日時点",
      h2Headline: "見出し h2 2022年09月08日時点",
      sectionH2Headline: "セクション見出し h2 2022年09月08日時点",
      h3Headline: "見出し h3 2022年09月08日時点",
      h4Headline: "見出し h4 2022年09月08日時点",
      copyHeadline: "見出しをコピー 2022年09月08日時点",
      copyText: "テキストを通常にコピー 2022年09月08日時点",
      copyTextBold: "テキストを太字でコピー  2022年09月08日時点",
      labelGerman: "ドイツ語",
      labelEnglish: "英語",
      labelChinese: "中国語",
      labelJapanese: "日本語"
    },
    coloredNumber: {
      default: "デフォルト",
      positive: "ポジティブ",
      negative: "ネガティブ"
    },
    footer: {
      contact: "コンタクト",
      showContactInformation: "連絡先情報を表示",
      changeAudienceAndCulture: "役割と言語を変更",
      changeCulture: "言語を変更",
      legalAndPolicyLinks: "法律と政策のリンク"
    },
    calendarPage: {
      icalDownload: "{eventTitle} イベントの iCal ファイルをダウンロード"
    },
    riskDisclaimer: {
      showDisclaimer: "免責事項を表示",
      hideDisclaimer: "免責事項を非表示"
    },
    crociCompanyOverviewPage: {
      searchBoxPlaceholder: "会社名またはティッカーを検索する"
    },
    crociCompanyDetailPage: {
      showAll: "すべて表示",
      showLess: "表示を減らす",
      ticker: {
        ticker: "ティッカー:",
        category: "カテゴリ:",
        sharePrice: "株価:"
      },
      zoomChart: "チャートの詳細ビューを開く"
    },
    calculatorOutputCard: {
      inflationInfoText: "<b>{years} 年後、{value}</b> の資本は、次のように購買力を失います:",
      investmentInfoText: "あなたの積立金",
      valueDevelopment: "価値の発展",
      regularInvestment: "合計定期投資",
      initialInvestment: "初期投資",
      purchasingPower: "単一金額",
      investmentChartTitle: "投資チャートデータ",
      inflationChartTitle: "インフレチャートデータ"
    },
    calculationArea: {
      calculationButtonLabel: "計算",
      optionButtonLabel: "オプション",
      optionButtonLabelLess: "オプション",
      restartButtonLabel: "再起動",
      currentInflationRateLabel: "現在のインフレ率を使用"
    }
  },
  nl: {
    Accept: "Aanvaarden",
    Cancel: "Annuleren",
    baseSearchBox: {
      resultEventComponentName: "Tekstlinks (dezelfde pagina)"
    },
    audioModule: {
      play: "Afspelen"
    },
    allocationChart: {
      card: {
        othersText: "Anderen"
      }
    },
    teaserWww: {
      countrySelectorTitle: "Selecteer een locatie",
      countryDropdownPlaceholder: "Selecteer een locatie",
      countryDropdownFilterPlaceholder: "Typ hier tekst..."
    },
    shareButton: {
      label: "Delen"
    },
    productHeader: {
      allDocuments: "Alle documenten"
    },
    entryGate: {
      productSearchLabel: "Voer uw product in",
      countryLabel: "Selecteer uw locatie",
      audienceLabel: "Selecteer je rol",
      inputPlaceholder: "ISIN",
      inputInvalidText: "Ongeldige ISIN",
      productLabel: "Jouw product",
      relationshipLabel: "Selecteer uw zakelijke relatie",
      existingInvestorLabel: "Ik ben een bestaande belegger",
      nonExistingInvestorLabel: "Ik ben geen bestaande belegger",
      countryDropdownFilterPlaceholder: "Typ hier tekst...",
      countryDropdownPlaceholder: "Selecteer een land"
    },
    dataTable: {
      pageReportTemplate: "Toont {first} tot {last} van {totalRecords} vermeldingen",
      sortedAscending: "Oplopend sorteren",
      sortedDescending: "Aflopend sorteren"
    },
    dataCards: {
      showMoreValues: "Meer waarden",
      showLessValues: "Minder waarden",
      loadMore: "Meer laden:",
      sortBy: "Sorteer op",
      apply: "Toepassen",
      ascending: "Oplopend",
      descending: "Aflopend"
    },
    paginator: {
      pageReportTemplate: "{first} - {last} van {totalRecords}",
      rowsPerPageLabel: "Inzendingen"
    },
    downloads: {
      fallbackText: "Momenteel zijn er geen downloads beschikbaar"
    },
    baseSlider: {
      navBackward: "achteruit navigeren",
      navForward: "vooruit navigeren",
      navToPage: "navigeer naar pagina"
    },
    historicalData: {
      waitMessage: "Downloaden voorbereiden",
      failedMessage: "Download mislukt"
    },
    showMoreShowLess: {
      showMoreText: "Laat meer zien",
      showLessText: "Laat minder zien"
    },
    globalTranslations: {
      yes: "Ja",
      no: "Nee",
      submit: "Indienen",
      copyButton: "Kopiëren",
      copiedButton: "Gekopieerd!",
      clear: "Delete",
      disclaimerDisagreeButtonLabel: "Oneens",
      disclaimerAgreeButtonLabel: "Mee eens",
      disclaimerCancelButtonLabel: "Annuleren",
      disclaimerConfirmButtonLabel: "Aanvaarden",
      disclaimerTitle: "Vrijwaring",
      lockedContentLabel: "Alleen beschikbaar voor geregistreerde gebruikers",
      loginOrRegisterLabel: "Log in of registreer nu",
      isNewLabel: "Nieuw",
      addToWatchlist: "Toevoegen aan kijklijst",
      addedToWatchlist: "Toegevoegd aan volglijst",
      tooltipTextShare: "Deel",
      tooltipTextPrint: "Afdrukken",
      backLinkText: "Back",
      backToTopButtonText: "Terug naar boven",
      closeAllButtonText: "Sluit alles",
      openAllButtonText: "Open all",
      shareClassSelectLabel: "Maak alles open",
      emailInputLabelText: "E-mailadres",
      emailInputHelperText: "Voer het juiste e-mailadres in",
      date: "Datum",
      startDate: "Startdatum",
      endDate: "Einddatum",
      doNotShowAgain: "Niet meer weergeven",
      star: "Ster",
      stars: "Sterren",
      outOfStars: "van 5 sterren",
      noContent: "Geen inhoud",
      results: "Resultaten",
      result: "Resultaat",
      search: "Zoeken",
      phone: "Telefoon",
      email: "E-mail",
      open: "Open",
      close: "Dichtbij",
      monthly: "Maandelijks",
      quarterly: "Driemaandelijks",
      yearly: "Jaarlijks",
      million: "mio",
      billion: "mrd",
      years: "jaar",
      year: "jaar"
    },
    mediaReleases: {
      searchBoxPlaceholder: "Zoeken in mediaberichten",
      noResults: "Geen resultaten gevonden"
    },
    alertButton: {
      label: "Abonneren"
    },
    periodCalendar: {
      fromLabel: "Van:",
      toLabel: "Naar:"
    },
    accordionContainer: {
      closeAll: "Sluit alles",
      openAll: "Maak alles open"
    },
    premiumDiscountLineChart: {
      yAxisLabel: "Premie of kortingen (bps)"
    },
    premiumDiscountHistoricChart: {
      yAxisLabel: "Aantal dagen",
      discount: "Korting",
      premium: "Premie",
      nav: "NAV"
    },
    stickyNavigation: {
      backToTopLinkText: "Terug naar boven",
      dataEventComponentName: "Zijnavigatie",
      dataEventTitle: "Sprong | Terug naar boven",
      mobileNavigation: "Mobiele navigatie"
    },
    contactCard: {
      mailto: "mail naar"
    },
    footNote: {
      link: "spring terug naar de voetnoot"
    },
    footNoteHeader: {
      link: "spring naar voetnoot"
    },
    breadcrumb: {
      shareButton: "kies een aandelenklasse",
      email: "Verzend mail",
      scrollLeft: "Scroll naar links",
      scrollRight: "Scroll naar rechts"
    },
    dropDocuments: {
      button: "keuzelijst openen",
      allDocuments: "Alle documenten"
    },
    dwsCarousel: {
      backward: "vorige bladzijde",
      forward: "volgende bladzijde",
      page: "spring naar pagina"
    },
    megaMenu: {
      close: "dichtbij"
    },
    header: {
      search: "Zoekopdracht",
      user: "Gebruiker",
      moreLinks: "Laat meer zien",
      main: "Hoofdnavigatie",
      toggleMenu: "Menu aan/uit",
      audienceAndCultureText: "Rol en locatie selecteren",
      cultureText: "Jouw locatie"
    },
    allocationChartCard: {
      showLess: "laat minder zien",
      showMore: "laat meer zien"
    },
    performanceChart: {
      close: "dichtbij",
      //remove after old component is eliminated
      calendarCloseTooltipText: "Dichtbij",
      calendarTooltipText: "Periode instellen",
      downloadTooltipText: "Downloaden",
      performanceToggleText: "Prestaties in %",
      priceToggleText: "NAV-geschiedenis",
      date: "Datum",
      startDate: "Startdatum",
      endDate: "Einddatum",
      nav: "Nav",
      navPercent: "Nav %",
      indexLevel: "Index level",
      indexLevelPercent: "Index level %",
      performanceYaxisLabel: "Prestaties in %",
      navYaxisLabel: "Nav",
      chartAriaLabel: "Interactieve prestatiegrafiek",
      chartSeriesLabel: "Labels voor diagramreeksen",
      chartNavigatorGroupLabel: "Navigatorhandvatten voor het selecteren van een datumbereik.",
      chartNavigatorHandlesLabelLeft: "Linker",
      chartNavigatorHandlesLabelRight: "Rechter",
      chartNavigatorHandlesLabelEnd: "handvat voor zoomen."
    },
    fundsInFocus: {
      categoryLabel: "Categorie / Beleggersprofiel"
    },
    videoModule: {
      isRunningText: "nu aan het rennen",
      minutesShort: "min.",
      playButton: "Video afspelen"
    },
    personDetailBlock: {
      biography: "Biografie",
      education: "Opleiding",
      professionalCareer: "Professionele carrière",
      publications: "Publicaties"
    },
    publications: {
      loadMore: "Meer laden"
    },
    newsletterTeaser: {
      invalidErrorTextHeading: "Er is een fout opgetreden",
      invalidErrorText: "Er is een fout opgetreden tijdens de verwerking van uw verzoek. Probeer het opnieuw."
    },
    baseActionMenu: {
      label: "actiemenu",
      itemSelected: "Ter vergelijking is het product naar de top van de lijst verplaatst.",
      itemRemoved: "Ter vergelijking: het product is verwijderd naar de top van de lijst.",
      markForComparison: "Markeren voor vergelijking",
      bookmark: "Bladwijzer",
      bookmarked: "gebookmarked",
      removeCompare: "Verwijderen uit vergelijking",
      openActionMenu: "open het actiemenu"
    },
    fundFinder: {
      periodLabel: "Periode",
      periodHeadline: "Verander periode",
      periodHint: "Wijzigingen hier worden ook toegepast op andere tijdsafhankelijke instellingen.",
      otherFilters: "Andere filters",
      deselectAll: "Alles deselecteren",
      fundSearchHeadline: "",
      resetFilters: "Alle filters resetten",
      fundSearchPlaceholder: "Zoeken",
      products: "producten",
      product: "product",
      showProducts: "Toon",
      downloadDocuments: "Documenten downloaden",
      addedCompareMessage: "Ter vergelijking, het product werd verplaatst naar de top van de lijst",
      removedCompareMessage: "Het product is verwijderd van de eerste plaats op de lijst",
      addedBookmarkMessage: "Het product is toegevoegd aan uw watchlist",
      removedBookmarkMessage: "Het product is verwijderd van uw watchlist",
      changeColumnView: "Kolomweergave wijzigen"
    },
    productChartTeaser: {
      performance: "Rendement"
    },
    archivePage: {
      searchBoxPlaceholder: "Zoeken in de archieven",
      loadMore: "Meer laden",
      filters: "Filters",
      resetFilters: "Alle filters resetten",
      otherFilters: "Andere filters"
    },
    teaser: {
      new: "Nieuw"
    },
    baseResultView: {
      listViewTitle: "Lijstweergave",
      gridViewTitle: "Roosterweergave"
    },
    showMoreLessToggle: {
      showMoreText: "Laat meer zien",
      showLessText: "Laat minder zien"
    },
    searchResultPage: {
      searchResultPagePlaceholder: "Zoekopdracht",
      resultsFor: "Resultaten voor",
      filterBy: "Filteren op",
      sortBy: "Sorteer op"
    },
    baseNonRemovableFilters: {
      edit: "Bewerken"
    },
    baseRemovableFilters: {
      removeFilter: "filter verwijderen"
    },
    tabContainer: {
      requiresLogin: "Vereist inloggen"
    },
    propertyTeaser: {
      gallery: "Galerij",
      images: "Afbeeldingen"
    },
    propertyGallery: {
      map: "Kaart",
      filters: "Filters",
      marketValue: "Marktwaarde",
      acquisitionYear: "Jaar van aankoop",
      location: "Locatie",
      resultText: "Eigendom",
      resultsText: "Eigenschappen",
      loadMore: "Meer laden"
    },
    sortOptions: {
      sortByLabel: "Sorteren op",
      nameAsc: "Naam A-Z",
      nameDesc: "Naam Z-A",
      priceAsc: "Prijs laag-hoog",
      priceDesc: "Prijs hoog-laag",
      acquisitionYearAsc: "Aanschafjaar oud-nieuw",
      acquisitionYearDesc: "Aanschafjaar nieuw-oud"
    },
    propertyKeyValues: {
      type: "Type",
      purchasePrice: "Aankoopprijs",
      acquisitionYear: "Acquisitiejaar",
      location: "Locatie"
    },
    baseGoogleMap: {
      mapType: "Type kaart",
      streetView: "Straatweergave",
      zoomIn: "Inzoomen",
      zoomOut: "Uitzoomen",
      locationMarker: "Kiezen"
    },
    documentList: {
      numberOfResultLabel: "documenten"
    },
    literatureLibrary: {
      searchBoxPlaceholder: "Product zoeken"
    },
    baseTreeSelect: {
      placeholder: "Zoeken",
      emptyMessage: "Geen prospectussen of rapporten gevonden",
      triggerAriaLabel: "Open selectielijst"
    },
    faqPage: {
      expandAll: "Alle antwoorden weergeven",
      closeAll: "Alle antwoorden sluiten",
      searchPlaceholder: "Zoeken in het FAQ",
      result: "Resultaat",
      results: "Resultaten",
      noResults: "Geen resultaten gevonden",
      searchResults: "Zoekresultaten"
    },
    glossary: {
      expandAll: "Alle antwoorden weergeven",
      closeAll: "Alle antwoorden sluiten",
      searchPlaceholder: "Zoeken in het glossarium",
      result: "Resultaat",
      results: "Resultaten",
      noResults: "Geen resultaten gevonden voor",
      showAllResults: "Alle resultaten weergeven",
      chooseOption: "Optie kiezen"
    },
    eventList: {
      date: "Datum",
      event: "Evenement",
      time: "Tijd",
      download: "Downloaden"
    },
    quizAndPoll: {
      explanationHeadlineCorrect: "Geweldig, je antwoord is correct.",
      explanationHeadlineInCorrect: "Sorry, je antwoord was niet helemaal correct.",
      socialLabel: "Delen:"
    },
    marketDataBlock: {
      intraday: "Intraday"
    },
    search: {
      showAllResults: "Alle resultaten weergeven"
    },
    imageGalleryTeaser: {
      gallery: "Openen in galerij"
    },
    documentViewer: {
      documentView: "PDF-documentweergave",
      loading: "Document laden"
    },
    productBuyingProcess: {
      searchBoxPlaceholder: "Zoek uw product",
      continueToPartner: "Doorgaan naar partner"
    },
    coloredNumber: {
      default: "Standaard",
      positive: "Positief",
      negative: "Negatief"
    },
    footer: {
      contact: "Contact",
      showContactInformation: "Contact informatie weergeven",
      changeAudienceAndCulture: "Rol en taal wijzigen",
      changeCulture: "Taal wijzigen",
      legalAndPolicyLinks: "Juridische en beleidslinks"
    },
    calendarPage: {
      icalDownload: "Download het iCal-bestand van {eventTitle} evenement"
    },
    riskDisclaimer: {
      showDisclaimer: "Disclaimer weergeven",
      hideDisclaimer: "Disclaimer verbergen"
    },
    crociCompanyOverviewPage: {
      searchBoxPlaceholder: "Zoek op bedrijfsnaam of ticker"
    },
    crociCompanyDetailPage: {
      showAll: "Alles weergeven",
      showLess: "Minder weergeven",
      ticker: {
        ticker: "Ticker:",
        category: "Categorie:",
        sharePrice: "Aandelenkoers:"
      },
      zoomChart: "Open gedetailleerde weergave van de grafiek"
    },
    calculatorOutputCard: {
      inflationInfoText: "<b>{years} jaar</b> later, <b>{value}</b> van kapitaal verliest koopkracht als volgt:",
      investmentInfoText: "Uw investering",
      valueDevelopment: "Waardeontwikkeling",
      regularInvestment: "Totale regelmatige investering",
      initialInvestment: "Initiële investering",
      purchasingPower: "Enkel bedrag",
      investmentChartTitle: "Investeringsgrafiekgegevens",
      inflationChartTitle: "Inflatiegrafiekgegevens"
    },
    calculationArea: {
      calculationButtonLabel: "Berekenen",
      optionButtonLabel: "Meer opties",
      optionButtonLabelLess: "Minder optie",
      restartButtonLabel: "Herstarten",
      currentInflationRateLabel: "Gebruik huidige inflatie"
    }
  },
  sv: {
    Accept: "Acceptera",
    Cancel: "Annullera",
    baseSearchBox: {
      resultEventComponentName: "Textlänkar (samma sida)"
    },
    audioModule: {
      play: "Spela"
    },
    allocationChart: {
      card: {
        othersText: "Andra"
      }
    },
    teaserWww: {
      countrySelectorTitle: "Välj en plats",
      countryDropdownPlaceholder: "Välj en plats",
      countryDropdownFilterPlaceholder: "Skriv text här..."
    },
    shareButton: {
      label: "Dela"
    },
    productHeader: {
      allDocuments: "Alla dokument"
    },
    entryGate: {
      productSearchLabel: "Ange din produkt",
      countryLabel: "Välj din plats",
      audienceLabel: "Välj din roll",
      inputPlaceholder: "ISIN",
      inputInvalidText: "Ogiltig ISIN",
      productLabel: "Din produkt",
      relationshipLabel: "Välj din affärsrelation",
      existingInvestorLabel: "Jag är en befintlig investerare",
      nonExistingInvestorLabel: "Jag är inte en befintlig investerare",
      countryDropdownFilterPlaceholder: "Skriv text här...",
      countryDropdownPlaceholder: "Välj ett land"
    },
    dataTable: {
      pageReportTemplate: "Visar {first} to {last} av {totalRecords} poster",
      sortedAscending: "Sorterad stigande",
      sortedDescending: "Sorterad fallande"
    },
    dataCards: {
      showMoreValues: "Visa fler värden",
      showLessValues: "Visa färre värden",
      loadMore: "Ladda mer:",
      sortBy: "Sortera efter",
      apply: "Tillämpa",
      ascending: "Stigande",
      descending: "Nedåtgående"
    },
    paginator: {
      pageReportTemplate: "{first} - {last} av {totalRecords}",
      rowsPerPageLabel: "Inlägg"
    },
    downloads: {
      fallbackText: "För närvarande finns det inga nedladdningar tillgängliga"
    },
    baseSlider: {
      navBackward: "navigera bakåt",
      navForward: "navigera framåt",
      navToPage: "navigera till sidan"
    },
    historicalData: {
      waitMessage: "Förbereder nedladdning",
      failedMessage: "Nedladdning misslyckad"
    },
    showMoreShowLess: {
      showMoreText: "Visa mer",
      showLessText: "Visa mindre"
    },
    globalTranslations: {
      yes: "Ja",
      no: "Nej",
      submit: "Skicka in",
      copyButton: "Kopiera",
      copiedButton: "Kopierade!",
      clear: "Delete",
      disclaimerDisagreeButtonLabel: "Håller inte med",
      disclaimerAgreeButtonLabel: "Instämmer",
      disclaimerCancelButtonLabel: "Annullera",
      disclaimerConfirmButtonLabel: "Acceptera",
      disclaimerTitle: "varning",
      lockedContentLabel: "Endast tillgängligt för registrerade användare",
      loginOrRegisterLabel: "Logga in eller registrera dig nu",
      isNewLabel: "Ny",
      addToWatchlist: "Lägg till i tittalistan",
      addedToWatchlist: "Lades till på bevakningslistan",
      tooltipTextShare: "Dela med sig",
      tooltipTextPrint: "Skriva ut",
      backLinkText: "Back",
      backToTopButtonText: "Tillbaka till toppen",
      closeAllButtonText: "Stäng alla",
      openAllButtonText: "Öppna alla",
      shareClassSelectLabel: "Aktieklass",
      emailInputLabelText: "E-postadress",
      emailInputHelperText: "Ange rätt e-postadress",
      date: "Utgångspunkt",
      startDate: "Startdatum",
      endDate: "Slutdatum",
      doNotShowAgain: "Visa inte igen",
      star: "Stjärna",
      stars: "Stjärnor",
      outOfStars: "av 5 stjärnor",
      noContent: "Inget innehåll",
      results: "Resultat",
      result: "Resultat",
      search: "Sök",
      phone: "Telefon",
      email: "E-post",
      open: "Öppna",
      close: "Stänga",
      monthly: "Månadsvis",
      quarterly: "Kvartalsvis",
      yearly: "Årligen",
      million: "Mio",
      billion: "Mrd",
      years: "år",
      year: "år"
    },
    mediaReleases: {
      searchBoxPlaceholder: "Sök i pressmeddelanden",
      noResults: "Geen resultaten gevonden"
    },
    alertButton: {
      label: "Prenumerera"
    },
    periodCalendar: {
      fromLabel: "Från:",
      toLabel: "Till:"
    },
    accordionContainer: {
      closeAll: "Stäng alla",
      openAll: "Öppna alla"
    },
    premiumDiscountLineChart: {
      yAxisLabel: "Premium eller rabatter (bps)"
    },
    premiumDiscountHistoricChart: {
      yAxisLabel: "Antal dagar",
      discount: "Rabatt",
      premium: "Premium",
      nav: "NAV"
    },
    stickyNavigation: {
      backToTopLinkText: "Tillbaka till toppen",
      dataEventComponentName: "Sidnavigering",
      dataEventTitle: "Jumpmark | Tillbaka till toppen",
      mobileNavigation: "Mobil navigering"
    },
    contactCard: {
      mailto: "mailto"
    },
    footNote: {
      link: "hoppa tillbaka till fotnot"
    },
    footNoteHeader: {
      link: "hoppa till fotnot"
    },
    breadcrumb: {
      shareButton: "välj andelsklass",
      email: "skicka brev",
      scrollLeft: "Rulla till vänster",
      scrollRight: "Rulla till höger"
    },
    dropDocuments: {
      button: "öppna urvalslistan",
      allDocuments: "Alla dokument"
    },
    dwsCarousel: {
      backward: "föregående sida",
      forward: "nästa sida",
      page: "hoppa till sidan"
    },
    megaMenu: {
      close: "stänga"
    },
    header: {
      search: "Sök",
      user: "Användare",
      moreLinks: "Visa mer",
      main: "Huvudnavigering",
      toggleMenu: "Aktivera/inaktivera menyn",
      audienceAndCultureText: "Välj roll och plats",
      cultureText: "Din plats"
    },
    allocationChartCard: {
      showLess: "show less",
      showMore: "show more"
    },
    performanceChart: {
      close: "stänga",
      //remove after old component is eliminated
      calendarCloseTooltipText: "Stänga",
      calendarTooltipText: "Ställ in period",
      downloadTooltipText: "Nedladdningar",
      performanceToggleText: "Prestanda i %",
      priceToggleText: "NAV historik",
      date: "Datum",
      startDate: "Startdatum",
      endDate: "Slutdatum",
      nav: "Nav",
      navPercent: "Nav %",
      indexLevel: "Index level",
      indexLevelPercent: "Index level %",
      performanceYaxisLabel: "Prestanda i %",
      navYaxisLabel: "Nav",
      chartAriaLabel: "Interaktiv prestandagraf",
      chartSeriesLabel: "Etiketter i diagramserier",
      chartNavigatorGroupLabel: "Navigatorhandtag för att välja datumintervall.",
      chartNavigatorHandlesLabelLeft: "Länkare",
      chartNavigatorHandlesLabelRight: "Höger",
      chartNavigatorHandlesLabelEnd: "handtag för zoomning."
    },
    fundsInFocus: {
      categoryLabel: "Kategori / Investerarprofil"
    },
    videoModule: {
      isRunningText: "kör nu",
      minutesShort: "min.",
      playButton: "Spela filmen"
    },
    personDetailBlock: {
      biography: "Biografi",
      education: "Utbildning",
      professionalCareer: "Yrkesmässig karriär",
      publications: "Publications"
    },
    publications: {
      loadMore: "Ladda mer"
    },
    newsletterTeaser: {
      invalidErrorTextHeading: "Ett fel har inträffat",
      invalidErrorText: "Ett fel inträffade under behandlingen av din begäran. Försök igen."
    },
    baseActionMenu: {
      label: "Åtgärdsmeny",
      itemSelected: "Som jämförelse flyttades produkten till toppen av listan.",
      itemRemoved: "Som jämförelse togs produkten bort till toppen av listan.",
      markForComparison: "Markera för jämförelse",
      bookmark: "Bokmärke",
      bookmarked: "bokmärkt",
      removeCompare: "Ta bort från jämförelse",
      openActionMenu: "öppna åtgärdslistan"
    },
    fundFinder: {
      periodLabel: "Period",
      periodHeadline: "Förändring period",
      periodHint: "Ändringar här tillämpas också på andra tidsberoende inställningar.",
      otherFilters: "Andra filter",
      deselectAll: "Avmarkera alla",
      fundSearchHeadline: "",
      resetFilters: "Återställ alla filter",
      fundSearchPlaceholder: "Sök",
      products: "produkter",
      product: "produkt",
      showProducts: "Visa",
      downloadDocuments: "Ladda ner dokument",
      addedCompareMessage: "För jämförelse flyttades produkten till toppen av listan",
      removedCompareMessage: "Produkten togs bort från toppen av listan",
      addedBookmarkMessage: "Produkten har lagts till i din bevakningslista",
      removedBookmarkMessage: "Produkten har tagits bort från din bevakningslista",
      changeColumnView: "Ändra kolumnvy"
    },
    productChartTeaser: {
      performance: "Resultat"
    },
    archivePage: {
      searchBoxPlaceholder: "Sök i arkiven",
      loadMore: "Ladda mer",
      filters: "Filter",
      resetFilters: "Återställ alla filter",
      otherFilters: "Andra filter"
    },
    teaser: {
      new: "Ny"
    },
    baseResultView: {
      listViewTitle: "Lista",
      gridViewTitle: "Gridvy"
    },
    showMoreLessToggle: {
      showMoreText: "Visa mer",
      showLessText: "Visa mindre"
    },
    searchResultPage: {
      searchResultPagePlaceholder: "Sök",
      resultsFor: "Resultat för",
      filterBy: "Filtrera efter",
      sortBy: "Sortera efter"
    },
    baseNonRemovableFilters: {
      edit: "Redigera"
    },
    baseRemovableFilters: {
      removeFilter: "ta bort filter"
    },
    tabContainer: {
      requiresLogin: "Kräver inloggning"
    },
    propertyTeaser: {
      gallery: "Galleri",
      images: "Bilder"
    },
    propertyGallery: {
      map: "Karta",
      filters: "Filter",
      marketValue: "Marknadsvärde",
      acquisitionYear: "Förvärvsår",
      location: "Plats",
      resultText: "Egendom",
      resultsText: "Egenskaper",
      loadMore: "Ladda mer"
    },
    sortOptions: {
      sortByLabel: "Sortera efter",
      nameAsc: "Namn A-Ö",
      nameDesc: "Namn Ö-A",
      priceAsc: "Pris lågt-högt",
      priceDesc: "Pris högt-lågt",
      acquisitionYearAsc: "Förvärvsår gammal-ny",
      acquisitionYearDesc: "Förvärvsår ny-gammal"
    },
    propertyKeyValues: {
      type: "Typ",
      purchasePrice: "Inköpspris",
      acquisitionYear: "Förvärvsår",
      location: "Plats"
    },
    baseGoogleMap: {
      mapType: "Typ av karta",
      streetView: "Gatuvy",
      zoomIn: "Zooma in",
      zoomOut: "Zooma ut",
      locationMarker: "Välja"
    },
    documentList: {
      numberOfResultLabel: "dokument"
    },
    literatureLibrary: {
      searchBoxPlaceholder: "Sök efter produkt"
    },
    baseTreeSelect: {
      placeholder: "Sök",
      emptyMessage: "Inga prospekt eller rapporter hittades",
      triggerAriaLabel: "Öppna urvalslistan"
    },
    faqPage: {
      expandAll: "Toon alle antwoorden",
      closeAll: "Sluit alle antwoorden",
      searchPlaceholder: "Zoek in FAQ",
      result: "Resultaat",
      results: "Resultaten",
      noResults: "Geen resultaten gevonden",
      searchResults: "Zoekresultaten"
    },
    glossary: {
      expandAll: "Toon alle antwoorden",
      closeAll: "Sluit alle antwoorden",
      searchPlaceholder: "Zoek in het woordenboek",
      result: "Resultaat",
      results: "Resultaten",
      noResults: "Geen resultaten gevonden voor",
      showAllResults: "Toon alle resultaten",
      chooseOption: "Kies een optie"
    },
    eventList: {
      date: "Datum",
      event: "Evenemang",
      time: "Tid",
      download: "Nedladdningar"
    },
    quizAndPoll: {
      explanationHeadlineCorrect: "Fantastiskt, ditt svar är korrekt.",
      explanationHeadlineInCorrect: "Tyvärr, ditt svar var inte helt korrekt.",
      socialLabel: "Dela:"
    },
    marketDataBlock: {
      intraday: "Intradag"
    },
    search: {
      showAllResults: "Visa alla resultat"
    },
    imageGalleryTeaser: {
      gallery: "Öppna i galleriet"
    },
    documentViewer: {
      documentView: "PDF-dokumentvy",
      loading: "Laddar dokument"
    },
    productBuyingProcess: {
      searchBoxPlaceholder: "Sök efter din produkt",
      continueToPartner: "Fortsätt till partner"
    },
    coloredNumber: {
      default: "Standard",
      positive: "Positiv",
      negative: "Negativ"
    },
    footer: {
      contact: "Kontakt",
      showContactInformation: "Visa kontaktinformation",
      changeAudienceAndCulture: "Ändra roll och språk",
      changeCulture: "Ändra språk",
      legalAndPolicyLinks: "Juridiska och policylänkar"
    },
    calendarPage: {
      icalDownload: "Ladda ner iCal-filen för {eventTitle} händelse"
    },
    riskDisclaimer: {
      showDisclaimer: "Visa ansvarsfriskrivning",
      hideDisclaimer: "Dölj ansvarsfriskrivning"
    },
    crociCompanyOverviewPage: {
      searchBoxPlaceholder: "Sök efter företagsnamn eller ticker"
    },
    crociCompanyDetailPage: {
      showAll: "Visa alla",
      showLess: "Visa mindre",
      ticker: {
        ticker: "Ticker:",
        category: "Kategori:",
        sharePrice: "Aktiekurs:"
      },
      zoomChart: "Öppna detaljerad vy av diagrammet"
    },
    calculatorOutputCard: {
      inflationInfoText: "<b>{years} år</b> senare, <b>{value}</b> av kapitalet förlorar köpkraft enligt följande:",
      investmentInfoText: "Din investering",
      valueDevelopment: "Värdeutveck",
      regularInvestment: "Total regelbunden investering",
      initialInvestment: "Initial investering",
      purchasingPower: "Enskild summa",
      investmentChartTitle: "Investeringsdiagramdata",
      inflationChartTitle: "Inflationsdiagramdata"
    },
    calculationArea: {
      calculationButtonLabel: "Beräkna",
      optionButtonLabel: "Fler alternativ",
      optionButtonLabelLess: "Färre alternativ",
      restartButtonLabel: "Starta om",
      currentInflationRateLabel: "Använd aktuell inflationsnivå"
    }
  },
  ko: {
    Accept: "수용하다",
    Cancel: "취소",
    typography: {
      disclaimer: "DWS 면책 조항: 채권 투자는 금리, 신용, 유동성 및 시장 위험에 다양한 정도로 영향을 받습니다. 일반적으로 금리가 상승하면 채권 가격은 하락합니다. 신용 위험은 발행자가 원금과 이자를 제때 상환할 수 있는 능력을 의미합니다. 저품질(정크 채권) 또는 등급이 없는 증권에 대한 투자는 고품질 증권에 비해 더 높은 손실 위험을 수반합니다. 지방 정부가 발행한 증권은 소송, 법률 및 기타 정치적 사건, 지역 비즈니스 또는 경제 조건과 같은 위험에 노출되며, 발행자의 파산은 원금 및/또는 이자 상환 능력에 중대한 영향을 미칠 수 있습니다. 지방 채권 시장의 유동성은 과세 채권보다 낮을 수 있으며, 지방 정부 발행자의 재정 상태에 대한 정보는 공공 회사보다 적을 수 있습니다. 파생상품 투자는 유동성, 레버리지 및 신용과 관련된 특수 위험이 있으며, 이는 변동성을 증가시키거나 수익을 감소시킬 수 있습니다. 펀드는 일부 캘리포니아 및 연방 소득세가 면제되는 수익을 추구합니다. 그러나 펀드 배분은 대체 최저세를 포함한 연방, 주 또는 지방 세금의 영향을 받을 수 있습니다. 자세한 내용은 설명서를 참조하십시오. 날짜: 2022년 9월 8일.",
      pageHeadline: "페이지 제목 h1: DWS 2022년 9월 8일 자료",
      h2Headline: "페이지 제목 h2: DWS 2022년 9월 8일 자료",
      sectionH2Headline: "섹션 제목 h2: 2022년 9월 8일 자료",
      h3Headline: "페이지 제목 h3: DWS 2022년 9월 8일 자료",
      h4Headline: "페이지 제목 h4: DWS 2022년 9월 8일 자료",
      copyHeadline: "제목: 2022년 9월 8일 자료",
      copyText: "텍스트: 2022년 9월 8일 자료",
      copyTextBold: "텍스트: 2022년 9월 8일 자료",
      labelGerman: "독일어",
      labelEnglish: "영어",
      labelChinese: "중국어",
      labelJapanese: "일본어"
    },
    baseSearchBox: {
      resultEventComponentName: "텍스트 링크(같은 페이지)"
    },
    audioModule: {
      play: "재생"
    },
    allocationChart: {
      card: {
        othersText: "기타"
      }
    },
    teaserWww: {
      countrySelectorTitle: "위치 선택",
      countryDropdownPlaceholder: "위치 선택",
      countryDropdownFilterPlaceholder: "여기에 텍스트를 입력하세요..."
    },
    shareButton: {
      label: "공유"
    },
    productHeader: {
      allDocuments: "모든 문서"
    },
    entryGate: {
      productSearchLabel: "제품을 입력하세요",
      countryLabel: "위치 선택",
      audienceLabel: "역할 선택",
      inputPlaceholder: "ISIN",
      inputInvalidText: "잘못된 ISIN",
      productLabel: "귀하의 제품",
      relationshipLabel: "비즈니스 관계를 선택하세요.",
      existingInvestorLabel: "나는 기존 투자자입니다",
      nonExistingInvestorLabel: "나는 기존 투자자가 아니다",
      countryDropdownFilterPlaceholder: "여기에 텍스트를 입력하세요...",
      countryDropdownPlaceholder: "국가를 고르시 오"
    },
    dataTable: {
      pageReportTemplate: "{totalRecords} 항목 중 {first}에서 {last}까지 표시 중",
      sortedAscending: "오름차순 정렬",
      sortedDescending: "내림차순 정렬"
    },
    dataCards: {
      showMoreValues: "더 많은 값 표시",
      showLessValues: "더 적은 값 표시",
      loadMore: "더 많이 로드하십시오:",
      sortBy: "정렬 기준",
      apply: "신청하기",
      ascending: "오름차순",
      descending: "내림차순"
    },
    paginator: {
      pageReportTemplate: "{first} - {last} 중 {totalRecords}",
      rowsPerPageLabel: "항목"
    },
    downloads: {
      fallbackText: "현재 사용 가능한 다운로드가 없습니다."
    },
    baseSlider: {
      navBackward: "뒤로 탐색",
      navForward: "앞으로 탐색",
      navToPage: "페이지로 이동"
    },
    historicalData: {
      waitMessage: "다운로드 준비 중",
      failedMessage: "다운로드 실패"
    },
    showMoreShowLess: {
      showMoreText: "자세히보기",
      showLessText: "간단히 보기"
    },
    globalTranslations: {
      yes: "예",
      no: "아니",
      submit: "제출",
      copyButton: "복사",
      copiedButton: "복사됨!",
      clear: "Delete",
      disclaimerDisagreeButtonLabel: "동의하지 않습니다",
      disclaimerAgreeButtonLabel: "동의합니다",
      disclaimerCancelButtonLabel: "취소",
      disclaimerConfirmButtonLabel: "수용하다",
      disclaimerTitle: "부인 성명",
      lockedContentLabel: "등록된 사용자만 사용 가능",
      loginOrRegisterLabel: "지금 로그인 또는 등록",
      isNewLabel: "새로운",
      addToWatchlist: "목록을보고 추가",
      addedToWatchlist: "관심 목록에 추가됨",
      tooltipTextShare: "공유하다",
      tooltipTextPrint: "인쇄",
      backLinkText: "Back",
      backToTopButtonText: "맨 위로",
      closeAllButtonText: "모두 닫기",
      openAllButtonText: "모두 열기",
      shareClassSelectLabel: "공유 클래스",
      emailInputLabelText: "이메일 주소",
      emailInputHelperText: "올바른 이메일 주소를 입력하세요.",
      date: "자료",
      startDate: "시작일",
      endDate: "종점",
      doNotShowAgain: "다시 표시하지 않음",
      star: "별",
      stars: "별",
      outOfStars: "5점 만점",
      noContent: "콘텐츠가 없습니다",
      results: "결과",
      result: "결과",
      search: "검색",
      phone: "전화",
      email: "이메일",
      open: "열다",
      close: "닫다",
      monthly: "월간",
      quarterly: "분기별",
      yearly: "연간",
      million: "백만",
      billion: "십억",
      years: "년",
      year: "년"
    },
    mediaReleases: {
      searchBoxPlaceholder: "미디어 릴리스에서 검색",
      noResults: "결과가 없습니다"
    },
    alertButton: {
      label: "구독하다"
    },
    periodCalendar: {
      fromLabel: "에서:",
      toLabel: "에게:"
    },
    accordionContainer: {
      closeAll: "모두 닫기",
      openAll: "모두 열기"
    },
    premiumDiscountLineChart: {
      yAxisLabel: "할증 또는 할인(bps)"
    },
    premiumDiscountHistoricChart: {
      yAxisLabel: "일 수",
      discount: "인 {",
      premium: "프리미엄",
      nav: "NAV"
    },
    stickyNavigation: {
      backToTopLinkText: "맨 위로",
      dataEventComponentName: "측면 탐색",
      dataEventTitle: "점프마크 | 맨 위로",
      mobileNavigation: "모바일 내비게이션"
    },
    contactCard: {
      mailto: "메일토"
    },
    footNote: {
      link: "각주로 돌아가기"
    },
    footNoteHeader: {
      link: "각주로 이동"
    },
    breadcrumb: {
      shareButton: "공유 클래스를 선택",
      email: "메일을 보내다",
      scrollLeft: "왼쪽으로 스크롤",
      scrollRight: "오른쪽으로 스크롤"
    },
    dropDocuments: {
      button: "선택 목록 열기",
      allDocuments: "모든 문서"
    },
    dwsCarousel: {
      backward: "이전 페이지",
      forward: "다음 페이지",
      page: "페이지로 이동"
    },
    megaMenu: {
      close: "닫다"
    },
    header: {
      search: "찾다",
      user: "사용자",
      moreLinks: "자세히보기",
      main: "메인 탐색",
      toggleMenu: "메뉴 전환",
      audienceAndCultureText: "역할 및 위치 선택",
      cultureText: "귀하의 위치"
    },
    allocationChartCard: {
      showLess: "적게 표시",
      showMore: "자세히보기"
    },
    performanceChart: {
      close: "닫다",
      //remove after old component is eliminated
      calendarCloseTooltipText: "닫다",
      calendarTooltipText: "기간 설정",
      downloadTooltipText: "다운로드",
      performanceToggleText: "성능(%)",
      priceToggleText: "탐색 기록",
      date: "날짜",
      startDate: "시작일",
      endDate: "종료일",
      nav: "Nav",
      navPercent: "Nav %",
      indexLevel: "Index level",
      indexLevelPercent: "Index level %",
      performanceYaxisLabel: "성능(%)",
      navYaxisLabel: "Nav",
      chartAriaLabel: "대화식 성능 차트",
      chartSeriesLabel: "차트 시리즈 라벨",
      chartNavigatorGroupLabel: "날짜 범위 선택을 위한 네비게이터 핸들",
      chartNavigatorHandlesLabelLeft: "왼쪽",
      chartNavigatorHandlesLabelRight: "오른쪽",
      chartNavigatorHandlesLabelEnd: "확대/축소 핸들"
    },
    fundsInFocus: {
      categoryLabel: "범주 / 투자자 프로필"
    },
    videoModule: {
      isRunningText: "지금 실행 중",
      minutesShort: "분",
      playButton: "동영상 재생"
    },
    personDetailBlock: {
      biography: "약력",
      education: "교육",
      professionalCareer: "전문 경력",
      publications: "간행물"
    },
    publications: {
      loadMore: "더 많이 로드"
    },
    newsletterTeaser: {
      invalidErrorTextHeading: "오류가 발생했습니다.",
      invalidErrorText: "요청을 처리하는 동안 오류가 발생했습니다. 다시 시도해 주세요."
    },
    baseActionMenu: {
      label: "액션 메뉴",
      itemSelected: "비교를 위해 제품을 목록의 맨 위로 이동했습니다.",
      itemRemoved: "비교를 위해 제품이 목록 맨 위로 제거되었습니다.",
      markForComparison: "비교를 위해 표시",
      bookmark: "책갈피",
      bookmarked: "북마크",
      removeCompare: "비교에서 제거",
      openActionMenu: "작업 메뉴 열기"
    },
    fundFinder: {
      periodLabel: "기간",
      periodHeadline: "변경 기간",
      periodHint: "여기에서 변경한 내용은 다른 시간 종속 설정에도 적용됩니다.",
      otherFilters: "다른 필터",
      deselectAll: "모두 선택 취소",
      fundSearchHeadline: "",
      resetFilters: "모든 필터 재설정",
      fundSearchPlaceholder: "검색",
      products: "제품",
      product: "제품",
      showProducts: "",
      downloadDocuments: "문서 다운로드",
      addedCompareMessage: "비교를 위해 제품이 목록 상단으로 이동되었습니다",
      removedCompareMessage: "제품이 목록 상단에서 제거되었습니다",
      addedBookmarkMessage: "제품이 관심 목록에 추가되었습니다",
      removedBookmarkMessage: "제품이 관심 목록에서 제거되었습니다",
      changeColumnView: "열 보기 변경"
    },
    productChartTeaser: {
      performance: "성능"
    },
    archivePage: {
      searchBoxPlaceholder: "아카이브에서 검색",
      loadMore: "더 많이 로드",
      filters: "필터",
      resetFilters: "모든 필터 재설정",
      otherFilters: "다른 필터"
    },
    teaser: {
      new: "신규"
    },
    baseResultView: {
      listViewTitle: "목록 보기",
      gridViewTitle: "그리드 보기"
    },
    showMoreLessToggle: {
      showMoreText: "자세히보기",
      showLessText: "간단히 보기"
    },
    searchResultPage: {
      searchResultPagePlaceholder: "검색",
      resultsFor: "다음에 대한 결과",
      filterBy: "필터링 기준",
      sortBy: "정렬 기준"
    },
    baseNonRemovableFilters: {
      edit: "편집"
    },
    baseRemovableFilters: {
      removeFilter: "필터 제거"
    },
    tabContainer: {
      requiresLogin: "로그인 필요"
    },
    propertyTeaser: {
      gallery: "갤러리",
      images: "이미지"
    },
    propertyGallery: {
      map: "지도",
      filters: "필터",
      marketValue: "시장 가치",
      acquisitionYear: "취득 연도",
      location: "위치",
      resultText: "속성",
      resultsText: "속성",
      loadMore: "더 로드"
    },
    sortOptions: {
      sortByLabel: "정렬 기준",
      nameAsc: "이름 오름차순",
      nameDesc: "이름 내림차순",
      priceAsc: "가격 낮은 순",
      priceDesc: "가격 높은 순",
      acquisitionYearAsc: "취득 연도 오래된 순",
      acquisitionYearDesc: "취득 연도 최신 순"
    },
    propertyKeyValues: {
      type: "유형",
      purchasePrice: "구매 가격",
      acquisitionYear: "취득 연도",
      location: "위치"
    },
    baseGoogleMap: {
      mapType: "지도 유형",
      streetView: "스트리트 뷰",
      zoomIn: "확대",
      zoomOut: "축소",
      locationMarker: "선택하다"
    },
    documentList: {
      numberOfResultLabel: "문서"
    },
    literatureLibrary: {
      searchBoxPlaceholder: "제품 검색"
    },
    baseTreeSelect: {
      placeholder: "검색",
      emptyMessage: "안내서 또는 보고서를 찾을 수 없습니다",
      triggerAriaLabel: "선택 목록 열기"
    },
    faqPage: {
      expandAll: "모든 답변 표시",
      closeAll: "모든 답변 닫기",
      searchPlaceholder: "FAQ에서 검색",
      result: "결과",
      results: "결과",
      noResults: "결과가 없습니다",
      searchResults: "검색 결과"
    },
    glossary: {
      expandAll: "모든 답변 표시",
      closeAll: "모든 답변 닫기",
      searchPlaceholder: "용어집에서 검색",
      result: "결과",
      results: "결과",
      noResults: "다음에 대한 결과가 없습니다",
      showAllResults: "모든 결과 표시",
      chooseOption: "옵션 선택"
    },
    eventList: {
      date: "날짜",
      event: "이벤트",
      time: "시간",
      download: "다운로드"
    },
    quizAndPoll: {
      explanationHeadlineCorrect: "좋아요, 당신의 답변은 정확합니다.",
      explanationHeadlineInCorrect: "죄송합니다, 당신의 답변이 완전히 정확하지 않았습니다.",
      socialLabel: "공유:"
    },
    marketDataBlock: {
      intraday: "당일"
    },
    search: {
      showAllResults: "모든 결과 표시"
    },
    imageGalleryTeaser: {
      gallery: "갤러리에서 열기"
    },
    documentViewer: {
      documentView: "PDF 문서보기",
      loading: "문서 로드 중"
    },
    productBuyingProcess: {
      searchBoxPlaceholder: "제품 검색",
      continueToPartner: "파트너로 이동"
    },
    coloredNumber: {
      default: "기본",
      positive: "긍정적",
      negative: "부정적"
    },
    footer: {
      contact: "연락처",
      showContactInformation: "연락처 정보 표시",
      changeAudienceAndCulture: "역할 및 언어 변경",
      changeCulture: "언어 변경",
      legalAndPolicyLinks: "법률 및 정책 링크"
    },
    calendarPage: {
      icalDownload: "{eventTitle} 이벤트에 대한 iCal 파일 다운로드"
    },
    riskDisclaimer: {
      showDisclaimer: "면책 성명 표시",
      hideDisclaimer: "면책 성명 숨기기"
    },
    crociCompanyOverviewPage: {
      searchBoxPlaceholder: "회사명 또는 종목 검색"
    },
    crociCompanyDetailPage: {
      showAll: "모두 표시",
      showLess: "간단히 보기",
      ticker: {
        ticker: "티커:",
        category: "범주:",
        sharePrice: "주가:"
      },
      zoomChart: "차트의 상세보기 열기"
    },
    calculatorOutputCard: {
      inflationInfoText: "<b>{years}년 후, {value}</b>의 자본은 구매력을 잃습니다:",
      investmentInfoText: "귀하의 투자",
      valueDevelopment: "가치 개발",
      regularInvestment: "총 정기 투자",
      initialInvestment: "초기 투자",
      purchasingPower: "개별 금액",
      investmentChartTitle: "투자 차트 데이터",
      inflationChartTitle: "인플레이션 차트 데이터"
    },
    calculationArea: {
      calculationButtonLabel: "계산",
      optionButtonLabel: "옵션",
      optionButtonLabelLess: "옵션",
      restartButtonLabel: "재시작",
      currentInflationRateLabel: "현재 인플레이션률 사용"
    }
  },
  pt: {
    Accept: "Accept",
    Cancel: "Cancelar",
    baseSearchBox: {
      resultEventComponentName: "Links de texto (mesma página)"
    },
    audioModule: {
      play: "Reproduzir"
    },
    allocationChart: {
      card: {
        othersText: "Diversos"
      }
    },
    teaserWww: {
      countrySelectorTitle: "Selecione um local",
      countryDropdownPlaceholder: "Selecione um local",
      countryDropdownFilterPlaceholder: "Digite o texto aqui..."
    },
    shareButton: {
      label: "Compartilhar"
    },
    productHeader: {
      allDocuments: "Todos os documentos"
    },
    entryGate: {
      productSearchLabel: "Insira seu produto",
      countryLabel: "Selecione sua localização",
      audienceLabel: "Selecione sua função",
      inputPlaceholder: "ISIN",
      inputInvalidText: "ISIN inválido",
      productLabel: "Seu produto",
      relationshipLabel: "Selecione sua relação comercial",
      existingInvestorLabel: "Eu sou um investidor existente",
      nonExistingInvestorLabel: "Eu não sou um investidor existente",
      countryDropdownFilterPlaceholder: "Digite o texto aqui...",
      countryDropdownPlaceholder: "Selecione um pais"
    },
    dataTable: {
      pageReportTemplate: "Mostrando {first} a {last} de {totalRecords} entradas",
      sortedAscending: "Classificado em ordem crescente",
      sortedDescending: "Classificado em ordem decrescente"
    },
    dataCards: {
      showMoreValues: "Mostrar mais valores",
      showLessValues: "Mostrar menos valores",
      loadMore: "Załaduj więcej:",
      sortBy: "Sortuj według",
      apply: "Aplicar",
      ascending: "Ascendente",
      descending: "Descendente"
    },
    paginator: {
      pageReportTemplate: "{first} - {last} de {totalRecords}",
      rowsPerPageLabel: "Entradas"
    },
    downloads: {
      fallbackText: "No momento não há downloads disponíveis"
    },
    baseSlider: {
      navBackward: "navegar para trás",
      navForward: "navegar para a frente",
      navToPage: "navegar para a página"
    },
    historicalData: {
      waitMessage: "Preparando o download",
      failedMessage: "Download falhou"
    },
    showMoreShowLess: {
      showMoreText: "Mostre mais",
      showLessText: "Mostre menos"
    },
    globalTranslations: {
      yes: "Sim",
      no: "Não",
      submit: "Enviar",
      copyButton: "cópia de",
      copiedButton: "copiado!",
      clear: "Delete",
      disclaimerDisagreeButtonLabel: "Discordar",
      disclaimerAgreeButtonLabel: "Concordo",
      disclaimerCancelButtonLabel: "Cancelar",
      disclaimerConfirmButtonLabel: "Aceitar",
      disclaimerTitle: "Isenção de responsabilidade",
      lockedContentLabel: "Disponível apenas para usuários registrados",
      loginOrRegisterLabel: "Entre ou registre-se agora",
      isNewLabel: "novo",
      addToWatchlist: "Adicionar à lista de observação",
      addedToWatchlist: "Adicionado à lista de observação",
      tooltipTextShare: "Compartilhar",
      tooltipTextPrint: "Imprimir",
      backLinkText: "Back",
      backToTopButtonText: "De volta ao topo",
      closeAllButtonText: "Feche tudo",
      openAllButtonText: "Abra tudo",
      shareClassSelectLabel: "Classe de ações",
      emailInputLabelText: "Endereço de email",
      emailInputHelperText: "Introduza o endereço de correio electrónico correcto",
      date: "Dado",
      startDate: "Dado inicial",
      endDate: "Ponto final",
      doNotShowAgain: "Não voltar a mostrar",
      star: "Estrela",
      stars: "Estrelas",
      outOfStars: "de 5 estrelas",
      noContent: "Sem conteúdo",
      results: "Resultados",
      result: "Resultado",
      search: "Procurar",
      phone: "Telefone",
      email: "Email",
      open: "Aberto",
      close: "Fechar",
      monthly: "Mensal",
      quarterly: "Trimestral",
      yearly: "Anual",
      million: "mill.",
      billion: "bill",
      years: "anos",
      year: "ano"
    },
    mediaReleases: {
      searchBoxPlaceholder: "Pesquisar em comunicados de imprensa",
      noResults: "Nenhum resultado encontrado"
    },
    alertButton: {
      label: "Se inscrever"
    },
    periodCalendar: {
      fromLabel: "De:",
      toLabel: "Para:"
    },
    accordionContainer: {
      closeAll: "Feche tudo",
      openAll: "Abra tudo"
    },
    premiumDiscountLineChart: {
      yAxisLabel: "Prêmio ou descontos (bps)"
    },
    premiumDiscountHistoricChart: {
      yAxisLabel: "Número de dias",
      discount: "Desconto",
      premium: "Premium",
      nav: "NAV"
    },
    stickyNavigation: {
      backToTopLinkText: "De volta ao topo",
      dataEventComponentName: "Navegação Lateral",
      dataEventTitle: "Marca de salto | De volta ao topo",
      mobileNavigation: "Navegação móve"
    },
    contactCard: {
      mailto: "mailto"
    },
    footNote: {
      link: "voltar para a nota de rodapé"
    },
    footNoteHeader: {
      link: "pular para nota de rodapé"
    },
    breadcrumb: {
      shareButton: "escolha a classe de compartilhamento",
      email: "enviar correio",
      scrollLeft: "rolar para a esquerda",
      scrollRight: "rolar para a direita"
    },
    dropDocuments: {
      button: "lista de seleção aberta",
      allDocuments: "Todos os documentos"
    },
    dwsCarousel: {
      backward: "página anterior",
      forward: "próxima página",
      page: "pular para a página"
    },
    megaMenu: {
      close: "fechar"
    },
    header: {
      search: "Procurar",
      user: "Do utilizador",
      moreLinks: "Mostre mais",
      main: "Navegação principal",
      toggleMenu: "Alternar menu",
      audienceAndCultureText: "Selecione a função e a localização",
      cultureText: "Sua localização"
    },
    allocationChartCard: {
      showLess: "mostre menos",
      showMore: "mostre mais"
    },
    performanceChart: {
      close: "fechar",
      //remove after old component is eliminated
      calendarCloseTooltipText: "Fechar",
      calendarTooltipText: "Definir período",
      downloadTooltipText: "Transferências",
      performanceToggleText: "Desempenho em %",
      priceToggleText: "histórico de NAV",
      date: "Data",
      startDate: "Data de início",
      endDate: "Data final",
      nav: "Nav",
      navPercent: "Nav %",
      indexLevel: "Index level",
      indexLevelPercent: "Index level %",
      performanceYaxisLabel: "Desempenho em %",
      navYaxisLabel: "Nav",
      chartAriaLabel: "Gráfico de desempenho interativo",
      chartSeriesLabel: "Rótulos de série de gráficos",
      chartNavigatorGroupLabel: "Alças do navegador para selecionar o intervalo de datas.",
      chartNavigatorHandlesLabelLeft: "Esquerda",
      chartNavigatorHandlesLabelRight: "Direita",
      chartNavigatorHandlesLabelEnd: "alça para zoom."
    },
    fundsInFocus: {
      categoryLabel: "Categoria / Perfil do Investidor"
    },
    videoModule: {
      isRunningText: "agora correndo",
      minutesShort: "min.",
      playButton: "Reproduzir vídeo"
    },
    personDetailBlock: {
      biography: "Biografia",
      education: "Formação académica",
      professionalCareer: "Carreira profissional",
      publications: "Publikacje"
    },
    publications: {
      loadMore: "Załaduj więcej"
    },
    newsletterTeaser: {
      invalidErrorTextHeading: "Ocorreu um erro",
      invalidErrorText: "Ocorreu um erro ao processar o seu pedido. Por favor, tente novamente."
    },
    baseActionMenu: {
      label: "menu de ação",
      itemSelected: "Para comparação, o produto foi movido para o topo da lista.",
      itemRemoved: "Para comparação, o produto foi removido para o topo da lista.",
      markForComparison: "Marcar para comparação",
      bookmark: "Marcador",
      bookmarked: "marcado",
      removeCompare: "Remover da comparação",
      openActionMenu: "abrir o menu de ações"
    },
    fundFinder: {
      periodLabel: "Período",
      periodHeadline: "Período de modificação",
      periodHint: "As alterações aqui efectuadas são também aplicadas a outras definições dependentes do tempo.",
      otherFilters: "Outros filtros",
      deselectAll: "Desmarcar tudo",
      fundSearchHeadline: "",
      resetFilters: "Redefinir todos os filtros",
      fundSearchPlaceholder: "Pesquisar",
      products: "produtos",
      product: "produto",
      showProducts: "Mostrar",
      downloadDocuments: "Transferir documentos",
      addedCompareMessage: "Para efeitos de comparação, o produto foi deslocado para o topo da lista",
      removedCompareMessage: "O produto foi retirado do topo da lista",
      addedBookmarkMessage: "O produto foi adicionado à sua lista de observação",
      removedBookmarkMessage: "O produto foi removido da sua lista de observação",
      changeColumnView: "Alterar a vista de colunas"
    },
    productChartTeaser: {
      performance: "Desempenho"
    },
    archivePage: {
      searchBoxPlaceholder: "Pesquisa nos arquivos",
      loadMore: "Załaduj więcej",
      filters: "Filtros",
      resetFilters: "Redefinir todos os filtros",
      otherFilters: "Outros filtros"
    },
    teaser: {
      new: "Novo"
    },
    baseResultView: {
      listViewTitle: "Vista de lista",
      gridViewTitle: "Vista da grelha"
    },
    showMoreLessToggle: {
      showMoreText: "Mostre mais",
      showLessText: "Mostre menos"
    },
    searchResultPage: {
      searchResultPagePlaceholder: "Procurar",
      resultsFor: "Resultados para",
      filterBy: "Filtrar por",
      sortBy: "Ordenar por"
    },
    baseNonRemovableFilters: {
      edit: "Editar"
    },
    baseRemovableFilters: {
      removeFilter: "remover filtro"
    },
    tabContainer: {
      requiresLogin: "Requer login"
    },
    propertyTeaser: {
      gallery: "Galeria",
      images: "Imagens"
    },
    propertyGallery: {
      map: "Mapa",
      filters: "Filtros",
      marketValue: "Valor de mercado",
      acquisitionYear: "Ano de aquisição",
      location: "Localização",
      resultText: "Propriedade",
      resultsText: "Propriedades",
      loadMore: "Carregar mais"
    },
    sortOptions: {
      sortByLabel: "Ordenar por",
      nameAsc: "Nome A-Z",
      nameDesc: "Nome Z-A",
      priceAsc: "Preço baixo-alto",
      priceDesc: "Preço alto-baixo",
      acquisitionYearAsc: "Ano de aquisição antigo-novo",
      acquisitionYearDesc: "Ano de aquisição novo-antigo"
    },
    propertyKeyValues: {
      type: "Tipo",
      purchasePrice: "Preço de compra",
      acquisitionYear: "Ano de aquisição",
      location: "Localização"
    },
    baseGoogleMap: {
      mapType: "Tipo de mapa",
      streetView: "Vista de rua",
      zoomIn: "Aumentar o zoom",
      zoomOut: "Reduzir o zoom",
      locationMarker: "Escolher"
    },
    documentList: {
      numberOfResultLabel: "documentos"
    },
    literatureLibrary: {
      searchBoxPlaceholder: "Pesquisar produto"
    },
    baseTreeSelect: {
      placeholder: "Pesquisar",
      emptyMessage: "Não foram encontrados prospectos ou relatórios",
      triggerAriaLabel: "Abrir lista de seleção"
    },
    faqPage: {
      expandAll: "Mostrar todas as respostas",
      closeAll: "Fechar todas as respostas",
      searchPlaceholder: "Pesquisar no FAQ",
      result: "Resultado",
      results: "Resultados",
      noResults: "Nenhum resultado encontrado",
      searchResults: "Resultados da pesquisa"
    },
    glossary: {
      expandAll: "Mostrar todas as respostas",
      closeAll: "Fechar todas as respostas",
      searchPlaceholder: "Pesquisar no glossário",
      result: "Resultado",
      results: "Resultados",
      noResults: "Nenhum resultado encontrado para",
      showAllResults: "Mostrar todos os resultados",
      chooseOption: "Escolha uma opção"
    },
    eventList: {
      date: "Data",
      event: "Evento",
      time: "Hora",
      download: "Transferências"
    },
    quizAndPoll: {
      explanationHeadlineCorrect: "Fantástico, a sua resposta está correta.",
      explanationHeadlineInCorrect: "Infelizmente, a sua resposta não estava totalmente correta.",
      socialLabel: "Compartilhar:"
    },
    marketDataBlock: {
      intraday: "Intraday"
    },
    search: {
      showAllResults: "Mostrar todos os resultados"
    },
    imageGalleryTeaser: {
      gallery: "Abrir na galeria"
    },
    documentViewer: {
      documentView: "Visualização de documento PDF",
      loading: "Carregando documento"
    },
    productBuyingProcess: {
      searchBoxPlaceholder: "Pesquise seu produto",
      continueToPartner: "Continuar para o parceiro"
    },
    coloredNumber: {
      default: "Padrão",
      positive: "Positivo",
      negative: "Negativo"
    },
    footer: {
      contact: "Contato",
      showContactInformation: "Mostrar  informações de contato",
      changeAudienceAndCulture: "Alterar função e idioma",
      changeCulture: "Alterar idioma",
      legalAndPolicyLinks: "Links legais e políticas"
    },
    calendarPage: {
      icalDownload: "Baixar arquivo iCal de {eventTitle} evento"
    },
    riskDisclaimer: {
      showDisclaimer: "Mostrar declaração de risco",
      hideDisclaimer: "Ocultar declaração de risco"
    },
    crociCompanyOverviewPage: {
      searchBoxPlaceholder: "Pesquise o nome da empresa ou ticker"
    },
    crociCompanyDetailPage: {
      showAll: "Mostrar tudo",
      showLess: "Mostrar menos",
      ticker: {
        ticker: "Ticker:",
        category: "Categoria:",
        sharePrice: "Preço da ação:"
      },
      zoomChart: "Abrir detalhes do gráfico"
    },
    calculatorOutputCard: {
      inflationInfoText: "Depois de <b>{years} anos</b>, o seu capital de <b>{value}</b> perderá o seu poder de compra:",
      investmentInfoText: "Seu investimento",
      valueDevelopment: "Desenvolvimento do valor",
      regularInvestment: "Investimento regular total",
      initialInvestment: "Investimento inicial",
      purchasingPower: "Valor individual",
      investmentChartTitle: "Dados do gráfico de investimento",
      inflationChartTitle: "Dados do gráfico de inflação"
    },
    calculationArea: {
      calculationButtonLabel: "Calcular",
      optionButtonLabel: "Mais opções",
      optionButtonLabelLess: "Menos opções",
      restartButtonLabel: "Reiniciar",
      currentInflationRateLabel: "Usar a taxa de inflação atual"
    }
  },
  zh: {
    Accept: "接受",
    Cancel: "取消",
    baseSearchBox: {
      resultEventComponentName: "文本链接（同一页）"
    },
    audioModule: {
      play: "播放"
    },
    allocationChart: {
      card: {
        othersText: "其他的"
      }
    },
    teaserWww: {
      countrySelectorTitle: "选择地点",
      countryDropdownPlaceholder: "选择地点",
      countryDropdownFilterPlaceholder: "在此输入文字..."
    },
    shareButton: {
      label: "分享"
    },
    productHeader: {
      allDocuments: "所有文件"
    },
    entryGate: {
      productSearchLabel: "输入您的产品",
      countryLabel: "选择您的位置",
      audienceLabel: "选择您的角色",
      inputPlaceholder: "ISIN",
      inputInvalidText: "无效的 ISIN",
      productLabel: "您的产品",
      relationshipLabel: "选择您的业务关系",
      existingInvestorLabel: "我是现有投资者",
      nonExistingInvestorLabel: "我不是现有投资者",
      countryDropdownFilterPlaceholder: "在此输入文字...",
      countryDropdownPlaceholder: "选择一个国家"
    },
    dataTable: {
      pageReportTemplate: "显示 {first} 到 {last} 个条目 共 {totalRecords} 个",
      sortedAscending: "按升序排序",
      sortedDescending: "按降序排序"
    },
    dataCards: {
      showMoreValues: "显示更多值",
      showLessValues: "显示更少值",
      loadMore: "装载更多:",
      sortBy: "排序方式",
      apply: "申请",
      ascending: "上升",
      descending: "下降"
    },
    paginator: {
      pageReportTemplate: "{first} - {last} 的 {totalRecords}",
      rowsPerPageLabel: "参赛作品"
    },
    downloads: {
      fallbackText: "目前没有可用的下载"
    },
    baseSlider: {
      navBackward: "向后导航",
      navForward: "向前导航",
      navToPage: "导航到页面"
    },
    historicalData: {
      waitMessage: "准备下载",
      failedMessage: "下载失败"
    },
    showMoreShowLess: {
      showMoreText: "展示更多",
      showLessText: "显示较少"
    },
    globalTranslations: {
      yes: "是",
      no: "没有",
      submit: "提交",
      copyButton: "复制",
      copiedButton: "已复制!",
      clear: "Delete",
      disclaimerDisagreeButtonLabel: "不同意",
      disclaimerAgreeButtonLabel: "同意",
      disclaimerCancelButtonLabel: "取消",
      disclaimerConfirmButtonLabel: "接受",
      disclaimerTitle: "免责声明",
      lockedContentLabel: "仅适用于注册用户",
      loginOrRegisterLabel: "登录或者现在注册",
      isNewLabel: "新的",
      addToWatchlist: "加入观看列表",
      addedToWatchlist: "已添加至关注列表",
      tooltipTextShare: "分享",
      tooltipTextPrint: "打印",
      backLinkText: "后退",
      backToTopButtonText: "回到顶部",
      closeAllButtonText: "关闭所有",
      openAllButtonText: "全部打开",
      shareClassSelectLabel: "股份类别",
      emailInputLabelText: "电子邮件地址",
      emailInputHelperText: "请输入正确的电子邮件地址",
      date: "日期",
      startDate: "开始日期",
      endDate: "结束日期",
      doNotShowAgain: "不再显示",
      star: "星星",
      stars: "星星",
      outOfStars: "5星级",
      noContent: "无内容",
      results: "结果",
      result: "结果",
      search: "搜索",
      phone: "电话",
      email: "电子邮件",
      open: "打开",
      close: "关闭",
      monthly: "每月",
      quarterly: "季度",
      yearly: "每年",
      million: "百萬",
      billion: "十億",
      years: "年",
      year: "年"
    },
    mediaReleases: {
      searchBoxPlaceholder: "在媒体发布中搜索",
      noResults: "没有结果"
    },
    alertButton: {
      label: "订阅"
    },
    periodCalendar: {
      fromLabel: "从:",
      toLabel: "到:"
    },
    accordionContainer: {
      closeAll: "关闭所有",
      openAll: "全部打开"
    },
    premiumDiscountLineChart: {
      yAxisLabel: "溢价或折扣（基点"
    },
    premiumDiscountHistoricChart: {
      yAxisLabel: "天数",
      discount: "折扣",
      premium: "优质的",
      nav: "NAV"
    },
    stickyNavigation: {
      backToTopLinkText: "回到顶部",
      dataEventComponentName: "侧面导航",
      dataEventTitle: "跳跃标记 | 回到顶部",
      mobileNavigation: "手机导航"
    },
    contactCard: {
      mailto: "牛奶"
    },
    footNote: {
      link: "跳回脚注"
    },
    footNoteHeader: {
      link: "跳转到脚注"
    },
    breadcrumb: {
      shareButton: "选择股票类别",
      email: "发送邮件",
      scrollLeft: "向左滚动",
      scrollRight: "向右滚动"
    },
    dropDocuments: {
      button: "打开选择列表",
      allDocuments: "所有文件"
    },
    dwsCarousel: {
      backward: "上一页",
      forward: "下一页",
      page: "页"
    },
    megaMenu: {
      close: "关闭"
    },
    header: {
      search: "搜索",
      user: "用户",
      moreLinks: "展示更多",
      main: "主导航",
      toggleMenu: "切换菜单",
      audienceAndCultureText: "选择角色和位置",
      cultureText: "您的位置"
    },
    allocationChartCard: {
      showLess: "显示较少",
      showMore: "展示更多"
    },
    performanceChart: {
      close: "关闭",
      //remove after old component is eliminated
      calendarCloseTooltipText: "关闭",
      calendarTooltipText: "设定期间",
      downloadTooltipText: "下载",
      performanceToggleText: "表现在 %",
      priceToggleText: "NAV 历史",
      date: "日期",
      startDate: "开始日期",
      endDate: "结束日期",
      nav: "Nav",
      navPercent: "Nav %",
      indexLevel: "指数级别",
      indexLevelPercent: "指数级别 %",
      performanceYaxisLabel: "表现在 %",
      navYaxisLabel: "Nav",
      chartAriaLabel: "互动表现图",
      chartSeriesLabel: "图表系列标签",
      chartNavigatorGroupLabel: "用于选择日期范围的导航器句柄。",
      chartNavigatorHandlesLabelLeft: "左",
      chartNavigatorHandlesLabelRight: "右",
      chartNavigatorHandlesLabelEnd: "缩放句柄。"
    },
    fundsInFocus: {
      categoryLabel: "类别 / 投资者简介"
    },
    videoModule: {
      isRunningText: "现在正在运行",
      minutesShort: "分钟",
      playButton: "播放视频"
    },
    personDetailBlock: {
      biography: "传记",
      education: "教育",
      professionalCareer: "职业生涯",
      publications: "出版物"
    },
    publications: {
      loadMore: "装载更多"
    },
    newsletterTeaser: {
      invalidErrorTextHeading: "发生了错误",
      invalidErrorText: "处理您的请求时发生错误。 请再试一次"
    },
    baseActionMenu: {
      label: "动作菜单",
      itemSelected: "为了进行比较，该产品已移至列表顶部",
      itemRemoved: "为了进行比较，该产品已被移至列表顶部",
      markForComparison: "标记为比较",
      bookmark: "书签",
      bookmarked: "书签",
      removeCompare: "从比较中删除",
      openActionMenu: "打开操作菜单"
    },
    fundFinder: {
      periodLabel: "期间",
      periodHeadline: "更改期间",
      periodHint: "此处的更改也适用于其他与时间相关的设置。",
      otherFilters: "其他过滤器",
      deselectAll: "取消全选",
      fundSearchHeadline: "",
      fundSearchPlaceholder: "搜索",
      resetFilters: "重置所有过滤器",
      products: "产品",
      product: "产品",
      showProducts: "显示",
      downloadDocuments: "下载文档",
      addedCompareMessage: "为便于比较，该产品被移至列表顶部",
      removedCompareMessage: " 该产品已从列表顶部移除",
      addedBookmarkMessage: "产品已添加到您的关注列表",
      removedBookmarkMessage: "产品已从您的关注列表中移除",
      changeColumnView: "更改列视图"
    },
    productChartTeaser: {
      performance: "表现"
    },
    archivePage: {
      searchBoxPlaceholder: "在档案中搜索",
      loadMore: "装载更多",
      filters: "过滤器",
      resetFilters: "重置所有筛选器",
      otherFilters: "其他过滤器"
    },
    teaser: {
      new: "新的"
    },
    baseResultView: {
      listViewTitle: "列表显示",
      gridViewTitle: "网格视图"
    },
    showMoreLessToggle: {
      showMoreText: "显示更多",
      showLessText: "显示更少"
    },
    searchResultPage: {
      searchResultPagePlaceholder: "搜索",
      resultsFor: "结果",
      filterBy: "过滤",
      sortBy: "排序方式"
    },
    baseNonRemovableFilters: {
      edit: "编辑"
    },
    baseRemovableFilters: {
      removeFilter: "删除过滤器"
    },
    tabContainer: {
      requiresLogin: "需要登录"
    },
    propertyTeaser: {
      gallery: "画廊",
      images: "图片"
    },
    propertyGallery: {
      map: "地图",
      filters: "过滤器",
      marketValue: "市场价值",
      acquisitionYear: "购置年份",
      location: "地点",
      resultText: "财产",
      resultsText: "财产",
      loadMore: "加载更多"
    },
    sortOptions: {
      sortByLabel: "排序方式",
      nameAsc: "名称升序",
      nameDesc: "名称降序",
      priceAsc: "价格升序",
      priceDesc: "价格降序",
      acquisitionYearAsc: "购置年份升序",
      acquisitionYearDesc: "购置年份降序"
    },
    propertyKeyValues: {
      type: "类型",
      purchasePrice: "购买价格",
      acquisitionYear: "收购年份",
      location: "位置"
    },
    baseGoogleMap: {
      mapType: "地图类型",
      streetView: "街道视图",
      zoomIn: "放大",
      zoomOut: "缩小",
      locationMarker: "选择"
    },
    documentList: {
      numberOfResultLabel: "文件"
    },
    literatureLibrary: {
      searchBoxPlaceholder: "搜索产品"
    },
    baseTreeSelect: {
      placeholder: "搜索",
      emptyMessage: "未找到招股说明书或报告",
      triggerAriaLabel: "打开选择列表"
    },
    faqPage: {
      expandAll: "展开所有答案",
      closeAll: "关闭所有答案",
      searchPlaceholder: "在常见问题中搜索",
      result: "结果",
      results: "结果",
      noResults: "没有结果",
      searchResults: "搜索结果"
    },
    glossary: {
      expandAll: "展开所有答案",
      closeAll: "关闭所有答案",
      searchPlaceholder: "在词汇表中搜索",
      result: "结果",
      results: "结果",
      noResults: "没有结果",
      showAllResults: "显示所有结果",
      chooseOption: "选择一个选项"
    },
    eventList: {
      date: "日期",
      event: "事件",
      time: "时间",
      download: "下载"
    },
    quizAndPoll: {
      explanationHeadlineCorrect: "太棒了，您的答案是正确的。",
      explanationHeadlineInCorrect: "很抱歉，您的答案并不完全正确。",
      socialLabel: "分享："
    },
    marketDataBlock: {
      intraday: "当日"
    },
    search: {
      showAllResults: "显示所有结果"
    },
    imageGalleryTeaser: {
      gallery: "在画廊中打开"
    },
    documentViewer: {
      documentView: "PDF文档查看",
      loading: "加载文档"
    },
    productBuyingProcess: {
      searchBoxPlaceholder: "搜索您的产品",
      continueToPartner: "继续到合作伙伴"
    },
    coloredNumber: {
      default: "默认",
      positive: "正面",
      negative: "负面"
    },
    footer: {
      contact: "联系",
      showContactInformation: "显示联系信息",
      changeAudienceAndCulture: "更改角色和语言",
      changeCulture: "更改语言",
      legalAndPolicyLinks: "法律和政策链接"
    },
    calendarPage: {
      icalDownload: "下载 {eventTitle} 事件的 iCal 文件"
    },
    riskDisclaimer: {
      showDisclaimer: "显示风险声明",
      hideDisclaimer: "隐藏风险声明"
    },
    crociCompanyOverviewPage: {
      searchBoxPlaceholder: "搜索公司名称或股票代码"
    },
    crociCompanyDetailPage: {
      showAll: "显示全部",
      showLess: "显示较少",
      ticker: {
        ticker: "股票代码：",
        category: "类别：",
        sharePrice: "股价："
      },
      zoomChart: "打开图表详细信息"
    },
    calculatorOutputCard: {
      inflationInfoText: "经过 <b>{years} 年</b>，您的 <b>{value}</b> 资本将失去购买力：",
      investmentInfoText: "您的投资",
      valueDevelopment: "价值发展",
      regularInvestment: "总常规投资",
      initialInvestment: "初始投资",
      purchasingPower: "单个价值",
      investmentChartTitle: "投資圖表資料",
      inflationChartTitle: "通貨膨脹圖表資料"
    },
    calculationArea: {
      calculationButtonLabel: "计算",
      optionButtonLabel: "更多选项",
      optionButtonLabelLess: "更少的选择",
      restartButtonLabel: "重新开始",
      currentInflationRateLabel: "使用当前通货膨胀率"
    }
  },
  "zh-TW": {
    Accept: "接受",
    Cancel: "取消",
    baseSearchBox: {
      resultEventComponentName: "文本链接（同一页）"
    },
    typography: {
      disclaimer: "DWS 免責聲明：債券投資在不同程度上受利率、信用、流動性和市場風險的影響。一般來說，當利率上升時，債券價格會下跌。信用風險是指發行人按時支付本金和利息的能力。投資於低質量（垃圾債券）或未評級的證券相比於投資於高質量證券，面臨更高的損失風險。地方政府發行的證券面臨訴訟、法律及其他政治事件、當地商業或經濟條件等風險，發行人的破產可能會對本金和/或利息的支付能力產生重大影響。地方債券的市場流動性可能低於應稅債券，且關於地方政府發行人的財務狀況可獲得的信息可能少於公共公司。投資衍生品涉及流動性、槓桿和信用的特殊風險，這些風險可能會增加波動性或降低回報。基金尋求免除部分加州和聯邦所得稅的收益。然而，基金分配可能會受到聯邦、州或地方稅的影響，包括替代最低稅。欲了解更多詳情，請參閱基金說明書。日期：2022年9月8日。",
      pageHeadline: "頁面標題 h1：DWS 2022年9月8日資料",
      h2Headline: "頁面標題 h2：DWS 2022年9月8日資料",
      sectionH2Headline: "段落標題 h2：2022年9月8日資料",
      h3Headline: "頁面標題 h3：DWS 2022年9月8日資料",
      h4Headline: "頁面標題 h4：DWS 2022年9月8日資料",
      copyHeadline: "標題：2022年9月8日資料",
      copyText: "文本：2022年9月8日資料",
      copyTextBold: "文本：2022年9月8日資料",
      labelGerman: "德語",
      labelEnglish: "英語",
      labelChinese: "中文",
      labelJapanese: "日文"
    },
    audioModule: {
      play: "播放"
    },
    allocationChart: {
      card: {
        othersText: "其他的"
      }
    },
    teaserWww: {
      countrySelectorTitle: "选择地点",
      countryDropdownPlaceholder: "选择地点",
      countryDropdownFilterPlaceholder: "在此输入文字..."
    },
    shareButton: {
      label: "分享"
    },
    productHeader: {
      allDocuments: "所有文件"
    },
    entryGate: {
      productSearchLabel: "输入您的产品",
      countryLabel: "选择您的位置",
      audienceLabel: "选择您的角色",
      inputPlaceholder: "ISIN",
      inputInvalidText: "无效的 ISIN",
      productLabel: "您的产品",
      relationshipLabel: "选择您的业务关系",
      existingInvestorLabel: "我是现有投资者",
      nonExistingInvestorLabel: "我不是现有投资者",
      countryDropdownFilterPlaceholder: "在此输入文字...",
      countryDropdownPlaceholder: "选择一个国家"
    },
    dataTable: {
      pageReportTemplate: "显示 {first} 到 {last} 个条目 共 {totalRecords} 个",
      sortedAscending: "按升序排序",
      sortedDescending: "按降序排序"
    },
    dataCards: {
      showMoreValues: "显示更多值",
      showLessValues: "显示更少值",
      loadMore: "装载更多:",
      sortBy: "排序方式",
      apply: "申请",
      ascending: "上升",
      descending: "下降"
    },
    paginator: {
      pageReportTemplate: "{first} - {last} 的 {totalRecords}",
      rowsPerPageLabel: "参赛作品"
    },
    downloads: {
      fallbackText: "目前没有可用的下载"
    },
    baseSlider: {
      navBackward: "向后导航",
      navForward: "向前导航",
      navToPage: "导航到页面"
    },
    historicalData: {
      waitMessage: "准备下载",
      failedMessage: "下载失败"
    },
    showMoreShowLess: {
      showMoreText: "展示更多",
      showLessText: "显示较少"
    },
    globalTranslations: {
      yes: "是",
      no: "没有",
      submit: "提交",
      copyButton: "复制",
      copiedButton: "已复制!",
      clear: "Delete",
      disclaimerDisagreeButtonLabel: "不同意",
      disclaimerAgreeButtonLabel: "同意",
      disclaimerCancelButtonLabel: "取消",
      disclaimerConfirmButtonLabel: "接受",
      disclaimerTitle: "免责声明",
      lockedContentLabel: "仅适用于注册用户",
      loginOrRegisterLabel: "登录或者现在注册",
      isNewLabel: "新的",
      addToWatchlist: "加入观看列表",
      addedToWatchlist: "已添加至关注列表",
      tooltipTextShare: "分享",
      tooltipTextPrint: "打印",
      backLinkText: "后退",
      backToTopButtonText: "回到顶部",
      closeAllButtonText: "关闭所有",
      openAllButtonText: "全部打开",
      shareClassSelectLabel: "股份类别",
      emailInputLabelText: "电子邮件地址",
      emailInputHelperText: "请输入正确的电子邮件地址",
      date: "日期",
      startDate: "开始日期",
      endDate: "结束日期",
      doNotShowAgain: "不再显示",
      star: "星星",
      stars: "星星",
      outOfStars: "5星级",
      noContent: "无内容",
      results: "结果",
      result: "结果",
      search: "搜索",
      phone: "电话",
      email: "电子邮件",
      open: "打开",
      close: "关闭",
      monthly: "每月",
      quarterly: "季度",
      yearly: "每年",
      million: "百萬",
      billion: "十億",
      years: "年",
      year: "年"
    },
    mediaReleases: {
      searchBoxPlaceholder: "在媒体发布中搜索",
      noResults: "没有结果"
    },
    alertButton: {
      label: "订阅"
    },
    periodCalendar: {
      fromLabel: "从:",
      toLabel: "到:"
    },
    accordionContainer: {
      closeAll: "关闭所有",
      openAll: "全部打开"
    },
    premiumDiscountLineChart: {
      yAxisLabel: "溢价或折扣（基点"
    },
    premiumDiscountHistoricChart: {
      yAxisLabel: "天数",
      discount: "折扣",
      premium: "优质的",
      nav: "NAV"
    },
    stickyNavigation: {
      backToTopLinkText: "回到顶部",
      dataEventComponentName: "侧面导航",
      dataEventTitle: "跳跃标记 | 回到顶部",
      mobileNavigation: "手机导航"
    },
    contactCard: {
      mailto: "牛奶"
    },
    footNote: {
      link: "跳回脚注"
    },
    footNoteHeader: {
      link: "跳转到脚注"
    },
    breadcrumb: {
      shareButton: "选择股票类别",
      email: "发送邮件",
      scrollLeft: "向左滚动",
      scrollRight: "向右滚动"
    },
    dropDocuments: {
      button: "打开选择列表",
      allDocuments: "所有文件"
    },
    dwsCarousel: {
      backward: "上一页",
      forward: "下一页",
      page: "页"
    },
    megaMenu: {
      close: "关闭"
    },
    header: {
      search: "搜索",
      user: "用户",
      moreLinks: "展示更多",
      main: "主导航",
      toggleMenu: "切换菜单",
      audienceAndCultureText: "选择角色和位置",
      cultureText: "您的位置"
    },
    allocationChartCard: {
      showLess: "显示较少",
      showMore: "展示更多"
    },
    performanceChart: {
      close: "关闭",
      //remove after old component is eliminated
      calendarCloseTooltipText: "关闭",
      calendarTooltipText: "设定期间",
      downloadTooltipText: "下载",
      performanceToggleText: "表现在 %",
      priceToggleText: "NAV 历史",
      date: "日期",
      startDate: "开始日期",
      endDate: "结束日期",
      nav: "Nav",
      navPercent: "Nav %",
      indexLevel: "指数级别",
      indexLevelPercent: "指数级别 %",
      performanceYaxisLabel: "表现在 %",
      navYaxisLabel: "Nav",
      chartAriaLabel: "互动表现图",
      chartSeriesLabel: "图表系列标签",
      chartNavigatorGroupLabel: "用于选择日期范围的导航器句柄。",
      chartNavigatorHandlesLabelLeft: "左",
      chartNavigatorHandlesLabelRight: "右",
      chartNavigatorHandlesLabelEnd: "缩放句柄。"
    },
    fundsInFocus: {
      categoryLabel: "类别 / 投资者简介"
    },
    videoModule: {
      isRunningText: "现在正在运行",
      minutesShort: "分钟",
      playButton: "播放视频"
    },
    personDetailBlock: {
      biography: "传记",
      education: "教育",
      professionalCareer: "职业生涯",
      publications: "出版物"
    },
    publications: {
      loadMore: "装载更多"
    },
    newsletterTeaser: {
      invalidErrorTextHeading: "发生了错误",
      invalidErrorText: "处理您的请求时发生错误。 请再试一次"
    },
    baseActionMenu: {
      label: "动作菜单",
      itemSelected: "为了进行比较，该产品已移至列表顶部",
      itemRemoved: "为了进行比较，该产品已被移至列表顶部",
      markForComparison: "标记为比较",
      bookmark: "书签",
      bookmarked: "书签",
      removeCompare: "从比较中删除",
      openActionMenu: "打开操作菜单"
    },
    fundFinder: {
      periodLabel: "期间",
      periodHeadline: "更改期间",
      periodHint: "此处的更改也适用于其他与时间相关的设置。",
      otherFilters: "其他过滤器",
      deselectAll: "取消全选",
      fundSearchHeadline: "",
      fundSearchPlaceholder: "搜索",
      resetFilters: "重置所有过滤器",
      products: "产品",
      product: "产品",
      showProducts: "显示",
      downloadDocuments: "下载文档",
      addedCompareMessage: "为便于比较，该产品被移至列表顶部",
      removedCompareMessage: " 该产品已从列表顶部移除",
      addedBookmarkMessage: "产品已添加到您的关注列表",
      removedBookmarkMessage: "产品已从您的关注列表中移除",
      changeColumnView: "更改列视图"
    },
    productChartTeaser: {
      performance: "表现"
    },
    archivePage: {
      searchBoxPlaceholder: "在档案中搜索",
      loadMore: "装载更多",
      filters: "过滤器",
      resetFilters: "重置所有筛选器",
      otherFilters: "其他过滤器"
    },
    teaser: {
      new: "新的"
    },
    baseResultView: {
      listViewTitle: "列表显示",
      gridViewTitle: "网格视图"
    },
    showMoreLessToggle: {
      showMoreText: "显示更多",
      showLessText: "显示更少"
    },
    searchResultPage: {
      searchResultPagePlaceholder: "搜索",
      resultsFor: "结果",
      filterBy: "过滤",
      sortBy: "排序方式"
    },
    baseNonRemovableFilters: {
      edit: "编辑"
    },
    baseRemovableFilters: {
      removeFilter: "删除过滤器"
    },
    tabContainer: {
      requiresLogin: "需要登录"
    },
    propertyTeaser: {
      gallery: "画廊",
      images: "图片"
    },
    propertyGallery: {
      map: "地图",
      filters: "过滤器",
      marketValue: "市场价值",
      acquisitionYear: "购置年份",
      location: "地点",
      resultText: "财产",
      resultsText: "财产",
      loadMore: "加载更多"
    },
    sortOptions: {
      sortByLabel: "排序方式",
      nameAsc: "名称升序",
      nameDesc: "名称降序",
      priceAsc: "价格升序",
      priceDesc: "价格降序",
      acquisitionYearAsc: "购置年份升序",
      acquisitionYearDesc: "购置年份降序"
    },
    propertyKeyValues: {
      type: "类型",
      purchasePrice: "购买价格",
      acquisitionYear: "收购年份",
      location: "位置"
    },
    baseGoogleMap: {
      mapType: "地图类型",
      streetView: "街道视图",
      zoomIn: "放大",
      zoomOut: "缩小",
      locationMarker: "选择"
    },
    documentList: {
      numberOfResultLabel: "文件"
    },
    literatureLibrary: {
      searchBoxPlaceholder: "搜索产品"
    },
    baseTreeSelect: {
      placeholder: "搜索",
      emptyMessage: "未找到招股说明书或报告",
      triggerAriaLabel: "打开选择列表"
    },
    faqPage: {
      expandAll: "展开所有答案",
      closeAll: "关闭所有答案",
      searchPlaceholder: "在常见问题中搜索",
      result: "结果",
      results: "结果",
      noResults: "没有结果",
      searchResults: "搜索结果"
    },
    glossary: {
      expandAll: "展开所有答案",
      closeAll: "关闭所有答案",
      searchPlaceholder: "在词汇表中搜索",
      result: "结果",
      results: "结果",
      noResults: "没有结果",
      showAllResults: "显示所有结果",
      chooseOption: "选择一个选项"
    },
    eventList: {
      date: "日期",
      event: "事件",
      time: "时间",
      download: "下载"
    },
    quizAndPoll: {
      explanationHeadlineCorrect: "太棒了，您的答案是正确的。",
      explanationHeadlineInCorrect: "很抱歉，您的答案并不完全正确。",
      socialLabel: "分享："
    },
    marketDataBlock: {
      intraday: "当日"
    },
    search: {
      showAllResults: "显示所有结果"
    },
    imageGalleryTeaser: {
      gallery: "在画廊中打开"
    },
    documentViewer: {
      documentView: "PDF文档查看",
      loading: "加载文档"
    },
    productBuyingProcess: {
      searchBoxPlaceholder: "搜索您的产品",
      continueToPartner: "继续到合作伙伴"
    },
    coloredNumber: {
      default: "默认",
      positive: "正面",
      negative: "负面"
    },
    footer: {
      contact: "联系",
      showContactInformation: "显示联系信息",
      changeAudienceAndCulture: "更改角色和语言",
      changeCulture: "更改语言",
      legalAndPolicyLinks: "法律和政策链接"
    },
    calendarPage: {
      icalDownload: "下载 {eventTitle} 事件的 iCal 文件"
    },
    riskDisclaimer: {
      showDisclaimer: "显示风险声明",
      hideDisclaimer: "隐藏风险声明"
    },
    crociCompanyOverviewPage: {
      searchBoxPlaceholder: "搜索公司名称或股票代码"
    },
    crociCompanyDetailPage: {
      showAll: "显示全部",
      showLess: "显示较少",
      ticker: {
        ticker: "股票代码：",
        category: "类别：",
        sharePrice: "股价："
      },
      zoomChart: "打开图表详细信息"
    },
    calculatorOutputCard: {
      inflationInfoText: "经过 <b>{years} 年</b>，您的 <b>{value}</b> 资本将失去购买力：</b>",
      investmentInfoText: "您的投资",
      valueDevelopment: "价值发展",
      regularInvestment: "总常规投资",
      initialInvestment: "初始投资",
      purchasingPower: "单个价值",
      investmentChartTitle: "投资图表数据",
      inflationChartTitle: "通货膨胀图表数据"
    },
    calculationArea: {
      calculationButtonLabel: "计算",
      optionButtonLabel: "更多选项",
      optionButtonLabelLess: "更少的选择",
      restartButtonLabel: "重新开始",
      currentInflationRateLabel: "使用当前通货膨胀率"
    }
  },
  "zh-CN": {
    Accept: "接受",
    Cancel: "取消",
    typography: {
      disclaimer: "DWS 免責聲明：債券投資在不同程度上受利率、信用、流動性和市場風險的影響。一般來說，當利率上升時，債券價格會下跌。信用風險是指發行人按時支付本金和利息的能力。投資於低質量（垃圾債券）或未評級的證券相比於投資於高質量證券，面臨更高的損失風險。地方政府發行的證券面臨訴訟、法律及其他政治事件、當地商業或經濟條件等風險，發行人的破產可能會對本金和/或利息的支付能力產生重大影響。地方債券的市場流動性可能低於應稅債券，且關於地方政府發行人的財務狀況可獲得的信息可能少於公共公司。投資衍生品涉及流動性、槓桿和信用的特殊風險，這些風險可能會增加波動性或降低回報。基金尋求免除部分加州和聯邦所得稅的收益。然而，基金分配可能會受到聯邦、州或地方稅的影響，包括替代最低稅。欲了解更多詳情，請參閱基金說明書。日期：2022年9月8日。",
      pageHeadline: "頁面標題 h1：DWS 2022年9月8日資料",
      h2Headline: "頁面標題 h2：DWS 2022年9月8日資料",
      sectionH2Headline: "段落標題 h2：2022年9月8日資料",
      h3Headline: "頁面標題 h3：DWS 2022年9月8日資料",
      h4Headline: "頁面標題 h4：DWS 2022年9月8日資料",
      copyHeadline: "標題：2022年9月8日資料",
      copyText: "文本：2022年9月8日資料",
      copyTextBold: "文本：2022年9月8日資料",
      labelGerman: "德語",
      labelEnglish: "英語",
      labelChinese: "中文",
      labelJapanese: "日文"
    },
    baseSearchBox: {
      resultEventComponentName: "文本链接（同一页）"
    },
    audioModule: {
      play: "播放"
    },
    allocationChart: {
      card: {
        othersText: "其他的"
      }
    },
    teaserWww: {
      countrySelectorTitle: "选择地点",
      countryDropdownPlaceholder: "选择地点",
      countryDropdownFilterPlaceholder: "在此输入文字..."
    },
    shareButton: {
      label: "分享"
    },
    productHeader: {
      allDocuments: "所有文件"
    },
    entryGate: {
      productSearchLabel: "输入您的产品",
      countryLabel: "选择您的位置",
      audienceLabel: "选择您的角色",
      inputPlaceholder: "ISIN",
      inputInvalidText: "无效的 ISIN",
      productLabel: "您的产品",
      relationshipLabel: "选择您的业务关系",
      existingInvestorLabel: "我是现有投资者",
      nonExistingInvestorLabel: "我不是现有投资者",
      countryDropdownFilterPlaceholder: "在此输入文字...",
      countryDropdownPlaceholder: "选择一个国家"
    },
    dataTable: {
      pageReportTemplate: "显示 {first} 到 {last} 个条目 共 {totalRecords} 个",
      sortedAscending: "按升序排序",
      sortedDescending: "按降序排序"
    },
    dataCards: {
      showMoreValues: "显示更多值",
      showLessValues: "显示更少值",
      loadMore: "装载更多:",
      sortBy: "排序方式",
      apply: "申请",
      ascending: "上升",
      descending: "下降"
    },
    paginator: {
      pageReportTemplate: "{first} - {last} 的 {totalRecords}",
      rowsPerPageLabel: "參賽作品"
    },
    downloads: {
      fallbackText: "目前没有可用的下载"
    },
    baseSlider: {
      navBackward: "向后导航",
      navForward: "向前导航",
      navToPage: "导航到页面"
    },
    historicalData: {
      waitMessage: "准备下载",
      failedMessage: "下载失败"
    },
    showMoreShowLess: {
      showMoreText: "展示更多",
      showLessText: "显示较少"
    },
    globalTranslations: {
      yes: "是",
      no: "没有",
      submit: "提交",
      copyButton: "复制",
      copiedButton: "已复制!",
      clear: "Delete",
      disclaimerDisagreeButtonLabel: "不同意",
      disclaimerAgreeButtonLabel: "同意",
      disclaimerCancelButtonLabel: "取消",
      disclaimerConfirmButtonLabel: "接受",
      disclaimerTitle: "免责声明",
      lockedContentLabel: "仅适用于注册用户",
      loginOrRegisterLabel: "登录或者现在注册",
      isNewLabel: "新的",
      addToWatchlist: "加入观看列表",
      addedToWatchlist: "已添加至关注列表",
      tooltipTextShare: "分享",
      tooltipTextPrint: "打印",
      backLinkText: "后退",
      backToTopButtonText: "回到顶部",
      closeAllButtonText: "关闭所有",
      openAllButtonText: "全部打开",
      shareClassSelectLabel: "股份类别",
      emailInputLabelText: "电子邮件地址",
      emailInputHelperText: "请输入正确的电子邮件地址",
      date: "日期",
      startDate: "开始日期",
      endDate: "结束日期",
      doNotShowAgain: "不再显示",
      star: "星星",
      stars: "星星",
      outOfStars: "5星级",
      noContent: "无内容",
      results: "结果",
      result: "结果",
      search: "搜索",
      phone: "电话",
      email: "电子邮件",
      open: "打开",
      close: "关闭",
      monthly: "每月",
      quarterly: "季度",
      yearly: "每年",
      million: "百萬",
      billion: "十億",
      years: "年",
      year: "年"
    },
    mediaReleases: {
      searchBoxPlaceholder: "在媒体发布中搜索",
      noResults: "没有结果"
    },
    alertButton: {
      label: "订阅"
    },
    periodCalendar: {
      fromLabel: "从:",
      toLabel: "到:"
    },
    accordionContainer: {
      closeAll: "关闭所有",
      openAll: "全部打开"
    },
    premiumDiscountLineChart: {
      yAxisLabel: "溢价或折扣（基点"
    },
    premiumDiscountHistoricChart: {
      yAxisLabel: "天数",
      discount: "折扣",
      premium: "优质的",
      nav: "NAV"
    },
    stickyNavigation: {
      backToTopLinkText: "回到顶部",
      dataEventComponentName: "侧面导航",
      dataEventTitle: "跳跃标记 | 回到顶部",
      mobileNavigation: "手机导航"
    },
    contactCard: {
      mailto: "牛奶"
    },
    footNote: {
      link: "跳回脚注"
    },
    footNoteHeader: {
      link: "跳转到脚注"
    },
    breadcrumb: {
      shareButton: "选择股票类别",
      email: "发送邮件",
      scrollLeft: "向左滚动",
      scrollRight: "向右滚动"
    },
    dropDocuments: {
      button: "打开选择列表",
      allDocuments: "所有文件"
    },
    dwsCarousel: {
      backward: "上一页",
      forward: "下一页",
      page: "页"
    },
    megaMenu: {
      close: "关闭"
    },
    header: {
      search: "搜索",
      user: "用户",
      moreLinks: "展示更多",
      main: "主导航",
      toggleMenu: "切换菜单",
      audienceAndCultureText: "选择角色和位置",
      cultureText: "您的位置"
    },
    allocationChartCard: {
      showLess: "显示较少",
      showMore: "展示更多"
    },
    performanceChart: {
      close: "关闭",
      //remove after old component is eliminated
      calendarCloseTooltipText: "关闭",
      calendarTooltipText: "设定期间",
      downloadTooltipText: "下载",
      performanceToggleText: "表现在 %",
      priceToggleText: "NAV 历史",
      date: "日期",
      startDate: "开始日期",
      endDate: "结束日期",
      nav: "Nav",
      navPercent: "Nav %",
      indexLevel: "指数级别",
      indexLevelPercent: "指数级别 %",
      performanceYaxisLabel: "表现在 %",
      navYaxisLabel: "Nav",
      chartAriaLabel: "互动表现图",
      chartSeriesLabel: "圖表系列標籤",
      chartNavigatorGroupLabel: "用於選擇日期範圍的導航器手柄。",
      chartNavigatorHandlesLabelLeft: "左",
      chartNavigatorHandlesLabelRight: "右",
      chartNavigatorHandlesLabelEnd: "h縮放句柄。"
    },
    fundsInFocus: {
      categoryLabel: "类别 / 投资者简介"
    },
    videoModule: {
      isRunningText: "现在正在运行",
      minutesShort: "分钟",
      playButton: "播放视频"
    },
    personDetailBlock: {
      biography: "传记",
      education: "教育",
      professionalCareer: "职业生涯",
      publications: "出版物"
    },
    publications: {
      loadMore: "装载更多"
    },
    newsletterTeaser: {
      invalidErrorTextHeading: "发生了错误",
      invalidErrorText: "处理您的请求时发生错误。 请再试一次"
    },
    baseActionMenu: {
      label: "动作菜单",
      itemSelected: "为了进行比较，该产品已移至列表顶部",
      itemRemoved: "为了进行比较，该产品已被移至列表顶部",
      markForComparison: "标记为比较",
      bookmark: "书签",
      bookmarked: "书签",
      removeCompare: "从比较中删除",
      openActionMenu: "打开操作菜单"
    },
    fundFinder: {
      periodLabel: "期间",
      periodHeadline: "更改期间",
      periodHint: "此处的更改也适用于其他与时间相关的设置。",
      otherFilters: "其他过滤器",
      deselectAll: "取消全选",
      fundSearchHeadline: "",
      fundSearchPlaceholder: "搜索",
      resetFilters: "重置所有过滤器",
      products: "产品",
      product: "产品",
      showProducts: "显示",
      downloadDocuments: "下载文档",
      addedCompareMessage: "为便于比较，该产品被移至列表顶部",
      removedCompareMessage: " 该产品已从列表顶部移除",
      addedBookmarkMessage: "产品已添加到您的关注列表",
      removedBookmarkMessage: "产品已从您的关注列表中移除",
      changeColumnView: "更改列视图"
    },
    productChartTeaser: {
      performance: "表现"
    },
    archivePage: {
      searchBoxPlaceholder: "在档案中搜索",
      loadMore: "装载更多",
      filters: "过滤器",
      resetFilters: "重置所有筛选器",
      otherFilters: "其他过滤器"
    },
    teaser: {
      new: "新的"
    },
    baseResultView: {
      listViewTitle: "列表显示",
      gridViewTitle: "网格视图"
    },
    showMoreLessToggle: {
      showMoreText: "显示更多",
      showLessText: "显示更少"
    },
    searchResultPage: {
      searchResultPagePlaceholder: "搜索",
      resultsFor: "結果",
      filterBy: "過濾",
      sortBy: "排序方式"
    },
    baseNonRemovableFilters: {
      edit: "编辑"
    },
    baseRemovableFilters: {
      removeFilter: "删除过滤器"
    },
    tabContainer: {
      requiresLogin: "需要登录"
    },
    propertyTeaser: {
      gallery: "画廊",
      images: "图片"
    },
    propertyGallery: {
      map: "地图",
      filters: "过滤器",
      marketValue: "市场价值",
      acquisitionYear: "购置年份",
      location: "地点",
      resultText: "财产",
      resultsText: "财产",
      loadMore: "加载更多"
    },
    sortOptions: {
      sortByLabel: "排序方式",
      nameAsc: "名称升序",
      nameDesc: "名称降序",
      priceAsc: "价格升序",
      priceDesc: "价格降序",
      acquisitionYearAsc: "购置年份升序",
      acquisitionYearDesc: "购置年份降序"
    },
    propertyKeyValues: {
      type: "类型",
      purchasePrice: "购买价格",
      acquisitionYear: "收购年份",
      location: "位置"
    },
    baseGoogleMap: {
      mapType: "地图类型",
      streetView: "街道视图",
      zoomIn: "放大",
      zoomOut: "缩小",
      locationMarker: "选择"
    },
    documentList: {
      numberOfResultLabel: "文件"
    },
    literatureLibrary: {
      searchBoxPlaceholder: "搜索产品"
    },
    baseTreeSelect: {
      placeholder: "搜索",
      emptyMessage: "未找到招股说明书或报告",
      triggerAriaLabel: "打开选择列表"
    },
    faqPage: {
      expandAll: "展开所有答案",
      closeAll: "关闭所有答案",
      searchPlaceholder: "在常见问题中搜索",
      result: "结果",
      results: "结果",
      noResults: "没有结果",
      searchResults: "搜索结果"
    },
    glossary: {
      expandAll: "展开所有答案",
      closeAll: "关闭所有答案",
      searchPlaceholder: "在词汇表中搜索",
      result: "结果",
      results: "结果",
      noResults: "没有结果",
      showAllResults: "显示所有结果",
      chooseOption: "选择一个选项"
    },
    eventList: {
      date: "日期",
      event: "事件",
      time: "时间",
      download: "下载"
    },
    quizAndPoll: {
      explanationHeadlineCorrect: "太棒了，您的答案是正确的。",
      explanationHeadlineInCorrect: "很抱歉，您的答案并不完全正确。",
      socialLabel: "分享："
    },
    marketDataBlock: {
      intraday: "当日"
    },
    search: {
      showAllResults: "显示所有结果"
    },
    imageGalleryTeaser: {
      gallery: "在画廊中打开"
    },
    documentViewer: {
      documentView: "PDF文档查看",
      loading: "加载文档"
    },
    productBuyingProcess: {
      searchBoxPlaceholder: "搜索您的产品",
      continueToPartner: "继续到合作伙伴"
    },
    coloredNumber: {
      default: "默认",
      positive: "正面",
      negative: "负面"
    },
    footer: {
      contact: "联系",
      showContactInformation: "显示联系信息",
      changeAudienceAndCulture: "更改角色和语言",
      changeCulture: "更改语言",
      legalAndPolicyLinks: "法律和政策链接"
    },
    calendarPage: {
      icalDownload: "下载 {eventTitle} 事件的 iCal 文件"
    },
    riskDisclaimer: {
      showDisclaimer: "显示风险声明",
      hideDisclaimer: "隐藏风险声明"
    },
    crociCompanyOverviewPage: {
      searchBoxPlaceholder: "搜尋公司名稱或股票代碼"
    },
    crociCompanyDetailPage: {
      showAll: "显示全部",
      showLess: "显示较少",
      ticker: {
        ticker: "股票代码：",
        category: "类别：",
        sharePrice: "股价："
      },
      zoomChart: "打开图表详细信息"
    },
    calculatorOutputCard: {
      inflationInfoText: "经过 <b>{years} 年</b>，您的 <b>{value}</b> 资本将失去购买力：",
      investmentInfoText: "您的投资",
      valueDevelopment: "价值发展",
      regularInvestment: "总常规投资",
      initialInvestment: "初始投资",
      purchasingPower: "单个价值",
      investmentChartTitle: "投資圖表資料",
      inflationChartTitle: "通貨膨脹圖表資料"
    },
    calculationArea: {
      calculationButtonLabel: "计算",
      optionButtonLabel: "更多选项",
      optionButtonLabelLess: "更少的选择",
      restartButtonLabel: "重新开始",
      currentInflationRateLabel: "使用当前通货膨胀率"
    }
  },
  "zh-HK": {
    Accept: "接受",
    Cancel: "取消",
    typography: {
      disclaimer: "DWS 免責聲明：債券投資在不同程度上受利率、信用、流動性和市場風險的影響。一般來說，當利率上升時，債券價格會下跌。信用風險是指發行人按時支付本金和利息的能力。投資於低質量（垃圾債券）或未評級的證券相比於投資於高質量證券，面臨更高的損失風險。地方政府發行的證券面臨訴訟、法律及其他政治事件、當地商業或經濟條件等風險，發行人的破產可能會對本金和/或利息的支付能力產生重大影響。地方債券的市場流動性可能低於應稅債券，且關於地方政府發行人的財務狀況可獲得的信息可能少於公共公司。投資衍生品涉及流動性、槓桿和信用的特殊風險，這些風險可能會增加波動性或降低回報。基金尋求免除部分加州和聯邦所得稅的收益。然而，基金分配可能會受到聯邦、州或地方稅的影響，包括替代最低稅。欲了解更多詳情，請參閱基金說明書。日期：2022年9月8日。",
      pageHeadline: "頁面標題 h1：DWS 2022年9月8日資料",
      h2Headline: "頁面標題 h2：DWS 2022年9月8日資料",
      sectionH2Headline: "段落標題 h2：2022年9月8日資料",
      h3Headline: "頁面標題 h3：DWS 2022年9月8日資料",
      h4Headline: "頁面標題 h4：DWS 2022年9月8日資料",
      copyHeadline: "標題：2022年9月8日資料",
      copyText: "文本：2022年9月8日資料",
      copyTextBold: "文本：2022年9月8日資料",
      labelGerman: "德語",
      labelEnglish: "英語",
      labelChinese: "中文",
      labelJapanese: "日文"
    },
    baseSearchBox: {
      resultEventComponentName: "文本链接（同一页）"
    },
    audioModule: {
      play: "播放"
    },
    allocationChart: {
      card: {
        othersText: "其他的"
      }
    },
    teaserWww: {
      countrySelectorTitle: "选择地点",
      countryDropdownPlaceholder: "选择地点",
      countryDropdownFilterPlaceholder: "在此输入文字..."
    },
    shareButton: {
      label: "分享"
    },
    productHeader: {
      allDocuments: "所有文件"
    },
    entryGate: {
      productSearchLabel: "输入您的产品",
      countryLabel: "选择您的位置",
      audienceLabel: "选择您的角色",
      inputPlaceholder: "ISIN",
      inputInvalidText: "无效的 ISIN",
      productLabel: "您的产品",
      relationshipLabel: "选择您的业务关系",
      existingInvestorLabel: "我是现有投资者",
      nonExistingInvestorLabel: "我不是现有投资者",
      countryDropdownFilterPlaceholder: "在此输入文字...",
      countryDropdownPlaceholder: "选择一个国家"
    },
    dataTable: {
      pageReportTemplate: "显示 {first} 到 {last} 个条目 共 {totalRecords} 个",
      sortedAscending: "按升序排序",
      sortedDescending: "按降序排序"
    },
    dataCards: {
      showMoreValues: "显示更多值",
      showLessValues: "显示更少值",
      loadMore: "装载更多:",
      sortBy: "排序方式",
      apply: "申请",
      ascending: "上升",
      descending: "下降"
    },
    paginator: {
      pageReportTemplate: "{first} - {last} 的 {totalRecords}",
      rowsPerPageLabel: "参赛作品"
    },
    downloads: {
      fallbackText: "目前没有可用的下载"
    },
    baseSlider: {
      navBackward: "向后导航",
      navForward: "向前导航",
      navToPage: "导航到页面"
    },
    historicalData: {
      waitMessage: "准备下载",
      failedMessage: "下载失败"
    },
    showMoreShowLess: {
      showMoreText: "展示更多",
      showLessText: "显示较少"
    },
    globalTranslations: {
      yes: "是",
      no: "没有",
      submit: "提交",
      copyButton: "复制",
      copiedButton: "已复制!",
      clear: "Delete",
      disclaimerDisagreeButtonLabel: "不同意",
      disclaimerAgreeButtonLabel: "同意",
      disclaimerCancelButtonLabel: "取消",
      disclaimerConfirmButtonLabel: "接受",
      disclaimerTitle: "免责声明",
      lockedContentLabel: "仅适用于注册用户",
      loginOrRegisterLabel: "登录或者现在注册",
      isNewLabel: "新的",
      addToWatchlist: "加入观看列表",
      addedToWatchlist: "已添加至关注列表",
      tooltipTextShare: "分享",
      tooltipTextPrint: "打印",
      backLinkText: "后退",
      backToTopButtonText: "回到顶部",
      closeAllButtonText: "关闭所有",
      openAllButtonText: "全部打开",
      shareClassSelectLabel: "股份类别",
      emailInputLabelText: "电子邮件地址",
      emailInputHelperText: "请输入正确的电子邮件地址",
      date: "日期",
      startDate: "开始日期",
      endDate: "结束日期",
      doNotShowAgain: "不再显示",
      star: "星星",
      stars: "星星",
      outOfStars: "5星级",
      noContent: "无内容",
      results: "结果",
      result: "结果",
      search: "搜索",
      phone: "电话",
      email: "电子邮件",
      open: "打开",
      close: "关闭",
      monthly: "每月",
      quarterly: "季度",
      yearly: "每年",
      million: "百萬",
      billion: "十億",
      years: "年",
      year: "年"
    },
    mediaReleases: {
      searchBoxPlaceholder: "在媒体发布中搜索",
      noResults: "没有结果"
    },
    alertButton: {
      label: "订阅"
    },
    periodCalendar: {
      fromLabel: "从:",
      toLabel: "到:"
    },
    accordionContainer: {
      closeAll: "关闭所有",
      openAll: "全部打开"
    },
    premiumDiscountLineChart: {
      yAxisLabel: "溢价或折扣（基点"
    },
    premiumDiscountHistoricChart: {
      yAxisLabel: "天数",
      discount: "折扣",
      premium: "优质的",
      nav: "NAV"
    },
    stickyNavigation: {
      backToTopLinkText: "回到顶部",
      dataEventComponentName: "侧面导航",
      dataEventTitle: "跳跃标记 | 回到顶部",
      mobileNavigation: "手机导航"
    },
    contactCard: {
      mailto: "牛奶"
    },
    footNote: {
      link: "跳回脚注"
    },
    footNoteHeader: {
      link: "跳转到脚注"
    },
    breadcrumb: {
      shareButton: "选择股票类别",
      email: "发送邮件",
      scrollLeft: "向左滚动",
      scrollRight: "向右滚动"
    },
    dropDocuments: {
      button: "打开选择列表",
      allDocuments: "所有文件"
    },
    dwsCarousel: {
      backward: "上一页",
      forward: "下一页",
      page: "页"
    },
    megaMenu: {
      close: "关闭"
    },
    header: {
      search: "搜索",
      user: "用户",
      moreLinks: "展示更多",
      main: "主导航",
      toggleMenu: "切换菜单",
      audienceAndCultureText: "选择角色和位置",
      cultureText: "您的位置"
    },
    allocationChartCard: {
      showLess: "显示较少",
      showMore: "展示更多"
    },
    performanceChart: {
      close: "关闭",
      //remove after old component is eliminated
      calendarCloseTooltipText: "关闭",
      calendarTooltipText: "设定期间",
      downloadTooltipText: "下载",
      performanceToggleText: "表现在 %",
      priceToggleText: "NAV 历史",
      date: "日期",
      startDate: "开始日期",
      endDate: "结束日期",
      nav: "Nav",
      navPercent: "Nav %",
      indexLevel: "指数级别",
      indexLevelPercent: "指数级别 %",
      performanceYaxisLabel: "表现在 %",
      navYaxisLabel: "Nav",
      chartAriaLabel: "互动表现图",
      chartSeriesLabel: "图表系列标签",
      chartNavigatorGroupLabel: "用于选择日期范围的导航器句柄。",
      chartNavigatorHandlesLabelLeft: "左",
      chartNavigatorHandlesLabelRight: "右",
      chartNavigatorHandlesLabelEnd: "缩放句柄。"
    },
    fundsInFocus: {
      categoryLabel: "类别 / 投资者简介"
    },
    videoModule: {
      isRunningText: "现在正在运行",
      minutesShort: "分钟",
      playButton: "播放视频"
    },
    personDetailBlock: {
      biography: "传记",
      education: "教育",
      professionalCareer: "职业生涯",
      publications: "出版物"
    },
    publications: {
      loadMore: "装载更多"
    },
    newsletterTeaser: {
      invalidErrorTextHeading: "发生了错误",
      invalidErrorText: "处理您的请求时发生错误。 请再试一次"
    },
    baseActionMenu: {
      label: "动作菜单",
      itemSelected: "为了进行比较，该产品已移至列表顶部",
      itemRemoved: "为了进行比较，该产品已被移至列表顶部",
      markForComparison: "标记为比较",
      bookmark: "书签",
      bookmarked: "书签",
      removeCompare: "从比较中删除",
      openActionMenu: "打开操作菜单"
    },
    fundFinder: {
      periodLabel: "期间",
      periodHeadline: "更改期间",
      periodHint: "此处的更改也适用于其他与时间相关的设置。",
      otherFilters: "其他过滤器",
      deselectAll: "取消全选",
      fundSearchHeadline: "",
      fundSearchPlaceholder: "搜索",
      resetFilters: "重置所有过滤器",
      products: "产品",
      product: "产品",
      showProducts: "显示",
      downloadDocuments: "下载文档",
      addedCompareMessage: "为便于比较，该产品被移至列表顶部",
      removedCompareMessage: " 该产品已从列表顶部移除",
      addedBookmarkMessage: "产品已添加到您的关注列表",
      removedBookmarkMessage: "产品已从您的关注列表中移除 ",
      changeColumnView: "更改列视图"
    },
    productChartTeaser: {
      performance: "表現"
    },
    archivePage: {
      searchBoxPlaceholder: "在档案中搜索",
      loadMore: "装载更多",
      filters: "过滤器",
      resetFilters: "重置所有筛选器",
      otherFilters: "其他过滤器"
    },
    teaser: {
      new: "新的"
    },
    baseResultView: {
      listViewTitle: "列表显示",
      gridViewTitle: "网格视图"
    },
    showMoreLessToggle: {
      showMoreText: "显示更多",
      showLessText: "显示更少"
    },
    searchResultPage: {
      searchResultPagePlaceholder: "搜索",
      resultsFor: "结果",
      filterBy: "过滤",
      sortBy: "排序方式"
    },
    baseNonRemovableFilters: {
      edit: "编辑"
    },
    baseRemovableFilters: {
      removeFilter: "删除过滤器"
    },
    tabContainer: {
      requiresLogin: "需要登录"
    },
    propertyTeaser: {
      gallery: "画廊",
      images: "图片"
    },
    propertyGallery: {
      map: "地图",
      filters: "过滤器",
      marketValue: "市场价值",
      acquisitionYear: "购置年份",
      location: "地点",
      resultText: "财产",
      resultsText: "财产",
      loadMore: "加载更多"
    },
    sortOptions: {
      sortByLabel: "排序方式",
      nameAsc: "名称升序",
      nameDesc: "名称降序",
      priceAsc: "价格升序",
      priceDesc: "价格降序",
      acquisitionYearAsc: "购置年份升序",
      acquisitionYearDesc: "购置年份降序"
    },
    propertyKeyValues: {
      type: "类型",
      purchasePrice: "购买价格",
      acquisitionYear: "收购年份",
      location: "位置"
    },
    baseGoogleMap: {
      mapType: "地图类型",
      streetView: "街道视图",
      zoomIn: "放大",
      zoomOut: "缩小",
      locationMarker: "选择"
    },
    documentList: {
      numberOfResultLabel: "文件"
    },
    literatureLibrary: {
      searchBoxPlaceholder: "搜索产品"
    },
    baseTreeSelect: {
      placeholder: "搜索",
      emptyMessage: "未找到招股说明书或报告",
      triggerAriaLabel: "打开选择列表"
    },
    faqPage: {
      expandAll: "展开所有答案",
      closeAll: "关闭所有答案",
      searchPlaceholder: "在常见问题中搜索",
      result: "结果",
      results: "结果",
      noResults: "没有结果",
      searchResults: "搜索结果"
    },
    glossary: {
      expandAll: "展开所有答案",
      closeAll: "关闭所有答案",
      searchPlaceholder: "在词汇表中搜索",
      result: "结果",
      results: "结果",
      noResults: "没有结果",
      showAllResults: "显示所有结果",
      chooseOption: "选择一个选项"
    },
    eventList: {
      date: "日期",
      event: "事件",
      time: "时间",
      download: "下载"
    },
    quizAndPoll: {
      explanationHeadlineCorrect: "太棒了，您的答案是正确的。",
      explanationHeadlineInCorrect: "很抱歉，您的答案并不完全正确。",
      socialLabel: "分享："
    },
    marketDataBlock: {
      intraday: "当日"
    },
    search: {
      showAllResults: "显示所有结果"
    },
    imageGalleryTeaser: {
      gallery: "在画廊中打开"
    },
    documentViewer: {
      documentView: "PDF文档查看",
      loading: "加载文档"
    },
    productBuyingProcess: {
      searchBoxPlaceholder: "搜索您的产品",
      continueToPartner: "继续到合作伙伴"
    },
    coloredNumber: {
      default: "默认",
      positive: "正面",
      negative: "负面"
    },
    footer: {
      contact: "联系",
      showContactInformation: "显示联系信息",
      changeAudienceAndCulture: "更改角色和语言",
      changeCulture: "更改语言",
      legalAndPolicyLinks: "法律和政策链接"
    },
    calendarPage: {
      icalDownload: "下载 {eventTitle} 事件的 iCal 文件"
    },
    riskDisclaimer: {
      showDisclaimer: "显示风险声明",
      hideDisclaimer: "隐藏风险声明"
    },
    crociCompanyOverviewPage: {
      searchBoxPlaceholder: "搜尋公司名稱或股票代碼"
    },
    crociCompanyDetailPage: {
      showAll: "显示全部",
      showLess: "显示较少",
      ticker: {
        ticker: "股票代码：",
        category: "类别：",
        sharePrice: "股价："
      },
      zoomChart: "打开图表详细信息"
    },
    calculatorOutputCard: {
      inflationInfoText: "经过 <b>{years} 年，{value}</b> 的资本如下：",
      investmentInfoText: "您的投资",
      valueDevelopment: "价值发展",
      regularInvestment: "总常规投资",
      initialInvestment: "初始投资",
      purchasingPower: "单个价值",
      investmentChartTitle: "投资图表数据",
      inflationChartTitle: "通货膨胀图表数据"
    },
    calculationArea: {
      calculationButtonLabel: "计算",
      optionButtonLabel: "更多选项",
      optionButtonLabelLess: "更少的选择",
      restartButtonLabel: "重新开始",
      currentInflationRateLabel: "使用当前通货膨胀率"
    }
  }
};
var Bn = /* @__PURE__ */ ((e) => (e.UpdateDataTable = "UpdateDataTable", e.ChangedActionMenuItem = "changedActionMenuItem", e.DropDownForDataTableChanged = "dropDownForDataTableChanged", e.TimePeriodValueChanged = "handleTimePeriodValueChanged", e.TabHasChanged = "tabHasChanged", e.ResetFilters = "resetFilters", e.FilterValueChanged = "filterValueChanged", e.SearchTermHasChanged = "searchTermHasChanged", e.SearchTermBlurred = "searchTermBlurred", e.SearchTermFocus = "searchTermFocus", e.SearchTermClear = "searchTermClear", e.SearchTermFilterValueChanged = "SearchTermFilterValueChanged", e.SearchTermEnter = "searchTermEnter", e.AddBookmark = "addBookmark", e.RemoveBookmark = "removeBookmark", e))(Bn || {});
let fp;
const Ej = /* @__PURE__ */ Ha("fundFinder", {
  state: () => ({
    headline: "",
    introText: "",
    searchTerm: "",
    documentsPlaceholderText: null,
    filters: [],
    timePeriods: [],
    tabs: [],
    selectedTabIndex: 0,
    result: {},
    dropDownForDataTableItems: [],
    flyoutResults: {},
    selectedDropDownForDataTableItem: null,
    timePeriod: null,
    documents: null,
    footnoteComponentId: null,
    lockedItems: null,
    bookmarkedItems: null,
    footnoteType: null,
    submitLinkModel: {},
    sortedIdentifier: []
  }),
  getters: {
    topFilters: (e) => e?.filters?.filter((t) => t.isTopFilter),
    otherFilters: (e) => e?.filters?.filter((t) => !t.isTopFilter),
    selectedTimePeriod: (e) => e?.timePeriods?.find((t) => t.isSelected) ?? null,
    nonRemovableFilters: (e) => e?.filters?.filter((t) => !t.isRemovable),
    selectedRemovableFilters: (e) => e?.filters?.filter((t) => t.isRemovable && t.isSelected),
    selectedOptionsByFilter: () => (e) => e?.filterOptions[e.identifier]?.filter(
      (t) => t.isSelected
    ),
    selectedFiltersNumber: (e) => e?.filters?.filter((t) => t.isSelected)?.length
  },
  actions: {
    initStore(e, t, n, i, o, a, r, s, l, d, y, u, m, h, c, g, v, P, f) {
      this.headline = e, this.introText = t, this.searchTerm = n, this.filters = i, this.timePeriods = o, this.tabs = a, this.selectedTabIndex = r, this.result = s, this.dropDownForDataTableItems = l ?? [], this.selectedDropDownForDataTableItem = d, this.flyoutResults = y, this.documents = u, this.documentsPlaceholderText = m, this.footnoteComponentId = h, this.lockedItems = c, this.bookmarkedItems = g, this.footnoteType = v, fp = P, this.submitLinkModel = f;
    },
    deselectFilterOption(e, t) {
      this.filters?.forEach((n) => {
        n.identifier === e && n.filterOptions[n.identifier].forEach((i) => {
          i.identifier === t && (i.isSelected = !1);
        });
      }), this.filters?.forEach((n) => {
        if (n.identifier === e) {
          let i = !1;
          n.filterOptions[n.identifier].forEach((o) => {
            o.isSelected && (i = !0);
          }), i || (n.isSelected = !1);
        }
      });
    },
    deselectAllOptions(e) {
      this?.filters?.forEach((t) => {
        t.identifier === e && (t.isSelected = !1, t.filterOptions[t.identifier].forEach((n) => {
          n.isSelected = !1;
        }));
      });
    },
    setSortedIdentifier(e) {
      this.sortedIdentifier = e;
    },
    adoptSortingByIdentifier(e) {
      const t = io();
      !e.lazy && this.result?.values && e.values.length > 0 && this.sortedIdentifier.length > 0 && e.values.sort((n, i) => {
        const o = this.sortedIdentifier.indexOf(
          t.getIdentifier(n)
        ), a = this.sortedIdentifier.indexOf(
          t.getIdentifier(i)
        );
        return o - a;
      });
    },
    async onSearchCriteriaChanged(e) {
      if (this.selectedTabIndex = e.selectedTabIndex, this.setTimePeriod(e.timePeriod), fp) {
        const t = await fp(e);
        this.adoptSortingByIdentifier(t.dataTableResult);
        const n = io(), i = t.dataTableResult.id;
        e.lazyLoadDataTableUpdateEventData && (n.setSortKey(
          i,
          e.lazyLoadDataTableUpdateEventData.sortField
        ), n.setSortOrder(
          i,
          e.lazyLoadDataTableUpdateEventData.sortOrder || 0
        ), n.setPage(
          i,
          e.lazyLoadDataTableUpdateEventData.page
        ), n.setRowsPerPage(
          i,
          e.lazyLoadDataTableUpdateEventData.rowsPerPage
        )), e.eventType === "tabHasChanged" && this.adoptLockedItemToNewTable(
          this.result.id,
          t.dataTableResult
        ), this.adoptBookmarks(
          t.dataTableResult,
          e.bookmarkedItems
        ), this.result = t.dataTableResult, this.flyoutResults = t.flyoutResults;
      }
    },
    adoptBookmarks(e, t) {
      const n = io();
      t?.forEach((i) => {
        const o = n.getIdentifier(i);
        if (o) {
          const a = e.values.find((r) => n.getIdentifier(r) === o);
          if (a) {
            const r = n.getActionMenuKey(a);
            r && (a[r].value = i[r].value);
          }
        }
      });
    },
    adoptLockedItemToNewTable(e, t) {
      const n = io(), i = n.getLockedItems(e), o = n.getLockedItems(t.id);
      i.forEach((a) => {
        const r = n.getIdentifier(a);
        if (r) {
          const s = t.values.find((d) => n.getIdentifier(d) === r), l = o.some((d) => n.getIdentifier(d) === r);
          if (s && !l) {
            const d = n.getActionMenuKey(a);
            s[d].value = a[d].value, n.addLockedItem(t.id, s);
          }
        }
      });
    },
    selectDropDownForDataTableItem(e) {
      this.selectedDropDownForDataTableItem = e;
    },
    setTimePeriod(e) {
      this.timePeriods?.forEach((t) => {
        t.isSelected = t.identifier === e?.identifier;
      });
    },
    setDropDownForDataTableItems(e) {
      this.dropDownForDataTableItems = e;
    },
    setResult(e) {
      this.result = e;
    },
    hasSelectedOptions(e) {
      let t = !1;
      return e.filterOptions[e.identifier]?.forEach(
        (n) => {
          n.isSelected && (t = !0);
        }
      ), t;
    },
    resetAllFilters() {
      this?.filters?.forEach((e) => {
        e.isRemovable && (e.isSelected = !1, e.filterOptions[e.identifier]?.forEach((t) => {
          t.isSelected = !1;
        }));
      });
    }
  }
});
var Pi = /* @__PURE__ */ ((e) => (e.SearchTermHasChanged = "searchTermHasChanged", e.SearchTermClear = "searchTermClear", e.SearchTermEnter = "searchTermEnter", e.ResetFilters = "resetFilters", e.FilterValueChanged = "filterValueChanged", e.PageChanged = "pageChanged", e.RowsPerPageChanged = "rowsPerPageChanged", e))(Pi || {});
let Sd;
const Dj = /* @__PURE__ */ Ha("archivePage", {
  state: () => ({
    headline: "",
    introText: "",
    searchTerm: "",
    filters: [],
    flyoutResults: {},
    notificationItems: [],
    results: [],
    showGridFirst: !1,
    lazy: !1,
    noResultsText: "",
    totalItemsCount: 0,
    hideSearchBar: !1
  }),
  getters: {
    selectedFilters: (e) => e?.filters?.filter((t) => t.isSelected).map((t) => t.name),
    selectedRemovableFilters: (e) => e?.filters?.filter((t) => t.isRemovable && t.isSelected),
    selectedFiltersNumber: (e) => e?.filters?.filter((t) => t.isSelected)?.length
  },
  actions: {
    initStore(e, t, n, i, o, a, r, s, l, d, y, u) {
      this.headline = e, this.introText = t, this.searchTerm = n, this.filters = i, this.flyoutResults = o, this.results = a, this.showGridFirst = r, this.lazy = s, this.noResultsText = l, this.totalItemsCount = d, Sd = y, this.hideSearchBar = u;
    },
    resetStore() {
      this.headline = "", this.introText = "", this.searchTerm = "", this.filters = [], this.flyoutResults = {}, this.results = [], this.showGridFirst = !1, this.lazy = !1, this.noResultsText = "", this.totalItemsCount = 0, Sd = () => new Promise(() => ({
        results: [],
        flyouts: {},
        filters: [],
        totalItemsCount: Number
      })), this.hideSearchBar = !1;
    },
    resetAllFilters() {
      this.filters?.forEach((e) => {
        e.isRemovable && (e.isSelected = !1, e.filterOptions[e.identifier]?.forEach((t) => {
          t.isSelected = !1;
        }));
      });
    },
    async onSearchCriteriaChanged(e) {
      if (Sd) {
        const t = await Sd(
          e
        );
        this.results = t.results, this.flyoutResults = t.flyouts, this.filters = t.filters, this.totalItemsCount = t.totalItemsCount;
      }
    },
    deselectFilterOption(e, t) {
      this.filters?.forEach((n) => {
        n.identifier === e && n.filterOptions[n.identifier]?.forEach((i) => {
          i.identifier === t && (i.isSelected = !1);
        });
      }), this.filters?.forEach((n) => {
        if (n.identifier === e) {
          let i = !1;
          n.filterOptions[n.identifier]?.forEach((o) => {
            o.isSelected && (i = !0);
          }), i || (n.isSelected = !1);
        }
      });
    },
    deselectAllOptions(e) {
      this.filters?.forEach((t) => {
        t.identifier === e && (t.isSelected = !1, t.filterOptions[t.identifier]?.forEach((n) => {
          n.isSelected = !1;
        }));
      });
    }
  }
});
var $i = /* @__PURE__ */ ((e) => (e.SearchTermHasChanged = "searchTermHasChanged", e.SearchTermClear = "searchTermClear", e.SearchTermEnter = "searchTermEnter", e.FilterValueChanged = "filterValueChanged", e.ShowAllTriggered = "showAllTriggered", e.SortValueChanged = "sortValueChanged", e.ActiveTabChanged = "activeTabChanged", e.PageChanged = "pageChanged", e.RowsPerPageChanged = "rowsPerPageChanged", e))($i || {});
let mp;
const og = /* @__PURE__ */ Ha("searchResultPage", {
  state: () => ({
    searchTerm: "",
    searchTermOfLastSearch: void 0,
    selectedTabIndex: 0,
    flyoutResults: {},
    results: [],
    filters: void 0,
    submitLinkModel: {}
  }),
  actions: {
    initStore(e, t, n, i, o, a, r) {
      this.searchTerm = e, this.searchTermOfLastSearch = e, this.selectedTabIndex = t, this.flyoutResults = n, this.results = i, this.filters = o, mp = a, this.submitLinkModel = r;
    },
    clearStore() {
      this.searchTerm = "", this.searchTermOfLastSearch = void 0, this.selectedTabIndex = 0, this.flyoutResults = {}, this.results = [], this.filters = void 0, this.submitLinkModel = {};
    },
    async onSearchCriteriaChanged(e) {
      if (mp) {
        const t = await mp(
          e
        );
        this.selectedTabIndex = e.selectedTabIndex, this.results = t.results, this.flyoutResults = t.flyouts, this.filters = t.filters;
      }
    },
    setNewSelectedFilter(e) {
      this.filters.filter = {
        ...this.filters.filter,
        name: e.name,
        results: e.results,
        isSelected: !0,
        filterOptions: this.filters.filter.filterOptions?.map((t) => ({
          ...t,
          isSelected: t.name === e.name
        }))
      };
    }
  }
});
var or = /* @__PURE__ */ ((e) => (e.SearchTermHasChanged = "searchTermHasChanged", e.SearchTermBlur = "searchTermBlur", e.SearchTermClear = "searchTermClear", e.SearchTermFilterValueChanged = "SearchTermFilterValueChanged", e.SearchTermEnter = "searchTermEnter", e))(or || {});
let Cd;
const Rj = /* @__PURE__ */ Ha("literatureLibrary", {
  state: () => ({
    filters: [],
    searchTerm: "",
    flyoutResults: {},
    documentList: {}
  }),
  getters: {
    selectedFilters: (e) => e?.filters?.filter((t) => t.isSelected).map((t) => t.name),
    selectedRemovableFilters: (e) => e?.filters?.filter((t) => t.isRemovable && t.isSelected),
    selectedFiltersNumber: (e) => e?.filters?.filter((t) => t.isSelected)?.length
  },
  actions: {
    initStore(e, t, n, i, o) {
      this.filters = e, this.flyoutResults = t, this.documentList = n, this.searchTerm = i, Cd = o;
    },
    resetStore() {
      this.filters = [], this.flyoutResults = {}, this.documentList = {}, Cd = () => new Promise(() => ({
        results: [],
        flyouts: {},
        documentList: {}
      }));
    },
    resetAllFilters() {
      this.filters?.forEach((e) => {
        e.isRemovable && (e.isSelected = !1, e.filterOptions[e.identifier]?.forEach((t) => {
          t.isSelected = !1;
        }));
      });
    },
    deselectFilterOption(e, t) {
      this.filters?.forEach((n) => {
        n.identifier === e && n.filterOptions[n.identifier]?.forEach((i) => {
          i.identifier === t && (i.isSelected = !1);
        });
      }), this.filters?.forEach((n) => {
        if (n.identifier === e) {
          let i = !1;
          n.filterOptions[n.identifier]?.forEach((o) => {
            o.isSelected && (i = !0);
          }), i || (n.isSelected = !1);
        }
      });
    },
    async onSearchCriteriaChanged(e) {
      if (Cd) {
        const t = await Cd(
          e
        );
        this.filters = t.filters, this.flyoutResults = t.flyouts, this.documentList = t.documentList;
      }
    }
  }
});
let Td;
const Nj = /* @__PURE__ */ Ha("propertyGallery", {
  state: () => ({
    filters: [],
    results: []
  }),
  getters: {
    selectedFilters: (e) => e?.filters?.filter((t) => t.isSelected).map((t) => t.name),
    selectedRemovableFilters: (e) => e?.filters?.filter((t) => t.isRemovable && t.isSelected),
    selectedFiltersNumber: (e) => e?.filters?.filter((t) => t.isSelected)?.length
  },
  actions: {
    initStore(e, t, n) {
      this.filters = e, this.results = t, Td = n;
    },
    resetStore() {
      this.filters = [], this.results = [], Td = () => new Promise(() => ({
        results: []
      }));
    },
    resetAllFilters() {
      this.filters?.forEach((e) => {
        e.isRemovable && (e.isSelected = !1, e.filterOptions[e.identifier]?.forEach((t) => {
          t.isSelected = !1;
        }));
      });
    },
    deselectFilterOption(e, t) {
      this.filters?.forEach((n) => {
        n.identifier === e && n.filterOptions[n.identifier]?.forEach((i) => {
          i.identifier === t && (i.isSelected = !1);
        });
      }), this.filters?.forEach((n) => {
        if (n.identifier === e) {
          let i = !1;
          n.filterOptions[n.identifier]?.forEach((o) => {
            o.isSelected && (i = !0);
          }), i || (n.isSelected = !1);
        }
      });
    },
    async onSearchCriteriaChanged(e) {
      if (Td) {
        const t = await Td(
          e
        );
        this.results = t.results, this.filters = t.filters;
      }
    }
  }
});
var fr = /* @__PURE__ */ ((e) => (e.SearchTermHasChanged = "searchTermHasChanged", e.SearchTermBlur = "searchTermBlur", e.SearchTermClear = "searchTermClear", e.SearchTermEnter = "searchTermEnter", e.FilterValueChanged = "filterValueChanged", e.SearchRecordClick = "searchRecordClick", e))(fr || {});
let Ld;
const $j = /* @__PURE__ */ Ha("MediaReleases", {
  state: () => ({
    searchTerm: "",
    filter: {},
    flyoutResults: {},
    results: [],
    showNumberOfResults: !1,
    selectedFilter: {}
  }),
  getters: {},
  actions: {
    initStore(e, t, n, i, o, a) {
      this.filter = e, this.flyoutResults = t, this.results = n, this.showNumberOfResults = i, this.searchTerm = o, Ld = a;
    },
    resetStore() {
      this.flyoutResults = {}, Ld = () => new Promise(() => ({
        filter: {},
        flyouts: {},
        results: [],
        showNumberOfResults: !1,
        selectedFilter: {}
      }));
    },
    async onSearchCriteriaChanged(e) {
      if (Ld) {
        const t = await Ld(
          e
        );
        this.filter = t.filter, this.flyoutResults = t.flyouts, this.results = t.results, this.showNumberOfResults = t.showNumberOfResults;
      }
    }
  }
});
var ga = /* @__PURE__ */ ((e) => (e.Bookmark = "bookmark", e.Compare = "compare", e))(ga || {}), Fj = `
@layer primevue {
    .p-overlaypanel {
        margin-top: 10px;
    }

    .p-overlaypanel-flipped {
        margin-top: 0;
        margin-bottom: 10px;
    }

    .p-overlaypanel-close {
        display: flex;
        justify-content: center;
        align-items: center;
        overflow: hidden;
        position: relative;
    }

    /* Animation */
    .p-overlaypanel-enter-from {
        opacity: 0;
        transform: scaleY(0.8);
    }

    .p-overlaypanel-leave-to {
        opacity: 0;
    }

    .p-overlaypanel-enter-active {
        transition: transform 0.12s cubic-bezier(0, 0, 0.2, 1), opacity 0.12s cubic-bezier(0, 0, 0.2, 1);
    }

    .p-overlaypanel-leave-active {
        transition: opacity 0.1s linear;
    }

    .p-overlaypanel:after,
    .p-overlaypanel:before {
        bottom: 100%;
        left: calc(var(--overlayArrowLeft, 0) + 1.25rem);
        content: ' ';
        height: 0;
        width: 0;
        position: absolute;
        pointer-events: none;
    }

    .p-overlaypanel:after {
        border-width: 8px;
        margin-left: -8px;
    }

    .p-overlaypanel:before {
        border-width: 10px;
        margin-left: -10px;
    }

    .p-overlaypanel-flipped:after,
    .p-overlaypanel-flipped:before {
        bottom: auto;
        top: 100%;
    }

    .p-overlaypanel.p-overlaypanel-flipped:after {
        border-bottom-color: transparent;
    }

    .p-overlaypanel.p-overlaypanel-flipped:before {
        border-bottom-color: transparent;
    }
}
`, jj = {
  root: function(t) {
    var n = t.instance;
    return ["p-overlaypanel p-component", {
      "p-input-filled": n.$primevue.config.inputStyle === "filled",
      "p-ripple-disabled": n.$primevue.config.ripple === !1
    }];
  },
  content: "p-overlaypanel-content",
  closeButton: "p-overlaypanel-close p-link",
  closeIcon: "p-overlaypanel-close-icon"
}, Hj = Wt.extend({
  name: "overlaypanel",
  css: Fj,
  classes: jj
}), zj = {
  name: "BaseOverlayPanel",
  extends: wt,
  props: {
    dismissable: {
      type: Boolean,
      default: !0
    },
    showCloseIcon: {
      type: Boolean,
      default: !1
    },
    appendTo: {
      type: [String, Object],
      default: "body"
    },
    baseZIndex: {
      type: Number,
      default: 0
    },
    autoZIndex: {
      type: Boolean,
      default: !0
    },
    breakpoints: {
      type: Object,
      default: null
    },
    closeIcon: {
      type: String,
      default: void 0
    },
    closeOnEscape: {
      type: Boolean,
      default: !0
    }
  },
  style: Hj,
  provide: function() {
    return {
      $parentInstance: this
    };
  }
}, oh = {
  name: "OverlayPanel",
  extends: zj,
  inheritAttrs: !1,
  emits: ["show", "hide"],
  data: function() {
    return {
      visible: !1
    };
  },
  watch: {
    dismissable: {
      immediate: !0,
      handler: function(t) {
        t ? this.bindOutsideClickListener() : this.unbindOutsideClickListener();
      }
    }
  },
  selfClick: !1,
  target: null,
  eventTarget: null,
  outsideClickListener: null,
  scrollHandler: null,
  resizeListener: null,
  container: null,
  styleElement: null,
  overlayEventListener: null,
  documentKeydownListener: null,
  beforeUnmount: function() {
    this.dismissable && this.unbindOutsideClickListener(), this.scrollHandler && (this.scrollHandler.destroy(), this.scrollHandler = null), this.destroyStyle(), this.unbindResizeListener(), this.target = null, this.container && this.autoZIndex && qt.clear(this.container), this.overlayEventListener && (Zn.off("overlay-click", this.overlayEventListener), this.overlayEventListener = null), this.container = null;
  },
  mounted: function() {
    this.breakpoints && this.createStyle();
  },
  methods: {
    toggle: function(t, n) {
      this.visible ? this.hide() : this.show(t, n);
    },
    show: function(t, n) {
      this.visible = !0, this.eventTarget = t.currentTarget, this.target = n || t.currentTarget;
    },
    hide: function() {
      this.visible = !1;
    },
    onContentClick: function() {
      this.selfClick = !0;
    },
    onEnter: function(t) {
      var n = this;
      this.container.setAttribute(this.attributeSelector, ""), Oe.addStyles(t, {
        position: "absolute",
        top: "0",
        left: "0"
      }), this.alignOverlay(), this.dismissable && this.bindOutsideClickListener(), this.bindScrollListener(), this.bindResizeListener(), this.autoZIndex && qt.set("overlay", t, this.baseZIndex + this.$primevue.config.zIndex.overlay), this.overlayEventListener = function(i) {
        n.container.contains(i.target) && (n.selfClick = !0);
      }, this.focus(), Zn.on("overlay-click", this.overlayEventListener), this.$emit("show"), this.closeOnEscape && this.bindDocumentKeyDownListener();
    },
    onLeave: function() {
      this.unbindOutsideClickListener(), this.unbindScrollListener(), this.unbindResizeListener(), this.unbindDocumentKeyDownListener(), Zn.off("overlay-click", this.overlayEventListener), this.overlayEventListener = null, this.$emit("hide");
    },
    onAfterLeave: function(t) {
      this.autoZIndex && qt.clear(t);
    },
    alignOverlay: function() {
      Oe.absolutePosition(this.container, this.target);
      var t = Oe.getOffset(this.container), n = Oe.getOffset(this.target), i = 0;
      t.left < n.left && (i = n.left - t.left), this.container.style.setProperty("--overlayArrowLeft", "".concat(i, "px")), t.top < n.top && (this.container.setAttribute("data-p-overlaypanel-flipped", "true"), !this.isUnstyled && Oe.addClass(this.container, "p-overlaypanel-flipped"));
    },
    onContentKeydown: function(t) {
      t.code === "Escape" && this.closeOnEscape && (this.hide(), Oe.focus(this.target));
    },
    onButtonKeydown: function(t) {
      switch (t.code) {
        case "ArrowDown":
        case "ArrowUp":
        case "ArrowLeft":
        case "ArrowRight":
          t.preventDefault();
      }
    },
    focus: function() {
      var t = this.container.querySelector("[autofocus]");
      t && t.focus();
    },
    onKeyDown: function(t) {
      t.code === "Escape" && this.closeOnEscape && (this.visible = !1);
    },
    bindDocumentKeyDownListener: function() {
      this.documentKeydownListener || (this.documentKeydownListener = this.onKeyDown.bind(this), window.document.addEventListener("keydown", this.documentKeydownListener));
    },
    unbindDocumentKeyDownListener: function() {
      this.documentKeydownListener && (window.document.removeEventListener("keydown", this.documentKeydownListener), this.documentKeydownListener = null);
    },
    bindOutsideClickListener: function() {
      var t = this;
      !this.outsideClickListener && Oe.isClient() && (this.outsideClickListener = function(n) {
        t.visible && !t.selfClick && !t.isTargetClicked(n) && (t.visible = !1), t.selfClick = !1;
      }, document.addEventListener("click", this.outsideClickListener));
    },
    unbindOutsideClickListener: function() {
      this.outsideClickListener && (document.removeEventListener("click", this.outsideClickListener), this.outsideClickListener = null, this.selfClick = !1);
    },
    bindScrollListener: function() {
      var t = this;
      this.scrollHandler || (this.scrollHandler = new po(this.target, function() {
        t.visible && (t.visible = !1);
      })), this.scrollHandler.bindScrollListener();
    },
    unbindScrollListener: function() {
      this.scrollHandler && this.scrollHandler.unbindScrollListener();
    },
    bindResizeListener: function() {
      var t = this;
      this.resizeListener || (this.resizeListener = function() {
        t.visible && !Oe.isTouchDevice() && (t.visible = !1);
      }, window.addEventListener("resize", this.resizeListener));
    },
    unbindResizeListener: function() {
      this.resizeListener && (window.removeEventListener("resize", this.resizeListener), this.resizeListener = null);
    },
    isTargetClicked: function(t) {
      return this.eventTarget && (this.eventTarget === t.target || this.eventTarget.contains(t.target));
    },
    containerRef: function(t) {
      this.container = t;
    },
    createStyle: function() {
      if (!this.styleElement && !this.isUnstyled) {
        var t;
        this.styleElement = document.createElement("style"), this.styleElement.type = "text/css", Oe.setAttribute(this.styleElement, "nonce", (t = this.$primevue) === null || t === void 0 || (t = t.config) === null || t === void 0 || (t = t.csp) === null || t === void 0 ? void 0 : t.nonce), document.head.appendChild(this.styleElement);
        var n = "";
        for (var i in this.breakpoints)
          n += `
                        @media screen and (max-width: `.concat(i, `) {
                            .p-overlaypanel[`).concat(this.attributeSelector, `] {
                                width: `).concat(this.breakpoints[i], ` !important;
                            }
                        }
                    `);
        this.styleElement.innerHTML = n;
      }
    },
    destroyStyle: function() {
      this.styleElement && (document.head.removeChild(this.styleElement), this.styleElement = null);
    },
    onOverlayClick: function(t) {
      Zn.emit("overlay-click", {
        originalEvent: t,
        target: this.target
      });
    }
  },
  computed: {
    attributeSelector: function() {
      return Mt();
    },
    closeAriaLabel: function() {
      return this.$primevue.config.locale.aria ? this.$primevue.config.locale.aria.close : void 0;
    }
  },
  directives: {
    focustrap: qu,
    ripple: An
  },
  components: {
    Portal: Yn,
    TimesIcon: Ho
  }
};
function mc(e) {
  "@babel/helpers - typeof";
  return mc = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, mc(e);
}
function nb(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    t && (i = i.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), n.push.apply(n, i);
  }
  return n;
}
function ib(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? nb(Object(n), !0).forEach(function(i) {
      Vj(e, i, n[i]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : nb(Object(n)).forEach(function(i) {
      Object.defineProperty(e, i, Object.getOwnPropertyDescriptor(n, i));
    });
  }
  return e;
}
function Vj(e, t, n) {
  return t = Gj(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function Gj(e) {
  var t = Uj(e, "string");
  return mc(t) == "symbol" ? t : String(t);
}
function Uj(e, t) {
  if (mc(e) != "object" || !e)
    return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var i = n.call(e, t || "default");
    if (mc(i) != "object")
      return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var Wj = ["aria-modal"], Yj = ["aria-label"];
function qj(e, t, n, i, o, a) {
  var r = $e("Portal"), s = Ut("ripple"), l = Ut("focustrap");
  return E(), fe(r, {
    appendTo: e.appendTo
  }, {
    default: Se(function() {
      return [ue(ia, Ce({
        name: "p-overlaypanel",
        onEnter: a.onEnter,
        onLeave: a.onLeave,
        onAfterLeave: a.onAfterLeave
      }, e.ptm("transition")), {
        default: Se(function() {
          return [o.visible ? rt((E(), X("div", Ce({
            key: 0,
            ref: a.containerRef,
            role: "dialog",
            "aria-modal": o.visible,
            onClick: t[5] || (t[5] = function() {
              return a.onOverlayClick && a.onOverlayClick.apply(a, arguments);
            }),
            class: e.cx("root")
          }, ib(ib({}, e.$attrs), e.ptm("root"))), [e.$slots.container ? je(e.$slots, "container", {
            key: 0,
            onClose: a.hide,
            onKeydown: function(y) {
              return a.onButtonKeydown(y);
            },
            closeCallback: a.hide,
            keydownCallback: function(y) {
              return a.onButtonKeydown(y);
            }
          }) : (E(), X(Re, {
            key: 1
          }, [oe("div", Ce({
            class: e.cx("content"),
            onClick: t[0] || (t[0] = function() {
              return a.onContentClick && a.onContentClick.apply(a, arguments);
            }),
            onMousedown: t[1] || (t[1] = function() {
              return a.onContentClick && a.onContentClick.apply(a, arguments);
            }),
            onKeydown: t[2] || (t[2] = function() {
              return a.onContentKeydown && a.onContentKeydown.apply(a, arguments);
            })
          }, e.ptm("content")), [je(e.$slots, "default")], 16), e.showCloseIcon ? rt((E(), X("button", Ce({
            key: 0,
            class: e.cx("closeButton"),
            "aria-label": a.closeAriaLabel,
            type: "button",
            autofocus: "",
            onClick: t[3] || (t[3] = function() {
              return a.hide && a.hide.apply(a, arguments);
            }),
            onKeydown: t[4] || (t[4] = function() {
              return a.onButtonKeydown && a.onButtonKeydown.apply(a, arguments);
            })
          }, e.ptm("closeButton")), [je(e.$slots, "closeicon", {}, function() {
            return [(E(), fe(tt(e.closeIcon ? "span" : "TimesIcon"), Ce({
              class: [e.cx("closeIcon"), e.closeIcon]
            }, e.ptm("closeIcon")), null, 16, ["class"]))];
          })], 16, Yj)), [[s]]) : te("", !0)], 64))], 16, Wj)), [[l]]) : te("", !0)];
        }),
        _: 3
      }, 16, ["onEnter", "onLeave", "onAfterLeave"])];
    }),
    _: 3
  }, 8, ["appendTo"]);
}
oh.render = qj;
const Kj = { class: "d-base-action-menu" }, Xj = ["id", "aria-label", "aria-expanded"], Zj = { class: "d-base-action-menu__items" }, Jj = ["data-event_source", "data-event_title", "data-event_target", "data-event_component_name", "aria-pressed", "onKeypress", "onClick"], Qj = { class: "d-base-action-menu__label-container whitespace-nowrap" }, eH = /* @__PURE__ */ Be({
  __name: "BaseActionMenu",
  props: {
    values: {
      type: Array,
      required: !0
    },
    maxCompare: {
      type: Number,
      default: 5
    },
    compareCount: {
      type: Number,
      default: 0
    },
    fundsName: {
      type: String,
      default: ""
    }
  },
  emits: ["actionTriggered"],
  setup(e, { emit: t }) {
    const { pageName: n } = Qe(), { t: i } = Je(), o = e;
    let a = Qi(o.values);
    const r = ge(), s = ge([]), l = ge(!1), d = ge(o.fundsName.toLowerCase().replaceAll(" ", "-")), y = t;
    qe(
      () => o.values,
      (f) => {
        a = f;
      }
    );
    const u = () => {
      l.value = !0, s.value[0].focus();
    }, m = () => {
      Ue && setTimeout(() => {
        document.getElementById(d.value)?.focus();
      }, 0);
    }, h = async () => {
      l.value = !1, m();
    }, c = (f) => {
      l.value = !l.value, r?.value.toggle(f), l.value || m();
    }, g = (f) => {
      f.selected && f.nonRemovable || (f.key === ga.Compare ? (o.compareCount < o.maxCompare && !f.selected || o.compareCount <= o.maxCompare && f.selected) && v(f) : v(f), r?.value.hide());
    }, v = (f) => {
      f.selected = !f.selected, y("actionTriggered", f, d.value), f.url && Ue && window.open(f.url);
    }, P = () => {
      if (!a?.find(
        (w) => w.selected === !1
      ) && a?.length > 1)
        return H.CheckDouble;
      const S = a?.find(
        (w) => w.selected === !0
      );
      return S ? S.icon : H.Plus;
    };
    return (f, S) => {
      const w = $e("BaseText");
      return E(), X("div", Kj, [
        oe("span", {
          id: d.value,
          class: "d-base-action-menu__button",
          tabindex: "0",
          role: "combobox",
          "aria-label": e.fundsName + " " + _(i)("baseActionMenu.openActionMenu"),
          "aria-expanded": l.value,
          onKeypress: Ze(c, ["enter"]),
          onClick: c
        }, [
          ue(_t, {
            "base-icon": P(),
            "base-icon-size": _(at).S,
            class: "d-base-action-menu__button--icon"
          }, null, 8, ["base-icon", "base-icon-size"])
        ], 40, Xj),
        ue(_(oh), {
          ref_key: "actionMenu",
          ref: r,
          class: "d-base-action-menu__overlay",
          onShow: u,
          onHide: h
        }, {
          default: Se(() => [
            oe("div", Zj, [
              (E(!0), X(Re, null, Ge(_(a), (x, k) => (E(), X("div", {
                key: k,
                ref_for: !0,
                ref: (A) => s.value[k] = A,
                class: Pe(["d-base-action-menu__item", {
                  "cursor-pointer": !(x.selected && x.nonRemovable)
                }]),
                "data-event_source": _(n),
                "data-event_title": e.fundsName,
                "data-event_target": x?.selected ? "remove" : "add",
                "data-event_component_name": x.key === _(ga).Compare ? "Compare" : "Bookmark",
                tabindex: "0",
                role: "button",
                "aria-pressed": x.selected,
                onKeypress: Ze((A) => g(x), ["enter"]),
                onClick: (A) => g(x)
              }, [
                x?.icon ? (E(), fe(_t, {
                  key: 0,
                  "base-icon": x.icon,
                  "base-icon-size": _(at).S,
                  "base-icon-filled": x?.selected,
                  class: "d-base-action-menu__icon"
                }, null, 8, ["base-icon", "base-icon-size", "base-icon-filled"])) : te("", !0),
                oe("div", Qj, [
                  x?.label ? (E(), fe(w, {
                    key: 0,
                    text: x.selected && x.labelSelected ? x.labelSelected : x.label,
                    "font-size": _(st).TwelvePx,
                    "text-color": _(dt).GreyBlue006,
                    "font-type": _(lt).DwsSansBold,
                    class: "d-base-action-menu__label inline"
                  }, null, 8, ["text", "font-size", "text-color", "font-type"])) : te("", !0),
                  x?.selected && !x.nonRemovable ? (E(), fe(_t, {
                    key: 1,
                    "base-icon": _(H).Times,
                    "base-icon-size": _(at).S,
                    class: "d-base-action-menu__cancel-icon"
                  }, null, 8, ["base-icon", "base-icon-size"])) : te("", !0)
                ])
              ], 42, Jj))), 128))
            ])
          ]),
          _: 1
        }, 512)
      ]);
    };
  }
});
const ff = /* @__PURE__ */ Fe(eH, [["__scopeId", "data-v-05c85834"]]);
var ln = /* @__PURE__ */ ((e) => (e.Boolean = "boolean", e.Empty = "empty", e.PerformanceValue = "performance-value", e.Link = "link", e.DownloadLink = "download-link", e.Hidden = "hidden", e.Tag = "tag", e.Text = "text", e.Image = "image", e.MorningStarRating = "morning-star-rating", e.ActionMenu = "action-menu", e.Identifier = "identifier", e))(ln || {}), mf = /* @__PURE__ */ ((e) => (e.Text = "text", e.Icon = "icon", e))(mf || {});
const io = /* @__PURE__ */ Ha("dataTable", () => {
  const e = ge([]), t = ge([]);
  function n(p, L) {
    c(p), e.value[m(p)].SortKey = L;
  }
  function i(p, L) {
    c(p), e.value[m(p)].Ascending = L, e.value[m(p)].SortOrder = L ? 1 : -1;
  }
  function o(p, L) {
    c(p), e.value[m(p)].Ascending = L === 1, e.value[m(p)].SortOrder = L;
  }
  function a(p, L) {
    c(p), e.value[m(p)].page = L;
  }
  function r(p, L) {
    c(p), e.value[m(p)].rowsPerPage = L;
  }
  function s(p) {
    return e.value[m(p)]?.SortKey || "";
  }
  function l(p) {
    return e.value[m(p)]?.Ascending;
  }
  function d(p) {
    return e.value[m(p)]?.SortOrder || 0;
  }
  function y(p) {
    return e.value[m(p)]?.page || 1;
  }
  function u(p) {
    return e.value[m(p)]?.rowsPerPage || 15;
  }
  function m(p) {
    return e.value.findIndex((L) => L.tableId === p);
  }
  function h(p) {
    return e.value.find((L) => L.tableId === p);
  }
  function c(p) {
    if (m(p) > -1)
      return;
    const L = {
      tableId: p,
      SortKey: "",
      Ascending: !1,
      SortOrder: 0,
      page: 1,
      rowsPerPage: 15,
      LockedItems: []
    };
    e.value.push(L);
  }
  function g(p) {
    e.value.splice(m(p), 1);
  }
  function v(p, L) {
    c(p);
    const B = e.value[m(p)]?.LockedItems;
    B && !B.includes(L) && B.push(L);
  }
  function P(p, L) {
    c(p);
    const B = e.value[m(p)]?.LockedItems;
    if (B) {
      const T = w(L);
      if (B.some((I) => T === w(I)))
        S(p, L);
      else {
        const I = L[x(L)];
        I && I.value.forEach(
          (R) => {
            R.key === ga.Compare && (R.selected = !0);
          }
        ), B.push(L);
      }
    }
  }
  function f(p) {
    const L = w(p);
    L && !t.value.some((T) => L === w(T)) && t.value && t.value.push(p);
  }
  function S(p, L) {
    const B = e.value[m(p)];
    if (B) {
      const T = w(L), O = B.LockedItems.findIndex((I) => T === w(I));
      if (B.LockedItems[O]) {
        const I = x(B.LockedItems[O]);
        L[I] = B.LockedItems[O][I], B.LockedItems[O] = L;
      }
    }
  }
  function w(p) {
    return Object.values(p).find((B) => B.type === ln.Identifier)?.value || "";
  }
  function x(p) {
    let L = "";
    return Object.entries(p).forEach(([B, T]) => {
      T.type === ln.ActionMenu && (L = B);
    }), L;
  }
  function k(p, L) {
    const B = w(L), T = e.value[m(p)].LockedItems.findIndex(
      (O) => B === w(O)
    );
    e.value[m(p)]?.LockedItems.splice(T, 1);
  }
  function A(p) {
    const L = w(p);
    e.value.forEach((B) => {
      const T = B.LockedItems.findIndex((O) => L === w(O));
      T > -1 && B.LockedItems.splice(T, 1);
    });
  }
  function $(p) {
    const L = w(p), B = t.value.findIndex((T) => L === w(T));
    t.value.splice(B, 1);
  }
  function j(p) {
    return e.value[m(p)]?.LockedItems || [];
  }
  function N() {
    return t.value || [];
  }
  function M(p) {
    return p?.type ? typeof p.value == "string" ? p.value : typeof p.value == "boolean" ? p.value.toString() : "" : "";
  }
  function D(p, L) {
    if (!L || !p)
      return "";
    const B = L[p];
    if (B?.value)
      return B.sortValue ?? M(B);
    const T = L[p], O = T ? Object.keys(T)[0] : void 0, I = O ? T[O] : void 0;
    return I?.sortValue ?? M(I);
  }
  function C(p, L) {
    if (!L || !p)
      return ln.Empty;
    const B = L[p];
    if (B?.value)
      return B.type;
    const T = L[p], O = T ? Object.keys(T)[0] : void 0;
    return (O ? T[O] : void 0)?.type;
  }
  function b(p, L, B, T) {
    const O = D(p, L), I = D(p, B), R = C(p, L), Y = C(p, B);
    return O === I || R === ln.Empty && Y === ln.Empty ? 0 : R === ln.PerformanceValue && Y === ln.PerformanceValue ? T ? +O < +I ? -1 : 1 : +O > +I ? -1 : 1 : T ? R === ln.Empty ? -1 : Y === ln.Empty ? 1 : O < I ? -1 : 1 : Y === ln.Empty ? -1 : R === ln.Empty ? 1 : O > I ? -1 : 1;
  }
  return {
    tables: e,
    setSortKey: n,
    setAscending: i,
    setSortOrder: o,
    setPage: a,
    setRowsPerPage: r,
    getSortKey: s,
    getAscending: l,
    getSortOrder: d,
    getPage: y,
    getRowsPerPage: u,
    addLockedItem: v,
    addOrUpdateLockedItemByIdentifier: P,
    updateLockedItem: S,
    getLockedItems: j,
    removeLockedItem: k,
    removeLockedItemFromAllTables: A,
    addBookmarkedItem: f,
    getBookmarkedItems: N,
    removeBookmarkedItem: $,
    addTable: c,
    getTable: h,
    getIdentifier: w,
    getActionMenuKey: x,
    removeTable: g,
    getCellValueString: M,
    getValue: D,
    sortAlgorithm: b
  };
}), SBe = (e) => e && "backgroundColor" in e && typeof e.backgroundColor == typeof Zt;
var Hi = zx();
function gc(e) {
  "@babel/helpers - typeof";
  return gc = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, gc(e);
}
function Id(e, t, n) {
  return t = tH(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function tH(e) {
  var t = nH(e, "string");
  return gc(t) == "symbol" ? t : String(t);
}
function nH(e, t) {
  if (gc(e) != "object" || !e)
    return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var i = n.call(e, t || "default");
    if (gc(i) != "object")
      return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var iH = `
@layer primevue {
    .p-toast {
        width: 25rem;
        white-space: pre-line;
        word-break: break-word;
    }

    .p-toast-message-icon {
        flex-shrink: 0;
    }

    .p-toast-message-content {
        display: flex;
        align-items: flex-start;
    }

    .p-toast-message-text {
        flex: 1 1 auto;
    }

    .p-toast-top-center {
        transform: translateX(-50%);
    }

    .p-toast-bottom-center {
        transform: translateX(-50%);
    }

    .p-toast-center {
        min-width: 20vw;
        transform: translate(-50%, -50%);
    }

    .p-toast-icon-close {
        display: flex;
        align-items: center;
        justify-content: center;
        overflow: hidden;
        position: relative;
    }

    .p-toast-icon-close.p-link {
        cursor: pointer;
    }

    /* Animations */
    .p-toast-message-enter-from {
        opacity: 0;
        -webkit-transform: translateY(50%);
        -ms-transform: translateY(50%);
        transform: translateY(50%);
    }

    .p-toast-message-leave-from {
        max-height: 1000px;
    }

    .p-toast .p-toast-message.p-toast-message-leave-to {
        max-height: 0;
        opacity: 0;
        margin-bottom: 0;
        overflow: hidden;
    }

    .p-toast-message-enter-active {
        -webkit-transition: transform 0.3s, opacity 0.3s;
        transition: transform 0.3s, opacity 0.3s;
    }

    .p-toast-message-leave-active {
        -webkit-transition: max-height 0.45s cubic-bezier(0, 1, 0, 1), opacity 0.3s, margin-bottom 0.3s;
        transition: max-height 0.45s cubic-bezier(0, 1, 0, 1), opacity 0.3s, margin-bottom 0.3s;
    }
}
`, aH = {
  root: function(t) {
    var n = t.position;
    return {
      position: "fixed",
      top: n === "top-right" || n === "top-left" || n === "top-center" ? "20px" : n === "center" ? "50%" : null,
      right: (n === "top-right" || n === "bottom-right") && "20px",
      bottom: (n === "bottom-left" || n === "bottom-right" || n === "bottom-center") && "20px",
      left: n === "top-left" || n === "bottom-left" ? "20px" : n === "center" || n === "top-center" || n === "bottom-center" ? "50%" : null
    };
  }
}, oH = {
  root: function(t) {
    var n = t.props, i = t.instance;
    return ["p-toast p-component p-toast-" + n.position, {
      "p-input-filled": i.$primevue.config.inputStyle === "filled",
      "p-ripple-disabled": i.$primevue.config.ripple === !1
    }];
  },
  container: function(t) {
    var n = t.props;
    return ["p-toast-message", {
      "p-toast-message-info": n.message.severity === "info" || n.message.severity === void 0,
      "p-toast-message-warn": n.message.severity === "warn",
      "p-toast-message-error": n.message.severity === "error",
      "p-toast-message-success": n.message.severity === "success"
    }];
  },
  content: "p-toast-message-content",
  icon: function(t) {
    var n = t.props;
    return ["p-toast-message-icon", Id(Id(Id(Id({}, n.infoIcon, n.message.severity === "info"), n.warnIcon, n.message.severity === "warn"), n.errorIcon, n.message.severity === "error"), n.successIcon, n.message.severity === "success")];
  },
  text: "p-toast-message-text",
  summary: "p-toast-summary",
  detail: "p-toast-detail",
  closeButton: "p-toast-icon-close p-link",
  closeIcon: "p-toast-icon-close-icon"
}, rH = Wt.extend({
  name: "toast",
  css: iH,
  classes: oH,
  inlineStyles: aH
}), sH = {
  name: "BaseToast",
  extends: wt,
  props: {
    group: {
      type: String,
      default: null
    },
    position: {
      type: String,
      default: "top-right"
    },
    autoZIndex: {
      type: Boolean,
      default: !0
    },
    baseZIndex: {
      type: Number,
      default: 0
    },
    breakpoints: {
      type: Object,
      default: null
    },
    closeIcon: {
      type: String,
      default: void 0
    },
    infoIcon: {
      type: String,
      default: void 0
    },
    warnIcon: {
      type: String,
      default: void 0
    },
    errorIcon: {
      type: String,
      default: void 0
    },
    successIcon: {
      type: String,
      default: void 0
    },
    closeButtonProps: {
      type: null,
      default: null
    }
  },
  style: rH,
  provide: function() {
    return {
      $parentInstance: this
    };
  }
}, aS = {
  name: "ToastMessage",
  hostName: "Toast",
  extends: wt,
  emits: ["close"],
  closeTimeout: null,
  props: {
    message: {
      type: null,
      default: null
    },
    templates: {
      type: Object,
      default: null
    },
    closeIcon: {
      type: String,
      default: null
    },
    infoIcon: {
      type: String,
      default: null
    },
    warnIcon: {
      type: String,
      default: null
    },
    errorIcon: {
      type: String,
      default: null
    },
    successIcon: {
      type: String,
      default: null
    },
    closeButtonProps: {
      type: null,
      default: null
    }
  },
  mounted: function() {
    var t = this;
    this.message.life && (this.closeTimeout = setTimeout(function() {
      t.close({
        message: t.message,
        type: "life-end"
      });
    }, this.message.life));
  },
  beforeUnmount: function() {
    this.clearCloseTimeout();
  },
  methods: {
    close: function(t) {
      this.$emit("close", t);
    },
    onCloseClick: function() {
      this.clearCloseTimeout(), this.close({
        message: this.message,
        type: "close"
      });
    },
    clearCloseTimeout: function() {
      this.closeTimeout && (clearTimeout(this.closeTimeout), this.closeTimeout = null);
    }
  },
  computed: {
    iconComponent: function() {
      return {
        info: !this.infoIcon && bu,
        success: !this.successIcon && Oa,
        warn: !this.warnIcon && yu,
        error: !this.errorIcon && hc
      }[this.message.severity];
    },
    closeAriaLabel: function() {
      return this.$primevue.config.locale.aria ? this.$primevue.config.locale.aria.close : void 0;
    }
  },
  components: {
    TimesIcon: Ho,
    InfoCircleIcon: bu,
    CheckIcon: Oa,
    ExclamationTriangleIcon: yu,
    TimesCircleIcon: hc
  },
  directives: {
    ripple: An
  }
};
function vc(e) {
  "@babel/helpers - typeof";
  return vc = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, vc(e);
}
function ab(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    t && (i = i.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), n.push.apply(n, i);
  }
  return n;
}
function ol(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? ab(Object(n), !0).forEach(function(i) {
      lH(e, i, n[i]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : ab(Object(n)).forEach(function(i) {
      Object.defineProperty(e, i, Object.getOwnPropertyDescriptor(n, i));
    });
  }
  return e;
}
function lH(e, t, n) {
  return t = cH(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function cH(e) {
  var t = dH(e, "string");
  return vc(t) == "symbol" ? t : String(t);
}
function dH(e, t) {
  if (vc(e) != "object" || !e)
    return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var i = n.call(e, t || "default");
    if (vc(i) != "object")
      return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var uH = ["aria-label"];
function hH(e, t, n, i, o, a) {
  var r = Ut("ripple");
  return E(), X("div", Ce({
    class: [e.cx("container"), n.message.styleClass],
    role: "alert",
    "aria-live": "assertive",
    "aria-atomic": "true"
  }, e.ptm("container")), [n.templates.container ? (E(), fe(tt(n.templates.container), {
    key: 0,
    message: n.message,
    onClose: a.onCloseClick,
    closeCallback: a.onCloseClick
  }, null, 40, ["message", "onClose", "closeCallback"])) : (E(), X("div", Ce({
    key: 1,
    class: [e.cx("content"), n.message.contentStyleClass]
  }, e.ptm("content")), [n.templates.message ? (E(), fe(tt(n.templates.message), {
    key: 1,
    message: n.message
  }, null, 8, ["message"])) : (E(), X(Re, {
    key: 0
  }, [(E(), fe(tt(n.templates.icon ? n.templates.icon : a.iconComponent && a.iconComponent.name ? a.iconComponent : "span"), Ce({
    class: e.cx("icon")
  }, e.ptm("icon")), null, 16, ["class"])), oe("div", Ce({
    class: e.cx("text")
  }, e.ptm("text")), [oe("span", Ce({
    class: e.cx("summary")
  }, e.ptm("summary")), Ie(n.message.summary), 17), oe("div", Ce({
    class: e.cx("detail")
  }, e.ptm("detail")), Ie(n.message.detail), 17)], 16)], 64)), n.message.closable !== !1 ? (E(), X("div", si(Ce({
    key: 2
  }, e.ptm("buttonContainer"))), [rt((E(), X("button", Ce({
    class: e.cx("closeButton"),
    type: "button",
    "aria-label": a.closeAriaLabel,
    onClick: t[0] || (t[0] = function() {
      return a.onCloseClick && a.onCloseClick.apply(a, arguments);
    }),
    autofocus: ""
  }, ol(ol(ol({}, n.closeButtonProps), e.ptm("button")), e.ptm("closeButton"))), [(E(), fe(tt(n.templates.closeicon || "TimesIcon"), Ce({
    class: [e.cx("closeIcon"), n.closeIcon]
  }, ol(ol({}, e.ptm("buttonIcon")), e.ptm("closeIcon"))), null, 16, ["class"]))], 16, uH)), [[r]])], 16)) : te("", !0)], 16))], 16);
}
aS.render = hH;
function pH(e) {
  return vH(e) || gH(e) || mH(e) || fH();
}
function fH() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function mH(e, t) {
  if (e) {
    if (typeof e == "string")
      return gf(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set")
      return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return gf(e, t);
  }
}
function gH(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null)
    return Array.from(e);
}
function vH(e) {
  if (Array.isArray(e))
    return gf(e);
}
function gf(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, i = new Array(t); n < t; n++)
    i[n] = e[n];
  return i;
}
var yH = 0, oS = {
  name: "Toast",
  extends: sH,
  inheritAttrs: !1,
  emits: ["close", "life-end"],
  data: function() {
    return {
      messages: []
    };
  },
  styleElement: null,
  mounted: function() {
    Hi.on("add", this.onAdd), Hi.on("remove", this.onRemove), Hi.on("remove-group", this.onRemoveGroup), Hi.on("remove-all-groups", this.onRemoveAllGroups), this.breakpoints && this.createStyle();
  },
  beforeUnmount: function() {
    this.destroyStyle(), this.$refs.container && this.autoZIndex && qt.clear(this.$refs.container), Hi.off("add", this.onAdd), Hi.off("remove", this.onRemove), Hi.off("remove-group", this.onRemoveGroup), Hi.off("remove-all-groups", this.onRemoveAllGroups);
  },
  methods: {
    add: function(t) {
      t.id == null && (t.id = yH++), this.messages = [].concat(pH(this.messages), [t]);
    },
    remove: function(t) {
      for (var n = -1, i = 0; i < this.messages.length; i++)
        if (this.messages[i] === t.message) {
          n = i;
          break;
        }
      this.messages.splice(n, 1), this.$emit(t.type, {
        message: t.message
      });
    },
    onAdd: function(t) {
      this.group == t.group && this.add(t);
    },
    onRemove: function(t) {
      this.remove({
        message: t,
        type: "close"
      });
    },
    onRemoveGroup: function(t) {
      this.group === t && (this.messages = []);
    },
    onRemoveAllGroups: function() {
      this.messages = [];
    },
    onEnter: function() {
      this.$refs.container.setAttribute(this.attributeSelector, ""), this.autoZIndex && qt.set("modal", this.$refs.container, this.baseZIndex || this.$primevue.config.zIndex.modal);
    },
    onLeave: function() {
      var t = this;
      this.$refs.container && this.autoZIndex && We.isEmpty(this.messages) && setTimeout(function() {
        qt.clear(t.$refs.container);
      }, 200);
    },
    createStyle: function() {
      if (!this.styleElement && !this.isUnstyled) {
        var t;
        this.styleElement = document.createElement("style"), this.styleElement.type = "text/css", Oe.setAttribute(this.styleElement, "nonce", (t = this.$primevue) === null || t === void 0 || (t = t.config) === null || t === void 0 || (t = t.csp) === null || t === void 0 ? void 0 : t.nonce), document.head.appendChild(this.styleElement);
        var n = "";
        for (var i in this.breakpoints) {
          var o = "";
          for (var a in this.breakpoints[i])
            o += a + ":" + this.breakpoints[i][a] + "!important;";
          n += `
                        @media screen and (max-width: `.concat(i, `) {
                            .p-toast[`).concat(this.attributeSelector, `] {
                                `).concat(o, `
                            }
                        }
                    `);
        }
        this.styleElement.innerHTML = n;
      }
    },
    destroyStyle: function() {
      this.styleElement && (document.head.removeChild(this.styleElement), this.styleElement = null);
    }
  },
  computed: {
    attributeSelector: function() {
      return Mt();
    }
  },
  components: {
    ToastMessage: aS,
    Portal: Yn
  }
};
function yc(e) {
  "@babel/helpers - typeof";
  return yc = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, yc(e);
}
function ob(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    t && (i = i.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), n.push.apply(n, i);
  }
  return n;
}
function Pd(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? ob(Object(n), !0).forEach(function(i) {
      bH(e, i, n[i]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : ob(Object(n)).forEach(function(i) {
      Object.defineProperty(e, i, Object.getOwnPropertyDescriptor(n, i));
    });
  }
  return e;
}
function bH(e, t, n) {
  return t = xH(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function xH(e) {
  var t = wH(e, "string");
  return yc(t) == "symbol" ? t : String(t);
}
function wH(e, t) {
  if (yc(e) != "object" || !e)
    return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var i = n.call(e, t || "default");
    if (yc(i) != "object")
      return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function kH(e, t, n, i, o, a) {
  var r = $e("ToastMessage"), s = $e("Portal");
  return E(), fe(s, null, {
    default: Se(function() {
      return [oe("div", Ce({
        ref: "container",
        class: e.cx("root"),
        style: e.sx("root", !0, {
          position: e.position
        })
      }, Pd(Pd({}, e.$attrs), e.ptm("root"))), [ue(FL, Ce({
        name: "p-toast-message",
        tag: "div",
        onEnter: a.onEnter,
        onLeave: a.onLeave
      }, Pd(Pd({}, e.ptm("message")), e.ptm("transition"))), {
        default: Se(function() {
          return [(E(!0), X(Re, null, Ge(o.messages, function(l) {
            return E(), fe(r, {
              key: l.id,
              message: l,
              templates: e.$slots,
              closeIcon: e.closeIcon,
              infoIcon: e.infoIcon,
              warnIcon: e.warnIcon,
              errorIcon: e.errorIcon,
              successIcon: e.successIcon,
              closeButtonProps: e.closeButtonProps,
              onClose: t[0] || (t[0] = function(d) {
                return a.remove(d);
              }),
              pt: e.pt
            }, null, 8, ["message", "templates", "closeIcon", "infoIcon", "warnIcon", "errorIcon", "successIcon", "closeButtonProps", "pt"]);
          }), 128))];
        }),
        _: 1
      }, 16, ["onEnter", "onLeave"])], 16)];
    }),
    _: 1
  });
}
oS.render = kH;
var rS = Symbol();
function sS() {
  var e = $t(rS);
  if (!e)
    throw new Error("No PrimeVue Toast provided!");
  return e;
}
var SH = {
  install: function(t) {
    var n = {
      add: function(o) {
        Hi.emit("add", o);
      },
      remove: function(o) {
        Hi.emit("remove", o);
      },
      removeGroup: function(o) {
        Hi.emit("remove-group", o);
      },
      removeAllGroups: function() {
        Hi.emit("remove-all-groups");
      }
    };
    t.config.globalProperties.$toast = n, t.provide(rS, n);
  }
}, lS = { exports: {} };
(function(e, t) {
  (function() {
    var n = {
      expires: "1d",
      path: "; path=/",
      domain: "",
      secure: "",
      sameSite: "; SameSite=Lax",
      partitioned: ""
    }, i = {
      // install of Vue
      install: function(o, a) {
        a && this.config(a.expires, a.path, a.domain, a.secure, a.sameSite, a.partitioned), o.prototype && (o.prototype.$cookies = this), o.config && o.config.globalProperties && (o.config.globalProperties.$cookies = this, o.provide("$cookies", this)), o.$cookies = this;
      },
      config: function(o, a, r, s, l, d) {
        n.expires = o || "1d", n.path = a ? "; path=" + a : "; path=/", n.domain = r ? "; domain=" + r : "", n.secure = s ? "; Secure" : "", n.sameSite = l ? "; SameSite=" + l : "; SameSite=Lax", n.partitioned = d ? "; Partitioned" : "";
      },
      get: function(o) {
        var a = decodeURIComponent(document.cookie.replace(new RegExp("(?:(?:^|.*;)\\s*" + encodeURIComponent(o).replace(/[\-\.\+\*]/g, "\\$&") + "\\s*\\=\\s*([^;]*).*$)|^.*$"), "$1")) || null;
        if (a && (a.substring(0, 1) === "{" && a.substring(a.length - 1, a.length) === "}" || a.substring(0, 1) === "[" && a.substring(a.length - 1, a.length) === "]"))
          try {
            a = JSON.parse(a);
          } catch {
            return a;
          }
        return a;
      },
      set: function(o, a, r, s, l, d, y, u) {
        if (o) {
          if (/^(?:expires|max\-age|path|domain|secure|SameSite)$/i.test(o))
            throw new Error('Cookie name illegality. Cannot be set to ["expires","max-age","path","domain","secure","SameSite"]	 current key name: ' + o);
        } else
          throw new Error("Cookie name is not found in the first argument.");
        a && typeof a == "object" && (a = JSON.stringify(a));
        var m = "";
        if (r = r === void 0 ? n.expires : r, r && r !== 0)
          switch (r.constructor) {
            case Number:
              r === 1 / 0 || r === -1 ? m = "; expires=Fri, 31 Dec 9999 23:59:59 GMT" : m = "; max-age=" + r;
              break;
            case String:
              if (/^(?:\d+(y|m|d|h|min|s))$/i.test(r)) {
                var h = r.replace(/^(\d+)(?:y|m|d|h|min|s)$/i, "$1");
                switch (r.replace(/^(?:\d+)(y|m|d|h|min|s)$/i, "$1").toLowerCase()) {
                  case "m":
                    m = "; max-age=" + +h * 2592e3;
                    break;
                  case "d":
                    m = "; max-age=" + +h * 86400;
                    break;
                  case "h":
                    m = "; max-age=" + +h * 3600;
                    break;
                  case "min":
                    m = "; max-age=" + +h * 60;
                    break;
                  case "s":
                    m = "; max-age=" + h;
                    break;
                  case "y":
                    m = "; max-age=" + +h * 31104e3;
                    break;
                }
              } else
                m = "; expires=" + r;
              break;
            case Date:
              m = "; expires=" + r.toUTCString();
              break;
          }
        return document.cookie = encodeURIComponent(o) + "=" + encodeURIComponent(a) + m + (l ? "; domain=" + l : n.domain) + (s ? "; path=" + s : n.path) + (d === void 0 ? n.secure : d ? "; Secure" : "") + (y === void 0 ? n.sameSite : y ? "; SameSite=" + y : "") + (u === void 0 ? n.partitioned : u ? "; Partitioned" : ""), this;
      },
      remove: function(o, a, r) {
        return !o || !this.isKey(o) ? !1 : (document.cookie = encodeURIComponent(o) + "=; expires=Thu, 01 Jan 1970 00:00:00 GMT" + (r ? "; domain=" + r : n.domain) + (a ? "; path=" + a : n.path) + "; SameSite=Lax", !0);
      },
      isKey: function(o) {
        return new RegExp("(?:^|;\\s*)" + encodeURIComponent(o).replace(/[\-\.\+\*]/g, "\\$&") + "\\s*\\=").test(document.cookie);
      },
      keys: function() {
        if (!document.cookie)
          return [];
        for (var o = document.cookie.replace(/((?:^|\s*;)[^\=]+)(?=;|$)|^\s*|\s*(?:\=[^;]*)?(?:\1|$)/g, "").split(/\s*(?:\=[^;]*)?;\s*/), a = 0; a < o.length; a++)
          o[a] = decodeURIComponent(o[a]);
        return o;
      }
    };
    e.exports = i, typeof window < "u" && (window.$cookies = i);
  })();
})(lS);
var CH = lS.exports;
const TH = /* @__PURE__ */ en(CH);
function Qd(e) {
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Qd = function(t) {
    return typeof t;
  } : Qd = function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Qd(e);
}
function LH(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function rb(e, t) {
  for (var n = 0; n < t.length; n++) {
    var i = t[n];
    i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, i.key, i);
  }
}
function IH(e, t, n) {
  return t && rb(e.prototype, t), n && rb(e, n), e;
}
function sb(e) {
  return PH(e) || AH(e) || _H();
}
function PH(e) {
  if (Array.isArray(e)) {
    for (var t = 0, n = new Array(e.length); t < e.length; t++)
      n[t] = e[t];
    return n;
  }
}
function AH(e) {
  if (Symbol.iterator in Object(e) || Object.prototype.toString.call(e) === "[object Arguments]")
    return Array.from(e);
}
function _H() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}
function MH(e) {
  var t;
  return typeof e == "function" ? t = {
    callback: e
  } : t = e, t;
}
function OH(e, t) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, i, o, a, r = function(l) {
    for (var d = arguments.length, y = new Array(d > 1 ? d - 1 : 0), u = 1; u < d; u++)
      y[u - 1] = arguments[u];
    if (a = y, !(i && l === o)) {
      var m = n.leading;
      typeof m == "function" && (m = m(l, o)), (!i || l !== o) && m && e.apply(void 0, [l].concat(sb(a))), o = l, clearTimeout(i), i = setTimeout(function() {
        e.apply(void 0, [l].concat(sb(a))), i = 0;
      }, t);
    }
  };
  return r._clear = function() {
    clearTimeout(i), i = null;
  }, r;
}
function cS(e, t) {
  if (e === t)
    return !0;
  if (Qd(e) === "object") {
    for (var n in e)
      if (!cS(e[n], t[n]))
        return !1;
    return !0;
  }
  return !1;
}
var BH = /* @__PURE__ */ function() {
  function e(t, n, i) {
    LH(this, e), this.el = t, this.observer = null, this.frozen = !1, this.createObserver(n, i);
  }
  return IH(e, [{
    key: "createObserver",
    value: function(n) {
      var i = this;
      if (this.observer && this.destroyObserver(), !this.frozen) {
        if (this.options = MH(n), this.callback = function(r, s) {
          i.options.callback(r, s), r && i.options.once && (i.frozen = !0, i.destroyObserver());
        }, this.callback && this.options.throttle) {
          var o = this.options.throttleOptions || {}, a = o.leading;
          this.callback = OH(this.callback, this.options.throttle, {
            leading: function(s) {
              return a === "both" || a === "visible" && s || a === "hidden" && !s;
            }
          });
        }
        this.oldResult = void 0, this.observer = new IntersectionObserver(function(r) {
          var s = r[0];
          if (r.length > 1) {
            var l = r.find(function(y) {
              return y.isIntersecting;
            });
            l && (s = l);
          }
          if (i.callback) {
            var d = s.isIntersecting && s.intersectionRatio >= i.threshold;
            if (d === i.oldResult)
              return;
            i.oldResult = d, i.callback(d, s);
          }
        }, this.options.intersection), setTimeout(function() {
          i.observer && i.observer.observe(i.el);
        });
      }
    }
  }, {
    key: "destroyObserver",
    value: function() {
      this.observer && (this.observer.disconnect(), this.observer = null), this.callback && this.callback._clear && (this.callback._clear(), this.callback = null);
    }
  }, {
    key: "threshold",
    get: function() {
      return this.options.intersection && this.options.intersection.threshold || 0;
    }
  }]), e;
}();
function dS(e, t, n) {
  var i = t.value;
  if (i)
    if (typeof IntersectionObserver > "u")
      console.warn("[vue-observe-visibility] IntersectionObserver API is not available in your browser. Please install this polyfill: https://github.com/w3c/IntersectionObserver/tree/master/polyfill");
    else {
      var o = new BH(e, i, n);
      e._vue_visibilityState = o;
    }
}
function uS(e) {
  var t = e._vue_visibilityState;
  t && (t.destroyObserver(), delete e._vue_visibilityState);
}
function EH(e, t, n) {
  var i = t.value, o = t.oldValue;
  if (!cS(i, o)) {
    var a = e._vue_visibilityState;
    if (!i) {
      uS(e);
      return;
    }
    a ? a.createObserver(i, n) : dS(e, {
      value: i
    }, n);
  }
}
var DH = {
  mounted: dS,
  componentUpdated: EH,
  unmounted: uS
}, RH = "0.0.3", NH = function(t) {
  t.use({
    // eslint-disable-next-line no-shadow
    install: function(i) {
      i.directive("observe-visibility", DH);
    }
  });
}, $H = {
  version: RH,
  install: NH
}, hS = { exports: {} };
(function(e, t) {
  (function(n, i) {
    e.exports = i();
  })(rn, function() {
    return function(n) {
      var i = {};
      function o(a) {
        if (i[a])
          return i[a].exports;
        var r = i[a] = { i: a, l: !1, exports: {} };
        return n[a].call(r.exports, r, r.exports, o), r.l = !0, r.exports;
      }
      return o.m = n, o.c = i, o.d = function(a, r, s) {
        o.o(a, r) || Object.defineProperty(a, r, { enumerable: !0, get: s });
      }, o.r = function(a) {
        typeof Symbol < "u" && Symbol.toStringTag && Object.defineProperty(a, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(a, "__esModule", { value: !0 });
      }, o.t = function(a, r) {
        if (1 & r && (a = o(a)), 8 & r || 4 & r && typeof a == "object" && a && a.__esModule)
          return a;
        var s = /* @__PURE__ */ Object.create(null);
        if (o.r(s), Object.defineProperty(s, "default", { enumerable: !0, value: a }), 2 & r && typeof a != "string")
          for (var l in a)
            o.d(s, l, function(d) {
              return a[d];
            }.bind(null, l));
        return s;
      }, o.n = function(a) {
        var r = a && a.__esModule ? function() {
          return a.default;
        } : function() {
          return a;
        };
        return o.d(r, "a", r), r;
      }, o.o = function(a, r) {
        return Object.prototype.hasOwnProperty.call(a, r);
      }, o.p = "", o(o.s = 0);
    }([function(n, i, o) {
      function a(h, c, g) {
        return c in h ? Object.defineProperty(h, c, { value: g, enumerable: !0, configurable: !0, writable: !0 }) : h[c] = g, h;
      }
      function r(h) {
        return (r = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(c) {
          return typeof c;
        } : function(c) {
          return c && typeof Symbol == "function" && c.constructor === Symbol && c !== Symbol.prototype ? "symbol" : typeof c;
        })(h);
      }
      var s;
      o.r(i);
      var l = function(h) {
        return h < 0.5 ? 4 * h * h * h : (h - 1) * (2 * h - 2) * (2 * h - 2) + 1;
      }, d = function() {
        return { duration: 500, offset: 0, container: window, updateHistory: !0, easingFunction: null };
      }, y = Symbol("smoothScrollCtx"), u = function(h) {
        var c = h.scrollTo, g = h.offset, v = h.duration, P = h.container, f = h.updateHistory, S = h.hash, w = h.easingFunction;
        s || (s = window.requestAnimationFrame || function(D) {
          return window.setTimeout(D, 16);
        }), f && window.history.pushState && location.hash !== S && window.history.pushState("", "", S);
        var x, k, A = typeof c == "number", $ = P.scrollTop || window.pageYOffset, j = (A ? c : (k = $, (x = c).nodeName === "HTML" ? -k : x.getBoundingClientRect().top + k)) + g, N = typeof w == "function" ? w : l, M = Date.now();
        (function D() {
          var C = Date.now() - M, b = C < v, p = b ? $ + (j - $) * N(C / v) : j;
          b ? s(D) : f && !A && location.replace("#" + c.id), P === window ? P.scrollTo(0, p) : P.scrollTop = p;
        })();
      }, m = { install: function(h, c) {
        var g, v = !h.version.startsWith("3"), P = function() {
          return c ? Object.assign(d(), c) : d();
        };
        h.directive("smooth-scroll", (a(g = {}, v ? "inserted" : "mounted", function(S, w, x) {
          if ((typeof window > "u" ? "undefined" : r(window)) === "object" && window.pageYOffset !== void 0) {
            var k = Object.assign(P(), w.value);
            typeof k.container == "string" && (k.container = document.querySelector(k.container));
            var A = function($) {
              $.preventDefault();
              var j = v ? x.data.attrs.href : x.props.href, N = document.getElementById(j.substring(1));
              N && u(Object.assign(k, { scrollTo: N, hash: j }));
            };
            S.addEventListener("click", A), S[y] = { clickHandler: A };
          }
        }), a(g, v ? "unbind" : "unmounted", function(S) {
          S.removeEventListener("click", S[y].clickHandler), S[y] = null;
        }), g));
        var f = function(S) {
          var w = Object.assign(P(), S);
          return u(w);
        };
        (v ? h.prototype : h.config.globalProperties).$smoothScroll = f, v || h.provide("smoothScroll", f);
      } };
      i.default = m;
    }]).default;
  });
})(hS);
var FH = hS.exports;
const jH = /* @__PURE__ */ en(FH);
var pS = { exports: {} };
(function(e, t) {
  (function(n, i) {
    e.exports = i();
  })(rn, function() {
    var n = "__v-click-outside", i = typeof window < "u", o = typeof navigator < "u", a = i && ("ontouchstart" in window || o && navigator.msMaxTouchPoints > 0) ? ["touchstart"] : ["click"], r = function(y) {
      var u = y.event, m = y.handler;
      (0, y.middleware)(u) && m(u);
    }, s = function(y, u) {
      var m = function(f) {
        var S = typeof f == "function";
        if (!S && typeof f != "object")
          throw new Error("v-click-outside: Binding value must be a function or an object");
        return { handler: S ? f : f.handler, middleware: f.middleware || function(w) {
          return w;
        }, events: f.events || a, isActive: f.isActive !== !1, detectIframe: f.detectIframe !== !1, capture: !!f.capture };
      }(u.value), h = m.handler, c = m.middleware, g = m.detectIframe, v = m.capture;
      if (m.isActive) {
        if (y[n] = m.events.map(function(f) {
          return { event: f, srcTarget: document.documentElement, handler: function(S) {
            return function(w) {
              var x = w.el, k = w.event, A = w.handler, $ = w.middleware, j = k.path || k.composedPath && k.composedPath();
              (j ? j.indexOf(x) < 0 : !x.contains(k.target)) && r({ event: k, handler: A, middleware: $ });
            }({ el: y, event: S, handler: h, middleware: c });
          }, capture: v };
        }), g) {
          var P = { event: "blur", srcTarget: window, handler: function(f) {
            return function(S) {
              var w = S.el, x = S.event, k = S.handler, A = S.middleware;
              setTimeout(function() {
                var $ = document.activeElement;
                $ && $.tagName === "IFRAME" && !w.contains($) && r({ event: x, handler: k, middleware: A });
              }, 0);
            }({ el: y, event: f, handler: h, middleware: c });
          }, capture: v };
          y[n] = [].concat(y[n], [P]);
        }
        y[n].forEach(function(f) {
          var S = f.event, w = f.srcTarget, x = f.handler;
          return setTimeout(function() {
            y[n] && w.addEventListener(S, x, v);
          }, 0);
        });
      }
    }, l = function(y) {
      (y[n] || []).forEach(function(u) {
        return u.srcTarget.removeEventListener(u.event, u.handler, u.capture);
      }), delete y[n];
    }, d = i ? { beforeMount: s, updated: function(y, u) {
      var m = u.value, h = u.oldValue;
      JSON.stringify(m) !== JSON.stringify(h) && (l(y), s(y, { value: m }));
    }, unmounted: l } : {};
    return { install: function(y) {
      y.directive("click-outside", d);
    }, directive: d };
  });
})(pS);
var HH = pS.exports;
const zH = /* @__PURE__ */ en(HH);
var fS = { exports: {} };
(function(e, t) {
  (function(n, i) {
    e.exports = i();
  })(rn, function() {
    var n = { LTS: "h:mm:ss A", LT: "h:mm A", L: "MM/DD/YYYY", LL: "MMMM D, YYYY", LLL: "MMMM D, YYYY h:mm A", LLLL: "dddd, MMMM D, YYYY h:mm A" };
    return function(i, o, a) {
      var r = o.prototype, s = r.format;
      a.en.formats = n, r.format = function(l) {
        l === void 0 && (l = "YYYY-MM-DDTHH:mm:ssZ");
        var d = this.$locale().formats, y = function(u, m) {
          return u.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g, function(h, c, g) {
            var v = g && g.toUpperCase();
            return c || m[g] || n[g] || m[v].replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, function(P, f, S) {
              return f || S.slice(1);
            });
          });
        }(l, d === void 0 ? {} : d);
        return s.call(this, y);
      };
    };
  });
})(fS);
var VH = fS.exports;
const GH = /* @__PURE__ */ en(VH);
/*!
  * shared v9.13.1
  * (c) 2024 kazuya kawaguchi
  * Released under the MIT License.
  */
const va = typeof window < "u";
let _i, Cr;
if (process.env.NODE_ENV !== "production") {
  const e = va && window.performance;
  e && e.mark && e.measure && e.clearMarks && // @ts-ignore browser compat
  e.clearMeasures && (_i = (t) => {
    e.mark(t);
  }, Cr = (t, n, i) => {
    e.measure(t, n, i), e.clearMarks(n), e.clearMarks(i);
  });
}
const UH = /\{([0-9a-zA-Z]+)\}/g;
function rg(e, ...t) {
  return t.length === 1 && Xt(t[0]) && (t = t[0]), (!t || !t.hasOwnProperty) && (t = {}), e.replace(UH, (n, i) => t.hasOwnProperty(i) ? t[i] : "");
}
const Ua = (e, t = !1) => t ? Symbol.for(e) : Symbol(e), WH = (e, t, n) => YH({ l: e, k: t, s: n }), YH = (e) => JSON.stringify(e).replace(/\u2028/g, "\\u2028").replace(/\u2029/g, "\\u2029").replace(/\u0027/g, "\\u0027"), Wn = (e) => typeof e == "number" && isFinite(e), qH = (e) => gS(e) === "[object Date]", wu = (e) => gS(e) === "[object RegExp]", rh = (e) => Kt(e) && Object.keys(e).length === 0, ci = Object.assign;
let lb;
const bc = () => lb || (lb = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : typeof global < "u" ? global : {});
function cb(e) {
  return e.replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&apos;");
}
const KH = Object.prototype.hasOwnProperty;
function ku(e, t) {
  return KH.call(e, t);
}
const Dn = Array.isArray, Sn = (e) => typeof e == "function", ft = (e) => typeof e == "string", bn = (e) => typeof e == "boolean", Xt = (e) => e !== null && typeof e == "object", XH = (e) => Xt(e) && Sn(e.then) && Sn(e.catch), mS = Object.prototype.toString, gS = (e) => mS.call(e), Kt = (e) => {
  if (!Xt(e))
    return !1;
  const t = Object.getPrototypeOf(e);
  return t === null || t.constructor === Object;
}, ZH = (e) => e == null ? "" : Dn(e) || Kt(e) && e.toString === mS ? JSON.stringify(e, null, 2) : String(e);
function JH(e, t = "") {
  return e.reduce((n, i, o) => o === 0 ? n + i : n + t + i, "");
}
const db = 2;
function QH(e, t = 0, n = e.length) {
  const i = e.split(/\r?\n/);
  let o = 0;
  const a = [];
  for (let r = 0; r < i.length; r++)
    if (o += i[r].length + 1, o >= t) {
      for (let s = r - db; s <= r + db || n > o; s++) {
        if (s < 0 || s >= i.length)
          continue;
        const l = s + 1;
        a.push(`${l}${" ".repeat(3 - String(l).length)}|  ${i[s]}`);
        const d = i[s].length;
        if (s === r) {
          const y = t - (o - d) + 1, u = Math.max(1, n > o ? d - y : n - t);
          a.push("   |  " + " ".repeat(y) + "^".repeat(u));
        } else if (s > r) {
          if (n > o) {
            const y = Math.max(Math.min(n - o, d), 1);
            a.push("   |  " + "^".repeat(y));
          }
          o += d + 1;
        }
      }
      break;
    }
  return a.join(`
`);
}
function sh(e) {
  let t = e;
  return () => ++t;
}
function xa(e, t) {
  typeof console < "u" && (console.warn("[intlify] " + e), t && console.warn(t.stack));
}
const ub = {};
function vS(e) {
  ub[e] || (ub[e] = !0, xa(e));
}
function yS() {
  const e = /* @__PURE__ */ new Map();
  return {
    events: e,
    on(n, i) {
      const o = e.get(n);
      o && o.push(i) || e.set(n, [i]);
    },
    off(n, i) {
      const o = e.get(n);
      o && o.splice(o.indexOf(i) >>> 0, 1);
    },
    emit(n, i) {
      (e.get(n) || []).slice().map((o) => o(i)), (e.get("*") || []).slice().map((o) => o(n, i));
    }
  };
}
const Ad = (e) => !Xt(e) || Dn(e);
function eu(e, t) {
  if (Ad(e) || Ad(t))
    throw new Error("Invalid value");
  const n = [{ src: e, des: t }];
  for (; n.length; ) {
    const { src: i, des: o } = n.pop();
    Object.keys(i).forEach((a) => {
      Ad(i[a]) || Ad(o[a]) ? o[a] = i[a] : n.push({ src: i[a], des: o[a] });
    });
  }
}
/*!
  * message-compiler v9.13.1
  * (c) 2024 kazuya kawaguchi
  * Released under the MIT License.
  */
function ez(e, t, n) {
  return { line: e, column: t, offset: n };
}
function Su(e, t, n) {
  const i = { start: e, end: t };
  return n != null && (i.source = n), i;
}
const tz = /\{([0-9a-zA-Z]+)\}/g;
function bS(e, ...t) {
  return t.length === 1 && nz(t[0]) && (t = t[0]), (!t || !t.hasOwnProperty) && (t = {}), e.replace(tz, (n, i) => t.hasOwnProperty(i) ? t[i] : "");
}
const xS = Object.assign, hb = (e) => typeof e == "string", nz = (e) => e !== null && typeof e == "object";
function wS(e, t = "") {
  return e.reduce((n, i, o) => o === 0 ? n + i : n + t + i, "");
}
const lh = {
  USE_MODULO_SYNTAX: 1,
  __EXTEND_POINT__: 2
}, iz = {
  [lh.USE_MODULO_SYNTAX]: "Use modulo before '{{0}}'."
};
function az(e, t, ...n) {
  const i = bS(iz[e] || "", ...n || []), o = { message: String(i), code: e };
  return t && (o.location = t), o;
}
const Dt = {
  // tokenizer error codes
  EXPECTED_TOKEN: 1,
  INVALID_TOKEN_IN_PLACEHOLDER: 2,
  UNTERMINATED_SINGLE_QUOTE_IN_PLACEHOLDER: 3,
  UNKNOWN_ESCAPE_SEQUENCE: 4,
  INVALID_UNICODE_ESCAPE_SEQUENCE: 5,
  UNBALANCED_CLOSING_BRACE: 6,
  UNTERMINATED_CLOSING_BRACE: 7,
  EMPTY_PLACEHOLDER: 8,
  NOT_ALLOW_NEST_PLACEHOLDER: 9,
  INVALID_LINKED_FORMAT: 10,
  // parser error codes
  MUST_HAVE_MESSAGES_IN_PLURAL: 11,
  UNEXPECTED_EMPTY_LINKED_MODIFIER: 12,
  UNEXPECTED_EMPTY_LINKED_KEY: 13,
  UNEXPECTED_LEXICAL_ANALYSIS: 14,
  // generator error codes
  UNHANDLED_CODEGEN_NODE_TYPE: 15,
  // minifier error codes
  UNHANDLED_MINIFIER_NODE_TYPE: 16,
  // Special value for higher-order compilers to pick up the last code
  // to avoid collision of error codes. This should always be kept as the last
  // item.
  __EXTEND_POINT__: 17
}, oz = {
  // tokenizer error messages
  [Dt.EXPECTED_TOKEN]: "Expected token: '{0}'",
  [Dt.INVALID_TOKEN_IN_PLACEHOLDER]: "Invalid token in placeholder: '{0}'",
  [Dt.UNTERMINATED_SINGLE_QUOTE_IN_PLACEHOLDER]: "Unterminated single quote in placeholder",
  [Dt.UNKNOWN_ESCAPE_SEQUENCE]: "Unknown escape sequence: \\{0}",
  [Dt.INVALID_UNICODE_ESCAPE_SEQUENCE]: "Invalid unicode escape sequence: {0}",
  [Dt.UNBALANCED_CLOSING_BRACE]: "Unbalanced closing brace",
  [Dt.UNTERMINATED_CLOSING_BRACE]: "Unterminated closing brace",
  [Dt.EMPTY_PLACEHOLDER]: "Empty placeholder",
  [Dt.NOT_ALLOW_NEST_PLACEHOLDER]: "Not allowed nest placeholder",
  [Dt.INVALID_LINKED_FORMAT]: "Invalid linked format",
  // parser error messages
  [Dt.MUST_HAVE_MESSAGES_IN_PLURAL]: "Plural must have messages",
  [Dt.UNEXPECTED_EMPTY_LINKED_MODIFIER]: "Unexpected empty linked modifier",
  [Dt.UNEXPECTED_EMPTY_LINKED_KEY]: "Unexpected empty linked key",
  [Dt.UNEXPECTED_LEXICAL_ANALYSIS]: "Unexpected lexical analysis in token: '{0}'",
  // generator error messages
  [Dt.UNHANDLED_CODEGEN_NODE_TYPE]: "unhandled codegen node type: '{0}'",
  // minimizer error messages
  [Dt.UNHANDLED_MINIFIER_NODE_TYPE]: "unhandled mimifier node type: '{0}'"
};
function Os(e, t, n = {}) {
  const { domain: i, messages: o, args: a } = n, r = bS((o || oz)[e] || "", ...a || []), s = new SyntaxError(String(r));
  return s.code = e, t && (s.location = t), s.domain = i, s;
}
function rz(e) {
  throw e;
}
const sz = /<\/?[\w\s="/.':;#-\/]+>/, lz = (e) => sz.test(e), Za = " ", cz = "\r", hi = `
`, dz = String.fromCharCode(8232), uz = String.fromCharCode(8233);
function hz(e) {
  const t = e;
  let n = 0, i = 1, o = 1, a = 0;
  const r = (A) => t[A] === cz && t[A + 1] === hi, s = (A) => t[A] === hi, l = (A) => t[A] === uz, d = (A) => t[A] === dz, y = (A) => r(A) || s(A) || l(A) || d(A), u = () => n, m = () => i, h = () => o, c = () => a, g = (A) => r(A) || l(A) || d(A) ? hi : t[A], v = () => g(n), P = () => g(n + a);
  function f() {
    return a = 0, y(n) && (i++, o = 0), r(n) && n++, n++, o++, t[n];
  }
  function S() {
    return r(n + a) && a++, a++, t[n + a];
  }
  function w() {
    n = 0, i = 1, o = 1, a = 0;
  }
  function x(A = 0) {
    a = A;
  }
  function k() {
    const A = n + a;
    for (; A !== n; )
      f();
    a = 0;
  }
  return {
    index: u,
    line: m,
    column: h,
    peekOffset: c,
    charAt: g,
    currentChar: v,
    currentPeek: P,
    next: f,
    peek: S,
    reset: w,
    resetPeek: x,
    skipToPeek: k
  };
}
const bo = void 0, pz = ".", pb = "'", fz = "tokenizer";
function mz(e, t = {}) {
  const n = t.location !== !1, i = hz(e), o = () => i.index(), a = () => ez(i.line(), i.column(), i.index()), r = a(), s = o(), l = {
    currentType: 14,
    offset: s,
    startLoc: r,
    endLoc: r,
    lastType: 14,
    lastOffset: s,
    lastStartLoc: r,
    lastEndLoc: r,
    braceNest: 0,
    inLinked: !1,
    text: ""
  }, d = () => l, { onError: y } = t;
  function u(ce, pe, xe, ...le) {
    const se = d();
    if (pe.column += xe, pe.offset += xe, y) {
      const he = n ? Su(se.startLoc, pe) : null, ve = Os(ce, he, {
        domain: fz,
        args: le
      });
      y(ve);
    }
  }
  function m(ce, pe, xe) {
    ce.endLoc = a(), ce.currentType = pe;
    const le = { type: pe };
    return n && (le.loc = Su(ce.startLoc, ce.endLoc)), xe != null && (le.value = xe), le;
  }
  const h = (ce) => m(
    ce,
    14
    /* TokenTypes.EOF */
  );
  function c(ce, pe) {
    return ce.currentChar() === pe ? (ce.next(), pe) : (u(Dt.EXPECTED_TOKEN, a(), 0, pe), "");
  }
  function g(ce) {
    let pe = "";
    for (; ce.currentPeek() === Za || ce.currentPeek() === hi; )
      pe += ce.currentPeek(), ce.peek();
    return pe;
  }
  function v(ce) {
    const pe = g(ce);
    return ce.skipToPeek(), pe;
  }
  function P(ce) {
    if (ce === bo)
      return !1;
    const pe = ce.charCodeAt(0);
    return pe >= 97 && pe <= 122 || // a-z
    pe >= 65 && pe <= 90 || // A-Z
    pe === 95;
  }
  function f(ce) {
    if (ce === bo)
      return !1;
    const pe = ce.charCodeAt(0);
    return pe >= 48 && pe <= 57;
  }
  function S(ce, pe) {
    const { currentType: xe } = pe;
    if (xe !== 2)
      return !1;
    g(ce);
    const le = P(ce.currentPeek());
    return ce.resetPeek(), le;
  }
  function w(ce, pe) {
    const { currentType: xe } = pe;
    if (xe !== 2)
      return !1;
    g(ce);
    const le = ce.currentPeek() === "-" ? ce.peek() : ce.currentPeek(), se = f(le);
    return ce.resetPeek(), se;
  }
  function x(ce, pe) {
    const { currentType: xe } = pe;
    if (xe !== 2)
      return !1;
    g(ce);
    const le = ce.currentPeek() === pb;
    return ce.resetPeek(), le;
  }
  function k(ce, pe) {
    const { currentType: xe } = pe;
    if (xe !== 8)
      return !1;
    g(ce);
    const le = ce.currentPeek() === ".";
    return ce.resetPeek(), le;
  }
  function A(ce, pe) {
    const { currentType: xe } = pe;
    if (xe !== 9)
      return !1;
    g(ce);
    const le = P(ce.currentPeek());
    return ce.resetPeek(), le;
  }
  function $(ce, pe) {
    const { currentType: xe } = pe;
    if (!(xe === 8 || xe === 12))
      return !1;
    g(ce);
    const le = ce.currentPeek() === ":";
    return ce.resetPeek(), le;
  }
  function j(ce, pe) {
    const { currentType: xe } = pe;
    if (xe !== 10)
      return !1;
    const le = () => {
      const he = ce.currentPeek();
      return he === "{" ? P(ce.peek()) : he === "@" || he === "%" || he === "|" || he === ":" || he === "." || he === Za || !he ? !1 : he === hi ? (ce.peek(), le()) : D(ce, !1);
    }, se = le();
    return ce.resetPeek(), se;
  }
  function N(ce) {
    g(ce);
    const pe = ce.currentPeek() === "|";
    return ce.resetPeek(), pe;
  }
  function M(ce) {
    const pe = g(ce), xe = ce.currentPeek() === "%" && ce.peek() === "{";
    return ce.resetPeek(), {
      isModulo: xe,
      hasSpace: pe.length > 0
    };
  }
  function D(ce, pe = !0) {
    const xe = (se = !1, he = "", ve = !1) => {
      const ye = ce.currentPeek();
      return ye === "{" ? he === "%" ? !1 : se : ye === "@" || !ye ? he === "%" ? !0 : se : ye === "%" ? (ce.peek(), xe(se, "%", !0)) : ye === "|" ? he === "%" || ve ? !0 : !(he === Za || he === hi) : ye === Za ? (ce.peek(), xe(!0, Za, ve)) : ye === hi ? (ce.peek(), xe(!0, hi, ve)) : !0;
    }, le = xe();
    return pe && ce.resetPeek(), le;
  }
  function C(ce, pe) {
    const xe = ce.currentChar();
    return xe === bo ? bo : pe(xe) ? (ce.next(), xe) : null;
  }
  function b(ce) {
    const pe = ce.charCodeAt(0);
    return pe >= 97 && pe <= 122 || // a-z
    pe >= 65 && pe <= 90 || // A-Z
    pe >= 48 && pe <= 57 || // 0-9
    pe === 95 || // _
    pe === 36;
  }
  function p(ce) {
    return C(ce, b);
  }
  function L(ce) {
    const pe = ce.charCodeAt(0);
    return pe >= 97 && pe <= 122 || // a-z
    pe >= 65 && pe <= 90 || // A-Z
    pe >= 48 && pe <= 57 || // 0-9
    pe === 95 || // _
    pe === 36 || // $
    pe === 45;
  }
  function B(ce) {
    return C(ce, L);
  }
  function T(ce) {
    const pe = ce.charCodeAt(0);
    return pe >= 48 && pe <= 57;
  }
  function O(ce) {
    return C(ce, T);
  }
  function I(ce) {
    const pe = ce.charCodeAt(0);
    return pe >= 48 && pe <= 57 || // 0-9
    pe >= 65 && pe <= 70 || // A-F
    pe >= 97 && pe <= 102;
  }
  function R(ce) {
    return C(ce, I);
  }
  function Y(ce) {
    let pe = "", xe = "";
    for (; pe = O(ce); )
      xe += pe;
    return xe;
  }
  function F(ce) {
    v(ce);
    const pe = ce.currentChar();
    return pe !== "%" && u(Dt.EXPECTED_TOKEN, a(), 0, pe), ce.next(), "%";
  }
  function U(ce) {
    let pe = "";
    for (; ; ) {
      const xe = ce.currentChar();
      if (xe === "{" || xe === "}" || xe === "@" || xe === "|" || !xe)
        break;
      if (xe === "%")
        if (D(ce))
          pe += xe, ce.next();
        else
          break;
      else if (xe === Za || xe === hi)
        if (D(ce))
          pe += xe, ce.next();
        else {
          if (N(ce))
            break;
          pe += xe, ce.next();
        }
      else
        pe += xe, ce.next();
    }
    return pe;
  }
  function Q(ce) {
    v(ce);
    let pe = "", xe = "";
    for (; pe = B(ce); )
      xe += pe;
    return ce.currentChar() === bo && u(Dt.UNTERMINATED_CLOSING_BRACE, a(), 0), xe;
  }
  function J(ce) {
    v(ce);
    let pe = "";
    return ce.currentChar() === "-" ? (ce.next(), pe += `-${Y(ce)}`) : pe += Y(ce), ce.currentChar() === bo && u(Dt.UNTERMINATED_CLOSING_BRACE, a(), 0), pe;
  }
  function ee(ce) {
    return ce !== pb && ce !== hi;
  }
  function V(ce) {
    v(ce), c(ce, "'");
    let pe = "", xe = "";
    for (; pe = C(ce, ee); )
      pe === "\\" ? xe += G(ce) : xe += pe;
    const le = ce.currentChar();
    return le === hi || le === bo ? (u(Dt.UNTERMINATED_SINGLE_QUOTE_IN_PLACEHOLDER, a(), 0), le === hi && (ce.next(), c(ce, "'")), xe) : (c(ce, "'"), xe);
  }
  function G(ce) {
    const pe = ce.currentChar();
    switch (pe) {
      case "\\":
      case "'":
        return ce.next(), `\\${pe}`;
      case "u":
        return W(ce, pe, 4);
      case "U":
        return W(ce, pe, 6);
      default:
        return u(Dt.UNKNOWN_ESCAPE_SEQUENCE, a(), 0, pe), "";
    }
  }
  function W(ce, pe, xe) {
    c(ce, pe);
    let le = "";
    for (let se = 0; se < xe; se++) {
      const he = R(ce);
      if (!he) {
        u(Dt.INVALID_UNICODE_ESCAPE_SEQUENCE, a(), 0, `\\${pe}${le}${ce.currentChar()}`);
        break;
      }
      le += he;
    }
    return `\\${pe}${le}`;
  }
  function ae(ce) {
    return ce !== "{" && ce !== "}" && ce !== Za && ce !== hi;
  }
  function z(ce) {
    v(ce);
    let pe = "", xe = "";
    for (; pe = C(ce, ae); )
      xe += pe;
    return xe;
  }
  function q(ce) {
    let pe = "", xe = "";
    for (; pe = p(ce); )
      xe += pe;
    return xe;
  }
  function Z(ce) {
    const pe = (xe) => {
      const le = ce.currentChar();
      return le === "{" || le === "%" || le === "@" || le === "|" || le === "(" || le === ")" || !le || le === Za ? xe : (xe += le, ce.next(), pe(xe));
    };
    return pe("");
  }
  function ne(ce) {
    v(ce);
    const pe = c(
      ce,
      "|"
      /* TokenChars.Pipe */
    );
    return v(ce), pe;
  }
  function ie(ce, pe) {
    let xe = null;
    switch (ce.currentChar()) {
      case "{":
        return pe.braceNest >= 1 && u(Dt.NOT_ALLOW_NEST_PLACEHOLDER, a(), 0), ce.next(), xe = m(
          pe,
          2,
          "{"
          /* TokenChars.BraceLeft */
        ), v(ce), pe.braceNest++, xe;
      case "}":
        return pe.braceNest > 0 && pe.currentType === 2 && u(Dt.EMPTY_PLACEHOLDER, a(), 0), ce.next(), xe = m(
          pe,
          3,
          "}"
          /* TokenChars.BraceRight */
        ), pe.braceNest--, pe.braceNest > 0 && v(ce), pe.inLinked && pe.braceNest === 0 && (pe.inLinked = !1), xe;
      case "@":
        return pe.braceNest > 0 && u(Dt.UNTERMINATED_CLOSING_BRACE, a(), 0), xe = re(ce, pe) || h(pe), pe.braceNest = 0, xe;
      default: {
        let se = !0, he = !0, ve = !0;
        if (N(ce))
          return pe.braceNest > 0 && u(Dt.UNTERMINATED_CLOSING_BRACE, a(), 0), xe = m(pe, 1, ne(ce)), pe.braceNest = 0, pe.inLinked = !1, xe;
        if (pe.braceNest > 0 && (pe.currentType === 5 || pe.currentType === 6 || pe.currentType === 7))
          return u(Dt.UNTERMINATED_CLOSING_BRACE, a(), 0), pe.braceNest = 0, de(ce, pe);
        if (se = S(ce, pe))
          return xe = m(pe, 5, Q(ce)), v(ce), xe;
        if (he = w(ce, pe))
          return xe = m(pe, 6, J(ce)), v(ce), xe;
        if (ve = x(ce, pe))
          return xe = m(pe, 7, V(ce)), v(ce), xe;
        if (!se && !he && !ve)
          return xe = m(pe, 13, z(ce)), u(Dt.INVALID_TOKEN_IN_PLACEHOLDER, a(), 0, xe.value), v(ce), xe;
        break;
      }
    }
    return xe;
  }
  function re(ce, pe) {
    const { currentType: xe } = pe;
    let le = null;
    const se = ce.currentChar();
    switch ((xe === 8 || xe === 9 || xe === 12 || xe === 10) && (se === hi || se === Za) && u(Dt.INVALID_LINKED_FORMAT, a(), 0), se) {
      case "@":
        return ce.next(), le = m(
          pe,
          8,
          "@"
          /* TokenChars.LinkedAlias */
        ), pe.inLinked = !0, le;
      case ".":
        return v(ce), ce.next(), m(
          pe,
          9,
          "."
          /* TokenChars.LinkedDot */
        );
      case ":":
        return v(ce), ce.next(), m(
          pe,
          10,
          ":"
          /* TokenChars.LinkedDelimiter */
        );
      default:
        return N(ce) ? (le = m(pe, 1, ne(ce)), pe.braceNest = 0, pe.inLinked = !1, le) : k(ce, pe) || $(ce, pe) ? (v(ce), re(ce, pe)) : A(ce, pe) ? (v(ce), m(pe, 12, q(ce))) : j(ce, pe) ? (v(ce), se === "{" ? ie(ce, pe) || le : m(pe, 11, Z(ce))) : (xe === 8 && u(Dt.INVALID_LINKED_FORMAT, a(), 0), pe.braceNest = 0, pe.inLinked = !1, de(ce, pe));
    }
  }
  function de(ce, pe) {
    let xe = {
      type: 14
      /* TokenTypes.EOF */
    };
    if (pe.braceNest > 0)
      return ie(ce, pe) || h(pe);
    if (pe.inLinked)
      return re(ce, pe) || h(pe);
    switch (ce.currentChar()) {
      case "{":
        return ie(ce, pe) || h(pe);
      case "}":
        return u(Dt.UNBALANCED_CLOSING_BRACE, a(), 0), ce.next(), m(
          pe,
          3,
          "}"
          /* TokenChars.BraceRight */
        );
      case "@":
        return re(ce, pe) || h(pe);
      default: {
        if (N(ce))
          return xe = m(pe, 1, ne(ce)), pe.braceNest = 0, pe.inLinked = !1, xe;
        const { isModulo: se, hasSpace: he } = M(ce);
        if (se)
          return he ? m(pe, 0, U(ce)) : m(pe, 4, F(ce));
        if (D(ce))
          return m(pe, 0, U(ce));
        break;
      }
    }
    return xe;
  }
  function me() {
    const { currentType: ce, offset: pe, startLoc: xe, endLoc: le } = l;
    return l.lastType = ce, l.lastOffset = pe, l.lastStartLoc = xe, l.lastEndLoc = le, l.offset = o(), l.startLoc = a(), i.currentChar() === bo ? m(
      l,
      14
      /* TokenTypes.EOF */
    ) : de(i, l);
  }
  return {
    nextToken: me,
    currentOffset: o,
    currentPosition: a,
    context: d
  };
}
const gz = "parser", vz = /(?:\\\\|\\'|\\u([0-9a-fA-F]{4})|\\U([0-9a-fA-F]{6}))/g;
function yz(e, t, n) {
  switch (e) {
    case "\\\\":
      return "\\";
    case "\\'":
      return "'";
    default: {
      const i = parseInt(t || n, 16);
      return i <= 55295 || i >= 57344 ? String.fromCodePoint(i) : "�";
    }
  }
}
function bz(e = {}) {
  const t = e.location !== !1, { onError: n, onWarn: i } = e;
  function o(S, w, x, k, ...A) {
    const $ = S.currentPosition();
    if ($.offset += k, $.column += k, n) {
      const j = t ? Su(x, $) : null, N = Os(w, j, {
        domain: gz,
        args: A
      });
      n(N);
    }
  }
  function a(S, w, x, k, ...A) {
    const $ = S.currentPosition();
    if ($.offset += k, $.column += k, i) {
      const j = t ? Su(x, $) : null;
      i(az(w, j, A));
    }
  }
  function r(S, w, x) {
    const k = { type: S };
    return t && (k.start = w, k.end = w, k.loc = { start: x, end: x }), k;
  }
  function s(S, w, x, k) {
    k && (S.type = k), t && (S.end = w, S.loc && (S.loc.end = x));
  }
  function l(S, w) {
    const x = S.context(), k = r(3, x.offset, x.startLoc);
    return k.value = w, s(k, S.currentOffset(), S.currentPosition()), k;
  }
  function d(S, w) {
    const x = S.context(), { lastOffset: k, lastStartLoc: A } = x, $ = r(5, k, A);
    return $.index = parseInt(w, 10), S.nextToken(), s($, S.currentOffset(), S.currentPosition()), $;
  }
  function y(S, w, x) {
    const k = S.context(), { lastOffset: A, lastStartLoc: $ } = k, j = r(4, A, $);
    return j.key = w, x === !0 && (j.modulo = !0), S.nextToken(), s(j, S.currentOffset(), S.currentPosition()), j;
  }
  function u(S, w) {
    const x = S.context(), { lastOffset: k, lastStartLoc: A } = x, $ = r(9, k, A);
    return $.value = w.replace(vz, yz), S.nextToken(), s($, S.currentOffset(), S.currentPosition()), $;
  }
  function m(S) {
    const w = S.nextToken(), x = S.context(), { lastOffset: k, lastStartLoc: A } = x, $ = r(8, k, A);
    return w.type !== 12 ? (o(S, Dt.UNEXPECTED_EMPTY_LINKED_MODIFIER, x.lastStartLoc, 0), $.value = "", s($, k, A), {
      nextConsumeToken: w,
      node: $
    }) : (w.value == null && o(S, Dt.UNEXPECTED_LEXICAL_ANALYSIS, x.lastStartLoc, 0, ra(w)), $.value = w.value || "", s($, S.currentOffset(), S.currentPosition()), {
      node: $
    });
  }
  function h(S, w) {
    const x = S.context(), k = r(7, x.offset, x.startLoc);
    return k.value = w, s(k, S.currentOffset(), S.currentPosition()), k;
  }
  function c(S) {
    const w = S.context(), x = r(6, w.offset, w.startLoc);
    let k = S.nextToken();
    if (k.type === 9) {
      const A = m(S);
      x.modifier = A.node, k = A.nextConsumeToken || S.nextToken();
    }
    switch (k.type !== 10 && o(S, Dt.UNEXPECTED_LEXICAL_ANALYSIS, w.lastStartLoc, 0, ra(k)), k = S.nextToken(), k.type === 2 && (k = S.nextToken()), k.type) {
      case 11:
        k.value == null && o(S, Dt.UNEXPECTED_LEXICAL_ANALYSIS, w.lastStartLoc, 0, ra(k)), x.key = h(S, k.value || "");
        break;
      case 5:
        k.value == null && o(S, Dt.UNEXPECTED_LEXICAL_ANALYSIS, w.lastStartLoc, 0, ra(k)), x.key = y(S, k.value || "");
        break;
      case 6:
        k.value == null && o(S, Dt.UNEXPECTED_LEXICAL_ANALYSIS, w.lastStartLoc, 0, ra(k)), x.key = d(S, k.value || "");
        break;
      case 7:
        k.value == null && o(S, Dt.UNEXPECTED_LEXICAL_ANALYSIS, w.lastStartLoc, 0, ra(k)), x.key = u(S, k.value || "");
        break;
      default: {
        o(S, Dt.UNEXPECTED_EMPTY_LINKED_KEY, w.lastStartLoc, 0);
        const A = S.context(), $ = r(7, A.offset, A.startLoc);
        return $.value = "", s($, A.offset, A.startLoc), x.key = $, s(x, A.offset, A.startLoc), {
          nextConsumeToken: k,
          node: x
        };
      }
    }
    return s(x, S.currentOffset(), S.currentPosition()), {
      node: x
    };
  }
  function g(S) {
    const w = S.context(), x = w.currentType === 1 ? S.currentOffset() : w.offset, k = w.currentType === 1 ? w.endLoc : w.startLoc, A = r(2, x, k);
    A.items = [];
    let $ = null, j = null;
    do {
      const D = $ || S.nextToken();
      switch ($ = null, D.type) {
        case 0:
          D.value == null && o(S, Dt.UNEXPECTED_LEXICAL_ANALYSIS, w.lastStartLoc, 0, ra(D)), A.items.push(l(S, D.value || ""));
          break;
        case 6:
          D.value == null && o(S, Dt.UNEXPECTED_LEXICAL_ANALYSIS, w.lastStartLoc, 0, ra(D)), A.items.push(d(S, D.value || ""));
          break;
        case 4:
          j = !0;
          break;
        case 5:
          D.value == null && o(S, Dt.UNEXPECTED_LEXICAL_ANALYSIS, w.lastStartLoc, 0, ra(D)), A.items.push(y(S, D.value || "", !!j)), j && (a(S, lh.USE_MODULO_SYNTAX, w.lastStartLoc, 0, ra(D)), j = null);
          break;
        case 7:
          D.value == null && o(S, Dt.UNEXPECTED_LEXICAL_ANALYSIS, w.lastStartLoc, 0, ra(D)), A.items.push(u(S, D.value || ""));
          break;
        case 8: {
          const C = c(S);
          A.items.push(C.node), $ = C.nextConsumeToken || null;
          break;
        }
      }
    } while (w.currentType !== 14 && w.currentType !== 1);
    const N = w.currentType === 1 ? w.lastOffset : S.currentOffset(), M = w.currentType === 1 ? w.lastEndLoc : S.currentPosition();
    return s(A, N, M), A;
  }
  function v(S, w, x, k) {
    const A = S.context();
    let $ = k.items.length === 0;
    const j = r(1, w, x);
    j.cases = [], j.cases.push(k);
    do {
      const N = g(S);
      $ || ($ = N.items.length === 0), j.cases.push(N);
    } while (A.currentType !== 14);
    return $ && o(S, Dt.MUST_HAVE_MESSAGES_IN_PLURAL, x, 0), s(j, S.currentOffset(), S.currentPosition()), j;
  }
  function P(S) {
    const w = S.context(), { offset: x, startLoc: k } = w, A = g(S);
    return w.currentType === 14 ? A : v(S, x, k, A);
  }
  function f(S) {
    const w = mz(S, xS({}, e)), x = w.context(), k = r(0, x.offset, x.startLoc);
    return t && k.loc && (k.loc.source = S), k.body = P(w), e.onCacheKey && (k.cacheKey = e.onCacheKey(S)), x.currentType !== 14 && o(w, Dt.UNEXPECTED_LEXICAL_ANALYSIS, x.lastStartLoc, 0, S[x.offset] || ""), s(k, w.currentOffset(), w.currentPosition()), k;
  }
  return { parse: f };
}
function ra(e) {
  if (e.type === 14)
    return "EOF";
  const t = (e.value || "").replace(/\r?\n/gu, "\\n");
  return t.length > 10 ? t.slice(0, 9) + "…" : t;
}
function xz(e, t = {}) {
  const n = {
    ast: e,
    helpers: /* @__PURE__ */ new Set()
  };
  return { context: () => n, helper: (a) => (n.helpers.add(a), a) };
}
function fb(e, t) {
  for (let n = 0; n < e.length; n++)
    sg(e[n], t);
}
function sg(e, t) {
  switch (e.type) {
    case 1:
      fb(e.cases, t), t.helper(
        "plural"
        /* HelperNameMap.PLURAL */
      );
      break;
    case 2:
      fb(e.items, t);
      break;
    case 6: {
      sg(e.key, t), t.helper(
        "linked"
        /* HelperNameMap.LINKED */
      ), t.helper(
        "type"
        /* HelperNameMap.TYPE */
      );
      break;
    }
    case 5:
      t.helper(
        "interpolate"
        /* HelperNameMap.INTERPOLATE */
      ), t.helper(
        "list"
        /* HelperNameMap.LIST */
      );
      break;
    case 4:
      t.helper(
        "interpolate"
        /* HelperNameMap.INTERPOLATE */
      ), t.helper(
        "named"
        /* HelperNameMap.NAMED */
      );
      break;
  }
}
function wz(e, t = {}) {
  const n = xz(e);
  n.helper(
    "normalize"
    /* HelperNameMap.NORMALIZE */
  ), e.body && sg(e.body, n);
  const i = n.context();
  e.helpers = Array.from(i.helpers);
}
function kz(e) {
  const t = e.body;
  return t.type === 2 ? mb(t) : t.cases.forEach((n) => mb(n)), e;
}
function mb(e) {
  if (e.items.length === 1) {
    const t = e.items[0];
    (t.type === 3 || t.type === 9) && (e.static = t.value, delete t.value);
  } else {
    const t = [];
    for (let n = 0; n < e.items.length; n++) {
      const i = e.items[n];
      if (!(i.type === 3 || i.type === 9) || i.value == null)
        break;
      t.push(i.value);
    }
    if (t.length === e.items.length) {
      e.static = wS(t);
      for (let n = 0; n < e.items.length; n++) {
        const i = e.items[n];
        (i.type === 3 || i.type === 9) && delete i.value;
      }
    }
  }
}
const Sz = "minifier";
function Yr(e) {
  switch (e.t = e.type, e.type) {
    case 0: {
      const t = e;
      Yr(t.body), t.b = t.body, delete t.body;
      break;
    }
    case 1: {
      const t = e, n = t.cases;
      for (let i = 0; i < n.length; i++)
        Yr(n[i]);
      t.c = n, delete t.cases;
      break;
    }
    case 2: {
      const t = e, n = t.items;
      for (let i = 0; i < n.length; i++)
        Yr(n[i]);
      t.i = n, delete t.items, t.static && (t.s = t.static, delete t.static);
      break;
    }
    case 3:
    case 9:
    case 8:
    case 7: {
      const t = e;
      t.value && (t.v = t.value, delete t.value);
      break;
    }
    case 6: {
      const t = e;
      Yr(t.key), t.k = t.key, delete t.key, t.modifier && (Yr(t.modifier), t.m = t.modifier, delete t.modifier);
      break;
    }
    case 5: {
      const t = e;
      t.i = t.index, delete t.index;
      break;
    }
    case 4: {
      const t = e;
      t.k = t.key, delete t.key;
      break;
    }
    default:
      throw Os(Dt.UNHANDLED_MINIFIER_NODE_TYPE, null, {
        domain: Sz,
        args: [e.type]
      });
  }
  delete e.type;
}
const Cz = "parser";
function Tz(e, t) {
  const { sourceMap: n, filename: i, breakLineCode: o, needIndent: a } = t, r = t.location !== !1, s = {
    filename: i,
    code: "",
    column: 1,
    line: 1,
    offset: 0,
    map: void 0,
    breakLineCode: o,
    needIndent: a,
    indentLevel: 0
  };
  r && e.loc && (s.source = e.loc.source);
  const l = () => s;
  function d(v, P) {
    s.code += v;
  }
  function y(v, P = !0) {
    const f = P ? o : "";
    d(a ? f + "  ".repeat(v) : f);
  }
  function u(v = !0) {
    const P = ++s.indentLevel;
    v && y(P);
  }
  function m(v = !0) {
    const P = --s.indentLevel;
    v && y(P);
  }
  function h() {
    y(s.indentLevel);
  }
  return {
    context: l,
    push: d,
    indent: u,
    deindent: m,
    newline: h,
    helper: (v) => `_${v}`,
    needIndent: () => s.needIndent
  };
}
function Lz(e, t) {
  const { helper: n } = e;
  e.push(`${n(
    "linked"
    /* HelperNameMap.LINKED */
  )}(`), gs(e, t.key), t.modifier ? (e.push(", "), gs(e, t.modifier), e.push(", _type")) : e.push(", undefined, _type"), e.push(")");
}
function Iz(e, t) {
  const { helper: n, needIndent: i } = e;
  e.push(`${n(
    "normalize"
    /* HelperNameMap.NORMALIZE */
  )}([`), e.indent(i());
  const o = t.items.length;
  for (let a = 0; a < o && (gs(e, t.items[a]), a !== o - 1); a++)
    e.push(", ");
  e.deindent(i()), e.push("])");
}
function Pz(e, t) {
  const { helper: n, needIndent: i } = e;
  if (t.cases.length > 1) {
    e.push(`${n(
      "plural"
      /* HelperNameMap.PLURAL */
    )}([`), e.indent(i());
    const o = t.cases.length;
    for (let a = 0; a < o && (gs(e, t.cases[a]), a !== o - 1); a++)
      e.push(", ");
    e.deindent(i()), e.push("])");
  }
}
function Az(e, t) {
  t.body ? gs(e, t.body) : e.push("null");
}
function gs(e, t) {
  const { helper: n } = e;
  switch (t.type) {
    case 0:
      Az(e, t);
      break;
    case 1:
      Pz(e, t);
      break;
    case 2:
      Iz(e, t);
      break;
    case 6:
      Lz(e, t);
      break;
    case 8:
      e.push(JSON.stringify(t.value), t);
      break;
    case 7:
      e.push(JSON.stringify(t.value), t);
      break;
    case 5:
      e.push(`${n(
        "interpolate"
        /* HelperNameMap.INTERPOLATE */
      )}(${n(
        "list"
        /* HelperNameMap.LIST */
      )}(${t.index}))`, t);
      break;
    case 4:
      e.push(`${n(
        "interpolate"
        /* HelperNameMap.INTERPOLATE */
      )}(${n(
        "named"
        /* HelperNameMap.NAMED */
      )}(${JSON.stringify(t.key)}))`, t);
      break;
    case 9:
      e.push(JSON.stringify(t.value), t);
      break;
    case 3:
      e.push(JSON.stringify(t.value), t);
      break;
    default:
      throw Os(Dt.UNHANDLED_CODEGEN_NODE_TYPE, null, {
        domain: Cz,
        args: [t.type]
      });
  }
}
const _z = (e, t = {}) => {
  const n = hb(t.mode) ? t.mode : "normal", i = hb(t.filename) ? t.filename : "message.intl", o = !!t.sourceMap, a = t.breakLineCode != null ? t.breakLineCode : n === "arrow" ? ";" : `
`, r = t.needIndent ? t.needIndent : n !== "arrow", s = e.helpers || [], l = Tz(e, {
    mode: n,
    filename: i,
    sourceMap: o,
    breakLineCode: a,
    needIndent: r
  });
  l.push(n === "normal" ? "function __msg__ (ctx) {" : "(ctx) => {"), l.indent(r), s.length > 0 && (l.push(`const { ${wS(s.map((u) => `${u}: _${u}`), ", ")} } = ctx`), l.newline()), l.push("return "), gs(l, e), l.deindent(r), l.push("}"), delete e.helpers;
  const { code: d, map: y } = l.context();
  return {
    ast: e,
    code: d,
    map: y ? y.toJSON() : void 0
    // eslint-disable-line @typescript-eslint/no-explicit-any
  };
};
function Mz(e, t = {}) {
  const n = xS({}, t), i = !!n.jit, o = !!n.minify, a = n.optimize == null ? !0 : n.optimize, s = bz(n).parse(e);
  return i ? (a && kz(s), o && Yr(s), { ast: s, code: "" }) : (wz(s, n), _z(s, n));
}
/*!
  * core-base v9.13.1
  * (c) 2024 kazuya kawaguchi
  * Released under the MIT License.
  */
function Oz() {
  typeof __INTLIFY_JIT_COMPILATION__ != "boolean" && (bc().__INTLIFY_JIT_COMPILATION__ = !1), typeof __INTLIFY_DROP_MESSAGE_COMPILER__ != "boolean" && (bc().__INTLIFY_DROP_MESSAGE_COMPILER__ = !1);
}
const Uo = [];
Uo[
  0
  /* States.BEFORE_PATH */
] = {
  w: [
    0
    /* States.BEFORE_PATH */
  ],
  i: [
    3,
    0
    /* Actions.APPEND */
  ],
  "[": [
    4
    /* States.IN_SUB_PATH */
  ],
  o: [
    7
    /* States.AFTER_PATH */
  ]
};
Uo[
  1
  /* States.IN_PATH */
] = {
  w: [
    1
    /* States.IN_PATH */
  ],
  ".": [
    2
    /* States.BEFORE_IDENT */
  ],
  "[": [
    4
    /* States.IN_SUB_PATH */
  ],
  o: [
    7
    /* States.AFTER_PATH */
  ]
};
Uo[
  2
  /* States.BEFORE_IDENT */
] = {
  w: [
    2
    /* States.BEFORE_IDENT */
  ],
  i: [
    3,
    0
    /* Actions.APPEND */
  ],
  0: [
    3,
    0
    /* Actions.APPEND */
  ]
};
Uo[
  3
  /* States.IN_IDENT */
] = {
  i: [
    3,
    0
    /* Actions.APPEND */
  ],
  0: [
    3,
    0
    /* Actions.APPEND */
  ],
  w: [
    1,
    1
    /* Actions.PUSH */
  ],
  ".": [
    2,
    1
    /* Actions.PUSH */
  ],
  "[": [
    4,
    1
    /* Actions.PUSH */
  ],
  o: [
    7,
    1
    /* Actions.PUSH */
  ]
};
Uo[
  4
  /* States.IN_SUB_PATH */
] = {
  "'": [
    5,
    0
    /* Actions.APPEND */
  ],
  '"': [
    6,
    0
    /* Actions.APPEND */
  ],
  "[": [
    4,
    2
    /* Actions.INC_SUB_PATH_DEPTH */
  ],
  "]": [
    1,
    3
    /* Actions.PUSH_SUB_PATH */
  ],
  o: 8,
  l: [
    4,
    0
    /* Actions.APPEND */
  ]
};
Uo[
  5
  /* States.IN_SINGLE_QUOTE */
] = {
  "'": [
    4,
    0
    /* Actions.APPEND */
  ],
  o: 8,
  l: [
    5,
    0
    /* Actions.APPEND */
  ]
};
Uo[
  6
  /* States.IN_DOUBLE_QUOTE */
] = {
  '"': [
    4,
    0
    /* Actions.APPEND */
  ],
  o: 8,
  l: [
    6,
    0
    /* Actions.APPEND */
  ]
};
const Bz = /^\s?(?:true|false|-?[\d.]+|'[^']*'|"[^"]*")\s?$/;
function Ez(e) {
  return Bz.test(e);
}
function Dz(e) {
  const t = e.charCodeAt(0), n = e.charCodeAt(e.length - 1);
  return t === n && (t === 34 || t === 39) ? e.slice(1, -1) : e;
}
function Rz(e) {
  if (e == null)
    return "o";
  switch (e.charCodeAt(0)) {
    case 91:
    case 93:
    case 46:
    case 34:
    case 39:
      return e;
    case 95:
    case 36:
    case 45:
      return "i";
    case 9:
    case 10:
    case 13:
    case 160:
    case 65279:
    case 8232:
    case 8233:
      return "w";
  }
  return "i";
}
function Nz(e) {
  const t = e.trim();
  return e.charAt(0) === "0" && isNaN(parseInt(e)) ? !1 : Ez(t) ? Dz(t) : "*" + t;
}
function $z(e) {
  const t = [];
  let n = -1, i = 0, o = 0, a, r, s, l, d, y, u;
  const m = [];
  m[
    0
    /* Actions.APPEND */
  ] = () => {
    r === void 0 ? r = s : r += s;
  }, m[
    1
    /* Actions.PUSH */
  ] = () => {
    r !== void 0 && (t.push(r), r = void 0);
  }, m[
    2
    /* Actions.INC_SUB_PATH_DEPTH */
  ] = () => {
    m[
      0
      /* Actions.APPEND */
    ](), o++;
  }, m[
    3
    /* Actions.PUSH_SUB_PATH */
  ] = () => {
    if (o > 0)
      o--, i = 4, m[
        0
        /* Actions.APPEND */
      ]();
    else {
      if (o = 0, r === void 0 || (r = Nz(r), r === !1))
        return !1;
      m[
        1
        /* Actions.PUSH */
      ]();
    }
  };
  function h() {
    const c = e[n + 1];
    if (i === 5 && c === "'" || i === 6 && c === '"')
      return n++, s = "\\" + c, m[
        0
        /* Actions.APPEND */
      ](), !0;
  }
  for (; i !== null; )
    if (n++, a = e[n], !(a === "\\" && h())) {
      if (l = Rz(a), u = Uo[i], d = u[l] || u.l || 8, d === 8 || (i = d[0], d[1] !== void 0 && (y = m[d[1]], y && (s = a, y() === !1))))
        return;
      if (i === 7)
        return t;
    }
}
const gb = /* @__PURE__ */ new Map();
function Fz(e, t) {
  return Xt(e) ? e[t] : null;
}
function jz(e, t) {
  if (!Xt(e))
    return null;
  let n = gb.get(t);
  if (n || (n = $z(t), n && gb.set(t, n)), !n)
    return null;
  const i = n.length;
  let o = e, a = 0;
  for (; a < i; ) {
    const r = o[n[a]];
    if (r === void 0 || Sn(o))
      return null;
    o = r, a++;
  }
  return o;
}
const Hz = (e) => e, zz = (e) => "", Vz = "text", Gz = (e) => e.length === 0 ? "" : JH(e), Uz = ZH;
function vb(e, t) {
  return e = Math.abs(e), t === 2 ? e ? e > 1 ? 1 : 0 : 1 : e ? Math.min(e, 2) : 0;
}
function Wz(e) {
  const t = Wn(e.pluralIndex) ? e.pluralIndex : -1;
  return e.named && (Wn(e.named.count) || Wn(e.named.n)) ? Wn(e.named.count) ? e.named.count : Wn(e.named.n) ? e.named.n : t : t;
}
function Yz(e, t) {
  t.count || (t.count = e), t.n || (t.n = e);
}
function qz(e = {}) {
  const t = e.locale, n = Wz(e), i = Xt(e.pluralRules) && ft(t) && Sn(e.pluralRules[t]) ? e.pluralRules[t] : vb, o = Xt(e.pluralRules) && ft(t) && Sn(e.pluralRules[t]) ? vb : void 0, a = (P) => P[i(n, P.length, o)], r = e.list || [], s = (P) => r[P], l = e.named || {};
  Wn(e.pluralIndex) && Yz(n, l);
  const d = (P) => l[P];
  function y(P) {
    const f = Sn(e.messages) ? e.messages(P) : Xt(e.messages) ? e.messages[P] : !1;
    return f || (e.parent ? e.parent.message(P) : zz);
  }
  const u = (P) => e.modifiers ? e.modifiers[P] : Hz, m = Kt(e.processor) && Sn(e.processor.normalize) ? e.processor.normalize : Gz, h = Kt(e.processor) && Sn(e.processor.interpolate) ? e.processor.interpolate : Uz, c = Kt(e.processor) && ft(e.processor.type) ? e.processor.type : Vz, v = {
    list: s,
    named: d,
    plural: a,
    linked: (P, ...f) => {
      const [S, w] = f;
      let x = "text", k = "";
      f.length === 1 ? Xt(S) ? (k = S.modifier || k, x = S.type || x) : ft(S) && (k = S || k) : f.length === 2 && (ft(S) && (k = S || k), ft(w) && (x = w || x));
      const A = y(P)(v), $ = (
        // The message in vnode resolved with linked are returned as an array by processor.nomalize
        x === "vnode" && Dn(A) && k ? A[0] : A
      );
      return k ? u(k)($, x) : $;
    },
    message: y,
    type: c,
    interpolate: h,
    normalize: m,
    values: ci({}, r, l)
  };
  return v;
}
let xc = null;
function Kz(e) {
  xc = e;
}
function Xz(e, t, n) {
  xc && xc.emit("i18n:init", {
    timestamp: Date.now(),
    i18n: e,
    version: t,
    meta: n
  });
}
const Zz = /* @__PURE__ */ Jz(
  "function:translate"
  /* IntlifyDevToolsHooks.FunctionTranslate */
);
function Jz(e) {
  return (t) => xc && xc.emit(e, t);
}
const kS = lh.__EXTEND_POINT__, Jo = sh(kS), pi = {
  NOT_FOUND_KEY: kS,
  // 2
  FALLBACK_TO_TRANSLATE: Jo(),
  // 3
  CANNOT_FORMAT_NUMBER: Jo(),
  // 4
  FALLBACK_TO_NUMBER_FORMAT: Jo(),
  // 5
  CANNOT_FORMAT_DATE: Jo(),
  // 6
  FALLBACK_TO_DATE_FORMAT: Jo(),
  // 7
  EXPERIMENTAL_CUSTOM_MESSAGE_COMPILER: Jo(),
  // 8
  __EXTEND_POINT__: Jo()
  // 9
}, Qz = {
  [pi.NOT_FOUND_KEY]: "Not found '{key}' key in '{locale}' locale messages.",
  [pi.FALLBACK_TO_TRANSLATE]: "Fall back to translate '{key}' key with '{target}' locale.",
  [pi.CANNOT_FORMAT_NUMBER]: "Cannot format a number value due to not supported Intl.NumberFormat.",
  [pi.FALLBACK_TO_NUMBER_FORMAT]: "Fall back to number format '{key}' key with '{target}' locale.",
  [pi.CANNOT_FORMAT_DATE]: "Cannot format a date value due to not supported Intl.DateTimeFormat.",
  [pi.FALLBACK_TO_DATE_FORMAT]: "Fall back to datetime format '{key}' key with '{target}' locale.",
  [pi.EXPERIMENTAL_CUSTOM_MESSAGE_COMPILER]: "This project is using Custom Message Compiler, which is an experimental feature. It may receive breaking changes or be removed in the future."
};
function Tr(e, ...t) {
  return rg(Qz[e], ...t);
}
const SS = Dt.__EXTEND_POINT__, Qo = sh(SS), Un = {
  INVALID_ARGUMENT: SS,
  // 17
  INVALID_DATE_ARGUMENT: Qo(),
  // 18
  INVALID_ISO_DATE_ARGUMENT: Qo(),
  // 19
  NOT_SUPPORT_NON_STRING_MESSAGE: Qo(),
  // 20
  NOT_SUPPORT_LOCALE_PROMISE_VALUE: Qo(),
  // 21
  NOT_SUPPORT_LOCALE_ASYNC_FUNCTION: Qo(),
  // 22
  NOT_SUPPORT_LOCALE_TYPE: Qo(),
  // 23
  __EXTEND_POINT__: Qo()
  // 24
};
function La(e) {
  return Os(e, null, process.env.NODE_ENV !== "production" ? { messages: eV } : void 0);
}
const eV = {
  [Un.INVALID_ARGUMENT]: "Invalid arguments",
  [Un.INVALID_DATE_ARGUMENT]: "The date provided is an invalid Date object.Make sure your Date represents a valid date.",
  [Un.INVALID_ISO_DATE_ARGUMENT]: "The argument provided is not a valid ISO date string",
  [Un.NOT_SUPPORT_NON_STRING_MESSAGE]: "Not support non-string message",
  [Un.NOT_SUPPORT_LOCALE_PROMISE_VALUE]: "cannot support promise value",
  [Un.NOT_SUPPORT_LOCALE_ASYNC_FUNCTION]: "cannot support async function",
  [Un.NOT_SUPPORT_LOCALE_TYPE]: "cannot support locale type"
};
function lg(e, t) {
  return t.locale != null ? yb(t.locale) : yb(e.locale);
}
let gp;
function yb(e) {
  if (ft(e))
    return e;
  if (Sn(e)) {
    if (e.resolvedOnce && gp != null)
      return gp;
    if (e.constructor.name === "Function") {
      const t = e();
      if (XH(t))
        throw La(Un.NOT_SUPPORT_LOCALE_PROMISE_VALUE);
      return gp = t;
    } else
      throw La(Un.NOT_SUPPORT_LOCALE_ASYNC_FUNCTION);
  } else
    throw La(Un.NOT_SUPPORT_LOCALE_TYPE);
}
function tV(e, t, n) {
  return [.../* @__PURE__ */ new Set([
    n,
    ...Dn(t) ? t : Xt(t) ? Object.keys(t) : ft(t) ? [t] : [n]
  ])];
}
function CS(e, t, n) {
  const i = ft(n) ? n : Cu, o = e;
  o.__localeChainCache || (o.__localeChainCache = /* @__PURE__ */ new Map());
  let a = o.__localeChainCache.get(i);
  if (!a) {
    a = [];
    let r = [n];
    for (; Dn(r); )
      r = bb(a, r, t);
    const s = Dn(t) || !Kt(t) ? t : t.default ? t.default : null;
    r = ft(s) ? [s] : s, Dn(r) && bb(a, r, !1), o.__localeChainCache.set(i, a);
  }
  return a;
}
function bb(e, t, n) {
  let i = !0;
  for (let o = 0; o < t.length && bn(i); o++) {
    const a = t[o];
    ft(a) && (i = nV(e, t[o], n));
  }
  return i;
}
function nV(e, t, n) {
  let i;
  const o = t.split("-");
  do {
    const a = o.join("-");
    i = iV(e, a, n), o.splice(-1, 1);
  } while (o.length && i === !0);
  return i;
}
function iV(e, t, n) {
  let i = !1;
  if (!e.includes(t) && (i = !0, t)) {
    i = t[t.length - 1] !== "!";
    const o = t.replace(/!/g, "");
    e.push(o), (Dn(n) || Kt(n)) && n[o] && (i = n[o]);
  }
  return i;
}
const aV = "9.13.1", ch = -1, Cu = "en-US", Tu = "", xb = (e) => `${e.charAt(0).toLocaleUpperCase()}${e.substr(1)}`;
function oV() {
  return {
    upper: (e, t) => t === "text" && ft(e) ? e.toUpperCase() : t === "vnode" && Xt(e) && "__v_isVNode" in e ? e.children.toUpperCase() : e,
    lower: (e, t) => t === "text" && ft(e) ? e.toLowerCase() : t === "vnode" && Xt(e) && "__v_isVNode" in e ? e.children.toLowerCase() : e,
    capitalize: (e, t) => t === "text" && ft(e) ? xb(e) : t === "vnode" && Xt(e) && "__v_isVNode" in e ? xb(e.children) : e
  };
}
let TS;
function wb(e) {
  TS = e;
}
let LS;
function rV(e) {
  LS = e;
}
let IS;
function sV(e) {
  IS = e;
}
let PS = null;
const lV = /* @__NO_SIDE_EFFECTS__ */ (e) => {
  PS = e;
}, cV = /* @__NO_SIDE_EFFECTS__ */ () => PS;
let AS = null;
const kb = (e) => {
  AS = e;
}, dV = () => AS;
let Sb = 0;
function uV(e = {}) {
  const t = Sn(e.onWarn) ? e.onWarn : xa, n = ft(e.version) ? e.version : aV, i = ft(e.locale) || Sn(e.locale) ? e.locale : Cu, o = Sn(i) ? Cu : i, a = Dn(e.fallbackLocale) || Kt(e.fallbackLocale) || ft(e.fallbackLocale) || e.fallbackLocale === !1 ? e.fallbackLocale : o, r = Kt(e.messages) ? e.messages : { [o]: {} }, s = Kt(e.datetimeFormats) ? e.datetimeFormats : { [o]: {} }, l = Kt(e.numberFormats) ? e.numberFormats : { [o]: {} }, d = ci({}, e.modifiers || {}, oV()), y = e.pluralRules || {}, u = Sn(e.missing) ? e.missing : null, m = bn(e.missingWarn) || wu(e.missingWarn) ? e.missingWarn : !0, h = bn(e.fallbackWarn) || wu(e.fallbackWarn) ? e.fallbackWarn : !0, c = !!e.fallbackFormat, g = !!e.unresolving, v = Sn(e.postTranslation) ? e.postTranslation : null, P = Kt(e.processor) ? e.processor : null, f = bn(e.warnHtmlMessage) ? e.warnHtmlMessage : !0, S = !!e.escapeParameter, w = Sn(e.messageCompiler) ? e.messageCompiler : TS;
  process.env.NODE_ENV !== "production" && Sn(e.messageCompiler) && vS(Tr(pi.EXPERIMENTAL_CUSTOM_MESSAGE_COMPILER));
  const x = Sn(e.messageResolver) ? e.messageResolver : LS || Fz, k = Sn(e.localeFallbacker) ? e.localeFallbacker : IS || tV, A = Xt(e.fallbackContext) ? e.fallbackContext : void 0, $ = e, j = Xt($.__datetimeFormatters) ? $.__datetimeFormatters : /* @__PURE__ */ new Map(), N = Xt($.__numberFormatters) ? $.__numberFormatters : /* @__PURE__ */ new Map(), M = Xt($.__meta) ? $.__meta : {};
  Sb++;
  const D = {
    version: n,
    cid: Sb,
    locale: i,
    fallbackLocale: a,
    messages: r,
    modifiers: d,
    pluralRules: y,
    missing: u,
    missingWarn: m,
    fallbackWarn: h,
    fallbackFormat: c,
    unresolving: g,
    postTranslation: v,
    processor: P,
    warnHtmlMessage: f,
    escapeParameter: S,
    messageCompiler: w,
    messageResolver: x,
    localeFallbacker: k,
    fallbackContext: A,
    onWarn: t,
    __meta: M
  };
  return D.datetimeFormats = s, D.numberFormats = l, D.__datetimeFormatters = j, D.__numberFormatters = N, process.env.NODE_ENV !== "production" && (D.__v_emitter = $.__v_emitter != null ? $.__v_emitter : void 0), process.env.NODE_ENV !== "production" && Xz(D, n, M), D;
}
function dh(e, t) {
  return e instanceof RegExp ? e.test(t) : e;
}
function _S(e, t) {
  return e instanceof RegExp ? e.test(t) : e;
}
function cg(e, t, n, i, o) {
  const { missing: a, onWarn: r } = e;
  if (process.env.NODE_ENV !== "production") {
    const s = e.__v_emitter;
    s && s.emit("missing", {
      locale: n,
      key: t,
      type: o,
      groupId: `${o}:${t}`
    });
  }
  if (a !== null) {
    const s = a(e, n, t, o);
    return ft(s) ? s : t;
  } else
    return process.env.NODE_ENV !== "production" && _S(i, t) && r(Tr(pi.NOT_FOUND_KEY, { key: t, locale: n })), t;
}
function rl(e, t, n) {
  const i = e;
  i.__localeChainCache = /* @__PURE__ */ new Map(), e.localeFallbacker(e, n, t);
}
function MS(e, t) {
  return e === t ? !1 : e.split("-")[0] === t.split("-")[0];
}
function hV(e, t) {
  const n = t.indexOf(e);
  if (n === -1)
    return !1;
  for (let i = n + 1; i < t.length; i++)
    if (MS(e, t[i]))
      return !0;
  return !1;
}
function vp(e) {
  return (n) => pV(n, e);
}
function pV(e, t) {
  const n = t.b || t.body;
  if ((n.t || n.type) === 1) {
    const i = n, o = i.c || i.cases;
    return e.plural(o.reduce((a, r) => [
      ...a,
      Cb(e, r)
    ], []));
  } else
    return Cb(e, n);
}
function Cb(e, t) {
  const n = t.s || t.static;
  if (n)
    return e.type === "text" ? n : e.normalize([n]);
  {
    const i = (t.i || t.items).reduce((o, a) => [...o, vf(e, a)], []);
    return e.normalize(i);
  }
}
function vf(e, t) {
  const n = t.t || t.type;
  switch (n) {
    case 3: {
      const i = t;
      return i.v || i.value;
    }
    case 9: {
      const i = t;
      return i.v || i.value;
    }
    case 4: {
      const i = t;
      return e.interpolate(e.named(i.k || i.key));
    }
    case 5: {
      const i = t;
      return e.interpolate(e.list(i.i != null ? i.i : i.index));
    }
    case 6: {
      const i = t, o = i.m || i.modifier;
      return e.linked(vf(e, i.k || i.key), o ? vf(e, o) : void 0, e.type);
    }
    case 7: {
      const i = t;
      return i.v || i.value;
    }
    case 8: {
      const i = t;
      return i.v || i.value;
    }
    default:
      throw new Error(`unhandled node type on format message part: ${n}`);
  }
}
const fV = "Detected HTML in '{source}' message. Recommend not using HTML messages to avoid XSS.";
function OS(e, t) {
  t && lz(e) && xa(rg(fV, { source: e }));
}
const BS = (e) => e;
let Zr = /* @__PURE__ */ Object.create(null);
function ES(e) {
  e.code === lh.USE_MODULO_SYNTAX && xa(`The use of named interpolation with modulo syntax is deprecated. It will be removed in v10.
reference: https://vue-i18n.intlify.dev/guide/essentials/syntax#rails-i18n-format 
(message compiler warning message: ${e.message})`);
}
const Do = (e) => Xt(e) && (e.t === 0 || e.type === 0) && ("b" in e || "body" in e);
function DS(e, t = {}) {
  let n = !1;
  const i = t.onError || rz;
  return t.onError = (o) => {
    n = !0, i(o);
  }, { ...Mz(e, t), detectError: n };
}
const mV = /* @__NO_SIDE_EFFECTS__ */ (e, t) => {
  if (!ft(e))
    throw La(Un.NOT_SUPPORT_NON_STRING_MESSAGE);
  process.env.NODE_ENV !== "production" && (t.onWarn = ES);
  {
    const n = bn(t.warnHtmlMessage) ? t.warnHtmlMessage : !0;
    process.env.NODE_ENV !== "production" && OS(e, n);
    const o = (t.onCacheKey || BS)(e), a = Zr[o];
    if (a)
      return a;
    const { code: r, detectError: s } = DS(e, t), l = new Function(`return ${r}`)();
    return s ? l : Zr[o] = l;
  }
};
function gV(e, t) {
  if (process.env.NODE_ENV !== "production" && (t.onWarn = ES), __INTLIFY_JIT_COMPILATION__ && !__INTLIFY_DROP_MESSAGE_COMPILER__ && ft(e)) {
    const n = bn(t.warnHtmlMessage) ? t.warnHtmlMessage : !0;
    process.env.NODE_ENV !== "production" && OS(e, n);
    const o = (t.onCacheKey || BS)(e), a = Zr[o];
    if (a)
      return a;
    const { ast: r, detectError: s } = DS(e, {
      ...t,
      location: process.env.NODE_ENV !== "production",
      jit: !0
    }), l = vp(r);
    return s ? l : Zr[o] = l;
  } else {
    if (process.env.NODE_ENV !== "production" && !Do(e))
      return xa(`the message that is resolve with key '${t.key}' is not supported for jit compilation`), () => e;
    const n = e.cacheKey;
    if (n) {
      const i = Zr[n];
      return i || (Zr[n] = vp(e));
    } else
      return vp(e);
  }
}
const Tb = () => "", Gi = (e) => Sn(e);
function Lb(e, ...t) {
  const { fallbackFormat: n, postTranslation: i, unresolving: o, messageCompiler: a, fallbackLocale: r, messages: s } = e, [l, d] = yf(...t), y = bn(d.missingWarn) ? d.missingWarn : e.missingWarn, u = bn(d.fallbackWarn) ? d.fallbackWarn : e.fallbackWarn, m = bn(d.escapeParameter) ? d.escapeParameter : e.escapeParameter, h = !!d.resolvedMessage, c = ft(d.default) || bn(d.default) ? bn(d.default) ? a ? l : () => l : d.default : n ? a ? l : () => l : "", g = n || c !== "", v = lg(e, d);
  m && vV(d);
  let [P, f, S] = h ? [
    l,
    v,
    s[v] || {}
  ] : RS(e, l, v, r, u, y), w = P, x = l;
  if (!h && !(ft(w) || Do(w) || Gi(w)) && g && (w = c, x = w), !h && (!(ft(w) || Do(w) || Gi(w)) || !ft(f)))
    return o ? ch : l;
  if (process.env.NODE_ENV !== "production" && ft(w) && e.messageCompiler == null)
    return xa(`The message format compilation is not supported in this build. Because message compiler isn't included. You need to pre-compilation all message format. So translate function return '${l}'.`), l;
  let k = !1;
  const A = () => {
    k = !0;
  }, $ = Gi(w) ? w : NS(e, l, f, w, x, A);
  if (k)
    return w;
  const j = wV(e, f, S, d), N = qz(j), M = yV(e, $, N), D = i ? i(M, l) : M;
  if (process.env.NODE_ENV !== "production") {
    const C = {
      timestamp: Date.now(),
      key: ft(l) ? l : Gi(w) ? w.key : "",
      locale: f || (Gi(w) ? w.locale : ""),
      format: ft(w) ? w : Gi(w) ? w.source : "",
      message: D
    };
    C.meta = ci({}, e.__meta, /* @__PURE__ */ cV() || {}), Zz(C);
  }
  return D;
}
function vV(e) {
  Dn(e.list) ? e.list = e.list.map((t) => ft(t) ? cb(t) : t) : Xt(e.named) && Object.keys(e.named).forEach((t) => {
    ft(e.named[t]) && (e.named[t] = cb(e.named[t]));
  });
}
function RS(e, t, n, i, o, a) {
  const { messages: r, onWarn: s, messageResolver: l, localeFallbacker: d } = e, y = d(e, i, n);
  let u = {}, m, h = null, c = n, g = null;
  const v = "translate";
  for (let P = 0; P < y.length; P++) {
    if (m = g = y[P], process.env.NODE_ENV !== "production" && n !== m && !MS(n, m) && dh(o, t) && s(Tr(pi.FALLBACK_TO_TRANSLATE, {
      key: t,
      target: m
    })), process.env.NODE_ENV !== "production" && n !== m) {
      const x = e.__v_emitter;
      x && x.emit("fallback", {
        type: v,
        key: t,
        from: c,
        to: g,
        groupId: `${v}:${t}`
      });
    }
    u = r[m] || {};
    let f = null, S, w;
    if (process.env.NODE_ENV !== "production" && va && (f = window.performance.now(), S = "intlify-message-resolve-start", w = "intlify-message-resolve-end", _i && _i(S)), (h = l(u, t)) === null && (h = u[t]), process.env.NODE_ENV !== "production" && va) {
      const x = window.performance.now(), k = e.__v_emitter;
      k && f && h && k.emit("message-resolve", {
        type: "message-resolve",
        key: t,
        message: h,
        time: x - f,
        groupId: `${v}:${t}`
      }), S && w && _i && Cr && (_i(w), Cr("intlify message resolve", S, w));
    }
    if (ft(h) || Do(h) || Gi(h))
      break;
    if (!hV(m, y)) {
      const x = cg(
        e,
        // eslint-disable-line @typescript-eslint/no-explicit-any
        t,
        m,
        a,
        v
      );
      x !== t && (h = x);
    }
    c = g;
  }
  return [h, m, u];
}
function NS(e, t, n, i, o, a) {
  const { messageCompiler: r, warnHtmlMessage: s } = e;
  if (Gi(i)) {
    const m = i;
    return m.locale = m.locale || n, m.key = m.key || t, m;
  }
  if (r == null) {
    const m = () => i;
    return m.locale = n, m.key = t, m;
  }
  let l = null, d, y;
  process.env.NODE_ENV !== "production" && va && (l = window.performance.now(), d = "intlify-message-compilation-start", y = "intlify-message-compilation-end", _i && _i(d));
  const u = r(i, bV(e, n, o, i, s, a));
  if (process.env.NODE_ENV !== "production" && va) {
    const m = window.performance.now(), h = e.__v_emitter;
    h && l && h.emit("message-compilation", {
      type: "message-compilation",
      message: i,
      time: m - l,
      groupId: `translate:${t}`
    }), d && y && _i && Cr && (_i(y), Cr("intlify message compilation", d, y));
  }
  return u.locale = n, u.key = t, u.source = i, u;
}
function yV(e, t, n) {
  let i = null, o, a;
  process.env.NODE_ENV !== "production" && va && (i = window.performance.now(), o = "intlify-message-evaluation-start", a = "intlify-message-evaluation-end", _i && _i(o));
  const r = t(n);
  if (process.env.NODE_ENV !== "production" && va) {
    const s = window.performance.now(), l = e.__v_emitter;
    l && i && l.emit("message-evaluation", {
      type: "message-evaluation",
      value: r,
      time: s - i,
      groupId: `translate:${t.key}`
    }), o && a && _i && Cr && (_i(a), Cr("intlify message evaluation", o, a));
  }
  return r;
}
function yf(...e) {
  const [t, n, i] = e, o = {};
  if (!ft(t) && !Wn(t) && !Gi(t) && !Do(t))
    throw La(Un.INVALID_ARGUMENT);
  const a = Wn(t) ? String(t) : (Gi(t), t);
  return Wn(n) ? o.plural = n : ft(n) ? o.default = n : Kt(n) && !rh(n) ? o.named = n : Dn(n) && (o.list = n), Wn(i) ? o.plural = i : ft(i) ? o.default = i : Kt(i) && ci(o, i), [a, o];
}
function bV(e, t, n, i, o, a) {
  return {
    locale: t,
    key: n,
    warnHtmlMessage: o,
    onError: (r) => {
      if (a && a(r), process.env.NODE_ENV !== "production") {
        const s = xV(i), l = `Message compilation error: ${r.message}`, d = r.location && s && QH(s, r.location.start.offset, r.location.end.offset), y = e.__v_emitter;
        y && s && y.emit("compile-error", {
          message: s,
          error: r.message,
          start: r.location && r.location.start.offset,
          end: r.location && r.location.end.offset,
          groupId: `translate:${n}`
        }), console.error(d ? `${l}
${d}` : l);
      } else
        throw r;
    },
    onCacheKey: (r) => WH(t, n, r)
  };
}
function xV(e) {
  if (ft(e))
    return e;
  if (e.loc && e.loc.source)
    return e.loc.source;
}
function wV(e, t, n, i) {
  const { modifiers: o, pluralRules: a, messageResolver: r, fallbackLocale: s, fallbackWarn: l, missingWarn: d, fallbackContext: y } = e, m = {
    locale: t,
    modifiers: o,
    pluralRules: a,
    messages: (h) => {
      let c = r(n, h);
      if (c == null && y) {
        const [, , g] = RS(y, h, t, s, l, d);
        c = r(g, h);
      }
      if (ft(c) || Do(c)) {
        let g = !1;
        const P = NS(e, h, t, c, h, () => {
          g = !0;
        });
        return g ? Tb : P;
      } else
        return Gi(c) ? c : Tb;
    }
  };
  return e.processor && (m.processor = e.processor), i.list && (m.list = i.list), i.named && (m.named = i.named), Wn(i.plural) && (m.pluralIndex = i.plural), m;
}
const Ib = typeof Intl < "u", $S = {
  dateTimeFormat: Ib && typeof Intl.DateTimeFormat < "u",
  numberFormat: Ib && typeof Intl.NumberFormat < "u"
};
function Pb(e, ...t) {
  const { datetimeFormats: n, unresolving: i, fallbackLocale: o, onWarn: a, localeFallbacker: r } = e, { __datetimeFormatters: s } = e;
  if (process.env.NODE_ENV !== "production" && !$S.dateTimeFormat)
    return a(Tr(pi.CANNOT_FORMAT_DATE)), Tu;
  const [l, d, y, u] = bf(...t), m = bn(y.missingWarn) ? y.missingWarn : e.missingWarn, h = bn(y.fallbackWarn) ? y.fallbackWarn : e.fallbackWarn, c = !!y.part, g = lg(e, y), v = r(
    e,
    // eslint-disable-line @typescript-eslint/no-explicit-any
    o,
    g
  );
  if (!ft(l) || l === "")
    return new Intl.DateTimeFormat(g, u).format(d);
  let P = {}, f, S = null, w = g, x = null;
  const k = "datetime format";
  for (let j = 0; j < v.length; j++) {
    if (f = x = v[j], process.env.NODE_ENV !== "production" && g !== f && dh(h, l) && a(Tr(pi.FALLBACK_TO_DATE_FORMAT, {
      key: l,
      target: f
    })), process.env.NODE_ENV !== "production" && g !== f) {
      const N = e.__v_emitter;
      N && N.emit("fallback", {
        type: k,
        key: l,
        from: w,
        to: x,
        groupId: `${k}:${l}`
      });
    }
    if (P = n[f] || {}, S = P[l], Kt(S))
      break;
    cg(e, l, f, m, k), w = x;
  }
  if (!Kt(S) || !ft(f))
    return i ? ch : l;
  let A = `${f}__${l}`;
  rh(u) || (A = `${A}__${JSON.stringify(u)}`);
  let $ = s.get(A);
  return $ || ($ = new Intl.DateTimeFormat(f, ci({}, S, u)), s.set(A, $)), c ? $.formatToParts(d) : $.format(d);
}
const FS = [
  "localeMatcher",
  "weekday",
  "era",
  "year",
  "month",
  "day",
  "hour",
  "minute",
  "second",
  "timeZoneName",
  "formatMatcher",
  "hour12",
  "timeZone",
  "dateStyle",
  "timeStyle",
  "calendar",
  "dayPeriod",
  "numberingSystem",
  "hourCycle",
  "fractionalSecondDigits"
];
function bf(...e) {
  const [t, n, i, o] = e, a = {};
  let r = {}, s;
  if (ft(t)) {
    const l = t.match(/(\d{4}-\d{2}-\d{2})(T|\s)?(.*)/);
    if (!l)
      throw La(Un.INVALID_ISO_DATE_ARGUMENT);
    const d = l[3] ? l[3].trim().startsWith("T") ? `${l[1].trim()}${l[3].trim()}` : `${l[1].trim()}T${l[3].trim()}` : l[1].trim();
    s = new Date(d);
    try {
      s.toISOString();
    } catch {
      throw La(Un.INVALID_ISO_DATE_ARGUMENT);
    }
  } else if (qH(t)) {
    if (isNaN(t.getTime()))
      throw La(Un.INVALID_DATE_ARGUMENT);
    s = t;
  } else if (Wn(t))
    s = t;
  else
    throw La(Un.INVALID_ARGUMENT);
  return ft(n) ? a.key = n : Kt(n) && Object.keys(n).forEach((l) => {
    FS.includes(l) ? r[l] = n[l] : a[l] = n[l];
  }), ft(i) ? a.locale = i : Kt(i) && (r = i), Kt(o) && (r = o), [a.key || "", s, a, r];
}
function Ab(e, t, n) {
  const i = e;
  for (const o in n) {
    const a = `${t}__${o}`;
    i.__datetimeFormatters.has(a) && i.__datetimeFormatters.delete(a);
  }
}
function _b(e, ...t) {
  const { numberFormats: n, unresolving: i, fallbackLocale: o, onWarn: a, localeFallbacker: r } = e, { __numberFormatters: s } = e;
  if (process.env.NODE_ENV !== "production" && !$S.numberFormat)
    return a(Tr(pi.CANNOT_FORMAT_NUMBER)), Tu;
  const [l, d, y, u] = xf(...t), m = bn(y.missingWarn) ? y.missingWarn : e.missingWarn, h = bn(y.fallbackWarn) ? y.fallbackWarn : e.fallbackWarn, c = !!y.part, g = lg(e, y), v = r(
    e,
    // eslint-disable-line @typescript-eslint/no-explicit-any
    o,
    g
  );
  if (!ft(l) || l === "")
    return new Intl.NumberFormat(g, u).format(d);
  let P = {}, f, S = null, w = g, x = null;
  const k = "number format";
  for (let j = 0; j < v.length; j++) {
    if (f = x = v[j], process.env.NODE_ENV !== "production" && g !== f && dh(h, l) && a(Tr(pi.FALLBACK_TO_NUMBER_FORMAT, {
      key: l,
      target: f
    })), process.env.NODE_ENV !== "production" && g !== f) {
      const N = e.__v_emitter;
      N && N.emit("fallback", {
        type: k,
        key: l,
        from: w,
        to: x,
        groupId: `${k}:${l}`
      });
    }
    if (P = n[f] || {}, S = P[l], Kt(S))
      break;
    cg(e, l, f, m, k), w = x;
  }
  if (!Kt(S) || !ft(f))
    return i ? ch : l;
  let A = `${f}__${l}`;
  rh(u) || (A = `${A}__${JSON.stringify(u)}`);
  let $ = s.get(A);
  return $ || ($ = new Intl.NumberFormat(f, ci({}, S, u)), s.set(A, $)), c ? $.formatToParts(d) : $.format(d);
}
const jS = [
  "localeMatcher",
  "style",
  "currency",
  "currencyDisplay",
  "currencySign",
  "useGrouping",
  "minimumIntegerDigits",
  "minimumFractionDigits",
  "maximumFractionDigits",
  "minimumSignificantDigits",
  "maximumSignificantDigits",
  "compactDisplay",
  "notation",
  "signDisplay",
  "unit",
  "unitDisplay",
  "roundingMode",
  "roundingPriority",
  "roundingIncrement",
  "trailingZeroDisplay"
];
function xf(...e) {
  const [t, n, i, o] = e, a = {};
  let r = {};
  if (!Wn(t))
    throw La(Un.INVALID_ARGUMENT);
  const s = t;
  return ft(n) ? a.key = n : Kt(n) && Object.keys(n).forEach((l) => {
    jS.includes(l) ? r[l] = n[l] : a[l] = n[l];
  }), ft(i) ? a.locale = i : Kt(i) && (r = i), Kt(o) && (r = o), [a.key || "", s, a, r];
}
function Mb(e, t, n) {
  const i = e;
  for (const o in n) {
    const a = `${t}__${o}`;
    i.__numberFormatters.has(a) && i.__numberFormatters.delete(a);
  }
}
Oz();
/*!
  * vue-i18n v9.13.1
  * (c) 2024 kazuya kawaguchi
  * Released under the MIT License.
  */
const kV = "9.13.1";
function SV() {
  typeof __INTLIFY_JIT_COMPILATION__ != "boolean" && (bc().__INTLIFY_JIT_COMPILATION__ = !1), typeof __INTLIFY_DROP_MESSAGE_COMPILER__ != "boolean" && (bc().__INTLIFY_DROP_MESSAGE_COMPILER__ = !1);
}
const HS = pi.__EXTEND_POINT__, Ja = sh(HS), Qn = {
  FALLBACK_TO_ROOT: HS,
  // 9
  NOT_SUPPORTED_PRESERVE: Ja(),
  // 10
  NOT_SUPPORTED_FORMATTER: Ja(),
  // 11
  NOT_SUPPORTED_PRESERVE_DIRECTIVE: Ja(),
  // 12
  NOT_SUPPORTED_GET_CHOICE_INDEX: Ja(),
  // 13
  COMPONENT_NAME_LEGACY_COMPATIBLE: Ja(),
  // 14
  NOT_FOUND_PARENT_SCOPE: Ja(),
  // 15
  IGNORE_OBJ_FLATTEN: Ja(),
  // 16
  NOTICE_DROP_ALLOW_COMPOSITION: Ja(),
  // 17
  NOTICE_DROP_TRANSLATE_EXIST_COMPATIBLE_FLAG: Ja()
  // 18
}, CV = {
  [Qn.FALLBACK_TO_ROOT]: "Fall back to {type} '{key}' with root locale.",
  [Qn.NOT_SUPPORTED_PRESERVE]: "Not supported 'preserve'.",
  [Qn.NOT_SUPPORTED_FORMATTER]: "Not supported 'formatter'.",
  [Qn.NOT_SUPPORTED_PRESERVE_DIRECTIVE]: "Not supported 'preserveDirectiveContent'.",
  [Qn.NOT_SUPPORTED_GET_CHOICE_INDEX]: "Not supported 'getChoiceIndex'.",
  [Qn.COMPONENT_NAME_LEGACY_COMPATIBLE]: "Component name legacy compatible: '{name}' -> 'i18n'",
  [Qn.NOT_FOUND_PARENT_SCOPE]: "Not found parent scope. use the global scope.",
  [Qn.IGNORE_OBJ_FLATTEN]: "Ignore object flatten: '{key}' key has an string value",
  [Qn.NOTICE_DROP_ALLOW_COMPOSITION]: "'allowComposition' option will be dropped in the next major version. For more information, please see 👉 https://tinyurl.com/2p97mcze",
  [Qn.NOTICE_DROP_TRANSLATE_EXIST_COMPATIBLE_FLAG]: "'translateExistCompatible' option will be dropped in the next major version."
};
function vs(e, ...t) {
  return rg(CV[e], ...t);
}
const zS = Un.__EXTEND_POINT__, bi = sh(zS), un = {
  // composer module errors
  UNEXPECTED_RETURN_TYPE: zS,
  // 24
  // legacy module errors
  INVALID_ARGUMENT: bi(),
  // 25
  // i18n module errors
  MUST_BE_CALL_SETUP_TOP: bi(),
  // 26
  NOT_INSTALLED: bi(),
  // 27
  NOT_AVAILABLE_IN_LEGACY_MODE: bi(),
  // 28
  // directive module errors
  REQUIRED_VALUE: bi(),
  // 29
  INVALID_VALUE: bi(),
  // 30
  // vue-devtools errors
  CANNOT_SETUP_VUE_DEVTOOLS_PLUGIN: bi(),
  // 31
  NOT_INSTALLED_WITH_PROVIDE: bi(),
  // 32
  // unexpected error
  UNEXPECTED_ERROR: bi(),
  // 33
  // not compatible legacy vue-i18n constructor
  NOT_COMPATIBLE_LEGACY_VUE_I18N: bi(),
  // 34
  // bridge support vue 2.x only
  BRIDGE_SUPPORT_VUE_2_ONLY: bi(),
  // 35
  // need to define `i18n` option in `allowComposition: true` and `useScope: 'local' at `useI18n``
  MUST_DEFINE_I18N_OPTION_IN_ALLOW_COMPOSITION: bi(),
  // 36
  // Not available Compostion API in Legacy API mode. Please make sure that the legacy API mode is working properly
  NOT_AVAILABLE_COMPOSITION_IN_LEGACY: bi(),
  // 37
  // for enhancement
  __EXTEND_POINT__: bi()
  // 38
};
function na(e, ...t) {
  return Os(e, null, process.env.NODE_ENV !== "production" ? { messages: TV, args: t } : void 0);
}
const TV = {
  [un.UNEXPECTED_RETURN_TYPE]: "Unexpected return type in composer",
  [un.INVALID_ARGUMENT]: "Invalid argument",
  [un.MUST_BE_CALL_SETUP_TOP]: "Must be called at the top of a `setup` function",
  [un.NOT_INSTALLED]: "Need to install with `app.use` function",
  [un.UNEXPECTED_ERROR]: "Unexpected error",
  [un.NOT_AVAILABLE_IN_LEGACY_MODE]: "Not available in legacy mode",
  [un.REQUIRED_VALUE]: "Required in value: {0}",
  [un.INVALID_VALUE]: "Invalid value",
  [un.CANNOT_SETUP_VUE_DEVTOOLS_PLUGIN]: "Cannot setup vue-devtools plugin",
  [un.NOT_INSTALLED_WITH_PROVIDE]: "Need to install with `provide` function",
  [un.NOT_COMPATIBLE_LEGACY_VUE_I18N]: "Not compatible legacy VueI18n.",
  [un.BRIDGE_SUPPORT_VUE_2_ONLY]: "vue-i18n-bridge support Vue 2.x only",
  [un.MUST_DEFINE_I18N_OPTION_IN_ALLOW_COMPOSITION]: "Must define ‘i18n’ option or custom block in Composition API with using local scope in Legacy API mode",
  [un.NOT_AVAILABLE_COMPOSITION_IN_LEGACY]: "Not available Compostion API in Legacy API mode. Please make sure that the legacy API mode is working properly"
}, wf = /* @__PURE__ */ Ua("__translateVNode"), kf = /* @__PURE__ */ Ua("__datetimeParts"), Sf = /* @__PURE__ */ Ua("__numberParts"), wc = /* @__PURE__ */ Ua("__enableEmitter"), Cf = /* @__PURE__ */ Ua("__disableEmitter"), LV = Ua("__setPluralRules"), IV = /* @__PURE__ */ Ua("__injectWithOption"), Tf = /* @__PURE__ */ Ua("__dispose");
function kc(e) {
  if (!Xt(e))
    return e;
  for (const t in e)
    if (ku(e, t))
      if (!t.includes("."))
        Xt(e[t]) && kc(e[t]);
      else {
        const n = t.split("."), i = n.length - 1;
        let o = e, a = !1;
        for (let r = 0; r < i; r++) {
          if (n[r] in o || (o[n[r]] = {}), !Xt(o[n[r]])) {
            process.env.NODE_ENV !== "production" && xa(vs(Qn.IGNORE_OBJ_FLATTEN, {
              key: n[r]
            })), a = !0;
            break;
          }
          o = o[n[r]];
        }
        a || (o[n[i]] = e[t], delete e[t]), Xt(o[n[i]]) && kc(o[n[i]]);
      }
  return e;
}
function VS(e, t) {
  const { messages: n, __i18n: i, messageResolver: o, flatJson: a } = t, r = Kt(n) ? n : Dn(i) ? {} : { [e]: {} };
  if (Dn(i) && i.forEach((s) => {
    if ("locale" in s && "resource" in s) {
      const { locale: l, resource: d } = s;
      l ? (r[l] = r[l] || {}, eu(d, r[l])) : eu(d, r);
    } else
      ft(s) && eu(JSON.parse(s), r);
  }), o == null && a)
    for (const s in r)
      ku(r, s) && kc(r[s]);
  return r;
}
function GS(e) {
  return e.type;
}
function PV(e, t, n) {
  let i = Xt(t.messages) ? t.messages : {};
  "__i18nGlobal" in n && (i = VS(e.locale.value, {
    messages: i,
    __i18n: n.__i18nGlobal
  }));
  const o = Object.keys(i);
  o.length && o.forEach((a) => {
    e.mergeLocaleMessage(a, i[a]);
  });
  {
    if (Xt(t.datetimeFormats)) {
      const a = Object.keys(t.datetimeFormats);
      a.length && a.forEach((r) => {
        e.mergeDateTimeFormat(r, t.datetimeFormats[r]);
      });
    }
    if (Xt(t.numberFormats)) {
      const a = Object.keys(t.numberFormats);
      a.length && a.forEach((r) => {
        e.mergeNumberFormat(r, t.numberFormats[r]);
      });
    }
  }
}
function Ob(e) {
  return ue(jL, null, e, 0);
}
const Bb = "__INTLIFY_META__", Eb = () => [], AV = () => !1;
let Db = 0;
function Rb(e) {
  return (t, n, i, o) => e(n, i, ho() || void 0, o);
}
const _V = /* @__NO_SIDE_EFFECTS__ */ () => {
  const e = ho();
  let t = null;
  return e && (t = GS(e)[Bb]) ? { [Bb]: t } : null;
};
function US(e = {}, t) {
  const { __root: n, __injectWithOption: i } = e, o = n === void 0, a = e.flatJson, r = va ? ge : ti, s = !!e.translateExistCompatible;
  process.env.NODE_ENV !== "production" && s && vS(vs(Qn.NOTICE_DROP_TRANSLATE_EXIST_COMPATIBLE_FLAG));
  let l = bn(e.inheritLocale) ? e.inheritLocale : !0;
  const d = r(
    // prettier-ignore
    n && l ? n.locale.value : ft(e.locale) ? e.locale : Cu
  ), y = r(
    // prettier-ignore
    n && l ? n.fallbackLocale.value : ft(e.fallbackLocale) || Dn(e.fallbackLocale) || Kt(e.fallbackLocale) || e.fallbackLocale === !1 ? e.fallbackLocale : d.value
  ), u = r(VS(d.value, e)), m = r(Kt(e.datetimeFormats) ? e.datetimeFormats : { [d.value]: {} }), h = r(Kt(e.numberFormats) ? e.numberFormats : { [d.value]: {} });
  let c = n ? n.missingWarn : bn(e.missingWarn) || wu(e.missingWarn) ? e.missingWarn : !0, g = n ? n.fallbackWarn : bn(e.fallbackWarn) || wu(e.fallbackWarn) ? e.fallbackWarn : !0, v = n ? n.fallbackRoot : bn(e.fallbackRoot) ? e.fallbackRoot : !0, P = !!e.fallbackFormat, f = Sn(e.missing) ? e.missing : null, S = Sn(e.missing) ? Rb(e.missing) : null, w = Sn(e.postTranslation) ? e.postTranslation : null, x = n ? n.warnHtmlMessage : bn(e.warnHtmlMessage) ? e.warnHtmlMessage : !0, k = !!e.escapeParameter;
  const A = n ? n.modifiers : Kt(e.modifiers) ? e.modifiers : {};
  let $ = e.pluralRules || n && n.pluralRules, j;
  j = (() => {
    o && kb(null);
    const ye = {
      version: kV,
      locale: d.value,
      fallbackLocale: y.value,
      messages: u.value,
      modifiers: A,
      pluralRules: $,
      missing: S === null ? void 0 : S,
      missingWarn: c,
      fallbackWarn: g,
      fallbackFormat: P,
      unresolving: !0,
      postTranslation: w === null ? void 0 : w,
      warnHtmlMessage: x,
      escapeParameter: k,
      messageResolver: e.messageResolver,
      messageCompiler: e.messageCompiler,
      __meta: { framework: "vue" }
    };
    ye.datetimeFormats = m.value, ye.numberFormats = h.value, ye.__datetimeFormatters = Kt(j) ? j.__datetimeFormatters : void 0, ye.__numberFormatters = Kt(j) ? j.__numberFormatters : void 0, process.env.NODE_ENV !== "production" && (ye.__v_emitter = Kt(j) ? j.__v_emitter : void 0);
    const be = uV(ye);
    return o && kb(be), be;
  })(), rl(j, d.value, y.value);
  function M() {
    return [
      d.value,
      y.value,
      u.value,
      m.value,
      h.value
    ];
  }
  const D = Te({
    get: () => d.value,
    set: (ye) => {
      d.value = ye, j.locale = d.value;
    }
  }), C = Te({
    get: () => y.value,
    set: (ye) => {
      y.value = ye, j.fallbackLocale = y.value, rl(j, d.value, ye);
    }
  }), b = Te(() => u.value), p = /* @__PURE__ */ Te(() => m.value), L = /* @__PURE__ */ Te(() => h.value);
  function B() {
    return Sn(w) ? w : null;
  }
  function T(ye) {
    w = ye, j.postTranslation = ye;
  }
  function O() {
    return f;
  }
  function I(ye) {
    ye !== null && (S = Rb(ye)), f = ye, j.missing = S;
  }
  function R(ye, be) {
    return ye !== "translate" || !be.resolvedMessage;
  }
  const Y = (ye, be, ke, we, Le, Me) => {
    M();
    let De;
    try {
      process.env.NODE_ENV, o || (j.fallbackContext = n ? dV() : void 0), De = ye(j);
    } finally {
      process.env.NODE_ENV, o || (j.fallbackContext = void 0);
    }
    if (ke !== "translate exists" && // for not `te` (e.g `t`)
    Wn(De) && De === ch || ke === "translate exists" && !De) {
      const [Ae, _e] = be();
      if (process.env.NODE_ENV !== "production" && n && ft(Ae) && R(ke, _e) && (v && (dh(g, Ae) || _S(c, Ae)) && xa(vs(Qn.FALLBACK_TO_ROOT, {
        key: Ae,
        type: ke
      })), process.env.NODE_ENV !== "production")) {
        const { __v_emitter: He } = j;
        He && v && He.emit("fallback", {
          type: ke,
          key: Ae,
          to: "global",
          groupId: `${ke}:${Ae}`
        });
      }
      return n && v ? we(n) : Le(Ae);
    } else {
      if (Me(De))
        return De;
      throw na(un.UNEXPECTED_RETURN_TYPE);
    }
  };
  function F(...ye) {
    return Y((be) => Reflect.apply(Lb, null, [be, ...ye]), () => yf(...ye), "translate", (be) => Reflect.apply(be.t, be, [...ye]), (be) => be, (be) => ft(be));
  }
  function U(...ye) {
    const [be, ke, we] = ye;
    if (we && !Xt(we))
      throw na(un.INVALID_ARGUMENT);
    return F(be, ke, ci({ resolvedMessage: !0 }, we || {}));
  }
  function Q(...ye) {
    return Y((be) => Reflect.apply(Pb, null, [be, ...ye]), () => bf(...ye), "datetime format", (be) => Reflect.apply(be.d, be, [...ye]), () => Tu, (be) => ft(be));
  }
  function J(...ye) {
    return Y((be) => Reflect.apply(_b, null, [be, ...ye]), () => xf(...ye), "number format", (be) => Reflect.apply(be.n, be, [...ye]), () => Tu, (be) => ft(be));
  }
  function ee(ye) {
    return ye.map((be) => ft(be) || Wn(be) || bn(be) ? Ob(String(be)) : be);
  }
  const G = {
    normalize: ee,
    interpolate: (ye) => ye,
    type: "vnode"
  };
  function W(...ye) {
    return Y(
      (be) => {
        let ke;
        const we = be;
        try {
          we.processor = G, ke = Reflect.apply(Lb, null, [we, ...ye]);
        } finally {
          we.processor = null;
        }
        return ke;
      },
      () => yf(...ye),
      "translate",
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (be) => be[wf](...ye),
      (be) => [Ob(be)],
      (be) => Dn(be)
    );
  }
  function ae(...ye) {
    return Y(
      (be) => Reflect.apply(_b, null, [be, ...ye]),
      () => xf(...ye),
      "number format",
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (be) => be[Sf](...ye),
      Eb,
      (be) => ft(be) || Dn(be)
    );
  }
  function z(...ye) {
    return Y(
      (be) => Reflect.apply(Pb, null, [be, ...ye]),
      () => bf(...ye),
      "datetime format",
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (be) => be[kf](...ye),
      Eb,
      (be) => ft(be) || Dn(be)
    );
  }
  function q(ye) {
    $ = ye, j.pluralRules = $;
  }
  function Z(ye, be) {
    return Y(() => {
      if (!ye)
        return !1;
      const ke = ft(be) ? be : d.value, we = re(ke), Le = j.messageResolver(we, ye);
      return s ? Le != null : Do(Le) || Gi(Le) || ft(Le);
    }, () => [ye], "translate exists", (ke) => Reflect.apply(ke.te, ke, [ye, be]), AV, (ke) => bn(ke));
  }
  function ne(ye) {
    let be = null;
    const ke = CS(j, y.value, d.value);
    for (let we = 0; we < ke.length; we++) {
      const Le = u.value[ke[we]] || {}, Me = j.messageResolver(Le, ye);
      if (Me != null) {
        be = Me;
        break;
      }
    }
    return be;
  }
  function ie(ye) {
    const be = ne(ye);
    return be ?? (n ? n.tm(ye) || {} : {});
  }
  function re(ye) {
    return u.value[ye] || {};
  }
  function de(ye, be) {
    if (a) {
      const ke = { [ye]: be };
      for (const we in ke)
        ku(ke, we) && kc(ke[we]);
      be = ke[ye];
    }
    u.value[ye] = be, j.messages = u.value;
  }
  function me(ye, be) {
    u.value[ye] = u.value[ye] || {};
    const ke = { [ye]: be };
    if (a)
      for (const we in ke)
        ku(ke, we) && kc(ke[we]);
    be = ke[ye], eu(be, u.value[ye]), j.messages = u.value;
  }
  function ce(ye) {
    return m.value[ye] || {};
  }
  function pe(ye, be) {
    m.value[ye] = be, j.datetimeFormats = m.value, Ab(j, ye, be);
  }
  function xe(ye, be) {
    m.value[ye] = ci(m.value[ye] || {}, be), j.datetimeFormats = m.value, Ab(j, ye, be);
  }
  function le(ye) {
    return h.value[ye] || {};
  }
  function se(ye, be) {
    h.value[ye] = be, j.numberFormats = h.value, Mb(j, ye, be);
  }
  function he(ye, be) {
    h.value[ye] = ci(h.value[ye] || {}, be), j.numberFormats = h.value, Mb(j, ye, be);
  }
  Db++, n && va && (qe(n.locale, (ye) => {
    l && (d.value = ye, j.locale = ye, rl(j, d.value, y.value));
  }), qe(n.fallbackLocale, (ye) => {
    l && (y.value = ye, j.fallbackLocale = ye, rl(j, d.value, y.value));
  }));
  const ve = {
    id: Db,
    locale: D,
    fallbackLocale: C,
    get inheritLocale() {
      return l;
    },
    set inheritLocale(ye) {
      l = ye, ye && n && (d.value = n.locale.value, y.value = n.fallbackLocale.value, rl(j, d.value, y.value));
    },
    get availableLocales() {
      return Object.keys(u.value).sort();
    },
    messages: b,
    get modifiers() {
      return A;
    },
    get pluralRules() {
      return $ || {};
    },
    get isGlobal() {
      return o;
    },
    get missingWarn() {
      return c;
    },
    set missingWarn(ye) {
      c = ye, j.missingWarn = c;
    },
    get fallbackWarn() {
      return g;
    },
    set fallbackWarn(ye) {
      g = ye, j.fallbackWarn = g;
    },
    get fallbackRoot() {
      return v;
    },
    set fallbackRoot(ye) {
      v = ye;
    },
    get fallbackFormat() {
      return P;
    },
    set fallbackFormat(ye) {
      P = ye, j.fallbackFormat = P;
    },
    get warnHtmlMessage() {
      return x;
    },
    set warnHtmlMessage(ye) {
      x = ye, j.warnHtmlMessage = ye;
    },
    get escapeParameter() {
      return k;
    },
    set escapeParameter(ye) {
      k = ye, j.escapeParameter = ye;
    },
    t: F,
    getLocaleMessage: re,
    setLocaleMessage: de,
    mergeLocaleMessage: me,
    getPostTranslationHandler: B,
    setPostTranslationHandler: T,
    getMissingHandler: O,
    setMissingHandler: I,
    [LV]: q
  };
  return ve.datetimeFormats = p, ve.numberFormats = L, ve.rt = U, ve.te = Z, ve.tm = ie, ve.d = Q, ve.n = J, ve.getDateTimeFormat = ce, ve.setDateTimeFormat = pe, ve.mergeDateTimeFormat = xe, ve.getNumberFormat = le, ve.setNumberFormat = se, ve.mergeNumberFormat = he, ve[IV] = i, ve[wf] = W, ve[kf] = z, ve[Sf] = ae, process.env.NODE_ENV !== "production" && (ve[wc] = (ye) => {
    j.__v_emitter = ye;
  }, ve[Cf] = () => {
    j.__v_emitter = void 0;
  }), ve;
}
const dg = {
  tag: {
    type: [String, Object]
  },
  locale: {
    type: String
  },
  scope: {
    type: String,
    // NOTE: avoid https://github.com/microsoft/rushstack/issues/1050
    validator: (e) => e === "parent" || e === "global",
    default: "parent"
    /* ComponentI18nScope */
  },
  i18n: {
    type: Object
  }
};
function MV({ slots: e }, t) {
  return t.length === 1 && t[0] === "default" ? (e.default ? e.default() : []).reduce((i, o) => [
    ...i,
    // prettier-ignore
    ...o.type === Re ? o.children : [o]
  ], []) : t.reduce((n, i) => {
    const o = e[i];
    return o && (n[i] = o()), n;
  }, {});
}
function WS(e) {
  return Re;
}
const OV = /* @__PURE__ */ Be({
  /* eslint-disable */
  name: "i18n-t",
  props: ci({
    keypath: {
      type: String,
      required: !0
    },
    plural: {
      type: [Number, String],
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      validator: (e) => Wn(e) || !isNaN(e)
    }
  }, dg),
  /* eslint-enable */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  setup(e, t) {
    const { slots: n, attrs: i } = t, o = e.i18n || hg({
      useScope: e.scope,
      __useComponent: !0
    });
    return () => {
      const a = Object.keys(n).filter((u) => u !== "_"), r = {};
      e.locale && (r.locale = e.locale), e.plural !== void 0 && (r.plural = ft(e.plural) ? +e.plural : e.plural);
      const s = MV(t, a), l = o[wf](e.keypath, s, r), d = ci({}, i), y = ft(e.tag) || Xt(e.tag) ? e.tag : WS();
      return At(y, d, l);
    };
  }
}), yp = OV;
function BV(e) {
  return Dn(e) && !ft(e[0]);
}
function YS(e, t, n, i) {
  const { slots: o, attrs: a } = t;
  return () => {
    const r = { part: !0 };
    let s = {};
    e.locale && (r.locale = e.locale), ft(e.format) ? r.key = e.format : Xt(e.format) && (ft(e.format.key) && (r.key = e.format.key), s = Object.keys(e.format).reduce((m, h) => n.includes(h) ? ci({}, m, { [h]: e.format[h] }) : m, {}));
    const l = i(e.value, r, s);
    let d = [r.key];
    Dn(l) ? d = l.map((m, h) => {
      const c = o[m.type], g = c ? c({ [m.type]: m.value, index: h, parts: l }) : [m.value];
      return BV(g) && (g[0].key = `${m.type}-${h}`), g;
    }) : ft(l) && (d = [l]);
    const y = ci({}, a), u = ft(e.tag) || Xt(e.tag) ? e.tag : WS();
    return At(u, y, d);
  };
}
const EV = /* @__PURE__ */ Be({
  /* eslint-disable */
  name: "i18n-n",
  props: ci({
    value: {
      type: Number,
      required: !0
    },
    format: {
      type: [String, Object]
    }
  }, dg),
  /* eslint-enable */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  setup(e, t) {
    const n = e.i18n || hg({
      useScope: e.scope,
      __useComponent: !0
    });
    return YS(e, t, jS, (...i) => (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      n[Sf](...i)
    ));
  }
}), Nb = EV, DV = /* @__PURE__ */ Be({
  /* eslint-disable */
  name: "i18n-d",
  props: ci({
    value: {
      type: [Number, Date],
      required: !0
    },
    format: {
      type: [String, Object]
    }
  }, dg),
  /* eslint-enable */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  setup(e, t) {
    const n = e.i18n || hg({
      useScope: e.scope,
      __useComponent: !0
    });
    return YS(e, t, FS, (...i) => (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      n[kf](...i)
    ));
  }
}), $b = DV;
function RV(e, t) {
  const n = e;
  if (e.mode === "composition")
    return n.__getInstance(t) || e.global;
  {
    const i = n.__getInstance(t);
    return i != null ? i.__composer : e.global.__composer;
  }
}
function NV(e) {
  const t = (r) => {
    const { instance: s, modifiers: l, value: d } = r;
    if (!s || !s.$)
      throw na(un.UNEXPECTED_ERROR);
    const y = RV(e, s.$);
    process.env.NODE_ENV !== "production" && l.preserve && xa(vs(Qn.NOT_SUPPORTED_PRESERVE));
    const u = Fb(d);
    return [
      Reflect.apply(y.t, y, [...jb(u)]),
      y
    ];
  };
  return {
    created: (r, s) => {
      const [l, d] = t(s);
      va && e.global === d && (r.__i18nWatcher = qe(d.locale, () => {
        s.instance && s.instance.$forceUpdate();
      })), r.__composer = d, r.textContent = l;
    },
    unmounted: (r) => {
      va && r.__i18nWatcher && (r.__i18nWatcher(), r.__i18nWatcher = void 0, delete r.__i18nWatcher), r.__composer && (r.__composer = void 0, delete r.__composer);
    },
    beforeUpdate: (r, { value: s }) => {
      if (r.__composer) {
        const l = r.__composer, d = Fb(s);
        r.textContent = Reflect.apply(l.t, l, [
          ...jb(d)
        ]);
      }
    },
    getSSRProps: (r) => {
      const [s] = t(r);
      return { textContent: s };
    }
  };
}
function Fb(e) {
  if (ft(e))
    return { path: e };
  if (Kt(e)) {
    if (!("path" in e))
      throw na(un.REQUIRED_VALUE, "path");
    return e;
  } else
    throw na(un.INVALID_VALUE);
}
function jb(e) {
  const { path: t, locale: n, args: i, choice: o, plural: a } = e, r = {}, s = i || {};
  return ft(n) && (r.locale = n), Wn(o) && (r.plural = o), Wn(a) && (r.plural = a), [t, s, r];
}
function $V(e, t, ...n) {
  const i = Kt(n[0]) ? n[0] : {}, o = !!i.useI18nComponentName, a = bn(i.globalInstall) ? i.globalInstall : !0;
  process.env.NODE_ENV !== "production" && a && o && xa(vs(Qn.COMPONENT_NAME_LEGACY_COMPATIBLE, {
    name: yp.name
  })), a && ([o ? "i18n" : yp.name, "I18nT"].forEach((r) => e.component(r, yp)), [Nb.name, "I18nN"].forEach((r) => e.component(r, Nb)), [$b.name, "I18nD"].forEach((r) => e.component(r, $b))), e.directive("t", NV(t));
}
const bp = {
  "vue-devtools-plugin-vue-i18n": "Vue I18n devtools",
  "vue-i18n-resource-inspector": "I18n Resources",
  "vue-i18n-timeline": "Vue I18n"
}, FV = {
  "vue-i18n-resource-inspector": "Search for scopes ..."
}, jV = {
  "vue-i18n-timeline": 16764185
}, qS = "vue-i18n: composer properties";
let Lf;
async function HV(e, t) {
  return new Promise((n, i) => {
    try {
      wm({
        id: "vue-devtools-plugin-vue-i18n",
        label: bp[
          "vue-devtools-plugin-vue-i18n"
          /* VueDevToolsIDs.PLUGIN */
        ],
        packageName: "vue-i18n",
        homepage: "https://vue-i18n.intlify.dev",
        logo: "https://vue-i18n.intlify.dev/vue-i18n-devtools-logo.png",
        componentStateTypes: [qS],
        app: e
        // eslint-disable-line @typescript-eslint/no-explicit-any
      }, (o) => {
        Lf = o, o.on.visitComponentTree(({ componentInstance: r, treeNode: s }) => {
          zV(r, s, t);
        }), o.on.inspectComponent(({ componentInstance: r, instanceData: s }) => {
          r.vnode.el && r.vnode.el.__VUE_I18N__ && s && (t.mode === "legacy" ? r.vnode.el.__VUE_I18N__ !== t.global.__composer && Hb(s, r.vnode.el.__VUE_I18N__) : Hb(s, r.vnode.el.__VUE_I18N__));
        }), o.addInspector({
          id: "vue-i18n-resource-inspector",
          label: bp[
            "vue-i18n-resource-inspector"
            /* VueDevToolsIDs.CUSTOM_INSPECTOR */
          ],
          icon: "language",
          treeFilterPlaceholder: FV[
            "vue-i18n-resource-inspector"
            /* VueDevToolsIDs.CUSTOM_INSPECTOR */
          ]
        }), o.on.getInspectorTree((r) => {
          r.app === e && r.inspectorId === "vue-i18n-resource-inspector" && YV(r, t);
        });
        const a = /* @__PURE__ */ new Map();
        o.on.getInspectorState(async (r) => {
          if (r.app === e && r.inspectorId === "vue-i18n-resource-inspector")
            if (o.unhighlightElement(), KV(r, t), r.nodeId === "global") {
              if (!a.has(r.app)) {
                const [s] = await o.getComponentInstances(r.app);
                a.set(r.app, s);
              }
              o.highlightElement(a.get(r.app));
            } else {
              const s = qV(r.nodeId, t);
              s && o.highlightElement(s);
            }
        }), o.on.editInspectorState((r) => {
          r.app === e && r.inspectorId === "vue-i18n-resource-inspector" && ZV(r, t);
        }), o.addTimelineLayer({
          id: "vue-i18n-timeline",
          label: bp[
            "vue-i18n-timeline"
            /* VueDevToolsIDs.TIMELINE */
          ],
          color: jV[
            "vue-i18n-timeline"
            /* VueDevToolsIDs.TIMELINE */
          ]
        }), n(!0);
      });
    } catch (o) {
      console.error(o), i(!1);
    }
  });
}
function KS(e) {
  return e.type.name || e.type.displayName || e.type.__file || "Anonymous";
}
function zV(e, t, n) {
  const i = n.mode === "composition" ? n.global : n.global.__composer;
  if (e && e.vnode.el && e.vnode.el.__VUE_I18N__ && e.vnode.el.__VUE_I18N__ !== i) {
    const o = {
      label: `i18n (${KS(e)} Scope)`,
      textColor: 0,
      backgroundColor: 16764185
    };
    t.tags.push(o);
  }
}
function Hb(e, t) {
  const n = qS;
  e.state.push({
    type: n,
    key: "locale",
    editable: !0,
    value: t.locale.value
  }), e.state.push({
    type: n,
    key: "availableLocales",
    editable: !1,
    value: t.availableLocales
  }), e.state.push({
    type: n,
    key: "fallbackLocale",
    editable: !0,
    value: t.fallbackLocale.value
  }), e.state.push({
    type: n,
    key: "inheritLocale",
    editable: !0,
    value: t.inheritLocale
  }), e.state.push({
    type: n,
    key: "messages",
    editable: !1,
    value: ug(t.messages.value)
  }), e.state.push({
    type: n,
    key: "datetimeFormats",
    editable: !1,
    value: t.datetimeFormats.value
  }), e.state.push({
    type: n,
    key: "numberFormats",
    editable: !1,
    value: t.numberFormats.value
  });
}
function ug(e) {
  const t = {};
  return Object.keys(e).forEach((n) => {
    const i = e[n];
    Sn(i) && "source" in i ? t[n] = WV(i) : Do(i) && i.loc && i.loc.source ? t[n] = i.loc.source : Xt(i) ? t[n] = ug(i) : t[n] = i;
  }), t;
}
const VV = {
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "&": "&amp;"
};
function GV(e) {
  return e.replace(/[<>"&]/g, UV);
}
function UV(e) {
  return VV[e] || e;
}
function WV(e) {
  return {
    _custom: {
      type: "function",
      display: `<span>ƒ</span> ${e.source ? `("${GV(e.source)}")` : "(?)"}`
    }
  };
}
function YV(e, t) {
  e.rootNodes.push({
    id: "global",
    label: "Global Scope"
  });
  const n = t.mode === "composition" ? t.global : t.global.__composer;
  for (const [i, o] of t.__instances) {
    const a = t.mode === "composition" ? o : o.__composer;
    n !== a && e.rootNodes.push({
      id: a.id.toString(),
      label: `${KS(i)} Scope`
    });
  }
}
function qV(e, t) {
  let n = null;
  if (e !== "global") {
    for (const [i, o] of t.__instances.entries())
      if (o.id.toString() === e) {
        n = i;
        break;
      }
  }
  return n;
}
function XS(e, t) {
  if (e === "global")
    return t.mode === "composition" ? t.global : t.global.__composer;
  {
    const n = Array.from(t.__instances.values()).find((i) => i.id.toString() === e);
    return n ? t.mode === "composition" ? n : n.__composer : null;
  }
}
function KV(e, t) {
  const n = XS(e.nodeId, t);
  return n && (e.state = XV(n)), null;
}
function XV(e) {
  const t = {}, n = "Locale related info", i = [
    {
      type: n,
      key: "locale",
      editable: !0,
      value: e.locale.value
    },
    {
      type: n,
      key: "fallbackLocale",
      editable: !0,
      value: e.fallbackLocale.value
    },
    {
      type: n,
      key: "availableLocales",
      editable: !1,
      value: e.availableLocales
    },
    {
      type: n,
      key: "inheritLocale",
      editable: !0,
      value: e.inheritLocale
    }
  ];
  t[n] = i;
  const o = "Locale messages info", a = [
    {
      type: o,
      key: "messages",
      editable: !1,
      value: ug(e.messages.value)
    }
  ];
  t[o] = a;
  {
    const r = "Datetime formats info", s = [
      {
        type: r,
        key: "datetimeFormats",
        editable: !1,
        value: e.datetimeFormats.value
      }
    ];
    t[r] = s;
    const l = "Datetime formats info", d = [
      {
        type: l,
        key: "numberFormats",
        editable: !1,
        value: e.numberFormats.value
      }
    ];
    t[l] = d;
  }
  return t;
}
function If(e, t) {
  if (Lf) {
    let n;
    t && "groupId" in t && (n = t.groupId, delete t.groupId), Lf.addTimelineEvent({
      layerId: "vue-i18n-timeline",
      event: {
        title: e,
        groupId: n,
        time: Date.now(),
        meta: {},
        data: t || {},
        logType: e === "compile-error" ? "error" : e === "fallback" || e === "missing" ? "warning" : "default"
      }
    });
  }
}
function ZV(e, t) {
  const n = XS(e.nodeId, t);
  if (n) {
    const [i] = e.path;
    i === "locale" && ft(e.state.value) ? n.locale.value = e.state.value : i === "fallbackLocale" && (ft(e.state.value) || Dn(e.state.value) || Xt(e.state.value)) ? n.fallbackLocale.value = e.state.value : i === "inheritLocale" && bn(e.state.value) && (n.inheritLocale = e.state.value);
  }
}
const JV = /* @__PURE__ */ Ua("global-vue-i18n");
function QV(e = {}, t) {
  const n = bn(e.globalInjection) ? e.globalInjection : !0, i = !0, o = /* @__PURE__ */ new Map(), [a, r] = eG(e), s = /* @__PURE__ */ Ua(process.env.NODE_ENV !== "production" ? "vue-i18n" : "");
  process.env.NODE_ENV;
  function l(u) {
    return o.get(u) || null;
  }
  function d(u, m) {
    o.set(u, m);
  }
  function y(u) {
    o.delete(u);
  }
  {
    const u = {
      // mode
      get mode() {
        return "composition";
      },
      // allowComposition
      get allowComposition() {
        return i;
      },
      // install plugin
      async install(m, ...h) {
        if (process.env.NODE_ENV !== "production" && (m.__VUE_I18N__ = u), m.__VUE_I18N_SYMBOL__ = s, m.provide(m.__VUE_I18N_SYMBOL__, u), Kt(h[0])) {
          const v = h[0];
          u.__composerExtend = v.__composerExtend, u.__vueI18nExtend = v.__vueI18nExtend;
        }
        let c = null;
        n && (c = lG(m, u.global)), $V(m, u, ...h);
        const g = m.unmount;
        if (m.unmount = () => {
          c && c(), u.dispose(), g();
        }, process.env.NODE_ENV !== "production") {
          if (!await HV(m, u))
            throw na(un.CANNOT_SETUP_VUE_DEVTOOLS_PLUGIN);
          const P = yS();
          {
            const f = r;
            f[wc] && f[wc](P);
          }
          P.on("*", If);
        }
      },
      // global accessor
      get global() {
        return r;
      },
      dispose() {
        a.stop();
      },
      // @internal
      __instances: o,
      // @internal
      __getInstance: l,
      // @internal
      __setInstance: d,
      // @internal
      __deleteInstance: y
    };
    return u;
  }
}
function hg(e = {}) {
  const t = ho();
  if (t == null)
    throw na(un.MUST_BE_CALL_SETUP_TOP);
  if (!t.isCE && t.appContext.app != null && !t.appContext.app.__VUE_I18N_SYMBOL__)
    throw na(un.NOT_INSTALLED);
  const n = tG(t), i = iG(n), o = GS(t), a = nG(e, o);
  if (a === "global")
    return PV(i, e, o), i;
  if (a === "parent") {
    let l = aG(n, t, e.__useComponent);
    return l == null && (process.env.NODE_ENV !== "production" && xa(vs(Qn.NOT_FOUND_PARENT_SCOPE)), l = i), l;
  }
  const r = n;
  let s = r.__getInstance(t);
  if (s == null) {
    const l = ci({}, e);
    "__i18n" in o && (l.__i18n = o.__i18n), i && (l.__root = i), s = US(l), r.__composerExtend && (s[Tf] = r.__composerExtend(s)), rG(r, t, s), r.__setInstance(t, s);
  }
  return s;
}
function eG(e, t, n) {
  const i = um();
  {
    const o = i.run(() => US(e));
    if (o == null)
      throw na(un.UNEXPECTED_ERROR);
    return [i, o];
  }
}
function tG(e) {
  {
    const t = $t(e.isCE ? JV : e.appContext.app.__VUE_I18N_SYMBOL__);
    if (!t)
      throw na(e.isCE ? un.NOT_INSTALLED_WITH_PROVIDE : un.UNEXPECTED_ERROR);
    return t;
  }
}
function nG(e, t) {
  return rh(e) ? "__i18n" in t ? "local" : "global" : e.useScope ? e.useScope : "local";
}
function iG(e) {
  return e.mode === "composition" ? e.global : e.global.__composer;
}
function aG(e, t, n = !1) {
  let i = null;
  const o = t.root;
  let a = oG(t, n);
  for (; a != null; ) {
    const r = e;
    if (e.mode === "composition" && (i = r.__getInstance(a)), i != null || o === a)
      break;
    a = a.parent;
  }
  return i;
}
function oG(e, t = !1) {
  return e == null ? null : t && e.vnode.ctx || e.parent;
}
function rG(e, t, n) {
  let i = null;
  it(() => {
    if (process.env.NODE_ENV !== "production" && t.vnode.el) {
      t.vnode.el.__VUE_I18N__ = n, i = yS();
      const o = n;
      o[wc] && o[wc](i), i.on("*", If);
    }
  }, t), sn(() => {
    const o = n;
    process.env.NODE_ENV !== "production" && t.vnode.el && t.vnode.el.__VUE_I18N__ && (i && i.off("*", If), o[Cf] && o[Cf](), delete t.vnode.el.__VUE_I18N__), e.__deleteInstance(t);
    const a = o[Tf];
    a && (a(), delete o[Tf]);
  }, t);
}
const sG = [
  "locale",
  "fallbackLocale",
  "availableLocales"
], zb = ["t", "rt", "d", "n", "tm", "te"];
function lG(e, t) {
  const n = /* @__PURE__ */ Object.create(null);
  return sG.forEach((o) => {
    const a = Object.getOwnPropertyDescriptor(t, o);
    if (!a)
      throw na(un.UNEXPECTED_ERROR);
    const r = In(a.value) ? {
      get() {
        return a.value.value;
      },
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      set(s) {
        a.value.value = s;
      }
    } : {
      get() {
        return a.get && a.get();
      }
    };
    Object.defineProperty(n, o, r);
  }), e.config.globalProperties.$i18n = n, zb.forEach((o) => {
    const a = Object.getOwnPropertyDescriptor(t, o);
    if (!a || !a.value)
      throw na(un.UNEXPECTED_ERROR);
    Object.defineProperty(e.config.globalProperties, `$${o}`, a);
  }), () => {
    delete e.config.globalProperties.$i18n, zb.forEach((o) => {
      delete e.config.globalProperties[`$${o}`];
    });
  };
}
SV();
__INTLIFY_JIT_COMPILATION__ ? wb(gV) : wb(mV);
rV(jz);
sV(CS);
if (process.env.NODE_ENV !== "production") {
  const e = bc();
  e.__INTLIFY__ = !0, Kz(e.__INTLIFY_DEVTOOLS_GLOBAL_HOOK__);
}
process.env.NODE_ENV;
const sl = [
  {
    locale: "en",
    startsWith: "Starts with",
    contains: "Contains",
    notContains: "Not contains",
    endsWith: "Ends with",
    equals: "Equals",
    notEquals: "Not equals",
    noFilter: "No Filter",
    filter: "Filter",
    lt: "Less than",
    lte: "Less than or equal to",
    gt: "Greater than",
    gte: "Greater than or equal to",
    dateIs: "Date is",
    dateIsNot: "Date is not",
    dateBefore: "Date is before",
    dateAfter: "Date is after",
    custom: "Custom",
    clear: "Clear",
    apply: "Apply",
    matchAll: "Match All",
    matchAny: "Match Any",
    addRule: "Add Rule",
    removeRule: "Remove Rule",
    accept: "Yes",
    reject: "No",
    choose: "Choose",
    upload: "Upload",
    cancel: "Cancel",
    completed: "Completed",
    pending: "Pending",
    fileSizeTypes: ["B", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"],
    dayNames: [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday"
    ],
    dayNamesShort: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
    dayNamesMin: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
    monthNames: [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December"
    ],
    monthNamesShort: [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec"
    ],
    chooseYear: "Choose Year",
    chooseMonth: "Choose Month",
    chooseDate: "Choose Date",
    prevDecade: "Previous Decade",
    nextDecade: "Next Decade",
    prevYear: "Previous Year",
    nextYear: "Next Year",
    prevMonth: "Previous Month",
    nextMonth: "Next Month",
    prevHour: "Previous Hour",
    nextHour: "Next Hour",
    prevMinute: "Previous Minute",
    nextMinute: "Next Minute",
    prevSecond: "Previous Second",
    nextSecond: "Next Second",
    am: "AM",
    pm: "PM",
    today: "Today",
    weekHeader: "Wk",
    firstDayOfWeek: 0,
    showMonthAfterYear: !1,
    dateFormat: "dd/mm/yy",
    weak: "Weak",
    medium: "Medium",
    strong: "Strong",
    passwordPrompt: "Enter a password",
    emptyFilterMessage: "No results found",
    searchMessage: "{0} results are available",
    selectionMessage: "{0} items selected",
    emptySelectionMessage: "No selected item",
    emptySearchMessage: "No results found",
    emptyMessage: "No available options",
    aria: {
      trueLabel: "True",
      falseLabel: "False",
      nullLabel: "Not Selected",
      star: "1 star",
      stars: "{star} stars",
      selectAll: "All items selected",
      unselectAll: "All items unselected",
      close: "Close",
      previous: "Previous",
      next: "Next",
      navigation: "Navigation",
      scrollTop: "Scroll Top",
      moveTop: "Move Top",
      moveUp: "Move Up",
      moveDown: "Move Down",
      moveBottom: "Move Bottom",
      moveToTarget: "Move to Target",
      moveToSource: "Move to Source",
      moveAllToTarget: "Move All to Target",
      moveAllToSource: "Move All to Source",
      pageLabel: "Page {page}",
      firstPageLabel: "First Page",
      lastPageLabel: "Last Page",
      nextPageLabel: "Next Page",
      prevPageLabel: "Previous Page",
      rowsPerPageLabel: "Rows per page",
      jumpToPageDropdownLabel: "Jump to Page Dropdown",
      jumpToPageInputLabel: "Jump to Page Input",
      selectRow: "Row Selected",
      unselectRow: "Row Unselected",
      expandRow: "Row Expanded",
      collapseRow: "Row Collapsed",
      showFilterMenu: "Show Filter Menu",
      hideFilterMenu: "Hide Filter Menu",
      filterOperator: "Filter Operator",
      filterConstraint: "Filter Constraint",
      editRow: "Edit Row",
      saveEdit: "Save Edit",
      cancelEdit: "Cancel Edit",
      listView: "List View",
      gridView: "Grid View",
      slide: "Slide",
      slideNumber: "{slideNumber}",
      zoomImage: "Zoom Image",
      zoomIn: "Zoom In",
      zoomOut: "Zoom Out",
      rotateRight: "Rotate Right",
      rotateLeft: "Rotate Left"
    }
  },
  {
    locale: "en-US",
    startsWith: "Starts with",
    contains: "Contains",
    notContains: "Not contains",
    endsWith: "Ends with",
    equals: "Equals",
    notEquals: "Not equals",
    noFilter: "No Filter",
    filter: "Filter",
    lt: "Less than",
    lte: "Less than or equal to",
    gt: "Greater than",
    gte: "Greater than or equal to",
    dateIs: "Date is",
    dateIsNot: "Date is not",
    dateBefore: "Date is before",
    dateAfter: "Date is after",
    custom: "Custom",
    clear: "Clear",
    apply: "Apply",
    matchAll: "Match All",
    matchAny: "Match Any",
    addRule: "Add Rule",
    removeRule: "Remove Rule",
    accept: "Yes",
    reject: "No",
    choose: "Choose",
    upload: "Upload",
    cancel: "Cancel",
    completed: "Completed",
    pending: "Pending",
    fileSizeTypes: ["B", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"],
    dayNames: [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday"
    ],
    dayNamesShort: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
    dayNamesMin: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
    monthNames: [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December"
    ],
    monthNamesShort: [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec"
    ],
    chooseYear: "Choose Year",
    chooseMonth: "Choose Month",
    chooseDate: "Choose Date",
    prevDecade: "Previous Decade",
    nextDecade: "Next Decade",
    prevYear: "Previous Year",
    nextYear: "Next Year",
    prevMonth: "Previous Month",
    nextMonth: "Next Month",
    prevHour: "Previous Hour",
    nextHour: "Next Hour",
    prevMinute: "Previous Minute",
    nextMinute: "Next Minute",
    prevSecond: "Previous Second",
    nextSecond: "Next Second",
    am: "AM",
    pm: "PM",
    today: "Today",
    weekHeader: "Wk",
    firstDayOfWeek: 0,
    showMonthAfterYear: !1,
    dateFormat: "mm/dd/yy",
    weak: "Weak",
    medium: "Medium",
    strong: "Strong",
    passwordPrompt: "Enter a password",
    emptyFilterMessage: "No results found",
    searchMessage: "{0} results are available",
    selectionMessage: "{0} items selected",
    emptySelectionMessage: "No selected item",
    emptySearchMessage: "No results found",
    emptyMessage: "No available options",
    aria: {
      trueLabel: "True",
      falseLabel: "False",
      nullLabel: "Not Selected",
      star: "1 star",
      stars: "{star} stars",
      selectAll: "All items selected",
      unselectAll: "All items unselected",
      close: "Close",
      previous: "Previous",
      next: "Next",
      navigation: "Navigation",
      scrollTop: "Scroll Top",
      moveTop: "Move Top",
      moveUp: "Move Up",
      moveDown: "Move Down",
      moveBottom: "Move Bottom",
      moveToTarget: "Move to Target",
      moveToSource: "Move to Source",
      moveAllToTarget: "Move All to Target",
      moveAllToSource: "Move All to Source",
      pageLabel: "Page {page}",
      firstPageLabel: "First Page",
      lastPageLabel: "Last Page",
      nextPageLabel: "Next Page",
      prevPageLabel: "Previous Page",
      rowsPerPageLabel: "Rows per page",
      jumpToPageDropdownLabel: "Jump to Page Dropdown",
      jumpToPageInputLabel: "Jump to Page Input",
      selectRow: "Row Selected",
      unselectRow: "Row Unselected",
      expandRow: "Row Expanded",
      collapseRow: "Row Collapsed",
      showFilterMenu: "Show Filter Menu",
      hideFilterMenu: "Hide Filter Menu",
      filterOperator: "Filter Operator",
      filterConstraint: "Filter Constraint",
      editRow: "Edit Row",
      saveEdit: "Save Edit",
      cancelEdit: "Cancel Edit",
      listView: "List View",
      gridView: "Grid View",
      slide: "Slide",
      slideNumber: "{slideNumber}",
      zoomImage: "Zoom Image",
      zoomIn: "Zoom In",
      zoomOut: "Zoom Out",
      rotateRight: "Rotate Right",
      rotateLeft: "Rotate Left"
    }
  },
  {
    locale: "en-LU",
    startsWith: "Starts with",
    contains: "Contains",
    notContains: "Not contains",
    endsWith: "Ends with",
    equals: "Equals",
    notEquals: "Not equals",
    noFilter: "No Filter",
    filter: "Filter",
    lt: "Less than",
    lte: "Less than or equal to",
    gt: "Greater than",
    gte: "Greater than or equal to",
    dateIs: "Date is",
    dateIsNot: "Date is not",
    dateBefore: "Date is before",
    dateAfter: "Date is after",
    custom: "Custom",
    clear: "Clear",
    apply: "Apply",
    matchAll: "Match All",
    matchAny: "Match Any",
    addRule: "Add Rule",
    removeRule: "Remove Rule",
    accept: "Yes",
    reject: "No",
    choose: "Choose",
    upload: "Upload",
    cancel: "Cancel",
    completed: "Completed",
    pending: "Pending",
    fileSizeTypes: ["B", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"],
    dayNames: [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday"
    ],
    dayNamesShort: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
    dayNamesMin: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
    monthNames: [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December"
    ],
    monthNamesShort: [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec"
    ],
    chooseYear: "Choose Year",
    chooseMonth: "Choose Month",
    chooseDate: "Choose Date",
    prevDecade: "Previous Decade",
    nextDecade: "Next Decade",
    prevYear: "Previous Year",
    nextYear: "Next Year",
    prevMonth: "Previous Month",
    nextMonth: "Next Month",
    prevHour: "Previous Hour",
    nextHour: "Next Hour",
    prevMinute: "Previous Minute",
    nextMinute: "Next Minute",
    prevSecond: "Previous Second",
    nextSecond: "Next Second",
    am: "AM",
    pm: "PM",
    today: "Today",
    weekHeader: "Wk",
    firstDayOfWeek: 0,
    showMonthAfterYear: !1,
    dateFormat: "dd.mm.yy",
    weak: "Weak",
    medium: "Medium",
    strong: "Strong",
    passwordPrompt: "Enter a password",
    emptyFilterMessage: "No results found",
    searchMessage: "{0} results are available",
    selectionMessage: "{0} items selected",
    emptySelectionMessage: "No selected item",
    emptySearchMessage: "No results found",
    emptyMessage: "No available options",
    aria: {
      trueLabel: "True",
      falseLabel: "False",
      nullLabel: "Not Selected",
      star: "1 star",
      stars: "{star} stars",
      selectAll: "All items selected",
      unselectAll: "All items unselected",
      close: "Close",
      previous: "Previous",
      next: "Next",
      navigation: "Navigation",
      scrollTop: "Scroll Top",
      moveTop: "Move Top",
      moveUp: "Move Up",
      moveDown: "Move Down",
      moveBottom: "Move Bottom",
      moveToTarget: "Move to Target",
      moveToSource: "Move to Source",
      moveAllToTarget: "Move All to Target",
      moveAllToSource: "Move All to Source",
      pageLabel: "Page {page}",
      firstPageLabel: "First Page",
      lastPageLabel: "Last Page",
      nextPageLabel: "Next Page",
      prevPageLabel: "Previous Page",
      rowsPerPageLabel: "Rows per page",
      jumpToPageDropdownLabel: "Jump to Page Dropdown",
      jumpToPageInputLabel: "Jump to Page Input",
      selectRow: "Row Selected",
      unselectRow: "Row Unselected",
      expandRow: "Row Expanded",
      collapseRow: "Row Collapsed",
      showFilterMenu: "Show Filter Menu",
      hideFilterMenu: "Hide Filter Menu",
      filterOperator: "Filter Operator",
      filterConstraint: "Filter Constraint",
      editRow: "Edit Row",
      saveEdit: "Save Edit",
      cancelEdit: "Cancel Edit",
      listView: "List View",
      gridView: "Grid View",
      slide: "Slide",
      slideNumber: "{slideNumber}",
      zoomImage: "Zoom Image",
      zoomIn: "Zoom In",
      zoomOut: "Zoom Out",
      rotateRight: "Rotate Right",
      rotateLeft: "Rotate Left"
    }
  },
  {
    locale: "de",
    startsWith: "Beginnt mit",
    contains: "Enthält",
    notContains: "Enthält nicht",
    endsWith: "Endet mit",
    equals: "Ist gleich",
    notEquals: "Ist ungleich",
    noFilter: "Kein Filter",
    filter: "Filtern",
    lt: "Kleiner als",
    lte: "Kleiner oder gleich",
    gt: "Größer als",
    gte: "Größer oder gleich",
    dateIs: "Datum ist",
    dateIsNot: "Datum ist nicht",
    dateBefore: "Datum ist vor",
    dateAfter: "Datum ist nach",
    custom: "Benutzerdefiniert",
    clear: "Löschen",
    apply: "Übernehmen",
    matchAll: "Passt auf alle",
    matchAny: "Passt auf einige",
    addRule: "Regel hinzufügen",
    removeRule: "Regel entfernen",
    accept: "Ja",
    reject: "Nein",
    choose: "Auswählen",
    upload: "Hochladen",
    cancel: "Abbrechen",
    completed: "Abgeschlossen",
    pending: "Ausstehend",
    fileSizeTypes: ["B", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"],
    dayNames: [
      "Sonntag",
      "Montag",
      "Dienstag",
      "Mittwoch",
      "Donnerstag",
      "Freitag",
      "Samstag"
    ],
    dayNamesShort: ["Son", "Mon", "Die", "Mit", "Don", "Fre", "Sam"],
    dayNamesMin: ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"],
    monthNames: [
      "Januar",
      "Februar",
      "März",
      "April",
      "Mai",
      "Juni",
      "Juli",
      "August",
      "September",
      "Oktober",
      "November",
      "Dezember"
    ],
    monthNamesShort: [
      "Jan",
      "Feb",
      "Mär",
      "Apr",
      "Mai",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Okt",
      "Nov",
      "Dez"
    ],
    chooseYear: "Jahr wählen",
    chooseMonth: "Monat wählen",
    chooseDate: "Datum wählen",
    prevDecade: "Vorheriges Jahrzehnt",
    nextDecade: "Nächstes Jahrzehnt",
    prevYear: "Vorheriges Jahr",
    nextYear: "Nächstes Jahr",
    prevMonth: "Vorheriger Monat",
    nextMonth: "Nächster Monat",
    prevHour: "Vorherige Stunde",
    nextHour: "Nächste Stunde",
    prevMinute: "Vorherige Minute",
    nextMinute: "Nächste Minute",
    prevSecond: "Vorherige Sekunde",
    nextSecond: "Nächste Sekunde",
    am: "am",
    pm: "pm",
    today: "Heute",
    weekHeader: "KW",
    firstDayOfWeek: 1,
    showMonthAfterYear: !1,
    dateFormat: "dd.mm.yy",
    weak: "Schwach",
    medium: "Mittel",
    strong: "Stark",
    passwordPrompt: "Passwort eingeben",
    emptyFilterMessage: "Keine Ergebnisse gefunden",
    searchMessage: "{0} Ergebnisse verfügbar",
    selectionMessage: "{0} Elemente ausgewählt",
    emptySelectionMessage: "Kein ausgewähltes Element",
    emptySearchMessage: "Keine Ergebnisse gefunden",
    emptyMessage: "Keine Einträge gefunden",
    aria: {
      trueLabel: "Wahr",
      falseLabel: "Falsch",
      nullLabel: "Nicht ausgewählt",
      star: "1 Stern",
      stars: "{star} Sterne",
      selectAll: "Alle Elemente ausgewählt",
      unselectAll: "Alle Elemente abgewählt",
      close: "Schließen",
      previous: "Vorherige",
      next: "Nächste",
      navigation: "Navigation",
      scrollTop: "Nach oben scrollen",
      moveTop: "Zum Anfang bewegen",
      moveUp: "Nach oben bewegen",
      moveDown: "Nach unten bewegen",
      moveBottom: "Zum Ende bewegen",
      moveToTarget: "Zum Ziel bewegen",
      moveToSource: "Zur Quelle bewegen",
      moveAllToTarget: "Alle zum Ziel bewegen",
      moveAllToSource: "Alle zur Quelle bewegen",
      pageLabel: "Seite {page}",
      firstPageLabel: "Erste Seite",
      lastPageLabel: "Letzte Seite",
      nextPageLabel: "Nächste Seite",
      prevPageLabel: "Vorherige Seite",
      rowsPerPageLabel: "Zeilen pro Seite",
      jumpToPageDropdownLabel: "Zum Dropdown-Menü springen",
      jumpToPageInputLabel: "Zum Eingabefeld springen",
      selectRow: "Zeile ausgewählt",
      unselectRow: "Zeile abgewählt",
      expandRow: "Zeile erweitert",
      collapseRow: "Zeile reduziert",
      showFilterMenu: "Filtermenü anzeigen",
      hideFilterMenu: "Filtermenü ausblenden",
      filterOperator: "Filteroperator",
      filterConstraint: "Filterbeschränkung",
      editRow: "Zeile bearbeiten",
      saveEdit: "Änderungen speichern",
      cancelEdit: "Änderungen abbrechen",
      listView: "Listenansicht",
      gridView: "Rasteransicht",
      slide: "Folie",
      slideNumber: "{slideNumber}",
      zoomImage: "Bild vergrößern",
      zoomIn: "Vergrößern",
      zoomOut: "Verkleinern",
      rotateRight: "Nach rechts drehen",
      rotateLeft: "Nach links drehen"
    }
  },
  {
    locale: "es",
    startsWith: "Comience con",
    contains: "Contenga",
    notContains: "No contenga",
    endsWith: "Termine con",
    equals: "Igual a",
    notEquals: "Diferente a",
    noFilter: "Sin filtro",
    lt: "Menor que",
    lte: "Menor o igual a",
    gt: "Mayor que",
    gte: "Mayor o igual a",
    dateIs: "Fecha igual a",
    dateIsNot: "Fecha diferente a",
    dateBefore: "Fecha antes de",
    dateAfter: "Fecha después de",
    custom: "Personalizar",
    clear: "Limpiar",
    apply: "Aplicar",
    matchAll: "Coincidir todo",
    matchAny: "Coincidir con cualquiera",
    addRule: "Agregar regla",
    removeRule: "Eliminar regla",
    accept: "Sí",
    reject: "No",
    choose: "Escoger",
    upload: "Subir",
    cancel: "Cancelar",
    dayNames: [
      "Domingo",
      "Lunes",
      "Martes",
      "Miércoles",
      "Jueves",
      "Viernes",
      "Sábado"
    ],
    dayNamesShort: ["Dom", "Lun", "Mar", "Mié", "Jue", "Vie", "Sáb"],
    dayNamesMin: ["D", "L", "M", "X", "J", "V", "S"],
    monthNames: [
      "Enero",
      "Febrero",
      "Marzo",
      "Abril",
      "Mayo",
      "Junio",
      "Julio",
      "Agosto",
      "Septiembre",
      "Octubre",
      "Noviembre",
      "Diciembre"
    ],
    monthNamesShort: [
      "Ene",
      "Feb",
      "Mar",
      "Abr",
      "May",
      "Jun",
      "Jul",
      "Ago",
      "Sep",
      "Oct",
      "Nov",
      "Dic"
    ],
    today: "Hoy",
    weekHeader: "Sem",
    firstDayOfWeek: 1,
    showMonthAfterYear: !1,
    dateFormat: "dd/mm/yy",
    weak: "Débil",
    medium: "Medio",
    strong: "Fuerte",
    passwordPrompt: "Escriba una contraseña",
    emptyFilterMessage: "Sin opciones disponibles",
    emptyMessage: "No se han encontrado resultados",
    aria: {
      trueLabel: "Verdadero",
      falseLabel: "Falso",
      nullLabel: "No seleccionado",
      star: "1 estrella",
      stars: "{star} estrellas",
      selectAll: "Seleccionar todos",
      unselectAll: "Deseleccionar todos",
      close: "Cerrar",
      previous: "Anterior",
      next: "Siguiente",
      navigation: "Navegación",
      scrollTop: "Desplazarse arriba",
      moveTop: "Mover arriba",
      moveUp: "Subir",
      moveDown: "Bajar",
      moveBottom: "Desplazarse abajo",
      moveToTarget: "Mover al objectivo",
      moveToSource: "Mover al fuente",
      moveAllToTarget: "Mover todo al objetivo",
      moveAllToSource: "Mover todo al fuente",
      pageLabel: "Página {page}",
      firstPageLabel: "Primera Página",
      lastPageLabel: "Última Página",
      nextPageLabel: "Siguiente Página",
      prevPageLabel: "Página Anterior",
      rowsPerPageLabel: "Filas por página",
      jumpToPageDropdownLabel: "Ir al menú desplegable de página",
      jumpToPageInputLabel: "Ir a la entrada de página",
      selectRow: "Seleccionar fila",
      unselectRow: "Desmarcar fila",
      expandRow: "Expandir Fila",
      collapseRow: "Reducir Fila",
      showFilterMenu: "Mostrar menú del filtro",
      hideFilterMenu: "Ocultar menú del filtro",
      filterOperator: "Operador de filtro",
      filterConstraint: "Restricción de filtro",
      editRow: "Editar fila",
      saveEdit: "Guardar editado",
      cancelEdit: "Cancelar editado",
      listView: "Vista de lista",
      gridView: "Vista de cuadrícula",
      slide: "Deslizar",
      slideNumber: "{slideNumber}",
      zoomImage: "Ampliar imagen",
      zoomIn: "Ampliar",
      zoomOut: "Reducir",
      rotateRight: "Girar derecha",
      rotateLeft: "Girar izquierda"
    }
  },
  {
    locale: "fr",
    startsWith: "Commence par",
    contains: "Contient",
    notContains: "Ne contient pas",
    endsWith: "Se termine par",
    equals: "Égal à",
    notEquals: "Différent de",
    noFilter: "Aucun filtre",
    filter: "Filtre",
    lt: "Inférieur à",
    lte: "Inférieur ou égal à",
    gt: "Supérieur à",
    gte: "Supérieur ou égal à",
    dateIs: "La date est",
    dateIsNot: "La date n'est pas",
    dateBefore: "Avant le",
    dateAfter: "Après le",
    custom: "Personnalisé",
    clear: "Effacer",
    apply: "Appliquer",
    matchAll: "Correspond à tous",
    matchAny: "Au moins un Correspond",
    addRule: "Ajouter une règle",
    removeRule: "Retirer une règle",
    accept: "Oui",
    reject: "Non",
    choose: "Choisir",
    upload: "Envoyer",
    cancel: "Annuler",
    completed: "Terminé",
    pending: "En attente",
    fileSizeTypes: ["B", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"],
    dayNames: [
      "Dimanche",
      "Lundi",
      "Mardi",
      "Mercredi",
      "Jeudi",
      "Vendredi",
      "Samedi"
    ],
    dayNamesShort: ["Dim", "Lun", "Mar", "Mer", "Jeu", "Ven", "Sam"],
    dayNamesMin: ["Di", "Lu", "Mar", "Mer", "Je", "Ve", "Sa"],
    monthNames: [
      "Janvier",
      "Février",
      "Mars",
      "Avril",
      "Mai",
      "Juin",
      "Juillet",
      "Août",
      "Septembre",
      "Octobre",
      "Novembre",
      "Décembre"
    ],
    monthNamesShort: [
      "Jan",
      "Fev",
      "Mar",
      "Avr",
      "Mai",
      "Jun",
      "Jui",
      "Août",
      "Sept",
      "Oct",
      "Nov",
      "Dec"
    ],
    chooseYear: "Choisir une année",
    chooseMonth: "Choisir un mois",
    chooseDate: "Choisir une date",
    prevDecade: "Décennie précédente",
    nextDecade: "Décennie suivante",
    prevYear: "Année précédente",
    nextYear: "Année suivante",
    prevMonth: "Mois précédent",
    nextMonth: "Mois suivant",
    prevHour: "Heure précédente",
    nextHour: "Heure suivante",
    prevMinute: "Minute précédente",
    nextMinute: "Minute suivante",
    prevSecond: "Seconde précédente",
    nextSecond: "Seconde suivante",
    am: "am",
    pm: "pm",
    today: "Aujourd'hui",
    weekHeader: "Sem",
    firstDayOfWeek: 1,
    showMonthAfterYear: !1,
    dateFormat: "dd/mm/yy",
    weak: "Faible",
    medium: "Moyen",
    strong: "Fort",
    passwordPrompt: "Saisissez un mot de passe",
    emptyFilterMessage: "Aucun résultat trouvé",
    searchMessage: "{0} résultats disponibles",
    selectionMessage: "{0} éléments sélectionnés",
    emptySelectionMessage: "Aucun élément sélectionné",
    emptySearchMessage: "Aucun résultat trouvé",
    emptyMessage: "Aucune option disponible",
    aria: {
      trueLabel: "Vrai",
      falseLabel: "Faux",
      nullLabel: "Aucune sélection",
      star: "1 étoile",
      stars: "{star} étoiles",
      selectAll: "Tous éléments sélectionnés",
      unselectAll: "Tous éléments désélectionnés",
      close: "Fermer",
      previous: "Précédent",
      next: "Suivant",
      navigation: "Navigation",
      scrollTop: "Défiler tout en haut",
      moveTop: "Déplacer tout en haut",
      moveUp: "Déplacer vers le haut",
      moveDown: "Déplacer vers le bas",
      moveBottom: "Déplacer tout en bas",
      moveToTarget: "Déplacer vers la cible",
      moveToSource: "Déplacer vers la source",
      moveAllToTarget: "Tout déplacer vers la cible",
      moveAllToSource: "Tout déplacer vers la source",
      pageLabel: "Page {page}",
      firstPageLabel: "Première Page",
      lastPageLabel: "Dernière Page",
      nextPageLabel: "Page Suivante",
      rowsPerPageLabel: "Lignes par page",
      prevPageLabel: "Page précédente",
      jumpToPageDropdownLabel: "Aller à la page",
      jumpToPageInputLabel: "Aller à la page",
      selectRow: "Ligne sélectionnée",
      unselectRow: "Ligne désélectionnée",
      expandRow: "Ligne dépliée",
      collapseRow: "Ligne repliée",
      showFilterMenu: "Montre le menu des filtres",
      hideFilterMenu: "Masque le menu des filtres",
      filterOperator: "Opérateur de filtrage",
      filterConstraint: "Contrainte de filtrage",
      editRow: "Édite une ligne",
      saveEdit: "Sauvegarde l'édition",
      cancelEdit: "Annule l'édition",
      listView: "Vue en liste",
      gridView: "Vue en grille",
      slide: "Diapositive",
      slideNumber: "{slideNumber}",
      zoomImage: "Zoomer l'image",
      zoomIn: "Zoomer",
      zoomOut: "Dézoomer",
      rotateRight: "Tourner vers la droite",
      rotateLeft: "Tourner vers la gauche"
    }
  },
  {
    locale: "it",
    startsWith: "Inizia con",
    contains: "Contiene",
    notContains: "Non contiene",
    endsWith: "Finisce con",
    equals: "Equivale",
    notEquals: "Non uguale",
    noFilter: "Senza Filtro",
    filter: "Filtro",
    lt: "Minore di",
    lte: "Minore o uguale a",
    gt: "Maggiore di",
    gte: "Maggiore o uguale a",
    dateIs: "La data è",
    dateIsNot: "La data non è",
    dateBefore: "La data è precedente",
    dateAfter: "La data è successiva",
    custom: "Personalizzato",
    clear: "Cancella tutto",
    apply: "Applica",
    matchAll: "Abbina tutto",
    matchAny: "Abbina alcuni",
    addRule: "Aggiungi regola",
    removeRule: "Rimuovi regola",
    accept: "Si",
    reject: "No",
    choose: "Scegli",
    upload: "Carica",
    cancel: "Annulla",
    completed: "Completato",
    pending: "In corso",
    fileSizeTypes: ["B", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"],
    dayNames: [
      "Domenica",
      "Lunedi",
      "Martedì",
      "Mercoledì",
      "Giovedì",
      "Venerdì",
      "Sabato"
    ],
    dayNamesShort: ["Dom", "Lun", "Mar", "Mer", "Gio", "Ven", "Sab"],
    dayNamesMin: ["Do", "Lu", "Ma", "Me", "Gi", "Ve", "Sa"],
    monthNames: [
      "Gennaio",
      "Febbraio",
      "Marzo",
      "Aprile",
      "Maggio",
      "Giugno",
      "Luglio",
      "Agosto",
      "Settembre",
      "Ottobre",
      "Novembre",
      "Dicembre"
    ],
    monthNamesShort: [
      "Gen",
      "Feb",
      "Mar",
      "Apr",
      "Mag",
      "Giu",
      "Lug",
      "Ago",
      "Set",
      "Ott",
      "Nov",
      "Dic"
    ],
    chooseYear: "Seleziona Anno",
    chooseMonth: "Seleziona Mese",
    chooseDate: "Seleziona Data",
    prevDecade: "Decade precedente",
    nextDecade: "Decade successiva",
    prevYear: "Anno precedente",
    nextYear: "Anno successivo",
    prevMonth: "Mese precedente",
    nextMonth: "Mese successivo",
    prevHour: "Ora precedente",
    nextHour: "Ora successiva",
    prevMinute: "Minuto precedente",
    nextMinute: "Minuto successivo",
    prevSecond: "Secondo precedente",
    nextSecond: "Secondo successivo",
    am: "AM",
    pm: "PM",
    today: "Oggi",
    weekHeader: "Sett",
    firstDayOfWeek: 1,
    showMonthAfterYear: !1,
    dateFormat: "dd/mm/yy",
    weak: "Debole",
    medium: "Medio",
    strong: "Forte",
    passwordPrompt: "Inserisci la password",
    emptyFilterMessage: "Nessuna opzione disponibile",
    searchMessage: "{0} risultati disponibili",
    selectionMessage: "{0} elementi selezionati",
    emptySelectionMessage: "Nessun elemento selezionato",
    emptySearchMessage: "Nessun risultato trovato",
    emptyMessage: "Nessun risultato trovato",
    aria: {
      trueLabel: "Vero",
      falseLabel: "Falso",
      nullLabel: "Non selezionato",
      pageLabel: "Pagina {page}",
      firstPageLabel: "Prima pagina",
      lastPageLabel: "Ultima pagina",
      nextPageLabel: "Pagina successiva",
      prevPageLabel: "Pagina precedente",
      selectLabel: "Seleziona",
      unselectLabel: "Deseleziona",
      expandLabel: "Espandi",
      collapseLabel: "Riduci",
      star: "1 stella",
      stars: "{star} stelle",
      selectAll: "Seleziona tutti gli elementi",
      unselectAll: "Deseleziona tutti gli elementi",
      close: "Chiudi",
      previous: "Precedente",
      next: "Successivo",
      navigation: "Naviga",
      scrollTop: "Torna sù",
      moveTop: "Vai in cima",
      moveUp: "Vai sopra",
      moveDown: "Vai sotto",
      moveBottom: "Vai in fondo",
      moveToTarget: "Vai all'elemento",
      moveToSource: "Vai alla sorgente",
      moveAllToTarget: "Muovi tutto all'elemento",
      moveAllToSource: "Muovi tutto alla sorgente",
      rowsPerPageLabel: "Elementi per pagina",
      jumpToPageDropdownLabel: "Vai alla Dropdown delle pagine",
      jumpToPageInputLabel: "Vai all'Input delle pagine",
      selectRow: "Seleziona riga",
      unselectRow: "Deseleziona riga",
      expandRow: "Espandi riga",
      collapseRow: "Riduci riga",
      showFilterMenu: "Mostra Menu filtri",
      hideFilterMenu: "Nascondi Menu filtri",
      filterOperator: "Operatore di filtro",
      filterConstraint: "Costante di filtro",
      editRow: "Modifica riga",
      saveEdit: "Salva modifica",
      cancelEdit: "Annulla modifica",
      listView: "Lista",
      gridView: "Griglia",
      slide: "Scorri",
      slideNumber: "{slideNumber}",
      zoomImage: "Zoom Immagine",
      zoomIn: "Ingrandisci",
      zoomOut: "Riduci",
      rotateRight: "Ruota a destra",
      rotateLeft: "Ruota a sinistra"
    }
  },
  {
    locale: "ja",
    startsWith: "始まる",
    contains: "含む",
    notContains: "含まない",
    endsWith: "終わる",
    equals: "等しい",
    notEquals: "等しくない",
    noFilter: "フィルターなし",
    filter: "フィルター",
    lt: "未満",
    lte: "以下",
    gt: "超える",
    gte: "以上",
    dateIs: "等しい",
    dateIsNot: "等しくない",
    dateBefore: "指定日より過去",
    dateAfter: "指定日より未来",
    custom: "カスタム",
    clear: "クリア",
    apply: "適用",
    matchAll: "全て一致",
    matchAny: "いずれかが一致",
    addRule: "条件追加",
    removeRule: "条件削除",
    accept: "はい",
    reject: "いいえ",
    choose: "選択",
    upload: "アップロード",
    cancel: "キャンセル",
    completed: "完了済",
    pending: "保留",
    fileSizeTypes: ["B", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"],
    dayNames: [
      "日曜日",
      "月曜日",
      "火曜日",
      "水曜日",
      "木曜日",
      "金曜日",
      "土曜日"
    ],
    dayNamesShort: ["日", "月", "火", "水", "木", "金", "土"],
    dayNamesMin: ["日", "月", "火", "水", "木", "金", "土"],
    monthNames: [
      "1月",
      "2月",
      "3月",
      "4月",
      "5月",
      "6月",
      "7月",
      "8月",
      "9月",
      "10月",
      "11月",
      "12月"
    ],
    monthNamesShort: [
      "1月",
      "2月",
      "3月",
      "4月",
      "5月",
      "6月",
      "7月",
      "8月",
      "9月",
      "10月",
      "11月",
      "12月"
    ],
    chooseYear: "年を選択",
    chooseMonth: "月を選択",
    chooseDate: "日を選択",
    prevDecade: "前の10年",
    nextDecade: "後の10年",
    prevYear: "前年",
    nextYear: "翌年",
    prevMonth: "先月",
    nextMonth: "翌月",
    prevHour: "前の時間",
    nextHour: "次の時間",
    prevMinute: "前の分",
    nextMinute: "次の分",
    prevSecond: "前の秒",
    nextSecond: "次の秒",
    am: "午前",
    pm: "午後",
    today: "今日",
    weekHeader: "週",
    firstDayOfWeek: 0,
    showMonthAfterYear: !0,
    dateFormat: "yy年mm月dd日",
    weak: "弱い",
    medium: "普通",
    strong: "強い",
    passwordPrompt: "パスワードを入力",
    emptyFilterMessage: "オプションなし",
    searchMessage: "{0} 件の結果",
    selectionMessage: "{0} 件選択済み",
    emptySelectionMessage: "選択なし",
    emptySearchMessage: "該当なし",
    emptyMessage: "結果なし",
    aria: {
      trueLabel: "True",
      falseLabel: "False",
      nullLabel: "未選択",
      star: "1件のスター",
      stars: "{star}件のスター",
      selectAll: "全て選択",
      unselectAll: "すべての選択を解除",
      close: "閉じる",
      previous: "前",
      next: "次",
      navigation: "ナビゲーション",
      scrollTop: "トップへスクロール",
      moveTop: "トップへ移動",
      moveUp: "上へ",
      moveDown: "下へ",
      moveBottom: "一番下へ",
      moveToTarget: "ターゲットへ移動",
      moveToSource: "ソースへ移動",
      moveAllToTarget: "ターゲットへ全て移動",
      moveAllToSource: "ソースへ全て移動",
      pageLabel: "{page}ページ",
      firstPageLabel: "最初のページ",
      lastPageLabel: "最後のページ",
      nextPageLabel: "次のページ",
      prevPageLabel: "前のページ",
      rowsPerPageLabel: "行/ページ",
      jumpToPageDropdownLabel: "ページドロップダウンへ",
      jumpToPageInputLabel: "ページ入力へ",
      selectRow: "選択済み行",
      unselectRow: "未選択行",
      expandRow: "展開済行",
      collapseRow: "折りたたみ行",
      showFilterMenu: "フィルターメニューを表示",
      hideFilterMenu: "フィルターメニューを非表示",
      filterOperator: "フィルター操作",
      filterConstraint: "フィルター成約",
      editRow: "行編集",
      saveEdit: "保存",
      cancelEdit: "キャンセル",
      listView: "リストビュー",
      gridView: "グリッドビュー",
      slide: "スライド",
      slideNumber: "{slideNumber}",
      zoomImage: "画像を拡大",
      zoomIn: "拡大",
      zoomOut: "縮小",
      rotateRight: "右に回転",
      rotateLeft: "左に回転"
    }
  },
  {
    locale: "nl",
    startsWith: "Begint met",
    contains: "Bevat",
    notContains: "Bevat niet",
    endsWith: "Eindigt met",
    equals: "Is gelijk aan",
    notEquals: "Is niet gelijk aan",
    noFilter: "Geen filter",
    filter: "Filter",
    lt: "Kleiner dan",
    lte: "Kleiner dan of gelijk aan",
    gt: "Groter dan",
    gte: "Groter dan of gelijk aan",
    dateIs: "Datum is",
    dateIsNot: "Datum is niet",
    dateBefore: "Datum is voor",
    dateAfter: "Date is na",
    custom: "Aangepast",
    clear: "Wissen",
    apply: "Toepassen",
    matchAll: "Overeenkomen met alle",
    matchAny: "Overeenkomen met elke",
    addRule: "Voeg regel toe",
    removeRule: "Verwijder regel",
    accept: "Ja",
    reject: "Nee",
    choose: "Kies",
    upload: "Upload",
    cancel: "Annuleer",
    completed: "Voltooid",
    pending: "In behandeling",
    fileSizeTypes: ["B", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"],
    dayNames: [
      "zondag",
      "maandag",
      "dinsdag",
      "woensdag",
      "donderdag",
      "vrijdag",
      "zaterdag"
    ],
    dayNamesShort: ["zon", "ma", "di", "woe", "do", "vrij", "zat"],
    dayNamesMin: ["zo", "ma", "di", "wo", "do", "vr", "za"],
    monthNames: [
      "januari",
      "februari",
      "maart",
      "april",
      "mei",
      "juni",
      "juli",
      "augustus",
      "september",
      "oktober",
      "november",
      "december"
    ],
    monthNamesShort: [
      "jan",
      "feb",
      "mar",
      "apr",
      "mei",
      "jun",
      "jul",
      "aug",
      "sep",
      "okt",
      "nov",
      "dec"
    ],
    chooseYear: "Kies jaar",
    chooseMonth: "Kies maand",
    chooseDate: "Kies datum",
    prevDecade: "Vorig decennium",
    nextDecade: "Volgend decennium",
    prevYear: "Vorig jaar",
    nextYear: "Volgend jaar",
    prevMonth: "Vorige maand",
    nextMonth: "Volgende maand",
    prevHour: "Vorig uur",
    nextHour: "Volgend uur",
    prevMinute: "Vorige minuut",
    nextMinute: "Volgende minuut",
    prevSecond: "Vorige seconde",
    nextSecond: "Volgende seconde",
    am: "voormiddag",
    pm: "namiddag",
    today: "Vandaag",
    weekHeader: "Wk",
    firstDayOfWeek: 1,
    showMonthAfterYear: !1,
    dateFormat: "dd-mm-yy",
    weak: "Zwak",
    medium: "Gemiddeld",
    strong: "Sterk",
    passwordPrompt: "Geef een wachtwoord",
    emptyFilterMessage: "Geen resultaten gevonden",
    searchMessage: "{0} resultaten beschikbaar",
    selectionMessage: "{0} opties geselecteerd",
    emptySelectionMessage: "Geen optie geselecteerd",
    emptySearchMessage: "Geen resultaten gevonden",
    emptyMessage: "Geen beschikbare opties",
    aria: {
      trueLabel: "Waar",
      falseLabel: "Onwaar",
      nullLabel: "Niet geselecteerd",
      star: "1 ster",
      stars: "{star} sterren",
      selectAll: "Alle opties geselecteerd",
      unselectAll: "Alle opties gedeselecteerd",
      close: "Sluit",
      previous: "Vorige",
      next: "Volgende",
      navigation: "Navigatie",
      scrollTop: "Scroll naar boven",
      moveTop: "Verplaats naar boven",
      moveUp: "Verplaats omhoog",
      moveDown: "Verplaats omlaag",
      moveBottom: "Verplaats naar beneden",
      moveToTarget: "Verplaats naar doel",
      moveToSource: "Verplaats naar bron",
      moveAllToTarget: "Verplaats alle naar doel",
      moveAllToSource: "Verplaats alle naar bron",
      pageLabel: "Pagina {page}",
      firstPageLabel: "Eerste pagina",
      lastPageLabel: "Laatste pagina",
      nextPageLabel: "Volgende pagina",
      prevPageLabel: "Vorige pagina",
      rowsPerPageLabel: "Rijen per pagina",
      jumpToPageDropdownLabel: "Spring naar paginamenu",
      jumpToPageInputLabel: "Spring naar pagina-invoer",
      selectRow: "Rij geselecteerd",
      unselectRow: "Rij gedeselecteerd",
      expandRow: "Rij uitgeklapt",
      collapseRow: "Rij ingeklapt",
      showFilterMenu: "Toon filtermenu",
      hideFilterMenu: "Verberg filtermenu",
      filterOperator: "Filteroperator",
      filterConstraint: "Filterbeperking",
      editRow: "Bewerk rij",
      saveEdit: "Sla bewerking op",
      cancelEdit: "Annuleer bewerking",
      listView: "Lijstweergave",
      gridView: "Roosterweergave",
      slide: "Dia",
      slideNumber: "{slideNumber}",
      zoomImage: "Zoom afbeeling",
      zoomIn: "Zoom in",
      zoomOut: "Zoom uit",
      rotateRight: "Draai rechtsom",
      rotateLeft: "Draai linksom"
    }
  },
  {
    locale: "nl-BE",
    startsWith: "Begint met",
    contains: "Bevat",
    notContains: "Bevat niet",
    endsWith: "Eindigt met",
    equals: "Is gelijk aan",
    notEquals: "Is niet gelijk aan",
    noFilter: "Geen filter",
    filter: "Filter",
    lt: "Kleiner dan",
    lte: "Kleiner dan of gelijk aan",
    gt: "Groter dan",
    gte: "Groter dan of gelijk aan",
    dateIs: "Datum is",
    dateIsNot: "Datum is niet",
    dateBefore: "Datum is voor",
    dateAfter: "Date is na",
    custom: "Aangepast",
    clear: "Wissen",
    apply: "Toepassen",
    matchAll: "Overeenkomen met alle",
    matchAny: "Overeenkomen met elke",
    addRule: "Voeg regel toe",
    removeRule: "Verwijder regel",
    accept: "Ja",
    reject: "Nee",
    choose: "Kies",
    upload: "Upload",
    cancel: "Annuleer",
    completed: "Voltooid",
    pending: "In behandeling",
    fileSizeTypes: ["B", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"],
    dayNames: [
      "zondag",
      "maandag",
      "dinsdag",
      "woensdag",
      "donderdag",
      "vrijdag",
      "zaterdag"
    ],
    dayNamesShort: ["zon", "ma", "di", "woe", "do", "vrij", "zat"],
    dayNamesMin: ["zo", "ma", "di", "wo", "do", "vr", "za"],
    monthNames: [
      "januari",
      "februari",
      "maart",
      "april",
      "mei",
      "juni",
      "juli",
      "augustus",
      "september",
      "oktober",
      "november",
      "december"
    ],
    monthNamesShort: [
      "jan",
      "feb",
      "mar",
      "apr",
      "mei",
      "jun",
      "jul",
      "aug",
      "sep",
      "okt",
      "nov",
      "dec"
    ],
    chooseYear: "Kies jaar",
    chooseMonth: "Kies maand",
    chooseDate: "Kies datum",
    prevDecade: "Vorig decennium",
    nextDecade: "Volgend decennium",
    prevYear: "Vorig jaar",
    nextYear: "Volgend jaar",
    prevMonth: "Vorige maand",
    nextMonth: "Volgende maand",
    prevHour: "Vorig uur",
    nextHour: "Volgend uur",
    prevMinute: "Vorige minuut",
    nextMinute: "Volgende minuut",
    prevSecond: "Vorige seconde",
    nextSecond: "Volgende seconde",
    am: "voormiddag",
    pm: "namiddag",
    today: "Vandaag",
    weekHeader: "Wk",
    firstDayOfWeek: 1,
    showMonthAfterYear: !1,
    dateFormat: "dd/mm/yy",
    weak: "Zwak",
    medium: "Gemiddeld",
    strong: "Sterk",
    passwordPrompt: "Geef een wachtwoord",
    emptyFilterMessage: "Geen resultaten gevonden",
    searchMessage: "{0} resultaten beschikbaar",
    selectionMessage: "{0} opties geselecteerd",
    emptySelectionMessage: "Geen optie geselecteerd",
    emptySearchMessage: "Geen resultaten gevonden",
    emptyMessage: "Geen beschikbare opties",
    aria: {
      trueLabel: "Waar",
      falseLabel: "Onwaar",
      nullLabel: "Niet geselecteerd",
      star: "1 ster",
      stars: "{star} sterren",
      selectAll: "Alle opties geselecteerd",
      unselectAll: "Alle opties gedeselecteerd",
      close: "Sluit",
      previous: "Vorige",
      next: "Volgende",
      navigation: "Navigatie",
      scrollTop: "Scroll naar boven",
      moveTop: "Verplaats naar boven",
      moveUp: "Verplaats omhoog",
      moveDown: "Verplaats omlaag",
      moveBottom: "Verplaats naar beneden",
      moveToTarget: "Verplaats naar doel",
      moveToSource: "Verplaats naar bron",
      moveAllToTarget: "Verplaats alle naar doel",
      moveAllToSource: "Verplaats alle naar bron",
      pageLabel: "Pagina {page}",
      firstPageLabel: "Eerste pagina",
      lastPageLabel: "Laatste pagina",
      nextPageLabel: "Volgende pagina",
      prevPageLabel: "Vorige pagina",
      rowsPerPageLabel: "Rijen per pagina",
      jumpToPageDropdownLabel: "Spring naar paginamenu",
      jumpToPageInputLabel: "Spring naar pagina-invoer",
      selectRow: "Rij geselecteerd",
      unselectRow: "Rij gedeselecteerd",
      expandRow: "Rij uitgeklapt",
      collapseRow: "Rij ingeklapt",
      showFilterMenu: "Toon filtermenu",
      hideFilterMenu: "Verberg filtermenu",
      filterOperator: "Filteroperator",
      filterConstraint: "Filterbeperking",
      editRow: "Bewerk rij",
      saveEdit: "Sla bewerking op",
      cancelEdit: "Annuleer bewerking",
      listView: "Lijstweergave",
      gridView: "Roosterweergave",
      slide: "Dia",
      slideNumber: "{slideNumber}",
      zoomImage: "Zoom afbeeling",
      zoomIn: "Zoom in",
      zoomOut: "Zoom uit",
      rotateRight: "Draai rechtsom",
      rotateLeft: "Draai linksom"
    }
  },
  {
    locale: "sv",
    accept: "Ja",
    addRule: "Lägg till regel",
    am: "AM",
    apply: "Använd",
    cancel: "Avbryt",
    choose: "Välj",
    chooseDate: "Välj Datum",
    chooseMonth: "Välj månad",
    chooseYear: "Välj år",
    clear: "Rensa",
    close: "Stäng",
    completed: "Avslutad",
    contains: "Innehåller",
    custom: "Anpassad",
    dateAfter: "Datumet är senare än",
    dateBefore: "Datumet är tidigare än",
    dateFormat: "yy-mm-dd",
    dateIs: "Datumet är",
    dateIsNot: "Datumet är inte",
    dayNames: [
      "Söndag",
      "Måndag",
      "Tisdag",
      "Onsdag",
      "Torsdag",
      "Fredag",
      "Lördag"
    ],
    dayNamesMin: ["S", "M", "T", "O", "T", "F", "L"],
    dayNamesShort: ["Sön", "Mån", "Tis", "Ons", "Tor", "Fre", "Lör"],
    emptyFilterMessage: "Inga tillgängliga rader",
    emptyMessage: "Inga resultat hittades",
    emptySearchMessage: "Inga resultat funna",
    emptySelectionMessage: "Inget valt objekt",
    endsWith: "Slutar med",
    equals: "Lika med",
    fileSizeTypes: ["B", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"],
    filter: "Filter",
    firstDayOfWeek: 1,
    gt: "Större än",
    gte: "Större än eller lika med",
    lt: "Mindre än",
    lte: "Mindre än eller lika med",
    matchAll: "Matcha alla",
    matchAny: "Matcha något",
    medium: "Mellan",
    monthNames: [
      "Januari",
      "Februari",
      "Mars",
      "April",
      "Maj",
      "Juni",
      "Juli",
      "Augusti",
      "September",
      "Oktober",
      "November",
      "December"
    ],
    monthNamesShort: [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "Maj",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Okt",
      "Nov",
      "Dec"
    ],
    nextDecade: "Nästa decennium",
    nextHour: "Nästa timme",
    nextMinute: "Nästa minut",
    nextMonth: "Nästa månad",
    nextSecond: "Nästa sekund",
    nextYear: "Nästa år",
    noFilter: "Inget filter",
    notContains: "Innehåller inte",
    notEquals: "Inte lika med",
    now: "Nu",
    passwordPrompt: "Fyll i lösenord",
    pending: "I väntan på",
    pm: "PM",
    prevDecade: "Föregående decennium",
    prevHour: "Föregående timme",
    prevMinute: "Föregående minut",
    prevMonth: "Förra månaden",
    prevSecond: "Föregående andra",
    prevYear: "Förra året",
    reject: "Nej",
    removeRule: "Ta bort regel",
    searchMessage: "{0} resultat är tillgängliga",
    selectionMessage: "{0} objekt har valts",
    showMonthAfterYear: !1,
    startsWith: "Börjar med",
    strong: "Starkt",
    today: "Idag",
    upload: "Ladda upp",
    weak: "Svagt",
    weekHeader: "v",
    aria: {
      cancelEdit: "Avbryt redigera",
      close: "Stänga",
      collapseLabel: "Fäll ihop",
      collapseRow: "Rad kollapsade",
      editRow: "Redigera rad",
      expandLabel: "Expandera",
      expandRow: "Rad utökad",
      falseLabel: "Falskt",
      filterConstraint: "Filterbegränsning",
      filterOperator: "Filteroperatör",
      firstPageLabel: "Första sidan",
      gridView: "Rutnätsvy",
      hideFilterMenu: "Dölj filtermenyn",
      jumpToPageDropdownLabel: "Hoppa till rullgardinsmenyn",
      jumpToPageInputLabel: "Hoppa till Sidinmatning",
      lastPageLabel: "Sista sidan",
      listView: "Listvy",
      moveAllToSource: "Flytta alla till källan",
      moveAllToTarget: "Flytta alla till mål",
      moveBottom: "Flytta botten",
      moveDown: "Flytta ner",
      moveTop: "Flytta toppen",
      moveToSource: "Flytta till Källa",
      moveToTarget: "Flytta till mål",
      moveUp: "Flytta upp",
      navigation: "Navigering",
      next: "Nästa",
      nextPageLabel: "Nästa sida",
      nullLabel: "Ej vald",
      otpLabel: "Vänligen ange tecken för engångslösenord {0}",
      pageLabel: "Sida {page}",
      passwordHide: "Dölj lösenord",
      passwordShow: "Visa lösenord",
      previous: "Tidigare",
      prevPageLabel: "Föregående sida",
      rotateLeft: "Rotera vänster",
      rotateRight: "Vrid höger",
      rowsPerPageLabel: "Rader per sida",
      saveEdit: "Spara Redigera",
      scrollTop: "Bläddra till toppen",
      selectAll: "Alla objekt markerade",
      selectLabel: "Markera",
      selectRow: "Rad vald",
      showFilterMenu: "Visa filtermeny",
      slide: "Glida",
      slideNumber: "{slideNumber}",
      star: "1 stjärna",
      stars: "{stjärna} stjärnor",
      trueLabel: "Sant",
      unselectAll: "Alla objekt avmarkerade",
      unselectLabel: "Avmarkera",
      unselectRow: "Rad avmarkerad",
      zoomImage: "Zooma bild",
      zoomIn: "Zooma in",
      zoomOut: "Zooma ut"
    }
  },
  {
    locale: "ko",
    startsWith: "으로 시작하는",
    contains: "포함하는",
    notContains: "포함하지 않는",
    endsWith: "으로 끝나는",
    equals: "같은",
    notEquals: "같지 않는",
    noFilter: "필터하지 않은",
    filter: "필터",
    lt: "보다 작은",
    lte: "보다 같거나 작은",
    gt: "보다 큰",
    gte: "보다 같거나 큰",
    dateIs: "날짜가 같은",
    dateIsNot: "날짜가 같지 않은",
    dateBefore: "날짜 전",
    dateAfter: "날짜 후",
    custom: "커스텀",
    clear: "초기화",
    apply: "적용",
    matchAll: "모두 맞는",
    matchAny: "하나라도 맞는",
    addRule: "규칙 추가",
    removeRule: "규칙 제거",
    accept: "예",
    reject: "아니오",
    choose: "선택",
    upload: "업로드",
    cancel: "취소",
    completed: "완료",
    pending: "대기",
    fileSizeTypes: ["B", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"],
    dayNames: [
      "일요일",
      "월요일",
      "화요일",
      "수요일",
      "목요일",
      "금요일",
      "토요일"
    ],
    dayNamesShort: ["일", "월", "화", "수", "목", "금", "토"],
    dayNamesMin: ["일", "월", "화", "수", "목", "금", "토"],
    monthNames: [
      "1월",
      "2월",
      "3월",
      "4월",
      "5월",
      "6월",
      "7월",
      "8월",
      "9월",
      "10월",
      "11월",
      "12월"
    ],
    monthNamesShort: [
      "1월",
      "2월",
      "3월",
      "4월",
      "5월",
      "6월",
      "7월",
      "8월",
      "9월",
      "10월",
      "11월",
      "12월"
    ],
    chooseYear: "년을 선택하세요",
    chooseMonth: "월을 선택하세요",
    chooseDate: "일을 선택하세요",
    prevDecade: "10년 전",
    nextDecade: "10년 후",
    prevYear: "작년",
    nextYear: "내년",
    prevMonth: "전달",
    nextMonth: "다음달",
    prevHour: "이전 시간",
    nextHour: "다음 시간",
    prevMinute: "이전 분",
    nextMinute: "다음 분",
    prevSecond: "이전 초",
    nextSecond: "다음 초",
    am: "AM",
    pm: "PM",
    today: "오늘",
    weekHeader: "Wk",
    firstDayOfWeek: 0,
    showMonthAfterYear: !1,
    dateFormat: "yy-mm-dd",
    weak: "약함",
    medium: "보통",
    strong: "강함",
    passwordPrompt: "패스워드를 입력하세요",
    emptyFilterMessage: "결과가 없습니다.",
    searchMessage: "{0} 개 사용 가능",
    selectionMessage: "{0} 개 선택",
    emptySelectionMessage: "선택되지 않았습니다",
    emptySearchMessage: "결과가 없습니다",
    emptyMessage: "가능한 선택이 없습니다.",
    aria: {
      trueLabel: "참",
      falseLabel: "거짓",
      nullLabel: "선택되지 않음",
      star: "별 1개",
      stars: "별 {star}개",
      selectAll: "모두 선택",
      unselectAll: "모두 선택되지 않음",
      close: "닫기",
      previous: "이전",
      next: "다음",
      navigation: "네비게이션",
      scrollTop: "스크롤 위로",
      moveTop: "맨위로 이동",
      moveUp: "위로 이동",
      moveDown: "아래로 이동",
      moveBottom: "맨아래로 이동",
      moveToTarget: "타겟으로 이동",
      moveToSource: "소스로 이동",
      moveAllToTarget: "타겟으로 모두 이동",
      moveAllToSource: "소스로 모두 이동",
      pageLabel: "페이지 {page}",
      firstPageLabel: "첫 페이지",
      lastPageLabel: "마지막 페이지",
      nextPageLabel: "다음 페이지",
      prevPageLabel: "이전 페이지",
      rowsPerPageLabel: "페이지별 행 수",
      jumpToPageDropdownLabel: "페이지 드롭다운라벨로 점프",
      jumpToPageInputLabel: "페이지 입력라벨로 점프",
      selectRow: "행 선택됨",
      unselectRow: "행 선택되지 않음",
      expandRow: "행 확장됨",
      collapseRow: "행 접힘",
      showFilterMenu: "필터 메뉴 보이기",
      hideFilterMenu: "필터 메뉴 숨기기",
      filterOperator: "필터 Operator",
      filterConstraint: "필터 Constraint",
      editRow: "행 편집",
      saveEdit: "편집 저장",
      cancelEdit: "편집 취소",
      listView: "리스트 보기",
      gridView: "그리드 보기",
      slide: "슬라이드",
      slideNumber: "{slideNumber}",
      zoomImage: "확대/축소 이미지",
      zoomIn: "확대",
      zoomOut: "축소",
      rotateRight: "오른쪽으로 회전",
      rotateLeft: "왼쪽으로 회전"
    }
  },
  {
    locale: "pt",
    startsWith: "Começa com",
    contains: "Contém",
    notContains: "Não contém",
    endsWith: "Termina com",
    equals: "Igual",
    notEquals: "Diferente",
    noFilter: "Sem filtro",
    filter: "Filtro",
    lt: "Menor que",
    lte: "Menor que ou igual a",
    gt: "Maior que",
    gte: "Maior que ou igual a",
    dateIs: "Data é",
    dateIsNot: "Data não é",
    dateBefore: "Date é anterior",
    dateAfter: "Data é posterior",
    custom: "Customizado",
    clear: "Limpar",
    close: "Fechar",
    apply: "Aplicar",
    matchAll: "Match All",
    matchAny: "Match Any",
    addRule: "Adicionar Regra",
    removeRule: "Remover Regra",
    accept: "Sim",
    reject: "Não",
    choose: "Escolha",
    upload: "Upload",
    cancel: "Cancelar",
    completed: "Concluído",
    pending: "Pendente",
    fileSizeTypes: ["B", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"],
    dayNames: [
      "Domingo",
      "Segunda",
      "Terça",
      "Quarta",
      "Quinta",
      "Sexta",
      "Sábado"
    ],
    dayNamesShort: ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sáb"],
    dayNamesMin: ["Do", "Se", "Te", "Qa", "Qi", "Sx", "Sa"],
    monthNames: [
      "Janeiro",
      "Fevereiro",
      "Março",
      "Abril",
      "Maio",
      "Junho",
      "Julho",
      "Agosto",
      "Setembro",
      "Outubro",
      "Novembro",
      "Dezembro"
    ],
    monthNamesShort: [
      "Jan",
      "Fev",
      "Mar",
      "Abr",
      "Mai",
      "Jun",
      "Jul",
      "Ago",
      "Set",
      "Out",
      "Nov",
      "Dez"
    ],
    chooseYear: "Escolha Ano",
    chooseMonth: "Escolha Mês",
    chooseDate: "Escolha Data",
    prevDecade: "Década Anterior",
    nextDecade: "Década Seguinte",
    prevYear: "Ano Anterior",
    nextYear: "Ano Seguinte",
    prevMonth: "Mês Anterior",
    nextMonth: "Mês Seguinte",
    prevHour: "Hora Anterior",
    nextHour: "Hora Seguinte",
    prevMinute: "Minuto Anterior",
    nextMinute: "Minuto Seguinte",
    prevSecond: "Segundo Anterior",
    nextSecond: "Segundo Seguinte",
    am: "am",
    pm: "pm",
    today: "Hoje",
    weekHeader: "Sem",
    firstDayOfWeek: 0,
    showMonthAfterYear: !1,
    dateFormat: "dd/mm/yy",
    weak: "Fraco",
    medium: "Médio",
    strong: "Forte",
    passwordPrompt: "Digite uma senha",
    emptyFilterMessage: "Nenhum resultado encontrado",
    searchMessage: "{0} resultados disponíveis",
    selectionMessage: "{0} itens selecionados",
    emptySelectionMessage: "Nenhum item selecionado",
    emptySearchMessage: "Nenhum resultado encontrado",
    emptyMessage: "Nenhuma opção disponível",
    aria: {
      trueLabel: "Verdadeiro",
      falseLabel: "Falso",
      nullLabel: "Não selecionado",
      star: "1 estrela",
      stars: "{star} estrelas",
      selectAll: "Todos itens selecionados",
      unselectAll: "Nenhum item selecionado",
      close: "Fechar",
      previous: "Anterior",
      next: "Seguinte",
      navigation: "Navegação",
      scrollTop: "Rolar para Topo",
      moveTop: "Mover para Topo",
      moveUp: "Mover para Cima",
      moveDown: "Mover para Baixo",
      moveBottom: "Mover para Final",
      moveToTarget: "Mover para Alvo",
      moveToSource: "Mover para Fonte",
      moveAllToTarget: "Mover Todos para Alvo",
      moveAllToSource: "Mover Todos para Fonte",
      pageLabel: "Página {page}",
      firstPageLabel: "Primeira Página",
      lastPageLabel: "Última Página",
      nextPageLabel: "Página Seguinte",
      prevPageLabel: "Página Anterior",
      rowsPerPageLabel: "Linhas por página",
      jumpToPageDropdownLabel: "Pular para Menu da Página",
      jumpToPageInputLabel: "Pular para Campo da Página",
      selectRow: "Linha Selecionada",
      unselectRow: "Linha Não Selecionada",
      expandRow: "Linha Expandida",
      collapseRow: "Linha Recolhida",
      showFilterMenu: "Mostrar Menu de Filtro",
      hideFilterMenu: "Esconder Menu de Filtro",
      filterOperator: "Operador de Filtro",
      filterConstraint: "Restrição de Filtro",
      editRow: "Editar Linha",
      saveEdit: "Salvar Editar",
      cancelEdit: "Cancelar Editar",
      listView: "Exibição em Lista",
      gridView: "Exibição em Grade",
      slide: "Deslizar",
      slideNumber: "{slideNumber}",
      zoomImage: "Ampliar Imagem",
      zoomIn: "Mais Zoom",
      zoomOut: "Menos Zoom",
      rotateRight: "Girar à Direita",
      rotateLeft: "Girar à Esquerda"
    }
  },
  {
    locale: "zh-CN",
    startsWith: "以...开始",
    contains: "包含",
    notContains: "不包含",
    endsWith: "以...结尾",
    equals: "等于",
    notEquals: "不等于",
    noFilter: "无筛选",
    filter: "筛选",
    lt: "小于",
    lte: "小于等于",
    gt: "大于",
    gte: "大于等于",
    dateIs: "日期为",
    dateIsNot: "日期不为",
    dateBefore: "日期早于",
    dateAfter: "日期晚于",
    custom: "自定义",
    clear: "清除",
    apply: "应用",
    matchAll: "全部匹配",
    matchAny: "任意匹配",
    addRule: "添加规则",
    removeRule: "移除规则",
    accept: "是",
    reject: "否",
    choose: "选择",
    upload: "上传",
    cancel: "取消",
    completed: "已完成",
    pending: "待处理",
    fileSizeTypes: ["B", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"],
    dayNames: [
      "星期日",
      "星期一",
      "星期二",
      "星期三",
      "星期四",
      "星期五",
      "星期六"
    ],
    dayNamesShort: ["周日", "周一", "周二", "周三", "周四", "周五", "周六"],
    dayNamesMin: ["日", "一", "二", "三", "四", "五", "六"],
    monthNames: [
      "一月",
      "二月",
      "三月",
      "四月",
      "五月",
      "六月",
      "七月",
      "八月",
      "九月",
      "十月",
      "十一月",
      "十二月"
    ],
    monthNamesShort: [
      "1月",
      "2月",
      "3月",
      "4月",
      "5月",
      "6月",
      "7月",
      "8月",
      "9月",
      "10月",
      "11月",
      "12月"
    ],
    chooseYear: "选择年份",
    chooseMonth: "选择月份",
    chooseDate: "选择日期",
    prevDecade: "上一个十年",
    nextDecade: "下一个十年",
    prevYear: "上一年",
    nextYear: "下一年",
    prevMonth: "上个月",
    nextMonth: "下个月",
    prevHour: "上一小时",
    nextHour: "下一小时",
    prevMinute: "上一分钟",
    nextMinute: "下一分钟",
    prevSecond: "上一秒",
    nextSecond: "下一秒",
    am: "上午",
    pm: "下午",
    today: "今天",
    weekHeader: "周",
    firstDayOfWeek: 0,
    showMonthAfterYear: !0,
    dateFormat: "yy年mm月dd日",
    weak: "弱",
    medium: "中",
    strong: "强",
    passwordPrompt: "输入密码",
    emptyFilterMessage: "未找到结果",
    searchMessage: "有 {0} 条结果可用",
    selectionMessage: "已选择 {0} 项",
    emptySelectionMessage: "未选择任何项",
    emptySearchMessage: "未找到结果",
    emptyMessage: "无可用选项",
    aria: {
      trueLabel: "是",
      falseLabel: "否",
      nullLabel: "未选择",
      star: "1颗星",
      stars: "{star}颗星",
      selectAll: "已选择所有项目",
      unselectAll: "已取消选择所有项目",
      close: "关闭",
      previous: "上一个",
      next: "下一个",
      navigation: "导航",
      scrollTop: "滚动到顶部",
      moveTop: "移至顶部",
      moveUp: "上移",
      moveDown: "下移",
      moveBottom: "移至底部",
      moveToTarget: "移至目标",
      moveToSource: "移至源",
      moveAllToTarget: "全部移至目标",
      moveAllToSource: "全部移至源",
      pageLabel: "{page}",
      firstPageLabel: "首页",
      lastPageLabel: "尾页",
      nextPageLabel: "下一页",
      prevPageLabel: "上一页",
      rowsPerPageLabel: "每页行数",
      jumpToPageDropdownLabel: "跳至页面下拉框",
      jumpToPageInputLabel: "跳至页面输入框",
      selectRow: "选择行",
      unselectRow: "取消选择行",
      expandRow: "展开行",
      collapseRow: "折叠行",
      showFilterMenu: "显示筛选菜单",
      hideFilterMenu: "隐藏筛选菜单",
      filterOperator: "筛选运算符",
      filterConstraint: "筛选条件",
      editRow: "编辑行",
      saveEdit: "保存编辑",
      cancelEdit: "取消编辑",
      listView: "列表视图",
      gridView: "网格视图",
      slide: "滑动",
      slideNumber: "{slideNumber}",
      zoomImage: "放大图片",
      zoomIn: "放大",
      zoomOut: "缩小",
      rotateRight: "向右旋转",
      rotateLeft: "向左旋转"
    }
  },
  {
    locale: "zh-TW",
    startsWith: "以...開始",
    contains: "包含",
    notContains: "不包含",
    endsWith: "以...結束",
    equals: "等於",
    notEquals: "不等於",
    noFilter: "不篩選",
    filter: "篩選",
    lt: "小於",
    lte: "小於或等於",
    gt: "大於",
    gte: "大於或等於",
    dateIs: "日期為",
    dateIsNot: "日期不為",
    dateBefore: "日期早於",
    dateAfter: "日期晚於",
    custom: "自訂義",
    clear: "清除",
    apply: "應用",
    matchAll: "全部匹配",
    matchAny: "任意匹配",
    addRule: "增加規則",
    removeRule: "移除規則",
    accept: "是",
    reject: "否",
    choose: "選擇",
    upload: "上傳",
    cancel: "取消",
    completed: "已完成",
    pending: "待定",
    fileSizeTypes: ["B", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"],
    dayNames: [
      "星期日",
      "星期一",
      "星期二",
      "星期三",
      "星期四",
      "星期五",
      "星期六"
    ],
    dayNamesShort: ["周日", "周一", "周二", "周三", "周四", "周五", "周六"],
    dayNamesMin: ["日", "一", "二", "三", "四", "五", "六"],
    monthNames: [
      "一月",
      "二月",
      "三月",
      "四月",
      "五月",
      "六月",
      "七月",
      "八月",
      "九月",
      "十月",
      "十一月",
      "十二月"
    ],
    monthNamesShort: [
      "1 月",
      "2 月",
      "3 月",
      "4 月",
      "5 月",
      "6 月",
      "7 月",
      "8 月",
      "9 月",
      "10 月",
      "11 月",
      "12 月"
    ],
    chooseYear: "選擇年份",
    chooseMonth: "選擇月份",
    chooseDate: "選擇日期",
    prevDecade: "上一個十年",
    nextDecade: "下一個十年",
    prevYear: "上一年",
    nextYear: "下一年",
    prevMonth: "上一個月",
    nextMonth: "下一個月",
    prevHour: "上一個小時",
    nextHour: "下一個小時",
    prevMinute: "上一分鐘",
    nextMinute: "下一分鐘",
    prevSecond: "上一秒",
    nextSecond: "下一秒",
    am: "上午",
    pm: "下午",
    today: "今日",
    weekHeader: "周",
    firstDayOfWeek: 0,
    showMonthAfterYear: !0,
    dateFormat: "yy年mm月dd日",
    weak: "弱",
    medium: "中",
    strong: "強",
    passwordPrompt: "輸入一組密碼",
    emptyFilterMessage: "無相關篩選結果",
    searchMessage: "{0} 個相關結果",
    selectionMessage: "{0} 個項目被選取",
    emptySelectionMessage: "無選取項目",
    emptySearchMessage: "無相關搜尋結果",
    emptyMessage: "無可用選項",
    aria: {
      trueLabel: "是",
      falseLabel: "否",
      nullLabel: "未選擇",
      star: "1 顆星",
      stars: "{star} 顆星",
      selectAll: "已選取所有項目",
      unselectAll: "已取消選取所有項目",
      close: "關閉",
      previous: "上一個",
      next: "下一個",
      navigation: "轉導",
      scrollTop: "滾動至頂端",
      moveTop: "移動至頂端",
      moveUp: "往上移動",
      moveDown: "往下移動",
      moveBottom: "移動至底端",
      moveToTarget: "移動至目標",
      moveToSource: "移動至來源",
      moveAllToTarget: "全部移動至目標",
      moveAllToSource: "全部移動至來源",
      pageLabel: "{page}",
      firstPageLabel: "第一頁",
      lastPageLabel: "最後一頁",
      nextPageLabel: "下一頁",
      prevPageLabel: "上一頁",
      rowsPerPageLabel: "每頁行數",
      jumpToPageDropdownLabel: "跳至頁面下拉選單",
      jumpToPageInputLabel: "跳至頁面輸入欄位",
      selectRow: "選取行",
      unselectRow: "取消選取行",
      expandRow: "展開行",
      collapseRow: "收闔行",
      showFilterMenu: "展示篩選選單",
      hideFilterMenu: "隱藏篩選選單",
      filterOperator: "篩選運算子",
      filterConstraint: "篩選條件",
      editRow: "編輯行",
      saveEdit: "儲存編輯",
      cancelEdit: "取消編輯",
      listView: "列表視圖",
      gridView: "網格視圖",
      slide: "滑動",
      slideNumber: "{slideNumber}",
      zoomImage: "放大圖片",
      zoomIn: "放大",
      zoomOut: "縮小",
      rotateRight: "向右旋轉",
      rotateLeft: "向左旋轉"
    }
  },
  {
    locale: "zh-HK",
    // zh-TW
    startsWith: "以...開始",
    contains: "包含",
    notContains: "不包含",
    endsWith: "以...結束",
    equals: "等於",
    notEquals: "不等於",
    noFilter: "不篩選",
    filter: "篩選",
    lt: "小於",
    lte: "小於或等於",
    gt: "大於",
    gte: "大於或等於",
    dateIs: "日期為",
    dateIsNot: "日期不為",
    dateBefore: "日期早於",
    dateAfter: "日期晚於",
    custom: "自訂義",
    clear: "清除",
    apply: "應用",
    matchAll: "全部匹配",
    matchAny: "任意匹配",
    addRule: "增加規則",
    removeRule: "移除規則",
    accept: "是",
    reject: "否",
    choose: "選擇",
    upload: "上傳",
    cancel: "取消",
    completed: "已完成",
    pending: "待定",
    fileSizeTypes: ["B", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"],
    dayNames: [
      "星期日",
      "星期一",
      "星期二",
      "星期三",
      "星期四",
      "星期五",
      "星期六"
    ],
    dayNamesShort: ["周日", "周一", "周二", "周三", "周四", "周五", "周六"],
    dayNamesMin: ["日", "一", "二", "三", "四", "五", "六"],
    monthNames: [
      "一月",
      "二月",
      "三月",
      "四月",
      "五月",
      "六月",
      "七月",
      "八月",
      "九月",
      "十月",
      "十一月",
      "十二月"
    ],
    monthNamesShort: [
      "1 月",
      "2 月",
      "3 月",
      "4 月",
      "5 月",
      "6 月",
      "7 月",
      "8 月",
      "9 月",
      "10 月",
      "11 月",
      "12 月"
    ],
    chooseYear: "選擇年份",
    chooseMonth: "選擇月份",
    chooseDate: "選擇日期",
    prevDecade: "上一個十年",
    nextDecade: "下一個十年",
    prevYear: "上一年",
    nextYear: "下一年",
    prevMonth: "上一個月",
    nextMonth: "下一個月",
    prevHour: "上一個小時",
    nextHour: "下一個小時",
    prevMinute: "上一分鐘",
    nextMinute: "下一分鐘",
    prevSecond: "上一秒",
    nextSecond: "下一秒",
    am: "上午",
    pm: "下午",
    today: "今日",
    weekHeader: "周",
    firstDayOfWeek: 0,
    showMonthAfterYear: !0,
    dateFormat: "yy年mm月dd日",
    weak: "弱",
    medium: "中",
    strong: "強",
    passwordPrompt: "輸入一組密碼",
    emptyFilterMessage: "無相關篩選結果",
    searchMessage: "{0} 個相關結果",
    selectionMessage: "{0} 個項目被選取",
    emptySelectionMessage: "無選取項目",
    emptySearchMessage: "無相關搜尋結果",
    emptyMessage: "無可用選項",
    aria: {
      trueLabel: "是",
      falseLabel: "否",
      nullLabel: "未選擇",
      star: "1 顆星",
      stars: "{star} 顆星",
      selectAll: "已選取所有項目",
      unselectAll: "已取消選取所有項目",
      close: "關閉",
      previous: "上一個",
      next: "下一個",
      navigation: "轉導",
      scrollTop: "滾動至頂端",
      moveTop: "移動至頂端",
      moveUp: "往上移動",
      moveDown: "往下移動",
      moveBottom: "移動至底端",
      moveToTarget: "移動至目標",
      moveToSource: "移動至來源",
      moveAllToTarget: "全部移動至目標",
      moveAllToSource: "全部移動至來源",
      pageLabel: "{page}",
      firstPageLabel: "第一頁",
      lastPageLabel: "最後一頁",
      nextPageLabel: "下一頁",
      prevPageLabel: "上一頁",
      rowsPerPageLabel: "每頁行數",
      jumpToPageDropdownLabel: "跳至頁面下拉選單",
      jumpToPageInputLabel: "跳至頁面輸入欄位",
      selectRow: "選取行",
      unselectRow: "取消選取行",
      expandRow: "展開行",
      collapseRow: "收闔行",
      showFilterMenu: "展示篩選選單",
      hideFilterMenu: "隱藏篩選選單",
      filterOperator: "篩選運算子",
      filterConstraint: "篩選條件",
      editRow: "編輯行",
      saveEdit: "儲存編輯",
      cancelEdit: "取消編輯",
      listView: "列表視圖",
      gridView: "網格視圖",
      slide: "滑動",
      slideNumber: "{slideNumber}",
      zoomImage: "放大圖片",
      zoomIn: "放大",
      zoomOut: "縮小",
      rotateRight: "向右旋轉",
      rotateLeft: "向左旋轉"
    }
  }
], ZS = {
  en: {
    percent: {
      style: "percent",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
      useGrouping: !1
    },
    currency: {
      style: "currency",
      currency: "USD",
      notation: "standard"
    },
    decimal: {
      style: "decimal",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }
  },
  "en-GB": {
    percent: {
      style: "percent",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
      useGrouping: !1
    },
    currency: {
      style: "currency",
      currency: "USD",
      notation: "standard"
    },
    decimal: {
      style: "decimal",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }
  },
  "en-US": {
    percent: {
      style: "percent",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
      useGrouping: !1
    },
    currency: {
      style: "currency",
      currency: "USD",
      notation: "standard"
    },
    decimal: {
      style: "decimal",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }
  },
  de: {
    percent: {
      style: "percent",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
      useGrouping: !1
    },
    currency: {
      style: "currency",
      currency: "EUR",
      notation: "standard"
    },
    decimal: {
      style: "decimal",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }
  }
}, cG = {
  isinValidationServiceUrl: "https://dacl-afp-epi12.vccfe.dev.smarthouse.local/EntryGate/other-country-validate-isin",
  performancChartGraphDataServiceUrl: "",
  graphQlServiceUrl: "",
  bookmarkServiceUrl: ""
};
var ze = /* @__PURE__ */ ((e) => (e.H1 = "h1", e.H2 = "h2", e.StyledAsH1 = "styled-as-h1", e.StyledAsH2 = "styled-as-h2", e.H2Section = "h2-section", e.StyledAsH2Section = "styled-as-h2-section", e.H2LooksLikeH3 = "h2-looks-like-h3", e.H2LooksLikeH4 = "h2-looks-like-h4", e.H3 = "h3", e.StyledAsH3 = "styled-as-h3", e.H3LooksLikeH2 = "h3-looks-like-h2", e.StyledAsH3LooksLikeH2 = "styled-as-h3-looks-like-h2", e.H3LooksLikeH2Section = "h3-looks-like-h2-section", e.StyledAsH3LooksLikeH2Section = "styled-as-h3-looks-like-h2-section", e.H4 = "h4", e.StyledAsH4 = "styled-as-h4", e.H4LooksLikeH3 = "h4-looks-like-h3", e.H5 = "h5", e))(ze || {});
const dG = /* @__PURE__ */ Be({
  __name: "BaseHeading",
  props: {
    baseHeadingType: {
      type: String,
      required: !1,
      default: ze.H3
    }
  },
  setup(e) {
    const t = e, n = Jt(), i = Te(() => n.default && n.default()), { convertVNodeToHTML: o, hasOnlyTextChildren: a } = yP(), r = Te(() => {
      switch (t.baseHeadingType) {
        case ze.H1:
          return "h1";
        case ze.H2:
          return "h2";
        case ze.H2Section:
          return "h2";
        case ze.H2LooksLikeH3:
          return "h2";
        case ze.H2LooksLikeH4:
          return "h2";
        case ze.H3:
          return "h3";
        case ze.H3LooksLikeH2:
          return "h3";
        case ze.H3LooksLikeH2Section:
          return "h3";
        case ze.H4:
          return "h4";
        case ze.H4LooksLikeH3:
          return "h4";
        case ze.StyledAsH1:
          return "div";
        case ze.StyledAsH2:
          return "div";
        case ze.StyledAsH2Section:
          return "div";
        case ze.StyledAsH3:
          return "div";
        case ze.StyledAsH3LooksLikeH2:
          return "div";
        case ze.StyledAsH3LooksLikeH2Section:
          return "div";
        case ze.StyledAsH4:
          return "div";
        case ze.H5:
          return "h5";
        default:
          return "h3";
      }
    }), s = Te(() => {
      switch (t.baseHeadingType) {
        case ze.H1:
          return "d-base-heading--h1";
        case ze.H2:
          return "d-base-heading--h2";
        case ze.H2Section:
          return "d-base-heading--h2-section";
        case ze.H2LooksLikeH3:
          return "d-base-heading--h3";
        case ze.H2LooksLikeH4:
          return "d-base-heading--h4";
        case ze.H3:
          return "d-base-heading--h3";
        case ze.H3LooksLikeH2:
          return "d-base-heading--h2";
        case ze.H3LooksLikeH2Section:
          return "d-base-heading--h2-section";
        case ze.H4:
          return "d-base-heading--h4";
        case ze.H4LooksLikeH3:
          return "d-base-heading--h3";
        case ze.StyledAsH1:
          return "d-base-heading--h1";
        case ze.StyledAsH2:
          return "d-base-heading--h2";
        case ze.StyledAsH2Section:
          return "d-base-heading--h2-section";
        case ze.StyledAsH3:
          return "d-base-heading--h3";
        case ze.StyledAsH3LooksLikeH2:
          return "d-base-heading d-base-heading--h2";
        case ze.StyledAsH3LooksLikeH2Section:
          return "d-base-heading d-base-heading--h2-section";
        case ze.StyledAsH4:
          return "d-base-heading--h4";
        case ze.H5:
          return "d-base-heading--h5";
        default:
          return "";
      }
    }), l = Te(() => {
      switch (t.baseHeadingType) {
        case ze.StyledAsH1:
          return "heading";
        case ze.StyledAsH2:
          return "heading";
        case ze.StyledAsH2Section:
          return "heading";
        case ze.StyledAsH3:
          return "heading";
        case ze.StyledAsH3LooksLikeH2:
          return "heading";
        case ze.StyledAsH3LooksLikeH2Section:
          return "heading";
        case ze.StyledAsH4:
          return "heading";
        default:
          return;
      }
    }), d = Te(() => {
      switch (t.baseHeadingType) {
        case ze.StyledAsH1:
          return "1";
        case ze.StyledAsH2:
          return "2";
        case ze.StyledAsH2Section:
          return "2";
        case ze.StyledAsH3:
          return "3";
        case ze.StyledAsH3LooksLikeH2:
          return "2";
        case ze.StyledAsH3LooksLikeH2Section:
          return "2";
        case ze.StyledAsH4:
          return "4";
        default:
          return null;
      }
    });
    return (y, u) => (E(), fe(tt(r.value), {
      class: Pe(s.value),
      role: l.value,
      "aria-level": d.value
    }, {
      default: Se(() => [
        (E(!0), X(Re, null, Ge(i.value, (m) => (E(), X(Re, { key: m }, [
          _(a)(m) ? (E(), fe(_(ht), {
            key: 0,
            "html-text": _(o)(m),
            "disable-default-styling": ""
          }, null, 8, ["html-text"])) : (E(), fe(tt(m), { key: 1 }))
        ], 64))), 128))
      ]),
      _: 1
    }, 8, ["class", "role", "aria-level"]));
  }
});
const Ot = /* @__PURE__ */ Fe(dG, [["__scopeId", "data-v-7d444f3a"]]), uG = {}, hG = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: uG
}, Symbol.toStringTag, { value: "Module" })), pG = /* @__PURE__ */ OI(hG);
var Vb = typeof rn < "u" ? rn : typeof window < "u" ? window : {}, fG = pG, vl;
typeof document < "u" ? vl = document : (vl = Vb["__GLOBAL_DOCUMENT_CACHE@4"], vl || (vl = Vb["__GLOBAL_DOCUMENT_CACHE@4"] = fG));
var mG = vl;
const lo = /* @__PURE__ */ en(mG);
var yl;
typeof window < "u" ? yl = window : typeof rn < "u" ? yl = rn : typeof self < "u" ? yl = self : yl = {};
var gG = yl;
const _a = /* @__PURE__ */ en(gG);
/*! @name @brightcove/player-loader @version 1.8.0 @license Apache-2.0 */
function Lu() {
  return Lu = Object.assign || function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var i in n)
        Object.prototype.hasOwnProperty.call(n, i) && (e[i] = n[i]);
    }
    return e;
  }, Lu.apply(this, arguments);
}
var vG = "1.8.0";
/*! @name @brightcove/player-url @version 1.2.0 @license Apache-2.0 */
var yG = "1.2.0", bG = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
  return typeof e;
} : function(e) {
  return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
}, xG = ["catalogSearch", "catalogSequence"], wG = ["adConfigId", "applicationId", "catalogSearch", "catalogSequence", "playlistId", "playlistVideoId", "videoId"], kG = function(t, n) {
  if (!(!t || t[n] === void 0)) {
    if (typeof t[n] != "string" && xG.indexOf(n) !== -1)
      try {
        return encodeURIComponent(JSON.stringify(t[n]));
      } catch {
        return;
      }
    return encodeURIComponent(String(t[n]).trim()) || void 0;
  }
}, SG = function(t) {
  return Object.keys(t).filter(function(n) {
    return wG.indexOf(n) !== -1;
  }).reduce(function(n, i) {
    var o = kG(t, i);
    return o !== void 0 && (n += n ? "&" : "?", n += encodeURIComponent(i) + "=" + o), n;
  }, "");
}, JS = function(t) {
  var n = t.accountId, i = t.base, o = i === void 0 ? "https://players.brightcove.net" : i, a = t.playerId, r = a === void 0 ? "default" : a, s = t.embedId, l = s === void 0 ? "default" : s, d = t.iframe, y = d === void 0 ? !1 : d, u = t.minified, m = u === void 0 ? !0 : u, h = t.queryParams, c = h === void 0 ? null : h, g = "";
  y ? g += "html" : (m && (g += "min."), g += "js"), o.charAt(o.length - 1) === "/" && (o = o.substring(0, o.length - 1));
  var v = "";
  return y && c && (typeof c > "u" ? "undefined" : bG(c)) === "object" && (v = SG(c)), n = encodeURIComponent(n), r = encodeURIComponent(r), l = encodeURIComponent(l), o + "/" + n + "/" + r + "_" + l + "/index." + g + v;
};
JS.VERSION = yG;
var CG = {
  embedId: "default",
  embedType: "in-page",
  playerId: "default",
  Promise: _a.Promise,
  refNodeInsert: "append"
}, TG = "16:9", LG = !1, IG = "100%", QS = "video", uh = "video-js", pg = "in-page", Ro = "iframe", eC = "append", fg = "prepend", mg = "before", gg = "after", hh = "replace", PG = ["catalogSearch", "catalogSequence"], vg = "https://players.brightcove.net/", AG = function(t) {
  if (t.playerUrl)
    return t.playerUrl;
  var n = t.accountId, i = t.playerId, o = t.embedId, a = t.embedOptions, r = t.embedType === Ro;
  return JS({
    accountId: n,
    playerId: i,
    embedId: o,
    iframe: r,
    base: vg,
    // The unminified embed option is the exact reverse of the minified option
    // here.
    minified: a ? !a.unminified : !0,
    // Pass the entire params object as query params. This is safe because
    // @brightcove/player-url only accepts a whitelist of parameters. Anything
    // else will be ignored.
    queryParams: t
  });
}, _G = function() {
  return vg;
}, MG = function(t) {
  vg = t;
}, Bs = {
  getUrl: AG,
  getBaseUrl: _G,
  setBaseUrl: MG
}, tC = function(t) {
  return !!(t && t.nodeType === 1);
}, nC = function(t) {
  return !!(tC(t) && t.parentNode);
}, OG = function(t) {
  var n = lo.createElement("iframe");
  return n.setAttribute("allow", "autoplay;encrypted-media;fullscreen"), n.setAttribute("allowfullscreen", "allowfullscreen"), n.src = Bs.getUrl(t), n;
}, BG = function(t) {
  var n = t.embedOptions, i = {
    adConfigId: "data-ad-config-id",
    applicationId: "data-application-id",
    catalogSearch: "data-catalog-search",
    catalogSequence: "data-catalog-sequence",
    deliveryConfigId: "data-delivery-config-id",
    playlistId: "data-playlist-id",
    playlistVideoId: "data-playlist-video-id",
    poster: "poster",
    videoId: "data-video-id"
  }, o = n && n.tagName || uh, a = lo.createElement(o);
  return Object.keys(i).filter(function(r) {
    return t[r];
  }).forEach(function(r) {
    var s;
    if (typeof t[r] != "string" && PG.indexOf(r) !== -1)
      try {
        s = JSON.stringify(t[r]);
      } catch {
        return;
      }
    else
      s = String(t[r]).trim();
    a.setAttribute(i[r], s);
  }), a.setAttribute("controls", "controls"), a.classList.add("video-js"), a;
}, EG = function(t, n, i) {
  if (!n.responsive)
    return i;
  i.style.position = "absolute", i.style.top = "0px", i.style.right = "0px", i.style.bottom = "0px", i.style.left = "0px", i.style.width = "100%", i.style.height = "100%";
  var o = Lu({
    aspectRatio: TG,
    iframeHorizontalPlaylist: LG,
    maxWidth: IG
  }, n.responsive), a = o.aspectRatio.split(":").map(Number), r = lo.createElement("div"), s = a[1] / a[0] * 100;
  t === Ro && o.iframeHorizontalPlaylist && (s *= 1.25), r.style.paddingTop = s + "%", r.appendChild(i);
  var l = lo.createElement("div");
  return l.style.position = "relative", l.style.display = "block", l.style.maxWidth = o.maxWidth, l.appendChild(r), l;
}, DG = function(t, n) {
  if (!t.pip)
    return n;
  var i = lo.createElement("div");
  return i.classList.add("vjs-pip-container"), i.appendChild(n), i;
}, RG = function(t, n, i) {
  return n ? DG(n, EG(t, n, i)) : i;
}, NG = function(t, n) {
  var i = t.refNode, o = t.refNodeInsert, a = i.parentNode, r = RG(t.embedType, t.embedOptions, n);
  if (o === mg ? a.insertBefore(r, i) : o === gg ? a.insertBefore(r, i.nextElementSibling || null) : o === hh ? a.replaceChild(r, i) : o === fg ? i.insertBefore(r, i.firstChild || null) : i.appendChild(r), t.embedOptions && t.embedOptions.playlist) {
    var s = t.embedOptions.playlist.legacy ? "ul" : "div", l = lo.createElement(s);
    l.classList.add("vjs-playlist"), n.parentNode.insertBefore(l, n.nextElementSibling || null);
  }
  return t.refNode = null, n;
}, $G = function(t, n) {
  if (typeof t.onEmbedCreated != "function")
    return n;
  var i = t.onEmbedCreated(n);
  return tC(i) ? i : n;
}, FG = function(t) {
  var n = t.embedType === Ro ? OG(t) : BG(t);
  return NG(t, $G(t, n));
}, Jc = new _a.Map(), ph = function(t) {
  var n = t.accountId, i = t.playerId, o = t.embedId;
  return (n || "*") + "_" + i + "_" + o;
}, jG = function(t) {
  Jc.set(ph(t), t.accountId ? Bs.getUrl(t) : "");
}, HG = function(t) {
  return Jc.has(ph(t));
}, zG = function(t) {
  return Jc.get(ph(t));
}, VG = function() {
  Jc.clear();
}, GG = function(t) {
  Jc.forEach(t);
}, ys = {
  clear: VG,
  forEach: GG,
  get: zG,
  has: HG,
  key: ph,
  store: jG
}, iC = /^([A-Za-z0-9]+)_([A-Za-z0-9]+)$/, aC = function() {
  return _a.bc ? Object.keys(_a.bc).filter(function(t) {
    return iC.test(t);
  }) : [];
}, UG = function() {
  return Object.keys(_a).filter(function(t) {
    return /^videojs/i.test(t) || /^(bc)$/.test(t);
  });
}, Gb = function(t) {
  t && Object.keys(t.players).forEach(function(n) {
    var i = t.players[n];
    i && i.dispose();
  });
}, WG = function() {
  ys.forEach(function(t, n) {
    t && Array.prototype.slice.call(lo.querySelectorAll('script[src="' + t + '"]')).forEach(function(i) {
      return i.parentNode.removeChild(i);
    });
  }), ys.clear(), Gb(_a.videojs), aC().forEach(function(t) {
    return Gb(_a.bc[t].videojs);
  }), UG().forEach(function(t) {
    delete _a[t];
  });
}, YG = function() {
  aC().forEach(function(t) {
    var n = t.match(iC), i = {
      playerId: n[1],
      embedId: n[2]
    };
    ys.has(i) || ys.store(i);
  });
}, oC = {
  detectPlayers: YG,
  reset: WG
};
oC.detectPlayers();
var ll = function(t) {
  return typeof t == "function";
}, qG = function(t) {
  return t === pg || t === Ro;
}, KG = function(t) {
  return t === uh || t === QS;
}, XG = function(t) {
  return t === eC || t === fg || t === mg || t === gg || t === hh;
}, ZG = function(t) {
  var n = t.accountId, i = t.embedOptions, o = t.embedType, a = t.options, r = t.refNode, s = t.refNodeInsert;
  if (n)
    if (nC(r))
      if (qG(o)) {
        if (o === Ro && a)
          throw new Error("cannot use options with an iframe embed");
        if (i && i.tagName !== void 0 && !KG(i.tagName))
          throw new Error('embedOptions.tagName is invalid (value: "' + i.tagName + '")');
        if (i && i.responsive && i.responsive.aspectRatio && !/^\d+\:\d+$/.test(i.responsive.aspectRatio))
          throw new Error('embedOptions.responsive.aspectRatio must be in the "n:n" format (value: "' + i.responsive.aspectRatio + '")');
        if (!XG(s))
          throw new Error("refNodeInsert is missing or invalid");
      } else
        throw new Error("embedType is missing or invalid");
    else
      throw new Error("refNode must resolve to a node attached to the DOM");
  else
    throw new Error("accountId is required");
}, JG = function(t) {
  return nC(t) ? t : typeof t == "string" ? lo.querySelector(t) : null;
}, Ub = function(t, n, i, o) {
  var a = t.embedId, r = t.playerId, s = _a.bc[r + "_" + a] || _a.bc;
  if (!s)
    return o(new Error("missing bc function for " + r));
  ys.store(t);
  var l;
  try {
    l = s(n, t.options), l.bcinfo && (l.bcinfo.PLAYER_LOADER = !0);
  } catch {
    var d = "Could not initialize the Brightcove Player.";
    return t.embedOptions.tagName === uh && (d += ' You are attempting to embed using a "video-js" element. Please ensure that your Player is v6.11.0 or newer in order to support this embed type. Alternatively, pass `"video"` for `embedOptions.tagName`.'), o(new Error(d));
  }
  i({
    type: pg,
    ref: l
  });
}, Wb = function(t, n, i) {
  t.refNode = JG(t.refNode), ZG(t);
  var o = t.refNode, a = t.refNodeInsert, r = o.parentNode, s = FG(t);
  if (t.embedType === Ro) {
    n({
      type: Ro,
      ref: s
    });
    return;
  }
  if (ys.has(t))
    return Ub(t, s, n, i);
  var l = lo.createElement("script");
  l.onload = function() {
    return Ub(t, s, n, i);
  }, l.onerror = function() {
    i(new Error("player script could not be downloaded"));
  }, l.async = !0, l.charset = "utf-8", l.src = Bs.getUrl(t), a === hh ? r.appendChild(l) : o.appendChild(l);
}, rC = function(t) {
  var n = Lu({}, CG, t), i = n.Promise, o = n.onSuccess, a = n.onFailure;
  return !ll(i) || ll(o) || ll(a) ? Wb(n, ll(o) ? o : function() {
  }, ll(a) ? a : function(r) {
    throw r;
  }) : new i(function(r, s) {
    return Wb(n, r, s);
  });
}, Qc = function(t, n) {
  Object.defineProperty(rC, t, {
    configurable: !1,
    enumerable: !0,
    value: n,
    writable: !1
  });
};
Qc("getBaseUrl", function() {
  return Bs.getBaseUrl();
});
Qc("setBaseUrl", function(e) {
  Bs.setBaseUrl(e);
});
Qc("getUrl", function(e) {
  return Bs.getUrl(e);
});
Qc("reset", function() {
  return oC.reset();
});
[["EMBED_TAG_NAME_VIDEO", QS], ["EMBED_TAG_NAME_VIDEOJS", uh], ["EMBED_TYPE_IN_PAGE", pg], ["EMBED_TYPE_IFRAME", Ro], ["REF_NODE_INSERT_APPEND", eC], ["REF_NODE_INSERT_PREPEND", fg], ["REF_NODE_INSERT_BEFORE", mg], ["REF_NODE_INSERT_AFTER", gg], ["REF_NODE_INSERT_REPLACE", hh], ["VERSION", vG]].forEach(function(e) {
  Qc(e[0], e[1]);
});
var Lr = /* @__PURE__ */ ((e) => (e.AudioOnly = "i3NG182nu", e.AudioWithImage = "DrOiBocG3", e.v7 = "CYUxCNOXYn", e.v6 = "n0bfAyGR5V", e))(Lr || {}), Ir = /* @__PURE__ */ ((e) => (e.AudioOnly = "audio-only", e.AudioWithImage = "audio-with-image", e.v7 = "v-7", e.v6 = "v-6", e))(Ir || {}), sa = /* @__PURE__ */ ((e) => (e.Durationchange = "durationchange", e.Ended = "ended", e.Error = "error", e.Firstplay = "firstplay", e.Fullscreenchange = "fullscreenchange", e.Loadedalldata = "loadedalldata", e.Loadeddata = "loadeddata", e.Loadedmetadata = "loadedmetadata", e.Loadstart = "loadstart", e.Pause = "pause", e.Play = "play", e.Progress = "progress", e.Timeupdate = "timeupdate", e.Volumechange = "volumechange", e.Resize = "resize", e))(sa || {});
const QG = {
  class: "vjs-pip-container",
  "data-vjs-player": "true"
}, eU = {
  key: 0,
  class: "brightcove-video-error"
}, tU = /* @__PURE__ */ Be({
  __name: "BaseVideoPlayer",
  props: {
    baseVideoPlayerProps: {
      type: Object,
      required: !0
    }
  },
  emits: ["video-play", "loaded", "ended", "paused"],
  setup(e, { expose: t, emit: n }) {
    const i = e, o = n, a = ge(null), r = ge(null), s = ge(null), l = Te(() => i.baseVideoPlayerProps?.playerType ? i.baseVideoPlayerProps.playerType === Ir.AudioOnly : i.baseVideoPlayerProps?.playerId === Lr.AudioOnly), d = Te(() => i.baseVideoPlayerProps?.playerType ? i.baseVideoPlayerProps.playerType === Ir.AudioWithImage : i.baseVideoPlayerProps?.playerId === Lr.AudioWithImage);
    qe(
      () => i.baseVideoPlayerProps.videoId,
      () => {
        y();
      },
      { deep: !0 }
    ), it(() => {
      const m = i?.baseVideoPlayerProps?.componentName || "media player";
      rC({
        refNode: r.value,
        refNodeInsert: "append",
        accountId: i.baseVideoPlayerProps.accountId,
        videoId: i.baseVideoPlayerProps.videoId,
        playerId: i.baseVideoPlayerProps.playerId,
        options: {
          playsinline: !0,
          autoplay: i.baseVideoPlayerProps.isAutoPlay,
          muted: i.baseVideoPlayerProps.isMute
        }
      }).then((h) => {
        a.value = h.ref, a.value.on(sa.Play, () => {
          o("video-play"), On(m, sa.Play);
        }), a.value.on(sa.Pause, () => {
          o("paused"), On(m, sa.Pause);
        }), a.value.on(sa.Volumechange, () => {
          On(m, sa.Volumechange);
        }), a.value.on(sa.Fullscreenchange, () => {
          On(
            m,
            sa.Fullscreenchange
          );
        }), a.value.on(sa.Ended, () => {
          o("ended"), On(m, sa.Ended);
        }), l.value && a.value.audioOnlyMode(!0), d.value && a.value.audioPosterMode(!0);
        const c = `#${a.value.id_}_html5_api`, g = Oe.findSingle(
          r.value,
          c
        );
        g.setAttribute("aria-hidden", "true"), g.setAttribute(
          "aria-label",
          i.baseVideoPlayerProps.videoTopic || "Video Player"
        ), o("loaded");
      }).catch((h) => {
        s.value = h;
      });
    });
    function y() {
      a?.value && a?.value?.catalog.getVideo(
        i.baseVideoPlayerProps.videoId,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (m, h) => {
          m && (s.value = m), a?.value?.catalog.load(h), u();
        }
      );
    }
    const u = () => {
      a?.value?.play(), o("video-play");
    };
    return t({
      play: u
    }), (m, h) => (E(), X("div", {
      class: Pe(["d-base-video-player", {
        "d-base-video-player--video": !l.value && !d.value
      }]),
      "data-chromatic": "ignore"
    }, [
      oe("div", QG, [
        oe("div", {
          ref_key: "videoRef",
          ref: r,
          class: "brightcove-video-holder"
        }, null, 512),
        s.value ? (E(), X("div", eU, Ie(s.value), 1)) : te("", !0)
      ])
    ], 2));
  }
});
const yg = /* @__PURE__ */ Fe(tU, [["__scopeId", "data-v-595f49ba"]]), nU = ["href", "target", "rel", "data-event_linktype", "data-event_source", "data-event_target", "data-event_title", "data-event_engagement", "data-event_component_name", "data-event_component_headline"], iU = {
  key: 0,
  class: "d-base-link__container"
}, aU = {
  key: 2,
  class: "d-base-link--text"
}, oU = /* @__PURE__ */ Be({
  __name: "BaseLink",
  props: {
    linkModel: {
      type: Object,
      required: !0
    },
    fontSize: {
      type: String,
      default: zi.SixteenPx
    },
    iconSize: {
      type: String,
      default: gw.TwentyFour
    },
    fontType: {
      type: String,
      default: Kd.DwsBold
    },
    hasText: {
      type: Boolean,
      default: !0
    },
    isCopyLink: {
      type: Boolean,
      default: !1
    }
  },
  setup(e, { expose: t }) {
    const n = e, i = ge(), o = ge();
    t({
      linkRef: i,
      iconRef: o
    });
    const a = Jt(), r = (m) => !!a[m], s = Te(() => r("leftIcon") || r("rightIcon") ? "d-base-link--icon" : n.hasText ? "d-base-link--hover" : "d-base-link--no-hover"), l = Te(() => `d-base-link--icon-size-${n.iconSize}`), d = Te(() => {
      switch (n.fontSize) {
        case zi.TwelvePx:
          return "d-base-link--font-size-12";
        case zi.FourteenPx:
          return "d-base-link--font-size-14";
        case zi.SixteenPx:
          return "d-base-link--font-size-16";
        case zi.TwentyPx:
          return "d-base-link--font-size-20";
        case zi.TwentyTwoPx:
          return "d-base-link--font-size-22";
        case zi.TwentyFourPx:
          return "d-base-link--font-size-24";
        default:
          return "";
      }
    }), y = Te(() => {
      switch (n.fontType) {
        case Kd.DwsRegular:
          return "d-base-link--font-type-regular";
        case Kd.DwsBold:
          return "d-base-link--font-type-bold";
        default:
          return "";
      }
    }), u = Te(
      () => n.isCopyLink ? "d-base-link--is-copy-link" : ""
    );
    return (m, h) => (E(), X("a", {
      ref_key: "linkRef",
      ref: i,
      href: e.linkModel?.href,
      target: e.linkModel?.target,
      rel: e.linkModel?.target ? "noopener noreferrer" : "",
      tabindex: "0",
      class: Pe(["d-base-link", [d.value, y.value, s.value, u.value]]),
      "data-event_linktype": e.linkModel?.tealiumTrackingModel?.eventLinkType,
      "data-event_source": e.linkModel?.tealiumTrackingModel?.eventSource,
      "data-event_target": e.linkModel?.tealiumTrackingModel?.eventTarget,
      "data-event_title": e.linkModel?.tealiumTrackingModel?.eventTitle,
      "data-event_engagement": e.linkModel?.tealiumTrackingModel?.eventEngagement,
      "data-event_component_name": e.linkModel?.tealiumTrackingModel?.eventComponentName,
      "data-event_component_headline": e.linkModel?.tealiumTrackingModel?.eventComponentHeadline
    }, [
      r("container") ? (E(), X("div", iU, [
        je(m.$slots, "container", {}, void 0, !0)
      ])) : te("", !0),
      r("leftIcon") ? (E(), X("div", {
        key: 1,
        ref_key: "iconRef",
        ref: o,
        class: Pe([
          e.hasText ? "d-base-link--left-icon" : "d-base-link--no-margin",
          l.value
        ])
      }, [
        je(m.$slots, "leftIcon", {}, void 0, !0)
      ], 2)) : te("", !0),
      e.hasText ? (E(), X("span", aU, Ie(e.linkModel?.text), 1)) : te("", !0),
      r("rightIcon") ? (E(), X("div", {
        key: 3,
        ref_key: "iconRef",
        ref: o,
        class: Pe([
          e.hasText ? "d-base-link--right-icon" : "d-base-link--no-margin",
          l.value
        ])
      }, [
        je(m.$slots, "rightIcon", {}, void 0, !0)
      ], 2)) : te("", !0)
    ], 10, nU));
  }
});
const rU = /* @__PURE__ */ Fe(oU, [["__scopeId", "data-v-76482a57"]]);
var fh = {
  name: "SearchIcon",
  extends: Yt,
  computed: {
    pathId: function() {
      return "pv_icon_clip_".concat(Mt());
    }
  }
}, sU = ["clip-path"], lU = /* @__PURE__ */ oe("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M2.67602 11.0265C3.6661 11.688 4.83011 12.0411 6.02086 12.0411C6.81149 12.0411 7.59438 11.8854 8.32483 11.5828C8.87005 11.357 9.37808 11.0526 9.83317 10.6803L12.9769 13.8241C13.0323 13.8801 13.0983 13.9245 13.171 13.9548C13.2438 13.985 13.3219 14.0003 13.4007 14C13.4795 14.0003 13.5575 13.985 13.6303 13.9548C13.7031 13.9245 13.7691 13.8801 13.8244 13.8241C13.9367 13.7116 13.9998 13.5592 13.9998 13.4003C13.9998 13.2414 13.9367 13.089 13.8244 12.9765L10.6807 9.8328C11.053 9.37773 11.3573 8.86972 11.5831 8.32452C11.8857 7.59408 12.0414 6.81119 12.0414 6.02056C12.0414 4.8298 11.6883 3.66579 11.0268 2.67572C10.3652 1.68564 9.42494 0.913972 8.32483 0.45829C7.22472 0.00260857 6.01418 -0.116618 4.84631 0.115686C3.67844 0.34799 2.60568 0.921393 1.76369 1.76338C0.921698 2.60537 0.348296 3.67813 0.115991 4.84601C-0.116313 6.01388 0.00291375 7.22441 0.458595 8.32452C0.914277 9.42464 1.68595 10.3649 2.67602 11.0265ZM3.35565 2.0158C4.14456 1.48867 5.07206 1.20731 6.02086 1.20731C7.29317 1.20731 8.51338 1.71274 9.41304 2.6124C10.3127 3.51206 10.8181 4.73226 10.8181 6.00457C10.8181 6.95337 10.5368 7.88088 10.0096 8.66978C9.48251 9.45868 8.73328 10.0736 7.85669 10.4367C6.98011 10.7997 6.01554 10.8947 5.08496 10.7096C4.15439 10.5245 3.2996 10.0676 2.62869 9.39674C1.95778 8.72583 1.50089 7.87104 1.31579 6.94046C1.13068 6.00989 1.22568 5.04532 1.58878 4.16874C1.95187 3.29215 2.56675 2.54292 3.35565 2.0158Z",
  fill: "currentColor"
}, null, -1), cU = [lU], dU = ["id"], uU = /* @__PURE__ */ oe("rect", {
  width: "14",
  height: "14",
  fill: "white"
}, null, -1), hU = [uU];
function pU(e, t, n, i, o, a) {
  return E(), X("svg", Ce({
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.pti()), [oe("g", {
    "clip-path": "url(#".concat(a.pathId, ")")
  }, cU, 8, sU), oe("defs", null, [oe("clipPath", {
    id: "".concat(a.pathId)
  }, hU, 8, dU)])], 16);
}
fh.render = pU;
var fU = `
@layer primevue {
    .p-listbox-list-wrapper {
        overflow: auto;
    }

    .p-listbox-list {
        list-style-type: none;
        margin: 0;
        padding: 0;
    }

    .p-listbox-item {
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }

    .p-listbox-item-group {
        cursor: auto;
    }

    .p-listbox-filter-container {
        position: relative;
    }

    .p-listbox-filter-icon {
        position: absolute;
        top: 50%;
        margin-top: -0.5rem;
    }

    .p-listbox-filter {
        width: 100%;
    }
}
`, mU = {
  root: function(t) {
    var n = t.instance, i = t.props;
    return ["p-listbox p-component", {
      "p-focus": n.focused,
      "p-disabled": i.disabled
    }];
  },
  header: "p-listbox-header",
  filterContainer: "p-listbox-filter-container",
  filterInput: "p-listbox-filter p-inputtext p-component",
  filterIcon: "p-listbox-filter-icon",
  wrapper: "p-listbox-list-wrapper",
  list: "p-listbox-list",
  itemGroup: "p-listbox-item-group",
  item: function(t) {
    var n = t.instance, i = t.option, o = t.index, a = t.getItemOptions;
    return ["p-listbox-item", {
      "p-highlight": n.isSelected(i),
      "p-focus": n.focusedOptionIndex === n.getOptionIndex(o, a),
      "p-disabled": n.isOptionDisabled(i)
    }];
  },
  emptyMessage: "p-listbox-empty-message"
}, gU = Wt.extend({
  name: "listbox",
  css: fU,
  classes: mU
}), vU = {
  name: "BaseListbox",
  extends: wt,
  props: {
    modelValue: null,
    options: Array,
    optionLabel: null,
    optionValue: null,
    optionDisabled: null,
    optionGroupLabel: null,
    optionGroupChildren: null,
    listStyle: null,
    disabled: {
      type: Boolean,
      default: !1
    },
    dataKey: null,
    multiple: {
      type: Boolean,
      default: !1
    },
    metaKeySelection: {
      type: Boolean,
      default: !1
    },
    filter: Boolean,
    filterPlaceholder: String,
    filterLocale: String,
    filterMatchMode: {
      type: String,
      default: "contains"
    },
    filterFields: {
      type: Array,
      default: null
    },
    filterInputProps: null,
    virtualScrollerOptions: {
      type: Object,
      default: null
    },
    autoOptionFocus: {
      type: Boolean,
      default: !0
    },
    selectOnFocus: {
      type: Boolean,
      default: !1
    },
    filterMessage: {
      type: String,
      default: null
    },
    selectionMessage: {
      type: String,
      default: null
    },
    emptySelectionMessage: {
      type: String,
      default: null
    },
    emptyFilterMessage: {
      type: String,
      default: null
    },
    emptyMessage: {
      type: String,
      default: null
    },
    filterIcon: {
      type: String,
      default: void 0
    },
    tabindex: {
      type: Number,
      default: 0
    },
    ariaLabel: {
      type: String,
      default: null
    },
    ariaLabelledby: {
      type: String,
      default: null
    }
  },
  style: gU,
  provide: function() {
    return {
      $parentInstance: this
    };
  }
};
function Yb(e) {
  return wU(e) || xU(e) || bU(e) || yU();
}
function yU() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function bU(e, t) {
  if (e) {
    if (typeof e == "string")
      return Pf(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set")
      return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return Pf(e, t);
  }
}
function xU(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null)
    return Array.from(e);
}
function wU(e) {
  if (Array.isArray(e))
    return Pf(e);
}
function Pf(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, i = new Array(t); n < t; n++)
    i[n] = e[n];
  return i;
}
var sC = {
  name: "Listbox",
  extends: vU,
  emits: ["update:modelValue", "change", "focus", "blur", "filter"],
  list: null,
  virtualScroller: null,
  optionTouched: !1,
  startRangeIndex: -1,
  searchTimeout: null,
  searchValue: "",
  focusOnHover: !1,
  data: function() {
    return {
      id: this.$attrs.id,
      filterValue: null,
      focused: !1,
      focusedOptionIndex: -1
    };
  },
  watch: {
    "$attrs.id": function(t) {
      this.id = t || Mt();
    },
    options: function() {
      this.autoUpdateModel();
    }
  },
  mounted: function() {
    this.id = this.id || Mt(), this.autoUpdateModel();
  },
  methods: {
    getOptionIndex: function(t, n) {
      return this.virtualScrollerDisabled ? t : n && n(t).index;
    },
    getOptionLabel: function(t) {
      return this.optionLabel ? We.resolveFieldData(t, this.optionLabel) : t;
    },
    getOptionValue: function(t) {
      return this.optionValue ? We.resolveFieldData(t, this.optionValue) : t;
    },
    getOptionRenderKey: function(t, n) {
      return (this.dataKey ? We.resolveFieldData(t, this.dataKey) : this.getOptionLabel(t)) + "_" + n;
    },
    getPTOptions: function(t, n, i, o) {
      return this.ptm(o, {
        context: {
          selected: this.isSelected(t),
          focused: this.focusedOptionIndex === this.getOptionIndex(i, n),
          disabled: this.isOptionDisabled(t)
        }
      });
    },
    isOptionDisabled: function(t) {
      return this.optionDisabled ? We.resolveFieldData(t, this.optionDisabled) : !1;
    },
    isOptionGroup: function(t) {
      return this.optionGroupLabel && t.optionGroup && t.group;
    },
    getOptionGroupLabel: function(t) {
      return We.resolveFieldData(t, this.optionGroupLabel);
    },
    getOptionGroupChildren: function(t) {
      return We.resolveFieldData(t, this.optionGroupChildren);
    },
    getAriaPosInset: function(t) {
      var n = this;
      return (this.optionGroupLabel ? t - this.visibleOptions.slice(0, t).filter(function(i) {
        return n.isOptionGroup(i);
      }).length : t) + 1;
    },
    onFirstHiddenFocus: function() {
      Oe.focus(this.list);
      var t = Oe.getFirstFocusableElement(this.$el, ':not([data-p-hidden-focusable="true"])');
      this.$refs.lastHiddenFocusableElement.tabIndex = Oe.isElement(t) ? void 0 : -1, this.$refs.firstHiddenFocusableElement.tabIndex = -1;
    },
    onLastHiddenFocus: function(t) {
      var n = t.relatedTarget;
      if (n === this.list) {
        var i = Oe.getFirstFocusableElement(this.$el, ':not([data-p-hidden-focusable="true"])');
        Oe.focus(i), this.$refs.firstHiddenFocusableElement.tabIndex = void 0;
      } else
        Oe.focus(this.$refs.firstHiddenFocusableElement);
      this.$refs.lastHiddenFocusableElement.tabIndex = -1;
    },
    onFocusout: function(t) {
      !this.$el.contains(t.relatedTarget) && this.$refs.lastHiddenFocusableElement && this.$refs.firstHiddenFocusableElement && (this.$refs.lastHiddenFocusableElement.tabIndex = this.$refs.firstHiddenFocusableElement.tabIndex = void 0);
    },
    onListFocus: function(t) {
      this.focused = !0, this.focusedOptionIndex = this.focusedOptionIndex !== -1 ? this.focusedOptionIndex : this.autoOptionFocus ? this.findFirstFocusedOptionIndex() : -1, this.autoUpdateModel(), this.$emit("focus", t);
    },
    onListBlur: function(t) {
      this.focused = !1, this.focusedOptionIndex = this.startRangeIndex = -1, this.searchValue = "", this.$emit("blur", t);
    },
    onListKeyDown: function(t) {
      var n = this, i = t.metaKey || t.ctrlKey;
      switch (t.code) {
        case "ArrowDown":
          this.onArrowDownKey(t);
          break;
        case "ArrowUp":
          this.onArrowUpKey(t);
          break;
        case "Home":
          this.onHomeKey(t);
          break;
        case "End":
          this.onEndKey(t);
          break;
        case "PageDown":
          this.onPageDownKey(t);
          break;
        case "PageUp":
          this.onPageUpKey(t);
          break;
        case "Enter":
        case "NumpadEnter":
        case "Space":
          this.onSpaceKey(t);
          break;
        case "Tab":
          break;
        case "ShiftLeft":
        case "ShiftRight":
          this.onShiftKey(t);
          break;
        default:
          if (this.multiple && t.code === "KeyA" && i) {
            var o = this.visibleOptions.filter(function(a) {
              return n.isValidOption(a);
            }).map(function(a) {
              return n.getOptionValue(a);
            });
            this.updateModel(t, o), t.preventDefault();
            break;
          }
          !i && We.isPrintableCharacter(t.key) && (this.searchOptions(t, t.key), t.preventDefault());
          break;
      }
    },
    onOptionSelect: function(t, n) {
      var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : -1;
      this.disabled || this.isOptionDisabled(n) || (this.multiple ? this.onOptionSelectMultiple(t, n) : this.onOptionSelectSingle(t, n), this.optionTouched = !1, i !== -1 && (this.focusedOptionIndex = i));
    },
    onOptionMouseDown: function(t, n) {
      this.changeFocusedOptionIndex(t, n);
    },
    onOptionMouseMove: function(t, n) {
      this.focusOnHover && this.changeFocusedOptionIndex(t, n);
    },
    onOptionTouchEnd: function() {
      this.disabled || (this.optionTouched = !0);
    },
    onOptionSelectSingle: function(t, n) {
      var i = this.isSelected(n), o = !1, a = null, r = this.optionTouched ? !1 : this.metaKeySelection;
      if (r) {
        var s = t && (t.metaKey || t.ctrlKey);
        i ? s && (a = null, o = !0) : (a = this.getOptionValue(n), o = !0);
      } else
        a = i ? null : this.getOptionValue(n), o = !0;
      o && this.updateModel(t, a);
    },
    onOptionSelectMultiple: function(t, n) {
      var i = this.isSelected(n), o = null, a = this.optionTouched ? !1 : this.metaKeySelection;
      if (a) {
        var r = t.metaKey || t.ctrlKey;
        i ? o = r ? this.removeOption(n) : [this.getOptionValue(n)] : (o = r ? this.modelValue || [] : [], o = [].concat(Yb(o), [this.getOptionValue(n)]));
      } else
        o = i ? this.removeOption(n) : [].concat(Yb(this.modelValue || []), [this.getOptionValue(n)]);
      this.updateModel(t, o);
    },
    onOptionSelectRange: function(t) {
      var n = this, i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : -1, o = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : -1;
      if (i === -1 && (i = this.findNearestSelectedOptionIndex(o, !0)), o === -1 && (o = this.findNearestSelectedOptionIndex(i)), i !== -1 && o !== -1) {
        var a = Math.min(i, o), r = Math.max(i, o), s = this.visibleOptions.slice(a, r + 1).filter(function(l) {
          return n.isValidOption(l);
        }).map(function(l) {
          return n.getOptionValue(l);
        });
        this.updateModel(t, s);
      }
    },
    onFilterChange: function(t) {
      this.$emit("filter", {
        originalEvent: t,
        value: t.target.value
      }), this.focusedOptionIndex = this.startRangeIndex = -1;
    },
    onFilterBlur: function() {
      this.focusedOptionIndex = this.startRangeIndex = -1;
    },
    onFilterKeyDown: function(t) {
      switch (t.code) {
        case "ArrowDown":
          this.onArrowDownKey(t);
          break;
        case "ArrowUp":
          this.onArrowUpKey(t);
          break;
        case "ArrowLeft":
        case "ArrowRight":
          this.onArrowLeftKey(t, !0);
          break;
        case "Home":
          this.onHomeKey(t, !0);
          break;
        case "End":
          this.onEndKey(t, !0);
          break;
        case "Enter":
        case "NumpadEnter":
          this.onEnterKey(t);
          break;
        case "ShiftLeft":
        case "ShiftRight":
          this.onShiftKey(t);
          break;
      }
    },
    onArrowDownKey: function(t) {
      var n = this.focusedOptionIndex !== -1 ? this.findNextOptionIndex(this.focusedOptionIndex) : this.findFirstFocusedOptionIndex();
      this.multiple && t.shiftKey && this.onOptionSelectRange(t, this.startRangeIndex, n), this.changeFocusedOptionIndex(t, n), t.preventDefault();
    },
    onArrowUpKey: function(t) {
      var n = this.focusedOptionIndex !== -1 ? this.findPrevOptionIndex(this.focusedOptionIndex) : this.findLastFocusedOptionIndex();
      this.multiple && t.shiftKey && this.onOptionSelectRange(t, n, this.startRangeIndex), this.changeFocusedOptionIndex(t, n), t.preventDefault();
    },
    onArrowLeftKey: function(t) {
      var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
      n && (this.focusedOptionIndex = -1);
    },
    onHomeKey: function(t) {
      var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
      if (n)
        t.currentTarget.setSelectionRange(0, 0), this.focusedOptionIndex = -1;
      else {
        var i = t.metaKey || t.ctrlKey, o = this.findFirstOptionIndex();
        this.multiple && t.shiftKey && i && this.onOptionSelectRange(t, o, this.startRangeIndex), this.changeFocusedOptionIndex(t, o);
      }
      t.preventDefault();
    },
    onEndKey: function(t) {
      var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
      if (n) {
        var i = t.currentTarget, o = i.value.length;
        i.setSelectionRange(o, o), this.focusedOptionIndex = -1;
      } else {
        var a = t.metaKey || t.ctrlKey, r = this.findLastOptionIndex();
        this.multiple && t.shiftKey && a && this.onOptionSelectRange(t, this.startRangeIndex, r), this.changeFocusedOptionIndex(t, r);
      }
      t.preventDefault();
    },
    onPageUpKey: function(t) {
      this.scrollInView(0), t.preventDefault();
    },
    onPageDownKey: function(t) {
      this.scrollInView(this.visibleOptions.length - 1), t.preventDefault();
    },
    onEnterKey: function(t) {
      this.focusedOptionIndex !== -1 && (this.multiple && t.shiftKey ? this.onOptionSelectRange(t, this.focusedOptionIndex) : this.onOptionSelect(t, this.visibleOptions[this.focusedOptionIndex])), t.preventDefault();
    },
    onSpaceKey: function(t) {
      this.onEnterKey(t);
    },
    onShiftKey: function() {
      this.startRangeIndex = this.focusedOptionIndex;
    },
    isOptionMatched: function(t) {
      return this.isValidOption(t) && this.getOptionLabel(t).toLocaleLowerCase(this.filterLocale).startsWith(this.searchValue.toLocaleLowerCase(this.filterLocale));
    },
    isValidOption: function(t) {
      return We.isNotEmpty(t) && !(this.isOptionDisabled(t) || this.isOptionGroup(t));
    },
    isValidSelectedOption: function(t) {
      return this.isValidOption(t) && this.isSelected(t);
    },
    isSelected: function(t) {
      var n = this, i = this.getOptionValue(t);
      return this.multiple ? (this.modelValue || []).some(function(o) {
        return We.equals(o, i, n.equalityKey);
      }) : We.equals(this.modelValue, i, this.equalityKey);
    },
    findFirstOptionIndex: function() {
      var t = this;
      return this.visibleOptions.findIndex(function(n) {
        return t.isValidOption(n);
      });
    },
    findLastOptionIndex: function() {
      var t = this;
      return We.findLastIndex(this.visibleOptions, function(n) {
        return t.isValidOption(n);
      });
    },
    findNextOptionIndex: function(t) {
      var n = this, i = t < this.visibleOptions.length - 1 ? this.visibleOptions.slice(t + 1).findIndex(function(o) {
        return n.isValidOption(o);
      }) : -1;
      return i > -1 ? i + t + 1 : t;
    },
    findPrevOptionIndex: function(t) {
      var n = this, i = t > 0 ? We.findLastIndex(this.visibleOptions.slice(0, t), function(o) {
        return n.isValidOption(o);
      }) : -1;
      return i > -1 ? i : t;
    },
    findFirstSelectedOptionIndex: function() {
      var t = this;
      return this.hasSelectedOption ? this.visibleOptions.findIndex(function(n) {
        return t.isValidSelectedOption(n);
      }) : -1;
    },
    findLastSelectedOptionIndex: function() {
      var t = this;
      return this.hasSelectedOption ? We.findLastIndex(this.visibleOptions, function(n) {
        return t.isValidSelectedOption(n);
      }) : -1;
    },
    findNextSelectedOptionIndex: function(t) {
      var n = this, i = this.hasSelectedOption && t < this.visibleOptions.length - 1 ? this.visibleOptions.slice(t + 1).findIndex(function(o) {
        return n.isValidSelectedOption(o);
      }) : -1;
      return i > -1 ? i + t + 1 : -1;
    },
    findPrevSelectedOptionIndex: function(t) {
      var n = this, i = this.hasSelectedOption && t > 0 ? We.findLastIndex(this.visibleOptions.slice(0, t), function(o) {
        return n.isValidSelectedOption(o);
      }) : -1;
      return i > -1 ? i : -1;
    },
    findNearestSelectedOptionIndex: function(t) {
      var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, i = -1;
      return this.hasSelectedOption && (n ? (i = this.findPrevSelectedOptionIndex(t), i = i === -1 ? this.findNextSelectedOptionIndex(t) : i) : (i = this.findNextSelectedOptionIndex(t), i = i === -1 ? this.findPrevSelectedOptionIndex(t) : i)), i > -1 ? i : t;
    },
    findFirstFocusedOptionIndex: function() {
      var t = this.findFirstSelectedOptionIndex();
      return t < 0 ? this.findFirstOptionIndex() : t;
    },
    findLastFocusedOptionIndex: function() {
      var t = this.findLastSelectedOptionIndex();
      return t < 0 ? this.findLastOptionIndex() : t;
    },
    searchOptions: function(t, n) {
      var i = this;
      this.searchValue = (this.searchValue || "") + n;
      var o = -1;
      this.focusedOptionIndex !== -1 ? (o = this.visibleOptions.slice(this.focusedOptionIndex).findIndex(function(a) {
        return i.isOptionMatched(a);
      }), o = o === -1 ? this.visibleOptions.slice(0, this.focusedOptionIndex).findIndex(function(a) {
        return i.isOptionMatched(a);
      }) : o + this.focusedOptionIndex) : o = this.visibleOptions.findIndex(function(a) {
        return i.isOptionMatched(a);
      }), o === -1 && this.focusedOptionIndex === -1 && (o = this.findFirstFocusedOptionIndex()), o !== -1 && this.changeFocusedOptionIndex(t, o), this.searchTimeout && clearTimeout(this.searchTimeout), this.searchTimeout = setTimeout(function() {
        i.searchValue = "", i.searchTimeout = null;
      }, 500);
    },
    removeOption: function(t) {
      var n = this;
      return this.modelValue.filter(function(i) {
        return !We.equals(i, n.getOptionValue(t), n.equalityKey);
      });
    },
    changeFocusedOptionIndex: function(t, n) {
      this.focusedOptionIndex !== n && (this.focusedOptionIndex = n, this.scrollInView(), this.selectOnFocus && !this.multiple && this.onOptionSelect(t, this.visibleOptions[n]));
    },
    scrollInView: function() {
      var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : -1, n = t !== -1 ? "".concat(this.id, "_").concat(t) : this.focusedOptionId, i = Oe.findSingle(this.list, 'li[id="'.concat(n, '"]'));
      i ? i.scrollIntoView && i.scrollIntoView({
        block: "nearest",
        inline: "nearest"
      }) : this.virtualScrollerDisabled || this.virtualScroller && this.virtualScroller.scrollToIndex(t !== -1 ? t : this.focusedOptionIndex);
    },
    autoUpdateModel: function() {
      this.selectOnFocus && this.autoOptionFocus && !this.hasSelectedOption && !this.multiple && this.focused && (this.focusedOptionIndex = this.findFirstFocusedOptionIndex(), this.onOptionSelect(null, this.visibleOptions[this.focusedOptionIndex]));
    },
    updateModel: function(t, n) {
      this.$emit("update:modelValue", n), this.$emit("change", {
        originalEvent: t,
        value: n
      });
    },
    flatOptions: function(t) {
      var n = this;
      return (t || []).reduce(function(i, o, a) {
        i.push({
          optionGroup: o,
          group: !0,
          index: a
        });
        var r = n.getOptionGroupChildren(o);
        return r && r.forEach(function(s) {
          return i.push(s);
        }), i;
      }, []);
    },
    listRef: function(t, n) {
      this.list = t, n && n(t);
    },
    virtualScrollerRef: function(t) {
      this.virtualScroller = t;
    }
  },
  computed: {
    visibleOptions: function() {
      var t = this.optionGroupLabel ? this.flatOptions(this.options) : this.options || [];
      return this.filterValue ? El.filter(t, this.searchFields, this.filterValue, this.filterMatchMode, this.filterLocale) : t;
    },
    hasSelectedOption: function() {
      return We.isNotEmpty(this.modelValue);
    },
    equalityKey: function() {
      return this.optionValue ? null : this.dataKey;
    },
    searchFields: function() {
      return this.filterFields || [this.optionLabel];
    },
    filterResultMessageText: function() {
      return We.isNotEmpty(this.visibleOptions) ? this.filterMessageText.replaceAll("{0}", this.visibleOptions.length) : this.emptyFilterMessageText;
    },
    filterMessageText: function() {
      return this.filterMessage || this.$primevue.config.locale.searchMessage || "";
    },
    emptyFilterMessageText: function() {
      return this.emptyFilterMessage || this.$primevue.config.locale.emptySearchMessage || this.$primevue.config.locale.emptyFilterMessage || "";
    },
    emptyMessageText: function() {
      return this.emptyMessage || this.$primevue.config.locale.emptyMessage || "";
    },
    selectionMessageText: function() {
      return this.selectionMessage || this.$primevue.config.locale.selectionMessage || "";
    },
    emptySelectionMessageText: function() {
      return this.emptySelectionMessage || this.$primevue.config.locale.emptySelectionMessage || "";
    },
    selectedMessageText: function() {
      return this.hasSelectedOption ? this.selectionMessageText.replaceAll("{0}", this.multiple ? this.modelValue.length : "1") : this.emptySelectionMessageText;
    },
    focusedOptionId: function() {
      return this.focusedOptionIndex !== -1 ? "".concat(this.id, "_").concat(this.focusedOptionIndex) : null;
    },
    ariaSetSize: function() {
      var t = this;
      return this.visibleOptions.filter(function(n) {
        return !t.isOptionGroup(n);
      }).length;
    },
    virtualScrollerDisabled: function() {
      return !this.virtualScrollerOptions;
    }
  },
  directives: {
    ripple: An
  },
  components: {
    VirtualScroller: Ls,
    SearchIcon: fh
  }
};
function Sc(e) {
  "@babel/helpers - typeof";
  return Sc = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Sc(e);
}
function qb(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    t && (i = i.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), n.push.apply(n, i);
  }
  return n;
}
function Kb(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? qb(Object(n), !0).forEach(function(i) {
      kU(e, i, n[i]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : qb(Object(n)).forEach(function(i) {
      Object.defineProperty(e, i, Object.getOwnPropertyDescriptor(n, i));
    });
  }
  return e;
}
function kU(e, t, n) {
  return t = SU(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function SU(e) {
  var t = CU(e, "string");
  return Sc(t) == "symbol" ? t : String(t);
}
function CU(e, t) {
  if (Sc(e) != "object" || !e)
    return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var i = n.call(e, t || "default");
    if (Sc(i) != "object")
      return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var TU = ["id"], LU = ["tabindex"], IU = ["placeholder", "aria-owns", "aria-activedescendant", "tabindex"], PU = ["id", "aria-multiselectable", "aria-label", "aria-labelledby", "aria-activedescendant", "aria-disabled"], AU = ["id"], _U = ["id", "aria-label", "aria-selected", "aria-disabled", "aria-setsize", "aria-posinset", "onClick", "onMousedown", "onMousemove", "data-p-highlight", "data-p-focused", "data-p-disabled"], MU = ["tabindex"];
function OU(e, t, n, i, o, a) {
  var r = $e("VirtualScroller"), s = Ut("ripple");
  return E(), X("div", Ce({
    id: o.id,
    class: e.cx("root"),
    onFocusout: t[10] || (t[10] = function() {
      return a.onFocusout && a.onFocusout.apply(a, arguments);
    })
  }, e.ptm("root"), {
    "data-pc-name": "listbox"
  }), [oe("span", Ce({
    ref: "firstHiddenFocusableElement",
    role: "presentation",
    "aria-hidden": "true",
    class: "p-hidden-accessible p-hidden-focusable",
    tabindex: e.disabled ? -1 : e.tabindex,
    onFocus: t[0] || (t[0] = function() {
      return a.onFirstHiddenFocus && a.onFirstHiddenFocus.apply(a, arguments);
    })
  }, e.ptm("hiddenFirstFocusableEl"), {
    "data-p-hidden-accessible": !0,
    "data-p-hidden-focusable": !0
  }), null, 16, LU), je(e.$slots, "header", {
    value: e.modelValue,
    options: a.visibleOptions
  }), e.filter ? (E(), X("div", Ce({
    key: 0,
    class: e.cx("header")
  }, e.ptm("header")), [oe("div", Ce({
    class: e.cx("filterContainer")
  }, e.ptm("filterContainer")), [rt(oe("input", Ce({
    ref: "filterInput",
    "onUpdate:modelValue": t[1] || (t[1] = function(l) {
      return o.filterValue = l;
    }),
    type: "text",
    class: e.cx("filterInput"),
    placeholder: e.filterPlaceholder,
    role: "searchbox",
    autocomplete: "off",
    "aria-owns": o.id + "_list",
    "aria-activedescendant": a.focusedOptionId,
    tabindex: !e.disabled && !o.focused ? e.tabindex : -1,
    onInput: t[2] || (t[2] = function() {
      return a.onFilterChange && a.onFilterChange.apply(a, arguments);
    }),
    onBlur: t[3] || (t[3] = function() {
      return a.onFilterBlur && a.onFilterBlur.apply(a, arguments);
    }),
    onKeydown: t[4] || (t[4] = function() {
      return a.onFilterKeyDown && a.onFilterKeyDown.apply(a, arguments);
    })
  }, Kb(Kb({}, e.filterInputProps), e.ptm("filterInput"))), null, 16, IU), [[$x, o.filterValue]]), je(e.$slots, "filtericon", {
    class: Pe(e.cx("filterIcon"))
  }, function() {
    return [(E(), fe(tt(e.filterIcon ? "span" : "SearchIcon"), Ce({
      class: [e.cx("filterIcon"), e.filterIcon]
    }, e.ptm("filterIcon")), null, 16, ["class"]))];
  })], 16), oe("span", Ce({
    role: "status",
    "aria-live": "polite",
    class: "p-hidden-accessible"
  }, e.ptm("hiddenFilterResult"), {
    "data-p-hidden-accessible": !0
  }), Ie(a.filterResultMessageText), 17)], 16)) : te("", !0), oe("div", Ce({
    ref: "listWrapper",
    class: e.cx("wrapper"),
    style: e.listStyle
  }, e.ptm("wrapper")), [ue(r, Ce({
    ref: a.virtualScrollerRef
  }, e.virtualScrollerOptions, {
    style: e.listStyle,
    items: a.visibleOptions,
    tabindex: -1,
    disabled: a.virtualScrollerDisabled,
    pt: e.ptm("virtualScroller")
  }), Qt({
    content: Se(function(l) {
      var d = l.styleClass, y = l.contentRef, u = l.items, m = l.getItemOptions, h = l.contentStyle, c = l.itemSize;
      return [oe("ul", Ce({
        ref: function(v) {
          return a.listRef(v, y);
        },
        id: o.id + "_list",
        class: [e.cx("list"), d],
        style: h,
        tabindex: -1,
        role: "listbox",
        "aria-multiselectable": e.multiple,
        "aria-label": e.ariaLabel,
        "aria-labelledby": e.ariaLabelledby,
        "aria-activedescendant": o.focused ? a.focusedOptionId : void 0,
        "aria-disabled": e.disabled,
        onFocus: t[6] || (t[6] = function() {
          return a.onListFocus && a.onListFocus.apply(a, arguments);
        }),
        onBlur: t[7] || (t[7] = function() {
          return a.onListBlur && a.onListBlur.apply(a, arguments);
        }),
        onKeydown: t[8] || (t[8] = function() {
          return a.onListKeyDown && a.onListKeyDown.apply(a, arguments);
        })
      }, e.ptm("list")), [(E(!0), X(Re, null, Ge(u, function(g, v) {
        return E(), X(Re, {
          key: a.getOptionRenderKey(g, a.getOptionIndex(v, m))
        }, [a.isOptionGroup(g) ? (E(), X("li", Ce({
          key: 0,
          id: o.id + "_" + a.getOptionIndex(v, m),
          style: {
            height: c ? c + "px" : void 0
          },
          class: e.cx("itemGroup"),
          role: "option"
        }, e.ptm("itemGroup")), [je(e.$slots, "optiongroup", {
          option: g.optionGroup,
          index: a.getOptionIndex(v, m)
        }, function() {
          return [Ve(Ie(a.getOptionGroupLabel(g.optionGroup)), 1)];
        })], 16, AU)) : rt((E(), X("li", Ce({
          key: 1,
          id: o.id + "_" + a.getOptionIndex(v, m),
          style: {
            height: c ? c + "px" : void 0
          },
          class: e.cx("item", {
            option: g,
            index: v,
            getItemOptions: m
          }),
          role: "option",
          "aria-label": a.getOptionLabel(g),
          "aria-selected": a.isSelected(g),
          "aria-disabled": a.isOptionDisabled(g),
          "aria-setsize": a.ariaSetSize,
          "aria-posinset": a.getAriaPosInset(a.getOptionIndex(v, m)),
          onClick: function(f) {
            return a.onOptionSelect(f, g, a.getOptionIndex(v, m));
          },
          onMousedown: function(f) {
            return a.onOptionMouseDown(f, a.getOptionIndex(v, m));
          },
          onMousemove: function(f) {
            return a.onOptionMouseMove(f, a.getOptionIndex(v, m));
          },
          onTouchend: t[5] || (t[5] = function(P) {
            return a.onOptionTouchEnd();
          })
        }, a.getPTOptions(g, m, v, "item"), {
          "data-p-highlight": a.isSelected(g),
          "data-p-focused": o.focusedOptionIndex === a.getOptionIndex(v, m),
          "data-p-disabled": a.isOptionDisabled(g)
        }), [je(e.$slots, "option", {
          option: g,
          index: a.getOptionIndex(v, m)
        }, function() {
          return [Ve(Ie(a.getOptionLabel(g)), 1)];
        })], 16, _U)), [[s]])], 64);
      }), 128)), o.filterValue && (!u || u && u.length === 0) ? (E(), X("li", Ce({
        key: 0,
        class: e.cx("emptyMessage"),
        role: "option"
      }, e.ptm("emptyMessage")), [je(e.$slots, "emptyfilter", {}, function() {
        return [Ve(Ie(a.emptyFilterMessageText), 1)];
      })], 16)) : !e.options || e.options && e.options.length === 0 ? (E(), X("li", Ce({
        key: 1,
        class: e.cx("emptyMessage"),
        role: "option"
      }, e.ptm("emptyMessage")), [je(e.$slots, "empty", {}, function() {
        return [Ve(Ie(a.emptyMessageText), 1)];
      })], 16)) : te("", !0)], 16, PU)];
    }),
    _: 2
  }, [e.$slots.loader ? {
    name: "loader",
    fn: Se(function(l) {
      var d = l.options;
      return [je(e.$slots, "loader", {
        options: d
      })];
    }),
    key: "0"
  } : void 0]), 1040, ["style", "items", "disabled", "pt"])], 16), je(e.$slots, "footer", {
    value: e.modelValue,
    options: a.visibleOptions
  }), !e.options || e.options && e.options.length === 0 ? (E(), X("span", Ce({
    key: 1,
    role: "status",
    "aria-live": "polite",
    class: "p-hidden-accessible"
  }, e.ptm("hiddenEmptyMessage"), {
    "data-p-hidden-accessible": !0
  }), Ie(a.emptyMessageText), 17)) : te("", !0), oe("span", Ce({
    role: "status",
    "aria-live": "polite",
    class: "p-hidden-accessible"
  }, e.ptm("hiddenSelectedMessage"), {
    "data-p-hidden-accessible": !0
  }), Ie(a.selectedMessageText), 17), oe("span", Ce({
    ref: "lastHiddenFocusableElement",
    role: "presentation",
    "aria-hidden": "true",
    class: "p-hidden-accessible p-hidden-focusable",
    tabindex: e.disabled ? -1 : e.tabindex,
    onFocus: t[9] || (t[9] = function() {
      return a.onLastHiddenFocus && a.onLastHiddenFocus.apply(a, arguments);
    })
  }, e.ptm("hiddenLastFocusableEl"), {
    "data-p-hidden-accessible": !0,
    "data-p-hidden-focusable": !0
  }), null, 16, MU)], 16, TU);
}
sC.render = OU;
const BU = /* @__PURE__ */ Be({
  __name: "BaseRadioBoxItem",
  props: {
    label: {
      type: String,
      required: !0
    },
    tooltipText: {
      type: String,
      default: ""
    },
    icon: {
      type: String,
      default: void 0
    }
  },
  setup(e) {
    const t = e, n = ge();
    return it(() => {
      Ue && pn({
        trigger: n,
        headline: "",
        content: t.tooltipText,
        appendTo: document.body,
        showOnTouchDevices: !0,
        field: () => n
      });
    }), (i, o) => {
      const a = $e("BaseIcon"), r = $e("BaseText");
      return E(), X("div", {
        ref_key: "itemRef",
        ref: n,
        class: "d-base-radio-box__item"
      }, [
        e.icon ? (E(), fe(a, {
          key: 0,
          "base-icon": e.icon,
          "base-icon-color": _(gt).Inherit,
          class: "d-base-radio-box__item--icon"
        }, null, 8, ["base-icon", "base-icon-color"])) : te("", !0),
        e.label ? (E(), fe(r, {
          key: 1,
          text: e.label,
          "font-size": _(st).FourteenPx,
          "text-color": _(dt).GreyBlue009,
          "font-type": _(lt).DwsSlabBold,
          class: "d-base-radio-box__item--label"
        }, null, 8, ["text", "font-size", "text-color", "font-type"])) : te("", !0)
      ], 512);
    };
  }
}), EU = /* @__PURE__ */ Be({
  __name: "BaseRadioBox",
  props: {
    items: {
      type: Array,
      required: !0
    },
    selectedItem: {
      type: Object,
      default: null
    },
    ariaLabel: {
      type: String,
      required: !0
    }
  },
  emits: ["selected-item-changed"],
  setup(e, { emit: t }) {
    const n = e, i = ge(), o = t, a = () => {
      o("selected-item-changed", i.value);
    };
    return qe(
      () => n.items,
      (r) => {
        i.value = r.find((s) => s.isSelected);
      },
      { immediate: !0 }
    ), (r, s) => (E(), fe(_(sC), {
      modelValue: i.value,
      "onUpdate:modelValue": s[0] || (s[0] = (l) => i.value = l),
      options: e.items,
      "aria-label": e.ariaLabel,
      class: "d-base-radio-box",
      onChange: a
    }, {
      option: Se((l) => [
        ue(BU, {
          label: l.option.label,
          icon: l.option.icon,
          "tooltip-text": l.option.tooltip
        }, null, 8, ["label", "icon", "tooltip-text"])
      ]),
      _: 1
    }, 8, ["modelValue", "options", "aria-label"]));
  }
});
const DU = /* @__PURE__ */ Fe(EU, [["__scopeId", "data-v-7b32773e"]]);
var Cc = /* @__PURE__ */ ((e) => (e.Vertical = "vertical", e.Horizontal = "horizontal", e))(Cc || {});
const RU = /* @__PURE__ */ Be({
  __name: "BaseHelperText",
  props: {
    text: {
      type: String,
      default: void 0
    },
    disableHelper: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const t = e, n = ge(), i = (o) => {
      t.text && n.value && !o && pn({
        trigger: n,
        content: t.text,
        appendTo: n,
        showOnTouchDevices: !0,
        field: () => n,
        manuallyOverlayType: ms.Tooltip
      });
    };
    return it(() => {
      i(t.disableHelper);
    }), qe(
      () => t.text,
      (o) => {
        o && (Hy(), i(t.disableHelper));
      }
    ), qe(
      () => t.disableHelper,
      (o) => {
        o ? Hy() : i(o);
      }
    ), (o, a) => e.text ? (E(), X("span", {
      key: 0,
      ref_key: "helperTextRef",
      ref: n,
      class: Pe(["d-base-helper-text", { "d-base-helper-text--disabled": e.disableHelper }]),
      onClick: a[0] || (a[0] = It(() => {
      }, ["prevent"]))
    }, null, 2)) : te("", !0);
  }
});
const mh = /* @__PURE__ */ Fe(RU, [["__scopeId", "data-v-593cefcc"]]), NU = ["for"], $U = { class: "d-base-checkbox-container" }, FU = ["for"], jU = {
  key: 1,
  class: "d-base-checkbox__label-error-text"
}, HU = /* @__PURE__ */ Be({
  __name: "BaseCheckbox",
  props: {
    model: {
      type: Object,
      required: !0
    },
    label: {
      type: String,
      default: null
    },
    helperText: {
      type: String,
      default: null
    },
    mandatory: {
      type: Boolean,
      default: !1
    },
    hideLabel: {
      type: Boolean,
      default: !1
    },
    disableHelperText: {
      type: Boolean,
      default: !1
    },
    errorText: {
      type: String,
      default: null
    }
  },
  emits: ["selected-item-changed"],
  setup(e, { emit: t }) {
    const n = e, i = Pn(), o = t, a = ge(n.model.items), r = (d) => {
      o("selected-item-changed", d, a.value);
    }, s = Te(() => n.label ? n.label.toLowerCase().replace(/\W/g, "") : i), l = Te(() => n.disableHelperText ? dt.GreyBlue004 : dt.GreyBlue009);
    return qe(
      () => n.model.items,
      (d) => {
        a.value = d;
      }
    ), (d, y) => (E(), X("div", {
      class: Pe(["d-base-checkbox", {
        "d-base-checkbox--horizontal": e.model.alignment === _(Cc).Horizontal,
        "d-base-checkbox--vertical": e.model.alignment === _(Cc).Vertical
      }])
    }, [
      !e.hideLabel && (e.label || e.mandatory) ? (E(), X("label", {
        key: 0,
        for: s.value,
        class: "d-base-checkbox__checkbox-label"
      }, [
        e.label ? (E(), fe(Tt, {
          key: 0,
          text: e.label,
          "font-size": _(st).FourteenPx,
          "text-color": l.value,
          "font-type": _(lt).DwsSlabBold
        }, null, 8, ["text", "font-size", "text-color", "font-type"])) : te("", !0),
        e.mandatory ? (E(), fe(Tt, {
          key: 1,
          text: "*",
          "font-size": _(st).FourteenPx,
          "text-color": _(dt).Negative,
          "font-type": _(lt).DwsSlabBold
        }, null, 8, ["font-size", "text-color", "font-type"])) : te("", !0),
        e.helperText ? (E(), fe(mh, {
          key: 2,
          text: e.helperText,
          "disable-helper": e.disableHelperText,
          class: "d-base-checkbox__checkbox-helper-text"
        }, null, 8, ["text", "disable-helper"])) : te("", !0)
      ], 8, NU)) : te("", !0),
      oe("div", $U, [
        (E(!0), X(Re, null, Ge(a.value, (u) => (E(), X("div", {
          key: u.id,
          class: Pe(["d-base-checkbox", {
            "d-base-checkbox__label-disabled": u.isDisabled,
            "d-base-checkbox__label-invalid": !e.model.isValid,
            "d-base-checkbox__label-checked": u.value
          }])
        }, [
          ue(_(ah), {
            modelValue: u.value,
            "onUpdate:modelValue": (m) => u.value = m,
            "input-id": u.id,
            binary: !0,
            disabled: u.isDisabled,
            "data-testid": `checkbox-${u.id}`,
            class: Pe({
              "p-invalid": !e.model.isValid
            }),
            pt: {
              root: {
                tabindex: u.isDisabled ? -1 : 0
              }
            },
            onChange: (m) => r(u),
            onKeydown: Ze(It((m) => u.value = !u.value, ["prevent", "stop"]), ["space"])
          }, null, 8, ["modelValue", "onUpdate:modelValue", "input-id", "disabled", "data-testid", "class", "pt", "onChange", "onKeydown"]),
          oe("label", {
            class: Pe(["d-base-checkbox__label", {
              "d-base-checkbox__label-disabled": u.isDisabled,
              "d-base-checkbox__label-invalid": !e.model.isValid,
              "d-base-checkbox__label-checked": u.value
            }]),
            for: u.id
          }, [
            ue(_(ht), {
              "disable-default-styling": !0,
              "html-text": u.name
            }, null, 8, ["html-text"])
          ], 10, FU)
        ], 2))), 128))
      ]),
      !e.model.isValid && e.errorText ? (E(), X("span", jU, [
        e.model.isValid ? te("", !0) : (E(), fe(_t, {
          key: 0,
          "base-icon": _(H).ExclamationTriangle,
          "base-icon-color": _(gt).Negative,
          "base-icon-size": _(at).NextToText
        }, null, 8, ["base-icon", "base-icon-color", "base-icon-size"])),
        e.model.isValid ? te("", !0) : (E(), fe(Tt, {
          key: 1,
          text: e.errorText,
          "font-size": _(st).TwelvePx,
          "font-type": _(lt).DwsSlabBold,
          class: "d-base-checkbox__label-invalid"
        }, null, 8, ["text", "font-size", "font-type"]))
      ])) : te("", !0)
    ], 2));
  }
});
const bg = /* @__PURE__ */ Fe(HU, [["__scopeId", "data-v-2a673233"]]);
var _n = /* @__PURE__ */ ((e) => (e.Default = "default", e.Password = "password", e.Textarea = "textarea", e.Email = "email", e.Date = "date", e.Hidden = "hidden", e.Number = "number", e))(_n || {}), Ht = /* @__PURE__ */ ((e) => (e.Default = "default", e.Valid = "valid", e.Invalid = "invalid", e))(Ht || {}), xg = /* @__PURE__ */ ((e) => (e.Up = "up", e.Left = "left", e))(xg || {}), lC = /* @__PURE__ */ ((e) => (e.Decimal = "decimal", e.Currency = "currency", e))(lC || {});
const zU = /* @__PURE__ */ Be({
  __name: "BaseDateInput",
  props: {
    model: {
      type: Date,
      default: void 0
    },
    placeholder: {
      type: String,
      default: "MM/DD/YYYY"
    },
    ariaLabel: {
      type: String,
      default: void 0
    },
    minDate: {
      type: Date,
      default: /* @__PURE__ */ new Date("1900-01-01")
    },
    maxDate: {
      type: Date,
      default: /* @__PURE__ */ new Date()
    }
  },
  emits: ["update:model", "change"],
  setup(e, { emit: t }) {
    Lt.extend(ks), Lt.extend(Ss);
    const n = e, i = gm(), a = ge((() => {
      const P = (i.config.locale?.dateFormat ?? "").replace(/[a-zA-Z]/g, "");
      return Array.from(new Set(P));
    })()), r = ge(0), s = ge(), l = ge(), d = ge(""), y = ge(n.model), u = t, m = () => {
      const v = Lt(
        Lt(y.value).tz("UTC").toISOString().replace("T00:00:00.000Z", "")
      ).toDate();
      u("update:model", v), u("change", v);
    }, h = () => {
      d.value = "", r.value = 0;
    }, c = (v) => {
      a.value.length > 0 && (v.data && d.value.length < 10 ? d.value += v.data : d.value.endsWith(a.value[r.value]) ? (d.value = d.value.slice(0, -2), r.value < 3 && r.value > 0 && a.value.length === 3 && r.value--) : d.value = d.value.slice(0, -1), d.value.length === 2 && (d.value += a.value[r.value], r.value < 3 && a.value.length === 3 && r.value++), d.value.length === 5 && (d.value += a.value[r.value], r.value < 3 && a.value.length === 3 && r.value++), d.value.length === 10 && a.value.length === 3 && (d.value += a.value[r.value])), d.value.length >= 10 && !v.data && (d.value = d.value.slice(0, -1)), l.value && (l.value.value = d.value);
    }, g = (v) => {
      ["ArrowRight", "ArrowLeft"].includes(v.key) && v.preventDefault();
    };
    return it(() => {
      l.value = s.value?.$el.querySelector("input"), l.value && (l.value.addEventListener("input", c), l.value.addEventListener("keydown", g));
    }), qe(
      () => n.model,
      (v) => {
        y.value = v;
      },
      { immediate: !0 }
    ), (v, P) => (E(), fe(_(ag), {
      ref_key: "calendarRef",
      ref: s,
      modelValue: y.value,
      "onUpdate:modelValue": P[0] || (P[0] = (f) => y.value = f),
      class: "d-base-date-input",
      placeholder: e.placeholder,
      "show-icon": !0,
      "manual-input": !0,
      "disabled-days": [0, 6],
      "min-date": e.minDate,
      "max-date": e.maxDate,
      "aria-label": e.ariaLabel,
      onDateSelect: m,
      onFocus: h
    }, {
      dropdownicon: Se(() => [
        ue(_(_t), {
          "base-icon": _(H).CalendarAlt,
          "base-icon-size": _(at).Inherit
        }, null, 8, ["base-icon", "base-icon-size"])
      ]),
      _: 1
    }, 8, ["modelValue", "placeholder", "min-date", "max-date", "aria-label"]));
  }
});
const VU = /* @__PURE__ */ Fe(zU, [["__scopeId", "data-v-1a5e7a0c"]]);
var cC = {
  name: "EyeIcon",
  extends: Yt
}, GU = /* @__PURE__ */ oe("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M0.0535499 7.25213C0.208567 7.59162 2.40413 12.4 7 12.4C11.5959 12.4 13.7914 7.59162 13.9465 7.25213C13.9487 7.2471 13.9506 7.24304 13.952 7.24001C13.9837 7.16396 14 7.08239 14 7.00001C14 6.91762 13.9837 6.83605 13.952 6.76001C13.9506 6.75697 13.9487 6.75292 13.9465 6.74788C13.7914 6.4084 11.5959 1.60001 7 1.60001C2.40413 1.60001 0.208567 6.40839 0.0535499 6.74788C0.0512519 6.75292 0.0494023 6.75697 0.048 6.76001C0.0163137 6.83605 0 6.91762 0 7.00001C0 7.08239 0.0163137 7.16396 0.048 7.24001C0.0494023 7.24304 0.0512519 7.2471 0.0535499 7.25213ZM7 11.2C3.664 11.2 1.736 7.92001 1.264 7.00001C1.736 6.08001 3.664 2.80001 7 2.80001C10.336 2.80001 12.264 6.08001 12.736 7.00001C12.264 7.92001 10.336 11.2 7 11.2ZM5.55551 9.16182C5.98308 9.44751 6.48576 9.6 7 9.6C7.68891 9.59789 8.349 9.32328 8.83614 8.83614C9.32328 8.349 9.59789 7.68891 9.59999 7C9.59999 6.48576 9.44751 5.98308 9.16182 5.55551C8.87612 5.12794 8.47006 4.7947 7.99497 4.59791C7.51988 4.40112 6.99711 4.34963 6.49276 4.44995C5.98841 4.55027 5.52513 4.7979 5.16152 5.16152C4.7979 5.52513 4.55027 5.98841 4.44995 6.49276C4.34963 6.99711 4.40112 7.51988 4.59791 7.99497C4.7947 8.47006 5.12794 8.87612 5.55551 9.16182ZM6.2222 5.83594C6.45243 5.6821 6.7231 5.6 7 5.6C7.37065 5.6021 7.72553 5.75027 7.98762 6.01237C8.24972 6.27446 8.39789 6.62934 8.4 7C8.4 7.27689 8.31789 7.54756 8.16405 7.77779C8.01022 8.00802 7.79157 8.18746 7.53575 8.29343C7.27994 8.39939 6.99844 8.42711 6.72687 8.37309C6.4553 8.31908 6.20584 8.18574 6.01005 7.98994C5.81425 7.79415 5.68091 7.54469 5.6269 7.27312C5.57288 7.00155 5.6006 6.72006 5.70656 6.46424C5.81253 6.20842 5.99197 5.98977 6.2222 5.83594Z",
  fill: "currentColor"
}, null, -1), UU = [GU];
function WU(e, t, n, i, o, a) {
  return E(), X("svg", Ce({
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.pti()), UU, 16);
}
cC.render = WU;
var dC = {
  name: "EyeSlashIcon",
  extends: Yt,
  computed: {
    pathId: function() {
      return "pv_icon_clip_".concat(Mt());
    }
  }
}, YU = ["clip-path"], qU = /* @__PURE__ */ oe("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M13.9414 6.74792C13.9437 6.75295 13.9455 6.757 13.9469 6.76003C13.982 6.8394 14.0001 6.9252 14.0001 7.01195C14.0001 7.0987 13.982 7.1845 13.9469 7.26386C13.6004 8.00059 13.1711 8.69549 12.6674 9.33515C12.6115 9.4071 12.54 9.46538 12.4582 9.50556C12.3765 9.54574 12.2866 9.56678 12.1955 9.56707C12.0834 9.56671 11.9737 9.53496 11.8788 9.47541C11.7838 9.41586 11.7074 9.3309 11.6583 9.23015C11.6092 9.12941 11.5893 9.01691 11.6008 8.90543C11.6124 8.79394 11.6549 8.68793 11.7237 8.5994C12.1065 8.09726 12.4437 7.56199 12.7313 6.99995C12.2595 6.08027 10.3402 2.8014 6.99732 2.8014C6.63723 2.80218 6.27816 2.83969 5.92569 2.91336C5.77666 2.93304 5.62568 2.89606 5.50263 2.80972C5.37958 2.72337 5.29344 2.59398 5.26125 2.44714C5.22907 2.30031 5.2532 2.14674 5.32885 2.01685C5.40451 1.88696 5.52618 1.79021 5.66978 1.74576C6.10574 1.64961 6.55089 1.60134 6.99732 1.60181C11.5916 1.60181 13.7864 6.40856 13.9414 6.74792ZM2.20333 1.61685C2.35871 1.61411 2.5091 1.67179 2.6228 1.77774L12.2195 11.3744C12.3318 11.4869 12.3949 11.6393 12.3949 11.7983C12.3949 11.9572 12.3318 12.1097 12.2195 12.2221C12.107 12.3345 11.9546 12.3976 11.7956 12.3976C11.6367 12.3976 11.4842 12.3345 11.3718 12.2221L10.5081 11.3584C9.46549 12.0426 8.24432 12.4042 6.99729 12.3981C2.403 12.3981 0.208197 7.59135 0.0532336 7.25198C0.0509364 7.24694 0.0490875 7.2429 0.0476856 7.23986C0.0162332 7.16518 3.05176e-05 7.08497 3.05176e-05 7.00394C3.05176e-05 6.92291 0.0162332 6.8427 0.0476856 6.76802C0.631261 5.47831 1.46902 4.31959 2.51084 3.36119L1.77509 2.62545C1.66914 2.51175 1.61146 2.36136 1.61421 2.20597C1.61695 2.05059 1.6799 1.90233 1.78979 1.79244C1.89968 1.68254 2.04794 1.6196 2.20333 1.61685ZM7.45314 8.35147L5.68574 6.57609V6.5361C5.5872 6.78938 5.56498 7.06597 5.62183 7.33173C5.67868 7.59749 5.8121 7.84078 6.00563 8.03158C6.19567 8.21043 6.43052 8.33458 6.68533 8.39089C6.94014 8.44721 7.20543 8.43359 7.45314 8.35147ZM1.26327 6.99994C1.7351 7.91163 3.64645 11.1985 6.99729 11.1985C7.9267 11.2048 8.8408 10.9618 9.64438 10.4947L8.35682 9.20718C7.86027 9.51441 7.27449 9.64491 6.69448 9.57752C6.11446 9.51014 5.57421 9.24881 5.16131 8.83592C4.74842 8.42303 4.4871 7.88277 4.41971 7.30276C4.35232 6.72274 4.48282 6.13697 4.79005 5.64041L3.35855 4.2089C2.4954 5.00336 1.78523 5.94935 1.26327 6.99994Z",
  fill: "currentColor"
}, null, -1), KU = [qU], XU = ["id"], ZU = /* @__PURE__ */ oe("rect", {
  width: "14",
  height: "14",
  fill: "white"
}, null, -1), JU = [ZU];
function QU(e, t, n, i, o, a) {
  return E(), X("svg", Ce({
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.pti()), [oe("g", {
    "clip-path": "url(#".concat(a.pathId, ")")
  }, KU, 8, YU), oe("defs", null, [oe("clipPath", {
    id: "".concat(a.pathId)
  }, JU, 8, XU)])], 16);
}
dC.render = QU;
var eW = `
@layer primevue {
    .p-password {
        display: inline-flex;
    }

    .p-password .p-password-panel {
        min-width: 100%;
    }

    .p-password-meter {
        height: 10px;
    }

    .p-password-strength {
        height: 100%;
        width: 0;
        transition: width 1s ease-in-out;
    }

    .p-fluid .p-password {
        display: flex;
    }

    .p-password-input::-ms-reveal,
    .p-password-input::-ms-clear {
        display: none;
    }
}
`, tW = {
  root: function(t) {
    var n = t.props;
    return {
      position: n.appendTo === "self" ? "relative" : void 0
    };
  }
}, nW = {
  root: function(t) {
    var n = t.instance, i = t.props;
    return ["p-password p-component p-inputwrapper", {
      "p-inputwrapper-filled": n.filled,
      "p-inputwrapper-focus": n.focused,
      "p-input-icon-right": i.toggleMask
    }];
  },
  input: function(t) {
    var n = t.props;
    return ["p-password-input", {
      "p-disabled": n.disabled
    }];
  },
  panel: function(t) {
    var n = t.instance;
    return ["p-password-panel p-component", {
      "p-input-filled": n.$primevue.config.inputStyle === "filled",
      "p-ripple-disabled": n.$primevue.config.ripple === !1
    }];
  },
  meter: "p-password-meter",
  meterLabel: function(t) {
    var n = t.instance;
    return "p-password-strength ".concat(n.meter ? n.meter.strength : "");
  },
  info: "p-password-info"
}, iW = Wt.extend({
  name: "password",
  css: eW,
  classes: nW,
  inlineStyles: tW
}), aW = {
  name: "BasePassword",
  extends: wt,
  props: {
    modelValue: String,
    promptLabel: {
      type: String,
      default: null
    },
    mediumRegex: {
      type: String,
      default: "^(((?=.*[a-z])(?=.*[A-Z]))|((?=.*[a-z])(?=.*[0-9]))|((?=.*[A-Z])(?=.*[0-9])))(?=.{6,})"
      // eslint-disable-line
    },
    strongRegex: {
      type: String,
      default: "^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})"
      // eslint-disable-line
    },
    weakLabel: {
      type: String,
      default: null
    },
    mediumLabel: {
      type: String,
      default: null
    },
    strongLabel: {
      type: String,
      default: null
    },
    feedback: {
      type: Boolean,
      default: !0
    },
    appendTo: {
      type: [String, Object],
      default: "body"
    },
    toggleMask: {
      type: Boolean,
      default: !1
    },
    hideIcon: {
      type: String,
      default: void 0
    },
    showIcon: {
      type: String,
      default: void 0
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    placeholder: {
      type: String,
      default: null
    },
    required: {
      type: Boolean,
      default: !1
    },
    inputId: {
      type: String,
      default: null
    },
    inputClass: {
      type: [String, Object],
      default: null
    },
    inputStyle: {
      type: Object,
      default: null
    },
    inputProps: {
      type: null,
      default: null
    },
    panelId: {
      type: String,
      default: null
    },
    panelClass: {
      type: [String, Object],
      default: null
    },
    panelStyle: {
      type: Object,
      default: null
    },
    panelProps: {
      type: null,
      default: null
    },
    ariaLabelledby: {
      type: String,
      default: null
    },
    ariaLabel: {
      type: String,
      default: null
    }
  },
  style: iW,
  provide: function() {
    return {
      $parentInstance: this
    };
  }
}, uC = {
  name: "Password",
  extends: aW,
  emits: ["update:modelValue", "change", "focus", "blur", "invalid"],
  data: function() {
    return {
      overlayVisible: !1,
      meter: null,
      infoText: null,
      focused: !1,
      unmasked: !1
    };
  },
  mediumCheckRegExp: null,
  strongCheckRegExp: null,
  resizeListener: null,
  scrollHandler: null,
  overlay: null,
  mounted: function() {
    this.infoText = this.promptText, this.mediumCheckRegExp = new RegExp(this.mediumRegex), this.strongCheckRegExp = new RegExp(this.strongRegex);
  },
  beforeUnmount: function() {
    this.unbindResizeListener(), this.scrollHandler && (this.scrollHandler.destroy(), this.scrollHandler = null), this.overlay && (qt.clear(this.overlay), this.overlay = null);
  },
  methods: {
    onOverlayEnter: function(t) {
      qt.set("overlay", t, this.$primevue.config.zIndex.overlay), Oe.addStyles(t, {
        position: "absolute",
        top: "0",
        left: "0"
      }), this.alignOverlay(), this.bindScrollListener(), this.bindResizeListener();
    },
    onOverlayLeave: function() {
      this.unbindScrollListener(), this.unbindResizeListener(), this.overlay = null;
    },
    onOverlayAfterLeave: function(t) {
      qt.clear(t);
    },
    alignOverlay: function() {
      this.appendTo === "self" ? Oe.relativePosition(this.overlay, this.$refs.input.$el) : (this.overlay.style.minWidth = Oe.getOuterWidth(this.$refs.input.$el) + "px", Oe.absolutePosition(this.overlay, this.$refs.input.$el));
    },
    testStrength: function(t) {
      var n = 0;
      return this.strongCheckRegExp.test(t) ? n = 3 : this.mediumCheckRegExp.test(t) ? n = 2 : t.length && (n = 1), n;
    },
    onInput: function(t) {
      this.$emit("update:modelValue", t.target.value), this.$emit("change", t);
    },
    onFocus: function(t) {
      this.focused = !0, this.feedback && (this.setPasswordMeter(this.modelValue), this.overlayVisible = !0), this.$emit("focus", t);
    },
    onBlur: function(t) {
      this.focused = !1, this.feedback && (this.overlayVisible = !1), this.$emit("blur", t);
    },
    onKeyUp: function(t) {
      if (this.feedback) {
        var n = t.target.value, i = this.checkPasswordStrength(n), o = i.meter, a = i.label;
        if (this.meter = o, this.infoText = a, t.code === "Escape") {
          this.overlayVisible && (this.overlayVisible = !1);
          return;
        }
        this.overlayVisible || (this.overlayVisible = !0);
      }
    },
    setPasswordMeter: function() {
      if (this.modelValue) {
        var t = this.checkPasswordStrength(this.modelValue), n = t.meter, i = t.label;
        this.meter = n, this.infoText = i, this.overlayVisible || (this.overlayVisible = !0);
      }
    },
    checkPasswordStrength: function(t) {
      var n = null, i = null;
      switch (this.testStrength(t)) {
        case 1:
          n = this.weakText, i = {
            strength: "weak",
            width: "33.33%"
          };
          break;
        case 2:
          n = this.mediumText, i = {
            strength: "medium",
            width: "66.66%"
          };
          break;
        case 3:
          n = this.strongText, i = {
            strength: "strong",
            width: "100%"
          };
          break;
        default:
          n = this.promptText, i = null;
          break;
      }
      return {
        label: n,
        meter: i
      };
    },
    onInvalid: function(t) {
      this.$emit("invalid", t);
    },
    bindScrollListener: function() {
      var t = this;
      this.scrollHandler || (this.scrollHandler = new po(this.$refs.input.$el, function() {
        t.overlayVisible && (t.overlayVisible = !1);
      })), this.scrollHandler.bindScrollListener();
    },
    unbindScrollListener: function() {
      this.scrollHandler && this.scrollHandler.unbindScrollListener();
    },
    bindResizeListener: function() {
      var t = this;
      this.resizeListener || (this.resizeListener = function() {
        t.overlayVisible && !Oe.isTouchDevice() && (t.overlayVisible = !1);
      }, window.addEventListener("resize", this.resizeListener));
    },
    unbindResizeListener: function() {
      this.resizeListener && (window.removeEventListener("resize", this.resizeListener), this.resizeListener = null);
    },
    overlayRef: function(t) {
      this.overlay = t;
    },
    onMaskToggle: function() {
      this.unmasked = !this.unmasked;
    },
    onOverlayClick: function(t) {
      Zn.emit("overlay-click", {
        originalEvent: t,
        target: this.$el
      });
    }
  },
  computed: {
    inputType: function() {
      return this.unmasked ? "text" : "password";
    },
    filled: function() {
      return this.modelValue != null && this.modelValue.toString().length > 0;
    },
    weakText: function() {
      return this.weakLabel || this.$primevue.config.locale.weak;
    },
    mediumText: function() {
      return this.mediumLabel || this.$primevue.config.locale.medium;
    },
    strongText: function() {
      return this.strongLabel || this.$primevue.config.locale.strong;
    },
    promptText: function() {
      return this.promptLabel || this.$primevue.config.locale.passwordPrompt;
    },
    panelUniqueId: function() {
      return Mt() + "_panel";
    }
  },
  components: {
    PInputText: ls,
    Portal: Yn,
    EyeSlashIcon: dC,
    EyeIcon: cC
  }
};
function Tc(e) {
  "@babel/helpers - typeof";
  return Tc = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Tc(e);
}
function Xb(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    t && (i = i.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), n.push.apply(n, i);
  }
  return n;
}
function Zb(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Xb(Object(n), !0).forEach(function(i) {
      oW(e, i, n[i]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Xb(Object(n)).forEach(function(i) {
      Object.defineProperty(e, i, Object.getOwnPropertyDescriptor(n, i));
    });
  }
  return e;
}
function oW(e, t, n) {
  return t = rW(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function rW(e) {
  var t = sW(e, "string");
  return Tc(t) == "symbol" ? t : String(t);
}
function sW(e, t) {
  if (Tc(e) != "object" || !e)
    return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var i = n.call(e, t || "default");
    if (Tc(i) != "object")
      return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var lW = ["id"];
function cW(e, t, n, i, o, a) {
  var r = $e("PInputText"), s = $e("Portal");
  return E(), X("div", Ce({
    class: e.cx("root"),
    style: e.sx("root")
  }, e.ptm("root"), {
    "data-pc-name": "password"
  }), [ue(r, Ce({
    ref: "input",
    id: e.inputId,
    type: a.inputType,
    class: [e.cx("input"), e.inputClass],
    style: e.inputStyle,
    value: e.modelValue,
    "aria-labelledby": e.ariaLabelledby,
    "aria-label": e.ariaLabel,
    "aria-controls": e.panelProps && e.panelProps.id || e.panelId || a.panelUniqueId,
    "aria-expanded": o.overlayVisible,
    "aria-haspopup": !0,
    placeholder: e.placeholder,
    required: e.required,
    disabled: e.disabled,
    onInput: a.onInput,
    onFocus: a.onFocus,
    onBlur: a.onBlur,
    onKeyup: a.onKeyUp,
    onInvalid: a.onInvalid
  }, e.inputProps, {
    pt: e.ptm("input"),
    unstyled: e.unstyled
  }), null, 16, ["id", "type", "class", "style", "value", "aria-labelledby", "aria-label", "aria-controls", "aria-expanded", "placeholder", "required", "disabled", "onInput", "onFocus", "onBlur", "onKeyup", "onInvalid", "pt", "unstyled"]), e.toggleMask && o.unmasked ? je(e.$slots, "hideicon", {
    key: 0,
    onClick: a.onMaskToggle,
    toggleCallback: a.onMaskToggle
  }, function() {
    return [(E(), fe(tt(e.hideIcon ? "i" : "EyeSlashIcon"), Ce({
      class: e.hideIcon,
      onClick: a.onMaskToggle
    }, e.ptm("hideIcon")), null, 16, ["class", "onClick"]))];
  }) : te("", !0), e.toggleMask && !o.unmasked ? je(e.$slots, "showicon", {
    key: 1,
    onClick: a.onMaskToggle,
    toggleCallback: a.onMaskToggle
  }, function() {
    return [(E(), fe(tt(e.showIcon ? "i" : "EyeIcon"), Ce({
      class: e.showIcon,
      onClick: a.onMaskToggle
    }, e.ptm("showIcon")), null, 16, ["class", "onClick"]))];
  }) : te("", !0), oe("span", Ce({
    class: "p-hidden-accessible",
    "aria-live": "polite"
  }, e.ptm("hiddenAccesible"), {
    "data-p-hidden-accessible": !0
  }), Ie(o.infoText), 17), ue(s, {
    appendTo: e.appendTo
  }, {
    default: Se(function() {
      return [ue(ia, Ce({
        name: "p-connected-overlay",
        onEnter: a.onOverlayEnter,
        onLeave: a.onOverlayLeave,
        onAfterLeave: a.onOverlayAfterLeave
      }, e.ptm("transition")), {
        default: Se(function() {
          return [o.overlayVisible ? (E(), X("div", Ce({
            key: 0,
            ref: a.overlayRef,
            id: e.panelId || a.panelUniqueId,
            class: [e.cx("panel"), e.panelClass],
            style: e.panelStyle,
            onClick: t[0] || (t[0] = function() {
              return a.onOverlayClick && a.onOverlayClick.apply(a, arguments);
            })
          }, Zb(Zb({}, e.panelProps), e.ptm("panel"))), [je(e.$slots, "header"), je(e.$slots, "content", {}, function() {
            return [oe("div", Ce({
              class: e.cx("meter")
            }, e.ptm("meter")), [oe("div", Ce({
              class: e.cx("meterLabel"),
              style: {
                width: o.meter ? o.meter.width : ""
              }
            }, e.ptm("meterLabel")), null, 16)], 16), oe("div", Ce({
              class: e.cx("info")
            }, e.ptm("info")), Ie(o.infoText), 17)];
          }), je(e.$slots, "footer")], 16, lW)) : te("", !0)];
        }),
        _: 3
      }, 16, ["onEnter", "onLeave", "onAfterLeave"])];
    }),
    _: 3
  }, 8, ["appendTo"])], 16);
}
uC.render = cW;
var dW = `
@layer primevue {
    .p-inputtextarea-resizable {
        overflow: hidden;
        resize: none;
    }

    .p-fluid .p-inputtextarea {
        width: 100%;
    }
}
`, uW = {
  root: function(t) {
    var n = t.instance, i = t.props;
    return ["p-inputtextarea p-inputtext p-component", {
      "p-filled": n.filled,
      "p-inputtextarea-resizable ": i.autoResize
    }];
  }
}, hW = Wt.extend({
  name: "textarea",
  css: dW,
  classes: uW
}), pW = {
  name: "BaseTextarea",
  extends: wt,
  props: {
    modelValue: null,
    autoResize: Boolean
  },
  style: hW,
  provide: function() {
    return {
      $parentInstance: this
    };
  }
}, hC = {
  name: "Textarea",
  extends: pW,
  emits: ["update:modelValue"],
  mounted: function() {
    this.$el.offsetParent && this.autoResize && this.resize();
  },
  updated: function() {
    this.$el.offsetParent && this.autoResize && this.resize();
  },
  methods: {
    resize: function() {
      this.$el.style.height = "auto", this.$el.style.height = this.$el.scrollHeight + "px", parseFloat(this.$el.style.height) >= parseFloat(this.$el.style.maxHeight) ? (this.$el.style.overflowY = "scroll", this.$el.style.height = this.$el.style.maxHeight) : this.$el.style.overflow = "hidden";
    },
    onInput: function(t) {
      this.autoResize && this.resize(), this.$emit("update:modelValue", t.target.value);
    }
  },
  computed: {
    filled: function() {
      return this.modelValue != null && this.modelValue.toString().length > 0;
    },
    ptmParams: function() {
      return {
        context: {
          disabled: this.$attrs.disabled || this.$attrs.disabled === ""
        }
      };
    }
  }
}, fW = ["value"];
function mW(e, t, n, i, o, a) {
  return E(), X("textarea", Ce({
    class: e.cx("root"),
    value: e.modelValue,
    onInput: t[0] || (t[0] = function() {
      return a.onInput && a.onInput.apply(a, arguments);
    })
  }, e.ptm("root", a.ptmParams), {
    "data-pc-name": "textarea"
  }), null, 16, fW);
}
hC.render = mW;
function pC(e) {
  var t, n, i = "";
  if (typeof e == "string" || typeof e == "number")
    i += e;
  else if (typeof e == "object")
    if (Array.isArray(e)) {
      var o = e.length;
      for (t = 0; t < o; t++)
        e[t] && (n = pC(e[t])) && (i && (i += " "), i += n);
    } else
      for (n in e)
        e[n] && (i && (i += " "), i += n);
  return i;
}
function ts() {
  for (var e, t, n = 0, i = "", o = arguments.length; n < o; n++)
    (e = arguments[n]) && (t = pC(e)) && (i && (i += " "), i += t);
  return i;
}
const gW = ["data-testid"], vW = ["id", "for"], yW = { class: "d-base-input__label__box" }, bW = {
  key: 0,
  class: "d-base-input__icon-left"
}, xW = {
  key: 0,
  class: "d-base-input__icon-right"
}, wW = /* @__PURE__ */ Be({
  __name: "BaseInput",
  props: {
    id: {
      type: String,
      default: null
    },
    placeholder: {
      type: String,
      default: null
    },
    label: {
      type: String,
      default: null
    },
    helperText: {
      type: String,
      default: null
    },
    errorText: {
      type: String,
      default: null
    },
    inputValue: {
      type: [String, Date, Number],
      default: null
    },
    model: {
      type: Date,
      default: void 0
    },
    inputType: {
      type: String,
      default: _n.Default
    },
    state: {
      type: String,
      default: Ht.Default
    },
    labelPosition: {
      type: String,
      default: xg.Up
    },
    numberMode: {
      type: String,
      default: void 0
    },
    leftIcon: {
      type: String,
      default: null
    },
    rightIcon: {
      type: Object,
      default: null
    },
    rightIconFilled: {
      type: Boolean,
      default: !1
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    mandatory: {
      type: Boolean,
      default: !1
    },
    hideLabel: {
      type: Boolean,
      default: !1
    },
    ariaLabel: {
      type: String,
      default: void 0
    },
    dataTestid: {
      type: String,
      default: void 0
    },
    minDate: {
      type: Date,
      default: /* @__PURE__ */ new Date("1900-01-01")
    },
    maxDate: {
      type: Date,
      default: /* @__PURE__ */ new Date()
    },
    numberPrefix: {
      type: String,
      default: void 0
    },
    numberSuffix: {
      type: String,
      default: void 0
    },
    min: {
      type: Number,
      default: void 0
    },
    max: {
      type: Number,
      default: void 0
    },
    currency: {
      type: String,
      default: void 0
    },
    minFractionDigits: {
      type: Number,
      default: void 0
    },
    maxFractionDigits: {
      type: Number,
      default: void 0
    }
  },
  emits: [
    "value-changed",
    "on-keyup",
    "left-icon-clicked",
    "right-icon-clicked",
    "blur",
    "click",
    "update:inputValue"
  ],
  setup(e, { expose: t, emit: n }) {
    const i = e, { currentLocale: o } = Je(), a = Pn(), r = ge(), s = ge(), l = ge(o.value.toString()), d = n, y = Te(() => i.id ? i.id : i.label ? i.label.toLowerCase().replace(/\W/g, "") : a), u = Te(() => {
      if (i.labelPosition)
        return `d-base-input--${i.labelPosition}`;
    }), m = Te(() => {
      if (i.disabled)
        return dt.GreyBlue004;
      switch (i.state) {
        case Ht.Default:
          return dt.GreyBlue009;
        case Ht.Valid:
          return dt.Success;
        case Ht.Invalid:
          return dt.Negative;
      }
    }), h = () => {
      d("value-changed", s.value), d("update:inputValue", s.value);
    }, c = (x) => {
      d("blur", x, s.value);
    }, g = () => {
      d("click", s.value);
    }, v = () => {
      d("on-keyup", s.value);
    }, P = () => {
      On("Base Input", "left icon clicked"), d("left-icon-clicked", s.value);
    }, f = () => {
      On("Base Input", "right icon clicked"), d("right-icon-clicked", s.value);
    }, S = () => {
      On("Date Input", "Selected DatePicker");
    }, w = Te(() => ts({
      "p-invalid": i.state === Ht.Invalid,
      "p-valid": i.state === Ht.Valid,
      disabled: i.disabled
    }));
    return qe(
      () => i.inputValue,
      (x) => {
        s.value = x, x == "" && r.value && r.value.$el.focus();
      },
      { immediate: !0 }
    ), t({
      inputRef: r
    }), (x, k) => {
      const A = $e("BaseIcon"), $ = $e("BaseText");
      return E(), X("div", {
        class: "d-base-input",
        "data-testid": e.dataTestid
      }, [
        oe("div", {
          class: Pe(["d-base-input__inner", u.value])
        }, [
          !e.hideLabel && (e.label || e.mandatory) ? (E(), X("label", {
            key: 0,
            id: `${y.value}-label`,
            for: y.value,
            class: "d-base-input__label"
          }, [
            oe("span", yW, [
              e.label ? (E(), fe(_(ht), {
                key: 0,
                "html-text": e.label,
                class: Pe([{
                  "d-base-input__label__box--disabled": e.disabled,
                  "d-base-input__label__box--margin": e.helperText && !e.mandatory
                }, "d-base-input__label__box__text"]),
                "disable-default-styling": ""
              }, null, 8, ["html-text", "class"])) : te("", !0),
              e.mandatory ? (E(), fe(_(ht), {
                key: 1,
                "html-text": "*",
                class: Pe(["d-base-input__label__box--mandatory", {
                  "d-base-input__label__box--margin": e.helperText
                }]),
                "disable-default-styling": ""
              }, null, 8, ["class"])) : te("", !0),
              e.helperText ? (E(), fe(mh, {
                key: 2,
                text: e.helperText,
                "disable-helper": e.disabled,
                class: "d-base-input__helper-text"
              }, null, 8, ["text", "disable-helper"])) : te("", !0)
            ])
          ], 8, vW)) : te("", !0),
          oe("span", {
            class: Pe(["d-base-input__container", {
              "p-input-icon-left": e.leftIcon,
              "p-input-icon-right": e.rightIcon && e.state === _(Ht).Default || e.state === _(Ht).Invalid || e.state === _(Ht).Valid,
              "p-input-two-icon-right": (e.rightIcon || e.inputType === _(_n).Password) && e.state !== _(Ht).Default
            }])
          }, [
            e.leftIcon ? (E(), X("span", bW, [
              ue(A, {
                "base-icon": e.leftIcon,
                "base-icon-color": _(gt).Petrol45,
                "base-icon-size": _(at).Inherit,
                "base-icon-filled": !1,
                onClick: P
              }, null, 8, ["base-icon", "base-icon-color", "base-icon-size"])
            ])) : te("", !0),
            e.inputType === _(_n).Default || e.inputType === _(_n).Email ? (E(), fe(_(ls), {
              key: 1,
              id: y.value,
              ref_key: "inputRef",
              ref: r,
              modelValue: s.value,
              "onUpdate:modelValue": k[0] || (k[0] = (j) => s.value = j),
              name: y.value,
              type: e.inputType === _(_n).Email ? "email" : "text",
              class: Pe(["d-base-input__input", w.value]),
              "aria-label": e.ariaLabel,
              placeholder: e.placeholder,
              disabled: e.disabled,
              onChange: h,
              onKeyup: v,
              onBlur: c,
              onClick: g
            }, null, 8, ["id", "modelValue", "name", "type", "class", "aria-label", "placeholder", "disabled"])) : te("", !0),
            e.inputType === _(_n).Hidden ? (E(), fe(_(ls), {
              key: 2,
              id: y.value,
              ref_key: "inputRef",
              ref: r,
              modelValue: s.value,
              "onUpdate:modelValue": k[1] || (k[1] = (j) => s.value = j),
              name: y.value,
              type: _(_n).Hidden,
              "aria-hidden": !0
            }, null, 8, ["id", "modelValue", "name", "type"])) : te("", !0),
            e.inputType === _(_n).Number ? (E(), fe(_(Am), {
              key: 3,
              ref_key: "inputRef",
              ref: r,
              modelValue: s.value,
              "onUpdate:modelValue": [
                k[2] || (k[2] = (j) => s.value = j),
                h
              ],
              "input-id": y.value,
              name: y.value,
              locale: l.value,
              mode: e.numberMode,
              suffix: e.numberSuffix,
              prefix: e.numberPrefix,
              min: e.min,
              max: e.max,
              currency: e.currency,
              "min-fraction-digits": e.minFractionDigits,
              "max-fraction-digits": e.maxFractionDigits,
              class: Pe(["d-base-input__input-number", w.value]),
              "aria-label": e.ariaLabel,
              placeholder: e.placeholder,
              disabled: e.disabled,
              onKeyup: v,
              onClick: g
            }, null, 8, ["modelValue", "input-id", "name", "locale", "mode", "suffix", "prefix", "min", "max", "currency", "min-fraction-digits", "max-fraction-digits", "class", "aria-label", "placeholder", "disabled"])) : te("", !0),
            e.inputType === _(_n).Password ? (E(), fe(_(uC), {
              key: 4,
              modelValue: s.value,
              "onUpdate:modelValue": k[3] || (k[3] = (j) => s.value = j),
              "input-id": y.value,
              name: y.value,
              class: Pe(["d-base-input__password", w.value]),
              "aria-label": e.ariaLabel,
              placeholder: e.placeholder,
              disabled: e.disabled,
              "toggle-mask": "",
              feedback: !1,
              "show-icon": "las la-" + _(H).Eye,
              "hide-icon": "las la-" + _(H).EyeSlash,
              onChange: h,
              onKeyup: v,
              onBlur: c,
              onClick: g
            }, null, 8, ["modelValue", "input-id", "name", "class", "aria-label", "placeholder", "disabled", "show-icon", "hide-icon"])) : te("", !0),
            e.inputType === _(_n).Textarea ? (E(), fe(_(hC), {
              key: 5,
              id: y.value,
              modelValue: s.value,
              "onUpdate:modelValue": k[4] || (k[4] = (j) => s.value = j),
              name: y.value,
              class: Pe(["d-base-input__textarea", w.value]),
              "aria-label": e.ariaLabel,
              placeholder: e.placeholder,
              disabled: e.disabled,
              onChange: h,
              onKeyup: v,
              onBlur: c,
              onClick: g
            }, null, 8, ["id", "modelValue", "name", "class", "aria-label", "placeholder", "disabled"])) : te("", !0),
            e.inputType === _(_n).Date ? (E(), fe(VU, {
              key: 6,
              modelValue: s.value,
              "onUpdate:modelValue": k[5] || (k[5] = (j) => s.value = j),
              "input-id": y.value,
              class: Pe(["d-base-input__date", w.value]),
              "aria-label": e.ariaLabel,
              placeholder: e.placeholder,
              "min-date": e.minDate,
              "max-date": e.maxDate,
              disabled: e.disabled,
              onChange: h,
              onKeyup: v,
              onBlur: c,
              onClick: g,
              onShow: S
            }, {
              dropdownicon: Se(() => [
                ue(A, {
                  "base-icon": _(H).CalendarAlt,
                  "base-icon-size": _(at).S,
                  "aria-label": e.ariaLabel
                }, null, 8, ["base-icon", "base-icon-size", "aria-label"])
              ]),
              _: 1
            }, 8, ["modelValue", "input-id", "class", "aria-label", "placeholder", "min-date", "max-date", "disabled"])) : te("", !0),
            je(x.$slots, "right-icon", {}, () => [
              e.rightIcon || e.state === _(Ht).Invalid || e.state === _(Ht).Valid ? (E(), X("span", xW, [
                e.rightIcon && e.state === _(Ht).Default ? (E(), fe(A, {
                  key: 0,
                  "base-icon": e.rightIcon,
                  "base-icon-color": e.rightIconFilled ? _(gt).White : _(gt).Petrol45,
                  "base-icon-size": _(at).Inherit,
                  "base-icon-filled": e.rightIconFilled,
                  onClick: f
                }, null, 8, ["base-icon", "base-icon-color", "base-icon-size", "base-icon-filled"])) : te("", !0),
                e.state !== _(Ht).Default ? (E(), fe(A, {
                  key: 1,
                  "base-icon": e.state === _(Ht).Valid ? _(H).CheckCircle : _(H).ExclamationTriangle,
                  "base-icon-color": e.state === _(Ht).Valid ? _(gt).Positive : _(gt).Negative,
                  "base-icon-size": _(at).Inherit
                }, null, 8, ["base-icon", "base-icon-color", "base-icon-size"])) : te("", !0)
              ])) : te("", !0)
            ], !0)
          ], 2)
        ], 2),
        e.errorText && e.state === _(Ht).Invalid ? (E(), fe($, {
          key: 0,
          text: e.errorText,
          "font-size": _(st).TwelvePx,
          "text-color": m.value,
          "font-type": _(lt).DwsSlabBold,
          class: "d-base-input__error-text"
        }, null, 8, ["text", "font-size", "text-color", "font-type"])) : te("", !0)
      ], 8, gW);
    };
  }
});
const Es = /* @__PURE__ */ Fe(wW, [["__scopeId", "data-v-4207458f"]]);
var on = /* @__PURE__ */ ((e) => (e.Original = "original", e.TwoToOne = "two-to-one", e.OneToOne = "one-to-one", e.SixteenToNine = "sixteen-to-nine", e.None = "none", e))(on || {}), kW = Object.defineProperty, SW = Object.defineProperties, CW = Object.getOwnPropertyDescriptors, Jb = Object.getOwnPropertySymbols, TW = Object.prototype.hasOwnProperty, LW = Object.prototype.propertyIsEnumerable, Qb = (e, t, n) => t in e ? kW(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, IW = (e, t) => {
  for (var n in t || (t = {}))
    TW.call(t, n) && Qb(e, n, t[n]);
  if (Jb)
    for (var n of Jb(t))
      LW.call(t, n) && Qb(e, n, t[n]);
  return e;
}, PW = (e, t) => SW(e, CW(t)), AW = {
  props: {
    src: {
      type: String,
      required: !0
    },
    srcPlaceholder: {
      type: String,
      default: "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
    },
    srcset: {
      type: String
    },
    intersectionOptions: {
      type: Object,
      default: () => ({})
    },
    usePicture: {
      type: Boolean,
      default: !1
    }
  },
  inheritAttrs: !1,
  setup(e, { attrs: t, slots: n, emit: i }) {
    const o = ge(null), a = Qi({
      observer: null,
      intersected: !1,
      loaded: !1
    }), r = Te(() => a.intersected && e.src ? e.src : e.srcPlaceholder), s = Te(() => a.intersected && e.srcset ? e.srcset : !1), l = () => {
      o.value && o.value.getAttribute("src") !== e.srcPlaceholder && (a.loaded = !0, i("load", o.value));
    }, d = () => i("error", o.value);
    return it(() => {
      "IntersectionObserver" in window && (a.observer = new IntersectionObserver((y) => {
        y[0].isIntersecting && (a.intersected = !0, a.observer.disconnect(), i("intersect"));
      }, e.intersectionOptions), a.observer.observe(o.value));
    }), Fa(() => {
      "IntersectionObserver" in window && a.observer && a.observer.disconnect();
    }), () => {
      const y = At("img", PW(IW({
        ref: o,
        src: r.value,
        srcset: s.value || null
      }, t), {
        class: [
          t.class,
          "v-lazy-image",
          { "v-lazy-image-loaded": a.loaded }
        ],
        onLoad: l,
        onError: d
      }));
      return e.usePicture ? At("picture", { ref: o, onLoad: l }, a.intersected ? [n.default, y] : [y]) : y;
    };
  }
};
const _W = ["aria-hidden"], e0 = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=", MW = /* @__PURE__ */ Be({
  __name: "BaseImage",
  props: {
    model: {
      type: Object,
      default: null
    },
    responsiveOptions: {
      type: Array,
      default: () => []
    },
    aspectRatio: {
      type: String,
      default: on.TwoToOne
    },
    calculateWidth: {
      type: Boolean,
      default: !0
    },
    active: {
      type: Boolean,
      default: !0
    },
    roundedCorner: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["loaded"],
  setup(e, { emit: t }) {
    const n = e, { currentBreakpoint: i } = xt(), { elementWidth: o, elementHeight: a, registerObserver: r } = Jx(), s = ge(), l = ge(e0), d = ge(""), y = ge(void 0), u = ge(void 0), m = ge(n.responsiveOptions), h = ge(), c = ge(), g = t, v = () => {
      r(s.value?.parentElement);
      const I = p(Ct.Xs);
      I && (d.value = I, D(), n.active && (u.value = "loaded", y.value = !0));
    };
    it(() => {
      v();
    });
    const P = (I, R) => {
      g("loaded", I, R);
    }, f = Te(() => Object.entries(Ct).find(
      ([I]) => I === i.value
    )?.[1]), S = () => w(f.value) || x(f.value) || C.value[C.value.length - 1], w = (I) => C.value?.find(
      (R) => R.dxBreakpoint === I
    ), x = (I) => C.value?.reduce((R, Y) => R.dxBreakpoint >= I ? Y : R), k = () => {
      if (m.value) {
        const I = S();
        h.value = I.width, c.value = I.height;
      }
    }, A = (I) => {
      let R = I.clientWidth;
      return R === 0 && I.parentElement && (R = A(I.parentElement)), R;
    }, $ = (I) => {
      let R = I.clientHeight;
      return R === 0 && I.parentElement && (R = $(I.parentElement)), R;
    }, j = (I) => new Promise((R, Y) => {
      const F = new Image();
      F.onload = () => R(F), F.onerror = () => Y(), F.src = I;
    }), N = async () => {
      const I = await j(n.model.src);
      return I.width / I.height;
    }, M = async () => {
      const I = s.value?.parentElement;
      if (I) {
        switch (h.value = n.model.maxWidth ?? A(I), n.aspectRatio) {
          case on.TwoToOne:
            c.value = Math.round(h.value / 2);
            break;
          case on.SixteenToNine:
            c.value = Math.round(h.value / 1.7777777778);
            break;
          case on.OneToOne:
            c.value = h.value;
            break;
          case on.Original:
            c.value = Math.round(
              h.value / await N()
            );
            break;
          default:
            c.value = $(I);
            break;
        }
        const R = {
          width: h.value,
          height: c.value,
          dxBreakpoint: Ct.Xs
        }, Y = b(R);
        l.value = n.active ? Y : e0, d.value = Y, m.value = [R];
      }
    }, D = async () => {
      await mt(), n.calculateWidth ? Ue && window.requestAnimationFrame(() => {
        fi(() => {
          n.responsiveOptions && n.responsiveOptions.length > 0 ? k() : M();
        }, 100);
      }) : l.value = p(Ct.Xs);
    }, C = Te(() => m.value?.sort(
      (I, R) => I.dxBreakpoint > R.dxBreakpoint ? -1 : 1
    )), b = (I) => I ? `${n.model?.src + (n.model?.src?.indexOf("?") === -1 ? "?" : "&")}width=${I.width}&height=${I.height}` : n.model?.src || "", p = (I) => {
      if (!m.value || m.value.length === 0)
        return n.model?.src || "";
      const R = C.value, Y = R.find((F) => F.dxBreakpoint === I) || R[R.length - 1];
      return b(Y);
    }, L = (I) => {
      if (y.value)
        return p(I);
    }, B = Te(() => n.calculateWidth ? `d-base-image-ratio-${n.aspectRatio}` : void 0), T = Te(() => n.roundedCorner ? "d-base-image--rounded-corner" : void 0);
    qe(
      () => n.model,
      () => {
        v();
      }
    ), qe(
      () => n.active,
      (I) => {
        I && (D(), u.value = "loaded", y.value = !0);
      }
    ), qe(
      () => n.responsiveOptions,
      (I) => {
        I && (m.value = I);
      }
    );
    const O = Jn(() => {
      D();
    }, 100);
    return qe(
      () => [a.value, o.value],
      () => {
        O();
      }
    ), (I, R) => e.model?.src ? (E(), X("picture", {
      key: 0,
      ref_key: "pictureRef",
      ref: s,
      class: Pe(["d-base-image", [B.value, T.value]]),
      "aria-hidden": !e.model?.alt || e.model?.alt === ""
    }, [
      ue(_(AW), {
        alt: e.model?.alt,
        title: e.model?.title,
        class: Pe(u.value),
        "data-src": d.value,
        src: l.value,
        "data-was-processed": y.value,
        width: h.value,
        height: c.value,
        srcset: L(f.value),
        "data-chromatic": "ignore",
        onLoad: R[0] || (R[0] = (Y) => P(Y, e.model))
      }, null, 8, ["alt", "title", "class", "data-src", "src", "data-was-processed", "width", "height", "srcset"])
    ], 10, _W)) : te("", !0);
  }
});
const di = /* @__PURE__ */ Fe(MW, [["__scopeId", "data-v-6818443b"]]), fC = /* @__PURE__ */ Be({
  __name: "BaseToast",
  setup(e) {
    return (t, n) => {
      const i = $e("BaseIcon"), o = $e("PrimeToast");
      return E(), fe(o, {
        class: "d-base-toast",
        "error-icon": "las la-trash-alt",
        "success-icon": "las la-check",
        pt: {
          detail: { class: "d-base-toast__detail" },
          button: { class: "d-base-toast__button" }
        }
      }, {
        closeicon: Se(() => [
          ue(i, {
            "base-icon": _(H).TimesCircle,
            "base-icon-size": _(at).Inherit,
            "base-icon-color": _(gt).GreyBlue008,
            class: "d-base-toast__close-icon"
          }, null, 8, ["base-icon", "base-icon-size", "base-icon-color"])
        ]),
        _: 1
      });
    };
  }
});
var bl = /* @__PURE__ */ ((e) => (e.ComponentProps = "component-props", e.SlotAsText = "slot-as-text", e.SlotAsOverlayText = "slot-as-overlay-text", e))(bl || {});
const OW = /* @__PURE__ */ Be({
  __name: "GlossaryItem",
  props: {
    itemText: {
      type: String,
      required: !1,
      default: ""
    },
    itemOverlayText: {
      type: String,
      required: !1,
      default: ""
    },
    footnoteReferenceId: {
      type: String,
      default: void 0
    },
    type: {
      type: String,
      required: !1,
      default: bl.ComponentProps
    }
  },
  setup(e) {
    const t = e, n = ge(), i = ge(t.itemText), o = ge(t.itemOverlayText), a = Jt(), r = Te(() => a.default && a.default());
    qe(
      () => r.value,
      (l) => {
        t.type !== bl.ComponentProps && l?.length > 0 && l[0]?.type?.toString() === "Symbol(v-txt)" && l[0]?.children && (t.type === bl.SlotAsText ? i.value = l[0].children.toString() : t.type === bl.SlotAsOverlayText && (o.value = l[0].children.toString()));
      },
      { immediate: !0, deep: !0 }
    ), it(() => {
      o.value && pn({
        trigger: n,
        headline: s(),
        content: o.value,
        appendTo: "parent",
        showOnTouchDevices: !0,
        field: () => n,
        manuallyOverlayType: ms.InfoOverlay
      });
    });
    const s = () => {
      const l = i?.value?.indexOf("{{");
      return l !== -1 ? i?.value?.slice(0, l) : i?.value;
    };
    return (l, d) => i.value ? (E(), X("span", {
      key: 0,
      ref_key: "glossaryItemRef",
      ref: n,
      class: "d-glossary-item"
    }, [
      ue(li, {
        "foot-note-id": e.footnoteReferenceId,
        text: i.value
      }, null, 8, ["foot-note-id", "text"])
    ], 512)) : te("", !0);
  }
});
const tu = /* @__PURE__ */ Fe(OW, [["__scopeId", "data-v-9c379d3b"]]);
function BW() {
  this.__data__ = [], this.size = 0;
}
var EW = BW;
function DW(e, t) {
  return e === t || e !== e && t !== t;
}
var ed = DW, RW = ed;
function NW(e, t) {
  for (var n = e.length; n--; )
    if (RW(e[n][0], t))
      return n;
  return -1;
}
var gh = NW, $W = gh, FW = Array.prototype, jW = FW.splice;
function HW(e) {
  var t = this.__data__, n = $W(t, e);
  if (n < 0)
    return !1;
  var i = t.length - 1;
  return n == i ? t.pop() : jW.call(t, n, 1), --this.size, !0;
}
var zW = HW, VW = gh;
function GW(e) {
  var t = this.__data__, n = VW(t, e);
  return n < 0 ? void 0 : t[n][1];
}
var UW = GW, WW = gh;
function YW(e) {
  return WW(this.__data__, e) > -1;
}
var qW = YW, KW = gh;
function XW(e, t) {
  var n = this.__data__, i = KW(n, e);
  return i < 0 ? (++this.size, n.push([e, t])) : n[i][1] = t, this;
}
var ZW = XW, JW = EW, QW = zW, eY = UW, tY = qW, nY = ZW;
function Ds(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++t < n; ) {
    var i = e[t];
    this.set(i[0], i[1]);
  }
}
Ds.prototype.clear = JW;
Ds.prototype.delete = QW;
Ds.prototype.get = eY;
Ds.prototype.has = tY;
Ds.prototype.set = nY;
var vh = Ds, iY = vh;
function aY() {
  this.__data__ = new iY(), this.size = 0;
}
var oY = aY;
function rY(e) {
  var t = this.__data__, n = t.delete(e);
  return this.size = t.size, n;
}
var sY = rY;
function lY(e) {
  return this.__data__.get(e);
}
var cY = lY;
function dY(e) {
  return this.__data__.has(e);
}
var uY = dY, hY = typeof rn == "object" && rn && rn.Object === Object && rn, mC = hY, pY = mC, fY = typeof self == "object" && self && self.Object === Object && self, mY = pY || fY || Function("return this")(), wa = mY, gY = wa, vY = gY.Symbol, td = vY, t0 = td, gC = Object.prototype, yY = gC.hasOwnProperty, bY = gC.toString, cl = t0 ? t0.toStringTag : void 0;
function xY(e) {
  var t = yY.call(e, cl), n = e[cl];
  try {
    e[cl] = void 0;
    var i = !0;
  } catch {
  }
  var o = bY.call(e);
  return i && (t ? e[cl] = n : delete e[cl]), o;
}
var wY = xY, kY = Object.prototype, SY = kY.toString;
function CY(e) {
  return SY.call(e);
}
var TY = CY, n0 = td, LY = wY, IY = TY, PY = "[object Null]", AY = "[object Undefined]", i0 = n0 ? n0.toStringTag : void 0;
function _Y(e) {
  return e == null ? e === void 0 ? AY : PY : i0 && i0 in Object(e) ? LY(e) : IY(e);
}
var Rs = _Y;
function MY(e) {
  var t = typeof e;
  return e != null && (t == "object" || t == "function");
}
var Wa = MY, OY = Rs, BY = Wa, EY = "[object AsyncFunction]", DY = "[object Function]", RY = "[object GeneratorFunction]", NY = "[object Proxy]";
function $Y(e) {
  if (!BY(e))
    return !1;
  var t = OY(e);
  return t == DY || t == RY || t == EY || t == NY;
}
var wg = $Y, FY = wa, jY = FY["__core-js_shared__"], HY = jY, xp = HY, a0 = function() {
  var e = /[^.]+$/.exec(xp && xp.keys && xp.keys.IE_PROTO || "");
  return e ? "Symbol(src)_1." + e : "";
}();
function zY(e) {
  return !!a0 && a0 in e;
}
var VY = zY, GY = Function.prototype, UY = GY.toString;
function WY(e) {
  if (e != null) {
    try {
      return UY.call(e);
    } catch {
    }
    try {
      return e + "";
    } catch {
    }
  }
  return "";
}
var vC = WY, YY = wg, qY = VY, KY = Wa, XY = vC, ZY = /[\\^$.*+?()[\]{}|]/g, JY = /^\[object .+?Constructor\]$/, QY = Function.prototype, eq = Object.prototype, tq = QY.toString, nq = eq.hasOwnProperty, iq = RegExp(
  "^" + tq.call(nq).replace(ZY, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function aq(e) {
  if (!KY(e) || qY(e))
    return !1;
  var t = YY(e) ? iq : JY;
  return t.test(XY(e));
}
var oq = aq;
function rq(e, t) {
  return e?.[t];
}
var sq = rq, lq = oq, cq = sq;
function dq(e, t) {
  var n = cq(e, t);
  return lq(n) ? n : void 0;
}
var Er = dq, uq = Er, hq = wa, pq = uq(hq, "Map"), kg = pq, fq = Er, mq = fq(Object, "create"), yh = mq, o0 = yh;
function gq() {
  this.__data__ = o0 ? o0(null) : {}, this.size = 0;
}
var vq = gq;
function yq(e) {
  var t = this.has(e) && delete this.__data__[e];
  return this.size -= t ? 1 : 0, t;
}
var bq = yq, xq = yh, wq = "__lodash_hash_undefined__", kq = Object.prototype, Sq = kq.hasOwnProperty;
function Cq(e) {
  var t = this.__data__;
  if (xq) {
    var n = t[e];
    return n === wq ? void 0 : n;
  }
  return Sq.call(t, e) ? t[e] : void 0;
}
var Tq = Cq, Lq = yh, Iq = Object.prototype, Pq = Iq.hasOwnProperty;
function Aq(e) {
  var t = this.__data__;
  return Lq ? t[e] !== void 0 : Pq.call(t, e);
}
var _q = Aq, Mq = yh, Oq = "__lodash_hash_undefined__";
function Bq(e, t) {
  var n = this.__data__;
  return this.size += this.has(e) ? 0 : 1, n[e] = Mq && t === void 0 ? Oq : t, this;
}
var Eq = Bq, Dq = vq, Rq = bq, Nq = Tq, $q = _q, Fq = Eq;
function Ns(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++t < n; ) {
    var i = e[t];
    this.set(i[0], i[1]);
  }
}
Ns.prototype.clear = Dq;
Ns.prototype.delete = Rq;
Ns.prototype.get = Nq;
Ns.prototype.has = $q;
Ns.prototype.set = Fq;
var jq = Ns, r0 = jq, Hq = vh, zq = kg;
function Vq() {
  this.size = 0, this.__data__ = {
    hash: new r0(),
    map: new (zq || Hq)(),
    string: new r0()
  };
}
var Gq = Vq;
function Uq(e) {
  var t = typeof e;
  return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? e !== "__proto__" : e === null;
}
var Wq = Uq, Yq = Wq;
function qq(e, t) {
  var n = e.__data__;
  return Yq(t) ? n[typeof t == "string" ? "string" : "hash"] : n.map;
}
var bh = qq, Kq = bh;
function Xq(e) {
  var t = Kq(this, e).delete(e);
  return this.size -= t ? 1 : 0, t;
}
var Zq = Xq, Jq = bh;
function Qq(e) {
  return Jq(this, e).get(e);
}
var eK = Qq, tK = bh;
function nK(e) {
  return tK(this, e).has(e);
}
var iK = nK, aK = bh;
function oK(e, t) {
  var n = aK(this, e), i = n.size;
  return n.set(e, t), this.size += n.size == i ? 0 : 1, this;
}
var rK = oK, sK = Gq, lK = Zq, cK = eK, dK = iK, uK = rK;
function $s(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++t < n; ) {
    var i = e[t];
    this.set(i[0], i[1]);
  }
}
$s.prototype.clear = sK;
$s.prototype.delete = lK;
$s.prototype.get = cK;
$s.prototype.has = dK;
$s.prototype.set = uK;
var Sg = $s, hK = vh, pK = kg, fK = Sg, mK = 200;
function gK(e, t) {
  var n = this.__data__;
  if (n instanceof hK) {
    var i = n.__data__;
    if (!pK || i.length < mK - 1)
      return i.push([e, t]), this.size = ++n.size, this;
    n = this.__data__ = new fK(i);
  }
  return n.set(e, t), this.size = n.size, this;
}
var vK = gK, yK = vh, bK = oY, xK = sY, wK = cY, kK = uY, SK = vK;
function Fs(e) {
  var t = this.__data__ = new yK(e);
  this.size = t.size;
}
Fs.prototype.clear = bK;
Fs.prototype.delete = xK;
Fs.prototype.get = wK;
Fs.prototype.has = kK;
Fs.prototype.set = SK;
var xh = Fs, CK = Er, TK = function() {
  try {
    var e = CK(Object, "defineProperty");
    return e({}, "", {}), e;
  } catch {
  }
}(), yC = TK, s0 = yC;
function LK(e, t, n) {
  t == "__proto__" && s0 ? s0(e, t, {
    configurable: !0,
    enumerable: !0,
    value: n,
    writable: !0
  }) : e[t] = n;
}
var Cg = LK, IK = Cg, PK = ed;
function AK(e, t, n) {
  (n !== void 0 && !PK(e[t], n) || n === void 0 && !(t in e)) && IK(e, t, n);
}
var bC = AK;
function _K(e) {
  return function(t, n, i) {
    for (var o = -1, a = Object(t), r = i(t), s = r.length; s--; ) {
      var l = r[e ? s : ++o];
      if (n(a[l], l, a) === !1)
        break;
    }
    return t;
  };
}
var MK = _K, OK = MK, BK = OK(), xC = BK, Iu = { exports: {} };
Iu.exports;
(function(e, t) {
  var n = wa, i = t && !t.nodeType && t, o = i && !0 && e && !e.nodeType && e, a = o && o.exports === i, r = a ? n.Buffer : void 0, s = r ? r.allocUnsafe : void 0;
  function l(d, y) {
    if (y)
      return d.slice();
    var u = d.length, m = s ? s(u) : new d.constructor(u);
    return d.copy(m), m;
  }
  e.exports = l;
})(Iu, Iu.exports);
var wC = Iu.exports, EK = wa, DK = EK.Uint8Array, kC = DK, l0 = kC;
function RK(e) {
  var t = new e.constructor(e.byteLength);
  return new l0(t).set(new l0(e)), t;
}
var Tg = RK, NK = Tg;
function $K(e, t) {
  var n = t ? NK(e.buffer) : e.buffer;
  return new e.constructor(n, e.byteOffset, e.length);
}
var SC = $K;
function FK(e, t) {
  var n = -1, i = e.length;
  for (t || (t = Array(i)); ++n < i; )
    t[n] = e[n];
  return t;
}
var CC = FK, jK = Wa, c0 = Object.create, HK = function() {
  function e() {
  }
  return function(t) {
    if (!jK(t))
      return {};
    if (c0)
      return c0(t);
    e.prototype = t;
    var n = new e();
    return e.prototype = void 0, n;
  };
}(), zK = HK;
function VK(e, t) {
  return function(n) {
    return e(t(n));
  };
}
var TC = VK, GK = TC, UK = GK(Object.getPrototypeOf, Object), Lg = UK, WK = Object.prototype;
function YK(e) {
  var t = e && e.constructor, n = typeof t == "function" && t.prototype || WK;
  return e === n;
}
var Ig = YK, qK = zK, KK = Lg, XK = Ig;
function ZK(e) {
  return typeof e.constructor == "function" && !XK(e) ? qK(KK(e)) : {};
}
var LC = ZK;
function JK(e) {
  return e != null && typeof e == "object";
}
var go = JK, QK = Rs, eX = go, tX = "[object Arguments]";
function nX(e) {
  return eX(e) && QK(e) == tX;
}
var iX = nX, d0 = iX, aX = go, IC = Object.prototype, oX = IC.hasOwnProperty, rX = IC.propertyIsEnumerable, sX = d0(function() {
  return arguments;
}()) ? d0 : function(e) {
  return aX(e) && oX.call(e, "callee") && !rX.call(e, "callee");
}, Pg = sX, lX = Array.isArray, oa = lX, cX = 9007199254740991;
function dX(e) {
  return typeof e == "number" && e > -1 && e % 1 == 0 && e <= cX;
}
var Ag = dX, uX = wg, hX = Ag;
function pX(e) {
  return e != null && hX(e.length) && !uX(e);
}
var js = pX, fX = js, mX = go;
function gX(e) {
  return mX(e) && fX(e);
}
var vX = gX, Pu = { exports: {} };
function yX() {
  return !1;
}
var bX = yX;
Pu.exports;
(function(e, t) {
  var n = wa, i = bX, o = t && !t.nodeType && t, a = o && !0 && e && !e.nodeType && e, r = a && a.exports === o, s = r ? n.Buffer : void 0, l = s ? s.isBuffer : void 0, d = l || i;
  e.exports = d;
})(Pu, Pu.exports);
var wh = Pu.exports, xX = Rs, wX = Lg, kX = go, SX = "[object Object]", CX = Function.prototype, TX = Object.prototype, PC = CX.toString, LX = TX.hasOwnProperty, IX = PC.call(Object);
function PX(e) {
  if (!kX(e) || xX(e) != SX)
    return !1;
  var t = wX(e);
  if (t === null)
    return !0;
  var n = LX.call(t, "constructor") && t.constructor;
  return typeof n == "function" && n instanceof n && PC.call(n) == IX;
}
var AX = PX, _X = Rs, MX = Ag, OX = go, BX = "[object Arguments]", EX = "[object Array]", DX = "[object Boolean]", RX = "[object Date]", NX = "[object Error]", $X = "[object Function]", FX = "[object Map]", jX = "[object Number]", HX = "[object Object]", zX = "[object RegExp]", VX = "[object Set]", GX = "[object String]", UX = "[object WeakMap]", WX = "[object ArrayBuffer]", YX = "[object DataView]", qX = "[object Float32Array]", KX = "[object Float64Array]", XX = "[object Int8Array]", ZX = "[object Int16Array]", JX = "[object Int32Array]", QX = "[object Uint8Array]", eZ = "[object Uint8ClampedArray]", tZ = "[object Uint16Array]", nZ = "[object Uint32Array]", vn = {};
vn[qX] = vn[KX] = vn[XX] = vn[ZX] = vn[JX] = vn[QX] = vn[eZ] = vn[tZ] = vn[nZ] = !0;
vn[BX] = vn[EX] = vn[WX] = vn[DX] = vn[YX] = vn[RX] = vn[NX] = vn[$X] = vn[FX] = vn[jX] = vn[HX] = vn[zX] = vn[VX] = vn[GX] = vn[UX] = !1;
function iZ(e) {
  return OX(e) && MX(e.length) && !!vn[_X(e)];
}
var aZ = iZ;
function oZ(e) {
  return function(t) {
    return e(t);
  };
}
var _g = oZ, Au = { exports: {} };
Au.exports;
(function(e, t) {
  var n = mC, i = t && !t.nodeType && t, o = i && !0 && e && !e.nodeType && e, a = o && o.exports === i, r = a && n.process, s = function() {
    try {
      var l = o && o.require && o.require("util").types;
      return l || r && r.binding && r.binding("util");
    } catch {
    }
  }();
  e.exports = s;
})(Au, Au.exports);
var Mg = Au.exports, rZ = aZ, sZ = _g, u0 = Mg, h0 = u0 && u0.isTypedArray, lZ = h0 ? sZ(h0) : rZ, Og = lZ;
function cZ(e, t) {
  if (!(t === "constructor" && typeof e[t] == "function") && t != "__proto__")
    return e[t];
}
var AC = cZ, dZ = Cg, uZ = ed, hZ = Object.prototype, pZ = hZ.hasOwnProperty;
function fZ(e, t, n) {
  var i = e[t];
  (!(pZ.call(e, t) && uZ(i, n)) || n === void 0 && !(t in e)) && dZ(e, t, n);
}
var _C = fZ, mZ = _C, gZ = Cg;
function vZ(e, t, n, i) {
  var o = !n;
  n || (n = {});
  for (var a = -1, r = t.length; ++a < r; ) {
    var s = t[a], l = i ? i(n[s], e[s], s, n, e) : void 0;
    l === void 0 && (l = e[s]), o ? gZ(n, s, l) : mZ(n, s, l);
  }
  return n;
}
var nd = vZ;
function yZ(e, t) {
  for (var n = -1, i = Array(e); ++n < e; )
    i[n] = t(n);
  return i;
}
var bZ = yZ, xZ = 9007199254740991, wZ = /^(?:0|[1-9]\d*)$/;
function kZ(e, t) {
  var n = typeof e;
  return t = t ?? xZ, !!t && (n == "number" || n != "symbol" && wZ.test(e)) && e > -1 && e % 1 == 0 && e < t;
}
var Bg = kZ, SZ = bZ, CZ = Pg, TZ = oa, LZ = wh, IZ = Bg, PZ = Og, AZ = Object.prototype, _Z = AZ.hasOwnProperty;
function MZ(e, t) {
  var n = TZ(e), i = !n && CZ(e), o = !n && !i && LZ(e), a = !n && !i && !o && PZ(e), r = n || i || o || a, s = r ? SZ(e.length, String) : [], l = s.length;
  for (var d in e)
    (t || _Z.call(e, d)) && !(r && // Safari 9 has enumerable `arguments.length` in strict mode.
    (d == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    o && (d == "offset" || d == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    a && (d == "buffer" || d == "byteLength" || d == "byteOffset") || // Skip index properties.
    IZ(d, l))) && s.push(d);
  return s;
}
var MC = MZ;
function OZ(e) {
  var t = [];
  if (e != null)
    for (var n in Object(e))
      t.push(n);
  return t;
}
var BZ = OZ, EZ = Wa, DZ = Ig, RZ = BZ, NZ = Object.prototype, $Z = NZ.hasOwnProperty;
function FZ(e) {
  if (!EZ(e))
    return RZ(e);
  var t = DZ(e), n = [];
  for (var i in e)
    i == "constructor" && (t || !$Z.call(e, i)) || n.push(i);
  return n;
}
var jZ = FZ, HZ = MC, zZ = jZ, VZ = js;
function GZ(e) {
  return VZ(e) ? HZ(e, !0) : zZ(e);
}
var id = GZ, UZ = nd, WZ = id;
function YZ(e) {
  return UZ(e, WZ(e));
}
var qZ = YZ, p0 = bC, KZ = wC, XZ = SC, ZZ = CC, JZ = LC, f0 = Pg, m0 = oa, QZ = vX, eJ = wh, tJ = wg, nJ = Wa, iJ = AX, aJ = Og, g0 = AC, oJ = qZ;
function rJ(e, t, n, i, o, a, r) {
  var s = g0(e, n), l = g0(t, n), d = r.get(l);
  if (d) {
    p0(e, n, d);
    return;
  }
  var y = a ? a(s, l, n + "", e, t, r) : void 0, u = y === void 0;
  if (u) {
    var m = m0(l), h = !m && eJ(l), c = !m && !h && aJ(l);
    y = l, m || h || c ? m0(s) ? y = s : QZ(s) ? y = ZZ(s) : h ? (u = !1, y = KZ(l, !0)) : c ? (u = !1, y = XZ(l, !0)) : y = [] : iJ(l) || f0(l) ? (y = s, f0(s) ? y = oJ(s) : (!nJ(s) || tJ(s)) && (y = JZ(l))) : u = !1;
  }
  u && (r.set(l, y), o(y, l, i, a, r), r.delete(l)), p0(e, n, y);
}
var sJ = rJ, lJ = xh, cJ = bC, dJ = xC, uJ = sJ, hJ = Wa, pJ = id, fJ = AC;
function OC(e, t, n, i, o) {
  e !== t && dJ(t, function(a, r) {
    if (o || (o = new lJ()), hJ(a))
      uJ(e, t, r, n, OC, i, o);
    else {
      var s = i ? i(fJ(e, r), a, r + "", e, t, o) : void 0;
      s === void 0 && (s = a), cJ(e, r, s);
    }
  }, pJ);
}
var mJ = OC;
function gJ(e) {
  return e;
}
var Eg = gJ;
function vJ(e, t, n) {
  switch (n.length) {
    case 0:
      return e.call(t);
    case 1:
      return e.call(t, n[0]);
    case 2:
      return e.call(t, n[0], n[1]);
    case 3:
      return e.call(t, n[0], n[1], n[2]);
  }
  return e.apply(t, n);
}
var yJ = vJ, bJ = yJ, v0 = Math.max;
function xJ(e, t, n) {
  return t = v0(t === void 0 ? e.length - 1 : t, 0), function() {
    for (var i = arguments, o = -1, a = v0(i.length - t, 0), r = Array(a); ++o < a; )
      r[o] = i[t + o];
    o = -1;
    for (var s = Array(t + 1); ++o < t; )
      s[o] = i[o];
    return s[t] = n(r), bJ(e, this, s);
  };
}
var wJ = xJ;
function kJ(e) {
  return function() {
    return e;
  };
}
var SJ = kJ, CJ = SJ, y0 = yC, TJ = Eg, LJ = y0 ? function(e, t) {
  return y0(e, "toString", {
    configurable: !0,
    enumerable: !1,
    value: CJ(t),
    writable: !0
  });
} : TJ, IJ = LJ, PJ = 800, AJ = 16, _J = Date.now;
function MJ(e) {
  var t = 0, n = 0;
  return function() {
    var i = _J(), o = AJ - (i - n);
    if (n = i, o > 0) {
      if (++t >= PJ)
        return arguments[0];
    } else
      t = 0;
    return e.apply(void 0, arguments);
  };
}
var OJ = MJ, BJ = IJ, EJ = OJ, DJ = EJ(BJ), RJ = DJ, NJ = Eg, $J = wJ, FJ = RJ;
function jJ(e, t) {
  return FJ($J(e, t, NJ), e + "");
}
var HJ = jJ, zJ = ed, VJ = js, GJ = Bg, UJ = Wa;
function WJ(e, t, n) {
  if (!UJ(n))
    return !1;
  var i = typeof t;
  return (i == "number" ? VJ(n) && GJ(t, n.length) : i == "string" && t in n) ? zJ(n[t], e) : !1;
}
var YJ = WJ, qJ = HJ, KJ = YJ;
function XJ(e) {
  return qJ(function(t, n) {
    var i = -1, o = n.length, a = o > 1 ? n[o - 1] : void 0, r = o > 2 ? n[2] : void 0;
    for (a = e.length > 3 && typeof a == "function" ? (o--, a) : void 0, r && KJ(n[0], n[1], r) && (a = o < 3 ? void 0 : a, o = 1), t = Object(t); ++i < o; ) {
      var s = n[i];
      s && e(t, s, i, a);
    }
    return t;
  });
}
var ZJ = XJ, JJ = mJ, QJ = ZJ, eQ = QJ(function(e, t, n) {
  JJ(e, t, n);
}), tQ = eQ;
const Af = /* @__PURE__ */ en(tQ), nQ = (e) => (e || (e = {}), e.baseImagePath = e.baseImagePath || "./", e.localesPrimeVue && e.localesPrimeVue.length > 0 ? sl.forEach((t) => {
  if (e?.localesPrimeVue && e.localesPrimeVue.length > 0) {
    const n = e?.localesPrimeVue?.findIndex(
      (o) => o.locale === t.locale
    ), i = sl.findIndex(
      (o) => o.locale === t.locale
    );
    e?.localesPrimeVue[n] ? e.localesPrimeVue[n] = Af(
      sl[i],
      e.localesPrimeVue[n]
    ) : e.localesPrimeVue.push(sl[i]);
  }
}) : e.localesPrimeVue = sl, e.serviceUrlOptions || (e.serviceUrlOptions = cG), e.translationOptions || (e.translationOptions = { locale: "de", fallbackLocale: "en" }), e.translationOptions.numberFormats || (e.translationOptions.numberFormats = ZS), (e.shouldUseColorCodingPerCulture === void 0 || e.shouldUseColorCodingPerCulture === null) && (e.shouldUseColorCodingPerCulture = !0), e.documentViewerConfig || (e.documentViewerConfig = { path: "/pdfjs-4.4.168-dist" }), e.htmlContentBlockWhitelist ? e.htmlContentBlockWhitelist = Af(dv, e.htmlContentBlockWhitelist) : e.htmlContentBlockWhitelist = dv, e), iQ = rs(ZP()), CBe = {
  install(e, t = void 0) {
    if (t = nQ(t), t.shouldUseColorCodingPerCulture && Ue) {
      const r = t.translationOptions.locale.toString().toLocaleLowerCase();
      r !== "en-gb" && r !== "en-ie" && document.querySelector("html")?.setAttribute("data-color-coding", "true");
    }
    const n = t?.translationOptions?.messages || {}, i = QV({
      locale: t?.translationOptions?.locale || "de",
      fallbackLocale: t?.translationOptions?.fallbackLocale || "en",
      numberFormats: t?.translationOptions?.numberFormats || { ...ZS },
      messages: Af(Bj, n),
      legacy: !1
      // needed for composition api
    });
    e.provide(Hx, i), e.provide(tw, t), Lt.extend(GH), Lt.extend(ks), Lt.extend(Ss);
    let o, a = "en";
    if (t?.translationOptions?.locale ? a = t?.translationOptions?.locale.toLocaleLowerCase() : t?.translationOptions?.fallbackLocale && (a = t?.translationOptions?.fallbackLocale.toLocaleLowerCase()), t?.localesPrimeVue && (o = t?.localesPrimeVue.find(
      (r) => r.locale.toLocaleLowerCase() === a
    )), !o && a.includes("-")) {
      const r = a.split("-")?.[0] || "";
      o = t?.localesPrimeVue?.find((s) => s.locale.toLowerCase() === r);
    }
    o || (o = t?.localesPrimeVue?.find(
      (r) => r.locale.toLocaleLowerCase() === t?.translationOptions?.fallbackLocale.toLocaleLowerCase()
    )), o || (o = t?.localesPrimeVue?.find(
      (r) => r.locale.toLocaleLowerCase() === "en"
    )), e.use(iQ).use(i).use(SH).use(zH).use(TH, { expires: 1 / 0, secure: !0 }).use($H).use(jH).use(MI, { locale: o }).use(fN).use(r5, {
      shareNetworks: {
        "email-link": "mailto:?body=@u%0D%0A@d"
      }
    }).component("PrimeToast", oS).component("ErrorBoundary", nS).component("BaseIcon", _t).component("BaseHeading", Ot).component("BaseVideoPlayer", yg).component("BaseLink", rU).component("BaseLinkV2", ot).component("baselinkv2", ot).component("BaseText", Tt).component("BaseButtonV2", vt).component("BaseRadioBox", DU).component("BaseCheckbox", bg).component("BaseInput", Es).component("BaseImage", di).component("baseimage", di).component("BaseToast", fC).component("GlossaryItem", tu).component("glossaryitem", tu).component("vue-glossary-item", tu).component("FootNote", ja).component("PageFootnoteReference", ma).component("pagefootnotereference", ma).component("PageFootnoteList", ro).component("pagefootnotelist", ro).component("BaseOverlay", Lk).provide("toast", e.config.globalProperties.$toast).provide("scrollHashUpdate", !0).provide("dayJS", Lt).directive("tooltip", Yu);
  }
}, aQ = { class: "d-base-range-slider" }, oQ = ["id", "name", "value", "min", "max", "step", "aria-label", "aria-labelledby", "aria-valuemin", "aria-valuemax", "aria-valuenow", "disabled"], rQ = { class: "d-base-range-slider__min" }, sQ = { class: "d-base-range-slider__max" }, lQ = /* @__PURE__ */ Be({
  __name: "BaseRangeSlider",
  props: {
    id: {
      type: String,
      default: void 0
    },
    value: {
      type: Number,
      default: 0
    },
    min: {
      type: Number,
      default: 0
    },
    max: {
      type: Number,
      default: 10
    },
    step: {
      type: Number,
      default: 1
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    ariaLabel: {
      type: String,
      default: void 0
    },
    ariaLabelledby: {
      type: String,
      default: void 0
    }
  },
  emits: ["input", "change"],
  setup(e, { emit: t }) {
    const n = e, { currentLocale: i } = Je(), o = t, a = ge(n.value), r = ge(), s = ge(), l = (c) => new Intl.NumberFormat(i.value.toString()).format(c), d = Te(() => l(n.min)), y = Te(() => l(n.max)), u = () => {
      (a.value < n.min || a.value > n.max || n.step >= n.max) && (a.value = n.min);
      const c = Math.round(
        (a.value - n.min) * 100 / (n.max - n.min)
      );
      s.value = `--progress: ${c}%;`;
    };
    it(() => {
      u();
    });
    const m = () => {
      o("change", Number(r.value?.value));
    }, h = () => {
      a.value = Number(r.value?.value), u(), o("input", a.value);
    };
    return qe(
      () => n.value,
      (c) => {
        a.value = c, u();
      }
    ), qe(
      () => [n.min, n.max, n.step],
      () => {
        u();
      }
    ), (c, g) => (E(), X("div", aQ, [
      oe("input", {
        id: e.id,
        ref_key: "inputRef",
        ref: r,
        name: e.id,
        type: "range",
        value: a.value,
        min: e.min,
        max: e.max,
        step: e.step,
        class: Pe(["d-base-range-slider__input", { "d-base-range-slider__input--disabled": e.disabled }]),
        style: hn(s.value),
        "aria-label": e.ariaLabel,
        "aria-labelledby": e.ariaLabelledby,
        "aria-valuemin": e.min,
        "aria-valuemax": e.max,
        "aria-valuenow": a.value,
        disabled: e.disabled,
        role: "slider",
        onChange: m,
        onInput: h
      }, null, 46, oQ),
      oe("div", {
        class: Pe(["d-base-range-slider__labels", { "d-base-range-slider__labels--disabled": e.disabled }])
      }, [
        oe("span", rQ, Ie(d.value), 1),
        oe("span", sQ, Ie(y.value), 1)
      ], 2)
    ]));
  }
});
const cQ = /* @__PURE__ */ Fe(lQ, [["__scopeId", "data-v-ef394e73"]]), dQ = {
  key: 0,
  class: "d-base-range-slider-input"
}, uQ = /* @__PURE__ */ Be({
  __name: "BaseRangeSliderInput",
  props: {
    value: {
      type: Number,
      default: void 0
    },
    min: {
      type: Number,
      default: 0
    },
    max: {
      type: Number,
      default: 10
    },
    step: {
      type: Number,
      default: 1
    },
    label: {
      type: String,
      default: void 0
    },
    placeholder: {
      type: String,
      default: void 0
    },
    helperText: {
      type: String,
      default: void 0
    },
    errorText: {
      type: String,
      default: void 0
    },
    numberPrefix: {
      type: String,
      default: void 0
    },
    numberSuffix: {
      type: String,
      default: void 0
    },
    validateStep: {
      type: Boolean,
      default: !0
    }
  },
  emits: ["changed"],
  setup(e, { emit: t }) {
    const n = e, i = t, o = ge(n.value), a = ge(Ht.Default), r = Te(() => {
      if (n.label)
        return `${n.label.toLowerCase().replace(/\W/g, "")}-label`;
    }), s = (y) => {
      const u = y >= n.min && y <= n.max && (n.validateStep ? y % n.step === 0 : !0);
      return u ? (a.value = Ht.Default, o.value = y) : a.value = Ht.Invalid, u;
    }, l = (y) => {
      s(y || n.min || 0) && i("changed", y || n.min || 0);
    }, d = (y) => {
      a.value = Ht.Default, o.value = y || n.min || 0, i("changed", o.value);
    };
    return it(() => {
      s(n.value || n.min || 0);
    }), qe(
      () => n.value,
      (y) => {
        o.value = y || n.min || 0, s(o.value);
      }
    ), (y, u) => o.value !== void 0 && o.value !== null ? (E(), X("div", dQ, [
      ue(Es, {
        label: e.label,
        "label-position": _(xg).Left,
        "input-type": _(_n).Number,
        "input-value": o.value,
        "number-mode": _(lC).Decimal,
        "number-prefix": e.numberPrefix,
        "number-suffix": e.numberSuffix,
        min: e.min,
        max: e.max,
        "min-fraction-digits": 0,
        "max-fraction-digits": 2,
        placeholder: e.placeholder,
        "helper-text": e.helperText,
        "error-text": e.errorText,
        state: a.value,
        onValueChanged: l
      }, null, 8, ["label", "label-position", "input-type", "input-value", "number-mode", "number-prefix", "number-suffix", "min", "max", "placeholder", "helper-text", "error-text", "state"]),
      ue(cQ, {
        value: o.value,
        min: e.min,
        max: e.max,
        step: e.step,
        "aria-labelledby": r.value,
        onInput: d
      }, null, 8, ["value", "min", "max", "step", "aria-labelledby"])
    ])) : te("", !0);
  }
});
const to = /* @__PURE__ */ Fe(uQ, [["__scopeId", "data-v-c5fe3e8d"]]), hQ = /* @__PURE__ */ Be({
  __name: "BaseShrinkPanel",
  props: {
    triggerElement: {
      type: Object,
      required: !0
    },
    appendTo: {
      type: String,
      required: !1,
      default: "#dx-overlay"
    },
    class: {
      type: String,
      required: !1,
      default: null
    }
  },
  emits: ["expanded", "collapsed"],
  setup(e, { emit: t }) {
    const n = e, i = ge(null), o = ge(!1), a = ge(null), { setShrinkPanel: r, isHeaderExpanded: s } = Fn(), l = t;
    qe(i, (m) => {
      m && r(m, n?.triggerElement);
    }), it(async () => {
      i.value && r(i.value, n?.triggerElement), Ue && (window.addEventListener("scroll", y, { passive: !0 }), a.value = new ResizeObserver(d), i.value && a.value.observe(i.value)), await mt(), await u();
    }), sn(() => {
      Ue && (window.removeEventListener("scroll", y), a.value.disconnect());
    });
    const d = Jn(
      () => {
        i.value && r(i.value, n?.triggerElement);
      },
      250,
      { maxWait: 500 }
    ), y = Jn(
      () => {
        u();
      },
      250,
      { maxWait: 500 }
    );
    qe(
      () => s(),
      (m) => {
        m ? i.value.classList.add("d-base-shrink-panel__extra-top") : i.value.classList.remove("d-base-shrink-panel__extra-top");
      }
    );
    async function u() {
      if (!Ue || !n?.triggerElement || !i.value)
        return;
      o.value = s(), await mt();
      const m = n?.triggerElement?.getBoundingClientRect()?.bottom;
      no("(max-width: 320px)").value || m >= 0 ? i.value?.classList.contains("d-base-shrink-panel__show-element") && (i.value?.classList.remove("d-base-shrink-panel__show-element"), l("collapsed")) : (i.value.classList.add("d-base-shrink-panel__show-element"), l("expanded"));
    }
    return (m, h) => (E(), fe(_(Yn), { "append-to": "#dx-overlay" }, {
      default: Se(() => [
        oe("div", {
          ref_key: "shrinkPanel",
          ref: i,
          class: Pe(["d-base-shrink-panel d-base-shrink-panel__show-element", {
            "d-base-shrink-panel__extra-top": _(s)(),
            [n.class]: n.class
          }]),
          role: "main"
        }, [
          je(m.$slots, "default", {}, void 0, !0)
        ], 2)
      ]),
      _: 3
    }));
  }
});
const BC = /* @__PURE__ */ Fe(hQ, [["__scopeId", "data-v-e342eb97"]]), pQ = {
  key: 0,
  class: "d-header-area"
}, fQ = {
  key: 1,
  class: "d-header-area__intro"
}, mQ = /* @__PURE__ */ Be({
  __name: "HeaderArea",
  props: {
    model: {
      type: Object,
      required: !0
    },
    baseHeadingType: {
      type: String,
      default: ze.H1,
      required: !1
    }
  },
  setup(e) {
    const t = Jt(), n = (i) => !!t[i];
    return (i, o) => e.model ? (E(), X("div", pQ, [
      e.model.headline ? (E(), fe(Ot, {
        key: 0,
        class: "d-header-area__heading",
        "base-heading-type": e.baseHeadingType
      }, {
        default: Se(() => [
          Ve(Ie(e.model.headline), 1)
        ]),
        _: 1
      }, 8, ["base-heading-type"])) : te("", !0),
      e.model.introText || n("intro") ? (E(), X("p", fQ, [
        je(i.$slots, "intro", {}, () => [
          e.model.introText ? (E(), fe(ht, {
            key: 0,
            "html-text": e.model.introText,
            "disable-default-styling": !0,
            class: "d-header-area__intro-text"
          }, null, 8, ["html-text"])) : te("", !0)
        ], !0)
      ])) : te("", !0)
    ])) : te("", !0);
  }
});
const Hs = /* @__PURE__ */ Fe(mQ, [["__scopeId", "data-v-a6806b02"]]);
var qr = /* @__PURE__ */ ((e) => (e.White = "white", e.Grey = "grey", e.None = "none", e))(qr || {}), zn = /* @__PURE__ */ ((e) => (e.Top = "top", e.Left = "left", e.Middle = "center", e.Right = "right", e.None = "none", e))(zn || {});
const gQ = ["id", "data-outside-click"], vQ = ["data-outside-click"], yQ = /* @__PURE__ */ Be({
  __name: "PageSection",
  props: {
    id: { default: "" },
    title: { default: "" },
    titleAlignment: { default: zn.None },
    isSubPageSection: { type: Boolean, default: !1 },
    contentInSameLine: { type: Boolean, default: !1 },
    contentInFullWidth: { type: Boolean, default: !1 },
    asOfDate: { default: void 0 },
    asOfDateInSameLine: { type: Boolean, default: !1 },
    disclaimerHtml: { default: void 0 },
    disclaimerNumberOfColumns: { default: 1 },
    footnoteComponentId: { default: Pn() },
    hasStripes: { type: Boolean, default: !1 },
    stripesWithShadow: { type: Boolean, default: !1 },
    hasPaddingTop: { type: Boolean, default: !1 },
    footnoteType: { default: Oi.None },
    oneColumnCentered: { type: Boolean, default: !1 },
    headlineWidthTwoThirds: { type: Boolean, default: !1 },
    baseHeadingType: { default: void 0 },
    dataOutsideClick: { type: Boolean },
    isFirst: { type: Boolean, default: !1 },
    isLast: { type: Boolean, default: !1 },
    nextIsBgGrey: { type: Boolean, default: !1 },
    hasOneItem: { type: Boolean, default: !1 },
    noMargin: { type: Boolean, default: !1 },
    noMarginBottom: { type: Boolean, default: !1 },
    background: { default: qr.White }
  },
  setup(e) {
    const t = e, { referencesCount: n } = Xi(), i = Te(() => t.baseHeadingType || (t.isSubPageSection ? ze.H3LooksLikeH2Section : ze.H2));
    return (o, a) => {
      const r = $e("BaseHeading");
      return E(), X("div", {
        id: o.id,
        class: Pe([
          "d-page-section",
          _(ts)({
            "d-page-section--stripes": o.hasStripes,
            "d-page-section--stripes--with-shadow": o.stripesWithShadow,
            "d-page-section--white": o.background === _(qr).White,
            "d-page-section--grey": o.background === _(qr).Grey,
            "d-page-section--next-grey": o.background === _(qr).Grey && o.nextIsBgGrey,
            "d-page-section--no-margin-bottom": o.noMarginBottom,
            "d-page-section--last": o.isLast,
            "d-page-section--reduced-margin": o.isLast && _(n) > 0 || o.isFirst && o.hasOneItem
          })
        ]),
        "data-outside-click": o.dataOutsideClick
      }, [
        oe("div", {
          class: Pe([
            "d-page-section__container grid grid-cols-1 lg:grid-cols-6",
            _(ts)({
              "d-page-section__container--full-width": o.contentInFullWidth,
              "d-page-section__container--padding-top": o.hasPaddingTop
            })
          ]),
          "data-outside-click": o.dataOutsideClick
        }, [
          o.title ? (E(), X("div", {
            key: 0,
            class: Pe(["d-page-section__heading", {
              "lg:col-span-2": o.contentInSameLine,
              "lg:col-span-6": !o.contentInSameLine,
              "d-page-section__heading--align-left": o.titleAlignment === _(zn).Left,
              "d-page-section__heading--align-center": o.titleAlignment === _(zn).Middle,
              "d-page-section__heading--align-right": o.titleAlignment === _(zn).Right,
              "d-page-section__heading--headline-width-two-thirds": o.headlineWidthTwoThirds,
              "d-page-section__heading--centered": o.oneColumnCentered
            }])
          }, [
            ue(r, { "base-heading-type": i.value }, {
              default: Se(() => [
                Ve(Ie(o.title), 1)
              ]),
              _: 1
            }, 8, ["base-heading-type"]),
            o.asOfDate && o.asOfDateInSameLine === !0 ? (E(), X("span", {
              key: 0,
              class: Pe(["d-page-section__heading__asOfDate", {
                "d-page-section__heading__asOfDate--h2-section": o.isSubPageSection
              }])
            }, Ie(" " + o.asOfDate), 3)) : te("", !0),
            o.asOfDate && o.asOfDateInSameLine === !1 ? (E(), X("div", {
              key: 1,
              class: Pe(["d-page-section__heading__asOfDate", {
                "d-page-section__heading__asOfDate--h2-section": o.isSubPageSection
              }])
            }, Ie(o.asOfDate), 3)) : te("", !0)
          ], 2)) : te("", !0),
          oe("div", {
            class: Pe(["d-page-section__content col-span-1", {
              "lg:col-span-4": o.contentInSameLine,
              "lg:col-span-6": !o.contentInSameLine,
              "d-page-section__content--centered": o.oneColumnCentered,
              "d-page-section__content--gap": !o.noMargin,
              "d-page-section__content--remove-child-margin": !o.noMargin,
              "d-page-section__content--grey": o.background === _(qr).Grey
            }])
          }, [
            je(o.$slots, "default", {}, void 0, !0)
          ], 2),
          ue(ro, {
            class: Pe(["xs:col-span-1 lg:col-span-6", {
              "d-page-section__footnote-list--no-margin": (o.disclaimerHtml?.length || 0) === 0
            }]),
            "component-id": o.footnoteComponentId,
            "footnote-type": o.footnoteType
          }, null, 8, ["class", "component-id", "footnote-type"]),
          (E(!0), X(Re, null, Ge(o.disclaimerHtml, (s) => (E(), fe(Mr, {
            key: s.text,
            values: s.text,
            "number-column": o.disclaimerNumberOfColumns ?? 1,
            class: "col-span-1 lg:col-span-6"
          }, null, 8, ["values", "number-column"]))), 128))
        ], 10, vQ)
      ], 10, gQ);
    };
  }
});
const Vt = /* @__PURE__ */ Fe(yQ, [["__scopeId", "data-v-2d12ec63"]]), bQ = {
  [et.XXSmall]: at.XXS,
  [et.XSmall]: at.XS,
  [et.Small]: at.S,
  [et.Medium]: at.M,
  [et.Large]: at.L,
  [et.Inherit]: at.Inherit
}, xQ = ["type", "target", "tabindex", "aria-label", "aria-disabled", "data-event_linktype", "data-event_source", "data-event_target", "data-event_title", "data-event_engagement", "data-event_component_name", "data-event_component_headline"], wQ = {
  key: 0,
  class: "d-rounded-button__twitter-icon"
}, kQ = {
  key: 1,
  class: "d-rounded-button__custom__text"
}, SQ = {
  key: 0,
  class: "sr-only"
}, CQ = /* @__PURE__ */ Be({
  __name: "RoundedButton",
  props: {
    linkModel: {
      type: Object,
      required: !0
    },
    type: {
      type: String,
      required: !0
    },
    size: {
      type: String,
      required: !0
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    icon: {
      type: String,
      default: null
    },
    noBorder: {
      type: Boolean,
      default: !1
    },
    active: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["click"],
  setup(e, { expose: t, emit: n }) {
    const i = ge();
    t({ buttonRef: i });
    const o = n;
    return (a, r) => {
      const s = $e("BaseIcon");
      return E(), X("button", {
        ref_key: "buttonRef",
        ref: i,
        type: e.linkModel?.linkType == _(za).Javascript ? "button" : "submit",
        target: e.linkModel?.target,
        class: Pe(["d-rounded-button", {
          "d-rounded-button--primary": e.type === _(Ke).RoundedPrimary,
          "d-rounded-button--secondary": e.type === _(Ke).RoundedSecondary,
          "d-rounded-button--tertiary": e.type === _(Ke).RoundedTertiary,
          "d-rounded-button--ghost": e.type === _(Ke).RoundedGhost,
          "d-rounded-button--social": e.type === _(Ke).RoundedSocial,
          "d-rounded-button--non-filled": e.type === _(Ke).RoundedNonFilled,
          "d-rounded-button--large": e.size === _(et).Large,
          "d-rounded-button--medium": e.size === _(et).Medium,
          "d-rounded-button--small": e.size === _(et).Small,
          "d-rounded-button--x-small": e.size === _(et).XSmall,
          "d-rounded-button--xx-small": e.size === _(et).XXSmall,
          "d-rounded-button--inherit": e.size === _(et).Inherit,
          "d-disabled": e.disabled,
          "no-border": e.noBorder,
          active: e.active
        }]),
        tabindex: e.disabled ? -1 : 0,
        "aria-label": e.linkModel?.title,
        "aria-disabled": e.disabled,
        "data-event_linktype": e.linkModel?.tealiumTrackingModel?.eventLinkType,
        "data-event_source": e.linkModel?.tealiumTrackingModel?.eventSource,
        "data-event_target": e.linkModel?.tealiumTrackingModel?.eventTarget,
        "data-event_title": e.linkModel?.tealiumTrackingModel?.eventTitle,
        "data-event_engagement": e.linkModel?.tealiumTrackingModel?.eventEngagement,
        "data-event_component_name": e.linkModel?.tealiumTrackingModel?.eventComponentName,
        "data-event_component_headline": e.linkModel?.tealiumTrackingModel?.eventComponentHeadline,
        onClick: r[0] || (r[0] = (l) => o("click", l))
      }, [
        je(a.$slots, "default", {}, () => [
          oe("div", null, [
            e.icon === _(H).Twitter || e.icon === _(H).TwitterSquare || e.linkModel?.text && !e.icon ? (E(), X("div", {
              key: 0,
              class: Pe(["d-rounded-button__custom", {
                "d-rounded-button__custom--primary": e.type === _(Ke).RoundedPrimary,
                "d-rounded-button__custom--secondary": e.type === _(Ke).RoundedSecondary,
                "d-rounded-button__custom--tertiary": e.type === _(Ke).RoundedTertiary,
                "d-rounded-button__custom--ghost": e.type === _(Ke).RoundedGhost,
                "d-rounded-button__custom--nonFilled": e.type === _(Ke).RoundedNonFilled,
                "d-rounded-button__custom--greyBlue009": e.type === _(Ke).RoundedSocial,
                "d-rounded-button__custom__twitter": e.icon === _(H).Twitter || e.icon === _(H).TwitterSquare
              }])
            }, [
              e.icon === _(H).Twitter || e.icon === _(H).TwitterSquare ? (E(), X("div", wQ)) : e.linkModel?.text ? (E(), X("span", kQ, Ie(e.linkModel?.text), 1)) : te("", !0)
            ], 2)) : e.icon ? (E(), fe(s, {
              key: 1,
              "base-icon": e.icon,
              "base-icon-filled": e.type === _(Ke).RoundedPrimary,
              "base-icon-size": _(bQ)[e.size]
            }, null, 8, ["base-icon", "base-icon-filled", "base-icon-size"])) : te("", !0)
          ])
        ], !0),
        e.linkModel?.text ? (E(), X("span", SQ, Ie(e.linkModel.text), 1)) : te("", !0)
      ], 10, xQ);
    };
  }
});
const Nt = /* @__PURE__ */ Fe(CQ, [["__scopeId", "data-v-e3d8e9fd"]]);
var EC = { exports: {} };
/*!***************************************************
* mark.js v8.11.1
* https://markjs.io/
* Copyright (c) 2014–2018, Julian Kühnel
* Released under the MIT license https://git.io/vwTVl
*****************************************************/
(function(e, t) {
  (function(n, i) {
    e.exports = i();
  })(rn, function() {
    var n = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(d) {
      return typeof d;
    } : function(d) {
      return d && typeof Symbol == "function" && d.constructor === Symbol && d !== Symbol.prototype ? "symbol" : typeof d;
    }, i = function(d, y) {
      if (!(d instanceof y))
        throw new TypeError("Cannot call a class as a function");
    }, o = function() {
      function d(y, u) {
        for (var m = 0; m < u.length; m++) {
          var h = u[m];
          h.enumerable = h.enumerable || !1, h.configurable = !0, "value" in h && (h.writable = !0), Object.defineProperty(y, h.key, h);
        }
      }
      return function(y, u, m) {
        return u && d(y.prototype, u), m && d(y, m), y;
      };
    }(), a = Object.assign || function(d) {
      for (var y = 1; y < arguments.length; y++) {
        var u = arguments[y];
        for (var m in u)
          Object.prototype.hasOwnProperty.call(u, m) && (d[m] = u[m]);
      }
      return d;
    }, r = function() {
      function d(y) {
        var u = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0, m = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [], h = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 5e3;
        i(this, d), this.ctx = y, this.iframes = u, this.exclude = m, this.iframesTimeout = h;
      }
      return o(d, [{
        key: "getContexts",
        value: function() {
          var u = void 0, m = [];
          return typeof this.ctx > "u" || !this.ctx ? u = [] : NodeList.prototype.isPrototypeOf(this.ctx) ? u = Array.prototype.slice.call(this.ctx) : Array.isArray(this.ctx) ? u = this.ctx : typeof this.ctx == "string" ? u = Array.prototype.slice.call(document.querySelectorAll(this.ctx)) : u = [this.ctx], u.forEach(function(h) {
            var c = m.filter(function(g) {
              return g.contains(h);
            }).length > 0;
            m.indexOf(h) === -1 && !c && m.push(h);
          }), m;
        }
      }, {
        key: "getIframeContents",
        value: function(u, m) {
          var h = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : function() {
          }, c = void 0;
          try {
            var g = u.contentWindow;
            if (c = g.document, !g || !c)
              throw new Error("iframe inaccessible");
          } catch {
            h();
          }
          c && m(c);
        }
      }, {
        key: "isIframeBlank",
        value: function(u) {
          var m = "about:blank", h = u.getAttribute("src").trim(), c = u.contentWindow.location.href;
          return c === m && h !== m && h;
        }
      }, {
        key: "observeIframeLoad",
        value: function(u, m, h) {
          var c = this, g = !1, v = null, P = function f() {
            if (!g) {
              g = !0, clearTimeout(v);
              try {
                c.isIframeBlank(u) || (u.removeEventListener("load", f), c.getIframeContents(u, m, h));
              } catch {
                h();
              }
            }
          };
          u.addEventListener("load", P), v = setTimeout(P, this.iframesTimeout);
        }
      }, {
        key: "onIframeReady",
        value: function(u, m, h) {
          try {
            u.contentWindow.document.readyState === "complete" ? this.isIframeBlank(u) ? this.observeIframeLoad(u, m, h) : this.getIframeContents(u, m, h) : this.observeIframeLoad(u, m, h);
          } catch {
            h();
          }
        }
      }, {
        key: "waitForIframes",
        value: function(u, m) {
          var h = this, c = 0;
          this.forEachIframe(u, function() {
            return !0;
          }, function(g) {
            c++, h.waitForIframes(g.querySelector("html"), function() {
              --c || m();
            });
          }, function(g) {
            g || m();
          });
        }
      }, {
        key: "forEachIframe",
        value: function(u, m, h) {
          var c = this, g = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : function() {
          }, v = u.querySelectorAll("iframe"), P = v.length, f = 0;
          v = Array.prototype.slice.call(v);
          var S = function() {
            --P <= 0 && g(f);
          };
          P || S(), v.forEach(function(w) {
            d.matches(w, c.exclude) ? S() : c.onIframeReady(w, function(x) {
              m(w) && (f++, h(x)), S();
            }, S);
          });
        }
      }, {
        key: "createIterator",
        value: function(u, m, h) {
          return document.createNodeIterator(u, m, h, !1);
        }
      }, {
        key: "createInstanceOnIframe",
        value: function(u) {
          return new d(u.querySelector("html"), this.iframes);
        }
      }, {
        key: "compareNodeIframe",
        value: function(u, m, h) {
          var c = u.compareDocumentPosition(h), g = Node.DOCUMENT_POSITION_PRECEDING;
          if (c & g)
            if (m !== null) {
              var v = m.compareDocumentPosition(h), P = Node.DOCUMENT_POSITION_FOLLOWING;
              if (v & P)
                return !0;
            } else
              return !0;
          return !1;
        }
      }, {
        key: "getIteratorNode",
        value: function(u) {
          var m = u.previousNode(), h = void 0;
          return m === null ? h = u.nextNode() : h = u.nextNode() && u.nextNode(), {
            prevNode: m,
            node: h
          };
        }
      }, {
        key: "checkIframeFilter",
        value: function(u, m, h, c) {
          var g = !1, v = !1;
          return c.forEach(function(P, f) {
            P.val === h && (g = f, v = P.handled);
          }), this.compareNodeIframe(u, m, h) ? (g === !1 && !v ? c.push({
            val: h,
            handled: !0
          }) : g !== !1 && !v && (c[g].handled = !0), !0) : (g === !1 && c.push({
            val: h,
            handled: !1
          }), !1);
        }
      }, {
        key: "handleOpenIframes",
        value: function(u, m, h, c) {
          var g = this;
          u.forEach(function(v) {
            v.handled || g.getIframeContents(v.val, function(P) {
              g.createInstanceOnIframe(P).forEachNode(m, h, c);
            });
          });
        }
      }, {
        key: "iterateThroughNodes",
        value: function(u, m, h, c, g) {
          for (var v = this, P = this.createIterator(m, u, c), f = [], S = [], w = void 0, x = void 0, k = function() {
            var $ = v.getIteratorNode(P);
            return x = $.prevNode, w = $.node, w;
          }; k(); )
            this.iframes && this.forEachIframe(m, function(A) {
              return v.checkIframeFilter(w, x, A, f);
            }, function(A) {
              v.createInstanceOnIframe(A).forEachNode(u, function($) {
                return S.push($);
              }, c);
            }), S.push(w);
          S.forEach(function(A) {
            h(A);
          }), this.iframes && this.handleOpenIframes(f, u, h, c), g();
        }
      }, {
        key: "forEachNode",
        value: function(u, m, h) {
          var c = this, g = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : function() {
          }, v = this.getContexts(), P = v.length;
          P || g(), v.forEach(function(f) {
            var S = function() {
              c.iterateThroughNodes(u, f, m, h, function() {
                --P <= 0 && g();
              });
            };
            c.iframes ? c.waitForIframes(f, S) : S();
          });
        }
      }], [{
        key: "matches",
        value: function(u, m) {
          var h = typeof m == "string" ? [m] : m, c = u.matches || u.matchesSelector || u.msMatchesSelector || u.mozMatchesSelector || u.oMatchesSelector || u.webkitMatchesSelector;
          if (c) {
            var g = !1;
            return h.every(function(v) {
              return c.call(u, v) ? (g = !0, !1) : !0;
            }), g;
          } else
            return !1;
        }
      }]), d;
    }(), s = function() {
      function d(y) {
        i(this, d), this.ctx = y, this.ie = !1;
        var u = window.navigator.userAgent;
        (u.indexOf("MSIE") > -1 || u.indexOf("Trident") > -1) && (this.ie = !0);
      }
      return o(d, [{
        key: "log",
        value: function(u) {
          var m = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "debug", h = this.opt.log;
          this.opt.debug && (typeof h > "u" ? "undefined" : n(h)) === "object" && typeof h[m] == "function" && h[m]("mark.js: " + u);
        }
      }, {
        key: "escapeStr",
        value: function(u) {
          return u.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
        }
      }, {
        key: "createRegExp",
        value: function(u) {
          return this.opt.wildcards !== "disabled" && (u = this.setupWildcardsRegExp(u)), u = this.escapeStr(u), Object.keys(this.opt.synonyms).length && (u = this.createSynonymsRegExp(u)), (this.opt.ignoreJoiners || this.opt.ignorePunctuation.length) && (u = this.setupIgnoreJoinersRegExp(u)), this.opt.diacritics && (u = this.createDiacriticsRegExp(u)), u = this.createMergedBlanksRegExp(u), (this.opt.ignoreJoiners || this.opt.ignorePunctuation.length) && (u = this.createJoinersRegExp(u)), this.opt.wildcards !== "disabled" && (u = this.createWildcardsRegExp(u)), u = this.createAccuracyRegExp(u), u;
        }
      }, {
        key: "createSynonymsRegExp",
        value: function(u) {
          var m = this.opt.synonyms, h = this.opt.caseSensitive ? "" : "i", c = this.opt.ignoreJoiners || this.opt.ignorePunctuation.length ? "\0" : "";
          for (var g in m)
            if (m.hasOwnProperty(g)) {
              var v = m[g], P = this.opt.wildcards !== "disabled" ? this.setupWildcardsRegExp(g) : this.escapeStr(g), f = this.opt.wildcards !== "disabled" ? this.setupWildcardsRegExp(v) : this.escapeStr(v);
              P !== "" && f !== "" && (u = u.replace(new RegExp("(" + this.escapeStr(P) + "|" + this.escapeStr(f) + ")", "gm" + h), c + ("(" + this.processSynomyms(P) + "|") + (this.processSynomyms(f) + ")") + c));
            }
          return u;
        }
      }, {
        key: "processSynomyms",
        value: function(u) {
          return (this.opt.ignoreJoiners || this.opt.ignorePunctuation.length) && (u = this.setupIgnoreJoinersRegExp(u)), u;
        }
      }, {
        key: "setupWildcardsRegExp",
        value: function(u) {
          return u = u.replace(/(?:\\)*\?/g, function(m) {
            return m.charAt(0) === "\\" ? "?" : "";
          }), u.replace(/(?:\\)*\*/g, function(m) {
            return m.charAt(0) === "\\" ? "*" : "";
          });
        }
      }, {
        key: "createWildcardsRegExp",
        value: function(u) {
          var m = this.opt.wildcards === "withSpaces";
          return u.replace(/\u0001/g, m ? "[\\S\\s]?" : "\\S?").replace(/\u0002/g, m ? "[\\S\\s]*?" : "\\S*");
        }
      }, {
        key: "setupIgnoreJoinersRegExp",
        value: function(u) {
          return u.replace(/[^(|)\\]/g, function(m, h, c) {
            var g = c.charAt(h + 1);
            return /[(|)\\]/.test(g) || g === "" ? m : m + "\0";
          });
        }
      }, {
        key: "createJoinersRegExp",
        value: function(u) {
          var m = [], h = this.opt.ignorePunctuation;
          return Array.isArray(h) && h.length && m.push(this.escapeStr(h.join(""))), this.opt.ignoreJoiners && m.push("\\u00ad\\u200b\\u200c\\u200d"), m.length ? u.split(/\u0000+/).join("[" + m.join("") + "]*") : u;
        }
      }, {
        key: "createDiacriticsRegExp",
        value: function(u) {
          var m = this.opt.caseSensitive ? "" : "i", h = this.opt.caseSensitive ? ["aàáảãạăằắẳẵặâầấẩẫậäåāą", "AÀÁẢÃẠĂẰẮẲẴẶÂẦẤẨẪẬÄÅĀĄ", "cçćč", "CÇĆČ", "dđď", "DĐĎ", "eèéẻẽẹêềếểễệëěēę", "EÈÉẺẼẸÊỀẾỂỄỆËĚĒĘ", "iìíỉĩịîïī", "IÌÍỈĨỊÎÏĪ", "lł", "LŁ", "nñňń", "NÑŇŃ", "oòóỏõọôồốổỗộơởỡớờợöøō", "OÒÓỎÕỌÔỒỐỔỖỘƠỞỠỚỜỢÖØŌ", "rř", "RŘ", "sšśșş", "SŠŚȘŞ", "tťțţ", "TŤȚŢ", "uùúủũụưừứửữựûüůū", "UÙÚỦŨỤƯỪỨỬỮỰÛÜŮŪ", "yýỳỷỹỵÿ", "YÝỲỶỸỴŸ", "zžżź", "ZŽŻŹ"] : ["aàáảãạăằắẳẵặâầấẩẫậäåāąAÀÁẢÃẠĂẰẮẲẴẶÂẦẤẨẪẬÄÅĀĄ", "cçćčCÇĆČ", "dđďDĐĎ", "eèéẻẽẹêềếểễệëěēęEÈÉẺẼẸÊỀẾỂỄỆËĚĒĘ", "iìíỉĩịîïīIÌÍỈĨỊÎÏĪ", "lłLŁ", "nñňńNÑŇŃ", "oòóỏõọôồốổỗộơởỡớờợöøōOÒÓỎÕỌÔỒỐỔỖỘƠỞỠỚỜỢÖØŌ", "rřRŘ", "sšśșşSŠŚȘŞ", "tťțţTŤȚŢ", "uùúủũụưừứửữựûüůūUÙÚỦŨỤƯỪỨỬỮỰÛÜŮŪ", "yýỳỷỹỵÿYÝỲỶỸỴŸ", "zžżźZŽŻŹ"], c = [];
          return u.split("").forEach(function(g) {
            h.every(function(v) {
              if (v.indexOf(g) !== -1) {
                if (c.indexOf(v) > -1)
                  return !1;
                u = u.replace(new RegExp("[" + v + "]", "gm" + m), "[" + v + "]"), c.push(v);
              }
              return !0;
            });
          }), u;
        }
      }, {
        key: "createMergedBlanksRegExp",
        value: function(u) {
          return u.replace(/[\s]+/gmi, "[\\s]+");
        }
      }, {
        key: "createAccuracyRegExp",
        value: function(u) {
          var m = this, h = "!\"#$%&'()*+,-./:;<=>?@[\\]^_`{|}~¡¿", c = this.opt.accuracy, g = typeof c == "string" ? c : c.value, v = typeof c == "string" ? [] : c.limiters, P = "";
          switch (v.forEach(function(f) {
            P += "|" + m.escapeStr(f);
          }), g) {
            case "partially":
            default:
              return "()(" + u + ")";
            case "complementary":
              return P = "\\s" + (P || this.escapeStr(h)), "()([^" + P + "]*" + u + "[^" + P + "]*)";
            case "exactly":
              return "(^|\\s" + P + ")(" + u + ")(?=$|\\s" + P + ")";
          }
        }
      }, {
        key: "getSeparatedKeywords",
        value: function(u) {
          var m = this, h = [];
          return u.forEach(function(c) {
            m.opt.separateWordSearch ? c.split(" ").forEach(function(g) {
              g.trim() && h.indexOf(g) === -1 && h.push(g);
            }) : c.trim() && h.indexOf(c) === -1 && h.push(c);
          }), {
            keywords: h.sort(function(c, g) {
              return g.length - c.length;
            }),
            length: h.length
          };
        }
      }, {
        key: "isNumeric",
        value: function(u) {
          return Number(parseFloat(u)) == u;
        }
      }, {
        key: "checkRanges",
        value: function(u) {
          var m = this;
          if (!Array.isArray(u) || Object.prototype.toString.call(u[0]) !== "[object Object]")
            return this.log("markRanges() will only accept an array of objects"), this.opt.noMatch(u), [];
          var h = [], c = 0;
          return u.sort(function(g, v) {
            return g.start - v.start;
          }).forEach(function(g) {
            var v = m.callNoMatchOnInvalidRanges(g, c), P = v.start, f = v.end, S = v.valid;
            S && (g.start = P, g.length = f - P, h.push(g), c = f);
          }), h;
        }
      }, {
        key: "callNoMatchOnInvalidRanges",
        value: function(u, m) {
          var h = void 0, c = void 0, g = !1;
          return u && typeof u.start < "u" ? (h = parseInt(u.start, 10), c = h + parseInt(u.length, 10), this.isNumeric(u.start) && this.isNumeric(u.length) && c - m > 0 && c - h > 0 ? g = !0 : (this.log("Ignoring invalid or overlapping range: " + ("" + JSON.stringify(u))), this.opt.noMatch(u))) : (this.log("Ignoring invalid range: " + JSON.stringify(u)), this.opt.noMatch(u)), {
            start: h,
            end: c,
            valid: g
          };
        }
      }, {
        key: "checkWhitespaceRanges",
        value: function(u, m, h) {
          var c = void 0, g = !0, v = h.length, P = m - v, f = parseInt(u.start, 10) - P;
          return f = f > v ? v : f, c = f + parseInt(u.length, 10), c > v && (c = v, this.log("End range automatically set to the max value of " + v)), f < 0 || c - f < 0 || f > v || c > v ? (g = !1, this.log("Invalid range: " + JSON.stringify(u)), this.opt.noMatch(u)) : h.substring(f, c).replace(/\s+/g, "") === "" && (g = !1, this.log("Skipping whitespace only range: " + JSON.stringify(u)), this.opt.noMatch(u)), {
            start: f,
            end: c,
            valid: g
          };
        }
      }, {
        key: "getTextNodes",
        value: function(u) {
          var m = this, h = "", c = [];
          this.iterator.forEachNode(NodeFilter.SHOW_TEXT, function(g) {
            c.push({
              start: h.length,
              end: (h += g.textContent).length,
              node: g
            });
          }, function(g) {
            return m.matchesExclude(g.parentNode) ? NodeFilter.FILTER_REJECT : NodeFilter.FILTER_ACCEPT;
          }, function() {
            u({
              value: h,
              nodes: c
            });
          });
        }
      }, {
        key: "matchesExclude",
        value: function(u) {
          return r.matches(u, this.opt.exclude.concat(["script", "style", "title", "head", "html"]));
        }
      }, {
        key: "wrapRangeInTextNode",
        value: function(u, m, h) {
          var c = this.opt.element ? this.opt.element : "mark", g = u.splitText(m), v = g.splitText(h - m), P = document.createElement(c);
          return P.setAttribute("data-markjs", "true"), this.opt.className && P.setAttribute("class", this.opt.className), P.textContent = g.textContent, g.parentNode.replaceChild(P, g), v;
        }
      }, {
        key: "wrapRangeInMappedTextNode",
        value: function(u, m, h, c, g) {
          var v = this;
          u.nodes.every(function(P, f) {
            var S = u.nodes[f + 1];
            if (typeof S > "u" || S.start > m) {
              if (!c(P.node))
                return !1;
              var w = m - P.start, x = (h > P.end ? P.end : h) - P.start, k = u.value.substr(0, P.start), A = u.value.substr(x + P.start);
              if (P.node = v.wrapRangeInTextNode(P.node, w, x), u.value = k + A, u.nodes.forEach(function($, j) {
                j >= f && (u.nodes[j].start > 0 && j !== f && (u.nodes[j].start -= x), u.nodes[j].end -= x);
              }), h -= x, g(P.node.previousSibling, P.start), h > P.end)
                m = P.end;
              else
                return !1;
            }
            return !0;
          });
        }
      }, {
        key: "wrapMatches",
        value: function(u, m, h, c, g) {
          var v = this, P = m === 0 ? 0 : m + 1;
          this.getTextNodes(function(f) {
            f.nodes.forEach(function(S) {
              S = S.node;
              for (var w = void 0; (w = u.exec(S.textContent)) !== null && w[P] !== ""; )
                if (h(w[P], S)) {
                  var x = w.index;
                  if (P !== 0)
                    for (var k = 1; k < P; k++)
                      x += w[k].length;
                  S = v.wrapRangeInTextNode(S, x, x + w[P].length), c(S.previousSibling), u.lastIndex = 0;
                }
            }), g();
          });
        }
      }, {
        key: "wrapMatchesAcrossElements",
        value: function(u, m, h, c, g) {
          var v = this, P = m === 0 ? 0 : m + 1;
          this.getTextNodes(function(f) {
            for (var S = void 0; (S = u.exec(f.value)) !== null && S[P] !== ""; ) {
              var w = S.index;
              if (P !== 0)
                for (var x = 1; x < P; x++)
                  w += S[x].length;
              var k = w + S[P].length;
              v.wrapRangeInMappedTextNode(f, w, k, function(A) {
                return h(S[P], A);
              }, function(A, $) {
                u.lastIndex = $, c(A);
              });
            }
            g();
          });
        }
      }, {
        key: "wrapRangeFromIndex",
        value: function(u, m, h, c) {
          var g = this;
          this.getTextNodes(function(v) {
            var P = v.value.length;
            u.forEach(function(f, S) {
              var w = g.checkWhitespaceRanges(f, P, v.value), x = w.start, k = w.end, A = w.valid;
              A && g.wrapRangeInMappedTextNode(v, x, k, function($) {
                return m($, f, v.value.substring(x, k), S);
              }, function($) {
                h($, f);
              });
            }), c();
          });
        }
      }, {
        key: "unwrapMatches",
        value: function(u) {
          for (var m = u.parentNode, h = document.createDocumentFragment(); u.firstChild; )
            h.appendChild(u.removeChild(u.firstChild));
          m.replaceChild(h, u), this.ie ? this.normalizeTextNode(m) : m.normalize();
        }
      }, {
        key: "normalizeTextNode",
        value: function(u) {
          if (u) {
            if (u.nodeType === 3)
              for (; u.nextSibling && u.nextSibling.nodeType === 3; )
                u.nodeValue += u.nextSibling.nodeValue, u.parentNode.removeChild(u.nextSibling);
            else
              this.normalizeTextNode(u.firstChild);
            this.normalizeTextNode(u.nextSibling);
          }
        }
      }, {
        key: "markRegExp",
        value: function(u, m) {
          var h = this;
          this.opt = m, this.log('Searching with expression "' + u + '"');
          var c = 0, g = "wrapMatches", v = function(f) {
            c++, h.opt.each(f);
          };
          this.opt.acrossElements && (g = "wrapMatchesAcrossElements"), this[g](u, this.opt.ignoreGroups, function(P, f) {
            return h.opt.filter(f, P, c);
          }, v, function() {
            c === 0 && h.opt.noMatch(u), h.opt.done(c);
          });
        }
      }, {
        key: "mark",
        value: function(u, m) {
          var h = this;
          this.opt = m;
          var c = 0, g = "wrapMatches", v = this.getSeparatedKeywords(typeof u == "string" ? [u] : u), P = v.keywords, f = v.length, S = this.opt.caseSensitive ? "" : "i", w = function x(k) {
            var A = new RegExp(h.createRegExp(k), "gm" + S), $ = 0;
            h.log('Searching with expression "' + A + '"'), h[g](A, 1, function(j, N) {
              return h.opt.filter(N, k, c, $);
            }, function(j) {
              $++, c++, h.opt.each(j);
            }, function() {
              $ === 0 && h.opt.noMatch(k), P[f - 1] === k ? h.opt.done(c) : x(P[P.indexOf(k) + 1]);
            });
          };
          this.opt.acrossElements && (g = "wrapMatchesAcrossElements"), f === 0 ? this.opt.done(c) : w(P[0]);
        }
      }, {
        key: "markRanges",
        value: function(u, m) {
          var h = this;
          this.opt = m;
          var c = 0, g = this.checkRanges(u);
          g && g.length ? (this.log("Starting to mark with the following ranges: " + JSON.stringify(g)), this.wrapRangeFromIndex(g, function(v, P, f, S) {
            return h.opt.filter(v, P, f, S);
          }, function(v, P) {
            c++, h.opt.each(v, P);
          }, function() {
            h.opt.done(c);
          })) : this.opt.done(c);
        }
      }, {
        key: "unmark",
        value: function(u) {
          var m = this;
          this.opt = u;
          var h = this.opt.element ? this.opt.element : "*";
          h += "[data-markjs]", this.opt.className && (h += "." + this.opt.className), this.log('Removal selector "' + h + '"'), this.iterator.forEachNode(NodeFilter.SHOW_ELEMENT, function(c) {
            m.unwrapMatches(c);
          }, function(c) {
            var g = r.matches(c, h), v = m.matchesExclude(c);
            return !g || v ? NodeFilter.FILTER_REJECT : NodeFilter.FILTER_ACCEPT;
          }, this.opt.done);
        }
      }, {
        key: "opt",
        set: function(u) {
          this._opt = a({}, {
            element: "",
            className: "",
            exclude: [],
            iframes: !1,
            iframesTimeout: 5e3,
            separateWordSearch: !0,
            diacritics: !0,
            synonyms: {},
            accuracy: "partially",
            acrossElements: !1,
            caseSensitive: !1,
            ignoreJoiners: !1,
            ignoreGroups: 0,
            ignorePunctuation: [],
            wildcards: "disabled",
            each: function() {
            },
            noMatch: function() {
            },
            filter: function() {
              return !0;
            },
            done: function() {
            },
            debug: !1,
            log: window.console
          }, u);
        },
        get: function() {
          return this._opt;
        }
      }, {
        key: "iterator",
        get: function() {
          return new r(this.ctx, this.opt.iframes, this.opt.exclude, this.opt.iframesTimeout);
        }
      }]), d;
    }();
    function l(d) {
      var y = this, u = new s(d);
      return this.mark = function(m, h) {
        return u.mark(m, h), y;
      }, this.markRegExp = function(m, h) {
        return u.markRegExp(m, h), y;
      }, this.markRanges = function(m, h) {
        return u.markRanges(m, h), y;
      }, this.unmark = function(m) {
        return u.unmark(m), y;
      }, this;
    }
    return l;
  });
})(EC);
var TQ = EC.exports;
const b0 = /* @__PURE__ */ en(TQ), LQ = /* @__PURE__ */ Be({
  __name: "Mark",
  props: {
    term: {
      type: String,
      required: !0
    },
    separateWordSearch: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const t = e, n = Jt(), i = ge();
    it(() => {
      Ue && o(t.term);
    }), qe(
      () => t.term,
      (r) => {
        Ue && (a(), o(r));
      }
    );
    const o = async (r) => {
      await mt(), new b0(i.value).mark(r, {
        element: "span",
        className: "highlight",
        separateWordSearch: t.separateWordSearch
      });
    }, a = () => {
      new b0(i.value).unmark();
    };
    return (r, s) => _(n).default ? (E(), X("div", {
      key: 0,
      ref_key: "elementRef",
      ref: i
    }, [
      je(r.$slots, "default", {}, void 0, !0)
    ], 512)) : te("", !0);
  }
});
const gi = /* @__PURE__ */ Fe(LQ, [["__scopeId", "data-v-b3cb22bd"]]), IQ = { class: "d-base-search-box-result__filter-row" }, PQ = {
  key: 0,
  class: "d-base-search-box-result__filter"
}, AQ = { class: "d-base-search-box-result__filter-name" }, _Q = ["aria-label"], MQ = ["href", "target", "data-event_component_name", "data-event_source", "aria-setsize", "aria-posinset"], OQ = { class: "d-base-search-box-result__block--text" }, BQ = ["href", "target", "data-event-component-name", "data-event_source", "aria-setsize", "aria-posinset"], EQ = { class: "d-base-search-box-result__block--text" }, DQ = /* @__PURE__ */ Be({
  __name: "BaseSearchBoxResult",
  props: {
    searchTerm: {
      type: String,
      required: !0
    },
    result: {
      type: Object,
      default: null
    },
    filterOption: {
      type: Object,
      default: void 0
    },
    useCustomClicks: {
      type: Boolean,
      default: !1
    },
    showAlways: {
      type: Boolean,
      default: !1
    },
    isFundFinder: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["filter-changed", "onButtonClick"],
  setup(e, { emit: t }) {
    const n = e, i = t, { pageName: o } = Qe(), { t: a } = Je(), { engineName: r } = Cl(), s = ge([]);
    let l = 1;
    qe(
      () => n.result?.results,
      () => {
        l = 1;
      },
      { deep: !0 }
    );
    const d = () => l++, y = Te(
      () => n.result?.results?.reduce(
        (v, P) => v + (P?.records?.length || 0),
        0
      )
    ), u = () => {
      r.value === "WebKit" && (s.value[0]?.children[0]?.focus(), s.value[0]?.children[0]?.blur());
    }, m = (v) => {
      n.useCustomClicks && (v.preventDefault(), i("onButtonClick"));
    }, h = (v) => {
      v.isSelected = !1, i("filter-changed", v);
    }, c = Jt(), g = (v) => !!c[v];
    return (v, P) => {
      const f = $e("BaseButtonV2"), S = $e("BaseText");
      return E(), fe(oo, null, {
        default: Se(() => [
          (e.searchTerm && e.searchTerm !== "" || e.showAlways) && e.result?.results ? (E(), X("div", {
            key: 0,
            class: "d-base-search-box-result",
            role: "listbox",
            onMouseover: u
          }, [
            oe("span", {
              ref: "showResults",
              "aria-live": "polite",
              class: "d-base-search-box-result__screen-reader_result"
            }, Ie(`${y.value} ${_(a)("globalTranslations.results")}`), 513),
            oe("div", IQ, [
              e.filterOption ? (E(), X("span", PQ, [
                ue(_(Nt), {
                  "link-model": {},
                  type: _(Ke).RoundedNonFilled,
                  size: _(et).Small,
                  icon: _(H).Times,
                  class: "d-base-search-box-result__filter-remove",
                  onClick: P[0] || (P[0] = (w) => h(e.filterOption))
                }, null, 8, ["type", "size", "icon"]),
                oe("span", AQ, Ie(e.filterOption.name), 1)
              ])) : te("", !0)
            ]),
            e.result?.results?.length > 0 ? (E(), X(Re, { key: 0 }, [
              (E(!0), X(Re, null, Ge(e.result?.results, (w, x) => (E(), X("div", {
                key: x,
                class: "d-base-search-box-result__block"
              }, [
                e.result?.results?.length > (e.isFundFinder ? 1 : 0) ? (E(), X("p", {
                  key: 0,
                  "aria-label": w?.name + " " + w?.numberOfRecords,
                  class: "d-base-search-box-result__block--headline"
                }, [
                  Ve(Ie(w?.name) + " ", 1),
                  w?.numberOfRecords ? (E(), X(Re, { key: 0 }, [
                    Ve(" (" + Ie(w.numberOfRecords) + ") ", 1)
                  ], 64)) : te("", !0)
                ], 8, _Q)) : te("", !0),
                (E(!0), X(Re, null, Ge(w?.records, (k, A) => (E(), X("div", {
                  ref_for: !0,
                  ref_key: "linkRefs",
                  ref: s,
                  key: A,
                  class: "d-base-search-box-result__block--item"
                }, [
                  g("record") ? je(v.$slots, "record", {
                    key: 0,
                    record: k,
                    setsize: y.value || null,
                    posinset: d()
                  }, void 0, !0) : (E(), X(Re, { key: 1 }, [
                    oe("a", {
                      href: k.link.href,
                      target: k.link.target,
                      "data-event_component_name": _(a)("baseSearchBox.resultEventComponentName"),
                      "data-event_source": _(o),
                      class: "d-base-search-box-result__block--title",
                      role: "option",
                      "aria-setsize": y.value || null,
                      "aria-posinset": d()
                    }, [
                      oe("span", OQ, [
                        ue(gi, {
                          term: e.searchTerm,
                          "separate-word-search": ""
                        }, {
                          default: Se(() => [
                            (E(), fe(_(ht), {
                              key: k.title,
                              "disable-default-styling": "",
                              "html-text": k.title
                            }, null, 8, ["html-text"]))
                          ]),
                          _: 2
                        }, 1032, ["term"])
                      ])
                    ], 8, MQ),
                    k.productKey ? (E(), X("a", {
                      key: 0,
                      href: k.link.href,
                      target: k.link.target,
                      "data-event-component-name": _(a)("baseSearchBox.resultEventComponentName"),
                      "data-event_source": _(o),
                      role: "option",
                      "aria-setsize": y.value || null,
                      "aria-posinset": d(),
                      class: "d-base-search-box-result__block--isin"
                    }, [
                      oe("span", EQ, [
                        ue(gi, {
                          term: e.searchTerm,
                          "separate-word-search": ""
                        }, {
                          default: Se(() => [
                            (E(), fe(_(ht), {
                              key: k.productKey ?? "",
                              "disable-default-styling": "",
                              "html-text": k.productKey ?? ""
                            }, null, 8, ["html-text"]))
                          ]),
                          _: 2
                        }, 1032, ["term"])
                      ])
                    ], 8, BQ)) : te("", !0)
                  ], 64))
                ]))), 128))
              ]))), 128)),
              e.result.allResultsLink ? (E(), fe(f, {
                key: 0,
                "link-model": {
                  ...e.result.allResultsLink,
                  href: e.useCustomClicks ? void 0 : e.result?.allResultsLink?.href
                },
                type: _(Ke).Secondary,
                "button-type": _(zt).Link,
                size: _(et).Large,
                class: "d-base-search-box-result__button",
                onClick: m
              }, null, 8, ["link-model", "type", "button-type", "size"])) : te("", !0)
            ], 64)) : (E(), fe(S, {
              key: 1,
              text: _(a)("mediaReleases.noResults"),
              "font-size": _(st).SixteenPx,
              class: "d-base-search-box-result__no-results"
            }, null, 8, ["text", "font-size"]))
          ], 32)) : te("", !0)
        ]),
        _: 3
      });
    };
  }
});
const RQ = /* @__PURE__ */ Fe(DQ, [["__scopeId", "data-v-5c5ed203"]]);
var Gt = /* @__PURE__ */ ((e) => (e.Simple = "simple", e.Default = "default", e.DocumentsDownload = "documents-download", e.FreeText = "free-text", e.InputDropdown = "input-dropdown", e))(Gt || {}), Vi = /* @__PURE__ */ ((e) => (e.Default = "default", e.Valid = "valid", e.Invalid = "invalid", e))(Vi || {});
const NQ = ["data-event_source", "data-event_component_name", "data-event_title"], $Q = {
  key: 0,
  class: "d-dws-dropdown-item--image-container"
}, FQ = ["src", "alt"], DC = /* @__PURE__ */ Be({
  __name: "DwsDropdownItem",
  props: {
    value: {
      type: Object,
      required: !0
    },
    isImagesVisible: {
      type: Boolean,
      required: !0
    },
    eventComponentName: {
      type: String,
      required: !0
    },
    eventTitle: {
      type: String,
      default: void 0
    },
    dropdownType: {
      type: String,
      default: Gt.Default
    },
    imageOptions: {
      type: Object,
      default: null
    },
    showIcons: {
      type: Boolean,
      default: !1
    },
    locked: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const t = e, { baseImagePath: n } = Li();
    function i(o) {
      if (o && o.imageUrl) {
        const a = o.imageUrl, r = t.imageOptions, s = r?.folderSubPath, l = r?.extension;
        return `${n}img/${s}/${a}.${l}`;
      } else {
        console.error("imageKey is missing in the option model");
        return;
      }
    }
    return (o, a) => (E(), X("div", {
      class: Pe({
        "d-dws-dropdown-item--image-visible": e.isImagesVisible,
        " d-dws-dropdown-item": e.dropdownType !== _(Gt).Simple,
        " d-dws-dropdown-item-simple ": e.dropdownType === _(Gt).Simple,
        "d-dws-dropdown-item-document-download": e.dropdownType === _(Gt).DocumentsDownload
      }),
      "data-event_source": _(Qe)().pageName,
      "data-event_component_name": e.eventComponentName,
      "data-event_title": e.eventTitle ?? e.value.name
    }, [
      e.isImagesVisible ? (E(), X("div", $Q, [
        oe("img", {
          class: "d-dws-dropdown-item--image",
          src: i(e.value),
          alt: `image-${e.value.name}`
        }, null, 8, FQ),
        a[0] || (a[0] = oe("div", { class: "d-dws-dropdown-item--background" }, null, -1))
      ])) : te("", !0),
      Ve(" " + Ie(e.value.name) + " ", 1),
      e.locked ? (E(), fe(_t, {
        key: 1,
        class: "d-dws-dropdown-item--lock",
        "base-icon": _(H).Lock,
        "base-icon-size": _(at).Inherit,
        "base-icon-color": _(gt).Inherit
      }, null, 8, ["base-icon", "base-icon-size", "base-icon-color"])) : te("", !0)
    ], 10, NQ));
  }
}), jQ = { key: 0 }, HQ = { key: 1 }, zQ = /* @__PURE__ */ Be({
  __name: "DwsDropdownValue",
  props: {
    value: {
      type: Object,
      required: !0
    },
    placeholder: {
      type: String,
      default: ""
    },
    isImagesVisible: {
      type: Boolean,
      required: !0
    },
    eventComponentName: {
      type: String,
      required: !0
    },
    eventTitle: {
      type: String,
      default: void 0
    },
    dropdownType: {
      type: String,
      default: Gt.Default
    },
    imageOptions: {
      type: Object,
      default: null
    }
  },
  setup(e) {
    return (t, n) => e.value ? (E(), X("div", jQ, [
      ue(DC, {
        class: Pe({
          "d-dws-dropdown-item--value ": e.dropdownType !== _(Gt).Simple
        }),
        value: e.value,
        placeholder: e.placeholder,
        "is-images-visible": e.isImagesVisible,
        "event-component-name": e.eventComponentName,
        "event-title": e.eventTitle,
        "dropdown-type": e.dropdownType,
        "image-options": e.imageOptions
      }, null, 8, ["class", "value", "placeholder", "is-images-visible", "event-component-name", "event-title", "dropdown-type", "image-options"])
    ])) : (E(), X("span", HQ, Ie(e.placeholder), 1));
  }
}), VQ = /* @__PURE__ */ Be({
  __name: "DwsDropdownOption",
  props: {
    option: {
      type: Object,
      required: !0
    },
    isImagesVisible: {
      type: Boolean,
      required: !0
    },
    eventComponentName: {
      type: String,
      required: !0
    },
    eventTitle: {
      type: String,
      default: void 0
    },
    dropdownType: {
      type: String,
      default: Gt.Default
    },
    imageOptions: {
      type: Object,
      default: null
    }
  },
  setup(e) {
    return (t, n) => (E(), fe(DC, {
      class: Pe({
        "locked-item": e.option.isLocked
      }),
      value: e.option,
      "is-images-visible": e.isImagesVisible,
      "event-component-name": e.eventComponentName,
      "event-title": e.eventTitle,
      "dropdown-type": e.dropdownType,
      "image-options": e.imageOptions,
      locked: e.option.isLocked
    }, null, 8, ["class", "value", "is-images-visible", "event-component-name", "event-title", "dropdown-type", "image-options", "locked"]));
  }
}), GQ = ["for"], UQ = { key: 0 }, WQ = { key: 1 }, YQ = {
  key: 1,
  class: "d-dws-dropdown--notch"
}, x0 = 4, RC = /* @__PURE__ */ Be({
  __name: "SingleDropdown",
  props: {
    placeholder: {
      type: String,
      default: ""
    },
    items: {
      type: Array,
      required: !0
    },
    selected: {
      type: Object,
      default: void 0
    },
    hasFilter: {
      type: Boolean,
      default: !1
    },
    filterPlaceholder: {
      type: String,
      default: ""
    },
    showImage: {
      type: Boolean,
      default: !1
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    imageOptions: {
      type: Object,
      default: null
    },
    panelClass: {
      type: String,
      default: ""
    },
    appendTo: {
      type: String,
      default: "#dx-overlay"
    },
    locked: {
      type: Object,
      default: void 0
    },
    eventComponentName: {
      type: String,
      default: "DwsDropdown"
    },
    dropdownType: {
      type: String,
      default: Gt.Default
    },
    label: {
      type: String,
      default: ""
    },
    mandatory: {
      type: Boolean,
      default: !1
    },
    errorText: {
      type: String,
      default: null
    },
    state: {
      type: String,
      default: Vi.Default
    },
    inputPattern: {
      type: String,
      default: null
    },
    maxLength: {
      type: Number,
      default: null
    },
    helperText: {
      type: String,
      default: null
    },
    ariaLabelledby: {
      type: String,
      default: null
    }
  },
  emits: ["selected-item-changed", "before-show"],
  setup(e, { emit: t }) {
    const { t: n } = Je(), i = Jt(), o = e, a = ge(), r = ge(-1), s = ge(!1), l = ge(o.state), d = ge(o.selected), y = ge(o.selected), u = ge(o.locked), m = t, h = ge(Pn());
    qe(
      () => o.state,
      (x) => {
        l.value = x;
      },
      { immediate: !0 }
    );
    const c = (x) => !!i[x], g = Te(() => 3.8 * x0 + "rem"), v = Te(() => {
      const x = [];
      return o.dropdownType === Gt.Simple ? x.push("d-dws-dropdown-simple") : x.push("d-dws-dropdown-panel"), o.dropdownType === Gt.FreeText && x.push("d-base-dropdown--free-text__panel"), o.dropdownType === Gt.InputDropdown && x.push("d-base-dropdown--input-dropdown__panel"), o.items.length > x0 && x.push("scrollable"), o.showImage && x.push("d-dws-dropdown-panel--image-visible"), o.panelClass && x.push(o.panelClass), x.join(" ");
    }), P = Te(() => o.showImage && o.imageOptions !== null && o.imageOptions !== void 0 && (o.imageOptions.folderSubPath !== "" || o.imageOptions.folderSubPath !== void 0) && (o.imageOptions.extension !== "" || o.imageOptions.extension !== void 0));
    ws(() => {
      o.items.forEach((x) => {
        x.isSelected && (d.value = x);
      }), o.items.forEach((x) => {
        x.isLocked && (u.value = x);
      });
    }), qe(
      () => o.selected,
      (x) => {
        d.value = x;
      },
      { immediate: !0 }
    );
    const f = (x) => {
      if (l.value = Vi.Default, o.dropdownType === Gt.FreeText || o.dropdownType === Gt.InputDropdown) {
        const k = typeof d.value == "object" ? d.value.name : d.value;
        y.value = {
          name: k,
          value: k,
          isSelected: !0
        };
      } else
        y.value = d.value;
      On("Dropdown", `Selected ${y.value.name}`), m("selected-item-changed", y.value, x);
    };
    function S() {
      if (s.value = !0, a.value) {
        const x = a.value.$el;
        r.value = x.offsetWidth;
      }
      m("before-show");
    }
    const w = () => {
      s.value && Ue && document.querySelector(
        ".d-dws-dropdown-panel"
      )?.querySelector(".p-dropdown-filter")?.focus();
    };
    return (x, k) => (E(), X("div", {
      class: Pe({
        "d-dws-dropdown": e.dropdownType !== _(Gt).Simple,
        "d-dws-dropdown-simple": e.dropdownType === _(Gt).Simple,
        "d-dws-dropdown--free-text": e.dropdownType === _(Gt).FreeText,
        "d-dws-dropdown--input-dropdown": e.dropdownType === _(Gt).InputDropdown,
        "d-dws-dropdown--image-visible": P.value,
        "d-dws-dropdown-document-download": e.dropdownType === _(Gt).DocumentsDownload,
        [`d-dws-dropdown--${l.value}`]: l.value !== _(Vi).Default
      })
    }, [
      e.label || e.mandatory ? (E(), X("label", {
        key: 0,
        for: h.value,
        class: "d-dws-dropdown__label"
      }, [
        e.label ? (E(), fe(_(Tt), {
          key: 0,
          class: "d-dws-dropdown__label__text",
          text: e.label,
          "font-size": _(st).FourteenPx,
          "text-color": _(dt).GreyBlue009,
          "font-type": _(lt).DwsSlabBold
        }, null, 8, ["text", "font-size", "text-color", "font-type"])) : te("", !0),
        e.mandatory ? (E(), fe(_(Tt), {
          key: 1,
          class: "d-dws-dropdown__label__text",
          text: "*",
          "font-size": _(st).FourteenPx,
          "text-color": _(dt).Negative,
          "font-type": _(lt).DwsSlabBold
        }, null, 8, ["font-size", "text-color", "font-type"])) : te("", !0),
        e.helperText ? (E(), fe(_(mh), {
          key: 2,
          text: e.helperText,
          "disable-helper": e.disabled,
          class: "d-dws-dropdown__helper-text"
        }, null, 8, ["text", "disable-helper"])) : te("", !0)
      ], 8, GQ)) : te("", !0),
      ue(_(Ga), {
        ref_key: "dropdownRef",
        ref: a,
        modelValue: d.value,
        "onUpdate:modelValue": k[0] || (k[0] = (A) => d.value = A),
        "input-id": h.value,
        "aria-labelledby": e.ariaLabelledby,
        options: e.items,
        filter: e.hasFilter,
        placeholder: e.placeholder,
        "show-clear": !1,
        "filter-placeholder": e.filterPlaceholder,
        "reset-filter-on-hide": !0,
        "scroll-height": g.value,
        "panel-class": v.value,
        "panel-style": {
          maxWidth: r.value !== -1 && (e.dropdownType === _(Gt).FreeText || e.dropdownType === _(Gt).InputDropdown) || e.showImage ? r.value + "px" : null
        },
        disabled: e.disabled,
        "option-disabled": (A) => A.isDisabled,
        "append-to": e.appendTo,
        "option-label": (A) => A.name + (A.isLocked ? " " + _(n)("tabContainer.requiresLogin") : ""),
        editable: e.dropdownType === _(Gt).FreeText,
        pt: {
          input: {
            pattern: e.inputPattern,
            maxlength: e.maxLength
          }
        },
        onKeydown: Ze(w, ["tab"]),
        onChange: f,
        onBeforeShow: S,
        onBeforeHide: k[1] || (k[1] = (A) => s.value = !1)
      }, Qt({
        filtericon: Se(() => [
          ue(_(_t), {
            class: "filtericon",
            "base-icon": _(H).ArrowRight,
            "base-icon-filled": !0,
            "base-icon-size": _(at).S,
            "base-icon-color": _(gt).White
          }, null, 8, ["base-icon", "base-icon-size", "base-icon-color"])
        ]),
        value: Se((A) => [
          je(x.$slots, "value", si(Ki(A)))
        ]),
        option: Se((A) => [
          je(x.$slots, "option", si(Ki(A)))
        ]),
        footer: Se(() => [
          je(x.$slots, "footer")
        ]),
        _: 2
      }, [
        c("dropdownicon") ? {
          name: "dropdownicon",
          fn: Se(() => [
            je(x.$slots, "dropdownicon", {}, () => [
              e.dropdownType === _(Gt).FreeText || e.dropdownType === _(Gt).InputDropdown ? (E(), X("div", UQ, [
                ue(_(_t), {
                  "base-icon": s.value ? _(H).AngleUp : _(H).AngleDown,
                  "base-icon-size": _(at).M
                }, null, 8, ["base-icon", "base-icon-size"])
              ])) : te("", !0),
              e.dropdownType === _(Gt).FreeText || e.dropdownType === _(Gt).InputDropdown ? (E(), X("div", WQ, [
                l.value !== _(Vi).Default ? (E(), fe(_(_t), {
                  key: 0,
                  "base-icon": l.value === _(Vi).Invalid ? _(H).ExclamationTriangle : _(H).CheckCircle,
                  "base-icon-size": _(at).M,
                  "base-icon-color": l.value === _(Vi).Invalid ? _(gt).Negative : _(gt).Positive
                }, null, 8, ["base-icon", "base-icon-size", "base-icon-color"])) : te("", !0)
              ])) : te("", !0)
            ])
          ]),
          key: "0"
        } : void 0
      ]), 1032, ["modelValue", "input-id", "aria-labelledby", "options", "filter", "placeholder", "filter-placeholder", "scroll-height", "panel-class", "panel-style", "disabled", "option-disabled", "append-to", "option-label", "editable", "pt"]),
      e.dropdownType !== _(Gt).Simple ? (E(), X("div", YQ)) : te("", !0),
      l.value === _(Vi).Invalid && e.errorText ? (E(), fe(_(Tt), {
        key: 2,
        class: "d-dws-dropdown__invalid",
        text: e.errorText,
        "font-size": _(st).TwelvePx,
        "text-color": _(dt).Negative,
        "font-type": _(lt).DwsSlabBold
      }, null, 8, ["text", "font-size", "text-color", "font-type"])) : te("", !0)
    ], 2));
  }
});
const vi = /* @__PURE__ */ Be({
  __name: "DwsDropdown",
  props: {
    placeholder: {
      type: String,
      default: ""
    },
    items: {
      type: Array,
      required: !0
    },
    selected: {
      type: Object,
      default: void 0
    },
    hasFilter: {
      type: Boolean,
      default: !1
    },
    filterPlaceholder: {
      type: String,
      default: ""
    },
    showImage: {
      type: Boolean,
      default: !1
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    imageOptions: {
      type: Object,
      default: null
    },
    panelClass: {
      type: String,
      default: ""
    },
    appendTo: {
      type: String,
      default: "#dx-overlay"
    },
    locked: {
      type: Object,
      default: void 0
    },
    eventComponentName: {
      type: String,
      default: "DwsDropdown"
    },
    eventTitle: {
      type: String,
      default: void 0
    },
    dropdownType: {
      type: String,
      default: Gt.Default
    },
    label: {
      type: String,
      default: ""
    },
    mandatory: {
      type: Boolean,
      default: !1
    },
    invalidText: {
      type: String,
      default: ""
    },
    state: {
      type: String,
      default: Vi.Default
    },
    maxLength: {
      type: Number,
      default: null
    },
    helperText: {
      type: String,
      default: null
    },
    ariaLabelledby: {
      type: String,
      default: null
    }
  },
  setup(e) {
    const t = e, n = Te(() => t.showImage && t.imageOptions !== null && t.imageOptions !== void 0 && (t.imageOptions.folderSubPath !== "" || t.imageOptions.folderSubPath !== void 0) && (t.imageOptions.extension !== "" || t.imageOptions.extension !== void 0));
    return (i, o) => (E(), fe(RC, {
      placeholder: e.placeholder,
      items: e.items,
      selected: e.selected,
      "has-filter": e.hasFilter,
      "filter-placeholder": e.filterPlaceholder,
      "show-image": e.showImage,
      disabled: e.disabled,
      "image-options": e.imageOptions,
      "panel-class": e.panelClass,
      "append-to": e.appendTo,
      locked: e.locked,
      "event-component-name": e.eventComponentName,
      "dropdown-type": e.dropdownType,
      label: e.label,
      mandatory: e.mandatory,
      "invalid-text": e.invalidText,
      state: e.state,
      "max-length": e.maxLength,
      "helper-text": e.helperText,
      "aria-labelledby": e.ariaLabelledby
    }, {
      dropdownicon: Se(() => [
        je(i.$slots, "dropdownicon")
      ]),
      value: Se((a) => [
        a.value ? (E(), fe(zQ, {
          key: 0,
          value: a.value,
          placeholder: e.placeholder,
          "event-component-name": e.eventComponentName,
          "event-title": e.eventTitle,
          "is-images-visible": n.value,
          "image-options": e.imageOptions,
          "dropdown-type": e.dropdownType
        }, null, 8, ["value", "placeholder", "event-component-name", "event-title", "is-images-visible", "image-options", "dropdown-type"])) : te("", !0)
      ]),
      option: Se((a) => [
        ue(VQ, {
          ref: "dwsDropdownItem",
          option: a.option,
          "is-images-visible": n.value,
          "event-component-name": e.eventComponentName,
          "event-title": e.eventTitle,
          "dropdown-type": e.dropdownType,
          "image-options": e.imageOptions
        }, null, 8, ["option", "is-images-visible", "event-component-name", "event-title", "dropdown-type", "image-options"])
      ]),
      _: 3
    }, 8, ["placeholder", "items", "selected", "has-filter", "filter-placeholder", "show-image", "disabled", "image-options", "panel-class", "append-to", "locked", "event-component-name", "dropdown-type", "label", "mandatory", "invalid-text", "state", "max-length", "helper-text", "aria-labelledby"]));
  }
});
const qQ = { class: "d-base-search-box-search-bar__close" }, KQ = /* @__PURE__ */ Be({
  __name: "BaseSearchBoxSearchBar",
  props: {
    model: {
      type: Object,
      required: !0
    },
    result: {
      type: Object,
      default: null
    },
    minLength: {
      type: Number,
      default: 3
    },
    trackingDropdownName: {
      type: String,
      default: "Search"
    },
    debounceInterval: {
      type: Number,
      default: 300
    },
    blockEmptyEnterSearch: {
      type: Boolean
    },
    labelFor: {
      type: String,
      default: void 0
    },
    useCustomClicks: {
      type: Boolean,
      default: !0
    },
    liveSearch: {
      type: Boolean,
      default: !1
    },
    focusInputWithInitTerm: {
      type: Boolean,
      default: !1
    },
    showAlways: {
      type: Boolean,
      default: !1
    },
    isFundFinder: {
      type: Boolean,
      default: !1
    }
  },
  emits: [
    "search",
    "clear",
    "filter-changed",
    "blur",
    "focus",
    "enter",
    "submit",
    "showSuggestions",
    "onButtonClick",
    "typing"
  ],
  setup(e, { expose: t, emit: n }) {
    const i = e, { t: o } = Je(), a = n, r = ge(!1), s = ge(), l = ge(), d = ge(), y = ge(null), u = ge(), m = ge(!1), h = ge([]), c = ge(-1);
    ym(s, () => p());
    const g = Te(() => i?.model?.submitLinkModel ? i?.model?.submitLinkModel : {
      contentUrl: "",
      title: o("globalTranslations.submit"),
      text: "",
      isLocked: !1,
      target: "_self",
      isExternal: !1,
      linkType: yt.Default,
      tealiumTrackingModel: {
        eventSource: Qe().pageName,
        eventComponentName: "Search",
        eventTitle: "Performed",
        eventTarget: S.value
      }
    }), v = Te(() => m.value || i?.showAlways), P = {
      eventSource: Qe().pageName,
      eventComponentName: i.trackingDropdownName,
      eventTitle: "Clear"
    }, f = {
      ...Tm,
      title: o("globalTranslations.clear"),
      text: "",
      tealiumTrackingModel: P
    }, S = ge(
      i.model.searchTerm ? i.model.searchTerm : ""
    ), w = ge(S.value), x = ge(
      i.model.filterOptions?.find((q) => q.isSelected === !0)
    ), k = () => {
      l.value.inputRef.$el.focus();
    }, A = () => {
      i.focusInputWithInitTerm && i.model.searchTerm && i.model.searchTerm !== "" && k();
    };
    it(async () => {
      A(), Ue && (await z(), await F());
    }), sn(() => {
      y.value && y?.value?.removeEventListener("keydown", ae);
    });
    const $ = Te(() => i.result), j = Te(() => i.model.filterOptions && i.model.filterOptions.length > 0), N = Te(() => {
      if (i.model.submitLinkModel && j.value)
        return "d-base-search-box-search-bar__search-input--three";
      if (i.model.submitLinkModel || j.value)
        return "d-base-search-box-search-bar__search-input--two";
    }), M = Te(() => S.value && S.value.length >= i.minLength && w.value !== "" || r.value), D = () => {
      m.value = !1, S.value = "", w.value = "", w.value = "", r.value = !1, a("showSuggestions", !1), a("clear", S.value);
    }, C = () => {
      a("submit", S.value);
    }, b = () => {
      $.value && (m.value = !0, a("showSuggestions", !0));
    }, p = () => {
      m.value = !1, a("showSuggestions", !1);
    }, L = (q) => {
      q.relatedTarget === null && m.value && p(), a("blur", S.value);
    }, B = Jn((q) => {
      if (r.value) {
        r.value = !1;
        return;
      }
      S.value = q, a("search", q), b();
    }, i.debounceInterval), T = (q) => {
      a("typing", q), w.value = q, (q?.length >= i.minLength || r.value) && B(q), q || p();
    }, O = (q) => {
      q ? b() : p(), a("focus", w.value);
    }, I = (q) => {
      !i.liveSearch && (q.key !== "Enter" || i.blockEmptyEnterSearch && !w.value) || (r.value = !0, p(), S.value = w.value !== void 0 ? w.value : "", a("enter", w.value));
    }, R = (q) => {
      let Z = q;
      q.isSelected = !0, x.value?.value === Z?.value && (Z = void 0), x.value = Z, a("filter-changed", Z);
    }, Y = (q) => {
      a("filter-changed", q);
    };
    qe(
      () => i.model.filterOptions,
      (q) => {
        x.value = q?.find(
          (Z) => Z.isSelected === !0
        );
      },
      { immediate: !0, deep: !0 }
    ), qe(
      () => i.model.searchTerm,
      (q) => {
        S.value = q, w.value = q;
      }
    );
    const F = async (q = !1) => {
      await mt(), !(!Ue || !u?.value?.$el || !(u?.value?.$el instanceof HTMLElement)) && (q || (c.value = -1), h.value = Array.from(
        u?.value?.$el?.querySelectorAll('a, button, [tabindex="0"]')
      ));
    };
    qe(
      () => v.value,
      async (q) => {
        q && Ue && u?.value && u?.value?.$el instanceof HTMLElement && (await z(), await F());
      }
    );
    const U = Jt(), Q = (q) => !!U[q], J = async (q) => {
      if (await z(), await F(!0), h.value.length === 0)
        return;
      c.value = (c.value + q + h.value.length) % h.value.length;
      const Z = h.value[c.value];
      Z && typeof Z.focus == "function" && (Z.classList.contains("d-base-search-box-result__block--isin") && J(q).then(() => {
      }), Z.focus());
    }, ee = (q) => {
      v.value && !g.value && !j.value && W(q);
    }, V = (q) => {
      v.value && !j.value && W(q);
    }, G = (q) => {
      v.value && W(q);
    }, W = (q) => {
      q.shiftKey || (q.preventDefault(), J(1));
    }, ae = (q) => {
      if (q.key === "Tab") {
        if (q.shiftKey || !y?.value)
          return;
        q?.preventDefault(), q?.stopPropagation(), k();
      }
    }, z = async () => {
      if (await mt(), !Ue || !u?.value?.$el || !(u?.value?.$el instanceof HTMLElement))
        return;
      const q = u?.value?.$el?.querySelectorAll(
        'a, button, textarea, input[type="text"], input[type="radio"], input[type="checkbox"], select, [tabindex="0"]'
      );
      q?.length && (y?.value?.removeEventListener("keydown", ae), y.value = q[q.length - 1], y?.value?.addEventListener("keydown", ae));
    };
    return t({
      showSuggestionPanel: b,
      hideSuggestionPanel: p,
      focusInput: k
    }), (q, Z) => (E(), X("div", {
      ref_key: "searchBarRef",
      ref: s,
      class: Pe(["d-base-search-box-search-bar", {
        "d-base-search-box-search-bar--heading": e.model.headline?.length > 0
      }])
    }, [
      oe("div", {
        class: Pe(["d-base-search-box-search-bar__search-input", [N.value]])
      }, [
        ue(Es, {
          ref_key: "searchInputRef",
          ref: l,
          label: e.labelFor ? e.labelFor : e.model.placeholder,
          "hide-label": !e.model.showLabel,
          "input-value": w.value,
          placeholder: e.model.placeholder,
          "aria-label": e.model.placeholder,
          "left-icon": _(H).Search,
          onOnKeyup: T,
          onKeydown: [
            I,
            Z[5] || (Z[5] = Ze(It((ne) => J(1), ["prevent"]), ["down"])),
            Z[6] || (Z[6] = Ze(It((ne) => J(-1), ["prevent"]), ["up"]))
          ],
          onClick: O,
          onBlur: L,
          onFocusin: Z[4] || (Z[4] = (ne) => c.value = -1)
        }, {
          "right-icon": Se(() => [
            oe("span", {
              class: "d-base-search-box-search-bar__input-buttons",
              style: hn({
                height: l.value?.inputRef?.$el?.clientHeight + "px"
              })
            }, [
              oe("span", qQ, [
                M.value ? (E(), fe(_(Nt), {
                  key: 0,
                  class: "d-base-search-box-search-bar__clear",
                  "link-model": f,
                  type: _(Ke).Secondary,
                  "button-type": _(zt).Button,
                  size: _(et).Small,
                  icon: _(H).Times,
                  onKeydown: [
                    Ze(ee, ["tab"]),
                    Z[0] || (Z[0] = Ze(It(() => {
                    }, ["stop"]), ["enter"]))
                  ],
                  onClick: D
                }, null, 8, ["type", "button-type", "size", "icon"])) : te("", !0)
              ]),
              g.value ? (E(), fe(_(Nt), {
                key: 0,
                class: "d-base-search-box-search-bar__submit",
                "link-model": g.value,
                type: _(Ke).RoundedPrimary,
                "button-type": _(zt).Button,
                size: _(et).Small,
                icon: _(H).ArrowRight,
                onKeydown: Ze(V, ["tab"]),
                onClick: C
              }, null, 8, ["link-model", "type", "button-type", "size", "icon"])) : te("", !0),
              j.value ? (E(), fe(vi, {
                key: 1,
                ref_key: "filterRef",
                ref: d,
                "dropdown-type": _(Gt).Simple,
                items: e.model.filterOptions,
                selected: { ...x.value, name: "" },
                "has-filter": !1,
                "show-image": !1,
                "panel-class": "d-base-search-box-search-bar__filter-dropdown",
                class: Pe(["d-base-search-box-search-bar__filter-dropdown", {
                  "d-base-search-box-search-bar__no-filter-selected": !x.value
                }]),
                "event-component-name": e.trackingDropdownName,
                onKeydown: [
                  Ze(G, ["tab"]),
                  Z[1] || (Z[1] = Ze(It(() => {
                  }, ["stop"]), ["enter"])),
                  Z[2] || (Z[2] = Ze(It(() => {
                  }, ["stop"]), ["down"])),
                  Z[3] || (Z[3] = Ze(It(() => {
                  }, ["stop"]), ["up"]))
                ],
                onSelectedItemChanged: R
              }, {
                dropdownicon: Se(() => [
                  ue(_(_t), {
                    "base-icon": _(H).SlidersH,
                    class: "d-base-search-box-search-bar__filter-dropdown--icon",
                    tabindex: "0"
                  }, null, 8, ["base-icon"])
                ]),
                _: 1
              }, 8, ["dropdown-type", "items", "selected", "class", "event-component-name"])) : te("", !0)
            ], 4)
          ]),
          _: 1
        }, 8, ["label", "hide-label", "input-value", "placeholder", "aria-label", "left-icon"]),
        v.value ? (E(), fe(RQ, {
          key: 0,
          ref_key: "flyoutRef",
          ref: u,
          "search-term": S.value,
          result: $.value,
          "filter-option": x.value,
          "use-custom-clicks": e.useCustomClicks,
          "show-always": e.showAlways,
          "is-fund-finder": e.isFundFinder,
          class: Pe(e.model.showLabel ? "with-label" : ""),
          onFilterChanged: Y,
          onOnButtonClick: Z[7] || (Z[7] = (ne) => a("onButtonClick", w.value)),
          onKeydown: [
            Z[8] || (Z[8] = Ze(It((ne) => J(1), ["prevent"]), ["down"])),
            Z[9] || (Z[9] = Ze(It((ne) => J(-1), ["prevent"]), ["up"])),
            Ze(It(W, ["prevent"]), ["tab"]),
            Z[10] || (Z[10] = Ze(It((ne) => J(-1), ["shift", "prevent"]), ["tab"]))
          ]
        }, Qt({ _: 2 }, [
          Q("record") ? {
            name: "record",
            fn: Se((ne) => [
              je(q.$slots, "record", { record: ne }, void 0, !0)
            ]),
            key: "0"
          } : void 0
        ]), 1032, ["search-term", "result", "filter-option", "use-custom-clicks", "show-always", "is-fund-finder", "class", "onKeydown"])) : te("", !0)
      ], 2)
    ], 2));
  }
});
const kh = /* @__PURE__ */ Fe(KQ, [["__scopeId", "data-v-6c8ffc78"]]), XQ = {
  key: 0,
  class: "d-croci-company-overview"
}, ZQ = { class: "d-croci-company-overview__search-area" }, JQ = /* @__PURE__ */ Be({
  __name: "CrociCompanyOverviewPage",
  props: {
    model: {
      type: Object,
      required: !0
    }
  },
  setup(e) {
    const t = e, { t: n } = Je(), i = $t("smoothScroll"), { calculateScrollPosition: o } = Fn(), a = ge(t?.model?.initialSearchTerm || ""), r = ge(), s = ge(), l = ge(), d = ge(), y = ge("#croci-search"), u = ge(t?.model?.companyList), m = ge(!1);
    qe(
      () => a.value,
      (f) => {
        if (!f || f === "") {
          u.value = t?.model?.companyList;
          return;
        }
        u.value = t?.model?.companyList?.filter(
          (S) => S.companyTicker.toLowerCase().includes(f.toLowerCase()) || S.companyName.toLowerCase().includes(f.toLowerCase())
        );
      },
      { immediate: !0 }
    );
    const h = (f) => {
      a.value = f;
    }, c = () => {
      d?.value && d.value.focusFirstCompany(), i({
        scrollTo: o(r?.value) || 0,
        duration: 1e3,
        updateHistory: !1
      });
    }, g = () => {
      a.value = "";
    }, v = (f) => {
      y.value = f ? "#shrink-panel" : "#croci-search", m.value && mt().then(() => {
        setTimeout(
          () => {
            s.value?.focusInput();
          },
          f ? 600 : 0
        );
      });
    }, P = Te(() => ({
      placeholder: t?.model?.searchBoxPlaceholder || n("crociCompanyOverviewPage.searchBoxPlaceholder"),
      searchTerm: a.value,
      showLabel: !0
    }));
    return (f, S) => e.model ? (E(), X("div", XQ, [
      e.model && r.value ? (E(), fe(_(BC), {
        key: 0,
        ref_key: "shrinkPanelRef",
        ref: l,
        class: "d-base-shrink-panel__croci-overview",
        "trigger-element": r.value,
        "append-to": e.model?.shrinkSearchAppendTo,
        onExpanded: S[0] || (S[0] = (w) => v(!0)),
        onCollapsed: S[1] || (S[1] = (w) => v(!1))
      }, {
        default: Se(() => [
          ue(_(Vt), {
            id: "croci-shrink-panel",
            "no-margin-bottom": !0
          }, {
            default: Se(() => S[4] || (S[4] = [
              oe("div", { class: "d-croci-company-overview__shrink-search" }, [
                oe("div", {
                  id: "shrink-panel",
                  class: "d-croci-company-overview__shrink-search__bar"
                })
              ], -1)
            ])),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["trigger-element", "append-to"])) : te("", !0),
      ue(_(Vt), {
        id: "croci-overview",
        "no-margin-bottom": !0,
        "no-margin": !0
      }, {
        default: Se(() => [
          ue(Hs, {
            class: Pe(["d-croci-company-overview__header", {
              "d-croci-company-overview__header--no-intro": !e.model?.headerArea?.introText
            }]),
            model: e.model.headerArea,
            "base-heading-type": _(ze).H1
          }, null, 8, ["class", "model", "base-heading-type"]),
          oe("div", ZQ, [
            oe("div", {
              id: "croci-search",
              ref_key: "searchBoxRef",
              ref: r,
              class: "d-croci-company-overview__search"
            }, [
              ue(_(Yn), { "append-to": y.value }, {
                default: Se(() => [
                  ue(kh, {
                    ref_key: "searchRef",
                    ref: s,
                    model: P.value,
                    "is-suppress-open-new-window-on-enter": !0,
                    "label-for": e.model.searchBoxPlaceholder || _(n)("crociCompanyOverviewPage.searchBoxPlaceholder"),
                    "min-length": 0,
                    "debounce-interval": 0,
                    onSearch: h,
                    onEnter: c,
                    onSubmit: c,
                    onClear: g,
                    onFocusin: S[2] || (S[2] = (w) => m.value = !0),
                    onFocusout: S[3] || (S[3] = (w) => m.value = !1)
                  }, null, 8, ["model", "label-for"])
                ]),
                _: 1
              }, 8, ["append-to"])
            ], 512)
          ]),
          ue(_(oee), {
            ref_key: "companyListRef",
            ref: d,
            class: "d-croci-company-overview__results",
            model: e.model.overviewModel,
            companies: u.value,
            letters: e.model.letters,
            "umlaut-as-vowel": e.model.umlautAsVowel,
            "is-searching": a.value.length > 0
          }, null, 8, ["model", "companies", "letters", "umlaut-as-vowel", "is-searching"])
        ]),
        _: 1
      })
    ])) : te("", !0);
  }
});
const TBe = /* @__PURE__ */ Fe(JQ, [["__scopeId", "data-v-72d254fe"]]);
var ui = /* @__PURE__ */ ((e) => (e.Industrials = "Industrials", e.Financials = "Financials", e))(ui || {});
const QQ = {
  "aria-live": "polite",
  class: "d-company-list__hidden"
}, eee = { class: "d-company-list__header" }, tee = { class: "d-company-list__result" }, nee = { class: "d-company-list__result__companies" }, iee = { class: "d-company-list__result__companies__company__ticker" }, _d = "0-9", aee = /* @__PURE__ */ Be({
  __name: "CompanyList",
  props: {
    model: {
      type: Object,
      required: !0
    },
    companies: {
      type: Array,
      required: !1,
      default: () => []
    },
    letters: {
      type: String,
      required: !1,
      default: "ABCDEFGHIJKLMNOPQRSTUVWXYZ#"
    },
    umlautAsVowel: {
      type: Boolean,
      required: !1,
      default: !0
    },
    isSearching: {
      type: Boolean,
      required: !1,
      default: !1
    }
  },
  setup(e, { expose: t }) {
    const n = e, { calculateScrollPosition: i } = Fn(), { t: o } = Je();
    let a = 1;
    const { rootFontSize: r } = Hu(), s = ge(null), l = $t("smoothScroll"), d = Te(() => {
      if (!n?.companies?.length)
        return [];
      const f = m?.value?.length, S = h?.value?.length;
      return f && S ? [ui.Industrials, ui.Financials] : f ? [ui.Industrials] : S ? [ui.Financials] : [];
    }), y = ge({
      [ui.Industrials]: null,
      [ui.Financials]: null
    }), u = () => {
      const f = y.value[ui.Financials];
      if (Ue && f) {
        const S = f.querySelector(
          ".d-company-list__result__companies__company__link"
        );
        S && S.focus({ preventScroll: !0 });
      }
      l({
        scrollTo: i(f, r.value * -4) || 0,
        duration: 1e3,
        updateHistory: !1
      });
    }, m = Te(() => n?.companies?.filter(
      (f) => f.category === ui.Industrials
    )), h = Te(() => n?.companies?.filter(
      (f) => f.category === ui.Financials
    )), c = () => a++, g = Te(() => {
      const f = ge();
      return d.value.length ? f.value = n.companies.length + " " + (n.companies.length === 1 ? o("faqPage.result") : o("faqPage.results")) : f.value = o("faqPage.noResults"), f.value;
    }), v = Te(
      () => (f = []) => {
        const S = {};
        return (n?.letters?.length > 0 ? n.letters.split("") : []).forEach((x) => {
          /[A-Z]/.test(x.toUpperCase()) ? S[x.toUpperCase()] = [] : S[_d] || (S[_d] = []);
        }), f.forEach((x) => {
          let k = x.companyName?.length > 0 ? x.companyName[0].toUpperCase() : _d;
          n.umlautAsVowel && (k = k.normalize("NFD").replace(/[\u0300-\u036f]/g, ""), k.toLowerCase() === "ß" && (k = "S"));
          const A = /[A-Z]/.test(k) ? k : _d;
          S[A] && S[A].push(x);
        }), n?.isSearching && Object.keys(S).forEach((x) => {
          S[x].length === 0 && delete S[x];
        }), S;
      }
    ), P = () => {
      if (a = 1, !Ue || !s?.value)
        return;
      const f = s.value.querySelector(
        ".d-company-list__result__companies__company__link"
      );
      f && f.focus({
        preventScroll: !0
      });
    };
    return qe(
      () => n.companies,
      () => {
        a = 1;
      },
      { deep: !0, immediate: !0 }
    ), t({
      focusFirstCompany: P
    }), (f, S) => e.model ? (E(), X("div", {
      key: 0,
      ref_key: "companyListRef",
      ref: s,
      class: "d-company-list",
      role: "listbox"
    }, [
      oe("div", QQ, Ie(g.value), 1),
      d.value.length ? te("", !0) : (E(), fe(_(Ot), {
        key: 0,
        "base-heading-type": _(ze).H2Section
      }, {
        default: Se(() => [
          oe("span", null, Ie(_(o)("faqPage.noResults")), 1)
        ]),
        _: 1
      }, 8, ["base-heading-type"])),
      (E(!0), X(Re, null, Ge(d.value, (w) => (E(), X("div", {
        key: w,
        ref_for: !0,
        ref: (x) => y.value[w] = x
      }, [
        oe("div", eee, [
          (w === _(ui).Industrials ? e.model.industrialHeadline : e.model.financialHeadline) ? (E(), fe(_(Ot), {
            key: 0,
            "base-heading-type": _(ze).H2Section,
            class: "d-company-list__header__heading"
          }, {
            default: Se(() => [
              oe("span", null, Ie(w === _(ui).Industrials ? e.model.industrialHeadline : e.model.financialHeadline), 1)
            ]),
            _: 2
          }, 1032, ["base-heading-type"])) : te("", !0),
          w === _(ui).Industrials && d.value.find((x) => x === _(ui).Financials) ? (E(), fe(_(ot), {
            key: 1,
            class: "d-company-list__header__detail-page-link",
            "link-model": e.model.ctaLink,
            icon: _(H).ArrowDown,
            "icon-position": _(ct).Left,
            onClick: It(u, ["prevent"]),
            onKeydown: Ze(It(u, ["prevent"]), ["enter"])
          }, null, 8, ["link-model", "icon", "icon-position", "onKeydown"])) : te("", !0)
        ]),
        oe("div", tee, [
          (E(!0), X(Re, null, Ge(v.value(
            w === _(ui).Industrials ? m.value : h.value
          ), (x, k) => (E(), X("div", { key: k }, [
            k ? (E(), fe(_(Ot), {
              key: 0,
              "base-heading-type": _(ze).H3,
              class: Pe(["d-company-list__result__letter", {
                "d-company-list__result__letter--empty": !x?.length
              }])
            }, {
              default: Se(() => [
                oe("span", null, Ie(k), 1)
              ]),
              _: 2
            }, 1032, ["base-heading-type", "class"])) : te("", !0),
            oe("div", nee, [
              (E(!0), X(Re, null, Ge(x, (A) => (E(), X("div", {
                key: `${A.companyName}_${A.companyTicker}`,
                class: "d-company-list__result__companies__company"
              }, [
                A.link ? (E(), fe(_(ot), {
                  key: 0,
                  class: "d-company-list__result__companies__company__link",
                  role: "option",
                  "link-model": A.link,
                  "aria-setsize": e.companies.length || 0,
                  "aria-posinset": c()
                }, null, 8, ["link-model", "aria-setsize", "aria-posinset"])) : te("", !0),
                oe("p", iee, Ie(A.companyTicker), 1)
              ]))), 128))
            ])
          ]))), 128))
        ])
      ]))), 128))
    ], 512)) : te("", !0);
  }
});
const oee = /* @__PURE__ */ Fe(aee, [["__scopeId", "data-v-ddb1a373"]]);
var $n = /* @__PURE__ */ ((e) => (e[e.Zero = 0] = "Zero", e[e.One = 1] = "One", e[e.Two = 2] = "Two", e[e.AudienceCulture = 3] = "AudienceCulture", e))($n || {});
const ree = {
  key: 0,
  class: "d-header-breadcrumb"
}, see = { class: "d-header-breadcrumb__first" }, lee = {
  key: 0,
  class: "d-header-breadcrumb__second"
}, cee = /* @__PURE__ */ Be({
  __name: "HeaderBreadcrumb",
  props: {
    currentLevel: {
      type: Number,
      required: !0
    },
    levelZeroTriggerLinkModel: {
      type: Object,
      required: !0
    },
    currentItem: {
      type: Object,
      required: !0
    }
  },
  emits: ["click"],
  setup(e, { emit: t }) {
    const n = e, i = t, { t: o } = Je(), a = Te(() => n?.currentLevel === $n.AudienceCulture ? o("globalTranslations.backLinkText") : o("header.main")), r = Te(() => n.currentLevel === $n.Two || n.currentLevel === $n.AudienceCulture ? H.AngleLeft : H.Bars), s = () => {
      i("click");
    };
    return (l, d) => e.currentLevel !== _($n).Zero ? (E(), X("ul", ree, [
      oe("li", see, [
        ue(_(ot), {
          role: "button",
          "link-model": e.levelZeroTriggerLinkModel,
          "font-size": _(yn).FourteenPx,
          "icon-size": _(at).NextToText,
          icon: r.value,
          "icon-position": _(ct).Left,
          alt: a.value,
          onClick: s,
          onKeydown: Ze(s, ["enter"])
        }, null, 8, ["link-model", "font-size", "icon-size", "icon", "icon-position", "alt"])
      ]),
      e.currentLevel !== _($n).AudienceCulture ? (E(), X("li", lee, [
        ue(_(ot), {
          class: "d-header-breadcrumb__second__link",
          "link-model": e.currentItem?.link,
          "font-size": _(yn).FourteenPx
        }, null, 8, ["link-model", "font-size"])
      ])) : te("", !0)
    ])) : te("", !0);
  }
});
const dee = /* @__PURE__ */ Fe(cee, [["__scopeId", "data-v-f67fdb35"]]), uee = {
  key: 0,
  class: "d-header-menu"
}, hee = /* @__PURE__ */ Be({
  __name: "HeaderMenu",
  props: {
    model: {
      type: Object,
      required: !0
    },
    activeItemText: {
      type: String,
      required: !1,
      default: null
    },
    fontSize: {
      type: String,
      default: yn.FourteenPx
    },
    showArrows: {
      type: Boolean,
      default: !0
    }
  },
  emits: ["click"],
  setup(e, { emit: t }) {
    const n = e, i = t, { t: o } = Je(), a = Te(() => (y) => ({
      ...y?.link,
      tealiumTrackingModel: {
        ...y?.link?.tealiumTrackingModel,
        eventComponentName: "Text Links (next page)"
      }
    })), r = Te(() => n?.model?.link?.href ? !n?.model?.items || !n?.model?.items.length ? [] : n?.model?.items?.find(
      (m) => m?.link?.href === n?.model?.link?.href
    ) ? n?.model?.items : [{ ...n?.model, items: null, isActive: !1 }, ...n.model.items] : n?.model?.items), s = Te(() => (y) => !y?.link?.href || y?.items?.length && !y?.link?.isLocked ? "button" : null), l = Te(() => (y) => n?.showArrows ? y?.link?.isLocked ? H.Lock : y?.items?.length ? H.AngleRight : null : null), d = (y, u) => {
      !u?.items?.length || u?.link?.isLocked || !n?.showArrows || (y?.preventDefault(), i("click", u));
    };
    return (y, u) => e.model ? (E(), X("ul", uee, [
      (E(!0), X(Re, null, Ge(r.value, (m, h) => (E(), X("li", {
        key: `${m?.link?.text}_${h}`,
        class: "d-header-menu__item"
      }, [
        ue(_(ot), {
          "link-model": a.value(m),
          role: s.value(m),
          icon: l.value(m),
          "icon-position": _(ct).Right,
          "icon-aria-hidden": m?.link?.isLocked ? null : !0,
          "icon-aria-label": m?.link?.isLocked ? _(o)("globalTranslations.lockedContentLabel") : null,
          "font-size": e.fontSize,
          class: Pe(["d-header-menu__item__link", {
            "d-header-menu__item__link--active": e.activeItemText === m?.link?.text || m?.isActive
          }]),
          "aria-expanded": m?.items?.length ? e.activeItemText === m?.link?.text : null,
          onClick: (c) => d(c, m),
          onKeydown: Ze((c) => d(c, m), ["enter"])
        }, null, 8, ["link-model", "role", "icon", "icon-position", "icon-aria-hidden", "icon-aria-label", "font-size", "class", "aria-expanded", "onClick", "onKeydown"])
      ]))), 128))
    ])) : te("", !0);
  }
});
const _f = /* @__PURE__ */ Fe(hee, [["__scopeId", "data-v-9d0b3f64"]]);
var qi = /* @__PURE__ */ ((e) => (e.Text = "text", e.Document = "document", e.DocumentArchivePage = "document-archive-page", e.VideoTeaser = "video-teaser", e.VideoPlayer = "video-player", e.AudioPlayer = "audio-player", e.AudioPlayerWithImage = "audio-player-with-image", e))(qi || {}), Ti = /* @__PURE__ */ ((e) => (e.Row = "row", e.Column = "column", e))(Ti || {}), En = /* @__PURE__ */ ((e) => (e.Black = "black", e.White = "white", e.Grey = "grey", e.GreyBlue009 = "grey-blue-009", e.GreyBlue001 = "grey-blue-001", e.GreyBlue000 = "grey-blue-000", e.Transparent = "transparent", e))(En || {}), mi = /* @__PURE__ */ ((e) => (e.White = "white", e.NearWhite = "near-white", e.GreyBlue009 = "grey-blue-009", e.GreyBlue006 = "grey-blue-006", e.Petrol45 = "petrol-45", e.Black = "black", e))(mi || {}), nu = /* @__PURE__ */ ((e) => (e.Text = "text", e.MorningStarRating = "morning-star-rating", e))(nu || {});
const pee = { class: "d-morningstar__morningstar" }, fee = {
  key: 1,
  class: "d-morningstar__star-text"
}, mee = /* @__PURE__ */ Be({
  __name: "MorningstarRating",
  props: {
    model: {
      type: Object,
      required: !0
    },
    insideComponent: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const { t } = Je(), n = e, i = ge(), o = Te(() => {
      let a = "(" + n.model.value + " ";
      switch (n.model.value) {
        case 1:
          a = a + t("globalTranslations.star") + ")";
          break;
        case 2:
        case 3:
        case 4:
        case 5:
          a = a + t("globalTranslations.stars") + ")";
          break;
        default:
          a = "";
      }
      return a;
    });
    return it(() => {
      if (!n.insideComponent) {
        const a = i.value.$el.querySelectorAll(".las.la-star");
        if (a.length > 0) {
          const r = a[a.length - 1];
          pn({
            trigger: r,
            content: n.model.tooltip,
            appendTo: r.value,
            showOnTouchDevices: !0,
            field: () => r,
            triggerTarget: i.value.$el
          });
        }
      }
    }), (a, r) => {
      const s = $e("BaseText");
      return E(), X("div", {
        class: Pe(["d-morningstar", { "d-morningstar__inside": e.insideComponent }])
      }, [
        oe("div", pee, [
          ue(_(Xu), {
            ref_key: "morningstarRating",
            ref: i,
            "model-value": e.model.value,
            readonly: !0,
            stars: 5,
            cancel: !1,
            "on-icon": "las la-star",
            "off-icon": "lar la-star",
            class: "d-morningstar__rating",
            role: "img",
            "aria-label": n.model.value + " " + _(t)("globalTranslations.outOfStars")
          }, null, 8, ["model-value", "aria-label"])
        ]),
        e.model.relatedFunds ? (E(), fe(s, {
          key: 0,
          class: "d-morningstar__related-funds",
          "text-color": _(dt).GreyBlue008,
          "font-size": _(st).SixteenPx,
          "font-type": _(lt).DwsSans,
          text: e.model.relatedFunds
        }, null, 8, ["text-color", "font-size", "font-type", "text"])) : te("", !0),
        e.insideComponent ? (E(), X("span", fee, Ie(o.value), 1)) : te("", !0)
      ], 2);
    };
  }
});
const Sh = /* @__PURE__ */ Fe(mee, [["__scopeId", "data-v-c2f373e3"]]), gee = {
  key: 0,
  class: "d-base-tag--label"
}, vee = { class: "d-base-tag--label" }, yee = /* @__PURE__ */ Be({
  __name: "BaseTag",
  props: {
    linkModel: {
      type: Object,
      default: null
    },
    backgroundColor: {
      type: String,
      default: En.White
    },
    color: {
      type: String,
      default: mi.GreyBlue009
    },
    tagText: {
      type: String,
      required: !0
    },
    isBorderVisible: {
      type: Boolean,
      default: !0
    },
    valueType: {
      type: String,
      default: nu.Text
    }
  },
  setup(e) {
    const t = e, n = Te(() => t.linkModel ? "d-base-tag--petrol-45" : `d-base-tag--${t.color}`), i = Te(() => `d-base-tag--${t.backgroundColor}-bg`), o = Te(() => t.isBorderVisible === !1 ? "d-base-tag--no-border" : ""), a = Jt(), r = Te(() => a.icon ? "d-base-tag--with-icon" : ""), s = (l, d) => {
      switch (d) {
        case nu.Text:
          return At("span", { innerHTML: l });
        case nu.MorningStarRating:
          return At(Sh, {
            model: {
              value: +l,
              tooltip: "",
              relatedFunds: null
            },
            insideComponent: !0
          });
        default:
          return At("span", { innerHTML: l });
      }
    };
    return (l, d) => (E(), X("div", {
      class: Pe(["d-base-tag", [n.value, i.value, o.value, r.value]])
    }, [
      e.linkModel ? te("", !0) : (E(), X("span", gee, [
        (E(), fe(tt(s(t.tagText, t.valueType))))
      ])),
      e.linkModel ? (E(), fe(ot, {
        key: 1,
        class: "d-base-tag--link",
        "has-text": !1,
        "aria-label": e.tagText,
        "link-model": e.linkModel,
        "font-size": _(zi).TwelvePx
      }, {
        container: Se(() => [
          oe("span", vee, [
            (E(), fe(tt(s(t.tagText, t.valueType))))
          ])
        ]),
        _: 1
      }, 8, ["aria-label", "link-model", "font-size"])) : te("", !0),
      l.$slots.icon ? je(l.$slots, "icon", { key: 2 }, void 0, !0) : te("", !0)
    ], 2));
  }
});
const Ji = /* @__PURE__ */ Fe(yee, [["__scopeId", "data-v-dd4f2edf"]]), bee = /* @__PURE__ */ Be({
  __name: "BaseTagList",
  props: {
    tags: {
      type: Array,
      required: !0
    },
    backgroundColor: {
      type: String,
      default: void 0
    },
    color: {
      type: String,
      default: void 0
    },
    isBorderVisible: {
      type: Boolean,
      default: void 0
    },
    alignRight: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    return (t, n) => (E(), X("div", {
      class: Pe(["d-base-tag-list", { "d-base-tag-list__right": e.alignRight }])
    }, [
      (E(!0), X(Re, null, Ge(e.tags, (i, o) => (E(), X("div", { key: o }, [
        ue(Ji, Ce({
          "tag-text": i.label,
          ref_for: !0
        }, i, {
          "background-color": e.backgroundColor,
          color: e.color,
          "is-border-visible": e.isBorderVisible
        }), null, 16, ["tag-text", "background-color", "color", "is-border-visible"])
      ]))), 128))
    ], 2));
  }
});
const Ch = /* @__PURE__ */ Fe(bee, [["__scopeId", "data-v-7d7a1c95"]]), xee = {
  key: 0,
  class: "d-base-card__body"
}, wee = {
  key: 0,
  class: "d-base-card__title"
}, kee = {
  key: 1,
  class: "d-base-card__content"
}, See = {
  key: 2,
  class: "d-base-card__footer"
}, Cee = {
  key: 1,
  class: "d-base-card__header"
}, Tee = {
  key: 2,
  class: "d-base-card__corner"
}, Lee = /* @__PURE__ */ Be({
  __name: "BaseCard",
  props: {
    model: {
      type: Object,
      required: !0
    },
    direction: {
      type: String,
      default: Ti.Column
    },
    showTags: {
      type: Boolean,
      default: !0
    }
  },
  setup(e) {
    const t = e, n = Jt(), i = (r) => !!n[r], o = Te(() => t.model?.headerTags ? Qx(t.model.headerTags) : []), a = Te(() => {
      switch (t.model.type) {
        case qi.Document:
        case qi.DocumentArchivePage:
          return H.Download;
        case qi.Text:
          return H.AngleRight;
        case qi.VideoTeaser:
          return H.Play;
      }
    });
    return (r, s) => {
      const l = $e("BaseLinkV2"), d = $e("BaseIcon");
      return e.model ? (E(), X("div", {
        key: 0,
        class: Pe(["d-base-card", {
          "d-base-card--no-corner": e.model.hideCorner,
          "d-base-card--column-direction": e.direction === _(Ti).Column,
          "d-base-card--row-direction": e.direction === _(Ti).Row
        }])
      }, [
        i("title") || i("content") || i("footer") ? (E(), X("div", xee, [
          i("title") ? (E(), X("div", wee, [
            je(r.$slots, "title", {}, void 0, !0)
          ])) : te("", !0),
          i("content") ? (E(), X("div", kee, [
            je(r.$slots, "content", {}, void 0, !0)
          ])) : te("", !0),
          i("footer") ? (E(), X("div", See, [
            je(r.$slots, "footer", {}, void 0, !0)
          ])) : te("", !0)
        ])) : te("", !0),
        i("header") ? (E(), X("div", Cee, [
          e.showTags && o.value && o.value?.length > 0 ? (E(), fe(Ch, {
            key: 0,
            tags: o.value,
            "background-color": _(En).GreyBlue009,
            color: _(mi).NearWhite,
            "is-border-visible": !1,
            "align-right": !0,
            class: "d-base-card__header-tags"
          }, null, 8, ["tags", "background-color", "color"])) : te("", !0),
          je(r.$slots, "header", {}, void 0, !0)
        ])) : te("", !0),
        e.model.hideCorner ? te("", !0) : (E(), X("div", Tee, [
          e.model.linkModel ? (E(), fe(l, {
            key: 0,
            class: "d-base-card-linked",
            "has-text": !1,
            "font-size": _(yn).TwentyPx,
            icon: a.value,
            "icon-color": _(gt).White,
            "icon-size": _(at).Inherit,
            "aria-label": e.model.linkModel.title,
            "link-model": e.model.linkModel
          }, null, 8, ["font-size", "icon", "icon-color", "icon-size", "aria-label", "link-model"])) : (E(), fe(d, {
            key: 1,
            "base-icon": a.value,
            "base-icon-color": _(gt).White,
            "base-icon-size": _(at).Inherit
          }, null, 8, ["base-icon", "base-icon-color", "base-icon-size"]))
        ]))
      ], 2)) : te("", !0);
    };
  }
});
const Th = /* @__PURE__ */ Fe(Lee, [["__scopeId", "data-v-a3bc4063"]]), Iee = /* @__PURE__ */ Be({
  __name: "BaseCardClickable",
  props: {
    model: {
      type: Object,
      required: !0
    },
    direction: {
      type: String,
      default: Ti.Column
    },
    showTags: {
      type: Boolean,
      default: !0
    }
  },
  setup(e) {
    const t = Jt(), n = (i) => !!t[i];
    return (i, o) => {
      const a = $e("BaseLinkV2");
      return e.model ? (E(), fe(a, {
        key: 0,
        class: "d-base-card-clickable",
        "has-text": !1,
        "aria-label": e.model.linkModel.title,
        "link-model": e.model.linkModel
      }, {
        container: Se(() => [
          ue(Th, {
            model: e.model,
            "show-tags": e.showTags,
            direction: e.direction
          }, Qt({ _: 2 }, [
            n("header") ? {
              name: "header",
              fn: Se(() => [
                je(i.$slots, "header", {}, void 0, !0)
              ]),
              key: "0"
            } : void 0,
            n("content") ? {
              name: "content",
              fn: Se(() => [
                je(i.$slots, "content", {}, void 0, !0)
              ]),
              key: "1"
            } : void 0
          ]), 1032, ["model", "show-tags", "direction"])
        ]),
        _: 3
      }, 8, ["aria-label", "link-model"])) : te("", !0);
    };
  }
});
const NC = /* @__PURE__ */ Fe(Iee, [["__scopeId", "data-v-2884e44e"]]), Pee = { class: "d-header-teaser__content" }, Aee = /* @__PURE__ */ Be({
  __name: "HeaderTeaser",
  props: {
    model: {
      type: Object,
      required: !0
    }
  },
  setup(e) {
    return (t, n) => e.model ? (E(), fe(_(NC), {
      key: 0,
      class: "d-header-teaser",
      model: {
        type: _(qi).Text,
        hideCorner: !1,
        backgroundColor: _(Zt).Transparent,
        linkModel: e.model?.link
      }
    }, {
      header: Se(() => [
        ue(_(di), {
          model: e.model?.image,
          "aspect-ratio": _(on).Original
        }, null, 8, ["model", "aspect-ratio"])
      ]),
      content: Se(() => [
        oe("div", Pee, Ie(e.model?.link?.text), 1)
      ]),
      _: 1
    }, 8, ["model"])) : te("", !0);
  }
});
const $C = /* @__PURE__ */ Fe(Aee, [["__scopeId", "data-v-baccce10"]]);
var Oo = /* @__PURE__ */ ((e) => (e.Audience = "audience", e.Culture = "culture", e))(Oo || {});
function _ee(e) {
  var t = e == null ? 0 : e.length;
  return t ? e[t - 1] : void 0;
}
var Mee = _ee;
const Oee = /* @__PURE__ */ en(Mee), Bee = {
  key: 0,
  class: "d-audience-culture-selection-flyout-content-item"
}, Eee = ["src"], Dee = /* @__PURE__ */ Be({
  __name: "AudienceCultureSelectionFlyoutContentItem",
  props: {
    model: {
      type: Object,
      required: !0
    },
    imageOptions: {
      type: Object,
      default: null
    },
    type: {
      type: String,
      default: Oo.Audience
    }
  },
  emits: ["audience-culture-selection-item-clicked"],
  setup(e, { emit: t }) {
    const n = e, { pageName: i } = Qe(), o = t, a = (d) => {
      o("audience-culture-selection-item-clicked", d, n.model);
    }, r = () => ({
      ...n.model.link,
      tealiumTrackingModel: {
        eventSource: i,
        eventComponentName: "AudienceCultureSelectionFlyoutContent",
        eventTitle: n.model.link.text
      }
    }), { baseImagePath: s } = Li(), l = (d) => {
      if (d && d.id) {
        const y = n.imageOptions, u = y?.folderSubPath, m = y?.extension, h = d?.id?.split("-"), c = h?.length === 1 ? "globe-solid.svg" : `${Oee(h)}.${m}`;
        return `${s}img/${u}/${c}`;
      } else {
        console.error("key is missing in the item model");
        return;
      }
    };
    return (d, y) => e.model ? (E(), X("div", Bee, [
      ue(vt, {
        "link-model": r(),
        class: Pe(["d-audience-culture-selection-flyout-content-item__link", e.model.isActive ? "active" : ""]),
        icon: e.model.icon,
        size: _(et).Small,
        type: _(Ke).Unstyled,
        "button-type": e.type === _(Oo).Audience ? _(zt).Button : _(zt).Link,
        "icon-position": _(ct).Left,
        "aria-pressed": e.type === _(Oo).Audience ? e.model.isActive : void 0,
        "aria-current": e.type === _(Oo).Culture && e.model.isActive ? "page" : void 0,
        onClick: a
      }, Qt({ _: 2 }, [
        e.model.useImage ? {
          name: "custom-icon",
          fn: Se(() => [
            oe("img", {
              class: "d-audience-culture-selection-flyout-content-item__link__image",
              src: l(e.model)
            }, null, 8, Eee)
          ]),
          key: "0"
        } : void 0
      ]), 1032, ["link-model", "class", "icon", "size", "type", "button-type", "icon-position", "aria-pressed", "aria-current"])
    ])) : te("", !0);
  }
});
const Ree = /* @__PURE__ */ Fe(Dee, [["__scopeId", "data-v-ce202eeb"]]), Nee = {
  key: 0,
  class: "d-audience-culture-selection-flyout-content-item-list"
}, $ee = /* @__PURE__ */ Be({
  __name: "AudienceCultureSelectionFlyoutContentItemList",
  props: {
    model: {
      type: Object,
      required: !0
    },
    imageOptions: {
      type: Object,
      default: null
    },
    type: {
      type: String,
      default: Oo.Audience
    },
    breakInColumns: {
      type: Boolean,
      default: !0
    }
  },
  emits: ["item-changed"],
  setup(e, { emit: t }) {
    const n = e, i = () => {
      const s = Math.floor(n.model.items.length / 3), l = n.model.items.length % 3;
      return {
        columnOne: l > 0 ? s + 1 : s,
        columnTwo: l > 1 ? s + 1 : s
      };
    }, o = Te(() => {
      if (!n.breakInColumns)
        return [n.model.items];
      const { columnOne: s, columnTwo: l } = i(), d = n.model.items.slice(0, s), y = n.model.items.slice(
        s,
        s + l
      ), u = n.model.items.slice(s + l);
      return [d, y, u];
    }), a = t, r = (s, l) => {
      a("item-changed", s, l);
    };
    return (s, l) => {
      const d = $e("BaseHeading");
      return e.model.items && e.model.items?.length > 0 ? (E(), X("div", Nee, [
        ue(d, {
          "base-heading-type": _(ze).H2LooksLikeH3,
          class: "d-audience-culture-selection-flyout-content-item-list__headline"
        }, {
          default: Se(() => [
            Ve(Ie(e.model.headline), 1)
          ]),
          _: 1
        }, 8, ["base-heading-type"]),
        oe("div", {
          class: Pe(["d-audience-culture-selection-flyout-content-item-list__block", {
            "only-one-col": !e.breakInColumns
          }])
        }, [
          (E(!0), X(Re, null, Ge(o.value, (y, u) => (E(), X("div", {
            key: u,
            class: "d-audience-culture-selection-flyout-content-item-list__column"
          }, [
            (E(!0), X(Re, null, Ge(y, (m) => (E(), X("div", {
              key: m.id,
              class: "d-audience-culture-selection-flyout-content-item-list__item"
            }, [
              ue(Ree, {
                model: m,
                "image-options": e.imageOptions,
                type: e.type,
                onAudienceCultureSelectionItemClicked: r
              }, null, 8, ["model", "image-options", "type"])
            ]))), 128))
          ]))), 128))
        ], 2)
      ])) : te("", !0);
    };
  }
});
const w0 = /* @__PURE__ */ Fe($ee, [["__scopeId", "data-v-a642269a"]]), Fee = { class: "d-audience-culture-selection-flyout-content" }, jee = { class: "d-audience-culture-selection-flyout-content__container" }, Hee = {
  key: 0,
  class: "d-audience-culture-selection-flyout-content__section d-audience-culture-selection-flyout-content__section--audience"
}, zee = {
  key: 1,
  class: "d-audience-culture-selection-flyout-content__section d-audience-culture-selection-flyout-content__section--culture"
}, Vee = /* @__PURE__ */ Be({
  __name: "AudienceCultureSelectionFlyoutContent",
  props: {
    culture: {
      type: Object,
      required: !0
    },
    audience: {
      type: Object,
      default: void 0
    },
    imageOptions: {
      type: Object,
      default: null
    }
  },
  emits: ["audience-changed", "culture-changed"],
  setup(e, { emit: t }) {
    const n = e, i = t, o = ge(), a = ge(), r = ge(n.audience), s = ge(n.culture), l = (u, m) => {
      o.value = m, i("audience-changed", u, m);
    }, d = (u, m) => {
      a.value = m, y(m, s.value), i("culture-changed", u, m);
    }, y = (u, m) => {
      m.items.forEach((h) => {
        h.isActive = h == u;
      });
    };
    return qe(
      () => n.audience,
      (u) => {
        r.value = u;
      }
    ), qe(
      () => n.culture,
      (u) => {
        s.value = u;
      }
    ), (u, m) => (E(), X("div", Fee, [
      oe("div", jee, [
        r.value ? (E(), X("div", Hee, [
          ue(w0, {
            model: r.value,
            "image-options": e.imageOptions,
            type: _(Oo).Audience,
            "break-in-columns": !1,
            onItemChanged: l
          }, null, 8, ["model", "image-options", "type"])
        ])) : te("", !0),
        s.value ? (E(), X("div", zee, [
          ue(w0, {
            model: s.value,
            "image-options": e.imageOptions,
            type: _(Oo).Culture,
            onItemChanged: d
          }, null, 8, ["model", "image-options", "type"])
        ])) : te("", !0)
      ])
    ]));
  }
});
const Dg = /* @__PURE__ */ Fe(Vee, [["__scopeId", "data-v-e2a3cb2e"]]), Gee = {
  key: 0,
  class: "d-audience-disclaimer-modal"
}, Uee = { class: "d-audience-disclaimer-modal__footer" }, Wee = /* @__PURE__ */ Be({
  __name: "AudienceDisclaimerModal",
  props: {
    model: {
      type: Object,
      required: !0
    },
    appendTo: {
      type: String,
      required: !1,
      default: "body"
    }
  },
  emits: ["close", "accept", "cancel"],
  setup(e, { emit: t }) {
    const n = e, { t: i } = Je(), { pageName: o } = Qe(), a = t, r = ge(n.model.showModal), s = (m) => {
      r.value = !1, a("close", m, n.model);
    }, l = (m) => {
      r.value = !1, a("cancel", m, n.model);
    }, d = (m) => {
      r.value = !1, a("accept", m, n.model);
    }, y = () => ({
      contentUrl: "",
      title: i("Cancel"),
      text: i("Cancel"),
      isLocked: !1,
      target: "",
      isExternal: !1,
      linkType: yt.Javascript,
      tealiumTrackingModel: {
        eventSource: o,
        eventComponentName: "Audience disclaimer",
        eventTitle: "Audience disclaimer cancel"
      }
    }), u = () => ({
      contentUrl: "",
      title: i("Accept"),
      text: i("Accept"),
      isLocked: !1,
      target: "",
      isExternal: !1,
      linkType: yt.Javascript,
      tealiumTrackingModel: {
        eventSource: o,
        eventComponentName: "Audience disclaimer",
        eventTitle: "Audience disclaimer accept"
      }
    });
    return qe(
      () => n.model.showModal,
      (m) => {
        r.value = m;
      },
      { immediate: !0 }
    ), (m, h) => {
      const c = $e("BaseHeading");
      return e.model ? (E(), X("div", Gee, [
        ue(Ei, {
          display: r.value,
          "append-to": e.appendTo,
          onCloseDialog: s
        }, {
          header: Se(() => [
            oe("div", null, [
              ue(c, {
                "base-heading-type": _(ze).H2Section
              }, {
                default: Se(() => [
                  Ve(Ie(e.model.audience), 1)
                ]),
                _: 1
              }, 8, ["base-heading-type"])
            ])
          ]),
          content: Se(() => [
            ue(ht, {
              "html-text": e.model.disclaimerText,
              class: "d-audience-disclaimer-modal__content"
            }, null, 8, ["html-text"])
          ]),
          footer: Se(() => [
            oe("div", Uee, [
              ue(vt, {
                "link-model": y(),
                type: _(Ke).Secondary,
                size: _(et).Small,
                class: "d-audience-disclaimer-modal__button",
                onClick: l
              }, null, 8, ["link-model", "type", "size"]),
              ue(vt, {
                "link-model": u(),
                type: _(Ke).Primary,
                size: _(et).Small,
                class: "d-audience-disclaimer-modal__button",
                "data-id": "silktide-accept",
                onClick: d
              }, null, 8, ["link-model", "type", "size"])
            ])
          ]),
          _: 1
        }, 8, ["display", "append-to"])
      ])) : te("", !0);
    };
  }
});
const Rg = /* @__PURE__ */ Fe(Wee, [["__scopeId", "data-v-0917882a"]]), Yee = {
  key: 0,
  class: "d-header-mobile-menu"
}, qee = {
  key: 0,
  class: "d-header-mobile-menu__teaser__wrapper"
}, Kee = {
  key: 2,
  class: "d-header-mobile-menu__further-items"
}, Xee = /* @__PURE__ */ Be({
  __name: "HeaderMobileMenu",
  props: {
    model: {
      type: Object,
      required: !0
    }
  },
  emits: ["audience-changed", "culture-changed"],
  setup(e, { emit: t }) {
    const n = e, i = t, { t: o } = Je(), a = ge(!1), r = ge(null), s = ge(null), l = ge($n.Zero), d = Te(
      () => ({
        link: null,
        items: n?.model?.itemList
      })
    ), y = ge(d.value), u = ge(null), m = ge(
      $n.Zero
    ), h = Te(() => {
      const N = l.value === $n.AudienceCulture ? o("globalTranslations.backLinkText") : u.value?.link?.text || n.model?.iconList?.moreMobileIcon?.backText || "";
      return {
        contentUrl: "",
        title: N,
        text: N,
        isLocked: !1,
        isExternal: !1,
        linkType: yt.Javascript,
        tealiumTrackingModel: {
          eventSource: Qe().pageName,
          eventComponentName: "Header",
          eventTitle: N
        }
      };
    }), c = Te(
      () => ({
        link: {
          contentUrl: "",
          title: v.value,
          text: v.value,
          isLocked: !1,
          isExternal: !1,
          linkType: yt.Javascript,
          tealiumTrackingModel: {
            eventSource: Qe().pageName,
            eventComponentName: "Header",
            eventTitle: v.value
          }
        }
      })
    ), g = Te(
      () => ({
        audience: r?.value?.link?.text,
        disclaimerText: r?.value?.disclaimerText,
        showModal: a.value
      })
    ), v = Te(() => r?.value && s.value ? `${s?.value?.link?.text} / ${r?.value?.link?.text}` : r?.value?.link?.text || s?.value?.link?.text || ""), P = () => {
      if (l.value === $n.AudienceCulture) {
        l.value = m.value;
        return;
      } else
        l.value === $n.One ? (y.value = d.value, l.value = $n.Zero) : l.value === $n.Two && (y.value = u.value, l.value = $n.One);
      u.value = null;
    }, f = (N) => {
      u.value = l.value === $n.One ? y.value : null, y.value = N, l.value++;
    }, S = () => {
      m.value = l.value, l.value = $n.AudienceCulture;
    }, w = (N, M) => {
      N.preventDefault(), r.value = M, M?.disclaimerText ? a.value = !0 : k(N);
    }, x = (N, M) => {
      s.value = M, i("culture-changed", M);
    }, k = (N) => {
      n?.model?.iconList?.audienceIcon?.audience?.items?.forEach((M) => {
        M.isActive = M?.id === r?.value?.id;
      }), i("audience-changed", N, r?.value);
    }, A = (N) => {
      N.preventDefault(), k(N), a.value = !1;
    }, $ = () => {
      j(), a.value = !1;
    }, j = () => {
      n?.model?.iconList?.audienceIcon?.culture?.items?.forEach((N) => {
        N?.isActive && (s.value = N);
      }), n?.model?.iconList?.audienceIcon?.audience?.items?.forEach((N) => {
        N?.isActive && (r.value = N);
      });
    };
    return it(() => {
      j();
    }), (N, M) => e.model ? (E(), X("div", Yee, [
      ue(_(dee), {
        "current-level": l.value,
        "level-zero-trigger-link-model": h.value,
        "current-item": y.value,
        onClick: P
      }, null, 8, ["current-level", "level-zero-trigger-link-model", "current-item"]),
      l.value !== _($n).AudienceCulture ? (E(), X(Re, { key: 0 }, [
        ue(_(_f), {
          model: y.value,
          "font-size": _(yn).SixteenPx,
          "show-arrows": l.value !== _($n).Two,
          onClick: f
        }, null, 8, ["model", "font-size", "show-arrows"]),
        y.value?.teaser?.length > 0 ? (E(), X("div", qee, [
          (E(!0), X(Re, null, Ge(y.value?.teaser, (D, C) => (E(), fe(_($C), {
            key: `${D?.link?.text}_${C}`,
            class: "d-header-mobile-menu__teaser",
            model: D
          }, null, 8, ["model"]))), 128))
        ])) : te("", !0),
        e.model?.iconList?.audienceIcon && !e.model?.iconList?.audienceIcon?.hideIcon ? (E(), fe(_(ot), {
          key: 1,
          class: "d-header-mobile-menu__audience-trigger",
          role: "button",
          "link-model": c.value?.link,
          icon: _(H).Globe,
          "icon-position": _(ct).Left,
          onClick: S,
          onKeydown: Ze(S, ["enter"])
        }, null, 8, ["link-model", "icon", "icon-position"])) : te("", !0)
      ], 64)) : te("", !0),
      l.value === _($n).AudienceCulture ? (E(), fe(Dg, {
        key: 1,
        class: "d-header-mobile-menu__audience-culture",
        audience: e.model?.iconList?.audienceIcon?.audience,
        culture: e.model?.iconList?.audienceIcon?.culture,
        "image-options": e.model?.iconList?.audienceIcon?.imageOptions,
        onAudienceChanged: w,
        onCultureChanged: x
      }, null, 8, ["audience", "culture", "image-options"])) : te("", !0),
      e.model?.iconList?.moreIcon && !e.model?.iconList?.moreIcon?.hideIcon ? (E(), X("ul", Kee, [
        (E(!0), X(Re, null, Ge(e.model?.iconList?.moreIcon?.furtherItems, (D, C) => (E(), X("li", {
          key: `${D.link?.text}_${C}`
        }, [
          ue(_(ot), {
            "link-model": D?.link,
            "font-size": _(yn).FourteenPx
          }, null, 8, ["link-model", "font-size"])
        ]))), 128))
      ])) : te("", !0),
      a.value ? (E(), fe(Rg, {
        key: 3,
        model: g.value,
        "append-to": e.model?.iconList?.audienceIcon?.modalAppendTo,
        onAccept: A,
        onCancel: $,
        onClose: $
      }, null, 8, ["model", "append-to"])) : te("", !0)
    ])) : te("", !0);
  }
});
const Zee = /* @__PURE__ */ Fe(Xee, [["__scopeId", "data-v-27dd1acc"]]), Jee = {
  key: 0,
  class: "d-header-item-flyout"
}, Qee = { class: "d-header-item-flyout__column d-header-item-flyout__column--first" }, ete = { class: "d-header-item-flyout__column d-header-item-flyout__column--second" }, tte = { class: "d-header-item-flyout__column d-header-item-flyout__column--third" }, nte = /* @__PURE__ */ Be({
  __name: "HeaderItemFlyout",
  props: {
    model: {
      type: Object,
      required: !0
    },
    showArrows: {
      type: Boolean,
      default: !0
    }
  },
  setup(e) {
    const t = e, n = Te(
      () => t?.model?.items?.find((r) => r?.isActive) || null
    ), i = ge(n.value);
    qe(
      () => n.value,
      (r) => {
        i.value = r;
      },
      { deep: !0 }
    );
    const o = ge(null), a = async (r) => {
      r?.items?.length && (i.value = r, await mt(), o?.value?.$el?.querySelector("a")?.focus());
    };
    return (r, s) => e.model ? (E(), X("div", Jee, [
      oe("div", Qee, [
        ue(_(_f), {
          model: e.model,
          "active-item-text": i.value?.link?.text,
          "show-arrows": e.showArrows,
          onClick: a
        }, null, 8, ["model", "active-item-text", "show-arrows"])
      ]),
      oe("div", ete, [
        i.value ? (E(), fe(_(_f), {
          key: 0,
          ref_key: "subMenuRef",
          ref: o,
          model: i.value,
          "show-arrows": !1,
          onClick: a
        }, null, 8, ["model"])) : te("", !0)
      ]),
      oe("div", tte, [
        (E(!0), X(Re, null, Ge(e.model?.teaser, (l, d) => (E(), fe(_($C), {
          key: `${l?.link?.text}_${d}`,
          model: l
        }, null, 8, ["model"]))), 128))
      ])
    ])) : te("", !0);
  }
});
const k0 = /* @__PURE__ */ Fe(nte, [["__scopeId", "data-v-df249610"]]), ite = {
  key: 0,
  class: "d-header-avatar--logged-in__wrapper--no-image"
}, ate = {
  key: 0,
  class: "d-header-avatar--logged-in__wrapper"
}, ote = ["src", "alt"], rte = /* @__PURE__ */ Be({
  __name: "HeaderAvatar",
  props: {
    model: {
      type: Object,
      required: !0
    },
    showCloseButton: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["click"],
  setup(e, { emit: t }) {
    const n = t, i = () => {
      n("click");
    };
    return (o, a) => e.model && !e.model.isLoggedIn ? (E(), fe(Nt, {
      key: 0,
      class: "d-header-avatar",
      "link-model": e.model.linkModel,
      type: _(Ke).RoundedNonFilled,
      size: _(et).Small,
      icon: e.showCloseButton ? _(H).Times : _(H).User,
      onClick: i
    }, null, 8, ["link-model", "type", "size", "icon"])) : e.model?.isLoggedIn && !e.model?.imageSrc ? (E(), fe(Nt, {
      key: 1,
      class: "d-header-avatar--logged-in--no-image",
      "link-model": e.model.linkModel,
      type: _(Ke).RoundedNonFilled,
      size: _(et).Small,
      icon: e.showCloseButton ? _(H).Times : null,
      onClick: i
    }, {
      default: Se(() => [
        e.showCloseButton ? te("", !0) : (E(), X("div", ite, [
          ue(_t, {
            "base-icon": e.showCloseButton ? _(H).Times : _(H).User,
            "base-icon-size": _(at).Inherit
          }, null, 8, ["base-icon", "base-icon-size"]),
          ue(_t, {
            class: "d-header-avatar--logged-in__icon d-header-avatar--logged-in__icon--no-image",
            "base-icon": _(H).Check,
            "base-icon-color": _(gt).White
          }, null, 8, ["base-icon", "base-icon-color"])
        ]))
      ]),
      _: 1
    }, 8, ["link-model", "type", "size", "icon"])) : e.model?.isLoggedIn ? (E(), fe(Nt, {
      key: 2,
      class: "d-header-avatar--logged-in",
      "link-model": e.model.linkModel,
      type: _(Ke).RoundedNonFilled,
      size: _(et).Small,
      icon: e.showCloseButton ? _(H).Times : null,
      onClick: i
    }, {
      default: Se(() => [
        e.showCloseButton ? te("", !0) : (E(), X("div", ate, [
          oe("img", {
            class: "d-header-avatar--logged-in__image",
            src: e.model.imageSrc,
            alt: e.model?.altText
          }, null, 8, ote),
          ue(_t, {
            class: "d-header-avatar--logged-in__icon",
            "base-icon": _(H).Check,
            "base-icon-color": _(gt).White
          }, null, 8, ["base-icon", "base-icon-color"])
        ]))
      ]),
      _: 1
    }, 8, ["link-model", "type", "size", "icon"])) : te("", !0);
  }
});
const ste = /* @__PURE__ */ Fe(rte, [["__scopeId", "data-v-22f2e8e7"]]), lte = {
  class: "d-header-icon-list",
  "data-outside-click": !0
}, cte = /* @__PURE__ */ Be({
  __name: "HeaderIconList",
  props: {
    model: {
      type: Object,
      required: !0
    },
    activeIconKey: {
      type: String,
      required: !1,
      default: null
    },
    hasItems: {
      type: Boolean,
      required: !1,
      default: !1
    }
  },
  emits: ["click", "audience-changed"],
  setup(e, { emit: t }) {
    const n = e, { t: i } = Je(), { isSmallerXl: o, isSmallerXlAsync: a } = xt(), r = t, s = {
      [pt.Search]: null,
      [pt.Audience]: null,
      [pt.Login]: null,
      [pt.More]: null,
      [pt.MoreMobile]: null
    }, l = {
      [pt.Search]: null,
      [pt.Audience]: null,
      [pt.Login]: null,
      [pt.More]: null,
      [pt.MoreMobile]: null
    }, d = {
      [pt.Search]: null,
      [pt.Audience]: null,
      [pt.Login]: null,
      [pt.More]: null,
      [pt.MoreMobile]: null
    }, y = ge({
      moreIcon: o.value,
      moreMobileIcon: !o.value,
      audienceIcon: o.value
    }), u = Te(() => {
      const x = n?.model?.audienceIcon?.audience?.items, k = i(x ? "header.audienceAndCultureText" : "header.cultureText");
      return `${n?.model?.audienceIcon?.tooltipText}; ${k}`;
    }), m = Te(() => ({
      ...n.model?.loginIcon?.avatar,
      linkModel: {
        ...n.model?.loginIcon?.avatar?.linkModel,
        tealiumTrackingModel: {
          ...n?.model?.loginIcon?.tealiumTrackingModel,
          eventComponentName: P[pt.Login],
          eventTitle: g.value(pt.Login) ? "Close" : "Open"
        }
      }
    })), h = Te(() => (x, k) => a.value && g.value(x) ? H.Times : k), c = Te(() => (x) => ({
      "d-header-icon-list__icon--expanded": g.value(x)
    })), g = Te(
      () => (x) => n?.activeIconKey === x
    ), v = (x) => {
      r("click", x, l[x]);
    }, P = {
      [pt.Search]: "Search",
      [pt.Audience]: "Country Picker",
      [pt.Login]: "Login",
      [pt.More]: "Falafel",
      [pt.MoreMobile]: "Mobile Menu"
    }, f = Te(() => (x) => ({
      contentUrl: "",
      title: x,
      isLocked: !1,
      isExternal: !1,
      linkType: za.Javascript,
      tealiumTrackingModel: {
        ...n?.model?.[x]?.tealiumTrackingModel,
        eventComponentName: P[x],
        eventTitle: g.value(x) ? "Close" : "Open"
      }
    })), S = async () => {
      await mt(), !a.value && (w(), Object.keys(s).forEach((x) => {
        const k = n?.model?.[x]?.tooltipText, A = s[x]?.$el;
        if (k && A) {
          const { tippyInstance: $ } = pn({
            trigger: A,
            content: k,
            appendTo: "parent",
            showOnTouchDevices: !1,
            field: () => A
          });
          d[x] = $;
        }
      }));
    }, w = () => {
      Object.keys(d).forEach((x) => {
        const k = d[x];
        k && k.destroy();
      });
    };
    return qe(a, () => {
      n?.model?.moreIcon?.hideIcon || (y.value.moreIcon = a.value), n?.model?.moreMobileIcon?.hideIcon || (y.value.moreMobileIcon = !a.value), n?.model?.audienceIcon?.hideIcon || (y.value.audienceIcon = a.value), a.value ? w() : a.value || S();
    }), qe(
      () => n?.model,
      (x) => {
        Object.keys(x).forEach((k) => {
          qe(
            () => x[k]?.tooltipText,
            () => {
              S();
            }
          );
        });
      },
      { deep: !0 }
    ), it(async () => {
      n?.model?.moreIcon && (y.value.moreIcon = n.model.moreIcon.hideIcon), n?.model?.moreMobileIcon && (y.value.moreMobileIcon = n.model.moreMobileIcon.hideIcon), n?.model?.audienceIcon && (y.value.audienceIcon = n.model.audienceIcon.hideIcon), await S();
    }), (x, k) => (E(), X("ul", lte, [
      e.model?.searchIcon && !e.model?.searchIcon?.hideIcon ? (E(), X("li", {
        key: 0,
        ref: (A) => l[_(pt).Search] = A,
        class: "d-header-icon-list__item d-header-icon-list__item__search",
        "data-outside-click": !0
      }, [
        ue(Nt, {
          ref: (A) => s[_(pt).Search] = A,
          class: Pe(["d-header-icon-list__icon", c.value(_(pt).Search)]),
          type: _(Ke).RoundedNonFilled,
          size: _(et).Small,
          icon: h.value(_(pt).Search, _(H).Search),
          "link-model": f.value(_(pt).Search),
          "aria-expanded": g.value(_(pt).Search),
          "aria-label": e.model?.searchIcon?.tooltipText || _(i)("header.search"),
          onClick: k[0] || (k[0] = (A) => v(_(pt).Search))
        }, null, 8, ["class", "type", "size", "icon", "link-model", "aria-expanded", "aria-label"])
      ], 512)) : te("", !0),
      y.value.audienceIcon ? te("", !0) : (E(), X("li", {
        key: 1,
        ref: (A) => l[_(pt).Audience] = A,
        class: "d-header-icon-list__item d-header-icon-list__item__audience",
        "data-outside-click": !0
      }, [
        ue(Nt, {
          ref: (A) => s[_(pt).Audience] = A,
          class: Pe(["d-header-icon-list__icon", c.value(_(pt).Audience)]),
          type: _(Ke).RoundedNonFilled,
          size: _(et).Small,
          icon: h.value(_(pt).Search, _(H).Globe),
          "link-model": f.value(_(pt).Audience),
          "aria-expanded": g.value(_(pt).Audience),
          "aria-label": u.value,
          onClick: k[1] || (k[1] = (A) => v(_(pt).Audience))
        }, null, 8, ["class", "type", "size", "icon", "link-model", "aria-expanded", "aria-label"])
      ], 512)),
      e.model?.loginIcon && !e.model?.loginIcon?.hideIcon ? (E(), X("li", {
        key: 2,
        ref: (A) => l[_(pt).Login] = A,
        class: "d-header-icon-list__item d-header-icon-list__item__login",
        "data-outside-click": !0
      }, [
        ue(ste, {
          ref: (A) => s[_(pt).Login] = A,
          class: Pe(["d-header-icon-list__icon", c.value(_(pt).Login)]),
          "aria-expanded": g.value(_(pt).Login),
          model: m.value,
          "show-close-button": g.value(_(pt).Login) && _(a),
          "aria-label": e.model?.loginIcon?.tooltipText || _(i)("header.user"),
          onClick: k[2] || (k[2] = (A) => v(_(pt).Login))
        }, null, 8, ["class", "aria-expanded", "model", "show-close-button", "aria-label"])
      ], 512)) : te("", !0),
      y.value.moreIcon ? te("", !0) : (E(), X("li", {
        key: 3,
        ref: (A) => l[_(pt).More] = A,
        class: "d-header-icon-list__item d-header-icon-list__item__more",
        "data-outside-click": !0
      }, [
        ue(Nt, {
          ref: (A) => s[_(pt).More] = A,
          class: Pe(["d-header-icon-list__icon", c.value(_(pt).More)]),
          type: _(Ke).RoundedNonFilled,
          size: _(et).Small,
          icon: _(H).EllipsisV,
          "link-model": f.value(_(pt).More),
          "aria-expanded": g.value(_(pt).More),
          "aria-label": e.model?.moreIcon?.tooltipText || _(i)("header.moreLinks"),
          onClick: k[3] || (k[3] = (A) => v(_(pt).More))
        }, null, 8, ["class", "type", "size", "icon", "link-model", "aria-expanded", "aria-label"])
      ], 512)),
      y.value.moreMobileIcon ? te("", !0) : (E(), X("li", {
        key: 4,
        ref: (A) => l[_(pt).MoreMobile] = A,
        class: "d-header-icon-list__item d-header-icon-list__item__more--mobile",
        "data-outside-click": !0
      }, [
        ue(Nt, {
          ref: (A) => s[_(pt).MoreMobile] = A,
          class: Pe(["d-header-icon-list__icon", c.value(_(pt).MoreMobile)]),
          type: _(Ke).RoundedNonFilled,
          size: _(et).Small,
          icon: h.value(_(pt).MoreMobile, _(H).Bars),
          "link-model": f.value(_(pt).MoreMobile),
          "aria-expanded": g.value(_(pt).MoreMobile),
          "aria-label": e.model?.moreMobileIcon?.tooltipText || _(i)("header.toggleMenu"),
          onClick: k[4] || (k[4] = (A) => v(_(pt).MoreMobile))
        }, null, 8, ["class", "type", "size", "icon", "link-model", "aria-expanded", "aria-label"])
      ], 512))
    ]));
  }
});
const dte = /* @__PURE__ */ Fe(cte, [["__scopeId", "data-v-adb32fbf"]]);
var pt = /* @__PURE__ */ ((e) => (e.Search = "searchIcon", e.Audience = "audienceIcon", e.Login = "loginIcon", e.More = "moreIcon", e.MoreMobile = "moreMobileIcon", e))(pt || {});
const ute = {
  key: 0,
  class: "d-header-item"
}, hte = /* @__PURE__ */ Be({
  __name: "HeaderItem",
  props: {
    model: {
      type: Object,
      required: !0
    },
    expanded: {
      type: Boolean,
      required: !1,
      default: !1
    }
  },
  emits: ["click"],
  setup(e, { emit: t }) {
    const n = e, i = t, { t: o } = Je(), a = Te(() => ({
      ...n.model?.link,
      tealiumTrackingModel: {
        ...n.model?.link?.tealiumTrackingModel,
        eventComponentName: "main navigation | L1"
      }
    })), r = Te(() => (l) => !l?.link?.href || l?.items?.length && !l?.link?.isLocked ? "button" : null), s = (l) => {
      n?.model?.items?.length && !n?.model?.link?.isLocked && (l?.preventDefault(), i("click"));
    };
    return (l, d) => e.model ? (E(), X("li", ute, [
      ue(_(ot), {
        class: "d-header-item__link",
        role: r.value(e.model),
        "aria-expanded": e.expanded,
        "link-model": a.value,
        "font-size": _(yn).FourteenPx,
        "font-type": _(ya).DwsBold,
        icon: e.model?.link?.isLocked ? _(H).Lock : null,
        "icon-position": _(ct).Left,
        "icon-size": _(at).Inherit,
        "icon-aria-hidden": null,
        "icon-aria-label": _(o)("globalTranslations.lockedContentLabel"),
        onClick: s,
        onKeydown: Ze(s, ["enter"])
      }, null, 8, ["role", "aria-expanded", "link-model", "font-size", "font-type", "icon", "icon-position", "icon-size", "icon-aria-label"])
    ])) : te("", !0);
  }
});
const pte = /* @__PURE__ */ Fe(hte, [["__scopeId", "data-v-b649a5c6"]]), fte = /* @__PURE__ */ Be({
  __name: "HeaderItemList",
  props: {
    model: {
      type: Object,
      required: !0
    },
    activeItemText: {
      type: String,
      required: !1,
      default: null
    }
  },
  emits: ["click"],
  setup(e, { emit: t }) {
    const n = e, i = t, o = ge(), a = ge([]), r = ge(0), s = ge(!1), l = Te(() => (h) => !h?.items?.length || h?.link?.isLocked ? null : n?.activeItemText === h?.link?.text), d = (h) => {
      h?.items?.length && i("click", h);
    }, y = async () => {
      await mt(), Ue && a?.value?.forEach((h) => {
        r.value += h?.$el?.clientWidth || 0;
      });
    }, u = async () => {
      if (await mt(), Ue) {
        const h = o?.value?.clientWidth || 0, c = (a?.value?.length - 1) * 40;
        s.value = r.value + c <= h;
      }
    }, m = () => {
      new ResizeObserver(() => {
        u();
      }).observe(o.value);
    };
    return qe(n?.model, () => {
      u();
    }), it(() => {
      y(), m();
    }), (h, c) => e.model ? (E(), X("ul", {
      key: 0,
      ref_key: "listElement",
      ref: o,
      class: Pe(["d-header-item-list", { "d-header-item-list--wider": s.value }]),
      "data-outside-click": !0
    }, [
      (E(!0), X(Re, null, Ge(e.model, (g, v) => (E(), fe(_(pte), {
        ref_for: !0,
        ref_key: "itemRefs",
        ref: a,
        key: `${g?.link?.text}_${v}`,
        model: g,
        class: Pe({
          "d-header-item-list__link": e.activeItemText === g?.link?.text || g?.isActive
        }),
        expanded: l.value(g),
        onClick: (P) => d(g)
      }, null, 8, ["model", "class", "expanded", "onClick"]))), 128))
    ], 2)) : te("", !0);
  }
});
const mte = /* @__PURE__ */ Fe(fte, [["__scopeId", "data-v-e059c918"]]);
var yr = /* @__PURE__ */ ((e) => (e.Footer = "footer", e.Header = "header", e))(yr || {}), gte = function(e) {
  if (typeof document > "u")
    return null;
  var t = Array.isArray(e) ? e[0] : e;
  return t.ownerDocument.body;
}, zr = /* @__PURE__ */ new WeakMap(), Md = /* @__PURE__ */ new WeakMap(), Od = {}, wp = 0, FC = function(e) {
  return e && (e.host || FC(e.parentNode));
}, vte = function(e, t) {
  return t.map(function(n) {
    if (e.contains(n))
      return n;
    var i = FC(n);
    return i && e.contains(i) ? i : (console.error("aria-hidden", n, "in not contained inside", e, ". Doing nothing"), null);
  }).filter(function(n) {
    return !!n;
  });
}, yte = function(e, t, n, i) {
  var o = vte(t, Array.isArray(e) ? e : [e]);
  Od[n] || (Od[n] = /* @__PURE__ */ new WeakMap());
  var a = Od[n], r = [], s = /* @__PURE__ */ new Set(), l = new Set(o), d = function(u) {
    !u || s.has(u) || (s.add(u), d(u.parentNode));
  };
  o.forEach(d);
  var y = function(u) {
    !u || l.has(u) || Array.prototype.forEach.call(u.children, function(m) {
      if (s.has(m))
        y(m);
      else
        try {
          var h = m.getAttribute(i), c = h !== null && h !== "false", g = (zr.get(m) || 0) + 1, v = (a.get(m) || 0) + 1;
          zr.set(m, g), a.set(m, v), r.push(m), g === 1 && c && Md.set(m, !0), v === 1 && m.setAttribute(n, "true"), c || m.setAttribute(i, "true");
        } catch (P) {
          console.error("aria-hidden: cannot operate on ", m, P);
        }
    });
  };
  return y(t), s.clear(), wp++, function() {
    r.forEach(function(u) {
      var m = zr.get(u) - 1, h = a.get(u) - 1;
      zr.set(u, m), a.set(u, h), m || (Md.has(u) || u.removeAttribute(i), Md.delete(u)), h || u.removeAttribute(n);
    }), wp--, wp || (zr = /* @__PURE__ */ new WeakMap(), zr = /* @__PURE__ */ new WeakMap(), Md = /* @__PURE__ */ new WeakMap(), Od = {});
  };
}, bte = function(e, t, n) {
  n === void 0 && (n = "data-aria-hidden");
  var i = Array.from(Array.isArray(e) ? e : [e]), o = t || gte(e);
  return o ? (i.push.apply(i, Array.from(o.querySelectorAll("[aria-live]"))), yte(i, o, n, "aria-hidden")) : function() {
    return null;
  };
};
/*!
* tabbable 6.2.0
* @license MIT, https://github.com/focus-trap/tabbable/blob/master/LICENSE
*/
var jC = ["input:not([inert])", "select:not([inert])", "textarea:not([inert])", "a[href]:not([inert])", "button:not([inert])", "[tabindex]:not(slot):not([inert])", "audio[controls]:not([inert])", "video[controls]:not([inert])", '[contenteditable]:not([contenteditable="false"]):not([inert])', "details>summary:first-of-type:not([inert])", "details:not([inert])"], _u = /* @__PURE__ */ jC.join(","), HC = typeof Element > "u", Pr = HC ? function() {
} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector, Mu = !HC && Element.prototype.getRootNode ? function(e) {
  var t;
  return e == null || (t = e.getRootNode) === null || t === void 0 ? void 0 : t.call(e);
} : function(e) {
  return e?.ownerDocument;
}, Ou = function e(t, n) {
  var i;
  n === void 0 && (n = !0);
  var o = t == null || (i = t.getAttribute) === null || i === void 0 ? void 0 : i.call(t, "inert"), a = o === "" || o === "true", r = a || n && t && e(t.parentNode);
  return r;
}, xte = function(t) {
  var n, i = t == null || (n = t.getAttribute) === null || n === void 0 ? void 0 : n.call(t, "contenteditable");
  return i === "" || i === "true";
}, zC = function(t, n, i) {
  if (Ou(t))
    return [];
  var o = Array.prototype.slice.apply(t.querySelectorAll(_u));
  return n && Pr.call(t, _u) && o.unshift(t), o = o.filter(i), o;
}, VC = function e(t, n, i) {
  for (var o = [], a = Array.from(t); a.length; ) {
    var r = a.shift();
    if (!Ou(r, !1))
      if (r.tagName === "SLOT") {
        var s = r.assignedElements(), l = s.length ? s : r.children, d = e(l, !0, i);
        i.flatten ? o.push.apply(o, d) : o.push({
          scopeParent: r,
          candidates: d
        });
      } else {
        var y = Pr.call(r, _u);
        y && i.filter(r) && (n || !t.includes(r)) && o.push(r);
        var u = r.shadowRoot || // check for an undisclosed shadow
        typeof i.getShadowRoot == "function" && i.getShadowRoot(r), m = !Ou(u, !1) && (!i.shadowRootFilter || i.shadowRootFilter(r));
        if (u && m) {
          var h = e(u === !0 ? r.children : u.children, !0, i);
          i.flatten ? o.push.apply(o, h) : o.push({
            scopeParent: r,
            candidates: h
          });
        } else
          a.unshift.apply(a, r.children);
      }
  }
  return o;
}, GC = function(t) {
  return !isNaN(parseInt(t.getAttribute("tabindex"), 10));
}, hr = function(t) {
  if (!t)
    throw new Error("No node provided");
  return t.tabIndex < 0 && (/^(AUDIO|VIDEO|DETAILS)$/.test(t.tagName) || xte(t)) && !GC(t) ? 0 : t.tabIndex;
}, wte = function(t, n) {
  var i = hr(t);
  return i < 0 && n && !GC(t) ? 0 : i;
}, kte = function(t, n) {
  return t.tabIndex === n.tabIndex ? t.documentOrder - n.documentOrder : t.tabIndex - n.tabIndex;
}, UC = function(t) {
  return t.tagName === "INPUT";
}, Ste = function(t) {
  return UC(t) && t.type === "hidden";
}, Cte = function(t) {
  var n = t.tagName === "DETAILS" && Array.prototype.slice.apply(t.children).some(function(i) {
    return i.tagName === "SUMMARY";
  });
  return n;
}, Tte = function(t, n) {
  for (var i = 0; i < t.length; i++)
    if (t[i].checked && t[i].form === n)
      return t[i];
}, Lte = function(t) {
  if (!t.name)
    return !0;
  var n = t.form || Mu(t), i = function(s) {
    return n.querySelectorAll('input[type="radio"][name="' + s + '"]');
  }, o;
  if (typeof window < "u" && typeof window.CSS < "u" && typeof window.CSS.escape == "function")
    o = i(window.CSS.escape(t.name));
  else
    try {
      o = i(t.name);
    } catch (r) {
      return console.error("Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s", r.message), !1;
    }
  var a = Tte(o, t.form);
  return !a || a === t;
}, Ite = function(t) {
  return UC(t) && t.type === "radio";
}, Pte = function(t) {
  return Ite(t) && !Lte(t);
}, Ate = function(t) {
  var n, i = t && Mu(t), o = (n = i) === null || n === void 0 ? void 0 : n.host, a = !1;
  if (i && i !== t) {
    var r, s, l;
    for (a = !!((r = o) !== null && r !== void 0 && (s = r.ownerDocument) !== null && s !== void 0 && s.contains(o) || t != null && (l = t.ownerDocument) !== null && l !== void 0 && l.contains(t)); !a && o; ) {
      var d, y, u;
      i = Mu(o), o = (d = i) === null || d === void 0 ? void 0 : d.host, a = !!((y = o) !== null && y !== void 0 && (u = y.ownerDocument) !== null && u !== void 0 && u.contains(o));
    }
  }
  return a;
}, S0 = function(t) {
  var n = t.getBoundingClientRect(), i = n.width, o = n.height;
  return i === 0 && o === 0;
}, _te = function(t, n) {
  var i = n.displayCheck, o = n.getShadowRoot;
  if (getComputedStyle(t).visibility === "hidden")
    return !0;
  var a = Pr.call(t, "details>summary:first-of-type"), r = a ? t.parentElement : t;
  if (Pr.call(r, "details:not([open]) *"))
    return !0;
  if (!i || i === "full" || i === "legacy-full") {
    if (typeof o == "function") {
      for (var s = t; t; ) {
        var l = t.parentElement, d = Mu(t);
        if (l && !l.shadowRoot && o(l) === !0)
          return S0(t);
        t.assignedSlot ? t = t.assignedSlot : !l && d !== t.ownerDocument ? t = d.host : t = l;
      }
      t = s;
    }
    if (Ate(t))
      return !t.getClientRects().length;
    if (i !== "legacy-full")
      return !0;
  } else if (i === "non-zero-area")
    return S0(t);
  return !1;
}, Mte = function(t) {
  if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(t.tagName))
    for (var n = t.parentElement; n; ) {
      if (n.tagName === "FIELDSET" && n.disabled) {
        for (var i = 0; i < n.children.length; i++) {
          var o = n.children.item(i);
          if (o.tagName === "LEGEND")
            return Pr.call(n, "fieldset[disabled] *") ? !0 : !o.contains(t);
        }
        return !0;
      }
      n = n.parentElement;
    }
  return !1;
}, Bu = function(t, n) {
  return !(n.disabled || // we must do an inert look up to filter out any elements inside an inert ancestor
  //  because we're limited in the type of selectors we can use in JSDom (see related
  //  note related to `candidateSelectors`)
  Ou(n) || Ste(n) || _te(n, t) || // For a details element with a summary, the summary element gets the focus
  Cte(n) || Mte(n));
}, Mf = function(t, n) {
  return !(Pte(n) || hr(n) < 0 || !Bu(t, n));
}, Ote = function(t) {
  var n = parseInt(t.getAttribute("tabindex"), 10);
  return !!(isNaN(n) || n >= 0);
}, Bte = function e(t) {
  var n = [], i = [];
  return t.forEach(function(o, a) {
    var r = !!o.scopeParent, s = r ? o.scopeParent : o, l = wte(s, r), d = r ? e(o.candidates) : s;
    l === 0 ? r ? n.push.apply(n, d) : n.push(s) : i.push({
      documentOrder: a,
      tabIndex: l,
      item: o,
      isScope: r,
      content: d
    });
  }), i.sort(kte).reduce(function(o, a) {
    return a.isScope ? o.push.apply(o, a.content) : o.push(a.content), o;
  }, []).concat(n);
}, Ete = function(t, n) {
  n = n || {};
  var i;
  return n.getShadowRoot ? i = VC([t], n.includeContainer, {
    filter: Mf.bind(null, n),
    flatten: !1,
    getShadowRoot: n.getShadowRoot,
    shadowRootFilter: Ote
  }) : i = zC(t, n.includeContainer, Mf.bind(null, n)), Bte(i);
}, Dte = function(t, n) {
  n = n || {};
  var i;
  return n.getShadowRoot ? i = VC([t], n.includeContainer, {
    filter: Bu.bind(null, n),
    flatten: !0,
    getShadowRoot: n.getShadowRoot
  }) : i = zC(t, n.includeContainer, Bu.bind(null, n)), i;
}, Vr = function(t, n) {
  if (n = n || {}, !t)
    throw new Error("No node provided");
  return Pr.call(t, _u) === !1 ? !1 : Mf(n, t);
}, Rte = /* @__PURE__ */ jC.concat("iframe").join(","), kp = function(t, n) {
  if (n = n || {}, !t)
    throw new Error("No node provided");
  return Pr.call(t, Rte) === !1 ? !1 : Bu(n, t);
};
/*!
* focus-trap 7.6.2
* @license MIT, https://github.com/focus-trap/focus-trap/blob/master/LICENSE
*/
function Of(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, i = Array(t); n < t; n++)
    i[n] = e[n];
  return i;
}
function Nte(e) {
  if (Array.isArray(e))
    return Of(e);
}
function $te(e, t, n) {
  return (t = Vte(t)) in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function Fte(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null)
    return Array.from(e);
}
function jte() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function C0(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    t && (i = i.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), n.push.apply(n, i);
  }
  return n;
}
function T0(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? C0(Object(n), !0).forEach(function(i) {
      $te(e, i, n[i]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : C0(Object(n)).forEach(function(i) {
      Object.defineProperty(e, i, Object.getOwnPropertyDescriptor(n, i));
    });
  }
  return e;
}
function Hte(e) {
  return Nte(e) || Fte(e) || Gte(e) || jte();
}
function zte(e, t) {
  if (typeof e != "object" || !e)
    return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var i = n.call(e, t || "default");
    if (typeof i != "object")
      return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function Vte(e) {
  var t = zte(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
function Gte(e, t) {
  if (e) {
    if (typeof e == "string")
      return Of(e, t);
    var n = {}.toString.call(e).slice(8, -1);
    return n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set" ? Array.from(e) : n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? Of(e, t) : void 0;
  }
}
var L0 = {
  activateTrap: function(t, n) {
    if (t.length > 0) {
      var i = t[t.length - 1];
      i !== n && i.pause();
    }
    var o = t.indexOf(n);
    o === -1 || t.splice(o, 1), t.push(n);
  },
  deactivateTrap: function(t, n) {
    var i = t.indexOf(n);
    i !== -1 && t.splice(i, 1), t.length > 0 && t[t.length - 1].unpause();
  }
}, Ute = function(t) {
  return t.tagName && t.tagName.toLowerCase() === "input" && typeof t.select == "function";
}, Wte = function(t) {
  return t?.key === "Escape" || t?.key === "Esc" || t?.keyCode === 27;
}, Pl = function(t) {
  return t?.key === "Tab" || t?.keyCode === 9;
}, Yte = function(t) {
  return Pl(t) && !t.shiftKey;
}, qte = function(t) {
  return Pl(t) && t.shiftKey;
}, I0 = function(t) {
  return setTimeout(t, 0);
}, dl = function(t) {
  for (var n = arguments.length, i = new Array(n > 1 ? n - 1 : 0), o = 1; o < n; o++)
    i[o - 1] = arguments[o];
  return typeof t == "function" ? t.apply(void 0, i) : t;
}, Bd = function(t) {
  return t.target.shadowRoot && typeof t.composedPath == "function" ? t.composedPath()[0] : t.target;
}, Kte = [], Xte = function(t, n) {
  var i = n?.document || document, o = n?.trapStack || Kte, a = T0({
    returnFocusOnDeactivate: !0,
    escapeDeactivates: !0,
    delayInitialFocus: !0,
    isKeyForward: Yte,
    isKeyBackward: qte
  }, n), r = {
    // containers given to createFocusTrap()
    // @type {Array<HTMLElement>}
    containers: [],
    // list of objects identifying tabbable nodes in `containers` in the trap
    // NOTE: it's possible that a group has no tabbable nodes if nodes get removed while the trap
    //  is active, but the trap should never get to a state where there isn't at least one group
    //  with at least one tabbable node in it (that would lead to an error condition that would
    //  result in an error being thrown)
    // @type {Array<{
    //   container: HTMLElement,
    //   tabbableNodes: Array<HTMLElement>, // empty if none
    //   focusableNodes: Array<HTMLElement>, // empty if none
    //   posTabIndexesFound: boolean,
    //   firstTabbableNode: HTMLElement|undefined,
    //   lastTabbableNode: HTMLElement|undefined,
    //   firstDomTabbableNode: HTMLElement|undefined,
    //   lastDomTabbableNode: HTMLElement|undefined,
    //   nextTabbableNode: (node: HTMLElement, forward: boolean) => HTMLElement|undefined
    // }>}
    containerGroups: [],
    // same order/length as `containers` list
    // references to objects in `containerGroups`, but only those that actually have
    //  tabbable nodes in them
    // NOTE: same order as `containers` and `containerGroups`, but __not necessarily__
    //  the same length
    tabbableGroups: [],
    nodeFocusedBeforeActivation: null,
    mostRecentlyFocusedNode: null,
    active: !1,
    paused: !1,
    // timer ID for when delayInitialFocus is true and initial focus in this trap
    //  has been delayed during activation
    delayInitialFocusTimer: void 0,
    // the most recent KeyboardEvent for the configured nav key (typically [SHIFT+]TAB), if any
    recentNavEvent: void 0
  }, s, l = function(C, b, p) {
    return C && C[b] !== void 0 ? C[b] : a[p || b];
  }, d = function(C, b) {
    var p = typeof b?.composedPath == "function" ? b.composedPath() : void 0;
    return r.containerGroups.findIndex(function(L) {
      var B = L.container, T = L.tabbableNodes;
      return B.contains(C) || p?.includes(B) || T.find(function(O) {
        return O === C;
      });
    });
  }, y = function(C) {
    var b = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, p = b.hasFallback, L = p === void 0 ? !1 : p, B = b.params, T = B === void 0 ? [] : B, O = a[C];
    if (typeof O == "function" && (O = O.apply(void 0, Hte(T))), O === !0 && (O = void 0), !O) {
      if (O === void 0 || O === !1)
        return O;
      throw new Error("`".concat(C, "` was specified but was not a node, or did not return a node"));
    }
    var I = O;
    if (typeof O == "string") {
      try {
        I = i.querySelector(O);
      } catch (R) {
        throw new Error("`".concat(C, '` appears to be an invalid selector; error="').concat(R.message, '"'));
      }
      if (!I && !L)
        throw new Error("`".concat(C, "` as selector refers to no known node"));
    }
    return I;
  }, u = function() {
    var C = y("initialFocus", {
      hasFallback: !0
    });
    if (C === !1)
      return !1;
    if (C === void 0 || C && !kp(C, a.tabbableOptions))
      if (d(i.activeElement) >= 0)
        C = i.activeElement;
      else {
        var b = r.tabbableGroups[0], p = b && b.firstTabbableNode;
        C = p || y("fallbackFocus");
      }
    else
      C === null && (C = y("fallbackFocus"));
    if (!C)
      throw new Error("Your focus-trap needs to have at least one focusable element");
    return C;
  }, m = function() {
    if (r.containerGroups = r.containers.map(function(C) {
      var b = Ete(C, a.tabbableOptions), p = Dte(C, a.tabbableOptions), L = b.length > 0 ? b[0] : void 0, B = b.length > 0 ? b[b.length - 1] : void 0, T = p.find(function(R) {
        return Vr(R);
      }), O = p.slice().reverse().find(function(R) {
        return Vr(R);
      }), I = !!b.find(function(R) {
        return hr(R) > 0;
      });
      return {
        container: C,
        tabbableNodes: b,
        focusableNodes: p,
        /** True if at least one node with positive `tabindex` was found in this container. */
        posTabIndexesFound: I,
        /** First tabbable node in container, __tabindex__ order; `undefined` if none. */
        firstTabbableNode: L,
        /** Last tabbable node in container, __tabindex__ order; `undefined` if none. */
        lastTabbableNode: B,
        // NOTE: DOM order is NOT NECESSARILY "document position" order, but figuring that out
        //  would require more than just https://developer.mozilla.org/en-US/docs/Web/API/Node/compareDocumentPosition
        //  because that API doesn't work with Shadow DOM as well as it should (@see
        //  https://github.com/whatwg/dom/issues/320) and since this first/last is only needed, so far,
        //  to address an edge case related to positive tabindex support, this seems like a much easier,
        //  "close enough most of the time" alternative for positive tabindexes which should generally
        //  be avoided anyway...
        /** First tabbable node in container, __DOM__ order; `undefined` if none. */
        firstDomTabbableNode: T,
        /** Last tabbable node in container, __DOM__ order; `undefined` if none. */
        lastDomTabbableNode: O,
        /**
         * Finds the __tabbable__ node that follows the given node in the specified direction,
         *  in this container, if any.
         * @param {HTMLElement} node
         * @param {boolean} [forward] True if going in forward tab order; false if going
         *  in reverse.
         * @returns {HTMLElement|undefined} The next tabbable node, if any.
         */
        nextTabbableNode: function(Y) {
          var F = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0, U = b.indexOf(Y);
          return U < 0 ? F ? p.slice(p.indexOf(Y) + 1).find(function(Q) {
            return Vr(Q);
          }) : p.slice(0, p.indexOf(Y)).reverse().find(function(Q) {
            return Vr(Q);
          }) : b[U + (F ? 1 : -1)];
        }
      };
    }), r.tabbableGroups = r.containerGroups.filter(function(C) {
      return C.tabbableNodes.length > 0;
    }), r.tabbableGroups.length <= 0 && !y("fallbackFocus"))
      throw new Error("Your focus-trap must have at least one container with at least one tabbable node in it at all times");
    if (r.containerGroups.find(function(C) {
      return C.posTabIndexesFound;
    }) && r.containerGroups.length > 1)
      throw new Error("At least one node with a positive tabindex was found in one of your focus-trap's multiple containers. Positive tabindexes are only supported in single-container focus-traps.");
  }, h = function(C) {
    var b = C.activeElement;
    if (b)
      return b.shadowRoot && b.shadowRoot.activeElement !== null ? h(b.shadowRoot) : b;
  }, c = function(C) {
    if (C !== !1 && C !== h(document)) {
      if (!C || !C.focus) {
        c(u());
        return;
      }
      C.focus({
        preventScroll: !!a.preventScroll
      }), r.mostRecentlyFocusedNode = C, Ute(C) && C.select();
    }
  }, g = function(C) {
    var b = y("setReturnFocus", {
      params: [C]
    });
    return b || (b === !1 ? !1 : C);
  }, v = function(C) {
    var b = C.target, p = C.event, L = C.isBackward, B = L === void 0 ? !1 : L;
    b = b || Bd(p), m();
    var T = null;
    if (r.tabbableGroups.length > 0) {
      var O = d(b, p), I = O >= 0 ? r.containerGroups[O] : void 0;
      if (O < 0)
        B ? T = r.tabbableGroups[r.tabbableGroups.length - 1].lastTabbableNode : T = r.tabbableGroups[0].firstTabbableNode;
      else if (B) {
        var R = r.tabbableGroups.findIndex(function(ee) {
          var V = ee.firstTabbableNode;
          return b === V;
        });
        if (R < 0 && (I.container === b || kp(b, a.tabbableOptions) && !Vr(b, a.tabbableOptions) && !I.nextTabbableNode(b, !1)) && (R = O), R >= 0) {
          var Y = R === 0 ? r.tabbableGroups.length - 1 : R - 1, F = r.tabbableGroups[Y];
          T = hr(b) >= 0 ? F.lastTabbableNode : F.lastDomTabbableNode;
        } else
          Pl(p) || (T = I.nextTabbableNode(b, !1));
      } else {
        var U = r.tabbableGroups.findIndex(function(ee) {
          var V = ee.lastTabbableNode;
          return b === V;
        });
        if (U < 0 && (I.container === b || kp(b, a.tabbableOptions) && !Vr(b, a.tabbableOptions) && !I.nextTabbableNode(b)) && (U = O), U >= 0) {
          var Q = U === r.tabbableGroups.length - 1 ? 0 : U + 1, J = r.tabbableGroups[Q];
          T = hr(b) >= 0 ? J.firstTabbableNode : J.firstDomTabbableNode;
        } else
          Pl(p) || (T = I.nextTabbableNode(b));
      }
    } else
      T = y("fallbackFocus");
    return T;
  }, P = function(C) {
    var b = Bd(C);
    if (!(d(b, C) >= 0)) {
      if (dl(a.clickOutsideDeactivates, C)) {
        s.deactivate({
          // NOTE: by setting `returnFocus: false`, deactivate() will do nothing,
          //  which will result in the outside click setting focus to the node
          //  that was clicked (and if not focusable, to "nothing"); by setting
          //  `returnFocus: true`, we'll attempt to re-focus the node originally-focused
          //  on activation (or the configured `setReturnFocus` node), whether the
          //  outside click was on a focusable node or not
          returnFocus: a.returnFocusOnDeactivate
        });
        return;
      }
      dl(a.allowOutsideClick, C) || C.preventDefault();
    }
  }, f = function(C) {
    var b = Bd(C), p = d(b, C) >= 0;
    if (p || b instanceof Document)
      p && (r.mostRecentlyFocusedNode = b);
    else {
      C.stopImmediatePropagation();
      var L, B = !0;
      if (r.mostRecentlyFocusedNode)
        if (hr(r.mostRecentlyFocusedNode) > 0) {
          var T = d(r.mostRecentlyFocusedNode), O = r.containerGroups[T].tabbableNodes;
          if (O.length > 0) {
            var I = O.findIndex(function(R) {
              return R === r.mostRecentlyFocusedNode;
            });
            I >= 0 && (a.isKeyForward(r.recentNavEvent) ? I + 1 < O.length && (L = O[I + 1], B = !1) : I - 1 >= 0 && (L = O[I - 1], B = !1));
          }
        } else
          r.containerGroups.some(function(R) {
            return R.tabbableNodes.some(function(Y) {
              return hr(Y) > 0;
            });
          }) || (B = !1);
      else
        B = !1;
      B && (L = v({
        // move FROM the MRU node, not event-related node (which will be the node that is
        //  outside the trap causing the focus escape we're trying to fix)
        target: r.mostRecentlyFocusedNode,
        isBackward: a.isKeyBackward(r.recentNavEvent)
      })), c(L || r.mostRecentlyFocusedNode || u());
    }
    r.recentNavEvent = void 0;
  }, S = function(C) {
    var b = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
    r.recentNavEvent = C;
    var p = v({
      event: C,
      isBackward: b
    });
    p && (Pl(C) && C.preventDefault(), c(p));
  }, w = function(C) {
    (a.isKeyForward(C) || a.isKeyBackward(C)) && S(C, a.isKeyBackward(C));
  }, x = function(C) {
    Wte(C) && dl(a.escapeDeactivates, C) !== !1 && (C.preventDefault(), s.deactivate());
  }, k = function(C) {
    var b = Bd(C);
    d(b, C) >= 0 || dl(a.clickOutsideDeactivates, C) || dl(a.allowOutsideClick, C) || (C.preventDefault(), C.stopImmediatePropagation());
  }, A = function() {
    if (r.active)
      return L0.activateTrap(o, s), r.delayInitialFocusTimer = a.delayInitialFocus ? I0(function() {
        c(u());
      }) : c(u()), i.addEventListener("focusin", f, !0), i.addEventListener("mousedown", P, {
        capture: !0,
        passive: !1
      }), i.addEventListener("touchstart", P, {
        capture: !0,
        passive: !1
      }), i.addEventListener("click", k, {
        capture: !0,
        passive: !1
      }), i.addEventListener("keydown", w, {
        capture: !0,
        passive: !1
      }), i.addEventListener("keydown", x), s;
  }, $ = function() {
    if (r.active)
      return i.removeEventListener("focusin", f, !0), i.removeEventListener("mousedown", P, !0), i.removeEventListener("touchstart", P, !0), i.removeEventListener("click", k, !0), i.removeEventListener("keydown", w, !0), i.removeEventListener("keydown", x), s;
  }, j = function(C) {
    var b = C.some(function(p) {
      var L = Array.from(p.removedNodes);
      return L.some(function(B) {
        return B === r.mostRecentlyFocusedNode;
      });
    });
    b && c(u());
  }, N = typeof window < "u" && "MutationObserver" in window ? new MutationObserver(j) : void 0, M = function() {
    N && (N.disconnect(), r.active && !r.paused && r.containers.map(function(C) {
      N.observe(C, {
        subtree: !0,
        childList: !0
      });
    }));
  };
  return s = {
    get active() {
      return r.active;
    },
    get paused() {
      return r.paused;
    },
    activate: function(C) {
      if (r.active)
        return this;
      var b = l(C, "onActivate"), p = l(C, "onPostActivate"), L = l(C, "checkCanFocusTrap");
      L || m(), r.active = !0, r.paused = !1, r.nodeFocusedBeforeActivation = i.activeElement, b?.();
      var B = function() {
        L && m(), A(), M(), p?.();
      };
      return L ? (L(r.containers.concat()).then(B, B), this) : (B(), this);
    },
    deactivate: function(C) {
      if (!r.active)
        return this;
      var b = T0({
        onDeactivate: a.onDeactivate,
        onPostDeactivate: a.onPostDeactivate,
        checkCanReturnFocus: a.checkCanReturnFocus
      }, C);
      clearTimeout(r.delayInitialFocusTimer), r.delayInitialFocusTimer = void 0, $(), r.active = !1, r.paused = !1, M(), L0.deactivateTrap(o, s);
      var p = l(b, "onDeactivate"), L = l(b, "onPostDeactivate"), B = l(b, "checkCanReturnFocus"), T = l(b, "returnFocus", "returnFocusOnDeactivate");
      p?.();
      var O = function() {
        I0(function() {
          T && c(g(r.nodeFocusedBeforeActivation)), L?.();
        });
      };
      return T && B ? (B(g(r.nodeFocusedBeforeActivation)).then(O, O), this) : (O(), this);
    },
    pause: function(C) {
      if (r.paused || !r.active)
        return this;
      var b = l(C, "onPause"), p = l(C, "onPostPause");
      return r.paused = !0, b?.(), $(), M(), p?.(), this;
    },
    unpause: function(C) {
      if (!r.paused || !r.active)
        return this;
      var b = l(C, "onUnpause"), p = l(C, "onPostUnpause");
      return r.paused = !1, b?.(), m(), A(), M(), p?.(), this;
    },
    updateContainerElements: function(C) {
      var b = [].concat(C).filter(Boolean);
      return r.containers = b.map(function(p) {
        return typeof p == "string" ? i.querySelector(p) : p;
      }), r.active && m(), M(), this;
    }
  }, s.updateContainerElements(t), s;
};
const Zte = { class: "d-base-flyout__container" }, Jte = { class: "d-base-flyout__content" }, Qte = {
  key: 0,
  class: "d-base-flyout__close-btn"
}, ene = { class: "d-base-flyout__content" }, tne = /* @__PURE__ */ Be({
  __name: "BaseFlyout",
  props: {
    showFlyout: {
      type: Boolean,
      default: !1
    },
    appendTo: {
      type: String,
      default: "#dx-overlay"
    },
    modalAppendTo: {
      type: String,
      required: !1,
      default: "body"
    },
    type: {
      type: String,
      default: yr.Footer
    },
    useCloseButton: {
      type: Boolean,
      default: !0
    },
    defaultPadding: {
      type: Boolean,
      default: !0
    },
    fullWidth: {
      type: Boolean,
      default: !1
    },
    useBackdrop: {
      type: Boolean,
      default: !1
    },
    extraFocusableElement: {
      type: Object,
      default: null
    }
  },
  emits: ["close"],
  setup(e, { emit: t }) {
    const n = e, i = t, o = ge(null), a = ge(n.showFlyout), { isMobile: r } = xt(), s = ge(null), l = ge(null), { isSmallerXlAsync: d } = xt(), y = Te(
      () => !r.value || n.type === yr.Header
    ), u = () => {
      a.value = !1, i("close");
    }, { pageName: m } = Qe(), { t: h } = Je(), c = () => ({
      href: "",
      title: h("megaMenu.close"),
      text: "",
      contentUrl: "",
      isLocked: !1,
      target: "",
      isExternal: !1,
      linkType: yt.Javascript,
      tealiumTrackingModel: {
        eventSource: m,
        eventComponentName: "BaseFlyout",
        eventTitle: "Close Flyout"
      }
    }), g = () => {
      const x = [o?.value];
      return d.value && n?.extraFocusableElement && n?.type === yr.Header && x.push(n.extraFocusableElement), x;
    }, v = (x) => {
      const k = x?.target;
      return k && k instanceof HTMLElement ? k?.getAttribute("data-outside-click")?.toLowerCase() !== "true" : !0;
    }, P = () => {
      l?.value && l?.value();
    }, f = (x) => {
      s.value = Xte(x, {
        fallbackFocus: document.body,
        escapeDeactivates: !1,
        clickOutsideDeactivates: v,
        onDeactivate: P,
        onActivate() {
          l.value = bte(x);
        }
      }), s?.value.activate();
    }, S = () => {
      const x = g();
      f(x);
    }, w = () => {
      s?.value && s?.value?.deactivate();
    };
    return qe(
      () => n.showFlyout,
      async (x) => {
        a.value = x, await mt(), x && o?.value && Ue ? S() : Ue && w();
      }
    ), Fa(() => {
      w();
    }), (x, k) => (E(), X(Re, null, [
      y.value ? (E(), X(Re, { key: 0 }, [
        ue(_(Yn), { "append-to": e.appendTo }, {
          default: Se(() => [
            a.value && e.useBackdrop ? (E(), X("div", {
              key: 0,
              class: "d-base-flyout__backdrop",
              onClick: u
            })) : te("", !0)
          ]),
          _: 1
        }, 8, ["append-to"]),
        ue(_(Yn), { "append-to": e.appendTo }, {
          default: Se(() => [
            ue(oo, null, {
              default: Se(() => [
                a.value ? (E(), X("div", {
                  key: 0,
                  ref_key: "flyoutRef",
                  ref: o,
                  class: Pe(["d-base-flyout", {
                    "d-base-flyout__padding": e.defaultPadding,
                    "d-base-flyout__no-padding": !e.defaultPadding
                  }])
                }, [
                  oe("div", Zte, [
                    ue(Vt, {
                      id: "flyout",
                      class: "d-base-flyout__page-section",
                      "content-in-full-width": e.fullWidth,
                      "no-margin-bottom": !0
                    }, {
                      default: Se(() => [
                        oe("div", Jte, [
                          e.useCloseButton ? (E(), X("div", Qte, [
                            ue(Nt, {
                              "link-model": c(),
                              type: _(Ke).RoundedSecondary,
                              size: _(et).Small,
                              icon: _(H).Times,
                              "data-id": "silktide-close",
                              onClick: u
                            }, null, 8, ["link-model", "type", "size", "icon"])
                          ])) : te("", !0),
                          je(x.$slots, "default", {}, void 0, !0)
                        ])
                      ]),
                      _: 3
                    }, 8, ["content-in-full-width"])
                  ])
                ], 2)) : te("", !0)
              ]),
              _: 3
            })
          ]),
          _: 3
        }, 8, ["append-to"])
      ], 64)) : te("", !0),
      y.value ? te("", !0) : (E(), fe(Ei, {
        key: 1,
        display: e.showFlyout,
        "append-to": e.modalAppendTo,
        onCloseDialog: u
      }, {
        content: Se(() => [
          oe("div", ene, [
            je(x.$slots, "default", {}, void 0, !0)
          ])
        ]),
        _: 3
      }, 8, ["display", "append-to"]))
    ], 64));
  }
});
const Ng = /* @__PURE__ */ Fe(tne, [["__scopeId", "data-v-c15ffebf"]]), nne = /* @__PURE__ */ Be({
  __name: "BaseAudioPlayer",
  props: {
    model: {
      type: Object,
      required: !0
    }
  },
  emits: ["play", "loaded", "ended"],
  setup(e, { expose: t, emit: n }) {
    const i = e, { containerQueriesEnabled: o } = Bi(), a = n, r = ge(null), s = Te(() => i.model?.playerType ? i.model.playerType === Ir.AudioOnly : i.model?.playerId === Lr.AudioOnly), l = Te(() => i.model?.playerType ? i.model.playerType === Ir.AudioWithImage : i.model?.playerId === Lr.AudioWithImage), d = () => {
      a("play");
    }, y = () => {
      a("loaded");
    }, u = () => {
      a("ended");
    };
    return t({
      play: () => {
        r.value?.play(), a("play");
      }
    }), (h, c) => e.model && (l.value || s.value) ? (E(), X("div", {
      key: 0,
      class: Pe(["d-base-audio-player-container", {
        "d-base-audio-player-container--container": _(o),
        "d-base-audio-player-container--media": !_(o)
      }])
    }, [
      oe("div", {
        class: Pe(["d-base-audio-player", {
          "d-base-audio-player--with-image": l.value,
          "d-base-audio-player--audio-only": s.value
        }])
      }, [
        ue(_(yg), {
          ref_key: "playerRef",
          ref: r,
          "base-video-player-props": e.model,
          onVideoPlay: d,
          onLoaded: y,
          onEnded: u
        }, null, 8, ["base-video-player-props"])
      ], 2)
    ], 2)) : te("", !0);
  }
});
const Sp = /* @__PURE__ */ Fe(nne, [["__scopeId", "data-v-2f06651d"]]);
var Pt = /* @__PURE__ */ ((e) => (e.Email = "email", e.EmailLink = "email-link", e.Facebook = "facebook", e.Linkedin = "linkedin", e.Twitter = "twitter", e.Xing = "xing", e.Youtube = "youtube", e))(Pt || {});
const ine = /* @__PURE__ */ Be({
  __name: "ShareButton",
  props: {
    model: {
      type: Object,
      required: !0
    },
    size: {
      type: String,
      default: et.Inherit
    },
    buttonType: {
      type: String,
      default: Ke.RoundedPrimary
    },
    focusable: {
      type: Boolean,
      default: !0
    }
  },
  setup(e) {
    const t = e, { t: n } = Je(), i = Te(() => {
      switch (t.model.network) {
        case Pt.Facebook:
          return H.FacebookF;
        case Pt.Linkedin:
          return H.LinkedinIn;
        case Pt.Xing:
          return H.Xing;
        case Pt.EmailLink:
        case Pt.Email:
          return H.Envelope;
        case Pt.Twitter:
          return H.Twitter;
        case Pt.Youtube:
          return H.Youtube;
      }
    }), o = () => {
      const a = t.model.network === Pt.EmailLink ? Pt.Email : t.model.network;
      return {
        contentUrl: "",
        title: "",
        text: "",
        isLocked: !1,
        target: "",
        isExternal: !1,
        linkType: yt.Javascript,
        tealiumTrackingModel: {
          eventSource: Qe().pageName,
          eventComponentName: "shareButton",
          eventTitle: a,
          eventTarget: a
        }
      };
    };
    return (a, r) => e.model ? (E(), fe(_(Wk), {
      key: 0,
      network: e.model.network,
      url: e.model.url,
      title: e.model?.title,
      description: e.model.description,
      hashtags: e.model.hashtags,
      quote: e.model.quote
    }, {
      default: Se(({ share: s }) => [
        ue(Nt, {
          "link-model": o(),
          type: e.buttonType,
          size: e.size,
          icon: i.value,
          "aria-label": e.model.network === _(Pt).Email || e.model.network === _(Pt).EmailLink ? `${_(n)("breadcrumb.email")}` : `${_(n)("shareButton.label")} ${e.model.network}`,
          tabindex: e.focusable ? null : -1,
          class: "d-share-button",
          role: "link",
          onClick: s
        }, null, 8, ["link-model", "type", "size", "icon", "aria-label", "tabindex", "onClick"])
      ]),
      _: 1
    }, 8, ["network", "url", "title", "description", "hashtags", "quote"])) : te("", !0);
  }
});
const Lh = /* @__PURE__ */ Fe(ine, [["__scopeId", "data-v-319bc82d"]]), ane = /* @__PURE__ */ Be({
  __name: "BaseBar",
  props: {
    percent: {
      type: Number,
      default: 0
    },
    active: {
      type: Boolean,
      default: !0
    }
  },
  setup(e) {
    const t = e, n = Te(() => `--width: ${Math.min(100, Math.max(0, t.percent))}%;`);
    return (i, o) => (E(), X("div", {
      class: Pe(["d-base-bar", { "d-base-bar--active": e.active }]),
      role: "presentation"
    }, [
      oe("span", {
        class: "d-base-bar__filled",
        style: hn(n.value)
      }, null, 4)
    ], 2));
  }
});
const one = /* @__PURE__ */ Fe(ane, [["__scopeId", "data-v-618414ba"]]);
var Ih = /* @__PURE__ */ ((e) => (e.LeafGreen = "leaf-green", e.SkyBlue = "sky-blue", e.OceanBlue = "ocean-blue", e.SustainedGreen = "sustained-green", e.ProgPurple = "prog-purple", e.Amber = "amber", e.Pink = "pink", e.PrimaryColor = "petrol-45", e.GreyBlue000 = "grey-blue-000", e.GreyBlue001 = "grey-blue-001", e.GreyBlue008 = "grey-blue-008", e.GreyBlue009 = "grey-blue-009", e))(Ih || {});
const rne = /* @__PURE__ */ Be({
  __name: "BasePolygonBox",
  props: {
    polygonBoxBackgroundColor: {
      type: String,
      default: Ih.GreyBlue008
    },
    opacity: {
      type: Number,
      default: 0.9
    }
  },
  setup(e) {
    const t = e, n = Te(() => `--opacity: ${t.opacity}`);
    return (i, o) => (E(), X("div", {
      class: Pe(["d-base-polygon-box d-base-polygon-box--opacity", "d-base-polygon-box--" + e.polygonBoxBackgroundColor]),
      style: hn(n.value)
    }, [
      je(i.$slots, "default", {}, void 0, !0)
    ], 6));
  }
});
const WC = /* @__PURE__ */ Fe(rne, [["__scopeId", "data-v-f52764b2"]]), sne = /* @__PURE__ */ Be({
  __name: "BaseContactBox",
  props: {
    model: {
      type: Object,
      required: !0
    }
  },
  setup(e) {
    return (t, n) => e.model ? (E(), X("div", {
      key: 0,
      class: Pe(["d-base-contact-box", { "d-base-contact-box--sticky": e.model.isSticky }])
    }, [
      n[0] || (n[0] = oe("div", { class: "d-base-contact-box__triangle--left" }, null, -1)),
      n[1] || (n[1] = oe("div", { class: "d-base-contact-box__triangle--right" }, null, -1)),
      e.model.headline ? (E(), fe(Ot, {
        key: 0,
        class: "d-base-contact-box__heading",
        "base-heading-type": _(ze).StyledAsH3
      }, {
        default: Se(() => [
          Ve(Ie(e.model.headline), 1)
        ]),
        _: 1
      }, 8, ["base-heading-type"])) : te("", !0),
      e.model.htmlContent ? (E(), fe(ht, {
        key: 1,
        class: "d-base-contact-box__html",
        "html-text": e.model.htmlContent
      }, null, 8, ["html-text"])) : te("", !0),
      (E(!0), X(Re, null, Ge(e.model.contacts, (i) => (E(), X("div", {
        key: i.name,
        class: "d-base-contact-box__links"
      }, [
        i.name ? (E(), fe(_(Tt), {
          key: 0,
          "font-size": _(st).SixteenPx,
          "font-type": _(lt).DwsSansBold,
          "text-color": _(dt).GreyBlue008,
          text: i.name,
          class: "d-base-contact-box__links-headline"
        }, null, 8, ["font-size", "font-type", "text-color", "text"])) : te("", !0),
        i.mail ? (E(), fe(ot, {
          key: 1,
          "is-copy-link": !0,
          "link-model": i.mail,
          icon: _(H).Envelope,
          "icon-position": _(ct).Left,
          class: "d-base-contact-box__mail"
        }, null, 8, ["link-model", "icon", "icon-position"])) : te("", !0),
        i.tel ? (E(), fe(ot, {
          key: 2,
          "is-copy-link": !0,
          "link-model": i.tel,
          icon: _(H).Phone,
          "icon-position": _(ct).Left
        }, null, 8, ["link-model", "icon", "icon-position"])) : te("", !0)
      ]))), 128))
    ], 2)) : te("", !0);
  }
});
const Lc = /* @__PURE__ */ Fe(sne, [["__scopeId", "data-v-1269bad7"]]), lne = {
  key: 0,
  class: "d-new-base-slider-footer"
}, cne = { class: "d-new-base-slider-footer__indicators" }, dne = /* @__PURE__ */ Be({
  __name: "NewBaseSliderFooter",
  props: {
    currentIndex: {
      type: Number,
      default: 0
    },
    numItems: {
      type: Number,
      default: 0
    },
    numVisible: {
      type: Number,
      default: 3
    },
    numScroll: {
      type: Number,
      default: 1
    },
    disableBackwardButton: {
      type: Boolean,
      default: !1
    },
    disableForwardButton: {
      type: Boolean,
      default: !1
    },
    moreLink: {
      type: Object,
      default: null
    }
  },
  emits: ["forward", "backward", "jumpTo"],
  setup(e, { emit: t }) {
    const n = e, { t: i } = Je(), o = t, a = ge(1);
    it(() => {
      u(n.currentIndex);
    });
    const r = Te(() => n.numVisible === n.numScroll ? n.numItems / n.numVisible : Math.ceil((n.numItems - n.numVisible) / n.numScroll) + 1), s = Te(() => (h) => h === a.value ? Ke.RoundedPrimary : Ke.RoundedNonFilled), l = () => {
      a.value < r.value && a.value++, o("forward");
    }, d = () => {
      a.value > 1 && a.value--, o("backward");
    }, y = (h) => {
      const c = n.numScroll * h - 1;
      a.value = h, o("jumpTo", c);
    }, u = (h) => {
      n.numScroll === 1 ? a.value = h * n.numScroll + 1 : a.value = Math.floor(h / n.numScroll) + 1;
    };
    qe(
      () => n.currentIndex,
      (h) => u(h)
    );
    const m = () => ({
      contentUrl: "",
      title: "",
      target: "_self",
      isLocked: !1,
      isExternal: !1,
      linkType: za.Javascript,
      tealiumTrackingModel: {
        eventSource: Qe().pageName,
        eventComponentName: "new-base-slider",
        eventTitle: ""
      }
    });
    return (h, c) => e.numItems > 0 ? (E(), X("div", lne, [
      ue(Nt, {
        "link-model": m(),
        type: _(Ke).RoundedNonFilled,
        size: _(et).Inherit,
        icon: _(H).AngleLeft,
        disabled: e.disableBackwardButton,
        "aria-disabled": e.disableBackwardButton,
        "aria-label": _(i)("baseSlider.navBackward"),
        class: "d-new-base-slider-footer__backward",
        onClick: c[0] || (c[0] = (g) => d())
      }, null, 8, ["link-model", "type", "size", "icon", "disabled", "aria-disabled", "aria-label"]),
      oe("div", cne, [
        (E(!0), X(Re, null, Ge(r.value, (g) => (E(), fe(Nt, {
          key: g,
          "link-model": m(),
          type: s.value(g),
          size: _(et).Inherit,
          "aria-label": `${_(i)("baseSlider.navToPage")} ${g}`,
          "aria-current": g === a.value ? "page" : null,
          class: Pe(["d-new-base-slider-footer__indicator", {
            "d-new-base-slider-footer__indicator--active": g === a.value
          }]),
          onClick: (v) => y(g)
        }, null, 8, ["link-model", "type", "size", "aria-label", "aria-current", "class", "onClick"]))), 128))
      ]),
      ue(Nt, {
        "link-model": m(),
        type: _(Ke).RoundedNonFilled,
        size: _(et).Inherit,
        icon: _(H).AngleRight,
        disabled: e.disableForwardButton,
        "aria-disabled": e.disableForwardButton,
        "aria-label": _(i)("baseSlider.navForward"),
        class: "d-new-base-slider-footer__forward",
        onClick: c[1] || (c[1] = (g) => l())
      }, null, 8, ["link-model", "type", "size", "icon", "disabled", "aria-disabled", "aria-label"]),
      e.moreLink && e.moreLink.href ? (E(), fe(ot, {
        key: 0,
        class: "d-new-base-slider-footer__more-link",
        "link-model": e.moreLink,
        icon: _(H).ArrowRight
      }, null, 8, ["link-model", "icon"])) : te("", !0)
    ])) : te("", !0);
  }
});
const une = /* @__PURE__ */ Fe(dne, [["__scopeId", "data-v-81e414e9"]]);
var Ph = /* @__PURE__ */ ((e) => (e.Image = "image", e.Grey = "grey", e.GreyStripes = "grey-stripes", e.None = "none", e))(Ph || {});
const hne = { class: "d-new-base-slider" }, pne = ["aria-label", "onKeypress", "onClick", "onTouchend"], fne = /* @__PURE__ */ Be({
  __name: "NewBaseSlider",
  props: {
    items: {},
    isCircular: { type: Boolean, default: !1 },
    numVisible: { default: 3 },
    numScroll: { default: 1 },
    startIndex: { default: 0 },
    showIndicators: { type: Boolean, default: !0 },
    showButtons: { type: Boolean, default: !0 },
    autoplayInterval: {},
    stretchItems: { type: Boolean, default: !1 },
    moreLink: {},
    cutAfterTenItems: { type: Boolean, default: !1 },
    backgroundType: { default: void 0 },
    backgroundImage: { default: void 0 }
  },
  emits: ["forward", "backward", "itemClicked"],
  setup(e, { expose: t, emit: n }) {
    const i = e, { isMobile: o, currentBreakpoint: a } = xt(), { t: r } = Je(), s = n, l = Te(() => i.cutAfterTenItems && i.items.length > 10 ? 10 : i.items.length), d = ge([]), y = Te(() => Math.min(i.numVisible, l.value)), u = ge(i.isCircular ? 1 : i.numScroll), m = () => i.isCircular ? Math.ceil(y.value / 2) - 1 + P.value : i.startIndex + P.value, h = () => d.value[0]?.clientWidth ?? 0, c = () => o.value && Ue ? h() * 100 / window.innerWidth * u.value : i.isCircular ? h() * 100 / j.value : 100 / y.value * u.value, g = ge(null), v = ge(null), P = ge(i.isCircular ? y.value - 1 : 0), f = ge(
      i.isCircular ? i.items.length + P.value - 1 : l.value - y.value
    ), S = ge(
      (i.numScroll > 1 ? 0 : i.startIndex) + P.value
    ), w = ge(m()), x = ge(S.value), k = ge(x.value + y.value - 1), A = ge(0), $ = ge(0), j = ge(0), N = ge(0), M = ge(y.value % 2 !== 0), D = () => {
      Ue && window.requestAnimationFrame(() => {
        j.value = h() * y.value, A.value = c(), $.value = S.value * A.value * -1, N.value = i.isCircular ? A.value * (y.value + 1) * -1 : A.value * ((l.value - y.value) / u.value) * -1;
      });
    };
    it(() => {
      D();
    }), qe(
      () => o.value,
      () => D()
    );
    const C = Te(() => i.isCircular ? [
      ...i.items.slice(-(y.value - 1)),
      ...i.items,
      ...i.items.slice(0, y.value - 1)
    ] : i.cutAfterTenItems ? i.items.slice(0, 10) : i.items), b = Te(
      () => i.stretchItems && !i.showButtons ? "--width: 100%;" : `--width: ${j.value}px;`
    ), p = Te(() => `--flex: 1 0 ${100 / y.value}%;`), L = Te(
      () => `transform: translate3d(${$.value}%, 0px, 0px);`
    ), B = Te(() => w.value === P.value), T = Te(() => w.value === f.value), O = () => w.value - P.value, I = () => {
      w.value -= u.value, $.value = $.value + A.value, x.value = x.value - 1 * u.value, fi(() => {
        k.value = k.value - 1 * u.value;
      }, 500), s("backward", i.items[O()], O());
    }, R = () => {
      w.value += u.value, $.value = $.value - A.value, k.value = k.value + 1 * u.value, fi(() => {
        x.value = x.value + 1 * u.value;
      }, 500), s("forward", i.items[O()], O());
    }, Y = () => {
      const W = i.isCircular ? Math.ceil(y.value / 2) - 1 : 0;
      w.value = P.value, x.value = P.value - W, k.value = P.value + y.value - 1, $.value = (P.value - W) * A.value * -1, s("forward", i.items[O()], O());
    }, F = () => {
      const W = i.isCircular ? Math.floor(y.value / 2) : 0, ae = i.isCircular ? M.value ? W : 1 : 0;
      w.value = f.value, x.value = f.value - ae, k.value = f.value + W;
      let z = i.isCircular ? l.value - i.numVisible : 0;
      i.isCircular && y.value === 2 && (z = -1), i.isCircular ? $.value = N.value - A.value * z : $.value = N.value, s("forward", i.items[O()], O());
    }, U = () => {
      T.value ? i.isCircular && Y() : R();
    }, Q = () => {
      B.value ? i.isCircular && F() : I();
    }, J = (W) => {
      const ae = w.value - W;
      if (ae > 0)
        for (let z = 0; z < ae; z++)
          Q();
      else if (ae < 0)
        for (let z = 0; z < Math.abs(ae); z++)
          U();
    }, ee = (W) => {
      J(W), s("itemClicked", i.items[O()], O());
    };
    o && Zx(v, {
      passive: !1,
      onSwipeEnd(W, ae) {
        ae === "left" ? U() : ae === "right" && Q();
      }
    });
    const V = () => ({
      contentUrl: "",
      title: "",
      target: "_self",
      isLocked: !1,
      isExternal: !1,
      linkType: za.Javascript,
      tealiumTrackingModel: {
        eventSource: Qe().pageName,
        eventComponentName: "new-base-slider",
        eventTitle: ""
      }
    });
    qe(
      () => a.value,
      () => {
        k.value = x.value + y.value - 1;
      }
    );
    const G = Te(() => i.backgroundType === void 0 ? "" : `d-new-base-slider__background--${i.backgroundType}`);
    return t({ navForward: U, navBackward: Q, jumpToItem: J }), (W, ae) => (E(), X("div", hne, [
      oe("div", {
        class: Pe(["d-new-base-slider__background", G.value]),
        style: hn(
          W.backgroundImage && W.backgroundType === _(Ph).Image ? { backgroundImage: `url(${W.backgroundImage})` } : {}
        )
      }, [
        oe("div", {
          class: Pe([
            "d-new-base-slider__container",
            W.backgroundType !== void 0 ? "d-new-base-slider__container--with-background" : ""
          ])
        }, [
          !_(o) && W.showButtons ? (E(), fe(Nt, {
            key: 0,
            "link-model": V(),
            type: _(Ke).RoundedNonFilled,
            size: _(et).Small,
            icon: _(H).AngleLeft,
            disabled: !W.isCircular && B.value,
            "aria-disabled": !W.isCircular && B.value,
            "aria-label": _(r)("baseSlider.navBackward"),
            class: "d-new-base-slider__backward",
            onClick: ae[0] || (ae[0] = (z) => Q())
          }, null, 8, ["link-model", "type", "size", "icon", "disabled", "aria-disabled", "aria-label"])) : te("", !0),
          oe("div", {
            ref_key: "sliderContent",
            ref: g,
            class: "d-new-base-slider__content",
            style: hn(b.value)
          }, [
            oe("div", {
              ref_key: "sliderItemContainer",
              ref: v,
              class: "d-new-base-slider__items",
              style: hn(L.value)
            }, [
              (E(!0), X(Re, null, Ge(C.value, (z, q) => (E(), X("div", {
                key: q,
                ref_for: !0,
                ref: (Z) => d.value[q] = Z,
                class: Pe(["d-new-base-slider__item d-new-base-slider__items--flex", {
                  "d-new-base-slider__item--active": q === w.value,
                  "d-new-base-slider__item--visible": q >= x.value && q <= k.value
                }]),
                tabindex: "0",
                role: "button",
                "aria-label": `${_(r)("baseSlider.navToPage")} ${q + 1}`,
                style: hn(p.value),
                onKeypress: Ze((Z) => ee(q), ["enter"]),
                onClick: (Z) => ee(q),
                onTouchend: (Z) => ee(q)
              }, [
                je(W.$slots, "item", { item: z }, void 0, !0)
              ], 46, pne))), 128))
            ], 4)
          ], 4),
          !_(o) && W.showButtons ? (E(), fe(Nt, {
            key: 1,
            "link-model": V(),
            type: _(Ke).RoundedNonFilled,
            size: _(et).Small,
            icon: _(H).AngleRight,
            disabled: !W.isCircular && T.value,
            "aria-disabled": !W.isCircular && T.value,
            "aria-label": _(r)("baseSlider.navForward"),
            class: "d-new-base-slider__forward",
            onClick: ae[1] || (ae[1] = (z) => U())
          }, null, 8, ["link-model", "type", "size", "icon", "disabled", "aria-disabled", "aria-label"])) : te("", !0)
        ], 2)
      ], 6),
      W.showIndicators && !W.isCircular && l.value > y.value ? (E(), fe(une, {
        key: 0,
        "current-index": w.value,
        "num-items": l.value,
        "num-visible": y.value,
        "num-scroll": u.value,
        "disable-backward-button": !W.isCircular && B.value,
        "disable-forward-button": !W.isCircular && T.value,
        "more-link": i.moreLink,
        onBackward: Q,
        onForward: U,
        onJumpTo: J
      }, null, 8, ["current-index", "num-items", "num-visible", "num-scroll", "disable-backward-button", "disable-forward-button", "more-link"])) : te("", !0)
    ]));
  }
});
const $g = /* @__PURE__ */ Fe(fne, [["__scopeId", "data-v-0ce18343"]]);
var mne = `
@layer primevue {
    .p-tree-container {
        margin: 0;
        padding: 0;
        list-style-type: none;
        overflow: auto;
    }

    .p-treenode-children {
        margin: 0;
        padding: 0;
        list-style-type: none;
    }

    .p-tree-wrapper {
        overflow: auto;
    }

    .p-treenode-selectable {
        cursor: pointer;
        user-select: none;
    }

    .p-tree-toggler {
        cursor: pointer;
        user-select: none;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        overflow: hidden;
        position: relative;
        flex-shrink: 0;
    }

    .p-treenode-leaf > .p-treenode-content .p-tree-toggler {
        visibility: hidden;
    }

    .p-treenode-content {
        display: flex;
        align-items: center;
    }

    .p-tree-filter {
        width: 100%;
    }

    .p-tree-filter-container {
        position: relative;
        display: block;
        width: 100%;
    }

    .p-tree-filter-icon {
        position: absolute;
        top: 50%;
        margin-top: -0.5rem;
    }

    .p-tree-loading {
        position: relative;
        min-height: 4rem;
    }

    .p-tree .p-tree-loading-overlay {
        position: absolute;
        z-index: 1;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .p-tree-flex-scrollable {
        display: flex;
        flex: 1;
        height: 100%;
        flex-direction: column;
    }

    .p-tree-flex-scrollable .p-tree-wrapper {
        flex: 1;
    }
}
`, gne = {
  root: function(t) {
    var n = t.props;
    return ["p-tree p-component", {
      "p-tree-selectable": n.selectionMode != null,
      "p-tree-loading": n.loading,
      "p-tree-flex-scrollable": n.scrollHeight === "flex"
    }];
  },
  loadingOverlay: "p-tree-loading-overlay p-component-overlay",
  loadingIcon: "p-tree-loading-icon",
  filterContainer: "p-tree-filter-container",
  input: "p-tree-filter p-inputtext p-component",
  searchIcon: "p-tree-filter-icon",
  wrapper: "p-tree-wrapper",
  container: "p-tree-container",
  node: function(t) {
    var n = t.instance;
    return ["p-treenode", {
      "p-treenode-leaf": n.leaf
    }];
  },
  content: function(t) {
    var n = t.instance;
    return ["p-treenode-content", n.node.styleClass, {
      "p-treenode-selectable": n.selectable,
      "p-highlight": n.checkboxMode ? n.checked : n.selected
    }];
  },
  toggler: "p-tree-toggler p-link",
  togglerIcon: "p-tree-toggler-icon",
  nodeTogglerIcon: "p-tree-node-toggler-icon",
  checkboxContainer: "p-checkbox p-component",
  checkbox: function(t) {
    var n = t.instance;
    return ["p-checkbox-box", {
      "p-highlight": n.checked,
      "p-indeterminate": n.partialChecked
    }];
  },
  checkboxIcon: "p-checkbox-icon",
  nodeIcon: "p-treenode-icon",
  label: "p-treenode-label",
  subgroup: "p-treenode-children"
}, vne = Wt.extend({
  name: "tree",
  css: mne,
  classes: gne
}), YC = {
  name: "MinusIcon",
  extends: Yt
}, yne = /* @__PURE__ */ oe("path", {
  d: "M13.2222 7.77778H0.777778C0.571498 7.77778 0.373667 7.69584 0.227806 7.54998C0.0819442 7.40412 0 7.20629 0 7.00001C0 6.79373 0.0819442 6.5959 0.227806 6.45003C0.373667 6.30417 0.571498 6.22223 0.777778 6.22223H13.2222C13.4285 6.22223 13.6263 6.30417 13.7722 6.45003C13.9181 6.5959 14 6.79373 14 7.00001C14 7.20629 13.9181 7.40412 13.7722 7.54998C13.6263 7.69584 13.4285 7.77778 13.2222 7.77778Z",
  fill: "currentColor"
}, null, -1), bne = [yne];
function xne(e, t, n, i, o, a) {
  return E(), X("svg", Ce({
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.pti()), bne, 16);
}
YC.render = xne;
var wne = {
  name: "BaseTree",
  extends: wt,
  props: {
    value: {
      type: null,
      default: null
    },
    expandedKeys: {
      type: null,
      default: null
    },
    selectionKeys: {
      type: null,
      default: null
    },
    selectionMode: {
      type: String,
      default: null
    },
    metaKeySelection: {
      type: Boolean,
      default: !1
    },
    loading: {
      type: Boolean,
      default: !1
    },
    loadingIcon: {
      type: String,
      default: void 0
    },
    loadingMode: {
      type: String,
      default: "mask"
    },
    filter: {
      type: Boolean,
      default: !1
    },
    filterBy: {
      type: String,
      default: "label"
    },
    filterMode: {
      type: String,
      default: "lenient"
    },
    filterPlaceholder: {
      type: String,
      default: null
    },
    filterLocale: {
      type: String,
      default: void 0
    },
    scrollHeight: {
      type: String,
      default: null
    },
    level: {
      type: Number,
      default: 0
    },
    ariaLabelledby: {
      type: String,
      default: null
    },
    ariaLabel: {
      type: String,
      default: null
    }
  },
  style: vne,
  provide: function() {
    return {
      $parentInstance: this
    };
  }
};
function Ic(e) {
  "@babel/helpers - typeof";
  return Ic = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Ic(e);
}
function P0(e, t) {
  var n = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (!n) {
    if (Array.isArray(e) || (n = qC(e)) || t && e && typeof e.length == "number") {
      n && (e = n);
      var i = 0, o = function() {
      };
      return { s: o, n: function() {
        return i >= e.length ? { done: !0 } : { done: !1, value: e[i++] };
      }, e: function(d) {
        throw d;
      }, f: o };
    }
    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  var a = !0, r = !1, s;
  return { s: function() {
    n = n.call(e);
  }, n: function() {
    var d = n.next();
    return a = d.done, d;
  }, e: function(d) {
    r = !0, s = d;
  }, f: function() {
    try {
      !a && n.return != null && n.return();
    } finally {
      if (r)
        throw s;
    }
  } };
}
function A0(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    t && (i = i.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), n.push.apply(n, i);
  }
  return n;
}
function _0(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? A0(Object(n), !0).forEach(function(i) {
      kne(e, i, n[i]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : A0(Object(n)).forEach(function(i) {
      Object.defineProperty(e, i, Object.getOwnPropertyDescriptor(n, i));
    });
  }
  return e;
}
function kne(e, t, n) {
  return t = Sne(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function Sne(e) {
  var t = Cne(e, "string");
  return Ic(t) == "symbol" ? t : String(t);
}
function Cne(e, t) {
  if (Ic(e) != "object" || !e)
    return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var i = n.call(e, t || "default");
    if (Ic(i) != "object")
      return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function ul(e) {
  return Ine(e) || Lne(e) || qC(e) || Tne();
}
function Tne() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function qC(e, t) {
  if (e) {
    if (typeof e == "string")
      return Bf(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set")
      return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return Bf(e, t);
  }
}
function Lne(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null)
    return Array.from(e);
}
function Ine(e) {
  if (Array.isArray(e))
    return Bf(e);
}
function Bf(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, i = new Array(t); n < t; n++)
    i[n] = e[n];
  return i;
}
var KC = {
  name: "TreeNode",
  hostName: "Tree",
  extends: wt,
  emits: ["node-toggle", "node-click", "checkbox-change"],
  props: {
    node: {
      type: null,
      default: null
    },
    expandedKeys: {
      type: null,
      default: null
    },
    loadingMode: {
      type: String,
      default: "mask"
    },
    selectionKeys: {
      type: null,
      default: null
    },
    selectionMode: {
      type: String,
      default: null
    },
    templates: {
      type: null,
      default: null
    },
    level: {
      type: Number,
      default: null
    },
    index: null
  },
  nodeTouched: !1,
  toggleClicked: !1,
  mounted: function() {
    this.setAllNodesTabIndexes();
  },
  methods: {
    toggle: function() {
      this.$emit("node-toggle", this.node), this.toggleClicked = !0;
    },
    label: function(t) {
      return typeof t.label == "function" ? t.label() : t.label;
    },
    onChildNodeToggle: function(t) {
      this.$emit("node-toggle", t);
    },
    getPTOptions: function(t) {
      return this.ptm(t, {
        context: {
          index: this.index,
          expanded: this.expanded,
          selected: this.selected,
          checked: this.checked,
          leaf: this.leaf
        }
      });
    },
    onClick: function(t) {
      if (this.toggleClicked || Oe.getAttribute(t.target, '[data-pc-section="toggler"]') || Oe.getAttribute(t.target.parentElement, '[data-pc-section="toggler"]')) {
        this.toggleClicked = !1;
        return;
      }
      this.isCheckboxSelectionMode() ? this.toggleCheckbox() : this.$emit("node-click", {
        originalEvent: t,
        nodeTouched: this.nodeTouched,
        node: this.node
      }), this.nodeTouched = !1;
    },
    onChildNodeClick: function(t) {
      this.$emit("node-click", t);
    },
    onTouchEnd: function() {
      this.nodeTouched = !0;
    },
    onKeyDown: function(t) {
      if (this.isSameNode(t))
        switch (t.code) {
          case "Tab":
            this.onTabKey(t);
            break;
          case "ArrowDown":
            this.onArrowDown(t);
            break;
          case "ArrowUp":
            this.onArrowUp(t);
            break;
          case "ArrowRight":
            this.onArrowRight(t);
            break;
          case "ArrowLeft":
            this.onArrowLeft(t);
            break;
          case "Enter":
          case "NumpadEnter":
          case "Space":
            this.onEnterKey(t);
            break;
        }
    },
    onArrowDown: function(t) {
      var n = t.target.getAttribute("data-pc-section") === "toggler" ? t.target.closest('[role="treeitem"]') : t.target, i = n.children[1];
      if (i)
        this.focusRowChange(n, i.children[0]);
      else if (n.nextElementSibling)
        this.focusRowChange(n, n.nextElementSibling);
      else {
        var o = this.findNextSiblingOfAncestor(n);
        o && this.focusRowChange(n, o);
      }
      t.preventDefault();
    },
    onArrowUp: function(t) {
      var n = t.target;
      if (n.previousElementSibling)
        this.focusRowChange(n, n.previousElementSibling, this.findLastVisibleDescendant(n.previousElementSibling));
      else {
        var i = this.getParentNodeElement(n);
        i && this.focusRowChange(n, i);
      }
      t.preventDefault();
    },
    onArrowRight: function(t) {
      var n = this;
      this.leaf || this.expanded || (t.currentTarget.tabIndex = -1, this.$emit("node-toggle", this.node), this.$nextTick(function() {
        n.onArrowDown(t);
      }));
    },
    onArrowLeft: function(t) {
      var n = Oe.findSingle(t.currentTarget, '[data-pc-section="toggler"]');
      if (this.level === 0 && !this.expanded)
        return !1;
      if (this.expanded && !this.leaf)
        return n.click(), !1;
      var i = this.findBeforeClickableNode(t.currentTarget);
      i && this.focusRowChange(t.currentTarget, i);
    },
    onEnterKey: function(t) {
      this.setTabIndexForSelectionMode(t, this.nodeTouched), this.onClick(t), t.preventDefault();
    },
    onTabKey: function() {
      this.setAllNodesTabIndexes();
    },
    setAllNodesTabIndexes: function() {
      var t = Oe.find(this.$refs.currentNode.closest('[data-pc-section="container"]'), '[role="treeitem"]'), n = ul(t).some(function(o) {
        return o.getAttribute("aria-selected") === "true" || o.getAttribute("aria-checked") === "true";
      });
      if (ul(t).forEach(function(o) {
        o.tabIndex = -1;
      }), n) {
        var i = ul(t).filter(function(o) {
          return o.getAttribute("aria-selected") === "true" || o.getAttribute("aria-checked") === "true";
        });
        i[0].tabIndex = 0;
        return;
      }
      ul(t)[0].tabIndex = 0;
    },
    setTabIndexForSelectionMode: function(t, n) {
      if (this.selectionMode !== null) {
        var i = ul(Oe.find(this.$refs.currentNode.parentElement, '[role="treeitem"]'));
        t.currentTarget.tabIndex = n === !1 ? -1 : 0, i.every(function(o) {
          return o.tabIndex === -1;
        }) && (i[0].tabIndex = 0);
      }
    },
    focusRowChange: function(t, n, i) {
      t.tabIndex = "-1", n.tabIndex = "0", this.focusNode(i || n);
    },
    findBeforeClickableNode: function(t) {
      var n = t.closest("ul").closest("li");
      if (n) {
        var i = Oe.findSingle(n, "button");
        return i && i.style.visibility !== "hidden" ? n : this.findBeforeClickableNode(t.previousElementSibling);
      }
      return null;
    },
    toggleCheckbox: function() {
      var t = this.selectionKeys ? _0({}, this.selectionKeys) : {}, n = !this.checked;
      this.propagateDown(this.node, n, t), this.$emit("checkbox-change", {
        node: this.node,
        check: n,
        selectionKeys: t
      });
    },
    propagateDown: function(t, n, i) {
      if (n ? i[t.key] = {
        checked: !0,
        partialChecked: !1
      } : delete i[t.key], t.children && t.children.length) {
        var o = P0(t.children), a;
        try {
          for (o.s(); !(a = o.n()).done; ) {
            var r = a.value;
            this.propagateDown(r, n, i);
          }
        } catch (s) {
          o.e(s);
        } finally {
          o.f();
        }
      }
    },
    propagateUp: function(t) {
      var n = t.check, i = _0({}, t.selectionKeys), o = 0, a = !1, r = P0(this.node.children), s;
      try {
        for (r.s(); !(s = r.n()).done; ) {
          var l = s.value;
          i[l.key] && i[l.key].checked ? o++ : i[l.key] && i[l.key].partialChecked && (a = !0);
        }
      } catch (d) {
        r.e(d);
      } finally {
        r.f();
      }
      n && o === this.node.children.length ? i[this.node.key] = {
        checked: !0,
        partialChecked: !1
      } : (n || delete i[this.node.key], a || o > 0 && o !== this.node.children.length ? i[this.node.key] = {
        checked: !1,
        partialChecked: !0
      } : delete i[this.node.key]), this.$emit("checkbox-change", {
        node: t.node,
        check: t.check,
        selectionKeys: i
      });
    },
    onChildCheckboxChange: function(t) {
      this.$emit("checkbox-change", t);
    },
    findNextSiblingOfAncestor: function(t) {
      var n = this.getParentNodeElement(t);
      return n ? n.nextElementSibling ? n.nextElementSibling : this.findNextSiblingOfAncestor(n) : null;
    },
    findLastVisibleDescendant: function(t) {
      var n = t.children[1];
      if (n) {
        var i = n.children[n.children.length - 1];
        return this.findLastVisibleDescendant(i);
      } else
        return t;
    },
    getParentNodeElement: function(t) {
      var n = t.parentElement.parentElement;
      return Oe.getAttribute(n, "role") === "treeitem" ? n : null;
    },
    focusNode: function(t) {
      t.focus();
    },
    isCheckboxSelectionMode: function() {
      return this.selectionMode === "checkbox";
    },
    isSameNode: function(t) {
      return t.currentTarget && (t.currentTarget.isSameNode(t.target) || t.currentTarget.isSameNode(t.target.closest('[role="treeitem"]')));
    }
  },
  computed: {
    hasChildren: function() {
      return this.node.children && this.node.children.length > 0;
    },
    expanded: function() {
      return this.expandedKeys && this.expandedKeys[this.node.key] === !0;
    },
    leaf: function() {
      return this.node.leaf === !1 ? !1 : !(this.node.children && this.node.children.length);
    },
    selectable: function() {
      return this.node.selectable === !1 ? !1 : this.selectionMode != null;
    },
    selected: function() {
      return this.selectionMode && this.selectionKeys ? this.selectionKeys[this.node.key] === !0 : !1;
    },
    checkboxMode: function() {
      return this.selectionMode === "checkbox" && this.node.selectable !== !1;
    },
    checked: function() {
      return this.selectionKeys ? this.selectionKeys[this.node.key] && this.selectionKeys[this.node.key].checked : !1;
    },
    partialChecked: function() {
      return this.selectionKeys ? this.selectionKeys[this.node.key] && this.selectionKeys[this.node.key].partialChecked : !1;
    },
    ariaChecked: function() {
      return this.selectionMode === "single" || this.selectionMode === "multiple" ? this.selected : void 0;
    },
    ariaSelected: function() {
      return this.checkboxMode ? this.checked : void 0;
    }
  },
  components: {
    ChevronDownIcon: Va,
    ChevronRightIcon: Fo,
    CheckIcon: Oa,
    MinusIcon: YC,
    SpinnerIcon: jo
  },
  directives: {
    ripple: An
  }
}, Pne = ["aria-label", "aria-selected", "aria-expanded", "aria-setsize", "aria-posinset", "aria-level", "aria-checked", "tabindex"], Ane = ["data-p-highlight", "data-p-selectable"], _ne = ["data-p-checked", "data-p-partialchecked"];
function Mne(e, t, n, i, o, a) {
  var r = $e("SpinnerIcon"), s = $e("TreeNode", !0), l = Ut("ripple");
  return E(), X("li", Ce({
    ref: "currentNode",
    class: e.cx("node"),
    role: "treeitem",
    "aria-label": a.label(n.node),
    "aria-selected": a.ariaSelected,
    "aria-expanded": a.expanded,
    "aria-setsize": n.node.children ? n.node.children.length : 0,
    "aria-posinset": n.index + 1,
    "aria-level": n.level,
    "aria-checked": a.ariaChecked,
    tabindex: n.index === 0 ? 0 : -1,
    onKeydown: t[4] || (t[4] = function() {
      return a.onKeyDown && a.onKeyDown.apply(a, arguments);
    })
  }, n.level === 1 ? a.getPTOptions("node") : e.ptm("subgroup")), [oe("div", Ce({
    class: e.cx("content"),
    onClick: t[2] || (t[2] = function() {
      return a.onClick && a.onClick.apply(a, arguments);
    }),
    onTouchend: t[3] || (t[3] = function() {
      return a.onTouchEnd && a.onTouchEnd.apply(a, arguments);
    }),
    style: n.node.style
  }, a.getPTOptions("content"), {
    "data-p-highlight": a.checkboxMode ? a.checked : a.selected,
    "data-p-selectable": a.selectable
  }), [rt((E(), X("button", Ce({
    type: "button",
    class: e.cx("toggler"),
    onClick: t[0] || (t[0] = function() {
      return a.toggle && a.toggle.apply(a, arguments);
    }),
    tabindex: "-1",
    "aria-hidden": "true"
  }, a.getPTOptions("toggler")), [n.node.loading && n.loadingMode === "icon" ? (E(), X(Re, {
    key: 0
  }, [n.templates.nodetogglericon ? (E(), fe(tt(n.templates.nodetogglericon), {
    key: 0,
    class: Pe(e.cx("nodetogglericon"))
  }, null, 8, ["class"])) : (E(), fe(r, Ce({
    key: 1,
    spin: "",
    class: e.cx("nodetogglericon")
  }, e.ptm("nodetogglericon")), null, 16, ["class"]))], 64)) : (E(), X(Re, {
    key: 1
  }, [n.templates.togglericon ? (E(), fe(tt(n.templates.togglericon), {
    key: 0,
    node: n.node,
    expanded: a.expanded,
    class: Pe(e.cx("togglerIcon"))
  }, null, 8, ["node", "expanded", "class"])) : a.expanded ? (E(), fe(tt(n.node.expandedIcon ? "span" : "ChevronDownIcon"), Ce({
    key: 1,
    class: e.cx("togglerIcon")
  }, a.getPTOptions("togglerIcon")), null, 16, ["class"])) : (E(), fe(tt(n.node.collapsedIcon ? "span" : "ChevronRightIcon"), Ce({
    key: 2,
    class: e.cx("togglerIcon")
  }, a.getPTOptions("togglerIcon")), null, 16, ["class"]))], 64))], 16)), [[l]]), a.checkboxMode ? (E(), X("div", Ce({
    key: 0,
    class: e.cx("checkboxContainer"),
    "aria-hidden": "true"
  }, a.getPTOptions("checkboxContainer")), [oe("div", Ce({
    class: e.cx("checkbox"),
    role: "checkbox"
  }, a.getPTOptions("checkbox"), {
    "data-p-checked": a.checked,
    "data-p-partialchecked": a.partialChecked
  }), [n.templates.checkboxicon ? (E(), fe(tt(n.templates.checkboxicon), {
    key: 0,
    checked: a.checked,
    partialChecked: a.partialChecked,
    class: Pe(e.cx("checkboxIcon"))
  }, null, 8, ["checked", "partialChecked", "class"])) : (E(), fe(tt(a.checked ? "CheckIcon" : a.partialChecked ? "MinusIcon" : null), Ce({
    key: 1,
    class: e.cx("checkboxIcon")
  }, a.getPTOptions("checkboxIcon")), null, 16, ["class"]))], 16, _ne)], 16)) : te("", !0), oe("span", Ce({
    class: [e.cx("nodeIcon"), n.node.icon]
  }, a.getPTOptions("nodeIcon")), null, 16), oe("span", Ce({
    class: e.cx("label")
  }, a.getPTOptions("label"), {
    onKeydown: t[1] || (t[1] = It(function() {
    }, ["stop"]))
  }), [n.templates[n.node.type] || n.templates.default ? (E(), fe(tt(n.templates[n.node.type] || n.templates.default), {
    key: 0,
    node: n.node
  }, null, 8, ["node"])) : (E(), X(Re, {
    key: 1
  }, [Ve(Ie(a.label(n.node)), 1)], 64))], 16)], 16, Ane), a.hasChildren && a.expanded ? (E(), X("ul", Ce({
    key: 0,
    class: e.cx("subgroup"),
    role: "group"
  }, e.ptm("subgroup")), [(E(!0), X(Re, null, Ge(n.node.children, function(d) {
    return E(), fe(s, {
      key: d.key,
      node: d,
      templates: n.templates,
      level: n.level + 1,
      expandedKeys: n.expandedKeys,
      onNodeToggle: a.onChildNodeToggle,
      onNodeClick: a.onChildNodeClick,
      selectionMode: n.selectionMode,
      selectionKeys: n.selectionKeys,
      onCheckboxChange: a.propagateUp,
      pt: e.pt
    }, null, 8, ["node", "templates", "level", "expandedKeys", "onNodeToggle", "onNodeClick", "selectionMode", "selectionKeys", "onCheckboxChange", "pt"]);
  }), 128))], 16)) : te("", !0)], 16, Pne);
}
KC.render = Mne;
function Pc(e) {
  "@babel/helpers - typeof";
  return Pc = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Pc(e);
}
function Cp(e, t) {
  var n = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (!n) {
    if (Array.isArray(e) || (n = XC(e)) || t && e && typeof e.length == "number") {
      n && (e = n);
      var i = 0, o = function() {
      };
      return { s: o, n: function() {
        return i >= e.length ? { done: !0 } : { done: !1, value: e[i++] };
      }, e: function(d) {
        throw d;
      }, f: o };
    }
    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  var a = !0, r = !1, s;
  return { s: function() {
    n = n.call(e);
  }, n: function() {
    var d = n.next();
    return a = d.done, d;
  }, e: function(d) {
    r = !0, s = d;
  }, f: function() {
    try {
      !a && n.return != null && n.return();
    } finally {
      if (r)
        throw s;
    }
  } };
}
function One(e) {
  return Dne(e) || Ene(e) || XC(e) || Bne();
}
function Bne() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function XC(e, t) {
  if (e) {
    if (typeof e == "string")
      return Ef(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set")
      return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return Ef(e, t);
  }
}
function Ene(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null)
    return Array.from(e);
}
function Dne(e) {
  if (Array.isArray(e))
    return Ef(e);
}
function Ef(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, i = new Array(t); n < t; n++)
    i[n] = e[n];
  return i;
}
function M0(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    t && (i = i.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), n.push.apply(n, i);
  }
  return n;
}
function er(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? M0(Object(n), !0).forEach(function(i) {
      Rne(e, i, n[i]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : M0(Object(n)).forEach(function(i) {
      Object.defineProperty(e, i, Object.getOwnPropertyDescriptor(n, i));
    });
  }
  return e;
}
function Rne(e, t, n) {
  return t = Nne(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function Nne(e) {
  var t = $ne(e, "string");
  return Pc(t) == "symbol" ? t : String(t);
}
function $ne(e, t) {
  if (Pc(e) != "object" || !e)
    return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var i = n.call(e, t || "default");
    if (Pc(i) != "object")
      return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var ZC = {
  name: "Tree",
  extends: wne,
  emits: ["node-expand", "node-collapse", "update:expandedKeys", "update:selectionKeys", "node-select", "node-unselect", "filter"],
  data: function() {
    return {
      d_expandedKeys: this.expandedKeys || {},
      filterValue: null
    };
  },
  watch: {
    expandedKeys: function(t) {
      this.d_expandedKeys = t;
    }
  },
  methods: {
    onNodeToggle: function(t) {
      var n = t.key;
      this.d_expandedKeys[n] ? (delete this.d_expandedKeys[n], this.$emit("node-collapse", t)) : (this.d_expandedKeys[n] = !0, this.$emit("node-expand", t)), this.d_expandedKeys = er({}, this.d_expandedKeys), this.$emit("update:expandedKeys", this.d_expandedKeys);
    },
    onNodeClick: function(t) {
      if (this.selectionMode != null && t.node.selectable !== !1) {
        var n = t.nodeTouched ? !1 : this.metaKeySelection, i = n ? this.handleSelectionWithMetaKey(t) : this.handleSelectionWithoutMetaKey(t);
        this.$emit("update:selectionKeys", i);
      }
    },
    onCheckboxChange: function(t) {
      this.$emit("update:selectionKeys", t.selectionKeys), t.check ? this.$emit("node-select", t.node) : this.$emit("node-unselect", t.node);
    },
    handleSelectionWithMetaKey: function(t) {
      var n = t.originalEvent, i = t.node, o = n.metaKey || n.ctrlKey, a = this.isNodeSelected(i), r;
      return a && o ? (this.isSingleSelectionMode() ? r = {} : (r = er({}, this.selectionKeys), delete r[i.key]), this.$emit("node-unselect", i)) : (this.isSingleSelectionMode() ? r = {} : this.isMultipleSelectionMode() && (r = o ? this.selectionKeys ? er({}, this.selectionKeys) : {} : {}), r[i.key] = !0, this.$emit("node-select", i)), r;
    },
    handleSelectionWithoutMetaKey: function(t) {
      var n = t.node, i = this.isNodeSelected(n), o;
      return this.isSingleSelectionMode() ? i ? (o = {}, this.$emit("node-unselect", n)) : (o = {}, o[n.key] = !0, this.$emit("node-select", n)) : i ? (o = er({}, this.selectionKeys), delete o[n.key], this.$emit("node-unselect", n)) : (o = this.selectionKeys ? er({}, this.selectionKeys) : {}, o[n.key] = !0, this.$emit("node-select", n)), o;
    },
    isSingleSelectionMode: function() {
      return this.selectionMode === "single";
    },
    isMultipleSelectionMode: function() {
      return this.selectionMode === "multiple";
    },
    isNodeSelected: function(t) {
      return this.selectionMode && this.selectionKeys ? this.selectionKeys[t.key] === !0 : !1;
    },
    isChecked: function(t) {
      return this.selectionKeys ? this.selectionKeys[t.key] && this.selectionKeys[t.key].checked : !1;
    },
    isNodeLeaf: function(t) {
      return t.leaf === !1 ? !1 : !(t.children && t.children.length);
    },
    onFilterKeydown: function(t) {
      (t.code === "Enter" || t.code === "NumpadEnter") && t.preventDefault(), this.$emit("filter", {
        originalEvent: t,
        value: t.target.value
      });
    },
    findFilteredNodes: function(t, n) {
      if (t) {
        var i = !1;
        if (t.children) {
          var o = One(t.children);
          t.children = [];
          var a = Cp(o), r;
          try {
            for (a.s(); !(r = a.n()).done; ) {
              var s = r.value, l = er({}, s);
              this.isFilterMatched(l, n) && (i = !0, t.children.push(l));
            }
          } catch (d) {
            a.e(d);
          } finally {
            a.f();
          }
        }
        if (i)
          return !0;
      }
    },
    isFilterMatched: function(t, n) {
      var i = n.searchFields, o = n.filterText, a = n.strict, r = !1, s = Cp(i), l;
      try {
        for (s.s(); !(l = s.n()).done; ) {
          var d = l.value, y = String(We.resolveFieldData(t, d)).toLocaleLowerCase(this.filterLocale);
          y.indexOf(o) > -1 && (r = !0);
        }
      } catch (u) {
        s.e(u);
      } finally {
        s.f();
      }
      return (!r || a && !this.isNodeLeaf(t)) && (r = this.findFilteredNodes(t, {
        searchFields: i,
        filterText: o,
        strict: a
      }) || r), r;
    }
  },
  computed: {
    filteredValue: function() {
      var t = [], n = this.filterBy.split(","), i = this.filterValue.trim().toLocaleLowerCase(this.filterLocale), o = this.filterMode === "strict", a = Cp(this.value), r;
      try {
        for (a.s(); !(r = a.n()).done; ) {
          var s = r.value, l = er({}, s), d = {
            searchFields: n,
            filterText: i,
            strict: o
          };
          (o && (this.findFilteredNodes(l, d) || this.isFilterMatched(l, d)) || !o && (this.isFilterMatched(l, d) || this.findFilteredNodes(l, d))) && t.push(l);
        }
      } catch (y) {
        a.e(y);
      } finally {
        a.f();
      }
      return t;
    },
    valueToRender: function() {
      return this.filterValue && this.filterValue.trim().length > 0 ? this.filteredValue : this.value;
    }
  },
  components: {
    TreeNode: KC,
    SearchIcon: fh,
    SpinnerIcon: jo
  }
}, Fne = ["placeholder"], jne = ["aria-labelledby", "aria-label"];
function Hne(e, t, n, i, o, a) {
  var r = $e("SpinnerIcon"), s = $e("SearchIcon"), l = $e("TreeNode");
  return E(), X("div", Ce({
    class: e.cx("root")
  }, e.ptm("root"), {
    "data-pc-name": "tree"
  }), [e.loading && e.loadingMode === "mask" ? (E(), X("div", Ce({
    key: 0,
    class: e.cx("loadingOverlay")
  }, e.ptm("loadingOverlay")), [je(e.$slots, "loadingicon", {
    class: Pe(e.cx("loadingIcon"))
  }, function() {
    return [e.loadingIcon ? (E(), X("i", Ce({
      key: 0,
      class: [e.cx("loadingIcon"), "pi-spin", e.loadingIcon]
    }, e.ptm("loadingIcon")), null, 16)) : (E(), fe(r, Ce({
      key: 1,
      spin: "",
      class: e.cx("loadingIcon")
    }, e.ptm("loadingIcon")), null, 16, ["class"]))];
  })], 16)) : te("", !0), e.filter ? (E(), X("div", Ce({
    key: 1,
    class: e.cx("filterContainer")
  }, e.ptm("filterContainer")), [rt(oe("input", Ce({
    "onUpdate:modelValue": t[0] || (t[0] = function(d) {
      return o.filterValue = d;
    }),
    type: "text",
    autocomplete: "off",
    class: e.cx("input"),
    placeholder: e.filterPlaceholder,
    onKeydown: t[1] || (t[1] = function() {
      return a.onFilterKeydown && a.onFilterKeydown.apply(a, arguments);
    })
  }, e.ptm("input")), null, 16, Fne), [[$x, o.filterValue]]), je(e.$slots, "searchicon", {
    class: Pe(e.cx("searchIcon"))
  }, function() {
    return [ue(s, Ce({
      class: e.cx("searchIcon")
    }, e.ptm("searchIcon")), null, 16, ["class"])];
  })], 16)) : te("", !0), oe("div", Ce({
    class: e.cx("wrapper"),
    style: {
      maxHeight: e.scrollHeight
    }
  }, e.ptm("wrapper")), [oe("ul", Ce({
    class: e.cx("container"),
    role: "tree",
    "aria-labelledby": e.ariaLabelledby,
    "aria-label": e.ariaLabel
  }, e.ptm("container")), [(E(!0), X(Re, null, Ge(a.valueToRender, function(d, y) {
    return E(), fe(l, {
      key: d.key,
      node: d,
      templates: e.$slots,
      level: e.level + 1,
      index: y,
      expandedKeys: o.d_expandedKeys,
      onNodeToggle: a.onNodeToggle,
      onNodeClick: a.onNodeClick,
      selectionMode: e.selectionMode,
      selectionKeys: e.selectionKeys,
      onCheckboxChange: a.onCheckboxChange,
      loadingMode: e.loadingMode,
      pt: e.pt,
      unstyled: e.unstyled
    }, null, 8, ["node", "templates", "level", "index", "expandedKeys", "onNodeToggle", "onNodeClick", "selectionMode", "selectionKeys", "onCheckboxChange", "loadingMode", "pt", "unstyled"]);
  }), 128))], 16, jne)], 16)], 16);
}
ZC.render = Hne;
var zne = `
@layer primevue {
    .p-treeselect {
        display: inline-flex;
        cursor: pointer;
        user-select: none;
    }

    .p-treeselect-trigger {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
    }

    .p-treeselect-label-container {
        overflow: hidden;
        flex: 1 1 auto;
        cursor: pointer;
    }

    .p-treeselect-label {
        display: block;
        white-space: nowrap;
        cursor: pointer;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .p-treeselect-label-empty {
        overflow: hidden;
        visibility: hidden;
    }

    .p-treeselect-token {
        cursor: default;
        display: inline-flex;
        align-items: center;
        flex: 0 0 auto;
    }

    .p-treeselect .p-treeselect-panel {
        min-width: 100%;
    }

    .p-treeselect-items-wrapper {
        overflow: auto;
    }

    .p-fluid .p-treeselect {
        display: flex;
    }
}
`, Vne = {
  root: function(t) {
    var n = t.props;
    return {
      position: n.appendTo === "self" ? "relative" : void 0
    };
  }
}, Gne = {
  root: function(t) {
    var n = t.instance, i = t.props;
    return ["p-treeselect p-component p-inputwrapper", {
      "p-treeselect-chip": i.display === "chip",
      "p-disabled": i.disabled,
      "p-focus": n.focused,
      "p-inputwrapper-filled": !n.emptyValue,
      "p-inputwrapper-focus": n.focused || n.overlayVisible
    }];
  },
  labelContainer: "p-treeselect-label-container",
  label: function(t) {
    var n = t.instance, i = t.props;
    return ["p-treeselect-label", {
      "p-placeholder": n.label === i.placeholder,
      "p-treeselect-label-empty": !i.placeholder && n.emptyValue
    }];
  },
  token: "p-treeselect-token",
  tokenLabel: "p-treeselect-token-label",
  trigger: "p-treeselect-trigger",
  triggerIcon: "p-treeselect-trigger-icon",
  panel: function(t) {
    var n = t.instance;
    return ["p-treeselect-panel p-component", {
      "p-input-filled": n.$primevue.config.inputStyle === "filled",
      "p-ripple-disabled": n.$primevue.config.ripple === !1
    }];
  },
  wrapper: "p-treeselect-items-wrapper",
  emptyMessage: "p-treeselect-empty-message"
}, Une = Wt.extend({
  name: "treeselect",
  css: zne,
  classes: Gne,
  inlineStyles: Vne
}), Wne = {
  name: "BaseTreeSelect",
  extends: wt,
  props: {
    modelValue: null,
    options: Array,
    scrollHeight: {
      type: String,
      default: "400px"
    },
    placeholder: {
      type: String,
      default: null
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    tabindex: {
      type: Number,
      default: null
    },
    selectionMode: {
      type: String,
      default: "single"
    },
    appendTo: {
      type: [String, Object],
      default: "body"
    },
    emptyMessage: {
      type: String,
      default: null
    },
    display: {
      type: String,
      default: "comma"
    },
    metaKeySelection: {
      type: Boolean,
      default: !1
    },
    inputId: {
      type: String,
      default: null
    },
    inputClass: {
      type: [String, Object],
      default: null
    },
    inputStyle: {
      type: Object,
      default: null
    },
    inputProps: {
      type: null,
      default: null
    },
    panelClass: {
      type: [String, Object],
      default: null
    },
    panelProps: {
      type: null,
      default: null
    },
    ariaLabelledby: {
      type: String,
      default: null
    },
    ariaLabel: {
      type: String,
      default: null
    }
  },
  style: Une,
  provide: function() {
    return {
      $parentInstance: this
    };
  }
};
function Ac(e) {
  "@babel/helpers - typeof";
  return Ac = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Ac(e);
}
function O0(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    t && (i = i.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), n.push.apply(n, i);
  }
  return n;
}
function B0(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? O0(Object(n), !0).forEach(function(i) {
      Yne(e, i, n[i]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : O0(Object(n)).forEach(function(i) {
      Object.defineProperty(e, i, Object.getOwnPropertyDescriptor(n, i));
    });
  }
  return e;
}
function Yne(e, t, n) {
  return t = qne(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function qne(e) {
  var t = Kne(e, "string");
  return Ac(t) == "symbol" ? t : String(t);
}
function Kne(e, t) {
  if (Ac(e) != "object" || !e)
    return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var i = n.call(e, t || "default");
    if (Ac(i) != "object")
      return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function hl(e, t) {
  var n = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (!n) {
    if (Array.isArray(e) || (n = JC(e)) || t && e && typeof e.length == "number") {
      n && (e = n);
      var i = 0, o = function() {
      };
      return { s: o, n: function() {
        return i >= e.length ? { done: !0 } : { done: !1, value: e[i++] };
      }, e: function(d) {
        throw d;
      }, f: o };
    }
    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  var a = !0, r = !1, s;
  return { s: function() {
    n = n.call(e);
  }, n: function() {
    var d = n.next();
    return a = d.done, d;
  }, e: function(d) {
    r = !0, s = d;
  }, f: function() {
    try {
      !a && n.return != null && n.return();
    } finally {
      if (r)
        throw s;
    }
  } };
}
function Xne(e) {
  return Qne(e) || Jne(e) || JC(e) || Zne();
}
function Zne() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function JC(e, t) {
  if (e) {
    if (typeof e == "string")
      return Df(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set")
      return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return Df(e, t);
  }
}
function Jne(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null)
    return Array.from(e);
}
function Qne(e) {
  if (Array.isArray(e))
    return Df(e);
}
function Df(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, i = new Array(t); n < t; n++)
    i[n] = e[n];
  return i;
}
var QC = {
  name: "TreeSelect",
  extends: Wne,
  emits: ["update:modelValue", "before-show", "before-hide", "change", "show", "hide", "node-select", "node-unselect", "node-expand", "node-collapse", "focus", "blur"],
  data: function() {
    return {
      focused: !1,
      overlayVisible: !1,
      expandedKeys: {}
    };
  },
  watch: {
    modelValue: {
      handler: function() {
        this.selfChange || this.updateTreeState(), this.selfChange = !1;
      },
      immediate: !0
    },
    options: function() {
      this.updateTreeState();
    }
  },
  outsideClickListener: null,
  resizeListener: null,
  scrollHandler: null,
  overlay: null,
  selfChange: !1,
  selfClick: !1,
  beforeUnmount: function() {
    this.unbindOutsideClickListener(), this.unbindResizeListener(), this.scrollHandler && (this.scrollHandler.destroy(), this.scrollHandler = null), this.overlay && (qt.clear(this.overlay), this.overlay = null);
  },
  mounted: function() {
    this.updateTreeState();
  },
  methods: {
    show: function() {
      this.$emit("before-show"), this.overlayVisible = !0;
    },
    hide: function() {
      this.$emit("before-hide"), this.overlayVisible = !1, this.$refs.focusInput.focus();
    },
    onFocus: function(t) {
      this.focused = !0, this.$emit("focus", t);
    },
    onBlur: function(t) {
      this.focused = !1, this.$emit("blur", t);
    },
    onClick: function(t) {
      this.disabled || !this.disabled && (!this.overlay || !this.overlay.contains(t.target)) && (this.overlayVisible ? this.hide() : this.show(), Oe.focus(this.$refs.focusInput));
    },
    onSelectionChange: function(t) {
      this.selfChange = !0, this.$emit("update:modelValue", t), this.$emit("change", t);
    },
    onNodeSelect: function(t) {
      this.$emit("node-select", t), this.selectionMode === "single" && this.hide();
    },
    onNodeUnselect: function(t) {
      this.$emit("node-unselect", t);
    },
    onNodeToggle: function(t) {
      this.expandedKeys = t;
    },
    onFirstHiddenFocus: function(t) {
      var n = t.relatedTarget === this.$refs.focusInput ? Oe.getFirstFocusableElement(this.overlay, ':not([data-p-hidden-focusable="true"])') : this.$refs.focusInput;
      Oe.focus(n);
    },
    onLastHiddenFocus: function(t) {
      var n = t.relatedTarget === this.$refs.focusInput ? Oe.getLastFocusableElement(this.overlay, ':not([data-p-hidden-focusable="true"])') : this.$refs.focusInput;
      Oe.focus(n);
    },
    onKeyDown: function(t) {
      switch (t.code) {
        case "ArrowDown":
          this.onArrowDownKey(t);
          break;
        case "Space":
        case "Enter":
        case "NumpadEnter":
          this.onEnterKey(t);
          break;
        case "Escape":
          this.onEscapeKey(t);
          break;
        case "Tab":
          this.onTabKey(t);
          break;
      }
    },
    onArrowDownKey: function(t) {
      var n = this;
      this.overlayVisible || (this.show(), this.$nextTick(function() {
        var i = Oe.find(n.$refs.tree.$el, '[data-pc-section="treeitem"]'), o = Xne(i).find(function(a) {
          return a.getAttribute("tabindex") === "0";
        });
        Oe.focus(o);
      }), t.preventDefault());
    },
    onEnterKey: function(t) {
      this.overlayVisible ? this.hide() : this.onArrowDownKey(t), t.preventDefault();
    },
    onEscapeKey: function(t) {
      this.overlayVisible && (this.hide(), t.preventDefault());
    },
    onTabKey: function(t) {
      var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
      n || this.overlayVisible && this.hasFocusableElements() && (Oe.focus(this.$refs.firstHiddenFocusableElementOnOverlay), t.preventDefault());
    },
    hasFocusableElements: function() {
      return Oe.getFocusableElements(this.overlay, ':not([data-p-hidden-focusable="true"])').length > 0;
    },
    onOverlayEnter: function(t) {
      qt.set("overlay", t, this.$primevue.config.zIndex.overlay), Oe.addStyles(t, {
        position: "absolute",
        top: "0",
        left: "0"
      }), this.alignOverlay(), this.focus();
    },
    onOverlayAfterEnter: function() {
      this.bindOutsideClickListener(), this.bindScrollListener(), this.bindResizeListener(), this.scrollValueInView(), this.$emit("show");
    },
    onOverlayLeave: function() {
      this.unbindOutsideClickListener(), this.unbindScrollListener(), this.unbindResizeListener(), this.$emit("hide"), this.overlay = null;
    },
    onOverlayAfterLeave: function(t) {
      qt.clear(t);
    },
    focus: function() {
      var t = Oe.getFocusableElements(this.overlay);
      t && t.length > 0 && t[0].focus();
    },
    alignOverlay: function() {
      this.appendTo === "self" ? Oe.relativePosition(this.overlay, this.$el) : (this.overlay.style.minWidth = Oe.getOuterWidth(this.$el) + "px", Oe.absolutePosition(this.overlay, this.$el));
    },
    bindOutsideClickListener: function() {
      var t = this;
      this.outsideClickListener || (this.outsideClickListener = function(n) {
        t.overlayVisible && !t.selfClick && t.isOutsideClicked(n) && t.hide(), t.selfClick = !1;
      }, document.addEventListener("click", this.outsideClickListener));
    },
    unbindOutsideClickListener: function() {
      this.outsideClickListener && (document.removeEventListener("click", this.outsideClickListener), this.outsideClickListener = null);
    },
    bindScrollListener: function() {
      var t = this;
      this.scrollHandler || (this.scrollHandler = new po(this.$refs.container, function() {
        t.overlayVisible && t.hide();
      })), this.scrollHandler.bindScrollListener();
    },
    unbindScrollListener: function() {
      this.scrollHandler && this.scrollHandler.unbindScrollListener();
    },
    bindResizeListener: function() {
      var t = this;
      this.resizeListener || (this.resizeListener = function() {
        t.overlayVisible && !Oe.isTouchDevice() && t.hide();
      }, window.addEventListener("resize", this.resizeListener));
    },
    unbindResizeListener: function() {
      this.resizeListener && (window.removeEventListener("resize", this.resizeListener), this.resizeListener = null);
    },
    isOutsideClicked: function(t) {
      return !(this.$el.isSameNode(t.target) || this.$el.contains(t.target) || this.overlay && this.overlay.contains(t.target));
    },
    overlayRef: function(t) {
      this.overlay = t;
    },
    onOverlayClick: function(t) {
      Zn.emit("overlay-click", {
        originalEvent: t,
        target: this.$el
      }), this.selfClick = !0;
    },
    onOverlayKeydown: function(t) {
      t.code === "Escape" && this.hide();
    },
    findSelectedNodes: function(t, n, i) {
      if (t) {
        if (this.isSelected(t, n) && (i.push(t), delete n[t.key]), Object.keys(n).length && t.children) {
          var o = hl(t.children), a;
          try {
            for (o.s(); !(a = o.n()).done; ) {
              var r = a.value;
              this.findSelectedNodes(r, n, i);
            }
          } catch (y) {
            o.e(y);
          } finally {
            o.f();
          }
        }
      } else {
        var s = hl(this.options), l;
        try {
          for (s.s(); !(l = s.n()).done; ) {
            var d = l.value;
            this.findSelectedNodes(d, n, i);
          }
        } catch (y) {
          s.e(y);
        } finally {
          s.f();
        }
      }
    },
    isSelected: function(t, n) {
      return this.selectionMode === "checkbox" ? n[t.key] && n[t.key].checked : n[t.key];
    },
    updateTreeState: function() {
      var t = B0({}, this.modelValue);
      this.expandedKeys = {}, t && this.options && this.updateTreeBranchState(null, null, t);
    },
    updateTreeBranchState: function(t, n, i) {
      if (t) {
        if (this.isSelected(t, i) && (this.expandPath(n), delete i[t.key]), Object.keys(i).length && t.children) {
          var o = hl(t.children), a;
          try {
            for (o.s(); !(a = o.n()).done; ) {
              var r = a.value;
              n.push(t.key), this.updateTreeBranchState(r, n, i);
            }
          } catch (y) {
            o.e(y);
          } finally {
            o.f();
          }
        }
      } else {
        var s = hl(this.options), l;
        try {
          for (s.s(); !(l = s.n()).done; ) {
            var d = l.value;
            this.updateTreeBranchState(d, [], i);
          }
        } catch (y) {
          s.e(y);
        } finally {
          s.f();
        }
      }
    },
    expandPath: function(t) {
      if (t.length > 0) {
        var n = hl(t), i;
        try {
          for (n.s(); !(i = n.n()).done; ) {
            var o = i.value;
            this.expandedKeys[o] = !0;
          }
        } catch (a) {
          n.e(a);
        } finally {
          n.f();
        }
      }
    },
    scrollValueInView: function() {
      if (this.overlay) {
        var t = Oe.findSingle(this.overlay, '[data-p-highlight="true"]');
        t && t.scrollIntoView({
          block: "nearest",
          inline: "start"
        });
      }
    }
  },
  computed: {
    selectedNodes: function() {
      var t = [];
      if (this.modelValue && this.options) {
        var n = B0({}, this.modelValue);
        this.findSelectedNodes(null, n, t);
      }
      return t;
    },
    label: function() {
      var t = this.selectedNodes;
      return t.length ? t.map(function(n) {
        return n.label;
      }).join(", ") : this.placeholder;
    },
    emptyMessageText: function() {
      return this.emptyMessage || this.$primevue.config.locale.emptyMessage;
    },
    emptyValue: function() {
      return !this.modelValue || Object.keys(this.modelValue).length === 0;
    },
    emptyOptions: function() {
      return !this.options || this.options.length === 0;
    },
    listId: function() {
      return Mt() + "_list";
    }
  },
  components: {
    TSTree: ZC,
    Portal: Yn,
    ChevronDownIcon: Va
  },
  directives: {
    ripple: An
  }
};
function _c(e) {
  "@babel/helpers - typeof";
  return _c = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, _c(e);
}
function E0(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    t && (i = i.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), n.push.apply(n, i);
  }
  return n;
}
function Ed(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? E0(Object(n), !0).forEach(function(i) {
      eie(e, i, n[i]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : E0(Object(n)).forEach(function(i) {
      Object.defineProperty(e, i, Object.getOwnPropertyDescriptor(n, i));
    });
  }
  return e;
}
function eie(e, t, n) {
  return t = tie(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function tie(e) {
  var t = nie(e, "string");
  return _c(t) == "symbol" ? t : String(t);
}
function nie(e, t) {
  if (_c(e) != "object" || !e)
    return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var i = n.call(e, t || "default");
    if (_c(i) != "object")
      return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var iie = ["id", "disabled", "tabindex", "aria-labelledby", "aria-label", "aria-expanded", "aria-controls"], aie = ["aria-expanded"];
function oie(e, t, n, i, o, a) {
  var r = $e("TSTree"), s = $e("Portal");
  return E(), X("div", Ce({
    ref: "container",
    class: e.cx("root"),
    style: e.sx("root"),
    onClick: t[9] || (t[9] = function() {
      return a.onClick && a.onClick.apply(a, arguments);
    })
  }, e.ptm("root"), {
    "data-pc-name": "treeselect"
  }), [oe("div", Ce({
    class: "p-hidden-accessible"
  }, e.ptm("hiddenInputWrapper"), {
    "data-p-hidden-accessible": !0
  }), [oe("input", Ce({
    ref: "focusInput",
    id: e.inputId,
    type: "text",
    role: "combobox",
    class: e.inputClass,
    style: e.inputStyle,
    readonly: "",
    disabled: e.disabled,
    tabindex: e.disabled ? -1 : e.tabindex,
    "aria-labelledby": e.ariaLabelledby,
    "aria-label": e.ariaLabel,
    "aria-haspopup": "tree",
    "aria-expanded": o.overlayVisible,
    "aria-controls": a.listId,
    onFocus: t[0] || (t[0] = function(l) {
      return a.onFocus(l);
    }),
    onBlur: t[1] || (t[1] = function(l) {
      return a.onBlur(l);
    }),
    onKeydown: t[2] || (t[2] = function(l) {
      return a.onKeyDown(l);
    })
  }, Ed(Ed({}, e.inputProps), e.ptm("hiddenInput"))), null, 16, iie)], 16), oe("div", Ce({
    class: e.cx("labelContainer")
  }, e.ptm("labelContainer")), [oe("div", Ce({
    class: e.cx("label")
  }, e.ptm("label")), [je(e.$slots, "value", {
    value: a.selectedNodes,
    placeholder: e.placeholder
  }, function() {
    return [e.display === "comma" ? (E(), X(Re, {
      key: 0
    }, [Ve(Ie(a.label || "empty"), 1)], 64)) : e.display === "chip" ? (E(), X(Re, {
      key: 1
    }, [(E(!0), X(Re, null, Ge(a.selectedNodes, function(l) {
      return E(), X("div", Ce({
        key: l.key,
        class: e.cx("token")
      }, e.ptm("token")), [oe("span", Ce({
        class: e.cx("tokenLabel")
      }, e.ptm("tokenLabel")), Ie(l.label), 17)], 16);
    }), 128)), a.emptyValue ? (E(), X(Re, {
      key: 0
    }, [Ve(Ie(e.placeholder || "empty"), 1)], 64)) : te("", !0)], 64)) : te("", !0)];
  })], 16)], 16), oe("div", Ce({
    class: e.cx("trigger"),
    role: "button",
    "aria-haspopup": "tree",
    "aria-expanded": o.overlayVisible
  }, e.ptm("trigger")), [je(e.$slots, "triggericon", {
    class: Pe(e.cx("triggerIcon"))
  }, function() {
    return [(E(), fe(tt("ChevronDownIcon"), Ce({
      class: e.cx("triggerIcon")
    }, e.ptm("triggerIcon")), null, 16, ["class"]))];
  })], 16, aie), ue(s, {
    appendTo: e.appendTo
  }, {
    default: Se(function() {
      return [ue(ia, Ce({
        name: "p-connected-overlay",
        onEnter: a.onOverlayEnter,
        onAfterEnter: a.onOverlayAfterEnter,
        onLeave: a.onOverlayLeave,
        onAfterLeave: a.onOverlayAfterLeave
      }, e.ptm("transition")), {
        default: Se(function() {
          return [o.overlayVisible ? (E(), X("div", Ce({
            key: 0,
            ref: a.overlayRef,
            onClick: t[7] || (t[7] = function() {
              return a.onOverlayClick && a.onOverlayClick.apply(a, arguments);
            }),
            class: [e.cx("panel"), e.panelClass],
            onKeydown: t[8] || (t[8] = function() {
              return a.onOverlayKeydown && a.onOverlayKeydown.apply(a, arguments);
            })
          }, Ed(Ed({}, e.panelProps), e.ptm("panel"))), [oe("span", Ce({
            ref: "firstHiddenFocusableElementOnOverlay",
            role: "presentation",
            "aria-hidden": "true",
            class: "p-hidden-accessible p-hidden-focusable",
            tabindex: 0,
            onFocus: t[3] || (t[3] = function() {
              return a.onFirstHiddenFocus && a.onFirstHiddenFocus.apply(a, arguments);
            })
          }, e.ptm("hiddenFirstFocusableEl"), {
            "data-p-hidden-accessible": !0,
            "data-p-hidden-focusable": !0
          }), null, 16), je(e.$slots, "header", {
            value: e.modelValue,
            options: e.options
          }), oe("div", Ce({
            class: e.cx("wrapper"),
            style: {
              "max-height": e.scrollHeight
            }
          }, e.ptm("wrapper")), [ue(r, {
            ref: "tree",
            id: a.listId,
            value: e.options,
            selectionMode: e.selectionMode,
            "onUpdate:selectionKeys": a.onSelectionChange,
            selectionKeys: e.modelValue,
            expandedKeys: o.expandedKeys,
            "onUpdate:expandedKeys": a.onNodeToggle,
            metaKeySelection: e.metaKeySelection,
            onNodeExpand: t[4] || (t[4] = function(l) {
              return e.$emit("node-expand", l);
            }),
            onNodeCollapse: t[5] || (t[5] = function(l) {
              return e.$emit("node-collapse", l);
            }),
            onNodeSelect: a.onNodeSelect,
            onNodeUnselect: a.onNodeUnselect,
            level: 0,
            unstyled: e.unstyled,
            pt: e.ptm("tree"),
            "data-pc-section": "tree"
          }, Qt({
            _: 2
          }, [e.$slots.itemtogglericon ? {
            name: "togglericon",
            fn: Se(function(l) {
              return [je(e.$slots, "itemtogglericon", {
                node: l.node,
                expanded: l.expanded,
                class: Pe(l.class)
              })];
            }),
            key: "0"
          } : void 0, e.$slots.itemcheckboxicon ? {
            name: "checkboxicon",
            fn: Se(function(l) {
              return [je(e.$slots, "itemcheckboxicon", {
                checked: l.checked,
                partialChecked: l.partialChecked,
                class: Pe(l.class)
              })];
            }),
            key: "1"
          } : void 0]), 1032, ["id", "value", "selectionMode", "onUpdate:selectionKeys", "selectionKeys", "expandedKeys", "onUpdate:expandedKeys", "metaKeySelection", "onNodeSelect", "onNodeUnselect", "unstyled", "pt"]), a.emptyOptions ? (E(), X("div", Ce({
            key: 0,
            class: e.cx("emptyMessage")
          }, e.ptm("emptyMessage")), [je(e.$slots, "empty", {}, function() {
            return [Ve(Ie(a.emptyMessageText), 1)];
          })], 16)) : te("", !0)], 16), je(e.$slots, "footer", {
            value: e.modelValue,
            options: e.options
          }), oe("span", Ce({
            ref: "lastHiddenFocusableElementOnOverlay",
            role: "presentation",
            "aria-hidden": "true",
            class: "p-hidden-accessible p-hidden-focusable",
            tabindex: 0,
            onFocus: t[6] || (t[6] = function() {
              return a.onLastHiddenFocus && a.onLastHiddenFocus.apply(a, arguments);
            })
          }, e.ptm("hiddenLastFocusableEl"), {
            "data-p-hidden-accessible": !0,
            "data-p-hidden-focusable": !0
          }), null, 16)], 16)) : te("", !0)];
        }),
        _: 3
      }, 16, ["onEnter", "onAfterEnter", "onLeave", "onAfterLeave"])];
    }),
    _: 3
  }, 8, ["appendTo"])], 16);
}
QC.render = oie;
var eT = /* @__PURE__ */ ((e) => (e.Multiple = "multiple", e.Checkbox = "checkbox", e.Single = "single", e))(eT || {});
const rie = ["data-event_source", "data-event_component_name", "data-event_title", "aria-label", "onKeydown"], sie = /* @__PURE__ */ Be({
  __name: "IconButtonWithText",
  props: {
    trackingModel: {
      type: Object,
      required: !0
    },
    text: {
      type: String,
      default: ""
    },
    showText: {
      type: Boolean,
      default: !0
    },
    icon: {
      type: String,
      required: !0
    }
  },
  emits: ["click"],
  setup(e, { expose: t, emit: n }) {
    const i = ge();
    t({
      iconButtonTooltipTrigger: i
    });
    const o = n, a = (r) => {
      o("click", r);
    };
    return (r, s) => {
      const l = $e("BaseIcon");
      return E(), X("button", {
        class: "d-icon-button-with-text appearance-none border-none p-0 m-0",
        "data-event_source": e.trackingModel?.eventSource,
        "data-event_component_name": e.trackingModel?.eventComponentName,
        "data-event_title": e.trackingModel?.eventTitle,
        "aria-label": e.text,
        type: "button",
        tabindex: "0",
        onKeydown: Ze(It(a, ["prevent"]), ["enter"]),
        onClick: a
      }, [
        e.showText ? (E(), fe(_(Tt), {
          key: 0,
          class: "d-icon-button-with-text__text hover:underline",
          text: e.text,
          "text-color": _(dt).Primary,
          "font-type": _(lt).DwsSlabBold
        }, null, 8, ["text", "text-color", "font-type"])) : te("", !0),
        oe("div", {
          ref_key: "iconButtonTooltipTrigger",
          ref: i
        }, [
          ue(l, {
            "base-icon": e.icon,
            "base-icon-size": _(at).NextToText
          }, null, 8, ["base-icon", "base-icon-size"])
        ], 512)
      ], 40, rie);
    };
  }
});
const No = /* @__PURE__ */ Fe(sie, [["__scopeId", "data-v-25345ebb"]]), lie = ["onKeypress"], cie = { class: "d-base-tree-select__header" }, die = /* @__PURE__ */ Be({
  __name: "BaseTreeSelect",
  props: {
    model: {
      type: Object,
      required: !0
    },
    type: {
      type: String,
      default: eT.Checkbox
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    showNumberOfResultsInValue: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["changed"],
  setup(e, { emit: t }) {
    const n = e, { t: i } = Je(), o = (p) => {
      let L = p.length;
      return p.forEach((B) => {
        B.children && B.children.length > 0 && (L += o(B.children));
      }), L;
    }, a = (p, L) => p.children && o(p.children) === Object.keys(L).length ? !0 : p.children && o(p.children) > Object.keys(L).length ? !1 : !!p.isSelected, r = (p) => {
      let L = {};
      return p.forEach((B) => {
        let T = {};
        B.children && (T = r(B.children));
        const O = Object.keys(T).length > 0;
        (a(B, T) || O) && (L[B.key] = {
          partialChecked: O,
          checked: a(B, T)
        }, O && (L = {
          ...L,
          ...T
        }));
      }), L;
    }, s = Te(() => n.model?.componentNameForTracking ? n.model?.componentNameForTracking : "Base-Tree-Select"), l = Te(() => n.model.options), d = ge(), y = ge(!1), u = ge(l.value), m = ge(
      r(l.value)
    ), h = t;
    qe(
      () => n.model,
      (p) => {
        m.value = r(p.options);
      },
      { deep: !0 }
    );
    const c = Te(() => Object.keys(m.value).length > 0), g = (p, L) => {
      const B = [];
      return p.forEach((T) => {
        const O = { ...T };
        O.children && (O.children = [...g(O.children, L)]);
        const I = O.children && O.children.length > 0;
        (O.label.toLowerCase().includes(L.toLowerCase()) || I) && B.push(O);
      }), B;
    }, v = (p) => {
      let L = {};
      return p.forEach((B) => {
        if (L[B.key] = !0, B.children) {
          const T = v(B.children);
          L = { ...L, ...T };
        }
      }), L;
    }, P = () => {
      const p = v(l.value);
      d.value.onNodeToggle(p);
    }, f = (p) => {
      b.value = p;
      const L = g(l.value, p);
      u.value = p !== "" ? L : l.value, p && p.length > 0 && fi(() => {
        P();
      }, 10);
    }, S = () => {
      u.value = l.value, b.value = "";
    }, w = (p) => {
      p.forEach((L) => {
        m.value[L.key] ? L.isSelected = m.value[L.key].checked : L.isSelected = !1, L.children && w(L.children);
      });
    }, x = (p, L) => {
      On(
        s.value,
        `${L}, ${p?.label}`,
        Qe().pageName
      );
    }, k = (p, L) => {
      On(
        s.value,
        `${L}, ${p?.label}`,
        Qe().pageName
      );
    }, A = (p) => {
      m.value = p, w(l.value), h("changed", l.value);
    }, $ = () => {
      m.value = {}, w(l.value), h("changed", []);
    }, j = () => {
      D(), y.value = !y.value;
    }, N = () => {
      const p = n.model.results && n.showNumberOfResultsInValue ? ` (${n.model.results})` : "";
      return `${n.model.name}${p}`;
    }, M = (p) => p.checked ? H.Check : H.Minus, D = () => {
      Ue && document.querySelectorAll(".p-tree-toggler")?.forEach((L) => {
        L.setAttribute("aria-label", i("baseTreeSelect.triggerAriaLabel")), L.setAttribute("tabindex", "0");
      });
    }, C = () => {
      y.value ? d.value.hide() : d.value.show();
    }, b = ge("");
    return (p, L) => {
      const B = $e("BaseIcon"), T = $e("BaseText");
      return e.model ? (E(), X("div", {
        key: 0,
        class: "d-base-tree-select",
        tabindex: 0,
        onClick: It(C, ["self"]),
        onKeypress: Ze(It(C, ["self"]), ["enter"])
      }, [
        ue(_(QC), {
          ref_key: "treeSelect",
          ref: d,
          modelValue: m.value,
          "onUpdate:modelValue": L[1] || (L[1] = (O) => m.value = O),
          options: u.value,
          "append-to": "#d-base-tree-select__panel",
          placeholder: N(),
          "selection-mode": e.type,
          disabled: e.model.isDisabled || e.disabled,
          "aria-disabled": e.model.isDisabled || e.disabled,
          "data-event_source": _(Qe)().pageName,
          "data-event_component_name": s.value,
          "data-event_title": e.model.name,
          class: Pe(["d-base-tree-select__dropdown", { "d-base-tree-select--selected": c.value }]),
          pt: {
            trigger: {
              ariaLabel: _(i)("baseTreeSelect.triggerAriaLabel")
            },
            hiddenInput: {
              ariaHidden: !0,
              ariaLabel: N()
            }
          },
          onChange: A,
          onNodeSelect: L[2] || (L[2] = (O) => x(O, e.model.name)),
          onNodeUnselect: L[3] || (L[3] = (O) => k(O, e.model.name)),
          onShow: j,
          onHide: j
        }, {
          header: Se(() => [
            oe("div", cie, [
              ue(No, {
                ref: "deselectButtonTooltipTrigger",
                "tracking-model": {
                  eventSource: _(Qe)().pageName,
                  eventComponentName: "Tree Select",
                  eventTitle: e.model.name + ": " + _(i)("fundFinder.deselectAll")
                },
                "show-text": !0,
                text: _(i)("fundFinder.deselectAll"),
                icon: _(H).TrashAlt,
                onClick: L[0] || (L[0] = (O) => $())
              }, null, 8, ["tracking-model", "text", "icon"]),
              ue(kh, {
                model: {
                  placeholder: _(i)("baseTreeSelect.placeholder"),
                  searchTerm: b.value
                },
                "is-suppress-open-new-window-on-enter": !0,
                "min-length": 0,
                tabindex: "0",
                onClear: S,
                onSearch: f
              }, null, 8, ["model"])
            ])
          ]),
          triggericon: Se(() => [
            ue(B, {
              "base-icon": y.value ? _(H).AngleUp : _(H).AngleDown,
              "base-icon-size": _(at).S,
              class: "mr-4"
            }, null, 8, ["base-icon", "base-icon-size"])
          ]),
          itemcheckboxicon: Se((O) => [
            O.checked || O.partialChecked ? (E(), fe(B, {
              key: 0,
              "base-icon": M(O),
              "base-icon-color": _(gt).GreyBlue009
            }, null, 8, ["base-icon", "base-icon-color"])) : te("", !0)
          ]),
          value: Se(() => [
            Ve(Ie(N()), 1)
          ]),
          empty: Se(() => [
            ue(T, {
              text: _(i)("baseTreeSelect.emptyMessage")
            }, null, 8, ["text"])
          ]),
          _: 1
        }, 8, ["modelValue", "options", "placeholder", "selection-mode", "disabled", "aria-disabled", "data-event_source", "data-event_component_name", "data-event_title", "class", "pt"]),
        L[4] || (L[4] = oe("div", { id: "d-base-tree-select__panel" }, null, -1))
      ], 40, lie)) : te("", !0);
    };
  }
});
const uie = /* @__PURE__ */ Fe(die, [["__scopeId", "data-v-38fb76c9"]]);
var br = /* @__PURE__ */ ((e) => (e.VariantA = "variant-a", e.VariantB = "variant-b", e))(br || {}), Eo = /* @__PURE__ */ ((e) => (e.GreyBlue000 = "grey-blue-000", e.White = "white", e))(Eo || {});
const hie = {
  key: 0,
  class: "d-branded-image"
}, pie = { class: "d-branded-image__compose" }, fie = { class: "d-branded-image__compose__baseimage" }, mie = /* @__PURE__ */ Be({
  __name: "BrandedImage",
  props: {
    image: {
      type: Object,
      required: !0
    },
    variant: {
      type: String,
      default: br.VariantA
    },
    stripeBackgroundColor: {
      type: String,
      default: Eo.White
    },
    aspectRatio: {
      type: String,
      default: on.Original
    }
  },
  setup(e) {
    return (t, n) => {
      const i = $e("BaseImage");
      return e.image ? (E(), X("div", hie, [
        oe("div", pie, [
          oe("div", {
            class: Pe(["d-branded-image__compose__overlaystripes", {
              "d-branded-image__compose__overlaystripes--variant-a": e.variant === _(br).VariantA,
              "d-branded-image__compose__overlaystripes--variant-b": e.variant === _(br).VariantB,
              "stripeBackgroundColor-white": e.stripeBackgroundColor === _(Eo).White,
              "stripeBackgroundColor-greyblue000": e.stripeBackgroundColor === _(Eo).GreyBlue000
            }])
          }, null, 2),
          oe("div", fie, [
            ue(i, {
              model: e.image,
              "aspect-ratio": e.aspectRatio,
              class: "d-img"
            }, null, 8, ["model", "aspect-ratio"])
          ])
        ])
      ])) : te("", !0);
    };
  }
});
const tT = /* @__PURE__ */ Fe(mie, [["__scopeId", "data-v-61838924"]]), gie = { class: "d-property-teaser__wrapper" }, vie = {
  key: 0,
  class: "d-property-teaser__wrapper__image"
}, yie = {
  key: 0,
  class: "d-property-teaser__wrapper__image-button"
}, bie = { class: "d-property-teaser__wrapper__content" }, xie = /* @__PURE__ */ Be({
  __name: "PropertyTeaser",
  props: {
    image: {
      type: Object,
      required: !0
    },
    backgroundColor: {
      type: String,
      default: Eo.White
    },
    brandedImageVariant: {
      type: String,
      default: br.VariantA
    },
    aspectRatio: {
      type: String,
      default: on.Original
    }
  },
  setup(e) {
    const { containerQueriesEnabled: t } = Bi(), n = Jt(), i = (a) => !!n[a], o = Te(() => t.value ? "d-property-teaser--container" : "d-property-teaser--media");
    return (a, r) => (E(), X("div", {
      class: Pe(["d-property-teaser", [o.value]])
    }, [
      oe("div", gie, [
        e.image ? (E(), X("div", vie, [
          ue(tT, {
            image: e.image,
            variant: e.brandedImageVariant,
            "stripe-background-color": e.backgroundColor,
            "aspect-ratio": e.aspectRatio
          }, null, 8, ["image", "variant", "stripe-background-color", "aspect-ratio"]),
          i("imageButton") ? (E(), X("div", yie, [
            je(a.$slots, "imageButton", {}, void 0, !0)
          ])) : te("", !0)
        ])) : te("", !0),
        oe("div", bie, [
          je(a.$slots, "content", {}, void 0, !0)
        ])
      ])
    ], 2));
  }
});
const Fg = /* @__PURE__ */ Fe(xie, [["__scopeId", "data-v-f595120f"]]), wie = ["onKeydown"], kie = ["data-event_source", "data-event_title", "onKeydown"], Sie = { class: "d-radio-button__label flex justify-between w-full align-baseline" }, Cie = {
  key: 0,
  class: "d-base-single-select__item--name"
}, Tie = {
  key: 1,
  class: "d-base-single-select__item--result"
}, Lie = /* @__PURE__ */ Be({
  __name: "BaseSingleSelect",
  props: {
    filter: {
      type: Object,
      required: !0
    },
    showNumberOfResultsInOptions: {
      type: Boolean,
      default: !1
    },
    showNumberOfResultsInValue: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["singleSelectValueChanged"],
  setup(e, { emit: t }) {
    const n = e, i = t, o = ge(), a = ge(), r = ge(!1), s = ge(0), l = () => {
      r.value || o.value.show();
    }, d = () => {
      r.value && o.value.hide();
    }, y = (x) => {
      if (Ue && r.value) {
        const k = x?.target;
        k && k instanceof HTMLElement && k.click();
      }
      l();
    }, u = () => {
      d();
    }, m = () => {
      d();
    }, h = (x) => {
      if (Ue) {
        const A = (o.value?.$el.querySelectorAll(
          ".d-base-single-select__item"
        ))[x];
        A && A.focus();
      }
    }, c = (x) => {
      x.preventDefault(), s.value > 0 && s.value--, s.value < 0 && (s.value = 0), h(s.value);
    }, g = (x) => {
      x.preventDefault(), s.value + 1 < n.filter.filterOptions.length && s.value++, h(s.value);
    }, v = ge(
      n.filter.filterOptions.find((x) => x.isSelected) ?? null
    ), P = Te(
      () => (x) => !x.results && n.showNumberOfResultsInOptions || x?.isDisabled
    );
    function f(x) {
      n.filter.filterOptions.forEach((k) => k.isSelected = !1), x.isSelected = !x.isSelected, n.filter.isSelected = !0, v.value = x, i("singleSelectValueChanged", x);
    }
    function S() {
      r.value = !r.value, Ue && (r.value ? document.body.addEventListener("keydown", w) : document.body.removeEventListener("keydown", w)), r.value ? (s.value = n.filter.filterOptions.findIndex(
        (x) => x.isSelected
      ), h(s.value)) : Ue && window.requestAnimationFrame(() => {
        o?.value?.focus?.() || o?.value?.$el?.focus?.();
      });
    }
    const w = (x) => {
      (x.key === "ArrowUp" || x.key === "ArrowDown") && x.preventDefault();
    };
    return qe(
      () => n.filter.filterOptions,
      () => {
        v.value = n.filter.filterOptions.find(
          (x) => x.isSelected
        ) ?? null;
      },
      { deep: !0, immediate: !0 }
    ), (x, k) => {
      const A = $e("BaseIcon"), $ = $e("BaseText");
      return E(), X("div", {
        ref_key: "singleSelectContainer",
        ref: a,
        class: "d-base-single-select",
        onKeyup: [
          Ze(c, ["up"]),
          Ze(g, ["down"])
        ],
        onKeydown: [
          Ze(m, ["tab"]),
          Ze(It(y, ["prevent"]), ["space"]),
          Ze(It(u, ["prevent"]), ["enter"])
        ]
      }, [
        ue(_(Ga), {
          ref_key: "singleSelect",
          ref: o,
          modelValue: v.value,
          "onUpdate:modelValue": [
            k[0] || (k[0] = (j) => v.value = j),
            k[1] || (k[1] = (j) => f(j))
          ],
          options: e.filter.filterOptions,
          "option-label": "name",
          placeholder: `${e.filter.name}${e.showNumberOfResultsInValue && e.filter.results !== void 0 ? " (" + e.filter.results + ")" : ""}`,
          class: Pe(["d-base-single-select__dropdown", e.filter.isSelected ? "d-base-single-select--selected" : ""]),
          "scroll-height": "364px",
          pt: {
            panel: { class: "d-base-single-select__panel" },
            wrapper: { class: "d-base-single-select_wrapper" },
            hiddenInput: {
              ariaHidden: !0
            }
          },
          "append-to": "self",
          "option-disabled": P.value,
          disabled: e.filter.isDisabled,
          filter: e.filter.hasSearchField,
          onShow: S,
          onHide: S
        }, {
          dropdownicon: Se(() => [
            ue(A, {
              "base-icon": r.value ? _(H).AngleUp : _(H).AngleDown,
              "base-icon-size": _(at).S,
              class: "mr-4",
              "aria-hidden": "true"
            }, null, 8, ["base-icon", "base-icon-size"])
          ]),
          value: Se(() => [
            Ve(Ie(e.filter.name + (e.showNumberOfResultsInValue && e.filter.results !== void 0 ? " (" + e.filter.results + ")" : "")), 1)
          ]),
          option: Se((j) => [
            oe("div", {
              class: "d-base-single-select__item flex justify-start w-full align-baseline",
              tabindex: "0",
              "data-event_source": _(Qe)().pageName,
              "data-event_component_name": "Base-Single-Select",
              "data-event_title": e.filter.name + " | " + j.option.name,
              onKeydown: Ze(It((N) => f(j.option), ["prevent"]), ["enter"])
            }, [
              ue(_(Or), {
                name: j.option.name,
                value: j.option.identifier,
                disabled: !1,
                "input-id": j.option.identifier,
                "aria-label": j.option.name,
                class: Pe([{
                  "p-radiobutton-checked": j.option.isSelected
                }, "d-radio-button"])
              }, null, 8, ["name", "value", "input-id", "aria-label", "class"]),
              oe("div", Sie, [
                j.option.name ? (E(), X("span", Cie, Ie(j.option.name), 1)) : te("", !0),
                j.option.results !== void 0 && e.showNumberOfResultsInOptions ? (E(), X("span", Tie, Ie(j.option.results), 1)) : te("", !0)
              ])
            ], 40, kie)
          ]),
          footer: Se(() => [
            e.filter.disclaimer ? (E(), fe($, {
              key: 0,
              text: e.filter.disclaimer,
              "font-type": _(lt).DwsSans,
              "font-size": _(st).FourteenPx,
              "text-color": _(dt).GreyBlue009,
              class: "d-base-single-select__footer"
            }, null, 8, ["text", "font-type", "font-size", "text-color"])) : te("", !0)
          ]),
          _: 1
        }, 8, ["modelValue", "options", "placeholder", "class", "option-disabled", "disabled", "filter"])
      ], 40, wie);
    };
  }
});
const Iie = /* @__PURE__ */ Fe(Lie, [["__scopeId", "data-v-1bd38c3d"]]);
var Rf = /* @__PURE__ */ ((e) => (e.Text = "text", e.Performance = "performance", e))(Rf || {}), Pie = `
@layer primevue {
    .p-multiselect {
        display: inline-flex;
        cursor: pointer;
        user-select: none;
    }

    .p-multiselect-trigger {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
    }

    .p-multiselect-label-container {
        overflow: hidden;
        flex: 1 1 auto;
        cursor: pointer;
    }

    .p-multiselect-label {
        display: block;
        white-space: nowrap;
        cursor: pointer;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .p-multiselect-label-empty {
        overflow: hidden;
        visibility: hidden;
    }

    .p-multiselect-token {
        cursor: default;
        display: inline-flex;
        align-items: center;
        flex: 0 0 auto;
    }

    .p-multiselect-token-icon {
        cursor: pointer;
    }

    .p-multiselect .p-multiselect-panel {
        min-width: 100%;
    }

    .p-multiselect-items-wrapper {
        overflow: auto;
    }

    .p-multiselect-items {
        margin: 0;
        padding: 0;
        list-style-type: none;
    }

    .p-multiselect-item {
        cursor: pointer;
        display: flex;
        align-items: center;
        font-weight: normal;
        white-space: nowrap;
        position: relative;
        overflow: hidden;
    }

    .p-multiselect-item-group {
        cursor: auto;
    }

    .p-multiselect-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    .p-multiselect-filter-container {
        position: relative;
        flex: 1 1 auto;
    }

    .p-multiselect-filter-icon {
        position: absolute;
        top: 50%;
        margin-top: -0.5rem;
    }

    .p-multiselect-filter-container .p-inputtext {
        width: 100%;
    }

    .p-multiselect-close {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        overflow: hidden;
        position: relative;
        margin-left: auto;
    }

    .p-fluid .p-multiselect {
        display: flex;
    }
}
`, Aie = {
  root: function(t) {
    var n = t.props;
    return {
      position: n.appendTo === "self" ? "relative" : void 0
    };
  }
}, _ie = {
  root: function(t) {
    var n = t.instance, i = t.props;
    return ["p-multiselect p-component p-inputwrapper", {
      "p-multiselect-chip": i.display === "chip",
      "p-disabled": i.disabled,
      "p-focus": n.focused,
      "p-inputwrapper-filled": i.modelValue && i.modelValue.length,
      "p-inputwrapper-focus": n.focused || n.overlayVisible,
      "p-overlay-open": n.overlayVisible
    }];
  },
  labelContainer: "p-multiselect-label-container",
  label: function(t) {
    var n = t.instance, i = t.props;
    return ["p-multiselect-label", {
      "p-placeholder": n.label === i.placeholder,
      "p-multiselect-label-empty": !i.placeholder && (!i.modelValue || i.modelValue.length === 0)
    }];
  },
  token: "p-multiselect-token",
  tokenLabel: "p-multiselect-token-label",
  removeTokenIcon: "p-multiselect-token-icon",
  trigger: "p-multiselect-trigger",
  loadingIcon: "p-multiselect-trigger-icon",
  dropdownIcon: "p-multiselect-trigger-icon",
  panel: function(t) {
    var n = t.instance;
    return ["p-multiselect-panel p-component", {
      "p-input-filled": n.$primevue.config.inputStyle === "filled",
      "p-ripple-disabled": n.$primevue.config.ripple === !1
    }];
  },
  header: "p-multiselect-header",
  headerCheckboxContainer: function(t) {
    var n = t.instance;
    return ["p-checkbox p-component", {
      "p-checkbox-checked": n.allSelected,
      "p-checkbox-focused": n.headerCheckboxFocused
    }];
  },
  headerCheckbox: function(t) {
    var n = t.instance;
    return ["p-checkbox-box", {
      "p-highlight": n.allSelected,
      "p-focus": n.headerCheckboxFocused
    }];
  },
  headerCheckboxIcon: "p-checkbox-icon",
  filterContainer: "p-multiselect-filter-container",
  filterInput: "p-multiselect-filter p-inputtext p-component",
  filterIcon: "p-multiselect-filter-icon",
  closeButton: "p-multiselect-close p-link",
  closeIcon: "p-multiselect-close-icon",
  wrapper: "p-multiselect-items-wrapper",
  list: "p-multiselect-items p-component",
  itemGroup: "p-multiselect-item-group",
  item: function(t) {
    var n = t.instance, i = t.option, o = t.index, a = t.getItemOptions;
    return ["p-multiselect-item", {
      "p-highlight": n.isSelected(i),
      "p-focus": n.focusedOptionIndex === n.getOptionIndex(o, a),
      "p-disabled": n.isOptionDisabled(i)
    }];
  },
  checkboxContainer: "p-checkbox p-component",
  checkbox: function(t) {
    var n = t.instance, i = t.option;
    return ["p-checkbox-box", {
      "p-highlight": n.isSelected(i)
    }];
  },
  checkboxIcon: "p-checkbox-icon",
  emptyMessage: "p-multiselect-empty-message"
}, Mie = Wt.extend({
  name: "multiselect",
  css: Pie,
  classes: _ie,
  inlineStyles: Aie
}), Oie = {
  name: "BaseMultiSelect",
  extends: wt,
  props: {
    modelValue: null,
    options: Array,
    optionLabel: null,
    optionValue: null,
    optionDisabled: null,
    optionGroupLabel: null,
    optionGroupChildren: null,
    scrollHeight: {
      type: String,
      default: "200px"
    },
    placeholder: String,
    disabled: Boolean,
    inputId: {
      type: String,
      default: null
    },
    inputProps: {
      type: null,
      default: null
    },
    panelClass: {
      type: String,
      default: null
    },
    panelStyle: {
      type: null,
      default: null
    },
    panelProps: {
      type: null,
      default: null
    },
    filterInputProps: {
      type: null,
      default: null
    },
    closeButtonProps: {
      type: null,
      default: null
    },
    dataKey: null,
    filter: Boolean,
    filterPlaceholder: String,
    filterLocale: String,
    filterMatchMode: {
      type: String,
      default: "contains"
    },
    filterFields: {
      type: Array,
      default: null
    },
    appendTo: {
      type: [String, Object],
      default: "body"
    },
    display: {
      type: String,
      default: "comma"
    },
    selectedItemsLabel: {
      type: String,
      default: "{0} items selected"
    },
    maxSelectedLabels: {
      type: Number,
      default: null
    },
    selectionLimit: {
      type: Number,
      default: null
    },
    showToggleAll: {
      type: Boolean,
      default: !0
    },
    loading: {
      type: Boolean,
      default: !1
    },
    checkboxIcon: {
      type: String,
      default: void 0
    },
    closeIcon: {
      type: String,
      default: void 0
    },
    dropdownIcon: {
      type: String,
      default: void 0
    },
    filterIcon: {
      type: String,
      default: void 0
    },
    loadingIcon: {
      type: String,
      default: void 0
    },
    removeTokenIcon: {
      type: String,
      default: void 0
    },
    selectAll: {
      type: Boolean,
      default: null
    },
    resetFilterOnHide: {
      type: Boolean,
      default: !1
    },
    virtualScrollerOptions: {
      type: Object,
      default: null
    },
    autoOptionFocus: {
      type: Boolean,
      default: !0
    },
    autoFilterFocus: {
      type: Boolean,
      default: !1
    },
    filterMessage: {
      type: String,
      default: null
    },
    selectionMessage: {
      type: String,
      default: null
    },
    emptySelectionMessage: {
      type: String,
      default: null
    },
    emptyFilterMessage: {
      type: String,
      default: null
    },
    emptyMessage: {
      type: String,
      default: null
    },
    tabindex: {
      type: Number,
      default: 0
    },
    ariaLabel: {
      type: String,
      default: null
    },
    ariaLabelledby: {
      type: String,
      default: null
    }
  },
  style: Mie,
  provide: function() {
    return {
      $parentInstance: this
    };
  }
};
function Mc(e) {
  "@babel/helpers - typeof";
  return Mc = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Mc(e);
}
function D0(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    t && (i = i.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), n.push.apply(n, i);
  }
  return n;
}
function R0(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? D0(Object(n), !0).forEach(function(i) {
      nT(e, i, n[i]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : D0(Object(n)).forEach(function(i) {
      Object.defineProperty(e, i, Object.getOwnPropertyDescriptor(n, i));
    });
  }
  return e;
}
function nT(e, t, n) {
  return t = Bie(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function Bie(e) {
  var t = Eie(e, "string");
  return Mc(t) == "symbol" ? t : String(t);
}
function Eie(e, t) {
  if (Mc(e) != "object" || !e)
    return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var i = n.call(e, t || "default");
    if (Mc(i) != "object")
      return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function N0(e) {
  return $ie(e) || Nie(e) || Rie(e) || Die();
}
function Die() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Rie(e, t) {
  if (e) {
    if (typeof e == "string")
      return Nf(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set")
      return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return Nf(e, t);
  }
}
function Nie(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null)
    return Array.from(e);
}
function $ie(e) {
  if (Array.isArray(e))
    return Nf(e);
}
function Nf(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, i = new Array(t); n < t; n++)
    i[n] = e[n];
  return i;
}
var iT = {
  name: "MultiSelect",
  extends: Oie,
  emits: ["update:modelValue", "change", "focus", "blur", "before-show", "before-hide", "show", "hide", "filter", "selectall-change"],
  outsideClickListener: null,
  scrollHandler: null,
  resizeListener: null,
  overlay: null,
  list: null,
  virtualScroller: null,
  startRangeIndex: -1,
  searchTimeout: null,
  searchValue: "",
  selectOnFocus: !1,
  focusOnHover: !1,
  data: function() {
    return {
      id: this.$attrs.id,
      focused: !1,
      focusedOptionIndex: -1,
      headerCheckboxFocused: !1,
      filterValue: null,
      overlayVisible: !1
    };
  },
  watch: {
    "$attrs.id": function(t) {
      this.id = t || Mt();
    },
    options: function() {
      this.autoUpdateModel();
    }
  },
  mounted: function() {
    this.id = this.id || Mt(), this.autoUpdateModel();
  },
  beforeUnmount: function() {
    this.unbindOutsideClickListener(), this.unbindResizeListener(), this.scrollHandler && (this.scrollHandler.destroy(), this.scrollHandler = null), this.overlay && (qt.clear(this.overlay), this.overlay = null);
  },
  methods: {
    getOptionIndex: function(t, n) {
      return this.virtualScrollerDisabled ? t : n && n(t).index;
    },
    getOptionLabel: function(t) {
      return this.optionLabel ? We.resolveFieldData(t, this.optionLabel) : t;
    },
    getOptionValue: function(t) {
      return this.optionValue ? We.resolveFieldData(t, this.optionValue) : t;
    },
    getOptionRenderKey: function(t) {
      return this.dataKey ? We.resolveFieldData(t, this.dataKey) : this.getOptionLabel(t);
    },
    getHeaderCheckboxPTOptions: function(t) {
      return this.ptm(t, {
        context: {
          selected: this.allSelected,
          focused: this.headerCheckboxFocused
        }
      });
    },
    getCheckboxPTOptions: function(t, n, i, o) {
      return this.ptm(o, {
        context: {
          selected: this.isSelected(t),
          focused: this.focusedOptionIndex === this.getOptionIndex(i, n),
          disabled: this.isOptionDisabled(t)
        }
      });
    },
    isOptionDisabled: function(t) {
      return this.maxSelectionLimitReached && !this.isSelected(t) ? !0 : this.optionDisabled ? We.resolveFieldData(t, this.optionDisabled) : !1;
    },
    isOptionGroup: function(t) {
      return this.optionGroupLabel && t.optionGroup && t.group;
    },
    getOptionGroupLabel: function(t) {
      return We.resolveFieldData(t, this.optionGroupLabel);
    },
    getOptionGroupChildren: function(t) {
      return We.resolveFieldData(t, this.optionGroupChildren);
    },
    getAriaPosInset: function(t) {
      var n = this;
      return (this.optionGroupLabel ? t - this.visibleOptions.slice(0, t).filter(function(i) {
        return n.isOptionGroup(i);
      }).length : t) + 1;
    },
    show: function(t) {
      this.$emit("before-show"), this.overlayVisible = !0, this.focusedOptionIndex = this.focusedOptionIndex !== -1 ? this.focusedOptionIndex : this.autoOptionFocus ? this.findFirstFocusedOptionIndex() : -1, t && Oe.focus(this.$refs.focusInput);
    },
    hide: function(t) {
      var n = this, i = function() {
        n.$emit("before-hide"), n.overlayVisible = !1, n.focusedOptionIndex = -1, n.searchValue = "", n.resetFilterOnHide && (n.filterValue = null), t && Oe.focus(n.$refs.focusInput);
      };
      setTimeout(function() {
        i();
      }, 0);
    },
    onFocus: function(t) {
      this.disabled || (this.focused = !0, this.focusedOptionIndex = this.focusedOptionIndex !== -1 ? this.focusedOptionIndex : this.overlayVisible && this.autoOptionFocus ? this.findFirstFocusedOptionIndex() : -1, this.overlayVisible && this.scrollInView(this.focusedOptionIndex), this.$emit("focus", t));
    },
    onBlur: function(t) {
      this.focused = !1, this.focusedOptionIndex = -1, this.searchValue = "", this.$emit("blur", t);
    },
    onKeyDown: function(t) {
      var n = this;
      if (this.disabled) {
        t.preventDefault();
        return;
      }
      var i = t.metaKey || t.ctrlKey;
      switch (t.code) {
        case "ArrowDown":
          this.onArrowDownKey(t);
          break;
        case "ArrowUp":
          this.onArrowUpKey(t);
          break;
        case "Home":
          this.onHomeKey(t);
          break;
        case "End":
          this.onEndKey(t);
          break;
        case "PageDown":
          this.onPageDownKey(t);
          break;
        case "PageUp":
          this.onPageUpKey(t);
          break;
        case "Enter":
        case "NumpadEnter":
        case "Space":
          this.onEnterKey(t);
          break;
        case "Escape":
          this.onEscapeKey(t);
          break;
        case "Tab":
          this.onTabKey(t);
          break;
        case "ShiftLeft":
        case "ShiftRight":
          this.onShiftKey(t);
          break;
        default:
          if (t.code === "KeyA" && i) {
            var o = this.visibleOptions.filter(function(a) {
              return n.isValidOption(a);
            }).map(function(a) {
              return n.getOptionValue(a);
            });
            this.updateModel(t, o), t.preventDefault();
            break;
          }
          !i && We.isPrintableCharacter(t.key) && (!this.overlayVisible && this.show(), this.searchOptions(t), t.preventDefault());
          break;
      }
    },
    onContainerClick: function(t) {
      this.disabled || this.loading || (!this.overlay || !this.overlay.contains(t.target)) && (this.overlayVisible ? this.hide(!0) : this.show(!0));
    },
    onFirstHiddenFocus: function(t) {
      var n = t.relatedTarget === this.$refs.focusInput ? Oe.getFirstFocusableElement(this.overlay, ':not([data-p-hidden-focusable="true"])') : this.$refs.focusInput;
      Oe.focus(n);
    },
    onLastHiddenFocus: function(t) {
      var n = t.relatedTarget === this.$refs.focusInput ? Oe.getLastFocusableElement(this.overlay, ':not([data-p-hidden-focusable="true"])') : this.$refs.focusInput;
      Oe.focus(n);
    },
    onCloseClick: function() {
      this.hide(!0);
    },
    onHeaderCheckboxFocus: function() {
      this.headerCheckboxFocused = !0;
    },
    onHeaderCheckboxBlur: function() {
      this.headerCheckboxFocused = !1;
    },
    onOptionSelect: function(t, n) {
      var i = this, o = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : -1, a = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !1;
      if (!(this.disabled || this.isOptionDisabled(n))) {
        var r = this.isSelected(n), s = null;
        r ? s = this.modelValue.filter(function(l) {
          return !We.equals(l, i.getOptionValue(n), i.equalityKey);
        }) : s = [].concat(N0(this.modelValue || []), [this.getOptionValue(n)]), this.updateModel(t, s), o !== -1 && (this.focusedOptionIndex = o), a && Oe.focus(this.$refs.focusInput);
      }
    },
    onOptionMouseMove: function(t, n) {
      this.focusOnHover && this.changeFocusedOptionIndex(t, n);
    },
    onOptionSelectRange: function(t) {
      var n = this, i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : -1, o = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : -1;
      if (i === -1 && (i = this.findNearestSelectedOptionIndex(o, !0)), o === -1 && (o = this.findNearestSelectedOptionIndex(i)), i !== -1 && o !== -1) {
        var a = Math.min(i, o), r = Math.max(i, o), s = this.visibleOptions.slice(a, r + 1).filter(function(l) {
          return n.isValidOption(l);
        }).map(function(l) {
          return n.getOptionValue(l);
        });
        this.updateModel(t, s);
      }
    },
    onFilterChange: function(t) {
      var n = t.target.value;
      this.filterValue = n, this.focusedOptionIndex = -1, this.$emit("filter", {
        originalEvent: t,
        value: n
      }), !this.virtualScrollerDisabled && this.virtualScroller.scrollToIndex(0);
    },
    onFilterKeyDown: function(t) {
      switch (t.code) {
        case "ArrowDown":
          this.onArrowDownKey(t);
          break;
        case "ArrowUp":
          this.onArrowUpKey(t, !0);
          break;
        case "ArrowLeft":
        case "ArrowRight":
          this.onArrowLeftKey(t, !0);
          break;
        case "Home":
          this.onHomeKey(t, !0);
          break;
        case "End":
          this.onEndKey(t, !0);
          break;
        case "Enter":
        case "NumpadEnter":
          this.onEnterKey(t);
          break;
        case "Escape":
          this.onEscapeKey(t);
          break;
        case "Tab":
          this.onTabKey(t, !0);
          break;
      }
    },
    onFilterBlur: function() {
      this.focusedOptionIndex = -1;
    },
    onFilterUpdated: function() {
      this.overlayVisible && this.alignOverlay();
    },
    onOverlayClick: function(t) {
      Zn.emit("overlay-click", {
        originalEvent: t,
        target: this.$el
      });
    },
    onOverlayKeyDown: function(t) {
      switch (t.code) {
        case "Escape":
          this.onEscapeKey(t);
          break;
      }
    },
    onArrowDownKey: function(t) {
      var n = this.focusedOptionIndex !== -1 ? this.findNextOptionIndex(this.focusedOptionIndex) : this.findFirstFocusedOptionIndex();
      t.shiftKey && this.onOptionSelectRange(t, this.startRangeIndex, n), this.changeFocusedOptionIndex(t, n), !this.overlayVisible && this.show(), t.preventDefault();
    },
    onArrowUpKey: function(t) {
      var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
      if (t.altKey && !n)
        this.focusedOptionIndex !== -1 && this.onOptionSelect(t, this.visibleOptions[this.focusedOptionIndex]), this.overlayVisible && this.hide(), t.preventDefault();
      else {
        var i = this.focusedOptionIndex !== -1 ? this.findPrevOptionIndex(this.focusedOptionIndex) : this.findLastFocusedOptionIndex();
        t.shiftKey && this.onOptionSelectRange(t, i, this.startRangeIndex), this.changeFocusedOptionIndex(t, i), !this.overlayVisible && this.show(), t.preventDefault();
      }
    },
    onArrowLeftKey: function(t) {
      var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
      n && (this.focusedOptionIndex = -1);
    },
    onHomeKey: function(t) {
      var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, i = t.currentTarget;
      if (n) {
        var o = i.value.length;
        i.setSelectionRange(0, t.shiftKey ? o : 0), this.focusedOptionIndex = -1;
      } else {
        var a = t.metaKey || t.ctrlKey, r = this.findFirstOptionIndex();
        t.shiftKey && a && this.onOptionSelectRange(t, r, this.startRangeIndex), this.changeFocusedOptionIndex(t, r), !this.overlayVisible && this.show();
      }
      t.preventDefault();
    },
    onEndKey: function(t) {
      var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, i = t.currentTarget;
      if (n) {
        var o = i.value.length;
        i.setSelectionRange(t.shiftKey ? 0 : o, o), this.focusedOptionIndex = -1;
      } else {
        var a = t.metaKey || t.ctrlKey, r = this.findLastOptionIndex();
        t.shiftKey && a && this.onOptionSelectRange(t, this.startRangeIndex, r), this.changeFocusedOptionIndex(t, r), !this.overlayVisible && this.show();
      }
      t.preventDefault();
    },
    onPageUpKey: function(t) {
      this.scrollInView(0), t.preventDefault();
    },
    onPageDownKey: function(t) {
      this.scrollInView(this.visibleOptions.length - 1), t.preventDefault();
    },
    onEnterKey: function(t) {
      this.overlayVisible ? this.focusedOptionIndex !== -1 && (t.shiftKey ? this.onOptionSelectRange(t, this.focusedOptionIndex) : this.onOptionSelect(t, this.visibleOptions[this.focusedOptionIndex])) : this.onArrowDownKey(t), t.preventDefault();
    },
    onEscapeKey: function(t) {
      this.overlayVisible && this.hide(!0), t.preventDefault();
    },
    onTabKey: function(t) {
      var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
      n || (this.overlayVisible && this.hasFocusableElements() ? (Oe.focus(t.shiftKey ? this.$refs.lastHiddenFocusableElementOnOverlay : this.$refs.firstHiddenFocusableElementOnOverlay), t.preventDefault()) : (this.focusedOptionIndex !== -1 && this.onOptionSelect(t, this.visibleOptions[this.focusedOptionIndex]), this.overlayVisible && this.hide(this.filter)));
    },
    onShiftKey: function() {
      this.startRangeIndex = this.focusedOptionIndex;
    },
    onOverlayEnter: function(t) {
      qt.set("overlay", t, this.$primevue.config.zIndex.overlay), Oe.addStyles(t, {
        position: "absolute",
        top: "0",
        left: "0"
      }), this.alignOverlay(), this.scrollInView(), this.autoFilterFocus && Oe.focus(this.$refs.filterInput);
    },
    onOverlayAfterEnter: function() {
      this.bindOutsideClickListener(), this.bindScrollListener(), this.bindResizeListener(), this.$emit("show");
    },
    onOverlayLeave: function() {
      this.unbindOutsideClickListener(), this.unbindScrollListener(), this.unbindResizeListener(), this.$emit("hide"), this.overlay = null;
    },
    onOverlayAfterLeave: function(t) {
      qt.clear(t);
    },
    alignOverlay: function() {
      this.appendTo === "self" ? Oe.relativePosition(this.overlay, this.$el) : (this.overlay.style.minWidth = Oe.getOuterWidth(this.$el) + "px", Oe.absolutePosition(this.overlay, this.$el));
    },
    bindOutsideClickListener: function() {
      var t = this;
      this.outsideClickListener || (this.outsideClickListener = function(n) {
        t.overlayVisible && t.isOutsideClicked(n) && t.hide();
      }, document.addEventListener("click", this.outsideClickListener));
    },
    unbindOutsideClickListener: function() {
      this.outsideClickListener && (document.removeEventListener("click", this.outsideClickListener), this.outsideClickListener = null);
    },
    bindScrollListener: function() {
      var t = this;
      this.scrollHandler || (this.scrollHandler = new po(this.$refs.container, function() {
        t.overlayVisible && t.hide();
      })), this.scrollHandler.bindScrollListener();
    },
    unbindScrollListener: function() {
      this.scrollHandler && this.scrollHandler.unbindScrollListener();
    },
    bindResizeListener: function() {
      var t = this;
      this.resizeListener || (this.resizeListener = function() {
        t.overlayVisible && !Oe.isTouchDevice() && t.hide();
      }, window.addEventListener("resize", this.resizeListener));
    },
    unbindResizeListener: function() {
      this.resizeListener && (window.removeEventListener("resize", this.resizeListener), this.resizeListener = null);
    },
    isOutsideClicked: function(t) {
      return !(this.$el.isSameNode(t.target) || this.$el.contains(t.target) || this.overlay && this.overlay.contains(t.target));
    },
    getLabelByValue: function(t) {
      var n = this, i = this.optionGroupLabel ? this.flatOptions(this.options) : this.options || [], o = i.find(function(a) {
        return !n.isOptionGroup(a) && We.equals(n.getOptionValue(a), t, n.equalityKey);
      });
      return o ? this.getOptionLabel(o) : null;
    },
    getSelectedItemsLabel: function() {
      var t = /{(.*?)}/, n = this.selectedItemsLabel || this.$primevue.config.locale.selectionMessage;
      return t.test(n) ? n.replace(n.match(t)[0], this.modelValue.length + "") : n;
    },
    onToggleAll: function(t) {
      var n = this;
      if (this.selectAll !== null)
        this.$emit("selectall-change", {
          originalEvent: t,
          checked: !this.allSelected
        });
      else {
        var i = this.allSelected ? [] : this.visibleOptions.filter(function(o) {
          return n.isValidOption(o);
        }).map(function(o) {
          return n.getOptionValue(o);
        });
        this.updateModel(t, i);
      }
      this.headerCheckboxFocused = !0;
    },
    removeOption: function(t, n) {
      var i = this, o = this.modelValue.filter(function(a) {
        return !We.equals(a, n, i.equalityKey);
      });
      this.updateModel(t, o);
    },
    clearFilter: function() {
      this.filterValue = null;
    },
    hasFocusableElements: function() {
      return Oe.getFocusableElements(this.overlay, ':not([data-p-hidden-focusable="true"])').length > 0;
    },
    isOptionMatched: function(t) {
      return this.isValidOption(t) && this.getOptionLabel(t).toLocaleLowerCase(this.filterLocale).startsWith(this.searchValue.toLocaleLowerCase(this.filterLocale));
    },
    isValidOption: function(t) {
      return We.isNotEmpty(t) && !(this.isOptionDisabled(t) || this.isOptionGroup(t));
    },
    isValidSelectedOption: function(t) {
      return this.isValidOption(t) && this.isSelected(t);
    },
    isSelected: function(t) {
      var n = this, i = this.getOptionValue(t);
      return (this.modelValue || []).some(function(o) {
        return We.equals(o, i, n.equalityKey);
      });
    },
    findFirstOptionIndex: function() {
      var t = this;
      return this.visibleOptions.findIndex(function(n) {
        return t.isValidOption(n);
      });
    },
    findLastOptionIndex: function() {
      var t = this;
      return We.findLastIndex(this.visibleOptions, function(n) {
        return t.isValidOption(n);
      });
    },
    findNextOptionIndex: function(t) {
      var n = this, i = t < this.visibleOptions.length - 1 ? this.visibleOptions.slice(t + 1).findIndex(function(o) {
        return n.isValidOption(o);
      }) : -1;
      return i > -1 ? i + t + 1 : t;
    },
    findPrevOptionIndex: function(t) {
      var n = this, i = t > 0 ? We.findLastIndex(this.visibleOptions.slice(0, t), function(o) {
        return n.isValidOption(o);
      }) : -1;
      return i > -1 ? i : t;
    },
    findFirstSelectedOptionIndex: function() {
      var t = this;
      return this.hasSelectedOption ? this.visibleOptions.findIndex(function(n) {
        return t.isValidSelectedOption(n);
      }) : -1;
    },
    findLastSelectedOptionIndex: function() {
      var t = this;
      return this.hasSelectedOption ? We.findLastIndex(this.visibleOptions, function(n) {
        return t.isValidSelectedOption(n);
      }) : -1;
    },
    findNextSelectedOptionIndex: function(t) {
      var n = this, i = this.hasSelectedOption && t < this.visibleOptions.length - 1 ? this.visibleOptions.slice(t + 1).findIndex(function(o) {
        return n.isValidSelectedOption(o);
      }) : -1;
      return i > -1 ? i + t + 1 : -1;
    },
    findPrevSelectedOptionIndex: function(t) {
      var n = this, i = this.hasSelectedOption && t > 0 ? We.findLastIndex(this.visibleOptions.slice(0, t), function(o) {
        return n.isValidSelectedOption(o);
      }) : -1;
      return i > -1 ? i : -1;
    },
    findNearestSelectedOptionIndex: function(t) {
      var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, i = -1;
      return this.hasSelectedOption && (n ? (i = this.findPrevSelectedOptionIndex(t), i = i === -1 ? this.findNextSelectedOptionIndex(t) : i) : (i = this.findNextSelectedOptionIndex(t), i = i === -1 ? this.findPrevSelectedOptionIndex(t) : i)), i > -1 ? i : t;
    },
    findFirstFocusedOptionIndex: function() {
      var t = this.findFirstSelectedOptionIndex();
      return t < 0 ? this.findFirstOptionIndex() : t;
    },
    findLastFocusedOptionIndex: function() {
      var t = this.findLastSelectedOptionIndex();
      return t < 0 ? this.findLastOptionIndex() : t;
    },
    searchOptions: function(t) {
      var n = this;
      this.searchValue = (this.searchValue || "") + t.key;
      var i = -1;
      this.focusedOptionIndex !== -1 ? (i = this.visibleOptions.slice(this.focusedOptionIndex).findIndex(function(o) {
        return n.isOptionMatched(o);
      }), i = i === -1 ? this.visibleOptions.slice(0, this.focusedOptionIndex).findIndex(function(o) {
        return n.isOptionMatched(o);
      }) : i + this.focusedOptionIndex) : i = this.visibleOptions.findIndex(function(o) {
        return n.isOptionMatched(o);
      }), i === -1 && this.focusedOptionIndex === -1 && (i = this.findFirstFocusedOptionIndex()), i !== -1 && this.changeFocusedOptionIndex(t, i), this.searchTimeout && clearTimeout(this.searchTimeout), this.searchTimeout = setTimeout(function() {
        n.searchValue = "", n.searchTimeout = null;
      }, 500);
    },
    changeFocusedOptionIndex: function(t, n) {
      this.focusedOptionIndex !== n && (this.focusedOptionIndex = n, this.scrollInView());
    },
    scrollInView: function() {
      var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : -1, n = t !== -1 ? "".concat(this.id, "_").concat(t) : this.focusedOptionId, i = Oe.findSingle(this.list, 'li[id="'.concat(n, '"]'));
      i ? i.scrollIntoView && i.scrollIntoView({
        block: "nearest",
        inline: "nearest"
      }) : this.virtualScrollerDisabled || this.virtualScroller && this.virtualScroller.scrollToIndex(t !== -1 ? t : this.focusedOptionIndex);
    },
    autoUpdateModel: function() {
      if (this.selectOnFocus && this.autoOptionFocus && !this.hasSelectedOption) {
        this.focusedOptionIndex = this.findFirstFocusedOptionIndex();
        var t = this.getOptionValue(this.visibleOptions[this.focusedOptionIndex]);
        this.updateModel(null, [t]);
      }
    },
    updateModel: function(t, n) {
      this.$emit("update:modelValue", n), this.$emit("change", {
        originalEvent: t,
        value: n
      });
    },
    flatOptions: function(t) {
      var n = this;
      return (t || []).reduce(function(i, o, a) {
        i.push({
          optionGroup: o,
          group: !0,
          index: a
        });
        var r = n.getOptionGroupChildren(o);
        return r && r.forEach(function(s) {
          return i.push(s);
        }), i;
      }, []);
    },
    overlayRef: function(t) {
      this.overlay = t;
    },
    listRef: function(t, n) {
      this.list = t, n && n(t);
    },
    virtualScrollerRef: function(t) {
      this.virtualScroller = t;
    }
  },
  computed: {
    visibleOptions: function() {
      var t = this, n = this.optionGroupLabel ? this.flatOptions(this.options) : this.options || [];
      if (this.filterValue) {
        var i = El.filter(n, this.searchFields, this.filterValue, this.filterMatchMode, this.filterLocale);
        if (this.optionGroupLabel) {
          var o = this.options || [], a = [];
          return o.forEach(function(r) {
            var s = t.getOptionGroupChildren(r), l = s.filter(function(d) {
              return i.includes(d);
            });
            l.length > 0 && a.push(R0(R0({}, r), {}, nT({}, typeof t.optionGroupChildren == "string" ? t.optionGroupChildren : "items", N0(l))));
          }), this.flatOptions(a);
        }
        return i;
      }
      return n;
    },
    label: function() {
      var t;
      if (this.modelValue && this.modelValue.length) {
        if (We.isNotEmpty(this.maxSelectedLabels) && this.modelValue.length > this.maxSelectedLabels)
          return this.getSelectedItemsLabel();
        t = "";
        for (var n = 0; n < this.modelValue.length; n++)
          n !== 0 && (t += ", "), t += this.getLabelByValue(this.modelValue[n]);
      } else
        t = this.placeholder;
      return t;
    },
    chipSelectedItems: function() {
      return We.isNotEmpty(this.maxSelectedLabels) && this.modelValue && this.modelValue.length > this.maxSelectedLabels ? this.modelValue.slice(0, this.maxSelectedLabels) : this.modelValue;
    },
    allSelected: function() {
      var t = this;
      return this.selectAll !== null ? this.selectAll : We.isNotEmpty(this.visibleOptions) && this.visibleOptions.every(function(n) {
        return t.isOptionGroup(n) || t.isOptionDisabled(n) || t.isSelected(n);
      });
    },
    hasSelectedOption: function() {
      return We.isNotEmpty(this.modelValue);
    },
    equalityKey: function() {
      return this.optionValue ? null : this.dataKey;
    },
    searchFields: function() {
      return this.filterFields || [this.optionLabel];
    },
    maxSelectionLimitReached: function() {
      return this.selectionLimit && this.modelValue && this.modelValue.length === this.selectionLimit;
    },
    filterResultMessageText: function() {
      return We.isNotEmpty(this.visibleOptions) ? this.filterMessageText.replaceAll("{0}", this.visibleOptions.length) : this.emptyFilterMessageText;
    },
    filterMessageText: function() {
      return this.filterMessage || this.$primevue.config.locale.searchMessage || "";
    },
    emptyFilterMessageText: function() {
      return this.emptyFilterMessage || this.$primevue.config.locale.emptySearchMessage || this.$primevue.config.locale.emptyFilterMessage || "";
    },
    emptyMessageText: function() {
      return this.emptyMessage || this.$primevue.config.locale.emptyMessage || "";
    },
    selectionMessageText: function() {
      return this.selectionMessage || this.$primevue.config.locale.selectionMessage || "";
    },
    emptySelectionMessageText: function() {
      return this.emptySelectionMessage || this.$primevue.config.locale.emptySelectionMessage || "";
    },
    selectedMessageText: function() {
      return this.hasSelectedOption ? this.selectionMessageText.replaceAll("{0}", this.modelValue.length) : this.emptySelectionMessageText;
    },
    focusedOptionId: function() {
      return this.focusedOptionIndex !== -1 ? "".concat(this.id, "_").concat(this.focusedOptionIndex) : null;
    },
    ariaSetSize: function() {
      var t = this;
      return this.visibleOptions.filter(function(n) {
        return !t.isOptionGroup(n);
      }).length;
    },
    toggleAllAriaLabel: function() {
      return this.$primevue.config.locale.aria ? this.$primevue.config.locale.aria[this.allSelected ? "selectAll" : "unselectAll"] : void 0;
    },
    closeAriaLabel: function() {
      return this.$primevue.config.locale.aria ? this.$primevue.config.locale.aria.close : void 0;
    },
    virtualScrollerDisabled: function() {
      return !this.virtualScrollerOptions;
    }
  },
  directives: {
    ripple: An
  },
  components: {
    VirtualScroller: Ls,
    Portal: Yn,
    TimesIcon: Ho,
    SearchIcon: fh,
    TimesCircleIcon: hc,
    ChevronDownIcon: Va,
    SpinnerIcon: jo,
    CheckIcon: Oa
  }
};
function Oc(e) {
  "@babel/helpers - typeof";
  return Oc = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Oc(e);
}
function $0(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    t && (i = i.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), n.push.apply(n, i);
  }
  return n;
}
function xo(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? $0(Object(n), !0).forEach(function(i) {
      $f(e, i, n[i]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : $0(Object(n)).forEach(function(i) {
      Object.defineProperty(e, i, Object.getOwnPropertyDescriptor(n, i));
    });
  }
  return e;
}
function $f(e, t, n) {
  return t = Fie(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function Fie(e) {
  var t = jie(e, "string");
  return Oc(t) == "symbol" ? t : String(t);
}
function jie(e, t) {
  if (Oc(e) != "object" || !e)
    return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var i = n.call(e, t || "default");
    if (Oc(i) != "object")
      return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var Hie = ["id", "disabled", "placeholder", "tabindex", "aria-label", "aria-labelledby", "aria-expanded", "aria-controls", "aria-activedescendant"], zie = ["onClick"], Vie = ["checked", "aria-label"], Gie = ["value", "placeholder", "aria-owns", "aria-activedescendant"], Uie = ["aria-label"], Wie = ["id"], Yie = ["id"], qie = ["id", "aria-label", "aria-selected", "aria-disabled", "aria-setsize", "aria-posinset", "onClick", "onMousemove", "data-p-highlight", "data-p-focused", "data-p-disabled"];
function Kie(e, t, n, i, o, a) {
  var r = $e("TimesCircleIcon"), s = $e("SpinnerIcon"), l = $e("VirtualScroller"), d = $e("Portal"), y = Ut("ripple");
  return E(), X("div", Ce({
    ref: "container",
    class: e.cx("root"),
    onClick: t[15] || (t[15] = function() {
      return a.onContainerClick && a.onContainerClick.apply(a, arguments);
    })
  }, e.ptm("root"), {
    "data-pc-name": "multiselect"
  }), [oe("div", Ce({
    class: "p-hidden-accessible"
  }, e.ptm("hiddenInputWrapper"), {
    "data-p-hidden-accessible": !0
  }), [oe("input", Ce({
    ref: "focusInput",
    id: e.inputId,
    type: "text",
    readonly: "",
    disabled: e.disabled,
    placeholder: e.placeholder,
    tabindex: e.disabled ? -1 : e.tabindex,
    role: "combobox",
    "aria-label": e.ariaLabel,
    "aria-labelledby": e.ariaLabelledby,
    "aria-haspopup": "listbox",
    "aria-expanded": o.overlayVisible,
    "aria-controls": o.id + "_list",
    "aria-activedescendant": o.focused ? a.focusedOptionId : void 0,
    onFocus: t[0] || (t[0] = function() {
      return a.onFocus && a.onFocus.apply(a, arguments);
    }),
    onBlur: t[1] || (t[1] = function() {
      return a.onBlur && a.onBlur.apply(a, arguments);
    }),
    onKeydown: t[2] || (t[2] = function() {
      return a.onKeyDown && a.onKeyDown.apply(a, arguments);
    })
  }, xo(xo({}, e.inputProps), e.ptm("hiddenInput"))), null, 16, Hie)], 16), oe("div", Ce({
    class: e.cx("labelContainer")
  }, e.ptm("labelContainer")), [oe("div", Ce({
    class: e.cx("label")
  }, e.ptm("label")), [je(e.$slots, "value", {
    value: e.modelValue,
    placeholder: e.placeholder
  }, function() {
    return [e.display === "comma" ? (E(), X(Re, {
      key: 0
    }, [Ve(Ie(a.label || "empty"), 1)], 64)) : e.display === "chip" ? (E(), X(Re, {
      key: 1
    }, [(E(!0), X(Re, null, Ge(a.chipSelectedItems, function(u) {
      return E(), X("div", Ce({
        key: a.getLabelByValue(u),
        class: e.cx("token")
      }, e.ptm("token")), [je(e.$slots, "chip", {
        value: u
      }, function() {
        return [oe("span", Ce({
          class: e.cx("tokenLabel")
        }, e.ptm("tokenLabel")), Ie(a.getLabelByValue(u)), 17)];
      }), e.disabled ? te("", !0) : je(e.$slots, "removetokenicon", {
        key: 0,
        class: Pe(e.cx("removeTokenIcon")),
        item: u,
        onClick: function(h) {
          return a.removeOption(h, u);
        },
        removeCallback: function(h) {
          return a.removeOption(h, u);
        }
      }, function() {
        return [e.removeTokenIcon ? (E(), X("span", Ce({
          key: 0,
          class: [e.cx("removeTokenIcon"), e.removeTokenIcon],
          onClick: It(function(m) {
            return a.removeOption(m, u);
          }, ["stop"])
        }, e.ptm("removeTokenIcon")), null, 16, zie)) : (E(), fe(r, Ce({
          key: 1,
          class: e.cx("removeTokenIcon"),
          onClick: It(function(m) {
            return a.removeOption(m, u);
          }, ["stop"])
        }, e.ptm("removeTokenIcon")), null, 16, ["class", "onClick"]))];
      })], 16);
    }), 128)), !e.modelValue || e.modelValue.length === 0 ? (E(), X(Re, {
      key: 0
    }, [Ve(Ie(e.placeholder || "empty"), 1)], 64)) : te("", !0)], 64)) : te("", !0)];
  })], 16)], 16), oe("div", Ce({
    class: e.cx("trigger")
  }, e.ptm("trigger")), [e.loading ? je(e.$slots, "loadingicon", {
    key: 0,
    class: Pe(e.cx("loadingIcon"))
  }, function() {
    return [e.loadingIcon ? (E(), X("span", Ce({
      key: 0,
      class: [e.cx("loadingIcon"), "pi-spin", e.loadingIcon],
      "aria-hidden": "true"
    }, e.ptm("loadingIcon")), null, 16)) : (E(), fe(s, Ce({
      key: 1,
      class: e.cx("loadingIcon"),
      spin: "",
      "aria-hidden": "true"
    }, e.ptm("loadingIcon")), null, 16, ["class"]))];
  }) : je(e.$slots, "dropdownicon", {
    key: 1,
    class: Pe(e.cx("dropdownIcon"))
  }, function() {
    return [(E(), fe(tt(e.dropdownIcon ? "span" : "ChevronDownIcon"), Ce({
      class: [e.cx("dropdownIcon"), e.dropdownIcon],
      "aria-hidden": "true"
    }, e.ptm("dropdownIcon")), null, 16, ["class"]))];
  })], 16), ue(d, {
    appendTo: e.appendTo
  }, {
    default: Se(function() {
      return [ue(ia, Ce({
        name: "p-connected-overlay",
        onEnter: a.onOverlayEnter,
        onAfterEnter: a.onOverlayAfterEnter,
        onLeave: a.onOverlayLeave,
        onAfterLeave: a.onOverlayAfterLeave
      }, e.ptm("transition")), {
        default: Se(function() {
          return [o.overlayVisible ? (E(), X("div", Ce({
            key: 0,
            ref: a.overlayRef,
            style: e.panelStyle,
            class: [e.cx("panel"), e.panelClass],
            onClick: t[13] || (t[13] = function() {
              return a.onOverlayClick && a.onOverlayClick.apply(a, arguments);
            }),
            onKeydown: t[14] || (t[14] = function() {
              return a.onOverlayKeyDown && a.onOverlayKeyDown.apply(a, arguments);
            })
          }, xo(xo({}, e.panelProps), e.ptm("panel"))), [oe("span", Ce({
            ref: "firstHiddenFocusableElementOnOverlay",
            role: "presentation",
            "aria-hidden": "true",
            class: "p-hidden-accessible p-hidden-focusable",
            tabindex: 0,
            onFocus: t[3] || (t[3] = function() {
              return a.onFirstHiddenFocus && a.onFirstHiddenFocus.apply(a, arguments);
            })
          }, e.ptm("hiddenFirstFocusableEl"), {
            "data-p-hidden-accessible": !0,
            "data-p-hidden-focusable": !0
          }), null, 16), je(e.$slots, "header", {
            value: e.modelValue,
            options: a.visibleOptions
          }), e.showToggleAll && e.selectionLimit == null || e.filter ? (E(), X("div", Ce({
            key: 0,
            class: e.cx("header")
          }, e.ptm("header")), [e.showToggleAll && e.selectionLimit == null ? (E(), X("div", Ce({
            key: 0,
            class: e.cx("headerCheckboxContainer"),
            onClick: t[6] || (t[6] = function() {
              return a.onToggleAll && a.onToggleAll.apply(a, arguments);
            })
          }, e.ptm("headerCheckboxContainer")), [oe("div", Ce({
            class: "p-hidden-accessible"
          }, e.ptm("hiddenInputWrapper"), {
            "data-p-hidden-accessible": !0
          }), [oe("input", Ce({
            type: "checkbox",
            readonly: "",
            checked: a.allSelected,
            "aria-label": a.toggleAllAriaLabel,
            onFocus: t[4] || (t[4] = function() {
              return a.onHeaderCheckboxFocus && a.onHeaderCheckboxFocus.apply(a, arguments);
            }),
            onBlur: t[5] || (t[5] = function() {
              return a.onHeaderCheckboxBlur && a.onHeaderCheckboxBlur.apply(a, arguments);
            })
          }, e.ptm("headerCheckbox")), null, 16, Vie)], 16), oe("div", Ce({
            class: e.cx("headerCheckbox")
          }, a.getHeaderCheckboxPTOptions("headerCheckbox")), [je(e.$slots, "headercheckboxicon", {
            allSelected: a.allSelected,
            class: Pe(e.cx("headerCheckboxIcon"))
          }, function() {
            return [rt((E(), fe(tt(e.checkboxIcon ? "span" : "CheckIcon"), Ce({
              class: [e.cx("headerCheckboxIcon"), $f({}, e.checkboxIcon, a.allSelected)]
            }, a.getHeaderCheckboxPTOptions("headerCheckboxIcon")), null, 16, ["class"])), [[xn, a.allSelected]])];
          })], 16)], 16)) : te("", !0), e.filter ? (E(), X("div", Ce({
            key: 1,
            class: e.cx("filterContainer")
          }, e.ptm("filterContainer")), [oe("input", Ce({
            ref: "filterInput",
            type: "text",
            value: o.filterValue,
            onVnodeMounted: t[7] || (t[7] = function() {
              return a.onFilterUpdated && a.onFilterUpdated.apply(a, arguments);
            }),
            class: e.cx("filterInput"),
            placeholder: e.filterPlaceholder,
            role: "searchbox",
            autocomplete: "off",
            "aria-owns": o.id + "_list",
            "aria-activedescendant": a.focusedOptionId,
            onKeydown: t[8] || (t[8] = function() {
              return a.onFilterKeyDown && a.onFilterKeyDown.apply(a, arguments);
            }),
            onBlur: t[9] || (t[9] = function() {
              return a.onFilterBlur && a.onFilterBlur.apply(a, arguments);
            }),
            onInput: t[10] || (t[10] = function() {
              return a.onFilterChange && a.onFilterChange.apply(a, arguments);
            })
          }, xo(xo({}, e.filterInputProps), e.ptm("filterInput"))), null, 16, Gie), je(e.$slots, "filtericon", {
            class: Pe(e.cx("filterIcon"))
          }, function() {
            return [(E(), fe(tt(e.filterIcon ? "span" : "SearchIcon"), Ce({
              class: [e.cx("filterIcon"), e.filterIcon]
            }, e.ptm("filterIcon")), null, 16, ["class"]))];
          })], 16)) : te("", !0), e.filter ? (E(), X("span", Ce({
            key: 2,
            role: "status",
            "aria-live": "polite",
            class: "p-hidden-accessible"
          }, e.ptm("hiddenFilterResult"), {
            "data-p-hidden-accessible": !0
          }), Ie(a.filterResultMessageText), 17)) : te("", !0), rt((E(), X("button", Ce({
            class: e.cx("closeButton"),
            "aria-label": a.closeAriaLabel,
            onClick: t[11] || (t[11] = function() {
              return a.onCloseClick && a.onCloseClick.apply(a, arguments);
            }),
            type: "button"
          }, xo(xo({}, e.closeButtonProps), e.ptm("closeButton"))), [je(e.$slots, "closeicon", {
            class: Pe(e.cx("closeIcon"))
          }, function() {
            return [(E(), fe(tt(e.closeIcon ? "span" : "TimesIcon"), Ce({
              class: [e.cx("closeIcon"), e.closeIcon]
            }, e.ptm("closeIcon")), null, 16, ["class"]))];
          })], 16, Uie)), [[y]])], 16)) : te("", !0), oe("div", Ce({
            class: e.cx("wrapper"),
            style: {
              "max-height": a.virtualScrollerDisabled ? e.scrollHeight : ""
            }
          }, e.ptm("wrapper")), [ue(l, Ce({
            ref: a.virtualScrollerRef
          }, e.virtualScrollerOptions, {
            items: a.visibleOptions,
            style: {
              height: e.scrollHeight
            },
            tabindex: -1,
            disabled: a.virtualScrollerDisabled,
            pt: e.ptm("virtualScroller")
          }), Qt({
            content: Se(function(u) {
              var m = u.styleClass, h = u.contentRef, c = u.items, g = u.getItemOptions, v = u.contentStyle, P = u.itemSize;
              return [oe("ul", Ce({
                ref: function(S) {
                  return a.listRef(S, h);
                },
                id: o.id + "_list",
                class: [e.cx("list"), m],
                style: v,
                role: "listbox",
                "aria-multiselectable": "true"
              }, e.ptm("list")), [(E(!0), X(Re, null, Ge(c, function(f, S) {
                return E(), X(Re, {
                  key: a.getOptionRenderKey(f, a.getOptionIndex(S, g))
                }, [a.isOptionGroup(f) ? (E(), X("li", Ce({
                  key: 0,
                  id: o.id + "_" + a.getOptionIndex(S, g),
                  style: {
                    height: P ? P + "px" : void 0
                  },
                  class: e.cx("itemGroup"),
                  role: "option"
                }, e.ptm("itemGroup")), [je(e.$slots, "optiongroup", {
                  option: f.optionGroup,
                  index: a.getOptionIndex(S, g)
                }, function() {
                  return [Ve(Ie(a.getOptionGroupLabel(f.optionGroup)), 1)];
                })], 16, Yie)) : rt((E(), X("li", Ce({
                  key: 1,
                  id: o.id + "_" + a.getOptionIndex(S, g),
                  style: {
                    height: P ? P + "px" : void 0
                  },
                  class: e.cx("item", {
                    option: f,
                    index: S,
                    getItemOptions: g
                  }),
                  role: "option",
                  "aria-label": a.getOptionLabel(f),
                  "aria-selected": a.isSelected(f),
                  "aria-disabled": a.isOptionDisabled(f),
                  "aria-setsize": a.ariaSetSize,
                  "aria-posinset": a.getAriaPosInset(a.getOptionIndex(S, g)),
                  onClick: function(x) {
                    return a.onOptionSelect(x, f, a.getOptionIndex(S, g), !0);
                  },
                  onMousemove: function(x) {
                    return a.onOptionMouseMove(x, a.getOptionIndex(S, g));
                  }
                }, a.getCheckboxPTOptions(f, g, S, "item"), {
                  "data-p-highlight": a.isSelected(f),
                  "data-p-focused": o.focusedOptionIndex === a.getOptionIndex(S, g),
                  "data-p-disabled": a.isOptionDisabled(f)
                }), [oe("div", Ce({
                  class: e.cx("checkboxContainer")
                }, e.ptm("checkboxContainer")), [oe("div", Ce({
                  class: e.cx("checkbox", {
                    option: f
                  })
                }, a.getCheckboxPTOptions(f, g, S, "checkbox")), [je(e.$slots, "itemcheckboxicon", {
                  selected: a.isSelected(f),
                  class: Pe(e.cx("checkboxIcon"))
                }, function() {
                  return [rt((E(), fe(tt(e.checkboxIcon ? "span" : "CheckIcon"), Ce({
                    class: [e.cx("checkboxIcon"), $f({}, e.checkboxIcon, a.isSelected(f))]
                  }, a.getCheckboxPTOptions(f, g, S, "checkboxIcon")), null, 16, ["class"])), [[xn, a.isSelected(f)]])];
                })], 16)], 16), je(e.$slots, "option", {
                  option: f,
                  index: a.getOptionIndex(S, g)
                }, function() {
                  return [oe("span", si(Ki(e.ptm("option"))), Ie(a.getOptionLabel(f)), 17)];
                })], 16, qie)), [[y]])], 64);
              }), 128)), o.filterValue && (!c || c && c.length === 0) ? (E(), X("li", Ce({
                key: 0,
                class: e.cx("emptyMessage"),
                role: "option"
              }, e.ptm("emptyMessage")), [je(e.$slots, "emptyfilter", {}, function() {
                return [Ve(Ie(a.emptyFilterMessageText), 1)];
              })], 16)) : !e.options || e.options && e.options.length === 0 ? (E(), X("li", Ce({
                key: 1,
                class: e.cx("emptyMessage"),
                role: "option"
              }, e.ptm("emptyMessage")), [je(e.$slots, "empty", {}, function() {
                return [Ve(Ie(a.emptyMessageText), 1)];
              })], 16)) : te("", !0)], 16, Wie)];
            }),
            _: 2
          }, [e.$slots.loader ? {
            name: "loader",
            fn: Se(function(u) {
              var m = u.options;
              return [je(e.$slots, "loader", {
                options: m
              })];
            }),
            key: "0"
          } : void 0]), 1040, ["items", "style", "disabled", "pt"])], 16), je(e.$slots, "footer", {
            value: e.modelValue,
            options: a.visibleOptions
          }), !e.options || e.options && e.options.length === 0 ? (E(), X("span", Ce({
            key: 1,
            role: "status",
            "aria-live": "polite",
            class: "p-hidden-accessible"
          }, e.ptm("hiddenEmptyMessage"), {
            "data-p-hidden-accessible": !0
          }), Ie(a.emptyMessageText), 17)) : te("", !0), oe("span", Ce({
            role: "status",
            "aria-live": "polite",
            class: "p-hidden-accessible"
          }, e.ptm("hiddenSelectedMessage"), {
            "data-p-hidden-accessible": !0
          }), Ie(a.selectedMessageText), 17), oe("span", Ce({
            ref: "lastHiddenFocusableElementOnOverlay",
            role: "presentation",
            "aria-hidden": "true",
            class: "p-hidden-accessible p-hidden-focusable",
            tabindex: 0,
            onFocus: t[12] || (t[12] = function() {
              return a.onLastHiddenFocus && a.onLastHiddenFocus.apply(a, arguments);
            })
          }, e.ptm("hiddenLastFocusableEl"), {
            "data-p-hidden-accessible": !0,
            "data-p-hidden-focusable": !0
          }), null, 16)], 16)) : te("", !0)];
        }),
        _: 3
      }, 16, ["onEnter", "onAfterEnter", "onLeave", "onAfterLeave"])];
    }),
    _: 3
  }, 8, ["appendTo"])], 16);
}
iT.render = Kie;
var Bc = /* @__PURE__ */ ((e) => (e.SingleSelect = "single-select", e.MultiSelect = "multi-select", e.TreeSelect = "tree-select", e))(Bc || {}), Ff = /* @__PURE__ */ ((e) => (e.Text = "text", e.MorningStarRating = "morning-star-rating", e))(Ff || {});
const Xie = {
  key: 0,
  class: "d-base-select-time-period"
}, Zie = ["aria-expanded", "aria-label"], Jie = ["data-event_source", "data-event_title", "aria-label", "tabindex", "onKeydown", "onClick"], Qie = /* @__PURE__ */ Be({
  __name: "BaseSelectTimePeriod",
  props: {
    model: {
      type: Object,
      required: !0
    },
    showBackLink: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["periodChanged", "show", "hide", "onEscape"],
  setup(e, { expose: t, emit: n }) {
    const i = e, o = n, { t: a } = Je(), r = ge(!1), s = ge(), l = ge(), d = ge(), y = ge(i.model.selectedTimePeriod), u = ge(y.value?.name), m = ge([]), h = ge(-1), c = ge(void 0), g = Te(() => i.model.showShortName ? y.value?.shortName : y.value?.name), v = (M) => {
      s.value.toggle(M), r.value = !r.value, M.stopPropagation();
    }, P = (M) => {
      f(M), o("onEscape");
    }, f = (M) => {
      r.value && (s.value.toggle(M), r.value = !r.value), M.stopPropagation();
    }, S = () => {
      h.value = -1, o("show");
    }, w = () => {
      d.value.focus(), o("hide");
    }, x = () => {
      if (!Ue)
        return;
      const M = l.value?.querySelectorAll(
        ".d-base-select-time-period__item"
      );
      let D = [];
      M && (D = Array.from(M).filter(
        (C) => !C.classList.contains("d-base-select-time-period__item--disabled")
      )), c?.value?.$el && D.push(c.value.$el), D?.[h.value] ? D[h.value]?.focus() : h.value -= 1;
    }, k = (M) => {
      M.preventDefault(), h.value > 0 && h.value--, h.value < 0 && (h.value = 0), x();
    }, A = (M) => {
      M.preventDefault(), h.value < m.value.length - 1 && h.value++, x();
    }, $ = (M) => {
      s.value.toggle(M), r.value = !r.value, M.stopPropagation();
    }, j = (M) => {
      Ue && window.utag?.view({
        ck1: Qe().pageName,
        ck2: "Fund-Finder",
        ck4: "Period Changed | " + M.name,
        "data-event_source": Qe().pageName,
        "data-event_component_name": "Fund-Finder",
        "data-event_title": "Period Changed | " + M.name
      });
    };
    function N(M, D) {
      D?.isDisabled || (s.value.toggle(), r.value = !r.value, y.value = D, i.model.selectedTimePeriod = D, j(D), M.stopPropagation(), o("periodChanged", D));
    }
    return qe(
      () => i.model,
      (M) => {
        y.value = M.selectedTimePeriod, u.value = y.value?.name;
      },
      { deep: !0 }
    ), t({
      selectTimePeriodButton: d
    }), (M, D) => {
      const C = $e("BaseText"), b = $e("BaseIcon");
      return e.model.timePeriods ? (E(), X("div", Xie, [
        e.model.label ? (E(), fe(C, {
          key: 0,
          "font-type": _(lt).DwsSlabBold,
          "text-color": _(dt).GreyBlue008,
          text: e.model.label + ":",
          class: "d-base-select-time-period__label"
        }, null, 8, ["font-type", "text-color", "text"])) : te("", !0),
        oe("div", {
          ref_key: "selectTimePeriodButton",
          ref: d,
          class: "d-base-select-time-period__button",
          tabindex: "0",
          role: "combobox",
          "aria-expanded": r.value,
          "aria-label": `${e.model.label} ${y.value?.name}`,
          onKeyup: [
            Ze(k, ["up"]),
            Ze(A, ["down"])
          ],
          onKeydown: [
            Ze(f, ["tab"]),
            Ze(P, ["esc"]),
            Ze(v, ["enter"])
          ],
          onClick: v
        }, [
          ue(C, {
            "font-type": _(lt).DwsSlabBold,
            "text-color": _(dt).Primary,
            text: g.value,
            class: "grow-1 hover:underline"
          }, null, 8, ["font-type", "text-color", "text"]),
          ue(b, {
            "base-icon": _(H).Cog,
            "base-icon-size": _(at).S
          }, null, 8, ["base-icon", "base-icon-size"])
        ], 40, Zie),
        ue(_(oh), {
          ref_key: "overlay",
          ref: s,
          class: "p-overlaypanel-singleselect",
          "append-to": "#dx-overlay",
          onShow: S,
          onHide: w,
          onKeydown: Ze(f, ["tab"])
        }, {
          default: Se(() => [
            oe("div", {
              ref_key: "overlayContent",
              ref: l,
              class: "d-base-select-time-period__overlay"
            }, [
              ue(C, {
                "font-type": _(lt).DwsSlabBold,
                text: _(a)("fundFinder.periodHeadline")
              }, null, 8, ["font-type", "text"]),
              (E(!0), X(Re, null, Ge(e.model.timePeriods, (p, L) => (E(), X("div", {
                key: L,
                ref_for: !0,
                ref: (B) => m.value.push(B),
                class: Pe(["d-base-select-time-period__item", {
                  "d-base-select-time-period__item--disabled": p?.isDisabled
                }]),
                "data-event_source": _(Qe)().pageName,
                "data-event_component_name": "Fund-Finder",
                "data-event_title": "Period Changed | " + p.name,
                "aria-label": p.name,
                tabindex: p?.isDisabled ? null : 0,
                role: "radio",
                onKeydown: [
                  Ze(k, ["up"]),
                  Ze(A, ["down"]),
                  Ze((B) => N(B, p), ["enter"]),
                  Ze(It((B) => N(B, p), ["prevent"]), ["space"])
                ],
                onClick: (B) => N(B, p)
              }, [
                ue(_(Or), {
                  id: "period-radio-button",
                  modelValue: u.value,
                  "onUpdate:modelValue": D[0] || (D[0] = (B) => u.value = B),
                  name: "period",
                  "input-id": p.identifier,
                  value: p.name,
                  disabled: p?.isDisabled,
                  class: "d-radio-button",
                  pt: {
                    root: {
                      "data-event_source": _(Qe)().pageName,
                      "data-event_title": "Fund-Finder",
                      "data-event_component_name": "Period Changed | " + p.name
                    },
                    input: {
                      "data-event_source": _(Qe)().pageName,
                      "data-event_title": "Fund-Finder",
                      "data-event_component_name": "Period Changed | " + p.name
                    },
                    hiddenInput: {
                      "data-event_source": _(Qe)().pageName,
                      "data-event_title": "Fund-Finder",
                      "data-event_component_name": "Period Changed | " + p.name
                    },
                    hiddenInputWrapper: {
                      "data-event_source": _(Qe)().pageName,
                      "data-event_title": "Fund-Finder",
                      "data-event_component_name": "Period Changed | " + p.name
                    },
                    icon: {
                      "data-event_source": _(Qe)().pageName,
                      "data-event_title": "Fund-Finder",
                      "data-event_component_name": "Period Changed | " + p.name
                    }
                  }
                }, null, 8, ["modelValue", "input-id", "value", "disabled", "pt"]),
                oe("label", {
                  for: "period-radio-button",
                  class: Pe(["d-base-select-time-period__radio--label", {
                    "d-base-select-time-period__radio--label--disabled": p?.isDisabled
                  }])
                }, [
                  p.name ? (E(), fe(C, {
                    key: 0,
                    "font-type": _(lt).DwsSansBold,
                    text: p.name,
                    class: "inline-block"
                  }, null, 8, ["font-type", "text"])) : te("", !0)
                ], 2)
              ], 42, Jie))), 128)),
              ue(C, {
                "font-type": _(lt).DwsSans,
                "font-size": _(st).FourteenPx,
                text: _(a)("fundFinder.periodHint")
              }, null, 8, ["font-type", "font-size", "text"]),
              e.showBackLink ? (E(), fe(_(ot), {
                key: 0,
                ref_key: "backLinkRef",
                ref: c,
                class: "d-base-select-time-period__back-link",
                "link-model": {
                  text: _(a)("globalTranslations.backLinkText"),
                  title: _(a)("globalTranslations.backLinkText"),
                  href: void 0,
                  target: "",
                  contentUrl: "",
                  isLocked: !1,
                  isExternal: !1,
                  linkType: _(yt).Javascript,
                  tealiumTrackingModel: {
                    eventComponentName: "Fund-Finder",
                    eventTitle: "Period Back",
                    eventSource: _(Qe)().pageName
                  }
                },
                icon: _(H).ArrowLeft,
                "icon-position": _(ct).Left,
                onClick: $,
                onKeyup: [
                  Ze(k, ["up"]),
                  Ze(A, ["down"])
                ],
                onKeydown: Ze(It(f, ["prevent"]), ["tab", "esc", "enter", "space"])
              }, null, 8, ["link-model", "icon", "icon-position", "onKeydown"])) : te("", !0)
            ], 512)
          ]),
          _: 1
        }, 512)
      ])) : te("", !0);
    };
  }
});
const jf = /* @__PURE__ */ Fe(Qie, [["__scopeId", "data-v-92a1ce7f"]]), eae = ["aria-expanded", "aria-label", "onKeydown"], tae = {
  key: 1,
  class: "d-base-multi-select--header flex flex-row items-center justify-between my-2"
}, nae = { class: "flex flex-row items-center grow-1" }, iae = {
  key: 1,
  class: "d-base-multi-select__item--option--result grow-0"
}, aae = /* @__PURE__ */ Be({
  __name: "BaseMultiSelect",
  props: {
    filter: {
      type: Object,
      required: !0
    },
    showDeselectAllText: {
      type: Boolean,
      default: !0
    },
    showNumberOfResultsInOptions: {
      type: Boolean,
      default: !1
    },
    showNumberOfResultsInValue: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["multiselectValueChanged", "timePeriodValueChanged"],
  setup(e, { emit: t }) {
    const { t: n } = Je(), i = e, o = t;
    let a = !1;
    const r = ge(), s = ge(), l = ge(0), d = ge(!1), y = ge(), u = ge(), m = ge(
      i.filter.filterOptions.filter((R) => R.isSelected)
    ), h = ge(m.value?.map((R) => R.name)), c = ge([]), g = ge(!1), v = () => {
      if (Ue) {
        const R = u.value?.selectTimePeriodButton, Y = y.value?.$el, F = Array.from(r.value?.$el.querySelectorAll("li")), U = [];
        return R && U.push(R), Y && U.push(Y), U.push(...F), U;
      }
      return [];
    }, P = Te(
      () => (R) => R.isDisabled || !R.results && i.showNumberOfResultsInOptions
    ), f = (R) => {
      if (Ue) {
        const Y = R?.target;
        Y && Y instanceof HTMLElement && Y.click();
      }
    }, S = (R) => {
      if (Ue) {
        c.value.forEach((F) => {
          F.classList.remove("p-focus");
        });
        const Y = c.value[R];
        Y && (Y.focus(), Y.classList.add("p-focus"));
      }
    }, w = async () => {
      d.value || (r.value.show(), await mt(), c.value = v(), l.value = 0, S(l.value));
    }, x = () => {
      g.value || d.value && (r.value.hide(), Ue && window.requestAnimationFrame(() => {
        s.value.focus();
      }));
    }, k = () => {
      l.value > 0 && l.value--, l.value < 0 && (l.value = 0), S(l.value);
    }, A = () => {
      l.value + 1 < c.value.length && l.value++, S(l.value);
    }, $ = (R) => {
      g.value || d.value && (R.preventDefault(), R.shiftKey ? k() : A());
    }, j = (R) => {
      g.value || (R.preventDefault(), w(), k());
    }, N = (R) => {
      g.value || (R.preventDefault(), w(), A());
    };
    function M(R, Y) {
      const F = R.map((J) => J?.name), U = F?.filter(
        (J) => !h.value?.includes(J)
      ), Q = h.value?.filter(
        (J) => !F?.includes(J)
      );
      On(
        O.value,
        `${Y}, ${U[0] || ""}${Q[0] || ""}`,
        Qe().pageName
      ), h.value = [...F], i.filter.isSelected = R?.length > 0, m.value = R, o("multiselectValueChanged", R);
    }
    function D() {
      i.filter.filterOptions.forEach((R) => R.isSelected = !1), i.filter.isSelected = !1, m.value = [], o("multiselectValueChanged", m.value);
    }
    const C = (R) => {
      (R.key === "ArrowUp" || R.key === "ArrowDown") && R.preventDefault();
    };
    async function b(R) {
      if (On(
        O.value,
        R,
        Qe().pageName
      ), d.value = !d.value, I(), !Ue)
        return;
      d.value ? document.body.addEventListener("keydown", C) : document.body.removeEventListener("keydown", C);
      const Y = document.querySelector(
        ".p-multiselect-panel span[role=presentation]"
      );
      Y && Y.setAttribute("tabIndex", "-1"), a || (a = !0, y.value?.iconButtonTooltipTrigger && pn({
        trigger: y.value.iconButtonTooltipTrigger,
        headline: "",
        content: n("fundFinder.deselectAll"),
        appendTo: y.value.iconButtonTooltipTrigger,
        showOnTouchDevices: !1,
        field: () => y.value.iconButtonTooltipTrigger
      }));
    }
    function p(R) {
      g.value || (d.value ? f(R) : w());
    }
    function L() {
      m.value = i.filter.filterOptions.filter(
        (R) => R.isSelected
      );
    }
    const B = (R) => {
      i.filter.selectedTimePeriod = R, o("timePeriodValueChanged", R);
    }, T = (R, Y) => {
      switch (Y) {
        case Ff.Text:
          return At("span", { innerHTML: R });
        case Ff.MorningStarRating:
          return At(Sh, {
            model: {
              value: +R
            },
            insideComponent: !0
          });
        default:
          return At("span", { innerHTML: R });
      }
    }, O = Te(() => i.filter?.componentNameForTracking ? i.filter.componentNameForTracking : "Base-Multi-Select"), I = () => {
      Ue && document.querySelectorAll(
        ".d-base-multi-select__panel.p-hidden-accessible"
      )?.forEach((Y) => {
        Y.setAttribute("tabindex", "-1");
      });
    };
    return (R, Y) => {
      const F = $e("BaseIcon"), U = $e("BaseText");
      return E(), X("div", {
        ref_key: "multiSelectContainer",
        ref: s,
        class: "d-base-multi-select",
        role: "combobox",
        "aria-expanded": d.value,
        tabindex: 0,
        "aria-label": e.filter.name,
        onClick: It(p, ["self"]),
        onKeyup: [
          Ze(j, ["up"]),
          Ze(N, ["down"])
        ],
        onKeydown: [
          Ze(It(p, ["prevent"]), ["space"]),
          Ze(p, ["enter"]),
          Ze($, ["tab"]),
          Ze(x, ["esc"])
        ]
      }, [
        ue(_(iT), {
          ref_key: "multiSelect",
          ref: r,
          modelValue: m.value,
          "onUpdate:modelValue": [
            Y[4] || (Y[4] = (Q) => m.value = Q),
            Y[5] || (Y[5] = (Q) => M(Q, e.filter?.name))
          ],
          options: e.filter.filterOptions,
          "option-label": "name",
          placeholder: `${e.filter.name} ${e.showNumberOfResultsInValue && e.filter.results !== void 0 ? "(" + e.filter.results + ")" : ""}`,
          "scroll-height": "364px",
          class: Pe(["d-base-multi-select__dropdown", e.filter.isSelected ? "d-base-multi-select--selected" : ""]),
          "show-toggle-all": !1,
          "append-to": "self",
          "aria-label": e.filter.name,
          disabled: e.filter.isDisabled,
          "option-disabled": P.value,
          filter: e.filter.hasSearchField,
          "filter-placeholder": e.filter.searchFieldPlaceholder ? e.filter.searchFieldPlaceholder : _(n)("globalTranslations.search"),
          "close-button-props": {
            style: {
              display: "none"
            }
          },
          pt: {
            item: {
              tabindex: 0,
              class: "d-base-multi-select__item"
            },
            panel: {
              class: `d-base-multi-select__panel  ${e.filter.filterOptions.length > 5 ? "scrollable" : ""} `
            },
            hiddenInput: {
              ariaHidden: !0
            }
          },
          onBeforeShow: L,
          onShow: Y[6] || (Y[6] = (Q) => b(e.filter?.name)),
          onHide: Y[7] || (Y[7] = (Q) => b(e.filter?.name))
        }, {
          dropdownicon: Se(() => [
            ue(F, {
              "base-icon": d.value ? _(H).AngleUp : _(H).AngleDown,
              "base-icon-size": _(at).S,
              class: "mr-4",
              "aria-hidden": "true"
            }, null, 8, ["base-icon", "base-icon-size"])
          ]),
          value: Se(() => [
            e.filter.isTimeDependent ? (E(), X(Re, { key: 0 }, [
              Ve(Ie(`${e.filter.name} ${e.filter.selectedTimePeriod?.shortName ? e.filter.selectedTimePeriod?.shortName : ""} 
            ${e.showNumberOfResultsInValue && e.filter.results !== void 0 ? "(" + e.filter.results + ")" : ""}`), 1)
            ], 64)) : (E(), X(Re, { key: 1 }, [
              Ve(Ie(`${e.filter.name}  ${e.showNumberOfResultsInValue && e.filter.results !== void 0 ? "(" + e.filter.results + ")" : ""}`), 1)
            ], 64))
          ]),
          header: Se(() => [
            e.filter.isTimeDependent ? (E(), X("div", tae, [
              oe("div", nae, [
                e.filter.isTimeDependent && e.filter.timePeriods && e.filter.timePeriods.length > 0 ? (E(), fe(jf, {
                  key: 0,
                  ref_key: "selectTimePeriod",
                  ref: u,
                  model: {
                    timePeriods: e.filter.timePeriods,
                    label: e.filter.name,
                    showShortName: !0,
                    selectedTimePeriod: e.filter.selectedTimePeriod
                  },
                  "show-back-link": !0,
                  onPeriodChanged: B,
                  onShow: Y[1] || (Y[1] = (Q) => g.value = !0),
                  onHide: Y[2] || (Y[2] = (Q) => g.value = !1),
                  onOnEscape: x
                }, null, 8, ["model"])) : te("", !0)
              ]),
              e.filter.isTimeDependent ? (E(), fe(No, {
                key: 0,
                ref_key: "deselectButtonTooltipTrigger",
                ref: y,
                class: "flex justify-end items-center grow-1",
                "tracking-model": {
                  eventSource: _(Qe)().pageName,
                  eventComponentName: "Base-Multi-Select",
                  eventTitle: e.filter.name + ": " + _(n)("fundFinder.deselectAll")
                },
                "show-text": !1,
                icon: _(H).TrashAlt,
                onClick: Y[3] || (Y[3] = (Q) => D())
              }, null, 8, ["tracking-model", "icon"])) : te("", !0)
            ])) : (E(), fe(No, {
              key: 0,
              ref_key: "deselectButtonTooltipTrigger",
              ref: y,
              class: "flex justify-end items-center d-base-multi-select__deselect-all",
              "tracking-model": {
                eventSource: _(Qe)().pageName,
                eventComponentName: "Filter-dropdown",
                eventTitle: e.filter.name + ": " + _(n)("fundFinder.deselectAll")
              },
              "show-text": e.showDeselectAllText,
              text: _(n)("fundFinder.deselectAll"),
              icon: _(H).TrashAlt,
              onClick: Y[0] || (Y[0] = (Q) => D())
            }, null, 8, ["tracking-model", "show-text", "text", "icon"]))
          ]),
          filtericon: Se(() => [
            ue(F, {
              "base-icon": _(H).Search,
              "base-icon-size": _(at).S,
              "base-icon-color": _(gt).GreyBlue005
            }, null, 8, ["base-icon", "base-icon-size", "base-icon-color"])
          ]),
          option: Se((Q) => [
            oe("div", {
              class: Pe([
                "d-base-multi-select__item--option flex w-full py-4 content-center justify-between",
                e.filter.filterType === _(Rf).Performance ? "gap-14" : ""
              ])
            }, [
              Q.option.name ? (E(), X("span", {
                key: 0,
                class: Pe([
                  "d-base-multi-select__item--option--name",
                  e.filter.filterType === _(Rf).Performance ? "flex grow-1 justify-end w-full" : ""
                ])
              }, [
                (E(), fe(tt(T(Q.option.name, Q.option.valueType))))
              ], 2)) : te("", !0),
              e.showNumberOfResultsInOptions && Q.option.results !== void 0 ? (E(), X("span", iae, Ie(Q.option.results), 1)) : te("", !0)
            ], 2)
          ]),
          footer: Se(() => [
            e.filter.disclaimer ? (E(), fe(U, {
              key: 0,
              class: "d-base-multi-select__footer",
              text: e.filter.disclaimer,
              "font-type": _(lt).DwsSans,
              "font-size": _(st).FourteenPx,
              "text-color": _(dt).GreyBlue009
            }, null, 8, ["text", "font-type", "font-size", "text-color"])) : te("", !0)
          ]),
          _: 1
        }, 8, ["modelValue", "options", "placeholder", "class", "aria-label", "disabled", "option-disabled", "filter", "filter-placeholder", "pt"])
      ], 40, eae);
    };
  }
});
const oae = /* @__PURE__ */ Fe(aae, [["__scopeId", "data-v-0ffa62f5"]]), rae = { class: "d-base-filter-selectors" }, sae = { key: 0 }, lae = { key: 1 }, cae = { key: 2 }, dae = /* @__PURE__ */ Be({
  __name: "BaseFilterSelectors",
  props: {
    model: {
      type: Object,
      required: !0
    },
    showDeselectAllText: {
      type: Boolean,
      default: !0
    },
    componentNameTrackingMultiSelect: {
      type: String,
      default: ""
    },
    componentNameTrackingTreeSelect: {
      type: String,
      default: ""
    }
  },
  emits: [
    "filter-value-changed",
    "filter-time-period-changed",
    "tree-select-value-changed"
  ],
  setup(e, { emit: t }) {
    const n = e, i = t;
    function o(d, y) {
      y.isSelected = d.length > 0, y.filterOptions[y.identifier].forEach((u) => {
        u.isSelected = d?.some(
          (m) => m.identifier === u.identifier
        );
      }), i("filter-value-changed", d, y);
    }
    const a = (d) => {
      const y = [];
      return d.forEach((u) => {
        if (u.children)
          y.push(...a(u.children));
        else if (u.isSelected) {
          const m = {
            identifier: u.key,
            name: u.label,
            isSelected: u.isSelected
          };
          y.push(m);
        }
      }), y;
    };
    function r(d, y) {
      const u = [];
      d?.forEach((m) => {
        m.children && u.push(...a(m.children));
      }), i("tree-select-value-changed", u, y);
    }
    function s(d, y) {
      y.isSelected = d.isSelected, i("filter-value-changed", d, y);
    }
    function l(d) {
      i("filter-time-period-changed", d);
    }
    return (d, y) => (E(), X("div", rae, [
      (E(!0), X(Re, null, Ge(n.model?.filters, (u) => (E(), X("div", {
        key: u.identifier,
        class: "d-base-filter-section__wrap"
      }, [
        u.selectionType === _(Bc).MultiSelect ? (E(), X("div", sae, [
          ue(oae, {
            filter: {
              name: u.name,
              results: u.results,
              filterOptions: u.filterOptions[u.identifier],
              isSelected: u.isSelected,
              filterType: u.filterType,
              isTimeDependent: u.isTimeDependent,
              disclaimer: u.disclaimer,
              timePeriods: e.model.timePeriods,
              selectedTimePeriod: e.model.selectedTimePeriod,
              isDisabled: u.isDisabled,
              hasSearchField: u.hasSearchField,
              searchFieldPlaceholder: u.searchFieldPlaceholder,
              componentNameForTracking: e.componentNameTrackingMultiSelect
            },
            "show-deselect-all-text": e.showDeselectAllText,
            "show-number-of-results-in-options": u.showNumberOfResultsInOptions,
            "show-number-of-results-in-value": u.showNumberOfResultsInValue,
            onMultiselectValueChanged: (m) => o(m, u),
            onTimePeriodValueChanged: l
          }, null, 8, ["filter", "show-deselect-all-text", "show-number-of-results-in-options", "show-number-of-results-in-value", "onMultiselectValueChanged"])
        ])) : u.selectionType === _(Bc).TreeSelect ? (E(), X("div", lae, [
          ue(uie, {
            model: {
              name: u.name,
              results: u.results,
              options: u.filterOptions[u.identifier],
              isSelected: u.isSelected,
              isDisabled: u.isDisabled,
              componentNameForTracking: e.componentNameTrackingTreeSelect
            },
            "show-number-of-results-in-value": u.showNumberOfResultsInValue,
            onChanged: (m) => r(m, u)
          }, null, 8, ["model", "show-number-of-results-in-value", "onChanged"])
        ])) : (E(), X("div", cae, [
          ue(Iie, {
            filter: {
              name: u.name,
              filterOptions: u.filterOptions[u.identifier],
              results: u.results,
              isSelected: u.isSelected,
              isDisabled: u.isDisabled,
              hasSearchField: u.hasSearchField
            },
            "show-number-of-results-in-options": u.showNumberOfResultsInOptions,
            "show-number-of-results-in-value": u.showNumberOfResultsInValue,
            onSingleSelectValueChanged: (m) => s(m, u)
          }, null, 8, ["filter", "show-number-of-results-in-options", "show-number-of-results-in-value", "onSingleSelectValueChanged"])
        ]))
      ]))), 128))
    ]));
  }
});
const uae = /* @__PURE__ */ Fe(dae, [["__scopeId", "data-v-65fbd061"]]), hae = ["id"], pae = ["aria-labelledby", "aria-expanded", "aria-label", "data-event_source", "onClick", "onKeypress", "onKeydown"], fae = {
  class: "p-dropdown-items p-0",
  role: "listbox"
}, mae = ["id", "data-event_source", "data-event_title", "onKeypress", "onClick"], gae = { class: "d-radio-button__label flex justify-between w-full align-baseline" }, vae = {
  key: 0,
  class: "d-base-single-select__item--name"
}, yae = {
  key: 1,
  class: "d-base-single-select__item--result"
}, bae = /* @__PURE__ */ Be({
  __name: "BaseNonRemovableFilters",
  props: {
    model: {
      type: Array,
      required: !0
    }
  },
  emits: ["singleSelectValueChanged"],
  setup(e, { emit: t }) {
    const { t: n } = Je(), i = ge(!1), o = ge([]), a = ge([]), r = ge([]), s = ge(-1), l = t;
    function d(f) {
      return f.filterOptions[f.identifier].find(
        (S) => S.isSelected
      );
    }
    zc(() => {
      o.value = [], a.value = [], r.value = [];
    });
    const y = (f, S) => {
      o.value[S].toggle(f);
    }, u = () => {
      i.value = !0, s.value = -1;
    }, m = (f) => {
      i.value = !1, a.value[f]?.focus();
    }, h = (f) => {
      Ue && document.getElementById(`${f}`)?.focus();
    }, c = (f) => {
      f.preventDefault(), s.value > 0 && s.value--, s.value < 0 && (s.value = 0), h(s.value);
    }, g = (f) => {
      f.preventDefault(), s.value < r.value.length - 1 && s.value++, h(s.value);
    }, v = (f, S) => {
      i.value && (o.value[S].toggle(f), i.value = !i.value);
    };
    function P(f, S, w) {
      w.showNumberOfResultsInOptions && !f.results || (w.filterOptions[w.identifier].forEach(
        (x) => x.isSelected = !1
      ), f.isSelected = !0, l("singleSelectValueChanged", f), o.value[S].hide(), i.value = !i.value);
    }
    return (f, S) => {
      const w = $e("BaseText"), x = $e("BaseIcon");
      return E(!0), X(Re, null, Ge(e.model, (k, A) => (E(), X("div", {
        key: k.identifier,
        class: "d-base-non-removable-filter flex flex-row items-start flex-wrap gap-2"
      }, [
        k.filterOptions[k.identifier]?.length > 0 && k.selectionType === _(Bc).SingleSelect ? (E(), X("div", {
          key: 0,
          id: `${k.identifier}-filter-label`,
          class: "d-base-non-removable-filter--filter-name flex-shrink-0"
        }, Ie(k.name + ": "), 9, hae)) : te("", !0),
        k.filterOptions[k.identifier]?.length > 0 && k.selectionType === _(Bc).SingleSelect ? (E(), X("div", {
          key: 1,
          ref_for: !0,
          ref: ($) => a.value.push($),
          "aria-labelledby": `${k.identifier}-filter-label`,
          "aria-expanded": i.value,
          role: "combobox",
          tabindex: "0",
          "aria-label": _(n)("baseNonRemovableFilters.edit"),
          class: "d-base-non-removable-filter--option",
          "data-event_source": _(Qe)().pageName,
          "data-event_component_name": "Non-Removable-Filters",
          "data-event_title": "filter.name",
          onClick: ($) => y($, A),
          onKeypress: Ze(($) => y($, A), ["enter"]),
          onKeyup: [
            Ze(c, ["up"]),
            Ze(g, ["down"])
          ],
          onKeydown: [
            Ze(($) => v($, A), ["tab"]),
            Ze(($) => v($, A), ["esc"])
          ]
        }, [
          ue(w, {
            "font-type": _(lt).DwsSansBold,
            "text-color": _(dt).Primary,
            text: d(k)?.name,
            class: "hover:underline"
          }, null, 8, ["font-type", "text-color", "text"]),
          ue(x, {
            "aria-label": _(n)("baseNonRemovableFilters.edit"),
            role: "img",
            "base-icon": _(H).Cog,
            "base-icon-size": _(at).Inherit
          }, null, 8, ["aria-label", "base-icon", "base-icon-size"])
        ], 40, pae)) : te("", !0),
        ue(_(oh), {
          ref_for: !0,
          ref: ($) => o.value[A] = $,
          class: "p-dropdown-panel p-min-width-15 p-overlaypanel-singleselect",
          onShow: u,
          onHide: ($) => m(A)
        }, {
          default: Se(() => [
            oe("ul", fae, [
              (E(!0), X(Re, null, Ge(k.filterOptions[k.identifier], ($, j) => (E(), X("li", {
                key: $.identifier,
                class: Pe([
                  "p-dropdown-item px-0 list-none",
                  k.showNumberOfResultsInOptions && $.results ? "" : "d-base-single-select__item__disabled"
                ])
              }, [
                oe("div", {
                  id: j.toString(),
                  ref_for: !0,
                  ref: (N) => r.value.push(N),
                  class: "d-base-single-select__item flex justify-start w-full align-baseline",
                  "data-event_source": _(Qe)().pageName,
                  "data-event_component_name": "Non-Removable-Filters",
                  "data-event_title": $.name,
                  tabindex: "0",
                  role: "radio",
                  onKeydown: [
                    Ze(c, ["up"]),
                    Ze(g, ["down"])
                  ],
                  onKeypress: [
                    Ze((N) => P(
                      $,
                      A,
                      k
                    ), ["enter"]),
                    Ze((N) => P(
                      $,
                      A,
                      k
                    ), ["space"])
                  ],
                  onClick: (N) => P(
                    $,
                    A,
                    k
                  )
                }, [
                  ue(_(Or), {
                    name: $.name,
                    value: $.identifier,
                    disabled: k.showNumberOfResultsInOptions && ($.results === void 0 || $.results < 1),
                    "input-id": $.identifier,
                    "aria-label": $.name,
                    class: Pe([{
                      "p-radiobutton-checked": $.isSelected
                    }, "d-radio-button"])
                  }, null, 8, ["name", "value", "disabled", "input-id", "aria-label", "class"]),
                  oe("div", gae, [
                    $.name ? (E(), X("span", vae, Ie($.name), 1)) : te("", !0),
                    k.showNumberOfResultsInOptions && $.results ? (E(), X("span", yae, Ie($.results), 1)) : te("", !0)
                  ])
                ], 40, mae)
              ], 2))), 128))
            ])
          ]),
          _: 2
        }, 1032, ["onHide"])
      ]))), 128);
    };
  }
});
const xae = /* @__PURE__ */ Fe(bae, [["__scopeId", "data-v-a90bde02"]]), wae = { class: "d-base-removable-filters" }, kae = {
  key: 0,
  class: "d-base-removable-filters--filters"
}, Sae = { class: "d-base-removable-filters--filter-name" }, Cae = /* @__PURE__ */ Be({
  __name: "BaseRemovableFilters",
  props: {
    model: {
      type: Array,
      required: !0
    }
  },
  emits: ["filter-value-deselected"],
  setup(e, { emit: t }) {
    const { t: n } = Je(), i = e, o = t, a = Te(() => i.model.filter(
      (d) => d.isSelected && l(d).length > 0
    ));
    function r(d, y) {
      o("filter-value-deselected", d, y);
    }
    const s = (d) => {
      const y = [];
      return d.forEach((u) => {
        if (u.children)
          y.push(...s(u.children));
        else if (u.isSelected) {
          const m = {
            identifier: u.key,
            name: u.label,
            isSelected: u.isSelected
          };
          y.push(m);
        }
      }), y;
    }, l = (d) => {
      const y = [];
      return d.filterOptions[d.identifier].forEach(
        (u) => {
          const m = u.children;
          m ? y.push(...s(m)) : u.isSelected && y.push(u);
        }
      ), y;
    };
    return (d, y) => {
      const u = $e("BaseIcon");
      return E(), X("div", wae, [
        (E(!0), X(Re, null, Ge(a.value, (m) => (E(), X(Re, {
          key: m.identifier
        }, [
          m.filterOptions[m.identifier]?.length > 0 && m.isSelected ? (E(), X("div", kae, [
            oe("div", Sae, Ie(m.name), 1),
            (E(!0), X(Re, null, Ge(l(m), (h) => (E(), X("div", {
              key: h.identifier,
              class: "d-base-removable-filters--tags"
            }, [
              ue(Ji, {
                class: "d-base-removable-filters--option items-center",
                "tag-text": h.name,
                "value-type": h.valueType,
                "background-color": _(En).Transparent,
                color: _(mi).Petrol45,
                "is-border-visible": !0,
                "data-event_source": _(Qe)().pageName,
                "data-event_component_name": "base-Removable-filters",
                "data-event_title": m.name + ": " + h.name + " deselected",
                "aria-label": h.name + " " + _(n)("baseRemovableFilters.removeFilter"),
                tabindex: "0",
                role: "button",
                "data-testid": "base-tag-" + h.name,
                onKeypress: Ze((c) => r(m.identifier, h.identifier), ["enter"]),
                onClick: (c) => r(m.identifier, h.identifier)
              }, {
                icon: Se(() => [
                  ue(u, {
                    "base-icon-size": _(at).Inherit,
                    "base-icon": _(H).Times,
                    "base-icon-color": _(gt).Petrol45,
                    "aria-hidden": "true"
                  }, null, 8, ["base-icon-size", "base-icon", "base-icon-color"])
                ]),
                _: 2
              }, 1032, ["tag-text", "value-type", "background-color", "color", "data-event_source", "data-event_title", "aria-label", "data-testid", "onKeypress", "onClick"])
            ]))), 128))
          ])) : te("", !0)
        ], 64))), 128))
      ]);
    };
  }
});
const Tae = /* @__PURE__ */ Fe(Cae, [["__scopeId", "data-v-d2835826"]]), Lae = /* @__PURE__ */ Be({
  __name: "BaseSelectedFilters",
  props: {
    nonRemovableFilters: {
      type: Array,
      required: !1,
      default: () => []
    },
    removableFilters: {
      type: Array,
      required: !0
    }
  },
  emits: ["filter-value-deselected", "filter-value-changed"],
  setup(e, { emit: t }) {
    const n = t;
    function i(a, r) {
      n("filter-value-deselected", a, r);
    }
    function o(a) {
      n("filter-value-changed", a);
    }
    return (a, r) => (E(), X(Re, null, [
      e.nonRemovableFilters?.length > 0 ? (E(), fe(xae, {
        key: 0,
        model: e.nonRemovableFilters,
        onSingleSelectValueChanged: o
      }, null, 8, ["model"])) : te("", !0),
      e.removableFilters?.length > 0 ? (E(), fe(Tae, {
        key: 1,
        model: e.removableFilters,
        onFilterValueDeselected: i
      }, null, 8, ["model"])) : te("", !0)
    ], 64));
  }
}), F0 = /* @__PURE__ */ Be({
  __name: "ShowMoreLessToggle",
  props: {
    trackingModel: {
      type: Object,
      required: !0
    },
    showMoreText: {
      type: String,
      default: "Show more"
    },
    showLessText: {
      type: String,
      default: "Show less"
    }
  },
  emits: ["toggle"],
  setup(e, { emit: t }) {
    const n = e, i = Te(() => a.value ? n.showLessText : n.showMoreText), o = t, a = ge(!1);
    function r() {
      a.value = !a.value, a.value ? o("toggle", !0) : o("toggle", !1);
    }
    return (s, l) => (E(), fe(No, {
      "tracking-model": e.trackingModel,
      text: i.value,
      icon: a.value ? _(H).Minus : _(H).Plus,
      onClick: r
    }, null, 8, ["tracking-model", "text", "icon"]));
  }
}), Iae = { class: "d-base-filter-section" }, Pae = { class: "d-base-filter-section__top-filters" }, Aae = {
  key: 0,
  class: "d-base-filter-section__filter-btns__toggle"
}, _ae = { class: "d-base-filter-section__selected-filters" }, Mae = { class: "d-base-filter-section__filter-btns" }, Oae = {
  key: 0,
  class: "d-base-filter-section__filter-btns__remove"
}, Bae = {
  key: 1,
  class: "d-base-filter-section__filter-btns__toggle"
}, Eae = /* @__PURE__ */ Be({
  __name: "BaseFilterSection",
  props: {
    model: {
      type: Object,
      required: !0
    },
    componentNameTrackingMultiSelect: {
      type: String,
      default: ""
    },
    componentNameTrackingTreeSelect: {
      type: String,
      default: ""
    }
  },
  emits: [
    "filter-value-deselected",
    "filter-value-changed",
    "filter-time-period-changed",
    "tree-select-value-changed",
    "reset-filters"
  ],
  setup(e, { emit: t }) {
    const { t: n } = Je(), { isMobile: i } = xt(), o = e, a = Te(() => {
      const x = [];
      return o.model.topFilters.forEach((k) => {
        x.push(k);
      }), o.model.otherFilters?.forEach((k) => {
        x.push(k);
      }), x;
    }), r = Te(() => {
      const x = [];
      return a.value.forEach((k) => {
        k.isRemovable && x.push(k);
      }), x;
    }), s = Te(() => {
      const x = [];
      return a.value.forEach((k) => {
        k.isRemovable || x.push(k);
      }), x;
    }), l = ge(!1), d = t, y = (x, k) => {
      x?.forEach((A) => {
        if (A.children)
          A.children.forEach(($) => {
            const j = k.find(
              (N) => N.identifier === $.key
            );
            $.isSelected = j ? j.isSelected : !1, $.children && y($.children, k);
          });
        else {
          const $ = k.find(
            (j) => j.identifier === A.key
          );
          A.isSelected = $ ? $.isSelected : !1;
        }
      });
    };
    function u(x, k) {
      a.value.filter((A) => A.identifier === k.identifier).forEach((A) => {
        const $ = A.filterOptions[k.identifier];
        y($, x), A.isSelected = x.length > 0;
      }), d("tree-select-value-changed", x, k);
    }
    const m = (x) => {
      x.forEach((k) => {
        k.isSelected = !1, k.children && m(k.children);
      });
    }, h = (x, k) => {
      x.forEach((A) => {
        A.key === k && (A.isSelected = !1), A.children && h(A.children, k);
      });
    };
    function c(x, k) {
      a.value.filter((A) => A.identifier === x).forEach((A) => {
        A.filterOptions[x].forEach((j) => {
          j.identifier === k && (j.isSelected = !1);
        }), A.filterOptions[x].every(
          (j) => !j.isSelected
        ) && (A.isSelected = !1);
        const $ = A.filterOptions[x];
        h($, k);
      }), d("filter-value-deselected", x, k);
    }
    function g(x, k) {
      a.value.forEach((A) => {
        A.identifier === x.identifier && (A.filterOptions[x.identifier].forEach(
          ($) => {
            $.identifier === x.identifier && ($.isSelected = !$.isSelected);
          }
        ), A.filterOptions[x.identifier].every(
          ($) => !$.isSelected
        ) ? A.isSelected = !1 : A.isSelected = !0);
      }), d("filter-value-changed", x, k);
    }
    function v(x) {
      d("filter-time-period-changed", x);
    }
    function P() {
      a.value.forEach((x) => {
        x.filterOptions[x.identifier].forEach((A) => {
          A.isSelected = !1;
        }), x.isSelected = !1;
        const k = x.filterOptions[x.identifier];
        m(k);
      }), d("reset-filters");
    }
    const f = Te(() => o.model?.componentNameForTracking ? o.model.componentNameForTracking : "Base-Filter-Section"), S = Te(() => o.model?.sourceNameForTracking ? o.model.sourceNameForTracking : "Button"), w = Te(() => l.value ? a.value : o.model.topFilters);
    return (x, k) => (E(), X("div", Iae, [
      oe("div", Pae, [
        ue(uae, {
          model: {
            filters: w.value,
            timePeriods: e.model.timePeriods,
            selectedTimePeriod: e.model.selectedTimePeriod
          },
          "component-name-tracking-multi-select": e.componentNameTrackingMultiSelect,
          "component-name-tracking-tree-select": e.componentNameTrackingTreeSelect,
          onFilterValueChanged: g,
          onFilterTimePeriodChanged: v,
          onTreeSelectValueChanged: u
        }, null, 8, ["model", "component-name-tracking-multi-select", "component-name-tracking-tree-select"])
      ]),
      e.model.otherFilters?.length > 0 && _(i) ? (E(), X("div", Aae, [
        ue(F0, {
          "tracking-model": {
            eventSource: _(Qe)().pageName,
            eventComponentName: f.value,
            eventTitle: "show-other-filters"
          },
          "show-more-text": _(n)("fundFinder.otherFilters"),
          "show-less-text": _(n)("showMoreLessToggle.showLessText"),
          onToggle: k[0] || (k[0] = (A) => l.value = A)
        }, null, 8, ["tracking-model", "show-more-text", "show-less-text"])
      ])) : te("", !0),
      oe("div", _ae, [
        oe("div", {
          class: Pe([
            "d-base-filter-section__selected-filters__tags",
            e.model.otherFilters?.length > 0 && _(i) ? "no-margin" : "margin-y"
          ])
        }, [
          ue(Lae, {
            "removable-filters": r.value,
            "non-removable-filters": s.value,
            onFilterValueChanged: g,
            onFilterValueDeselected: c
          }, null, 8, ["removable-filters", "non-removable-filters"])
        ], 2),
        oe("div", Mae, [
          r.value?.length > 0 ? (E(), X("div", Oae, [
            a.value.find((A) => A.isSelected) ? (E(), fe(No, {
              key: 0,
              id: "d-base-filter-section-reset-filters",
              "tracking-model": {
                eventSource: S.value,
                eventComponentName: f.value,
                eventTitle: "Reset"
              },
              text: _(n)("fundFinder.resetFilters"),
              icon: _(H).TrashAlt,
              "data-testid": "d-base-filter-section-reset-filters",
              onClick: P
            }, null, 8, ["tracking-model", "text", "icon"])) : te("", !0)
          ])) : te("", !0),
          e.model.otherFilters?.length > 0 && !_(i) ? (E(), X("div", Bae, [
            ue(F0, {
              "tracking-model": {
                eventSource: _(Qe)().pageName,
                eventComponentName: f.value,
                eventTitle: "show-other-filters"
              },
              "show-more-text": _(n)("fundFinder.otherFilters"),
              "show-less-text": _(n)("showMoreLessToggle.showLessText"),
              onToggle: k[1] || (k[1] = (A) => l.value = A)
            }, null, 8, ["tracking-model", "show-more-text", "show-less-text"])
          ])) : te("", !0)
        ])
      ])
    ]));
  }
});
const Ec = /* @__PURE__ */ Fe(Eae, [["__scopeId", "data-v-f5d370f6"]]), Dae = { class: "d-base-disclaimer" }, Rae = /* @__PURE__ */ Be({
  __name: "BaseDisclaimer",
  props: {
    text: {
      type: String,
      default: ""
    },
    asOfDate: {
      type: String,
      default: ""
    }
  },
  setup(e) {
    const t = e;
    return (n, i) => (E(), X("div", Dae, [
      t.asOfDate?.length > 0 || t.text?.length > 0 ? (E(), fe(_(ht), {
        key: 0,
        "html-text": `${t.asOfDate || ""}${t.text || ""}`,
        "disable-default-styling": !0
      }, null, 8, ["html-text"])) : te("", !0)
    ]));
  }
});
const Na = /* @__PURE__ */ Fe(Rae, [["__scopeId", "data-v-fa60915e"]]), Nae = {
  key: 0,
  class: "d-page-disclaimer"
}, $ae = { class: "d-page-disclaimer__content" }, Fae = /* @__PURE__ */ Be({
  __name: "PageDisclaimer",
  props: {
    pageDisclaimer: {
      type: String,
      default: ""
    },
    complianceCodes: {
      type: Object,
      default: void 0
    },
    cultureActive: {
      type: String,
      default: "de"
    }
  },
  setup(e) {
    const t = e, n = $t("dayJS"), i = (a, r) => {
      let s = n(r)?.locale(t?.cultureActive)?.format("MM/YYYY");
      return s == "Invalid Date" && (s = r), (a ?? "") + (r != null ? ` (${s})` : "");
    }, o = Te(() => {
      const a = i(
        t?.complianceCodes?.alpsCode,
        t?.complianceCodes?.alpsCodeEndDate
      ), r = i(
        t?.complianceCodes?.crsCode,
        t?.complianceCodes?.crsCodeEndDate
      );
      return r != "" && a != "" ? `${r} / ${a}` : `${r}${a}`;
    });
    return (a, r) => e.pageDisclaimer?.length > 0 || o.value?.length > 0 ? (E(), X("div", Nae, [
      oe("div", $ae, [
        e.pageDisclaimer?.length > 0 ? (E(), fe(Na, {
          key: 0,
          text: e.pageDisclaimer
        }, null, 8, ["text"])) : te("", !0),
        o.value?.length > 0 ? (E(), fe(Na, {
          key: 1,
          text: o.value,
          class: "d-page-disclaimer__crs-alps-codes"
        }, null, 8, ["text"])) : te("", !0)
      ])
    ])) : te("", !0);
  }
});
const jae = /* @__PURE__ */ Fe(Fae, [["__scopeId", "data-v-c4bb3f26"]]), Hae = {
  key: 0,
  class: "d-base-tag-with-text-list"
}, zae = /* @__PURE__ */ Be({
  __name: "BaseTagWithTextList",
  props: {
    model: {
      type: Object,
      required: !0,
      default: void 0
    }
  },
  setup(e) {
    return (t, n) => e.model.tags ? (E(), X("div", Hae, [
      (E(!0), X(Re, null, Ge(e.model.tags, (i, o) => (E(), X(Re, { key: o }, [
        ue(Ji, Ce({
          "tag-text": i.label,
          ref_for: !0
        }, i, {
          color: e.model.color,
          "background-color": _(En).GreyBlue001,
          "is-border-visible": e.model.isBorderVisible
        }), null, 16, ["tag-text", "color", "background-color", "is-border-visible"]),
        oe("div", null, [
          ue(Tt, {
            text: i.description,
            "text-color": e.model.textColor,
            "font-type": e.model.fontType,
            "font-size": e.model.fontSize
          }, null, 8, ["text", "text-color", "font-type", "font-size"])
        ])
      ], 64))), 128))
    ])) : te("", !0);
  }
});
const Vae = /* @__PURE__ */ Fe(zae, [["__scopeId", "data-v-c3d59e13"]]);
var Gae = {}, Uae = {
  name: "BaseTabPanel",
  extends: wt,
  props: {
    header: null,
    headerStyle: null,
    headerClass: null,
    headerProps: null,
    headerActionProps: null,
    contentStyle: null,
    contentClass: null,
    contentProps: null,
    disabled: Boolean
  },
  style: Gae
}, jg = {
  name: "TabPanel",
  extends: Uae
};
function Wae(e, t, n, i, o, a) {
  return je(e.$slots, "default");
}
jg.render = Wae;
var Yae = `
@layer primevue {
    .p-tabview-nav-container {
        position: relative;
    }

    .p-tabview-scrollable .p-tabview-nav-container {
        overflow: hidden;
    }

    .p-tabview-nav-content {
        overflow-x: auto;
        overflow-y: hidden;
        scroll-behavior: smooth;
        scrollbar-width: none;
        overscroll-behavior: contain auto;
    }

    .p-tabview-nav {
        display: flex;
        margin: 0;
        padding: 0;
        list-style-type: none;
        flex: 1 1 auto;
    }

    .p-tabview-header-action {
        cursor: pointer;
        user-select: none;
        display: flex;
        align-items: center;
        position: relative;
        text-decoration: none;
        overflow: hidden;
    }

    .p-tabview-ink-bar {
        display: none;
        z-index: 1;
    }

    .p-tabview-header-action:focus {
        z-index: 1;
    }

    .p-tabview-title {
        line-height: 1;
        white-space: nowrap;
    }

    .p-tabview-nav-btn {
        position: absolute;
        top: 0;
        z-index: 2;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .p-tabview-nav-prev {
        left: 0;
    }

    .p-tabview-nav-next {
        right: 0;
    }

    .p-tabview-nav-content::-webkit-scrollbar {
        display: none;
    }
}
`, qae = {
  root: function(t) {
    var n = t.props;
    return ["p-tabview p-component", {
      "p-tabview-scrollable": n.scrollable
    }];
  },
  navContainer: "p-tabview-nav-container",
  previousButton: "p-tabview-nav-prev p-tabview-nav-btn p-link",
  navContent: "p-tabview-nav-content",
  nav: "p-tabview-nav",
  tab: {
    header: function(t) {
      var n = t.instance, i = t.tab, o = t.index;
      return ["p-tabview-header", n.getTabProp(i, "headerClass"), {
        "p-highlight": n.d_activeIndex === o,
        "p-disabled": n.getTabProp(i, "disabled")
      }];
    },
    headerAction: "p-tabview-nav-link p-tabview-header-action",
    headerTitle: "p-tabview-title",
    content: function(t) {
      var n = t.instance, i = t.tab;
      return ["p-tabview-panel", n.getTabProp(i, "contentClass")];
    }
  },
  inkbar: "p-tabview-ink-bar",
  nextButton: "p-tabview-nav-next p-tabview-nav-btn p-link",
  panelContainer: "p-tabview-panels"
}, Kae = Wt.extend({
  name: "tabview",
  css: Yae,
  classes: qae
}), Xae = {
  name: "BaseTabView",
  extends: wt,
  props: {
    activeIndex: {
      type: Number,
      default: 0
    },
    lazy: {
      type: Boolean,
      default: !1
    },
    scrollable: {
      type: Boolean,
      default: !1
    },
    tabindex: {
      type: Number,
      default: 0
    },
    selectOnFocus: {
      type: Boolean,
      default: !1
    },
    previousButtonProps: {
      type: null,
      default: null
    },
    nextButtonProps: {
      type: null,
      default: null
    },
    prevIcon: {
      type: String,
      default: void 0
    },
    nextIcon: {
      type: String,
      default: void 0
    }
  },
  style: Kae,
  provide: function() {
    return {
      $parentInstance: this
    };
  }
}, Hg = {
  name: "TabView",
  extends: Xae,
  emits: ["update:activeIndex", "tab-change", "tab-click"],
  data: function() {
    return {
      id: this.$attrs.id,
      d_activeIndex: this.activeIndex,
      isPrevButtonDisabled: !0,
      isNextButtonDisabled: !1
    };
  },
  watch: {
    "$attrs.id": function(t) {
      this.id = t || Mt();
    },
    activeIndex: function(t) {
      this.d_activeIndex = t, this.scrollInView({
        index: t
      });
    }
  },
  mounted: function() {
    this.id = this.id || Mt(), this.updateInkBar(), this.scrollable && this.updateButtonState();
  },
  updated: function() {
    this.updateInkBar();
  },
  methods: {
    isTabPanel: function(t) {
      return t.type.name === "TabPanel";
    },
    isTabActive: function(t) {
      return this.d_activeIndex === t;
    },
    getTabProp: function(t, n) {
      return t.props ? t.props[n] : void 0;
    },
    getKey: function(t, n) {
      return this.getTabProp(t, "header") || n;
    },
    getTabHeaderActionId: function(t) {
      return "".concat(this.id, "_").concat(t, "_header_action");
    },
    getTabContentId: function(t) {
      return "".concat(this.id, "_").concat(t, "_content");
    },
    getTabPT: function(t, n, i) {
      var o = this.tabs.length, a = {
        props: t.props,
        parent: {
          instance: this,
          props: this.$props,
          state: this.$data
        },
        context: {
          index: i,
          count: o,
          first: i === 0,
          last: i === o - 1,
          active: this.isTabActive(i)
        }
      };
      return Ce(this.ptm("tab.".concat(n), {
        tab: a
      }), this.ptm("tabpanel.".concat(n), {
        tabpanel: a
      }), this.ptm("tabpanel.".concat(n), a), this.ptmo(this.getTabProp(t, "pt"), n, a));
    },
    onScroll: function(t) {
      this.scrollable && this.updateButtonState(), t.preventDefault();
    },
    onPrevButtonClick: function() {
      var t = this.$refs.content, n = Oe.getWidth(t), i = t.scrollLeft - n;
      t.scrollLeft = i <= 0 ? 0 : i;
    },
    onNextButtonClick: function() {
      var t = this.$refs.content, n = Oe.getWidth(t) - this.getVisibleButtonWidths(), i = t.scrollLeft + n, o = t.scrollWidth - n;
      t.scrollLeft = i >= o ? o : i;
    },
    onTabClick: function(t, n, i) {
      this.changeActiveIndex(t, n, i), this.$emit("tab-click", {
        originalEvent: t,
        index: i
      });
    },
    onTabKeyDown: function(t, n, i) {
      switch (t.code) {
        case "ArrowLeft":
          this.onTabArrowLeftKey(t);
          break;
        case "ArrowRight":
          this.onTabArrowRightKey(t);
          break;
        case "Home":
          this.onTabHomeKey(t);
          break;
        case "End":
          this.onTabEndKey(t);
          break;
        case "PageDown":
          this.onPageDownKey(t);
          break;
        case "PageUp":
          this.onPageUpKey(t);
          break;
        case "Enter":
        case "NumpadEnter":
        case "Space":
          this.onTabEnterKey(t, n, i);
          break;
      }
    },
    onTabArrowRightKey: function(t) {
      var n = this.findNextHeaderAction(t.target.parentElement);
      n ? this.changeFocusedTab(t, n) : this.onTabHomeKey(t), t.preventDefault();
    },
    onTabArrowLeftKey: function(t) {
      var n = this.findPrevHeaderAction(t.target.parentElement);
      n ? this.changeFocusedTab(t, n) : this.onTabEndKey(t), t.preventDefault();
    },
    onTabHomeKey: function(t) {
      var n = this.findFirstHeaderAction();
      this.changeFocusedTab(t, n), t.preventDefault();
    },
    onTabEndKey: function(t) {
      var n = this.findLastHeaderAction();
      this.changeFocusedTab(t, n), t.preventDefault();
    },
    onPageDownKey: function(t) {
      this.scrollInView({
        index: this.$refs.nav.children.length - 2
      }), t.preventDefault();
    },
    onPageUpKey: function(t) {
      this.scrollInView({
        index: 0
      }), t.preventDefault();
    },
    onTabEnterKey: function(t, n, i) {
      this.changeActiveIndex(t, n, i), t.preventDefault();
    },
    findNextHeaderAction: function(t) {
      var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, i = n ? t : t.nextElementSibling;
      return i ? Oe.getAttribute(i, "data-p-disabled") || Oe.getAttribute(i, "data-pc-section") === "inkbar" ? this.findNextHeaderAction(i) : Oe.findSingle(i, '[data-pc-section="headeraction"]') : null;
    },
    findPrevHeaderAction: function(t) {
      var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, i = n ? t : t.previousElementSibling;
      return i ? Oe.getAttribute(i, "data-p-disabled") || Oe.getAttribute(i, "data-pc-section") === "inkbar" ? this.findPrevHeaderAction(i) : Oe.findSingle(i, '[data-pc-section="headeraction"]') : null;
    },
    findFirstHeaderAction: function() {
      return this.findNextHeaderAction(this.$refs.nav.firstElementChild, !0);
    },
    findLastHeaderAction: function() {
      return this.findPrevHeaderAction(this.$refs.nav.lastElementChild, !0);
    },
    changeActiveIndex: function(t, n, i) {
      !this.getTabProp(n, "disabled") && this.d_activeIndex !== i && (this.d_activeIndex = i, this.$emit("update:activeIndex", i), this.$emit("tab-change", {
        originalEvent: t,
        index: i
      }), this.scrollInView({
        index: i
      }));
    },
    changeFocusedTab: function(t, n) {
      if (n && (Oe.focus(n), this.scrollInView({
        element: n
      }), this.selectOnFocus)) {
        var i = parseInt(n.parentElement.dataset.index, 10), o = this.tabs[i];
        this.changeActiveIndex(t, o, i);
      }
    },
    scrollInView: function(t) {
      var n = t.element, i = t.index, o = i === void 0 ? -1 : i, a = n || this.$refs.nav.children[o];
      a && a.scrollIntoView && a.scrollIntoView({
        block: "nearest"
      });
    },
    updateInkBar: function() {
      var t = this.$refs.nav.children[this.d_activeIndex];
      this.$refs.inkbar.style.width = Oe.getWidth(t) + "px", this.$refs.inkbar.style.left = Oe.getOffset(t).left - Oe.getOffset(this.$refs.nav).left + "px";
    },
    updateButtonState: function() {
      var t = this.$refs.content, n = t.scrollLeft, i = t.scrollWidth, o = Oe.getWidth(t);
      this.isPrevButtonDisabled = n === 0, this.isNextButtonDisabled = parseInt(n) === i - o;
    },
    getVisibleButtonWidths: function() {
      var t = this.$refs, n = t.prevBtn, i = t.nextBtn;
      return [n, i].reduce(function(o, a) {
        return a ? o + Oe.getWidth(a) : o;
      }, 0);
    }
  },
  computed: {
    tabs: function() {
      var t = this;
      return this.$slots.default().reduce(function(n, i) {
        return t.isTabPanel(i) ? n.push(i) : i.children && i.children instanceof Array && i.children.forEach(function(o) {
          t.isTabPanel(o) && n.push(o);
        }), n;
      }, []);
    },
    prevButtonAriaLabel: function() {
      return this.$primevue.config.locale.aria ? this.$primevue.config.locale.aria.previous : void 0;
    },
    nextButtonAriaLabel: function() {
      return this.$primevue.config.locale.aria ? this.$primevue.config.locale.aria.next : void 0;
    }
  },
  directives: {
    ripple: An
  },
  components: {
    ChevronLeftIcon: th,
    ChevronRightIcon: Fo
  }
};
function Dc(e) {
  "@babel/helpers - typeof";
  return Dc = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Dc(e);
}
function j0(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    t && (i = i.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), n.push.apply(n, i);
  }
  return n;
}
function Ni(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? j0(Object(n), !0).forEach(function(i) {
      Zae(e, i, n[i]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : j0(Object(n)).forEach(function(i) {
      Object.defineProperty(e, i, Object.getOwnPropertyDescriptor(n, i));
    });
  }
  return e;
}
function Zae(e, t, n) {
  return t = Jae(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function Jae(e) {
  var t = Qae(e, "string");
  return Dc(t) == "symbol" ? t : String(t);
}
function Qae(e, t) {
  if (Dc(e) != "object" || !e)
    return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var i = n.call(e, t || "default");
    if (Dc(i) != "object")
      return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var eoe = ["tabindex", "aria-label"], toe = ["data-p-highlight", "data-p-disabled", "data-pc-index", "data-p-active"], noe = ["id", "tabindex", "aria-disabled", "aria-selected", "aria-controls", "onClick", "onKeydown"], ioe = ["tabindex", "aria-label"], aoe = ["id", "aria-labelledby", "data-pc-index", "data-p-active"];
function ooe(e, t, n, i, o, a) {
  var r = Ut("ripple");
  return E(), X("div", Ce({
    class: e.cx("root")
  }, e.ptm("root"), {
    "data-pc-name": "tabview"
  }), [oe("div", Ce({
    class: e.cx("navContainer")
  }, e.ptm("navContainer")), [e.scrollable && !o.isPrevButtonDisabled ? rt((E(), X("button", Ce({
    key: 0,
    ref: "prevBtn",
    type: "button",
    class: e.cx("previousButton"),
    tabindex: e.tabindex,
    "aria-label": a.prevButtonAriaLabel,
    onClick: t[0] || (t[0] = function() {
      return a.onPrevButtonClick && a.onPrevButtonClick.apply(a, arguments);
    })
  }, Ni(Ni({}, e.previousButtonProps), e.ptm("previousButton")), {
    "data-pc-group-section": "navbutton"
  }), [je(e.$slots, "previcon", {}, function() {
    return [(E(), fe(tt(e.prevIcon ? "span" : "ChevronLeftIcon"), Ce({
      "aria-hidden": "true",
      class: e.prevIcon
    }, e.ptm("previousIcon")), null, 16, ["class"]))];
  })], 16, eoe)), [[r]]) : te("", !0), oe("div", Ce({
    ref: "content",
    class: e.cx("navContent"),
    onScroll: t[1] || (t[1] = function() {
      return a.onScroll && a.onScroll.apply(a, arguments);
    })
  }, e.ptm("navContent")), [oe("ul", Ce({
    ref: "nav",
    class: e.cx("nav"),
    role: "tablist"
  }, e.ptm("nav")), [(E(!0), X(Re, null, Ge(a.tabs, function(s, l) {
    return E(), X("li", Ce({
      key: a.getKey(s, l),
      style: a.getTabProp(s, "headerStyle"),
      class: e.cx("tab.header", {
        tab: s,
        index: l
      }),
      role: "presentation"
    }, Ni(Ni(Ni({}, a.getTabProp(s, "headerProps")), a.getTabPT(s, "root", l)), a.getTabPT(s, "header", l)), {
      "data-pc-name": "tabpanel",
      "data-p-highlight": o.d_activeIndex === l,
      "data-p-disabled": a.getTabProp(s, "disabled"),
      "data-pc-index": l,
      "data-p-active": o.d_activeIndex === l
    }), [rt((E(), X("a", Ce({
      id: a.getTabHeaderActionId(l),
      class: e.cx("tab.headerAction"),
      tabindex: a.getTabProp(s, "disabled") || !a.isTabActive(l) ? -1 : e.tabindex,
      role: "tab",
      "aria-disabled": a.getTabProp(s, "disabled"),
      "aria-selected": a.isTabActive(l),
      "aria-controls": a.getTabContentId(l),
      onClick: function(y) {
        return a.onTabClick(y, s, l);
      },
      onKeydown: function(y) {
        return a.onTabKeyDown(y, s, l);
      }
    }, Ni(Ni({}, a.getTabProp(s, "headerActionProps")), a.getTabPT(s, "headerAction", l))), [s.props && s.props.header ? (E(), X("span", Ce({
      key: 0,
      class: e.cx("tab.headerTitle")
    }, a.getTabPT(s, "headerTitle", l)), Ie(s.props.header), 17)) : te("", !0), s.children && s.children.header ? (E(), fe(tt(s.children.header), {
      key: 1
    })) : te("", !0)], 16, noe)), [[r]])], 16, toe);
  }), 128)), oe("li", Ce({
    ref: "inkbar",
    class: e.cx("inkbar"),
    role: "presentation",
    "aria-hidden": "true"
  }, e.ptm("inkbar")), null, 16)], 16)], 16), e.scrollable && !o.isNextButtonDisabled ? rt((E(), X("button", Ce({
    key: 1,
    ref: "nextBtn",
    type: "button",
    class: e.cx("nextButton"),
    tabindex: e.tabindex,
    "aria-label": a.nextButtonAriaLabel,
    onClick: t[2] || (t[2] = function() {
      return a.onNextButtonClick && a.onNextButtonClick.apply(a, arguments);
    })
  }, Ni(Ni({}, e.nextButtonProps), e.ptm("nextButton")), {
    "data-pc-group-section": "navbutton"
  }), [je(e.$slots, "nexticon", {}, function() {
    return [(E(), fe(tt(e.nextIcon ? "span" : "ChevronRightIcon"), Ce({
      "aria-hidden": "true",
      class: e.nextIcon
    }, e.ptm("nextIcon")), null, 16, ["class"]))];
  })], 16, ioe)), [[r]]) : te("", !0)], 16), oe("div", Ce({
    class: e.cx("panelContainer")
  }, e.ptm("panelContainer")), [(E(!0), X(Re, null, Ge(a.tabs, function(s, l) {
    return E(), X(Re, {
      key: a.getKey(s, l)
    }, [!e.lazy || a.isTabActive(l) ? rt((E(), X("div", Ce({
      key: 0,
      id: a.getTabContentId(l),
      style: a.getTabProp(s, "contentStyle"),
      class: e.cx("tab.content", {
        tab: s
      }),
      role: "tabpanel",
      "aria-labelledby": a.getTabHeaderActionId(l)
    }, Ni(Ni(Ni({}, a.getTabProp(s, "contentProps")), a.getTabPT(s, "root", l)), a.getTabPT(s, "content", l)), {
      "data-pc-name": "tabpanel",
      "data-pc-index": l,
      "data-p-active": o.d_activeIndex === l
    }), [(E(), fe(tt(s)))], 16, aoe)), [[xn, e.lazy ? !0 : a.isTabActive(l)]]) : te("", !0)], 64);
  }), 128))], 16)], 16);
}
Hg.render = ooe;
const roe = {
  key: 0,
  class: "d-base-single-select-button-bar"
}, soe = {
  key: 0,
  class: "d-base-single-select-button-bar__tabs"
}, loe = { class: "d-tab-container-border" }, coe = {
  key: 1,
  class: "d-base-single-select-button-bar__select"
}, doe = /* @__PURE__ */ Be({
  __name: "BaseSingleSelectButtonBar",
  props: {
    filter: {
      type: Object,
      required: !0
    },
    showTabsWithNoResults: {
      type: Boolean,
      default: !1
    },
    eventComponentName: {
      type: String,
      default: "tab"
    },
    dataEventSource: {
      type: String,
      default: "BaseSingleSelectButtonBar"
    }
  },
  emits: ["singleSelectValueChanged"],
  setup(e, { emit: t }) {
    const n = t, i = e, { isDesktopAsync: o } = xt(), a = ge(), r = ge(), s = ge([]), l = ge(
      i.filter.filterOptions?.findIndex((w) => w.isSelected === !0)
    ), d = ge(i.filter.filterOptions[l.value]);
    it(() => {
      s.value = g(), r.value = s.value[l.value], u();
    });
    const y = (w, x) => {
      w.isDisabled || (w.isSelected = !0, d.value = w, s.value.forEach((k) => k.isSelected = !1), s.value[x].isSelected = !0, u(), n("singleSelectValueChanged", w, x));
    }, u = async () => {
      await mt(), Ue && a.value?.$el?.querySelector('a[aria-selected="true"]')?.setAttribute("tabindex", "-1");
    }, m = (w) => {
      const x = i.filter.filterOptions[w.index];
      y(x, w.index);
    }, h = (w) => {
      const x = i.filter.filterOptions.findIndex(
        (A) => A.identifier === w.value
      ), k = i.filter.filterOptions[x];
      y(k, x);
    };
    qe(
      () => i.filter.filterOptions,
      (w) => {
        w && (l.value = w.findIndex(
          (x) => x.isSelected === !0
        ), d.value = w[l.value], s.value = g());
      }
    ), qe(
      () => l.value,
      (w) => {
        r.value = s.value[w], d.value = i.filter.filterOptions[w];
      }
    );
    const c = (w) => w.results && w.results > 0 ? `${w.name} (${w.results})` : w.name, g = () => i.filter.filterOptions.map((w) => ({
      name: c(w),
      value: w.identifier,
      isSelected: w.isSelected,
      isDisabled: w.isDisabled
    })), v = () => {
      let w = null;
      return i.filter.filterOptions.forEach((x) => {
        x.results && x.results > 0 && !w && (w = x);
      }), w;
    }, P = () => {
      let w = null;
      for (let x = i.filter.filterOptions.length - 1; x >= 0; x--)
        i.filter.filterOptions[x].results && i.filter.filterOptions[x].results > 0 && !w && (w = i.filter.filterOptions[x]);
      return w;
    }, f = (w) => {
      if (i.showTabsWithNoResults) {
        if (w === i.filter.filterOptions[0])
          return "first-tab";
        if (w === i.filter.filterOptions[i.filter.filterOptions.length - 1])
          return "last-tab";
      } else {
        if (w === v())
          return "first-tab";
        if (w === P())
          return "last-tab";
      }
      return "";
    }, S = (w) => d?.value?.identifier == w.identifier;
    return (w, x) => i ? (E(), X("div", roe, [
      _(o) ? (E(), X("div", soe, [
        ue(_(Hg), {
          ref_key: "tabView",
          ref: a,
          activeIndex: l.value,
          "onUpdate:activeIndex": x[0] || (x[0] = (k) => l.value = k),
          scrollable: "",
          onTabChange: m
        }, {
          default: Se(() => [
            (E(!0), X(Re, null, Ge(e.filter.filterOptions, (k) => (E(), fe(_(jg), {
              key: k.identifier,
              pt: {
                root: {
                  class: f(k)
                }
              }
            }, {
              header: Se(() => [
                oe("div", loe, [
                  k.results > 0 || e.showTabsWithNoResults ? (E(), fe(_(ki), {
                    key: 0,
                    label: c(k),
                    disabled: k.isDisabled,
                    class: Pe(["p-button-rounded", {
                      "active-tab": S(k)
                    }]),
                    "data-event_source": e.dataEventSource,
                    "data-event_component_name": e.eventComponentName,
                    "data-event_title": k.name
                  }, null, 8, ["label", "disabled", "class", "data-event_source", "data-event_component_name", "data-event_title"])) : te("", !0)
                ])
              ]),
              _: 2
            }, 1032, ["pt"]))), 128))
          ]),
          _: 1
        }, 8, ["activeIndex"])
      ])) : (E(), X("div", coe, [
        ue(vi, {
          items: s.value,
          selected: r.value,
          "data-event_source": e.dataEventSource,
          "data-event_component_name": e.eventComponentName,
          onSelectedItemChanged: h
        }, null, 8, ["items", "selected", "data-event_source", "data-event_component_name"])
      ]))
    ])) : te("", !0);
  }
});
const Ah = /* @__PURE__ */ Fe(doe, [["__scopeId", "data-v-83e2ed35"]]);
function uoe(e) {
  const t = [];
  let n = 1;
  return e.replace(
    /{{\s*tooltip\s+overlayType:\s*"(.*?)"\s+title:\s*"(.*?)"\s+content:\s*"(.*?)"\s*}}/g,
    (o, a, r, s, l) => (s === void 0 && (s = r), r === void 0 && (r = s), a === "tooltip" ? a = ms.Tooltip : a = ms.InfoOverlay, t.push({
      id: n++,
      position: l,
      overlayType: a,
      title: r,
      content: s
    }), "")
  ), e.replace(
    /{{(.*?)}}/g,
    (o, a, r) => {
      const s = t.find((l) => l.position === r);
      return `
          <tippy theme="${rf(a, s?.overlayType)}"
                  maxWidth="440"
                  placement="bottom">
            <span class="dynamic-overlay">${s?.title} </span> 
            <template #content>
                <BaseOverlay :title="'${s?.title}'" 
                             :content="'${s?.content}'" 
                             overlayType="${s?.overlayType}"
                />
            </template>
          </tippy>`;
    }
  );
}
const LBe = Be({
  name: "DynamicOverlayRenderer",
  props: {
    html: {
      type: String,
      default: ""
    },
    purify: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const t = uoe(e.html);
    return e.purify ? Ia.isSupported ? () => At(mr(Ia.sanitize(t))) : () => At(mr(t)) : () => At(mr(t));
  }
}), hoe = {
  key: 0,
  class: "d-base-result-number",
  role: "status",
  "aria-label": "polite"
}, poe = /* @__PURE__ */ Be({
  __name: "BaseResultNumber",
  props: {
    results: {
      type: Number,
      default: 0
    },
    numberOfResultText: {
      type: Object,
      required: !0
    }
  },
  setup(e) {
    const t = e, n = Te(() => t.results === 1 ? t.numberOfResultText.oneResultText : t.numberOfResultText.multipleResultsText);
    return (i, o) => e.results || e.results === 0 ? (E(), X("div", hoe, [
      ue(Ot, {
        "base-heading-type": _(ze).H2Section
      }, {
        default: Se(() => [
          Ve(Ie(e.results + " " + n.value), 1)
        ]),
        _: 1
      }, 8, ["base-heading-type"])
    ])) : te("", !0);
  }
});
const _h = /* @__PURE__ */ Fe(poe, [["__scopeId", "data-v-05f9e81f"]]), foe = { class: "d-base-result-view" }, moe = { class: "d-base-result-view__header" }, goe = {
  key: 1,
  class: "d-base-result-view__header-slot"
}, voe = {
  key: 0,
  class: "d-base-result-view__list"
}, yoe = {
  key: 1,
  class: "d-base-result-view__grid"
}, boe = /* @__PURE__ */ Be({
  __name: "BaseResultView",
  props: {
    results: {
      type: Number,
      default: 0
    },
    numberOfResultText: {
      type: Object,
      required: !0
    },
    showGridFirst: {
      type: Boolean,
      default: !1
    },
    hideButtons: {
      type: Boolean,
      default: !1
    },
    hideNumberOfResults: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["viewChanged"],
  setup(e, { emit: t }) {
    const n = e, { t: i } = Je(), o = Jt(), a = (c) => !!o[c], r = ge(Qe().pageName), s = Te(() => n.showGridFirst), l = ge(!s.value), d = t, y = () => {
      l.value = !l.value, d("viewChanged", l.value);
    }, u = Te(() => l.value ? Ke.RoundedSecondary : Ke.RoundedPrimary), m = Te(() => l.value ? Ke.RoundedPrimary : Ke.RoundedSecondary), h = (c) => ({
      contentUrl: "",
      title: c,
      isLocked: !1,
      target: "",
      isExternal: !1,
      linkType: yt.Javascript,
      tealiumTrackingModel: {
        eventComponentName: "BaseResultView",
        eventTitle: c,
        eventSource: r.value
      }
    });
    return (c, g) => (E(), X("div", foe, [
      oe("div", moe, [
        e.hideNumberOfResults ? te("", !0) : (E(), fe(_h, {
          key: 0,
          results: e.results,
          "number-of-result-text": e.numberOfResultText
        }, null, 8, ["results", "number-of-result-text"])),
        a("header") ? (E(), X("div", goe, [
          je(c.$slots, "header", {}, void 0, !0)
        ])) : te("", !0),
        e.hideButtons ? te("", !0) : (E(), fe(Nt, {
          key: 2,
          type: u.value,
          size: _(et).Medium,
          "link-model": h(_(i)("baseResultView.gridViewTitle")),
          icon: _(H).GripHorizontal,
          class: Pe({
            "ml-2": a("header"),
            "ml-auto": !a("header")
          }),
          onClick: g[0] || (g[0] = (v) => y())
        }, null, 8, ["type", "size", "link-model", "icon", "class"])),
        e.hideButtons ? te("", !0) : (E(), fe(Nt, {
          key: 3,
          type: m.value,
          size: _(et).Medium,
          "link-model": h(_(i)("baseResultView.listViewTitle")),
          icon: _(H).List,
          class: "ml-1",
          onClick: g[1] || (g[1] = (v) => y())
        }, null, 8, ["type", "size", "link-model", "icon"]))
      ]),
      a("list") && l.value ? (E(), X("div", voe, [
        je(c.$slots, "list", {}, void 0, !0)
      ])) : te("", !0),
      a("grid") && !l.value ? (E(), X("div", yoe, [
        je(c.$slots, "grid", {}, void 0, !0)
      ])) : te("", !0)
    ]));
  }
});
const aT = /* @__PURE__ */ Fe(boe, [["__scopeId", "data-v-b2bcd013"]]), xoe = {
  key: 0,
  class: "d-base-search-box"
}, woe = {
  key: 1,
  class: "d-base-search-box__filter"
}, koe = {
  key: 0,
  class: "d-base-search-box__filter-links"
}, Soe = {
  key: 1,
  class: "d-base-search-box__filter-buttons"
}, Coe = "{searchTerm}", Toe = /* @__PURE__ */ Be({
  __name: "BaseSearchBox",
  props: {
    model: {
      type: Object,
      required: !0
    },
    result: {
      type: Object,
      default: null
    },
    minLength: {
      type: Number,
      default: 3
    },
    trackingDropdownName: {
      type: String,
      default: "BaseSearchBox"
    },
    isSuppressOpenNewWindowOnEnter: {
      type: Boolean,
      default: !1
    },
    useCustomClicks: {
      type: Boolean,
      default: !1
    },
    debounceInterval: {
      type: Number,
      default: 300
    },
    blockEmptyEnterSearch: {
      type: Boolean
    },
    eventComponentName: {
      type: String,
      default: "search"
    },
    labelFor: {
      type: String,
      default: void 0
    },
    liveSearch: {
      type: Boolean,
      default: !1
    },
    focusInputWithInitTerm: {
      type: Boolean,
      default: !1
    },
    isFundFinder: {
      type: Boolean,
      default: !1
    }
  },
  emits: [
    "search",
    "clear",
    "filterChanged",
    "blur",
    "focus",
    "enter",
    "onButtonClick",
    "showSuggestions"
  ],
  setup(e, { expose: t, emit: n }) {
    const i = e, o = n, { isMobileAsync: a } = xt(), r = ge(i.model.searchTerm), s = ge(), l = (w) => {
      o("showSuggestions", w);
    }, d = (w) => {
      r.value = w, o("clear", w);
    }, y = (w) => {
      r.value = w, o("blur", w);
    }, u = (w) => {
      o("focus", w);
    }, m = (w) => {
      w?.length >= i.minLength && (r.value = w, o("search", w));
    }, h = (w) => {
      On(i.eventComponentName, w), !i.isSuppressOpenNewWindowOnEnter && i.result?.allResultsLink?.href && w && Ue && window.open(
        i.result.allResultsLink.href.replace(Coe, w),
        i.result.allResultsLink.target
      ), r.value = w, P(), o("enter", w);
    }, c = (w, x) => {
      Ue && x && !i.useCustomClicks && (window.open(x.href, x.target), w.preventDefault()), o("onButtonClick", w, x);
    }, g = (w) => {
      o("filterChanged", w, r.value);
    };
    qe(
      () => i.model.searchTerm,
      (w) => {
        r.value = w;
      },
      { immediate: !0, deep: !0 }
    );
    const v = () => {
      s.value?.showSuggestionPanel();
    }, P = () => {
      s.value?.hideSuggestionPanel();
    };
    t({
      showSuggestionPanel: v,
      hideSuggestionPanel: P
    });
    const f = Jt(), S = (w) => !!f[w];
    return (w, x) => e.model ? (E(), X("div", xoe, [
      e.model.headline?.length > 0 ? (E(), fe(Ot, {
        key: 0,
        "base-heading-type": _(ze).H2
      }, {
        default: Se(() => [
          Ve(Ie(e.model.headline), 1)
        ]),
        _: 1
      }, 8, ["base-heading-type"])) : te("", !0),
      ue(kh, {
        ref_key: "searchBarRef",
        ref: s,
        model: e.model,
        result: e.result,
        "is-suppress-open-new-window-on-enter": e.isSuppressOpenNewWindowOnEnter,
        "min-length": e.minLength,
        "filter-options": e.model.filterOptions,
        "debounce-interval": e.debounceInterval,
        "block-empty-enter-search": e.blockEmptyEnterSearch,
        "label-for": e.labelFor,
        "use-custom-clicks": !0,
        "live-search": e.liveSearch,
        "focus-input-with-init-term": e.focusInputWithInitTerm,
        "is-fund-finder": e.isFundFinder,
        onBlur: y,
        onFocus: u,
        onEnter: h,
        onSubmit: h,
        onClear: d,
        onSearch: m,
        onFilterChanged: g,
        onShowSuggestions: l,
        onOnButtonClick: h
      }, Qt({ _: 2 }, [
        S("record") ? {
          name: "record",
          fn: Se((k) => [
            je(w.$slots, "record", { record: k }, void 0, !0)
          ]),
          key: "0"
        } : void 0
      ]), 1032, ["model", "result", "is-suppress-open-new-window-on-enter", "min-length", "filter-options", "debounce-interval", "block-empty-enter-search", "label-for", "live-search", "focus-input-with-init-term", "is-fund-finder"]),
      e.result?.resultLinks && e.result.resultLinks.length > 0 ? (E(), X("div", woe, [
        _(a) ? (E(), X("div", koe, [
          (E(!0), X(Re, null, Ge(e.result.resultLinks, (k, A) => (E(), fe(ot, {
            key: A,
            "link-model": k,
            icon: _(H).ArrowRight,
            "icon-position": _(ct).Left,
            class: Pe(["d-base-search-box__search-text", {
              "d-base-search-box__search-button--hide": r.value && r.value.length > 0
            }]),
            onClick: ($) => c($, k)
          }, null, 8, ["link-model", "icon", "icon-position", "class", "onClick"]))), 128))
        ])) : (E(), X("div", Soe, [
          (E(!0), X(Re, null, Ge(e.result.resultLinks, (k, A) => (E(), fe(vt, {
            key: A,
            "link-model": k,
            role: "link",
            type: _(Ke).Primary,
            size: _(et).Large,
            class: Pe(["d-base-search-box__search-button", {
              "d-base-search-box__search-button--hide": r.value && r.value.length > 0
            }]),
            onClick: ($) => c($, k)
          }, null, 8, ["link-model", "type", "size", "class", "onClick"]))), 128))
        ]))
      ])) : te("", !0)
    ])) : te("", !0);
  }
});
const Wo = /* @__PURE__ */ Fe(Toe, [["__scopeId", "data-v-f7770161"]]);
var ji = /* @__PURE__ */ ((e) => (e.Full = "full", e.Half = "half", e.OneThird = "one-third", e))(ji || {});
const Loe = { class: "d-layout-item" }, pa = /* @__PURE__ */ Be({
  __name: "LayoutItem",
  props: {
    order: {
      type: Number,
      default: 0
    }
  },
  setup(e) {
    return (t, n) => (E(), X("div", Loe, [
      je(t.$slots, "default")
    ]));
  }
}), oT = () => {
  const e = Jt(), t = Te(() => (e?.default ? e.default() : null)?.reduce(
    (a, r) => (n(r) ? a.push(r) : r?.children && r?.children instanceof Array && r?.children.forEach((s) => {
      n(s) && a.push(s);
    }), a),
    []
  )?.sort((a, r) => i(a) < i(r) ? -1 : 1) || []), n = (o) => o?.type === pa, i = (o) => o?.props?.order;
  return {
    getLayoutItems: t
  };
};
class IBe {
  breakpoint;
  numVisible;
  numScroll;
}
const Ioe = {
  breakpoint: "1024px",
  numVisible: 3,
  numScroll: 1
}, Poe = {
  breakpoint: "576px",
  numVisible: 1,
  numScroll: 1
}, Aoe = {
  breakpoint: "768px",
  numVisible: 2,
  numScroll: 1
}, _oe = [Ioe, Aoe, Poe];
var Moe = `
@layer primevue {
    .p-carousel {
        display: flex;
        flex-direction: column;
    }

    .p-carousel-content {
        display: flex;
        flex-direction: column;
        overflow: auto;
    }

    .p-carousel-prev,
    .p-carousel-next {
        align-self: center;
        flex-grow: 0;
        flex-shrink: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        overflow: hidden;
        position: relative;
    }

    .p-carousel-container {
        display: flex;
        flex-direction: row;
    }

    .p-carousel-items-content {
        overflow: hidden;
        width: 100%;
    }

    .p-carousel-items-container {
        display: flex;
        flex-direction: row;
    }

    .p-carousel-indicators {
        display: flex;
        flex-direction: row;
        justify-content: center;
        flex-wrap: wrap;
    }

    .p-carousel-indicator > button {
        display: flex;
        align-items: center;
        justify-content: center;
    }

    /* Vertical */
    .p-carousel-vertical .p-carousel-container {
        flex-direction: column;
    }

    .p-carousel-vertical .p-carousel-items-container {
        flex-direction: column;
        height: 100%;
    }

    /* Keyboard Support */
    .p-items-hidden .p-carousel-item {
        visibility: hidden;
    }

    .p-items-hidden .p-carousel-item.p-carousel-item-active {
        visibility: visible;
    }
}
`, Ooe = {
  root: function(t) {
    var n = t.instance;
    return ["p-carousel p-component", {
      "p-carousel-vertical": n.isVertical(),
      "p-carousel-horizontal": !n.isVertical()
    }];
  },
  header: "p-carousel-header",
  content: "p-carousel-content",
  container: "p-carousel-container",
  previousButton: function(t) {
    var n = t.instance;
    return ["p-carousel-prev p-link", {
      "p-disabled": n.backwardIsDisabled
    }];
  },
  previousButtonIcon: "p-carousel-next-icon",
  itemsContent: "p-carousel-items-content",
  itemsContainer: "p-carousel-items-container",
  itemCloned: function(t) {
    var n = t.index, i = t.value, o = t.totalShiftedItems, a = t.d_numVisible;
    return ["p-carousel-item p-carousel-item-cloned", {
      "p-carousel-item-active": o * -1 === i.length + a,
      "p-carousel-item-start": n === 0,
      "p-carousel-item-end": i.slice(-1 * a).length - 1 === n
    }];
  },
  item: function(t) {
    var n = t.instance, i = t.index;
    return ["p-carousel-item", {
      "p-carousel-item-active": n.firstIndex() <= i && n.lastIndex() >= i,
      "p-carousel-item-start": n.firstIndex() === i,
      "p-carousel-item-end": n.lastIndex() === i
    }];
  },
  nextButton: function(t) {
    var n = t.instance;
    return ["p-carousel-next p-link", {
      "p-disabled": n.forwardIsDisabled
    }];
  },
  nextButtonIcon: "p-carousel-prev-icon",
  indicators: "p-carousel-indicators p-reset",
  indicator: function(t) {
    var n = t.instance, i = t.index;
    return ["p-carousel-indicator", {
      "p-highlight": n.d_page === i
    }];
  },
  indicatorButton: "p-link",
  footer: "p-carousel-footer"
}, Boe = Wt.extend({
  name: "carousel",
  css: Moe,
  classes: Ooe
}), Eoe = {
  name: "BaseCarousel",
  extends: wt,
  props: {
    value: null,
    page: {
      type: Number,
      default: 0
    },
    numVisible: {
      type: Number,
      default: 1
    },
    numScroll: {
      type: Number,
      default: 1
    },
    responsiveOptions: Array,
    orientation: {
      type: String,
      default: "horizontal"
    },
    verticalViewPortHeight: {
      type: String,
      default: "300px"
    },
    contentClass: String,
    containerClass: String,
    indicatorsContentClass: String,
    circular: {
      type: Boolean,
      default: !1
    },
    autoplayInterval: {
      type: Number,
      default: 0
    },
    showNavigators: {
      type: Boolean,
      default: !0
    },
    showIndicators: {
      type: Boolean,
      default: !0
    },
    prevButtonProps: {
      type: null,
      default: null
    },
    nextButtonProps: {
      type: null,
      default: null
    }
  },
  style: Boe,
  provide: function() {
    return {
      $parentInstance: this
    };
  }
};
function Gr(e) {
  return $oe(e) || Noe(e) || Roe(e) || Doe();
}
function Doe() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Roe(e, t) {
  if (e) {
    if (typeof e == "string")
      return Hf(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set")
      return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return Hf(e, t);
  }
}
function Noe(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null)
    return Array.from(e);
}
function $oe(e) {
  if (Array.isArray(e))
    return Hf(e);
}
function Hf(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, i = new Array(t); n < t; n++)
    i[n] = e[n];
  return i;
}
var zf = {
  name: "Carousel",
  extends: Eoe,
  emits: ["update:page"],
  isRemainingItemsAdded: !1,
  data: function() {
    return {
      remainingItems: 0,
      d_numVisible: this.numVisible,
      d_numScroll: this.numScroll,
      d_oldNumScroll: 0,
      d_oldNumVisible: 0,
      d_oldValue: null,
      d_page: this.page,
      totalShiftedItems: this.page * this.numScroll * -1,
      allowAutoplay: !!this.autoplayInterval,
      d_circular: this.circular || this.allowAutoplay,
      swipeThreshold: 20
    };
  },
  watch: {
    page: function(t) {
      t > this.d_page ? this.navForward({}, t) : t < this.d_page && this.navBackward({}, t), this.d_page = t;
    },
    circular: function(t) {
      this.d_circular = t;
    },
    numVisible: function(t, n) {
      this.d_numVisible = t, this.d_oldNumVisible = n;
    },
    numScroll: function(t, n) {
      this.d_oldNumScroll = n, this.d_numScroll = t;
    },
    value: function(t) {
      this.d_oldValue = t;
    }
  },
  mounted: function() {
    var t = !1;
    if (this.$el.setAttribute(this.attributeSelector, ""), this.createStyle(), this.calculatePosition(), this.responsiveOptions && this.bindDocumentListeners(), this.isCircular()) {
      var n = this.totalShiftedItems;
      this.d_page === 0 ? n = -1 * this.d_numVisible : n === 0 && (n = -1 * this.value.length, this.remainingItems > 0 && (this.isRemainingItemsAdded = !0)), n !== this.totalShiftedItems && (this.totalShiftedItems = n, t = !0);
    }
    !t && this.isAutoplay() && this.startAutoplay();
  },
  updated: function() {
    var t = this.isCircular(), n = !1, i = this.totalShiftedItems;
    if (this.autoplayInterval && this.stopAutoplay(), this.d_oldNumScroll !== this.d_numScroll || this.d_oldNumVisible !== this.d_numVisible || this.d_oldValue.length !== this.value.length) {
      this.remainingItems = (this.value.length - this.d_numVisible) % this.d_numScroll;
      var o = this.d_page;
      this.totalIndicators !== 0 && o >= this.totalIndicators && (o = this.totalIndicators - 1, this.$emit("update:page", o), this.d_page = o, n = !0), i = o * this.d_numScroll * -1, t && (i -= this.d_numVisible), o === this.totalIndicators - 1 && this.remainingItems > 0 ? (i += -1 * this.remainingItems + this.d_numScroll, this.isRemainingItemsAdded = !0) : this.isRemainingItemsAdded = !1, i !== this.totalShiftedItems && (this.totalShiftedItems = i, n = !0), this.d_oldNumScroll = this.d_numScroll, this.d_oldNumVisible = this.d_numVisible, this.d_oldValue = this.value, this.$refs.itemsContainer.style.transform = this.isVertical() ? "translate3d(0, ".concat(i * (100 / this.d_numVisible), "%, 0)") : "translate3d(".concat(i * (100 / this.d_numVisible), "%, 0, 0)");
    }
    t && (this.d_page === 0 ? i = -1 * this.d_numVisible : i === 0 && (i = -1 * this.value.length, this.remainingItems > 0 && (this.isRemainingItemsAdded = !0)), i !== this.totalShiftedItems && (this.totalShiftedItems = i, n = !0)), !n && this.isAutoplay() && this.startAutoplay();
  },
  beforeUnmount: function() {
    this.responsiveOptions && this.unbindDocumentListeners(), this.autoplayInterval && this.stopAutoplay();
  },
  methods: {
    getIndicatorPTOptions: function(t) {
      return {
        context: {
          highlighted: t === this.d_page
        }
      };
    },
    step: function(t, n) {
      var i = this.totalShiftedItems, o = this.isCircular();
      if (n != null)
        i = this.d_numScroll * n * -1, o && (i -= this.d_numVisible), this.isRemainingItemsAdded = !1;
      else {
        i += this.d_numScroll * t, this.isRemainingItemsAdded && (i += this.remainingItems - this.d_numScroll * t, this.isRemainingItemsAdded = !1);
        var a = o ? i + this.d_numVisible : i;
        n = Math.abs(Math.floor(a / this.d_numScroll));
      }
      o && this.d_page === this.totalIndicators - 1 && t === -1 ? (i = -1 * (this.value.length + this.d_numVisible), n = 0) : o && this.d_page === 0 && t === 1 ? (i = 0, n = this.totalIndicators - 1) : n === this.totalIndicators - 1 && this.remainingItems > 0 && (i += this.remainingItems * -1 - this.d_numScroll * t, this.isRemainingItemsAdded = !0), this.$refs.itemsContainer && (!this.isUnstyled && Oe.removeClass(this.$refs.itemsContainer, "p-items-hidden"), this.$refs.itemsContainer.style.transform = this.isVertical() ? "translate3d(0, ".concat(i * (100 / this.d_numVisible), "%, 0)") : "translate3d(".concat(i * (100 / this.d_numVisible), "%, 0, 0)"), this.$refs.itemsContainer.style.transition = "transform 500ms ease 0s"), this.totalShiftedItems = i, this.$emit("update:page", n), this.d_page = n;
    },
    calculatePosition: function() {
      if (this.$refs.itemsContainer && this.responsiveOptions) {
        for (var t = window.innerWidth, n = {
          numVisible: this.numVisible,
          numScroll: this.numScroll
        }, i = 0; i < this.responsiveOptions.length; i++) {
          var o = this.responsiveOptions[i];
          parseInt(o.breakpoint, 10) >= t && (n = o);
        }
        if (this.d_numScroll !== n.numScroll) {
          var a = this.d_page;
          a = parseInt(a * this.d_numScroll / n.numScroll), this.totalShiftedItems = n.numScroll * a * -1, this.isCircular() && (this.totalShiftedItems -= n.numVisible), this.d_numScroll = n.numScroll, this.$emit("update:page", a), this.d_page = a;
        }
        this.d_numVisible !== n.numVisible && (this.d_numVisible = n.numVisible);
      }
    },
    navBackward: function(t, n) {
      (this.d_circular || this.d_page !== 0) && this.step(1, n), this.allowAutoplay = !1, t.cancelable && t.preventDefault();
    },
    navForward: function(t, n) {
      (this.d_circular || this.d_page < this.totalIndicators - 1) && this.step(-1, n), this.allowAutoplay = !1, t.cancelable && t.preventDefault();
    },
    onIndicatorClick: function(t, n) {
      var i = this.d_page;
      n > i ? this.navForward(t, n) : n < i && this.navBackward(t, n);
    },
    onTransitionEnd: function() {
      this.$refs.itemsContainer && (!this.isUnstyled && Oe.addClass(this.$refs.itemsContainer, "p-items-hidden"), this.$refs.itemsContainer.style.transition = "", (this.d_page === 0 || this.d_page === this.totalIndicators - 1) && this.isCircular() && (this.$refs.itemsContainer.style.transform = this.isVertical() ? "translate3d(0, ".concat(this.totalShiftedItems * (100 / this.d_numVisible), "%, 0)") : "translate3d(".concat(this.totalShiftedItems * (100 / this.d_numVisible), "%, 0, 0)")));
    },
    onTouchStart: function(t) {
      var n = t.changedTouches[0];
      this.startPos = {
        x: n.pageX,
        y: n.pageY
      };
    },
    onTouchMove: function(t) {
      t.cancelable && t.preventDefault();
    },
    onTouchEnd: function(t) {
      var n = t.changedTouches[0];
      this.isVertical() ? this.changePageOnTouch(t, n.pageY - this.startPos.y) : this.changePageOnTouch(t, n.pageX - this.startPos.x);
    },
    changePageOnTouch: function(t, n) {
      Math.abs(n) > this.swipeThreshold && (n < 0 ? this.navForward(t) : this.navBackward(t));
    },
    onIndicatorKeydown: function(t) {
      switch (t.code) {
        case "ArrowRight":
          this.onRightKey();
          break;
        case "ArrowLeft":
          this.onLeftKey();
          break;
        case "Home":
          this.onHomeKey(), t.preventDefault();
          break;
        case "End":
          this.onEndKey(), t.preventDefault();
          break;
        case "ArrowUp":
        case "ArrowDown":
        case "PageUp":
        case "PageDown":
          t.preventDefault();
          break;
        case "Tab":
          this.onTabKey();
          break;
      }
    },
    onRightKey: function() {
      var t = Gr(Oe.find(this.$refs.indicatorContent, '[data-pc-section="indicator"]')), n = this.findFocusedIndicatorIndex();
      this.changedFocusedIndicator(n, n + 1 === t.length ? t.length - 1 : n + 1);
    },
    onLeftKey: function() {
      var t = this.findFocusedIndicatorIndex();
      this.changedFocusedIndicator(t, t - 1 <= 0 ? 0 : t - 1);
    },
    onHomeKey: function() {
      var t = this.findFocusedIndicatorIndex();
      this.changedFocusedIndicator(t, 0);
    },
    onEndKey: function() {
      var t = Gr(Oe.find(this.$refs.indicatorContent, '[data-pc-section="indicator"]')), n = this.findFocusedIndicatorIndex();
      this.changedFocusedIndicator(n, t.length - 1);
    },
    onTabKey: function() {
      var t = Gr(Oe.find(this.$refs.indicatorContent, '[data-pc-section="indicator"]')), n = t.findIndex(function(a) {
        return Oe.getAttribute(a, "data-p-highlight") === !0;
      }), i = Oe.findSingle(this.$refs.indicatorContent, '[data-pc-section="indicator"] > button[tabindex="0"]'), o = t.findIndex(function(a) {
        return a === i.parentElement;
      });
      t[o].children[0].tabIndex = "-1", t[n].children[0].tabIndex = "0";
    },
    findFocusedIndicatorIndex: function() {
      var t = Gr(Oe.find(this.$refs.indicatorContent, '[data-pc-section="indicator"]')), n = Oe.findSingle(this.$refs.indicatorContent, '[data-pc-section="indicator"] > button[tabindex="0"]');
      return t.findIndex(function(i) {
        return i === n.parentElement;
      });
    },
    changedFocusedIndicator: function(t, n) {
      var i = Gr(Oe.find(this.$refs.indicatorContent, '[data-pc-section="indicator"]'));
      i[t].children[0].tabIndex = "-1", i[n].children[0].tabIndex = "0", i[n].children[0].focus();
    },
    bindDocumentListeners: function() {
      var t = this;
      this.documentResizeListener || (this.documentResizeListener = function(n) {
        t.calculatePosition(n);
      }, window.addEventListener("resize", this.documentResizeListener));
    },
    unbindDocumentListeners: function() {
      this.documentResizeListener && (window.removeEventListener("resize", this.documentResizeListener), this.documentResizeListener = null);
    },
    startAutoplay: function() {
      var t = this;
      this.interval = setInterval(function() {
        t.d_page === t.totalIndicators - 1 ? t.step(-1, 0) : t.step(-1, t.d_page + 1);
      }, this.autoplayInterval);
    },
    stopAutoplay: function() {
      this.interval && clearInterval(this.interval);
    },
    createStyle: function() {
      if (!this.carouselStyle) {
        var t;
        this.carouselStyle = document.createElement("style"), this.carouselStyle.type = "text/css", Oe.setAttribute(this.carouselStyle, "nonce", (t = this.$primevue) === null || t === void 0 || (t = t.config) === null || t === void 0 || (t = t.csp) === null || t === void 0 ? void 0 : t.nonce), document.body.appendChild(this.carouselStyle);
      }
      var n = `
                .p-carousel[`.concat(this.attributeSelector, `] .p-carousel-item {
                    flex: 1 0 `).concat(100 / this.d_numVisible, `%
                }
            `);
      if (this.responsiveOptions && !this.isUnstyled) {
        var i = Gr(this.responsiveOptions), o = We.localeComparator();
        i.sort(function(s, l) {
          var d = s.breakpoint, y = l.breakpoint;
          return We.sort(d, y, -1, o);
        });
        for (var a = 0; a < i.length; a++) {
          var r = i[a];
          n += `
                        @media screen and (max-width: `.concat(r.breakpoint, `) {
                            .p-carousel[`).concat(this.attributeSelector, `] .p-carousel-item {
                                flex: 1 0 `).concat(100 / r.numVisible, `%
                            }
                        }
                    `);
        }
      }
      this.carouselStyle.innerHTML = n;
    },
    isVertical: function() {
      return this.orientation === "vertical";
    },
    isCircular: function() {
      return this.value && this.d_circular && this.value.length >= this.d_numVisible;
    },
    isAutoplay: function() {
      return this.autoplayInterval && this.allowAutoplay;
    },
    firstIndex: function() {
      return this.isCircular() ? -1 * (this.totalShiftedItems + this.d_numVisible) : this.totalShiftedItems * -1;
    },
    lastIndex: function() {
      return this.firstIndex() + this.d_numVisible - 1;
    },
    ariaSlideNumber: function(t) {
      return this.$primevue.config.locale.aria ? this.$primevue.config.locale.aria.slideNumber.replace(/{slideNumber}/g, t) : void 0;
    },
    ariaPageLabel: function(t) {
      return this.$primevue.config.locale.aria ? this.$primevue.config.locale.aria.pageLabel.replace(/{page}/g, t) : void 0;
    }
  },
  computed: {
    totalIndicators: function() {
      return this.value ? Math.max(Math.ceil((this.value.length - this.d_numVisible) / this.d_numScroll) + 1, 0) : 0;
    },
    backwardIsDisabled: function() {
      return this.value && (!this.circular || this.value.length < this.d_numVisible) && this.d_page === 0;
    },
    forwardIsDisabled: function() {
      return this.value && (!this.circular || this.value.length < this.d_numVisible) && (this.d_page === this.totalIndicators - 1 || this.totalIndicators === 0);
    },
    ariaSlideLabel: function() {
      return this.$primevue.config.locale.aria ? this.$primevue.config.locale.aria.slide : void 0;
    },
    ariaPrevButtonLabel: function() {
      return this.$primevue.config.locale.aria ? this.$primevue.config.locale.aria.prevPageLabel : void 0;
    },
    ariaNextButtonLabel: function() {
      return this.$primevue.config.locale.aria ? this.$primevue.config.locale.aria.nextPageLabel : void 0;
    },
    attributeSelector: function() {
      return Mt();
    }
  },
  components: {
    ChevronRightIcon: Fo,
    ChevronDownIcon: Va,
    ChevronLeftIcon: th,
    ChevronUpIcon: ig
  },
  directives: {
    ripple: An
  }
};
function Rc(e) {
  "@babel/helpers - typeof";
  return Rc = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Rc(e);
}
function H0(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    t && (i = i.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), n.push.apply(n, i);
  }
  return n;
}
function Dd(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? H0(Object(n), !0).forEach(function(i) {
      Foe(e, i, n[i]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : H0(Object(n)).forEach(function(i) {
      Object.defineProperty(e, i, Object.getOwnPropertyDescriptor(n, i));
    });
  }
  return e;
}
function Foe(e, t, n) {
  return t = joe(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function joe(e) {
  var t = Hoe(e, "string");
  return Rc(t) == "symbol" ? t : String(t);
}
function Hoe(e, t) {
  if (Rc(e) != "object" || !e)
    return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var i = n.call(e, t || "default");
    if (Rc(i) != "object")
      return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var zoe = ["aria-live"], Voe = ["disabled", "aria-label"], Goe = ["data-p-carousel-item-active", "data-p-carousel-item-start", "data-p-carousel-item-end"], Uoe = ["aria-hidden", "aria-label", "aria-roledescription", "data-p-carousel-item-active", "data-p-carousel-item-start", "data-p-carousel-item-end"], Woe = ["disabled", "aria-label"], Yoe = ["data-p-highlight"], qoe = ["tabindex", "aria-label", "aria-current", "onClick"];
function Koe(e, t, n, i, o, a) {
  var r = Ut("ripple");
  return E(), X("div", Ce({
    class: e.cx("root"),
    role: "region"
  }, e.ptm("root")), [e.$slots.header ? (E(), X("div", Ce({
    key: 0,
    class: e.cx("header")
  }, e.ptm("header")), [je(e.$slots, "header")], 16)) : te("", !0), oe("div", Ce({
    class: [e.cx("content"), e.contentClass]
  }, e.ptm("content")), [oe("div", Ce({
    class: [e.cx("container"), e.containerClass],
    "aria-live": o.allowAutoplay ? "polite" : "off"
  }, e.ptm("container")), [e.showNavigators ? rt((E(), X("button", Ce({
    key: 0,
    type: "button",
    class: e.cx("previousButton"),
    disabled: a.backwardIsDisabled,
    "aria-label": a.ariaPrevButtonLabel,
    onClick: t[0] || (t[0] = function() {
      return a.navBackward && a.navBackward.apply(a, arguments);
    })
  }, Dd(Dd({}, e.prevButtonProps), e.ptm("previousButton")), {
    "data-pc-group-section": "navigator"
  }), [je(e.$slots, "previousicon", {}, function() {
    return [(E(), fe(tt(a.isVertical() ? "ChevronUpIcon" : "ChevronLeftIcon"), Ce({
      class: e.cx("previousButtonIcon")
    }, e.ptm("previousButtonIcon")), null, 16, ["class"]))];
  })], 16, Voe)), [[r]]) : te("", !0), oe("div", Ce({
    class: e.cx("itemsContent"),
    style: [{
      height: a.isVertical() ? e.verticalViewPortHeight : "auto"
    }],
    onTouchend: t[2] || (t[2] = function() {
      return a.onTouchEnd && a.onTouchEnd.apply(a, arguments);
    }),
    onTouchstart: t[3] || (t[3] = function() {
      return a.onTouchStart && a.onTouchStart.apply(a, arguments);
    }),
    onTouchmove: t[4] || (t[4] = function() {
      return a.onTouchMove && a.onTouchMove.apply(a, arguments);
    })
  }, e.ptm("itemsContent")), [oe("div", Ce({
    ref: "itemsContainer",
    class: e.cx("itemsContainer"),
    onTransitionend: t[1] || (t[1] = function() {
      return a.onTransitionEnd && a.onTransitionEnd.apply(a, arguments);
    })
  }, e.ptm("itemsContainer")), [a.isCircular() ? (E(!0), X(Re, {
    key: 0
  }, Ge(e.value.slice(-1 * o.d_numVisible), function(s, l) {
    return E(), X("div", Ce({
      key: l + "_scloned",
      class: e.cx("itemCloned", {
        index: l,
        value: e.value,
        totalShiftedItems: o.totalShiftedItems,
        d_numVisible: o.d_numVisible
      })
    }, e.ptm("itemCloned"), {
      "data-p-carousel-item-active": o.totalShiftedItems * -1 === e.value.length + o.d_numVisible,
      "data-p-carousel-item-start": l === 0,
      "data-p-carousel-item-end": e.value.slice(-1 * o.d_numVisible).length - 1 === l
    }), [je(e.$slots, "item", {
      data: s,
      index: l
    })], 16, Goe);
  }), 128)) : te("", !0), (E(!0), X(Re, null, Ge(e.value, function(s, l) {
    return E(), X("div", Ce({
      key: l,
      class: e.cx("item", {
        index: l
      }),
      role: "group",
      "aria-hidden": a.firstIndex() > l || a.lastIndex() < l ? !0 : void 0,
      "aria-label": a.ariaSlideNumber(l),
      "aria-roledescription": a.ariaSlideLabel
    }, e.ptm("item"), {
      "data-p-carousel-item-active": a.firstIndex() <= l && a.lastIndex() >= l,
      "data-p-carousel-item-start": a.firstIndex() === l,
      "data-p-carousel-item-end": a.lastIndex() === l
    }), [je(e.$slots, "item", {
      data: s,
      index: l
    })], 16, Uoe);
  }), 128)), a.isCircular() ? (E(!0), X(Re, {
    key: 1
  }, Ge(e.value.slice(0, o.d_numVisible), function(s, l) {
    return E(), X("div", Ce({
      key: l + "_fcloned",
      class: e.cx("itemCloned", {
        index: l,
        value: e.value,
        totalShiftedItems: o.totalShiftedItems,
        d_numVisible: o.d_numVisible
      })
    }, e.ptm("itemCloned")), [je(e.$slots, "item", {
      data: s,
      index: l
    })], 16);
  }), 128)) : te("", !0)], 16)], 16), e.showNavigators ? rt((E(), X("button", Ce({
    key: 1,
    type: "button",
    class: e.cx("nextButton"),
    disabled: a.forwardIsDisabled,
    "aria-label": a.ariaNextButtonLabel,
    onClick: t[5] || (t[5] = function() {
      return a.navForward && a.navForward.apply(a, arguments);
    })
  }, Dd(Dd({}, e.nextButtonProps), e.ptm("nextButton")), {
    "data-pc-group-section": "navigator"
  }), [je(e.$slots, "nexticon", {}, function() {
    return [(E(), fe(tt(a.isVertical() ? "ChevronDownIcon" : "ChevronRightIcon"), Ce({
      class: e.cx("nextButtonIcon")
    }, e.ptm("nextButtonIcon")), null, 16, ["class"]))];
  })], 16, Woe)), [[r]]) : te("", !0)], 16, zoe), a.totalIndicators >= 0 && e.showIndicators ? (E(), X("ul", Ce({
    key: 0,
    ref: "indicatorContent",
    class: [e.cx("indicators"), e.indicatorsContentClass],
    onKeydown: t[6] || (t[6] = function() {
      return a.onIndicatorKeydown && a.onIndicatorKeydown.apply(a, arguments);
    })
  }, e.ptm("indicators")), [(E(!0), X(Re, null, Ge(a.totalIndicators, function(s, l) {
    return E(), X("li", Ce({
      key: "p-carousel-indicator-" + l.toString(),
      class: e.cx("indicator", {
        index: l
      })
    }, e.ptm("indicator", a.getIndicatorPTOptions(l)), {
      "data-p-highlight": o.d_page === l
    }), [oe("button", Ce({
      class: e.cx("indicatorButton"),
      type: "button",
      tabindex: o.d_page === l ? "0" : "-1",
      "aria-label": a.ariaPageLabel(l + 1),
      "aria-current": o.d_page === l ? "page" : void 0,
      onClick: function(y) {
        return a.onIndicatorClick(y, l);
      }
    }, e.ptm("indicatorButton", a.getIndicatorPTOptions(l))), null, 16, qoe)], 16, Yoe);
  }), 128))], 16)) : te("", !0)], 16), e.$slots.footer ? (E(), X("div", Ce({
    key: 1,
    class: e.cx("footer")
  }, e.ptm("footer")), [je(e.$slots, "footer")], 16)) : te("", !0)], 16);
}
zf.render = Koe;
const Xoe = Be({
  name: "Carousel",
  extends: zf,
  methods: {
    onTouchMove: () => {
    }
  },
  render: zf.render
}), Zoe = ["aria-label", "aria-disabled"], Joe = {
  key: 1,
  class: "indicators"
}, Qoe = ["aria-label", "aria-current", "onClick"], ere = ["aria-label", "aria-disabled"], tre = /* @__PURE__ */ Be({
  __name: "BaseSlider",
  props: {
    items: {
      type: Array,
      required: !0
    },
    itemsVisible: {
      type: Number,
      default: 3
    },
    numScroll: {
      type: Number,
      default: null
    },
    baseLink: {
      type: Object,
      required: !1,
      default: null
    },
    page: {
      type: Number,
      required: !1,
      default: 0
    },
    responsiveOptions: {
      type: Object,
      required: !1,
      default: _oe
    },
    autoPlayInterval: {
      type: Number,
      default: null
    },
    setBackward: {
      type: Boolean,
      default: !1
    },
    setForward: {
      type: Boolean,
      default: !1
    },
    showNavigators: {
      type: Boolean,
      default: !0
    },
    showIndicators: {
      type: Boolean,
      default: !0
    }
  },
  setup(e, { expose: t }) {
    const n = e, i = ge(null), o = ge(null), { t: a } = Je();
    qe(
      () => n.setForward,
      () => {
        i.value && d(i.value);
      },
      { deep: !0 }
    ), qe(
      () => n.setBackward,
      () => {
        o.value && l(o.value);
      },
      { deep: !0 }
    );
    const r = Te(() => n.items.length < n.itemsVisible ? 0 : n.numScroll ? n.numScroll : n.items.length - n.itemsVisible), s = ge(null);
    t({
      carousel: s
    });
    function l(g) {
      s?.value && s.value.navBackward(g);
    }
    function d(g) {
      s?.value && s.value.navForward(g);
    }
    function y() {
      return s?.value ? s.value.totalIndicators : [];
    }
    function u() {
      if (s?.value)
        return s.value.d_page;
    }
    function m() {
      if (s?.value)
        return s.value.forwardIsDisabled;
    }
    function h() {
      if (s?.value)
        return s.value.backwardIsDisabled;
    }
    function c(g, v) {
      s?.value && s.value.onIndicatorClick(g, v);
    }
    return it(async () => {
      await mt();
      const g = s.value?.$el.querySelector(".p-carousel-prev");
      g && g.setAttribute("aria-hidden", "true");
    }), (g, v) => (E(), fe(Xoe, {
      ref_key: "carousel",
      ref: s,
      class: "d-base-slider",
      "responsive-options": e.responsiveOptions,
      value: e.items,
      "num-visible": e.itemsVisible,
      "num-scroll": r.value,
      page: e.page,
      "show-indicators": e.showIndicators,
      "autoplay-interval": e.autoPlayInterval,
      "show-navigators": e.showNavigators
    }, {
      item: Se((P) => [
        je(g.$slots, "item", {
          data: P.data
        }, void 0, !0)
      ]),
      footer: Se(() => [
        y() > 1 ? (E(), X("button", {
          key: 0,
          ref_key: "backward",
          ref: o,
          class: Pe([{ "p-disabled": h() }, "backward"]),
          type: "button",
          "aria-label": _(a)("baseSlider.navBackward"),
          "aria-disabled": h() ? "true" : "false",
          onClick: l
        }, v[0] || (v[0] = [
          oe("span", { class: "las la-angle-left" }, null, -1)
        ]), 10, Zoe)) : te("", !0),
        y() > 1 ? (E(), X("ul", Joe, [
          (E(!0), X(Re, null, Ge(y(), (P, f) => (E(), X("li", {
            key: "p-carousel-indicator-" + f.toString(),
            class: Pe({ "p-highlight": u() === f })
          }, [
            oe("button", {
              class: "p-link",
              type: "button",
              "aria-label": `${_(a)("baseSlider.navToPage")} ${f + 1}`,
              "aria-current": u() === f ? "page" : null,
              onClick: (S) => c(S, f)
            }, null, 8, Qoe)
          ], 2))), 128))
        ])) : te("", !0),
        y() > 1 ? (E(), X("button", {
          key: 2,
          ref_key: "forward",
          ref: i,
          class: Pe([{ "p-disabled": m() }, "forward"]),
          type: "button",
          "aria-label": _(a)("baseSlider.navForward"),
          "aria-disabled": m() ? "true" : "false",
          onClick: d
        }, v[1] || (v[1] = [
          oe("span", { class: "las la-angle-right" }, null, -1)
        ]), 10, ere)) : te("", !0),
        e.baseLink && e.baseLink.href ? (E(), fe(ot, {
          key: 3,
          class: "base-link",
          "link-model": e.baseLink,
          icon: _(H).ArrowRight
        }, null, 8, ["link-model", "icon"])) : te("", !0)
      ]),
      _: 3
    }, 8, ["responsive-options", "value", "num-visible", "num-scroll", "page", "show-indicators", "autoplay-interval", "show-navigators"]));
  }
});
const zs = /* @__PURE__ */ Fe(tre, [["__scopeId", "data-v-b04b89b7"]]), nre = /* @__PURE__ */ Be({
  __name: "ColumnLayout",
  props: {
    type: {
      type: String,
      default: ji.OneThird
    }
  },
  setup(e) {
    const t = e, { getLayoutItems: n } = oT(), i = Te(() => {
      switch (t.type) {
        case ji.Full:
          return n.value.length > 1;
        case ji.Half:
          return n.value.length > 2;
        case ji.OneThird:
          return n.value.length > 3;
      }
    }), o = Te(() => {
      switch (t.type) {
        case ji.Full:
          return 1;
        case ji.Half:
          return 2;
        case ji.OneThird:
          return 3;
      }
    }), a = n.value.map((v, P) => ({
      index: P,
      ...v
    })), r = {
      breakpoint: `${Ct.Xxxl - 1}px`,
      numVisible: 1,
      numScroll: 1
    }, s = {
      breakpoint: `${Ct.Xxl - 1}px`,
      numVisible: 1,
      numScroll: 1
    }, l = {
      breakpoint: `${Ct.Lg - 1}px`,
      numVisible: 1,
      numScroll: 1
    }, d = {
      breakpoint: `${Ct.Xxxl - 1}px`,
      numVisible: 2,
      numScroll: 1
    }, y = {
      breakpoint: `${Ct.Xxl - 1}px`,
      numVisible: 1,
      numScroll: 1
    }, u = {
      breakpoint: `${Ct.Lg - 1}px`,
      numVisible: 1,
      numScroll: 1
    }, m = {
      breakpoint: `${Ct.Xxxl - 1}px`,
      numVisible: 3,
      numScroll: 1
    }, h = {
      breakpoint: `${Ct.Xxl - 1}px`,
      numVisible: 2,
      numScroll: 1
    }, c = {
      breakpoint: `${Ct.Lg - 1}px`,
      numVisible: 1,
      numScroll: 1
    }, g = Te(() => {
      switch (t.type) {
        case ji.Full:
          return [
            r,
            s,
            l
          ];
        case ji.Half:
          return [
            d,
            y,
            u
          ];
        case ji.OneThird:
          return [
            m,
            h,
            c
          ];
      }
    });
    return (v, P) => (E(), X(Re, null, [
      _(n).length > 0 && !i.value ? (E(), X("div", {
        key: 0,
        class: Pe(["d-column-layout", `d-column-layout--${e.type}`])
      }, [
        (E(!0), X(Re, null, Ge(_(n), (f, S) => (E(), fe(tt(f), { key: S }))), 128))
      ], 2)) : te("", !0),
      i.value ? (E(), fe(zs, {
        key: 1,
        ref: "slider",
        items: _(a),
        "items-visible": o.value,
        "num-scroll": 1,
        page: 0,
        "responsive-options": g.value,
        class: "d-column-layout__slider"
      }, {
        item: Se((f) => [
          (E(), fe(tt(f.data)))
        ]),
        _: 1
      }, 8, ["items", "items-visible", "responsive-options"])) : te("", !0)
    ], 64));
  }
});
const rT = /* @__PURE__ */ Fe(nre, [["__scopeId", "data-v-c3fd9482"]]), ire = { class: "d-stacked-layout__wrapper" }, are = { class: "d-stacked-layout__items" }, ore = /* @__PURE__ */ Be({
  __name: "StackedLayout",
  props: {
    backgroundType: {
      type: String,
      default: void 0
    },
    backgroundImage: {
      type: String,
      default: void 0
    }
  },
  setup(e) {
    const t = e, { getLayoutItems: n } = oT(), i = Te(() => t.backgroundType === void 0 ? "" : `d-stacked-layout__with-background d-stacked-layout__with-background--${t.backgroundType}`);
    return (o, a) => _(n).length > 0 ? (E(), X("div", {
      key: 0,
      class: Pe(["d-stacked-layout", i.value]),
      style: hn(
        e.backgroundImage && e.backgroundType === _(Ph).Image ? { backgroundImage: `url(${e.backgroundImage})` } : {}
      )
    }, [
      oe("div", ire, [
        oe("div", are, [
          (E(!0), X(Re, null, Ge(_(n), (r, s) => (E(), fe(tt(r), { key: s }))), 128))
        ])
      ])
    ], 6)) : te("", !0);
  }
});
const Mh = /* @__PURE__ */ Fe(ore, [["__scopeId", "data-v-3885db23"]]), rre = {
  key: 0,
  class: "d-base-dropdown"
}, sre = ["onKeydown"], lre = /* @__PURE__ */ Be({
  __name: "BaseDropdown",
  props: {
    model: {
      type: Object,
      required: !0
    },
    appendTo: {
      type: String,
      default: "self"
    },
    ariaLabel: {
      type: String,
      default: "Dropdown"
    },
    ariaLabelledby: {
      type: String,
      default: null
    }
  },
  emits: ["selected-item-changed", "hide", "show"],
  setup(e, { expose: t, emit: n }) {
    const { pageName: i } = Qe(), o = e, a = ge(), r = ge(), s = ge(!1), l = (g) => {
      a.value = g.selectedItem;
    };
    qe(
      () => o.model,
      (g) => {
        l(g);
      },
      { immediate: !0 }
    );
    const d = n, y = () => {
      d("selected-item-changed", a.value);
    }, u = (g) => {
      s.value && (g.preventDefault(), r.value?.hide());
    }, m = () => {
      s.value = !0, d("show");
    }, h = () => {
      s.value = !1, d("hide");
    }, c = (g) => {
      a.value = g, y();
    };
    return t({
      dropdownRef: r
    }), (g, v) => o ? (E(), X("div", rre, [
      ue(_(Ga), {
        ref_key: "dropdownRef",
        ref: r,
        modelValue: a.value,
        "onUpdate:modelValue": [
          v[0] || (v[0] = (P) => a.value = P),
          y
        ],
        "aria-label": e.ariaLabelledby ? null : e.ariaLabel,
        "aria-labelledby": e.ariaLabelledby,
        class: Pe(["w-full", { "p-invalid": e.model.invalid }]),
        options: e.model.options,
        "option-label": "label",
        "scroll-height": "364px",
        placeholder: e.model.placeholder,
        disabled: e.model.disabled,
        "data-event_source": _(i) + e.model.eventSource,
        "data-event_title": a.value?.label,
        "data-event_component_name": e.model.componentName ? e.model.componentName : "Base-Dropdown",
        pt: {
          panel: { class: "d-base-dropdown-singleselect__panel" },
          wrapper: { class: "d-base-dropdown-singleselect_wrapper" }
        },
        "append-to": e.appendTo,
        onKeydown: Ze(u, ["tab"]),
        onShow: m,
        onHide: h
      }, {
        option: Se((P) => [
          oe("div", {
            class: "p-dropdown-item__inner",
            tabindex: "0",
            onKeydown: Ze((f) => c(P.option), ["enter"])
          }, Ie(P.option.label), 41, sre)
        ]),
        dropdownicon: Se(() => [
          ue(_t, {
            "base-icon": _(H).AngleDown,
            "base-icon-size": _(at).Inherit,
            "aria-hidden": "true"
          }, null, 8, ["base-icon", "base-icon-size"])
        ]),
        _: 1
      }, 8, ["modelValue", "aria-label", "aria-labelledby", "class", "options", "placeholder", "disabled", "data-event_source", "data-event_title", "data-event_component_name", "append-to"])
    ])) : te("", !0);
  }
});
const Oh = /* @__PURE__ */ Fe(lre, [["__scopeId", "data-v-3c1063e2"]]), cre = { class: "d-breadcrumb" }, dre = {
  key: 0,
  class: "d-breadcrumb__left-button-container"
}, ure = { class: "d-breadcrumb__items-container" }, hre = { class: "d-breadcrumb__right-gradient" }, pre = {
  key: 0,
  class: "not-link"
}, fre = ["href", "data-event_source", "data-event_title", "data-event_target"], mre = {
  key: 2,
  class: "not-link"
}, gre = {
  key: 3,
  class: "las la-angle-right"
}, vre = ["aria-label", "data-event_source"], yre = {
  key: 1,
  class: "d-breadcrumb__right-button-container"
}, bre = { class: "share-buttons" }, xre = "Breadcrumb", wre = 25, kre = /* @__PURE__ */ Be({
  __name: "Breadcrumb",
  props: {
    metaTags: {
      type: Object,
      required: !0
    },
    breadcrumbs: {
      type: Array,
      required: !0
    },
    shareClassItems: {
      type: Array,
      default: null
    },
    hasBlueGradientBackground: {
      type: Boolean
    }
  },
  setup(e) {
    const { showPrintDialog: t } = Uu(), n = e, { t: i } = Je(), { pageName: o } = Qe(), { isDesktop: a, isMobile: r, isTablet: s } = xt(), l = ge(null), d = ge(null), y = ge(!0), u = ge(), m = ge(), h = ge(!1), c = ge(!1), g = ge(250), v = o, P = [
      Pt.Linkedin,
      Pt.Twitter,
      Pt.Facebook,
      Pt.Xing,
      Pt.Email
    ], f = (L) => ({
      contentUrl: "",
      title: "",
      target: "_self",
      isLocked: !1,
      isExternal: !1,
      linkType: yt.Javascript,
      tealiumTrackingModel: {
        eventSource: v,
        eventComponentName: "Breadcrumb",
        eventTitle: L
      }
    }), S = Te(() => n.shareClassItems.filter(
      (L) => !L.isSelected
    )), w = Te(() => (L) => {
      const B = L === Pt.Twitter ? n.metaTags?.twitterDescription : n.metaTags.ogDescription;
      return {
        network: L,
        url: n.metaTags.ogUrl,
        title: n.metaTags.metaTitleWithFallbackAndSuffix,
        description: B,
        hashtags: n.metaTags.metaKeywords,
        quote: B
      };
    });
    function x() {
      l?.value && (g.value = l.value.clientWidth - 64);
    }
    function k() {
      const L = l.value;
      L && (h.value = L.scrollLeft > 0, c.value = L.scrollWidth > L.clientWidth && Math.round(L.scrollLeft) < L.scrollWidth - L.clientWidth);
    }
    const A = () => {
      if (l.value) {
        let L = l.value.scrollLeft - g.value;
        L < 0 && (L = 0), l.value.scrollTo({
          left: L,
          behavior: "smooth"
        });
      }
    }, $ = () => {
      if (l.value) {
        const L = l.value.scrollWidth - l.value.clientWidth;
        let B = l.value.scrollLeft + g.value;
        B > L && (B = L), l.value.scrollTo({
          left: B,
          behavior: "smooth"
        });
      }
    };
    function j(L) {
      Ue && window.open(L.value, "_self");
    }
    it(async () => {
      await mt(), M(), x(), d?.value && d.value.setAttribute("hidden", "hidden"), Ue && (u?.value?.buttonRef && pn({
        trigger: u.value.buttonRef,
        content: i("globalTranslations.tooltipTextPrint"),
        appendTo: () => document.body,
        showOnTouchDevices: !0,
        field: () => u.value.buttonRef
      }), m?.value?.buttonRef && pn({
        trigger: m.value.buttonRef,
        content: i("globalTranslations.tooltipTextShare"),
        appendTo: () => document.body,
        showOnTouchDevices: !0,
        field: () => m.value.buttonRef
      }));
    });
    function N(L, B) {
      return L.length > B ? L.substring(0, B) + "..." : L;
    }
    async function M() {
      await mt();
      const L = l.value?.scrollWidth;
      l.value?.scrollLeft !== L && l.value?.scrollTo({
        left: L,
        behavior: "smooth"
      });
    }
    function D() {
      y.value = !y.value;
    }
    function C() {
      t();
    }
    function b() {
      return d.value && (d.value.removeAttribute("hidden"), d.value.click(), d.value.setAttribute("hidden", "hidden")), !0;
    }
    function p(L, B) {
      return n.breadcrumbs?.length <= B + 1 ? !1 : L.link === n.breadcrumbs[B + 1]?.link;
    }
    return qe(
      [a, s, r],
      () => {
        x(), k();
      },
      { immediate: !0 }
    ), (L, B) => (E(), X("div", cre, [
      h.value ? (E(), X("div", dre, [
        ue(_(Nt), {
          class: "d-breadcrumb__left-button",
          type: _(Ke).Tertiary,
          size: _(et).Inherit,
          icon: _(H).AngleLeft,
          "link-model": f("scroll left"),
          "aria-label": _(i)("breadcrumb.scrollLeft"),
          onClick: A
        }, null, 8, ["type", "size", "icon", "link-model", "aria-label"])
      ])) : te("", !0),
      oe("div", ure, [
        rt(oe("div", {
          class: Pe(["d-breadcrumb__left-gradient", {
            "d-breadcrumb__left-gradient--blue": e.hasBlueGradientBackground
          }])
        }, null, 2), [
          [xn, h.value]
        ]),
        rt(oe("div", hre, null, 512), [
          [xn, c.value]
        ]),
        oe("ul", {
          ref_key: "breadcrumbItems",
          ref: l,
          class: "d-breadcrumb__items",
          onScroll: k
        }, [
          (E(!0), X(Re, null, Ge(e.breadcrumbs, (T, O) => (E(), X("li", { key: O }, [
            T.link.length < 1 ? (E(), X("span", pre, Ie(T.name), 1)) : te("", !0),
            T.link.length >= 1 && !p(T, O) ? (E(), X("a", {
              key: 1,
              class: Pe({ "item-bold": O == e.breadcrumbs.length - 1 }),
              href: T.link,
              "data-event_source": _(v),
              "data-event_component_name": xre,
              "data-event_title": T.name,
              "data-event_target": T.link
            }, [
              O == e.breadcrumbs.length - 1 ? (E(), X(Re, { key: 0 }, [
                Ve(Ie(N(T.name, wre)), 1)
              ], 64)) : (E(), X(Re, { key: 1 }, [
                Ve(Ie(T.name), 1)
              ], 64))
            ], 10, fre)) : te("", !0),
            p(T, O) ? (E(), X("span", mre, Ie(T.name), 1)) : te("", !0),
            O !== e.breadcrumbs.length - 1 ? (E(), X("i", gre)) : te("", !0)
          ]))), 128)),
          e.shareClassItems?.length > 0 ? (E(), X(Re, { key: 0 }, [
            B[1] || (B[1] = oe("li", null, [
              oe("span", { class: "border-right" })
            ], -1)),
            oe("li", null, [
              ue(_(vi), {
                items: S.value,
                "panel-class": "d-dws-dropdown-simple",
                placeholder: _(i)("globalTranslations.shareClassSelectLabel"),
                class: "share-class-dropdown",
                "dropdown-type": _(Gt).Simple,
                onBeforeShow: b,
                onSelectedItemChanged: j
              }, null, 8, ["items", "placeholder", "dropdown-type"]),
              oe("button", {
                ref_key: "shareClassDropdownButton",
                ref: d,
                "aria-label": _(i)("breadcrumb.shareButton"),
                "data-event_component_name": "Breadcrumb",
                "data-event_title": "Share class",
                "data-event_source": _(v)
              }, null, 8, vre)
            ])
          ], 64)) : te("", !0)
        ], 544)
      ]),
      c.value ? (E(), X("div", yre, [
        ue(_(Nt), {
          class: "d-breadcrumb__right-button",
          type: _(Ke).Tertiary,
          size: _(et).Inherit,
          icon: _(H).AngleRight,
          "link-model": f("scroll right"),
          "aria-label": _(i)("breadcrumb.scrollRight"),
          onClick: $
        }, null, 8, ["type", "size", "icon", "link-model", "aria-label"])
      ])) : te("", !0),
      e.metaTags ? (E(), X("div", {
        key: 2,
        class: Pe(["d-breadcrumb__buttons gap-x-2", y.value ? "" : "over-items"])
      }, [
        oe("ul", null, [
          oe("li", null, [
            oe("div", {
              class: Pe(["social-bar__wrapper", y.value ? "" : "active"])
            }, [
              oe("div", bre, [
                (E(), X(Re, null, Ge(P, (T) => ue(Lh, {
                  key: T,
                  size: _(et).Small,
                  "button-type": _(Ke).RoundedSocial,
                  model: w.value(T)
                }, null, 8, ["size", "button-type", "model"])), 64))
              ])
            ], 2)
          ]),
          oe("li", null, [
            e.metaTags ? (E(), fe(_(Nt), {
              key: 0,
              ref_key: "shareButton",
              ref: m,
              "no-border": "",
              class: "mr-1 rounded-full",
              type: _(Ke).RoundedSocial,
              size: _(et).Small,
              icon: _(H).Share,
              "link-model": {
                contentUrl: "",
                title: "",
                target: "_self",
                isLocked: !1,
                isExternal: !1,
                linkType: _(yt).Javascript,
                tealiumTrackingModel: {
                  eventSource: _(v),
                  eventComponentName: "Text Links (same page)",
                  eventComponentHeadline: "Breadcrumb",
                  eventTitle: "Share",
                  eventLinkType: "",
                  eventTarget: "",
                  eventEngagement: "",
                  customAttributes: {}
                }
              },
              active: !y.value,
              "aria-label": _(i)("globalTranslations.tooltipTextShare"),
              onClick: B[0] || (B[0] = (T) => D())
            }, null, 8, ["type", "size", "icon", "link-model", "active", "aria-label"])) : te("", !0),
            ue(_(Nt), {
              ref_key: "printButton",
              ref: u,
              "no-border": "",
              class: "rounded-full",
              type: _(Ke).RoundedSocial,
              size: _(et).Small,
              icon: _(H).Print,
              "link-model": {
                contentUrl: "",
                title: "",
                target: "_self",
                isLocked: !1,
                isExternal: !1,
                linkType: _(yt).Javascript,
                tealiumTrackingModel: {
                  eventSource: _(v),
                  eventComponentName: "Text Links (same page)",
                  eventComponentHeadline: "Breadcrumb",
                  eventTitle: "Print",
                  eventLinkType: "",
                  eventTarget: "",
                  eventEngagement: "",
                  customAttributes: {}
                }
              },
              "aria-label": _(i)("globalTranslations.tooltipTextPrint"),
              onClick: C
            }, null, 8, ["type", "size", "icon", "link-model", "aria-label"])
          ])
        ])
      ], 2)) : te("", !0)
    ]));
  }
});
const zg = /* @__PURE__ */ Fe(kre, [["__scopeId", "data-v-c83596fb"]]);
var Vf = /* @__PURE__ */ ((e) => (e.Success = "success", e.Info = "info", e.Warn = "warn", e.Error = "error", e))(Vf || {}), xl = /* @__PURE__ */ ((e) => (e.Positive = "positive", e.Negative = "negative", e.Neutral = "neutral", e))(xl || {});
const Sre = { class: "d-colored-number" }, Cre = /* @__PURE__ */ Be({
  __name: "ColoredNumber",
  props: {
    number: {
      type: [String, Number],
      required: !0
    },
    addPercent: {
      type: Boolean,
      default: !1
    },
    percentSign: {
      type: String,
      default: "%"
    },
    colored: {
      type: Boolean,
      default: !1
    },
    additionalValue: {
      type: [String, Number],
      default: ""
    },
    addPercentToAdditionalValue: {
      type: Boolean,
      default: !1
    },
    withIcon: {
      type: Boolean,
      default: !1
    },
    zeroInterpretation: {
      type: String,
      default: xl.Neutral
    }
  },
  setup(e) {
    const t = e, { t: n } = Je(), i = Te(() => {
      switch (o()) {
        case "colorless":
          return "d-colored-number--colorless";
        case "positive":
          return "d-colored-number--positive";
        case "negative":
          return "d-colored-number--negative";
      }
    }), o = () => pm().useColorCoding || t.colored ? l() ? a() : s() ? "positive" : "negative" : "colorless", a = () => {
      switch (t.zeroInterpretation) {
        case xl.Neutral:
          return "colorless";
        case xl.Positive:
          return "positive";
        case xl.Negative:
          return "negative";
        default:
          return "colorless";
      }
    };
    function r() {
      if (t.number) {
        const h = typeof t.number == "string" ? t.number.replace(",", ".") : t.number.toString();
        return parseFloat(h);
      }
      return 0;
    }
    function s() {
      return Math.sign(r()) !== -1;
    }
    function l() {
      return t.number === "0" || t.number === 0;
    }
    const d = Te(() => {
      switch (o()) {
        case "colorless":
          return;
        case "positive":
          return H.ArrowUp;
        case "negative":
          return H.ArrowDown;
      }
    }), y = Te(() => {
      switch (o()) {
        case "colorless":
          return gt.Default;
        case "positive":
          return gt.Positive;
        case "negative":
          return gt.Negative;
      }
    }), u = Te(() => ` (${t.additionalValue}${t.addPercentToAdditionalValue ? t.percentSign : ""})`), m = Te(() => {
      switch (o()) {
        case "colorless":
          return n("coloredNumber.default");
        case "positive":
          return n("coloredNumber.positive");
        case "negative":
          return n("coloredNumber.negative");
      }
    });
    return (h, c) => (E(), X("div", Sre, [
      e.withIcon && d.value !== void 0 ? (E(), fe(_t, {
        key: 0,
        "base-icon": d.value,
        "base-icon-color": y.value,
        role: "img",
        "aria-label": m.value
      }, null, 8, ["base-icon", "base-icon-color", "aria-label"])) : te("", !0),
      e.number || e.number === 0 ? (E(), X("span", {
        key: 1,
        class: Pe(i.value)
      }, Ie(e.number) + Ie(e.addPercent ? e.percentSign : ""), 3)) : te("", !0),
      e.additionalValue ? (E(), X("span", {
        key: 2,
        class: Pe(["d-colored-number__additional-value", i.value])
      }, Ie(u.value), 3)) : te("", !0)
    ]));
  }
});
const ad = /* @__PURE__ */ Fe(Cre, [["__scopeId", "data-v-f110d9a0"]]), Eu = /* @__PURE__ */ Be({
  __name: "DataTableFieldComponent",
  props: {
    tableId: {
      type: String,
      required: !0
    },
    row: {
      type: Object,
      required: !0
    },
    field: {
      type: String,
      required: !0
    },
    subField: {
      type: Object,
      default: void 0
    },
    footNoteId: {
      type: String,
      default: ""
    },
    newPageFootnoteListVisible: {
      type: Boolean,
      default: !1
    },
    coloredPerformance: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["actionTriggered"],
  setup(e, { emit: t }) {
    const { t: n } = Je(), i = e, o = io(), a = ge(
      o.getTable(i.tableId)?.LockedItems || []
    ), r = t;
    function s(m) {
      return m?.type ? typeof m.value == "string" ? m.value : typeof m.value == "boolean" ? m.value.toString() : "" : "";
    }
    const l = (m, h, c, g) => {
      switch (c) {
        case ln.PerformanceValue:
          return At(ad, {
            number: g,
            colored: i.coloredPerformance
          });
        case ln.Tag:
          return At(Ji, {
            tagText: g,
            isBorderVisible: !0,
            backgroundColor: En.Transparent,
            Color: mi.GreyBlue009
          });
        case ln.Link:
          return At(ot, { linkModel: h.value });
        case ln.DownloadLink:
          return At(ot, {
            class: "d-datatable_column_downloadLink",
            linkModel: h.value,
            icon: H.Download,
            fontType: ya.DwsRegular,
            iconPosition: ct.Left
          });
        case ln.Text:
          return At(ht, {
            htmlText: g,
            disableDefaultStyling: !0
          });
        case ln.Boolean:
          return g === "true" ? At(_t, {
            baseIcon: H.Check,
            ariaLabel: n("globalTranslations.yes")
          }) : At(_t, {
            baseIcon: H.Ban,
            ariaLabel: n("globalTranslations.no")
          });
        case ln.MorningStarRating:
          return At(Sh, {
            model: h.value
          });
        case ln.Image:
          return At(di, {
            model: h.value,
            calculateWidth: !1
          });
        case ln.ActionMenu:
          return At(ff, {
            values: h.value,
            compareCount: a.value.length,
            fundsName: u(m),
            onActionTriggered(v, P) {
              r("actionTriggered", v, m, P);
            }
          });
        case ln.Empty:
          return At(Tt, { text: "--" });
        default:
          return At(Tt, { text: h.value });
      }
    }, d = (m, h, c = void 0) => {
      let g = m[h], v = s(m[h]), P = m[h]?.type, f = m[h]?.footnoteTitle;
      if (c) {
        const S = m[h];
        S && (g = S[c.key], v = s(S[c.key]), P = S[c.key]?.type, f = S[c.key]?.footnoteTitle);
      }
      return !v && !P && (P = ln.Empty), f && f.length > 0 ? At("div", { class: "d-datatable_column_footnote" }, [
        l(m, g, P, v),
        f.map((S) => At(ma, {
          title: S,
          specialLink: i.footNoteId,
          key: Pn(),
          componentId: i.footNoteId
        }))
      ]) : l(m, g, P, v);
    };
    function y(m, h) {
      let c;
      return Object.keys(m).some(function(g) {
        if (g === h)
          return c = m[g], !0;
        if (m[g] && typeof m[g] == "object")
          return c = y(
            m[g],
            h
          ), c !== void 0;
      }), c;
    }
    const u = (m) => y(m, "text");
    return (m, h) => (E(), fe(tt(d(e.row, e.field, e.subField))));
  }
}), Tre = { class: "d-sort-icons" }, Lre = /* @__PURE__ */ Be({
  __name: "SortIcons",
  props: {
    ascending: {
      type: Boolean,
      default: !0
    }
  },
  setup(e) {
    return (t, n) => {
      const i = $e("BaseIcon");
      return E(), X("span", Tre, [
        e.ascending ? (E(), fe(i, {
          key: 0,
          "base-icon": _(H).SortAmountUpAlt
        }, null, 8, ["base-icon"])) : te("", !0),
        e.ascending ? te("", !0) : (E(), fe(i, {
          key: 1,
          "base-icon": _(H).SortAmountDownAlt
        }, null, 8, ["base-icon"]))
      ]);
    };
  }
});
const Tp = /* @__PURE__ */ Fe(Lre, [["__scopeId", "data-v-83f58404"]]), Ire = {
  key: 0,
  class: "d-data-card__value-header"
}, Pre = {
  key: 0,
  class: "d-data-card__value-header"
}, Are = {
  key: 1,
  class: "d-data-card__value"
}, _re = /* @__PURE__ */ Be({
  __name: "DataCard",
  props: {
    header: {
      type: Array,
      required: !0
    },
    values: {
      type: Object,
      required: !0
    },
    compareCount: {
      type: Number,
      default: 0
    },
    tableId: {
      type: String,
      default: "dataCards"
    },
    alwaysVisibleKeys: {
      type: Array,
      default: () => []
    }
  },
  emits: ["actionTriggered"],
  setup(e, { emit: t }) {
    const n = e, i = t, o = io(), a = ge(!1), { t: r } = Je(), { pageName: s } = Qe(), l = Te(() => n?.alwaysVisibleKeys?.length > 0), d = ($) => a.value || (l.value ? n?.alwaysVisibleKeys?.includes($) : !0), y = Te(() => {
      const $ = a.value ? r("dataCards.showLessValues") : r("dataCards.showMoreValues");
      return {
        contentUrl: "",
        text: $,
        title: $,
        isLocked: !1,
        target: "_self",
        isExternal: !1,
        linkType: yt.Javascript,
        tealiumTrackingModel: {
          eventSource: s,
          eventComponentName: "Button",
          eventTitle: a.value ? "Load more values" : "Load less values"
        }
      };
    }), u = Te(
      () => o.getSortKey(n.tableId).split(".")[0]
    ), m = Te(() => o.getAscending(n.tableId));
    let h = !1;
    const c = ($, j) => {
      let N = 0;
      return h && (N = 1), !!($ === N && j === 0 && g());
    }, g = () => {
      const $ = Object.keys(n.values).find(
        (j) => n.values[j].type === ln.ActionMenu
      );
      return $ ? n.values[$].value : null;
    };
    function v($, j) {
      let N;
      return Object.keys($).some(function(M) {
        if (M === j)
          return N = $[M], !0;
        if ($[M] && typeof $[M] == "object")
          return N = v(
            $[M],
            j
          ), N !== void 0;
      }), N;
    }
    const P = ($) => v($, "text"), f = ($, j, N) => ($[j]?.type === ln.ActionMenu && N === 0 && (h = !0), $[j]?.type === ln.ActionMenu), S = ($) => $.colspan && $.colspan > 0;
    let w = 0, x = 0;
    const k = ($) => {
      if ($)
        w = $;
      else if (w > 0 && (x++, x === w))
        return x = 0, w = 0, !0;
      return !1;
    };
    function A($) {
      i("actionTriggered", $, n.values);
    }
    return ($, j) => {
      const N = $e("BaseText");
      return e.header && e.values ? (E(), fe(_(Ms), {
        key: 0,
        class: "d-data-card"
      }, {
        content: Se(() => [
          (E(!0), X(Re, null, Ge(e.header, (M, D) => (E(), fe(Br, { key: D }, {
            default: Se(() => [
              !f(e.values, M?.key, D) && d(M?.key) ? (E(), X("div", {
                key: 0,
                class: Pe(["d-data-card__field", {
                  "d-data-card__group-header": S(M),
                  "d-data-card__group-end": k(M.colspan)
                }])
              }, [
                Array.isArray(M.value) ? (E(!0), X(Re, { key: 0 }, Ge(M.value, (C, b) => (E(), X(Re, { key: b }, [
                  D > 1 && b === 0 ? (E(), X("div", Ire, [
                    ue(N, {
                      text: C.value,
                      "text-color": u.value === M.key && !S(M) ? _(dt).Primary : _(dt).GreyBlue009,
                      "font-type": _(lt).DwsSlabBold
                    }, null, 8, ["text", "text-color", "font-type"]),
                    u.value === M.key && !S(M) ? (E(), fe(Tp, {
                      key: 0,
                      ascending: m.value
                    }, null, 8, ["ascending"])) : te("", !0)
                  ])) : te("", !0),
                  S(M) ? te("", !0) : (E(), X("div", {
                    key: 1,
                    class: Pe({
                      "d-data-card__value-header": b === 0,
                      "d-data-card__value-header__fund-name": b === 0 && D === 1,
                      "d-data-card__value": b > 0
                    })
                  }, [
                    ue(Eu, {
                      "table-id": n.tableId,
                      row: e.values,
                      field: M.key,
                      "sub-field": C,
                      "foot-note-id": M.key
                    }, null, 8, ["table-id", "row", "field", "sub-field", "foot-note-id"]),
                    u.value === M.key && D === 0 && b === 0 ? (E(), fe(Tp, {
                      key: 0,
                      ascending: m.value
                    }, null, 8, ["ascending"])) : te("", !0),
                    c(D, b) ? (E(), fe(ff, {
                      key: 1,
                      class: "d-data-card__action-menu",
                      values: g(),
                      "compare-count": e.compareCount,
                      "funds-name": P(e.values),
                      onActionTriggered: A
                    }, null, 8, ["values", "compare-count", "funds-name"])) : te("", !0)
                  ], 2))
                ], 64))), 128)) : (E(), X(Re, { key: 1 }, [
                  D > 0 ? (E(), X("div", Pre, [
                    ue(N, {
                      text: M.value,
                      "text-color": u.value === M.key && !S(M) ? _(dt).Primary : _(dt).GreyBlue009,
                      "font-type": _(lt).DwsSlabBold
                    }, null, 8, ["text", "text-color", "font-type"]),
                    u.value === M.key && !S(M) ? (E(), fe(Tp, {
                      key: 0,
                      ascending: m.value
                    }, null, 8, ["ascending"])) : te("", !0)
                  ])) : te("", !0),
                  S(M) ? te("", !0) : (E(), X("div", Are, [
                    ue(Eu, {
                      "table-id": n.tableId,
                      row: e.values,
                      field: M.key,
                      "foot-note-id": M.key
                    }, null, 8, ["table-id", "row", "field", "foot-note-id"]),
                    c(D, 0) ? (E(), fe(ff, {
                      key: 0,
                      class: "d-data-card__action-menu",
                      values: g(),
                      "funds-name": P(e.values),
                      "compare-count": e.compareCount,
                      onActionTriggered: A
                    }, null, 8, ["values", "funds-name", "compare-count"])) : te("", !0)
                  ]))
                ], 64))
              ], 2)) : te("", !0)
            ]),
            _: 2
          }, 1024))), 128)),
          l.value ? (E(), fe(_(vt), {
            key: 0,
            class: "d-data-card__button",
            type: _(Ke).Secondary,
            "link-model": y.value,
            icon: a.value ? _(H).Minus : _(H).Plus,
            "icon-position": _(ct).Left,
            onClick: j[0] || (j[0] = (M) => a.value = !a.value)
          }, null, 8, ["type", "link-model", "icon", "icon-position"])) : te("", !0)
        ]),
        _: 1
      })) : te("", !0);
    };
  }
});
const z0 = /* @__PURE__ */ Fe(_re, [["__scopeId", "data-v-76dd5c5d"]]);
var Nc = /* @__PURE__ */ ((e) => (e.Vertical = "vertical", e.Horizontal = "horizontal", e))(Nc || {});
const Mre = ["for"], Ore = ["id"], Bre = ["for", "onClick"], Ere = {
  key: 0,
  class: "d-radio-button__figure"
}, Dre = ["src", "alt"], Rre = {
  key: 1,
  class: "d-radio-button__figure__caption"
}, Nre = {
  key: 1,
  class: "d-base-radio-button-group__label-error-text"
}, $re = /* @__PURE__ */ Be({
  __name: "BaseRadioButtonGroup",
  props: {
    model: {
      type: Object,
      required: !0
    },
    labelTextVisible: {
      type: Boolean,
      default: !0
    },
    withTooltip: {
      type: Boolean,
      default: !1
    },
    label: {
      type: String,
      default: null
    },
    helperText: {
      type: String,
      default: null
    },
    errorText: {
      type: String,
      default: null
    },
    mandatory: {
      type: Boolean,
      default: !1
    },
    hideLabel: {
      type: Boolean,
      default: !1
    },
    disabled: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["value-changed"],
  setup(e, { emit: t }) {
    const n = Pn(), i = e, o = Pn(), a = ge(i.model.selectedItem), r = ge(0), s = t, l = (g) => {
      a.value = g, s("value-changed", g);
    }, d = (g) => {
      g <= 0 && (g = 0), g >= i.model?.items?.length && (g = i.model?.items?.length - 1), Ue && document.getElementById(`${n + "-" + i.model?.items[g].id}`)?.focus();
    }, y = Te(() => i.label ? i.label.toLowerCase().replace(/\W/g, "") : o), u = Te(() => i.disabled ? dt.GreyBlue004 : dt.GreyBlue009), m = ge([]);
    zc(() => {
      m.value = [];
    }), it(async () => {
      await mt(), m.value.forEach((g, v) => {
        g && i.withTooltip && pn({
          trigger: g,
          headline: i.model.items[v].name,
          content: i.model.items[v].name,
          appendTo: g,
          showOnTouchDevices: !0,
          field: () => g
        });
      }), r.value++;
    }), qe(
      () => i.model.selectedItem,
      (g) => {
        a.value = g;
      },
      { deep: !0 }
    );
    const h = Jt(), c = (g) => !!h[g];
    return (g, v) => {
      const P = $e("BaseIcon");
      return E(), X("div", {
        class: Pe(["d-base-radio-button-group", {
          "d-base-radio-button-group--horizontal": e.model.alignment === _(Nc).Horizontal,
          "d-base-radio-button-group--vertical": e.model.alignment === _(Nc).Vertical
        }])
      }, [
        !e.hideLabel && (e.label || e.mandatory) ? (E(), X("label", {
          key: 0,
          for: y.value,
          class: "d-base-radio-button-group__input-label"
        }, [
          e.label ? (E(), fe(Tt, {
            key: 0,
            text: e.label,
            "font-size": _(st).FourteenPx,
            "text-color": u.value,
            "font-type": _(lt).DwsSlabBold
          }, null, 8, ["text", "font-size", "text-color", "font-type"])) : te("", !0),
          e.mandatory ? (E(), fe(Tt, {
            key: 1,
            text: "*",
            "font-size": _(st).FourteenPx,
            "text-color": _(dt).Negative,
            "font-type": _(lt).DwsSlabBold
          }, null, 8, ["font-size", "text-color", "font-type"])) : te("", !0),
          e.helperText ? (E(), fe(mh, {
            key: 2,
            text: e.helperText,
            "disable-helper": e.disabled,
            class: "d-base-radio-button-group__helper-text"
          }, null, 8, ["text", "disable-helper"])) : te("", !0)
        ], 8, Mre)) : te("", !0),
        oe("div", {
          id: y.value,
          class: "d-radio-buttons-container"
        }, [
          (E(!0), X(Re, null, Ge(e.model?.items, (f, S) => (E(), X("div", {
            key: `${S}_${r.value}`,
            class: Pe(["d-radio-button", {
              "d-radio-button-in-valid": !e.model?.isValid,
              "d-radio-button-disabled": e.model?.isDisabled,
              "d-radio-button-selected": f?.id === a.value?.id
            }])
          }, [
            ue(_(Or), {
              modelValue: a.value,
              "onUpdate:modelValue": v[0] || (v[0] = (w) => a.value = w),
              pt: {
                root: { name: _(n) }
              },
              name: _(n),
              value: f,
              disabled: e.model.isDisabled,
              "input-id": _(n) + "-" + f.id,
              tabindex: e.model.isDisabled ? -1 : 0,
              "data-event_source": e.model.tealiumTrackingModel?.eventSource,
              "data-event_component_name": e.model.tealiumTrackingModel?.eventComponentName,
              "data-event_title": e.model.tealiumTrackingModel?.eventTitle,
              onChange: (w) => l(f),
              onKeydown: [
                Ze(It((w) => l(f), ["prevent"]), ["enter", "space"]),
                Ze((w) => d(S + 1), ["down"]),
                Ze((w) => d(S - 1), ["up"])
              ]
            }, null, 8, ["modelValue", "pt", "name", "value", "disabled", "input-id", "tabindex", "data-event_source", "data-event_component_name", "data-event_title", "onChange", "onKeydown"]),
            oe("label", {
              for: _(n) + "-" + f.id,
              onClick: (w) => !e.model.isDisabled && l(f)
            }, [
              c("label") ? je(g.$slots, "label", {
                key: 0,
                item: f
              }, void 0, !0) : te("", !0),
              c("label") ? te("", !0) : (E(), X(Re, { key: 1 }, [
                rt(ue(ht, {
                  "html-text": f.name
                }, null, 8, ["html-text"]), [
                  [xn, e.labelTextVisible]
                ]),
                f.image ? (E(), X("figure", Ere, [
                  oe("div", {
                    ref_for: !0,
                    ref: (w) => m.value[S] = w,
                    class: "d-radio-button__figure__image"
                  }, [
                    oe("img", {
                      src: f.image.src,
                      alt: f.name
                    }, null, 8, Dre)
                  ], 512)
                ])) : te("", !0),
                f.id == a.value?.id && f.image ? (E(), X("figcaption", Rre, [
                  oe("span", null, Ie(f.name), 1)
                ])) : te("", !0)
              ], 64))
            ], 8, Bre)
          ], 2))), 128))
        ], 8, Ore),
        !e.model.isValid && e.errorText ? (E(), X("span", Nre, [
          ue(P, {
            "base-icon": _(H).ExclamationTriangle,
            "base-icon-color": _(gt).Negative,
            "base-icon-size": _(at).NextToText
          }, null, 8, ["base-icon", "base-icon-color", "base-icon-size"]),
          ue(Tt, {
            text: e.errorText,
            "font-size": _(st).TwelvePx,
            "font-type": _(lt).DwsSlabBold,
            class: "d-base-radio-button-group__label-invalid"
          }, null, 8, ["text", "font-size", "font-type"])
        ])) : te("", !0)
      ], 2);
    };
  }
});
const Vs = /* @__PURE__ */ Fe($re, [["__scopeId", "data-v-5aff23a1"]]);
var Fre = {
  root: function(t) {
    var n = t.props;
    return ["p-selectbutton p-buttonset p-component", {
      "p-disabled": n.disabled
    }];
  },
  button: function(t) {
    var n = t.instance, i = t.option;
    return ["p-button p-component", {
      "p-highlight": n.isSelected(i),
      "p-disabled": n.isOptionDisabled(i)
    }];
  },
  label: "p-button-label"
}, jre = Wt.extend({
  name: "selectbutton",
  classes: Fre
}), Hre = {
  name: "BaseSelectButton",
  extends: wt,
  props: {
    modelValue: null,
    options: Array,
    optionLabel: null,
    optionValue: null,
    optionDisabled: null,
    multiple: Boolean,
    unselectable: {
      type: Boolean,
      default: !0
    },
    allowEmpty: {
      type: Boolean,
      default: !0
    },
    disabled: Boolean,
    dataKey: null,
    ariaLabelledby: {
      type: String,
      default: null
    }
  },
  style: jre,
  provide: function() {
    return {
      $parentInstance: this
    };
  }
};
function zre(e, t) {
  var n = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (!n) {
    if (Array.isArray(e) || (n = sT(e)) || t && e && typeof e.length == "number") {
      n && (e = n);
      var i = 0, o = function() {
      };
      return { s: o, n: function() {
        return i >= e.length ? { done: !0 } : { done: !1, value: e[i++] };
      }, e: function(d) {
        throw d;
      }, f: o };
    }
    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  var a = !0, r = !1, s;
  return { s: function() {
    n = n.call(e);
  }, n: function() {
    var d = n.next();
    return a = d.done, d;
  }, e: function(d) {
    r = !0, s = d;
  }, f: function() {
    try {
      !a && n.return != null && n.return();
    } finally {
      if (r)
        throw s;
    }
  } };
}
function Vre(e) {
  return Wre(e) || Ure(e) || sT(e) || Gre();
}
function Gre() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function sT(e, t) {
  if (e) {
    if (typeof e == "string")
      return Gf(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set")
      return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return Gf(e, t);
  }
}
function Ure(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null)
    return Array.from(e);
}
function Wre(e) {
  if (Array.isArray(e))
    return Gf(e);
}
function Gf(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, i = new Array(t); n < t; n++)
    i[n] = e[n];
  return i;
}
var lT = {
  name: "SelectButton",
  extends: Hre,
  emits: ["update:modelValue", "focus", "blur", "change"],
  data: function() {
    return {
      focusedIndex: 0
    };
  },
  mounted: function() {
    this.defaultTabIndexes();
  },
  methods: {
    defaultTabIndexes: function() {
      for (var t = Oe.find(this.$refs.container, '[data-pc-section="button"]'), n = Oe.findSingle(this.$refs.container, '[data-p-highlight="true"]'), i = 0; i < t.length; i++)
        (Oe.getAttribute(t[i], "data-p-highlight") === !0 && We.equals(t[i], n) || n === null && i == 0) && (this.focusedIndex = i);
    },
    getOptionLabel: function(t) {
      return this.optionLabel ? We.resolveFieldData(t, this.optionLabel) : t;
    },
    getOptionValue: function(t) {
      return this.optionValue ? We.resolveFieldData(t, this.optionValue) : t;
    },
    getOptionRenderKey: function(t) {
      return this.dataKey ? We.resolveFieldData(t, this.dataKey) : this.getOptionLabel(t);
    },
    getPTOptions: function(t, n) {
      return this.ptm(n, {
        context: {
          active: this.isSelected(t),
          disabled: this.isOptionDisabled(t),
          option: t
        }
      });
    },
    isOptionDisabled: function(t) {
      return this.optionDisabled ? We.resolveFieldData(t, this.optionDisabled) : !1;
    },
    onOptionSelect: function(t, n, i) {
      var o = this;
      if (!(this.disabled || this.isOptionDisabled(n))) {
        var a = this.isSelected(n);
        if (!(a && !(this.unselectable && this.allowEmpty))) {
          var r = this.getOptionValue(n), s;
          this.multiple ? a ? s = this.modelValue.filter(function(l) {
            return !We.equals(l, r, o.equalityKey);
          }) : s = this.modelValue ? [].concat(Vre(this.modelValue), [r]) : [r] : s = a ? null : r, this.focusedIndex = i, this.$emit("update:modelValue", s), this.$emit("change", {
            event: t,
            value: s
          });
        }
      }
    },
    isSelected: function(t) {
      var n = !1, i = this.getOptionValue(t);
      if (this.multiple) {
        if (this.modelValue) {
          var o = zre(this.modelValue), a;
          try {
            for (o.s(); !(a = o.n()).done; ) {
              var r = a.value;
              if (We.equals(r, i, this.equalityKey)) {
                n = !0;
                break;
              }
            }
          } catch (s) {
            o.e(s);
          } finally {
            o.f();
          }
        }
      } else
        n = We.equals(this.modelValue, i, this.equalityKey);
      return n;
    },
    onKeydown: function(t, n, i) {
      switch (t.code) {
        case "Space": {
          this.onOptionSelect(t, n, i), t.preventDefault();
          break;
        }
        case "ArrowDown":
        case "ArrowRight": {
          this.changeTabIndexes(t, "next"), t.preventDefault();
          break;
        }
        case "ArrowUp":
        case "ArrowLeft": {
          this.changeTabIndexes(t, "prev"), t.preventDefault();
          break;
        }
      }
    },
    changeTabIndexes: function(t, n) {
      for (var i, o, a = 0; a <= this.$refs.container.children.length - 1; a++)
        this.$refs.container.children[a].getAttribute("tabindex") === "0" && (i = {
          elem: this.$refs.container.children[a],
          index: a
        });
      n === "prev" ? i.index === 0 ? o = this.$refs.container.children.length - 1 : o = i.index - 1 : i.index === this.$refs.container.children.length - 1 ? o = 0 : o = i.index + 1, this.focusedIndex = o, this.$refs.container.children[o].focus();
    },
    onFocus: function(t) {
      this.$emit("focus", t);
    },
    onBlur: function(t, n) {
      t.target && t.relatedTarget && t.target.parentElement !== t.relatedTarget.parentElement && this.defaultTabIndexes(), this.$emit("blur", t, n);
    }
  },
  computed: {
    equalityKey: function() {
      return this.optionValue ? null : this.dataKey;
    }
  },
  directives: {
    ripple: An
  }
}, Yre = ["aria-labelledby"], qre = ["tabindex", "aria-label", "role", "aria-checked", "aria-disabled", "onClick", "onKeydown", "onBlur", "data-p-highlight", "data-p-disabled"];
function Kre(e, t, n, i, o, a) {
  var r = Ut("ripple");
  return E(), X("div", Ce({
    ref: "container",
    class: e.cx("root"),
    role: "group",
    "aria-labelledby": e.ariaLabelledby
  }, e.ptm("root"), {
    "data-pc-name": "selectbutton"
  }), [(E(!0), X(Re, null, Ge(e.options, function(s, l) {
    return rt((E(), X("div", Ce({
      key: a.getOptionRenderKey(s),
      tabindex: l === o.focusedIndex ? "0" : "-1",
      "aria-label": a.getOptionLabel(s),
      role: e.multiple ? "checkbox" : "radio",
      "aria-checked": a.isSelected(s),
      "aria-disabled": e.optionDisabled,
      class: e.cx("button", {
        option: s
      }),
      onClick: function(y) {
        return a.onOptionSelect(y, s, l);
      },
      onKeydown: function(y) {
        return a.onKeydown(y, s, l);
      },
      onFocus: t[0] || (t[0] = function(d) {
        return a.onFocus(d);
      }),
      onBlur: function(y) {
        return a.onBlur(y, s);
      }
    }, a.getPTOptions(s, "button"), {
      "data-p-highlight": a.isSelected(s),
      "data-p-disabled": a.isOptionDisabled(s)
    }), [je(e.$slots, "option", {
      option: s,
      index: l,
      class: Pe(e.cx("label"))
    }, function() {
      return [oe("span", Ce({
        class: e.cx("label")
      }, a.getPTOptions(s, "label")), Ie(a.getOptionLabel(s)), 17)];
    })], 16, qre)), [[r]]);
  }), 128))], 16, Yre);
}
lT.render = Kre;
const Xre = { class: "d-base-select-button" }, cT = /* @__PURE__ */ Be({
  __name: "SelectButton",
  props: {
    model: {
      type: Object,
      required: !0
    },
    eventComponentName: {
      type: String,
      default: "BaseSelectButton"
    }
  },
  emits: ["value-changed"],
  setup(e, { emit: t }) {
    const n = e, i = t, o = ge(), a = ge(n.model.selectedItem), r = ge(
      n.model.selectedItem
    ), s = () => {
      o.value.$el.querySelectorAll(".p-button").forEach((m) => {
        m.hasAttribute("aria-checked") && m.removeAttribute("aria-checked");
      });
    };
    it(() => {
      a.value = n.model.selectedItem, r.value = n.model.selectedItem, l(), s();
    }), hm(() => {
      a.value = n.model.selectedItem, r.value = n.model.selectedItem, s();
    }), qe(
      () => n.model.selectedItem,
      (m, h) => {
        m !== h && (r.value = h, a.value = m);
      }
    ), qe(
      () => a.value,
      (m, h) => {
        m !== h && (r.value = h, a.value = m);
      }
    );
    const l = async () => {
      await mt(), o.value.$el.querySelectorAll('[tabindex="-1"]').forEach((h) => {
        h.setAttribute("tabindex", "0"), h.addEventListener("keypress", function(c) {
          c.key === "Enter" && (c.preventDefault(), c.target.click());
        });
      });
    }, d = Te(() => ({
      button: (m) => ({
        ariaSelected: m.context.active,
        role: "tab"
      })
    })), y = (m) => {
      i("value-changed", m), u(), l();
    }, u = async () => {
      if (await mt(), n.model.multiple)
        a.value?.forEach((h) => {
          h.isLocked !== void 0 && h.isLocked && (a.value = r.value);
        });
      else {
        const m = a.value;
        m?.isLocked !== void 0 && m.isLocked && (a.value = r.value);
      }
    };
    return (m, h) => (E(), X("div", Xre, [
      ue(_(lT), {
        ref_key: "selectButton",
        ref: o,
        modelValue: a.value,
        "onUpdate:modelValue": h[0] || (h[0] = (c) => a.value = c),
        class: Pe(["d-select-button", {
          "d-select-button-invalid": !e.model.isValid,
          "d-select-button-disabled": e.model.isDisabled
        }]),
        options: e.model.items,
        "option-label": "value",
        disabled: e.model.isDisabled,
        multiple: e.model.multiple,
        unselectable: e.model.unselectable,
        role: "tablist",
        pt: d.value,
        onChange: h[1] || (h[1] = (c) => y(c.value))
      }, {
        option: Se((c) => [
          je(m.$slots, "option", si(Ki(c)))
        ]),
        _: 3
      }, 8, ["modelValue", "class", "options", "disabled", "multiple", "unselectable", "pt"])
    ]));
  }
}), Zre = { class: "d-base-select-button-switch" }, Jre = ["data-event_source", "data-event_title", "data-event_component_name"], Qre = /* @__PURE__ */ Be({
  __name: "BaseSelectButtonSwitch",
  props: {
    model: {
      type: Object,
      required: !0
    },
    eventComponentName: {
      type: String,
      default: "BaseSelectButtonSwitch"
    },
    selected: {
      type: Object,
      default: void 0
    }
  },
  emits: ["value-changed"],
  setup(e, { emit: t }) {
    const n = e, o = ge((() => n.model.multiple ? n.model.selectedItem : n.model.selectedItem instanceof Array ? n.model.selectedItem[0] : n.model.selectedItem)());
    qe(
      () => n.selected,
      (s) => {
        s && (o.value = s);
      }
    );
    const a = t, r = (s) => {
      o.value = s, a("value-changed", o.value);
    };
    return (s, l) => (E(), X("div", Zre, [
      ue(cT, {
        model: {
          ...e.model,
          selectedItem: o.value
        },
        onValueChanged: r
      }, {
        option: Se((d) => [
          oe("span", {
            class: "p-button-label",
            "data-event_source": _(Qe)().pageName,
            "data-event_title": "Switcher | " + d.option.name,
            "data-event_component_name": e.eventComponentName
          }, Ie(d.option.name), 9, Jre)
        ]),
        _: 1
      }, 8, ["model"])
    ]));
  }
});
const dT = /* @__PURE__ */ Fe(Qre, [["__scopeId", "data-v-4f7cadeb"]]), ese = /* @__PURE__ */ Be({
  __name: "SortDialog",
  props: {
    columns: {
      type: Object,
      required: !0
    },
    sortKey: {
      type: String,
      default: ""
    },
    ascending: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["onSort"],
  setup(e, { emit: t }) {
    const n = e, { t: i } = Je(), o = {
      name: i("dataCards.ascending"),
      value: "asc"
    }, a = {
      name: i("dataCards.descending"),
      value: "desc"
    }, r = ge(!1), s = ge(), l = ge(o), d = Te(() => n.columns.filter((w) => w.sortable !== !1).map((w) => ({
      id: w.key,
      name: Array.isArray(w.value) ? w.value[0].value : w.value,
      toolTipText: ""
    }))), y = Te(() => ({
      isValid: !0,
      isDisabled: !1,
      items: d.value,
      selectedItem: s.value
    })), u = (S) => {
      s.value = d.value.find((w) => w.id === S) || d.value[0];
    };
    it(() => {
      u(n.sortKey);
    }), qe(
      () => n.columns,
      () => {
        u(n.sortKey);
      }
    ), qe(
      () => n.sortKey,
      (S) => {
        u(S);
      }
    ), qe(
      () => n.ascending,
      (S) => {
        l.value = S ? o : a;
      },
      { immediate: !0 }
    );
    const m = t, h = () => {
      if (s.value && l.value) {
        const S = {
          key: s.value.id,
          ascending: l.value.value === "asc"
        };
        m("onSort", S);
      }
    }, c = Te(() => ({
      contentUrl: "",
      title: i("dataCards.apply"),
      text: i("dataCards.apply"),
      isLocked: !1,
      isExternal: !1,
      linkType: yt.Javascript,
      tealiumTrackingModel: {
        eventSource: Qe().pageName,
        eventComponentName: "Data Card",
        eventTitle: `Sort | ${s.value?.name}`
      }
    })), g = Te(() => ({
      unselectable: !1,
      selectedItem: [l.value],
      items: [o, a]
    })), v = (S) => {
      s.value = S;
    }, P = (S) => {
      S ? l.value = S : l.value = l.value.value === o.value ? a : o;
    }, f = {
      "1280px": "90vw",
      "1024px": "90vw",
      "768px": "90vw",
      "576px": "90vw",
      "375px": "90vw",
      "320px": "90vw"
    };
    return (S, w) => {
      const x = $e("BaseHeading");
      return n.columns && n.columns.length > 0 ? (E(), fe(Ei, {
        key: 0,
        visible: r.value,
        "onUpdate:visible": w[0] || (w[0] = (k) => r.value = k),
        breakpoints: f,
        position: _(aa).Center,
        class: "d-data-cards-sort-dialog"
      }, {
        header: Se(() => [
          ue(x, {
            "base-heading-type": _(ze).H3
          }, {
            default: Se(() => [
              Ve(Ie(_(i)("dataCards.sortBy")), 1)
            ]),
            _: 1
          }, 8, ["base-heading-type"])
        ]),
        content: Se(() => [
          ue(Vs, {
            class: "d-data-cards-sort-dialog__columns",
            model: y.value,
            onValueChanged: v
          }, null, 8, ["model"])
        ]),
        footer: Se(() => [
          ue(dT, {
            class: "d-data-cards-sort-dialog__direction",
            model: g.value,
            selected: l.value,
            "event-component-name": "Data Card",
            onValueChanged: P
          }, null, 8, ["model", "selected"]),
          ue(vt, {
            "link-model": c.value,
            type: _(Ke).Primary,
            size: _(et).Large,
            icon: _(H).Check,
            "icon-position": _(ct).Left,
            class: "d-data-cards-sort-dialog__apply",
            "data-id": "silktide-accept",
            onClick: h
          }, null, 8, ["link-model", "type", "size", "icon", "icon-position"])
        ]),
        _: 1
      }, 8, ["visible", "position"])) : te("", !0);
    };
  }
});
const tse = /* @__PURE__ */ Fe(ese, [["__scopeId", "data-v-f3ebcef1"]]), nse = { class: "d-data-cards" }, ise = {
  key: 0,
  class: "d-data-cards__header"
}, ase = {
  key: 0,
  class: "d-data-cards__header__additionalContent"
}, ose = { class: "d-data-cards__load-more" }, rse = /* @__PURE__ */ Be({
  __name: "DataCards",
  props: {
    props: {
      type: Object,
      required: !0
    },
    maxLength: {
      type: Number,
      default: 15
    },
    loadMoreLength: {
      type: Number,
      default: 15
    },
    showSortBy: {
      type: Boolean,
      default: !0
    },
    alwaysVisibleKeys: {
      type: Array,
      default: () => []
    }
  },
  emits: [
    "actionTriggered",
    "updateDataTable",
    "onLoadMore",
    "sort"
  ],
  setup(e, { emit: t }) {
    const n = e, { t: i } = Je(), { pageName: o } = Qe(), a = io(), r = Jt(), s = Xi(), l = {
      eventSource: o,
      eventComponentName: "Sort",
      eventTitle: "Sort"
    }, d = ge(n.props.id || "dataCards"), y = ge(a.getLockedItems(d.value)), u = ge(a.getSortKey(d.value)), m = ge(!a.getAscending(d.value)), h = ge(), c = ge(), g = ge(!1), v = ge(n.maxLength), P = ge(n.props.values), f = ge(), S = t, w = (I, R) => {
      if (a.setSortKey(d.value, I), !n.props.lazy) {
        const Y = I.split(".")[0];
        P.value.sort(
          (F, U) => a.sortAlgorithm(Y, F, U, R)
        );
      }
      a.setAscending(d.value, R), m.value = R;
    }, x = () => {
      a.getSortKey(d.value) === "" ? (u.value = n.props.initialSort, m.value = n.props.initialSortOrder == 1) : (u.value = a.getSortKey(d.value), m.value = a.getAscending(d.value)), u?.value && (h.value = {
        key: u.value.split(".")[0],
        ascending: m.value
      }, w(u.value, m.value));
    };
    it(() => {
      x(), s.$dispose();
    }), qe(
      () => n.props.id,
      (I) => {
        I && (d.value = I, y.value = a.getLockedItems(I), x());
      },
      { immediate: !0 }
    ), qe(
      () => n.props.values,
      (I) => {
        n.props.lazy && I && f?.value ? P.value = f?.value?.concat(I) : I && (P.value = I);
      },
      { immediate: !0 }
    ), qe(
      () => a.tables,
      () => {
        y.value = a.getLockedItems(d.value);
      },
      { deep: !0 }
    );
    const k = Jn(() => {
      x();
    }, 1e3);
    Ue && wi(window, "resize", () => k(), {
      passive: !0
    });
    const A = () => {
      let I = 0;
      const R = [];
      return n.props.headerRows?.forEach((Y, F) => {
        Y.columns?.forEach((U) => {
          R.some((Q) => Q.key === U.key) || R.push(U), U.colspan && (n.props.headerRows[F + 1].columns?.slice(
            I,
            U.colspan + I
          )?.forEach((ee) => {
            R?.some((V) => V.key === ee.key) || R.push(ee);
          }), I += U.colspan);
        });
      }), R;
    }, $ = () => n.props.headerRows ? A() : n.props.columns, j = () => {
      g.value = !0;
    }, N = () => {
      g.value = !1;
    }, M = () => {
      if (n.props.lazy) {
        f.value = P.value;
        const I = f?.value?.length / n?.loadMoreLength + 1;
        S("onLoadMore", I);
      } else
        v.value = v.value + n.loadMoreLength;
    }, D = Te(() => {
      const I = P.value?.filter((R) => !y.value?.some((Y) => a.getIdentifier(Y) === a.getIdentifier(R)));
      return n.props.lazy ? I : I.slice(0, v.value);
    }), C = Te(
      () => n.props.lazy ? P?.value?.length === n?.props?.totalRecords : P?.value?.length <= v?.value
    );
    function b(I) {
      return P.value?.every(
        (R) => R[I]?.sortValue !== null && R[I]?.sortValue !== void 0
      );
    }
    const p = (I, R) => {
      if (!R)
        return "";
      if (R[I]?.value) {
        const ee = b(I) ? "sortValue" : "value";
        return `${I}.${ee}`;
      }
      const F = R[I], U = F ? Object.keys(F)[0] : void 0, J = (U ? F[U] : void 0)?.sortValue ? "sortValue" : "value";
      return `${I}.${U}.${J}`;
    }, L = (I) => {
      h.value = I, u.value = p(I.key, P.value[0]), w(u.value, I.ascending), N(), S("sort", {
        sortField: u.value,
        sortOrder: I.ascending ? 1 : -1,
        rows: v.value,
        first: 0,
        originalEvent: void 0,
        multiSortMeta: [],
        filters: void 0,
        filterMatchModes: ""
      }), n.props.lazy && (f.value = void 0, S("updateDataTable", {
        sortField: u.value,
        sortOrder: I.ascending ? 1 : -1,
        page: 1,
        rowsPerPage: v.value
      }));
    }, B = Te(() => ({
      contentUrl: "",
      title: i("dataCards.loadMore"),
      text: i("dataCards.loadMore"),
      isLocked: !1,
      target: "",
      isExternal: !1,
      linkType: za.Javascript,
      tealiumTrackingModel: {
        eventSource: o,
        eventComponentName: "Load More",
        eventTitle: "next " + n.loadMoreLength
      }
    }));
    function T(I, R) {
      switch (I.key) {
        case ga.Compare:
          I.selected ? a.addLockedItem(d.value, R) : a.removeLockedItemFromAllTables(R), y.value = a.getLockedItems(d.value);
          break;
        case ga.Bookmark:
          I.selected ? a.addBookmarkedItem(R) : a.removeBookmarkedItem(R);
          break;
      }
      S("actionTriggered", I, R);
    }
    sn(() => {
      y.value = [], u.value = "", m.value = !0, a.$dispose(), s.$dispose();
    });
    const O = (I) => !!r[I];
    return (I, R) => (E(), X("div", nse, [
      D.value?.length > 0 && (O("additionalHeaderContent") || e.showSortBy) ? (E(), X("div", ise, [
        O("additionalHeaderContent") ? (E(), X("div", ase, [
          je(I.$slots, "additionalHeaderContent", {}, void 0, !0)
        ])) : te("", !0),
        e.showSortBy ? (E(), fe(_(No), {
          key: 1,
          "tracking-model": l,
          text: _(i)("dataCards.sortBy"),
          "show-text": !0,
          icon: _(H).Sort,
          onClick: j
        }, null, 8, ["text", "icon"])) : te("", !0)
      ])) : te("", !0),
      (E(!0), X(Re, null, Ge(y.value, (Y, F) => (E(), fe(z0, {
        key: F,
        header: $(),
        values: Y,
        "compare-count": y.value.length,
        "table-id": d.value,
        "always-visible-keys": e.alwaysVisibleKeys,
        class: "d-data-cards__frozen",
        onActionTriggered: T
      }, null, 8, ["header", "values", "compare-count", "table-id", "always-visible-keys"]))), 128)),
      (E(!0), X(Re, null, Ge(D.value, (Y, F) => (E(), fe(z0, {
        key: F,
        header: $(),
        values: Y,
        "compare-count": y.value.length,
        "table-id": d.value,
        "always-visible-keys": e.alwaysVisibleKeys,
        onActionTriggered: T
      }, null, 8, ["header", "values", "compare-count", "table-id", "always-visible-keys"]))), 128)),
      oe("div", ose, [
        oe("div", {
          ref_key: "scrollTo",
          ref: c
        }, null, 512),
        C.value ? te("", !0) : (E(), fe(vt, {
          key: 0,
          "link-model": B.value,
          icon: _(H).AngleDoubleDown,
          type: _(Ke).Primary,
          size: _(et).Large,
          onClick: M
        }, null, 8, ["link-model", "icon", "type", "size"]))
      ]),
      ue(tse, {
        visible: g.value,
        "onUpdate:visible": R[0] || (R[0] = (Y) => g.value = Y),
        columns: n.props.columns,
        "sort-key": h.value?.key,
        ascending: m.value,
        onOnSort: L
      }, null, 8, ["visible", "columns", "sort-key", "ascending"])
    ]));
  }
});
const Vg = /* @__PURE__ */ Fe(rse, [["__scopeId", "data-v-f0d894b0"]]), sse = { class: "d-base-video-modal" }, lse = /* @__PURE__ */ Be({
  __name: "BaseVideoModal",
  props: {
    baseVideoPlayerProps: {
      type: Object,
      required: !0
    },
    openDialog: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["close"],
  setup(e, { emit: t }) {
    const n = e, i = ge(!1), o = t;
    qe(
      () => n.openDialog,
      (r) => {
        r && (i.value = r);
      },
      { immediate: !0 }
    ), qe(
      () => i.value,
      (r) => {
        r || o("close");
      },
      { immediate: !0 }
    );
    const a = {
      "1920px": "75vw",
      "1280px": "75vw",
      "1024px": "95vw",
      "768px": "95vw",
      "576px": "95vw",
      "375px": "95vw",
      "320px": "95vw"
    };
    return (r, s) => {
      const l = $e("BaseVideoPlayer");
      return E(), X("div", sse, [
        e.baseVideoPlayerProps ? (E(), fe(_(Ei), {
          key: 0,
          visible: i.value,
          "onUpdate:visible": s[0] || (s[0] = (d) => i.value = d),
          position: _(aa).Center,
          breakpoints: a,
          style: { width: "75vw" },
          class: "d-teaser-hero-dialog"
        }, {
          content: Se(() => [
            e.baseVideoPlayerProps ? (E(), fe(l, {
              key: 0,
              "base-video-player-props": e.baseVideoPlayerProps
            }, null, 8, ["base-video-player-props"])) : te("", !0)
          ]),
          footer: Se(() => s[1] || (s[1] = [])),
          _: 1
        }, 8, ["visible", "position"])) : te("", !0)
      ]);
    };
  }
});
const Gg = /* @__PURE__ */ Fe(lse, [["__scopeId", "data-v-70f078cb"]]), cse = {
  key: 0,
  class: "d-unordered-list"
}, dse = /* @__PURE__ */ Be({
  __name: "UnorderedList",
  props: {
    listItems: {
      type: Array,
      default: () => []
    }
  },
  setup(e) {
    return (t, n) => e.listItems && e.listItems.length > 0 ? (E(), X("ul", cse, [
      (E(!0), X(Re, null, Ge(e.listItems, (i) => (E(), X("li", { key: i }, [
        ue(_(ht), {
          "disable-default-styling": "",
          "html-text": i
        }, null, 8, ["html-text"])
      ]))), 128))
    ])) : te("", !0);
  }
});
const $c = /* @__PURE__ */ Fe(dse, [["__scopeId", "data-v-94a72da1"]]);
var use = `
@layer primevue {
    .p-inputswitch {
        display: inline-block;
    }

    .p-inputswitch-slider {
        position: absolute;
        cursor: pointer;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        border: 1px solid transparent;
    }

    .p-inputswitch-slider:before {
        position: absolute;
        content: '';
        top: 50%;
    }
}
`, hse = {
  root: {
    position: "relative"
  }
}, pse = {
  root: function(t) {
    var n = t.instance, i = t.props;
    return ["p-inputswitch p-component", {
      "p-inputswitch-checked": n.checked,
      "p-disabled": i.disabled,
      "p-focus": n.focused
    }];
  },
  slider: "p-inputswitch-slider"
}, fse = Wt.extend({
  name: "inputswitch",
  css: use,
  classes: pse,
  inlineStyles: hse
}), mse = {
  name: "BaseInputSwitch",
  extends: wt,
  props: {
    modelValue: {
      type: null,
      default: !1
    },
    trueValue: {
      type: null,
      default: !0
    },
    falseValue: {
      type: null,
      default: !1
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    inputId: {
      type: String,
      default: null
    },
    inputClass: {
      type: [String, Object],
      default: null
    },
    inputStyle: {
      type: Object,
      default: null
    },
    inputProps: {
      type: null,
      default: null
    },
    ariaLabelledby: {
      type: String,
      default: null
    },
    ariaLabel: {
      type: String,
      default: null
    }
  },
  style: fse,
  provide: function() {
    return {
      $parentInstance: this
    };
  }
}, uT = {
  name: "InputSwitch",
  extends: mse,
  emits: ["click", "update:modelValue", "change", "input", "focus", "blur"],
  data: function() {
    return {
      focused: !1
    };
  },
  methods: {
    onClick: function(t) {
      if (!this.disabled) {
        var n = this.checked ? this.falseValue : this.trueValue;
        this.$emit("click", t), this.$emit("update:modelValue", n), this.$emit("change", t), this.$emit("input", n), this.$refs.input.focus();
      }
    },
    onFocus: function(t) {
      this.focused = !0, this.$emit("focus", t);
    },
    onBlur: function(t) {
      this.focused = !1, this.$emit("blur", t);
    }
  },
  computed: {
    checked: function() {
      return this.modelValue === this.trueValue;
    }
  }
};
function Fc(e) {
  "@babel/helpers - typeof";
  return Fc = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Fc(e);
}
function V0(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    t && (i = i.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), n.push.apply(n, i);
  }
  return n;
}
function G0(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? V0(Object(n), !0).forEach(function(i) {
      gse(e, i, n[i]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : V0(Object(n)).forEach(function(i) {
      Object.defineProperty(e, i, Object.getOwnPropertyDescriptor(n, i));
    });
  }
  return e;
}
function gse(e, t, n) {
  return t = vse(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function vse(e) {
  var t = yse(e, "string");
  return Fc(t) == "symbol" ? t : String(t);
}
function yse(e, t) {
  if (Fc(e) != "object" || !e)
    return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var i = n.call(e, t || "default");
    if (Fc(i) != "object")
      return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var bse = ["id", "checked", "disabled", "aria-checked", "aria-labelledby", "aria-label"];
function xse(e, t, n, i, o, a) {
  return E(), X("div", Ce({
    class: e.cx("root"),
    style: e.sx("root"),
    onClick: t[2] || (t[2] = function(r) {
      return a.onClick(r);
    })
  }, e.ptm("root"), {
    "data-pc-name": "inputswitch"
  }), [oe("div", Ce({
    class: "p-hidden-accessible"
  }, e.ptm("hiddenInputWrapper"), {
    "data-p-hidden-accessible": !0
  }), [oe("input", Ce({
    ref: "input",
    id: e.inputId,
    type: "checkbox",
    role: "switch",
    class: e.inputClass,
    style: e.inputStyle,
    checked: a.checked,
    disabled: e.disabled,
    "aria-checked": a.checked,
    "aria-labelledby": e.ariaLabelledby,
    "aria-label": e.ariaLabel,
    onFocus: t[0] || (t[0] = function(r) {
      return a.onFocus(r);
    }),
    onBlur: t[1] || (t[1] = function(r) {
      return a.onBlur(r);
    })
  }, G0(G0({}, e.inputProps), e.ptm("hiddenInput"))), null, 16, bse)], 16), oe("span", Ce({
    class: e.cx("slider")
  }, e.ptm("slider")), null, 16)], 16);
}
uT.render = xse;
const wse = /* @__PURE__ */ Be({
  __name: "BaseInputSwitch",
  props: {
    value: {
      type: Boolean,
      default: !1
    },
    tabIndex: {
      type: Number,
      default: 0
    },
    ariaLabel: {
      type: String,
      default: null
    }
  },
  emits: ["valueChanged"],
  setup(e, { emit: t }) {
    const n = ge(), i = e;
    qe(
      () => i.value,
      () => {
        n.value = i.value;
      },
      { immediate: !0 }
    );
    const o = t;
    function a() {
      o("valueChanged", n);
    }
    return (r, s) => (E(), fe(_(uT), {
      modelValue: n.value,
      "onUpdate:modelValue": [
        s[0] || (s[0] = (l) => n.value = l),
        a
      ],
      class: "d-base-input-switch",
      "aria-label": e.ariaLabel,
      tabindex: e.tabIndex,
      onKeydown: s[1] || (s[1] = Ze(It((l) => n.value = !n.value, ["prevent"]), ["space", "enter"]))
    }, null, 8, ["modelValue", "aria-label", "tabindex"]));
  }
});
const hT = /* @__PURE__ */ Fe(wse, [["__scopeId", "data-v-e1358849"]]), kse = { class: "d-base-quote" }, Sse = /* @__PURE__ */ Be({
  __name: "BaseQuote",
  props: {
    quote: {
      type: String,
      required: !0
    }
  },
  setup(e) {
    const t = e, n = Te(() => {
      let i = t.quote.trim();
      const o = i.startsWith('"') || i.startsWith("'"), a = i.endsWith('"') || i.endsWith("'");
      return o ? i = `“${i.slice(1)}` : i = `“${i}`, a ? i = `${i.slice(0, -1)}”` : i = `${i}”`, i;
    });
    return (i, o) => {
      const a = $e("BaseText");
      return E(), X("div", kse, [
        oe("blockquote", null, [
          ue(a, {
            text: n.value,
            "font-type": _(lt).DwsSlabLight,
            class: "d-base-quote__quote"
          }, null, 8, ["text", "font-type"])
        ])
      ]);
    };
  }
});
const Uf = /* @__PURE__ */ Fe(Sse, [["__scopeId", "data-v-07070791"]]);
var Du = /* @__PURE__ */ ((e) => (e.FooterStyle = "footer-style", e))(Du || {});
const Cse = { class: "d-social-media" }, Tse = /* @__PURE__ */ Be({
  __name: "SocialMedia",
  props: {
    model: {
      type: Object,
      required: !0
    },
    buttonType: {
      type: String,
      default: Ke.RoundedPrimary
    },
    showTooltip: {
      type: Boolean,
      default: !0
    },
    footerRef: {
      type: Object,
      default: null
    }
  },
  setup(e) {
    const t = e, { t: n } = Je(), i = (s) => {
      Ue && window.open(s.href, s.target || "_blank");
    }, o = (s) => {
      const l = {
        [Pt.Facebook]: "Facebook",
        [Pt.Linkedin]: "LinkedIn",
        [Pt.Xing]: "Xing",
        [Pt.Email]: "Email",
        [Pt.Twitter]: "X",
        [Pt.Youtube]: "Youtube"
      }, d = {
        [H.FacebookF]: l[Pt.Facebook],
        [H.Linkedin]: l[Pt.Linkedin],
        [H.Xing]: l[Pt.Xing],
        [H.Envelope]: l[Pt.Email],
        [H.Twitter]: l[Pt.Twitter],
        [H.Youtube]: l[Pt.Youtube]
      };
      return s.icon ? d[s.icon] || s.icon : l[s.network];
    }, a = (s) => {
      if (s.icon)
        return s.icon;
      switch (s.network) {
        case Pt.Facebook:
          return H.FacebookF;
        case Pt.Linkedin:
          return H.LinkedinIn;
        case Pt.Xing:
          return H.Xing;
        case Pt.Email:
          return H.Envelope;
        case Pt.Twitter:
          return H.Twitter;
        case Pt.Youtube:
          return H.Youtube;
      }
    }, r = ge([]);
    return it(async () => {
      await mt(), r.value.forEach((s, l) => {
        pn({
          trigger: s?.$el,
          headline: t.model[l]?.link.text,
          content: t.model[l]?.link.text,
          appendTo: t.footerRef ? t.footerRef : "parent",
          showOnTouchDevices: !1,
          field: () => s?.$el
        });
      });
    }), (s, l) => (E(), X("div", Cse, [
      (E(!0), X(Re, null, Ge(e.model, (d, y) => (E(), X("div", {
        key: y,
        class: "d-social-media__btn"
      }, [
        ue(Nt, {
          ref_for: !0,
          ref: (u) => r.value[y] = u,
          role: "link",
          "link-model": d.link,
          type: e.buttonType !== _(Du).FooterStyle ? e.buttonType : _(Ke).RoundedPrimary,
          size: _(et).Small,
          icon: a(d),
          class: Pe(
            e.buttonType === _(Du).FooterStyle ? "d-social-media--footer-style" : ""
          ),
          "aria-label": `${_(n)("globalTranslations.open")} ${o(d)}`,
          onClick: (u) => i(d.link)
        }, null, 8, ["link-model", "type", "size", "icon", "class", "aria-label", "onClick"])
      ]))), 128))
    ]));
  }
});
const pT = /* @__PURE__ */ Fe(Tse, [["__scopeId", "data-v-b4f83709"]]), Lse = { class: "d-base-rowsperpage-dropdown" }, Ise = ["id"], Pse = { class: "d-base-rowsperpage-dropdown__dropdown" }, Ase = /* @__PURE__ */ Be({
  __name: "BaseRowsPerPageDropDown",
  props: {
    rowsPerPageOptions: {
      type: Array,
      default: () => [5, 10, 20, 50, 100]
    },
    rows: {
      type: Number,
      default: 10
    },
    eventComponentName: {
      type: String,
      default: "Paginator"
    }
  },
  emits: ["selected-item-changed"],
  setup(e, { emit: t }) {
    const { t: n } = Je(), i = t, o = e, a = ge(Pn()), r = ge(
      o.rowsPerPageOptions.map((y) => ({
        value: y,
        label: y.toString()
      }))
    ), s = ge({
      options: r.value
    }), l = ge({ value: o.rows, label: o.rows.toString() });
    function d(y) {
      l.value = { value: +y.value, label: y.value.toString() }, i("selected-item-changed", y);
    }
    return qe(
      () => o.rowsPerPageOptions,
      (y) => {
        r.value = y.map((u) => ({
          value: u,
          label: u.toString()
        }));
      },
      { immediate: !0 }
    ), qe(
      () => o.rows,
      (y) => {
        l.value = { value: y, label: y.toString() };
      },
      { immediate: !0 }
    ), (y, u) => (E(), X("div", Lse, [
      oe("label", {
        id: a.value + "-label",
        class: "d-base-rowsperpage-dropdown__text"
      }, Ie(_(n)("paginator.rowsPerPageLabel")), 9, Ise),
      oe("span", Pse, [
        ue(Oh, {
          "aria-labelledby": a.value + "-label",
          model: {
            options: s.value.options,
            selectedItem: l.value,
            componentName: e.eventComponentName
          },
          "append-to": "self",
          onSelectedItemChanged: d
        }, null, 8, ["aria-labelledby", "model"])
      ])
    ]));
  }
});
const fT = /* @__PURE__ */ Fe(Ase, [["__scopeId", "data-v-4e16b63e"]]), _se = { class: "d-base-paginator" }, Mse = /* @__PURE__ */ Be({
  __name: "BasePaginator",
  props: {
    // Zero-relative number of the first row to be displayed.
    first: {
      type: Number,
      default: 0
    },
    // Data count to display per page.
    rows: {
      type: Number,
      default: 10
    },
    // Number of page links to display.
    pageLinkSize: {
      type: Number,
      default: 5
    },
    totalRecords: {
      type: Number,
      default: 0
    },
    rowsPerPageOptions: {
      type: Array,
      default: () => [5, 10, 20, 100]
    },
    currentPageReportTemplate: {
      type: String,
      default: void 0
    },
    eventSource: {
      type: String,
      default: ""
    },
    eventComponentName: {
      type: String,
      default: "Paginator"
    }
  },
  emits: ["page-changed", "rows-per-page-changed"],
  setup(e, { emit: t }) {
    const { isMobileAsync: n, isMobile: i } = xt(), { t: o } = Je(), a = Qe().pageName, r = t, s = e, l = ge(s.rows), d = ge(0), y = ge(s.first), u = () => a + s.eventSource;
    function m(v) {
      d.value = v.page, r("page-changed", v);
    }
    function h(v) {
      y.value = 0, d.value = 0, l.value = +v.value;
      const P = {
        page: 0,
        first: 0,
        rows: l.value,
        pageCount: Math.ceil(s.totalRecords / l.value)
      };
      r("rows-per-page-changed", P);
    }
    const c = Te(() => s.currentPageReportTemplate ? s.currentPageReportTemplate : o("paginator.pageReportTemplate", {
      first: "{first}",
      last: "{last}",
      totalRecords: "{totalRecords}"
    }));
    function g(v) {
      const P = l.value >= s.totalRecords;
      return v ? P ? "" : "PrevPageLink PageLinks NextPageLink" : P ? "" : "CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink";
    }
    return qe(
      () => s.rows,
      (v) => {
        l.value = v;
      },
      { immediate: !0 }
    ), qe(
      () => s.first,
      (v) => {
        y.value = v;
      }
    ), (v, P) => (E(), X("div", _se, [
      ue(_(_m), {
        first: y.value,
        rows: l.value,
        "total-records": e.totalRecords,
        "rows-per-page-options": e.rowsPerPageOptions,
        "page-link-size": e.pageLinkSize,
        "always-show": e.rowsPerPageOptions.length > 1,
        "current-page-report-template": c.value,
        template: g(_(i)),
        pt: {
          firstPageButton: {
            "data-event_source": u(),
            "data-event_title": "firstPageButton",
            "data-event_component_name": e.eventComponentName
          },
          lastPageButton: {
            "data-event_source": u(),
            "data-event_title": "lastPageButton",
            "data-event_component_name": e.eventComponentName
          },
          previousPageButton: {
            "data-event_source": u(),
            "data-event_title": "prevPageButton",
            "data-event_component_name": e.eventComponentName
          },
          nextPageButton: {
            "data-event_source": u(),
            "data-event_title": "nextPageButton",
            "data-event_component_name": e.eventComponentName
          },
          pageButton: {
            "data-event_source": u(),
            "data-event_title": "Page " + (d.value + 1),
            "data-event_component_name": e.eventComponentName
          }
        },
        class: "d-base-paginator__paginator",
        onPage: m
      }, Qt({
        firstpagelinkicon: Se(() => [
          ue(_t, {
            "base-icon": _(H).AngleDoubleLeft,
            "base-icon-size": _(at).S
          }, null, 8, ["base-icon", "base-icon-size"])
        ]),
        prevpagelinkicon: Se(() => [
          ue(_t, {
            "base-icon": _(H).AngleLeft,
            "base-icon-size": _(at).S
          }, null, 8, ["base-icon", "base-icon-size"])
        ]),
        nextpagelinkicon: Se(() => [
          ue(_t, {
            "base-icon": _(H).AngleRight,
            "base-icon-size": _(at).S
          }, null, 8, ["base-icon", "base-icon-size"])
        ]),
        lastpagelinkicon: Se(() => [
          ue(_t, {
            "base-icon": _(H).AngleDoubleRight,
            "base-icon-size": _(at).S
          }, null, 8, ["base-icon", "base-icon-size"])
        ]),
        _: 2
      }, [
        _(n) ? void 0 : {
          name: "end",
          fn: Se(() => [
            ue(fT, {
              "rows-per-page-options": e.rowsPerPageOptions,
              rows: e.rows,
              "event-component-name": e.eventComponentName,
              onSelectedItemChanged: h
            }, null, 8, ["rows-per-page-options", "rows", "event-component-name"])
          ]),
          key: "0"
        }
      ]), 1032, ["first", "rows", "total-records", "rows-per-page-options", "page-link-size", "always-show", "current-page-report-template", "template", "pt"])
    ]));
  }
});
const od = /* @__PURE__ */ Fe(Mse, [["__scopeId", "data-v-a84e9140"]]);
var iu = /* @__PURE__ */ ((e) => (e.Tab = "tab", e.Switch = "switch", e))(iu || {});
const Ose = ["data-event_source", "data-event_title", "data-event_component_name", "aria-label"], U0 = 56, Bse = /* @__PURE__ */ Be({
  __name: "BaseSelectButtonTab",
  props: {
    model: {
      type: Object,
      required: !0
    },
    eventComponentName: {
      type: String,
      default: "BaseSelectButtonSwitch"
    },
    filterMethod: {
      type: Function,
      default: () => !0
    }
  },
  emits: ["click-on-tab"],
  setup(e, { emit: t }) {
    const n = e, { t: i } = Je(), { width: o } = Ts(), a = t, r = ge(n.model.selectedItem), s = ge(null), l = ge(!1);
    it(() => {
      l.value = s.value.clientHeight > U0;
    });
    const d = (m) => m.results ? m.name + " (" + m.results + ")" : m.name, y = Te(() => n.model.items.filter(n.filterMethod)), u = (m) => {
      r.value = m, a("click-on-tab", m);
    };
    return qe(
      () => r.value,
      (m) => {
        m && (r.value = m);
      }
    ), qe(
      () => o.value,
      async () => {
        l.value = !1, await mt(), l.value = s.value.clientHeight > U0;
      }
    ), (m, h) => (E(), X("div", {
      ref_key: "baseSelectButtonTab",
      ref: s,
      class: Pe(["d-base-select-button-tab", {
        overflown: l.value
      }])
    }, [
      ue(cT, {
        model: {
          ...e.model,
          items: y.value,
          selectedItem: r.value
        },
        onValueChanged: h[0] || (h[0] = (c) => u(c))
      }, {
        option: Se((c) => [
          oe("span", {
            class: "p-button-label",
            "data-event_source": _(Qe)().pageName,
            "data-event_title": "Tab| " + c.option.name,
            "data-event_component_name": e.eventComponentName,
            "aria-label": c.option.name + (c.option.isLocked ? _(i)("tabContainer.requiresLogin") : "")
          }, Ie(d(c.option)), 9, Ose),
          c.option.isLocked ? (E(), fe(_t, {
            key: 0,
            "base-icon": _(H).Lock
          }, null, 8, ["base-icon"])) : te("", !0)
        ]),
        _: 1
      }, 8, ["model"])
    ], 2));
  }
});
const mT = /* @__PURE__ */ Fe(Bse, [["__scopeId", "data-v-1cdd9785"]]), Ese = { class: "d-base-select-button-wrapper" }, PBe = /* @__PURE__ */ Be({
  __name: "BaseSelectButton",
  props: {
    model: {
      type: Object,
      required: !0
    },
    eventComponentName: {
      type: String,
      default: "BaseSelectButton"
    },
    selectButtonType: {
      type: String,
      default: iu.Switch
    },
    filterMethod: {
      type: Function,
      default: () => !0
    }
  },
  emits: ["value-changed"],
  setup(e, { emit: t }) {
    const n = (a) => {
      let r = a.selectedItem;
      return a.selectedItem instanceof Array && (r = a.selectedItem[0]), {
        ...a,
        selectedItem: r,
        multiple: !1
      };
    }, i = t, o = (a) => {
      i("value-changed", a);
    };
    return (a, r) => (E(), X("div", Ese, [
      e.selectButtonType === _(iu).Tab ? (E(), fe(mT, {
        key: 0,
        model: n(e.model),
        "event-component-name": e.eventComponentName,
        onClickOnTab: o
      }, null, 8, ["model", "event-component-name"])) : e.selectButtonType === _(iu).Switch ? (E(), fe(dT, {
        key: 1,
        model: e.model,
        "event-component-name": e.eventComponentName,
        selected: e.model.selectedItem,
        onValueChanged: o
      }, null, 8, ["model", "event-component-name", "selected"])) : te("", !0)
    ]));
  }
});
var rr = /* @__PURE__ */ ((e) => (e.Large = "large", e.Medium = "medium", e.Small = "small", e))(rr || {}), qn = /* @__PURE__ */ ((e) => (e.Primary = "primary", e.Secondary = "secondary", e.Grey = "grey", e.RoundedPrimary = "rounded-primary", e.RoundedSecondary = "rounded-secondary", e.RoundedNonFilled = "rounded-non-filled", e.RoundedSocial = "rounded-social", e))(qn || {}), Wf = /* @__PURE__ */ ((e) => (e.Link = "link", e.Button = "button", e))(Wf || {});
const Dse = ["href", "target", "aria-label", "data-event_linktype", "data-event_source", "data-event_target", "data-event_title", "data-event_engagement", "data-event_component_name", "data-event_component_headline"], Rse = ["target", "aria-label", "data-event_linktype", "data-event_source", "data-event_target", "data-event_title", "data-event_engagement", "data-event_component_name", "data-event_component_headline"], Nse = /* @__PURE__ */ Be({
  __name: "BaseButton",
  props: {
    linkModel: {
      type: Object,
      default: null
    },
    type: {
      type: String,
      required: !0
    },
    size: {
      type: String,
      required: !0
    },
    buttonType: {
      type: String,
      default: Wf.Link
    },
    disabled: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["click"],
  setup(e, { emit: t }) {
    const n = Jt(), i = t;
    return (o, a) => e.buttonType === _(Wf).Link ? (E(), X("a", {
      key: 0,
      href: e.linkModel?.href ?? "javascript:void(0)",
      target: e.linkModel?.target,
      class: Pe(["d-base-button", {
        "d-base-button--rounded-primary": e.type === _(qn).RoundedPrimary,
        "d-base-button--rounded-secondary": e.type === _(qn).RoundedSecondary,
        "d-base-button--rounded-non-filled": e.type === _(qn).RoundedNonFilled,
        "d-base-button--primary": e.type === _(qn).Primary,
        "d-base-button--secondary": e.type === _(qn).Secondary,
        "d-base-button--large": e.size === _(rr).Large,
        "d-base-button--medium": e.size === _(rr).Medium,
        "d-base-button--small": e.size === _(rr).Small,
        "d-disabled": e.disabled
      }]),
      tabindex: "0",
      "aria-label": e.linkModel?.title,
      "data-event_linktype": e.linkModel?.tealiumTrackingModel?.eventLinkType,
      "data-event_source": e.linkModel?.tealiumTrackingModel?.eventSource,
      "data-event_target": e.linkModel?.tealiumTrackingModel?.eventTarget,
      "data-event_title": e.linkModel?.tealiumTrackingModel?.eventTitle,
      "data-event_engagement": e.linkModel?.tealiumTrackingModel?.eventEngagement,
      "data-event_component_name": e.linkModel?.tealiumTrackingModel?.eventComponentName,
      "data-event_component_headline": e.linkModel?.tealiumTrackingModel?.eventComponentHeadline,
      onClick: a[0] || (a[0] = (r) => i("click", r))
    }, [
      _(n).leftIcon ? je(o.$slots, "leftIcon", { key: 0 }, void 0, !0) : te("", !0),
      Ve(" " + Ie(e.type !== _(qn).RoundedPrimary && e.type !== _(qn).RoundedSecondary && e.type !== _(qn).RoundedNonFilled ? e.linkModel?.text : "") + " ", 1),
      _(n).default ? je(o.$slots, "default", { key: 1 }, void 0, !0) : te("", !0),
      _(n).rightIcon ? je(o.$slots, "rightIcon", { key: 2 }, void 0, !0) : te("", !0)
    ], 10, Dse)) : (E(), X("button", {
      key: 1,
      type: "submit",
      target: e.linkModel?.target,
      class: Pe(["d-base-button", {
        "d-base-button--rounded-primary": e.type === _(qn).RoundedPrimary,
        "d-base-button--rounded-secondary": e.type === _(qn).RoundedSecondary,
        "d-base-button--rounded-non-filled": e.type === _(qn).RoundedNonFilled,
        "d-base-button--primary": e.type === _(qn).Primary,
        "d-base-button--secondary": e.type === _(qn).Secondary,
        "d-base-button--large": e.size === _(rr).Large,
        "d-base-button--medium": e.size === _(rr).Medium,
        "d-base-button--small": e.size === _(rr).Small,
        "d-disabled": e.disabled
      }]),
      tabindex: "0",
      "aria-label": e.linkModel?.title,
      "data-event_linktype": e.linkModel?.tealiumTrackingModel?.eventLinkType,
      "data-event_source": e.linkModel?.tealiumTrackingModel?.eventSource,
      "data-event_target": e.linkModel?.tealiumTrackingModel?.eventTarget,
      "data-event_title": e.linkModel?.tealiumTrackingModel?.eventTitle,
      "data-event_engagement": e.linkModel?.tealiumTrackingModel?.eventEngagement,
      "data-event_component_name": e.linkModel?.tealiumTrackingModel?.eventComponentName,
      "data-event_component_headline": e.linkModel?.tealiumTrackingModel?.eventComponentHeadline,
      onClick: a[1] || (a[1] = (r) => i("click", r))
    }, [
      _(n).leftIcon ? je(o.$slots, "leftIcon", { key: 0 }, void 0, !0) : te("", !0),
      Ve(" " + Ie(e.type !== _(qn).RoundedPrimary && e.type !== _(qn).RoundedSecondary && e.type !== _(qn).RoundedNonFilled ? e.linkModel?.text : "") + " ", 1),
      _(n).default ? je(o.$slots, "default", { key: 1 }, void 0, !0) : te("", !0),
      _(n).rightIcon ? je(o.$slots, "rightIcon", { key: 2 }, void 0, !0) : te("", !0)
    ], 10, Rse));
  }
});
const ABe = /* @__PURE__ */ Fe(Nse, [["__scopeId", "data-v-27c4e25c"]]), $se = /* @__PURE__ */ Be({
  __name: "BaseCalendar",
  props: {
    selectedDate: {
      type: Date,
      required: !0
    },
    minDate: {
      type: Date,
      default: /* @__PURE__ */ new Date("1900-01-01")
    },
    maxDate: {
      type: Date,
      default: /* @__PURE__ */ new Date()
    }
  },
  emits: ["update:selectedDate"],
  setup(e, { emit: t }) {
    Lt.extend(ks), Lt.extend(Ss);
    const n = e, i = ge(n.selectedDate), o = t, a = (r) => {
      i.value = r, o("update:selectedDate", i.value);
    };
    return qe(
      () => n.selectedDate,
      (r) => {
        i.value = r;
      },
      { immediate: !0 }
    ), (r, s) => (E(), fe(Es, {
      "input-value": i.value,
      class: "d-base-calendar",
      "input-type": _(_n).Date,
      "min-date": e.minDate,
      "max-date": e.maxDate,
      onValueChanged: a
    }, null, 8, ["input-value", "input-type", "min-date", "max-date"]));
  }
});
const W0 = /* @__PURE__ */ Fe($se, [["__scopeId", "data-v-146433dd"]]);
Lt.extend(ks);
Lt.extend(Ss);
Lt.tz.setDefault("UTC");
const Y0 = "";
function Fse(e, t) {
  if (!e?.notVisibleBefore)
    return !0;
  const n = new Date(e?.notVisibleBefore);
  return new Date(t).getTime() >= n?.getTime();
}
function jse(e) {
  const t = pm(), n = t.useColorCoding ? 'class="positive"' : "", i = t.useColorCoding ? 'class="negative"' : "", o = '<i class="las la-arrow-circle-up la-rotate-45" style="--fa-rotate-angle: 45deg;"></i>', a = '<i class="las la-arrow-circle-down la-rotate-45-minus" style="--fa-rotate-angle: -45deg;"></i>';
  let r = "";
  return e.forEach((s) => {
    r += "<tr><th>" + s.percentTitle + "</th><th>" + (s.value ? s.title : "") + "</th></tr>", r += "<tr>", s.percentage ? s.percentage >= 0 ? r += "<td><span " + n + ">" + o + " " + s.formattedPercentage + "%</span></td>" : r += "<td><span " + i + ">" + a + " " + s.formattedPercentage + "%</span></td>" : r += "<td></td>", r += "<td><span>" + (s.value ? s.formattedValue : "") + "</span></td>", r += "</tr>";
  }), r;
}
function Hse(e) {
  let t = "";
  return e.forEach((n) => {
    n.value != null && (t += "<tr><th>" + n.title + "</th></tr>", n.value >= 0 && (t += "<tr><td><span>" + n.formattedValue + "</td></tr>"));
  }), t;
}
function zse(e, t, n, i, o) {
  return '<table class="highchart-stock-chart-tooltip performanceTooltip"><thead><tr><th>' + i + "</th><th>" + o + "</th></tr><tr><td>" + e + "</td><td>" + t + "</td></tr></thead><tbody>" + jse(n) + "</tbody> </table>";
}
function Vse(e, t, n) {
  return '<table class="highchart-stock-chart-tooltip historyTooltip"><thead><tr><th>' + n + "</th></tr><tr><td>" + e + "</td></tr></thead><tbody>" + Hse(t) + "</tbody> </table>";
}
function Gse(e, t, n) {
  return '<table class="highchart-stock-chart-tooltip historyTooltip eventsTooltip"><thead><tr><th>' + t + "</th></tr><tr><td>" + e + "</td></tr></thead><tbody><tr><td>" + n + "</td></tr></tbody> </table>";
}
function Use(e, t) {
  const n = e[0];
  return t == n;
}
function Wse(e, t) {
  const n = e.values.find((o) => Use(o, t));
  return n != null ? n[1][0][0] : 0;
}
function gT(e, t, n, i, o, a) {
  const [
    r,
    s,
    l,
    d,
    y,
    u,
    m,
    h
  ] = o, c = t.chart.xAxis[0].getExtremes(), g = a(
    Lt(c.min).utc().toDate(),
    Y0
  ), v = a(
    Lt(Number(e.x)).utc().toDate(),
    Y0
  ), P = [];
  let f = !0, S = 2, w = !1;
  return o[7].startsWith("ja") && (S = 0, w = !0), e.points && e.points.forEach(function(k) {
    const A = k.series.index, $ = n.seriesConfiguration[A], j = k.x;
    if (f = $?.chartType !== "Nav" && $?.chartType !== "Index", Fse($, j)) {
      const M = Object.getOwnPropertyDescriptor(k, "point")?.value?.change, D = $?.chartType == "Nav" ? Wse(n, j) : k.y;
      P.push({
        date: j,
        value: D,
        percentage: M,
        formattedValue: D?.toLocaleString(h, {
          minimumFractionDigits: S,
          maximumFractionDigits: S,
          useGrouping: w
        }),
        formattedPercentage: M?.toLocaleString(
          h,
          {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
            useGrouping: !1
          }
        ),
        title: $?.chartType == "Nav" ? d : u,
        percentTitle: $?.chartType == "Nav" ? y : m
      });
    }
  }), f ? Gse(
    v,
    r,
    e.point?.options?.text
  ) : i ? zse(
    g,
    v,
    P,
    s,
    l
  ) : Vse(v, P, r);
}
var Ug = /* @__PURE__ */ ((e) => (e.IndexMerge = "index-merge", e.FundMerge = "fund-merge", e))(Ug || {});
const Wg = [
  Ai,
  Qu,
  Da,
  Um,
  Wm,
  Ym,
  qm,
  Sr,
  Km,
  Xm,
  fu,
  Zm,
  Jm,
  Qm,
  eg,
  tg,
  ng
], Yse = {
  positioner: function(e, t, n) {
    const i = this.chart.chartWidth, o = n.plotX + e > i ? Math.round(i - e) : Math.round(n.plotX + e / 2 - 268), a = o > 0 ? o : 0, s = n.plotY - t - 8;
    return {
      x: a,
      y: s
    };
  },
  backgroundColor: "rgba(255,255,255,0)",
  borderRadius: 12,
  shadow: !1,
  useHTML: !0,
  outside: !0,
  split: !1,
  shared: !0,
  percentageDecimals: 2
}, qse = {
  ..._s,
  accessibility: {
    enabled: !0,
    keyboardNavigation: {
      enabled: !0,
      focusBorder: {
        style: {
          lineWidth: 2,
          color: Ai,
          borderRadius: 2
        },
        margin: 2
      }
    }
  },
  chart: {
    type: "line",
    styledMode: !1,
    panning: {
      enabled: !1
    },
    zooming: {
      mouseWheel: {
        enabled: !1
      }
    },
    zoomType: "",
    style: {
      fontFamily: Is,
      fontSize: Ps
    },
    title: {
      text: ""
    }
  },
  xAxis: [
    {
      lineColor: Wi,
      crosshair: {
        interpolate: !0,
        snap: !1
      },
      tickWidth: 0,
      tickInterval: 24 * 3600 * 1e3 * 360,
      type: "datetime",
      // no hours in x-axis
      minTickInterval: 24 * 3600 * 1e3,
      dateTimeLabelFormats: {
        millisecond: "%e. %b",
        second: "%e. %b",
        minute: "%e. %b",
        hour: "%e. %b",
        day: "%e. %b",
        week: "%e. %b",
        month: "%b / %y",
        year: "%Y"
      },
      labels: {
        enabled: !0,
        step: 0,
        style: ii,
        align: "right",
        allowOverlap: !0,
        padding: 8
      },
      plotBands: [],
      plotLines: []
    }
  ],
  yAxis: [
    {
      startOnTick: !0,
      endOnTick: !1,
      lineColor: Wi,
      lineWidth: 1,
      tickWidth: 0,
      labels: {
        enabled: !1,
        step: 1,
        style: ii
      },
      title: {
        text: null
      }
    }
  ],
  plotOptions: {
    series: {
      states: {
        inactive: {
          opacity: 1
        }
      },
      marker: {
        enabled: !1,
        enabledThreshold: 10,
        states: {
          hover: {
            enabled: !0
          }
        }
      },
      animation: {
        duration: 1500
      },
      lineWidth: 1,
      showCheckbox: !1,
      compare: "percent",
      compareStart: !0,
      padding: 0,
      turboThreshold: 0,
      dataGrouping: {
        enabled: !1
      }
    },
    flags: {
      shape: "flag",
      y: -248,
      lineColor: so,
      lineWidth: 0,
      lineStyle: "ShortDot",
      dashStyle: "ShortDot",
      fillColor: so,
      height: 24,
      width: 58,
      states: {
        hover: {
          fillColor: Da,
          lineColor: Da
        }
      },
      style: {
        fontFamily: gu,
        fontWeight: As,
        fontSize: "12px",
        color: "#fff",
        borderRadius: 12
      },
      tooltip: {}
    }
  },
  series: [
    {
      marker: {
        enabled: !1,
        enabledThreshold: 1e3,
        states: {
          hover: {
            enabled: !0
          }
        }
      },
      type: "areaspline",
      fillColor: {
        linearGradient: {
          x1: 0,
          y1: 0,
          x2: 0,
          y2: 1
        },
        stops: [
          [0, "rgba(193,225,225, 1)"],
          [1, "rgba(193,225,225, 0.25)"]
        ]
      }
    }
  ],
  tooltip: Yse,
  navigator: {
    show: !1,
    adaptToUpdatedData: !0,
    maskFill: "rgba(238, 247, 247, .5)",
    color: "#fff",
    maskInside: !0,
    outlineWidth: 0,
    borderRadius: 20,
    marker: {
      enabled: !1
    },
    handles: {
      symbols: ["navigator-handle", "navigator-handle"],
      backgroundColor: "#007D85",
      borderColor: "#fff",
      color: "#fff",
      height: 24,
      width: 10,
      lineWidth: 1
    },
    height: 64,
    margin: 32,
    xAxis: {
      gridLineWidth: 0,
      labels: {
        enabled: !1
      }
    },
    series: {
      data: [],
      name: "NavigatorSeries",
      type: "areaspline",
      fillColor: {
        linearGradient: {
          x1: 0,
          y1: 0,
          x2: 0,
          y2: 1
        },
        stops: [
          [0, "rgba(193,225,225, 1)"],
          [1, "rgba(193,225,225, 0.25)"]
        ]
      }
    }
  },
  colors: Wg,
  rangeSelector: {
    buttons: [
      {
        type: "year",
        count: 1,
        text: "1y"
      }
    ],
    enabled: !0,
    selected: 0,
    floating: !0,
    y: -1e3
  },
  responsive: {
    rules: [
      {
        condition: {
          maxWidth: 576
        },
        chartOptions: {
          xAxis: [
            {
              tickWidth: 0,
              tickPosition: "inside",
              tickInterval: 24 * 3600 * 1e3 * 360,
              type: "datetime",
              // no hours in x-axis
              minTickInterval: 24 * 3600 * 1e3,
              dateTimeLabelFormats: {
                millisecond: "%e. %b",
                second: "%e. %b",
                minute: "%e. %b",
                hour: "%e. %b",
                day: "%e. %b",
                week: "%e. %b",
                month: "%b / %y",
                year: "%Y"
              },
              labels: {
                step: 0,
                style: ii,
                align: "right",
                reserveSpace: !0,
                overflow: "allow",
                allowOverlap: !0
              }
            }
          ]
        }
      }
    ]
  }
};
function Kse(e) {
  const t = [];
  for (let n = 0; n < e.seriesConfiguration.length; n++) {
    const i = e.values.map((o) => {
      const a = o[0], s = o[1][n], l = s ? s[0] : null, d = s ? s[1] : null, y = s ? s[2] : null;
      return {
        date: a,
        value: l,
        adjustedValue: d,
        performance: y
      };
    });
    t.push(i);
  }
  return t;
}
function Xse(e) {
  const t = [], n = e.seriesConfiguration;
  for (let i = 0; i < e.flags?.length; i++) {
    const o = e.flags[i], a = {
      type: "flags",
      name: "Events",
      accessibility: {
        exposeAsGroupOnly: !0,
        description: "Flagged events."
      },
      showInLegend: !1,
      data: [],
      fillColor: o.type == Ug.IndexMerge ? _k : Mk,
      // onSeries: '',
      // this is the index of the additional yAxis without labels
      yAxis: n.length,
      clip: !1,
      tooltip: {}
    }, r = {
      x: o.x,
      title: o.title,
      text: o.text
    };
    a.data?.push(r), t.push(a);
  }
  return t;
}
function Zse(e, t) {
  const n = [];
  n.push({
    color: Wi,
    from: t,
    to: t
  });
  for (let i = 0; i < e.flags?.length; i++) {
    const o = e.flags[i], a = {
      color: so,
      from: o.x,
      to: o.x
    };
    n.push(a);
  }
  return n;
}
function Jse(e, t, n) {
  const i = e.seriesConfiguration, o = Kse(e), a = [];
  for (let r = 0; r < i.length; r++) {
    const s = Wg[r], l = i[r], y = o[r].map((m) => {
      const h = m.date >= l.notVisibleBefore;
      return {
        x: m.date,
        y: t ? m.adjustedValue ? m.adjustedValue : null : m.value ? m.value : null,
        states: {
          hover: {
            halo: {
              size: 0,
              attributes: {
                fill: h ? s : "transparent"
              }
            }
          }
        },
        marker: {
          enabled: !1,
          states: {
            hover: {
              enabled: !0
            }
          },
          fillColor: h ? s : "transparent"
        }
      };
    }).filter((m) => m.x != null && m.y != null), u = {
      type: "line",
      cursor: "pointer",
      name: l.identifier,
      id: l.identifier,
      yAxis: 0,
      data: y,
      pointStart: l.notVisibleBefore,
      color: s,
      dashStyle: l.chartType === "Nav" ? "Solid" : "ShortDot",
      zIndex: r == 0 ? 1 : 0,
      zoneAxis: "x",
      states: {
        inactive: {
          opacity: 1
        },
        hover: {
          halo: {
            size: 8,
            attributes: {
              fill: s
            }
          }
        }
      },
      marker: {
        enabled: !1,
        radius: 0,
        states: {
          hover: {
            enabled: !0,
            radius: 4,
            radiusPlus: 2
          }
        }
      },
      zones: [
        {
          color: "transparent"
        },
        {
          value: l.notVisibleBefore,
          color: s
        }
      ]
    };
    if (a.push(u), !t && n)
      break;
  }
  return a;
}
function Qse(e, t) {
  const n = e.seriesConfiguration, i = [];
  for (let a = 0; a < n.length; a++) {
    const r = Wg[a], s = a == 0 ? t : null, l = {
      labels: {
        enabled: !0,
        step: 1,
        style: {
          color: a == 0 ? so : r,
          fontWeight: As,
          fontSize: Ps,
          fontFamily: Is
        }
      },
      title: {
        text: s,
        style: ii
      },
      opposite: a != 0,
      showEmpty: !1,
      allowDecimals: !1
    };
    i.push(l);
  }
  const o = {
    labels: {
      enabled: !1
    },
    title: {
      text: null
    }
  };
  return i.push(o), i;
}
function ele(e, t) {
  for (var n = -1, i = e == null ? 0 : e.length; ++n < i && t(e[n], n, e) !== !1; )
    ;
  return e;
}
var tle = ele, nle = TC, ile = nle(Object.keys, Object), ale = ile, ole = Ig, rle = ale, sle = Object.prototype, lle = sle.hasOwnProperty;
function cle(e) {
  if (!ole(e))
    return rle(e);
  var t = [];
  for (var n in Object(e))
    lle.call(e, n) && n != "constructor" && t.push(n);
  return t;
}
var dle = cle, ule = MC, hle = dle, ple = js;
function fle(e) {
  return ple(e) ? ule(e) : hle(e);
}
var rd = fle, mle = nd, gle = rd;
function vle(e, t) {
  return e && mle(t, gle(t), e);
}
var yle = vle, ble = nd, xle = id;
function wle(e, t) {
  return e && ble(t, xle(t), e);
}
var kle = wle;
function Sle(e, t) {
  for (var n = -1, i = e == null ? 0 : e.length, o = 0, a = []; ++n < i; ) {
    var r = e[n];
    t(r, n, e) && (a[o++] = r);
  }
  return a;
}
var vT = Sle;
function Cle() {
  return [];
}
var yT = Cle, Tle = vT, Lle = yT, Ile = Object.prototype, Ple = Ile.propertyIsEnumerable, q0 = Object.getOwnPropertySymbols, Ale = q0 ? function(e) {
  return e == null ? [] : (e = Object(e), Tle(q0(e), function(t) {
    return Ple.call(e, t);
  }));
} : Lle, Yg = Ale, _le = nd, Mle = Yg;
function Ole(e, t) {
  return _le(e, Mle(e), t);
}
var Ble = Ole;
function Ele(e, t) {
  for (var n = -1, i = t.length, o = e.length; ++n < i; )
    e[o + n] = t[n];
  return e;
}
var bT = Ele, Dle = bT, Rle = Lg, Nle = Yg, $le = yT, Fle = Object.getOwnPropertySymbols, jle = Fle ? function(e) {
  for (var t = []; e; )
    Dle(t, Nle(e)), e = Rle(e);
  return t;
} : $le, xT = jle, Hle = nd, zle = xT;
function Vle(e, t) {
  return Hle(e, zle(e), t);
}
var Gle = Vle, Ule = bT, Wle = oa;
function Yle(e, t, n) {
  var i = t(e);
  return Wle(e) ? i : Ule(i, n(e));
}
var wT = Yle, qle = wT, Kle = Yg, Xle = rd;
function Zle(e) {
  return qle(e, Xle, Kle);
}
var kT = Zle, Jle = wT, Qle = xT, ece = id;
function tce(e) {
  return Jle(e, ece, Qle);
}
var nce = tce, ice = Er, ace = wa, oce = ice(ace, "DataView"), rce = oce, sce = Er, lce = wa, cce = sce(lce, "Promise"), dce = cce, uce = Er, hce = wa, pce = uce(hce, "Set"), fce = pce, mce = Er, gce = wa, vce = mce(gce, "WeakMap"), yce = vce, Yf = rce, qf = kg, Kf = dce, Xf = fce, Zf = yce, ST = Rs, Gs = vC, K0 = "[object Map]", bce = "[object Object]", X0 = "[object Promise]", Z0 = "[object Set]", J0 = "[object WeakMap]", Q0 = "[object DataView]", xce = Gs(Yf), wce = Gs(qf), kce = Gs(Kf), Sce = Gs(Xf), Cce = Gs(Zf), sr = ST;
(Yf && sr(new Yf(new ArrayBuffer(1))) != Q0 || qf && sr(new qf()) != K0 || Kf && sr(Kf.resolve()) != X0 || Xf && sr(new Xf()) != Z0 || Zf && sr(new Zf()) != J0) && (sr = function(e) {
  var t = ST(e), n = t == bce ? e.constructor : void 0, i = n ? Gs(n) : "";
  if (i)
    switch (i) {
      case xce:
        return Q0;
      case wce:
        return K0;
      case kce:
        return X0;
      case Sce:
        return Z0;
      case Cce:
        return J0;
    }
  return t;
});
var Bh = sr, Tce = Object.prototype, Lce = Tce.hasOwnProperty;
function Ice(e) {
  var t = e.length, n = new e.constructor(t);
  return t && typeof e[0] == "string" && Lce.call(e, "index") && (n.index = e.index, n.input = e.input), n;
}
var Pce = Ice, Ace = Tg;
function _ce(e, t) {
  var n = t ? Ace(e.buffer) : e.buffer;
  return new e.constructor(n, e.byteOffset, e.byteLength);
}
var Mce = _ce, Oce = /\w*$/;
function Bce(e) {
  var t = new e.constructor(e.source, Oce.exec(e));
  return t.lastIndex = e.lastIndex, t;
}
var Ece = Bce, e1 = td, t1 = e1 ? e1.prototype : void 0, n1 = t1 ? t1.valueOf : void 0;
function Dce(e) {
  return n1 ? Object(n1.call(e)) : {};
}
var Rce = Dce, Nce = Tg, $ce = Mce, Fce = Ece, jce = Rce, Hce = SC, zce = "[object Boolean]", Vce = "[object Date]", Gce = "[object Map]", Uce = "[object Number]", Wce = "[object RegExp]", Yce = "[object Set]", qce = "[object String]", Kce = "[object Symbol]", Xce = "[object ArrayBuffer]", Zce = "[object DataView]", Jce = "[object Float32Array]", Qce = "[object Float64Array]", ede = "[object Int8Array]", tde = "[object Int16Array]", nde = "[object Int32Array]", ide = "[object Uint8Array]", ade = "[object Uint8ClampedArray]", ode = "[object Uint16Array]", rde = "[object Uint32Array]";
function sde(e, t, n) {
  var i = e.constructor;
  switch (t) {
    case Xce:
      return Nce(e);
    case zce:
    case Vce:
      return new i(+e);
    case Zce:
      return $ce(e, n);
    case Jce:
    case Qce:
    case ede:
    case tde:
    case nde:
    case ide:
    case ade:
    case ode:
    case rde:
      return Hce(e, n);
    case Gce:
      return new i();
    case Uce:
    case qce:
      return new i(e);
    case Wce:
      return Fce(e);
    case Yce:
      return new i();
    case Kce:
      return jce(e);
  }
}
var lde = sde, cde = Bh, dde = go, ude = "[object Map]";
function hde(e) {
  return dde(e) && cde(e) == ude;
}
var pde = hde, fde = pde, mde = _g, i1 = Mg, a1 = i1 && i1.isMap, gde = a1 ? mde(a1) : fde, vde = gde, yde = Bh, bde = go, xde = "[object Set]";
function wde(e) {
  return bde(e) && yde(e) == xde;
}
var kde = wde, Sde = kde, Cde = _g, o1 = Mg, r1 = o1 && o1.isSet, Tde = r1 ? Cde(r1) : Sde, Lde = Tde, Ide = xh, Pde = tle, Ade = _C, _de = yle, Mde = kle, Ode = wC, Bde = CC, Ede = Ble, Dde = Gle, Rde = kT, Nde = nce, $de = Bh, Fde = Pce, jde = lde, Hde = LC, zde = oa, Vde = wh, Gde = vde, Ude = Wa, Wde = Lde, Yde = rd, qde = id, Kde = 1, Xde = 2, Zde = 4, CT = "[object Arguments]", Jde = "[object Array]", Qde = "[object Boolean]", eue = "[object Date]", tue = "[object Error]", TT = "[object Function]", nue = "[object GeneratorFunction]", iue = "[object Map]", aue = "[object Number]", LT = "[object Object]", oue = "[object RegExp]", rue = "[object Set]", sue = "[object String]", lue = "[object Symbol]", cue = "[object WeakMap]", due = "[object ArrayBuffer]", uue = "[object DataView]", hue = "[object Float32Array]", pue = "[object Float64Array]", fue = "[object Int8Array]", mue = "[object Int16Array]", gue = "[object Int32Array]", vue = "[object Uint8Array]", yue = "[object Uint8ClampedArray]", bue = "[object Uint16Array]", xue = "[object Uint32Array]", fn = {};
fn[CT] = fn[Jde] = fn[due] = fn[uue] = fn[Qde] = fn[eue] = fn[hue] = fn[pue] = fn[fue] = fn[mue] = fn[gue] = fn[iue] = fn[aue] = fn[LT] = fn[oue] = fn[rue] = fn[sue] = fn[lue] = fn[vue] = fn[yue] = fn[bue] = fn[xue] = !0;
fn[tue] = fn[TT] = fn[cue] = !1;
function au(e, t, n, i, o, a) {
  var r, s = t & Kde, l = t & Xde, d = t & Zde;
  if (n && (r = o ? n(e, i, o, a) : n(e)), r !== void 0)
    return r;
  if (!Ude(e))
    return e;
  var y = zde(e);
  if (y) {
    if (r = Fde(e), !s)
      return Bde(e, r);
  } else {
    var u = $de(e), m = u == TT || u == nue;
    if (Vde(e))
      return Ode(e, s);
    if (u == LT || u == CT || m && !o) {
      if (r = l || m ? {} : Hde(e), !s)
        return l ? Dde(e, Mde(r, e)) : Ede(e, _de(r, e));
    } else {
      if (!fn[u])
        return o ? e : {};
      r = jde(e, u, s);
    }
  }
  a || (a = new Ide());
  var h = a.get(e);
  if (h)
    return h;
  a.set(e, r), Wde(e) ? e.forEach(function(v) {
    r.add(au(v, t, n, v, e, a));
  }) : Gde(e) && e.forEach(function(v, P) {
    r.set(P, au(v, t, n, P, e, a));
  });
  var c = d ? l ? Nde : Rde : l ? qde : Yde, g = y ? void 0 : c(e);
  return Pde(g || e, function(v, P) {
    g && (P = v, v = e[P]), Ade(r, P, au(v, t, n, P, e, a));
  }), r;
}
var wue = au, kue = wue, Sue = 1, Cue = 4;
function Tue(e) {
  return kue(e, Sue | Cue);
}
var Lue = Tue;
const qg = /* @__PURE__ */ en(Lue), Iue = () => {
  const { currentLocale: e, t } = Je(), { localesPrimeVue: n } = Li(), { formatDateWithPrimeFormat: i } = vm(), o = ge(), a = ge(), r = ge($()), s = ge(j()), l = {}, d = ge(), y = ge(), u = ge(null), m = ge();
  function h(C) {
    o.value = C, S(), a.value = o.value;
  }
  async function c() {
    const C = v();
    m.value = C;
    const b = C.tooltip;
    b.formatter = function(B) {
      const T = t("globalTranslations.date"), O = t("globalTranslations.startDate"), I = t("globalTranslations.endDate"), R = t("performanceChart.nav"), Y = t("performanceChart.navPercent"), F = t("performanceChart.indexLevel"), U = t("performanceChart.indexLevelPercent"), Q = [
        T,
        O,
        I,
        R,
        Y,
        F,
        U,
        e.value.toString()
      ];
      return o.value ? gT(
        this,
        B,
        o.value,
        !0,
        Q,
        i
      ) : "";
    };
    const p = C.xAxis[0];
    p.events = {
      ...p.events,
      afterSetExtremes(B) {
        P(B);
      }
    };
    const L = C.chart;
    L.events = {
      ...L.events,
      load() {
        a.value = this, y.value = a.value?.series.find(
          (B) => B.name == "NavigatorSeries"
        ), d.value = a.value?.series[0];
      }
    }, await g();
  }
  async function g() {
    await mt();
    const C = j(), b = Math.round(C.getTime()), p = Math.round(
      l[u.value.type].getTime()
    );
    M(p, b);
  }
  function v() {
    const C = qg(qse);
    if (!o.value)
      return C;
    const b = Jse(o.value, !0, !1), p = Xse(o.value), L = +o.value.values[0][0], B = Zse(o.value, L), T = Qse(
      o.value,
      t("performanceChart.performanceYaxisLabel")
    );
    if (C.yAxis = T, C.series = b, p?.length != 0 && (C.series.push(...p), C.xAxis[0]?.plotBands?.push(...B)), C.navigator != null) {
      const O = C.navigator?.series, I = b[0];
      O.data = I.data;
    }
    if (n) {
      let O = n?.findIndex(
        (R) => R.locale.toLowerCase() === e.value.toString().toLowerCase()
      );
      O < 0 && (O = n?.findIndex(
        (R) => R.locale.toLowerCase() === "en"
      ));
      const I = {
        months: n[O].monthNames,
        weekdays: n[O].dayNames,
        shortMonths: n[O].monthNamesShort,
        accessibility: {
          chartContainerLabel: t("performanceChart.chartAriaLabel")
        }
      };
      eo.setOptions({ lang: I }), C.lang = I;
    }
    return C;
  }
  function P(C) {
    if (C.trigger == "navigator") {
      const b = a.value?.xAxis[0].series[0].data?.filter(
        (B) => B.x >= C.min && B.x <= C.max
      ).map((B) => B.x) ?? [], p = Math.max(...b), L = Math.min(...b);
      r.value = new Date(L), s.value = new Date(p), u.value = null, (C.min !== L || C.max !== p) && f(r.value, s.value);
    }
  }
  function f(C, b) {
    const p = C.getTime(), L = b.getTime();
    a.value?.xAxis?.length && a.value.xAxis[0].setExtremes(p, L, !0);
  }
  function S() {
    const C = j(), b = $();
    l["1M"] = new Date(
      C.getFullYear(),
      C.getMonth() - 1,
      C.getDate()
    ), l["3M"] = new Date(
      C.getFullYear(),
      C.getMonth() - 3,
      C.getDate()
    ), l["6M"] = new Date(
      C.getFullYear(),
      C.getMonth() - 6,
      C.getDate()
    ), l.YTD = new Date(C.getFullYear(), 0, 1), l["1Y"] = new Date(
      C.getFullYear() - 1,
      C.getMonth(),
      C.getDate()
    ), l["3Y"] = new Date(
      C.getFullYear() - 3,
      C.getMonth(),
      C.getDate()
    ), l["5Y"] = new Date(
      C.getFullYear() - 5,
      C.getMonth(),
      C.getDate()
    ), l["10Y"] = new Date(
      C.getFullYear() - 10,
      C.getMonth(),
      C.getDate()
    ), l["20Y"] = new Date(
      C.getFullYear() - 20,
      C.getMonth(),
      C.getDate()
    ), l.MAX = new Date(
      b.getFullYear(),
      b.getMonth(),
      b.getDate()
    ), o.value?.usePreviousBusinessDateForCalculation && (l["1M"] = w(l["1M"]), l["3M"] = w(l["3M"]), l["6M"] = w(l["6M"]), l.YTD = w(l.YTD), l["1Y"] = w(l["1Y"]), l["3Y"] = w(l["3Y"]), l["5Y"] = w(l["5Y"]), l["10Y"] = w(l["10Y"]), l["20Y"] = w(l["20Y"]), l.MAX = w(l.MAX));
  }
  function w(C) {
    const b = $().getTime(), p = Date.UTC(
      C.getFullYear(),
      C.getMonth(),
      C.getDate()
    ), L = new Date(p);
    for (; !x(L) && L.getTime() > b; )
      L.setDate(L.getDate() - 1);
    return L;
  }
  function x(C) {
    const b = C.getTime();
    let p = !1;
    const L = o.value.values;
    let B = 1;
    for (let T = L.length - 1; T >= 0; T--)
      if (B = L[T][0], B === b) {
        p = !0;
        break;
      }
    return p;
  }
  function k(C) {
    u.value = C;
    const b = l[C.type], p = Math.round(j().getTime()), L = Math.round(b.getTime());
    b != null && M(L, p);
  }
  function A(C) {
    let b = 0, p = 0;
    if (C.type !== "MAX" && C.type !== "YTD") {
      const T = parseInt(C.type.substring(-3, 2)), I = C.type.substring(-1) === "M" ? 1 : 12;
      p = T * I;
    }
    const L = $(), B = j();
    return b = N(B, L), p >= b;
  }
  function $() {
    if (!o.value)
      return /* @__PURE__ */ new Date();
    const C = o.value.values[0], b = Object.values(C)[0];
    return new Date(b);
  }
  function j() {
    if (!o.value)
      return /* @__PURE__ */ new Date();
    const C = o.value.values[o.value.values?.length - 1], b = Object.values(C)[0];
    return new Date(b);
  }
  function N(C, b) {
    const p = C.getMonth() - b.getMonth(), L = C.getFullYear() - b.getFullYear();
    return p + L * 12;
  }
  function M(C, b) {
    r.value = new Date(C), s.value = new Date(b), a.value?.xAxis?.length && (a.value.xAxis[0].setExtremes(Math.round(C), Math.round(b), !0), a.value.redraw(!0));
  }
  function D(C) {
    if (a.value?.series) {
      let b = a.value?.series[0]?.points[0] ?? { x: 0, y: 0 };
      return a.value?.series[0]?.points.forEach((p) => {
        p.x <= C && b.x < p.x && (b = p);
      }), b;
    }
    return { x: 0, y: 0 };
  }
  return {
    loadChart: c,
    chartOptions: m,
    changePeriod: k,
    checkNumberMonths: A,
    activePeriodButton: u,
    setChartData: h,
    getFirstDate: $,
    getLastDate: j,
    getLastVisiblePoint: D,
    endDate: s,
    chart: a
  };
};
var la = /* @__PURE__ */ ((e) => (e.BOOL = "BOOL", e.MORNINGSTAR = "MORNINGSTAR", e.LIPPERRATING = "LIPPERRATING", e.SRRI = "SRRI", e.STRING = "STRING", e.IMAGELIST = "IMAGELIST", e.URLLIST = "URLLIST", e.NAV = "NAV", e.URLDROPDOWN = "URLDROPDOWN", e))(la || {});
const Pue = ["data-event_linktype", "data-event_source", "data-event_target", "data-event_title", "data-event_engagement", "data-event_component_name", "data-event_component_headline"], Aue = /* @__PURE__ */ Be({
  __name: "BaseListUrlDropdown",
  props: {
    model: {
      type: Object,
      required: !0
    },
    ariaLabelledby: {
      type: String,
      default: void 0
    }
  },
  setup(e) {
    const t = e, n = ge(t.model.selectedValue), i = ge(), o = Te(() => t.model.sortAscendingByText ? t.model.value.sort((s, l) => s.text === null || s.text === void 0 ? -1 : l.text === null || l.text === void 0 ? 1 : s.text < l.text ? -1 : 1) : t.model.value);
    function a() {
      return i?.value && (i.value.removeAttribute("hidden"), i.value.click(), i.value.setAttribute("hidden", "hidden")), !0;
    }
    function r(s) {
      Ue && s && window.open(s.href, "_self");
    }
    return (s, l) => (E(), X(Re, null, [
      ue(_(Ga), {
        modelValue: n.value,
        "onUpdate:modelValue": l[0] || (l[0] = (d) => n.value = d),
        class: "d-base-list__item__url-dropdown",
        "option-label": "text",
        "panel-class": "d-dws-dropdown-simple",
        options: o.value,
        placeholder: e.model.placeholderText,
        "aria-labelledby": e.ariaLabelledby,
        pt: {
          item: {
            class: "d-dws-dropdown-item-simple",
            style: "padding: 1.125rem 1rem !important;"
          }
        },
        onChange: l[1] || (l[1] = (d) => r(n.value)),
        onBeforeShow: a
      }, null, 8, ["modelValue", "options", "placeholder", "aria-labelledby"]),
      oe("button", {
        ref_key: "tealiumTriggerButton",
        ref: i,
        "data-event_linktype": e.model?.tealiumTrackingModel?.eventLinkType,
        "data-event_source": e.model?.tealiumTrackingModel?.eventSource,
        "data-event_target": e.model?.tealiumTrackingModel?.eventTarget,
        "data-event_title": e.model?.tealiumTrackingModel?.eventTitle,
        "data-event_engagement": e.model?.tealiumTrackingModel?.eventEngagement,
        "data-event_component_name": e.model?.tealiumTrackingModel?.eventComponentName,
        "data-event_component_headline": e.model?.tealiumTrackingModel?.eventComponentHeadline,
        hidden: "",
        "aria-hidden": ""
      }, " . ", 8, Pue)
    ], 64));
  }
}), _ue = { class: "lipper-rating" }, Mue = ["id", "data-tooltip"], Oue = /* @__PURE__ */ Be({
  __name: "LipperRating",
  props: {
    model: {
      type: Object,
      required: !0
    }
  },
  setup(e) {
    const t = Pn(), n = ge([]);
    return it(() => {
      Ue && n.value.forEach((i) => {
        pn({
          trigger: i,
          content: i.getAttribute("data-tooltip") ?? "",
          appendTo: i,
          showOnTouchDevices: !0,
          field: () => i
        });
      });
    }), (i, o) => (E(), X("div", _ue, [
      (E(!0), X(Re, null, Ge(e.model.values, (a, r) => (E(), X("span", {
        id: `rate-${r}-${_(t)}`,
        ref_for: !0,
        ref_key: "itemRefs",
        ref: n,
        key: r,
        "data-tooltip": a.text + ": " + a.rating,
        class: Pe([{
          "lipper-circle-inverted": a.rating === 5,
          "lipper-circle ": a.rating >= 1 && a.rating <= 4
        }, "inline-block"])
      }, Ie(a.rating), 11, Mue))), 128))
    ]));
  }
});
const Bue = /* @__PURE__ */ Fe(Oue, [["__scopeId", "data-v-26fb29e2"]]);
const Eue = { class: "performance-icon" }, IT = /* @__PURE__ */ Be({
  __name: "PerformanceIcon",
  props: {
    isPositive: { type: Boolean }
  },
  setup(e) {
    const t = e;
    return (n, i) => (E(), X("span", Eue, [
      oe("i", {
        class: Pe(["las", {
          "la-arrow-circle-up las__rotate-45 green-text": t.isPositive === !0,
          "la-arrow-circle-down las__rotate-45-minus red-text": t.isPositive !== void 0 && t.isPositive !== null && t.isPositive == !1
        }])
      }, null, 2)
    ]));
  }
}), Due = {
  key: 0,
  class: "d-base-list"
}, Rue = { class: "d-base-list__item__label" }, Nue = ["id"], $ue = { key: 1 }, Fue = ["data-field", "data-item", "data-grid", "data-source"], jue = {
  key: 3,
  class: "d-base-list__item__label__date"
}, Hue = {
  key: 0,
  class: "d-base-list__item__value"
}, zue = {
  key: 1,
  class: "d-base-list__item__value"
}, Vue = {
  key: 2,
  class: "d-base-list__item__value"
}, Gue = {
  key: 3,
  class: "d-base-list__item__value d-base-list__item__value__lipper-rating"
}, Uue = {
  key: 4,
  class: "d-base-list__item__value"
}, Wue = ["data-field", "data-item"], Yue = {
  key: 0,
  class: "d-base-list__item__value__nav"
}, que = { class: "d-base-list__item__value__nav__performance" }, Kue = {
  key: 5,
  class: "d-base-list__item__value category-list"
}, Xue = {
  key: 6,
  class: "d-base-list__item__value category-list"
}, Zue = {
  key: 7,
  class: "d-base-list__item__value item-list-images"
}, Jue = ["src", "alt"], Que = {
  key: 8,
  class: "d-base-list__item__value d-base-list__item__value__srri-indicator"
}, ehe = {
  key: 9,
  class: "d-base-list__item__value"
}, the = /* @__PURE__ */ Be({
  __name: "BaseList",
  props: {
    model: {
      type: Object,
      required: !0
    },
    useDynamicFootnote: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const t = Pn(), n = (o) => o.value, i = (o) => o.value;
    return (o, a) => e.model?.items && e.model.items.length > 0 ? (E(), X("ul", Due, [
      (E(!0), X(Re, null, Ge(e.model.items, (r) => (E(), X("li", {
        key: r.key,
        class: "d-base-list__item"
      }, [
        oe("span", Rue, [
          oe("div", {
            id: r.key.replaceAll(" ", "-") + "-" + _(t),
            class: "w-auto inline-block"
          }, [
            r.tooltip ? (E(), fe(tu, {
              key: 0,
              "item-text": r.key,
              "item-overlay-text": r.tooltip,
              "footnote-reference-id": e.model.footnoteReferenceId ?? e.model.id
            }, null, 8, ["item-text", "item-overlay-text", "footnote-reference-id"])) : (E(), X("div", $ue, [
              e.useDynamicFootnote ? (E(), fe(_(ss), {
                key: 0,
                html: r.key,
                purify: !1
              }, null, 8, ["html"])) : (E(), fe(li, {
                key: 1,
                "foot-note-id": e.model.footnoteReferenceId ?? e.model.id,
                text: r.key
              }, null, 8, ["foot-note-id", "text"]))
            ])),
            r.type === _(la).NAV ? (E(), X("span", {
              key: 2,
              class: "d-base-list__item__label__date",
              "data-field": r.value.iNaveDateField,
              "data-item": r.value.solactiveTicker,
              "data-grid": r.gridIdentifier,
              "data-source": r.sourceIdentifier
            }, Ie(r.date), 9, Fue)) : (E(), X("span", jue, Ie(r.date), 1))
          ], 8, Nue)
        ]),
        r.type === _(la).BOOL && n(r) ? (E(), X("span", Hue, [
          ue(_t, {
            "base-icon": _(H).CheckCircle,
            "base-icon-color": _(gt).GreyBlue008
          }, null, 8, ["base-icon", "base-icon-color"])
        ])) : r.type === _(la).BOOL && !n(r) ? (E(), X("span", zue, [
          ue(_t, {
            "base-icon": _(H).Ban,
            "base-icon-color": _(gt).GreyBlue008
          }, null, 8, ["base-icon", "base-icon-color"])
        ])) : r.type === _(la).MORNINGSTAR ? (E(), X("span", Vue, [
          ue(Sh, {
            model: r.value
          }, null, 8, ["model"])
        ])) : r.type === _(la).LIPPERRATING ? (E(), X("span", Gue, [
          ue(Bue, {
            model: { values: i(r) }
          }, null, 8, ["model"])
        ])) : r.type === _(la).NAV ? (E(), X("span", Uue, [
          oe("div", {
            "data-field": r.value.iNavField,
            "data-item": r.value.solactiveTicker,
            "data-grid": "currentPrices",
            "data-source": "lightstreamer"
          }, Ie(r.value.price), 9, Wue),
          r.value.performance ? (E(), X("span", Yue, [
            r.value.isPositive !== void 0 && r.value.isPositive !== null ? (E(), fe(IT, {
              key: 0,
              "is-positive": r.value.isPositive
            }, null, 8, ["is-positive"])) : te("", !0),
            oe("span", que, Ie(r.value.performance), 1)
          ])) : te("", !0)
        ])) : r.type === _(la).URLLIST ? (E(), X("span", Kue, [
          (E(!0), X(Re, null, Ge(r.value, (s) => (E(), X("div", {
            key: s.title
          }, [
            ue(ot, {
              class: Pe(["base-link category-list__link", {
                underline: s.href !== null,
                "no-underline": s.href === null
              }]),
              "link-model": s
            }, null, 8, ["class", "link-model"])
          ]))), 128))
        ])) : r.type === _(la).URLDROPDOWN ? (E(), X("span", Xue, [
          ue(Aue, {
            model: r,
            "aria-labelledby": r.key.replaceAll(" ", "-") + "-" + _(t)
          }, null, 8, ["model", "aria-labelledby"])
        ])) : r.type === _(la).IMAGELIST ? (E(), X("span", Zue, [
          (E(!0), X(Re, null, Ge(r.value, (s) => (E(), X("div", {
            key: s.href,
            class: "item-list-image"
          }, [
            oe("img", {
              src: s.href,
              alt: s.text
            }, null, 8, Jue)
          ]))), 128))
        ])) : r.type === _(la).SRRI ? (E(), X("span", Que, [
          ue(Ik, {
            "tooltip-label": r.tooltipLabel,
            rating: parseInt(n(r))
          }, null, 8, ["tooltip-label", "rating"])
        ])) : (E(), X("span", ehe, [
          e.useDynamicFootnote ? (E(), fe(_(ss), {
            key: 0,
            html: n(r),
            purify: !1
          }, null, 8, ["html"])) : (E(), fe(li, {
            key: 1,
            "foot-note-id": e.model.id,
            text: n(r)
          }, null, 8, ["foot-note-id", "text"]))
        ]))
      ]))), 128))
    ])) : te("", !0);
  }
});
const Ar = /* @__PURE__ */ Fe(the, [["__scopeId", "data-v-927cdd2f"]]);
var lr = /* @__PURE__ */ ((e) => (e.Warn = "warn", e.Info = "info", e.Success = "success", e.Error = "error", e))(lr || {});
const nhe = { class: "d-base-notification-box__container" }, ihe = { class: "d-base-notification-box__icon-container" }, ahe = { class: "d-base-notification-box__icon" }, ohe = { class: "d-base-notification-box__content" }, rhe = {
  key: 0,
  class: "d-base-notification-box__title"
}, she = {
  key: 1,
  class: "d-base-notification-box__text"
}, lhe = { class: "d-base-notification-box__container" }, che = { class: "d-base-notification-box__icon-container" }, dhe = { class: "d-base-notification-box__icon" }, uhe = { class: "p-toast-message-text" }, hhe = { class: "p-toast-summary" }, phe = { class: "p-toast-detail" }, fhe = {
  key: 0,
  class: "anchor-button-div"
}, mhe = ["onKeydown"], ghe = /* @__PURE__ */ Be({
  __name: "BaseNotificationBox",
  props: {
    notification: {
      type: Object,
      required: !0
    },
    type: {
      type: String,
      default: lr.Info
    },
    url: {
      type: Object,
      default: void 0
    },
    showCheckbox: {
      type: Boolean,
      default: !1
    },
    showAsToast: {
      type: Boolean,
      default: !1
    },
    closable: {
      type: Boolean,
      default: !0
    },
    id: {
      type: String,
      default: ""
    }
  },
  setup(e) {
    const t = sS(), n = $t("$cookies"), { t: i } = Je(), o = ge(!1), a = ge(), r = e, s = Te(() => r.type === lr.Warn ? H.Exclamation : H.Info);
    function l() {
      o.value = !o.value, d(r.id, o.value);
    }
    function d(y, u) {
      n?.set(`NotificationCookie${y}`, u.toString());
    }
    return it(async () => {
      n?.get(`NotificationCookie${r.id}`) !== "true" && r.showAsToast && t.add({
        severity: r.type,
        summary: r.notification.title,
        detail: r.notification.text,
        closable: r.closable
      }), await mt(), a.value?.getElementsByClassName("p-checkbox-box")[0].setAttribute("tabindex", "3");
    }), (y, u) => {
      const m = $e("PrimeToast");
      return E(), X(Re, null, [
        e.notification && !e.showAsToast ? (E(), X("div", {
          key: 0,
          class: Pe(["col-span-1 lg:col-span-6 xl:grid-cols-5 d-base-notification-box", {
            "d-base-notification-box--info": e.type === _(lr).Info,
            "d-base-notification-box--warning": e.type === _(lr).Warn
          }])
        }, [
          oe("div", nhe, [
            oe("div", ihe, [
              oe("div", ahe, [
                ue(_t, {
                  "base-icon": s.value,
                  "base-icon-color": _(gt).White,
                  "base-icon-size": _(at).Inherit
                }, null, 8, ["base-icon", "base-icon-color", "base-icon-size"])
              ])
            ]),
            oe("div", ohe, [
              e.notification?.title ? (E(), X("span", rhe, [
                ue(_(ht), {
                  "disable-default-styling": "",
                  "html-text": e.notification.title
                }, null, 8, ["html-text"])
              ])) : te("", !0),
              e.notification?.text ? (E(), X("div", she, [
                ue(_(ht), {
                  "disable-default-styling": "",
                  "html-text": e.notification.text
                }, null, 8, ["html-text"])
              ])) : te("", !0)
            ])
          ])
        ], 2)) : te("", !0),
        e.notification && e.showAsToast ? (E(), fe(m, {
          key: 1,
          class: Pe(["notification-box print:hidden d-base-notification-box", {
            "d-base-notification-box--info": e.type === _(lr).Info,
            "d-base-notification-box--warning": e.type === _(lr).Warn
          }]),
          position: "bottom-center",
          pt: {
            closeButton: {
              tabindex: 1
            }
          }
        }, {
          message: Se((h) => [
            oe("div", lhe, [
              oe("div", che, [
                oe("div", dhe, [
                  ue(_t, {
                    "base-icon": s.value,
                    "base-icon-color": _(gt).White,
                    "base-icon-size": _(at).L
                  }, null, 8, ["base-icon", "base-icon-color", "base-icon-size"])
                ])
              ]),
              oe("div", uhe, [
                oe("span", hhe, [
                  ue(_(ht), {
                    "disable-default-styling": "",
                    "html-text": h.message.summary
                  }, null, 8, ["html-text"])
                ]),
                oe("div", phe, [
                  ue(_(ht), {
                    "disable-default-styling": "",
                    "html-text": h.message.detail
                  }, null, 8, ["html-text"])
                ]),
                e.url ? (E(), X("div", fhe, [
                  ue(vt, {
                    "link-model": e.url,
                    type: _(Ke).Primary,
                    size: _(et).Small,
                    tabindex: 2
                  }, null, 8, ["link-model", "type", "size"])
                ])) : te("", !0),
                e.showCheckbox ? (E(), X("div", {
                  key: 1,
                  ref_key: "checkbox",
                  ref: a,
                  class: "d-base-notification-box__checkbox field-checkbox flex flex-row-reverse",
                  onKeydown: Ze(It(l, ["prevent"]), ["space"])
                }, [
                  ue(_(ah), {
                    modelValue: o.value,
                    "onUpdate:modelValue": u[0] || (u[0] = (c) => o.value = c),
                    "input-id": "check",
                    binary: !0,
                    onChange: u[1] || (u[1] = (c) => d(e.id, o.value))
                  }, null, 8, ["modelValue"]),
                  oe("label", {
                    class: Pe(["p-checkbox__label", {
                      "p-checkbox__label--selected": o.value
                    }]),
                    for: "check"
                  }, Ie(_(i)("globalTranslations.doNotShowAgain")), 3)
                ], 40, mhe)) : te("", !0)
              ])
            ])
          ]),
          _: 1
        }, 8, ["class"])) : te("", !0)
      ], 64);
    };
  }
});
const Eh = /* @__PURE__ */ Fe(ghe, [["__scopeId", "data-v-43f54c7d"]]), _Be = /* @__PURE__ */ Be({
  __name: "NotificationBoxes",
  props: {
    notifications: {
      type: Object,
      required: !0
    }
  },
  setup(e) {
    return (t, n) => (E(!0), X(Re, null, Ge(e.notifications, (i, o) => (E(), X("div", {
      key: o,
      class: "mb-4"
    }, [
      ue(Eh, {
        id: i.id,
        notification: i.notification,
        type: i.type,
        url: i.url,
        "show-checkbox": i.showCheckbox,
        "show-as-toast": i.showAsToast,
        closable: i.closable
      }, null, 8, ["id", "notification", "type", "url", "show-checkbox", "show-as-toast", "closable"])
    ]))), 128));
  }
}), vhe = /* @__PURE__ */ Be({
  __name: "BookmarkButton",
  props: {
    addToWatchlistUrl: {},
    isBookmarked: { type: Boolean, default: !1 },
    buttonSize: { default: et.Small }
  },
  emits: ["bookmarked"],
  setup(e, { emit: t }) {
    const n = e, i = t, { pageName: o } = Qe(), { t: a } = Je(), { serviceUrlOptions: r } = Li(), s = r?.bookmarkServiceUrl ? r?.bookmarkServiceUrl : "", l = ge();
    it(() => {
      pn({
        trigger: l.value.buttonRef,
        content: n.isBookmarked ? a("globalTranslations.addedToWatchlist") : a("globalTranslations.addToWatchlist"),
        appendTo: l.value.buttonRef,
        showOnTouchDevices: !0,
        field: () => l.value.buttonRef
      });
    });
    async function d() {
      const y = s + n.addToWatchlistUrl, { error: u, data: m } = await Wu().get(y, {});
      m.value.data ? i("bookmarked", m.value.data) : console.log(u.value);
    }
    return (y, u) => n.addToWatchlistUrl ? (E(), fe(Nt, {
      key: 0,
      ref_key: "buttonRef",
      ref: l,
      class: Pe(["bookmark-button", {
        "bookmark-button__bookmarked": n.isBookmarked
      }]),
      type: n.isBookmarked ? _(Ke).RoundedPrimary : _(Ke).RoundedSecondary,
      size: n.buttonSize,
      icon: _(H).Bookmark,
      "link-model": {
        title: n.isBookmarked ? _(a)("globalTranslations.addedToWatchlist") : _(a)("globalTranslations.addToWatchlist"),
        tealiumTrackingModel: {
          eventComponentName: "Product-Header",
          // we might need to pass this in via props, we can't assume it will always be 'Product-Header'
          eventTitle: "Bookmark | sticky",
          eventSource: _(o)
        }
      },
      onClick: d
    }, null, 8, ["class", "type", "size", "icon", "link-model"])) : te("", !0);
  }
});
const PT = /* @__PURE__ */ Fe(vhe, [["__scopeId", "data-v-71086c72"]]);
var cr = /* @__PURE__ */ ((e) => (e.Header = "header", e.ShrinkHeader = "shrink-header", e.Inherit = "inherit", e))(cr || {});
const yhe = { class: "d-copy-clipboard" }, bhe = ["aria-labelledby"], xhe = ["data-event_source", "data-event_component_name", "data-event_title", "aria-label"], whe = /* @__PURE__ */ Be({
  __name: "CopyToClipboard",
  props: {
    model: {
      type: Object,
      required: !1,
      default: void 0
    },
    text: {
      type: String,
      required: !1,
      default: ""
    },
    inputText: {
      type: String,
      required: !1,
      default: ""
    },
    textAriaLabeledBy: {
      type: String,
      required: !1,
      default: ""
    },
    eventComponentName: {
      type: String,
      default: "CopyToClipboard"
    },
    eventTitle: {
      type: String,
      default: "Copy | regular"
    }
  },
  setup(e) {
    const { t } = Je(), { pageName: n } = Qe(), i = e, o = ge(!1);
    function a() {
      const s = i.model?.inputText ? i.model?.inputText : i.inputText, { copy: l, isSupported: d } = aP({ source: s });
      d ? l(s) : navigator.clipboard.writeText(s), o.value = !0, setTimeout(() => {
        o.value = !1;
      }, 5e3);
    }
    const r = ge();
    return it(() => {
      pn({
        trigger: r,
        headline: t(
          o.value ? "globalTranslations.copiedButton" : "globalTranslations.copyButton"
        ),
        content: t(
          o.value ? "globalTranslations.copiedButton" : "globalTranslations.copyButton"
        ),
        appendTo: r,
        showOnTouchDevices: !0,
        field: () => r
      });
    }), (s, l) => {
      const d = $e("BaseText"), y = $e("BaseIcon");
      return E(), X("div", yhe, [
        e.model?.text && e.model.text.length > 0 || e.text && e.text.length > 0 ? (E(), fe(d, {
          key: 0,
          class: Pe(["d-copy-clipboard__text", {
            "d-copy-clipboard__text-header": e.model?.type === _(cr).Header,
            "d-copy-clipboard__text-shrink-header": e.model?.type === _(cr).ShrinkHeader
          }]),
          tabindex: -1,
          text: e.model?.text ? e.model.text : e.text
        }, null, 8, ["class", "text"])) : te("", !0),
        (e.model?.inputText ? e.model?.inputText : e.inputText) ? (E(), X("strong", {
          key: 1,
          class: Pe(["d-copy-clipboard__input", {
            "d-copy-clipboard__input-header": e.model?.type === _(cr).Header,
            "d-copy-clipboard__input-shrink-header": e.model?.type === _(cr).ShrinkHeader
          }]),
          "aria-labelledby": e.model?.textAriaLabeledBy ? e.model?.textAriaLabeledBy : e.textAriaLabeledBy,
          tabindex: -1
        }, Ie(e.model?.inputText ? e.model.inputText : e.inputText), 11, bhe)) : te("", !0),
        oe("span", {
          ref_key: "copyToClipboardTooltipTrigger",
          ref: r,
          "data-event_source": _(n),
          "data-event_component_name": e.eventComponentName,
          "data-event_title": e.eventTitle,
          tabindex: "0",
          role: "button",
          "aria-label": _(t)("globalTranslations.copyButton"),
          onKeydown: l[0] || (l[0] = Ze((u) => a(), ["enter"])),
          onClick: l[1] || (l[1] = (u) => a())
        }, [
          ue(y, {
            class: Pe(["d-copy-clipboard__button", {
              "d-copy-clipboard__button-header": e.model?.type === _(cr).Header,
              "d-copy-clipboard__button-shrink-header": e.model?.type === _(cr).ShrinkHeader
            }]),
            "base-icon": o.value ? _(H).Check : _(H).Copy
          }, null, 8, ["class", "base-icon"])
        ], 40, xhe)
      ]);
    };
  }
});
const Kg = /* @__PURE__ */ Fe(whe, [["__scopeId", "data-v-c0212906"]]), khe = /* @__PURE__ */ Be({
  __name: "DataTableError",
  props: {
    id: {
      type: String,
      required: !0
    }
  },
  setup(e) {
    return (t, n) => (E(), X("div", null, [
      oe("span", null, " Could not render - " + Ie(e.id), 1)
    ]));
  }
}), She = { class: "d-datatable_column_header__icon-text" }, Che = /* @__PURE__ */ Be({
  __name: "DataTableColumnHeader",
  props: {
    id: {
      type: String,
      required: !0
    },
    model: {
      type: Object,
      required: !0
    },
    newPageFootnoteListVisible: {
      type: Boolean,
      default: !1
    },
    columnClass: {
      type: String,
      default: ""
    },
    sortable: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const t = e, n = ge(), i = ge([]);
    qe(
      () => t.model,
      (r) => {
        r && (Array.isArray(r.value) ? i.value = r.value : n.value = r);
      },
      { immediate: !0 }
    );
    const o = (r) => r == null || r === !0, a = (r) => {
      if (t.sortable) {
        const s = r.target?.closest(
          ".p-sortable-column"
        );
        setTimeout(function() {
          s?.click();
        }, 300);
      }
    };
    return (r, s) => i.value.length > 0 ? (E(), X("span", {
      key: 0,
      class: Pe(["d-datatable_column_header", e.columnClass]),
      onClick: a
    }, [
      (E(!0), X(Re, null, Ge(i.value, (l, d) => (E(), X(Re, { key: d }, [
        o(l.isVisibleOnHeader) && l.value && l.value.length > 0 ? (E(), X(Re, { key: 0 }, [
          oe("span", {
            class: Pe([d !== 0 || !e.sortable ? "nosort" : ""])
          }, [
            ue(_(ht), {
              "html-text": _(Ma)(l.value, {
                ALLOWED_TAGS: ["br"]
              }),
              "disable-default-styling": ""
            }, null, 8, ["html-text"])
          ], 2),
          l.footnoteTitle && l.footnoteTitle.length > 0 ? (E(!0), X(Re, { key: 0 }, Ge(l.footnoteTitle, (y, u) => (E(), fe(ma, {
            key: u,
            title: y,
            "component-id": e.model.footnoteComponentId
          }, null, 8, ["title", "component-id"]))), 128)) : te("", !0),
          s[0] || (s[0] = oe("br", null, null, -1))
        ], 64)) : te("", !0)
      ], 64))), 128))
    ], 2)) : (E(), X("span", {
      key: 1,
      class: Pe(["d-datatable_column_header", e.columnClass]),
      onClick: a
    }, [
      n.value.headerValueType === _(mf).Icon && n.value.icon ? (E(), X("span", {
        key: 0,
        class: Pe(e.sortable ? "" : "nosort")
      }, [
        oe("span", She, Ie(n.value.value || "icon"), 1),
        ue(_t, {
          "base-icon": n.value.icon,
          "base-icon-size": _(at).M,
          "base-icon-color": _(gt).GreyBlue009,
          "aria-label": n.value.value || "icon",
          role: "img",
          tabindex: "0"
        }, null, 8, ["base-icon", "base-icon-size", "base-icon-color", "aria-label"])
      ], 2)) : te("", !0),
      (!n.value.headerValueType || n.value.headerValueType === _(mf).Text) && n.value.value ? (E(), X("span", {
        key: 1,
        class: Pe(e.sortable ? "" : "nosort")
      }, [
        ue(_(ht), {
          "html-text": _(Ma)(n.value.value, {
            ALLOWED_TAGS: ["br"]
          }),
          "disable-default-styling": ""
        }, null, 8, ["html-text"])
      ], 2)) : te("", !0)
    ], 2));
  }
});
var The = {}, Lhe = {
  name: "BaseColumnGroup",
  extends: wt,
  props: {
    type: {
      type: String,
      default: null
    }
  },
  style: The,
  provide: function() {
    return {
      $parentInstance: this
    };
  }
}, s1 = {
  name: "ColumnGroup",
  extends: Lhe,
  inject: ["$columnGroups"],
  mounted: function() {
    var t;
    (t = this.$columnGroups) === null || t === void 0 || t.add(this.$);
  },
  unmounted: function() {
    var t;
    (t = this.$columnGroups) === null || t === void 0 || t.delete(this.$);
  },
  render: function() {
    return null;
  }
}, l1 = {
  name: "Row",
  extends: wt,
  inject: ["$rows"],
  mounted: function() {
    var t;
    (t = this.$rows) === null || t === void 0 || t.add(this.$);
  },
  unmounted: function() {
    var t;
    (t = this.$rows) === null || t === void 0 || t.delete(this.$);
  },
  render: function() {
    return null;
  }
}, Ihe = "__lodash_hash_undefined__";
function Phe(e) {
  return this.__data__.set(e, Ihe), this;
}
var Ahe = Phe;
function _he(e) {
  return this.__data__.has(e);
}
var Mhe = _he, Ohe = Sg, Bhe = Ahe, Ehe = Mhe;
function Ru(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.__data__ = new Ohe(); ++t < n; )
    this.add(e[t]);
}
Ru.prototype.add = Ru.prototype.push = Bhe;
Ru.prototype.has = Ehe;
var Dhe = Ru;
function Rhe(e, t) {
  for (var n = -1, i = e == null ? 0 : e.length; ++n < i; )
    if (t(e[n], n, e))
      return !0;
  return !1;
}
var Nhe = Rhe;
function $he(e, t) {
  return e.has(t);
}
var Fhe = $he, jhe = Dhe, Hhe = Nhe, zhe = Fhe, Vhe = 1, Ghe = 2;
function Uhe(e, t, n, i, o, a) {
  var r = n & Vhe, s = e.length, l = t.length;
  if (s != l && !(r && l > s))
    return !1;
  var d = a.get(e), y = a.get(t);
  if (d && y)
    return d == t && y == e;
  var u = -1, m = !0, h = n & Ghe ? new jhe() : void 0;
  for (a.set(e, t), a.set(t, e); ++u < s; ) {
    var c = e[u], g = t[u];
    if (i)
      var v = r ? i(g, c, u, t, e, a) : i(c, g, u, e, t, a);
    if (v !== void 0) {
      if (v)
        continue;
      m = !1;
      break;
    }
    if (h) {
      if (!Hhe(t, function(P, f) {
        if (!zhe(h, f) && (c === P || o(c, P, n, i, a)))
          return h.push(f);
      })) {
        m = !1;
        break;
      }
    } else if (!(c === g || o(c, g, n, i, a))) {
      m = !1;
      break;
    }
  }
  return a.delete(e), a.delete(t), m;
}
var AT = Uhe;
function Whe(e) {
  var t = -1, n = Array(e.size);
  return e.forEach(function(i, o) {
    n[++t] = [o, i];
  }), n;
}
var Yhe = Whe;
function qhe(e) {
  var t = -1, n = Array(e.size);
  return e.forEach(function(i) {
    n[++t] = i;
  }), n;
}
var Khe = qhe, c1 = td, d1 = kC, Xhe = ed, Zhe = AT, Jhe = Yhe, Qhe = Khe, epe = 1, tpe = 2, npe = "[object Boolean]", ipe = "[object Date]", ape = "[object Error]", ope = "[object Map]", rpe = "[object Number]", spe = "[object RegExp]", lpe = "[object Set]", cpe = "[object String]", dpe = "[object Symbol]", upe = "[object ArrayBuffer]", hpe = "[object DataView]", u1 = c1 ? c1.prototype : void 0, Lp = u1 ? u1.valueOf : void 0;
function ppe(e, t, n, i, o, a, r) {
  switch (n) {
    case hpe:
      if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset)
        return !1;
      e = e.buffer, t = t.buffer;
    case upe:
      return !(e.byteLength != t.byteLength || !a(new d1(e), new d1(t)));
    case npe:
    case ipe:
    case rpe:
      return Xhe(+e, +t);
    case ape:
      return e.name == t.name && e.message == t.message;
    case spe:
    case cpe:
      return e == t + "";
    case ope:
      var s = Jhe;
    case lpe:
      var l = i & epe;
      if (s || (s = Qhe), e.size != t.size && !l)
        return !1;
      var d = r.get(e);
      if (d)
        return d == t;
      i |= tpe, r.set(e, t);
      var y = Zhe(s(e), s(t), i, o, a, r);
      return r.delete(e), y;
    case dpe:
      if (Lp)
        return Lp.call(e) == Lp.call(t);
  }
  return !1;
}
var fpe = ppe, h1 = kT, mpe = 1, gpe = Object.prototype, vpe = gpe.hasOwnProperty;
function ype(e, t, n, i, o, a) {
  var r = n & mpe, s = h1(e), l = s.length, d = h1(t), y = d.length;
  if (l != y && !r)
    return !1;
  for (var u = l; u--; ) {
    var m = s[u];
    if (!(r ? m in t : vpe.call(t, m)))
      return !1;
  }
  var h = a.get(e), c = a.get(t);
  if (h && c)
    return h == t && c == e;
  var g = !0;
  a.set(e, t), a.set(t, e);
  for (var v = r; ++u < l; ) {
    m = s[u];
    var P = e[m], f = t[m];
    if (i)
      var S = r ? i(f, P, m, t, e, a) : i(P, f, m, e, t, a);
    if (!(S === void 0 ? P === f || o(P, f, n, i, a) : S)) {
      g = !1;
      break;
    }
    v || (v = m == "constructor");
  }
  if (g && !v) {
    var w = e.constructor, x = t.constructor;
    w != x && "constructor" in e && "constructor" in t && !(typeof w == "function" && w instanceof w && typeof x == "function" && x instanceof x) && (g = !1);
  }
  return a.delete(e), a.delete(t), g;
}
var bpe = ype, Ip = xh, xpe = AT, wpe = fpe, kpe = bpe, p1 = Bh, f1 = oa, m1 = wh, Spe = Og, Cpe = 1, g1 = "[object Arguments]", v1 = "[object Array]", Rd = "[object Object]", Tpe = Object.prototype, y1 = Tpe.hasOwnProperty;
function Lpe(e, t, n, i, o, a) {
  var r = f1(e), s = f1(t), l = r ? v1 : p1(e), d = s ? v1 : p1(t);
  l = l == g1 ? Rd : l, d = d == g1 ? Rd : d;
  var y = l == Rd, u = d == Rd, m = l == d;
  if (m && m1(e)) {
    if (!m1(t))
      return !1;
    r = !0, y = !1;
  }
  if (m && !y)
    return a || (a = new Ip()), r || Spe(e) ? xpe(e, t, n, i, o, a) : wpe(e, t, l, n, i, o, a);
  if (!(n & Cpe)) {
    var h = y && y1.call(e, "__wrapped__"), c = u && y1.call(t, "__wrapped__");
    if (h || c) {
      var g = h ? e.value() : e, v = c ? t.value() : t;
      return a || (a = new Ip()), o(g, v, n, i, a);
    }
  }
  return m ? (a || (a = new Ip()), kpe(e, t, n, i, o, a)) : !1;
}
var Ipe = Lpe, Ppe = Ipe, b1 = go;
function _T(e, t, n, i, o) {
  return e === t ? !0 : e == null || t == null || !b1(e) && !b1(t) ? e !== e && t !== t : Ppe(e, t, n, i, _T, o);
}
var Xg = _T, Ape = Xg;
function _pe(e, t) {
  return Ape(e, t);
}
var Mpe = _pe;
const Ope = /* @__PURE__ */ en(Mpe);
var MT = function() {
  if (typeof Map < "u")
    return Map;
  function e(t, n) {
    var i = -1;
    return t.some(function(o, a) {
      return o[0] === n ? (i = a, !0) : !1;
    }), i;
  }
  return (
    /** @class */
    function() {
      function t() {
        this.__entries__ = [];
      }
      return Object.defineProperty(t.prototype, "size", {
        /**
         * @returns {boolean}
         */
        get: function() {
          return this.__entries__.length;
        },
        enumerable: !0,
        configurable: !0
      }), t.prototype.get = function(n) {
        var i = e(this.__entries__, n), o = this.__entries__[i];
        return o && o[1];
      }, t.prototype.set = function(n, i) {
        var o = e(this.__entries__, n);
        ~o ? this.__entries__[o][1] = i : this.__entries__.push([n, i]);
      }, t.prototype.delete = function(n) {
        var i = this.__entries__, o = e(i, n);
        ~o && i.splice(o, 1);
      }, t.prototype.has = function(n) {
        return !!~e(this.__entries__, n);
      }, t.prototype.clear = function() {
        this.__entries__.splice(0);
      }, t.prototype.forEach = function(n, i) {
        i === void 0 && (i = null);
        for (var o = 0, a = this.__entries__; o < a.length; o++) {
          var r = a[o];
          n.call(i, r[1], r[0]);
        }
      }, t;
    }()
  );
}(), Jf = typeof window < "u" && typeof document < "u" && window.document === document, Nu = function() {
  return typeof global < "u" && global.Math === Math ? global : typeof self < "u" && self.Math === Math ? self : typeof window < "u" && window.Math === Math ? window : Function("return this")();
}(), Bpe = function() {
  return typeof requestAnimationFrame == "function" ? requestAnimationFrame.bind(Nu) : function(e) {
    return setTimeout(function() {
      return e(Date.now());
    }, 1e3 / 60);
  };
}(), Epe = 2;
function Dpe(e, t) {
  var n = !1, i = !1, o = 0;
  function a() {
    n && (n = !1, e()), i && s();
  }
  function r() {
    Bpe(a);
  }
  function s() {
    var l = Date.now();
    if (n) {
      if (l - o < Epe)
        return;
      i = !0;
    } else
      n = !0, i = !1, setTimeout(r, t);
    o = l;
  }
  return s;
}
var Rpe = 20, Npe = ["top", "right", "bottom", "left", "width", "height", "size", "weight"], $pe = typeof MutationObserver < "u", Fpe = (
  /** @class */
  function() {
    function e() {
      this.connected_ = !1, this.mutationEventsAdded_ = !1, this.mutationsObserver_ = null, this.observers_ = [], this.onTransitionEnd_ = this.onTransitionEnd_.bind(this), this.refresh = Dpe(this.refresh.bind(this), Rpe);
    }
    return e.prototype.addObserver = function(t) {
      ~this.observers_.indexOf(t) || this.observers_.push(t), this.connected_ || this.connect_();
    }, e.prototype.removeObserver = function(t) {
      var n = this.observers_, i = n.indexOf(t);
      ~i && n.splice(i, 1), !n.length && this.connected_ && this.disconnect_();
    }, e.prototype.refresh = function() {
      var t = this.updateObservers_();
      t && this.refresh();
    }, e.prototype.updateObservers_ = function() {
      var t = this.observers_.filter(function(n) {
        return n.gatherActive(), n.hasActive();
      });
      return t.forEach(function(n) {
        return n.broadcastActive();
      }), t.length > 0;
    }, e.prototype.connect_ = function() {
      !Jf || this.connected_ || (document.addEventListener("transitionend", this.onTransitionEnd_), window.addEventListener("resize", this.refresh), $pe ? (this.mutationsObserver_ = new MutationObserver(this.refresh), this.mutationsObserver_.observe(document, {
        attributes: !0,
        childList: !0,
        characterData: !0,
        subtree: !0
      })) : (document.addEventListener("DOMSubtreeModified", this.refresh), this.mutationEventsAdded_ = !0), this.connected_ = !0);
    }, e.prototype.disconnect_ = function() {
      !Jf || !this.connected_ || (document.removeEventListener("transitionend", this.onTransitionEnd_), window.removeEventListener("resize", this.refresh), this.mutationsObserver_ && this.mutationsObserver_.disconnect(), this.mutationEventsAdded_ && document.removeEventListener("DOMSubtreeModified", this.refresh), this.mutationsObserver_ = null, this.mutationEventsAdded_ = !1, this.connected_ = !1);
    }, e.prototype.onTransitionEnd_ = function(t) {
      var n = t.propertyName, i = n === void 0 ? "" : n, o = Npe.some(function(a) {
        return !!~i.indexOf(a);
      });
      o && this.refresh();
    }, e.getInstance = function() {
      return this.instance_ || (this.instance_ = new e()), this.instance_;
    }, e.instance_ = null, e;
  }()
), OT = function(e, t) {
  for (var n = 0, i = Object.keys(t); n < i.length; n++) {
    var o = i[n];
    Object.defineProperty(e, o, {
      value: t[o],
      enumerable: !1,
      writable: !1,
      configurable: !0
    });
  }
  return e;
}, bs = function(e) {
  var t = e && e.ownerDocument && e.ownerDocument.defaultView;
  return t || Nu;
}, BT = Dh(0, 0, 0, 0);
function $u(e) {
  return parseFloat(e) || 0;
}
function x1(e) {
  for (var t = [], n = 1; n < arguments.length; n++)
    t[n - 1] = arguments[n];
  return t.reduce(function(i, o) {
    var a = e["border-" + o + "-width"];
    return i + $u(a);
  }, 0);
}
function jpe(e) {
  for (var t = ["top", "right", "bottom", "left"], n = {}, i = 0, o = t; i < o.length; i++) {
    var a = o[i], r = e["padding-" + a];
    n[a] = $u(r);
  }
  return n;
}
function Hpe(e) {
  var t = e.getBBox();
  return Dh(0, 0, t.width, t.height);
}
function zpe(e) {
  var t = e.clientWidth, n = e.clientHeight;
  if (!t && !n)
    return BT;
  var i = bs(e).getComputedStyle(e), o = jpe(i), a = o.left + o.right, r = o.top + o.bottom, s = $u(i.width), l = $u(i.height);
  if (i.boxSizing === "border-box" && (Math.round(s + a) !== t && (s -= x1(i, "left", "right") + a), Math.round(l + r) !== n && (l -= x1(i, "top", "bottom") + r)), !Gpe(e)) {
    var d = Math.round(s + a) - t, y = Math.round(l + r) - n;
    Math.abs(d) !== 1 && (s -= d), Math.abs(y) !== 1 && (l -= y);
  }
  return Dh(o.left, o.top, s, l);
}
var Vpe = function() {
  return typeof SVGGraphicsElement < "u" ? function(e) {
    return e instanceof bs(e).SVGGraphicsElement;
  } : function(e) {
    return e instanceof bs(e).SVGElement && typeof e.getBBox == "function";
  };
}();
function Gpe(e) {
  return e === bs(e).document.documentElement;
}
function Upe(e) {
  return Jf ? Vpe(e) ? Hpe(e) : zpe(e) : BT;
}
function Wpe(e) {
  var t = e.x, n = e.y, i = e.width, o = e.height, a = typeof DOMRectReadOnly < "u" ? DOMRectReadOnly : Object, r = Object.create(a.prototype);
  return OT(r, {
    x: t,
    y: n,
    width: i,
    height: o,
    top: n,
    right: t + i,
    bottom: o + n,
    left: t
  }), r;
}
function Dh(e, t, n, i) {
  return { x: e, y: t, width: n, height: i };
}
var Ype = (
  /** @class */
  function() {
    function e(t) {
      this.broadcastWidth = 0, this.broadcastHeight = 0, this.contentRect_ = Dh(0, 0, 0, 0), this.target = t;
    }
    return e.prototype.isActive = function() {
      var t = Upe(this.target);
      return this.contentRect_ = t, t.width !== this.broadcastWidth || t.height !== this.broadcastHeight;
    }, e.prototype.broadcastRect = function() {
      var t = this.contentRect_;
      return this.broadcastWidth = t.width, this.broadcastHeight = t.height, t;
    }, e;
  }()
), qpe = (
  /** @class */
  function() {
    function e(t, n) {
      var i = Wpe(n);
      OT(this, { target: t, contentRect: i });
    }
    return e;
  }()
), Kpe = (
  /** @class */
  function() {
    function e(t, n, i) {
      if (this.activeObservations_ = [], this.observations_ = new MT(), typeof t != "function")
        throw new TypeError("The callback provided as parameter 1 is not a function.");
      this.callback_ = t, this.controller_ = n, this.callbackCtx_ = i;
    }
    return e.prototype.observe = function(t) {
      if (!arguments.length)
        throw new TypeError("1 argument required, but only 0 present.");
      if (!(typeof Element > "u" || !(Element instanceof Object))) {
        if (!(t instanceof bs(t).Element))
          throw new TypeError('parameter 1 is not of type "Element".');
        var n = this.observations_;
        n.has(t) || (n.set(t, new Ype(t)), this.controller_.addObserver(this), this.controller_.refresh());
      }
    }, e.prototype.unobserve = function(t) {
      if (!arguments.length)
        throw new TypeError("1 argument required, but only 0 present.");
      if (!(typeof Element > "u" || !(Element instanceof Object))) {
        if (!(t instanceof bs(t).Element))
          throw new TypeError('parameter 1 is not of type "Element".');
        var n = this.observations_;
        n.has(t) && (n.delete(t), n.size || this.controller_.removeObserver(this));
      }
    }, e.prototype.disconnect = function() {
      this.clearActive(), this.observations_.clear(), this.controller_.removeObserver(this);
    }, e.prototype.gatherActive = function() {
      var t = this;
      this.clearActive(), this.observations_.forEach(function(n) {
        n.isActive() && t.activeObservations_.push(n);
      });
    }, e.prototype.broadcastActive = function() {
      if (this.hasActive()) {
        var t = this.callbackCtx_, n = this.activeObservations_.map(function(i) {
          return new qpe(i.target, i.broadcastRect());
        });
        this.callback_.call(t, n, t), this.clearActive();
      }
    }, e.prototype.clearActive = function() {
      this.activeObservations_.splice(0);
    }, e.prototype.hasActive = function() {
      return this.activeObservations_.length > 0;
    }, e;
  }()
), ET = typeof WeakMap < "u" ? /* @__PURE__ */ new WeakMap() : new MT(), DT = (
  /** @class */
  function() {
    function e(t) {
      if (!(this instanceof e))
        throw new TypeError("Cannot call a class as a function.");
      if (!arguments.length)
        throw new TypeError("1 argument required, but only 0 present.");
      var n = Fpe.getInstance(), i = new Kpe(t, n, this);
      ET.set(this, i);
    }
    return e;
  }()
);
[
  "observe",
  "unobserve",
  "disconnect"
].forEach(function(e) {
  DT.prototype[e] = function() {
    var t;
    return (t = ET.get(this))[e].apply(t, arguments);
  };
});
var RT = function() {
  return typeof Nu.ResizeObserver < "u" ? Nu.ResizeObserver : DT;
}();
const Xpe = {
  key: 0,
  class: "pr-2"
}, Zpe = /* @__PURE__ */ Be({
  __name: "DataTable",
  props: {
    model: {
      type: Object,
      required: !0
    },
    newPageFootnoteListVisible: {
      type: Boolean,
      default: !1
    },
    eventComponentName: {
      type: String,
      default: "Data Table"
    },
    showPaginator: {
      type: Boolean,
      default: !0
    },
    footnoteType: {
      type: String,
      default: Oi.None
    },
    removableSort: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["updateDataTable", "actionTriggered", "rows-per-page-changed", "sort", "page"],
  setup(e, { emit: t }) {
    const { isMobile: n, isMobileAsync: i } = xt(), { t: o } = Je(), a = ge(), { isPrint: r, initialize: s } = Uu(), l = io(), {
      calculateScrollPosition: d,
      isHeaderExpanded: y,
      headerRef: u,
      shrinkHeaderRef: m
    } = Fn(), h = $t("smoothScroll"), c = e, g = () => {
      if (c.model.groupBy)
        return pe;
      const we = l.getSortKey(c.model.id);
      return we || c.model.initialSort;
    }, v = () => {
      if (c.model.groupBy)
        return 1;
      const we = l.getAscending(c.model.id);
      return we !== void 0 ? we ? 1 : -1 : c.model.initialSortOrder === 1 ? 1 : -1;
    }, P = () => (N.value - 1) * M.value, f = ge(l.getLockedItems(c.model.id)), S = ge(g()), w = ge(v()), x = ge(), k = ge(!0), A = ge(!1), $ = ge(!1), j = ge(), N = ge(1), M = ge(15), D = ge(P()), C = t, b = () => {
      j.value?.$el.querySelectorAll('[data-pc-section="rowgroupheadercell"]').forEach((we) => {
        we.setAttribute("scope", "colgroup");
      });
    };
    it(() => {
      s(), l.addTable(c.model.id), S.value = g(), w.value = v(), N.value = l.getPage(c.model.id), M.value = l.getRowsPerPage(c.model.id), D.value = P(), I.$dispose(), wi(window, "scroll", () => p(), {
        passive: !0
      }), window.requestAnimationFrame(() => {
        T(), b();
      });
    });
    const p = Jn(
      () => {
        L();
      },
      250,
      { maxWait: 500 }
    );
    async function L() {
      if (c.model.stickyHeader) {
        const we = m.value?.offsetHeight ?? 0, Le = y() ? u.value?.offsetHeight ?? 0 : 0;
        let Me = we + Le;
        Me > 0 && (Me = Me - 1);
        const De = j.value?.$el.querySelector(".p-datatable-thead");
        De && (De.style.position = "sticky", De.style.top = `${Me}px`);
      }
    }
    const B = (we) => {
      $.value && we.addEventListener("scroll", O, {
        passive: !0
      });
    }, T = () => {
      const we = Oe.findSingle(
        x.value,
        ".p-datatable-wrapper"
      );
      new RT((Me) => {
        for (const De of Me) {
          const Ae = De.contentRect;
          Ae.width > 0 && Ae.height > 0 && ($.value = x.value.scrollWidth < we.scrollWidth, B(we));
        }
      }).observe(x.value);
    }, O = (we) => {
      const Le = we.target, Me = Math.ceil(Le.scrollLeft), De = Le.scrollWidth - x.value.scrollWidth;
      k.value = Me === 0, A.value = Me >= De;
    }, I = Xi();
    sn(() => {
      f.value = [], S.value = "", w.value = 1, l.$dispose(), I.$dispose();
    }), qe(
      () => c.model.values,
      (we) => {
        a.value = we, Ue && window.requestAnimationFrame(() => {
          b();
        }), mt().then(() => {
          S.value = g(), w.value = v(), N.value = l.getPage(c.model.id), M.value = l.getRowsPerPage(c.model.id), D.value = P();
        });
      },
      { immediate: !0 }
    ), qe(
      () => c.model.id,
      (we) => {
        f.value = l.getLockedItems(we), mt().then(() => {
          S.value = g(), w.value = v(), N.value = l.getPage(c.model.id), M.value = l.getRowsPerPage(c.model.id), D.value = P();
        });
      },
      { immediate: !0 }
    );
    const R = ge(c.model.totalRecords);
    qe(
      () => c.model.totalRecords,
      (we) => {
        R.value = we;
      },
      { immediate: !0 }
    ), qe(
      () => l.tables,
      () => {
        f.value = l.getLockedItems(c.model.id);
      },
      { deep: !0 }
    );
    const Y = (we) => {
      const Le = { ...we };
      return f.value.findIndex((De) => {
        const Ae = { ...De }, _e = l.getActionMenuKey(De);
        return delete Ae[_e], delete Le[_e], Ope(Ae, Le);
      }) > -1;
    }, F = (we) => we !== ln.Hidden && we !== ln.Identifier, U = Te(() => {
      if (M.value > 0) {
        const we = N.value * M.value - M.value, Le = N.value * M.value;
        return a?.value?.slice(we, Le);
      } else
        return a?.value;
    }), Q = khe, J = Te(() => {
      const we = P() + 1;
      let Le = we - 1 + M.value;
      return Le = Le > ee.value ? ee.value : Le, o("paginator.pageReportTemplate", {
        first: we,
        last: Le,
        totalRecords: ee.value
      });
    }), ee = Te(() => R.value ?? c.model.values?.length), V = [5, 15, 30, 50, 100, 200, 500], G = () => V.slice(
      0,
      V.filter((we) => we < ee.value)?.length + 1
    ), W = Te(() => G()), ae = Te(() => ee.value > M.value), z = ge(!ae.value), q = Te(() => c.model.summary != null ? c.model.summary.length > 0 : !1), Z = ge((we) => we ? ae.value ? "PrevPageLink PageLinks NextPageLink" : "" : ae.value ? "CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink " : "");
    function ne(we) {
      return a?.value?.every(
        (Le) => Le[we]?.sortValue !== null && Le[we]?.sortValue !== void 0
      );
    }
    function ie(we) {
      const Le = a?.value?.every(
        (Ae) => Ae[we] ? Object.prototype.hasOwnProperty.call(Ae[we], "value") : !0
      );
      let Me = we, De = "value";
      if (!Le && a?.value) {
        const Ae = a?.value[0][we], _e = Object.keys(Ae)[0];
        (c?.model?.lazy ? Ae[_e]?.sortValue !== null && Ae[_e]?.sortValue !== void 0 : Ae[_e]?.sortValue) && (De = "sortValue"), Me = `${we}.${_e}`;
      } else
        ne(Me) && (De = "sortValue");
      return `${Me}.${De}`;
    }
    function re(we) {
      return we?.type ? typeof we.value == "string" ? we.value : typeof we.value == "boolean" ? we.value.toString() : "" : "";
    }
    function de(we) {
      const Le = we;
      return c.model.groupBy !== void 0 ? re(Le[c.model.groupBy]) : "";
    }
    function me(we) {
      N.value = we.page + 1, M.value = we.rows, z.value = we.page === (we.pageCount ?? 1) - 1, D.value = P(), l.setPage(c.model.id, N.value), l.setRowsPerPage(c.model.id, M.value), C("page", we), c.model.lazy && C("updateDataTable", {
        sortField: S.value,
        sortOrder: w.value,
        page: N.value,
        rowsPerPage: M.value
      }), j.value && h({
        scrollTo: d(j.value.$el),
        duration: 1e3,
        updateHistory: !1
      });
    }
    function ce(we) {
      S.value = we.sortField, w.value = we.sortOrder, M.value = we.rows, N.value = 1, S.value && (l.setSortKey(c.model.id, S.value), l.setSortOrder(c.model.id, w.value)), C("sort", we), c?.model?.lazy && C("updateDataTable", {
        sortField: S.value,
        sortOrder: w.value,
        page: N.value,
        rowsPerPage: we.rows
      });
    }
    function pe(we) {
      if (c.model.groupBy != null) {
        const Le = we[c.model.groupBy];
        return Le.sortValue != null ? Le.sortValue.toString() : re(Le);
      }
      return "";
    }
    const xe = (we, Le, Me) => {
      switch (we.key) {
        case ga.Compare:
          we.selected ? l.addLockedItem(c.model.id, Le) : l.removeLockedItemFromAllTables(Le), f.value = l.getLockedItems(c.model.id);
          break;
        case ga.Bookmark:
          we.selected ? l.addBookmarkedItem(Le) : l.removeBookmarkedItem(Le);
          break;
      }
      c.model.lazy && C("updateDataTable", {
        sortField: S.value,
        sortOrder: w.value,
        page: N.value,
        rowsPerPage: M.value
      }), C("actionTriggered", we, Le, Me);
    }, le = () => c.model.headerRows && c.model.headerRows.length > 0 ? c.model.headerRows : [{ columns: c.model.columns }], se = () => ({
      columns: c.model.columns,
      headerRows: c.model.headerRows,
      values: U.value
    });
    let he = 0;
    const ve = (we, Le) => we > 0 ? !1 : he === 0 ? (Le && Le >= 1 && (he = Le - 1), !0) : (he = he - 1, !1), ye = (we) => we == null || we;
    function be(we) {
      M.value = +we.value, N.value = Math.floor(D.value / M.value + 1), D.value = P(), c.model.lazy && C("updateDataTable", {
        sortField: S.value,
        sortOrder: w.value,
        page: N.value,
        rowsPerPage: M.value
      }), C("rows-per-page-changed", we), j.value && h({
        scrollTo: d(j.value.$el),
        duration: 1e3,
        updateHistory: !1
      });
    }
    const ke = Jn(() => {
      S.value = g(), w.value = v();
    }, 1e3);
    return Ue && wi(window, "resize", () => ke(), {
      passive: !0
    }), (we, Le) => {
      const Me = $e("ErrorBoundary");
      return E(), X("div", {
        ref_key: "containerRef",
        ref: x,
        class: "d-datatable p-smooth-scroller"
      }, [
        e.model.headlineText ? (E(), fe(Ot, {
          key: 0,
          "base-heading-type": e.model.standAlone === !0 ? _(ze).H3 : _(ze).H4
        }, {
          default: Se(() => [
            ue(li, {
              "new-page-footnote-list-visible": e.newPageFootnoteListVisible,
              "foot-note-id": e.model.id,
              text: e.model.headlineText
            }, null, 8, ["new-page-footnote-list-visible", "foot-note-id", "text"])
          ]),
          _: 1
        }, 8, ["base-heading-type"])) : te("", !0),
        _(r) ? te("", !0) : (E(), fe(_(Ku), {
          key: 1,
          ref_key: "dataTable",
          ref: j,
          class: Pe(["result-page-right", {
            "frozen-column": e.model.frozenColumn && !e.model.stickyHeader,
            "sticky-header": e.model.stickyHeader,
            "fixed-column-width": e.model.fixedColumnWidth,
            "has-paging": c.showPaginator,
            "scroll-shadow-left": $.value && (A.value || !A.value && !k.value),
            "scroll-shadow-right": $.value && (k.value || !A.value && !k.value)
          }]),
          "table-class": "p-datatable-group-header-border",
          value: a.value,
          scrollable: !1,
          paginator: e.showPaginator,
          "paginator-template": Z.value(_(n)),
          "page-link-size": _(n) ? 3 : 5,
          "always-show-paginator": !ae.value && W.value.length > 1,
          rows: M.value,
          "rows-per-page-options": W.value,
          "current-page-report-template": J.value,
          "row-group-mode": e.model.groupBy ? "subheader" : void 0,
          "group-rows-by": de,
          "sort-field": S.value,
          "sort-order": w.value,
          "frozen-value": f.value,
          "removable-sort": e.removableSort,
          first: D.value,
          "responsive-layout": "scroll",
          "show-gridlines": "",
          pt: {
            wrapper: {
              style: `overflow: ${e.model.stickyHeader ? "unset" : "auto"};`
            },
            paginator: {
              paginatorWrapper: {
                "aria-label": e.eventComponentName
              },
              firstPageButton: {
                "data-event_source": _(Qe)().pageName,
                "data-event_title": "firstPageButton",
                "data-event_component_name": "Pagination"
              },
              lastPageButton: {
                "data-event_source": _(Qe)().pageName,
                "data-event_title": "lastPageButton",
                "data-event_component_name": "Pagination"
              },
              previousPageButton: {
                "data-event_source": _(Qe)().pageName,
                "data-event_title": "prevPageButton",
                "data-event_component_name": "Pagination"
              },
              nextPageButton: {
                "data-event_source": _(Qe)().pageName,
                "data-event_title": "nextPageButton",
                "data-event_component_name": "Pagination"
              },
              pageButton: {
                "data-event_source": _(Qe)().pageName,
                "data-event_title": "Page " + N.value,
                "data-event_component_name": "Pagination"
              }
            }
          },
          "total-records": R.value,
          lazy: e.model.lazy,
          onPage: me,
          onSort: ce
        }, Qt({
          groupheader: Se((De) => [
            ue(Ot, {
              "base-heading-type": _(ze).H3,
              class: "bold"
            }, {
              default: Se(() => [
                Ve(Ie(De.data[e.model.groupBy?.toString() ?? ""]?.value), 1)
              ]),
              _: 2
            }, 1032, ["base-heading-type"])
          ]),
          paginatorfirstpagelinkicon: Se(() => [
            ue(_(_t), {
              "base-icon": _(H).AngleDoubleLeft,
              "base-icon-size": _(at).S
            }, null, 8, ["base-icon", "base-icon-size"])
          ]),
          paginatorprevpagelinkicon: Se(() => [
            ue(_(_t), {
              "base-icon": _(H).AngleLeft,
              "base-icon-size": _(at).S
            }, null, 8, ["base-icon", "base-icon-size"])
          ]),
          paginatornextpagelinkicon: Se(() => [
            ue(_(_t), {
              "base-icon": _(H).AngleRight,
              "base-icon-size": _(at).S
            }, null, 8, ["base-icon", "base-icon-size"])
          ]),
          paginatorlastpagelinkicon: Se(() => [
            ue(_(_t), {
              "base-icon": _(H).AngleDoubleRight,
              "base-icon-size": _(at).S
            }, null, 8, ["base-icon", "base-icon-size"])
          ]),
          default: Se(() => [
            ue(_(s1), { type: "header" }, {
              default: Se(() => [
                (E(!0), X(Re, null, Ge(le(), (De, Ae) => (E(), fe(_(l1), { key: Ae }, {
                  default: Se(() => [
                    (E(!0), X(Re, null, Ge(De.columns, (_e, He) => (E(), fe(_(Xr), {
                      key: _e.key,
                      field: _e.key,
                      colspan: _e.colspan,
                      rowspan: _e.rowspan,
                      frozen: _e.key == e.model.frozenColumn && !e.model.stickyHeader,
                      "sort-field": ie(_e.key),
                      sortable: e.model.sortable && _e.sortable !== !1 && e.model.groupBy == null,
                      "header-class": _(ts)({
                        "p-datatable__word-break-column": _e.wordBreakHeader,
                        "p-datatable__no-left-right-padding": _e.noLeftRightPadding,
                        left: _e.alignment === _(zn).Left || _e.alignment === void 0,
                        right: _e.alignment === _(zn).Right,
                        noBorder: ve(He, _e.rowspan),
                        headerBorder: le().length === _e.rowspan,
                        fixedWidth: !!_e.width
                      }),
                      pt: {
                        headerCell: {
                          scope: _e.colspan && _e.colspan > 1 ? "colgroup" : "col",
                          style: _e.width ? `width: ${_e.width};` : "",
                          "data-event_source": e.model.sortable && _e.sortable !== !1 && e.model.groupBy == null ? _(Qe)().pageName : "",
                          "data-event_title": e.model.sortable && _e.sortable !== !1 && e.model.groupBy == null ? Array.isArray(_e.value) ? "Sort | " + _e.value[0].value : "Sort | " + _e.value : "",
                          "data-event_component_name": e.model.sortable && _e.sortable !== !1 && e.model.groupBy == null ? e.eventComponentName : ""
                        }
                      }
                    }, {
                      header: Se(() => [
                        ye(_e?.isVisibleOnHeader) ? (E(), fe(Che, {
                          key: 0,
                          id: e.model.id,
                          model: _e,
                          "new-page-footnote-list-visible": e.newPageFootnoteListVisible,
                          "column-class": _(ts)({
                            left: _e.alignment === _(zn).Left || _e.alignment === void 0,
                            right: _e.alignment === _(zn).Right,
                            "p-datatable__word-break-column": _e.wordBreakHeader
                          })
                        }, null, 8, ["id", "model", "new-page-footnote-list-visible", "column-class"])) : te("", !0)
                      ]),
                      sorticon: Se((Ee) => [
                        Ee.sorted ? (E(), X("div", Xpe, [
                          Ee.sortOrder === 1 ? (E(), fe(_(_t), {
                            key: 0,
                            "base-icon": _(H).SortAmountUpAlt,
                            "base-icon-color": _(gt).Inherit,
                            "base-icon-size": _(at).S,
                            "aria-label": _(o)("dataTable.sortedAscending")
                          }, null, 8, ["base-icon", "base-icon-color", "base-icon-size", "aria-label"])) : te("", !0),
                          Ee.sortOrder === -1 ? (E(), fe(_(_t), {
                            key: 1,
                            "base-icon": _(H).SortAmountDownAlt,
                            "base-icon-color": _(gt).Inherit,
                            "base-icon-size": _(at).S,
                            "aria-label": _(o)("dataTable.sortedDescending")
                          }, null, 8, ["base-icon", "base-icon-color", "base-icon-size", "aria-label"])) : te("", !0)
                        ])) : te("", !0)
                      ]),
                      _: 2
                    }, 1032, ["field", "colspan", "rowspan", "frozen", "sort-field", "sortable", "header-class", "pt"]))), 128))
                  ]),
                  _: 2
                }, 1024))), 128))
              ]),
              _: 1
            }),
            e.model.groupBy !== void 0 && e.model.groupBy?.length > 0 ? (E(), fe(_(Xr), {
              key: 0,
              field: de,
              header: de
            })) : te("", !0),
            (E(!0), X(Re, null, Ge(e.model.columns, (De, Ae) => (E(), fe(_(Xr), {
              key: De.key,
              field: De.key,
              "sort-field": ie(De.key),
              frozen: De.key == e.model.frozenColumn && !e.model.stickyHeader,
              sortable: e.model.sortable && De.sortable !== !1 && e.model.groupBy == null,
              "body-class": _(ts)({
                left: De.alignment === _(zn).Left || De.alignment === void 0,
                right: De.alignment === _(zn).Right,
                top: De.alignment === _(zn).Top,
                "no-row-header": e.model.noRowHeader,
                "p-frozen-column-last-td": Ae == e.model.columns.length - 1 && e.model.frozenColumn && !e.model.stickyHeader,
                "p-datatable__word-break-column": De.wordBreak,
                "p-datatable__no-left-right-padding": De.noLeftRightPadding
              })
            }, {
              body: Se((_e) => [
                (E(), fe(Me, {
                  key: De,
                  params: { id: De.key },
                  "fall-back": _(Q)
                }, {
                  default: Se(() => [
                    Array.isArray(De.value) ? (E(!0), X(Re, { key: 0 }, Ge(De.value, (He, Ee) => (E(), X(Re, { key: Ee }, [
                      F(_e.data[_e.field]?.[He.key]?.type) ? (E(), X("span", {
                        key: 0,
                        class: Pe({
                          "d-datatable__first-value": Ee === 0,
                          "d-datatable__value": Ee > 0
                        })
                      }, [
                        ue(Eu, {
                          "table-id": c.model.id,
                          row: _e.data,
                          field: _e.field,
                          "sub-field": He,
                          "foot-note-id": e.model.footnoteComponentId,
                          "colored-performance": c.model.coloredPerformance,
                          onActionTriggered: xe
                        }, null, 8, ["table-id", "row", "field", "sub-field", "foot-note-id", "colored-performance"])
                      ], 2)) : te("", !0)
                    ], 64))), 128)) : (E(), X(Re, { key: 1 }, [
                      F(_e.data[_e.field]?.type) ? (E(), fe(Eu, {
                        key: 0,
                        "table-id": c.model.id,
                        row: _e.data,
                        field: _e.field,
                        "foot-note-id": e.model.footnoteComponentId,
                        "colored-performance": c.model.coloredPerformance,
                        class: Pe({ "locked-item": Y(_e.data) }),
                        onActionTriggered: xe
                      }, null, 8, ["table-id", "row", "field", "foot-note-id", "colored-performance", "class"])) : te("", !0)
                    ], 64))
                  ]),
                  _: 2
                }, 1032, ["params", "fall-back"]))
              ]),
              _: 2
            }, 1032, ["field", "sort-field", "frozen", "sortable", "body-class"]))), 128)),
            q.value && z.value ? (E(), fe(_(s1), {
              key: 1,
              type: "footer"
            }, {
              default: Se(() => [
                ue(_(l1), null, {
                  default: Se(() => [
                    (E(!0), X(Re, null, Ge(e.model.summary, (De) => (E(), fe(_(Xr), {
                      key: De.key,
                      footer: De.value,
                      frozen: De.key == e.model.frozenColumn && !e.model.stickyHeader,
                      colspan: De.colspan !== void 0 && De.colspan > 1 ? De.colspan : 1,
                      "footer-class": {
                        left: De.alignment === _(zn).Left || De.alignment === void 0,
                        right: De.alignment === _(zn).Right,
                        top: De.alignment === _(zn).Top,
                        "p-datatable__word-break-column": De.wordBreak
                      }
                    }, null, 8, ["footer", "frozen", "colspan", "footer-class"]))), 128))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })) : te("", !0)
          ]),
          _: 2
        }, [
          _(i) ? void 0 : {
            name: "paginatorend",
            fn: Se(() => [
              ue(fT, {
                "rows-per-page-options": W.value,
                rows: M.value,
                class: Pe({ "p-datatable-single-page": !ae.value }),
                "event-component-name": e.eventComponentName,
                onSelectedItemChanged: be
              }, null, 8, ["rows-per-page-options", "rows", "class", "event-component-name"])
            ]),
            key: "0"
          }
        ]), 1032, ["class", "value", "paginator", "paginator-template", "page-link-size", "always-show-paginator", "rows", "rows-per-page-options", "current-page-report-template", "row-group-mode", "sort-field", "sort-order", "frozen-value", "removable-sort", "first", "pt", "total-records", "lazy"])),
        _(r) ? (E(), fe(Vg, {
          key: 2,
          "max-length": M.value,
          props: se()
        }, null, 8, ["max-length", "props"])) : te("", !0),
        ue(ro, {
          class: "mb-8",
          "component-id": e.model.footnoteComponentId,
          "footnote-type": e.footnoteType
        }, null, 8, ["component-id", "footnote-type"])
      ], 512);
    };
  }
});
const Fu = /* @__PURE__ */ Fe(Zpe, [["__scopeId", "data-v-628f8543"]]), Us = {
  ...Tm,
  title: "Public Funds Germany",
  text: "Public Funds Germany",
  tealiumTrackingModel: Yc
}, MBe = {
  ...Us,
  title: "Exchange Traded Products",
  text: "Exchange Traded Products"
}, OBe = {
  ...Us,
  title: "Liquidity Germany",
  text: "Liquidity Germany"
}, NT = {
  ...Us,
  title: "Real Estate Investment Management Germany",
  text: "Real Estate Investment Management Germany"
}, Jpe = {
  ...Us,
  title: "Value lnvesting mit CROCI Fonds",
  text: "Value lnvesting mit CROCI Fonds"
};
({ ...Us });
({ ...NT });
({ ...Jpe });
({ ...Us });
({ ...NT });
const Qpe = { class: "d-link-list" }, efe = { key: 0 }, tfe = { class: "ml-8 mb-6" }, nfe = { key: 1 }, ife = /* @__PURE__ */ Be({
  __name: "LinkList",
  props: {
    viewModel: {
      type: Object,
      required: !0
    },
    currentCountry: {
      type: Object,
      default: null
    },
    iconFontSize: {
      type: String,
      default: null
    },
    iconFontType: {
      type: String,
      default: ya.DwsBold
    },
    textColor: {
      type: String,
      default: dt.GreyBlue008
    },
    showAllWhenNoCountrySelected: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["item-click"],
  setup(e, { emit: t }) {
    const n = e;
    ws(() => {
      r(n.currentCountry?.value);
    }), qe(n, (s) => {
      r(s.currentCountry?.value);
    });
    const i = t, o = (s) => {
      i("item-click", s);
    }, a = ge(), r = (s) => {
      s ? a.value = n.viewModel?.items?.filter((l) => l.country === s) : n.showAllWhenNoCountrySelected && (a.value = n.viewModel?.items);
    };
    return (s, l) => {
      const d = $e("BaseText");
      return E(), X("div", Qpe, [
        e.viewModel?.showAsImportant ? (E(), X("div", efe, [
          (E(!0), X(Re, null, Ge(a.value, (y, u) => (E(), X("div", {
            key: `item-${String(u)}`
          }, [
            ue(ot, {
              "link-model": y.linkModel,
              "font-size": e.iconFontSize,
              "font-type": e.iconFontType,
              icon: _(H).ExternalLinkAlt,
              "icon-position": _(ct).Left,
              onClick: (m) => o(y)
            }, null, 8, ["link-model", "font-size", "font-type", "icon", "icon-position", "onClick"]),
            oe("div", tfe, [
              y.description ? (E(), fe(d, {
                key: 0,
                text: y.description,
                "font-type": _(lt).DwsSlab,
                "text-color": e.textColor,
                class: "ml-2"
              }, null, 8, ["text", "font-type", "text-color"])) : te("", !0)
            ])
          ]))), 128))
        ])) : (E(), X("div", nfe, [
          (E(!0), X(Re, null, Ge(a.value, (y, u) => (E(), X("div", {
            key: `item-${String(u)}`,
            class: Pe(["mb-2", { "d-link-list__item-border": e.viewModel.hasBorder }])
          }, [
            ue(ot, {
              "link-model": y.linkModel,
              "font-size": e.iconFontSize,
              "font-type": e.iconFontType,
              icon: e.viewModel.hasIcon ? _(H).ArrowRight : void 0,
              "icon-position": _(ct).Left,
              onClick: (m) => o(y)
            }, null, 8, ["link-model", "font-size", "font-type", "icon", "icon-position", "onClick"])
          ], 2))), 128))
        ]))
      ]);
    };
  }
});
const Qf = /* @__PURE__ */ Fe(ife, [["__scopeId", "data-v-bedd345d"]]), afe = { key: 0 }, ofe = { key: 1 }, rfe = /* @__PURE__ */ Be({
  __name: "ShowMoreText",
  props: {
    text: {
      type: String,
      required: !0
    },
    textLimit: {
      type: Number,
      default: 300
    },
    isPlainText: {
      type: Boolean,
      default: !0
    }
  },
  setup(e) {
    const { t } = Je(), n = Qe().pageName, i = e, o = {
      eventSource: n,
      eventComponentName: "",
      eventTitle: ""
    }, a = ge(!0), r = Te(
      () => i.isPlainText && i.text.length > i.textLimit && i.textLimit > 0
    ), s = Te(() => t(
      a.value ? "showMoreShowLess.showMoreText" : "showMoreShowLess.showLessText"
    ));
    function l(u) {
      return i.textLimit > 0 ? y(u, i.textLimit) : u;
    }
    function d() {
      a.value = !a.value;
    }
    function y(u, m) {
      if (u.length > m) {
        for (let h = m; h > 0; h--)
          if (u.charAt(h) === " " && (u.charAt(h - 1) != "," || u.charAt(h - 1) != "." || u.charAt(h - 1) != ";"))
            return u.substring(0, h) + "...";
        return u.substring(0, m) + "...";
      } else
        return u;
    }
    return (u, m) => (E(), X(Re, null, [
      ue(Br, null, {
        default: Se(() => [
          e.isPlainText ? (E(), X("div", afe, [
            oe("p", null, Ie(a.value ? l(e.text) : e.text), 1)
          ])) : (E(), X("div", ofe, [
            oe("p", null, [
              ue(_(ht), {
                "disable-default-styling": "",
                "html-text": e.text
              }, null, 8, ["html-text"])
            ])
          ]))
        ]),
        _: 1
      }),
      r.value ? (E(), fe(No, {
        key: 0,
        tabindex: "0",
        role: "button",
        "aria-label": s.value,
        "tracking-model": o,
        text: s.value,
        icon: a.value ? _(H).Plus : _(H).Minus,
        onClick: d
      }, null, 8, ["aria-label", "text", "icon"])) : te("", !0)
    ], 64));
  }
});
const sfe = /* @__PURE__ */ Fe(rfe, [["__scopeId", "data-v-75f2c7fd"]]);
var ei = /* @__PURE__ */ ((e) => (e.Investment = "investment", e.Inflation = "inflation", e))(ei || {});
const lfe = { class: "d-social-share-bar__list__item" }, cfe = /* @__PURE__ */ Be({
  __name: "SocialShareBar",
  props: {
    metaTags: {},
    shareButtons: { default: () => [
      Pt.Linkedin,
      Pt.Twitter,
      Pt.Facebook,
      Pt.Xing,
      Pt.Email
    ] },
    buttonType: { default: Ke.RoundedPrimary },
    buttonSize: { default: et.Medium },
    componentName: {}
  },
  emits: ["download"],
  setup(e, { emit: t }) {
    const n = e, { pageName: i } = Qe(), { t: o } = Je(), { showPrintDialog: a } = Uu(), r = t, s = ge(null), l = ge(null), d = ge(
      null
    ), y = ge(null), u = ge(
      null
    ), m = ge(!0), h = ge(!0), c = ge(-1), g = ge(-1), v = Te(() => (w) => {
      const x = w === Pt.Twitter ? n?.metaTags?.twitterDescription : n?.metaTags?.ogDescription;
      return {
        network: w,
        url: n?.metaTags?.ogUrl,
        title: n?.metaTags?.metaTitleWithFallbackAndSuffix,
        description: x,
        hashtags: n?.metaTags?.metaKeywords,
        quote: x
      };
    }), P = (w) => ({
      contentUrl: "",
      title: "",
      target: "_self",
      isLocked: !1,
      isExternal: !1,
      linkType: yt.Javascript,
      tealiumTrackingModel: {
        eventSource: i,
        eventComponentName: n?.componentName || "SocialShareBar",
        eventTitle: w
      }
    }), f = () => {
      !Ue || !l.value || (c.value = s.value.clientWidth, g.value = g.value === -1 ? l.value.offsetWidth : g.value, h.value = c.value >= g.value);
    }, S = () => {
      new ResizeObserver(() => {
        f();
      }).observe(s.value);
    };
    return it(() => {
      if (!Ue)
        return;
      s.value && S(), [
        {
          ref: d,
          text: o("globalTranslations.tooltipTextShare")
        },
        {
          ref: y,
          text: o("eventList.download")
        },
        {
          ref: u,
          text: o("globalTranslations.tooltipTextPrint")
        }
      ].forEach(({ ref: x, text: k }) => {
        x?.value?.buttonRef && pn({
          trigger: x?.value?.buttonRef,
          content: k,
          appendTo: () => document.body,
          showOnTouchDevices: !0,
          field: () => x?.value?.buttonRef
        });
      });
    }), (w, x) => w.metaTags ? (E(), X("div", {
      key: 0,
      ref_key: "shareBarRef",
      ref: s,
      class: Pe(["d-social-share-bar", {
        "d-social-share-bar--over-items": !m.value
      }])
    }, [
      oe("ul", {
        ref_key: "shareBarListRef",
        ref: l,
        class: Pe(["d-social-share-bar__list", { "d-social-share-bar__list--horizontal": h.value }])
      }, [
        oe("li", {
          class: Pe(["d-social-share-bar__buttons", { "d-social-share-bar__buttons--horizontal": h.value }])
        }, [
          ue(_(Nt), {
            ref_key: "shareButtonRef",
            ref: d,
            "no-border": !0,
            type: w.buttonType,
            size: w.buttonSize,
            icon: _(H).Share,
            "link-model": P("Share"),
            active: !m.value,
            "aria-label": _(o)("globalTranslations.tooltipTextShare"),
            onClick: x[0] || (x[0] = (k) => m.value = !m.value)
          }, null, 8, ["type", "size", "icon", "link-model", "active", "aria-label"]),
          ue(_(Nt), {
            ref_key: "downloadButtonRef",
            ref: y,
            "no-border": !0,
            type: w.buttonType,
            size: w.buttonSize,
            icon: _(H).Download,
            "link-model": P("Download"),
            "aria-label": _(o)("eventList.download"),
            onClick: x[1] || (x[1] = (k) => r("download"))
          }, null, 8, ["type", "size", "icon", "link-model", "aria-label"]),
          ue(_(Nt), {
            ref_key: "printButtonRef",
            ref: u,
            "no-border": !0,
            type: w.buttonType,
            size: w.buttonSize,
            icon: _(H).Print,
            "link-model": P("Print"),
            "aria-label": _(o)("globalTranslations.tooltipTextPrint"),
            onClick: _(a)
          }, null, 8, ["type", "size", "icon", "link-model", "aria-label", "onClick"])
        ], 2),
        oe("li", lfe, [
          ue(Br, null, {
            default: Se(() => [
              h.value || !m.value ? (E(), X("div", {
                key: 0,
                class: Pe(["d-social-share-bar__list__item__bar", {
                  "d-social-share-bar__list__item__bar--active": !m.value
                }])
              }, [
                oe("div", {
                  class: Pe(["d-social-share-bar__list__item__bar__buttons", {
                    "d-social-share-bar__list__item__bar__buttons--horizontal": h.value
                  }])
                }, [
                  (E(!0), X(Re, null, Ge(w.shareButtons, (k) => (E(), fe(Lh, {
                    key: k,
                    size: w.buttonSize,
                    "button-type": w.buttonType,
                    model: v.value(k),
                    focusable: !m.value
                  }, null, 8, ["size", "button-type", "model", "focusable"]))), 128))
                ], 2)
              ], 2)) : te("", !0)
            ]),
            _: 1
          })
        ])
      ], 2)
    ], 2)) : te("", !0);
  }
});
const dfe = /* @__PURE__ */ Fe(cfe, [["__scopeId", "data-v-cfe1e262"]]), w1 = {
  accessibility: {
    enabled: !0,
    description: "This chart displays the Investment over time.",
    series: {
      descriptionFormatter: function(e) {
        return e.name + ", with " + e.points.length + " data points.";
      }
    },
    keyboardNavigation: {
      enabled: !0,
      focusBorder: {
        enabled: !0,
        hideBrowserFocusOutline: !0,
        style: {
          lineWidth: 2,
          color: oi,
          borderRadius: 0
        },
        margin: 2
      },
      order: ["series"],
      seriesNavigation: {
        mode: "normal"
      }
    }
  },
  legend: {
    enabled: !1
  },
  chart: {
    backgroundColor: "transparent",
    type: "column"
  },
  title: {
    text: ""
  },
  xAxis: {
    //minPadding: 0,
    //maxPadding: 10,
    //min: 0, // Set minimum value for padding
    //max: 10, // Set maximum value for padding
    tickInterval: 1,
    // Define your tick interval
    //categories: ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10'],
    lineWidth: 0,
    gridLineWidth: 0,
    gridLineColor: Yi,
    // Set gridline color to red
    lineColor: Yi,
    // Set axis line color to red
    labels: {
      style: {
        color: oi
      }
    }
  },
  yAxis: {
    min: 0,
    title: {
      text: ""
    },
    lineWidth: 0,
    gridLineWidth: 1,
    gridLineColor: Yi,
    // Set gridline color to red
    lineColor: Yi,
    // Set axis line color to red
    labels: {
      style: {
        color: oi
      }
    },
    stackLabels: {
      enabled: !1,
      style: {
        fontWeight: "bold",
        color: oi
      }
    }
  },
  tooltip: {
    enabled: !0,
    shared: !0,
    useHTML: !0,
    outside: !0,
    shadow: !1,
    split: !1
  },
  plotOptions: {
    column: {
      stacking: "normal",
      dataLabels: {
        enabled: !1,
        style: {
          color: "white"
          // White data labels
        }
      },
      borderColor: oi,
      borderWidth: 0,
      borderRadius: 0,
      pointPadding: 0.04,
      // Adjust padding for spacing
      groupPadding: 0.04
      // Adjust group padding for gap between columns
    }
  },
  series: [
    {
      name: "Wertzuwachs",
      type: "column",
      //data: [0, 3, 6, 9, 12, 15, 18, 21, 24, 27, 30],
      className: Sr,
      // use class to get color instead of gradient for series
      color: {
        linearGradient: { x1: 0, y1: 1, x2: 0, y2: 0 },
        stops: [
          [0, "#50711D"],
          // Bottom color
          [1, Sr]
          // Top color
        ]
      }
    },
    {
      name: "Gesamte regelmäßige Einzahlung",
      type: "column",
      //data: [0, 5, 10, 15, 20, 25, 30, 35, 40, 45, 50],
      className: Da,
      color: {
        linearGradient: { x1: 0, y1: 1, x2: 0, y2: 0 },
        stops: [
          [0, "#326D93"],
          // Bottom color
          [1, Da]
          // Top color
        ]
      }
    },
    {
      name: "Einzahlung",
      type: "column",
      //data: [20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20],
      className: mu,
      color: {
        linearGradient: { x1: 0, y1: 1, x2: 0, y2: 0 },
        stops: [
          [0, "#5A6D78"],
          // Bottom color
          [1, mu]
          // Top color
        ]
      }
    }
  ]
}, $T = {
  enabled: !0,
  description: "This chart displays the Investment over time.",
  series: {
    descriptionFormatter: function(e) {
      return e.name + ", with " + e.points.length + " data points.";
    }
  },
  keyboardNavigation: {
    enabled: !0,
    focusBorder: {
      enabled: !0,
      hideBrowserFocusOutline: !0,
      style: {
        lineWidth: 2,
        color: oi,
        borderRadius: 0
      },
      margin: 2
    },
    order: ["series"],
    seriesNavigation: {
      mode: "normal"
    }
  }
}, ufe = {
  accessibility: $T,
  lang: {
    noData: "No Data available..."
  },
  noData: {
    style: {
      color: oi,
      fontSize: "12px",
      fontWeight: "bold",
      textAlign: "center"
    }
  },
  legend: {
    enabled: !1
  },
  chart: {
    backgroundColor: "transparent",
    type: "column"
  },
  title: {
    text: ""
  },
  xAxis: {
    //minPadding: 0,
    //maxPadding: 10,
    //min: 0, // Set minimum value for padding
    //max: 10, // Set maximum value for padding
    tickInterval: 1,
    // Define your tick interval
    lineWidth: 0,
    gridLineWidth: 0,
    gridLineColor: Yi,
    lineColor: Yi,
    labels: {
      style: {
        color: oi
      }
    }
  },
  yAxis: {
    min: 0,
    title: {
      text: ""
    },
    lineWidth: 0,
    gridLineWidth: 1,
    gridLineColor: Yi,
    lineColor: Yi,
    stackLabels: {
      enabled: !1,
      style: {
        fontWeight: "bold",
        color: oi
      }
    }
  },
  tooltip: {
    enabled: !0,
    shared: !0,
    useHTML: !0,
    outside: !0,
    shadow: !1,
    split: !1
  },
  plotOptions: {
    column: {
      stacking: "normal",
      dataLabels: {
        enabled: !1,
        style: {
          color: "white"
        }
      },
      borderColor: oi,
      borderWidth: 0,
      borderRadius: 0,
      pointPadding: 0.04,
      // Adjust padding for spacing
      groupPadding: 0.04
      // Adjust group padding for gap between columns
    }
  },
  series: [
    {
      //name: 'Wertzuwachs',
      type: "column",
      className: Sr,
      // use class to get color instead of gradient for series
      color: {
        linearGradient: { x1: 0, y1: 1, x2: 0, y2: 0 },
        stops: [
          [0, "#50711D"],
          // Bottom color
          [1, Sr]
          // Top color
        ]
      }
    },
    {
      //name: 'Gesamte regelmäßige Einzahlung',
      type: "column",
      className: Da,
      color: {
        linearGradient: { x1: 0, y1: 1, x2: 0, y2: 0 },
        stops: [
          [0, "#326D93"],
          [1, Da]
        ]
      }
    },
    {
      //name: 'Einzahlung',
      type: "column",
      className: mu,
      color: {
        linearGradient: { x1: 0, y1: 1, x2: 0, y2: 0 },
        stops: [
          [0, "#5A6D78"],
          [1, mu]
        ]
      }
    }
  ]
}, hfe = {
  accessibility: $T,
  lang: {
    noData: "No Data available..."
  },
  noData: {
    style: {
      color: oi,
      fontSize: "12px",
      fontWeight: "bold",
      textAlign: "center"
    }
  },
  legend: {
    enabled: !1
  },
  chart: {
    backgroundColor: "transparent",
    type: "column"
  },
  title: {
    text: ""
  },
  xAxis: {
    lineWidth: 0,
    gridLineWidth: 0,
    gridLineColor: Yi,
    lineColor: Yi,
    labels: {
      style: {
        color: oi
      }
    }
  },
  yAxis: {
    min: 0,
    title: {
      text: ""
    },
    lineWidth: 0,
    gridLineWidth: 1,
    gridLineColor: Yi,
    lineColor: Yi,
    stackLabels: {
      enabled: !1,
      style: {
        fontWeight: "bold",
        color: oi
      }
    }
  },
  tooltip: {
    enabled: !0,
    shared: !0,
    useHTML: !0,
    outside: !0,
    shadow: !1,
    split: !0
  },
  plotOptions: {
    column: {
      stacking: "normal",
      dataLabels: {
        enabled: !1,
        style: {
          color: "white"
        }
      },
      borderColor: oi,
      borderWidth: 0,
      borderRadius: 0,
      pointPadding: 0.04,
      groupPadding: 0.04
    }
  },
  series: [
    {
      //name: 'Kaufkraft',
      type: "column",
      className: "#489CD2",
      color: {
        linearGradient: { x1: 0, y1: 1, x2: 0, y2: 0 },
        stops: [
          [0, "#326D93"],
          [1, "#489CD2"]
        ]
      }
      //borderColor: 'white',
      //borderWidth: 2,
    }
  ]
}, pfe = {
  key: 0,
  class: "d-calculator-output-chart"
}, ffe = /* @__PURE__ */ Be({
  __name: "CalculatorOutputChart",
  props: {
    model: {
      type: Object,
      required: !0
    }
  },
  setup(e, { expose: t }) {
    const n = e, { abbreviateNumber: i } = Uc(), { t: o } = Je(), a = ge(), r = ge();
    function s(m) {
      const h = [];
      for (let c = 0; c < m; c++)
        h.push(c * n?.model?.yearsStep);
      return h;
    }
    const l = (m) => {
      const h = m?.chartType === ei.Investment ? ufe : hfe;
      return {
        ..._s,
        ...h,
        xAxis: {
          ...h.xAxis,
          categories: s(m?.seriesData[0]?.length)
        },
        yAxis: {
          ...h.yAxis,
          labels: {
            style: {
              color: oi
            },
            formatter: function(c) {
              return i(c.value, {
                useDefaultOptions: !0,
                minimumAbbreviation: 1e3,
                minimumFractionDigits: 0
              });
            }
          }
        },
        chart: {
          ...h.chart,
          spacing: [8, 0, 8, 0],
          width: m?.width,
          style: {
            color: oi,
            fontWeight: As,
            fontSize: Ps,
            fontFamily: Is
          }
        },
        series: m?.chartType === ei.Investment ? [
          {
            ...h.series[0],
            data: m?.seriesData[0],
            name: m?.seriesNames[0]
          },
          {
            ...h.series[1],
            data: m?.seriesData[1],
            name: m?.seriesNames[1]
          },
          {
            ...h.series[2],
            data: m?.seriesData[2],
            name: m?.seriesNames[2]
          }
        ] : [
          {
            ...h.series[0],
            data: m?.seriesData[0],
            name: m?.seriesNames[0]
          }
        ],
        tooltip: {
          enabled: !0,
          shared: !0,
          useHTML: !0,
          outside: !0,
          shadow: !1,
          split: !1,
          backgroundColor: "rgba(255,255,255,0)",
          borderRadius: 12,
          style: {
            pointerEvents: "none",
            border: "none",
            backgroundColor: "transparent",
            padding: "0",
            zIndex: 1e4
          },
          positioner: function(c, g, v) {
            const P = this.chart, f = v.plotX - c / 2 + 64, S = v.plotY - g - 8, w = Math.max(
              0,
              Math.min(f, P.chartWidth + 60 - c)
            ), x = Math.max(
              0,
              Math.min(S, P.chartHeight - g)
            );
            return { x: w, y: x };
          },
          formatter() {
            const c = [];
            return this.points?.forEach((g) => {
              c.push({
                name: g.series.name,
                value: g.y,
                color: g.series.userOptions.className
              });
            }), u(c);
          }
        }
      };
    };
    qe(
      () => n.model,
      (m) => {
        m && (r.value = l(m), a.value?.rerender(r.value));
      },
      { immediate: !0, deep: !0 }
    );
    const d = () => {
      if (!Ue)
        return;
      const h = Nn.charts[0]?.getCSV(!0).replace(
        "Category",
        o("globalTranslations.years").charAt(0).toUpperCase() + o("globalTranslations.years").slice(1).toLowerCase()
      ), c = new Blob([h], { type: "text/csv;charset=utf-8;" }), g = document.createElement("a"), v = URL.createObjectURL(c);
      g.setAttribute("href", v);
      const P = n.model.chartType === ei.Investment ? o("calculatorOutputCard.investmentChartTitle") : o("calculatorOutputCard.inflationChartTitle");
      g.setAttribute("download", P + ".csv"), g.style.visibility = "hidden", document.body.appendChild(g), g.click(), document.body.removeChild(g);
    }, y = () => {
      if (Ue) {
        const m = Nn.charts[0], h = window.open("", "", "height=600,width=800");
        h && (h.document.write("<html><head><title>Chart Print</title>"), h.document.write("</head><body>"), h.document.write("<h1>Stacked Column Chart</h1>"), h.document.write(m.getSVG()), h.document.write("</body></html>"), h.document.close(), h.print());
      }
    };
    function u(m) {
      let h = '<div class="calculatorTooltip">';
      return m?.forEach((c) => {
        c.name && (h += `
        <div class="calculatorTooltip-element">
          <div class="calculatorTooltip-color">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
              <circle cx="8" cy="8" r="6" fill="${c.color}" />
            </svg>
          </div>
          <div class="calculatorTooltip-label">${c.name}</div>
          <div class="calculatorTooltip-value">${i(
          c.value || 0,
          {
            useDefaultOptions: !0,
            checkForInteger: !0,
            currency: n?.model?.currency,
            currencyDisplay: "symbol"
          }
        )}</div>
        </div>
      `);
      }), h += "</div>", h;
    }
    return t({
      downloadCSV: d,
      printChart: y
    }), (m, h) => e.model.seriesData ? (E(), X("div", pfe, [
      ue(eh, {
        ref_key: "calculatorOutputChart",
        ref: a,
        options: r.value,
        type: _(Ra).Chart,
        height: _(Vo).Small
      }, null, 8, ["options", "type", "height"])
    ])) : te("", !0);
  }
});
const mfe = {
  key: 0,
  class: "d-calculator-output-card"
}, gfe = {
  key: 0,
  class: "d-calculator-output-card__header__column"
}, vfe = {
  key: 0,
  class: "d-calculator-output-card__header__column__legend__item__row"
}, yfe = { class: "d-calculator-output-card__chart" }, bfe = {
  key: 1,
  class: "d-calculator-output-card__cta"
}, xfe = {
  key: 0,
  class: "d-calculator-output-card__cta__text-area"
}, wfe = {
  key: 1,
  class: "d-calculator-output-card__cta__button-area"
}, kfe = /* @__PURE__ */ Be({
  __name: "CalculatorOutputCard",
  props: {
    model: {
      type: Object,
      required: !0
    },
    type: {
      type: String,
      default: ei.Investment
    },
    metaTags: {
      type: Object,
      default: void 0
    },
    currency: {
      type: String,
      required: !0
    },
    yearsStep: {
      type: Number,
      default: 1,
      required: !0
    }
  },
  setup(e) {
    const t = e, { t: n } = Je(), { abbreviateNumber: i } = Uc(), { getCircleComponent: o } = qL(), { currentBreakpoint: a } = xt(), r = ge(), s = ge(t.metaTags), l = ge(void 0), d = ge(null), y = ge(null), u = ge(null);
    let m = null;
    const h = () => {
      r.value?.downloadCSV();
    }, c = ge(
      t?.type === ei.Investment ? [
        { key: "valueDevelopment" },
        { key: "regularInvestment" },
        { key: "initialInvestment" }
      ] : t?.type === ei.Inflation ? [{ key: "purchasingPower" }] : void 0
    ), g = Te(() => {
      if (t?.type === ei.Investment)
        return t?.model?.infoText || n("calculatorOutputCard.investmentInfoText");
      if (t?.type === ei.Inflation) {
        const k = t?.model?.inflationValues?.adjustedCapital?.[0] || 0, A = {
          years: t?.model?.inflationValues?.observationYears || 0,
          value: i(k, {
            useDefaultOptions: !0,
            checkForInteger: !0,
            currency: t.currency,
            currencyDisplay: "code"
          })
        };
        return t?.model?.infoText ? w(t?.model?.infoText, A) : n("calculatorOutputCard.inflationInfoText", A);
      }
      return t?.model?.infoText;
    }), v = Te(() => t?.type === ei.Inflation ? i(
      t?.model?.inflationValues?.adjustedCapital?.[t?.model?.inflationValues?.adjustedCapital?.length - 1] || 0,
      {
        useDefaultOptions: !0,
        currency: t?.currency,
        currencyDisplay: "symbol"
      }
    ) : t?.type === ei.Investment ? i(
      t?.model?.investmentValues?.summary?.[t?.model?.investmentValues?.summary?.length - 1] || 0,
      {
        useDefaultOptions: !0,
        currency: t?.currency,
        currencyDisplay: "symbol"
      }
    ) : ""), P = Te(() => {
      const k = t?.type === ei.Investment;
      return {
        type: t?.type,
        seriesData: k ? [
          t.model?.investmentValues?.valueDevelopment,
          t.model?.investmentValues?.regularInvestment,
          t.model?.investmentValues?.initialInvestment
        ] : [t.model?.inflationValues?.adjustedCapital],
        seriesNames: c.value?.map((A) => A?.label),
        chartType: t?.type,
        currency: t?.currency,
        width: l.value,
        yearsStep: t?.yearsStep
      };
    }), f = () => {
      if (t.model.legendLabels ||= {}, t?.type === ei.Investment && [
        "valueDevelopment",
        "regularInvestment",
        "initialInvestment"
      ].forEach((A, $) => {
        const j = c.value.find((N) => N.key === A);
        j && (j.label = t?.model?.legendLabels?.[j.key] || n(`calculatorOutputCard.${j.key}`), j.value = S(
          t?.model?.investmentValues?.[A]
        ).toString(), j.color = w1?.series?.[$]?.className || "red");
      }), t?.type === ei.Inflation) {
        const k = c.value.find((A) => A.key === "purchasingPower");
        k && (k.label = t?.model?.legendLabels?.[k?.key] || n(`calculatorOutputCard.${k.key}`), k.color = w1?.series?.[1]?.className || "red");
      }
    }, S = (k) => i(k && k.length !== 0 ? k?.[k.length - 1] : 0, {
      useDefaultOptions: !0,
      currency: t?.currency,
      currencyDisplay: "symbol"
    });
    function w(k, A) {
      return k.replace(/\{(\w+)}/g, ($, j) => A?.[j] !== void 0 ? String(A?.[j]) : `{${j}}`);
    }
    const x = () => {
      if (!d?.value || !y?.value || !u?.value)
        return;
      const k = y?.value?.getBoundingClientRect(), A = u.value.getBoundingClientRect(), $ = Math.abs(A.top - k.top) > k.height / 2;
      u.value.classList.toggle(
        "d-calculator-output-card__header__column__legend--end",
        !$
      );
    };
    return qe(
      () => t?.model,
      () => {
        f();
      },
      { immediate: !0, deep: !0 }
    ), qe(
      () => t.metaTags,
      (k) => {
        s.value = k;
      },
      { immediate: !0, deep: !0 }
    ), qe(
      a,
      (k) => {
        ["Xxl", "Xxxl"].includes(k) ? l.value = 540 : l.value = void 0;
      },
      { immediate: !0 }
    ), it(() => {
      d?.value && !c?.value?.some((k) => k?.value) && (x(), m = new ResizeObserver(() => {
        x();
      }), m.observe(d.value));
    }), (k, A) => e.model ? (E(), X("div", mfe, [
      g.value || v.value || c.value?.some(($) => $?.label) ? (E(), X("div", {
        key: 0,
        ref_key: "headerRef",
        ref: d,
        class: "d-calculator-output-card__header"
      }, [
        g.value || v.value ? (E(), X("div", gfe, [
          oe("div", {
            ref_key: "headlineRef",
            ref: y,
            class: "d-calculator-output-card__header__column__headline"
          }, [
            g.value ? (E(), fe(_(Tt), {
              key: 0,
              class: "d-calculator-output-card__header__column",
              text: g.value,
              "text-color": _(dt).NearWhite
            }, null, 8, ["text", "text-color"])) : te("", !0),
            v.value ? (E(), fe(_(Ot), {
              key: 1,
              class: "d-calculator-output-card__header__column d-calculator-output-card__header__column__headline__value",
              "base-heading-type": _(ze).StyledAsH1
            }, {
              default: Se(() => [
                oe("span", null, Ie(v.value), 1)
              ]),
              _: 1
            }, 8, ["base-heading-type"])) : te("", !0)
          ], 512)
        ])) : te("", !0),
        c.value?.some(($) => $?.label) ? (E(), X("div", {
          key: 1,
          ref_key: "legendRef",
          ref: u,
          class: Pe(["d-calculator-output-card__header__column d-calculator-output-card__header__column__legend", {
            "d-calculator-output-card__header__column__legend--end": !c.value?.some(($) => $?.value)
          }])
        }, [
          (E(!0), X(Re, null, Ge(c.value, ($, j) => (E(), X("div", {
            key: `${$?.key}-${j}`,
            class: "d-calculator-output-card__header__column__legend__item"
          }, [
            $?.color || $?.label ? (E(), X("div", vfe, [
              (E(), fe(tt(_(o)($?.color, !0)), { class: "d-calculator-output-card__header__column__legend__item__row__indicator" })),
              $?.label ? (E(), fe(_(Tt), {
                key: 0,
                text: $?.label,
                "text-color": _(dt).NearWhite,
                "font-type": _(lt).DwsSlab,
                "font-size": _(st).FourteenPx,
                class: "d-calculator-output-card__header__column__legend__item__row__label"
              }, null, 8, ["text", "text-color", "font-type", "font-size"])) : te("", !0)
            ])) : te("", !0),
            $?.value ? (E(), fe(_(Tt), {
              key: 1,
              text: $?.value,
              "text-color": _(dt).NearWhite,
              "font-size": _(st).FourteenPx,
              class: "d-calculator-output-card__header__column__legend__item__row__value"
            }, null, 8, ["text", "text-color", "font-size"])) : te("", !0)
          ]))), 128))
        ], 2)) : te("", !0)
      ], 512)) : te("", !0),
      oe("div", yfe, [
        ue(ffe, {
          ref_key: "outputChart",
          ref: r,
          model: P.value
        }, null, 8, ["model"])
      ]),
      e.model?.ctaHeadline || e.model?.ctaText || e.model?.primaryButton || e.model?.ghostButton ? (E(), X("div", bfe, [
        e.model?.ctaHeadline || e.model?.ctaText ? (E(), X("div", xfe, [
          e.model?.ctaHeadline ? (E(), fe(_(Tt), {
            key: 0,
            text: e.model?.ctaHeadline,
            "text-color": _(dt).NearWhite,
            "font-type": _(lt).DwsSlabBold,
            "font-size": _(st).EighteenPx
          }, null, 8, ["text", "text-color", "font-type", "font-size"])) : te("", !0),
          e.model?.ctaText ? (E(), fe(_(Tt), {
            key: 1,
            class: "d-calculator-output-card__cta__text-area__text",
            text: e.model?.ctaText,
            "text-color": _(dt).NearWhite,
            "font-size": _(st).FourteenPx
          }, null, 8, ["text", "text-color", "font-size"])) : te("", !0)
        ])) : te("", !0),
        e.model?.primaryButton || e.model?.ghostButton ? (E(), X("div", wfe, [
          e.model?.primaryButton ? (E(), fe(_(vt), {
            key: 0,
            "link-model": e.model?.primaryButton,
            size: _(et).Medium,
            "button-type": _(zt).Link
          }, null, 8, ["link-model", "size", "button-type"])) : te("", !0),
          e.model?.ghostButton ? (E(), fe(_(vt), {
            key: 1,
            "link-model": e.model?.ghostButton,
            size: _(et).Medium,
            type: _(Ke).Ghost,
            "button-type": _(zt).Link
          }, null, 8, ["link-model", "size", "type", "button-type"])) : te("", !0)
        ])) : te("", !0)
      ])) : te("", !0),
      s.value ? (E(), fe(_(dfe), {
        key: 2,
        "meta-tags": s.value,
        "share-buttons": [
          _(Pt).Linkedin,
          _(Pt).Twitter,
          _(Pt).Facebook,
          _(Pt).Xing,
          _(Pt).EmailLink
        ],
        onDownload: h
      }, null, 8, ["meta-tags", "share-buttons"])) : te("", !0)
    ])) : te("", !0);
  }
});
const FT = /* @__PURE__ */ Fe(kfe, [["__scopeId", "data-v-646baf2d"]]), Sfe = {
  key: 0,
  class: "d-inflation-calculation-area"
}, Cfe = { class: "d-inflation-calculation-area__settings" }, Tfe = { class: "d-inflation-calculation-area__settings__item" }, Lfe = {
  key: 0,
  class: "d-inflation-calculation-area__settings__item"
}, Ife = { class: "d-inflation-calculation-area__inflation-rate-switch" }, Pfe = {
  class: "d-inflation-calculation-area__inflation-rate-label",
  for: "taxSwitch"
}, Afe = { class: "d-inflation-calculation-area__footer" }, _fe = /* @__PURE__ */ Be({
  __name: "InflationCalculationArea",
  props: {
    model: {
      type: Object,
      required: !0
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    currency: {
      type: String,
      required: !0
    }
  },
  emits: ["calculate", "jumpToChart"],
  setup(e, { emit: t }) {
    const n = e, { pageName: i } = Qe(), { isDesktopAsync: o } = xt(), { t: a } = Je(), { getCurrencyAffix: r } = Uc(), s = t, l = () => {
      s("jumpToChart");
    }, d = ge(null), y = ge(null), u = ge(n?.model?.capitalInvestment.value), m = ge(
      n?.model?.useCurrentInflationRate?.active ? n?.model?.useCurrentInflationRate?.currentInflationRate : n?.model?.inflationRate.value
    ), h = ge(n?.model?.observationPeriod.value), c = ge(
      n?.model?.useCurrentInflationRate?.active || !1
    ), g = ge(n?.model?.capitalInvestment.value), v = ge(m.value), P = ge(n?.model?.observationPeriod.value), f = () => {
      u.value = g.value, m.value = v.value, h.value = P.value, n?.model?.useCurrentInflationRate && (c.value = n?.model?.useCurrentInflationRate?.active), $();
    }, S = (M) => {
      u.value = Number(M), N("Capital investment changed", M, n.currency), $();
    }, w = (M, D) => {
      m.value !== M && (m.value = Number(M), N("Inflation rate changed", M, "%"), D === "slider" && n?.model?.useCurrentInflationRate && (c.value = !1), $());
    }, x = (M) => {
      h.value = Number(M), N("Observation period changed", M, "years"), $();
    }, k = (M) => {
      c.value = M, M && (m.value = n?.model?.useCurrentInflationRate.currentInflationRate), $();
    }, A = () => {
      const M = {
        capitalInvestment: {
          ...n.model.capitalInvestment,
          value: u.value
        },
        inflationRate: {
          ...n.model.inflationRate,
          value: m.value
        },
        observationPeriod: {
          ...n.model.observationPeriod,
          value: h.value
        }
      };
      return n?.model?.useCurrentInflationRate && (M.useCurrentInflationRate = n.model.useCurrentInflationRate), M;
    }, $ = () => {
      const M = {
        adjustedCapital: [],
        observationYears: h.value
      };
      for (let D = 0; D <= h.value; D += n?.model?.observationPeriod?.step)
        M.adjustedCapital.push(
          u.value / Math.pow(1 + m.value / 100, D)
        );
      s("calculate", M, A());
    }, j = (M) => ({
      contentUrl: "",
      title: M,
      text: M,
      isLocked: !1,
      target: "",
      isExternal: !1,
      linkType: yt.Javascript,
      tealiumTrackingModel: {
        eventSource: i,
        eventComponentName: "InflationCalculationArea",
        eventTitle: M
      }
    }), N = (M, D, C) => On(
      "InflationCalculator",
      `${M} | ${D}${C}`,
      i
    );
    return it(() => {
      $();
      const M = r(n?.currency);
      d.value = M?.prefix, y.value = M?.suffix;
    }), qe(c, (M) => {
      On(
        "InflationCalculator",
        `Use current inflation rate | ${M}`,
        i
      ), M && (m.value = n?.model?.useCurrentInflationRate.currentInflationRate, $());
    }), (M, D) => e.model ? (E(), X("div", Sfe, [
      oe("div", Cfe, [
        oe("div", Tfe, [
          ue(to, {
            class: "d-inflation-calculation-area__slider",
            "helper-text": e.model?.capitalInvestment?.helperText,
            value: u.value,
            label: e.model?.capitalInvestment.label,
            min: e.model?.capitalInvestment.min,
            max: e.model?.capitalInvestment.max,
            step: e.model?.capitalInvestment.step,
            "number-suffix": y.value,
            "number-prefix": d.value,
            "validate-step": !1,
            onChanged: D[0] || (D[0] = (C) => S(C))
          }, null, 8, ["helper-text", "value", "label", "min", "max", "step", "number-suffix", "number-prefix"])
        ]),
        oe("div", {
          class: Pe({
            "d-inflation-calculation-area__settings__item": !e.model?.useCurrentInflationRate
          })
        }, [
          ue(to, {
            class: "d-inflation-calculation-area__slider",
            "helper-text": e.model?.inflationRate?.helperText,
            value: m.value,
            label: e.model?.inflationRate?.label,
            min: e.model?.inflationRate?.min,
            max: e.model?.inflationRate?.max,
            step: e.model?.inflationRate?.step,
            "validate-step": !1,
            "number-suffix": "%",
            onChanged: D[1] || (D[1] = (C) => w(C, "slider"))
          }, null, 8, ["helper-text", "value", "label", "min", "max", "step"])
        ], 2),
        e.model?.useCurrentInflationRate ? (E(), X("div", Lfe, [
          oe("span", Ife, [
            ue(hT, {
              id: "useCurrentInflation",
              modelValue: c.value,
              "onUpdate:modelValue": [
                D[2] || (D[2] = (C) => c.value = C),
                k
              ],
              "aria-label": e.model?.calculationButtonLabel || _(a)("calculationArea.calculationButtonLabel"),
              onKeydown: D[3] || (D[3] = Ze(It((C) => c.value = !c.value, ["prevent"]), ["space", "enter"]))
            }, null, 8, ["modelValue", "aria-label"]),
            oe("label", Pfe, Ie(_(a)("calculationArea.currentInflationRateLabel")), 1)
          ]),
          ue(Tt, {
            class: "d-inflation-calculation-area__inflation-rate-description",
            text: e.model?.useCurrentInflationRate?.description,
            "text-color": _(dt).GreyBlue006,
            "font-type": _(lt).DwsSans
          }, null, 8, ["text", "text-color", "font-type"])
        ])) : te("", !0),
        ue(to, {
          class: "d-inflation-calculation-area__slider d-inflation-calculation-area__settings__item",
          "helper-text": e.model?.observationPeriod?.helperText,
          value: h.value,
          label: e.model?.observationPeriod?.label,
          min: e.model?.observationPeriod?.min,
          max: e.model?.observationPeriod?.max,
          step: e.model?.observationPeriod?.step,
          "number-suffix": ` ${h.value === 1 ? _(a)("globalTranslations.year") : _(a)("globalTranslations.years")}`,
          "validate-step": !1,
          onChanged: D[4] || (D[4] = (C) => x(C))
        }, null, 8, ["helper-text", "value", "label", "min", "max", "step", "number-suffix"])
      ]),
      oe("div", Afe, [
        _(o) ? te("", !0) : (E(), fe(vt, {
          key: 0,
          "link-model": j(
            e.model?.calculationButtonLabel || _(a)("calculationArea.calculationButtonLabel")
          ),
          type: _(Ke).Primary,
          size: _(et).Large,
          icon: _(H).SlidersH,
          "icon-position": _(ct).Left,
          class: "d-investment-calculation-area__calculate",
          onClick: D[5] || (D[5] = (C) => l())
        }, null, 8, ["link-model", "type", "size", "icon", "icon-position"])),
        ue(vt, {
          "link-model": j(
            e.model.restartButtonLabel || _(a)("calculationArea.restartButtonLabel")
          ),
          type: _(Ke).Secondary,
          size: _(et).Large,
          icon: _(H).RedoAlt,
          "icon-position": _(ct).Left,
          class: "d-inflation-calculation-area__restart",
          onClick: D[6] || (D[6] = (C) => f())
        }, null, 8, ["link-model", "type", "size", "icon", "icon-position"])
      ])
    ])) : te("", !0);
  }
});
const Mfe = /* @__PURE__ */ Fe(_fe, [["__scopeId", "data-v-e1366272"]]), Ofe = {
  key: 0,
  class: "d-inflation-calculator"
}, Bfe = { class: "d-inflation-calculator__column" }, Efe = { class: "d-inflation-calculator__column" }, Dfe = /* @__PURE__ */ Be({
  __name: "InflationCalculator",
  props: {
    model: {
      type: Object,
      required: !0
    }
  },
  setup(e) {
    const t = e, n = $t("smoothScroll"), { calculateScrollPosition: i } = Fn(), o = ge(
      t.model.inflationCalculationAreaProps
    ), a = ge(t.model.calculatorOutputCardProps), r = ge(null);
    function s() {
      if (!Ue)
        return {};
      const c = new URL(window.location.href), g = new URLSearchParams(c.search), v = {};
      return g.forEach((P, f) => {
        const S = parseFloat(P);
        v[f] = isNaN(S) ? null : S;
      }), v;
    }
    const l = s();
    Object.keys(l).length > 0 && (o.value.capitalInvestment.value = l.clcI || t.model?.inflationCalculationAreaProps?.capitalInvestment?.value, o.value.inflationRate.value = l.cliR || t.model?.inflationCalculationAreaProps?.inflationRate.value, o?.value?.useCurrentInflationRate && "cliR" in l && (o.value.useCurrentInflationRate.active = o.value.useCurrentInflationRate.currentInflationRate === o.value.inflationRate.value), o.value.observationPeriod.value = l.cloP || t.model?.inflationCalculationAreaProps?.observationPeriod?.value);
    const d = Te(() => ({
      clcI: o.value?.capitalInvestment?.value?.toString(),
      cliR: o.value?.inflationRate?.value?.toString(),
      cloP: o.value?.observationPeriod?.value?.toString()
    })), y = (c, g) => {
      const v = new URL(c);
      return Object.entries(g).forEach(([P, f]) => {
        v.searchParams.set(P, f);
      }), v.toString();
    }, u = Te(() => {
      if (!Ue)
        return {
          ogUrl: void 0,
          twitterUrl: void 0
        };
      const c = y(
        window.location.href,
        d.value
      );
      return {
        ogUrl: c,
        twitterUrl: c
      };
    }), m = (c, g) => {
      a.value.inflationValues = c, o.value.capitalInvestment.value = g.capitalInvestment?.value, o.value.inflationRate.value = g.inflationRate?.value, o.value.observationPeriod.value = g.observationPeriod?.value;
    }, h = () => {
      Ue && n({
        scrollTo: i(r.value?.$el),
        duration: 1e3,
        updateHistory: !1
      });
    };
    return (c, g) => e.model ? (E(), X("div", Ofe, [
      e.model?.headline || e.model?.introText ? (E(), X("div", {
        key: 0,
        class: Pe(["d-inflation-calculator__header", {
          "d-inflation-calculator__header--full-width": e.model.fullWidth
        }])
      }, [
        ue(Hs, {
          model: {
            headline: e.model.headline,
            introText: e.model.introText
          },
          "base-heading-type": e.model.headingType || _(ze).H1
        }, null, 8, ["model", "base-heading-type"])
      ], 2)) : te("", !0),
      e.model.inflationCalculationAreaProps && e.model.calculatorOutputCardProps ? (E(), X("div", {
        key: 1,
        class: Pe(["d-inflation-calculator__container", {
          "d-inflation-calculator__container--bg-grey": e.model.fullWidth,
          "d-inflation-calculator__container--full-width": e.model.fullWidth
        }])
      }, [
        oe("div", Bfe, [
          ue(_(Mfe), {
            model: o.value,
            currency: e.model?.currency,
            onCalculate: m,
            onJumpToChart: h
          }, null, 8, ["model", "currency"])
        ]),
        oe("div", Efe, [
          ue(_(FT), {
            ref_key: "outputCard",
            ref: r,
            model: a.value,
            type: _(ei).Inflation,
            "meta-tags": u.value,
            currency: e.model?.currency,
            "years-step": e.model?.inflationCalculationAreaProps?.observationPeriod?.step
          }, null, 8, ["model", "type", "meta-tags", "currency", "years-step"])
        ])
      ], 2)) : te("", !0)
    ])) : te("", !0);
  }
});
const BBe = /* @__PURE__ */ Fe(Dfe, [["__scopeId", "data-v-a9521ada"]]), Rfe = {
  key: 0,
  class: "d-croci-company-detail-page-ticker"
}, Nfe = { class: "d-croci-company-detail-page-ticker__ticker" }, $fe = { key: 1 }, Ffe = {
  key: 2,
  class: "d-croci-company-detail-page-ticker__ticker--mobile"
}, jfe = { key: 5 }, Hfe = {
  key: 6,
  class: "d-croci-company-detail-page-ticker__ticker--mobile"
}, zfe = /* @__PURE__ */ Be({
  __name: "CrociCompanyDetailPageTicker",
  props: {
    model: {
      type: Object,
      required: !0
    }
  },
  setup(e) {
    const { t } = Je(), { isMobileAsync: n } = xt();
    return (i, o) => e.model ? (E(), X("div", Rfe, [
      oe("div", Nfe, [
        e.model.companyTicker ? (E(), fe(Tt, {
          key: 0,
          text: _(t)("crociCompanyDetailPage.ticker.ticker"),
          "font-size": _(st).FourteenPx,
          "text-color": _(dt).GreyBlue006,
          "font-type": _(lt).DwsSansBold
        }, null, 8, ["text", "font-size", "text-color", "font-type"])) : te("", !0),
        ue(Kg, {
          "input-text": e.model.companyTicker
        }, null, 8, ["input-text"]),
        _(n) ? te("", !0) : (E(), X("span", $fe, "|")),
        _(n) ? (E(), X("div", Ffe)) : te("", !0),
        e.model.category ? (E(), fe(Tt, {
          key: 3,
          text: _(t)("crociCompanyDetailPage.ticker.category"),
          "font-size": _(st).FourteenPx,
          "text-color": _(dt).GreyBlue006,
          "font-type": _(lt).DwsSansBold
        }, null, 8, ["text", "font-size", "text-color", "font-type"])) : te("", !0),
        e.model.category ? (E(), fe(Tt, {
          key: 4,
          text: e.model.category,
          "font-size": _(st).FourteenPx,
          "text-color": _(dt).GreyBlue006,
          "font-type": _(lt).DwsSans
        }, null, 8, ["text", "font-size", "text-color", "font-type"])) : te("", !0),
        _(n) ? te("", !0) : (E(), X("span", jfe, "|")),
        _(n) ? (E(), X("div", Hfe)) : te("", !0),
        e.model.category ? (E(), fe(Tt, {
          key: 7,
          text: _(t)("crociCompanyDetailPage.ticker.sharePrice"),
          "font-size": _(st).FourteenPx,
          "text-color": _(dt).GreyBlue006,
          "font-type": _(lt).DwsSansBold
        }, null, 8, ["text", "font-size", "text-color", "font-type"])) : te("", !0),
        e.model.sharePrice ? (E(), fe(Tt, {
          key: 8,
          text: e.model.currency + " " + e.model.sharePrice,
          "font-size": _(st).FourteenPx,
          "text-color": _(dt).GreyBlue006,
          "font-type": _(lt).DwsSans
        }, null, 8, ["text", "font-size", "text-color", "font-type"])) : te("", !0)
      ])
    ])) : te("", !0);
  }
});
const Vfe = /* @__PURE__ */ Fe(zfe, [["__scopeId", "data-v-910cdc4c"]]), Gfe = { class: "d-croci-company-detail-header__charts" }, Ufe = /* @__PURE__ */ Be({
  __name: "CrociCompanyDetailHeader",
  props: {
    sectionId: {
      type: String,
      required: !0
    },
    sectionTitle: {
      type: String,
      required: !0
    },
    headerAreaModel: {
      type: Object,
      required: !0
    },
    headingType: {
      type: String,
      default: ze.H1
    },
    tickerModel: {
      type: Object,
      required: !0
    },
    linkModel: {
      type: Object,
      required: !0
    },
    linkIcon: {
      type: String,
      required: !0
    },
    fullWidth: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["scrollToSection"],
  setup(e, { emit: t }) {
    const n = t, i = (o) => {
      n("scrollToSection", o);
    };
    return (o, a) => (E(), fe(Vt, {
      id: e.sectionId,
      class: "d-croci-company-detail-header",
      "content-in-full-width": e.fullWidth,
      "no-margin-bottom": !0,
      "no-margin": !0
    }, {
      default: Se(() => [
        ue(Hs, {
          class: "d-croci-company-detail-header__header",
          model: e.headerAreaModel,
          "base-heading-type": e.headingType
        }, {
          intro: Se(() => [
            ue(Vfe, { model: e.tickerModel }, null, 8, ["model"])
          ]),
          _: 1
        }, 8, ["model", "base-heading-type"]),
        oe("div", Gfe, [
          ue(Ot, {
            "base-heading-type": _(ze).H2Section,
            class: "d-croci-company-detail-header-charts__header-heading"
          }, {
            default: Se(() => [
              oe("span", null, Ie(e.sectionTitle), 1)
            ]),
            _: 1
          }, 8, ["base-heading-type"]),
          ue(ot, {
            class: "d-croci-company-detail-header-charts__header-data-page-link",
            "link-model": e.linkModel,
            icon: e.linkIcon,
            "icon-position": _(ct).Left,
            onClick: It(i, ["prevent"]),
            onKeydown: [
              Ze(It(i, ["prevent"]), ["enter"]),
              Ze(It(i, ["prevent"]), ["space"])
            ]
          }, null, 8, ["link-model", "icon", "icon-position", "onKeydown"])
        ])
      ]),
      _: 1
    }, 8, ["id", "content-in-full-width"]));
  }
});
const k1 = /* @__PURE__ */ Fe(Ufe, [["__scopeId", "data-v-07078a04"]]), Wfe = {
  key: 0,
  class: "d-croci-company-detail-data-table"
}, Yfe = /* @__PURE__ */ Be({
  __name: "CrociCompanyDetailDataTable",
  props: {
    model: {
      type: Object,
      required: !0
    }
  },
  emits: ["expanded"],
  setup(e, { expose: t, emit: n }) {
    const i = e, o = n, { isMobile: a } = xt(), r = ge(!1), s = Te(() => {
      const d = r.value ? i?.model?.columns : i?.model?.columns.filter(
        (y) => i?.model?.alwaysVisibleKeys.includes(y.key)
      );
      return {
        values: i?.model?.values,
        columns: d,
        frozenColumn: i?.model?.frozenColumn,
        id: i?.model?.id
      };
    });
    return qe(
      () => a.value,
      (d) => {
        d && !r.value && (r.value = !0, o("expanded"));
      },
      { immediate: !0 }
    ), t({
      setShowAllColumns: (d) => {
        r.value = d;
      }
    }), (d, y) => e.model ? (E(), X("div", Wfe, [
      _(a) ? (E(), fe(_(Vg), {
        key: 1,
        props: s.value,
        "show-sort-by": !1,
        "always-visible-keys": e.model.alwaysVisibleKeys,
        "max-length": s.value.values.length
      }, null, 8, ["props", "always-visible-keys", "max-length"])) : (E(), fe(Fu, {
        key: 0,
        model: s.value,
        "show-paginator": !1
      }, null, 8, ["model"])),
      e.model?.downloadLink ? (E(), fe(_(vt), {
        key: 2,
        class: "d-croci-company-detail-data-table__button",
        type: _(Ke).Secondary,
        "button-type": _(zt).Link,
        "link-model": e.model?.downloadLink
      }, null, 8, ["type", "button-type", "link-model"])) : te("", !0)
    ])) : te("", !0);
  }
});
const qfe = /* @__PURE__ */ Fe(Yfe, [["__scopeId", "data-v-acb377c4"]]), S1 = {
  colors: Ok,
  symbols: ["circle", "diamond", "square", "triangle", "triangle-down"],
  lang: {
    noData: "No data to display"
  },
  global: {},
  time: {
    timezoneOffset: 0,
    useUTC: !0
  },
  accessibility: {
    enabled: !0,
    description: "This chart displays the CROCI over time.",
    series: {
      descriptionFormatter: function(e) {
        return e.name + ", with " + e.points.length + " data points.";
      }
    },
    highContrastMode: "auto",
    keyboardNavigation: {
      enabled: !0,
      focusBorder: {
        enabled: !0,
        hideBrowserFocusOutline: !0,
        style: {
          lineWidth: 2,
          color: Ai,
          borderRadius: 2
        },
        margin: 2
      },
      order: ["series", "legend"],
      seriesNavigation: {
        mode: "normal",
        skipNullPoints: !0
      }
    }
  },
  chart: {
    panning: {
      enabled: !1
    },
    styledMode: !1,
    borderRadius: 0,
    colorCount: 10,
    defaultSeriesType: "line",
    ignoreHiddenSeries: !0,
    resetZoomButton: {
      theme: {
        zIndex: 6
      },
      position: {
        align: "right",
        x: -10,
        y: 10
      }
    },
    zoomBySingleTouch: !1,
    borderColor: "#335cad",
    backgroundColor: "#ffffff",
    plotBorderColor: "#cccccc",
    marginTop: null
  },
  title: {
    style: {
      color: "#2e393d",
      fontSize: "18px",
      fill: "#2e393d",
      width: "274px"
    },
    text: "",
    align: "left",
    margin: 15,
    widthAdjust: -44
  },
  subtitle: {
    style: {
      color: "#666666",
      fill: "#666666",
      width: "274px"
    },
    text: "",
    align: "left",
    widthAdjust: -44
  },
  caption: {
    style: {
      color: "#666666",
      fill: "#666666",
      width: "318px"
    },
    margin: 0,
    text: "",
    align: "left",
    verticalAlign: "bottom"
  },
  plotOptions: {
    line: {
      lineWidth: 2,
      allowPointSelect: !1,
      crisp: !0,
      showCheckbox: !1,
      animation: {
        duration: 1e3
      },
      events: {},
      marker: {
        enabledThreshold: 2,
        lineColor: "#ffffff",
        lineWidth: 0,
        radius: 4,
        states: {
          normal: {
            animation: !0
          },
          hover: {
            animation: {
              duration: 50
            },
            enabled: !0,
            radiusPlus: 2,
            lineWidthPlus: 1
          },
          select: {
            fillColor: "#cccccc",
            lineColor: "#000000",
            lineWidth: 2
          }
        }
      },
      point: {
        events: {}
      },
      dataLabels: {
        animation: {},
        align: "left",
        defer: !0,
        padding: 5,
        style: {
          fontSize: "11px",
          fontWeight: "bold",
          color: "contrast",
          textOutline: "1px contrast"
        },
        verticalAlign: "bottom",
        x: 0,
        y: 0
      },
      cropThreshold: 300,
      opacity: 1,
      pointRange: 0,
      softThreshold: !0,
      states: {
        normal: {
          animation: !0
        },
        hover: {
          animation: {
            duration: 50
          },
          lineWidthPlus: 1,
          marker: {},
          halo: {
            size: 10,
            opacity: 0.25
          }
        },
        select: {
          animation: {
            duration: 0
          }
        },
        inactive: {
          animation: {
            duration: 50
          },
          opacity: 0.2
        }
      },
      stickyTracking: !0,
      turboThreshold: 1e3,
      findNearestPointBy: "x"
    },
    area: {
      lineWidth: 2,
      allowPointSelect: !1,
      crisp: !0,
      showCheckbox: !1,
      animation: {
        duration: 1e3
      },
      events: {},
      marker: {
        enabledThreshold: 2,
        lineColor: "#ffffff",
        lineWidth: 0,
        radius: 4,
        states: {
          normal: {
            animation: !0
          },
          hover: {
            animation: {
              duration: 50
            },
            enabled: !0,
            radiusPlus: 2,
            lineWidthPlus: 1
          },
          select: {
            fillColor: "#cccccc",
            lineColor: "#000000",
            lineWidth: 2
          }
        }
      },
      point: {
        events: {}
      },
      dataLabels: {
        animation: {},
        align: "left",
        defer: !0,
        padding: 5,
        style: {
          fontSize: "11px",
          fontWeight: "bold",
          color: "contrast",
          textOutline: "1px contrast"
        },
        verticalAlign: "bottom",
        x: 0,
        y: 0
      },
      cropThreshold: 300,
      opacity: 1,
      pointRange: 0,
      softThreshold: !0,
      states: {
        normal: {
          animation: !0
        },
        hover: {
          animation: {
            duration: 50
          },
          lineWidthPlus: 1,
          marker: {},
          halo: {
            size: 10,
            opacity: 0.25
          }
        },
        select: {
          animation: {
            duration: 0
          }
        },
        inactive: {
          animation: {
            duration: 50
          },
          opacity: 0.2
        }
      },
      stickyTracking: !0,
      turboThreshold: 1e3,
      findNearestPointBy: "x",
      threshold: 0
    },
    spline: {
      lineWidth: 2,
      allowPointSelect: !1,
      crisp: !0,
      showCheckbox: !1,
      animation: {
        duration: 1e3
      },
      events: {},
      marker: {
        enabledThreshold: 2,
        lineColor: "#ffffff",
        lineWidth: 0,
        radius: 4,
        states: {
          normal: {
            animation: !0
          },
          hover: {
            animation: {
              duration: 50
            },
            enabled: !0,
            radiusPlus: 2,
            lineWidthPlus: 1
          },
          select: {
            fillColor: "#cccccc",
            lineColor: "#000000",
            lineWidth: 2
          }
        }
      },
      point: {
        events: {}
      },
      dataLabels: {
        animation: {},
        align: "left",
        defer: !0,
        padding: 5,
        style: {
          fontSize: "11px",
          fontWeight: "bold",
          color: "contrast",
          textOutline: "1px contrast"
        },
        verticalAlign: "bottom",
        x: 0,
        y: 0
      },
      cropThreshold: 300,
      opacity: 1,
      pointRange: 0,
      softThreshold: !0,
      states: {
        normal: {
          animation: !0
        },
        hover: {
          animation: {
            duration: 50
          },
          lineWidthPlus: 1,
          marker: {},
          halo: {
            size: 10,
            opacity: 0.25
          }
        },
        select: {
          animation: {
            duration: 0
          }
        },
        inactive: {
          animation: {
            duration: 50
          },
          opacity: 0.2
        }
      },
      stickyTracking: !0,
      turboThreshold: 1e3,
      findNearestPointBy: "x"
    },
    areaspline: {
      lineWidth: 2,
      allowPointSelect: !1,
      crisp: !0,
      showCheckbox: !1,
      animation: {
        duration: 1e3
      },
      events: {},
      marker: {
        enabledThreshold: 2,
        lineColor: "#ffffff",
        lineWidth: 0,
        radius: 4,
        states: {
          normal: {
            animation: !0
          },
          hover: {
            animation: {
              duration: 50
            },
            enabled: !0,
            radiusPlus: 2,
            lineWidthPlus: 1
          },
          select: {
            fillColor: "#cccccc",
            lineColor: "#000000",
            lineWidth: 2
          }
        }
      },
      point: {
        events: {}
      },
      dataLabels: {
        animation: {},
        align: "left",
        defer: !0,
        padding: 5,
        style: {
          fontSize: "11px",
          fontWeight: "bold",
          color: "contrast",
          textOutline: "1px contrast"
        },
        verticalAlign: "bottom",
        x: 0,
        y: 0
      },
      cropThreshold: 300,
      opacity: 1,
      pointRange: 0,
      softThreshold: !0,
      states: {
        normal: {
          animation: !0
        },
        hover: {
          animation: {
            duration: 50
          },
          lineWidthPlus: 1,
          marker: {},
          halo: {
            size: 10,
            opacity: 0.25
          }
        },
        select: {
          animation: {
            duration: 0
          }
        },
        inactive: {
          animation: {
            duration: 50
          },
          opacity: 0.2
        }
      },
      stickyTracking: !0,
      turboThreshold: 1e3,
      findNearestPointBy: "x",
      threshold: 0
    },
    column: {
      lineWidth: 2,
      allowPointSelect: !1,
      crisp: !0,
      showCheckbox: !1,
      animation: {
        duration: 1e3
      },
      events: {},
      marker: null,
      point: {
        events: {}
      },
      dataLabels: {
        animation: {},
        defer: !0,
        padding: 5,
        style: {
          fontSize: "11px",
          fontWeight: "bold",
          color: "contrast",
          textOutline: "1px contrast"
        },
        x: 0
      },
      cropThreshold: 50,
      opacity: 1,
      pointRange: null,
      softThreshold: !0,
      states: {
        normal: {
          animation: !0
        },
        hover: {
          animation: {
            duration: 50
          },
          lineWidthPlus: 1,
          marker: {},
          halo: !1,
          brightness: 0.1
        },
        select: {
          animation: {
            duration: 0
          },
          color: "#cccccc",
          borderColor: "#000000"
        },
        inactive: {
          animation: {
            duration: 50
          },
          opacity: 0.2
        }
      },
      stickyTracking: !1,
      turboThreshold: 1e3,
      findNearestPointBy: "x",
      borderRadius: 0,
      centerInCategory: !1,
      groupPadding: 0.2,
      pointPadding: 0.1,
      minPointLength: 0,
      startFromThreshold: !0,
      tooltip: {},
      threshold: 0,
      borderColor: "#ffffff",
      stacking: null
    },
    bar: {
      lineWidth: 2,
      allowPointSelect: !1,
      crisp: !0,
      showCheckbox: !1,
      animation: {
        duration: 1e3
      },
      events: {},
      marker: null,
      point: {
        events: {}
      },
      dataLabels: {
        animation: {},
        defer: !0,
        padding: 5,
        style: {
          fontSize: "11px",
          fontWeight: "bold",
          color: "contrast",
          textOutline: "1px contrast"
        },
        x: 0
      },
      cropThreshold: 50,
      opacity: 1,
      pointRange: null,
      softThreshold: !0,
      states: {
        normal: {
          animation: !0
        },
        hover: {
          animation: {
            duration: 50
          },
          lineWidthPlus: 1,
          marker: {},
          halo: !1,
          brightness: 0.1
        },
        select: {
          animation: {
            duration: 0
          },
          color: "#cccccc",
          borderColor: "#000000"
        },
        inactive: {
          animation: {
            duration: 50
          },
          opacity: 0.2
        }
      },
      stickyTracking: !1,
      turboThreshold: 1e3,
      findNearestPointBy: "x",
      borderRadius: 0,
      centerInCategory: !1,
      groupPadding: 0.2,
      pointPadding: 0.1,
      minPointLength: 0,
      startFromThreshold: !0,
      threshold: 0,
      borderColor: "#ffffff"
    },
    scatter: {
      lineWidth: 0,
      allowPointSelect: !1,
      crisp: !0,
      showCheckbox: !1,
      animation: {
        duration: 1e3
      },
      events: {},
      marker: {
        enabledThreshold: 2,
        lineColor: "#ffffff",
        lineWidth: 0,
        radius: 4,
        states: {
          normal: {
            animation: !0
          },
          hover: {
            animation: {
              duration: 50
            },
            enabled: !0,
            radiusPlus: 2,
            lineWidthPlus: 1
          },
          select: {
            fillColor: "#cccccc",
            lineColor: "#000000",
            lineWidth: 2
          }
        },
        enabled: !0
      },
      point: {
        events: {}
      },
      dataLabels: {
        animation: {},
        align: "left",
        defer: !0,
        padding: 5,
        style: {
          fontSize: "11px",
          fontWeight: "bold",
          color: "contrast",
          textOutline: "1px contrast"
        },
        verticalAlign: "bottom",
        x: 0,
        y: 0
      },
      cropThreshold: 300,
      opacity: 1,
      pointRange: 0,
      softThreshold: !0,
      states: {
        normal: {
          animation: !0
        },
        hover: {
          animation: {
            duration: 50
          },
          lineWidthPlus: 1,
          marker: {},
          halo: {
            size: 10,
            opacity: 0.25
          }
        },
        select: {
          animation: {
            duration: 0
          }
        },
        inactive: {
          animation: {
            duration: 50
          },
          opacity: 0.2
        }
      },
      stickyTracking: !0,
      turboThreshold: 1e3,
      findNearestPointBy: "xy",
      jitter: {
        x: 0,
        y: 0
      }
    },
    pie: {
      allowPointSelect: !1,
      crisp: !0,
      showCheckbox: !1,
      animation: {
        duration: 1e3
      },
      events: {},
      marker: null,
      point: {
        events: {}
      },
      dataLabels: {
        animation: {},
        align: "left",
        defer: !0,
        padding: 5,
        style: {
          fontSize: "11px",
          fontWeight: "bold",
          color: "contrast",
          textOutline: "1px contrast"
        },
        verticalAlign: "bottom",
        x: 0,
        y: 0,
        allowOverlap: !0,
        connectorPadding: 5,
        connectorShape: "fixedOffset",
        crookDistance: "70%",
        distance: 30,
        enabled: !0,
        softConnector: !0
      },
      cropThreshold: 300,
      opacity: 1,
      pointRange: 0,
      softThreshold: !0,
      states: {
        normal: {
          animation: !0
        },
        hover: {
          animation: {
            duration: 50
          },
          lineWidthPlus: 1,
          marker: {},
          halo: {
            size: 10,
            opacity: 0.25
          },
          brightness: 0.1
        },
        select: {
          animation: {
            duration: 0
          }
        },
        inactive: {
          animation: {
            duration: 50
          },
          opacity: 0.2
        }
      },
      stickyTracking: !1,
      turboThreshold: 1e3,
      findNearestPointBy: "x",
      center: [null, null],
      clip: !1,
      colorByPoint: !0,
      ignoreHiddenPoint: !0,
      inactiveOtherPoints: !0,
      legendType: "point",
      size: null,
      showInLegend: !1,
      slicedOffset: 10,
      borderColor: "#ffffff",
      borderWidth: 1
    },
    ohlc: {
      lineWidth: 1,
      allowPointSelect: !1,
      crisp: !0,
      showCheckbox: !1,
      animation: {
        duration: 1e3
      },
      events: {},
      marker: null,
      point: {
        events: {}
      },
      dataLabels: {
        animation: {},
        defer: !0,
        padding: 5,
        style: {
          fontSize: "11px",
          fontWeight: "bold",
          color: "contrast",
          textOutline: "1px contrast"
        },
        x: 0
      },
      cropThreshold: 50,
      opacity: 1,
      pointRange: null,
      softThreshold: !0,
      states: {
        normal: {
          animation: !0
        },
        hover: {
          animation: {
            duration: 50
          },
          lineWidthPlus: 1,
          marker: {},
          halo: !1,
          brightness: 0.1,
          lineWidth: 3
        },
        select: {
          animation: {
            duration: 0
          },
          color: "#cccccc",
          borderColor: "#000000"
        },
        inactive: {
          animation: {
            duration: 50
          },
          opacity: 0.2
        }
      },
      stickyTracking: !0,
      turboThreshold: 1e3,
      findNearestPointBy: "x",
      borderRadius: 0,
      centerInCategory: !1,
      groupPadding: 0.2,
      pointPadding: 0.1,
      minPointLength: 0,
      startFromThreshold: !0,
      threshold: null,
      borderColor: "#ffffff"
    },
    candlestick: {
      lineWidth: 1,
      allowPointSelect: !1,
      crisp: !0,
      showCheckbox: !1,
      animation: {
        duration: 1e3
      },
      events: {},
      marker: null,
      point: {
        events: {}
      },
      dataLabels: {
        animation: {},
        defer: !0,
        padding: 5,
        style: {
          fontSize: "11px",
          fontWeight: "bold",
          color: "contrast",
          textOutline: "1px contrast"
        },
        x: 0
      },
      cropThreshold: 50,
      opacity: 1,
      pointRange: null,
      softThreshold: !0,
      states: {
        normal: {
          animation: !0
        },
        hover: {
          animation: {
            duration: 50
          },
          lineWidthPlus: 1,
          marker: {},
          halo: !1,
          brightness: 0.1,
          lineWidth: 2
        },
        select: {
          animation: {
            duration: 0
          },
          color: "#cccccc",
          borderColor: "#000000"
        },
        inactive: {
          animation: {
            duration: 50
          },
          opacity: 0.2
        }
      },
      stickyTracking: !0,
      turboThreshold: 1e3,
      findNearestPointBy: "x",
      borderRadius: 0,
      centerInCategory: !1,
      groupPadding: 0.2,
      pointPadding: 0.1,
      minPointLength: 0,
      startFromThreshold: !0,
      threshold: null,
      borderColor: "#ffffff",
      line: {
        lineWidth: 2,
        allowPointSelect: !1,
        crisp: !0,
        showCheckbox: !1,
        animation: {
          duration: 1e3
        },
        events: {},
        marker: {
          enabledThreshold: 2,
          lineColor: "#ffffff",
          lineWidth: 0,
          radius: 4,
          states: {
            normal: {
              animation: !0
            },
            hover: {
              animation: {
                duration: 50
              },
              enabled: !0,
              radiusPlus: 2,
              lineWidthPlus: 1
            },
            select: {
              fillColor: "#cccccc",
              lineColor: "#000000",
              lineWidth: 2
            }
          }
        },
        point: {
          events: {}
        },
        dataLabels: {
          animation: {},
          align: "left",
          defer: !0,
          padding: 5,
          style: {
            fontSize: "11px",
            fontWeight: "bold",
            color: "contrast",
            textOutline: "1px contrast"
          },
          verticalAlign: "bottom",
          x: 0,
          y: 0
        },
        cropThreshold: 300,
        opacity: 1,
        pointRange: 0,
        softThreshold: !0,
        states: {
          normal: {
            animation: !0
          },
          hover: {
            animation: {
              duration: 50
            },
            lineWidthPlus: 1,
            marker: {},
            halo: {
              size: 10,
              opacity: 0.25
            }
          },
          select: {
            animation: {
              duration: 0
            }
          },
          inactive: {
            animation: {
              duration: 50
            },
            opacity: 0.2
          }
        },
        stickyTracking: !0,
        turboThreshold: 1e3,
        findNearestPointBy: "x"
      },
      area: {
        lineWidth: 2,
        allowPointSelect: !1,
        crisp: !0,
        showCheckbox: !1,
        animation: {
          duration: 1e3
        },
        events: {},
        marker: {
          enabledThreshold: 2,
          lineColor: "#ffffff",
          lineWidth: 0,
          radius: 4,
          states: {
            normal: {
              animation: !0
            },
            hover: {
              animation: {
                duration: 50
              },
              enabled: !0,
              radiusPlus: 2,
              lineWidthPlus: 1
            },
            select: {
              fillColor: "#cccccc",
              lineColor: "#000000",
              lineWidth: 2
            }
          }
        },
        point: {
          events: {}
        },
        dataLabels: {
          animation: {},
          align: "left",
          defer: !0,
          padding: 5,
          style: {
            fontSize: "11px",
            fontWeight: "bold",
            color: "contrast",
            textOutline: "1px contrast"
          },
          verticalAlign: "bottom",
          x: 0,
          y: 0
        },
        cropThreshold: 300,
        opacity: 1,
        pointRange: 0,
        softThreshold: !0,
        states: {
          normal: {
            animation: !0
          },
          hover: {
            animation: {
              duration: 50
            },
            lineWidthPlus: 1,
            marker: {},
            halo: {
              size: 10,
              opacity: 0.25
            }
          },
          select: {
            animation: {
              duration: 0
            }
          },
          inactive: {
            animation: {
              duration: 50
            },
            opacity: 0.2
          }
        },
        stickyTracking: !0,
        turboThreshold: 1e3,
        findNearestPointBy: "x",
        threshold: 0
      },
      spline: {
        lineWidth: 2,
        allowPointSelect: !1,
        crisp: !0,
        showCheckbox: !1,
        animation: {
          duration: 1e3
        },
        events: {},
        marker: {
          enabledThreshold: 2,
          lineColor: "#ffffff",
          lineWidth: 0,
          radius: 4,
          states: {
            normal: {
              animation: !0
            },
            hover: {
              animation: {
                duration: 50
              },
              enabled: !0,
              radiusPlus: 2,
              lineWidthPlus: 1
            },
            select: {
              fillColor: "#cccccc",
              lineColor: "#000000",
              lineWidth: 2
            }
          }
        },
        point: {
          events: {}
        },
        dataLabels: {
          animation: {},
          align: "left",
          defer: !0,
          padding: 5,
          style: {
            fontSize: "11px",
            fontWeight: "bold",
            color: "contrast",
            textOutline: "1px contrast"
          },
          verticalAlign: "bottom",
          x: 0,
          y: 0
        },
        cropThreshold: 300,
        opacity: 1,
        pointRange: 0,
        softThreshold: !0,
        states: {
          normal: {
            animation: !0
          },
          hover: {
            animation: {
              duration: 50
            },
            lineWidthPlus: 1,
            marker: {},
            halo: {
              size: 10,
              opacity: 0.25
            }
          },
          select: {
            animation: {
              duration: 0
            }
          },
          inactive: {
            animation: {
              duration: 50
            },
            opacity: 0.2
          }
        },
        stickyTracking: !0,
        turboThreshold: 1e3,
        findNearestPointBy: "x"
      },
      areaspline: {
        lineWidth: 2,
        allowPointSelect: !1,
        crisp: !0,
        showCheckbox: !1,
        animation: {
          duration: 1e3
        },
        events: {},
        marker: {
          enabledThreshold: 2,
          lineColor: "#ffffff",
          lineWidth: 0,
          radius: 4,
          states: {
            normal: {
              animation: !0
            },
            hover: {
              animation: {
                duration: 50
              },
              enabled: !0,
              radiusPlus: 2,
              lineWidthPlus: 1
            },
            select: {
              fillColor: "#cccccc",
              lineColor: "#000000",
              lineWidth: 2
            }
          }
        },
        point: {
          events: {}
        },
        dataLabels: {
          animation: {},
          align: "left",
          defer: !0,
          padding: 5,
          style: {
            fontSize: "11px",
            fontWeight: "bold",
            color: "contrast",
            textOutline: "1px contrast"
          },
          verticalAlign: "bottom",
          x: 0,
          y: 0
        },
        cropThreshold: 300,
        opacity: 1,
        pointRange: 0,
        softThreshold: !0,
        states: {
          normal: {
            animation: !0
          },
          hover: {
            animation: {
              duration: 50
            },
            lineWidthPlus: 1,
            marker: {},
            halo: {
              size: 10,
              opacity: 0.25
            }
          },
          select: {
            animation: {
              duration: 0
            }
          },
          inactive: {
            animation: {
              duration: 50
            },
            opacity: 0.2
          }
        },
        stickyTracking: !0,
        turboThreshold: 1e3,
        findNearestPointBy: "x",
        threshold: 0
      },
      column: {
        lineWidth: 2,
        allowPointSelect: !1,
        crisp: !0,
        showCheckbox: !1,
        animation: {
          duration: 1e3
        },
        events: {},
        marker: null,
        point: {
          events: {}
        },
        dataLabels: {
          animation: {},
          defer: !0,
          padding: 5,
          style: {
            fontSize: "11px",
            fontWeight: "bold",
            color: "contrast",
            textOutline: "1px contrast"
          },
          x: 0
        },
        cropThreshold: 50,
        opacity: 1,
        pointRange: null,
        softThreshold: !0,
        states: {
          normal: {
            animation: !0
          },
          hover: {
            animation: {
              duration: 50
            },
            lineWidthPlus: 1,
            marker: {},
            halo: !1,
            brightness: 0.1
          },
          select: {
            animation: {
              duration: 0
            },
            color: "#cccccc",
            borderColor: "#000000"
          },
          inactive: {
            animation: {
              duration: 50
            },
            opacity: 0.2
          }
        },
        stickyTracking: !1,
        turboThreshold: 1e3,
        findNearestPointBy: "x",
        borderRadius: 0,
        centerInCategory: !1,
        groupPadding: 0.2,
        pointPadding: 0.1,
        minPointLength: 0,
        startFromThreshold: !0,
        tooltip: {
          distance: 6
        },
        threshold: 0,
        borderColor: "#ffffff"
      },
      bar: {
        lineWidth: 2,
        allowPointSelect: !1,
        crisp: !0,
        showCheckbox: !1,
        animation: {
          duration: 1e3
        },
        events: {},
        marker: null,
        point: {
          events: {}
        },
        dataLabels: {
          animation: {},
          defer: !0,
          padding: 5,
          style: {
            fontSize: "11px",
            fontWeight: "bold",
            color: "contrast",
            textOutline: "1px contrast"
          },
          x: 0
        },
        cropThreshold: 50,
        opacity: 1,
        pointRange: null,
        softThreshold: !0,
        states: {
          normal: {
            animation: !0
          },
          hover: {
            animation: {
              duration: 50
            },
            lineWidthPlus: 1,
            marker: {},
            halo: !1,
            brightness: 0.1
          },
          select: {
            animation: {
              duration: 0
            },
            color: "#cccccc",
            borderColor: "#000000"
          },
          inactive: {
            animation: {
              duration: 50
            },
            opacity: 0.2
          }
        },
        stickyTracking: !1,
        turboThreshold: 1e3,
        findNearestPointBy: "x",
        borderRadius: 0,
        centerInCategory: !1,
        groupPadding: 0.2,
        pointPadding: 0.1,
        minPointLength: 0,
        startFromThreshold: !0,
        tooltip: {
          distance: 6
        },
        threshold: 0,
        borderColor: "#ffffff"
      },
      scatter: {
        lineWidth: 0,
        allowPointSelect: !1,
        crisp: !0,
        showCheckbox: !1,
        animation: {
          duration: 1e3
        },
        events: {},
        marker: {
          enabledThreshold: 2,
          lineColor: "#ffffff",
          lineWidth: 0,
          radius: 4,
          states: {
            normal: {
              animation: !0
            },
            hover: {
              animation: {
                duration: 50
              },
              enabled: !0,
              radiusPlus: 2,
              lineWidthPlus: 1
            },
            select: {
              fillColor: "#cccccc",
              lineColor: "#000000",
              lineWidth: 2
            }
          },
          enabled: !0
        },
        point: {
          events: {}
        },
        dataLabels: {
          animation: {},
          align: "left",
          defer: !0,
          padding: 5,
          style: {
            fontSize: "11px",
            fontWeight: "bold",
            color: "contrast",
            textOutline: "1px contrast"
          },
          verticalAlign: "bottom",
          x: 0,
          y: 0
        },
        cropThreshold: 300,
        opacity: 1,
        pointRange: 0,
        softThreshold: !0,
        states: {
          normal: {
            animation: !0
          },
          hover: {
            animation: {
              duration: 50
            },
            lineWidthPlus: 1,
            marker: {},
            halo: {
              size: 10,
              opacity: 0.25
            }
          },
          select: {
            animation: {
              duration: 0
            }
          },
          inactive: {
            animation: {
              duration: 50
            },
            opacity: 0.2
          }
        },
        stickyTracking: !0,
        turboThreshold: 1e3,
        findNearestPointBy: "xy",
        jitter: {
          x: 0,
          y: 0
        },
        tooltip: {
          headerFormat: '<span style="color:{point.color}">●</span> <span style="font-size: 10px"> {series.name}</span><br/>',
          pointFormat: "x: <b>{point.x}</b><br/>y: <b>{point.y}</b><br/>"
        }
      },
      pie: {
        allowPointSelect: !1,
        crisp: !0,
        showCheckbox: !1,
        animation: {
          duration: 1e3
        },
        events: {},
        marker: null,
        point: {
          events: {}
        },
        dataLabels: {
          animation: {},
          align: "left",
          defer: !0,
          padding: 5,
          style: {
            fontSize: "11px",
            fontWeight: "bold",
            color: "contrast",
            textOutline: "1px contrast"
          },
          verticalAlign: "bottom",
          x: 0,
          y: 0,
          allowOverlap: !0,
          connectorPadding: 5,
          connectorShape: "fixedOffset",
          crookDistance: "70%",
          distance: 30,
          enabled: !0,
          softConnector: !0
        },
        cropThreshold: 300,
        opacity: 1,
        pointRange: 0,
        softThreshold: !0,
        states: {
          normal: {
            animation: !0
          },
          hover: {
            animation: {
              duration: 50
            },
            lineWidthPlus: 1,
            marker: {},
            halo: {
              size: 10,
              opacity: 0.25
            },
            brightness: 0.1
          },
          select: {
            animation: {
              duration: 0
            }
          },
          inactive: {
            animation: {
              duration: 50
            },
            opacity: 0.2
          }
        },
        stickyTracking: !1,
        turboThreshold: 1e3,
        findNearestPointBy: "x",
        center: [null, null],
        clip: !1,
        colorByPoint: !0,
        ignoreHiddenPoint: !0,
        inactiveOtherPoints: !0,
        legendType: "point",
        size: null,
        showInLegend: !1,
        slicedOffset: 10,
        tooltip: {
          followPointer: !0
        },
        borderColor: "#ffffff",
        borderWidth: 1
      },
      ohlc: {
        lineWidth: 1,
        allowPointSelect: !1,
        crisp: !0,
        showCheckbox: !1,
        animation: {
          duration: 1e3
        },
        events: {},
        marker: null,
        point: {
          events: {}
        },
        dataLabels: {
          animation: {},
          defer: !0,
          padding: 5,
          style: {
            fontSize: "11px",
            fontWeight: "bold",
            color: "contrast",
            textOutline: "1px contrast"
          },
          x: 0
        },
        cropThreshold: 50,
        opacity: 1,
        pointRange: null,
        softThreshold: !0,
        states: {
          normal: {
            animation: !0
          },
          hover: {
            animation: {
              duration: 50
            },
            lineWidthPlus: 1,
            marker: {},
            halo: !1,
            brightness: 0.1,
            lineWidth: 3
          },
          select: {
            animation: {
              duration: 0
            },
            color: "#cccccc",
            borderColor: "#000000"
          },
          inactive: {
            animation: {
              duration: 50
            },
            opacity: 0.2
          }
        },
        stickyTracking: !0,
        turboThreshold: 1e3,
        findNearestPointBy: "x",
        borderRadius: 0,
        centerInCategory: !1,
        groupPadding: 0.2,
        pointPadding: 0.1,
        minPointLength: 0,
        startFromThreshold: !0,
        tooltip: {
          distance: 6,
          pointFormat: '<span style="color:{point.color}">●</span> <b> {series.name}</b><br/>Open: {point.open}<br/>High: {point.high}<br/>Low: {point.low}<br/>Close: {point.close}<br/>'
        },
        threshold: null,
        borderColor: "#ffffff"
      },
      lineColor: "#000000",
      upColor: "#ffffff"
    },
    flags: {
      lineWidth: 1,
      allowPointSelect: !1,
      crisp: !0,
      showCheckbox: !1,
      animation: {
        duration: 1e3
      },
      events: {},
      marker: null,
      point: {
        events: {}
      },
      dataLabels: {
        animation: {},
        defer: !0,
        padding: 5,
        style: {
          fontSize: "11px",
          fontWeight: "bold",
          color: "contrast",
          textOutline: "1px contrast"
        },
        x: 0
      },
      cropThreshold: 50,
      opacity: 1,
      pointRange: 0,
      softThreshold: !0,
      states: {
        normal: {
          animation: !0
        },
        hover: {
          animation: {
            duration: 50
          },
          lineWidthPlus: 1,
          marker: {},
          halo: !1,
          brightness: 0.1,
          lineColor: "#000000",
          fillColor: "#ccd6eb"
        },
        select: {
          animation: {
            duration: 0
          },
          color: "#cccccc",
          borderColor: "#000000"
        },
        inactive: {
          animation: {
            duration: 50
          },
          opacity: 0.2
        }
      },
      stickyTracking: !1,
      turboThreshold: 1e3,
      findNearestPointBy: "x",
      borderRadius: 0,
      centerInCategory: !1,
      groupPadding: 0.2,
      pointPadding: 0.1,
      minPointLength: 0,
      startFromThreshold: !0,
      threshold: null,
      borderColor: "#ffffff",
      allowOverlapX: !1,
      shape: "flag",
      stackDistance: 12,
      textAlign: "left",
      y: -30,
      fillColor: "#ffffff",
      style: {
        fontSize: "11px",
        fontWeight: "bold"
      }
    },
    arearange: {
      lineWidth: 1,
      allowPointSelect: !1,
      crisp: !0,
      showCheckbox: !1,
      animation: {
        duration: 1e3
      },
      events: {},
      marker: {
        enabledThreshold: 2,
        lineColor: "#ffffff",
        lineWidth: 0,
        radius: 4,
        states: {
          normal: {
            animation: !0
          },
          hover: {
            animation: {
              duration: 50
            },
            enabled: !0,
            radiusPlus: 2,
            lineWidthPlus: 1
          },
          select: {
            fillColor: "#cccccc",
            lineColor: "#000000",
            lineWidth: 2
          }
        }
      },
      point: {
        events: {}
      },
      dataLabels: {
        animation: {},
        defer: !0,
        padding: 5,
        style: {
          fontSize: "11px",
          fontWeight: "bold",
          color: "contrast",
          textOutline: "1px contrast"
        },
        x: 0,
        y: 0,
        xLow: 0,
        xHigh: 0,
        yLow: 0,
        yHigh: 0
      },
      cropThreshold: 300,
      opacity: 1,
      pointRange: 0,
      softThreshold: !0,
      states: {
        normal: {
          animation: !0
        },
        hover: {
          animation: {
            duration: 50
          },
          lineWidthPlus: 1,
          marker: {},
          halo: {
            size: 10,
            opacity: 0.25
          }
        },
        select: {
          animation: {
            duration: 0
          }
        },
        inactive: {
          animation: {
            duration: 50
          },
          opacity: 0.2
        }
      },
      stickyTracking: !0,
      turboThreshold: 1e3,
      findNearestPointBy: "x",
      threshold: null,
      trackByArea: !0
    },
    areasplinerange: {
      lineWidth: 1,
      allowPointSelect: !1,
      crisp: !0,
      showCheckbox: !1,
      animation: {
        duration: 1e3
      },
      events: {},
      marker: {
        enabledThreshold: 2,
        lineColor: "#ffffff",
        lineWidth: 0,
        radius: 4,
        states: {
          normal: {
            animation: !0
          },
          hover: {
            animation: {
              duration: 50
            },
            enabled: !0,
            radiusPlus: 2,
            lineWidthPlus: 1
          },
          select: {
            fillColor: "#cccccc",
            lineColor: "#000000",
            lineWidth: 2
          }
        }
      },
      point: {
        events: {}
      },
      dataLabels: {
        animation: {},
        defer: !0,
        padding: 5,
        style: {
          fontSize: "11px",
          fontWeight: "bold",
          color: "contrast",
          textOutline: "1px contrast"
        },
        x: 0,
        y: 0,
        xLow: 0,
        xHigh: 0,
        yLow: 0,
        yHigh: 0
      },
      cropThreshold: 300,
      opacity: 1,
      pointRange: 0,
      softThreshold: !0,
      states: {
        normal: {
          animation: !0
        },
        hover: {
          animation: {
            duration: 50
          },
          lineWidthPlus: 1,
          marker: {},
          halo: {
            size: 10,
            opacity: 0.25
          }
        },
        select: {
          animation: {
            duration: 0
          }
        },
        inactive: {
          animation: {
            duration: 50
          },
          opacity: 0.2
        }
      },
      stickyTracking: !0,
      turboThreshold: 1e3,
      findNearestPointBy: "x",
      threshold: null,
      trackByArea: !0
    },
    boxplot: {
      lineWidth: 1,
      allowPointSelect: !1,
      crisp: !0,
      showCheckbox: !1,
      animation: {
        duration: 1e3
      },
      events: {},
      marker: null,
      point: {
        events: {}
      },
      dataLabels: {
        animation: {},
        defer: !0,
        padding: 5,
        style: {
          fontSize: "11px",
          fontWeight: "bold",
          color: "contrast",
          textOutline: "1px contrast"
        },
        x: 0
      },
      cropThreshold: 50,
      opacity: 1,
      pointRange: null,
      softThreshold: !0,
      states: {
        normal: {
          animation: !0
        },
        hover: {
          animation: {
            duration: 50
          },
          lineWidthPlus: 1,
          marker: {},
          halo: !1,
          brightness: 0.1
        },
        select: {
          animation: {
            duration: 0
          },
          color: "#cccccc",
          borderColor: "#000000"
        },
        inactive: {
          animation: {
            duration: 50
          },
          opacity: 0.2
        }
      },
      stickyTracking: !1,
      turboThreshold: 1e3,
      findNearestPointBy: "x",
      borderRadius: 0,
      centerInCategory: !1,
      groupPadding: 0.2,
      pointPadding: 0.1,
      minPointLength: 0,
      startFromThreshold: !0,
      threshold: null,
      borderColor: "#ffffff",
      whiskerLength: "50%",
      fillColor: "#ffffff",
      medianWidth: 2,
      whiskerWidth: 2
    },
    bubble: {
      lineWidth: 0,
      allowPointSelect: !1,
      crisp: !0,
      showCheckbox: !1,
      animation: {
        duration: 1e3
      },
      events: {},
      marker: {
        enabledThreshold: 2,
        lineColor: null,
        lineWidth: 1,
        radius: null,
        states: {
          normal: {
            animation: !0
          },
          hover: {
            animation: {
              duration: 50
            },
            enabled: !0,
            radiusPlus: 0,
            lineWidthPlus: 1
          },
          select: {
            fillColor: "#cccccc",
            lineColor: "#000000",
            lineWidth: 2
          }
        },
        enabled: !0,
        fillOpacity: 0.5,
        symbol: "circle"
      },
      point: {
        events: {}
      },
      dataLabels: {
        animation: {},
        align: "left",
        defer: !0,
        padding: 5,
        style: {
          fontSize: "11px",
          fontWeight: "bold",
          color: "contrast",
          textOutline: "1px contrast"
        },
        verticalAlign: "middle",
        x: 0,
        y: 0,
        inside: !0
      },
      cropThreshold: 300,
      opacity: 1,
      pointRange: 0,
      softThreshold: !1,
      states: {
        normal: {
          animation: !0
        },
        hover: {
          animation: {
            duration: 50
          },
          lineWidthPlus: 1,
          marker: {},
          halo: {
            size: 5,
            opacity: 0.25
          }
        },
        select: {
          animation: {
            duration: 0
          }
        },
        inactive: {
          animation: {
            duration: 50
          },
          opacity: 0.2
        }
      },
      stickyTracking: !0,
      turboThreshold: 0,
      findNearestPointBy: "xy",
      jitter: {
        x: 0,
        y: 0
      },
      animationLimit: 250,
      minSize: 8,
      maxSize: "20%",
      zThreshold: 0,
      zoneAxis: "z"
    },
    columnrange: {
      lineWidth: 1,
      allowPointSelect: !1,
      crisp: !0,
      showCheckbox: !1,
      animation: {
        duration: 1e3
      },
      events: {},
      marker: null,
      point: {
        events: {}
      },
      dataLabels: {
        animation: {},
        defer: !0,
        padding: 5,
        style: {
          fontSize: "11px",
          fontWeight: "bold",
          color: "contrast",
          textOutline: "1px contrast"
        },
        x: 0,
        y: 0,
        xLow: 0,
        xHigh: 0,
        yLow: 0,
        yHigh: 0
      },
      cropThreshold: 300,
      opacity: 1,
      pointRange: null,
      softThreshold: !0,
      states: {
        normal: {
          animation: !0
        },
        hover: {
          animation: {
            duration: 50
          },
          lineWidthPlus: 1,
          marker: {},
          halo: !1,
          brightness: 0.1
        },
        select: {
          animation: {
            duration: 0
          },
          color: "#cccccc",
          borderColor: "#000000"
        },
        inactive: {
          animation: {
            duration: 50
          },
          opacity: 0.2
        }
      },
      stickyTracking: !0,
      turboThreshold: 1e3,
      findNearestPointBy: "x",
      borderRadius: 0,
      centerInCategory: !1,
      groupPadding: 0.2,
      pointPadding: 0.1,
      minPointLength: 0,
      startFromThreshold: !0,
      threshold: null,
      borderColor: "#ffffff",
      trackByArea: !0
    },
    columnpyramid: {
      lineWidth: 2,
      allowPointSelect: !1,
      crisp: !0,
      showCheckbox: !1,
      animation: {
        duration: 1e3
      },
      events: {},
      marker: null,
      point: {
        events: {}
      },
      dataLabels: {
        animation: {},
        defer: !0,
        padding: 5,
        style: {
          fontSize: "11px",
          fontWeight: "bold",
          color: "contrast",
          textOutline: "1px contrast"
        },
        x: 0
      },
      cropThreshold: 50,
      opacity: 1,
      pointRange: null,
      softThreshold: !0,
      states: {
        normal: {
          animation: !0
        },
        hover: {
          animation: {
            duration: 50
          },
          lineWidthPlus: 1,
          marker: {},
          halo: !1,
          brightness: 0.1
        },
        select: {
          animation: {
            duration: 0
          },
          color: "#cccccc",
          borderColor: "#000000"
        },
        inactive: {
          animation: {
            duration: 50
          },
          opacity: 0.2
        }
      },
      stickyTracking: !1,
      turboThreshold: 1e3,
      findNearestPointBy: "x",
      borderRadius: 0,
      centerInCategory: !1,
      groupPadding: 0.2,
      pointPadding: 0.1,
      minPointLength: 0,
      startFromThreshold: !0,
      threshold: 0,
      borderColor: "#ffffff"
    },
    errorbar: {
      lineWidth: 1,
      allowPointSelect: !1,
      crisp: !0,
      showCheckbox: !1,
      animation: {
        duration: 1e3
      },
      events: {},
      marker: null,
      point: {
        events: {}
      },
      dataLabels: {
        animation: {},
        defer: !0,
        padding: 5,
        style: {
          fontSize: "11px",
          fontWeight: "bold",
          color: "contrast",
          textOutline: "1px contrast"
        },
        x: 0
      },
      cropThreshold: 50,
      opacity: 1,
      pointRange: null,
      softThreshold: !0,
      states: {
        normal: {
          animation: !0
        },
        hover: {
          animation: {
            duration: 50
          },
          lineWidthPlus: 1,
          marker: {},
          halo: !1,
          brightness: 0.1
        },
        select: {
          animation: {
            duration: 0
          },
          color: "#cccccc",
          borderColor: "#000000"
        },
        inactive: {
          animation: {
            duration: 50
          },
          opacity: 0.2
        }
      },
      stickyTracking: !1,
      turboThreshold: 1e3,
      findNearestPointBy: "x",
      borderRadius: 0,
      centerInCategory: !1,
      groupPadding: 0.2,
      pointPadding: 0.1,
      minPointLength: 0,
      startFromThreshold: !0,
      threshold: null,
      borderColor: "#ffffff",
      whiskerLength: "50%",
      fillColor: "#ffffff",
      medianWidth: 2,
      whiskerWidth: null,
      color: "#000000",
      grouping: !1,
      linkedTo: ":previous"
    },
    gauge: {
      lineWidth: 2,
      allowPointSelect: !1,
      crisp: !0,
      showCheckbox: !1,
      animation: {
        duration: 1e3
      },
      events: {},
      marker: {
        enabledThreshold: 2,
        lineColor: "#ffffff",
        lineWidth: 0,
        radius: 4,
        states: {
          normal: {
            animation: !0
          },
          hover: {
            animation: {
              duration: 50
            },
            enabled: !0,
            radiusPlus: 2,
            lineWidthPlus: 1
          },
          select: {
            fillColor: "#cccccc",
            lineColor: "#000000",
            lineWidth: 2
          }
        }
      },
      point: {
        events: {}
      },
      dataLabels: {
        animation: {},
        align: "left",
        defer: !1,
        padding: 5,
        style: {
          fontSize: "11px",
          fontWeight: "bold",
          color: "contrast",
          textOutline: "1px contrast"
        },
        verticalAlign: "top",
        x: 0,
        y: 15,
        borderColor: "#cccccc",
        borderRadius: 3,
        borderWidth: 1,
        crop: !1,
        enabled: !0,
        zIndex: 2
      },
      cropThreshold: 300,
      opacity: 1,
      pointRange: 0,
      softThreshold: !0,
      states: {
        normal: {
          animation: !0
        },
        hover: {
          animation: {
            duration: 50
          },
          lineWidthPlus: 1,
          marker: {},
          halo: {
            size: 10,
            opacity: 0.25
          }
        },
        select: {
          animation: {
            duration: 0
          }
        },
        inactive: {
          animation: {
            duration: 50
          },
          opacity: 0.2
        }
      },
      stickyTracking: !0,
      turboThreshold: 1e3,
      findNearestPointBy: "x",
      dial: {},
      pivot: {},
      showInLegend: !1
    },
    packedbubble: {
      lineWidth: 0,
      allowPointSelect: !1,
      crisp: !1,
      showCheckbox: !1,
      animation: {
        duration: 1e3
      },
      events: {},
      marker: {
        enabledThreshold: 2,
        lineColor: null,
        lineWidth: 1,
        radius: null,
        states: {
          normal: {
            animation: !0
          },
          hover: {
            animation: {
              duration: 50
            },
            enabled: !0,
            radiusPlus: 0,
            lineWidthPlus: 1
          },
          select: {
            fillColor: "#cccccc",
            lineColor: "#000000",
            lineWidth: 2
          }
        },
        enabled: !0,
        fillOpacity: 0.5,
        symbol: "circle"
      },
      point: {
        events: {}
      },
      dataLabels: {
        animation: {},
        align: "left",
        defer: !0,
        padding: 0,
        style: {
          fontSize: "11px",
          fontWeight: "bold",
          color: "contrast",
          textOutline: "1px contrast",
          transition: "opacity 2000ms"
        },
        verticalAlign: "middle",
        x: 0,
        y: 0,
        inside: !0,
        parentNodeTextPath: {
          enabled: !0
        }
      },
      cropThreshold: 300,
      opacity: 1,
      pointRange: 0,
      softThreshold: !1,
      states: {
        normal: {
          animation: !0
        },
        hover: {
          animation: {
            duration: 50
          },
          lineWidthPlus: 1,
          marker: {},
          halo: {
            size: 5,
            opacity: 0.25
          }
        },
        select: {
          animation: {
            duration: 0
          }
        },
        inactive: {
          animation: {
            duration: 50
          },
          opacity: 0.2
        }
      },
      stickyTracking: !0,
      turboThreshold: 0,
      findNearestPointBy: "xy",
      jitter: {
        x: 0,
        y: 0
      },
      animationLimit: 250,
      minSize: "10%",
      maxSize: "50%",
      zThreshold: 0,
      zoneAxis: "y",
      sizeBy: "area",
      draggable: !0,
      useSimulation: !0,
      parentNode: {
        allowPointSelect: !1
      },
      layoutAlgorithm: {
        initialPositions: "circle",
        initialPositionRadius: 20,
        bubblePadding: 5,
        parentNodeLimit: !1,
        seriesInteraction: !0,
        dragBetweenSeries: !1,
        parentNodeOptions: {
          maxIterations: 400,
          gravitationalConstant: 0.03,
          maxSpeed: 50,
          initialPositionRadius: 100,
          seriesInteraction: !0,
          marker: {
            fillColor: null,
            fillOpacity: 1,
            lineWidth: 1,
            lineColor: null,
            symbol: "circle"
          }
        },
        enableSimulation: !0,
        type: "packedbubble",
        integration: "packedbubble",
        maxIterations: 1e3,
        splitSeries: !1,
        maxSpeed: 5,
        gravitationalConstant: 0.01,
        friction: -0.981
      }
    },
    polygon: {
      lineWidth: 0,
      allowPointSelect: !1,
      crisp: !0,
      showCheckbox: !1,
      animation: {
        duration: 1e3
      },
      events: {},
      marker: {
        enabledThreshold: 2,
        lineColor: "#ffffff",
        lineWidth: 0,
        radius: 4,
        states: {
          normal: {
            animation: !0
          },
          hover: {
            animation: {
              duration: 50
            },
            enabled: !1,
            radiusPlus: 2,
            lineWidthPlus: 1
          },
          select: {
            fillColor: "#cccccc",
            lineColor: "#000000",
            lineWidth: 2
          }
        },
        enabled: !1
      },
      point: {
        events: {}
      },
      dataLabels: {
        animation: {},
        align: "left",
        defer: !0,
        padding: 5,
        style: {
          fontSize: "11px",
          fontWeight: "bold",
          color: "contrast",
          textOutline: "1px contrast"
        },
        verticalAlign: "bottom",
        x: 0,
        y: 0
      },
      cropThreshold: 300,
      opacity: 1,
      pointRange: 0,
      softThreshold: !0,
      states: {
        normal: {
          animation: !0
        },
        hover: {
          animation: {
            duration: 50
          },
          lineWidthPlus: 1,
          marker: {},
          halo: {
            size: 10,
            opacity: 0.25
          }
        },
        select: {
          animation: {
            duration: 0
          }
        },
        inactive: {
          animation: {
            duration: 50
          },
          opacity: 0.2
        }
      },
      stickyTracking: !1,
      turboThreshold: 1e3,
      findNearestPointBy: "xy",
      jitter: {
        x: 0,
        y: 0
      },
      trackByArea: !0
    },
    waterfall: {
      lineWidth: 1,
      allowPointSelect: !1,
      crisp: !0,
      showCheckbox: !1,
      animation: {
        duration: 1e3
      },
      events: {},
      marker: null,
      point: {
        events: {}
      },
      dataLabels: {
        animation: {},
        defer: !0,
        padding: 5,
        style: {
          fontSize: "11px",
          fontWeight: "bold",
          color: "contrast",
          textOutline: "1px contrast"
        },
        x: 0,
        inside: !0
      },
      cropThreshold: 50,
      opacity: 1,
      pointRange: null,
      softThreshold: !0,
      states: {
        normal: {
          animation: !0
        },
        hover: {
          animation: {
            duration: 50
          },
          lineWidthPlus: 0,
          marker: {},
          halo: !1,
          brightness: 0.1
        },
        select: {
          animation: {
            duration: 0
          },
          color: "#cccccc",
          borderColor: "#000000"
        },
        inactive: {
          animation: {
            duration: 50
          },
          opacity: 0.2
        }
      },
      stickyTracking: !1,
      turboThreshold: 1e3,
      findNearestPointBy: "x",
      borderRadius: 0,
      centerInCategory: !1,
      groupPadding: 0.2,
      pointPadding: 0.1,
      minPointLength: 0,
      startFromThreshold: !0,
      threshold: 0,
      borderColor: "#2e393d",
      lineColor: "#2e393d",
      dashStyle: "Dot"
    }
  },
  legend: {
    enabled: !0,
    useHTML: !0,
    align: "left",
    layout: "horizontal",
    borderColor: "#999999",
    borderRadius: 0,
    itemStyle: {
      color: "#2e393d",
      cursor: "pointer",
      fontSize: "12px",
      fontWeight: "normal",
      textOverflow: "ellipsis"
    },
    itemHoverStyle: {
      color: "#000000",
      fill: "#000000"
    },
    itemHiddenStyle: {
      color: "#cccccc"
    },
    shadow: !1,
    itemCheckboxStyle: {
      position: "absolute",
      width: "14px",
      height: "14px"
    },
    squareSymbol: !0,
    symbolPadding: 8,
    verticalAlign: "bottom",
    x: 0,
    y: 0,
    title: {
      style: {
        fontWeight: "bold"
      }
    },
    bubbleLegend: {
      borderWidth: 2,
      connectorDistance: 60,
      connectorWidth: 1,
      enabled: !1,
      labels: {
        allowOverlap: !1,
        format: "",
        align: "right",
        style: {
          fontSize: "10px",
          color: "#000000"
        },
        x: 0,
        y: 0
      },
      maxSize: 60,
      minSize: 10,
      legendIndex: 0,
      ranges: {},
      sizeBy: "area",
      sizeByAbsoluteValue: !1,
      zIndex: 1,
      zThreshold: 0
    },
    itemWidth: 220
  },
  /*   loading: {
    labelStyle: {
      fontWeight: 'bold',
      position: 'relative',
      top: '45%',
    },
    style: {
      position: 'absolute',
      backgroundColor: '#ffffff',
      opacity: 0.5,
      textAlign: 'left',
    },
  }, */
  tooltip: {
    enabled: !1
    /*   animation: true,
    borderRadius: 3,
    dateTimeLabelFormats: {
      millisecond: '%A, %b %e, %H:%M:%S.%L',
      second: '%A, %b %e, %H:%M:%S',
      minute: '%A, %b %e, %H:%M',
      hour: '%A, %b %e, %H:%M',
      day: '%A, %b %e, %Y',
      week: 'Week from %A, %b %e, %Y',
      month: '%B %Y',
      year: '%Y',
    },
    footerFormat: '',
    headerShape: 'callout',
    hideDelay: 500,
    padding: 8,
    shape: 'callout',
    shared: true,
    snap: 10,
    headerFormat: '<span style="font-size: 10px">{point.key}</span><br/>',
    pointFormat:
      '<span style="color:{point.color}">●</span> {series.name}: <b>{point.y}</b><br/>',
    backgroundColor: 'white',
    borderWidth: 0,
    shadow: false,
    stickOnContact: false,
    style: {
      color: '#2e393d',
      cursor: 'default',
      fontSize: '12px',
      whiteSpace: 'nowrap',
    },
    useHTML: true,
    userOptions: {
      shared: true,
      backgroundColor: 'white',
      borderWidth: 0,
      shadow: false,
      useHTML: true,
      enabled: false,
    }, */
  },
  credits: {
    enabled: !1
  },
  /*  scrollbar: {
    height: 14,
    barBorderRadius: 0,
    buttonBorderRadius: 0,
    margin: 10,
    minWidth: 6,
    step: 0.2,
    zIndex: 3,
    barBackgroundColor: '#cccccc',
    barBorderWidth: 1,
    barBorderColor: '#cccccc',
    buttonArrowColor: '#2e393d',
    buttonBackgroundColor: '#e6e6e6',
    buttonBorderColor: '#cccccc',
    buttonBorderWidth: 1,
    rifleColor: '#2e393d',
    trackBackgroundColor: '#f2f2f2',
    trackBorderColor: '#f2f2f2',
    trackBorderWidth: 1,
  }, */
  /*   navigator: {
    enabled: false,
    height: 40,
    margin: 25,
    maskInside: true,
    handles: {
      width: 7,
      height: 15,
      symbols: ['navigator-handle', 'navigator-handle'],
      enabled: true,
      lineWidth: 1,
      backgroundColor: '#f2f2f2',
      borderColor: '#999999',
    },
    maskFill: 'rgba(102,133,194,0.3)',
    outlineColor: '#cccccc',
    outlineWidth: 1,
    series: {
      type: 'areaspline',
      fillOpacity: 0.05,
      lineWidth: 1,
      compare: null,
      dataGrouping: {
        approximation: 'average',
        enabled: true,
        groupPixelWidth: 2,
        firstAnchor: 'firstPoint',
        anchor: 'middle',
        lastAnchor: 'lastPoint',
        units: [
          ['millisecond', [1, 2, 5, 10, 20, 25, 50, 100, 200, 500]],
          ['second', [1, 2, 5, 10, 15, 30]],
          ['minute', [1, 2, 5, 10, 15, 30]],
          ['hour', [1, 2, 3, 4, 6, 8, 12]],
          ['day', [1, 2, 3, 4]],
          ['week', [1, 2, 3]],
          ['month', [1, 3, 6]],
          ['year', null],
        ],
      },
      dataLabels: {
        enabled: false,
        zIndex: 2,
      },
      id: 'highcharts-navigator-series',
      className: 'highcharts-navigator-series',
      lineColor: null,
      marker: {
        enabled: false,
      },
      threshold: null,
    },
    xAxis: {
      overscroll: 0,
      className: 'highcharts-navigator-xaxis',
      tickLength: 0,
      lineWidth: 0,
      gridLineColor: '#e6e6e6',
      gridLineWidth: 1,
      tickPixelInterval: 200,
      labels: {
        align: 'left',
        style: {
          color: '#999999',
        },
        x: 3,
        y: -4,
      },
      crosshair: false,
    },
    yAxis: {
      className: 'highcharts-navigator-yaxis',
      gridLineWidth: 0,
      startOnTick: false,
      endOnTick: false,
      minPadding: 0.1,
      maxPadding: 0.1,
      labels: {
        enabled: false,
      },
      crosshair: false,
      title: {
        text: null,
      },
      tickLength: 0,
      tickWidth: 0,
    },
  }, */
  rangeSelector: {
    allButtonsEnabled: !1
  },
  exporting: {
    enabled: !1
  },
  /*  navigation: {
    buttonOptions: {
      symbolSize: 14,
      symbolX: 12.5,
      symbolY: 10.5,
      align: 'right',
      buttonSpacing: 3,
      height: 22,
      verticalAlign: 'top',
      width: 24,
      symbolFill: '#666666',
      symbolStroke: '#666666',
      symbolStrokeWidth: 3,
      theme: {
        padding: 5,
      },
    },
    menuStyle: {
      border: '1px solid #999999',
      background: '#ffffff',
      padding: '5px 0',
    },
    menuItemStyle: {
      padding: '0.5em 1em',
      color: '#2e393d',
      background: 'none',
      fontSize: '11px',
      transition: 'background 250ms, color 250ms',
    },
    menuItemHoverStyle: {
      background: '#335cad',
      color: '#ffffff',
    },
  }, */
  xAxis: [
    {
      categories: [
        "89",
        "90",
        "91",
        "92",
        "93",
        "94",
        "95",
        "96",
        "97",
        "98",
        "99",
        "00",
        "01",
        "02",
        "03",
        "04",
        "05",
        "06",
        "07",
        "08",
        "09",
        "10",
        "11",
        "12",
        "13",
        "14",
        "15",
        "16",
        "17",
        "18",
        "19",
        "20",
        "21",
        "22E",
        "23E",
        "24E",
        "25E"
      ],
      index: 0,
      isX: !0
    }
  ],
  yAxis: [
    {
      title: {
        text: ""
      },
      index: 0
    },
    {
      title: {
        text: ""
      },
      labels: {
        format: null
      },
      opposite: !0,
      index: 1
    },
    {
      title: {
        text: ""
      }
    },
    {
      title: {
        text: ""
      }
    },
    {
      title: {
        text: ""
      }
    },
    {
      title: {
        text: ""
      }
    }
  ],
  series: [
    {
      type: "column",
      dataLabels: {
        enabled: !1,
        rotation: -90,
        verticalAlign: "top",
        color: "#FFFFFF",
        format: "{point.y:.1f}",
        y: 30,
        style: {
          fontSize: "13px",
          fontFamily: "Verdana, sans-serif",
          fontWeight: "normal",
          textShadow: "0px 0px"
        }
      }
    },
    {
      type: "spline"
    },
    {
      type: "scatter",
      marker: {
        radius: 8,
        symbol: "diamond"
      }
    },
    {
      type: "errorbar",
      showInLegend: !0,
      pointWidth: 100,
      lineWidth: 4
    },
    {
      type: "boxplot",
      whiskerLength: 0,
      medianWidth: 4,
      lineWidth: 1
    }
  ],
  startOnTick: !0,
  endOnTick: !0,
  maxPadding: 0.01,
  minPadding: 0.01,
  pane: [null]
}, Kfe = {
  accessibility: {
    enabled: !0,
    keyboardNavigation: {
      enabled: !0,
      focusBorder: {
        enabled: !0,
        hideBrowserFocusOutline: !0,
        style: {
          lineWidth: 2,
          color: Ai,
          borderRadius: 2
        },
        margin: 2
      },
      order: ["series", "legend"],
      seriesNavigation: {
        mode: "normal",
        skipNullPoints: !0
      }
    }
  },
  legend: {
    enabled: !0,
    align: "left",
    layout: "horizontal"
  },
  lang: {
    noData: "No data to display"
  }
}, Xfe = {
  key: 0,
  class: "d-croci-company-detail-chart"
}, Zfe = { class: "d-croci-company-detail-chart__container" }, Jfe = /* @__PURE__ */ Be({
  __name: "CrociCompanyDetailChart",
  props: {
    model: {
      type: Object,
      required: !0
    }
  },
  emits: ["showZoom"],
  setup(e, { emit: t }) {
    const n = e, { t: i } = Je(), { pageName: o } = Qe(), a = t, r = () => {
      a("showZoom", n.model);
    }, s = Te(() => ({
      contentUrl: "",
      title: i("crociCompanyDetailPage.zoomChart"),
      text: i("crociCompanyDetailPage.zoomChart"),
      isLocked: !1,
      target: "",
      isExternal: !1,
      linkType: yt.Javascript,
      tealiumTrackingModel: {
        eventSource: o,
        eventComponentName: "CrociCompanyDetailChart",
        eventTitle: "chart-zoom"
      }
    })), l = Te(() => ({
      ...n.model?.chartData,
      ...Kfe,
      chart: {
        spacing: [8, 8, 88, 0],
        aria: {
          label: n.model.title,
          role: "img"
        }
      }
    }));
    return (d, y) => e.model ? (E(), X("div", Xfe, [
      oe("div", Zfe, [
        ue(Ot, {
          "base-heading-type": _(ze).H3,
          class: "d-croci-company-detail-chart__headline"
        }, {
          default: Se(() => [
            Ve(Ie(e.model.title), 1)
          ]),
          _: 1
        }, 8, ["base-heading-type"]),
        ue(eh, {
          ref: "chart",
          options: l.value,
          type: _(Ra).Chart,
          height: _(Vo).Small,
          class: "d-croci-company-detail-chart__chart"
        }, null, 8, ["options", "type", "height"]),
        ue(Nt, {
          type: _(Ke).RoundedNonFilled,
          size: _(et).Small,
          icon: _(H).Expand,
          "link-model": s.value,
          class: "d-croci-company-detail-chart__button",
          onClick: r,
          onKeydown: Ze(It(r, ["prevent"]), ["enter"])
        }, null, 8, ["type", "size", "icon", "link-model", "onKeydown"])
      ])
    ])) : te("", !0);
  }
});
const Qfe = /* @__PURE__ */ Fe(Jfe, [["__scopeId", "data-v-7cc510f4"]]), eme = { class: "d-croci-modal-dialog__content" }, tme = {
  key: 1,
  class: "d-croci-modal-dialog__intro-text"
}, nme = /* @__PURE__ */ Be({
  __name: "CrociCompanyDetailChartZoom",
  props: {
    model: {
      type: Object,
      required: !0
    },
    showModal: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["update:showModal"],
  setup(e, { emit: t }) {
    const n = e, i = t, o = Te({
      get: () => n.showModal,
      set: (s) => {
        i("update:showModal", s);
      }
    }), a = Te(() => ({
      ...n.model.chartData,
      chart: {
        aria: {
          label: n.model.title,
          role: "img"
        },
        spacing: [8, 8, 88, 0]
      },
      accessibility: {
        enabled: !0,
        description: "This chart displays the CROCI over time.",
        series: {
          descriptionFormatter: function(s) {
            return s.name + ", with " + s.points.length + " data points.";
          }
        },
        keyboardNavigation: {
          enabled: !0,
          focusBorder: {
            enabled: !0,
            hideBrowserFocusOutline: !0,
            style: {
              lineWidth: 2,
              color: Ai,
              borderRadius: 2
            },
            margin: 2
          },
          order: ["series", "legend"],
          seriesNavigation: {
            mode: "normal",
            skipNullPoints: !0
          }
        }
      },
      legend: {
        enabled: !0,
        align: "left",
        layout: "horizontal"
      },
      tooltip: {
        positioner: function(s, l, d) {
          const y = this.chart, u = d.plotX - s / 2 + 64, m = d.plotY - l - 16;
          return { x: Math.max(
            0,
            Math.min(u, y.chartWidth + 40 - s)
          ), y: m };
        },
        enabled: !0,
        shared: !0,
        useHTML: !0,
        outside: !0,
        shadow: !1,
        split: !1,
        backgroundColor: "rgba(255,255,255,0)",
        borderRadius: 12,
        style: {
          pointerEvents: "none",
          border: "none",
          backgroundColor: "transparent",
          padding: "0",
          zIndex: 1e4
        },
        formatter() {
          const s = [];
          return this.points?.forEach((l) => {
            s.push({
              name: l.series.name,
              value: l.y
              //color: point.series.color
            });
          }), r(s);
        }
      }
    }));
    function r(s) {
      const l = pm();
      l.useColorCoding = !1;
      const d = l.useColorCoding ? 'class="positive"' : "", y = l.useColorCoding ? 'class="negative"' : "", u = '<i class="las la-arrow-up la-rotate-45" style="--fa-rotate-angle: 45deg;"></i>', m = '<i class="las la-arrow-down la-rotate-45-minus" style="--fa-rotate-angle: -45deg;"></i>';
      let h = '<div class="crociTooltip"><div class="crociTooltip-grid">';
      return s?.forEach((c) => {
        c.name && (h += '<div class="crociTooltip-element">', h += '<div class="crociTooltip-label">' + c.name + "</div>", c.value >= 0 ? h += '<div class="crociTooltip-value"><span ' + d + ">" + u + c.value + "</span></div>" : h += '<div class="crociTooltip-value"><span ' + y + ">" + m + c.value + "</span></div>", h += "</div>");
      }), h += "</div></div>", h;
    }
    return (s, l) => (E(), fe(_(Ei), {
      visible: o.value,
      "onUpdate:visible": l[0] || (l[0] = (d) => o.value = d),
      class: "d-croci-modal-dialog",
      modal: !0,
      closable: !0,
      position: _(aa).Center,
      "close-button-with-border": !1,
      pt: {
        root: {
          class: "d-modal-dialog--container-width"
        }
      }
    }, {
      content: Se(() => [
        oe("div", eme, [
          ue(Ot, {
            "base-heading-type": _(ze).H3,
            class: "d-croci-modal-dialog__headline"
          }, {
            default: Se(() => [
              Ve(Ie(e.model.title), 1)
            ]),
            _: 1
          }, 8, ["base-heading-type"]),
          e.model.introText ? (E(), fe(Tt, {
            key: 0,
            text: e.model.introText,
            "font-size": _(st).FourteenPx,
            "text-color": _(dt).GreyBlue006,
            "font-type": _(lt).DwsSansBold,
            class: "d-croci-modal-dialog__intro-text"
          }, null, 8, ["text", "font-size", "text-color", "font-type"])) : (E(), X("p", tme)),
          ue(eh, {
            ref: "chart",
            options: a.value,
            type: _(Ra).Chart,
            height: _(Vo).Small,
            class: "d-croci-modal-dialog__chart"
          }, null, 8, ["options", "type", "height"])
        ])
      ]),
      _: 1
    }, 8, ["visible", "position"]));
  }
});
const ime = /* @__PURE__ */ Fe(nme, [["__scopeId", "data-v-d5bf7915"]]), ame = {
  key: 0,
  class: "d-croci-company-detail-charts-area"
}, ome = { class: "d-croci-company-detail-charts-area__cards-container" }, rme = /* @__PURE__ */ Be({
  __name: "CrociCompanyDetailChartsArea",
  props: {
    model: {
      type: Object,
      required: !0
    }
  },
  setup(e) {
    const t = e, n = ge(null), i = ge(!1), o = ge({ title: "", introText: "", chartData: {} }), a = (s) => {
      o.value = s, i.value = !0;
    }, r = ge(t.model);
    return r.value?.crociCharts?.forEach((s) => {
      s.chartData = {
        ...S1,
        xAxis: {
          ...S1.xAxis,
          categories: Array.isArray(s.chartData.xAxis) ? void 0 : s.chartData.xAxis?.categories
        },
        series: s.chartData.series
      };
    }), ym(n, (s) => {
      s.target.className === "p-dialog-mask p-component-overlay p-component-overlay-enter" && i.value === !0 && (i.value = !1);
    }), (s, l) => e.model ? (E(), X("div", ame, [
      oe("div", ome, [
        (E(!0), X(Re, null, Ge(r.value.crociCharts, (d) => (E(), X("div", {
          key: d.title,
          class: "d-croci-company-detail-charts-area____chart-card"
        }, [
          ue(Qfe, {
            model: d,
            onShowZoom: (y) => a(d)
          }, null, 8, ["model", "onShowZoom"])
        ]))), 128))
      ]),
      ue(ime, {
        ref_key: "target",
        ref: n,
        visible: i.value,
        "onUpdate:visible": l[0] || (l[0] = (d) => i.value = d),
        model: o.value
      }, null, 8, ["visible", "model"])
    ])) : te("", !0);
  }
});
const sme = /* @__PURE__ */ Fe(rme, [["__scopeId", "data-v-3531aabe"]]), lme = {
  key: 0,
  class: "d-croci-company-detail-page__notification-area"
}, cme = {
  id: "croci-company-detail-data",
  class: "d-croci-company-detail-page__data"
}, dme = { class: "d-croci-company-detail-page__data__header" }, ume = /* @__PURE__ */ Be({
  __name: "CrociCompanyDetailPage",
  props: {
    model: {
      type: Object,
      required: !0
    }
  },
  emits: ["switchColumns"],
  setup(e, { emit: t }) {
    const n = e, { t: i } = Je(), o = t, { calculateScrollPosition: a } = Fn(), { pageName: r } = Qe(), { isMobile: s } = xt(), l = ge(null), d = ge(null), y = ge(null), u = ge(0), m = ge("charts"), h = ge(!1), c = $t("smoothScroll"), g = (k) => {
      h.value = !h.value, l?.value?.setShowAllColumns(h.value), o("switchColumns", k);
    }, v = () => {
      if (!l?.value)
        return;
      const k = m.value === "data" ? 0 : a(l.value.$el);
      c({
        scrollTo: k,
        duration: 1e3,
        updateHistory: !1
      }), m.value === "data" ? S(y.value)?.focus({
        preventScroll: !0
      }) : S(l.value.$el)?.focus({
        preventScroll: !0
      });
    }, P = Te(() => {
      const k = m.value === "charts" ? n?.model?.crociDataTableTitle : i("globalTranslations.backToTopButtonText");
      return {
        contentUrl: "#croci-company-detail-data",
        title: k,
        text: k,
        isLocked: !1,
        target: "_self",
        isExternal: !1,
        linkType: yt.Anchor,
        tealiumTrackingModel: {
          eventSource: r,
          eventComponentName: "CTA Link",
          eventTitle: m.value === "charts" ? "Croci Company Data" : "Back to top"
        }
      };
    }), f = Te(() => {
      const k = h.value ? i("crociCompanyDetailPage.showLess") : i("crociCompanyDetailPage.showAll");
      return {
        contentUrl: "",
        title: k,
        text: k,
        isLocked: !1,
        isExternal: !1,
        linkType: yt.Javascript,
        tealiumTrackingModel: {
          eventSource: r,
          eventComponentName: "Croci Company Detail",
          eventTitle: h.value ? "Show all columns" : "Show less columns"
        }
      };
    });
    function S(k) {
      const A = k.querySelectorAll(
        'a, button, textarea, input[type="text"], input[type="radio"], input[type="checkbox"], select, [tabindex="0"]'
      );
      return Array.from(A).find(($) => $.offsetParent !== null) || null;
    }
    const w = Jn(
      () => {
        window.scrollY >= u.value ? m.value = "data" : m.value = "charts";
      },
      250,
      { maxWait: 500 }
    ), x = Jn(
      () => {
        l?.value && (u.value = a(l.value.$el) - 10);
      },
      250,
      { maxWait: 500 }
    );
    return it(() => {
      window.addEventListener("scroll", w), window.addEventListener("resize", x);
    }), hm(() => {
      x(), w();
    }), sn(() => {
      Ue && (window.removeEventListener("scroll", w), window.removeEventListener("resize", x));
    }), (k, A) => e.model ? (E(), X("div", {
      key: 0,
      ref_key: "pageRef",
      ref: y,
      class: "d-croci-company-detail-page"
    }, [
      d.value?.$el ? (E(), fe(_(BC), {
        key: 0,
        "trigger-element": d.value?.$el,
        class: "d-croci-company-detail-page__shrink-header"
      }, {
        default: Se(() => [
          ue(_(k1), {
            "section-title": m.value === "charts" ? e.model.crociChartsTitle : e.model.crociDataTableTitle,
            "header-area-model": e.model.headerArea,
            "heading-type": _(ze).StyledAsH4,
            "ticker-model": e.model.companyInformation,
            "link-model": P.value,
            "link-icon": m.value === "charts" ? _(H).ArrowDown : _(H).ArrowUp,
            "section-id": "d-croci-company-detail--shrink",
            class: "d-croci-company-detail-page__shrink-header",
            onScrollToSection: v
          }, null, 8, ["section-title", "header-area-model", "heading-type", "ticker-model", "link-model", "link-icon"])
        ]),
        _: 1
      }, 8, ["trigger-element"])) : te("", !0),
      ue(Vt, {
        id: "d-croci-company-detail",
        class: "d-croci-company-detail",
        "no-margin-bottom": !0,
        "no-margin": !0
      }, {
        default: Se(() => [
          e.model.notifications && e.model.notifications.length ? (E(), X("div", lme, [
            (E(!0), X(Re, null, Ge(e.model.notifications, ($) => (E(), fe(Eh, {
              id: $.id,
              key: $.id,
              notification: $.notification,
              type: $.type,
              url: $.url,
              "show-checkbox": $.showCheckbox,
              "show-as-toast": $.showAsToast,
              closable: $.closable
            }, null, 8, ["id", "notification", "type", "url", "show-checkbox", "show-as-toast", "closable"]))), 128))
          ])) : te("", !0),
          ue(_(k1), {
            ref_key: "headerRef",
            ref: d,
            "section-title": e.model.crociChartsTitle,
            "header-area-model": e.model.headerArea,
            "ticker-model": e.model.companyInformation,
            "link-model": P.value,
            "link-icon": _(H).ArrowDown,
            "full-width": !0,
            "section-id": "croci-company-detail-charts",
            class: "d-croci-company-detail-page__charts-header",
            onScrollToSection: v
          }, null, 8, ["section-title", "header-area-model", "ticker-model", "link-model", "link-icon"]),
          ue(sme, {
            class: "d-croci-company-detail-page__charts",
            model: e.model.crociData
          }, null, 8, ["model"]),
          oe("div", cme, [
            oe("div", dme, [
              ue(Ot, {
                "base-heading-type": _(ze).H2Section,
                class: "d-croci-company-detail-page__data__header-heading"
              }, {
                default: Se(() => [
                  oe("span", null, Ie(e.model.crociDataTableTitle), 1)
                ]),
                _: 1
              }, 8, ["base-heading-type"]),
              _(s) ? te("", !0) : (E(), fe(vt, {
                key: 0,
                class: "d-croci-company-detail-page__data__header-button",
                "link-model": f.value,
                icon: h.value ? _(H).Minus : _(H).Plus,
                type: _(Ke).Secondary,
                size: _(et).Large,
                "icon-position": _(ct).Left,
                onClick: g,
                onKeydown: Ze(It(g, ["prevent"]), ["enter"])
              }, null, 8, ["link-model", "icon", "type", "size", "icon-position", "onKeydown"]))
            ]),
            ue(qfe, {
              ref_key: "dataSectionRef",
              ref: l,
              model: e.model.dataTable,
              onExpanded: g
            }, null, 8, ["model"])
          ])
        ]),
        _: 1
      })
    ], 512)) : te("", !0);
  }
});
const EBe = /* @__PURE__ */ Fe(ume, [["__scopeId", "data-v-96a3c9db"]]);
var Ln = /* @__PURE__ */ ((e) => (e.Input = "input", e.Textarea = "textarea", e.Password = "password", e.Date = "date", e.Email = "email", e.Telephone = "telephone", e.Checkbox = "checkbox", e.RadioButton = "radio-button", e.Dropdown = "dropdown", e.FreeTextDropdown = "free-text-dropdown", e.Html = "html", e.HiddenInput = "hidden-input", e))(Ln || {}), Ii = /* @__PURE__ */ ((e) => (e.RequiredValidator = "RequiredValidator", e.NameValidator = "NameValidator", e.NumberValidator = "NumberValidator", e.PhoneNumberValidator = "PhoneNumberValidator", e.PasswordValidator = "PasswordValidator", e.EmailValidator = "EmailValidator", e.PositiveIntegerValidator = "PositiveIntegerValidator", e.IntegerValidator = "IntegerValidator", e.RegularExpressionValidator = "RegularExpressionValidator", e.MaximumStringLengthValidator = "MaximumStringLengthValidator", e.MinimumStringLengthValidator = "MinimumStringLengthValidator", e))(Ii || {}), hme = /^[-!#$%&'*+\/0-9=?A-Z^_a-z{|}~](\.?[-!#$%&'*+\/0-9=?A-Z^_a-z`{|}~])*@[a-zA-Z0-9](-*\.?[a-zA-Z0-9])*\.[a-zA-Z](-?[a-zA-Z0-9])+$/, jT = function(e) {
  if (!e || e.length > 254)
    return !1;
  var t = hme.test(e);
  if (!t)
    return !1;
  var n = e.split("@");
  if (n[0].length > 64)
    return !1;
  var i = n[1].split(".");
  return !i.some(function(o) {
    return o.length > 63;
  });
};
const pme = {
  key: 0,
  class: "d-form-builder-element"
}, fme = /* @__PURE__ */ Be({
  __name: "FormBuilderElement",
  props: {
    modelValue: {},
    modelModifiers: {}
  },
  emits: /* @__PURE__ */ HL(["changed"], ["update:modelValue"]),
  setup(e, { expose: t, emit: n }) {
    const i = zL(e, "modelValue"), o = n, { checkNumberString: a } = Uc(), r = ge(Ht.Default), s = ge(Vi.Default), l = ge(!0), d = ge(""), y = ge(i.value), u = (D) => D.toLowerCase().replace(/\W/g, ""), m = Te(() => y.value?.validators && y.value.validators.length > 0), h = Te(() => m.value && y.value?.validators.some(
      (D) => D.name === Ii.RequiredValidator
    )), c = Te(() => y.value?.options?.map(
      (C) => ({
        id: u(C.caption),
        name: C.caption
      })
    )), g = Te(() => y.value?.options?.filter((C) => C.isChecked)?.map((C) => ({
      id: u(C.caption),
      name: C.caption
    }))?.[0]), v = Te(() => ({
      isValid: l.value,
      isDisabled: !1,
      items: c.value,
      selectedItem: g.value,
      alignment: y.value.alignment ?? Cc.Vertical
    })), P = Te(() => y.value?.options?.map((C) => ({
      id: u(C.caption),
      name: C.caption,
      value: C.isChecked
    }))), f = Te(() => ({
      label: y.value?.name,
      items: P.value,
      alignment: y.value.alignment ?? Cc.Vertical,
      isValid: l.value
    })), S = Te(() => y.value?.options?.filter((C) => C.isChecked)?.map((C) => ({
      name: C.caption,
      value: C.value,
      isSelected: C.isChecked
    }))?.[0]), w = Te(() => y.value?.options?.map(
      (C) => ({
        name: C.caption,
        value: C.value,
        isSelected: C.isChecked
      })
    )), x = Te(() => {
      switch (y.value?.type) {
        case Ln.Password:
          return _n.Password;
        case Ln.Email:
          return _n.Email;
        case Ln.Textarea:
          return _n.Textarea;
        case Ln.Telephone:
          return _n.Default;
        case Ln.Date:
          return _n.Date;
        case Ln.HiddenInput:
          return _n.Hidden;
        default:
          return _n.Default;
      }
    }), k = Te(() => {
      switch (y.value?.type) {
        case Ln.Password:
        case Ln.Email:
        case Ln.Textarea:
        case Ln.Input:
        case Ln.Date:
        case Ln.Telephone:
        case Ln.HiddenInput:
          return !0;
        default:
          return !1;
      }
    }), A = () => {
      if (y.value.isValid = !0, m.value && y.value?.type !== Ln.HiddenInput) {
        l.value = !0, d.value = "", r.value = Ht.Valid, s.value = Vi.Valid, i.value = y.value;
        const D = a(y.value?.value);
        y.value?.validators.forEach((C) => {
          switch (C.name) {
            case Ii.RequiredValidator:
              y.value?.options ? l.value = y.value?.options.some(
                (b) => b.isChecked
              ) : l.value = !!y.value?.value;
              break;
            case Ii.NumberValidator:
              l.value = !y.value?.value || D.isNumber, i.value = l.value ? {
                ...i.value,
                value: D.value?.toString() || ""
              } : i.value;
              break;
            case Ii.IntegerValidator: {
              l.value = !y.value?.value || D.isNumber && D.isInteger, i.value = l.value ? {
                ...i.value,
                value: D.value?.toString() || ""
              } : i.value;
              break;
            }
            case Ii.PositiveIntegerValidator: {
              l.value = !y.value?.value || D.isNumber && D.isInteger && D.isPositive, i.value = l.value ? {
                ...i.value,
                value: D.value?.toString() || ""
              } : i.value;
              break;
            }
            case Ii.MinimumStringLengthValidator:
              l.value = !y.value?.value || y.value?.value.length >= Number(C.value);
              break;
            case Ii.MaximumStringLengthValidator:
              l.value = (y.value?.value || "").length <= Number(C.value);
              break;
            case Ii.EmailValidator:
              l.value = !y.value?.value || jT(y.value?.value);
              break;
            case Ii.RegularExpressionValidator:
            case Ii.PhoneNumberValidator:
            case Ii.PasswordValidator:
            case Ii.NameValidator:
              l.value = !y.value?.value || new RegExp(C.value, "gi").test(y.value?.value);
              break;
          }
          l.value || (r.value = Ht.Invalid, s.value = Vi.Invalid, y.value.isValid = !1, d.value += ` ${C.message}`, d.value.endsWith(".") || (d.value += "."));
        });
      }
    }, $ = (D) => {
      y.value.value = D, A(), o("changed", i.value);
    }, j = (D, C) => {
      y.value?.options.forEach((b) => {
        b.isChecked = C.find((p) => b.caption === p.name)?.value || !1;
      }), A(), o("changed", i.value);
    }, N = (D) => {
      i.value?.options.forEach((C) => {
        C.isChecked = C.caption === D.name;
      }), A(), o("changed", i.value);
    }, M = (D) => {
      i.value?.options.forEach((C) => {
        C.isChecked = C.caption === D.name;
      }), o("changed", i.value);
    };
    return t({
      validate: A
    }), (D, C) => i.value ? (E(), X("div", pme, [
      k.value ? (E(), fe(Es, {
        key: 0,
        id: i.value.id,
        "input-type": x.value,
        "input-value": y.value.value,
        label: i.value.name,
        placeholder: i.value.placeholder,
        mandatory: h.value,
        "helper-text": i.value.tooltip,
        "error-text": d.value,
        state: r.value,
        onValueChanged: $
      }, null, 8, ["id", "input-type", "input-value", "label", "placeholder", "mandatory", "helper-text", "error-text", "state"])) : te("", !0),
      i.value.type === _(Ln).Checkbox ? (E(), fe(bg, {
        key: 1,
        model: f.value,
        label: i.value.name,
        mandatory: h.value,
        "helper-text": i.value.tooltip,
        "error-text": d.value,
        onSelectedItemChanged: j
      }, null, 8, ["model", "label", "mandatory", "helper-text", "error-text"])) : te("", !0),
      i.value.type === _(Ln).RadioButton ? (E(), fe(Vs, {
        key: 2,
        model: v.value,
        label: i.value.name,
        mandatory: h.value,
        "helper-text": i.value.tooltip,
        "error-text": d.value,
        onValueChanged: N
      }, null, 8, ["model", "label", "mandatory", "helper-text", "error-text"])) : te("", !0),
      i.value.type === _(Ln).FreeTextDropdown || i.value.type === _(Ln).Dropdown ? (E(), fe(vi, {
        key: 3,
        "dropdown-type": i.value.type === _(Ln).FreeTextDropdown ? _(Gt).FreeText : _(Gt).InputDropdown,
        selected: S.value,
        items: w.value,
        label: i.value.name,
        placeholder: i.value.placeholder,
        state: s.value,
        mandatory: h.value,
        "helper-text": i.value.tooltip,
        "error-text": d.value,
        onSelectedItemChanged: M
      }, null, 8, ["dropdown-type", "selected", "items", "label", "placeholder", "state", "mandatory", "helper-text", "error-text"])) : te("", !0),
      i.value.type === _(Ln).Html ? (E(), fe(ht, {
        key: 4,
        "html-text": y.value.value
      }, null, 8, ["html-text"])) : te("", !0)
    ])) : te("", !0);
  }
});
const C1 = /* @__PURE__ */ Fe(fme, [["__scopeId", "data-v-988d5f6b"]]), mme = {
  key: 0,
  class: "d-form-builder"
}, gme = {
  key: 0,
  class: "d-form-builder__column"
}, vme = /* @__PURE__ */ Be({
  __name: "FormBuilder",
  props: {
    model: {
      type: Object,
      required: !0
    }
  },
  emits: ["submit"],
  setup(e, { emit: t }) {
    const n = e, { pageName: i } = Qe(), o = t, a = ge(n.model), r = ge([]), s = Te(() => a.value.sections.every((y) => y.rows.every((u) => u.columnOne.isValid && (!u.columnTwo || u.columnTwo.isValid)))), l = () => {
      r.value.forEach((y) => {
        y.validate();
      }), s.value && o("submit", a.value);
    }, d = () => ({
      contentUrl: "",
      title: n.model.submitButtonLabel,
      text: n.model.submitButtonLabel,
      isLocked: !1,
      target: "",
      isExternal: !1,
      linkType: yt.Default,
      tealiumTrackingModel: {
        eventSource: i,
        eventComponentName: "FormBuilder",
        eventTitle: "Submit button"
      }
    });
    return (y, u) => {
      const m = $e("BaseHeading");
      return e.model ? (E(), X("div", mme, [
        a.value.header ? (E(), fe(Hs, {
          key: 0,
          class: "d-form-builder__header",
          model: {
            headline: a.value.header,
            introText: a.value.description
          },
          "base-heading-type": e.model.headingType
        }, null, 8, ["model", "base-heading-type"])) : te("", !0),
        a.value.sections ? (E(), X("form", {
          key: 1,
          onSubmit: It(l, ["stop", "prevent"])
        }, [
          (E(!0), X(Re, null, Ge(a.value.sections, (h) => (E(), X("div", {
            key: h.id,
            class: "d-form-builder__section"
          }, [
            h.headline ? (E(), fe(m, {
              key: 0,
              "base-heading-type": _(ze).H2Section,
              class: "d-form-builder__section-heading"
            }, {
              default: Se(() => [
                Ve(Ie(h.headline), 1)
              ]),
              _: 2
            }, 1032, ["base-heading-type"])) : te("", !0),
            (E(!0), X(Re, null, Ge(h.rows, (c, g) => (E(), X("div", {
              key: g,
              class: "d-form-builder__row"
            }, [
              oe("div", {
                class: Pe(["d-form-builder__column", {
                  "d-form-builder__column--full-width": !c.columnTwo && (c.columnOne.type === _(Ln).Textarea || c.columnOne.type === _(Ln).Html)
                }])
              }, [
                ue(C1, {
                  ref_for: !0,
                  ref_key: "elements",
                  ref: r,
                  modelValue: c.columnOne,
                  "onUpdate:modelValue": (v) => c.columnOne = v
                }, null, 8, ["modelValue", "onUpdate:modelValue"])
              ], 2),
              c.columnTwo ? (E(), X("div", gme, [
                ue(C1, {
                  ref_for: !0,
                  ref_key: "elements",
                  ref: r,
                  modelValue: c.columnTwo,
                  "onUpdate:modelValue": (v) => c.columnTwo = v
                }, null, 8, ["modelValue", "onUpdate:modelValue"])
              ])) : te("", !0)
            ]))), 128))
          ]))), 128)),
          a.value.submitButtonLabel ? (E(), fe(vt, {
            key: 0,
            "link-model": d(),
            type: _(Ke).Primary,
            size: _(et).Large,
            "icon-position": _(ct).Left,
            "button-type": _(zt).Button,
            class: "d-form-builder__button"
          }, null, 8, ["link-model", "type", "size", "icon-position", "button-type"])) : te("", !0)
        ], 32)) : te("", !0)
      ])) : te("", !0);
    };
  }
});
const DBe = /* @__PURE__ */ Fe(vme, [["__scopeId", "data-v-160849bf"]]);
var Lo = /* @__PURE__ */ ((e) => (e.Monthly = "0", e.Quarterly = "1", e.Yearly = "2", e))(Lo || {});
const yme = { class: "d-investment-calculation-area__settings" }, bme = /* @__PURE__ */ Be({
  __name: "InvestmentCalculationArea",
  props: {
    model: {
      type: Object,
      required: !0
    },
    currency: {
      type: String,
      required: !0
    }
  },
  emits: ["calculate", "jumpToChart"],
  setup(e, { emit: t }) {
    const n = e, { pageName: i } = Qe(), { isDesktopAsync: o, isMobile: a } = xt(), { t: r } = Je(), { getCurrencyAffix: s } = Uc(), l = t, d = ge(null), y = ge(null), u = ge(!1), m = ge(n.model.initialInvestment.value), h = ge(n.model.regularInvestment.value), c = ge(n.model.valueDevelopment.value), g = ge(n.model.investmentDuration.value), v = ge(n.model.dynamicIncrease.value), P = ge(n.model.issuePremium.value), f = ge(n.model.initialInvestment.value), S = ge(n.model.regularInvestment.value), w = ge(n.model.valueDevelopment.value), x = ge(n.model.investmentDuration.value), k = ge(n.model.dynamicIncrease.value), A = ge(n.model.issuePremium.value), $ = ge([
      {
        id: Lo.Monthly,
        name: r("globalTranslations.monthly")
      },
      {
        id: Lo.Quarterly,
        name: r("globalTranslations.quarterly")
      },
      {
        id: Lo.Yearly,
        name: r("globalTranslations.yearly")
      }
    ]), j = $.value.find((W) => W.id === n?.model?.initialPeriod) || $.value[0], N = ge(j), M = () => {
      u.value = !u.value;
    }, D = () => {
      l("jumpToChart");
    }, C = () => {
      f.value = m.value, S.value = h.value, w.value = c.value, x.value = g.value, k.value = v.value, A.value = P.value, N.value = j, T();
    }, b = Te(() => {
      switch (N.value.id) {
        case Lo.Monthly:
          return 12;
        case Lo.Quarterly:
          return 4;
        default:
          return 1;
      }
    }), p = (W) => S.value * Math.pow(1 + k.value / 100, W - 1), L = (W) => A.value / 100 * W, B = () => ({
      initialInvestment: {
        ...n.model.initialInvestment,
        value: f.value
      },
      regularInvestment: {
        ...n.model.regularInvestment,
        value: S.value
      },
      initialPeriod: N.value.id,
      valueDevelopment: {
        ...n.model.valueDevelopment,
        value: w.value
      },
      investmentDuration: {
        ...n.model.investmentDuration,
        value: x.value
      },
      dynamicIncrease: {
        ...n.model.dynamicIncrease,
        value: k.value
      },
      issuePremium: { ...n.model.issuePremium, value: A.value }
    }), T = () => {
      let W = 0, ae = 0, z = 0;
      const q = {
        valueDevelopment: [0],
        regularInvestment: [0],
        initialInvestment: [f.value],
        summary: [f.value]
      }, Z = 1 + w.value / 100, ne = 1 / b.value, ie = (Math.pow(Z, ne) - 1) * 100, re = f.value - L(f.value);
      W = re;
      for (let de = 0; de < x.value; de++) {
        const me = p(de + 1);
        for (let ce = 0; ce < b.value; ce++) {
          const pe = me - L(me);
          W += pe;
          const xe = W * (ie / 100);
          W += xe, z += pe, ae += xe;
        }
        q.valueDevelopment.push(ae), q.regularInvestment.push(z), q.initialInvestment.push(re), q.summary.push(W);
      }
      l("calculate", q, B());
    };
    it(() => {
      T();
      const W = s(n?.currency);
      d.value = W?.prefix, y.value = W?.suffix;
    });
    const O = (W) => {
      f.value = Number(W), G(
        "Initial investment change",
        f.value,
        n?.currency
      ), T();
    }, I = (W) => {
      S.value = W, G(
        "Regular investment change",
        S.value,
        n?.currency
      ), T();
    }, R = (W) => {
      w.value = W, G("Value development change", w.value, "%"), T();
    }, Y = (W) => {
      x.value = W, G(
        "Investment duration change",
        x.value,
        "years"
      ), T();
    }, F = (W) => {
      k.value = W, G("Dynamic increase change", k.value, "%"), T();
    }, U = (W) => {
      A.value = W, G("Issue premium change", A.value, "%"), T();
    }, Q = (W) => {
      N.value = W, On(
        "InvestmentCalculator",
        "Frequency change | " + V(W?.id),
        i
      ), T();
    }, J = (W) => ({
      contentUrl: "",
      title: W,
      text: W,
      isLocked: !1,
      target: "",
      isExternal: !1,
      linkType: yt.Javascript,
      tealiumTrackingModel: {
        eventSource: i,
        eventComponentName: "InvestmentCalculator",
        eventTitle: u.value ? "Mehr Optionen" : "Weniger Optionen"
      }
    }), ee = Te(() => ({
      isDisabled: !1,
      isValid: !0,
      alignment: a.value ? Nc.Vertical : Nc.Horizontal,
      selectedItem: N.value,
      items: $.value
    }));
    function V(W) {
      const ae = Object.entries(Lo).find(
        ([, z]) => z === W
      );
      return ae ? ae[0] : void 0;
    }
    const G = (W, ae, z) => On(
      "InvestmentCalculator",
      `${W} | ${ae}${z}`,
      i
    );
    return qe(
      () => n.model.initialInvestment,
      (W) => {
        O(W.value);
      }
    ), qe(
      () => n.model.regularInvestment,
      (W) => {
        I(W.value);
      }
    ), qe(
      () => n.model.initialPeriod,
      (W) => {
        const ae = Number(W);
        Q($.value[ae]);
      }
    ), qe(
      () => n.model.valueDevelopment,
      (W) => {
        R(W.value);
      }
    ), qe(
      () => n.model.investmentDuration,
      (W) => {
        Y(W.value);
      }
    ), qe(
      () => n.model.dynamicIncrease,
      (W) => {
        F(W.value);
      }
    ), qe(
      () => n.model.issuePremium,
      (W) => {
        U(W.value);
      }
    ), (W, ae) => e.model ? (E(), X("div", {
      key: 0,
      class: Pe(["d-investment-calculation-area", { "d-investment-calculation-area--no-margin": u.value }])
    }, [
      oe("div", yme, [
        oe("div", null, [
          ue(to, {
            class: "d-investment-calculation-area__slider",
            value: f.value,
            label: e.model.initialInvestment.label,
            min: e.model.initialInvestment.min,
            max: e.model.initialInvestment.max,
            step: e.model.initialInvestment.step,
            "number-suffix": y.value,
            "number-prefix": d.value,
            "helper-text": e.model.initialInvestment.helperText,
            "error-text": e.model.initialInvestment.errorText,
            onChanged: ae[0] || (ae[0] = (z) => O(z))
          }, null, 8, ["value", "label", "min", "max", "step", "number-suffix", "number-prefix", "helper-text", "error-text"])
        ]),
        oe("div", null, [
          ue(to, {
            class: "d-investment-calculation-area__slider",
            value: S.value,
            label: e.model.regularInvestment.label,
            min: e.model.regularInvestment.min,
            max: e.model.regularInvestment.max,
            step: e.model.regularInvestment.step,
            "number-suffix": y.value,
            "number-prefix": d.value,
            "helper-text": e.model.regularInvestment.helperText,
            "error-text": e.model.regularInvestment.errorText,
            onChanged: ae[1] || (ae[1] = (z) => I(z))
          }, null, 8, ["value", "label", "min", "max", "step", "number-suffix", "number-prefix", "helper-text", "error-text"]),
          ue(Vs, {
            class: "d-investment-calculation-area__periods",
            model: ee.value,
            onValueChanged: Q
          }, null, 8, ["model"])
        ]),
        oe("div", null, [
          ue(to, {
            class: "d-investment-calculation-area__slider",
            value: w.value,
            label: e.model.valueDevelopment.label,
            min: e.model.valueDevelopment.min,
            max: e.model.valueDevelopment.max,
            step: e.model.valueDevelopment.step,
            "number-suffix": "%",
            "helper-text": e.model.valueDevelopment.helperText,
            "error-text": e.model.valueDevelopment.errorText,
            onChanged: ae[2] || (ae[2] = (z) => R(z))
          }, null, 8, ["value", "label", "min", "max", "step", "helper-text", "error-text"])
        ]),
        oe("div", null, [
          ue(to, {
            class: "d-investment-calculation-area__slider",
            value: x.value,
            label: e.model.investmentDuration.label,
            min: e.model.investmentDuration.min,
            max: e.model.investmentDuration.max,
            step: e.model.investmentDuration.step,
            "number-suffix": ` ${x.value === 1 ? _(r)("globalTranslations.year") : _(r)("globalTranslations.years")}`,
            "helper-text": e.model.investmentDuration.helperText,
            "error-text": e.model.investmentDuration.errorText,
            onChanged: ae[3] || (ae[3] = (z) => Y(z))
          }, null, 8, ["value", "label", "min", "max", "step", "number-suffix", "helper-text", "error-text"])
        ]),
        ue(Br, { class: "d-investment-calculation-area__slider-box" }, {
          default: Se(() => [
            rt(oe("div", null, [
              ue(to, {
                class: "d-investment-calculation-area__slider",
                value: k.value,
                label: e.model.dynamicIncrease.label,
                min: e.model.dynamicIncrease.min,
                max: e.model.dynamicIncrease.max,
                step: e.model.dynamicIncrease.step,
                "number-suffix": "%",
                "helper-text": e.model.dynamicIncrease.helperText,
                "error-text": e.model.dynamicIncrease.errorText,
                onChanged: ae[4] || (ae[4] = (z) => F(z))
              }, null, 8, ["value", "label", "min", "max", "step", "helper-text", "error-text"])
            ], 512), [
              [xn, u.value]
            ]),
            rt(oe("div", null, [
              ue(to, {
                class: "d-investment-calculation-area__slider",
                value: A.value,
                label: e.model.issuePremium.label,
                min: e.model.issuePremium.min,
                max: e.model.issuePremium.max,
                step: e.model.issuePremium.step,
                "number-suffix": "%",
                "helper-text": e.model.issuePremium.helperText,
                "error-text": e.model.issuePremium.errorText,
                onChanged: ae[5] || (ae[5] = (z) => U(z))
              }, null, 8, ["value", "label", "min", "max", "step", "helper-text", "error-text"])
            ], 512), [
              [xn, u.value]
            ])
          ]),
          _: 1
        })
      ]),
      oe("div", {
        class: Pe(["d-investment-calculation-area__footer", { "d-investment-calculation-area__footer--margin": u.value }])
      }, [
        _(o) ? te("", !0) : (E(), fe(vt, {
          key: 0,
          "link-model": J(
            e.model.calculationButtonLabel || _(r)("calculationArea.calculationButtonLabel")
          ),
          type: _(Ke).Primary,
          size: _(et).Large,
          icon: _(H).SlidersH,
          "icon-position": _(ct).Left,
          class: "d-investment-calculation-area__calculate",
          onClick: ae[6] || (ae[6] = (z) => D())
        }, null, 8, ["link-model", "type", "size", "icon", "icon-position"])),
        ue(vt, {
          "link-model": J(
            e.model.optionButtonLabel || u.value ? _(r)("calculationArea.optionButtonLabelLess") : _(r)("calculationArea.optionButtonLabel")
          ),
          type: _(Ke).Secondary,
          size: _(et).Large,
          icon: u.value ? _(H).Minus : _(H).Plus,
          "icon-position": _(ct).Left,
          class: "d-investment-calculation-area__show-more",
          onClick: ae[7] || (ae[7] = (z) => M())
        }, null, 8, ["link-model", "type", "size", "icon", "icon-position"]),
        ue(vt, {
          "link-model": J(
            e.model.restartButtonLabel || _(r)("calculationArea.restartButtonLabel")
          ),
          type: _(Ke).Tertiary,
          size: _(et).Large,
          icon: _(H).RedoAlt,
          "icon-position": _(ct).Left,
          class: "d-investment-calculation-area__restart",
          onClick: ae[8] || (ae[8] = (z) => C())
        }, null, 8, ["link-model", "type", "size", "icon", "icon-position"])
      ], 2)
    ], 2)) : te("", !0);
  }
});
const xme = /* @__PURE__ */ Fe(bme, [["__scopeId", "data-v-ccfc9351"]]), wme = {
  key: 0,
  class: "d-investment-calculator"
}, kme = { class: "d-investment-calculator__column" }, Sme = { class: "d-investment-calculator__column" }, Cme = /* @__PURE__ */ Be({
  __name: "InvestmentCalculator",
  props: {
    model: {
      type: Object,
      required: !0
    }
  },
  setup(e) {
    const t = e, n = $t("smoothScroll"), { calculateScrollPosition: i } = Fn(), o = ge(
      t.model.investmentCalculationAreaProps
    ), a = ge(t.model.calculatorOutputCardProps), r = ge(null);
    function s() {
      if (!Ue)
        return {};
      const g = new URL(window.location.href), v = new URLSearchParams(g.search), P = {};
      return v.forEach((f, S) => {
        const w = parseFloat(f);
        P[S] = isNaN(w) ? null : w;
      }), P;
    }
    const l = s();
    function d(g) {
      return Object.values(Lo).includes(
        g
      ) ? g : void 0;
    }
    if (Object.keys(l).length > 0) {
      o.value.initialInvestment.value = l.cliI || t.model?.investmentCalculationAreaProps?.initialInvestment?.value, o.value.regularInvestment.value = l.clrI || t.model?.investmentCalculationAreaProps?.regularInvestment?.value;
      const g = l?.cliPr?.toString();
      o.value.initialPeriod = g ? d(g) : t.model?.investmentCalculationAreaProps?.initialPeriod, o.value.valueDevelopment.value = l.clvD || t.model?.investmentCalculationAreaProps?.valueDevelopment?.value, o.value.investmentDuration.value = l.cliD || t.model?.investmentCalculationAreaProps?.investmentDuration?.value, o.value.dynamicIncrease.value = l.cldI || t.model?.investmentCalculationAreaProps?.dynamicIncrease?.value, o.value.issuePremium.value = l.cliP || t.model?.investmentCalculationAreaProps?.issuePremium?.value;
    }
    const y = Te(() => ({
      cliI: o.value?.initialInvestment?.value?.toString(),
      clrI: o.value?.regularInvestment?.value?.toString(),
      cliPr: o.value?.initialPeriod?.toString(),
      clvD: o.value?.valueDevelopment?.value?.toString(),
      cliD: o.value?.investmentDuration?.value?.toString(),
      cldI: o.value?.dynamicIncrease?.value?.toString(),
      cliP: o.value?.issuePremium?.value?.toString()
    })), u = (g, v) => {
      const P = new URL(g);
      return Object.entries(v).forEach(([f, S]) => {
        P.searchParams.set(f, S);
      }), P.toString();
    }, m = Te(() => {
      if (!Ue)
        return {
          ogUrl: void 0,
          twitterUrl: void 0
        };
      const g = u(
        window.location.href,
        y.value
      );
      return {
        ogUrl: g,
        twitterUrl: g
      };
    }), h = (g, v) => {
      a.value.investmentValues = g, o.value.initialInvestment.value = v.initialInvestment?.value, o.value.regularInvestment.value = v.regularInvestment?.value, o.value.initialPeriod = v.initialPeriod, o.value.valueDevelopment.value = v.valueDevelopment?.value, o.value.investmentDuration.value = v.investmentDuration?.value, o.value.dynamicIncrease.value = v.dynamicIncrease?.value, o.value.issuePremium.value = v.issuePremium?.value;
    }, c = () => {
      Ue && n({
        scrollTo: i(r.value?.$el),
        duration: 1e3,
        updateHistory: !1
      });
    };
    return (g, v) => e.model ? (E(), X("div", wme, [
      e.model?.headline || e.model?.introText ? (E(), X("div", {
        key: 0,
        class: Pe(["d-investment-calculator__header", {
          "d-investment-calculator__header--full-width": e.model.fullWidth
        }])
      }, [
        ue(Hs, {
          model: {
            headline: e.model.headline,
            introText: e.model.introText
          },
          "base-heading-type": e.model.headingType || _(ze).H1
        }, null, 8, ["model", "base-heading-type"])
      ], 2)) : te("", !0),
      e.model.investmentCalculationAreaProps && e.model.calculatorOutputCardProps ? (E(), X("div", {
        key: 1,
        class: Pe(["d-investment-calculator__container", {
          "d-investment-calculator__container--bg-grey": e.model.fullWidth,
          "d-investment-calculator__container--full-width": e.model.fullWidth
        }])
      }, [
        oe("div", kme, [
          ue(xme, {
            model: o.value,
            currency: e.model?.currency,
            onCalculate: h,
            onJumpToChart: c
          }, null, 8, ["model", "currency"])
        ]),
        oe("div", Sme, [
          ue(FT, {
            ref_key: "outputCard",
            ref: r,
            model: a.value,
            type: _(ei).Investment,
            "meta-tags": m.value,
            currency: e.model?.currency,
            "years-step": e.model?.investmentCalculationAreaProps?.investmentDuration?.step
          }, null, 8, ["model", "type", "meta-tags", "currency", "years-step"])
        ])
      ], 2)) : te("", !0)
    ])) : te("", !0);
  }
});
const RBe = /* @__PURE__ */ Fe(Cme, [["__scopeId", "data-v-5380b8cc"]]);
var HT = /* @__PURE__ */ ((e) => (e.ListFilledPerRow = "list-filled-per-row", e.ListFilledFromTopToBottom = "list-filled-from-top-to-bottom", e))(HT || {}), $o = /* @__PURE__ */ ((e) => (e.LeafGreen = "leaf-green", e.SkyBlue = "sky-blue", e.OceanBlue = "ocean-blue", e.SustainedGreen = "sustained-green", e.ProgPurple = "prog-purple", e.Amber = "amber", e.Pink = "pink", e.GreyBlue001 = "grey-blue-001", e))($o || {});
const Tme = { class: "d-facts-lists-item-marker__content" }, Lme = {
  key: 1,
  class: "d-facts-lists-item-marker__content--number"
}, Ime = /* @__PURE__ */ Be({
  __name: "FactsListsItemMarker",
  props: {
    model: {
      type: String,
      required: !0
    },
    itemMarkerColor: {
      type: String,
      default: $o.GreyBlue001
    }
  },
  setup(e) {
    const t = (n) => Object.values(H).includes(n);
    return (n, i) => (E(), X("div", {
      class: Pe(["d-facts-lists-item-marker", "d-facts-lists-item-marker--" + e.itemMarkerColor])
    }, [
      oe("div", Tme, [
        t(e.model) ? (E(), fe(_t, {
          key: 0,
          "base-icon": e.model,
          "base-icon-filled": !1,
          "base-icon-color": e.itemMarkerColor === _($o).GreyBlue001 ? _(gt).GreyBlue009 : _(gt).White
        }, null, 8, ["base-icon", "base-icon-color"])) : (E(), X("span", Lme, Ie(e.model), 1))
      ])
    ], 2));
  }
});
const Rh = /* @__PURE__ */ Fe(Ime, [["__scopeId", "data-v-7de33dd7"]]), Pme = {
  key: 0,
  class: "d-risk-disclaimer"
}, Ame = { class: "d-risk-disclaimer__container" }, _me = { class: "d-risk-disclaimer__header" }, Mme = { class: "d-risk-disclaimer__icon-and-headline" }, Ome = /* @__PURE__ */ Be({
  __name: "RiskDisclaimer",
  props: {
    model: {
      type: Object,
      required: !0
    }
  },
  emits: ["riskDisclaimerCollapsed"],
  setup(e, { emit: t }) {
    const n = e, { t: i } = Je(), { pageName: o } = Qe(), a = $t("$cookies"), r = t, s = ge(n?.model?.cookieName || "RiskDisclaimerCookie"), l = ge(!1), d = () => {
      l.value = !l.value, Ue && a?.set(s.value, l.value.toString()), r("riskDisclaimerCollapsed", l.value);
    }, y = () => ({
      contentUrl: "",
      title: l.value ? i("riskDisclaimer.showDisclaimer") : i("riskDisclaimer.hideDisclaimer"),
      text: l.value ? i("riskDisclaimer.showDisclaimer") : i("riskDisclaimer.hideDisclaimer"),
      isLocked: !1,
      target: "",
      isExternal: !1,
      linkType: yt.Javascript,
      tealiumTrackingModel: {
        eventSource: o,
        eventComponentName: " Risk Disclaimer",
        eventTitle: l.value ? i("riskDisclaimer.showDisclaimer") : i("riskDisclaimer.hideDisclaimer")
      }
    }), u = () => l.value ? H.Plus : H.Minus;
    return it(() => {
      l.value = a?.get(s.value) === "true";
    }), (m, h) => e.model ? (E(), X("div", Pme, [
      ue(Vt, {
        id: "risk-disclaimer",
        "no-margin-bottom": !0
      }, {
        default: Se(() => [
          oe("div", Ame, [
            oe("div", _me, [
              oe("div", Mme, [
                ue(Rh, {
                  model: "i",
                  "item-marker-color": _($o).GreyBlue001,
                  class: "d-content-box-content__icon"
                }, null, 8, ["item-marker-color"]),
                ue(Tt, {
                  text: e.model.title,
                  "text-color": _(dt).GreyBlue009,
                  "font-type": _(lt).DwsSlabBold
                }, null, 8, ["text", "text-color", "font-type"])
              ]),
              ue(Nt, {
                class: "d-risk-disclaimer__button",
                "link-model": y(),
                type: _(Ke).RoundedNonFilled,
                size: _(et).Small,
                icon: u(),
                onClick: d
              }, null, 8, ["link-model", "type", "size", "icon"])
            ]),
            rt(ue(Br, { class: "d-risk-disclaimer__text" }, {
              default: Se(() => [
                ue(Tt, {
                  text: e.model.text
                }, null, 8, ["text"])
              ]),
              _: 1
            }, 512), [
              [xn, !l.value]
            ])
          ])
        ]),
        _: 1
      })
    ])) : te("", !0);
  }
});
const Bme = /* @__PURE__ */ Fe(Ome, [["__scopeId", "data-v-632c504c"]]), Eme = {
  key: 0,
  class: "d-header-search"
}, T1 = 3, Dme = /* @__PURE__ */ Be({
  __name: "HeaderSearch",
  props: {
    model: {
      type: Object,
      required: !0
    },
    searchOptions: {
      type: Object,
      required: !0
    },
    show: {
      type: Boolean,
      default: !1
    },
    result: {
      type: Object,
      default: null
    }
  },
  emits: [
    "submit",
    "search",
    "clear",
    "typing",
    "show-changed"
  ],
  setup(e, { emit: t }) {
    const n = e, { t: i } = Je(), o = ge(), a = ge(""), r = ge(0), s = t;
    it(async () => {
      await mt(), o.value?.focusInput();
    });
    const l = (v) => {
      a.value = v, s("search", v);
    }, d = (v) => {
      v.length < T1 && g(), s("typing", v);
    }, y = () => {
      a.value = "", s("clear");
    }, u = Te(() => n.searchOptions.searchPattern.replace(
      "{searchTerm}",
      encodeURIComponent(a.value)
    )), m = async (v) => {
      s("submit", v), a.value = v, Ue && window.open(u.value, "_self");
    }, h = Te(() => ({
      contentUrl: "",
      title: i("globalTranslations.submit"),
      text: "",
      isLocked: !1,
      target: "_self",
      isExternal: !1,
      linkType: yt.Default,
      tealiumTrackingModel: {
        eventSource: Qe().pageName,
        eventComponentName: "Search",
        eventTitle: "Performed",
        eventTarget: a.value
      }
    })), c = Te(() => ({
      placeholder: n.model.inputPlaceholderText,
      searchTerm: a.value,
      submitLinkModel: h.value
    })), g = () => {
      r.value = 0;
    };
    return qe(
      () => n.show,
      async (v) => {
        v && (o.value?.focusInput(), s("show-changed", v));
      },
      { immediate: !0 }
    ), (v, P) => e.model && e.show ? (E(), X("div", Eme, [
      ue(kh, {
        ref_key: "searchBarRef",
        ref: o,
        model: c.value,
        result: e.result,
        "min-length": T1,
        "is-suppress-open-new-window-on-enter": !1,
        "use-custom-clicks": !1,
        "live-search": !1,
        "block-empty-enter-search": !1,
        "show-always": !0,
        "label-for": _(i)("globalTranslations.search"),
        onEnter: m,
        onSubmit: m,
        onClear: y,
        onSearch: l,
        onTyping: d
      }, null, 8, ["model", "result", "label-for"])
    ])) : te("", !0);
  }
});
const Rme = /* @__PURE__ */ Fe(Dme, [["__scopeId", "data-v-189a57b6"]]), Nme = {
  key: 0,
  class: "d-login-flyout-content"
}, $me = { class: "d-login-flyout-content__items" }, Fme = {
  key: 0,
  class: "d-login-flyout-content__additional-titles"
}, jme = /* @__PURE__ */ Be({
  __name: "LoginFlyoutContent",
  props: {
    loginItems: {
      type: Object,
      required: !0
    }
  },
  setup(e) {
    return (t, n) => {
      const i = $e("BaseHeading"), o = $e("BaseText");
      return e.loginItems && e.loginItems?.length > 0 ? (E(), X("div", Nme, [
        oe("div", $me, [
          (E(!0), X(Re, null, Ge(e.loginItems, (a) => (E(), X("div", {
            key: a.title,
            class: "d-login-flyout-content__item"
          }, [
            ue(i, {
              "base-heading-type": _(ze).H2LooksLikeH3,
              class: "d-login-flyout-content__header"
            }, {
              default: Se(() => [
                Ve(Ie(a.title), 1)
              ]),
              _: 2
            }, 1032, ["base-heading-type"]),
            a.subTitle || a.shortTitle ? (E(), X("div", Fme, [
              a.subTitle ? (E(), fe(o, {
                key: 0,
                text: a.subTitle,
                class: "d-login-flyout-content__sub-title"
              }, null, 8, ["text"])) : te("", !0),
              a.shortTitle ? (E(), fe(o, {
                key: 1,
                text: a.shortTitle,
                class: "d-login-flyout-content__short-title"
              }, null, 8, ["text"])) : te("", !0)
            ])) : te("", !0),
            ue(o, {
              text: a.description,
              class: "d-login-flyout-content__description"
            }, null, 8, ["text"]),
            ue(vt, {
              "link-model": a.loginLink,
              type: _(Ke).Primary,
              size: _(et).Small,
              "button-type": _(zt).Link,
              "icon-position": _(ct).Left,
              icon: _(H).User,
              class: "d-login-flyout-content__button"
            }, null, 8, ["link-model", "type", "size", "button-type", "icon-position", "icon"])
          ]))), 128))
        ])
      ])) : te("", !0);
    };
  }
});
const Hme = /* @__PURE__ */ Fe(jme, [["__scopeId", "data-v-15218f95"]]), zme = ["src", "alt"], Vme = ["aria-label"], Gme = {
  class: "d-header__navigation__wrapper",
  "data-outside-click": !0
}, Ume = {
  key: 1,
  class: "d-header__logo-container"
}, Wme = /* @__PURE__ */ Be({
  __name: "Header",
  props: {
    model: {
      type: Object,
      required: !0
    }
  },
  emits: [
    "audience-changed",
    "culture-changed",
    "search",
    "search-clear",
    "search-typing",
    "search-show-changed"
  ],
  setup(e, { emit: t }) {
    const n = e, i = t, { t: o } = Je(), { setHeader: a } = Fn(), { isSmallerXlAsync: r } = xt(), s = ge(null), l = ge(!1), d = ge(null), y = ge(null), u = ge(!1), m = ge(null), h = ge(null), c = ge(0), g = ge(null), v = Te(() => ({
      ...n.model?.logo?.image,
      src: r.value ? n.model?.logo?.mobileSrc : n.model?.logo?.image?.src
    })), P = Te(() => ({
      link: null,
      items: n?.model?.iconList?.moreIcon?.furtherItems
    })), f = (I) => {
      i("search", I);
    }, S = () => {
      i("search-clear");
    }, w = (I) => {
      i("search-typing", I);
    }, x = (I) => {
      i("search-show-changed", I);
    }, k = Te(() => L(m.value, h.value)), A = (I) => {
      n?.model?.iconList?.audienceIcon?.audience?.items?.forEach((R) => {
        R.isActive = R?.id === m?.value?.id;
      }), i("audience-changed", I, m.value, h.value);
    }, $ = (I, R) => {
      I?.preventDefault(), m.value = R, !R?.disclaimerText || r?.value ? A(I) : u.value = !0;
    }, j = (I, R) => {
      h.value = R, i("culture-changed", R);
    }, N = (I) => {
      A(I), u.value = !1;
    }, M = () => {
      T(), u.value = !1;
    }, D = () => {
      l.value = !1, d.value = null, y.value = null;
    }, C = async (I, R, Y) => {
      Y(), I.value === R ? l.value = !l.value : (await B(), l.value = !0), I.value = l.value ? R : null;
    }, b = (I) => {
      C(d, I, () => {
        y.value = null;
      });
    }, p = (I, R) => {
      C(y, I, () => {
        d.value = null;
      }), g.value = R;
    }, L = (I, R) => I && R ? `${R?.link?.text} / ${I?.link?.text}` : I ? I?.link?.text : R ? R?.link?.text : "";
    qe(r, () => {
      const I = r?.value, R = [pt.Audience, pt.More];
      I ? (d?.value && (d.value = null), R.includes(y?.value) && (y.value = null)) : y?.value === pt.MoreMobile && (y.value = null), d?.value === null && y?.value === null && (l.value = !1);
    }), qe(
      () => k.value,
      (I) => {
        n.model.iconList.audienceIcon.tooltipText = I;
      }
    ), qe(l, (I) => {
      I ? Ue && (document.body.style.overflow = "hidden") : Ue && (document.body.style.overflow = "");
    }), it(() => {
      T(), a(s?.value), Ue && window.addEventListener("scroll", O);
    }), sn(() => {
      Ue && window.removeEventListener("scroll", O);
    });
    const B = async () => {
      l.value = !1, await mt(), l.value = !0;
    }, T = () => {
      n?.model?.iconList?.audienceIcon?.culture?.items?.forEach((I) => {
        I?.isActive && (h.value = I);
      }), n?.model?.iconList?.audienceIcon?.audience?.items?.forEach((I) => {
        I?.isActive && (m.value = I);
      });
    }, O = () => {
      if (!s?.value)
        return;
      const I = window.scrollY;
      I < c.value && I !== 0 ? s.value.classList.add("d-header--fixed-on-up") : s.value.classList.remove("d-header--fixed-on-up"), c.value = I;
    };
    return (I, R) => (E(), X(Re, null, [
      oe("img", {
        src: e.model?.logo?.printSrc || e.model?.logo?.image?.src,
        alt: e.model?.logo?.image?.alt,
        class: "d-header__print-logo"
      }, null, 8, zme),
      e.model ? (E(), X("div", {
        key: 0,
        ref_key: "headerRef",
        ref: s,
        class: "d-header"
      }, [
        oe("div", {
          class: "d-header__navigation container",
          role: "navigation",
          "data-outside-click": !0,
          "aria-label": _(o)("header.main")
        }, [
          oe("div", Gme, [
            je(I.$slots, "logo", {}, () => [
              e.model?.logo?.link ? (E(), fe(_(ot), {
                key: 0,
                class: "d-header__logo-container",
                "link-model": e.model?.logo?.link
              }, {
                content: Se(() => [
                  e.model?.logo?.image ? (E(), fe(_(di), {
                    key: 0,
                    class: "d-header__logo",
                    model: v.value,
                    "aspect-ratio": _(on).None
                  }, null, 8, ["model", "aspect-ratio"])) : te("", !0)
                ]),
                _: 1
              }, 8, ["link-model"])) : (E(), X("div", Ume, [
                e.model?.logo?.image ? (E(), fe(_(di), {
                  key: 0,
                  class: "d-header__logo",
                  model: v.value,
                  "aspect-ratio": _(on).None
                }, null, 8, ["model", "aspect-ratio"])) : te("", !0)
              ]))
            ], !0),
            je(I.$slots, "itemList", {}, () => [
              e.model?.itemList && !_(r) ? (E(), fe(_(mte), {
                key: 0,
                model: e.model?.itemList,
                "active-item-text": d.value?.link?.text,
                onClick: b
              }, null, 8, ["model", "active-item-text"])) : te("", !0)
            ], !0)
          ]),
          je(I.$slots, "iconList", {}, () => [
            e.model?.iconList ? (E(), fe(dte, {
              key: 0,
              model: e.model?.iconList,
              "active-icon-key": y.value,
              "has-items": e.model?.itemList?.length > 0,
              onClick: p
            }, null, 8, ["model", "active-icon-key", "has-items"])) : te("", !0)
          ], !0)
        ], 8, Vme),
        ue(_(Ng), {
          "show-flyout": l.value,
          type: _(yr).Header,
          "default-padding": y.value !== null && y.value !== _(pt).MoreMobile,
          "use-close-button": !_(r),
          "full-width": y.value === _(pt).MoreMobile,
          "extra-focusable-element": g.value,
          "use-backdrop": !0,
          "append-to": ".d-header",
          onClose: D
        }, {
          default: Se(() => [
            d.value ? (E(), fe(_(k0), {
              key: 0,
              model: d.value
            }, null, 8, ["model"])) : te("", !0),
            y.value === _(pt).Search && e.model?.iconList?.searchIcon?.headerSearch ? (E(), fe(Rme, {
              key: 1,
              class: "d-header__search",
              show: y.value === _(pt).Search,
              model: e.model?.iconList?.searchIcon?.headerSearch,
              "search-options": e.model?.iconList?.searchIcon?.searchOptions,
              result: e.model?.iconList?.searchIcon?.result,
              onSearch: f,
              onClear: S,
              onTyping: w,
              onShowChanged: x
            }, null, 8, ["show", "model", "search-options", "result"])) : te("", !0),
            y.value === _(pt).Audience ? (E(), fe(Dg, {
              key: 2,
              audience: e.model?.iconList?.audienceIcon?.audience,
              culture: e.model?.iconList?.audienceIcon?.culture,
              "image-options": e.model?.iconList?.audienceIcon?.imageOptions,
              onAudienceChanged: $,
              onCultureChanged: j
            }, null, 8, ["audience", "culture", "image-options"])) : te("", !0),
            y.value === _(pt).Login && e.model?.iconList?.loginIcon?.content ? (E(), fe(_(Hme), {
              key: 3,
              "login-items": e.model?.iconList?.loginIcon?.content
            }, null, 8, ["login-items"])) : te("", !0),
            y.value === _(pt).More && P.value ? (E(), fe(_(k0), {
              key: 4,
              class: "d-header__more",
              model: P.value,
              "show-arrows": !1
            }, null, 8, ["model"])) : te("", !0),
            y.value === _(pt).MoreMobile && e.model ? (E(), fe(_(Zee), {
              key: 5,
              model: e.model,
              onAudienceChanged: $,
              onCultureChanged: j
            }, null, 8, ["model"])) : te("", !0)
          ]),
          _: 1
        }, 8, ["show-flyout", "type", "default-padding", "use-close-button", "full-width", "extra-focusable-element"]),
        u.value ? (E(), fe(Rg, {
          key: 0,
          model: {
            audience: m.value?.link?.text,
            disclaimerText: m.value?.disclaimerText,
            showModal: u.value
          },
          "append-to": e.model?.iconList?.audienceIcon?.modalAppendTo,
          onAccept: N,
          onCancel: M,
          onClose: M
        }, null, 8, ["model", "append-to"])) : te("", !0)
      ], 512)) : te("", !0)
    ], 64));
  }
});
const zT = /* @__PURE__ */ Fe(Wme, [["__scopeId", "data-v-eed89240"]]), Yme = /* @__PURE__ */ Be({
  __name: "AudienceCultureSelectionButton",
  props: {
    text: {
      type: String,
      default: ""
    },
    isExpanded: {
      type: Boolean,
      required: !1,
      default: !1
    }
  },
  emits: ["click"],
  setup(e, { emit: t }) {
    const n = e, { pageName: i } = Qe(), o = t, { t: a } = Je(), r = (d) => {
      o("click", d);
    }, s = () => ({
      contentUrl: "",
      title: l(),
      text: n.text,
      isLocked: !1,
      target: "",
      isExternal: !1,
      linkType: yt.Javascript,
      tealiumTrackingModel: {
        eventSource: i,
        eventComponentName: "AudienceCultureSelection",
        eventTitle: "Change Audience/Culture"
      }
    }), l = () => n.text.includes("/") ? a("footer.changeAudienceAndCulture") : a("footer.changeCulture");
    return (d, y) => (E(), X("div", {
      class: "d-audience-culture-selection-button",
      onClick: r
    }, [
      ue(_t, {
        "base-icon": _(H).GlobeEurope,
        "base-icon-size": _(at).Inherit,
        "base-icon-color": _(gt).White,
        class: "d-audience-culture-selection-button__icon"
      }, null, 8, ["base-icon", "base-icon-size", "base-icon-color"]),
      ue(vt, {
        "link-model": s(),
        type: _(Ke).Primary,
        size: _(et).Medium,
        "icon-position": _(ct).Right,
        icon: _(H).AngleDown,
        "aria-expanded": e.isExpanded,
        class: "d-audience-culture-selection-button__button"
      }, null, 8, ["link-model", "type", "size", "icon-position", "icon", "aria-expanded"])
    ]));
  }
});
const qme = /* @__PURE__ */ Fe(Yme, [["__scopeId", "data-v-2ae6c018"]]), Kme = {
  key: 0,
  class: "d-audience-culture-selection"
}, Xme = /* @__PURE__ */ Be({
  __name: "AudienceCultureSelection",
  props: {
    model: {
      type: Object,
      required: !0
    },
    appendTo: {
      type: String,
      default: "#dx-overlay"
    },
    active: {
      type: Boolean,
      default: !1
    }
  },
  emits: [
    "click",
    "audience-changed",
    "text-changed",
    "flyout-closed"
  ],
  setup(e, { emit: t }) {
    const n = e, i = t, o = ge(null), a = ge(null), r = ge(null), s = ge(!1), l = ge(!1), d = ge(n.active), y = (x, k) => {
      o.value = k, n.model?.audience?.items?.forEach((A) => {
        A.isActive = A?.id === k?.id;
      }), i("audience-changed", x, o.value, r.value);
    }, u = () => S(o.value, r.value), m = () => {
      i("click", n.model);
    }, h = (x, k) => {
      x.preventDefault(), k.disclaimerText ? (a.value = k, s.value = !0) : y(x, k);
    }, c = (x, k) => {
      r.value = k;
    }, g = (x) => {
      s.value = !1, l.value = !0, a.value && (y(x, a.value), a.value = null);
    }, v = () => {
      s.value = !1, d.value = !0, a.value = null;
    }, P = () => {
      d.value = !1, i("flyout-closed");
    }, f = () => {
      r.value = n.model.culture?.items?.find((x) => x.isActive) || null, o.value = n.model.audience?.items?.find((x) => x.isActive) || null;
    };
    function S(x, k) {
      return x && k ? `${k?.link?.text} / ${x?.link?.text}` : x?.link?.text || k?.link?.text || "";
    }
    const w = Te(u);
    return it(() => {
      f(), u();
    }), qe(
      () => n.active,
      (x) => {
        d.value = x;
      }
    ), (x, k) => e.model ? (E(), X("div", Kme, [
      ue(qme, {
        text: w.value,
        class: Pe({ "d-audience-culture-selection-button--active": d.value }),
        "is-expanded": d.value,
        onClick: m
      }, null, 8, ["text", "class", "is-expanded"]),
      ue(Ng, {
        "show-flyout": d.value,
        "append-to": e.appendTo,
        "modal-append-to": e.model.modalAppendTo,
        type: _(yr).Footer,
        "use-backdrop": !0,
        onClose: k[0] || (k[0] = (A) => P())
      }, {
        default: Se(() => [
          ue(Dg, {
            audience: e.model.audience,
            culture: e.model.culture,
            "image-options": e.model.imageOptions,
            onAudienceChanged: h,
            onCultureChanged: c
          }, null, 8, ["audience", "culture", "image-options"])
        ]),
        _: 1
      }, 8, ["show-flyout", "append-to", "modal-append-to", "type"]),
      s.value ? (E(), fe(Rg, {
        key: 0,
        model: {
          audience: a.value?.link.text || o.value?.link.text,
          disclaimerText: a.value?.disclaimerText || o.value?.disclaimerText,
          showModal: s.value
        },
        "append-to": e.model.modalAppendTo,
        onAccept: g,
        onCancel: v,
        onClose: v
      }, null, 8, ["model", "append-to"])) : te("", !0)
    ])) : te("", !0);
  }
});
const Zme = /* @__PURE__ */ Fe(Xme, [["__scopeId", "data-v-610d9b8a"]]), Jme = {
  key: 0,
  class: "d-contact-flyout-content"
}, Qme = /* @__PURE__ */ Be({
  __name: "ContactFlyoutContent",
  props: {
    model: {
      type: Object,
      required: !0
    }
  },
  setup(e) {
    return (t, n) => {
      const i = $e("BaseHeading"), o = $e("BaseText");
      return e.model ? (E(), X("div", Jme, [
        (E(!0), X(Re, null, Ge(e.model, (a, r) => (E(), X("div", {
          key: a.headline + r,
          class: "d-contact-flyout-content__item"
        }, [
          ue(i, {
            "base-heading-type": _(ze).H3,
            class: "d-contact-flyout-content__header"
          }, {
            default: Se(() => [
              Ve(Ie(a.headline), 1)
            ]),
            _: 2
          }, 1032, ["base-heading-type"]),
          (E(!0), X(Re, null, Ge(a.items, (s, l) => (E(), X("div", {
            key: s.title + l,
            class: "d-contact-flyout-content__item__content"
          }, [
            ue(i, {
              "base-heading-type": _(ze).StyledAsH3,
              class: "d-contact-flyout-content__item__content__title"
            }, {
              default: Se(() => [
                Ve(Ie(s.title), 1)
              ]),
              _: 2
            }, 1032, ["base-heading-type"]),
            s.subtitle ? (E(), fe(i, {
              key: 0,
              "base-heading-type": _(ze).StyledAsH4,
              class: "d-contact-flyout-content__item__content__subtitle"
            }, {
              default: Se(() => [
                Ve(Ie(s.subtitle), 1)
              ]),
              _: 2
            }, 1032, ["base-heading-type"])) : te("", !0),
            s.additionalInfo ? (E(), fe(o, {
              key: 1,
              text: s.additionalInfo,
              class: "d-contact-flyout-content__item__content__additional-info"
            }, null, 8, ["text"])) : te("", !0),
            s.number ? (E(), fe(ot, {
              key: 2,
              "link-model": s.number,
              icon: _(H).Phone,
              "icon-position": _(ct).Left,
              "font-size": _(yn).TwentyFourPx,
              class: "d-contact-flyout-content__item__content__number"
            }, null, 8, ["link-model", "icon", "icon-position", "font-size"])) : te("", !0),
            s.timings ? (E(), fe(o, {
              key: 3,
              text: s.timings,
              class: "d-contact-flyout-content__item__content__timings grey-text"
            }, null, 8, ["text"])) : te("", !0),
            s.email ? (E(), fe(ot, {
              key: 4,
              "link-model": s.email,
              icon: _(H).Envelope,
              "icon-position": _(ct).Left,
              class: "d-contact-flyout-content__item__content__email"
            }, null, 8, ["link-model", "icon", "icon-position"])) : te("", !0),
            s.contactUsMessage ? (E(), fe(o, {
              key: 5,
              text: s.contactUsMessage,
              class: "d-contact-flyout-content__item__content__contact-us-message grey-text"
            }, null, 8, ["text"])) : te("", !0)
          ]))), 128))
        ]))), 128))
      ])) : te("", !0);
    };
  }
});
const VT = /* @__PURE__ */ Fe(Qme, [["__scopeId", "data-v-67c33d59"]]), ege = /* @__PURE__ */ Be({
  __name: "ContactFlyoutButton",
  props: {
    isExpanded: {
      type: Boolean,
      required: !1,
      default: !1
    }
  },
  emits: ["click"],
  setup(e, { expose: t, emit: n }) {
    const { t: i } = Je(), { pageName: o } = Qe(), a = n, r = ge(
      null
    ), s = (d) => {
      a("click", d);
    }, l = () => ({
      contentUrl: "",
      title: i("footer.showContactInformation"),
      text: i("footer.contact"),
      isLocked: !1,
      target: "",
      isExternal: !1,
      linkType: yt.Javascript,
      tealiumTrackingModel: {
        eventSource: o,
        eventComponentName: "Footer Contact Button",
        eventTitle: "Footer Contact Button"
      }
    });
    return t({
      buttonRef: r
    }), (d, y) => (E(), X("div", {
      class: "d-contact-flyout-button",
      onClick: s
    }, [
      ue(vt, {
        ref_key: "buttonRef",
        ref: r,
        "link-model": l(),
        type: _(Ke).Primary,
        size: _(et).Medium,
        icon: _(H).IdCard,
        "icon-position": _(ct).Left,
        "aria-expanded": e.isExpanded,
        class: "d-contact-flyout-button__button"
      }, null, 8, ["link-model", "type", "size", "icon", "icon-position", "aria-expanded"])
    ]));
  }
});
const tge = /* @__PURE__ */ Fe(ege, [["__scopeId", "data-v-52faa48b"]]), nge = {
  key: 0,
  class: "d-contact-flyout"
}, ige = /* @__PURE__ */ Be({
  __name: "ContactFlyout",
  props: {
    information: {
      type: Array,
      required: !0
    },
    appendTo: {
      type: String,
      default: "#dx-overlay"
    },
    modalAppendTo: {
      type: String,
      default: "#dx-overlay"
    },
    active: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["flyout-closed", "contact-flyout-button-click"],
  setup(e, { expose: t, emit: n }) {
    const i = e, o = n, a = ge(null), r = () => {
      o("contact-flyout-button-click", i.information);
    }, s = () => {
      o("flyout-closed");
    };
    return t({
      contactFlyoutButtonRef: a
    }), (l, d) => (E(), X(Re, null, [
      e.information ? (E(), X("div", nge, [
        ue(tge, {
          ref_key: "contactFlyoutButtonRef",
          ref: a,
          class: Pe({ "d-contact-flyout__button--active": e.active }),
          "is-expanded": e.active,
          onClick: r
        }, null, 8, ["class", "is-expanded"])
      ])) : te("", !0),
      ue(Ng, {
        "show-flyout": e.active,
        "append-to": e.appendTo,
        "modal-append-to": e.modalAppendTo,
        type: _(yr).Footer,
        "use-backdrop": !0,
        onClose: d[0] || (d[0] = (y) => s())
      }, {
        default: Se(() => [
          ue(VT, { model: e.information }, null, 8, ["model"])
        ]),
        _: 1
      }, 8, ["show-flyout", "append-to", "modal-append-to", "type"])
    ], 64));
  }
});
const age = /* @__PURE__ */ Fe(ige, [["__scopeId", "data-v-5644c405"]]), oge = {
  key: 0,
  class: "d-footer-top__culture-switch",
  "data-outside-click": !0
}, rge = {
  class: "d-footer-top__right-section",
  "data-outside-click": !0
}, sge = {
  class: "d-footer-top__right-section__contact-and-newsletter",
  "data-outside-click": !0
}, lge = {
  key: 0,
  class: "d-footer-top__right-section__contact-and-newsletter__contact",
  "data-outside-click": !0
}, cge = {
  key: 1,
  class: "d-footer-top__right-section__contact-and-newsletter__newsletter",
  "data-outside-click": !0
}, dge = {
  class: "d-footer-top__right-section__social-media",
  "data-outside-click": !0
}, uge = /* @__PURE__ */ Be({
  __name: "FooterTop",
  props: {
    model: {
      type: Object,
      required: !0
    },
    footerRef: {
      type: Object,
      default: null
    }
  },
  emits: ["audience-changed"],
  setup(e, { expose: t, emit: n }) {
    const i = e, o = ge(), a = ge(), r = ge(null), s = ge(), l = ge(null), d = ge(null);
    it(async () => {
      await mt(), pn({
        trigger: o?.value?.$el,
        content: i.model.newsletterTooltip,
        appendTo: i.footerRef ? i.footerRef : "parent",
        showOnTouchDevices: !1,
        field: () => o?.value?.$el
      });
    });
    const y = () => ({
      ...i.model.newsletter,
      tealiumTrackingModel: {
        eventSource: Qe().pageName,
        eventComponentName: "button",
        eventTitle: i.model.newsletter?.title,
        eventTarget: i.model.newsletter?.contentUrl
      }
    }), u = n, m = (P, f, S) => {
      u("audience-changed", P, f, S);
    }, h = () => {
      r.value = null;
    }, c = () => {
      r.value = r?.value === "audienceCultureSelection" ? null : "audienceCultureSelection";
    }, g = () => {
      r.value = r?.value === "contact" ? null : "contact";
    }, v = () => {
      Ue && (l.value = document.activeElement), d.value?.contactFlyoutButtonRef?.buttonRef?.$el?.focus(), r.value = "contact";
    };
    return qe(r, (P) => {
      setTimeout(() => {
        P === null && l.value && (l.value.focus(), l.value = null);
      }, 1);
    }), t({
      openContactFlyout: v
    }), (P, f) => (E(), X(Re, null, [
      e.model ? (E(), X("div", {
        key: 0,
        ref_key: "footerTop",
        ref: a,
        class: Pe(["d-footer-top", { "d-footer-top--active": r.value }])
      }, [
        ue(Vt, {
          id: "footer-top",
          "data-outside-click": !0,
          "no-margin-bottom": !0
        }, {
          default: Se(() => [
            oe("div", {
              class: Pe(["d-footer-top__container", {
                "d-footer-top__container--end": !e.model?.audienceCultureSelection
              }]),
              "data-outside-click": !0
            }, [
              e.model?.audienceCultureSelection ? (E(), X("div", oge, [
                ue(Zme, {
                  model: e.model?.audienceCultureSelection,
                  active: r.value === "audienceCultureSelection",
                  "append-to": "#flyoutAfterFooterTop",
                  onFlyoutClosed: h,
                  onAudienceChanged: m,
                  onClick: c
                }, null, 8, ["model", "active"])
              ])) : te("", !0),
              oe("div", rge, [
                oe("div", sge, [
                  e.model.contact ? (E(), X("div", lge, [
                    ue(age, {
                      ref_key: "contactFlyoutRef",
                      ref: d,
                      information: e.model.contact,
                      "append-to": "#flyoutAfterFooterTop",
                      active: r.value === "contact",
                      "modal-append-to": e.model.modalAppendTo,
                      onFlyoutClosed: h,
                      onContactFlyoutButtonClick: g
                    }, null, 8, ["information", "active", "modal-append-to"])
                  ])) : te("", !0),
                  e.model?.newsletter ? (E(), X("div", cge, [
                    ue(ot, {
                      ref_key: "newsletterRef",
                      ref: o,
                      "link-model": y(),
                      "font-size": _(yn).FourteenPx,
                      "font-type": _(ya).DwsBold,
                      icon: _(H).EnvelopeOpenText,
                      "icon-color": _(gt).White,
                      "icon-position": _(ct).Left,
                      "stop-propagation": !0
                    }, null, 8, ["link-model", "font-size", "font-type", "icon", "icon-color", "icon-position"])
                  ])) : te("", !0)
                ]),
                oe("div", dge, [
                  ue(pT, {
                    model: e.model.socialMedia,
                    "button-type": _(Du).FooterStyle,
                    "footer-ref": e.footerRef,
                    "data-outside-click": !0
                  }, null, 8, ["model", "button-type", "footer-ref"])
                ])
              ])
            ], 2)
          ]),
          _: 1
        })
      ], 2)) : te("", !0),
      ue(VT, {
        class: "d-footer-top__print-contact-flyout",
        model: e.model.contact
      }, null, 8, ["model"]),
      oe("div", {
        id: "flyoutAfterFooterTop",
        ref_key: "flyoutAfterFooterTop",
        ref: s
      }, null, 512)
    ], 64));
  }
});
const hge = /* @__PURE__ */ Fe(uge, [["__scopeId", "data-v-7929856d"]]), pge = {
  key: 0,
  class: "d-footer-sitemap"
}, fge = { class: "d-footer-sitemap__container" }, mge = { class: "d-footer-sitemap__logo" }, gge = ["href", "target", "data-event_source", "data-event_target"], vge = ["src", "alt"], yge = { class: "d-footer-sitemap__menu" }, bge = ["aria-label"], xge = /* @__PURE__ */ Be({
  __name: "FooterSitemap",
  props: {
    model: {
      type: Object,
      required: !0
    }
  },
  setup(e) {
    const { isMobile: t } = xt(), n = (i, o) => {
      if (o == 2)
        return i.isExternal ? H.ExternalLinkAlt : H.Link;
    };
    return (i, o) => {
      const a = $e("BaseHeading");
      return e.model ? (E(), X("div", pge, [
        ue(Vt, {
          id: "footer-sitemap",
          "no-margin-bottom": !0
        }, {
          default: Se(() => [
            oe("div", fge, [
              oe("div", mge, [
                oe("a", {
                  class: "d-footer-sitemap__logo__link",
                  href: e.model.logo.startPageUrl,
                  target: e.model?.logo?.target || "_self",
                  "data-event_source": _(Qe)().pageName,
                  "data-event_component_name": "Footer",
                  "data-event_title": "Footer Home::Slogan",
                  "data-event_target": e.model.logo.startPageUrl
                }, [
                  oe("img", {
                    src: _(t) ? e.model.logo.smallLogo : e.model.logo.fullLogo,
                    alt: e.model.logo.legalEntity
                  }, null, 8, vge)
                ], 8, gge)
              ]),
              oe("div", yge, [
                (E(!0), X(Re, null, Ge(e.model.sitemapItems, (r, s) => (E(), X("div", {
                  key: r.groupTitle,
                  class: "d-footer-sitemap__menu__item"
                }, [
                  ue(a, {
                    "base-heading-type": _(ze).H2
                  }, {
                    default: Se(() => [
                      Ve(Ie(r.groupTitle), 1)
                    ]),
                    _: 2
                  }, 1032, ["base-heading-type"]),
                  oe("ul", {
                    class: "d-footer-sitemap__menu__item__list",
                    "aria-label": r.groupTitle
                  }, [
                    (E(!0), X(Re, null, Ge(r.links, (l) => (E(), X("li", {
                      key: l.title
                    }, [
                      ue(ot, {
                        "link-model": {
                          ...l,
                          tealiumTrackingModel: {
                            eventSource: _(Qe)().pageName,
                            eventComponentName: "Footer",
                            eventTitle: l.title,
                            eventTarget: l.contentUrl,
                            eventLinkType: s == 2 ? l.isExternal ? "External" : "Internal" : ""
                          }
                        },
                        icon: n(l, s),
                        "icon-position": _(ct).Left
                      }, null, 8, ["link-model", "icon", "icon-position"])
                    ]))), 128))
                  ], 8, bge)
                ]))), 128))
              ])
            ])
          ]),
          _: 1
        })
      ])) : te("", !0);
    };
  }
});
const wge = /* @__PURE__ */ Fe(xge, [["__scopeId", "data-v-49de8489"]]), kge = {
  key: 0,
  class: "d-footer-bottom"
}, Sge = ["aria-label"], Cge = /* @__PURE__ */ Be({
  __name: "FooterBottom",
  props: {
    model: {
      type: Object,
      required: !0
    }
  },
  setup(e) {
    const { t } = Je();
    return (n, i) => e.model && e.model.length > 0 ? (E(), X("div", kge, [
      ue(Vt, {
        id: "footer-bottom",
        "no-margin-bottom": !0
      }, {
        default: Se(() => [
          oe("ul", {
            class: "d-footer-bottom__links",
            "aria-label": _(t)("footer.legalAndPolicyLinks")
          }, [
            (E(!0), X(Re, null, Ge(e.model, (o) => (E(), X("li", {
              key: o.title
            }, [
              ue(ot, {
                "link-model": {
                  ...o,
                  tealiumTrackingModel: {
                    eventSource: _(Qe)().pageName,
                    eventComponentName: "Footer",
                    eventTitle: o.title,
                    eventTarget: o.contentUrl
                  }
                },
                "font-size": _(yn).SixteenPx,
                "font-type": _(ya).DwsRegular,
                class: "d-footer-bottom__links__link"
              }, null, 8, ["link-model", "font-size", "font-type"])
            ]))), 128))
          ], 8, Sge)
        ]),
        _: 1
      })
    ])) : te("", !0);
  }
});
const Tge = /* @__PURE__ */ Fe(Cge, [["__scopeId", "data-v-61213ffa"]]), Lge = {
  key: 1,
  class: "d-footer__page-disclaimer"
}, Ige = {
  key: 2,
  class: "d-footer__site-disclaimer"
}, Pge = /* @__PURE__ */ Be({
  __name: "Footer",
  props: {
    model: {
      type: Object,
      required: !0
    }
  },
  emits: ["audience-changed"],
  setup(e, { expose: t, emit: n }) {
    const i = e, o = ge(), a = ge(), { currentLocale: r } = Je(), { referenceItems: s } = Cm(Xi()), { getReferencesByComponentId: l } = Xi(), d = Xi(), y = Te(() => i?.model?.footnoteType === Oi.None ? !1 : i?.model?.footnoteType === Oi.ComponentId ? Object.keys(l(i?.model?.footnoteComponentId))?.length > 0 : Object.keys(s.value)?.length > 0), u = Te(() => r.value ? r.value : "en"), m = n, h = (g, v, P) => {
      m("audience-changed", g, v, P);
    };
    return t({
      openContactFlyout: () => {
        a.value?.openContactFlyout();
      }
    }), (g, v) => e.model ? (E(), X("div", {
      key: 0,
      ref_key: "footerRef",
      ref: o,
      class: "d-footer"
    }, [
      y.value && _(d)?.referencesCount ? (E(), fe(Vt, {
        key: 0,
        id: "footer-footnote-list",
        "content-in-full-width": e.model?.showFootnotesFullWidth,
        "no-margin-bottom": !0,
        class: "d-footer__footnotes"
      }, {
        default: Se(() => [
          ue(_(ro), {
            "component-id": e.model?.footnoteComponentId,
            "footnote-type": e.model?.footnoteType
          }, null, 8, ["component-id", "footnote-type"])
        ]),
        _: 1
      }, 8, ["content-in-full-width"])) : te("", !0),
      e.model.pageDisclaimer && (e.model.pageDisclaimer.pageDisclaimerText?.length > 0 || e.model.pageDisclaimer?.complianceCodes) ? (E(), X("div", Lge, [
        ue(Vt, {
          id: "footer-page-disclaimer",
          "no-margin-bottom": !0
        }, {
          default: Se(() => [
            ue(jae, {
              "page-disclaimer": e.model.pageDisclaimer.pageDisclaimerText,
              "compliance-codes": e.model.pageDisclaimer?.complianceCodes,
              "culture-active": u.value
            }, null, 8, ["page-disclaimer", "compliance-codes", "culture-active"])
          ]),
          _: 1
        })
      ])) : te("", !0),
      oe("footer", null, [
        ue(hge, {
          ref_key: "footerTop",
          ref: a,
          model: e.model.footerTop,
          "footer-ref": o.value,
          onAudienceChanged: h
        }, null, 8, ["model", "footer-ref"]),
        e.model.footerSitemap ? (E(), fe(wge, {
          key: 0,
          model: e.model.footerSitemap
        }, null, 8, ["model"])) : te("", !0),
        ue(Tge, {
          model: e.model.footerBottom
        }, null, 8, ["model"])
      ]),
      e.model.siteDisclaimer && e.model.siteDisclaimer?.length > 0 ? (E(), X("div", Ige, [
        ue(Vt, {
          id: "footer-site-disclaimer",
          "no-margin-bottom": !0
        }, {
          default: Se(() => [
            ue(Na, {
              text: e.model?.siteDisclaimer
            }, null, 8, ["text"])
          ]),
          _: 1
        })
      ])) : te("", !0)
    ], 512)) : te("", !0);
  }
});
const Age = /* @__PURE__ */ Fe(Pge, [["__scopeId", "data-v-fc9deb07"]]), _ge = {
  key: 0,
  class: "d-page-frame"
}, NBe = /* @__PURE__ */ Be({
  __name: "PageFrame",
  props: {
    model: {
      type: Object,
      required: !0
    }
  },
  emits: [
    "audience-changed",
    "culture-changed",
    "search",
    "search-clear",
    "search-typing",
    "search-show-changed",
    "risk-disclaimer-collapsed"
  ],
  setup(e, { expose: t, emit: n }) {
    const i = ge(), o = n, a = (h, c, g) => {
      o("audience-changed", h, c, g);
    }, r = (h) => {
      o("culture-changed", h);
    }, s = (h) => {
      o("search", h);
    }, l = () => {
      o("search-clear");
    }, d = (h) => {
      o("search-typing", h);
    }, y = (h) => {
      o("search-show-changed", h);
    }, u = (h) => {
      o("risk-disclaimer-collapsed", h);
    };
    return t({
      openContactFlyout: () => {
        i.value?.openContactFlyout();
      }
    }), (h, c) => e.model ? (E(), X("div", _ge, [
      e.model?.header ? (E(), fe(_(zT), {
        key: 0,
        model: e.model?.header,
        onAudienceChanged: a,
        onCultureChanged: r,
        onSearch: s,
        onSearchClear: l,
        onSearchTyping: d,
        onSearchShowChanged: y
      }, null, 8, ["model"])) : te("", !0),
      e.model?.riskDisclaimer ? (E(), fe(Bme, {
        key: 1,
        model: e.model?.riskDisclaimer,
        onRiskDisclaimerCollapsed: u
      }, null, 8, ["model"])) : te("", !0),
      e.model?.hideBreadcrumb ? te("", !0) : (E(), fe(_(Vt), {
        key: 2,
        id: "page-frame-breadcrumb",
        "no-margin-bottom": !0
      }, {
        default: Se(() => [
          ue(zg, {
            breadcrumbs: e.model?.breadcrumb?.breadcrumbs,
            "meta-tags": e.model?.breadcrumb?.metaTags,
            "share-class-items": e.model?.breadcrumb?.shareClassItems,
            "has-blue-gradient-background": e.model?.breadcrumb?.hasBlueGradientBackground
          }, null, 8, ["breadcrumbs", "meta-tags", "share-class-items", "has-blue-gradient-background"])
        ]),
        _: 1
      })),
      je(h.$slots, "default"),
      e.model?.footer ? (E(), fe(_(Age), {
        key: 3,
        ref_key: "footerRef",
        ref: i,
        model: e.model?.footer,
        onAudienceChanged: a
      }, null, 8, ["model"])) : te("", !0)
    ])) : te("", !0);
  }
}), $Be = (e) => e ? {
  results: e.Results?.map((n) => ({
    name: n.Name,
    records: n.Records?.map((i) => ({
      link: i.Link,
      title: i.Title,
      productKey: i.ProductKey
    })) || []
  })) || []
} : null, FBe = (e, t) => e ? {
  name: t,
  records: e.results?.map((n) => ({
    link: n.url,
    title: n.title,
    productKey: n.ProductKey
  })) || []
} : null, Mge = { class: "d-content-slider-card__card__header" }, Oge = { class: "d-content-slider-card__card__header__container" }, Bge = {
  key: 0,
  class: "d-content-slider-card__card__header__container__icon"
}, Ege = /* @__PURE__ */ Be({
  __name: "ContentSliderCard",
  props: {
    item: {
      type: Object,
      required: !0
    },
    headlineType: {
      type: String,
      default: ze.StyledAsH3
    },
    iconColor: {
      type: String,
      default: void 0
    }
  },
  emits: ["imageLoaded"],
  setup(e, { expose: t, emit: n }) {
    const i = ge(), o = n;
    function a() {
      o("imageLoaded");
    }
    return t({
      contentSliderCardRef: i
    }), (r, s) => (E(), X("div", {
      ref_key: "contentSliderCardRef",
      ref: i,
      class: "d-content-slider-card"
    }, [
      ue(Th, {
        model: {
          type: _(qi).Text,
          hideCorner: !0,
          backgroundColor: _(Zt).White
        },
        class: "d-content-slider-card__card"
      }, {
        header: Se(() => [
          oe("div", Mge, [
            oe("div", Oge, [
              ue(_(Ot), {
                "base-heading-type": e.headlineType,
                class: "d-content-slider-card__card__header__container__headline"
              }, {
                default: Se(() => [
                  Ve(Ie(e.item.headline), 1)
                ]),
                _: 1
              }, 8, ["base-heading-type"]),
              ue(ht, {
                "html-text": e.item.subHeadline,
                class: "d-content-slider-card__card__header__container__sub-headline"
              }, null, 8, ["html-text"]),
              e.item.icon ? (E(), X("div", Bge, [
                ue(Rh, {
                  model: e.item.icon,
                  "item-marker-color": e.iconColor
                }, null, 8, ["model", "item-marker-color"])
              ])) : te("", !0)
            ]),
            e.item.image ? (E(), fe(di, {
              key: 0,
              model: e.item.image,
              "aspect-ratio": _(on).TwoToOne,
              class: "d-content-slider-card__card__header__image",
              onLoaded: a
            }, null, 8, ["model", "aspect-ratio"])) : te("", !0)
          ])
        ]),
        content: Se(() => [
          ue(ht, {
            "html-text": e.item.contentText,
            class: "d-content-slider-card__card__content-text"
          }, null, 8, ["html-text"])
        ]),
        _: 1
      }, 8, ["model"])
    ], 512));
  }
});
const L1 = /* @__PURE__ */ Fe(Ege, [["__scopeId", "data-v-1ad326da"]]), Dge = {
  key: 0,
  class: "d-content-slider"
}, Rge = { key: 1 }, Nge = { class: "d-content-slider__load-more" }, I1 = 0, $ge = /* @__PURE__ */ Be({
  __name: "ContentSlider",
  props: {
    model: {
      type: Object,
      required: !0
    },
    backgroundType: {
      type: String,
      default: Ph.None
    },
    headlineType: {
      type: String,
      default: ze.H3
    }
  },
  setup(e) {
    const t = e, { t: n } = Je(), { isDesktop: i, isMobileAsync: o } = xt(), a = ge(I1), r = ge(3), s = ge(3), l = async () => {
      a.value = I1, r.value = r.value + s.value;
    }, d = Te(() => t.model.items.slice(
      a.value,
      a.value + r.value
    )), y = ge(Qe().pageName), u = () => ({
      title: n("propertyGallery.loadMore"),
      text: n("propertyGallery.loadMore"),
      contentUrl: "",
      isLocked: !1,
      target: "",
      isExternal: !1,
      linkType: yt.Javascript,
      tealiumTrackingModel: {
        eventComponentName: "Button",
        eventTitle: n("propertyGallery.loadMore"),
        eventSource: y.value
      }
    }), m = Te(() => t.model.items?.length < 3 && i.value ? "wider" : ""), h = ge([]), c = () => {
      fi(() => {
        if (Ue && !o) {
          if (h.value?.length === 1 || h.value?.length === 0 || h.value === void 0)
            return;
          let v = 0;
          h.value?.forEach((P) => {
            v = Math.max(
              v,
              P?.contentSliderCardRef?.offsetHeight
            );
          }), h.value?.forEach((P) => {
            P.contentSliderCardRef.style.height = `${v}px`;
          });
        }
      }, 100);
    };
    it(() => {
      c();
    });
    const { width: g } = Ts();
    return qe(
      () => g.value,
      () => {
        c();
      }
    ), (v, P) => {
      const f = $e("BaseButtonV2");
      return e.model && e.model.items && e.model.items.length > 0 ? (E(), X("div", Dge, [
        _(o) ? te("", !0) : (E(), fe($g, {
          key: 0,
          items: e.model.items,
          "num-visible": _(i) ? 3 : 2,
          "num-scroll": 1,
          "show-buttons": !1,
          "cut-after-ten-items": !0,
          "background-type": e.backgroundType,
          "background-image": e.model.backgroundImage,
          "stretch-items": !0
        }, {
          item: Se((S) => [
            ue(L1, {
              ref: (w) => h.value.push(w),
              "headline-type": e.headlineType,
              item: S.item,
              "icon-color": e.model.iconColor,
              class: Pe(m.value),
              onImageLoaded: P[0] || (P[0] = (w) => c())
            }, null, 8, ["headline-type", "item", "icon-color", "class"])
          ]),
          _: 1
        }, 8, ["items", "num-visible", "background-type", "background-image"])),
        _(o) ? (E(), X("div", Rge, [
          ue(Mh, {
            "background-type": e.backgroundType,
            "background-image": e.model.backgroundImage
          }, {
            default: Se(() => [
              (E(!0), X(Re, null, Ge(d.value, (S, w) => (E(), fe(_(pa), {
                key: S.headline + w
              }, {
                default: Se(() => [
                  ue(L1, {
                    item: S,
                    "icon-color": e.model.iconColor
                  }, null, 8, ["item", "icon-color"])
                ]),
                _: 2
              }, 1024))), 128))
            ]),
            _: 1
          }, 8, ["background-type", "background-image"]),
          oe("div", Nge, [
            d.value?.length < t.model.items?.length && t.model.items?.length > r.value ? (E(), fe(f, {
              key: 0,
              type: _(Ke).Primary,
              size: _(et).Large,
              icon: _(H).AngleDoubleDown,
              "icon-position": _(ct).Right,
              "link-model": u(),
              onClick: l
            }, null, 8, ["type", "size", "icon", "icon-position", "link-model"])) : te("", !0)
          ])
        ])) : te("", !0)
      ])) : te("", !0);
    };
  }
});
const jBe = /* @__PURE__ */ Fe($ge, [["__scopeId", "data-v-d101d842"]]), Fge = {
  key: 0,
  class: "d-audio-module-item"
}, jge = { class: "d-audio-module-item__icon" }, Hge = { class: "d-audio-module-item__content" }, zge = {
  key: 0,
  class: "d-audio-module-item__date"
}, Vge = /* @__PURE__ */ Be({
  __name: "AudioModuleItem",
  props: {
    model: {
      type: Object,
      required: !0
    },
    headlineType: {
      type: String,
      default: ze.H4
    }
  },
  setup(e) {
    return (t, n) => {
      const i = $e("BaseIcon"), o = $e("BaseText"), a = $e("BaseHeading");
      return e.model ? (E(), X("div", Fge, [
        oe("div", jge, [
          ue(i, {
            "base-icon": _(H).Headphones,
            "base-icon-size": _(at).L,
            "base-icon-filled": !0
          }, null, 8, ["base-icon", "base-icon-size"])
        ]),
        oe("div", Hge, [
          e.model.date || e.model.episodeLabel ? (E(), X("div", zge, [
            e.model.episodeLabel ? (E(), fe(o, {
              key: 0,
              text: e.model.episodeLabel,
              "font-size": _(st).TwelvePx,
              "text-color": _(dt).GreyBlue009,
              "font-type": _(lt).DwsSlabBold
            }, null, 8, ["text", "font-size", "text-color", "font-type"])) : te("", !0),
            e.model.episodeLabel ? (E(), fe(o, {
              key: 1,
              text: "|",
              "font-size": _(st).TwelvePx,
              "text-color": _(dt).GreyBlue009,
              "font-type": _(lt).DwsSlabBold
            }, null, 8, ["font-size", "text-color", "font-type"])) : te("", !0),
            e.model.date ? (E(), fe(o, {
              key: 2,
              text: e.model.date,
              "font-size": _(st).TwelvePx,
              "text-color": _(dt).GreyBlue009,
              "font-type": _(lt).DwsSlabBold
            }, null, 8, ["text", "font-size", "text-color", "font-type"])) : te("", !0)
          ])) : te("", !0),
          e.model.headline ? (E(), fe(a, {
            key: 1,
            "base-heading-type": e.headlineType,
            class: "d-audio-module-item__item-headline"
          }, {
            default: Se(() => [
              Ve(Ie(e.model.headline), 1)
            ]),
            _: 1
          }, 8, ["base-heading-type"])) : te("", !0)
        ])
      ])) : te("", !0);
    };
  }
});
const P1 = /* @__PURE__ */ Fe(Vge, [["__scopeId", "data-v-c7b732b7"]]), Gge = { class: "d-audio-module-playlist-header__inner" }, Uge = /* @__PURE__ */ Be({
  __name: "AudioModulePlaylistHeader",
  props: {
    headline: {
      type: String,
      required: !0
    },
    headlineType: {
      type: String,
      default: ze.H3
    },
    length: {
      type: Number,
      required: !0
    },
    itemsLabel: {
      type: String,
      default: ""
    }
  },
  setup(e) {
    const { containerQueriesEnabled: t } = Bi();
    return (n, i) => {
      const o = $e("BaseHeading"), a = $e("BaseText");
      return E(), X("div", {
        class: Pe(["d-audio-module-playlist-header", {
          "d-audio-module-playlist-header--container": _(t),
          "d-audio-module-playlist-header--media": !_(t)
        }])
      }, [
        oe("div", Gge, [
          e.headline ? (E(), fe(o, {
            key: 0,
            "base-heading-type": e.headlineType
          }, {
            default: Se(() => [
              Ve(Ie(e.headline), 1)
            ]),
            _: 1
          }, 8, ["base-heading-type"])) : te("", !0),
          e.length ? (E(), fe(a, {
            key: 1,
            text: `${e.length} ${e.itemsLabel}`,
            "font-size": _(st).TwelvePx,
            "text-color": _(dt).GreyBlue009,
            "font-type": _(lt).DwsSlabBold
          }, null, 8, ["text", "font-size", "text-color", "font-type"])) : te("", !0)
        ])
      ], 2);
    };
  }
});
const A1 = /* @__PURE__ */ Fe(Uge, [["__scopeId", "data-v-8b1c6c2c"]]), Wge = {
  key: 0,
  class: "d-single-audio-module__audio-container"
}, Yge = {
  key: 1,
  class: "d-single-audio-module__image-play-button"
}, qge = {
  key: 1,
  class: "d-single-audio-module__date"
}, Kge = { class: "d-single-audio-module__footer" }, Xge = /* @__PURE__ */ Be({
  __name: "SingleAudioModule",
  props: {
    model: {
      type: Object,
      required: !0
    },
    headlineType: {
      type: String,
      default: ze.H2Section
    },
    stageMode: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["play", "loaded", "ended"],
  setup(e, { expose: t, emit: n }) {
    const i = e, { containerQueriesEnabled: o } = Bi(), { t: a } = Je(), r = n, s = ge(null), l = ge(null), d = ge(i.model.audioPlayerModel?.isAutoPlay || !1), y = ge(!!i.model.image), u = Te(() => i.model.audioPlayerModel?.playerType ? i.model.audioPlayerModel.playerType === Ir.AudioOnly : i.model.audioPlayerModel?.playerId === Lr.AudioOnly), m = Te(() => i.model.audioPlayerModel?.playerType ? i.model.audioPlayerModel.playerType === Ir.AudioWithImage : i.model.audioPlayerModel?.playerId === Lr.AudioWithImage), h = () => ({
      title: a("audioModule.play"),
      text: a("audioModule.play"),
      tealiumTrackingModel: {
        eventSource: Qe().pageName,
        eventComponentName: "SingleVideoModule",
        eventTitle: a("audioModule.play")
      }
    }), c = Te(() => zu(
      i.model?.audioPlayerModel?.videoLengthSeconds ? i.model.audioPlayerModel.videoLengthSeconds : 0,
      !1
    )), g = () => {
      d.value = !0, r("play");
    }, v = () => {
      r("loaded");
    }, P = () => {
      r("ended");
    }, f = async () => {
      d.value = !0, y.value = !1, s.value?.play(), l.value?.play(), r("play");
    }, S = () => ({
      contentUrl: "",
      title: "",
      text: "",
      isLocked: !1,
      target: "",
      isExternal: !1,
      linkType: yt.Javascript,
      tealiumTrackingModel: {
        eventSource: Qe().pageName,
        eventComponentName: "button",
        eventTitle: a("audioModule.play")
      }
    });
    return qe(
      () => i.model.audioPlayerModel,
      (w) => {
        d.value = w?.isAutoPlay || !1;
      }
    ), t({
      play: f
    }), (w, x) => e.model ? (E(), X("div", {
      key: 0,
      class: Pe(["d-single-audio-module-container", {
        "d-single-audio-module-container--container": _(o),
        "d-single-audio-module-container--media": !_(o)
      }])
    }, [
      oe("div", {
        class: Pe(["d-single-audio-module", {
          "d-single-audio-module--audio-only": u.value,
          "d-single-audio-module--with-image": m.value
        }])
      }, [
        oe("div", {
          class: Pe(["d-single-audio-module__inner", {
            "d-single-audio-module__inner--stage-mode": u.value && e.stageMode,
            "d-single-audio-module__inner--started": u.value && d.value
          }])
        }, [
          e.model.audioPlayerModel ? (E(), X("div", Wge, [
            m.value ? (E(), X(Re, { key: 0 }, [
              rt(ue(Sp, {
                ref_key: "playerWithImageRef",
                ref: l,
                model: e.model.audioPlayerModel,
                onPlay: g,
                onLoaded: v,
                onEnded: P
              }, null, 8, ["model"]), [
                [xn, !y.value]
              ]),
              e.model.image ? rt((E(), fe(di, {
                key: 0,
                model: e.model.image,
                "rounded-corner": !0,
                "aspect-ratio": _(on).None
              }, null, 8, ["model", "aspect-ratio"])), [
                [xn, y.value]
              ]) : te("", !0)
            ], 64)) : te("", !0),
            e.model.image ? rt((E(), X("div", Yge, [
              ue(Nt, {
                "link-model": S(),
                type: _(Ke).RoundedPrimary,
                size: _(et).Inherit,
                icon: _(H).Play,
                "aria-label": _(a)("audioModule.play"),
                onClick: f
              }, null, 8, ["link-model", "type", "size", "icon", "aria-label"])
            ], 512)), [
              [xn, y.value]
            ]) : te("", !0),
            e.model.audioPlayerModel?.videoLengthSeconds && !d.value ? (E(), fe(Ji, {
              key: 2,
              "tag-text": c.value,
              "background-color": _(En).GreyBlue009,
              color: _(mi).White,
              "is-border-visible": !1,
              class: "d-single-audio-module__length"
            }, null, 8, ["tag-text", "background-color", "color"])) : te("", !0)
          ])) : te("", !0),
          e.model.date || e.model.episodeLabel ? (E(), X("div", qge, [
            e.model.episodeLabel ? (E(), fe(_(Tt), {
              key: 0,
              text: e.model.episodeLabel,
              "font-size": _(st).TwelvePx,
              "text-color": _(dt).GreyBlue009,
              "font-type": _(lt).DwsSlabBold
            }, null, 8, ["text", "font-size", "text-color", "font-type"])) : te("", !0),
            e.model.episodeLabel ? (E(), fe(_(Tt), {
              key: 1,
              text: "|",
              "font-size": _(st).TwelvePx,
              "text-color": _(dt).GreyBlue009,
              "font-type": _(lt).DwsSlabBold
            }, null, 8, ["font-size", "text-color", "font-type"])) : te("", !0),
            e.model.date ? (E(), fe(_(Tt), {
              key: 2,
              text: e.model.date,
              "font-size": _(st).TwelvePx,
              "text-color": _(dt).GreyBlue009,
              "font-type": _(lt).DwsSlabBold
            }, null, 8, ["text", "font-size", "text-color", "font-type"])) : te("", !0)
          ])) : te("", !0),
          e.model.headline ? (E(), fe(_(Ot), {
            key: 2,
            class: "d-single-audio-module__headline",
            "base-heading-type": e.headlineType
          }, {
            default: Se(() => [
              Ve(Ie(e.model.headline), 1)
            ]),
            _: 1
          }, 8, ["base-heading-type"])) : te("", !0),
          e.model.text ? (E(), fe(ht, {
            key: 3,
            class: "d-single-audio-module__text",
            "html-text": e.model.text
          }, null, 8, ["html-text"])) : te("", !0),
          u.value && !e.stageMode ? (E(), fe(Sp, {
            key: 4,
            ref_key: "playerRef",
            ref: s,
            model: e.model.audioPlayerModel,
            class: Pe(["d-single-audio-module__audio-only", {
              "d-single-audio-module__audio-only--started": d.value
            }]),
            onPlay: g,
            onLoaded: v,
            onEnded: P
          }, null, 8, ["model", "class"])) : te("", !0),
          oe("div", Kge, [
            u.value && !d.value ? (E(), fe(_(vt), {
              key: 0,
              "link-model": h(),
              type: _(Ke).Primary,
              size: _(et).Large,
              "button-type": _(zt).Button,
              icon: _(H).Headphones,
              "icon-position": _(ct).Left,
              class: "d-single-audio-module__play-button",
              onClick: f
            }, null, 8, ["link-model", "type", "size", "button-type", "icon", "icon-position"])) : te("", !0),
            e.model.transcriptButton ? (E(), fe(_(vt), {
              key: 1,
              "link-model": e.model.transcriptButton,
              type: _(Ke).Secondary,
              size: _(et).Large,
              "button-type": _(zt).Link,
              icon: _(H).FileDownload,
              "icon-position": _(ct).Left,
              class: "d-single-audio-module__transcript-button"
            }, null, 8, ["link-model", "type", "size", "button-type", "icon", "icon-position"])) : te("", !0),
            e.model.allButton ? (E(), fe(_(ot), {
              key: 2,
              "link-model": e.model.allButton,
              icon: _(H).ArrowRight,
              class: "d-single-audio-module__all-button"
            }, null, 8, ["link-model", "icon"])) : te("", !0)
          ])
        ], 2),
        u.value && e.stageMode ? (E(), fe(Sp, {
          key: 0,
          ref_key: "playerRef",
          ref: s,
          model: e.model.audioPlayerModel,
          class: Pe(["d-single-audio-module__audio-only", {
            "d-single-audio-module__audio-only--started": d.value,
            "d-single-audio-module__audio-only--stage-mode": e.stageMode
          }]),
          onPlay: g,
          onLoaded: v,
          onEnded: P
        }, null, 8, ["model", "class"])) : te("", !0)
      ], 2)
    ], 2)) : te("", !0);
  }
});
const GT = /* @__PURE__ */ Fe(Xge, [["__scopeId", "data-v-71748628"]]), Zge = { class: "d-audio-module__header" }, Jge = { class: "d-audio-module__content" }, Qge = { class: "d-audio-module__stage" }, eve = {
  key: 0,
  class: "d-audio-module__playlist"
}, tve = { class: "d-audio-module__playlist-content" }, nve = { class: "d-audio-module__stack" }, ive = {
  key: 1,
  class: "d-audio-module__footer"
}, ave = { class: "d-audio-module__slider" }, ove = /* @__PURE__ */ Be({
  __name: "AudioModule",
  props: {
    model: {
      type: Object,
      required: !0
    }
  },
  setup(e) {
    const t = e, { containerQueriesEnabled: n } = Bi(), { isDesktop: i } = xt(), o = ge(), a = ge(), r = ge(), s = ge(), l = ge(), d = ge(!0), y = ge(!1), u = ge(), m = ge([]), h = ge(!1), c = ge(!1), g = ge(!0), v = ge(!0), P = () => {
      a.value = Gu(o.value), v.value = n.value ? a.value?.xlarge : !i.value;
    };
    it(() => {
      P(), t.model?.items && t.model?.items.length > 0 && (u.value = t.model?.items[0], m.value = t.model?.items.slice(1, t.model?.items.length), m.value.push(t.model?.items[0]));
    }), qe(
      () => i.value,
      () => P()
    ), qe(
      () => a.value?.xlarge,
      () => P()
    );
    const f = () => {
      if (s?.value) {
        const C = s.value.$el.clientHeight;
        r.value = `height: ${C - 64}px;`;
      }
    }, S = () => {
      g.value && (g.value = !1, f());
    }, w = () => {
      const b = t.model?.items.findIndex(
        (p) => p?.audioPlayerModel?.videoId === u?.value?.audioPlayerModel?.videoId
      ) + 1;
      b < t.model?.items.length && (c.value = !c.value, x(t.model?.items[b], b));
    }, x = (C, b) => {
      C.audioPlayerModel.isAutoPlay = !0, u.value = C, k(b), Ue && window.requestAnimationFrame(() => {
        f();
      });
    }, k = (C) => {
      if (C >= 0) {
        let b = "#list-item-" + (C + 1);
        C === t.model?.items.length - 1 && (b = "#list-item-" + (C - 2));
        const p = Oe.findSingle(l.value, b);
        p && l.value.scrollTo({
          top: p.offsetTop - 50,
          behavior: "smooth"
        });
      } else {
        if (!u.value)
          return;
        t.model?.items.findIndex(
          (p) => p?.audioPlayerModel?.videoId === u?.value?.audioPlayerModel?.videoId
        ) === t.model?.items.length - 1 ? c.value = !c.value : h.value = !h.value;
      }
    }, A = (C) => {
      const b = C.target;
      d.value = b.scrollTop === 0, y.value = Math.abs(b.scrollHeight - b.scrollTop - b.clientHeight) < 1, C.preventDefault();
    }, $ = (C) => ({
      contentUrl: "",
      title: C.headline,
      text: C.headline,
      isLocked: !1,
      target: "",
      isExternal: !1,
      linkType: yt.Javascript,
      tealiumTrackingModel: {
        eventSource: Qe().pageName,
        eventComponentName: "AudioModule",
        eventTitle: C.headline
      }
    }), j = Te(() => [N, M, D]), N = {
      breakpoint: "1024px",
      numVisible: 2,
      numScroll: 1
    }, M = {
      breakpoint: "767px",
      numVisible: 2,
      numScroll: 1
    }, D = {
      breakpoint: "576px",
      numVisible: 1,
      numScroll: 1
    };
    return (C, b) => {
      const p = $e("BaseHeading");
      return e.model ? (E(), X("div", {
        key: 0,
        ref_key: "containerElement",
        ref: o,
        class: Pe(["d-audio-module", {
          "d-audio-module--container": _(n),
          "d-audio-module--media": !_(n)
        }])
      }, [
        oe("div", Zge, [
          e.model?.headline ? (E(), fe(p, {
            key: 0,
            "base-heading-type": e.model?.headlineType || _(ze).H2,
            class: "d-audio-module__heading"
          }, {
            default: Se(() => [
              Ve(Ie(e.model?.headline), 1)
            ]),
            _: 1
          }, 8, ["base-heading-type"])) : te("", !0),
          e.model?.textLink?.text ? (E(), fe(ot, {
            key: 1,
            "link-model": e.model.textLink,
            icon: _(H).ArrowRight,
            class: "d-audio-module__link"
          }, null, 8, ["link-model", "icon"])) : te("", !0)
        ]),
        oe("div", Jge, [
          oe("div", Qge, [
            u.value ? (E(), fe(GT, {
              key: 0,
              ref_key: "stageRef",
              ref: s,
              model: u.value,
              "headline-type": e.model?.headline ? _(ze).H3 : _(ze).H2Section,
              "stage-mode": !0,
              class: Pe({
                "single-audio": e.model?.items?.length === 1
              }),
              onLoaded: S,
              onEnded: w
            }, null, 8, ["model", "headline-type", "class"])) : te("", !0)
          ]),
          e.model?.items?.length > 1 && !v.value ? (E(), X("div", eve, [
            ue(A1, {
              headline: e.model.playlistHeadline,
              "headline-type": e.model?.headlineType === _(ze).H2 ? _(ze).H3 : _(ze).H4,
              "items-label": e.model.playlistItemsLabel,
              length: e.model.items.length
            }, null, 8, ["headline", "headline-type", "items-label", "length"]),
            oe("div", tve, [
              oe("div", {
                ref_key: "listRef",
                ref: l,
                class: Pe(["d-audio-module__overflow", {
                  "overflow-shadow-bottom": d.value || !d.value && !y.value,
                  "overflow-shadow-top": y.value || !d.value && !y.value
                }]),
                style: hn(r.value),
                onScroll: A
              }, [
                oe("div", nve, [
                  (E(!0), X(Re, null, Ge(m.value, (L, B) => (E(), fe(ot, {
                    id: "list-item-" + B,
                    key: B,
                    class: "d-audio-module__stack--item no-underline",
                    "has-text": !1,
                    "aria-label": L.headline,
                    "link-model": $(L),
                    onKeypress: Ze((T) => x(L, B), ["enter"]),
                    onClick: (T) => x(L, B)
                  }, {
                    container: Se(() => [
                      ue(P1, {
                        model: L,
                        "headline-type": e.model?.headlineType === _(ze).H2 ? _(ze).H4 : _(ze).H5
                      }, null, 8, ["model", "headline-type"])
                    ]),
                    _: 2
                  }, 1032, ["id", "aria-label", "link-model", "onKeypress", "onClick"]))), 128))
                ])
              ], 38)
            ])
          ])) : te("", !0),
          e.model?.items && e.model?.items.length > 1 && v.value ? (E(), X("div", ive, [
            ue(A1, {
              headline: e.model.playlistHeadline,
              "headline-type": e.model?.headlineType === _(ze).H2 ? _(ze).H3 : _(ze).H4,
              "items-label": e.model.playlistItemsLabel,
              length: e.model.items.length
            }, null, 8, ["headline", "headline-type", "items-label", "length"]),
            oe("div", ave, [
              ue(zs, {
                items: m.value,
                "items-visible": 2,
                "num-scroll": 1,
                page: 1,
                "set-forward": h.value,
                "set-backward": c.value,
                "responsive-options": j.value
              }, {
                item: Se((L) => [
                  ue(ot, {
                    class: "d-audio-module__slider--item no-underline",
                    "has-text": !1,
                    "aria-label": L.data.headline,
                    "link-model": $(L.data),
                    onKeypress: Ze((B) => x(L.data, -1), ["enter"]),
                    onClick: (B) => x(L.data, -1)
                  }, {
                    container: Se(() => [
                      ue(P1, {
                        model: L.data
                      }, null, 8, ["model"])
                    ]),
                    _: 2
                  }, 1032, ["aria-label", "link-model", "onKeypress", "onClick"])
                ]),
                _: 1
              }, 8, ["items", "set-forward", "set-backward", "responsive-options"])
            ])
          ])) : te("", !0)
        ])
      ], 2)) : te("", !0);
    };
  }
});
const HBe = /* @__PURE__ */ Fe(ove, [["__scopeId", "data-v-879fc5f1"]]), rve = { class: "d-single-audio-module-card" }, sve = /* @__PURE__ */ Be({
  __name: "SingleAudioModuleCard",
  props: {
    model: {
      type: Object,
      required: !0
    },
    backgroundColor: {
      type: String,
      default: Zt.White
    },
    stageMode: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["play"],
  setup(e, { emit: t }) {
    const { containerQueriesEnabled: n } = Bi(), i = t, o = Te(() => ({
      type: qi.AudioPlayer,
      backgroundColor: Zt.White,
      hideCorner: !0
    })), a = () => {
      i("play");
    };
    return (r, s) => e.model ? (E(), X("div", {
      key: 0,
      class: Pe(["d-single-audio-module-card-container", {
        "d-single-audio-module-card-container--container": _(n),
        "d-single-audio-module-card-container--media": !_(n)
      }])
    }, [
      oe("div", rve, [
        ue(Th, { model: o.value }, {
          content: Se(() => [
            ue(GT, {
              model: e.model,
              onPlay: a
            }, null, 8, ["model"])
          ]),
          _: 1
        }, 8, ["model"])
      ])
    ], 2)) : te("", !0);
  }
});
const zBe = /* @__PURE__ */ Fe(sve, [["__scopeId", "data-v-e73a1ab8"]]);
var ao = /* @__PURE__ */ ((e) => (e.Page = "page", e.Modal = "modal", e))(ao || {});
function lve(e, t) {
  for (var n = -1, i = e == null ? 0 : e.length, o = Array(i); ++n < i; )
    o[n] = t(e[n], n, e);
  return o;
}
var UT = lve, cve = xh, dve = Xg, uve = 1, hve = 2;
function pve(e, t, n, i) {
  var o = n.length, a = o, r = !i;
  if (e == null)
    return !a;
  for (e = Object(e); o--; ) {
    var s = n[o];
    if (r && s[2] ? s[1] !== e[s[0]] : !(s[0] in e))
      return !1;
  }
  for (; ++o < a; ) {
    s = n[o];
    var l = s[0], d = e[l], y = s[1];
    if (r && s[2]) {
      if (d === void 0 && !(l in e))
        return !1;
    } else {
      var u = new cve();
      if (i)
        var m = i(d, y, l, e, t, u);
      if (!(m === void 0 ? dve(y, d, uve | hve, i, u) : m))
        return !1;
    }
  }
  return !0;
}
var fve = pve, mve = Wa;
function gve(e) {
  return e === e && !mve(e);
}
var WT = gve, vve = WT, yve = rd;
function bve(e) {
  for (var t = yve(e), n = t.length; n--; ) {
    var i = t[n], o = e[i];
    t[n] = [i, o, vve(o)];
  }
  return t;
}
var xve = bve;
function wve(e, t) {
  return function(n) {
    return n == null ? !1 : n[e] === t && (t !== void 0 || e in Object(n));
  };
}
var YT = wve, kve = fve, Sve = xve, Cve = YT;
function Tve(e) {
  var t = Sve(e);
  return t.length == 1 && t[0][2] ? Cve(t[0][0], t[0][1]) : function(n) {
    return n === e || kve(n, e, t);
  };
}
var Lve = Tve, Ive = Rs, Pve = go, Ave = "[object Symbol]";
function _ve(e) {
  return typeof e == "symbol" || Pve(e) && Ive(e) == Ave;
}
var Nh = _ve, Mve = oa, Ove = Nh, Bve = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, Eve = /^\w*$/;
function Dve(e, t) {
  if (Mve(e))
    return !1;
  var n = typeof e;
  return n == "number" || n == "symbol" || n == "boolean" || e == null || Ove(e) ? !0 : Eve.test(e) || !Bve.test(e) || t != null && e in Object(t);
}
var Zg = Dve, qT = Sg, Rve = "Expected a function";
function Jg(e, t) {
  if (typeof e != "function" || t != null && typeof t != "function")
    throw new TypeError(Rve);
  var n = function() {
    var i = arguments, o = t ? t.apply(this, i) : i[0], a = n.cache;
    if (a.has(o))
      return a.get(o);
    var r = e.apply(this, i);
    return n.cache = a.set(o, r) || a, r;
  };
  return n.cache = new (Jg.Cache || qT)(), n;
}
Jg.Cache = qT;
var Nve = Jg, $ve = Nve, Fve = 500;
function jve(e) {
  var t = $ve(e, function(i) {
    return n.size === Fve && n.clear(), i;
  }), n = t.cache;
  return t;
}
var Hve = jve, zve = Hve, Vve = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, Gve = /\\(\\)?/g, Uve = zve(function(e) {
  var t = [];
  return e.charCodeAt(0) === 46 && t.push(""), e.replace(Vve, function(n, i, o, a) {
    t.push(o ? a.replace(Gve, "$1") : i || n);
  }), t;
}), Wve = Uve, _1 = td, Yve = UT, qve = oa, Kve = Nh, Xve = 1 / 0, M1 = _1 ? _1.prototype : void 0, O1 = M1 ? M1.toString : void 0;
function KT(e) {
  if (typeof e == "string")
    return e;
  if (qve(e))
    return Yve(e, KT) + "";
  if (Kve(e))
    return O1 ? O1.call(e) : "";
  var t = e + "";
  return t == "0" && 1 / e == -Xve ? "-0" : t;
}
var Zve = KT, Jve = Zve;
function Qve(e) {
  return e == null ? "" : Jve(e);
}
var XT = Qve, eye = oa, tye = Zg, nye = Wve, iye = XT;
function aye(e, t) {
  return eye(e) ? e : tye(e, t) ? [e] : nye(iye(e));
}
var ZT = aye, oye = Nh, rye = 1 / 0;
function sye(e) {
  if (typeof e == "string" || oye(e))
    return e;
  var t = e + "";
  return t == "0" && 1 / e == -rye ? "-0" : t;
}
var $h = sye, lye = ZT, cye = $h;
function dye(e, t) {
  t = lye(t, e);
  for (var n = 0, i = t.length; e != null && n < i; )
    e = e[cye(t[n++])];
  return n && n == i ? e : void 0;
}
var JT = dye, uye = JT;
function hye(e, t, n) {
  var i = e == null ? void 0 : uye(e, t);
  return i === void 0 ? n : i;
}
var pye = hye;
function fye(e, t) {
  return e != null && t in Object(e);
}
var mye = fye, gye = ZT, vye = Pg, yye = oa, bye = Bg, xye = Ag, wye = $h;
function kye(e, t, n) {
  t = gye(t, e);
  for (var i = -1, o = t.length, a = !1; ++i < o; ) {
    var r = wye(t[i]);
    if (!(a = e != null && n(e, r)))
      break;
    e = e[r];
  }
  return a || ++i != o ? a : (o = e == null ? 0 : e.length, !!o && xye(o) && bye(r, o) && (yye(e) || vye(e)));
}
var Sye = kye, Cye = mye, Tye = Sye;
function Lye(e, t) {
  return e != null && Tye(e, t, Cye);
}
var Iye = Lye, Pye = Xg, Aye = pye, _ye = Iye, Mye = Zg, Oye = WT, Bye = YT, Eye = $h, Dye = 1, Rye = 2;
function Nye(e, t) {
  return Mye(e) && Oye(t) ? Bye(Eye(e), t) : function(n) {
    var i = Aye(n, e);
    return i === void 0 && i === t ? _ye(n, e) : Pye(t, i, Dye | Rye);
  };
}
var $ye = Nye;
function Fye(e) {
  return function(t) {
    return t?.[e];
  };
}
var jye = Fye, Hye = JT;
function zye(e) {
  return function(t) {
    return Hye(t, e);
  };
}
var Vye = zye, Gye = jye, Uye = Vye, Wye = Zg, Yye = $h;
function qye(e) {
  return Wye(e) ? Gye(Yye(e)) : Uye(e);
}
var Kye = qye, Xye = Lve, Zye = $ye, Jye = Eg, Qye = oa, ebe = Kye;
function tbe(e) {
  return typeof e == "function" ? e : e == null ? Jye : typeof e == "object" ? Qye(e) ? Zye(e[0], e[1]) : Xye(e) : ebe(e);
}
var QT = tbe, nbe = xC, ibe = rd;
function abe(e, t) {
  return e && nbe(e, t, ibe);
}
var obe = abe, rbe = js;
function sbe(e, t) {
  return function(n, i) {
    if (n == null)
      return n;
    if (!rbe(n))
      return e(n, i);
    for (var o = n.length, a = t ? o : -1, r = Object(n); (t ? a-- : ++a < o) && i(r[a], a, r) !== !1; )
      ;
    return n;
  };
}
var lbe = sbe, cbe = obe, dbe = lbe, ube = dbe(cbe), eL = ube, hbe = eL, pbe = js;
function fbe(e, t) {
  var n = -1, i = pbe(e) ? Array(e.length) : [];
  return hbe(e, function(o, a, r) {
    i[++n] = t(o, a, r);
  }), i;
}
var mbe = fbe, gbe = UT, vbe = QT, ybe = mbe, bbe = oa;
function xbe(e, t) {
  var n = bbe(e) ? gbe : ybe;
  return n(e, vbe(t));
}
var wbe = xbe;
const kbe = /* @__PURE__ */ en(wbe), Sbe = {
  key: 0,
  class: "d-product-buying-process-partners"
}, Cbe = /* @__PURE__ */ Be({
  __name: "ProductBuyingProcessPartners",
  props: {
    partners: {
      type: Object,
      required: !0
    }
  },
  emits: ["partnerChanged"],
  setup(e, { emit: t }) {
    const n = e, { t: i } = Je(), o = ge(), a = t, r = (y) => {
      o.value = y;
      const u = s(y);
      a("partnerChanged", u);
    }, s = (y) => n.partners.find((u) => u.key === y.id), l = (y) => kbe(y, (u) => ({
      id: u.key,
      name: u.partnerName,
      toolTipText: u.partnerName,
      image: u.logo
    })), d = Te(() => ({
      items: l(n.partners),
      selectedItem: o.value,
      isValid: !0,
      isDisabled: !1,
      tealiumTrackingModel: {
        eventSource: Qe().pageName,
        eventComponentName: "Product Buying Process - Partner Selection",
        eventTitle: o.value?.name
      }
    }));
    return (y, u) => {
      const m = $e("BaseText");
      return e.partners ? (E(), X("div", Sbe, [
        e.partners?.length > 0 ? (E(), fe(Vs, {
          key: 0,
          model: d.value,
          "label-text-visible": !1,
          "with-tooltip": !0,
          onValueChanged: r
        }, null, 8, ["model"])) : te("", !0),
        e.partners?.length === 0 ? (E(), fe(m, {
          key: 1,
          text: _(i)("mediaReleases.noResults"),
          "font-size": _(st).SixteenPx
        }, null, 8, ["text", "font-size"])) : te("", !0)
      ])) : te("", !0);
    };
  }
});
const Tbe = /* @__PURE__ */ Fe(Cbe, [["__scopeId", "data-v-5cd6a885"]]), Lbe = {
  key: 0,
  class: "d-product-buying-process-partner-detail"
}, Ibe = { class: "d-product-buying-process-partner-detail__description" }, Pbe = { class: "d-product-buying-process-partner-detail__logo-and-contact" }, Abe = { class: "d-product-buying-process-partner-detail__logo-and-contact__logo" }, _be = { class: "d-product-buying-process-partner-detail__logo-and-contact__logo__img" }, Mbe = ["src", "alt"], Obe = {
  key: 0,
  class: "d-product-buying-process-partner-detail__logo-and-contact__contact"
}, Bbe = {
  key: 1,
  class: "d-product-buying-process-partner-detail__modal-disclaimer"
}, Ebe = { class: "d-product-buying-process-partner-detail__modal-disclaimer__description" }, Dbe = /* @__PURE__ */ Be({
  __name: "ProductBuyingProcessPartnerDetail",
  props: {
    model: {
      type: Object,
      required: !0
    },
    type: {
      type: String,
      default: ao.Page
    }
  },
  setup(e) {
    const t = e, { pageName: n } = Qe(), { t: i } = Je(), o = () => ({
      ...t.model.link,
      title: i("productBuyingProcess.continueToPartner"),
      text: i("productBuyingProcess.continueToPartner"),
      tealiumTrackingModel: {
        eventSource: n,
        eventComponentName: "Product Buying Process",
        eventTitle: "Continue to Partner",
        eventTarget: t.model.link?.href
      }
    });
    return (a, r) => {
      const s = $e("BaseHeading");
      return e.model ? (E(), X("div", Lbe, [
        ue(s, {
          class: "d-product-buying-process-partner-detail__heading",
          "base-heading-type": e.type === _(ao).Page ? _(ze).H2Section : _(ze).StyledAsH3
        }, {
          default: Se(() => [
            Ve(Ie(e.model.partnerName), 1)
          ]),
          _: 1
        }, 8, ["base-heading-type"]),
        oe("div", Ibe, [
          e.model.description ? (E(), fe(ht, {
            key: 0,
            "html-text": e.model.description
          }, null, 8, ["html-text"])) : te("", !0)
        ]),
        oe("div", Pbe, [
          oe("div", Abe, [
            oe("div", _be, [
              oe("img", {
                src: e.model.logo.src,
                alt: e.model.logo.alt
              }, null, 8, Mbe)
            ])
          ]),
          e.model.contactInfo ? (E(), X("div", Obe, [
            e.model.contactInfo.email ? (E(), fe(ot, {
              key: 0,
              "is-copy-link": !0,
              "link-model": e.model.contactInfo.email,
              icon: _(H).Envelope,
              "icon-position": _(ct).Left
            }, null, 8, ["link-model", "icon", "icon-position"])) : te("", !0),
            e.model.contactInfo.tel ? (E(), fe(ot, {
              key: 1,
              "is-copy-link": !0,
              "link-model": e.model.contactInfo.tel,
              icon: _(H).Phone,
              "icon-position": _(ct).Left
            }, null, 8, ["link-model", "icon", "icon-position"])) : te("", !0),
            e.model.contactInfo.homepage ? (E(), fe(ot, {
              key: 2,
              "is-copy-link": !0,
              "link-model": e.model.contactInfo.homepage,
              icon: _(H).ExternalLinkAlt,
              "icon-position": _(ct).Left
            }, null, 8, ["link-model", "icon", "icon-position"])) : te("", !0)
          ])) : te("", !0)
        ]),
        e.type === _(ao).Page ? (E(), fe(vt, {
          key: 0,
          "link-model": o(),
          type: _(Ke).Primary,
          size: _(et).Large,
          icon: _(H).ExternalLinkAlt,
          "icon-position": _(ct).Left,
          "button-type": _(zt).Link,
          class: "d-product-buying-process-partner-detail__button"
        }, null, 8, ["link-model", "type", "size", "icon", "icon-position", "button-type"])) : te("", !0),
        e.type === _(ao).Modal ? (E(), X("div", Bbe, [
          ue(s, {
            class: "d-product-buying-process-partner-detail__modal-disclaimer__heading",
            "base-heading-type": _(ze).StyledAsH3
          }, {
            default: Se(() => [
              Ve(Ie(e.model.disclaimerHeadline), 1)
            ]),
            _: 1
          }, 8, ["base-heading-type"]),
          oe("div", Ebe, [
            e.model.disclaimerText ? (E(), fe(ht, {
              key: 0,
              "html-text": e.model.disclaimerText
            }, null, 8, ["html-text"])) : te("", !0)
          ])
        ])) : te("", !0)
      ])) : te("", !0);
    };
  }
});
const Rbe = /* @__PURE__ */ Fe(Dbe, [["__scopeId", "data-v-f36cb082"]]), Nbe = { class: "d-product-buying-process__header" }, $be = { class: "d-product-buying-process__content-filter" }, Fbe = { class: "d-product-buying-process__partners" }, jbe = /* @__PURE__ */ Be({
  __name: "ProductBuyingProcess",
  props: {
    model: {
      type: Object,
      required: !0
    },
    type: {
      type: String,
      default: ao.Page
    },
    partnersAlphabeticallySorted: {
      type: Boolean,
      default: !1
    }
  },
  emits: [
    "tabChanged",
    "search",
    "enter",
    "blur",
    "clear",
    "partnerChanged"
  ],
  setup(e, { emit: t }) {
    const n = e, { t: i } = Je(), { pageName: o } = Qe(), { calculateScrollPosition: a } = Fn(), r = t, s = ge(), l = ge(), d = ge(""), y = ge(null), u = $t("smoothScroll"), m = ($) => {
      s.value = $, A(), r("partnerChanged", $);
    }, h = Te(() => n.partnersAlphabeticallySorted ? n.model.partnerInformation.sort(($, j) => $.key.localeCompare(j.key)) : n.model.partnerInformation), c = ge(h.value), g = ge(h.value), v = ge(), P = ($) => {
      v.value = $, f(d.value), r("tabChanged", $);
    }, f = ($) => {
      d.value = $, g.value = h.value.filter((j) => {
        const N = !v.value || v.value.identifier === "allProviders" || j.category === v.value.identifier, M = j.partnerName.toLowerCase().includes($.toLowerCase());
        return N && M;
      });
    }, S = ($) => {
      f($), r("search", $);
    }, w = ($) => {
      f($), r("enter", $);
    }, x = ($) => {
      f($), r("blur", $);
    }, k = () => {
      d.value = "", g.value = c.value, f(d.value), r("clear");
    };
    async function A() {
      if (await mt(), !l.value)
        return;
      const $ = {
        scrollTo: l.value || 0,
        duration: 1e3,
        offset: 0,
        updateHistory: !1
      };
      n.type === ao.Modal ? u({
        ...$,
        container: y?.value?.parentElement
      }) : u({
        ...$,
        scrollTo: a(l.value) || 0
      });
    }
    return ($, j) => e.model ? (E(), X("div", {
      key: 0,
      ref_key: "productBuyingRef",
      ref: y,
      class: Pe(["d-product-buying-process", e.type])
    }, [
      oe("div", Nbe, [
        ue(Hs, {
          model: { headline: e.model.headline, introText: e.model.introText },
          "base-heading-type": e.type === _(ao).Page ? _(ze).H1 : _(ze).StyledAsH2Section
        }, null, 8, ["model", "base-heading-type"])
      ]),
      oe("div", $be, [
        e.model.tabs ? (E(), fe(Ah, {
          key: 0,
          filter: e.model.tabs,
          "show-tabs-with-no-results": !0,
          "event-component-name": "tab-control",
          "data-event-source": _(o),
          class: "d-product-buying-process__content-filter__tabs",
          onSingleSelectValueChanged: P
        }, null, 8, ["filter", "data-event-source"])) : te("", !0),
        ue(Wo, {
          "is-suppress-open-new-window-on-enter": !0,
          class: "d-product-buying-process__content-filter__search",
          model: {
            headline: "",
            placeholder: _(i)("productBuyingProcess.searchBoxPlaceholder"),
            filterOptions: [],
            searchTerm: e.model.initialSearchTerm,
            submitLinkModel: e.model.submitLinkModel,
            showLabel: !0
          },
          "debounce-interval": 0,
          "min-length": 0,
          onSearch: S,
          onEnter: w,
          onBlur: x,
          onClear: k
        }, null, 8, ["model"])
      ]),
      oe("div", Fbe, [
        g.value ? (E(), fe(Tbe, {
          key: 0,
          partners: g.value,
          class: "d-product-buying-process__partners",
          onPartnerChanged: m
        }, null, 8, ["partners"])) : te("", !0)
      ]),
      s.value ? (E(), X("div", {
        key: 0,
        ref_key: "partnerDetail",
        ref: l,
        class: "d-product-buying-process__partner-detail",
        "aria-live": "polite"
      }, [
        ue(Rbe, {
          model: s.value,
          type: e.type
        }, null, 8, ["model", "type"])
      ], 512)) : te("", !0)
    ], 2)) : te("", !0);
  }
});
const Hbe = /* @__PURE__ */ Fe(jbe, [["__scopeId", "data-v-87d2f425"]]), zbe = {
  key: 0,
  class: "d-product-buying-process-modal"
}, Vbe = { class: "d-product-buying-process-modal__footer" }, Gbe = /* @__PURE__ */ Be({
  __name: "ProductBuyingProcessModal",
  props: {
    model: {
      type: Object,
      required: !0
    },
    openDialog: {
      type: Boolean,
      default: !1
    },
    partnersAlphabeticallySorted: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["close", "partnerChanged"],
  setup(e, { emit: t }) {
    const n = e, { pageName: i } = Qe(), { t: o } = Je(), a = t, r = ge(!1), s = ge(), l = () => {
      s.value = null, r.value = !1, a("close");
    }, d = Te(() => ({
      "1920px": "95vw",
      "1280px": "95vw",
      "1024px": "95vw",
      "768px": "95vw",
      "767px": "100vw",
      "375px": "100vw"
    })), y = () => ({
      ...s.value?.link,
      title: o("productBuyingProcess.continueToPartner"),
      text: o("productBuyingProcess.continueToPartner"),
      tealiumTrackingModel: {
        eventSource: i,
        eventComponentName: "Product Buying Process Modal",
        eventTitle: "Continue to Partner"
      }
    }), u = () => ({
      text: o("Cancel"),
      title: o("Cancel"),
      contentUrl: "",
      isLocked: !1,
      linkType: yt.Default,
      isExternal: !1,
      tealiumTrackingModel: {
        eventSource: i,
        eventComponentName: "Product Buying Process Modal",
        eventTitle: "Cancel Modal"
      }
    }), m = (h) => {
      s.value = h, a("partnerChanged", h);
    };
    return qe(
      () => n.openDialog,
      (h) => {
        h && (r.value = h);
      },
      { immediate: !0 }
    ), qe(
      () => r.value,
      (h) => {
        h || (s.value = null, a("close"));
      },
      { immediate: !0 }
    ), (h, c) => e.model ? (E(), X("div", zbe, [
      ue(Ei, {
        visible: r.value,
        "onUpdate:visible": c[0] || (c[0] = (g) => r.value = g),
        breakpoints: d.value,
        "close-button-with-border": !1,
        "append-to": e.model.appendTo,
        position: _(aa).Center,
        class: "d-product-buying-process-modal_modal"
      }, {
        closeicon: Se(() => [
          ue(_t, {
            "base-icon": _(H).Times,
            class: "d-product-buying-process-modal__close-icon",
            "aria-label": _(o)("globalTranslations.close")
          }, null, 8, ["base-icon", "aria-label"])
        ]),
        content: Se(() => [
          ue(Hbe, {
            model: e.model,
            type: _(ao).Modal,
            "partners-alphabetically-sorted": e.partnersAlphabeticallySorted,
            onPartnerChanged: m
          }, null, 8, ["model", "type", "partners-alphabetically-sorted"])
        ]),
        footer: Se(() => [
          oe("div", Vbe, [
            ue(vt, {
              "link-model": u(),
              type: _(Ke).Secondary,
              size: _(et).Large,
              "icon-position": _(ct).Left,
              "button-type": _(zt).Button,
              class: "d-product-buying-process-modal__footer__cancel-button",
              onClick: l
            }, null, 8, ["link-model", "type", "size", "icon-position", "button-type"]),
            ue(vt, {
              "link-model": y(),
              type: _(Ke).Primary,
              size: _(et).Large,
              icon: _(H).ExternalLinkAlt,
              "icon-position": _(ct).Left,
              "button-type": _(zt).Link,
              disabled: s.value == null,
              class: "d-product-buying-process-modal__footer__continue-button",
              "data-id": "silktide-accept",
              onClick: l
            }, null, 8, ["link-model", "type", "size", "icon", "icon-position", "button-type", "disabled"])
          ])
        ]),
        _: 1
      }, 8, ["visible", "breakpoints", "append-to", "position"])
    ])) : te("", !0);
  }
});
const VBe = /* @__PURE__ */ Fe(Gbe, [["__scopeId", "data-v-d87aaf4b"]]);
var Al = /* @__PURE__ */ ((e) => (e.InfoBox = "info-box", e.CallOutBox = "call-out-box", e))(Al || {});
const Ube = {}, Wbe = { class: "d-content-box-card" };
function Ybe(e, t) {
  return E(), X("div", Wbe, [
    je(e.$slots, "content", {}, void 0, !0)
  ]);
}
const qbe = /* @__PURE__ */ Fe(Ube, [["render", Ybe], ["__scopeId", "data-v-be84d910"]]), Kbe = {
  key: 0,
  class: "d-content-box-content"
}, Xbe = /* @__PURE__ */ Be({
  __name: "ContentBoxContent",
  props: {
    content: {
      type: Object,
      required: !0
    },
    type: {
      type: String,
      default: Al.InfoBox
    },
    iconMarkerColor: {
      type: String,
      default: $o.GreyBlue001
    },
    headlineType: {
      type: String,
      default: ze.StyledAsH3
    }
  },
  setup(e) {
    const { pageName: t } = Qe(), n = (i) => (i.tealiumTrackingModel = {
      eventSource: t,
      eventComponentName: "content-box",
      eventTitle: i.title,
      eventTarget: i.contentUrl
    }, i);
    return (i, o) => {
      const a = $e("BaseHeading");
      return e.content ? (E(), X("div", Kbe, [
        e.content.icon ? (E(), fe(Rh, {
          key: 0,
          model: e.content.icon,
          "item-marker-color": e.iconMarkerColor,
          class: "d-content-box-content__icon"
        }, null, 8, ["model", "item-marker-color"])) : te("", !0),
        ue(a, {
          "base-heading-type": e.headlineType,
          class: "d-content-box-content__header"
        }, {
          default: Se(() => [
            Ve(Ie(e.content.headline), 1)
          ]),
          _: 1
        }, 8, ["base-heading-type"]),
        e.content.text ? (E(), fe(ht, {
          key: 1,
          "html-text": e.content.text,
          class: Pe({
            "d-content-box-content__text--copy": e.type === _(Al).InfoBox,
            "d-content-box-content__text--h3-light": e.type === _(Al).CallOutBox
          })
        }, null, 8, ["html-text", "class"])) : te("", !0),
        e.content.textLink ? (E(), fe(ot, {
          key: 2,
          "link-model": n(e.content.textLink),
          icon: _(H).ArrowRight,
          class: "d-content-box-content__link"
        }, null, 8, ["link-model", "icon"])) : te("", !0)
      ])) : te("", !0);
    };
  }
});
const Zbe = /* @__PURE__ */ Fe(Xbe, [["__scopeId", "data-v-2c0e1b72"]]), Jbe = { class: "d-content-box" }, Qbe = /* @__PURE__ */ Be({
  __name: "ContentBox",
  props: {
    content: {
      type: Object,
      required: !0
    },
    type: {
      type: String,
      default: Al.InfoBox
    },
    iconMarkerColor: {
      type: String,
      default: $o.GreyBlue001
    },
    headlineType: {
      type: String,
      default: ze.StyledAsH3
    }
  },
  setup(e) {
    return (t, n) => (E(), X("div", Jbe, [
      ue(qbe, null, {
        content: Se(() => [
          e.content ? (E(), fe(Zbe, {
            key: 0,
            content: e.content,
            type: e.type,
            "icon-marker-color": e.iconMarkerColor,
            "headline-type": e.headlineType
          }, null, 8, ["content", "type", "icon-marker-color", "headline-type"])) : te("", !0)
        ]),
        _: 1
      })
    ]));
  }
});
const GBe = /* @__PURE__ */ Fe(Qbe, [["__scopeId", "data-v-0133d7b0"]]), e0e = {
  key: 0,
  class: "d-responsive-picture"
}, t0e = /* @__PURE__ */ Be({
  __name: "ResponsivePicture",
  props: {
    model: {
      type: Object,
      required: !0
    },
    aspectRatio: {
      type: String,
      default: on.TwoToOne
    }
  },
  setup(e) {
    return (t, n) => e.model ? (E(), X("div", e0e, [
      e.model?.picture ? (E(), fe(_(di), {
        key: 0,
        class: "d-responsive-picture__image",
        model: e.model?.picture,
        "aspect-ratio": e.aspectRatio,
        "rounded-corner": !0
      }, null, 8, ["model", "aspect-ratio"])) : te("", !0),
      e.model?.description ? (E(), fe(_(ht), {
        key: 1,
        class: "d-responsive-picture__description",
        "html-text": e.model?.description
      }, null, 8, ["html-text"])) : te("", !0)
    ])) : te("", !0);
  }
});
const UBe = /* @__PURE__ */ Fe(t0e, [["__scopeId", "data-v-96a75702"]]), n0e = { class: "d-image-gallery-header" }, i0e = /* @__PURE__ */ Be({
  __name: "ImageGalleryHeader",
  props: {
    headline: {
      type: String,
      default: ""
    },
    description: {
      type: String,
      default: void 0
    }
  },
  setup(e) {
    const { isMobile: t } = xt();
    return (n, i) => {
      const o = $e("BaseHeading"), a = $e("BaseText");
      return E(), X("div", n0e, [
        ue(o, {
          "base-heading-type": _(ze).StyledAsH2Section,
          class: Pe(["d-image-gallery-header__headline", {
            "d-image-gallery-header__headline--small": _(t) && e.headline.length > 60
          }])
        }, {
          default: Se(() => [
            Ve(Ie(e.headline), 1)
          ]),
          _: 1
        }, 8, ["base-heading-type", "class"]),
        e.description ? (E(), fe(a, {
          key: 0,
          text: e.description,
          "font-size": _(st).FourteenPx,
          "font-type": _(lt).DwsSans,
          "text-color": _(dt).GreyBlue006,
          class: "d-image-gallery-header__description"
        }, null, 8, ["text", "font-size", "font-type", "text-color"])) : te("", !0)
      ]);
    };
  }
});
const a0e = /* @__PURE__ */ Fe(i0e, [["__scopeId", "data-v-4b8488d6"]]), o0e = /* @__PURE__ */ Be({
  __name: "ImageGallery",
  props: {
    model: {
      type: Object,
      required: !0
    }
  },
  setup(e) {
    const t = e, { isMobile: n, isMobileLandscape: i, currentBreakpoint: o } = xt(), { t: a } = Je(), r = () => {
      const V = Math.ceil(Math.min(d.value, t.model?.images?.length) / 2) - 1;
      return t.model?.images?.[V];
    }, s = ge(!1), l = ge(!1), d = ge(4), y = ge(r()), u = ge(), m = ge(), h = ge(), c = ge(), g = ge(), v = ge(), P = ge(), f = ge([]), S = ge(!1), w = ge(!1), x = ge(!1), k = ge(0), A = () => {
      y.value = r();
    }, $ = () => {
      o.value === "Lg" ? d.value = 3 : d.value = 4;
    }, j = () => {
      i.value && Ue && window.requestAnimationFrame(() => {
        const V = f.value.map((G) => G.$el).find((G) => G.classList.contains("d-image-gallery__active-header"));
        if (V) {
          const G = (h.value.offsetHeight - V.offsetHeight - c.value.$el.offsetHeight) / 2;
          c.value.$el.style.bottom = `${G}px`, g.value.$el.style.bottom = `${G}px`;
        }
      });
    }, N = () => {
      Ue && P.value && window.requestAnimationFrame(() => {
        fi(() => {
          if (!i.value && f.value && f.value.length > 0) {
            const V = f.value.map(
              (G) => G?.$el?.offsetHeight || 0
            );
            k.value = Math.max(...V), P.value.style.height = `${k.value}px`;
          } else
            P.value.style.height = "";
        }, 100);
      });
    }, M = async () => {
      Ue && (await mt(), n.value || i.value ? m.value.style.height = void 0 : window.requestAnimationFrame(() => {
        fi(() => {
          if (v.value && u.value && k.value && m.value) {
            const V = v.value.parentElement.offsetHeight - u.value?.$el.offsetHeight - k.value - 96;
            m.value.style.height = `${V}px`;
          }
        }, 1e3);
      }));
    };
    it(() => {
      $(), A(), N(), M();
    }), qe(
      () => t.model?.images,
      () => {
        A(), N(), M();
      },
      { deep: !0 }
    ), qe(
      () => o.value,
      () => {
        $(), N(), j(), M();
      }
    );
    const D = Te(() => t.model.images.length >= 2 && s.value), C = () => {
      s.value = !0;
    }, b = () => {
      s.value = !1;
    }, p = () => {
      s.value = !s.value, l.value = !l.value, j();
    }, L = () => new Promise((V) => {
      w.value = !1, S.value = !1, x.value = !0, fi(() => {
        V(1), S.value = !0;
      }, 300);
    }), B = () => new Promise((V) => {
      S.value = !1, w.value = !1, x.value = !1, fi(() => {
        w.value = !0, V(1);
      }, 300);
    }), T = () => {
      L().then(() => {
        u.value.navForward(), j();
      });
    }, O = () => {
      B().then(() => {
        u.value.navBackward(), j();
      });
    }, I = (V) => {
      L().then(() => {
        y.value = V, j(), Y();
      });
    }, R = (V) => {
      B().then(() => {
        y.value = V, j(), F();
      });
    }, Y = () => {
      fi(() => {
        S.value = !1;
      }, 500);
    }, F = () => {
      fi(() => {
        w.value = !1;
      }, 500);
    }, U = (V) => t.model.images.findIndex((G) => G === V), Q = (V) => {
      if (y.value !== V) {
        const G = U(V), W = U(y.value), ae = t.model.images.length - 1;
        G === 0 ? I(V) : G === ae && W === 0 || G < W ? R(V) : I(V);
      }
    }, J = () => {
      x.value ? Y() : F();
    };
    n && Zx(h, {
      passive: !1,
      onSwipeEnd(V, G) {
        G === "left" ? T() : G === "right" && O();
      }
    });
    const ee = () => ({
      contentUrl: "",
      title: "",
      target: "_self",
      isLocked: !1,
      isExternal: !1,
      linkType: yt.Javascript,
      tealiumTrackingModel: {
        eventSource: Qe().pageName,
        eventComponentName: "Featured Property Teaser",
        eventTitle: `${y.value.headline} | ${y.value.description}`
      }
    });
    return (V, G) => e.model ? (E(), X("div", {
      key: 0,
      ref_key: "gallery",
      ref: v,
      class: "d-image-gallery"
    }, [
      oe("div", {
        ref_key: "galleryHeader",
        ref: P,
        class: "d-image-gallery__header-container"
      }, [
        (E(!0), X(Re, null, Ge(e.model.images, (W) => (E(), fe(a0e, {
          key: W.image.src,
          ref_for: !0,
          ref: (ae) => {
            f.value.includes(ae) || f.value.push(ae);
          },
          headline: W.headline,
          description: W.description,
          class: Pe(["d-image-gallery__header", {
            "d-image-gallery__active-header": (!_(i) || l.value) && y.value?.image?.src === W?.image?.src
          }])
        }, null, 8, ["headline", "description", "class"]))), 128))
      ], 512),
      y.value ? (E(), X("div", {
        key: 0,
        ref_key: "mainItemContainer",
        ref: h,
        class: "d-image-gallery__main-item-container",
        onMouseover: C,
        onMouseleave: b
      }, [
        !_(n) || _(i) ? rt((E(), fe(Nt, {
          key: 0,
          ref_key: "backwardButton",
          ref: c,
          "link-model": ee(),
          type: _(Ke).RoundedPrimary,
          size: _(et).Medium,
          icon: _(H).AngleLeft,
          "aria-label": _(a)("baseSlider.navBackward"),
          class: "d-image-gallery__backward",
          onClick: G[0] || (G[0] = (W) => O()),
          onTouchend: G[1] || (G[1] = (W) => O())
        }, null, 8, ["link-model", "type", "size", "icon", "aria-label"])), [
          [xn, D.value]
        ]) : te("", !0),
        oe("div", {
          ref_key: "mainItem",
          ref: m,
          class: Pe(["d-image-gallery__main-item", {
            "d-image-gallery__main-item--move-right": S.value,
            "d-image-gallery__main-item--move-left": w.value,
            "d-image-gallery__main-item--mobile-landscape": _(i)
          }]),
          onTouchend: p,
          onKeyup: Ze(p, ["tab"])
        }, [
          ue(di, {
            model: y.value.image,
            "rounded-corner": !0,
            "aspect-ratio": _(on).SixteenToNine,
            onLoaded: J
          }, null, 8, ["model", "aspect-ratio"])
        ], 34),
        !_(n) || _(i) ? rt((E(), fe(Nt, {
          key: 1,
          ref_key: "forwardButton",
          ref: g,
          "link-model": ee(),
          type: _(Ke).RoundedPrimary,
          size: _(et).Medium,
          icon: _(H).AngleRight,
          "aria-label": _(a)("baseSlider.navForward"),
          class: "d-image-gallery__forward",
          onClick: G[2] || (G[2] = (W) => T()),
          onTouchend: G[3] || (G[3] = (W) => T())
        }, null, 8, ["link-model", "type", "size", "icon", "aria-label"])), [
          [xn, D.value]
        ]) : te("", !0)
      ], 544)) : te("", !0),
      e.model.images.length > 1 ? rt((E(), fe($g, {
        key: 1,
        ref_key: "sliderRef",
        ref: u,
        items: e.model.images,
        "is-circular": !0,
        "num-scroll": 1,
        "num-visible": d.value,
        "show-indicators": !1,
        class: "d-image-gallery__slider",
        onBackward: R,
        onForward: I,
        onItemClicked: Q
      }, {
        item: Se(({ item: W }) => [
          ue(di, {
            model: W.image,
            "rounded-corner": !0,
            class: "d-image-gallery__thumbnail"
          }, null, 8, ["model"])
        ]),
        _: 1
      }, 8, ["items", "num-visible"])), [
        [xn, !_(i)]
      ]) : te("", !0)
    ], 512)) : te("", !0);
  }
});
const r0e = /* @__PURE__ */ Fe(o0e, [["__scopeId", "data-v-3fb4c009"]]), s0e = {
  key: 0,
  class: "d-image-gallery-modal"
}, l0e = /* @__PURE__ */ Be({
  __name: "ImageGalleryModal",
  props: {
    model: {
      type: Object,
      required: !0
    },
    openDialog: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["close"],
  setup(e, { emit: t }) {
    const n = e, i = ge(!1), { t: o } = Je(), a = t;
    qe(
      () => n.openDialog,
      (s) => {
        s && (i.value = s);
      },
      { immediate: !0 }
    ), qe(
      () => i.value,
      (s) => {
        s || a("close");
      },
      { immediate: !0 }
    );
    const r = Te(() => ({
      "1920px": "95vw",
      "1280px": "95vw",
      "1024px": "95vw",
      "768px": "95vw",
      "767px": "100vw",
      "375px": "100vw"
    }));
    return (s, l) => e.model ? (E(), X("div", s0e, [
      ue(Ei, {
        visible: i.value,
        "onUpdate:visible": l[0] || (l[0] = (d) => i.value = d),
        breakpoints: r.value,
        "close-button-with-border": !1,
        "append-to": e.model.appendTo,
        position: _(aa).Center,
        class: "d-image-gallery-modal__modal"
      }, {
        closeicon: Se(() => [
          ue(_t, {
            "base-icon": _(H).Times,
            "aria-label": _(o)("globalTranslations.close"),
            class: "d-image-gallery-modal__close-icon"
          }, null, 8, ["base-icon", "aria-label"])
        ]),
        content: Se(() => [
          ue(r0e, { model: e.model }, null, 8, ["model"])
        ]),
        _: 1
      }, 8, ["visible", "breakpoints", "append-to", "position"])
    ])) : te("", !0);
  }
});
const Qg = /* @__PURE__ */ Fe(l0e, [["__scopeId", "data-v-19dab2af"]]), c0e = { class: "d-image-gallery-teaser" }, d0e = /* @__PURE__ */ Be({
  __name: "ImageGalleryTeaser",
  props: {
    model: {
      type: Object,
      required: !0
    }
  },
  setup(e) {
    const t = e, { containerQueriesEnabled: n } = Bi(), { t: i } = Je(), { pageName: o } = Qe(), a = ge(!1);
    function r() {
      a.value = !0;
    }
    function s() {
      a.value = !1;
    }
    const l = () => ({
      contentUrl: "",
      title: t.model.buttonText ? t.model.buttonText : i("imageGalleryTeaser.gallery"),
      text: t.model.buttonText ? t.model.buttonText : i("imageGalleryTeaser.gallery"),
      isLocked: !1,
      target: "",
      isExternal: !1,
      linkType: yt.Javascript,
      tealiumTrackingModel: {
        eventSource: o,
        eventComponentName: "ImageGalleryTeaser",
        eventTitle: "Open image gallery"
      }
    }), d = Te(() => n.value ? "d-image-gallery-teaser-container--container" : "d-image-gallery-teaser-container--media");
    return (y, u) => {
      const m = $e("BaseHeading"), h = $e("BaseText");
      return e.model ? (E(), X("div", {
        key: 0,
        class: Pe(["d-image-gallery-teaser-container", [d.value]])
      }, [
        oe("div", c0e, [
          ue(WC, {
            "polygon-box-background-color": _(Ih).GreyBlue000,
            opacity: 1
          }, {
            default: Se(() => [
              ue(Fg, {
                image: e.model.mainImage ? e.model.mainImage : e.model.imageGallery?.images.at(0).image,
                "branded-image-variant": _(br).VariantA,
                "background-color": _(Eo).GreyBlue000,
                "aspect-ratio": _(on).None
              }, {
                content: Se(() => [
                  e.model.tinyHeadline ? (E(), fe(m, {
                    key: 0,
                    class: "d-image-gallery-teaser__tiny-headline",
                    "base-heading-type": _(ze).StyledAsH4
                  }, {
                    default: Se(() => [
                      Ve(Ie(e.model.tinyHeadline), 1)
                    ]),
                    _: 1
                  }, 8, ["base-heading-type"])) : te("", !0),
                  e.model.headline ? (E(), fe(m, {
                    key: 1,
                    class: "d-image-gallery-teaser__headline",
                    "base-heading-type": _(ze).H2Section
                  }, {
                    default: Se(() => [
                      Ve(Ie(e.model.headline), 1)
                    ]),
                    _: 1
                  }, 8, ["base-heading-type"])) : te("", !0),
                  e.model.descriptionText ? (E(), fe(h, {
                    key: 2,
                    class: "d-image-gallery-teaser__description",
                    text: e.model.descriptionText,
                    "max-length": 250
                  }, null, 8, ["text"])) : te("", !0),
                  ue(vt, {
                    class: "d-image-gallery-teaser__button",
                    "link-model": l(),
                    type: _(Ke).Primary,
                    size: _(et).Large,
                    "button-type": _(zt).Button,
                    icon: _(H).Images,
                    "icon-position": _(ct).Left,
                    onClick: r
                  }, null, 8, ["link-model", "type", "size", "button-type", "icon", "icon-position"])
                ]),
                _: 1
              }, 8, ["image", "branded-image-variant", "background-color", "aspect-ratio"])
            ]),
            _: 1
          }, 8, ["polygon-box-background-color"]),
          e.model.imageGallery ? (E(), fe(Qg, {
            key: 0,
            model: e.model.imageGallery,
            "open-dialog": a.value,
            onClose: s
          }, null, 8, ["model", "open-dialog"])) : te("", !0)
        ])
      ], 2)) : te("", !0);
    };
  }
});
const WBe = /* @__PURE__ */ Fe(d0e, [["__scopeId", "data-v-ba5ccf2c"]]);
var u0e = /* @__PURE__ */ ((e) => (e.KebabCase = "kebab-case", e))(u0e || {});
const h0e = {
  key: 0,
  class: "d-quiz-and-poll-explanation"
}, p0e = {
  key: 1,
  class: "d-quiz-and-poll-explanation__social"
}, f0e = { class: "d-quiz-and-poll-explanation__social-buttons" }, m0e = /* @__PURE__ */ Be({
  __name: "QuizAndPollExplanation",
  props: {
    explanation: {
      type: String,
      required: !0
    },
    question: {
      type: String,
      default: ""
    },
    isCorrect: {
      type: Boolean,
      default: void 0
    },
    shareButtons: {
      type: Array,
      default: () => []
    }
  },
  setup(e) {
    const t = e, { t: n } = Je(), i = () => Ue ? window.location.href : "", o = Te(() => Ma(t.explanation, {}));
    return (a, r) => {
      const s = $e("BaseText");
      return e.explanation ? (E(), X("div", h0e, [
        e.isCorrect !== void 0 ? (E(), fe(s, {
          key: 0,
          text: e.isCorrect ? _(n)("quizAndPoll.explanationHeadlineCorrect") : _(n)("quizAndPoll.explanationHeadlineInCorrect"),
          "font-type": _(lt).DwsSansBold,
          class: Pe(["d-quiz-and-poll-explanation__headline", {
            "d-quiz-and-poll-explanation__headline--correct": e.isCorrect,
            "d-quiz-and-poll-explanation__headline--incorrect": !e.isCorrect
          }])
        }, null, 8, ["text", "font-type", "class"])) : te("", !0),
        ue(ht, {
          class: "d-quiz-and-poll-explanation__text",
          "html-text": e.explanation
        }, null, 8, ["html-text"]),
        e.shareButtons?.length > 0 ? (E(), X("div", p0e, [
          ue(s, {
            text: _(n)("quizAndPoll.socialLabel"),
            "font-type": _(lt).DwsSlabBold,
            class: "d-quiz-and-poll-explanation__social-label"
          }, null, 8, ["text", "font-type"]),
          oe("div", f0e, [
            (E(!0), X(Re, null, Ge(e.shareButtons, (l) => (E(), X("div", {
              key: l,
              class: "d-quiz-and-poll-explanation__share-button"
            }, [
              ue(Lh, {
                model: {
                  network: l,
                  url: i(),
                  title: e.question,
                  description: o.value
                }
              }, null, 8, ["model"])
            ]))), 128))
          ])
        ])) : te("", !0)
      ])) : te("", !0);
    };
  }
});
const g0e = /* @__PURE__ */ Fe(m0e, [["__scopeId", "data-v-75b204c3"]]), v0e = {
  key: 0,
  class: "d-quiz-and-poll-card"
}, y0e = {
  key: 0,
  class: "d-quiz-and-poll-card__content"
}, b0e = { class: "d-quiz-and-poll-card__radio-button-group" }, x0e = { class: "d-quiz-and-poll-card__legend" }, w0e = { class: "d-quiz-and-poll-card__answer-id" }, k0e = {
  key: 1,
  class: "d-quiz-and-poll-card__resolved"
}, S0e = { class: "d-quiz-and-poll-card__resolved-icon" }, C0e = {
  key: 1,
  class: "d-quiz-and-poll-card__resolved-icon-poll"
}, T0e = { class: "d-quiz-and-poll-card__resolved-content" }, L0e = { class: "d-quiz-and-poll-card__resolved-text" }, I0e = { class: "d-quiz-and-poll-card__answer-id" }, P0e = {
  key: 0,
  class: "d-quiz-and-poll-card__resolved-share"
}, A0e = /* @__PURE__ */ Be({
  __name: "QuizAndPollCard",
  props: {
    model: {
      type: Object,
      required: !0
    },
    pollCallback: {
      type: Function,
      default: void 0
    }
  },
  emits: ["answer-selected"],
  setup(e, { emit: t }) {
    const n = e, i = ge(), o = t, a = ge(n.model.answers), r = (c) => i.value?.id === c, s = Te(() => (c) => !!(c.isCorrect || r(c.id))), l = Te(() => (c) => c.isCorrect ? H.CheckCircle : H.TimesCircle), d = Te(() => n.model.answers.map(
      (g) => ({
        id: g.id,
        name: g.text,
        toolTipText: ""
      })
    )), y = Te(() => ({
      isValid: !0,
      isDisabled: !1,
      items: d.value,
      tealiumTrackingModel: {
        eventSource: Qe().pageName,
        eventComponentName: "QuizAndPoll",
        eventTitle: "answer"
      }
    })), u = (c) => "isCorrect" in c ? c : void 0, m = (c) => "share" in c ? c : void 0, h = async (c) => {
      const g = a.value.find(
        (v) => v.id === c.id
      );
      if (n.pollCallback && m(g)) {
        const v = await n.pollCallback(
          g
        );
        a.value.forEach((P) => {
          const f = v.find((S) => S.id === P.id);
          f && (P.share = f.share), g.id === P.id && (g.share = f.share);
        });
      }
      i.value = g, o("answer-selected", g);
    };
    return qe(
      () => n.model.answers,
      (c) => {
        c && (a.value = c);
      }
    ), (c, g) => {
      const v = $e("BaseIcon"), P = $e("BaseHeading");
      return e.model ? (E(), X("div", v0e, [
        e.model.question ? (E(), X("div", y0e, [
          e.model.icon ? (E(), fe(v, {
            key: 0,
            class: "d-quiz-and-poll-card__icon",
            "base-icon": e.model.icon,
            "base-icon-size": _(at).L,
            "base-icon-color": e.model.iconBackgroundColor ? _(gt).White : _(gt).GreyBlue009,
            "base-icon-bg-color": e.model.iconBackgroundColor || _(ew).GreyBlue001,
            "base-icon-filled": !0
          }, null, 8, ["base-icon", "base-icon-size", "base-icon-color", "base-icon-bg-color"])) : te("", !0),
          ue(P, {
            "base-heading-type": _(ze).StyledAsH3,
            class: "d-quiz-and-poll-card__headline"
          }, {
            default: Se(() => [
              Ve(Ie(e.model.question), 1)
            ]),
            _: 1
          }, 8, ["base-heading-type"]),
          oe("fieldset", b0e, [
            oe("legend", x0e, Ie(e.model.question), 1),
            e.model.answers && e.model.answers.length > 0 ? (E(), X(Re, { key: 0 }, [
              i.value ? (E(), X("ul", k0e, [
                (E(!0), X(Re, null, Ge(a.value, (f) => (E(), X("li", {
                  key: f.text,
                  class: Pe(["d-quiz-and-poll-card__resolved-row", {
                    "d-quiz-and-poll-card__resolved-row--poll": m(f),
                    "d-quiz-and-poll-card__resolved-row--quiz": u(f),
                    "d-quiz-and-poll-card__resolved-row--correct": u(f)?.isCorrect,
                    "d-quiz-and-poll-card__resolved-row--incorrect": u(f) && !u(f).isCorrect && f.id === i.value.id
                  }])
                }, [
                  oe("span", S0e, [
                    u(f) && s.value(f) ? (E(), fe(v, {
                      key: 0,
                      "base-icon": l.value(f),
                      "base-icon-size": _(at).NextToText,
                      "base-icon-color": _(gt).Inherit
                    }, null, 8, ["base-icon", "base-icon-size", "base-icon-color"])) : te("", !0),
                    m(f) && r(f.id) ? (E(), X("div", C0e, g[0] || (g[0] = [
                      oe("div", { class: "d-quiz-and-poll-card__resolved-icon-poll__inner" }, null, -1)
                    ]))) : te("", !0)
                  ]),
                  oe("span", T0e, [
                    oe("span", L0e, [
                      oe("span", I0e, Ie(f.id) + ": ", 1),
                      oe("span", null, Ie(f.text), 1),
                      m(f) ? (E(), X("span", P0e, Ie(m(f)?.share) + " % ", 1)) : te("", !0)
                    ]),
                    m(f) ? (E(), fe(one, {
                      key: 0,
                      percent: m(f)?.share,
                      active: r(f.id)
                    }, null, 8, ["percent", "active"])) : te("", !0)
                  ])
                ], 2))), 128))
              ])) : (E(), fe(Vs, {
                key: 0,
                class: Pe(["d-quiz-and-poll-card__radio-button", {
                  "d-quiz-and-poll-card__radio-button--selected": i.value
                }]),
                model: y.value,
                onValueChanged: h
              }, {
                label: Se((f) => [
                  oe("span", w0e, Ie(f.item.id) + ": ", 1),
                  oe("span", null, Ie(f.item.name), 1)
                ]),
                _: 1
              }, 8, ["class", "model"]))
            ], 64)) : te("", !0)
          ]),
          ue(oo, null, {
            default: Se(() => [
              i.value ? (E(), fe(g0e, {
                key: 0,
                class: "d-quiz-and-poll-card__explanation",
                question: e.model.question,
                explanation: e.model.explanation,
                "is-correct": i.value?.isCorrect,
                "share-buttons": e.model.shareButtons
              }, null, 8, ["question", "explanation", "is-correct", "share-buttons"])) : te("", !0)
            ]),
            _: 1
          }),
          e.model.disclaimer ? (E(), fe(ht, {
            key: 1,
            class: "d-quiz-and-poll-card__disclaimer",
            "html-text": e.model.disclaimer
          }, null, 8, ["html-text"])) : te("", !0)
        ])) : te("", !0)
      ])) : te("", !0);
    };
  }
});
const _0e = /* @__PURE__ */ Fe(A0e, [["__scopeId", "data-v-36ebe031"]]), M0e = {
  key: 0,
  class: "d-quiz-and-poll"
}, O0e = { class: "d-quiz-and-poll__container" }, B0e = { class: "d-quiz-and-poll__content" }, E0e = { class: "d-quiz-and-poll__image" }, D0e = {
  key: 0,
  class: "d-quiz-and-poll__stripes"
}, R0e = /* @__PURE__ */ Be({
  __name: "QuizAndPoll",
  props: {
    model: {
      type: Object,
      required: !0
    },
    pollCallback: {
      type: Function,
      default: void 0
    }
  },
  emits: ["answer-selected"],
  setup(e, { emit: t }) {
    const n = t, i = (o) => {
      n("answer-selected", o);
    };
    return (o, a) => {
      const r = $e("BaseImage");
      return e.model ? (E(), X("div", M0e, [
        oe("div", O0e, [
          oe("div", B0e, [
            ue(_0e, {
              model: e.model,
              "poll-callback": e.pollCallback,
              onAnswerSelected: i
            }, null, 8, ["model", "poll-callback"]),
            oe("div", E0e, [
              ue(r, {
                model: e.model.image,
                "rounded-corner": !0,
                "aspect-ratio": _(on).None
              }, null, 8, ["model", "aspect-ratio"])
            ])
          ])
        ]),
        e.model.image ? (E(), X("div", D0e)) : te("", !0)
      ])) : te("", !0);
    };
  }
});
const YBe = /* @__PURE__ */ Fe(R0e, [["__scopeId", "data-v-5f35af91"]]), N0e = { class: "d-product-teaser-with-image__inner" }, $0e = {
  key: 0,
  class: "d-product-teaser-with-image__image"
}, F0e = { class: "d-product-teaser-with-image__product-data" }, j0e = { class: "d-product-teaser-with-image__product-data-inner" }, H0e = /* @__PURE__ */ Be({
  __name: "ProductTeaserWithImage",
  props: {
    model: {
      type: Object,
      required: !0
    }
  },
  setup(e) {
    const t = ge(), n = ge();
    it(() => {
      n.value = Gu(t.value);
    });
    const i = Te(() => n.value?.isDesktop ? on.None : on.TwoToOne);
    return (o, a) => {
      const r = $e("BaseHeading"), s = $e("BaseText");
      return e.model ? (E(), X("div", {
        key: 0,
        ref_key: "containerElement",
        ref: t,
        class: "d-product-teaser-with-image"
      }, [
        oe("div", N0e, [
          e.model.image ? (E(), X("div", $0e, [
            ue(di, {
              model: e.model.image,
              "rounded-corner": !0,
              "aspect-ratio": i.value
            }, null, 8, ["model", "aspect-ratio"])
          ])) : te("", !0),
          oe("div", F0e, [
            oe("div", j0e, [
              ue(r, {
                "base-heading-type": _(ze).StyledAsH3,
                class: "d-product-teaser-with-image__headline"
              }, {
                default: Se(() => [
                  Ve(Ie(e.model.headline), 1)
                ]),
                _: 1
              }, 8, ["base-heading-type"]),
              e.model.description ? (E(), fe(s, {
                key: 0,
                text: e.model.description,
                class: "d-product-teaser-with-image__description"
              }, null, 8, ["text"])) : te("", !0),
              e.model.dataList ? (E(), fe(Ar, {
                key: 1,
                model: e.model.dataList,
                class: "d-product-teaser-with-image__list"
              }, null, 8, ["model"])) : te("", !0),
              ue(vt, {
                "link-model": e.model.detailPageLink,
                type: _(Ke).Primary,
                "button-type": _(zt).Link,
                size: _(et).Large,
                class: "d-product-teaser-with-image__button"
              }, null, 8, ["link-model", "type", "button-type", "size"])
            ])
          ])
        ])
      ], 512)) : te("", !0);
    };
  }
});
const qBe = /* @__PURE__ */ Fe(H0e, [["__scopeId", "data-v-b8e49e0c"]]), z0e = {
  key: 0,
  class: "d-person-card"
}, V0e = { class: "d-person-card__image-container" }, G0e = {
  key: 1,
  class: "d-person-card__no-image"
}, U0e = { class: "d-person-card__info" }, W0e = /* @__PURE__ */ Be({
  __name: "PersonCard",
  props: {
    model: {
      type: Object,
      required: !0
    }
  },
  setup(e) {
    return (t, n) => e.model ? (E(), X("div", z0e, [
      oe("div", V0e, [
        e.model?.image && !e.model?.disableImage ? (E(), fe(_(di), {
          key: 0,
          model: e.model?.image,
          "responsive-options": [
            {
              height: 72,
              width: 72,
              dxBreakpoint: _(Ct).Xs
            }
          ],
          class: "d-person-card__image"
        }, null, 8, ["model", "responsive-options"])) : te("", !0),
        !e.model?.image || e.model?.disableImage ? (E(), X("div", G0e, [
          ue(_(_t), {
            "base-icon": _(H).User,
            "base-icon-size": _(at).Inherit,
            "base-icon-color": _(gt).Inherit
          }, null, 8, ["base-icon", "base-icon-size", "base-icon-color"])
        ])) : te("", !0)
      ]),
      oe("div", U0e, [
        e.model?.name ? (E(), fe(_(Tt), {
          key: 0,
          text: e.model?.name,
          "font-type": _(lt).DwsSlabBold,
          "font-size": _(st).SixteenPx,
          "text-color": _(dt).GreyBlue009
        }, null, 8, ["text", "font-type", "font-size", "text-color"])) : te("", !0),
        e.model?.position ? (E(), fe(_(Tt), {
          key: 1,
          text: e.model?.position,
          "font-type": _(lt).DwsSlab,
          "font-size": _(st).FourteenPx,
          "text-color": _(dt).GreyBlue006
        }, null, 8, ["text", "font-type", "font-size", "text-color"])) : te("", !0)
      ])
    ])) : te("", !0);
  }
});
const Y0e = /* @__PURE__ */ Fe(W0e, [["__scopeId", "data-v-d8536e9f"]]), q0e = {
  key: 0,
  class: "d-person-card-block"
}, K0e = /* @__PURE__ */ Be({
  __name: "PersonCardBlock",
  props: {
    model: {
      type: Object,
      required: !0
    }
  },
  setup(e) {
    return (t, n) => e.model && e.model?.personCards?.length > 0 ? (E(), X("div", q0e, [
      (E(!0), X(Re, null, Ge(e.model?.personCards, (i, o) => (E(), fe(Y0e, {
        key: o,
        model: i
      }, null, 8, ["model"]))), 128))
    ])) : te("", !0);
  }
});
const X0e = /* @__PURE__ */ Fe(K0e, [["__scopeId", "data-v-49b2da1b"]]), Z0e = { class: "d-article-header__intro" }, J0e = /* @__PURE__ */ Be({
  __name: "ArticleHeader",
  props: {
    model: {
      type: Object,
      required: !0
    }
  },
  setup(e) {
    const t = e, n = (r) => r == null ? !0 : typeof r != "object" ? !r : Object.values(r).every(
      (s) => typeof s == "object" && s !== null ? n(s) : s == null || !s
    ), i = Te(() => {
      const { headline: r, tags: s, date: l, isImageFullWidth: d, ...y } = t.model, u = r != null, m = n(y);
      return u && m;
    }), o = Te(() => {
      const { headline: r, introText: s, tags: l, date: d, isImageFullWidth: y, ...u } = t.model, m = s != null, h = n(u);
      return m && h;
    }), a = Te(() => t?.model?.isImageFullWidth ? on.Original : on.TwoToOne);
    return (r, s) => e.model ? (E(), X("div", {
      key: 0,
      class: Pe(["d-article-header", { "d-article-header--no-margin-bottom": i.value }])
    }, [
      e.model ? (E(), fe(_(Vt), {
        key: 0,
        id: "article-header",
        "no-margin-bottom": !0
      }, {
        default: Se(() => [
          oe("div", Z0e, [
            e.model?.headline ? (E(), fe(_(Ot), {
              key: 0,
              class: Pe(["d-article-header__heading d-article-header__two-third", { "d-article-header__heading--no-intro": !e.model?.introText }]),
              "base-heading-type": _(ze).H1
            }, {
              default: Se(() => [
                Ve(Ie(e.model?.headline), 1)
              ]),
              _: 1
            }, 8, ["class", "base-heading-type"])) : te("", !0),
            e.model?.tags ? (E(), fe(_(Ch), {
              key: 1,
              class: "d-article-header__tags",
              tags: e.model?.tags,
              "align-right": !0
            }, null, 8, ["tags"])) : te("", !0),
            e.model?.date ? (E(), fe(_(Tt), {
              key: 2,
              text: e.model?.date,
              "font-size": _(st).TwelvePx,
              "font-type": _(lt).DwsSlabBold,
              "text-color": _(dt).GreyBlue009,
              class: "d-article-header__date-area"
            }, null, 8, ["text", "font-size", "font-type", "text-color"])) : te("", !0),
            e.model?.introText ? (E(), fe(_(ht), {
              key: 3,
              "html-text": e.model?.introText,
              class: Pe(["d-article-header__intro-text d-article-header__two-third", {
                "d-article-header__intro-text--no-margin-bottom": o.value
              }])
            }, null, 8, ["html-text", "class"])) : te("", !0)
          ])
        ]),
        _: 1
      })) : te("", !0),
      e.model?.authors && e.model?.authors?.personCards?.length > 0 ? (E(), fe(_(Vt), {
        key: 1,
        id: "article-header-author-area",
        class: "d-article-header__author-area",
        "no-margin-bottom": !0
      }, {
        default: Se(() => [
          ue(_(X0e), {
            model: e.model?.authors
          }, null, 8, ["model"])
        ]),
        _: 1
      })) : te("", !0),
      e.model?.image ? (E(), fe(_(Vt), {
        key: 2,
        id: "article-header-image-area",
        "content-in-full-width": e.model?.isImageFullWidth,
        "no-margin-bottom": !0
      }, {
        default: Se(() => [
          e.model?.image ? (E(), fe(_(di), {
            key: 0,
            model: e.model?.image,
            "aspect-ratio": a.value,
            "rounded-corner": !e.model?.isImageFullWidth
          }, null, 8, ["model", "aspect-ratio", "rounded-corner"])) : te("", !0)
        ]),
        _: 1
      }, 8, ["content-in-full-width"])) : te("", !0),
      e.model?.imageDescription ? (E(), fe(_(Vt), {
        key: 3,
        id: "article-header-image-description",
        "no-margin-bottom": !0
      }, {
        default: Se(() => [
          e.model?.imageDescription ? (E(), fe(_(ht), {
            key: 0,
            class: "d-article-header__image-description",
            "html-text": e.model?.imageDescription
          }, null, 8, ["html-text"])) : te("", !0)
        ]),
        _: 1
      })) : te("", !0)
    ], 2)) : te("", !0);
  }
});
const Q0e = /* @__PURE__ */ Fe(J0e, [["__scopeId", "data-v-7c4ced9b"]]), e1e = "jumpmark-anchor", em = (e) => `${e1e}-${e}`, t1e = /* @__PURE__ */ Be({
  __name: "JumpmarkLink",
  props: {
    model: {
      type: Object,
      required: !0
    },
    eventComponentName: {
      type: String,
      default: "jumpmark-link"
    }
  },
  emits: ["click"],
  setup(e, { emit: t }) {
    const n = e, { pageName: i } = Qe(), { calculateScrollPosition: o } = Fn(), a = t, r = (y, u) => {
      l(), a("click", y, u);
    }, s = $t("smoothScroll");
    async function l() {
      if (await mt(), Ue) {
        const y = document.getElementById(em(n.model.id));
        y && s({
          scrollTo: o(y) || 0,
          duration: 1e3,
          updateHistory: !1
        });
      }
    }
    const d = Te(() => ({
      href: `#${em(n.model.id)}`,
      contentUrl: "",
      title: n.model.label,
      text: n.model.label,
      target: "_self",
      isLocked: !1,
      isExternal: !1,
      linkType: yt.Javascript,
      tealiumTrackingModel: {
        eventSource: i,
        eventComponentName: n.eventComponentName,
        eventTitle: n.model.label
      }
    }));
    return (y, u) => {
      const m = $e("BaseLinkV2");
      return e.model ? (E(), fe(m, {
        key: 0,
        "link-model": d.value,
        icon: _(H).ArrowDown,
        "icon-position": _(ct).Left,
        class: "d-jumpmark-link",
        onClick: u[0] || (u[0] = (h) => r(h, e.model.id))
      }, null, 8, ["link-model", "icon", "icon-position"])) : te("", !0);
    };
  }
}), tL = /* @__PURE__ */ Ha("jumpmark", () => {
  const e = ge({}), t = (o) => {
    e.value[o.pageId] || (e.value[o.pageId] = []);
    const a = e.value[o.pageId];
    a.includes(o) || a.push(o);
  }, n = (o) => {
    if (e.value[o.pageId]) {
      const a = e.value[o.pageId];
      if (a.includes(o)) {
        const r = a.indexOf(o);
        a.splice(r, 1);
      }
      a.length === 0 && delete e.value[o.pageId];
    }
  };
  return {
    getList: Te(() => (o) => e.value[o]),
    add: t,
    remove: n
  };
}), n1e = {
  key: 0,
  class: "d-jumpmark-overview"
}, i1e = /* @__PURE__ */ Be({
  __name: "JumpmarkOverview",
  props: {
    pageId: {
      type: String,
      default: "page-id"
    },
    eventComponentName: {
      type: String,
      default: void 0
    }
  },
  emits: ["jumpmark-click"],
  setup(e, { emit: t }) {
    const n = e, i = tL(), o = t, a = (s, l) => {
      o("jumpmark-click", s, l);
    }, r = Te(() => i.getList(n.pageId));
    return (s, l) => r.value && r.value.length > 0 ? (E(), X("div", n1e, [
      (E(!0), X(Re, null, Ge(r.value, (d) => (E(), fe(t1e, {
        key: d.label,
        model: d,
        "event-component-name": e.eventComponentName,
        onClick: (y) => a(y, d.id)
      }, null, 8, ["model", "event-component-name", "onClick"]))), 128))
    ])) : te("", !0);
  }
});
const a1e = /* @__PURE__ */ Fe(i1e, [["__scopeId", "data-v-a4f1d11d"]]), o1e = {
  key: 0,
  class: "d-article-page-overview"
}, r1e = {
  key: 1,
  class: "d-article-page-overview__jumpmarks"
}, s1e = /* @__PURE__ */ Be({
  __name: "ArticlePageOverview",
  props: {
    model: {
      type: Object,
      required: !0
    }
  },
  emits: ["jumpmark-click"],
  setup(e, { emit: t }) {
    const n = t, i = (o, a) => {
      n("jumpmark-click", o, a);
    };
    return (o, a) => {
      const r = $e("BaseHeading");
      return e.model ? (E(), X("div", o1e, [
        ue(r, {
          "base-heading-type": _(ze).H2Section,
          class: "d-article-page-overview__header"
        }, {
          default: Se(() => [
            Ve(Ie(e.model.headline), 1)
          ]),
          _: 1
        }, 8, ["base-heading-type"]),
        e.model.bulletItems && e.model.bulletItems.length > 0 ? (E(), fe($c, {
          key: 0,
          "list-items": e.model.bulletItems,
          class: "d-article-page-overview__bullets"
        }, null, 8, ["list-items"])) : (E(), X("div", r1e, [
          ue(a1e, {
            "page-id": e.model.pageId,
            "event-component-name": "article-jumpmark",
            onJumpmarkClick: i
          }, null, 8, ["page-id"])
        ]))
      ])) : te("", !0);
    };
  }
});
const l1e = /* @__PURE__ */ Fe(s1e, [["__scopeId", "data-v-d05cbf88"]]), c1e = ["id"], d1e = /* @__PURE__ */ Be({
  __name: "JumpmarkAnchor",
  props: {
    model: {
      type: Object,
      required: !0
    }
  },
  setup(e) {
    const t = e, n = tL();
    return it(() => {
      n.add(t.model);
    }), sn(() => {
      n.remove(t.model);
    }), (i, o) => e.model ? (E(), X("span", {
      key: 0,
      id: _(em)(e.model.id),
      class: "d-jumpmark-anchor"
    }, null, 8, c1e)) : te("", !0);
  }
});
const KBe = /* @__PURE__ */ Fe(d1e, [["__scopeId", "data-v-3e409f35"]]), u1e = { class: "d-teaser-hero__content" }, h1e = { class: "d-teaser-hero__content--box" }, p1e = { class: "d-teaser-hero__image-container" }, f1e = /* @__PURE__ */ Be({
  __name: "TeaserHeroLayout",
  props: {
    model: {
      type: Object,
      required: !0
    }
  },
  setup(e, { expose: t }) {
    const n = (s) => s.image, i = ge(null);
    t({
      teaserHeroItemContent: i
    });
    const o = ge(), a = () => {
      if (Ue && o.value) {
        const s = window.getComputedStyle(o.value) || o.value?.currentStyle.marginLeft;
        i.value.children[0].children[0].style.marginLeft = s.marginLeft;
      }
    };
    it(() => {
      a();
    });
    const { width: r } = Ts();
    return qe(
      () => r.value,
      () => {
        a();
      }
    ), (s, l) => {
      const d = $e("BaseImage");
      return E(), X(Re, null, [
        oe("div", {
          ref_key: "containerRef",
          ref: o,
          class: "container",
          "aria-hidden": "true"
        }, null, 512),
        oe("div", {
          ref_key: "teaserHeroItemContent",
          ref: i,
          class: "d-teaser-hero"
        }, [
          oe("div", u1e, [
            oe("div", h1e, [
              je(s.$slots, "teaser-hero-item-content", {}, void 0, !0)
            ])
          ]),
          oe("div", p1e, [
            l[0] || (l[0] = oe("div", { class: "d-teaser-hero__triangle" }, null, -1)),
            n(e.model) ? (E(), fe(d, {
              key: 0,
              model: e.model?.image,
              "aspect-ratio": _(on).None,
              class: "d-teaser-hero__image"
            }, null, 8, ["model", "aspect-ratio"])) : te("", !0)
          ])
        ], 512)
      ], 64);
    };
  }
});
const nL = /* @__PURE__ */ Fe(f1e, [["__scopeId", "data-v-c9748c8a"]]), m1e = { class: "d-market-data-block-content" }, g1e = { class: "d-market-data-block-content--heading-and-text" }, v1e = { class: "d-market-data-block-content__label" }, y1e = { class: "d-market-data-block-content__name" }, b1e = { class: "d-market-data-block-content__trading-platform" }, x1e = { class: "d-market-data-block-content__price-and-trend" }, w1e = { class: "d-market-data-block-content__price-and-trend__price" }, k1e = { class: "d-market-data-block-content__price-and-trend__price__value" }, S1e = { class: "d-market-data-block-content__price-and-trend__price__currency" }, C1e = { class: "d-market-data-block-content__price-and-trend__trend" }, T1e = {
  key: 0,
  class: "d-market-data-block-content__button_container"
}, L1e = /* @__PURE__ */ Be({
  __name: "MarketDataBlockContent",
  props: {
    model: {
      type: Object,
      required: !0
    }
  },
  setup(e) {
    const { t } = Je(), { pageName: n } = Qe(), i = e, o = () => `${t("marketDataBlock.intraday")}  (${i.model.tradingPlatform}, ${i.model.dateAndTime})`, a = (r) => ({
      ...r,
      tealiumTrackingModel: {
        eventSource: n,
        eventComponentName: "hero-teaser",
        eventTitle: r.title,
        eventTarget: r.href
      }
    });
    return (r, s) => {
      const l = $e("BaseHeading"), d = $e("BaseText");
      return E(), X("div", m1e, [
        oe("div", g1e, [
          ue(l, {
            "base-heading-type": _(ze).StyledAsH2,
            class: "d-market-data-block-content__heading"
          }, {
            default: Se(() => [
              Ve(Ie(e.model.headline), 1)
            ]),
            _: 1
          }, 8, ["base-heading-type"]),
          e.model.description ? (E(), fe(d, {
            key: 0,
            text: e.model.description,
            "max-length": 200,
            "clipped-after-last-word": !0,
            class: "d-market-data-block-content__text"
          }, null, 8, ["text"])) : te("", !0),
          oe("span", v1e, Ie(e.model.label), 1),
          oe("div", y1e, Ie(e.model.name), 1),
          oe("div", b1e, Ie(o()), 1),
          oe("div", x1e, [
            oe("div", w1e, [
              oe("span", k1e, Ie(e.model.price.value), 1),
              oe("span", S1e, Ie(e.model.price.currency), 1)
            ]),
            oe("div", C1e, [
              ue(ad, {
                number: e.model.price.trend.number,
                "additional-value": e.model.price.trend.additionalValue,
                "with-icon": !0,
                "add-percent-to-additional-value": !0,
                "zero-interpretation": e.model.price.trend.zeroInterpretation
              }, null, 8, ["number", "additional-value", "zero-interpretation"])
            ])
          ])
        ]),
        e.model.buttonModel ? (E(), X("div", T1e, [
          ue(vt, {
            "link-model": a(e.model.buttonModel),
            type: _(Ke).Primary,
            size: _(et).Large,
            "button-type": _(zt).Link,
            class: "d-market-data-block-content__button"
          }, null, 8, ["link-model", "type", "size", "button-type"])
        ])) : te("", !0)
      ]);
    };
  }
});
const I1e = /* @__PURE__ */ Fe(L1e, [["__scopeId", "data-v-8387efe4"]]), P1e = {
  key: 0,
  class: "d-market-data-block"
}, XBe = /* @__PURE__ */ Be({
  __name: "MarketDataBlock",
  props: {
    model: {
      type: Object,
      required: !0
    }
  },
  setup(e) {
    return (t, n) => e.model ? (E(), X("div", P1e, [
      ue(nL, { model: e.model }, {
        "teaser-hero-item-content": Se(() => [
          ue(I1e, {
            model: e.model.itemContent
          }, null, 8, ["model"])
        ]),
        _: 1
      }, 8, ["model"])
    ])) : te("", !0);
  }
}), A1e = { class: "d-teaser-event" }, _1e = {
  class: "d-teaser-event__calendar-icon",
  "aria-hidden": "true"
}, M1e = { class: "d-teaser-event__box" }, O1e = { class: "d-teaser-event__box__title" }, B1e = { class: "d-teaser-event__box__date" }, E1e = {
  key: 0,
  class: "mr-2"
}, D1e = { class: "d-teaser-event__box__location" }, R1e = /* @__PURE__ */ Be({
  __name: "TeaserEvent",
  props: {
    teaserEventViewModel: {
      type: Object,
      required: !0
    }
  },
  setup(e) {
    const t = e, n = ge(), i = ge(), { t: o } = Je(), a = Te(() => {
      const { teaserDetailLink: s, title: l } = t.teaserEventViewModel || {};
      return s?.text ? s : {
        ...s,
        text: l
      };
    });
    it(() => {
      i.value = n?.value.linkRef, pn({
        trigger: i,
        headline: t.teaserEventViewModel.calendarFileIconLink?.title,
        content: t.teaserEventViewModel.calendarFileIconLink?.title,
        appendTo: i.value,
        showOnTouchDevices: !1,
        field: () => i.value
      });
    });
    const r = Te(() => t.teaserEventViewModel?.location ? t.teaserEventViewModel?.location?.length > 0 : !1);
    return (s, l) => (E(), X("div", A1e, [
      oe("div", _1e, [
        ue(_(_t), {
          "base-icon": _(H).CalendarDay
        }, null, 8, ["base-icon"])
      ]),
      oe("div", M1e, [
        oe("div", O1e, [
          e.teaserEventViewModel.title && !e.teaserEventViewModel?.teaserDetailLink ? (E(), fe(_(Tt), {
            key: 0,
            text: e.teaserEventViewModel.title,
            "font-size": _(st).TwentyFour,
            "font-type": _(lt).DwsSlabBold,
            class: "d-teaser-event__box__title--text"
          }, null, 8, ["text", "font-size", "font-type"])) : e.teaserEventViewModel.teaserDetailLink ? (E(), fe(ot, {
            key: 1,
            "link-model": a.value,
            "font-size": _(zi).TwentyFourPx
          }, null, 8, ["link-model", "font-size"])) : te("", !0)
        ]),
        oe("div", B1e, [
          Ve(Ie(t.teaserEventViewModel.startDate), 1),
          e.teaserEventViewModel.time ? (E(), X("span", E1e, " // " + Ie(t.teaserEventViewModel.time), 1)) : te("", !0),
          e.teaserEventViewModel.calendarFileIconLink ? (E(), fe(ot, {
            key: 1,
            "aria-label": e.teaserEventViewModel.calendarFileIconLink.title,
            class: "inline-block d-teaser-event__box__date__mobile",
            "link-model": e.teaserEventViewModel.calendarFileIconLink,
            icon: e.teaserEventViewModel.calendarFileIcon,
            "icon-position": _(ct).Right
          }, null, 8, ["aria-label", "link-model", "icon", "icon-position"])) : te("", !0),
          e.teaserEventViewModel.calendarFileIconLink ? (E(), fe(ot, {
            key: 2,
            ref_key: "calenderFileIconTooltipTrigger",
            ref: n,
            "aria-label": _(o)("calendarPage.icalDownload", {
              eventTitle: e.teaserEventViewModel.title
            }),
            class: "inline-block d-teaser-event__box__date__desktop",
            "link-model": e.teaserEventViewModel.calendarFileIconLink,
            icon: e.teaserEventViewModel.calendarFileIcon,
            "icon-position": _(ct).Right,
            "has-text": !1
          }, null, 8, ["aria-label", "link-model", "icon", "icon-position"])) : te("", !0)
        ]),
        oe("div", D1e, Ie(r.value ? e.teaserEventViewModel.location : e.teaserEventViewModel.eventType), 1)
      ])
    ]));
  }
});
const tm = /* @__PURE__ */ Fe(R1e, [["__scopeId", "data-v-c6eb289f"]]), N1e = { class: "d-teaser-events" }, $1e = {
  key: 0,
  class: "d-teaser-events__heading"
}, F1e = { class: "d-teaser-events__events" }, j1e = { class: "d-teaser-events__mobile" }, H1e = { class: "d-teaser-events__desktop" }, z1e = /* @__PURE__ */ Be({
  __name: "TeaserEvents",
  props: {
    teaserEvents: {
      type: Object,
      required: !0
    }
  },
  setup(e) {
    const t = e, n = Te(
      () => t.teaserEvents.teasers ? t.teaserEvents.teasers.map((i) => i.model) : []
    );
    return (i, o) => {
      const a = $e("BaseHeading"), r = $e("BaseText");
      return E(), X("div", N1e, [
        e.teaserEvents?.title ? (E(), X("div", $1e, [
          ue(a, {
            "base-heading-type": _(ze).H2
          }, {
            default: Se(() => [
              Ve(Ie(e.teaserEvents?.title), 1)
            ]),
            _: 1
          }, 8, ["base-heading-type"])
        ])) : te("", !0),
        oe("div", F1e, [
          e.teaserEvents.teasers ? (E(), X(Re, { key: 0 }, [
            oe("div", j1e, [
              (E(!0), X(Re, null, Ge(e.teaserEvents?.teasers, (s) => (E(), fe(tm, {
                key: s,
                class: "d-teaser-events__teaser",
                "teaser-event-view-model": s.model
              }, null, 8, ["teaser-event-view-model"]))), 128)),
              e.teaserEvents.moreTeasersLink ? (E(), fe(ot, {
                key: 0,
                class: "teaser-link",
                "link-model": e.teaserEvents.moreTeasersLink,
                icon: _(H).ArrowRight
              }, null, 8, ["link-model", "icon"])) : te("", !0)
            ]),
            oe("div", H1e, [
              ue(zs, {
                items: n.value,
                "base-link": e.teaserEvents?.moreTeasersLink,
                "responsive-options": e.teaserEvents?.responsiveOptions
              }, {
                item: Se((s) => [
                  ue(tm, {
                    "teaser-event-view-model": s.data
                  }, null, 8, ["teaser-event-view-model"])
                ]),
                _: 1
              }, 8, ["items", "base-link", "responsive-options"])
            ])
          ], 64)) : (E(), X(Re, { key: 1 }, [
            e.teaserEvents.noTeasersText ? (E(), fe(r, {
              key: 0,
              text: e.teaserEvents.noTeasersText
            }, null, 8, ["text"])) : te("", !0)
          ], 64))
        ])
      ]);
    };
  }
});
const V1e = /* @__PURE__ */ Fe(z1e, [["__scopeId", "data-v-62618b0f"]]), G1e = { class: "d-event-list-item" }, U1e = { class: "d-event-list-item__event-name" }, W1e = { class: "d-event-list-item__event-name__title" }, Y1e = { class: "d-event-list-item__event-name__location" }, q1e = {
  key: 0,
  class: "d-event-list-item__date-block"
}, K1e = { class: "d-event-list-item__date-block__date" }, X1e = { class: "d-event-list-item__date-block__time-and-icon" }, Z1e = {
  key: 0,
  class: "d-event-list-item__date-block__time-and-icon__time"
}, J1e = {
  key: 1,
  class: "d-event-list-item__date-block__time-and-icon__icon"
}, Q1e = {
  key: 1,
  class: "d-event-list-item__download"
}, exe = /* @__PURE__ */ Be({
  __name: "EventListItem",
  props: {
    model: {
      type: Object,
      required: !0
    },
    showTime: {
      type: Boolean,
      default: !0
    }
  },
  setup(e) {
    const { pageName: t } = Qe(), n = e, { t: i } = Je(), o = () => n.model.eventLink ? At(ot, {
      linkModel: l(n.model.eventLink),
      fontSize: yn.EighteenPx
    }) : At(
      Ot,
      {
        baseHeadingType: ze.H4
      },
      () => n.model.eventName
    ), a = (d) => typeof d == "object" && d !== null ? d.title : d, r = (d) => ({
      ...d,
      tealiumTrackingModel: {
        eventSource: t,
        eventComponentName: "event-teaser-ical",
        eventTitle: a(n.model.eventName)
      }
    }), s = (d) => ({
      ...d,
      tealiumTrackingModel: {
        eventSource: t,
        eventComponentName: "Download-Button",
        eventTitle: d.title
      }
    }), l = (d) => ({
      ...d,
      tealiumTrackingModel: {
        eventSource: t,
        eventComponentName: "Event-link",
        eventTitle: d.title,
        eventTarget: d.href
      }
    });
    return (d, y) => (E(), X("div", G1e, [
      oe("div", U1e, [
        oe("div", W1e, [
          (E(), fe(tt(o)))
        ]),
        oe("div", Y1e, Ie(e.model.location), 1)
      ]),
      e.model.date ? (E(), X("div", q1e, [
        oe("div", K1e, Ie(e.model.date), 1),
        oe("div", X1e, [
          e.model.time ? (E(), X("div", Z1e, Ie(e.model.time), 1)) : te("", !0),
          e.model.calenderFileLink ? (E(), X("div", J1e, [
            ue(ot, {
              "aria-label": _(i)("calendarPage.icalDownload", {
                eventTitle: a(e.model.eventName)
              }),
              "link-model": r(e.model.calenderFileLink),
              icon: _(H).CalendarPlus,
              "has-text": !1
            }, null, 8, ["aria-label", "link-model", "icon"])
          ])) : te("", !0)
        ])
      ])) : te("", !0),
      e.model.downloadLinks ? (E(), X("div", Q1e, [
        (E(!0), X(Re, null, Ge(e.model.downloadLinks, (u) => (E(), fe(ot, {
          key: u.title,
          "aria-label": u.title,
          "link-model": s(u),
          icon: _(H).Download,
          "icon-position": _(ct).Left
        }, null, 8, ["aria-label", "link-model", "icon", "icon-position"]))), 128))
      ])) : te("", !0)
    ]));
  }
});
const txe = /* @__PURE__ */ Fe(exe, [["__scopeId", "data-v-e2233aa8"]]), nxe = {
  key: 0,
  class: "d-event-list"
}, ixe = { class: "d-event-list__event-list__header" }, axe = { class: "d-event-list__event-list__header__date-and-time" }, oxe = { class: "d-event-list__event-list__header__event" }, rxe = {
  key: 0,
  class: "d-event-list__event-list__header__download"
}, sxe = /* @__PURE__ */ Be({
  __name: "EventList",
  props: {
    model: {
      type: Object,
      required: !0
    }
  },
  setup(e) {
    const { t } = Je(), n = (o) => o.showTime ? t("eventList.date") + " / " + t("eventList.time") : t("eventList.date"), i = (o) => o.some(
      (a) => a.downloadLinks && a.downloadLinks.length > 0
    );
    return (o, a) => {
      const r = $e("BaseHeading");
      return e.model ? (E(), X("div", nxe, [
        (E(!0), X(Re, null, Ge(e.model.items, (s) => (E(), X("div", {
          key: s.headline,
          class: Pe([
            "d-event-list__event-list",
            i(s.events) ? "hasDownloadLinks" : ""
          ])
        }, [
          ue(r, {
            "base-heading-type": _(ze).H3LooksLikeH2Section,
            class: "d-event-list__event-list__heading"
          }, {
            default: Se(() => [
              Ve(Ie(s.headline), 1)
            ]),
            _: 2
          }, 1032, ["base-heading-type"]),
          oe("div", ixe, [
            oe("div", axe, Ie(n(s)), 1),
            oe("div", oxe, Ie(_(t)("eventList.event")), 1),
            i(s.events) ? (E(), X("div", rxe, Ie(_(t)("eventList.download")), 1)) : te("", !0)
          ]),
          (E(!0), X(Re, null, Ge(s.events, (l) => (E(), fe(txe, {
            key: l.eventName + l.date,
            model: l,
            "show-time": s.showTime
          }, null, 8, ["model", "show-time"]))), 128))
        ], 2))), 128))
      ])) : te("", !0);
    };
  }
});
const lxe = /* @__PURE__ */ Fe(sxe, [["__scopeId", "data-v-1e9d2760"]]), cxe = {
  key: 0,
  class: "d-calendar"
}, dxe = { class: "d-calendar__header" }, uxe = {
  key: 1,
  class: "d-calendar__teaser-events--mobile"
}, hxe = /* @__PURE__ */ Be({
  __name: "Calendar",
  props: {
    model: {
      type: Object,
      required: !0
    }
  },
  emits: ["filterChanged"],
  setup(e, { emit: t }) {
    const n = e, i = t, { isMobileAsync: o } = xt(), { pageName: a } = Qe(), r = Te(
      () => n.model.teaserEvents.teasers ? n.model.teaserEvents.teasers.map((y) => y.model) : []
    ), s = (y, u) => {
      i("filterChanged", y, u);
    }, l = {
      breakpoint: "1279px",
      numVisible: 2,
      numScroll: 1
    }, d = {
      breakpoint: "767px",
      numVisible: 2,
      numScroll: 1
    };
    return it(() => {
      n.model.teaserEvents.responsiveOptions = [l, d];
    }), (y, u) => e.model ? (E(), X("div", cxe, [
      ue(Vt, {
        id: _(Pn)(),
        "no-margin-bottom": !0,
        "no-margin": !0
      }, {
        default: Se(() => [
          oe("div", dxe, [
            e.model.headline ? (E(), fe(_(Ot), {
              key: 0,
              class: "d-calendar__header__headline",
              "base-heading-type": _(ze).H1
            }, {
              default: Se(() => [
                Ve(Ie(e.model.headline), 1)
              ]),
              _: 1
            }, 8, ["base-heading-type"])) : te("", !0),
            e.model.intro ? (E(), fe(ht, {
              key: 1,
              "html-text": e.model.intro,
              class: "d-calendar__header__intro"
            }, null, 8, ["html-text"])) : te("", !0),
            e.model.eventHeadline ? (E(), fe(_(Ot), {
              key: 2,
              class: "d-calendar__header__event-headline",
              "base-heading-type": _(ze).H2Section
            }, {
              default: Se(() => [
                Ve(Ie(e.model.eventHeadline), 1)
              ]),
              _: 1
            }, 8, ["base-heading-type"])) : te("", !0)
          ]),
          e.model.teaserEvents && !_(o) ? (E(), fe(_(V1e), {
            key: 0,
            class: "d-calendar__teaser-events",
            "teaser-events": e.model.teaserEvents
          }, null, 8, ["teaser-events"])) : te("", !0),
          _(o) ? (E(), X("div", uxe, [
            (E(!0), X(Re, null, Ge(r.value, (m) => (E(), fe(tm, {
              key: m.title,
              "teaser-event-view-model": m
            }, null, 8, ["teaser-event-view-model"]))), 128))
          ])) : te("", !0),
          e.model.timeFilter ? (E(), fe(_(Ah), {
            key: 2,
            class: "d-calendar__time-filter",
            "event-component-name": "Tab Control",
            "data-event-source": _(a),
            filter: e.model.timeFilter,
            "show-tabs-with-no-results": !0,
            onSingleSelectValueChanged: s
          }, null, 8, ["data-event-source", "filter"])) : te("", !0),
          ue(lxe, {
            model: e.model.eventList
          }, null, 8, ["model"])
        ]),
        _: 1
      }, 8, ["id"])
    ])) : te("", !0);
  }
});
const ZBe = /* @__PURE__ */ Fe(hxe, [["__scopeId", "data-v-baeb9850"]]);
var Ui = /* @__PURE__ */ ((e) => (e.Visible = "visible", e.Hidden = "hidden", e.VisibleOnlyOnDesktop = "visible-only-on-desktop", e))(Ui || {}), $a = /* @__PURE__ */ ((e) => (e.OneToTwo = "one-to-two", e.OneToThree = "one-to-three", e.ThreeToOne = "three-to-one", e.OneToFour = "one-to-four", e))($a || {}), Rt = /* @__PURE__ */ ((e) => (e.Half = "half", e.OneThird = "one-third", e.Full = "full", e))(Rt || {}), Kn = /* @__PURE__ */ ((e) => (e.Text = "text", e.Document = "document", e.VideoTeaser = "video-teaser", e.VideoPlayer = "video-player", e.DocumentArchivePage = "document-archive-page", e))(Kn || {}), cn = /* @__PURE__ */ ((e) => (e.None = "none", e.Link = "link", e.LinkCorner = "link-corner", e.PrimaryButton = "primary-button", e.SecondaryButton = "secondary-button", e))(cn || {}), ev = /* @__PURE__ */ ((e) => (e.Left = "left", e.Right = "right", e))(ev || {});
const pxe = { class: "d-teaser-box__info" }, fxe = { class: "d-teaser-box__footer-links" }, mxe = /* @__PURE__ */ Be({
  __name: "Teaser",
  props: {
    teaserBox: {
      type: Object,
      required: !0
    },
    layout: {
      type: String,
      default: Rt.OneThird
    },
    fullLayout: {
      type: String,
      default: $a.OneToThree
    },
    picture: {
      type: String,
      default: Ui.Visible
    },
    description: {
      type: String,
      default: Ui.Visible
    },
    ctaElementType: {
      type: String,
      default: cn.None
    },
    fontSize: {
      type: String,
      default: st.SixteenPx
    },
    pictureRoundedCorner: {
      type: Boolean,
      default: !1
    },
    contentPadding: {
      type: Boolean,
      default: !0
    },
    showTags: {
      type: Boolean,
      default: !0
    },
    showDate: {
      type: Boolean,
      default: !0
    },
    clippingText: {
      type: Boolean,
      default: !0
    },
    videoIsRunning: {
      type: Boolean,
      default: !1
    },
    pt: {
      type: Object,
      default: void 0
    },
    linkCorner: {
      type: Boolean,
      default: !1
    },
    imageHeight: {
      type: String,
      default: void 0
    },
    headingType: {
      type: String,
      default: void 0
    },
    characterLimitDescription: {
      type: Number,
      default: 250
    },
    direction: {
      type: String,
      default: void 0
    }
  },
  emits: ["openVideo"],
  setup(e, { expose: t, emit: n }) {
    const i = e, { t: o } = Je(), { isDesktop: a } = xt(), r = Jt(), { containerQueriesEnabled: s } = Bi(), l = ge(Pn()), d = ge(!1), y = ge(null), u = ge(), m = ge(), h = ge(!0), c = {
      title: o("videoModule.playButton")
    };
    t({
      card: y
    });
    const g = () => {
      u.value = Gu(m.value), h.value = s.value ? u.value?.xlarge : !a.value;
    };
    it(() => {
      g();
    }), qe(
      () => a.value,
      () => g()
    ), qe(
      () => u.value?.xlarge,
      () => g()
    );
    const v = Te(() => ({
      type: M.value,
      backgroundColor: Zt.White,
      hideCorner: !B.value,
      linkModel: i.teaserBox.linkUrl
    })), P = Te(() => i.direction ? i.direction : h.value ? Ti.Column : i.layout === Rt.Full ? Ti.Row : Ti.Column), f = Te(() => i.teaserBox.fullLayout ?? i.fullLayout), S = Te(() => i.teaserBox.pictureRoundedCorner ?? i.pictureRoundedCorner), w = () => {
      Ue && i.teaserBox.linkUrl && window.open(i.teaserBox.linkUrl.href, i.teaserBox.linkUrl.target);
    }, x = Te(() => i.teaserBox.text && i.teaserBox.text.length > 0 && i.description !== Ui.Hidden), k = (q) => !!r[q], A = Te(() => i.teaserBox.type === Kn.Document || i.teaserBox.type === Kn.DocumentArchivePage ? H.Download : H.ArrowRight), $ = Te(() => j()), j = () => i.teaserBox.image?.src && i.teaserBox.image.src.length > 0 && i.picture !== Ui.Hidden && i.teaserBox.type !== Kn.Document, N = () => {
      d.value = !0;
    }, M = Te(() => {
      switch (i.teaserBox.type) {
        case Kn.Document:
          return qi.Document;
        case Kn.DocumentArchivePage:
          return qi.DocumentArchivePage;
        case Kn.Text:
          return qi.Text;
        case Kn.VideoTeaser:
          return qi.VideoTeaser;
      }
    }), D = Te(() => i.teaserBox.tags ? Qx(i.teaserBox.tags) : []), C = Te(() => i.teaserBox.text ? i.clippingText ? Ml({
      text: i.teaserBox.text,
      maxCharacters: i.characterLimitDescription
    }) : i.teaserBox.text : ""), b = Te(() => i.clippingText ? Ml({
      text: i.teaserBox.headline,
      maxCharacters: 80
    }) : i.teaserBox.headline), p = Te(() => {
      if (i.headingType)
        return i.headingType;
      switch (i.layout) {
        case Rt.Full:
          return ze.StyledAsH2Section;
        case Rt.Half:
          return ze.StyledAsH2Section;
        case Rt.OneThird:
          return ze.StyledAsH3;
      }
    }), L = Te(() => {
      switch (i.teaserBox.color) {
        case Zt.White:
          return En.White;
        case Zt.Grey:
          return En.Grey;
        case Zt.GreyBlue000:
          return En.GreyBlue000;
        case Zt.Transparent:
          return En.Transparent;
        default:
          return En.Transparent;
      }
    }), B = Te(() => i.ctaElementType === cn.LinkCorner && i.layout !== Rt.Full && i.teaserBox.type !== Kn.VideoTeaser), T = Te(() => `d-teaser-box--${i.layout}`), O = Te(() => {
      switch (i.teaserBox.color) {
        case Zt.White:
          return `d-teaser-box--bg-white${B.value ? "-with-corner" : ""}`;
        case Zt.Grey:
          return `d-teaser-box--bg-grey${B.value ? "-with-corner" : ""}`;
        case Zt.Transparent:
          return `d-teaser-box--bg-transparent${B.value ? "-with-corner" : ""}`;
        case Zt.GreyBlue000:
          return `d-teaser-box--bg-grey-blue-000${B.value ? "-with-corner" : ""}`;
        default:
          Zt.Transparent;
      }
    }), I = Te(() => i.contentPadding !== void 0 && i.contentPadding === !1 ? "d-teaser-box--no-padding" : ""), R = Te(() => S.value ? "d-teaser-box__img--rounded-corner" : ""), Y = Te(() => i.picture === Ui.VisibleOnlyOnDesktop ? "d-teaser-box--img-visible-only-on-desktop" : ""), F = Te(() => i.description === Ui.VisibleOnlyOnDesktop ? "d-teaser-box__description--visible-only-on-desktop" : ""), U = Te(() => i.layout !== Rt.Full ? "" : `d-teaser-box--${f.value}`), Q = Te(() => `d-teaser-box--${i.teaserBox.type}`), J = Te(() => i.teaserBox.fullLayoutImageAlignment === ev.Right ? "d-teaser-box--img-right" : ""), ee = Te(() => j() ? "" : "d-teaser-box--no-img"), V = Te(() => x.value ? "" : "d-teaser-box--no-description"), G = Te(() => zu(
      i.teaserBox?.baseVideoPlayerProps?.videoLengthSeconds ? i.teaserBox?.baseVideoPlayerProps?.videoLengthSeconds : 0,
      !1
    )), W = Te(() => i.showTags && D.value && D.value.length > 0 ? "d-teaser-box--has-tags" : ""), ae = Te(() => s.value ? "d-teaser-box-wrapper--container" : "d-teaser-box-wrapper--media"), z = n;
    return (q, Z) => (E(), X("div", {
      ref_key: "containerElement",
      ref: m,
      class: Pe(["d-teaser-box-wrapper", [ae.value]])
    }, [
      ue(Th, {
        ref_key: "card",
        ref: y,
        model: v.value,
        direction: P.value,
        class: Pe(["d-teaser-box", [
          O.value,
          T.value,
          U.value,
          I.value,
          J.value,
          ee.value,
          V.value,
          Y.value,
          Q.value,
          W.value
        ]])
      }, Qt({
        title: Se(() => [
          ue(Ot, {
            id: l.value,
            "base-heading-type": p.value,
            class: Pe(["d-teaser-box__heading", {
              "d-teaser-box__heading--h3-margin": e.headingType === _(ze).H3,
              "d-teaser-box__heading--margin-no-tags": (!e.showDate || !e.teaserBox.date) && e.showTags && D.value && D.value?.length > 0,
              "d-teaser-box__heading--margin-no-tags-no-date": (!e.showDate || !e.teaserBox.date) && (!e.showTags || !D.value || D.value?.length === 0)
            }])
          }, {
            default: Se(() => [
              Ve(Ie(b.value), 1)
            ]),
            _: 1
          }, 8, ["id", "base-heading-type", "class"]),
          e.showTags && D.value && D.value?.length > 0 ? (E(), fe(Ch, {
            key: 0,
            tags: D.value,
            "background-color": L.value,
            color: _(mi).GreyBlue009,
            "align-right": !0,
            class: "d-teaser-box__tags"
          }, null, 8, ["tags", "background-color", "color"])) : te("", !0),
          oe("div", pxe, [
            e.showDate && e.teaserBox.date ? (E(), X("div", {
              key: 0,
              class: Pe(["d-teaser-box__date", {
                "d-teaser-box__date--margin-no-tags": (!e.showTags || !D.value || D.value?.length === 0) && (e.layout === _(Rt).OneThird || e.layout === _(Rt).Half),
                "d-teaser-box__date--margin-no-category": !e.teaserBox.category
              }])
            }, [
              e.teaserBox.date ? (E(), fe(Tt, {
                key: 0,
                text: e.teaserBox.date,
                "font-size": _(st).TwelvePx,
                "text-color": _(dt).GreyBlue009,
                "font-type": _(lt).DwsSlabBold
              }, null, 8, ["text", "font-size", "text-color", "font-type"])) : te("", !0),
              e.teaserBox.category ? (E(), X(Re, { key: 1 }, [
                ue(Tt, {
                  text: " | ",
                  "font-size": _(st).TwelvePx,
                  "text-color": _(dt).GreyBlue009,
                  "font-type": _(lt).DwsSlabBold
                }, null, 8, ["font-size", "text-color", "font-type"]),
                ue(Tt, {
                  text: e.teaserBox.category,
                  "font-size": _(st).TwelvePx,
                  "text-color": _(dt).GreyBlue009,
                  "font-type": _(lt).DwsSlabBold
                }, null, 8, ["text", "font-size", "text-color", "font-type"])
              ], 64)) : te("", !0),
              e.teaserBox.isNew ? (E(), fe(Ji, {
                key: 2,
                "tag-text": _(o)("teaser.new"),
                "background-color": _(En).GreyBlue009,
                color: _(mi).White,
                "aria-hidden": "true"
              }, null, 8, ["tag-text", "background-color", "color"])) : te("", !0)
            ], 2)) : te("", !0)
          ])
        ]),
        _: 2
      }, [
        $.value ? {
          name: "header",
          fn: Se(() => [
            e.teaserBox.type === _(Kn).VideoPlayer ? (E(), fe(yg, {
              key: 0,
              "base-video-player-props": e.teaserBox.baseVideoPlayerProps,
              onVideoPlay: N
            }, null, 8, ["base-video-player-props"])) : te("", !0),
            e.teaserBox.type !== _(Kn).VideoPlayer ? (E(), fe(di, {
              key: 1,
              model: e.teaserBox?.image,
              "aspect-ratio": _(on).TwoToOne,
              class: Pe(["d-teaser-box__img", [R.value]])
            }, null, 8, ["model", "aspect-ratio", "class"])) : te("", !0),
            e.teaserBox.type === _(Kn).VideoTeaser && e.videoIsRunning ? (E(), fe(Ji, {
              key: 2,
              class: "d-teaser-box__is-running",
              "tag-text": _(o)("videoModule.isRunningText"),
              "background-color": _(En).GreyBlue001,
              color: _(mi).GreyBlue009
            }, null, 8, ["tag-text", "background-color", "color"])) : te("", !0),
            e.teaserBox.type === _(Kn).VideoTeaser && !e.videoIsRunning ? (E(), fe(Nt, {
              key: 3,
              class: "d-teaser-box__play",
              type: _(Ke).RoundedPrimary,
              size: _(et).Large,
              icon: _(H).Play,
              "link-model": c,
              onClick: Z[0] || (Z[0] = (ne) => z("openVideo"))
            }, null, 8, ["type", "size", "icon"])) : te("", !0),
            e.teaserBox?.baseVideoPlayerProps?.videoLengthSeconds && (e.teaserBox.type === _(Kn).VideoTeaser || e.teaserBox.type === _(Kn).VideoPlayer) && !d.value ? (E(), fe(Ji, {
              key: 4,
              class: "d-teaser-box__duration",
              "tag-text": G.value,
              "background-color": _(En).GreyBlue009,
              color: _(mi).White,
              "is-border-visible": !1
            }, null, 8, ["tag-text", "background-color", "color"])) : te("", !0)
          ]),
          key: "0"
        } : void 0,
        x.value || k("teaserContent") ? {
          name: "content",
          fn: Se(() => [
            k("teaserContent") ? te("", !0) : (E(), fe(Tt, {
              key: 0,
              text: C.value,
              "font-size": e.fontSize,
              class: Pe(["d-teaser-box__text", [
                F.value,
                { "d-teaser-box__text--no-image": !e.teaserBox.image }
              ]])
            }, null, 8, ["text", "font-size", "class"])),
            k("teaserContent") ? je(q.$slots, "teaserContent", {
              key: 1,
              teaserContent: e.teaserBox
            }, void 0, !0) : te("", !0)
          ]),
          key: "1"
        } : void 0,
        (e.ctaElementType === _(cn).Link || e.ctaElementType === _(cn).SecondaryButton || e.ctaElementType === _(cn).PrimaryButton || e.teaserBox.secondLink) && e.teaserBox.linkUrl?.text && e.teaserBox.linkUrl?.text !== "" && (e.layout === _(Rt).Full || e.teaserBox.alwaysShowButton) ? {
          name: "footer",
          fn: Se(() => [
            oe("div", fxe, [
              e.ctaElementType === _(cn).Link ? (E(), fe(ot, {
                key: 0,
                class: "hidden xl:block pointer-events-auto d-teaser-box__text-link",
                "link-model": e.teaserBox.linkUrl,
                icon: A.value,
                "aria-describedby": l.value,
                onClick: w
              }, null, 8, ["link-model", "icon", "aria-describedby"])) : te("", !0),
              e.ctaElementType === _(cn).SecondaryButton ? (E(), fe(vt, {
                key: 1,
                "link-model": e.teaserBox.linkUrl,
                type: _(Ke).Secondary,
                size: _(et).Large,
                "button-type": _(zt).Link,
                icon: A.value,
                onClick: w
              }, null, 8, ["link-model", "type", "size", "button-type", "icon"])) : te("", !0),
              e.ctaElementType === _(cn).PrimaryButton ? (E(), fe(vt, {
                key: 2,
                "link-model": e.teaserBox.linkUrl,
                class: Pe(e.linkCorner),
                type: _(Ke).Primary,
                size: _(et).Large,
                "button-type": _(zt).Link,
                icon: A.value,
                onClick: w
              }, null, 8, ["link-model", "class", "type", "size", "button-type", "icon"])) : te("", !0),
              e.teaserBox.secondLink ? (E(), fe(ot, {
                key: 3,
                class: "d-teaser-box__second-link",
                "link-model": e.teaserBox.secondLink,
                icon: _(H).Download,
                "aria-describedby": l.value
              }, null, 8, ["link-model", "icon", "aria-describedby"])) : te("", !0)
            ])
          ]),
          key: "2"
        } : void 0
      ]), 1032, ["model", "direction", "class"])
    ], 2));
  }
});
const co = /* @__PURE__ */ Fe(mxe, [["__scopeId", "data-v-d44e7e9b"]]), gxe = {
  key: 1,
  class: "d-teaser-box-full"
}, vxe = /* @__PURE__ */ Be({
  __name: "TeaserBoxFull",
  props: {
    teaserBox: {
      type: Object,
      required: !0
    },
    picture: {
      type: String,
      default: Ui.Visible
    },
    showTags: {
      type: Boolean,
      default: !0
    },
    showDate: {
      type: Boolean,
      default: !0
    },
    clippingText: {
      type: Boolean,
      default: !0
    },
    linkedTeaser: {
      type: Boolean,
      default: !0
    },
    ctaElementType: {
      type: String,
      default: cn.Link
    },
    description: {
      type: String,
      default: Ui.Visible
    },
    pt: {
      type: Object,
      default: void 0
    },
    linkCorner: {
      type: Boolean,
      default: !1
    },
    imageHeight: {
      type: String,
      default: void 0
    },
    headingType: {
      type: String,
      default: ze.H3
    }
  },
  setup(e) {
    const t = Jt(), n = ge(!1), i = (r) => {
      n.value = r;
    }, o = dP().isTouchDevice, a = (r) => !!t[r];
    return (r, s) => (E(), X(Re, null, [
      e.linkedTeaser && _(o) || e.teaserBox.linkedTeaser ? (E(), fe(ot, {
        key: 0,
        class: "d-teaser-box-full",
        "has-text": !1,
        "aria-label": e.teaserBox.headline,
        "link-model": e.teaserBox.linkUrl,
        onClick: s[0] || (s[0] = (l) => i(!0))
      }, {
        container: Se(() => [
          ue(co, {
            ref: "teaser",
            pt: e.pt,
            "teaser-box": e.teaserBox,
            layout: _(Rt).Full,
            "full-layout": _($a).OneToTwo,
            description: e.description,
            picture: e.picture,
            "show-date": e.showDate,
            "show-tags": e.showTags,
            "clipping-text": e.clippingText,
            "cta-element-type": e.ctaElementType,
            "font-size": _(st).SixteenPx,
            "link-corner": e.linkCorner,
            "image-height": e.imageHeight,
            "heading-type": e.headingType
          }, Qt({ _: 2 }, [
            a("teaserContent") ? {
              name: "teaserContent",
              fn: Se((l) => [
                je(r.$slots, "teaserContent", { teaserContent: l }, void 0, !0)
              ]),
              key: "0"
            } : void 0
          ]), 1032, ["pt", "teaser-box", "layout", "full-layout", "description", "picture", "show-date", "show-tags", "clipping-text", "cta-element-type", "font-size", "link-corner", "image-height", "heading-type"])
        ]),
        _: 3
      }, 8, ["aria-label", "link-model"])) : (E(), X("div", gxe, [
        ue(co, {
          ref: "teaser",
          pt: e.pt,
          "teaser-box": e.teaserBox,
          layout: _(Rt).Full,
          "full-layout": _($a).OneToTwo,
          description: e.description,
          picture: e.picture,
          "show-date": e.showDate,
          "show-tags": e.showTags,
          "clipping-text": e.clippingText,
          "cta-element-type": e.ctaElementType,
          "font-size": _(st).SixteenPx,
          "link-corner": e.linkCorner,
          "image-height": e.imageHeight,
          onOpenVideo: s[1] || (s[1] = (l) => i(!0))
        }, Qt({ _: 2 }, [
          a("teaserContent") ? {
            name: "teaserContent",
            fn: Se((l) => [
              je(r.$slots, "teaserContent", { teaserContent: l }, void 0, !0)
            ]),
            key: "0"
          } : void 0
        ]), 1032, ["pt", "teaser-box", "layout", "full-layout", "description", "picture", "show-date", "show-tags", "clipping-text", "cta-element-type", "font-size", "link-corner", "image-height"])
      ])),
      e.teaserBox.baseVideoPlayerProps ? (E(), fe(Gg, {
        key: 2,
        "open-dialog": n.value,
        "base-video-player-props": e.teaserBox.baseVideoPlayerProps,
        onClose: s[2] || (s[2] = (l) => i(!1))
      }, null, 8, ["open-dialog", "base-video-player-props"])) : te("", !0)
    ], 64));
  }
});
const iL = /* @__PURE__ */ Fe(vxe, [["__scopeId", "data-v-5ae48cd5"]]), yxe = {
  key: 1,
  class: "d-teaser-box-half-and-third"
}, bxe = /* @__PURE__ */ Be({
  __name: "TeaserBoxHalfAndThird",
  props: {
    teaserBox: {
      type: Object,
      required: !0
    },
    layout: {
      type: String,
      default: Rt.OneThird
    },
    picture: {
      type: String,
      default: Ui.Visible
    },
    showTags: {
      type: Boolean,
      default: !0
    },
    showDate: {
      type: Boolean,
      default: !0
    },
    clippingText: {
      type: Boolean,
      default: !0
    },
    linkedTeaser: {
      type: Boolean,
      default: !0
    },
    ctaElementType: {
      type: String,
      default: cn.LinkCorner
    },
    description: {
      type: String,
      default: Ui.Visible
    },
    linkCorner: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const t = Jt(), n = e, i = (r) => !!t[r], o = ge(!1), a = (r) => {
      n.teaserBox.baseVideoPlayerProps && (o.value = r);
    };
    return (r, s) => (E(), X(Re, null, [
      e.linkedTeaser ? (E(), fe(ot, {
        key: 0,
        class: "d-teaser-box-half-and-third no-underline",
        "has-text": !1,
        "aria-label": e.teaserBox.headline,
        "link-model": e.teaserBox.linkUrl,
        onClick: s[0] || (s[0] = (l) => a(!0))
      }, {
        container: Se(() => [
          ue(co, {
            "teaser-box": e.teaserBox,
            layout: e.layout,
            description: e.description,
            picture: e.picture,
            "show-date": e.showDate,
            "show-tags": e.showTags,
            "cta-element-type": e.ctaElementType,
            "clipping-text": e.clippingText,
            "link-corner": e.linkCorner
          }, Qt({ _: 2 }, [
            i("teaserContent") ? {
              name: "teaserContent",
              fn: Se((l) => [
                je(r.$slots, "teaserContent", { teaserContent: l }, void 0, !0)
              ]),
              key: "0"
            } : void 0
          ]), 1032, ["teaser-box", "layout", "description", "picture", "show-date", "show-tags", "cta-element-type", "clipping-text", "link-corner"])
        ]),
        _: 3
      }, 8, ["aria-label", "link-model"])) : te("", !0),
      e.linkedTeaser ? te("", !0) : (E(), X("div", yxe, [
        ue(co, {
          "teaser-box": e.teaserBox,
          layout: e.layout,
          description: e.description,
          picture: e.picture,
          "show-date": e.showDate,
          "show-tags": e.showTags,
          "cta-element-type": e.ctaElementType,
          "clipping-text": e.clippingText,
          "link-corner": e.linkCorner,
          onOpenVideo: s[1] || (s[1] = (l) => a(!0))
        }, Qt({ _: 2 }, [
          i("teaserContent") ? {
            name: "teaserContent",
            fn: Se((l) => [
              je(r.$slots, "teaserContent", { teaserContent: l }, void 0, !0)
            ]),
            key: "0"
          } : void 0
        ]), 1032, ["teaser-box", "layout", "description", "picture", "show-date", "show-tags", "cta-element-type", "clipping-text", "link-corner"])
      ])),
      e.teaserBox.baseVideoPlayerProps ? (E(), fe(_(Gg), {
        key: 2,
        "open-dialog": o.value,
        "base-video-player-props": e.teaserBox.baseVideoPlayerProps,
        onClose: s[2] || (s[2] = (l) => a(!1))
      }, null, 8, ["open-dialog", "base-video-player-props"])) : te("", !0)
    ], 64));
  }
});
const aL = /* @__PURE__ */ Fe(bxe, [["__scopeId", "data-v-bbbe6aed"]]), xxe = {
  key: 0,
  class: "d-teaser-boxes-stack__heading"
}, wxe = {
  key: 1,
  class: "flex justify-end pt-6 lg:pt-8 xl:pt-10"
}, kxe = /* @__PURE__ */ Be({
  __name: "TeaserBoxesStack",
  props: {
    model: {
      type: Object,
      required: !0
    },
    baseLink: {
      type: Object,
      required: !1,
      default: null
    },
    linkCorner: {
      type: Boolean,
      default: !1
    },
    headingType: {
      type: String,
      default: ze.H3
    }
  },
  setup(e) {
    const t = Jt(), n = (i) => !!t[i];
    return (i, o) => {
      const a = $e("BaseHeading"), r = $e("BaseText");
      return E(), X("div", {
        class: Pe({
          "d-teaser-boxes-stack--grey-bg": e.model.backgroundColor === _(Zt).Grey
        })
      }, [
        e.model.title ? (E(), X("div", xxe, [
          ue(a, {
            "base-heading-type": _(ze).H2
          }, {
            default: Se(() => [
              Ve(Ie(e.model.title), 1)
            ]),
            _: 1
          }, 8, ["base-heading-type"])
        ])) : te("", !0),
        oe("div", {
          class: Pe(["d-teaser-boxes-stack grid grid-flow-row-dense gap-6 lg:gap-8 xl:gap-10", {
            "grid-cols-1 lg:grid-cols-2 xxl:grid-cols-3": e.model.layout === _(Rt).OneThird,
            "grid-cols-1 lg:grid-cols-1 xl:grid-cols-2": e.model.layout === _(Rt).Half,
            "grid-cols-1": e.model.layout === _(Rt).Full
          }])
        }, [
          (E(!0), X(Re, null, Ge(e.model.teasers, (s) => (E(), X("div", {
            key: s,
            class: Pe(["d-teaser-boxes-stack__item col-span-1", {
              "d-teaser-boxes-stack--featured-mobile": e.model.isFeatured
            }])
          }, [
            e.model.layout === _(Rt).Full ? (E(), fe(iL, {
              key: 0,
              "teaser-box": s.model,
              picture: e.model.picture,
              "show-tags": e.model.showTags,
              "show-date": e.model.showDate,
              "cta-element-type": e.model.ctaElementType,
              "linked-teaser": e.model.linkedTeaser,
              description: e.model.description,
              "link-corner": e.linkCorner,
              "heading-type": e.headingType
            }, Qt({ _: 2 }, [
              n("teaserContent") ? {
                name: "teaserContent",
                fn: Se((l) => [
                  je(i.$slots, "teaserContent", { teaserContent: l }, void 0, !0)
                ]),
                key: "0"
              } : void 0
            ]), 1032, ["teaser-box", "picture", "show-tags", "show-date", "cta-element-type", "linked-teaser", "description", "link-corner", "heading-type"])) : te("", !0),
            e.model.layout === _(Rt).OneThird || e.model.layout === _(Rt).Half ? (E(), fe(aL, {
              key: 1,
              "teaser-box": s.model,
              layout: e.model.layout,
              picture: e.model.picture,
              "show-tags": e.model.showTags,
              "show-date": e.model.showDate,
              "clipping-text": e.model.clippingText,
              "cta-element-type": e.model.ctaElementType,
              "linked-teaser": e.model.linkedTeaser,
              description: e.model.description,
              "link-corner": e.linkCorner
            }, Qt({ _: 2 }, [
              n("teaserContent") ? {
                name: "teaserContent",
                fn: Se((l) => [
                  je(i.$slots, "teaserContent", { teaserContent: l }, void 0, !0)
                ]),
                key: "0"
              } : void 0
            ]), 1032, ["teaser-box", "layout", "picture", "show-tags", "show-date", "clipping-text", "cta-element-type", "linked-teaser", "description", "link-corner"])) : te("", !0)
          ], 2))), 128)),
          e.model.teasers.length === 0 ? (E(), fe(r, {
            key: 0,
            text: e.model.noTeasersText
          }, null, 8, ["text"])) : te("", !0)
        ], 2),
        e.model.moreTeasersLink?.href ? (E(), X("div", wxe, [
          ue(ot, {
            "link-model": e.model.moreTeasersLink,
            icon: _(H).ArrowRight
          }, null, 8, ["link-model", "icon"])
        ])) : te("", !0)
      ], 2);
    };
  }
});
const ns = /* @__PURE__ */ Fe(kxe, [["__scopeId", "data-v-21d99fb6"]]), Sxe = {
  key: 0,
  class: "d-teaser-boxes-slider__heading"
}, Cxe = /* @__PURE__ */ Be({
  __name: "TeaserBoxesSliderSushi",
  props: {
    model: {
      type: Object,
      required: !0
    },
    randomSliderPage: {
      type: Boolean,
      default: !1
    },
    linkCorner: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const t = Jt(), n = e, i = n.model.teasers.map((P, f) => ({
      index: f,
      ...P
    })), o = {
      breakpoint: `${Ct.Xxxl - 1}px`,
      numVisible: 1,
      numScroll: 1
    }, a = {
      breakpoint: `${Ct.Xxl - 1}px`,
      numVisible: 1,
      numScroll: 1
    }, r = {
      breakpoint: `${Ct.Lg - 1}px`,
      numVisible: 1,
      numScroll: 1
    }, s = {
      breakpoint: `${Ct.Xxxl - 1}px`,
      numVisible: 2,
      numScroll: 1
    }, l = {
      breakpoint: `${Ct.Xxl - 1}px`,
      numVisible: 1,
      numScroll: 1
    }, d = {
      breakpoint: `${Ct.Lg - 1}px`,
      numVisible: 1,
      numScroll: 1
    }, y = {
      breakpoint: `${Ct.Xxxl - 1}px`,
      numVisible: 3,
      numScroll: 1
    }, u = {
      breakpoint: `${Ct.Xxl - 1}px`,
      numVisible: 2,
      numScroll: 1
    }, m = {
      breakpoint: `${Ct.Lg - 1}px`,
      numVisible: 1,
      numScroll: 1
    }, h = Te(() => {
      switch (n.model.layout) {
        case Rt.Full:
          return [
            o,
            a,
            r
          ];
        case Rt.Half:
          return [
            s,
            l,
            d
          ];
        case Rt.OneThird:
          return [
            y,
            u,
            m
          ];
      }
    }), c = Te(() => {
      switch (n.model.layout) {
        case Rt.Full:
          return 1;
        case Rt.Half:
          return 2;
        case Rt.OneThird:
          return 3;
      }
    }), g = Te(() => {
      if (n.randomSliderPage) {
        const P = n.model.teasers.length;
        return Math.floor(Math.random() * P);
      }
    }), v = (P) => !!t[P];
    return (P, f) => {
      const S = $e("BaseHeading"), w = $e("BaseText");
      return E(), X(Re, null, [
        oe("div", {
          class: Pe({
            "d-teaser-boxes-slider--grey-bg": e.model.backgroundColor === _(Zt).Grey
          })
        }, [
          e.model?.title ? (E(), X("div", Sxe, [
            ue(S, {
              "base-heading-type": _(ze).H2
            }, {
              default: Se(() => [
                Ve(Ie(e.model.title), 1)
              ]),
              _: 1
            }, 8, ["base-heading-type"])
          ])) : te("", !0),
          e.model.teasers.length > 0 ? (E(), X("div", {
            key: 1,
            class: Pe(["d-teaser-boxes-slider", {
              "d-teaser-boxes-slider-third": e.model.layout === _(Rt).OneThird,
              "d-teaser-boxes-slider-half": e.model.layout === _(Rt).Half
            }])
          }, [
            ue(zs, {
              ref: "slider",
              items: _(i),
              "items-visible": c.value,
              "num-scroll": 1,
              page: g.value,
              "responsive-options": h.value,
              "base-link": e.model.moreTeasersLink,
              "show-indicators": !1,
              "show-navigators": !1
            }, {
              item: Se((x) => [
                e.model.layout === _(Rt).Full ? (E(), fe(iL, {
                  key: 0,
                  pt: { body: { id: "slide" + x.data.index } },
                  "teaser-box": x.data?.model,
                  picture: e.model.picture,
                  "show-tags": e.model.showTags,
                  "show-date": e.model.showDate,
                  "cta-element-type": e.model.ctaElementType,
                  "clipping-text": e.model.clippingText,
                  "linked-teaser": e.model.linkedTeaser,
                  description: e.model.description,
                  "link-corner": e.linkCorner,
                  "image-height": _(Rt).Full
                }, Qt({ _: 2 }, [
                  v("teaserContent") ? {
                    name: "teaserContent",
                    fn: Se((k) => [
                      je(P.$slots, "teaserContent", { teaserContent: k }, void 0, !0)
                    ]),
                    key: "0"
                  } : void 0
                ]), 1032, ["pt", "teaser-box", "picture", "show-tags", "show-date", "cta-element-type", "clipping-text", "linked-teaser", "description", "link-corner", "image-height"])) : te("", !0),
                e.model.layout === _(Rt).OneThird || e.model.layout === _(Rt).Half ? (E(), fe(aL, {
                  key: 1,
                  "teaser-box": x.data?.model,
                  layout: e.model.layout,
                  picture: e.model.picture,
                  "show-tags": e.model.showTags,
                  "show-date": e.model.showDate,
                  "cta-element-type": e.model.ctaElementType,
                  "clipping-text": e.model.clippingText,
                  "linked-teaser": e.model.linkedTeaser,
                  description: e.model.description,
                  "link-corner": e.linkCorner
                }, Qt({ _: 2 }, [
                  v("teaserContent") ? {
                    name: "teaserContent",
                    fn: Se((k) => [
                      je(P.$slots, "teaserContent", { teaserContent: k }, void 0, !0)
                    ]),
                    key: "0"
                  } : void 0
                ]), 1032, ["teaser-box", "layout", "picture", "show-tags", "show-date", "cta-element-type", "clipping-text", "linked-teaser", "description", "link-corner"])) : te("", !0)
              ]),
              _: 3
            }, 8, ["items", "items-visible", "page", "responsive-options", "base-link"])
          ], 2)) : te("", !0)
        ], 2),
        e.model.teasers.length === 0 ? (E(), fe(w, {
          key: 0,
          text: e.model.noTeasersText
        }, null, 8, ["text"])) : te("", !0)
      ], 64);
    };
  }
});
const Txe = /* @__PURE__ */ Fe(Cxe, [["__scopeId", "data-v-b649c422"]]), oL = /* @__PURE__ */ Be({
  __name: "TeaserBoxesSlider",
  props: {
    model: {
      type: Object,
      required: !0
    },
    randomSliderPage: {
      type: Boolean,
      default: !1
    },
    linkCorner: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const { isDesktopAsync: t } = xt(), n = Jt(), i = (o) => !!n[o];
    return (o, a) => _(t) ? (E(), fe(Txe, {
      key: 0,
      model: e.model,
      "random-slider-page": e.randomSliderPage,
      "link-corner": e.linkCorner
    }, Qt({ _: 2 }, [
      i("teaserContent") ? {
        name: "teaserContent",
        fn: Se((r) => [
          je(o.$slots, "teaserContent", { teaserContent: r })
        ]),
        key: "0"
      } : void 0
    ]), 1032, ["model", "random-slider-page", "link-corner"])) : (E(), fe(ns, {
      key: 1,
      model: e.model,
      "link-corner": e.linkCorner
    }, Qt({ _: 2 }, [
      i("teaserContent") ? {
        name: "teaserContent",
        fn: Se((r) => [
          je(o.$slots, "teaserContent", { teaserContent: r })
        ]),
        key: "0"
      } : void 0
    ]), 1032, ["model", "link-corner"]));
  }
}), JBe = /* @__PURE__ */ Be({
  __name: "TeaserBoxes",
  props: {
    model: {
      type: Object,
      required: !0
    },
    linkCorner: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    return (t, n) => e.model.isStacked && e.model.isStacked === !0 ? (E(), fe(ns, {
      key: 0,
      model: e.model,
      "link-corner": e.linkCorner
    }, null, 8, ["model", "link-corner"])) : (E(), fe(oL, {
      key: 1,
      model: e.model,
      "link-corner": e.linkCorner
    }, null, 8, ["model", "link-corner"]));
  }
}), Lxe = {
  key: 0,
  class: "d-media-releases-details-page container"
}, Ixe = { class: "d-media-releases-details-page__flex" }, Pxe = { class: "d-media-releases-details-page__main" }, Axe = { class: "d-media-releases-details-page__flex-reversed" }, _xe = { class: "d-media-releases-details-page__date__tag" }, Mxe = { class: "d-media-releases-details-page__main__list-section" }, Oxe = { class: "d-media-releases-details-page__main__bullet-list" }, Bxe = {
  key: 0,
  class: "d-media-releases-details-page__sidebar"
}, Exe = { class: "d-media-releases-details-page__content" }, Dxe = /* @__PURE__ */ Be({
  __name: "MediaReleasesDetailsPage",
  props: {
    model: {
      type: Object,
      required: !0
    }
  },
  setup(e) {
    const { t } = Je(), { isDesktopAsync: n } = xt();
    return (i, o) => e.model ? (E(), X("div", Lxe, [
      oe("div", Ixe, [
        oe("div", Pxe, [
          oe("div", Axe, [
            e.model.headline ? (E(), fe(_(Ot), {
              key: 0,
              "base-heading-type": _(ze).H1,
              class: "d-media-releases-details-page__main__heading"
            }, {
              default: Se(() => [
                Ve(Ie(e.model.headline), 1)
              ]),
              _: 1
            }, 8, ["base-heading-type"])) : te("", !0),
            oe("div", _xe, [
              e.model.date ? (E(), fe(Tt, {
                key: 0,
                text: e.model.date,
                "font-size": _(st).TwelvePx,
                "text-color": _(dt).GreyBlue009,
                "font-type": _(lt).DwsSlabBold
              }, null, 8, ["text", "font-size", "text-color", "font-type"])) : te("", !0),
              e.model.isNew ? (E(), fe(Ji, {
                key: 1,
                "tag-text": _(t)("teaser.new"),
                "background-color": _(En).GreyBlue009,
                color: _(mi).White
              }, null, 8, ["tag-text", "background-color", "color"])) : te("", !0)
            ])
          ]),
          oe("div", Mxe, [
            e.model.listHeading ? (E(), fe(_(Ot), {
              key: 0,
              "base-heading-type": _(ze).H2Section,
              class: "d-media-releases-details-page__main__list-heading"
            }, {
              default: Se(() => [
                Ve(Ie(e.model.listHeading), 1)
              ]),
              _: 1
            }, 8, ["base-heading-type"])) : te("", !0),
            oe("ul", Oxe, [
              (E(!0), X(Re, null, Ge(e.model.bulletPoints, (a) => (E(), X("li", { key: a }, [
                oe("p", null, Ie(a), 1)
              ]))), 128))
            ]),
            e.model.downloadLink && e.model.downloadLink.href ? (E(), fe(ot, {
              key: 1,
              "link-model": e.model.downloadLink,
              icon: _(H).Download,
              class: "d-media-releases-details-page__main__download-link"
            }, null, 8, ["link-model", "icon"])) : te("", !0)
          ]),
          !_(n) && e.model.contactBox ? (E(), fe(_(Lc), {
            key: 0,
            model: e.model.contactBox,
            class: "d-media-releases-details-page__main__contact-box"
          }, null, 8, ["model"])) : te("", !0),
          e.model.htmlContent ? (E(), fe(ht, {
            key: 1,
            "html-text": e.model.htmlContent,
            "font-type": _(lt).DwsSans,
            class: "d-media-releases-details-page__main__html-content"
          }, null, 8, ["html-text", "font-type"])) : te("", !0)
        ]),
        _(n) ? (E(), X("div", Bxe, [
          o[0] || (o[0] = oe("div", { class: "d-media-releases-details-page__sidebar__gap" }, null, -1)),
          oe("div", Exe, [
            e.model.contactBox ? (E(), fe(_(Lc), {
              key: 0,
              model: e.model.contactBox
            }, null, 8, ["model"])) : te("", !0)
          ])
        ])) : te("", !0)
      ])
    ])) : te("", !0);
  }
});
const QBe = /* @__PURE__ */ Fe(Dxe, [["__scopeId", "data-v-b0c4ad02"]]), Rxe = { class: "d-facts-lists-item" }, Nxe = { class: "d-facts-lists-item__header" }, $xe = { class: "d-facts-lists-item__content" }, Fxe = /* @__PURE__ */ Be({
  __name: "FactsListsItem",
  props: {
    model: {
      type: Object,
      required: !0
    },
    itemMarkerColor: {
      type: String,
      default: $o.GreyBlue001
    },
    factsListItemHeadingType: {
      type: String,
      default: ze.H3
    }
  },
  setup(e) {
    return (t, n) => {
      const i = $e("BaseHeading");
      return E(), X("div", Rxe, [
        oe("div", Nxe, [
          e.model.headline ? (E(), fe(i, {
            key: 0,
            class: "d-facts-lists__heading d-facts-lists-item__header__heading",
            "base-heading-type": e.factsListItemHeadingType
          }, {
            default: Se(() => [
              e.model.itemMarker ? (E(), fe(Rh, {
                key: 0,
                model: e.model.itemMarker,
                "item-marker-color": e.itemMarkerColor
              }, null, 8, ["model", "item-marker-color"])) : te("", !0),
              Ve(" " + Ie(e.model?.headline), 1)
            ]),
            _: 1
          }, 8, ["base-heading-type"])) : te("", !0)
        ]),
        oe("div", $xe, [
          e.model.htmlContent ? (E(), fe(ht, {
            key: 0,
            "html-text": e.model.htmlContent
          }, null, 8, ["html-text"])) : te("", !0),
          e.model.textLink ? (E(), fe(ot, {
            key: 1,
            "link-model": e.model.textLink,
            icon: e.model.textLinkIcon
          }, null, 8, ["link-model", "icon"])) : te("", !0)
        ])
      ]);
    };
  }
});
const jxe = /* @__PURE__ */ Fe(Fxe, [["__scopeId", "data-v-297646b4"]]), Hxe = { class: "d-facts-lists__items" }, zxe = /* @__PURE__ */ Be({
  __name: "FactsLists",
  props: {
    model: {
      type: Object,
      required: !0
    },
    layout: {
      type: String,
      default: HT.ListFilledPerRow
    },
    itemMarkerColor: {
      type: String,
      default: $o.GreyBlue001
    },
    sectionHeadingType: {
      type: String,
      default: ze.H2
    }
  },
  setup(e) {
    const t = e, n = Te(() => t.sectionHeadingType === ze.H2 ? ze.H3 : ze.H4);
    return (i, o) => {
      const a = $e("BaseHeading");
      return e.model ? (E(), X("div", {
        key: 0,
        class: Pe(["d-facts-lists", "d-facts-lists--" + e.layout])
      }, [
        e.model.sectionHeadline ? (E(), fe(a, {
          key: 0,
          class: "d-facts-lists__heading",
          "base-heading-type": e.sectionHeadingType
        }, {
          default: Se(() => [
            Ve(Ie(e.model.sectionHeadline), 1)
          ]),
          _: 1
        }, 8, ["base-heading-type"])) : te("", !0),
        oe("div", Hxe, [
          (E(!0), X(Re, null, Ge(e.model.listItems, (r) => (E(), fe(jxe, {
            key: r.headline + i.itemMarker,
            model: r,
            "item-marker-color": e.itemMarkerColor,
            "facts-list-item-heading-type": n.value
          }, null, 8, ["model", "item-marker-color", "facts-list-item-heading-type"]))), 128))
        ])
      ], 2)) : te("", !0);
    };
  }
});
const eEe = /* @__PURE__ */ Fe(zxe, [["__scopeId", "data-v-9dd1d392"]]), Vxe = {
  key: 0,
  class: "d-document-viewer-page container"
}, Gxe = /* @__PURE__ */ Be({
  __name: "DocumentViewerPage",
  props: {
    model: {
      type: Object,
      required: !0
    }
  },
  emits: ["download", "switchValueChanged", "headlineLink"],
  setup(e, { emit: t }) {
    const n = t;
    let o = e.model.selectButtonTabs.selectedItem, a;
    Ue ? a = VL(
      () => import("./BaseDocumentViewer-88369bea.mjs")
    ) : Be({
      template: `
   <div class="flex items-center p-4 mb-4 text-sm text-red-800 rounded-lg bg-red-50 dark:bg-gray-800 dark:text-red-400" role="alert">
    <svg class="flex-shrink-0 inline w-4 h-4 me-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
      <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5ZM9.5 4a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3ZM12 15H8a1 1 0 0 1 0-2h1v-3H8a1 1 0 0 1 0-2h2a1 1 0 0 1 1 1v4h1a1 1 0 0 1 0 2Z"/>
    </svg>
    <span class="sr-only">Info</span>
    <div>
      <span class="font-medium">DocumentViewer not available with SSR!</span>
    </div>
  </div>
   `
    });
    const r = (d) => {
      n("download", d);
    }, s = (d) => {
      n("headlineLink", d);
    }, l = (d) => {
      o = d, n("switchValueChanged", d);
    };
    return (d, y) => e.model ? (E(), X("div", Vxe, [
      e.model.headline || e.model.headlineLinkModel ? (E(), fe(Ot, {
        key: 0,
        "base-heading-type": _(ze).H1,
        class: Pe("d-document-viewer__headline")
      }, {
        default: Se(() => [
          e.model.headlineLinkModel ? (E(), fe(ot, {
            key: 1,
            "font-size": _(yn).TwentyFourPx,
            "link-model": e.model.headlineLinkModel,
            onClick: y[0] || (y[0] = (u) => s(e.model.headlineLinkModel.href))
          }, null, 8, ["font-size", "link-model"])) : (E(), X(Re, { key: 0 }, [
            Ve(Ie(e.model.headline), 1)
          ], 64))
        ]),
        _: 1
      }, 8, ["base-heading-type"])) : te("", !0),
      ue(mT, {
        class: "d-document-viewer-page__selector",
        model: e.model.selectButtonTabs,
        "event-component-name": "Tab Control",
        onClickOnTab: l
      }, null, 8, ["model"]),
      ue(ot, {
        class: "d-document-viewer-page__downloadLink",
        "link-model": e.model.downloadLinkModel,
        "font-size": _(yn).SixteenPx,
        icon: _(H).Download,
        "icon-position": _(ct).Right,
        onClick: y[1] || (y[1] = (u) => r(e.model.downloadLinkModel.href))
      }, null, 8, ["link-model", "font-size", "icon", "icon-position"]),
      (E(), fe(_(a), {
        key: _(o),
        class: "d-document-viewer-page__pdfDocument",
        model: e.model.document
      }, null, 8, ["model"]))
    ])) : te("", !0);
  }
});
const tEe = /* @__PURE__ */ Fe(Gxe, [["__scopeId", "data-v-a4c49f4c"]]), Uxe = {
  key: 0,
  class: "d-media-releases"
}, Wxe = {
  key: 3,
  class: "d-media-releases__paging"
}, Yxe = {
  key: 1,
  class: "d-media-releases__load-more"
}, B1 = 0, E1 = 15, qxe = /* @__PURE__ */ Be({
  __name: "MediaReleases",
  props: {
    model: {
      type: Object,
      required: !0
    }
  },
  emits: [
    "search-term",
    "search-record-click",
    "filter-value-changed"
  ],
  setup(e, { emit: t }) {
    const n = e, { t: i } = Je(), o = Qe().pageName, { isDesktopAsync: a } = xt(), r = ge(n?.model?.searchTerm || ""), s = ge(""), l = ge(), d = ge(0), y = t, u = ge(B1), m = ge([5, 15, 25, 50]), h = ge(E1), c = ge(E1), g = ge(n.model.filter), { onRowsPerPageChanged: v } = bm(), P = Te(() => n.model.showNumberOfResults && n.model.results?.length > 0), f = Te(() => n.model.results.slice(
      u.value,
      u.value + h.value
    )), S = (p) => {
      u.value = p.first, h.value = p.rows;
    }, w = (p) => {
      v(p, u, h);
    }, x = () => {
      u.value = B1, h.value = h.value + c.value;
    };
    async function k(p) {
      r.value = p, y("search-term", p, fr.SearchTermHasChanged);
    }
    async function A(p) {
      r.value = p, y("search-term", p, fr.SearchTermBlur);
    }
    async function $(p) {
      r.value = p, s.value = p, y("search-term", p, fr.SearchTermEnter);
    }
    async function j() {
      r.value = "", y("search-term", "", fr.SearchTermClear);
    }
    const N = (p) => {
      g.value.filterOptions?.forEach(
        (L) => L.isSelected = L.identifier === p.identifier
      ), y("filter-value-changed", p, g.value);
    };
    function M(p) {
      l.value?.hideSuggestionPanel(), y("search-record-click", p);
    }
    const D = Te(() => C()), C = () => ({
      noTeasersText: i("globalTranslations.noContent"),
      backgroundColor: Zt.White,
      layout: Rt.Full,
      showDate: !0,
      showTags: !0,
      ctaElementType: cn.Link,
      teasers: f.value.map((L) => ({
        tag: "",
        model: {
          ...L,
          fullLayout: $a.OneToFour,
          pictureRoundedCorner: !0
        }
      }))
    }), b = () => ({
      title: i("archivePage.loadMore"),
      text: i("archivePage.loadMore"),
      contentUrl: "",
      isLocked: !1,
      target: "",
      isExternal: !1,
      linkType: yt.Javascript,
      tealiumTrackingModel: {
        eventSource: o,
        eventComponentName: "Pagination",
        eventTitle: "load more"
      }
    });
    return it(() => {
      r.value && r.value !== "" && $(r.value);
    }), qe(
      () => D.value,
      () => {
        d.value++;
      }
    ), (p, L) => {
      const B = $e("BaseHeading"), T = $e("BaseLinkV2");
      return e.model ? (E(), X("div", Uxe, [
        ue(Vt, {
          id: "media-releases-header",
          class: "d-media-releases__header",
          "no-margin-bottom": !0,
          "no-margin": !0
        }, {
          default: Se(() => [
            e.model.headline ? (E(), fe(B, {
              key: 0,
              "base-heading-type": _(ze).H1,
              class: "d-media-releases__headline"
            }, {
              default: Se(() => [
                Ve(Ie(e.model.headline), 1)
              ]),
              _: 1
            }, 8, ["base-heading-type"])) : te("", !0),
            e.model.introText ? (E(), fe(ht, {
              key: 1,
              "html-text": e.model.introText,
              class: "d-media-releases__intro-text"
            }, null, 8, ["html-text"])) : te("", !0)
          ]),
          _: 1
        }),
        ue(Vt, {
          id: "media-releases-search-section",
          class: "d-media-releases__search-section",
          "no-margin-bottom": !0,
          "no-margin": !0
        }, {
          default: Se(() => [
            ue(Wo, {
              ref_key: "searchBoxRef",
              ref: l,
              class: "d-media-releases__search",
              "is-suppress-open-new-window-on-enter": "",
              model: {
                headline: "",
                placeholder: _(i)("mediaReleases.searchBoxPlaceholder"),
                filterOptions: [],
                searchTerm: r.value,
                showLabel: !0
              },
              result: e.model.flyoutResults,
              onSearch: k,
              onEnter: $,
              onBlur: A,
              onClear: j
            }, {
              record: Se((O) => [
                ue(gi, { term: r.value }, {
                  default: Se(() => [
                    ue(T, {
                      "link-model": {
                        ...O.record.record.record.link,
                        text: O.record.record.record.title
                      },
                      "font-type": _(ya).DwsRegular,
                      onClick: (I) => M(O.record.record.record),
                      onKeypress: Ze((I) => M(O.record.record.record), ["enter"])
                    }, null, 8, ["link-model", "font-type", "onClick", "onKeypress"])
                  ]),
                  _: 2
                }, 1032, ["term"])
              ]),
              _: 1
            }, 8, ["model", "result"])
          ]),
          _: 1
        }),
        ue(Vt, {
          id: "media-releases-filter-section",
          class: "d-media-releases__filter-section",
          "no-margin-bottom": !0
        }, {
          default: Se(() => [
            e.model.filter ? (E(), fe(Ah, {
              key: 0,
              filter: e.model.filter,
              "show-tabs-with-no-results": !0,
              "event-component-name": "tab-control",
              "data-event-source": _(o),
              onSingleSelectValueChanged: N
            }, null, 8, ["filter", "data-event-source"])) : te("", !0)
          ]),
          _: 1
        }),
        ue(Vt, {
          id: "media-releases-result-container",
          class: "d-media-releases__result-container",
          "no-margin-bottom": !0,
          "no-margin": !0
        }, {
          default: Se(() => [
            P.value ? (E(), fe(_h, {
              key: 0,
              results: e.model.results?.length,
              "number-of-result-text": {
                oneResultText: _(i)("globalTranslations.result"),
                multipleResultsText: _(i)("globalTranslations.results")
              },
              class: "d-media-releases__result-number"
            }, null, 8, ["results", "number-of-result-text"])) : te("", !0),
            e.model.results?.length > 0 ? (E(), fe(gi, {
              key: d.value,
              term: s.value,
              class: "d-media-releases__result-list"
            }, {
              default: Se(() => [
                ue(ns, {
                  model: D.value,
                  "heading-type": e.model.showNumberOfResults ? _(ze).H3 : _(ze).H2Section
                }, null, 8, ["model", "heading-type"])
              ]),
              _: 1
            }, 8, ["term"])) : te("", !0),
            e.model.results?.length === 0 ? (E(), fe(Tt, {
              key: 2,
              text: _(i)("mediaReleases.noResults"),
              "font-size": _(st).SixteenPx,
              class: "d-media-releases__result-list"
            }, null, 8, ["text", "font-size"])) : te("", !0),
            e.model.results?.length > 0 ? (E(), X("div", Wxe, [
              _(a) ? (E(), fe(od, {
                key: 0,
                first: u.value,
                "total-records": e.model.results?.length,
                "rows-per-page-options": m.value,
                rows: h.value,
                onRowsPerPageChanged: w,
                onPageChanged: S
              }, null, 8, ["first", "total-records", "rows-per-page-options", "rows"])) : te("", !0),
              _(a) ? te("", !0) : (E(), X("div", Yxe, [
                f.value?.length < e.model.results?.length ? (E(), fe(vt, {
                  key: 0,
                  type: _(Ke).Primary,
                  size: _(et).Large,
                  icon: _(H).AngleDoubleDown,
                  "icon-position": _(ct).Right,
                  "link-model": b(),
                  onClick: x
                }, null, 8, ["type", "size", "icon", "icon-position", "link-model"])) : te("", !0)
              ]))
            ])) : te("", !0)
          ]),
          _: 1
        })
      ])) : te("", !0);
    };
  }
});
const Kxe = /* @__PURE__ */ Fe(qxe, [["__scopeId", "data-v-ce7eaa19"]]), Xxe = /* @__PURE__ */ Be({
  __name: "MediaReleases.container",
  props: {
    headline: {
      type: String,
      required: !0
    },
    introText: {
      type: String,
      required: !1,
      default: ""
    }
  },
  emits: [
    "searchTerm",
    "search-record-click",
    "filter-value-changed"
  ],
  setup(e, { emit: t }) {
    const n = $j(), i = t, o = ge(n.filter), a = ge(n.selectedFilter), r = async (d, y) => {
      n.searchTerm = d, await n.onSearchCriteriaChanged({
        searchTerm: n.searchTerm,
        filter: o.value,
        flyoutResults: n.flyoutResults,
        eventType: y,
        selectedFilter: a.value
      }), i("searchTerm", d, y);
    }, s = async (d, y) => {
      o.value = y, a.value = d, await n.onSearchCriteriaChanged({
        searchTerm: n.searchTerm,
        filter: o.value,
        flyoutResults: n.flyoutResults,
        eventType: fr.FilterValueChanged,
        selectedFilter: a.value
      }), i("filter-value-changed", d);
    }, l = async (d) => {
      await n.onSearchCriteriaChanged({
        searchTerm: n.searchTerm,
        filter: o.value,
        flyoutResults: n.flyoutResults,
        eventType: fr.SearchRecordClick,
        selectedFilter: a.value
      }), i("search-record-click", d);
    };
    return sn(() => {
      n.resetStore();
    }), (d, y) => (E(), fe(Kxe, {
      model: {
        headline: e.headline,
        introText: e.introText,
        searchTerm: _(n).searchTerm,
        filter: _(n).filter,
        flyoutResults: _(n).flyoutResults,
        showNumberOfResults: _(n).showNumberOfResults,
        results: _(n).results
      },
      onSearchTerm: r,
      onSearchRecordClick: l,
      onFilterValueChanged: s
    }, null, 8, ["model"]));
  }
});
const nEe = /* @__PURE__ */ Fe(Xxe, [["__scopeId", "data-v-2f99231f"]]);
var wl = /* @__PURE__ */ ((e) => (e.Download = "download", e.DocumentViewer = "document-viewer", e.Login = "login", e))(wl || {});
const Zxe = /* @__PURE__ */ Be({
  __name: "DocumentListDocumentLink",
  props: {
    document: {
      type: Object,
      required: !0
    }
  },
  setup(e) {
    const t = e, n = ge();
    it(() => {
      t.document?.type === wl.Login && t.document?.tooltip && pn({
        trigger: n,
        headline: "props.headline",
        content: t.document.tooltip,
        appendTo: "parent",
        showOnTouchDevices: !0,
        field: () => n
      });
    });
    const i = (o) => {
      switch (o.type) {
        case wl.Download:
        case wl.DocumentViewer:
          return H.Download;
        case wl.Login:
          return H.Lock;
      }
    };
    return (o, a) => {
      const r = $e("BaseLinkV2");
      return E(), X("span", {
        ref_key: "tooltipTrigger",
        ref: n,
        class: "d-document-list-document-link"
      }, [
        e.document ? (E(), fe(r, {
          key: 0,
          "link-model": e.document.linkModel,
          icon: i(e.document),
          "icon-position": _(ct).Left
        }, null, 8, ["link-model", "icon", "icon-position"])) : te("", !0)
      ], 512);
    };
  }
});
const Jxe = /* @__PURE__ */ Fe(Zxe, [["__scopeId", "data-v-6dccf6b3"]]), Qxe = {
  key: 0,
  class: "d-document-list-product"
}, ewe = { class: "d-document-list-product__header" }, twe = { class: "d-document-list-product__category" }, nwe = { class: "d-document-list-product__document-list" }, iwe = {
  key: 0,
  class: "d-document-list-product__column"
}, awe = /* @__PURE__ */ Be({
  __name: "DocumentListProduct",
  props: {
    product: {
      type: Object,
      required: !0
    },
    mark: {
      type: String,
      default: ""
    }
  },
  setup(e) {
    const t = e, { isMobile: n, isTablet: i, isDesktop: o, isXxlPageSection: a } = xt(), r = Te(() => o.value ? s(3) : i.value || a.value ? s(2) : s(1)), s = (m) => Math.ceil(t.product.documentList.length / m), l = Te(() => t.product.documentList.slice(0, r.value)), d = Te(() => t.product.documentList.slice(
      r.value,
      r.value + r.value
    )), y = Te(() => t.product.documentList.slice(
      r.value + r.value,
      t.product.documentList.length
    )), u = Te(() => {
      const m = [];
      for (let h = 0; h < r.value; h++)
        m.push([l.value[h], d.value[h], y.value[h]]);
      return m;
    });
    return (m, h) => {
      const c = $e("BaseHeading"), g = $e("BaseLinkV2");
      return e.product ? (E(), X("div", Qxe, [
        oe("div", ewe, [
          ue(gi, { term: e.mark }, {
            default: Se(() => [
              e.product.name ? (E(), fe(c, {
                key: 0,
                "base-heading-type": _(ze).H3,
                class: "d-document-list-product__heading"
              }, {
                default: Se(() => [
                  oe("span", null, Ie(e.product.name), 1),
                  e.product.category ? (E(), X(Re, { key: 0 }, [
                    h[0] || (h[0] = oe("span", null, " – ", -1)),
                    oe("span", twe, Ie(e.product.category), 1)
                  ], 64)) : te("", !0)
                ]),
                _: 1
              }, 8, ["base-heading-type"])) : te("", !0)
            ]),
            _: 1
          }, 8, ["term"]),
          e.product.detailPageLink ? (E(), fe(g, {
            key: 0,
            class: "d-document-list-product__detail-page-link",
            "link-model": e.product.detailPageLink,
            icon: _(H).ArrowRight
          }, null, 8, ["link-model", "icon"])) : te("", !0)
        ]),
        ue(gi, { term: e.mark }, {
          default: Se(() => [
            oe("div", nwe, [
              (E(!0), X(Re, null, Ge(u.value, (v, P) => (E(), X("div", {
                key: P,
                class: "d-document-list-product__row"
              }, [
                (E(!0), X(Re, null, Ge(v, (f, S) => (E(), X(Re, { key: S }, [
                  S === 0 || S === 1 && !_(n) || S === 2 && _(o) ? (E(), X("div", iwe, [
                    f ? (E(), fe(Jxe, {
                      key: 0,
                      document: f
                    }, null, 8, ["document"])) : te("", !0)
                  ])) : te("", !0)
                ], 64))), 128))
              ]))), 128))
            ])
          ]),
          _: 1
        }, 8, ["term"])
      ])) : te("", !0);
    };
  }
});
const owe = /* @__PURE__ */ Fe(awe, [["__scopeId", "data-v-fbd21eaf"]]), rwe = {
  key: 0,
  class: "d-document-list"
}, swe = {
  key: 0,
  class: "d-document-list__paginator"
}, lwe = {
  key: 1,
  class: "d-document-list__load-more"
}, D1 = 0, cwe = /* @__PURE__ */ Be({
  __name: "DocumentList",
  props: {
    products: {
      type: Object,
      required: !0
    },
    mark: {
      type: String,
      default: ""
    },
    showAll: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const t = e, { t: n } = Je(), { onRowsPerPageChanged: i } = bm(), { isDesktopAsync: o } = xt(), a = ge(D1), r = ge(15), s = ge(15), l = Te(() => {
      const v = [15, 30];
      return t?.products?.length > 30 && v?.push(t?.products?.length), v;
    }), d = (v) => {
      a.value = v.first, r.value = v.rows;
    }, y = (v) => {
      i(v, a, r);
    }, u = Te(() => t.products?.length > 15 && !t.showAll), m = Te(() => u.value ? t.products?.slice(
      a.value,
      a.value + r.value
    ) : t.products), h = () => {
      a.value = D1, r.value = r.value + s.value;
    }, c = Te(() => {
      let v = 0;
      return t.products?.forEach((P) => {
        v += P.documentList.length;
      }), v;
    }), g = () => ({
      title: n("archivePage.loadMore"),
      text: n("archivePage.loadMore"),
      contentUrl: "",
      isLocked: !1,
      target: "",
      isExternal: !1,
      linkType: yt.Javascript,
      tealiumTrackingModel: {
        eventComponentName: "Pagination",
        eventTitle: "load more",
        eventSource: Qe().pageName
      }
    });
    return qe(
      () => t.products,
      (v, P) => {
        r.value === P?.length && (r.value = l.value.at(-1));
      }
    ), (v, P) => {
      const f = $e("BaseHeading"), S = $e("BaseButtonV2");
      return e.products ? (E(), X("div", rwe, [
        ue(f, {
          "base-heading-type": _(ze).H2Section,
          class: "d-document-list__number-of-results"
        }, {
          default: Se(() => [
            Ve(Ie(c.value) + " " + Ie(_(n)("documentList.numberOfResultLabel")), 1)
          ]),
          _: 1
        }, 8, ["base-heading-type"]),
        (E(!0), X(Re, null, Ge(m.value, (w, x) => (E(), fe(owe, {
          key: x,
          product: w,
          mark: t.mark,
          class: "d-document-list__products"
        }, null, 8, ["product", "mark"]))), 128)),
        u.value ? (E(), X("div", swe, [
          _(o) ? (E(), fe(od, {
            key: l.value?.at(-1),
            first: a.value,
            "total-records": e.products?.length,
            "rows-per-page-options": l.value,
            rows: r.value,
            onRowsPerPageChanged: y,
            onPageChanged: d
          }, null, 8, ["first", "total-records", "rows-per-page-options", "rows"])) : te("", !0),
          _(o) ? te("", !0) : (E(), X("div", lwe, [
            ue(S, {
              disabled: m.value?.length >= t.products?.length,
              type: _(Ke).Primary,
              size: _(et).Large,
              icon: _(H).AngleDoubleDown,
              "icon-position": _(ct).Right,
              "link-model": g(),
              onClick: h
            }, null, 8, ["disabled", "type", "size", "icon", "icon-position", "link-model"])
          ]))
        ])) : te("", !0)
      ])) : te("", !0);
    };
  }
});
const dwe = /* @__PURE__ */ Fe(cwe, [["__scopeId", "data-v-d144b80e"]]), uwe = {
  key: 0,
  class: "d-literature-library"
}, hwe = /* @__PURE__ */ Be({
  __name: "LiteratureLibrary",
  props: {
    model: {
      type: Object,
      required: !0
    }
  },
  emits: [
    "searchTerm",
    "filterValueChanged",
    "filterValueDeselected",
    "filter-time-period-changed",
    "tree-select-value-changed",
    "resetFilters",
    "SortByChanged",
    "search-record-click"
  ],
  setup(e, { emit: t }) {
    const n = e, { t: i } = Je(), o = Qe().pageName, a = ge(n.model.searchTerm), r = ge(), s = ge(), l = ge(), d = t;
    async function y(w, x) {
      a.value = w, d("searchTerm", w, x);
    }
    async function u(w, x, k = !1) {
      s.value?.hideSuggestionPanel(), a.value = w, r.value = w, d("searchTerm", w, x), k && f();
    }
    async function m(w) {
      s.value?.hideSuggestionPanel(), a.value = "", r.value = "", d("searchTerm", "", w);
    }
    async function h(w) {
      d("filterValueChanged", w);
    }
    function c(w) {
      d("tree-select-value-changed", w);
    }
    function g(w, x) {
      d("filterValueDeselected", w, x);
    }
    function v() {
      d("resetFilters");
    }
    function P(w) {
      a.value = w.title, r.value = w.title, s.value?.hideSuggestionPanel(), f(), d("search-record-click", w);
    }
    const f = () => {
      l.value.$el.scrollIntoView({
        behavior: "smooth"
      });
    }, S = (w) => ({
      contentUrl: "",
      title: w.title,
      text: w.title,
      isLocked: !1,
      target: "",
      isExternal: !1,
      linkType: yt.Javascript,
      tealiumTrackingModel: {
        eventSource: o,
        eventComponentName: "Literature Library",
        eventTitle: w.title
      }
    });
    return it(() => {
      a.value && u(
        a.value,
        or.SearchTermEnter
      );
    }), (w, x) => {
      const k = $e("BaseHeading");
      return e.model ? (E(), X("div", uwe, [
        ue(Vt, {
          id: "literature-library-header",
          class: "d-literature-library__header",
          "no-margin-bottom": !0,
          "no-margin": !0
        }, {
          default: Se(() => [
            e.model.headline ? (E(), fe(k, {
              key: 0,
              "base-heading-type": _(ze).H1,
              class: "d-literature-library__header--headline"
            }, {
              default: Se(() => [
                Ve(Ie(e.model.headline), 1)
              ]),
              _: 1
            }, 8, ["base-heading-type"])) : te("", !0),
            e.model.introText ? (E(), fe(ht, {
              key: 1,
              "html-text": e.model.introText,
              class: "d-literature-library__intro-text"
            }, null, 8, ["html-text"])) : te("", !0)
          ]),
          _: 1
        }),
        e.model.filters && e.model.filters.length > 0 ? (E(), fe(Vt, {
          key: 0,
          id: "literature-library-filter-section",
          class: "d-literature-library__filter-section",
          "no-margin-bottom": !0,
          "no-margin": !0
        }, {
          default: Se(() => [
            ue(Wo, {
              ref_key: "searchBoxRef",
              ref: s,
              class: "d-literature-library__filter-section--search",
              "is-suppress-open-new-window-on-enter": !0,
              model: {
                headline: "",
                placeholder: _(i)("literatureLibrary.searchBoxPlaceholder"),
                filterOptions: [],
                searchTerm: a.value,
                showLabel: !0
              },
              "use-custom-clicks": !0,
              "event-component-name": "search",
              result: e.model.flyoutResults,
              onSearch: x[0] || (x[0] = (A) => y(
                A,
                _(or).SearchTermHasChanged
              )),
              onBlur: x[1] || (x[1] = (A) => y(
                A,
                _(or).SearchTermBlur
              )),
              onClear: x[2] || (x[2] = (A) => m(
                _(or).SearchTermClear
              )),
              onEnter: x[3] || (x[3] = (A) => u(
                A,
                _(or).SearchTermEnter,
                !0
              )),
              onOnButtonClick: x[4] || (x[4] = (A) => u(
                A,
                _(or).SearchTermEnter
              ))
            }, {
              record: Se((A) => [
                ue(gi, { term: a.value }, {
                  default: Se(() => [
                    ue(_(ot), {
                      "aria-setsize": A?.record?.record?.setsize,
                      "aria-posinset": A?.record?.record?.posinset,
                      role: "option",
                      "link-model": S(A.record.record.record),
                      "font-type": _(ya).DwsRegular,
                      onClick: ($) => P(A.record.record.record),
                      onKeypress: Ze(($) => P(A.record.record.record), ["enter"])
                    }, null, 8, ["aria-setsize", "aria-posinset", "link-model", "font-type", "onClick", "onKeypress"])
                  ]),
                  _: 2
                }, 1032, ["term"])
              ]),
              _: 1
            }, 8, ["model", "result"]),
            ue(Ec, {
              model: {
                topFilters: e.model.filters,
                componentNameForTracking: "Reset-Button",
                sourceNameForTracking: _(o)
              },
              "component-name-tracking-multi-select": "Filter-dropdown",
              "component-name-tracking-tree-select": "Filter-dropdown",
              onFilterValueChanged: h,
              onTreeSelectValueChanged: c,
              onFilterValueDeselected: g,
              onResetFilters: v
            }, null, 8, ["model"])
          ]),
          _: 1
        })) : te("", !0),
        ue(Vt, {
          id: "literature-library-document-list",
          class: "d-literature-library__document-list",
          "no-margin-bottom": !0
        }, {
          default: Se(() => [
            ue(_(dwe), {
              ref_key: "documentListRef",
              ref: l,
              products: e.model.documentList,
              "show-all": e.model.showAll,
              mark: r.value
            }, null, 8, ["products", "show-all", "mark"])
          ]),
          _: 1
        })
      ])) : te("", !0);
    };
  }
});
const pwe = /* @__PURE__ */ Fe(hwe, [["__scopeId", "data-v-2095ea4d"]]), fwe = /* @__PURE__ */ Be({
  __name: "LiteratureLibrary.container",
  props: {
    headline: {
      type: String,
      required: !0
    },
    introText: {
      type: String,
      required: !1,
      default: ""
    },
    showAll: {
      type: Boolean,
      default: !1
    }
  },
  emits: [
    "filterValueChanged",
    "filterValueDeselected",
    "SortByChanged",
    "searchTerm",
    "search-record-click",
    "tree-select-value-changed"
  ],
  setup(e, { emit: t }) {
    const n = Rj(), i = t;
    async function o(u) {
      await n.onSearchCriteriaChanged({
        filters: n.filters,
        searchTerm: n.searchTerm,
        flyoutResults: n.flyoutResults,
        documentList: n.documentList
      }), i("filterValueChanged", u);
    }
    const a = async (u) => {
      await n.onSearchCriteriaChanged({
        filters: n.filters,
        searchTerm: n.searchTerm,
        flyoutResults: n.flyoutResults,
        documentList: n.documentList
      }), i("SortByChanged", u);
    }, r = async (u, m) => {
      n.searchTerm = u, await n.onSearchCriteriaChanged({
        filters: n.filters,
        searchTerm: n.searchTerm,
        flyoutResults: n.flyoutResults,
        documentList: n.documentList
      }), i("searchTerm", u, m);
    }, s = async (u, m) => {
      n.deselectFilterOption(u, m), await n.onSearchCriteriaChanged({
        filters: n.filters,
        searchTerm: n.searchTerm,
        flyoutResults: n.flyoutResults,
        documentList: n.documentList
      }), i("filterValueDeselected", u, m);
    }, l = async () => {
      n.resetAllFilters(), await n.onSearchCriteriaChanged({
        filters: n.filters,
        searchTerm: n.searchTerm,
        flyoutResults: n.flyoutResults,
        documentList: n.documentList
      }), i("filterValueChanged");
    }, d = async (u) => {
      n.searchTerm = u.title, await n.onSearchCriteriaChanged({
        filters: n.filters,
        searchTerm: n.searchTerm,
        flyoutResults: n.flyoutResults,
        documentList: n.documentList
      }), i("search-record-click", u);
    };
    function y(u) {
      i("tree-select-value-changed", u);
    }
    return sn(() => {
      n.resetStore(), n.resetAllFilters();
    }), (u, m) => (E(), fe(pwe, {
      model: {
        headline: e.headline,
        introText: e.introText,
        filters: _(n).filters,
        documentList: _(n).documentList,
        flyoutResults: _(n).flyoutResults,
        showAll: e.showAll,
        searchTerm: _(n).searchTerm
      },
      onFilterValueChanged: o,
      onFilterValueDeselected: s,
      onResetFilters: l,
      onSortByChanged: a,
      onSearchTerm: r,
      onSearchRecordClick: d,
      onTreeSelectValueChanged: y
    }, null, 8, ["model"]));
  }
});
const iEe = /* @__PURE__ */ Fe(fwe, [["__scopeId", "data-v-b90bcc6d"]]);
var mwe = eL;
function gwe(e, t) {
  var n = [];
  return mwe(e, function(i, o, a) {
    t(i, o, a) && n.push(i);
  }), n;
}
var vwe = gwe, ywe = vT, bwe = vwe, xwe = QT, wwe = oa;
function kwe(e, t) {
  var n = wwe(e) ? ywe : bwe;
  return n(e, xwe(t));
}
var Swe = kwe;
const Cwe = /* @__PURE__ */ en(Swe), Twe = {
  key: 0,
  class: "d-maintenance-page"
}, Lwe = {
  key: 0,
  class: "d-maintenance-page__background"
}, Iwe = ["src", "alt"], Pwe = { class: "d-maintenance-page__content container" }, Awe = /* @__PURE__ */ Be({
  __name: "MaintenancePage",
  props: {
    model: {
      type: Object,
      required: !0
    }
  },
  setup(e) {
    const { currentLocale: t, t: n } = Je(), i = e, o = Te(() => t.value.toString().slice(0, 2).toLowerCase() === "de" ? Cwe(i.model, function(s) {
      return s.culture.slice(0, 2).toLowerCase() === "en";
    }) : i.model), a = Te(() => o.value.length === 1 ? 0 : 1), r = (s) => s === H.Envelope ? `icon, ${n("globalTranslations.email")}` : s === H.Phone ? `icon, ${n("globalTranslations.phone")}` : "";
    return (s, l) => {
      const d = $e("BaseHeading"), y = $e("BaseText"), u = $e("BaseLinkV2");
      return e.model && o.value.length ? (E(), X("div", Twe, [
        o.value[a.value].backgroundImageUrl ? (E(), X("div", Lwe, [
          oe("img", {
            class: "d-maintenance-page__background--image",
            src: o.value[a.value].backgroundImageUrl,
            alt: o.value[a.value].backgroundImageAltText
          }, null, 8, Iwe)
        ])) : te("", !0),
        oe("div", Pwe, [
          oe("div", {
            class: Pe(["d-maintenance-page__content--container", {
              "d-maintenance-page__content--container--extra-padding": a.value === 1
            }])
          }, [
            o.value ? (E(!0), X(Re, { key: 0 }, Ge(o.value, (m, h) => (E(), X("div", { key: h }, [
              ue(d, {
                "base-heading-type": h === 0 ? _(ze).H1 : _(ze).H2,
                class: Pe({
                  "d-maintenance-page__content--headline": h === 1
                })
              }, {
                default: Se(() => [
                  Ve(Ie(m.headline), 1)
                ]),
                _: 2
              }, 1032, ["base-heading-type", "class"]),
              ue(y, {
                text: m.introText
              }, null, 8, ["text"]),
              m.mail ? (E(), fe(u, {
                key: 0,
                "is-copy-link": !0,
                "link-model": m.mail,
                icon: _(H).Envelope,
                "icon-position": _(ct).Left,
                "icon-aria-label": r(_(H).Envelope)
              }, null, 8, ["link-model", "icon", "icon-position", "icon-aria-label"])) : te("", !0),
              m.tel ? (E(), fe(u, {
                key: 1,
                class: "flex",
                "is-copy-link": !0,
                "link-model": m.tel,
                icon: _(H).Phone,
                "icon-position": _(ct).Left,
                "icon-aria-label": r(_(H).Phone)
              }, null, 8, ["link-model", "icon", "icon-position", "icon-aria-label"])) : te("", !0),
              m.sectionHeadline ? (E(), fe(d, {
                key: 2,
                class: "d-maintenance-page__content--section-headline",
                "base-heading-type": _(ze).H2LooksLikeH3
              }, {
                default: Se(() => [
                  Ve(Ie(m.sectionHeadline), 1)
                ]),
                _: 2
              }, 1032, ["base-heading-type"])) : te("", !0),
              m.contacts ? (E(), fe($c, {
                key: 3,
                class: "d-maintenance-page__content--unordered-list",
                "list-items": m.contacts
              }, null, 8, ["list-items"])) : te("", !0)
            ]))), 128)) : te("", !0)
          ], 2)
        ])
      ])) : te("", !0);
    };
  }
});
const aEe = /* @__PURE__ */ Fe(Awe, [["__scopeId", "data-v-e419ea26"]]), _we = { class: "d-shrink-search__main container" }, Mwe = { class: "d-shrink-search__box" }, Owe = { class: "d-shrink-search__header" }, Bwe = {
  key: 0,
  class: "d-shrink-search__itemlist"
}, Ewe = ["data-event_component_name", "data-event_title", "data-event_source", "onClick", "onKeydown"], Dwe = {
  key: 1,
  class: "d-shrink-search__custom-itemlist"
}, Rwe = {
  key: 0,
  class: "container"
}, Nwe = { class: "d-shrink-search__header--mobile" }, $we = {
  key: 1,
  class: "d-shrink-search__itemlist"
}, Fwe = ["data-event_component_name", "data-event_title", "data-event_source", "onClick"], jwe = {
  key: 2,
  class: "d-shrink-search__custom-itemlist"
}, rL = /* @__PURE__ */ Be({
  __name: "ShrinkSearch",
  props: {
    model: {
      type: Object,
      required: !0
    },
    customButton: {
      type: Boolean,
      default: !1
    },
    noButton: {
      type: Boolean,
      default: !1
    },
    customItemList: {
      type: Boolean,
      default: !1
    },
    headingType: {
      type: String,
      default: ze.H3
    },
    suggesterResult: {
      type: Object,
      default: null
    }
  },
  emits: [
    "expandChanged",
    "clickOutside",
    "selectionClick",
    "toggle"
  ],
  setup(e, { expose: t, emit: n }) {
    const i = e, o = ge(!1), a = ge(), r = n, { isSmallOrEqualLgAsync: s, isSmallOrEqualXxlAsync: l } = xt(), { pageName: d } = Qe(), y = ge(!1), u = ge(), m = ge(), h = ge(!1), { setShrinkSearch: c, isHeaderExpanded: g } = Fn(), v = Te(() => (j) => ({
      title: j + " " + i.model.tealiumTracking?.itemListButtonDataEventComponentName,
      tealiumTrackingModel: {
        eventSource: d,
        eventComponentName: i.model.tealiumTracking?.itemListButtonDataEventComponentName,
        eventTitle: j
      }
    })), P = (j) => {
      h.value = j;
    }, f = Te(() => () => ({
      title: "A-Z",
      text: "A-Z",
      target: "_self",
      isLocked: !1,
      tealiumTrackingModel: {
        eventSource: d,
        eventComponentName: "Glossary",
        eventTitle: "letter"
      },
      linkType: yt.Javascript
    })), S = (j) => {
      w(!1), r("selectionClick", j);
    }, w = (j) => {
      r("toggle", j), o.value = j;
    }, x = Te(() => !i?.customButton && !i?.noButton && i?.model?.itemList?.length > 1);
    it(async () => {
      a.value && c(a.value, i?.model?.triggerElement), Ue && (window.addEventListener("scroll", A, { passive: !0 }), window.addEventListener("resize", k)), await mt(), await $();
    }), sn(() => {
      Ue && (window.removeEventListener("scroll", A), window.removeEventListener("resize", k));
    });
    async function k() {
      a.value && c(a.value, i?.model?.triggerElement);
    }
    const A = Jn(
      () => {
        $();
      },
      250,
      { maxWait: 500 }
    );
    qe(
      () => g(),
      (j) => {
        j ? a.value.classList.add("d-shrink-search__extra-top") : a.value.classList.remove("d-shrink-search__extra-top");
      }
    ), qe(
      () => i?.model?.triggerElement,
      (j) => {
        c(a.value, j);
      }
    );
    async function $() {
      if (!Ue || !i.model.triggerElement || !a.value)
        return;
      y.value = g(), await mt();
      const j = i?.model?.triggerElement?.getBoundingClientRect()?.bottom;
      no("(max-width: 320px)").value || j >= 0 ? a.value?.classList.contains("d-shrink-search__show-element") && (r("expandChanged", !1), a.value?.classList.remove("d-shrink-search__show-element"), o.value = !1) : (r("expandChanged", !0), a.value.classList.add("d-shrink-search__show-element"));
    }
    return t({ toggleSelection: w, setSuggester: P }), (j, N) => (E(), X("div", {
      ref_key: "shrinkSearch",
      ref: a,
      class: Pe(["d-shrink-search d-shrink-search__show-element", {
        "d-shrink-search--full": o.value || h.value,
        "d-shrink-search__extra-top": _(g)()
      }]),
      role: "main"
    }, [
      oe("div", _we, [
        oe("div", Mwe, [
          N[5] || (N[5] = oe("div", { id: "shrink-search" }, null, -1)),
          ue(oo, null, {
            default: Se(() => [
              !_(s) && o.value ? (E(), X("div", {
                key: 0,
                ref_key: "suggesterRef",
                ref: u
              }, [
                oe("div", Owe, [
                  ue(Ot, { "base-heading-type": e.headingType }, {
                    default: Se(() => [
                      Ve(Ie(e.model.itemHeadline), 1)
                    ]),
                    _: 1
                  }, 8, ["base-heading-type"]),
                  ue(Nt, {
                    type: _(Ke).RoundedNonFilled,
                    size: _(et).Small,
                    "link-model": v.value("Close"),
                    icon: _(H).Times,
                    onClick: N[0] || (N[0] = (M) => w(!1))
                  }, null, 8, ["type", "size", "link-model", "icon"])
                ]),
                e.customItemList ? te("", !0) : (E(), X("div", Bwe, [
                  oe("div", {
                    class: Pe(["d-shrink-search__itemlist__items", {
                      "d-shrink-search__itemlist__items--extra": y.value
                    }])
                  }, [
                    (E(!0), X(Re, null, Ge(e.model.itemList, (M, D) => (E(), X("a", {
                      key: D,
                      tabindex: "0",
                      "data-event_component_name": e.model.tealiumTracking?.itemListDataEventComponentName,
                      "data-event_title": M,
                      "data-event_source": _(d),
                      onClick: (C) => S(D),
                      onKeydown: Ze((C) => S(D), ["enter"])
                    }, [
                      ue(Tt, {
                        "font-type": _(lt).DwsSlabBold,
                        "font-size": _(st).SixteenPx,
                        class: "d-shrink-search__itemlist__items__item",
                        text: M
                      }, null, 8, ["font-type", "font-size", "text"])
                    ], 40, Ewe))), 128))
                  ], 2)
                ])),
                e.customItemList ? (E(), X("div", Dwe, [
                  je(j.$slots, "letterBlock")
                ])) : te("", !0)
              ], 512)) : te("", !0)
            ]),
            _: 3
          })
        ]),
        x.value ? (E(), fe(Nt, {
          key: 0,
          class: Pe(["d-shrink-search__button", { "d-shrink-search__button--active": o.value }]),
          type: _(Ke).RoundedPrimary,
          size: _(et).Large,
          icon: _(H).EllipsisH,
          "link-model": v.value("Open"),
          onClick: N[1] || (N[1] = (M) => w(!0))
        }, null, 8, ["class", "type", "size", "icon", "link-model"])) : te("", !0),
        e.customButton ? (E(), fe(ot, {
          key: 1,
          class: Pe(["d-shrink-search__custom-button", { "d-shrink-search__custom-button--active": o.value }]),
          "font-size": _(yn).TwentyFourPx,
          "link-model": f.value(),
          onClick: N[2] || (N[2] = (M) => w(!0)),
          onKeydown: N[3] || (N[3] = Ze(It((M) => w(!0), ["prevent"]), ["enter"]))
        }, null, 8, ["class", "font-size", "link-model"])) : te("", !0)
      ]),
      ue(oo, null, {
        default: Se(() => [
          _(l) && !_(s) && o.value ? (E(), X("div", Rwe, [
            je(j.$slots, "footer")
          ])) : te("", !0)
        ]),
        _: 3
      }),
      ue(oo, null, {
        default: Se(() => [
          _(s) && o.value ? (E(), X("div", {
            key: 0,
            ref_key: "suggesterMobileRef",
            ref: m,
            class: "container"
          }, [
            oe("div", Nwe, [
              ue(Nt, {
                type: _(Ke).RoundedNonFilled,
                size: _(et).Small,
                "link-model": v.value("Close"),
                icon: _(H).Times,
                onClick: N[4] || (N[4] = (M) => w(!1))
              }, null, 8, ["type", "size", "link-model", "icon"])
            ]),
            e.model.itemHeadline ? (E(), fe(Ot, {
              key: 0,
              "base-heading-type": e.headingType
            }, {
              default: Se(() => [
                Ve(Ie(e.model.itemHeadline), 1)
              ]),
              _: 1
            }, 8, ["base-heading-type"])) : te("", !0),
            e.customItemList ? te("", !0) : (E(), X("div", $we, [
              oe("div", {
                class: Pe(["d-shrink-search__itemlist__items", {
                  "d-shrink-search__itemlist__items--extra": y.value
                }])
              }, [
                (E(!0), X(Re, null, Ge(e.model.itemList, (M, D) => (E(), X("a", {
                  key: D,
                  "data-event_component_name": e.model.tealiumTracking?.itemListDataEventComponentName,
                  "data-event_title": M,
                  "data-event_source": _(d),
                  onClick: (C) => S(D)
                }, [
                  ue(Tt, {
                    "font-type": _(lt).DwsSlabBold,
                    "font-size": _(st).SixteenPx,
                    class: "d-shrink-search__itemlist__items__item",
                    text: M
                  }, null, 8, ["font-type", "font-size", "text"])
                ], 8, Fwe))), 128)),
                je(j.$slots, "footer")
              ], 2)
            ])),
            e.customItemList ? (E(), X("div", jwe, [
              je(j.$slots, "letterBlock")
            ])) : te("", !0)
          ], 512)) : te("", !0)
        ]),
        _: 3
      })
    ], 2));
  }
});
var Ao = /* @__PURE__ */ ((e) => (e.FullWidth = "full-width", e.TwoThirdWidth = "two-third-width", e.HalfWidth = "half-width", e))(Ao || {}), sL = /* @__PURE__ */ ((e) => (e.Left = "left", e.Right = "right", e.AlternatingFirstLeft = "alternating-first-left", e.AlternatingFirstRight = "alternating-first-right", e.Alternate = "alternate", e))(sL || {});
const Hwe = { class: "d-accordion-item" }, zwe = { class: "d-accordion-item__expand-element collapsible mb-5 w-full text-right xs:pr-5 md:pr-3 pr-3 hover:underline" }, Vwe = { key: 0 }, Gwe = ["data-event_source"], Uwe = {
  key: 0,
  class: "mb-5"
}, Wwe = /* @__PURE__ */ Be({
  __name: "AccordionItem",
  props: {
    id: {
      type: String,
      default: null
    },
    header: {
      type: String,
      default: null
    },
    image: {
      type: Object,
      default: null,
      required: !1
    },
    preview: {
      type: String,
      default: null,
      required: !1
    },
    expanded: {
      type: Boolean,
      default: !1
    },
    footnotes: {
      type: Object,
      default: null
    },
    layout: {
      type: String,
      default: null,
      required: !1
    },
    showLessText: {
      type: String,
      default: null,
      required: !1
    },
    showMoreText: {
      type: String,
      default: null,
      required: !1
    }
  },
  setup(e) {
    const { pageName: t } = Qe(), { t: n } = Je(), i = Jt(), o = ge(!1);
    return (a, r) => {
      const s = $e("BaseIcon");
      return E(), X("div", Hwe, [
        je(a.$slots, "default", {}, void 0, !0),
        _(i).showMoreContent ? (E(), X("div", {
          key: 0,
          onClick: r[0] || (r[0] = () => o.value = !o.value)
        }, [
          oe("p", zwe, [
            o.value ? (E(), X("span", Vwe, [
              Ve(Ie(e.showLessText ?? _(n)("showMoreShowLess.showLessText")) + " ", 1),
              ue(s, {
                "base-icon": _(H).Minus,
                "aria-label": _(n)("showMoreShowLess.showLessText")
              }, null, 8, ["base-icon", "aria-label"])
            ])) : (E(), X("span", {
              key: 1,
              "data-event_source": _(t),
              "data-event_component_name": "Accordion",
              "data-event_title": "show more"
            }, [
              Ve(Ie(e.showMoreText ?? _(n)("showMoreShowLess.showMoreText")) + " ", 1),
              ue(s, {
                "base-icon": _(H).Plus,
                "data-event_source": _(t),
                "data-event_component_name": "Accordion",
                "data-event_title": "show more",
                "aria-label": _(n)("showMoreShowLess.showMoreText")
              }, null, 8, ["base-icon", "data-event_source", "aria-label"])
            ], 8, Gwe))
          ]),
          o.value ? (E(), X("div", Uwe, [
            je(a.$slots, "showMoreContent", {}, void 0, !0)
          ])) : te("", !0)
        ])) : te("", !0),
        e.footnotes !== void 0 ? (E(), fe(ja, {
          key: 1,
          id: e.id,
          values: {
            footnotes: e.footnotes
          }
        }, null, 8, ["id", "values"])) : te("", !0)
      ]);
    };
  }
});
const Fh = /* @__PURE__ */ Fe(Wwe, [["__scopeId", "data-v-f2b708d0"]]), Ywe = {
  key: 0,
  class: "d-accordion-container__button"
}, tv = /* @__PURE__ */ Be({
  __name: "AccordionContainerButtons",
  props: {
    showButtons: {
      type: Boolean,
      default: !0
    },
    isCloseAllDefault: {
      type: Boolean
    },
    openButtonText: {
      type: String,
      default: ""
    },
    closeButtonText: {
      type: String,
      default: ""
    }
  },
  emits: ["toggleAll"],
  setup(e, { expose: t, emit: n }) {
    const i = e, { t: o } = Je(), { pageName: a } = Qe(), r = a, s = n, l = ge(), d = ge(), y = ge();
    function u(m) {
      y.value = m ? d.value : l.value;
    }
    return it(() => {
      l.value = i.openButtonText ? i.openButtonText : o("accordionContainer.openAll"), d.value = i.closeButtonText ? i.closeButtonText : o("accordionContainer.closeAll"), y.value = i.isCloseAllDefault ? d.value : l.value;
    }), t({
      tabToggled: u
    }), (m, h) => e.showButtons ? (E(), X("div", Ywe, [
      ue(vt, {
        type: _(Ke).Secondary,
        size: _(et).Small,
        "link-model": {
          title: y.value,
          text: y.value,
          tealiumTrackingModel: {
            eventComponentName: "Button",
            eventTitle: y.value,
            eventSource: _(r)
          }
        },
        onClick: h[0] || (h[0] = (c) => s("toggleAll"))
      }, null, 8, ["type", "size", "link-model"])
    ])) : te("", !0);
  }
}), qwe = (e) => {
  if (e) {
    const t = e.split("{{");
    return t.length > 1 ? t[0] : e;
  } else
    return e;
}, Kwe = (e) => {
  if (e) {
    const t = e.indexOf("{{");
    if (t > 0)
      return e.substring(t, e.length);
  }
  return "";
}, Xwe = { class: "d-expandable-teasers__content" }, Zwe = {
  key: 1,
  class: "d-expandable-teasers__button"
}, Jwe = /* @__PURE__ */ Be({
  __name: "ExpandableTeasersContent",
  props: {
    item: {
      type: Object,
      required: !0
    }
  },
  setup(e) {
    const t = e, n = (o) => {
      const a = {
        linkModel: t.item.linkUrl,
        size: et.Medium
      };
      switch (o.buttonType) {
        case cn.Link:
          return At(ot, {
            linkModel: t.item.linkUrl,
            icon: H.ArrowRight,
            iconPosition: ct.Right,
            stopPropagation: !0
          });
        case cn.SecondaryButton:
          return At(vt, {
            ...a,
            type: Ke.Secondary,
            onClick: (r) => {
              i(r, t.item.linkUrl);
            }
          });
        case cn.PrimaryButton:
        default:
          return At(vt, {
            ...a,
            type: Ke.Primary,
            onClick: (r) => {
              i(r, t.item.linkUrl);
            }
          });
      }
    }, i = (o, a) => {
      o?.stopPropagation(), Ue && a && window.open(a.href, a.target);
    };
    return (o, a) => (E(), X("div", Xwe, [
      e.item.text !== void 0 && e.item.text != "" ? (E(), fe(ht, {
        key: 0,
        "html-text": e.item.text,
        class: "d-expandable-teasers__content__teaser-text"
      }, null, 8, ["html-text"])) : te("", !0),
      e.item.linkUrl != null ? (E(), X("div", Zwe, [
        (E(), fe(tt(n(e.item))))
      ])) : te("", !0)
    ]));
  }
});
const lL = /* @__PURE__ */ Fe(Jwe, [["__scopeId", "data-v-dc99e54f"]]), Qwe = { class: "d-accordion-container" }, eke = ["data-event_source", "data-event_component_name", "data-event_title"], tke = /* @__PURE__ */ Be({
  __name: "AccordionContainer",
  props: {
    showButtons: {
      type: Boolean,
      default: !0
    },
    openButtonText: {
      type: String,
      default: ""
    },
    closeButtonText: {
      type: String,
      default: ""
    },
    openTabs: {
      type: Array,
      default: () => []
    },
    layout: {
      type: String,
      default: Ao.FullWidth
    },
    highlightedText: {
      type: String,
      default: ""
    },
    eventComponentName: {
      type: String,
      default: "Accordion"
    },
    headingType: {
      type: String,
      default: ze.H3
    },
    resultCount: {
      type: Number,
      default: 0
    },
    initialIndex: {
      type: Number,
      default: 1
    }
  },
  emits: ["tab-open", "tab-close"],
  setup(e, { expose: t, emit: n }) {
    const i = e, { pageName: o } = Qe(), a = o, r = n, s = Jt(), l = xt(), d = ge([]), y = ge(), u = (b) => {
      const p = b?.target;
      if (!(p?.tagName === "A"))
        return;
      b?.stopPropagation();
      const B = p?.getAttribute("data-event_component_name") || "", T = p?.getAttribute("data-event_title") || "", O = p?.getAttribute("data-event_source") || "";
      On(B, T, O);
    }, m = () => (s.default ? s.default() : null)?.reduce((b, p) => (h(p) ? b.push(p) : p.children && p.children instanceof Array && p.children.forEach((L) => {
      h(L) && b.push(L);
    }), b), new Array());
    function h(b) {
      return b.type === Fh;
    }
    const c = (b) => qwe(b.props?.header), g = (b) => Kwe(b.props?.header), v = (b) => b.props?.id, P = ge(
      m()?.reduce((b, p, L) => (p.props?.expanded === !0 && b.push(L), b), i.openTabs)
    ), f = (b) => P.value?.find((p) => p === b) !== void 0, S = Te(() => P.value.length === m().length), w = (b) => {
      y.value?.tabToggled(S.value), r("tab-open", b);
    }, x = (b) => {
      A(b), r("tab-close", b);
    }, k = (b) => {
      f(b) || A(b);
    }, A = (b) => {
      f(b) ? P.value = P.value?.filter(
        (p) => p != b
      ) : P.value?.push(b);
    }, $ = () => {
      P.value = S.value ? [] : m()?.map((b, p) => p);
    }, j = (b) => {
      P.value = b ? m()?.map((p, L) => L) : [], r("tab-open");
    }, N = (b) => b.props?.layout === Ao.FullWidth && l.isXxlPageSection.value || l.isTablet.value, M = (b, p) => {
      if (b.props?.layout === Ao.HalfWidth && l.isXxlPageSection.value) {
        if (C(b, p) && D(b, p) && !f(p))
          return "calc(100% + 0.25rem)";
        switch (!0) {
          case f(p):
            return "auto";
          case D(b, p):
            return "auto";
          default:
            return "100%";
        }
      }
    };
    function D(b, p) {
      if (b.props?.layout === Ao.HalfWidth && l.isXxlPageSection.value)
        return p % 2 !== 0 ? f(p - 1) : f(p + 1);
    }
    function C(b, p) {
      if (b.props?.layout === Ao.HalfWidth && l.isXxlPageSection.value) {
        const L = m();
        return L !== void 0 && p === L.length - 1 ? !0 : L !== void 0 && p === L.length - 2;
      }
    }
    return qe(P, () => {
      y.value?.tabToggled(S.value);
    }), t({
      toggleAll: j,
      isAllExpanded: S
    }), (b, p) => {
      const L = $e("BaseImage"), B = $e("BaseHeading"), T = $e("BaseText"), O = $e("BaseIcon");
      return E(), X("div", Qwe, [
        ue(tv, {
          ref_key: "containerButtons",
          ref: y,
          "show-buttons": e.showButtons,
          "is-close-all-default": S.value,
          "open-button-text": e.openButtonText,
          "close-button-text": e.closeButtonText,
          onToggleAll: $
        }, null, 8, ["show-buttons", "is-close-all-default", "open-button-text", "close-button-text"]),
        ue(_(Lm), {
          multiple: !0,
          "active-index": P.value,
          onTabClose: p[0] || (p[0] = (I) => x(I.index)),
          onTabOpen: p[1] || (p[1] = (I) => w(I.index))
        }, {
          default: Se(() => [
            (E(!0), X(Re, null, Ge(m(), (I, R) => (E(), fe(_(Im), {
              key: R,
              pt: {
                header: {
                  style: {
                    height: M(I, R)
                  }
                },
                headerIcon: {
                  role: "img",
                  "aria-label": "SVG image"
                },
                headerAction: {
                  role: "button",
                  "aria-setsize": e.resultCount || null,
                  "aria-expanded": f(R),
                  "aria-posinset": e.resultCount ? e.initialIndex + R : null,
                  "data-event_source": f(R) ? _(a) : null,
                  "data-event_title": f(R) ? c(I) : null,
                  "data-event_component_name": f(R) ? e.eventComponentName : null,
                  style: {
                    height: M(I, R),
                    "text-decoration": "none"
                  },
                  class: {
                    neighborExpanded: D(I, R)
                  }
                }
              }
            }, {
              header: Se(() => [
                oe("a", {
                  class: "contents",
                  tabindex: "-1",
                  "data-event_source": f(R) ? null : _(a),
                  "data-event_component_name": f(R) ? null : e.eventComponentName,
                  "data-event_title": f(R) ? null : c(I)
                }, [
                  oe("div", {
                    ref_for: !0,
                    ref: (Y) => d.value[R] = Y,
                    class: Pe(["d-accordion-container__header-container", I.props?.image ? "withImg" : "noImg"])
                  }, [
                    I.props?.image ? (E(), fe(L, {
                      key: 0,
                      model: I.props?.image,
                      class: "d-accordion-container__image"
                    }, null, 8, ["model"])) : te("", !0),
                    oe("div", {
                      class: "d-accordion-container__headingAndText justify-center",
                      onClick: u,
                      onKeydown: Ze(u, ["enter"])
                    }, [
                      ue(gi, { term: e.highlightedText }, {
                        default: Se(() => [
                          ue(B, {
                            id: v(I),
                            "base-heading-type": e.headingType,
                            class: "d-accordion-container__heading"
                          }, {
                            default: Se(() => [
                              Ve(Ie(c(I)), 1)
                            ]),
                            _: 2
                          }, 1032, ["id", "base-heading-type"])
                        ]),
                        _: 2
                      }, 1032, ["term"]),
                      ue(li, {
                        text: g(I),
                        "foot-note-id": v(I),
                        "should-stop-propagation": !0,
                        "on-click": () => {
                          k(R);
                        }
                      }, null, 8, ["text", "foot-note-id", "on-click"]),
                      I.props?.preview != "" && I.props?.preview !== void 0 && I.props?.preview !== null && N(I) ? (E(), fe(T, {
                        key: 0,
                        text: I.props?.preview,
                        class: "d-accordion-container__previewText"
                      }, null, 8, ["text"])) : te("", !0),
                      rt(ue(lL, {
                        item: {
                          text: I.props?.text,
                          linkUrl: I.props?.linkurl,
                          buttonType: I.props?.buttontype
                        }
                      }, null, 8, ["item"]), [
                        [xn, f(R) && N(I)]
                      ])
                    ], 32),
                    I.props?.preview != "" && I.props?.preview !== void 0 && I.props?.preview !== null && !N(I) ? (E(), fe(T, {
                      key: 1,
                      text: I.props?.preview,
                      class: "d-accordion-container__previewText"
                    }, null, 8, ["text"])) : te("", !0),
                    ue(O, {
                      "base-icon": f(R) ? _(H).Minus : _(H).Plus,
                      class: "p-accordion-toggle-icon",
                      "aria-label": f(R) ? "collapse" : "expand"
                    }, null, 8, ["base-icon", "aria-label"])
                  ], 2)
                ], 8, eke)
              ]),
              default: Se(() => [
                (E(), fe(tt(I)))
              ]),
              _: 2
            }, 1032, ["pt"]))), 128))
          ]),
          _: 1
        }, 8, ["active-index"])
      ]);
    };
  }
});
const nv = /* @__PURE__ */ Fe(tke, [["__scopeId", "data-v-a363b279"]]), nke = {
  key: 0,
  class: "d-accordion-topic-container"
}, ike = { class: "d-accordion-topic-container__accordion" }, ake = /* @__PURE__ */ Be({
  __name: "AccordionTopicContainer",
  props: {
    model: {
      type: Object,
      required: !0
    },
    showButtons: {
      type: Boolean,
      default: !0
    },
    openButtonText: {
      type: String,
      default: null
    },
    closeButtonText: {
      type: String,
      default: null
    },
    renderSlotAfterTopics: {
      type: Array,
      default: () => []
    },
    highlightedText: {
      type: String,
      default: ""
    },
    eventComponentName: {
      type: String,
      default: "Accordion"
    },
    topicHeadingType: {
      type: String,
      default: ze.H2Section
    },
    resultsCount: {
      type: Number,
      default: 0
    },
    initialIndex: {
      type: Number,
      default: 1
    }
  },
  emits: ["tabToggled"],
  setup(e, { expose: t, emit: n }) {
    const i = e, o = ge([]), a = ge(), r = ge(), s = n, l = Te(() => {
      const h = [];
      let c = i?.initialIndex;
      return i?.model?.topics?.forEach((g) => {
        h.push(c), c += g?.items?.length || 0;
      }), h;
    }), d = Te(() => (h) => h?.reduce((c, g, v) => (g.isExpanded && c.push(v), c), [])), y = () => {
      r.value = o.value.filter((h) => h !== null).every((h) => h?.isAllExpanded), a.value?.tabToggled(r.value), s("tabToggled");
    }, u = (h) => (o.value.push(h), h), m = (h = r.value) => {
      o.value.filter((c) => c !== null).forEach((c) => {
        c?.toggleAll(!h);
      }), y();
    };
    return it(() => {
      y();
    }), t({
      isAllExpanded: r,
      expandCollapseAllTabs: m
    }), (h, c) => e.model ? (E(), X("div", nke, [
      e.showButtons ? (E(), fe(tv, {
        key: 0,
        ref_key: "containerButtons",
        ref: a,
        class: "d-accordion-topic-container__buttons",
        "show-buttons": !0,
        "is-close-all-default": r.value,
        "open-button-text": e.openButtonText,
        "close-button-text": e.closeButtonText,
        onToggleAll: m
      }, null, 8, ["is-close-all-default", "open-button-text", "close-button-text"])) : te("", !0),
      e.model.headline ? (E(), fe(Ot, {
        key: 1,
        class: "d-accordion-topic-container__headline",
        "base-heading-type": _(ze).H2
      }, {
        default: Se(() => [
          Ve(Ie(e.model.headline), 1)
        ]),
        _: 1
      }, 8, ["base-heading-type"])) : te("", !0),
      oe("div", ike, [
        (E(!0), X(Re, null, Ge(e.model.topics, (g, v) => (E(), X("div", { key: v }, [
          ue(gi, { term: e.highlightedText }, {
            default: Se(() => [
              g.headline ? (E(), fe(Ot, {
                key: 0,
                class: Pe([{
                  "d-accordion-topic-container__headline--topic-without-items": !g.items || g.items.length === 0
                }, "d-accordion-topic-container__headline--topic"]),
                "base-heading-type": e.topicHeadingType
              }, {
                default: Se(() => [
                  Ve(Ie(g.headline), 1)
                ]),
                _: 2
              }, 1032, ["class", "base-heading-type"])) : te("", !0)
            ]),
            _: 2
          }, 1032, ["term"]),
          (E(), fe(_(nv), {
            id: "container_" + v,
            ref_for: !0,
            ref: u,
            key: "container_" + v,
            "open-tabs": d.value(g.items),
            "show-buttons": !1,
            "highlighted-text": e.highlightedText,
            "event-component-name": e.eventComponentName,
            "heading-type": _(ze).H4LooksLikeH3,
            "result-count": e.resultsCount,
            "initial-index": l.value[v],
            onTabOpen: y,
            onTabClose: y
          }, {
            default: Se(() => [
              (E(!0), X(Re, null, Ge(g.items, (P, f) => (E(), fe(_(Fh), {
                id: "item_" + P.id,
                key: P.header + f,
                header: P.header
              }, {
                default: Se(() => [
                  ue(gi, { term: e.highlightedText }, {
                    default: Se(() => [
                      ue(ht, {
                        "html-text": P.content
                      }, null, 8, ["html-text"])
                    ]),
                    _: 2
                  }, 1032, ["term"])
                ]),
                _: 2
              }, 1032, ["id", "header"]))), 128))
            ]),
            _: 2
          }, 1032, ["id", "open-tabs", "highlighted-text", "event-component-name", "heading-type", "result-count", "initial-index"])),
          e.renderSlotAfterTopics.includes(v) ? je(h.$slots, "default", { key: 0 }, void 0, !0) : te("", !0)
        ]))), 128))
      ])
    ])) : te("", !0);
  }
});
const cL = /* @__PURE__ */ Fe(ake, [["__scopeId", "data-v-ae175411"]]), oke = {
  key: 0,
  class: "d-faq-page-results-view"
}, rke = {
  key: 0,
  "aria-live": "polite",
  class: "d-faq-page-results-view__results-text"
}, ske = ["role"], lke = /* @__PURE__ */ Be({
  __name: "FaqPageResultsView",
  props: {
    model: {
      type: Object,
      required: !0
    }
  },
  setup(e) {
    const t = e, { t: n } = Je(), { isDesktopAsync: i, isSmallOrEqualMdAsync: o } = xt(), a = ge(), r = ge(), s = ge(), l = ge(), d = Te(() => {
      const h = [];
      let c = 1;
      return t?.model?.categories?.forEach((g) => {
        h?.push(c), g?.topics?.forEach((v) => {
          c += v?.items?.length || 0;
        });
      }), h;
    }), y = Te(() => {
      const h = ge();
      return t.model.isSearching && !isNaN(t.model.resultsCount) && t.model.resultsCount > 0 ? h.value = t.model.resultsCount + " " + (t.model.resultsCount === 1 ? n("faqPage.result") : n("faqPage.results")) : h.value = n("faqPage.noResults"), h.value;
    }), u = () => {
      if (!Ue || (r.value = s.value.querySelectorAll(".p-accordion-tab"), !r.value || !r.value.length))
        return;
      new MutationObserver(() => {
        fi(() => {
          l.value = Array.from(r.value).every(
            (c) => c.classList.contains("p-accordion-tab-active")
          ), a.value?.tabToggled(l.value);
        }, 0);
      }).observe(s.value, { subtree: !0, childList: !0 });
    }, m = () => {
      Ue && (r.value = s.value.querySelectorAll(".p-accordion-tab"), !(!r.value || !r.value.length) && r.value.forEach((h) => {
        const c = h?.classList?.contains("p-accordion-tab-active");
        (!l.value && !c || l.value && c) && h?.querySelector(".p-accordion-header-action")?.dispatchEvent(new Event("click"));
      }));
    };
    return (h, c) => e.model ? (E(), X("div", oke, [
      e.model.isSearching || e.model.isSearching && e.model.resultsCount === 0 ? (E(), X("div", rke, Ie(y.value), 1)) : te("", !0),
      e.model.isSearching && (e.model.showResultsCount || !e.model.resultsCount || e.model.resultsCount === 0) ? (E(), fe(Ot, {
        key: 1,
        class: "d-faq-page-results-view__heading",
        "base-heading-type": _(ze).StyledAsH2Section
      }, {
        default: Se(() => [
          Ve(Ie(y.value), 1)
        ]),
        _: 1
      }, 8, ["base-heading-type"])) : te("", !0),
      ue(tv, {
        ref_key: "containerButtons",
        ref: a,
        class: "d-faq-page-results-view__buttons",
        "show-buttons": !_(o) && e.model.isSearching && e.model.resultsCount > 0,
        "is-close-all-default": l.value,
        "open-button-text": _(n)("faqPage.expandAll"),
        "close-button-text": _(n)("faqPage.closeAll"),
        onToggleAll: m
      }, null, 8, ["show-buttons", "is-close-all-default", "open-button-text", "close-button-text"]),
      oe("div", {
        ref_key: "containerRef",
        ref: s,
        class: "d-faq-page-results-view__accordion-container",
        role: e.model?.resultsCount ? "listbox" : null
      }, [
        (E(!0), X(Re, null, Ge(e.model.isSearching ? e.model.searchResults : [e.model.categories[e.model.activeCategoryIndex]], (g, v) => (E(), fe(cL, {
          key: g.headline + v,
          model: g,
          "show-buttons": !_(o) && !e.model.isSearching,
          "render-slot-after-topics": v === 0 ? [0] : [],
          "open-button-text": _(n)("faqPage.expandAll"),
          "close-button-text": _(n)("faqPage.closeAll"),
          "highlighted-text": e.model.isSearching ? e.model.searchTerm : "",
          "topic-heading-type": _(ze).H3LooksLikeH2Section,
          "results-count": e.model.resultsCount,
          "initial-index": d.value[v],
          onTabToggled: u
        }, {
          default: Se(() => [
            !_(i) && e.model.contactBox ? (E(), fe(_(Lc), {
              key: 0,
              class: "d-faq-page-results-view__contact-box",
              model: e.model.contactBox
            }, null, 8, ["model"])) : te("", !0)
          ]),
          _: 2
        }, 1032, ["model", "show-buttons", "render-slot-after-topics", "open-button-text", "close-button-text", "highlighted-text", "topic-heading-type", "results-count", "initial-index"]))), 128))
      ], 8, ske)
    ])) : te("", !0);
  }
});
const cke = /* @__PURE__ */ Fe(lke, [["__scopeId", "data-v-cc1b38b8"]]), dke = {
  key: 0,
  class: "d-faq-page"
}, uke = { class: "container" }, hke = { class: "d-faq-page__header" }, pke = { class: "d-faq-page__flex" }, fke = { class: "d-faq-page__main" }, mke = { key: 0 }, gke = {
  key: 0,
  class: "d-faq-page__sidebar"
}, vke = { class: "d-faq-page__sidebar__content" }, yke = /* @__PURE__ */ Be({
  __name: "FaqPage",
  props: {
    model: {
      type: Object,
      required: !0
    }
  },
  emits: ["enterSearch", "onSearch"],
  setup(e, { emit: t }) {
    const n = e, i = ge(0), o = ge(), a = ge(), r = ge(), s = ge(), l = ge(""), d = ge(""), y = ge(!1), u = ge(!1), m = ge(!1), h = ge(), c = ge(), g = ge(0), v = ge([]), P = ge({
      searchResults: [],
      resultsCount: 0
    }), f = ge(0), S = ge(), w = ge("#faq-search"), { t: x } = Je(), { isDesktopAsync: k, isSmallOrEqualLgAsync: A } = xt(), {
      scrollToTwice: $,
      isShrinkSearchExpanded: j,
      headerHeight: N,
      isHeaderExpanded: M,
      calculateOffset: D
    } = Fn(), { pageName: C } = Qe(), b = t, { rootFontSize: p } = Hu(), L = $t("smoothScroll"), B = Te(() => ({
      results: P.value.searchResults.map((Z) => ({
        name: Z.categoryName,
        records: Z.questions.map((ne) => ({
          title: ne.question,
          link: {
            contentUrl: `${Z.categoryId},${ne.topicId},${ne.questionId}`,
            title: ne.question,
            text: ne.question,
            isLocked: !1,
            isExternal: !1,
            linkType: yt.Javascript,
            tealiumTrackingModel: {
              eventSource: C,
              eventComponentName: "BaseSearchBox",
              eventTitle: ne.question
            }
          }
        }))
      })),
      allResultsLink: P.value.resultsCount ? {
        contentUrl: "",
        title: `${x("search.showAllResults")} ${n?.model?.showResultsCount ? `(${P?.value?.resultsCount})` : ""}`,
        text: `${x("search.showAllResults")} ${n?.model?.showResultsCount ? `(${P?.value?.resultsCount})` : ""}`,
        isLocked: !1,
        isExternal: !1,
        linkType: yt.Javascript,
        tealiumTrackingModel: {
          eventSource: C,
          eventComponentName: "BaseSearchBox",
          eventTitle: `${x("search.showAllResults")} ${n?.model?.showResultsCount ? `(${P?.value?.resultsCount})` : ""}`
        }
      } : void 0
    })), T = Te(() => (q) => ({
      contentUrl: "",
      title: q,
      text: q,
      isLocked: !1,
      isExternal: !1,
      linkType: yt.Javascript,
      tealiumTrackingModel: {
        eventSource: C,
        eventComponentName: "BaseSearchBox",
        eventTitle: q
      }
    })), O = (q) => {
      q && S.value?.hideSuggestionPanel();
    }, I = (q) => {
      r.value?.toggleSelection(!1), j() && r.value?.setSuggester(q);
    }, R = async (q) => {
      if (!Ue)
        return;
      S.value?.hideSuggestionPanel();
      const [Z, ne, ie] = q.split(",");
      i.value !== Z && (Y(Z), await mt());
      const ce = s.value?.$el?.querySelector("#container_" + ne)?.querySelector("#item_" + ie)?.closest(
        ".p-accordion-header-action"
      );
      ce?.closest(".p-accordion-tab")?.classList?.contains("p-accordion-tab-active") || ce?.dispatchEvent(new Event("click")), ce?.focus({ preventScroll: !0 }), $(L, ce, -N());
    }, Y = (q, Z = !1) => {
      if (y.value) {
        if (q === V.value.length - 1)
          return;
        l.value = "", h.value && (h.value.value = ""), Q(l.value);
      }
      n.model.categories.forEach(
        (ne) => ne.topics.forEach(
          (ie, re) => ie.items.forEach(
            (de, me) => de.isExpanded = re === 0 && me === 0
          )
        )
      ), i.value = q, V.value?.forEach((ne, ie) => {
        ne.isSelected = ie === q;
      }), g.value++, Z && L({
        scrollTo: 0,
        duration: 1e3,
        updateHistory: !1
      });
    }, F = (q) => Y(parseInt(q.value, 10)), U = (q) => {
      l.value = q;
      const Z = ge([]), ne = ge(0);
      n.model.categories.forEach((ie) => {
        ie.topics.forEach((re) => {
          re.items.forEach((de) => {
            if (de.header.toLowerCase().includes(l.value.toLowerCase()) || de.content.toLowerCase().includes(l.value.toLowerCase())) {
              ne.value++;
              const me = Z.value.find(
                (ce) => ce.categoryName === ie.headline
              );
              me ? me.questions.push({
                topicId: re.id,
                question: de.header,
                questionId: de.id
              }) : Z.value.push({
                categoryName: ie.headline,
                categoryId: ie.id,
                questions: [
                  {
                    topicId: re.id,
                    question: de.header,
                    questionId: de.id
                  }
                ]
              });
            }
          });
        });
      }), P.value.resultsCount = ne.value, P.value.searchResults = Z.value, b("onSearch", l.value);
    }, Q = (q) => {
      d.value = q, y.value = q.length > 0, i.value = y.value ? V.value.length - 1 : 0, f.value = void 0, v.value = [], q && (n.model.categories.forEach((Z) => {
        Z.topics.forEach((ne) => {
          const ie = ne.items.filter(
            (re) => re.header.toLowerCase().includes(q.toLowerCase()) || re.content.toLowerCase().includes(q.toLowerCase())
          );
          if (ie.length > 0) {
            ie[0].isExpanded = !0, f.value || (f.value = 0), f.value += ie.length;
            const re = v.value.findIndex(
              (de) => de.id === Z.id
            );
            re !== -1 ? v.value[re].topics.push({
              ...ne,
              items: ie
            }) : v.value.push({
              id: Z.id,
              headline: Z.headline,
              topics: [{ ...ne, items: ie }]
            });
          }
        });
      }), v.value.forEach(
        (Z) => Z.topics.forEach(
          (ne) => ne.items.forEach((ie) => ie.isExpanded = !1)
        )
      ), v.value.length > 0 && v.value[0].topics.length > 0 && v.value[0].topics[0].items.length > 0 && (v.value[0].topics[0].items[0].isExpanded = !0), g.value++, b("enterSearch", q), j() && L({
        scrollTo: 0,
        duration: 1e3,
        updateHistory: !1
      }));
    }, J = (q) => {
      w.value = q ? "#shrink-search" : "#faq-search", m.value = q;
    };
    async function ee() {
      if (Ue && a.value) {
        let q = D(window.scrollY);
        M() && (q += N());
        const Z = a.value?.$el;
        setTimeout(() => {
          Z.style.top = `${q + p.value * 1.875}px`;
        }, 500);
      }
    }
    const V = Te(() => {
      const q = n.model.categories.map((Z, ne) => ({
        name: Z.headline,
        value: ne.toString(),
        isSelected: ne === i.value && !y.value
      }));
      return y.value && q.push({
        name: x("faqPage.searchResults"),
        value: q.length.toString(),
        isSelected: !0
      }), q;
    }), G = Te(() => ({
      triggerElement: o.value,
      itemHeadline: n.model.ctaHeadline,
      itemList: V.value.map((q) => q.name),
      tealiumTracking: {
        itemListDataEventComponentName: "Faq categories",
        itemListButtonDataEventComponentName: "Category flyout"
      }
    })), W = Te(() => ({
      searchTerm: d.value,
      categories: n.model.categories,
      searchResults: v.value,
      resultsCount: f.value,
      showResultsCount: n.model.showResultsCount,
      contactBox: n.model.contactBox,
      isSearching: y.value,
      activeCategoryIndex: i.value
    })), ae = Te(() => ({
      headline: "",
      placeholder: x("faqPage.searchPlaceholder"),
      filterOptions: [],
      searchTerm: l.value,
      showLabel: !0
    })), z = Te(() => n?.model?.categories?.length > 1);
    return it(() => {
      Ue && (window.addEventListener("scroll", ee, { passive: !0 }), h.value = o.value?.querySelector("input"), c.value = r.value?.$el.querySelector("input"));
    }), sn(() => {
      Ue && window.removeEventListener("scroll", ee);
    }), (q, Z) => e.model ? (E(), X("div", dke, [
      e.model ? (E(), fe(rL, {
        key: 0,
        ref_key: "shrinkSearchRef",
        ref: r,
        "suggester-result": B.value,
        model: G.value,
        class: Pe({ "d-faq-page__shrink-search": u.value }),
        onExpandChanged: J,
        onToggle: O
      }, {
        footer: Se(() => [
          e.model.contactBox && e.model.showCtaInFlyout && !_(k) ? (E(), fe(_(Lc), {
            key: 0,
            class: Pe(["d-faq-page__shrink-search__contact-box", {
              "d-faq-page__shrink-search__contact-box--mobile": _(A)
            }]),
            model: e.model.contactBox
          }, null, 8, ["class", "model"])) : te("", !0)
        ]),
        _: 1
      }, 8, ["suggester-result", "model", "class"])) : te("", !0),
      oe("div", uke, [
        oe("div", hke, [
          e.model.headline ? (E(), fe(Ot, {
            key: 0,
            class: "d-faq-page__main__heading",
            "base-heading-type": _(ze).H1
          }, {
            default: Se(() => [
              Ve(Ie(e.model.headline), 1)
            ]),
            _: 1
          }, 8, ["base-heading-type"])) : te("", !0),
          e.model.introText ? (E(), fe(ht, {
            key: 1,
            "html-text": e.model.introText,
            class: "d-faq-page__main__intro-text"
          }, null, 8, ["html-text"])) : te("", !0)
        ]),
        oe("div", pke, [
          oe("div", fke, [
            oe("div", {
              id: "faq-search",
              ref_key: "searchBoxRef",
              ref: o
            }, [
              ue(_(Yn), { "append-to": w.value }, {
                default: Se(() => [
                  ue(Wo, {
                    ref_key: "searchRef",
                    ref: S,
                    class: Pe({
                      "d-faq-page__main__search-box": !m.value
                    }),
                    model: ae.value,
                    "debounce-interval": 0,
                    result: B.value,
                    "is-suppress-open-new-window-on-enter": !0,
                    onSearch: U,
                    onEnter: Q,
                    onShowSuggestions: I
                  }, {
                    record: Se((ne) => [
                      ue(gi, { term: l.value }, {
                        default: Se(() => [
                          ue(_(ot), {
                            "aria-setsize": ne?.record?.record?.setsize,
                            "aria-posinset": ne?.record?.record?.posinset,
                            role: "option",
                            "link-model": T.value(ne.record.record.record.title),
                            "font-type": _(ya).DwsRegular,
                            onClick: (ie) => R(
                              ne.record.record.record.link.contentUrl
                            ),
                            onKeydown: Ze((ie) => R(
                              ne.record.record.record.link.contentUrl
                            ), ["enter"])
                          }, null, 8, ["aria-setsize", "aria-posinset", "link-model", "font-type", "onClick", "onKeydown"])
                        ]),
                        _: 2
                      }, 1032, ["term"])
                    ]),
                    _: 1
                  }, 8, ["class", "model", "result"])
                ]),
                _: 1
              }, 8, ["append-to"])
            ], 512),
            _(k) ? te("", !0) : (E(), X("div", mke, [
              e.model.headline && z.value ? (E(), fe(Ot, {
                key: 0,
                class: "d-faq-page__sidebar__categories-heading",
                "base-heading-type": _(ze).H3
              }, {
                default: Se(() => [
                  Ve(Ie(e.model.ctaHeadline), 1)
                ]),
                _: 1
              }, 8, ["base-heading-type"])) : te("", !0),
              z.value ? (E(), fe(_(vi), {
                key: 1,
                class: "d-faq-page__main__dropdown",
                items: V.value,
                selected: V.value[i.value],
                "data-event_source": _(C),
                "event-title": V.value[i.value].name,
                "event-component-name": "Category dropdown",
                onSelectedItemChanged: F
              }, null, 8, ["items", "selected", "data-event_source", "event-title"])) : te("", !0)
            ])),
            (E(), fe(cke, {
              ref_key: "resultsViewRef",
              ref: s,
              key: g.value,
              model: W.value
            }, null, 8, ["model"]))
          ]),
          _(k) ? (E(), X("div", gke, [
            Z[0] || (Z[0] = oe("div", { class: "d-faq-page__sidebar__gap" }, null, -1)),
            oe("div", vke, [
              e.model.headline && z.value ? (E(), fe(Ot, {
                key: 0,
                class: "d-faq-page__sidebar__categories-heading",
                "base-heading-type": _(ze).H3
              }, {
                default: Se(() => [
                  Ve(Ie(e.model.ctaHeadline), 1)
                ]),
                _: 1
              }, 8, ["base-heading-type"])) : te("", !0),
              z.value ? (E(), fe(iS, {
                key: g.value,
                class: "d-faq-page__sidebar__table-of-contents",
                "item-list": V.value.map((ne) => ne.name),
                "initial-item-selected": i.value,
                "data-event-source": _(C),
                "data-event-component": "Faq categories",
                onClick: Y
              }, null, 8, ["item-list", "initial-item-selected", "data-event-source"])) : te("", !0),
              e.model.contactBox ? (E(), fe(_(Lc), {
                key: 2,
                ref_key: "contactBoxRef",
                ref: a,
                model: e.model.contactBox
              }, null, 8, ["model"])) : te("", !0)
            ])
          ])) : te("", !0)
        ])
      ])
    ])) : te("", !0);
  }
});
const oEe = /* @__PURE__ */ Fe(yke, [["__scopeId", "data-v-6f3371d2"]]), bke = { class: "d-glossary-letter-block" }, xke = /* @__PURE__ */ Be({
  __name: "GlossaryLetterBlock",
  props: {
    enabledLetters: {
      type: Array,
      default: () => []
    },
    selectedLetter: {
      type: String,
      default: ""
    }
  },
  emits: ["click"],
  setup(e, { emit: t }) {
    const n = t, i = [
      "A",
      "B",
      "C",
      "D",
      "E",
      "F",
      "G",
      "H",
      "I",
      "J",
      "K",
      "L",
      "M",
      "N",
      "O",
      "P",
      "Q",
      "R",
      "S",
      "T",
      "U",
      "V",
      "W",
      "X",
      "Y",
      "Z",
      "0-9"
    ], o = (r) => {
      n("click", r);
    }, a = (r) => ({
      title: r,
      text: r,
      target: "_self",
      isLocked: !1,
      isExternal: !1,
      linkType: yt.Javascript,
      tealiumTrackingModel: {
        eventSource: Qe().pageName,
        eventComponentName: "Glossary",
        eventTitle: r
      }
    });
    return (r, s) => (E(), X("div", bke, [
      (E(), X(Re, null, Ge(i, (l, d) => ue(ot, {
        key: d,
        class: Pe(["d-glossary-letter-block__link", {
          "d-glossary-letter-block__link--disabled": !e.enabledLetters.includes(l),
          "d-glossary-letter-block__link--selected": e.selectedLetter === l
        }]),
        "font-size": _(yn).TwentyFourPx,
        disabled: !e.enabledLetters.includes(l),
        "aria-disabled": !e.enabledLetters.includes(l),
        "link-model": a(l),
        onClick: (y) => o(l),
        onKeyup: Ze((y) => o(l), ["enter"])
      }, null, 8, ["font-size", "class", "disabled", "aria-disabled", "link-model", "onClick", "onKeyup"])), 64))
    ]));
  }
});
const Pp = /* @__PURE__ */ Fe(xke, [["__scopeId", "data-v-12ebdc25"]]), wke = { class: "d-glossary" }, kke = { class: "d-glossary__header" }, Ske = { class: "d-glossary__content-area" }, Cke = { class: "d-glossary__content-area--search-accordion" }, Tke = { class: "d-glossary__search-area" }, Lke = /* @__PURE__ */ Be({
  __name: "Glossary",
  props: {
    model: {
      type: Object,
      required: !0
    }
  },
  emits: [
    "enterSearch",
    "onSearch",
    "selectionClick",
    "expandChanged",
    "showSuggestions",
    "clear"
  ],
  setup(e, { emit: t }) {
    const n = e, { t: i } = Je(), { isSmallOrEqualMdAsync: o, isDesktopAsync: a } = xt(), r = t, s = ge(), l = ge(), d = ge(), y = ge(), u = ge(""), m = ge(), h = ge(), c = ge(""), g = ge(!1), v = ge(!1), P = ge(!1), f = ge(), S = ge(), w = ge(), x = ge(""), k = ge(), A = ge({
      searchResults: [],
      resultsCount: 0
    }), $ = ge(0), j = ge(0), { scrollToTwice: N, isShrinkSearchExpanded: M, headerHeight: D } = Fn(), { pageName: C } = Qe(), b = ge(), p = ge("#glossary-search"), L = $t("smoothScroll"), B = Te(() => (ae) => ({
      contentUrl: "",
      title: ae,
      text: ae,
      isLocked: !1,
      isExternal: !1,
      linkType: yt.Javascript,
      tealiumTrackingModel: {
        eventSource: C,
        eventComponentName: "BaseSearchBox",
        eventTitle: ae
      }
    })), T = Te(() => ({
      results: A.value.searchResults.map((z) => ({
        name: z.letter,
        records: z.headlines.map((q) => ({
          title: q.headline,
          link: {
            contentUrl: `${z.letter},${q.headlineId}`,
            title: q.headline,
            text: q.headline,
            isLocked: !1,
            isExternal: !1,
            linkType: yt.Javascript,
            tealiumTrackingModel: {
              eventSource: C,
              eventComponentName: "BaseSearchBox",
              eventTitle: q.headline
            }
          }
        }))
      })),
      allResultsLink: A.value.resultsCount ? {
        contentUrl: "",
        title: `${i("search.showAllResults")} (${A?.value?.resultsCount})`,
        text: `${i("search.showAllResults")} (${A?.value?.resultsCount})`,
        isLocked: !1,
        isExternal: !1,
        linkType: yt.Javascript,
        tealiumTrackingModel: {
          eventSource: C,
          eventComponentName: "BaseSearchBox",
          eventTitle: `${i("search.showAllResults")} (${A?.value?.resultsCount})`
        }
      } : void 0
    })), O = (ae) => {
      h.value?.toggleSelection(!1), M() && h.value?.setSuggester(ae);
    }, I = async (ae) => {
      if (!Ue)
        return;
      b.value?.hideSuggestionPanel();
      const [z, q] = ae.split(","), Z = Number(q);
      v.value = !1, j.value++, await mt();
      const ne = n?.model?.itemList?.topics?.find(
        (xe) => xe.headline === z
      )?.id, me = w.value?.$el?.querySelector("#container_" + ne)?.querySelector("#item_" + Z)?.closest(".p-accordion-header-action");
      me?.closest(".p-accordion-tab")?.classList?.contains("p-accordion-tab-active") || me?.dispatchEvent(new Event("click")), me?.focus({ preventScroll: !0 }), N(L, me, -D());
    }, R = async (ae) => {
      if (!Ue)
        return;
      v.value = !1, u.value = "", c.value = "", x.value = ae, j.value++;
      const z = n?.model?.itemList?.topics?.find(
        (me) => me.headline === ae
      )?.id;
      h.value.toggleSelection(!1), await mt();
      const ie = d.value?.querySelector("#container_" + z)?.querySelector("#item_0")?.closest(
        ".p-accordion-header-action"
      );
      ie?.closest(".p-accordion-tab")?.classList?.contains("p-accordion-tab-active") || ie?.dispatchEvent(new Event("click")), N(L, ie, -80);
    }, Y = (ae) => {
      u.value = ae;
      const z = ge([]), q = ge(0), Z = ge(0);
      n.model.itemList.topics.forEach((ne) => {
        const ie = ne.items.filter((re) => re.header.toLowerCase().includes(u.value.toLowerCase()) || re.content.toLowerCase().includes(u.value.toLowerCase()));
        if (ie.length > 0) {
          const re = ie.map((de) => ({
            headlineId: de.id,
            headline: de.header
          }));
          z.value.push({
            letter: ne.headline,
            letterId: ne.id,
            headlines: re
          }), Z.value += re.length, q.value += ie.length;
        }
      }), A.value.searchResults = z.value, A.value.resultsCount = q.value, r("onSearch", u.value);
    }, F = (ae) => {
      u.value = ae, v.value = ae.length > 0, x.value = "", c.value = u.value, j.value++, u.value && (k.value = { id: 1, topics: [] }, k.value.topics = n.model.itemList.topics.filter((z) => z.items.filter((Z) => Z.header.toLowerCase().includes(u.value.toLowerCase()) || Z.content.toLowerCase().includes(u.value.toLowerCase())).length > 0).map((z) => ({
        id: z.id,
        headline: z.headline,
        items: z.items.filter((q) => q.header.toLowerCase().includes(u.value.toLowerCase()) || q.content.toLowerCase().includes(u.value.toLowerCase())).map((q) => ({
          id: q.id,
          header: q.header,
          content: q.content,
          isExpanded: !1
        }))
      })), $.value = k.value.topics.reduce(
        (z, q) => z + q.items.length,
        0
      ), k.value.topics.length > 0 && k.value.topics[0].items.length > 0 && (k.value.topics[0].items[0].isExpanded = !0), M() && (L({
        scrollTo: 0,
        duration: 1e3,
        updateHistory: !1
      }), r("enterSearch", u.value)));
    }, U = (ae) => {
      p.value = ae ? "#shrink-search" : "#glossary-search", P.value = ae;
    }, Q = () => {
      if (!Ue || (l.value = w.value.$el.querySelectorAll(".p-accordion-tab"), !l.value || !l.value.length))
        return;
      new MutationObserver(() => {
        fi(() => {
          y.value = Array.from(l.value).every(
            (z) => z.classList.contains("p-accordion-tab-active")
          ), s.value?.tabToggled(y.value);
        }, 0);
      }).observe(w.value.$el, { subtree: !0, childList: !0 });
    }, J = Te(() => ({
      triggerElement: m.value,
      itemList: n.model.itemList.topics.map((ae) => ae.headline),
      itemHeadline: i("glossary.chooseOption")
    })), ee = Te(() => {
      const ae = n.model.itemList.topics, z = [];
      return ae.forEach((q) => {
        q.items.length !== 0 && z.push(q.headline);
      }), z;
    }), V = Te(() => ({
      headline: "",
      placeholder: i("glossary.searchPlaceholder"),
      filterOptions: [],
      searchTerm: u.value,
      showLabel: !0
    })), G = () => {
      u.value = "", v.value = !1, x.value = "", c.value = "", A.value.searchResults = [], A.value.resultsCount = 0, j.value++;
    }, W = (ae) => {
      ae && b.value?.hideSuggestionPanel();
    };
    return it(() => {
      Ue && (f.value = m.value?.querySelector("input"), S.value = h.value?.$el.querySelector("input"));
    }), (ae, z) => (E(), X("div", wke, [
      e.model ? (E(), fe(rL, {
        key: 0,
        ref_key: "shrinkSearchRef",
        ref: h,
        "suggester-result": T.value,
        "custom-button": !0,
        "custom-item-list": !0,
        model: J.value,
        "enabled-letters": ee.value,
        "heading-type": _(ze).H4,
        class: Pe({ "d-glossary__shrink-search": g.value }),
        onExpandChanged: U,
        onToggle: W
      }, {
        letterBlock: Se(() => [
          ue(Pp, {
            class: "d-glossary__letter-block__shrink-search",
            "enabled-letters": ee.value,
            "selected-letter": x.value,
            onClick: R
          }, null, 8, ["enabled-letters", "selected-letter"])
        ]),
        _: 1
      }, 8, ["suggester-result", "model", "enabled-letters", "heading-type", "class"])) : te("", !0),
      ue(Vt, {
        id: "glossary",
        class: "d-glossary__page-section",
        "no-margin-bottom": !0,
        "no-margin": !0
      }, {
        default: Se(() => [
          oe("div", kke, [
            e.model.headline ? (E(), fe(Ot, {
              key: 0,
              class: "d-glossary__headline",
              "base-heading-type": _(ze).H1
            }, {
              default: Se(() => [
                Ve(Ie(e.model.headline), 1)
              ]),
              _: 1
            }, 8, ["base-heading-type"])) : te("", !0),
            e.model.introText ? (E(), fe(ht, {
              key: 1,
              "html-text": e.model.introText,
              class: "d-glossary__intro-text"
            }, null, 8, ["html-text"])) : te("", !0)
          ]),
          oe("div", Ske, [
            oe("div", Cke, [
              oe("div", Tke, [
                oe("div", {
                  id: "glossary-search",
                  ref_key: "searchBoxRef",
                  ref: m,
                  class: "d-glossary__search"
                }, [
                  ue(_(Yn), { "append-to": p.value }, {
                    default: Se(() => [
                      ue(Wo, {
                        ref_key: "searchRef",
                        ref: b,
                        model: V.value,
                        "debounce-interval": 0,
                        result: T.value,
                        onSearch: Y,
                        onEnter: F,
                        onClear: G,
                        onShowSuggestions: O
                      }, {
                        record: Se((q) => [
                          ue(gi, { term: u.value }, {
                            default: Se(() => [
                              ue(_(ot), {
                                "aria-setsize": q?.record?.record?.setsize,
                                "aria-posinset": q?.record?.record?.posinset,
                                role: "option",
                                "link-model": B.value(q.record.record.record.title),
                                "font-type": _(ya).DwsRegular,
                                onClick: (Z) => I(
                                  q.record.record.record.link.contentUrl
                                ),
                                onKeydown: Ze((Z) => I(
                                  q.record.record.record.link.contentUrl
                                ), ["enter"])
                              }, null, 8, ["aria-setsize", "aria-posinset", "link-model", "font-type", "onClick", "onKeydown"])
                            ]),
                            _: 2
                          }, 1032, ["term"])
                        ]),
                        _: 1
                      }, 8, ["model", "result"])
                    ]),
                    _: 1
                  }, 8, ["append-to"])
                ], 512),
                _(a) ? te("", !0) : (E(), fe(Pp, {
                  key: 0,
                  class: "d-glossary__search-area__letter-block",
                  "enabled-letters": ee.value,
                  "selected-letter": x.value,
                  onClick: R
                }, null, 8, ["enabled-letters", "selected-letter"]))
              ]),
              v.value && $.value === 0 ? (E(), fe(Ot, {
                key: 0,
                class: "d-faq-page-results-view__heading",
                "base-heading-type": _(ze).StyledAsH2Section
              }, {
                default: Se(() => [
                  Ve(Ie(`${_(i)("glossary.noResults")} ${c.value}.`), 1)
                ]),
                _: 1
              }, 8, ["base-heading-type"])) : te("", !0),
              oe("div", {
                ref_key: "containerRef",
                ref: d,
                class: "d-glossary__item-list"
              }, [
                (E(), fe(cL, {
                  key: j.value,
                  ref_key: "itemListRef",
                  ref: w,
                  class: "d-glossary__item-list--accordion",
                  model: v.value ? k.value : e.model.itemList,
                  "show-buttons": !_(o) && (!v.value || $.value > 0),
                  "open-button-text": _(i)("glossary.expandAll"),
                  "close-button-text": _(i)("glossary.closeAll"),
                  "highlighted-text": c.value,
                  "event-component-name": "Glossary",
                  onTabToggled: Q
                }, null, 8, ["model", "show-buttons", "open-button-text", "close-button-text", "highlighted-text"]))
              ], 512)
            ]),
            _(a) ? (E(), fe(Pp, {
              key: 0,
              "enabled-letters": ee.value,
              "selected-letter": x.value,
              onClick: R
            }, null, 8, ["enabled-letters", "selected-letter"])) : te("", !0)
          ])
        ]),
        _: 1
      })
    ]));
  }
});
const rEe = /* @__PURE__ */ Fe(Lke, [["__scopeId", "data-v-4c40ef3a"]]), Ike = {
  key: 0,
  class: "d-property-key-values"
}, Pke = { key: 0 }, Ake = { key: 1 }, _ke = { key: 2 }, Mke = { key: 3 }, Oke = { key: 4 }, Bke = { key: 5 }, Eke = { key: 6 }, Dke = {
  key: 7,
  class: "d-property-key-values__location"
}, Rke = /* @__PURE__ */ Be({
  __name: "PropertyKeyValues",
  props: {
    type: {
      type: String,
      default: ""
    },
    purchasePrice: {
      type: String,
      default: ""
    },
    acquisitionYear: {
      type: String,
      default: ""
    },
    location: {
      type: String,
      default: ""
    }
  },
  setup(e) {
    const { t } = Je();
    return (n, i) => {
      const o = $e("BaseIcon");
      return e.type || e.purchasePrice || e.acquisitionYear || e.location ? (E(), X("dl", Ike, [
        e.type ? (E(), X("dt", Pke, [
          oe("b", null, Ie(_(t)("propertyKeyValues.type")) + ":", 1)
        ])) : te("", !0),
        e.type ? (E(), X("dd", Ake, Ie(e.type), 1)) : te("", !0),
        e.purchasePrice ? (E(), X("dt", _ke, [
          oe("b", null, Ie(_(t)("propertyKeyValues.purchasePrice")) + ":", 1)
        ])) : te("", !0),
        e.purchasePrice ? (E(), X("dd", Mke, Ie(e.purchasePrice), 1)) : te("", !0),
        e.acquisitionYear ? (E(), X("dt", Oke, [
          oe("b", null, Ie(_(t)("propertyKeyValues.acquisitionYear")) + ":", 1)
        ])) : te("", !0),
        e.acquisitionYear ? (E(), X("dd", Bke, Ie(e.acquisitionYear), 1)) : te("", !0),
        e.location ? (E(), X("dt", Eke, [
          oe("b", null, Ie(_(t)("propertyKeyValues.location")) + ":", 1)
        ])) : te("", !0),
        e.location ? (E(), X("dd", Dke, [
          oe("p", null, [
            Ve(Ie(e.location) + " ", 1),
            ue(o, {
              "base-icon": _(H).MapMarker,
              "base-icon-size": _(at).Inherit,
              "base-icon-color": _(gt).GreyBlue008,
              "aria-label": _(t)("propertyKeyValues.location")
            }, null, 8, ["base-icon", "base-icon-size", "base-icon-color", "aria-label"])
          ])
        ])) : te("", !0)
      ])) : te("", !0);
    };
  }
});
const Nke = /* @__PURE__ */ Fe(Rke, [["__scopeId", "data-v-7adf9317"]]), $ke = {
  key: 1,
  class: "d-property-detail-header__content__market-value"
}, Fke = { class: "d-property-detail-header__content__market-value--value" }, jke = /* @__PURE__ */ Be({
  __name: "PropertyDetailHeader",
  props: {
    model: {
      type: Object,
      required: !0
    }
  },
  setup(e) {
    const { containerQueriesEnabled: t } = Bi(), { t: n } = Je(), { pageName: i } = Qe(), o = ge(""), a = ge(!1), r = e;
    function s() {
      a.value = !0;
    }
    function l() {
      a.value = !1;
    }
    const d = Te(() => r?.model?.trackingModel ? r.model.trackingModel : {
      eventSource: i,
      eventComponentName: i,
      eventTitle: "Gallery | " + r.model.name,
      eventTarget: o.value
    }), y = () => n("propertyTeaser.gallery") + " (" + r.model.imageGallery?.images.length + " " + n("propertyTeaser.images") + ") ", u = Te(() => t.value ? "d-property-detail-header--container" : "d-property-detail-header--media");
    return it(() => {
      Ue && (o.value = window.location.href);
    }), (m, h) => {
      const c = $e("BaseHeading"), g = $e("BaseText");
      return e.model ? (E(), X("div", {
        key: 0,
        class: Pe(["d-property-detail-header", [u.value]])
      }, [
        ue(Fg, {
          image: e.model.mainImage,
          "branded-image-variant": _(br).VariantA
        }, {
          content: Se(() => [
            e.model.name ? (E(), fe(c, {
              key: 0,
              class: "d-property-detail-header__content__heading",
              "base-heading-type": _(ze).H1
            }, {
              default: Se(() => [
                Ve(Ie(e.model.name), 1)
              ]),
              _: 1
            }, 8, ["base-heading-type"])) : te("", !0),
            e.model.marketValue ? (E(), X("div", $ke, [
              oe("p", Fke, [
                Ve(Ie(e.model.marketValue) + " ", 1),
                e.model.marketValueFootnote ? (E(), fe(ma, {
                  key: 0,
                  title: e.model.marketValueFootnote,
                  "component-id": e.model.footnoteComponentId
                }, null, 8, ["title", "component-id"])) : te("", !0)
              ])
            ])) : te("", !0),
            e.model.descriptionText ? (E(), fe(g, {
              key: 2,
              class: "d-property-detail-header__content__description",
              text: e.model.descriptionText,
              "max-length": 250
            }, null, 8, ["text"])) : te("", !0),
            ue(vt, {
              class: "d-property-detail-header__content__button",
              "link-model": {
                title: y(),
                contentUrl: "",
                isLocked: !1,
                isExternal: !1,
                linkType: _(yt).Javascript,
                text: y(),
                tealiumTrackingModel: d.value
              },
              type: _(Ke).Secondary,
              size: _(et).Large,
              "button-type": _(zt).Button,
              icon: _(H).Images,
              "icon-position": _(ct).Left,
              onClick: s
            }, null, 8, ["link-model", "type", "size", "button-type", "icon", "icon-position"])
          ]),
          _: 1
        }, 8, ["image", "branded-image-variant"]),
        e.model.imageGallery ? (E(), fe(Qg, {
          key: 0,
          model: e.model.imageGallery,
          "open-dialog": a.value,
          onClose: l
        }, null, 8, ["model", "open-dialog"])) : te("", !0)
      ], 2)) : te("", !0);
    };
  }
});
const Hke = /* @__PURE__ */ Fe(jke, [["__scopeId", "data-v-34575a8d"]]), zke = { class: "d-featured-property-teaser__wrapper__teaser" }, Vke = {
  key: 0,
  class: "d-featured-property-teaser__wrapper__triangle"
}, Gke = /* @__PURE__ */ Be({
  __name: "FeaturedPropertyTeaser",
  props: {
    model: {
      type: Object,
      required: !0
    },
    backgroundOn: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const { containerQueriesEnabled: t } = Bi(), { t: n } = Je(), { pageName: i } = Qe(), o = window.location.href, a = ge(!1), r = e;
    function s() {
      a.value = !0;
    }
    function l() {
      a.value = !1;
    }
    const d = Te(() => r.model.imageGallery?.images.length > 1 ? H.Images : H.Expand), y = Te(() => t.value ? "d-featured-property-teaser--container" : "d-featured-property-teaser--media");
    return (u, m) => {
      const h = $e("BaseText");
      return e.model ? (E(), X("div", {
        key: 0,
        class: Pe(["d-featured-property-teaser", [y.value]])
      }, [
        oe("div", {
          class: Pe(["d-featured-property-teaser__wrapper", e.backgroundOn ? "withBackground" : ""])
        }, [
          oe("div", zke, [
            ue(Fg, {
              image: e.model.mainImage ? e.model.mainImage : e.model.imageGallery?.images.at(0).image,
              "background-color": e.backgroundOn ? _(Eo).GreyBlue000 : _(Eo).White
            }, {
              imageButton: Se(() => [
                ue(Nt, {
                  "link-model": {
                    title: _(n)("propertyTeaser.gallery"),
                    contentUrl: "",
                    isLocked: !1,
                    isExternal: !1,
                    linkType: _(yt).Javascript,
                    tealiumTrackingModel: {
                      eventSource: _(i),
                      eventComponentName: "Featured Property Teaser",
                      eventTitle: "Image Gallery | " + e.model.nameOfProperty
                    }
                  },
                  type: _(Ke).RoundedPrimary,
                  size: _(et).Large,
                  "button-type": _(zt).Button,
                  icon: d.value,
                  "icon-position": _(ct).Left,
                  onClick: s
                }, null, 8, ["link-model", "type", "size", "button-type", "icon", "icon-position"])
              ]),
              content: Se(() => [
                e.model.headline ? (E(), fe(Ot, {
                  key: 0,
                  class: "d-featured-property-teaser__wrapper__content__heading",
                  "base-heading-type": _(ze).StyledAsH3
                }, {
                  default: Se(() => [
                    Ve(Ie(e.model.headline), 1)
                  ]),
                  _: 1
                }, 8, ["base-heading-type"])) : te("", !0),
                e.model.nameOfProperty ? (E(), fe(Ot, {
                  key: 1,
                  class: "d-featured-property-teaser__wrapper__content__name-of-property",
                  "base-heading-type": _(ze).H2
                }, {
                  default: Se(() => [
                    Ve(Ie(e.model.nameOfProperty), 1)
                  ]),
                  _: 1
                }, 8, ["base-heading-type"])) : te("", !0),
                e.model.description ? (E(), fe(h, {
                  key: 2,
                  class: "d-featured-property-teaser__wrapper__content__description",
                  text: e.model.description,
                  "max-length": 250
                }, null, 8, ["text"])) : te("", !0),
                ue(Nke, {
                  class: "d-featured-property-teaser__wrapper__content__key-values",
                  type: e.model.keyValues.type,
                  "purchase-price": e.model.keyValues.purchasePrice,
                  "acquisition-year": e.model.keyValues.acquisitionYear,
                  location: e.model.keyValues.location
                }, null, 8, ["type", "purchase-price", "acquisition-year", "location"]),
                ue(vt, {
                  class: "d-featured-property-teaser__wrapper__content__button",
                  "link-model": {
                    ...e.model.ctaModel,
                    tealiumTrackingModel: {
                      eventSource: _(i),
                      eventComponentName: "Featured Property Teaser",
                      eventTitle: "Show property details  | " + e.model.nameOfProperty,
                      eventTarget: _(o)
                    }
                  },
                  "button-type": _(zt).Link
                }, null, 8, ["link-model", "button-type"])
              ]),
              _: 1
            }, 8, ["image", "background-color"])
          ]),
          e.backgroundOn ? (E(), X("div", Vke)) : te("", !0),
          e.model.imageGallery ? (E(), fe(Qg, {
            key: 1,
            model: e.model.imageGallery,
            "open-dialog": a.value,
            onClose: l
          }, null, 8, ["model", "open-dialog"])) : te("", !0)
        ], 2)
      ], 2)) : te("", !0);
    };
  }
});
const sEe = /* @__PURE__ */ Fe(Gke, [["__scopeId", "data-v-9372814d"]]);
var Io = /* @__PURE__ */ ((e) => (e.VariantA = "variant-a", e.VariantB = "variant-b", e))(Io || {});
const Uke = /* @__PURE__ */ Be({
  __name: "SingleVideoModule",
  props: {
    videoItemHero: {
      type: Object,
      required: !0
    },
    variant: {
      type: String,
      default: Io.VariantA
    },
    backgroundColor: {
      type: String,
      default: Zt.Transparent
    }
  },
  setup(e) {
    const t = e, { isMobile: n, isGreaterOrEqualLgAsync: i } = xt(), { containerQueriesEnabled: o } = Bi(), a = ge(), r = ge(), s = Te(() => (a.value = Gu(r.value), o.value ? a.value?.xlarge : !i.value)), l = () => {
      switch (t.variant) {
        case Io.VariantA:
          return At(co, {
            teaserBox: {
              ...t.videoItemHero,
              color: t.backgroundColor,
              text: d.value,
              alwaysShowButton: !0
            },
            layout: Rt.OneThird,
            showDate: !0,
            showTags: !0,
            pictureRoundedCorner: !0,
            ctaElementType: cn.Link,
            fontSize: st.SixteenPx,
            clippingText: !1,
            headingType: n.value ? ze.StyledAsH3 : ze.StyledAsH2Section
          });
        case Io.VariantB:
          return At(co, {
            teaserBox: {
              ...t.videoItemHero,
              color: t.backgroundColor,
              text: d.value,
              alwaysShowButton: !0
            },
            layout: Rt.Full,
            showDate: !0,
            showTags: !0,
            pictureRoundedCorner: !0,
            ctaElementType: cn.Link,
            fontSize: st.SixteenPx,
            fullLayout: $a.ThreeToOne,
            clippingText: !0,
            headingType: ze.StyledAsH3,
            characterLimitDescription: 250,
            direction: s.value ? Ti.Column : Ti.Row
          });
      }
    }, d = Te(() => t.videoItemHero.text ? t.variant === Io.VariantB ? Ml({
      text: t.videoItemHero.text,
      maxCharacters: 250
    }) : t.videoItemHero.text : "");
    return (y, u) => e.videoItemHero ? (E(), X("div", {
      key: 0,
      ref_key: "containerElement",
      ref: r,
      class: Pe(["d-single-video-module", {
        "d-single-video-module--variant-a": e.variant === _(Io).VariantA,
        "d-single-video-module--variant-b": e.variant === _(Io).VariantB,
        "d-single-video-module--variant-b--background-color-white": e.backgroundColor === _(Zt).Transparent,
        "d-single-video-module--variant-b--background-color-grey": e.backgroundColor === _(Zt).Grey
      }])
    }, [
      (E(), fe(tt(l)))
    ], 2)) : te("", !0);
  }
});
const dL = /* @__PURE__ */ Fe(Uke, [["__scopeId", "data-v-d3811c87"]]);
var Wke = /* @__PURE__ */ ((e) => (e.Grey = "grey", e.White = "white", e))(Wke || {}), uL = /* @__PURE__ */ ((e) => (e.OceanBlue = "ocean-blue", e.SustainedGreen = "sustained-green", e.ProgPurple = "prog-purple", e.Amber = "amber", e.Pink = "pink", e.GreyBlue006 = "grey-blue-006", e.GreyBlue009 = "grey-blue-009", e.PrimaryColor = "petrol-45", e))(uL || {});
const Yke = {
  key: 3,
  class: "d-key-facts-item__after-fact-text"
}, qke = {
  key: 4,
  class: "d-key-facts-item__before-after-text"
}, Kke = { class: "d-key-facts-item__after-fact-text" }, Xke = /* @__PURE__ */ Be({
  __name: "KeyFactsItem",
  props: {
    model: {
      type: Object,
      required: !0
    },
    color: {
      type: String,
      default: uL.GreyBlue009
    },
    footnoteId: {
      type: String,
      default: void 0
    },
    footnotes: {
      type: Object,
      default: void 0
    }
  },
  setup(e) {
    const t = e, n = Te(() => `d-key-facts-item--${t.color}`), i = Te(() => `${n.value} ${t?.model?.beforeFactText ? "" : "d-key-facts-item__fact-text--headline"}`), o = Te(() => {
      if (t.model?.afterFactText != "") {
        const r = /\{\{(\d+)\}\}/, s = t.model.afterFactText.match(r);
        if (s)
          return parseInt(s[1], 10);
      }
    }), a = Te(() => {
      if (t.model?.afterFactText != "") {
        const r = /\{\{(\d+)\}\}/;
        if (t.model.afterFactText.match(r))
          return t.model.afterFactText.replace(r, "");
      }
      return t.model?.afterFactText;
    });
    return (r, s) => {
      const l = $e("BaseIcon"), d = $e("BaseText");
      return E(), X("div", {
        class: Pe(["d-key-facts-item", n.value])
      }, [
        e.model?.icon ? (E(), fe(l, {
          key: 0,
          "base-icon": e.model?.icon,
          "base-icon-color": _(gt).Inherit,
          "base-icon-size": _(at).Inherit,
          class: "d-key-facts-item__icon"
        }, null, 8, ["base-icon", "base-icon-color", "base-icon-size"])) : te("", !0),
        e.model?.beforeFactText ? (E(), fe(d, {
          key: 1,
          text: `<h3>${e.model?.beforeFactText}</h3>`,
          class: "d-key-facts-item__before-fact-text d-key-facts-item__before-after-text"
        }, null, 8, ["text"])) : te("", !0),
        e.model?.factText ? (E(), fe(d, {
          key: 2,
          text: e.model?.beforeFactText ? e.model?.factText : `<h3 class='${n.value}'>${e.model?.factText}</h3>`,
          class: Pe(["d-key-facts-item__fact-text", i.value])
        }, null, 8, ["text", "class"])) : te("", !0),
        e.model?.afterFactText && (e.model?.beforeFactText || e.model?.factText) ? (E(), X("p", Yke, [
          Ve(Ie(a.value) + " ", 1),
          o.value && _(Ue) ? (E(), fe(ma, {
            key: 0,
            title: e.footnotes.find((y) => y.index === o.value)?.value,
            "special-link": "",
            "component-id": e.footnoteId
          }, null, 8, ["title", "component-id"])) : te("", !0)
        ])) : te("", !0),
        e.model?.afterFactText && !e.model?.beforeFactText && !e.model?.factText ? (E(), X("span", qke, [
          oe("h3", Kke, [
            Ve(Ie(a.value) + " ", 1),
            o.value && _(Ue) ? (E(), fe(ma, {
              key: 0,
              title: e.footnotes.find((y) => y.index === o.value)?.value,
              "special-link": "",
              "component-id": e.footnoteId
            }, null, 8, ["title", "component-id"])) : te("", !0)
          ])
        ])) : te("", !0)
      ], 2);
    };
  }
});
const Zke = /* @__PURE__ */ Fe(Xke, [["__scopeId", "data-v-1f5233db"]]), Jke = { class: "d-key-facts__header" }, Qke = /* @__PURE__ */ Be({
  __name: "KeyFacts",
  props: {
    model: {
      type: Object,
      required: !0
    }
  },
  setup(e) {
    const t = e, n = Te(() => `d-key-facts--${t.model.backgroundColor}`);
    return (i, o) => {
      const a = $e("BaseHeading"), r = $e("BaseText");
      return E(), X("div", {
        class: Pe(["d-key-facts", n.value])
      }, [
        oe("div", Jke, [
          e.model?.headline ? (E(), fe(a, {
            key: 0,
            "base-heading-type": _(ze).H2,
            class: "d-key-facts__heading"
          }, {
            default: Se(() => [
              Ve(Ie(e.model.headline), 1)
            ]),
            _: 1
          }, 8, ["base-heading-type"])) : te("", !0),
          e.model?.introText ? (E(), fe(r, {
            key: 1,
            text: e.model?.introText,
            class: "d-key-facts__text"
          }, null, 8, ["text"])) : te("", !0)
        ]),
        e.model?.items && e.model?.items.length > 0 ? (E(), X("div", {
          key: 0,
          class: Pe(["d-key-facts__items", {
            "d-key-facts__items-wrap-4": e.model.items.length === 4,
            "d-key-facts__items-wrap-5": e.model.items.length === 5,
            "d-key-facts__items-wrap-6": e.model.items.length === 6
          }])
        }, [
          (E(!0), X(Re, null, Ge(e.model.items, (s, l) => (E(), fe(Zke, {
            key: l,
            model: s,
            color: e.model.itemColor,
            "footnote-id": e.model.footnoteComponentId,
            footnotes: e.model.footnotes
          }, null, 8, ["model", "color", "footnote-id", "footnotes"]))), 128))
        ], 2)) : te("", !0),
        ue(ro, {
          class: "d-key-facts__footnotes container",
          "component-id": e.model.footnoteComponentId,
          "footnote-type": e.model.footnoteType
        }, null, 8, ["component-id", "footnote-type"])
      ], 2);
    };
  }
});
const eSe = /* @__PURE__ */ Fe(Qke, [["__scopeId", "data-v-b0c7f461"]]);
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode(".mapdiv[data-v-d05fc6bc]{width:100%;height:100%}.custom-control-wrapper[data-v-d099a3a6]{display:none}.mapdiv .custom-control-wrapper[data-v-d099a3a6]{display:inline-block}.info-window-wrapper[data-v-cbe1707b]{display:none}.mapdiv .info-window-wrapper[data-v-cbe1707b]{display:inline-block}.custom-marker-wrapper[data-v-2d2d343a]{display:none}.mapdiv .custom-marker-wrapper[data-v-2d2d343a]{display:inline-block}")), document.head.appendChild(e);
    }
  } catch (t) {
    console.error("vite-plugin-css-injected-by-js", t);
  }
})();
var tSe = Object.defineProperty, nSe = (e, t, n) => t in e ? tSe(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, R1 = (e, t, n) => (nSe(e, typeof t != "symbol" ? t + "" : t, n), n);
const Dr = Symbol("map"), Rr = Symbol("api"), iv = Symbol("marker"), av = Symbol("markerCluster"), jh = Symbol("CustomMarker"), hL = Symbol("mapTilesLoaded"), xs = [
  "click",
  "dblclick",
  "drag",
  "dragend",
  "dragstart",
  "mousedown",
  "mousemove",
  "mouseout",
  "mouseover",
  "mouseup",
  "rightclick"
];
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
function iSe(e, t, n, i) {
  function o(a) {
    return a instanceof n ? a : new n(function(r) {
      r(a);
    });
  }
  return new (n || (n = Promise))(function(a, r) {
    function s(y) {
      try {
        d(i.next(y));
      } catch (u) {
        r(u);
      }
    }
    function l(y) {
      try {
        d(i.throw(y));
      } catch (u) {
        r(u);
      }
    }
    function d(y) {
      y.done ? a(y.value) : o(y.value).then(s, l);
    }
    d((i = i.apply(e, t || [])).next());
  });
}
var aSe = function e(t, n) {
  if (t === n)
    return !0;
  if (t && n && typeof t == "object" && typeof n == "object") {
    if (t.constructor !== n.constructor)
      return !1;
    var i, o, a;
    if (Array.isArray(t)) {
      if (i = t.length, i != n.length)
        return !1;
      for (o = i; o-- !== 0; )
        if (!e(t[o], n[o]))
          return !1;
      return !0;
    }
    if (t.constructor === RegExp)
      return t.source === n.source && t.flags === n.flags;
    if (t.valueOf !== Object.prototype.valueOf)
      return t.valueOf() === n.valueOf();
    if (t.toString !== Object.prototype.toString)
      return t.toString() === n.toString();
    if (a = Object.keys(t), i = a.length, i !== Object.keys(n).length)
      return !1;
    for (o = i; o-- !== 0; )
      if (!Object.prototype.hasOwnProperty.call(n, a[o]))
        return !1;
    for (o = i; o-- !== 0; ) {
      var r = a[o];
      if (!e(t[r], n[r]))
        return !1;
    }
    return !0;
  }
  return t !== t && n !== n;
};
const N1 = "__googleMapsScriptId";
var Jr;
(function(e) {
  e[e.INITIALIZED = 0] = "INITIALIZED", e[e.LOADING = 1] = "LOADING", e[e.SUCCESS = 2] = "SUCCESS", e[e.FAILURE = 3] = "FAILURE";
})(Jr || (Jr = {}));
class pr {
  /**
   * Creates an instance of Loader using [[LoaderOptions]]. No defaults are set
   * using this library, instead the defaults are set by the Google Maps
   * JavaScript API server.
   *
   * ```
   * const loader = Loader({apiKey, version: 'weekly', libraries: ['places']});
   * ```
   */
  constructor({ apiKey: t, authReferrerPolicy: n, channel: i, client: o, id: a = N1, language: r, libraries: s = [], mapIds: l, nonce: d, region: y, retries: u = 3, url: m = "https://maps.googleapis.com/maps/api/js", version: h }) {
    if (this.callbacks = [], this.done = !1, this.loading = !1, this.errors = [], this.apiKey = t, this.authReferrerPolicy = n, this.channel = i, this.client = o, this.id = a || N1, this.language = r, this.libraries = s, this.mapIds = l, this.nonce = d, this.region = y, this.retries = u, this.url = m, this.version = h, pr.instance) {
      if (!aSe(this.options, pr.instance.options))
        throw new Error(`Loader must not be called again with different options. ${JSON.stringify(this.options)} !== ${JSON.stringify(pr.instance.options)}`);
      return pr.instance;
    }
    pr.instance = this;
  }
  get options() {
    return {
      version: this.version,
      apiKey: this.apiKey,
      channel: this.channel,
      client: this.client,
      id: this.id,
      libraries: this.libraries,
      language: this.language,
      region: this.region,
      mapIds: this.mapIds,
      nonce: this.nonce,
      url: this.url,
      authReferrerPolicy: this.authReferrerPolicy
    };
  }
  get status() {
    return this.errors.length ? Jr.FAILURE : this.done ? Jr.SUCCESS : this.loading ? Jr.LOADING : Jr.INITIALIZED;
  }
  get failed() {
    return this.done && !this.loading && this.errors.length >= this.retries + 1;
  }
  /**
   * CreateUrl returns the Google Maps JavaScript API script url given the [[LoaderOptions]].
   *
   * @ignore
   * @deprecated
   */
  createUrl() {
    let t = this.url;
    return t += "?callback=__googleMapsCallback", this.apiKey && (t += `&key=${this.apiKey}`), this.channel && (t += `&channel=${this.channel}`), this.client && (t += `&client=${this.client}`), this.libraries.length > 0 && (t += `&libraries=${this.libraries.join(",")}`), this.language && (t += `&language=${this.language}`), this.region && (t += `&region=${this.region}`), this.version && (t += `&v=${this.version}`), this.mapIds && (t += `&map_ids=${this.mapIds.join(",")}`), this.authReferrerPolicy && (t += `&auth_referrer_policy=${this.authReferrerPolicy}`), t;
  }
  deleteScript() {
    const t = document.getElementById(this.id);
    t && t.remove();
  }
  /**
   * Load the Google Maps JavaScript API script and return a Promise.
   * @deprecated, use importLibrary() instead.
   */
  load() {
    return this.loadPromise();
  }
  /**
   * Load the Google Maps JavaScript API script and return a Promise.
   *
   * @ignore
   * @deprecated, use importLibrary() instead.
   */
  loadPromise() {
    return new Promise((t, n) => {
      this.loadCallback((i) => {
        i ? n(i.error) : t(window.google);
      });
    });
  }
  importLibrary(t) {
    return this.execute(), google.maps.importLibrary(t);
  }
  /**
   * Load the Google Maps JavaScript API script with a callback.
   * @deprecated, use importLibrary() instead.
   */
  loadCallback(t) {
    this.callbacks.push(t), this.execute();
  }
  /**
   * Set the script on document.
   */
  setScript() {
    var t, n;
    if (document.getElementById(this.id)) {
      this.callback();
      return;
    }
    const i = {
      key: this.apiKey,
      channel: this.channel,
      client: this.client,
      libraries: this.libraries.length && this.libraries,
      v: this.version,
      mapIds: this.mapIds,
      language: this.language,
      region: this.region,
      authReferrerPolicy: this.authReferrerPolicy
    };
    Object.keys(i).forEach(
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (a) => !i[a] && delete i[a]
    ), !((n = (t = window?.google) === null || t === void 0 ? void 0 : t.maps) === null || n === void 0) && n.importLibrary || ((a) => {
      let r, s, l, d = "The Google Maps JavaScript API", y = "google", u = "importLibrary", m = "__ib__", h = document, c = window;
      c = c[y] || (c[y] = {});
      const g = c.maps || (c.maps = {}), v = /* @__PURE__ */ new Set(), P = new URLSearchParams(), f = () => (
        // @ts-ignore
        r || (r = new Promise((S, w) => iSe(this, void 0, void 0, function* () {
          var x;
          yield s = h.createElement("script"), s.id = this.id, P.set("libraries", [...v] + "");
          for (l in a)
            P.set(l.replace(/[A-Z]/g, (k) => "_" + k[0].toLowerCase()), a[l]);
          P.set("callback", y + ".maps." + m), s.src = this.url + "?" + P, g[m] = S, s.onerror = () => r = w(Error(d + " could not load.")), s.nonce = this.nonce || ((x = h.querySelector("script[nonce]")) === null || x === void 0 ? void 0 : x.nonce) || "", h.head.append(s);
        })))
      );
      g[u] ? console.warn(d + " only loads once. Ignoring:", a) : g[u] = (S, ...w) => v.add(S) && f().then(() => g[u](S, ...w));
    })(i);
    const o = this.libraries.map((a) => this.importLibrary(a));
    o.length || o.push(this.importLibrary("core")), Promise.all(o).then(() => this.callback(), (a) => {
      const r = new ErrorEvent("error", { error: a });
      this.loadErrorCallback(r);
    });
  }
  /**
   * Reset the loader state.
   */
  reset() {
    this.deleteScript(), this.done = !1, this.loading = !1, this.errors = [], this.onerrorEvent = null;
  }
  resetIfRetryingFailed() {
    this.failed && this.reset();
  }
  loadErrorCallback(t) {
    if (this.errors.push(t), this.errors.length <= this.retries) {
      const n = this.errors.length * Math.pow(2, this.errors.length);
      console.error(`Failed to load Google Maps script, retrying in ${n} ms.`), setTimeout(() => {
        this.deleteScript(), this.setScript();
      }, n);
    } else
      this.onerrorEvent = t, this.callback();
  }
  callback() {
    this.done = !0, this.loading = !1, this.callbacks.forEach((t) => {
      t(this.onerrorEvent);
    }), this.callbacks = [];
  }
  execute() {
    if (this.resetIfRetryingFailed(), this.done)
      this.callback();
    else {
      if (window.google && window.google.maps && window.google.maps.version) {
        console.warn("Google Maps already loaded outside @googlemaps/js-api-loader.This may result in undesirable behavior as options and script parameters may not match."), this.callback();
        return;
      }
      this.loading || (this.loading = !0, this.setScript());
    }
  }
}
function oSe(e) {
  return class extends e.OverlayView {
    constructor(t) {
      super(), R1(this, "element"), R1(this, "opts");
      const { element: n, ...i } = t;
      this.element = n, this.opts = i, this.opts.map && this.setMap(this.opts.map);
    }
    getPosition() {
      return this.opts.position ? this.opts.position instanceof e.LatLng ? this.opts.position : new e.LatLng(this.opts.position) : null;
    }
    getVisible() {
      if (!this.element)
        return !1;
      const t = this.element;
      return t.style.display !== "none" && t.style.visibility !== "hidden" && (t.style.opacity === "" || Number(t.style.opacity) > 0.01);
    }
    onAdd() {
      if (!this.element)
        return;
      const t = this.getPanes();
      t && t.overlayMouseTarget.appendChild(this.element);
    }
    draw() {
      if (!this.element)
        return;
      const t = this.getProjection(), n = t?.fromLatLngToDivPixel(this.getPosition());
      if (n) {
        this.element.style.position = "absolute";
        let i, o;
        switch (this.opts.anchorPoint) {
          case "TOP_CENTER":
            i = "-50%", o = "-100%";
            break;
          case "BOTTOM_CENTER":
            i = "-50%", o = "0";
            break;
          case "LEFT_CENTER":
            i = "-100%", o = "-50%";
            break;
          case "RIGHT_CENTER":
            i = "0", o = "-50%";
            break;
          case "TOP_LEFT":
            i = "-100%", o = "-100%";
            break;
          case "TOP_RIGHT":
            i = "0", o = "-100%";
            break;
          case "BOTTOM_LEFT":
            i = "-100%", o = "0";
            break;
          case "BOTTOM_RIGHT":
            i = "0", o = "0";
            break;
          default:
            i = "-50%", o = "-50%";
        }
        const a = n.x + (this.opts.offsetX || 0) + "px", r = n.y + (this.opts.offsetY || 0) + "px";
        this.element.style.transform = `translateX(${i}) translateX(${a}) translateY(${o}) translateY(${r})`, this.opts.zIndex && (this.element.style.zIndex = this.opts.zIndex.toString());
      }
    }
    onRemove() {
      this.element && this.element.remove();
    }
    setOptions(t) {
      const { element: n, ...i } = t;
      this.element = n, this.opts = i, this.draw();
    }
  };
}
let $1;
const F1 = [
  "bounds_changed",
  "center_changed",
  "click",
  "contextmenu",
  "dblclick",
  "drag",
  "dragend",
  "dragstart",
  "heading_changed",
  "idle",
  "isfractionalzoomenabled_changed",
  "mapcapabilities_changed",
  "maptypeid_changed",
  "mousemove",
  "mouseout",
  "mouseover",
  "projection_changed",
  "renderingtype_changed",
  "rightclick",
  "tilesloaded",
  "tilt_changed",
  "zoom_changed"
], rSe = Be({
  props: {
    apiPromise: {
      type: Promise
    },
    apiKey: {
      type: String,
      default: ""
    },
    version: {
      type: String,
      default: "weekly"
    },
    libraries: {
      type: Array,
      default: () => ["places", "marker"]
    },
    region: {
      type: String,
      required: !1
    },
    language: {
      type: String,
      required: !1
    },
    backgroundColor: {
      type: String,
      required: !1
    },
    center: {
      type: Object,
      default: () => ({ lat: 0, lng: 0 })
    },
    clickableIcons: {
      type: Boolean,
      required: !1,
      default: void 0
    },
    controlSize: {
      type: Number,
      required: !1
    },
    disableDefaultUi: {
      type: Boolean,
      required: !1,
      default: void 0
    },
    disableDoubleClickZoom: {
      type: Boolean,
      required: !1,
      default: void 0
    },
    draggable: {
      type: Boolean,
      required: !1,
      default: void 0
    },
    draggableCursor: {
      type: String,
      required: !1
    },
    draggingCursor: {
      type: String,
      required: !1
    },
    fullscreenControl: {
      type: Boolean,
      required: !1,
      default: void 0
    },
    fullscreenControlPosition: {
      type: String,
      required: !1
    },
    gestureHandling: {
      type: String,
      required: !1
    },
    heading: {
      type: Number,
      required: !1
    },
    isFractionalZoomEnabled: {
      type: Boolean,
      required: !1,
      default: void 0
    },
    keyboardShortcuts: {
      type: Boolean,
      required: !1,
      default: void 0
    },
    mapTypeControl: {
      type: Boolean,
      required: !1,
      default: void 0
    },
    mapTypeControlOptions: {
      type: Object,
      required: !1
    },
    mapTypeId: {
      type: [Number, String],
      required: !1
    },
    mapId: {
      type: String,
      required: !1
    },
    maxZoom: {
      type: Number,
      required: !1
    },
    minZoom: {
      type: Number,
      required: !1
    },
    noClear: {
      type: Boolean,
      required: !1,
      default: void 0
    },
    panControl: {
      type: Boolean,
      required: !1,
      default: void 0
    },
    panControlPosition: {
      type: String,
      required: !1
    },
    restriction: {
      type: Object,
      required: !1
    },
    rotateControl: {
      type: Boolean,
      required: !1,
      default: void 0
    },
    rotateControlPosition: {
      type: String,
      required: !1
    },
    scaleControl: {
      type: Boolean,
      required: !1,
      default: void 0
    },
    scaleControlStyle: {
      type: Number,
      required: !1
    },
    scrollwheel: {
      type: Boolean,
      required: !1,
      default: void 0
    },
    streetView: {
      type: Object,
      required: !1
    },
    streetViewControl: {
      type: Boolean,
      required: !1,
      default: void 0
    },
    streetViewControlPosition: {
      type: String,
      required: !1
    },
    styles: {
      type: Array,
      required: !1
    },
    tilt: {
      type: Number,
      required: !1
    },
    zoom: {
      type: Number,
      required: !1
    },
    zoomControl: {
      type: Boolean,
      required: !1,
      default: void 0
    },
    zoomControlPosition: {
      type: String,
      required: !1
    },
    nonce: {
      type: String,
      default: ""
    }
  },
  emits: F1,
  setup(e, { emit: t }) {
    const n = ge(), i = ge(!1), o = ge(), a = ge(), r = ge(!1);
    Bo(Dr, o), Bo(Rr, a), Bo(hL, r);
    const s = () => {
      const u = { ...e };
      Object.keys(u).forEach((c) => {
        u[c] === void 0 && delete u[c];
      });
      const m = (c) => {
        var g;
        return c ? { position: (g = a.value) == null ? void 0 : g.ControlPosition[c] } : {};
      }, h = {
        scaleControlOptions: e.scaleControlStyle ? { style: e.scaleControlStyle } : {},
        panControlOptions: m(e.panControlPosition),
        zoomControlOptions: m(e.zoomControlPosition),
        rotateControlOptions: m(e.rotateControlPosition),
        streetViewControlOptions: m(e.streetViewControlPosition),
        fullscreenControlOptions: m(e.fullscreenControlPosition),
        disableDefaultUI: e.disableDefaultUi
      };
      return { ...u, ...h };
    }, l = qe(
      [a, o],
      ([u, m]) => {
        const h = u, c = m;
        h && c && (h.event.addListenerOnce(c, "tilesloaded", () => {
          r.value = !0;
        }), setTimeout(l, 0));
      },
      { immediate: !0 }
    ), d = () => {
      try {
        const { apiKey: u, region: m, version: h, language: c, libraries: g, nonce: v } = e;
        $1 = new pr({ apiKey: u, region: m, version: h, language: c, libraries: g, nonce: v });
      } catch (u) {
        console.error(u);
      }
    }, y = (u) => {
      a.value = ri(u.maps), o.value = ri(new u.maps.Map(n.value, s()));
      const m = oSe(a.value);
      a.value[jh] = m, F1.forEach((c) => {
        var g;
        (g = o.value) == null || g.addListener(c, (v) => t(c, v));
      }), i.value = !0;
      const h = Object.keys(e).filter(
        (c) => !["apiPromise", "apiKey", "version", "libraries", "region", "language", "center", "zoom", "nonce"].includes(c)
      ).map((c) => xi(e, c));
      qe(
        [() => e.center, () => e.zoom, ...h],
        ([c, g], [v, P]) => {
          var f, S, w;
          const { center: x, zoom: k, ...A } = s();
          (f = o.value) == null || f.setOptions(A), g !== void 0 && g !== P && ((S = o.value) == null || S.setZoom(g));
          const $ = !v || c.lng !== v.lng || c.lat !== v.lat;
          c && $ && ((w = o.value) == null || w.panTo(c));
        }
      );
    };
    return it(() => {
      e.apiPromise && e.apiPromise instanceof Promise ? e.apiPromise.then(y) : (d(), $1.load().then(y));
    }), Fa(() => {
      var u;
      r.value = !1, o.value && ((u = a.value) == null || u.event.clearInstanceListeners(o.value));
    }), { mapRef: n, ready: i, map: o, api: a, mapTilesLoaded: r };
  }
}), ov = (e, t) => {
  const n = e.__vccOpts || e;
  for (const [i, o] of t)
    n[i] = o;
  return n;
}, sSe = {
  ref: "mapRef",
  class: "mapdiv"
};
function lSe(e, t, n, i, o, a) {
  return E(), X("div", null, [
    oe("div", sSe, null, 512),
    je(e.$slots, "default", si(Ki({ ready: e.ready, map: e.map, api: e.api, mapTilesLoaded: e.mapTilesLoaded })), void 0, !0)
  ]);
}
const cSe = /* @__PURE__ */ ov(rSe, [["render", lSe], ["__scopeId", "data-v-d05fc6bc"]]);
function dSe(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var uSe = function e(t, n) {
  if (t === n)
    return !0;
  if (t && n && typeof t == "object" && typeof n == "object") {
    if (t.constructor !== n.constructor)
      return !1;
    var i, o, a;
    if (Array.isArray(t)) {
      if (i = t.length, i != n.length)
        return !1;
      for (o = i; o-- !== 0; )
        if (!e(t[o], n[o]))
          return !1;
      return !0;
    }
    if (t.constructor === RegExp)
      return t.source === n.source && t.flags === n.flags;
    if (t.valueOf !== Object.prototype.valueOf)
      return t.valueOf() === n.valueOf();
    if (t.toString !== Object.prototype.toString)
      return t.toString() === n.toString();
    if (a = Object.keys(t), i = a.length, i !== Object.keys(n).length)
      return !1;
    for (o = i; o-- !== 0; )
      if (!Object.prototype.hasOwnProperty.call(n, a[o]))
        return !1;
    for (o = i; o-- !== 0; ) {
      var r = a[o];
      if (!e(t[r], n[r]))
        return !1;
    }
    return !0;
  }
  return t !== t && n !== n;
};
const uo = /* @__PURE__ */ dSe(uSe), j1 = ["click", "drag", "dragend", "dragstart", "gmp-click"];
Be({
  name: "AdvancedMarker",
  props: {
    options: {
      type: Object,
      required: !0
    },
    pinOptions: {
      type: Object,
      required: !1
    }
  },
  emits: j1,
  setup(e, { emit: t, expose: n, slots: i }) {
    const o = xi(e, "options"), a = xi(e, "pinOptions"), r = ge(), s = $t(Dr, ge()), l = $t(Rr, ge()), d = $t(av, ge()), y = Te(
      () => !!(d.value && l.value && r.value instanceof google.maps.marker.AdvancedMarkerElement)
    );
    return qe(
      [s, o, a],
      async (u, [m, h, c]) => {
        var g, v, P;
        const f = !uo(o.value, h) || !uo(a.value, c) || s.value !== m;
        if (!s.value || !l.value || !f)
          return;
        const { AdvancedMarkerElement: S, PinElement: w } = l.value.marker;
        if (r.value) {
          const { map: x, content: k, ...A } = o.value;
          Object.assign(r.value, {
            content: a.value ? new w(a.value).element : k,
            ...A
          }), y.value && ((g = d.value) == null || g.removeMarker(r.value), (v = d.value) == null || v.addMarker(r.value));
        } else
          a.value && (o.value.content = new w(a.value).element), r.value = ri(new S(o.value)), y.value ? (P = d.value) == null || P.addMarker(r.value) : r.value.map = s.value, j1.forEach((x) => {
            var k;
            (k = r.value) == null || k.addListener(x, (A) => t(x, A));
          });
      },
      {
        immediate: !0
      }
    ), Fa(() => {
      var u, m;
      r.value && ((u = l.value) == null || u.event.clearInstanceListeners(r.value), y.value ? (m = d.value) == null || m.removeMarker(r.value) : r.value.map = null);
    }), Bo(iv, r), n({ marker: r }), () => {
      var u;
      return (u = i.default) == null ? void 0 : u.call(i);
    };
  }
});
const hSe = (e) => e === "Marker", pSe = (e) => e === jh, Ws = (e, t, n, i) => {
  const o = ge(), a = $t(Dr, ge()), r = $t(Rr, ge()), s = $t(av, ge()), l = Te(
    () => !!(s.value && r.value && (o.value instanceof r.value.Marker || o.value instanceof r.value[jh]))
  );
  return qe(
    [a, n],
    (d, [y, u]) => {
      var m, h, c;
      const g = !uo(n.value, u) || a.value !== y;
      !a.value || !r.value || !g || (o.value ? (o.value.setOptions(n.value), l.value && ((m = s.value) == null || m.removeMarker(o.value), (h = s.value) == null || h.addMarker(o.value))) : (hSe(e) ? o.value = ri(
        new r.value[e](n.value)
      ) : pSe(e) ? o.value = ri(
        new r.value[e](n.value)
      ) : o.value = ri(
        new r.value[e]({
          ...n.value,
          map: a.value
        })
      ), l.value ? (c = s.value) == null || c.addMarker(o.value) : o.value.setMap(a.value), t.forEach((v) => {
        var P;
        (P = o.value) == null || P.addListener(v, (f) => i(v, f));
      })));
    },
    {
      immediate: !0
    }
  ), Fa(() => {
    var d, y;
    o.value && ((d = r.value) == null || d.event.clearInstanceListeners(o.value), l.value ? (y = s.value) == null || y.removeMarker(o.value) : o.value.setMap(null));
  }), o;
}, H1 = [
  "animation_changed",
  "click",
  "dblclick",
  "rightclick",
  "dragstart",
  "dragend",
  "drag",
  "mouseover",
  "mousedown",
  "mouseout",
  "mouseup",
  "draggable_changed",
  "clickable_changed",
  "contextmenu",
  "cursor_changed",
  "flat_changed",
  "rightclick",
  "zindex_changed",
  "icon_changed",
  "position_changed",
  "shape_changed",
  "title_changed",
  "visible_changed"
];
Be({
  name: "Marker",
  props: {
    options: {
      type: Object,
      required: !0
    }
  },
  emits: H1,
  setup(e, { emit: t, expose: n, slots: i }) {
    const o = xi(e, "options"), a = Ws("Marker", H1, o, t);
    return Bo(iv, a), n({ marker: a }), () => {
      var r;
      return (r = i.default) == null ? void 0 : r.call(i);
    };
  }
});
Be({
  name: "Polyline",
  props: {
    options: {
      type: Object,
      required: !0
    }
  },
  emits: xs,
  setup(e, { emit: t }) {
    const n = xi(e, "options");
    return { polyline: Ws("Polyline", xs, n, t) };
  },
  render: () => null
});
Be({
  name: "Polygon",
  props: {
    options: {
      type: Object,
      required: !0
    }
  },
  emits: xs,
  setup(e, { emit: t }) {
    const n = xi(e, "options");
    return { polygon: Ws("Polygon", xs, n, t) };
  },
  render: () => null
});
const z1 = xs.concat(["bounds_changed"]);
Be({
  name: "Rectangle",
  props: {
    options: {
      type: Object,
      required: !0
    }
  },
  emits: z1,
  setup(e, { emit: t }) {
    const n = xi(e, "options");
    return { rectangle: Ws("Rectangle", z1, n, t) };
  },
  render: () => null
});
const V1 = xs.concat(["center_changed", "radius_changed"]);
Be({
  name: "Circle",
  props: {
    options: {
      type: Object,
      required: !0
    }
  },
  emits: V1,
  setup(e, { emit: t }) {
    const n = xi(e, "options");
    return { circle: Ws("Circle", V1, n, t) };
  },
  render: () => null
});
const fSe = Be({
  props: {
    position: {
      type: String,
      required: !0
    },
    index: {
      type: Number,
      default: 1
    }
  },
  emits: ["content:loaded"],
  setup(e, { emit: t }) {
    const n = ge(null), i = $t(Dr, ge()), o = $t(Rr, ge()), a = $t(hL, ge(!1)), r = qe(
      [a, o, n],
      ([d, y, u]) => {
        y && d && u && (s(e.position), t("content:loaded"), setTimeout(r, 0));
      },
      { immediate: !0 }
    ), s = (d) => {
      if (i.value && o.value && n.value) {
        const y = o.value.ControlPosition[d];
        i.value.controls[y].push(n.value);
      }
    }, l = (d) => {
      if (i.value && o.value) {
        let y = null;
        const u = o.value.ControlPosition[d];
        i.value.controls[u].forEach((m, h) => {
          m === n.value && (y = h);
        }), y !== null && i.value.controls[u].removeAt(y);
      }
    };
    return Fa(() => l(e.position)), qe(
      () => e.position,
      (d, y) => {
        l(y), s(d);
      }
    ), qe(
      () => e.index,
      (d) => {
        d && n.value && (n.value.index = e.index);
      }
    ), { controlRef: n };
  }
}), mSe = {
  ref: "controlRef",
  class: "custom-control-wrapper"
};
function gSe(e, t, n, i, o, a) {
  return E(), X("div", mSe, [
    je(e.$slots, "default", {}, void 0, !0)
  ], 512);
}
const G1 = /* @__PURE__ */ ov(fSe, [["render", gSe], ["__scopeId", "data-v-d099a3a6"]]), U1 = ["closeclick", "content_changed", "domready", "position_changed", "visible", "zindex_changed"];
Be({
  inheritAttrs: !1,
  props: {
    options: {
      type: Object,
      default: () => ({})
    },
    modelValue: {
      type: Boolean
    }
  },
  emits: [...U1, "update:modelValue"],
  setup(e, { slots: t, emit: n, expose: i }) {
    const o = ge(), a = ge(), r = $t(Dr, ge()), s = $t(Rr, ge()), l = $t(iv, ge());
    let d, y = e.modelValue;
    const u = Te(() => {
      var g;
      return (g = t.default) == null ? void 0 : g.call(t).some((v) => v.type !== Fx);
    }), m = (g) => {
      y = g, n("update:modelValue", g);
    }, h = (g) => {
      o.value && (o.value.open({ map: r.value, anchor: l.value, ...g }), m(!0));
    }, c = () => {
      o.value && (o.value.close(), m(!1));
    };
    return it(() => {
      qe(
        [r, () => e.options],
        ([g, v], [P, f]) => {
          var S;
          const w = !uo(v, f) || r.value !== P;
          r.value && s.value && w && (o.value ? (o.value.setOptions({
            ...v,
            content: u.value ? a.value : v.content
          }), l.value || h()) : (o.value = ri(
            new s.value.InfoWindow({
              ...v,
              content: u.value ? a.value : v.content
            })
          ), l.value && (d = l.value.addListener("click", () => {
            h();
          })), (!l.value || y) && h(), U1.forEach((x) => {
            var k;
            (k = o.value) == null || k.addListener(x, (A) => n(x, A));
          }), (S = o.value) == null || S.addListener("closeclick", () => m(!1))));
        },
        {
          immediate: !0
        }
      ), qe(
        () => e.modelValue,
        (g) => {
          g !== y && (g ? h() : c());
        }
      );
    }), Fa(() => {
      var g;
      d && d.remove(), o.value && ((g = s.value) == null || g.event.clearInstanceListeners(o.value), c());
    }), i({ infoWindow: o, open: h, close: c }), { infoWindow: o, infoWindowRef: a, hasSlotContent: u, open: h, close: c };
  }
});
const W1 = [
  Int8Array,
  Uint8Array,
  Uint8ClampedArray,
  Int16Array,
  Uint16Array,
  Int32Array,
  Uint32Array,
  Float32Array,
  Float64Array
], Ap = 1, pl = 8;
class rv {
  /**
   * Creates an index from raw `ArrayBuffer` data.
   * @param {ArrayBuffer} data
   */
  static from(t) {
    if (!(t instanceof ArrayBuffer))
      throw new Error("Data must be an instance of ArrayBuffer.");
    const [n, i] = new Uint8Array(t, 0, 2);
    if (n !== 219)
      throw new Error("Data does not appear to be in a KDBush format.");
    const o = i >> 4;
    if (o !== Ap)
      throw new Error(`Got v${o} data when expected v${Ap}.`);
    const a = W1[i & 15];
    if (!a)
      throw new Error("Unrecognized array type.");
    const [r] = new Uint16Array(t, 2, 1), [s] = new Uint32Array(t, 4, 1);
    return new rv(s, r, a, t);
  }
  /**
   * Creates an index that will hold a given number of items.
   * @param {number} numItems
   * @param {number} [nodeSize=64] Size of the KD-tree node (64 by default).
   * @param {TypedArrayConstructor} [ArrayType=Float64Array] The array type used for coordinates storage (`Float64Array` by default).
   * @param {ArrayBuffer} [data] (For internal use only)
   */
  constructor(t, n = 64, i = Float64Array, o) {
    if (isNaN(t) || t < 0)
      throw new Error(`Unpexpected numItems value: ${t}.`);
    this.numItems = +t, this.nodeSize = Math.min(Math.max(+n, 2), 65535), this.ArrayType = i, this.IndexArrayType = t < 65536 ? Uint16Array : Uint32Array;
    const a = W1.indexOf(this.ArrayType), r = t * 2 * this.ArrayType.BYTES_PER_ELEMENT, s = t * this.IndexArrayType.BYTES_PER_ELEMENT, l = (8 - s % 8) % 8;
    if (a < 0)
      throw new Error(`Unexpected typed array class: ${i}.`);
    o && o instanceof ArrayBuffer ? (this.data = o, this.ids = new this.IndexArrayType(this.data, pl, t), this.coords = new this.ArrayType(this.data, pl + s + l, t * 2), this._pos = t * 2, this._finished = !0) : (this.data = new ArrayBuffer(pl + r + s + l), this.ids = new this.IndexArrayType(this.data, pl, t), this.coords = new this.ArrayType(this.data, pl + s + l, t * 2), this._pos = 0, this._finished = !1, new Uint8Array(this.data, 0, 2).set([219, (Ap << 4) + a]), new Uint16Array(this.data, 2, 1)[0] = n, new Uint32Array(this.data, 4, 1)[0] = t);
  }
  /**
   * Add a point to the index.
   * @param {number} x
   * @param {number} y
   * @returns {number} An incremental index associated with the added item (starting from `0`).
   */
  add(t, n) {
    const i = this._pos >> 1;
    return this.ids[i] = i, this.coords[this._pos++] = t, this.coords[this._pos++] = n, i;
  }
  /**
   * Perform indexing of the added points.
   */
  finish() {
    const t = this._pos >> 1;
    if (t !== this.numItems)
      throw new Error(`Added ${t} items when expected ${this.numItems}.`);
    return nm(this.ids, this.coords, this.nodeSize, 0, this.numItems - 1, 0), this._finished = !0, this;
  }
  /**
   * Search the index for items within a given bounding box.
   * @param {number} minX
   * @param {number} minY
   * @param {number} maxX
   * @param {number} maxY
   * @returns {number[]} An array of indices correponding to the found items.
   */
  range(t, n, i, o) {
    if (!this._finished)
      throw new Error("Data not yet indexed - call index.finish().");
    const { ids: a, coords: r, nodeSize: s } = this, l = [0, a.length - 1, 0], d = [];
    for (; l.length; ) {
      const y = l.pop() || 0, u = l.pop() || 0, m = l.pop() || 0;
      if (u - m <= s) {
        for (let v = m; v <= u; v++) {
          const P = r[2 * v], f = r[2 * v + 1];
          P >= t && P <= i && f >= n && f <= o && d.push(a[v]);
        }
        continue;
      }
      const h = m + u >> 1, c = r[2 * h], g = r[2 * h + 1];
      c >= t && c <= i && g >= n && g <= o && d.push(a[h]), (y === 0 ? t <= c : n <= g) && (l.push(m), l.push(h - 1), l.push(1 - y)), (y === 0 ? i >= c : o >= g) && (l.push(h + 1), l.push(u), l.push(1 - y));
    }
    return d;
  }
  /**
   * Search the index for items within a given radius.
   * @param {number} qx
   * @param {number} qy
   * @param {number} r Query radius.
   * @returns {number[]} An array of indices correponding to the found items.
   */
  within(t, n, i) {
    if (!this._finished)
      throw new Error("Data not yet indexed - call index.finish().");
    const { ids: o, coords: a, nodeSize: r } = this, s = [0, o.length - 1, 0], l = [], d = i * i;
    for (; s.length; ) {
      const y = s.pop() || 0, u = s.pop() || 0, m = s.pop() || 0;
      if (u - m <= r) {
        for (let v = m; v <= u; v++)
          Y1(a[2 * v], a[2 * v + 1], t, n) <= d && l.push(o[v]);
        continue;
      }
      const h = m + u >> 1, c = a[2 * h], g = a[2 * h + 1];
      Y1(c, g, t, n) <= d && l.push(o[h]), (y === 0 ? t - i <= c : n - i <= g) && (s.push(m), s.push(h - 1), s.push(1 - y)), (y === 0 ? t + i >= c : n + i >= g) && (s.push(h + 1), s.push(u), s.push(1 - y));
    }
    return l;
  }
}
function nm(e, t, n, i, o, a) {
  if (o - i <= n)
    return;
  const r = i + o >> 1;
  pL(e, t, r, i, o, a), nm(e, t, n, i, r - 1, 1 - a), nm(e, t, n, r + 1, o, 1 - a);
}
function pL(e, t, n, i, o, a) {
  for (; o > i; ) {
    if (o - i > 600) {
      const d = o - i + 1, y = n - i + 1, u = Math.log(d), m = 0.5 * Math.exp(2 * u / 3), h = 0.5 * Math.sqrt(u * m * (d - m) / d) * (y - d / 2 < 0 ? -1 : 1), c = Math.max(i, Math.floor(n - y * m / d + h)), g = Math.min(o, Math.floor(n + (d - y) * m / d + h));
      pL(e, t, n, c, g, a);
    }
    const r = t[2 * n + a];
    let s = i, l = o;
    for (fl(e, t, i, n), t[2 * o + a] > r && fl(e, t, i, o); s < l; ) {
      for (fl(e, t, s, l), s++, l--; t[2 * s + a] < r; )
        s++;
      for (; t[2 * l + a] > r; )
        l--;
    }
    t[2 * i + a] === r ? fl(e, t, i, l) : (l++, fl(e, t, l, o)), l <= n && (i = l + 1), n <= l && (o = l - 1);
  }
}
function fl(e, t, n, i) {
  _p(e, n, i), _p(t, 2 * n, 2 * i), _p(t, 2 * n + 1, 2 * i + 1);
}
function _p(e, t, n) {
  const i = e[t];
  e[t] = e[n], e[n] = i;
}
function Y1(e, t, n, i) {
  const o = e - n, a = t - i;
  return o * o + a * a;
}
const vSe = {
  minZoom: 0,
  // min zoom to generate clusters on
  maxZoom: 16,
  // max zoom level to cluster the points on
  minPoints: 2,
  // minimum points to form a cluster
  radius: 40,
  // cluster radius in pixels
  extent: 512,
  // tile extent (radius is calculated relative to it)
  nodeSize: 64,
  // size of the KD-tree leaf node, affects performance
  log: !1,
  // whether to log timing info
  // whether to generate numeric ids for input features (in vector tiles)
  generateId: !1,
  // a reduce function for calculating custom cluster properties
  reduce: null,
  // (accumulated, props) => { accumulated.sum += props.sum; }
  // properties to use for individual points when running the reducer
  map: (e) => e
  // props => ({sum: props.my_value})
}, q1 = Math.fround || ((e) => (t) => (e[0] = +t, e[0]))(new Float32Array(1)), tr = 2, Po = 3, Mp = 4, Co = 5, fL = 6;
class mL {
  constructor(t) {
    this.options = Object.assign(Object.create(vSe), t), this.trees = new Array(this.options.maxZoom + 1), this.stride = this.options.reduce ? 7 : 6, this.clusterProps = [];
  }
  load(t) {
    const { log: n, minZoom: i, maxZoom: o } = this.options;
    n && console.time("total time");
    const a = `prepare ${t.length} points`;
    n && console.time(a), this.points = t;
    const r = [];
    for (let l = 0; l < t.length; l++) {
      const d = t[l];
      if (!d.geometry)
        continue;
      const [y, u] = d.geometry.coordinates, m = q1(Nd(y)), h = q1($d(u));
      r.push(
        m,
        h,
        // projected point coordinates
        1 / 0,
        // the last zoom the point was processed at
        l,
        // index of the source feature in the original input array
        -1,
        // parent cluster id
        1
        // number of points in a cluster
      ), this.options.reduce && r.push(0);
    }
    let s = this.trees[o + 1] = this._createTree(r);
    n && console.timeEnd(a);
    for (let l = o; l >= i; l--) {
      const d = +Date.now();
      s = this.trees[l] = this._createTree(this._cluster(s, l)), n && console.log("z%d: %d clusters in %dms", l, s.numItems, +Date.now() - d);
    }
    return n && console.timeEnd("total time"), this;
  }
  getClusters(t, n) {
    let i = ((t[0] + 180) % 360 + 360) % 360 - 180;
    const o = Math.max(-90, Math.min(90, t[1]));
    let a = t[2] === 180 ? 180 : ((t[2] + 180) % 360 + 360) % 360 - 180;
    const r = Math.max(-90, Math.min(90, t[3]));
    if (t[2] - t[0] >= 360)
      i = -180, a = 180;
    else if (i > a) {
      const u = this.getClusters([i, o, 180, r], n), m = this.getClusters([-180, o, a, r], n);
      return u.concat(m);
    }
    const s = this.trees[this._limitZoom(n)], l = s.range(Nd(i), $d(r), Nd(a), $d(o)), d = s.data, y = [];
    for (const u of l) {
      const m = this.stride * u;
      y.push(d[m + Co] > 1 ? K1(d, m, this.clusterProps) : this.points[d[m + Po]]);
    }
    return y;
  }
  getChildren(t) {
    const n = this._getOriginId(t), i = this._getOriginZoom(t), o = "No cluster with the specified id.", a = this.trees[i];
    if (!a)
      throw new Error(o);
    const r = a.data;
    if (n * this.stride >= r.length)
      throw new Error(o);
    const s = this.options.radius / (this.options.extent * Math.pow(2, i - 1)), l = r[n * this.stride], d = r[n * this.stride + 1], y = a.within(l, d, s), u = [];
    for (const m of y) {
      const h = m * this.stride;
      r[h + Mp] === t && u.push(r[h + Co] > 1 ? K1(r, h, this.clusterProps) : this.points[r[h + Po]]);
    }
    if (u.length === 0)
      throw new Error(o);
    return u;
  }
  getLeaves(t, n, i) {
    n = n || 10, i = i || 0;
    const o = [];
    return this._appendLeaves(o, t, n, i, 0), o;
  }
  getTile(t, n, i) {
    const o = this.trees[this._limitZoom(t)], a = Math.pow(2, t), { extent: r, radius: s } = this.options, l = s / r, d = (i - l) / a, y = (i + 1 + l) / a, u = {
      features: []
    };
    return this._addTileFeatures(
      o.range((n - l) / a, d, (n + 1 + l) / a, y),
      o.data,
      n,
      i,
      a,
      u
    ), n === 0 && this._addTileFeatures(
      o.range(1 - l / a, d, 1, y),
      o.data,
      a,
      i,
      a,
      u
    ), n === a - 1 && this._addTileFeatures(
      o.range(0, d, l / a, y),
      o.data,
      -1,
      i,
      a,
      u
    ), u.features.length ? u : null;
  }
  getClusterExpansionZoom(t) {
    let n = this._getOriginZoom(t) - 1;
    for (; n <= this.options.maxZoom; ) {
      const i = this.getChildren(t);
      if (n++, i.length !== 1)
        break;
      t = i[0].properties.cluster_id;
    }
    return n;
  }
  _appendLeaves(t, n, i, o, a) {
    const r = this.getChildren(n);
    for (const s of r) {
      const l = s.properties;
      if (l && l.cluster ? a + l.point_count <= o ? a += l.point_count : a = this._appendLeaves(t, l.cluster_id, i, o, a) : a < o ? a++ : t.push(s), t.length === i)
        break;
    }
    return a;
  }
  _createTree(t) {
    const n = new rv(t.length / this.stride | 0, this.options.nodeSize, Float32Array);
    for (let i = 0; i < t.length; i += this.stride)
      n.add(t[i], t[i + 1]);
    return n.finish(), n.data = t, n;
  }
  _addTileFeatures(t, n, i, o, a, r) {
    for (const s of t) {
      const l = s * this.stride, d = n[l + Co] > 1;
      let y, u, m;
      if (d)
        y = gL(n, l, this.clusterProps), u = n[l], m = n[l + 1];
      else {
        const g = this.points[n[l + Po]];
        y = g.properties;
        const [v, P] = g.geometry.coordinates;
        u = Nd(v), m = $d(P);
      }
      const h = {
        type: 1,
        geometry: [[
          Math.round(this.options.extent * (u * a - i)),
          Math.round(this.options.extent * (m * a - o))
        ]],
        tags: y
      };
      let c;
      d || this.options.generateId ? c = n[l + Po] : c = this.points[n[l + Po]].id, c !== void 0 && (h.id = c), r.features.push(h);
    }
  }
  _limitZoom(t) {
    return Math.max(this.options.minZoom, Math.min(Math.floor(+t), this.options.maxZoom + 1));
  }
  _cluster(t, n) {
    const { radius: i, extent: o, reduce: a, minPoints: r } = this.options, s = i / (o * Math.pow(2, n)), l = t.data, d = [], y = this.stride;
    for (let u = 0; u < l.length; u += y) {
      if (l[u + tr] <= n)
        continue;
      l[u + tr] = n;
      const m = l[u], h = l[u + 1], c = t.within(l[u], l[u + 1], s), g = l[u + Co];
      let v = g;
      for (const P of c) {
        const f = P * y;
        l[f + tr] > n && (v += l[f + Co]);
      }
      if (v > g && v >= r) {
        let P = m * g, f = h * g, S, w = -1;
        const x = ((u / y | 0) << 5) + (n + 1) + this.points.length;
        for (const k of c) {
          const A = k * y;
          if (l[A + tr] <= n)
            continue;
          l[A + tr] = n;
          const $ = l[A + Co];
          P += l[A] * $, f += l[A + 1] * $, l[A + Mp] = x, a && (S || (S = this._map(l, u, !0), w = this.clusterProps.length, this.clusterProps.push(S)), a(S, this._map(l, A)));
        }
        l[u + Mp] = x, d.push(P / v, f / v, 1 / 0, x, -1, v), a && d.push(w);
      } else {
        for (let P = 0; P < y; P++)
          d.push(l[u + P]);
        if (v > 1)
          for (const P of c) {
            const f = P * y;
            if (!(l[f + tr] <= n)) {
              l[f + tr] = n;
              for (let S = 0; S < y; S++)
                d.push(l[f + S]);
            }
          }
      }
    }
    return d;
  }
  // get index of the point from which the cluster originated
  _getOriginId(t) {
    return t - this.points.length >> 5;
  }
  // get zoom of the point from which the cluster originated
  _getOriginZoom(t) {
    return (t - this.points.length) % 32;
  }
  _map(t, n, i) {
    if (t[n + Co] > 1) {
      const r = this.clusterProps[t[n + fL]];
      return i ? Object.assign({}, r) : r;
    }
    const o = this.points[t[n + Po]].properties, a = this.options.map(o);
    return i && a === o ? Object.assign({}, a) : a;
  }
}
function K1(e, t, n) {
  return {
    type: "Feature",
    id: e[t + Po],
    properties: gL(e, t, n),
    geometry: {
      type: "Point",
      coordinates: [ySe(e[t]), bSe(e[t + 1])]
    }
  };
}
function gL(e, t, n) {
  const i = e[t + Co], o = i >= 1e4 ? `${Math.round(i / 1e3)}k` : i >= 1e3 ? `${Math.round(i / 100) / 10}k` : i, a = e[t + fL], r = a === -1 ? {} : Object.assign({}, n[a]);
  return Object.assign(r, {
    cluster: !0,
    cluster_id: e[t + Po],
    point_count: i,
    point_count_abbreviated: o
  });
}
function Nd(e) {
  return e / 360 + 0.5;
}
function $d(e) {
  const t = Math.sin(e * Math.PI / 180), n = 0.5 - 0.25 * Math.log((1 + t) / (1 - t)) / Math.PI;
  return n < 0 ? 0 : n > 1 ? 1 : n;
}
function ySe(e) {
  return (e - 0.5) * 360;
}
function bSe(e) {
  const t = (180 - e * 360) * Math.PI / 180;
  return 360 * Math.atan(Math.exp(t)) / Math.PI - 90;
}
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
function sv(e, t) {
  var n = {};
  for (var i in e)
    Object.prototype.hasOwnProperty.call(e, i) && t.indexOf(i) < 0 && (n[i] = e[i]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, i = Object.getOwnPropertySymbols(e); o < i.length; o++)
      t.indexOf(i[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, i[o]) && (n[i[o]] = e[i[o]]);
  return n;
}
class ai {
  static isAdvancedMarkerAvailable(t) {
    return google.maps.marker && t.getMapCapabilities().isAdvancedMarkersAvailable === !0;
  }
  static isAdvancedMarker(t) {
    return google.maps.marker && t instanceof google.maps.marker.AdvancedMarkerElement;
  }
  static setMap(t, n) {
    this.isAdvancedMarker(t) ? t.map = n : t.setMap(n);
  }
  static getPosition(t) {
    if (this.isAdvancedMarker(t)) {
      if (t.position) {
        if (t.position instanceof google.maps.LatLng)
          return t.position;
        if (t.position.lat && t.position.lng)
          return new google.maps.LatLng(t.position.lat, t.position.lng);
      }
      return new google.maps.LatLng(null);
    }
    return t.getPosition();
  }
  static getVisible(t) {
    return this.isAdvancedMarker(t) ? !0 : t.getVisible();
  }
}
class jc {
  constructor({ markers: t, position: n }) {
    this.markers = t, n && (n instanceof google.maps.LatLng ? this._position = n : this._position = new google.maps.LatLng(n));
  }
  get bounds() {
    if (this.markers.length === 0 && !this._position)
      return;
    const t = new google.maps.LatLngBounds(this._position, this._position);
    for (const n of this.markers)
      t.extend(ai.getPosition(n));
    return t;
  }
  get position() {
    return this._position || this.bounds.getCenter();
  }
  /**
   * Get the count of **visible** markers.
   */
  get count() {
    return this.markers.filter((t) => ai.getVisible(t)).length;
  }
  /**
   * Add a marker to the cluster.
   */
  push(t) {
    this.markers.push(t);
  }
  /**
   * Cleanup references and remove marker from map.
   */
  delete() {
    this.marker && (ai.setMap(this.marker, null), this.marker = void 0), this.markers.length = 0;
  }
}
const xSe = (e, t, n, i) => {
  const o = vL(e.getBounds(), t, i);
  return n.filter((a) => o.contains(ai.getPosition(a)));
}, vL = (e, t, n) => {
  const { northEast: i, southWest: o } = wSe(e, t), a = kSe({ northEast: i, southWest: o }, n);
  return SSe(a, t);
}, X1 = (e, t, n) => {
  const i = vL(e, t, n), o = i.getNorthEast(), a = i.getSouthWest();
  return [a.lng(), a.lat(), o.lng(), o.lat()];
}, wSe = (e, t) => ({
  northEast: t.fromLatLngToDivPixel(e.getNorthEast()),
  southWest: t.fromLatLngToDivPixel(e.getSouthWest())
}), kSe = ({ northEast: e, southWest: t }, n) => (e.x += n, e.y -= n, t.x -= n, t.y += n, { northEast: e, southWest: t }), SSe = ({ northEast: e, southWest: t }, n) => {
  const i = n.fromDivPixelToLatLng(t), o = n.fromDivPixelToLatLng(e);
  return new google.maps.LatLngBounds(i, o);
};
class yL {
  constructor({ maxZoom: t = 16 }) {
    this.maxZoom = t;
  }
  /**
   * Helper function to bypass clustering based upon some map state such as
   * zoom, number of markers, etc.
   *
   * ```typescript
   *  cluster({markers, map}: AlgorithmInput): Cluster[] {
   *    if (shouldBypassClustering(map)) {
   *      return this.noop({markers})
   *    }
   * }
   * ```
   */
  noop({ markers: t }) {
    return TSe(t);
  }
}
class CSe extends yL {
  constructor(t) {
    var { viewportPadding: n = 60 } = t, i = sv(t, ["viewportPadding"]);
    super(i), this.viewportPadding = 60, this.viewportPadding = n;
  }
  calculate({ markers: t, map: n, mapCanvasProjection: i }) {
    return n.getZoom() >= this.maxZoom ? {
      clusters: this.noop({
        markers: t
      }),
      changed: !1
    } : {
      clusters: this.cluster({
        markers: xSe(n, i, t, this.viewportPadding),
        map: n,
        mapCanvasProjection: i
      })
    };
  }
}
const TSe = (e) => e.map((t) => new jc({
  position: ai.getPosition(t),
  markers: [t]
}));
class LSe extends yL {
  constructor(t) {
    var { maxZoom: n, radius: i = 60 } = t, o = sv(t, ["maxZoom", "radius"]);
    super({ maxZoom: n }), this.state = { zoom: -1 }, this.superCluster = new mL(Object.assign({ maxZoom: this.maxZoom, radius: i }, o));
  }
  calculate(t) {
    let n = !1;
    const i = { zoom: t.map.getZoom() };
    if (!uo(t.markers, this.markers)) {
      n = !0, this.markers = [...t.markers];
      const o = this.markers.map((a) => {
        const r = ai.getPosition(a);
        return {
          type: "Feature",
          geometry: {
            type: "Point",
            coordinates: [r.lng(), r.lat()]
          },
          properties: { marker: a }
        };
      });
      this.superCluster.load(o);
    }
    return n || (this.state.zoom <= this.maxZoom || i.zoom <= this.maxZoom) && (n = !uo(this.state, i)), this.state = i, n && (this.clusters = this.cluster(t)), { clusters: this.clusters, changed: n };
  }
  cluster({ map: t }) {
    return this.superCluster.getClusters([-180, -90, 180, 90], Math.round(t.getZoom())).map((n) => this.transformCluster(n));
  }
  transformCluster({ geometry: { coordinates: [t, n] }, properties: i }) {
    if (i.cluster)
      return new jc({
        markers: this.superCluster.getLeaves(i.cluster_id, 1 / 0).map((a) => a.properties.marker),
        position: { lat: n, lng: t }
      });
    const o = i.marker;
    return new jc({
      markers: [o],
      position: ai.getPosition(o)
    });
  }
}
class ISe extends CSe {
  constructor(t) {
    var { maxZoom: n, radius: i = 60, viewportPadding: o = 60 } = t, a = sv(t, ["maxZoom", "radius", "viewportPadding"]);
    super({ maxZoom: n, viewportPadding: o }), this.superCluster = new mL(Object.assign({ maxZoom: this.maxZoom, radius: i }, a)), this.state = { zoom: -1, view: [0, 0, 0, 0] };
  }
  calculate(t) {
    const n = {
      zoom: Math.round(t.map.getZoom()),
      view: X1(t.map.getBounds(), t.mapCanvasProjection, this.viewportPadding)
    };
    let i = !uo(this.state, n);
    if (!uo(t.markers, this.markers)) {
      i = !0, this.markers = [...t.markers];
      const o = this.markers.map((a) => {
        const r = ai.getPosition(a);
        return {
          type: "Feature",
          geometry: {
            type: "Point",
            coordinates: [r.lng(), r.lat()]
          },
          properties: { marker: a }
        };
      });
      this.superCluster.load(o);
    }
    return i && (this.clusters = this.cluster(t), this.state = n), { clusters: this.clusters, changed: i };
  }
  cluster({ map: t, mapCanvasProjection: n }) {
    const i = {
      zoom: Math.round(t.getZoom()),
      view: X1(t.getBounds(), n, this.viewportPadding)
    };
    return this.superCluster.getClusters(i.view, i.zoom).map((o) => this.transformCluster(o));
  }
  transformCluster({ geometry: { coordinates: [t, n] }, properties: i }) {
    if (i.cluster)
      return new jc({
        markers: this.superCluster.getLeaves(i.cluster_id, 1 / 0).map((a) => a.properties.marker),
        position: { lat: n, lng: t }
      });
    const o = i.marker;
    return new jc({
      markers: [o],
      position: ai.getPosition(o)
    });
  }
}
class PSe {
  constructor(t, n) {
    this.markers = { sum: t.length };
    const i = n.map((a) => a.count), o = i.reduce((a, r) => a + r, 0);
    this.clusters = {
      count: n.length,
      markers: {
        mean: o / n.length,
        sum: o,
        min: Math.min(...i),
        max: Math.max(...i)
      }
    };
  }
}
class ASe {
  /**
   * The default render function for the library used by {@link MarkerClusterer}.
   *
   * Currently set to use the following:
   *
   * ```typescript
   * // change color if this cluster has more markers than the mean cluster
   * const color =
   *   count > Math.max(10, stats.clusters.markers.mean)
   *     ? "#ff0000"
   *     : "#0000ff";
   *
   * // create svg url with fill color
   * const svg = window.btoa(`
   * <svg fill="${color}" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 240">
   *   <circle cx="120" cy="120" opacity=".6" r="70" />
   *   <circle cx="120" cy="120" opacity=".3" r="90" />
   *   <circle cx="120" cy="120" opacity=".2" r="110" />
   *   <circle cx="120" cy="120" opacity=".1" r="130" />
   * </svg>`);
   *
   * // create marker using svg icon
   * return new google.maps.Marker({
   *   position,
   *   icon: {
   *     url: `data:image/svg+xml;base64,${svg}`,
   *     scaledSize: new google.maps.Size(45, 45),
   *   },
   *   label: {
   *     text: String(count),
   *     color: "rgba(255,255,255,0.9)",
   *     fontSize: "12px",
   *   },
   *   // adjust zIndex to be above other markers
   *   zIndex: 1000 + count,
   * });
   * ```
   */
  render({ count: t, position: n }, i, o) {
    const a = `<svg fill="${t > Math.max(10, i.clusters.markers.mean) ? "#ff0000" : "#0000ff"}" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 240" width="50" height="50">
<circle cx="120" cy="120" opacity=".6" r="70" />
<circle cx="120" cy="120" opacity=".3" r="90" />
<circle cx="120" cy="120" opacity=".2" r="110" />
<text x="50%" y="50%" style="fill:#fff" text-anchor="middle" font-size="50" dominant-baseline="middle" font-family="roboto,arial,sans-serif">${t}</text>
</svg>`, r = `Cluster of ${t} markers`, s = Number(google.maps.Marker.MAX_ZINDEX) + t;
    if (ai.isAdvancedMarkerAvailable(o)) {
      const d = document.createElement("div");
      d.innerHTML = a;
      const y = d.firstElementChild;
      y.setAttribute("transform", "translate(0 25)");
      const u = {
        map: o,
        position: n,
        zIndex: s,
        title: r,
        content: y
      };
      return new google.maps.marker.AdvancedMarkerElement(u);
    }
    const l = {
      position: n,
      zIndex: s,
      title: r,
      icon: {
        url: `data:image/svg+xml;base64,${btoa(a)}`,
        anchor: new google.maps.Point(25, 25)
      }
    };
    return new google.maps.Marker(l);
  }
}
function _Se(e, t) {
  for (let n in t.prototype)
    e.prototype[n] = t.prototype[n];
}
class lv {
  constructor() {
    _Se(lv, google.maps.OverlayView);
  }
}
var is;
(function(e) {
  e.CLUSTERING_BEGIN = "clusteringbegin", e.CLUSTERING_END = "clusteringend", e.CLUSTER_CLICK = "click";
})(is || (is = {}));
const MSe = (e, t, n) => {
  n.fitBounds(t.bounds);
};
class OSe extends lv {
  constructor({ map: t, markers: n = [], algorithmOptions: i = {}, algorithm: o = new LSe(i), renderer: a = new ASe(), onClusterClick: r = MSe }) {
    super(), this.markers = [...n], this.clusters = [], this.algorithm = o, this.renderer = a, this.onClusterClick = r, t && this.setMap(t);
  }
  addMarker(t, n) {
    this.markers.includes(t) || (this.markers.push(t), n || this.render());
  }
  addMarkers(t, n) {
    t.forEach((i) => {
      this.addMarker(i, !0);
    }), n || this.render();
  }
  removeMarker(t, n) {
    const i = this.markers.indexOf(t);
    return i === -1 ? !1 : (ai.setMap(t, null), this.markers.splice(i, 1), n || this.render(), !0);
  }
  removeMarkers(t, n) {
    let i = !1;
    return t.forEach((o) => {
      i = this.removeMarker(o, !0) || i;
    }), i && !n && this.render(), i;
  }
  clearMarkers(t) {
    this.markers.length = 0, t || this.render();
  }
  /**
   * Recalculates and draws all the marker clusters.
   */
  render() {
    const t = this.getMap();
    if (t instanceof google.maps.Map && t.getProjection()) {
      google.maps.event.trigger(this, is.CLUSTERING_BEGIN, this);
      const { clusters: n, changed: i } = this.algorithm.calculate({
        markers: this.markers,
        map: t,
        mapCanvasProjection: this.getProjection()
      });
      if (i || i == null) {
        const o = /* @__PURE__ */ new Set();
        for (const r of n)
          r.markers.length == 1 && o.add(r.markers[0]);
        const a = [];
        for (const r of this.clusters)
          r.marker != null && (r.markers.length == 1 ? o.has(r.marker) || ai.setMap(r.marker, null) : a.push(r.marker));
        this.clusters = n, this.renderClusters(), requestAnimationFrame(() => a.forEach((r) => ai.setMap(r, null)));
      }
      google.maps.event.trigger(this, is.CLUSTERING_END, this);
    }
  }
  onAdd() {
    this.idleListener = this.getMap().addListener("idle", this.render.bind(this)), this.render();
  }
  onRemove() {
    google.maps.event.removeListener(this.idleListener), this.reset();
  }
  reset() {
    this.markers.forEach((t) => ai.setMap(t, null)), this.clusters.forEach((t) => t.delete()), this.clusters = [];
  }
  renderClusters() {
    const t = new PSe(this.markers, this.clusters), n = this.getMap();
    this.clusters.forEach((i) => {
      i.markers.length === 1 ? i.marker = i.markers[0] : (i.marker = this.renderer.render(i, t, n), i.markers.forEach((o) => ai.setMap(o, null)), this.onClusterClick && i.marker.addListener(
        "click",
        /* istanbul ignore next */
        (o) => {
          google.maps.event.trigger(this, is.CLUSTER_CLICK, i), this.onClusterClick(o, i, n);
        }
      )), ai.setMap(i.marker, n);
    });
  }
}
const Z1 = Object.values(is), BSe = Be({
  name: "MarkerCluster",
  props: {
    options: {
      type: Object,
      default: () => ({})
    }
  },
  emits: Z1,
  setup(e, { emit: t, expose: n, slots: i }) {
    const o = ge(), a = $t(Dr, ge()), r = $t(Rr, ge());
    return Bo(av, o), qe(
      a,
      () => {
        a.value && (o.value = ri(
          new OSe({
            map: a.value,
            // Better perf than the default `SuperClusterAlgorithm`. See:
            // https://github.com/googlemaps/js-markerclusterer/pull/640
            algorithm: new ISe(e.options.algorithmOptions ?? {}),
            ...e.options
          })
        ), Z1.forEach((s) => {
          var l;
          (l = o.value) == null || l.addListener(s, (d) => t(s, d));
        }));
      },
      {
        immediate: !0
      }
    ), Fa(() => {
      var s;
      o.value && ((s = r.value) == null || s.event.clearInstanceListeners(o.value), o.value.clearMarkers(), o.value.setMap(null));
    }), n({ markerCluster: o }), () => {
      var s;
      return (s = i.default) == null ? void 0 : s.call(i);
    };
  }
}), ESe = Be({
  inheritAttrs: !1,
  props: {
    options: {
      type: Object,
      required: !0
    }
  },
  setup(e, { slots: t, emit: n, expose: i }) {
    const o = ge(), a = Te(() => {
      var l;
      return (l = t.default) == null ? void 0 : l.call(t).some((d) => d.type !== Fx);
    }), r = Te(() => ({
      ...e.options,
      element: o.value
    })), s = Ws(jh, [], r, n);
    return i({
      customMarker: s
    }), { customMarkerRef: o, customMarker: s, hasSlotContent: a };
  }
}), DSe = {
  key: 0,
  class: "custom-marker-wrapper"
};
function RSe(e, t, n, i, o, a) {
  return e.hasSlotContent ? (E(), X("div", DSe, [
    oe("div", Ce({
      ref: "customMarkerRef",
      style: { cursor: e.$attrs.onClick ? "pointer" : void 0 }
    }, e.$attrs), [
      je(e.$slots, "default", {}, void 0, !0)
    ], 16)
  ])) : te("", !0);
}
const NSe = /* @__PURE__ */ ov(ESe, [["render", RSe], ["__scopeId", "data-v-2d2d343a"]]);
Be({
  name: "HeatmapLayer",
  props: {
    options: {
      type: Object,
      default: () => ({})
    }
  },
  setup(e) {
    const t = ge(), n = $t(Dr, ge()), i = $t(Rr, ge());
    return qe(
      [n, () => e.options],
      ([o, a], [r, s]) => {
        var l;
        const d = !uo(a, s) || n.value !== r;
        if (n.value && i.value && d) {
          const y = structuredClone(a);
          if (y.data && !(y.data instanceof i.value.MVCArray)) {
            const u = i.value.LatLng;
            y.data = (l = y.data) == null ? void 0 : l.map((m) => m instanceof u || "location" in m && (m.location instanceof u || m.location === null) ? m : "location" in m ? { ...m, location: new u(m.location) } : new u(m));
          }
          t.value ? t.value.setOptions(y) : t.value = ri(
            new i.value.visualization.HeatmapLayer({
              ...y,
              map: n.value
            })
          );
        }
      },
      { immediate: !0 }
    ), Fa(() => {
      t.value && t.value.setMap(null);
    }), { heatmapLayer: t };
  },
  render: () => null
});
var $Se = function e(t, n) {
  if (t === n)
    return !0;
  if (t && n && typeof t == "object" && typeof n == "object") {
    if (t.constructor !== n.constructor)
      return !1;
    var i, o, a;
    if (Array.isArray(t)) {
      if (i = t.length, i != n.length)
        return !1;
      for (o = i; o-- !== 0; )
        if (!e(t[o], n[o]))
          return !1;
      return !0;
    }
    if (t.constructor === RegExp)
      return t.source === n.source && t.flags === n.flags;
    if (t.valueOf !== Object.prototype.valueOf)
      return t.valueOf() === n.valueOf();
    if (t.toString !== Object.prototype.toString)
      return t.toString() === n.toString();
    if (a = Object.keys(t), i = a.length, i !== Object.keys(n).length)
      return !1;
    for (o = i; o-- !== 0; )
      if (!Object.prototype.hasOwnProperty.call(n, a[o]))
        return !1;
    for (o = i; o-- !== 0; ) {
      var r = a[o];
      if (!e(t[r], n[r]))
        return !1;
    }
    return !0;
  }
  return t !== t && n !== n;
};
const FSe = /* @__PURE__ */ en($Se);
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
function bL(e, t) {
  var n = {};
  for (var i in e)
    Object.prototype.hasOwnProperty.call(e, i) && t.indexOf(i) < 0 && (n[i] = e[i]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, i = Object.getOwnPropertySymbols(e); o < i.length; o++)
      t.indexOf(i[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, i[o]) && (n[i[o]] = e[i[o]]);
  return n;
}
class xr {
  static isAdvancedMarkerAvailable(t) {
    return google.maps.marker && t.getMapCapabilities().isAdvancedMarkersAvailable === !0;
  }
  static isAdvancedMarker(t) {
    return google.maps.marker && t instanceof google.maps.marker.AdvancedMarkerElement;
  }
  static setMap(t, n) {
    this.isAdvancedMarker(t) ? t.map = n : t.setMap(n);
  }
  static getPosition(t) {
    if (this.isAdvancedMarker(t)) {
      if (t.position) {
        if (t.position instanceof google.maps.LatLng)
          return t.position;
        if (t.position.lat && t.position.lng)
          return new google.maps.LatLng(t.position.lat, t.position.lng);
      }
      return new google.maps.LatLng(null);
    }
    return t.getPosition();
  }
  static getVisible(t) {
    return this.isAdvancedMarker(t) ? !0 : t.getVisible();
  }
}
class xL {
  constructor({ markers: t, position: n }) {
    this.markers = t, n && (n instanceof google.maps.LatLng ? this._position = n : this._position = new google.maps.LatLng(n));
  }
  get bounds() {
    if (this.markers.length === 0 && !this._position)
      return;
    const t = new google.maps.LatLngBounds(this._position, this._position);
    for (const n of this.markers)
      t.extend(xr.getPosition(n));
    return t;
  }
  get position() {
    return this._position || this.bounds.getCenter();
  }
  /**
   * Get the count of **visible** markers.
   */
  get count() {
    return this.markers.filter((t) => xr.getVisible(t)).length;
  }
  /**
   * Add a marker to the cluster.
   */
  push(t) {
    this.markers.push(t);
  }
  /**
   * Cleanup references and remove marker from map.
   */
  delete() {
    this.marker && (xr.setMap(this.marker, null), this.marker = void 0), this.markers.length = 0;
  }
}
const wL = (e, t, n, i) => {
  const o = kL(e.getBounds(), t, i);
  return n.filter((a) => o.contains(xr.getPosition(a)));
}, kL = (e, t, n) => {
  const { northEast: i, southWest: o } = HSe(e, t), a = zSe({ northEast: i, southWest: o }, n);
  return VSe(a, t);
}, jSe = (e, t) => {
  const i = (t.lat - e.lat) * Math.PI / 180, o = (t.lng - e.lng) * Math.PI / 180, a = Math.sin(i / 2), r = Math.sin(o / 2), s = a * a + Math.cos(e.lat * Math.PI / 180) * Math.cos(t.lat * Math.PI / 180) * r * r;
  return 6371 * (2 * Math.atan2(Math.sqrt(s), Math.sqrt(1 - s)));
}, HSe = (e, t) => ({
  northEast: t.fromLatLngToDivPixel(e.getNorthEast()),
  southWest: t.fromLatLngToDivPixel(e.getSouthWest())
}), zSe = ({ northEast: e, southWest: t }, n) => (e.x += n, e.y -= n, t.x -= n, t.y += n, { northEast: e, southWest: t }), VSe = ({ northEast: e, southWest: t }, n) => {
  const i = n.fromDivPixelToLatLng(t), o = n.fromDivPixelToLatLng(e);
  return new google.maps.LatLngBounds(i, o);
};
class GSe {
  constructor({ maxZoom: t = 16 }) {
    this.maxZoom = t;
  }
  /**
   * Helper function to bypass clustering based upon some map state such as
   * zoom, number of markers, etc.
   *
   * ```typescript
   *  cluster({markers, map}: AlgorithmInput): Cluster[] {
   *    if (shouldBypassClustering(map)) {
   *      return this.noop({markers})
   *    }
   * }
   * ```
   */
  noop({ markers: t }) {
    return WSe(t);
  }
}
class USe extends GSe {
  constructor(t) {
    var { viewportPadding: n = 60 } = t, i = bL(t, ["viewportPadding"]);
    super(i), this.viewportPadding = 60, this.viewportPadding = n;
  }
  calculate({ markers: t, map: n, mapCanvasProjection: i }) {
    return n.getZoom() >= this.maxZoom ? {
      clusters: this.noop({
        markers: t
      }),
      changed: !1
    } : {
      clusters: this.cluster({
        markers: wL(n, i, t, this.viewportPadding),
        map: n,
        mapCanvasProjection: i
      })
    };
  }
}
const WSe = (e) => e.map((n) => new xL({
  position: xr.getPosition(n),
  markers: [n]
}));
class YSe extends USe {
  constructor(t) {
    var { maxDistance: n = 4e4, gridSize: i = 40 } = t, o = bL(t, ["maxDistance", "gridSize"]);
    super(o), this.clusters = [], this.state = { zoom: -1 }, this.maxDistance = n, this.gridSize = i;
  }
  calculate({ markers: t, map: n, mapCanvasProjection: i }) {
    const o = { zoom: n.getZoom() };
    let a = !1;
    return this.state.zoom >= this.maxZoom && o.zoom >= this.maxZoom || (a = !FSe(this.state, o)), this.state = o, n.getZoom() >= this.maxZoom ? {
      clusters: this.noop({
        markers: t
      }),
      changed: a
    } : {
      clusters: this.cluster({
        markers: wL(n, i, t, this.viewportPadding),
        map: n,
        mapCanvasProjection: i
      })
    };
  }
  cluster({ markers: t, map: n, mapCanvasProjection: i }) {
    return this.clusters = [], t.forEach((o) => {
      this.addToClosestCluster(o, n, i);
    }), this.clusters;
  }
  addToClosestCluster(t, n, i) {
    let o = this.maxDistance, a = null;
    for (let r = 0; r < this.clusters.length; r++) {
      const s = this.clusters[r], l = jSe(s.bounds.getCenter().toJSON(), xr.getPosition(t).toJSON());
      l < o && (o = l, a = s);
    }
    if (a && kL(a.bounds, i, this.gridSize).contains(xr.getPosition(t)))
      a.push(t);
    else {
      const r = new xL({ markers: [t] });
      this.clusters.push(r);
    }
  }
}
var J1;
(function(e) {
  e.CLUSTERING_BEGIN = "clusteringbegin", e.CLUSTERING_END = "clusteringend", e.CLUSTER_CLICK = "click";
})(J1 || (J1 = {}));
var im = /* @__PURE__ */ ((e) => (e.Hybrid = "hybrid", e.Roadmap = "roadmap", e.Satellite = "satellite", e.Terrain = "terrain ", e))(im || {}), ou = /* @__PURE__ */ ((e) => (e.TopCenter = "TOP_CENTER", e.TopLeft = "TOP_LEFT", e.TopRight = "TOP_RIGHT", e.RightTop = "RIGHT_TOP", e.LeftCenter = "LEFT_CENTER", e.RightCenter = "RIGHT_CENTER", e.LeftBottom = "LEFT_BOTTOM", e.RightBottom = "RIGHT_BOTTOM", e.BottomCenter = "BOTTOM_CENTER", e.BottomLeft = "BOTTOM_LEFT", e.BottomRight = "BOTTOM_RIGHT", e))(ou || {});
const qSe = [
  {
    featureType: "administrative.country",
    elementType: "geometry.fill",
    stylers: [
      {
        color: "#73a22a"
      }
    ]
  },
  {
    featureType: "administrative.country",
    elementType: "labels.text.fill",
    stylers: [
      {
        color: "#5a6d78"
      }
    ]
  },
  {
    featureType: "administrative.land_parcel",
    elementType: "labels",
    stylers: [
      {
        visibility: "off"
      }
    ]
  },
  {
    featureType: "administrative.land_parcel",
    elementType: "labels.text",
    stylers: [
      {
        color: "#5a6d78"
      },
      {
        visibility: "simplified"
      }
    ]
  },
  {
    featureType: "administrative.locality",
    elementType: "labels.text",
    stylers: [
      {
        color: "#5a6d78"
      },
      {
        visibility: "simplified"
      }
    ]
  },
  {
    featureType: "administrative.neighborhood",
    elementType: "labels.text",
    stylers: [
      {
        color: "#5a6d78"
      },
      {
        visibility: "simplified"
      }
    ]
  },
  {
    featureType: "administrative.province",
    elementType: "geometry.stroke",
    stylers: [
      {
        color: "#73a22a"
      }
    ]
  },
  {
    featureType: "administrative.province",
    elementType: "labels.text",
    stylers: [
      {
        color: "#5a6d78"
      },
      {
        visibility: "simplified"
      }
    ]
  },
  {
    featureType: "poi",
    elementType: "labels.text",
    stylers: [
      {
        visibility: "off"
      }
    ]
  },
  {
    featureType: "poi.business",
    stylers: [
      {
        visibility: "off"
      }
    ]
  },
  {
    featureType: "poi.park",
    elementType: "labels.text",
    stylers: [
      {
        visibility: "off"
      }
    ]
  },
  {
    featureType: "road.arterial",
    elementType: "labels",
    stylers: [
      {
        visibility: "off"
      }
    ]
  },
  {
    featureType: "road.highway",
    elementType: "geometry.fill",
    stylers: [
      {
        color: "#ededed"
      }
    ]
  },
  {
    featureType: "road.highway",
    elementType: "geometry.stroke",
    stylers: [
      {
        color: "#e8c64d"
      }
    ]
  },
  {
    featureType: "road.highway",
    elementType: "labels",
    stylers: [
      {
        visibility: "off"
      }
    ]
  },
  {
    featureType: "road.local",
    stylers: [
      {
        visibility: "off"
      }
    ]
  },
  {
    featureType: "road.local",
    elementType: "labels",
    stylers: [
      {
        visibility: "off"
      }
    ]
  },
  {
    featureType: "water",
    elementType: "geometry.fill",
    stylers: [
      {
        color: "#9ed1d1"
      },
      {
        saturation: 20
      }
    ]
  },
  {
    featureType: "water",
    elementType: "labels.text",
    stylers: [
      {
        color: "#006366"
      },
      {
        saturation: -10
      },
      {
        visibility: "on"
      }
    ]
  }
], KSe = { class: "d-base-google-map" }, XSe = ["data-event_source", "data-event_title", "aria-label"], ZSe = ["data-event_source", "aria-label"], JSe = { class: "d-base-google-map__zoom" }, QSe = ["data-event_source", "aria-label"], eCe = ["data-event_source", "aria-label"], tCe = ["data-event_source", "data-event_component_name", "onFocus"], nCe = /* @__PURE__ */ Be({
  __name: "BaseGoogleMap",
  props: {
    positions: {
      type: Object,
      required: !0
    },
    center: {
      type: Object,
      default: void 0
    },
    active: {
      type: Object,
      default: void 0
    },
    zoom: {
      type: Number,
      default: 0
    },
    hoverPositionId: {
      type: String,
      default: void 0
    },
    hideSatelliteControl: {
      type: Boolean,
      default: !1
    },
    hideStreetViewControl: {
      type: Boolean,
      default: !1
    },
    apiKey: {
      type: String,
      default: "AIzaSyDqent3G70OGIkx3uZcXaFv1WnxGszMU4o"
    }
  },
  emits: ["mapLocationClick", "mapLocationFocus"],
  setup(e, { expose: t, emit: n }) {
    const i = e, { t: o } = Je(), a = ge(!1), r = ge(null), s = ge([]), l = ge(null), d = ge(Qe().pageName), y = n;
    t({ setZoom: (k) => {
      r.value.map.setZoom(k);
    } });
    const m = {
      onClusterClick: (k, A, $) => {
        const j = new google.maps.LatLngBounds();
        A.markers.forEach(
          (N) => j.extend(N.getPosition())
        ), $.moveCamera({
          center: A.position
        }), google.maps.event.addListenerOnce($, "idle", () => {
          $.fitBounds(j);
        }), On("Merged map marker", "Zoom");
      },
      algorithm: new YSe({
        gridSize: 40,
        maxDistance: 1e5,
        viewportPadding: 100
      }),
      renderer: {
        render: ({ markers: k, position: A }) => {
          const $ = {
            path: `M 48.00,86.09
          C 48.00,86.09 63.76,86.09 63.76,86.09
          63.76,86.09 48.00,101.85 48.00,101.85
          48.00,101.85 32.24,86.09 32.24,86.09
          32.24,86.09 48.00,86.09 48.00,86.09 Z
          M 48.00,0.05
          C 74.51,0.05 96.00,21.54 96.00,48.05
          96.00,48.05 96.00,48.05 96.00,48.05
          96.00,74.56 74.51,96.05 48.00,96.05
          48.00,96.05 48.00,96.05 48.00,96.05
          21.49,96.05 0.00,74.56 0.00,48.05
          0.00,48.05 0.00,48.05 0.00,48.05
          0.00,21.54 21.49,0.05 48.00,0.05
          48.00,0.05 48.00,0.05 48.00,0.05 Z`,
            fillColor: "#007d85",
            fillOpacity: 0.9,
            strokeWeight: 0,
            rotation: 0,
            scale: 0.575,
            anchor: new google.maps.Point(40, 100),
            labelOrigin: new google.maps.Point(47, 50)
          };
          return new google.maps.Marker({
            position: {
              lat: A.lat(),
              lng: A.lng()
            },
            label: {
              text: String(k.length),
              color: "#FCFCFD",
              fontSize: "18px",
              fontFamily: "DwsSlab",
              fontWeight: "700"
            },
            icon: $
          });
        }
      }
    };
    qe(
      () => r.value?.ready,
      (k) => {
        k && r.value.map.setOptions({
          styles: qSe
        });
      }
    );
    const h = Te(
      () => (k) => i.hoverPositionId && k ? i.hoverPositionId === k.id : !1
    ), c = Te(() => (k) => i.active ? i.active.id === k.id : !1), g = Te(
      () => (k) => i.active ? i.active.id !== k.id : !1
    ), v = (k, A) => {
      y("mapLocationClick", A);
    }, P = (k, A) => {
      y("mapLocationFocus", A);
    }, f = () => {
      r.value.map.setZoom(r.value.map.getZoom() + 1);
    }, S = () => {
      r.value.map.setZoom(r.value.map.getZoom() - 1);
    }, w = () => {
      const k = a.value ? im.Roadmap : im.Satellite;
      r.value.map.setMapTypeId(k), a.value = !a.value;
    }, x = () => {
      const k = {
        heading: 0,
        pitch: 0
      }, A = r.value.map.getStreetView();
      A.setPosition(i.center), A.setPov(k), A.setVisible(!0);
    };
    return (k, A) => {
      const $ = $e("BaseIcon");
      return E(), X("div", KSe, [
        ue(_(cSe), {
          ref_key: "mapRef",
          ref: r,
          "api-key": e.apiKey,
          class: "d-base-google-map__inner",
          center: e.center,
          zoom: e.zoom,
          "disable-default-ui": !0
        }, {
          default: Se(() => [
            ue(_(G1), {
              position: _(ou).BottomLeft
            }, {
              default: Se(() => [
                i.hideSatelliteControl ? te("", !0) : (E(), X("button", {
                  key: 0,
                  class: "d-base-google-map__control d-base-google-map__map-type",
                  "data-event_source": d.value,
                  "data-event_component_name": "Layers",
                  "data-event_title": a.value ? "Map view" : "Satellite view",
                  "aria-label": _(o)("baseGoogleMap.mapType"),
                  onClick: A[0] || (A[0] = (j) => w())
                }, [
                  ue($, {
                    "base-icon": _(H).LayerGroup,
                    "base-icon-size": _(at).S,
                    "base-icon-color": _(gt).Petrol45
                  }, null, 8, ["base-icon", "base-icon-size", "base-icon-color"])
                ], 8, XSe))
              ]),
              _: 1
            }, 8, ["position"]),
            ue(_(G1), {
              position: _(ou).RightBottom
            }, {
              default: Se(() => [
                i.hideStreetViewControl ? te("", !0) : (E(), X("button", {
                  key: 0,
                  class: "d-base-google-map__control d-base-google-map__street-view",
                  "data-event_source": d.value,
                  "data-event_component_name": "Street View",
                  "data-event_title": "Street view started",
                  "aria-label": _(o)("baseGoogleMap.streetView"),
                  onClick: A[1] || (A[1] = (j) => x())
                }, [
                  ue($, {
                    "base-icon": _(H).StreetView,
                    "base-icon-size": _(at).S,
                    "base-icon-color": _(gt).Petrol45
                  }, null, 8, ["base-icon", "base-icon-size", "base-icon-color"])
                ], 8, ZSe)),
                oe("div", JSe, [
                  oe("button", {
                    class: "d-base-google-map__control d-base-google-map__zoom-in",
                    "data-event_source": d.value,
                    "data-event_component_name": "Merged map marker",
                    "data-event_title": "Zoom in",
                    "aria-label": _(o)("baseGoogleMap.zoomIn"),
                    onClick: A[2] || (A[2] = (j) => f())
                  }, [
                    ue($, {
                      "base-icon": _(H).Plus,
                      "base-icon-size": _(at).S,
                      "base-icon-color": _(gt).Petrol45
                    }, null, 8, ["base-icon", "base-icon-size", "base-icon-color"])
                  ], 8, QSe),
                  oe("button", {
                    class: "d-base-google-map__control d-base-google-map__zoom-out",
                    "data-event_source": d.value,
                    "data-event_component_name": "Merged map marker",
                    "data-event_title": "Zoom out",
                    "aria-label": _(o)("baseGoogleMap.zoomOut"),
                    onClick: A[3] || (A[3] = (j) => S())
                  }, [
                    ue($, {
                      "base-icon": _(H).Minus,
                      "base-icon-size": _(at).S,
                      "base-icon-color": _(gt).Petrol45
                    }, null, 8, ["base-icon", "base-icon-size", "base-icon-color"])
                  ], 8, eCe)
                ])
              ]),
              _: 1
            }, 8, ["position"]),
            ue(_(BSe), {
              ref_key: "markerClusterRef",
              ref: l,
              options: m
            }, {
              default: Se(() => [
                (E(!0), X(Re, null, Ge(e.positions, (j, N) => (E(), fe(_(NSe), {
                  key: N,
                  ref_for: !0,
                  ref: (M) => s.value[N] = M,
                  tabindex: "0",
                  options: {
                    position: j,
                    anchorPoint: _(ou).BottomCenter
                  },
                  onClick: (M) => v(M, j),
                  onKeydown: Ze((M) => v(M, j), ["enter"])
                }, {
                  default: Se(() => [
                    oe("div", {
                      class: Pe(["d-base-google-map__marker", {
                        "d-base-google-map__marker--hover": h.value(j),
                        "d-base-google-map__marker--active": c.value(j),
                        "d-base-google-map__marker--inactive": g.value(j)
                      }]),
                      "data-event_source": d.value,
                      "data-event_component_name": j.name,
                      "data-event_title": "Focus marker / tile",
                      onFocus: (M) => P(M, j)
                    }, [
                      ue($, {
                        "base-icon": _(H).MapMarker,
                        "base-icon-size": _(at).Inherit,
                        "base-icon-color": _(gt).White,
                        alt: _(o)("baseGoogleMap.locationMarker") + ` ${j.name}`,
                        class: "d-base-action-menu__button--icon"
                      }, null, 8, ["base-icon", "base-icon-size", "base-icon-color", "alt"]),
                      A[4] || (A[4] = oe("div", { class: "d-base-google-map__marker--tippy" }, null, -1))
                    ], 42, tCe)
                  ]),
                  _: 2
                }, 1032, ["options", "onClick", "onKeydown"]))), 128))
              ]),
              _: 1
            }, 512)
          ]),
          _: 1
        }, 8, ["api-key", "center", "zoom"])
      ]);
    };
  }
});
const SL = /* @__PURE__ */ Fe(nCe, [["__scopeId", "data-v-e2ebf645"]]), iCe = { class: "d-property-card__content" }, aCe = {
  key: 1,
  class: "d-property-card__content-row"
}, oCe = {
  key: 2,
  class: "d-property-card__content-row"
}, rCe = {
  key: 3,
  class: "d-property-card__content-row"
}, sCe = {
  key: 1,
  class: "d-property-card__location"
}, lCe = /* @__PURE__ */ Be({
  __name: "PropertyCard",
  props: {
    model: {
      type: Object,
      required: !0
    },
    clickableLocation: {
      type: Boolean,
      default: !0
    },
    direction: {
      type: String,
      default: void 0
    }
  },
  emits: ["locationClick", "mouseover", "mouseleave"],
  setup(e, { expose: t, emit: n }) {
    const i = e, { t: o } = Je(), { pageName: a } = Qe(), { isTabletLandscapeAsync: r } = xt(), s = n, l = Te(() => !i.direction && r.value ? Ti.Row : Ti.Column), d = Te(() => ({
      contentUrl: "",
      title: i.model?.location,
      text: i.model?.location,
      isLocked: !1,
      target: "",
      isExternal: !1,
      linkType: yt.Javascript,
      tealiumTrackingModel: {
        eventSource: a,
        eventComponentName: "Location",
        eventTitle: i.model?.location
      }
    })), y = (c) => {
      c.preventDefault(), s("locationClick", i.model);
    }, u = () => {
      s("mouseover", i.model);
    }, m = () => {
      s("mouseleave", i.model);
    }, h = ge();
    return t({
      propertyCard: h
    }), (c, g) => {
      const v = $e("BaseImage"), P = $e("BaseHeading"), f = $e("BaseText"), S = $e("BaseLinkV2"), w = $e("BaseIcon");
      return e.model ? (E(), X("div", {
        key: 0,
        ref_key: "propertyCard",
        ref: h,
        class: "d-property-card"
      }, [
        ue(NC, {
          model: e.model.cardModel,
          direction: l.value,
          onMouseover: u,
          onMouseleave: m
        }, Qt({
          content: Se(() => [
            oe("div", iCe, [
              e.model.headline ? (E(), fe(P, {
                key: 0,
                "base-heading-type": _(ze).H3,
                class: "d-property-card__heading"
              }, {
                default: Se(() => [
                  Ve(Ie(e.model.headline), 1)
                ]),
                _: 1
              }, 8, ["base-heading-type"])) : te("", !0),
              e.model.marketValue ? (E(), X("div", aCe, [
                e.model.marketValueDate ? (E(), fe(f, {
                  key: 0,
                  text: `${_(o)("propertyGallery.marketValue")} ${e.model.marketValueDate}`,
                  "font-size": _(st).SixteenPx,
                  "text-color": _(dt).GreyBlue009,
                  "font-type": _(lt).DwsSlabBold
                }, null, 8, ["text", "font-size", "text-color", "font-type"])) : te("", !0),
                ue(f, {
                  text: e.model.marketValue,
                  "font-size": _(st).SixteenPx,
                  "text-color": _(dt).GreyBlue009,
                  "font-type": _(lt).DwsSans
                }, null, 8, ["text", "font-size", "text-color", "font-type"])
              ])) : te("", !0),
              e.model.acquisitionYear ? (E(), X("div", oCe, [
                ue(f, {
                  text: _(o)("propertyGallery.acquisitionYear"),
                  "font-size": _(st).SixteenPx,
                  "text-color": _(dt).GreyBlue009,
                  "font-type": _(lt).DwsSlabBold
                }, null, 8, ["text", "font-size", "text-color", "font-type"]),
                ue(f, {
                  text: e.model.acquisitionYear,
                  "font-size": _(st).SixteenPx,
                  "text-color": _(dt).GreyBlue009,
                  "font-type": _(lt).DwsSans
                }, null, 8, ["text", "font-size", "text-color", "font-type"])
              ])) : te("", !0),
              e.model.location ? (E(), X("div", rCe, [
                ue(f, {
                  text: _(o)("propertyGallery.location"),
                  "font-size": _(st).SixteenPx,
                  "text-color": _(dt).GreyBlue009,
                  "font-type": _(lt).DwsSlabBold
                }, null, 8, ["text", "font-size", "text-color", "font-type"]),
                e.clickableLocation ? (E(), fe(S, {
                  key: 0,
                  "link-model": d.value,
                  icon: _(H).MapMarker,
                  "is-copy-link": !0,
                  onClick: g[0] || (g[0] = (x) => y(x)),
                  onKeydown: [
                    g[1] || (g[1] = Ze((x) => y(x), ["space"])),
                    g[2] || (g[2] = Ze((x) => y(x), ["enter"]))
                  ]
                }, null, 8, ["link-model", "icon"])) : (E(), X("div", sCe, [
                  ue(f, {
                    text: e.model.location,
                    "font-size": _(st).SixteenPx,
                    "text-color": _(dt).GreyBlue009,
                    "font-type": _(lt).DwsSans
                  }, null, 8, ["text", "font-size", "text-color", "font-type"]),
                  ue(w, {
                    "base-icon": _(H).MapMarker,
                    "base-icon-size": _(at).Inherit,
                    "base-icon-color": _(gt).GreyBlue009,
                    class: ""
                  }, null, 8, ["base-icon", "base-icon-size", "base-icon-color"])
                ]))
              ])) : te("", !0)
            ])
          ]),
          _: 2
        }, [
          e.model.imageModel ? {
            name: "header",
            fn: Se(() => [
              ue(v, {
                model: e.model.imageModel,
                "aspect-ratio": _(on).TwoToOne
              }, null, 8, ["model", "aspect-ratio"])
            ]),
            key: "0"
          } : void 0
        ]), 1032, ["model", "direction"])
      ], 512)) : te("", !0);
    };
  }
});
const am = /* @__PURE__ */ Fe(lCe, [["__scopeId", "data-v-d74388a9"]]), cCe = {
  key: 0,
  class: "d-property-detail-page"
}, dCe = {
  key: 3,
  class: "d-property-detail-page__video-section__triangle--left"
}, uCe = {
  key: 5,
  class: "d-property-detail-page__video-section__triangle--right"
}, hCe = { key: 2 }, Q1 = 0, pCe = /* @__PURE__ */ Be({
  __name: "PropertyDetailPage",
  props: {
    model: {
      type: Object,
      required: !0
    },
    hideSatelliteControl: {
      type: Boolean,
      default: !1
    },
    hideStreetViewControl: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const t = e, { t: n } = Je(), { isDesktop: i, isMobileAsync: o } = xt(), a = ge(Qe().pageName), r = ge(Q1), s = ge(5), l = ge(5), d = async () => {
      r.value = Q1, s.value = s.value + l.value;
    }, y = Te(() => t.model.teaserSectionCards.slice(
      r.value,
      r.value + s.value
    )), u = () => ({
      title: n("propertyGallery.loadMore"),
      text: n("propertyGallery.loadMore"),
      contentUrl: "",
      isLocked: !1,
      target: "",
      isExternal: !1,
      linkType: yt.Javascript,
      tealiumTrackingModel: {
        eventComponentName: "Button",
        eventTitle: n("propertyGallery.loadMore"),
        eventSource: a.value
      }
    });
    return (m, h) => {
      const c = $e("BaseButtonV2");
      return e.model ? (E(), X("div", cCe, [
        ue(Vt, {
          id: "property-detail-page-header",
          class: "d-property-detail-page__header",
          "content-in-full-width": !_(i),
          "no-margin-bottom": !0
        }, {
          default: Se(() => [
            ue(Hke, {
              model: e.model.propertyTeaser
            }, null, 8, ["model"])
          ]),
          _: 1
        }, 8, ["content-in-full-width"]),
        e.model.introText ? (E(), fe(Vt, {
          key: 0,
          id: "property-detail-html-section",
          class: Pe(["d-property-detail-page__html-section", {
            "d-property-detail-page__html-section--keyfacts-available": e.model.keyfacts
          }]),
          "no-margin-bottom": !0
        }, {
          default: Se(() => [
            e.model.introText ? (E(), fe(ht, {
              key: 0,
              "html-text": e.model.introText
            }, null, 8, ["html-text"])) : te("", !0)
          ]),
          _: 1
        }, 8, ["class"])) : te("", !0),
        e.model.keyfacts ? (E(), fe(Vt, {
          key: 1,
          id: "property-detail-keyfacts-section",
          class: "d-property-detail-page__keyfacts",
          "no-margin-bottom": !0
        }, {
          default: Se(() => [
            ue(eSe, {
              model: e.model.keyfacts
            }, null, 8, ["model"])
          ]),
          _: 1
        })) : te("", !0),
        e.model.keyfacts ? (E(), fe(Vt, {
          key: 2,
          id: "property-detail-keyfacts-section-disclaimer",
          class: "d-property-detail-page__keyfacts__disclaimer",
          "no-margin-bottom": !0
        }, {
          default: Se(() => [
            e.model.disclaimerText ? (E(), fe(Na, {
              key: 0,
              text: e.model.disclaimerText
            }, null, 8, ["text"])) : te("", !0)
          ]),
          _: 1
        })) : te("", !0),
        e.model.videoItemHero ? (E(), X("div", dCe)) : te("", !0),
        e.model.videoItemHero ? (E(), fe(Vt, {
          key: 4,
          id: "property-detail-video-section",
          class: "d-property-detail-page__video-section",
          title: e.model.videoSectionHeadline,
          "title-alignment": _(zn).Top,
          "no-margin-bottom": !0
        }, {
          default: Se(() => [
            ue(dL, {
              class: "d-property-detail-page__video-section--player",
              "video-item-hero": e.model.videoItemHero,
              variant: _(Io).VariantB,
              "background-color": _(Zt).Transparent
            }, null, 8, ["video-item-hero", "variant", "background-color"])
          ]),
          _: 1
        }, 8, ["title", "title-alignment"])) : te("", !0),
        e.model.videoItemHero ? (E(), X("div", uCe)) : te("", !0),
        e.model.maps && e.model.maps.length > 0 ? (E(), fe(Vt, {
          key: 6,
          id: "property-detail-maps-section",
          class: "d-property-detail-page__map",
          "no-margin-bottom": !0,
          "no-margin": !0
        }, {
          default: Se(() => [
            e.model.headlineMaps ? (E(), fe(Ot, {
              key: 0,
              class: "d-property-detail-page__map--headline",
              "base-heading-type": _(ze).H2
            }, {
              default: Se(() => [
                Ve(Ie(e.model.headlineMaps), 1)
              ]),
              _: 1
            }, 8, ["base-heading-type"])) : te("", !0),
            e.model.introTextMaps ? (E(), fe(ht, {
              key: 1,
              class: "d-property-detail-page__map--intro-text",
              "html-text": e.model.introTextMaps
            }, null, 8, ["html-text"])) : te("", !0),
            ue(SL, {
              class: "d-property-detail-page__map--map-section",
              "hide-satellite-control": e.hideSatelliteControl,
              "hide-street-view-control": e.hideStreetViewControl,
              positions: e.model.maps,
              center: e.model.maps[0],
              zoom: 13,
              "api-key": e.model.apiKey
            }, null, 8, ["hide-satellite-control", "hide-street-view-control", "positions", "center", "api-key"])
          ]),
          _: 1
        })) : te("", !0),
        e.model.teaserSectionCards ? (E(), fe(Vt, {
          key: 7,
          id: "property-detail-teaser-section",
          class: "d-property-detail-page__teaser",
          "no-margin-bottom": !0,
          "no-margin": !0
        }, {
          default: Se(() => [
            e.model.teaserSectionHeadline ? (E(), fe(Ot, {
              key: 0,
              "base-heading-type": _(ze).H2,
              class: "d-property-detail-page__teaser-headline"
            }, {
              default: Se(() => [
                Ve(Ie(e.model.teaserSectionHeadline), 1)
              ]),
              _: 1
            }, 8, ["base-heading-type"])) : te("", !0),
            !_(o) && e.model.teaserSectionCards?.length > 0 ? (E(), fe($g, {
              key: 1,
              items: e.model.teaserSectionCards,
              "num-visible": _(i) ? 3 : 2,
              "num-scroll": 1,
              "stretch-items": !0,
              "show-buttons": !1,
              "more-link": e.model.teaserSectionMoreLink,
              "cut-after-ten-items": !0
            }, {
              item: Se((g) => [
                ue(am, {
                  model: g.item,
                  "clickable-location": !1,
                  direction: _(Ti).Row,
                  class: Pe(["d-property-detail-page__card", {
                    "d-property-detail-page__card--full-width": e.model.teaserSectionCards?.length < 3
                  }])
                }, null, 8, ["model", "direction", "class"])
              ]),
              _: 1
            }, 8, ["items", "num-visible", "more-link"])) : te("", !0),
            _(o) ? (E(), X("div", hCe, [
              e.model.teaserSectionCards?.length > 0 ? (E(), fe(Mh, { key: 0 }, {
                default: Se(() => [
                  (E(!0), X(Re, null, Ge(y.value, (g, v) => (E(), fe(_(pa), { key: v }, {
                    default: Se(() => [
                      ue(am, {
                        model: g,
                        "clickable-location": !1,
                        direction: _(Ti).Row
                      }, null, 8, ["model", "direction"])
                    ]),
                    _: 2
                  }, 1024))), 128))
                ]),
                _: 1
              })) : te("", !0),
              y.value?.length < t.model.teaserSectionCards?.length ? (E(), fe(c, {
                key: 1,
                type: _(Ke).Primary,
                size: _(et).Large,
                icon: _(H).AngleDoubleDown,
                "icon-position": _(ct).Right,
                "link-model": u(),
                class: "d-property-detail-page__load-more",
                onClick: d
              }, null, 8, ["type", "size", "icon", "icon-position", "link-model"])) : te("", !0)
            ])) : te("", !0)
          ]),
          _: 1
        })) : te("", !0)
      ])) : te("", !0);
    };
  }
});
const lEe = /* @__PURE__ */ Fe(pCe, [["__scopeId", "data-v-c974df84"]]), fCe = {
  key: 0,
  class: "d-property-gallery-page-results"
}, mCe = { class: "d-property-gallery-page-results__results" }, gCe = {
  key: 0,
  class: "d-property-gallery-page-results__load-more"
}, Op = 0, vCe = /* @__PURE__ */ Be({
  __name: "PropertyGalleryPageResults",
  props: {
    results: {
      type: Object,
      default: void 0
    },
    scrollTo: {
      type: Object,
      default: void 0
    }
  },
  emits: [
    "SortByChanged",
    "locationClick",
    "cardHoverStart",
    "cardHoverEnd"
  ],
  setup(e, { expose: t, emit: n }) {
    const i = e, { t: o } = Je(), { isDesktop: a, isMobile: r, isMobileAsync: s, isTablet: l } = xt(), d = Te(() => {
      const B = [
        {
          name: o("sortOptions.nameAsc"),
          value: "headline-asc",
          isSelected: !0
        },
        {
          name: o("sortOptions.nameDesc"),
          value: "headline-desc",
          isSelected: !1
        },
        {
          name: o("sortOptions.acquisitionYearAsc"),
          value: "acquisitionYear-asc",
          isSelected: !1
        },
        {
          name: o("sortOptions.acquisitionYearDesc"),
          value: "acquisitionYear-desc",
          isSelected: !1
        }
      ];
      return i.results.some(
        (O) => O.marketValueSortValue != null
      ) && B.splice(
        2,
        0,
        {
          name: o("sortOptions.priceAsc"),
          value: "marketValueSortValue-asc",
          isSelected: !1
        },
        {
          name: o("sortOptions.priceDesc"),
          value: "marketValueSortValue-desc",
          isSelected: !1
        }
      ), B;
    }), y = ge(Qe().pageName), u = ge(
      d.value.filter((B) => B.isSelected)?.[0]
    ), m = ge(
      u.value.value.split("-")[1]
    ), h = ge(u.value.value.split("-")[2] === "asc"), c = ge(), g = ge([]), v = n, P = () => {
      w.value = Op, x.value = i.results?.length || 0;
    }, f = async (B) => {
      if (await mt(), Ue) {
        const T = document.getElementById(B.id);
        T ? setTimeout(() => {
          r.value ? T.scrollIntoView({ behavior: "smooth", block: "center" }) : c.value.scrollTo({
            top: T.offsetTop - 150,
            behavior: "smooth"
          });
        }, 100) : (P(), await mt(), f(B));
      }
    }, S = Te(() => r.value ? 5 : i.results?.length || 0), w = ge(Op), x = ge(S.value), k = ge(S.value), A = (B, T) => {
      const O = B[m.value], I = T[m.value];
      return h.value ? O < I ? -1 : 1 : O > I ? -1 : 1;
    }, $ = ge(i.results?.sort(A)), j = Te(() => $.value?.slice(
      w.value,
      w.value + x.value
    )), N = () => {
      x.value = S.value;
    }, M = () => {
      w.value = Op, x.value = x.value + k.value;
    }, D = async (B) => {
      const T = B.value.split("-");
      m.value = T[0], T.length > 1 && T[1] === "asc" ? h.value = !0 : h.value = !1, u.value = B, v("SortByChanged", B);
    }, C = (B) => {
      v("locationClick", B);
    }, b = (B) => {
      v("cardHoverStart", B);
    }, p = (B) => {
      v("cardHoverEnd", B);
    }, L = () => ({
      title: o("propertyGallery.loadMore"),
      text: o("propertyGallery.loadMore"),
      contentUrl: "",
      isLocked: !1,
      target: "",
      isExternal: !1,
      linkType: yt.Javascript,
      tealiumTrackingModel: {
        eventComponentName: "Button",
        eventTitle: o("propertyGallery.loadMore"),
        eventSource: y.value
      }
    });
    return qe([a, l, r], () => {
      N(), k.value = S.value;
    }), qe(
      () => u.value,
      () => {
        $.value = i.results?.sort(A);
      }
    ), qe(
      () => i.results,
      (B) => {
        $.value = B?.sort(A);
      }
    ), t({ scrollToProperty: f, resultsRef: g }), (B, T) => {
      const O = $e("BaseText");
      return i.results ? (E(), X("div", fCe, [
        oe("div", mCe, [
          ue(aT, {
            results: i.results?.length,
            "number-of-result-text": {
              oneResultText: _(o)("propertyGallery.resultText"),
              multipleResultsText: _(o)("propertyGallery.resultsText")
            },
            "show-grid-first": !0,
            "hide-buttons": !0
          }, {
            header: Se(() => [
              ue(O, {
                id: "sortByLabel",
                text: _(o)("sortOptions.sortByLabel"),
                "font-size": _(st).FourteenPx,
                "text-color": _(dt).GreyBlue009,
                "font-type": _(lt).DwsSlabBold,
                class: "d-property-gallery-page-results__sort-label"
              }, null, 8, ["text", "font-size", "text-color", "font-type"]),
              ue(vi, {
                items: d.value,
                "dropdown-type": _(Gt).Simple,
                "has-filter": !1,
                "show-image": !1,
                selected: u.value,
                "event-component-name": "Sort by",
                "event-title": `Sorting | ${u.value.name}`,
                "aria-labelledby": "sortByLabel",
                onSelectedItemChanged: D
              }, null, 8, ["items", "dropdown-type", "selected", "event-title"])
            ]),
            grid: Se(() => [
              oe("div", {
                ref_key: "listRef",
                ref: c,
                class: "d-property-gallery-page-results__list"
              }, [
                (E(!0), X(Re, null, Ge(j.value, (I, R) => (E(), fe(am, {
                  id: I.id,
                  ref_for: !0,
                  ref: (Y) => g.value[R] = Y,
                  key: R,
                  model: I,
                  onLocationClick: C,
                  onMouseover: b,
                  onMouseleave: p
                }, null, 8, ["id", "model"]))), 128))
              ], 512)
            ]),
            _: 1
          }, 8, ["results", "number-of-result-text"])
        ]),
        _(s) && i.results?.length > 5 ? (E(), X("div", gCe, [
          j.value?.length < i.results?.length ? (E(), fe(vt, {
            key: 0,
            type: _(Ke).Primary,
            size: _(et).Large,
            icon: _(H).AngleDoubleDown,
            "icon-position": _(ct).Right,
            "link-model": L(),
            onClick: M
          }, null, 8, ["type", "size", "icon", "icon-position", "link-model"])) : te("", !0)
        ])) : te("", !0)
      ])) : te("", !0);
    };
  }
});
const yCe = /* @__PURE__ */ Fe(vCe, [["__scopeId", "data-v-4dba17ef"]]), bCe = {
  key: 0,
  class: "d-property-gallery-page-result-view__gallery"
}, xCe = {
  key: 0,
  class: "d-property-gallery-page-result-view__map"
}, wCe = /* @__PURE__ */ Be({
  __name: "PropertyGalleryPageResultView",
  props: {
    results: {
      type: Object,
      required: !0
    },
    showMap: {
      type: Boolean,
      default: !0
    },
    hideSatelliteControl: {
      type: Boolean,
      default: !1
    },
    hideStreetViewControl: {
      type: Boolean,
      default: !1
    },
    apiKey: {
      type: String,
      default: void 0,
      required: !1
    }
  },
  emits: [
    "SortByChanged",
    "locationClick",
    "mapLocationClick",
    "mapLocationFocus",
    "cardHoverStart",
    "cardHoverEnd"
  ],
  setup(e, { expose: t, emit: n }) {
    const { isMobile: i } = xt(), o = e, a = (k) => {
      if (k)
        return {
          id: k.id,
          name: k.location,
          lat: k.lat,
          lng: k.lng
        };
    }, r = ti(), s = ge(), l = ge(), d = ge(), y = ge(
      o.results && o.results.length > 0 ? a(o.results[0]) : void 0
    ), u = n, m = Te(() => o.results?.map((k) => a(k))), h = async (k) => {
      u("SortByChanged", k);
    }, c = (k) => {
      P(k), x(k), u("locationClick", k);
    }, g = (k) => {
      const A = o.results?.find(($) => $.id === k.id);
      l.value = A, y.value = a(A), s.value?.scrollToProperty(A), P(A), u("mapLocationClick", k);
    }, v = (k) => {
      const A = o.results?.find(($) => $.id === k.id);
      l.value = A, y.value = a(A), s.value?.scrollToProperty(A), u("mapLocationFocus", k);
    }, P = (k) => {
      f(), s.value?.resultsRef?.forEach((A) => {
        A.propertyCard.id === k.id && A.propertyCard.classList.add("d-property-card--focused");
      });
    }, f = () => {
      s.value?.resultsRef?.forEach((k) => {
        k.propertyCard.classList.remove("d-property-card--focused");
      });
    }, S = (k) => {
      d.value = k, u("cardHoverStart", k);
    }, w = (k) => {
      d.value === k && (d.value = void 0), u("cardHoverEnd", k);
    }, x = (k) => {
      l.value = k, y.value = a(k), r.value?.setZoom(10);
    };
    return t({ focusPropertyOnMap: x }), (k, A) => e.results ? (E(), X("div", bCe, [
      ue(yCe, {
        ref_key: "resultsRef",
        ref: s,
        class: Pe(["d-property-gallery-page-result-view__result-view", {
          container: _(i),
          "d-property-gallery-page-result-view__result-view--no-margin": e.results.length == 0
        }]),
        results: e.results,
        onLocationClick: c,
        onSortByChanged: h,
        onCardHoverStart: S,
        onCardHoverEnd: w
      }, null, 8, ["class", "results"]),
      e.showMap ? (E(), X("div", xCe, [
        ue(SL, {
          ref_key: "mapRef",
          ref: r,
          positions: m.value,
          center: y.value,
          active: a(l.value),
          zoom: 4,
          "hide-satellite-control": e.hideSatelliteControl,
          "hide-street-view-control": e.hideStreetViewControl,
          "hover-position-id": d.value?.id,
          "api-key": e.apiKey,
          onMapLocationClick: g,
          onMapLocationFocus: v
        }, null, 8, ["positions", "center", "active", "hide-satellite-control", "hide-street-view-control", "hover-position-id", "api-key"])
      ])) : te("", !0)
    ])) : te("", !0);
  }
});
const Bp = /* @__PURE__ */ Fe(wCe, [["__scopeId", "data-v-3f49a5de"]]), _r = /* @__PURE__ */ Be({
  __name: "TabContent",
  props: {
    header: {
      type: String,
      default: null
    },
    locked: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    return (t, n) => je(t.$slots, "default");
  }
}), kCe = { class: "d-tab-container grid grid-cols-1 xl:grid-cols-4" }, SCe = {
  key: 0,
  class: "d-tab-container__intro-text col-span-1 xl:col-span-4"
}, CCe = { class: "d-tab-container-border" }, TCe = { class: "d-tab-container__content xs:col-span-1 xl:col-span-4" }, LCe = /* @__PURE__ */ Be({
  __name: "TabContainer",
  props: {
    introText: {
      type: String,
      default: null
    },
    eventComponentName: {
      type: String,
      default: "TabControl"
    },
    trackingDropdownName: {
      type: String,
      default: "TabControlDropdown"
    },
    selectedTab: {
      type: Number,
      default: 0
    },
    isDropdownInMobile: {
      type: Boolean,
      default: !0
    }
  },
  emits: ["tabHasChanged"],
  setup(e, { expose: t, emit: n }) {
    const i = e, { isMobile: o } = xt(), { t: a } = Je(), r = Jt(), { pageName: s } = Qe(), l = ge(), d = ge(0), y = ge(i.selectedTab), u = ge(i.selectedTab), m = ge(), h = ge(), c = ge([]);
    it(() => {
      $();
    }), ws(() => {
      g(i.selectedTab);
    });
    const g = (C) => {
      const b = v(), p = S(b[C]), L = w(b);
      m.value = b && !p ? b[C] : L[0], u.value = b.indexOf(m.value), y.value = u.value, c.value = x(), h.value = p ? c.value[u.value] : c.value[C];
    }, v = () => (r?.default ? r.default() : null)?.reduce(
      (C, b) => (P(b) ? C.push(b) : b?.children && b?.children instanceof Array && b?.children?.forEach((p) => {
        P(p) && C.push(p);
      }), C?.length > 1 ? C.filter((p) => p.props?.header !== "") : C),
      []
    ), P = (C) => C?.type === _r, f = (C) => C?.props?.header, S = (C) => C?.props?.locked, w = (C) => C.filter((b) => !b.props?.locked), x = () => {
      const C = v(), b = ge(0), p = [];
      return C ? C.reduce((L, B) => (L.push(
        N(
          B,
          b.value === u.value,
          S(B),
          b.value
        )
      ), b.value++, L), []) : p;
    }, k = n, A = (C) => {
      const b = M(C), p = S(b);
      p ? (u.value = y.value, h.value = c.value[y.value], c.value.forEach((L) => L.isSelected = !1), c.value[y.value].isSelected = !0, d.value += 1) : (m.value = b, h.value = c.value[+C.value], u.value = +C.value, y.value = +C.value), k("tabHasChanged", +C.value, {
        isLocked: p,
        header: f(b),
        index: +C.value
      });
    }, $ = async () => {
      await mt(), Ue && l.value?.$el?.querySelector('a[aria-selected="true"]')?.setAttribute("tabindex", "-1");
    }, j = (C) => {
      const b = M({
        value: C.index.toString(),
        name: "",
        isSelected: !0
      }), p = S(b);
      p ? (u.value = y.value, h.value = c.value[u.value]) : (m.value = b, u.value = C.index, y.value = C.index, h.value = c.value[C.index]), $(), k("tabHasChanged", C.index, {
        isLocked: p,
        header: f(b),
        index: C.index
      });
    }, N = (C, b, p, L) => ({
      name: f(C),
      value: L.toString(),
      isSelected: b,
      isLocked: p
    }), M = (C) => {
      const b = v(), p = parseInt(C.value);
      return b ? b[p] : void 0;
    }, D = (C) => {
      g(C);
    };
    return Vc && g(i.selectedTab), t({ selectTab: D }), (C, b) => {
      const p = $e("BaseText");
      return E(), X("div", kCe, [
        e.introText ? (E(), X("div", SCe, [
          ue(p, { text: e.introText }, null, 8, ["text"])
        ])) : te("", !0),
        v()?.length > 1 && _(o) && e.isDropdownInMobile ? (E(), fe(vi, {
          key: d.value,
          class: "d-tab-container__dropdown grid-cols-1 xl:col-span-4",
          items: c.value,
          selected: h.value,
          "event-component-name": e.trackingDropdownName,
          onSelectedItemChanged: A
        }, null, 8, ["items", "selected", "event-component-name"])) : te("", !0),
        v()?.length > 1 && !_(o) || !e.isDropdownInMobile ? (E(), X("div", {
          key: 2,
          class: Pe(["d-tab-container__tabs col-span-1 mr-4", {
            "xl:col-span-3": C.$slots.additionalContent,
            "xl:col-span-4": !C.$slots.additionalContent
          }])
        }, [
          ue(_(Hg), {
            ref_key: "tabView",
            ref: l,
            activeIndex: u.value,
            "onUpdate:activeIndex": b[0] || (b[0] = (L) => u.value = L),
            lazy: "",
            scrollable: "",
            onTabChange: j
          }, {
            default: Se(() => [
              (E(!0), X(Re, null, Ge(v(), (L, B) => (E(), fe(_(jg), { key: B }, {
                header: Se(() => [
                  oe("div", CCe, [
                    L !== void 0 && f(L)?.length > 0 ? (E(), fe(_(ki), {
                      key: 0,
                      label: f(L),
                      class: Pe(["p-button-rounded", [
                        u.value === B ? "active-tab" : "",
                        S(L) ? "locked-tab" : ""
                      ]]),
                      "data-event_source": _(s),
                      "data-event_component_name": e.eventComponentName,
                      "data-event_title": "Toggle | " + f(L),
                      "aria-label": f(L) + (S(L) ? _(a)("tabContainer.requiresLogin") : ""),
                      "aria-selected": u.value === B
                    }, null, 8, ["label", "class", "data-event_source", "data-event_component_name", "data-event_title", "aria-label", "aria-selected"])) : te("", !0)
                  ])
                ]),
                _: 2
              }, 1024))), 128))
            ]),
            _: 1
          }, 8, ["activeIndex"])
        ], 2)) : te("", !0),
        C.$slots.additionalContent ? (E(), X("div", {
          key: "additionalContent",
          class: Pe(["d-tab-container__additional-content", {
            "xl:col-span-1": v()?.length > 1,
            "xl:col-span-4": v()?.length <= 1
          }])
        }, [
          je(C.$slots, "additionalContent", {}, void 0, !0)
        ], 2)) : te("", !0),
        oe("div", TCe, [
          (E(), fe(tt(m.value)))
        ])
      ]);
    };
  }
});
const Hh = /* @__PURE__ */ Fe(LCe, [["__scopeId", "data-v-7590b260"]]), ICe = {
  key: 0,
  class: "d-property-gallery-page"
}, PCe = { class: "d-property-gallery-page__header container" }, ACe = {
  key: 0,
  class: "d-property-gallery-page__filter-section"
}, _Ce = { class: "d-property-gallery-page__filter-section" }, MCe = { class: "d-property-gallery-page__result-view" }, OCe = /* @__PURE__ */ Be({
  __name: "PropertyGalleryPage",
  props: {
    model: {
      type: Object,
      required: !0
    },
    hideSatelliteControl: {
      type: Boolean,
      default: !1
    },
    hideStreetViewControl: {
      type: Boolean,
      default: !1
    }
  },
  emits: [
    "filterValueChanged",
    "filterValueDeselected",
    "resetFilters",
    "SortByChanged",
    "locationClick",
    "mapLocationClick",
    "mapLocationFocus",
    "cardHoverStart",
    "cardHoverEnd"
  ],
  setup(e, { emit: t }) {
    const { isMobile: n } = xt(), { t: i } = Je(), o = ge(), a = ge(), r = ge(), s = t, l = (f) => {
      a.value?.selectTab(0), setTimeout(() => {
        r.value?.focusPropertyOnMap(f), n.value && P();
      }, 100), s("locationClick", f);
    }, d = (f) => {
      s("mapLocationClick", f);
    }, y = (f) => {
      s("mapLocationFocus", f);
    }, u = (f) => {
      s("cardHoverStart", f);
    }, m = (f) => {
      s("cardHoverEnd", f);
    }, h = async (f) => {
      s("SortByChanged", f);
    };
    async function c(f, S) {
      s("filterValueChanged", f, S);
    }
    function g(f, S) {
      s("filterValueDeselected", f, S);
    }
    function v() {
      s("resetFilters");
    }
    const P = async () => {
      await mt(), Ue && o.value?.scrollIntoView({ behavior: "smooth", block: "start" });
    };
    return (f, S) => {
      const w = $e("BaseHeading");
      return e.model ? (E(), X("div", ICe, [
        oe("div", PCe, [
          e.model.headline ? (E(), fe(w, {
            key: 0,
            "base-heading-type": _(ze).H1
          }, {
            default: Se(() => [
              Ve(Ie(e.model.headline), 1)
            ]),
            _: 1
          }, 8, ["base-heading-type"])) : te("", !0),
          e.model.introText ? (E(), fe(ht, {
            key: 1,
            "html-text": e.model.introText,
            class: "d-property-gallery-page__intro-text"
          }, null, 8, ["html-text"])) : te("", !0)
        ]),
        _(n) ? te("", !0) : (E(), X("div", ACe, [
          ue(Ec, {
            model: {
              topFilters: e.model.filters,
              componentNameForTracking: "Button"
            },
            class: "container",
            "component-name-tracking-multi-select": "filter dropdown",
            onFilterValueChanged: c,
            onFilterValueDeselected: g,
            onResetFilters: v
          }, null, 8, ["model"])
        ])),
        oe("div", {
          ref_key: "scrollToRef",
          ref: o
        }, null, 512),
        _(n) ? (E(), fe(Hh, {
          key: 1,
          ref_key: "tabContainer",
          ref: a,
          "is-dropdown-in-mobile": !1,
          class: "d-property-gallery-page__tab-control"
        }, {
          default: Se(() => [
            ue(_r, {
              header: _(i)("propertyGallery.map")
            }, {
              default: Se(() => [
                ue(Bp, {
                  ref_key: "propertyGalleryPageResultView",
                  ref: r,
                  results: e.model.results,
                  "hide-satellite-control": e.hideSatelliteControl,
                  "hide-street-view-control": e.hideStreetViewControl,
                  "api-key": e.model.apiKey,
                  onLocationClick: l,
                  onMapLocationClick: d,
                  onSortByChanged: h,
                  onCardHoverStart: u,
                  onCardHoverEnd: m
                }, null, 8, ["results", "hide-satellite-control", "hide-street-view-control", "api-key"])
              ]),
              _: 1
            }, 8, ["header"]),
            ue(_r, {
              header: _(i)("propertyGallery.filters")
            }, {
              default: Se(() => [
                oe("div", _Ce, [
                  ue(Ec, {
                    model: {
                      topFilters: e.model.filters,
                      componentNameForTracking: "Property-Gallery-Page"
                    },
                    class: "container",
                    onFilterValueChanged: c,
                    onFilterValueDeselected: g,
                    onResetFilters: v
                  }, null, 8, ["model"])
                ]),
                oe("div", MCe, [
                  ue(Bp, {
                    results: e.model.results,
                    "hide-satellite-control": e.hideSatelliteControl,
                    "hide-street-view-control": e.hideStreetViewControl,
                    "show-map": !1,
                    "api-key": e.model.apiKey,
                    onLocationClick: l,
                    onMapLocationClick: d,
                    onSortByChanged: h,
                    onCardHoverStart: u,
                    onCardHoverEnd: m
                  }, null, 8, ["results", "hide-satellite-control", "hide-street-view-control", "api-key"])
                ])
              ]),
              _: 1
            }, 8, ["header"])
          ]),
          _: 1
        }, 512)) : te("", !0),
        _(n) ? te("", !0) : (E(), fe(Bp, {
          key: 2,
          class: "container d-property-gallery-page-result-view__result-view--no-padding-right",
          results: e.model.results,
          "hide-satellite-control": e.hideSatelliteControl,
          "hide-street-view-control": e.hideStreetViewControl,
          "api-key": e.model.apiKey,
          onLocationClick: l,
          onMapLocationClick: d,
          onMapLocationFocus: y,
          onSortByChanged: h,
          onCardHoverStart: u,
          onCardHoverEnd: m
        }, null, 8, ["results", "hide-satellite-control", "hide-street-view-control", "api-key"]))
      ])) : te("", !0);
    };
  }
});
const BCe = /* @__PURE__ */ Fe(OCe, [["__scopeId", "data-v-1eed1244"]]), ECe = /* @__PURE__ */ Be({
  __name: "PropertyGalleryPage.container",
  props: {
    headline: {
      type: String,
      required: !0
    },
    introText: {
      type: String,
      required: !1,
      default: ""
    },
    hideSatelliteControl: {
      type: Boolean,
      default: !1
    },
    hideStreetViewControl: {
      type: Boolean,
      default: !1
    }
  },
  emits: [
    "filterValueChanged",
    "filterValueDeselected",
    "resetFilters",
    "SortByChanged",
    "locationClick",
    "mapLocationClick",
    "cardHoverStart",
    "cardHoverEnd"
  ],
  setup(e, { emit: t }) {
    const n = Nj(), i = t;
    async function o() {
      await n.onSearchCriteriaChanged({
        filters: n.filters,
        results: n.results
      }), i("filterValueChanged", n.filters);
    }
    const a = async (m) => {
      await n.onSearchCriteriaChanged({
        filters: n.filters,
        results: n.results
      }), i("SortByChanged", m);
    };
    async function r(m, h) {
      await n.onSearchCriteriaChanged({
        filters: n.filters,
        results: n.results
      }), n.deselectFilterOption(m, h), await o();
    }
    async function s() {
      await n.onSearchCriteriaChanged({
        filters: n.filters,
        results: n.results
      }), n.resetAllFilters();
    }
    const l = (m) => {
      i("locationClick", m);
    }, d = (m) => {
      i("mapLocationClick", m);
    }, y = (m) => {
      i("cardHoverStart", m);
    }, u = (m) => {
      i("cardHoverEnd", m);
    };
    return sn(() => {
      n.resetStore(), n.resetAllFilters();
    }), (m, h) => (E(), fe(BCe, {
      model: {
        headline: e.headline,
        introText: e.introText,
        filters: _(n).filters,
        results: _(n).results
      },
      "hide-satellite-control": e.hideSatelliteControl,
      "hide-street-view-control": e.hideStreetViewControl,
      onFilterValueChanged: o,
      onFilterValueDeselected: r,
      onResetFilters: s,
      onSortByChanged: a,
      onLocationClick: l,
      onMapLocationClick: d,
      onCardHoverStart: y,
      onCardHoverEnd: u
    }, null, 8, ["model", "hide-satellite-control", "hide-street-view-control"]));
  }
});
const cEe = /* @__PURE__ */ Fe(ECe, [["__scopeId", "data-v-926c33f2"]]);
var ru = /* @__PURE__ */ ((e) => (e.DocumentDownload = "document-download", e.InternalLink = "internal-link", e.ExternalLink = "external-link", e))(ru || {});
const DCe = /* @__PURE__ */ Be({
  __name: "LinkDropdown",
  props: {
    items: {
      type: Object,
      required: !0
    },
    placeholder: {
      type: String,
      required: !1,
      default: ""
    },
    downloadAnchor: {
      type: Object,
      required: !1,
      default: null
    }
  },
  setup(e) {
    const t = e, n = () => {
      const r = [];
      return t.items.map((s) => {
        r.push({
          name: s.name,
          value: s.url,
          isSelected: !1
        });
      }), r;
    }, i = (r) => {
      switch (t.items.find((l) => l.name === r).type) {
        case ru.DocumentDownload:
          return H.FileDownload;
        case ru.InternalLink:
          return H.Link;
        case ru.ExternalLink:
          return H.ExternalLinkAlt;
        default:
          return H.FileDownload;
      }
    }, o = $t("smoothScroll");
    function a(r) {
      if (Ue) {
        const s = document.getElementById(r.replace("#", ""));
        s && o({
          scrollTo: s || 0,
          duration: 1e3,
          updateHistory: !1
        });
      }
    }
    return (r, s) => (E(), fe(RC, {
      items: n(),
      placeholder: e.placeholder,
      "append-to": "self",
      class: "d-link-dropdown"
    }, {
      dropdownicon: Se(() => [
        ue(_t, {
          "base-icon": _(H).AngleDown
        }, null, 8, ["base-icon"])
      ]),
      value: Se((l) => [
        Ve(Ie(l.placeholder), 1)
      ]),
      option: Se((l) => [
        ue(ot, {
          "link-model": {
            text: l.option.name,
            href: l.option.value,
            target: "_blank",
            contentUrl: "",
            title: "",
            isLocked: !1,
            isExternal: !1,
            linkType: _(yt).Default,
            tealiumTrackingModel: {
              eventComponentName: "LinkDropdown",
              eventTitle: "Downloads | regular",
              eventSource: _(Qe)().pageName,
              eventTarget: `${l.option.name}`
            }
          },
          icon: i(l.option.name),
          "icon-position": _(ct).Left
        }, null, 8, ["link-model", "icon", "icon-position"])
      ]),
      footer: Se(() => [
        e.downloadAnchor ? (E(), fe(ot, {
          key: 0,
          class: "d-link-dropdown__anchor",
          "link-model": {
            text: e.downloadAnchor.name,
            href: e.downloadAnchor.href,
            target: "_self",
            contentUrl: "",
            title: "",
            isLocked: !1,
            isExternal: !1,
            linkType: _(yt).Anchor,
            tealiumTrackingModel: {
              eventComponentName: "LinkDropdown",
              eventTitle: "Downloads | regular | all",
              eventSource: _(Qe)().pageName,
              eventTarget: "Alle Dokumente"
            }
          },
          icon: _(H).ArrowDown,
          "icon-position": _(ct).Left,
          onClick: s[0] || (s[0] = (l) => a(e.downloadAnchor.href))
        }, null, 8, ["link-model", "icon", "icon-position"])) : te("", !0)
      ]),
      _: 1
    }, 8, ["items", "placeholder"]));
  }
});
const RCe = /* @__PURE__ */ Fe(DCe, [["__scopeId", "data-v-fb8f9ef1"]]), NCe = {
  key: 0,
  class: "d-search-result-item-teaser"
}, $Ce = /* @__PURE__ */ Be({
  __name: "SearchResultItemTeaser",
  props: {
    props: {
      type: Object,
      required: !0
    }
  },
  setup(e) {
    const t = og();
    return (n, i) => e.props ? (E(), X("div", NCe, [
      ue(ot, {
        "has-text": !1,
        "aria-label": e.props.headline,
        "link-model": e.props.linkUrl
      }, {
        container: Se(() => [
          ue(gi, {
            term: _(t).searchTermOfLastSearch
          }, {
            default: Se(() => [
              ue(co, {
                "teaser-box": e.props,
                layout: _(Rt).Full,
                "full-layout": _($a).OneToFour,
                "cta-element-type": _(cn).Link,
                "picture-rounded-corner": !0,
                "content-padding": !1,
                "render-h3": !0,
                "heading-type": _(ze).H3
              }, null, 8, ["teaser-box", "layout", "full-layout", "cta-element-type", "heading-type"])
            ]),
            _: 1
          }, 8, ["term"])
        ]),
        _: 1
      }, 8, ["aria-label", "link-model"])
    ])) : te("", !0);
  }
});
const FCe = /* @__PURE__ */ Fe($Ce, [["__scopeId", "data-v-bf361e75"]]), jCe = {
  key: 0,
  class: "d-search-result-item-product"
}, HCe = /* @__PURE__ */ Be({
  __name: "SearchResultItemProduct",
  props: {
    props: {
      type: Object,
      required: !0
    }
  },
  setup(e) {
    const t = og();
    return (n, i) => {
      const o = $e("BaseHeading"), a = $e("BaseText");
      return e.props ? (E(), X("div", jCe, [
        ue(ot, {
          "has-text": !1,
          "aria-label": e.props.headline,
          "link-model": e.props.linkUrl
        }, {
          container: Se(() => [
            ue(gi, {
              term: _(t).searchTermOfLastSearch
            }, {
              default: Se(() => [
                e.props.headline ? (E(), fe(o, {
                  key: 0,
                  "base-heading-type": _(ze).StyledAsH3,
                  class: "d-search-result-item-product__heading"
                }, {
                  default: Se(() => [
                    Ve(Ie(e.props.headline), 1)
                  ]),
                  _: 1
                }, 8, ["base-heading-type"])) : te("", !0)
              ]),
              _: 1
            }, 8, ["term"]),
            e.props.labels ? (E(), fe(Ar, {
              key: 0,
              model: e.props.labels,
              class: "d-search-result-item-product__list"
            }, null, 8, ["model"])) : te("", !0),
            ue(gi, {
              term: _(t).searchTermOfLastSearch
            }, {
              default: Se(() => [
                e.props.text ? (E(), fe(a, {
                  key: 0,
                  text: e.props.text,
                  "max-length": 200,
                  class: "d-search-result-item-product__text"
                }, null, 8, ["text"])) : te("", !0)
              ]),
              _: 1
            }, 8, ["term"]),
            e.props.linkUrl ? (E(), fe(ot, {
              key: 1,
              class: "d-search-result-item-product__text-link",
              "link-model": e.props.linkUrl,
              icon: _(H).ArrowRight
            }, null, 8, ["link-model", "icon"])) : te("", !0)
          ]),
          _: 1
        }, 8, ["aria-label", "link-model"])
      ])) : te("", !0);
    };
  }
});
const zCe = /* @__PURE__ */ Fe(HCe, [["__scopeId", "data-v-a16830ea"]]);
var mn = /* @__PURE__ */ ((e) => (e.Product = "product", e.Document = "asset", e.Article = "article", e.Other = "other", e.Faq = "faq", e.PressRelease = "press-release", e.Topic = "topic", e.Video = "video", e))(mn || {});
const VCe = {
  key: 0,
  class: "d-search-result-item"
}, GCe = /* @__PURE__ */ Be({
  __name: "SearchResultItem",
  props: {
    props: {
      type: Object,
      required: !0
    },
    type: {
      type: String,
      default: mn.Article
    }
  },
  setup(e) {
    const t = e, n = Te(() => {
      switch (t.type) {
        case mn.Product:
          return At(zCe, t);
        case mn.Article:
        case mn.Document:
        case mn.Other:
        case mn.Faq:
        case mn.PressRelease:
        case mn.Topic:
        case mn.Video:
          return At(FCe, t);
        default:
          return At("");
      }
    });
    return (i, o) => t ? (E(), X("div", VCe, [
      (E(), fe(tt(n.value)))
    ])) : te("", !0);
  }
}), UCe = {
  key: 0,
  class: "d-search-result-list-link"
}, WCe = /* @__PURE__ */ Be({
  __name: "SearchResultListLink",
  props: {
    link: {
      type: Object,
      default: void 0
    },
    linkCaption: {
      type: String,
      default: void 0
    }
  },
  setup(e) {
    return (t, n) => {
      const i = $e("BaseText");
      return e.link || e.linkCaption ? (E(), X("div", UCe, [
        e.linkCaption ? (E(), fe(i, {
          key: 0,
          text: e.linkCaption,
          "font-size": _(st).FourteenPx,
          "text-color": _(dt).GreyBlue008,
          "font-type": _(lt).DwsSans,
          class: "d-search-result-list-link__caption"
        }, null, 8, ["text", "font-size", "text-color", "font-type"])) : te("", !0),
        e.link ? (E(), fe(ot, {
          key: 1,
          "link-model": e.link,
          icon: _(H).ArrowRight
        }, null, 8, ["link-model", "icon"])) : te("", !0)
      ])) : te("", !0);
    };
  }
});
const ex = /* @__PURE__ */ Fe(WCe, [["__scopeId", "data-v-2f217ea6"]]);
var om = /* @__PURE__ */ ((e) => (e.CompleteList = "complete-list", e.Overview = "overview", e))(om || {});
const YCe = { class: "d-search-result-list__header" }, qCe = {
  key: 0,
  class: "d-search-result-list"
}, KCe = {
  key: 1,
  class: "d-search-result-list__footer"
}, tx = 0, XCe = /* @__PURE__ */ Be({
  __name: "SearchResultList",
  props: {
    props: {
      type: Object,
      required: !0
    }
  },
  emits: ["onShowAll", "pageChanged", "rowsPerPageChanged"],
  setup(e, { emit: t }) {
    const n = e, { t: i } = Je(), { isMobileAsync: o } = xt(), a = t, r = ge(tx), s = ge(tx), l = ge([15, 25, 30]), d = ge(15), y = Te(() => n.props.lazy ? n.props.items : n.props.items.slice(
      r.value,
      r.value + d.value
    )), u = Te(() => {
      const g = s.value * d.value + 1;
      let v = g - 1 + d.value;
      return v = v > n.props.totalItemsCount ? n.props.totalItemsCount : v, i("paginator.pageReportTemplate", {
        first: n.props.lazy ? g : "{first}",
        last: n.props.lazy ? v : "{last}",
        totalRecords: "{totalRecords}"
      });
    }), m = (g) => {
      r.value = g.first, d.value = g.rows, s.value = g.page, a("pageChanged", g);
    }, h = (g) => {
      r.value = g.first, d.value = g.rows, s.value = g.page, a("rowsPerPageChanged", g);
    }, c = () => {
      a("onShowAll");
    };
    return (g, v) => {
      const P = $e("BaseHeading"), f = $e("BaseText");
      return E(), fe(oo, null, {
        default: Se(() => [
          n.props && n.props.items ? (E(), X("div", {
            key: n.props.type,
            class: "d-search-result-list container"
          }, [
            oe("div", YCe, [
              n.props.headline ? (E(), fe(P, {
                key: 0,
                "base-heading-type": _(ze).StyledAsH2Section,
                class: "d-search-result-list__heading"
              }, {
                default: Se(() => [
                  Ve(Ie(n.props.headline), 1)
                ]),
                _: 1
              }, 8, ["base-heading-type"])) : te("", !0),
              _(o) ? te("", !0) : (E(), fe(ex, {
                key: 1,
                link: n.props.link,
                "link-caption": n.props.linkCaption
              }, null, 8, ["link", "link-caption"]))
            ]),
            n.props.items ? (E(), X("div", qCe, [
              (E(!0), X(Re, null, Ge(y.value, (S) => (E(), X("div", {
                key: S.headline,
                class: "d-search-result-list__item"
              }, [
                ue(GCe, {
                  props: S,
                  type: n.props.type
                }, null, 8, ["props", "type"])
              ]))), 128))
            ])) : te("", !0),
            n.props.items.length > 0 && (n.props.displayOption === _(om).CompleteList || n.props.showAllButton && n.props.totalItemsCount && n.props.totalItemsCount > 5 || _(o) && n.props.link && n.props.linkCaptionMobile) ? (E(), X("div", KCe, [
              n.props.displayOption === _(om).CompleteList ? (E(), fe(od, {
                key: 0,
                first: r.value,
                "total-records": n.props.lazy ? n.props.totalItemsCount : n.props.items.length,
                "rows-per-page-options": l.value,
                rows: d.value,
                "current-page-report-template": u.value,
                "event-source": "SearchResultPage",
                onPageChanged: m,
                onRowsPerPageChanged: h
              }, null, 8, ["first", "total-records", "rows-per-page-options", "rows", "current-page-report-template"])) : (E(), X(Re, { key: 1 }, [
                n.props.showAllButton && n.props.totalItemsCount && n.props.totalItemsCount > 5 ? (E(), fe(vt, {
                  key: 0,
                  class: "d-search-result-list__button",
                  "link-model": n.props.showAllButton,
                  icon: _(H).ArrowRight,
                  type: _(Ke).Primary,
                  size: _(et).Large,
                  "button-type": _(zt).Button,
                  onClick: v[0] || (v[0] = (S) => c())
                }, null, 8, ["link-model", "icon", "type", "size", "button-type"])) : te("", !0),
                _(o) ? (E(), fe(ex, {
                  key: 1,
                  link: n.props.link,
                  "link-caption": n.props.linkCaptionMobile,
                  class: "d-search-result-list__link"
                }, null, 8, ["link", "link-caption"])) : te("", !0)
              ], 64))
            ])) : te("", !0),
            n.props.items.length === 0 ? (E(), fe(f, {
              key: 2,
              text: _(i)("mediaReleases.noResults"),
              "font-size": _(st).SixteenPx,
              class: "d-search-result-list__no-results"
            }, null, 8, ["text", "font-size"])) : te("", !0)
          ])) : te("", !0)
        ]),
        _: 1
      });
    };
  }
});
const wo = /* @__PURE__ */ Fe(XCe, [["__scopeId", "data-v-0c5f2b26"]]), ZCe = {
  key: 0,
  class: "d-search-results"
}, JCe = /* @__PURE__ */ Be({
  __name: "SearchResults",
  props: {
    results: {
      type: Object,
      required: !0
    }
  },
  emits: ["onShowAll", "pageChanged", "rowsPerPageChanged"],
  setup(e, { emit: t }) {
    const n = e, i = t, o = (v, P) => v?.find((f) => f.type === P), a = ge(o(n.results, mn.Article)), r = ge(o(n.results, mn.Document)), s = ge(o(n.results, mn.Product)), l = ge(
      o(n.results, mn.Other)
    ), d = ge(o(n.results, mn.Faq)), y = ge(
      o(n.results, mn.PressRelease)
    ), u = ge(o(n.results, mn.Topic)), m = ge(o(n.results, mn.Video));
    qe(
      () => n.results,
      (v) => {
        s.value = {
          ...o(v, mn.Product)
        }, a.value = {
          ...o(v, mn.Article)
        }, r.value = {
          ...o(v, mn.Document)
        }, l.value = {
          ...o(v, mn.Other)
        }, d.value = { ...o(v, mn.Faq) }, y.value = {
          ...o(v, mn.PressRelease)
        }, u.value = { ...o(v, mn.Topic) }, m.value = { ...o(v, mn.Video) };
      },
      { deep: !0 }
    );
    const h = (v, P) => {
      i("pageChanged", v, P);
    }, c = (v, P) => {
      i("rowsPerPageChanged", v, P);
    }, g = async (v) => {
      i("onShowAll", v);
    };
    return (v, P) => n?.results ? (E(), X("div", ZCe, [
      s.value ? (E(), fe(wo, {
        key: 0,
        props: s.value,
        onOnShowAll: P[0] || (P[0] = (f) => g("products")),
        onPageChanged: P[1] || (P[1] = (f) => h(f, "products")),
        onRowsPerPageChanged: P[2] || (P[2] = (f) => c(f, "products"))
      }, null, 8, ["props"])) : te("", !0),
      a.value ? (E(), fe(wo, {
        key: 1,
        props: a.value,
        onOnShowAll: P[3] || (P[3] = (f) => g("articles")),
        onPageChanged: P[4] || (P[4] = (f) => h(f, "articles")),
        onRowsPerPageChanged: P[5] || (P[5] = (f) => c(f, "articles"))
      }, null, 8, ["props"])) : te("", !0),
      r.value ? (E(), fe(wo, {
        key: 2,
        props: r.value,
        onOnShowAll: P[6] || (P[6] = (f) => g("documents")),
        onPageChanged: P[7] || (P[7] = (f) => h(f, "documents")),
        onRowsPerPageChanged: P[8] || (P[8] = (f) => c(f, "documents"))
      }, null, 8, ["props"])) : te("", !0),
      l.value ? (E(), fe(wo, {
        key: 3,
        props: l.value,
        onOnShowAll: P[9] || (P[9] = (f) => g("other")),
        onPageChanged: P[10] || (P[10] = (f) => h(f, "other")),
        onRowsPerPageChanged: P[11] || (P[11] = (f) => c(f, "other"))
      }, null, 8, ["props"])) : te("", !0),
      d.value ? (E(), fe(wo, {
        key: 4,
        props: d.value,
        onOnShowAll: P[12] || (P[12] = (f) => g("faq")),
        onPageChanged: P[13] || (P[13] = (f) => h(f, "faq")),
        onRowsPerPageChanged: P[14] || (P[14] = (f) => c(f, "faq"))
      }, null, 8, ["props"])) : te("", !0),
      y.value ? (E(), fe(wo, {
        key: 5,
        props: y.value,
        onOnShowAll: P[15] || (P[15] = (f) => g("pressRelease")),
        onPageChanged: P[16] || (P[16] = (f) => h(f, "pressRelease")),
        onRowsPerPageChanged: P[17] || (P[17] = (f) => c(f, "pressRelease"))
      }, null, 8, ["props"])) : te("", !0),
      u.value ? (E(), fe(wo, {
        key: 6,
        props: u.value,
        onOnShowAll: P[18] || (P[18] = (f) => g("topic")),
        onPageChanged: P[19] || (P[19] = (f) => h(f, "topic")),
        onRowsPerPageChanged: P[20] || (P[20] = (f) => c(f, "topic"))
      }, null, 8, ["props"])) : te("", !0),
      m.value ? (E(), fe(wo, {
        key: 7,
        props: m.value,
        onOnShowAll: P[21] || (P[21] = (f) => g("video")),
        onPageChanged: P[22] || (P[22] = (f) => h(f, "video")),
        onRowsPerPageChanged: P[23] || (P[23] = (f) => c(f, "video"))
      }, null, 8, ["props"])) : te("", !0)
    ])) : te("", !0);
  }
});
const QCe = /* @__PURE__ */ Fe(JCe, [["__scopeId", "data-v-fa950a82"]]), eTe = { class: "d-search-result-filter" }, tTe = { class: "d-search-result-filter__title" }, nTe = /* @__PURE__ */ Be({
  __name: "SearchResultFilter",
  props: {
    title: {
      type: String,
      required: !0
    },
    filterBy: {
      type: Object,
      required: !0
    },
    eventSource: {
      type: String,
      default: ""
    },
    eventComponentName: {
      type: String,
      default: "SearchResultFilter"
    }
  },
  emits: ["selected-item-changed"],
  setup(e, { emit: t }) {
    const n = Pn(), i = t, o = e, { rootFontSize: a } = Hu(), r = ge(null), s = ge(!1), l = ge(!1), d = ge(
      o.filterBy.selectedItem
    ), y = () => {
      l.value = !1;
    }, u = () => {
      if (Ue) {
        const h = r?.value?.dropdownRef?.$el?.getBoundingClientRect()?.left || 0, c = r?.value?.dropdownRef?.overlay?.clientWidth || 0;
        s.value = h + c > window?.innerWidth - a.value * 0.25;
      }
      l.value = !0;
    }, m = (h) => {
      d.value?.value !== h.value && (d.value = h, i("selected-item-changed", d.value));
    };
    return (h, c) => (E(), X("div", eTe, [
      oe("div", tTe, [
        ue(Tt, {
          id: _(n),
          text: e.title,
          "font-size": _(st).TwelvePx,
          "text-color": _(dt).GreyBlue009,
          "font-type": _(lt).DwsSlabBold
        }, null, 8, ["id", "text", "font-size", "text-color", "font-type"])
      ]),
      oe("div", {
        class: Pe(["d-search-result-filter__dropdown", {
          "d-search-result-filter__dropdown--hide": !l.value,
          "d-search-result-filter__dropdown--right": s.value
        }])
      }, [
        ue(Oh, {
          ref_key: "filterDropdown",
          ref: r,
          model: {
            options: e.filterBy.options,
            selectedItem: d.value,
            componentName: e.eventComponentName,
            eventSource: e.eventSource
          },
          "aria-label": e.title,
          "aria-labelledby": _(n),
          "append-to": "self",
          onSelectedItemChanged: m,
          onShow: u,
          onHide: y
        }, null, 8, ["model", "aria-label", "aria-labelledby"])
      ], 2)
    ]));
  }
});
const nx = /* @__PURE__ */ Fe(nTe, [["__scopeId", "data-v-18cbc2bf"]]), iTe = {
  key: 0,
  class: "d-search-result-filter-section container"
}, aTe = { class: "d-search-result-filter-section__filters" }, oTe = { class: "d-search-result-filter-section__filters__filter" }, rTe = {
  key: 0,
  class: "d-search-result-filter-section__filters__singleFilter"
}, sTe = {
  key: 1,
  class: "d-search-result-filter-section__filters__singleFilter"
}, lTe = /* @__PURE__ */ Be({
  __name: "SearchResultFilterSection",
  props: {
    filters: {
      type: Object,
      required: !0
    }
  },
  emits: [
    "filter-value-changed",
    "filter-changed",
    "sort-changed"
  ],
  setup(e, { emit: t }) {
    const { t: n } = Je(), i = t, o = e, a = ge(
      o.filters?.filterBy?.selectedItem
    ), r = ge(
      o.filters?.sortBy?.selectedItem
    ), s = ge(o.filters?.filter), l = (u) => {
      s.value.filterOptions?.forEach(
        (m) => m.isSelected = !1
      ), s.value.name = u.name, s.value.results = u.results, s.value.filterOptions?.forEach((m) => {
        m.name === u.name && (m.isSelected = !0);
      }), i("filter-value-changed", u);
    }, d = (u) => {
      a.value?.value !== u.value && (a.value = u, i("filter-changed", a.value));
    }, y = (u) => {
      r.value?.value !== u.value && (r.value = u, i("sort-changed", r.value));
    };
    return qe(
      () => o.filters,
      (u) => {
        u && (s.value = u.filter, a.value = u.filterBy?.selectedItem, r.value = u.sortBy?.selectedItem);
      },
      { deep: !0 }
    ), (u, m) => o ? (E(), X("div", iTe, [
      oe("div", aTe, [
        oe("div", oTe, [
          e.filters.filter ? (E(), fe(Ah, {
            key: 0,
            filter: s.value,
            "event-component-name": "Search-Results-Page",
            onSingleSelectValueChanged: l
          }, null, 8, ["filter"])) : te("", !0)
        ]),
        m[0] || (m[0] = oe("div", { class: "d-search-result-filter-section__filters__spacer" }, null, -1)),
        e.filters.filterBy ? (E(), X("div", rTe, [
          ue(nx, {
            title: _(n)("searchResultPage.filterBy"),
            "filter-by": e.filters.filterBy,
            "event-source": "SearchResultPage",
            "event-component-name": "Search-Results | Filter by",
            onSelectedItemChanged: d
          }, null, 8, ["title", "filter-by"])
        ])) : te("", !0),
        e.filters.sortBy ? (E(), X("div", sTe, [
          ue(nx, {
            title: _(n)("searchResultPage.sortBy"),
            "filter-by": e.filters.sortBy,
            "event-source": "SearchResultPage",
            "event-component-name": "Search-Results | Sort by",
            onSelectedItemChanged: y
          }, null, 8, ["title", "filter-by"])
        ])) : te("", !0)
      ])
    ])) : te("", !0);
  }
});
const cTe = /* @__PURE__ */ Fe(lTe, [["__scopeId", "data-v-9d293806"]]), dTe = {
  key: 0,
  class: "d-search-result-page"
}, uTe = { class: "d-search-result-page__search-bar" }, hTe = { class: "d-search-result-page__headline__searchTerm" }, pTe = {
  key: 1,
  class: "d-search-result-page__filter"
}, fTe = { class: "d-search-result-page__results" }, mTe = /* @__PURE__ */ Be({
  __name: "SearchResultPage",
  emits: [
    "searchTerm",
    "tabChanged",
    "filterChanged",
    "sortChanged",
    "pageChanged",
    "rowsPerPageChanged"
  ],
  setup(e, { emit: t }) {
    const n = t, { t: i } = Je(), o = og(), a = Te(() => o.filters), r = ge(), s = ge(o.selectedTabIndex), l = ge({
      identifier: void 0,
      rowsPerPage: 15,
      page: 0
    });
    function d(w, x) {
      l.value.identifier = x, l.value.rowsPerPage = w.rows, l.value.page = w.page;
    }
    function y(w) {
      l.value.identifier = w, l.value.page = 0, l.value.rowsPerPage = 15;
    }
    const u = Te(() => ({
      headline: "",
      placeholder: i("searchResultPage.searchResultPagePlaceholder"),
      filterOptions: [],
      searchTerm: o.searchTerm,
      submitLinkModel: o.submitLinkModel
    })), m = Te(
      () => o.flyoutResults
    );
    async function h(w, x) {
      x !== $i.SearchTermClear && (o.searchTerm = w), x === $i.SearchTermEnter && (o.searchTermOfLastSearch = o.searchTerm), await o.onSearchCriteriaChanged({
        searchTerm: w,
        selectedTabIndex: s.value,
        filters: o.filters,
        eventType: x,
        lazyLoadEventData: l.value
      }), n("searchTerm", o.searchTerm, x);
    }
    const c = async (w) => {
      const x = o.filters.filter.filterOptions?.findIndex(
        (k) => k.identifier == w?.identifier
      );
      s.value = x, y(w.identifier), await o.onSearchCriteriaChanged({
        searchTerm: o.searchTerm,
        selectedTabIndex: s.value,
        filters: o.filters,
        eventType: $i.ActiveTabChanged,
        lazyLoadEventData: l.value
      }), await o.setNewSelectedFilter(w), n("tabChanged", w, x);
    }, g = async (w) => {
      await o.onSearchCriteriaChanged({
        searchTerm: o.searchTerm,
        selectedTabIndex: s.value,
        filters: {
          ...o.filters,
          filterBy: {
            ...o.filters.filterBy,
            selectedItem: w
          }
        },
        eventType: $i.FilterValueChanged,
        lazyLoadEventData: l.value
      }), n("filterChanged", w);
    }, v = async (w, x) => {
      d(w, x), await o.onSearchCriteriaChanged({
        searchTerm: o.searchTerm,
        selectedTabIndex: s.value,
        filters: o.filters,
        eventType: $i.PageChanged,
        lazyLoadEventData: l.value
      }), n("pageChanged", w, x);
    }, P = async (w, x) => {
      d(w, x), await o.onSearchCriteriaChanged({
        searchTerm: o.searchTerm,
        selectedTabIndex: s.value,
        filters: o.filters,
        eventType: $i.RowsPerPageChanged,
        lazyLoadEventData: l.value
      }), n("rowsPerPageChanged", w, x);
    }, f = async (w) => {
      await o.onSearchCriteriaChanged({
        searchTerm: o.searchTerm,
        selectedTabIndex: s.value,
        filters: {
          ...o.filters,
          sortBy: {
            ...o.filters.sortBy,
            selectedItem: w
          }
        },
        eventType: $i.SortValueChanged,
        lazyLoadEventData: l.value
      }), n("sortChanged", w);
    }, S = async (w) => {
      const x = o.filters.filter.filterOptions?.findIndex(
        (A) => A.identifier.toLocaleLowerCase() == w.toLocaleLowerCase()
      ), k = o.filters.filter.filterOptions?.find(
        (A) => A.identifier.toLocaleLowerCase() == w.toLocaleLowerCase()
      );
      s.value = x, o.setNewSelectedFilter(k), y(k.identifier), await o.onSearchCriteriaChanged({
        searchTerm: o.searchTerm,
        selectedTabIndex: s.value,
        filters: o.filters,
        eventType: $i.ShowAllTriggered,
        lazyLoadEventData: l.value
      }), Ue && r.value.$el.scrollIntoView({
        behavior: "smooth"
      }), n("tabChanged", k, x);
    };
    return sn(() => {
      o.$dispose();
    }), (w, x) => {
      const k = $e("BaseText");
      return _(o) ? (E(), X("div", dTe, [
        oe("div", uTe, [
          ue(Wo, {
            class: "container",
            "is-suppress-open-new-window-on-enter": "",
            model: u.value,
            result: m.value,
            "min-length": 1,
            "block-empty-enter-search": !0,
            "event-component-name": "search",
            onSearch: x[0] || (x[0] = (A) => h(
              A,
              _($i).SearchTermHasChanged
            )),
            onClear: x[1] || (x[1] = (A) => h("", _($i).SearchTermClear)),
            onEnter: x[2] || (x[2] = (A) => h(
              A,
              _($i).SearchTermEnter
            ))
          }, null, 8, ["model", "result"])
        ]),
        _(o).results && _(o).results.length > 0 && _(o).searchTermOfLastSearch ? (E(), fe(Ot, {
          key: 0,
          class: "d-search-result-page__headline container",
          "base-heading-type": _(ze).StyledAsH1
        }, {
          default: Se(() => [
            Ve(Ie(_(i)("searchResultPage.resultsFor")) + " ", 1),
            oe("span", hTe, "“" + Ie(_(o).searchTermOfLastSearch) + "”", 1)
          ]),
          _: 1
        }, 8, ["base-heading-type"])) : te("", !0),
        _(o).results?.length > 0 ? (E(), X("div", pTe, [
          a.value?.filter ? (E(), fe(cTe, {
            key: 0,
            ref_key: "searchResultFilterSection",
            ref: r,
            filters: a.value,
            onFilterValueChanged: c,
            onFilterChanged: g,
            onSortChanged: f
          }, null, 8, ["filters"])) : te("", !0)
        ])) : te("", !0),
        oe("div", fTe, [
          ue(QCe, {
            results: _(o).results,
            onOnShowAll: S,
            onPageChanged: v,
            onRowsPerPageChanged: P
          }, null, 8, ["results"])
        ]),
        _(o).results?.length === 0 ? (E(), fe(k, {
          key: 2,
          text: _(i)("mediaReleases.noResults"),
          "font-size": _(st).SixteenPx,
          class: "d-search-result-page__no-results container"
        }, null, 8, ["text", "font-size"])) : te("", !0)
      ])) : te("", !0);
    };
  }
});
const dEe = /* @__PURE__ */ Fe(mTe, [["__scopeId", "data-v-623a331a"]]), gTe = {
  key: 0,
  class: "d-archive-page-result-view"
}, vTe = { class: "d-archive-page-result-view__results" }, yTe = { key: 0 }, bTe = {
  key: 1,
  class: "d-archive-page-result-view__load-more"
}, ml = 0, xTe = /* @__PURE__ */ Be({
  __name: "ArchivePageResultView",
  props: {
    results: {
      type: Object,
      required: !0
    },
    renderH3: {
      type: Boolean,
      default: !1
    },
    showGridFirst: {
      type: Boolean,
      default: !1
    },
    totalItemsCount: {
      type: Number,
      default: 0
    },
    lazy: {
      type: Boolean,
      default: !1
    },
    noResultsText: {
      type: String,
      default: "No Content"
    }
  },
  emits: ["pageChanged", "rowsPerPageChanged", "loadMore"],
  setup(e, { expose: t, emit: n }) {
    const i = e, { t: o } = Je(), { isDesktopAsync: a, isDesktop: r, isMobile: s, isMobileAsync: l, isTablet: d } = xt(), y = ge(Qe().pageName), u = ge(i.showGridFirst), m = ge(i.results), h = n, c = () => ({
      page: P.value,
      first: v.value,
      rows: S.value
    });
    qe([r, d, s], () => {
      D(), w.value = g.value, s.value && i.lazy && h("pageChanged", c());
    });
    const g = Te(() => r.value ? 15 : d.value ? 6 : 5), v = ge(ml), P = ge(ml), f = ge([5, 15, 25, 50]), S = ge(g.value), w = ge(g.value), x = ge(!1), k = Te(() => i.lazy ? i.totalItemsCount : i.results?.length), A = Te(() => !f.value || f.value?.length === 0 ? !1 : k.value > f.value[0]);
    qe(
      () => i.results,
      (I) => {
        i.lazy && !r.value && x.value ? (x.value = !1, m.value = m.value?.concat(I)) : I ? m.value = I : m.value = [];
      },
      { immediate: !0 }
    );
    const $ = Te(() => i.lazy && r.value ? i.results : i.lazy && !r.value ? m.value : i.results.slice(
      v.value,
      v.value + S.value
    )), j = Te(() => {
      const I = P.value * S.value + 1;
      let R = I - 1 + S.value;
      return R = R > i.totalItemsCount ? i.totalItemsCount : R, o("paginator.pageReportTemplate", {
        first: i.lazy ? I : "{first}",
        last: i.lazy ? R : "{last}",
        totalRecords: "{totalRecords}"
      });
    }), N = (I) => {
      v.value = I.first, S.value = I.rows, P.value = I.page, h("pageChanged", I);
    }, M = (I) => {
      v.value = I.first, S.value = I.rows, P.value = I.page, h("rowsPerPageChanged", I);
    }, D = () => {
      P.value = ml, v.value = ml, S.value = g.value, m.value = [];
    };
    t({ resetRowsPerPage: D });
    const C = () => {
      P.value = P.value + 1, i.lazy ? (v.value = v.value + w.value, S.value = w.value) : (v.value = ml, S.value = S.value + w.value), x.value = !0, h("loadMore", c());
    }, b = () => ({
      title: o("archivePage.loadMore"),
      text: o("archivePage.loadMore"),
      contentUrl: "",
      isLocked: !1,
      target: "",
      isExternal: !1,
      linkType: yt.Javascript,
      tealiumTrackingModel: {
        eventComponentName: "Pagination",
        eventTitle: "load more",
        eventSource: y.value
      }
    }), p = (I) => {
      u.value = !I;
    }, L = Te(() => T(Rt.Full)), B = Te(() => T(Rt.OneThird)), T = (I) => ({
      noTeasersText: i.noResultsText,
      backgroundColor: Zt.White,
      layout: I,
      showDate: !0,
      showTags: !0,
      ctaElementType: I === Rt.OneThird ? cn.LinkCorner : cn.Link,
      teasers: O($.value, I)
    }), O = (I, R) => I.map((Y) => ({
      tag: "",
      model: {
        ...Y,
        linkUrl: {
          ...Y.linkUrl,
          tealiumTrackingModel: {
            eventSource: y.value,
            eventComponentName: "Result View",
            eventTitle: Rt.Full ? "List item" : "Tile item"
          }
        },
        pictureRoundedCorner: R === Rt.Full,
        fullLayoutImageAlignment: ev.Left,
        fullLayout: R === Rt.Full ? $a.OneToFour : $a.OneToTwo,
        color: R === Rt.Full ? Zt.White : Y.color
      }
    }));
    return (I, R) => e.results ? (E(), X("div", gTe, [
      oe("div", vTe, [
        _(l) ? (E(), X(Re, { key: 0 }, [
          ue(_h, {
            results: k.value,
            "number-of-result-text": {
              oneResultText: _(o)("globalTranslations.result"),
              multipleResultsText: _(o)("globalTranslations.results")
            }
          }, null, 8, ["results", "number-of-result-text"]),
          ue(ns, {
            model: L.value,
            "heading-type": e.renderH3 ? _(ze).H3 : void 0
          }, null, 8, ["model", "heading-type"])
        ], 64)) : (E(), fe(aT, {
          key: 1,
          results: k.value,
          "number-of-result-text": {
            oneResultText: _(o)("globalTranslations.result"),
            multipleResultsText: _(o)("globalTranslations.results")
          },
          "show-grid-first": u.value,
          onViewChanged: p
        }, {
          list: Se(() => [
            ue(ns, {
              model: L.value,
              "heading-type": e.renderH3 ? _(ze).H3 : void 0
            }, null, 8, ["model", "heading-type"])
          ]),
          grid: Se(() => [
            ue(ns, { model: B.value }, null, 8, ["model"])
          ]),
          _: 1
        }, 8, ["results", "number-of-result-text", "show-grid-first"]))
      ]),
      A.value ? (E(), X("div", yTe, [
        _(a) ? (E(), fe(od, {
          key: 0,
          first: v.value,
          "total-records": k.value,
          "rows-per-page-options": f.value,
          rows: S.value,
          "current-page-report-template": j.value,
          onRowsPerPageChanged: M,
          onPageChanged: N
        }, null, 8, ["first", "total-records", "rows-per-page-options", "rows", "current-page-report-template"])) : te("", !0),
        _(a) ? te("", !0) : (E(), X("div", bTe, [
          ue(vt, {
            disabled: $.value?.length >= k.value,
            type: _(Ke).Primary,
            size: _(et).Large,
            icon: _(H).AngleDoubleDown,
            "icon-position": _(ct).Right,
            "link-model": b(),
            onClick: C
          }, null, 8, ["disabled", "type", "size", "icon", "icon-position", "link-model"])
        ]))
      ])) : te("", !0)
    ])) : te("", !0);
  }
});
const wTe = /* @__PURE__ */ Fe(xTe, [["__scopeId", "data-v-bb33c1f0"]]), kTe = /* @__PURE__ */ Be({
  __name: "StickyFilterResultBar",
  props: {
    numberOfResults: {
      type: Number,
      required: !0
    },
    showFilterBar: {
      type: Boolean
    }
  },
  emits: ["scrollToAnchor"],
  setup(e, { emit: t }) {
    const { isMobile: n } = xt(), i = Qe().pageName, { t: o } = Je(), a = t, r = e, s = Te(() => `${r.numberOfResults} ${r.numberOfResults > 1 ? o("globalTranslations.results") : o("globalTranslations.result")}`);
    function l() {
      a("scrollToAnchor");
    }
    return (d, y) => _(n) ? (E(), X("div", {
      key: 0,
      class: Pe(["d-sticky-filter-result-bar", {
        "d-sticky-filter-result-bar--hide-filter-bar": !r.showFilterBar
      }])
    }, [
      r.showFilterBar ? (E(), fe(No, {
        key: 0,
        "tracking-model": {
          eventSource: _(i),
          eventComponentName: "Archive-Page",
          eventTitle: "back to top filter section"
        },
        text: _(o)("archivePage.filters"),
        icon: _(H).SlidersH,
        onClick: l
      }, null, 8, ["tracking-model", "text", "icon"])) : te("", !0),
      ue(Tt, {
        text: s.value,
        "font-size": _(st).SixteenPx,
        "font-type": _(lt).DwsSansBold
      }, null, 8, ["text", "font-size", "font-type"])
    ], 2)) : te("", !0);
  }
});
const STe = /* @__PURE__ */ Fe(kTe, [["__scopeId", "data-v-f81a9b89"]]), CTe = {
  key: 0,
  class: "d-archive-page"
}, TTe = {
  key: 0,
  class: "d-archive-page__filter-section"
}, LTe = { class: "d-archive-page__search" }, ITe = /* @__PURE__ */ Be({
  __name: "ArchivePage",
  props: {
    model: {
      type: Object,
      required: !0
    }
  },
  emits: [
    "searchTerm",
    "filterValueChanged",
    "resetAllFilters",
    "filterValueDeselected",
    "pageChanged",
    "rowsPerPageChanged",
    "loadMore"
  ],
  setup(e, { emit: t }) {
    const { t: n } = Je(), i = xt(), o = ge(), a = ge(), r = t, s = e, l = Te(() => ({
      headline: "",
      placeholder: n("archivePage.searchBoxPlaceholder"),
      filterOptions: [],
      searchTerm: s.model.searchTerm,
      showLabel: !0
    })), d = Te(() => i.isTablet.value ? s.model.filters.slice(0, 3) : s.model.filters.slice(0, 4)), y = Te(() => i.isTablet.value ? s.model.filters.slice(3) : s.model.filters.slice(4)), u = () => {
      a.value?.resetRowsPerPage();
    };
    async function m() {
      u(), r("filterValueChanged", s.model.filters);
    }
    function h() {
      u(), r("resetAllFilters");
    }
    function c(x, k) {
      (k === Pi.SearchTermEnter || k === Pi.SearchTermClear) && u(), r("searchTerm", x, k);
    }
    async function g(x, k) {
      r("filterValueDeselected", x, k);
    }
    const v = (x) => {
      r("pageChanged", x);
    }, P = (x) => {
      r("rowsPerPageChanged", x);
    }, f = (x) => {
      r("loadMore", x);
    }, S = $t("smoothScroll");
    function w() {
      const { calculateScrollPosition: x } = Fn(), k = o.value;
      S({
        scrollTo: x(k) || 0,
        duration: 1e3,
        updateHistory: !1
      });
    }
    return (x, k) => {
      const A = $e("BaseHeading"), $ = $e("BaseText");
      return e.model.results ? (E(), X("div", CTe, [
        ue(Vt, {
          id: "archive-page-top",
          class: "d-archive-page__top",
          "no-margin-bottom": !0,
          "no-margin": !0
        }, {
          default: Se(() => [
            e.model.headline ? (E(), fe(A, {
              key: 0,
              "base-heading-type": _(ze).H1
            }, {
              default: Se(() => [
                Ve(Ie(e.model.headline), 1)
              ]),
              _: 1
            }, 8, ["base-heading-type"])) : te("", !0),
            e.model.introText ? (E(), fe($, {
              key: 1,
              text: e.model.introText
            }, null, 8, ["text"])) : te("", !0)
          ]),
          _: 1
        }),
        !e.model.hideSearchBar || e.model.filters && e.model.filters?.length > 0 ? (E(), X("div", TTe, [
          e.model.hideSearchBar ? te("", !0) : (E(), fe(Vt, {
            key: 0,
            id: "archive-page-search",
            "no-margin-bottom": !0
          }, {
            default: Se(() => [
              oe("div", LTe, [
                ue(Wo, {
                  "is-suppress-open-new-window-on-enter": "",
                  model: l.value,
                  result: e.model.flyoutResults,
                  "event-component-name": "search",
                  onSearch: k[0] || (k[0] = (j) => c(
                    j,
                    _(Pi).SearchTermHasChanged
                  )),
                  onClear: k[1] || (k[1] = (j) => c(
                    "",
                    _(Pi).SearchTermClear
                  )),
                  onEnter: k[2] || (k[2] = (j) => c(
                    j,
                    _(Pi).SearchTermEnter
                  ))
                }, null, 8, ["model", "result"])
              ])
            ]),
            _: 1
          })),
          e.model.filters && e.model.filters?.length > 0 ? (E(), fe(Vt, {
            key: 1,
            id: "archive-page-filter-section-filters",
            "no-margin-bottom": !0
          }, {
            default: Se(() => [
              oe("div", {
                ref_key: "filterSection",
                ref: o,
                class: "d-archive-page__filter-section__filters"
              }, [
                ue(Ec, {
                  model: {
                    topFilters: d.value,
                    otherFilters: y.value,
                    componentNameForTracking: "Archive-Page"
                  },
                  onFilterValueChanged: m,
                  onFilterValueDeselected: g,
                  onResetFilters: h
                }, null, 8, ["model"])
              ], 512)
            ]),
            _: 1
          })) : te("", !0)
        ])) : te("", !0),
        ue(Vt, {
          id: "archive-page-results",
          "no-margin-bottom": !0
        }, {
          default: Se(() => [
            e.model.results ? (E(), fe(wTe, {
              key: 0,
              ref_key: "resultView",
              ref: a,
              results: e.model.results,
              "heading-type": _(ze).H3,
              "show-grid-first": e.model.showGridFirst,
              lazy: e.model.lazy,
              "total-items-count": e.model.totalItemsCount,
              "no-results-text": e.model.noResultsText,
              onPageChanged: v,
              onRowsPerPageChanged: P,
              onLoadMore: f
            }, null, 8, ["results", "heading-type", "show-grid-first", "lazy", "total-items-count", "no-results-text"])) : te("", !0)
          ]),
          _: 1
        }),
        e.model.results?.length > 0 ? (E(), fe(STe, {
          key: 1,
          "number-of-results": e.model.results?.length,
          "show-filter-bar": e.model.filters && e.model.filters?.length > 0,
          onScrollToAnchor: w
        }, null, 8, ["number-of-results", "show-filter-bar"])) : te("", !0)
      ])) : te("", !0);
    };
  }
});
const PTe = /* @__PURE__ */ Fe(ITe, [["__scopeId", "data-v-d3483610"]]), uEe = /* @__PURE__ */ Be({
  __name: "ArchivePage.container",
  emits: [
    "searchTerm",
    "filterValueChanged",
    "pageChanged",
    "rowsPerPageChanged",
    "loadMore"
  ],
  setup(e, { emit: t }) {
    const n = Dj(), { isDesktop: i, isTablet: o } = xt(), a = t, s = {
      rowsPerPage: Te(() => i.value ? 15 : o.value ? 6 : 5).value,
      page: 0
    }, l = ge({ ...s });
    function d(f) {
      l.value.rowsPerPage = f.rows, l.value.page = f.page;
    }
    function y() {
      l.value = { ...s };
    }
    async function u(f) {
      y(), await n.onSearchCriteriaChanged({
        filters: n.filters,
        searchTerm: n.searchTerm,
        flyoutResults: n.flyoutResults,
        eventType: Pi.FilterValueChanged,
        lazyLoadEventData: l.value
      }), a("filterValueChanged", f);
    }
    async function m() {
      y(), n.resetAllFilters(), await n.onSearchCriteriaChanged({
        filters: n.filters,
        searchTerm: n.searchTerm,
        flyoutResults: n.flyoutResults,
        eventType: Pi.ResetFilters,
        lazyLoadEventData: l.value
      });
    }
    async function h(f, S) {
      n.searchTerm = f, (S === Pi.SearchTermEnter || S === Pi.SearchTermClear) && y(), await n.onSearchCriteriaChanged({
        filters: n.filters,
        searchTerm: n.searchTerm,
        flyoutResults: n.flyoutResults,
        eventType: S,
        lazyLoadEventData: l.value
      }), a("searchTerm", n.searchTerm, S);
    }
    async function c(f, S) {
      y(), n.deselectFilterOption(f, S), u(n.filters);
    }
    const g = async (f) => {
      d(f), await n.onSearchCriteriaChanged({
        filters: n.filters,
        searchTerm: n.searchTerm,
        flyoutResults: n.flyoutResults,
        eventType: Pi.PageChanged,
        lazyLoadEventData: l.value
      }), a("pageChanged", f);
    }, v = async (f) => {
      d(f), await n.onSearchCriteriaChanged({
        filters: n.filters,
        searchTerm: n.searchTerm,
        flyoutResults: n.flyoutResults,
        eventType: Pi.RowsPerPageChanged,
        lazyLoadEventData: l.value
      }), a("rowsPerPageChanged", f);
    }, P = async (f) => {
      n.lazy && (d(f), await n.onSearchCriteriaChanged({
        filters: n.filters,
        searchTerm: n.searchTerm,
        flyoutResults: n.flyoutResults,
        eventType: Pi.RowsPerPageChanged,
        lazyLoadEventData: l.value
      }), a("loadMore", f));
    };
    return sn(() => {
      n.$dispose();
    }), (f, S) => (E(), fe(PTe, {
      model: {
        headline: _(n).headline,
        introText: _(n).introText,
        searchTerm: _(n).searchTerm,
        filters: _(n).filters,
        results: _(n).results,
        flyoutResults: _(n).flyoutResults,
        showGridFirst: _(n).showGridFirst,
        lazy: _(n).lazy,
        noResultsText: _(n).noResultsText,
        totalItemsCount: _(n).totalItemsCount,
        hideSearchBar: _(n).hideSearchBar
      },
      onSearchTerm: h,
      onFilterValueChanged: u,
      onResetAllFilters: m,
      onFilterValueDeselected: c,
      onPageChanged: g,
      onRowsPerPageChanged: v,
      onLoadMore: P
    }, null, 8, ["model"]));
  }
}), ATe = { class: "d-product-chart-teaser__chart-container-header" }, _Te = {
  key: 0,
  class: "d-product-chart-teaser__date"
}, MTe = {
  key: 1,
  class: "d-product-chart-teaser__period-dropdown"
}, OTe = {
  key: 2,
  class: "d-product-chart-teaser__period"
}, BTe = ["hidden", "data-event_title", "data-event_source", "onClick"], ETe = /* @__PURE__ */ Be({
  __name: "ProductChartTeaser",
  props: {
    model: {
      type: Object,
      required: !0
    },
    cardStyle: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const t = e, { t: n, currentLocale: i } = Je(), { isMobileAsync: o } = xt(), { pageName: a } = Qe(), r = a, {
      setChartData: s,
      loadChart: l,
      chartOptions: d,
      checkNumberMonths: y,
      changePeriod: u,
      activePeriodButton: m,
      getLastVisiblePoint: h,
      endDate: c,
      chart: g
    } = Iue(), v = (D) => ({
      name: D.text,
      value: D.type,
      isSelected: D.default
    }), P = ge();
    ws(() => {
      s(t.model.chartData);
      const D = x.value;
      u(D), P.value = v(D);
    }), it(() => {
      l();
    });
    const f = Te(
      () => t.model.headlinePerformanceChart ?? n("productChartTeaser.performance")
    ), S = Te(() => t.model.periodButtons), w = Te(() => {
      const D = S.value?.filter((C) => !y(C)).map((C) => v(C));
      if (D) {
        const C = D.length >= 2 ? D.length - 2 : 0, b = D[C];
        b && (b.isSelected = !0);
      }
      return D;
    }), x = Te(() => {
      let D = "MAX";
      if (w?.value?.length >= 2) {
        const C = w?.value?.length - 2;
        D = w?.value[C].value;
      }
      return t.model.periodButtons?.find((C) => C.type === D) || t.model.periodButtons?.find((C) => C.type === "3Y") || { text: "3J", type: "3Y", default: !0 };
    });
    function k(D) {
      const C = t.model.periodButtons?.find(
        (b) => b.type === D.value
      );
      C && u(C);
    }
    function A(D) {
      P.value = v(D), u(D);
    }
    const $ = (D) => {
      D.preventDefault();
    }, j = ge(
      !!t.model.chartData && !(t.model.chartData && Object.keys(t.model.chartData).length === 0)
    ), N = Te(() => {
      const D = [];
      if (!j.value)
        return D;
      const C = h(c.value.getTime());
      return t.model.chartData.seriesConfiguration.forEach((b) => {
        if (!b.notVisibleBefore || b.notVisibleBefore < C.x) {
          const p = g.value?.series.find(
            (L) => L.name === b.identifier
          );
          if (p != null) {
            const L = p.points.find(
              (B) => B.x === C?.x
            );
            if (L != null) {
              const B = Object.getOwnPropertyDescriptor(L, "change"), T = L.y?.toLocaleString(i.value.toString(), {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
              }) ?? "", O = Number(B?.value?.toFixed(3))?.toFixed(2) ?? "";
              D.push({
                identifier: b.chartType === "NAV" ? b.identifier : n("performanceChart.indexLevel"),
                lastValue: T,
                lastPerformance: O
              });
            }
          }
        }
      }), D;
    });
    function M(D) {
      return D ? D.lastPerformance : "";
    }
    return (D, C) => {
      const b = $e("BaseHeading"), p = $e("BaseText");
      return e.model ? (E(), X("div", {
        key: 0,
        class: Pe(["d-product-chart-teaser", { "d-product-chart-teaser--card": e.cardStyle }])
      }, [
        e.model.headline ? (E(), fe(b, {
          key: 0,
          "base-heading-type": e.model.headlineType,
          class: "d-product-chart-teaser__heading"
        }, {
          default: Se(() => [
            Ve(Ie(e.model.headline), 1)
          ]),
          _: 1
        }, 8, ["base-heading-type"])) : te("", !0),
        oe("div", {
          class: Pe(["d-product-chart-teaser__container", { "d-product-chart-teaser__container--card": e.cardStyle }])
        }, [
          e.model.dataList ? (E(), fe(Ar, {
            key: 0,
            model: e.model.dataList,
            class: "d-product-chart-teaser__list"
          }, null, 8, ["model"])) : te("", !0),
          e.model.detailPageLink && !e.cardStyle ? (E(), fe(vt, {
            key: 1,
            "link-model": e.model.detailPageLink,
            type: _(Ke).Secondary,
            "button-type": _(zt).Link,
            size: _(et).Large,
            class: "d-product-chart-teaser__detail-button"
          }, null, 8, ["link-model", "type", "button-type", "size"])) : te("", !0),
          oe("div", {
            class: Pe(["d-product-chart-teaser__chart-container", { "d-product-chart-teaser__chart-container--card": e.cardStyle }])
          }, [
            oe("div", ATe, [
              ue(b, {
                "base-heading-type": _(ze).H3,
                class: "d-product-chart-teaser__performance-heading"
              }, {
                default: Se(() => [
                  Ve(Ie(f.value), 1)
                ]),
                _: 1
              }, 8, ["base-heading-type"]),
              e.model.chartData?.asOfDate ? (E(), X("span", _Te, Ie(e.model.chartData.asOfDate), 1)) : te("", !0)
            ]),
            M(N.value.at(0)) ? (E(), fe(ad, {
              key: 0,
              class: "d-product-chart-teaser__performance",
              number: M(N.value.at(0)),
              "add-percent": !0
            }, null, 8, ["number"])) : te("", !0),
            e.cardStyle || _(o) ? (E(), X("div", MTe, [
              ue(_(vi), {
                items: w.value,
                selected: P.value,
                "has-filter": !1,
                "show-image": !1,
                "dropdown-type": _(Gt).Simple,
                onSelectedItemChanged: k,
                onClick: $
              }, null, 8, ["items", "selected", "dropdown-type"])
            ])) : (E(), X("div", OTe, [
              (E(!0), X(Re, null, Ge(S.value, (L, B) => (E(), X("button", {
                key: B,
                hidden: _(y)(L),
                class: Pe(["performance-buttons-period", {
                  "performance-buttons-period__active": L.type === _(m)?.type
                }]),
                "data-event_component_name": "Fund Teaser",
                "data-event_title": `Year Buttons | ${L.text}`,
                "data-event_source": _(r),
                onClick: (T) => A(L)
              }, Ie(L.text), 11, BTe))), 128))
            ])),
            _(d) ? (E(), fe(Xc, {
              key: 3,
              ref: "highChart",
              options: _(d),
              "chart-type": _(Ra).Chart,
              height: _(Vo).Small,
              class: "d-product-chart-teaser__chart"
            }, null, 8, ["options", "chart-type", "height"])) : te("", !0),
            e.model.disclaimer ? (E(), fe(p, {
              key: 4,
              text: e.model.disclaimer,
              "font-size": _(st).FourteenPx,
              "text-color": _(dt).GreyBlue006,
              class: "d-product-chart-teaser__disclaimer"
            }, null, 8, ["text", "font-size", "text-color"])) : te("", !0)
          ], 2)
        ], 2)
      ], 2)) : te("", !0);
    };
  }
});
const DTe = /* @__PURE__ */ Fe(ETe, [["__scopeId", "data-v-cae4aaf1"]]), RTe = { class: "d-product-chart-teaser-card__icon" }, NTe = /* @__PURE__ */ Be({
  __name: "ProductChartTeaserCard",
  props: {
    model: {
      type: Object,
      required: !0
    }
  },
  setup(e) {
    return (t, n) => {
      const i = $e("BaseIcon");
      return e.model ? (E(), fe(ot, {
        key: 0,
        class: "d-product-chart-teaser-card",
        "has-text": !1,
        "aria-label": e.model.detailPageLink.title,
        "link-model": e.model.detailPageLink
      }, {
        container: Se(() => [
          e.model ? (E(), fe(_(Ms), {
            key: 0,
            class: "d-product-chart-teaser-card__inner"
          }, {
            content: Se(() => [
              ue(DTe, {
                model: e.model,
                "card-style": !0
              }, null, 8, ["model"])
            ]),
            footer: Se(() => [
              oe("div", RTe, [
                ue(i, {
                  "base-icon": _(H).AngleRight,
                  "base-icon-color": _(gt).White,
                  "base-icon-size": _(at).Inherit
                }, null, 8, ["base-icon", "base-icon-color", "base-icon-size"])
              ])
            ]),
            _: 1
          })) : te("", !0)
        ]),
        _: 1
      }, 8, ["aria-label", "link-model"])) : te("", !0);
    };
  }
});
const ix = /* @__PURE__ */ Fe(NTe, [["__scopeId", "data-v-023366c5"]]), $Te = /* @__PURE__ */ Be({
  __name: "ProductChartTeasers",
  props: {
    model: {
      type: Object,
      required: !0
    }
  },
  setup(e) {
    const t = e, { isDesktopAsync: n } = xt(), i = Te(() => `d-product-chart-teasers--${t.model.backgroundColor}-bg`);
    return (o, a) => e.model?.teasers && e.model.teasers.length > 0 ? (E(), X("div", {
      key: 0,
      class: Pe(["d-product-chart-teasers", i.value])
    }, [
      _(n) ? (E(), fe(rT, {
        key: 0,
        type: _(ji).Half
      }, {
        default: Se(() => [
          (E(!0), X(Re, null, Ge(e.model.teasers, (r, s) => (E(), fe(_(pa), { key: s }, {
            default: Se(() => [
              ue(ix, { model: r }, null, 8, ["model"])
            ]),
            _: 2
          }, 1024))), 128))
        ]),
        _: 1
      }, 8, ["type"])) : (E(), fe(Mh, { key: 1 }, {
        default: Se(() => [
          (E(!0), X(Re, null, Ge(e.model.teasers, (r, s) => (E(), fe(_(pa), { key: s }, {
            default: Se(() => [
              ue(ix, { model: r }, null, 8, ["model"])
            ]),
            _: 2
          }, 1024))), 128))
        ]),
        _: 1
      }))
    ], 2)) : te("", !0);
  }
});
const hEe = /* @__PURE__ */ Fe($Te, [["__scopeId", "data-v-57f4d765"]]), FTe = {
  key: 0,
  class: "d-morning-star-stylebox"
}, jTe = {
  key: 1,
  class: "d-morning-star-stylebox__top-headline"
}, HTe = { class: "flex flex-row flex-wrap w-full" }, zTe = { class: "flex flex-wrap" }, VTe = { class: "d-morning-star-stylebox__row-values" }, GTe = { class: "d-morning-star-stylebox__row-headline table-headline" }, UTe = { class: "d-morning-star-stylebox__col-values pt-4" }, WTe = { class: "d-morning-star-stylebox__col-headline table-headline" }, YTe = /* @__PURE__ */ Be({
  __name: "MorningStarStylebox",
  props: {
    props: {
      type: Object,
      required: !0
    }
  },
  setup(e) {
    const t = "morningstar-stylebox-" + Pn();
    return (n, i) => {
      const o = $e("BaseHeading");
      return e.props ? (E(), X("div", FTe, [
        e.props?.headlineText !== "" ? (E(), fe(o, {
          key: 0,
          "base-heading-type": _(ze).H4,
          class: "d-morning-star-stylebox__headline"
        }, {
          default: Se(() => [
            ue(li, {
              "foot-note-id": t,
              text: e.props.headlineText
            }, null, 8, ["text"])
          ]),
          _: 1
        }, 8, ["base-heading-type"])) : te("", !0),
        e.props.topHeadlineText ? (E(), X("p", jTe, [
          ue(li, {
            "foot-note-id": t,
            text: e.props.topHeadlineText
          }, null, 8, ["text"])
        ])) : te("", !0),
        oe("div", HTe, [
          oe("table", null, [
            oe("tbody", null, [
              oe("tr", zTe, [
                (E(), X(Re, null, Ge(9, (a, r) => oe("td", {
                  key: `box-${r}`,
                  class: Pe(["w-1/3", {
                    "color-marker": a === e.props.value
                  }])
                }, null, 2)), 64))
              ])
            ])
          ]),
          oe("div", VTe, [
            (E(!0), X(Re, null, Ge(e.props.rowValues, (a) => (E(), X("span", {
              key: a,
              class: "value"
            }, Ie(a), 1))), 128))
          ]),
          oe("span", GTe, [
            ue(li, {
              text: e.props.rowHeadlineText,
              "foot-note-id": t
            }, null, 8, ["text"])
          ])
        ]),
        oe("div", UTe, [
          (E(!0), X(Re, null, Ge(e.props.colValues, (a) => (E(), X("span", {
            key: a,
            class: "text-center value"
          }, Ie(a), 1))), 128)),
          i[0] || (i[0] = oe("br", null, null, -1)),
          oe("span", WTe, Ie(e.props.colHeadlineText), 1)
        ]),
        e.props.footnotes && e.props.footnotes.length > 0 ? (E(), fe(ja, {
          key: 2,
          id: t,
          class: "mt-10",
          values: e.props
        }, null, 8, ["values"])) : te("", !0)
      ])) : te("", !0);
    };
  }
});
const pEe = /* @__PURE__ */ Fe(YTe, [["__scopeId", "data-v-7264f20a"]]), qTe = { class: "d-fund-finder" }, KTe = { class: "d-fund-finder__filter-section" }, XTe = { class: "d-fund-finder__search-results container" }, ZTe = { class: "container" }, JTe = {
  key: 1,
  class: "d-fund-finder__tab-container container"
}, QTe = {
  key: 0,
  class: "grid grid-cols-1 xl:grid-cols-4 d-fund-finder-table-drop-down"
}, eLe = { class: "grid xxl:grid-cols-4 xxl:col-span-3" }, tLe = { class: "xxl:col-span-3" }, nLe = { class: "flex flex-col lg:flex-row mb-11" }, Fd = 15, iLe = /* @__PURE__ */ Be({
  __name: "FundFinder",
  emits: [
    "search",
    "actionTriggered",
    "searchCriteriaChanged",
    "filterValueChanged",
    "timePeriodValueChanged",
    "tabHasChanged",
    "dropDownForDataTableChanged",
    "resetFilters",
    "updateDataTable",
    "onLoadMore",
    "rowsPerPageChanged",
    "sort",
    "page"
  ],
  setup(e, { emit: t }) {
    GL((J) => ({
      "1135e74f": Q.value.justifySelf,
      45354689: Q.value.gridColumn
    }));
    const n = Ej(), i = io(), o = sS(), { isSmallOrEqualLg: a, isTablet: r, isMobile: s } = xt(), { t: l } = Je(), d = ge(a.value), y = t, { selectedFiltersNumber: u } = Cm(n), m = ge([]);
    let h;
    const c = ge(null), g = ge(null), v = Te(() => s.value ? g.value : c.value);
    it(() => {
      if (n.result?.initialSort) {
        const J = {
          sortField: n.result.initialSort,
          sortOrder: n.result.initialSortOrder || -1,
          rows: 15,
          first: 0,
          originalEvent: void 0,
          multiSortMeta: [],
          filters: void 0,
          filterMatchModes: ""
        };
        A(J);
      }
    });
    const P = (J, ee) => {
      const V = n.result.id;
      V && (i.setPage(V, ee), i.setRowsPerPage(V, J));
    }, f = (J) => {
      const ee = n.result.id;
      ee && (i.setSortKey(ee, J.sortField), i.setSortOrder(ee, J.sortOrder));
    };
    function S(J, ee = 1) {
      P(J, ee), h ? (h.rowsPerPage = J, h.page = ee) : h = {
        sortField: null,
        sortOrder: 0,
        rowsPerPage: J,
        page: ee
      };
    }
    function w(J) {
      f(J), h ? (h.sortField = J.sortField, h.sortOrder = J.sortOrder) : h = {
        sortField: J.sortField,
        sortOrder: J.sortOrder,
        rowsPerPage: J.rows,
        page: 1
      };
    }
    function x() {
      h && (P(h.rowsPerPage, 1), h.page = 1);
    }
    qe(
      () => a.value,
      async (J) => {
        d.value = J, n.result.lazy && (S(Fd), await n.onSearchCriteriaChanged({
          selectedTabIndex: n.selectedTabIndex,
          filters: n.filters,
          searchTerm: n.searchTerm,
          timePeriod: n.selectedTimePeriod,
          selectedDropDownForDataTableItem: n.selectedDropDownForDataTableItem,
          lazyLoadDataTableUpdateEventData: h,
          eventType: Bn.UpdateDataTable,
          lockedItems: i.getLockedItems(n.result?.id)
        }));
      }
    );
    const k = (J) => ({
      tags: J.tags,
      textColor: dt.GreyBlue009,
      isBorderVisible: !1,
      fontType: lt.DwsSans,
      fontSize: st.FourteenPx
    });
    async function A(J) {
      if (w(J), x(), n.result?.values) {
        const ee = qg(n.result.values);
        if (!n.result.lazy) {
          const V = J.sortField.split(".")[0];
          ee.sort(
            (G, W) => i.sortAlgorithm(V, G, W, J.sortOrder === 1)
          ), m.value = [], ee.forEach((G) => {
            const W = i.getIdentifier(G);
            W && m.value.push(W);
          });
        }
      }
      n.setSortedIdentifier(m.value);
    }
    async function $(J) {
      A(J), y("sort", J);
    }
    async function j() {
      n.resetAllFilters(), x(), await n.onSearchCriteriaChanged({
        selectedTabIndex: n.selectedTabIndex,
        filters: n?.filters,
        searchTerm: n.searchTerm,
        timePeriod: n.selectedTimePeriod,
        selectedDropDownForDataTableItem: n.selectedDropDownForDataTableItem,
        lazyLoadDataTableUpdateEventData: h,
        eventType: Bn.ResetFilters,
        lockedItems: i.getLockedItems(n.result?.id)
      }), y("resetFilters", n);
    }
    async function N(J) {
      n.selectDropDownForDataTableItem(J), await n.onSearchCriteriaChanged({
        selectedTabIndex: n.selectedTabIndex,
        filters: n?.filters,
        searchTerm: n.searchTerm,
        timePeriod: n.selectedTimePeriod,
        selectedDropDownForDataTableItem: J,
        lazyLoadDataTableUpdateEventData: h,
        eventType: Bn.DropDownForDataTableChanged,
        lockedItems: i.getLockedItems(n.result?.id)
      }), y("dropDownForDataTableChanged", J);
    }
    async function M() {
      x(), await n.onSearchCriteriaChanged({
        selectedTabIndex: n.selectedTabIndex,
        filters: n?.filters,
        searchTerm: n.searchTerm,
        timePeriod: n.selectedTimePeriod,
        selectedDropDownForDataTableItem: n.selectedDropDownForDataTableItem,
        lazyLoadDataTableUpdateEventData: h,
        eventType: Bn.FilterValueChanged,
        lockedItems: i.getLockedItems(n.result?.id)
      }), y("filterValueChanged", n.filters);
    }
    async function D(J, ee) {
      n.deselectFilterOption(J, ee), M();
    }
    async function C(J) {
      x(), n.setTimePeriod(J), await n.onSearchCriteriaChanged({
        selectedTabIndex: n.selectedTabIndex,
        filters: n.filters,
        searchTerm: n.searchTerm,
        timePeriod: J,
        selectedDropDownForDataTableItem: n.selectedDropDownForDataTableItem,
        lazyLoadDataTableUpdateEventData: h,
        eventType: Bn.TimePeriodValueChanged,
        lockedItems: i.getLockedItems(n.result?.id)
      }), y("timePeriodValueChanged", J);
    }
    async function b(J) {
      S(J.rows, J.page + 1), y("page", J);
    }
    async function p(J) {
      let ee = 1;
      if (h && h.page > 1) {
        const V = (h.page - 1) * h.rowsPerPage;
        V > n.result?.values?.length ? ee = Math.ceil(
          (V - h.rowsPerPage + 1) / +J.value
        ) : V < +J.value ? ee = 1 : ee = Math.ceil(V / +J.value) + 1;
      }
      S(+J.value, ee), y("rowsPerPageChanged", J);
    }
    async function L(J) {
      h = J, await n.onSearchCriteriaChanged({
        selectedDropDownForDataTableItem: n.selectedDropDownForDataTableItem,
        selectedTabIndex: n.selectedTabIndex,
        filters: n.filters,
        searchTerm: n.searchTerm,
        timePeriod: n.selectedTimePeriod,
        lazyLoadDataTableUpdateEventData: h,
        eventType: Bn.UpdateDataTable,
        lockedItems: i.getLockedItems(n.result?.id)
      }), y("updateDataTable", J);
    }
    async function B(J, ee) {
      ee.locked ? (await n.onSearchCriteriaChanged({
        selectedTabIndex: n.selectedTabIndex,
        filters: n.filters,
        searchTerm: n.searchTerm,
        timePeriod: n.selectedTimePeriod,
        selectedDropDownForDataTableItem: n.selectedDropDownForDataTableItem,
        lazyLoadDataTableUpdateEventData: h,
        blockedTab: ee,
        eventType: Bn.TabHasChanged,
        lockedItems: i.getLockedItems(n.result?.id)
      }), y("tabHasChanged", J)) : (await n.onSearchCriteriaChanged({
        selectedTabIndex: J,
        filters: n.filters,
        searchTerm: n.searchTerm,
        timePeriod: n.selectedTimePeriod,
        selectedDropDownForDataTableItem: n.selectedDropDownForDataTableItem,
        lazyLoadDataTableUpdateEventData: h,
        eventType: Bn.TabHasChanged,
        lockedItems: i.getLockedItems(n.result?.id)
      }), y("tabHasChanged", n.selectedTabIndex));
    }
    async function T(J, ee) {
      x(), n.searchTerm = J, await n.onSearchCriteriaChanged({
        selectedTabIndex: n.selectedTabIndex,
        filters: n.filters,
        searchTerm: J,
        timePeriod: n.selectedTimePeriod,
        selectedDropDownForDataTableItem: n.selectedDropDownForDataTableItem,
        lazyLoadDataTableUpdateEventData: h,
        eventType: ee,
        lockedItems: i.getLockedItems(n.result?.id)
      }), y("search", n.searchTerm, ee);
    }
    async function O() {
      await n.onSearchCriteriaChanged({
        selectedTabIndex: n.selectedTabIndex,
        filters: n.filters,
        searchTerm: n.searchTerm,
        timePeriod: n.selectedTimePeriod,
        selectedDropDownForDataTableItem: n.selectedDropDownForDataTableItem,
        lazyLoadDataTableUpdateEventData: h,
        eventType: Bn.SearchTermFocus,
        lockedItems: i.getLockedItems(n.result?.id)
      }), y("search", n.searchTerm, Bn.SearchTermFocus);
    }
    async function I(J, ee, V) {
      let G = Bn.ChangedActionMenuItem;
      J.key === ga.Bookmark && (G = J.selected ? Bn.AddBookmark : Bn.RemoveBookmark), await n.onSearchCriteriaChanged({
        selectedTabIndex: n.selectedTabIndex,
        filters: n.filters,
        searchTerm: n.searchTerm,
        timePeriod: n.selectedTimePeriod,
        selectedDropDownForDataTableItem: n.selectedDropDownForDataTableItem,
        lazyLoadDataTableUpdateEventData: h,
        eventType: G,
        lockedItems: i.getLockedItems(n.result?.id),
        bookmarkedItems: [ee]
      }), o.add({
        severity: J.selected ? Vf.Success : Vf.Error,
        detail: R(J),
        life: 3e3
      }), Ue && document.getElementById(V)?.focus(), y("actionTriggered", J, ee);
    }
    const R = (J) => {
      switch (J.key) {
        case ga.Compare:
          return J.selected ? l("fundFinder.addedCompareMessage") : l("fundFinder.removedCompareMessage");
        case ga.Bookmark:
          return J.selected ? l("fundFinder.addedBookmarkMessage") : l("fundFinder.removedBookmarkMessage");
        default:
          return "";
      }
    };
    async function Y(J) {
      n.result?.lazy && (S(Fd, J), await n.onSearchCriteriaChanged({
        selectedTabIndex: n.selectedTabIndex,
        filters: n.filters,
        searchTerm: n.searchTerm,
        timePeriod: n.selectedTimePeriod,
        selectedDropDownForDataTableItem: n.selectedDropDownForDataTableItem,
        lazyLoadDataTableUpdateEventData: h,
        eventType: Bn.UpdateDataTable,
        lockedItems: i.getLockedItems(n.result?.id)
      }), y("onLoadMore"));
    }
    const F = Te(() => ({
      headline: l("fundFinder.fundSearchHeadline"),
      placeholder: l("fundFinder.fundSearchPlaceholder"),
      filterOptions: [],
      searchTerm: n.searchTerm,
      submitLinkModel: n.submitLinkModel
    })), U = Te(
      () => n.flyoutResults
    ), Q = Te(() => r.value ? u.value % 3 === 0 ? { justifySelf: "start", gridColumn: 1 } : { justifySelf: "end", gridColumn: 3 } : u.value % 4 === 0 ? { justifySelf: "start", gridColumn: 1 } : { justifySelf: "end", gridColumn: 4 });
    return sn(() => {
      n.$dispose();
    }), (J, ee) => (E(), X(Re, null, [
      oe("div", qTe, [
        ue(Ot, {
          "base-heading-type": _(ze).H1,
          class: "d-fund-finder__page-headline container"
        }, {
          default: Se(() => [
            Ve(Ie(_(n).headline), 1)
          ]),
          _: 1
        }, 8, ["base-heading-type"]),
        _(n).introText ? (E(), fe(ht, {
          key: 0,
          "html-text": _(n).introText,
          "font-type": _(lt).DwsSans,
          class: "d-fund-finder__intro-text container"
        }, null, 8, ["html-text", "font-type"])) : te("", !0),
        oe("div", KTe, [
          oe("div", XTe, [
            ue(Wo, {
              "is-suppress-open-new-window-on-enter": "",
              model: F.value,
              result: U.value,
              "event-component-name": "search",
              "focus-input-with-init-term": !1,
              "label-for": _(l)("globalTranslations.search"),
              "is-fund-finder": !0,
              onFocus: ee[0] || (ee[0] = (V) => O()),
              onSearch: ee[1] || (ee[1] = (V) => T(
                V,
                _(Bn).SearchTermHasChanged
              )),
              onBlur: ee[2] || (ee[2] = (V) => T(
                V,
                _(Bn).SearchTermBlurred
              )),
              onFilterChanged: ee[3] || (ee[3] = (V) => T(
                V,
                _(Bn).SearchTermFilterValueChanged
              )),
              onClear: ee[4] || (ee[4] = (V) => T(
                V,
                _(Bn).SearchTermClear
              )),
              onEnter: ee[5] || (ee[5] = (V) => T(
                V,
                _(Bn).SearchTermEnter
              ))
            }, null, 8, ["model", "result", "label-for"]),
            rt(oe("div", {
              ref_key: "resultNumberRef",
              ref: c
            }, null, 512), [
              [xn, v.value === c.value]
            ]),
            ue(_(Yn), { "append-to": v.value }, {
              default: Se(() => [
                ue(_h, {
                  results: _(n).result?.lazy ? _(n)?.result?.totalRecords : _(n).result?.values?.length,
                  "number-of-result-text": {
                    oneResultText: _(l)("fundFinder.product"),
                    multipleResultsText: _(l)("fundFinder.products")
                  }
                }, null, 8, ["results", "number-of-result-text"])
              ]),
              _: 1
            }, 8, ["append-to"])
          ]),
          oe("div", ZTe, [
            ue(Ec, {
              model: {
                topFilters: _(n).topFilters,
                otherFilters: _(n).otherFilters,
                timePeriods: _(n).timePeriods,
                selectedTimePeriod: _(n).selectedTimePeriod,
                componentNameForTracking: "Fund-Finder"
              },
              onFilterValueChanged: M,
              onFilterTimePeriodChanged: C,
              onFilterValueDeselected: D,
              onResetFilters: j
            }, null, 8, ["model"])
          ])
        ]),
        rt(oe("div", {
          ref_key: "resultNumberMobileRef",
          ref: g,
          class: "d-fund-finder__result-count--mobile container"
        }, null, 512), [
          [xn, v.value === g.value]
        ]),
        _(n).result?.values ? (E(), X("div", JTe, [
          ue(Hh, {
            "selected-tab": _(n).selectedTabIndex,
            onTabHasChanged: B
          }, Qt({
            default: Se(() => [
              (E(!0), X(Re, null, Ge(_(n).tabs, (V) => (E(), fe(_r, {
                key: V.title,
                header: V.title,
                locked: V.isLocked ? V.isLocked : !1
              }, {
                default: Se(() => [
                  _(n).dropDownForDataTableItems?.length > 0 ? (E(), X("div", QTe, [
                    ue(_(Oh), {
                      "aria-label": _(l)("fundFinder.changeColumnView"),
                      model: {
                        options: _(n).dropDownForDataTableItems,
                        selectedItem: _(n).selectedDropDownForDataTableItem,
                        componentName: "Table adjuster"
                      },
                      onSelectedItemChanged: N
                    }, null, 8, ["aria-label", "model"])
                  ])) : te("", !0),
                  d.value ? (E(), fe(Vg, {
                    key: 1,
                    props: _(n).result,
                    "load-more-length": Fd,
                    "max-length": Fd,
                    onUpdateDataTable: L,
                    onActionTriggered: I,
                    onOnLoadMore: Y,
                    onSort: $
                  }, Qt({ _: 2 }, [
                    _(n).timePeriods?.length > 0 && _(s) ? {
                      name: "additionalHeaderContent",
                      fn: Se(() => [
                        ue(jf, {
                          model: {
                            timePeriods: _(n).timePeriods,
                            label: _(l)("fundFinder.periodLabel"),
                            showShortName: !0,
                            selectedTimePeriod: _(n).selectedTimePeriod
                          },
                          onPeriodChanged: C
                        }, null, 8, ["model"])
                      ]),
                      key: "0"
                    } : void 0
                  ]), 1032, ["props"])) : (E(), fe(Fu, {
                    key: 2,
                    "new-page-footnote-list-visible": !0,
                    model: _(n).result,
                    "footnote-type": _(Oi).None,
                    onUpdateDataTable: L,
                    onActionTriggered: I,
                    onRowsPerPageChanged: p,
                    onPage: b,
                    onSort: $
                  }, null, 8, ["model", "footnote-type"])),
                  V.disclaimerForResultTable ? (E(), fe(Na, {
                    key: 3,
                    "as-of-date": V.disclaimerForResultTable.asOfDate,
                    text: V.disclaimerForResultTable.text
                  }, null, 8, ["as-of-date", "text"])) : te("", !0),
                  oe("div", eLe, [
                    oe("div", tLe, [
                      oe("div", nLe, [
                        _(n).documents && _(n).documents.length > 0 ? (E(), fe(RCe, {
                          key: 0,
                          class: "d-fund-finder__link-dropdown",
                          items: _(n).documents,
                          placeholder: _(n).documentsPlaceholderText ?? _(l)("fundFinder.downloadDocuments")
                        }, null, 8, ["items", "placeholder"])) : te("", !0),
                        V.downloadLink && V.downloadLink.href ? (E(), fe(ot, {
                          key: 1,
                          class: "d-fund-finder__download-link",
                          "link-model": V.downloadLink,
                          icon: _(H).Download
                        }, null, 8, ["link-model", "icon"])) : te("", !0)
                      ]),
                      ue(Vae, {
                        class: "d-fund-finder__tags",
                        model: k(V)
                      }, null, 8, ["model"]),
                      ue(ro, {
                        "component-id": _(n).footnoteComponentId,
                        "footnote-type": _(n).footnoteType
                      }, null, 8, ["component-id", "footnote-type"]),
                      V.disclaimer ? (E(), fe(Na, {
                        key: 0,
                        text: V.disclaimer
                      }, null, 8, ["text"])) : te("", !0)
                    ])
                  ])
                ]),
                _: 2
              }, 1032, ["header", "locked"]))), 128))
            ]),
            _: 2
          }, [
            _(n).timePeriods?.length > 0 && !_(s) ? {
              name: "additionalContent",
              fn: Se(() => [
                ue(jf, {
                  model: {
                    timePeriods: _(n).timePeriods,
                    label: _(l)("fundFinder.periodLabel"),
                    showShortName: !0,
                    selectedTimePeriod: _(n).selectedTimePeriod
                  },
                  onPeriodChanged: C
                }, null, 8, ["model"])
              ]),
              key: "0"
            } : void 0
          ]), 1032, ["selected-tab"])
        ])) : te("", !0),
        je(J.$slots, "pageDisclaimer", {}, void 0, !0)
      ]),
      ue(fC)
    ], 64));
  }
});
const fEe = /* @__PURE__ */ Fe(iLe, [["__scopeId", "data-v-537bcab2"]]);
var su = /* @__PURE__ */ ((e) => (e.Information = "information", e.Products = "products", e.Entities = "entities", e))(su || {});
const aLe = {
  key: 0,
  class: "d-announcement-item"
}, ax = 3, oLe = /* @__PURE__ */ Be({
  __name: "AnnouncementItem",
  props: {
    teaserContent: {
      type: Object,
      required: !0
    }
  },
  setup(e) {
    const t = e, n = ge(!1), i = () => {
      n.value = !1;
    }, o = Te(() => ({
      "1980px": "60rem",
      "1280px": "60rem",
      "1024px": "50rem",
      "768px": "40rem",
      "576px": "100vw",
      "375px": "100vw"
    })), a = Te(() => t?.teaserContent?.teaserContent?.teaserContent?.teaserContent), r = () => {
      n.value = !0;
    };
    return (s, l) => {
      const d = $e("BaseText");
      return a.value ? (E(), X("div", aLe, [
        a.value.description ? (E(), fe(d, {
          key: 0,
          text: a.value.description
        }, null, 8, ["text"])) : te("", !0),
        a.value.items && a.value.items.length > 0 ? (E(), X(Re, { key: 1 }, [
          a.value.itemsHeadline && a.value.announcementType !== _(su).Products ? (E(), fe(Ot, {
            key: 0,
            "base-heading-type": _(ze).H4
          }, {
            default: Se(() => [
              Ve(Ie(a.value.itemsHeadline), 1)
            ]),
            _: 1
          }, 8, ["base-heading-type"])) : te("", !0),
          a.value.announcementType !== _(su).Products ? (E(), fe($c, {
            key: 1,
            "list-items": a.value.items.slice(0, ax)
          }, null, 8, ["list-items"])) : te("", !0),
          a.value.showMoreLink && a.value.items.length > ax || a.value.announcementType === _(su).Products ? (E(), fe(ot, {
            key: 2,
            "link-model": a.value.showMoreLink,
            icon: _(H).Plus,
            onClick: l[0] || (l[0] = (y) => r())
          }, null, 8, ["link-model", "icon"])) : te("", !0),
          ue(Ei, {
            class: "d-announcements-modal p-smooth-scroller d-disclaimer",
            position: _(aa).Center,
            display: n.value,
            closable: !0,
            modal: !0,
            breakpoints: o.value,
            "append-to": "#dx-overlay",
            onAfterHide: l[1] || (l[1] = (y) => i())
          }, {
            header: Se(() => [
              ue(Ot, {
                "base-heading-type": _(ze).H2Section
              }, {
                default: Se(() => [
                  Ve(Ie(a.value.headline), 1)
                ]),
                _: 1
              }, 8, ["base-heading-type"])
            ]),
            content: Se(() => [
              ue($c, {
                "list-items": a.value.items
              }, null, 8, ["list-items"])
            ]),
            footer: Se(() => [
              ue(vt, {
                "link-model": a.value.linkUrl,
                type: _(Ke).Primary,
                size: _(et).Medium,
                icon: _(H).Download,
                "button-type": _(zt).Link
              }, null, 8, ["link-model", "type", "size", "icon", "button-type"])
            ]),
            _: 1
          }, 8, ["position", "display", "breakpoints"])
        ], 64)) : te("", !0)
      ])) : te("", !0);
    };
  }
});
const rLe = /* @__PURE__ */ Fe(oLe, [["__scopeId", "data-v-9571bfda"]]), sLe = {
  key: 0,
  class: "d-announcements"
}, lLe = {
  key: 0,
  class: "d-announcements__button-right"
}, cLe = /* @__PURE__ */ Be({
  __name: "Announcements",
  props: {
    props: {
      type: Object,
      required: !0
    }
  },
  setup(e) {
    const t = (n) => {
      Ue && n && window.open(n.href, n.target);
    };
    return (n, i) => e.props.announcementTabs ? (E(), X("div", sLe, [
      ue(Hh, null, {
        default: Se(() => [
          (E(!0), X(Re, null, Ge(e.props.announcementTabs, (o, a) => (E(), fe(_r, {
            key: a,
            header: o.tabTitle
          }, {
            default: Se(() => [
              ue(oL, {
                model: o.teasers,
                "link-corner": !0
              }, {
                teaserContent: Se((r) => [
                  ue(rLe, {
                    "teaser-content": r.teaserContent
                  }, null, 8, ["teaser-content"])
                ]),
                _: 2
              }, 1032, ["model"]),
              o.ctaElementType && o.readMoreLink?.text && o.readMoreLink?.text !== "" ? (E(), X("div", lLe, [
                o.ctaElementType === _(cn).Link ? (E(), fe(ot, {
                  key: 0,
                  "link-model": o.readMoreLink,
                  icon: _(H).ArrowRight,
                  onClick: t
                }, null, 8, ["link-model", "icon"])) : te("", !0),
                o.ctaElementType === _(cn).SecondaryButton ? (E(), fe(vt, {
                  key: 1,
                  "link-model": o.readMoreLink,
                  type: _(Ke).Secondary,
                  size: _(et).Medium,
                  icon: _(H).ArrowRight,
                  onClick: (r) => t(o.readMoreLink)
                }, null, 8, ["link-model", "type", "size", "icon", "onClick"])) : te("", !0),
                o.ctaElementType === _(cn).PrimaryButton ? (E(), fe(vt, {
                  key: 2,
                  "link-model": o.readMoreLink,
                  type: _(Ke).Primary,
                  size: _(et).Medium,
                  icon: _(H).ArrowRight,
                  onClick: (r) => t(o.readMoreLink)
                }, null, 8, ["link-model", "type", "size", "icon", "onClick"])) : te("", !0)
              ])) : te("", !0)
            ]),
            _: 2
          }, 1032, ["header"]))), 128))
        ]),
        _: 1
      })
    ])) : te("", !0);
  }
});
const mEe = /* @__PURE__ */ Fe(cLe, [["__scopeId", "data-v-352612ca"]]), dLe = { class: "d-publications" }, uLe = { class: "d-publications__items" }, ox = 0, rx = 5, hLe = /* @__PURE__ */ Be({
  __name: "Publications",
  props: {
    model: {
      type: Object,
      required: !0
    }
  },
  setup(e) {
    const { t } = Je(), { pageName: n } = Qe(), { onRowsPerPageChanged: i } = bm(), o = ge(n), a = e, r = ge(ox), s = ge(rx), l = Te(() => a.model.publications.slice(
      r.value,
      r.value + s.value
    )), d = (m) => {
      r.value = m.first, s.value = m.rows;
    }, y = () => {
      r.value = ox, s.value = s.value + rx;
    }, u = (m) => {
      i(m, r, s);
    };
    return (m, h) => {
      const c = $e("BaseHeading");
      return E(), X("div", dLe, [
        ue(c, {
          "base-heading-type": _(ze).H2Section,
          class: "d-publications__heading"
        }, {
          default: Se(() => [
            Ve(Ie(e.model.headline), 1)
          ]),
          _: 1
        }, 8, ["base-heading-type"]),
        oe("div", uLe, [
          (E(!0), X(Re, null, Ge(l.value, (g, v) => (E(), fe(co, {
            key: v,
            "teaser-box": g,
            layout: _(Rt).Full,
            "full-layout": _($a).OneToThree,
            "cta-element-type": _(cn).Link,
            "picture-rounded-corner": !0,
            "content-padding": !1,
            "heading-type": _(ze).H3,
            class: "d-publications__publication"
          }, null, 8, ["teaser-box", "layout", "full-layout", "cta-element-type", "heading-type"]))), 128))
        ]),
        ue(od, {
          class: "d-publications__paginator",
          first: r.value,
          "total-records": e.model.publications.length,
          "rows-per-page-options": [5, 10, 15],
          rows: s.value,
          onRowsPerPageChanged: u,
          onPageChanged: d
        }, null, 8, ["first", "total-records", "rows"]),
        s.value < e.model.publications.length ? (E(), fe(vt, {
          key: 0,
          class: "d-publications__load-more",
          type: _(Ke).Primary,
          size: _(et).Large,
          "link-model": {
            title: _(t)("publications.loadMore"),
            text: _(t)("publications.loadMore"),
            tealiumTrackingModel: {
              eventComponentName: "Pagination",
              eventTitle: "load more",
              eventSource: o.value
            }
          },
          icon: _(H).Plus,
          "icon-position": _(ct).Left,
          onClick: y
        }, null, 8, ["type", "size", "link-model", "icon", "icon-position"])) : te("", !0)
      ]);
    };
  }
});
const sx = /* @__PURE__ */ Fe(hLe, [["__scopeId", "data-v-53408356"]]), pLe = { class: "d-person-detail-block-biography" }, fLe = { class: "d-person-detail-block-biography--text" }, mLe = { class: "d-person-detail-block-biography--list p" }, gLe = { class: "d-person-detail-block-biography--education" }, vLe = { class: "d-person-detail-block-biography--list p" }, yLe = { class: "d-person-detail-block-biography--professionalCareer" }, bLe = { class: "d-person-detail-block-biography--list p" }, xLe = /* @__PURE__ */ Be({
  __name: "Biography",
  props: {
    props: {
      type: Object,
      required: !0
    }
  },
  setup(e) {
    const { t } = Je();
    return (n, i) => {
      const o = $e("BaseHeading");
      return E(), X("div", pLe, [
        ue(o, {
          "base-heading-type": _(ze).H2Section
        }, {
          default: Se(() => [
            Ve(Ie(_(t)("Biography")), 1)
          ]),
          _: 1
        }, 8, ["base-heading-type"]),
        oe("div", fLe, [
          oe("div", mLe, [
            ue(_(ht), {
              "html-text": e.props.text
            }, null, 8, ["html-text"])
          ])
        ]),
        oe("div", gLe, [
          ue(o, {
            "base-heading-type": _(ze).H3
          }, {
            default: Se(() => [
              Ve(Ie(_(t)("Education")), 1)
            ]),
            _: 1
          }, 8, ["base-heading-type"]),
          oe("div", vLe, [
            ue(_(ht), {
              "html-text": e.props.education
            }, null, 8, ["html-text"])
          ])
        ]),
        oe("div", yLe, [
          ue(o, {
            "base-heading-type": _(ze).H3
          }, {
            default: Se(() => [
              Ve(Ie(_(t)("Professional career")), 1)
            ]),
            _: 1
          }, 8, ["base-heading-type"]),
          oe("div", bLe, [
            ue(_(ht), {
              "html-text": e.props.professionalCareer
            }, null, 8, ["html-text"])
          ])
        ])
      ]);
    };
  }
});
const lx = /* @__PURE__ */ Fe(xLe, [["__scopeId", "data-v-39a2a034"]]), wLe = { class: "d-person-detail-block" }, kLe = { class: "d-person-detail-block__image-and-motto-container" }, SLe = { class: "d-person-detail-block__image-container" }, CLe = {
  key: 1,
  class: "d-person-detail-block__no-image"
}, TLe = { class: "d-person-detail-block__information-container" }, LLe = { class: "d-person-detail-block__contact" }, ILe = {
  key: 3,
  class: "d-person-detail-block__location"
}, PLe = {
  key: 1,
  class: "d-person-detail-block__social-media"
}, ALe = {
  key: 4,
  class: "d-person-detail-block__positions"
}, _Le = {
  key: 8,
  class: "d-person-detail-block__disclaimer"
}, MLe = /* @__PURE__ */ Be({
  __name: "PersonDetailBlock",
  props: {
    props: {
      type: Object,
      required: !0
    }
  },
  setup(e) {
    const { t } = Je(), n = Te(() => [
      {
        height: 256,
        width: 256,
        dxBreakpoint: Ct.Sm
      },
      {
        height: 256,
        width: 256,
        dxBreakpoint: Ct.Md
      },
      {
        height: 264,
        width: 264,
        dxBreakpoint: Ct.Lg
      },
      {
        height: 320,
        width: 320,
        dxBreakpoint: Ct.Xxl
      }
    ]);
    return (i, o) => {
      const a = $e("BaseImage"), r = $e("BaseIcon"), s = $e("BaseHeading"), l = $e("BaseText");
      return E(), X("div", wLe, [
        oe("div", kLe, [
          oe("div", SLe, [
            e.props.image ? (E(), fe(a, {
              key: 0,
              model: e.props.image,
              "responsive-options": n.value,
              class: "d-person-detail-block__image"
            }, null, 8, ["model", "responsive-options"])) : te("", !0),
            e.props.image ? te("", !0) : (E(), X("div", CLe, [
              ue(r, {
                "base-icon": _(H).User,
                "base-icon-size": _(at).Inherit,
                "base-icon-color": _(gt).Inherit,
                class: "d-person-detail-block__name"
              }, null, 8, ["base-icon", "base-icon-size", "base-icon-color"])
            ]))
          ]),
          e.props.motto ? (E(), fe(Uf, {
            key: 0,
            quote: e.props.motto,
            class: "d-person-detail-block__quote xs:hidden xxl:block"
          }, null, 8, ["quote"])) : te("", !0)
        ]),
        oe("div", TLe, [
          ue(s, {
            "base-heading-type": _(ze).H1
          }, {
            default: Se(() => [
              Ve(Ie(e.props.name), 1)
            ]),
            _: 1
          }, 8, ["base-heading-type"]),
          e.props.position ? (E(), fe(l, {
            key: 0,
            text: e.props.position,
            "font-type": _(lt).DwsSansBold,
            "text-color": _(dt).GreyBlue009,
            class: "d-person-detail-block__position"
          }, null, 8, ["text", "font-type", "text-color"])) : te("", !0),
          oe("div", LLe, [
            e.props.mail ? (E(), fe(ot, {
              key: 0,
              class: "d-person-detail-block__mail flex",
              "is-copy-link": !0,
              "link-model": e.props.mail,
              icon: _(H).Envelope,
              "icon-position": _(ct).Left
            }, null, 8, ["link-model", "icon", "icon-position"])) : te("", !0),
            e.props.tel ? (E(), fe(ot, {
              key: 1,
              class: "d-person-detail-block__tel flex",
              "is-copy-link": !0,
              "link-model": e.props.tel,
              icon: _(H).Phone,
              "icon-position": _(ct).Left
            }, null, 8, ["link-model", "icon", "icon-position"])) : te("", !0),
            e.props.link ? (E(), fe(ot, {
              key: 2,
              class: "d-person-detail-block__link flex",
              "is-copy-link": !0,
              "link-model": e.props.link,
              icon: _(H).ExternalLinkAlt,
              "icon-position": _(ct).Left
            }, null, 8, ["link-model", "icon", "icon-position"])) : te("", !0),
            e.props.location ? (E(), X("span", ILe, [
              ue(r, {
                "base-icon-color": _(gt).Inherit,
                "base-icon": _(H).MapMarker,
                "aria-hidden": "true"
              }, null, 8, ["base-icon-color", "base-icon"]),
              Ve(Ie(e.props.location), 1)
            ])) : te("", !0)
          ]),
          e.props.socialMedia ? (E(), X("div", PLe, [
            ue(pT, {
              model: e.props.socialMedia,
              "button-type": _(Ke).RoundedSecondary
            }, null, 8, ["model", "button-type"])
          ])) : te("", !0),
          e.props.tags ? (E(), fe(Ch, {
            key: 2,
            class: "d-person-detail-block__tags",
            tags: e.props.tags,
            "background-color": _(En).Transparent
          }, null, 8, ["tags", "background-color"])) : te("", !0),
          e.props.motto ? (E(), fe(Uf, {
            key: 3,
            quote: e.props.motto,
            class: "d-person-detail-block__quote xs:block xxl:hidden"
          }, null, 8, ["quote"])) : te("", !0),
          e.props.positions?.positionsList && e.props.positions.positionsList.length > 0 ? (E(), X("div", ALe, [
            ue(s, {
              "base-heading-type": _(ze).H2Section
            }, {
              default: Se(() => [
                Ve(Ie(e.props.positions.headline), 1)
              ]),
              _: 1
            }, 8, ["base-heading-type"]),
            e.props.positions.positionsList ? (E(), fe($c, {
              key: 0,
              "list-items": e.props.positions.positionsList
            }, null, 8, ["list-items"])) : te("", !0)
          ])) : te("", !0),
          e.props.publications && e.props.biography ? (E(), fe(Hh, { key: 5 }, {
            default: Se(() => [
              ue(_r, {
                header: _(t)("personDetailBlock.publications")
              }, {
                default: Se(() => [
                  ue(sx, {
                    model: e.props.publications
                  }, null, 8, ["model"])
                ]),
                _: 1
              }, 8, ["header"]),
              ue(_r, {
                header: _(t)("personDetailBlock.biography")
              }, {
                default: Se(() => [
                  ue(lx, {
                    props: e.props.biography
                  }, null, 8, ["props"])
                ]),
                _: 1
              }, 8, ["header"])
            ]),
            _: 1
          })) : e.props.biography ? (E(), fe(lx, {
            key: 6,
            props: e.props.biography
          }, null, 8, ["props"])) : e.props.publications ? (E(), fe(sx, {
            key: 7,
            model: e.props.publications
          }, null, 8, ["model"])) : te("", !0),
          e.props.disclaimer ? (E(), X("div", _Le, [
            (E(!0), X(Re, null, Ge(e.props.disclaimer, (d, y) => (E(), fe(l, {
              key: y,
              text: d.text,
              "font-size": _(st).FourteenPx,
              "text-color": _(dt).GreyBlue006
            }, null, 8, ["text", "font-size", "text-color"]))), 128))
          ])) : te("", !0)
        ])
      ]);
    };
  }
});
const OLe = /* @__PURE__ */ Fe(MLe, [["__scopeId", "data-v-a7029eaa"]]), BLe = { class: "d-person-detail-page" }, ELe = /* @__PURE__ */ Be({
  __name: "PersonDetailPage",
  props: {
    props: {
      type: Object,
      required: !0
    },
    breadcrumb: {
      type: Object,
      required: !0
    }
  },
  setup(e) {
    return (t, n) => (E(), X("div", BLe, [
      ue(_(Vt), {
        id: "person-detail-page",
        "has-stripes": !0,
        "no-margin-bottom": !0,
        "no-margin": !0
      }, {
        default: Se(() => [
          ue(_(zg), si(Ki(e.breadcrumb)), null, 16),
          ue(_(OLe), { props: e.props }, null, 8, ["props"])
        ]),
        _: 1
      })
    ]));
  }
});
const gEe = /* @__PURE__ */ Fe(ELe, [["__scopeId", "data-v-2b9ee9ea"]]), DLe = /* @__PURE__ */ Be({
  __name: "ExpandableTeasers",
  props: {
    model: {
      type: Object,
      required: !0
    },
    layout: {
      type: String,
      default: Ao.FullWidth
    },
    alignment: {
      type: String,
      default: sL.Left
    },
    hideToggleButton: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const t = xt(), n = e, i = () => n.layout === Ao.FullWidth && t.isXxlPageSection.value || t.isTablet.value;
    return (o, a) => {
      const r = $e("BaseHeading");
      return E(), X("div", {
        class: Pe(["d-expandable-teasers", e.layout])
      }, [
        oe("div", {
          class: Pe(["d-expandable-teasers__heading", { "d-expandable-teasers__heading--margin": e.hideToggleButton }])
        }, [
          ue(r, {
            "base-heading-type": _(ze).H2
          }, {
            default: Se(() => [
              Ve(Ie(e.model.sectionHeadline), 1)
            ]),
            _: 1
          }, 8, ["base-heading-type"])
        ], 2),
        oe("div", {
          class: Pe(["d-expandable-teasers__accordion", e.alignment])
        }, [
          ue(nv, {
            layout: e.layout,
            "show-buttons": !e.hideToggleButton
          }, {
            default: Se(() => [
              (E(!0), X(Re, null, Ge(e.model.accordionItems, (s, l) => (E(), fe(Fh, {
                key: l,
                header: s.headline,
                expanded: !1,
                footnotes: [],
                image: s.image,
                preview: s.previewText,
                layout: e.layout,
                text: s.text,
                linkurl: s.linkUrl,
                buttontype: s.buttonType,
                class: Pe(s?.image ? "withImg" : "noImg")
              }, {
                default: Se(() => [
                  i() ? te("", !0) : (E(), fe(lL, {
                    key: 0,
                    item: s
                  }, null, 8, ["item"]))
                ]),
                _: 2
              }, 1032, ["header", "image", "preview", "layout", "text", "linkurl", "buttontype", "class"]))), 128))
            ]),
            _: 1
          }, 8, ["layout", "show-buttons"])
        ], 2)
      ], 2);
    };
  }
});
const vEe = /* @__PURE__ */ Fe(DLe, [["__scopeId", "data-v-9aace46e"]]);
var lu = /* @__PURE__ */ ((e) => (e.Error = "error", e.Success = "success", e.AlreadySubscribed = "already-subscribed", e))(lu || {});
const cx = ge(), RLe = () => ({
  postNewsletterRegistrationResult: cx,
  postNewsletterRegistration: async (t, n) => {
    const i = n, o = {
      Accept: "application/json",
      "Content-Type": "application/json"
    }, a = {
      body: JSON.stringify(t),
      headers: o
    }, { data: r } = await Wu().post(i, a);
    return cx.value = r.value, r.value;
  }
}), NLe = { class: "d-container" }, $Le = { key: 2 }, FLe = { key: 3 }, jLe = { key: 4 }, HLe = /* @__PURE__ */ Be({
  __name: "NewsletterTeaser",
  props: {
    model: {
      type: Object,
      required: !0
    }
  },
  emits: [
    "submitted-newsletter",
    "already-subscribed",
    "error"
  ],
  setup(e, { emit: t }) {
    const { t: n } = Je(), i = t, o = ge(""), a = ge(Ht.Default), r = ge(!1), s = ge(!1), l = ge(!1), d = ge(!0), y = ge(!1), u = ge(!1), { postNewsletterRegistration: m } = RLe(), h = e, c = (S) => {
      o.value = S, P.value;
    }, g = (S) => {
      y.value = S.value, u.value && (d.value = S.value);
    }, v = Te(() => ({
      items: [
        {
          id: "checkbox1",
          name: h.model.checkboxLabel,
          value: y.value
        }
      ],
      isValid: d.value
    })), P = Te(() => {
      const S = jT(o.value);
      return S ? a.value = Ht.Valid : a.value = Ht.Invalid, S;
    }), f = async () => {
      if (h.model.subscribeButtonModel.href) {
        const S = {
          newsletterId: h.model.newsletterId,
          email: o.value
        };
        if (u.value = !0, d.value = y.value, P.value && y.value) {
          const w = await m(
            S,
            h.model.subscribeButtonModel.href
          );
          w.status === lu.Success ? (r.value = !0, s.value = !1, i("submitted-newsletter", S)) : w.status === lu.AlreadySubscribed ? (r.value = !1, s.value = !0, i("already-subscribed", S)) : w.status === lu.Error && (r.value = !1, s.value = !1, l.value = !0, i("error", S));
        }
      }
    };
    return (S, w) => {
      const x = $e("BaseHeading"), k = $e("BaseText");
      return E(), X("div", NLe, [
        oe("div", {
          class: Pe(["d-newsletter-teaser", {
            "d-newsletter-teaser--bg-grey-on-white": e.model.backgroundColor === _(Zt).White,
            "d-newsletter-teaser--bg-white-on-grey": e.model.backgroundColor === _(Zt).Grey,
            "d-newsletter-teaser--bg-white-on-white": e.model.isWhiteOnWhite
          }])
        }, [
          ue(x, {
            "base-heading-type": _(ze).H2Section,
            class: "d-newsletter-teaser__heading"
          }, {
            default: Se(() => [
              Ve(Ie(e.model.headlineText), 1)
            ]),
            _: 1
          }, 8, ["base-heading-type"]),
          !r.value && !s.value && e.model.introText ? (E(), fe(ht, {
            key: 0,
            class: "d-newsletter-teaser__intro-text p",
            "html-text": e.model.introText
          }, null, 8, ["html-text"])) : te("", !0),
          !r.value && !s.value && !l.value ? (E(), X("form", {
            key: 1,
            id: "newsletterForm",
            class: "d-newsletter-teaser__container gap-2.5",
            onSubmit: w[0] || (w[0] = It((A) => f(), ["prevent"]))
          }, [
            ue(Es, {
              class: "d-newsletter-teaser__input",
              label: _(n)("globalTranslations.emailInputLabelText"),
              "input-value": o.value,
              "input-type": _(_n).Email,
              state: a.value,
              mandatory: !0,
              "error-text": _(n)("globalTranslations.emailInputHelperText"),
              "data-testid": "emailAddress",
              onOnKeyup: c
            }, null, 8, ["label", "input-value", "input-type", "state", "error-text"]),
            ue(vt, {
              "link-model": e.model.subscribeButtonModel,
              type: _(Ke).Primary,
              size: _(et).Large,
              "button-type": _(zt).Button,
              class: "d-newsletter-teaser__subscribe-button"
            }, null, 8, ["link-model", "type", "size", "button-type"]),
            ue(bg, {
              "data-testid": "checkbox1",
              class: "d-newsletter-teaser__checkbox",
              model: v.value,
              onSelectedItemChanged: g
            }, null, 8, ["model"])
          ], 32)) : te("", !0),
          r.value ? (E(), X("div", $Le, [
            ue(x, {
              "base-heading-type": _(ze).H3,
              class: "d-newsletter-teaser__confirmation-sub-heading"
            }, {
              default: Se(() => [
                ue(_(_t), {
                  "base-icon": _(H).CheckCircle,
                  "base-icon-color": _(gt).Inherit,
                  "base-icon-size": _(at).Inherit
                }, null, 8, ["base-icon", "base-icon-color", "base-icon-size"]),
                Ve(" " + Ie(e.model.confirmationSubHeadline), 1)
              ]),
              _: 1
            }, 8, ["base-heading-type"]),
            ue(ht, {
              "html-text": e.model.confirmationMessage,
              class: "p"
            }, null, 8, ["html-text"]),
            w[1] || (w[1] = oe("div", { "data-testid": "success" }, null, -1))
          ])) : te("", !0),
          s.value ? (E(), X("div", FLe, [
            ue(x, {
              "base-heading-type": _(ze).H3,
              class: "d-newsletter-teaser__confirmation-sub-heading"
            }, {
              default: Se(() => [
                ue(_(_t), {
                  "base-icon": _(H).ExclamationTriangle,
                  "base-icon-color": _(gt).Inherit,
                  "base-icon-size": _(at).Inherit
                }, null, 8, ["base-icon", "base-icon-color", "base-icon-size"]),
                Ve(" " + Ie(e.model.alreadySubscribedHeadline) + " ", 1),
                w[2] || (w[2] = oe("div", { "data-testid": "already" }, null, -1))
              ]),
              _: 1
            }, 8, ["base-heading-type"]),
            ue(ht, {
              "html-text": e.model.alreadySubscribedMessage,
              class: "p"
            }, null, 8, ["html-text"])
          ])) : te("", !0),
          l.value ? (E(), X("div", jLe, [
            ue(x, {
              "base-heading-type": _(ze).H3,
              class: "d-newsletter-teaser__confirmation-sub-heading"
            }, {
              default: Se(() => [
                ue(_(_t), {
                  "base-icon": _(H).ExclamationTriangle,
                  "base-icon-color": _(gt).Inherit,
                  "base-icon-size": _(at).Inherit
                }, null, 8, ["base-icon", "base-icon-color", "base-icon-size"]),
                Ve(" " + Ie(_(n)("newsletterTeaser.invalidErrorTextHeading")), 1)
              ]),
              _: 1
            }, 8, ["base-heading-type"]),
            ue(k, {
              text: _(n)("newsletterTeaser.invalidErrorText"),
              "font-size": _(st).SixteenPx,
              "font-type": _(lt).DwsSans,
              "text-color": _(dt).GreyBlue008
            }, null, 8, ["text", "font-size", "font-type", "text-color"]),
            w[3] || (w[3] = oe("div", { "data-testid": "error" }, null, -1))
          ])) : te("", !0),
          w[4] || (w[4] = oe("div", { class: "d-newsletter-teaser__left-triangle" }, null, -1)),
          w[5] || (w[5] = oe("div", { class: "d-newsletter-teaser__right-triangle" }, null, -1))
        ], 2)
      ]);
    };
  }
});
const yEe = /* @__PURE__ */ Fe(HLe, [["__scopeId", "data-v-d5af7ea4"]]), zLe = { class: "d-topic-tile-card" }, VLe = {
  key: 0,
  class: "d-topic-tile-card__container__item_image"
}, GLe = {
  key: 1,
  class: "d-topic-tile-card__container__item_image__compose__baseimage"
}, ULe = {
  key: 1,
  class: "d-topic-tile-card__container__item_no_image"
}, WLe = { class: "d-topic-tile-card__container__item_text" }, YLe = { class: "d-topic-tile-card__header" }, qLe = {
  key: 0,
  class: "d-topic-tile-card__number"
}, KLe = { class: "d-topic-tile-card__link" }, XLe = /* @__PURE__ */ Be({
  __name: "TopicTileCard",
  props: {
    model: {
      type: Object,
      required: !0
    },
    numbering: {
      type: Boolean,
      required: !1,
      default: !1
    },
    number: {
      type: Number,
      required: !1,
      default: 1
    }
  },
  setup(e) {
    const { isXXLAsync: t, isMobile: n } = xt(), i = e, o = Te(() => !i.model.image?.src || i.model.image.src.length === 0), a = Te(() => i.model.linkUrl);
    return (r, s) => {
      const l = $e("BaseImage"), d = $e("BaseHeading");
      return E(), X("div", zLe, [
        oe("div", {
          class: Pe(["d-topic-tile-card__container", {
            "d-topic-tile-card__container--left": e.model.imageAlignment === _(rm).Left,
            "d-topic-tile-card__container--right": e.model.imageAlignment === _(rm).Right,
            "d-topic-tile-card__container--full": o.value
          }])
        }, [
          o.value ? (E(), X("div", ULe)) : (E(), X("div", VLe, [
            e.model.brandElement ? (E(), fe(_(tT), {
              key: 0,
              image: e.model?.image,
              "aspect-ratio": _(t) ? _(on).OneToOne : _(on).Original
            }, null, 8, ["image", "aspect-ratio"])) : (E(), X("div", GLe, [
              o.value ? te("", !0) : (E(), fe(l, {
                key: 0,
                model: e.model?.image,
                "aspect-ratio": _(t) ? _(on).OneToOne : _(on).Original,
                class: "d-img"
              }, null, 8, ["model", "aspect-ratio"]))
            ]))
          ])),
          oe("div", WLe, [
            oe("div", YLe, [
              i.numbering ? (E(), X("div", qLe, Ie(i.number), 1)) : te("", !0),
              e.model?.headline ? (E(), fe(d, {
                key: 1,
                "base-heading-type": _(n) ? _(ze).H3 : _(ze).H2Section,
                class: "d-topic-tile-card__heading"
              }, {
                default: Se(() => [
                  ue(_(ss), {
                    html: e.model.headline,
                    purify: !1
                  }, null, 8, ["html"])
                ]),
                _: 1
              }, 8, ["base-heading-type"])) : te("", !0)
            ]),
            e.model.text ? (E(), fe(ht, {
              key: 0,
              "html-text": e.model.text,
              class: "d-topic-tile-card__text"
            }, null, 8, ["html-text"])) : te("", !0),
            oe("div", KLe, [
              e.model.ctaElementType === _(cn).Link ? (E(), fe(ot, {
                key: 0,
                class: "hidden xl:block pointer-events-auto",
                "link-model": a.value,
                icon: _(H).ArrowRight
              }, null, 8, ["link-model", "icon"])) : te("", !0),
              e.model.ctaElementType === _(cn).PrimaryButton ? (E(), fe(vt, {
                key: 1,
                "link-model": a.value,
                type: _(Ke).Primary,
                size: _(et).Medium,
                "button-type": _(zt).Link
              }, null, 8, ["link-model", "type", "size", "button-type"])) : te("", !0),
              e.model.ctaElementType === _(cn).SecondaryButton ? (E(), fe(vt, {
                key: 2,
                "link-model": a.value,
                type: _(Ke).Secondary,
                size: _(et).Medium,
                "button-type": _(zt).Link
              }, null, 8, ["link-model", "type", "size", "button-type"])) : te("", !0)
            ])
          ])
        ], 2)
      ]);
    };
  }
});
const ZLe = /* @__PURE__ */ Fe(XLe, [["__scopeId", "data-v-29d84b30"]]);
var rm = /* @__PURE__ */ ((e) => (e.Left = "left", e.Right = "right", e))(rm || {});
const JLe = { class: "d-topic-tile-content-block" }, QLe = { class: "d-topic-tile-content-block__container" }, eIe = { class: "d-topic-tile-content-block__heading" }, tIe = {
  key: 0,
  class: "d-topic-tile-content-block__cards"
}, nIe = /* @__PURE__ */ Be({
  __name: "TopicTileContentBlock",
  props: {
    topicTileContentBlockProps: {
      type: Object,
      required: !0
    }
  },
  setup(e) {
    return (t, n) => {
      const i = $e("BaseHeading");
      return E(), X("div", JLe, [
        oe("div", QLe, [
          oe("div", eIe, [
            e.topicTileContentBlockProps.title ? (E(), fe(i, {
              key: 0,
              "base-heading-type": _(ze).H2,
              class: "d-topic-tile-content-block__heading_title"
            }, {
              default: Se(() => [
                Ve(Ie(e.topicTileContentBlockProps.title), 1)
              ]),
              _: 1
            }, 8, ["base-heading-type"])) : te("", !0)
          ]),
          e.topicTileContentBlockProps?.items ? (E(), X("div", tIe, [
            (E(!0), X(Re, null, Ge(e.topicTileContentBlockProps?.items, (o, a) => (E(), X("div", {
              key: a,
              class: "d-topic-tile-content-block__cards__item"
            }, [
              ue(_(ZLe), {
                model: o,
                number: a + 1,
                numbering: e.topicTileContentBlockProps.numbering
              }, null, 8, ["model", "number", "numbering"])
            ]))), 128))
          ])) : te("", !0)
        ])
      ]);
    };
  }
});
const bEe = /* @__PURE__ */ Fe(nIe, [["__scopeId", "data-v-75a75f0a"]]);
var sm = /* @__PURE__ */ ((e) => (e.AsInput = "as-input", e.Reversed = "reversed", e))(sm || {}), ca = /* @__PURE__ */ ((e) => (e.Text = "text", e.Icon = "icon", e.Number = "number", e))(ca || {}), da = /* @__PURE__ */ ((e) => (e.GroupCaption = "group-caption", e.ContentBox = "content-box", e))(da || {}), cu = /* @__PURE__ */ ((e) => (e.Left = "left", e.Right = "right", e.Alternate = "alternate", e))(cu || {}), iIe = `
@layer primevue {
    .p-timeline {
        display: flex;
        flex-grow: 1;
        flex-direction: column;
    }

    .p-timeline-left .p-timeline-event-opposite {
        text-align: right;
    }

    .p-timeline-left .p-timeline-event-content {
        text-align: left;
    }

    .p-timeline-right .p-timeline-event {
        flex-direction: row-reverse;
    }

    .p-timeline-right .p-timeline-event-opposite {
        text-align: left;
    }

    .p-timeline-right .p-timeline-event-content {
        text-align: right;
    }

    .p-timeline-vertical.p-timeline-alternate .p-timeline-event:nth-child(even) {
        flex-direction: row-reverse;
    }

    .p-timeline-vertical.p-timeline-alternate .p-timeline-event:nth-child(odd) .p-timeline-event-opposite {
        text-align: right;
    }

    .p-timeline-vertical.p-timeline-alternate .p-timeline-event:nth-child(odd) .p-timeline-event-content {
        text-align: left;
    }

    .p-timeline-vertical.p-timeline-alternate .p-timeline-event:nth-child(even) .p-timeline-event-opposite {
        text-align: left;
    }

    .p-timeline-vertical.p-timeline-alternate .p-timeline-event:nth-child(even) .p-timeline-event-content {
        text-align: right;
    }

    .p-timeline-event {
        display: flex;
        position: relative;
        min-height: 70px;
    }

    .p-timeline-event:last-child {
        min-height: 0;
    }

    .p-timeline-event-opposite {
        flex: 1;
        padding: 0 1rem;
    }

    .p-timeline-event-content {
        flex: 1;
        padding: 0 1rem;
    }

    .p-timeline-event-separator {
        flex: 0;
        display: flex;
        align-items: center;
        flex-direction: column;
    }

    .p-timeline-event-marker {
        display: flex;
        align-self: baseline;
    }

    .p-timeline-event-connector {
        flex-grow: 1;
    }

    .p-timeline-horizontal {
        flex-direction: row;
    }

    .p-timeline-horizontal .p-timeline-event {
        flex-direction: column;
        flex: 1;
    }

    .p-timeline-horizontal .p-timeline-event:last-child {
        flex: 0;
    }

    .p-timeline-horizontal .p-timeline-event-separator {
        flex-direction: row;
    }

    .p-timeline-horizontal .p-timeline-event-connector {
        width: 100%;
    }

    .p-timeline-bottom .p-timeline-event {
        flex-direction: column-reverse;
    }

    .p-timeline-horizontal.p-timeline-alternate .p-timeline-event:nth-child(even) {
        flex-direction: column-reverse;
    }
}
`, aIe = {
  root: function(t) {
    var n = t.props;
    return ["p-timeline p-component", "p-timeline-" + n.align, "p-timeline-" + n.layout];
  },
  event: "p-timeline-event",
  opposite: "p-timeline-event-opposite",
  separator: "p-timeline-event-separator",
  marker: "p-timeline-event-marker",
  connector: "p-timeline-event-connector",
  content: "p-timeline-event-content"
}, oIe = Wt.extend({
  name: "timeline",
  css: iIe,
  classes: aIe
}), rIe = {
  name: "BaseTimeline",
  extends: wt,
  props: {
    value: null,
    align: {
      mode: String,
      default: "left"
    },
    layout: {
      mode: String,
      default: "vertical"
    },
    dataKey: null
  },
  style: oIe,
  provide: function() {
    return {
      $parentInstance: this
    };
  }
}, CL = {
  name: "Timeline",
  extends: rIe,
  methods: {
    getKey: function(t, n) {
      return this.dataKey ? We.resolveFieldData(t, this.dataKey) : n;
    },
    getPTOptions: function(t, n) {
      return this.ptm(t, {
        context: {
          index: n,
          count: this.value.length
        }
      });
    }
  }
};
function sIe(e, t, n, i, o, a) {
  return E(), X("div", Ce({
    class: e.cx("root")
  }, e.ptm("root"), {
    "data-pc-name": "timeline"
  }), [(E(!0), X(Re, null, Ge(e.value, function(r, s) {
    return E(), X("div", Ce({
      key: a.getKey(r, s),
      class: e.cx("event")
    }, a.getPTOptions("event", s)), [oe("div", Ce({
      class: e.cx("opposite", {
        index: s
      })
    }, a.getPTOptions("opposite", s)), [je(e.$slots, "opposite", {
      item: r,
      index: s
    })], 16), oe("div", Ce({
      class: e.cx("separator")
    }, a.getPTOptions("separator", s)), [je(e.$slots, "marker", {
      item: r,
      index: s
    }, function() {
      return [oe("div", Ce({
        class: e.cx("marker")
      }, a.getPTOptions("marker", s)), null, 16)];
    }), s !== e.value.length - 1 ? je(e.$slots, "connector", {
      key: 0,
      item: r,
      index: s
    }, function() {
      return [oe("div", Ce({
        class: e.cx("connector")
      }, a.getPTOptions("connector", s)), null, 16)];
    }) : te("", !0)], 16), oe("div", Ce({
      class: e.cx("content")
    }, a.getPTOptions("content", s)), [je(e.$slots, "content", {
      item: r,
      index: s
    })], 16)], 16);
  }), 128))], 16);
}
CL.render = sIe;
const lIe = { class: "d-timeline-block__outer" }, cIe = { class: "d-timeline-block container" }, dIe = { class: "d-timeline-block__inner" }, uIe = { class: "d-timeline-block__heading" }, hIe = {
  key: 1,
  class: "d-timeline-block__group-caption-icon"
}, pIe = {
  key: 1,
  class: "d-timeline-block__placeholder sm:hidden md:flex"
}, fIe = {
  key: 1,
  class: "d-timeline-block__group-caption-icon"
}, mIe = /* @__PURE__ */ Be({
  __name: "TimelineBlock",
  props: {
    timeline: {
      type: Object,
      required: !0
    },
    sortOrder: {
      type: String,
      default: sm.AsInput
    },
    boxesPosition: {
      type: String,
      default: cu.Alternate
    }
  },
  setup(e) {
    const t = e, n = Te(() => t.boxesPosition === cu.Left ? "right" : t.boxesPosition === cu.Right ? "left" : "alternate"), i = (d) => {
      const y = [];
      let u = {
        groupCaption: {
          type: da.GroupCaption,
          value: {
            groupCaption: "",
            type: ca.Text
          }
        },
        boxes: []
      }, m = {
        type: da.GroupCaption,
        value: {
          groupCaption: "",
          type: ca.Text
        }
      };
      return d.forEach((h) => {
        h.type === da.GroupCaption && h !== m ? (u = {
          groupCaption: h,
          boxes: []
        }, m = h, y.push(u)) : h.type === da.ContentBox && u && u.boxes.push(h);
      }), y;
    }, o = Te(() => i(r.value).reverse().flatMap((d) => [d.groupCaption, ...d.boxes.reverse()]));
    function a(d) {
      return d === 0 ? "custom-marker first-marker" : d === t.timeline.timelineItems?.length - 1 ? "custom-marker last-marker" : "custom-marker " + n.value;
    }
    const r = Te(() => s(t.timeline.timelineItems));
    function s(d) {
      return d?.map((y) => {
        if (y.type === da.GroupCaption) {
          const u = y.value;
          if (typeof u.groupCaption == "string") {
            const m = u.groupCaption.substring(0, 20);
            return {
              type: da.GroupCaption,
              value: {
                groupCaption: m,
                type: u.type
              }
            };
          }
        }
        return y;
      });
    }
    const l = Te(() => [
      {
        height: 192,
        width: 360,
        dxBreakpoint: Ct.Xs
      },
      {
        height: 176,
        width: 264,
        dxBreakpoint: Ct.Lg
      },
      {
        height: 261,
        width: 392,
        dxBreakpoint: Ct.Md
      },
      {
        height: 212,
        width: 318,
        dxBreakpoint: Ct.Xl
      }
    ]);
    return (d, y) => (E(), X("div", lIe, [
      oe("div", cIe, [
        oe("div", dIe, [
          oe("div", uIe, [
            ue(Ot, {
              "base-heading-type": _(ze).H2
            }, {
              default: Se(() => [
                Ve(Ie(e.timeline.headline), 1)
              ]),
              _: 1
            }, 8, ["base-heading-type"])
          ]),
          ue(_(CL), {
            value: e.sortOrder === _(sm).AsInput ? r.value : o.value,
            align: n.value,
            class: Pe(["d-timeline-block__timeline", n.value])
          }, {
            marker: Se((u) => [
              u.item.type === _(da).GroupCaption ? (E(), X("div", {
                key: 0,
                class: Pe(["hidden lg:block", a(u.index)])
              }, [
                u.item.value.type === _(ca).Text || u.item.value.type === _(ca).Number ? (E(), X("span", {
                  key: 0,
                  class: Pe(
                    u.item.value.type === _(ca).Text ? "d-timeline-block__group-caption" : "d-timeline-block__group-caption-number"
                  )
                }, [
                  ue(Ot, {
                    "base-heading-type": _(ze).H3
                  }, {
                    default: Se(() => [
                      Ve(Ie(u.item.value.groupCaption), 1)
                    ]),
                    _: 2
                  }, 1032, ["base-heading-type"])
                ], 2)) : te("", !0),
                u.item.value.type === _(ca).Icon ? (E(), X("span", hIe, [
                  ue(_t, {
                    "base-icon": u.item.value.groupCaption,
                    class: "icon"
                  }, null, 8, ["base-icon"])
                ])) : te("", !0)
              ], 2)) : te("", !0)
            ]),
            content: Se((u) => [
              u.item.type === _(da).ContentBox ? (E(), X("div", {
                key: 0,
                class: Pe(["d-timeline-block__box", n.value])
              }, [
                ue(Ot, {
                  "base-heading-type": _(ze).H3,
                  class: "d-timeline-block__box__heading"
                }, {
                  default: Se(() => [
                    Ve(Ie(u.item.value.title), 1)
                  ]),
                  _: 2
                }, 1032, ["base-heading-type"]),
                u.item.value.image ? (E(), fe(di, {
                  key: 0,
                  model: u.item.value.image,
                  class: "d-timeline-block__box__image",
                  "responsive-options": l.value
                }, null, 8, ["model", "responsive-options"])) : te("", !0),
                u.item.value.text ? (E(), fe(Tt, {
                  key: 1,
                  text: u.item.value.text,
                  class: "d-timeline-block__box__text"
                }, null, 8, ["text"])) : te("", !0),
                u.item.value.textLink?.text && u.item.value.textLink?.text !== "" ? (E(), fe(ot, {
                  key: 2,
                  "link-model": u.item.value.textLink,
                  class: "d-timeline-block__box__textlink",
                  icon: _(H).ArrowRight
                }, null, 8, ["link-model", "icon"])) : te("", !0)
              ], 2)) : te("", !0),
              u.item.type === _(da).GroupCaption ? (E(), X("div", pIe)) : te("", !0),
              u.item.type === _(da).GroupCaption ? (E(), X("div", {
                key: 2,
                class: Pe(["sm:flex lg:hidden", a(u.index)])
              }, [
                u.item.value.type === _(ca).Text || u.item.value.type === _(ca).Number ? (E(), X("span", {
                  key: 0,
                  class: Pe(
                    u.item.value.type === _(ca).Text ? "d-timeline-block__group-caption" : "d-timeline-block__group-caption-number"
                  )
                }, [
                  ue(Ot, {
                    "base-heading-type": _(ze).H3
                  }, {
                    default: Se(() => [
                      Ve(Ie(u.item.value.groupCaption), 1)
                    ]),
                    _: 2
                  }, 1032, ["base-heading-type"])
                ], 2)) : te("", !0),
                u.item.value.type === _(ca).Icon ? (E(), X("span", fIe, [
                  ue(_t, {
                    "base-icon": u.item.value.groupCaption,
                    class: "icon"
                  }, null, 8, ["base-icon"])
                ])) : te("", !0)
              ], 2)) : te("", !0)
            ]),
            _: 1
          }, 8, ["value", "align", "class"])
        ])
      ])
    ]));
  }
});
const xEe = /* @__PURE__ */ Fe(mIe, [["__scopeId", "data-v-ef8a19e5"]]), gIe = { class: "d-social-button" }, vIe = { class: "d-social-button__inner" }, yIe = {
  key: 0,
  class: "d-social-button__buttons"
}, bIe = /* @__PURE__ */ Be({
  __name: "SocialButton",
  props: {
    linkModel: {
      type: Object,
      required: !0
    },
    metaTags: {
      type: Object,
      required: !0
    }
  },
  setup(e) {
    const t = ge(!1), n = () => {
      t.value = !t.value;
    }, i = [
      Pt.Linkedin,
      Pt.Twitter,
      Pt.Facebook,
      Pt.Xing,
      Pt.Email
    ];
    return (o, a) => (E(), X("div", gIe, [
      oe("div", vIe, [
        t.value ? (E(), X("div", yIe, [
          (E(), X(Re, null, Ge(i, (r) => ue(Lh, {
            key: r,
            size: _(et).Small,
            model: {
              network: r,
              url: e.metaTags.ogUrl,
              title: e.metaTags.metaTitleWithFallbackAndSuffix,
              description: e.metaTags.ogDescription,
              hashtags: e.metaTags.metaKeywords,
              quote: e.metaTags.ogDescription
            }
          }, null, 8, ["size", "model"])), 64)),
          a[0] || (a[0] = oe("div", { class: "d-social-button__buttons-arrow" }, null, -1))
        ])) : te("", !0),
        ue(_(ot), {
          "link-model": e.linkModel,
          icon: _(H).Share,
          onClick: n,
          onKeydown: [
            Ze(n, ["enter"]),
            Ze(n, ["esc"])
          ]
        }, null, 8, ["link-model", "icon"])
      ])
    ]));
  }
});
const xIe = /* @__PURE__ */ Fe(bIe, [["__scopeId", "data-v-395954fa"]]), wIe = { class: "d-funds-in-focus" }, kIe = ["aria-label"], SIe = { class: "d-funds-in-focus__name" }, CIe = { class: "d-funds-in-focus__description" }, TIe = /* @__PURE__ */ Be({
  __name: "FundsInFocus",
  props: {
    fundsInFocus: {
      type: Object,
      required: !0
    }
  },
  setup(e) {
    const { t } = Je();
    function n(i) {
      Ue && i && window.open(i.href, i.target);
    }
    return (i, o) => {
      const a = $e("BaseHeading"), r = $e("BaseText");
      return E(), X("div", wIe, [
        ue(a, { class: "d-funds-in-focus__heading" }, {
          default: Se(() => [
            Ve(Ie(e.fundsInFocus.title), 1)
          ]),
          _: 1
        }),
        oe("div", {
          class: "d-funds-in-focus__content",
          tabindex: "0",
          role: "button",
          "aria-label": `${e.fundsInFocus.title} - ${e.fundsInFocus.linkModel.text}`,
          onKeypress: o[0] || (o[0] = Ze((s) => n(e.fundsInFocus.linkModel), ["enter"])),
          onClick: o[1] || (o[1] = (s) => n(e.fundsInFocus.linkModel))
        }, [
          oe("div", SIe, Ie(e.fundsInFocus.name), 1),
          oe("div", CIe, [
            ue(_(ht), {
              "html-text": e.fundsInFocus.description,
              "disable-default-styling": ""
            }, null, 8, ["html-text"])
          ]),
          ue(r, {
            text: _(t)("fundsInFocus.categoryLabel"),
            "font-size": _(st).TwelvePx,
            "font-type": _(lt).DwsSlabBold,
            "text-color": _(dt).GreyBlue009
          }, null, 8, ["text", "font-size", "font-type", "text-color"]),
          ue(r, {
            class: "d-funds-in-focus__category",
            text: `${e.fundsInFocus.category} / ${e.fundsInFocus.investorProfile}`
          }, null, 8, ["text"]),
          ue(ot, {
            "link-model": e.fundsInFocus.linkModel,
            icon: _(H).ArrowRight
          }, null, 8, ["link-model", "icon"])
        ], 40, kIe)
      ]);
    };
  }
});
const dx = /* @__PURE__ */ Fe(TIe, [["__scopeId", "data-v-29045fc5"]]), LIe = { class: "d-most-clicked" }, IIe = { class: "mb-6" }, PIe = /* @__PURE__ */ Be({
  __name: "MostClickedFunds",
  props: {
    mostClickedFundsProps: {
      type: Object,
      required: !0
    }
  },
  setup(e) {
    return (t, n) => {
      const i = $e("BaseHeading");
      return E(), X("div", LIe, [
        oe("div", IIe, [
          ue(i, null, {
            default: Se(() => [
              Ve(Ie(e.mostClickedFundsProps?.title), 1)
            ]),
            _: 1
          })
        ]),
        e.mostClickedFundsProps?.linkListModel ? (E(), fe(Qf, {
          key: 0,
          "view-model": e.mostClickedFundsProps?.linkListModel,
          "current-country": e.mostClickedFundsProps?.currentCountry,
          "show-all-when-no-country-selected": ""
        }, null, 8, ["view-model", "current-country"])) : te("", !0),
        !e.mostClickedFundsProps.isSingleDisclaimerHidden && e.mostClickedFundsProps.disclaimer ? (E(), fe(_(Na), {
          key: 1,
          class: "d-most-clicked__disclaimer",
          text: e.mostClickedFundsProps.disclaimer
        }, null, 8, ["text"])) : te("", !0)
      ]);
    };
  }
});
const ux = /* @__PURE__ */ Fe(PIe, [["__scopeId", "data-v-3670bc74"]]), AIe = { class: "d-product-teaser-top-products" }, _Ie = { class: "d-product-teaser-top-products__header" }, MIe = { class: "d-product-teaser-top-products__value" }, OIe = /* @__PURE__ */ Be({
  __name: "TopProducts",
  props: {
    topProductsProps: {
      type: Object,
      required: !0
    },
    trackingDropdownName: {
      type: String,
      default: "TopProductsDropdown"
    }
  },
  emits: ["selectedDisclaimerChanged"],
  setup(e, { emit: t }) {
    const n = e;
    let i;
    const o = ge(), a = ge(), r = t;
    it(async () => {
      s(n.topProductsProps.selectedYear);
    });
    const s = (l) => {
      i = l, a.value = n.topProductsProps?.topProductsLinkModel.filter(
        (d) => d.year === i.value
      ), o.value = n.topProductsProps?.disclaimer?.find(
        (d) => d.year === i.value
      ), r("selectedDisclaimerChanged", o.value.text);
    };
    return (l, d) => {
      const y = $e("BaseHeading");
      return E(), X("div", AIe, [
        oe("div", _Ie, [
          ue(y, {
            "base-heading-type": _(ze).H3,
            class: "d-product-teaser-top-products__title"
          }, {
            default: Se(() => [
              Ve(Ie(e.topProductsProps.title), 1)
            ]),
            _: 1
          }, 8, ["base-heading-type"]),
          ue(vi, {
            "has-filter": !1,
            selected: _(i),
            items: e.topProductsProps.yearsDropdownViewModel,
            "dropdown-type": _(Gt).Simple,
            "event-component-name": e.trackingDropdownName,
            onSelectedItemChanged: s
          }, null, 8, ["selected", "items", "dropdown-type", "event-component-name"])
        ]),
        (E(!0), X(Re, null, Ge(a.value, (u) => (E(), X("div", {
          key: u,
          class: "d-product-teaser-top-products__item"
        }, [
          ue(ot, {
            class: "d-product-teaser-top-products__link",
            "link-model": u.linkModel
          }, null, 8, ["link-model"]),
          oe("div", MIe, [
            ue(ad, {
              number: u.value,
              "add-percent": !1
            }, null, 8, ["number"])
          ])
        ]))), 128)),
        !e.topProductsProps.isSingleDisclaimerHidden && o.value && o.value.text ? (E(), fe(_(Na), {
          key: 0,
          class: "d-product-teaser-top-products__disclaimer",
          text: o.value.text
        }, null, 8, ["text"])) : te("", !0)
      ]);
    };
  }
});
const hx = /* @__PURE__ */ Fe(OIe, [["__scopeId", "data-v-92b5e7e3"]]), BIe = { key: 2 }, EIe = /* @__PURE__ */ Be({
  __name: "TeaserProduct",
  props: {
    teaserProductProps: {
      type: Object,
      required: !0
    }
  },
  setup(e) {
    const t = e, n = ge(""), { isDesktopAsync: i } = xt(), o = Te(() => t.teaserProductProps.topProductsProps.order < t.teaserProductProps.mostClickedFundsProps.order ? [
      n.value,
      t.teaserProductProps?.mostClickedFundsProps?.disclaimer
    ] : [
      t.teaserProductProps?.mostClickedFundsProps?.disclaimer,
      n.value
    ]), a = Te(() => ({
      ...t.teaserProductProps.mostClickedFundsProps,
      isSingleDisclaimerHidden: t.teaserProductProps.renderSingleDisclaimer
    })), r = Te(() => ({
      ...t.teaserProductProps.topProductsProps,
      isSingleDisclaimerHidden: t.teaserProductProps.renderSingleDisclaimer
    }));
    return (s, l) => (E(), X("div", {
      class: Pe(["d-teaser-product", {
        "d-teaser-product--grey-bg": e.teaserProductProps.backgroundColor === _(Zt).Grey
      }])
    }, [
      _(i) ? (E(), fe(rT, {
        key: 0,
        type: e.teaserProductProps.columnType
      }, {
        default: Se(() => [
          ue(_(pa), {
            order: e.teaserProductProps.mostClickedFundsProps.order
          }, {
            default: Se(() => [
              ue(ux, { "most-clicked-funds-props": a.value }, null, 8, ["most-clicked-funds-props"])
            ]),
            _: 1
          }, 8, ["order"]),
          ue(_(pa), {
            order: e.teaserProductProps.topProductsProps.order
          }, {
            default: Se(() => [
              ue(hx, {
                "top-products-props": r.value,
                onSelectedDisclaimerChanged: l[0] || (l[0] = (d) => n.value = d)
              }, null, 8, ["top-products-props"])
            ]),
            _: 1
          }, 8, ["order"]),
          ue(_(pa), {
            order: e.teaserProductProps.fundsInFocusProps.order
          }, {
            default: Se(() => [
              ue(dx, {
                "funds-in-focus": e.teaserProductProps.fundsInFocusProps
              }, null, 8, ["funds-in-focus"])
            ]),
            _: 1
          }, 8, ["order"])
        ]),
        _: 1
      }, 8, ["type"])) : (E(), fe(Mh, { key: 1 }, {
        default: Se(() => [
          ue(_(pa), {
            order: e.teaserProductProps.mostClickedFundsProps.order
          }, {
            default: Se(() => [
              ue(ux, { "most-clicked-funds-props": a.value }, null, 8, ["most-clicked-funds-props"])
            ]),
            _: 1
          }, 8, ["order"]),
          ue(_(pa), {
            order: e.teaserProductProps.topProductsProps.order
          }, {
            default: Se(() => [
              ue(hx, {
                "top-products-props": r.value,
                onSelectedDisclaimerChanged: l[1] || (l[1] = (d) => n.value = d)
              }, null, 8, ["top-products-props"])
            ]),
            _: 1
          }, 8, ["order"]),
          ue(_(pa), {
            order: e.teaserProductProps.fundsInFocusProps.order
          }, {
            default: Se(() => [
              ue(dx, {
                "funds-in-focus": e.teaserProductProps.fundsInFocusProps
              }, null, 8, ["funds-in-focus"])
            ]),
            _: 1
          }, 8, ["order"])
        ]),
        _: 1
      })),
      e.teaserProductProps.renderSingleDisclaimer ? (E(), X("div", BIe, [
        (E(!0), X(Re, null, Ge(o.value, (d, y) => (E(), fe(_(Na), {
          key: y,
          class: "d-teaser-product__disclaimer",
          text: d
        }, {
          default: Se(() => [
            Ve(Ie(d), 1)
          ]),
          _: 2
        }, 1032, ["text"]))), 128))
      ])) : te("", !0)
    ], 2));
  }
});
const wEe = /* @__PURE__ */ Fe(EIe, [["__scopeId", "data-v-b4f24fed"]]), DIe = { class: "d-card-portfolio__header" }, RIe = {
  key: 0,
  class: "d-card-portfolio__title--date"
}, NIe = { class: "d-card-portfolio__barchart" }, $Ie = {
  class: "d-card-portfolio__barchart--bar",
  style: { width: "100%" }
}, FIe = { class: "d-card-portfolio__content" }, jIe = ["onMouseenter"], HIe = { class: "allocation-row" }, zIe = { class: "allocation-name" }, VIe = { class: "percent" }, GIe = { key: 0 }, UIe = ["aria-label", "data-event_source", "data-event_component_name", "data-event_title"], px = 40, fx = 22, WIe = /* @__PURE__ */ Be({
  __name: "AllocationChartCard",
  props: {
    chart: {
      type: Object,
      required: !0
    }
  },
  setup(e) {
    const { t, n } = Je(), { isPrint: i } = Uu(), { pageName: o } = Qe(), { isSmallOrEqualMd: a } = xt(), r = ge([]), s = e, l = [
      "#73A22A",
      "#489CD2",
      "#5A6D78",
      "#91887E",
      "#2B5192",
      "#238B45",
      "#6A51A3",
      "#E8C64D",
      "#50711D",
      "#326D93",
      "#3F4C54",
      "#655F58",
      "#1E3966",
      "#186130",
      "#4A3972",
      "#A28B36"
    ], d = ge(!0), y = ge(), u = ge(0), m = ge(0);
    qe(i, () => {
      d.value = !i.value;
    });
    const h = [];
    s.chart.data.length > 0 && s.chart.data.forEach((O) => {
      h.push(O);
    }), M(h.filter((O) => !O.excludeFromCalculations));
    const c = h.findIndex((O) => O.excludeFromCalculations) - 1, g = Te(() => {
      if (h.length === 0)
        return null;
      const O = d.value ? v() : P();
      return M(O.result.filter((I) => !I.excludeFromCalculations)), {
        result: O.result,
        chartZeroPosition: O.chartZeroPosition,
        data: f(
          O.result.filter((I) => !I.excludeFromCalculations)
        )
      };
    });
    function v() {
      let O = [], I = 0;
      return h.length > 6 ? (O = w(h, 5, l), O.push(
        x(h, 5, h.length, l)
      ), I = S(
        O.filter((R) => !R.excludeFromCalculations),
        O.filter((R) => !R.excludeFromCalculations)?.length
      )) : (I = S(
        h.filter((R) => !R.excludeFromCalculations),
        h.filter((R) => !R.excludeFromCalculations)?.length
      ), O = w(h, h.length, l)), {
        result: O,
        chartZeroPosition: I
      };
    }
    function P() {
      let O = [], I = 0;
      return h.length >= 13 ? (O = w(h, 12, l), I = S(h, 12), O.push(
        x(h, 12, h.length, l)
      )) : (O = w(h, h.length, l), I = S(
        h.filter((R) => !R.excludeFromCalculations),
        h.filter((R) => !R.excludeFromCalculations)?.length
      )), {
        result: O,
        chartZeroPosition: I
      };
    }
    function f(O) {
      const I = [], R = [];
      return O.forEach((Y) => {
        Y.weighting < 0 ? I.push(Y) : R.push(Y);
      }), R.concat(
        I.sort((Y, F) => F.weighting - Y.weighting)
      );
    }
    function S(O, I) {
      let R = 0, Y = !1;
      for (let F = 0; F < I; F++)
        O[F].weighting >= 0 ? R += O[F].weighting : Y = !0;
      return Y ? R : null;
    }
    function w(O, I, R) {
      const Y = [];
      for (let F = 0; F < I; F++) {
        const U = {
          id: O[F].id,
          allocationName: O[F].allocationName,
          weighting: O[F].weighting,
          excludeFromCalculations: O[F].excludeFromCalculations,
          color: R[F]
        };
        Y.push(U);
      }
      return Y;
    }
    function x(O, I, R, Y) {
      let F = 0;
      for (let Q = I; Q < R; Q++)
        F += O[Q].weighting;
      return {
        id: "other",
        allocationName: t("allocationChart.card.othersText"),
        weighting: F,
        color: Y[I]
      };
    }
    function k(O) {
      const I = O?.split("{{");
      return I[0].length > px ? `${I[0].substring(0, px)}...{{` + I[1] : O;
    }
    function A(O) {
      return O?.length > fx ? `${O.substring(0, fx)}...` : O;
    }
    function $(O) {
      let I, R = "none";
      y.value ? (I = y.value?.id === O.id ? "1" : "0.25", R = y.value?.id === O.id ? "1px solid #D9DFE3" : "none") : I = "1";
      const Y = {
        width: Math.abs(O.weighting) * u.value + "%",
        background: O.color ?? void 0,
        opacity: I,
        border: R
      };
      return Object.entries(Y).map(([F, U]) => `${F}: ${U};`).join(" ");
    }
    function j(O) {
      y.value = O;
    }
    function N(O, I) {
      const R = y.value?.id === I.id ? "#f6f8f8" : "";
      let Y = -1;
      return d.value ? Y = O > 3 ? -1 : c : Y = c, {
        backgroundColor: R,
        borderBottom: Y === O ? "0.188rem solid #D9DFE3" : "0.0625rem solid #EBEEF0"
      };
    }
    function M(O) {
      let I = 0, R = 0;
      O.forEach((Y) => {
        Y.weighting >= 0 ? I += Y.weighting : R += Math.abs(Y.weighting);
      }), I = 100 / (I + R), u.value = I >= 1 ? I : 1, m.value = I;
    }
    function D() {
      d.value = !d.value;
    }
    const C = ge([]), b = ge([]), p = ge();
    zc(() => {
      C.value = [], b.value = [];
    });
    function L({
      trigger: O,
      headline: I,
      content: R,
      appendTo: Y,
      positionLeft: F = void 0,
      fixedPosition: U = !0
    }) {
      const { tippyInstance: Q } = pn({
        trigger: O,
        headline: I,
        content: R,
        appendTo: Y,
        showOnTouchDevices: !0,
        field: () => O,
        useSetFixedPosition: U,
        ...F !== void 0 && { positionLeft: F }
      });
      return Q;
    }
    function B(O, I, R) {
      let Y = R;
      const F = [];
      return O.forEach((U, Q) => {
        const J = I?.[Q]?.allocationName;
        if (J) {
          const ee = L({
            trigger: U,
            headline: J,
            content: J,
            appendTo: U,
            positionLeft: Y + U.offsetWidth / 2
          });
          F.push(ee);
        }
        Y += U.offsetWidth;
      }), F;
    }
    const T = Jn(
      async () => {
        r.value && r.value.length > 0 && r.value.forEach((O) => O?.destroy()), r.value = [], await mt(), r.value = B(
          C.value,
          g?.value?.data,
          a.value ? 20 : 40
        );
      },
      250,
      { maxWait: 500 }
    );
    return it(async () => {
      window.addEventListener("resize", T), await mt(), r.value = B(
        C.value,
        g?.value?.data,
        a.value ? 20 : 40
      ), b.value.forEach((O, I) => {
        const R = g?.value?.data[I].allocationName;
        if (R == null)
          return;
        const Y = A(R);
        R !== Y && L({
          trigger: O,
          headline: R,
          content: R,
          appendTo: O,
          fixedPosition: !1
        });
      }), L({
        trigger: p,
        headline: s.chart.title?.split("{")[0],
        content: s.chart.title?.split("{")[0],
        appendTo: p.value,
        fixedPosition: !1
      });
    }), (O, I) => {
      const R = $e("BaseHeading"), Y = $e("BaseIcon");
      return E(), fe(_(Ms), {
        bordered: !0,
        class: "d-card-portfolio"
      }, {
        title: Se(() => [
          oe("div", DIe, [
            oe("div", {
              ref_key: "titleTooltipTrigger",
              ref: p,
              class: "d-card-portfolio__title"
            }, [
              ue(R, {
                "base-heading-type": _(ze).H3
              }, {
                default: Se(() => [
                  ue(li, {
                    "foot-note-id": e.chart.footNoteAreaId,
                    text: k(e.chart.title)
                  }, null, 8, ["foot-note-id", "text"])
                ]),
                _: 1
              }, 8, ["base-heading-type"]),
              e.chart.asOfDate ? (E(), X("span", RIe, [
                ue(li, {
                  "foot-note-id": e.chart.footNoteAreaId,
                  text: e.chart.asOfDate
                }, null, 8, ["foot-note-id", "text"])
              ])) : te("", !0)
            ], 512),
            oe("div", NIe, [
              oe("div", $Ie, [
                (E(!0), X(Re, null, Ge(g.value?.data, (F, U) => (E(), X("div", {
                  key: F.allocationName,
                  ref_for: !0,
                  ref: (Q) => C.value[U] = Q,
                  style: hn($(F))
                }, null, 4))), 128))
              ]),
              g.value?.chartZeroPosition !== null ? (E(), X("div", {
                key: 0,
                class: "d-card-portfolio__barchart__zero",
                style: hn({
                  left: -1 * (100 - (g.value?.chartZeroPosition ?? 0) * m.value) + "%"
                })
              }, I[1] || (I[1] = [
                oe("span", { class: "d-card-portfolio__barchart__zero--plus" }, "+", -1),
                oe("span", { class: "d-card-portfolio__barchart__zero--minus" }, "-", -1)
              ]), 4)) : te("", !0)
            ])
          ])
        ]),
        content: Se(() => [
          oe("div", FIe, [
            oe("ul", null, [
              (E(!0), X(Re, null, Ge(g.value?.result, (F, U) => (E(), X("li", {
                key: F.id,
                ref_for: !0,
                ref: (Q) => b.value[U] = Q,
                style: hn(N(U, F)),
                onMouseenter: (Q) => j(F),
                onMouseleave: I[0] || (I[0] = (Q) => j(null))
              }, [
                oe("div", HIe, [
                  oe("span", zIe, [
                    F.excludeFromCalculations ? te("", !0) : (E(), X("i", {
                      key: 0,
                      style: hn({ background: l[U] }),
                      class: "circle-item"
                    }, null, 4)),
                    Ve(" " + Ie(A(F.allocationName)), 1)
                  ]),
                  oe("span", VIe, Ie(_(n)(F.weighting, "percent")), 1)
                ])
              ], 44, jIe))), 128))
            ])
          ])
        ]),
        footer: Se(() => [
          h.length > 6 ? (E(), X("div", GIe, [
            oe("button", {
              class: "triangle-button",
              "aria-label": `${d.value ? _(t)("showMoreShowLess.showMoreText") : _(t)("showMoreShowLess.showLessText")}`,
              "data-event_source": d.value ? null : _(o),
              "data-event_component_name": d.value ? null : "Accordion",
              "data-event_title": `${d.value ? null : e.chart.title?.split("{")[0]}`,
              onClick: D
            }, [
              ue(Y, {
                "base-icon": d.value ? _(H).Plus : _(H).Minus
              }, null, 8, ["base-icon"])
            ], 8, UIe)
          ])) : te("", !0)
        ]),
        _: 1
      });
    };
  }
});
const mx = /* @__PURE__ */ Fe(WIe, [["__scopeId", "data-v-6f6ff53d"]]), YIe = { class: "grid grid-cols-1 portfolio-cards" }, qIe = {
  key: 0,
  class: "portfolio-cards__fallback"
}, KIe = ["href"], XIe = { class: "flex print:flex-wrap sm:gap-x-10 m-auto portfolio-cards__no-carousel" }, ZIe = !0, JIe = /* @__PURE__ */ Be({
  __name: "AllocationChart",
  props: {
    values: {
      type: Object,
      required: !0
    }
  },
  setup(e) {
    const t = ge(Ue ? window.innerWidth : 0), n = [
      {
        breakpoint: "1699px",
        numVisible: 2,
        numScroll: 1
      },
      {
        breakpoint: "1280px",
        numVisible: 2,
        numScroll: 1
      },
      {
        breakpoint: "360px",
        numVisible: 1,
        numScroll: 1
      }
    ];
    it(() => {
      i(), Ue && window.addEventListener("resize", () => {
        t.value = window.innerWidth;
      });
    }), sn(() => {
      Ue && window.removeEventListener("resize", () => {
        t.value = window.innerWidth;
      });
    }), qe(t, (o, a) => {
      o !== a && i();
    });
    async function i() {
      if (await mt(), Ue) {
        const o = document.getElementsByClassName(
          "d-card-portfolio__title"
        );
        let a = 0;
        for (let r = 0; r < o.length; r++)
          a < o[r].clientHeight && (a = o[r].clientHeight);
        for (let r = 0; r < o.length; r++) {
          const s = o[r];
          a > 60 ? (s.classList.remove("one-line-height"), s.classList.add("two-line-height")) : (s.classList.remove("two-line-height"), s.classList.add("one-line-height"));
        }
      }
    }
    return (o, a) => {
      const r = $e("BaseIcon"), s = Ut("smooth-scroll");
      return E(), X("div", YIe, [
        oe("div", {
          class: Pe(["col-span-1 portfolio-cards__row", [e.values?.cards?.length > 2 ? "block xxl:hidden" : "block"]])
        }, [
          !e.values?.cards || e.values?.cards?.length === 0 ? (E(), X("p", qIe, [
            ue(r, {
              "base-icon": _(H).InfoCircle,
              "base-icon-size": _(at).S,
              "base-icon-color": _(gt).Inherit
            }, null, 8, ["base-icon", "base-icon-size", "base-icon-color"]),
            Ve(" " + Ie(e.values?.fallbackText) + " ", 1),
            e.values?.furtherPortfolioInfoButton ? rt((E(), X("a", {
              key: 0,
              href: e.values?.furtherPortfolioInfoButton
            }, [
              ue(r, {
                "base-icon": _(H).AngleRight,
                "base-icon-size": _(at).S,
                "base-icon-color": _(gt).Inherit
              }, null, 8, ["base-icon", "base-icon-size", "base-icon-color"])
            ], 8, KIe)), [
              [s]
            ]) : te("", !0)
          ])) : te("", !0),
          e.values?.cards && e.values?.cards?.length > 0 ? (E(), X("div", {
            key: 1,
            class: Pe([e.values?.cards?.length > 2 ? "touch-scroll" : "flex"])
          }, [
            oe("div", XIe, [
              (E(!0), X(Re, null, Ge(e.values?.cards, (l, d) => (E(), X("div", { key: d }, [
                ue(mx, {
                  chart: {
                    footNoteAreaId: e.values?.id,
                    title: l.title,
                    asOfDate: l.asOfDate,
                    data: l.data
                  }
                }, null, 8, ["chart"])
              ]))), 128))
            ])
          ], 2)) : te("", !0)
        ], 2),
        e.values?.cards && e.values?.cards?.length > 0 ? (E(), X("div", {
          key: 0,
          class: Pe({
            "hidden xxl:block print:hidden dws-carousel-container": e.values?.cards?.length > 2,
            hidden: e.values?.cards?.length <= 2
          })
        }, [
          ue(ik, {
            value: e.values.cards,
            circular: !1,
            "responsive-options": n,
            "num-scroll": 1,
            "num-visible": 3
          }, {
            item: Se((l) => [
              ue(mx, {
                chart: {
                  footNoteAreaId: e.values?.id,
                  title: l.data.title,
                  asOfDate: l.data.asOfDate,
                  data: l.data.data
                }
              }, null, 8, ["chart"])
            ]),
            _: 1
          }, 8, ["value"])
        ], 2)) : te("", !0),
        ue(ja, {
          id: e.values.id,
          values: e.values,
          class: "portfolio-cards__footnote"
        }, null, 8, ["id", "values"]),
        (E(!0), X(Re, null, Ge(e.values?.disclaimerHtml, (l) => (E(), fe(Mr, {
          key: l.text,
          values: l.text,
          class: "col-span-1 lg:col-span-1 portfolio-cards__disclaimer mt-8",
          "number-column": 1,
          "smaller-font-size": ZIe
        }, null, 8, ["values"]))), 128))
      ]);
    };
  }
});
const kEe = /* @__PURE__ */ Fe(JIe, [["__scopeId", "data-v-e5229ad5"]]), QIe = {
  key: 0,
  class: "bullet-point-list"
}, ePe = { class: "bullet-point-list__item__text" }, tPe = /* @__PURE__ */ Be({
  __name: "BulletPointList",
  props: {
    bulletPoints: { default: () => [] }
  },
  setup(e) {
    const t = e;
    return (n, i) => {
      const o = $e("BaseIcon");
      return n.bulletPoints && n.bulletPoints.length > 0 ? (E(), X("ul", QIe, [
        (E(!0), X(Re, null, Ge(t.bulletPoints, (a) => (E(), X("li", {
          key: a,
          class: "bullet-point-list__item"
        }, [
          ue(o, {
            class: "bullet-point-list__item__icon",
            "base-icon": _(H).CheckCircle,
            "base-icon-color": _(gt).Default,
            "base-icon-size": _(at).S
          }, null, 8, ["base-icon", "base-icon-color", "base-icon-size"]),
          oe("p", ePe, [
            ue(_(ht), {
              "html-text": a,
              "disable-default-styling": ""
            }, null, 8, ["html-text"])
          ])
        ]))), 128))
      ])) : te("", !0);
    };
  }
});
const SEe = /* @__PURE__ */ Fe(tPe, [["__scopeId", "data-v-e7e1e822"]]), nPe = { class: "d-disclaimer" }, iPe = ["src", "alt"], aPe = {
  key: 0,
  class: "d-disclaimer__disclaimer"
}, oPe = { class: "p-dialog-footer__hint" }, rPe = { class: "button-group p-button-group" }, sPe = /* @__PURE__ */ Be({
  __name: "BuyAndSell",
  props: {
    model: {
      type: Object,
      required: !0
    },
    visible: {
      type: Boolean,
      required: !1,
      default: !1
    }
  },
  setup(e, { expose: t }) {
    const { t: n } = Je(), i = ge(""), o = ge(null), { pageName: a } = Qe(), r = ge(a), s = e;
    t({
      openModal: u
    });
    const l = ge(s.visible);
    function d() {
      l.value = !1;
    }
    function y() {
      l.value = !1;
      const v = h.value?.link;
      v && Ue && window.open(v, "_blank")?.focus();
    }
    function u() {
      i.value = "", l.value = !0;
    }
    async function m() {
      if (o.value) {
        const v = o.value, P = v.parentElement, f = v.offsetHeight;
        P?.className && (await mt(), P.scrollTo({
          top: f,
          behavior: "smooth"
        }));
      }
    }
    const h = Te(() => s.model?.handlers.find((P) => P.key === i.value)), c = ge([]);
    zc(() => {
      c.value = [];
    });
    async function g() {
      await mt(), c.value.forEach((v, P) => {
        pn({
          trigger: v,
          content: s.model?.handlers[P].name,
          appendTo: "parent",
          showOnTouchDevices: !0,
          field: () => v
        });
      });
    }
    return it(g), hm(g), (v, P) => {
      const f = $e("BaseHeading");
      return E(), X("div", nPe, [
        ue(_(Ei), {
          visible: l.value,
          "onUpdate:visible": P[1] || (P[1] = (S) => l.value = S),
          class: "p-smooth-scroller d-disclaimer",
          position: _(aa).Center,
          onCloseDialog: d
        }, {
          header: Se(() => [
            oe("div", null, [
              ue(f, {
                "base-heading-type": _(ze).H2Section
              }, {
                default: Se(() => [
                  Ve(Ie(e.model?.headerText), 1)
                ]),
                _: 1
              }, 8, ["base-heading-type"])
            ])
          ]),
          content: Se(() => [
            oe("div", {
              ref_key: "handlers",
              ref: o,
              class: "grid grid-cols-1 lg:grid-cols-2 xxl:grid-cols-4 d-disclaimer__handlers"
            }, [
              (E(!0), X(Re, null, Ge(e.model?.handlers, (S, w) => (E(), X("div", {
                key: S.key,
                class: "d-disclaimer__radios flex m-4"
              }, [
                ue(_(Or), {
                  id: S.key,
                  modelValue: i.value,
                  "onUpdate:modelValue": P[0] || (P[0] = (x) => i.value = x),
                  class: "field",
                  value: S.key,
                  "aria-label": S.key,
                  onChange: m
                }, null, 8, ["id", "modelValue", "value", "aria-label"]),
                oe("figure", null, [
                  oe("img", {
                    ref_for: !0,
                    ref: (x) => S.name ? c.value[w] = x : void 0,
                    class: "field d-disclaimer__radio__label",
                    src: S.icon,
                    alt: S.name
                  }, null, 8, iPe),
                  oe("figcaption", null, [
                    rt(oe("span", null, Ie(S.name), 513), [
                      [xn, S.key == i.value]
                    ])
                  ])
                ])
              ]))), 128))
            ], 512),
            i.value !== "" ? (E(), X("div", aPe, [
              h.value?.disclaimer !== "" ? (E(), fe(f, {
                key: 0,
                "base-heading-type": _(ze).H3
              }, {
                default: Se(() => [
                  Ve(Ie(_(n)("globalTranslations.disclaimerTitle")), 1)
                ]),
                _: 1
              }, 8, ["base-heading-type"])) : te("", !0),
              oe("div", null, [
                ue(_(ht), {
                  "html-text": h.value?.disclaimer,
                  "disable-default-styling": ""
                }, null, 8, ["html-text"])
              ])
            ])) : te("", !0)
          ]),
          footer: Se(() => [
            oe("div", oPe, Ie(e.model?.hintText), 1),
            oe("div", rPe, [
              ue(vt, {
                id: "buyAndSellCancelButton",
                type: _(Ke).Secondary,
                size: _(et).Small,
                "link-model": {
                  title: _(n)("globalTranslations.disclaimerCancelButtonLabel"),
                  text: _(n)("globalTranslations.disclaimerCancelButtonLabel"),
                  tealiumTrackingModel: {
                    eventSource: r.value,
                    eventComponentName: "Buy and Sell Disclaimer",
                    eventTitle: "Cancel"
                  }
                },
                onClick: d
              }, null, 8, ["type", "size", "link-model"]),
              ue(vt, {
                id: "buyAndSellConfirmButton",
                type: _(Ke).Primary,
                size: _(et).Small,
                "link-model": {
                  title: _(n)("globalTranslations.disclaimerConfirmButtonLabel"),
                  text: _(n)("globalTranslations.disclaimerConfirmButtonLabel"),
                  tealiumTrackingModel: {
                    eventSource: r.value,
                    eventComponentName: "Buy and Sell Disclaimer",
                    eventTitle: "Confirm",
                    eventTarget: i.value
                  }
                },
                disabled: i.value === "",
                "data-id": "silktide-accept",
                onClick: y
              }, null, 8, ["type", "size", "link-model", "disabled"])
            ])
          ]),
          _: 1
        }, 8, ["visible", "position"])
      ]);
    };
  }
});
const CEe = /* @__PURE__ */ Fe(sPe, [["__scopeId", "data-v-b0602e98"]]), lPe = ["data-event_source", "data-event_component_name", "data-event_title", "data-event_target", "aria-label"], cPe = { class: "d-download-item__content__wrapper" }, dPe = { class: "d-download-item__content__infowrapper" }, uPe = { class: "d-download-item__content--title" }, hPe = {
  key: 0,
  class: "d-download-item__content--subtitle"
}, pPe = { class: "d-download-item__content__metadata" }, fPe = {
  key: 0,
  class: "d-download-item__content__metadata--language"
}, mPe = {
  key: 1,
  class: "d-download-item__content__locked-register"
}, gPe = { class: "d-download-item__content__locked-register--label" }, vPe = /* @__PURE__ */ Be({
  __name: "DownloadItem",
  props: {
    model: {
      type: Object,
      required: !0
    },
    update: {
      type: Number,
      required: !1,
      default: 0
    }
  },
  emits: ["locked-content-clicked"],
  setup(e, { emit: t }) {
    const { t: n } = Je(), { pageName: i } = Qe(), o = i, a = ge("Download"), r = ge(), s = sP(r.value), l = ge(!1), d = ge(!1), { osIsIos: y } = Cl(), { isMobile: u } = xt(), m = ge(), h = e, c = ge(), g = t, v = () => h.model.tooltipText && h.model.tooltipText?.length >= 1 || l.value;
    function P(D) {
      if (h.model.isLocked) {
        g("locked-content-clicked", h.model);
        return;
      }
      window.open(D, "_blank", "noopener noreferrer");
    }
    const f = nw(S, 700);
    function S(D) {
      if (!y) {
        if (u.value && v() && !d.value) {
          d.value = !0;
          return;
        }
        (!v() || d.value || !u.value) && P(D);
      }
    }
    function w(D) {
      if (y) {
        if (v() && !d.value) {
          d.value = !0;
          return;
        }
        (!v() || d.value) && P(D);
      }
    }
    function x(D) {
      S(D);
    }
    function k() {
      const C = [
        h?.model?.title || "",
        h?.model?.subTitle || "",
        h?.model?.culture?.substring(0, 2)?.toLowerCase() || h?.model?.language?.toLowerCase() !== "" ? h?.model?.language : "",
        h?.model?.date || ""
      ].filter((b) => b).join("; ");
      return C ? `${C}, ${n("eventList.download")}` : n("eventList.download");
    }
    const A = new RT(() => {
      $();
    }), $ = Jn(
      () => {
        N();
      },
      250,
      { maxWait: 500 }
    ), j = () => {
      r.value && s && (h.model.isLocked ? l.value = r.value?.getBoundingClientRect().width < r.value?.scrollWidth : (l.value = r.value?.clientWidth < r.value?.scrollWidth, l.value || (m?.value?.destroy(), m.value = null)));
    }, N = () => {
      if (j(), !m.value) {
        if (h.model.tooltipText && h.model.tooltipText?.length >= 1) {
          A.unobserve(r.value);
          const { tippyInstance: D } = pn({
            trigger: c,
            headline: h.model.title,
            content: h.model.tooltipText,
            appendTo: c.value,
            showOnTouchDevices: !0,
            field: () => c
          });
          m.value = D;
        } else if (l.value) {
          A.unobserve(r.value);
          const { tippyInstance: D } = pn({
            trigger: c,
            headline: h.model.title,
            content: h.model.title,
            appendTo: c.value,
            showOnTouchDevices: !0,
            field: () => c
          });
          m.value = D;
        }
      }
    };
    it(() => {
      A.observe(c.value), ym(c, () => d.value = !1);
    });
    const M = () => h.model.isLocked ? H.Lock : H.Download;
    return (D, C) => {
      const b = $e("BaseIcon");
      return E(), X("div", {
        ref_key: "downloadItemTooltipTrigger",
        ref: c,
        class: "d-download-item",
        "data-event_source": _(o),
        "data-event_component_name": a.value,
        "data-event_title": e.model.title,
        "data-event_target": e.model.source,
        tabindex: "0",
        role: "button",
        "aria-label": k(),
        onKeydown: C[0] || (C[0] = Ze((p) => x(e.model.source), ["enter"])),
        onClick: C[1] || (C[1] = (p) => _(f)(e.model.source)),
        onTouchend: C[2] || (C[2] = (p) => w(e.model.source))
      }, [
        oe("div", {
          class: Pe(["d-download-item__content", {
            "d-download-item__content--locked": e.model.isLocked
          }])
        }, [
          oe("div", cPe, [
            ue(b, {
              class: "d-download-item__content--icon",
              "base-icon": M(),
              "base-icon-size": _(at).L
            }, null, 8, ["base-icon", "base-icon-size"]),
            oe("div", dPe, [
              oe("p", uPe, [
                oe("span", {
                  ref_key: "titleText",
                  ref: r,
                  class: "d-download-item__content--title__text"
                }, Ie(e.model.title), 513)
              ]),
              e.model.subTitle && !e.model.isLocked ? (E(), X("span", hPe, Ie(e.model.subTitle), 1)) : te("", !0),
              oe("span", pPe, [
                e.model.culture && e.model.language && e.model.culture?.substring(0, 2).toLowerCase() !== e.model.language.toLowerCase() ? (E(), X("span", fPe, Ie(e.model.language), 1)) : te("", !0),
                e.model.date ? (E(), X(Re, { key: 1 }, [
                  ue(b, {
                    class: "d-download-item__content__metadata__calendar-icon",
                    "base-icon": _(H).CalendarAlt,
                    "base-icon-size": _(at).S,
                    "base-icon-color": _(gt).Inherit
                  }, null, 8, ["base-icon", "base-icon-size", "base-icon-color"]),
                  Ve(" " + Ie(e.model.date), 1)
                ], 64)) : te("", !0),
                e.model.isNew == !0 ? (E(), fe(Ji, {
                  key: 2,
                  "tag-text": _(n)("globalTranslations.isNewLabel"),
                  "background-color": _(En).GreyBlue009,
                  color: _(mi).White,
                  "is-border-visible": !1
                }, null, 8, ["tag-text", "background-color", "color"])) : te("", !0)
              ]),
              e.model.isLocked ? (E(), X("div", mPe, [
                oe("span", gPe, Ie(_(n)("globalTranslations.loginOrRegisterLabel")), 1),
                ue(b, {
                  class: "d-download-item__content__locked-register--icon",
                  "base-icon": _(H).ArrowRight,
                  "base-icon-size": _(at).Inherit
                }, null, 8, ["base-icon", "base-icon-size"])
              ])) : te("", !0)
            ])
          ])
        ], 2)
      ], 40, lPe);
    };
  }
});
const gx = /* @__PURE__ */ Fe(vPe, [["__scopeId", "data-v-4eda392a"]]);
var lm = /* @__PURE__ */ ((e) => (e.All = "all", e.Filtered = "filtered", e))(lm || {}), cm = /* @__PURE__ */ ((e) => (e.Country = "country", e.Year = "year", e))(cm || {});
const yPe = ["aria-label"], bPe = /* @__PURE__ */ Be({
  __name: "ToggleButton",
  props: {
    modelValue: Boolean
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const { t: n } = Je(), o = ge(e.modelValue), a = t, r = (d) => {
      a("update:modelValue", d);
    }, s = Te(() => n(
      o.value ? "showMoreShowLess.showLessText" : "showMoreShowLess.showMoreText"
    ));
    function l() {
      o.value = !o.value, r(o.value);
    }
    return (d, y) => {
      const u = $e("BaseIcon");
      return E(), X("div", {
        class: "d-expand-button",
        tabindex: "0",
        role: "button",
        "aria-label": s.value,
        onKeydown: Ze(l, ["enter"]),
        onClick: l
      }, [
        ue(u, {
          "base-icon": o.value ? _(H).Minus : _(H).Plus,
          "base-icon-size": _(at).Inherit
        }, null, 8, ["base-icon", "base-icon-size"]),
        Ve(" " + Ie(s.value), 1)
      ], 40, yPe);
    };
  }
});
const vx = /* @__PURE__ */ Fe(bPe, [["__scopeId", "data-v-c9b3cd23"]]), xPe = { class: "d-download-list" }, wPe = {
  key: 1,
  class: "d-download-list__filter-selectors"
}, kPe = { class: "d-download-list__filter-selectors__filter" }, SPe = { class: "d-download-list__filter-selectors__filter" }, CPe = ["id"], TPe = {
  key: 0,
  class: "d-download-list__group__headline"
}, LPe = {
  key: 1,
  class: "d-download-list__expand-button"
}, IPe = {
  key: 0,
  class: "d-download-list__expand-button"
}, yx = 6, PPe = /* @__PURE__ */ Be({
  __name: "DownloadList",
  props: {
    model: {
      type: Object,
      required: !0
    }
  },
  emits: ["filter-value-changed", "locked-content-clicked"],
  setup(e, { emit: t }) {
    const { t: n } = Je(), i = ge(0), a = ge(e.model.downloadGroups), r = t, s = Pn(), l = (h, c) => {
      r("filter-value-changed", h, c);
    }, d = (h) => h?.filterType == lm.Filtered && h?.downloadItems?.length > (h?.filteredItemCount ?? yx), y = (h) => {
      const c = h?.filteredItemCount ? h?.filteredItemCount : yx;
      return !h?.showAll && h?.filterType == lm.Filtered ? h?.downloadItems?.slice(0, c) : h?.downloadItems;
    }, u = (h) => {
      i.value = h;
    }, m = (h) => {
      r("locked-content-clicked", h);
    };
    return (h, c) => {
      const g = $e("BaseHeading");
      return E(), X("div", xPe, [
        e.model.headline ? (E(), fe(g, {
          key: 0,
          "base-heading-type": _(ze).H2,
          class: "d-download-list__heading"
        }, {
          default: Se(() => [
            Ve(Ie(e.model.headline), 1)
          ]),
          _: 1
        }, 8, ["base-heading-type"])) : te("", !0),
        e.model?.filters ? (E(), X("div", wPe, [
          oe("div", kPe, [
            ue(_(Tt), {
              id: `${_(s)}-country-label`,
              text: e.model?.filters?.filterByCountryLabel,
              "text-color": _(dt).GreyBlue009,
              "font-size": _(st).TwelvePx,
              "font-type": _(lt).DwsSlabBold
            }, null, 8, ["id", "text", "text-color", "font-size", "font-type"]),
            e.model?.filters?.countryFilter?.length > 0 ? (E(), fe(_(vi), {
              key: 0,
              items: e.model?.filters?.countryFilter,
              "dropdown-type": _(Gt).Simple,
              "has-filter": !1,
              "show-image": !1,
              selected: e.model?.filters?.countryFilter?.filter((v) => v.isSelected)?.[0],
              "event-component-name": "Filter by country",
              "event-title": `Filtering country | ${e.model?.filters?.countryFilter?.filter((v) => v.isSelected)?.[0]?.name}`,
              "aria-labelledby": `${_(s)}-country-label`,
              onSelectedItemChanged: c[0] || (c[0] = (v) => l(_(cm).Country, v))
            }, null, 8, ["items", "dropdown-type", "selected", "event-title", "aria-labelledby"])) : te("", !0)
          ]),
          oe("div", SPe, [
            ue(_(Tt), {
              id: `${_(s)}-year-label`,
              text: e.model?.filters?.filterByYearLabel,
              "text-color": _(dt).GreyBlue009,
              "font-size": _(st).TwelvePx,
              "font-type": _(lt).DwsSlabBold
            }, null, 8, ["id", "text", "text-color", "font-size", "font-type"]),
            e.model?.filters?.yearFilter?.length > 0 ? (E(), fe(_(vi), {
              key: 0,
              items: e.model?.filters?.yearFilter,
              "dropdown-type": _(Gt).Simple,
              "has-filter": !1,
              "show-image": !1,
              selected: e.model?.filters?.yearFilter?.filter((v) => v.isSelected)?.[0],
              "event-component-name": "Filter by country",
              "event-title": `Filtering country | ${e.model?.filters?.yearFilter?.filter((v) => v.isSelected)?.[0]?.name}`,
              "aria-labelledby": `${_(s)}-year-label`,
              onSelectedItemChanged: c[1] || (c[1] = (v) => l(_(cm).Year, v))
            }, null, 8, ["items", "dropdown-type", "selected", "event-title", "aria-labelledby"])) : te("", !0)
          ])
        ])) : te("", !0),
        e.model.showAccordion ? (E(), fe(_(nv), {
          key: 3,
          "show-buttons": e.model.showAccordionToggleButton,
          onTabOpen: c[2] || (c[2] = (v) => u(v))
        }, {
          default: Se(() => [
            (E(!0), X(Re, null, Ge(a.value, (v, P) => (E(), fe(_(Fh), {
              id: `download-items-${P}`,
              key: P,
              header: v.headlineText,
              expanded: v.groupOpened
            }, {
              default: Se(() => [
                oe("div", {
                  class: Pe(["grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-x-8", { "mb-12": !d(v) }])
                }, [
                  (E(!0), X(Re, null, Ge(y(v), (f, S) => (E(), X("div", { key: S }, [
                    ue(gx, {
                      model: f,
                      update: i.value,
                      onLockedContentClicked: m
                    }, null, 8, ["model", "update"])
                  ]))), 128))
                ], 2),
                d(v) ? (E(), X("div", IPe, [
                  ue(vx, {
                    modelValue: v.showAll,
                    "onUpdate:modelValue": (f) => v.showAll = f
                  }, null, 8, ["modelValue", "onUpdate:modelValue"])
                ])) : te("", !0)
              ]),
              _: 2
            }, 1032, ["id", "header", "expanded"]))), 128))
          ]),
          _: 1
        }, 8, ["show-buttons"])) : (E(!0), X(Re, { key: 2 }, Ge(a.value.filter((v) => v !== void 0), (v, P) => (E(), X("div", {
          id: `download-items-${P}`,
          key: P,
          class: "d-download-list__group"
        }, [
          v?.headlineText ? (E(), X("div", TPe, [
            ue(g, {
              "base-heading-type": _(ze).H3
            }, {
              default: Se(() => [
                Ve(Ie(v.headlineText), 1)
              ]),
              _: 2
            }, 1032, ["base-heading-type"])
          ])) : te("", !0),
          oe("div", {
            class: Pe(["d-download-list__group__items", { "mb-12": !d(v) }])
          }, [
            (E(!0), X(Re, null, Ge(y(v), (f, S) => (E(), X("div", { key: S }, [
              ue(gx, {
                model: f,
                onLockedContentClicked: m
              }, null, 8, ["model"])
            ]))), 128))
          ], 2),
          d(v) ? (E(), X("div", LPe, [
            ue(vx, {
              modelValue: v.showAll,
              "onUpdate:modelValue": (f) => v.showAll = f
            }, null, 8, ["modelValue", "onUpdate:modelValue"])
          ])) : te("", !0)
        ], 8, CPe))), 128)),
        !e.model?.downloadGroups?.length || e.model?.downloadGroups.every((v) => v === void 0) ? (E(), fe(_(Tt), {
          key: 4,
          text: _(n)("downloads.fallbackText"),
          "font-size": _(st).FourteenPx,
          "font-type": _(lt).DwsSans,
          "text-color": _(dt).GreyBlue006
        }, null, 8, ["text", "font-size", "font-type", "text-color"])) : te("", !0)
      ]);
    };
  }
});
const TEe = /* @__PURE__ */ Fe(PPe, [["__scopeId", "data-v-5ce04d10"]]);
var jt = /* @__PURE__ */ ((e) => (e.Default = "default", e.DisclaimerOnly = "disclaimer-only", e.CountryOnly = "country-only", e.AudienceOnly = "audience-only", e.CountryAndDisclaimer = "country-and-disclaimer", e.OtherCountry = "other-country", e.OtherCountryRelation = "other-country-relation", e.OtherCountryDisclaimer = "other-country-disclaimer", e))(jt || {}), Qa = /* @__PURE__ */ ((e) => (e.ExistingInvestor = "existing-investor", e.NonExistingInvestor = "nonExisting-investor", e))(Qa || {});
const APe = (e) => ({
  getValidateIsin: async (n) => {
    try {
      const o = (e || "/EntryGate/other-country-validate-isin") + "?isin=" + n, { data: a } = await Wu().post(o, {});
      return a?.value.Results;
    } catch (i) {
      throw console.error("Error validating ISIN:", i), i;
    }
  }
});
function _Pe(e) {
  const t = e || typeof window < "u" && window;
  return !!(t && (/Chromatic/.test(t.navigator.userAgent) || /chromatic=true/.test(t.location.href)));
}
const MPe = { class: "d-entry-gate" }, OPe = { class: "d-entry-gate__image-container" }, BPe = { class: "d-entry-gate__content-container" }, EPe = {
  key: 0,
  class: "d-entry-gate__decision"
}, DPe = {
  key: 0,
  class: "d-entry-gate__decision-left"
}, RPe = {
  key: 1,
  class: "d-entry-gate__decision-right"
}, NPe = {
  key: 1,
  class: "d-entry-gate__info"
}, $Pe = {
  key: 2,
  class: "d-entry-gate__product"
}, FPe = {
  key: 3,
  class: "d-entry-gate__relationship"
}, jPe = { class: "d-entry-gate__footer" }, HPe = ["action"], zPe = /* @__PURE__ */ Be({
  __name: "EntryGate",
  props: {
    entryGate: {
      type: Object,
      required: !0
    },
    trackingDropdownName: {
      type: String,
      default: "EntryGateDropdown"
    }
  },
  emits: ["cultureChanged", "audienceChanged"],
  setup(e, { emit: t }) {
    const n = t, { t: i } = Je(), { serviceUrlOptions: o } = Li(), { getValidateIsin: a } = APe(
      `${o?.isinValidationServiceUrl}`
    ), r = e, s = {
      productName: null,
      productIdentifier: void 0,
      country: void 0,
      relationship: null,
      audience: void 0,
      accepted: !1
    }, l = () => r.entryGate.countryDropdown && y.value?.value === "other-country" ? jt.OtherCountry : !r.entryGate.audienceList && r.entryGate.countryDropdown && !r.entryGate.disclaimerList ? jt.CountryOnly : !r.entryGate.audienceList && r.entryGate.countryDropdown && r.entryGate.disclaimerList ? jt.CountryAndDisclaimer : r.entryGate.audienceList && !r.entryGate.countryDropdown ? jt.AudienceOnly : !r.entryGate.audienceList && !r.entryGate.countryDropdown ? jt.DisclaimerOnly : jt.Default, d = Qi(s), y = ge(), u = ge(), m = ge(), h = ge(jt.Default), c = ge(Ht.Default), g = ge(""), v = ge(""), P = ge(), f = ge(void 0), S = ge(), w = (ie) => {
      if (y.value = ie.countryDropdown?.find(
        (re) => re.isSelected
      ), d.audience = ie.audienceList?.find(
        (re) => re.isSelected
      ), h.value = l(), h.value === jt.OtherCountry && Ue) {
        const re = window.location.href.match(
          /([A-Z]{2})((?![A-Z]{10}\b)[A-Z0-9]{10})/gm
        );
        re && re.length > 0 && (g.value = encodeURIComponent(re[0]), p());
      }
      d.country = y.value, u.value = N(y.value?.value), m.value = M(), S.value = { ...ie.continueButtonModel }, x();
    }, x = () => {
      let ie = "", re;
      Ue && (ie = window.location.origin, re = window.location.hash), r.entryGate.continueButtonModel.href && (ie = r.entryGate.continueButtonModel.href);
      const de = new URL(ie);
      (h.value === jt.DisclaimerOnly || h.value === jt.CountryAndDisclaimer && Y() && U()) && de.searchParams.append("setDisclaimer", "true"), d.country && de.searchParams.append("setLanguage", d.country?.value), d.audience && de.searchParams.append("setAudience", d.audience?.key), re && de.searchParams.append("anchor", re.replace("#", "")), S.value && (S.value.href = de.href);
    }, k = Te(() => ({ folderSubPath: "svg/countries", extension: "svg" })), A = Te(() => r.entryGate.countryDropdown ? r.entryGate.countryDropdown : []), $ = {
      id: "",
      name: "",
      toolTipText: ""
    }, j = Te(() => ({
      isValid: !0,
      isDisabled: !1,
      selectedItem: $,
      items: [
        {
          id: Qa.ExistingInvestor,
          name: i("entryGate.existingInvestorLabel"),
          toolTipText: ""
        },
        {
          id: Qa.NonExistingInvestor,
          name: i("entryGate.nonExistingInvestorLabel"),
          toolTipText: ""
        }
      ]
    })), N = (ie) => r.entryGate.imageList.find(
      (re) => re.countryKey === (ie || "default")
    ) || r.entryGate.imageList[0], M = () => {
      if (h.value === jt.DisclaimerOnly && r.entryGate.disclaimerList && r.entryGate.disclaimerList.length > 0)
        return r.entryGate.disclaimerList[0];
      if (d.relationship !== null)
        return r.entryGate.investorDisclaimerList.find(
          (ie) => ie.userRelationShip === d.relationship
        );
      if (d.country && d.audience === void 0)
        return r.entryGate.disclaimerList?.find(
          (ie) => ie.countryKey === d.country?.value
        );
      if (d.country && d.audience)
        return r.entryGate.audienceDisclaimerList.find(
          (ie) => ie.countryKey === d.country?.value && ie.audienceKey === d.audience?.key
        );
      if (h.value === jt.AudienceOnly && d.audience)
        return r.entryGate.audienceDisclaimerList.find(
          (ie) => ie.audienceKey === d.audience?.key
        );
    }, D = (ie) => {
      y.value = ie, d.audience = void 0, d.country = ie, h.value = l(), d.relationship = null, g.value = "", c.value = Ht.Default, m.value = M(), u.value = N(ie.value), x(), Y() && h.value === jt.CountryAndDisclaimer && G(), n("cultureChanged", ie);
    }, C = (ie) => {
      d.audience = ie, m.value = M(), x(), R() && G(), n("audienceChanged", ie);
    }, b = async (ie) => {
      g.value = ie, ie && ie !== "" ? c.value = T(g.value) ? Ht.Valid : Ht.Invalid : c.value = Ht.Default, c.value === Ht.Valid && await p();
    }, p = async () => {
      const ie = await a(
        g.value
      );
      if (!ie) {
        c.value = Ht.Invalid;
        return;
      }
      if (!ie.isIsinValid) {
        c.value = Ht.Invalid;
        return;
      }
      h.value = jt.OtherCountryRelation, d.productIdentifier = ie.isin, d.productName = ie.productName, v.value = ie.productName, S.value && (S.value.href = ie.redirectUrl);
    }, L = async (ie) => {
      c.value === Ht.Invalid && g.value !== ie && (c.value = Ht.Default), g.value === ie && (c.value = T(g.value) ? Ht.Valid : Ht.Invalid), c.value === Ht.Valid && await p();
    }, B = (ie) => {
      ie?.id && (ie?.id === Qa.NonExistingInvestor.toString() ? d.relationship = Qa.NonExistingInvestor : ie?.id === Qa.ExistingInvestor.toString() && (d.relationship = Qa.ExistingInvestor), h.value = jt.OtherCountryDisclaimer, m.value = M(), G());
    }, T = (ie) => ie.match(/^([A-Z]{2})((?![A-Z]{10}\b)[A-Z0-9]{10})$/gm), O = Te(() => r.entryGate.cancelButtonModel === null), I = Te(() => !(h.value === jt.OtherCountryDisclaimer && d.relationship === Qa.ExistingInvestor || R() && Y() && U() && F() && h.value !== jt.OtherCountry && h.value !== jt.OtherCountryRelation || h.value === jt.CountryOnly && Y() && U() && d.country?.value !== "other-country" || h.value === jt.AudienceOnly && R() && F() || h.value === jt.CountryAndDisclaimer && Y() && U() || h.value === jt.DisclaimerOnly)), R = () => d.audience !== void 0, Y = () => d.country !== void 0, F = () => d.audience?.isAllowed, U = () => d.country?.isAllowed, Q = Te(() => r.entryGate.countryDropdown ? r.entryGate.audienceList?.filter((re) => re.countryKey === d.country?.value) : r.entryGate.audienceList), J = Te(() => d.country && !U() ? {
      title: "",
      text: r.entryGate.invalidCountryMessage || ""
    } : d.audience && !F() ? {
      title: "",
      text: r.entryGate.invalidAudienceMessage || ""
    } : null), ee = Te(() => {
      switch (h.value) {
        case jt.DisclaimerOnly:
        case jt.CountryOnly:
        case jt.OtherCountry:
        case jt.OtherCountryRelation:
        case jt.OtherCountryDisclaimer:
        case jt.CountryAndDisclaimer:
          return !1;
        case jt.AudienceOnly:
          return !0;
        default:
          return !!d.country?.value;
      }
    }), V = Te(() => {
      switch (h.value) {
        case jt.DisclaimerOnly:
        case jt.AudienceOnly:
          return !1;
        default:
          return !0;
      }
    }), G = async () => {
      await mt(), !_Pe() && f.value && P.value && setTimeout(() => {
        P.value?.scrollIntoView({ behavior: "smooth", block: "start" });
      }, 500);
    }, W = Te(() => {
      if (d.country && !U() || d.audience && !F())
        return !1;
      switch (h.value) {
        case jt.DisclaimerOnly:
        case jt.OtherCountryDisclaimer:
          return !0;
        case jt.CountryAndDisclaimer:
          return Y();
        case jt.Default:
          return Y() && R() && F();
        case jt.AudienceOnly:
          return R();
        default:
          return !1;
      }
    }), ae = Te(() => {
      switch (h.value) {
        case jt.DisclaimerOnly:
          return !1;
        default:
          return !0;
      }
    }), z = Te(() => r.entryGate.textLinkModel !== null), q = Te(() => !(r.entryGate.backButtonModel === null || d.relationship !== Qa.NonExistingInvestor)), Z = () => {
      w(r.entryGate), d.productName = null, d.productIdentifier = void 0, d.relationship = null, d.accepted = !1, g.value = "", c.value = Ht.Default, h.value = l();
    }, ne = () => {
      Ue && r.entryGate?.cancelButtonModel?.href && (window.location.href = r.entryGate.cancelButtonModel.href);
    };
    return qe(
      () => r.entryGate,
      (ie) => {
        w(ie);
      },
      { immediate: !0 }
    ), (ie, re) => {
      const de = $e("BaseImage"), me = $e("BaseHeading"), ce = $e("BaseRadioBox"), pe = $e("BaseText"), xe = $e("BaseInput");
      return E(), X("div", MPe, [
        oe("div", OPe, [
          u.value ? (E(), fe(de, {
            key: 0,
            model: u.value?.imageModel,
            class: "d-entry-gate__image",
            "aspect-ratio": _(on).None
          }, null, 8, ["model", "aspect-ratio"])) : te("", !0)
        ]),
        oe("div", BPe, [
          ue(me, {
            "base-heading-type": _(ze).H2,
            class: "d-entry-gate__heading"
          }, {
            default: Se(() => [
              Ve(Ie(e.entryGate.title), 1)
            ]),
            _: 1
          }, 8, ["base-heading-type"]),
          oe("div", {
            ref_key: "scrollContainer",
            ref: f,
            class: "d-entry-gate__content d-entry-gate__content--scroll-shadows"
          }, [
            ae.value ? (E(), X("div", EPe, [
              V.value ? (E(), X("div", DPe, [
                ue(me, {
                  "base-heading-type": _(ze).H3,
                  class: "d-entry-gate__decision-heading"
                }, {
                  default: Se(() => [
                    Ve(Ie(_(i)("entryGate.countryLabel")), 1)
                  ]),
                  _: 1
                }, 8, ["base-heading-type"]),
                ue(vi, {
                  placeholder: _(i)("entryGate.countryDropdownPlaceholder"),
                  items: A.value,
                  "filter-placeholder": _(i)("entryGate.countryDropdownFilterPlaceholder"),
                  "image-options": k.value,
                  "has-filter": !0,
                  "show-image": !0,
                  selected: y.value,
                  "event-component-name": e.trackingDropdownName,
                  onSelectedItemChanged: D
                }, null, 8, ["placeholder", "items", "filter-placeholder", "image-options", "selected", "event-component-name"])
              ])) : te("", !0),
              ee.value ? (E(), X("div", RPe, [
                ue(me, {
                  "base-heading-type": _(ze).H3,
                  class: "d-entry-gate__decision-heading"
                }, {
                  default: Se(() => [
                    Ve(Ie(_(i)("entryGate.audienceLabel")), 1)
                  ]),
                  _: 1
                }, 8, ["base-heading-type"]),
                ue(ce, {
                  items: Q.value,
                  "aria-label": _(i)("entryGate.audienceLabel"),
                  onSelectedItemChanged: C
                }, null, 8, ["items", "aria-label"]),
                d.audience?.tooltip ? (E(), fe(pe, {
                  key: 0,
                  text: d.audience?.tooltip,
                  "font-size": _(st).FourteenPx,
                  class: "d-entry-gate__audience-explanation"
                }, null, 8, ["text", "font-size"])) : te("", !0)
              ])) : te("", !0)
            ])) : te("", !0),
            h.value === _(jt).OtherCountry ? (E(), X("div", NPe, [
              ue(me, {
                "base-heading-type": _(ze).H3,
                class: "d-entry-gate__decision-heading"
              }, {
                default: Se(() => [
                  Ve(Ie(_(i)("entryGate.productSearchLabel")), 1)
                ]),
                _: 1
              }, 8, ["base-heading-type"]),
              ue(xe, {
                placeholder: _(i)("entryGate.inputPlaceholder"),
                "error-text": _(i)("entryGate.inputInvalidText"),
                "input-value": g.value,
                state: c.value,
                "right-icon": _(H).ArrowRight,
                "right-icon-filled": !0,
                onValueChanged: b,
                onOnKeyup: L
              }, null, 8, ["placeholder", "error-text", "input-value", "state", "right-icon"])
            ])) : te("", !0),
            h.value === _(jt).OtherCountryRelation || h.value === _(jt).OtherCountryDisclaimer ? (E(), X("div", $Pe, [
              ue(me, {
                "base-heading-type": _(ze).H3
              }, {
                default: Se(() => [
                  Ve(Ie(_(i)("entryGate.productLabel")), 1)
                ]),
                _: 1
              }, 8, ["base-heading-type"]),
              ue(pe, {
                class: "d-entry-gate__product-name",
                text: `${v.value} (${d.productIdentifier})`
              }, null, 8, ["text"])
            ])) : te("", !0),
            h.value === _(jt).OtherCountryRelation ? (E(), X("div", FPe, [
              ue(me, {
                "base-heading-type": _(ze).H3
              }, {
                default: Se(() => [
                  Ve(Ie(_(i)("entryGate.relationshipLabel")), 1)
                ]),
                _: 1
              }, 8, ["base-heading-type"]),
              ue(Vs, {
                class: "d-entry-gate__relationship-radio",
                model: j.value,
                onValueChanged: B
              }, null, 8, ["model"])
            ])) : te("", !0),
            oe("div", {
              ref_key: "scrollTo",
              ref: P
            }, null, 512),
            ue(oo, null, {
              default: Se(() => [
                W.value ? (E(), fe(ht, {
                  id: "disclaimer",
                  key: m.value?.disclaimerHtml,
                  class: "d-entry-gate__disclaimer",
                  "html-text": m.value?.disclaimerHtml ?? ""
                }, null, 8, ["html-text"])) : te("", !0)
              ]),
              _: 1
            }),
            ue(oo, null, {
              default: Se(() => [
                J.value ? (E(), X("div", {
                  key: J.value.text,
                  class: "d-entry-gate__notification"
                }, [
                  ue(Eh, { notification: J.value }, null, 8, ["notification"])
                ])) : te("", !0)
              ]),
              _: 1
            })
          ], 512),
          oe("div", jPe, [
            z.value ? (E(), fe(ot, {
              key: 0,
              "link-model": e.entryGate.textLinkModel,
              icon: _(H).ArrowLeft,
              "icon-position": _(ct).Left,
              class: "d-entry-gate__home-link"
            }, null, 8, ["link-model", "icon", "icon-position"])) : te("", !0),
            q.value ? (E(), fe(ot, {
              key: 1,
              "link-model": e.entryGate.backButtonModel,
              icon: _(H).ArrowLeft,
              "icon-position": _(ct).Left,
              class: "d-entry-gate__home-link",
              onClick: Z
            }, null, 8, ["link-model", "icon", "icon-position"])) : te("", !0),
            O.value ? te("", !0) : (E(), fe(vt, {
              key: 2,
              "link-model": e.entryGate.cancelButtonModel,
              type: _(Ke).Secondary,
              size: _(et).Large,
              class: "d-entry-gate__cancel",
              onClick: ne
            }, null, 8, ["link-model", "type", "size"])),
            oe("form", {
              action: S.value?.href,
              method: "post"
            }, [
              ue(vt, {
                "link-model": S.value,
                type: _(Ke).Primary,
                "button-type": _(zt).Button,
                size: _(et).Large,
                disabled: I.value,
                name: "continue",
                class: "d-entry-gate__continue",
                "data-id": "silktide-accept"
              }, null, 8, ["link-model", "type", "button-type", "size", "disabled"])
            ], 8, HPe)
          ])
        ])
      ]);
    };
  }
});
const VPe = /* @__PURE__ */ Fe(zPe, [["__scopeId", "data-v-ce4da282"]]), GPe = { class: "d-entry-gate-modal" }, UPe = /* @__PURE__ */ Be({
  __name: "EntryGateModal",
  props: {
    entryGate: {
      type: Object,
      required: !0
    },
    header: {
      type: Object,
      required: !0
    }
  },
  emits: ["cultureChanged", "audienceChanged"],
  setup(e, { emit: t }) {
    const n = e, i = ge(), o = ge(), a = t, r = Te(() => n.entryGate.appendTo ?? "#dx-overlay");
    function s(u) {
      if (!Ue)
        return;
      const m = document.body;
      m && (u ? m.style.overflow = "hidden" : m.style.overflow = "");
    }
    it(() => {
      const u = document.querySelector(r.value);
      u && (u.appendChild(i.value), u.appendChild(o.value.$el)), s(!0);
    }), sn(() => {
      const u = document.querySelector(
        `${r.value} .d-entry-gate-modal--backdrop`
      ), m = document.querySelector(
        `${r.value} .d-entry-gate-modal--header`
      );
      u?.remove(), m?.remove(), s(!1);
    });
    const l = Te(() => ({
      "1280px": "75.5rem",
      "1024px": "40.5rem",
      "768px": "40.5rem",
      "576px": "100vw",
      "375px": "100vw"
    })), d = (u) => {
      a("cultureChanged", u);
    }, y = (u) => {
      a("audienceChanged", u);
    };
    return (u, m) => (E(), X(Re, null, [
      oe("div", GPe, [
        e.header ? (E(), fe(zT, {
          key: 0,
          ref_key: "headerRef",
          ref: o,
          model: e.header
        }, null, 8, ["model"])) : te("", !0),
        ue(Ei, {
          display: !0,
          closable: !1,
          breakpoints: l.value,
          "append-to": r.value
        }, {
          content: Se(() => [
            ue(VPe, Ce(n, {
              onCultureChanged: d,
              onAudienceChanged: y
            }), null, 16)
          ]),
          _: 1
        }, 8, ["breakpoints", "append-to"])
      ]),
      oe("div", {
        ref_key: "backdrop",
        ref: i,
        class: "d-entry-gate-modal--backdrop"
      }, null, 512)
    ], 64));
  }
});
const LEe = /* @__PURE__ */ Fe(UPe, [["__scopeId", "data-v-f6c4167d"]]), WPe = { class: "grid grid-cols-2 d-period-calendar" }, YPe = { class: "d-period-calendar__group" }, qPe = {
  key: 0,
  class: "label",
  for: "rangeFrom"
}, KPe = { class: "d-period-calendar__group" }, XPe = {
  key: 0,
  class: "label",
  for: "rangeTo"
}, ZPe = /* @__PURE__ */ Be({
  __name: "PeriodCalendar",
  props: {
    selectedFromDate: {
      type: Date,
      required: !0
    },
    selectedToDate: {
      type: Date,
      required: !0
    },
    showLabels: {
      type: Boolean,
      default: !0
    },
    minDateFrom: {
      type: Date,
      default: /* @__PURE__ */ new Date("1900-01-01")
    },
    maxDateFrom: {
      type: Date,
      default: /* @__PURE__ */ new Date()
    },
    minDateTo: {
      type: Date,
      default: /* @__PURE__ */ new Date("1900-01-01")
    },
    maxDateTo: {
      type: Date,
      default: /* @__PURE__ */ new Date()
    }
  },
  emits: ["update:selectedFromDate", "update:selectedToDate"],
  setup(e, { emit: t }) {
    const { t: n } = Je(), i = e, o = ge(i.selectedFromDate), a = ge(i.selectedToDate), r = ge(i.maxDateFrom), s = ge(i.minDateTo), l = t;
    return qe(o, () => {
      l("update:selectedFromDate", o.value), s.value = o.value;
    }), qe(a, () => {
      l("update:selectedToDate", a.value), r.value = a.value;
    }), (d, y) => (E(), X("div", WPe, [
      oe("div", YPe, [
        e.showLabels ? (E(), X("label", qPe, Ie(_(n)("periodCalendar.fromLabel")), 1)) : te("", !0),
        ue(W0, {
          id: "rangeFrom",
          "selected-date": o.value,
          "onUpdate:selectedDate": y[0] || (y[0] = (u) => o.value = u),
          "min-date": e.minDateFrom,
          "max-date": r.value,
          "aria-label": _(n)("periodCalendar.fromLabel")
        }, null, 8, ["selected-date", "min-date", "max-date", "aria-label"])
      ]),
      oe("div", KPe, [
        e.showLabels ? (E(), X("label", XPe, Ie(_(n)("periodCalendar.toLabel")), 1)) : te("", !0),
        ue(W0, {
          id: "rangeTo",
          "selected-date": a.value,
          "onUpdate:selectedDate": y[1] || (y[1] = (u) => a.value = u),
          "min-date": s.value,
          "max-date": e.maxDateTo,
          "aria-label": _(n)("periodCalendar.toLabel")
        }, null, 8, ["selected-date", "min-date", "max-date", "aria-label"])
      ])
    ]));
  }
});
const TL = /* @__PURE__ */ Fe(ZPe, [["__scopeId", "data-v-af08b544"]]);
var JPe = `
@layer primevue {
    .p-progress-spinner {
        position: relative;
        margin: 0 auto;
        width: 100px;
        height: 100px;
        display: inline-block;
    }

    .p-progress-spinner::before {
        content: '';
        display: block;
        padding-top: 100%;
    }

    .p-progress-spinner-svg {
        height: 100%;
        transform-origin: center center;
        width: 100%;
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        margin: auto;
    }
}
`, QPe = {
  root: "p-progress-spinner",
  spinner: "p-progress-spinner-svg",
  circle: "p-progress-spinner-circle"
}, eAe = Wt.extend({
  name: "progressspinner",
  css: JPe,
  classes: QPe
}), tAe = {
  name: "BaseProgressSpinner",
  extends: wt,
  props: {
    strokeWidth: {
      type: String,
      default: "2"
    },
    fill: {
      type: String,
      default: "none"
    },
    animationDuration: {
      type: String,
      default: "2s"
    }
  },
  style: eAe,
  provide: function() {
    return {
      $parentInstance: this
    };
  }
}, LL = {
  name: "ProgressSpinner",
  extends: tAe,
  computed: {
    svgStyle: function() {
      return {
        "animation-duration": this.animationDuration
      };
    }
  }
}, nAe = ["fill", "stroke-width"];
function iAe(e, t, n, i, o, a) {
  return E(), X("div", Ce({
    class: e.cx("root"),
    role: "progressbar"
  }, e.ptm("root"), {
    "data-pc-name": "progressspinner"
  }), [(E(), X("svg", Ce({
    class: e.cx("spinner"),
    viewBox: "25 25 50 50",
    style: a.svgStyle
  }, e.ptm("spinner")), [oe("circle", Ce({
    class: e.cx("circle"),
    cx: "50",
    cy: "50",
    r: "20",
    fill: e.fill,
    "stroke-width": e.strokeWidth,
    strokeMiterlimit: "10"
  }, e.ptm("circle")), null, 16, nAe)], 16))], 16);
}
LL.render = iAe;
const aAe = { class: "d-historical-data" }, oAe = {
  key: 0,
  class: "d-historical-data__headline"
}, rAe = {
  key: 1,
  class: "d-historical-data__description"
}, sAe = {
  key: 0,
  class: "calendar-input-group lg:ml-5"
}, lAe = { class: "gap-4 flex items-center mt-10" }, cAe = {
  class: "p-label-ts",
  for: "taxSwitch"
}, dAe = { class: "calendar-input-group pt-7" }, uAe = { class: "d-historical-data__message-box" }, hAe = {
  key: 0,
  class: "d-historical-data__message-box--error"
}, pAe = {
  key: 1,
  class: "d-historical-data__message-box--error"
}, fAe = {
  key: 2,
  class: "d-historical-data__message-box--waiting"
}, mAe = /* @__PURE__ */ Be({
  __name: "HistoricalData",
  props: {
    model: {
      type: Object,
      required: !0
    }
  },
  setup(e) {
    const { t } = Je(), n = e, i = ge(new Date(n.model.values.defaultStartDate)), o = ge(new Date(n.model.values.defaultEndDate)), { pageName: a } = Qe(), r = ge(a), s = ge(!1), l = ge(!1), d = ge(!1), y = ge(!1), u = Te(() => n.model.values.downloadButtonText);
    async function m() {
      if (l.value = !1, d.value = !1, h(i.value) && h(o.value) && i.value <= o.value) {
        y.value = !0;
        const v = await g();
        y.value = !1, v !== !0 && (d.value = !0);
        return;
      }
      l.value = !0;
    }
    function h(v) {
      return v !== void 0;
    }
    function c(v) {
      try {
        const P = ("0" + v.getDate()).slice(-2), f = ("0" + (v.getMonth() + 1)).slice(-2);
        return "" + v.getFullYear() + "-" + f + "-" + P;
      } catch {
        return (/* @__PURE__ */ new Date()).toISOString().split("T")[0];
      }
    }
    async function g() {
      const v = c(i.value), P = c(o.value);
      return await n.model.onDownload(v, P, s.value);
    }
    return (v, P) => (E(), X("div", aAe, [
      e.model.values.headlineText ? (E(), X("div", oAe, Ie(e.model.values.headlineText), 1)) : te("", !0),
      e.model.values.descriptionText ? (E(), X("div", rAe, [
        oe("p", null, Ie(e.model.values.descriptionText), 1)
      ])) : te("", !0),
      oe("div", {
        class: Pe(["grid grid-cols-1", {
          "lg:grid-cols-2 xl:grid-cols-3": e.model.values.hasTaxSwitch,
          "xl:grid-cols-2": !e.model.values.hasTaxSwitch
        }])
      }, [
        ue(TL, {
          "selected-from-date": i.value,
          "onUpdate:selectedFromDate": P[0] || (P[0] = (f) => i.value = f),
          "selected-to-date": o.value,
          "onUpdate:selectedToDate": P[1] || (P[1] = (f) => o.value = f)
        }, null, 8, ["selected-from-date", "selected-to-date"]),
        e.model.values.hasTaxSwitch ? (E(), X("span", sAe, [
          oe("span", lAe, [
            ue(hT, {
              id: "taxSwitch",
              modelValue: s.value,
              "onUpdate:modelValue": P[2] || (P[2] = (f) => s.value = f),
              "aria-label": e.model.values.taxLabel
            }, null, 8, ["modelValue", "aria-label"]),
            oe("label", cAe, Ie(e.model.values.taxLabel), 1)
          ])
        ])) : te("", !0),
        oe("span", dAe, [
          ue(vt, {
            id: "downloadButton",
            type: _(Ke).Primary,
            size: _(et).Large,
            "link-model": {
              title: e.model.values.downloadButtonText,
              text: e.model.values.downloadButtonText,
              tealiumTrackingModel: {
                eventSource: r.value,
                eventComponentName: "Download",
                eventTitle: u.value
              }
            },
            icon: _(H).Download,
            "icon-position": _(ct).Left,
            onClick: m
          }, null, 8, ["type", "size", "link-model", "icon", "icon-position"])
        ])
      ], 2),
      oe("div", uAe, [
        ue(Br, null, {
          default: Se(() => [
            l.value ? (E(), X("span", hAe, Ie(e.model.values.errorMessage), 1)) : te("", !0),
            d.value ? (E(), X("span", pAe, Ie(_(t)("historicalData.failedMessage")), 1)) : te("", !0),
            y.value ? (E(), X("span", fAe, [
              ue(_(LL), {
                class: "d-historical-data__message-box--spinner",
                "stroke-width": "5",
                "animation-duration": "1s"
              }),
              Ve(" " + Ie(_(t)("historicalData.waitMessage")), 1)
            ])) : te("", !0)
          ]),
          _: 1
        })
      ])
    ]));
  }
});
const IEe = /* @__PURE__ */ Fe(mAe, [["__scopeId", "data-v-ac9dce6a"]]), gAe = { class: "d-disclaimer" }, vAe = { key: 0 }, yAe = { class: "button-group p-button-group" }, PEe = /* @__PURE__ */ Be({
  __name: "LeavingDisclaimer",
  props: {
    model: {
      type: Object,
      required: !0
    }
  },
  setup(e) {
    const { t } = Je(), { pageName: n } = Qe(), i = ge(n), o = e, { shouldShowLeavingDisclaimer: a, url: r, disclaimer: s } = jx(), l = Te(
      () => o.model.disclaimers.find((d) => d.key === s.value)?.value ?? o.model.disclaimers[0].value
    );
    return (d, y) => {
      const u = $e("BaseHeading");
      return E(), X("div", gAe, [
        ue(_(Ei), {
          ref: "dialog",
          visible: _(a),
          "onUpdate:visible": y[2] || (y[2] = (m) => In(a) ? a.value = m : null),
          class: "p-smooth-scroller d-disclaimer",
          position: _(aa).Center,
          "base-z-index": 1e3,
          modal: !0,
          draggable: !1,
          closable: !0,
          "append-to": e.model.appendTo ?? "#dx-overlay",
          onCloseDialog: y[3] || (y[3] = () => a.value = !1)
        }, {
          header: Se(() => [
            oe("div", null, [
              ue(u, {
                "base-heading-type": _(ze).H2Section
              }, {
                default: Se(() => [
                  Ve(Ie(e.model.headerText ? e.model.headerText : _(t)("globalTranslations.disclaimerTitle")), 1)
                ]),
                _: 1
              }, 8, ["base-heading-type"])
            ])
          ]),
          content: Se(() => [
            l.value ? (E(), X("div", vAe, [
              ue(_(ht), {
                "html-text": l.value,
                "disable-default-styling": ""
              }, null, 8, ["html-text"])
            ])) : te("", !0)
          ]),
          footer: Se(() => [
            y[4] || (y[4] = oe("div", { class: "p-dialog-footer__hint" }, null, -1)),
            oe("div", yAe, [
              ue(vt, {
                id: "leavingdisclaimerCancelButton",
                type: _(Ke).Secondary,
                size: _(et).Small,
                "button-type": _(zt).Link,
                "link-model": {
                  title: _(t)("globalTranslations.disclaimerCancelButtonLabel"),
                  text: _(t)("globalTranslations.disclaimerCancelButtonLabel"),
                  tealiumTrackingModel: {
                    eventSource: i.value,
                    eventComponentName: "Leaving Disclaimer",
                    eventTitle: "Cancel"
                  }
                },
                onClick: y[0] || (y[0] = () => a.value = !1)
              }, null, 8, ["type", "size", "button-type", "link-model"]),
              ue(vt, {
                id: "leavingdisclaimerAcceptButton",
                type: _(Ke).Primary,
                size: _(et).Small,
                "button-type": _(zt).Link,
                "link-model": {
                  title: _(t)("globalTranslations.disclaimerConfirmButtonLabel"),
                  text: _(t)("globalTranslations.disclaimerConfirmButtonLabel"),
                  href: _(r),
                  target: "_blank",
                  tealiumTrackingModel: {
                    eventSource: i.value,
                    eventComponentName: "Leaving Disclaimer",
                    eventTitle: "Confirm",
                    eventTarget: _(r)
                  }
                },
                "data-id": "silktide-accept",
                onClick: y[1] || (y[1] = () => a.value = !1)
              }, null, 8, ["type", "size", "button-type", "link-model"])
            ])
          ]),
          _: 1
        }, 8, ["visible", "position", "append-to"])
      ]);
    };
  }
});
var Qr = /* @__PURE__ */ ((e) => (e.Always = "always", e.OncePerUser = "once-per-user", e.UntilAccepted = "until-accepted", e))(Qr || {});
const jd = ge(!1), bx = "entry-popup", bAe = () => {
  const e = $t("$cookies");
  function t() {
    const l = e?.get(bx);
    try {
      const d = l ?? {};
      return d.p = d.p ?? [], d;
    } catch {
      return {
        p: []
      };
    }
  }
  function n(l, d, y) {
    l.p.push({
      i: d.id,
      c: d.culture.toLowerCase(),
      d: /* @__PURE__ */ new Date(),
      a: y
    }), e?.set(bx, JSON.stringify(l));
  }
  function i(l) {
    return t()?.p?.find(
      (u) => u.i == l.id && u.c.toLowerCase() == l.culture.toLowerCase()
    ) != null;
  }
  function o(l) {
    if (l.type === Qr.UntilAccepted || l.type === Qr.OncePerUser) {
      const d = t();
      d?.p?.find(
        (u) => u.i == l.id && u.c.toLowerCase() == l.culture.toLowerCase()
      ) == null && n(d, l, !0);
    }
  }
  return {
    shouldShowEntryDisclaimer: jd,
    openPopup: (l) => {
      jd.value = l.type == Qr.Always || !i(l);
    },
    acceptDisclaimer: (l) => {
      jd.value = !1, o(l);
    },
    disagreeDisclaimer: (l) => {
      if (jd.value = !1, l.type === Qr.OncePerUser) {
        const d = t();
        d?.p?.find(
          (u) => u.i == l.id && u.c.toLowerCase() == l.culture.toLowerCase()
        ) == null && n(d, l, !1);
      }
    }
  };
}, xAe = { class: "d-disclaimer" }, wAe = { key: 0 }, kAe = { class: "button-group p-button-group" }, AEe = /* @__PURE__ */ Be({
  __name: "EntryDisclaimer",
  props: {
    model: {
      type: Object,
      required: !0
    }
  },
  setup(e) {
    const t = e, { t: n } = Je(), { pageName: i } = Qe(), {
      shouldShowEntryDisclaimer: o,
      acceptDisclaimer: a,
      disagreeDisclaimer: r,
      openPopup: s
    } = bAe();
    it(() => {
      o.value = !1, s(t.model);
    });
    function l() {
      r(t.model);
    }
    function d() {
      a(t.model);
    }
    const y = Te(() => t.model.acceptButton && t.model.type === Qr.Always ? t.model.acceptButton : {
      contentUrl: "",
      title: n("globalTranslations.disclaimerAgreeButtonLabel"),
      text: n("globalTranslations.disclaimerAgreeButtonLabel"),
      isLocked: !1,
      target: "",
      isExternal: !1,
      linkType: yt.Javascript,
      tealiumTrackingModel: {
        eventSource: i,
        eventComponentName: "Entry Disclaimer",
        eventTitle: "Agree"
      }
    }), u = Te(() => t.model.disagreeButton ? t.model.disagreeButton : {
      contentUrl: "",
      href: t.model.returnUrl.href,
      title: n("globalTranslations.disclaimerDisagreeButtonLabel"),
      text: n("globalTranslations.disclaimerDisagreeButtonLabel"),
      isLocked: !1,
      target: "_top",
      isExternal: !1,
      linkType: yt.Javascript,
      tealiumTrackingModel: {
        eventSource: i,
        eventComponentName: "Entry Disclaimer",
        eventTitle: t.model.returnUrl.href,
        eventTarget: t.model.returnUrl.href
      }
    });
    return (m, h) => {
      const c = $e("BaseHeading");
      return E(), X("div", xAe, [
        ue(_(Ei), {
          ref: "dialog",
          visible: _(o),
          "onUpdate:visible": h[2] || (h[2] = (g) => In(o) ? o.value = g : null),
          class: "p-smooth-scroller d-disclaimer",
          position: _(aa).Center,
          "base-z-index": 1e3,
          modal: !0,
          draggable: !1,
          closable: e.model.hideCloseButton !== void 0 && !e.model.hideCloseButton,
          onCloseDialog: h[3] || (h[3] = (g) => l())
        }, {
          header: Se(() => [
            oe("div", null, [
              ue(c, {
                "base-heading-type": _(ze).H2Section
              }, {
                default: Se(() => [
                  Ve(Ie(e.model.headerText ? e.model.headerText : _(n)("globalTranslations.disclaimerTitle")), 1)
                ]),
                _: 1
              }, 8, ["base-heading-type"])
            ])
          ]),
          content: Se(() => [
            e.model.disclaimer ? (E(), X("div", wAe, [
              ue(_(ht), {
                "html-text": e.model.disclaimer,
                "disable-default-styling": ""
              }, null, 8, ["html-text"])
            ])) : te("", !0)
          ]),
          footer: Se(() => [
            h[4] || (h[4] = oe("div", { class: "p-dialog-footer__hint" }, null, -1)),
            oe("div", kAe, [
              e.model.hideDisagreeButton ? te("", !0) : (E(), fe(vt, {
                key: 0,
                id: "entryDisclaimerDisagreeButton",
                type: _(Ke).Secondary,
                size: _(et).Small,
                "button-type": _(zt).Link,
                "link-model": u.value,
                onClick: h[0] || (h[0] = (g) => l())
              }, null, 8, ["type", "size", "button-type", "link-model"])),
              e.model.hideAcceptButton ? te("", !0) : (E(), fe(vt, {
                key: 1,
                id: "entryDisclaimerAgreeButton",
                type: _(Ke).Primary,
                size: _(et).Small,
                "button-type": _(zt).Link,
                "link-model": y.value,
                "data-id": "silktide-accept",
                onClick: h[1] || (h[1] = (g) => d())
              }, null, 8, ["type", "size", "button-type", "link-model"]))
            ])
          ]),
          _: 1
        }, 8, ["visible", "position", "closable"])
      ]);
    };
  }
}), SAe = {
  key: 0,
  class: "d-mifid"
}, CAe = {
  key: 1,
  class: "d-mifid__line"
}, TAe = {
  key: 3,
  class: "d-mifid__line"
}, LAe = /* @__PURE__ */ Be({
  __name: "Mifid",
  props: {
    model: {
      type: Object,
      required: !0
    }
  },
  setup(e) {
    return (t, n) => {
      const i = $e("BaseHeading");
      return e.model?.targetMarket?.data || e.model?.costAndFees?.data ? (E(), X("div", SAe, [
        e.model.targetMarket?.data ? (E(), fe(i, {
          key: 0,
          class: "d-mifid__heading",
          "base-heading-type": _(ze).H3LooksLikeH2Section
        }, {
          default: Se(() => [
            ue(_(ss), {
              html: e.model.targetMarket?.headlineText,
              purify: !1
            }, null, 8, ["html"])
          ]),
          _: 1
        }, 8, ["base-heading-type"])) : te("", !0),
        e.model.targetMarket?.data ? (E(), X("hr", CAe)) : te("", !0),
        ue(Ar, {
          "use-dynamic-footnote": !0,
          class: "d-mifid__list",
          model: { id: e.model.id, items: e.model.targetMarket?.data }
        }, null, 8, ["model"]),
        e.model.costAndFees?.data ? (E(), fe(i, {
          key: 2,
          class: "d-mifid__heading",
          "base-heading-type": _(ze).H3LooksLikeH2Section
        }, {
          default: Se(() => [
            ue(_(ss), {
              html: e.model.costAndFees?.headlineText,
              purify: !1
            }, null, 8, ["html"])
          ]),
          _: 1
        }, 8, ["base-heading-type"])) : te("", !0),
        e.model.costAndFees?.data ? (E(), X("hr", TAe)) : te("", !0),
        ue(Ar, {
          "use-dynamic-footnote": !0,
          class: "d-mifid__list",
          model: { id: e.model.id, items: e.model.costAndFees?.data }
        }, null, 8, ["model"])
      ])) : te("", !0);
    };
  }
});
const _Ee = /* @__PURE__ */ Fe(LAe, [["__scopeId", "data-v-e2310ff5"]]);
var IL = /* @__PURE__ */ ((e) => (e[e.OneColumn = 1] = "OneColumn", e[e.TwoColumns = 2] = "TwoColumns", e))(IL || {});
const IAe = { class: "d-performance-block" }, PAe = { class: "d-performance-block__container grid xs:grid-cols-1 lg:grid-cols-2 gap-8 container" }, AAe = {
  key: 0,
  class: "xs:col-span-1"
}, _Ae = { class: "d-performance-block__body" }, MAe = {
  key: 1,
  class: "xs:col-span-1"
}, OAe = { class: "d-performance-block__body" }, BAe = { class: "d-performance-block__disclaimers xs:col-span-1 lg:col-span-2" }, EAe = /* @__PURE__ */ Be({
  __name: "PerformanceBlock",
  props: {
    model: {
      type: Object,
      required: !0
    },
    headingType: {
      type: String,
      default: ze.H2Section
    },
    numberOfColumns: {
      type: Number,
      default: IL.TwoColumns
    }
  },
  setup(e) {
    const t = (r) => (r?.columns?.map((s) => {
      s.alignment === void 0 && (s.key === "header" ? s.alignment = zn.Left : s.alignment = zn.Right);
    }), r), n = Ts(), i = ge(), o = ge();
    it(() => {
      i.value = a(o);
    }), qe(n.width, (r) => {
      r && (i.value = a(o));
    });
    function a(r) {
      if (n.width.value >= 768) {
        if (r)
          return { height: r.value.clientHeight + "px" };
      } else
        return {};
    }
    return (r, s) => (E(), X("div", IAe, [
      oe("div", PAe, [
        e.model.leftTable !== null ? (E(), X("div", AAe, [
          oe("div", {
            ref: "perfLeft",
            class: "d-performance-block__side-header hi",
            style: hn(i.value)
          }, [
            ue(Ot, {
              "base-heading-type": e.headingType,
              class: "d-performance-block__heading"
            }, {
              default: Se(() => [
                ue(li, {
                  "foot-note-id": e.model.id,
                  text: e.model.leftTable.headline.headlineText
                }, null, 8, ["foot-note-id", "text"])
              ]),
              _: 1
            }, 8, ["base-heading-type"]),
            e.model.leftTable.headline.headlineDateText ? (E(), fe(Ot, {
              key: 0,
              "base-heading-type": e.headingType,
              class: "performance-block__side-heading-date"
            }, {
              default: Se(() => [
                Ve(Ie(e.model.leftTable.headline.headlineDateText), 1)
              ]),
              _: 1
            }, 8, ["base-heading-type"])) : te("", !0)
          ], 4),
          oe("div", _Ae, [
            ue(Fu, {
              model: t(e.model.leftTable.table),
              "show-paginator": !1,
              "footnote-type": _(Oi).ComponentId
            }, null, 8, ["model", "footnote-type"])
          ])
        ])) : te("", !0),
        e.model.rightTable !== null ? (E(), X("div", MAe, [
          oe("div", {
            ref_key: "perfRight",
            ref: o,
            class: "d-performance-block__side-header"
          }, [
            ue(Ot, {
              "base-heading-type": e.headingType,
              class: "d-performance-block__heading"
            }, {
              default: Se(() => [
                ue(li, {
                  "foot-note-id": e.model.id,
                  text: e.model.rightTable.headline.headlineText
                }, null, 8, ["foot-note-id", "text"])
              ]),
              _: 1
            }, 8, ["base-heading-type"]),
            e.model.rightTable.headline.headlineDateText ? (E(), fe(Ot, {
              key: 0,
              "base-heading-type": e.headingType,
              class: "performance-block__side-heading-date"
            }, {
              default: Se(() => [
                Ve(Ie(e.model.rightTable.headline.headlineDateText), 1)
              ]),
              _: 1
            }, 8, ["base-heading-type"])) : te("", !0)
          ], 512),
          oe("div", OAe, [
            ue(Fu, {
              model: t(e.model.rightTable.table),
              "show-paginator": !1,
              "footnote-type": _(Oi).ComponentId
            }, null, 8, ["model", "footnote-type"])
          ])
        ])) : te("", !0),
        rt(ue(ja, {
          id: e.model.id,
          class: "xs:col-span-1 lg:col-span-2 mb-8",
          values: e.model
        }, null, 8, ["id", "values"]), [
          [xn, e.model.footnotes.length !== 0]
        ]),
        oe("div", BAe, [
          (E(!0), X(Re, null, Ge(e.model.disclaimers, (l) => rt((E(), fe(Mr, {
            key: l.text,
            values: l.text,
            class: "d-performance-block__disclaimer",
            "number-column": e.numberOfColumns
          }, null, 8, ["values", "number-column"])), [
            [xn, e.model.disclaimers.length !== 0]
          ])), 128))
        ])
      ])
    ]));
  }
});
const MEe = /* @__PURE__ */ Fe(EAe, [["__scopeId", "data-v-0fd66fb6"]]);
let Hd;
const zh = [
  Ai,
  Qu,
  fu,
  // wcag SkyBlue contrast is to low
  Um,
  Wm,
  Ym,
  qm,
  Sr,
  Km,
  Xm,
  fu,
  Zm,
  Jm,
  Qm,
  eg,
  tg,
  ng
], DAe = {
  positioner: function(e, t, n) {
    const i = this.chart.chartWidth, o = n.plotX + e > i ? Math.round(i - e) : Math.round(n.plotX + e / 2 - 268), a = o > 0 ? o : 0, s = n.plotY - t - 8;
    return {
      x: a,
      y: s
    };
  },
  backgroundColor: "rgba(255,255,255,0)",
  borderRadius: 12,
  shadow: !1,
  useHTML: !0,
  outside: !0,
  split: !1,
  shared: !0,
  percentageDecimals: 2
}, RAe = {
  ..._s,
  time: {
    timezoneOffset: 0,
    useUTC: !0
  },
  accessibility: {
    enabled: !0,
    keyboardNavigation: {
      enabled: !0,
      focusBorder: {
        style: {
          lineWidth: 2,
          color: Ai,
          borderRadius: 2
        },
        margin: 2
      },
      order: ["series", "navigator"],
      seriesNavigation: {
        mode: "normal",
        pointNavigationEnabledThreshold: !1,
        pointNavigationEnabled: !0,
        skipNullPoints: !0,
        rememberPointFocus: !0
      }
    }
  },
  chart: {
    events: {
      load: function() {
      },
      render: function() {
      }
    },
    type: "line",
    styledMode: !1,
    panning: {
      enabled: !1
    },
    zooming: {
      mouseWheel: {
        enabled: !1
      }
    },
    zoomType: "",
    style: {
      fontFamily: Is,
      fontSize: Ps
    },
    title: {
      text: ""
    }
  },
  xAxis: [
    {
      lineColor: Wi,
      crosshair: {
        interpolate: !0,
        snap: !1
      },
      tickWidth: 0,
      type: "datetime",
      // UTC
      minTickInterval: 24 * 3600 * 1e3,
      dateTimeLabelFormats: {
        millisecond: "%e. %b",
        second: "%e. %b",
        minute: "%e. %b",
        hour: "%e. %b",
        day: "%e. %b",
        week: "%e. %b",
        month: "%b / %y",
        year: "%Y"
      },
      labels: {
        step: 2,
        style: ii,
        align: "right",
        //reserveSpace: true,
        overflow: "justify"
      },
      plotBands: [],
      plotLines: []
    }
  ],
  yAxis: [
    {
      startOnTick: !0,
      endOnTick: !1,
      lineColor: Wi,
      lineWidth: 1,
      tickWidth: 0,
      labels: {
        enabled: !1,
        step: 1,
        style: ii
      },
      title: {
        text: null
      }
    }
  ],
  plotOptions: {
    series: {
      states: {
        inactive: {
          opacity: 1
        }
      },
      marker: {
        enabled: !1,
        enabledThreshold: 10,
        states: {
          hover: {
            enabled: !0
          }
        }
      },
      animation: {
        duration: 1500
      },
      lineWidth: 1,
      showCheckbox: !1,
      compare: "percent",
      compareStart: !0,
      padding: 0,
      turboThreshold: 0,
      dataGrouping: {
        enabled: !1
      }
    },
    flags: {
      shape: "flag",
      y: -248,
      lineColor: so,
      lineWidth: 0,
      lineStyle: "ShortDot",
      dashStyle: "ShortDot",
      fillColor: so,
      height: 24,
      width: 58,
      states: {
        hover: {
          fillColor: Da,
          lineColor: Da
        }
      },
      style: {
        fontFamily: gu,
        fontWeight: As,
        fontSize: "12px",
        color: "#fff",
        borderRadius: 12
      },
      tooltip: {}
    }
  },
  series: [
    {
      marker: {
        enabled: !1,
        enabledThreshold: 1e3,
        states: {
          hover: {
            enabled: !0
          }
        }
      },
      type: "areaspline",
      fillColor: {
        linearGradient: {
          x1: 0,
          y1: 0,
          x2: 0,
          y2: 1
        },
        stops: [
          [0, "rgba(193,225,225, 1)"],
          [1, "rgba(193,225,225, 0.25)"]
        ]
      }
    }
  ],
  tooltip: DAe,
  navigator: {
    accessibility: {
      enabled: !0
    },
    enabled: !0,
    adaptToUpdatedData: !0,
    maskFill: "rgba(238, 247, 247, .5)",
    color: "#fff",
    maskInside: !0,
    outlineWidth: 0,
    borderRadius: 20,
    marker: {
      enabled: !1
    },
    handles: {
      enabled: !0,
      accessibility: {
        description: "Navigator handle for selecting date range"
      },
      symbols: ["navigator-handle", "navigator-handle"],
      backgroundColor: Ai,
      borderColor: "#fff",
      color: "#fff",
      height: 24,
      width: 10,
      lineWidth: 1,
      style: {
        outline: "1px solid #007d85"
      },
      states: {
        hover: {
          backgroundColor: Ai,
          borderColor: "#fff"
        },
        select: {
          backgroundColor: Ai,
          // Color when focused
          borderColor: Ai
          // Border color when focused
        }
      }
    },
    height: 64,
    margin: 32,
    xAxis: {
      gridLineWidth: 0,
      labels: {
        enabled: !1
      }
    },
    series: {
      data: [],
      name: "NavigatorSeries",
      type: "areaspline",
      fillColor: {
        linearGradient: {
          x1: 0,
          y1: 0,
          x2: 0,
          y2: 1
        },
        stops: [
          [0, "rgba(193,225,225, 1)"],
          [1, "rgba(193,225,225, 0.25)"]
        ]
      }
    }
  },
  colors: zh,
  rangeSelector: {
    buttons: [
      {
        type: "year",
        count: 1,
        text: "1y"
      }
    ],
    enabled: !1,
    selected: 0,
    floating: !0,
    y: -1e3
  },
  responsive: {
    rules: [
      {
        condition: {
          maxWidth: 375
        },
        chartOptions: {
          xAxis: [
            {
              labels: {
                step: 1
              }
            }
          ]
        }
      }
    ]
  }
};
function NAe(e) {
  const t = [];
  for (let n = 0; n < e.seriesConfiguration.length; n++) {
    const i = e.values.map((o) => {
      const a = o[0], s = o[1][n], l = s ? s[0] : null, d = s ? s[1] : null, y = s ? s[2] : null;
      return {
        date: a,
        value: l,
        adjustedValue: d,
        performance: y
      };
    });
    t.push(i);
  }
  return t;
}
function xx(e) {
  const t = [], n = e.seriesConfiguration;
  for (let i = 0; i < e.flags?.length; i++) {
    const o = e.flags[i], a = {
      type: "flags",
      name: "Events",
      accessibility: {
        exposeAsGroupOnly: !0,
        description: "Flagged events."
      },
      showInLegend: !1,
      data: [],
      fillColor: o.type == Ug.IndexMerge ? _k : Mk,
      // onSeries: '',
      // this is the index of the additional yAxis without labels
      yAxis: n.length,
      clip: !1,
      tooltip: {}
    }, r = {
      x: o.x,
      title: o.title,
      text: o.text
    };
    a.data?.push(r), t.push(a);
  }
  return t;
}
function $Ae(e, t) {
  const n = [];
  n.push({
    color: Wi,
    from: t,
    to: t
  });
  for (let i = 0; i < e.flags?.length; i++) {
    const o = e.flags[i], a = {
      color: so,
      from: o.x,
      to: o.x
    };
    n.push(a);
  }
  return n;
}
function wx(e, t, n) {
  const i = e.seriesConfiguration, o = NAe(e), a = [];
  for (let r = 0; r < i.length; r++) {
    const s = zh[r], l = i[r], y = o[r].map((m) => {
      const h = m.date >= l.notVisibleBefore;
      return {
        x: m.date,
        y: t ? m.adjustedValue ? m.adjustedValue : null : m.value ? m.value : null,
        states: {
          hover: {
            halo: {
              size: 0,
              attributes: {
                fill: h ? s : "transparent"
              }
            }
          }
        },
        marker: {
          enabled: !1,
          states: {
            hover: {
              enabled: !0
            }
          },
          fillColor: h ? s : "transparent"
        }
      };
    }).filter((m) => m.x != null && m.y != null), u = {
      type: "line",
      cursor: "pointer",
      name: l.identifier,
      id: l.identifier,
      yAxis: 0,
      data: y,
      pointStart: l.notVisibleBefore,
      color: s,
      dashStyle: l.chartType === "Nav" ? "Solid" : "ShortDot",
      zIndex: r == 0 ? 1 : 0,
      zoneAxis: "x",
      states: {
        inactive: {
          opacity: 1
        },
        hover: {
          halo: {
            size: 8,
            attributes: {
              fill: s
            }
          }
        }
      },
      marker: {
        enabled: !1,
        radius: 0,
        states: {
          hover: {
            enabled: !0,
            radius: 4,
            radiusPlus: 2
          }
        }
      },
      zones: [
        {
          color: "transparent"
        },
        {
          value: l.notVisibleBefore,
          color: s
        }
      ]
    };
    if (a.push(u), !t && n)
      break;
  }
  return a;
}
function FAe(e, t) {
  const n = e.seriesConfiguration, i = [];
  for (let a = 0; a < n.length; a++) {
    const r = zh[a], s = a == 0 ? t : null, l = {
      labels: {
        formatter: function() {
          return jAe(+this.value);
        },
        enabled: !0,
        step: 1,
        style: {
          color: a == 0 ? so : r,
          fontWeight: As,
          fontSize: Ps,
          fontFamily: Is
        }
      },
      title: {
        text: s,
        style: ii
      },
      opposite: a != 0,
      showEmpty: !1,
      allowDecimals: !1
    };
    i.push(l);
  }
  const o = {
    labels: {
      enabled: !1
    },
    title: {
      text: null
    }
  };
  return i.push(o), i;
}
function jAe(e) {
  const t = ".", n = ",";
  return Hd || (Hd = Li()?.translationOptions?.locale), Hd && Hd.startsWith("ja") ? eo.numberFormat(
    e,
    0,
    t,
    n
  ) : e.toString();
}
var PL = { exports: {} };
(function(e, t) {
  (function(n, i) {
    e.exports = i();
  })(rn, function() {
    return function(n, i) {
      i.prototype.isSameOrBefore = function(o, a) {
        return this.isSame(o, a) || this.isBefore(o, a);
      };
    };
  });
})(PL);
var HAe = PL.exports;
const zAe = /* @__PURE__ */ en(HAe);
var VAe = /\s/;
function GAe(e) {
  for (var t = e.length; t-- && VAe.test(e.charAt(t)); )
    ;
  return t;
}
var UAe = GAe, WAe = UAe, YAe = /^\s+/;
function qAe(e) {
  return e && e.slice(0, WAe(e) + 1).replace(YAe, "");
}
var KAe = qAe, XAe = KAe, kx = Wa, ZAe = Nh, Sx = 0 / 0, JAe = /^[-+]0x[0-9a-f]+$/i, QAe = /^0b[01]+$/i, e_e = /^0o[0-7]+$/i, t_e = parseInt;
function n_e(e) {
  if (typeof e == "number")
    return e;
  if (ZAe(e))
    return Sx;
  if (kx(e)) {
    var t = typeof e.valueOf == "function" ? e.valueOf() : e;
    e = kx(t) ? t + "" : t;
  }
  if (typeof e != "string")
    return e === 0 ? e : +e;
  e = XAe(e);
  var n = QAe.test(e);
  return n || e_e.test(e) ? t_e(e.slice(2), n ? 2 : 8) : JAe.test(e) ? Sx : +e;
}
var AL = n_e, i_e = AL, Cx = 1 / 0, a_e = 17976931348623157e292;
function o_e(e) {
  if (!e)
    return e === 0 ? e : 0;
  if (e = i_e(e), e === Cx || e === -Cx) {
    var t = e < 0 ? -1 : 1;
    return t * a_e;
  }
  return e === e ? e : 0;
}
var r_e = o_e, s_e = r_e;
function l_e(e) {
  var t = s_e(e), n = t % 1;
  return t === t ? n ? t - n : t : 0;
}
var c_e = l_e, d_e = wa, u_e = c_e, h_e = AL, Tx = XT, p_e = d_e.isFinite, f_e = Math.min;
function m_e(e) {
  var t = Math[e];
  return function(n, i) {
    if (n = h_e(n), i = i == null ? 0 : f_e(u_e(i), 292), i && p_e(n)) {
      var o = (Tx(n) + "e").split("e"), a = t(o[0] + "e" + (+o[1] + i));
      return o = (Tx(a) + "e").split("e"), +(o[0] + "e" + (+o[1] - i));
    }
    return t(n);
  };
}
var g_e = m_e, v_e = g_e, y_e = v_e("round"), b_e = y_e;
const x_e = /* @__PURE__ */ en(b_e), w_e = { class: "d-performance-chart grid grid-cols-1 lg:grid-cols-3" }, k_e = {
  key: 1,
  class: "col-span-1 lg:col-span-3"
}, S_e = {
  key: 0,
  class: "d-performance-chart__toggle col-span-1 lg:col-span-3 pt-8"
}, C_e = {
  class: "d-performance-chart__toggle__desktop",
  role: "tablist"
}, T_e = {
  key: 0,
  role: "tablist",
  class: "d-performance-chart__controls__periods flex flex-wrap gap-x-2 justify-end"
}, L_e = ["hidden", "disabled", "data-event_title", "data-event_source", "aria-selected", "onClick"], I_e = {
  key: 1,
  class: "flex flex-wrap gap-x-2 justify-end d-performance-chart__controls__calendar-container"
}, P_e = { class: "flex justify-end d-performance-chart__controls__buttons" }, A_e = { class: "chart-download-link bordered" }, M_e = ["data-event_title", "data-event_source", "onClick", "onKeydown", "onSpace"], O_e = { class: "d-performance-chart__legend grid xs:grid-cols-1 lg:grid-cols-2" }, B_e = { class: "item item1 ml-2 mt-4 text-left" }, E_e = {
  key: 0,
  class: "d-performance-chart__series-values flex"
}, D_e = { class: "performance-percent-text" }, R_e = ["aria-label"], N_e = ["onClick", "onKeydown"], $_e = { class: "d-performance-chart__performance-series-title--first" }, F_e = { class: "d-performance-chart__performance-series-title--second" }, j_e = { id: "highcharts-wrapper" }, H_e = ["data-event_source"], z_e = "%", V_e = /* @__PURE__ */ Be({
  __name: "PerformanceChart",
  props: {
    model: {
      type: Object,
      required: !0
    },
    trackingDropdownName: {
      type: String,
      default: "PerformanceCharDropdown"
    }
  },
  emits: ["onDownload"],
  setup(e, { emit: t }) {
    Lt.extend(ks), Lt.extend(Ss), Lt.tz.setDefault("UTC"), Lt.extend(zAe);
    const { localesPrimeVue: n } = Li(), { isMobileAsync: i } = xt(), { currentLocale: o, t: a } = Je(), { formatDateWithPrimeFormat: r } = vm(), s = t, l = e, d = l.model?.chartData?.values?.map((Ee) => Ee[0]), y = {
      name: a("performanceChart.performanceToggleText"),
      value: "0",
      imageUrl: "",
      isSelected: !0
    }, u = {
      name: a("performanceChart.priceToggleText"),
      value: "1",
      imageUrl: "",
      isSelected: !1
    }, m = [
      y,
      u
    ], h = ge(
      l.model?.showOnlyNavHistory ? m[1] : m[0]
    ), c = [
      {
        text: "1M",
        default: !1,
        type: "1M"
      },
      {
        text: "3M",
        default: !1,
        type: "3M"
      },
      {
        text: "6M",
        default: !1,
        type: "6M"
      },
      {
        text: "KJ",
        default: !1,
        type: "YTD"
      },
      {
        text: "1J",
        default: !0,
        type: "1Y"
      },
      {
        text: "3J",
        default: !1,
        type: "3Y"
      },
      {
        text: "5J",
        default: !1,
        type: "5Y"
      },
      {
        text: "10J",
        default: !1,
        type: "10Y"
      },
      {
        text: "20J",
        default: !1,
        type: "20Y"
      },
      {
        text: "MAX",
        default: !1,
        type: "MAX"
      }
    ], g = ge();
    g.value = l.model?.periodButtons ? l.model?.periodButtons?.filter((Ee) => Ee.default === !0)?.map((Ee) => ({
      label: Ee.text,
      value: Ee.type
    }))?.[0] : c.filter((Ee) => Ee.default === !0).map((Ee) => ({
      label: Ee.text,
      value: Ee.type
    }))?.[0];
    const v = ge(!1), P = l.model?.periodButtons ? l.model?.periodButtons?.find((Ee) => Ee.default === !0) : c?.find((Ee) => Ee.default === !0), f = ge(P), S = ge(
      !!l.model?.chartData && !(l.model?.chartData && Object.keys(l.model?.chartData)?.length === 0)
    ), w = ti(le()), x = ti(se()), k = he(x.value, w.value), A = ti(w.value), $ = ti(
      _e(Lt(x.value).utc().subtract(5, "day").valueOf())
    ), j = ti(
      _e(Lt(w.value).utc().add(5, "day").valueOf())
    ), N = ti(x.value), M = ge(null), D = ti(1), C = ti(1), b = ge(), p = ti(1), L = {}, B = ge(), T = ge(), O = ge();
    let I = null;
    const R = ge(Qe().pageName), Y = x.value;
    if (L["1M"] = Lt(Y).utc().subtract(1, "month").valueOf(), L["3M"] = Lt(Y).utc().subtract(3, "month").valueOf(), L["6M"] = Lt(Y).utc().subtract(6, "month").valueOf(), L.YTD = Lt(Y).month(0).date(1).hour(0).minute(0).second(0).millisecond(0).valueOf(), L["1Y"] = Z({ type: "1Y" }) ? Lt(Y).subtract(1, "year").valueOf() : w.value, L["3Y"] = Z({ type: "3Y" }) ? Lt(Y).subtract(3, "year").valueOf() : w.value, L["5Y"] = Z({ type: "5Y" }) ? Lt(Y).subtract(5, "year").valueOf() : w.value, L["10Y"] = Z({ type: "10Y" }) ? Lt(Y).subtract(10, "year").valueOf() : w.value, L["20Y"] = Z({ type: "20Y" }) ? Lt(Y).subtract(20, "year").valueOf() : w.value, L.MAX = w.value, l.model?.chartData?.usePreviousBusinessDateForCalculation) {
      L["1M"] = Le(L["1M"], 0), L["3M"] = Le(L["3M"], 20), L["6M"] = Le(L["6M"], 40), L.YTD = Le(L.YTD, 0);
      const Ee = 120;
      L["1Y"] = Z({ type: "1Y" }) ? Le(L["1Y"], Ee) : w.value, L["3Y"] = Z({ type: "3Y" }) ? Le(L["3Y"], Ee * 3) : w.value, L["5Y"] = Z({ type: "5Y" }) ? Le(L["5Y"], Ee * 5) : w.value, L["10Y"] = Z({
        type: "10Y"
      }) ? Le(L["10Y"], Ee * 10) : w.value, L["20Y"] = Z({
        type: "20Y"
      }) ? Le(L["20Y"], Ee * 20) : w.value;
    }
    const F = (Ee) => ({
      label: Ee.text,
      value: Ee.type
    });
    function U() {
      return l.model?.periodButtons ? l.model.periodButtons?.filter((Ee) => Z(Ee))?.map(
        (Ee) => F(Ee)
      ) : c.filter((Ee) => Z(Ee)).map((Ee) => F(Ee));
    }
    const Q = ge(U());
    function J() {
      const Ee = ee();
      I = Ee;
      const Ne = Ee.tooltip;
      Ne.formatter = function(nt) {
        const ut = a("globalTranslations.date"), bt = a("globalTranslations.startDate"), Bt = a("globalTranslations.endDate"), kt = l.model.chartData.seriesConfiguration[0].tooltipLabelNav ? l.model.chartData.seriesConfiguration[0].tooltipLabelNav : a("performanceChart.nav"), nn = l.model.chartData.seriesConfiguration[0].tooltipLabelPercentage ? l.model.chartData.seriesConfiguration[0].tooltipLabelPercentage : a("performanceChart.navPercent"), an = a("performanceChart.indexLevel"), Cn = a("performanceChart.indexLevelPercent"), Ft = [
          ut,
          bt,
          Bt,
          kt,
          nn,
          an,
          Cn,
          o.value.toString()
        ];
        return gT(
          this,
          nt,
          l.model.chartData,
          h.value?.value === y.value,
          Ft,
          r
        );
      };
      const Ye = Ee.xAxis[0];
      Ye.events = {
        ...Ye.events,
        afterSetExtremes: Jn((nt) => {
          xe(nt);
        }, 500)
      };
      const Xe = Ee.chart;
      Xe.events = {
        ...Xe.events,
        load() {
          b.value = this, T.value = b.value?.series.find(
            (nt) => nt.name == "NavigatorSeries"
          ), B.value = b.value?.series[0];
        }
      };
    }
    function ee() {
      const Ee = qg(RAe);
      if (!S.value)
        return Ee;
      const Ne = wx(l.model?.chartData, !0, !1), Ye = xx(l.model?.chartData), Xe = +l.model?.chartData.values[0][0], nt = $Ae(l.model?.chartData, Xe), ut = l.model?.showOnlyNavHistory ? a("performanceChart.navYaxisLabel") : a("performanceChart.performanceYaxisLabel");
      Ee.yAxis = FAe(l.model?.chartData, ut), Ee.series = Ne;
      const bt = Ee.xAxis;
      if (Ye?.length != 0 && (Ee.series.push(...Ye), bt[0]?.plotBands?.push(...nt)), Ee.navigator != null) {
        const Cn = Ee.navigator?.series, Ft = Ne[0];
        Cn.data = Ft.data;
      }
      let Bt = n?.findIndex(
        (Cn) => Cn.locale.toLowerCase() === o.value.toString().toLowerCase()
      );
      Bt < 0 && (Bt = n?.findIndex(
        (Cn) => Cn.locale.toLowerCase() === "en"
      ));
      const kt = "{#eq handleIx 0}" + a("performanceChart.chartNavigatorHandlesLabelLeft") + "{else}" + a("performanceChart.chartNavigatorHandlesLabelRight") + "{/eq} " + a("performanceChart.chartNavigatorHandlesLabelEnd"), nn = {
        months: n[Bt]?.monthNames,
        weekdays: n[Bt]?.dayNames,
        shortMonths: n[Bt]?.monthNamesShort,
        accessibility: {
          chartContainerLabel: a("performanceChart.chartAriaLabel"),
          navigator: {
            groupLabel: a("performanceChart.chartNavigatorGroupLabel"),
            handleLabel: kt
          }
        }
      };
      Ue && eo.setOptions({ lang: nn }), Ee.lang = nn;
      let an = {
        millisecond: "%e. %b",
        second: "%e. %b",
        minute: "%e. %b",
        hour: "%e. %b",
        day: "%e. %b",
        week: "%e. %b",
        month: "%b %y",
        year: "%Y"
      };
      return l.model.dateTimeLabelFormats ? an = l.model.dateTimeLabelFormats : (o.value.toString().toLowerCase() === "zh-hk" || o.value.toString().toLowerCase() === "zh-cn") && (an = {
        millisecond: "%m日%e日",
        second: "%m日%e日",
        minute: "%m日%e日",
        hour: "%m日%e日",
        day: "%m日%e日",
        week: "%m日%e日",
        month: "%y年%m日",
        year: "%Y年"
      }), bt[0].dateTimeLabelFormats = an, Ee;
    }
    const V = Te(() => {
      const Ee = [];
      if (!S.value)
        return Ee;
      const Ne = G(x.value);
      return l.model?.chartData?.seriesConfiguration?.forEach((Ye) => {
        if (!Ye.notVisibleBefore || Ye.notVisibleBefore < Ne.x) {
          const Xe = b.value?.series?.find(
            (nt) => nt.name === Ye.identifier
          );
          if (Xe != null) {
            const nt = Xe.points?.find(
              (ut) => ut.x === Ne?.x
            );
            if (nt != null) {
              const ut = Object.getOwnPropertyDescriptor(nt, "change"), bt = nt.y?.toLocaleString(o.value.toString(), {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
              }) ?? "", Bt = x_e(Number(ut?.value), 2) ?? "";
              Ee.push({
                identifier: Ye.chartType === "Nav" ? Ye.identifier : a("performanceChart.indexLevel"),
                lastValue: bt,
                lastPerformance: Bt
              });
            }
          }
        }
      }), Ee;
    });
    function G(Ee) {
      let Ne = b.value?.series[0]?.points[0] ?? { x: 0, y: 0 };
      return b.value?.series[0]?.points?.forEach((Ye) => {
        Ye.x <= Ee && Ne.x < Ye.x && (Ne = Ye);
      }), Ne;
    }
    function W(Ee) {
      h.value = Ee;
      const Ne = I;
      if (Ne != null) {
        Ne.plotOptions = {
          ...Ne.plotOptions,
          series: {
            ...Ne.plotOptions?.series,
            compare: h.value.value === y.value ? "percent" : void 0
          }
        };
        const Ye = xx(l.model?.chartData);
        Ne.series = wx(
          l.model?.chartData,
          h.value.value === y.value,
          l.model?.hideIndexInPriceTab ?? !1
        ), Ye?.length != 0 && Ne.series.push(...Ye), Ne.series?.forEach((ut, bt) => {
          ut.type == "line" && (ut.yAxis = h.value?.value === y.value ? 0 : bt);
        });
        const nt = Ne.yAxis;
        nt?.length > 0 && (nt[0].title = {
          ...nt[0].title,
          text: h.value.value === y.value ? a("performanceChart.performanceYaxisLabel") : a("performanceChart.navYaxisLabel")
        }), mt().then(() => {
          pe(w.value, x.value);
        }), C.value++;
      }
    }
    function ae() {
      return S.value ? l.model.hideIndexInPriceTab && h.value?.value === u.value ? l.model?.chartData?.seriesConfiguration?.slice(0, 1) : l.model?.chartData?.seriesConfiguration : [];
    }
    function z() {
      v.value = !v.value, v.value || (w.value = le(), x.value = se(), ne(f.value), document.activeElement instanceof HTMLElement && document.activeElement.blur());
    }
    function q(Ee) {
      let Ne = {};
      Ee.type === "PERIOD" ? (Ne = {
        ...Ee,
        startDate: Lt(w.value).utc().format("YYYY-MM-DD"),
        endDate: Lt(x.value).utc().format("YYYY-MM-DD")
      }, s("onDownload", Ne)) : (Ne = {
        ...Ee,
        startDate: Lt(le()).utc().format("YYYY-MM-DD"),
        endDate: Lt(se()).utc().format("YYYY-MM-DD")
      }, s("onDownload", Ne));
    }
    function Z(Ee) {
      let Ne = 0;
      if (Ee.type !== "MAX" && Ee.type !== "YTD") {
        const Ye = parseInt(Ee.type.replace(/\D/g, "")), nt = Ee.type.replace(/\d+/g, "") === "M" ? 1 : 12;
        Ne = Ye * nt;
      }
      return Ne <= k;
    }
    function ne(Ee) {
      f.value = Ee, g.value = { label: Ee.text, value: Ee.type };
      const Ne = L[Ee.type], Ye = se();
      Ne && mt().then(() => {
        pe(Ne, Ye);
      });
    }
    function ie(Ee) {
      const Ne = l.model.periodButtons.find(
        (Ye) => Ye.type === Ee.value
      );
      Ne && (g.value = Ee, ne(Ne));
    }
    function re(Ee) {
      let Ne = "";
      return Ee.split("{{").forEach((Xe) => {
        const nt = Xe.indexOf("}}");
        if (nt > -1) {
          const ut = Xe.substring(0, nt + 2), bt = Xe.substring(0, nt), Bt = l.model.id;
          Ne += Xe.replace(
            ut,
            `<a class="footnote" id="first-${bt}${Bt}" href="#sec-${bt}${Bt}" v-smooth-scroll="{ duration: 1000, offset: -250}"><sup>[${bt}]</sup></a>`
          );
        } else
          Ne += Xe;
      }), Ne;
    }
    function de(Ee) {
      b.value?.series[Ee].setVisible(!b.value?.series[Ee].visible), Ee === 0 && b.value?.series.forEach((Ne) => {
        Ne.name == "Flags" && Ne.setVisible(B.value?.visible);
      }), T.value?.setVisible(!0);
    }
    function me(Ee) {
      return b.value?.series[Ee]?.visible ? "color:" + zh[Ee] : "color : #EBEEF0";
    }
    function ce(Ee) {
      return Ee.lastPerformance;
    }
    function pe(Ee, Ne) {
      w.value = Ee, x.value = Ne, b.value?.xAxis?.length && b.value.xAxis[0].setExtremes(Ee, Ne, !0);
    }
    function xe(Ee) {
      if (Ee.trigger == "navigator") {
        let Ne = null;
        document.activeElement instanceof HTMLElement && (Ne = document.activeElement, document.activeElement.blur()), v.value = !0, O.value.click();
        const Ye = 432e6;
        Ee.max - Ee.min <= Ye && pe(Ee.max - Ye, Ee.max);
        const Xe = b.value?.xAxis[0]?.series[0]?.data?.filter(
          (bt) => bt.x >= Ee.min && bt.x <= Ee.max
        )?.map((bt) => bt.x) ?? [], nt = Math.round(Math.min(...Xe)), ut = Math.round(Math.max(...Xe));
        w.value = nt, x.value = ut, j.value = _e(
          Lt(w.value).utc().add(5, "day").valueOf()
        ), $.value = _e(
          Lt(x.value).utc().subtract(5, "day").valueOf()
        ), (Math.round(Ee.min) !== nt || Math.round(Ee.max) !== ut) && pe(w.value, x.value), D.value++, Ne.focus();
      }
    }
    function le() {
      return S.value ? d[0] : Lt().utc().valueOf();
    }
    function se() {
      return S.value ? d[d?.length - 1] : Lt().utc().valueOf();
    }
    function he(Ee, Ne) {
      const Ye = Lt(Ee).utc(), Xe = Lt(Ne).utc();
      return Ye.diff(Xe, "month");
    }
    const ve = Te(() => l.model?.periodButtons ? l.model.periodButtons : c);
    function ye(Ee) {
      w.value = He(Ee), j.value = _e(
        Lt(w.value).utc().add(5, "day").valueOf()
      ), D.value++, mt().then(() => {
        pe(w.value, x.value);
      });
    }
    function be(Ee) {
      x.value = He(Ee), $.value = _e(
        Lt(x.value).utc().subtract(5, "day").valueOf()
      ), D.value++, mt().then(() => {
        pe(w.value, x.value);
      });
    }
    const ke = ge(), we = ge();
    J(), it(() => {
      pn({
        trigger: ke,
        headline: v.value ? a("performanceChart.calendarCloseTooltipText") : a("performanceChart.calendarTooltipText"),
        content: v.value ? a("performanceChart.calendarCloseTooltipText") : a("performanceChart.calendarTooltipText"),
        appendTo: ke.value,
        showOnTouchDevices: !1,
        field: () => ke
      }), pn({
        trigger: we,
        headline: a("performanceChart.downloadTooltipText"),
        content: a("performanceChart.downloadTooltipText"),
        appendTo: we.value,
        showOnTouchDevices: !1,
        field: () => we
      }), C.value++;
      const Ee = l?.model?.periodButtons?.find(
        (Ne) => Ne?.default === !0
      );
      Ee && ne(Ee), l.model?.showOnlyNavHistory && W(u);
    });
    function Le(Ee, Ne) {
      for (let Ye = d.length - 1 - Ne; Ye >= 0; Ye--)
        if (Lt(d[Ye]).utc().isSameOrBefore(Ee, "day"))
          return d[Ye];
      return Ee;
    }
    function Me() {
      const Ee = /* @__PURE__ */ new Date(), Ne = new Date(Ee.getFullYear(), 0, 1), Ye = new Date(Ee.getFullYear(), 6, 1);
      return Math.max(
        Ne.getTimezoneOffset(),
        Ye.getTimezoneOffset()
      );
    }
    function De() {
      return -Me() / 60;
    }
    function Ae(Ee) {
      return Ee.getTimezoneOffset() < Me();
    }
    function _e(Ee) {
      const Ne = new Date(Ee), Ye = Ne.getUTCFullYear(), Xe = ("0" + (Ne.getUTCMonth() + 1)).slice(-2), nt = ("0" + Ne.getUTCDate()).slice(-2);
      return Lt(`${Ye}-${Xe}-${nt}`).toDate();
    }
    function He(Ee) {
      const Ne = Ae(Lt(Ee).toDate()) ? 1 : 0;
      return Lt(Ee).add(De(), "hour").add(Ne, "hour").valueOf();
    }
    return (Ee, Ne) => {
      const Ye = $e("BaseText");
      return E(), X("div", w_e, [
        S.value ? te("", !0) : (E(), fe(Ye, {
          key: 0,
          text: e.model?.noDataText,
          class: "xs:col-span-1 lg:col-span-3"
        }, null, 8, ["text"])),
        S.value ? (E(), X("div", k_e, [
          e.model?.showOnlyNavHistory ? te("", !0) : (E(), X("div", S_e, [
            ue(vi, {
              class: "d-performance-chart__toggle__mobile w-full mb-4 lg:hidden",
              items: m,
              selected: h.value,
              "event-component-name": e.trackingDropdownName,
              onSelectedItemChanged: W
            }, null, 8, ["selected", "event-component-name"]),
            oe("div", C_e, [
              ue(_(ki), {
                label: `${_(a)("performanceChart.performanceToggleText")}`,
                class: Pe(["d-performance-chart__toggle__desktop--button p-button-rounded", {
                  active: h.value?.value === y.value
                }]),
                "data-event_component_name": "Chart",
                "data-event_title": `Toggle | ${_(a)(
                  "performanceChart.performanceToggleText"
                )}`,
                role: "tab",
                "data-event_source": R.value,
                value: `${_(a)("performanceChart.performanceToggleText")}`,
                "aria-selected": h.value?.value === y.value,
                onClick: Ne[0] || (Ne[0] = (Xe) => W(y))
              }, null, 8, ["label", "class", "data-event_title", "data-event_source", "value", "aria-selected"]),
              ue(_(ki), {
                label: `${_(a)("performanceChart.priceToggleText")}`,
                class: Pe(["d-performance-chart__toggle__desktop--button p-button-rounded", {
                  active: h.value?.value === u.value
                }]),
                "data-event_component_name": "Chart",
                "data-event_title": `Toggle | ${_(a)(
                  "performanceChart.priceToggleText"
                )}`,
                role: "tab",
                value: `${_(a)("performanceChart.priceToggleText")}`,
                "data-event_source": R.value,
                "aria-selected": h.value?.value === u.value,
                onClick: Ne[1] || (Ne[1] = (Xe) => W(u))
              }, null, 8, ["label", "class", "data-event_title", "value", "data-event_source", "aria-selected"])
            ])
          ])),
          (E(), X("div", {
            key: p.value,
            class: "d-performance-chart__controls d-performance-chart__performance-buttons flex flex-col mb-4 lg:flex-row lg:justify-end"
          }, [
            v.value ? te("", !0) : (E(), X("span", T_e, [
              _(i) ? (E(), fe(Oh, {
                key: 0,
                "aria-label": _(a)("performanceChart.calendarTooltipText"),
                class: "d-performance-chart__performance-buttons-dropdown",
                model: {
                  options: Q.value,
                  selectedItem: g.value,
                  componentName: "Year Buttons"
                },
                onSelectedItemChanged: ie
              }, null, 8, ["aria-label", "model"])) : (E(!0), X(Re, { key: 1 }, Ge(ve.value, (Xe) => (E(), X("button", {
                key: "per-but-" + Xe.type,
                hidden: !Z(Xe),
                disabled: v.value,
                class: Pe(["performance-buttons-period", {
                  "performance-buttons-period__active": Xe.type === f.value?.type
                }]),
                "data-event_component_name": "Chart",
                "data-event_title": `Year Buttons | ${Xe.text}`,
                "data-event_source": R.value,
                role: "tab",
                "aria-selected": Xe.type === f.value?.type,
                onClick: (nt) => ne(Xe)
              }, Ie(Xe.text), 11, L_e))), 128))
            ])),
            v.value ? (E(), X("span", I_e, [
              (E(), fe(TL, {
                key: D.value,
                class: "d-performance-chart__controls__periodcalendar",
                "selected-from-date": _e(w.value),
                "selected-to-date": _e(x.value),
                "min-date-from": _e(A.value),
                "max-date-from": $.value,
                "min-date-to": j.value,
                "max-date-to": _e(N.value),
                "show-labels": !1,
                "onUpdate:selectedFromDate": ye,
                "onUpdate:selectedToDate": be
              }, null, 8, ["selected-from-date", "selected-to-date", "min-date-from", "max-date-from", "min-date-to", "max-date-to"]))
            ])) : te("", !0),
            oe("span", P_e, [
              oe("div", {
                ref_key: "controlButtonTooltipTriggerCalender",
                ref: ke
              }, [
                ue(Nt, {
                  type: _(Ke).RoundedSecondary,
                  size: _(et).Small,
                  "link-model": {
                    title: _(a)("performanceChart.calendarTooltipText"),
                    tealiumTrackingModel: v.value ? {
                      eventComponentName: "Chart",
                      eventTitle: "Calendar opened",
                      eventSource: R.value
                    } : {}
                  },
                  icon: v.value ? _(H).CalendarTimes : _(H).CalendarAlt,
                  "aria-expanded": v.value,
                  onClick: z,
                  onMouseout: _(ld),
                  onTouchend: _(ld)
                }, null, 8, ["type", "size", "link-model", "icon", "aria-expanded", "onMouseout", "onTouchend"])
              ], 512),
              e.model?.documents?.length ? (E(), X("div", {
                key: 0,
                ref_key: "controlButtonTooltipTriggerDownload",
                ref: we
              }, [
                ue(_(ki), {
                  class: "d-performance-chart__controls__button p-button-icon-only p-button-rounded performance-buttons-add p-cal-dl-buttons dd-small",
                  "aria-label": _(a)("performanceChart.downloadTooltipText"),
                  onMouseout: _(ld),
                  onTouchend: _(ld)
                }, {
                  default: Se(() => [
                    ue(Zc, {
                      options: e.model.documents,
                      "option-label": "name",
                      "option-value": "name",
                      "empty-label": !0,
                      "loading-icon": "las la-download",
                      class: "d-performance-chart__documents-button p-button-icon"
                    }, {
                      option: Se((Xe) => [
                        oe("div", A_e, [
                          oe("a", {
                            "data-event_component_name": "Chart",
                            "data-event_title": "Download | " + Xe.option.name,
                            "data-event_source": R.value,
                            onClick: (nt) => q(Xe.option),
                            onKeydown: Ze((nt) => q(Xe.option), ["enter"]),
                            onSpace: (nt) => q(Xe.option)
                          }, Ie(Xe.option.name), 41, M_e)
                        ])
                      ]),
                      _: 1
                    }, 8, ["options"])
                  ]),
                  _: 1
                }, 8, ["aria-label", "onMouseout", "onTouchend"])
              ], 512)) : te("", !0)
            ])
          ])),
          oe("div", O_e, [
            oe("div", B_e, [
              h.value?.value === y.value ? (E(), X("div", E_e, [
                (E(!0), X(Re, null, Ge(V.value, (Xe) => (E(), X("div", {
                  key: Xe.identifier
                }, [
                  oe("span", D_e, [
                    ue(_(ht), {
                      "html-text": re(Xe.identifier),
                      "disable-default-styling": ""
                    }, null, 8, ["html-text"])
                  ]),
                  Ne[2] || (Ne[2] = oe("br", null, null, -1)),
                  ue(ad, {
                    class: "performance-percent-number",
                    number: ce(Xe),
                    "add-percent": !0,
                    "percent-sign": z_e
                  }, null, 8, ["number"])
                ]))), 128))
              ])) : te("", !0)
            ]),
            oe("div", {
              class: "d-performance-chart__performance-fonds item item2 mx-2 mt-4 text-right",
              role: "navigation",
              "aria-label": _(a)("performanceChart.chartSeriesLabel")
            }, [
              (E(!0), X(Re, null, Ge(ae(), (Xe, nt) => (E(), X("div", {
                key: Xe.identifier,
                tabindex: 0,
                role: "button",
                class: "d-performance-chart__performance-series-title",
                style: hn(me(nt)),
                onClick: (ut) => de(nt),
                onKeydown: [
                  Ze(It((ut) => de(nt), ["prevent"]), ["enter"]),
                  Ze(It((ut) => de(nt), ["prevent"]), ["space"])
                ]
              }, [
                oe("div", $_e, [
                  oe("i", {
                    class: Pe(["las text-xl", {
                      "la-minus": Xe.chartType == "Nav",
                      "la-ellipsis-h": Xe.chartType != "Nav"
                    }]),
                    style: hn(me(nt))
                  }, null, 6)
                ]),
                oe("div", F_e, Ie(Xe.identifier), 1)
              ], 44, N_e))), 128))
            ], 8, R_e)
          ]),
          oe("div", j_e, [
            _(I) ? (E(), fe(Xc, {
              ref_key: "highChartRef",
              ref: M,
              key: C.value,
              options: _(I),
              "chart-type": e.model.chartType,
              height: e.model.height
            }, null, 8, ["options", "chart-type", "height"])) : te("", !0)
          ]),
          oe("button", {
            ref_key: "navigatorEvent",
            ref: O,
            hidden: !0,
            "data-event_source": R.value,
            "data-event_component_name": "Chart",
            "data-event_title": "Navigator"
          }, " . ", 8, H_e)
        ])) : te("", !0)
      ]);
    };
  }
});
const OEe = /* @__PURE__ */ Fe(V_e, [["__scopeId", "data-v-a08030d8"]]), Lx = (e) => !e || !e.text ? !1 : e.text.length > 0, G_e = { class: "d-person-section__image-container" }, U_e = {
  key: 1,
  class: "d-person-section__no-image"
}, W_e = { class: "d-person-section__info" }, Y_e = { class: "d-person-section__contact" }, q_e = {
  key: 2,
  class: "d-person-section__location"
}, K_e = {
  key: 0,
  class: "d-person-section__angle"
}, X_e = /* @__PURE__ */ Be({
  __name: "PersonSection",
  props: {
    model: {
      type: Object,
      required: !0
    },
    disableImages: {
      type: Boolean,
      required: !0
    }
  },
  setup(e) {
    return (t, n) => {
      const i = $e("BaseImage"), o = $e("BaseIcon"), a = $e("BaseHeading"), r = $e("BaseText");
      return E(), X("div", {
        class: Pe([
          "d-person-section",
          e.model.link ? "d-person-section__with-link" : "d-person-section__without_link"
        ])
      }, [
        oe("div", G_e, [
          e.model.image && !e.disableImages ? (E(), fe(i, {
            key: 0,
            model: e.model.image,
            "responsive-options": [
              {
                height: 160,
                width: 160,
                dxBreakpoint: _(Ct).Xs
              }
            ],
            class: "d-person-section__image"
          }, null, 8, ["model", "responsive-options"])) : te("", !0),
          !e.model.image || e.disableImages ? (E(), X("div", U_e, [
            ue(o, {
              "base-icon": _(H).User,
              "base-icon-size": _(at).Inherit,
              "base-icon-color": _(gt).Inherit
            }, null, 8, ["base-icon", "base-icon-size", "base-icon-color"])
          ])) : te("", !0)
        ]),
        oe("div", W_e, [
          e.model.name ? (E(), fe(a, {
            key: 0,
            "base-heading-type": _(ze).H3,
            class: "d-person-section__name"
          }, {
            default: Se(() => [
              Ve(Ie(e.model.name), 1)
            ]),
            _: 1
          }, 8, ["base-heading-type"])) : te("", !0),
          e.model.position ? (E(), fe(r, {
            key: 1,
            text: e.model.position,
            "font-type": _(lt).DwsSlab,
            "text-color": _(dt).GreyBlue006,
            class: "d-person-section__position"
          }, null, 8, ["text", "font-type", "text-color"])) : te("", !0),
          oe("div", Y_e, [
            _(Lx)(e.model.mail) ? (E(), fe(ot, {
              key: 0,
              class: "d-person-section__mail flex",
              "is-copy-link": !0,
              "link-model": e.model.mail,
              icon: _(H).Envelope,
              "icon-position": _(ct).Left
            }, null, 8, ["link-model", "icon", "icon-position"])) : te("", !0),
            _(Lx)(e.model.tel) ? (E(), fe(ot, {
              key: 1,
              class: "d-person-section__tel flex",
              "is-copy-link": !0,
              "link-model": e.model.tel,
              icon: _(H).Phone,
              "icon-position": _(ct).Left
            }, null, 8, ["link-model", "icon", "icon-position"])) : te("", !0),
            e.model.location && e.model.location.length > 0 ? (E(), X("span", q_e, [
              ue(o, {
                "base-icon-color": _(gt).Inherit,
                "base-icon": _(H).MapMarker
              }, null, 8, ["base-icon-color", "base-icon"]),
              Ve(Ie(e.model.location), 1)
            ])) : te("", !0)
          ])
        ]),
        e.model.link ? (E(), X("div", K_e, [
          ue(o, {
            "base-icon": _(H).AngleRight,
            "base-icon-color": _(gt).White,
            "base-icon-size": _(at).M
          }, null, 8, ["base-icon", "base-icon-color", "base-icon-size"])
        ])) : te("", !0)
      ], 2);
    };
  }
});
const Ix = /* @__PURE__ */ Fe(X_e, [["__scopeId", "data-v-eafc0580"]]), Z_e = { class: "d-person-section-block" }, J_e = { class: "mb-6" }, Q_e = { class: "d-person-section-block__cards grid gap-10 grid-cols-1 lg:grid-cols-1 xl:grid-cols-2" }, eMe = /* @__PURE__ */ Be({
  __name: "PersonSectionBlock",
  props: {
    personSectionBlockProps: {
      type: Object,
      required: !0
    }
  },
  setup(e) {
    return (t, n) => {
      const i = $e("BaseHeading");
      return E(), X("div", Z_e, [
        oe("div", J_e, [
          e.personSectionBlockProps.title ? (E(), fe(i, {
            key: 0,
            "base-heading-type": _(ze).H2
          }, {
            default: Se(() => [
              Ve(Ie(e.personSectionBlockProps.title), 1)
            ]),
            _: 1
          }, 8, ["base-heading-type"])) : te("", !0)
        ]),
        oe("div", Q_e, [
          (E(!0), X(Re, null, Ge(e.personSectionBlockProps.personSectionProps, (o, a) => (E(), X(Re, { key: a }, [
            o.link ? (E(), fe(ot, {
              key: 0,
              "link-model": o.link,
              class: "d-person-section-block__card-link"
            }, {
              container: Se(() => [
                ue(Ix, {
                  model: o,
                  "disable-images": e.personSectionBlockProps.disableImages
                }, null, 8, ["model", "disable-images"])
              ]),
              _: 2
            }, 1032, ["link-model"])) : te("", !0),
            o.link ? te("", !0) : (E(), fe(Ix, {
              key: 1,
              model: o,
              "disable-images": e.personSectionBlockProps.disableImages
            }, null, 8, ["model", "disable-images"]))
          ], 64))), 128))
        ])
      ]);
    };
  }
});
const BEe = /* @__PURE__ */ Fe(eMe, [["__scopeId", "data-v-e462bd60"]]);
const tMe = { class: "product-header__background" }, nMe = ["src", "alt"], iMe = { class: "container product-header__breadcrumb-wrapper" }, aMe = { class: "product-header__container grid xs:grid-cols-1 lg:grid-cols-6 xl:grid-cols-5 print:grid-cols-1 container" }, oMe = {
  key: 0,
  class: "xs:col-span-1 lg:col-span-3 fund-name product-header__description"
}, rMe = { class: "pr-4" }, sMe = { class: "inline-block product-header__description__title__buttons" }, lMe = {
  key: 0,
  class: "product-header__description__fund-identifier"
}, cMe = { class: "product-header__description__fund-identifier__column" }, dMe = { class: "product-header__description__fund-identifier__column__label" }, uMe = {
  key: 1,
  class: "product-header__description__text mt-8 mb-16"
}, hMe = { class: "product-header__description__btn-group gap-2.5" }, pMe = {
  key: 3,
  class: "mt-8"
}, fMe = {
  key: 1,
  class: "xs:col-span-1 lg:col-span-3 xl:col-span-2 product-header__details"
}, mMe = 700, EEe = /* @__PURE__ */ Be({
  __name: "ProductHeader",
  props: {
    userData: { default: () => ({
      isBookmarked: !1
    }) },
    breadcrumbModel: { default: () => ({
      breadcrumbs: [],
      siblings: [],
      currentShareClassName: "",
      metaTags: {
        ogUrl: ""
      }
    }) },
    productHeader: { default: () => ({
      shrinkHeaderValues: [],
      corporateNotifications: [],
      tableValues: [],
      footnotes: [],
      disclaimerHtml: [],
      id: "product-header-default"
    }) }
  },
  emits: [
    "bookmarked",
    "ctaButtonClicked",
    "buyAndSellClicked"
  ],
  setup(e, { emit: t }) {
    const n = t, i = e, o = Jt(), { pageName: a } = Qe(), r = a, { t: s } = Je(), l = ge(), d = xm().productHeader, y = ge(), { headerRef: u, shrinkHeaderRef: m } = Fn(), h = Te(() => i?.productHeader?.anchorLink ? i.productHeader.anchorLink : {
      text: s("productHeader.allDocuments"),
      href: "#downloads",
      target: "_self",
      contentUrl: "",
      title: s("productHeader.allDocuments"),
      isLocked: !1,
      isExternal: !1,
      linkType: yt.Anchor,
      tealiumTrackingModel: {
        eventComponentName: "Product-Header",
        eventTitle: "Downloads | regular | all",
        eventSource: r,
        eventTarget: "Alle Dokumente"
      }
    }), c = () => !u.value || !m.value ? -190 : (u.value?.scrollHeight + m.value?.scrollHeight) * -1, g = ge(c()), v = Te(() => i.productHeader?.tableValues ? i.productHeader.tableValues.filter(
      (x) => x.isHighlighted
    ) : []), P = Te(() => i.productHeader?.tableValues ? i.productHeader.tableValues.filter(
      (x) => !x.isHighlighted
    ) : []), f = Te(() => i.productHeader?.texts?.descriptionText ?? i.productHeader?.texts?.productText), S = Te(() => i.breadcrumbModel?.siblings?.sort(
      (x, k) => x.name < k.name ? -1 : 1
    ));
    it(() => {
      g.value = c(), y?.value && (y.value.setAttribute("hidden", "hidden"), l.value && pn({
        trigger: l.value.buttonRef,
        content: s("alertButton.label"),
        appendTo: l.value.buttonRef,
        showOnTouchDevices: !0,
        field: () => l.value.buttonRef
      }));
    });
    function w() {
      return y?.value && (y.value.removeAttribute("hidden"), y.value.click(), y.value.setAttribute("hidden", "hidden")), !0;
    }
    return (x, k) => {
      const A = $e("BaseHeading"), $ = Ut("smooth-scroll");
      return E(), X("div", {
        ref_key: "productHeaderRef",
        ref: d,
        class: "product-header"
      }, [
        oe("div", tMe, [
          oe("img", {
            class: "product-header-image",
            src: i.productHeader?.backgroundImageUrl,
            alt: i.productHeader?.backgroundImageAlt
          }, null, 8, nMe)
        ]),
        oe("div", iMe, [
          i.breadcrumbModel ? (E(), fe(zg, {
            key: 0,
            breadcrumbs: i.breadcrumbModel.breadcrumbs,
            "values-main": {
              tooltipTextShare: _(s)("globalTranslations.tooltipTextShare"),
              tooltipTextPrint: _(s)("globalTranslations.tooltipTextPrint")
            },
            "share-class-items": S.value,
            "current-share-class-label": i.breadcrumbModel?.currentShareClassName,
            "share-class-select-label": _(s)("globalTranslations.shareClassSelectLabel"),
            "meta-tags": i.breadcrumbModel.metaTags,
            class: "xs:col-span-1 lg:col-span-6 xl:col-span-6",
            "has-blue-gradient-background": !0
          }, null, 8, ["breadcrumbs", "values-main", "share-class-items", "current-share-class-label", "share-class-select-label", "meta-tags"])) : te("", !0)
        ]),
        oe("div", aMe, [
          (E(!0), X(Re, null, Ge(i?.productHeader?.corporateNotifications, (j, N) => (E(), X("div", {
            key: `${j?.title}_${N}`,
            class: Pe(["xs:col-span-1 lg:col-span-6 xl:grid-cols-5 mb-4", {
              "mb-14": N === i.productHeader?.corporateNotifications.length - 1
            }])
          }, [
            ue(_(Eh), { notification: j }, null, 8, ["notification"])
          ], 2))), 128)),
          i.productHeader?.texts ? (E(), X("div", oMe, [
            ue(A, {
              id: "product-header-title",
              class: "product-header__description__title",
              "base-heading-type": _(ze).H1
            }, {
              default: Se(() => [
                oe("span", rMe, Ie(i.productHeader?.texts.title), 1),
                oe("div", sMe, [
                  i.productHeader?.addToWatchlistUrl ? (E(), fe(PT, {
                    key: 0,
                    "add-to-watchlist-url": i.productHeader?.addToWatchlistUrl,
                    "is-bookmarked": i.userData?.isBookmarked,
                    "button-size": _(et).Medium,
                    onBookmarked: k[0] || (k[0] = (j) => n("bookmarked"))
                  }, null, 8, ["add-to-watchlist-url", "is-bookmarked", "button-size"])) : te("", !0),
                  i.productHeader?.alertUrl ? (E(), fe(Nt, {
                    key: 1,
                    ref_key: "alertButton",
                    ref: l,
                    class: "alert-button ml-2",
                    type: _(Ke).RoundedSecondary,
                    size: _(et).Medium,
                    "link-model": {
                      text: _(s)("alertButton.label"),
                      title: _(s)("alertButton.label"),
                      href: i.productHeader?.alertUrl,
                      target: "_blank",
                      tealiumTrackingModel: {
                        eventComponentName: "Product-Header",
                        eventTitle: "Subscribe | regular",
                        eventSource: _(r)
                      }
                    },
                    icon: _(H).Bell
                  }, null, 8, ["type", "size", "link-model", "icon"])) : te("", !0)
                ])
              ]),
              _: 1
            }, 8, ["base-heading-type"]),
            i.productHeader?.identifier ? (E(), X("div", lMe, [
              oe("table", null, [
                (E(!0), X(Re, null, Ge(i.productHeader?.identifier, (j) => (E(), X("tr", {
                  key: j
                }, [
                  oe("td", cMe, [
                    oe("span", dMe, Ie(j.key) + ": ", 1)
                  ]),
                  oe("td", null, [
                    ue(Kg, {
                      "input-text": j.value,
                      "event-component-name": "Product-Header",
                      class: "pr-2",
                      "text-aria-labeled-by": "product-header-title"
                    }, null, 8, ["input-text"])
                  ])
                ]))), 128))
              ])
            ])) : te("", !0),
            i.productHeader?.texts.descriptionText || i.productHeader?.texts.productText || _(o).descriptionArea ? (E(), X("div", uMe, [
              f.value ? (E(), fe(sfe, {
                key: 0,
                "is-plain-text": (i.productHeader?.texts?.descriptionTextIsHtml ?? !1) == !1,
                text: f.value,
                "text-limit": mMe
              }, null, 8, ["is-plain-text", "text"])) : te("", !0),
              je(x.$slots, "descriptionArea")
            ])) : te("", !0),
            oe("div", hMe, [
              i.productHeader?.buyAndSell ? (E(), fe(vt, {
                key: 0,
                type: _(Ke).Primary,
                size: _(et).Medium,
                "button-type": _(zt).Link,
                "link-model": {
                  text: i.productHeader?.buyAndSell?.label,
                  tealiumTrackingModel: {
                    eventComponentName: "Product-Header",
                    eventTitle: `Button | ${i.productHeader?.buyAndSell.label}  | regular`,
                    eventSource: _(r)
                  }
                },
                onClick: k[1] || (k[1] = (j) => n("buyAndSellClicked", j))
              }, null, 8, ["type", "size", "button-type", "link-model"])) : te("", !0),
              i.productHeader?.button ? (E(), fe(vt, {
                key: 1,
                type: _(Ke).Primary,
                size: _(et).Medium,
                "button-type": _(zt).Link,
                "link-model": {
                  text: i.productHeader?.button.label,
                  href: i.productHeader?.button.href,
                  target: i.productHeader?.button.target,
                  tealiumTrackingModel: {
                    eventComponentName: "Product-Header",
                    eventTitle: "Order | regular",
                    eventSource: _(r)
                  }
                },
                onClick: k[2] || (k[2] = (j) => n(
                  "ctaButtonClicked",
                  j,
                  i.productHeader?.button?.href
                ))
              }, null, 8, ["type", "size", "button-type", "link-model"])) : te("", !0),
              je(x.$slots, "callToActionButtons"),
              i.productHeader?.documents && i.productHeader?.documents.length > 0 ? (E(), fe(Zc, {
                key: 2,
                options: i.productHeader?.documents,
                "option-label": "name",
                "option-value": "name",
                placeholder: i.productHeader?.texts.downloadButton,
                "reset-option-label": !0,
                "download-anchor": !0,
                "anchor-link": h.value,
                "data-event-source": _(r),
                "event-component-name": "Product-Header",
                onBeforeShow: w
              }, {
                option: Se((j) => [
                  ue(ot, {
                    class: "product-header__description__btn-group__documents__item border",
                    "link-model": {
                      text: j.option.name,
                      href: j.option.url,
                      target: "_blank",
                      contentUrl: "",
                      title: "",
                      isLocked: !1,
                      isExternal: !1,
                      linkType: _(yt).Default,
                      tealiumTrackingModel: {
                        eventComponentName: "Product-Header",
                        eventTitle: "Downloads | regular",
                        eventSource: _(r),
                        eventTarget: `${j.option.name}`
                      }
                    },
                    icon: _(H).FileDownload,
                    "icon-position": _(ct).Left
                  }, null, 8, ["link-model", "icon", "icon-position"])
                ]),
                _: 1
              }, 8, ["options", "placeholder", "anchor-link", "data-event-source"])) : te("", !0),
              oe("button", {
                ref_key: "dropdownOpenerButton",
                ref: y,
                hidden: "",
                "aria-hidden": ""
              }, ".", 512),
              i.productHeader?.furtherInfoButton ? rt((E(), fe(ot, {
                key: 3,
                class: "further-info-link d-entry-gate__home-link",
                "link-model": {
                  text: i.productHeader?.furtherInfoButton.label,
                  href: i.productHeader?.furtherInfoButton.href,
                  target: "_blank",
                  contentUrl: "",
                  title: "bla",
                  isLocked: !1,
                  isExternal: !1,
                  linkType: _(yt).Default,
                  tealiumTrackingModel: {
                    eventSource: _(r),
                    eventComponentName: "Text Links (same page)",
                    eventTitle: `${i.productHeader?.furtherInfoButton.label}`
                  }
                },
                icon: _(H).ArrowDown,
                "icon-position": _(ct).Left
              }, null, 8, ["link-model", "icon", "icon-position"])), [
                [$, { offset: g.value }]
              ]) : te("", !0)
            ]),
            i.productHeader.footnotes && i.productHeader.footnotes.length > 0 ? (E(), fe(ja, {
              key: 2,
              class: "xs:col-span-1 lg:col-span-3 mt-4",
              values: i.productHeader
            }, null, 8, ["values"])) : te("", !0),
            i.productHeader.disclaimerHtml ? (E(), X("div", pMe, [
              (E(!0), X(Re, null, Ge(i.productHeader.disclaimerHtml, (j) => (E(), fe(Mr, {
                key: j.text,
                values: j.text,
                class: "xs:col-span-1 lg:col-span-2",
                "number-column": 1
              }, null, 8, ["values"]))), 128))
            ])) : te("", !0)
          ])) : te("", !0),
          i.productHeader?.tableValues ? (E(), X("div", fMe, [
            v.value?.length > 0 ? (E(), X("div", {
              key: 0,
              class: Pe(["product-header__details__fund-card top", {
                "full-card": !P.value || P.value.length == 0
              }])
            }, [
              ue(Ar, {
                model: {
                  items: v.value,
                  id: "product-header-items-highlighted",
                  footnoteReferenceId: i.productHeader.id
                }
              }, null, 8, ["model"])
            ], 2)) : te("", !0),
            P.value?.length > 0 ? (E(), X("div", {
              key: 1,
              class: Pe(["product-header__details__fund-card bottom", {
                "full-card": !v.value || v.value.length == 0
              }])
            }, [
              ue(Ar, {
                model: {
                  items: P.value,
                  id: "product-header-items-normal",
                  footnoteReferenceId: i.productHeader.id
                }
              }, null, 8, ["model"])
            ], 2)) : te("", !0)
          ])) : te("", !0)
        ])
      ], 512);
    };
  }
}), gMe = { class: "flex flex-wrap xs:flex-col md:flex-row container" }, vMe = { id: "shrink-header-title" }, yMe = {
  key: 0,
  class: "shrink-header__cta-buttons"
}, bMe = {
  key: 0,
  class: "shrink-header__btn-group flex flex-col md:flex-row justify-end xs:w-full md:w-1/2 gap-4 xs:order-3 md:order-2"
}, xMe = { class: "flex items-baseline w-full xs:order-2 md:order-3" }, wMe = {
  key: 0,
  class: "shrink-header__fund-identifier"
}, kMe = { class: "shrink-header__fund-identifier__paragraph" }, SMe = { class: "shrink-header__fund-data" }, CMe = { class: "mr-3 shrink-header__fund-data__paragraph__value" }, TMe = {
  key: 0,
  class: "shrink-header__fund-data__paragraph__value__subValue"
}, LMe = { class: "shrink-header__fund-data__paragraph__value__subValue__text" }, zd = /* @__PURE__ */ Be({
  __name: "ShrinkHeader",
  props: {
    userData: { default: () => ({
      isBookmarked: !1
    }) },
    productHeader: { default: () => ({
      shrinkHeaderValues: [],
      corporateNotifications: [],
      tableValues: [],
      id: "product-header-default"
    }) }
  },
  emits: ["bookmarked", "ctaButtonClicked"],
  setup(e) {
    const t = e, n = ge(), i = ge(!1), o = ge(!1), a = ge(), r = ge(), { pageName: s } = Qe(), l = s, { t: d } = Je(), { setShrinkHeader: y, headerRef: u } = Fn(), m = Te(() => t?.productHeader?.anchorLink ? t.productHeader.anchorLink : {
      text: d("productHeader.allDocuments"),
      href: "#downloads",
      target: "_self",
      contentUrl: "",
      title: d("productHeader.allDocuments"),
      isLocked: !1,
      isExternal: !1,
      linkType: yt.Anchor,
      tealiumTrackingModel: {
        eventComponentName: "Shrink-Header",
        eventTitle: "Downloads | regular | all",
        eventSource: l,
        eventTarget: "Alle Dokumente"
      }
    });
    it(() => {
      a.value && y(a.value), Ue && (h(), window.addEventListener("scroll", v, { passive: !0 }), window.addEventListener("resize", g)), n.value && pn({
        trigger: n.value.buttonRef,
        content: d("alertButton.label"),
        appendTo: n.value.buttonRef,
        showOnTouchDevices: !0,
        field: () => n.value.buttonRef
      });
    }), sn(() => {
      Ue && (window.removeEventListener("scroll", v), window.removeEventListener("resize", g));
    });
    const h = () => {
      u.value && new MutationObserver(function(w) {
        w.forEach(function(x) {
          x.target.className.includes("fixed-on-up") ? c(!0) : c(!1);
        });
      }).observe(u.value, {
        attributes: !0,
        attributeFilter: ["class"]
      });
    }, c = (S) => {
      fi(() => {
        i.value = S;
      }, 250);
    };
    async function g() {
      if (!a.value)
        return;
      const { setShrinkHeader: S } = Fn();
      S(a.value);
    }
    const v = Jn(
      () => {
        f();
      },
      250,
      { maxWait: 500 }
    );
    function P() {
      return r?.value && (r.value.removeAttribute("hidden"), r.value.click(), r.value.setAttribute("hidden", "hidden")), !0;
    }
    async function f() {
      if (!Ue)
        return;
      const { productHeader: S } = xm();
      if (!S.value || !a.value)
        return;
      await mt();
      const x = S.value.getBoundingClientRect()?.bottom;
      if (no("(max-width: 320px)").value) {
        o.value = !1;
        return;
      }
      x < 0 ? o.value = !0 : o.value = !1;
    }
    return (S, w) => {
      const x = $e("BaseHeading");
      return E(), X("div", {
        ref_key: "shrinkHeader",
        ref: a,
        role: "main",
        class: Pe(["shrink-header", {
          "extra-top": i.value,
          "show-element": o.value
        }])
      }, [
        oe("div", gMe, [
          oe("div", {
            class: Pe(["xs:w-full order-1 flex items-center", {
              "md:w-full": !(t.productHeader?.button || t.productHeader?.documents && t.productHeader?.documents.length > 0),
              "md:w-1/2": t.productHeader?.documents && t.productHeader?.documents.length > 0
            }])
          }, [
            ue(x, {
              "base-heading-type": _(ze).StyledAsH2,
              class: "shrink-header__title"
            }, {
              default: Se(() => [
                oe("span", vMe, Ie(t.productHeader?.texts?.title), 1)
              ]),
              _: 1
            }, 8, ["base-heading-type"]),
            t.productHeader?.addToWatchlistUrl || t.productHeader?.alertUrl ? (E(), X("div", yMe, [
              t.productHeader?.addToWatchlistUrl ? (E(), fe(PT, {
                key: 0,
                "add-to-watchlist-url": t.productHeader?.addToWatchlistUrl,
                "is-bookmarked": t.userData?.isBookmarked,
                "button-size": _(et).Small,
                onBookmarked: w[0] || (w[0] = (k) => S.$emit("bookmarked"))
              }, null, 8, ["add-to-watchlist-url", "is-bookmarked", "button-size"])) : te("", !0),
              t.productHeader?.alertUrl ? (E(), fe(Nt, {
                key: 1,
                ref_key: "alertButton",
                ref: n,
                class: "alert-button",
                type: _(Ke).RoundedSecondary,
                size: _(et).Small,
                icon: _(H).Bell,
                "link-model": {
                  title: _(d)("alertButton.label"),
                  href: t.productHeader?.alertUrl,
                  target: "_blank",
                  tealiumTrackingModel: {
                    eventComponentName: "Alert-button",
                    eventTitle: "Alert | sticky",
                    eventSource: _(l)
                  }
                }
              }, null, 8, ["type", "size", "icon", "link-model"])) : te("", !0)
            ])) : te("", !0)
          ], 2),
          t.productHeader?.documents && t.productHeader?.documents.length > 0 || t.productHeader?.button ? (E(), X("div", bMe, [
            t.productHeader?.documents && t.productHeader?.documents.length > 0 ? (E(), fe(Zc, {
              key: 0,
              options: t.productHeader?.documents,
              "option-label": "name",
              "option-value": "name",
              placeholder: t.productHeader?.texts?.downloadButton,
              "reset-option-label": !0,
              "download-anchor": !0,
              "anchor-link": m.value,
              "data-event-source": _(l),
              "event-component-name": "Shrink-Header",
              onBeforeShow: P
            }, {
              option: Se((k) => [
                ue(ot, {
                  class: "shrink-header__btn-group__documents__item border",
                  "link-model": {
                    text: k.option.name,
                    href: k.option.url,
                    target: "_blank",
                    contentUrl: "",
                    title: "",
                    isLocked: !1,
                    isExternal: !1,
                    linkType: _(yt).Default,
                    tealiumTrackingModel: {
                      eventComponentName: "Shrink-Header",
                      eventTitle: "Downloads | sticky",
                      eventSource: _(l),
                      eventTarget: `${k.option.name}`
                    }
                  },
                  icon: _(H).FileDownload,
                  "icon-position": _(ct).Left
                }, null, 8, ["link-model", "icon", "icon-position"])
              ]),
              _: 1
            }, 8, ["options", "placeholder", "anchor-link", "data-event-source"])) : te("", !0),
            oe("button", {
              ref_key: "dropdownOpenerButton",
              ref: r,
              hidden: "",
              "aria-hidden": ""
            }, ".", 512),
            t.productHeader?.button ? (E(), fe(vt, {
              key: 1,
              type: _(Ke).Primary,
              size: _(et).Medium,
              "button-type": _(zt).Link,
              "link-model": {
                text: t.productHeader?.button.label,
                href: t.productHeader?.button.href,
                target: t.productHeader?.button.target,
                tealiumTrackingModel: {
                  eventComponentName: "Product-Header",
                  eventTitle: `Button | ${t.productHeader?.button.label}  | sticky`,
                  eventSource: _(l)
                }
              },
              onClick: w[1] || (w[1] = (k) => S.$emit("ctaButtonClicked", k, t.productHeader?.button?.href))
            }, null, 8, ["type", "size", "button-type", "link-model"])) : te("", !0)
          ])) : te("", !0),
          oe("div", xMe, [
            t.productHeader?.identifier?.length && t.productHeader?.identifier?.length > 0 ? (E(), X("div", wMe, [
              oe("p", kMe, [
                Ve(Ie(t.productHeader?.identifier[0].key) + ": ", 1),
                ue(Kg, {
                  class: "shrink-header__fund-identifier__paragraph__value",
                  "input-text": t.productHeader?.identifier[0].value,
                  "event-component-name": "Product-Header",
                  "event-title": "Copy | sticky",
                  "aria-label": `${_(d)("globalTranslations.copyButton")}; ${t.productHeader?.identifier[0].value}`,
                  "text-aria-labeled-by": "shrink-header-title"
                }, null, 8, ["input-text", "aria-label"])
              ])
            ])) : te("", !0),
            oe("div", SMe, [
              (E(!0), X(Re, null, Ge(t.productHeader?.shrinkHeaderValues, (k) => (E(), X("p", {
                key: k,
                class: "shrink-header__fund-data__paragraph"
              }, [
                Ve(Ie(k.title) + " ", 1),
                oe("span", CMe, [
                  Ve(Ie(k.value) + " ", 1),
                  k.subValue ? (E(), X("span", TMe, [
                    k.isPositivePerformanceSubValue !== void 0 && k.isPositivePerformanceSubValue !== null ? (E(), fe(IT, {
                      key: 0,
                      "is-positive": k.isPositivePerformanceSubValue
                    }, null, 8, ["is-positive"])) : te("", !0),
                    oe("span", LMe, Ie(k.subValue), 1)
                  ])) : te("", !0)
                ])
              ]))), 128))
            ])
          ])
        ])
      ], 2);
    };
  }
});
var _L = { exports: {} };
(function(e) {
  /**
  * Highstock JS v11.4.8 (2024-08-29)
  *
  * (c) 2009-2024 Torstein Honsi
  *
  * License: www.highcharts.com/license
  */
  (function(t, n) {
    e.exports ? (n.default = n, e.exports = t && t.document ? n(t) : n) : (t.Highcharts && t.Highcharts.error(16, !0), t.Highcharts = n(t));
  })(typeof window < "u" ? window : rn, function(t) {
    var n = {};
    function i(o, a, r, s) {
      !o.hasOwnProperty(a) && (o[a] = s.apply(null, r), t && typeof CustomEvent == "function" && t.dispatchEvent(new CustomEvent("HighchartsModuleLoaded", { detail: { path: a, module: o[a] } })));
    }
    return i(n, "Core/Globals.js", [], function() {
      var o, a;
      return (a = o || (o = {})).SVG_NS = "http://www.w3.org/2000/svg", a.product = "Highcharts", a.version = "11.4.8", a.win = t !== void 0 ? t : {}, a.doc = a.win.document, a.svg = a.doc && a.doc.createElementNS && !!a.doc.createElementNS(a.SVG_NS, "svg").createSVGRect, a.userAgent = a.win.navigator && a.win.navigator.userAgent || "", a.isChrome = a.win.chrome, a.isFirefox = a.userAgent.indexOf("Firefox") !== -1, a.isMS = /(edge|msie|trident)/i.test(a.userAgent) && !a.win.opera, a.isSafari = !a.isChrome && a.userAgent.indexOf("Safari") !== -1, a.isTouchDevice = /(Mobile|Android|Windows Phone)/.test(a.userAgent), a.isWebKit = a.userAgent.indexOf("AppleWebKit") !== -1, a.deg2rad = 2 * Math.PI / 360, a.hasBidiBug = a.isFirefox && 4 > parseInt(a.userAgent.split("Firefox/")[1], 10), a.marginNames = ["plotTop", "marginRight", "marginBottom", "plotLeft"], a.noop = function() {
      }, a.supportsPassiveEvents = function() {
        let r = !1;
        if (!a.isMS) {
          let s = Object.defineProperty({}, "passive", { get: function() {
            r = !0;
          } });
          a.win.addEventListener && a.win.removeEventListener && (a.win.addEventListener("testPassive", a.noop, s), a.win.removeEventListener("testPassive", a.noop, s));
        }
        return r;
      }(), a.charts = [], a.composed = [], a.dateFormats = {}, a.seriesTypes = {}, a.symbolSizes = {}, a.chartCount = 0, o;
    }), i(n, "Core/Utilities.js", [n["Core/Globals.js"]], function(o) {
      let a, { charts: r, doc: s, win: l } = o;
      function d(b, p, L, B) {
        let T = p ? "Highcharts error" : "Highcharts warning";
        b === 32 && (b = `${T}: Deprecated member`);
        let O = v(b), I = O ? `${T} #${b}: www.highcharts.com/errors/${b}/` : b.toString();
        if (B !== void 0) {
          let R = "";
          O && (I += "?"), N(B, function(Y, F) {
            R += `
 - ${F}: ${Y}`, O && (I += encodeURI(F) + "=" + encodeURI(Y));
          }), I += R;
        }
        D(o, "displayError", { chart: L, code: b, message: I, params: B }, function() {
          if (p)
            throw Error(I);
          l.console && d.messages.indexOf(I) === -1 && console.warn(I);
        }), d.messages.push(I);
      }
      function y(b, p) {
        return parseInt(b, p || 10);
      }
      function u(b) {
        return typeof b == "string";
      }
      function m(b) {
        let p = Object.prototype.toString.call(b);
        return p === "[object Array]" || p === "[object Array Iterator]";
      }
      function h(b, p) {
        return !!b && typeof b == "object" && (!p || !m(b));
      }
      function c(b) {
        return h(b) && typeof b.nodeType == "number";
      }
      function g(b) {
        let p = b && b.constructor;
        return !!(h(b, !0) && !c(b) && p && p.name && p.name !== "Object");
      }
      function v(b) {
        return typeof b == "number" && !isNaN(b) && b < 1 / 0 && b > -1 / 0;
      }
      function P(b) {
        return b != null;
      }
      function f(b, p, L) {
        let B, T = u(p) && !P(L), O = (I, R) => {
          P(I) ? b.setAttribute(R, I) : T ? (B = b.getAttribute(R)) || R !== "class" || (B = b.getAttribute(R + "Name")) : b.removeAttribute(R);
        };
        return u(p) ? O(L, p) : N(p, O), B;
      }
      function S(b) {
        return m(b) ? b : [b];
      }
      function w(b, p) {
        let L;
        for (L in b || (b = {}), p)
          b[L] = p[L];
        return b;
      }
      function x() {
        let b = arguments, p = b.length;
        for (let L = 0; L < p; L++) {
          let B = b[L];
          if (B != null)
            return B;
        }
      }
      function k(b, p) {
        w(b.style, p);
      }
      function A(b) {
        return Math.pow(10, Math.floor(Math.log(b) / Math.LN10));
      }
      function $(b, p) {
        return b > 1e14 ? b : parseFloat(b.toPrecision(p || 14));
      }
      (d || (d = {})).messages = [], Math.easeInOutSine = function(b) {
        return -0.5 * (Math.cos(Math.PI * b) - 1);
      };
      let j = Array.prototype.find ? function(b, p) {
        return b.find(p);
      } : function(b, p) {
        let L, B = b.length;
        for (L = 0; L < B; L++)
          if (p(b[L], L))
            return b[L];
      };
      function N(b, p, L) {
        for (let B in b)
          Object.hasOwnProperty.call(b, B) && p.call(L || b[B], b[B], B, b);
      }
      function M(b, p, L) {
        function B(I, R) {
          let Y = b.removeEventListener;
          Y && Y.call(b, I, R, !1);
        }
        function T(I) {
          let R, Y;
          b.nodeName && (p ? (R = {})[p] = !0 : R = I, N(R, function(F, U) {
            if (I[U])
              for (Y = I[U].length; Y--; )
                B(U, I[U][Y].fn);
          }));
        }
        let O = typeof b == "function" && b.prototype || b;
        if (Object.hasOwnProperty.call(O, "hcEvents")) {
          let I = O.hcEvents;
          if (p) {
            let R = I[p] || [];
            L ? (I[p] = R.filter(function(Y) {
              return L !== Y.fn;
            }), B(p, L)) : (T(I), I[p] = []);
          } else
            T(I), delete O.hcEvents;
        }
      }
      function D(b, p, L, B) {
        if (L = L || {}, s.createEvent && (b.dispatchEvent || b.fireEvent && b !== o)) {
          let T = s.createEvent("Events");
          T.initEvent(p, !0, !0), L = w(T, L), b.dispatchEvent ? b.dispatchEvent(L) : b.fireEvent(p, L);
        } else if (b.hcEvents) {
          L.target || w(L, { preventDefault: function() {
            L.defaultPrevented = !0;
          }, target: b, type: p });
          let T = [], O = b, I = !1;
          for (; O.hcEvents; )
            Object.hasOwnProperty.call(O, "hcEvents") && O.hcEvents[p] && (T.length && (I = !0), T.unshift.apply(T, O.hcEvents[p])), O = Object.getPrototypeOf(O);
          I && T.sort((R, Y) => R.order - Y.order), T.forEach((R) => {
            R.fn.call(b, L) === !1 && L.preventDefault();
          });
        }
        B && !L.defaultPrevented && B.call(b, L);
      }
      N({ map: "map", each: "forEach", grep: "filter", reduce: "reduce", some: "some" }, function(b, p) {
        o[p] = function(L) {
          return d(32, !1, void 0, { [`Highcharts.${p}`]: `use Array.${b}` }), Array.prototype[b].apply(L, [].slice.call(arguments, 1));
        };
      });
      let C = function() {
        let b = Math.random().toString(36).substring(2, 9) + "-", p = 0;
        return function() {
          return "highcharts-" + (a ? "" : b) + p++;
        };
      }();
      return l.jQuery && (l.jQuery.fn.highcharts = function() {
        let b = [].slice.call(arguments);
        if (this[0])
          return b[0] ? (new o[u(b[0]) ? b.shift() : "Chart"](this[0], b[0], b[1]), this) : r[f(this[0], "data-highcharts-chart")];
      }), { addEvent: function(b, p, L, B = {}) {
        let T = typeof b == "function" && b.prototype || b;
        Object.hasOwnProperty.call(T, "hcEvents") || (T.hcEvents = {});
        let O = T.hcEvents;
        o.Point && b instanceof o.Point && b.series && b.series.chart && (b.series.chart.runTrackerClick = !0);
        let I = b.addEventListener;
        I && I.call(b, p, L, !!o.supportsPassiveEvents && { passive: B.passive === void 0 ? p.indexOf("touch") !== -1 : B.passive, capture: !1 }), O[p] || (O[p] = []);
        let R = { fn: L, order: typeof B.order == "number" ? B.order : 1 / 0 };
        return O[p].push(R), O[p].sort((Y, F) => Y.order - F.order), function() {
          M(b, p, L);
        };
      }, arrayMax: function(b) {
        let p = b.length, L = b[0];
        for (; p--; )
          b[p] > L && (L = b[p]);
        return L;
      }, arrayMin: function(b) {
        let p = b.length, L = b[0];
        for (; p--; )
          b[p] < L && (L = b[p]);
        return L;
      }, attr: f, clamp: function(b, p, L) {
        return b > p ? b < L ? b : L : p;
      }, clearTimeout: function(b) {
        P(b) && clearTimeout(b);
      }, correctFloat: $, createElement: function(b, p, L, B, T) {
        let O = s.createElement(b);
        return p && w(O, p), T && k(O, { padding: "0", border: "none", margin: "0" }), L && k(O, L), B && B.appendChild(O), O;
      }, crisp: (b, p = 0, L) => {
        let B = p % 2 / 2, T = L ? -1 : 1;
        return (Math.round(b * T - B) + B) * T;
      }, css: k, defined: P, destroyObjectProperties: function(b, p, L) {
        N(b, function(B, T) {
          B !== p && B?.destroy && B.destroy(), (B?.destroy || !L) && delete b[T];
        });
      }, diffObjects: function(b, p, L, B) {
        let T = {};
        return function O(I, R, Y, F) {
          let U = L ? R : I;
          N(I, function(Q, J) {
            if (!F && B && B.indexOf(J) > -1 && R[J]) {
              Q = S(Q), Y[J] = [];
              for (let ee = 0; ee < Math.max(Q.length, R[J].length); ee++)
                R[J][ee] && (Q[ee] === void 0 ? Y[J][ee] = R[J][ee] : (Y[J][ee] = {}, O(Q[ee], R[J][ee], Y[J][ee], F + 1)));
            } else
              h(Q, !0) && !Q.nodeType ? (Y[J] = m(Q) ? [] : {}, O(Q, R[J] || {}, Y[J], F + 1), Object.keys(Y[J]).length !== 0 || J === "colorAxis" && F === 0 || delete Y[J]) : (I[J] !== R[J] || J in I && !(J in R)) && J !== "__proto__" && J !== "constructor" && (Y[J] = U[J]);
          });
        }(b, p, T, 0), T;
      }, discardElement: function(b) {
        b && b.parentElement && b.parentElement.removeChild(b);
      }, erase: function(b, p) {
        let L = b.length;
        for (; L--; )
          if (b[L] === p) {
            b.splice(L, 1);
            break;
          }
      }, error: d, extend: w, extendClass: function(b, p) {
        let L = function() {
        };
        return L.prototype = new b(), w(L.prototype, p), L;
      }, find: j, fireEvent: D, getClosestDistance: function(b, p) {
        let L, B, T, O = !p;
        return b.forEach((I) => {
          if (I.length > 1)
            for (T = I.length - 1; T > 0; T--)
              (B = I[T] - I[T - 1]) < 0 && !O ? (p?.(), p = void 0) : B && (L === void 0 || B < L) && (L = B);
        }), L;
      }, getMagnitude: A, getNestedProperty: function(b, p) {
        let L = b.split(".");
        for (; L.length && P(p); ) {
          let B = L.shift();
          if (B === void 0 || B === "__proto__")
            return;
          if (B === "this") {
            let O;
            return h(p) && (O = p["@this"]), O ?? p;
          }
          let T = p[B];
          if (!P(T) || typeof T == "function" || typeof T.nodeType == "number" || T === l)
            return;
          p = T;
        }
        return p;
      }, getStyle: function b(p, L, B) {
        let T;
        if (L === "width") {
          let I = Math.min(p.offsetWidth, p.scrollWidth), R = p.getBoundingClientRect && p.getBoundingClientRect().width;
          return R < I && R >= I - 1 && (I = Math.floor(R)), Math.max(0, I - (b(p, "padding-left", !0) || 0) - (b(p, "padding-right", !0) || 0));
        }
        if (L === "height")
          return Math.max(0, Math.min(p.offsetHeight, p.scrollHeight) - (b(p, "padding-top", !0) || 0) - (b(p, "padding-bottom", !0) || 0));
        let O = l.getComputedStyle(p, void 0);
        return O && (T = O.getPropertyValue(L), x(B, L !== "opacity") && (T = y(T))), T;
      }, inArray: function(b, p, L) {
        return d(32, !1, void 0, { "Highcharts.inArray": "use Array.indexOf" }), p.indexOf(b, L);
      }, insertItem: function(b, p) {
        let L, B = b.options.index, T = p.length;
        for (L = b.options.isInternal ? T : 0; L < T + 1; L++)
          if (!p[L] || v(B) && B < x(p[L].options.index, p[L]._i) || p[L].options.isInternal) {
            p.splice(L, 0, b);
            break;
          }
        return L;
      }, isArray: m, isClass: g, isDOMElement: c, isFunction: function(b) {
        return typeof b == "function";
      }, isNumber: v, isObject: h, isString: u, keys: function(b) {
        return d(32, !1, void 0, { "Highcharts.keys": "use Object.keys" }), Object.keys(b);
      }, merge: function() {
        let b, p = arguments, L = {}, B = function(O, I) {
          return typeof O != "object" && (O = {}), N(I, function(R, Y) {
            Y !== "__proto__" && Y !== "constructor" && (!h(R, !0) || g(R) || c(R) ? O[Y] = I[Y] : O[Y] = B(O[Y] || {}, R));
          }), O;
        };
        p[0] === !0 && (L = p[1], p = Array.prototype.slice.call(p, 2));
        let T = p.length;
        for (b = 0; b < T; b++)
          L = B(L, p[b]);
        return L;
      }, normalizeTickInterval: function(b, p, L, B, T) {
        let O, I = b;
        L = x(L, A(b));
        let R = b / L;
        for (!p && (p = T ? [1, 1.2, 1.5, 2, 2.5, 3, 4, 5, 6, 8, 10] : [1, 2, 2.5, 5, 10], B === !1 && (L === 1 ? p = p.filter(function(Y) {
          return Y % 1 == 0;
        }) : L <= 0.1 && (p = [1 / L]))), O = 0; O < p.length && (I = p[O], (!T || !(I * L >= b)) && (T || !(R <= (p[O] + (p[O + 1] || p[O])) / 2))); O++)
          ;
        return $(I * L, -Math.round(Math.log(1e-3) / Math.LN10));
      }, objectEach: N, offset: function(b) {
        let p = s.documentElement, L = b.parentElement || b.parentNode ? b.getBoundingClientRect() : { top: 0, left: 0, width: 0, height: 0 };
        return { top: L.top + (l.pageYOffset || p.scrollTop) - (p.clientTop || 0), left: L.left + (l.pageXOffset || p.scrollLeft) - (p.clientLeft || 0), width: L.width, height: L.height };
      }, pad: function(b, p, L) {
        return Array((p || 2) + 1 - String(b).replace("-", "").length).join(L || "0") + b;
      }, pick: x, pInt: y, pushUnique: function(b, p) {
        return 0 > b.indexOf(p) && !!b.push(p);
      }, relativeLength: function(b, p, L) {
        return /%$/.test(b) ? p * parseFloat(b) / 100 + (L || 0) : parseFloat(b);
      }, removeEvent: M, replaceNested: function(b, ...p) {
        let L, B;
        do
          for (B of (L = b, p))
            b = b.replace(B[0], B[1]);
        while (b !== L);
        return b;
      }, splat: S, stableSort: function(b, p) {
        let L, B, T = b.length;
        for (B = 0; B < T; B++)
          b[B].safeI = B;
        for (b.sort(function(O, I) {
          return (L = p(O, I)) === 0 ? O.safeI - I.safeI : L;
        }), B = 0; B < T; B++)
          delete b[B].safeI;
      }, syncTimeout: function(b, p, L) {
        return p > 0 ? setTimeout(b, p, L) : (b.call(0, L), -1);
      }, timeUnits: { millisecond: 1, second: 1e3, minute: 6e4, hour: 36e5, day: 864e5, week: 6048e5, month: 24192e5, year: 314496e5 }, uniqueKey: C, useSerialIds: function(b) {
        return a = x(b, a);
      }, wrap: function(b, p, L) {
        let B = b[p];
        b[p] = function() {
          let T = arguments, O = this;
          return L.apply(this, [function() {
            return B.apply(O, arguments.length ? arguments : T);
          }].concat([].slice.call(arguments)));
        };
      } };
    }), i(n, "Core/Chart/ChartDefaults.js", [], function() {
      return { alignThresholds: !1, panning: { enabled: !1, type: "x" }, styledMode: !1, borderRadius: 0, colorCount: 10, allowMutatingData: !0, ignoreHiddenSeries: !0, spacing: [10, 10, 15, 10], resetZoomButton: { theme: {}, position: {} }, reflow: !0, type: "line", zooming: { singleTouch: !1, resetButton: { theme: { zIndex: 6 }, position: { align: "right", x: -10, y: 10 } } }, width: null, height: null, borderColor: "#334eff", backgroundColor: "#ffffff", plotBorderColor: "#cccccc" };
    }), i(n, "Core/Color/Palettes.js", [], function() {
      return { colors: ["#2caffe", "#544fc5", "#00e272", "#fe6a35", "#6b8abc", "#d568fb", "#2ee0ca", "#fa4b42", "#feb56a", "#91e8e1"] };
    }), i(n, "Core/Time.js", [n["Core/Globals.js"], n["Core/Utilities.js"]], function(o, a) {
      let { win: r } = o, { defined: s, error: l, extend: d, isNumber: y, isObject: u, merge: m, objectEach: h, pad: c, pick: g, splat: v, timeUnits: P } = a, f = o.isSafari && r.Intl && r.Intl.DateTimeFormat.prototype.formatRange, S = o.isSafari && r.Intl && !r.Intl.DateTimeFormat.prototype.formatRange;
      class w {
        constructor(k) {
          this.options = {}, this.useUTC = !1, this.variableTimezone = !1, this.Date = r.Date, this.getTimezoneOffset = this.timezoneOffsetFunction(), this.update(k);
        }
        get(k, A) {
          if (this.variableTimezone || this.timezoneOffset) {
            let $ = A.getTime(), j = $ - this.getTimezoneOffset(A);
            A.setTime(j);
            let N = A["getUTC" + k]();
            return A.setTime($), N;
          }
          return this.useUTC ? A["getUTC" + k]() : A["get" + k]();
        }
        set(k, A, $) {
          if (this.variableTimezone || this.timezoneOffset) {
            if (k === "Milliseconds" || k === "Seconds" || k === "Minutes" && this.getTimezoneOffset(A) % 36e5 == 0)
              return A["setUTC" + k]($);
            let j = this.getTimezoneOffset(A), N = A.getTime() - j;
            A.setTime(N), A["setUTC" + k]($);
            let M = this.getTimezoneOffset(A);
            return N = A.getTime() + M, A.setTime(N);
          }
          return this.useUTC || f && k === "FullYear" ? A["setUTC" + k]($) : A["set" + k]($);
        }
        update(k = {}) {
          let A = g(k.useUTC, !0);
          this.options = k = m(!0, this.options, k), this.Date = k.Date || r.Date || Date, this.useUTC = A, this.timezoneOffset = A && k.timezoneOffset || void 0, this.getTimezoneOffset = this.timezoneOffsetFunction(), this.variableTimezone = A && !!(k.getTimezoneOffset || k.timezone);
        }
        makeTime(k, A, $, j, N, M) {
          let D, C, b;
          return this.useUTC ? (D = this.Date.UTC.apply(0, arguments), C = this.getTimezoneOffset(D), D += C, C !== (b = this.getTimezoneOffset(D)) ? D += b - C : C - 36e5 !== this.getTimezoneOffset(D - 36e5) || S || (D -= 36e5)) : D = new this.Date(k, A, g($, 1), g(j, 0), g(N, 0), g(M, 0)).getTime(), D;
        }
        timezoneOffsetFunction() {
          let k = this, A = this.options, $ = A.getTimezoneOffset;
          return this.useUTC ? A.timezone ? (j) => {
            try {
              let N = `shortOffset,${A.timezone || ""}`, [M, D, C, b, p = 0] = (w.formatCache[N] = w.formatCache[N] || Intl.DateTimeFormat("en", { timeZone: A.timezone, timeZoneName: "shortOffset" })).format(j).split(/(GMT|:)/).map(Number), L = -(36e5 * (C + p / 60));
              if (y(L))
                return L;
            } catch {
              l(34);
            }
            return 0;
          } : this.useUTC && $ ? (j) => 6e4 * $(j.valueOf()) : () => 6e4 * (k.timezoneOffset || 0) : (j) => 6e4 * new Date(j.toString()).getTimezoneOffset();
        }
        dateFormat(k, A, $) {
          if (!s(A) || isNaN(A))
            return o.defaultOptions.lang && o.defaultOptions.lang.invalidDate || "";
          k = g(k, "%Y-%m-%d %H:%M:%S");
          let j = this, N = new this.Date(A), M = this.get("Hours", N), D = this.get("Day", N), C = this.get("Date", N), b = this.get("Month", N), p = this.get("FullYear", N), L = o.defaultOptions.lang, B = L && L.weekdays, T = L && L.shortWeekdays;
          return h(d({ a: T ? T[D] : B[D].substr(0, 3), A: B[D], d: c(C), e: c(C, 2, " "), w: D, b: L.shortMonths[b], B: L.months[b], m: c(b + 1), o: b + 1, y: p.toString().substr(2, 2), Y: p, H: c(M), k: M, I: c(M % 12 || 12), l: M % 12 || 12, M: c(this.get("Minutes", N)), p: M < 12 ? "AM" : "PM", P: M < 12 ? "am" : "pm", S: c(this.get("Seconds", N)), L: c(Math.floor(A % 1e3), 3) }, o.dateFormats), function(O, I) {
            for (; k.indexOf("%" + I) !== -1; )
              k = k.replace("%" + I, typeof O == "function" ? O.call(j, A) : O);
          }), $ ? k.substr(0, 1).toUpperCase() + k.substr(1) : k;
        }
        resolveDTLFormat(k) {
          return u(k, !0) ? k : { main: (k = v(k))[0], from: k[1], to: k[2] };
        }
        getTimeTicks(k, A, $, j) {
          let N, M, D, C, b = this, p = b.Date, L = [], B = {}, T = new p(A), O = k.unitRange, I = k.count || 1;
          if (j = g(j, 1), s(A)) {
            b.set("Milliseconds", T, O >= P.second ? 0 : I * Math.floor(b.get("Milliseconds", T) / I)), O >= P.second && b.set("Seconds", T, O >= P.minute ? 0 : I * Math.floor(b.get("Seconds", T) / I)), O >= P.minute && b.set("Minutes", T, O >= P.hour ? 0 : I * Math.floor(b.get("Minutes", T) / I)), O >= P.hour && b.set("Hours", T, O >= P.day ? 0 : I * Math.floor(b.get("Hours", T) / I)), O >= P.day && b.set("Date", T, O >= P.month ? 1 : Math.max(1, I * Math.floor(b.get("Date", T) / I))), O >= P.month && (b.set("Month", T, O >= P.year ? 0 : I * Math.floor(b.get("Month", T) / I)), M = b.get("FullYear", T)), O >= P.year && (M -= M % I, b.set("FullYear", T, M)), O === P.week && (C = b.get("Day", T), b.set("Date", T, b.get("Date", T) - C + j + (C < j ? -7 : 0))), M = b.get("FullYear", T);
            let R = b.get("Month", T), Y = b.get("Date", T), F = b.get("Hours", T);
            A = T.getTime(), (b.variableTimezone || !b.useUTC) && s($) && (D = $ - A > 4 * P.month || b.getTimezoneOffset(A) !== b.getTimezoneOffset($));
            let U = T.getTime();
            for (N = 1; U < $; )
              L.push(U), O === P.year ? U = b.makeTime(M + N * I, 0) : O === P.month ? U = b.makeTime(M, R + N * I) : D && (O === P.day || O === P.week) ? U = b.makeTime(M, R, Y + N * I * (O === P.day ? 1 : 7)) : D && O === P.hour && I > 1 ? U = b.makeTime(M, R, Y, F + N * I) : U += O * I, N++;
            L.push(U), O <= P.hour && L.length < 1e4 && L.forEach(function(Q) {
              Q % 18e5 == 0 && b.dateFormat("%H%M%S%L", Q) === "000000000" && (B[Q] = "day");
            });
          }
          return L.info = d(k, { higherRanks: B, totalRange: O * I }), L;
        }
        getDateFormat(k, A, $, j) {
          let N = this.dateFormat("%m-%d %H:%M:%S.%L", A), M = "01-01 00:00:00.000", D = { millisecond: 15, second: 12, minute: 9, hour: 6, day: 3 }, C = "millisecond", b = C;
          for (C in P) {
            if (k === P.week && +this.dateFormat("%w", A) === $ && N.substr(6) === M.substr(6)) {
              C = "week";
              break;
            }
            if (P[C] > k) {
              C = b;
              break;
            }
            if (D[C] && N.substr(D[C]) !== M.substr(D[C]))
              break;
            C !== "week" && (b = C);
          }
          return this.resolveDTLFormat(j[C]).main;
        }
      }
      return w.formatCache = {}, w;
    }), i(n, "Core/Defaults.js", [n["Core/Chart/ChartDefaults.js"], n["Core/Globals.js"], n["Core/Color/Palettes.js"], n["Core/Time.js"], n["Core/Utilities.js"]], function(o, a, r, s, l) {
      let { isTouchDevice: d } = a, { fireEvent: y, merge: u } = l, m = { colors: r.colors, symbols: ["circle", "diamond", "square", "triangle", "triangle-down"], lang: { loading: "Loading...", months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"], shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"], weekdays: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"], decimalPoint: ".", numericSymbols: ["k", "M", "G", "T", "P", "E"], resetZoom: "Reset zoom", resetZoomTitle: "Reset zoom level 1:1", thousandsSep: " " }, global: { buttonTheme: { fill: "#f7f7f7", padding: 8, r: 2, stroke: "#cccccc", "stroke-width": 1, style: { color: "#333333", cursor: "pointer", fontSize: "0.8em", fontWeight: "normal" }, states: { hover: { fill: "#e6e6e6" }, select: { fill: "#e6e9ff", style: { color: "#000000", fontWeight: "bold" } }, disabled: { style: { color: "#cccccc" } } } } }, time: { Date: void 0, getTimezoneOffset: void 0, timezone: void 0, timezoneOffset: 0, useUTC: !0 }, chart: o, title: { style: { color: "#333333", fontWeight: "bold" }, text: "Chart title", align: "center", margin: 15, widthAdjust: -44 }, subtitle: { style: { color: "#666666", fontSize: "0.8em" }, text: "", align: "center", widthAdjust: -44 }, caption: { margin: 15, style: { color: "#666666", fontSize: "0.8em" }, text: "", align: "left", verticalAlign: "bottom" }, plotOptions: {}, legend: { enabled: !0, align: "center", alignColumns: !0, className: "highcharts-no-tooltip", events: {}, layout: "horizontal", itemMarginBottom: 2, itemMarginTop: 2, labelFormatter: function() {
        return this.name;
      }, borderColor: "#999999", borderRadius: 0, navigation: { style: { fontSize: "0.8em" }, activeColor: "#0022ff", inactiveColor: "#cccccc" }, itemStyle: { color: "#333333", cursor: "pointer", fontSize: "0.8em", textDecoration: "none", textOverflow: "ellipsis" }, itemHoverStyle: { color: "#000000" }, itemHiddenStyle: { color: "#666666", textDecoration: "line-through" }, shadow: !1, itemCheckboxStyle: { position: "absolute", width: "13px", height: "13px" }, squareSymbol: !0, symbolPadding: 5, verticalAlign: "bottom", x: 0, y: 0, title: { style: { fontSize: "0.8em", fontWeight: "bold" } } }, loading: { labelStyle: { fontWeight: "bold", position: "relative", top: "45%" }, style: { position: "absolute", backgroundColor: "#ffffff", opacity: 0.5, textAlign: "center" } }, tooltip: { enabled: !0, animation: { duration: 300, easing: (c) => Math.sqrt(1 - Math.pow(c - 1, 2)) }, borderRadius: 3, dateTimeLabelFormats: { millisecond: "%A, %e %b, %H:%M:%S.%L", second: "%A, %e %b, %H:%M:%S", minute: "%A, %e %b, %H:%M", hour: "%A, %e %b, %H:%M", day: "%A, %e %b %Y", week: "Week from %A, %e %b %Y", month: "%B %Y", year: "%Y" }, footerFormat: "", headerShape: "callout", hideDelay: 500, padding: 8, shape: "callout", shared: !1, snap: d ? 25 : 10, headerFormat: '<span style="font-size: 0.8em">{point.key}</span><br/>', pointFormat: '<span style="color:{point.color}">●</span> {series.name}: <b>{point.y}</b><br/>', backgroundColor: "#ffffff", borderWidth: void 0, shadow: !0, stickOnContact: !1, style: { color: "#333333", cursor: "default", fontSize: "0.8em" }, useHTML: !1 }, credits: { enabled: !0, href: "https://www.highcharts.com?credits", position: { align: "right", x: -10, verticalAlign: "bottom", y: -5 }, style: { cursor: "pointer", color: "#999999", fontSize: "0.6em" }, text: "Highcharts.com" } };
      m.chart.styledMode = !1;
      let h = new s(m.time);
      return { defaultOptions: m, defaultTime: h, getOptions: function() {
        return m;
      }, setOptions: function(c) {
        return y(a, "setOptions", { options: c }), u(!0, m, c), (c.time || c.global) && (a.time ? a.time.update(u(m.global, m.time, c.global, c.time)) : a.time = h), m;
      } };
    }), i(n, "Core/Color/Color.js", [n["Core/Globals.js"], n["Core/Utilities.js"]], function(o, a) {
      let { isNumber: r, merge: s, pInt: l } = a;
      class d {
        static parse(u) {
          return u ? new d(u) : d.None;
        }
        constructor(u) {
          let m, h, c, g;
          this.rgba = [NaN, NaN, NaN, NaN], this.input = u;
          let v = o.Color;
          if (v && v !== d)
            return new v(u);
          if (typeof u == "object" && u.stops !== void 0)
            this.stops = u.stops.map((P) => new d(P[1]));
          else if (typeof u == "string") {
            if (this.input = u = d.names[u.toLowerCase()] || u, u.charAt(0) === "#") {
              let P = u.length, f = parseInt(u.substr(1), 16);
              P === 7 ? h = [(16711680 & f) >> 16, (65280 & f) >> 8, 255 & f, 1] : P === 4 && (h = [(3840 & f) >> 4 | (3840 & f) >> 8, (240 & f) >> 4 | 240 & f, (15 & f) << 4 | 15 & f, 1]);
            }
            if (!h)
              for (c = d.parsers.length; c-- && !h; )
                (m = (g = d.parsers[c]).regex.exec(u)) && (h = g.parse(m));
          }
          h && (this.rgba = h);
        }
        get(u) {
          let m = this.input, h = this.rgba;
          if (typeof m == "object" && this.stops !== void 0) {
            let c = s(m);
            return c.stops = [].slice.call(c.stops), this.stops.forEach((g, v) => {
              c.stops[v] = [c.stops[v][0], g.get(u)];
            }), c;
          }
          return h && r(h[0]) ? u !== "rgb" && (u || h[3] !== 1) ? u === "a" ? `${h[3]}` : "rgba(" + h.join(",") + ")" : "rgb(" + h[0] + "," + h[1] + "," + h[2] + ")" : m;
        }
        brighten(u) {
          let m = this.rgba;
          if (this.stops)
            this.stops.forEach(function(h) {
              h.brighten(u);
            });
          else if (r(u) && u !== 0)
            for (let h = 0; h < 3; h++)
              m[h] += l(255 * u), m[h] < 0 && (m[h] = 0), m[h] > 255 && (m[h] = 255);
          return this;
        }
        setOpacity(u) {
          return this.rgba[3] = u, this;
        }
        tweenTo(u, m) {
          let h = this.rgba, c = u.rgba;
          if (!r(h[0]) || !r(c[0]))
            return u.input || "none";
          let g = c[3] !== 1 || h[3] !== 1;
          return (g ? "rgba(" : "rgb(") + Math.round(c[0] + (h[0] - c[0]) * (1 - m)) + "," + Math.round(c[1] + (h[1] - c[1]) * (1 - m)) + "," + Math.round(c[2] + (h[2] - c[2]) * (1 - m)) + (g ? "," + (c[3] + (h[3] - c[3]) * (1 - m)) : "") + ")";
        }
      }
      return d.names = { white: "#ffffff", black: "#000000" }, d.parsers = [{ regex: /rgba\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d?(?:\.\d+)?)\s*\)/, parse: function(y) {
        return [l(y[1]), l(y[2]), l(y[3]), parseFloat(y[4], 10)];
      } }, { regex: /rgb\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*\)/, parse: function(y) {
        return [l(y[1]), l(y[2]), l(y[3]), 1];
      } }], d.None = new d(""), d;
    }), i(n, "Core/Animation/Fx.js", [n["Core/Color/Color.js"], n["Core/Globals.js"], n["Core/Utilities.js"]], function(o, a, r) {
      let { parse: s } = o, { win: l } = a, { isNumber: d, objectEach: y } = r;
      class u {
        constructor(h, c, g) {
          this.pos = NaN, this.options = c, this.elem = h, this.prop = g;
        }
        dSetter() {
          let h = this.paths, c = h && h[0], g = h && h[1], v = this.now || 0, P = [];
          if (v !== 1 && c && g)
            if (c.length === g.length && v < 1)
              for (let f = 0; f < g.length; f++) {
                let S = c[f], w = g[f], x = [];
                for (let k = 0; k < w.length; k++) {
                  let A = S[k], $ = w[k];
                  d(A) && d($) && !(w[0] === "A" && (k === 4 || k === 5)) ? x[k] = A + v * ($ - A) : x[k] = $;
                }
                P.push(x);
              }
            else
              P = g;
          else
            P = this.toD || [];
          this.elem.attr("d", P, void 0, !0);
        }
        update() {
          let h = this.elem, c = this.prop, g = this.now, v = this.options.step;
          this[c + "Setter"] ? this[c + "Setter"]() : h.attr ? h.element && h.attr(c, g, null, !0) : h.style[c] = g + this.unit, v && v.call(h, g, this);
        }
        run(h, c, g) {
          let v = this, P = v.options, f = function(x) {
            return !f.stopped && v.step(x);
          }, S = l.requestAnimationFrame || function(x) {
            setTimeout(x, 13);
          }, w = function() {
            for (let x = 0; x < u.timers.length; x++)
              u.timers[x]() || u.timers.splice(x--, 1);
            u.timers.length && S(w);
          };
          h !== c || this.elem["forceAnimate:" + this.prop] ? (this.startTime = +/* @__PURE__ */ new Date(), this.start = h, this.end = c, this.unit = g, this.now = this.start, this.pos = 0, f.elem = this.elem, f.prop = this.prop, f() && u.timers.push(f) === 1 && S(w)) : (delete P.curAnim[this.prop], P.complete && Object.keys(P.curAnim).length === 0 && P.complete.call(this.elem));
        }
        step(h) {
          let c, g, v = +/* @__PURE__ */ new Date(), P = this.options, f = this.elem, S = P.complete, w = P.duration, x = P.curAnim;
          return f.attr && !f.element ? c = !1 : h || v >= w + this.startTime ? (this.now = this.end, this.pos = 1, this.update(), x[this.prop] = !0, g = !0, y(x, function(k) {
            k !== !0 && (g = !1);
          }), g && S && S.call(f), c = !1) : (this.pos = P.easing((v - this.startTime) / w), this.now = this.start + (this.end - this.start) * this.pos, this.update(), c = !0), c;
        }
        initPath(h, c, g) {
          let v = h.startX, P = h.endX, f = g.slice(), S = h.isArea, w = S ? 2 : 1, x = c && g.length > c.length && g.hasStackedCliffs, k, A, $, j, N = c && c.slice();
          if (!N || x)
            return [f, f];
          function M(C, b) {
            for (; C.length < A; ) {
              let p = C[0], L = b[A - C.length];
              if (L && p[0] === "M" && (L[0] === "C" ? C[0] = ["C", p[1], p[2], p[1], p[2], p[1], p[2]] : C[0] = ["L", p[1], p[2]]), C.unshift(p), S) {
                let B = C.pop();
                C.push(C[C.length - 1], B);
              }
            }
          }
          function D(C) {
            for (; C.length < A; ) {
              let b = C[Math.floor(C.length / w) - 1].slice();
              if (b[0] === "C" && (b[1] = b[5], b[2] = b[6]), S) {
                let p = C[Math.floor(C.length / w)].slice();
                C.splice(C.length / 2, 0, b, p);
              } else
                C.push(b);
            }
          }
          if (v && P && P.length) {
            for ($ = 0; $ < v.length; $++) {
              if (v[$] === P[0]) {
                k = $;
                break;
              }
              if (v[0] === P[P.length - v.length + $]) {
                k = $, j = !0;
                break;
              }
              if (v[v.length - 1] === P[P.length - v.length + $]) {
                k = v.length - $;
                break;
              }
            }
            k === void 0 && (N = []);
          }
          return N.length && d(k) && (A = f.length + k * w, j ? (M(N, f), D(f)) : (M(f, N), D(N))), [N, f];
        }
        fillSetter() {
          u.prototype.strokeSetter.apply(this, arguments);
        }
        strokeSetter() {
          this.elem.attr(this.prop, s(this.start).tweenTo(s(this.end), this.pos), void 0, !0);
        }
      }
      return u.timers = [], u;
    }), i(n, "Core/Animation/AnimationUtilities.js", [n["Core/Animation/Fx.js"], n["Core/Utilities.js"]], function(o, a) {
      let { defined: r, getStyle: s, isArray: l, isNumber: d, isObject: y, merge: u, objectEach: m, pick: h } = a;
      function c(v) {
        return y(v) ? u({ duration: 500, defer: 0 }, v) : { duration: v ? 500 : 0, defer: 0 };
      }
      function g(v, P) {
        let f = o.timers.length;
        for (; f--; )
          o.timers[f].elem !== v || P && P !== o.timers[f].prop || (o.timers[f].stopped = !0);
      }
      return { animate: function(v, P, f) {
        let S, w = "", x, k, A;
        y(f) || (A = arguments, f = { duration: A[2], easing: A[3], complete: A[4] }), d(f.duration) || (f.duration = 400), f.easing = typeof f.easing == "function" ? f.easing : Math[f.easing] || Math.easeInOutSine, f.curAnim = u(P), m(P, function($, j) {
          g(v, j), k = new o(v, f, j), x = void 0, j === "d" && l(P.d) ? (k.paths = k.initPath(v, v.pathArray, P.d), k.toD = P.d, S = 0, x = 1) : v.attr ? S = v.attr(j) : (S = parseFloat(s(v, j)) || 0, j !== "opacity" && (w = "px")), x || (x = $), typeof x == "string" && x.match("px") && (x = x.replace(/px/g, "")), k.run(S, x, w);
        });
      }, animObject: c, getDeferredAnimation: function(v, P, f) {
        let S = c(P), w = f ? [f] : v.series, x = 0, k = 0;
        return w.forEach((A) => {
          let $ = c(A.options.animation);
          x = y(P) && r(P.defer) ? S.defer : Math.max(x, $.duration + $.defer), k = Math.min(S.duration, $.duration);
        }), v.renderer.forExport && (x = 0), { defer: Math.max(0, x - k), duration: Math.min(x, k) };
      }, setAnimation: function(v, P) {
        P.renderer.globalAnimation = h(v, P.options.chart.animation, !0);
      }, stop: g };
    }), i(n, "Core/Renderer/HTML/AST.js", [n["Core/Globals.js"], n["Core/Utilities.js"]], function(o, a) {
      let { SVG_NS: r, win: s } = o, { attr: l, createElement: d, css: y, error: u, isFunction: m, isString: h, objectEach: c, splat: g } = a, { trustedTypes: v } = s, P = v && m(v.createPolicy) && v.createPolicy("highcharts", { createHTML: (x) => x }), f = P ? P.createHTML("") : "", S = function() {
        try {
          return !!new DOMParser().parseFromString(f, "text/html");
        } catch {
          return !1;
        }
      }();
      class w {
        static filterUserAttributes(k) {
          return c(k, (A, $) => {
            let j = !0;
            w.allowedAttributes.indexOf($) === -1 && (j = !1), ["background", "dynsrc", "href", "lowsrc", "src"].indexOf($) !== -1 && (j = h(A) && w.allowedReferences.some((N) => A.indexOf(N) === 0)), j || (u(33, !1, void 0, { "Invalid attribute in config": `${$}` }), delete k[$]), h(A) && k[$] && (k[$] = A.replace(/</g, "&lt;"));
          }), k;
        }
        static parseStyle(k) {
          return k.split(";").reduce((A, $) => {
            let j = $.split(":").map((M) => M.trim()), N = j.shift();
            return N && j.length && (A[N.replace(/-([a-z])/g, (M) => M[1].toUpperCase())] = j.join(":")), A;
          }, {});
        }
        static setElementHTML(k, A) {
          k.innerHTML = w.emptyHTML, A && new w(A).addToDOM(k);
        }
        constructor(k) {
          this.nodes = typeof k == "string" ? this.parseMarkup(k) : k;
        }
        addToDOM(k) {
          return function A($, j) {
            let N;
            return g($).forEach(function(M) {
              let D, C = M.tagName, b = M.textContent ? o.doc.createTextNode(M.textContent) : void 0, p = w.bypassHTMLFiltering;
              if (C)
                if (C === "#text")
                  D = b;
                else if (w.allowedTags.indexOf(C) !== -1 || p) {
                  let L = C === "svg" ? r : j.namespaceURI || r, B = o.doc.createElementNS(L, C), T = M.attributes || {};
                  c(M, function(O, I) {
                    I !== "tagName" && I !== "attributes" && I !== "children" && I !== "style" && I !== "textContent" && (T[I] = O);
                  }), l(B, p ? T : w.filterUserAttributes(T)), M.style && y(B, M.style), b && B.appendChild(b), A(M.children || [], B), D = B;
                } else
                  u(33, !1, void 0, { "Invalid tagName in config": C });
              D && j.appendChild(D), N = D;
            }), N;
          }(this.nodes, k);
        }
        parseMarkup(k) {
          let A, $ = [];
          if (k = k.trim().replace(/ style=(["'])/g, " data-style=$1"), S)
            A = new DOMParser().parseFromString(P ? P.createHTML(k) : k, "text/html");
          else {
            let N = d("div");
            N.innerHTML = k, A = { body: N };
          }
          let j = (N, M) => {
            let D = N.nodeName.toLowerCase(), C = { tagName: D };
            D === "#text" && (C.textContent = N.textContent || "");
            let b = N.attributes;
            if (b) {
              let p = {};
              [].forEach.call(b, (L) => {
                L.name === "data-style" ? C.style = w.parseStyle(L.value) : p[L.name] = L.value;
              }), C.attributes = p;
            }
            if (N.childNodes.length) {
              let p = [];
              [].forEach.call(N.childNodes, (L) => {
                j(L, p);
              }), p.length && (C.children = p);
            }
            M.push(C);
          };
          return [].forEach.call(A.body.childNodes, (N) => j(N, $)), $;
        }
      }
      return w.allowedAttributes = ["alt", "aria-controls", "aria-describedby", "aria-expanded", "aria-haspopup", "aria-hidden", "aria-label", "aria-labelledby", "aria-live", "aria-pressed", "aria-readonly", "aria-roledescription", "aria-selected", "class", "clip-path", "color", "colspan", "cx", "cy", "d", "dx", "dy", "disabled", "fill", "filterUnits", "flood-color", "flood-opacity", "height", "href", "id", "in", "in2", "markerHeight", "markerWidth", "offset", "opacity", "operator", "orient", "padding", "paddingLeft", "paddingRight", "patternUnits", "r", "radius", "refX", "refY", "role", "scope", "slope", "src", "startOffset", "stdDeviation", "stroke", "stroke-linecap", "stroke-width", "style", "tableValues", "result", "rowspan", "summary", "target", "tabindex", "text-align", "text-anchor", "textAnchor", "textLength", "title", "type", "valign", "width", "x", "x1", "x2", "xlink:href", "y", "y1", "y2", "zIndex"], w.allowedReferences = ["https://", "http://", "mailto:", "/", "../", "./", "#"], w.allowedTags = ["a", "abbr", "b", "br", "button", "caption", "circle", "clipPath", "code", "dd", "defs", "div", "dl", "dt", "em", "feComponentTransfer", "feComposite", "feDropShadow", "feFlood", "feFuncA", "feFuncB", "feFuncG", "feFuncR", "feGaussianBlur", "feMorphology", "feOffset", "feMerge", "feMergeNode", "filter", "h1", "h2", "h3", "h4", "h5", "h6", "hr", "i", "img", "li", "linearGradient", "marker", "ol", "p", "path", "pattern", "pre", "rect", "small", "span", "stop", "strong", "style", "sub", "sup", "svg", "table", "text", "textPath", "thead", "title", "tbody", "tspan", "td", "th", "tr", "u", "ul", "#text"], w.emptyHTML = f, w.bypassHTMLFiltering = !1, w;
    }), i(n, "Core/Templating.js", [n["Core/Defaults.js"], n["Core/Utilities.js"]], function(o, a) {
      let { defaultOptions: r, defaultTime: s } = o, { extend: l, getNestedProperty: d, isArray: y, isNumber: u, isObject: m, pick: h, pInt: c } = a, g = { add: (f, S) => f + S, divide: (f, S) => S !== 0 ? f / S : "", eq: (f, S) => f == S, each: function(f) {
        let S = arguments[arguments.length - 1];
        return !!y(f) && f.map((w, x) => v(S.body, l(m(w) ? w : { "@this": w }, { "@index": x, "@first": x === 0, "@last": x === f.length - 1 }))).join("");
      }, ge: (f, S) => f >= S, gt: (f, S) => f > S, if: (f) => !!f, le: (f, S) => f <= S, lt: (f, S) => f < S, multiply: (f, S) => f * S, ne: (f, S) => f != S, subtract: (f, S) => f - S, unless: (f) => !f };
      function v(f = "", S, w) {
        let x = /\{([\w\:\.\,;\-\/<>%@"'’= #\(\)]+)\}/g, k = /\(([\w\:\.\,;\-\/<>%@"'= ]+)\)/g, A = [], $ = /f$/, j = /\.(\d)/, N = r.lang, M = w && w.time || s, D = w && w.numberFormatter || P, C = (T = "") => {
          let O;
          return T === "true" || T !== "false" && ((O = Number(T)).toString() === T ? O : d(T, S));
        }, b, p, L = 0, B;
        for (; (b = x.exec(f)) !== null; ) {
          let T = k.exec(b[1]);
          T && (b = T, B = !0), p && p.isBlock || (p = { ctx: S, expression: b[1], find: b[0], isBlock: b[1].charAt(0) === "#", start: b.index, startInner: b.index + b[0].length, length: b[0].length });
          let O = b[1].split(" ")[0].replace("#", "");
          g[O] && (p.isBlock && O === p.fn && L++, p.fn || (p.fn = O));
          let I = b[1] === "else";
          if (p.isBlock && p.fn && (b[1] === `/${p.fn}` || I))
            if (L)
              !I && L--;
            else {
              let R = p.startInner, Y = f.substr(R, b.index - R);
              p.body === void 0 ? (p.body = Y, p.startInner = b.index + b[0].length) : p.elseBody = Y, p.find += Y + b[0], I || (A.push(p), p = void 0);
            }
          else
            p.isBlock || A.push(p);
          if (T && !p?.isBlock)
            break;
        }
        return A.forEach((T) => {
          let O, I, { body: R, elseBody: Y, expression: F, fn: U } = T;
          if (U) {
            let Q = [T], J = F.split(" ");
            for (I = g[U].length; I--; )
              Q.unshift(C(J[I + 1]));
            O = g[U].apply(S, Q), T.isBlock && typeof O == "boolean" && (O = v(O ? R : Y, S, w));
          } else {
            let Q = F.split(":");
            if (O = C(Q.shift() || ""), Q.length && typeof O == "number") {
              let J = Q.join(":");
              if ($.test(J)) {
                let ee = parseInt((J.match(j) || ["", "-1"])[1], 10);
                O !== null && (O = D(O, ee, N.decimalPoint, J.indexOf(",") > -1 ? N.thousandsSep : ""));
              } else
                O = M.dateFormat(J, O);
            }
          }
          f = f.replace(T.find, h(O, ""));
        }), B ? v(f, S, w) : f;
      }
      function P(f, S, w, x) {
        let k, A;
        f = +f || 0, S = +S;
        let $ = r.lang, j = (f.toString().split(".")[1] || "").split("e")[0].length, N = f.toString().split("e"), M = S;
        S === -1 ? S = Math.min(j, 20) : u(S) ? S && N[1] && N[1] < 0 && ((A = S + +N[1]) >= 0 ? (N[0] = (+N[0]).toExponential(A).split("e")[0], S = A) : (N[0] = N[0].split(".")[0] || 0, f = S < 20 ? (N[0] * Math.pow(10, N[1])).toFixed(S) : 0, N[1] = 0)) : S = 2;
        let D = (Math.abs(N[1] ? N[0] : f) + Math.pow(10, -Math.max(S, j) - 1)).toFixed(S), C = String(c(D)), b = C.length > 3 ? C.length % 3 : 0;
        return w = h(w, $.decimalPoint), x = h(x, $.thousandsSep), k = (f < 0 ? "-" : "") + (b ? C.substr(0, b) + x : ""), 0 > +N[1] && !M ? k = "0" : k += C.substr(b).replace(/(\d{3})(?=\d)/g, "$1" + x), S ? k += w + D.slice(-S) : +k == 0 && (k = "0"), N[1] && +k != 0 && (k += "e" + N[1]), k;
      }
      return { dateFormat: function(f, S, w) {
        return s.dateFormat(f, S, w);
      }, format: v, helpers: g, numberFormat: P };
    }), i(n, "Core/Renderer/RendererRegistry.js", [n["Core/Globals.js"]], function(o) {
      var a, r;
      let s;
      return (r = a || (a = {})).rendererTypes = {}, r.getRendererType = function(l = s) {
        return r.rendererTypes[l] || r.rendererTypes[s];
      }, r.registerRendererType = function(l, d, y) {
        r.rendererTypes[l] = d, (!s || y) && (s = l, o.Renderer = d);
      }, a;
    }), i(n, "Core/Renderer/RendererUtilities.js", [n["Core/Utilities.js"]], function(o) {
      var a;
      let { clamp: r, pick: s, pushUnique: l, stableSort: d } = o;
      return (a || (a = {})).distribute = function y(u, m, h) {
        let c = u, g = c.reducedLen || m, v = (C, b) => C.target - b.target, P = [], f = u.length, S = [], w = P.push, x, k, A, $ = !0, j, N, M = 0, D;
        for (x = f; x--; )
          M += u[x].size;
        if (M > g) {
          for (d(u, (C, b) => (b.rank || 0) - (C.rank || 0)), A = (D = u[0].rank === u[u.length - 1].rank) ? f / 2 : -1, k = D ? A : f - 1; A && M > g; )
            j = u[x = Math.floor(k)], l(S, x) && (M -= j.size), k += A, D && k >= u.length && (A /= 2, k = A);
          S.sort((C, b) => b - C).forEach((C) => w.apply(P, u.splice(C, 1)));
        }
        for (d(u, v), u = u.map((C) => ({ size: C.size, targets: [C.target], align: s(C.align, 0.5) })); $; ) {
          for (x = u.length; x--; )
            j = u[x], N = (Math.min.apply(0, j.targets) + Math.max.apply(0, j.targets)) / 2, j.pos = r(N - j.size * j.align, 0, m - j.size);
          for (x = u.length, $ = !1; x--; )
            x > 0 && u[x - 1].pos + u[x - 1].size > u[x].pos && (u[x - 1].size += u[x].size, u[x - 1].targets = u[x - 1].targets.concat(u[x].targets), u[x - 1].align = 0.5, u[x - 1].pos + u[x - 1].size > m && (u[x - 1].pos = m - u[x - 1].size), u.splice(x, 1), $ = !0);
        }
        return w.apply(c, P), x = 0, u.some((C) => {
          let b = 0;
          return (C.targets || []).some(() => (c[x].pos = C.pos + b, h !== void 0 && Math.abs(c[x].pos - c[x].target) > h ? (c.slice(0, x + 1).forEach((p) => delete p.pos), c.reducedLen = (c.reducedLen || m) - 0.1 * m, c.reducedLen > 0.1 * m && y(c, m, h), !0) : (b += c[x].size, x++, !1)));
        }), d(c, v), c;
      }, a;
    }), i(n, "Core/Renderer/SVG/SVGElement.js", [n["Core/Animation/AnimationUtilities.js"], n["Core/Color/Color.js"], n["Core/Globals.js"], n["Core/Utilities.js"]], function(o, a, r, s) {
      let { animate: l, animObject: d, stop: y } = o, { deg2rad: u, doc: m, svg: h, SVG_NS: c, win: g } = r, { addEvent: v, attr: P, createElement: f, crisp: S, css: w, defined: x, erase: k, extend: A, fireEvent: $, isArray: j, isFunction: N, isObject: M, isString: D, merge: C, objectEach: b, pick: p, pInt: L, pushUnique: B, replaceNested: T, syncTimeout: O, uniqueKey: I } = s;
      class R {
        _defaultGetter(F) {
          let U = p(this[F + "Value"], this[F], this.element ? this.element.getAttribute(F) : null, 0);
          return /^-?[\d\.]+$/.test(U) && (U = parseFloat(U)), U;
        }
        _defaultSetter(F, U, Q) {
          Q.setAttribute(U, F);
        }
        add(F) {
          let U, Q = this.renderer, J = this.element;
          return F && (this.parentGroup = F), this.textStr !== void 0 && this.element.nodeName === "text" && Q.buildText(this), this.added = !0, (!F || F.handleZ || this.zIndex) && (U = this.zIndexSetter()), U || (F ? F.element : Q.box).appendChild(J), this.onAdd && this.onAdd(), this;
        }
        addClass(F, U) {
          let Q = U ? "" : this.attr("class") || "";
          return (F = (F || "").split(/ /g).reduce(function(J, ee) {
            return Q.indexOf(ee) === -1 && J.push(ee), J;
          }, Q ? [Q] : []).join(" ")) !== Q && this.attr("class", F), this;
        }
        afterSetters() {
          this.doTransform && (this.updateTransform(), this.doTransform = !1);
        }
        align(F, U, Q, J = !0) {
          let ee, V, G, W, ae = {}, z = this.renderer, q = z.alignedObjects, Z = !!F;
          F ? (this.alignOptions = F, this.alignByTranslate = U, this.alignTo = Q) : (F = this.alignOptions || {}, U = this.alignByTranslate, Q = this.alignTo);
          let ne = !Q || D(Q) ? Q || "renderer" : void 0;
          ne && (Z && B(q, this), Q = void 0);
          let ie = p(Q, z[ne], z), re = F.align, de = F.verticalAlign;
          return ee = (ie.x || 0) + (F.x || 0), V = (ie.y || 0) + (F.y || 0), re === "right" ? G = 1 : re === "center" && (G = 2), G && (ee += ((ie.width || 0) - (F.width || 0)) / G), ae[U ? "translateX" : "x"] = Math.round(ee), de === "bottom" ? W = 1 : de === "middle" && (W = 2), W && (V += ((ie.height || 0) - (F.height || 0)) / W), ae[U ? "translateY" : "y"] = Math.round(V), J && (this[this.placed ? "animate" : "attr"](ae), this.placed = !0), this.alignAttr = ae, this;
        }
        alignSetter(F) {
          let U = { left: "start", center: "middle", right: "end" };
          U[F] && (this.alignValue = F, this.element.setAttribute("text-anchor", U[F]));
        }
        animate(F, U, Q) {
          let J = d(p(U, this.renderer.globalAnimation, !0)), ee = J.defer;
          return m.hidden && (J.duration = 0), J.duration !== 0 ? (Q && (J.complete = Q), O(() => {
            this.element && l(this, F, J);
          }, ee)) : (this.attr(F, void 0, Q || J.complete), b(F, function(V, G) {
            J.step && J.step.call(this, V, { prop: G, pos: 1, elem: this });
          }, this)), this;
        }
        applyTextOutline(F) {
          let U = this.element;
          F.indexOf("contrast") !== -1 && (F = F.replace(/contrast/g, this.renderer.getContrast(U.style.fill)));
          let Q = F.split(" "), J = Q[Q.length - 1], ee = Q[0];
          if (ee && ee !== "none" && r.svg) {
            this.fakeTS = !0, ee = ee.replace(/(^[\d\.]+)(.*?)$/g, function(z, q, Z) {
              return 2 * Number(q) + Z;
            }), this.removeTextOutline();
            let V = m.createElementNS(c, "tspan");
            P(V, { class: "highcharts-text-outline", fill: J, stroke: J, "stroke-width": ee, "stroke-linejoin": "round" });
            let G = U.querySelector("textPath") || U;
            [].forEach.call(G.childNodes, (z) => {
              let q = z.cloneNode(!0);
              q.removeAttribute && ["fill", "stroke", "stroke-width", "stroke"].forEach((Z) => q.removeAttribute(Z)), V.appendChild(q);
            });
            let W = 0;
            [].forEach.call(G.querySelectorAll("text tspan"), (z) => {
              W += Number(z.getAttribute("dy"));
            });
            let ae = m.createElementNS(c, "tspan");
            ae.textContent = "​", P(ae, { x: Number(U.getAttribute("x")), dy: -W }), V.appendChild(ae), G.insertBefore(V, G.firstChild);
          }
        }
        attr(F, U, Q, J) {
          let { element: ee } = this, V = R.symbolCustomAttribs, G, W, ae = this, z;
          return typeof F == "string" && U !== void 0 && (G = F, (F = {})[G] = U), typeof F == "string" ? ae = (this[F + "Getter"] || this._defaultGetter).call(this, F, ee) : (b(F, function(q, Z) {
            z = !1, J || y(this, Z), this.symbolName && V.indexOf(Z) !== -1 && (W || (this.symbolAttr(F), W = !0), z = !0), this.rotation && (Z === "x" || Z === "y") && (this.doTransform = !0), z || (this[Z + "Setter"] || this._defaultSetter).call(this, q, Z, ee);
          }, this), this.afterSetters()), Q && Q.call(this), ae;
        }
        clip(F) {
          if (F && !F.clipPath) {
            let U = I() + "-", Q = this.renderer.createElement("clipPath").attr({ id: U }).add(this.renderer.defs);
            A(F, { clipPath: Q, id: U, count: 0 }), F.add(Q);
          }
          return this.attr("clip-path", F ? `url(${this.renderer.url}#${F.id})` : "none");
        }
        crisp(F, U) {
          U = Math.round(U || F.strokeWidth || 0);
          let Q = F.x || this.x || 0, J = F.y || this.y || 0, ee = (F.width || this.width || 0) + Q, V = (F.height || this.height || 0) + J, G = S(Q, U), W = S(J, U);
          return A(F, { x: G, y: W, width: S(ee, U) - G, height: S(V, U) - W }), x(F.strokeWidth) && (F.strokeWidth = U), F;
        }
        complexColor(F, U, Q) {
          let J = this.renderer, ee, V, G, W, ae, z, q, Z, ne, ie, re = [], de;
          $(this.renderer, "complexColor", { args: arguments }, function() {
            if (F.radialGradient ? V = "radialGradient" : F.linearGradient && (V = "linearGradient"), V) {
              if (G = F[V], ae = J.gradients, z = F.stops, ne = Q.radialReference, j(G) && (F[V] = G = { x1: G[0], y1: G[1], x2: G[2], y2: G[3], gradientUnits: "userSpaceOnUse" }), V === "radialGradient" && ne && !x(G.gradientUnits) && (W = G, G = C(G, J.getRadialAttr(ne, W), { gradientUnits: "userSpaceOnUse" })), b(G, function(me, ce) {
                ce !== "id" && re.push(ce, me);
              }), b(z, function(me) {
                re.push(me);
              }), ae[re = re.join(",")])
                ie = ae[re].attr("id");
              else {
                G.id = ie = I();
                let me = ae[re] = J.createElement(V).attr(G).add(J.defs);
                me.radAttr = W, me.stops = [], z.forEach(function(ce) {
                  ce[1].indexOf("rgba") === 0 ? (q = (ee = a.parse(ce[1])).get("rgb"), Z = ee.get("a")) : (q = ce[1], Z = 1);
                  let pe = J.createElement("stop").attr({ offset: ce[0], "stop-color": q, "stop-opacity": Z }).add(me);
                  me.stops.push(pe);
                });
              }
              de = "url(" + J.url + "#" + ie + ")", Q.setAttribute(U, de), Q.gradient = re, F.toString = function() {
                return de;
              };
            }
          });
        }
        css(F) {
          let U = this.styles, Q = {}, J = this.element, ee, V = !U;
          if (U && b(F, function(G, W) {
            U && U[W] !== G && (Q[W] = G, V = !0);
          }), V) {
            U && (F = A(U, Q)), F.width === null || F.width === "auto" ? delete this.textWidth : J.nodeName.toLowerCase() === "text" && F.width && (ee = this.textWidth = L(F.width)), A(this.styles, F), ee && !h && this.renderer.forExport && delete F.width;
            let G = C(F);
            J.namespaceURI === this.SVG_NS && (["textOutline", "textOverflow", "width"].forEach((W) => G && delete G[W]), G.color && (G.fill = G.color)), w(J, G);
          }
          return this.added && (this.element.nodeName === "text" && this.renderer.buildText(this), F.textOutline && this.applyTextOutline(F.textOutline)), this;
        }
        dashstyleSetter(F) {
          let U, Q = this["stroke-width"];
          if (Q === "inherit" && (Q = 1), F = F && F.toLowerCase()) {
            let J = F.replace("shortdashdotdot", "3,1,1,1,1,1,").replace("shortdashdot", "3,1,1,1").replace("shortdot", "1,1,").replace("shortdash", "3,1,").replace("longdash", "8,3,").replace(/dot/g, "1,3,").replace("dash", "4,3,").replace(/,$/, "").split(",");
            for (U = J.length; U--; )
              J[U] = "" + L(J[U]) * p(Q, NaN);
            F = J.join(",").replace(/NaN/g, "none"), this.element.setAttribute("stroke-dasharray", F);
          }
        }
        destroy() {
          let F = this, U = F.element || {}, Q = F.renderer, J = U.ownerSVGElement, ee = U.nodeName === "SPAN" && F.parentGroup || void 0, V, G;
          if (U.onclick = U.onmouseout = U.onmouseover = U.onmousemove = U.point = null, y(F), F.clipPath && J) {
            let W = F.clipPath;
            [].forEach.call(J.querySelectorAll("[clip-path],[CLIP-PATH]"), function(ae) {
              ae.getAttribute("clip-path").indexOf(W.element.id) > -1 && ae.removeAttribute("clip-path");
            }), F.clipPath = W.destroy();
          }
          if (F.connector = F.connector?.destroy(), F.stops) {
            for (G = 0; G < F.stops.length; G++)
              F.stops[G].destroy();
            F.stops.length = 0, F.stops = void 0;
          }
          for (F.safeRemoveChild(U); ee && ee.div && ee.div.childNodes.length === 0; )
            V = ee.parentGroup, F.safeRemoveChild(ee.div), delete ee.div, ee = V;
          F.alignOptions && k(Q.alignedObjects, F), b(F, function(W, ae) {
            F[ae] && F[ae].parentGroup === F && F[ae].destroy && F[ae].destroy(), delete F[ae];
          });
        }
        dSetter(F, U, Q) {
          j(F) && (typeof F[0] == "string" && (F = this.renderer.pathToSegments(F)), this.pathArray = F, F = F.reduce((J, ee, V) => ee && ee.join ? (V ? J + " " : "") + ee.join(" ") : (ee || "").toString(), "")), /(NaN| {2}|^$)/.test(F) && (F = "M 0 0"), this[U] !== F && (Q.setAttribute(U, F), this[U] = F);
        }
        fillSetter(F, U, Q) {
          typeof F == "string" ? Q.setAttribute(U, F) : F && this.complexColor(F, U, Q);
        }
        hrefSetter(F, U, Q) {
          Q.setAttributeNS("http://www.w3.org/1999/xlink", U, F);
        }
        getBBox(F, U) {
          let Q, J, ee, V, { alignValue: G, element: W, renderer: ae, styles: z, textStr: q } = this, { cache: Z, cacheKeys: ne } = ae, ie = W.namespaceURI === this.SVG_NS, re = p(U, this.rotation, 0), de = ae.styledMode ? W && R.prototype.getStyle.call(W, "font-size") : z.fontSize;
          if (x(q) && ((V = q.toString()).indexOf("<") === -1 && (V = V.replace(/\d/g, "0")), V += ["", ae.rootFontSize, de, re, this.textWidth, G, z.textOverflow, z.fontWeight].join(",")), V && !F && (Q = Z[V]), !Q || Q.polygon) {
            if (ie || ae.forExport) {
              try {
                ee = this.fakeTS && function(ce) {
                  let pe = W.querySelector(".highcharts-text-outline");
                  pe && w(pe, { display: ce });
                }, N(ee) && ee("none"), Q = W.getBBox ? A({}, W.getBBox()) : { width: W.offsetWidth, height: W.offsetHeight, x: 0, y: 0 }, N(ee) && ee("");
              } catch {
              }
              (!Q || Q.width < 0) && (Q = { x: 0, y: 0, width: 0, height: 0 });
            } else
              Q = this.htmlGetBBox();
            J = Q.height, ie && (Q.height = J = { "11px,17": 14, "13px,20": 16 }[`${de || ""},${Math.round(J)}`] || J), re && (Q = this.getRotatedBox(Q, re));
            let me = { bBox: Q };
            $(this, "afterGetBBox", me), Q = me.bBox;
          }
          if (V && (q === "" || Q.height > 0)) {
            for (; ne.length > 250; )
              delete Z[ne.shift()];
            Z[V] || ne.push(V), Z[V] = Q;
          }
          return Q;
        }
        getRotatedBox(F, U) {
          let { x: Q, y: J, width: ee, height: V } = F, { alignValue: G, translateY: W, rotationOriginX: ae = 0, rotationOriginY: z = 0 } = this, q = { right: 1, center: 0.5 }[G || 0] || 0, Z = Number(this.element.getAttribute("y") || 0) - (W ? 0 : J), ne = U * u, ie = (U - 90) * u, re = Math.cos(ne), de = Math.sin(ne), me = ee * re, ce = ee * de, pe = Math.cos(ie), xe = Math.sin(ie), [[le, se], [he, ve]] = [ae, z].map((Ye) => [Ye - Ye * re, Ye * de]), ye = Q + q * (ee - me) + le + ve + Z * pe, be = ye + me, ke = be - V * pe, we = ke - me, Le = J + Z - q * ce - se + he + Z * xe, Me = Le + ce, De = Me - V * xe, Ae = De - ce, _e = Math.min(ye, be, ke, we), He = Math.min(Le, Me, De, Ae), Ee = Math.max(ye, be, ke, we) - _e, Ne = Math.max(Le, Me, De, Ae) - He;
          return { x: _e, y: He, width: Ee, height: Ne, polygon: [[ye, Le], [be, Me], [ke, De], [we, Ae]] };
        }
        getStyle(F) {
          return g.getComputedStyle(this.element || this, "").getPropertyValue(F);
        }
        hasClass(F) {
          return ("" + this.attr("class")).split(" ").indexOf(F) !== -1;
        }
        hide() {
          return this.attr({ visibility: "hidden" });
        }
        htmlGetBBox() {
          return { height: 0, width: 0, x: 0, y: 0 };
        }
        constructor(F, U) {
          this.onEvents = {}, this.opacity = 1, this.SVG_NS = c, this.element = U === "span" || U === "body" ? f(U) : m.createElementNS(this.SVG_NS, U), this.renderer = F, this.styles = {}, $(this, "afterInit");
        }
        on(F, U) {
          let { onEvents: Q } = this;
          return Q[F] && Q[F](), Q[F] = v(this.element, F, U), this;
        }
        opacitySetter(F, U, Q) {
          let J = Number(Number(F).toFixed(3));
          this.opacity = J, Q.setAttribute(U, J);
        }
        reAlign() {
          this.alignOptions?.width && this.alignOptions.align !== "left" && (this.alignOptions.width = this.getBBox().width, this.placed = !1, this.align());
        }
        removeClass(F) {
          return this.attr("class", ("" + this.attr("class")).replace(D(F) ? RegExp(`(^| )${F}( |$)`) : F, " ").replace(/ +/g, " ").trim());
        }
        removeTextOutline() {
          let F = this.element.querySelector("tspan.highcharts-text-outline");
          F && this.safeRemoveChild(F);
        }
        safeRemoveChild(F) {
          let U = F.parentNode;
          U && U.removeChild(F);
        }
        setRadialReference(F) {
          let U = this.element.gradient && this.renderer.gradients[this.element.gradient];
          return this.element.radialReference = F, U && U.radAttr && U.animate(this.renderer.getRadialAttr(F, U.radAttr)), this;
        }
        shadow(F) {
          let { renderer: U } = this, Q = C(this.parentGroup?.rotation === 90 ? { offsetX: -1, offsetY: -1 } : {}, M(F) ? F : {}), J = U.shadowDefinition(Q);
          return this.attr({ filter: F ? `url(${U.url}#${J})` : "none" });
        }
        show(F = !0) {
          return this.attr({ visibility: F ? "inherit" : "visible" });
        }
        "stroke-widthSetter"(F, U, Q) {
          this[U] = F, Q.setAttribute(U, F);
        }
        strokeWidth() {
          if (!this.renderer.styledMode)
            return this["stroke-width"] || 0;
          let F = this.getStyle("stroke-width"), U = 0, Q;
          return /px$/.test(F) ? U = L(F) : F !== "" && (P(Q = m.createElementNS(c, "rect"), { width: F, "stroke-width": 0 }), this.element.parentNode.appendChild(Q), U = Q.getBBox().width, Q.parentNode.removeChild(Q)), U;
        }
        symbolAttr(F) {
          let U = this;
          R.symbolCustomAttribs.forEach(function(Q) {
            U[Q] = p(F[Q], U[Q]);
          }), U.attr({ d: U.renderer.symbols[U.symbolName](U.x, U.y, U.width, U.height, U) });
        }
        textSetter(F) {
          F !== this.textStr && (delete this.textPxLength, this.textStr = F, this.added && this.renderer.buildText(this), this.reAlign());
        }
        titleSetter(F) {
          let U = this.element, Q = U.getElementsByTagName("title")[0] || m.createElementNS(this.SVG_NS, "title");
          U.insertBefore ? U.insertBefore(Q, U.firstChild) : U.appendChild(Q), Q.textContent = T(p(F, ""), [/<[^>]*>/g, ""]).replace(/&lt;/g, "<").replace(/&gt;/g, ">");
        }
        toFront() {
          let F = this.element;
          return F.parentNode.appendChild(F), this;
        }
        translate(F, U) {
          return this.attr({ translateX: F, translateY: U });
        }
        updateTransform(F = "transform") {
          let { element: U, matrix: Q, rotation: J = 0, rotationOriginX: ee, rotationOriginY: V, scaleX: G, scaleY: W, translateX: ae = 0, translateY: z = 0 } = this, q = ["translate(" + ae + "," + z + ")"];
          x(Q) && q.push("matrix(" + Q.join(",") + ")"), J && (q.push("rotate(" + J + " " + p(ee, U.getAttribute("x"), 0) + " " + p(V, U.getAttribute("y") || 0) + ")"), this.text?.element.tagName === "SPAN" && this.text.attr({ rotation: J, rotationOriginX: (ee || 0) - this.padding, rotationOriginY: (V || 0) - this.padding })), (x(G) || x(W)) && q.push("scale(" + p(G, 1) + " " + p(W, 1) + ")"), q.length && !(this.text || this).textPath && U.setAttribute(F, q.join(" "));
        }
        visibilitySetter(F, U, Q) {
          F === "inherit" ? Q.removeAttribute(U) : this[U] !== F && Q.setAttribute(U, F), this[U] = F;
        }
        xGetter(F) {
          return this.element.nodeName === "circle" && (F === "x" ? F = "cx" : F === "y" && (F = "cy")), this._defaultGetter(F);
        }
        zIndexSetter(F, U) {
          let Q = this.renderer, J = this.parentGroup, ee = (J || Q).element || Q.box, V = this.element, G = ee === Q.box, W, ae, z, q = !1, Z, ne = this.added, ie;
          if (x(F) ? (V.setAttribute("data-z-index", F), F = +F, this[U] === F && (ne = !1)) : x(this[U]) && V.removeAttribute("data-z-index"), this[U] = F, ne) {
            for ((F = this.zIndex) && J && (J.handleZ = !0), ie = (W = ee.childNodes).length - 1; ie >= 0 && !q; ie--)
              Z = !x(z = (ae = W[ie]).getAttribute("data-z-index")), ae !== V && (F < 0 && Z && !G && !ie ? (ee.insertBefore(V, W[ie]), q = !0) : (L(z) <= F || Z && (!x(F) || F >= 0)) && (ee.insertBefore(V, W[ie + 1]), q = !0));
            q || (ee.insertBefore(V, W[G ? 3 : 0]), q = !0);
          }
          return q;
        }
      }
      return R.symbolCustomAttribs = ["anchorX", "anchorY", "clockwise", "end", "height", "innerR", "r", "start", "width", "x", "y"], R.prototype.strokeSetter = R.prototype.fillSetter, R.prototype.yGetter = R.prototype.xGetter, R.prototype.matrixSetter = R.prototype.rotationOriginXSetter = R.prototype.rotationOriginYSetter = R.prototype.rotationSetter = R.prototype.scaleXSetter = R.prototype.scaleYSetter = R.prototype.translateXSetter = R.prototype.translateYSetter = R.prototype.verticalAlignSetter = function(Y, F) {
        this[F] = Y, this.doTransform = !0;
      }, R;
    }), i(n, "Core/Renderer/SVG/SVGLabel.js", [n["Core/Renderer/SVG/SVGElement.js"], n["Core/Utilities.js"]], function(o, a) {
      let { defined: r, extend: s, isNumber: l, merge: d, pick: y, removeEvent: u } = a;
      class m extends o {
        constructor(c, g, v, P, f, S, w, x, k, A) {
          let $;
          super(c, "g"), this.paddingLeftSetter = this.paddingSetter, this.paddingRightSetter = this.paddingSetter, this.doUpdate = !1, this.textStr = g, this.x = v, this.y = P, this.anchorX = S, this.anchorY = w, this.baseline = k, this.className = A, this.addClass(A === "button" ? "highcharts-no-tooltip" : "highcharts-label"), A && this.addClass("highcharts-" + A), this.text = c.text(void 0, 0, 0, x).attr({ zIndex: 1 }), typeof f == "string" && (($ = /^url\((.*?)\)$/.test(f)) || this.renderer.symbols[f]) && (this.symbolKey = f), this.bBox = m.emptyBBox, this.padding = 3, this.baselineOffset = 0, this.needsBox = c.styledMode || $, this.deferredAttr = {}, this.alignFactor = 0;
        }
        alignSetter(c) {
          let g = { left: 0, center: 0.5, right: 1 }[c];
          g !== this.alignFactor && (this.alignFactor = g, this.bBox && l(this.xSetting) && this.attr({ x: this.xSetting }));
        }
        anchorXSetter(c, g) {
          this.anchorX = c, this.boxAttr(g, Math.round(c) - this.getCrispAdjust() - this.xSetting);
        }
        anchorYSetter(c, g) {
          this.anchorY = c, this.boxAttr(g, c - this.ySetting);
        }
        boxAttr(c, g) {
          this.box ? this.box.attr(c, g) : this.deferredAttr[c] = g;
        }
        css(c) {
          if (c) {
            let g = {};
            c = d(c), m.textProps.forEach((v) => {
              c[v] !== void 0 && (g[v] = c[v], delete c[v]);
            }), this.text.css(g), "fontSize" in g || "fontWeight" in g ? this.updateTextPadding() : ("width" in g || "textOverflow" in g) && this.updateBoxSize();
          }
          return o.prototype.css.call(this, c);
        }
        destroy() {
          u(this.element, "mouseenter"), u(this.element, "mouseleave"), this.text && this.text.destroy(), this.box && (this.box = this.box.destroy()), o.prototype.destroy.call(this);
        }
        fillSetter(c, g) {
          c && (this.needsBox = !0), this.fill = c, this.boxAttr(g, c);
        }
        getBBox(c, g) {
          this.textStr && this.bBox.width === 0 && this.bBox.height === 0 && this.updateBoxSize();
          let { padding: v, height: P = 0, translateX: f = 0, translateY: S = 0, width: w = 0 } = this, x = y(this.paddingLeft, v), k = g ?? (this.rotation || 0), A = { width: w, height: P, x: f + this.bBox.x - x, y: S + this.bBox.y - v + this.baselineOffset };
          return k && (A = this.getRotatedBox(A, k)), A;
        }
        getCrispAdjust() {
          return (this.renderer.styledMode && this.box ? this.box.strokeWidth() : this["stroke-width"] ? parseInt(this["stroke-width"], 10) : 0) % 2 / 2;
        }
        heightSetter(c) {
          this.heightSetting = c, this.doUpdate = !0;
        }
        afterSetters() {
          super.afterSetters(), this.doUpdate && (this.updateBoxSize(), this.doUpdate = !1);
        }
        onAdd() {
          this.text.add(this), this.attr({ text: y(this.textStr, ""), x: this.x || 0, y: this.y || 0 }), this.box && r(this.anchorX) && this.attr({ anchorX: this.anchorX, anchorY: this.anchorY });
        }
        paddingSetter(c, g) {
          l(c) ? c !== this[g] && (this[g] = c, this.updateTextPadding()) : this[g] = void 0;
        }
        rSetter(c, g) {
          this.boxAttr(g, c);
        }
        strokeSetter(c, g) {
          this.stroke = c, this.boxAttr(g, c);
        }
        "stroke-widthSetter"(c, g) {
          c && (this.needsBox = !0), this["stroke-width"] = c, this.boxAttr(g, c);
        }
        "text-alignSetter"(c) {
          this.textAlign = c;
        }
        textSetter(c) {
          c !== void 0 && this.text.attr({ text: c }), this.updateTextPadding(), this.reAlign();
        }
        updateBoxSize() {
          let c, g = this.text, v = {}, P = this.padding, f = this.bBox = (!l(this.widthSetting) || !l(this.heightSetting) || this.textAlign) && r(g.textStr) ? g.getBBox(void 0, 0) : m.emptyBBox;
          this.width = this.getPaddedWidth(), this.height = (this.heightSetting || f.height || 0) + 2 * P;
          let S = this.renderer.fontMetrics(g);
          if (this.baselineOffset = P + Math.min((this.text.firstLineMetrics || S).b, f.height || 1 / 0), this.heightSetting && (this.baselineOffset += (this.heightSetting - S.h) / 2), this.needsBox && !g.textPath) {
            if (!this.box) {
              let w = this.box = this.symbolKey ? this.renderer.symbol(this.symbolKey) : this.renderer.rect();
              w.addClass((this.className === "button" ? "" : "highcharts-label-box") + (this.className ? " highcharts-" + this.className + "-box" : "")), w.add(this);
            }
            c = this.getCrispAdjust(), v.x = c, v.y = (this.baseline ? -this.baselineOffset : 0) + c, v.width = Math.round(this.width), v.height = Math.round(this.height), this.box.attr(s(v, this.deferredAttr)), this.deferredAttr = {};
          }
        }
        updateTextPadding() {
          let c = this.text;
          if (!c.textPath) {
            this.updateBoxSize();
            let g = this.baseline ? 0 : this.baselineOffset, v = y(this.paddingLeft, this.padding);
            r(this.widthSetting) && this.bBox && (this.textAlign === "center" || this.textAlign === "right") && (v += { center: 0.5, right: 1 }[this.textAlign] * (this.widthSetting - this.bBox.width)), (v !== c.x || g !== c.y) && (c.attr("x", v), c.hasBoxWidthChanged && (this.bBox = c.getBBox(!0)), g !== void 0 && c.attr("y", g)), c.x = v, c.y = g;
          }
        }
        widthSetter(c) {
          this.widthSetting = l(c) ? c : void 0, this.doUpdate = !0;
        }
        getPaddedWidth() {
          let c = this.padding, g = y(this.paddingLeft, c), v = y(this.paddingRight, c);
          return (this.widthSetting || this.bBox.width || 0) + g + v;
        }
        xSetter(c) {
          this.x = c, this.alignFactor && (c -= this.alignFactor * this.getPaddedWidth(), this["forceAnimate:x"] = !0), this.xSetting = Math.round(c), this.attr("translateX", this.xSetting);
        }
        ySetter(c) {
          this.ySetting = this.y = Math.round(c), this.attr("translateY", this.ySetting);
        }
      }
      return m.emptyBBox = { width: 0, height: 0, x: 0, y: 0 }, m.textProps = ["color", "direction", "fontFamily", "fontSize", "fontStyle", "fontWeight", "lineHeight", "textAlign", "textDecoration", "textOutline", "textOverflow", "whiteSpace", "width"], m;
    }), i(n, "Core/Renderer/SVG/Symbols.js", [n["Core/Utilities.js"]], function(o) {
      let { defined: a, isNumber: r, pick: s } = o;
      function l(u, m, h, c, g) {
        let v = [];
        if (g) {
          let P = g.start || 0, f = s(g.r, h), S = s(g.r, c || h), w = 2e-4 / (g.borderRadius ? 1 : Math.max(f, 1)), x = Math.abs((g.end || 0) - P - 2 * Math.PI) < w, k = (g.end || 0) - (x ? w : 0), A = g.innerR, $ = s(g.open, x), j = Math.cos(P), N = Math.sin(P), M = Math.cos(k), D = Math.sin(k), C = s(g.longArc, k - P - Math.PI < w ? 0 : 1), b = ["A", f, S, 0, C, s(g.clockwise, 1), u + f * M, m + S * D];
          b.params = { start: P, end: k, cx: u, cy: m }, v.push(["M", u + f * j, m + S * N], b), a(A) && ((b = ["A", A, A, 0, C, a(g.clockwise) ? 1 - g.clockwise : 0, u + A * j, m + A * N]).params = { start: k, end: P, cx: u, cy: m }, v.push($ ? ["M", u + A * M, m + A * D] : ["L", u + A * M, m + A * D], b)), $ || v.push(["Z"]);
        }
        return v;
      }
      function d(u, m, h, c, g) {
        return g && g.r ? y(u, m, h, c, g) : [["M", u, m], ["L", u + h, m], ["L", u + h, m + c], ["L", u, m + c], ["Z"]];
      }
      function y(u, m, h, c, g) {
        let v = g?.r || 0;
        return [["M", u + v, m], ["L", u + h - v, m], ["A", v, v, 0, 0, 1, u + h, m + v], ["L", u + h, m + c - v], ["A", v, v, 0, 0, 1, u + h - v, m + c], ["L", u + v, m + c], ["A", v, v, 0, 0, 1, u, m + c - v], ["L", u, m + v], ["A", v, v, 0, 0, 1, u + v, m], ["Z"]];
      }
      return { arc: l, callout: function(u, m, h, c, g) {
        let v = Math.min(g && g.r || 0, h, c), P = v + 6, f = g && g.anchorX, S = g && g.anchorY || 0, w = y(u, m, h, c, { r: v });
        if (!r(f) || f < h && f > 0 && S < c && S > 0)
          return w;
        if (u + f > h - P)
          if (S > m + P && S < m + c - P)
            w.splice(3, 1, ["L", u + h, S - 6], ["L", u + h + 6, S], ["L", u + h, S + 6], ["L", u + h, m + c - v]);
          else if (f < h) {
            let x = S < m + P, k = x ? m : m + c;
            w.splice(x ? 2 : 5, 0, ["L", f, S], ["L", u + h - v, k]);
          } else
            w.splice(3, 1, ["L", u + h, c / 2], ["L", f, S], ["L", u + h, c / 2], ["L", u + h, m + c - v]);
        else if (u + f < P)
          if (S > m + P && S < m + c - P)
            w.splice(7, 1, ["L", u, S + 6], ["L", u - 6, S], ["L", u, S - 6], ["L", u, m + v]);
          else if (f > 0) {
            let x = S < m + P, k = x ? m : m + c;
            w.splice(x ? 1 : 6, 0, ["L", f, S], ["L", u + v, k]);
          } else
            w.splice(7, 1, ["L", u, c / 2], ["L", f, S], ["L", u, c / 2], ["L", u, m + v]);
        else
          S > c && f < h - P ? w.splice(5, 1, ["L", f + 6, m + c], ["L", f, m + c + 6], ["L", f - 6, m + c], ["L", u + v, m + c]) : S < 0 && f > P && w.splice(1, 1, ["L", f - 6, m], ["L", f, m - 6], ["L", f + 6, m], ["L", h - v, m]);
        return w;
      }, circle: function(u, m, h, c) {
        return l(u + h / 2, m + c / 2, h / 2, c / 2, { start: 0.5 * Math.PI, end: 2.5 * Math.PI, open: !1 });
      }, diamond: function(u, m, h, c) {
        return [["M", u + h / 2, m], ["L", u + h, m + c / 2], ["L", u + h / 2, m + c], ["L", u, m + c / 2], ["Z"]];
      }, rect: d, roundedRect: y, square: d, triangle: function(u, m, h, c) {
        return [["M", u + h / 2, m], ["L", u + h, m + c], ["L", u, m + c], ["Z"]];
      }, "triangle-down": function(u, m, h, c) {
        return [["M", u, m], ["L", u + h, m], ["L", u + h / 2, m + c], ["Z"]];
      } };
    }), i(n, "Core/Renderer/SVG/TextBuilder.js", [n["Core/Renderer/HTML/AST.js"], n["Core/Globals.js"], n["Core/Utilities.js"]], function(o, a, r) {
      let { doc: s, SVG_NS: l, win: d } = a, { attr: y, extend: u, fireEvent: m, isString: h, objectEach: c, pick: g } = r;
      return class {
        constructor(v) {
          let P = v.styles;
          this.renderer = v.renderer, this.svgElement = v, this.width = v.textWidth, this.textLineHeight = P && P.lineHeight, this.textOutline = P && P.textOutline, this.ellipsis = !!(P && P.textOverflow === "ellipsis"), this.noWrap = !!(P && P.whiteSpace === "nowrap");
        }
        buildSVG() {
          let v = this.svgElement, P = v.element, f = v.renderer, S = g(v.textStr, "").toString(), w = S.indexOf("<") !== -1, x = P.childNodes, k = !v.added && f.box, A = [S, this.ellipsis, this.noWrap, this.textLineHeight, this.textOutline, v.getStyle("font-size"), this.width].join(",");
          if (A !== v.textCache) {
            v.textCache = A, delete v.actualWidth;
            for (let $ = x.length; $--; )
              P.removeChild(x[$]);
            if (w || this.ellipsis || this.width || v.textPath || S.indexOf(" ") !== -1 && (!this.noWrap || /<br.*?>/g.test(S))) {
              if (S !== "") {
                k && k.appendChild(P);
                let $ = new o(S);
                this.modifyTree($.nodes), $.addToDOM(P), this.modifyDOM(), this.ellipsis && (P.textContent || "").indexOf("…") !== -1 && v.attr("title", this.unescapeEntities(v.textStr || "", ["&lt;", "&gt;"])), k && k.removeChild(P);
              }
            } else
              P.appendChild(s.createTextNode(this.unescapeEntities(S)));
            h(this.textOutline) && v.applyTextOutline && v.applyTextOutline(this.textOutline);
          }
        }
        modifyDOM() {
          let v, P = this.svgElement, f = y(P.element, "x");
          for (P.firstLineMetrics = void 0; (v = P.element.firstChild) && /^[\s\u200B]*$/.test(v.textContent || " "); )
            P.element.removeChild(v);
          [].forEach.call(P.element.querySelectorAll("tspan.highcharts-br"), (k, A) => {
            k.nextSibling && k.previousSibling && (A === 0 && k.previousSibling.nodeType === 1 && (P.firstLineMetrics = P.renderer.fontMetrics(k.previousSibling)), y(k, { dy: this.getLineHeight(k.nextSibling), x: f }));
          });
          let S = this.width || 0;
          if (!S)
            return;
          let w = (k, A) => {
            let $ = k.textContent || "", j = $.replace(/([^\^])-/g, "$1- ").split(" "), N = !this.noWrap && (j.length > 1 || P.element.childNodes.length > 1), M = this.getLineHeight(A), D = 0, C = P.actualWidth;
            if (this.ellipsis)
              $ && this.truncate(k, $, void 0, 0, Math.max(0, S - 0.8 * M), (b, p) => b.substring(0, p) + "…");
            else if (N) {
              let b = [], p = [];
              for (; A.firstChild && A.firstChild !== k; )
                p.push(A.firstChild), A.removeChild(A.firstChild);
              for (; j.length; )
                j.length && !this.noWrap && D > 0 && (b.push(k.textContent || ""), k.textContent = j.join(" ").replace(/- /g, "-")), this.truncate(k, void 0, j, D === 0 && C || 0, S, (L, B) => j.slice(0, B).join(" ").replace(/- /g, "-")), C = P.actualWidth, D++;
              p.forEach((L) => {
                A.insertBefore(L, k);
              }), b.forEach((L) => {
                A.insertBefore(s.createTextNode(L), k);
                let B = s.createElementNS(l, "tspan");
                B.textContent = "​", y(B, { dy: M, x: f }), A.insertBefore(B, k);
              });
            }
          }, x = (k) => {
            [].slice.call(k.childNodes).forEach((A) => {
              A.nodeType === d.Node.TEXT_NODE ? w(A, k) : (A.className.baseVal.indexOf("highcharts-br") !== -1 && (P.actualWidth = 0), x(A));
            });
          };
          x(P.element);
        }
        getLineHeight(v) {
          let P = v.nodeType === d.Node.TEXT_NODE ? v.parentElement : v;
          return this.textLineHeight ? parseInt(this.textLineHeight.toString(), 10) : this.renderer.fontMetrics(P || this.svgElement.element).h;
        }
        modifyTree(v) {
          let P = (f, S) => {
            let { attributes: w = {}, children: x, style: k = {}, tagName: A } = f, $ = this.renderer.styledMode;
            if (A === "b" || A === "strong" ? $ ? w.class = "highcharts-strong" : k.fontWeight = "bold" : (A === "i" || A === "em") && ($ ? w.class = "highcharts-emphasized" : k.fontStyle = "italic"), k && k.color && (k.fill = k.color), A === "br") {
              w.class = "highcharts-br", f.textContent = "​";
              let j = v[S + 1];
              j && j.textContent && (j.textContent = j.textContent.replace(/^ +/gm, ""));
            } else
              A === "a" && x && x.some((j) => j.tagName === "#text") && (f.children = [{ children: x, tagName: "tspan" }]);
            A !== "#text" && A !== "a" && (f.tagName = "tspan"), u(f, { attributes: w, style: k }), x && x.filter((j) => j.tagName !== "#text").forEach(P);
          };
          v.forEach(P), m(this.svgElement, "afterModifyTree", { nodes: v });
        }
        truncate(v, P, f, S, w, x) {
          let k, A, $ = this.svgElement, { rotation: j } = $, N = [], M = f ? 1 : 0, D = (P || f || "").length, C = D, b = function(p, L) {
            let B = L || p, T = v.parentNode;
            if (T && N[B] === void 0 && T.getSubStringLength)
              try {
                N[B] = S + T.getSubStringLength(0, f ? B + 1 : B);
              } catch {
              }
            return N[B];
          };
          if ($.rotation = 0, S + (A = b(v.textContent.length)) > w) {
            for (; M <= D; )
              C = Math.ceil((M + D) / 2), f && (k = x(f, C)), A = b(C, k && k.length - 1), M === D ? M = D + 1 : A > w ? D = C - 1 : M = C;
            D === 0 ? v.textContent = "" : P && D === P.length - 1 || (v.textContent = k || x(P || f, C));
          }
          f && f.splice(0, C), $.actualWidth = A, $.rotation = j;
        }
        unescapeEntities(v, P) {
          return c(this.renderer.escapes, function(f, S) {
            P && P.indexOf(f) !== -1 || (v = v.toString().replace(RegExp(f, "g"), S));
          }), v;
        }
      };
    }), i(n, "Core/Renderer/SVG/SVGRenderer.js", [n["Core/Renderer/HTML/AST.js"], n["Core/Defaults.js"], n["Core/Color/Color.js"], n["Core/Globals.js"], n["Core/Renderer/RendererRegistry.js"], n["Core/Renderer/SVG/SVGElement.js"], n["Core/Renderer/SVG/SVGLabel.js"], n["Core/Renderer/SVG/Symbols.js"], n["Core/Renderer/SVG/TextBuilder.js"], n["Core/Utilities.js"]], function(o, a, r, s, l, d, y, u, m, h) {
      let c, { defaultOptions: g } = a, { charts: v, deg2rad: P, doc: f, isFirefox: S, isMS: w, isWebKit: x, noop: k, SVG_NS: A, symbolSizes: $, win: j } = s, { addEvent: N, attr: M, createElement: D, crisp: C, css: b, defined: p, destroyObjectProperties: L, extend: B, isArray: T, isNumber: O, isObject: I, isString: R, merge: Y, pick: F, pInt: U, replaceNested: Q, uniqueKey: J } = h;
      class ee {
        constructor(G, W, ae, z, q, Z, ne) {
          let ie, re, de = this.createElement("svg").attr({ version: "1.1", class: "highcharts-root" }), me = de.element;
          ne || de.css(this.getStyle(z || {})), G.appendChild(me), M(G, "dir", "ltr"), G.innerHTML.indexOf("xmlns") === -1 && M(me, "xmlns", this.SVG_NS), this.box = me, this.boxWrapper = de, this.alignedObjects = [], this.url = this.getReferenceURL(), this.createElement("desc").add().element.appendChild(f.createTextNode("Created with Highcharts 11.4.8")), this.defs = this.createElement("defs").add(), this.allowHTML = Z, this.forExport = q, this.styledMode = ne, this.gradients = {}, this.cache = {}, this.cacheKeys = [], this.imgCount = 0, this.rootFontSize = de.getStyle("font-size"), this.setSize(W, ae, !1), S && G.getBoundingClientRect && ((ie = function() {
            b(G, { left: 0, top: 0 }), re = G.getBoundingClientRect(), b(G, { left: Math.ceil(re.left) - re.left + "px", top: Math.ceil(re.top) - re.top + "px" });
          })(), this.unSubPixelFix = N(j, "resize", ie));
        }
        definition(G) {
          return new o([G]).addToDOM(this.defs.element);
        }
        getReferenceURL() {
          if ((S || x) && f.getElementsByTagName("base").length) {
            if (!p(c)) {
              let G = J(), W = new o([{ tagName: "svg", attributes: { width: 8, height: 8 }, children: [{ tagName: "defs", children: [{ tagName: "clipPath", attributes: { id: G }, children: [{ tagName: "rect", attributes: { width: 4, height: 4 } }] }] }, { tagName: "rect", attributes: { id: "hitme", width: 8, height: 8, "clip-path": `url(#${G})`, fill: "rgba(0,0,0,0.001)" } }] }]).addToDOM(f.body);
              b(W, { position: "fixed", top: 0, left: 0, zIndex: 9e5 });
              let ae = f.elementFromPoint(6, 6);
              c = (ae && ae.id) === "hitme", f.body.removeChild(W);
            }
            if (c)
              return Q(j.location.href.split("#")[0], [/<[^>]*>/g, ""], [/([\('\)])/g, "\\$1"], [/ /g, "%20"]);
          }
          return "";
        }
        getStyle(G) {
          return this.style = B({ fontFamily: "Helvetica, Arial, sans-serif", fontSize: "1rem" }, G), this.style;
        }
        setStyle(G) {
          this.boxWrapper.css(this.getStyle(G));
        }
        isHidden() {
          return !this.boxWrapper.getBBox().width;
        }
        destroy() {
          let G = this.defs;
          return this.box = null, this.boxWrapper = this.boxWrapper.destroy(), L(this.gradients || {}), this.gradients = null, this.defs = G.destroy(), this.unSubPixelFix && this.unSubPixelFix(), this.alignedObjects = null, null;
        }
        createElement(G) {
          return new this.Element(this, G);
        }
        getRadialAttr(G, W) {
          return { cx: G[0] - G[2] / 2 + (W.cx || 0) * G[2], cy: G[1] - G[2] / 2 + (W.cy || 0) * G[2], r: (W.r || 0) * G[2] };
        }
        shadowDefinition(G) {
          let W = [`highcharts-drop-shadow-${this.chartIndex}`, ...Object.keys(G).map((z) => `${z}-${G[z]}`)].join("-").toLowerCase().replace(/[^a-z\d\-]/g, ""), ae = Y({ color: "#000000", offsetX: 1, offsetY: 1, opacity: 0.15, width: 5 }, G);
          return this.defs.element.querySelector(`#${W}`) || this.definition({ tagName: "filter", attributes: { id: W, filterUnits: ae.filterUnits }, children: this.getShadowFilterContent(ae) }), W;
        }
        getShadowFilterContent(G) {
          return [{ tagName: "feDropShadow", attributes: { dx: G.offsetX, dy: G.offsetY, "flood-color": G.color, "flood-opacity": Math.min(5 * G.opacity, 1), stdDeviation: G.width / 2 } }];
        }
        buildText(G) {
          new m(G).buildSVG();
        }
        getContrast(G) {
          let W = r.parse(G).rgba.map((z) => {
            let q = z / 255;
            return q <= 0.03928 ? q / 12.92 : Math.pow((q + 0.055) / 1.055, 2.4);
          }), ae = 0.2126 * W[0] + 0.7152 * W[1] + 0.0722 * W[2];
          return 1.05 / (ae + 0.05) > (ae + 0.05) / 0.05 ? "#FFFFFF" : "#000000";
        }
        button(G, W, ae, z, q = {}, Z, ne, ie, re, de) {
          let me = this.label(G, W, ae, re, void 0, void 0, de, void 0, "button"), ce = this.styledMode, pe = arguments, xe = 0;
          q = Y(g.global.buttonTheme, q), ce && (delete q.fill, delete q.stroke, delete q["stroke-width"]);
          let le = q.states || {}, se = q.style || {};
          delete q.states, delete q.style;
          let he = [o.filterUserAttributes(q)], ve = [se];
          return ce || ["hover", "select", "disabled"].forEach((ye, be) => {
            he.push(Y(he[0], o.filterUserAttributes(pe[be + 5] || le[ye] || {}))), ve.push(he[be + 1].style), delete he[be + 1].style;
          }), N(me.element, w ? "mouseover" : "mouseenter", function() {
            xe !== 3 && me.setState(1);
          }), N(me.element, w ? "mouseout" : "mouseleave", function() {
            xe !== 3 && me.setState(xe);
          }), me.setState = (ye = 0) => {
            if (ye !== 1 && (me.state = xe = ye), me.removeClass(/highcharts-button-(normal|hover|pressed|disabled)/).addClass("highcharts-button-" + ["normal", "hover", "pressed", "disabled"][ye]), !ce) {
              me.attr(he[ye]);
              let be = ve[ye];
              I(be) && me.css(be);
            }
          }, me.attr(he[0]), !ce && (me.css(B({ cursor: "default" }, se)), de && me.text.css({ pointerEvents: "none" })), me.on("touchstart", (ye) => ye.stopPropagation()).on("click", function(ye) {
            xe !== 3 && z.call(me, ye);
          });
        }
        crispLine(G, W) {
          let [ae, z] = G;
          return p(ae[1]) && ae[1] === z[1] && (ae[1] = z[1] = C(ae[1], W)), p(ae[2]) && ae[2] === z[2] && (ae[2] = z[2] = C(ae[2], W)), G;
        }
        path(G) {
          let W = this.styledMode ? {} : { fill: "none" };
          return T(G) ? W.d = G : I(G) && B(W, G), this.createElement("path").attr(W);
        }
        circle(G, W, ae) {
          let z = I(G) ? G : G === void 0 ? {} : { x: G, y: W, r: ae }, q = this.createElement("circle");
          return q.xSetter = q.ySetter = function(Z, ne, ie) {
            ie.setAttribute("c" + ne, Z);
          }, q.attr(z);
        }
        arc(G, W, ae, z, q, Z) {
          let ne;
          I(G) ? (W = (ne = G).y, ae = ne.r, z = ne.innerR, q = ne.start, Z = ne.end, G = ne.x) : ne = { innerR: z, start: q, end: Z };
          let ie = this.symbol("arc", G, W, ae, ae, ne);
          return ie.r = ae, ie;
        }
        rect(G, W, ae, z, q, Z) {
          let ne = I(G) ? G : G === void 0 ? {} : { x: G, y: W, r: q, width: Math.max(ae || 0, 0), height: Math.max(z || 0, 0) }, ie = this.createElement("rect");
          return this.styledMode || (Z !== void 0 && (ne["stroke-width"] = Z, B(ne, ie.crisp(ne))), ne.fill = "none"), ie.rSetter = function(re, de, me) {
            ie.r = re, M(me, { rx: re, ry: re });
          }, ie.rGetter = function() {
            return ie.r || 0;
          }, ie.attr(ne);
        }
        roundedRect(G) {
          return this.symbol("roundedRect").attr(G);
        }
        setSize(G, W, ae) {
          this.width = G, this.height = W, this.boxWrapper.animate({ width: G, height: W }, { step: function() {
            this.attr({ viewBox: "0 0 " + this.attr("width") + " " + this.attr("height") });
          }, duration: F(ae, !0) ? void 0 : 0 }), this.alignElements();
        }
        g(G) {
          let W = this.createElement("g");
          return G ? W.attr({ class: "highcharts-" + G }) : W;
        }
        image(G, W, ae, z, q, Z) {
          let ne = { preserveAspectRatio: "none" };
          O(W) && (ne.x = W), O(ae) && (ne.y = ae), O(z) && (ne.width = z), O(q) && (ne.height = q);
          let ie = this.createElement("image").attr(ne), re = function(de) {
            ie.attr({ href: G }), Z.call(ie, de);
          };
          if (Z) {
            ie.attr({ href: "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==" });
            let de = new j.Image();
            N(de, "load", re), de.src = G, de.complete && re({});
          } else
            ie.attr({ href: G });
          return ie;
        }
        symbol(G, W, ae, z, q, Z) {
          let ne, ie, re, de, me = this, ce = /^url\((.*?)\)$/, pe = ce.test(G), xe = !pe && (this.symbols[G] ? G : "circle"), le = xe && this.symbols[xe];
          if (le)
            typeof W == "number" && (ie = le.call(this.symbols, W || 0, ae || 0, z || 0, q || 0, Z)), ne = this.path(ie), me.styledMode || ne.attr("fill", "none"), B(ne, { symbolName: xe || void 0, x: W, y: ae, width: z, height: q }), Z && B(ne, Z);
          else if (pe) {
            re = G.match(ce)[1];
            let se = ne = this.image(re);
            se.imgwidth = F(Z && Z.width, $[re] && $[re].width), se.imgheight = F(Z && Z.height, $[re] && $[re].height), de = (he) => he.attr({ width: he.width, height: he.height }), ["width", "height"].forEach((he) => {
              se[`${he}Setter`] = function(ve, ye) {
                this[ye] = ve;
                let { alignByTranslate: be, element: ke, width: we, height: Le, imgwidth: Me, imgheight: De } = this, Ae = ye === "width" ? Me : De, _e = 1;
                Z && Z.backgroundSize === "within" && we && Le && Me && De ? (_e = Math.min(we / Me, Le / De), M(ke, { width: Math.round(Me * _e), height: Math.round(De * _e) })) : ke && Ae && ke.setAttribute(ye, Ae), !be && Me && De && this.translate(((we || 0) - Me * _e) / 2, ((Le || 0) - De * _e) / 2);
              };
            }), p(W) && se.attr({ x: W, y: ae }), se.isImg = !0, se.symbolUrl = G, p(se.imgwidth) && p(se.imgheight) ? de(se) : (se.attr({ width: 0, height: 0 }), D("img", { onload: function() {
              let he = v[me.chartIndex];
              this.width === 0 && (b(this, { position: "absolute", top: "-999em" }), f.body.appendChild(this)), $[re] = { width: this.width, height: this.height }, se.imgwidth = this.width, se.imgheight = this.height, se.element && de(se), this.parentNode && this.parentNode.removeChild(this), me.imgCount--, me.imgCount || !he || he.hasLoaded || he.onload();
            }, src: re }), this.imgCount++);
          }
          return ne;
        }
        clipRect(G, W, ae, z) {
          return this.rect(G, W, ae, z, 0);
        }
        text(G, W, ae, z) {
          let q = {};
          if (z && (this.allowHTML || !this.forExport))
            return this.html(G, W, ae);
          q.x = Math.round(W || 0), ae && (q.y = Math.round(ae)), p(G) && (q.text = G);
          let Z = this.createElement("text").attr(q);
          return z && (!this.forExport || this.allowHTML) || (Z.xSetter = function(ne, ie, re) {
            let de = re.getElementsByTagName("tspan"), me = re.getAttribute(ie);
            for (let ce = 0, pe; ce < de.length; ce++)
              (pe = de[ce]).getAttribute(ie) === me && pe.setAttribute(ie, ne);
            re.setAttribute(ie, ne);
          }), Z;
        }
        fontMetrics(G) {
          let W = U(d.prototype.getStyle.call(G, "font-size") || 0), ae = W < 24 ? W + 3 : Math.round(1.2 * W), z = Math.round(0.8 * ae);
          return { h: ae, b: z, f: W };
        }
        rotCorr(G, W, ae) {
          let z = G;
          return W && ae && (z = Math.max(z * Math.cos(W * P), 4)), { x: -G / 3 * Math.sin(W * P), y: z };
        }
        pathToSegments(G) {
          let W = [], ae = [], z = { A: 8, C: 7, H: 2, L: 3, M: 3, Q: 5, S: 5, T: 3, V: 2 };
          for (let q = 0; q < G.length; q++)
            R(ae[0]) && O(G[q]) && ae.length === z[ae[0].toUpperCase()] && G.splice(q, 0, ae[0].replace("M", "L").replace("m", "l")), typeof G[q] == "string" && (ae.length && W.push(ae.slice(0)), ae.length = 0), ae.push(G[q]);
          return W.push(ae.slice(0)), W;
        }
        label(G, W, ae, z, q, Z, ne, ie, re) {
          return new y(this, G, W, ae, z, q, Z, ne, ie, re);
        }
        alignElements() {
          this.alignedObjects.forEach((G) => G.align());
        }
      }
      return B(ee.prototype, { Element: d, SVG_NS: A, escapes: { "&": "&amp;", "<": "&lt;", ">": "&gt;", "'": "&#39;", '"': "&quot;" }, symbols: u, draw: k }), l.registerRendererType("svg", ee, !0), ee;
    }), i(n, "Core/Renderer/HTML/HTMLElement.js", [n["Core/Renderer/HTML/AST.js"], n["Core/Globals.js"], n["Core/Renderer/SVG/SVGElement.js"], n["Core/Utilities.js"]], function(o, a, r, s) {
      let { composed: l } = a, { attr: d, css: y, createElement: u, defined: m, extend: h, pInt: c, pushUnique: g } = s;
      function v(w, x, k) {
        let A = this.div?.style || k.style;
        r.prototype[`${x}Setter`].call(this, w, x, k), A && (A[x] = w);
      }
      let P = (w, x) => {
        if (!w.div) {
          let k = d(w.element, "class"), A = w.css, $ = u("div", k ? { className: k } : void 0, { position: "absolute", left: `${w.translateX || 0}px`, top: `${w.translateY || 0}px`, ...w.styles, display: w.display, opacity: w.opacity, visibility: w.visibility }, w.parentGroup?.div || x);
          w.classSetter = (j, N, M) => {
            M.setAttribute("class", j), $.className = j;
          }, w.translateXSetter = w.translateYSetter = (j, N) => {
            w[N] = j, $.style[N === "translateX" ? "left" : "top"] = `${j}px`, w.doTransform = !0;
          }, w.opacitySetter = w.visibilitySetter = v, w.css = (j) => (A.call(w, j), j.cursor && ($.style.cursor = j.cursor), j.pointerEvents && ($.style.pointerEvents = j.pointerEvents), w), w.on = function() {
            return r.prototype.on.apply({ element: $, onEvents: w.onEvents }, arguments), w;
          }, w.div = $;
        }
        return w.div;
      };
      class f extends r {
        static compose(x) {
          g(l, this.compose) && (x.prototype.html = function(k, A, $) {
            return new f(this, "span").attr({ text: k, x: Math.round(A), y: Math.round($) });
          });
        }
        constructor(x, k) {
          super(x, k), this.css({ position: "absolute", ...x.styledMode ? {} : { fontFamily: x.style.fontFamily, fontSize: x.style.fontSize } }), this.element.style.whiteSpace = "nowrap";
        }
        getSpanCorrection(x, k, A) {
          this.xCorr = -x * A, this.yCorr = -k;
        }
        css(x) {
          let k, { element: A } = this, $ = A.tagName === "SPAN" && x && "width" in x, j = $ && x.width;
          return $ && (delete x.width, this.textWidth = c(j) || void 0, k = !0), x?.textOverflow === "ellipsis" && (x.whiteSpace = "nowrap", x.overflow = "hidden"), h(this.styles, x), y(A, x), k && this.updateTransform(), this;
        }
        htmlGetBBox() {
          let { element: x } = this;
          return { x: x.offsetLeft, y: x.offsetTop, width: x.offsetWidth, height: x.offsetHeight };
        }
        updateTransform() {
          if (!this.added) {
            this.alignOnAdd = !0;
            return;
          }
          let { element: x, renderer: k, rotation: A, rotationOriginX: $, rotationOriginY: j, styles: N, textAlign: M = "left", textWidth: D, translateX: C = 0, translateY: b = 0, x: p = 0, y: L = 0 } = this, B = { left: 0, center: 0.5, right: 1 }[M], T = N.whiteSpace;
          if (y(x, { marginLeft: `${C}px`, marginTop: `${b}px` }), x.tagName === "SPAN") {
            let O = [A, M, x.innerHTML, D, this.textAlign].join(","), I = -(this.parentGroup?.padding * 1) || 0, R, Y = !1;
            if (D !== this.oldTextWidth) {
              let ee = this.textPxLength ? this.textPxLength : (y(x, { width: "", whiteSpace: T || "nowrap" }), x.offsetWidth), V = D || 0;
              (V > this.oldTextWidth || ee > V) && (/[ \-]/.test(x.textContent || x.innerText) || x.style.textOverflow === "ellipsis") && (y(x, { width: ee > V || A ? D + "px" : "auto", display: "block", whiteSpace: T || "normal" }), this.oldTextWidth = D, Y = !0);
            }
            this.hasBoxWidthChanged = Y, O !== this.cTT && (R = k.fontMetrics(x).b, m(A) && (A !== (this.oldRotation || 0) || M !== this.oldAlign) && this.setSpanRotation(A, I, I), this.getSpanCorrection(!m(A) && this.textPxLength || x.offsetWidth, R, B));
            let { xCorr: F = 0, yCorr: U = 0 } = this, Q = ($ ?? p) - F - p - I, J = (j ?? L) - U - L - I;
            y(x, { left: `${p + F}px`, top: `${L + U}px`, transformOrigin: `${Q}px ${J}px` }), this.cTT = O, this.oldRotation = A, this.oldAlign = M;
          }
        }
        setSpanRotation(x, k, A) {
          y(this.element, { transform: `rotate(${x}deg)`, transformOrigin: `${k}% ${A}px` });
        }
        add(x) {
          let k, A = this.renderer.box.parentNode, $ = [];
          if (this.parentGroup = x, x && !(k = x.div)) {
            let j = x;
            for (; j; )
              $.push(j), j = j.parentGroup;
            for (let N of $.reverse())
              k = P(N, A);
          }
          return (k || A).appendChild(this.element), this.added = !0, this.alignOnAdd && this.updateTransform(), this;
        }
        textSetter(x) {
          x !== this.textStr && (delete this.bBox, delete this.oldTextWidth, o.setElementHTML(this.element, x ?? ""), this.textStr = x, this.doTransform = !0);
        }
        alignSetter(x) {
          this.alignValue = this.textAlign = x, this.doTransform = !0;
        }
        xSetter(x, k) {
          this[k] = x, this.doTransform = !0;
        }
      }
      let S = f.prototype;
      return S.visibilitySetter = S.opacitySetter = v, S.ySetter = S.rotationSetter = S.rotationOriginXSetter = S.rotationOriginYSetter = S.xSetter, f;
    }), i(n, "Core/Axis/AxisDefaults.js", [], function() {
      var o, a;
      return (a = o || (o = {})).xAxis = { alignTicks: !0, allowDecimals: void 0, panningEnabled: !0, zIndex: 2, zoomEnabled: !0, dateTimeLabelFormats: { millisecond: { main: "%H:%M:%S.%L", range: !1 }, second: { main: "%H:%M:%S", range: !1 }, minute: { main: "%H:%M", range: !1 }, hour: { main: "%H:%M", range: !1 }, day: { main: "%e %b" }, week: { main: "%e %b" }, month: { main: "%b '%y" }, year: { main: "%Y" } }, endOnTick: !1, gridLineDashStyle: "Solid", gridZIndex: 1, labels: { autoRotationLimit: 80, distance: 15, enabled: !0, indentation: 10, overflow: "justify", reserveSpace: void 0, rotation: void 0, staggerLines: 0, step: 0, useHTML: !1, zIndex: 7, style: { color: "#333333", cursor: "default", fontSize: "0.8em" } }, maxPadding: 0.01, minorGridLineDashStyle: "Solid", minorTickLength: 2, minorTickPosition: "outside", minorTicksPerMajor: 5, minPadding: 0.01, offset: void 0, reversed: void 0, reversedStacks: !1, showEmpty: !0, showFirstLabel: !0, showLastLabel: !0, startOfWeek: 1, startOnTick: !1, tickLength: 10, tickPixelInterval: 100, tickmarkPlacement: "between", tickPosition: "outside", title: { align: "middle", useHTML: !1, x: 0, y: 0, style: { color: "#666666", fontSize: "0.8em" } }, visible: !0, minorGridLineColor: "#f2f2f2", minorGridLineWidth: 1, minorTickColor: "#999999", lineColor: "#333333", lineWidth: 1, gridLineColor: "#e6e6e6", gridLineWidth: void 0, tickColor: "#333333" }, a.yAxis = { reversedStacks: !0, endOnTick: !0, maxPadding: 0.05, minPadding: 0.05, tickPixelInterval: 72, showLastLabel: !0, labels: { x: void 0 }, startOnTick: !0, title: { text: "Values" }, stackLabels: { animation: {}, allowOverlap: !1, enabled: !1, crop: !0, overflow: "justify", formatter: function() {
        let { numberFormatter: r } = this.axis.chart;
        return r(this.total || 0, -1);
      }, style: { color: "#000000", fontSize: "0.7em", fontWeight: "bold", textOutline: "1px contrast" } }, gridLineWidth: 1, lineWidth: 0 }, o;
    }), i(n, "Core/Foundation.js", [n["Core/Utilities.js"]], function(o) {
      var a;
      let { addEvent: r, isFunction: s, objectEach: l, removeEvent: d } = o;
      return (a || (a = {})).registerEventOptions = function(y, u) {
        y.eventOptions = y.eventOptions || {}, l(u.events, function(m, h) {
          y.eventOptions[h] !== m && (y.eventOptions[h] && (d(y, h, y.eventOptions[h]), delete y.eventOptions[h]), s(m) && (y.eventOptions[h] = m, r(y, h, m, { order: 0 })));
        });
      }, a;
    }), i(n, "Core/Axis/Tick.js", [n["Core/Templating.js"], n["Core/Globals.js"], n["Core/Utilities.js"]], function(o, a, r) {
      let { deg2rad: s } = a, { clamp: l, correctFloat: d, defined: y, destroyObjectProperties: u, extend: m, fireEvent: h, isNumber: c, merge: g, objectEach: v, pick: P } = r;
      return class {
        constructor(f, S, w, x, k) {
          this.isNew = !0, this.isNewLabel = !0, this.axis = f, this.pos = S, this.type = w || "", this.parameters = k || {}, this.tickmarkOffset = this.parameters.tickmarkOffset, this.options = this.parameters.options, h(this, "init"), w || x || this.addLabel();
        }
        addLabel() {
          let f = this, S = f.axis, w = S.options, x = S.chart, k = S.categories, A = S.logarithmic, $ = S.names, j = f.pos, N = P(f.options && f.options.labels, w.labels), M = S.tickPositions, D = j === M[0], C = j === M[M.length - 1], b = (!N.step || N.step === 1) && S.tickInterval === 1, p = M.info, L = f.label, B, T, O, I = this.parameters.category || (k ? P(k[j], $[j], j) : j);
          A && c(I) && (I = d(A.lin2log(I))), S.dateTime && (p ? B = (T = x.time.resolveDTLFormat(w.dateTimeLabelFormats[!w.grid && p.higherRanks[j] || p.unitName])).main : c(I) && (B = S.dateTime.getXDateFormat(I, w.dateTimeLabelFormats || {}))), f.isFirst = D, f.isLast = C;
          let R = { axis: S, chart: x, dateTimeLabelFormat: B, isFirst: D, isLast: C, pos: j, tick: f, tickPositionInfo: p, value: I };
          h(this, "labelFormat", R);
          let Y = (Q) => N.formatter ? N.formatter.call(Q, Q) : N.format ? (Q.text = S.defaultLabelFormatter.call(Q), o.format(N.format, Q, x)) : S.defaultLabelFormatter.call(Q), F = Y.call(R, R), U = T && T.list;
          U ? f.shortenLabel = function() {
            for (O = 0; O < U.length; O++)
              if (m(R, { dateTimeLabelFormat: U[O] }), L.attr({ text: Y.call(R, R) }), L.getBBox().width < S.getSlotWidth(f) - 2 * (N.padding || 0))
                return;
            L.attr({ text: "" });
          } : f.shortenLabel = void 0, b && S._addedPlotLB && f.moveLabel(F, N), y(L) || f.movedLabel ? L && L.textStr !== F && !b && (!L.textWidth || N.style.width || L.styles.width || L.css({ width: null }), L.attr({ text: F }), L.textPxLength = L.getBBox().width) : (f.label = L = f.createLabel(F, N), f.rotation = 0);
        }
        createLabel(f, S, w) {
          let x = this.axis, k = x.chart, A = y(f) && S.enabled ? k.renderer.text(f, w?.x, w?.y, S.useHTML).add(x.labelGroup) : void 0;
          return A && (k.styledMode || A.css(g(S.style)), A.textPxLength = A.getBBox().width), A;
        }
        destroy() {
          u(this, this.axis);
        }
        getPosition(f, S, w, x) {
          let k = this.axis, A = k.chart, $ = x && A.oldChartHeight || A.chartHeight, j = { x: f ? d(k.translate(S + w, void 0, void 0, x) + k.transB) : k.left + k.offset + (k.opposite ? (x && A.oldChartWidth || A.chartWidth) - k.right - k.left : 0), y: f ? $ - k.bottom + k.offset - (k.opposite ? k.height : 0) : d($ - k.translate(S + w, void 0, void 0, x) - k.transB) };
          return j.y = l(j.y, -1e9, 1e9), h(this, "afterGetPosition", { pos: j }), j;
        }
        getLabelPosition(f, S, w, x, k, A, $, j) {
          let N, M, D = this.axis, C = D.transA, b = D.isLinked && D.linkedParent ? D.linkedParent.reversed : D.reversed, p = D.staggerLines, L = D.tickRotCorr || { x: 0, y: 0 }, B = x || D.reserveSpaceDefault ? 0 : -D.labelOffset * (D.labelAlign === "center" ? 0.5 : 1), T = k.distance, O = {};
          return N = D.side === 0 ? w.rotation ? -T : -w.getBBox().height : D.side === 2 ? L.y + T : Math.cos(w.rotation * s) * (L.y - w.getBBox(!1, 0).height / 2), y(k.y) && (N = D.side === 0 && D.horiz ? k.y + N : k.y), f = f + P(k.x, [0, 1, 0, -1][D.side] * T) + B + L.x - (A && x ? A * C * (b ? -1 : 1) : 0), S = S + N - (A && !x ? A * C * (b ? 1 : -1) : 0), p && (M = $ / (j || 1) % p, D.opposite && (M = p - M - 1), S += M * (D.labelOffset / p)), O.x = f, O.y = Math.round(S), h(this, "afterGetLabelPosition", { pos: O, tickmarkOffset: A, index: $ }), O;
        }
        getLabelSize() {
          return this.label ? this.label.getBBox()[this.axis.horiz ? "height" : "width"] : 0;
        }
        getMarkPath(f, S, w, x, k = !1, A) {
          return A.crispLine([["M", f, S], ["L", f + (k ? 0 : -w), S + (k ? w : 0)]], x);
        }
        handleOverflow(f) {
          let S = this.axis, w = S.options.labels, x = f.x, k = S.chart.chartWidth, A = S.chart.spacing, $ = P(S.labelLeft, Math.min(S.pos, A[3])), j = P(S.labelRight, Math.max(S.isRadial ? 0 : S.pos + S.len, k - A[1])), N = this.label, M = this.rotation, D = { left: 0, center: 0.5, right: 1 }[S.labelAlign || N.attr("align")], C = N.getBBox().width, b = S.getSlotWidth(this), p = {}, L = b, B = 1, T, O, I;
          M || w.overflow !== "justify" ? M < 0 && x - D * C < $ ? I = Math.round(x / Math.cos(M * s) - $) : M > 0 && x + D * C > j && (I = Math.round((k - x) / Math.cos(M * s))) : (T = x - D * C, O = x + (1 - D) * C, T < $ ? L = f.x + L * (1 - D) - $ : O > j && (L = j - f.x + L * D, B = -1), (L = Math.min(b, L)) < b && S.labelAlign === "center" && (f.x += B * (b - L - D * (b - Math.min(C, L)))), (C > L || S.autoRotation && (N.styles || {}).width) && (I = L)), I && (this.shortenLabel ? this.shortenLabel() : (p.width = Math.floor(I) + "px", (w.style || {}).textOverflow || (p.textOverflow = "ellipsis"), N.css(p)));
        }
        moveLabel(f, S) {
          let w = this, x = w.label, k = w.axis, A = !1, $;
          x && x.textStr === f ? (w.movedLabel = x, A = !0, delete w.label) : v(k.ticks, function(j) {
            A || j.isNew || j === w || !j.label || j.label.textStr !== f || (w.movedLabel = j.label, A = !0, j.labelPos = w.movedLabel.xy, delete j.label);
          }), !A && (w.labelPos || x) && ($ = w.labelPos || x.xy, w.movedLabel = w.createLabel(f, S, $), w.movedLabel && w.movedLabel.attr({ opacity: 0 }));
        }
        render(f, S, w) {
          let x = this.axis, k = x.horiz, A = this.pos, $ = P(this.tickmarkOffset, x.tickmarkOffset), j = this.getPosition(k, A, $, S), N = j.x, M = j.y, D = x.pos, C = D + x.len, b = k ? N : M;
          !x.chart.polar && this.isNew && (d(b) < D || b > C) && (w = 0);
          let p = P(w, this.label && this.label.newOpacity, 1);
          w = P(w, 1), this.isActive = !0, this.renderGridLine(S, w), this.renderMark(j, w), this.renderLabel(j, S, p, f), this.isNew = !1, h(this, "afterRender");
        }
        renderGridLine(f, S) {
          let w = this.axis, x = w.options, k = {}, A = this.pos, $ = this.type, j = P(this.tickmarkOffset, w.tickmarkOffset), N = w.chart.renderer, M = this.gridLine, D, C = x.gridLineWidth, b = x.gridLineColor, p = x.gridLineDashStyle;
          this.type === "minor" && (C = x.minorGridLineWidth, b = x.minorGridLineColor, p = x.minorGridLineDashStyle), M || (w.chart.styledMode || (k.stroke = b, k["stroke-width"] = C || 0, k.dashstyle = p), $ || (k.zIndex = 1), f && (S = 0), this.gridLine = M = N.path().attr(k).addClass("highcharts-" + ($ ? $ + "-" : "") + "grid-line").add(w.gridGroup)), M && (D = w.getPlotLinePath({ value: A + j, lineWidth: M.strokeWidth(), force: "pass", old: f, acrossPanes: !1 })) && M[f || this.isNew ? "attr" : "animate"]({ d: D, opacity: S });
        }
        renderMark(f, S) {
          let w = this.axis, x = w.options, k = w.chart.renderer, A = this.type, $ = w.tickSize(A ? A + "Tick" : "tick"), j = f.x, N = f.y, M = P(x[A !== "minor" ? "tickWidth" : "minorTickWidth"], !A && w.isXAxis ? 1 : 0), D = x[A !== "minor" ? "tickColor" : "minorTickColor"], C = this.mark, b = !C;
          $ && (w.opposite && ($[0] = -$[0]), C || (this.mark = C = k.path().addClass("highcharts-" + (A ? A + "-" : "") + "tick").add(w.axisGroup), w.chart.styledMode || C.attr({ stroke: D, "stroke-width": M })), C[b ? "attr" : "animate"]({ d: this.getMarkPath(j, N, $[0], C.strokeWidth(), w.horiz, k), opacity: S }));
        }
        renderLabel(f, S, w, x) {
          let k = this.axis, A = k.horiz, $ = k.options, j = this.label, N = $.labels, M = N.step, D = P(this.tickmarkOffset, k.tickmarkOffset), C = f.x, b = f.y, p = !0;
          j && c(C) && (j.xy = f = this.getLabelPosition(C, b, j, A, N, D, x, M), (!this.isFirst || this.isLast || $.showFirstLabel) && (!this.isLast || this.isFirst || $.showLastLabel) ? !A || N.step || N.rotation || S || w === 0 || this.handleOverflow(f) : p = !1, M && x % M && (p = !1), p && c(f.y) ? (f.opacity = w, j[this.isNewLabel ? "attr" : "animate"](f).show(!0), this.isNewLabel = !1) : (j.hide(), this.isNewLabel = !0));
        }
        replaceMovedLabel() {
          let f = this.label, S = this.axis;
          f && !this.isNew && (f.animate({ opacity: 0 }, void 0, f.destroy), delete this.label), S.isDirty = !0, this.label = this.movedLabel, delete this.movedLabel;
        }
      };
    }), i(n, "Core/Axis/Axis.js", [n["Core/Animation/AnimationUtilities.js"], n["Core/Axis/AxisDefaults.js"], n["Core/Color/Color.js"], n["Core/Defaults.js"], n["Core/Foundation.js"], n["Core/Globals.js"], n["Core/Axis/Tick.js"], n["Core/Utilities.js"]], function(o, a, r, s, l, d, y, u) {
      let { animObject: m } = o, { xAxis: h, yAxis: c } = a, { defaultOptions: g } = s, { registerEventOptions: v } = l, { deg2rad: P } = d, { arrayMax: f, arrayMin: S, clamp: w, correctFloat: x, defined: k, destroyObjectProperties: A, erase: $, error: j, extend: N, fireEvent: M, getClosestDistance: D, insertItem: C, isArray: b, isNumber: p, isString: L, merge: B, normalizeTickInterval: T, objectEach: O, pick: I, relativeLength: R, removeEvent: Y, splat: F, syncTimeout: U } = u, Q = (ee, V) => T(V, void 0, void 0, I(ee.options.allowDecimals, V < 0.5 || ee.tickAmount !== void 0), !!ee.tickAmount);
      N(g, { xAxis: h, yAxis: B(h, c) });
      class J {
        constructor(V, G, W) {
          this.init(V, G, W);
        }
        init(V, G, W = this.coll) {
          let ae = W === "xAxis", z = this.isZAxis || (V.inverted ? !ae : ae);
          this.chart = V, this.horiz = z, this.isXAxis = ae, this.coll = W, M(this, "init", { userOptions: G }), this.opposite = I(G.opposite, this.opposite), this.side = I(G.side, this.side, z ? this.opposite ? 0 : 2 : this.opposite ? 1 : 3), this.setOptions(G);
          let q = this.options, Z = q.labels;
          this.type ?? (this.type = q.type || "linear"), this.uniqueNames ?? (this.uniqueNames = q.uniqueNames ?? !0), M(this, "afterSetType"), this.userOptions = G, this.minPixelPadding = 0, this.reversed = I(q.reversed, this.reversed), this.visible = q.visible, this.zoomEnabled = q.zoomEnabled, this.hasNames = this.type === "category" || q.categories === !0, this.categories = b(q.categories) && q.categories || (this.hasNames ? [] : void 0), this.names || (this.names = [], this.names.keys = {}), this.plotLinesAndBandsGroups = {}, this.positiveValuesOnly = !!this.logarithmic, this.isLinked = k(q.linkedTo), this.ticks = {}, this.labelEdge = [], this.minorTicks = {}, this.plotLinesAndBands = [], this.alternateBands = {}, this.len ?? (this.len = 0), this.minRange = this.userMinRange = q.minRange || q.maxZoom, this.range = q.range, this.offset = q.offset || 0, this.max = void 0, this.min = void 0;
          let ne = I(q.crosshair, F(V.options.tooltip.crosshairs)[ae ? 0 : 1]);
          this.crosshair = ne === !0 ? {} : ne, V.axes.indexOf(this) === -1 && (ae ? V.axes.splice(V.xAxis.length, 0, this) : V.axes.push(this), C(this, V[this.coll])), V.orderItems(this.coll), this.series = this.series || [], V.inverted && !this.isZAxis && ae && !k(this.reversed) && (this.reversed = !0), this.labelRotation = p(Z.rotation) ? Z.rotation : void 0, v(this, q), M(this, "afterInit");
        }
        setOptions(V) {
          let G = this.horiz ? { labels: { autoRotation: [-45], padding: 4 }, margin: 15 } : { labels: { padding: 1 }, title: { rotation: 90 * this.side } };
          this.options = B(G, g[this.coll], V), M(this, "afterSetOptions", { userOptions: V });
        }
        defaultLabelFormatter() {
          let V = this.axis, { numberFormatter: G } = this.chart, W = p(this.value) ? this.value : NaN, ae = V.chart.time, z = V.categories, q = this.dateTimeLabelFormat, Z = g.lang, ne = Z.numericSymbols, ie = Z.numericSymbolMagnitude || 1e3, re = V.logarithmic ? Math.abs(W) : V.tickInterval, de = ne && ne.length, me, ce;
          if (z)
            ce = `${this.value}`;
          else if (q)
            ce = ae.dateFormat(q, W);
          else if (de && ne && re >= 1e3)
            for (; de-- && ce === void 0; )
              re >= (me = Math.pow(ie, de + 1)) && 10 * W % me == 0 && ne[de] !== null && W !== 0 && (ce = G(W / me, -1) + ne[de]);
          return ce === void 0 && (ce = Math.abs(W) >= 1e4 ? G(W, -1) : G(W, -1, void 0, "")), ce;
        }
        getSeriesExtremes() {
          let V, G = this;
          M(this, "getSeriesExtremes", null, function() {
            G.hasVisibleSeries = !1, G.dataMin = G.dataMax = G.threshold = void 0, G.softThreshold = !G.isXAxis, G.series.forEach((W) => {
              if (W.reserveSpace()) {
                let ae = W.options, z, q = ae.threshold, Z, ne;
                if (G.hasVisibleSeries = !0, G.positiveValuesOnly && 0 >= (q || 0) && (q = void 0), G.isXAxis)
                  (z = W.xData) && z.length && (z = G.logarithmic ? z.filter((ie) => ie > 0) : z, Z = (V = W.getXExtremes(z)).min, ne = V.max, p(Z) || Z instanceof Date || (z = z.filter(p), Z = (V = W.getXExtremes(z)).min, ne = V.max), z.length && (G.dataMin = Math.min(I(G.dataMin, Z), Z), G.dataMax = Math.max(I(G.dataMax, ne), ne)));
                else {
                  let ie = W.applyExtremes();
                  p(ie.dataMin) && (Z = ie.dataMin, G.dataMin = Math.min(I(G.dataMin, Z), Z)), p(ie.dataMax) && (ne = ie.dataMax, G.dataMax = Math.max(I(G.dataMax, ne), ne)), k(q) && (G.threshold = q), (!ae.softThreshold || G.positiveValuesOnly) && (G.softThreshold = !1);
                }
              }
            });
          }), M(this, "afterGetSeriesExtremes");
        }
        translate(V, G, W, ae, z, q) {
          let Z = this.linkedParent || this, ne = ae && Z.old ? Z.old.min : Z.min;
          if (!p(ne))
            return NaN;
          let ie = Z.minPixelPadding, re = (Z.isOrdinal || Z.brokenAxis?.hasBreaks || Z.logarithmic && z) && Z.lin2val, de = 1, me = 0, ce = ae && Z.old ? Z.old.transA : Z.transA, pe = 0;
          return ce || (ce = Z.transA), W && (de *= -1, me = Z.len), Z.reversed && (de *= -1, me -= de * (Z.sector || Z.len)), G ? (pe = (V = V * de + me - ie) / ce + ne, re && (pe = Z.lin2val(pe))) : (re && (V = Z.val2lin(V)), pe = de * (V - ne) * ce + me + de * ie + (p(q) ? ce * q : 0), Z.isRadial || (pe = x(pe))), pe;
        }
        toPixels(V, G) {
          return this.translate(V, !1, !this.horiz, void 0, !0) + (G ? 0 : this.pos);
        }
        toValue(V, G) {
          return this.translate(V - (G ? 0 : this.pos), !0, !this.horiz, void 0, !0);
        }
        getPlotLinePath(V) {
          let G = this, W = G.chart, ae = G.left, z = G.top, q = V.old, Z = V.value, ne = V.lineWidth, ie = q && W.oldChartHeight || W.chartHeight, re = q && W.oldChartWidth || W.chartWidth, de = G.transB, me = V.translatedValue, ce = V.force, pe, xe, le, se, he;
          function ve(be, ke, we) {
            return ce !== "pass" && (be < ke || be > we) && (ce ? be = w(be, ke, we) : he = !0), be;
          }
          let ye = { value: Z, lineWidth: ne, old: q, force: ce, acrossPanes: V.acrossPanes, translatedValue: me };
          return M(this, "getPlotLinePath", ye, function(be) {
            pe = le = (me = w(me = I(me, G.translate(Z, void 0, void 0, q)), -1e9, 1e9)) + de, xe = se = ie - me - de, p(me) ? G.horiz ? (xe = z, se = ie - G.bottom + (G.options.isInternal ? 0 : W.scrollablePixelsY || 0), pe = le = ve(pe, ae, ae + G.width)) : (pe = ae, le = re - G.right + (W.scrollablePixelsX || 0), xe = se = ve(xe, z, z + G.height)) : (he = !0, ce = !1), be.path = he && !ce ? void 0 : W.renderer.crispLine([["M", pe, xe], ["L", le, se]], ne || 1);
          }), ye.path;
        }
        getLinearTickPositions(V, G, W) {
          let ae, z, q, Z = x(Math.floor(G / V) * V), ne = x(Math.ceil(W / V) * V), ie = [];
          if (x(Z + V) === Z && (q = 20), this.single)
            return [G];
          for (ae = Z; ae <= ne && (ie.push(ae), (ae = x(ae + V, q)) !== z); )
            z = ae;
          return ie;
        }
        getMinorTickInterval() {
          let { minorTicks: V, minorTickInterval: G } = this.options;
          return V === !0 ? I(G, "auto") : V !== !1 ? G : void 0;
        }
        getMinorTickPositions() {
          let V = this.options, G = this.tickPositions, W = this.minorTickInterval, ae = this.pointRangePadding || 0, z = (this.min || 0) - ae, q = (this.max || 0) + ae, Z = q - z, ne = [], ie;
          if (Z && Z / W < this.len / 3) {
            let re = this.logarithmic;
            if (re)
              this.paddedTicks.forEach(function(de, me, ce) {
                me && ne.push.apply(ne, re.getLogTickPositions(W, ce[me - 1], ce[me], !0));
              });
            else if (this.dateTime && this.getMinorTickInterval() === "auto")
              ne = ne.concat(this.getTimeTicks(this.dateTime.normalizeTimeTickInterval(W), z, q, V.startOfWeek));
            else
              for (ie = z + (G[0] - z) % W; ie <= q && ie !== ne[0]; ie += W)
                ne.push(ie);
          }
          return ne.length !== 0 && this.trimTicks(ne), ne;
        }
        adjustForMinRange() {
          let V = this.options, G = this.logarithmic, { max: W, min: ae, minRange: z } = this, q, Z, ne, ie;
          this.isXAxis && z === void 0 && !G && (z = k(V.min) || k(V.max) || k(V.floor) || k(V.ceiling) ? null : Math.min(5 * (D(this.series.map((re) => (re.xIncrement ? re.xData?.slice(0, 2) : re.xData) || [])) || 0), this.dataMax - this.dataMin)), p(W) && p(ae) && p(z) && W - ae < z && (Z = this.dataMax - this.dataMin >= z, q = (z - W + ae) / 2, ne = [ae - q, I(V.min, ae - q)], Z && (ne[2] = G ? G.log2lin(this.dataMin) : this.dataMin), ie = [(ae = f(ne)) + z, I(V.max, ae + z)], Z && (ie[2] = G ? G.log2lin(this.dataMax) : this.dataMax), (W = S(ie)) - ae < z && (ne[0] = W - z, ne[1] = I(V.min, W - z), ae = f(ne))), this.minRange = z, this.min = ae, this.max = W;
        }
        getClosest() {
          let V, G;
          if (this.categories)
            G = 1;
          else {
            let W = [];
            this.series.forEach(function(ae) {
              let z = ae.closestPointRange;
              ae.xData?.length === 1 ? W.push(ae.xData[0]) : !ae.noSharedTooltip && k(z) && ae.reserveSpace() && (G = k(G) ? Math.min(G, z) : z);
            }), W.length && (W.sort((ae, z) => ae - z), V = D([W]));
          }
          return V && G ? Math.min(V, G) : V || G;
        }
        nameToX(V) {
          let G = b(this.options.categories), W = G ? this.categories : this.names, ae = V.options.x, z;
          return V.series.requireSorting = !1, k(ae) || (ae = this.uniqueNames && W ? G ? W.indexOf(V.name) : I(W.keys[V.name], -1) : V.series.autoIncrement()), ae === -1 ? !G && W && (z = W.length) : z = ae, z !== void 0 ? (this.names[z] = V.name, this.names.keys[V.name] = z) : V.x && (z = V.x), z;
        }
        updateNames() {
          let V = this, G = this.names;
          G.length > 0 && (Object.keys(G.keys).forEach(function(W) {
            delete G.keys[W];
          }), G.length = 0, this.minRange = this.userMinRange, (this.series || []).forEach((W) => {
            W.xIncrement = null, (!W.points || W.isDirtyData) && (V.max = Math.max(V.max, W.xData.length - 1), W.processData(), W.generatePoints()), W.data.forEach(function(ae, z) {
              let q;
              ae?.options && ae.name !== void 0 && (q = V.nameToX(ae)) !== void 0 && q !== ae.x && (ae.x = q, W.xData[z] = q);
            });
          }));
        }
        setAxisTranslation() {
          let V = this, G = V.max - V.min, W = V.linkedParent, ae = !!V.categories, z = V.isXAxis, q = V.axisPointRange || 0, Z, ne = 0, ie = 0, re, de = V.transA;
          (z || ae || q) && (Z = V.getClosest(), W ? (ne = W.minPointOffset, ie = W.pointRangePadding) : V.series.forEach(function(me) {
            let ce = ae ? 1 : z ? I(me.options.pointRange, Z, 0) : V.axisPointRange || 0, pe = me.options.pointPlacement;
            if (q = Math.max(q, ce), !V.single || ae) {
              let xe = me.is("xrange") ? !z : z;
              ne = Math.max(ne, xe && L(pe) ? 0 : ce / 2), ie = Math.max(ie, xe && pe === "on" ? 0 : ce);
            }
          }), re = V.ordinal && V.ordinal.slope && Z ? V.ordinal.slope / Z : 1, V.minPointOffset = ne *= re, V.pointRangePadding = ie *= re, V.pointRange = Math.min(q, V.single && ae ? 1 : G), z && Z && (V.closestPointRange = Z)), V.translationSlope = V.transA = de = V.staticScale || V.len / (G + ie || 1), V.transB = V.horiz ? V.left : V.bottom, V.minPixelPadding = de * ne, M(this, "afterSetAxisTranslation");
        }
        minFromRange() {
          let { max: V, min: G } = this;
          return p(V) && p(G) && V - G || void 0;
        }
        setTickInterval(V) {
          let { categories: G, chart: W, dataMax: ae, dataMin: z, dateTime: q, isXAxis: Z, logarithmic: ne, options: ie, softThreshold: re } = this, de = p(this.threshold) ? this.threshold : void 0, me = this.minRange || 0, { ceiling: ce, floor: pe, linkedTo: xe, softMax: le, softMin: se } = ie, he = p(xe) && W[this.coll]?.[xe], ve = ie.tickPixelInterval, ye = ie.maxPadding, be = ie.minPadding, ke = 0, we, Le = p(ie.tickInterval) && ie.tickInterval >= 0 ? ie.tickInterval : void 0, Me, De, Ae, _e;
          if (q || G || he || this.getTickAmount(), Ae = I(this.userMin, ie.min), _e = I(this.userMax, ie.max), he ? (this.linkedParent = he, we = he.getExtremes(), this.min = I(we.min, we.dataMin), this.max = I(we.max, we.dataMax), this.type !== he.type && j(11, !0, W)) : (re && k(de) && p(ae) && p(z) && (z >= de ? (Me = de, be = 0) : ae <= de && (De = de, ye = 0)), this.min = I(Ae, Me, z), this.max = I(_e, De, ae)), p(this.max) && p(this.min) && (ne && (this.positiveValuesOnly && !V && 0 >= Math.min(this.min, I(z, this.min)) && j(10, !0, W), this.min = x(ne.log2lin(this.min), 16), this.max = x(ne.log2lin(this.max), 16)), this.range && p(z) && (this.userMin = this.min = Ae = Math.max(z, this.minFromRange() || 0), this.userMax = _e = this.max, this.range = void 0)), M(this, "foundExtremes"), this.adjustForMinRange(), p(this.min) && p(this.max)) {
            if (!p(this.userMin) && p(se) && se < this.min && (this.min = Ae = se), !p(this.userMax) && p(le) && le > this.max && (this.max = _e = le), G || this.axisPointRange || this.stacking?.usePercentage || he || !(ke = this.max - this.min) || (!k(Ae) && be && (this.min -= ke * be), k(_e) || !ye || (this.max += ke * ye)), !p(this.userMin) && p(pe) && (this.min = Math.max(this.min, pe)), !p(this.userMax) && p(ce) && (this.max = Math.min(this.max, ce)), re && p(z) && p(ae)) {
              let Ee = de || 0;
              !k(Ae) && this.min < Ee && z >= Ee ? this.min = ie.minRange ? Math.min(Ee, this.max - me) : Ee : !k(_e) && this.max > Ee && ae <= Ee && (this.max = ie.minRange ? Math.max(Ee, this.min + me) : Ee);
            }
            !W.polar && this.min > this.max && (k(ie.min) ? this.max = this.min : k(ie.max) && (this.min = this.max)), ke = this.max - this.min;
          }
          if (this.min !== this.max && p(this.min) && p(this.max) ? he && !Le && ve === he.options.tickPixelInterval ? this.tickInterval = Le = he.tickInterval : this.tickInterval = I(Le, this.tickAmount ? ke / Math.max(this.tickAmount - 1, 1) : void 0, G ? 1 : ke * ve / Math.max(this.len, ve)) : this.tickInterval = 1, Z && !V) {
            let Ee = this.min !== this.old?.min || this.max !== this.old?.max;
            this.series.forEach(function(Ne) {
              Ne.forceCrop = Ne.forceCropping?.(), Ne.processData(Ee);
            }), M(this, "postProcessData", { hasExtremesChanged: Ee });
          }
          this.setAxisTranslation(), M(this, "initialAxisTranslation"), this.pointRange && !Le && (this.tickInterval = Math.max(this.pointRange, this.tickInterval));
          let He = I(ie.minTickInterval, q && !this.series.some((Ee) => Ee.noSharedTooltip) ? this.closestPointRange : 0);
          !Le && this.tickInterval < He && (this.tickInterval = He), q || ne || Le || (this.tickInterval = Q(this, this.tickInterval)), this.tickAmount || (this.tickInterval = this.unsquish()), this.setTickPositions();
        }
        setTickPositions() {
          let V = this.options, G = V.tickPositions, W = V.tickPositioner, ae = this.getMinorTickInterval(), z = !this.isPanning, q = z && V.startOnTick, Z = z && V.endOnTick, ne = [], ie;
          if (this.tickmarkOffset = this.categories && V.tickmarkPlacement === "between" && this.tickInterval === 1 ? 0.5 : 0, this.single = this.min === this.max && k(this.min) && !this.tickAmount && (this.min % 1 == 0 || V.allowDecimals !== !1), G)
            ne = G.slice();
          else if (p(this.min) && p(this.max)) {
            if (!this.ordinal?.positions && (this.max - this.min) / this.tickInterval > Math.max(2 * this.len, 200))
              ne = [this.min, this.max], j(19, !1, this.chart);
            else if (this.dateTime)
              ne = this.getTimeTicks(this.dateTime.normalizeTimeTickInterval(this.tickInterval, V.units), this.min, this.max, V.startOfWeek, this.ordinal?.positions, this.closestPointRange, !0);
            else if (this.logarithmic)
              ne = this.logarithmic.getLogTickPositions(this.tickInterval, this.min, this.max);
            else {
              let re = this.tickInterval, de = re;
              for (; de <= 2 * re && (ne = this.getLinearTickPositions(this.tickInterval, this.min, this.max), this.tickAmount && ne.length > this.tickAmount); )
                this.tickInterval = Q(this, de *= 1.1);
            }
            ne.length > this.len && (ne = [ne[0], ne[ne.length - 1]])[0] === ne[1] && (ne.length = 1), W && (this.tickPositions = ne, (ie = W.apply(this, [this.min, this.max])) && (ne = ie));
          }
          this.tickPositions = ne, this.minorTickInterval = ae === "auto" && this.tickInterval ? this.tickInterval / V.minorTicksPerMajor : ae, this.paddedTicks = ne.slice(0), this.trimTicks(ne, q, Z), !this.isLinked && p(this.min) && p(this.max) && (this.single && ne.length < 2 && !this.categories && !this.series.some((re) => re.is("heatmap") && re.options.pointPlacement === "between") && (this.min -= 0.5, this.max += 0.5), G || ie || this.adjustTickAmount()), M(this, "afterSetTickPositions");
        }
        trimTicks(V, G, W) {
          let ae = V[0], z = V[V.length - 1], q = !this.isOrdinal && this.minPointOffset || 0;
          if (M(this, "trimTicks"), !this.isLinked) {
            if (G && ae !== -1 / 0)
              this.min = ae;
            else
              for (; this.min - q > V[0]; )
                V.shift();
            if (W)
              this.max = z;
            else
              for (; this.max + q < V[V.length - 1]; )
                V.pop();
            V.length === 0 && k(ae) && !this.options.tickPositions && V.push((z + ae) / 2);
          }
        }
        alignToOthers() {
          let V, G = this, W = G.chart, ae = [this], z = G.options, q = W.options.chart, Z = this.coll === "yAxis" && q.alignThresholds, ne = [];
          if (G.thresholdAlignment = void 0, (q.alignTicks !== !1 && z.alignTicks || Z) && z.startOnTick !== !1 && z.endOnTick !== !1 && !G.logarithmic) {
            let ie = (de) => {
              let { horiz: me, options: ce } = de;
              return [me ? ce.left : ce.top, ce.width, ce.height, ce.pane].join(",");
            }, re = ie(this);
            W[this.coll].forEach(function(de) {
              let { series: me } = de;
              me.length && me.some((ce) => ce.visible) && de !== G && ie(de) === re && (V = !0, ae.push(de));
            });
          }
          if (V && Z) {
            ae.forEach((re) => {
              let de = re.getThresholdAlignment(G);
              p(de) && ne.push(de);
            });
            let ie = ne.length > 1 ? ne.reduce((re, de) => re += de, 0) / ne.length : void 0;
            ae.forEach((re) => {
              re.thresholdAlignment = ie;
            });
          }
          return V;
        }
        getThresholdAlignment(V) {
          if ((!p(this.dataMin) || this !== V && this.series.some((G) => G.isDirty || G.isDirtyData)) && this.getSeriesExtremes(), p(this.threshold)) {
            let G = w((this.threshold - (this.dataMin || 0)) / ((this.dataMax || 0) - (this.dataMin || 0)), 0, 1);
            return this.options.reversed && (G = 1 - G), G;
          }
        }
        getTickAmount() {
          let V = this.options, G = V.tickPixelInterval, W = V.tickAmount;
          k(V.tickInterval) || W || !(this.len < G) || this.isRadial || this.logarithmic || !V.startOnTick || !V.endOnTick || (W = 2), !W && this.alignToOthers() && (W = Math.ceil(this.len / G) + 1), W < 4 && (this.finalTickAmt = W, W = 5), this.tickAmount = W;
        }
        adjustTickAmount() {
          let V = this, { finalTickAmt: G, max: W, min: ae, options: z, tickPositions: q, tickAmount: Z, thresholdAlignment: ne } = V, ie = q?.length, re = I(V.threshold, V.softThreshold ? 0 : null), de, me, ce = V.tickInterval, pe, xe = () => q.push(x(q[q.length - 1] + ce)), le = () => q.unshift(x(q[0] - ce));
          if (p(ne) && (pe = ne < 0.5 ? Math.ceil(ne * (Z - 1)) : Math.floor(ne * (Z - 1)), z.reversed && (pe = Z - 1 - pe)), V.hasData() && p(ae) && p(W)) {
            let se = () => {
              V.transA *= (ie - 1) / (Z - 1), V.min = z.startOnTick ? q[0] : Math.min(ae, q[0]), V.max = z.endOnTick ? q[q.length - 1] : Math.max(W, q[q.length - 1]);
            };
            if (p(pe) && p(V.threshold)) {
              for (; q[pe] !== re || q.length !== Z || q[0] > ae || q[q.length - 1] < W; ) {
                for (q.length = 0, q.push(V.threshold); q.length < Z; )
                  q[pe] === void 0 || q[pe] > V.threshold ? le() : xe();
                if (ce > 8 * V.tickInterval)
                  break;
                ce *= 2;
              }
              se();
            } else if (ie < Z) {
              for (; q.length < Z; )
                q.length % 2 || ae === re ? xe() : le();
              se();
            }
            if (k(G)) {
              for (me = de = q.length; me--; )
                (G === 3 && me % 2 == 1 || G <= 2 && me > 0 && me < de - 1) && q.splice(me, 1);
              V.finalTickAmt = void 0;
            }
          }
        }
        setScale() {
          let { coll: V, stacking: G } = this, W = !1, ae = !1;
          this.series.forEach((q) => {
            W = W || q.isDirtyData || q.isDirty, ae = ae || q.xAxis && q.xAxis.isDirty || !1;
          }), this.setAxisSize();
          let z = this.len !== (this.old && this.old.len);
          z || W || ae || this.isLinked || this.forceRedraw || this.userMin !== (this.old && this.old.userMin) || this.userMax !== (this.old && this.old.userMax) || this.alignToOthers() ? (G && V === "yAxis" && G.buildStacks(), this.forceRedraw = !1, this.userMinRange || (this.minRange = void 0), this.getSeriesExtremes(), this.setTickInterval(), G && V === "xAxis" && G.buildStacks(), this.isDirty || (this.isDirty = z || this.min !== this.old?.min || this.max !== this.old?.max)) : G && G.cleanStacks(), W && delete this.allExtremes, M(this, "afterSetScale");
        }
        setExtremes(V, G, W = !0, ae, z) {
          this.series.forEach((q) => {
            delete q.kdTree;
          }), M(this, "setExtremes", z = N(z, { min: V, max: G }), (q) => {
            this.userMin = q.min, this.userMax = q.max, this.eventArgs = q, W && this.chart.redraw(ae);
          });
        }
        setAxisSize() {
          let V = this.chart, G = this.options, W = G.offsets || [0, 0, 0, 0], ae = this.horiz, z = this.width = Math.round(R(I(G.width, V.plotWidth - W[3] + W[1]), V.plotWidth)), q = this.height = Math.round(R(I(G.height, V.plotHeight - W[0] + W[2]), V.plotHeight)), Z = this.top = Math.round(R(I(G.top, V.plotTop + W[0]), V.plotHeight, V.plotTop)), ne = this.left = Math.round(R(I(G.left, V.plotLeft + W[3]), V.plotWidth, V.plotLeft));
          this.bottom = V.chartHeight - q - Z, this.right = V.chartWidth - z - ne, this.len = Math.max(ae ? z : q, 0), this.pos = ae ? ne : Z;
        }
        getExtremes() {
          let V = this.logarithmic;
          return { min: V ? x(V.lin2log(this.min)) : this.min, max: V ? x(V.lin2log(this.max)) : this.max, dataMin: this.dataMin, dataMax: this.dataMax, userMin: this.userMin, userMax: this.userMax };
        }
        getThreshold(V) {
          let G = this.logarithmic, W = G ? G.lin2log(this.min) : this.min, ae = G ? G.lin2log(this.max) : this.max;
          return V === null || V === -1 / 0 ? V = W : V === 1 / 0 ? V = ae : W > V ? V = W : ae < V && (V = ae), this.translate(V, 0, 1, 0, 1);
        }
        autoLabelAlign(V) {
          let G = (I(V, 0) - 90 * this.side + 720) % 360, W = { align: "center" };
          return M(this, "autoLabelAlign", W, function(ae) {
            G > 15 && G < 165 ? ae.align = "right" : G > 195 && G < 345 && (ae.align = "left");
          }), W.align;
        }
        tickSize(V) {
          let G = this.options, W = I(G[V === "tick" ? "tickWidth" : "minorTickWidth"], V === "tick" && this.isXAxis && !this.categories ? 1 : 0), ae = G[V === "tick" ? "tickLength" : "minorTickLength"], z;
          W && ae && (G[V + "Position"] === "inside" && (ae = -ae), z = [ae, W]);
          let q = { tickSize: z };
          return M(this, "afterTickSize", q), q.tickSize;
        }
        labelMetrics() {
          let V = this.chart.renderer, G = this.ticks, W = G[Object.keys(G)[0]] || {};
          return this.chart.renderer.fontMetrics(W.label || W.movedLabel || V.box);
        }
        unsquish() {
          let V = this.options.labels, G = V.padding || 0, W = this.horiz, ae = this.tickInterval, z = this.len / (((this.categories ? 1 : 0) + this.max - this.min) / ae), q = V.rotation, Z = x(0.8 * this.labelMetrics().h), ne = Math.max(this.max - this.min, 0), ie = function(pe) {
            let xe = (pe + 2 * G) / (z || 1);
            return (xe = xe > 1 ? Math.ceil(xe) : 1) * ae > ne && pe !== 1 / 0 && z !== 1 / 0 && ne && (xe = Math.ceil(ne / ae)), x(xe * ae);
          }, re = ae, de, me = Number.MAX_VALUE, ce;
          if (W) {
            if (!V.staggerLines && (p(q) ? ce = [q] : z < V.autoRotationLimit && (ce = V.autoRotation)), ce) {
              let pe, xe;
              for (let le of ce)
                (le === q || le && le >= -90 && le <= 90) && (xe = (pe = ie(Math.abs(Z / Math.sin(P * le)))) + Math.abs(le / 360)) < me && (me = xe, de = le, re = pe);
            }
          } else
            re = ie(0.75 * Z);
          return this.autoRotation = ce, this.labelRotation = I(de, p(q) ? q : 0), V.step ? ae : re;
        }
        getSlotWidth(V) {
          let G = this.chart, W = this.horiz, ae = this.options.labels, z = Math.max(this.tickPositions.length - (this.categories ? 0 : 1), 1), q = G.margin[3];
          if (V && p(V.slotWidth))
            return V.slotWidth;
          if (W && ae.step < 2)
            return ae.rotation ? 0 : (this.staggerLines || 1) * this.len / z;
          if (!W) {
            let Z = ae.style.width;
            if (Z !== void 0)
              return parseInt(String(Z), 10);
            if (q)
              return q - G.spacing[3];
          }
          return 0.33 * G.chartWidth;
        }
        renderUnsquish() {
          let V = this.chart, G = V.renderer, W = this.tickPositions, ae = this.ticks, z = this.options.labels, q = z.style, Z = this.horiz, ne = this.getSlotWidth(), ie = Math.max(1, Math.round(ne - (Z ? 2 * (z.padding || 0) : z.distance || 0))), re = {}, de = this.labelMetrics(), me = q.textOverflow, ce, pe, xe = 0, le, se;
          if (L(z.rotation) || (re.rotation = z.rotation || 0), W.forEach(function(he) {
            let ve = ae[he];
            ve.movedLabel && ve.replaceMovedLabel(), ve && ve.label && ve.label.textPxLength > xe && (xe = ve.label.textPxLength);
          }), this.maxLabelLength = xe, this.autoRotation)
            xe > ie && xe > de.h ? re.rotation = this.labelRotation : this.labelRotation = 0;
          else if (ne && (ce = ie, !me))
            for (pe = "clip", se = W.length; !Z && se--; )
              (le = ae[W[se]].label) && (le.styles.textOverflow === "ellipsis" ? le.css({ textOverflow: "clip" }) : le.textPxLength > ne && le.css({ width: ne + "px" }), le.getBBox().height > this.len / W.length - (de.h - de.f) && (le.specificTextOverflow = "ellipsis"));
          re.rotation && (ce = xe > 0.5 * V.chartHeight ? 0.33 * V.chartHeight : xe, me || (pe = "ellipsis")), this.labelAlign = z.align || this.autoLabelAlign(this.labelRotation), this.labelAlign && (re.align = this.labelAlign), W.forEach(function(he) {
            let ve = ae[he], ye = ve && ve.label, be = q.width, ke = {};
            ye && (ye.attr(re), ve.shortenLabel ? ve.shortenLabel() : ce && !be && q.whiteSpace !== "nowrap" && (ce < ye.textPxLength || ye.element.tagName === "SPAN") ? (ke.width = ce + "px", me || (ke.textOverflow = ye.specificTextOverflow || pe), ye.css(ke)) : !ye.styles.width || ke.width || be || ye.css({ width: null }), delete ye.specificTextOverflow, ve.rotation = re.rotation);
          }, this), this.tickRotCorr = G.rotCorr(de.b, this.labelRotation || 0, this.side !== 0);
        }
        hasData() {
          return this.series.some(function(V) {
            return V.hasData();
          }) || this.options.showEmpty && k(this.min) && k(this.max);
        }
        addTitle(V) {
          let G, W = this.chart.renderer, ae = this.horiz, z = this.opposite, q = this.options.title, Z = this.chart.styledMode;
          this.axisTitle || ((G = q.textAlign) || (G = (ae ? { low: "left", middle: "center", high: "right" } : { low: z ? "right" : "left", middle: "center", high: z ? "left" : "right" })[q.align]), this.axisTitle = W.text(q.text || "", 0, 0, q.useHTML).attr({ zIndex: 7, rotation: q.rotation || 0, align: G }).addClass("highcharts-axis-title"), Z || this.axisTitle.css(B(q.style)), this.axisTitle.add(this.axisGroup), this.axisTitle.isNew = !0), Z || q.style.width || this.isRadial || this.axisTitle.css({ width: this.len + "px" }), this.axisTitle[V ? "show" : "hide"](V);
        }
        generateTick(V) {
          let G = this.ticks;
          G[V] ? G[V].addLabel() : G[V] = new y(this, V);
        }
        createGroups() {
          let { axisParent: V, chart: G, coll: W, options: ae } = this, z = G.renderer, q = (Z, ne, ie) => z.g(Z).attr({ zIndex: ie }).addClass(`highcharts-${W.toLowerCase()}${ne} ` + (this.isRadial ? `highcharts-radial-axis${ne} ` : "") + (ae.className || "")).add(V);
          this.axisGroup || (this.gridGroup = q("grid", "-grid", ae.gridZIndex), this.axisGroup = q("axis", "", ae.zIndex), this.labelGroup = q("axis-labels", "-labels", ae.labels.zIndex));
        }
        getOffset() {
          let V = this, { chart: G, horiz: W, options: ae, side: z, ticks: q, tickPositions: Z, coll: ne } = V, ie = G.inverted && !V.isZAxis ? [1, 0, 3, 2][z] : z, re = V.hasData(), de = ae.title, me = ae.labels, ce = p(ae.crossing), pe = G.axisOffset, xe = G.clipOffset, le = [-1, 1, 1, -1][z], se, he = 0, ve, ye = 0, be = 0, ke, we;
          if (V.showAxis = se = re || ae.showEmpty, V.staggerLines = V.horiz && me.staggerLines || void 0, V.createGroups(), re || V.isLinked ? (Z.forEach(function(Le) {
            V.generateTick(Le);
          }), V.renderUnsquish(), V.reserveSpaceDefault = z === 0 || z === 2 || { 1: "left", 3: "right" }[z] === V.labelAlign, I(me.reserveSpace, !ce && null, V.labelAlign === "center" || null, V.reserveSpaceDefault) && Z.forEach(function(Le) {
            be = Math.max(q[Le].getLabelSize(), be);
          }), V.staggerLines && (be *= V.staggerLines), V.labelOffset = be * (V.opposite ? -1 : 1)) : O(q, function(Le, Me) {
            Le.destroy(), delete q[Me];
          }), de?.text && de.enabled !== !1 && (V.addTitle(se), se && !ce && de.reserveSpace !== !1 && (V.titleOffset = he = V.axisTitle.getBBox()[W ? "height" : "width"], ye = k(ve = de.offset) ? 0 : I(de.margin, W ? 5 : 10))), V.renderLine(), V.offset = le * I(ae.offset, pe[z] ? pe[z] + (ae.margin || 0) : 0), V.tickRotCorr = V.tickRotCorr || { x: 0, y: 0 }, we = z === 0 ? -V.labelMetrics().h : z === 2 ? V.tickRotCorr.y : 0, ke = Math.abs(be) + ye, be && (ke -= we, ke += le * (W ? I(me.y, V.tickRotCorr.y + le * me.distance) : I(me.x, le * me.distance))), V.axisTitleMargin = I(ve, ke), V.getMaxLabelDimensions && (V.maxLabelDimensions = V.getMaxLabelDimensions(q, Z)), ne !== "colorAxis" && xe) {
            let Le = this.tickSize("tick");
            pe[z] = Math.max(pe[z], (V.axisTitleMargin || 0) + he + le * V.offset, ke, Z && Z.length && Le ? Le[0] + le * V.offset : 0);
            let Me = !V.axisLine || ae.offset ? 0 : V.axisLine.strokeWidth() / 2;
            xe[ie] = Math.max(xe[ie], Me);
          }
          M(this, "afterGetOffset");
        }
        getLinePath(V) {
          let G = this.chart, W = this.opposite, ae = this.offset, z = this.horiz, q = this.left + (W ? this.width : 0) + ae, Z = G.chartHeight - this.bottom - (W ? this.height : 0) + ae;
          return W && (V *= -1), G.renderer.crispLine([["M", z ? this.left : q, z ? Z : this.top], ["L", z ? G.chartWidth - this.right : q, z ? Z : G.chartHeight - this.bottom]], V);
        }
        renderLine() {
          this.axisLine || (this.axisLine = this.chart.renderer.path().addClass("highcharts-axis-line").add(this.axisGroup), this.chart.styledMode || this.axisLine.attr({ stroke: this.options.lineColor, "stroke-width": this.options.lineWidth, zIndex: 7 }));
        }
        getTitlePosition(V) {
          let G = this.horiz, W = this.left, ae = this.top, z = this.len, q = this.options.title, Z = G ? W : ae, ne = this.opposite, ie = this.offset, re = q.x, de = q.y, me = this.chart.renderer.fontMetrics(V), ce = V ? Math.max(V.getBBox(!1, 0).height - me.h - 1, 0) : 0, pe = { low: Z + (G ? 0 : z), middle: Z + z / 2, high: Z + (G ? z : 0) }[q.align], xe = (G ? ae + this.height : W) + (G ? 1 : -1) * (ne ? -1 : 1) * (this.axisTitleMargin || 0) + [-ce, ce, me.f, -ce][this.side], le = { x: G ? pe + re : xe + (ne ? this.width : 0) + ie + re, y: G ? xe + de - (ne ? this.height : 0) + ie : pe + de };
          return M(this, "afterGetTitlePosition", { titlePosition: le }), le;
        }
        renderMinorTick(V, G) {
          let W = this.minorTicks;
          W[V] || (W[V] = new y(this, V, "minor")), G && W[V].isNew && W[V].render(null, !0), W[V].render(null, !1, 1);
        }
        renderTick(V, G, W) {
          let ae = this.isLinked, z = this.ticks;
          (!ae || V >= this.min && V <= this.max || this.grid && this.grid.isColumn) && (z[V] || (z[V] = new y(this, V)), W && z[V].isNew && z[V].render(G, !0, -1), z[V].render(G));
        }
        render() {
          let V, G, W = this, ae = W.chart, z = W.logarithmic, q = ae.renderer, Z = W.options, ne = W.isLinked, ie = W.tickPositions, re = W.axisTitle, de = W.ticks, me = W.minorTicks, ce = W.alternateBands, pe = Z.stackLabels, xe = Z.alternateGridColor, le = Z.crossing, se = W.tickmarkOffset, he = W.axisLine, ve = W.showAxis, ye = m(q.globalAnimation);
          if (W.labelEdge.length = 0, W.overlap = !1, [de, me, ce].forEach(function(be) {
            O(be, function(ke) {
              ke.isActive = !1;
            });
          }), p(le)) {
            let be = this.isXAxis ? ae.yAxis[0] : ae.xAxis[0], ke = [1, -1, -1, 1][this.side];
            if (be) {
              let we = be.toPixels(le, !0);
              W.horiz && (we = be.len - we), W.offset = ke * we;
            }
          }
          if (W.hasData() || ne) {
            let be = W.chart.hasRendered && W.old && p(W.old.min);
            W.minorTickInterval && !W.categories && W.getMinorTickPositions().forEach(function(ke) {
              W.renderMinorTick(ke, be);
            }), ie.length && (ie.forEach(function(ke, we) {
              W.renderTick(ke, we, be);
            }), se && (W.min === 0 || W.single) && (de[-1] || (de[-1] = new y(W, -1, null, !0)), de[-1].render(-1))), xe && ie.forEach(function(ke, we) {
              G = ie[we + 1] !== void 0 ? ie[we + 1] + se : W.max - se, we % 2 == 0 && ke < W.max && G <= W.max + (ae.polar ? -se : se) && (ce[ke] || (ce[ke] = new d.PlotLineOrBand(W, {})), V = ke + se, ce[ke].options = { from: z ? z.lin2log(V) : V, to: z ? z.lin2log(G) : G, color: xe, className: "highcharts-alternate-grid" }, ce[ke].render(), ce[ke].isActive = !0);
            }), W._addedPlotLB || (W._addedPlotLB = !0, (Z.plotLines || []).concat(Z.plotBands || []).forEach(function(ke) {
              W.addPlotBandOrLine(ke);
            }));
          }
          [de, me, ce].forEach(function(be) {
            let ke = [], we = ye.duration;
            O(be, function(Le, Me) {
              Le.isActive || (Le.render(Me, !1, 0), Le.isActive = !1, ke.push(Me));
            }), U(function() {
              let Le = ke.length;
              for (; Le--; )
                be[ke[Le]] && !be[ke[Le]].isActive && (be[ke[Le]].destroy(), delete be[ke[Le]]);
            }, be !== ce && ae.hasRendered && we ? we : 0);
          }), he && (he[he.isPlaced ? "animate" : "attr"]({ d: this.getLinePath(he.strokeWidth()) }), he.isPlaced = !0, he[ve ? "show" : "hide"](ve)), re && ve && (re[re.isNew ? "attr" : "animate"](W.getTitlePosition(re)), re.isNew = !1), pe && pe.enabled && W.stacking && W.stacking.renderStackTotals(), W.old = { len: W.len, max: W.max, min: W.min, transA: W.transA, userMax: W.userMax, userMin: W.userMin }, W.isDirty = !1, M(this, "afterRender");
        }
        redraw() {
          this.visible && (this.render(), this.plotLinesAndBands.forEach(function(V) {
            V.render();
          })), this.series.forEach(function(V) {
            V.isDirty = !0;
          });
        }
        getKeepProps() {
          return this.keepProps || J.keepProps;
        }
        destroy(V) {
          let G = this, W = G.plotLinesAndBands, ae = this.eventOptions;
          if (M(this, "destroy", { keepEvents: V }), V || Y(G), [G.ticks, G.minorTicks, G.alternateBands].forEach(function(z) {
            A(z);
          }), W) {
            let z = W.length;
            for (; z--; )
              W[z].destroy();
          }
          for (let z in ["axisLine", "axisTitle", "axisGroup", "gridGroup", "labelGroup", "cross", "scrollbar"].forEach(function(q) {
            G[q] && (G[q] = G[q].destroy());
          }), G.plotLinesAndBandsGroups)
            G.plotLinesAndBandsGroups[z] = G.plotLinesAndBandsGroups[z].destroy();
          O(G, function(z, q) {
            G.getKeepProps().indexOf(q) === -1 && delete G[q];
          }), this.eventOptions = ae;
        }
        drawCrosshair(V, G) {
          let W = this.crosshair, ae = I(W && W.snap, !0), z = this.chart, q, Z, ne, ie = this.cross, re;
          if (M(this, "drawCrosshair", { e: V, point: G }), V || (V = this.cross && this.cross.e), W && (k(G) || !ae) !== !1) {
            if (ae ? k(G) && (Z = I(this.coll !== "colorAxis" ? G.crosshairPos : null, this.isXAxis ? G.plotX : this.len - G.plotY)) : Z = V && (this.horiz ? V.chartX - this.pos : this.len - V.chartY + this.pos), k(Z) && (re = { value: G && (this.isXAxis ? G.x : I(G.stackY, G.y)), translatedValue: Z }, z.polar && N(re, { isCrosshair: !0, chartX: V && V.chartX, chartY: V && V.chartY, point: G }), q = this.getPlotLinePath(re) || null), !k(q)) {
              this.hideCrosshair();
              return;
            }
            ne = this.categories && !this.isRadial, ie || (this.cross = ie = z.renderer.path().addClass("highcharts-crosshair highcharts-crosshair-" + (ne ? "category " : "thin ") + (W.className || "")).attr({ zIndex: I(W.zIndex, 2) }).add(), !z.styledMode && (ie.attr({ stroke: W.color || (ne ? r.parse("#ccd3ff").setOpacity(0.25).get() : "#cccccc"), "stroke-width": I(W.width, 1) }).css({ "pointer-events": "none" }), W.dashStyle && ie.attr({ dashstyle: W.dashStyle }))), ie.show().attr({ d: q }), ne && !W.width && ie.attr({ "stroke-width": this.transA }), this.cross.e = V;
          } else
            this.hideCrosshair();
          M(this, "afterDrawCrosshair", { e: V, point: G });
        }
        hideCrosshair() {
          this.cross && this.cross.hide(), M(this, "afterHideCrosshair");
        }
        update(V, G) {
          let W = this.chart;
          V = B(this.userOptions, V), this.destroy(!0), this.init(W, V), W.isDirtyBox = !0, I(G, !0) && W.redraw();
        }
        remove(V) {
          let G = this.chart, W = this.coll, ae = this.series, z = ae.length;
          for (; z--; )
            ae[z] && ae[z].remove(!1);
          $(G.axes, this), $(G[W] || [], this), G.orderItems(W), this.destroy(), G.isDirtyBox = !0, I(V, !0) && G.redraw();
        }
        setTitle(V, G) {
          this.update({ title: V }, G);
        }
        setCategories(V, G) {
          this.update({ categories: V }, G);
        }
      }
      return J.keepProps = ["coll", "extKey", "hcEvents", "len", "names", "series", "userMax", "userMin"], J;
    }), i(n, "Core/Axis/DateTimeAxis.js", [n["Core/Utilities.js"]], function(o) {
      var a;
      let { addEvent: r, getMagnitude: s, normalizeTickInterval: l, timeUnits: d } = o;
      return function(y) {
        function u() {
          return this.chart.time.getTimeTicks.apply(this.chart.time, arguments);
        }
        function m() {
          if (this.type !== "datetime") {
            this.dateTime = void 0;
            return;
          }
          this.dateTime || (this.dateTime = new h(this));
        }
        y.compose = function(c) {
          return c.keepProps.includes("dateTime") || (c.keepProps.push("dateTime"), c.prototype.getTimeTicks = u, r(c, "afterSetType", m)), c;
        };
        class h {
          constructor(g) {
            this.axis = g;
          }
          normalizeTimeTickInterval(g, v) {
            let P = v || [["millisecond", [1, 2, 5, 10, 20, 25, 50, 100, 200, 500]], ["second", [1, 2, 5, 10, 15, 30]], ["minute", [1, 2, 5, 10, 15, 30]], ["hour", [1, 2, 3, 4, 6, 8, 12]], ["day", [1, 2]], ["week", [1, 2]], ["month", [1, 2, 3, 4, 6]], ["year", null]], f = P[P.length - 1], S = d[f[0]], w = f[1], x;
            for (x = 0; x < P.length && (S = d[(f = P[x])[0]], w = f[1], !P[x + 1] || !(g <= (S * w[w.length - 1] + d[P[x + 1][0]]) / 2)); x++)
              ;
            S === d.year && g < 5 * S && (w = [1, 2, 5]);
            let k = l(g / S, w, f[0] === "year" ? Math.max(s(g / S), 1) : 1);
            return { unitRange: S, count: k, unitName: f[0] };
          }
          getXDateFormat(g, v) {
            let { axis: P } = this, f = P.chart.time;
            return P.closestPointRange ? f.getDateFormat(P.closestPointRange, g, P.options.startOfWeek, v) || f.resolveDTLFormat(v.year).main : f.resolveDTLFormat(v.day).main;
          }
        }
        y.Additions = h;
      }(a || (a = {})), a;
    }), i(n, "Core/Axis/LogarithmicAxis.js", [n["Core/Utilities.js"]], function(o) {
      var a;
      let { addEvent: r, normalizeTickInterval: s, pick: l } = o;
      return function(d) {
        function y() {
          this.type !== "logarithmic" ? this.logarithmic = void 0 : this.logarithmic ?? (this.logarithmic = new m(this));
        }
        function u() {
          let h = this.logarithmic;
          h && (this.lin2val = function(c) {
            return h.lin2log(c);
          }, this.val2lin = function(c) {
            return h.log2lin(c);
          });
        }
        d.compose = function(h) {
          return h.keepProps.includes("logarithmic") || (h.keepProps.push("logarithmic"), r(h, "afterSetType", y), r(h, "afterInit", u)), h;
        };
        class m {
          constructor(c) {
            this.axis = c;
          }
          getLogTickPositions(c, g, v, P) {
            let f = this.axis, S = f.len, w = f.options, x = [];
            if (P || (this.minorAutoInterval = void 0), c >= 0.5)
              c = Math.round(c), x = f.getLinearTickPositions(c, g, v);
            else if (c >= 0.08) {
              let k, A, $, j, N, M, D, C = Math.floor(g);
              for (k = c > 0.3 ? [1, 2, 4] : c > 0.15 ? [1, 2, 4, 6, 8] : [1, 2, 3, 4, 5, 6, 7, 8, 9], A = C; A < v + 1 && !D; A++)
                for ($ = 0, j = k.length; $ < j && !D; $++)
                  (N = this.log2lin(this.lin2log(A) * k[$])) > g && (!P || M <= v) && M !== void 0 && x.push(M), M > v && (D = !0), M = N;
            } else {
              let k = this.lin2log(g), A = this.lin2log(v), $ = P ? f.getMinorTickInterval() : w.tickInterval, j = w.tickPixelInterval / (P ? 5 : 1), N = P ? S / f.tickPositions.length : S;
              c = s(c = l($ === "auto" ? null : $, this.minorAutoInterval, (A - k) * j / (N || 1))), x = f.getLinearTickPositions(c, k, A).map(this.log2lin), P || (this.minorAutoInterval = c / 5);
            }
            return P || (f.tickInterval = c), x;
          }
          lin2log(c) {
            return Math.pow(10, c);
          }
          log2lin(c) {
            return Math.log(c) / Math.LN10;
          }
        }
        d.Additions = m;
      }(a || (a = {})), a;
    }), i(n, "Core/Axis/PlotLineOrBand/PlotLineOrBandAxis.js", [n["Core/Utilities.js"]], function(o) {
      var a;
      let { erase: r, extend: s, isNumber: l } = o;
      return function(d) {
        let y;
        function u(f) {
          return this.addPlotBandOrLine(f, "plotBands");
        }
        function m(f, S) {
          let w = this.userOptions, x = new y(this, f);
          if (this.visible && (x = x.render()), x) {
            if (this._addedPlotLB || (this._addedPlotLB = !0, (w.plotLines || []).concat(w.plotBands || []).forEach((k) => {
              this.addPlotBandOrLine(k);
            })), S) {
              let k = w[S] || [];
              k.push(f), w[S] = k;
            }
            this.plotLinesAndBands.push(x);
          }
          return x;
        }
        function h(f) {
          return this.addPlotBandOrLine(f, "plotLines");
        }
        function c(f, S, w) {
          w = w || this.options;
          let x = this.getPlotLinePath({ value: S, force: !0, acrossPanes: w.acrossPanes }), k = [], A = this.horiz, $ = !l(this.min) || !l(this.max) || f < this.min && S < this.min || f > this.max && S > this.max, j = this.getPlotLinePath({ value: f, force: !0, acrossPanes: w.acrossPanes }), N, M = 1, D;
          if (j && x)
            for ($ && (D = j.toString() === x.toString(), M = 0), N = 0; N < j.length; N += 2) {
              let C = j[N], b = j[N + 1], p = x[N], L = x[N + 1];
              (C[0] === "M" || C[0] === "L") && (b[0] === "M" || b[0] === "L") && (p[0] === "M" || p[0] === "L") && (L[0] === "M" || L[0] === "L") && (A && p[1] === C[1] ? (p[1] += M, L[1] += M) : A || p[2] !== C[2] || (p[2] += M, L[2] += M), k.push(["M", C[1], C[2]], ["L", b[1], b[2]], ["L", L[1], L[2]], ["L", p[1], p[2]], ["Z"])), k.isFlat = D;
            }
          return k;
        }
        function g(f) {
          this.removePlotBandOrLine(f);
        }
        function v(f) {
          let S = this.plotLinesAndBands, w = this.options, x = this.userOptions;
          if (S) {
            let k = S.length;
            for (; k--; )
              S[k].id === f && S[k].destroy();
            [w.plotLines || [], x.plotLines || [], w.plotBands || [], x.plotBands || []].forEach(function(A) {
              for (k = A.length; k--; )
                (A[k] || {}).id === f && r(A, A[k]);
            });
          }
        }
        function P(f) {
          this.removePlotBandOrLine(f);
        }
        d.compose = function(f, S) {
          let w = S.prototype;
          return w.addPlotBand || (y = f, s(w, { addPlotBand: u, addPlotLine: h, addPlotBandOrLine: m, getPlotBandPath: c, removePlotBand: g, removePlotLine: P, removePlotBandOrLine: v })), S;
        };
      }(a || (a = {})), a;
    }), i(n, "Core/Axis/PlotLineOrBand/PlotLineOrBand.js", [n["Core/Axis/PlotLineOrBand/PlotLineOrBandAxis.js"], n["Core/Utilities.js"]], function(o, a) {
      let { addEvent: r, arrayMax: s, arrayMin: l, defined: d, destroyObjectProperties: y, erase: u, fireEvent: m, merge: h, objectEach: c, pick: g } = a;
      class v {
        static compose(f, S) {
          return r(f, "afterInit", function() {
            this.labelCollectors.push(() => {
              let w = [];
              for (let x of this.axes)
                for (let { label: k, options: A } of x.plotLinesAndBands)
                  k && !A?.label?.allowOverlap && w.push(k);
              return w;
            });
          }), o.compose(v, S);
        }
        constructor(f, S) {
          this.axis = f, this.options = S, this.id = S.id;
        }
        render() {
          m(this, "render");
          let { axis: f, options: S } = this, { horiz: w, logarithmic: x } = f, { color: k, events: A, zIndex: $ = 0 } = S, j = {}, N = f.chart.renderer, M = S.to, D = S.from, C = S.value, b = S.borderWidth, p = S.label, { label: L, svgElem: B } = this, T = [], O, I = d(D) && d(M), R = d(C), Y = !B, F = { class: "highcharts-plot-" + (I ? "band " : "line ") + (S.className || "") }, U = I ? "bands" : "lines";
          if (!f.chart.styledMode && (R ? (F.stroke = k || "#999999", F["stroke-width"] = g(S.width, 1), S.dashStyle && (F.dashstyle = S.dashStyle)) : I && (F.fill = k || "#e6e9ff", b && (F.stroke = S.borderColor, F["stroke-width"] = b))), j.zIndex = $, U += "-" + $, (O = f.plotLinesAndBandsGroups[U]) || (f.plotLinesAndBandsGroups[U] = O = N.g("plot-" + U).attr(j).add()), B || (this.svgElem = B = N.path().attr(F).add(O)), d(C))
            T = f.getPlotLinePath({ value: x?.log2lin(C) ?? C, lineWidth: B.strokeWidth(), acrossPanes: S.acrossPanes });
          else {
            if (!(d(D) && d(M)))
              return;
            T = f.getPlotBandPath(x?.log2lin(D) ?? D, x?.log2lin(M) ?? M, S);
          }
          return !this.eventsAdded && A && (c(A, (Q, J) => {
            B?.on(J, (ee) => {
              A[J].apply(this, [ee]);
            });
          }), this.eventsAdded = !0), (Y || !B.d) && T?.length ? B.attr({ d: T }) : B && (T ? (B.show(), B.animate({ d: T })) : B.d && (B.hide(), L && (this.label = L = L.destroy()))), p && (d(p.text) || d(p.formatter)) && T?.length && f.width > 0 && f.height > 0 && !T.isFlat ? (p = h({ align: w && I ? "center" : void 0, x: w ? !I && 4 : 10, verticalAlign: !w && I ? "middle" : void 0, y: w ? I ? 16 : 10 : I ? 6 : -4, rotation: w && !I ? 90 : 0, ...I ? { inside: !0 } : {} }, p), this.renderLabel(p, T, I, $)) : L && L.hide(), this;
        }
        renderLabel(f, S, w, x) {
          let k = this.axis, A = k.chart.renderer, $ = f.inside, j = this.label;
          j || (this.label = j = A.text(this.getLabelText(f), 0, 0, f.useHTML).attr({ align: f.textAlign || f.align, rotation: f.rotation, class: "highcharts-plot-" + (w ? "band" : "line") + "-label " + (f.className || ""), zIndex: x }), k.chart.styledMode || j.css(h({ fontSize: "0.8em", textOverflow: w && !$ ? "" : "ellipsis" }, f.style)), j.add());
          let N = S.xBounds || [S[0][1], S[1][1], w ? S[2][1] : S[0][1]], M = S.yBounds || [S[0][2], S[1][2], w ? S[2][2] : S[0][2]], D = l(N), C = l(M), b = s(N) - D;
          j.align(f, !1, { x: D, y: C, width: b, height: s(M) - C }), (!j.alignValue || j.alignValue === "left" || d($)) && j.css({ width: (f.style?.width || (w && $ ? b : j.rotation === 90 ? k.height - (j.alignAttr.y - k.top) : (f.clip ? k.width : k.chart.chartWidth) - (j.alignAttr.x - k.left))) + "px" }), j.show(!0);
        }
        getLabelText(f) {
          return d(f.formatter) ? f.formatter.call(this) : f.text;
        }
        destroy() {
          u(this.axis.plotLinesAndBands, this), delete this.axis, y(this);
        }
      }
      return v;
    }), i(n, "Core/Tooltip.js", [n["Core/Animation/AnimationUtilities.js"], n["Core/Templating.js"], n["Core/Globals.js"], n["Core/Renderer/RendererUtilities.js"], n["Core/Renderer/RendererRegistry.js"], n["Core/Utilities.js"]], function(o, a, r, s, l, d) {
      var y;
      let { animObject: u } = o, { format: m } = a, { composed: h, doc: c, isSafari: g } = r, { distribute: v } = s, { addEvent: P, clamp: f, css: S, discardElement: w, extend: x, fireEvent: k, isArray: A, isNumber: $, isString: j, merge: N, pick: M, pushUnique: D, splat: C, syncTimeout: b } = d;
      class p {
        constructor(B, T, O) {
          this.allowShared = !0, this.crosshairs = [], this.distance = 0, this.isHidden = !0, this.isSticky = !1, this.options = {}, this.outside = !1, this.chart = B, this.init(B, T), this.pointer = O;
        }
        bodyFormatter(B) {
          return B.map(function(T) {
            let O = T.series.tooltipOptions;
            return (O[(T.point.formatPrefix || "point") + "Formatter"] || T.point.tooltipFormatter).call(T.point, O[(T.point.formatPrefix || "point") + "Format"] || "");
          });
        }
        cleanSplit(B) {
          this.chart.series.forEach(function(T) {
            let O = T && T.tt;
            O && (!O.isActive || B ? T.tt = O.destroy() : O.isActive = !1);
          });
        }
        defaultFormatter(B) {
          let T, O = this.points || C(this);
          return (T = (T = [B.tooltipFooterHeaderFormatter(O[0])]).concat(B.bodyFormatter(O))).push(B.tooltipFooterHeaderFormatter(O[0], !0)), T;
        }
        destroy() {
          this.label && (this.label = this.label.destroy()), this.split && (this.cleanSplit(!0), this.tt && (this.tt = this.tt.destroy())), this.renderer && (this.renderer = this.renderer.destroy(), w(this.container)), d.clearTimeout(this.hideTimer);
        }
        getAnchor(B, T) {
          let O, { chart: I, pointer: R } = this, Y = I.inverted, F = I.plotTop, U = I.plotLeft;
          if ((B = C(B))[0].series && B[0].series.yAxis && !B[0].series.yAxis.options.reversedStacks && (B = B.slice().reverse()), this.followPointer && T)
            T.chartX === void 0 && (T = R.normalize(T)), O = [T.chartX - U, T.chartY - F];
          else if (B[0].tooltipPos)
            O = B[0].tooltipPos;
          else {
            let Q = 0, J = 0;
            B.forEach(function(ee) {
              let V = ee.pos(!0);
              V && (Q += V[0], J += V[1]);
            }), Q /= B.length, J /= B.length, this.shared && B.length > 1 && T && (Y ? Q = T.chartX : J = T.chartY), O = [Q - U, J - F];
          }
          return O.map(Math.round);
        }
        getClassName(B, T, O) {
          let I = this.options, R = B.series, Y = R.options;
          return [I.className, "highcharts-label", O && "highcharts-tooltip-header", T ? "highcharts-tooltip-box" : "highcharts-tooltip", !O && "highcharts-color-" + M(B.colorIndex, R.colorIndex), Y && Y.className].filter(j).join(" ");
        }
        getLabel({ anchorX: B, anchorY: T } = { anchorX: 0, anchorY: 0 }) {
          let O = this, I = this.chart.styledMode, R = this.options, Y = this.split && this.allowShared, F = this.container, U = this.chart.renderer;
          if (this.label) {
            let Q = !this.label.hasClass("highcharts-label");
            (!Y && Q || Y && !Q) && this.destroy();
          }
          if (!this.label) {
            if (this.outside) {
              let Q = this.chart.options.chart.style, J = l.getRendererType();
              this.container = F = r.doc.createElement("div"), F.className = "highcharts-tooltip-container", S(F, { position: "absolute", top: "1px", pointerEvents: "none", zIndex: Math.max(this.options.style.zIndex || 0, (Q && Q.zIndex || 0) + 3) }), this.renderer = U = new J(F, 0, 0, Q, void 0, void 0, U.styledMode);
            }
            if (Y ? this.label = U.g("tooltip") : (this.label = U.label("", B, T, R.shape, void 0, void 0, R.useHTML, void 0, "tooltip").attr({ padding: R.padding, r: R.borderRadius }), I || this.label.attr({ fill: R.backgroundColor, "stroke-width": R.borderWidth || 0 }).css(R.style).css({ pointerEvents: R.style.pointerEvents || (this.shouldStickOnContact() ? "auto" : "none") })), O.outside) {
              let Q = this.label;
              [Q.xSetter, Q.ySetter].forEach((J, ee) => {
                Q[ee ? "ySetter" : "xSetter"] = (V) => {
                  J.call(Q, O.distance), Q[ee ? "y" : "x"] = V, F && (F.style[ee ? "top" : "left"] = `${V}px`);
                };
              });
            }
            this.label.attr({ zIndex: 8 }).shadow(R.shadow).add();
          }
          return F && !F.parentElement && r.doc.body.appendChild(F), this.label;
        }
        getPlayingField() {
          let { body: B, documentElement: T } = c, { chart: O, distance: I, outside: R } = this;
          return { width: R ? Math.max(B.scrollWidth, T.scrollWidth, B.offsetWidth, T.offsetWidth, T.clientWidth) - 2 * I : O.chartWidth, height: R ? Math.max(B.scrollHeight, T.scrollHeight, B.offsetHeight, T.offsetHeight, T.clientHeight) : O.chartHeight };
        }
        getPosition(B, T, O) {
          let { distance: I, chart: R, outside: Y, pointer: F } = this, { inverted: U, plotLeft: Q, plotTop: J, polar: ee } = R, { plotX: V = 0, plotY: G = 0 } = O, W = {}, ae = U && O.h || 0, { height: z, width: q } = this.getPlayingField(), Z = F.getChartPosition(), ne = (ye) => ye * Z.scaleX, ie = (ye) => ye * Z.scaleY, re = (ye) => {
            let be = ye === "x";
            return [ye, be ? q : z, be ? B : T].concat(Y ? [be ? ne(B) : ie(T), be ? Z.left - I + ne(V + Q) : Z.top - I + ie(G + J), 0, be ? q : z] : [be ? B : T, be ? V + Q : G + J, be ? Q : J, be ? Q + R.plotWidth : J + R.plotHeight]);
          }, de = re("y"), me = re("x"), ce, pe = !!O.negative;
          !ee && R.hoverSeries?.yAxis?.reversed && (pe = !pe);
          let xe = !this.followPointer && M(O.ttBelow, !ee && !U === pe), le = function(ye, be, ke, we, Le, Me, De) {
            let Ae = Y ? ye === "y" ? ie(I) : ne(I) : I, _e = (ke - we) / 2, He = we < Le - I, Ee = Le + I + we < be, Ne = Le - Ae - ke + _e, Ye = Le + Ae - _e;
            if (xe && Ee)
              W[ye] = Ye;
            else if (!xe && He)
              W[ye] = Ne;
            else if (He)
              W[ye] = Math.min(De - we, Ne - ae < 0 ? Ne : Ne - ae);
            else {
              if (!Ee)
                return !1;
              W[ye] = Math.max(Me, Ye + ae + ke > be ? Ye : Ye + ae);
            }
          }, se = function(ye, be, ke, we, Le) {
            if (Le < I || Le > be - I)
              return !1;
            Le < ke / 2 ? W[ye] = 1 : Le > be - we / 2 ? W[ye] = be - we - 2 : W[ye] = Le - ke / 2;
          }, he = function(ye) {
            [de, me] = [me, de], ce = ye;
          }, ve = () => {
            le.apply(0, de) !== !1 ? se.apply(0, me) !== !1 || ce || (he(!0), ve()) : ce ? W.x = W.y = 0 : (he(!0), ve());
          };
          return (U && !ee || this.len > 1) && he(), ve(), W;
        }
        hide(B) {
          let T = this;
          d.clearTimeout(this.hideTimer), B = M(B, this.options.hideDelay), this.isHidden || (this.hideTimer = b(function() {
            let O = T.getLabel();
            T.getLabel().animate({ opacity: 0 }, { duration: B && 150, complete: () => {
              O.hide(), T.container && T.container.remove();
            } }), T.isHidden = !0;
          }, B));
        }
        init(B, T) {
          this.chart = B, this.options = T, this.crosshairs = [], this.isHidden = !0, this.split = T.split && !B.inverted && !B.polar, this.shared = T.shared || this.split, this.outside = M(T.outside, !!(B.scrollablePixelsX || B.scrollablePixelsY));
        }
        shouldStickOnContact(B) {
          return !!(!this.followPointer && this.options.stickOnContact && (!B || this.pointer.inClass(B.target, "highcharts-tooltip")));
        }
        move(B, T, O, I) {
          let R = this, Y = u(!R.isHidden && R.options.animation), F = R.followPointer || (R.len || 0) > 1, U = { x: B, y: T };
          F || (U.anchorX = O, U.anchorY = I), Y.step = () => R.drawTracker(), R.getLabel().animate(U, Y);
        }
        refresh(B, T) {
          let { chart: O, options: I, pointer: R, shared: Y } = this, F = C(B), U = F[0], Q = [], J = I.format, ee = I.formatter || this.defaultFormatter, V = O.styledMode, G = {}, W = this.allowShared;
          if (!I.enabled || !U.series)
            return;
          d.clearTimeout(this.hideTimer), this.allowShared = !(!A(B) && B.series && B.series.noSharedTooltip), W = W && !this.allowShared, this.followPointer = !this.split && U.series.tooltipOptions.followPointer;
          let ae = this.getAnchor(B, T), z = ae[0], q = ae[1];
          Y && this.allowShared ? (R.applyInactiveState(F), F.forEach(function(ie) {
            ie.setState("hover"), Q.push(ie.getLabelConfig());
          }), (G = U.getLabelConfig()).points = Q) : G = U.getLabelConfig(), this.len = Q.length;
          let Z = j(J) ? m(J, G, O) : ee.call(G, this), ne = U.series;
          if (this.distance = M(ne.tooltipOptions.distance, 16), Z === !1)
            this.hide();
          else {
            if (this.split && this.allowShared)
              this.renderSplit(Z, F);
            else {
              let ie = z, re = q;
              if (T && R.isDirectTouch && (ie = T.chartX - O.plotLeft, re = T.chartY - O.plotTop), O.polar || ne.options.clip === !1 || F.some((de) => R.isDirectTouch || de.series.shouldShowTooltip(ie, re))) {
                let de = this.getLabel(W && this.tt || {});
                (!I.style.width || V) && de.css({ width: (this.outside ? this.getPlayingField() : O.spacingBox).width + "px" }), de.attr({ class: this.getClassName(U), text: Z && Z.join ? Z.join("") : Z }), this.outside && de.attr({ x: f(de.x || 0, 0, this.getPlayingField().width - (de.width || 0)) }), V || de.attr({ stroke: I.borderColor || U.color || ne.color || "#666666" }), this.updatePosition({ plotX: z, plotY: q, negative: U.negative, ttBelow: U.ttBelow, h: ae[2] || 0 });
              } else {
                this.hide();
                return;
              }
            }
            this.isHidden && this.label && this.label.attr({ opacity: 1 }).show(), this.isHidden = !1;
          }
          k(this, "refresh");
        }
        renderSplit(B, T) {
          let O = this, { chart: I, chart: { chartWidth: R, chartHeight: Y, plotHeight: F, plotLeft: U, plotTop: Q, scrollablePixelsY: J = 0, scrollablePixelsX: ee, styledMode: V }, distance: G, options: W, options: { positioner: ae }, pointer: z } = O, { scrollLeft: q = 0, scrollTop: Z = 0 } = I.scrollablePlotArea?.scrollingContainer || {}, ne = O.outside && typeof ee != "number" ? c.documentElement.getBoundingClientRect() : { left: q, right: q + R, top: Z, bottom: Z + Y }, ie = O.getLabel(), re = this.renderer || I.renderer, de = !!(I.xAxis[0] && I.xAxis[0].opposite), { left: me, top: ce } = z.getChartPosition(), pe = Q + Z, xe = 0, le = F - J;
          function se(we, Le, Me, De, Ae = !0) {
            let _e, He;
            return Me ? (_e = de ? 0 : le, He = f(we - De / 2, ne.left, ne.right - De - (O.outside ? me : 0))) : (_e = Le - pe, He = f(He = Ae ? we - De - G : we + G, Ae ? He : ne.left, ne.right)), { x: He, y: _e };
          }
          j(B) && (B = [!1, B]);
          let he = B.slice(0, T.length + 1).reduce(function(we, Le, Me) {
            if (Le !== !1 && Le !== "") {
              let De = T[Me - 1] || { isHeader: !0, plotX: T[0].plotX, plotY: F, series: {} }, Ae = De.isHeader, _e = Ae ? O : De.series, He = _e.tt = function(nt, ut, bt) {
                let Bt = nt, { isHeader: kt, series: nn } = ut;
                if (!Bt) {
                  let an = { padding: W.padding, r: W.borderRadius };
                  V || (an.fill = W.backgroundColor, an["stroke-width"] = W.borderWidth ?? 1), Bt = re.label("", 0, 0, W[kt ? "headerShape" : "shape"], void 0, void 0, W.useHTML).addClass(O.getClassName(ut, !0, kt)).attr(an).add(ie);
                }
                return Bt.isActive = !0, Bt.attr({ text: bt }), V || Bt.css(W.style).attr({ stroke: W.borderColor || ut.color || nn.color || "#333333" }), Bt;
              }(_e.tt, De, Le.toString()), Ee = He.getBBox(), Ne = Ee.width + He.strokeWidth();
              Ae && (xe = Ee.height, le += xe, de && (pe -= xe));
              let { anchorX: Ye, anchorY: Xe } = function(nt) {
                let ut, bt, { isHeader: Bt, plotX: kt = 0, plotY: nn = 0, series: an } = nt;
                if (Bt)
                  ut = Math.max(U + kt, U), bt = Q + F / 2;
                else {
                  let { xAxis: Cn, yAxis: Ft } = an;
                  ut = Cn.pos + f(kt, -G, Cn.len + G), an.shouldShowTooltip(0, Ft.pos - Q + nn, { ignoreX: !0 }) && (bt = Ft.pos + nn);
                }
                return { anchorX: ut = f(ut, ne.left - G, ne.right + G), anchorY: bt };
              }(De);
              if (typeof Xe == "number") {
                let nt = Ee.height + 1, ut = ae ? ae.call(O, Ne, nt, De) : se(Ye, Xe, Ae, Ne);
                we.push({ align: ae ? 0 : void 0, anchorX: Ye, anchorY: Xe, boxWidth: Ne, point: De, rank: M(ut.rank, Ae ? 1 : 0), size: nt, target: ut.y, tt: He, x: ut.x });
              } else
                He.isActive = !1;
            }
            return we;
          }, []);
          !ae && he.some((we) => {
            let { outside: Le } = O, Me = (Le ? me : 0) + we.anchorX;
            return Me < ne.left && Me + we.boxWidth < ne.right || Me < me - ne.left + we.boxWidth && ne.right - Me > Me;
          }) && (he = he.map((we) => {
            let { x: Le, y: Me } = se(we.anchorX, we.anchorY, we.point.isHeader, we.boxWidth, !1);
            return x(we, { target: Me, x: Le });
          })), O.cleanSplit(), v(he, le);
          let ve = { left: me, right: me };
          he.forEach(function(we) {
            let { x: Le, boxWidth: Me, isHeader: De } = we;
            !De && (O.outside && me + Le < ve.left && (ve.left = me + Le), !De && O.outside && ve.left + Me > ve.right && (ve.right = me + Le));
          }), he.forEach(function(we) {
            let { x: Le, anchorX: Me, anchorY: De, pos: Ae, point: { isHeader: _e } } = we, He = { visibility: Ae === void 0 ? "hidden" : "inherit", x: Le, y: (Ae || 0) + pe, anchorX: Me, anchorY: De };
            if (O.outside && Le < Me) {
              let Ee = me - ve.left;
              Ee > 0 && (_e || (He.x = Le + Ee, He.anchorX = Me + Ee), _e && (He.x = (ve.right - ve.left) / 2, He.anchorX = Me + Ee));
            }
            we.tt.attr(He);
          });
          let { container: ye, outside: be, renderer: ke } = O;
          if (be && ye && ke) {
            let { width: we, height: Le, x: Me, y: De } = ie.getBBox();
            ke.setSize(we + Me, Le + De, !1), ye.style.left = ve.left + "px", ye.style.top = ce + "px";
          }
          g && ie.attr({ opacity: ie.opacity === 1 ? 0.999 : 1 });
        }
        drawTracker() {
          if (!this.shouldStickOnContact()) {
            this.tracker && (this.tracker = this.tracker.destroy());
            return;
          }
          let B = this.chart, T = this.label, O = this.shared ? B.hoverPoints : B.hoverPoint;
          if (!T || !O)
            return;
          let I = { x: 0, y: 0, width: 0, height: 0 }, R = this.getAnchor(O), Y = T.getBBox();
          R[0] += B.plotLeft - (T.translateX || 0), R[1] += B.plotTop - (T.translateY || 0), I.x = Math.min(0, R[0]), I.y = Math.min(0, R[1]), I.width = R[0] < 0 ? Math.max(Math.abs(R[0]), Y.width - R[0]) : Math.max(Math.abs(R[0]), Y.width), I.height = R[1] < 0 ? Math.max(Math.abs(R[1]), Y.height - Math.abs(R[1])) : Math.max(Math.abs(R[1]), Y.height), this.tracker ? this.tracker.attr(I) : (this.tracker = T.renderer.rect(I).addClass("highcharts-tracker").add(T), B.styledMode || this.tracker.attr({ fill: "rgba(0,0,0,0)" }));
        }
        styledModeFormat(B) {
          return B.replace('style="font-size: 0.8em"', 'class="highcharts-header"').replace(/style="color:{(point|series)\.color}"/g, 'class="highcharts-color-{$1.colorIndex} {series.options.className} {point.options.className}"');
        }
        tooltipFooterHeaderFormatter(B, T) {
          let O = B.series, I = O.tooltipOptions, R = O.xAxis, Y = R && R.dateTime, F = { isFooter: T, labelConfig: B }, U = I.xDateFormat, Q = I[T ? "footerFormat" : "headerFormat"];
          return k(this, "headerFormatter", F, function(J) {
            Y && !U && $(B.key) && (U = Y.getXDateFormat(B.key, I.dateTimeLabelFormats)), Y && U && (B.point && B.point.tooltipDateKeys || ["key"]).forEach(function(ee) {
              Q = Q.replace("{point." + ee + "}", "{point." + ee + ":" + U + "}");
            }), O.chart.styledMode && (Q = this.styledModeFormat(Q)), J.text = m(Q, { point: B, series: O }, this.chart);
          }), F.text;
        }
        update(B) {
          this.destroy(), this.init(this.chart, N(!0, this.options, B));
        }
        updatePosition(B) {
          let { chart: T, container: O, distance: I, options: R, pointer: Y, renderer: F } = this, { height: U = 0, width: Q = 0 } = this.getLabel(), { left: J, top: ee, scaleX: V, scaleY: G } = Y.getChartPosition(), W = (R.positioner || this.getPosition).call(this, Q, U, B), ae = (B.plotX || 0) + T.plotLeft, z = (B.plotY || 0) + T.plotTop, q;
          F && O && (R.positioner && (W.x += J - I, W.y += ee - I), q = (R.borderWidth || 0) + 2 * I + 2, F.setSize(Q + q, U + q, !1), (V !== 1 || G !== 1) && (S(O, { transform: `scale(${V}, ${G})` }), ae *= V, z *= G), ae += J - W.x, z += ee - W.y), this.move(Math.round(W.x), Math.round(W.y || 0), ae, z);
        }
      }
      return (y = p || (p = {})).compose = function(L) {
        D(h, "Core.Tooltip") && P(L, "afterInit", function() {
          let B = this.chart;
          B.options.tooltip && (B.tooltip = new y(B, B.options.tooltip, this));
        });
      }, p;
    }), i(n, "Core/Series/Point.js", [n["Core/Renderer/HTML/AST.js"], n["Core/Animation/AnimationUtilities.js"], n["Core/Defaults.js"], n["Core/Templating.js"], n["Core/Utilities.js"]], function(o, a, r, s, l) {
      let { animObject: d } = a, { defaultOptions: y } = r, { format: u } = s, { addEvent: m, crisp: h, erase: c, extend: g, fireEvent: v, getNestedProperty: P, isArray: f, isFunction: S, isNumber: w, isObject: x, merge: k, pick: A, syncTimeout: $, removeEvent: j, uniqueKey: N } = l;
      class M {
        animateBeforeDestroy() {
          let C = this, b = { x: C.startXPos, opacity: 0 }, p = C.getGraphicalProps();
          p.singular.forEach(function(L) {
            C[L] = C[L].animate(L === "dataLabel" ? { x: C[L].startXPos, y: C[L].startYPos, opacity: 0 } : b);
          }), p.plural.forEach(function(L) {
            C[L].forEach(function(B) {
              B.element && B.animate(g({ x: C.startXPos }, B.startYPos ? { x: B.startXPos, y: B.startYPos } : {}));
            });
          });
        }
        applyOptions(C, b) {
          let p = this.series, L = p.options.pointValKey || p.pointValKey;
          return g(this, C = M.prototype.optionsToObject.call(this, C)), this.options = this.options ? g(this.options, C) : C, C.group && delete this.group, C.dataLabels && delete this.dataLabels, L && (this.y = M.prototype.getNestedProperty.call(this, L)), this.selected && (this.state = "select"), "name" in this && b === void 0 && p.xAxis && p.xAxis.hasNames && (this.x = p.xAxis.nameToX(this)), this.x === void 0 && p ? this.x = b ?? p.autoIncrement() : w(C.x) && p.options.relativeXValue && (this.x = p.autoIncrement(C.x)), this.isNull = this.isValid && !this.isValid(), this.formatPrefix = this.isNull ? "null" : "point", this;
        }
        destroy() {
          if (!this.destroyed) {
            let C = this, b = C.series, p = b.chart, L = b.options.dataSorting, B = p.hoverPoints, T = d(C.series.chart.renderer.globalAnimation), O = () => {
              for (let I in (C.graphic || C.graphics || C.dataLabel || C.dataLabels) && (j(C), C.destroyElements()), C)
                delete C[I];
            };
            C.legendItem && p.legend.destroyItem(C), B && (C.setState(), c(B, C), B.length || (p.hoverPoints = null)), C === p.hoverPoint && C.onMouseOut(), L && L.enabled ? (this.animateBeforeDestroy(), $(O, T.duration)) : O(), p.pointCount--;
          }
          this.destroyed = !0;
        }
        destroyElements(C) {
          let b = this, p = b.getGraphicalProps(C);
          p.singular.forEach(function(L) {
            b[L] = b[L].destroy();
          }), p.plural.forEach(function(L) {
            b[L].forEach(function(B) {
              B && B.element && B.destroy();
            }), delete b[L];
          });
        }
        firePointEvent(C, b, p) {
          let L = this, B = this.series.options;
          L.manageEvent(C), C === "click" && B.allowPointSelect && (p = function(T) {
            !L.destroyed && L.select && L.select(null, T.ctrlKey || T.metaKey || T.shiftKey);
          }), v(L, C, b, p);
        }
        getClassName() {
          return "highcharts-point" + (this.selected ? " highcharts-point-select" : "") + (this.negative ? " highcharts-negative" : "") + (this.isNull ? " highcharts-null-point" : "") + (this.colorIndex !== void 0 ? " highcharts-color-" + this.colorIndex : "") + (this.options.className ? " " + this.options.className : "") + (this.zone && this.zone.className ? " " + this.zone.className.replace("highcharts-negative", "") : "");
        }
        getGraphicalProps(C) {
          let b, p, L = this, B = [], T = { singular: [], plural: [] };
          for ((C = C || { graphic: 1, dataLabel: 1 }).graphic && B.push("graphic", "connector"), C.dataLabel && B.push("dataLabel", "dataLabelPath", "dataLabelUpper"), p = B.length; p--; )
            L[b = B[p]] && T.singular.push(b);
          return ["graphic", "dataLabel"].forEach(function(O) {
            let I = O + "s";
            C[O] && L[I] && T.plural.push(I);
          }), T;
        }
        getLabelConfig() {
          return { x: this.category, y: this.y, color: this.color, colorIndex: this.colorIndex, key: this.name || this.category, series: this.series, point: this, percentage: this.percentage, total: this.total || this.stackTotal };
        }
        getNestedProperty(C) {
          return C ? C.indexOf("custom.") === 0 ? P(C, this.options) : this[C] : void 0;
        }
        getZone() {
          let C = this.series, b = C.zones, p = C.zoneAxis || "y", L, B = 0;
          for (L = b[0]; this[p] >= L.value; )
            L = b[++B];
          return this.nonZonedColor || (this.nonZonedColor = this.color), L && L.color && !this.options.color ? this.color = L.color : this.color = this.nonZonedColor, L;
        }
        hasNewShapeType() {
          return (this.graphic && (this.graphic.symbolName || this.graphic.element.nodeName)) !== this.shapeType;
        }
        constructor(C, b, p) {
          this.formatPrefix = "point", this.visible = !0, this.series = C, this.applyOptions(b, p), this.id ?? (this.id = N()), this.resolveColor(), C.chart.pointCount++, v(this, "afterInit");
        }
        isValid() {
          return (w(this.x) || this.x instanceof Date) && w(this.y);
        }
        optionsToObject(C) {
          let b = this.series, p = b.options.keys, L = p || b.pointArrayMap || ["y"], B = L.length, T = {}, O, I = 0, R = 0;
          if (w(C) || C === null)
            T[L[0]] = C;
          else if (f(C))
            for (!p && C.length > B && ((O = typeof C[0]) == "string" ? T.name = C[0] : O === "number" && (T.x = C[0]), I++); R < B; )
              p && C[I] === void 0 || (L[R].indexOf(".") > 0 ? M.prototype.setNestedProperty(T, C[I], L[R]) : T[L[R]] = C[I]), I++, R++;
          else
            typeof C == "object" && (T = C, C.dataLabels && (b.hasDataLabels = () => !0), C.marker && (b._hasPointMarkers = !0));
          return T;
        }
        pos(C, b = this.plotY) {
          if (!this.destroyed) {
            let { plotX: p, series: L } = this, { chart: B, xAxis: T, yAxis: O } = L, I = 0, R = 0;
            if (w(p) && w(b))
              return C && (I = T ? T.pos : B.plotLeft, R = O ? O.pos : B.plotTop), B.inverted && T && O ? [O.len - b + R, T.len - p + I] : [p + I, b + R];
          }
        }
        resolveColor() {
          let C = this.series, b = C.chart.options.chart, p = C.chart.styledMode, L, B, T = b.colorCount, O;
          delete this.nonZonedColor, C.options.colorByPoint ? (p || (L = (B = C.options.colors || C.chart.options.colors)[C.colorCounter], T = B.length), O = C.colorCounter, C.colorCounter++, C.colorCounter === T && (C.colorCounter = 0)) : (p || (L = C.color), O = C.colorIndex), this.colorIndex = A(this.options.colorIndex, O), this.color = A(this.options.color, L);
        }
        setNestedProperty(C, b, p) {
          return p.split(".").reduce(function(L, B, T, O) {
            let I = O.length - 1 === T;
            return L[B] = I ? b : x(L[B], !0) ? L[B] : {}, L[B];
          }, C), C;
        }
        shouldDraw() {
          return !this.isNull;
        }
        tooltipFormatter(C) {
          let b = this.series, p = b.tooltipOptions, L = A(p.valueDecimals, ""), B = p.valuePrefix || "", T = p.valueSuffix || "";
          return b.chart.styledMode && (C = b.chart.tooltip.styledModeFormat(C)), (b.pointArrayMap || ["y"]).forEach(function(O) {
            O = "{point." + O, (B || T) && (C = C.replace(RegExp(O + "}", "g"), B + O + "}" + T)), C = C.replace(RegExp(O + "}", "g"), O + ":,." + L + "f}");
          }), u(C, { point: this, series: this.series }, b.chart);
        }
        update(C, b, p, L) {
          let B, T = this, O = T.series, I = T.graphic, R = O.chart, Y = O.options;
          function F() {
            T.applyOptions(C);
            let U = I && T.hasMockGraphic, Q = T.y === null ? !U : U;
            I && Q && (T.graphic = I.destroy(), delete T.hasMockGraphic), x(C, !0) && (I && I.element && C && C.marker && C.marker.symbol !== void 0 && (T.graphic = I.destroy()), C?.dataLabels && T.dataLabel && (T.dataLabel = T.dataLabel.destroy())), B = T.index, O.updateParallelArrays(T, B), Y.data[B] = x(Y.data[B], !0) || x(C, !0) ? T.options : A(C, Y.data[B]), O.isDirty = O.isDirtyData = !0, !O.fixedBox && O.hasCartesianSeries && (R.isDirtyBox = !0), Y.legendType === "point" && (R.isDirtyLegend = !0), b && R.redraw(p);
          }
          b = A(b, !0), L === !1 ? F() : T.firePointEvent("update", { options: C }, F);
        }
        remove(C, b) {
          this.series.removePoint(this.series.data.indexOf(this), C, b);
        }
        select(C, b) {
          let p = this, L = p.series, B = L.chart;
          C = A(C, !p.selected), this.selectedStaging = C, p.firePointEvent(C ? "select" : "unselect", { accumulate: b }, function() {
            p.selected = p.options.selected = C, L.options.data[L.data.indexOf(p)] = p.options, p.setState(C && "select"), b || B.getSelectedPoints().forEach(function(T) {
              let O = T.series;
              T.selected && T !== p && (T.selected = T.options.selected = !1, O.options.data[O.data.indexOf(T)] = T.options, T.setState(B.hoverPoints && O.options.inactiveOtherPoints ? "inactive" : ""), T.firePointEvent("unselect"));
            });
          }), delete this.selectedStaging;
        }
        onMouseOver(C) {
          let { inverted: b, pointer: p } = this.series.chart;
          p && (C = C ? p.normalize(C) : p.getChartCoordinatesFromPoint(this, b), p.runPointActions(C, this));
        }
        onMouseOut() {
          let C = this.series.chart;
          this.firePointEvent("mouseOut"), this.series.options.inactiveOtherPoints || (C.hoverPoints || []).forEach(function(b) {
            b.setState();
          }), C.hoverPoints = C.hoverPoint = null;
        }
        manageEvent(C) {
          let b = k(this.series.options.point, this.options), p = b.events?.[C];
          S(p) && (!this.hcEvents?.[C] || this.hcEvents?.[C]?.map((L) => L.fn).indexOf(p) === -1) ? (this.importedUserEvent?.(), this.importedUserEvent = m(this, C, p)) : this.importedUserEvent && !p && this.hcEvents?.[C] && (j(this, C), delete this.hcEvents[C], Object.keys(this.hcEvents) || delete this.importedUserEvent);
        }
        setState(C, b) {
          let p = this.series, L = this.state, B = p.options.states[C || "normal"] || {}, T = y.plotOptions[p.type].marker && p.options.marker, O = T && T.enabled === !1, I = T && T.states && T.states[C || "normal"] || {}, R = I.enabled === !1, Y = this.marker || {}, F = p.chart, U = T && p.markerAttribs, Q = p.halo, J, ee, V, G = p.stateMarkerGraphic, W;
          if ((C = C || "") === this.state && !b || this.selected && C !== "select" || B.enabled === !1 || C && (R || O && I.enabled === !1) || C && Y.states && Y.states[C] && Y.states[C].enabled === !1)
            return;
          if (this.state = C, U && (J = p.markerAttribs(this, C)), this.graphic && !this.hasMockGraphic) {
            if (L && this.graphic.removeClass("highcharts-point-" + L), C && this.graphic.addClass("highcharts-point-" + C), !F.styledMode) {
              ee = p.pointAttribs(this, C), V = A(F.options.chart.animation, B.animation);
              let Z = ee.opacity;
              p.options.inactiveOtherPoints && w(Z) && (this.dataLabels || []).forEach(function(ne) {
                ne && !ne.hasClass("highcharts-data-label-hidden") && (ne.animate({ opacity: Z }, V), ne.connector && ne.connector.animate({ opacity: Z }, V));
              }), this.graphic.animate(ee, V);
            }
            J && this.graphic.animate(J, A(F.options.chart.animation, I.animation, T.animation)), G && G.hide();
          } else
            C && I && (W = Y.symbol || p.symbol, G && G.currentSymbol !== W && (G = G.destroy()), J && (G ? G[b ? "animate" : "attr"]({ x: J.x, y: J.y }) : W && (p.stateMarkerGraphic = G = F.renderer.symbol(W, J.x, J.y, J.width, J.height).add(p.markerGroup), G.currentSymbol = W)), !F.styledMode && G && this.state !== "inactive" && G.attr(p.pointAttribs(this, C))), G && (G[C && this.isInside ? "show" : "hide"](), G.element.point = this, G.addClass(this.getClassName(), !0));
          let ae = B.halo, z = this.graphic || G, q = z && z.visibility || "inherit";
          ae && ae.size && z && q !== "hidden" && !this.isCluster ? (Q || (p.halo = Q = F.renderer.path().add(z.parentGroup)), Q.show()[b ? "animate" : "attr"]({ d: this.haloPath(ae.size) }), Q.attr({ class: "highcharts-halo highcharts-color-" + A(this.colorIndex, p.colorIndex) + (this.className ? " " + this.className : ""), visibility: q, zIndex: -1 }), Q.point = this, F.styledMode || Q.attr(g({ fill: this.color || p.color, "fill-opacity": ae.opacity }, o.filterUserAttributes(ae.attributes || {})))) : Q?.point?.haloPath && !Q.point.destroyed && Q.animate({ d: Q.point.haloPath(0) }, null, Q.hide), v(this, "afterSetState", { state: C });
        }
        haloPath(C) {
          let b = this.pos();
          return b ? this.series.chart.renderer.symbols.circle(h(b[0], 1) - C, b[1] - C, 2 * C, 2 * C) : [];
        }
      }
      return M;
    }), i(n, "Core/Pointer.js", [n["Core/Color/Color.js"], n["Core/Globals.js"], n["Core/Utilities.js"]], function(o, a, r) {
      var s;
      let { parse: l } = o, { charts: d, composed: y, isTouchDevice: u } = a, { addEvent: m, attr: h, css: c, extend: g, find: v, fireEvent: P, isNumber: f, isObject: S, objectEach: w, offset: x, pick: k, pushUnique: A, splat: $ } = r;
      class j {
        applyInactiveState(M) {
          let D = [], C;
          (M || []).forEach(function(b) {
            C = b.series, D.push(C), C.linkedParent && D.push(C.linkedParent), C.linkedSeries && (D = D.concat(C.linkedSeries)), C.navigatorSeries && D.push(C.navigatorSeries);
          }), this.chart.series.forEach(function(b) {
            D.indexOf(b) === -1 ? b.setState("inactive", !0) : b.options.inactiveOtherPoints && b.setAllPointsToState("inactive");
          });
        }
        destroy() {
          let M = this;
          this.eventsToUnbind.forEach((D) => D()), this.eventsToUnbind = [], !a.chartCount && (j.unbindDocumentMouseUp && j.unbindDocumentMouseUp.forEach((D) => D()), j.unbindDocumentTouchEnd && (j.unbindDocumentTouchEnd = j.unbindDocumentTouchEnd())), clearInterval(M.tooltipTimeout), w(M, function(D, C) {
            M[C] = void 0;
          });
        }
        getSelectionMarkerAttrs(M, D) {
          let C = { args: { chartX: M, chartY: D }, attrs: {}, shapeType: "rect" };
          return P(this, "getSelectionMarkerAttrs", C, (b) => {
            let p, { chart: L, zoomHor: B, zoomVert: T } = this, { mouseDownX: O = 0, mouseDownY: I = 0 } = L, R = b.attrs;
            R.x = L.plotLeft, R.y = L.plotTop, R.width = B ? 1 : L.plotWidth, R.height = T ? 1 : L.plotHeight, B && (p = M - O, R.width = Math.max(1, Math.abs(p)), R.x = (p > 0 ? 0 : p) + O), T && (p = D - I, R.height = Math.max(1, Math.abs(p)), R.y = (p > 0 ? 0 : p) + I);
          }), C;
        }
        drag(M) {
          let { chart: D } = this, { mouseDownX: C = 0, mouseDownY: b = 0 } = D, { panning: p, panKey: L, selectionMarkerFill: B } = D.options.chart, T = D.plotLeft, O = D.plotTop, I = D.plotWidth, R = D.plotHeight, Y = S(p) ? p.enabled : p, F = L && M[`${L}Key`], U = M.chartX, Q = M.chartY, J, ee = this.selectionMarker;
          if ((!ee || !ee.touch) && (U < T ? U = T : U > T + I && (U = T + I), Q < O ? Q = O : Q > O + R && (Q = O + R), this.hasDragged = Math.sqrt(Math.pow(C - U, 2) + Math.pow(b - Q, 2)), this.hasDragged > 10)) {
            J = D.isInsidePlot(C - T, b - O, { visiblePlotOnly: !0 });
            let { shapeType: V, attrs: G } = this.getSelectionMarkerAttrs(U, Q);
            (D.hasCartesianSeries || D.mapView) && this.hasZoom && J && !F && !ee && (this.selectionMarker = ee = D.renderer[V](), ee.attr({ class: "highcharts-selection-marker", zIndex: 7 }).add(), D.styledMode || ee.attr({ fill: B || l("#334eff").setOpacity(0.25).get() })), ee && ee.attr(G), J && !ee && Y && D.pan(M, p);
          }
        }
        dragStart(M) {
          let D = this.chart;
          D.mouseIsDown = M.type, D.cancelClick = !1, D.mouseDownX = M.chartX, D.mouseDownY = M.chartY;
        }
        getSelectionBox(M) {
          let D = { args: { marker: M }, result: M.getBBox() };
          return P(this, "getSelectionBox", D), D.result;
        }
        drop(M) {
          let D, { chart: C, selectionMarker: b } = this;
          for (let p of C.axes)
            p.isPanning && (p.isPanning = !1, (p.options.startOnTick || p.options.endOnTick || p.series.some((L) => L.boosted)) && (p.forceRedraw = !0, p.setExtremes(p.userMin, p.userMax, !1), D = !0));
          if (D && C.redraw(), b && M) {
            if (this.hasDragged) {
              let p = this.getSelectionBox(b);
              C.transform({ axes: C.axes.filter((L) => L.zoomEnabled && (L.coll === "xAxis" && this.zoomX || L.coll === "yAxis" && this.zoomY)), selection: { originalEvent: M, xAxis: [], yAxis: [], ...p }, from: p });
            }
            f(C.index) && (this.selectionMarker = b.destroy());
          }
          C && f(C.index) && (c(C.container, { cursor: C._cursor }), C.cancelClick = this.hasDragged > 10, C.mouseIsDown = !1, this.hasDragged = 0, this.pinchDown = []);
        }
        findNearestKDPoint(M, D, C) {
          let b;
          return M.forEach(function(p) {
            let L = !(p.noSharedTooltip && D) && 0 > p.options.findNearestPointBy.indexOf("y"), B = p.searchPoint(C, L);
            S(B, !0) && B.series && (!S(b, !0) || function(T, O) {
              let I = T.distX - O.distX, R = T.dist - O.dist, Y = O.series.group?.zIndex - T.series.group?.zIndex;
              return I !== 0 && D ? I : R !== 0 ? R : Y !== 0 ? Y : T.series.index > O.series.index ? -1 : 1;
            }(b, B) > 0) && (b = B);
          }), b;
        }
        getChartCoordinatesFromPoint(M, D) {
          let { xAxis: C, yAxis: b } = M.series, p = M.shapeArgs;
          if (C && b) {
            let L = M.clientX ?? M.plotX ?? 0, B = M.plotY || 0;
            return M.isNode && p && f(p.x) && f(p.y) && (L = p.x, B = p.y), D ? { chartX: b.len + b.pos - B, chartY: C.len + C.pos - L } : { chartX: L + C.pos, chartY: B + b.pos };
          }
          if (p && p.x && p.y)
            return { chartX: p.x, chartY: p.y };
        }
        getChartPosition() {
          if (this.chartPosition)
            return this.chartPosition;
          let { container: M } = this.chart, D = x(M);
          this.chartPosition = { left: D.left, top: D.top, scaleX: 1, scaleY: 1 };
          let { offsetHeight: C, offsetWidth: b } = M;
          return b > 2 && C > 2 && (this.chartPosition.scaleX = D.width / b, this.chartPosition.scaleY = D.height / C), this.chartPosition;
        }
        getCoordinates(M) {
          let D = { xAxis: [], yAxis: [] };
          for (let C of this.chart.axes)
            D[C.isXAxis ? "xAxis" : "yAxis"].push({ axis: C, value: C.toValue(M[C.horiz ? "chartX" : "chartY"]) });
          return D;
        }
        getHoverData(M, D, C, b, p, L) {
          let B = [], T = function(F) {
            return F.visible && !(!p && F.directTouch) && k(F.options.enableMouseTracking, !0);
          }, O = D, I, R = { chartX: L ? L.chartX : void 0, chartY: L ? L.chartY : void 0, shared: p };
          P(this, "beforeGetHoverData", R), I = O && !O.stickyTracking ? [O] : C.filter((F) => F.stickyTracking && (R.filter || T)(F));
          let Y = b && M || !L ? M : this.findNearestKDPoint(I, p, L);
          return O = Y && Y.series, Y && (p && !O.noSharedTooltip ? (I = C.filter(function(F) {
            return R.filter ? R.filter(F) : T(F) && !F.noSharedTooltip;
          })).forEach(function(F) {
            let U = v(F.points, function(Q) {
              return Q.x === Y.x && !Q.isNull;
            });
            S(U) && (F.boosted && F.boost && (U = F.boost.getPoint(U)), B.push(U));
          }) : B.push(Y)), P(this, "afterGetHoverData", R = { hoverPoint: Y }), { hoverPoint: R.hoverPoint, hoverSeries: O, hoverPoints: B };
        }
        getPointFromEvent(M) {
          let D = M.target, C;
          for (; D && !C; )
            C = D.point, D = D.parentNode;
          return C;
        }
        onTrackerMouseOut(M) {
          let D = this.chart, C = M.relatedTarget, b = D.hoverSeries;
          this.isDirectTouch = !1, !b || !C || b.stickyTracking || this.inClass(C, "highcharts-tooltip") || this.inClass(C, "highcharts-series-" + b.index) && this.inClass(C, "highcharts-tracker") || b.onMouseOut();
        }
        inClass(M, D) {
          let C = M, b;
          for (; C; ) {
            if (b = h(C, "class")) {
              if (b.indexOf(D) !== -1)
                return !0;
              if (b.indexOf("highcharts-container") !== -1)
                return !1;
            }
            C = C.parentElement;
          }
        }
        constructor(M, D) {
          this.hasDragged = 0, this.pointerCaptureEventsToUnbind = [], this.eventsToUnbind = [], this.options = D, this.chart = M, this.runChartClick = !!D.chart.events?.click, this.pinchDown = [], this.setDOMEvents(), P(this, "afterInit");
        }
        normalize(M, D) {
          let C = M.touches, b = C ? C.length ? C.item(0) : k(C.changedTouches, M.changedTouches)[0] : M;
          D || (D = this.getChartPosition());
          let p = b.pageX - D.left, L = b.pageY - D.top;
          return g(M, { chartX: Math.round(p /= D.scaleX), chartY: Math.round(L /= D.scaleY) });
        }
        onContainerClick(M) {
          let D = this.chart, C = D.hoverPoint, b = this.normalize(M), p = D.plotLeft, L = D.plotTop;
          !D.cancelClick && (C && this.inClass(b.target, "highcharts-tracker") ? (P(C.series, "click", g(b, { point: C })), D.hoverPoint && C.firePointEvent("click", b)) : (g(b, this.getCoordinates(b)), D.isInsidePlot(b.chartX - p, b.chartY - L, { visiblePlotOnly: !0 }) && P(D, "click", b)));
        }
        onContainerMouseDown(M) {
          let D = (1 & (M.buttons || M.button)) == 1;
          M = this.normalize(M), a.isFirefox && M.button !== 0 && this.onContainerMouseMove(M), (M.button === void 0 || D) && (this.zoomOption(M), D && M.preventDefault?.(), this.dragStart(M));
        }
        onContainerMouseLeave(M) {
          let { pointer: D } = d[k(j.hoverChartIndex, -1)] || {};
          M = this.normalize(M), this.onContainerMouseMove(M), D && !this.inClass(M.relatedTarget, "highcharts-tooltip") && (D.reset(), D.chartPosition = void 0);
        }
        onContainerMouseEnter() {
          delete this.chartPosition;
        }
        onContainerMouseMove(M) {
          let D = this.chart, C = D.tooltip, b = this.normalize(M);
          this.setHoverChartIndex(M), (D.mouseIsDown === "mousedown" || this.touchSelect(b)) && this.drag(b), !D.openMenu && (this.inClass(b.target, "highcharts-tracker") || D.isInsidePlot(b.chartX - D.plotLeft, b.chartY - D.plotTop, { visiblePlotOnly: !0 })) && !(C && C.shouldStickOnContact(b)) && (this.inClass(b.target, "highcharts-no-tooltip") ? this.reset(!1, 0) : this.runPointActions(b));
        }
        onDocumentTouchEnd(M) {
          this.onDocumentMouseUp(M);
        }
        onContainerTouchMove(M) {
          this.touchSelect(M) ? this.onContainerMouseMove(M) : this.touch(M);
        }
        onContainerTouchStart(M) {
          this.touchSelect(M) ? this.onContainerMouseDown(M) : (this.zoomOption(M), this.touch(M, !0));
        }
        onDocumentMouseMove(M) {
          let D = this.chart, C = D.tooltip, b = this.chartPosition, p = this.normalize(M, b);
          !b || D.isInsidePlot(p.chartX - D.plotLeft, p.chartY - D.plotTop, { visiblePlotOnly: !0 }) || C && C.shouldStickOnContact(p) || p.target !== D.container.ownerDocument && this.inClass(p.target, "highcharts-tracker") || this.reset();
        }
        onDocumentMouseUp(M) {
          d[k(j.hoverChartIndex, -1)]?.pointer?.drop(M);
        }
        pinch(M) {
          let D = this, { chart: C, hasZoom: b, lastTouches: p } = D, L = [].map.call(M.touches || [], (R) => D.normalize(R)), B = L.length, T = B === 1 && (D.inClass(M.target, "highcharts-tracker") && C.runTrackerClick || D.runChartClick), O = C.tooltip, I = B === 1 && k(O?.options.followTouchMove, !0);
          B > 1 ? D.initiated = !0 : I && (D.initiated = !1), b && D.initiated && !T && M.cancelable !== !1 && M.preventDefault(), M.type === "touchstart" ? (D.pinchDown = L, D.res = !0, C.mouseDownX = M.chartX) : I ? this.runPointActions(D.normalize(M)) : p && (P(C, "touchpan", { originalEvent: M, touches: L }, () => {
            let R = (Y) => {
              let F = Y[0], U = Y[1] || F;
              return { x: F.chartX, y: F.chartY, width: U.chartX - F.chartX, height: U.chartY - F.chartY };
            };
            C.transform({ axes: C.axes.filter((Y) => Y.zoomEnabled && (this.zoomHor && Y.horiz || this.zoomVert && !Y.horiz)), to: R(L), from: R(p), trigger: M.type });
          }), D.res && (D.res = !1, this.reset(!1, 0))), D.lastTouches = L;
        }
        reset(M, D) {
          let C = this.chart, b = C.hoverSeries, p = C.hoverPoint, L = C.hoverPoints, B = C.tooltip, T = B && B.shared ? L : p;
          M && T && $(T).forEach(function(O) {
            O.series.isCartesian && O.plotX === void 0 && (M = !1);
          }), M ? B && T && $(T).length && (B.refresh(T), B.shared && L ? L.forEach(function(O) {
            O.setState(O.state, !0), O.series.isCartesian && (O.series.xAxis.crosshair && O.series.xAxis.drawCrosshair(null, O), O.series.yAxis.crosshair && O.series.yAxis.drawCrosshair(null, O));
          }) : p && (p.setState(p.state, !0), C.axes.forEach(function(O) {
            O.crosshair && p.series[O.coll] === O && O.drawCrosshair(null, p);
          }))) : (p && p.onMouseOut(), L && L.forEach(function(O) {
            O.setState();
          }), b && b.onMouseOut(), B && B.hide(D), this.unDocMouseMove && (this.unDocMouseMove = this.unDocMouseMove()), C.axes.forEach(function(O) {
            O.hideCrosshair();
          }), C.hoverPoints = C.hoverPoint = void 0);
        }
        runPointActions(M, D, C) {
          let b = this.chart, p = b.series, L = b.tooltip && b.tooltip.options.enabled ? b.tooltip : void 0, B = !!L && L.shared, T = D || b.hoverPoint, O = T && T.series || b.hoverSeries, I = (!M || M.type !== "touchmove") && (!!D || O && O.directTouch && this.isDirectTouch), R = this.getHoverData(T, O, p, I, B, M);
          T = R.hoverPoint, O = R.hoverSeries;
          let Y = R.hoverPoints, F = O && O.tooltipOptions.followPointer && !O.tooltipOptions.split, U = B && O && !O.noSharedTooltip;
          if (T && (C || T !== b.hoverPoint || L && L.isHidden)) {
            if ((b.hoverPoints || []).forEach(function(Q) {
              Y.indexOf(Q) === -1 && Q.setState();
            }), b.hoverSeries !== O && O.onMouseOver(), this.applyInactiveState(Y), (Y || []).forEach(function(Q) {
              Q.setState("hover");
            }), b.hoverPoint && b.hoverPoint.firePointEvent("mouseOut"), !T.series)
              return;
            b.hoverPoints = Y, b.hoverPoint = T, T.firePointEvent("mouseOver", void 0, () => {
              L && T && L.refresh(U ? Y : T, M);
            });
          } else if (F && L && !L.isHidden) {
            let Q = L.getAnchor([{}], M);
            b.isInsidePlot(Q[0], Q[1], { visiblePlotOnly: !0 }) && L.updatePosition({ plotX: Q[0], plotY: Q[1] });
          }
          this.unDocMouseMove || (this.unDocMouseMove = m(b.container.ownerDocument, "mousemove", (Q) => d[j.hoverChartIndex ?? -1]?.pointer?.onDocumentMouseMove(Q)), this.eventsToUnbind.push(this.unDocMouseMove)), b.axes.forEach(function(Q) {
            let J, ee = k((Q.crosshair || {}).snap, !0);
            !ee || (J = b.hoverPoint) && J.series[Q.coll] === Q || (J = v(Y, (V) => V.series && V.series[Q.coll] === Q)), J || !ee ? Q.drawCrosshair(M, J) : Q.hideCrosshair();
          });
        }
        setDOMEvents() {
          let M = this.chart.container, D = M.ownerDocument;
          M.onmousedown = this.onContainerMouseDown.bind(this), M.onmousemove = this.onContainerMouseMove.bind(this), M.onclick = this.onContainerClick.bind(this), this.eventsToUnbind.push(m(M, "mouseenter", this.onContainerMouseEnter.bind(this)), m(M, "mouseleave", this.onContainerMouseLeave.bind(this))), j.unbindDocumentMouseUp || (j.unbindDocumentMouseUp = []), j.unbindDocumentMouseUp.push(m(D, "mouseup", this.onDocumentMouseUp.bind(this)));
          let C = this.chart.renderTo.parentElement;
          for (; C && C.tagName !== "BODY"; )
            this.eventsToUnbind.push(m(C, "scroll", () => {
              delete this.chartPosition;
            })), C = C.parentElement;
          this.eventsToUnbind.push(m(M, "touchstart", this.onContainerTouchStart.bind(this), { passive: !1 }), m(M, "touchmove", this.onContainerTouchMove.bind(this), { passive: !1 })), j.unbindDocumentTouchEnd || (j.unbindDocumentTouchEnd = m(D, "touchend", this.onDocumentTouchEnd.bind(this), { passive: !1 })), this.setPointerCapture(), m(this.chart, "redraw", this.setPointerCapture.bind(this));
        }
        setPointerCapture() {
          if (!u)
            return;
          let M = this.pointerCaptureEventsToUnbind, D = this.chart, C = D.container, b = k(D.options.tooltip?.followTouchMove, !0) && D.series.some((p) => p.options.findNearestPointBy.indexOf("y") > -1);
          !this.hasPointerCapture && b ? (M.push(m(C, "pointerdown", (p) => {
            p.target?.hasPointerCapture(p.pointerId) && p.target?.releasePointerCapture(p.pointerId);
          }), m(C, "pointermove", (p) => {
            D.pointer?.getPointFromEvent(p)?.onMouseOver(p);
          })), D.styledMode || c(C, { "touch-action": "none" }), C.className += " highcharts-no-touch-action", this.hasPointerCapture = !0) : this.hasPointerCapture && !b && (M.forEach((p) => p()), M.length = 0, D.styledMode || c(C, { "touch-action": k(D.options.chart.style?.["touch-action"], "manipulation") }), C.className = C.className.replace(" highcharts-no-touch-action", ""), this.hasPointerCapture = !1);
        }
        setHoverChartIndex(M) {
          let D = this.chart, C = a.charts[k(j.hoverChartIndex, -1)];
          if (C && C !== D) {
            let b = { relatedTarget: D.container };
            M && !M?.relatedTarget && (M = { ...b, ...M }), C.pointer?.onContainerMouseLeave(M || b);
          }
          C && C.mouseIsDown || (j.hoverChartIndex = D.index);
        }
        touch(M, D) {
          let C, { chart: b, pinchDown: p = [] } = this;
          this.setHoverChartIndex(), (M = this.normalize(M)).touches.length === 1 ? b.isInsidePlot(M.chartX - b.plotLeft, M.chartY - b.plotTop, { visiblePlotOnly: !0 }) && !b.openMenu ? (D && this.runPointActions(M), M.type === "touchmove" && (C = !!p[0] && Math.pow(p[0].chartX - M.chartX, 2) + Math.pow(p[0].chartY - M.chartY, 2) >= 16), k(C, !0) && this.pinch(M)) : D && this.reset() : M.touches.length === 2 && this.pinch(M);
        }
        touchSelect(M) {
          return !!(this.chart.zooming.singleTouch && M.touches && M.touches.length === 1);
        }
        zoomOption(M) {
          let D = this.chart, C = D.inverted, b = D.zooming.type || "", p, L;
          /touch/.test(M.type) && (b = k(D.zooming.pinchType, b)), this.zoomX = p = /x/.test(b), this.zoomY = L = /y/.test(b), this.zoomHor = p && !C || L && C, this.zoomVert = L && !C || p && C, this.hasZoom = p || L;
        }
      }
      return (s = j || (j = {})).compose = function(N) {
        A(y, "Core.Pointer") && m(N, "beforeRender", function() {
          this.pointer = new s(this, this.options);
        });
      }, j;
    }), i(n, "Core/Legend/LegendSymbol.js", [n["Core/Utilities.js"]], function(o) {
      var a;
      let { extend: r, merge: s, pick: l } = o;
      return function(d) {
        function y(u, m, h) {
          let c = this.legendItem = this.legendItem || {}, { chart: g, options: v } = this, { baseline: P = 0, symbolWidth: f, symbolHeight: S } = u, w = this.symbol || "circle", x = S / 2, k = g.renderer, A = c.group, $ = P - Math.round((u.fontMetrics?.b || S) * (h ? 0.4 : 0.3)), j = {}, N, M = v.marker, D = 0;
          if (g.styledMode || (j["stroke-width"] = Math.min(v.lineWidth || 0, 24), v.dashStyle ? j.dashstyle = v.dashStyle : v.linecap === "square" || (j["stroke-linecap"] = "round")), c.line = k.path().addClass("highcharts-graph").attr(j).add(A), h && (c.area = k.path().addClass("highcharts-area").add(A)), j["stroke-linecap"] && (D = Math.min(c.line.strokeWidth(), f) / 2), f) {
            let C = [["M", D, $], ["L", f - D, $]];
            c.line.attr({ d: C }), c.area?.attr({ d: [...C, ["L", f - D, P], ["L", D, P]] });
          }
          if (M && M.enabled !== !1 && f) {
            let C = Math.min(l(M.radius, x), x);
            w.indexOf("url") === 0 && (M = s(M, { width: S, height: S }), C = 0), c.symbol = N = k.symbol(w, f / 2 - C, $ - C, 2 * C, 2 * C, r({ context: "legend" }, M)).addClass("highcharts-point").add(A), N.isMarker = !0;
          }
        }
        d.areaMarker = function(u, m) {
          y.call(this, u, m, !0);
        }, d.lineMarker = y, d.rectangle = function(u, m) {
          let h = m.legendItem || {}, c = u.options, g = u.symbolHeight, v = c.squareSymbol, P = v ? g : u.symbolWidth;
          h.symbol = this.chart.renderer.rect(v ? (u.symbolWidth - g) / 2 : 0, u.baseline - g + 1, P, g, l(u.options.symbolRadius, g / 2)).addClass("highcharts-point").attr({ zIndex: 3 }).add(h.group);
        };
      }(a || (a = {})), a;
    }), i(n, "Core/Series/SeriesDefaults.js", [], function() {
      return { lineWidth: 2, allowPointSelect: !1, crisp: !0, showCheckbox: !1, animation: { duration: 1e3 }, enableMouseTracking: !0, events: {}, marker: { enabledThreshold: 2, lineColor: "#ffffff", lineWidth: 0, radius: 4, states: { normal: { animation: !0 }, hover: { animation: { duration: 150 }, enabled: !0, radiusPlus: 2, lineWidthPlus: 1 }, select: { fillColor: "#cccccc", lineColor: "#000000", lineWidth: 2 } } }, point: { events: {} }, dataLabels: { animation: {}, align: "center", borderWidth: 0, defer: !0, formatter: function() {
        let { numberFormatter: o } = this.series.chart;
        return typeof this.y != "number" ? "" : o(this.y, -1);
      }, padding: 5, style: { fontSize: "0.7em", fontWeight: "bold", color: "contrast", textOutline: "1px contrast" }, verticalAlign: "bottom", x: 0, y: 0 }, cropThreshold: 300, opacity: 1, pointRange: 0, softThreshold: !0, states: { normal: { animation: !0 }, hover: { animation: { duration: 150 }, lineWidthPlus: 1, marker: {}, halo: { size: 10, opacity: 0.25 } }, select: { animation: { duration: 0 } }, inactive: { animation: { duration: 150 }, opacity: 0.2 } }, stickyTracking: !0, turboThreshold: 1e3, findNearestPointBy: "x" };
    }), i(n, "Core/Series/SeriesRegistry.js", [n["Core/Globals.js"], n["Core/Defaults.js"], n["Core/Series/Point.js"], n["Core/Utilities.js"]], function(o, a, r, s) {
      var l;
      let { defaultOptions: d } = a, { extend: y, extendClass: u, merge: m } = s;
      return function(h) {
        function c(g, v) {
          let P = d.plotOptions || {}, f = v.defaultOptions, S = v.prototype;
          return S.type = g, S.pointClass || (S.pointClass = r), !h.seriesTypes[g] && (f && (P[g] = f), h.seriesTypes[g] = v, !0);
        }
        h.seriesTypes = o.seriesTypes, h.registerSeriesType = c, h.seriesType = function(g, v, P, f, S) {
          let w = d.plotOptions || {};
          if (v = v || "", w[g] = m(w[v], P), delete h.seriesTypes[g], c(g, u(h.seriesTypes[v] || function() {
          }, f)), h.seriesTypes[g].prototype.type = g, S) {
            class x extends r {
            }
            y(x.prototype, S), h.seriesTypes[g].prototype.pointClass = x;
          }
          return h.seriesTypes[g];
        };
      }(l || (l = {})), l;
    }), i(n, "Core/Series/Series.js", [n["Core/Animation/AnimationUtilities.js"], n["Core/Defaults.js"], n["Core/Foundation.js"], n["Core/Globals.js"], n["Core/Legend/LegendSymbol.js"], n["Core/Series/Point.js"], n["Core/Series/SeriesDefaults.js"], n["Core/Series/SeriesRegistry.js"], n["Core/Renderer/SVG/SVGElement.js"], n["Core/Utilities.js"]], function(o, a, r, s, l, d, y, u, m, h) {
      let { animObject: c, setAnimation: g } = o, { defaultOptions: v } = a, { registerEventOptions: P } = r, { svg: f, win: S } = s, { seriesTypes: w } = u, { arrayMax: x, arrayMin: k, clamp: A, correctFloat: $, crisp: j, defined: N, destroyObjectProperties: M, diffObjects: D, erase: C, error: b, extend: p, find: L, fireEvent: B, getClosestDistance: T, getNestedProperty: O, insertItem: I, isArray: R, isNumber: Y, isString: F, merge: U, objectEach: Q, pick: J, removeEvent: ee, splat: V, syncTimeout: G } = h;
      class W {
        constructor() {
          this.zoneAxis = "y";
        }
        init(z, q) {
          let Z;
          B(this, "init", { options: q });
          let ne = this, ie = z.series;
          this.eventsToUnbind = [], ne.chart = z, ne.options = ne.setOptions(q);
          let re = ne.options, de = re.visible !== !1;
          ne.linkedSeries = [], ne.bindAxes(), p(ne, { name: re.name, state: "", visible: de, selected: re.selected === !0 }), P(this, re);
          let me = re.events;
          (me && me.click || re.point && re.point.events && re.point.events.click || re.allowPointSelect) && (z.runTrackerClick = !0), ne.getColor(), ne.getSymbol(), ne.parallelArrays.forEach(function(ce) {
            ne[ce + "Data"] || (ne[ce + "Data"] = []);
          }), ne.isCartesian && (z.hasCartesianSeries = !0), ie.length && (Z = ie[ie.length - 1]), ne._i = J(Z && Z._i, -1) + 1, ne.opacity = ne.options.opacity, z.orderItems("series", I(this, ie)), re.dataSorting && re.dataSorting.enabled ? ne.setDataSortingOptions() : ne.points || ne.data || ne.setData(re.data, !1), B(this, "afterInit");
        }
        is(z) {
          return w[z] && this instanceof w[z];
        }
        bindAxes() {
          let z, q = this, Z = q.options, ne = q.chart;
          B(this, "bindAxes", null, function() {
            (q.axisTypes || []).forEach(function(ie) {
              (ne[ie] || []).forEach(function(re) {
                z = re.options, (J(Z[ie], 0) === re.index || Z[ie] !== void 0 && Z[ie] === z.id) && (I(q, re.series), q[ie] = re, re.isDirty = !0);
              }), q[ie] || q.optionalAxis === ie || b(18, !0, ne);
            });
          }), B(this, "afterBindAxes");
        }
        updateParallelArrays(z, q, Z) {
          let ne = z.series, ie = Y(q) ? function(re) {
            let de = re === "y" && ne.toYData ? ne.toYData(z) : z[re];
            ne[re + "Data"][q] = de;
          } : function(re) {
            Array.prototype[q].apply(ne[re + "Data"], Z);
          };
          ne.parallelArrays.forEach(ie);
        }
        hasData() {
          return this.visible && this.dataMax !== void 0 && this.dataMin !== void 0 || this.visible && this.yData && this.yData.length > 0;
        }
        hasMarkerChanged(z, q) {
          let Z = z.marker, ne = q.marker || {};
          return Z && (ne.enabled && !Z.enabled || ne.symbol !== Z.symbol || ne.height !== Z.height || ne.width !== Z.width);
        }
        autoIncrement(z) {
          let q = this.options, Z = q.pointIntervalUnit, ne = q.relativeXValue, ie = this.chart.time, re = this.xIncrement, de, me;
          return re = J(re, q.pointStart, 0), this.pointInterval = me = J(this.pointInterval, q.pointInterval, 1), ne && Y(z) && (me *= z), Z && (de = new ie.Date(re), Z === "day" ? ie.set("Date", de, ie.get("Date", de) + me) : Z === "month" ? ie.set("Month", de, ie.get("Month", de) + me) : Z === "year" && ie.set("FullYear", de, ie.get("FullYear", de) + me), me = de.getTime() - re), ne && Y(z) ? re + me : (this.xIncrement = re + me, re);
        }
        setDataSortingOptions() {
          let z = this.options;
          p(this, { requireSorting: !1, sorted: !1, enabledDataSorting: !0, allowDG: !1 }), N(z.pointRange) || (z.pointRange = 1);
        }
        setOptions(z) {
          let q, Z = this.chart, ne = Z.options.plotOptions, ie = Z.userOptions || {}, re = U(z), de = Z.styledMode, me = { plotOptions: ne, userOptions: re };
          B(this, "setOptions", me);
          let ce = me.plotOptions[this.type], pe = ie.plotOptions || {}, xe = pe.series || {}, le = v.plotOptions[this.type] || {}, se = pe[this.type] || {};
          this.userOptions = me.userOptions;
          let he = U(ce, ne.series, se, re);
          this.tooltipOptions = U(v.tooltip, v.plotOptions.series?.tooltip, le?.tooltip, Z.userOptions.tooltip, pe.series?.tooltip, se.tooltip, re.tooltip), this.stickyTracking = J(re.stickyTracking, se.stickyTracking, xe.stickyTracking, !!this.tooltipOptions.shared && !this.noSharedTooltip || he.stickyTracking), ce.marker === null && delete he.marker, this.zoneAxis = he.zoneAxis || "y";
          let ve = this.zones = (he.zones || []).map((ye) => ({ ...ye }));
          return (he.negativeColor || he.negativeFillColor) && !he.zones && (q = { value: he[this.zoneAxis + "Threshold"] || he.threshold || 0, className: "highcharts-negative" }, de || (q.color = he.negativeColor, q.fillColor = he.negativeFillColor), ve.push(q)), ve.length && N(ve[ve.length - 1].value) && ve.push(de ? {} : { color: this.color, fillColor: this.fillColor }), B(this, "afterSetOptions", { options: he }), he;
        }
        getName() {
          return J(this.options.name, "Series " + (this.index + 1));
        }
        getCyclic(z, q, Z) {
          let ne, ie, re = this.chart, de = `${z}Index`, me = `${z}Counter`, ce = Z?.length || re.options.chart.colorCount;
          !q && (N(ie = J(z === "color" ? this.options.colorIndex : void 0, this[de])) ? ne = ie : (re.series.length || (re[me] = 0), ne = re[me] % ce, re[me] += 1), Z && (q = Z[ne])), ne !== void 0 && (this[de] = ne), this[z] = q;
        }
        getColor() {
          this.chart.styledMode ? this.getCyclic("color") : this.options.colorByPoint ? this.color = "#cccccc" : this.getCyclic("color", this.options.color || v.plotOptions[this.type].color, this.chart.options.colors);
        }
        getPointsCollection() {
          return (this.hasGroupedData ? this.points : this.data) || [];
        }
        getSymbol() {
          let z = this.options.marker;
          this.getCyclic("symbol", z.symbol, this.chart.options.symbols);
        }
        findPointIndex(z, q) {
          let Z, ne, ie, re = z.id, de = z.x, me = this.points, ce = this.options.dataSorting;
          if (re) {
            let pe = this.chart.get(re);
            pe instanceof d && (Z = pe);
          } else if (this.linkedParent || this.enabledDataSorting || this.options.relativeXValue) {
            let pe = (xe) => !xe.touched && xe.index === z.index;
            if (ce && ce.matchByName ? pe = (xe) => !xe.touched && xe.name === z.name : this.options.relativeXValue && (pe = (xe) => !xe.touched && xe.options.x === z.x), !(Z = L(me, pe)))
              return;
          }
          return Z && (ie = Z && Z.index) !== void 0 && (ne = !0), ie === void 0 && Y(de) && (ie = this.xData.indexOf(de, q)), ie !== -1 && ie !== void 0 && this.cropped && (ie = ie >= this.cropStart ? ie - this.cropStart : ie), !ne && Y(ie) && me[ie] && me[ie].touched && (ie = void 0), ie;
        }
        updateData(z, q) {
          let Z = this.options, ne = Z.dataSorting, ie = this.points, re = [], de = this.requireSorting, me = z.length === ie.length, ce, pe, xe, le, se = !0;
          if (this.xIncrement = null, z.forEach(function(he, ve) {
            let ye, be = N(he) && this.pointClass.prototype.optionsToObject.call({ series: this }, he) || {}, ke = be.x;
            be.id || Y(ke) ? ((ye = this.findPointIndex(be, le)) === -1 || ye === void 0 ? re.push(he) : ie[ye] && he !== Z.data[ye] ? (ie[ye].update(he, !1, null, !1), ie[ye].touched = !0, de && (le = ye + 1)) : ie[ye] && (ie[ye].touched = !0), (!me || ve !== ye || ne && ne.enabled || this.hasDerivedData) && (ce = !0)) : re.push(he);
          }, this), ce)
            for (pe = ie.length; pe--; )
              (xe = ie[pe]) && !xe.touched && xe.remove && xe.remove(!1, q);
          else
            !me || ne && ne.enabled ? se = !1 : (z.forEach(function(he, ve) {
              he === ie[ve].y || ie[ve].destroyed || ie[ve].update(he, !1, null, !1);
            }), re.length = 0);
          return ie.forEach(function(he) {
            he && (he.touched = !1);
          }), !!se && (re.forEach(function(he) {
            this.addPoint(he, !1, null, null, !1);
          }, this), this.xIncrement === null && this.xData && this.xData.length && (this.xIncrement = x(this.xData), this.autoIncrement()), !0);
        }
        setData(z, q = !0, Z, ne) {
          let ie = this, re = ie.points, de = re && re.length || 0, me = ie.options, ce = ie.chart, pe = me.dataSorting, xe = ie.xAxis, le = me.turboThreshold, se = this.xData, he = this.yData, ve = ie.pointArrayMap, ye = ve && ve.length, be = me.keys, ke, we, Le, Me = 0, De = 1, Ae;
          ce.options.chart.allowMutatingData || (me.data && delete ie.options.data, ie.userOptions.data && delete ie.userOptions.data, Ae = U(!0, z));
          let _e = (z = Ae || z || []).length;
          if (pe && pe.enabled && (z = this.sortData(z)), ce.options.chart.allowMutatingData && ne !== !1 && _e && de && !ie.cropped && !ie.hasGroupedData && ie.visible && !ie.boosted && (Le = this.updateData(z, Z)), !Le) {
            ie.xIncrement = null, ie.colorCounter = 0, this.parallelArrays.forEach(function(Ee) {
              ie[Ee + "Data"].length = 0;
            });
            let He = le && _e > le;
            if (He) {
              let Ee = ie.getFirstValidPoint(z), Ne = ie.getFirstValidPoint(z, _e - 1, -1), Ye = (Xe) => !!(R(Xe) && (be || Y(Xe[0])));
              if (Y(Ee) && Y(Ne))
                for (ke = 0; ke < _e; ke++)
                  se[ke] = this.autoIncrement(), he[ke] = z[ke];
              else if (Ye(Ee) && Ye(Ne))
                if (ye)
                  if (Ee.length === ye)
                    for (ke = 0; ke < _e; ke++)
                      se[ke] = this.autoIncrement(), he[ke] = z[ke];
                  else
                    for (ke = 0; ke < _e; ke++)
                      we = z[ke], se[ke] = we[0], he[ke] = we.slice(1, ye + 1);
                else if (be && (Me = be.indexOf("x"), De = be.indexOf("y"), Me = Me >= 0 ? Me : 0, De = De >= 0 ? De : 1), Ee.length === 1 && (De = 0), Me === De)
                  for (ke = 0; ke < _e; ke++)
                    se[ke] = this.autoIncrement(), he[ke] = z[ke][De];
                else
                  for (ke = 0; ke < _e; ke++)
                    we = z[ke], se[ke] = we[Me], he[ke] = we[De];
              else
                He = !1;
            }
            if (!He)
              for (ke = 0; ke < _e; ke++)
                we = { series: ie }, ie.pointClass.prototype.applyOptions.apply(we, [z[ke]]), ie.updateParallelArrays(we, ke);
            for (he && F(he[0]) && b(14, !0, ce), ie.data = [], ie.options.data = ie.userOptions.data = z, ke = de; ke--; )
              re[ke]?.destroy();
            xe && (xe.minRange = xe.userMinRange), ie.isDirty = ce.isDirtyBox = !0, ie.isDirtyData = !!re, Z = !1;
          }
          me.legendType === "point" && (this.processData(), this.generatePoints()), q && ce.redraw(Z);
        }
        sortData(z) {
          let q = this, Z = q.options.dataSorting.sortKey || "y", ne = function(ie, re) {
            return N(re) && ie.pointClass.prototype.optionsToObject.call({ series: ie }, re) || {};
          };
          return z.forEach(function(ie, re) {
            z[re] = ne(q, ie), z[re].index = re;
          }, this), z.concat().sort((ie, re) => {
            let de = O(Z, ie), me = O(Z, re);
            return me < de ? -1 : me > de ? 1 : 0;
          }).forEach(function(ie, re) {
            ie.x = re;
          }, this), q.linkedSeries && q.linkedSeries.forEach(function(ie) {
            let re = ie.options, de = re.data;
            re.dataSorting && re.dataSorting.enabled || !de || (de.forEach(function(me, ce) {
              de[ce] = ne(ie, me), z[ce] && (de[ce].x = z[ce].x, de[ce].index = ce);
            }), ie.setData(de, !1));
          }), z;
        }
        getProcessedData(z) {
          let q = this, Z = q.xAxis, ne = q.options.cropThreshold, ie = Z?.logarithmic, re = q.isCartesian, de, me, ce = 0, pe, xe, le, se = q.xData, he = q.yData, ve = !1, ye = se.length;
          Z && (xe = (pe = Z.getExtremes()).min, le = pe.max, ve = !!(Z.categories && !Z.names.length)), re && q.sorted && !z && (!ne || ye > ne || q.forceCrop) && (se[ye - 1] < xe || se[0] > le ? (se = [], he = []) : q.yData && (se[0] < xe || se[ye - 1] > le) && (se = (de = this.cropData(q.xData, q.yData, xe, le)).xData, he = de.yData, ce = de.start, me = !0));
          let be = T([ie ? se.map(ie.log2lin) : se], () => q.requireSorting && !ve && b(15, !1, q.chart));
          return { xData: se, yData: he, cropped: me, cropStart: ce, closestPointRange: be };
        }
        processData(z) {
          let q = this.xAxis;
          if (this.isCartesian && !this.isDirty && !q.isDirty && !this.yAxis.isDirty && !z)
            return !1;
          let Z = this.getProcessedData();
          this.cropped = Z.cropped, this.cropStart = Z.cropStart, this.processedXData = Z.xData, this.processedYData = Z.yData, this.closestPointRange = this.basePointRange = Z.closestPointRange, B(this, "afterProcessData");
        }
        cropData(z, q, Z, ne) {
          let ie = z.length, re, de, me = 0, ce = ie;
          for (re = 0; re < ie; re++)
            if (z[re] >= Z) {
              me = Math.max(0, re - 1);
              break;
            }
          for (de = re; de < ie; de++)
            if (z[de] > ne) {
              ce = de + 1;
              break;
            }
          return { xData: z.slice(me, ce), yData: q.slice(me, ce), start: me, end: ce };
        }
        generatePoints() {
          let z = this.options, q = this.processedData || z.data, Z = this.processedXData, ne = this.processedYData, ie = this.pointClass, re = Z.length, de = this.cropStart || 0, me = this.hasGroupedData, ce = z.keys, pe = [], xe = z.dataGrouping && z.dataGrouping.groupAll ? de : 0, le, se, he, ve, ye = this.data;
          if (!ye && !me) {
            let be = [];
            be.length = q.length, ye = this.data = be;
          }
          for (ce && me && (this.options.keys = !1), ve = 0; ve < re; ve++)
            se = de + ve, me ? ((he = new ie(this, [Z[ve]].concat(V(ne[ve])))).dataGroup = this.groupMap[xe + ve], he.dataGroup.options && (he.options = he.dataGroup.options, p(he, he.dataGroup.options), delete he.dataLabels)) : (he = ye[se]) || q[se] === void 0 || (ye[se] = he = new ie(this, q[se], Z[ve])), he && (he.index = me ? xe + ve : se, pe[ve] = he);
          if (this.options.keys = ce, ye && (re !== (le = ye.length) || me))
            for (ve = 0; ve < le; ve++)
              ve !== de || me || (ve += re), ye[ve] && (ye[ve].destroyElements(), ye[ve].plotX = void 0);
          this.data = ye, this.points = pe, B(this, "afterGeneratePoints");
        }
        getXExtremes(z) {
          return { min: k(z), max: x(z) };
        }
        getExtremes(z, q) {
          let Z = this.xAxis, ne = this.yAxis, ie = [], re = this.requireSorting && !this.is("column") ? 1 : 0, de = !!ne && ne.positiveValuesOnly, me = q || this.getExtremesFromAll || this.options.getExtremesFromAll, { processedXData: ce, processedYData: pe } = this, xe, le, se, he, ve, ye, be, ke = 0, we = 0, Le = 0;
          if (this.cropped && me) {
            let _e = this.getProcessedData(!0);
            ce = _e.xData, pe = _e.yData;
          }
          let Me = (z = z || this.stackedYData || pe || []).length, De = ce || this.xData;
          for (Z && (ke = (xe = Z.getExtremes()).min, we = xe.max), ye = 0; ye < Me; ye++)
            if (he = De[ye], le = (Y(ve = z[ye]) || R(ve)) && ((Y(ve) ? ve > 0 : ve.length) || !de), se = q || this.getExtremesFromAll || this.options.getExtremesFromAll || this.cropped || !Z || (De[ye + re] || he) >= ke && (De[ye - re] || he) <= we, le && se)
              if (be = ve.length)
                for (; be--; )
                  Y(ve[be]) && (ie[Le++] = ve[be]);
              else
                ie[Le++] = ve;
          let Ae = { activeYData: ie, dataMin: k(ie), dataMax: x(ie) };
          return B(this, "afterGetExtremes", { dataExtremes: Ae }), Ae;
        }
        applyExtremes() {
          let z = this.getExtremes();
          return this.dataMin = z.dataMin, this.dataMax = z.dataMax, z;
        }
        getFirstValidPoint(z, q = 0, Z = 1) {
          let ne = z.length, ie = q;
          for (; ie >= 0 && ie < ne; ) {
            if (N(z[ie]))
              return z[ie];
            ie += Z;
          }
        }
        translate() {
          this.processedXData || this.processData(), this.generatePoints();
          let z = this.options, q = z.stacking, Z = this.xAxis, ne = Z.categories, ie = this.enabledDataSorting, re = this.yAxis, de = this.points, me = de.length, ce = this.pointPlacementToXValue(), pe = !!ce, xe = z.threshold, le = z.startFromThreshold ? xe : 0, se, he, ve, ye, be = Number.MAX_VALUE;
          function ke(we) {
            return A(we, -1e9, 1e9);
          }
          for (se = 0; se < me; se++) {
            let we, Le = de[se], Me = Le.x, De, Ae, _e = Le.y, He = Le.low, Ee = q && re.stacking?.stacks[(this.negStacks && _e < (le ? 0 : xe) ? "-" : "") + this.stackKey];
            he = Z.translate(Me, !1, !1, !1, !0, ce), Le.plotX = Y(he) ? $(ke(he)) : void 0, q && this.visible && Ee && Ee[Me] && (ye = this.getStackIndicator(ye, Me, this.index), !Le.isNull && ye.key && (Ae = (De = Ee[Me]).points[ye.key]), De && R(Ae) && (He = Ae[0], _e = Ae[1], He === le && ye.key === Ee[Me].base && (He = J(Y(xe) ? xe : re.min)), re.positiveValuesOnly && N(He) && He <= 0 && (He = void 0), Le.total = Le.stackTotal = J(De.total), Le.percentage = N(Le.y) && De.total ? Le.y / De.total * 100 : void 0, Le.stackY = _e, this.irregularWidths || De.setOffset(this.pointXOffset || 0, this.barW || 0, void 0, void 0, void 0, this.xAxis))), Le.yBottom = N(He) ? ke(re.translate(He, !1, !0, !1, !0)) : void 0, this.dataModify && (_e = this.dataModify.modifyValue(_e, se)), Y(_e) && Le.plotX !== void 0 && (we = Y(we = re.translate(_e, !1, !0, !1, !0)) ? ke(we) : void 0), Le.plotY = we, Le.isInside = this.isPointInside(Le), Le.clientX = pe ? $(Z.translate(Me, !1, !1, !1, !0, ce)) : he, Le.negative = (Le.y || 0) < (xe || 0), Le.category = J(ne && ne[Le.x], Le.x), Le.isNull || Le.visible === !1 || (ve !== void 0 && (be = Math.min(be, Math.abs(he - ve))), ve = he), Le.zone = this.zones.length ? Le.getZone() : void 0, !Le.graphic && this.group && ie && (Le.isNew = !0);
          }
          this.closestPointRangePx = be, B(this, "afterTranslate");
        }
        getValidPoints(z, q, Z) {
          let ne = this.chart;
          return (z || this.points || []).filter(function(ie) {
            let { plotX: re, plotY: de } = ie;
            return !!((Z || !ie.isNull && Y(de)) && (!q || ne.isInsidePlot(re, de, { inverted: ne.inverted }))) && ie.visible !== !1;
          });
        }
        getClipBox() {
          let { chart: z, xAxis: q, yAxis: Z } = this, { x: ne, y: ie, width: re, height: de } = U(z.clipBox);
          return q && q.len !== z.plotSizeX && (re = q.len), Z && Z.len !== z.plotSizeY && (de = Z.len), z.inverted && !this.invertible && ([re, de] = [de, re]), { x: ne, y: ie, width: re, height: de };
        }
        getSharedClipKey() {
          return this.sharedClipKey = (this.options.xAxis || 0) + "," + (this.options.yAxis || 0), this.sharedClipKey;
        }
        setClip() {
          let { chart: z, group: q, markerGroup: Z } = this, ne = z.sharedClips, ie = z.renderer, re = this.getClipBox(), de = this.getSharedClipKey(), me = ne[de];
          me ? me.animate(re) : ne[de] = me = ie.clipRect(re), q && q.clip(this.options.clip === !1 ? void 0 : me), Z && Z.clip();
        }
        animate(z) {
          let { chart: q, group: Z, markerGroup: ne } = this, ie = q.inverted, re = c(this.options.animation), de = [this.getSharedClipKey(), re.duration, re.easing, re.defer].join(","), me = q.sharedClips[de], ce = q.sharedClips[de + "m"];
          if (z && Z) {
            let pe = this.getClipBox();
            if (me)
              me.attr("height", pe.height);
            else {
              pe.width = 0, ie && (pe.x = q.plotHeight), me = q.renderer.clipRect(pe), q.sharedClips[de] = me;
              let xe = { x: -99, y: -99, width: ie ? q.plotWidth + 199 : 99, height: ie ? 99 : q.plotHeight + 199 };
              ce = q.renderer.clipRect(xe), q.sharedClips[de + "m"] = ce;
            }
            Z.clip(me), ne?.clip(ce);
          } else if (me && !me.hasClass("highcharts-animating")) {
            let pe = this.getClipBox(), xe = re.step;
            (ne?.element.childNodes.length || q.series.length > 1) && (re.step = function(le, se) {
              xe && xe.apply(se, arguments), se.prop === "width" && ce?.element && ce.attr(ie ? "height" : "width", le + 99);
            }), me.addClass("highcharts-animating").animate(pe, re);
          }
        }
        afterAnimate() {
          this.setClip(), Q(this.chart.sharedClips, (z, q, Z) => {
            z && !this.chart.container.querySelector(`[clip-path="url(#${z.id})"]`) && (z.destroy(), delete Z[q]);
          }), this.finishedAnimating = !0, B(this, "afterAnimate");
        }
        drawPoints(z = this.points) {
          let q, Z, ne, ie, re, de, me, ce = this.chart, pe = ce.styledMode, { colorAxis: xe, options: le } = this, se = le.marker, he = this[this.specialGroup || "markerGroup"], ve = this.xAxis, ye = J(se.enabled, !ve || !!ve.isRadial || null, this.closestPointRangePx >= se.enabledThreshold * se.radius);
          if (se.enabled !== !1 || this._hasPointMarkers)
            for (q = 0; q < z.length; q++)
              if (ie = (ne = (Z = z[q]).graphic) ? "animate" : "attr", re = Z.marker || {}, de = !!Z.marker, (ye && re.enabled === void 0 || re.enabled) && !Z.isNull && Z.visible !== !1) {
                let be = J(re.symbol, this.symbol, "rect");
                me = this.markerAttribs(Z, Z.selected && "select"), this.enabledDataSorting && (Z.startXPos = ve.reversed ? -(me.width || 0) : ve.width);
                let ke = Z.isInside !== !1;
                if (!ne && ke && ((me.width || 0) > 0 || Z.hasImage) && (Z.graphic = ne = ce.renderer.symbol(be, me.x, me.y, me.width, me.height, de ? re : se).add(he), this.enabledDataSorting && ce.hasRendered && (ne.attr({ x: Z.startXPos }), ie = "animate")), ne && ie === "animate" && ne[ke ? "show" : "hide"](ke).animate(me), ne) {
                  let we = this.pointAttribs(Z, pe || !Z.selected ? void 0 : "select");
                  pe ? xe && ne.css({ fill: we.fill }) : ne[ie](we);
                }
                ne && ne.addClass(Z.getClassName(), !0);
              } else
                ne && (Z.graphic = ne.destroy());
        }
        markerAttribs(z, q) {
          let Z = this.options, ne = Z.marker, ie = z.marker || {}, re = ie.symbol || ne.symbol, de = {}, me, ce, pe = J(ie.radius, ne && ne.radius);
          q && (me = ne.states[q], pe = J((ce = ie.states && ie.states[q]) && ce.radius, me && me.radius, pe && pe + (me && me.radiusPlus || 0))), z.hasImage = re && re.indexOf("url") === 0, z.hasImage && (pe = 0);
          let xe = z.pos();
          return Y(pe) && xe && (Z.crisp && (xe[0] = j(xe[0], z.hasImage ? 0 : re === "rect" ? ne?.lineWidth || 0 : 1)), de.x = xe[0] - pe, de.y = xe[1] - pe), pe && (de.width = de.height = 2 * pe), de;
        }
        pointAttribs(z, q) {
          let Z = this.options.marker, ne = z && z.options, ie = ne && ne.marker || {}, re = ne && ne.color, de = z && z.color, me = z && z.zone && z.zone.color, ce, pe, xe = this.color, le, se, he = J(ie.lineWidth, Z.lineWidth), ve = 1;
          return xe = re || me || de || xe, le = ie.fillColor || Z.fillColor || xe, se = ie.lineColor || Z.lineColor || xe, q = q || "normal", ce = Z.states[q] || {}, he = J((pe = ie.states && ie.states[q] || {}).lineWidth, ce.lineWidth, he + J(pe.lineWidthPlus, ce.lineWidthPlus, 0)), le = pe.fillColor || ce.fillColor || le, { stroke: se = pe.lineColor || ce.lineColor || se, "stroke-width": he, fill: le, opacity: ve = J(pe.opacity, ce.opacity, ve) };
        }
        destroy(z) {
          let q, Z, ne, ie = this, re = ie.chart, de = /AppleWebKit\/533/.test(S.navigator.userAgent), me = ie.data || [];
          for (B(ie, "destroy", { keepEventsForUpdate: z }), this.removeEvents(z), (ie.axisTypes || []).forEach(function(ce) {
            (ne = ie[ce]) && ne.series && (C(ne.series, ie), ne.isDirty = ne.forceRedraw = !0);
          }), ie.legendItem && ie.chart.legend.destroyItem(ie), q = me.length; q--; )
            (Z = me[q]) && Z.destroy && Z.destroy();
          for (let ce of ie.zones)
            M(ce, void 0, !0);
          h.clearTimeout(ie.animationTimeout), Q(ie, function(ce, pe) {
            ce instanceof m && !ce.survive && ce[de && pe === "group" ? "hide" : "destroy"]();
          }), re.hoverSeries === ie && (re.hoverSeries = void 0), C(re.series, ie), re.orderItems("series"), Q(ie, function(ce, pe) {
            z && pe === "hcEvents" || delete ie[pe];
          });
        }
        applyZones() {
          let { area: z, chart: q, graph: Z, zones: ne, points: ie, xAxis: re, yAxis: de, zoneAxis: me } = this, { inverted: ce, renderer: pe } = q, xe = this[`${me}Axis`], { isXAxis: le, len: se = 0 } = xe || {}, he = (Z?.strokeWidth() || 0) / 2 + 1, ve = (ye, be = 0, ke = 0) => {
            ce && (ke = se - ke);
            let { translated: we = 0, lineClip: Le } = ye, Me = ke - we;
            Le?.push(["L", be, Math.abs(Me) < he ? ke - he * (Me <= 0 ? -1 : 1) : we]);
          };
          if (ne.length && (Z || z) && xe && Y(xe.min)) {
            let ye = xe.getExtremes().max, be = (Le) => {
              Le.forEach((Me, De) => {
                (Me[0] === "M" || Me[0] === "L") && (Le[De] = [Me[0], le ? se - Me[1] : Me[1], le ? Me[2] : se - Me[2]]);
              });
            };
            if (ne.forEach((Le) => {
              Le.lineClip = [], Le.translated = A(xe.toPixels(J(Le.value, ye), !0) || 0, 0, se);
            }), Z && !this.showLine && Z.hide(), z && z.hide(), me === "y" && ie.length < re.len)
              for (let Le of ie) {
                let { plotX: Me, plotY: De, zone: Ae } = Le, _e = Ae && ne[ne.indexOf(Ae) - 1];
                Ae && ve(Ae, Me, De), _e && ve(_e, Me, De);
              }
            let ke = [], we = xe.toPixels(xe.getExtremes().min, !0);
            ne.forEach((Le) => {
              let Me = Le.lineClip || [], De = Math.round(Le.translated || 0);
              re.reversed && Me.reverse();
              let { clip: Ae, simpleClip: _e } = Le, He = 0, Ee = 0, Ne = re.len, Ye = de.len;
              le ? (He = De, Ne = we) : (Ee = De, Ye = we);
              let Xe = [["M", He, Ee], ["L", Ne, Ee], ["L", Ne, Ye], ["L", He, Ye], ["Z"]], nt = [Xe[0], ...Me, Xe[1], Xe[2], ...ke, Xe[3], Xe[4]];
              ke = Me.reverse(), we = De, ce && (be(nt), z && be(Xe)), Ae ? (Ae.animate({ d: nt }), _e?.animate({ d: Xe })) : (Ae = Le.clip = pe.path(nt), z && (_e = Le.simpleClip = pe.path(Xe))), Z && Le.graph?.clip(Ae), z && Le.area?.clip(_e);
            });
          } else
            this.visible && (Z && Z.show(), z && z.show());
        }
        plotGroup(z, q, Z, ne, ie) {
          let re = this[z], de = !re, me = { visibility: Z, zIndex: ne || 0.1 };
          return N(this.opacity) && !this.chart.styledMode && this.state !== "inactive" && (me.opacity = this.opacity), re || (this[z] = re = this.chart.renderer.g().add(ie)), re.addClass("highcharts-" + q + " highcharts-series-" + this.index + " highcharts-" + this.type + "-series " + (N(this.colorIndex) ? "highcharts-color-" + this.colorIndex + " " : "") + (this.options.className || "") + (re.hasClass("highcharts-tracker") ? " highcharts-tracker" : ""), !0), re.attr(me)[de ? "attr" : "animate"](this.getPlotBox(q)), re;
        }
        getPlotBox(z) {
          let q = this.xAxis, Z = this.yAxis, ne = this.chart, ie = ne.inverted && !ne.polar && q && this.invertible && z === "series";
          return ne.inverted && (q = Z, Z = this.xAxis), { translateX: q ? q.left : ne.plotLeft, translateY: Z ? Z.top : ne.plotTop, rotation: ie ? 90 : 0, rotationOriginX: ie ? (q.len - Z.len) / 2 : 0, rotationOriginY: ie ? (q.len + Z.len) / 2 : 0, scaleX: ie ? -1 : 1, scaleY: 1 };
        }
        removeEvents(z) {
          let { eventsToUnbind: q } = this;
          z || ee(this), q.length && (q.forEach((Z) => {
            Z();
          }), q.length = 0);
        }
        render() {
          let z = this, { chart: q, options: Z, hasRendered: ne } = z, ie = c(Z.animation), re = z.visible ? "inherit" : "hidden", de = Z.zIndex, me = q.seriesGroup, ce = z.finishedAnimating ? 0 : ie.duration;
          B(this, "render"), z.plotGroup("group", "series", re, de, me), z.markerGroup = z.plotGroup("markerGroup", "markers", re, de, me), Z.clip !== !1 && z.setClip(), ce && z.animate?.(!0), z.drawGraph && (z.drawGraph(), z.applyZones()), z.visible && z.drawPoints(), z.drawDataLabels?.(), z.redrawPoints?.(), Z.enableMouseTracking && z.drawTracker?.(), ce && z.animate?.(), ne || (ce && ie.defer && (ce += ie.defer), z.animationTimeout = G(() => {
            z.afterAnimate();
          }, ce || 0)), z.isDirty = !1, z.hasRendered = !0, B(z, "afterRender");
        }
        redraw() {
          let z = this.isDirty || this.isDirtyData;
          this.translate(), this.render(), z && delete this.kdTree;
        }
        reserveSpace() {
          return this.visible || !this.chart.options.chart.ignoreHiddenSeries;
        }
        searchPoint(z, q) {
          let { xAxis: Z, yAxis: ne } = this, ie = this.chart.inverted;
          return this.searchKDTree({ clientX: ie ? Z.len - z.chartY + Z.pos : z.chartX - Z.pos, plotY: ie ? ne.len - z.chartX + ne.pos : z.chartY - ne.pos }, q, z);
        }
        buildKDTree(z) {
          this.buildingKdTree = !0;
          let q = this, Z = q.options.findNearestPointBy.indexOf("y") > -1 ? 2 : 1;
          delete q.kdTree, G(function() {
            q.kdTree = function ne(ie, re, de) {
              let me, ce, pe = ie?.length;
              if (pe)
                return me = q.kdAxisArray[re % de], ie.sort((xe, le) => (xe[me] || 0) - (le[me] || 0)), { point: ie[ce = Math.floor(pe / 2)], left: ne(ie.slice(0, ce), re + 1, de), right: ne(ie.slice(ce + 1), re + 1, de) };
            }(q.getValidPoints(void 0, !q.directTouch), Z, Z), q.buildingKdTree = !1;
          }, q.options.kdNow || z?.type === "touchstart" ? 0 : 1);
        }
        searchKDTree(z, q, Z) {
          let ne = this, [ie, re] = this.kdAxisArray, de = q ? "distX" : "dist", me = (ne.options.findNearestPointBy || "").indexOf("y") > -1 ? 2 : 1, ce = !!ne.isBubble;
          if (this.kdTree || this.buildingKdTree || this.buildKDTree(Z), this.kdTree)
            return function pe(xe, le, se, he) {
              let ve = le.point, ye = ne.kdAxisArray[se % he], be, ke, we = ve;
              (function(Ae, _e) {
                let He = Ae[ie], Ee = _e[ie], Ne = N(He) && N(Ee) ? He - Ee : null, Ye = Ae[re], Xe = _e[re], nt = N(Ye) && N(Xe) ? Ye - Xe : 0, ut = ce && _e.marker?.radius || 0;
                _e.dist = Math.sqrt((Ne && Ne * Ne || 0) + nt * nt) - ut, _e.distX = N(Ne) ? Math.abs(Ne) - ut : Number.MAX_VALUE;
              })(xe, ve);
              let Le = (xe[ye] || 0) - (ve[ye] || 0) + (ce && ve.marker?.radius || 0), Me = Le < 0 ? "left" : "right", De = Le < 0 ? "right" : "left";
              return le[Me] && (we = (be = pe(xe, le[Me], se + 1, he))[de] < we[de] ? be : ve), le[De] && Math.sqrt(Le * Le) < we[de] && (we = (ke = pe(xe, le[De], se + 1, he))[de] < we[de] ? ke : we), we;
            }(z, this.kdTree, me, me);
        }
        pointPlacementToXValue() {
          let { options: z, xAxis: q } = this, Z = z.pointPlacement;
          return Z === "between" && (Z = q.reversed ? -0.5 : 0.5), Y(Z) ? Z * (z.pointRange || q.pointRange) : 0;
        }
        isPointInside(z) {
          let { chart: q, xAxis: Z, yAxis: ne } = this, { plotX: ie = -1, plotY: re = -1 } = z;
          return re >= 0 && re <= (ne ? ne.len : q.plotHeight) && ie >= 0 && ie <= (Z ? Z.len : q.plotWidth);
        }
        drawTracker() {
          let z = this, q = z.options, Z = q.trackByArea, ne = [].concat((Z ? z.areaPath : z.graphPath) || []), ie = z.chart, re = ie.pointer, de = ie.renderer, me = ie.options.tooltip?.snap || 0, ce = () => {
            q.enableMouseTracking && ie.hoverSeries !== z && z.onMouseOver();
          }, pe = "rgba(192,192,192," + (f ? 1e-4 : 2e-3) + ")", xe = z.tracker;
          xe ? xe.attr({ d: ne }) : z.graph && (z.tracker = xe = de.path(ne).attr({ visibility: z.visible ? "inherit" : "hidden", zIndex: 2 }).addClass(Z ? "highcharts-tracker-area" : "highcharts-tracker-line").add(z.group), ie.styledMode || xe.attr({ "stroke-linecap": "round", "stroke-linejoin": "round", stroke: pe, fill: Z ? pe : "none", "stroke-width": z.graph.strokeWidth() + (Z ? 0 : 2 * me) }), [z.tracker, z.markerGroup, z.dataLabelsGroup].forEach((le) => {
            le && (le.addClass("highcharts-tracker").on("mouseover", ce).on("mouseout", (se) => {
              re?.onTrackerMouseOut(se);
            }), q.cursor && !ie.styledMode && le.css({ cursor: q.cursor }), le.on("touchstart", ce));
          })), B(this, "afterDrawTracker");
        }
        addPoint(z, q, Z, ne, ie) {
          let re, de, me = this.options, ce = this.data, pe = this.chart, xe = this.xAxis, le = xe && xe.hasNames && xe.names, se = me.data, he = this.xData;
          q = J(q, !0);
          let ve = { series: this };
          this.pointClass.prototype.applyOptions.apply(ve, [z]);
          let ye = ve.x;
          if (de = he.length, this.requireSorting && ye < he[de - 1])
            for (re = !0; de && he[de - 1] > ye; )
              de--;
          this.updateParallelArrays(ve, "splice", [de, 0, 0]), this.updateParallelArrays(ve, de), le && ve.name && (le[ye] = ve.name), se.splice(de, 0, z), (re || this.processedData) && (this.data.splice(de, 0, null), this.processData()), me.legendType === "point" && this.generatePoints(), Z && (ce[0] && ce[0].remove ? ce[0].remove(!1) : (ce.shift(), this.updateParallelArrays(ve, "shift"), se.shift())), ie !== !1 && B(this, "addPoint", { point: ve }), this.isDirty = !0, this.isDirtyData = !0, q && pe.redraw(ne);
        }
        removePoint(z, q, Z) {
          let ne = this, ie = ne.data, re = ie[z], de = ne.points, me = ne.chart, ce = function() {
            de && de.length === ie.length && de.splice(z, 1), ie.splice(z, 1), ne.options.data.splice(z, 1), ne.updateParallelArrays(re || { series: ne }, "splice", [z, 1]), re && re.destroy(), ne.isDirty = !0, ne.isDirtyData = !0, q && me.redraw();
          };
          g(Z, me), q = J(q, !0), re ? re.firePointEvent("remove", null, ce) : ce();
        }
        remove(z, q, Z, ne) {
          let ie = this, re = ie.chart;
          function de() {
            ie.destroy(ne), re.isDirtyLegend = re.isDirtyBox = !0, re.linkSeries(ne), J(z, !0) && re.redraw(q);
          }
          Z !== !1 ? B(ie, "remove", null, de) : de();
        }
        update(z, q) {
          B(this, "update", { options: z = D(z, this.userOptions) });
          let Z = this, ne = Z.chart, ie = Z.userOptions, re = Z.initialType || Z.type, de = ne.options.plotOptions, me = w[re].prototype, ce = Z.finishedAnimating && { animation: !1 }, pe = {}, xe, le, se = ["colorIndex", "eventOptions", "navigatorSeries", "symbolIndex", "baseSeries"], he = z.type || ie.type || ne.options.chart.type, ve = !(this.hasDerivedData || he && he !== this.type || z.pointStart !== void 0 || z.pointInterval !== void 0 || z.relativeXValue !== void 0 || z.joinBy || z.mapData || ["dataGrouping", "pointStart", "pointInterval", "pointIntervalUnit", "keys"].some((be) => Z.hasOptionChanged(be)));
          he = he || re, ve && (se.push("data", "isDirtyData", "isDirtyCanvas", "points", "processedData", "processedXData", "processedYData", "xIncrement", "cropped", "_hasPointMarkers", "hasDataLabels", "nodes", "layout", "level", "mapMap", "mapData", "minY", "maxY", "minX", "maxX", "transformGroups"), z.visible !== !1 && se.push("area", "graph"), Z.parallelArrays.forEach(function(be) {
            se.push(be + "Data");
          }), z.data && (z.dataSorting && p(Z.options.dataSorting, z.dataSorting), this.setData(z.data, !1))), z = U(ie, { index: ie.index === void 0 ? Z.index : ie.index, pointStart: de?.series?.pointStart ?? ie.pointStart ?? Z.xData?.[0] }, !ve && { data: Z.options.data }, z, ce), ve && z.data && (z.data = Z.options.data), (se = ["group", "markerGroup", "dataLabelsGroup", "transformGroup"].concat(se)).forEach(function(be) {
            se[be] = Z[be], delete Z[be];
          });
          let ye = !1;
          if (w[he]) {
            if (ye = he !== Z.type, Z.remove(!1, !1, !1, !0), ye)
              if (ne.propFromSeries(), Object.setPrototypeOf)
                Object.setPrototypeOf(Z, w[he].prototype);
              else {
                let be = Object.hasOwnProperty.call(Z, "hcEvents") && Z.hcEvents;
                for (le in me)
                  Z[le] = void 0;
                p(Z, w[he].prototype), be ? Z.hcEvents = be : delete Z.hcEvents;
              }
          } else
            b(17, !0, ne, { missingModuleFor: he });
          if (se.forEach(function(be) {
            Z[be] = se[be];
          }), Z.init(ne, z), ve && this.points)
            for (let be of ((xe = Z.options).visible === !1 ? (pe.graphic = 1, pe.dataLabel = 1) : (this.hasMarkerChanged(xe, ie) && (pe.graphic = 1), Z.hasDataLabels?.() || (pe.dataLabel = 1)), this.points))
              be && be.series && (be.resolveColor(), Object.keys(pe).length && be.destroyElements(pe), xe.showInLegend === !1 && be.legendItem && ne.legend.destroyItem(be));
          Z.initialType = re, ne.linkSeries(), ne.setSortedData(), ye && Z.linkedSeries.length && (Z.isDirtyData = !0), B(this, "afterUpdate"), J(q, !0) && ne.redraw(!!ve && void 0);
        }
        setName(z) {
          this.name = this.options.name = this.userOptions.name = z, this.chart.isDirtyLegend = !0;
        }
        hasOptionChanged(z) {
          let q = this.chart, Z = this.options[z], ne = q.options.plotOptions, ie = this.userOptions[z], re = J(ne?.[this.type]?.[z], ne?.series?.[z]);
          return ie && !N(re) ? Z !== ie : Z !== J(re, Z);
        }
        onMouseOver() {
          let z = this.chart, q = z.hoverSeries;
          z.pointer?.setHoverChartIndex(), q && q !== this && q.onMouseOut(), this.options.events.mouseOver && B(this, "mouseOver"), this.setState("hover"), z.hoverSeries = this;
        }
        onMouseOut() {
          let z = this.options, q = this.chart, Z = q.tooltip, ne = q.hoverPoint;
          q.hoverSeries = null, ne && ne.onMouseOut(), this && z.events.mouseOut && B(this, "mouseOut"), Z && !this.stickyTracking && (!Z.shared || this.noSharedTooltip) && Z.hide(), q.series.forEach(function(ie) {
            ie.setState("", !0);
          });
        }
        setState(z, q) {
          let Z = this, ne = Z.options, ie = Z.graph, re = ne.inactiveOtherPoints, de = ne.states, me = J(de[z || "normal"] && de[z || "normal"].animation, Z.chart.options.chart.animation), ce = ne.lineWidth, pe = ne.opacity;
          if (z = z || "", Z.state !== z && ([Z.group, Z.markerGroup, Z.dataLabelsGroup].forEach(function(xe) {
            xe && (Z.state && xe.removeClass("highcharts-series-" + Z.state), z && xe.addClass("highcharts-series-" + z));
          }), Z.state = z, !Z.chart.styledMode)) {
            if (de[z] && de[z].enabled === !1)
              return;
            if (z && (ce = de[z].lineWidth || ce + (de[z].lineWidthPlus || 0), pe = J(de[z].opacity, pe)), ie && !ie.dashstyle && Y(ce))
              for (let xe of [ie, ...this.zones.map((le) => le.graph)])
                xe?.animate({ "stroke-width": ce }, me);
            re || [Z.group, Z.markerGroup, Z.dataLabelsGroup, Z.labelBySeries].forEach(function(xe) {
              xe && xe.animate({ opacity: pe }, me);
            });
          }
          q && re && Z.points && Z.setAllPointsToState(z || void 0);
        }
        setAllPointsToState(z) {
          this.points.forEach(function(q) {
            q.setState && q.setState(z);
          });
        }
        setVisible(z, q) {
          let Z = this, ne = Z.chart, ie = ne.options.chart.ignoreHiddenSeries, re = Z.visible;
          Z.visible = z = Z.options.visible = Z.userOptions.visible = z === void 0 ? !re : z;
          let de = z ? "show" : "hide";
          ["group", "dataLabelsGroup", "markerGroup", "tracker", "tt"].forEach((me) => {
            Z[me]?.[de]();
          }), (ne.hoverSeries === Z || ne.hoverPoint?.series === Z) && Z.onMouseOut(), Z.legendItem && ne.legend.colorizeItem(Z, z), Z.isDirty = !0, Z.options.stacking && ne.series.forEach((me) => {
            me.options.stacking && me.visible && (me.isDirty = !0);
          }), Z.linkedSeries.forEach((me) => {
            me.setVisible(z, !1);
          }), ie && (ne.isDirtyBox = !0), B(Z, de), q !== !1 && ne.redraw();
        }
        show() {
          this.setVisible(!0);
        }
        hide() {
          this.setVisible(!1);
        }
        select(z) {
          this.selected = z = this.options.selected = z === void 0 ? !this.selected : z, this.checkbox && (this.checkbox.checked = z), B(this, z ? "select" : "unselect");
        }
        shouldShowTooltip(z, q, Z = {}) {
          return Z.series = this, Z.visiblePlotOnly = !0, this.chart.isInsidePlot(z, q, Z);
        }
        drawLegendSymbol(z, q) {
          l[this.options.legendSymbol || "rectangle"]?.call(this, z, q);
        }
      }
      return W.defaultOptions = y, W.types = u.seriesTypes, W.registerType = u.registerSeriesType, p(W.prototype, { axisTypes: ["xAxis", "yAxis"], coll: "series", colorCounter: 0, directTouch: !1, invertible: !0, isCartesian: !0, kdAxisArray: ["clientX", "plotY"], parallelArrays: ["x", "y"], pointClass: d, requireSorting: !0, sorted: !0 }), u.series = W, W;
    }), i(n, "Core/Legend/Legend.js", [n["Core/Animation/AnimationUtilities.js"], n["Core/Foundation.js"], n["Core/Globals.js"], n["Core/Series/Series.js"], n["Core/Series/Point.js"], n["Core/Renderer/RendererUtilities.js"], n["Core/Templating.js"], n["Core/Utilities.js"]], function(o, a, r, s, l, d, y, u) {
      var m;
      let { animObject: h, setAnimation: c } = o, { registerEventOptions: g } = a, { composed: v, marginNames: P } = r, { distribute: f } = d, { format: S } = y, { addEvent: w, createElement: x, css: k, defined: A, discardElement: $, find: j, fireEvent: N, isNumber: M, merge: D, pick: C, pushUnique: b, relativeLength: p, stableSort: L, syncTimeout: B } = u;
      class T {
        constructor(I, R) {
          this.allItems = [], this.initialItemY = 0, this.itemHeight = 0, this.itemMarginBottom = 0, this.itemMarginTop = 0, this.itemX = 0, this.itemY = 0, this.lastItemY = 0, this.lastLineHeight = 0, this.legendHeight = 0, this.legendWidth = 0, this.maxItemWidth = 0, this.maxLegendWidth = 0, this.offsetWidth = 0, this.padding = 0, this.pages = [], this.symbolHeight = 0, this.symbolWidth = 0, this.titleHeight = 0, this.totalItemWidth = 0, this.widthOption = 0, this.chart = I, this.setOptions(R), R.enabled && (this.render(), g(this, R), w(this.chart, "endResize", function() {
            this.legend.positionCheckboxes();
          })), w(this.chart, "render", () => {
            this.options.enabled && this.proximate && (this.proximatePositions(), this.positionItems());
          });
        }
        setOptions(I) {
          let R = C(I.padding, 8);
          this.options = I, this.chart.styledMode || (this.itemStyle = I.itemStyle, this.itemHiddenStyle = D(this.itemStyle, I.itemHiddenStyle)), this.itemMarginTop = I.itemMarginTop, this.itemMarginBottom = I.itemMarginBottom, this.padding = R, this.initialItemY = R - 5, this.symbolWidth = C(I.symbolWidth, 16), this.pages = [], this.proximate = I.layout === "proximate" && !this.chart.inverted, this.baseline = void 0;
        }
        update(I, R) {
          let Y = this.chart;
          this.setOptions(D(!0, this.options, I)), "events" in this.options && g(this, this.options), this.destroy(), Y.isDirtyLegend = Y.isDirtyBox = !0, C(R, !0) && Y.redraw(), N(this, "afterUpdate", { redraw: R });
        }
        colorizeItem(I, R) {
          let { area: Y, group: F, label: U, line: Q, symbol: J } = I.legendItem || {};
          if (F?.[R ? "removeClass" : "addClass"]("highcharts-legend-item-hidden"), !this.chart.styledMode) {
            let { itemHiddenStyle: ee = {} } = this, V = ee.color, { fillColor: G, fillOpacity: W, lineColor: ae, marker: z } = I.options, q = (Z) => (!R && (Z.fill && (Z.fill = V), Z.stroke && (Z.stroke = V)), Z);
            U?.css(D(R ? this.itemStyle : ee)), Q?.attr(q({ stroke: ae || I.color })), J && J.attr(q(z && J.isMarker ? I.pointAttribs() : { fill: I.color })), Y?.attr(q({ fill: G || I.color, "fill-opacity": G ? 1 : W ?? 0.75 }));
          }
          N(this, "afterColorizeItem", { item: I, visible: R });
        }
        positionItems() {
          this.allItems.forEach(this.positionItem, this), this.chart.isResizing || this.positionCheckboxes();
        }
        positionItem(I) {
          let { group: R, x: Y = 0, y: F = 0 } = I.legendItem || {}, U = this.options, Q = U.symbolPadding, J = !U.rtl, ee = I.checkbox;
          if (R && R.element) {
            let V = { translateX: J ? Y : this.legendWidth - Y - 2 * Q - 4, translateY: F };
            R[A(R.translateY) ? "animate" : "attr"](V, void 0, () => {
              N(this, "afterPositionItem", { item: I });
            });
          }
          ee && (ee.x = Y, ee.y = F);
        }
        destroyItem(I) {
          let R = I.checkbox, Y = I.legendItem || {};
          for (let F of ["group", "label", "line", "symbol"])
            Y[F] && (Y[F] = Y[F].destroy());
          R && $(R), I.legendItem = void 0;
        }
        destroy() {
          for (let I of this.getAllItems())
            this.destroyItem(I);
          for (let I of ["clipRect", "up", "down", "pager", "nav", "box", "title", "group"])
            this[I] && (this[I] = this[I].destroy());
          this.display = null;
        }
        positionCheckboxes() {
          let I, R = this.group && this.group.alignAttr, Y = this.clipHeight || this.legendHeight, F = this.titleHeight;
          R && (I = R.translateY, this.allItems.forEach(function(U) {
            let Q, J = U.checkbox;
            J && (Q = I + F + J.y + (this.scrollOffset || 0) + 3, k(J, { left: R.translateX + U.checkboxOffset + J.x - 20 + "px", top: Q + "px", display: this.proximate || Q > I - 6 && Q < I + Y - 6 ? "" : "none" }));
          }, this));
        }
        renderTitle() {
          let I = this.options, R = this.padding, Y = I.title, F, U = 0;
          Y.text && (this.title || (this.title = this.chart.renderer.label(Y.text, R - 3, R - 4, void 0, void 0, void 0, I.useHTML, void 0, "legend-title").attr({ zIndex: 1 }), this.chart.styledMode || this.title.css(Y.style), this.title.add(this.group)), Y.width || this.title.css({ width: this.maxLegendWidth + "px" }), U = (F = this.title.getBBox()).height, this.offsetWidth = F.width, this.contentGroup.attr({ translateY: U })), this.titleHeight = U;
        }
        setText(I) {
          let R = this.options;
          I.legendItem.label.attr({ text: R.labelFormat ? S(R.labelFormat, I, this.chart) : R.labelFormatter.call(I) });
        }
        renderItem(I) {
          let R = I.legendItem = I.legendItem || {}, Y = this.chart, F = Y.renderer, U = this.options, Q = U.layout === "horizontal", J = this.symbolWidth, ee = U.symbolPadding || 0, V = this.itemStyle, G = this.itemHiddenStyle, W = Q ? C(U.itemDistance, 20) : 0, ae = !U.rtl, z = !I.series, q = !z && I.series.drawLegendSymbol ? I.series : I, Z = q.options, ne = !!this.createCheckboxForItem && Z && Z.showCheckbox, ie = U.useHTML, re = I.options.className, de = R.label, me = J + ee + W + (ne ? 20 : 0);
          !de && (R.group = F.g("legend-item").addClass("highcharts-" + q.type + "-series highcharts-color-" + I.colorIndex + (re ? " " + re : "") + (z ? " highcharts-series-" + I.index : "")).attr({ zIndex: 1 }).add(this.scrollGroup), R.label = de = F.text("", ae ? J + ee : -ee, this.baseline || 0, ie), Y.styledMode || de.css(D(I.visible ? V : G)), de.attr({ align: ae ? "left" : "right", zIndex: 2 }).add(R.group), !this.baseline && (this.fontMetrics = F.fontMetrics(de), this.baseline = this.fontMetrics.f + 3 + this.itemMarginTop, de.attr("y", this.baseline), this.symbolHeight = C(U.symbolHeight, this.fontMetrics.f), U.squareSymbol && (this.symbolWidth = C(U.symbolWidth, Math.max(this.symbolHeight, 16)), me = this.symbolWidth + ee + W + (ne ? 20 : 0), ae && de.attr("x", this.symbolWidth + ee))), q.drawLegendSymbol(this, I), this.setItemEvents && this.setItemEvents(I, de, ie)), ne && !I.checkbox && this.createCheckboxForItem && this.createCheckboxForItem(I), this.colorizeItem(I, I.visible), (Y.styledMode || !V.width) && de.css({ width: (U.itemWidth || this.widthOption || Y.spacingBox.width) - me + "px" }), this.setText(I);
          let ce = de.getBBox(), pe = this.fontMetrics && this.fontMetrics.h || 0;
          I.itemWidth = I.checkboxOffset = U.itemWidth || R.labelWidth || ce.width + me, this.maxItemWidth = Math.max(this.maxItemWidth, I.itemWidth), this.totalItemWidth += I.itemWidth, this.itemHeight = I.itemHeight = Math.round(R.labelHeight || (ce.height > 1.5 * pe ? ce.height : pe));
        }
        layoutItem(I) {
          let R = this.options, Y = this.padding, F = R.layout === "horizontal", U = I.itemHeight, Q = this.itemMarginBottom, J = this.itemMarginTop, ee = F ? C(R.itemDistance, 20) : 0, V = this.maxLegendWidth, G = R.alignColumns && this.totalItemWidth > V ? this.maxItemWidth : I.itemWidth, W = I.legendItem || {};
          F && this.itemX - Y + G > V && (this.itemX = Y, this.lastLineHeight && (this.itemY += J + this.lastLineHeight + Q), this.lastLineHeight = 0), this.lastItemY = J + this.itemY + Q, this.lastLineHeight = Math.max(U, this.lastLineHeight), W.x = this.itemX, W.y = this.itemY, F ? this.itemX += G : (this.itemY += J + U + Q, this.lastLineHeight = U), this.offsetWidth = this.widthOption || Math.max((F ? this.itemX - Y - (I.checkbox ? 0 : ee) : G) + Y, this.offsetWidth);
        }
        getAllItems() {
          let I = [];
          return this.chart.series.forEach(function(R) {
            let Y = R && R.options;
            R && C(Y.showInLegend, !A(Y.linkedTo) && void 0, !0) && (I = I.concat((R.legendItem || {}).labels || (Y.legendType === "point" ? R.data : R)));
          }), N(this, "afterGetAllItems", { allItems: I }), I;
        }
        getAlignment() {
          let I = this.options;
          return this.proximate ? I.align.charAt(0) + "tv" : I.floating ? "" : I.align.charAt(0) + I.verticalAlign.charAt(0) + I.layout.charAt(0);
        }
        adjustMargins(I, R) {
          let Y = this.chart, F = this.options, U = this.getAlignment();
          U && [/(lth|ct|rth)/, /(rtv|rm|rbv)/, /(rbh|cb|lbh)/, /(lbv|lm|ltv)/].forEach(function(Q, J) {
            Q.test(U) && !A(I[J]) && (Y[P[J]] = Math.max(Y[P[J]], Y.legend[(J + 1) % 2 ? "legendHeight" : "legendWidth"] + [1, -1, -1, 1][J] * F[J % 2 ? "x" : "y"] + C(F.margin, 12) + R[J] + (Y.titleOffset[J] || 0)));
          });
        }
        proximatePositions() {
          let I, R = this.chart, Y = [], F = this.options.align === "left";
          for (let U of (this.allItems.forEach(function(Q) {
            let J, ee, V = F, G, W;
            Q.yAxis && (Q.xAxis.options.reversed && (V = !V), Q.points && (J = j(V ? Q.points : Q.points.slice(0).reverse(), function(ae) {
              return M(ae.plotY);
            })), ee = this.itemMarginTop + Q.legendItem.label.getBBox().height + this.itemMarginBottom, W = Q.yAxis.top - R.plotTop, G = Q.visible ? (J ? J.plotY : Q.yAxis.height) + (W - 0.3 * ee) : W + Q.yAxis.height, Y.push({ target: G, size: ee, item: Q }));
          }, this), f(Y, R.plotHeight)))
            I = U.item.legendItem || {}, M(U.pos) && (I.y = R.plotTop - R.spacing[0] + U.pos);
        }
        render() {
          let I = this.chart, R = I.renderer, Y = this.options, F = this.padding, U = this.getAllItems(), Q, J, ee, V = this.group, G, W = this.box;
          this.itemX = F, this.itemY = this.initialItemY, this.offsetWidth = 0, this.lastItemY = 0, this.widthOption = p(Y.width, I.spacingBox.width - F), G = I.spacingBox.width - 2 * F - Y.x, ["rm", "lm"].indexOf(this.getAlignment().substring(0, 2)) > -1 && (G /= 2), this.maxLegendWidth = this.widthOption || G, V || (this.group = V = R.g("legend").addClass(Y.className || "").attr({ zIndex: 7 }).add(), this.contentGroup = R.g().attr({ zIndex: 1 }).add(V), this.scrollGroup = R.g().add(this.contentGroup)), this.renderTitle(), L(U, (ae, z) => (ae.options && ae.options.legendIndex || 0) - (z.options && z.options.legendIndex || 0)), Y.reversed && U.reverse(), this.allItems = U, this.display = Q = !!U.length, this.lastLineHeight = 0, this.maxItemWidth = 0, this.totalItemWidth = 0, this.itemHeight = 0, U.forEach(this.renderItem, this), U.forEach(this.layoutItem, this), J = (this.widthOption || this.offsetWidth) + F, ee = this.lastItemY + this.lastLineHeight + this.titleHeight, ee = this.handleOverflow(ee) + F, W || (this.box = W = R.rect().addClass("highcharts-legend-box").attr({ r: Y.borderRadius }).add(V)), I.styledMode || W.attr({ stroke: Y.borderColor, "stroke-width": Y.borderWidth || 0, fill: Y.backgroundColor || "none" }).shadow(Y.shadow), J > 0 && ee > 0 && W[W.placed ? "animate" : "attr"](W.crisp.call({}, { x: 0, y: 0, width: J, height: ee }, W.strokeWidth())), V[Q ? "show" : "hide"](), I.styledMode && V.getStyle("display") === "none" && (J = ee = 0), this.legendWidth = J, this.legendHeight = ee, Q && this.align(), this.proximate || this.positionItems(), N(this, "afterRender");
        }
        align(I = this.chart.spacingBox) {
          let R = this.chart, Y = this.options, F = I.y;
          /(lth|ct|rth)/.test(this.getAlignment()) && R.titleOffset[0] > 0 ? F += R.titleOffset[0] : /(lbh|cb|rbh)/.test(this.getAlignment()) && R.titleOffset[2] > 0 && (F -= R.titleOffset[2]), F !== I.y && (I = D(I, { y: F })), R.hasRendered || (this.group.placed = !1), this.group.align(D(Y, { width: this.legendWidth, height: this.legendHeight, verticalAlign: this.proximate ? "top" : Y.verticalAlign }), !0, I);
        }
        handleOverflow(I) {
          let R = this, Y = this.chart, F = Y.renderer, U = this.options, Q = U.y, J = U.verticalAlign === "top", ee = this.padding, V = U.maxHeight, G = U.navigation, W = C(G.animation, !0), ae = G.arrowSize || 12, z = this.pages, q = this.allItems, Z = function(xe) {
            typeof xe == "number" ? pe.attr({ height: xe }) : pe && (R.clipRect = pe.destroy(), R.contentGroup.clip()), R.contentGroup.div && (R.contentGroup.div.style.clip = xe ? "rect(" + ee + "px,9999px," + (ee + xe) + "px,0)" : "auto");
          }, ne = function(xe) {
            return R[xe] = F.circle(0, 0, 1.3 * ae).translate(ae / 2, ae / 2).add(ce), Y.styledMode || R[xe].attr("fill", "rgba(0,0,0,0.0001)"), R[xe];
          }, ie, re, de, me = Y.spacingBox.height + (J ? -Q : Q) - ee, ce = this.nav, pe = this.clipRect;
          return U.layout !== "horizontal" || U.verticalAlign === "middle" || U.floating || (me /= 2), V && (me = Math.min(me, V)), z.length = 0, I && me > 0 && I > me && G.enabled !== !1 ? (this.clipHeight = ie = Math.max(me - 20 - this.titleHeight - ee, 0), this.currentPage = C(this.currentPage, 1), this.fullHeight = I, q.forEach((xe, le) => {
            let se = (de = xe.legendItem || {}).y || 0, he = Math.round(de.label.getBBox().height), ve = z.length;
            (!ve || se - z[ve - 1] > ie && (re || se) !== z[ve - 1]) && (z.push(re || se), ve++), de.pageIx = ve - 1, re && ((q[le - 1].legendItem || {}).pageIx = ve - 1), le === q.length - 1 && se + he - z[ve - 1] > ie && se > z[ve - 1] && (z.push(se), de.pageIx = ve), se !== re && (re = se);
          }), pe || (pe = R.clipRect = F.clipRect(0, ee - 2, 9999, 0), R.contentGroup.clip(pe)), Z(ie), ce || (this.nav = ce = F.g().attr({ zIndex: 1 }).add(this.group), this.up = F.symbol("triangle", 0, 0, ae, ae).add(ce), ne("upTracker").on("click", function() {
            R.scroll(-1, W);
          }), this.pager = F.text("", 15, 10).addClass("highcharts-legend-navigation"), !Y.styledMode && G.style && this.pager.css(G.style), this.pager.add(ce), this.down = F.symbol("triangle-down", 0, 0, ae, ae).add(ce), ne("downTracker").on("click", function() {
            R.scroll(1, W);
          })), R.scroll(0), I = me) : ce && (Z(), this.nav = ce.destroy(), this.scrollGroup.attr({ translateY: 1 }), this.clipHeight = 0), I;
        }
        scroll(I, R) {
          let Y = this.chart, F = this.pages, U = F.length, Q = this.clipHeight, J = this.options.navigation, ee = this.pager, V = this.padding, G = this.currentPage + I;
          G > U && (G = U), G > 0 && (R !== void 0 && c(R, Y), this.nav.attr({ translateX: V, translateY: Q + this.padding + 7 + this.titleHeight, visibility: "inherit" }), [this.up, this.upTracker].forEach(function(W) {
            W.attr({ class: G === 1 ? "highcharts-legend-nav-inactive" : "highcharts-legend-nav-active" });
          }), ee.attr({ text: G + "/" + U }), [this.down, this.downTracker].forEach(function(W) {
            W.attr({ x: 18 + this.pager.getBBox().width, class: G === U ? "highcharts-legend-nav-inactive" : "highcharts-legend-nav-active" });
          }, this), Y.styledMode || (this.up.attr({ fill: G === 1 ? J.inactiveColor : J.activeColor }), this.upTracker.css({ cursor: G === 1 ? "default" : "pointer" }), this.down.attr({ fill: G === U ? J.inactiveColor : J.activeColor }), this.downTracker.css({ cursor: G === U ? "default" : "pointer" })), this.scrollOffset = -F[G - 1] + this.initialItemY, this.scrollGroup.animate({ translateY: this.scrollOffset }), this.currentPage = G, this.positionCheckboxes(), B(() => {
            N(this, "afterScroll", { currentPage: G });
          }, h(C(R, Y.renderer.globalAnimation, !0)).duration));
        }
        setItemEvents(I, R, Y) {
          let F = this, U = I.legendItem || {}, Q = F.chart.renderer.boxWrapper, J = I instanceof l, ee = I instanceof s, V = "highcharts-legend-" + (J ? "point" : "series") + "-active", G = F.chart.styledMode, W = Y ? [R, U.symbol] : [U.group], ae = (z) => {
            F.allItems.forEach((q) => {
              I !== q && [q].concat(q.linkedSeries || []).forEach((Z) => {
                Z.setState(z, !J);
              });
            });
          };
          for (let z of W)
            z && z.on("mouseover", function() {
              I.visible && ae("inactive"), I.setState("hover"), I.visible && Q.addClass(V), G || R.css(F.options.itemHoverStyle);
            }).on("mouseout", function() {
              F.chart.styledMode || R.css(D(I.visible ? F.itemStyle : F.itemHiddenStyle)), ae(""), Q.removeClass(V), I.setState();
            }).on("click", function(q) {
              let Z = function() {
                I.setVisible && I.setVisible(), ae(I.visible ? "inactive" : "");
              };
              Q.removeClass(V), N(F, "itemClick", { browserEvent: q, legendItem: I }, Z), J ? I.firePointEvent("legendItemClick", { browserEvent: q }) : ee && N(I, "legendItemClick", { browserEvent: q });
            });
        }
        createCheckboxForItem(I) {
          I.checkbox = x("input", { type: "checkbox", className: "highcharts-legend-checkbox", checked: I.selected, defaultChecked: I.selected }, this.options.itemCheckboxStyle, this.chart.container), w(I.checkbox, "click", function(R) {
            let Y = R.target;
            N(I.series || I, "checkboxClick", { checked: Y.checked, item: I }, function() {
              I.select();
            });
          });
        }
      }
      return (m = T || (T = {})).compose = function(O) {
        b(v, "Core.Legend") && w(O, "beforeMargins", function() {
          this.legend = new m(this, this.options.legend);
        });
      }, T;
    }), i(n, "Core/Chart/Chart.js", [n["Core/Animation/AnimationUtilities.js"], n["Core/Axis/Axis.js"], n["Core/Defaults.js"], n["Core/Templating.js"], n["Core/Foundation.js"], n["Core/Globals.js"], n["Core/Renderer/RendererRegistry.js"], n["Core/Series/Series.js"], n["Core/Series/SeriesRegistry.js"], n["Core/Renderer/SVG/SVGRenderer.js"], n["Core/Time.js"], n["Core/Utilities.js"], n["Core/Renderer/HTML/AST.js"], n["Core/Axis/Tick.js"]], function(o, a, r, s, l, d, y, u, m, h, c, g, v, P) {
      let { animate: f, animObject: S, setAnimation: w } = o, { defaultOptions: x, defaultTime: k } = r, { numberFormat: A } = s, { registerEventOptions: $ } = l, { charts: j, doc: N, marginNames: M, svg: D, win: C } = d, { seriesTypes: b } = m, { addEvent: p, attr: L, createElement: B, css: T, defined: O, diffObjects: I, discardElement: R, erase: Y, error: F, extend: U, find: Q, fireEvent: J, getStyle: ee, isArray: V, isNumber: G, isObject: W, isString: ae, merge: z, objectEach: q, pick: Z, pInt: ne, relativeLength: ie, removeEvent: re, splat: de, syncTimeout: me, uniqueKey: ce } = g;
      class pe {
        static chart(le, se, he) {
          return new pe(le, se, he);
        }
        constructor(le, se, he) {
          this.sharedClips = {};
          let ve = [...arguments];
          (ae(le) || le.nodeName) && (this.renderTo = ve.shift()), this.init(ve[0], ve[1]);
        }
        setZoomOptions() {
          let le = this.options.chart, se = le.zooming;
          this.zooming = { ...se, type: Z(le.zoomType, se.type), key: Z(le.zoomKey, se.key), pinchType: Z(le.pinchType, se.pinchType), singleTouch: Z(le.zoomBySingleTouch, se.singleTouch, !1), resetButton: z(se.resetButton, le.resetZoomButton) };
        }
        init(le, se) {
          J(this, "init", { args: arguments }, function() {
            let he = z(x, le), ve = he.chart;
            this.userOptions = U({}, le), this.margin = [], this.spacing = [], this.labelCollectors = [], this.callback = se, this.isResizing = 0, this.options = he, this.axes = [], this.series = [], this.time = le.time && Object.keys(le.time).length ? new c(le.time) : d.time, this.numberFormatter = ve.numberFormatter || A, this.styledMode = ve.styledMode, this.hasCartesianSeries = ve.showAxes, this.index = j.length, j.push(this), d.chartCount++, $(this, ve), this.xAxis = [], this.yAxis = [], this.pointCount = this.colorCounter = this.symbolCounter = 0, this.setZoomOptions(), J(this, "afterInit"), this.firstRender();
          });
        }
        initSeries(le) {
          let se = this.options.chart, he = le.type || se.type, ve = b[he];
          ve || F(17, !0, this, { missingModuleFor: he });
          let ye = new ve();
          return typeof ye.init == "function" && ye.init(this, le), ye;
        }
        setSortedData() {
          this.getSeriesOrderByLinks().forEach(function(le) {
            le.points || le.data || !le.enabledDataSorting || le.setData(le.options.data, !1);
          });
        }
        getSeriesOrderByLinks() {
          return this.series.concat().sort(function(le, se) {
            return le.linkedSeries.length || se.linkedSeries.length ? se.linkedSeries.length - le.linkedSeries.length : 0;
          });
        }
        orderItems(le, se = 0) {
          let he = this[le], ve = this.options[le] = de(this.options[le]).slice(), ye = this.userOptions[le] = this.userOptions[le] ? de(this.userOptions[le]).slice() : [];
          if (this.hasRendered && (ve.splice(se), ye.splice(se)), he)
            for (let be = se, ke = he.length; be < ke; ++be) {
              let we = he[be];
              we && (we.index = be, we instanceof u && (we.name = we.getName()), we.options.isInternal || (ve[be] = we.options, ye[be] = we.userOptions));
            }
        }
        isInsidePlot(le, se, he = {}) {
          let { inverted: ve, plotBox: ye, plotLeft: be, plotTop: ke, scrollablePlotBox: we } = this, { scrollLeft: Le = 0, scrollTop: Me = 0 } = he.visiblePlotOnly && this.scrollablePlotArea?.scrollingContainer || {}, De = he.series, Ae = he.visiblePlotOnly && we || ye, _e = he.inverted ? se : le, He = he.inverted ? le : se, Ee = { x: _e, y: He, isInsidePlot: !0, options: he };
          if (!he.ignoreX) {
            let Ne = De && (ve && !this.polar ? De.yAxis : De.xAxis) || { pos: be, len: 1 / 0 }, Ye = he.paneCoordinates ? Ne.pos + _e : be + _e;
            Ye >= Math.max(Le + be, Ne.pos) && Ye <= Math.min(Le + be + Ae.width, Ne.pos + Ne.len) || (Ee.isInsidePlot = !1);
          }
          if (!he.ignoreY && Ee.isInsidePlot) {
            let Ne = !ve && he.axis && !he.axis.isXAxis && he.axis || De && (ve ? De.xAxis : De.yAxis) || { pos: ke, len: 1 / 0 }, Ye = he.paneCoordinates ? Ne.pos + He : ke + He;
            Ye >= Math.max(Me + ke, Ne.pos) && Ye <= Math.min(Me + ke + Ae.height, Ne.pos + Ne.len) || (Ee.isInsidePlot = !1);
          }
          return J(this, "afterIsInsidePlot", Ee), Ee.isInsidePlot;
        }
        redraw(le) {
          J(this, "beforeRedraw");
          let se = this.hasCartesianSeries ? this.axes : this.colorAxis || [], he = this.series, ve = this.pointer, ye = this.legend, be = this.userOptions.legend, ke = this.renderer, we = ke.isHidden(), Le = [], Me, De, Ae, _e = this.isDirtyBox, He = this.isDirtyLegend, Ee;
          for (ke.rootFontSize = ke.boxWrapper.getStyle("font-size"), this.setResponsive && this.setResponsive(!1), w(!!this.hasRendered && le, this), we && this.temporaryDisplay(), this.layOutTitles(!1), Ae = he.length; Ae--; )
            if (((Ee = he[Ae]).options.stacking || Ee.options.centerInCategory) && (De = !0, Ee.isDirty)) {
              Me = !0;
              break;
            }
          if (Me)
            for (Ae = he.length; Ae--; )
              (Ee = he[Ae]).options.stacking && (Ee.isDirty = !0);
          he.forEach(function(Ne) {
            Ne.isDirty && (Ne.options.legendType === "point" ? (typeof Ne.updateTotals == "function" && Ne.updateTotals(), He = !0) : be && (be.labelFormatter || be.labelFormat) && (He = !0)), Ne.isDirtyData && J(Ne, "updatedData");
          }), He && ye && ye.options.enabled && (ye.render(), this.isDirtyLegend = !1), De && this.getStacks(), se.forEach(function(Ne) {
            Ne.updateNames(), Ne.setScale();
          }), this.getMargins(), se.forEach(function(Ne) {
            Ne.isDirty && (_e = !0);
          }), se.forEach(function(Ne) {
            let Ye = Ne.min + "," + Ne.max;
            Ne.extKey !== Ye && (Ne.extKey = Ye, Le.push(function() {
              J(Ne, "afterSetExtremes", U(Ne.eventArgs, Ne.getExtremes())), delete Ne.eventArgs;
            })), (_e || De) && Ne.redraw();
          }), _e && this.drawChartBox(), J(this, "predraw"), he.forEach(function(Ne) {
            (_e || Ne.isDirty) && Ne.visible && Ne.redraw(), Ne.isDirtyData = !1;
          }), ve && ve.reset(!0), ke.draw(), J(this, "redraw"), J(this, "render"), we && this.temporaryDisplay(!0), Le.forEach(function(Ne) {
            Ne.call();
          });
        }
        get(le) {
          let se = this.series;
          function he(ye) {
            return ye.id === le || ye.options && ye.options.id === le;
          }
          let ve = Q(this.axes, he) || Q(this.series, he);
          for (let ye = 0; !ve && ye < se.length; ye++)
            ve = Q(se[ye].points || [], he);
          return ve;
        }
        getAxes() {
          let le = this.userOptions;
          for (let se of (J(this, "getAxes"), ["xAxis", "yAxis"]))
            for (let he of le[se] = de(le[se] || {}))
              new a(this, he, se);
          J(this, "afterGetAxes");
        }
        getSelectedPoints() {
          return this.series.reduce((le, se) => (se.getPointsCollection().forEach((he) => {
            Z(he.selectedStaging, he.selected) && le.push(he);
          }), le), []);
        }
        getSelectedSeries() {
          return this.series.filter(function(le) {
            return le.selected;
          });
        }
        setTitle(le, se, he) {
          this.applyDescription("title", le), this.applyDescription("subtitle", se), this.applyDescription("caption", void 0), this.layOutTitles(he);
        }
        applyDescription(le, se) {
          let he = this, ve = this.options[le] = z(this.options[le], se), ye = this[le];
          ye && se && (this[le] = ye = ye.destroy()), ve && !ye && ((ye = this.renderer.text(ve.text, 0, 0, ve.useHTML).attr({ align: ve.align, class: "highcharts-" + le, zIndex: ve.zIndex || 4 }).add()).update = function(be, ke) {
            he.applyDescription(le, be), he.layOutTitles(ke);
          }, this.styledMode || ye.css(U(le === "title" ? { fontSize: this.options.isStock ? "1em" : "1.2em" } : {}, ve.style)), this[le] = ye);
        }
        layOutTitles(le = !0) {
          let se = [0, 0, 0], he = this.renderer, ve = this.spacingBox;
          ["title", "subtitle", "caption"].forEach(function(be) {
            let ke = this[be], we = this.options[be], Le = we.verticalAlign || "top", Me = be === "title" ? Le === "top" ? -3 : 0 : Le === "top" ? se[0] + 2 : 0;
            if (ke) {
              ke.css({ width: (we.width || ve.width + (we.widthAdjust || 0)) + "px" });
              let De = he.fontMetrics(ke).b, Ae = Math.round(ke.getBBox(we.useHTML).height);
              ke.align(U({ y: Le === "bottom" ? De : Me + De, height: Ae }, we), !1, "spacingBox"), we.floating || (Le === "top" ? se[0] = Math.ceil(se[0] + Ae) : Le === "bottom" && (se[2] = Math.ceil(se[2] + Ae)));
            }
          }, this), se[0] && (this.options.title.verticalAlign || "top") === "top" && (se[0] += this.options.title.margin), se[2] && this.options.caption.verticalAlign === "bottom" && (se[2] += this.options.caption.margin);
          let ye = !this.titleOffset || this.titleOffset.join(",") !== se.join(",");
          this.titleOffset = se, J(this, "afterLayOutTitles"), !this.isDirtyBox && ye && (this.isDirtyBox = this.isDirtyLegend = ye, this.hasRendered && le && this.isDirtyBox && this.redraw());
        }
        getContainerBox() {
          let le = [].map.call(this.renderTo.children, (he) => {
            if (he !== this.container) {
              let ve = he.style.display;
              return he.style.display = "none", [he, ve];
            }
          }), se = { width: ee(this.renderTo, "width", !0) || 0, height: ee(this.renderTo, "height", !0) || 0 };
          return le.filter(Boolean).forEach(([he, ve]) => {
            he.style.display = ve;
          }), se;
        }
        getChartSize() {
          let le = this.options.chart, se = le.width, he = le.height, ve = this.getContainerBox(), ye = ve.height > 1 && !(!this.renderTo.parentElement?.style.height && this.renderTo.style.height === "100%");
          this.chartWidth = Math.max(0, se || ve.width || 600), this.chartHeight = Math.max(0, ie(he, this.chartWidth) || (ye ? ve.height : 400)), this.containerBox = ve;
        }
        temporaryDisplay(le) {
          let se = this.renderTo, he;
          if (le)
            for (; se && se.style; )
              se.hcOrigStyle && (T(se, se.hcOrigStyle), delete se.hcOrigStyle), se.hcOrigDetached && (N.body.removeChild(se), se.hcOrigDetached = !1), se = se.parentNode;
          else
            for (; se && se.style && (N.body.contains(se) || se.parentNode || (se.hcOrigDetached = !0, N.body.appendChild(se)), (ee(se, "display", !1) === "none" || se.hcOricDetached) && (se.hcOrigStyle = { display: se.style.display, height: se.style.height, overflow: se.style.overflow }, he = { display: "block", overflow: "hidden" }, se !== this.renderTo && (he.height = 0), T(se, he), se.offsetWidth || se.style.setProperty("display", "block", "important")), (se = se.parentNode) !== N.body); )
              ;
        }
        setClassName(le) {
          this.container.className = "highcharts-container " + (le || "");
        }
        getContainer() {
          let le = this.options, se = le.chart, he = "data-highcharts-chart", ve = ce(), ye, be = this.renderTo;
          be || (this.renderTo = be = se.renderTo), ae(be) && (this.renderTo = be = N.getElementById(be)), be || F(13, !0, this);
          let ke = ne(L(be, he));
          G(ke) && j[ke] && j[ke].hasRendered && j[ke].destroy(), L(be, he, this.index), be.innerHTML = v.emptyHTML, se.skipClone || be.offsetWidth || this.temporaryDisplay(), this.getChartSize();
          let we = this.chartHeight, Le = this.chartWidth;
          T(be, { overflow: "hidden" }), this.styledMode || (ye = U({ position: "relative", overflow: "hidden", width: Le + "px", height: we + "px", textAlign: "left", lineHeight: "normal", zIndex: 0, "-webkit-tap-highlight-color": "rgba(0,0,0,0)", userSelect: "none", "touch-action": "manipulation", outline: "none", padding: "0px" }, se.style || {}));
          let Me = B("div", { id: ve }, ye, be);
          this.container = Me, this.getChartSize(), Le === this.chartWidth || (Le = this.chartWidth, this.styledMode || T(Me, { width: Z(se.style?.width, Le + "px") })), this.containerBox = this.getContainerBox(), this._cursor = Me.style.cursor;
          let De = se.renderer || !D ? y.getRendererType(se.renderer) : h;
          if (this.renderer = new De(Me, Le, we, void 0, se.forExport, le.exporting && le.exporting.allowHTML, this.styledMode), w(void 0, this), this.setClassName(se.className), this.styledMode)
            for (let Ae in le.defs)
              this.renderer.definition(le.defs[Ae]);
          else
            this.renderer.setStyle(se.style);
          this.renderer.chartIndex = this.index, J(this, "afterGetContainer");
        }
        getMargins(le) {
          let { spacing: se, margin: he, titleOffset: ve } = this;
          this.resetMargins(), ve[0] && !O(he[0]) && (this.plotTop = Math.max(this.plotTop, ve[0] + se[0])), ve[2] && !O(he[2]) && (this.marginBottom = Math.max(this.marginBottom, ve[2] + se[2])), this.legend && this.legend.display && this.legend.adjustMargins(he, se), J(this, "getMargins"), le || this.getAxisMargins();
        }
        getAxisMargins() {
          let le = this, se = le.axisOffset = [0, 0, 0, 0], he = le.colorAxis, ve = le.margin, ye = function(be) {
            be.forEach(function(ke) {
              ke.visible && ke.getOffset();
            });
          };
          le.hasCartesianSeries ? ye(le.axes) : he && he.length && ye(he), M.forEach(function(be, ke) {
            O(ve[ke]) || (le[be] += se[ke]);
          }), le.setChartSize();
        }
        getOptions() {
          return I(this.userOptions, x);
        }
        reflow(le) {
          let se = this, he = se.containerBox, ve = se.getContainerBox();
          delete se.pointer?.chartPosition, !se.isPrinting && !se.isResizing && he && ve.width && ((ve.width !== he.width || ve.height !== he.height) && (g.clearTimeout(se.reflowTimeout), se.reflowTimeout = me(function() {
            se.container && se.setSize(void 0, void 0, !1);
          }, le ? 100 : 0)), se.containerBox = ve);
        }
        setReflow() {
          let le = this, se = (he) => {
            le.options?.chart.reflow && le.hasLoaded && le.reflow(he);
          };
          if (typeof ResizeObserver == "function")
            new ResizeObserver(se).observe(le.renderTo);
          else {
            let he = p(C, "resize", se);
            p(this, "destroy", he);
          }
        }
        setSize(le, se, he) {
          let ve = this, ye = ve.renderer;
          ve.isResizing += 1, w(he, ve);
          let be = ye.globalAnimation;
          ve.oldChartHeight = ve.chartHeight, ve.oldChartWidth = ve.chartWidth, le !== void 0 && (ve.options.chart.width = le), se !== void 0 && (ve.options.chart.height = se), ve.getChartSize();
          let { chartWidth: ke, chartHeight: we, scrollablePixelsX: Le = 0, scrollablePixelsY: Me = 0 } = ve;
          (ve.isDirtyBox || ke !== ve.oldChartWidth || we !== ve.oldChartHeight) && (ve.styledMode || (be ? f : T)(ve.container, { width: `${ke + Le}px`, height: `${we + Me}px` }, be), ve.setChartSize(!0), ye.setSize(ke, we, be), ve.axes.forEach(function(De) {
            De.isDirty = !0, De.setScale();
          }), ve.isDirtyLegend = !0, ve.isDirtyBox = !0, ve.layOutTitles(), ve.getMargins(), ve.redraw(be), ve.oldChartHeight = void 0, J(ve, "resize"), setTimeout(() => {
            ve && J(ve, "endResize");
          }, S(be).duration)), ve.isResizing -= 1;
        }
        setChartSize(le) {
          let se, he, ve, ye, { chartHeight: be, chartWidth: ke, inverted: we, spacing: Le, renderer: Me } = this, De = this.clipOffset, Ae = Math[we ? "floor" : "round"];
          this.plotLeft = se = Math.round(this.plotLeft), this.plotTop = he = Math.round(this.plotTop), this.plotWidth = ve = Math.max(0, Math.round(ke - se - this.marginRight)), this.plotHeight = ye = Math.max(0, Math.round(be - he - this.marginBottom)), this.plotSizeX = we ? ye : ve, this.plotSizeY = we ? ve : ye, this.spacingBox = Me.spacingBox = { x: Le[3], y: Le[0], width: ke - Le[3] - Le[1], height: be - Le[0] - Le[2] }, this.plotBox = Me.plotBox = { x: se, y: he, width: ve, height: ye }, De && (this.clipBox = { x: Ae(De[3]), y: Ae(De[0]), width: Ae(this.plotSizeX - De[1] - De[3]), height: Ae(this.plotSizeY - De[0] - De[2]) }), le || (this.axes.forEach(function(_e) {
            _e.setAxisSize(), _e.setAxisTranslation();
          }), Me.alignElements()), J(this, "afterSetChartSize", { skipAxes: le });
        }
        resetMargins() {
          J(this, "resetMargins");
          let le = this, se = le.options.chart, he = se.plotBorderWidth || 0, ve = he / 2;
          ["margin", "spacing"].forEach(function(ye) {
            let be = se[ye], ke = W(be) ? be : [be, be, be, be];
            ["Top", "Right", "Bottom", "Left"].forEach(function(we, Le) {
              le[ye][Le] = Z(se[ye + we], ke[Le]);
            });
          }), M.forEach(function(ye, be) {
            le[ye] = Z(le.margin[be], le.spacing[be]);
          }), le.axisOffset = [0, 0, 0, 0], le.clipOffset = [ve, ve, ve, ve], le.plotBorderWidth = he;
        }
        drawChartBox() {
          let le = this.options.chart, se = this.renderer, he = this.chartWidth, ve = this.chartHeight, ye = this.styledMode, be = this.plotBGImage, ke = le.backgroundColor, we = le.plotBackgroundColor, Le = le.plotBackgroundImage, Me = this.plotLeft, De = this.plotTop, Ae = this.plotWidth, _e = this.plotHeight, He = this.plotBox, Ee = this.clipRect, Ne = this.clipBox, Ye = this.chartBackground, Xe = this.plotBackground, nt = this.plotBorder, ut, bt, Bt, kt = "animate";
          Ye || (this.chartBackground = Ye = se.rect().addClass("highcharts-background").add(), kt = "attr"), ye ? ut = bt = Ye.strokeWidth() : (bt = (ut = le.borderWidth || 0) + (le.shadow ? 8 : 0), Bt = { fill: ke || "none" }, (ut || Ye["stroke-width"]) && (Bt.stroke = le.borderColor, Bt["stroke-width"] = ut), Ye.attr(Bt).shadow(le.shadow)), Ye[kt]({ x: bt / 2, y: bt / 2, width: he - bt - ut % 2, height: ve - bt - ut % 2, r: le.borderRadius }), kt = "animate", Xe || (kt = "attr", this.plotBackground = Xe = se.rect().addClass("highcharts-plot-background").add()), Xe[kt](He), !ye && (Xe.attr({ fill: we || "none" }).shadow(le.plotShadow), Le && (be ? (Le !== be.attr("href") && be.attr("href", Le), be.animate(He)) : this.plotBGImage = se.image(Le, Me, De, Ae, _e).add())), Ee ? Ee.animate({ width: Ne.width, height: Ne.height }) : this.clipRect = se.clipRect(Ne), kt = "animate", nt || (kt = "attr", this.plotBorder = nt = se.rect().addClass("highcharts-plot-border").attr({ zIndex: 1 }).add()), ye || nt.attr({ stroke: le.plotBorderColor, "stroke-width": le.plotBorderWidth || 0, fill: "none" }), nt[kt](nt.crisp({ x: Me, y: De, width: Ae, height: _e }, -nt.strokeWidth())), this.isDirtyBox = !1, J(this, "afterDrawChartBox");
        }
        propFromSeries() {
          let le, se, he, ve = this, ye = ve.options.chart, be = ve.options.series;
          ["inverted", "angular", "polar"].forEach(function(ke) {
            for (se = b[ye.type], he = ye[ke] || se && se.prototype[ke], le = be && be.length; !he && le--; )
              (se = b[be[le].type]) && se.prototype[ke] && (he = !0);
            ve[ke] = he;
          });
        }
        linkSeries(le) {
          let se = this, he = se.series;
          he.forEach(function(ve) {
            ve.linkedSeries.length = 0;
          }), he.forEach(function(ve) {
            let { linkedTo: ye } = ve.options;
            if (ae(ye)) {
              let be;
              (be = ye === ":previous" ? se.series[ve.index - 1] : se.get(ye)) && be.linkedParent !== ve && (be.linkedSeries.push(ve), ve.linkedParent = be, be.enabledDataSorting && ve.setDataSortingOptions(), ve.visible = Z(ve.options.visible, be.options.visible, ve.visible));
            }
          }), J(this, "afterLinkSeries", { isUpdating: le });
        }
        renderSeries() {
          this.series.forEach(function(le) {
            le.translate(), le.render();
          });
        }
        render() {
          let le = this.axes, se = this.colorAxis, he = this.renderer, ve = this.options.chart.axisLayoutRuns || 2, ye = (Me) => {
            Me.forEach((De) => {
              De.visible && De.render();
            });
          }, be = 0, ke = !0, we, Le = 0;
          for (let Me of (this.setTitle(), J(this, "beforeMargins"), this.getStacks?.(), this.getMargins(!0), this.setChartSize(), le)) {
            let { options: De } = Me, { labels: Ae } = De;
            if (this.hasCartesianSeries && Me.horiz && Me.visible && Ae.enabled && Me.series.length && Me.coll !== "colorAxis" && !this.polar) {
              be = De.tickLength, Me.createGroups();
              let _e = new P(Me, 0, "", !0), He = _e.createLabel("x", Ae);
              if (_e.destroy(), He && Z(Ae.reserveSpace, !G(De.crossing)) && (be = He.getBBox().height + Ae.distance + Math.max(De.offset || 0, 0)), be) {
                He?.destroy();
                break;
              }
            }
          }
          for (this.plotHeight = Math.max(this.plotHeight - be, 0); (ke || we || ve > 1) && Le < ve; ) {
            let Me = this.plotWidth, De = this.plotHeight;
            for (let Ae of le)
              Le === 0 ? Ae.setScale() : (Ae.horiz && ke || !Ae.horiz && we) && Ae.setTickInterval(!0);
            Le === 0 ? this.getAxisMargins() : this.getMargins(), ke = Me / this.plotWidth > (Le ? 1 : 1.1), we = De / this.plotHeight > (Le ? 1 : 1.05), Le++;
          }
          this.drawChartBox(), this.hasCartesianSeries ? ye(le) : se && se.length && ye(se), this.seriesGroup || (this.seriesGroup = he.g("series-group").attr({ zIndex: 3 }).shadow(this.options.chart.seriesGroupShadow).add()), this.renderSeries(), this.addCredits(), this.setResponsive && this.setResponsive(), this.hasRendered = !0;
        }
        addCredits(le) {
          let se = this, he = z(!0, this.options.credits, le);
          he.enabled && !this.credits && (this.credits = this.renderer.text(he.text + (this.mapCredits || ""), 0, 0).addClass("highcharts-credits").on("click", function() {
            he.href && (C.location.href = he.href);
          }).attr({ align: he.position.align, zIndex: 8 }), se.styledMode || this.credits.css(he.style), this.credits.add().align(he.position), this.credits.update = function(ve) {
            se.credits = se.credits.destroy(), se.addCredits(ve);
          });
        }
        destroy() {
          let le, se = this, he = se.axes, ve = se.series, ye = se.container, be = ye && ye.parentNode;
          for (J(se, "destroy"), se.renderer.forExport ? Y(j, se) : j[se.index] = void 0, d.chartCount--, se.renderTo.removeAttribute("data-highcharts-chart"), re(se), le = he.length; le--; )
            he[le] = he[le].destroy();
          for (this.scroller && this.scroller.destroy && this.scroller.destroy(), le = ve.length; le--; )
            ve[le] = ve[le].destroy();
          ["title", "subtitle", "chartBackground", "plotBackground", "plotBGImage", "plotBorder", "seriesGroup", "clipRect", "credits", "pointer", "rangeSelector", "legend", "resetZoomButton", "tooltip", "renderer"].forEach(function(ke) {
            let we = se[ke];
            we && we.destroy && (se[ke] = we.destroy());
          }), ye && (ye.innerHTML = v.emptyHTML, re(ye), be && R(ye)), q(se, function(ke, we) {
            delete se[we];
          });
        }
        firstRender() {
          let le = this, se = le.options;
          le.getContainer(), le.resetMargins(), le.setChartSize(), le.propFromSeries(), le.getAxes();
          let he = V(se.series) ? se.series : [];
          se.series = [], he.forEach(function(ve) {
            le.initSeries(ve);
          }), le.linkSeries(), le.setSortedData(), J(le, "beforeRender"), le.render(), le.pointer?.getChartPosition(), le.renderer.imgCount || le.hasLoaded || le.onload(), le.temporaryDisplay(!0);
        }
        onload() {
          this.callbacks.concat([this.callback]).forEach(function(le) {
            le && this.index !== void 0 && le.apply(this, [this]);
          }, this), J(this, "load"), J(this, "render"), O(this.index) && this.setReflow(), this.warnIfA11yModuleNotLoaded(), this.hasLoaded = !0;
        }
        warnIfA11yModuleNotLoaded() {
          let { options: le, title: se } = this;
          !le || this.accessibility || (this.renderer.boxWrapper.attr({ role: "img", "aria-label": (se && se.element.textContent || "").replace(/</g, "&lt;") }), le.accessibility && le.accessibility.enabled === !1 || F('Highcharts warning: Consider including the "accessibility.js" module to make your chart more usable for people with disabilities. Set the "accessibility.enabled" option to false to remove this warning. See https://www.highcharts.com/docs/accessibility/accessibility-module.', !1, this));
        }
        addSeries(le, se, he) {
          let ve, ye = this;
          return le && (se = Z(se, !0), J(ye, "addSeries", { options: le }, function() {
            ve = ye.initSeries(le), ye.isDirtyLegend = !0, ye.linkSeries(), ve.enabledDataSorting && ve.setData(le.data, !1), J(ye, "afterAddSeries", { series: ve }), se && ye.redraw(he);
          })), ve;
        }
        addAxis(le, se, he, ve) {
          return this.createAxis(se ? "xAxis" : "yAxis", { axis: le, redraw: he, animation: ve });
        }
        addColorAxis(le, se, he) {
          return this.createAxis("colorAxis", { axis: le, redraw: se, animation: he });
        }
        createAxis(le, se) {
          let he = new a(this, se.axis, le);
          return Z(se.redraw, !0) && this.redraw(se.animation), he;
        }
        showLoading(le) {
          let se = this, he = se.options, ve = he.loading, ye = function() {
            be && T(be, { left: se.plotLeft + "px", top: se.plotTop + "px", width: se.plotWidth + "px", height: se.plotHeight + "px" });
          }, be = se.loadingDiv, ke = se.loadingSpan;
          be || (se.loadingDiv = be = B("div", { className: "highcharts-loading highcharts-loading-hidden" }, null, se.container)), ke || (se.loadingSpan = ke = B("span", { className: "highcharts-loading-inner" }, null, be), p(se, "redraw", ye)), be.className = "highcharts-loading", v.setElementHTML(ke, Z(le, he.lang.loading, "")), se.styledMode || (T(be, U(ve.style, { zIndex: 10 })), T(ke, ve.labelStyle), se.loadingShown || (T(be, { opacity: 0, display: "" }), f(be, { opacity: ve.style.opacity || 0.5 }, { duration: ve.showDuration || 0 }))), se.loadingShown = !0, ye();
        }
        hideLoading() {
          let le = this.options, se = this.loadingDiv;
          se && (se.className = "highcharts-loading highcharts-loading-hidden", this.styledMode || f(se, { opacity: 0 }, { duration: le.loading.hideDuration || 100, complete: function() {
            T(se, { display: "none" });
          } })), this.loadingShown = !1;
        }
        update(le, se, he, ve) {
          let ye, be, ke, we = this, Le = { credits: "addCredits", title: "setTitle", subtitle: "setSubtitle", caption: "setCaption" }, Me = le.isResponsiveOptions, De = [];
          J(we, "update", { options: le }), Me || we.setResponsive(!1, !0), le = I(le, we.options), we.userOptions = z(we.userOptions, le);
          let Ae = le.chart;
          Ae && (z(!0, we.options.chart, Ae), this.setZoomOptions(), "className" in Ae && we.setClassName(Ae.className), ("inverted" in Ae || "polar" in Ae || "type" in Ae) && (we.propFromSeries(), ye = !0), "alignTicks" in Ae && (ye = !0), "events" in Ae && $(this, Ae), q(Ae, function(Ee, Ne) {
            we.propsRequireUpdateSeries.indexOf("chart." + Ne) !== -1 && (be = !0), we.propsRequireDirtyBox.indexOf(Ne) !== -1 && (we.isDirtyBox = !0), we.propsRequireReflow.indexOf(Ne) === -1 || (we.isDirtyBox = !0, Me || (ke = !0));
          }), !we.styledMode && Ae.style && we.renderer.setStyle(we.options.chart.style || {})), !we.styledMode && le.colors && (this.options.colors = le.colors), le.time && (this.time === k && (this.time = new c(le.time)), z(!0, we.options.time, le.time)), q(le, function(Ee, Ne) {
            we[Ne] && typeof we[Ne].update == "function" ? we[Ne].update(Ee, !1) : typeof we[Le[Ne]] == "function" ? we[Le[Ne]](Ee) : Ne !== "colors" && we.collectionsWithUpdate.indexOf(Ne) === -1 && z(!0, we.options[Ne], le[Ne]), Ne !== "chart" && we.propsRequireUpdateSeries.indexOf(Ne) !== -1 && (be = !0);
          }), this.collectionsWithUpdate.forEach(function(Ee) {
            le[Ee] && (de(le[Ee]).forEach(function(Ne, Ye) {
              let Xe, nt = O(Ne.id);
              nt && (Xe = we.get(Ne.id)), !Xe && we[Ee] && (Xe = we[Ee][Z(Ne.index, Ye)]) && (nt && O(Xe.options.id) || Xe.options.isInternal) && (Xe = void 0), Xe && Xe.coll === Ee && (Xe.update(Ne, !1), he && (Xe.touched = !0)), !Xe && he && we.collectionsWithInit[Ee] && (we.collectionsWithInit[Ee][0].apply(we, [Ne].concat(we.collectionsWithInit[Ee][1] || []).concat([!1])).touched = !0);
            }), he && we[Ee].forEach(function(Ne) {
              Ne.touched || Ne.options.isInternal ? delete Ne.touched : De.push(Ne);
            }));
          }), De.forEach(function(Ee) {
            Ee.chart && Ee.remove && Ee.remove(!1);
          }), ye && we.axes.forEach(function(Ee) {
            Ee.update({}, !1);
          }), be && we.getSeriesOrderByLinks().forEach(function(Ee) {
            Ee.chart && Ee.update({}, !1);
          }, this);
          let _e = Ae && Ae.width, He = Ae && (ae(Ae.height) ? ie(Ae.height, _e || we.chartWidth) : Ae.height);
          ke || G(_e) && _e !== we.chartWidth || G(He) && He !== we.chartHeight ? we.setSize(_e, He, ve) : Z(se, !0) && we.redraw(ve), J(we, "afterUpdate", { options: le, redraw: se, animation: ve });
        }
        setSubtitle(le, se) {
          this.applyDescription("subtitle", le), this.layOutTitles(se);
        }
        setCaption(le, se) {
          this.applyDescription("caption", le), this.layOutTitles(se);
        }
        showResetZoom() {
          let le = this, se = x.lang, he = le.zooming.resetButton, ve = he.theme, ye = he.relativeTo === "chart" || he.relativeTo === "spacingBox" ? null : "plotBox";
          function be() {
            le.zoomOut();
          }
          J(this, "beforeShowResetZoom", null, function() {
            le.resetZoomButton = le.renderer.button(se.resetZoom, null, null, be, ve).attr({ align: he.position.align, title: se.resetZoomTitle }).addClass("highcharts-reset-zoom").add().align(he.position, !1, ye);
          }), J(this, "afterShowResetZoom");
        }
        zoomOut() {
          J(this, "selection", { resetSelection: !0 }, () => this.transform({ reset: !0, trigger: "zoom" }));
        }
        pan(le, se) {
          let he = this, ve = typeof se == "object" ? se : { enabled: se, type: "x" }, ye = ve.type, be = ye && he[{ x: "xAxis", xy: "axes", y: "yAxis" }[ye]].filter((we) => we.options.panningEnabled && !we.options.isInternal), ke = he.options.chart;
          ke?.panning && (ke.panning = ve), J(this, "pan", { originalEvent: le }, () => {
            he.transform({ axes: be, event: le, to: { x: le.chartX - (he.mouseDownX || 0), y: le.chartY - (he.mouseDownY || 0) }, trigger: "pan" }), T(he.container, { cursor: "move" });
          });
        }
        transform(le) {
          let { axes: se = this.axes, event: he, from: ve = {}, reset: ye, selection: be, to: ke = {}, trigger: we } = le, { inverted: Le } = this, Me = !1, De, Ae;
          for (let _e of (this.hoverPoints?.forEach((He) => He.setState()), se)) {
            let { horiz: He, len: Ee, minPointOffset: Ne = 0, options: Ye, reversed: Xe } = _e, nt = He ? "width" : "height", ut = He ? "x" : "y", bt = Z(ke[nt], _e.len), Bt = Z(ve[nt], _e.len), kt = 10 > Math.abs(bt) ? 1 : bt / Bt, nn = (ve[ut] || 0) + Bt / 2 - _e.pos, an = nn - ((ke[ut] ?? _e.pos) + bt / 2 - _e.pos) / kt, Cn = Xe && !Le || !Xe && Le ? -1 : 1;
            if (!ye && (nn < 0 || nn > _e.len))
              continue;
            let Ft = _e.toValue(an, !0) + (be || _e.isOrdinal ? 0 : Ne * Cn), dn = _e.toValue(an + Ee / kt, !0) - (be || _e.isOrdinal ? 0 : Ne * Cn || 0), Rn = _e.allExtremes;
            if (Ft > dn && ([Ft, dn] = [dn, Ft]), kt === 1 && !ye && _e.coll === "yAxis" && !Rn) {
              for (let Qs of _e.series) {
                let Ka = Qs.getExtremes(Qs.getProcessedData(!0).yData, !0);
                Rn ?? (Rn = { dataMin: Number.MAX_VALUE, dataMax: -Number.MAX_VALUE }), G(Ka.dataMin) && G(Ka.dataMax) && (Rn.dataMin = Math.min(Ka.dataMin, Rn.dataMin), Rn.dataMax = Math.max(Ka.dataMax, Rn.dataMax));
              }
              _e.allExtremes = Rn;
            }
            let { dataMin: Vh, dataMax: Gh, min: Ys, max: qs } = U(_e.getExtremes(), Rn || {}), Ks = Vh ?? Ye.min, Xs = Gh ?? Ye.max, Yo = dn - Ft, Zs = _e.categories ? 0 : Math.min(Yo, Xs - Ks), qo = Ks - Zs * (O(Ye.min) ? 0 : Ye.minPadding), Ko = Xs + Zs * (O(Ye.max) ? 0 : Ye.maxPadding), Js = _e.allowZoomOutside || kt === 1 || we !== "zoom" && kt > 1, Ya = Math.min(Ye.min ?? qo, qo, Js ? Ys : qo), qa = Math.max(Ye.max ?? Ko, Ko, Js ? qs : Ko);
            (!_e.isOrdinal || _e.options.overscroll || kt !== 1 || ye) && (Ft < Ya && (Ft = Ya, kt >= 1 && (dn = Ft + Yo)), dn > qa && (dn = qa, kt >= 1 && (Ft = dn - Yo)), (ye || _e.series.length && (Ft !== Ys || dn !== qs) && Ft >= Ya && dn <= qa) && (be ? be[_e.coll].push({ axis: _e, min: Ft, max: dn }) : (_e.isPanning = we !== "zoom", _e.isPanning && (Ae = !0), _e.setExtremes(ye ? void 0 : Ft, ye ? void 0 : dn, !1, !1, { move: an, trigger: we, scale: kt }), !ye && (Ft > Ya || dn < qa) && we !== "mousewheel" && (De = !0)), Me = !0), he && (this[He ? "mouseDownX" : "mouseDownY"] = he[He ? "chartX" : "chartY"]));
          }
          return Me && (be ? J(this, "selection", be, () => {
            delete le.selection, le.trigger = "zoom", this.transform(le);
          }) : (!De || Ae || this.resetZoomButton ? !De && this.resetZoomButton && (this.resetZoomButton = this.resetZoomButton.destroy()) : this.showResetZoom(), this.redraw(we === "zoom" && (this.options.chart.animation ?? this.pointCount < 100)))), Me;
        }
      }
      return U(pe.prototype, { callbacks: [], collectionsWithInit: { xAxis: [pe.prototype.addAxis, [!0]], yAxis: [pe.prototype.addAxis, [!1]], series: [pe.prototype.addSeries] }, collectionsWithUpdate: ["xAxis", "yAxis", "series"], propsRequireDirtyBox: ["backgroundColor", "borderColor", "borderWidth", "borderRadius", "plotBackgroundColor", "plotBackgroundImage", "plotBorderColor", "plotBorderWidth", "plotShadow", "shadow"], propsRequireReflow: ["margin", "marginTop", "marginRight", "marginBottom", "marginLeft", "spacing", "spacingTop", "spacingRight", "spacingBottom", "spacingLeft"], propsRequireUpdateSeries: ["chart.inverted", "chart.polar", "chart.ignoreHiddenSeries", "chart.type", "colors", "plotOptions", "time", "tooltip"] }), pe;
    }), i(n, "Extensions/ScrollablePlotArea.js", [n["Core/Animation/AnimationUtilities.js"], n["Core/Globals.js"], n["Core/Renderer/RendererRegistry.js"], n["Core/Utilities.js"]], function(o, a, r, s) {
      let { stop: l } = o, { composed: d } = a, { addEvent: y, createElement: u, css: m, defined: h, merge: c, pushUnique: g } = s;
      function v() {
        let S = this.scrollablePlotArea;
        (this.scrollablePixelsX || this.scrollablePixelsY) && !S && (this.scrollablePlotArea = S = new f(this)), S?.applyFixed();
      }
      function P() {
        this.chart.scrollablePlotArea && (this.chart.scrollablePlotArea.isDirty = !0);
      }
      class f {
        static compose(w, x, k) {
          g(d, this.compose) && (y(w, "afterInit", P), y(x, "afterSetChartSize", (A) => this.afterSetSize(A.target, A)), y(x, "render", v), y(k, "show", P));
        }
        static afterSetSize(w, x) {
          let k, A, $, { minWidth: j, minHeight: N } = w.options.chart.scrollablePlotArea || {}, { clipBox: M, plotBox: D, inverted: C, renderer: b } = w;
          if (!b.forExport && (j ? (w.scrollablePixelsX = k = Math.max(0, j - w.chartWidth), k && (w.scrollablePlotBox = c(w.plotBox), D.width = w.plotWidth += k, M[C ? "height" : "width"] += k, $ = !0)) : N && (w.scrollablePixelsY = A = Math.max(0, N - w.chartHeight), h(A) && (w.scrollablePlotBox = c(w.plotBox), D.height = w.plotHeight += A, M[C ? "width" : "height"] += A, $ = !1)), h($) && !x.skipAxes))
            for (let p of w.axes)
              p.horiz === $ && (p.setAxisSize(), p.setAxisTranslation());
        }
        constructor(w) {
          let x, k = w.options.chart, A = r.getRendererType(), $ = k.scrollablePlotArea || {}, j = this.moveFixedElements.bind(this), N = { WebkitOverflowScrolling: "touch", overflowX: "hidden", overflowY: "hidden" };
          w.scrollablePixelsX && (N.overflowX = "auto"), w.scrollablePixelsY && (N.overflowY = "auto"), this.chart = w;
          let M = this.parentDiv = u("div", { className: "highcharts-scrolling-parent" }, { position: "relative" }, w.renderTo), D = this.scrollingContainer = u("div", { className: "highcharts-scrolling" }, N, M), C = this.innerContainer = u("div", { className: "highcharts-inner-container" }, void 0, D), b = this.fixedDiv = u("div", { className: "highcharts-fixed" }, { position: "absolute", overflow: "hidden", pointerEvents: "none", zIndex: (k.style?.zIndex || 0) + 2, top: 0 }, void 0, !0), p = this.fixedRenderer = new A(b, w.chartWidth, w.chartHeight, k.style);
          this.mask = p.path().attr({ fill: k.backgroundColor || "#fff", "fill-opacity": $.opacity ?? 0.85, zIndex: -1 }).addClass("highcharts-scrollable-mask").add(), D.parentNode.insertBefore(b, D), m(w.renderTo, { overflow: "visible" }), y(w, "afterShowResetZoom", j), y(w, "afterApplyDrilldown", j), y(w, "afterLayOutTitles", j), y(D, "scroll", () => {
            let { pointer: L, hoverPoint: B } = w;
            L && (delete L.chartPosition, B && (x = B), L.runPointActions(void 0, x, !0));
          }), C.appendChild(w.container);
        }
        applyFixed() {
          let { chart: w, fixedRenderer: x, isDirty: k, scrollingContainer: A } = this, { axisOffset: $, chartWidth: j, chartHeight: N, container: M, plotHeight: D, plotLeft: C, plotTop: b, plotWidth: p, scrollablePixelsX: L = 0, scrollablePixelsY: B = 0 } = w, { scrollPositionX: T = 0, scrollPositionY: O = 0 } = w.options.chart.scrollablePlotArea || {}, I = j + L, R = N + B;
          x.setSize(j, N), (k ?? !0) && (this.isDirty = !1, this.moveFixedElements()), l(w.container), m(M, { width: `${I}px`, height: `${R}px` }), w.renderer.boxWrapper.attr({ width: I, height: R, viewBox: [0, 0, I, R].join(" ") }), w.chartBackground?.attr({ width: I, height: R }), m(A, { width: `${j}px`, height: `${N}px` }), h(k) || (A.scrollLeft = L * T, A.scrollTop = B * O);
          let Y = b - $[0] - 1, F = C - $[3] - 1, U = b + D + $[2] + 1, Q = C + p + $[1] + 1, J = C + p - L, ee = b + D - B, V = [["M", 0, 0]];
          L ? V = [["M", 0, Y], ["L", C - 1, Y], ["L", C - 1, U], ["L", 0, U], ["Z"], ["M", J, Y], ["L", j, Y], ["L", j, U], ["L", J, U], ["Z"]] : B && (V = [["M", F, 0], ["L", F, b - 1], ["L", Q, b - 1], ["L", Q, 0], ["Z"], ["M", F, ee], ["L", F, N], ["L", Q, N], ["L", Q, ee], ["Z"]]), w.redrawTrigger !== "adjustHeight" && this.mask.attr({ d: V });
        }
        moveFixedElements() {
          let w, { container: x, inverted: k, scrollablePixelsX: A, scrollablePixelsY: $ } = this.chart, j = this.fixedRenderer, N = f.fixedSelectors;
          for (let M of (A && !k ? w = ".highcharts-yaxis" : A && k || $ && !k ? w = ".highcharts-xaxis" : $ && k && (w = ".highcharts-yaxis"), w && N.push(`${w}:not(.highcharts-radial-axis)`, `${w}-labels:not(.highcharts-radial-axis-labels)`), N))
            [].forEach.call(x.querySelectorAll(M), (D) => {
              (D.namespaceURI === j.SVG_NS ? j.box : j.box.parentNode).appendChild(D), D.style.pointerEvents = "auto";
            });
        }
      }
      return f.fixedSelectors = [".highcharts-breadcrumbs-group", ".highcharts-contextbutton", ".highcharts-caption", ".highcharts-credits", ".highcharts-drillup-button", ".highcharts-legend", ".highcharts-legend-checkbox", ".highcharts-navigator-series", ".highcharts-navigator-xaxis", ".highcharts-navigator-yaxis", ".highcharts-navigator", ".highcharts-range-selector-group", ".highcharts-reset-zoom", ".highcharts-scrollbar", ".highcharts-subtitle", ".highcharts-title"], f;
    }), i(n, "Core/Axis/Stacking/StackItem.js", [n["Core/Templating.js"], n["Core/Series/SeriesRegistry.js"], n["Core/Utilities.js"]], function(o, a, r) {
      let { format: s } = o, { series: l } = a, { destroyObjectProperties: d, fireEvent: y, isNumber: u, pick: m } = r;
      return class {
        constructor(h, c, g, v, P) {
          let f = h.chart.inverted, S = h.reversed;
          this.axis = h;
          let w = this.isNegative = !!g != !!S;
          this.options = c = c || {}, this.x = v, this.total = null, this.cumulative = null, this.points = {}, this.hasValidPoints = !1, this.stack = P, this.leftCliff = 0, this.rightCliff = 0, this.alignOptions = { align: c.align || (f ? w ? "left" : "right" : "center"), verticalAlign: c.verticalAlign || (f ? "middle" : w ? "bottom" : "top"), y: c.y, x: c.x }, this.textAlign = c.textAlign || (f ? w ? "right" : "left" : "center");
        }
        destroy() {
          d(this, this.axis);
        }
        render(h) {
          let c = this.axis.chart, g = this.options, v = g.format, P = v ? s(v, this, c) : g.formatter.call(this);
          if (this.label)
            this.label.attr({ text: P, visibility: "hidden" });
          else {
            this.label = c.renderer.label(P, null, void 0, g.shape, void 0, void 0, g.useHTML, !1, "stack-labels");
            let f = { r: g.borderRadius || 0, text: P, padding: m(g.padding, 5), visibility: "hidden" };
            c.styledMode || (f.fill = g.backgroundColor, f.stroke = g.borderColor, f["stroke-width"] = g.borderWidth, this.label.css(g.style || {})), this.label.attr(f), this.label.added || this.label.add(h);
          }
          this.label.labelrank = c.plotSizeY, y(this, "afterRender");
        }
        setOffset(h, c, g, v, P, f) {
          let { alignOptions: S, axis: w, label: x, options: k, textAlign: A } = this, $ = w.chart, j = this.getStackBox({ xOffset: h, width: c, boxBottom: g, boxTop: v, defaultX: P, xAxis: f }), { verticalAlign: N } = S;
          if (x && j) {
            let M = x.getBBox(void 0, 0), D = x.padding, C = m(k.overflow, "justify") === "justify", b;
            S.x = k.x || 0, S.y = k.y || 0;
            let { x: p, y: L } = this.adjustStackPosition({ labelBox: M, verticalAlign: N, textAlign: A });
            j.x -= p, j.y -= L, x.align(S, !1, j), (b = $.isInsidePlot(x.alignAttr.x + S.x + p, x.alignAttr.y + S.y + L)) || (C = !1), C && l.prototype.justifyDataLabel.call(w, x, S, x.alignAttr, M, j), x.attr({ x: x.alignAttr.x, y: x.alignAttr.y, rotation: k.rotation, rotationOriginX: M.width * { left: 0, center: 0.5, right: 1 }[k.textAlign || "center"], rotationOriginY: M.height / 2 }), m(!C && k.crop, !0) && (b = u(x.x) && u(x.y) && $.isInsidePlot(x.x - D + (x.width || 0), x.y) && $.isInsidePlot(x.x + D, x.y)), x[b ? "show" : "hide"]();
          }
          y(this, "afterSetOffset", { xOffset: h, width: c });
        }
        adjustStackPosition({ labelBox: h, verticalAlign: c, textAlign: g }) {
          let v = { bottom: 0, middle: 1, top: 2, right: 1, center: 0, left: -1 }, P = v[c], f = v[g];
          return { x: h.width / 2 + h.width / 2 * f, y: h.height / 2 * P };
        }
        getStackBox(h) {
          let c = this.axis, g = c.chart, { boxTop: v, defaultX: P, xOffset: f, width: S, boxBottom: w } = h, x = c.stacking.usePercentage ? 100 : m(v, this.total, 0), k = c.toPixels(x), A = h.xAxis || g.xAxis[0], $ = m(P, A.translate(this.x)) + f, j = Math.abs(k - c.toPixels(w || u(c.min) && c.logarithmic && c.logarithmic.lin2log(c.min) || 0)), N = g.inverted, M = this.isNegative;
          return N ? { x: (M ? k : k - j) - g.plotLeft, y: A.height - $ - S + A.top - g.plotTop, width: j, height: S } : { x: $ + A.transB - g.plotLeft, y: (M ? k - j : k) - g.plotTop, width: S, height: j };
        }
      };
    }), i(n, "Core/Axis/Stacking/StackingAxis.js", [n["Core/Animation/AnimationUtilities.js"], n["Core/Axis/Axis.js"], n["Core/Series/SeriesRegistry.js"], n["Core/Axis/Stacking/StackItem.js"], n["Core/Utilities.js"]], function(o, a, r, s, l) {
      var d;
      let { getDeferredAnimation: y } = o, { series: { prototype: u } } = r, { addEvent: m, correctFloat: h, defined: c, destroyObjectProperties: g, fireEvent: v, isArray: P, isNumber: f, objectEach: S, pick: w } = l;
      function x() {
        let b = this.inverted;
        this.axes.forEach((p) => {
          p.stacking && p.stacking.stacks && p.hasVisibleSeries && (p.stacking.oldStacks = p.stacking.stacks);
        }), this.series.forEach((p) => {
          let L = p.xAxis && p.xAxis.options || {};
          p.options.stacking && p.reserveSpace() && (p.stackKey = [p.type, w(p.options.stack, ""), b ? L.top : L.left, b ? L.height : L.width].join(","));
        });
      }
      function k() {
        let b = this.stacking;
        if (b) {
          let p = b.stacks;
          S(p, (L, B) => {
            g(L), delete p[B];
          }), b.stackTotalGroup?.destroy();
        }
      }
      function A() {
        this.stacking || (this.stacking = new C(this));
      }
      function $(b, p, L, B) {
        return !c(b) || b.x !== p || B && b.stackKey !== B ? b = { x: p, index: 0, key: B, stackKey: B } : b.index++, b.key = [L, p, b.index].join(","), b;
      }
      function j() {
        let b, p = this, L = p.yAxis, B = p.stackKey || "", T = L.stacking.stacks, O = p.processedXData, I = p.options.stacking, R = p[I + "Stacker"];
        R && [B, "-" + B].forEach((Y) => {
          let F = O.length, U, Q, J;
          for (; F--; )
            U = O[F], b = p.getStackIndicator(b, U, p.index, Y), Q = T[Y]?.[U], (J = Q?.points[b.key || ""]) && R.call(p, J, Q, F);
        });
      }
      function N(b, p, L) {
        let B = p.total ? 100 / p.total : 0;
        b[0] = h(b[0] * B), b[1] = h(b[1] * B), this.stackedYData[L] = b[1];
      }
      function M(b) {
        (this.is("column") || this.is("columnrange")) && (this.options.centerInCategory && !this.options.stacking && this.chart.series.length > 1 ? u.setStackedPoints.call(this, b, "group") : b.stacking.resetStacks());
      }
      function D(b, p) {
        let L, B, T, O, I, R, Y, F, U, Q = p || this.options.stacking;
        if (!Q || !this.reserveSpace() || ({ group: "xAxis" }[Q] || "yAxis") !== b.coll)
          return;
        let J = this.processedXData, ee = this.processedYData, V = [], G = ee.length, W = this.options, ae = W.threshold || 0, z = W.startFromThreshold ? ae : 0, q = W.stack, Z = p ? `${this.type},${Q}` : this.stackKey || "", ne = "-" + Z, ie = this.negStacks, re = b.stacking, de = re.stacks, me = re.oldStacks;
        for (re.stacksTouched += 1, Y = 0; Y < G; Y++) {
          F = J[Y], U = ee[Y], R = (L = this.getStackIndicator(L, F, this.index)).key || "", de[I = (B = ie && U < (z ? 0 : ae)) ? ne : Z] || (de[I] = {}), de[I][F] || (me[I]?.[F] ? (de[I][F] = me[I][F], de[I][F].total = null) : de[I][F] = new s(b, b.options.stackLabels, !!B, F, q)), T = de[I][F], U !== null ? (T.points[R] = T.points[this.index] = [w(T.cumulative, z)], c(T.cumulative) || (T.base = R), T.touched = re.stacksTouched, L.index > 0 && this.singleStacks === !1 && (T.points[R][0] = T.points[this.index + "," + F + ",0"][0])) : (delete T.points[R], delete T.points[this.index]);
          let ce = T.total || 0;
          Q === "percent" ? (O = B ? Z : ne, ce = ie && de[O]?.[F] ? (O = de[O][F]).total = Math.max(O.total || 0, ce) + Math.abs(U) || 0 : h(ce + (Math.abs(U) || 0))) : Q === "group" ? (P(U) && (U = U[0]), U !== null && ce++) : ce = h(ce + (U || 0)), Q === "group" ? T.cumulative = (ce || 1) - 1 : T.cumulative = h(w(T.cumulative, z) + (U || 0)), T.total = ce, U !== null && (T.points[R].push(T.cumulative), V[Y] = T.cumulative, T.hasValidPoints = !0);
        }
        Q === "percent" && (re.usePercentage = !0), Q !== "group" && (this.stackedYData = V), re.oldStacks = {};
      }
      class C {
        constructor(p) {
          this.oldStacks = {}, this.stacks = {}, this.stacksTouched = 0, this.axis = p;
        }
        buildStacks() {
          let p, L, B = this.axis, T = B.series, O = B.coll === "xAxis", I = B.options.reversedStacks, R = T.length;
          for (this.resetStacks(), this.usePercentage = !1, L = R; L--; )
            p = T[I ? L : R - L - 1], O && p.setGroupedPoints(B), p.setStackedPoints(B);
          if (!O)
            for (L = 0; L < R; L++)
              T[L].modifyStacks();
          v(B, "afterBuildStacks");
        }
        cleanStacks() {
          this.oldStacks && (this.stacks = this.oldStacks, S(this.stacks, (p) => {
            S(p, (L) => {
              L.cumulative = L.total;
            });
          }));
        }
        resetStacks() {
          S(this.stacks, (p) => {
            S(p, (L, B) => {
              f(L.touched) && L.touched < this.stacksTouched ? (L.destroy(), delete p[B]) : (L.total = null, L.cumulative = null);
            });
          });
        }
        renderStackTotals() {
          let p = this.axis, L = p.chart, B = L.renderer, T = this.stacks, O = y(L, p.options.stackLabels?.animation || !1), I = this.stackTotalGroup = this.stackTotalGroup || B.g("stack-labels").attr({ zIndex: 6, opacity: 0 }).add();
          I.translate(L.plotLeft, L.plotTop), S(T, (R) => {
            S(R, (Y) => {
              Y.render(I);
            });
          }), I.animate({ opacity: 1 }, O);
        }
      }
      return (d || (d = {})).compose = function(b, p, L) {
        let B = p.prototype, T = L.prototype;
        B.getStacks || (m(b, "init", A), m(b, "destroy", k), B.getStacks = x, T.getStackIndicator = $, T.modifyStacks = j, T.percentStacker = N, T.setGroupedPoints = M, T.setStackedPoints = D);
      }, d;
    }), i(n, "Series/Line/LineSeries.js", [n["Core/Series/Series.js"], n["Core/Series/SeriesRegistry.js"], n["Core/Utilities.js"]], function(o, a, r) {
      let { defined: s, merge: l, isObject: d } = r;
      class y extends o {
        drawGraph() {
          let m = this.options, h = (this.gappedPath || this.getGraphPath).call(this), c = this.chart.styledMode;
          [this, ...this.zones].forEach((g, v) => {
            let P, f = g.graph, S = f ? "animate" : "attr", w = g.dashStyle || m.dashStyle;
            f ? (f.endX = this.preventGraphAnimation ? null : h.xMap, f.animate({ d: h })) : h.length && (g.graph = f = this.chart.renderer.path(h).addClass("highcharts-graph" + (v ? ` highcharts-zone-graph-${v - 1} ` : " ") + (v && g.className || "")).attr({ zIndex: 1 }).add(this.group)), f && !c && (P = { stroke: !v && m.lineColor || g.color || this.color || "#cccccc", "stroke-width": m.lineWidth || 0, fill: this.fillGraph && this.color || "none" }, w ? P.dashstyle = w : m.linecap !== "square" && (P["stroke-linecap"] = P["stroke-linejoin"] = "round"), f[S](P).shadow(v < 2 && m.shadow && l({ filterUnits: "userSpaceOnUse" }, d(m.shadow) ? m.shadow : {}))), f && (f.startX = h.xMap, f.isArea = h.isArea);
          });
        }
        getGraphPath(m, h, c) {
          let g = this, v = g.options, P = [], f = [], S, w = v.step, x = (m = m || g.points).reversed;
          return x && m.reverse(), (w = { right: 1, center: 2 }[w] || w && 3) && x && (w = 4 - w), (m = this.getValidPoints(m, !1, !(v.connectNulls && !h && !c))).forEach(function(k, A) {
            let $, j = k.plotX, N = k.plotY, M = m[A - 1], D = k.isNull || typeof N != "number";
            (k.leftCliff || M && M.rightCliff) && !c && (S = !0), D && !s(h) && A > 0 ? S = !v.connectNulls : D && !h ? S = !0 : (A === 0 || S ? $ = [["M", k.plotX, k.plotY]] : g.getPointSpline ? $ = [g.getPointSpline(m, k, A)] : w ? ($ = w === 1 ? [["L", M.plotX, N]] : w === 2 ? [["L", (M.plotX + j) / 2, M.plotY], ["L", (M.plotX + j) / 2, N]] : [["L", j, M.plotY]]).push(["L", j, N]) : $ = [["L", j, N]], f.push(k.x), w && (f.push(k.x), w === 2 && f.push(k.x)), P.push.apply(P, $), S = !1);
          }), P.xMap = f, g.graphPath = P, P;
        }
      }
      return y.defaultOptions = l(o.defaultOptions, { legendSymbol: "lineMarker" }), a.registerSeriesType("line", y), y;
    }), i(n, "Series/Area/AreaSeriesDefaults.js", [], function() {
      return { threshold: 0, legendSymbol: "areaMarker" };
    }), i(n, "Series/Area/AreaSeries.js", [n["Series/Area/AreaSeriesDefaults.js"], n["Core/Series/SeriesRegistry.js"], n["Core/Utilities.js"]], function(o, a, r) {
      let { seriesTypes: { line: s } } = a, { extend: l, merge: d, objectEach: y, pick: u } = r;
      class m extends s {
        drawGraph() {
          this.areaPath = [], super.drawGraph.apply(this);
          let { areaPath: c, options: g } = this;
          [this, ...this.zones].forEach((v, P) => {
            let f = {}, S = v.fillColor || g.fillColor, w = v.area, x = w ? "animate" : "attr";
            w ? (w.endX = this.preventGraphAnimation ? null : c.xMap, w.animate({ d: c })) : (f.zIndex = 0, (w = v.area = this.chart.renderer.path(c).addClass("highcharts-area" + (P ? ` highcharts-zone-area-${P - 1} ` : " ") + (P && v.className || "")).add(this.group)).isArea = !0), this.chart.styledMode || (f.fill = S || v.color || this.color, f["fill-opacity"] = S ? 1 : g.fillOpacity ?? 0.75, w.css({ pointerEvents: this.stickyTracking ? "none" : "auto" })), w[x](f), w.startX = c.xMap, w.shiftUnit = g.step ? 2 : 1;
          });
        }
        getGraphPath(c) {
          let g, v, P, f = s.prototype.getGraphPath, S = this.options, w = S.stacking, x = this.yAxis, k = [], A = [], $ = this.index, j = x.stacking.stacks[this.stackKey], N = S.threshold, M = Math.round(x.getThreshold(S.threshold)), D = u(S.connectNulls, w === "percent"), C = function(O, I, R) {
            let Y = c[O], F = w && j[Y.x].points[$], U = Y[R + "Null"] || 0, Q = Y[R + "Cliff"] || 0, J, ee, V = !0;
            Q || U ? (J = (U ? F[0] : F[1]) + Q, ee = F[0] + Q, V = !!U) : !w && c[I] && c[I].isNull && (J = ee = N), J !== void 0 && (A.push({ plotX: g, plotY: J === null ? M : x.getThreshold(J), isNull: V, isCliff: !0 }), k.push({ plotX: g, plotY: ee === null ? M : x.getThreshold(ee), doCurve: !1 }));
          };
          c = c || this.points, w && (c = this.getStackPoints(c));
          for (let O = 0, I = c.length; O < I; ++O)
            w || (c[O].leftCliff = c[O].rightCliff = c[O].leftNull = c[O].rightNull = void 0), v = c[O].isNull, g = u(c[O].rectPlotX, c[O].plotX), P = w ? u(c[O].yBottom, M) : M, v && !D || (D || C(O, O - 1, "left"), v && !w && D || (A.push(c[O]), k.push({ x: O, plotX: g, plotY: P })), D || C(O, O + 1, "right"));
          let b = f.call(this, A, !0, !0);
          k.reversed = !0;
          let p = f.call(this, k, !0, !0), L = p[0];
          L && L[0] === "M" && (p[0] = ["L", L[1], L[2]]);
          let B = b.concat(p);
          B.length && B.push(["Z"]);
          let T = f.call(this, A, !1, D);
          return this.chart.series.length > 1 && w && A.some((O) => O.isCliff) && (B.hasStackedCliffs = T.hasStackedCliffs = !0), B.xMap = b.xMap, this.areaPath = B, T;
        }
        getStackPoints(c) {
          let g = this, v = [], P = [], f = this.xAxis, S = this.yAxis, w = S.stacking.stacks[this.stackKey], x = {}, k = S.series, A = k.length, $ = S.options.reversedStacks ? 1 : -1, j = k.indexOf(g);
          if (c = c || this.points, this.options.stacking) {
            for (let M = 0; M < c.length; M++)
              c[M].leftNull = c[M].rightNull = void 0, x[c[M].x] = c[M];
            y(w, function(M, D) {
              M.total !== null && P.push(D);
            }), P.sort(function(M, D) {
              return M - D;
            });
            let N = k.map((M) => M.visible);
            P.forEach(function(M, D) {
              let C = 0, b, p;
              if (x[M] && !x[M].isNull)
                v.push(x[M]), [-1, 1].forEach(function(L) {
                  let B = L === 1 ? "rightNull" : "leftNull", T = w[P[D + L]], O = 0;
                  if (T) {
                    let I = j;
                    for (; I >= 0 && I < A; ) {
                      let R = k[I].index;
                      !(b = T.points[R]) && (R === g.index ? x[M][B] = !0 : N[I] && (p = w[M].points[R]) && (O -= p[1] - p[0])), I += $;
                    }
                  }
                  x[M][L === 1 ? "rightCliff" : "leftCliff"] = O;
                });
              else {
                let L = j;
                for (; L >= 0 && L < A; ) {
                  let B = k[L].index;
                  if (b = w[M].points[B]) {
                    C = b[1];
                    break;
                  }
                  L += $;
                }
                C = u(C, 0), C = S.translate(C, 0, 1, 0, 1), v.push({ isNull: !0, plotX: f.translate(M, 0, 0, 0, 1), x: M, plotY: C, yBottom: C });
              }
            });
          }
          return v;
        }
      }
      return m.defaultOptions = d(s.defaultOptions, o), l(m.prototype, { singleStacks: !1 }), a.registerSeriesType("area", m), m;
    }), i(n, "Series/Spline/SplineSeries.js", [n["Core/Series/SeriesRegistry.js"], n["Core/Utilities.js"]], function(o, a) {
      let { line: r } = o.seriesTypes, { merge: s, pick: l } = a;
      class d extends r {
        getPointSpline(u, m, h) {
          let c, g, v, P, f = m.plotX || 0, S = m.plotY || 0, w = u[h - 1], x = u[h + 1];
          function k($) {
            return $ && !$.isNull && $.doCurve !== !1 && !m.isCliff;
          }
          if (k(w) && k(x)) {
            let $ = w.plotX || 0, j = w.plotY || 0, N = x.plotX || 0, M = x.plotY || 0, D = 0;
            c = (1.5 * f + $) / 2.5, g = (1.5 * S + j) / 2.5, v = (1.5 * f + N) / 2.5, P = (1.5 * S + M) / 2.5, v !== c && (D = (P - g) * (v - f) / (v - c) + S - P), g += D, P += D, g > j && g > S ? (g = Math.max(j, S), P = 2 * S - g) : g < j && g < S && (g = Math.min(j, S), P = 2 * S - g), P > M && P > S ? (P = Math.max(M, S), g = 2 * S - P) : P < M && P < S && (P = Math.min(M, S), g = 2 * S - P), m.rightContX = v, m.rightContY = P, m.controlPoints = { low: [c, g], high: [v, P] };
          }
          let A = ["C", l(w.rightContX, w.plotX, 0), l(w.rightContY, w.plotY, 0), l(c, f, 0), l(g, S, 0), f, S];
          return w.rightContX = w.rightContY = void 0, A;
        }
      }
      return d.defaultOptions = s(r.defaultOptions), o.registerSeriesType("spline", d), d;
    }), i(n, "Series/AreaSpline/AreaSplineSeries.js", [n["Series/Spline/SplineSeries.js"], n["Core/Series/SeriesRegistry.js"], n["Core/Utilities.js"]], function(o, a, r) {
      let { area: s, area: { prototype: l } } = a.seriesTypes, { extend: d, merge: y } = r;
      class u extends o {
      }
      return u.defaultOptions = y(o.defaultOptions, s.defaultOptions), d(u.prototype, { getGraphPath: l.getGraphPath, getStackPoints: l.getStackPoints, drawGraph: l.drawGraph }), a.registerSeriesType("areaspline", u), u;
    }), i(n, "Series/Column/ColumnSeriesDefaults.js", [], function() {
      return { borderRadius: 3, centerInCategory: !1, groupPadding: 0.2, marker: null, pointPadding: 0.1, minPointLength: 0, cropThreshold: 50, pointRange: null, states: { hover: { halo: !1, brightness: 0.1 }, select: { color: "#cccccc", borderColor: "#000000" } }, dataLabels: { align: void 0, verticalAlign: void 0, y: void 0 }, startFromThreshold: !0, stickyTracking: !1, tooltip: { distance: 6 }, threshold: 0, borderColor: "#ffffff" };
    }), i(n, "Series/Column/ColumnSeries.js", [n["Core/Animation/AnimationUtilities.js"], n["Core/Color/Color.js"], n["Series/Column/ColumnSeriesDefaults.js"], n["Core/Globals.js"], n["Core/Series/Series.js"], n["Core/Series/SeriesRegistry.js"], n["Core/Utilities.js"]], function(o, a, r, s, l, d, y) {
      let { animObject: u } = o, { parse: m } = a, { noop: h } = s, { clamp: c, crisp: g, defined: v, extend: P, fireEvent: f, isArray: S, isNumber: w, merge: x, pick: k, objectEach: A } = y;
      class $ extends l {
        animate(N) {
          let M, D, C = this, b = this.yAxis, p = b.pos, L = b.reversed, B = C.options, { clipOffset: T, inverted: O } = this.chart, I = {}, R = O ? "translateX" : "translateY";
          N && T ? (I.scaleY = 1e-3, D = c(b.toPixels(B.threshold), p, p + b.len), O ? (D += L ? -Math.floor(T[0]) : Math.ceil(T[2]), I.translateX = D - b.len) : (D += L ? Math.ceil(T[0]) : -Math.floor(T[2]), I.translateY = D), C.clipBox && C.setClip(), C.group.attr(I)) : (M = Number(C.group.attr(R)), C.group.animate({ scaleY: 1 }, P(u(C.options.animation), { step: function(Y, F) {
            C.group && (I[R] = M + F.pos * (p - M), C.group.attr(I));
          } })));
        }
        init(N, M) {
          super.init.apply(this, arguments);
          let D = this;
          (N = D.chart).hasRendered && N.series.forEach(function(C) {
            C.type === D.type && (C.isDirty = !0);
          });
        }
        getColumnMetrics() {
          let N = this, M = N.options, D = N.xAxis, C = N.yAxis, b = D.options.reversedStacks, p = D.reversed && !b || !D.reversed && b, L = {}, B, T = 0;
          M.grouping === !1 ? T = 1 : N.chart.series.forEach(function(U) {
            let Q, J = U.yAxis, ee = U.options;
            U.type === N.type && U.reserveSpace() && C.len === J.len && C.pos === J.pos && (ee.stacking && ee.stacking !== "group" ? (L[B = U.stackKey] === void 0 && (L[B] = T++), Q = L[B]) : ee.grouping !== !1 && (Q = T++), U.columnIndex = Q);
          });
          let O = Math.min(Math.abs(D.transA) * (!D.brokenAxis?.hasBreaks && D.ordinal?.slope || M.pointRange || D.closestPointRange || D.tickInterval || 1), D.len), I = O * M.groupPadding, R = (O - 2 * I) / (T || 1), Y = Math.min(M.maxPointWidth || D.len, k(M.pointWidth, R * (1 - 2 * M.pointPadding))), F = (N.columnIndex || 0) + (p ? 1 : 0);
          return N.columnMetrics = { width: Y, offset: (R - Y) / 2 + (I + F * R - O / 2) * (p ? -1 : 1), paddedWidth: R, columnCount: T }, N.columnMetrics;
        }
        crispCol(N, M, D, C) {
          let b = this.borderWidth, p = this.chart.inverted;
          return C = g(M + C, b, p) - (M = g(M, b, p)), this.options.crisp && (D = g(N + D, b) - (N = g(N, b))), { x: N, y: M, width: D, height: C };
        }
        adjustForMissingColumns(N, M, D, C) {
          if (!D.isNull && C.columnCount > 1) {
            let b = this.xAxis.series.filter((T) => T.visible).map((T) => T.index), p = 0, L = 0;
            A(this.xAxis.stacking?.stacks, (T) => {
              if (typeof D.x == "number") {
                let O = T[D.x.toString()];
                if (O && S(O.points[this.index])) {
                  let I = Object.keys(O.points).filter((R) => !R.match(",") && O.points[R] && O.points[R].length > 1).map(parseFloat).filter((R) => b.indexOf(R) !== -1).sort((R, Y) => Y - R);
                  p = I.indexOf(this.index), L = I.length;
                }
              }
            }), p = this.xAxis.reversed ? L - 1 - p : p;
            let B = (L - 1) * C.paddedWidth + M;
            N = (D.plotX || 0) + B / 2 - M - p * C.paddedWidth;
          }
          return N;
        }
        translate() {
          let N = this, M = N.chart, D = N.options, C = N.dense = N.closestPointRange * N.xAxis.transA < 2, b = N.borderWidth = k(D.borderWidth, C ? 0 : 1), p = N.xAxis, L = N.yAxis, B = D.threshold, T = k(D.minPointLength, 5), O = N.getColumnMetrics(), I = O.width, R = N.pointXOffset = O.offset, Y = N.dataMin, F = N.dataMax, U = N.translatedThreshold = L.getThreshold(B), Q = N.barW = Math.max(I, 1 + 2 * b);
          D.pointPadding && (Q = Math.ceil(Q)), l.prototype.translate.apply(N), N.points.forEach(function(J) {
            let ee = k(J.yBottom, U), V = 999 + Math.abs(ee), G = J.plotX || 0, W = c(J.plotY, -V, L.len + V), ae, z = Math.min(W, ee), q = Math.max(W, ee) - z, Z = I, ne = G + R, ie = Q;
            T && Math.abs(q) < T && (q = T, ae = !L.reversed && !J.negative || L.reversed && J.negative, w(B) && w(F) && J.y === B && F <= B && (L.min || 0) < B && (Y !== F || (L.max || 0) <= B) && (ae = !ae, J.negative = !J.negative), z = Math.abs(z - U) > T ? ee - T : U - (ae ? T : 0)), v(J.options.pointWidth) && (ne -= Math.round(((Z = ie = Math.ceil(J.options.pointWidth)) - I) / 2)), D.centerInCategory && !D.stacking && (ne = N.adjustForMissingColumns(ne, Z, J, O)), J.barX = ne, J.pointWidth = Z, J.tooltipPos = M.inverted ? [c(L.len + L.pos - M.plotLeft - W, L.pos - M.plotLeft, L.len + L.pos - M.plotLeft), p.len + p.pos - M.plotTop - ne - ie / 2, q] : [p.left - M.plotLeft + ne + ie / 2, c(W + L.pos - M.plotTop, L.pos - M.plotTop, L.len + L.pos - M.plotTop), q], J.shapeType = N.pointClass.prototype.shapeType || "roundedRect", J.shapeArgs = N.crispCol(ne, J.isNull ? U : z, ie, J.isNull ? 0 : q);
          }), f(this, "afterColumnTranslate");
        }
        drawGraph() {
          this.group[this.dense ? "addClass" : "removeClass"]("highcharts-dense-data");
        }
        pointAttribs(N, M) {
          let D = this.options, C = this.pointAttrToOptions || {}, b = C.stroke || "borderColor", p = C["stroke-width"] || "borderWidth", L, B, T, O = N && N.color || this.color, I = N && N[b] || D[b] || O, R = N && N.options.dashStyle || D.dashStyle, Y = N && N[p] || D[p] || this[p] || 0, F = k(N && N.opacity, D.opacity, 1);
          N && this.zones.length && (B = N.getZone(), O = N.options.color || B && (B.color || N.nonZonedColor) || this.color, B && (I = B.borderColor || I, R = B.dashStyle || R, Y = B.borderWidth || Y)), M && N && (T = (L = x(D.states[M], N.options.states && N.options.states[M] || {})).brightness, O = L.color || T !== void 0 && m(O).brighten(L.brightness).get() || O, I = L[b] || I, Y = L[p] || Y, R = L.dashStyle || R, F = k(L.opacity, F));
          let U = { fill: O, stroke: I, "stroke-width": Y, opacity: F };
          return R && (U.dashstyle = R), U;
        }
        drawPoints(N = this.points) {
          let M, D = this, C = this.chart, b = D.options, p = C.renderer, L = b.animationLimit || 250;
          N.forEach(function(B) {
            let T = B.plotY, O = B.graphic, I = !!O, R = O && C.pointCount < L ? "animate" : "attr";
            w(T) && B.y !== null ? (M = B.shapeArgs, O && B.hasNewShapeType() && (O = O.destroy()), D.enabledDataSorting && (B.startXPos = D.xAxis.reversed ? -(M && M.width || 0) : D.xAxis.width), !O && (B.graphic = O = p[B.shapeType](M).add(B.group || D.group), O && D.enabledDataSorting && C.hasRendered && C.pointCount < L && (O.attr({ x: B.startXPos }), I = !0, R = "animate")), O && I && O[R](x(M)), C.styledMode || O[R](D.pointAttribs(B, B.selected && "select")).shadow(B.allowShadow !== !1 && b.shadow), O && (O.addClass(B.getClassName(), !0), O.attr({ visibility: B.visible ? "inherit" : "hidden" }))) : O && (B.graphic = O.destroy());
          });
        }
        drawTracker(N = this.points) {
          let M, D = this, C = D.chart, b = C.pointer, p = function(L) {
            let B = b?.getPointFromEvent(L);
            b && B && D.options.enableMouseTracking && (b.isDirectTouch = !0, B.onMouseOver(L));
          };
          N.forEach(function(L) {
            M = S(L.dataLabels) ? L.dataLabels : L.dataLabel ? [L.dataLabel] : [], L.graphic && (L.graphic.element.point = L), M.forEach(function(B) {
              (B.div || B.element).point = L;
            });
          }), D._hasTracking || (D.trackerGroups.forEach(function(L) {
            D[L] && (D[L].addClass("highcharts-tracker").on("mouseover", p).on("mouseout", function(B) {
              b?.onTrackerMouseOut(B);
            }).on("touchstart", p), !C.styledMode && D.options.cursor && D[L].css({ cursor: D.options.cursor }));
          }), D._hasTracking = !0), f(this, "afterDrawTracker");
        }
        remove() {
          let N = this, M = N.chart;
          M.hasRendered && M.series.forEach(function(D) {
            D.type === N.type && (D.isDirty = !0);
          }), l.prototype.remove.apply(N, arguments);
        }
      }
      return $.defaultOptions = x(l.defaultOptions, r), P($.prototype, { directTouch: !0, getSymbol: h, negStacks: !0, trackerGroups: ["group", "dataLabelsGroup"] }), d.registerSeriesType("column", $), $;
    }), i(n, "Core/Series/DataLabel.js", [n["Core/Animation/AnimationUtilities.js"], n["Core/Templating.js"], n["Core/Utilities.js"]], function(o, a, r) {
      var s;
      let { getDeferredAnimation: l } = o, { format: d } = a, { defined: y, extend: u, fireEvent: m, isArray: h, isString: c, merge: g, objectEach: v, pick: P, pInt: f, splat: S } = r;
      return function(w) {
        function x() {
          return D(this).some((b) => b?.enabled);
        }
        function k(b, p, L, B, T) {
          let { chart: O, enabledDataSorting: I } = this, R = this.isCartesian && O.inverted, Y = b.plotX, F = b.plotY, U = L.rotation || 0, Q = y(Y) && y(F) && O.isInsidePlot(Y, Math.round(F), { inverted: R, paneCoordinates: !0, series: this }), J = U === 0 && P(L.overflow, I ? "none" : "justify") === "justify", ee = this.visible && b.visible !== !1 && y(Y) && (b.series.forceDL || I && !J || Q || P(L.inside, !!this.options.stacking) && B && O.isInsidePlot(Y, R ? B.x + 1 : B.y + B.height - 1, { inverted: R, paneCoordinates: !0, series: this })), V = b.pos();
          if (ee && V) {
            var G;
            let W = p.getBBox(), ae = p.getBBox(void 0, 0), z = { right: 1, center: 0.5 }[L.align || 0] || 0, q = { bottom: 1, middle: 0.5 }[L.verticalAlign || 0] || 0;
            if (B = u({ x: V[0], y: Math.round(V[1]), width: 0, height: 0 }, B || {}), L.alignTo === "plotEdges" && this.isCartesian && (B[R ? "x" : "y"] = 0, B[R ? "width" : "height"] = this.yAxis?.len || 0), u(L, { width: W.width, height: W.height }), G = B, I && this.xAxis && !J && this.setDataLabelStartPos(b, p, T, Q, G), p.align(g(L, { width: ae.width, height: ae.height }), !1, B, !1), p.alignAttr.x += z * (ae.width - W.width), p.alignAttr.y += q * (ae.height - W.height), p[p.placed ? "animate" : "attr"]({ x: p.alignAttr.x + (W.width - ae.width) / 2, y: p.alignAttr.y + (W.height - ae.height) / 2, rotationOriginX: (p.width || 0) / 2, rotationOriginY: (p.height || 0) / 2 }), J && B.height >= 0)
              this.justifyDataLabel(p, L, p.alignAttr, W, B, T);
            else if (P(L.crop, !0)) {
              let { x: Z, y: ne } = p.alignAttr;
              ee = O.isInsidePlot(Z, ne, { paneCoordinates: !0, series: this }) && O.isInsidePlot(Z + W.width - 1, ne + W.height - 1, { paneCoordinates: !0, series: this });
            }
            L.shape && !U && p[T ? "attr" : "animate"]({ anchorX: V[0], anchorY: V[1] });
          }
          T && I && (p.placed = !1), ee || I && !J ? (p.show(), p.placed = !0) : (p.hide(), p.placed = !1);
        }
        function A() {
          return this.plotGroup("dataLabelsGroup", "data-labels", this.hasRendered ? "inherit" : "hidden", this.options.dataLabels.zIndex || 6);
        }
        function $(b) {
          let p = this.hasRendered || 0, L = this.initDataLabelsGroup().attr({ opacity: +p });
          return !p && L && (this.visible && L.show(), this.options.animation ? L.animate({ opacity: 1 }, b) : L.attr({ opacity: 1 })), L;
        }
        function j(b) {
          let p;
          b = b || this.points;
          let L = this, B = L.chart, T = L.options, O = B.renderer, { backgroundColor: I, plotBackgroundColor: R } = B.options.chart, Y = O.getContrast(c(R) && R || c(I) && I || "#000000"), F = D(L), { animation: U, defer: Q } = F[0], J = Q ? l(B, U, L) : { defer: 0, duration: 0 };
          m(this, "drawDataLabels"), L.hasDataLabels?.() && (p = this.initDataLabels(J), b.forEach((ee) => {
            let V = ee.dataLabels || [];
            S(M(F, ee.dlOptions || ee.options?.dataLabels)).forEach((W, ae) => {
              let z = W.enabled && (ee.visible || ee.dataLabelOnHidden) && (!ee.isNull || ee.dataLabelOnNull) && function(he, ve) {
                let ye = ve.filter;
                if (ye) {
                  let be = ye.operator, ke = he[ye.property], we = ye.value;
                  return be === ">" && ke > we || be === "<" && ke < we || be === ">=" && ke >= we || be === "<=" && ke <= we || be === "==" && ke == we || be === "===" && ke === we || be === "!=" && ke != we || be === "!==" && ke !== we;
                }
                return !0;
              }(ee, W), { backgroundColor: q, borderColor: Z, distance: ne, style: ie = {} } = W, re, de, me, ce, pe = {}, xe = V[ae], le = !xe, se;
              z && (de = P(W[ee.formatPrefix + "Format"], W.format), re = ee.getLabelConfig(), me = y(de) ? d(de, re, B) : (W[ee.formatPrefix + "Formatter"] || W.formatter).call(re, W), ce = W.rotation, !B.styledMode && (ie.color = P(W.color, ie.color, c(L.color) ? L.color : void 0, "#000000"), ie.color === "contrast" ? (q !== "none" && (se = q), ee.contrastColor = O.getContrast(se !== "auto" && se || ee.color || L.color), ie.color = se || !y(ne) && W.inside || 0 > f(ne || 0) || T.stacking ? ee.contrastColor : Y) : delete ee.contrastColor, T.cursor && (ie.cursor = T.cursor)), pe = { r: W.borderRadius || 0, rotation: ce, padding: W.padding, zIndex: 1 }, B.styledMode || (pe.fill = q === "auto" ? ee.color : q, pe.stroke = Z === "auto" ? ee.color : Z, pe["stroke-width"] = W.borderWidth), v(pe, (he, ve) => {
                he === void 0 && delete pe[ve];
              })), !xe || z && y(me) && !!xe.div == !!W.useHTML && (xe.rotation && W.rotation || xe.rotation === W.rotation) || (xe = void 0, le = !0), z && y(me) && (xe ? pe.text = me : (xe = O.label(me, 0, 0, W.shape, void 0, void 0, W.useHTML, void 0, "data-label")).addClass(" highcharts-data-label-color-" + ee.colorIndex + " " + (W.className || "") + (W.useHTML ? " highcharts-tracker" : "")), xe && (xe.options = W, xe.attr(pe), B.styledMode ? ie.width && xe.css({ width: ie.width, textOverflow: ie.textOverflow }) : xe.css(ie).shadow(W.shadow), m(xe, "beforeAddingDataLabel", { labelOptions: W, point: ee }), xe.added || xe.add(p), L.alignDataLabel(ee, xe, W, void 0, le), xe.isActive = !0, V[ae] && V[ae] !== xe && V[ae].destroy(), V[ae] = xe));
            });
            let G = V.length;
            for (; G--; )
              V[G] && V[G].isActive ? V[G].isActive = !1 : (V[G]?.destroy(), V.splice(G, 1));
            ee.dataLabel = V[0], ee.dataLabels = V;
          })), m(this, "afterDrawDataLabels");
        }
        function N(b, p, L, B, T, O) {
          let I = this.chart, R = p.align, Y = p.verticalAlign, F = b.box ? 0 : b.padding || 0, U = I.inverted ? this.yAxis : this.xAxis, Q = U ? U.left - I.plotLeft : 0, J = I.inverted ? this.xAxis : this.yAxis, ee = J ? J.top - I.plotTop : 0, { x: V = 0, y: G = 0 } = p, W, ae;
          return (W = (L.x || 0) + F + Q) < 0 && (R === "right" && V >= 0 ? (p.align = "left", p.inside = !0) : V -= W, ae = !0), (W = (L.x || 0) + B.width - F + Q) > I.plotWidth && (R === "left" && V <= 0 ? (p.align = "right", p.inside = !0) : V += I.plotWidth - W, ae = !0), (W = L.y + F + ee) < 0 && (Y === "bottom" && G >= 0 ? (p.verticalAlign = "top", p.inside = !0) : G -= W, ae = !0), (W = (L.y || 0) + B.height - F + ee) > I.plotHeight && (Y === "top" && G <= 0 ? (p.verticalAlign = "bottom", p.inside = !0) : G += I.plotHeight - W, ae = !0), ae && (p.x = V, p.y = G, b.placed = !O, b.align(p, void 0, T)), ae;
        }
        function M(b, p) {
          let L = [], B;
          if (h(b) && !h(p))
            L = b.map(function(T) {
              return g(T, p);
            });
          else if (h(p) && !h(b))
            L = p.map(function(T) {
              return g(b, T);
            });
          else if (h(b) || h(p)) {
            if (h(b) && h(p))
              for (B = Math.max(b.length, p.length); B--; )
                L[B] = g(b[B], p[B]);
          } else
            L = g(b, p);
          return L;
        }
        function D(b) {
          let p = b.chart.options.plotOptions;
          return S(M(M(p?.series?.dataLabels, p?.[b.type]?.dataLabels), b.options.dataLabels));
        }
        function C(b, p, L, B, T) {
          let O = this.chart, I = O.inverted, R = this.xAxis, Y = R.reversed, F = ((I ? p.height : p.width) || 0) / 2, U = b.pointWidth, Q = U ? U / 2 : 0;
          p.startXPos = I ? T.x : Y ? -F - Q : R.width - F + Q, p.startYPos = I ? Y ? this.yAxis.height - F + Q : -F - Q : T.y, B ? p.visibility === "hidden" && (p.show(), p.attr({ opacity: 0 }).animate({ opacity: 1 })) : p.attr({ opacity: 1 }).animate({ opacity: 0 }, void 0, p.hide), O.hasRendered && (L && p.attr({ x: p.startXPos, y: p.startYPos }), p.placed = !0);
        }
        w.compose = function(b) {
          let p = b.prototype;
          p.initDataLabels || (p.initDataLabels = $, p.initDataLabelsGroup = A, p.alignDataLabel = k, p.drawDataLabels = j, p.justifyDataLabel = N, p.setDataLabelStartPos = C, p.hasDataLabels = x);
        };
      }(s || (s = {})), s;
    }), i(n, "Series/Column/ColumnDataLabel.js", [n["Core/Series/DataLabel.js"], n["Core/Globals.js"], n["Core/Series/SeriesRegistry.js"], n["Core/Utilities.js"]], function(o, a, r, s) {
      var l;
      let { composed: d } = a, { series: y } = r, { merge: u, pick: m, pushUnique: h } = s;
      return function(c) {
        function g(v, P, f, S, w) {
          let x = this.chart.inverted, k = v.series, A = (k.xAxis ? k.xAxis.len : this.chart.plotSizeX) || 0, $ = (k.yAxis ? k.yAxis.len : this.chart.plotSizeY) || 0, j = v.dlBox || v.shapeArgs, N = m(v.below, v.plotY > m(this.translatedThreshold, $)), M = m(f.inside, !!this.options.stacking);
          if (j) {
            if (S = u(j), !(f.overflow === "allow" && f.crop === !1)) {
              S.y < 0 && (S.height += S.y, S.y = 0);
              let D = S.y + S.height - $;
              D > 0 && D < S.height - 1 && (S.height -= D);
            }
            x && (S = { x: $ - S.y - S.height, y: A - S.x - S.width, width: S.height, height: S.width }), M || (x ? (S.x += N ? 0 : S.width, S.width = 0) : (S.y += N ? S.height : 0, S.height = 0));
          }
          f.align = m(f.align, !x || M ? "center" : N ? "right" : "left"), f.verticalAlign = m(f.verticalAlign, x || M ? "middle" : N ? "top" : "bottom"), y.prototype.alignDataLabel.call(this, v, P, f, S, w), f.inside && v.contrastColor && P.css({ color: v.contrastColor });
        }
        c.compose = function(v) {
          o.compose(y), h(d, "ColumnDataLabel") && (v.prototype.alignDataLabel = g);
        };
      }(l || (l = {})), l;
    }), i(n, "Series/Bar/BarSeries.js", [n["Series/Column/ColumnSeries.js"], n["Core/Series/SeriesRegistry.js"], n["Core/Utilities.js"]], function(o, a, r) {
      let { extend: s, merge: l } = r;
      class d extends o {
      }
      return d.defaultOptions = l(o.defaultOptions, {}), s(d.prototype, { inverted: !0 }), a.registerSeriesType("bar", d), d;
    }), i(n, "Series/Scatter/ScatterSeriesDefaults.js", [], function() {
      return { lineWidth: 0, findNearestPointBy: "xy", jitter: { x: 0, y: 0 }, marker: { enabled: !0 }, tooltip: { headerFormat: '<span style="color:{point.color}">●</span> <span style="font-size: 0.8em"> {series.name}</span><br/>', pointFormat: "x: <b>{point.x}</b><br/>y: <b>{point.y}</b><br/>" } };
    }), i(n, "Series/Scatter/ScatterSeries.js", [n["Series/Scatter/ScatterSeriesDefaults.js"], n["Core/Series/SeriesRegistry.js"], n["Core/Utilities.js"]], function(o, a, r) {
      let { column: s, line: l } = a.seriesTypes, { addEvent: d, extend: y, merge: u } = r;
      class m extends l {
        applyJitter() {
          let c = this, g = this.options.jitter, v = this.points.length;
          g && this.points.forEach(function(P, f) {
            ["x", "y"].forEach(function(S, w) {
              if (g[S] && !P.isNull) {
                let x = `plot${S.toUpperCase()}`, k = c[`${S}Axis`], A = g[S] * k.transA;
                if (k && !k.logarithmic) {
                  let $ = Math.max(0, (P[x] || 0) - A), j = Math.min(k.len, (P[x] || 0) + A);
                  P[x] = $ + (j - $) * function(N) {
                    let M = 1e4 * Math.sin(N);
                    return M - Math.floor(M);
                  }(f + w * v), S === "x" && (P.clientX = P.plotX);
                }
              }
            });
          });
        }
        drawGraph() {
          this.options.lineWidth ? super.drawGraph() : this.graph && (this.graph = this.graph.destroy());
        }
      }
      return m.defaultOptions = u(l.defaultOptions, o), y(m.prototype, { drawTracker: s.prototype.drawTracker, sorted: !1, requireSorting: !1, noSharedTooltip: !0, trackerGroups: ["group", "markerGroup", "dataLabelsGroup"] }), d(m, "afterTranslate", function() {
        this.applyJitter();
      }), a.registerSeriesType("scatter", m), m;
    }), i(n, "Series/CenteredUtilities.js", [n["Core/Globals.js"], n["Core/Series/Series.js"], n["Core/Utilities.js"]], function(o, a, r) {
      var s, l;
      let { deg2rad: d } = o, { fireEvent: y, isNumber: u, pick: m, relativeLength: h } = r;
      return (l = s || (s = {})).getCenter = function() {
        let c = this.options, g = this.chart, v = 2 * (c.slicedOffset || 0), P = g.plotWidth - 2 * v, f = g.plotHeight - 2 * v, S = c.center, w = Math.min(P, f), x = c.thickness, k, A = c.size, $ = c.innerSize || 0, j, N;
        typeof A == "string" && (A = parseFloat(A)), typeof $ == "string" && ($ = parseFloat($));
        let M = [m(S[0], "50%"), m(S[1], "50%"), m(A && A < 0 ? void 0 : c.size, "100%"), m($ && $ < 0 ? void 0 : c.innerSize || 0, "0%")];
        for (!g.angular || this instanceof a || (M[3] = 0), j = 0; j < 4; ++j)
          N = M[j], k = j < 2 || j === 2 && /%$/.test(N), M[j] = h(N, [P, f, w, M[2]][j]) + (k ? v : 0);
        return M[3] > M[2] && (M[3] = M[2]), u(x) && 2 * x < M[2] && x > 0 && (M[3] = M[2] - 2 * x), y(this, "afterGetCenter", { positions: M }), M;
      }, l.getStartAndEndRadians = function(c, g) {
        let v = u(c) ? c : 0, P = u(g) && g > v && g - v < 360 ? g : v + 360;
        return { start: d * (v + -90), end: d * (P + -90) };
      }, s;
    }), i(n, "Series/Pie/PiePoint.js", [n["Core/Animation/AnimationUtilities.js"], n["Core/Series/Point.js"], n["Core/Utilities.js"]], function(o, a, r) {
      let { setAnimation: s } = o, { addEvent: l, defined: d, extend: y, isNumber: u, pick: m, relativeLength: h } = r;
      class c extends a {
        getConnectorPath(v) {
          let P = v.dataLabelPosition, f = v.options || {}, S = f.connectorShape, w = this.connectorShapes[S] || S;
          return P && w.call(this, { ...P.computed, alignment: P.alignment }, P.connectorPosition, f) || [];
        }
        getTranslate() {
          return this.sliced && this.slicedTranslation || { translateX: 0, translateY: 0 };
        }
        haloPath(v) {
          let P = this.shapeArgs;
          return this.sliced || !this.visible ? [] : this.series.chart.renderer.symbols.arc(P.x, P.y, P.r + v, P.r + v, { innerR: P.r - 1, start: P.start, end: P.end, borderRadius: P.borderRadius });
        }
        constructor(v, P, f) {
          super(v, P, f), this.half = 0, this.name ?? (this.name = "Slice");
          let S = (w) => {
            this.slice(w.type === "select");
          };
          l(this, "select", S), l(this, "unselect", S);
        }
        isValid() {
          return u(this.y) && this.y >= 0;
        }
        setVisible(v, P = !0) {
          v !== this.visible && this.update({ visible: v ?? !this.visible }, P, void 0, !1);
        }
        slice(v, P, f) {
          let S = this.series;
          s(f, S.chart), P = m(P, !0), this.sliced = this.options.sliced = v = d(v) ? v : !this.sliced, S.options.data[S.data.indexOf(this)] = this.options, this.graphic && this.graphic.animate(this.getTranslate());
        }
      }
      return y(c.prototype, { connectorShapes: { fixedOffset: function(g, v, P) {
        let f = v.breakAt, S = v.touchingSliceAt, w = P.softConnector ? ["C", g.x + (g.alignment === "left" ? -5 : 5), g.y, 2 * f.x - S.x, 2 * f.y - S.y, f.x, f.y] : ["L", f.x, f.y];
        return [["M", g.x, g.y], w, ["L", S.x, S.y]];
      }, straight: function(g, v) {
        let P = v.touchingSliceAt;
        return [["M", g.x, g.y], ["L", P.x, P.y]];
      }, crookedLine: function(g, v, P) {
        let { breakAt: f, touchingSliceAt: S } = v, { series: w } = this, [x, k, A] = w.center, $ = A / 2, { plotLeft: j, plotWidth: N } = w.chart, M = g.alignment === "left", { x: D, y: C } = g, b = f.x;
        if (P.crookDistance) {
          let L = h(P.crookDistance, 1);
          b = M ? x + $ + (N + j - x - $) * (1 - L) : j + (x - $) * L;
        } else
          b = x + (k - C) * Math.tan((this.angle || 0) - Math.PI / 2);
        let p = [["M", D, C]];
        return (M ? b <= D && b >= f.x : b >= D && b <= f.x) && p.push(["L", b, C]), p.push(["L", f.x, f.y], ["L", S.x, S.y]), p;
      } } }), c;
    }), i(n, "Series/Pie/PieSeriesDefaults.js", [], function() {
      return { borderRadius: 3, center: [null, null], clip: !1, colorByPoint: !0, dataLabels: { connectorPadding: 5, connectorShape: "crookedLine", crookDistance: void 0, distance: 30, enabled: !0, formatter: function() {
        return this.point.isNull ? void 0 : this.point.name;
      }, softConnector: !0, x: 0 }, fillColor: void 0, ignoreHiddenPoint: !0, inactiveOtherPoints: !0, legendType: "point", marker: null, size: null, showInLegend: !1, slicedOffset: 10, stickyTracking: !1, tooltip: { followPointer: !0 }, borderColor: "#ffffff", borderWidth: 1, lineWidth: void 0, states: { hover: { brightness: 0.1 } } };
    }), i(n, "Series/Pie/PieSeries.js", [n["Series/CenteredUtilities.js"], n["Series/Column/ColumnSeries.js"], n["Core/Globals.js"], n["Series/Pie/PiePoint.js"], n["Series/Pie/PieSeriesDefaults.js"], n["Core/Series/Series.js"], n["Core/Series/SeriesRegistry.js"], n["Core/Renderer/SVG/Symbols.js"], n["Core/Utilities.js"]], function(o, a, r, s, l, d, y, u, m) {
      let { getStartAndEndRadians: h } = o, { noop: c } = r, { clamp: g, extend: v, fireEvent: P, merge: f, pick: S } = m;
      class w extends d {
        animate(k) {
          let A = this, $ = A.points, j = A.startAngleRad;
          k || $.forEach(function(N) {
            let M = N.graphic, D = N.shapeArgs;
            M && D && (M.attr({ r: S(N.startR, A.center && A.center[3] / 2), start: j, end: j }), M.animate({ r: D.r, start: D.start, end: D.end }, A.options.animation));
          });
        }
        drawEmpty() {
          let k, A, $ = this.startAngleRad, j = this.endAngleRad, N = this.options;
          this.total === 0 && this.center ? (k = this.center[0], A = this.center[1], this.graph || (this.graph = this.chart.renderer.arc(k, A, this.center[1] / 2, 0, $, j).addClass("highcharts-empty-series").add(this.group)), this.graph.attr({ d: u.arc(k, A, this.center[2] / 2, 0, { start: $, end: j, innerR: this.center[3] / 2 }) }), this.chart.styledMode || this.graph.attr({ "stroke-width": N.borderWidth, fill: N.fillColor || "none", stroke: N.color || "#cccccc" })) : this.graph && (this.graph = this.graph.destroy());
        }
        drawPoints() {
          let k = this.chart.renderer;
          this.points.forEach(function(A) {
            A.graphic && A.hasNewShapeType() && (A.graphic = A.graphic.destroy()), A.graphic || (A.graphic = k[A.shapeType](A.shapeArgs).add(A.series.group), A.delayedRendering = !0);
          });
        }
        generatePoints() {
          super.generatePoints(), this.updateTotals();
        }
        getX(k, A, $, j) {
          let N = this.center, M = this.radii ? this.radii[$.index] || 0 : N[2] / 2, D = j.dataLabelPosition, C = D?.distance || 0, b = Math.asin(g((k - N[1]) / (M + C), -1, 1));
          return N[0] + Math.cos(b) * (M + C) * (A ? -1 : 1) + (C > 0 ? (A ? -1 : 1) * (j.padding || 0) : 0);
        }
        hasData() {
          return !!this.processedXData.length;
        }
        redrawPoints() {
          let k, A, $, j, N = this, M = N.chart;
          this.drawEmpty(), N.group && !M.styledMode && N.group.shadow(N.options.shadow), N.points.forEach(function(D) {
            let C = {};
            A = D.graphic, !D.isNull && A ? (j = D.shapeArgs, k = D.getTranslate(), M.styledMode || ($ = N.pointAttribs(D, D.selected && "select")), D.delayedRendering ? (A.setRadialReference(N.center).attr(j).attr(k), M.styledMode || A.attr($).attr({ "stroke-linejoin": "round" }), D.delayedRendering = !1) : (A.setRadialReference(N.center), M.styledMode || f(!0, C, $), f(!0, C, j, k), A.animate(C)), A.attr({ visibility: D.visible ? "inherit" : "hidden" }), A.addClass(D.getClassName(), !0)) : A && (D.graphic = A.destroy());
          });
        }
        sortByAngle(k, A) {
          k.sort(function($, j) {
            return $.angle !== void 0 && (j.angle - $.angle) * A;
          });
        }
        translate(k) {
          P(this, "translate"), this.generatePoints();
          let A = this.options, $ = A.slicedOffset, j = h(A.startAngle, A.endAngle), N = this.startAngleRad = j.start, M = (this.endAngleRad = j.end) - N, D = this.points, C = A.ignoreHiddenPoint, b = D.length, p, L, B, T, O, I, R, Y = 0;
          for (k || (this.center = k = this.getCenter()), I = 0; I < b; I++) {
            R = D[I], p = N + Y * M, R.isValid() && (!C || R.visible) && (Y += R.percentage / 100), L = N + Y * M;
            let F = { x: k[0], y: k[1], r: k[2] / 2, innerR: k[3] / 2, start: Math.round(1e3 * p) / 1e3, end: Math.round(1e3 * L) / 1e3 };
            R.shapeType = "arc", R.shapeArgs = F, (B = (L + p) / 2) > 1.5 * Math.PI ? B -= 2 * Math.PI : B < -Math.PI / 2 && (B += 2 * Math.PI), R.slicedTranslation = { translateX: Math.round(Math.cos(B) * $), translateY: Math.round(Math.sin(B) * $) }, T = Math.cos(B) * k[2] / 2, O = Math.sin(B) * k[2] / 2, R.tooltipPos = [k[0] + 0.7 * T, k[1] + 0.7 * O], R.half = B < -Math.PI / 2 || B > Math.PI / 2 ? 1 : 0, R.angle = B;
          }
          P(this, "afterTranslate");
        }
        updateTotals() {
          let k = this.points, A = k.length, $ = this.options.ignoreHiddenPoint, j, N, M = 0;
          for (j = 0; j < A; j++)
            (N = k[j]).isValid() && (!$ || N.visible) && (M += N.y);
          for (j = 0, this.total = M; j < A; j++)
            (N = k[j]).percentage = M > 0 && (N.visible || !$) ? N.y / M * 100 : 0, N.total = M;
        }
      }
      return w.defaultOptions = f(d.defaultOptions, l), v(w.prototype, { axisTypes: [], directTouch: !0, drawGraph: void 0, drawTracker: a.prototype.drawTracker, getCenter: o.getCenter, getSymbol: c, invertible: !1, isCartesian: !1, noSharedTooltip: !0, pointAttribs: a.prototype.pointAttribs, pointClass: s, requireSorting: !1, searchPoint: c, trackerGroups: ["group", "dataLabelsGroup"] }), y.registerSeriesType("pie", w), w;
    }), i(n, "Series/Pie/PieDataLabel.js", [n["Core/Series/DataLabel.js"], n["Core/Globals.js"], n["Core/Renderer/RendererUtilities.js"], n["Core/Series/SeriesRegistry.js"], n["Core/Utilities.js"]], function(o, a, r, s, l) {
      var d;
      let { composed: y, noop: u } = a, { distribute: m } = r, { series: h } = s, { arrayMax: c, clamp: g, defined: v, pick: P, pushUnique: f, relativeLength: S } = l;
      return function(w) {
        let x = { radialDistributionY: function(N, M) {
          return (M.dataLabelPosition?.top || 0) + N.distributeBox.pos;
        }, radialDistributionX: function(N, M, D, C, b) {
          let p = b.dataLabelPosition;
          return N.getX(D < (p?.top || 0) + 2 || D > (p?.bottom || 0) - 2 ? C : D, M.half, M, b);
        }, justify: function(N, M, D, C) {
          return C[0] + (N.half ? -1 : 1) * (D + (M.dataLabelPosition?.distance || 0));
        }, alignToPlotEdges: function(N, M, D, C) {
          let b = N.getBBox().width;
          return M ? b + C : D - b - C;
        }, alignToConnectors: function(N, M, D, C) {
          let b = 0, p;
          return N.forEach(function(L) {
            (p = L.dataLabel.getBBox().width) > b && (b = p);
          }), M ? b + C : D - b - C;
        } };
        function k(N, M) {
          let { center: D, options: C } = this, b = D[2] / 2, p = N.angle || 0, L = Math.cos(p), B = Math.sin(p), T = D[0] + L * b, O = D[1] + B * b, I = Math.min((C.slicedOffset || 0) + (C.borderWidth || 0), M / 5);
          return { natural: { x: T + L * M, y: O + B * M }, computed: {}, alignment: M < 0 ? "center" : N.half ? "right" : "left", connectorPosition: { breakAt: { x: T + L * I, y: O + B * I }, touchingSliceAt: { x: T, y: O } }, distance: M };
        }
        function A() {
          let N = this, M = N.points, D = N.chart, C = D.plotWidth, b = D.plotHeight, p = D.plotLeft, L = Math.round(D.chartWidth / 3), B = N.center, T = B[2] / 2, O = B[1], I = [[], []], R = [0, 0, 0, 0], Y = N.dataLabelPositioners, F, U, Q, J = 0;
          N.visible && N.hasDataLabels?.() && (M.forEach((ee) => {
            (ee.dataLabels || []).forEach((V) => {
              V.shortened && (V.attr({ width: "auto" }).css({ width: "auto", textOverflow: "clip" }), V.shortened = !1);
            });
          }), h.prototype.drawDataLabels.apply(N), M.forEach((ee) => {
            (ee.dataLabels || []).forEach((V, G) => {
              let W = B[2] / 2, ae = V.options, z = S(ae?.distance || 0, W);
              G === 0 && I[ee.half].push(ee), !v(ae?.style?.width) && V.getBBox().width > L && (V.css({ width: Math.round(0.7 * L) + "px" }), V.shortened = !0), V.dataLabelPosition = this.getDataLabelPosition(ee, z), J = Math.max(J, z);
            });
          }), I.forEach((ee, V) => {
            let G = ee.length, W = [], ae, z, q = 0, Z;
            G && (N.sortByAngle(ee, V - 0.5), J > 0 && (ae = Math.max(0, O - T - J), z = Math.min(O + T + J, D.plotHeight), ee.forEach((ne) => {
              (ne.dataLabels || []).forEach((ie) => {
                let re = ie.dataLabelPosition;
                re && re.distance > 0 && (re.top = Math.max(0, O - T - re.distance), re.bottom = Math.min(O + T + re.distance, D.plotHeight), q = ie.getBBox().height || 21, ie.lineHeight = D.renderer.fontMetrics(ie.text || ie).h + 2 * ie.padding, ne.distributeBox = { target: (ie.dataLabelPosition?.natural.y || 0) - re.top + ie.lineHeight / 2, size: q, rank: ne.y }, W.push(ne.distributeBox));
              });
            }), m(W, Z = z + q - ae, Z / 5)), ee.forEach((ne) => {
              (ne.dataLabels || []).forEach((ie) => {
                let re = ie.options || {}, de = ne.distributeBox, me = ie.dataLabelPosition, ce = me?.natural.y || 0, pe = re.connectorPadding || 0, xe = ie.lineHeight || 21, le = (xe - ie.getBBox().height) / 2, se = 0, he = ce, ve = "inherit";
                if (me) {
                  if (W && v(de) && me.distance > 0 && (de.pos === void 0 ? ve = "hidden" : (Q = de.size, he = Y.radialDistributionY(ne, ie))), re.justify)
                    se = Y.justify(ne, ie, T, B);
                  else
                    switch (re.alignTo) {
                      case "connectors":
                        se = Y.alignToConnectors(ee, V, C, p);
                        break;
                      case "plotEdges":
                        se = Y.alignToPlotEdges(ie, V, C, p);
                        break;
                      default:
                        se = Y.radialDistributionX(N, ne, he - le, ce, ie);
                    }
                  if (me.attribs = { visibility: ve, align: me.alignment }, me.posAttribs = { x: se + (re.x || 0) + ({ left: pe, right: -pe }[me.alignment] || 0), y: he + (re.y || 0) - xe / 2 }, me.computed.x = se, me.computed.y = he - le, P(re.crop, !0)) {
                    let ye;
                    se - (U = ie.getBBox().width) < pe && V === 1 ? (ye = Math.round(U - se + pe), R[3] = Math.max(ye, R[3])) : se + U > C - pe && V === 0 && (ye = Math.round(se + U - C + pe), R[1] = Math.max(ye, R[1])), he - Q / 2 < 0 ? R[0] = Math.max(Math.round(-he + Q / 2), R[0]) : he + Q / 2 > b && (R[2] = Math.max(Math.round(he + Q / 2 - b), R[2])), me.sideOverflow = ye;
                  }
                }
              });
            }));
          }), (c(R) === 0 || this.verifyDataLabelOverflow(R)) && (this.placeDataLabels(), this.points.forEach((ee) => {
            (ee.dataLabels || []).forEach((V) => {
              let { connectorColor: G, connectorWidth: W = 1 } = V.options || {}, ae = V.dataLabelPosition;
              if (W) {
                let z;
                F = V.connector, ae && ae.distance > 0 ? (z = !F, F || (V.connector = F = D.renderer.path().addClass("highcharts-data-label-connector  highcharts-color-" + ee.colorIndex + (ee.className ? " " + ee.className : "")).add(N.dataLabelsGroup)), D.styledMode || F.attr({ "stroke-width": W, stroke: G || ee.color || "#666666" }), F[z ? "attr" : "animate"]({ d: ee.getConnectorPath(V) }), F.attr({ visibility: ae.attribs?.visibility })) : F && (V.connector = F.destroy());
              }
            });
          })));
        }
        function $() {
          this.points.forEach((N) => {
            (N.dataLabels || []).forEach((M) => {
              let D = M.dataLabelPosition;
              D ? (D.sideOverflow && (M.css({ width: Math.max(M.getBBox().width - D.sideOverflow, 0) + "px", textOverflow: (M.options?.style || {}).textOverflow || "ellipsis" }), M.shortened = !0), M.attr(D.attribs), M[M.moved ? "animate" : "attr"](D.posAttribs), M.moved = !0) : M && M.attr({ y: -9999 });
            }), delete N.distributeBox;
          }, this);
        }
        function j(N) {
          let M = this.center, D = this.options, C = D.center, b = D.minSize || 80, p = b, L = D.size !== null;
          return !L && (C[0] !== null ? p = Math.max(M[2] - Math.max(N[1], N[3]), b) : (p = Math.max(M[2] - N[1] - N[3], b), M[0] += (N[3] - N[1]) / 2), C[1] !== null ? p = g(p, b, M[2] - Math.max(N[0], N[2])) : (p = g(p, b, M[2] - N[0] - N[2]), M[1] += (N[0] - N[2]) / 2), p < M[2] ? (M[2] = p, M[3] = Math.min(D.thickness ? Math.max(0, p - 2 * D.thickness) : Math.max(0, S(D.innerSize || 0, p)), p), this.translate(M), this.drawDataLabels && this.drawDataLabels()) : L = !0), L;
        }
        w.compose = function(N) {
          if (o.compose(h), f(y, "PieDataLabel")) {
            let M = N.prototype;
            M.dataLabelPositioners = x, M.alignDataLabel = u, M.drawDataLabels = A, M.getDataLabelPosition = k, M.placeDataLabels = $, M.verifyDataLabelOverflow = j;
          }
        };
      }(d || (d = {})), d;
    }), i(n, "Core/Geometry/GeometryUtilities.js", [], function() {
      var o, a;
      return (a = o || (o = {})).getCenterOfPoints = function(r) {
        let s = r.reduce((l, d) => (l.x += d.x, l.y += d.y, l), { x: 0, y: 0 });
        return { x: s.x / r.length, y: s.y / r.length };
      }, a.getDistanceBetweenPoints = function(r, s) {
        return Math.sqrt(Math.pow(s.x - r.x, 2) + Math.pow(s.y - r.y, 2));
      }, a.getAngleBetweenPoints = function(r, s) {
        return Math.atan2(s.x - r.x, s.y - r.y);
      }, a.pointInPolygon = function({ x: r, y: s }, l) {
        let d = l.length, y, u, m = !1;
        for (y = 0, u = d - 1; y < d; u = y++) {
          let [h, c] = l[y], [g, v] = l[u];
          c > s != v > s && r < (g - h) * (s - c) / (v - c) + h && (m = !m);
        }
        return m;
      }, o;
    }), i(n, "Extensions/OverlappingDataLabels.js", [n["Core/Geometry/GeometryUtilities.js"], n["Core/Utilities.js"]], function(o, a) {
      let { pointInPolygon: r } = o, { addEvent: s, fireEvent: l, objectEach: d, pick: y } = a;
      function u(c) {
        let g = c.length, v = ($, j) => !(j.x >= $.x + $.width || j.x + j.width <= $.x || j.y >= $.y + $.height || j.y + j.height <= $.y), P = ($, j) => {
          for (let N of $)
            if (r({ x: N[0], y: N[1] }, j))
              return !0;
          return !1;
        }, f, S, w, x, k, A = !1;
        for (let $ = 0; $ < g; $++)
          (f = c[$]) && (f.oldOpacity = f.opacity, f.newOpacity = 1, f.absoluteBox = function(j) {
            if (j && (!j.alignAttr || j.placed)) {
              let N = j.box ? 0 : j.padding || 0, M = j.alignAttr || { x: j.attr("x"), y: j.attr("y") }, D = j.getBBox();
              return j.width = D.width, j.height = D.height, { x: M.x + (j.parentGroup?.translateX || 0) + N, y: M.y + (j.parentGroup?.translateY || 0) + N, width: (j.width || 0) - 2 * N, height: (j.height || 0) - 2 * N, polygon: D?.polygon };
            }
          }(f));
        c.sort(($, j) => (j.labelrank || 0) - ($.labelrank || 0));
        for (let $ = 0; $ < g; ++$) {
          x = (S = c[$]) && S.absoluteBox;
          let j = x?.polygon;
          for (let N = $ + 1; N < g; ++N) {
            k = (w = c[N]) && w.absoluteBox;
            let M = !1;
            if (x && k && S !== w && S.newOpacity !== 0 && w.newOpacity !== 0 && S.visibility !== "hidden" && w.visibility !== "hidden") {
              let D = k.polygon;
              if (j && D && j !== D ? P(j, D) && (M = !0) : v(x, k) && (M = !0), M) {
                let C = S.labelrank < w.labelrank ? S : w, b = C.text;
                C.newOpacity = 0, b?.element.querySelector("textPath") && b.hide();
              }
            }
          }
        }
        for (let $ of c)
          m($, this) && (A = !0);
        A && l(this, "afterHideAllOverlappingLabels");
      }
      function m(c, g) {
        let v, P, f = !1;
        return c && (P = c.newOpacity, c.oldOpacity !== P && (c.hasClass("highcharts-data-label") ? (c[P ? "removeClass" : "addClass"]("highcharts-data-label-hidden"), v = function() {
          g.styledMode || c.css({ pointerEvents: P ? "auto" : "none" });
        }, f = !0, c[c.isOld ? "animate" : "attr"]({ opacity: P }, void 0, v), l(g, "afterHideOverlappingLabel")) : c.attr({ opacity: P })), c.isOld = !0), f;
      }
      function h() {
        let c = this, g = [];
        for (let v of c.labelCollectors || [])
          g = g.concat(v());
        for (let v of c.yAxis || [])
          v.stacking && v.options.stackLabels && !v.options.stackLabels.allowOverlap && d(v.stacking.stacks, (P) => {
            d(P, (f) => {
              f.label && g.push(f.label);
            });
          });
        for (let v of c.series || [])
          if (v.visible && v.hasDataLabels?.()) {
            let P = (f) => {
              for (let S of f)
                S.visible && (S.dataLabels || []).forEach((w) => {
                  let x = w.options || {};
                  w.labelrank = y(x.labelrank, S.labelrank, S.shapeArgs?.height), x.allowOverlap ?? Number(x.distance) > 0 ? (w.oldOpacity = w.opacity, w.newOpacity = 1, m(w, c)) : g.push(w);
                });
            };
            P(v.nodes || []), P(v.points);
          }
        this.hideOverlappingLabels(g);
      }
      return { compose: function(c) {
        let g = c.prototype;
        g.hideOverlappingLabels || (g.hideOverlappingLabels = u, s(c, "render", h));
      } };
    }), i(n, "Extensions/BorderRadius.js", [n["Core/Defaults.js"], n["Core/Globals.js"], n["Core/Utilities.js"]], function(o, a, r) {
      let { defaultOptions: s } = o, { noop: l } = a, { addEvent: d, extend: y, isObject: u, merge: m, relativeLength: h } = r, c = { radius: 0, scope: "stack", where: void 0 }, g = l, v = l;
      function P(k, A, $, j, N = {}) {
        let M = g(k, A, $, j, N), { innerR: D = 0, r: C = $, start: b = 0, end: p = 0 } = N;
        if (N.open || !N.borderRadius)
          return M;
        let L = p - b, B = Math.sin(L / 2), T = Math.max(Math.min(h(N.borderRadius || 0, C - D), (C - D) / 2, C * B / (1 + B)), 0), O = Math.min(T, L / Math.PI * 2 * D), I = M.length - 1;
        for (; I--; )
          (function(R, Y, F) {
            let U, Q, J, ee = R[Y], V = R[Y + 1];
            if (V[0] === "Z" && (V = R[0]), (ee[0] === "M" || ee[0] === "L") && V[0] === "A" ? (U = ee, Q = V, J = !0) : ee[0] === "A" && (V[0] === "M" || V[0] === "L") && (U = V, Q = ee), U && Q && Q.params) {
              let G = Q[1], W = Q[5], ae = Q.params, { start: z, end: q, cx: Z, cy: ne } = ae, ie = W ? G - F : G + F, re = ie ? Math.asin(F / ie) : 0, de = W ? re : -re, me = Math.cos(re) * ie;
              J ? (ae.start = z + de, U[1] = Z + me * Math.cos(z), U[2] = ne + me * Math.sin(z), R.splice(Y + 1, 0, ["A", F, F, 0, 0, 1, Z + G * Math.cos(ae.start), ne + G * Math.sin(ae.start)])) : (ae.end = q - de, Q[6] = Z + G * Math.cos(ae.end), Q[7] = ne + G * Math.sin(ae.end), R.splice(Y + 1, 0, ["A", F, F, 0, 0, 1, Z + me * Math.cos(q), ne + me * Math.sin(q)])), Q[4] = Math.abs(ae.end - ae.start) < Math.PI ? 0 : 1;
            }
          })(M, I, I > 1 ? O : T);
        return M;
      }
      function f() {
        if (this.options.borderRadius && !(this.chart.is3d && this.chart.is3d())) {
          let { options: k, yAxis: A } = this, $ = k.stacking === "percent", j = s.plotOptions?.[this.type]?.borderRadius, N = S(k.borderRadius, u(j) ? j : {}), M = A.options.reversed;
          for (let D of this.points) {
            let { shapeArgs: C } = D;
            if (D.shapeType === "roundedRect" && C) {
              let { width: b = 0, height: p = 0, y: L = 0 } = C, B = L, T = p;
              if (N.scope === "stack" && D.stackTotal) {
                let Y = A.translate($ ? 100 : D.stackTotal, !1, !0, !1, !0), F = A.translate(k.threshold || 0, !1, !0, !1, !0), U = this.crispCol(0, Math.min(Y, F), 0, Math.abs(Y - F));
                B = U.y, T = U.height;
              }
              let O = (D.negative ? -1 : 1) * (M ? -1 : 1) == -1, I = N.where;
              !I && this.is("waterfall") && Math.abs((D.yBottom || 0) - (this.translatedThreshold || 0)) > this.borderWidth && (I = "all"), I || (I = "end");
              let R = Math.min(h(N.radius, b), b / 2, I === "all" ? p / 2 : 1 / 0) || 0;
              I === "end" && (O && (B -= R), T += R), y(C, { brBoxHeight: T, brBoxY: B, r: R });
            }
          }
        }
      }
      function S(k, A) {
        return u(k) || (k = { radius: k || 0 }), m(c, A, k);
      }
      function w() {
        let k = S(this.options.borderRadius);
        for (let A of this.points) {
          let $ = A.shapeArgs;
          $ && ($.borderRadius = h(k.radius, ($.r || 0) - ($.innerR || 0)));
        }
      }
      function x(k, A, $, j, N = {}) {
        let M = v(k, A, $, j, N), { r: D = 0, brBoxHeight: C = j, brBoxY: b = A } = N, p = A - b, L = b + C - (A + j), B = p - D > -0.1 ? 0 : D, T = L - D > -0.1 ? 0 : D, O = Math.max(B && p, 0), I = Math.max(T && L, 0), R = [k + B, A], Y = [k + $ - B, A], F = [k + $, A + B], U = [k + $, A + j - T], Q = [k + $ - T, A + j], J = [k + T, A + j], ee = [k, A + j - T], V = [k, A + B], G = (W, ae) => Math.sqrt(Math.pow(W, 2) - Math.pow(ae, 2));
        if (O) {
          let W = G(B, B - O);
          R[0] -= W, Y[0] += W, F[1] = V[1] = A + B - O;
        }
        if (j < B - O) {
          let W = G(B, B - O - j);
          F[0] = U[0] = k + $ - B + W, Q[0] = Math.min(F[0], Q[0]), J[0] = Math.max(U[0], J[0]), ee[0] = V[0] = k + B - W, F[1] = V[1] = A + j;
        }
        if (I) {
          let W = G(T, T - I);
          Q[0] += W, J[0] -= W, U[1] = ee[1] = A + j - T + I;
        }
        if (j < T - I) {
          let W = G(T, T - I - j);
          F[0] = U[0] = k + $ - T + W, Y[0] = Math.min(F[0], Y[0]), R[0] = Math.max(U[0], R[0]), ee[0] = V[0] = k + T - W, U[1] = ee[1] = A;
        }
        return M.length = 0, M.push(["M", ...R], ["L", ...Y], ["A", B, B, 0, 0, 1, ...F], ["L", ...U], ["A", T, T, 0, 0, 1, ...Q], ["L", ...J], ["A", T, T, 0, 0, 1, ...ee], ["L", ...V], ["A", B, B, 0, 0, 1, ...R], ["Z"]), M;
      }
      return { compose: function(k, A, $) {
        let j = k.types.pie;
        if (!A.symbolCustomAttribs.includes("borderRadius")) {
          let N = $.prototype.symbols;
          d(k, "afterColumnTranslate", f, { order: 9 }), d(j, "afterTranslate", w), A.symbolCustomAttribs.push("borderRadius", "brBoxHeight", "brBoxY"), g = N.arc, v = N.roundedRect, N.arc = P, N.roundedRect = x;
        }
      }, optionsToObject: S };
    }), i(n, "Core/Responsive.js", [n["Core/Utilities.js"]], function(o) {
      var a;
      let { diffObjects: r, extend: s, find: l, merge: d, pick: y, uniqueKey: u } = o;
      return function(m) {
        function h(g, v) {
          let P = g.condition;
          (P.callback || function() {
            return this.chartWidth <= y(P.maxWidth, Number.MAX_VALUE) && this.chartHeight <= y(P.maxHeight, Number.MAX_VALUE) && this.chartWidth >= y(P.minWidth, 0) && this.chartHeight >= y(P.minHeight, 0);
          }).call(this) && v.push(g._id);
        }
        function c(g, v) {
          let P = this.options.responsive, f = this.currentResponsive, S = [], w;
          !v && P && P.rules && P.rules.forEach((A) => {
            A._id === void 0 && (A._id = u()), this.matchResponsiveRule(A, S);
          }, this);
          let x = d(...S.map((A) => l((P || {}).rules || [], ($) => $._id === A)).map((A) => A && A.chartOptions));
          x.isResponsiveOptions = !0, S = S.toString() || void 0;
          let k = f && f.ruleIds;
          S === k || (f && (this.currentResponsive = void 0, this.updatingResponsive = !0, this.update(f.undoOptions, g, !0), this.updatingResponsive = !1), S ? ((w = r(x, this.options, !0, this.collectionsWithUpdate)).isResponsiveOptions = !0, this.currentResponsive = { ruleIds: S, mergedOptions: x, undoOptions: w }, this.updatingResponsive || this.update(x, g, !0)) : this.currentResponsive = void 0);
        }
        m.compose = function(g) {
          let v = g.prototype;
          return v.matchResponsiveRule || s(v, { matchResponsiveRule: h, setResponsive: c }), g;
        };
      }(a || (a = {})), a;
    }), i(n, "masters/highcharts.src.js", [n["Core/Globals.js"], n["Core/Utilities.js"], n["Core/Defaults.js"], n["Core/Animation/Fx.js"], n["Core/Animation/AnimationUtilities.js"], n["Core/Renderer/HTML/AST.js"], n["Core/Templating.js"], n["Core/Renderer/RendererRegistry.js"], n["Core/Renderer/RendererUtilities.js"], n["Core/Renderer/SVG/SVGElement.js"], n["Core/Renderer/SVG/SVGRenderer.js"], n["Core/Renderer/HTML/HTMLElement.js"], n["Core/Axis/Axis.js"], n["Core/Axis/DateTimeAxis.js"], n["Core/Axis/LogarithmicAxis.js"], n["Core/Axis/PlotLineOrBand/PlotLineOrBand.js"], n["Core/Axis/Tick.js"], n["Core/Tooltip.js"], n["Core/Series/Point.js"], n["Core/Pointer.js"], n["Core/Legend/Legend.js"], n["Core/Legend/LegendSymbol.js"], n["Core/Chart/Chart.js"], n["Extensions/ScrollablePlotArea.js"], n["Core/Axis/Stacking/StackingAxis.js"], n["Core/Axis/Stacking/StackItem.js"], n["Core/Series/Series.js"], n["Core/Series/SeriesRegistry.js"], n["Series/Column/ColumnDataLabel.js"], n["Series/Pie/PieDataLabel.js"], n["Core/Series/DataLabel.js"], n["Extensions/OverlappingDataLabels.js"], n["Extensions/BorderRadius.js"], n["Core/Responsive.js"], n["Core/Color/Color.js"], n["Core/Time.js"]], function(o, a, r, s, l, d, y, u, m, h, c, g, v, P, f, S, w, x, k, A, $, j, N, M, D, C, b, p, L, B, T, O, I, R, Y, F) {
      return o.AST = d, o.Axis = v, o.Chart = N, o.Color = Y, o.DataLabel = T, o.Fx = s, o.HTMLElement = g, o.Legend = $, o.LegendSymbol = j, o.OverlappingDataLabels = o.OverlappingDataLabels || O, o.PlotLineOrBand = S, o.Point = k, o.Pointer = A, o.RendererRegistry = u, o.Series = b, o.SeriesRegistry = p, o.StackItem = C, o.SVGElement = h, o.SVGRenderer = c, o.Templating = y, o.Tick = w, o.Time = F, o.Tooltip = x, o.animate = l.animate, o.animObject = l.animObject, o.chart = N.chart, o.color = Y.parse, o.dateFormat = y.dateFormat, o.defaultOptions = r.defaultOptions, o.distribute = m.distribute, o.format = y.format, o.getDeferredAnimation = l.getDeferredAnimation, o.getOptions = r.getOptions, o.numberFormat = y.numberFormat, o.seriesType = p.seriesType, o.setAnimation = l.setAnimation, o.setOptions = r.setOptions, o.stop = l.stop, o.time = r.defaultTime, o.timers = s.timers, I.compose(o.Series, o.SVGElement, o.SVGRenderer), L.compose(o.Series.types.column), T.compose(o.Series), P.compose(o.Axis), g.compose(o.SVGRenderer), $.compose(o.Chart), f.compose(o.Axis), O.compose(o.Chart), B.compose(o.Series.types.pie), S.compose(o.Chart, o.Axis), A.compose(o.Chart), R.compose(o.Chart), M.compose(o.Axis, o.Chart, o.Series), D.compose(o.Axis, o.Chart, o.Series), x.compose(o.Pointer), a.extend(o, a), o;
    }), i(n, "Series/DataModifyComposition.js", [n["Core/Axis/Axis.js"], n["Core/Series/Point.js"], n["Core/Series/Series.js"], n["Core/Utilities.js"]], function(o, a, r, s) {
      var l;
      let { tooltipFormatter: d } = a.prototype, { addEvent: y, arrayMax: u, arrayMin: m, correctFloat: h, defined: c, isArray: g, isNumber: v, isString: P, pick: f } = s;
      return function(S) {
        function w(b, p, L) {
          !this.isXAxis && (this.series.forEach(function(B) {
            b === "compare" && typeof p != "boolean" ? B.setCompare(p, !1) : b !== "cumulative" || P(p) || B.setCumulative(p, !1);
          }), f(L, !0) && this.chart.redraw());
        }
        function x(b) {
          let p = this, { numberFormatter: L } = p.series.chart, B = function(T) {
            b = b.replace("{point." + T + "}", (p[T] > 0 && T === "change" ? "+" : "") + L(p[T], f(p.series.tooltipOptions.changeDecimals, 2)));
          };
          return c(p.change) && B("change"), c(p.cumulativeSum) && B("cumulativeSum"), d.apply(this, [b]);
        }
        function k() {
          let b, p = this.options.compare;
          (p === "percent" || p === "value" || this.options.cumulative) && (b = new C(this), p === "percent" || p === "value" ? b.initCompare(p) : b.initCumulative()), this.dataModify = b;
        }
        function A(b) {
          let p = b.dataExtremes, L = p.activeYData;
          if (this.dataModify && p) {
            let B;
            this.options.compare ? B = [this.dataModify.modifyValue(p.dataMin), this.dataModify.modifyValue(p.dataMax)] : this.options.cumulative && g(L) && L.length >= 2 && (B = C.getCumulativeExtremes(L)), B && (p.dataMin = m(B), p.dataMax = u(B));
          }
        }
        function $(b, p) {
          this.options.compare = this.userOptions.compare = b, this.update({}, f(p, !0)), this.dataModify && (b === "value" || b === "percent") ? this.dataModify.initCompare(b) : this.points.forEach((L) => {
            delete L.change;
          });
        }
        function j() {
          if (this.xAxis && this.processedYData && this.dataModify) {
            let b = this.processedXData, p = this.processedYData, L = p.length, B = this.options.compareStart === !0 ? 0 : 1, T = -1, O;
            for (this.pointArrayMap && (T = this.pointArrayMap.indexOf(this.options.pointValKey || this.pointValKey || "y")), O = 0; O < L - B; O++) {
              let I = p[O] && T > -1 ? p[O][T] : p[O];
              if (v(I) && I !== 0 && b[O + B] >= (this.xAxis.min || 0)) {
                this.dataModify.compareValue = I;
                break;
              }
            }
          }
        }
        function N(b, p) {
          this.setModifier("compare", b, p);
        }
        function M(b, p) {
          b = f(b, !1), this.options.cumulative = this.userOptions.cumulative = b, this.update({}, f(p, !0)), this.dataModify ? this.dataModify.initCumulative() : this.points.forEach((L) => {
            delete L.cumulativeSum;
          });
        }
        function D(b, p) {
          this.setModifier("cumulative", b, p);
        }
        S.compose = function(b, p, L) {
          let B = p.prototype, T = L.prototype, O = b.prototype;
          return O.setCompare || (O.setCompare = $, O.setCumulative = M, y(b, "afterInit", k), y(b, "afterGetExtremes", A), y(b, "afterProcessData", j)), B.setCompare || (B.setCompare = N, B.setModifier = w, B.setCumulative = D, T.tooltipFormatter = x), b;
        };
        class C {
          constructor(p) {
            this.series = p;
          }
          modifyValue() {
            return 0;
          }
          static getCumulativeExtremes(p) {
            let L = 1 / 0, B = -1 / 0;
            return p.reduce((T, O) => {
              let I = T + O;
              return L = Math.min(L, I, T), B = Math.max(B, I, T), I;
            }), [L, B];
          }
          initCompare(p) {
            this.modifyValue = function(L, B) {
              L === null && (L = 0);
              let T = this.compareValue;
              if (L !== void 0 && T !== void 0) {
                if (p === "value" ? L -= T : L = L / T * 100 - (this.series.options.compareBase === 100 ? 0 : 100), B !== void 0) {
                  let O = this.series.points[B];
                  O && (O.change = L);
                }
                return L;
              }
              return 0;
            };
          }
          initCumulative() {
            this.modifyValue = function(p, L) {
              if (p === null && (p = 0), p !== void 0 && L !== void 0) {
                let B = L > 0 ? this.series.points[L - 1] : null;
                B && B.cumulativeSum && (p = h(B.cumulativeSum + p));
                let T = this.series.points[L], O = T.series.options.cumulativeStart, I = T.x <= this.series.xAxis.max && T.x >= this.series.xAxis.min;
                return T && (!O || I ? T.cumulativeSum = p : T.cumulativeSum = void 0), p;
              }
              return 0;
            };
          }
        }
        S.Additions = C;
      }(l || (l = {})), l;
    }), i(n, "Stock/Navigator/ChartNavigatorComposition.js", [n["Core/Globals.js"], n["Core/Utilities.js"]], function(o, a) {
      let r, { isTouchDevice: s } = o, { addEvent: l, merge: d, pick: y } = a, u = [];
      function m() {
        this.navigator && this.navigator.setBaseSeries(null, !1);
      }
      function h() {
        let S, w, x, k = this.legend, A = this.navigator;
        if (A) {
          S = k && k.options, w = A.xAxis, x = A.yAxis;
          let { scrollbarHeight: $, scrollButtonSize: j } = A;
          this.inverted ? (A.left = A.opposite ? this.chartWidth - $ - A.height : this.spacing[3] + $, A.top = this.plotTop + j) : (A.left = y(w.left, this.plotLeft + j), A.top = A.navigatorOptions.top || this.chartHeight - A.height - $ - (this.scrollbar?.options.margin || 0) - this.spacing[2] - (this.rangeSelector && this.extraBottomMargin ? this.rangeSelector.getHeight() : 0) - (S && S.verticalAlign === "bottom" && S.layout !== "proximate" && S.enabled && !S.floating ? k.legendHeight + y(S.margin, 10) : 0) - (this.titleOffset ? this.titleOffset[2] : 0)), w && x && (this.inverted ? w.options.left = x.options.left = A.left : w.options.top = x.options.top = A.top, w.setAxisSize(), x.setAxisSize());
        }
      }
      function c(S) {
        !this.navigator && !this.scroller && (this.options.navigator.enabled || this.options.scrollbar.enabled) && (this.scroller = this.navigator = new r(this), y(S.redraw, !0) && this.redraw(S.animation));
      }
      function g() {
        let S = this.options;
        (S.navigator.enabled || S.scrollbar.enabled) && (this.scroller = this.navigator = new r(this));
      }
      function v() {
        let S = this.options, w = S.navigator, x = S.rangeSelector;
        if ((w && w.enabled || x && x.enabled) && (!s && this.zooming.type === "x" || s && this.zooming.pinchType === "x"))
          return !1;
      }
      function P(S) {
        let w = S.navigator;
        if (w && S.xAxis[0]) {
          let x = S.xAxis[0].getExtremes();
          w.render(x.min, x.max);
        }
      }
      function f(S) {
        let w = S.options.navigator || {}, x = S.options.scrollbar || {};
        !this.navigator && !this.scroller && (w.enabled || x.enabled) && (d(!0, this.options.navigator, w), d(!0, this.options.scrollbar, x), delete S.options.navigator, delete S.options.scrollbar);
      }
      return { compose: function(S, w) {
        if (a.pushUnique(u, S)) {
          let x = S.prototype;
          r = w, x.callbacks.push(P), l(S, "afterAddSeries", m), l(S, "afterSetChartSize", h), l(S, "afterUpdate", c), l(S, "beforeRender", g), l(S, "beforeShowResetZoom", v), l(S, "update", f);
        }
      } };
    }), i(n, "Core/Axis/NavigatorAxisComposition.js", [n["Core/Globals.js"], n["Core/Utilities.js"]], function(o, a) {
      let { isTouchDevice: r } = o, { addEvent: s, correctFloat: l, defined: d, isNumber: y, pick: u } = a;
      function m() {
        this.navigatorAxis || (this.navigatorAxis = new c(this));
      }
      function h(g) {
        let v, P = this.chart, f = P.options, S = f.navigator, w = this.navigatorAxis, x = P.zooming.pinchType, k = f.rangeSelector, A = P.zooming.type;
        if (this.isXAxis && (S?.enabled || k?.enabled)) {
          if (A === "y" && g.trigger === "zoom")
            v = !1;
          else if ((g.trigger === "zoom" && A === "xy" || r && x === "xy") && this.options.range) {
            let $ = w.previousZoom;
            d(g.min) ? w.previousZoom = [this.min, this.max] : $ && (g.min = $[0], g.max = $[1], w.previousZoom = void 0);
          }
        }
        v !== void 0 && g.preventDefault();
      }
      class c {
        static compose(v) {
          v.keepProps.includes("navigatorAxis") || (v.keepProps.push("navigatorAxis"), s(v, "init", m), s(v, "setExtremes", h));
        }
        constructor(v) {
          this.axis = v;
        }
        destroy() {
          this.axis = void 0;
        }
        toFixedRange(v, P, f, S) {
          let w = this.axis, x = (w.pointRange || 0) / 2, k = u(f, w.translate(v, !0, !w.horiz)), A = u(S, w.translate(P, !0, !w.horiz));
          return d(f) || (k = l(k + x)), d(S) || (A = l(A - x)), y(k) && y(A) || (k = A = void 0), { min: k, max: A };
        }
      }
      return c;
    }), i(n, "Stock/Navigator/NavigatorDefaults.js", [n["Core/Color/Color.js"], n["Core/Series/SeriesRegistry.js"]], function(o, a) {
      let { parse: r } = o, { seriesTypes: s } = a;
      return { height: 40, margin: 25, maskInside: !0, handles: { width: 7, borderRadius: 0, height: 15, symbols: ["navigator-handle", "navigator-handle"], enabled: !0, lineWidth: 1, backgroundColor: "#f2f2f2", borderColor: "#999999" }, maskFill: r("#667aff").setOpacity(0.3).get(), outlineColor: "#999999", outlineWidth: 1, series: { type: s.areaspline === void 0 ? "line" : "areaspline", fillOpacity: 0.05, lineWidth: 1, compare: null, sonification: { enabled: !1 }, dataGrouping: { approximation: "average", enabled: !0, groupPixelWidth: 2, firstAnchor: "firstPoint", anchor: "middle", lastAnchor: "lastPoint", units: [["millisecond", [1, 2, 5, 10, 20, 25, 50, 100, 200, 500]], ["second", [1, 2, 5, 10, 15, 30]], ["minute", [1, 2, 5, 10, 15, 30]], ["hour", [1, 2, 3, 4, 6, 8, 12]], ["day", [1, 2, 3, 4]], ["week", [1, 2, 3]], ["month", [1, 3, 6]], ["year", null]] }, dataLabels: { enabled: !1, zIndex: 2 }, id: "highcharts-navigator-series", className: "highcharts-navigator-series", lineColor: null, marker: { enabled: !1 }, threshold: null }, xAxis: { className: "highcharts-navigator-xaxis", tickLength: 0, lineWidth: 0, gridLineColor: "#e6e6e6", id: "navigator-x-axis", gridLineWidth: 1, tickPixelInterval: 200, labels: { align: "left", style: { color: "#000000", fontSize: "0.7em", opacity: 0.6, textOutline: "2px contrast" }, x: 3, y: -4 }, crosshair: !1 }, yAxis: { className: "highcharts-navigator-yaxis", gridLineWidth: 0, startOnTick: !1, endOnTick: !1, minPadding: 0.1, id: "navigator-y-axis", maxPadding: 0.1, labels: { enabled: !1 }, crosshair: !1, title: { text: null }, tickLength: 0, tickWidth: 0 } };
    }), i(n, "Stock/Navigator/NavigatorSymbols.js", [n["Core/Renderer/SVG/Symbols.js"], n["Core/Utilities.js"]], function(o, a) {
      let { relativeLength: r } = a;
      return { "navigator-handle": function(s, l, d, y, u = {}) {
        let m = u.width ? u.width / 2 : d, h = r(u.borderRadius || 0, Math.min(2 * m, y));
        return [["M", -1.5, (y = u.height || y) / 2 - 3.5], ["L", -1.5, y / 2 + 4.5], ["M", 0.5, y / 2 - 3.5], ["L", 0.5, y / 2 + 4.5], ...o.rect(-m - 1, 0.5, 2 * m + 1, y, { r: h })];
      } };
    }), i(n, "Stock/Utilities/StockUtilities.js", [n["Core/Utilities.js"]], function(o) {
      let { defined: a } = o;
      return { setFixedRange: function(r) {
        let s = this.xAxis[0];
        a(s.dataMax) && a(s.dataMin) && r ? this.fixedRange = Math.min(r, s.dataMax - s.dataMin) : this.fixedRange = r;
      } };
    }), i(n, "Stock/Navigator/NavigatorComposition.js", [n["Core/Defaults.js"], n["Core/Globals.js"], n["Core/Axis/NavigatorAxisComposition.js"], n["Stock/Navigator/NavigatorDefaults.js"], n["Stock/Navigator/NavigatorSymbols.js"], n["Core/Renderer/RendererRegistry.js"], n["Stock/Utilities/StockUtilities.js"], n["Core/Utilities.js"]], function(o, a, r, s, l, d, y, u) {
      let { setOptions: m } = o, { composed: h } = a, { getRendererType: c } = d, { setFixedRange: g } = y, { addEvent: v, extend: P, pushUnique: f } = u;
      function S() {
        this.chart.navigator && !this.options.isInternal && this.chart.navigator.setBaseSeries(null, !1);
      }
      return { compose: function(w, x, k) {
        r.compose(x), f(h, "Navigator") && (w.prototype.setFixedRange = g, P(c().prototype.symbols, l), v(k, "afterUpdate", S), m({ navigator: s }));
      } };
    }), i(n, "Core/Axis/ScrollbarAxis.js", [n["Core/Globals.js"], n["Core/Utilities.js"]], function(o, a) {
      var r;
      let { composed: s } = o, { addEvent: l, defined: d, pick: y, pushUnique: u } = a;
      return function(m) {
        let h;
        function c(f) {
          let S = y(f.options && f.options.min, f.min), w = y(f.options && f.options.max, f.max);
          return { axisMin: S, axisMax: w, scrollMin: d(f.dataMin) ? Math.min(S, f.min, f.dataMin, y(f.threshold, 1 / 0)) : S, scrollMax: d(f.dataMax) ? Math.max(w, f.max, f.dataMax, y(f.threshold, -1 / 0)) : w };
        }
        function g() {
          let f = this.scrollbar, S = f && !f.options.opposite, w = this.horiz ? 2 : S ? 3 : 1;
          f && (this.chart.scrollbarsOffsets = [0, 0], this.chart.axisOffset[w] += f.size + (f.options.margin || 0));
        }
        function v() {
          let f = this;
          f.options && f.options.scrollbar && f.options.scrollbar.enabled && (f.options.scrollbar.vertical = !f.horiz, f.options.startOnTick = f.options.endOnTick = !1, f.scrollbar = new h(f.chart.renderer, f.options.scrollbar, f.chart), l(f.scrollbar, "changed", function(S) {
            let w, x, { axisMin: k, axisMax: A, scrollMin: $, scrollMax: j } = c(f), N = j - $;
            if (d(k) && d(A))
              if (f.horiz && !f.reversed || !f.horiz && f.reversed ? (w = $ + N * this.to, x = $ + N * this.from) : (w = $ + N * (1 - this.from), x = $ + N * (1 - this.to)), this.shouldUpdateExtremes(S.DOMType)) {
                let M = S.DOMType !== "mousemove" && S.DOMType !== "touchmove" && void 0;
                f.setExtremes(x, w, !0, M, S);
              } else
                this.setRange(this.from, this.to);
          }));
        }
        function P() {
          let f, S, w, { scrollMin: x, scrollMax: k } = c(this), A = this.scrollbar, $ = this.axisTitleMargin + (this.titleOffset || 0), j = this.chart.scrollbarsOffsets, N = this.options.margin || 0;
          if (A && j) {
            if (this.horiz)
              this.opposite || (j[1] += $), A.position(this.left, this.top + this.height + 2 + j[1] - (this.opposite ? N : 0), this.width, this.height), this.opposite || (j[1] += N), f = 1;
            else {
              let M;
              this.opposite && (j[0] += $), M = A.options.opposite ? this.left + this.width + 2 + j[0] - (this.opposite ? 0 : N) : this.opposite ? 0 : N, A.position(M, this.top, this.width, this.height), this.opposite && (j[0] += N), f = 0;
            }
            if (j[f] += A.size + (A.options.margin || 0), isNaN(x) || isNaN(k) || !d(this.min) || !d(this.max) || this.dataMin === this.dataMax)
              A.setRange(0, 1);
            else if (this.min === this.max) {
              let M = this.pointRange / (this.dataMax + 1);
              S = M * this.min, w = M * (this.max + 1), A.setRange(S, w);
            } else
              S = (this.min - x) / (k - x), w = (this.max - x) / (k - x), this.horiz && !this.reversed || !this.horiz && this.reversed ? A.setRange(S, w) : A.setRange(1 - w, 1 - S);
          }
        }
        m.compose = function(f, S) {
          u(s, "Axis.Scrollbar") && (h = S, l(f, "afterGetOffset", g), l(f, "afterInit", v), l(f, "afterRender", P));
        };
      }(r || (r = {})), r;
    }), i(n, "Stock/Scrollbar/ScrollbarDefaults.js", [], function() {
      return { height: 10, barBorderRadius: 5, buttonBorderRadius: 0, buttonsEnabled: !1, liveRedraw: void 0, margin: void 0, minWidth: 6, opposite: !0, step: 0.2, zIndex: 3, barBackgroundColor: "#cccccc", barBorderWidth: 0, barBorderColor: "#cccccc", buttonArrowColor: "#333333", buttonBackgroundColor: "#e6e6e6", buttonBorderColor: "#cccccc", buttonBorderWidth: 1, rifleColor: "none", trackBackgroundColor: "rgba(255, 255, 255, 0.001)", trackBorderColor: "#cccccc", trackBorderRadius: 5, trackBorderWidth: 1 };
    }), i(n, "Stock/Scrollbar/Scrollbar.js", [n["Core/Defaults.js"], n["Core/Globals.js"], n["Core/Axis/ScrollbarAxis.js"], n["Stock/Scrollbar/ScrollbarDefaults.js"], n["Core/Utilities.js"]], function(o, a, r, s, l) {
      let { defaultOptions: d } = o, { addEvent: y, correctFloat: u, crisp: m, defined: h, destroyObjectProperties: c, fireEvent: g, merge: v, pick: P, removeEvent: f } = l;
      class S {
        static compose(x) {
          r.compose(x, S);
        }
        static swapXY(x, k) {
          return k && x.forEach((A) => {
            let $, j = A.length;
            for (let N = 0; N < j; N += 2)
              typeof ($ = A[N + 1]) == "number" && (A[N + 1] = A[N + 2], A[N + 2] = $);
          }), x;
        }
        constructor(x, k, A) {
          this._events = [], this.chartX = 0, this.chartY = 0, this.from = 0, this.scrollbarButtons = [], this.scrollbarLeft = 0, this.scrollbarStrokeWidth = 1, this.scrollbarTop = 0, this.size = 0, this.to = 0, this.trackBorderWidth = 1, this.x = 0, this.y = 0, this.init(x, k, A);
        }
        addEvents() {
          let x = this.options.inverted ? [1, 0] : [0, 1], k = this.scrollbarButtons, A = this.scrollbarGroup.element, $ = this.track.element, j = this.mouseDownHandler.bind(this), N = this.mouseMoveHandler.bind(this), M = this.mouseUpHandler.bind(this), D = [[k[x[0]].element, "click", this.buttonToMinClick.bind(this)], [k[x[1]].element, "click", this.buttonToMaxClick.bind(this)], [$, "click", this.trackClick.bind(this)], [A, "mousedown", j], [A.ownerDocument, "mousemove", N], [A.ownerDocument, "mouseup", M], [A, "touchstart", j], [A.ownerDocument, "touchmove", N], [A.ownerDocument, "touchend", M]];
          D.forEach(function(C) {
            y.apply(null, C);
          }), this._events = D;
        }
        buttonToMaxClick(x) {
          let k = (this.to - this.from) * P(this.options.step, 0.2);
          this.updatePosition(this.from + k, this.to + k), g(this, "changed", { from: this.from, to: this.to, trigger: "scrollbar", DOMEvent: x });
        }
        buttonToMinClick(x) {
          let k = u(this.to - this.from) * P(this.options.step, 0.2);
          this.updatePosition(u(this.from - k), u(this.to - k)), g(this, "changed", { from: this.from, to: this.to, trigger: "scrollbar", DOMEvent: x });
        }
        cursorToScrollbarPosition(x) {
          let k = this.options, A = k.minWidth > this.calculatedWidth ? k.minWidth : 0;
          return { chartX: (x.chartX - this.x - this.xOffset) / (this.barWidth - A), chartY: (x.chartY - this.y - this.yOffset) / (this.barWidth - A) };
        }
        destroy() {
          let x = this, k = x.chart.scroller;
          x.removeEvents(), ["track", "scrollbarRifles", "scrollbar", "scrollbarGroup", "group"].forEach(function(A) {
            x[A] && x[A].destroy && (x[A] = x[A].destroy());
          }), k && x === k.scrollbar && (k.scrollbar = null, c(k.scrollbarButtons));
        }
        drawScrollbarButton(x) {
          let k = this.renderer, A = this.scrollbarButtons, $ = this.options, j = this.size, N = k.g().add(this.group);
          if (A.push(N), $.buttonsEnabled) {
            let M = k.rect().addClass("highcharts-scrollbar-button").add(N);
            this.chart.styledMode || M.attr({ stroke: $.buttonBorderColor, "stroke-width": $.buttonBorderWidth, fill: $.buttonBackgroundColor }), M.attr(M.crisp({ x: -0.5, y: -0.5, width: j, height: j, r: $.buttonBorderRadius }, M.strokeWidth()));
            let D = k.path(S.swapXY([["M", j / 2 + (x ? -1 : 1), j / 2 - 3], ["L", j / 2 + (x ? -1 : 1), j / 2 + 3], ["L", j / 2 + (x ? 2 : -2), j / 2]], $.vertical)).addClass("highcharts-scrollbar-arrow").add(A[x]);
            this.chart.styledMode || D.attr({ fill: $.buttonArrowColor });
          }
        }
        init(x, k, A) {
          this.scrollbarButtons = [], this.renderer = x, this.userOptions = k, this.options = v(s, d.scrollbar, k), this.options.margin = P(this.options.margin, 10), this.chart = A, this.size = P(this.options.size, this.options.height), k.enabled && (this.render(), this.addEvents());
        }
        mouseDownHandler(x) {
          let k = this.chart.pointer?.normalize(x) || x, A = this.cursorToScrollbarPosition(k);
          this.chartX = A.chartX, this.chartY = A.chartY, this.initPositions = [this.from, this.to], this.grabbedCenter = !0;
        }
        mouseMoveHandler(x) {
          let k, A = this.chart.pointer?.normalize(x) || x, $ = this.options.vertical ? "chartY" : "chartX", j = this.initPositions || [];
          this.grabbedCenter && (!x.touches || x.touches[0][$] !== 0) && (k = this.cursorToScrollbarPosition(A)[$] - this[$], this.hasDragged = !0, this.updatePosition(j[0] + k, j[1] + k), this.hasDragged && g(this, "changed", { from: this.from, to: this.to, trigger: "scrollbar", DOMType: x.type, DOMEvent: x }));
        }
        mouseUpHandler(x) {
          this.hasDragged && g(this, "changed", { from: this.from, to: this.to, trigger: "scrollbar", DOMType: x.type, DOMEvent: x }), this.grabbedCenter = this.hasDragged = this.chartX = this.chartY = null;
        }
        position(x, k, A, $) {
          let { buttonsEnabled: j, margin: N = 0, vertical: M } = this.options, D = this.rendered ? "animate" : "attr", C = $, b = 0;
          this.group.show(), this.x = x, this.y = k + this.trackBorderWidth, this.width = A, this.height = $, this.xOffset = C, this.yOffset = b, M ? (this.width = this.yOffset = A = b = this.size, this.xOffset = C = 0, this.yOffset = b = j ? this.size : 0, this.barWidth = $ - (j ? 2 * A : 0), this.x = x += N) : (this.height = $ = this.size, this.xOffset = C = j ? this.size : 0, this.barWidth = A - (j ? 2 * $ : 0), this.y = this.y + N), this.group[D]({ translateX: x, translateY: this.y }), this.track[D]({ width: A, height: $ }), this.scrollbarButtons[1][D]({ translateX: M ? 0 : A - C, translateY: M ? $ - b : 0 });
        }
        removeEvents() {
          this._events.forEach(function(x) {
            f.apply(null, x);
          }), this._events.length = 0;
        }
        render() {
          let x = this.renderer, k = this.options, A = this.size, $ = this.chart.styledMode, j = x.g("scrollbar").attr({ zIndex: k.zIndex }).hide().add();
          this.group = j, this.track = x.rect().addClass("highcharts-scrollbar-track").attr({ r: k.trackBorderRadius || 0, height: A, width: A }).add(j), $ || this.track.attr({ fill: k.trackBackgroundColor, stroke: k.trackBorderColor, "stroke-width": k.trackBorderWidth });
          let N = this.trackBorderWidth = this.track.strokeWidth();
          this.track.attr({ x: -m(0, N), y: -m(0, N) }), this.scrollbarGroup = x.g().add(j), this.scrollbar = x.rect().addClass("highcharts-scrollbar-thumb").attr({ height: A - N, width: A - N, r: k.barBorderRadius || 0 }).add(this.scrollbarGroup), this.scrollbarRifles = x.path(S.swapXY([["M", -3, A / 4], ["L", -3, 2 * A / 3], ["M", 0, A / 4], ["L", 0, 2 * A / 3], ["M", 3, A / 4], ["L", 3, 2 * A / 3]], k.vertical)).addClass("highcharts-scrollbar-rifles").add(this.scrollbarGroup), $ || (this.scrollbar.attr({ fill: k.barBackgroundColor, stroke: k.barBorderColor, "stroke-width": k.barBorderWidth }), this.scrollbarRifles.attr({ stroke: k.rifleColor, "stroke-width": 1 })), this.scrollbarStrokeWidth = this.scrollbar.strokeWidth(), this.scrollbarGroup.translate(-m(0, this.scrollbarStrokeWidth), -m(0, this.scrollbarStrokeWidth)), this.drawScrollbarButton(0), this.drawScrollbarButton(1);
        }
        setRange(x, k) {
          let A, $, j = this.options, N = j.vertical, M = j.minWidth, D = this.barWidth, C = !this.rendered || this.hasDragged || this.chart.navigator && this.chart.navigator.hasDragged ? "attr" : "animate";
          if (!h(D))
            return;
          let b = D * Math.min(k, 1);
          A = Math.ceil(D * (x = Math.max(x, 0))), this.calculatedWidth = $ = u(b - A), $ < M && (A = (D - M + $) * x, $ = M);
          let p = Math.floor(A + this.xOffset + this.yOffset), L = $ / 2 - 0.5;
          this.from = x, this.to = k, N ? (this.scrollbarGroup[C]({ translateY: p }), this.scrollbar[C]({ height: $ }), this.scrollbarRifles[C]({ translateY: L }), this.scrollbarTop = p, this.scrollbarLeft = 0) : (this.scrollbarGroup[C]({ translateX: p }), this.scrollbar[C]({ width: $ }), this.scrollbarRifles[C]({ translateX: L }), this.scrollbarLeft = p, this.scrollbarTop = 0), $ <= 12 ? this.scrollbarRifles.hide() : this.scrollbarRifles.show(), j.showFull === !1 && (x <= 0 && k >= 1 ? this.group.hide() : this.group.show()), this.rendered = !0;
        }
        shouldUpdateExtremes(x) {
          return P(this.options.liveRedraw, a.svg && !a.isTouchDevice && !this.chart.boosted) || x === "mouseup" || x === "touchend" || !h(x);
        }
        trackClick(x) {
          let k = this.chart.pointer?.normalize(x) || x, A = this.to - this.from, $ = this.y + this.scrollbarTop, j = this.x + this.scrollbarLeft;
          this.options.vertical && k.chartY > $ || !this.options.vertical && k.chartX > j ? this.updatePosition(this.from + A, this.to + A) : this.updatePosition(this.from - A, this.to - A), g(this, "changed", { from: this.from, to: this.to, trigger: "scrollbar", DOMEvent: x });
        }
        update(x) {
          this.destroy(), this.init(this.chart.renderer, v(!0, this.options, x), this.chart);
        }
        updatePosition(x, k) {
          k > 1 && (x = u(1 - u(k - x)), k = 1), x < 0 && (k = u(k - x), x = 0), this.from = x, this.to = k;
        }
      }
      return S.defaultOptions = s, d.scrollbar = v(!0, S.defaultOptions, d.scrollbar), S;
    }), i(n, "Stock/Navigator/Navigator.js", [n["Core/Axis/Axis.js"], n["Stock/Navigator/ChartNavigatorComposition.js"], n["Core/Defaults.js"], n["Core/Globals.js"], n["Core/Axis/NavigatorAxisComposition.js"], n["Stock/Navigator/NavigatorComposition.js"], n["Stock/Scrollbar/Scrollbar.js"], n["Core/Renderer/SVG/SVGRenderer.js"], n["Core/Utilities.js"]], function(o, a, r, s, l, d, y, u, m) {
      let { defaultOptions: h } = r, { isTouchDevice: c } = s, { prototype: { symbols: g } } = u, { addEvent: v, clamp: P, correctFloat: f, defined: S, destroyObjectProperties: w, erase: x, extend: k, find: A, fireEvent: $, isArray: j, isNumber: N, merge: M, pick: D, removeEvent: C, splat: b } = m;
      function p(B, ...T) {
        let O = [].filter.call(T, N);
        if (O.length)
          return Math[B].apply(0, O);
      }
      class L {
        static compose(T, O, I) {
          a.compose(T, L), d.compose(T, O, I);
        }
        constructor(T) {
          this.isDirty = !1, this.scrollbarHeight = 0, this.init(T);
        }
        drawHandle(T, O, I, R) {
          let Y = this.navigatorOptions.handles.height;
          this.handles[O][R](I ? { translateX: Math.round(this.left + this.height / 2), translateY: Math.round(this.top + parseInt(T, 10) + 0.5 - Y) } : { translateX: Math.round(this.left + parseInt(T, 10)), translateY: Math.round(this.top + this.height / 2 - Y / 2 - 1) });
        }
        drawOutline(T, O, I, R) {
          let Y = this.navigatorOptions.maskInside, F = this.outline.strokeWidth(), U = F / 2, Q = F % 2 / 2, J = this.scrollButtonSize, ee = this.size, V = this.top, G = this.height, W = V - U, ae = V + G, z = this.left, q, Z;
          I ? (q = V + O + Q, O = V + T + Q, Z = [["M", z + G, V - J - Q], ["L", z + G, q], ["L", z, q], ["M", z, O], ["L", z + G, O], ["L", z + G, V + ee + J]], Y && Z.push(["M", z + G, q - U], ["L", z + G, O + U])) : (z -= J, T += z + J - Q, O += z + J - Q, Z = [["M", z, W], ["L", T, W], ["L", T, ae], ["M", O, ae], ["L", O, W], ["L", z + ee + 2 * J, W]], Y && Z.push(["M", T - U, W], ["L", O + U, W])), this.outline[R]({ d: Z });
        }
        drawMasks(T, O, I, R) {
          let Y, F, U, Q, J = this.left, ee = this.top, V = this.height;
          I ? (U = [J, J, J], Q = [ee, ee + T, ee + O], F = [V, V, V], Y = [T, O - T, this.size - O]) : (U = [J, J + T, J + O], Q = [ee, ee, ee], F = [T, O - T, this.size - O], Y = [V, V, V]), this.shades.forEach((G, W) => {
            G[R]({ x: U[W], y: Q[W], width: F[W], height: Y[W] });
          });
        }
        renderElements() {
          let T = this, O = T.navigatorOptions, I = O.maskInside, R = T.chart, Y = R.inverted, F = R.renderer, U = { cursor: Y ? "ns-resize" : "ew-resize" }, Q = T.navigatorGroup ?? (T.navigatorGroup = F.g("navigator").attr({ zIndex: 8, visibility: "hidden" }).add());
          if ([!I, I, !I].forEach((J, ee) => {
            let V = T.shades[ee] ?? (T.shades[ee] = F.rect().addClass("highcharts-navigator-mask" + (ee === 1 ? "-inside" : "-outside")).add(Q));
            R.styledMode || (V.attr({ fill: J ? O.maskFill : "rgba(0,0,0,0)" }), ee === 1 && V.css(U));
          }), T.outline || (T.outline = F.path().addClass("highcharts-navigator-outline").add(Q)), R.styledMode || T.outline.attr({ "stroke-width": O.outlineWidth, stroke: O.outlineColor }), O.handles?.enabled) {
            let J = O.handles, { height: ee, width: V } = J;
            [0, 1].forEach((G) => {
              let W = J.symbols[G];
              if (T.handles[G] && T.handles[G].symbolUrl === W) {
                if (!T.handles[G].isImg && T.handles[G].symbolName !== W) {
                  let ae = g[W].call(g, -V / 2 - 1, 0, V, ee);
                  T.handles[G].attr({ d: ae }), T.handles[G].symbolName = W;
                }
              } else
                T.handles[G]?.destroy(), T.handles[G] = F.symbol(W, -V / 2 - 1, 0, V, ee, J), T.handles[G].attr({ zIndex: 7 - G }).addClass("highcharts-navigator-handle highcharts-navigator-handle-" + ["left", "right"][G]).add(Q), T.addMouseEvents();
              R.inverted && T.handles[G].attr({ rotation: 90, rotationOriginX: Math.floor(-V / 2), rotationOriginY: (ee + V) / 2 }), R.styledMode || T.handles[G].attr({ fill: J.backgroundColor, stroke: J.borderColor, "stroke-width": J.lineWidth, width: J.width, height: J.height, x: -V / 2 - 1, y: 0 }).css(U);
            });
          }
        }
        update(T, O = !1) {
          let I = this.chart, R = I.options.chart.inverted !== I.scrollbar?.options.vertical;
          if (M(!0, I.options.navigator, T), this.navigatorOptions = I.options.navigator || {}, this.setOpposite(), S(T.enabled) || R)
            return this.destroy(), this.navigatorEnabled = T.enabled || this.navigatorEnabled, this.init(I);
          if (this.navigatorEnabled && (this.isDirty = !0, T.adaptToUpdatedData === !1 && this.baseSeries.forEach((Y) => {
            C(Y, "updatedData", this.updatedDataHandler);
          }, this), T.adaptToUpdatedData && this.baseSeries.forEach((Y) => {
            Y.eventsToUnbind.push(v(Y, "updatedData", this.updatedDataHandler));
          }, this), (T.series || T.baseSeries) && this.setBaseSeries(void 0, !1), T.height || T.xAxis || T.yAxis)) {
            this.height = T.height ?? this.height;
            let Y = this.getXAxisOffsets();
            this.xAxis.update({ ...T.xAxis, offsets: Y, [I.inverted ? "width" : "height"]: this.height, [I.inverted ? "height" : "width"]: void 0 }, !1), this.yAxis.update({ ...T.yAxis, [I.inverted ? "width" : "height"]: this.height }, !1);
          }
          O && I.redraw();
        }
        render(T, O, I, R) {
          let Y = this.chart, F = this.xAxis, U = F.pointRange || 0, Q = F.navigatorAxis.fake ? Y.xAxis[0] : F, J = this.navigatorEnabled, ee = this.rendered, V = Y.inverted, G = Y.xAxis[0].minRange, W = Y.xAxis[0].options.maxRange, ae = this.scrollButtonSize, z, q, Z, ne = this.scrollbarHeight, ie, re;
          if (this.hasDragged && !S(I))
            return;
          if (this.isDirty && this.renderElements(), T = f(T - U / 2), O = f(O + U / 2), !N(T) || !N(O)) {
            if (!ee)
              return;
            I = 0, R = D(F.width, Q.width);
          }
          this.left = D(F.left, Y.plotLeft + ae + (V ? Y.plotWidth : 0));
          let de = this.size = ie = D(F.len, (V ? Y.plotHeight : Y.plotWidth) - 2 * ae);
          z = V ? ne : ie + 2 * ae, I = D(I, F.toPixels(T, !0)), R = D(R, F.toPixels(O, !0)), N(I) && Math.abs(I) !== 1 / 0 || (I = 0, R = z);
          let me = F.toValue(I, !0), ce = F.toValue(R, !0), pe = Math.abs(f(ce - me));
          pe < G ? this.grabbedLeft ? I = F.toPixels(ce - G - U, !0) : this.grabbedRight && (R = F.toPixels(me + G + U, !0)) : S(W) && f(pe - U) > W && (this.grabbedLeft ? I = F.toPixels(ce - W - U, !0) : this.grabbedRight && (R = F.toPixels(me + W + U, !0))), this.zoomedMax = P(Math.max(I, R), 0, de), this.zoomedMin = P(this.fixedWidth ? this.zoomedMax - this.fixedWidth : Math.min(I, R), 0, de), this.range = this.zoomedMax - this.zoomedMin, de = Math.round(this.zoomedMax);
          let xe = Math.round(this.zoomedMin);
          J && (this.navigatorGroup.attr({ visibility: "inherit" }), re = ee && !this.hasDragged ? "animate" : "attr", this.drawMasks(xe, de, V, re), this.drawOutline(xe, de, V, re), this.navigatorOptions.handles.enabled && (this.drawHandle(xe, 0, V, re), this.drawHandle(de, 1, V, re))), this.scrollbar && (V ? (Z = this.top - ae, q = this.left - ne + (J || !Q.opposite ? 0 : (Q.titleOffset || 0) + Q.axisTitleMargin), ne = ie + 2 * ae) : (Z = this.top + (J ? this.height : -ne), q = this.left - ae), this.scrollbar.position(q, Z, z, ne), this.scrollbar.setRange(this.zoomedMin / (ie || 1), this.zoomedMax / (ie || 1))), this.rendered = !0, this.isDirty = !1, $(this, "afterRender");
        }
        addMouseEvents() {
          let T = this, O = T.chart, I = O.container, R = [], Y, F;
          T.mouseMoveHandler = Y = function(U) {
            T.onMouseMove(U);
          }, T.mouseUpHandler = F = function(U) {
            T.onMouseUp(U);
          }, (R = T.getPartsEvents("mousedown")).push(v(O.renderTo, "mousemove", Y), v(I.ownerDocument, "mouseup", F), v(O.renderTo, "touchmove", Y), v(I.ownerDocument, "touchend", F)), R.concat(T.getPartsEvents("touchstart")), T.eventsToUnbind = R, T.series && T.series[0] && R.push(v(T.series[0].xAxis, "foundExtremes", function() {
            O.navigator.modifyNavigatorAxisExtremes();
          }));
        }
        getPartsEvents(T) {
          let O = this, I = [];
          return ["shades", "handles"].forEach(function(R) {
            O[R].forEach(function(Y, F) {
              I.push(v(Y.element, T, function(U) {
                O[R + "Mousedown"](U, F);
              }));
            });
          }), I;
        }
        shadesMousedown(T, O) {
          T = this.chart.pointer?.normalize(T) || T;
          let I = this.chart, R = this.xAxis, Y = this.zoomedMin, F = this.size, U = this.range, Q = this.left, J = T.chartX, ee, V, G, W;
          I.inverted && (J = T.chartY, Q = this.top), O === 1 ? (this.grabbedCenter = J, this.fixedWidth = U, this.dragOffset = J - Y) : (W = J - Q - U / 2, O === 0 ? W = Math.max(0, W) : O === 2 && W + U >= F && (W = F - U, this.reversedExtremes ? (W -= U, V = this.getUnionExtremes().dataMin) : ee = this.getUnionExtremes().dataMax), W !== Y && (this.fixedWidth = U, S((G = R.navigatorAxis.toFixedRange(W, W + U, V, ee)).min) && $(this, "setRange", { min: Math.min(G.min, G.max), max: Math.max(G.min, G.max), redraw: !0, eventArguments: { trigger: "navigator" } })));
        }
        handlesMousedown(T, O) {
          T = this.chart.pointer?.normalize(T) || T;
          let I = this.chart, R = I.xAxis[0], Y = this.reversedExtremes;
          O === 0 ? (this.grabbedLeft = !0, this.otherHandlePos = this.zoomedMax, this.fixedExtreme = Y ? R.min : R.max) : (this.grabbedRight = !0, this.otherHandlePos = this.zoomedMin, this.fixedExtreme = Y ? R.max : R.min), I.setFixedRange(void 0);
        }
        onMouseMove(T) {
          let O = this, I = O.chart, R = O.navigatorSize, Y = O.range, F = O.dragOffset, U = I.inverted, Q = O.left, J;
          (!T.touches || T.touches[0].pageX !== 0) && (J = (T = I.pointer?.normalize(T) || T).chartX, U && (Q = O.top, J = T.chartY), O.grabbedLeft ? (O.hasDragged = !0, O.render(0, 0, J - Q, O.otherHandlePos)) : O.grabbedRight ? (O.hasDragged = !0, O.render(0, 0, O.otherHandlePos, J - Q)) : O.grabbedCenter && (O.hasDragged = !0, J < F ? J = F : J > R + F - Y && (J = R + F - Y), O.render(0, 0, J - F, J - F + Y)), O.hasDragged && O.scrollbar && D(O.scrollbar.options.liveRedraw, !c && !this.chart.boosted) && (T.DOMType = T.type, setTimeout(function() {
            O.onMouseUp(T);
          }, 0)));
        }
        onMouseUp(T) {
          let O, I, R, Y, F, U, Q = this.chart, J = this.xAxis, ee = this.scrollbar, V = T.DOMEvent || T, G = Q.inverted, W = this.rendered && !this.hasDragged ? "animate" : "attr";
          (this.hasDragged && (!ee || !ee.hasDragged) || T.trigger === "scrollbar") && (R = this.getUnionExtremes(), this.zoomedMin === this.otherHandlePos ? Y = this.fixedExtreme : this.zoomedMax === this.otherHandlePos && (F = this.fixedExtreme), this.zoomedMax === this.size && (F = this.reversedExtremes ? R.dataMin : R.dataMax), this.zoomedMin === 0 && (Y = this.reversedExtremes ? R.dataMax : R.dataMin), S((U = J.navigatorAxis.toFixedRange(this.zoomedMin, this.zoomedMax, Y, F)).min) && $(this, "setRange", { min: Math.min(U.min, U.max), max: Math.max(U.min, U.max), redraw: !0, animation: !this.hasDragged && null, eventArguments: { trigger: "navigator", triggerOp: "navigator-drag", DOMEvent: V } })), T.DOMType !== "mousemove" && T.DOMType !== "touchmove" && (this.grabbedLeft = this.grabbedRight = this.grabbedCenter = this.fixedWidth = this.fixedExtreme = this.otherHandlePos = this.hasDragged = this.dragOffset = null), this.navigatorEnabled && N(this.zoomedMin) && N(this.zoomedMax) && (I = Math.round(this.zoomedMin), O = Math.round(this.zoomedMax), this.shades && this.drawMasks(I, O, G, W), this.outline && this.drawOutline(I, O, G, W), this.navigatorOptions.handles.enabled && Object.keys(this.handles).length === this.handles.length && (this.drawHandle(I, 0, G, W), this.drawHandle(O, 1, G, W)));
        }
        removeEvents() {
          this.eventsToUnbind && (this.eventsToUnbind.forEach(function(T) {
            T();
          }), this.eventsToUnbind = void 0), this.removeBaseSeriesEvents();
        }
        removeBaseSeriesEvents() {
          let T = this.baseSeries || [];
          this.navigatorEnabled && T[0] && (this.navigatorOptions.adaptToUpdatedData !== !1 && T.forEach(function(O) {
            C(O, "updatedData", this.updatedDataHandler);
          }, this), T[0].xAxis && C(T[0].xAxis, "foundExtremes", this.modifyBaseAxisExtremes));
        }
        getXAxisOffsets() {
          return this.chart.inverted ? [this.scrollButtonSize, 0, -this.scrollButtonSize, 0] : [0, -this.scrollButtonSize, 0, this.scrollButtonSize];
        }
        init(T) {
          let O = T.options, I = O.navigator || {}, R = I.enabled, Y = O.scrollbar || {}, F = Y.enabled, U = R && I.height || 0, Q = F && Y.height || 0, J = Y.buttonsEnabled && Q || 0;
          this.handles = [], this.shades = [], this.chart = T, this.setBaseSeries(), this.height = U, this.scrollbarHeight = Q, this.scrollButtonSize = J, this.scrollbarEnabled = F, this.navigatorEnabled = R, this.navigatorOptions = I, this.scrollbarOptions = Y, this.setOpposite();
          let ee = this, V = ee.baseSeries, G = T.xAxis.length, W = T.yAxis.length, ae = V && V[0] && V[0].xAxis || T.xAxis[0] || { options: {} };
          if (T.isDirtyBox = !0, ee.navigatorEnabled) {
            let z = this.getXAxisOffsets();
            ee.xAxis = new o(T, M({ breaks: ae.options.breaks, ordinal: ae.options.ordinal, overscroll: ae.options.overscroll }, I.xAxis, { type: "datetime", yAxis: I.yAxis?.id, index: G, isInternal: !0, offset: 0, keepOrdinalPadding: !0, startOnTick: !1, endOnTick: !1, minPadding: ae.options.ordinal ? 0 : ae.options.minPadding, maxPadding: ae.options.ordinal ? 0 : ae.options.maxPadding, zoomEnabled: !1 }, T.inverted ? { offsets: z, width: U } : { offsets: z, height: U }), "xAxis"), ee.yAxis = new o(T, M(I.yAxis, { alignTicks: !1, offset: 0, index: W, isInternal: !0, reversed: D(I.yAxis && I.yAxis.reversed, T.yAxis[0] && T.yAxis[0].reversed, !1), zoomEnabled: !1 }, T.inverted ? { width: U } : { height: U }), "yAxis"), V || I.series.data ? ee.updateNavigatorSeries(!1) : T.series.length === 0 && (ee.unbindRedraw = v(T, "beforeRedraw", function() {
              T.series.length > 0 && !ee.series && (ee.setBaseSeries(), ee.unbindRedraw());
            })), ee.reversedExtremes = T.inverted && !ee.xAxis.reversed || !T.inverted && ee.xAxis.reversed, ee.renderElements(), ee.addMouseEvents();
          } else
            ee.xAxis = { chart: T, navigatorAxis: { fake: !0 }, translate: function(z, q) {
              let Z = T.xAxis[0], ne = Z.getExtremes(), ie = Z.len - 2 * J, re = p("min", Z.options.min, ne.dataMin), de = p("max", Z.options.max, ne.dataMax) - re;
              return q ? z * de / ie + re : ie * (z - re) / de;
            }, toPixels: function(z) {
              return this.translate(z);
            }, toValue: function(z) {
              return this.translate(z, !0);
            } }, ee.xAxis.navigatorAxis.axis = ee.xAxis, ee.xAxis.navigatorAxis.toFixedRange = l.prototype.toFixedRange.bind(ee.xAxis.navigatorAxis);
          if (T.options.scrollbar.enabled) {
            let z = M(T.options.scrollbar, { vertical: T.inverted });
            !N(z.margin) && ee.navigatorEnabled && (z.margin = T.inverted ? -3 : 3), T.scrollbar = ee.scrollbar = new y(T.renderer, z, T), v(ee.scrollbar, "changed", function(q) {
              let Z = ee.size, ne = Z * this.to, ie = Z * this.from;
              ee.hasDragged = ee.scrollbar.hasDragged, ee.render(0, 0, ie, ne), this.shouldUpdateExtremes(q.DOMType) && setTimeout(function() {
                ee.onMouseUp(q);
              });
            });
          }
          ee.addBaseSeriesEvents(), ee.addChartEvents();
        }
        setOpposite() {
          let T = this.navigatorOptions, O = this.navigatorEnabled, I = this.chart;
          this.opposite = D(T.opposite, !!(!O && I.inverted));
        }
        getUnionExtremes(T) {
          let O, I = this.chart.xAxis[0], R = this.xAxis, Y = R.options, F = I.options;
          return T && I.dataMin === null || (O = { dataMin: D(Y && Y.min, p("min", F.min, I.dataMin, R.dataMin, R.min)), dataMax: D(Y && Y.max, p("max", F.max, I.dataMax, R.dataMax, R.max)) }), O;
        }
        setBaseSeries(T, O) {
          let I = this.chart, R = this.baseSeries = [];
          T = T || I.options && I.options.navigator.baseSeries || (I.series.length ? A(I.series, (Y) => !Y.options.isInternal).index : 0), (I.series || []).forEach((Y, F) => {
            !Y.options.isInternal && (Y.options.showInNavigator || (F === T || Y.options.id === T) && Y.options.showInNavigator !== !1) && R.push(Y);
          }), this.xAxis && !this.xAxis.navigatorAxis.fake && this.updateNavigatorSeries(!0, O);
        }
        updateNavigatorSeries(T, O) {
          let I = this, R = I.chart, Y = I.baseSeries, F = { enableMouseTracking: !1, index: null, linkedTo: null, group: "nav", padXAxis: !1, xAxis: this.navigatorOptions.xAxis?.id, yAxis: this.navigatorOptions.yAxis?.id, showInLegend: !1, stacking: void 0, isInternal: !0, states: { inactive: { opacity: 1 } } }, U = I.series = (I.series || []).filter((G) => {
            let W = G.baseSeries;
            return !(0 > Y.indexOf(W)) || (W && (C(W, "updatedData", I.updatedDataHandler), delete W.navigatorSeries), G.chart && G.destroy(), !1);
          }), Q, J, ee = I.navigatorOptions.series, V;
          Y && Y.length && Y.forEach((G) => {
            let W = G.navigatorSeries, ae = k({ color: G.color, visible: G.visible }, j(ee) ? h.navigator.series : ee);
            if (W && I.navigatorOptions.adaptToUpdatedData === !1)
              return;
            F.name = "Navigator " + Y.length, V = (Q = G.options || {}).navigatorOptions || {}, ae.dataLabels = b(ae.dataLabels), (J = M(Q, F, ae, V)).pointRange = D(ae.pointRange, V.pointRange, h.plotOptions[J.type || "line"].pointRange);
            let z = V.data || ae.data;
            I.hasNavigatorData = I.hasNavigatorData || !!z, J.data = z || Q.data && Q.data.slice(0), W && W.options ? W.update(J, O) : (G.navigatorSeries = R.initSeries(J), R.setSortedData(), G.navigatorSeries.baseSeries = G, U.push(G.navigatorSeries));
          }), (ee.data && !(Y && Y.length) || j(ee)) && (I.hasNavigatorData = !1, (ee = b(ee)).forEach((G, W) => {
            F.name = "Navigator " + (U.length + 1), (J = M(h.navigator.series, { color: R.series[W] && !R.series[W].options.isInternal && R.series[W].color || R.options.colors[W] || R.options.colors[0] }, F, G)).data = G.data, J.data && (I.hasNavigatorData = !0, U.push(R.initSeries(J)));
          })), T && this.addBaseSeriesEvents();
        }
        addBaseSeriesEvents() {
          let T = this, O = T.baseSeries || [];
          O[0] && O[0].xAxis && O[0].eventsToUnbind.push(v(O[0].xAxis, "foundExtremes", this.modifyBaseAxisExtremes)), O.forEach((I) => {
            I.eventsToUnbind.push(v(I, "show", function() {
              this.navigatorSeries && this.navigatorSeries.setVisible(!0, !1);
            })), I.eventsToUnbind.push(v(I, "hide", function() {
              this.navigatorSeries && this.navigatorSeries.setVisible(!1, !1);
            })), this.navigatorOptions.adaptToUpdatedData !== !1 && I.xAxis && I.eventsToUnbind.push(v(I, "updatedData", this.updatedDataHandler)), I.eventsToUnbind.push(v(I, "remove", function() {
              O && x(O, I), this.navigatorSeries && (x(T.series, this.navigatorSeries), S(this.navigatorSeries.options) && this.navigatorSeries.remove(!1), delete this.navigatorSeries);
            }));
          });
        }
        getBaseSeriesMin(T) {
          return this.baseSeries.reduce(function(O, I) {
            return Math.min(O, I.xData && I.xData.length ? I.xData[0] : O);
          }, T);
        }
        modifyNavigatorAxisExtremes() {
          let T = this.xAxis;
          if (T.getExtremes !== void 0) {
            let O = this.getUnionExtremes(!0);
            O && (O.dataMin !== T.min || O.dataMax !== T.max) && (T.min = O.dataMin, T.max = O.dataMax);
          }
        }
        modifyBaseAxisExtremes() {
          let T, O, I = this.chart.navigator, R = this.getExtremes(), Y = R.min, F = R.max, U = R.dataMin, Q = R.dataMax, J = F - Y, ee = I.stickToMin, V = I.stickToMax, G = D(this.ordinal?.convertOverscroll(this.options.overscroll), 0), W = I.series && I.series[0], ae = !!this.setExtremes;
          !(this.eventArgs && this.eventArgs.trigger === "rangeSelectorButton") && (ee && (T = (O = U) + J), V && (T = Q + G, ee || (O = Math.max(U, T - J, I.getBaseSeriesMin(W && W.xData ? W.xData[0] : -Number.MAX_VALUE)))), ae && (ee || V) && N(O) && (this.min = this.userMin = O, this.max = this.userMax = T)), I.stickToMin = I.stickToMax = null;
        }
        updatedDataHandler() {
          let T = this.chart.navigator, O = this.navigatorSeries, I = T.reversedExtremes ? Math.round(T.zoomedMin) === 0 : Math.round(T.zoomedMax) >= Math.round(T.size);
          T.stickToMax = D(this.chart.options.navigator && this.chart.options.navigator.stickToMax, I), T.stickToMin = T.shouldStickToMin(this, T), O && !T.hasNavigatorData && (O.options.pointStart = this.xData[0], O.setData(this.options.data, !1, null, !1));
        }
        shouldStickToMin(T, O) {
          let I = O.getBaseSeriesMin(T.xData[0]), R = T.xAxis, Y = R.max, F = R.min, U = R.options.range;
          return !!(N(Y) && N(F)) && (U && Y - I > 0 ? Y - I < U : F <= I);
        }
        addChartEvents() {
          this.eventsToUnbind || (this.eventsToUnbind = []), this.eventsToUnbind.push(v(this.chart, "redraw", function() {
            let T = this.navigator, O = T && (T.baseSeries && T.baseSeries[0] && T.baseSeries[0].xAxis || this.xAxis[0]);
            O && T.render(O.min, O.max);
          }), v(this.chart, "getMargins", function() {
            let T = this.navigator, O = T.opposite ? "plotTop" : "marginBottom";
            this.inverted && (O = T.opposite ? "marginRight" : "plotLeft"), this[O] = (this[O] || 0) + (T.navigatorEnabled || !this.inverted ? T.height + T.scrollbarHeight : 0) + T.navigatorOptions.margin;
          }), v(L, "setRange", function(T) {
            this.chart.xAxis[0].setExtremes(T.min, T.max, T.redraw, T.animation, T.eventArguments);
          }));
        }
        destroy() {
          this.removeEvents(), this.xAxis && (x(this.chart.xAxis, this.xAxis), x(this.chart.axes, this.xAxis)), this.yAxis && (x(this.chart.yAxis, this.yAxis), x(this.chart.axes, this.yAxis)), (this.series || []).forEach((T) => {
            T.destroy && T.destroy();
          }), ["series", "xAxis", "yAxis", "shades", "outline", "scrollbarTrack", "scrollbarRifles", "scrollbarGroup", "scrollbar", "navigatorGroup", "rendered"].forEach((T) => {
            this[T] && this[T].destroy && this[T].destroy(), this[T] = null;
          }), [this.handles].forEach((T) => {
            w(T);
          }), this.navigatorEnabled = !1;
        }
      }
      return L;
    }), i(n, "Core/Axis/OrdinalAxis.js", [n["Core/Axis/Axis.js"], n["Core/Globals.js"], n["Core/Series/Series.js"], n["Core/Utilities.js"]], function(o, a, r, s) {
      var l;
      let { addEvent: d, correctFloat: y, css: u, defined: m, error: h, isNumber: c, pick: g, timeUnits: v, isString: P } = s;
      return function(f) {
        function S(p, L, B, T, O = [], I = 0, R) {
          let Y = {}, F = this.options.tickPixelInterval, U = this.chart.time, Q = [], J, ee, V, G, W, ae = 0, z = [], q = -Number.MAX_VALUE;
          if (!this.options.ordinal && !this.options.breaks || !O || O.length < 3 || L === void 0)
            return U.getTimeTicks.apply(U, arguments);
          let Z = O.length;
          for (J = 0; J < Z; J++) {
            if (W = J && O[J - 1] > B, O[J] < L && (ae = J), J === Z - 1 || O[J + 1] - O[J] > 5 * I || W) {
              if (O[J] > q) {
                for (ee = U.getTimeTicks(p, O[ae], O[J], T); ee.length && ee[0] <= q; )
                  ee.shift();
                ee.length && (q = ee[ee.length - 1]), Q.push(z.length), z = z.concat(ee);
              }
              ae = J + 1;
            }
            if (W)
              break;
          }
          if (ee) {
            if (G = ee.info, R && G.unitRange <= v.hour) {
              for (ae = 1, J = z.length - 1; ae < J; ae++)
                U.dateFormat("%d", z[ae]) !== U.dateFormat("%d", z[ae - 1]) && (Y[z[ae]] = "day", V = !0);
              V && (Y[z[0]] = "day"), G.higherRanks = Y;
            }
            G.segmentStarts = Q, z.info = G;
          } else
            h(12, !1, this.chart);
          if (R && m(F)) {
            let ne = z.length, ie = [], re = [], de, me, ce, pe, xe, le = ne;
            for (; le--; )
              me = this.translate(z[le]), ce && (re[le] = ce - me), ie[le] = ce = me;
            for (re.sort((se, he) => se - he), (pe = re[Math.floor(re.length / 2)]) < 0.6 * F && (pe = null), le = z[ne - 1] > B ? ne - 1 : ne, ce = void 0; le--; )
              xe = Math.abs(ce - (me = ie[le])), ce && xe < 0.8 * F && (pe === null || xe < 0.8 * pe) ? (Y[z[le]] && !Y[z[le + 1]] ? (de = le + 1, ce = me) : de = le, z.splice(de, 1)) : ce = me;
          }
          return z;
        }
        function w(p) {
          let L = this.ordinal.positions;
          if (!L)
            return p;
          let B = L.length - 1, T;
          return p < 0 ? p = L[0] : p > B ? p = L[B] : (B = Math.floor(p), T = p - B), T !== void 0 && L[B] !== void 0 ? L[B] + (T ? T * (L[B + 1] - L[B]) : 0) : p;
        }
        function x(p) {
          let L = this.ordinal, B = this.old ? this.old.min : this.min, T = this.old ? this.old.transA : this.transA, O = L.getExtendedPositions();
          if (O && O.length) {
            let I = y((p - B) * T + this.minPixelPadding), R = y(L.getIndexOfPoint(I, O)), Y = y(R % 1);
            if (R >= 0 && R <= O.length - 1) {
              let F = O[Math.floor(R)], U = O[Math.ceil(R)];
              return O[Math.floor(R)] + Y * (U - F);
            }
          }
          return p;
        }
        function k(p, L) {
          let B = f.Additions.findIndexOf(p, L, !0);
          if (p[B] === L)
            return B;
          let T = (L - p[B]) / (p[B + 1] - p[B]);
          return B + T;
        }
        function A() {
          this.ordinal || (this.ordinal = new f.Additions(this));
        }
        function $() {
          let { eventArgs: p, options: L } = this;
          if (this.isXAxis && m(L.overscroll) && L.overscroll !== 0 && c(this.max) && c(this.min) && (this.options.ordinal && !this.ordinal.originalOrdinalRange && this.ordinal.getExtendedPositions(!1), this.max === this.dataMax && (p?.trigger !== "pan" || this.isInternal) && p?.trigger !== "navigator")) {
            let B = this.ordinal.convertOverscroll(L.overscroll);
            this.max += B, !this.isInternal && m(this.userMin) && p?.trigger !== "mousewheel" && (this.min += B);
          }
        }
        function j() {
          this.horiz && !this.isDirty && (this.isDirty = this.isOrdinal && this.chart.navigator && !this.chart.navigator.adaptToUpdatedData);
        }
        function N() {
          this.ordinal && (this.ordinal.beforeSetTickPositions(), this.tickInterval = this.ordinal.postProcessTickInterval(this.tickInterval));
        }
        function M(p) {
          let L = this.xAxis[0], B = L.ordinal.convertOverscroll(L.options.overscroll), T = p.originalEvent.chartX, O = this.options.chart.panning, I = !1;
          if (O && O.type !== "y" && L.options.ordinal && L.series.length && (!p.touches || p.touches.length <= 1)) {
            let R, Y, F = this.mouseDownX, U = L.getExtremes(), Q = U.dataMin, J = U.dataMax, ee = U.min, V = U.max, G = this.hoverPoints, W = L.closestPointRange || L.ordinal && L.ordinal.overscrollPointsRange, ae = Math.round((F - T) / (L.translationSlope * (L.ordinal.slope || W))), z = L.ordinal.getExtendedPositions(), q = { ordinal: { positions: z, extendedOrdinalPositions: z } }, Z = L.index2val, ne = L.val2lin;
            if (ee <= Q && ae < 0 || V + B >= J && ae > 0)
              return;
            q.ordinal.positions ? Math.abs(ae) > 1 && (G && G.forEach(function(ie) {
              ie.setState();
            }), J > (Y = q.ordinal.positions)[Y.length - 1] && Y.push(J), this.setFixedRange(V - ee), (R = L.navigatorAxis.toFixedRange(void 0, void 0, Z.apply(q, [ne.apply(q, [ee, !0]) + ae]), Z.apply(q, [ne.apply(q, [V, !0]) + ae]))).min >= Math.min(U.dataMin, ee) && R.max <= Math.max(J, V) + B && L.setExtremes(R.min, R.max, !0, !1, { trigger: "pan" }), this.mouseDownX = T, u(this.container, { cursor: "move" })) : I = !0;
          } else
            I = !0;
          I || O && /y/.test(O.type) ? B && (L.max = L.dataMax + B) : p.preventDefault();
        }
        function D() {
          let p = this.xAxis;
          p && p.options.ordinal && (delete p.ordinal.index, delete p.ordinal.originalOrdinalRange);
        }
        function C(p, L) {
          let B, T = this.ordinal, O = T.positions, I = T.slope, R;
          if (!O)
            return p;
          let Y = O.length;
          if (O[0] <= p && O[Y - 1] >= p)
            B = k(O, p);
          else {
            if (!((R = T.getExtendedPositions && T.getExtendedPositions()) && R.length))
              return p;
            let F = R.length;
            I || (I = (R[F - 1] - R[0]) / F);
            let U = k(R, O[0]);
            if (p >= R[0] && p <= R[F - 1])
              B = k(R, p) - U;
            else {
              if (!L)
                return p;
              B = p < R[0] ? -U - (R[0] - p) / I : (p - R[F - 1]) / I + F - U;
            }
          }
          return L ? B : I * (B || 0) + T.offset;
        }
        f.compose = function(p, L, B) {
          let T = p.prototype;
          return T.ordinal2lin || (T.getTimeTicks = S, T.index2val = w, T.lin2val = x, T.val2lin = C, T.ordinal2lin = T.val2lin, d(p, "afterInit", A), d(p, "foundExtremes", $), d(p, "afterSetScale", j), d(p, "initialAxisTranslation", N), d(B, "pan", M), d(B, "touchpan", M), d(L, "updatedData", D)), p;
        };
        class b {
          constructor(L) {
            this.index = {}, this.axis = L;
          }
          beforeSetTickPositions() {
            let L = this.axis, B = L.ordinal, T = L.getExtremes(), O = T.min, I = T.max, R = L.brokenAxis?.hasBreaks, Y = L.options.ordinal, F, U, Q, J, ee, V, G, W = [], ae = Number.MAX_VALUE, z = !1, q = !1, Z = !1;
            if (Y || R) {
              let ne = 0;
              if (L.series.forEach(function(ie, re) {
                if (U = [], re > 0 && ie.options.id !== "highcharts-navigator-series" && ie.processedXData.length > 1 && (q = ne !== ie.processedXData[1] - ie.processedXData[0]), ne = ie.processedXData[1] - ie.processedXData[0], ie.boosted && (Z = ie.boosted), ie.reserveSpace() && (ie.takeOrdinalPosition !== !1 || R) && (F = (W = W.concat(ie.processedXData)).length, W.sort(function(de, me) {
                  return de - me;
                }), ae = Math.min(ae, g(ie.closestPointRange, ae)), F)) {
                  for (re = 0; re < F - 1; )
                    W[re] !== W[re + 1] && U.push(W[re + 1]), re++;
                  U[0] !== W[0] && U.unshift(W[0]), W = U;
                }
              }), L.ordinal.originalOrdinalRange || (L.ordinal.originalOrdinalRange = (W.length - 1) * ae), q && Z && (W.pop(), W.shift()), (F = W.length) > 2) {
                for (Q = W[1] - W[0], G = F - 1; G-- && !z; )
                  W[G + 1] - W[G] !== Q && (z = !0);
                !L.options.keepOrdinalPadding && (W[0] - O > Q || I - W[W.length - 1] > Q) && (z = !0);
              } else
                L.options.overscroll && (F === 2 ? ae = W[1] - W[0] : F === 1 ? (ae = L.ordinal.convertOverscroll(L.options.overscroll), W = [W[0], W[0] + ae]) : ae = B.overscrollPointsRange);
              z || L.forceOrdinal ? (L.options.overscroll && (B.overscrollPointsRange = ae, W = W.concat(B.getOverscrollPositions())), B.positions = W, J = L.ordinal2lin(Math.max(O, W[0]), !0), ee = Math.max(L.ordinal2lin(Math.min(I, W[W.length - 1]), !0), 1), B.slope = V = (I - O) / (ee - J), B.offset = O - J * V) : (B.overscrollPointsRange = g(L.closestPointRange, B.overscrollPointsRange), B.positions = L.ordinal.slope = B.offset = void 0);
            }
            L.isOrdinal = Y && z, B.groupIntervalFactor = null;
          }
          static findIndexOf(L, B, T) {
            let O = 0, I = L.length - 1, R;
            for (; O < I; )
              L[R = Math.ceil((O + I) / 2)] <= B ? O = R : I = R - 1;
            return L[O] === B || T ? O : -1;
          }
          getExtendedPositions(L = !0) {
            let B = this, T = B.axis, O = T.constructor.prototype, I = T.chart, R = T.series[0]?.currentDataGrouping, Y = R ? R.count + R.unitName : "raw", F = L ? T.ordinal.convertOverscroll(T.options.overscroll) : 0, U = T.getExtremes(), Q, J, ee = B.index;
            return ee || (ee = B.index = {}), ee[Y] || ((Q = { series: [], chart: I, forceOrdinal: !1, getExtremes: function() {
              return { min: U.dataMin, max: U.dataMax + F };
            }, applyGrouping: O.applyGrouping, getGroupPixelWidth: O.getGroupPixelWidth, getTimeTicks: O.getTimeTicks, options: { ordinal: !0 }, ordinal: { getGroupIntervalFactor: this.getGroupIntervalFactor }, ordinal2lin: O.ordinal2lin, getIndexOfPoint: O.getIndexOfPoint, val2lin: O.val2lin }).ordinal.axis = Q, T.series.forEach(function(V) {
              J = { xAxis: Q, xData: V.xData.slice(), chart: I, groupPixelWidth: V.groupPixelWidth, destroyGroupedData: a.noop, getProcessedData: r.prototype.getProcessedData, applyGrouping: r.prototype.applyGrouping, reserveSpace: r.prototype.reserveSpace, visible: V.visible }, L && (J.xData = J.xData.concat(B.getOverscrollPositions())), J.options = { dataGrouping: R ? { firstAnchor: V.options.dataGrouping?.firstAnchor, anchor: V.options.dataGrouping?.anchor, lastAnchor: V.options.dataGrouping?.firstAnchor, enabled: !0, forced: !0, approximation: "open", units: [[R.unitName, [R.count]]] } : { enabled: !1 } }, Q.series.push(J), V.processData.apply(J);
            }), Q.applyGrouping({ hasExtremesChanged: !0 }), J?.closestPointRange !== J?.basePointRange && J.currentDataGrouping && (Q.forceOrdinal = !0), T.ordinal.beforeSetTickPositions.apply({ axis: Q }), !T.ordinal.originalOrdinalRange && Q.ordinal.originalOrdinalRange && (T.ordinal.originalOrdinalRange = Q.ordinal.originalOrdinalRange), ee[Y] = Q.ordinal.positions), ee[Y];
          }
          getGroupIntervalFactor(L, B, T) {
            let O = T.processedXData, I = O.length, R = [], Y, F, U = this.groupIntervalFactor;
            if (!U) {
              for (F = 0; F < I - 1; F++)
                R[F] = O[F + 1] - O[F];
              R.sort(function(Q, J) {
                return Q - J;
              }), Y = R[Math.floor(I / 2)], L = Math.max(L, O[0]), B = Math.min(B, O[I - 1]), this.groupIntervalFactor = U = I * Y / (B - L);
            }
            return U;
          }
          getIndexOfPoint(L, B) {
            let T, O = this.axis, I = 0, R = function(U) {
              let { min: Q, max: J } = O;
              return !!(m(Q) && m(J)) && U.points.some((ee) => ee.x >= Q && ee.x <= J);
            };
            O.series.forEach((U) => {
              let Q = U.points?.[0];
              m(Q?.plotX) && (Q.plotX < T || !m(T)) && R(U) && (T = Q.plotX, I = Q.x);
            }), T ?? (T = O.minPixelPadding);
            let Y = O.translationSlope * (this.slope || O.closestPointRange || this.overscrollPointsRange), F = y((L - T) / Y);
            return b.findIndexOf(B, I, !0) + F;
          }
          getOverscrollPositions() {
            let L = this.axis, B = this.convertOverscroll(L.options.overscroll), T = this.overscrollPointsRange, O = [], I = L.dataMax;
            if (m(T))
              for (; I <= L.dataMax + B; )
                O.push(I += T);
            return O;
          }
          postProcessTickInterval(L) {
            let B = this.axis, T = this.slope;
            return T ? B.options.breaks ? B.closestPointRange || L : L / (T / B.closestPointRange) : L;
          }
          convertOverscroll(L = 0) {
            let B = this, T = B.axis, O = function(I) {
              return g(B.originalOrdinalRange, m(T.dataMax) && m(T.dataMin) ? T.dataMax - T.dataMin : 0) * I;
            };
            if (P(L)) {
              let I = parseInt(L, 10);
              if (/%$/.test(L))
                return O(I / 100);
              if (/px/.test(L)) {
                let R = Math.min(I, 0.9 * T.len) / T.len;
                return O(R / (1 - R));
              }
              return 0;
            }
            return L;
          }
        }
        f.Additions = b;
      }(l || (l = {})), l;
    }), i(n, "Stock/RangeSelector/RangeSelectorDefaults.js", [], function() {
      return { lang: { rangeSelectorZoom: "Zoom", rangeSelectorFrom: "", rangeSelectorTo: "→" }, rangeSelector: { allButtonsEnabled: !1, buttons: void 0, buttonSpacing: 5, dropdown: "responsive", enabled: void 0, verticalAlign: "top", buttonTheme: { width: 28, height: 18, padding: 2, zIndex: 7 }, floating: !1, x: 0, y: 0, height: void 0, inputBoxBorderColor: "none", inputBoxHeight: 17, inputBoxWidth: void 0, inputDateFormat: "%e %b %Y", inputDateParser: void 0, inputEditDateFormat: "%Y-%m-%d", inputEnabled: !0, inputPosition: { align: "right", x: 0, y: 0 }, inputSpacing: 5, selected: void 0, buttonPosition: { align: "left", x: 0, y: 0 }, inputStyle: { color: "#334eff", cursor: "pointer", fontSize: "0.8em" }, labelStyle: { color: "#666666", fontSize: "0.8em" } } };
    }), i(n, "Stock/RangeSelector/RangeSelectorComposition.js", [n["Core/Defaults.js"], n["Core/Globals.js"], n["Stock/RangeSelector/RangeSelectorDefaults.js"], n["Core/Utilities.js"]], function(o, a, r, s) {
      let l, { defaultOptions: d } = o, { composed: y } = a, { addEvent: u, defined: m, extend: h, isNumber: c, merge: g, pick: v, pushUnique: P } = s, f = [];
      function S() {
        let N, M, D = this.range, C = D.type, b = this.max, p = this.chart.time, L = function(T, O) {
          let I = C === "year" ? "FullYear" : "Month", R = new p.Date(T), Y = p.get(I, R);
          return p.set(I, R, Y + O), Y === p.get(I, R) && p.set("Date", R, 0), R.getTime() - T;
        };
        c(D) ? (N = b - D, M = D) : D && (N = b + L(b, -(D.count || 1)), this.chart && this.chart.setFixedRange(b - N));
        let B = v(this.dataMin, Number.MIN_VALUE);
        return c(N) || (N = B), N <= B && (N = B, M === void 0 && (M = L(N, D.count)), this.newMax = Math.min(N + M, v(this.dataMax, Number.MAX_VALUE))), c(b) ? !c(D) && D && D._offsetMin && (N += D._offsetMin) : N = void 0, N;
      }
      function w() {
        this.options.rangeSelector && this.options.rangeSelector.enabled && (this.rangeSelector = new l(this));
      }
      function x() {
        let N = this.rangeSelector;
        if (N) {
          c(N.deferredYTDClick) && (N.clickButton(N.deferredYTDClick), delete N.deferredYTDClick);
          let M = N.options.verticalAlign;
          N.options.floating || (M === "bottom" ? this.extraBottomMargin = !0 : M === "middle" || (this.extraTopMargin = !0));
        }
      }
      function k() {
        let N, M = this.rangeSelector;
        if (!M)
          return;
        let D = this.xAxis[0].getExtremes(), C = this.legend, b = M && M.options.verticalAlign;
        c(D.min) && M.render(D.min, D.max), C.display && b === "top" && b === C.options.verticalAlign && (N = g(this.spacingBox), C.options.layout === "vertical" ? N.y = this.plotTop : N.y += M.getHeight(), C.group.placed = !1, C.align(N));
      }
      function A() {
        for (let N = 0, M = f.length; N < M; ++N) {
          let D = f[N];
          if (D[0] === this) {
            D[1].forEach((C) => C()), f.splice(N, 1);
            return;
          }
        }
      }
      function $() {
        let N = this.rangeSelector;
        if (N) {
          let M = N.getHeight();
          this.extraTopMargin && (this.plotTop += M), this.extraBottomMargin && (this.marginBottom += M);
        }
      }
      function j(N) {
        let M = N.options.rangeSelector, D = this.extraBottomMargin, C = this.extraTopMargin, b = this.rangeSelector;
        if (M && M.enabled && !m(b) && this.options.rangeSelector && (this.options.rangeSelector.enabled = !0, this.rangeSelector = b = new l(this)), this.extraBottomMargin = !1, this.extraTopMargin = !1, b) {
          let p = M && M.verticalAlign || b.options && b.options.verticalAlign;
          b.options.floating || (p === "bottom" ? this.extraBottomMargin = !0 : p === "middle" || (this.extraTopMargin = !0)), (this.extraBottomMargin !== D || this.extraTopMargin !== C) && (this.isDirtyBox = !0);
        }
      }
      return { compose: function(N, M, D) {
        if (l = D, P(y, "RangeSelector")) {
          let C = M.prototype;
          N.prototype.minFromRange = S, u(M, "afterGetContainer", w), u(M, "beforeRender", x), u(M, "destroy", A), u(M, "getMargins", $), u(M, "redraw", k), u(M, "update", j), C.callbacks.push(k), h(d, { rangeSelector: r.rangeSelector }), h(d.lang, r.lang);
        }
      } };
    }), i(n, "Stock/RangeSelector/RangeSelector.js", [n["Core/Axis/Axis.js"], n["Core/Defaults.js"], n["Core/Globals.js"], n["Stock/RangeSelector/RangeSelectorComposition.js"], n["Core/Renderer/SVG/SVGElement.js"], n["Core/Utilities.js"], n["Core/Axis/OrdinalAxis.js"]], function(o, a, r, s, l, d, y) {
      let { defaultOptions: u } = a, { addEvent: m, createElement: h, css: c, defined: g, destroyObjectProperties: v, discardElement: P, extend: f, fireEvent: S, isNumber: w, merge: x, objectEach: k, pad: A, pick: $, pInt: j, splat: N } = d;
      class M {
        static compose(C, b) {
          s.compose(C, b, M);
        }
        constructor(C) {
          this.buttonOptions = M.prototype.defaultButtons, this.initialButtonGroupWidth = 0, this.init(C);
        }
        clickButton(C, b) {
          let p = this.chart, L = this.buttonOptions[C], B = p.xAxis[0], T = p.scroller && p.scroller.getUnionExtremes() || B || {}, O = L.type, I = L.dataGrouping, R = T.dataMin, Y = T.dataMax, F, U = B && Math.round(Math.min(B.max, $(Y, B.max))), Q, J = L._range, ee, V, G, W = !0;
          if (R !== null && Y !== null) {
            if (this.setSelected(C), I && (this.forcedDataGrouping = !0, o.prototype.setDataGrouping.call(B || { chart: this.chart }, I, !1), this.frozenStates = L.preserveDataGrouping), O === "month" || O === "year")
              B ? (V = { range: L, max: U, chart: p, dataMin: R, dataMax: Y }, F = B.minFromRange.call(V), w(V.newMax) && (U = V.newMax), W = !1) : J = L;
            else if (J)
              U = Math.min((F = Math.max(U - J, R)) + J, Y), W = !1;
            else if (O === "ytd")
              if (B)
                (Y === void 0 || R === void 0) && (R = Number.MAX_VALUE, Y = Number.MIN_VALUE, p.series.forEach((ae) => {
                  let z = ae.xData;
                  z && (R = Math.min(z[0], R), Y = Math.max(z[z.length - 1], Y));
                }), b = !1), F = ee = (G = this.getYTDExtremes(Y, R, p.time.useUTC)).min, U = G.max;
              else {
                this.deferredYTDClick = C;
                return;
              }
            else
              O === "all" && B && (p.navigator && p.navigator.baseSeries[0] && (p.navigator.baseSeries[0].xAxis.options.range = void 0), F = R, U = Y);
            if (W && L._offsetMin && g(F) && (F += L._offsetMin), L._offsetMax && g(U) && (U += L._offsetMax), this.dropdown && (this.dropdown.selectedIndex = C + 1), B)
              B.setExtremes(F, U, $(b, !0), void 0, { trigger: "rangeSelectorButton", rangeSelectorButton: L }), p.setFixedRange(L._range);
            else {
              Q = N(p.options.xAxis)[0];
              let ae = m(p, "afterGetAxes", function() {
                let z = p.xAxis[0];
                z.range = z.options.range = J, z.min = z.options.min = ee;
              });
              m(p, "load", function() {
                let z = p.xAxis[0];
                p.setFixedRange(L._range), z.options.range = Q.range, z.options.min = Q.min, ae();
              });
            }
            S(this, "afterBtnClick");
          }
        }
        setSelected(C) {
          this.selected = this.options.selected = C;
        }
        init(C) {
          let b = this, p = C.options.rangeSelector, L = p.buttons || b.defaultButtons.slice(), B = p.selected, T = function() {
            let O = b.minInput, I = b.maxInput;
            O && O.blur && S(O, "blur"), I && I.blur && S(I, "blur");
          };
          b.chart = C, b.options = p, b.buttons = [], b.buttonOptions = L, this.eventsToUnbind = [], this.eventsToUnbind.push(m(C.container, "mousedown", T)), this.eventsToUnbind.push(m(C, "resize", T)), L.forEach(b.computeButtonRange), B !== void 0 && L[B] && this.clickButton(B, !1), this.eventsToUnbind.push(m(C, "load", function() {
            C.xAxis && C.xAxis[0] && m(C.xAxis[0], "setExtremes", function(O) {
              w(this.max) && w(this.min) && this.max - this.min !== C.fixedRange && O.trigger !== "rangeSelectorButton" && O.trigger !== "updatedData" && b.forcedDataGrouping && !b.frozenStates && this.setDataGrouping(!1, !1);
            });
          })), this.createElements();
        }
        updateButtonStates() {
          let C = this, b = this.chart, p = this.dropdown, L = this.dropdownLabel, B = b.xAxis[0], T = Math.round(B.max - B.min), O = !B.hasVisibleSeries, I = 24 * 36e5, R = b.scroller && b.scroller.getUnionExtremes() || B, Y = R.dataMin, F = R.dataMax, U = C.getYTDExtremes(F, Y, b.time.useUTC), Q = U.min, J = U.max, ee = C.selected, V = C.options.allButtonsEnabled, G = Array(C.buttonOptions.length).fill(0), W = w(ee), ae = C.buttons, z = !1, q = null;
          C.buttonOptions.forEach((Z, ne) => {
            let ie = Z._range, re = Z.type, de = Z.count || 1, me = Z._offsetMax - Z._offsetMin, ce = ne === ee, pe = ie > F - Y, xe = ie < B.minRange, le = !1, se = ie === T;
            if (ce && pe && (z = !0), B.isOrdinal && B.ordinal?.positions && ie && T < ie) {
              let ye = B.ordinal.positions, be = y.Additions.findIndexOf(ye, B.min, !0), ke = Math.min(y.Additions.findIndexOf(ye, B.max, !0) + 1, ye.length - 1);
              ye[ke] - ye[be] > ie && (se = !0);
            } else
              (re === "month" || re === "year") && T + 36e5 >= { month: 28, year: 365 }[re] * I * de - me && T - 36e5 <= { month: 31, year: 366 }[re] * I * de + me ? se = !0 : re === "ytd" ? (se = J - Q + me === T, le = !ce) : re === "all" && (se = B.max - B.min >= F - Y);
            let he = !V && !(z && re === "all") && (pe || xe || O), ve = z && re === "all" || !le && se || ce && C.frozenStates;
            he ? G[ne] = 3 : ve && (!W || ne === ee) && (q = ne);
          }), q !== null ? (G[q] = 2, C.setSelected(q)) : (C.setSelected(), L && (L.setState(0), L.attr({ text: (u.lang.rangeSelectorZoom || "") + " ▾" })));
          for (let Z = 0; Z < G.length; Z++) {
            let ne = G[Z], ie = ae[Z];
            if (ie.state !== ne && (ie.setState(ne), p)) {
              p.options[Z + 1].disabled = ne === 3, ne === 2 && (L && (L.setState(2), L.attr({ text: C.buttonOptions[Z].text + " ▾" })), p.selectedIndex = Z + 1);
              let re = L.getBBox();
              c(p, { width: `${re.width}px`, height: `${re.height}px` });
            }
          }
        }
        computeButtonRange(C) {
          let b = C.type, p = C.count || 1, L = { millisecond: 1, second: 1e3, minute: 6e4, hour: 36e5, day: 864e5, week: 6048e5 };
          L[b] ? C._range = L[b] * p : (b === "month" || b === "year") && (C._range = 24 * { month: 30, year: 365 }[b] * 36e5 * p), C._offsetMin = $(C.offsetMin, 0), C._offsetMax = $(C.offsetMax, 0), C._range += C._offsetMax - C._offsetMin;
        }
        getInputValue(C) {
          let b = C === "min" ? this.minInput : this.maxInput, p = this.chart.options.rangeSelector, L = this.chart.time;
          return b ? (b.type === "text" && p.inputDateParser || this.defaultInputDateParser)(b.value, L.useUTC, L) : 0;
        }
        setInputValue(C, b) {
          let p = this.options, L = this.chart.time, B = C === "min" ? this.minInput : this.maxInput, T = C === "min" ? this.minDateBox : this.maxDateBox;
          if (B) {
            let O = B.getAttribute("data-hc-time"), I = g(O) ? Number(O) : void 0;
            if (g(b)) {
              let R = I;
              g(R) && B.setAttribute("data-hc-time-previous", R), B.setAttribute("data-hc-time", b), I = b;
            }
            B.value = L.dateFormat(this.inputTypeFormats[B.type] || p.inputEditDateFormat, I), T && T.attr({ text: L.dateFormat(p.inputDateFormat, I) });
          }
        }
        setInputExtremes(C, b, p) {
          let L = C === "min" ? this.minInput : this.maxInput;
          if (L) {
            let B = this.inputTypeFormats[L.type], T = this.chart.time;
            if (B) {
              let O = T.dateFormat(B, b);
              L.min !== O && (L.min = O);
              let I = T.dateFormat(B, p);
              L.max !== I && (L.max = I);
            }
          }
        }
        showInput(C) {
          let b = C === "min" ? this.minDateBox : this.maxDateBox, p = C === "min" ? this.minInput : this.maxInput;
          if (p && b && this.inputGroup) {
            let L = p.type === "text", { translateX: B = 0, translateY: T = 0 } = this.inputGroup, { x: O = 0, width: I = 0, height: R = 0 } = b, { inputBoxWidth: Y } = this.options;
            c(p, { width: L ? I + (Y ? -2 : 20) + "px" : "auto", height: R - 2 + "px", border: "2px solid silver" }), L && Y ? c(p, { left: B + O + "px", top: T + "px" }) : c(p, { left: Math.min(Math.round(O + B - (p.offsetWidth - I) / 2), this.chart.chartWidth - p.offsetWidth) + "px", top: T - (p.offsetHeight - R) / 2 + "px" });
          }
        }
        hideInput(C) {
          let b = C === "min" ? this.minInput : this.maxInput;
          b && c(b, { top: "-9999em", border: 0, width: "1px", height: "1px" });
        }
        defaultInputDateParser(C, b, p) {
          let L = C.split("/").join("-").split(" ").join("T");
          if (L.indexOf("T") === -1 && (L += "T00:00"), b)
            L += "Z";
          else {
            let T;
            if (r.isSafari && !((T = L).length > 6 && (T.lastIndexOf("-") === T.length - 6 || T.lastIndexOf("+") === T.length - 6))) {
              let O = new Date(L).getTimezoneOffset() / 60;
              L += O <= 0 ? `+${A(-O)}:00` : `-${A(O)}:00`;
            }
          }
          let B = Date.parse(L);
          if (!w(B)) {
            let T = C.split("-");
            B = Date.UTC(j(T[0]), j(T[1]) - 1, j(T[2]));
          }
          return p && b && w(B) && (B += p.getTimezoneOffset(B)), B;
        }
        drawInput(C) {
          let { chart: b, div: p, inputGroup: L } = this, B = this, T = b.renderer.style || {}, O = b.renderer, I = b.options.rangeSelector, R = u.lang, Y = C === "min";
          function F(G) {
            let { maxInput: W, minInput: ae } = B, z = b.xAxis[0], q = b.scroller?.getUnionExtremes() || z, Z = q.dataMin, ne = q.dataMax, ie = b.xAxis[0].getExtremes()[G], re = B.getInputValue(G);
            w(re) && re !== ie && (Y && W && w(Z) ? re > Number(W.getAttribute("data-hc-time")) ? re = void 0 : re < Z && (re = Z) : ae && w(ne) && (re < Number(ae.getAttribute("data-hc-time")) ? re = void 0 : re > ne && (re = ne)), re !== void 0 && z.setExtremes(Y ? re : z.min, Y ? z.max : re, void 0, void 0, { trigger: "rangeSelectorInput" }));
          }
          let U = R[Y ? "rangeSelectorFrom" : "rangeSelectorTo"] || "", Q = O.label(U, 0).addClass("highcharts-range-label").attr({ padding: U ? 2 : 0, height: U ? I.inputBoxHeight : 0 }).add(L), J = O.label("", 0).addClass("highcharts-range-input").attr({ padding: 2, width: I.inputBoxWidth, height: I.inputBoxHeight, "text-align": "center" }).on("click", function() {
            B.showInput(C), B[C + "Input"].focus();
          });
          b.styledMode || J.attr({ stroke: I.inputBoxBorderColor, "stroke-width": 1 }), J.add(L);
          let ee = h("input", { name: C, className: "highcharts-range-selector" }, void 0, p);
          ee.setAttribute("type", function(G) {
            if (G.indexOf("%L") !== -1)
              return "text";
            let W = ["a", "A", "d", "e", "w", "b", "B", "m", "o", "y", "Y"].some((z) => G.indexOf("%" + z) !== -1), ae = ["H", "k", "I", "l", "M", "S"].some((z) => G.indexOf("%" + z) !== -1);
            return W && ae ? "datetime-local" : W ? "date" : ae ? "time" : "text";
          }(I.inputDateFormat || "%e %b %Y")), b.styledMode || (Q.css(x(T, I.labelStyle)), J.css(x({ color: "#333333" }, T, I.inputStyle)), c(ee, f({ position: "absolute", border: 0, boxShadow: "0 0 15px rgba(0,0,0,0.3)", width: "1px", height: "1px", padding: 0, textAlign: "center", fontSize: T.fontSize, fontFamily: T.fontFamily, top: "-9999em" }, I.inputStyle))), ee.onfocus = () => {
            B.showInput(C);
          }, ee.onblur = () => {
            ee === r.doc.activeElement && F(C), B.hideInput(C), B.setInputValue(C), ee.blur();
          };
          let V = !1;
          return ee.onchange = () => {
            V || (F(C), B.hideInput(C), ee.blur());
          }, ee.onkeypress = (G) => {
            G.keyCode === 13 && F(C);
          }, ee.onkeydown = (G) => {
            V = !0, (G.key === "ArrowUp" || G.key === "ArrowDown" || G.key === "Tab") && F(C);
          }, ee.onkeyup = () => {
            V = !1;
          }, { dateBox: J, input: ee, label: Q };
        }
        getPosition() {
          let C = this.chart, b = C.options.rangeSelector, p = b.verticalAlign === "top" ? C.plotTop - C.axisOffset[0] : 0;
          return { buttonTop: p + b.buttonPosition.y, inputTop: p + b.inputPosition.y - 10 };
        }
        getYTDExtremes(C, b, p) {
          let L = this.chart.time, B = new L.Date(C), T = L.get("FullYear", B), O = Math.max(b, p ? L.Date.UTC(T, 0, 1) : +new L.Date(T, 0, 1)), I = B.getTime();
          return { max: Math.min(C || I, I), min: O };
        }
        createElements() {
          let C = this.chart, b = C.renderer, p = C.container, L = C.options, B = L.rangeSelector, T = B.inputEnabled, O = $(L.chart.style?.zIndex, 0) + 1;
          if (B.enabled !== !1 && (this.group = b.g("range-selector-group").attr({ zIndex: 7 }).add(), this.div = h("div", void 0, { position: "relative", height: 0, zIndex: O }), this.buttonOptions.length && this.renderButtons(), p.parentNode && p.parentNode.insertBefore(this.div, p), T)) {
            this.inputGroup = b.g("input-group").add(this.group);
            let I = this.drawInput("min");
            this.minDateBox = I.dateBox, this.minLabel = I.label, this.minInput = I.input;
            let R = this.drawInput("max");
            this.maxDateBox = R.dateBox, this.maxLabel = R.label, this.maxInput = R.input;
          }
        }
        render(C, b) {
          let p = this.chart, L = p.options.rangeSelector, B = L.inputEnabled;
          if (L.enabled !== !1) {
            if (B) {
              this.setInputValue("min", C), this.setInputValue("max", b);
              let T = p.scroller && p.scroller.getUnionExtremes() || p.xAxis[0] || {};
              if (g(T.dataMin) && g(T.dataMax)) {
                let O = p.xAxis[0].minRange || 0;
                this.setInputExtremes("min", T.dataMin, Math.min(T.dataMax, this.getInputValue("max")) - O), this.setInputExtremes("max", Math.max(T.dataMin, this.getInputValue("min")) + O, T.dataMax);
              }
              if (this.inputGroup) {
                let O = 0;
                [this.minLabel, this.minDateBox, this.maxLabel, this.maxDateBox].forEach((I) => {
                  if (I) {
                    let { width: R } = I.getBBox();
                    R && (I.attr({ x: O }), O += R + L.inputSpacing);
                  }
                });
              }
            }
            this.alignElements(), this.updateButtonStates();
          }
        }
        renderButtons() {
          let { buttons: C, chart: b, options: p } = this, L = u.lang, B = b.renderer, T = x(p.buttonTheme), O = T && T.states, I = T.width || 28;
          delete T.width, delete T.states, this.buttonGroup = B.g("range-selector-buttons").add(this.group);
          let R = this.dropdown = h("select", void 0, { position: "absolute", padding: 0, border: 0, cursor: "pointer", opacity: 1e-4 }, this.div), Y = b.userOptions.rangeSelector?.buttonTheme;
          this.dropdownLabel = B.button("", 0, 0, () => {
          }, x(T, { "stroke-width": $(T["stroke-width"], 0), width: "auto", paddingLeft: $(p.buttonTheme.paddingLeft, Y?.padding, 8), paddingRight: $(p.buttonTheme.paddingRight, Y?.padding, 8) }), O && O.hover, O && O.select, O && O.disabled).hide().add(this.group), m(R, "touchstart", () => {
            R.style.fontSize = "16px";
          });
          let F = r.isMS ? "mouseover" : "mouseenter", U = r.isMS ? "mouseout" : "mouseleave";
          m(R, F, () => {
            S(this.dropdownLabel.element, F);
          }), m(R, U, () => {
            S(this.dropdownLabel.element, U);
          }), m(R, "change", () => {
            S(this.buttons[R.selectedIndex - 1].element, "click");
          }), this.zoomText = B.label(L.rangeSelectorZoom || "", 0).attr({ padding: p.buttonTheme.padding, height: p.buttonTheme.height, paddingLeft: 0, paddingRight: 0 }).add(this.buttonGroup), this.chart.styledMode || (this.zoomText.css(p.labelStyle), T["stroke-width"] = $(T["stroke-width"], 0)), h("option", { textContent: this.zoomText.textStr, disabled: !0 }, void 0, R), this.buttonOptions.forEach((Q, J) => {
            h("option", { textContent: Q.title || Q.text }, void 0, R), C[J] = B.button(Q.text, 0, 0, (ee) => {
              let V, G = Q.events && Q.events.click;
              G && (V = G.call(Q, ee)), V !== !1 && this.clickButton(J), this.isActive = !0;
            }, T, O && O.hover, O && O.select, O && O.disabled).attr({ "text-align": "center", width: I }).add(this.buttonGroup), Q.title && C[J].attr("title", Q.title);
          });
        }
        alignElements() {
          let { buttonGroup: C, buttons: b, chart: p, group: L, inputGroup: B, options: T, zoomText: O } = this, I = p.options, R = I.exporting && I.exporting.enabled !== !1 && I.navigation && I.navigation.buttonOptions, { buttonPosition: Y, inputPosition: F, verticalAlign: U } = T, Q = (ee, V) => R && this.titleCollision(p) && U === "top" && V.align === "right" && V.y - ee.getBBox().height - 12 < (R.y || 0) + (R.height || 0) + p.spacing[0] ? -40 : 0, J = p.plotLeft;
          if (L && Y && F) {
            let ee = Y.x - p.spacing[3];
            if (C) {
              if (this.positionButtons(), !this.initialButtonGroupWidth) {
                let ie = 0;
                O && (ie += O.getBBox().width + 5), b.forEach((re, de) => {
                  ie += re.width || 0, de !== b.length - 1 && (ie += T.buttonSpacing);
                }), this.initialButtonGroupWidth = ie;
              }
              J -= p.spacing[3];
              let ne = Q(C, Y);
              this.alignButtonGroup(ne), this.buttonGroup?.translateY && this.dropdownLabel.attr({ y: this.buttonGroup.translateY }), L.placed = C.placed = p.hasLoaded;
            }
            let V = 0;
            B && (V = Q(B, F), F.align === "left" ? ee = J : F.align === "right" && (ee = -Math.max(p.axisOffset[1], -V)), B.align({ y: F.y, width: B.getBBox().width, align: F.align, x: F.x + ee - 2 }, !0, p.spacingBox), B.placed = p.hasLoaded), this.handleCollision(V), L.align({ verticalAlign: U }, !0, p.spacingBox);
            let G = L.alignAttr.translateY, W = L.getBBox().height + 20, ae = 0;
            if (U === "bottom") {
              let ne = p.legend && p.legend.options;
              ae = G - (W = W + (ne && ne.verticalAlign === "bottom" && ne.enabled && !ne.floating ? p.legend.legendHeight + $(ne.margin, 10) : 0) - 20) - (T.floating ? 0 : T.y) - (p.titleOffset ? p.titleOffset[2] : 0) - 10;
            }
            U === "top" ? (T.floating && (ae = 0), p.titleOffset && p.titleOffset[0] && (ae = p.titleOffset[0]), ae += p.margin[0] - p.spacing[0] || 0) : U === "middle" && (F.y === Y.y ? ae = G : (F.y || Y.y) && (F.y < 0 || Y.y < 0 ? ae -= Math.min(F.y, Y.y) : ae = G - W)), L.translate(T.x, T.y + Math.floor(ae));
            let { minInput: z, maxInput: q, dropdown: Z } = this;
            T.inputEnabled && z && q && (z.style.marginTop = L.translateY + "px", q.style.marginTop = L.translateY + "px"), Z && (Z.style.marginTop = L.translateY + "px");
          }
        }
        alignButtonGroup(C, b) {
          let { chart: p, options: L, buttonGroup: B } = this, { buttonPosition: T } = L, O = p.plotLeft - p.spacing[3], I = T.x - p.spacing[3];
          T.align === "right" ? I += C - O : T.align === "center" && (I -= O / 2), B && B.align({ y: T.y, width: $(b, this.initialButtonGroupWidth), align: T.align, x: I }, !0, p.spacingBox);
        }
        positionButtons() {
          let { buttons: C, chart: b, options: p, zoomText: L } = this, B = b.hasLoaded ? "animate" : "attr", { buttonPosition: T } = p, O = b.plotLeft, I = O;
          L && L.visibility !== "hidden" && (L[B]({ x: $(O + T.x, O) }), I += T.x + L.getBBox().width + 5);
          for (let R = 0, Y = this.buttonOptions.length; R < Y; ++R)
            C[R].visibility !== "hidden" ? (C[R][B]({ x: I }), I += (C[R].width || 0) + p.buttonSpacing) : C[R][B]({ x: O });
        }
        handleCollision(C) {
          let { chart: b, buttonGroup: p, inputGroup: L } = this, { buttonPosition: B, dropdown: T, inputPosition: O } = this.options, I = () => {
            let F = 0;
            return this.buttons.forEach((U) => {
              let Q = U.getBBox();
              Q.width > F && (F = Q.width);
            }), F;
          }, R = (F) => {
            if (L?.alignOptions && p) {
              let U = L.alignAttr.translateX + L.alignOptions.x - C + L.getBBox().x + 2, Q = L.alignOptions.width || 0, J = p.alignAttr.translateX + p.getBBox().x;
              return J + F > U && U + Q > J && B.y < O.y + L.getBBox().height;
            }
            return !1;
          }, Y = () => {
            L && p && L.attr({ translateX: L.alignAttr.translateX + (b.axisOffset[1] >= -C ? 0 : -C), translateY: L.alignAttr.translateY + p.getBBox().height + 10 });
          };
          if (p) {
            if (T === "always") {
              this.collapseButtons(), R(I()) && Y();
              return;
            }
            T === "never" && this.expandButtons();
          }
          L && p ? O.align === B.align || R(this.initialButtonGroupWidth + 20) ? T === "responsive" ? (this.collapseButtons(), R(I()) && Y()) : Y() : T === "responsive" && this.expandButtons() : p && T === "responsive" && (this.initialButtonGroupWidth > b.plotWidth ? this.collapseButtons() : this.expandButtons());
        }
        collapseButtons() {
          let { buttons: C, zoomText: b } = this;
          this.isCollapsed !== !0 && (this.isCollapsed = !0, b.hide(), C.forEach((p) => void p.hide()), this.showDropdown());
        }
        expandButtons() {
          let { buttons: C, zoomText: b } = this;
          this.isCollapsed !== !1 && (this.isCollapsed = !1, this.hideDropdown(), b.show(), C.forEach((p) => void p.show()), this.positionButtons());
        }
        showDropdown() {
          let { buttonGroup: C, chart: b, dropdownLabel: p, dropdown: L } = this;
          if (C && L) {
            let { translateX: B = 0, translateY: T = 0 } = C, O = b.plotLeft + B;
            p.attr({ x: O, y: T }).show(), c(L, { left: O + "px", top: T + "px", visibility: "inherit" }), this.hasVisibleDropdown = !0;
          }
        }
        hideDropdown() {
          let { dropdown: C } = this;
          C && (this.dropdownLabel.hide(), c(C, { visibility: "hidden", width: "1px", height: "1px" }), this.hasVisibleDropdown = !1);
        }
        getHeight() {
          let C = this.options, b = this.group, p = C.inputPosition, L = C.buttonPosition, B = C.y, T = L.y, O = p.y, I = 0;
          if (C.height)
            return C.height;
          this.alignElements(), I = b ? b.getBBox(!0).height + 13 + B : 0;
          let R = Math.min(O, T);
          return (O < 0 && T < 0 || O > 0 && T > 0) && (I += Math.abs(R)), I;
        }
        titleCollision(C) {
          return !(C.options.title.text || C.options.subtitle.text);
        }
        update(C, b = !0) {
          let p = this.chart;
          x(!0, p.options.rangeSelector, C), this.destroy(), this.init(p), b && this.render();
        }
        destroy() {
          let C = this, b = C.minInput, p = C.maxInput;
          C.eventsToUnbind && (C.eventsToUnbind.forEach((L) => L()), C.eventsToUnbind = void 0), v(C.buttons), b && (b.onfocus = b.onblur = b.onchange = null), p && (p.onfocus = p.onblur = p.onchange = null), k(C, function(L, B) {
            L && B !== "chart" && (L instanceof l ? L.destroy() : L instanceof t.HTMLElement && P(L)), L !== M.prototype[B] && (C[B] = null);
          }, this);
        }
      }
      return f(M.prototype, { defaultButtons: [{ type: "month", count: 1, text: "1m", title: "View 1 month" }, { type: "month", count: 3, text: "3m", title: "View 3 months" }, { type: "month", count: 6, text: "6m", title: "View 6 months" }, { type: "ytd", text: "YTD", title: "View year to date" }, { type: "year", count: 1, text: "1y", title: "View 1 year" }, { type: "all", text: "All", title: "View all" }], inputTypeFormats: { "datetime-local": "%Y-%m-%dT%H:%M:%S", date: "%Y-%m-%d", time: "%H:%M:%S" } }), M;
    }), i(n, "Core/Chart/StockChart.js", [n["Core/Chart/Chart.js"], n["Core/Templating.js"], n["Core/Defaults.js"], n["Stock/Navigator/NavigatorDefaults.js"], n["Stock/RangeSelector/RangeSelectorDefaults.js"], n["Stock/Scrollbar/ScrollbarDefaults.js"], n["Stock/Utilities/StockUtilities.js"], n["Core/Utilities.js"]], function(o, a, r, s, l, d, y, u) {
      let { format: m } = a, { getOptions: h } = r, { setFixedRange: c } = y, { addEvent: g, clamp: v, crisp: P, defined: f, extend: S, find: w, isNumber: x, isString: k, merge: A, pick: $, splat: j } = u;
      function N(C, b, p) {
        return C === "xAxis" ? { minPadding: 0, maxPadding: 0, overscroll: 0, ordinal: !0 } : C === "yAxis" ? { labels: { y: -2 }, opposite: p.opposite ?? b.opposite ?? !0, showLastLabel: !!(b.categories || b.type === "category"), title: { text: p.title?.text !== "Values" ? p.title?.text : null } } : {};
      }
      function M(C, b) {
        if (C === "xAxis") {
          let p = $(b.navigator && b.navigator.enabled, s.enabled, !0), L = { type: "datetime", categories: void 0 };
          return p && (L.startOnTick = !1, L.endOnTick = !1), L;
        }
        return {};
      }
      class D extends o {
        init(b, p) {
          let L = h(), B = b.xAxis, T = b.yAxis, O = $(b.navigator && b.navigator.enabled, s.enabled, !0);
          b.xAxis = b.yAxis = void 0;
          let I = A({ chart: { panning: { enabled: !0, type: "x" }, zooming: { pinchType: "x", mouseWheel: { type: "x" } } }, navigator: { enabled: O }, scrollbar: { enabled: $(d.enabled, !0) }, rangeSelector: { enabled: $(l.rangeSelector.enabled, !0) }, title: { text: null }, tooltip: { split: $(L.tooltip && L.tooltip.split, !0), crosshairs: !0 }, legend: { enabled: !1 } }, b, { isStock: !0 });
          b.xAxis = B, b.yAxis = T, I.xAxis = j(b.xAxis || {}).map((R) => A(N("xAxis", R, L.xAxis), R, M("xAxis", b))), I.yAxis = j(b.yAxis || {}).map((R) => A(N("yAxis", R, L.yAxis), R)), super.init(I, p);
        }
        createAxis(b, p) {
          return p.axis = A(N(b, p.axis, h()[b]), p.axis, M(b, this.userOptions)), super.createAxis(b, p);
        }
      }
      return g(o, "update", function(C) {
        let b = C.options;
        "scrollbar" in b && this.navigator && (A(!0, this.options.scrollbar, b.scrollbar), this.navigator.update({ enabled: !!this.navigator.navigatorEnabled }), delete b.scrollbar);
      }), function(C) {
        function b(Y) {
          if (!this.crosshair || !this.crosshair.label || !this.crosshair.label.enabled || !this.cross || !x(this.min) || !x(this.max))
            return;
          let F = this.chart, U = this.logarithmic, Q = this.crosshair.label, J = this.horiz, ee = this.opposite, V = this.left, G = this.top, W = this.width, ae = this.options.tickPosition === "inside", z = this.crosshair.snap !== !1, q = Y.e || this.cross && this.cross.e, Z = Y.point, ne = this.crossLabel, ie, re, de = Q.format, me = "", ce, pe = 0, xe = this.min, le = this.max;
          U && (xe = U.lin2log(this.min), le = U.lin2log(this.max));
          let se = J ? "center" : ee ? this.labelAlign === "right" ? "right" : "left" : this.labelAlign === "left" ? "left" : "center";
          ne || (ne = this.crossLabel = F.renderer.label("", 0, void 0, Q.shape || "callout").addClass("highcharts-crosshair-label highcharts-color-" + (Z && Z.series ? Z.series.colorIndex : this.series[0] && this.series[0].colorIndex)).attr({ align: Q.align || se, padding: $(Q.padding, 8), r: $(Q.borderRadius, 3), zIndex: 2 }).add(this.labelGroup), F.styledMode || ne.attr({ fill: Q.backgroundColor || Z && Z.series && Z.series.color || "#666666", stroke: Q.borderColor || "", "stroke-width": Q.borderWidth || 0 }).css(S({ color: "#ffffff", fontWeight: "normal", fontSize: "0.7em", textAlign: "center" }, Q.style || {}))), J ? (ie = z ? (Z.plotX || 0) + V : q.chartX, re = G + (ee ? 0 : this.height)) : (ie = V + this.offset + (ee ? W : 0), re = z ? (Z.plotY || 0) + G : q.chartY), de || Q.formatter || (this.dateTime && (me = "%b %d, %Y"), de = "{value" + (me ? ":" + me : "") + "}");
          let he = z ? this.isXAxis ? Z.x : Z.y : this.toValue(J ? q.chartX : q.chartY), ve = Z && Z.series ? Z.series.isPointInside(Z) : x(he) && he > xe && he < le, ye = "";
          de ? ye = m(de, { value: he }, F) : Q.formatter && x(he) && (ye = Q.formatter.call(this, he)), ne.attr({ text: ye, x: ie, y: re, visibility: ve ? "inherit" : "hidden" });
          let be = ne.getBBox();
          !x(ne.x) || J || ee || (ie = ne.x - be.width / 2), x(ne.y) && (J ? (ae && !ee || !ae && ee) && (re = ne.y - be.height) : re = ne.y - be.height / 2), ce = J ? { left: V, right: V + this.width } : { left: this.labelAlign === "left" ? V : 0, right: this.labelAlign === "right" ? V + this.width : F.chartWidth };
          let ke = ne.translateX || 0;
          ke < ce.left && (pe = ce.left - ke), ke + be.width >= ce.right && (pe = -(ke + be.width - ce.right)), ne.attr({ x: ie + pe, y: re, anchorX: J ? ie : this.opposite ? 0 : F.chartWidth, anchorY: J ? this.opposite ? F.chartHeight : 0 : re + be.height / 2 });
        }
        function p() {
          this.crossLabel && (this.crossLabel = this.crossLabel.hide());
        }
        function L(Y) {
          let F = this.chart, U = this.options, Q = F._labelPanes = F._labelPanes || {}, J = U.labels;
          if (F.options.isStock && this.coll === "yAxis") {
            let ee = U.top + "," + U.height;
            !Q[ee] && J.enabled && (J.distance === 15 && this.side === 1 && (J.distance = 0), J.align === void 0 && (J.align = "right"), Q[ee] = this, Y.align = "right", Y.preventDefault());
          }
        }
        function B() {
          let Y = this.chart, F = this.options && this.options.top + "," + this.options.height;
          F && Y._labelPanes && Y._labelPanes[F] === this && delete Y._labelPanes[F];
        }
        function T(Y) {
          let F = this, U = F.isLinked && !F.series && F.linkedParent ? F.linkedParent.series : F.series, Q = F.chart, J = Q.renderer, ee = F.left, V = F.top, G = [], W = Y.translatedValue, ae = Y.value, z = Y.force, q, Z, ne, ie, re = [], de, me;
          if (Q.options.isStock && Y.acrossPanes !== !1 && F.coll === "xAxis" || F.coll === "yAxis") {
            for (let ce of (Y.preventDefault(), re = ((pe) => {
              let xe = pe === "xAxis" ? "yAxis" : "xAxis", le = F.options[xe];
              return x(le) ? [Q[xe][le]] : k(le) ? [Q.get(le)] : U.map((se) => se[xe]);
            })(F.coll), F.isXAxis ? Q.yAxis : Q.xAxis))
              if (!ce.options.isInternal) {
                let pe = ce.isXAxis ? "yAxis" : "xAxis";
                F === (f(ce.options[pe]) ? Q[pe][ce.options[pe]] : Q[pe][0]) && re.push(ce);
              }
            for (let ce of (de = re.length ? [] : [F.isXAxis ? Q.yAxis[0] : Q.xAxis[0]], re))
              de.indexOf(ce) !== -1 || w(de, (pe) => pe.pos === ce.pos && pe.len === ce.len) || de.push(ce);
            if (x(me = $(W, F.translate(ae || 0, void 0, void 0, Y.old))))
              if (F.horiz)
                for (let ce of de) {
                  let pe;
                  ie = (Z = ce.pos) + ce.len, q = ne = Math.round(me + F.transB), z !== "pass" && (q < ee || q > ee + F.width) && (z ? q = ne = v(q, ee, ee + F.width) : pe = !0), pe || G.push(["M", q, Z], ["L", ne, ie]);
                }
              else
                for (let ce of de) {
                  let pe;
                  ne = (q = ce.pos) + ce.len, Z = ie = Math.round(V + F.height - me), z !== "pass" && (Z < V || Z > V + F.height) && (z ? Z = ie = v(Z, V, V + F.height) : pe = !0), pe || G.push(["M", q, Z], ["L", ne, ie]);
                }
            Y.path = G.length > 0 ? J.crispPolyLine(G, Y.lineWidth || 1) : void 0;
          }
        }
        function O(Y) {
          if (this.chart.options.isStock) {
            let F;
            this.is("column") || this.is("columnrange") ? F = { borderWidth: 0, shadow: !1 } : this.is("scatter") || this.is("sma") || (F = { marker: { enabled: !1, radius: 2 } }), F && (Y.plotOptions[this.type] = A(Y.plotOptions[this.type], F));
          }
        }
        function I() {
          let Y = this.chart, F = this.options.dataGrouping;
          return this.allowDG !== !1 && F && $(F.enabled, Y.options.isStock);
        }
        function R(Y, F) {
          for (let U = 0; U < Y.length; U += 2) {
            let Q = Y[U], J = Y[U + 1];
            f(Q[1]) && Q[1] === J[1] && (Q[1] = J[1] = P(Q[1], F)), f(Q[2]) && Q[2] === J[2] && (Q[2] = J[2] = P(Q[2], F));
          }
          return Y;
        }
        C.compose = function(Y, F, U, Q) {
          let J = U.prototype;
          J.forceCropping || (g(F, "afterDrawCrosshair", b), g(F, "afterHideCrosshair", p), g(F, "autoLabelAlign", L), g(F, "destroy", B), g(F, "getPlotLinePath", T), Y.prototype.setFixedRange = c, J.forceCropping = I, g(U, "setOptions", O), Q.prototype.crispPolyLine = R);
        }, C.stockChart = function(Y, F, U) {
          return new C(Y, F, U);
        };
      }(D || (D = {})), D;
    }), i(n, "Series/HLC/HLCPoint.js", [n["Core/Series/SeriesRegistry.js"]], function(o) {
      let { column: { prototype: { pointClass: a } } } = o.seriesTypes;
      return class extends a {
      };
    }), i(n, "Series/HLC/HLCSeriesDefaults.js", [], function() {
      return { lineWidth: 1, tooltip: { pointFormat: '<span style="color:{point.color}">●</span> <b> {series.name}</b><br/>High: {point.high}<br/>Low: {point.low}<br/>Close: {point.close}<br/>' }, threshold: null, states: { hover: { lineWidth: 3 } }, stickyTracking: !0 };
    }), i(n, "Series/HLC/HLCSeries.js", [n["Series/HLC/HLCPoint.js"], n["Series/HLC/HLCSeriesDefaults.js"], n["Core/Series/SeriesRegistry.js"], n["Core/Utilities.js"]], function(o, a, r, s) {
      let { column: l } = r.seriesTypes, { crisp: d, extend: y, merge: u } = s;
      class m extends l {
        extendStem(c, g, v) {
          let P = c[0], f = c[1];
          typeof P[2] == "number" && (P[2] = Math.max(v + g, P[2])), typeof f[2] == "number" && (f[2] = Math.min(v - g, f[2]));
        }
        getPointPath(c, g) {
          let v = g.strokeWidth(), P = c.series, f = d(c.plotX || 0, v), S = Math.round(c.shapeArgs.width / 2), w = [["M", f, Math.round(c.yBottom)], ["L", f, Math.round(c.plotHigh)]];
          if (c.close !== null) {
            let x = d(c.plotClose, v);
            w.push(["M", f, x], ["L", f + S, x]), P.extendStem(w, v / 2, x);
          }
          return w;
        }
        drawSinglePoint(c) {
          let g = c.series, v = g.chart, P, f = c.graphic;
          c.plotY !== void 0 && (f || (c.graphic = f = v.renderer.path().add(g.group)), v.styledMode || f.attr(g.pointAttribs(c, c.selected && "select")), P = g.getPointPath(c, f), f[f ? "animate" : "attr"]({ d: P }).addClass(c.getClassName(), !0));
        }
        drawPoints() {
          this.points.forEach(this.drawSinglePoint);
        }
        init() {
          super.init.apply(this, arguments), this.options.stacking = void 0;
        }
        pointAttribs(c, g) {
          let v = super.pointAttribs.call(this, c, g);
          return delete v.fill, v;
        }
        toYData(c) {
          return [c.high, c.low, c.close];
        }
        translate() {
          let c = this, g = c.yAxis, v = this.pointArrayMap && this.pointArrayMap.slice() || [], P = v.map((f) => `plot${f.charAt(0).toUpperCase() + f.slice(1)}`);
          P.push("yBottom"), v.push("low"), super.translate.apply(c), c.points.forEach(function(f) {
            v.forEach(function(S, w) {
              let x = f[S];
              x !== null && (c.dataModify && (x = c.dataModify.modifyValue(x)), f[P[w]] = g.toPixels(x, !0));
            }), f.tooltipPos[1] = f.plotHigh + g.pos - c.chart.plotTop;
          });
        }
      }
      return m.defaultOptions = u(l.defaultOptions, a), y(m.prototype, { pointClass: o, animate: null, directTouch: !1, pointArrayMap: ["high", "low", "close"], pointAttrToOptions: { stroke: "color", "stroke-width": "lineWidth" }, pointValKey: "close" }), r.registerSeriesType("hlc", m), m;
    }), i(n, "Series/OHLC/OHLCPoint.js", [n["Core/Series/SeriesRegistry.js"]], function(o) {
      let { seriesTypes: { hlc: a } } = o;
      class r extends a.prototype.pointClass {
        getClassName() {
          return super.getClassName.call(this) + (this.open < this.close ? " highcharts-point-up" : " highcharts-point-down");
        }
        resolveUpColor() {
          this.open < this.close && !this.options.color && this.series.options.upColor && (this.color = this.series.options.upColor);
        }
        resolveColor() {
          super.resolveColor(), this.series.is("heikinashi") || this.resolveUpColor();
        }
        getZone() {
          let l = super.getZone();
          return this.resolveUpColor(), l;
        }
        applyOptions() {
          return super.applyOptions.apply(this, arguments), this.resolveColor && this.resolveColor(), this;
        }
      }
      return r;
    }), i(n, "Series/OHLC/OHLCSeriesDefaults.js", [], function() {
      return { tooltip: { pointFormat: '<span style="color:{point.color}">●</span> <b> {series.name}</b><br/>Open: {point.open}<br/>High: {point.high}<br/>Low: {point.low}<br/>Close: {point.close}<br/>' } };
    }), i(n, "Series/OHLC/OHLCSeries.js", [n["Core/Globals.js"], n["Series/OHLC/OHLCPoint.js"], n["Series/OHLC/OHLCSeriesDefaults.js"], n["Core/Series/SeriesRegistry.js"], n["Core/Utilities.js"]], function(o, a, r, s, l) {
      let { composed: d } = o, { hlc: y } = s.seriesTypes, { addEvent: u, crisp: m, extend: h, merge: c, pushUnique: g } = l;
      function v(S) {
        let w = S.options, x = w.dataGrouping;
        x && w.useOhlcData && w.id !== "highcharts-navigator-series" && (x.approximation = "ohlc");
      }
      function P(S) {
        let w = S.options;
        w.useOhlcData && w.id !== "highcharts-navigator-series" && h(this, { pointValKey: f.prototype.pointValKey, pointArrayMap: f.prototype.pointArrayMap, toYData: f.prototype.toYData });
      }
      class f extends y {
        static compose(w, ...x) {
          g(d, "OHLCSeries") && (u(w, "afterSetOptions", v), u(w, "init", P));
        }
        getPointPath(w, x) {
          let k = super.getPointPath(w, x), A = x.strokeWidth(), $ = m(w.plotX || 0, A), j = Math.round(w.shapeArgs.width / 2);
          if (w.open !== null) {
            let N = m(w.plotOpen, A);
            k.push(["M", $, N], ["L", $ - j, N]), super.extendStem(k, A / 2, N);
          }
          return k;
        }
        pointAttribs(w, x) {
          let k = super.pointAttribs.call(this, w, x), A = this.options;
          return delete k.fill, !w.options.color && A.upColor && w.open < w.close && (k.stroke = A.upColor), k;
        }
        toYData(w) {
          return [w.open, w.high, w.low, w.close];
        }
      }
      return f.defaultOptions = c(y.defaultOptions, r), h(f.prototype, { pointClass: a, pointArrayMap: ["open", "high", "low", "close"] }), s.registerSeriesType("ohlc", f), f;
    }), i(n, "Series/Candlestick/CandlestickSeriesDefaults.js", [], function() {
      return { states: { hover: { lineWidth: 2 } }, threshold: null, lineColor: "#000000", lineWidth: 1, upColor: "#ffffff", stickyTracking: !0 };
    }), i(n, "Series/Candlestick/CandlestickSeries.js", [n["Series/Candlestick/CandlestickSeriesDefaults.js"], n["Core/Series/SeriesRegistry.js"], n["Core/Utilities.js"]], function(o, a, r) {
      let { column: s, ohlc: l } = a.seriesTypes, { crisp: d, merge: y } = r;
      class u extends l {
        pointAttribs(h, c) {
          let g = s.prototype.pointAttribs.call(this, h, c), v = this.options, P = h.open < h.close, f = v.lineColor || this.color, S = h.color || this.color;
          if (g["stroke-width"] = v.lineWidth, g.fill = h.options.color || P && v.upColor || S, g.stroke = h.options.lineColor || P && v.upLineColor || f, c) {
            let w = v.states[c];
            g.fill = w.color || g.fill, g.stroke = w.lineColor || g.stroke, g["stroke-width"] = w.lineWidth || g["stroke-width"];
          }
          return g;
        }
        drawPoints() {
          let h = this.points, c = this.chart, g = this.yAxis.reversed;
          for (let v of h) {
            let P = v.graphic, f, S, w, x, k, A, $, j, N, M = !P;
            if (v.plotY !== void 0) {
              P || (v.graphic = P = c.renderer.path().add(this.group)), this.chart.styledMode || P.attr(this.pointAttribs(v, v.selected && "select")).shadow(this.options.shadow);
              let D = P.strokeWidth();
              $ = d(v.plotX || 0, D), w = Math.min(f = v.plotOpen, S = v.plotClose), x = Math.max(f, S), N = Math.round(v.shapeArgs.width / 2), k = g ? x !== v.yBottom : Math.round(w) !== Math.round(v.plotHigh || 0), A = g ? Math.round(w) !== Math.round(v.plotHigh || 0) : x !== v.yBottom, w = d(w, D), x = d(x, D), (j = []).push(["M", $ - N, x], ["L", $ - N, w], ["L", $ + N, w], ["L", $ + N, x], ["Z"], ["M", $, w], ["L", $, k ? Math.round(g ? v.yBottom : v.plotHigh) : w], ["M", $, x], ["L", $, A ? Math.round(g ? v.plotHigh : v.yBottom) : x]), P[M ? "attr" : "animate"]({ d: j }).addClass(v.getClassName(), !0);
            }
          }
        }
      }
      return u.defaultOptions = y(l.defaultOptions, { tooltip: l.defaultOptions.tooltip }, o), a.registerSeriesType("candlestick", u), u;
    }), i(n, "Series/Flags/FlagsPoint.js", [n["Core/Series/SeriesRegistry.js"], n["Core/Utilities.js"]], function(o, a) {
      let { column: { prototype: { pointClass: r } } } = o.seriesTypes, { isNumber: s } = a;
      return class extends r {
        constructor() {
          super(...arguments), this.ttBelow = !1;
        }
        isValid() {
          return s(this.y) || this.y === void 0;
        }
        hasNewShapeType() {
          let l = this.options.shape || this.series.options.shape;
          return this.graphic && l && l !== this.graphic.symbolKey;
        }
      };
    }), i(n, "Series/Flags/FlagsSeriesDefaults.js", [], function() {
      return { borderRadius: 0, pointRange: 0, allowOverlapX: !1, shape: "flag", stackDistance: 12, textAlign: "center", tooltip: { pointFormat: "{point.text}" }, threshold: null, y: -30, fillColor: "#ffffff", lineWidth: 1, states: { hover: { lineColor: "#000000", fillColor: "#ccd3ff" } }, style: { fontSize: "0.7em", fontWeight: "bold" } };
    }), i(n, "Series/Flags/FlagsSymbols.js", [n["Core/Renderer/RendererRegistry.js"]], function(o) {
      var a;
      return function(r) {
        let s = [];
        function l(y, u, m, h, c) {
          let g = c && c.anchorX || y, v = c && c.anchorY || u, P = this.circle(g - 1, v - 1, 2, 2);
          return P.push(["M", g, v], ["L", y, u + h], ["L", y, u], ["L", y + m, u], ["L", y + m, u + h], ["L", y, u + h], ["Z"]), P;
        }
        function d(y, u) {
          y[u + "pin"] = function(m, h, c, g, v) {
            let P, f = v && v.anchorX, S = v && v.anchorY;
            if (u === "circle" && g > c && (m -= Math.round((g - c) / 2), c = g), P = y[u](m, h, c, g, v), f && S) {
              let w = f;
              if (u === "circle")
                w = m + c / 2;
              else {
                let k = P[0], A = P[1];
                k[0] === "M" && A[0] === "L" && (w = (k[1] + A[1]) / 2);
              }
              let x = h > S ? h : h + g;
              P.push(["M", w, x], ["L", f, S]), P = P.concat(y.circle(f - 1, S - 1, 2, 2));
            }
            return P;
          };
        }
        r.compose = function(y) {
          if (s.indexOf(y) === -1) {
            s.push(y);
            let m = y.prototype.symbols;
            m.flag = l, d(m, "circle"), d(m, "square");
          }
          let u = o.getRendererType();
          s.indexOf(u) && s.push(u);
        };
      }(a || (a = {})), a;
    }), i(n, "Series/OnSeriesComposition.js", [n["Series/Column/ColumnSeries.js"], n["Core/Globals.js"], n["Core/Series/Series.js"], n["Core/Utilities.js"]], function(o, a, r, s) {
      var l;
      let { composed: d } = a, { prototype: y } = o, { prototype: u } = r, { defined: m, pushUnique: h, stableSort: c } = s;
      return function(g) {
        function v(f) {
          return u.getPlotBox.call(this.options.onSeries && this.chart.get(this.options.onSeries) || this, f);
        }
        function P() {
          y.translate.apply(this);
          let f = this, S = f.options, w = f.chart, x = f.points, k = S.onSeries, A = k && w.get(k), $ = A && A.options.step, j = A && A.points, N = w.inverted, M = f.xAxis, D = f.yAxis, C = x.length - 1, b, p, L = S.onKey || "y", B = j && j.length, T = 0, O, I, R, Y, F;
          if (A && A.visible && B) {
            for (T = (A.pointXOffset || 0) + (A.barW || 0) / 2, Y = A.currentDataGrouping, I = j[B - 1].x + (Y ? Y.totalRange : 0), c(x, (U, Q) => U.x - Q.x), L = "plot" + L[0].toUpperCase() + L.substr(1); B-- && x[C]; )
              if (O = j[B], (b = x[C]).y = O.y, O.x <= b.x && O[L] !== void 0) {
                if (b.x <= I && (b.plotY = O[L], O.x < b.x && !$ && (R = j[B + 1]) && R[L] !== void 0))
                  if (m(b.plotX) && A.is("spline")) {
                    let U = [O.plotX || 0, O.plotY || 0], Q = [R.plotX || 0, R.plotY || 0], J = O.controlPoints?.high || U, ee = R.controlPoints?.low || Q, V = (z, q) => Math.pow(1 - z, 3) * U[q] + 3 * (1 - z) * (1 - z) * z * J[q] + 3 * (1 - z) * z * z * ee[q] + z * z * z * Q[q], G = 0, W = 1, ae;
                    for (let z = 0; z < 100; z++) {
                      let q = (G + W) / 2, Z = V(q, 0);
                      if (Z === null)
                        break;
                      if (0.25 > Math.abs(Z - b.plotX)) {
                        ae = q;
                        break;
                      }
                      Z < b.plotX ? G = q : W = q;
                    }
                    m(ae) && (b.plotY = V(ae, 1), b.y = D.toValue(b.plotY, !0));
                  } else
                    F = (b.x - O.x) / (R.x - O.x), b.plotY += F * (R[L] - O[L]), b.y += F * (R.y - O.y);
                if (C--, B++, C < 0)
                  break;
              }
          }
          x.forEach((U, Q) => {
            let J;
            U.plotX += T, (U.plotY === void 0 || N) && (U.plotX >= 0 && U.plotX <= M.len ? N ? (U.plotY = M.translate(U.x, 0, 1, 0, 1), U.plotX = m(U.y) ? D.translate(U.y, 0, 0, 0, 1) : 0) : U.plotY = (M.opposite ? 0 : f.yAxis.len) + M.offset : U.shapeArgs = {}), (p = x[Q - 1]) && p.plotX === U.plotX && (p.stackIndex === void 0 && (p.stackIndex = 0), J = p.stackIndex + 1), U.stackIndex = J;
          }), this.onSeries = A;
        }
        g.compose = function(f) {
          if (h(d, "OnSeries")) {
            let S = f.prototype;
            S.getPlotBox = v, S.translate = P;
          }
          return f;
        }, g.getPlotBox = v, g.translate = P;
      }(l || (l = {})), l;
    }), i(n, "Series/Flags/FlagsSeries.js", [n["Series/Flags/FlagsPoint.js"], n["Series/Flags/FlagsSeriesDefaults.js"], n["Series/Flags/FlagsSymbols.js"], n["Core/Globals.js"], n["Series/OnSeriesComposition.js"], n["Core/Renderer/RendererUtilities.js"], n["Core/Series/SeriesRegistry.js"], n["Core/Renderer/SVG/SVGElement.js"], n["Core/Utilities.js"]], function(o, a, r, s, l, d, y, u, m) {
      let { noop: h } = s, { distribute: c } = d, { series: g, seriesTypes: { column: v } } = y, { addEvent: P, defined: f, extend: S, isNumber: w, merge: x, objectEach: k, wrap: A } = m;
      class $ extends v {
        animate(N) {
          N && this.setClip();
        }
        drawPoints() {
          let N, M, D, C, b, p, L, B, T, O, I, R = this.points, Y = this.chart, F = Y.renderer, U = Y.inverted, Q = this.options, J = Q.y, ee = this.yAxis, V = {}, G = [], W = w(Q.borderRadius) ? Q.borderRadius : 0;
          for (C = R.length; C--; )
            b = R[C], O = (U ? b.plotY : b.plotX) > this.xAxis.len, N = b.plotX, L = b.stackIndex, D = b.options.shape || Q.shape, (M = b.plotY) !== void 0 && (M = b.plotY + J - (L !== void 0 && L * Q.stackDistance)), b.anchorX = L ? void 0 : b.plotX, B = L ? void 0 : b.plotY, I = D !== "flag", p = b.graphic, M !== void 0 && N >= 0 && !O ? (p && b.hasNewShapeType() && (p = p.destroy()), p || (p = b.graphic = F.label("", 0, void 0, D, void 0, void 0, Q.useHTML).addClass("highcharts-point").add(this.markerGroup), b.graphic.div && (b.graphic.div.point = b), p.isNew = !0), p.attr({ align: I ? "center" : "left", width: Q.width, height: Q.height, "text-align": Q.textAlign, r: W }), Y.styledMode || p.attr(this.pointAttribs(b)).css(x(Q.style, b.style)).shadow(Q.shadow), N > 0 && (N -= p.strokeWidth() % 2), T = { y: M, anchorY: B }, Q.allowOverlapX && (T.x = N, T.anchorX = b.anchorX), p.attr({ text: b.options.title ?? Q.title ?? "A" })[p.isNew ? "attr" : "animate"](T), Q.allowOverlapX || (V[b.plotX] ? V[b.plotX].size = Math.max(V[b.plotX].size, p.width || 0) : V[b.plotX] = { align: I ? 0.5 : 0, size: p.width || 0, target: N, anchorX: N }), b.tooltipPos = [N, M + ee.pos - Y.plotTop]) : p && (b.graphic = p.destroy());
          if (!Q.allowOverlapX) {
            let ae = 100;
            for (let z of (k(V, function(q) {
              q.plotX = q.anchorX, G.push(q), ae = Math.max(q.size, ae);
            }), c(G, U ? ee.len : this.xAxis.len, ae), R)) {
              let q = z.plotX, Z = z.graphic, ne = Z && V[q];
              ne && Z && (f(ne.pos) ? Z[Z.isNew ? "attr" : "animate"]({ x: ne.pos + (ne.align || 0) * ne.size, anchorX: z.anchorX }).show().isNew = !1 : Z.hide().isNew = !0);
            }
          }
          Q.useHTML && this.markerGroup && A(this.markerGroup, "on", function(ae) {
            return u.prototype.on.apply(ae.apply(this, [].slice.call(arguments, 1)), [].slice.call(arguments, 1));
          });
        }
        drawTracker() {
          let N = this.points;
          for (let M of (super.drawTracker(), N)) {
            let D = M.graphic;
            D && (M.unbindMouseOver && M.unbindMouseOver(), M.unbindMouseOver = P(D.element, "mouseover", function() {
              for (let C of (M.stackIndex > 0 && !M.raised && (M._y = D.y, D.attr({ y: M._y - 8 }), M.raised = !0), N))
                C !== M && C.raised && C.graphic && (C.graphic.attr({ y: C._y }), C.raised = !1);
            }));
          }
        }
        pointAttribs(N, M) {
          let D = this.options, C = N && N.color || this.color, b = D.lineColor, p = N && N.lineWidth, L = N && N.fillColor || D.fillColor;
          return M && (L = D.states[M].fillColor, b = D.states[M].lineColor, p = D.states[M].lineWidth), { fill: L || C, stroke: b || C, "stroke-width": p || D.lineWidth || 0 };
        }
        setClip() {
          g.prototype.setClip.apply(this, arguments), this.options.clip !== !1 && this.sharedClipKey && this.markerGroup && this.markerGroup.clip(this.chart.sharedClips[this.sharedClipKey]);
        }
      }
      return $.compose = r.compose, $.defaultOptions = x(v.defaultOptions, a), l.compose($), S($.prototype, { allowDG: !1, forceCrop: !0, invertible: !1, noSharedTooltip: !0, pointClass: o, sorted: !1, takeOrdinalPosition: !1, trackerGroups: ["markerGroup"], buildKDTree: h, init: g.prototype.init }), y.registerSeriesType("flags", $), $;
    }), i(n, "Core/Axis/BrokenAxis.js", [n["Core/Axis/Stacking/StackItem.js"], n["Core/Utilities.js"]], function(o, a) {
      var r;
      let { addEvent: s, find: l, fireEvent: d, isArray: y, isNumber: u, pick: m } = a;
      return function(h) {
        function c() {
          this.brokenAxis !== void 0 && this.brokenAxis.setBreaks(this.options.breaks, !1);
        }
        function g() {
          this.brokenAxis?.hasBreaks && (this.options.ordinal = !1);
        }
        function v() {
          let A = this.brokenAxis;
          if (A?.hasBreaks) {
            let $ = this.tickPositions, j = this.tickPositions.info, N = [];
            for (let M = 0; M < $.length; M++)
              A.isInAnyBreak($[M]) || N.push($[M]);
            this.tickPositions = N, this.tickPositions.info = j;
          }
        }
        function P() {
          this.brokenAxis || (this.brokenAxis = new k(this));
        }
        function f() {
          let { isDirty: A, options: { connectNulls: $ }, points: j, xAxis: N, yAxis: M } = this;
          if (A) {
            let D = j.length;
            for (; D--; ) {
              let C = j[D], b = !(C.y === null && $ === !1) && (N?.brokenAxis?.isInAnyBreak(C.x, !0) || M?.brokenAxis?.isInAnyBreak(C.y, !0));
              C.visible = !b && C.options.visible !== !1;
            }
          }
        }
        function S() {
          this.drawBreaks(this.xAxis, ["x"]), this.drawBreaks(this.yAxis, m(this.pointArrayMap, ["y"]));
        }
        function w(A, $) {
          let j, N, M, D = this, C = D.points;
          if (A?.brokenAxis?.hasBreaks) {
            let b = A.brokenAxis;
            $.forEach(function(p) {
              j = b?.breakArray || [], N = A.isXAxis ? A.min : m(D.options.threshold, A.min);
              let L = A?.options?.breaks?.filter(function(B) {
                let T = !0;
                for (let O = 0; O < j.length; O++) {
                  let I = j[O];
                  if (I.from === B.from && I.to === B.to) {
                    T = !1;
                    break;
                  }
                }
                return T;
              });
              C.forEach(function(B) {
                M = m(B["stack" + p.toUpperCase()], B[p]), j.forEach(function(T) {
                  if (u(N) && u(M)) {
                    let O = "";
                    N < T.from && M > T.to || N > T.from && M < T.from ? O = "pointBreak" : (N < T.from && M > T.from && M < T.to || N > T.from && M > T.to && M < T.from) && (O = "pointInBreak"), O && d(A, O, { point: B, brk: T });
                  }
                }), L?.forEach(function(T) {
                  d(A, "pointOutsideOfBreak", { point: B, brk: T });
                });
              });
            });
          }
        }
        function x() {
          let A = this.currentDataGrouping, $ = A?.gapSize, j = this.points.slice(), N = this.yAxis, M = this.options.gapSize, D = j.length - 1;
          if (M && D > 0) {
            let C, b;
            for (this.options.gapUnit !== "value" && (M *= this.basePointRange), $ && $ > M && $ >= this.basePointRange && (M = $); D--; )
              if (b && b.visible !== !1 || (b = j[D + 1]), C = j[D], b.visible !== !1 && C.visible !== !1) {
                if (b.x - C.x > M) {
                  let p = (C.x + b.x) / 2;
                  j.splice(D + 1, 0, { isNull: !0, x: p }), N.stacking && this.options.stacking && ((N.stacking.stacks[this.stackKey][p] = new o(N, N.options.stackLabels, !1, p, this.stack)).total = 0);
                }
                b = C;
              }
          }
          return this.getGraphPath(j);
        }
        h.compose = function(A, $) {
          if (!A.keepProps.includes("brokenAxis")) {
            A.keepProps.push("brokenAxis"), s(A, "init", P), s(A, "afterInit", c), s(A, "afterSetTickPositions", v), s(A, "afterSetOptions", g);
            let j = $.prototype;
            j.drawBreaks = w, j.gappedPath = x, s($, "afterGeneratePoints", f), s($, "afterRender", S);
          }
          return A;
        };
        class k {
          static isInBreak($, j) {
            let N = $.repeat || 1 / 0, M = $.from, D = $.to - $.from, C = j >= M ? (j - M) % N : N - (M - j) % N;
            return $.inclusive ? C <= D : C < D && C !== 0;
          }
          static lin2Val($) {
            let j = this.brokenAxis, N = j && j.breakArray;
            if (!N || !u($))
              return $;
            let M = $, D, C;
            for (C = 0; C < N.length && !((D = N[C]).from >= M); C++)
              (D.to < M || k.isInBreak(D, M)) && (M += D.len);
            return M;
          }
          static val2Lin($) {
            let j = this.brokenAxis, N = j && j.breakArray;
            if (!N || !u($))
              return $;
            let M = $, D, C;
            for (C = 0; C < N.length; C++)
              if ((D = N[C]).to <= $)
                M -= D.len;
              else {
                if (D.from >= $)
                  break;
                if (k.isInBreak(D, $)) {
                  M -= $ - D.from;
                  break;
                }
              }
            return M;
          }
          constructor($) {
            this.hasBreaks = !1, this.axis = $;
          }
          findBreakAt($, j) {
            return l(j, function(N) {
              return N.from < $ && $ < N.to;
            });
          }
          isInAnyBreak($, j) {
            let N = this.axis, M = N.options.breaks || [], D = M.length, C, b, p;
            if (D && u($)) {
              for (; D--; )
                k.isInBreak(M[D], $) && (C = !0, b || (b = m(M[D].showPoints, !N.isXAxis)));
              p = C && j ? C && !b : C;
            }
            return p;
          }
          setBreaks($, j) {
            let N = this, M = N.axis, D = y($) && !!$.length && !!Object.keys($[0]).length;
            M.isDirty = N.hasBreaks !== D, N.hasBreaks = D, $ !== M.options.breaks && (M.options.breaks = M.userOptions.breaks = $), M.forceRedraw = !0, M.series.forEach(function(C) {
              C.isDirty = !0;
            }), D || M.val2lin !== k.val2Lin || (delete M.val2lin, delete M.lin2val), D && (M.userOptions.ordinal = !1, M.lin2val = k.lin2Val, M.val2lin = k.val2Lin, M.setExtremes = function(C, b, p, L, B) {
              if (N.hasBreaks) {
                let T, O = this.options.breaks || [];
                for (; T = N.findBreakAt(C, O); )
                  C = T.to;
                for (; T = N.findBreakAt(b, O); )
                  b = T.from;
                b < C && (b = C);
              }
              M.constructor.prototype.setExtremes.call(this, C, b, p, L, B);
            }, M.setAxisTranslation = function() {
              if (M.constructor.prototype.setAxisTranslation.call(this), N.unitLength = void 0, N.hasBreaks) {
                let C = M.options.breaks || [], b = [], p = [], L = m(M.pointRangePadding, 0), B = 0, T, O, I = M.userMin || M.min, R = M.userMax || M.max, Y, F;
                C.forEach(function(U) {
                  O = U.repeat || 1 / 0, u(I) && u(R) && (k.isInBreak(U, I) && (I += U.to % O - I % O), k.isInBreak(U, R) && (R -= R % O - U.from % O));
                }), C.forEach(function(U) {
                  if (Y = U.from, O = U.repeat || 1 / 0, u(I) && u(R)) {
                    for (; Y - O > I; )
                      Y -= O;
                    for (; Y < I; )
                      Y += O;
                    for (F = Y; F < R; F += O)
                      b.push({ value: F, move: "in" }), b.push({ value: F + U.to - U.from, move: "out", size: U.breakSize });
                  }
                }), b.sort(function(U, Q) {
                  return U.value === Q.value ? (U.move === "in" ? 0 : 1) - (Q.move === "in" ? 0 : 1) : U.value - Q.value;
                }), T = 0, Y = I, b.forEach(function(U) {
                  (T += U.move === "in" ? 1 : -1) === 1 && U.move === "in" && (Y = U.value), T === 0 && u(Y) && (p.push({ from: Y, to: U.value, len: U.value - Y - (U.size || 0) }), B += U.value - Y - (U.size || 0));
                }), N.breakArray = p, u(I) && u(R) && u(M.min) && (N.unitLength = R - I - B + L, d(M, "afterBreaks"), M.staticScale ? M.transA = M.staticScale : N.unitLength && (M.transA *= (R - M.min + L) / N.unitLength), L && (M.minPixelPadding = M.transA * (M.minPointOffset || 0)), M.min = I, M.max = R);
              }
            }), m(j, !0) && M.chart.redraw();
          }
        }
        h.Additions = k;
      }(r || (r = {})), r;
    }), i(n, "masters/modules/broken-axis.src.js", [n["Core/Globals.js"], n["Core/Axis/BrokenAxis.js"]], function(o, a) {
      return o.BrokenAxis = o.BrokenAxis || a, o.BrokenAxis.compose(o.Axis, o.Series), o;
    }), i(n, "Extensions/DataGrouping/ApproximationRegistry.js", [], function() {
      return {};
    }), i(n, "Extensions/DataGrouping/ApproximationDefaults.js", [n["Extensions/DataGrouping/ApproximationRegistry.js"], n["Core/Utilities.js"]], function(o, a) {
      let { arrayMax: r, arrayMin: s, correctFloat: l, extend: d, isNumber: y } = a;
      function u(c) {
        let g = c.length, v = m(c);
        return y(v) && g && (v = l(v / g)), v;
      }
      function m(c) {
        let g = c.length, v;
        if (!g && c.hasNulls)
          v = null;
        else if (g)
          for (v = 0; g--; )
            v += c[g];
        return v;
      }
      let h = { average: u, averages: function() {
        let c = [];
        return [].forEach.call(arguments, function(g) {
          c.push(u(g));
        }), c[0] === void 0 ? void 0 : c;
      }, close: function(c) {
        return c.length ? c[c.length - 1] : c.hasNulls ? null : void 0;
      }, high: function(c) {
        return c.length ? r(c) : c.hasNulls ? null : void 0;
      }, hlc: function(c, g, v) {
        if (c = o.high(c), g = o.low(g), v = o.close(v), y(c) || y(g) || y(v))
          return [c, g, v];
      }, low: function(c) {
        return c.length ? s(c) : c.hasNulls ? null : void 0;
      }, ohlc: function(c, g, v, P) {
        if (c = o.open(c), g = o.high(g), v = o.low(v), P = o.close(P), y(c) || y(g) || y(v) || y(P))
          return [c, g, v, P];
      }, open: function(c) {
        return c.length ? c[0] : c.hasNulls ? null : void 0;
      }, range: function(c, g) {
        return c = o.low(c), g = o.high(g), y(c) || y(g) ? [c, g] : c === null && g === null ? null : void 0;
      }, sum: m };
      return d(o, h), h;
    }), i(n, "Extensions/DataGrouping/DataGroupingDefaults.js", [], function() {
      return { common: { groupPixelWidth: 2, dateTimeLabelFormats: { millisecond: ["%A, %e %b, %H:%M:%S.%L", "%A, %e %b, %H:%M:%S.%L", "-%H:%M:%S.%L"], second: ["%A, %e %b, %H:%M:%S", "%A, %e %b, %H:%M:%S", "-%H:%M:%S"], minute: ["%A, %e %b, %H:%M", "%A, %e %b, %H:%M", "-%H:%M"], hour: ["%A, %e %b, %H:%M", "%A, %e %b, %H:%M", "-%H:%M"], day: ["%A, %e %b %Y", "%A, %e %b", "-%A, %e %b %Y"], week: ["Week from %A, %e %b %Y", "%A, %e %b", "-%A, %e %b %Y"], month: ["%B %Y", "%B", "-%B %Y"], year: ["%Y", "%Y", "-%Y"] } }, seriesSpecific: { line: {}, spline: {}, area: {}, areaspline: {}, arearange: {}, column: { groupPixelWidth: 10 }, columnrange: { groupPixelWidth: 10 }, candlestick: { groupPixelWidth: 10 }, ohlc: { groupPixelWidth: 5 }, hlc: { groupPixelWidth: 5 }, heikinashi: { groupPixelWidth: 10 } }, units: [["millisecond", [1, 2, 5, 10, 20, 25, 50, 100, 200, 500]], ["second", [1, 2, 5, 10, 15, 30]], ["minute", [1, 2, 5, 10, 15, 30]], ["hour", [1, 2, 3, 4, 6, 8, 12]], ["day", [1]], ["week", [1]], ["month", [1, 3, 6]], ["year", null]] };
    }), i(n, "Extensions/DataGrouping/DataGroupingAxisComposition.js", [n["Extensions/DataGrouping/DataGroupingDefaults.js"], n["Core/Utilities.js"]], function(o, a) {
      let r, { addEvent: s, extend: l, merge: d, pick: y } = a;
      function u(g) {
        let v = this, P = v.series;
        P.forEach(function(f) {
          f.groupPixelWidth = void 0;
        }), P.forEach(function(f) {
          f.groupPixelWidth = v.getGroupPixelWidth && v.getGroupPixelWidth(), f.groupPixelWidth && (f.hasProcessed = !0), f.applyGrouping(!!g.hasExtremesChanged);
        });
      }
      function m() {
        let g = this.series, v = g.length, P = 0, f = !1, S, w;
        for (; v--; )
          (w = g[v].options.dataGrouping) && (P = Math.max(P, y(w.groupPixelWidth, o.common.groupPixelWidth)), S = (g[v].processedXData || g[v].data).length, (g[v].groupPixelWidth || S > this.chart.plotSizeX / P || S && w.forced) && (f = !0));
        return f ? P : 0;
      }
      function h() {
        this.series.forEach(function(g) {
          g.hasProcessed = !1;
        });
      }
      function c(g, v) {
        let P;
        if (v = y(v, !0), g || (g = { forced: !1, units: null }), this instanceof r)
          for (P = this.series.length; P--; )
            this.series[P].update({ dataGrouping: g }, !1);
        else
          this.chart.options.series.forEach(function(f) {
            f.dataGrouping = typeof g == "boolean" ? g : d(g, f.dataGrouping);
          });
        this.ordinal && (this.ordinal.slope = void 0), v && this.chart.redraw();
      }
      return { compose: function(g) {
        r = g;
        let v = g.prototype;
        v.applyGrouping || (s(g, "afterSetScale", h), s(g, "postProcessData", u), l(v, { applyGrouping: u, getGroupPixelWidth: m, setDataGrouping: c }));
      } };
    }), i(n, "Extensions/DataGrouping/DataGroupingSeriesComposition.js", [n["Extensions/DataGrouping/ApproximationRegistry.js"], n["Extensions/DataGrouping/DataGroupingDefaults.js"], n["Core/Axis/DateTimeAxis.js"], n["Core/Defaults.js"], n["Core/Series/SeriesRegistry.js"], n["Core/Utilities.js"]], function(o, a, r, s, l, d) {
      let { series: { prototype: y } } = l, { addEvent: u, defined: m, error: h, extend: c, isNumber: g, merge: v, pick: P } = d, f = y.generatePoints;
      function S(j) {
        var N;
        let M, D, C = this.chart, b = this.options.dataGrouping, p = this.allowDG !== !1 && b && P(b.enabled, C.options.isStock), L = this.reserveSpace(), B = this.currentDataGrouping, T, O, I = !1;
        p && !this.requireSorting && (this.requireSorting = I = !0);
        let R = !!(this.isCartesian && !this.isDirty && !this.xAxis.isDirty && !this.yAxis.isDirty && !j) || !p;
        if (I && (this.requireSorting = !1), R)
          return;
        this.destroyGroupedData();
        let Y = b.groupAll ? this.xData : this.processedXData, F = b.groupAll ? this.yData : this.processedYData, U = C.plotSizeX, Q = this.xAxis, J = Q.options.ordinal, ee = this.groupPixelWidth;
        if (ee && Y && Y.length && U) {
          D = !0, this.isDirty = !0, this.points = null;
          let V = Q.getExtremes(), G = V.min, W = V.max, ae = J && Q.ordinal && Q.ordinal.getGroupIntervalFactor(G, W, this) || 1, z = ee * (W - G) / U * ae, q = Q.getTimeTicks(r.Additions.prototype.normalizeTimeTickInterval(z, b.units || a.units), Math.min(G, Y[0]), Math.max(W, Y[Y.length - 1]), Q.options.startOfWeek, Y, this.closestPointRange), Z = y.groupData.apply(this, [Y, F, q, b.approximation]), ne = Z.groupedXData, ie = Z.groupedYData, re = 0;
          for (b && b.smoothed && ne.length && (b.firstAnchor = "firstPoint", b.anchor = "middle", b.lastAnchor = "lastPoint", h(32, !1, C, { "dataGrouping.smoothed": "use dataGrouping.anchor" })), M = 1; M < q.length; M++)
            q.info.segmentStarts && q.info.segmentStarts.indexOf(M) !== -1 || (re = Math.max(q[M] - q[M - 1], re));
          (T = q.info).gapSize = re, this.closestPointRange = q.info.totalRange, this.groupMap = Z.groupMap, this.currentDataGrouping = T, function(de, me, ce) {
            let pe = de.options.dataGrouping, xe = de.currentDataGrouping && de.currentDataGrouping.gapSize;
            if (!(pe && de.xData && xe && de.groupMap))
              return;
            let le = me.length - 1, se = pe.anchor, he = pe.firstAnchor, ve = pe.lastAnchor, ye = me.length - 1, be = 0;
            if (he && de.xData[0] >= me[0]) {
              let ke;
              be++;
              let we = de.groupMap[0].start, Le = de.groupMap[0].length;
              g(we) && g(Le) && (ke = we + (Le - 1)), me[0] = { start: me[0], middle: me[0] + 0.5 * xe, end: me[0] + xe, firstPoint: de.xData[0], lastPoint: ke && de.xData[ke] }[he];
            }
            if (le > 0 && ve && xe && me[le] >= ce - xe) {
              ye--;
              let ke = de.groupMap[de.groupMap.length - 1].start;
              me[le] = { start: me[le], middle: me[le] + 0.5 * xe, end: me[le] + xe, firstPoint: ke && de.xData[ke], lastPoint: de.xData[de.xData.length - 1] }[ve];
            }
            if (se && se !== "start") {
              let ke = xe * { middle: 0.5, end: 1 }[se];
              for (; ye >= be; )
                me[ye] += ke, ye--;
            }
          }(this, ne, W), L && (m((N = ne)[0]) && g(Q.min) && g(Q.dataMin) && N[0] < Q.min && ((!m(Q.options.min) && Q.min <= Q.dataMin || Q.min === Q.dataMin) && (Q.min = Math.min(N[0], Q.min)), Q.dataMin = Math.min(N[0], Q.dataMin)), m(N[N.length - 1]) && g(Q.max) && g(Q.dataMax) && N[N.length - 1] > Q.max && ((!m(Q.options.max) && g(Q.dataMax) && Q.max >= Q.dataMax || Q.max === Q.dataMax) && (Q.max = Math.max(N[N.length - 1], Q.max)), Q.dataMax = Math.max(N[N.length - 1], Q.dataMax))), b.groupAll && (this.allGroupedData = ie, ne = (O = this.cropData(ne, ie, Q.min, Q.max)).xData, ie = O.yData, this.cropStart = O.start), this.processedXData = ne, this.processedYData = ie;
        } else
          this.groupMap = null, this.currentDataGrouping = void 0;
        this.hasGroupedData = D, this.preventGraphAnimation = (B && B.totalRange) !== (T && T.totalRange);
      }
      function w() {
        this.groupedData && (this.groupedData.forEach(function(j, N) {
          j && (this.groupedData[N] = j.destroy ? j.destroy() : null);
        }, this), this.groupedData.length = 0, delete this.allGroupedData);
      }
      function x() {
        f.apply(this), this.destroyGroupedData(), this.groupedData = this.hasGroupedData ? this.points : null;
      }
      function k() {
        return this.is("arearange") ? "range" : this.is("ohlc") ? "ohlc" : this.is("hlc") ? "hlc" : this.is("column") || this.options.cumulative ? "sum" : "average";
      }
      function A(j, N, M, D) {
        let C = this, b = C.data, p = C.options && C.options.data, L = [], B = [], T = [], O = j.length, I = !!N, R = [], Y = C.pointArrayMap, F = Y && Y.length, U = ["x"].concat(Y || ["y"]), Q = this.options.dataGrouping && this.options.dataGrouping.groupAll, J, ee, V, G = 0, W = 0, ae = typeof D == "function" ? D : D && o[D] ? o[D] : o[C.getDGApproximation && C.getDGApproximation() || "average"];
        if (F) {
          let q = Y.length;
          for (; q--; )
            R.push([]);
        } else
          R.push([]);
        let z = F || 1;
        for (let q = 0; q <= O; q++)
          if (!(j[q] < M[0])) {
            for (; M[G + 1] !== void 0 && j[q] >= M[G + 1] || q === O; ) {
              J = M[G], C.dataGroupInfo = { start: Q ? W : C.cropStart + W, length: R[0].length, groupStart: J }, V = ae.apply(C, R), C.pointClass && !m(C.dataGroupInfo.options) && (C.dataGroupInfo.options = v(C.pointClass.prototype.optionsToObject.call({ series: C }, C.options.data[C.cropStart + W])), U.forEach(function(Z) {
                delete C.dataGroupInfo.options[Z];
              })), V !== void 0 && (L.push(J), B.push(V), T.push(C.dataGroupInfo)), W = q;
              for (let Z = 0; Z < z; Z++)
                R[Z].length = 0, R[Z].hasNulls = !1;
              if (G += 1, q === O)
                break;
            }
            if (q === O)
              break;
            if (Y) {
              let Z, ne = C.options.dataGrouping && C.options.dataGrouping.groupAll ? q : C.cropStart + q, ie = b && b[ne] || C.pointClass.prototype.applyOptions.apply({ series: C }, [p[ne]]);
              for (let re = 0; re < F; re++)
                g(Z = ie[Y[re]]) ? R[re].push(Z) : Z === null && (R[re].hasNulls = !0);
            } else
              g(ee = I ? N[q] : null) ? R[0].push(ee) : ee === null && (R[0].hasNulls = !0);
          }
        return { groupedXData: L, groupedYData: B, groupMap: T };
      }
      function $(j) {
        let N = j.options, M = this.type, D = this.chart.options.plotOptions, C = this.useCommonDataGrouping && a.common, b = a.seriesSpecific, p = s.defaultOptions.plotOptions[M].dataGrouping;
        if (D && (b[M] || C)) {
          let L = this.chart.rangeSelector;
          p || (p = v(a.common, b[M])), N.dataGrouping = v(C, p, D.series && D.series.dataGrouping, D[M].dataGrouping, this.userOptions.dataGrouping, !N.isInternal && L && g(L.selected) && L.buttonOptions[L.selected].dataGrouping);
        }
      }
      return { compose: function(j) {
        let N = j.prototype;
        N.applyGrouping || (u(j.prototype.pointClass, "update", function() {
          if (this.dataGroup)
            return h(24, !1, this.series.chart), !1;
        }), u(j, "afterSetOptions", $), u(j, "destroy", w), c(N, { applyGrouping: S, destroyGroupedData: w, generatePoints: x, getDGApproximation: k, groupData: A }));
      }, groupData: A };
    }), i(n, "Extensions/DataGrouping/DataGrouping.js", [n["Extensions/DataGrouping/DataGroupingAxisComposition.js"], n["Extensions/DataGrouping/DataGroupingDefaults.js"], n["Extensions/DataGrouping/DataGroupingSeriesComposition.js"], n["Core/Templating.js"], n["Core/Globals.js"], n["Core/Utilities.js"]], function(o, a, r, s, l, d) {
      let { format: y } = s, { composed: u } = l, { addEvent: m, extend: h, isNumber: c, pick: g, pushUnique: v } = d;
      function P(f) {
        let S = this.chart, w = S.time, x = f.labelConfig, k = x.series, A = x.point, $ = k.options, j = k.tooltipOptions, N = $.dataGrouping, M = k.xAxis, D = j.xDateFormat, C, b, p, L, B, T = j[f.isFooter ? "footerFormat" : "headerFormat"];
        if (M && M.options.type === "datetime" && N && c(x.key)) {
          b = k.currentDataGrouping, p = N.dateTimeLabelFormats || a.common.dateTimeLabelFormats, b ? (L = p[b.unitName], b.count === 1 ? D = L[0] : (D = L[1], C = L[2])) : !D && p && M.dateTime && (D = M.dateTime.getXDateFormat(x.x, j.dateTimeLabelFormats));
          let O = g(k.groupMap?.[A.index].groupStart, x.key), I = O + b?.totalRange - 1;
          B = w.dateFormat(D, O), C && (B += w.dateFormat(C, I)), k.chart.styledMode && (T = this.styledModeFormat(T)), f.text = y(T, { point: h(x.point, { key: B }), series: k }, S), f.preventDefault();
        }
      }
      return { compose: function(f, S, w) {
        o.compose(f), r.compose(S), w && v(u, "DataGrouping") && m(w, "headerFormatter", P);
      }, groupData: r.groupData };
    }), i(n, "masters/modules/datagrouping.src.js", [n["Core/Globals.js"], n["Extensions/DataGrouping/ApproximationDefaults.js"], n["Extensions/DataGrouping/ApproximationRegistry.js"], n["Extensions/DataGrouping/DataGrouping.js"]], function(o, a, r, s) {
      return o.dataGrouping = o.dataGrouping || {}, o.dataGrouping.approximationDefaults = o.dataGrouping.approximationDefaults || a, o.dataGrouping.approximations = o.dataGrouping.approximations || r, s.compose(o.Axis, o.Series, o.Tooltip), o;
    }), i(n, "Extensions/Annotations/NavigationBindingsUtilities.js", [n["Core/Utilities.js"]], function(o) {
      let { defined: a, isNumber: r, pick: s } = o, l = { backgroundColor: "string", borderColor: "string", borderRadius: "string", color: "string", fill: "string", fontSize: "string", labels: "string", name: "string", stroke: "string", title: "string" };
      return { annotationsFieldsTypes: l, getAssignedAxis: function(d) {
        return d.filter((y) => {
          let u = y.axis.getExtremes(), m = u.min, h = u.max, c = s(y.axis.minPointOffset, 0);
          return r(m) && r(h) && y.value >= m - c && y.value <= h + c && !y.axis.options.isInternal;
        })[0];
      }, getFieldType: function(d, y) {
        let u = l[d], m = typeof y;
        return a(u) && (m = u), { string: "text", number: "number", boolean: "checkbox" }[m];
      } };
    }), i(n, "Extensions/MouseWheelZoom/MouseWheelZoom.js", [n["Core/Utilities.js"], n["Extensions/Annotations/NavigationBindingsUtilities.js"]], function(o, a) {
      let r, { addEvent: s, isObject: l, pick: d, defined: y, merge: u } = o, { getAssignedAxis: m } = a, h = [], c = { enabled: !0, sensitivity: 1.1 }, g = (f) => (l(f) || (f = { enabled: f ?? !0 }), u(c, f)), v = function(f, S, w, x, k, A, $) {
        let j = d($.type, f.zooming.type, ""), N = [];
        j === "x" ? N = w : j === "y" ? N = x : j === "xy" && (N = f.axes);
        let M = f.transform({ axes: N, to: { x: k - 5, y: A - 5, width: 10, height: 10 }, from: { x: k - 5 * S, y: A - 5 * S, width: 10 * S, height: 10 * S }, trigger: "mousewheel" });
        return M && (y(r) && clearTimeout(r), r = setTimeout(() => {
          f.pointer?.drop();
        }, 400)), M;
      };
      function P() {
        let f = g(this.zooming.mouseWheel);
        f.enabled && s(this.container, "wheel", (S) => {
          S = this.pointer?.normalize(S) || S;
          let { pointer: w } = this, x = w && !w.inClass(S.target, "highcharts-no-mousewheel");
          if (this.isInsidePlot(S.chartX - this.plotLeft, S.chartY - this.plotTop) && x) {
            let k = f.sensitivity || 1.1, A = S.detail || (S.deltaY || 0) / 120, $ = m(w.getCoordinates(S).xAxis), j = m(w.getCoordinates(S).yAxis);
            v(this, Math.pow(k, A), $ ? [$.axis] : this.xAxis, j ? [j.axis] : this.yAxis, S.chartX, S.chartY, f) && S.preventDefault?.();
          }
        });
      }
      return { compose: function(f) {
        h.indexOf(f) === -1 && (h.push(f), s(f, "afterGetContainer", P));
      } };
    }), i(n, "masters/modules/mouse-wheel-zoom.src.js", [n["Core/Globals.js"], n["Extensions/MouseWheelZoom/MouseWheelZoom.js"]], function(o, a) {
      return o.MouseWheelZoom = o.MouseWheelZoom || a, o.MouseWheelZoom.compose(o.Chart), o;
    }), i(n, "masters/modules/stock.src.js", [n["Core/Globals.js"], n["Series/DataModifyComposition.js"], n["Stock/Navigator/Navigator.js"], n["Core/Axis/OrdinalAxis.js"], n["Stock/RangeSelector/RangeSelector.js"], n["Stock/Scrollbar/Scrollbar.js"], n["Core/Chart/StockChart.js"], n["Series/OHLC/OHLCSeries.js"], n["Series/Flags/FlagsSeries.js"]], function(o, a, r, s, l, d, y, u, m) {
      return o.Navigator = o.Navigator || r, o.OrdinalAxis = o.OrdinalAxis || s, o.RangeSelector = o.RangeSelector || l, o.Scrollbar = o.Scrollbar || d, o.stockChart = o.stockChart || y.stockChart, o.StockChart = o.StockChart || o.stockChart, o.extend(o.StockChart, y), a.compose(o.Series, o.Axis, o.Point), m.compose(o.Renderer), u.compose(o.Series), o.Navigator.compose(o.Chart, o.Axis, o.Series), o.OrdinalAxis.compose(o.Axis, o.Series, o.Chart), o.RangeSelector.compose(o.Axis, o.Chart), o.Scrollbar.compose(o.Axis), o.StockChart.compose(o.Chart, o.Axis, o.Series, o.SVGRenderer), o;
    }), i(n, "masters/highstock.src.js", [n["masters/highcharts.src.js"]], function(o) {
      return o.product = "Highstock", o;
    }), n["masters/highstock.src.js"]._modules = n, n["masters/highstock.src.js"];
  });
})(_L);
var IMe = _L.exports;
const PMe = /* @__PURE__ */ en(IMe), AMe = { class: "d-premium-discount-historic-chart" }, _Me = { class: "d-premium-discount-historic-chart__days" }, MMe = ["aria-label", "onKeypress", "onMouseover"], OMe = { class: "d-premium-discount-historic-chart__days__container" }, BMe = { class: "d-premium-discount-historic-chart__days__container__title" }, EMe = { class: "d-premium-discount-historic-chart__highchart" }, Px = "#007d85", nr = "#ebeef0", Ur = "#5A6D78", DMe = "#489CD2", Ax = "#abd654", ko = '"DwsSlab", Helvetica, Arial, sans-serif', Wr = "14px", RMe = /* @__PURE__ */ Be({
  __name: "PremiumDiscountHistoricChart",
  props: {
    model: {
      type: Object,
      required: !0
    },
    trackingDropdownName: {
      type: String,
      default: "Premium Discount Historic Chart"
    }
  },
  emits: ["changeDateRange"],
  setup(e, { emit: t }) {
    const { t: n } = Je(), i = ho(), o = ge(
      i?.parent?.type.__name == "AccordionItem"
    ), a = e, r = a.model.selected, s = t, l = Math.max(...a.model.dataSeries.map((w) => w[1] ?? 0)), d = Math.ceil(l * 0.4), y = l + d, u = {
      ..._s,
      series: [
        {
          dataLabels: {
            style: {
              textShadow: "0px 0px"
            }
          },
          type: "column",
          name: "No data"
        }
      ],
      chart: {
        type: "column",
        spacingLeft: 0,
        spacingRight: 0,
        spacingTop: 0,
        spacingBottom: 48,
        marginLeft: 0,
        panning: {
          enabled: !1
        },
        styledMode: !1,
        style: {
          fontFamily: ko,
          fontSize: Wr,
          fontWeight: "400",
          color: Ur
        }
      },
      plotOptions: {
        series: {
          color: Px,
          marker: {
            enabled: !1
          }
        },
        flags: {
          y: -320,
          style: {
            fontFamily: "SlabBold",
            color: "#ffffff",
            fontWeight: "400",
            borderRadius: 12
          }
        },
        column: {
          stacking: "normal",
          pointPadding: 0,
          groupPadding: 0,
          pointPlacement: -0.5,
          dataLabels: {
            enabled: !0,
            verticalAlign: "top",
            align: "center",
            y: -28,
            style: {
              color: Px,
              fontWeight: "700",
              fontFamily: ko,
              textOutline: "0px 0px",
              fontSize: Wr
            }
          },
          states: {
            hover: {
              enabled: !0,
              color: Ax
            }
          }
        }
      },
      xAxis: [
        {
          gridLineWidth: 0,
          plotBands: [
            {
              color: nr,
              from: -4,
              to: -4
            }
          ],
          tickPositions: [
            -4,
            -3.5,
            -3,
            -2.5,
            -2,
            -1.5,
            -1,
            -0.5,
            0,
            0.5,
            1,
            1.5,
            2,
            2.5,
            3,
            3.5,
            4
          ],
          min: -4,
          max: 4,
          tickInterval: 0.5,
          endOnTick: !0,
          startOnTick: !0,
          showFirstLabel: !0,
          showLastLabel: !0,
          lineWidth: 1,
          lineColor: nr,
          tickWidth: 1,
          tickLength: 10,
          tickColor: nr,
          plotLines: [
            {
              color: "transparent",
              value: 0,
              width: 1,
              label: {
                y: 380,
                x: -12,
                rotation: 0,
                text: "│",
                // Divider
                style: {
                  color: nr,
                  fontWeight: "400",
                  fontFamily: ko,
                  fontSize: 24
                }
              }
            },
            {
              color: "transparent",
              width: 1,
              value: 0,
              label: {
                text: n("premiumDiscountHistoricChart.discount"),
                //'Discount'
                textAlign: "right",
                y: 380,
                x: -16,
                rotation: 0,
                style: {
                  color: Ur,
                  fontWeight: "400",
                  fontFamily: ko,
                  fontSize: Wr
                }
              }
            },
            {
              color: "transparent",
              width: 1,
              value: 0,
              label: {
                text: n("premiumDiscountHistoricChart.premium"),
                //'Premium'
                textAlign: "left",
                y: 380,
                x: 16,
                rotation: 0,
                style: {
                  color: Ur,
                  fontWeight: "400",
                  fontFamily: ko,
                  fontSize: Wr
                }
              }
            }
          ],
          type: "linear",
          title: {
            text: ""
          },
          labels: {
            style: {
              color: Ur,
              fontWeight: "400",
              fontSize: Wr,
              fontFamily: ko
            },
            enabled: !0,
            formatter: function() {
              return Number(this.value) > 4 || Number(this.value) < -4 || Number(this.value) == this.axis?.min ? "" : Number(this.value).toFixed(1);
            }
          }
        }
      ],
      yAxis: [
        {
          lineWidth: 0,
          lineColor: nr,
          gridLineWidth: 0,
          max: y,
          labels: {
            enabled: !1
          },
          title: {
            text: n("premiumDiscountHistoricChart.yAxisLabel"),
            //'Number of Days'
            style: {
              color: Ur,
              fontFamily: ko,
              fontWeight: "400",
              fontSize: Wr
            },
            y: 200,
            x: 24,
            textAlign: "left",
            align: "high",
            rotation: -90
          }
        }
      ],
      tooltip: {
        outside: !0,
        enabled: !1
      },
      responsive: {
        rules: [
          {
            condition: {
              maxWidth: 576
            },
            chartOptions: {
              yAxis: [
                {
                  title: {
                    y: 14,
                    x: 20,
                    textAlign: "left",
                    align: "high",
                    rotation: 0
                  }
                }
              ],
              plotOptions: {
                flags: {
                  y: -288
                }
              }
            }
          }
        ]
      }
    }, m = ge(), h = ge(), c = [
      {
        type: "column",
        name: "bps",
        data: a.model.dataSeries,
        states: {
          hover: {
            color: Ax
          }
        }
      },
      {
        type: "flags",
        accessibility: {
          exposeAsGroupOnly: !0,
          description: "Flagged events."
        },
        data: [
          {
            x: 0,
            title: n("premiumDiscountHistoricChart.nav"),
            // 'NAV'
            color: "white"
          }
        ],
        fillColor: Ur,
        shape: "flag",
        height: 20,
        width: 38,
        fontFamily: ko,
        fontSize: "12px",
        lineWidth: 1,
        lineStyle: "ShortDot",
        lineColor: nr,
        states: {
          enabled: !1,
          hover: {
            fillColor: DMe,
            lineColor: nr
          }
        }
      }
    ];
    u.series = c, it(() => {
      h.value = PMe.chart(
        m.value.baseChart.chartRef.id,
        u
      );
    });
    function g(w) {
      s("changeDateRange", w);
    }
    function v(w) {
      w.forEach(
        (x) => h.value?.series[0]?.data[x].setState("hover")
      );
    }
    function P(w) {
      f(), v(w);
    }
    function f() {
      for (let w = 0; w < a.model.dataSeries.length; w++)
        h.value?.series[0]?.data[w].setState();
    }
    const S = Te(() => {
      const w = [
        "DaysAtNAV",
        "DaysAtDiscount",
        "DaysBetween",
        "DaysAtPremium",
        "Ratio"
      ];
      return a.model.dataDays.sort(
        (x, k) => w.indexOf(x.type) - w.indexOf(k.type)
      );
    });
    return (w, x) => (E(), X("div", AMe, [
      ue(_(vi), {
        "has-filter": !0,
        "filter-placeholder": "",
        items: e.model.dateRanges,
        selected: _(r),
        "show-image": !1,
        "event-component-name": e.trackingDropdownName,
        class: "d-premium-discount-historic-chart__daterange-dropdown",
        onSelectedItemChanged: g
      }, null, 8, ["items", "selected", "event-component-name"]),
      oe("div", _Me, [
        (E(!0), X(Re, null, Ge(S.value, (k) => (E(), X("div", {
          key: k.type,
          class: "d-premium-discount-historic-chart__days__item",
          tabindex: "0",
          role: "button",
          "aria-label": `${k.value} ${k.title}`,
          onKeypress: Ze((A) => P(k.days), ["enter"]),
          onMouseover: (A) => v(k.days),
          onMouseout: x[0] || (x[0] = (A) => f())
        }, [
          oe("div", OMe, [
            oe("span", BMe, Ie(k.title), 1),
            oe("span", {
              class: Pe(["d-premium-discount-historic-chart__days__container__value", {
                "d-premium-discount-historic-chart__days__container__value--highlight": k.type === "DaysAtDiscount" || k.type === "DaysBetween" || k.type === "DaysAtPremium",
                "d-premium-discount-historic-chart__days__container__value--inside": o.value
              }])
            }, Ie(k.value), 3)
          ])
        ], 40, MMe))), 128))
      ]),
      oe("div", EMe, [
        ue(_(Xc), {
          ref_key: "historicChart",
          ref: m,
          options: u,
          "chart-type": _(Ra).Chart,
          height: _(Vo).Small
        }, null, 8, ["chart-type", "height"])
      ]),
      ue(_(Na), {
        class: "d-premium-discount-historic-chart__disclaimer",
        text: e.model.disclaimer
      }, null, 8, ["text"])
    ]));
  }
});
const DEe = /* @__PURE__ */ Fe(RMe, [["__scopeId", "data-v-64105319"]]), NMe = { class: "d-premium-discount-line-chart" }, $Me = { class: "d-premium-discount-historic-chart__highchart" }, FMe = "#007D85", jMe = "#5A6D78", Vd = "#ebeef0", HMe = "'DwsSlab', -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol", zMe = "14px", VMe = "400", GMe = /* @__PURE__ */ Be({
  __name: "PremiumDiscountLineChart",
  props: {
    model: {
      type: Object,
      required: !0
    }
  },
  setup(e) {
    const { toUnixTimestamp: t, formatDateWithPrimeFormat: n } = vm(), { t: i, currentLocale: o } = Je(), a = e, r = ge([]), s = ge(a.model.chartDataSeries[0][0]), l = Math.max(...a.model.chartDataSeries.map((v) => v[1] ?? 0)), d = Math.min(...a.model.chartDataSeries.map((v) => v[1] ?? 0)), y = l + -d, u = Math.round(y / 6) > 50 ? 100 : Math.round(y / 6), m = {
      color: jMe,
      fontWeight: VMe,
      fontSize: zMe,
      fontFamily: HMe
    };
    a.model.chartDataSeries.forEach(function(v) {
      r.value.push([
        t(v[0]).value,
        v[1]
      ]);
    });
    const h = {
      ..._s,
      title: {
        text: ""
        //Premium/Discount Line Graph',
      },
      series: [
        {
          type: "line",
          name: "No data"
        }
      ],
      chart: {
        panning: {
          enabled: !1
        },
        styledMode: !1,
        style: m
      },
      plotOptions: {
        series: {
          //lineWidth: 2,
          color: FMe,
          marker: {
            enabled: !1
          },
          states: {
            hover: {
              //lineWidth: 3,
              enabled: !0
            }
          }
        }
      },
      xAxis: [
        {
          crosshair: {
            interpolate: !0,
            snap: !1
          },
          padding: "16px",
          offset: 16,
          lineWidth: 0,
          type: "datetime",
          tickInterval: 3 * 30 * 24 * 3600 * 1e3,
          lineColor: Vd,
          tickColor: "transparent",
          startOnTick: !1,
          labels: {
            align: "right",
            //reserveSpace: true,
            overflow: "justify",
            style: m,
            color: Vd,
            formatter: function() {
              const v = new Date(this.value);
              return `Q${Math.floor((v.getMonth() + 3) / 3)} ${v.getFullYear()}`;
            }
          },
          plotBands: [
            {
              color: Vd,
              from: s,
              to: s
            }
          ]
        }
      ],
      yAxis: [
        {
          lineColor: Vd,
          padding: 16,
          startOnTick: !0,
          endOnTick: !1,
          tickInterval: u,
          offset: 16,
          labels: {
            step: 1,
            style: m
          },
          title: {
            text: i("premiumDiscountLineChart.yAxisLabel"),
            //'Premium or discounts (bps)',
            margin: 24,
            style: m
          },
          opposite: !1
        }
      ],
      tooltip: {
        positioner: function(v, P, f) {
          const S = this.chart.chartWidth, w = (f.plotX ? f.plotX : 0) + v > S ? Math.round(S - v) : Math.round((f.plotX ? f.plotX : 0) + v / 2 - 52), x = w > 0 ? w : 0, A = (f.plotY ? f.plotY : 0) - P - 4;
          return {
            x,
            y: A
          };
        },
        borderColor: "transparent",
        backgroundColor: "transparent",
        shadow: !1,
        useHTML: !0,
        split: !1,
        outside: !0,
        distance: 8,
        stickOnContact: !1
      },
      responsive: {
        rules: [
          {
            condition: {
              maxWidth: 375
            },
            chartOptions: {
              xAxis: [
                {
                  offset: 8,
                  labels: {
                    step: 2
                  }
                }
              ],
              yAxis: {
                offset: 8
              }
            }
          }
        ]
      }
    }, c = h.tooltip;
    c.formatter = function() {
      return '<table class="highchart-discount-chart-tooltip"><thead><tr><th>' + i("globalTranslations.date") + '</th></tr><tr><td class="highchart-discount-chart-tooltip-date">' + n(new Date(this.x)) + '</td></tr></thead><tbody><tr><th>bps</th></tr><tr><td class="highchart-discount-chart-tooltip-value">' + this.y?.toLocaleString(o.value.toString(), {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }) + "</td></tr></tbody> </table>";
    };
    const g = [
      {
        cursor: "pointer",
        type: "line",
        name: "bps",
        data: r.value
      }
    ];
    return h.series = g, (v, P) => (E(), X("div", NMe, [
      oe("div", $Me, [
        ue(_(Xc), {
          ref: "lineChart",
          options: h,
          "chart-type": _(Ra).Chart,
          height: _(Vo).Small
        }, null, 8, ["chart-type", "height"])
      ])
    ]));
  }
});
const REe = /* @__PURE__ */ Fe(GMe, [["__scopeId", "data-v-700b2199"]]);
var dr = /* @__PURE__ */ ((e) => (e.LeftAligned = "left-aligned", e.RightAligned = "right-aligned", e))(dr || {});
const UMe = { class: "d-container" }, WMe = { class: "d-quote__author" }, YMe = { class: "d-quote__footer" }, qMe = {
  key: 0,
  class: "d-quote__image-container"
}, KMe = /* @__PURE__ */ Be({
  __name: "Quote",
  props: {
    model: {
      type: Object,
      required: !0
    }
  },
  setup(e) {
    const t = () => [
      {
        height: 375,
        width: 375,
        dxBreakpoint: Ct.Xs
      },
      {
        height: 564,
        width: 336,
        dxBreakpoint: Ct.Lg
      },
      {
        height: 656,
        width: 460,
        dxBreakpoint: Ct.Xxl
      }
    ];
    return (n, i) => {
      const o = $e("BaseText"), a = $e("BaseImage");
      return E(), X("div", UMe, [
        e.model ? (E(), X("div", {
          key: 0,
          class: Pe(["d-quote", {
            "d-quote--bg-white": e.model.backgroundColor === _(Zt).White,
            "d-quote--bg-grey": e.model.backgroundColor === _(Zt).Grey
          }])
        }, [
          oe("div", {
            class: Pe(["d-quote__container", {
              "d-quote__container--left": e.model.displayOption === _(dr).LeftAligned,
              "d-quote__container--right": e.model.displayOption === _(dr).RightAligned
            }])
          }, [
            oe("div", {
              class: Pe(["d-quote__content", {
                "d-quote__content--no-image": !e.model.authorImage
              }])
            }, [
              ue(Uf, {
                quote: e.model.quote,
                class: "d-quote__quote"
              }, null, 8, ["quote"]),
              oe("div", WMe, [
                ue(o, {
                  text: e.model.authorName,
                  "font-size": _(st).SixteenPx,
                  "font-type": _(lt).DwsSlabBold
                }, null, 8, ["text", "font-size", "font-type"]),
                ue(o, {
                  text: e.model.authorPosition,
                  "font-size": _(st).FourteenPx
                }, null, 8, ["text", "font-size"])
              ]),
              oe("div", YMe, [
                e.model.link ? (E(), fe(ot, {
                  key: 0,
                  "link-model": e.model.link,
                  icon: _(H).ArrowRight
                }, null, 8, ["link-model", "icon"])) : te("", !0),
                e.model.socialMediaLink && e.model.metaTags ? (E(), fe(xIe, {
                  key: 1,
                  "link-model": e.model.socialMediaLink,
                  "meta-tags": e.model.metaTags
                }, null, 8, ["link-model", "meta-tags"])) : te("", !0)
              ])
            ], 2),
            e.model.authorImage ? (E(), X("div", qMe, [
              ue(a, {
                model: e.model.authorImage,
                "responsive-options": t(),
                class: "d-quote__image"
              }, null, 8, ["model", "responsive-options"]),
              i[0] || (i[0] = oe("div", { class: "d-quote__corner-left-1" }, null, -1)),
              i[1] || (i[1] = oe("div", { class: "d-quote__corner-left-2" }, null, -1)),
              i[2] || (i[2] = oe("div", { class: "d-quote__corner-right-1" }, null, -1)),
              i[3] || (i[3] = oe("div", { class: "d-quote__corner-right-2" }, null, -1))
            ])) : te("", !0),
            e.model.backgroundColor === _(Zt).Grey && e.model.authorImage ? (E(), X(Re, { key: 1 }, [
              oe("div", {
                class: Pe(["d-quote__stroke-1", {
                  "d-quote__stroke-1--left": e.model.displayOption === _(dr).RightAligned,
                  "d-quote__stroke-1--right": e.model.displayOption === _(dr).LeftAligned
                }])
              }, null, 2),
              oe("div", {
                class: Pe(["d-quote__stroke-2", {
                  "d-quote__stroke-2--left": e.model.displayOption === _(dr).RightAligned,
                  "d-quote__stroke-2--right": e.model.displayOption === _(dr).LeftAligned
                }])
              }, null, 2)
            ], 64)) : te("", !0)
          ], 2),
          e.model.backgroundColor === _(Zt).Grey ? (E(), X(Re, { key: 0 }, [
            i[4] || (i[4] = oe("div", { class: "d-quote__left-triangle" }, null, -1)),
            i[5] || (i[5] = oe("div", { class: "d-quote__right-triangle" }, null, -1))
          ], 64)) : te("", !0)
        ], 2)) : te("", !0)
      ]);
    };
  }
});
const NEe = /* @__PURE__ */ Fe(KMe, [["__scopeId", "data-v-05452f0b"]]), XMe = ["data-event_source", "aria-label"], ZMe = {
  key: 0,
  class: "d-sticky-navigation-item__name"
}, JMe = ["href", "data-event_source", "data-event_title", "aria-label"], QMe = { class: "d-sticky-navigation-item__name" }, eOe = /* @__PURE__ */ Be({
  __name: "StickyNavigationItem",
  props: {
    model: {
      type: Object,
      required: !0
    }
  },
  setup(e) {
    const { t } = Je(), { pageName: n } = Qe(), i = e, o = n;
    function a(r) {
      return r.length < 20 ? r : r.substring(0, 19) + "..";
    }
    return (r, s) => e.model.isBackToTop ? (E(), X("button", {
      key: 0,
      class: "d-sticky-navigation-item d-sticky-navigation-item--back-to-top",
      "data-event_source": _(o),
      "data-event_component_name": "Sticky Navigation",
      "data-event_title": "Jumpmark",
      "aria-label": _(t)("stickyNavigation.dataEventTitle"),
      tabindex: "0"
    }, [
      ue(_t, {
        class: "d-sticky-navigation-item__icon",
        "base-icon": _(H).ArrowUp
      }, null, 8, ["base-icon"]),
      i.model.name ? (E(), X("span", ZMe, Ie(a(i.model.name)), 1)) : te("", !0)
    ], 8, XMe)) : (E(), X("a", {
      key: 1,
      class: Pe(["d-sticky-navigation-item", { active: e.model.isActive }]),
      href: e.model?.url,
      "data-event_source": _(o),
      "data-event_component_name": "Sticky Navigation",
      "data-event_title": e.model.name,
      "aria-label": e.model.name,
      tabindex: "0"
    }, [
      ue(_t, {
        class: "d-sticky-navigation-item__icon",
        "base-icon": e.model.icon
      }, null, 8, ["base-icon"]),
      oe("span", QMe, Ie(a(i.model.name)), 1)
    ], 10, JMe));
  }
});
const Gd = /* @__PURE__ */ Fe(eOe, [["__scopeId", "data-v-d7cb07d9"]]);
var tOe = `
@layer primevue {
    .p-sidebar-mask {
        display: none;
        pointer-events: none;
        background-color: transparent;
        transition-property: background-color;
    }

    .p-sidebar-mask.p-component-overlay {
        pointer-events: auto;
    }

    .p-sidebar-visible {
        display: flex;
    }

    .p-sidebar {
        display: flex;
        flex-direction: column;
        pointer-events: auto;
        transform: translate3d(0px, 0px, 0px);
        position: relative;
        transition: transform 0.3s;
    }

    .p-sidebar-content {
        overflow-y: auto;
        flex-grow: 1;
    }

    .p-sidebar-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        flex-shrink: 0;
    }

    .p-sidebar-icon {
        display: flex;
        align-items: center;
        justify-content: center;
        overflow: hidden;
        position: relative;
    }

    .p-sidebar-full .p-sidebar {
        transition: none;
        transform: none;
        width: 100vw !important;
        height: 100vh !important;
        max-height: 100%;
        top: 0px !important;
        left: 0px !important;
    }

    /* Animation */
    /* Center */
    .p-sidebar-left .p-sidebar-enter-from,
    .p-sidebar-left .p-sidebar-leave-to {
        transform: translateX(-100%);
    }
    .p-sidebar-right .p-sidebar-enter-from,
    .p-sidebar-right .p-sidebar-leave-to {
        transform: translateX(100%);
    }
    .p-sidebar-top .p-sidebar-enter-from,
    .p-sidebar-top .p-sidebar-leave-to {
        transform: translateY(-100%);
    }
    .p-sidebar-bottom .p-sidebar-enter-from,
    .p-sidebar-bottom .p-sidebar-leave-to {
        transform: translateY(100%);
    }
    .p-sidebar-full .p-sidebar-enter-from,
    .p-sidebar-full .p-sidebar-leave-to {
        opacity: 0;
    }
    .p-sidebar-full .p-sidebar-enter-active,
    .p-sidebar-full .p-sidebar-leave-active {
        transition: opacity 400ms cubic-bezier(0.25, 0.8, 0.25, 1);
    }

    /* Size */
    .p-sidebar-left .p-sidebar {
        width: 20rem;
        height: 100%;
    }

    .p-sidebar-right .p-sidebar {
        width: 20rem;
        height: 100%;
    }

    .p-sidebar-top .p-sidebar {
        height: 10rem;
        width: 100%;
    }

    .p-sidebar-bottom .p-sidebar {
        height: 10rem;
        width: 100%;
    }

    .p-sidebar-left .p-sidebar-sm,
    .p-sidebar-right .p-sidebar-sm {
        width: 20rem;
    }

    .p-sidebar-left .p-sidebar-md,
    .p-sidebar-right .p-sidebar-md {
        width: 40rem;
    }

    .p-sidebar-left .p-sidebar-lg,
    .p-sidebar-right .p-sidebar-lg {
        width: 60rem;
    }

    .p-sidebar-top .p-sidebar-sm,
    .p-sidebar-bottom .p-sidebar-sm {
        height: 10rem;
    }

    .p-sidebar-top .p-sidebar-md,
    .p-sidebar-bottom .p-sidebar-md {
        height: 20rem;
    }

    .p-sidebar-top .p-sidebar-lg,
    .p-sidebar-bottom .p-sidebar-lg {
        height: 30rem;
    }

    .p-sidebar-left .p-sidebar-content,
    .p-sidebar-right .p-sidebar-content,
    .p-sidebar-top .p-sidebar-content,
    .p-sidebar-bottom .p-sidebar-content {
        width: 100%;
        height: 100%;
    }

    @media screen and (max-width: 64em) {
        .p-sidebar-left .p-sidebar-lg,
        .p-sidebar-left .p-sidebar-md,
        .p-sidebar-right .p-sidebar-lg,
        .p-sidebar-right .p-sidebar-md {
            width: 20rem;
        }
    }
}
`, nOe = {
  mask: function(t) {
    var n = t.position;
    return {
      position: "fixed",
      height: "100%",
      width: "100%",
      left: 0,
      top: 0,
      display: "flex",
      justifyContent: n === "left" ? "flex-start" : n === "right" ? "flex-end" : "center",
      alignItems: n === "top" ? "flex-start" : n === "bottom" ? "flex-end" : "center"
    };
  }
}, iOe = {
  mask: function(t) {
    var n = t.instance, i = t.props, o = ["left", "right", "top", "bottom"], a = o.find(function(r) {
      return r === i.position;
    });
    return ["p-sidebar-mask", {
      "p-component-overlay p-component-overlay-enter": i.modal,
      "p-sidebar-mask-scrollblocker": i.blockScroll,
      "p-sidebar-visible": n.containerVisible,
      "p-sidebar-full": n.fullScreen
    }, a ? "p-sidebar-".concat(a) : ""];
  },
  root: function(t) {
    var n = t.instance;
    return ["p-sidebar p-component", {
      "p-input-filled": n.$primevue.config.inputStyle === "filled",
      "p-ripple-disabled": n.$primevue.config.ripple === !1,
      "p-sidebar-full": n.fullScreen
    }];
  },
  header: "p-sidebar-header",
  title: "p-sidebar-header-content",
  closeButton: "p-sidebar-close p-sidebar-icon p-link",
  closeIcon: "p-sidebar-close-icon",
  content: "p-sidebar-content"
}, aOe = Wt.extend({
  name: "sidebar",
  css: tOe,
  classes: iOe,
  inlineStyles: nOe
}), oOe = {
  name: "BaseSidebar",
  extends: wt,
  props: {
    visible: {
      type: Boolean,
      default: !1
    },
    position: {
      type: String,
      default: "left"
    },
    header: {
      type: null,
      default: null
    },
    baseZIndex: {
      type: Number,
      default: 0
    },
    autoZIndex: {
      type: Boolean,
      default: !0
    },
    dismissable: {
      type: Boolean,
      default: !0
    },
    showCloseIcon: {
      type: Boolean,
      default: !0
    },
    closeIcon: {
      type: String,
      default: void 0
    },
    modal: {
      type: Boolean,
      default: !0
    },
    blockScroll: {
      type: Boolean,
      default: !1
    }
  },
  style: aOe,
  provide: function() {
    return {
      $parentInstance: this
    };
  }
}, ML = {
  name: "Sidebar",
  extends: oOe,
  inheritAttrs: !1,
  emits: ["update:visible", "show", "hide", "after-hide"],
  data: function() {
    return {
      containerVisible: this.visible
    };
  },
  container: null,
  mask: null,
  content: null,
  headerContainer: null,
  closeButton: null,
  outsideClickListener: null,
  documentKeydownListener: null,
  updated: function() {
    this.visible && (this.containerVisible = this.visible);
  },
  beforeUnmount: function() {
    this.disableDocumentSettings(), this.mask && this.autoZIndex && qt.clear(this.mask), this.container = null, this.mask = null;
  },
  methods: {
    hide: function() {
      this.$emit("update:visible", !1);
    },
    onEnter: function() {
      this.$emit("show"), this.focus(), this.bindDocumentKeyDownListener(), this.autoZIndex && qt.set("modal", this.mask, this.baseZIndex || this.$primevue.config.zIndex.modal);
    },
    onAfterEnter: function() {
      this.enableDocumentSettings();
    },
    onBeforeLeave: function() {
      this.modal && !this.isUnstyled && Oe.addClass(this.mask, "p-component-overlay-leave");
    },
    onLeave: function() {
      this.$emit("hide");
    },
    onAfterLeave: function() {
      this.autoZIndex && qt.clear(this.mask), this.unbindDocumentKeyDownListener(), this.containerVisible = !1, this.disableDocumentSettings(), this.$emit("after-hide");
    },
    onMaskClick: function(t) {
      this.dismissable && this.modal && this.mask === t.target && this.hide();
    },
    focus: function() {
      var t = function(o) {
        return o && o.querySelector("[autofocus]");
      }, n = this.$slots.header && t(this.headerContainer);
      n || (n = this.$slots.default && t(this.container), n || (n = this.closeButton)), n && Oe.focus(n);
    },
    enableDocumentSettings: function() {
      this.dismissable && !this.modal && this.bindOutsideClickListener(), this.blockScroll && Oe.blockBodyScroll();
    },
    disableDocumentSettings: function() {
      this.unbindOutsideClickListener(), this.blockScroll && Oe.unblockBodyScroll();
    },
    onKeydown: function(t) {
      t.code === "Escape" && this.hide();
    },
    containerRef: function(t) {
      this.container = t;
    },
    maskRef: function(t) {
      this.mask = t;
    },
    contentRef: function(t) {
      this.content = t;
    },
    headerContainerRef: function(t) {
      this.headerContainer = t;
    },
    closeButtonRef: function(t) {
      this.closeButton = t;
    },
    bindDocumentKeyDownListener: function() {
      this.documentKeydownListener || (this.documentKeydownListener = this.onKeydown, document.addEventListener("keydown", this.documentKeydownListener));
    },
    unbindDocumentKeyDownListener: function() {
      this.documentKeydownListener && (document.removeEventListener("keydown", this.documentKeydownListener), this.documentKeydownListener = null);
    },
    bindOutsideClickListener: function() {
      var t = this;
      this.outsideClickListener || (this.outsideClickListener = function(n) {
        t.isOutsideClicked(n) && t.hide();
      }, document.addEventListener("click", this.outsideClickListener));
    },
    unbindOutsideClickListener: function() {
      this.outsideClickListener && (document.removeEventListener("click", this.outsideClickListener), this.outsideClickListener = null);
    },
    isOutsideClicked: function(t) {
      return this.container && !this.container.contains(t.target);
    }
  },
  computed: {
    fullScreen: function() {
      return this.position === "full";
    },
    closeAriaLabel: function() {
      return this.$primevue.config.locale.aria ? this.$primevue.config.locale.aria.close : void 0;
    }
  },
  directives: {
    focustrap: qu,
    ripple: An
  },
  components: {
    Portal: Yn,
    TimesIcon: Ho
  }
};
function Hc(e) {
  "@babel/helpers - typeof";
  return Hc = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Hc(e);
}
function _x(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    t && (i = i.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), n.push.apply(n, i);
  }
  return n;
}
function Mx(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? _x(Object(n), !0).forEach(function(i) {
      rOe(e, i, n[i]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : _x(Object(n)).forEach(function(i) {
      Object.defineProperty(e, i, Object.getOwnPropertyDescriptor(n, i));
    });
  }
  return e;
}
function rOe(e, t, n) {
  return t = sOe(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function sOe(e) {
  var t = lOe(e, "string");
  return Hc(t) == "symbol" ? t : String(t);
}
function lOe(e, t) {
  if (Hc(e) != "object" || !e)
    return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var i = n.call(e, t || "default");
    if (Hc(i) != "object")
      return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var cOe = ["aria-modal"], dOe = ["aria-label"];
function uOe(e, t, n, i, o, a) {
  var r = $e("Portal"), s = Ut("ripple"), l = Ut("focustrap");
  return E(), fe(r, null, {
    default: Se(function() {
      return [o.containerVisible ? (E(), X("div", Ce({
        key: 0,
        ref: a.maskRef,
        onMousedown: t[1] || (t[1] = function() {
          return a.onMaskClick && a.onMaskClick.apply(a, arguments);
        }),
        class: e.cx("mask"),
        style: e.sx("mask", !0, {
          position: e.position
        })
      }, e.ptm("mask")), [ue(ia, Ce({
        name: "p-sidebar",
        onEnter: a.onEnter,
        onAfterEnter: a.onAfterEnter,
        onBeforeLeave: a.onBeforeLeave,
        onLeave: a.onLeave,
        onAfterLeave: a.onAfterLeave,
        appear: ""
      }, e.ptm("transition")), {
        default: Se(function() {
          return [e.visible ? rt((E(), X("div", Ce({
            key: 0,
            ref: a.containerRef,
            class: e.cx("root"),
            role: "complementary",
            "aria-modal": e.modal
          }, Mx(Mx({}, e.$attrs), e.ptm("root"))), [e.$slots.container ? je(e.$slots, "container", {
            key: 0,
            onClose: a.hide,
            closeCallback: a.hide
          }) : (E(), X(Re, {
            key: 1
          }, [oe("div", Ce({
            ref: a.headerContainerRef,
            class: e.cx("header")
          }, e.ptm("header")), [je(e.$slots, "header", {
            class: Pe(e.cx("title"))
          }, function() {
            return [e.header ? (E(), X("div", Ce({
              key: 0,
              class: e.cx("title")
            }, e.ptm("title")), Ie(e.header), 17)) : te("", !0)];
          }), e.showCloseIcon ? rt((E(), X("button", Ce({
            key: 0,
            ref: a.closeButtonRef,
            type: "button",
            class: e.cx("closeButton"),
            "aria-label": a.closeAriaLabel,
            onClick: t[0] || (t[0] = function() {
              return a.hide && a.hide.apply(a, arguments);
            })
          }, e.ptm("closeButton"), {
            "data-pc-group-section": "iconcontainer"
          }), [je(e.$slots, "closeicon", {
            class: Pe(e.cx("closeIcon"))
          }, function() {
            return [(E(), fe(tt(e.closeIcon ? "span" : "TimesIcon"), Ce({
              class: [e.cx("closeIcon"), e.closeIcon]
            }, e.ptm("closeIcon")), null, 16, ["class"]))];
          })], 16, dOe)), [[s]]) : te("", !0)], 16), oe("div", Ce({
            ref: a.contentRef,
            class: e.cx("content")
          }, e.ptm("content")), [je(e.$slots, "default")], 16)], 64))], 16, cOe)), [[l]]) : te("", !0)];
        }),
        _: 3
      }, 16, ["onEnter", "onAfterEnter", "onBeforeLeave", "onLeave", "onAfterLeave"])], 16)) : te("", !0)];
    }),
    _: 3
  });
}
ML.render = uOe;
const hOe = {
  class: "d-sticky-navigation",
  role: "main"
}, pOe = ["aria-label"], fOe = ["aria-label"], mOe = ["id"], gOe = { key: 0 }, vOe = /* @__PURE__ */ Be({
  __name: "StickyNavigation",
  props: {
    model: {
      type: Object,
      required: !0
    }
  },
  setup(e) {
    const t = e, { t: n } = Je(), {
      shrinkHeaderRef: i,
      calculateScrollPosition: o,
      willStickyElementExpand: a,
      setShrinkHeader: r,
      isShrinkHeaderExpanded: s,
      isHeaderExpanded: l,
      headerHeight: d,
      shrinkHeaderHeight: y
    } = Fn(), { rootFontSize: u } = Hu(), m = $t("smoothScroll"), h = ge(!1), c = ge(""), g = ge(!0), v = ge(!1), P = ge(null), f = {
      eventSource: Qe().pageName,
      eventComponentName: "StickyNavigation",
      eventTitle: "Mobile | Open"
    }, S = {
      href: "",
      contentUrl: "",
      title: "",
      text: "",
      target: "",
      isLocked: !1,
      isExternal: !1,
      linkType: za.Javascript,
      tealiumTrackingModel: f
    };
    function w() {
      h.value = !1, m({
        scrollTo: 0,
        duration: 1e3,
        updateHistory: !1
      });
    }
    function x(D) {
      if (!Ue)
        return;
      const C = document.getElementById(D?.id || "");
      if (!C)
        return;
      k(C, 0, D.icon);
      const b = $(C);
      b && b.focus({ preventScroll: !0 });
    }
    function k(D, C, b) {
      m({
        scrollTo: o(D, A()),
        duration: 1e3,
        offset: b === H.ChartBar ? u.value * 13.75 : -C,
        updateHistory: !1
      });
    }
    function A() {
      return g.value ? (g.value = !1, y()) : 0;
    }
    function $(D) {
      const C = D.querySelectorAll(
        'a, button, textarea, input[type="text"], input[type="radio"], input[type="checkbox"], select, [tabindex="0"]'
      );
      return Array.from(C).find((b) => b.offsetParent !== null) || null;
    }
    qe(
      () => h.value,
      () => {
        Ue && (h.value ? Oe.addClass(document.body, "p-overflow-hidden") : Oe.removeClass(document.body, "p-overflow-hidden"));
      },
      { immediate: !0 }
    );
    async function j() {
      Ue && t?.model?.navigationItems?.forEach((D) => {
        const C = document.getElementById(D.id || "");
        if (!C)
          return;
        let b = 0;
        b += s() ? y() : 0, b += l() ? d() : 0, window.scrollY >= C.offsetTop - b && (c.value = D.id || ""), s() || (c.value = "", g.value = !0);
      });
    }
    const N = Jn(
      () => {
        zd.value && r(zd.value);
      },
      100,
      { maxWait: 500 }
    ), M = Jn(
      () => {
        j();
      },
      50,
      { maxWait: 500 }
    );
    return it(async () => {
      Ue && (window.addEventListener("scroll", M, { passive: !0 }), P.value = new ResizeObserver(N), zd.value && P.value.observe(zd.value)), await mt(), await j(), v.value = a(
        window.scrollY,
        i.value
      );
    }), sn(() => {
      Ue && (window.removeEventListener("scroll", M), P.value.disconnect());
    }), (D, C) => (E(), X("div", hOe, [
      oe("ul", {
        class: "d-sticky-navigation__desktop",
        "aria-label": _(n)("stickyNavigation.dataEventComponentName")
      }, [
        oe("li", {
          "aria-label": _(n)("stickyNavigation.backToTopLinkText")
        }, [
          ue(Gd, {
            model: { isBackToTop: !0, isActive: !1 },
            onClick: w,
            onKeydown: Ze(w, ["enter"])
          })
        ], 8, fOe),
        (E(!0), X(Re, null, Ge(e.model?.navigationItems, (b) => (E(), X("li", {
          id: "section-" + b.id,
          key: b.id,
          class: Pe("section")
        }, [
          ue(Gd, {
            model: {
              isBackToTop: !1,
              id: b.id,
              icon: b.icon,
              name: b.name,
              isActive: b.id === c.value
            },
            onClick: (p) => x(b),
            onKeydown: Ze((p) => x(b), ["enter"])
          }, null, 8, ["model", "onClick", "onKeydown"])
        ], 8, mOe))), 128))
      ], 8, pOe),
      ue(Nt, {
        type: _(Ke).RoundedPrimary,
        size: _(et).Small,
        class: "mobile-navigation-btn",
        "aria-label": _(n)("stickyNavigation.mobileNavigation"),
        "link-model": S,
        icon: _(H).Mobile,
        onClick: C[0] || (C[0] = (b) => h.value = !0)
      }, null, 8, ["type", "size", "aria-label", "icon"]),
      ue(_(ML), {
        visible: h.value,
        "onUpdate:visible": C[1] || (C[1] = (b) => h.value = b),
        class: "d-sticky-navigation__mobile",
        position: "bottom",
        "base-z-index": 1e3
      }, {
        default: Se(() => [
          e.model.navigationItems !== null ? (E(), X("ul", gOe, [
            oe("li", null, [
              ue(Gd, {
                model: {
                  isBackToTop: !0,
                  name: _(n)("stickyNavigation.backToTopLinkText"),
                  isActive: !1
                },
                onClick: w
              }, null, 8, ["model"])
            ]),
            (E(!0), X(Re, null, Ge(e.model.navigationItems, (b) => (E(), X("li", {
              key: b.id
            }, [
              ue(Gd, {
                model: {
                  isBackToTop: !1,
                  id: b.id,
                  icon: b.icon,
                  name: b.name,
                  isActive: b.id === c.value
                },
                onClick: (p) => x(b)
              }, null, 8, ["model", "onClick"])
            ]))), 128))
          ])) : te("", !0)
        ]),
        _: 1
      }, 8, ["visible"])
    ]));
  }
});
const $Ee = /* @__PURE__ */ Fe(vOe, [["__scopeId", "data-v-6ff73759"]]);
var dm = /* @__PURE__ */ ((e) => (e.Page = "page", e.Video = "video", e))(dm || {}), OL = /* @__PURE__ */ ((e) => (e.Slider = "slider", e.DisplayFirst = "display-first", e.DisplayOneRandomly = "display-one-randomly", e.SliderAutomatic = "slider-automatic", e))(OL || {});
const yOe = { class: "d-teaser-hero__content--heading-and-text" }, bOe = {
  key: 0,
  class: "d-teaser-hero_text"
}, xOe = {
  key: 0,
  class: "d-teaser-hero__button_container"
}, wOe = {
  key: 1,
  class: "d-teaser-hero__video"
}, kOe = { class: "d-teaser-hero__video--description" }, SOe = /* @__PURE__ */ Be({
  __name: "TeaserHeroItemContent",
  props: {
    model: {
      type: Object,
      required: !0
    }
  },
  setup(e) {
    const { t } = Je(), n = no("(max-width: 768px)"), i = ge(null), o = e, a = Te(() => o.model.title?.length > 617 ? Ml({
      text: o.model.title,
      maxCharacters: 617,
      clippedAfterLastWord: !0,
      clippedTextSuffix: "..."
    }) : o.model.title), r = () => {
      let u = "";
      switch (!0) {
        case o.model.title?.length > 385:
          u = "xxs";
          break;
        case o.model.title?.length > 243:
          u = "xs";
          break;
        case o.model.title?.length > 103:
          u = "s";
          break;
      }
      return u;
    }, s = Te(
      () => o.model.shouldRenderH1 ? ze.H1 : ze.StyledAsH2
    ), l = Te(() => zu(
      o.model?.baseVideoPlayerProps?.videoLengthSeconds ? o.model?.baseVideoPlayerProps?.videoLengthSeconds : 0,
      !1
    ) + " " + t("videoModule.minutesShort")), d = ge(!1), y = (u) => {
      d.value = u;
    };
    return (u, m) => {
      const h = $e("BaseHeading"), c = $e("BaseText");
      return E(), X(Re, null, [
        oe("div", yOe, [
          oe("div", {
            ref_key: "headingRef",
            ref: i
          }, [
            ue(h, {
              "base-heading-type": s.value,
              class: Pe(["d-teaser-hero__heading", `d-teaser-hero__heading--${r()}`])
            }, {
              default: Se(() => [
                Ve(Ie(a.value), 1)
              ]),
              _: 1
            }, 8, ["base-heading-type", "class"])
          ], 512),
          !e.model.title || !_(n) && e.model.title.length <= 80 || _(n) && e.model.title.length <= 60 ? (E(), X("span", bOe, [
            e.model.description ? (E(), fe(c, {
              key: 0,
              text: e.model.description,
              "max-length": _(n) ? 210 : 250,
              "clipped-after-last-word": !0,
              class: "d-teaser-hero__text"
            }, null, 8, ["text", "max-length"])) : te("", !0)
          ])) : te("", !0)
        ]),
        e.model.url ? (E(), X("div", xOe, [
          e.model.type === _(dm).Page ? (E(), fe(vt, {
            key: 0,
            "link-model": e.model.url,
            type: _(Ke).Primary,
            size: _(et).Large,
            "button-type": _(zt).Link,
            class: "d-teaser-hero__button"
          }, null, 8, ["link-model", "type", "size", "button-type"])) : te("", !0),
          e.model.type === _(dm).Video ? (E(), X("div", wOe, [
            ue(Nt, {
              "link-model": e.model.url,
              type: _(Ke).RoundedPrimary,
              size: _(et).Large,
              class: "d-teaser-hero__button d-teaser-hero__button--video",
              icon: _(H).Play,
              onClick: m[0] || (m[0] = (g) => y(!0))
            }, null, 8, ["link-model", "type", "size", "icon"]),
            oe("div", kOe, [
              ue(ot, {
                "link-model": e.model.url,
                "font-size": _(yn).TwentyFourPx,
                onClick: m[1] || (m[1] = (g) => y(!0))
              }, null, 8, ["link-model", "font-size"]),
              e.model?.baseVideoPlayerProps?.videoLengthSeconds ? (E(), fe(c, {
                key: 0,
                text: l.value,
                "font-size": _(st).FourteenPx,
                "font-type": _(lt).DwsSlab
              }, null, 8, ["text", "font-size", "font-type"])) : te("", !0)
            ])
          ])) : te("", !0)
        ])) : te("", !0),
        e.model.baseVideoPlayerProps ? (E(), fe(Gg, {
          key: 1,
          "open-dialog": d.value,
          "base-video-player-props": e.model.baseVideoPlayerProps,
          onClose: m[2] || (m[2] = (g) => y(!1))
        }, null, 8, ["open-dialog", "base-video-player-props"])) : te("", !0)
      ], 64);
    };
  }
});
const BL = /* @__PURE__ */ Fe(SOe, [["__scopeId", "data-v-61c2b2fc"]]), COe = /* @__PURE__ */ Be({
  __name: "TeaserHeroItem",
  props: {
    model: {
      type: Object,
      required: !0
    }
  },
  setup(e, { expose: t }) {
    const n = ge(null);
    return t({
      teaserHeroLayout: n
    }), (i, o) => (E(), fe(nL, {
      ref_key: "teaserHeroLayout",
      ref: n,
      model: { index: e.model.index, image: e.model.image }
    }, {
      "teaser-hero-item-content": Se(() => [
        ue(BL, {
          model: e.model.itemContent
        }, null, 8, ["model"])
      ]),
      _: 1
    }, 8, ["model"]));
  }
});
const TOe = /* @__PURE__ */ Fe(COe, [["__scopeId", "data-v-6af50272"]]), LOe = { class: "d-teaser-hero-carousel" }, IOe = /* @__PURE__ */ Be({
  __name: "TeaserHero",
  props: {
    model: {
      type: Object,
      required: !0
    },
    randomSliderPage: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const t = e, { elementWidth: n, elementHeight: i, registerObserver: o } = Jx(), a = ge(), r = ge([]), s = {
      breakpoint: "768px",
      numVisible: 1,
      numScroll: 1
    }, l = Te(() => t.model.items?.map((m, h) => ({
      index: h,
      ...m
    }))), d = Te(() => {
      if (t.randomSliderPage) {
        const m = t.model.items.length;
        return Math.floor(Math.random() * m);
      }
    }), y = Te(() => t.model.mode === OL.SliderAutomatic ? t.model.duration : 0), u = () => {
      const m = r.value?.map(
        (h) => h.teaserHeroLayout.teaserHeroItemContent
      );
      if (m.length > 1) {
        let h = 0;
        m.forEach((c) => {
          c.firstChild.style.height = "auto", h = Math.max(h, c.firstChild.offsetHeight);
        }), m.forEach((c) => {
          c.firstChild.style.height = `${h}px`;
        });
      }
    };
    return it(() => {
      u(), o(a.value.$el);
    }), qe(
      () => [n.value, i.value],
      () => {
        u();
      }
    ), (m, h) => (E(), X("div", LOe, [
      ue(zs, {
        ref_key: "baseSlider",
        ref: a,
        items: l.value,
        "items-visible": 1,
        "num-scroll": 1,
        page: d.value,
        "responsive-options": [s],
        "auto-play-interval": y.value
      }, {
        item: Se((c) => [
          ue(TOe, {
            ref: (g) => r.value.push(g),
            model: c.data
          }, {
            "teaser-hero-item-content": Se(() => [
              ue(BL, {
                model: c.data.itemContent
              }, null, 8, ["model"])
            ]),
            _: 2
          }, 1032, ["model"])
        ]),
        _: 1
      }, 8, ["items", "page", "responsive-options", "auto-play-interval"])
    ]));
  }
});
const FEe = /* @__PURE__ */ Fe(IOe, [["__scopeId", "data-v-5d0942da"]]), POe = { class: "d-teaser-www" }, AOe = { class: "d-teaser-www__heading" }, _Oe = { class: "d-teaser-www__body" }, MOe = { class: "d-teaser-www__body__col" }, OOe = {
  key: 0,
  class: "d-teaser-www__body__col"
}, BOe = /* @__PURE__ */ Be({
  __name: "TeaserWww",
  props: {
    teaserWww: {
      type: Object,
      required: !0
    },
    trackingDropdownName: {
      type: String,
      default: "TeaserWwwDropdown"
    }
  },
  setup(e) {
    const t = e, { t: n } = Je();
    ws(() => {
      r.value = t.teaserWww.countryDropDown.find(
        (l) => l.isSelected
      );
    });
    const i = Te(() => ({
      folderSubPath: "svg/countries",
      extension: "svg"
    })), o = Te(() => ({
      items: t.teaserWww.importantLinks.items,
      hasIcon: !0,
      hasBorder: !1,
      showAsImportant: !0
    })), a = Te(() => ({
      items: t.teaserWww.defaultLinks.items,
      hasIcon: !0,
      hasBorder: !1,
      showAsImportant: !1
    })), r = ge(), s = (l) => {
      r.value = l;
    };
    return (l, d) => {
      const y = $e("BaseHeading");
      return E(), X("div", POe, [
        oe("div", AOe, [
          ue(y, {
            "base-heading-type": _(ze).H2
          }, {
            default: Se(() => [
              Ve(Ie(e.teaserWww.title), 1)
            ]),
            _: 1
          }, 8, ["base-heading-type"])
        ]),
        oe("div", _Oe, [
          oe("div", MOe, [
            ue(_(Tt), {
              class: "d-teaser-www__body__text",
              text: e.teaserWww.text
            }, null, 8, ["text"]),
            ue(y, null, {
              default: Se(() => [
                Ve(Ie(_(n)("teaserWww.countrySelectorTitle")), 1)
              ]),
              _: 1
            }),
            ue(vi, {
              placeholder: _(n)("teaserWww.countryDropdownPlaceholder"),
              items: e.teaserWww.countryDropDown,
              "image-options": i.value,
              "filter-placeholder": _(n)("teaserWww.countryDropdownFilterPlaceholder"),
              "has-filter": !0,
              "show-image": !0,
              "selected-item-props": r.value,
              "event-component-name": e.trackingDropdownName,
              onSelectedItemChanged: s
            }, null, 8, ["placeholder", "items", "image-options", "filter-placeholder", "selected-item-props", "event-component-name"])
          ]),
          e.teaserWww?.importantLinks || e.teaserWww?.defaultLinks ? (E(), X("div", OOe, [
            e.teaserWww?.importantLinks ? (E(), fe(Qf, {
              key: 0,
              "view-model": o.value,
              "current-country": r.value,
              "icon-font-size": _(zi).TwentyFourPx,
              "text-color": _(dt).GreyBlue006
            }, null, 8, ["view-model", "current-country", "icon-font-size", "text-color"])) : te("", !0),
            e.teaserWww?.defaultLinks ? (E(), fe(Qf, {
              key: 1,
              "view-model": a.value,
              "current-country": r.value,
              "icon-font-size": _(zi).SixteenPx
            }, null, 8, ["view-model", "current-country", "icon-font-size"])) : te("", !0)
          ])) : te("", !0)
        ])
      ]);
    };
  }
});
const jEe = /* @__PURE__ */ Fe(BOe, [["__scopeId", "data-v-68025e20"]]);
var ju = /* @__PURE__ */ ((e) => (e.Default = "default", e.Slider = "slider", e))(ju || {});
const EOe = { class: "d-video-module-item__header" }, DOe = { class: "d-video-module-item__date" }, ROe = { key: 0 }, NOe = /* @__PURE__ */ Be({
  __name: "VideoModuleItem",
  props: {
    model: {
      type: Object,
      required: !0
    },
    type: {
      type: String,
      default: ju.Default
    },
    hideText: {
      type: Boolean,
      default: !1
    },
    showVideo: {
      type: Boolean,
      default: !1
    },
    isRunning: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["playVideo"],
  setup(e, { emit: t }) {
    const { t: n } = Je(), i = e, o = Te(() => [
      {
        height: 90,
        width: 136,
        dxBreakpoint: Ct.Xs
      },
      {
        height: 104,
        width: 156,
        dxBreakpoint: Ct.Sm
      },
      {
        height: 176,
        width: 264,
        dxBreakpoint: Ct.Md
      },
      {
        height: 198,
        width: 296,
        dxBreakpoint: Ct.Lg
      },
      {
        height: 199,
        width: 198,
        dxBreakpoint: Ct.Xl
      },
      {
        height: 231,
        width: 346,
        dxBreakpoint: Ct.Xxl
      }
    ]), a = Te(() => !i.model?.image?.src || i.model?.image?.src.length === 0), r = t, s = () => {
      r("playVideo", i.model);
    }, l = Te(() => zu(
      i.model?.baseVideoPlayerProps?.videoLengthSeconds ? i.model?.baseVideoPlayerProps?.videoLengthSeconds : 0,
      !1
    ));
    return (d, y) => {
      const u = $e("BaseImage"), m = $e("BaseVideoPlayer"), h = $e("BaseText"), c = $e("BaseHeading");
      return E(), X("div", {
        class: Pe(["d-video-module-item", {
          "d-video-module-item--slider": e.type === _(ju).Slider
        }])
      }, [
        ue(_(Ms), null, {
          header: Se(() => [
            oe("div", EOe, [
              !a.value && !e.showVideo ? (E(), fe(u, {
                key: 0,
                class: "d-video-module-item__image",
                model: e.model?.image,
                "responsive-options": o.value
              }, null, 8, ["model", "responsive-options"])) : te("", !0),
              !e.showVideo && !e.isRunning ? (E(), fe(Nt, {
                key: 1,
                class: "d-video-module-item__play",
                type: _(Ke).RoundedPrimary,
                size: _(et).Large,
                "link-model": { title: _(n)("videoModule.playButton") },
                icon: _(H).Play,
                onClick: y[0] || (y[0] = (g) => s())
              }, null, 8, ["type", "size", "link-model", "icon"])) : te("", !0),
              !e.showVideo && e.isRunning ? (E(), fe(Ji, {
                key: 2,
                class: "d-video-module-item__is-running",
                "tag-text": _(n)("videoModule.isRunningText"),
                "background-color": _(En).GreyBlue001,
                color: _(mi).GreyBlue009
              }, null, 8, ["tag-text", "background-color", "color"])) : te("", !0),
              e.showVideo ? (E(), fe(m, {
                key: 3,
                "base-video-player-props": e.model?.baseVideoPlayerProps
              }, null, 8, ["base-video-player-props"])) : te("", !0),
              e.model?.baseVideoPlayerProps?.videoLengthSeconds ? (E(), fe(Ji, {
                key: 4,
                class: "d-video-module-item__duration",
                "tag-text": l.value,
                "background-color": _(En).GreyBlue009,
                color: _(mi).White
              }, null, 8, ["tag-text", "background-color", "color"])) : te("", !0)
            ])
          ]),
          title: Se(() => [
            oe("div", DOe, [
              e.model?.date ? (E(), fe(h, {
                key: 0,
                text: e.model.date,
                "font-size": _(st).TwelvePx,
                "text-color": _(mi).GreyBlue009,
                "font-type": _(lt).DwsSlabBold
              }, null, 8, ["text", "font-size", "text-color", "font-type"])) : te("", !0)
            ]),
            ue(c, { class: "d-video-module-item__heading" }, {
              default: Se(() => [
                Ve(Ie(e.model?.headline), 1)
              ]),
              _: 1
            })
          ]),
          content: Se(() => [
            e.hideText ? te("", !0) : (E(), X("div", ROe, [
              e.model?.text ? (E(), fe(h, {
                key: 0,
                text: e.model.text,
                "font-size": _(st).SixteenPx
              }, null, 8, ["text", "font-size"])) : te("", !0)
            ]))
          ]),
          _: 1
        })
      ], 2);
    };
  }
});
const $Oe = /* @__PURE__ */ Fe(NOe, [["__scopeId", "data-v-8f4309c2"]]), FOe = { class: "d-video-module" }, jOe = { class: "d-video-module__header" }, HOe = { class: "d-video-module__content" }, zOe = {
  key: 0,
  class: "d-video-module__stack"
}, VOe = {
  key: 2,
  class: "d-video-module__slider"
}, GOe = /* @__PURE__ */ Be({
  __name: "VideoModule",
  props: {
    model: {
      type: Object,
      required: !0
    }
  },
  setup(e) {
    const t = e, { isSmallerXlAsync: n } = xt(), i = ge(), o = ge(!0), a = ge(!1), r = ge(), s = ge([]), l = ge(!1), d = ge(!1);
    it(async () => {
      t.model?.videoItems && t.model?.videoItems.length > 0 && (r.value = {
        ...t.model?.videoItems[0],
        type: Kn.VideoPlayer
      }, s.value = t.model?.videoItems.slice(
        1,
        t.model?.videoItems.length
      ), s.value.push(t.model?.videoItems[0]));
    });
    const y = (f, S) => {
      r.value = {
        ...f,
        type: Kn.VideoPlayer
      }, u(S);
    }, u = (f) => {
      if (f >= 0) {
        let S = "#list-item-" + (f + 1);
        f === t.model?.videoItems.length - 1 && (S = "#list-item-" + (f - 2));
        const w = Oe.findSingle(i.value, S);
        w && i.value.scrollTo({
          top: w.offsetTop,
          behavior: "smooth"
        });
      } else {
        if (!r.value)
          return;
        t.model?.videoItems.findIndex(
          (w) => w?.baseVideoPlayerProps?.videoId === r?.value?.baseVideoPlayerProps?.videoId
        ) === t.model?.videoItems.length - 1 ? d.value = !d.value : l.value = !l.value;
      }
    }, m = (f) => {
      const S = f.target;
      o.value = S.scrollTop === 0, a.value = Math.abs(S.scrollHeight - S.scrollTop - S.clientHeight) < 1, f.preventDefault();
    }, h = Te(() => [c, g, v, P]), c = {
      breakpoint: "1280px",
      numVisible: 1,
      numScroll: 1
    }, g = {
      breakpoint: "1024px",
      numVisible: 1,
      numScroll: 1
    }, v = {
      breakpoint: "767px",
      numVisible: 2,
      numScroll: 1
    }, P = {
      breakpoint: "576px",
      numVisible: 2,
      numScroll: 1
    };
    return (f, S) => {
      const w = $e("BaseHeading");
      return E(), X("div", FOe, [
        oe("div", jOe, [
          ue(w, {
            "base-heading-type": _(ze).H2,
            class: "d-video-module__heading"
          }, {
            default: Se(() => [
              Ve(Ie(e.model?.headline), 1)
            ]),
            _: 1
          }, 8, ["base-heading-type"]),
          e.model?.textLink?.text ? (E(), fe(ot, {
            key: 0,
            "link-model": e.model.textLink,
            icon: _(H).ArrowRight
          }, null, 8, ["link-model", "icon"])) : te("", !0)
        ]),
        oe("div", HOe, [
          r.value ? (E(), fe(_(dL), {
            key: 0,
            "video-item-hero": r.value,
            class: Pe({
              "single-video": e.model?.videoItems?.length === 1
            })
          }, null, 8, ["video-item-hero", "class"])) : te("", !0),
          e.model?.videoItems?.length > 1 ? (E(), X("div", {
            key: 1,
            ref_key: "listRef",
            ref: i,
            class: Pe(["d-video-module__overflow", {
              "overflow-shadow-bottom": o.value || !o.value && !a.value,
              "overflow-shadow-top": a.value || !o.value && !a.value
            }]),
            onScroll: m
          }, [
            _(n) ? te("", !0) : (E(), X("div", zOe, [
              (E(!0), X(Re, null, Ge(s.value, (x, k) => (E(), fe(ot, {
                id: "list-item-" + k,
                key: k,
                class: "d-video-module__stack--item no-underline",
                "has-text": !1,
                "aria-label": x.headline,
                "link-model": {},
                onKeydown: Ze((A) => y(x, k), ["enter"]),
                onClick: (A) => y(x, k)
              }, {
                container: Se(() => [
                  ue(co, {
                    "teaser-box": x,
                    layout: _(Rt).OneThird,
                    "show-date": !0,
                    "show-tags": !1,
                    description: _(Ui).Hidden,
                    "cta-element-type": _(cn).None,
                    "picture-rounded-corner": !0,
                    "video-is-running": x.baseVideoPlayerProps?.videoId === r.value?.baseVideoPlayerProps?.videoId
                  }, null, 8, ["teaser-box", "layout", "description", "cta-element-type", "video-is-running"])
                ]),
                _: 2
              }, 1032, ["id", "aria-label", "onKeydown", "onClick"]))), 128))
            ]))
          ], 34)) : te("", !0),
          e.model?.videoItems && e.model?.videoItems.length > 1 && _(n) ? (E(), X("div", VOe, [
            ue(zs, {
              items: s.value,
              "items-visible": 2,
              "num-scroll": 1,
              page: 1,
              "responsive-options": h.value,
              "set-forward": l.value,
              "set-backward": d.value
            }, {
              item: Se((x) => [
                ue($Oe, {
                  model: x.data,
                  "hide-text": !0,
                  type: _(ju).Slider,
                  "is-running": x.data.baseVideoPlayerProps.videoId === r.value?.baseVideoPlayerProps?.videoId,
                  onKeydown: Ze((k) => y(x.data, -1), ["enter"]),
                  onClick: (k) => y(x.data, -1)
                }, null, 8, ["model", "type", "is-running", "onKeydown", "onClick"])
              ]),
              _: 1
            }, 8, ["items", "responsive-options", "set-forward", "set-backward"])
          ])) : te("", !0)
        ])
      ]);
    };
  }
});
const HEe = /* @__PURE__ */ Fe(GOe, [["__scopeId", "data-v-1c732b8e"]]), UOe = { class: "d-error-page" }, WOe = {
  key: 0,
  class: "d-error-page__background"
}, YOe = ["src", "alt"], qOe = { class: "d-error-page__header-area container" }, KOe = { class: "d-error-page__header-area--container" }, XOe = {
  key: 0,
  class: "d-error-page__header-area--error"
}, ZOe = {
  key: 0,
  class: "additional-content container"
}, JOe = /* @__PURE__ */ Be({
  inheritAttrs: !1,
  __name: "ErrorPage",
  props: {
    model: {
      type: Object,
      required: !0
    }
  },
  setup(e) {
    const t = e, n = Te(() => t.model), i = Jt(), o = (a) => !!i[a];
    return (a, r) => {
      const s = $e("BaseHeading");
      return E(), X(Re, null, [
        oe("div", UOe, [
          n.value.backgroundImageUrl ? (E(), X("div", WOe, [
            oe("img", {
              class: "d-error-page__background--image",
              src: n.value.backgroundImageUrl,
              alt: n.value.backgroundImageAltText
            }, null, 8, YOe)
          ])) : te("", !0),
          oe("div", qOe, [
            oe("div", KOe, [
              n.value ? (E(), X(Re, { key: 0 }, [
                n.value.error ? (E(), X("span", XOe, Ie(n.value.error), 1)) : te("", !0),
                n.value.headline ? (E(), fe(s, {
                  key: 1,
                  "base-heading-type": _(ze).H1
                }, {
                  default: Se(() => [
                    Ve(Ie(n.value.headline), 1)
                  ]),
                  _: 1
                }, 8, ["base-heading-type"])) : te("", !0),
                ue(ht, {
                  "html-text": n.value.content
                }, null, 8, ["html-text"])
              ], 64)) : te("", !0)
            ])
          ])
        ]),
        o("additional_content") ? (E(), X("div", ZOe, [
          je(a.$slots, "additional_content", {}, void 0, !0)
        ])) : te("", !0)
      ], 64);
    };
  }
});
const zEe = /* @__PURE__ */ Fe(JOe, [["__scopeId", "data-v-9175170c"]]);
var QOe = /* @__PURE__ */ ((e) => (e[e.CONTINUE = 100] = "CONTINUE", e[e.SWITCHING_PROTOCOLS = 101] = "SWITCHING_PROTOCOLS", e[e.PROCESSING = 102] = "PROCESSING", e[e.OK = 200] = "OK", e[e.CREATED = 201] = "CREATED", e[e.ACCEPTED = 202] = "ACCEPTED", e[e.NON_AUTHORITATIVE_INFORMATION = 203] = "NON_AUTHORITATIVE_INFORMATION", e[e.NO_CONTENT = 204] = "NO_CONTENT", e[e.RESET_CONTENT = 205] = "RESET_CONTENT", e[e.PARTIAL_CONTENT = 206] = "PARTIAL_CONTENT", e[e.MULTI_STATUS = 207] = "MULTI_STATUS", e[e.ALREADY_REPORTED = 208] = "ALREADY_REPORTED", e[e.IM_USED = 226] = "IM_USED", e[e.MULTIPLE_CHOICES = 300] = "MULTIPLE_CHOICES", e[e.MOVED_PERMANENTLY = 301] = "MOVED_PERMANENTLY", e[e.FOUND = 302] = "FOUND", e[e.SEE_OTHER = 303] = "SEE_OTHER", e[e.NOT_MODIFIED = 304] = "NOT_MODIFIED", e[e.USE_PROXY = 305] = "USE_PROXY", e[e.SWITCH_PROXY = 306] = "SWITCH_PROXY", e[e.TEMPORARY_REDIRECT = 307] = "TEMPORARY_REDIRECT", e[e.PERMANENT_REDIRECT = 308] = "PERMANENT_REDIRECT", e[e.BAD_REQUEST = 400] = "BAD_REQUEST", e[e.UNAUTHORIZED = 401] = "UNAUTHORIZED", e[e.PAYMENT_REQUIRED = 402] = "PAYMENT_REQUIRED", e[e.FORBIDDEN = 403] = "FORBIDDEN", e[e.NOT_FOUND = 404] = "NOT_FOUND", e[e.METHOD_NOT_ALLOWED = 405] = "METHOD_NOT_ALLOWED", e[e.NOT_ACCEPTABLE = 406] = "NOT_ACCEPTABLE", e[e.PROXY_AUTHENTICATION_REQUIRED = 407] = "PROXY_AUTHENTICATION_REQUIRED", e[e.REQUEST_TIMEOUT = 408] = "REQUEST_TIMEOUT", e[e.CONFLICT = 409] = "CONFLICT", e[e.GONE = 410] = "GONE", e[e.LENGTH_REQUIRED = 411] = "LENGTH_REQUIRED", e[e.PRECONDITION_FAILED = 412] = "PRECONDITION_FAILED", e[e.PAYLOAD_TOO_LARGE = 413] = "PAYLOAD_TOO_LARGE", e[e.URI_TOO_LONG = 414] = "URI_TOO_LONG", e[e.UNSUPPORTED_MEDIA_TYPE = 415] = "UNSUPPORTED_MEDIA_TYPE", e[e.RANGE_NOT_SATISFIABLE = 416] = "RANGE_NOT_SATISFIABLE", e[e.EXPECTATION_FAILED = 417] = "EXPECTATION_FAILED", e[e.I_AM_A_TEAPOT = 418] = "I_AM_A_TEAPOT", e[e.MISDIRECTED_REQUEST = 421] = "MISDIRECTED_REQUEST", e[e.UNPROCESSABLE_ENTITY = 422] = "UNPROCESSABLE_ENTITY", e[e.LOCKED = 423] = "LOCKED", e[e.FAILED_DEPENDENCY = 424] = "FAILED_DEPENDENCY", e[e.UPGRADE_REQUIRED = 426] = "UPGRADE_REQUIRED", e[e.PRECONDITION_REQUIRED = 428] = "PRECONDITION_REQUIRED", e[e.TOO_MANY_REQUESTS = 429] = "TOO_MANY_REQUESTS", e[e.REQUEST_HEADER_FIELDS_TOO_LARGE = 431] = "REQUEST_HEADER_FIELDS_TOO_LARGE", e[e.UNAVAILABLE_FOR_LEGAL_REASONS = 451] = "UNAVAILABLE_FOR_LEGAL_REASONS", e[e.INTERNAL_SERVER_ERROR = 500] = "INTERNAL_SERVER_ERROR", e[e.NOT_IMPLEMENTED = 501] = "NOT_IMPLEMENTED", e[e.BAD_GATEWAY = 502] = "BAD_GATEWAY", e[e.SERVICE_UNAVAILABLE = 503] = "SERVICE_UNAVAILABLE", e[e.GATEWAY_TIMEOUT = 504] = "GATEWAY_TIMEOUT", e[e.HTTP_VERSION_NOT_SUPPORTED = 505] = "HTTP_VERSION_NOT_SUPPORTED", e[e.VARIANT_ALSO_NEGOTIATES = 506] = "VARIANT_ALSO_NEGOTIATES", e[e.INSUFFICIENT_STORAGE = 507] = "INSUFFICIENT_STORAGE", e[e.LOOP_DETECTED = 508] = "LOOP_DETECTED", e[e.NOT_EXTENDED = 510] = "NOT_EXTENDED", e[e.NETWORK_AUTHENTICATION_REQUIRED = 511] = "NETWORK_AUTHENTICATION_REQUIRED", e))(QOe || {}), ua = /* @__PURE__ */ ((e) => (e.TwoThirdsOneThird = "two-thirds-one-third", e.OneThirdTwoThirds = "one-third-two-thirds", e.HalfHalf = "half-half", e))(ua || {}), gn = /* @__PURE__ */ ((e) => (e.Auto = "auto", e.Top = "top", e.Right = "right", e.Bottom = "bottom", e.Left = "left", e.Center = "center", e))(gn || {}), Vn = /* @__PURE__ */ ((e) => (e.First = "first", e.Second = "second", e.Third = "third", e.Both = "both", e.None = "none", e))(Vn || {});
const eBe = /* @__PURE__ */ Be({
  __name: "TwoColumnLayout",
  props: {
    layoutType: {
      type: String,
      default: ua.TwoThirdsOneThird
    },
    verticalAlignContentColOne: {
      type: String,
      default: gn.Auto
    },
    verticalAlignContentColTwo: {
      type: String,
      default: gn.Auto
    },
    stretchedColumn: {
      type: String,
      default: Vn.None
    },
    contentWidth: {
      type: Boolean,
      default: !0
    },
    title: {
      type: String,
      default: ""
    },
    baseHeadingType: {
      type: String,
      default: ze.H2Section
    },
    noMargin: {
      type: Boolean,
      default: !1
    },
    noMarginBottom: {
      type: Boolean,
      default: !1
    }
  },
  setup(e, { expose: t }) {
    const n = e, { width: i } = Ts(), { enableContainerQueries: o, disableContainerQueries: a } = Bi(), r = () => {
      let c = "";
      switch (n.contentWidth ? c += "content-width" : n.stretchedColumn != Vn.None && (c += " has-stretched-column"), n.layoutType) {
        case ua.OneThirdTwoThirds:
          return c += " grid-cols-1 xl:grid-cols-3 one-third-two-third";
        case ua.TwoThirdsOneThird:
          return c += " grid-cols-1 xl:grid-cols-3 two-third-one-third";
        case ua.HalfHalf:
          return c += " grid-cols-1 xl:grid-cols-2 half-half";
      }
    }, s = () => n.noMargin ? "" : "col--gap col--remove-child-margin", l = () => {
      let c = "", g = "";
      switch (n.layoutType) {
        case ua.OneThirdTwoThirds:
          g = "xl:col-span-1";
          break;
        case ua.TwoThirdsOneThird:
          g = "xl:col-span-2";
          break;
        case ua.HalfHalf:
          g = "xl:col-span-1";
          break;
      }
      switch (n.verticalAlignContentColOne) {
        case gn.Auto:
          break;
        case gn.Top:
          c = "self-start";
          break;
        case gn.Bottom:
          c = "self-end";
          break;
        case gn.Center:
          c = "self-center";
          break;
      }
      return `${n.stretchedColumn === Vn.Second ? "not-stretched-column" : ""} ${c} ${g} ${s()}`;
    }, d = () => {
      let c = "", g = "";
      switch (n.layoutType) {
        case ua.OneThirdTwoThirds:
          g = "xl:col-span-2";
          break;
        case ua.TwoThirdsOneThird:
          g = "xl:col-span-1";
          break;
        case ua.HalfHalf:
          g = "xl:col-span-1";
          break;
      }
      switch (n.verticalAlignContentColTwo) {
        case gn.Auto:
          break;
        case gn.Top:
          c = "self-start";
          break;
        case gn.Bottom:
          c = "self-end";
          break;
        case gn.Center:
          c = "self-center";
          break;
      }
      return `${n.stretchedColumn === Vn.First ? "not-stretched-column" : ""} ${c} ${g} ${s()}`;
    }, y = ge(), u = ge(), m = ge(), h = () => {
      if (Ue && m.value && !n.contentWidth && n.stretchedColumn !== Vn.Both) {
        const c = window.getComputedStyle(m.value) || m.value?.currentStyle.marginLeft;
        y.value && n.stretchedColumn !== Vn.First && (y.value.style.marginLeft = c.marginLeft), u.value && n.stretchedColumn !== Vn.Second && (u.value.style.marginRight = c.marginLeft);
      }
    };
    return it(() => {
      h(), o();
    }), sn(() => {
      a();
    }), qe(
      () => i.value,
      () => {
        h();
      }
    ), t({
      coloneRef: y,
      coltwoRef: u
    }), (c, g) => {
      const v = $e("BaseHeading");
      return E(), X(Re, null, [
        oe("div", {
          ref_key: "containerRef",
          ref: m,
          class: "container"
        }, null, 512),
        oe("div", {
          class: Pe(["d-page-section d-page-section__two-column-layout", {
            "d-page-section--no-margin-bottom": e.noMarginBottom
          }])
        }, [
          e.title ? (E(), X("div", {
            key: 0,
            class: Pe(["d-page-section__heading", `d-page-section__heading--${e.contentWidth ? "content-width" : "full-width"}`])
          }, [
            ue(v, {
              "base-heading-type": e.baseHeadingType,
              class: "d-page-section__heading__title"
            }, {
              default: Se(() => [
                Ve(Ie(e.title), 1)
              ]),
              _: 1
            }, 8, ["base-heading-type"])
          ], 2)) : te("", !0),
          oe("div", {
            class: Pe(["d-page-section__container", r()])
          }, [
            oe("div", {
              id: "colone",
              ref_key: "coloneRef",
              ref: y,
              class: Pe(["col-span-3 col-one col", l()])
            }, [
              je(c.$slots, "colone", {}, void 0, !0)
            ], 2),
            oe("div", {
              id: "coltwo",
              ref_key: "coltwoRef",
              ref: u,
              class: Pe(["col-span-3 col-two col", d()])
            }, [
              je(c.$slots, "coltwo", {}, void 0, !0)
            ], 2)
          ], 2)
        ], 2)
      ], 64);
    };
  }
});
const VEe = /* @__PURE__ */ Fe(eBe, [["__scopeId", "data-v-9ea62b0c"]]), tBe = /* @__PURE__ */ Be({
  __name: "ThreeColumnLayout",
  props: {
    contentWidth: {
      type: Boolean,
      default: !0
    },
    verticalAlignContentColOne: {
      type: String,
      default: gn.Auto
    },
    verticalAlignContentColTwo: {
      type: String,
      default: gn.Auto
    },
    verticalAlignContentColThree: {
      type: String,
      default: gn.Auto
    },
    title: {
      type: String,
      default: ""
    },
    baseHeadingType: {
      type: String,
      default: ze.H2Section
    },
    stretchedColumn: {
      type: String,
      default: Vn.None
    },
    noMargin: {
      type: Boolean,
      default: !1
    },
    noMarginBottom: {
      type: Boolean,
      default: !1
    }
  },
  setup(e, { expose: t }) {
    const n = e, { width: i } = Ts(), { enableContainerQueries: o, disableContainerQueries: a } = Bi(), r = () => n.noMargin ? "" : "col--gap col--remove-child-margin", s = () => {
      let g = "";
      switch (n.verticalAlignContentColOne) {
        case gn.Auto:
          break;
        case gn.Top:
          g = "self-start";
          break;
        case gn.Bottom:
          g = "self-end";
          break;
        case gn.Center:
          g = "self-center";
          break;
      }
      return `${y(Vn.First)} ${g} ${r()}`;
    }, l = () => {
      let g = "";
      switch (n.verticalAlignContentColTwo) {
        case gn.Auto:
          break;
        case gn.Top:
          g = "self-start";
          break;
        case gn.Bottom:
          g = "self-end";
          break;
        case gn.Center:
          g = "self-center";
          break;
      }
      return `${y(Vn.Second)}  ${g} ${r()}`;
    }, d = () => {
      let g = "";
      switch (n.verticalAlignContentColThree) {
        case gn.Auto:
          break;
        case gn.Top:
          g = "self-start";
          break;
        case gn.Bottom:
          g = "self-end";
          break;
        case gn.Center:
          g = "self-center";
          break;
      }
      return `${y(Vn.Third)} ${g} ${r()}`;
    }, y = (g) => n.stretchedColumn === g ? "stretched-column" : g === Vn.Second ? "" : n.stretchedColumn === Vn.Both ? "stretched-column" : "not-stretched-column", u = ge(), m = ge(), h = ge(), c = () => {
      if (Ue && h.value && !n.contentWidth && n.stretchedColumn !== Vn.Both) {
        const g = window.getComputedStyle(h.value) || h.value?.currentStyle.marginLeft;
        u.value && n.stretchedColumn !== Vn.First && (u.value.style.marginLeft = g.marginLeft), m.value && n.stretchedColumn !== Vn.Third && (m.value.style.marginRight = g.marginLeft);
      }
    };
    return it(() => {
      c(), o();
    }), sn(() => {
      a();
    }), qe(
      () => i.value,
      () => {
        c();
      }
    ), t({
      coloneRef: u,
      colthreeRef: m
    }), (g, v) => {
      const P = $e("BaseHeading");
      return E(), X(Re, null, [
        oe("div", {
          ref_key: "containerRef",
          ref: h,
          class: "container"
        }, null, 512),
        oe("div", {
          class: Pe(["d-page-section d-page-section__three-column-layout", {
            "d-page-section--no-margin-bottom": e.noMarginBottom
          }])
        }, [
          e.title ? (E(), X("div", {
            key: 0,
            class: Pe(["d-page-section__heading", `d-page-section__heading--${e.contentWidth ? "content-width" : "full-width"}`])
          }, [
            ue(P, {
              "base-heading-type": e.baseHeadingType,
              class: "d-page-section__heading__title"
            }, {
              default: Se(() => [
                Ve(Ie(e.title), 1)
              ]),
              _: 1
            }, 8, ["base-heading-type"])
          ], 2)) : te("", !0),
          oe("div", {
            class: Pe(["d-page-section__container xl:grid-cols-3", {
              "content-width": e.contentWidth === !0,
              "has-stretched-column": e.stretchedColumn !== _(Vn).None
            }])
          }, [
            oe("div", {
              id: "colone",
              ref_key: "coloneRef",
              ref: u,
              class: Pe([s(), "col-one"])
            }, [
              je(g.$slots, "colone", {}, void 0, !0)
            ], 2),
            oe("div", {
              id: "coltwo",
              class: Pe([l(), "col-two"])
            }, [
              je(g.$slots, "coltwo", {}, void 0, !0)
            ], 2),
            oe("div", {
              id: "colthree",
              ref_key: "colthreeRef",
              ref: m,
              class: Pe([d(), "col-three"])
            }, [
              je(g.$slots, "colthree", {}, void 0, !0)
            ], 2)
          ], 2)
        ], 2)
      ], 64);
    };
  }
});
const GEe = /* @__PURE__ */ Fe(tBe, [["__scopeId", "data-v-c1cb840d"]]), nBe = { class: "d-content-box-with-image" }, iBe = /* @__PURE__ */ Be({
  __name: "ContentBoxWithImage",
  props: {
    model: {
      type: Object,
      required: !0
    },
    polygonBoxBackgroundColor: {
      type: String,
      default: Ih.GreyBlue008
    },
    opacity: {
      type: Number,
      default: 0.9
    }
  },
  setup(e) {
    const t = e, n = Te(() => {
      const i = t.model.image?.src;
      return i ? { backgroundImage: `url(${i})` } : {};
    });
    return (i, o) => (E(), X("div", nBe, [
      oe("div", {
        style: hn(n.value),
        class: Pe({ "d-content-box-with-image__background": e.model.image?.src })
      }, [
        ue(WC, {
          "polygon-box-background-color": e.polygonBoxBackgroundColor,
          opacity: e.opacity
        }, {
          default: Se(() => [
            ue(Ot, {
              class: "d-content-box-with-image__heading",
              "base-heading-type": _(ze).StyledAsH2Section
            }, {
              default: Se(() => [
                Ve(Ie(e.model.headlineSection), 1)
              ]),
              _: 1
            }, 8, ["base-heading-type"]),
            ue(Tt, {
              text: e.model.text,
              "font-size": _(st).SixteenPx,
              "text-color": _(dt).White,
              "font-type": _(lt).DwsSans,
              class: "d-content-box-with-image__text"
            }, null, 8, ["text", "font-size", "text-color", "font-type"])
          ]),
          _: 1
        }, 8, ["polygon-box-background-color", "opacity"])
      ], 6)
    ]));
  }
});
const UEe = /* @__PURE__ */ Fe(iBe, [["__scopeId", "data-v-4446f285"]]), aBe = {
  key: 0,
  class: "d-article-page"
}, oBe = /* @__PURE__ */ Be({
  __name: "ArticlePageLayout",
  props: {
    model: {
      type: Object,
      required: !0
    }
  },
  setup(e) {
    const t = e;
    return (n, i) => t.model ? (E(), X("div", aBe, [
      ue(Q0e, {
        class: "d-article-page__article-header",
        model: t.model?.articleHeaderProps
      }, null, 8, ["model"]),
      ue(Vt, {
        id: "d-article-page__article-page-overview",
        class: "d-article-page__article-page-overview"
      }, {
        default: Se(() => [
          ue(l1e, {
            model: t.model.articlePageOverviewProps
          }, null, 8, ["model"])
        ]),
        _: 1
      }),
      je(n.$slots, "default", {}, void 0, !0)
    ])) : te("", !0);
  }
});
const WEe = /* @__PURE__ */ Fe(oBe, [["__scopeId", "data-v-07f6f4d1"]]);
export {
  Hu as $,
  pBe as A,
  gBe as B,
  ik as C,
  Zc as D,
  Bn as E,
  oo as F,
  Pi as G,
  $i as H,
  or as I,
  fr as J,
  SBe as K,
  L9 as L,
  yBe as M,
  bBe as N,
  Wu as O,
  xBe as P,
  cBe as Q,
  vBe as R,
  Br as S,
  wBe as T,
  Ml as U,
  qL as V,
  vm as W,
  ld as X,
  Bi as Y,
  Gu as Z,
  Fe as _,
  xt as a,
  Vae as a$,
  zu as a0,
  Fn as a1,
  dP as a2,
  Uc as a3,
  dBe as a4,
  Jx as a5,
  Qe as a6,
  bm as a7,
  Uu as a8,
  xm as a9,
  pte as aA,
  mte as aB,
  Ng as aC,
  Sp as aD,
  ste as aE,
  Lh as aF,
  Pt as aG,
  one as aH,
  WC as aI,
  Hs as aJ,
  Lc as aK,
  $g as aL,
  Ph as aM,
  uie as aN,
  eT as aO,
  tT as aP,
  br as aQ,
  Fg as aR,
  Th as aS,
  NC as aT,
  qi as aU,
  Ti as aV,
  Ec as aW,
  jae as aX,
  tu as aY,
  bl as aZ,
  Na as a_,
  Ma as aa,
  pm as ab,
  On as ac,
  jx as ad,
  Qx as ae,
  nw as af,
  fi as ag,
  Cl as ah,
  uBe as ai,
  yP as aj,
  Ts as ak,
  Ct as al,
  to as am,
  cQ as an,
  BC as ao,
  VU as ap,
  mh as aq,
  oee as ar,
  dee as as,
  Zee as at,
  $n as au,
  _f as av,
  $C as aw,
  k0 as ax,
  dte as ay,
  pt as az,
  Li as b,
  _s as b$,
  Ch as b0,
  Tae as b1,
  xae as b2,
  Lae as b3,
  No as b4,
  Ah as b5,
  Lk as b6,
  LBe as b7,
  ms as b8,
  xN as b9,
  Nt as bA,
  $c as bB,
  hT as bC,
  Uf as bD,
  pT as bE,
  od as bF,
  PBe as bG,
  mT as bH,
  dT as bI,
  iu as bJ,
  yg as bK,
  Lr as bL,
  sa as bM,
  Ir as bN,
  di as bO,
  on as bP,
  ABe as bQ,
  vt as bR,
  et as bS,
  Ke as bT,
  zt as bU,
  ct as bV,
  md as bW,
  W0 as bX,
  Xc as bY,
  Ra as bZ,
  Vo as b_,
  SN as ba,
  aT as bb,
  _h as bc,
  Wo as bd,
  uae as be,
  Bc as bf,
  Ff as bg,
  jf as bh,
  oae as bi,
  Rf as bj,
  Iie as bk,
  rT as bl,
  Mh as bm,
  pa as bn,
  ji as bo,
  oT as bp,
  Oh as bq,
  zg as br,
  fC as bs,
  Vf as bt,
  ff as bu,
  ga as bv,
  z0 as bw,
  Vg as bx,
  tse as by,
  Gg as bz,
  Em as c,
  PT as c$,
  Ok as c0,
  Ai as c1,
  Sr as c2,
  Da as c3,
  Um as c4,
  Wm as c5,
  Ym as c6,
  qm as c7,
  Qu as c8,
  Km as c9,
  K as cA,
  H as cB,
  gt as cC,
  _t as cD,
  SA as cE,
  Es as cF,
  _n as cG,
  Ht as cH,
  xg as cI,
  lC as cJ,
  rU as cK,
  yt as cL,
  yn as cM,
  ya as cN,
  ot as cO,
  Ar as cP,
  la as cQ,
  Eh as cR,
  _Be as cS,
  lr as cT,
  DU as cU,
  Vs as cV,
  Nc as cW,
  Tt as cX,
  st as cY,
  dt as cZ,
  lt as c_,
  Xm as ca,
  fu as cb,
  Zm as cc,
  Jm as cd,
  Qm as ce,
  eg as cf,
  tg as cg,
  ng as ch,
  Wi as ci,
  oi as cj,
  mu as ck,
  Yi as cl,
  so as cm,
  _k as cn,
  Mk as co,
  Is as cp,
  gu as cq,
  Ps as cr,
  As as cs,
  ii as ct,
  Iue as cu,
  bg as cv,
  Cc as cw,
  Ot as cx,
  ze as cy,
  at as cz,
  ja as d,
  FBe as d$,
  Zt as d0,
  Et as d1,
  Kg as d2,
  cr as d3,
  Fu as d4,
  ln as d5,
  mf as d6,
  zs as d7,
  IBe as d8,
  _oe as d9,
  Qfe as dA,
  sme as dB,
  EBe as dC,
  DBe as dD,
  Ln as dE,
  Ii as dF,
  xme as dG,
  Lo as dH,
  RBe as dI,
  Bme as dJ,
  TBe as dK,
  ui as dL,
  NBe as dM,
  zT as dN,
  tge as dO,
  VT as dP,
  age as dQ,
  Hme as dR,
  Rg as dS,
  w0 as dT,
  Ree as dU,
  Oo as dV,
  Dg as dW,
  qme as dX,
  Zme as dY,
  Rme as dZ,
  $Be as d_,
  vi as da,
  Gt as db,
  Vi as dc,
  Qf as dd,
  Us as de,
  MBe as df,
  OBe as dg,
  NT as dh,
  Jpe as di,
  Bue as dj,
  Ei as dk,
  aa as dl,
  Sh as dm,
  Vt as dn,
  zn as dp,
  qr as dq,
  sfe as dr,
  Ik as ds,
  BBe as dt,
  Mfe as du,
  dfe as dv,
  FT as dw,
  ei as dx,
  k1 as dy,
  qfe as dz,
  li as e,
  ru as e$,
  Age as e0,
  jBe as e1,
  HBe as e2,
  P1 as e3,
  A1 as e4,
  GT as e5,
  zBe as e6,
  Hbe as e7,
  VBe as e8,
  ao as e9,
  Kxe as eA,
  nEe as eB,
  dwe as eC,
  wl as eD,
  pwe as eE,
  iEe as eF,
  aEe as eG,
  r0e as eH,
  Qg as eI,
  rL as eJ,
  cL as eK,
  oEe as eL,
  iS as eM,
  rEe as eN,
  Pp as eO,
  Nke as eP,
  Hke as eQ,
  sEe as eR,
  dL as eS,
  Io as eT,
  lEe as eU,
  am as eV,
  BCe as eW,
  cEe as eX,
  yCe as eY,
  Bp as eZ,
  RCe as e_,
  GBe as ea,
  Al as eb,
  UBe as ec,
  WBe as ed,
  u0e as ee,
  YBe as ef,
  _0e as eg,
  g0e as eh,
  qBe as ei,
  Q0e as ej,
  Y0e as ek,
  X0e as el,
  l1e as em,
  t1e as en,
  KBe as eo,
  a1e as ep,
  XBe as eq,
  ZBe as er,
  QBe as es,
  lxe as et,
  eEe as eu,
  jxe as ev,
  Rh as ew,
  HT as ex,
  $o as ey,
  tEe as ez,
  D9 as f,
  Qr as f$,
  F0 as f0,
  GCe as f1,
  FCe as f2,
  zCe as f3,
  QCe as f4,
  mn as f5,
  om as f6,
  cTe as f7,
  nx as f8,
  dEe as f9,
  xEe as fA,
  xIe as fB,
  wEe as fC,
  hx as fD,
  ux as fE,
  dx as fF,
  kEe as fG,
  mx as fH,
  nv as fI,
  Fh as fJ,
  tv as fK,
  SEe as fL,
  CEe as fM,
  TEe as fN,
  lm as fO,
  cm as fP,
  VPe as fQ,
  LEe as fR,
  jt as fS,
  Qa as fT,
  APe as fU,
  IEe as fV,
  eSe as fW,
  Wke as fX,
  uL as fY,
  PEe as fZ,
  AEe as f_,
  uEe as fa,
  DTe as fb,
  ix as fc,
  hEe as fd,
  pEe as fe,
  fEe as ff,
  ht as fg,
  mEe as fh,
  rLe as fi,
  su as fj,
  sx as fk,
  gEe as fl,
  OLe as fm,
  vEe as fn,
  lL as fo,
  yEe as fp,
  RLe as fq,
  ma as fr,
  ro as fs,
  ss as ft,
  hBe as fu,
  Xi as fv,
  Oi as fw,
  ZLe as fx,
  rm as fy,
  bEe as fz,
  kBe as g,
  _Ee as g0,
  MEe as g1,
  OEe as g2,
  Ug as g3,
  zh as g4,
  TL as g5,
  BEe as g6,
  Ix as g7,
  EEe as g8,
  zd as g9,
  $Oe as gA,
  ju as gB,
  zEe as gC,
  QOe as gD,
  VEe as gE,
  GEe as gF,
  ua as gG,
  gn as gH,
  Vn as gI,
  UEe as gJ,
  WEe as gK,
  ad as gL,
  xl as gM,
  DEe as ga,
  REe as gb,
  NEe as gc,
  dr as gd,
  $Ee as ge,
  Hh as gf,
  _r as gg,
  co as gh,
  JBe as gi,
  iL as gj,
  aL as gk,
  oL as gl,
  ns as gm,
  Ui as gn,
  Rt as go,
  Kn as gp,
  cn as gq,
  En as gr,
  mi as gs,
  ev as gt,
  $a as gu,
  tm as gv,
  V1e as gw,
  FEe as gx,
  jEe as gy,
  HEe as gz,
  mBe as h,
  Ue as i,
  _6 as j,
  Mr as k,
  i6 as l,
  fBe as m,
  CBe as n,
  Hx as o,
  Bj as p,
  Ej as q,
  Dj as r,
  LL as s,
  io as t,
  Je as u,
  T_ as v,
  og as w,
  Nj as x,
  Rj as y,
  $j as z
};
